import styled, { css as css$1 } from 'styled-components';
export { ThemeProvider } from 'styled-components';
import React__default, { createElement as createElement$2, useState, useEffect, useCallback, useRef, Children, isValidElement, cloneElement, useMemo, useContext, createContext as createContext$1, forwardRef, Fragment as Fragment$1, Component as Component$1, PureComponent, createRef, useImperativeHandle, useReducer } from 'react';
import PropTypes, { object, func, oneOfType, node, bool } from 'prop-types';
import ReactDOM, { createPortal, findDOMNode, render as render$1 } from 'react-dom';
import events from 'events';

var borderRadius = {
  'border-radius-1': '2px',
  'border-radius-2': '4px',
  'border-radius-3': '8px',
  'border-radius-4': '16px',
  'border-radius-5': '100px'
};

var colors = {
  primary: {
    text: {
      regular: '#023F80',
      strong: '#002A55',
      weak: '#0A7FE4'
    },
    bg: {
      regular: '#023F80',
      strong: '#002A55',
      weak: '#D8EBFF'
    },
    border: {
      regular: '#023F80',
      strong: '#002A55',
      weak: '#479EF8'
    },
    ic: {
      regular: '#023F80',
      strong: '#002A55',
      weak: '#0A7FE4'
    }
  },
  'secondary-1': {
    text: {
      regular: '#1AAAAD',
      strong: '#076568',
      weak: '#71D7D9'
    },
    bg: {
      regular: '#1AAAAD',
      strong: '#137F82',
      weak: '#E0FBFD'
    },
    border: {
      regular: '#1AAAAD',
      strong: '#137F82',
      weak: '#71D7D9'
    },
    ic: {
      regular: '#1AAAAD',
      strong: '#137F82',
      weak: '#71D7D9'
    }
  },
  'secondary-2': {
    text: {
      regular: '#DD2457',
      strong: '#921034',
      weak: '#FF95B3'
    },
    bg: {
      regular: '#DD2457',
      strong: '#B11E47',
      weak: '#FF95B3'
    },
    border: {
      regular: '#DD2457',
      strong: '#B11E47',
      weak: '#FF95B3'
    },
    ic: {
      regular: '#DD2457',
      strong: '#B11E47',
      weak: '#FF95B3'
    }
  },
  'secondary-3': {
    bg: {
      regular: '#FECF2F',
      strong: '#FFA53F',
      weak: '#FFF0BD'
    },
    border: {
      regular: '#FECF2F',
      strong: '#FFA53F',
      weak: '#FFF0BD'
    },
    ic: {
      regular: '#FECF2F',
      strong: '#FFA53F',
      weak: '#FFF0BD'
    }
  },
  neutral: {
    text: {
      regular: '#647180',
      strong: '#373E45',
      weak: '#B6C5D5',
      inverted: '#FFFFFF'
    },
    bg: {
      regular: '#F0F5FB',
      strong: '#EAF1F8',
      stronger: '#B6C5D5',
      weak: '#FFFFFF',
      inverted: '#373E45'
    },
    border: {
      regular: '#B6C5D5',
      strong: '#647180',
      weak: '#DEE8F3'
    },
    ic: {
      regular: '#647180',
      strong: '#373E45',
      weak: '#B6C5D5',
      inverted: '#FFFFFF'
    }
  },
  danger: {
    text: {
      regular: '#DD2457',
      strong: '#921034',
      weak: '#FF95B3'
    },
    bg: {
      regular: '#DD2457',
      strong: '#B11E47',
      weak: '#FFF0F4'
    },
    border: {
      regular: '#DD2457',
      strong: '#B11E47'
    },
    ic: {
      regular: '#DD2457'
    }
  },
  warning: {
    text: {
      regular: '#623311'
    },
    bg: {
      regular: '#FECF2F',
      strong: '#FFA53F',
      weak: '#FFF4CD'
    },
    border: {
      regular: '#FECF2F',
      strong: '#FFA53F'
    },
    ic: {
      regular: '#FFA53F'
    }
  },
  info: {
    text: {
      regular: '#023F80'
    },
    bg: {
      regular: '#479EF8',
      strong: '#023F80',
      weak: '#D8EBFF'
    },
    border: {
      regular: '#479EF8',
      strong: '#023F80'
    },
    ic: {
      regular: '#479EF8'
    }
  },
  success: {
    text: {
      regular: '#035456'
    },
    bg: {
      regular: '#1AAAAD',
      strong: '#137F82',
      weak: '#E0FBFD'
    },
    border: {
      regular: '#1AAAAD',
      strong: '#137F82',
      weak: '#71D7D9'
    },
    ic: {
      regular: '#1AAAAD'
    }
  }
};

var elevations = {
  'elevation-1': '0px 14px 64px -4px rgba(222, 232, 243, 0.65), 0px 8px 22px -6px rgba(222, 232, 243, 0.65)',
  'elevation-2': '0px 6px 14px -6px rgba(222, 232, 243, 0.65), 0px 10px 32px -4px rgba(222, 232, 243, 0.65)',
  'elevation-3': '0px 14px 64px -4px rgba(222, 232, 243, 0.65), 0px 8px 22px -6px rgba(222, 232, 243, 0.65)'
};

var opacities = {
  'opacity-1': '100%',
  'opacity-2': '85%',
  'opacity-3': '20%',
  'opacity-4': '0%'
};

var spacing = {
  'spacing-0': '0px',
  'spacing-1': '2px',
  'spacing-2': '4px',
  'spacing-3': '8px',
  'spacing-4': '12px',
  'spacing-5': '16px',
  'spacing-6': '24px',
  'spacing-7': '32px',
  'spacing-8': '40px',
  'spacing-9': '48px',
  'spacing-10': '56px',
  'spacing-11': '64px',
  'spacing-12': '72px',
  'spacing-13': '80px'
};

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
var textStyles = {
  'text-preset-1': function textPreset1() {
    return css$1(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: 44px;\n    line-height: 50px;\n    font-family: Rubik,serif;\n  "])));
  },
  'text-preset-2': function textPreset2() {
    return css$1(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 34px;\n    line-height: 40px;\n    font-family: Rubik,serif;\n  "])));
  },
  'text-preset-3': function textPreset3() {
    return css$1(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: 28px;\n    line-height: 34px;\n    font-family: Rubik,serif;\n  "])));
  },
  'text-preset-4': function textPreset4() {
    return css$1(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: 22px;\n    line-height: 28px;\n    font-family: Rubik,serif;\n  "])));
  },
  'text-preset-5': function textPreset5() {
    return css$1(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    font-size: 20px;\n    line-height: 28px;\n    font-family: Rubik,serif;\n  "])));
  },
  'text-preset-6': function textPreset6() {
    return css$1(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    font-size: 16px;\n    line-height: 24px;\n    font-family: Rubik,serif;\n  "])));
  },
  'text-preset-7': function textPreset7() {
    return css$1(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    font-size: 14px;\n    line-height: 24px;\n    font-family: Rubik,serif;\n  "])));
  },
  'text-preset-8': function textPreset8() {
    return css$1(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    font-size: 16px;\n    line-height: 24px;\n    font-family: Roboto,serif;\n  "])));
  },
  'text-preset-9': function textPreset9() {
    return css$1(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    font-size: 14px;\n    line-height: 24px;\n    font-family: Roboto,serif;\n  "])));
  },
  'text-preset-10': function textPreset10() {
    return css$1(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    font-size: 12px;\n    line-height: 16px;\n    font-family: Roboto,serif;\n  "])));
  },
  'text-preset-11': function textPreset11() {
    return css$1(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    font-size: 10px;\n    line-height: 14px;\n    font-family: Roboto,serif;\n  "])));
  }
};

var gap = spacing['spacing-6'];

// SI SE AGREGA UN NUEVO BREAKPOINT HAY QUE AGREGAR LA FUNCION DE MEDIA QUERY PARA ESE NUEVO BREAKPOINT
var breakpoints = {
  xxs: {
    size: '0px',
    columns: 4,
    gap: gap,
    min: '0px',
    max: '767px'
  },
  xs: {
    size: '768px',
    columns: 8,
    gap: gap,
    min: '768px',
    max: '1023px'
  },
  s: {
    size: '1024px',
    columns: 8,
    gap: gap,
    min: '1024px',
    max: '1279px'
  },
  m: {
    size: '1280px',
    columns: 8,
    gap: gap,
    min: '1280px',
    max: '1365px'
  },
  l: {
    size: '1366px',
    columns: 12,
    gap: gap,
    min: '1366px',
    max: '1599px'
  }
};

var sizesResponsive = {
  m: "(max-width: ".concat(breakpoints.m.max, ")"),
  xxs: "(max-width: ".concat(breakpoints.xxs.max, ")")
};

var oldColors = {
  primary: '#2d9cdb',
  blue: {
    100: 'linear-gradient(to bottom, rgb(90, 150, 252) 1%, rgb(55, 115, 220))',
    200: 'linear-gradient(to bottom, rgb(90, 150, 252, .45) 1%, rgb(55, 115, 220, .45))',
    300: '#48cdf8',
    500: '#2d9cdb'
  },
  orange: {
    100: 'linear-gradient(to bottom, rgb(253, 188, 115) 1%, rgb(255, 165, 63))',
    200: 'linear-gradient(to bottom, rgb(253, 188, 115, .45) 1%, rgb(255, 165, 63, .45))',
    300: '#fdbc73',
    700: '#ffa53f'
  },
  red: {
    100: '#d67878'
  },
  grey: {
    300: '#f1f1f1',
    400: '#F7F7F8',
    500: '#647180',
    600: '#647180'
  },
  teal: {
    100: 'linear-gradient(to bottom, rgb(5, 233, 234), rgb(38, 203, 204))',
    200: 'linear-gradient(to bottom, rgb(5, 233, 234, .45), rgb(38, 203, 204, .45))',
    300: '#05e9ea',
    500: '#023F80'
  },
  white: {
    500: '#fafafa',
    600: '#ffffff'
  },
  black: {
    100: 'rgb(0, 0, 0, 0.26)',
    500: '#373E45'
  },
  'palette-primary-p-1-p-1': '#023F80',
  'palette-primary-p-1-p-1-02': '#d2f1f1',
  'palette-primary-p-2-p-2': '#DD2457',
  'palette-primary-p-3-p-3': '#1AAAAD',
  'palette-primary-p-4-p-4': '#FECF2F',
  'palette-primary-p-5-p-5': '#FFA53F',
  'palette-message-note-light': '#FFF4CD',
  'palette-primary-p-6-p-6': '#B6C5D5',
  'palette-primary-p-7-p-7': '#647180',
  'palette-neutral-n-1': '#373E45',
  'palette-neutral-n-2': '#647180',
  'palette-neutral-n-3': '#B6C5D5',
  'palette-neutral-n-4': '#DEE8F3',
  'palette-neutral-n-5': '#F7FAFE',
  'palette-message-error': '#DD2457',
  'palette-message-error-light': '#FFF0F4',
  'palette-message-warning': '#FECF2F',
  'palette-message-info': '#479EF8',
  'palette-message-success': '#1AAAAD',
  'palette-message-success-light': '#E0FBFD',
  'palette-buttons-primary-hover': '#002A55',
  'palette-buttons-primary-pressed': '#1AAAAD',
  'palette-buttons-primary-disabled': '#B6C5D5',
  'palette-input-disabled-text': '#647180',
  'palette-input-enabled-text': '#373E45',
  'palette-gradient-green': 'linear-gradient(to bottom, #05e9ea, #26cbcc)',
  'palette-gradient-green-hover': 'linear-gradient(to bottom, #06e1e3, #20b9ba)',
  'palette-gradient-green-focus': 'linear-gradient(to bottom, #05e9ea, #26cbcc)',
  'palette-gradient-green-pressed': 'linear-gradient(to bottom, #06aaab, #20b9ba)',
  'palette-gradient-green-toggle': 'linear-gradient(to bottom, #54c789, #10b45b)',
  'palette-gradient-blue': 'linear-gradient(to bottom, #5a96fc, #3773dc)',
  'palette-gradient-orange': 'linear-gradient(to bottom, #fdbc73 1%, #ffa53f)',
  'palette-gradient-blue-datepicker-start': 'linear-gradient( 90deg, rgba(32, 186, 187, 0) 50%, rgba(32, 186, 187, 0.4) 50% )',
  'palette-gradient-blue-datepicker-end': 'linear-gradient( 90deg, rgba(32, 186, 187, 0.4) 50%, rgba(32, 186, 187, 0) 50% )',
  'palette-background-cards-white': '#ffffff',
  'palette-buttons-tertiary-pressed': '#076568',
  'palette-input-link-normal': '#0A7FE4',
  'palette-input-link-hover': '#002A55',
  'palette-background-cards-grays': '#F7FAFE',
  'palette-background-datepicker': '#a9deec',
  'colores-gris-4': '#999999',
  'colores-notificaciones': '#00cccc',
  'prisma-blue': '#023F86',
  'prisma-green': '#00B0B4',
  'prisma-red': '#e51b54',
  'prisma-color-primary': '#373E45',
  'palette-background-cards': '#FFFFFF',
  'link-color': '#0A7FE4',
  'text-light-gray': '#647180',
  'text-gray': '#647180',
  'text-dark-gray': '#373E45',
  'btn-secondary-border': '#023F80',
  'btn-secondary-hover': '#002A55',
  'btn-secondary-disabled': '#B6C5D5',
  'border-row-table': '#e8e8e8',
  'border-grey-walkthrough': '#979797'
};
var sizes = {
  none: '0px',
  sm: '4px',
  md: '8px',
  lg: '16px'
};
var theme = {
  borderRadius: borderRadius,
  colors: colors,
  elevations: elevations,
  oldColors: oldColors,
  opacities: opacities,
  sizes: sizes,
  spacing: spacing,
  textStyles: textStyles,
  breakpoints: breakpoints,
  sizesResponsive: sizesResponsive
};

var colors$1 = {
  theme: theme
};
var sizes$1 = {
  none: '0px',
  sm: '4px',
  md: '8px',
  lg: '16px'
};
var themeFree = {
  colors: colors$1,
  sizes: sizes$1
};

var colors$2 = {
  theme: theme
};
var sizes$2 = {
  none: '0px',
  sm: '4px',
  md: '8px',
  lg: '16px'
};
var themePremium = {
  colors: colors$2,
  sizes: sizes$2
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ":root {\n  --primary-text: #023F80;\n  --primary-text-strong: #002A55;\n  --primary-text-weak: #0A7FE4;\n  --primary-bg: #023F80;\n  --primary-bg-strong: #002A55;\n  --primary-bg-weak: #D8EBFF;\n  --primary-border: #023F80;\n  --primary-border-strong: #002A55;\n  --primary-border-weak: #479EF8;\n  --primary-ic: #023F80;\n  --primary-ic-strong: #002A55;\n  --primary-ic-weak: #0A7FE4;\n\n  --secondary-1-text: #1AAAAD;\n  --secondary-1-text-strong: #076568;\n  --secondary-1-text-weak: #71D7D9;\n  --secondary-1-bg: #1AAAAD;\n  --secondary-1-bg-strong: #137F82;\n  --secondary-1-bg-weak: #E0FBFD;\n  --secondary-1-border: #1AAAAD;\n  --secondary-1-border-strong: #137F82;\n  --secondary-1-border-weak: #71D7D9;\n  --secondary-1-ic: #1AAAAD;\n  --secondary-1-ic-strong: #137F82;\n  --secondary-1-ic-weak: #71D7D9;\n\n  --secondary-2-text: #DD2457;\n  --secondary-2-text-strong: #921034;\n  --secondary-2-text-weak: #FF95B3;\n  --secondary-2-bg: #DD2457;\n  --secondary-2-bg-strong: #B11E47;\n  --secondary-2-bg-weak: #FF95B3;\n  --secondary-2-border: #DD2457;\n  --secondary-2-border-strong: #B11E47;\n  --secondary-2-border-weak: #FF95B3;\n  --secondary-2-ic: #DD2457;\n  --secondary-2-ic-strong: #B11E47;\n  --secondary-2-ic-weak: #FF95B3;\n\n  --secondary-3-bg: #FECF2F;\n  --secondary-3-bg-strong: #FFA53F;\n  --secondary-3-bg-weak: #FFF0BD;\n  --secondary-3-border: #FECF2F;\n  --secondary-3-border-strong: #FFA53F;\n  --secondary-3-border-weak: #FFF0BD;\n  --secondary-3-ic: #FECF2F;\n  --secondary-3-ic-strong: #FFA53F;\n  --secondary-3-ic-weak: #FFF0BD;\n\n  --neutral-text: #647180;\n  --neutral-text-strong: #373E45;\n  --neutral-text-weak: #B6C5D5;\n  --neutral-text-inverted: #FFFFFF;\n  --neutral-bg: #F0F5FB;\n  --neutral-bg-strong: #EAF1F8;\n  --neutral-bg-stronger: #B6C5D5;\n  --neutral-bg-weak: #FFFFFF;\n  --neutral-bg-inverted:#373E45;\n  --neutral-border: #B6C5D5;\n  --neutral-border-strong: #647180;\n  --neutral-border-weak: #DEE8F3;\n  --neutral-ic: #647180;\n  --neutral-ic-strong: #373E45;\n  --neutral-ic-weak: #B6C5D5;\n  --neutral-ic-inverted: #FFFFFF;\n\n  --danger-text: #DD2457;\n  --danger-text-strong: #921034;\n  --danger-text-weak: #FF95B3;\n  --danger-bg:#DD2457;\n  --danger-bg-strong:#B11E47;\n  --danger-bg-weak: #FFF0F4;\n  --danger-border: #DD2457;\n  --danger-border-strong: #B11E47;\n  --danger-ic: #DD2457;\n\n  --warning-text: #623311;\n  --warning-bg: #FECF2F;\n  --warning-bg-strong: #FFA53F;\n  --warning-bg-weak: #FFF4CD;\n  --warning-border: #FECF2F;\n  --warning-border-strong: #FFA53F;\n  --warning-ic: #FFA53F;\n\n  --info-text:#023F80;\n  --info-bg: #479EF8;\n  --info-bg-strong: #023F80;\n  --info-bg-weak: #D8EBFF;\n  --info-border: #479EF8;\n  --info-border-strong: #023F80;\n  --info-ic: #479EF8;\n\n  --success-text: #035456;\n  --success-bg: #1AAAAD;\n  --success-bg-strong: #137F82;\n  --success-bg-weak: #E0FBFD;\n  --success-border: #1AAAAD;\n  --success-border-strong: #137F82;\n  --success-border-weak: #71D7D9;\n  --success-ic: #1AAAAD;\n\n}\n";
styleInject(css_248z);

var css_248z$1 = ":root {\n  --border-radius-1: 2px;\n  --border-radius-2: 4px;\n  --border-radius-3: 8px;\n  --border-radius-4: 16px;\n  --border-radius-5: 100px;\n}\n\n";
styleInject(css_248z$1);

var css_248z$2 = ":root {\n  --spacing-0: 0px;\n  --spacing-1: 2px;\n  --spacing-2: 4px;\n  --spacing-3: 8px;\n  --spacing-4: 12px;\n  --spacing-5: 16px;\n  --spacing-6: 24px;\n  --spacing-7: 32px;\n  --spacing-8: 40px;\n  --spacing-9: 48px;\n  --spacing-10: 56px;\n  --spacing-11: 64px;\n  --spacing-12: 72px;\n  --spacing-13: 80px;\n}\n";
styleInject(css_248z$2);

var css_248z$3 = ":root {\n  --elevation-1: 0px 2px 4px -2px rgba(222, 232, 243, 0.65), 0px 2px 4px -2px rgba(222, 232, 243, 0.65);\n  --elevation-2: 0px 6px 14px -6px rgba(222, 232, 243, 0.65), 0px 10px 32px -4px rgba(222, 232, 243, 0.65);\n  --elevation-3: 0px 14px 64px -4px rgba(222, 232, 243, 0.65), 0px 8px 22px -6px rgba(222, 232, 243, 0.65);\n}\n";
styleInject(css_248z$3);

var css_248z$4 = ":root {\n  --opacity-1: 100%;\n  --opacity-2: 85%;\n  --opacity-3: 20%;\n  --opacity-4: 0%;\n}\n";
styleInject(css_248z$4);

var css_248z$5 = ":root {\n  /* Excepción disponible para gráficos, será deprecado */\n  --text-preset-1-bold-font-size: 32px;\n  --text-preset-1-bold-line-height: 24px;\n  --text-preset-1-bold-font-family: Rubik, serif;\n  --text-preset-1-bold-font-weight: 500;\n  --text-preset-5-font-size: 20px;\n  --text-preset-5-line-height: 28px;\n  --text-preset-5-font-family: Rubik, serif;\n  --text-preset-9-font-size: 14px;\n  --text-preset-9-line-height: 24px;\n  --text-preset-9-font-family: Roboto, serif;\n}\n";
styleInject(css_248z$5);

var css_248z$6 = ":root {\n    --breakpoint-xxs-size: 0px;\n    --breakpoint-xxs-columns: 4;\n    --breakpoint-xxs-gap: 24px;\n    --breakpoint-xs-size: 768px;\n    --breakpoint-xs-columns: 8;\n    --breakpoint-xs-gap: 24px;\n    --breakpoint-s-size: 1024px;\n    --breakpoint-s-columns: 8;\n    --breakpoint-s-gap: 24px;\n    --breakpoint-m-size: 1280px;\n    --breakpoint-m-columns: 12;\n    --breakpoint-m-gap: 24px;\n    --breakpoint-l-size: 1366px;\n    --breakpoint-l-columns: 12;\n    --breakpoint-l-gap: 24px;\n}\n";
styleInject(css_248z$6);

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1;
var Alert = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: ", " ", "\n    ", " ", ";\n  border-radius: ", ";\n  ", "\n"])), theme.spacing['spacing-5'], theme.spacing['spacing-6'], theme.spacing['spacing-5'], theme.spacing['spacing-6'], theme.borderRadius['border-radius-3'], function (props) {
  return getVariant(props);
});
var AlertTitle = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"])), theme.spacing['spacing-1']);
var IconBaseAlert = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral([""])));
var TextWrapper = styled.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  margin-left: ", ";\n"])), theme.spacing['spacing-3']);
var LinkAlert = styled.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), theme.spacing['spacing-3']);
var getVariant = function getVariant(props) {
  return css$1(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), theme.colors[props.variant].bg.weak);
};

var _templateObject$2, _templateObject2$2, _templateObject3$2;
var Icon = styled.i(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  font-style: normal;\n  display: flex;\n  align-items: center;\n  ", "\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant,
    modifier = _ref.modifier;
  return setStyleSvgPath(variant, modifier);
}, function (_ref2) {
  var cursor = _ref2.cursor;
  return css$1(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n      cursor: ", ";\n    "])), cursor);
});
var setStyleSvgPath = function setStyleSvgPath(variant, modifier) {
  return css$1(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n    svg {\n      path {\n        fill: ", ";\n      }\n    }\n  "])), theme.colors[variant].ic[modifier]);
};

var _path;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgQr = function SvgQr(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/createElement$2("path", {
    d: "M8.011 12.857c1.09 0 1.484.114 1.882.327.398.212.71.525.924.923.213.398.326.793.326 1.882v2.308c0 1.089-.114 1.484-.326 1.882a2.22 2.22 0 0 1-.924.923c-.398.213-.793.327-1.882.327H5.703c-1.089 0-1.484-.114-1.882-.327a2.22 2.22 0 0 1-.923-.923c-.213-.398-.327-.793-.327-1.882V15.99c0-1.09.114-1.484.327-1.882a2.22 2.22 0 0 1 .923-.923c.398-.213.793-.327 1.882-.327h2.308Zm12.165 6c.286 0 .39.03.495.086a.584.584 0 0 1 .243.243c.056.105.086.209.086.495v.495c0 .287-.03.39-.086.495a.583.583 0 0 1-.243.243c-.105.056-.209.086-.495.086h-.495c-.286 0-.39-.03-.495-.086a.583.583 0 0 1-.243-.243c-.056-.104-.086-.208-.086-.495v-.495c0-.286.03-.39.086-.495a.584.584 0 0 1 .243-.243c.105-.056.209-.086.495-.086h.495Zm-5.571 0c.286 0 .39.03.495.086a.584.584 0 0 1 .243.243c.056.105.086.209.086.495v.495c0 .287-.03.39-.086.495a.584.584 0 0 1-.243.243c-.105.056-.209.086-.495.086h-.495c-.287 0-.39-.03-.495-.086a.583.583 0 0 1-.243-.243c-.056-.104-.086-.208-.086-.495v-.495c0-.286.03-.39.086-.495a.584.584 0 0 1 .243-.243c.104-.056.208-.086.495-.086h.495ZM8.16 14.572H5.703c-.734 0-.903.032-1.073.123a.507.507 0 0 0-.22.22c-.085.158-.12.316-.124.925v2.457c0 .734.032.903.123 1.073.054.1.121.168.22.22.17.092.34.124 1.074.124h2.308c.734 0 .904-.032 1.074-.123.099-.053.167-.121.22-.22.09-.17.124-.34.124-1.074V15.99c0-.734-.033-.904-.124-1.074a.507.507 0 0 0-.22-.22c-.158-.084-.316-.119-.925-.123Zm-1.056 1.5c.287 0 .39.03.496.085a.584.584 0 0 1 .243.243c.056.105.086.21.086.496v.494c0 .287-.03.39-.086.495a.584.584 0 0 1-.243.243c-.105.057-.209.086-.496.086H6.61c-.287 0-.39-.03-.495-.085a.584.584 0 0 1-.243-.244c-.056-.104-.086-.208-.086-.495v-.494c0-.287.03-.39.086-.496a.584.584 0 0 1 .243-.243c.104-.056.208-.085.495-.085h.494Zm10.286 0c.287 0 .39.03.495.085a.583.583 0 0 1 .243.243c.056.105.086.21.086.496v.494c0 .287-.03.39-.086.495a.583.583 0 0 1-.243.243c-.104.057-.208.086-.495.086h-.495c-.286 0-.39-.03-.495-.085a.583.583 0 0 1-.243-.244c-.056-.104-.086-.208-.086-.495v-.494c0-.287.03-.39.086-.496a.583.583 0 0 1 .243-.243c.105-.056.209-.085.495-.085h.495Zm-2.786-2.786c.287 0 .39.03.496.086a.584.584 0 0 1 .243.243c.056.104.086.208.086.495v.495c0 .286-.03.39-.086.495a.584.584 0 0 1-.243.243c-.105.056-.209.086-.495.086h-.495c-.287 0-.39-.03-.495-.086a.583.583 0 0 1-.243-.243c-.056-.105-.086-.209-.086-.495v-.495c0-.287.03-.39.086-.495a.583.583 0 0 1 .243-.243c.104-.056.208-.086.495-.086h.495Zm5.572 0c.286 0 .39.03.495.086a.583.583 0 0 1 .243.243c.056.104.086.208.086.495v.495c0 .286-.03.39-.086.495a.583.583 0 0 1-.243.243c-.105.056-.209.086-.495.086h-.495c-.286 0-.39-.03-.495-.086a.583.583 0 0 1-.243-.243c-.056-.105-.086-.209-.086-.495v-.495c0-.287.03-.39.086-.495a.583.583 0 0 1 .243-.243c.105-.056.209-.086.495-.086h.495ZM8.01 2.572c1.09 0 1.484.113 1.882.326.398.213.71.525.924.923.213.398.326.793.326 1.882v2.308c0 1.09-.114 1.484-.326 1.882a2.22 2.22 0 0 1-.924.924c-.398.213-.793.326-1.882.326H5.703c-1.089 0-1.484-.113-1.882-.326a2.22 2.22 0 0 1-.923-.924c-.213-.398-.327-.793-.327-1.882V5.703c0-1.089.114-1.484.327-1.882a2.22 2.22 0 0 1 .923-.923c.398-.213.793-.326 1.882-.326h2.308Zm10.286 0c1.089 0 1.484.113 1.882.326.398.213.71.525.923.923.213.398.327.793.327 1.882v2.308c0 1.09-.114 1.484-.327 1.882a2.22 2.22 0 0 1-.923.924c-.398.213-.793.326-1.882.326h-2.308c-1.09 0-1.484-.113-1.882-.326a2.22 2.22 0 0 1-.924-.924c-.213-.398-.326-.793-.326-1.882V5.703c0-1.089.114-1.484.326-1.882a2.22 2.22 0 0 1 .924-.923c.398-.213.793-.326 1.882-.326h2.308ZM8.16 4.286H5.703c-.734 0-.903.033-1.073.124a.507.507 0 0 0-.22.22c-.085.158-.12.315-.124.924v2.457c0 .734.032.904.123 1.074.054.1.121.167.22.22.17.091.34.124 1.074.124h2.308c.734 0 .904-.033 1.074-.124.099-.053.167-.12.22-.22.09-.17.124-.34.124-1.074V5.703c0-.734-.033-.903-.124-1.073a.507.507 0 0 0-.22-.22c-.158-.085-.316-.12-.925-.124Zm10.286 0h-2.457c-.734 0-.904.033-1.074.124a.506.506 0 0 0-.22.22c-.084.158-.119.315-.123.924v2.457c0 .734.032.904.123 1.074.053.1.12.167.22.22.17.091.34.124 1.074.124h2.308c.734 0 .903-.033 1.073-.124.1-.053.168-.12.22-.22.092-.17.124-.34.124-1.074V5.703c0-.734-.032-.903-.123-1.073a.507.507 0 0 0-.22-.22c-.159-.085-.316-.12-.925-.124Zm-11.342 1.5c.287 0 .39.03.496.086a.584.584 0 0 1 .243.243c.056.104.086.208.086.495v.495c0 .286-.03.39-.086.495a.584.584 0 0 1-.243.243c-.105.056-.209.086-.496.086H6.61c-.287 0-.39-.03-.495-.086a.584.584 0 0 1-.243-.243c-.056-.105-.086-.209-.086-.495V6.61c0-.287.03-.39.086-.495a.584.584 0 0 1 .243-.243c.104-.056.208-.086.495-.086h.494Zm10.286 0c.287 0 .39.03.495.086a.584.584 0 0 1 .243.243c.056.104.086.208.086.495v.495c0 .286-.03.39-.086.495a.584.584 0 0 1-.243.243c-.104.056-.208.086-.495.086h-.495c-.286 0-.39-.03-.495-.086a.584.584 0 0 1-.243-.243c-.056-.105-.086-.209-.086-.495V6.61c0-.287.03-.39.086-.495a.584.584 0 0 1 .243-.243c.105-.056.209-.086.495-.086h.495Z",
    fill: "#023F80"
  })));
};

var _path$1, _path2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgPuntosVenta = function SvgPuntosVenta(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/createElement$2("path", {
    d: "M8.5 13a2.5 2.5 0 0 1 2.5 2.5v4A2.5 2.5 0 0 1 8.5 22h-4A2.5 2.5 0 0 1 2 19.5v-4A2.5 2.5 0 0 1 4.5 13h4Zm-.25 1.75h-3.5a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1Zm-1 1.5a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5h1.5ZM19.5 2A2.5 2.5 0 0 1 22 4.5v4a2.5 2.5 0 0 1-2.5 2.5h-4A2.5 2.5 0 0 1 13 8.5v-4A2.5 2.5 0 0 1 15.5 2h4Zm-11 0A2.5 2.5 0 0 1 11 4.5v4A2.5 2.5 0 0 1 8.5 11h-4A2.5 2.5 0 0 1 2 8.5v-4A2.5 2.5 0 0 1 4.5 2h4Zm10.75 1.75h-3.5a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1Zm-11 0h-3.5a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1Zm10 1.5a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5h1.5Zm-11 0a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5h1.5ZM19.276 14.163a2.311 2.311 0 0 1 2.312 2.31c0 1.283-.513 1.925-2.669 3.601l-.982.764c-.257.2-.617.2-.874 0l-.982-.764c-2.155-1.676-2.668-2.318-2.668-3.6a2.311 2.311 0 0 1 2.31-2.311c.682 0 1.273.397 1.777 1.157.504-.76 1.095-1.157 1.776-1.157Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/createElement$2("path", {
    d: "M15.901 14.569c-1.158 0-2.097.939-2.097 2.097 0 1.162.464 1.743 2.408 3.255l.893.695c.233.18.558.18.79 0l.893-.695c1.944-1.512 2.409-2.093 2.409-3.255 0-1.158-.94-2.097-2.098-2.097-.602 0-1.137.273-1.599.799-.461-.526-.997-.8-1.599-.8Z",
    fill: "#023F80"
  })));
};

var _path$2, _path2$1, _path3;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgAccessibilityOutline = function SvgAccessibilityOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/createElement$2("path", {
    d: "M14 10.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "#023F80"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/createElement$2("path", {
    d: "M15.5 15c0 .224.036.446.107.658l1.342 4.026a1 1 0 0 1-1.898.632l-.956-2.87a.1.1 0 0 0-.19 0l-.956 2.87a1 1 0 0 1-1.898-.632l1.192-3.576a5 5 0 0 0 .257-1.582v-.878a10.935 10.935 0 0 1-4-1.37 1 1 0 0 1 1-1.732A8.954 8.954 0 0 0 14 11.75a8.954 8.954 0 0 0 4.5-1.204 1 1 0 0 1 1 1.732 10.935 10.935 0 0 1-4 1.37V15Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 14c0 6.627-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2s12 5.373 12 12Zm-2 0c0 5.523-4.477 10-10 10S4 19.523 4 14 8.477 4 14 4s10 4.477 10 10Z",
    fill: "#023F80"
  })));
};

var _path$3;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgAceleraciones = function SvgAceleraciones(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.976 7.21a7.105 7.105 0 0 0 .052 1.33h-.155c-.373 0-.624.234-.624.583 0 .323.203.567.516.612l.108.008H8.3c.138.43.317.841.532 1.23h-3.23c-.377 0-.626.242-.626.591 0 .332.202.56.516.603l.11.007h4.07c.414.475.891.893 1.418 1.24H4.487c-.375 0-.633.251-.633.61 0 .315.203.55.522.594l.11.007h7.478c.356 0 .625.27.625.6a.619.619 0 0 1-.52.622l-.105.008H5.601c-.376 0-.625.251-.625.61 0 .315.202.55.516.593l.11.008h8.805c.453 0 .765.278.765.672 0 .308-.122.572-.497.785l-.135.068-2.72 1.249c-.356.16-.534.457-.408.78.112.29.383.415.747.325l.125-.038 4.421-1.589c3.022-1.086 4.207-2.987 4.207-5.6 0-.804-.128-1.53-.376-2.168.312-.455.573-.95.773-1.476.636 1.016.977 2.267.977 3.69 0 3.167-1.635 5.406-4.847 6.652l-.305.114-4.43 1.588c-1.149.414-2.12.045-2.477-.924-.294-.82.02-1.631.853-2.067l.163-.077 1.229-.512c.046-.018.062-.046.062-.072 0-.04-.015-.06-.044-.068l-.035-.004H5.468c-1.079 0-1.775-.7-1.775-1.768 0-.35.116-.673.32-.924-.899-.153-1.442-.763-1.442-1.678 0-.89.561-1.526 1.427-1.687a1.33 1.33 0 0 1-.305-.854c0-.931.604-1.576 1.542-1.644l.17-.006h.881c-.221-.235-.338-.584-.338-.943 0-.933.645-1.6 1.594-1.672l.17-.006.264-.001Zm6.886-5.496c3.228 0 5.844 2.635 5.844 5.885s-2.616 5.885-5.844 5.885c-3.227 0-5.844-2.635-5.844-5.885s2.617-5.885 5.844-5.885Zm0 1.226c-2.555 0-4.627 2.086-4.627 4.66 0 2.572 2.072 4.659 4.627 4.659 2.556 0 4.627-2.087 4.627-4.66s-2.071-4.66-4.627-4.66Zm.038 1.084c.155 0 .282.047.38.143a.482.482 0 0 1 .14.288l.006.09v.356l.248.05c.33.083.653.225.97.427.09.06.153.127.191.2a.584.584 0 0 1 .056.27.605.605 0 0 1-.135.393c-.09.11-.195.166-.316.166a.499.499 0 0 1-.172-.03 2.172 2.172 0 0 1-.24-.114 8.841 8.841 0 0 0-.234-.124 1.93 1.93 0 0 0-.387-.152 1.654 1.654 0 0 0-.44-.056c-.225 0-.408.049-.548.147a.461.461 0 0 0-.21.397c0 .162.08.283.24.364.16.08.413.161.759.242.37.086.675.176.913.272.238.096.443.25.616.462.173.212.26.497.26.855 0 .409-.14.757-.418 1.044-.238.247-.547.421-.927.523l-.196.045v.37l-.006.09a.481.481 0 0 1-.14.289.519.519 0 0 1-.38.144.519.519 0 0 1-.38-.144.481.481 0 0 1-.14-.288l-.006-.09v-.34l-.234-.037a3.23 3.23 0 0 1-1.194-.456.512.512 0 0 1-.192-.189.597.597 0 0 1-.056-.28c0-.151.044-.282.132-.393.087-.111.191-.167.311-.167.06 0 .12.01.18.03.06.02.138.058.234.114.22.12.426.207.616.257.19.05.393.076.609.076.265 0 .467-.044.605-.133a.44.44 0 0 0 .206-.397.323.323 0 0 0-.124-.261.942.942 0 0 0-.308-.163 9.121 9.121 0 0 0-.537-.151 7.21 7.21 0 0 1-.925-.291 1.593 1.593 0 0 1-.623-.462c-.176-.21-.263-.49-.263-.844 0-.403.14-.754.42-1.052.241-.255.548-.436.92-.543l.193-.047v-.378l.01-.109a.486.486 0 0 1 .14-.266.515.515 0 0 1 .376-.147Z",
    fill: "#023F80"
  })));
};

var _path$4;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgAddAwardOutline = function SvgAddAwardOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.663 2.98a3.25 3.25 0 0 1 4.674 0l.793.82a1.25 1.25 0 0 0 1.029.375l1.134-.12a3.25 3.25 0 0 1 3.581 3.005l.08 1.138c.027.384.229.733.548.949l.945.638a3.25 3.25 0 0 1 .812 4.603l-.67.923a1.25 1.25 0 0 0-.19 1.079l.313 1.096a3.25 3.25 0 0 1-2.337 4.048l-1.106.277a1.25 1.25 0 0 0-.84.704l-.464 1.041a3.25 3.25 0 0 1-4.392 1.599l-1.025-.5a1.25 1.25 0 0 0-1.096 0l-1.025.5a3.25 3.25 0 0 1-4.392-1.599l-.465-1.041a1.25 1.25 0 0 0-.839-.704l-1.106-.277a3.25 3.25 0 0 1-2.337-4.048l.314-1.096a1.25 1.25 0 0 0-.19-1.079l-.67-.923a3.25 3.25 0 0 1 .811-4.603l.945-.638a1.25 1.25 0 0 0 .548-.949l.08-1.138a3.25 3.25 0 0 1 3.58-3.004l1.135.119a1.25 1.25 0 0 0 1.03-.375l.792-.82Zm3.236 1.39a1.25 1.25 0 0 0-1.798 0l-.792.82a3.25 3.25 0 0 1-2.676.974l-1.135-.12A1.25 1.25 0 0 0 7.121 7.2l-.08 1.138a3.25 3.25 0 0 1-1.424 2.466l-.945.638a1.25 1.25 0 0 0-.312 1.77l.67.924a3.25 3.25 0 0 1 .494 2.804l-.314 1.097a1.25 1.25 0 0 0 .9 1.557l1.106.276a3.25 3.25 0 0 1 2.181 1.83l.464 1.042a1.25 1.25 0 0 0 1.69.615l1.025-.5a3.25 3.25 0 0 1 2.848 0l1.025.5a1.25 1.25 0 0 0 1.69-.615l.464-1.041a3.25 3.25 0 0 1 2.181-1.831l1.107-.276a1.25 1.25 0 0 0 .899-1.557l-.314-1.097a3.25 3.25 0 0 1 .494-2.804l.67-.923a1.25 1.25 0 0 0-.312-1.77l-.945-.639a3.25 3.25 0 0 1-1.424-2.466l-.08-1.138a1.25 1.25 0 0 0-1.377-1.155l-1.135.119a3.25 3.25 0 0 1-2.676-.974l-.792-.82ZM18 14a1 1 0 0 1-1 1h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 1 1 2 0v2h2a1 1 0 0 1 1 1Z",
    fill: "#023F80"
  })));
};

var _path$5;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgAddAwardsOutline = function SvgAddAwardsOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.725 2.195a2.78 2.78 0 0 0-1.45 0c-.543.146-1.011.51-1.556.934l-.113.088-.092.071c-.309.24-.375.287-.44.32a.98.98 0 0 1-.227.083c-.07.016-.152.022-.543.037l-.115.005-.144.005c-.69.026-1.282.048-1.792.285a2.78 2.78 0 0 0-1.11.932c-.323.461-.447 1.041-.592 1.715l-.03.141-.025.113c-.083.382-.104.46-.132.527a.98.98 0 0 1-.12.21c-.044.058-.102.115-.392.378l-.086.078-.106.097c-.512.462-.952.86-1.19 1.37a2.78 2.78 0 0 0-.252 1.427c.05.56.327 1.085.65 1.694l.067.128.054.102c.182.346.217.42.238.489a.98.98 0 0 1 .042.239c.004.072-.004.153-.057.54l-.015.115-.02.142c-.094.683-.175 1.271-.03 1.815.125.475.376.908.724 1.255.398.397.948.62 1.587.88l.133.055.107.044c.362.148.436.181.497.22a.98.98 0 0 1 .186.157c.049.053.095.12.304.45l.061.098.077.122c.367.584.682 1.086 1.142 1.41a2.78 2.78 0 0 0 1.363.496c.56.048 1.125-.134 1.781-.346l.137-.044.11-.035c.373-.12.451-.141.523-.15.08-.01.162-.01.242 0 .072.009.15.03.523.15l.11.035.137.044c.656.212 1.221.394 1.781.346a2.78 2.78 0 0 0 1.363-.496c.46-.324.775-.826 1.142-1.41l.077-.122.061-.098c.209-.33.255-.397.304-.45a.981.981 0 0 1 .186-.156c.06-.04.135-.073.497-.221l.107-.044.133-.055c.639-.26 1.189-.483 1.587-.88a2.78 2.78 0 0 0 .725-1.255c.144-.544.063-1.132-.031-1.815l-.02-.142-.015-.115c-.053-.387-.06-.468-.057-.54a.98.98 0 0 1 .042-.24c.021-.068.056-.142.238-.488l.054-.102.067-.128c.323-.61.6-1.134.65-1.694a2.78 2.78 0 0 0-.252-1.428c-.238-.509-.678-.907-1.19-1.37l-.106-.096-.086-.078c-.29-.263-.348-.32-.391-.377a.98.98 0 0 1-.121-.21c-.028-.067-.05-.146-.132-.528l-.024-.113-.03-.14c-.146-.675-.27-1.255-.592-1.716a2.78 2.78 0 0 0-1.11-.932c-.51-.237-1.104-.259-1.793-.285l-.144-.005-.115-.005c-.391-.015-.472-.021-.543-.037a.98.98 0 0 1-.228-.083c-.064-.033-.13-.08-.44-.32l-.09-.07-.114-.09c-.545-.422-1.013-.787-1.556-.933Zm-.98 1.738a.98.98 0 0 1 .51 0c.148.04.312.145 1.036.707l.092.07.047.037c.237.184.442.343.675.463.205.105.422.184.647.235.255.059.515.068.815.08l.059.002.116.005c.916.035 1.11.06 1.248.124a.98.98 0 0 1 .391.328c.087.125.145.312.34 1.208l.024.113.012.058c.064.293.118.547.22.788.09.213.206.413.345.597.158.208.35.383.572.584l.044.04.086.078c.68.616.812.76.877.897a.98.98 0 0 1 .088.504c-.013.151-.089.331-.516 1.143l-.054.102-.028.053c-.14.265-.261.495-.338.745-.068.22-.108.448-.12.678-.013.261.022.519.063.816l.008.059.016.115c.124.908.134 1.103.094 1.25a.98.98 0 0 1-.255.443c-.108.108-.282.197-1.13.544l-.108.043-.055.023c-.278.113-.518.211-.738.353a2.78 2.78 0 0 0-.527.443c-.179.191-.317.411-.477.665l-.031.05-.062.098c-.489.776-.607.932-.732 1.02a.98.98 0 0 1-.48.174c-.152.013-.342-.03-1.215-.31l-.11-.035-.057-.019c-.286-.091-.533-.17-.793-.203a2.782 2.782 0 0 0-.688 0c-.26.032-.507.112-.793.203l-.056.019-.11.035c-.874.28-1.064.323-1.216.31a.98.98 0 0 1-.48-.175c-.125-.087-.243-.243-.732-1.018l-.062-.099-.031-.05c-.16-.254-.298-.474-.477-.665a2.78 2.78 0 0 0-.527-.443c-.22-.142-.46-.24-.738-.353l-.055-.023-.107-.043c-.85-.347-1.023-.436-1.13-.544a.98.98 0 0 1-.256-.443c-.04-.147-.03-.342.094-1.25l.016-.115.008-.06c.04-.296.076-.554.063-.815a2.779 2.779 0 0 0-.12-.678c-.077-.25-.198-.48-.338-.745l-.028-.053-.054-.102c-.427-.812-.503-.992-.516-1.143a.98.98 0 0 1 .089-.504c.064-.138.197-.28.876-.897l.086-.078.044-.04c.222-.201.415-.376.572-.584a2.78 2.78 0 0 0 .345-.597c.102-.24.156-.495.22-.788l.012-.058.025-.113c.194-.896.252-1.083.339-1.208a.98.98 0 0 1 .391-.328c.138-.064.332-.089 1.248-.124l.116-.005.06-.002c.3-.012.559-.021.814-.08a2.78 2.78 0 0 0 .647-.235c.233-.12.438-.279.675-.463l.047-.036.091-.071c.725-.562.89-.668 1.037-.707ZM12.9 8.9a.9.9 0 0 0-1.8 0v2.2H8.9a.9.9 0 1 0 0 1.8h2.2v2.2a.9.9 0 0 0 1.8 0v-2.2h2.2a.9.9 0 0 0 0-1.8h-2.2V8.9Z",
    fill: "#023F80"
  })));
};

var _path$6, _path2$2;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var SvgAddCircleDashedOutline = function SvgAddCircleDashedOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/createElement$2("path", {
    d: "M13 13v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 1 1 2 0v3h3a1 1 0 1 1 0 2h-3Z",
    fill: "#023F80"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.069 2.288a9.943 9.943 0 0 1 3.862 0 .9.9 0 1 1-.35 1.766 8.145 8.145 0 0 0-3.163 0 .9.9 0 1 1-.349-1.766ZM7.747 4.015A.9.9 0 0 1 7.5 5.264 8.144 8.144 0 0 0 5.264 7.5.9.9 0 0 1 3.768 6.5a9.944 9.944 0 0 1 2.73-2.731.9.9 0 0 1 1.25.247Zm8.506 0a.9.9 0 0 1 1.248-.247 9.944 9.944 0 0 1 2.731 2.73.9.9 0 0 1-1.496 1.002A8.144 8.144 0 0 0 16.5 5.264a.9.9 0 0 1-.247-1.249Zm4.401 5.346a.9.9 0 0 1 1.058.708 9.943 9.943 0 0 1 0 3.862.9.9 0 0 1-1.766-.35 8.14 8.14 0 0 0 0-3.163.9.9 0 0 1 .708-1.057Zm-17.308 0a.9.9 0 0 1 .708 1.057 8.145 8.145 0 0 0 0 3.164.9.9 0 1 1-1.766.349 9.944 9.944 0 0 1 0-3.862.9.9 0 0 1 1.058-.708Zm.67 6.892a.9.9 0 0 1 1.248.247A8.147 8.147 0 0 0 7.5 18.736.9.9 0 0 1 6.5 20.232a9.943 9.943 0 0 1-2.731-2.73.9.9 0 0 1 .247-1.25Zm15.969 0a.9.9 0 0 1 .247 1.248 9.95 9.95 0 0 1-2.73 2.731.9.9 0 0 1-1.002-1.496 8.14 8.14 0 0 0 2.236-2.236.9.9 0 0 1 1.249-.247ZM9.36 20.654a.9.9 0 0 1 1.057-.708 8.14 8.14 0 0 0 3.164 0 .9.9 0 0 1 .349 1.766 9.943 9.943 0 0 1-3.862 0 .9.9 0 0 1-.708-1.058Z",
    fill: "#023F80"
  })));
};

var _path$7;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var SvgAddCircleOutline = function SvgAddCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$8({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/createElement$2("path", {
    d: "M14 2c6.627 0 12 5.373 12 12s-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2Zm0 2C8.477 4 4 8.477 4 14s4.477 10 10 10 10-4.477 10-10S19.523 4 14 4Zm0 4a1 1 0 0 1 1 1v4h4a1 1 0 1 1 0 2h-4v4a1 1 0 1 1-2 0v-4H9a1 1 0 1 1 0-2h4V9a1 1 0 0 1 1-1Z",
    fill: "#023F80"
  })));
};

var _path$8;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var SvgAddOutline = function SvgAddOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$9({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/createElement$2("path", {
    d: "M12 3a.9.9 0 0 1 .9.9v7.2h7.2a.9.9 0 0 1 0 1.8l-7.2-.001V20.1a.9.9 0 1 1-1.8 0V12.9l-7.2.001a.9.9 0 0 1 0-1.8h7.2V3.9A.9.9 0 0 1 12 3Z",
    fill: "#023F80"
  })));
};

var _path$9;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var SvgAddSquareOutline = function SvgAddSquareOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$a({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/createElement$2("path", {
    d: "M14.59 2.1c2.168 0 3.202.2 4.277.774a5.443 5.443 0 0 1 2.259 2.26c.574 1.074.774 2.108.774 4.276v5.18c0 2.168-.2 3.202-.774 4.276a5.443 5.443 0 0 1-2.26 2.26c-1.074.574-2.108.774-4.276.774H9.41c-2.168 0-3.202-.2-4.276-.774a5.443 5.443 0 0 1-2.26-2.26C2.3 17.792 2.1 16.758 2.1 14.59V9.41c0-2.168.2-3.202.774-4.277a5.443 5.443 0 0 1 2.26-2.259C6.208 2.3 7.242 2.1 9.41 2.1h5.18Zm0 1.8H9.41c-1.896 0-2.65.145-3.428.561a3.644 3.644 0 0 0-1.52 1.521C4.046 6.76 3.9 7.514 3.9 9.41v5.18c0 1.896.146 2.65.562 3.428a3.644 3.644 0 0 0 1.52 1.52c.778.416 1.532.562 3.428.562h5.18c1.897 0 2.65-.146 3.428-.562a3.644 3.644 0 0 0 1.52-1.52c.417-.778.562-1.532.562-3.428V9.41c0-1.896-.145-2.65-.561-3.428a3.644 3.644 0 0 0-1.521-1.52c-.778-.417-1.531-.562-3.428-.562ZM12 7.5a.9.9 0 0 1 .893.787l.007.113v2.7h2.7a.9.9 0 0 1 .893.787L16.5 12a.9.9 0 0 1-.787.893l-.113.007h-2.7v2.7a.9.9 0 0 1-.787.893L12 16.5a.9.9 0 0 1-.893-.787L11.1 15.6v-2.7H8.4a.9.9 0 0 1-.893-.787L7.5 12a.9.9 0 0 1 .787-.893L8.4 11.1h2.7V8.4a.9.9 0 0 1 .787-.893L12 7.5Z",
    fill: "#023F80"
  })));
};

var _path$a, _path2$3, _path3$1;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var SvgAdvertisingOutline = function SvgAdvertisingOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$b({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$a || (_path$a = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.567 6.914a.819.819 0 0 0-.573.09l-.025.015-3.757 1.875H7.6c-.77 0-1.453.285-1.937.729-.442.404-.763 1.174-.763 1.867 0 .692.321 1.462.763 1.867.248.227.548.412.885.54.321.12.676.188 1.052.188h6.612l3.757 1.876.025.015a.81.81 0 0 0 .406.106c.218 0 .4-.08.523-.193a.504.504 0 0 0 .177-.373V7.463a.479.479 0 0 0-.09-.274.702.702 0 0 0-.443-.275Zm-1.452-1.478a2.622 2.622 0 0 1 1.811-.283c.603.122 1.18.46 1.563 1.011.265.381.411.832.411 1.3v8.052c0 .68-.302 1.279-.76 1.698a2.573 2.573 0 0 1-1.74.665c-.45 0-.894-.114-1.285-.335l-3.327-1.662H7.6c-.334 0-.66-.034-.976-.098a4.597 4.597 0 0 1-2.178-1.103C3.585 13.893 3.1 12.617 3.1 11.49c0-1.128.485-2.403 1.346-3.192A4.663 4.663 0 0 1 7.6 7.097h6.188l3.327-1.661Z",
    fill: "#023F80"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9 7.995v6.989h-1.8V7.995h1.8Z",
    fill: "#023F80"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/createElement$2("path", {
    d: "m8.776 17.618-.307-1.735H7.6c-.334 0-.66-.034-.976-.1l.38 2.147c.116.664.505 1.21 1.021 1.554a2.5 2.5 0 0 0 1.824.377 2.497 2.497 0 0 0 1.583-.977c.368-.5.546-1.145.429-1.81l-.21-1.192H9.821l.266 1.505a.562.562 0 0 1-.107.434.697.697 0 0 1-.445.27.698.698 0 0 1-.51-.102.563.563 0 0 1-.25-.371Z",
    fill: "#023F80"
  })));
};

var _path$b;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var SvgAhora12 = function SvgAhora12(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$c({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.162 19.816c1.004 0 1.533 1.104.862 1.797L15.22 27.6a1.22 1.22 0 0 1-1.722 0l-5.804-5.987c-.671-.693-.142-1.797.861-1.797h11.607Zm-7.78-13.15v10.65H9.264v-7.03L7 11.819V8.945l3.368-2.278h2.014Zm4.027-.1c1.49 0 2.602.262 3.336.785.733.523 1.1 1.339 1.1 2.447 0 .545-.111 1.084-.334 1.616-.222.533-.596 1.098-1.121 1.695l-1.462 1.655h3.382v2.551h-7.502v-1.662l2.859-3.39c.401-.482.687-.89.856-1.222.17-.332.255-.64.255-.928 0-.358-.133-.625-.398-.802-.265-.177-.706-.265-1.322-.265-.411 0-.83.037-1.258.11a6.085 6.085 0 0 0-1.129.298V6.96c.335-.11.765-.203 1.29-.279a10.125 10.125 0 0 1 1.448-.115Zm-1.573-5.174c.469 0 .831.131 1.088.394.256.263.384.65.384 1.163 0 .344-.06.632-.178.866a1.176 1.176 0 0 1-.507.523c-.22.116-.482.174-.787.174-.305 0-.567-.058-.787-.174a1.177 1.177 0 0 1-.507-.522c-.118-.233-.178-.52-.178-.861 0-.519.128-.909.384-1.17.255-.262.618-.393 1.088-.393Zm-6.397 0c.33 0 .595.04.797.121.202.081.352.214.449.398.097.185.146.435.146.751v1.792h-.727l-.061-.298h-.041a.797.797 0 0 1-.34.266 1.178 1.178 0 0 1-.46.087c-.202 0-.376-.036-.523-.109a.787.787 0 0 1-.338-.306.88.88 0 0 1-.117-.459c0-.288.1-.511.302-.67.2-.157.518-.25.952-.278l.49-.041v-.039a.666.666 0 0 0-.067-.328.378.378 0 0 0-.215-.17 1.278 1.278 0 0 0-.404-.05 2.968 2.968 0 0 0-.818.121V1.52a3.984 3.984 0 0 1 .976-.127Zm11.468 0c.33 0 .595.04.797.121.202.081.352.214.45.398.097.185.145.435.145.751v1.792h-.727l-.06-.298h-.042a.798.798 0 0 1-.34.266 1.178 1.178 0 0 1-.46.087c-.202 0-.376-.036-.523-.109a.786.786 0 0 1-.338-.306.88.88 0 0 1-.117-.459c0-.288.1-.511.302-.67.201-.157.518-.25.952-.278l.49-.041v-.039a.666.666 0 0 0-.067-.328.378.378 0 0 0-.215-.17 1.278 1.278 0 0 0-.404-.05 2.968 2.968 0 0 0-.818.121V1.52a3.986 3.986 0 0 1 .976-.127ZM11.18 0v1.742h.041c.103-.114.224-.2.364-.26.14-.06.295-.09.466-.09.297 0 .536.095.716.287.18.19.27.49.27.898v1.877h-.881v-1.82c0-.176-.036-.3-.108-.374-.072-.073-.177-.11-.317-.11a.777.777 0 0 0-.305.063.614.614 0 0 0-.246.185v2.056h-.882V0h.882Zm7.11 1.397c.089 0 .17.008.243.022v.797a1.518 1.518 0 0 0-.297-.025c-.135 0-.266.026-.395.077a.69.69 0 0 0-.297.213v1.973h-.882V1.439h.72l.068.388h.041a.796.796 0 0 1 .331-.323c.138-.071.294-.107.469-.107ZM8.97 3.142l-.403.03c-.165.013-.286.051-.361.115a.329.329 0 0 0-.113.266c0 .112.034.197.102.256.068.059.167.088.298.088.086 0 .17-.015.253-.045a.611.611 0 0 0 .223-.145v-.565Zm11.468 0-.403.03c-.165.013-.285.051-.36.115a.329.329 0 0 0-.114.266c0 .112.034.197.102.256.068.059.167.088.298.088a.73.73 0 0 0 .253-.045.611.611 0 0 0 .224-.145v-.565Zm-5.6-1.083a.581.581 0 0 0-.322.083.516.516 0 0 0-.196.277c-.045.13-.067.305-.067.527 0 .225.022.402.067.534a.52.52 0 0 0 .195.28.58.58 0 0 0 .322.082.58.58 0 0 0 .323-.083.519.519 0 0 0 .194-.277c.045-.13.068-.304.068-.525a1.71 1.71 0 0 0-.068-.534.517.517 0 0 0-.196-.281.582.582 0 0 0-.32-.083Z",
    fill: "#023F80"
  })));
};

var _path$c, _path2$4, _g, _path3$2, _path4;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var SvgAhora12B = function SvgAhora12B(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$d({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.164 14.447h-.543v-1.073h-.426v-.37a.645.645 0 0 0 .372-.097c.093-.064.155-.173.185-.327h.412v1.867Zm.182 0a.707.707 0 0 1 .206-.51c.066-.069.217-.184.452-.345.235-.161.352-.3.352-.419a.16.16 0 0 0-.067-.134.248.248 0 0 0-.155-.051c-.095 0-.163.033-.205.099a.475.475 0 0 0-.06.253h-.489c0-.261.068-.453.204-.575.135-.123.328-.184.576-.184a.9.9 0 0 1 .528.146c.14.097.21.247.21.448 0 .17-.047.292-.143.368-.095.077-.189.144-.28.2-.091.057-.18.11-.264.157a2.432 2.432 0 0 0-.17.103h.853v.444h-1.548Z",
    fill: "#023F80"
  })), /*#__PURE__*/createElement$2("mask", {
    id: "ahora-12-b_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _path2$4 || (_path2$4 = /*#__PURE__*/createElement$2("path", {
    d: "M3 3h18v18H3V3Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/createElement$2("g", {
    mask: "url(#ahora-12-b_svg__a)"
  }, /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19.513A7.513 7.513 0 1 1 19.513 12 7.513 7.513 0 0 1 12 19.515v-.001ZM12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18",
    fill: "#023F80"
  }))), _path3$2 || (_path3$2 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.314 18.164s-4.685.224-5.132-5.448c0 0-.334-3.68.744-3.643 0 0 .465-.094.335.929 0 0-.13 1.357-.074 1.822 0 0-.005.209.19.209.174 0 .167-.195.167-.195l.042-1.66s-.042-2.705 1.088-2.705c0 0 .53 0 .307 1.27 0 0-.21 1.421-.154 1.687 0 0-.014.195.181.195.196 0 .182-.251.182-.251s.167-2.943 1.171-4.03c0 0 .547-.768 1.116-.404.446.285.097.948.097.948s-.607 1.13-.864 2.468c0 0-.063.23.083.314.185.105.405-.021.405-.021s.99-.558 2.259.083c1.269.642 1.296 1.535 1.318 1.855 0 0 .041.55-.342.649-.421.107-.516-.385-.516-.385s-.32-1.22-1.687-1.226c-1.479-.007-1.813 1.2-1.813 1.2s-.758 2.593.302 4.099c0 0 .39.623 1.552.586 1.352-.044 1.674-1.325 1.674-1.325s.06-.567.604-.497c.544.07.4.929.4.929s-.395 2.682-3.635 2.547Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.318 13.518c0 .554.066 1.034.198 1.44.132.406.358.608.677.608.297 0 .518-.184.663-.554.145-.37.218-.867.218-1.495 0-.54-.075-1.004-.223-1.39-.15-.386-.373-.58-.67-.58-.303 0-.522.198-.659.59-.136.393-.204.853-.204 1.38Z",
    fill: "#023F80"
  })));
};

var _path$d;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
var SvgAirplayAudioOutline = function SvgAirplayAudioOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$e({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$d || (_path$d = /*#__PURE__*/createElement$2("path", {
    d: "M12.5 15.375a2.5 2.5 0 0 1 3 0L21 19.5a2.5 2.5 0 0 1-1.5 4.5h-11A2.5 2.5 0 0 1 7 19.5l5.5-4.125Zm1.8 1.6a.5.5 0 0 0-.6 0L8.2 21.1a.5.5 0 0 0 .3.9h11a.5.5 0 0 0 .3-.9l-5.5-4.125ZM14 3c5.412 0 9.8 4.388 9.8 9.8a9.77 9.77 0 0 1-.841 3.978 1 1 0 1 1-1.828-.813c.44-.987.669-2.059.669-3.165a7.8 7.8 0 1 0-15.6 0c0 1.183.263 2.326.762 3.367a1 1 0 0 1-1.803.865A9.764 9.764 0 0 1 4.2 12.8C4.2 7.388 8.588 3 14 3Zm0 4a5.8 5.8 0 0 1 5.723 6.75l-.076.377a1 1 0 1 1-1.947-.456l.01-.044a3.8 3.8 0 1 0-7.442-.106l.068.29.009.033a1 1 0 0 1-1.923.549l-.038-.14A5.8 5.8 0 0 1 14 7Z",
    fill: "#023F80"
  })));
};

var _path$e, _path2$5, _path3$3, _path4$1;
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
var SvgAirplayVideoOutline = function SvgAirplayVideoOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$f({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$e || (_path$e = /*#__PURE__*/createElement$2("path", {
    d: "M18.696 15.891c.253-.048.469-.118.666-.218a3 3 0 0 0 1.311-1.311C21 13.72 21 12.88 21 11.2V9.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 5 17.88 5 16.2 5H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 7.28 3 8.12 3 9.8v1.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311c.195.1.41.169.66.217",
    stroke: "#023F80",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/createElement$2("path", {
    d: "M10.94 14.06a1.5 1.5 0 0 1 2.12 0l4.233 4.233c.63.63.184 1.707-.707 1.707H7.414c-.89 0-1.337-1.077-.707-1.707l4.232-4.232Z",
    fill: "#023F80"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/createElement$2("path", {
    d: "M16.238 4.1H7.762c-.808 0-1.469 0-2.006.044-.556.045-1.058.142-1.527.381a3.9 3.9 0 0 0-1.704 1.704c-.239.47-.336.971-.381 1.527C2.1 8.293 2.1 8.954 2.1 9.762v1.476c0 .808 0 1.469.044 2.006.045.556.142 1.058.381 1.527a3.9 3.9 0 0 0 1.704 1.704c.285.145.583.238.899.299a.9.9 0 1 0 .34-1.768 1.551 1.551 0 0 1-.421-.135 2.1 2.1 0 0 1-.918-.918c-.088-.172-.155-.411-.191-.856C3.9 12.642 3.9 12.055 3.9 11.2V9.8c0-.855 0-1.442.038-1.897.036-.445.103-.684.19-.856a2.1 2.1 0 0 1 .919-.918c.172-.088.411-.155.856-.191C6.358 5.9 6.945 5.9 7.8 5.9h8.4c.855 0 1.442 0 1.897.038.445.036.683.103.856.19a2.1 2.1 0 0 1 .918.919c.088.172.155.411.191.856.037.455.038 1.042.038 1.897v1.4c0 .855 0 1.442-.038 1.897-.036.445-.103.684-.19.856a2.1 2.1 0 0 1-.919.918 1.56 1.56 0 0 1-.425.136.9.9 0 0 0 .337 1.768c.319-.06.618-.154.905-.3a3.9 3.9 0 0 0 1.705-1.705c.239-.468.336-.97.381-1.526.044-.537.044-1.198.044-2.006V9.762c0-.808 0-1.469-.044-2.006-.045-.556-.142-1.058-.381-1.527a3.9 3.9 0 0 0-1.705-1.704c-.468-.239-.97-.336-1.526-.381-.537-.044-1.198-.044-2.006-.044Z",
    fill: "#023F80"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/createElement$2("path", {
    d: "M13.06 14.06a1.5 1.5 0 0 0-2.12 0l-4.233 4.233c-.63.63-.184 1.707.707 1.707h9.172c.89 0 1.337-1.077.707-1.707L13.06 14.06Z",
    fill: "#023F80"
  })));
};

var _path$f;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
var SvgAllCategoriesOutline = function SvgAllCategoriesOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$g({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$f || (_path$f = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8c0-1.396 0-2.095.196-2.656a3.5 3.5 0 0 1 2.148-2.148C5.905 3 6.604 3 8 3c1.396 0 2.095 0 2.656.196a3.5 3.5 0 0 1 2.148 2.148C13 5.905 13 6.604 13 8c0 1.396 0 2.095-.196 2.656a3.5 3.5 0 0 1-2.148 2.148C10.095 13 9.396 13 8 13c-1.396 0-2.095 0-2.656-.196a3.5 3.5 0 0 1-2.148-2.148C3 10.095 3 9.396 3 8Zm2-.6c0-.84 0-1.26.163-1.581a1.5 1.5 0 0 1 .656-.656C6.139 5 6.559 5 7.4 5h1.2c.84 0 1.26 0 1.581.163a1.5 1.5 0 0 1 .655.656c.164.32.164.74.164 1.581v1.2c0 .84 0 1.26-.164 1.581a1.5 1.5 0 0 1-.655.655C9.861 11 9.441 11 8.6 11H7.4c-.84 0-1.26 0-1.581-.164a1.5 1.5 0 0 1-.656-.655C5 9.861 5 9.441 5 8.6V7.4ZM3 20c0-1.396 0-2.095.196-2.656a3.5 3.5 0 0 1 2.148-2.148C5.905 15 6.604 15 8 15c1.396 0 2.095 0 2.656.196a3.5 3.5 0 0 1 2.148 2.148C13 17.905 13 18.604 13 20c0 1.396 0 2.095-.196 2.656a3.5 3.5 0 0 1-2.148 2.148C10.095 25 9.396 25 8 25c-1.396 0-2.095 0-2.656-.196a3.5 3.5 0 0 1-2.148-2.148C3 22.095 3 21.396 3 20Zm2-.6c0-.84 0-1.26.163-1.581a1.5 1.5 0 0 1 .656-.655C6.139 17 6.559 17 7.4 17h1.2c.84 0 1.26 0 1.581.163a1.5 1.5 0 0 1 .655.656c.164.32.164.74.164 1.581v1.2c0 .84 0 1.26-.164 1.581a1.5 1.5 0 0 1-.655.655C9.861 23 9.441 23 8.6 23H7.4c-.84 0-1.26 0-1.581-.163a1.5 1.5 0 0 1-.656-.656C5 21.861 5 21.441 5 20.6v-1.2ZM15.196 5.344C15 5.905 15 6.604 15 8c0 1.396 0 2.095.196 2.656a3.5 3.5 0 0 0 2.148 2.148C17.905 13 18.604 13 20 13c1.396 0 2.095 0 2.656-.196a3.5 3.5 0 0 0 2.148-2.148C25 10.095 25 9.396 25 8c0-1.396 0-2.095-.196-2.656a3.5 3.5 0 0 0-2.148-2.148C22.095 3 21.396 3 20 3c-1.396 0-2.095 0-2.656.196a3.5 3.5 0 0 0-2.148 2.148Zm1.967.475C17 6.139 17 6.559 17 7.4v1.2c0 .84 0 1.26.163 1.581a1.5 1.5 0 0 0 .656.655c.32.164.74.164 1.581.164h1.2c.84 0 1.26 0 1.581-.164a1.5 1.5 0 0 0 .655-.655C23 9.861 23 9.441 23 8.6V7.4c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656C21.861 5 21.441 5 20.6 5h-1.2c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.655.656ZM15 20c0-1.396 0-2.095.196-2.656a3.5 3.5 0 0 1 2.148-2.148C17.905 15 18.604 15 20 15c1.396 0 2.095 0 2.656.196a3.5 3.5 0 0 1 2.148 2.148C25 17.905 25 18.604 25 20c0 1.396 0 2.095-.196 2.656a3.5 3.5 0 0 1-2.148 2.148C22.095 25 21.396 25 20 25c-1.396 0-2.095 0-2.656-.196a3.5 3.5 0 0 1-2.148-2.148C15 22.095 15 21.396 15 20Zm2-.6c0-.84 0-1.26.163-1.581a1.5 1.5 0 0 1 .656-.655c.32-.164.74-.164 1.581-.164h1.2c.84 0 1.26 0 1.581.163a1.5 1.5 0 0 1 .655.656c.164.32.164.74.164 1.581v1.2c0 .84 0 1.26-.163 1.581a1.5 1.5 0 0 1-.656.655c-.32.164-.74.164-1.581.164h-1.2c-.84 0-1.26 0-1.581-.163a1.5 1.5 0 0 1-.655-.656C17 21.861 17 21.441 17 20.6v-1.2Z",
    fill: "#023F80"
  })));
};

var _path$g;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
var SvgAnses = function SvgAnses(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$h({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$g || (_path$g = /*#__PURE__*/createElement$2("path", {
    d: "M12 12.428c3.31 0 5.572 1.508 5.572 3.858 0 1.654-1.101 2.571-2.572 2.571H9c-1.47 0-2.571-.917-2.571-2.571 0-2.35 2.26-3.858 5.571-3.858Zm6.857 0c2.354 0 3.857 1.42 3.857 3.215 0 1.45-1.108 2.357-2.357 2.357h-.643a.857.857 0 0 1 0-1.714h.643c.37 0 .643-.224.643-.643 0-.825-.715-1.5-2.143-1.5a.857.857 0 0 1 0-1.715Zm-13.714 0a.857.857 0 0 1 0 1.715c-1.428 0-2.143.675-2.143 1.5 0 .42.273.643.643.643h.643a.857.857 0 0 1 0 1.714h-.643c-1.25 0-2.357-.907-2.357-2.357 0-1.794 1.503-3.215 3.857-3.215ZM12 14.143c-2.475 0-3.857.921-3.857 2.143 0 .631.27.857.857.857h6c.586 0 .857-.226.857-.857 0-1.222-1.381-2.143-3.857-2.143Zm5.143-9a3 3 0 1 1 0 6 .857.857 0 0 1 0-1.715l.124-.005a1.286 1.286 0 0 0-.124-2.566l-.1-.006a.857.857 0 0 1 .1-1.708Zm-10.286 0a.857.857 0 0 1 .1 1.708l-.1.006a1.286 1.286 0 0 0-.124 2.566l.124.005a.857.857 0 1 1 0 1.715 3 3 0 0 1 0-6ZM12 4.286a3.429 3.429 0 1 1 0 6.857 3.429 3.429 0 0 1 0-6.857ZM12 6a1.714 1.714 0 1 0 0 3.428A1.714 1.714 0 0 0 12 6Z",
    fill: "#023F80"
  })));
};

var _path$h, _path2$6;
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
var SvgAppBadgeOutline = function SvgAppBadgeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$i({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$h || (_path$h = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.956 3H16a1 1 0 1 1 0 2h-4c-1.417 0-2.419 0-3.203.065-.771.063-1.243.182-1.613.371a4 4 0 0 0-1.748 1.748c-.189.37-.308.842-.371 1.613C5 9.581 5 10.583 5 12v4c0 1.417 0 2.419.065 3.203.063.771.182 1.243.371 1.613a4 4 0 0 0 1.748 1.748c.37.189.842.308 1.613.371C9.581 23 10.583 23 12 23h4c1.417 0 2.419 0 3.203-.065.771-.063 1.243-.182 1.613-.371a4 4 0 0 0 1.748-1.748c.189-.37.308-.841.371-1.613C23 18.419 23 17.417 23 16v-4a1 1 0 1 1 2 0v4.044c0 1.363 0 2.447-.071 3.321-.074.896-.227 1.66-.583 2.359a6 6 0 0 1-2.622 2.622c-.7.356-1.463.51-2.359.583-.874.071-1.958.071-3.321.071h-4.088c-1.363 0-2.447 0-3.321-.071-.896-.074-1.66-.227-2.359-.583a6 6 0 0 1-2.622-2.622c-.356-.7-.51-1.463-.583-2.359C3 18.491 3 17.407 3 16.044v-4.088c0-1.363 0-2.447.071-3.321.074-.896.227-1.66.583-2.359a6 6 0 0 1 2.622-2.622c.7-.356 1.463-.51 2.359-.583C9.509 3 10.593 3 11.956 3Z",
    fill: "#023F80"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/createElement$2("path", {
    d: "M25 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
    fill: "#023F80"
  })));
};

var _path$i, _path2$7;
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
var SvgAppleOutline = function SvgAppleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$j({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$i || (_path$i = /*#__PURE__*/createElement$2("path", {
    d: "M15 8.5a.9.9 0 1 0 0 1.8c.548 0 .962.18 1.235.445.269.262.465.67.465 1.255a.9.9 0 0 0 1.8 0c0-1.014-.354-1.906-1.01-2.545C16.838 8.82 15.952 8.5 15 8.5Z",
    fill: "#023F80"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.25 1.78-.129.892.13-.891h-.006l-.008-.002-.025-.003a3.849 3.849 0 0 0-.348-.03 6.06 6.06 0 0 0-.875.017c-.66.062-1.623.27-2.333.98-.71.709-.917 1.672-.979 2.332a5.929 5.929 0 0 0-.016.225c-.53-.13-1.085-.2-1.66-.2-3.998 0-6.9 2.903-6.9 6.9 0 1.927.676 4.333 1.81 6.268 1.11 1.893 2.845 3.632 5.09 3.632a6.843 6.843 0 0 0 3-.685 6.842 6.842 0 0 0 3 .685c2.243 0 3.978-1.739 5.088-3.632C21.223 16.333 21.9 13.928 21.9 12c0-3.755-2.562-6.545-6.187-6.869.198-.472.282-.95.317-1.328a6.075 6.075 0 0 0-.013-1.223l-.003-.024-.001-.008v-.005l-.892.129.89-.13-.096-.664-.664-.097Zm-2.32 2.235c.266-.267.717-.412 1.227-.46l.088-.007a3.526 3.526 0 0 1-.007.088c-.048.51-.194.961-.46 1.228-.267.266-.718.412-1.228.46l-.088.007.007-.088c.048-.51.194-.961.46-1.228ZM3.9 12c0-3.003 2.097-5.1 5.1-5.1.852 0 1.635.203 2.334.564.419.216.916.216 1.334 0A5.064 5.064 0 0 1 15 6.9c3.003 0 5.1 2.097 5.1 5.1 0 1.573-.573 3.667-1.564 5.357C17.521 19.09 16.256 20.1 15 20.1a5.044 5.044 0 0 1-2.334-.564 1.454 1.454 0 0 0-1.332 0A5.043 5.043 0 0 1 9 20.1c-1.256 0-2.521-1.011-3.536-2.743C4.474 15.667 3.9 13.573 3.9 12Z",
    fill: "#023F80"
  })));
};

var _path$j;
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
var SvgAppleWatchOutlite = function SvgAppleWatchOutlite(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$k({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$j || (_path$j = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 1h-.038c-.528 0-.982 0-1.357.03-.395.033-.789.104-1.167.297a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C9 4.178 9 4.629 9 5.153c-.492.08-.9.204-1.27.392A5 5 0 0 0 5.545 7.73C5 8.8 5 10.2 5 13v2c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185c.37.188.778.311 1.27.392 0 .524 0 .976.03 1.348.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031h1.677c.528 0 .982 0 1.357-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.03-.372.031-.824.031-1.348.492-.08.9-.204 1.27-.392a5 5 0 0 0 2.185-2.185C23 19.2 23 17.8 23 15v-2.01c.196-.012.335-.039.454-.099a1 1 0 0 0 .437-.437C24 12.24 24 11.96 24 11.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437c-.147-.075-.326-.098-.606-.106-.081-.493-.204-.903-.393-1.273a5 5 0 0 0-2.185-2.185c-.37-.188-.778-.311-1.27-.392 0-.524 0-.975-.03-1.348-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296C15.82 1 15.365 1 14.839 1H13.2ZM21 13c0-1.433-.002-2.388-.061-3.121-.058-.71-.161-1.035-.266-1.241a3 3 0 0 0-1.311-1.311c-.206-.105-.53-.207-1.24-.266C17.387 7.001 16.432 7 15 7h-2c-1.433 0-2.388.002-3.121.061-.71.059-1.035.161-1.241.266a3 3 0 0 0-1.311 1.311c-.105.206-.208.53-.266 1.24C7.001 10.613 7 11.568 7 13v2c0 1.433.002 2.388.061 3.121.058.71.161 1.035.266 1.241a3 3 0 0 0 1.311 1.311c.206.105.53.208 1.24.266.734.06 1.689.061 3.122.061h2c1.433 0 2.388-.002 3.121-.061.71-.058 1.035-.161 1.241-.266a3 3 0 0 0 1.311-1.311c.105-.206.208-.53.266-1.24.06-.734.061-1.689.061-3.122v-2Zm-9.976 11.032c-.02-.25-.023-.572-.024-1.043.577.011 1.236.011 2 .011h2c.764 0 1.423 0 2-.011 0 .471-.003.792-.024 1.043-.022.272-.06.372-.085.422a1 1 0 0 1-.437.437c-.05.025-.15.063-.422.085C15.75 25 15.377 25 14.8 25h-1.6c-.577 0-.949 0-1.232-.024-.272-.022-.373-.06-.422-.085a1 1 0 0 1-.437-.437c-.025-.05-.063-.15-.085-.422ZM17 5.012c0-.472-.003-.793-.024-1.044-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085C15.75 3 15.377 3 14.8 3h-1.6c-.577 0-.949 0-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422-.02.251-.023.572-.024 1.043C11.577 5 12.236 5 13 5h2c.764 0 1.423 0 2 .011ZM14 9a1 1 0 0 1 1 1v3.807l3.351 1.257a1 1 0 0 1-.702 1.872l-4-1.5A1 1 0 0 1 13 14.5V10a1 1 0 0 1 1-1Z",
    fill: "#023F80"
  })));
};

var _path$k, _path2$8, _path3$4;
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
var SvgArchiveOutline = function SvgArchiveOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$l({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$k || (_path$k = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1 13.4a.9.9 0 0 1 .9-.9h4a.9.9 0 0 1 0 1.8h-4a.9.9 0 0 1-.9-.9Z",
    fill: "#023F80"
  })), _path2$8 || (_path2$8 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.1A2.9 2.9 0 0 0 2.1 6v2c0 1.113.93 1.9 2 1.9V18A2.9 2.9 0 0 0 7 20.9h10a2.9 2.9 0 0 0 2.9-2.9V9.9c1.07 0 2-.787 2-1.9V6A2.9 2.9 0 0 0 19 3.1H5Zm0 1.8A1.1 1.1 0 0 0 3.9 6v2a.1.1 0 0 0 .1.1h16a.1.1 0 0 0 .1-.1V6A1.1 1.1 0 0 0 19 4.9H5Zm2 14.2A1.1 1.1 0 0 1 5.9 18V9.9h12.2V18a1.1 1.1 0 0 1-1.1 1.1H7Z",
    fill: "#023F80"
  })), _path3$4 || (_path3$4 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12.5a.9.9 0 1 0 0 1.8h4a.9.9 0 0 0 0-1.8h-4Z",
    fill: "#023F80"
  })));
};

var _path$l;
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
var SvgArmchairOutline = function SvgArmchairOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$m({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$l || (_path$l = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 18.25c0 .232 0 .348.013.446a1.5 1.5 0 0 0 1.291 1.291C5.652 20 5.768 20 6 20s.348 0 .446-.013a1.5 1.5 0 0 0 1.291-1.291c.013-.098.013-.214.013-.446v-.35h8.5v.35c0 .232 0 .348.013.446a1.5 1.5 0 0 0 1.291 1.291c.098.013.214.013.446.013s.348 0 .446-.013a1.5 1.5 0 0 0 1.291-1.291c.013-.098.013-.214.013-.446v-.463c.193-.045.382-.109.567-.203a2.9 2.9 0 0 0 1.267-1.267c.184-.362.254-.741.286-1.13.03-.37.03-.822.03-1.352v-2.877c0-.19 0-.355-.016-.505a2.65 2.65 0 0 0-1.987-2.273c-.006-.455-.027-.813-.091-1.136a4.9 4.9 0 0 0-3.85-3.85c-.475-.094-1.022-.094-1.848-.094H9.892c-.825 0-1.373 0-1.848.094a4.9 4.9 0 0 0-3.85 3.85c-.064.323-.085.68-.091 1.136a2.65 2.65 0 0 0-1.986 2.273c-.017.15-.017.315-.017.505v2.877c0 .53 0 .981.03 1.352.032.389.102.768.286 1.13a2.9 2.9 0 0 0 1.268 1.267c.184.094.373.158.566.203v.463Zm.405-8.345C4.69 9.901 4.743 9.9 5 9.9s.31.001.345.005a.85.85 0 0 1 .75.75c.004.035.005.088.005.345v1.614c0 .056 0 .143.007.223.007.098.03.26.118.435.11.216.287.392.503.503.175.089.337.11.435.119.08.006.167.006.223.006h9.228c.056 0 .144 0 .224-.006a1.15 1.15 0 0 0 .937-.621c.089-.176.11-.338.119-.435.006-.08.006-.168.006-.224V11c0-.257.002-.31.006-.345a.85.85 0 0 1 .749-.75c.035-.004.088-.005.345-.005s.31.001.345.005a.85.85 0 0 1 .75.75c.004.035.005.088.005.345v2.8c0 .575 0 .952-.024 1.24-.023.278-.062.394-.096.46a1.1 1.1 0 0 1-.48.48c-.066.034-.182.073-.46.096-.288.023-.665.024-1.24.024H6.2c-.575 0-.952 0-1.24-.024-.278-.023-.393-.062-.46-.096a1.1 1.1 0 0 1-.48-.48c-.034-.066-.073-.182-.096-.46-.023-.288-.024-.665-.024-1.24V11c0-.257.002-.31.005-.345a.85.85 0 0 1 .75-.75Zm13.386-2.51a3.1 3.1 0 0 0-2.436-2.435c-.278-.056-.632-.06-1.605-.06h-4c-.972 0-1.327.004-1.605.06A3.1 3.1 0 0 0 5.96 7.395c-.036.18-.05.393-.056.787a2.65 2.65 0 0 1 1.98 2.271c.016.15.016.315.016.505V12.1h8.2v-1.142c0-.19 0-.355.017-.505a2.65 2.65 0 0 1 1.98-2.271c-.006-.394-.02-.607-.056-.787Z",
    fill: "#023F80"
  })));
};

var _path$m;
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
var SvgArrowDownOutline = function SvgArrowDownOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$n({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$m || (_path$m = /*#__PURE__*/createElement$2("path", {
    d: "M19.74 12.468a.9.9 0 0 0-1.18-.089l-.092.08L12.9 17.95V3.9a.9.9 0 0 0-1.793-.113L11.1 3.9v14.05l-5.568-5.49a.9.9 0 0 0-1.181-.073l-.092.081a.9.9 0 0 0-.072 1.181l.081.092 7.1 7a.9.9 0 0 0 1.172.08l.092-.08 7.1-7a.9.9 0 0 0 .009-1.273Z",
    fill: "#023F80"
  })));
};

var _path$n;
function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
var SvgArrowLeftOutline = function SvgArrowLeftOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$o({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$n || (_path$n = /*#__PURE__*/createElement$2("path", {
    d: "M11.532 19.74a.9.9 0 0 0 .089-1.18l-.08-.092L6.05 12.9H20.1a.9.9 0 0 0 .113-1.793L20.1 11.1H6.05l5.49-5.568a.9.9 0 0 0 .073-1.181l-.081-.092a.9.9 0 0 0-1.181-.072l-.092.081-7 7.1a.9.9 0 0 0-.08 1.172l.08.092 7 7.1a.9.9 0 0 0 1.273.009Z",
    fill: "#023F80"
  })));
};

var _path$o;
function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
var SvgArrowPopDownOutline = function SvgArrowPopDownOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$p({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$o || (_path$o = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 21a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H10a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11Zm0-2H10a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1Zm-4 6a3.001 3.001 0 0 0 2.83-2h-9.702c-1.783 0-2.43-.186-3.082-.534a3.635 3.635 0 0 1-1.512-1.512C5.186 20.302 5 19.655 5 17.872V9.171A3.001 3.001 0 0 0 3 12v7a6 6 0 0 0 6 6h8Zm2.207-14.79a1.001 1.001 0 1 0-1.416-1.417l-3.788 3.788v-2.247a1.001 1.001 0 1 0-2.003 0V15.008c.002.252.1.504.291.697l.002.002.002.002a.997.997 0 0 0 .697.291H17.666a1.001 1.001 0 1 0 0-2.003H15.42l3.788-3.787Z",
    fill: "#023F80"
  })));
};

var _path$p;
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
var SvgArrowPopUpOutline = function SvgArrowPopUpOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$q({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$p || (_path$p = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 21a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H10a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11Zm0-2H10a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1Zm-4 6a3.001 3.001 0 0 0 2.83-2h-9.702c-1.783 0-2.43-.186-3.082-.534a3.635 3.635 0 0 1-1.512-1.512C5.186 20.302 5 19.655 5 17.872V9.171A3.001 3.001 0 0 0 3 12v7a6 6 0 0 0 6 6h8Zm-4.707-10.71a1.001 1.001 0 1 0 1.417 1.417l3.787-3.788v2.247a1.001 1.001 0 1 0 2.003 0V9.492a.999.999 0 0 0-.291-.697l-.002-.002-.002-.002a.998.998 0 0 0-.697-.291H13.834a1.001 1.001 0 1 0 0 2.003h2.247l-3.788 3.787Z",
    fill: "#023F80"
  })));
};

var _path$q, _path2$9;
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
var SvgArrowRightCircleOutline = function SvgArrowRightCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$r({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$q || (_path$q = /*#__PURE__*/createElement$2("path", {
    d: "M8 14a1 1 0 0 1 1-1h7.586l-2.293-2.293a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L16.586 15H9a1 1 0 0 1-1-1Z",
    fill: "#023F80"
  })), _path2$9 || (_path2$9 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14C2 7.373 7.373 2 14 2s12 5.373 12 12-5.373 12-12 12S2 20.627 2 14ZM14 4C8.477 4 4 8.477 4 14s4.477 10 10 10 10-4.477 10-10S19.523 4 14 4Z",
    fill: "#023F80"
  })));
};

var _path$r;
function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
var SvgArrowRightOutline = function SvgArrowRightOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$s({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$r || (_path$r = /*#__PURE__*/createElement$2("path", {
    d: "M12.468 4.26a.9.9 0 0 0-.089 1.18l.08.092L17.95 11.1H3.9a.9.9 0 0 0-.113 1.793l.113.007h14.05l-5.49 5.568a.9.9 0 0 0-.073 1.181l.081.092a.9.9 0 0 0 1.181.072l.092-.081 7-7.1a.9.9 0 0 0 .08-1.172l-.08-.092-7-7.1a.9.9 0 0 0-1.273-.009Z",
    fill: "#023F80"
  })));
};

var _path$s;
function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
var SvgArrowRightSquareOutline = function SvgArrowRightSquareOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$t({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$s || (_path$s = /*#__PURE__*/createElement$2("path", {
    d: "M14.59 2.1c2.168 0 3.202.2 4.277.774a5.443 5.443 0 0 1 2.259 2.26c.574 1.074.774 2.108.774 4.276v5.18c0 2.168-.2 3.202-.774 4.276a5.443 5.443 0 0 1-2.26 2.26c-1.074.574-2.108.774-4.276.774H9.41c-2.168 0-3.202-.2-4.276-.774a5.443 5.443 0 0 1-2.26-2.26C2.3 17.792 2.1 16.758 2.1 14.59V9.41c0-2.168.2-3.202.774-4.277a5.443 5.443 0 0 1 2.26-2.259C6.208 2.3 7.242 2.1 9.41 2.1h5.18Zm0 1.8H9.41c-1.896 0-2.65.145-3.428.561a3.644 3.644 0 0 0-1.52 1.521C4.046 6.76 3.9 7.514 3.9 9.41v5.18c0 1.896.146 2.65.562 3.428a3.644 3.644 0 0 0 1.52 1.52c.778.416 1.532.562 3.428.562h5.18c1.897 0 2.65-.146 3.428-.562a3.644 3.644 0 0 0 1.52-1.52c.417-.778.562-1.532.562-3.428V9.41c0-1.896-.145-2.65-.561-3.428a3.644 3.644 0 0 0-1.521-1.52c-.778-.417-1.531-.562-3.428-.562ZM12.31 8.221a.9.9 0 0 1 1.27.088l2.7 3.1a.9.9 0 0 1 0 1.182l-2.7 3.1a.9.9 0 0 1-1.358-1.182l1.401-1.609H8.4a.9.9 0 0 1-.893-.787L7.5 12a.9.9 0 0 1 .9-.9h5.222l-1.4-1.609a.9.9 0 0 1 0-1.183l.087-.087Z",
    fill: "#023F80"
  })));
};

var _path$t;
function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
var SvgArrowUpCircleOutline = function SvgArrowUpCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$u({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$t || (_path$t = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4C8.477 4 4 8.477 4 14s4.477 10 10 10 10-4.477 10-10S19.523 4 14 4ZM2 14C2 7.373 7.373 2 14 2s12 5.373 12 12-5.373 12-12 12S2 20.627 2 14Zm11-2.586-2.293 2.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L15 11.414V19a1 1 0 1 1-2 0v-7.586Z",
    fill: "#023F80"
  })));
};

var _path$u;
function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
var SvgArrowUpOutline = function SvgArrowUpOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$v({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$u || (_path$u = /*#__PURE__*/createElement$2("path", {
    d: "M11.368 3.26a.9.9 0 0 1 1.264 0l7.1 7a.9.9 0 0 1-1.264 1.28L12.9 6.052V20.1a.9.9 0 1 1-1.8 0V6.051l-5.568 5.49a.9.9 0 0 1-1.264-1.282l7.1-7Z",
    fill: "#023F80"
  })));
};

var _path$v, _path2$a;
function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
var SvgArrowUpRectangleOutline = function SvgArrowUpRectangleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$w({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$v || (_path$v = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07 4.801C6.164 4.216 7.243 4 9.691 4h8.616c2.448 0 3.527.216 4.622.801A5.465 5.465 0 0 1 25.2 7.07c.585 1.096.801 2.175.801 4.623v4.616c0 2.448-.216 3.527-.801 4.622A5.465 5.465 0 0 1 22.93 23.2c-1.095.585-2.174.801-4.622.801H9.692c-2.448 0-3.527-.216-4.623-.801a5.465 5.465 0 0 1-2.268-2.269C2.216 19.835 2 18.756 2 16.308v-4.616c0-2.448.216-3.527.801-4.623A5.466 5.466 0 0 1 5.07 4.801ZM9.691 6c-2.335 0-3.019.212-3.68.565a3.466 3.466 0 0 0-1.447 1.448C4.212 8.673 4 9.357 4 11.692v4.616c0 2.335.212 3.019.565 3.68a3.466 3.466 0 0 0 1.448 1.447c.66.353 1.344.565 3.679.565h8.616c2.335 0 3.019-.212 3.68-.565a3.467 3.467 0 0 0 1.447-1.448c.353-.66.565-1.344.565-3.679v-4.616c0-2.335-.212-3.019-.565-3.68a3.466 3.466 0 0 0-1.448-1.447C21.327 6.212 20.643 6 18.308 6H9.692Z",
    fill: "#023F80"
  })), _path2$a || (_path2$a = /*#__PURE__*/createElement$2("path", {
    d: "M13 18a1 1 0 1 0 2 0v-5.586l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414L13 12.414V18Z",
    fill: "#023F80"
  })));
};

var _path$w;
function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
var SvgArrowUturnLeftOutline = function SvgArrowUturnLeftOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$x({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$w || (_path$w = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.236 3.264a.9.9 0 0 1 0 1.272L7.673 7.1H12a5.9 5.9 0 1 1 0 11.8H7.9a.9.9 0 1 1 0-1.8H12a4.1 4.1 0 1 0 0-8.2H7.673l2.563 2.564a.9.9 0 1 1-1.272 1.272l-4.1-4.1a.9.9 0 0 1 0-1.272l4.1-4.1a.9.9 0 0 1 1.272 0Z",
    fill: "#023F80"
  })));
};

var _path$x;
function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
var SvgArrowUturnRightOutline = function SvgArrowUturnRightOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$y({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$x || (_path$x = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.764 3.264a.9.9 0 0 1 1.273 0l4.1 4.1a.9.9 0 0 1 0 1.272l-4.1 4.1a.9.9 0 0 1-1.273-1.272L16.327 8.9H12a4.1 4.1 0 1 0 0 8.2h4.1a.9.9 0 1 1 0 1.8H12a5.9 5.9 0 1 1 0-11.8h4.327l-2.563-2.564a.9.9 0 0 1 0-1.272Z",
    fill: "#023F80"
  })));
};

var _path$y;
function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }
var SvgArticleOutline = function SvgArticleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$z({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$y || (_path$y = /*#__PURE__*/createElement$2("path", {
    d: "M21 11H3a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2Zm0-7H3a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2ZM3 20h10a1 1 0 1 0 0-2H3a1 1 0 1 0 0 2Z",
    fill: "#023F80"
  })));
};

var _path$z;
function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }
var SvgArticlesOutline = function SvgArticlesOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$A({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$z || (_path$z = /*#__PURE__*/createElement$2("path", {
    d: "M3 7a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H9v7a1 1 0 1 1-2 0V8H4a1 1 0 0 1-1-1ZM17 8a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2h-7ZM12 15a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1ZM7 21a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z",
    fill: "#023F80"
  })));
};

var _path$A;
function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
var SvgAttachOutline = function SvgAttachOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$B({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$A || (_path$A = /*#__PURE__*/createElement$2("path", {
    d: "M14.189 10.897a1 1 0 0 1 1.414 1.414l-4.172 4.172a1.504 1.504 0 0 0 0 2.121c.6.6 1.554.567 2.121 0l7.778-7.778c1.602-1.601 1.514-4.143 0-5.657-1.514-1.514-4.055-1.601-5.656 0l-7.779 7.779c-2.55 2.55-2.503 6.689 0 9.192 2.504 2.503 6.642 2.55 9.193 0l4.172-4.172a1 1 0 1 1 1.414 1.414l-4.172 4.172c-3.34 3.34-8.744 3.277-12.02 0-3.278-3.277-3.34-8.682 0-12.02l7.777-7.779c2.406-2.405 6.212-2.274 8.486 0 2.274 2.274 2.405 6.08 0 8.485l-7.779 7.779c-1.327 1.327-3.546 1.403-4.95 0-1.403-1.404-1.326-3.623 0-4.95l4.173-4.172Z",
    fill: "#023F80"
  })));
};

var _path$B, _rect, _rect2, _path2$b, _path3$5;
function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }
var SvgBabyBottleOutline = function SvgBabyBottleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$C({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$B || (_path$B = /*#__PURE__*/createElement$2("path", {
    d: "M8 14.22c0-1.139 0-1.709.225-2.142a2 2 0 0 1 .853-.853C9.512 11 10.081 11 11.22 11h5.56c1.139 0 1.708 0 2.142.225a2 2 0 0 1 .853.853c.225.434.225 1.003.225 2.142v7.56c0 1.139 0 1.708-.225 2.142a2 2 0 0 1-.853.853C18.488 25 17.919 25 16.78 25h-5.56c-1.139 0-1.708 0-2.142-.225a2 2 0 0 1-.853-.853C8 23.488 8 22.919 8 21.78v-7.56Z",
    stroke: "#023F80",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/createElement$2("rect", {
    x: 7.5,
    y: 15.5,
    width: 4,
    height: 1,
    rx: 0.5,
    stroke: "#023F80"
  })), _rect2 || (_rect2 = /*#__PURE__*/createElement$2("rect", {
    x: 7.5,
    y: 19.5,
    width: 6,
    height: 1,
    rx: 0.5,
    stroke: "#023F80"
  })), _path2$b || (_path2$b = /*#__PURE__*/createElement$2("path", {
    d: "M9 10.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C10.52 7 11.08 7 12.2 7h3.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C19 8.52 19 9.08 19 10.2v.8H9v-.8ZM17 6c0-1-1-1.5-1-2a2 2 0 1 0-4 0c0 .5-1 1-1 2v1h6V6Z",
    stroke: "#023F80",
    strokeWidth: 2
  })), _path3$5 || (_path3$5 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1a3 3 0 0 0-2.996 2.837 3.05 3.05 0 0 1-.113.141c-.043.052-.097.116-.172.21C10.44 4.538 10 5.142 10 6v.178c-.122.04-.243.088-.362.149a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C8 9.18 8 9.635 8 10.162v.602a3 3 0 0 0-.662.853c-.2.383-.273.783-.306 1.185C7 13.182 7 13.645 7 14.18v7.639c0 .535 0 .998.032 1.378.033.402.107.802.306 1.185a3 3 0 0 0 1.28 1.28c.382.198.782.272 1.184.305.38.032.843.032 1.379.032H16.82c.535 0 .998 0 1.378-.032.402-.033.802-.107 1.185-.306a2.999 2.999 0 0 0 1.28-1.28c.198-.382.272-.782.305-1.184.032-.38.032-.843.032-1.379V14.18c0-.535 0-.998-.032-1.378-.033-.402-.107-.802-.306-1.185a3 3 0 0 0-.662-.853v-.602c0-.528 0-.982-.03-1.357-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.12-.06-.24-.11-.362-.149V6c0-.858-.44-1.463-.72-1.812-.074-.094-.128-.158-.17-.21a3.056 3.056 0 0 1-.114-.14A3 3 0 0 0 14 1Zm1.8 7h-3.6c-.577 0-.949 0-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422-.02.249-.023.567-.024 1.032H18c0-.465-.004-.783-.024-1.032-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085C16.75 8 16.377 8 15.8 8Zm.115-2H16c0-.142-.06-.287-.28-.563a8.832 8.832 0 0 0-.08-.097h-.001c-.09-.11-.215-.261-.3-.38C15.22 4.79 15 4.449 15 4a1 1 0 1 0-2 0c0 .449-.22.79-.34.96-.084.119-.209.27-.299.38a8.21 8.21 0 0 0-.08.097C12.06 5.713 12 5.858 12 6h3.916Zm-4.864-2.232-.006.011a.066.066 0 0 1 .006-.01Zm5.898 0 .006.011a.062.062 0 0 1-.006-.01Zm-6.982 8.257C10.255 12 10.634 12 11.22 12h5.56c.586 0 .965 0 1.253.025.276.023.378.061.428.088a1 1 0 0 1 .426.426c.026.05.065.152.088.428.024.288.025.667.025 1.253v7.56c0 .586 0 .965-.025 1.253-.023.276-.062.378-.088.428a1 1 0 0 1-.426.426c-.05.026-.152.065-.428.088-.288.024-.667.025-1.253.025h-5.56c-.586 0-.965 0-1.253-.025-.276-.023-.378-.062-.428-.088a1 1 0 0 1-.426-.426c-.026-.05-.065-.152-.088-.428C9 22.745 9 22.366 9 21.78V21h4a1 1 0 1 0 0-2H9v-2h2a1 1 0 1 0 0-2H9v-.78c0-.586 0-.965.025-1.253.023-.276.062-.378.088-.428a1 1 0 0 1 .426-.426c.05-.027.152-.065.428-.088Z",
    fill: "#023F80"
  })));
};

var _path$C;
function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }
var SvgBackspaceOutline = function SvgBackspaceOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$D({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$C || (_path$C = /*#__PURE__*/createElement$2("path", {
    d: "M18.666 4c2.245 0 3.287.278 4.264.801A5.452 5.452 0 0 1 25.2 7.07c.522.978.801 2.02.801 4.265v5.332c0 2.245-.279 3.287-.801 4.264A5.452 5.452 0 0 1 22.93 23.2c-.977.522-2.019.801-4.264.801h-6.91c-1.124 0-1.52-.05-1.954-.165a3.51 3.51 0 0 1-1.182-.56l-.142-.108c-.306-.24-.605-.547-1.222-1.301L3.56 17.34c-1-1.226-1.26-1.757-1.43-2.39a3.605 3.605 0 0 1 0-1.902c.17-.633.43-1.164 1.43-2.39l3.96-4.842c.527-.626.786-.863 1.101-1.091a3.51 3.51 0 0 1 1.182-.56c.406-.109.777-.16 1.739-.165L18.666 4Zm0 2-7.28.002-.328.007c-.288.01-.463.028-.613.059l-.13.03a1.512 1.512 0 0 0-.523.248l-.105.08c-.176.145-.366.348-.758.823l-3.82 4.676c-.655.8-.881 1.148-1 1.486l-.048.157c-.08.293-.08.57 0 .864l.048.157c.119.338.345.686 1 1.486l3.82 4.676.332.392c.185.212.309.334.426.43l.105.08c.166.12.326.196.524.249l.142.033c.198.039.443.058.928.063l7.28.002c1.777 0 2.564-.16 3.321-.565a3.452 3.452 0 0 0 1.448-1.448c.38-.712.545-1.451.563-3.018v-5.938c-.018-1.567-.182-2.306-.563-3.018a3.452 3.452 0 0 0-1.448-1.448C21.231 6.16 20.443 6 18.666 6Zm-6.873 4.293a1 1 0 0 1 1.414 0l2.293 2.292 2.293-2.292a1 1 0 1 1 1.414 1.414L16.915 14l2.292 2.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.414 0L15.5 15.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L14.086 14l-2.293-2.293a1 1 0 0 1-.083-1.32l.083-.094Z",
    fill: "#023F80"
  })));
};

var _path$D;
function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }
var SvgBallOutline = function SvgBallOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$E({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$D || (_path$D = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5a9.872 9.872 0 0 1 7-2.9c2.734 0 5.21 1.11 7 2.9a9.872 9.872 0 0 1 2.9 7c0 2.733-1.109 5.21-2.9 7a9.872 9.872 0 0 1-7 2.9A9.872 9.872 0 0 1 5 19a9.872 9.872 0 0 1-2.9-7c0-2.734 1.11-5.21 2.9-7Zm7.9 15c0-2.134-.75-4.092-2.003-5.625l1.603-1.602 5.09 5.09a8.069 8.069 0 0 1-4.69 2.188V20Zm-1.8 0a7.07 7.07 0 0 0-1.484-4.344L6.944 18.33A8.057 8.057 0 0 0 11.1 20.05V20ZM4 12.9c1.636 0 3.143.553 4.344 1.483L5.67 17.056A8.057 8.057 0 0 1 3.95 12.9H4Zm8.5-2.673 1.602-1.602A8.859 8.859 0 0 1 12.145 3.9L12 3.9a8.06 8.06 0 0 0-4.478 1.35l4.978 4.977Zm4.556-4.556-1.673 1.673a7.066 7.066 0 0 1-1.391-3.197 8.067 8.067 0 0 1 3.064 1.524Zm2.797 4.337a7.066 7.066 0 0 1-3.197-1.391l1.673-1.673a8.068 8.068 0 0 1 1.524 3.064Zm-6.08 1.492 1.602-1.602a8.858 8.858 0 0 0 4.724 1.957L20.1 12a8.058 8.058 0 0 1-1.35 4.478L13.774 11.5Zm-4.148 1.602 1.602-1.602-5.09-5.09A8.069 8.069 0 0 0 3.95 11.1H4c2.134 0 4.093.75 5.626 2.002Z",
    fill: "#023F80"
  })));
};

var _path$E;
function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }
var SvgBankOutline = function SvgBankOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$F({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$E || (_path$E = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.728 4.836a1.1 1.1 0 0 1 .558 0c.166.044.346.158 1.096.718l6.173 4.61a.9.9 0 0 0 1.077-1.441l-6.173-4.61-.114-.087c-.571-.427-1.05-.786-1.602-.93a2.9 2.9 0 0 0-1.47-.002c-.551.145-1.031.503-1.602.93l-.115.086-6.188 4.612a.9.9 0 0 0 1.076 1.443l6.188-4.612c.75-.56.93-.674 1.096-.717ZM12.9 10.89a.9.9 0 1 0-1.8 0v8.21H8.9v-8.208a.9.9 0 0 0-1.8 0V19.1H3.902a.9.9 0 1 0 0 1.8h16.196a.9.9 0 0 0 0-1.8H16.9v-8.207a.9.9 0 0 0-1.8 0V19.1h-2.2v-8.21Z",
    fill: "#023F80"
  })));
};

var _path$F;
function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }
var SvgBasketballBallOutline = function SvgBasketballBallOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$G({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$F || (_path$F = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.834 11.999a11.954 11.954 0 0 0-2.67-5.748c-.432-.51-.905-.983-1.415-1.414A11.953 11.953 0 0 0 14 2a11.944 11.944 0 0 0-8.187 3.227 11.975 11.975 0 0 0-3.797 9.39 11.948 11.948 0 0 0 2.821 7.132c.431.51.905.983 1.414 1.414A11.95 11.95 0 0 0 14 26a11.976 11.976 0 0 0 8.773-3.813A11.944 11.944 0 0 0 26 14c0-.682-.057-1.35-.166-2.001ZM14.166 4a11.953 11.953 0 0 0 2.671 5.748L15 11.586 8.844 5.43A9.953 9.953 0 0 1 14.166 4Zm4.085 7.162L16.414 13l6.156 6.156A9.954 9.954 0 0 0 24 13.834a11.953 11.953 0 0 1-5.748-2.67Zm5.494.582a9.965 9.965 0 0 0-2.002-4.074l-2.072 2.072a9.965 9.965 0 0 0 4.074 2.002Zm-2.387 9.027a9.987 9.987 0 0 1-5.36 3.028 11.95 11.95 0 0 0-2.835-7.549L15 14.414l6.358 6.358ZM14 24a9.96 9.96 0 0 0-2.257-6.329l-4.072 4.072A9.96 9.96 0 0 0 14 24Zm-.414-11-1.837 1.837a11.95 11.95 0 0 0-7.55-2.835 9.987 9.987 0 0 1 3.029-5.36L13.586 13ZM6.257 20.33A9.958 9.958 0 0 1 4 14c2.401 0 4.605.846 6.329 2.257L6.257 20.33Zm9.998-16.074a9.964 9.964 0 0 1 4.074 2.002L18.257 8.33a9.964 9.964 0 0 1-2.002-4.074Z",
    fill: "#023F80"
  })));
};

var _path$G;
function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }
var SvgBeautyOutline = function SvgBeautyOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$H({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$G || (_path$G = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9 15.933A6.002 6.002 0 0 0 16 4a6 6 0 0 0-.9 11.933V19.1h-2.2a.9.9 0 1 0 0 1.8h6.2a.9.9 0 1 0 0-1.8h-2.2v-3.167ZM20.2 10a4.2 4.2 0 1 1-8.4 0 4.2 4.2 0 0 1 8.4 0ZM7.526 4.27A.9.9 0 0 1 7.9 5v5.1h.25a.75.75 0 0 1 .75.75v6.65a3.4 3.4 0 1 1-6.8 0v-6.65a.75.75 0 0 1 .75-.75h.25V6a.9.9 0 0 1 .615-.854l3-1a.9.9 0 0 1 .811.124ZM6.1 6.249V10.1H4.9V6.649l1.2-.4ZM3.9 11.9h3.2v5.6a1.6 1.6 0 1 1-3.2 0v-5.6Z",
    fill: "#023F80"
  })));
};

var _path$H;
function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }
var SvgBidyOutline = function SvgBidyOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$I({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$H || (_path$H = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.301 3.9H8.3c-.125 0-.349.056-.68.244-.32.182-.669.447-1.026.764a16.383 16.383 0 0 0-1.647 1.733l1.717 1.77.034.035c.13.134.285.292.4.483.1.167.173.348.219.537a2.7 2.7 0 0 1 .053.674l.022 4.784c.003.623.01.776.027.85.026.115.032.132.033.134 0 .001.005.016.063.119a4.692 4.692 0 0 0 .193.243c.14.165.337.385.614.695.713.8 1.41 1.769 1.894 2.482.31.457.363.516.394.541.057.047.1.07.17.09.04.013.108.022.627.022h1.186c.52 0 .587-.01.626-.021a.443.443 0 0 0 .171-.09c.031-.026.083-.085.394-.542.483-.711 1.177-1.677 1.887-2.474.278-.312.475-.534.616-.7.07-.082.12-.142.154-.188.03-.039.04-.056.04-.056.058-.103.063-.118.063-.12.001-.001.007-.016.034-.134.016-.075.022-.228.022-.856V10.104c0-.189-.001-.413.051-.634a1.9 1.9 0 0 1 .223-.544 2.706 2.706 0 0 1 .442-.523l1.734-1.766a16.359 16.359 0 0 0-1.646-1.73 6.355 6.355 0 0 0-1.025-.763c-.33-.188-.554-.244-.679-.244h-.004v.001c-.5.594-1.768 1.845-3.696 1.845-1.936 0-3.197-1.244-3.697-1.844L8.301 3.9Zm.07-1.8c.104-.001.306-.003.49.047.161.043.292.104.429.2.11.079.192.166.238.217.046.052.1.115.15.176l.008.01c.384.46 1.185 1.196 2.314 1.196 1.118 0 1.927-.739 2.317-1.203l.008-.01c.05-.059.102-.121.149-.173.046-.05.127-.137.237-.214.137-.096.267-.156.428-.2.183-.048.383-.047.486-.046h.075c.572 0 1.115.221 1.57.48.465.265.918.616 1.328.979.82.726 1.55 1.573 1.97 2.09l.025.03c.095.113.294.352.37.657.064.254.052.53-.035.777a1.344 1.344 0 0 1-.244.418c-.066.08-.147.161-.21.226L18.6 9.664a6.209 6.209 0 0 0-.19.199.098.098 0 0 0-.007.017 6.36 6.36 0 0 0-.004.274V15.027c0 .461 0 .84-.065 1.138a2.674 2.674 0 0 1-.108.385 2.672 2.672 0 0 1-.176.36 3.567 3.567 0 0 1-.392.529c-.156.184-.368.421-.635.722l-.009.009c-.632.71-1.274 1.6-1.743 2.29l-.054.08c-.217.32-.427.63-.694.846-.239.194-.491.328-.786.417-.329.098-.688.098-1.056.097h-1.365c-.367 0-.726.001-1.055-.097a2.237 2.237 0 0 1-.786-.417c-.267-.216-.477-.526-.694-.847a51.974 51.974 0 0 0-.054-.08c-.47-.691-1.115-1.584-1.75-2.295l-.008-.01a45.464 45.464 0 0 1-.633-.718 3.568 3.568 0 0 1-.39-.526 2.673 2.673 0 0 1-.175-.357 2.679 2.679 0 0 1-.11-.383c-.066-.295-.067-.672-.069-1.13v-.107l-.023-4.784a6.195 6.195 0 0 0-.006-.27.1.1 0 0 0-.007-.018 6.209 6.209 0 0 0-.185-.197L3.53 7.766l-.013-.013c-.063-.065-.142-.147-.207-.226a1.345 1.345 0 0 1-.241-.418 1.363 1.363 0 0 1-.034-.773c.077-.304.275-.542.37-.654.009-.011.017-.022.025-.03.42-.516 1.15-1.364 1.97-2.091.41-.363.863-.715 1.33-.98.454-.26.998-.481 1.57-.481H8.371Z",
    fill: "#023F80"
  })));
};

var _path$I;
function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }
var SvgBillheadOutline = function SvgBillheadOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$J({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$I || (_path$I = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4.9h-.2c-.855 0-1.442 0-1.897.038-.445.036-.683.103-.856.19a2.1 2.1 0 0 0-.918.919c-.088.172-.155.411-.191.856C4.901 7.358 4.9 7.945 4.9 8.8v6.4c0 .855 0 1.442.038 1.897.036.445.103.683.191.856a2.1 2.1 0 0 0 .918.918c.173.088.411.155.856.191.455.037 1.042.038 1.897.038h6.4c.855 0 1.442 0 1.897-.038.445-.036.684-.103.856-.19a2.1 2.1 0 0 0 .918-.919c.088-.172.155-.411.191-.856.037-.455.038-1.042.038-1.897V8.8c0-.855 0-1.442-.038-1.897-.036-.445-.103-.684-.19-.856a2.1 2.1 0 0 0-.919-.918c-.172-.088-.411-.155-.856-.191C16.642 4.9 16.055 4.9 15.2 4.9H9Zm5.99-1.8h.248c.808 0 1.469 0 2.006.044.556.045 1.058.142 1.527.381a3.9 3.9 0 0 1 1.704 1.704c.239.47.336.971.381 1.527.044.537.044 1.198.044 2.006V15.238c0 .808 0 1.469-.044 2.006-.045.556-.142 1.058-.381 1.526a3.9 3.9 0 0 1-1.704 1.705c-.47.239-.971.336-1.527.381-.537.044-1.198.044-2.006.044H8.762c-.808 0-1.469 0-2.006-.044-.556-.045-1.058-.142-1.526-.381a3.9 3.9 0 0 1-1.705-1.705c-.239-.468-.336-.97-.381-1.526-.044-.537-.044-1.198-.044-2.006V8.762c0-.808 0-1.469.044-2.006.045-.556.142-1.058.381-1.527A3.9 3.9 0 0 1 5.23 3.525c.468-.239.97-.336 1.526-.381C7.293 3.1 7.954 3.1 8.762 3.1h.248c.014-.348.053-.583.154-.781a1.5 1.5 0 0 1 .655-.656C10.14 1.5 10.56 1.5 11.4 1.5h1.2c.84 0 1.26 0 1.581.163a1.5 1.5 0 0 1 .656.656c.1.198.139.433.154.781ZM11 7.1a.9.9 0 1 0 0 1.8h5a.9.9 0 1 0 0-1.8h-5Zm-.9 4.9a.9.9 0 0 1 .9-.9h5a.9.9 0 1 1 0 1.8h-5a.9.9 0 0 1-.9-.9Zm.9 3.1a.9.9 0 1 0 0 1.8h3a.9.9 0 0 0 0-1.8h-3ZM7 8a.9.9 0 1 1 1.8 0A.9.9 0 0 1 7 8Zm.9 3.1a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8ZM7 16a.9.9 0 1 1 1.8 0A.9.9 0 0 1 7 16Z",
    fill: "#023F80"
  })));
};

var _path$J;
function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }
var SvgBlockOutline = function SvgBlockOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$K({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$J || (_path$J = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1 12c0-5.468 4.432-9.9 9.9-9.9s9.9 4.432 9.9 9.9-4.432 9.9-9.9 9.9-9.9-4.432-9.9-9.9ZM12 3.9a8.1 8.1 0 0 1 6.329 13.156L6.944 5.67A8.066 8.066 0 0 1 12 3.9ZM3.9 12a8.1 8.1 0 0 0 13.156 6.329L5.671 6.944A8.066 8.066 0 0 0 3.901 12Z",
    fill: "#023F80"
  })));
};

var _path$K;
function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }
var SvgBodyOutline = function SvgBodyOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$L({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$K || (_path$K = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.998 5c-.143 0-.39.062-.749.261a6.835 6.835 0 0 0-1.116.813c-.7.608-1.35 1.33-1.791 1.854l1.896 1.896.037.036c.134.134.304.303.43.51.11.178.19.373.24.577a2.795 2.795 0 0 1 .055.716v5.124c0 .689.006.856.023.932.024.112.032.137.033.14.001.003.012.027.067.127.004.007.049.075.204.263.152.183.365.429.665.774.776.895 1.564 2.003 2.107 2.804.15.22.24.355.315.453.07.093.093.11.09.108a.45.45 0 0 0 .172.09c.036.012.1.022.654.022h1.517c.474 0 .52-.009.557-.02a.602.602 0 0 0 .168-.087c.034-.026.06-.048.308-.396.236-.33.475-.683.716-1.038.459-.679.925-1.367 1.39-1.929.309-.372.53-.64.687-.837.152-.191.202-.267.21-.28l.002-.001a3.88 3.88 0 0 0 .063-.124l.003-.013c.006-.023.014-.058.027-.123.016-.074.022-.226.022-.865v-5.175c0-.19-.001-.43.055-.665.05-.204.13-.399.24-.578.126-.206.296-.375.43-.509l.037-.036 1.896-1.896c-.441-.524-1.092-1.246-1.79-1.854a6.831 6.831 0 0 0-1.117-.813C18.39 5.061 18.142 5 18 5h-.001c-.544.653-1.908 2-3.999 2-2.101 0-3.458-1.342-4.002-2Zm.088-2c.112-.001.336-.003.54.052.18.049.324.117.475.224.123.087.213.186.263.242.051.057.109.127.164.193l.008.011C11.947 4.217 12.793 5 14 5c1.196 0 2.052-.786 2.466-1.285l.009-.01c.054-.066.112-.135.163-.192.05-.056.14-.153.262-.239.151-.106.295-.174.474-.222.202-.055.425-.053.537-.052H18c.626 0 1.221.235 1.722.513.512.284 1.009.662 1.458 1.052.897.78 1.696 1.693 2.16 2.257.009.01.018.022.03.034.106.126.332.393.418.736.072.285.058.594-.041.871a1.494 1.494 0 0 1-.277.468c-.075.089-.166.18-.239.252l-2.055 2.056a6.14 6.14 0 0 0-.171.174l-.002.002v.004a6.125 6.125 0 0 0-.003.244v5.234c0 .468 0 .858-.064 1.167l-.002.008c-.024.116-.053.253-.104.394a2.88 2.88 0 0 1-.171.37l-.004.007c-.1.188-.26.398-.416.595-.172.215-.406.498-.705.859l-.008.01c-.41.495-.775 1.035-1.189 1.649-.251.372-.52.77-.83 1.204l-.039.055c-.185.26-.375.527-.66.752a2.59 2.59 0 0 1-.841.432c-.349.102-.699.102-1.043.101H13.236c-.39 0-.778.002-1.136-.106a2.446 2.446 0 0 1-.856-.454c-.29-.236-.515-.569-.743-.906l-.057-.084c-.53-.782-1.264-1.812-1.962-2.616l-.01-.01c-.288-.333-.516-.596-.684-.8a3.953 3.953 0 0 1-.42-.579 2.931 2.931 0 0 1-.185-.387 2.93 2.93 0 0 1-.113-.413c-.07-.32-.07-.735-.07-1.237l.001-.12v-5.125c0-.131 0-.197-.002-.244v-.004l-.003-.002a6.175 6.175 0 0 0-.17-.175l-2.041-2.04-.015-.015a4.372 4.372 0 0 1-.239-.252 1.495 1.495 0 0 1-.277-.468 1.515 1.515 0 0 1-.041-.871c.086-.343.312-.61.419-.736l.028-.034c.465-.564 1.264-1.476 2.161-2.257.45-.39.946-.768 1.458-1.052C8.778 3.235 9.374 3 10 3h.086Z",
    fill: "#023F80"
  })));
};

var _path$L;
function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }
var SvgBombOutline = function SvgBombOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$M({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$L || (_path$L = /*#__PURE__*/createElement$2("path", {
    d: "M10.5 5c2.014 0 3.864.7 5.32 1.87l.598-.599a.926.926 0 0 1 1.388 1.223l-.077.088-.6.598A8.5 8.5 0 1 1 10.5 5Zm0 1.8a6.7 6.7 0 1 0 0 13.4 6.7 6.7 0 0 0 0-13.4Zm10.189-.583.11.03 1.58.517a.887.887 0 0 1 .574 1.128.913.913 0 0 1-1.042.59l-.11-.028-1.58-.518a.887.887 0 0 1-.574-1.128.913.913 0 0 1 1.042-.59Zm-3.466-4.715.043.104.487 1.425a.883.883 0 0 1-.572 1.123.914.914 0 0 1-1.104-.456l-.043-.104-.487-1.425a.883.883 0 0 1 .572-1.123.914.914 0 0 1 1.104.456Zm4.513.762a.9.9 0 0 1 .075 1.188l-.075.084-1.2 1.2a.9.9 0 0 1-1.347-1.188l.075-.084 1.2-1.2a.9.9 0 0 1 1.272 0Z",
    fill: "#023F80"
  })));
};

var _path$M;
function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }
var SvgBookOutline = function SvgBookOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$N({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$M || (_path$M = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.759 2H18.24c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C24 6.29 24 6.954 24 7.758V9h-2V7.8c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18C19.639 4 19.057 4 18.2 4H9.8c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C6 6.361 6 6.943 6 7.8v12.37c.313-.11.65-.17 1-.17h15V9.002h2V21a1 1 0 0 1-1 1h-.9a5.028 5.028 0 0 0 0 2h1.019a1 1 0 1 1 0 2H7a3 3 0 0 1-3-3V7.759c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C8.29 2 8.954 2 9.758 2ZM20.07 24a7.051 7.051 0 0 1 0-2H7a1 1 0 1 0 0 2h13.071Z",
    fill: "#023F80"
  })));
};

var _path$N;
function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }
var SvgBookmarkOutline = function SvgBookmarkOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$O({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$N || (_path$N = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.083 3h1.834c1.056 0 1.903 0 2.588.056.704.058 1.316.179 1.88.466a4.789 4.789 0 0 1 2.093 2.093c.287.564.409 1.176.466 1.88C20 8.18 20 9.027 20 10.083v7.615c0 .773 0 1.414-.045 1.914-.045.494-.145 1.026-.482 1.454a2.456 2.456 0 0 1-1.896.935c-.544.007-1.027-.238-1.447-.503-.423-.268-.933-.658-1.546-1.128l-1.617-1.24c-.607-.466-.714-.526-.797-.549a.657.657 0 0 0-.34 0c-.083.023-.19.083-.797.549l-1.617 1.24c-.613.47-1.123.86-1.546 1.128-.42.265-.903.51-1.447.503a2.456 2.456 0 0 1-1.896-.936c-.337-.427-.437-.96-.482-1.453C4 19.112 4 18.47 4 17.698v-7.615c0-1.056 0-1.903.056-2.588.058-.704.179-1.316.466-1.88a4.789 4.789 0 0 1 2.093-2.093c.564-.287 1.176-.408 1.88-.466C9.18 3 10.027 3 11.083 3ZM8.641 4.85c-.593.048-.941.14-1.209.276a2.989 2.989 0 0 0-1.306 1.306c-.137.268-.228.616-.276 1.21-.05.603-.05 1.376-.05 2.48v7.532c0 .828 0 1.387.038 1.794.038.414.103.503.103.503a.655.655 0 0 0 .506.25s.11-.003.461-.225c.346-.218.79-.557 1.448-1.062l1.582-1.213.1-.077c.44-.338.85-.654 1.327-.782a2.454 2.454 0 0 1 1.27 0c.478.128.888.444 1.326.782l.101.077 1.582 1.213c.658.505 1.102.844 1.448 1.062.351.222.461.225.461.225a.655.655 0 0 0 .506-.25s.065-.089.103-.503c.037-.407.038-.966.038-1.794v-7.532c0-1.104 0-1.877-.05-2.48-.048-.594-.14-.942-.276-1.21a2.989 2.989 0 0 0-1.306-1.306c-.268-.137-.617-.228-1.21-.276-.603-.05-1.376-.05-2.48-.05h-1.756c-1.104 0-1.877 0-2.48.05Z",
    fill: "#023F80"
  })));
};

var _path$O;
function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }
var SvgBooksOutline = function SvgBooksOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$P({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$O || (_path$O = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4 3.9H9.8c-.855 0-1.442 0-1.897.038-.445.036-.683.103-.856.19a2.1 2.1 0 0 0-.918.919c-.088.172-.155.411-.191.856C5.901 6.358 5.9 6.945 5.9 7.8v8.516c.34-.14.71-.216 1.1-.216h11.1V4.6c0-.6-.1-.7-.7-.7ZM4.1 7.762c0-.808 0-1.469.044-2.006.045-.556.142-1.058.381-1.527A3.9 3.9 0 0 1 6.23 2.525c.468-.239.97-.336 1.526-.381C8.293 2.1 8.954 2.1 9.762 2.1h7.668c.254 0 .496 0 .7.017.223.018.478.06.733.19a1.9 1.9 0 0 1 .83.83c.13.255.172.51.19.733.017.204.017.446.017.7v11.89c0 .504 0 .756-.098.949a.9.9 0 0 1-.393.393c-.193.098-.445.098-.949.098h-.305c-.076.322-.113.51-.131.699a4.088 4.088 0 0 0 0 .802c.018.188.055.378.131.699H19a.9.9 0 1 1 0 1.8H7A2.9 2.9 0 0 1 4.1 19V7.762ZM16.312 20.1a5.358 5.358 0 0 1-.08-.523 5.89 5.89 0 0 1 0-1.154c.017-.171.044-.34.08-.523H7a1.1 1.1 0 0 0 0 2.2h9.312Z",
    fill: "#023F80"
  })));
};

var _path$P;
function _extends$Q() { _extends$Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }
var SvgBotonDePago = function SvgBotonDePago(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$Q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$P || (_path$P = /*#__PURE__*/createElement$2("path", {
    d: "M10.791 14.426a.864.864 0 0 1-1.217 0 4.289 4.289 0 0 1 0-6.06l4.492-4.492a4.289 4.289 0 0 1 6.06 0 4.289 4.289 0 0 1 0 6.06l-1.231 1.231a.856.856 0 0 1-1.212-1.208l1.226-1.231a2.556 2.556 0 0 0 0-3.635 2.556 2.556 0 0 0-3.635 0l-4.483 4.483a2.556 2.556 0 0 0 0 3.635.834.834 0 0 1 0 1.217Zm2.418-4.852a.864.864 0 0 1 1.217 0 4.289 4.289 0 0 1 0 6.06l-4.492 4.492a4.289 4.289 0 0 1-6.06 0 4.289 4.289 0 0 1 0-6.06l1.227-1.227a.856.856 0 0 1 1.212 0 .859.859 0 0 1 0 1.213l-1.222 1.222a2.556 2.556 0 0 0 0 3.635 2.556 2.556 0 0 0 3.635 0l4.483-4.483a2.556 2.556 0 0 0 0-3.635.834.834 0 0 1 0-1.217Z",
    fill: "#023F80"
  })));
};

var _path$Q;
function _extends$R() { _extends$R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }
var SvgBowlSticksOutline = function SvgBowlSticksOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$R({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Q || (_path$Q = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.626 2.732a.9.9 0 0 1 1.273 0l6.317 6.317a.92.92 0 0 1 .047.051h6.47c.238 0 .512-.001.759.065a1.9 1.9 0 0 1 1.343 1.343c.066.247.066.521.065.759v.221c0 1.402 0 2.287-.2 3.039a5.9 5.9 0 0 1-3.8 4.059v.52c0 .358.001.693-.075.99a2.4 2.4 0 0 1-1.728 1.729c-.298.076-.632.076-.99.075H8.893c-.358 0-.693.001-.99-.075a2.4 2.4 0 0 1-1.729-1.728c-.076-.298-.075-.633-.075-.99v-.521a5.9 5.9 0 0 1-3.799-4.059c-.201-.752-.201-1.637-.2-3.04v-.154l-.001-.066c0-.238-.001-.512.065-.759a1.9 1.9 0 0 1 1.343-1.343c.247-.066.521-.066.759-.065H6.479L3.505 6.126a.9.9 0 1 1 1.273-1.273L9.024 9.1h1.697L5.626 4.005a.9.9 0 0 1 0-1.273ZM9.666 17.1h4.667c1.608 0 2.236-.008 2.728-.14a4.1 4.1 0 0 0 2.9-2.899c.131-.492.14-1.12.14-2.728a8.165 8.165 0 0 0-.007-.368.1.1 0 0 0-.059-.059 8.165 8.165 0 0 0-.368-.006H4.333a8.167 8.167 0 0 0-.368.006.1.1 0 0 0-.059.059 8.128 8.128 0 0 0-.006.368c0 1.608.008 2.236.14 2.728a4.1 4.1 0 0 0 2.899 2.9c.492.131 1.12.139 2.728.139ZM7.9 18.9v.12c0 .502.007.584.019.63a.6.6 0 0 0 .432.431c.046.012.127.019.63.019h6.04c.501 0 .583-.007.628-.019a.6.6 0 0 0 .432-.432c.012-.045.02-.127.02-.629v-.12H7.9Z",
    fill: "#023F80"
  })));
};

var _path$R;
function _extends$S() { _extends$S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }
var SvgBoxHeartOutline = function SvgBoxHeartOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$S({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$R || (_path$R = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.073 2A3.4 3.4 0 0 1 14 2.593 3.4 3.4 0 0 1 15.927 2a3.648 3.648 0 0 1 3.653 3.642c0 .398-.041.851-.203 1.335a4.14 4.14 0 0 1-.715 1.285c-.547.684-1.383 1.368-2.424 2.173l-.715.553a2.49 2.49 0 0 1-3.046 0l-.715-.553C10.72 9.63 9.885 8.946 9.338 8.262a4.14 4.14 0 0 1-.715-1.285 4.162 4.162 0 0 1-.203-1.335A3.648 3.648 0 0 1 12.073 2Zm0 2c-.913 0-1.653.735-1.653 1.642 0 1.029.425 1.557 2.565 3.21l.715.553a.49.49 0 0 0 .6 0l.715-.552c2.14-1.654 2.565-2.182 2.565-3.21 0-.908-.74-1.643-1.653-1.643-.552 0-1.054.312-1.525.99l-.134.192a.327.327 0 0 1-.536 0L13.6 4.99c-.472-.678-.974-.99-1.526-.99Zm-5.188 6.383a1 1 0 1 0-.755-1.852l-1.649.672-.12.05c-.55.223-1.049.425-1.432.777-.335.307-.592.69-.75 1.115-.18.488-.18 1.026-.18 1.62l.001.13v5.753c-.001.537-.002 1.038.163 1.496.144.4.38.76.686 1.054.352.336.81.538 1.302.755l.11.049 7.822 3.464.089.039c.47.208.858.38 1.274.45.367.063.74.063 1.107 0 .416-.07.805-.242 1.275-.45l.088-.04 7.823-3.463.11-.05c.492-.216.95-.418 1.302-.754a2.75 2.75 0 0 0 .686-1.054c.165-.458.164-.959.163-1.496v-5.882c.001-.594.002-1.133-.179-1.62a2.867 2.867 0 0 0-.75-1.117c-.384-.351-.883-.553-1.434-.776l-.12-.05-1.648-.67a1 1 0 1 0-.754 1.853l1.603.652-7.61 3.376c-.604.268-.75.325-.886.348a1.33 1.33 0 0 1-.444 0c-.136-.023-.282-.08-.887-.348l-3.735-1.657-3.875-1.72 1.604-.654Zm9.035 5.86L24 12.656v5.87c0 .736-.014.854-.044.938a.75.75 0 0 1-.188.288c-.064.061-.166.122-.84.42l-7.822 3.464-.106.047v-7.063c.263-.086.53-.205.831-.34l.089-.039Zm-3.751.039c.3.133.568.252.83.34v7.062l-.106-.047-7.822-3.464c-.673-.298-.775-.359-.84-.42a.75.75 0 0 1-.186-.288c-.03-.084-.045-.202-.045-.938v-5.869l4.344 1.927 3.736 1.657.089.04Z",
    fill: "#023F80"
  })));
};

var _path$S, _path2$c;
function _extends$T() { _extends$T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }
var SvgBrainOutline = function SvgBrainOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$T({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$S || (_path$S = /*#__PURE__*/createElement$2("path", {
    d: "M7.45 13.323a.9.9 0 0 0-.9 1.558 3.608 3.608 0 0 1 1.71 2.318.9.9 0 1 0 1.756-.398 5.408 5.408 0 0 0-2.565-3.478ZM9.54 6.027a.9.9 0 0 0-1.26.18 1.596 1.596 0 0 1-1.282.643.9.9 0 1 0 0 1.8A3.396 3.396 0 0 0 9.72 7.287a.9.9 0 0 0-.18-1.26ZM15.927 6.873a.9.9 0 0 0-1.782.254 4.404 4.404 0 0 0 3.098 3.59.9.9 0 1 0 .514-1.725 2.604 2.604 0 0 1-1.83-2.12Z",
    fill: "#023F80"
  })), _path2$c || (_path2$c = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1 14c0-.87.252-1.68.687-2.362a5.401 5.401 0 0 1 3.694-7.942 4.895 4.895 0 0 1 5.52-1.862 4.895 4.895 0 0 1 5.519 1.862 5.401 5.401 0 0 1 3.693 7.942c.435.682.687 1.493.687 2.362a4.396 4.396 0 0 1-2.015 3.698 2.9 2.9 0 0 1-3.061 3.196A3.396 3.396 0 0 1 12 21.75a3.396 3.396 0 0 1-4.823-.855 2.9 2.9 0 0 1-3.061-3.196A4.396 4.396 0 0 1 2.1 14Zm5.703-9.03A3.099 3.099 0 0 1 11.1 3.458v16.704a1.601 1.601 0 0 1-2.596-.594.9.9 0 0 0-1.14-.53 1.1 1.1 0 0 1-1.38-1.461.9.9 0 0 0-.484-1.176 2.601 2.601 0 1 1 2.114-4.751.9.9 0 0 0 .772-1.626A4.386 4.386 0 0 0 6.5 9.6c-.87 0-1.68.252-2.363.688A3.6 3.6 0 0 1 7.116 5.42a.9.9 0 0 0 .687-.45ZM12.9 20.162c.287.272.674.438 1.1.438.418 0 .799-.16 1.084-.423A2.893 2.893 0 0 1 14.1 18a.9.9 0 1 1 1.8 0c0 .6.48 1.087 1.076 1.1H17a1.1 1.1 0 0 0 1.016-1.523.9.9 0 0 1 .485-1.176 2.601 2.601 0 0 0 1.457-3.253A5.378 5.378 0 0 1 16.5 14.4a.9.9 0 0 1 0-1.8 3.6 3.6 0 0 0 .385-7.18.9.9 0 0 1-.688-.45A3.099 3.099 0 0 0 12.9 3.458v16.704Z",
    fill: "#023F80"
  })));
};

var _path$T;
function _extends$U() { _extends$U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }
var SvgBriefcaseOutline = function SvgBriefcaseOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$U({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$T || (_path$T = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3h-.032c-.439 0-.817 0-1.13.021a3.07 3.07 0 0 0-.986.207 3 3 0 0 0-1.624 1.624 3.072 3.072 0 0 0-.207.986C10 6.15 10 6.529 10 6.968V7H8.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C2 10.04 2 11.16 2 13.4v4.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C5.04 24 6.16 24 8.4 24h11.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C26 20.96 26 19.84 26 17.6v-4.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C22.96 7 21.84 7 19.6 7H18v-.032c0-.439 0-.817-.021-1.13a3.072 3.072 0 0 0-.207-.986 3 3 0 0 0-1.624-1.624 3.07 3.07 0 0 0-.986-.207C14.85 3 14.471 3 14.032 3H14Zm2 4c0-.48 0-.79-.017-1.026-.015-.228-.042-.315-.06-.357a1 1 0 0 0-.54-.54c-.042-.018-.129-.045-.357-.06A16.908 16.908 0 0 0 14 5c-.48 0-.79 0-1.026.017-.228.015-.315.042-.357.06a1 1 0 0 0-.54.54c-.018.042-.045.129-.06.357C12 6.21 12 6.52 12 7h4ZM9 22V9h10v13h.743H8.257 9Zm13.064-.048c-.295.024-.639.036-1.064.042V9.006c.425.006.769.018 1.064.042.544.044.745.12.844.17a2 2 0 0 1 .874.874c.05.099.126.3.17.844.046.566.048 1.31.048 2.464v4.2c0 1.153-.002 1.898-.048 2.464-.044.544-.12.745-.17.844a2 2 0 0 1-.874.874c-.099.05-.3.126-.844.17ZM7 9.006v12.988a16.032 16.032 0 0 1-1.064-.042c-.544-.044-.745-.12-.844-.17a2 2 0 0 1-.874-.874c-.05-.099-.126-.3-.17-.844C4.002 19.498 4 18.754 4 17.6v-4.2c0-1.153.002-1.898.048-2.464.044-.544.12-.745.17-.844a2 2 0 0 1 .874-.874c.099-.05.3-.126.844-.17.295-.024.64-.036 1.064-.042Z",
    fill: "#023F80"
  })));
};

var _path$U, _path2$d, _path3$6;
function _extends$V() { _extends$V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }
var SvgBroadcastOutline = function SvgBroadcastOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$V({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$U || (_path$U = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.497 4.266a.9.9 0 0 1-.005 1.273A9.07 9.07 0 0 0 2.8 12a9.07 9.07 0 0 0 2.692 6.461.9.9 0 0 1-1.268 1.278A10.87 10.87 0 0 1 1 12a10.87 10.87 0 0 1 3.224-7.739.9.9 0 0 1 1.273.005ZM18.5 4.266a.9.9 0 0 1 1.274-.005A10.87 10.87 0 0 1 22.998 12a10.87 10.87 0 0 1-3.224 7.739.9.9 0 0 1-1.268-1.278A9.07 9.07 0 0 0 21.198 12a9.07 9.07 0 0 0-2.692-6.461.9.9 0 0 1-.005-1.273Z",
    fill: "#023F80"
  })), _path2$d || (_path2$d = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.134 7.243a.9.9 0 0 1 .042 1.272A5.08 5.08 0 0 0 6.8 12c0 1.322.5 2.608 1.298 3.5a.9.9 0 1 1-1.341 1.2C5.655 15.468 5 13.751 5 12a6.88 6.88 0 0 1 1.862-4.715.9.9 0 0 1 1.272-.042ZM15.865 7.243a.9.9 0 0 1 1.272.042A6.879 6.879 0 0 1 18.999 12c0 1.751-.654 3.468-1.757 4.7a.9.9 0 1 1-1.341-1.2c.798-.892 1.298-2.178 1.298-3.5a5.08 5.08 0 0 0-1.376-3.485.9.9 0 0 1 .042-1.272Z",
    fill: "#023F80"
  })), _path3$6 || (_path3$6 = /*#__PURE__*/createElement$2("path", {
    d: "M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
    fill: "#023F80"
  })));
};

var _path$V, _path2$e;
function _extends$W() { _extends$W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }
var SvgBrushOutline = function SvgBrushOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$W({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$V || (_path$V = /*#__PURE__*/createElement$2("path", {
    d: "M20.377 3.467a1.857 1.857 0 0 0-2.558.09l-6.93 6.866a.911.911 0 0 0-.007 1.285.904.904 0 0 0 1.281.008l6.935-6.87c.044-.045.117-.018.07.04l-6.154 7.74a.911.911 0 0 0 .143 1.278.904.904 0 0 0 1.273-.143l6.15-7.735a1.85 1.85 0 0 0-.203-2.56Z",
    fill: "#023F80"
  })), _path2$e || (_path2$e = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.488 12.624c-2.003 0-3.476 1.63-3.56 3.533-.043.938-.454 1.416-.83 1.732-.382.321-.894.553-1.052 1.065-.13.418.033.863.373 1.128.763.593 2.355 1.343 4.654.622 2.399-.752 3.977-2.509 3.977-4.506a3.568 3.568 0 0 0-3.562-3.574Zm-1.75 3.614c.046-1.037.82-1.796 1.75-1.796.967 0 1.75.786 1.75 1.756 0 .947-.789 2.17-2.705 2.77-.866.272-1.549.249-2.057.123.59-.56 1.198-1.442 1.261-2.853Z",
    fill: "#023F80"
  })));
};

var _path$W, _path2$f, _path3$7;
function _extends$X() { _extends$X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }
var SvgBugOutline = function SvgBugOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$X({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$W || (_path$W = /*#__PURE__*/createElement$2("path", {
    d: "M10.5 10.4a.9.9 0 0 1 .9-.9h1.2a.9.9 0 1 1 0 1.8h-1.2a.9.9 0 0 1-.9-.9ZM10.5 15.4a.9.9 0 0 1 .9-.9h1.2a.9.9 0 1 1 0 1.8h-1.2a.9.9 0 0 1-.9-.9Z",
    fill: "#023F80"
  })), _path2$f || (_path2$f = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8a.9.9 0 0 1 .9-.9h2.275a6.937 6.937 0 0 1 1.77-1.883l-1.681-1.68a.9.9 0 0 1 1.272-1.273l2.065 2.064A6.886 6.886 0 0 1 12 3.9c.844 0 1.652.151 2.399.428l2.065-2.064a.9.9 0 0 1 1.272 1.272l-1.68 1.681a6.937 6.937 0 0 1 1.77 1.883H20.1a.9.9 0 1 1 0 1.8h-1.465c.173.604.265 1.241.265 1.9v1.3h3.2a.9.9 0 1 1 0 1.8h-3.2V15c0 .732-.114 1.438-.325 2.1H20.1a.9.9 0 1 1 0 1.8h-2.407a6.893 6.893 0 0 1-5.693 3 6.893 6.893 0 0 1-5.693-3H3.9a.9.9 0 0 1 0-1.8h1.525A6.896 6.896 0 0 1 5.1 15v-1.1H1.9a.9.9 0 0 1 0-1.8h3.2v-1.3c0-.659.092-1.296.265-1.9H3.9A.9.9 0 0 1 3 8Zm3.9 2.8a5.1 5.1 0 1 1 10.2 0V15a5.1 5.1 0 0 1-10.2 0v-4.2Z",
    fill: "#023F80"
  })), _path3$7 || (_path3$7 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 10.4a.9.9 0 0 1 .9-.9h1.2a.9.9 0 1 1 0 1.8h-1.2a.9.9 0 0 1-.9-.9Zm0 5a.9.9 0 0 1 .9-.9h1.2a.9.9 0 1 1 0 1.8h-1.2a.9.9 0 0 1-.9-.9Z",
    fill: "#023F80"
  })));
};

var _path$X;
function _extends$Y() { _extends$Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }
var SvgBuildingOutline = function SvgBuildingOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$Y({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$X || (_path$X = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.162 2c-.528 0-.982 0-1.357.03-.395.033-.788.104-1.167.297a3 3 0 0 0-1.31 1.311c-.194.378-.265.772-.297 1.167-.03.375-.03.83-.03 1.356v5.53a3 3 0 0 0-.868.128c-.376.113-.688.31-.978.532-.336.258-.65.549-.965.832l-1.866 1.68c-.325.292-.61.549-.822.867-.186.28-.324.589-.408.915C4 17.015 4 17.4 4 17.835v4.003c0 .528 0 .982.03 1.357.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.379.193.772.264 1.167.296.375.031.83.031 1.357.031h11.677c.527 0 .982 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.297-1.167.03-.375.03-.83.03-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.31-1.311c-.38-.193-.773-.264-1.168-.296C20.821 2 20.365 2 19.84 2h-5.677Zm-1.38 11.16c-.289-.262-.548-.495-.782-.686V6.2c0-.577 0-.949.024-1.232.022-.272.06-.373.085-.422a1 1 0 0 1 .437-.437c.05-.025.15-.063.422-.085C13.251 4 13.624 4 14.2 4h5.6c.577 0 .949 0 1.232.024.272.022.373.06.422.085a1 1 0 0 1 .437.437c.025.05.063.15.085.422C22 5.25 22 5.623 22 6.2v15.6c0 .577 0 .949-.024 1.232-.022.272-.06.372-.085.422a1 1 0 0 1-.437.437c-.05.025-.15.063-.422.085-.249.02-.567.024-1.032.024v-1c0-.326 0-.49-.057-.617a.65.65 0 0 0-.326-.326C19.49 22 19.327 22 19 22c-.326 0-.49 0-.617.057a.65.65 0 0 0-.326.326C18 22.511 18 22.673 18 23v1h-2v-6.164c0-.436.001-.821-.094-1.191a2.999 2.999 0 0 0-.407-.915c-.212-.319-.498-.575-.823-.867l-1.893-1.704ZM14 17.924V24h-3v-2c0-.326 0-.49-.057-.617a.65.65 0 0 0-.326-.326C10.489 21 10.327 21 10 21c-.326 0-.49 0-.617.057a.65.65 0 0 0-.326.326C9 21.511 9 21.673 9 22v2h-.8c-.576 0-.949 0-1.232-.024-.272-.022-.372-.06-.422-.085a1 1 0 0 1-.437-.437c-.025-.05-.063-.15-.085-.422C6.001 22.75 6 22.377 6 21.8v-3.875c0-.576.007-.69.032-.783a1 1 0 0 1 .135-.305c.054-.08.133-.162.561-.547l1.8-1.62c.39-.351.64-.575.845-.733.195-.15.287-.188.338-.204a1 1 0 0 1 .578 0c.052.016.143.055.338.204.204.158.455.382.845.733l1.8 1.62c.428.385.507.466.561.547.062.093.108.197.136.305.024.094.031.207.031.783Zm.057-11.542C14 6.51 14 6.673 14 7c0 .326 0 .49.057.617a.65.65 0 0 0 .326.326C14.511 8 14.673 8 15 8c.326 0 .49 0 .617-.057a.65.65 0 0 0 .326-.326C16 7.49 16 7.327 16 7c0-.326 0-.49-.057-.617a.65.65 0 0 0-.326-.326C15.49 6 15.327 6 15 6c-.326 0-.49 0-.617.057a.65.65 0 0 0-.326.326ZM18 7c0-.326 0-.49.057-.617a.65.65 0 0 1 .326-.326C18.511 6 18.673 6 19 6c.326 0 .49 0 .617.057a.65.65 0 0 1 .326.326C20 6.51 20 6.673 20 7c0 .326 0 .49-.057.617a.65.65 0 0 1-.326.326C19.49 8 19.327 8 19 8c-.326 0-.49 0-.617-.057a.65.65 0 0 1-.326-.326C18 7.49 18 7.327 18 7Zm.057 3.383C18 10.511 18 10.673 18 11c0 .326 0 .49.057.617a.65.65 0 0 0 .326.326c.128.057.29.057.617.057.326 0 .49 0 .617-.057a.65.65 0 0 0 .326-.326C20 11.489 20 11.327 20 11c0-.326 0-.49-.057-.617a.65.65 0 0 0-.326-.326C19.49 10 19.327 10 19 10c-.326 0-.49 0-.617.057a.65.65 0 0 0-.326.326ZM14 11c0-.326 0-.49.057-.617a.65.65 0 0 1 .326-.326C14.511 10 14.673 10 15 10c.326 0 .49 0 .617.057a.65.65 0 0 1 .326.326c.057.128.057.29.057.617 0 .326 0 .49-.057.617a.65.65 0 0 1-.326.326C15.49 12 15.327 12 15 12c-.326 0-.49 0-.617-.057a.65.65 0 0 1-.326-.326C14 11.489 14 11.327 14 11Zm4.057 3.383C18 14.511 18 14.673 18 15c0 .326 0 .49.057.617a.65.65 0 0 0 .326.326c.128.057.29.057.617.057.326 0 .49 0 .617-.057a.65.65 0 0 0 .326-.326C20 15.489 20 15.327 20 15c0-.326 0-.49-.057-.617a.65.65 0 0 0-.326-.326C19.49 14 19.327 14 19 14c-.326 0-.49 0-.617.057a.65.65 0 0 0-.326.326ZM18 19c0-.326 0-.49.057-.617a.65.65 0 0 1 .326-.326C18.511 18 18.673 18 19 18c.326 0 .49 0 .617.057a.65.65 0 0 1 .326.326c.057.128.057.29.057.617 0 .326 0 .49-.057.617a.65.65 0 0 1-.326.326C19.49 20 19.327 20 19 20c-.326 0-.49 0-.617-.057a.65.65 0 0 1-.326-.326C18 19.489 18 19.327 18 19Zm-9-1c0-.326 0-.49.057-.617a.65.65 0 0 1 .326-.326C9.51 17 9.673 17 10 17c.326 0 .49 0 .617.057a.65.65 0 0 1 .326.326c.057.128.057.29.057.617 0 .326 0 .49-.057.617a.65.65 0 0 1-.326.326C10.489 19 10.327 19 10 19c-.326 0-.49 0-.617-.057a.65.65 0 0 1-.326-.326C9 18.489 9 18.327 9 18Z",
    fill: "#023F80"
  })));
};

var _path$Y;
function _extends$Z() { _extends$Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }
var SvgBusOutline = function SvgBusOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$Z({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Y || (_path$Y = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2h-.044c-1.363 0-2.447 0-3.321.071-.896.074-1.66.227-2.359.583a6 6 0 0 0-2.622 2.622c-.356.7-.51 1.463-.583 2.359C4 8.509 4 9.593 4 10.956V12h-.532a1 1 0 0 0-.967.969l-.001.071v.314c0 .933.67 1.66 1.5 1.826V16.643c0 1.084 0 1.958.058 2.666.06.729.185 1.369.487 1.961A5 5 0 0 0 6 23v1c0 .559 0 .838.079 1.062a1.4 1.4 0 0 0 .859.86C7.162 26 7.44 26 8 26s.838 0 1.062-.079a1.4 1.4 0 0 0 .86-.859C10 24.838 10 24.56 10 24v-.006c.411.006.862.006 1.356.006h5.287c.495 0 .946 0 1.357-.006V24c0 .559 0 .838.079 1.062a1.4 1.4 0 0 0 .859.86C19.162 26 19.44 26 20 26s.838 0 1.062-.079a1.4 1.4 0 0 0 .86-.859C22 24.838 22 24.56 22 24v-1a5 5 0 0 0 1.455-1.73c.302-.592.428-1.232.487-1.961C24 18.6 24 17.727 24 16.643V15.18a1.86 1.86 0 0 0 1.5-1.826v-.385a1 1 0 0 0-.968-.968L24.46 12H24v-1.044c0-1.363 0-2.447-.071-3.321-.074-.896-.227-1.66-.583-2.359a6 6 0 0 0-2.622-2.622c-.7-.356-1.463-.51-2.359-.583C17.491 2 16.407 2 15.044 2H13Zm9 10v-1c0-1.417 0-2.419-.065-3.203-.063-.771-.182-1.243-.371-1.613a4 4 0 0 0-1.748-1.748c-.37-.189-.841-.308-1.613-.371C17.419 4 16.417 4 15 4h-2c-1.417 0-2.419 0-3.203.065-.771.063-1.243.182-1.613.371a4 4 0 0 0-1.748 1.748c-.189.37-.308.842-.371 1.613C6 8.581 6 9.583 6 11v3h16v-2ZM6 16v.6c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051h5.2c1.137 0 1.929 0 2.546-.051.605-.05.953-.142 1.216-.276a3 3 0 0 0 1.311-1.311c.134-.263.226-.611.276-1.216.05-.617.051-1.41.051-2.546V16H6Zm2 3a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm11-1a1 1 0 1 1 0 2h-1a1 1 0 1 1 0-2h1Z",
    fill: "#023F80"
  })));
};

var _path$Z;
function _extends$_() { _extends$_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }
var SvgCactusOutline = function SvgCactusOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$_({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Z || (_path$Z = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.995 2c2.324 0 3.803 1.585 4.072 3.3.175-.091.585-.248.875-.3 2.449-.44 4.935 1.694 3.756 5.204-.763 2.273-2.355 3.81-4.575 4.03a64.793 64.793 0 0 1-.528 5.651l-.013.096c-.049.36-.107.786-.335 1.142a1.917 1.917 0 0 1-.81.704 1.9 1.9 0 0 1-.658.159c-.18.014-.392.014-.609.014h-2.35c-.217 0-.428 0-.609-.014a1.901 1.901 0 0 1-.658-.159c-.329-.15-.615-.399-.81-.704-.228-.356-.286-.783-.335-1.142l-.013-.096a61.93 61.93 0 0 1-.415-3.878C6 16 4.33 14.427 3.7 13.165c-1.906-3.824.421-6.169 2.684-6.225H6.5c.466-.01.915.09 1.316.274.017-.49.037-.946.059-1.366V5.83c.01-.172.016-.301.04-.472C8.158 3.617 9.672 2.001 11.995 2Zm4.2 10.408c1.346-.232 3.013-1.743 3.013-3.838 0-1.157-.735-2.07-2.105-1.767-.585.13-.892.66-.892 1.229v.52c.022 1.169.023 2.47-.016 3.856ZM14.411 8.57v2.095c0 .051.004.102.012.15-.021 2.648-.176 5.72-.61 8.82a6.923 6.923 0 0 1-.075.473.752.752 0 0 1-.014.055.139.139 0 0 1-.025.022.786.786 0 0 1-.06.006 7.282 7.282 0 0 1-.496.009h-2.296c-.254 0-.394 0-.495-.009a.78.78 0 0 1-.06-.006.139.139 0 0 1-.025-.022.657.657 0 0 1-.014-.055 6.859 6.859 0 0 1-.075-.473C9.432 14.321 9.51 9.087 9.672 5.94c.01-.19.013-.245.025-.33.128-.912.918-1.809 2.298-1.809s2.17.897 2.299 1.808c.012.086.015.14.025.33.039.765.073 1.651.092 2.632Zm-6.636 2.92c.014.862.042 1.763.09 2.691-1.143.052-2.926-1.449-3.088-3.365-.084-1.001.411-2.073 1.58-2.073.792 0 1.338.467 1.368 1.072.026.524.046 1.081.046 1.585 0 .03.001.06.004.09Z",
    fill: "#023F80"
  })));
};

var _rect$1, _path$_, _path2$g, _circle, _path3$8;
function _extends$$() { _extends$$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }
var SvgCalendarOutline = function SvgCalendarOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$$({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$1 || (_rect$1 = /*#__PURE__*/createElement$2("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 3.75,
    stroke: "#023F80",
    strokeWidth: 1.8
  })), _path$_ || (_path$_ = /*#__PURE__*/createElement$2("path", {
    d: "M16 2.4v3.2M8 2.4v3.2",
    stroke: "#023F80",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$g || (_path2$g = /*#__PURE__*/createElement$2("path", {
    d: "M4 10h16",
    stroke: "#023F80",
    strokeWidth: 1.8
  })), _circle || (_circle = /*#__PURE__*/createElement$2("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 1,
    stroke: "#023F80"
  })), _path3$8 || (_path3$8 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.5a.9.9 0 0 1 .9.9v.791c.532.067 1.012.187 1.461.416a4.65 4.65 0 0 1 2.032 2.032c.28.55.397 1.144.453 1.825.054.662.054 1.48.054 2.497v4.078c0 1.017 0 1.835-.054 2.497-.056.681-.173 1.276-.453 1.825a4.65 4.65 0 0 1-2.032 2.032c-.55.28-1.144.397-1.825.453-.662.054-1.48.054-2.497.054H9.96c-1.017 0-1.835 0-2.497-.054-.681-.056-1.276-.173-1.825-.453a4.65 4.65 0 0 1-2.032-2.032c-.28-.549-.397-1.144-.453-1.825-.054-.662-.054-1.48-.054-2.497V9.96c0-1.017 0-1.835.054-2.497.056-.681.173-1.276.453-1.825a4.65 4.65 0 0 1 2.032-2.032c.449-.229.929-.35 1.461-.416V2.4a.9.9 0 1 1 1.8 0v.703c.327-.003.68-.003 1.061-.003h4.078c.38 0 .734 0 1.061.003V2.4a.9.9 0 0 1 .9-.9ZM7.1 5.01v.59a.9.9 0 1 0 1.8 0v-.697C9.225 4.9 9.588 4.9 10 4.9h4c.412 0 .775 0 1.1.003V5.6a.9.9 0 1 0 1.8 0v-.59c.278.05.478.116.644.2.536.274.972.71 1.245 1.246.13.253.216.585.263 1.154.033.401.043.88.046 1.49H4.902c.003-.61.013-1.089.046-1.49.047-.57.134-.9.263-1.154a2.85 2.85 0 0 1 1.245-1.245c.166-.085.366-.151.644-.2ZM4.9 10.9h14.2V14c0 1.065 0 1.81-.048 2.39-.047.57-.134.9-.263 1.154a2.85 2.85 0 0 1-1.245 1.245c-.253.13-.585.216-1.154.263-.58.047-1.325.048-2.39.048h-4c-1.065 0-1.81 0-2.39-.048-.57-.047-.9-.134-1.154-.263a2.85 2.85 0 0 1-1.245-1.245c-.13-.253-.216-.585-.263-1.154-.047-.58-.048-1.325-.048-2.39v-3.1ZM15.5 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: "#023F80"
  })));
};

var _path$$;
function _extends$10() { _extends$10 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }
var SvgCameraOutline = function SvgCameraOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$10({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$$ || (_path$$ = /*#__PURE__*/createElement$2("path", {
    d: "M14.252 3c.904 0 1.544.29 2.102.947.009.01.472.59.696.867.077.096.431.186.995.186h.432C20.798 5 22.4 6.664 22.4 9.225v6.414c0 2.31-2.217 4.361-4.786 4.361H6.386C3.817 20 1.6 17.95 1.6 15.639V9.225C1.6 6.665 3.202 5 5.523 5h.432c.564 0 .917-.09.995-.186.224-.277.687-.857.696-.867C8.203 3.291 8.844 3 9.747 3h4.505Zm0 1.8H9.747c-.38 0-.517.062-.73.313.012-.014-.425.533-.668.833-.525.65-1.326.854-2.394.854h-.432C4.212 6.8 3.4 7.643 3.4 9.225v6.414c0 1.283 1.381 2.561 2.986 2.561h11.228c1.605 0 2.986-1.278 2.986-2.561V9.225c0-1.582-.812-2.425-2.123-2.425h-.432c-1.068 0-1.87-.205-2.395-.854-.242-.3-.68-.847-.668-.833-.212-.25-.35-.313-.73-.313ZM12 7.7a4.4 4.4 0 1 1 0 8.8 4.4 4.4 0 0 1 0-8.8Zm0 1.8a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2Z",
    fill: "#023F80"
  })));
};

var _path$10, _path2$h, _path3$9;
function _extends$11() { _extends$11 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }
var SvgCameraSlashOutline = function SvgCameraSlashOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$11({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$10 || (_path$10 = /*#__PURE__*/createElement$2("path", {
    d: "M11.148 5.245c-.246.124-.42.266-.6.505-.333.44-.957.473-1.398.14-.44-.333-.483-.95-.15-1.39.293-.388.64-.735 1.25-1.042.602-.302 1.338-.458 2.26-.458h2.798c1.163 0 2.031.208 2.707.609.68.402 1.056.939 1.32 1.343l.087.133c.229.35.339.52.515.657.143.112.415.258 1.074.258h.489a4.5 4.5 0 0 1 4.5 4.5v9.8c0 .552-.448 1.08-1 1.08s-1-.528-1-1.08v-9.8A2.5 2.5 0 0 0 21.5 8h-.507c-.976-.003-1.71-.232-2.285-.68-.463-.36-.766-.835-.969-1.153l-.077-.12c-.226-.345-.397-.558-.667-.718C16.722 5.167 16.24 5 15.308 5H12.51c-.701 0-1.11.118-1.363.245Z",
    fill: "#023F80"
  })), _path2$h || (_path2$h = /*#__PURE__*/createElement$2("path", {
    d: "M14.432 10.393a1 1 0 0 1 1.27-.623 5.265 5.265 0 0 1 3.275 3.277 1 1 0 1 1-1.893.646 3.265 3.265 0 0 0-2.029-2.03 1 1 0 0 1-.623-1.27Z",
    fill: "#023F80"
  })), _path3$9 || (_path3$9 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.839 7.982a4.166 4.166 0 0 1 1.409-1.32 1.023 1.023 0 0 1-.008-.008l-.947-.947a1 1 0 0 1 1.414-1.414l20 20a1 1 0 0 1-1.414 1.414l-1.188-1.187c-.914.33-1.954.48-3.097.48l-1.155.001h-.004c-2.539.004-8.26.01-8.852-.001-3.268-.003-5.137-1.202-6.102-2.86-.886-1.52-.885-3.247-.885-4.092V18l-.003-1.138c-.004-1.876-.014-5.333 0-5.877.003-1.008.225-2.09.832-3.003Zm6.531 4.283a1 1 0 0 1 .21-.27L5.759 8.173c-.606.192-.995.526-1.253.915-.332.5-.497 1.168-.497 1.912v.031c-.015.449-.006 3.81 0 5.725v.001L4.01 18c0 .873.017 2.11.613 3.134C5.156 22.05 6.283 23 9.008 23h.024c.487.012 6.137.005 8.734.001h.001l1.24-.001c.542 0 1.028-.04 1.464-.115l-3.72-3.72a1.002 1.002 0 0 1-.272.213 5.254 5.254 0 0 1-7.109-7.113Zm1.652 1.172 4.288 4.287a3.254 3.254 0 0 1-4.287-4.287Z",
    fill: "#023F80"
  })));
};

var _path$11;
function _extends$12() { _extends$12 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }
var SvgCancelCircleOutline = function SvgCancelCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$12({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$11 || (_path$11 = /*#__PURE__*/createElement$2("path", {
    d: "M14 2c6.627 0 12 5.373 12 12s-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2Zm0 2C8.477 4 4 8.477 4 14s4.477 10 10 10 10-4.477 10-10S19.523 4 14 4ZM9.793 9.793a1 1 0 0 1 1.414 0L14 12.585l2.793-2.792a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 0 1.414L15.415 14l2.792 2.793a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.414 0L14 15.415l-2.793 2.792a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1 0-1.414L12.585 14l-2.792-2.793a1 1 0 0 1-.083-1.32l.083-.094Z",
    fill: "#023F80"
  })));
};

var _path$12;
function _extends$13() { _extends$13 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }
var SvgCancelOutline = function SvgCancelOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$13({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$12 || (_path$12 = /*#__PURE__*/createElement$2("path", {
    d: "M5.264 5.264a.9.9 0 0 1 1.272 0L12 10.727l5.464-5.463a.9.9 0 0 1 1.272 1.272L13.273 12l5.463 5.464a.9.9 0 1 1-1.272 1.272L12 13.273l-5.464 5.463a.9.9 0 1 1-1.272-1.272L10.727 12 5.264 6.536a.9.9 0 0 1 0-1.272Z",
    fill: "#023F80"
  })));
};

var _path$13;
function _extends$14() { _extends$14 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }
var SvgCancelShieldOutline = function SvgCancelShieldOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$14({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$13 || (_path$13 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.516 1.502c-.35-.05-.682-.05-1.032 0-.31.044-.575.112-1.108.286L5.368 4.123A2 2 0 0 0 4 6.021V15.3c0 4.902 3.007 8.629 8.826 11.102a3 3 0 0 0 2.348 0l.368-.16C21.122 23.767 24 20.094 24 15.3V6.02a2 2 0 0 0-1.367-1.897l-6.82-2.273c-.664-.221-.952-.299-1.297-.348Zm-.75 1.98a1.58 1.58 0 0 1 .467 0l.122.02c.147.03.326.081.668.194L22 6.02V15.3c0 3.926-2.36 6.936-7.262 9.111l-.354.154a.996.996 0 0 1-.775-.003C8.47 22.378 6 19.316 6 15.3V6.02l6.82-2.273c.558-.186.747-.236.947-.265Zm-2.559 6.31a1 1 0 0 0-1.414 1.415L12.586 14l-2.793 2.793a1 1 0 1 0 1.414 1.414L14 15.414l2.793 2.793a1 1 0 0 0 1.414-1.414L15.414 14l2.793-2.793a1 1 0 0 0-1.414-1.414L14 12.586l-2.793-2.793Z",
    fill: "#023F80"
  })));
};

var _path$14;
function _extends$15() { _extends$15 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }
var SvgCanisterOutline = function SvgCanisterOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$15({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$14 || (_path$14 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 17v-6.707l7.538-3.392c1.914-.861 3.226-1.45 4.248-1.802 1.021-.352 1.48-.365 1.737-.32a3 3 0 0 1 1.956 1.265c.147.215.323.64.42 1.715.099 1.077.101 2.515.101 4.614V17c0 1.433-.002 2.388-.061 3.121-.058.71-.161 1.035-.266 1.241a3 3 0 0 1-1.311 1.311c-.206.105-.53.208-1.24.266-.734.06-1.689.061-3.122.061h-4c-1.433 0-2.388-.002-3.121-.061-.71-.058-1.035-.161-1.241-.266a3 3 0 0 1-1.311-1.311c-.105-.206-.208-.53-.266-1.24C6.001 19.387 6 18.432 6 17Zm0-8.9 3-1.35V6.1c0-.297 0-.459-.01-.575l-.001-.014h-.014A8.185 8.185 0 0 0 8.4 5.5H6.6c-.297 0-.459 0-.575.01l-.014.001v.014C6 5.64 6 5.803 6 6.1v2Zm5-2.25 1.717-.773c3.758-1.69 5.637-2.536 7.155-2.268a5 5 0 0 1 3.26 2.109C24 6.19 24 8.252 24 12.373V17c0 2.8 0 4.2-.545 5.27a4.999 4.999 0 0 1-2.185 2.185C20.2 25 18.8 25 16 25h-4c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 21.2 4 19.8 4 17V6.068c0-.252 0-.498.017-.706.019-.229.063-.499.201-.77a2 2 0 0 1 .874-.874c.271-.138.541-.182.77-.201.208-.017.454-.017.706-.017h1.864c.252 0 .498 0 .706.017.229.019.499.063.77.201a2 2 0 0 1 .874.874c.138.271.182.541.201.77.012.147.016.314.017.488Zm-1.707 5.443a1 1 0 0 1 1.414 0l.707.707h5.172l.707-.707a1 1 0 0 1 1.414 1.414l-.707.707v5.172l.707.707a1 1 0 0 1-1.414 1.414L16.586 20h-5.172l-.707.707a1 1 0 0 1-1.414-1.414l.707-.707v-5.172l-.707-.707a1 1 0 0 1 0-1.414ZM12 14v4h4v-4h-4Z",
    fill: "#023F80"
  })));
};

var _path$15, _path2$i, _path3$a, _path4$2, _path5, _path6, _path7;
function _extends$16() { _extends$16 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }
var SvgCarOutline = function SvgCarOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$16({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$15 || (_path$15 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.127 10.782a.9.9 0 0 1 1.091-.655L4 11l.218-.873h.004l.02.006c.02.004.05.012.093.02.084.02.213.047.385.08.343.068.857.159 1.527.25 1.339.183 3.298.367 5.753.367s4.414-.184 5.753-.367c.67-.091 1.184-.182 1.527-.25a14.633 14.633 0 0 0 .478-.1l.02-.005.004-.001a.9.9 0 0 1 .436 1.746L20 11l.218.873-.005.001-.009.003-.032.007a16.63 16.63 0 0 1-.547.116c-.375.074-.923.17-1.628.267A44.677 44.677 0 0 1 12 12.65c-2.545 0-4.586-.19-5.997-.383A28.799 28.799 0 0 1 4.374 12a16.654 16.654 0 0 1-.547-.116l-.031-.007-.01-.003h-.003L4 11l-.217.873a.9.9 0 0 1-.656-1.091Zm1.091-.655Z",
    fill: "#023F80"
  })), _path2$i || (_path2$i = /*#__PURE__*/createElement$2("path", {
    d: "M21 16.5a1.5 1.5 0 0 1-1.5 1.5H19v1.2c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C21 19.62 21 19.48 21 19.2v-2.7Z",
    fill: "#023F80"
  })), _path3$a || (_path3$a = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1 19.1h-.2v-.233c.068-.012.134-.026.2-.043v.276Zm1.8-2.6v2.722c0 .12 0 .259-.01.38-.011.139-.04.332-.143.534a1.4 1.4 0 0 1-.611.611 1.409 1.409 0 0 1-.534.143c-.121.01-.26.01-.38.01H19.778c-.12 0-.259 0-.38-.01a1.409 1.409 0 0 1-.534-.143 1.4 1.4 0 0 1-.611-.611 1.409 1.409 0 0 1-.143-.534c-.01-.121-.01-.26-.01-.38V17.1h1.4a.6.6 0 0 0 .6-.6h1.8Z",
    fill: "#023F80"
  })), _path4$2 || (_path4$2 = /*#__PURE__*/createElement$2("path", {
    d: "M3 16.5A1.5 1.5 0 0 0 4.5 18H5v1.2c0 .28 0 .42-.054.527a.5.5 0 0 1-.219.218C4.62 20 4.48 20 4.2 20h-.4c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.219-.218C3 19.62 3 19.48 3 19.2v-2.7Z",
    fill: "#023F80"
  })), _path5 || (_path5 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9 19.1h.2v-.233a2.361 2.361 0 0 1-.2-.043v.276Zm-1.8-2.6v2.722c0 .12 0 .259.01.38.011.139.04.332.143.534a1.4 1.4 0 0 0 .611.611c.202.103.395.132.534.143.121.01.26.01.38.01H4.222c.12 0 .259 0 .38-.01.139-.011.332-.04.534-.143a1.4 1.4 0 0 0 .611-.611c.103-.202.132-.395.143-.534.01-.121.01-.26.01-.38V17.1H4.5a.6.6 0 0 1-.6-.6H2.1Z",
    fill: "#023F80"
  })), _path6 || (_path6 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.662 4.1h4.676c.863 0 1.579 0 2.167.06.619.065 1.173.202 1.691.522.519.321.89.755 1.223 1.28.318.499.638 1.14 1.024 1.911l1.457 2.914V18.9H2.1v-8.112l1.457-2.915c.386-.772.706-1.412 1.024-1.91.334-.526.704-.96 1.223-1.28.518-.321 1.072-.458 1.691-.522C8.083 4.1 8.8 4.1 9.662 4.1ZM7.68 5.951c-.464.048-.724.135-.93.263-.206.127-.4.32-.65.714-.262.412-.542.968-.953 1.791L3.9 11.213V17.1h16.2v-5.888L18.853 8.72c-.411-.823-.69-1.38-.952-1.79-.25-.394-.445-.588-.651-.715-.206-.128-.466-.215-.93-.263-.485-.05-1.108-.051-2.028-.051H9.708c-.92 0-1.543.001-2.028.051Z",
    fill: "#023F80"
  })), _path7 || (_path7 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 10.614v-.229c0-.489.396-.885.885-.885H4V11l-.363.725a.807.807 0 0 1-.422.389A1.615 1.615 0 0 1 1 10.614Zm22 0v-.229a.885.885 0 0 0-.885-.885H20V11l.363.725a.807.807 0 0 0 .422.389 1.615 1.615 0 0 0 2.215-1.5ZM5.107 14.388a.9.9 0 0 1 1.005-.781l2 .25a.9.9 0 0 1-.224 1.786l-2-.25a.9.9 0 0 1-.781-1.005ZM18.893 14.388a.9.9 0 0 0-1.005-.781l-2 .25a.9.9 0 0 0 .224 1.786l2-.25a.9.9 0 0 0 .781-1.005Z",
    fill: "#023F80"
  })));
};

var _path$16, _path2$j;
function _extends$17() { _extends$17 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }
var SvgCards2Outline = function SvgCards2Outline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$17({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$16 || (_path$16 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.008 6.498a1.013 1.013 0 0 1-.81 1.177c-1.88.34-2.576.526-3.038.878-.507.387-.88.926-1.066 1.54-.087.287-.117.65-.06 1.264.057.625.194 1.417.392 2.552l.905 5.194c.198 1.135.336 1.926.493 2.533.155.596.306.927.484 1.167.383.513.915.89 1.523 1.078.274.085.62.117 1.195.066.585-.051 1.325-.179 2.38-.367a1.003 1.003 0 0 1 1.16.823 1.013 1.013 0 0 1-.813 1.175c-1.028.183-1.862.33-2.554.39-.703.062-1.336.044-1.954-.147a5.012 5.012 0 0 1-2.538-1.798c-.4-.538-.636-1.155-.822-1.873-.18-.697-.332-1.57-.52-2.652l-.92-5.28c-.19-1.082-.341-1.955-.408-2.672-.068-.739-.055-1.4.14-2.045a5.071 5.071 0 0 1 1.776-2.568c.924-.704 2.163-.943 3.893-1.255a1.003 1.003 0 0 1 1.162.82Z",
    fill: "#023F80"
  })), _path2$j || (_path2$j = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.292 2.45.282.05c1.07.19 1.933.345 2.621.527.71.188 1.32.426 1.852.832a5.071 5.071 0 0 1 1.776 2.567c.195.645.208 1.307.14 2.045-.067.718-.219 1.59-.407 2.673l-.92 5.28c-.189 1.082-.341 1.955-.521 2.652-.186.717-.421 1.335-.822 1.873a5.012 5.012 0 0 1-2.538 1.798c-.637.197-1.29.21-2.02.14-.71-.066-1.572-.22-2.642-.41l-.282-.051c-1.07-.191-1.932-.345-2.62-.527-.71-.188-1.32-.427-1.852-.832a5.071 5.071 0 0 1-1.776-2.568c-.195-.644-.208-1.306-.14-2.044.066-.718.218-1.59.407-2.673l.92-5.28c.188-1.082.34-1.955.521-2.652.186-.718.421-1.335.822-1.873a5.012 5.012 0 0 1 2.537-1.798c.637-.197 1.291-.21 2.02-.141.71.067 1.573.22 2.642.412Zm-2.827 1.608c-.606-.058-.965-.027-1.249.06a3.007 3.007 0 0 0-1.522 1.08c-.178.239-.33.57-.484 1.166-.157.607-.296 1.398-.493 2.533l-.905 5.194c-.198 1.135-.335 1.927-.393 2.552-.056.613-.026.977.06 1.263a3.044 3.044 0 0 0 1.066 1.54c.237.181.564.334 1.153.49.6.16 1.382.3 2.504.5l.197.035c1.122.2 1.904.339 2.522.397.606.058.965.027 1.248-.061a3.007 3.007 0 0 0 1.523-1.079c.178-.239.33-.57.483-1.166.158-.607.296-1.398.494-2.534l.905-5.193c.198-1.136.335-1.927.393-2.552.056-.613.026-.977-.06-1.263a3.043 3.043 0 0 0-1.067-1.54c-.236-.181-.564-.335-1.152-.49-.6-.16-1.382-.3-2.504-.5l-.198-.035c-1.121-.2-1.904-.34-2.521-.397Z",
    fill: "#023F80"
  })));
};

var _path$17;
function _extends$18() { _extends$18 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }
var SvgCashOutOutline = function SvgCashOutOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$18({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$17 || (_path$17 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9a5 5 0 0 1 5-5h14a5 5 0 0 1 1 9.9V19.838c0 .528 0 .982-.03 1.357-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.356.031h-7.677c-.528 0-.982 0-1.357-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167A17.9 17.9 0 0 1 6 19.839V13.9A5.002 5.002 0 0 1 2 9Zm4 3.086c0-.495.001-.925.03-1.281.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C9.18 8 9.635 8 10.161 8h7.677c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.03.36.031.792.031 1.292v-.268A3.001 3.001 0 0 0 21 6H7a3 3 0 0 0-1 5.83v.256Zm7 1V10h-2.8c-.577 0-.949 0-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C8 11.25 8 11.623 8 12.2V18h12v-5.8c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085C18.75 10 18.377 10 17.8 10H15v3.086l.793-.793a1 1 0 0 1 1.414 1.414l-2.5 2.5a1 1 0 0 1-1.414 0l-2.5-2.5a1 1 0 0 1 1.414-1.414l.793.793ZM8 20c0 .465.004.783.024 1.032.022.272.06.372.085.422a1 1 0 0 0 .437.437c.05.025.15.063.422.085C9.25 22 9.623 22 10.2 22h7.6c.577 0 .949 0 1.232-.024.272-.022.372-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.063-.15.085-.422.02-.249.024-.567.024-1.032H8Z",
    fill: "#023F80"
  })));
};

var _path$18;
function _extends$19() { _extends$19 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }
var SvgChainOutline = function SvgChainOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$19({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$18 || (_path$18 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.49 4.293a4.402 4.402 0 0 1 6.225 6.225l-1.072 1.072a.9.9 0 0 1-1.273-1.274l1.071-1.071a2.601 2.601 0 1 0-3.678-3.679l-3.537 3.537a2.601 2.601 0 0 0 0 3.679.9.9 0 1 1-1.274 1.273 4.402 4.402 0 0 1 0-6.225l3.537-3.537Zm-.708 5.66a.9.9 0 0 1 1.273 0 4.402 4.402 0 0 1 0 6.224l-3.537 3.538a4.402 4.402 0 0 1-6.225-6.226l1.122-1.122a.9.9 0 0 1 1.273 1.274l-1.122 1.122a2.601 2.601 0 1 0 3.679 3.678l3.537-3.537a2.601 2.601 0 0 0 0-3.678.9.9 0 0 1 0-1.274Z",
    fill: "#023F80"
  })));
};

var _path$19;
function _extends$1a() { _extends$1a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }
var SvgCheckCircleDeviceOutline = function SvgCheckCircleDeviceOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1a({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$19 || (_path$19 = /*#__PURE__*/createElement$2("path", {
    d: "M18 10a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm-5.128-8c1.777 0 2.648.168 3.553.652a4.634 4.634 0 0 1 1.922 1.923c.37.69.546 1.335.617 2.361a1 1 0 1 1-1.995.138c-.052-.752-.154-1.123-.385-1.556a2.635 2.635 0 0 0-1.102-1.102c-.508-.272-1.003-.388-2.125-.411L12.873 4l-3.006.001c-1.29.016-1.803.123-2.35.415a2.635 2.635 0 0 0-1.1 1.102c-.273.508-.389 1.003-.412 2.126L6 8.128l.001 12.005c.016 1.29.123 1.803.415 2.35.255.477.624.845 1.102 1.1.503.27.958.376 2.018.409a1 1 0 1 1-.061 1.999c-1.35-.042-2.104-.218-2.9-.643a4.634 4.634 0 0 1-1.923-1.923c-.43-.806-.61-1.58-.645-2.99l-.005-.29L4 8.128c0-1.777.168-2.648.652-3.553a4.635 4.635 0 0 1 1.923-1.923c.806-.43 1.58-.61 2.99-.645l.29-.005L12.872 2ZM18 12a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm3.536 3.564a.9.9 0 0 1 .08 1.18l-.08.092-4 4a.9.9 0 0 1-1.18.08l-.092-.08-1.6-1.6a.9.9 0 0 1 1.18-1.353l.092.08.964.964 3.364-3.363a.9.9 0 0 1 1.272 0Z",
    fill: "#023F80"
  })));
};

var _path$1a, _path2$k;
function _extends$1b() { _extends$1b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }
var SvgCheckCircleOutline = function SvgCheckCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1b({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1a || (_path$1a = /*#__PURE__*/createElement$2("path", {
    d: "M14.964 9.264a.9.9 0 0 1 1.272 1.272l-4.6 4.6a.9.9 0 0 1-1.272 0l-2.6-2.6a.9.9 0 1 1 1.272-1.272L11 13.227l3.964-3.963Z",
    fill: "#023F80"
  })), _path2$k || (_path2$k = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.1c5.467 0 9.9 4.433 9.9 9.9 0 5.467-4.433 9.9-9.9 9.9-5.467 0-9.9-4.433-9.9-9.9 0-5.467 4.433-9.9 9.9-9.9Zm0 1.8A8.1 8.1 0 0 0 3.9 12a8.1 8.1 0 0 0 8.1 8.1 8.1 8.1 0 0 0 8.1-8.1A8.1 8.1 0 0 0 12 3.9Z",
    fill: "#023F80"
  })));
};

var _path$1b;
function _extends$1c() { _extends$1c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }
var SvgCheckShieldDeviceOutline = function SvgCheckShieldDeviceOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1c({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1b || (_path$1b = /*#__PURE__*/createElement$2("path", {
    d: "m18.108 8.076.218.018c.206.027.375.066.762.177l5.752 1.643A1.6 1.6 0 0 1 26 11.453V17.5c0 3.48-2.611 6.279-7.606 8.42l-.394.168-.394-.169C12.611 23.78 10 20.981 10 17.5v-6.047a1.6 1.6 0 0 1 1.16-1.539l5.905-1.686c.283-.079.432-.111.61-.134.22-.028.43-.028.65 0l-.217-.018ZM12.872 2c1.777 0 2.648.168 3.553.652a4.632 4.632 0 0 1 1.887 1.858 1 1 0 0 1-1.686 1.069l-.063-.1a2.633 2.633 0 0 0-1.08-1.063c-.51-.272-1.004-.388-2.126-.411L12.873 4l-3.006.001c-1.29.016-1.803.123-2.35.415a2.635 2.635 0 0 0-1.1 1.102c-.273.508-.389 1.003-.412 2.126L6 8.128l.001 12.005c.016 1.29.123 1.803.415 2.35.255.477.624.845 1.102 1.1.508.273 1.003.389 2.126.412l.484.005h.369a1 1 0 0 1 .117 1.993l-.117.007h-.37c-1.776 0-2.647-.168-3.552-.652a4.634 4.634 0 0 1-1.923-1.923c-.43-.806-.61-1.58-.645-2.99l-.005-.29L4 8.128c0-1.777.168-2.648.652-3.553a4.635 4.635 0 0 1 1.923-1.923c.806-.43 1.58-.61 2.99-.645l.29-.005L12.872 2ZM18 10.073l-.073.005c-.059.008-.12.02-.258.058L12 11.754V17.5c0 2.38 1.833 4.476 5.692 6.268l.308.14.308-.14c3.745-1.74 5.582-3.765 5.687-6.059L24 17.5v-5.746l-5.713-1.63a1.897 1.897 0 0 0-.178-.04l-.036-.006a.54.54 0 0 0-.146 0l.073-.005Zm3.536 4.19a.9.9 0 0 1 .08 1.181l-.08.092-4 4a.9.9 0 0 1-1.18.08l-.092-.08-1.6-1.6a.9.9 0 0 1 1.18-1.353l.092.08.964.964 3.364-3.363a.9.9 0 0 1 1.272 0Z",
    fill: "#023F80"
  })));
};

var _path$1c, _path2$l;
function _extends$1d() { _extends$1d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }
var SvgCheckShieldOutline = function SvgCheckShieldOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1d({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1c || (_path$1c = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.697 2.152a.9.9 0 0 1 .606 0l7 2.5a.9.9 0 0 1 .597.848V13c0 2.85-1.568 5.077-3.243 6.55a11.885 11.885 0 0 1-2.531 1.71c-.758.374-1.537.64-2.126.64-.59 0-1.368-.265-2.125-.64a11.882 11.882 0 0 1-2.532-1.71C5.668 18.078 4.1 15.85 4.1 13V5.5a.9.9 0 0 1 .597-.848l7-2.5ZM5.9 6.134V13c0 2.15 1.182 3.923 2.632 5.2.72.633 1.482 1.12 2.14 1.446.696.345 1.167.454 1.328.454.16 0 .632-.11 1.328-.454.658-.325 1.42-.813 2.14-1.447C16.918 16.923 18.1 15.15 18.1 13V6.134L12 3.956 5.9 6.134Z",
    fill: "#023F80"
  })), _path2$l || (_path2$l = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.137 9.364a.9.9 0 0 1 0 1.272l-4.5 4.5a.9.9 0 0 1-1.273 0l-2.5-2.5a.9.9 0 0 1 1.272-1.272L11 13.227l3.864-3.863a.9.9 0 0 1 1.273 0Z",
    fill: "#023F80"
  })));
};

var _path$1d;
function _extends$1e() { _extends$1e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }
var SvgCheckSquareOutline = function SvgCheckSquareOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1e({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1d || (_path$1d = /*#__PURE__*/createElement$2("path", {
    d: "M14.59 2.1c2.168 0 3.202.2 4.277.774a5.443 5.443 0 0 1 2.259 2.26c.574 1.074.774 2.108.774 4.276v5.18c0 2.168-.2 3.202-.774 4.276a5.443 5.443 0 0 1-2.26 2.26c-1.074.574-2.108.774-4.276.774H9.41c-2.168 0-3.202-.2-4.276-.774a5.443 5.443 0 0 1-2.26-2.26C2.3 17.792 2.1 16.758 2.1 14.59V9.41c0-2.168.2-3.202.774-4.277a5.443 5.443 0 0 1 2.26-2.259C6.208 2.3 7.242 2.1 9.41 2.1h5.18Zm0 1.8H9.41c-1.896 0-2.65.145-3.428.561a3.644 3.644 0 0 0-1.52 1.521C4.046 6.76 3.9 7.514 3.9 9.41v5.18c0 1.896.146 2.65.562 3.428a3.644 3.644 0 0 0 1.52 1.52c.778.416 1.532.562 3.428.562h5.18c1.897 0 2.65-.146 3.428-.562a3.644 3.644 0 0 0 1.52-1.52c.417-.778.562-1.532.562-3.428V9.41c0-1.896-.145-2.65-.561-3.428a3.644 3.644 0 0 0-1.521-1.52c-.778-.417-1.531-.562-3.428-.562Zm.374 5.364a.9.9 0 0 1 1.272 1.272l-4.6 4.6a.9.9 0 0 1-1.272 0l-2.6-2.6a.9.9 0 0 1 1.272-1.272L11 13.227l3.964-3.963Z",
    fill: "#023F80"
  })));
};

var _path$1e;
function _extends$1f() { _extends$1f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }
var SvgChecksOutline = function SvgChecksOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1f({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1e || (_path$1e = /*#__PURE__*/createElement$2("path", {
    d: "M18.707 8.293a1 1 0 0 1 .083 1.32l-.083.094-10 10a1 1 0 0 1-1.32.083l-.094-.083-4-4a1 1 0 0 1 1.32-1.497l.094.083L8 17.585l9.293-9.292a1 1 0 0 1 1.414 0Zm6 0a1 1 0 0 1 .083 1.32l-.083.094-10 10a1 1 0 0 1-1.497-1.32l.083-.094 10-10a1 1 0 0 1 1.414 0Z",
    fill: "#023F80"
  })));
};

var _path$1f;
function _extends$1g() { _extends$1g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }
var SvgChefHatOutline = function SvgChefHatOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1g({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1f || (_path$1f = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8a4 4 0 0 1 8 0 1 1 0 1 0 2 0c0-.34-.028-.674-.083-1C22.127 6.957 24 8.789 24 11a4 4 0 0 1-2.328 3.635c-.4.139-.682.528-.672.972V18H7v-2.393a1.007 1.007 0 0 0-.672-.972A4 4 0 0 1 4 11c0-2.212 1.872-4.044 4.083-4A6.04 6.04 0 0 0 8 8a1 1 0 0 0 2 0ZM8.774 5.05A5.998 5.998 0 0 1 14 2a5.998 5.998 0 0 1 5.226 3.05A6 6 0 0 1 23 16.197v3.843c0 .666 0 1.226-.037 1.684-.04.478-.124.933-.345 1.365a3.5 3.5 0 0 1-1.529 1.53c-.432.22-.887.305-1.366.344-.457.037-1.017.037-1.683.037H9.96c-.666 0-1.226 0-1.683-.037-.48-.04-.934-.124-1.366-.344a3.5 3.5 0 0 1-1.53-1.53c-.22-.432-.305-.887-.344-1.365C5 21.266 5 20.706 5 20.04v-3.843A6 6 0 0 1 8.774 5.05ZM7 20h14c0 .717 0 1.194-.03 1.56-.03.356-.081.518-.133.621a1.5 1.5 0 0 1-.656.656c-.103.052-.265.103-.62.132C19.194 23 18.717 23 18 23h-8c-.717 0-1.194 0-1.56-.03-.356-.03-.518-.081-.621-.133a1.5 1.5 0 0 1-.656-.656c-.052-.103-.103-.265-.132-.62C7 21.194 7 20.717 7 20Z",
    fill: "#023F80"
  })));
};

var _path$1g;
function _extends$1h() { _extends$1h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }
var SvgChevronDownOutline = function SvgChevronDownOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1h({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1g || (_path$1g = /*#__PURE__*/createElement$2("path", {
    d: "M7.65 11.24a1 1 0 1 0-1.3 1.52l7 6a1 1 0 0 0 1.3 0l7-6a1 1 0 0 0-1.3-1.52L14 16.684 7.65 11.24Z",
    fill: "#023F80"
  })));
};

var _path$1h;
function _extends$1i() { _extends$1i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }
var SvgChevronDownSmall = function SvgChevronDownSmall(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1i({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1h || (_path$1h = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.736 9.264a.9.9 0 0 0-1.272 0L12 13.727 7.536 9.264a.9.9 0 0 0-1.272 1.272l5.1 5.1a.9.9 0 0 0 1.272 0l5.1-5.1a.9.9 0 0 0 0-1.272Z",
    fill: "#023F80"
  })));
};

var _path$1i;
function _extends$1j() { _extends$1j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }
var SvgChevronLeftOutline = function SvgChevronLeftOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1j({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1i || (_path$1i = /*#__PURE__*/createElement$2("path", {
    d: "m8.414 12 7.293 7.293a1 1 0 0 1-1.414 1.414l-8-8a1 1 0 0 1 0-1.414l8-8a1 1 0 1 1 1.414 1.414L8.414 12Z",
    fill: "#023F80"
  })));
};

var _path$1j;
function _extends$1k() { _extends$1k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }
var SvgChevronLeftSmall = function SvgChevronLeftSmall(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1k({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1j || (_path$1j = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.736 17.736a.9.9 0 0 0 0-1.272L10.273 12l4.463-4.464a.9.9 0 1 0-1.272-1.272l-5.1 5.1a.9.9 0 0 0 0 1.272l5.1 5.1a.9.9 0 0 0 1.272 0Z",
    fill: "#023F80"
  })));
};

var _path$1k;
function _extends$1l() { _extends$1l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }
var SvgChevronRightCircleOutline = function SvgChevronRightCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1l({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1k || (_path$1k = /*#__PURE__*/createElement$2("path", {
    d: "M14 2c6.627 0 12 5.373 12 12s-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2Zm0 2C8.477 4 4 8.477 4 14s4.477 10 10 10 10-4.477 10-10S19.523 4 14 4Zm-1.957 5.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L15.336 14l-3.293-3.293a1 1 0 0 1 0-1.414Z",
    fill: "#023F80"
  })));
};

var _path$1l;
function _extends$1m() { _extends$1m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }
var SvgChevronRightOutline = function SvgChevronRightOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1m({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1l || (_path$1l = /*#__PURE__*/createElement$2("path", {
    d: "M15.586 12 8.293 4.707a1 1 0 0 1 1.414-1.414l8 8a1 1 0 0 1 0 1.414l-8 8a1 1 0 0 1-1.414-1.414L15.586 12Z",
    fill: "#023F80"
  })));
};

var _path$1m;
function _extends$1n() { _extends$1n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }
var SvgChevronRightSmall = function SvgChevronRightSmall(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1n({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1m || (_path$1m = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.264 6.264a.9.9 0 0 0 0 1.272L13.727 12l-4.463 4.464a.9.9 0 0 0 1.272 1.272l5.1-5.1a.9.9 0 0 0 0-1.272l-5.1-5.1a.9.9 0 0 0-1.272 0Z",
    fill: "#023F80"
  })));
};

var _path$1n;
function _extends$1o() { _extends$1o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }
var SvgChevronUpOutline = function SvgChevronUpOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1o({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1n || (_path$1n = /*#__PURE__*/createElement$2("path", {
    d: "M20.35 16.76a1 1 0 1 0 1.3-1.52l-7-6a1 1 0 0 0-1.3 0l-7 6a1 1 0 0 0 1.3 1.52L14 11.316l6.35 5.442Z",
    fill: "#023F80"
  })));
};

var _path$1o;
function _extends$1p() { _extends$1p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }
var SvgChevronUpSmall = function SvgChevronUpSmall(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1p({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1o || (_path$1o = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.736 14.736a.9.9 0 0 1-1.272 0L12 10.273l-4.464 4.463a.9.9 0 0 1-1.272-1.272l5.1-5.1a.9.9 0 0 1 1.272 0l5.1 5.1a.9.9 0 0 1 0 1.272Z",
    fill: "#023F80"
  })));
};

var _path$1p, _path2$m;
function _extends$1q() { _extends$1q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }
var SvgChevrons2LeftOutline = function SvgChevrons2LeftOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1q({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1p || (_path$1p = /*#__PURE__*/createElement$2("path", {
    d: "m8.414 14 5.793 5.793a1 1 0 0 1-1.414 1.414l-6.5-6.5a1 1 0 0 1 0-1.414l6.5-6.5a1 1 0 1 1 1.414 1.414L8.414 14Z",
    fill: "#023F80"
  })), _path2$m || (_path2$m = /*#__PURE__*/createElement$2("path", {
    d: "m16.414 14 5.793 5.793a1 1 0 0 1-1.414 1.414l-6.5-6.5a1 1 0 0 1 0-1.414l6.5-6.5a1 1 0 1 1 1.414 1.414L16.414 14Z",
    fill: "#023F80"
  })));
};

var _path$1q, _path2$n;
function _extends$1r() { _extends$1r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }
var SvgChevrons2RightOutline = function SvgChevrons2RightOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1r({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1q || (_path$1q = /*#__PURE__*/createElement$2("path", {
    d: "m20.086 14-5.793-5.793a1 1 0 0 1 1.414-1.414l6.5 6.5a1 1 0 0 1 0 1.414l-6.5 6.5a1 1 0 0 1-1.414-1.414L20.086 14Z",
    fill: "#023F80"
  })), _path2$n || (_path2$n = /*#__PURE__*/createElement$2("path", {
    d: "M12.086 14 6.293 8.207a1 1 0 0 1 1.414-1.414l6.5 6.5a1 1 0 0 1 0 1.414l-6.5 6.5a1 1 0 0 1-1.414-1.414L12.086 14Z",
    fill: "#023F80"
  })));
};

var _path$1r;
function _extends$1s() { _extends$1s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }
var SvgClearDataOutline = function SvgClearDataOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1s({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1r || (_path$1r = /*#__PURE__*/createElement$2("path", {
    d: "M25.207 2.793a1 1 0 0 1 0 1.414l-2.191 2.191a5 5 0 0 1-.636 6.292l-.374.374c.348 4.356-1.192 8.26-4.575 11.643a1 1 0 0 1-.97.258c-2.775-.757-5.513-2.5-8.22-5.206-2.707-2.707-4.449-5.445-5.206-8.22a1 1 0 0 1 .258-.97c3.383-3.383 7.286-4.922 11.642-4.575l.375-.374a5 5 0 0 1 6.29-.636l2.193-2.191a1 1 0 0 1 1.414 0Zm-5.2 10.352-5.152-5.152-.371-.026c-3.462-.2-6.56.99-9.352 3.604.735 2.228 2.237 4.488 4.523 6.774 2.286 2.286 4.546 3.788 6.774 4.523 2.707-2.89 3.887-6.111 3.577-9.723Zm.959-6.11a3 3 0 0 0-4.242 0l4.242 4.24a3 3 0 0 0 0-4.24Z",
    fill: "#023F80"
  })));
};

var _path$1s, _path2$o;
function _extends$1t() { _extends$1t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }
var SvgClipOutline = function SvgClipOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1t({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1s || (_path$1s = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.286 22.329A7.329 7.329 0 0 1 2.957 15h1.8a5.529 5.529 0 0 0 5.529 5.529h.428a.9.9 0 0 1 0 1.8h-.428ZM13.671 9.429a.9.9 0 0 1 .9-.9c1.888 0 3.546.996 4.452 2.49a.9.9 0 1 1-1.538.934 3.398 3.398 0 0 0-2.914-1.624.9.9 0 0 1-.9-.9ZM7.39 3.9c-.68 0-1.215.583-1.156 1.262l.537 6.175L5 11.73 4.44 5.317a2.961 2.961 0 0 1 5.822-.974l.896 3.582a.9.9 0 0 1-1.746.436L8.517 4.78A1.161 1.161 0 0 0 7.391 3.9Z",
    fill: "#023F80"
  })), _path2$o || (_path2$o = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.395 3.47a1.153 1.153 0 0 0-1.377.884l-.852 3.977a.9.9 0 1 1-1.76-.377l.852-3.977a2.953 2.953 0 0 1 5.814 1.008l-.608 4.562a.9.9 0 1 1-1.785-.237l.609-4.562a1.153 1.153 0 0 0-.893-1.278ZM9.792 12.64a1.165 1.165 0 0 0-1.215-.91l-.811.054A3.223 3.223 0 0 0 4.757 15h-1.8a5.023 5.023 0 0 1 4.689-5.012l.811-.054a2.965 2.965 0 0 1 .685 5.883l-.423.07a.9.9 0 1 1-.296-1.775l.423-.07c.659-.11 1.09-.75.946-1.402ZM19.69 17.535l-4.295-2.498v4.997l4.296-2.499Zm1.423 1.487c1.138-.662 1.138-2.311 0-2.973l-5.147-2.994c-1.141-.664-2.57.163-2.57 1.487v5.987c0 1.324 1.429 2.15 2.57 1.486l5.147-2.993Z",
    fill: "#023F80"
  })));
};

var _path$1t, _path2$p;
function _extends$1u() { _extends$1u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }
var SvgClockOutline = function SvgClockOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1u({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1t || (_path$1t = /*#__PURE__*/createElement$2("path", {
    d: "M12.4 8a.9.9 0 0 0-1.8 0v4.5a.9.9 0 0 0 .584.843l4 1.5a.9.9 0 0 0 .632-1.686l-3.416-1.28V8Z",
    fill: "#023F80"
  })), _path2$p || (_path2$p = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.1c-5.468 0-9.9 4.432-9.9 9.9s4.432 9.9 9.9 9.9 9.9-4.432 9.9-9.9-4.432-9.9-9.9-9.9ZM3.9 12a8.1 8.1 0 1 1 16.2 0 8.1 8.1 0 0 1-16.2 0Z",
    fill: "#023F80"
  })));
};

var _path$1u;
function _extends$1v() { _extends$1v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1v.apply(this, arguments); }
var SvgClockRectangleStackOutline = function SvgClockRectangleStackOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1v({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1u || (_path$1u = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 11a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v9a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4v-9ZM7 9h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2Zm12.994-4.15A2 2 0 0 0 18 3h-8a2 2 0 0 0-2 2h12l-.006-.15Zm-6.594 5.9c.635 0 1.15.515 1.15 1.15v3.703l3.254 1.22a1.15 1.15 0 0 1-.808 2.154l-4-1.5a1.15 1.15 0 0 1-.746-1.077v-4.5c0-.635.515-1.15 1.15-1.15Z",
    fill: "#023F80"
  })));
};

var _path$1v;
function _extends$1w() { _extends$1w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1w.apply(this, arguments); }
var SvgCloudOutline = function SvgCloudOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1w({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1v || (_path$1v = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 6a5.5 5.5 0 0 0-5.449 6.254 1 1 0 0 1-.602 1.058A4.001 4.001 0 0 0 8 21h11a5 5 0 1 0-.145-9.998 1 1 0 0 1-1.002-.77A5.502 5.502 0 0 0 12.5 6ZM5 11.5a7.5 7.5 0 0 1 14.581-2.476A7 7 0 0 1 19 23H8a6 6 0 0 1-2.994-11.2c-.004-.1-.006-.2-.006-.3Z",
    fill: "#023F80"
  })));
};

var _path$1w;
function _extends$1x() { _extends$1x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1x.apply(this, arguments); }
var SvgCobroAnticipado = function SvgCobroAnticipado(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1x({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1w || (_path$1w = /*#__PURE__*/createElement$2("path", {
    d: "M23.995 19.178C23.831 22.31 19.351 24.5 14 24.5c-5.452 0-10-2.274-10-5.5V9l.005-.178C4.169 5.69 8.649 3.5 14 3.5c5.452 0 10 2.274 10 5.5v10l-.005.178Zm-1.994-6.813C20.165 13.696 17.242 14.5 14 14.5c-3.242 0-6.164-.804-8-2.134V14c0 1.745 3.51 3.5 8 3.5s8-1.755 8-3.5l.001-1.634ZM14 5.5C9.51 5.5 6 7.255 6 9s3.51 3.5 8 3.5 8-1.755 8-3.5-3.51-3.5-8-3.5Zm8.001 11.866C20.165 18.696 17.242 19.5 14 19.5c-3.242 0-6.164-.804-8-2.134V19l.005.116C6.157 20.822 9.611 22.5 14 22.5c4.49 0 8-1.755 8-3.5l.001-1.634Z",
    fill: "#023F80"
  })));
};

var _g$1, _defs;
function _extends$1y() { _extends$1y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1y.apply(this, arguments); }
var SvgCoffeeSteamOutline = function SvgCoffeeSteamOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1y({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/createElement$2("g", {
    clipPath: "url(#coffee_steam_outline_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#023F80"
  }, /*#__PURE__*/createElement$2("path", {
    d: "M18.316 1.051a1 1 0 0 0-1.265.633l-.146.44a3.7 3.7 0 0 0 .2 2.823 1.7 1.7 0 0 1 .093 1.297l-.147.44a1 1 0 0 0 1.898.632l.146-.44a3.7 3.7 0 0 0-.2-2.823 1.699 1.699 0 0 1-.093-1.297l.147-.44a1 1 0 0 0-.633-1.265ZM8.316 1.051a1 1 0 0 0-1.265.633l-.146.44a3.7 3.7 0 0 0 .2 2.823 1.7 1.7 0 0 1 .093 1.297l-.147.44a1 1 0 0 0 1.898.632l.146-.44a3.7 3.7 0 0 0-.2-2.823 1.7 1.7 0 0 1-.093-1.297l.147-.44a1 1 0 0 0-.633-1.265ZM13.268.036a1 1 0 0 0-1.232.696l-.222.801a4 4 0 0 0 .162 2.609l.202.485a2 2 0 0 1 .08 1.305l-.221.8a1 1 0 1 0 1.926.536l.223-.801a4 4 0 0 0-.162-2.609l-.202-.485a2 2 0 0 1-.08-1.305l.221-.8a1 1 0 0 0-.695-1.232ZM20.218 10.035C19.804 10 19.297 10 18.704 10H7.297c-.593 0-1.101 0-1.515.035-.434.037-.866.12-1.272.346a3 3 0 0 0-1.32 1.501c-.173.431-.2.871-.181 1.306.018.415.082.918.158 1.506l.385 2.995.025.192c.242 1.892.394 3.072.843 4.047a7 7 0 0 0 4.264 3.752C9.71 26 10.9 26 12.806 26h.388c1.907 0 3.097 0 4.122-.32a7 7 0 0 0 4.264-3.752c.092-.2.172-.409.243-.63l2.421-.727A3.867 3.867 0 0 0 23.134 13h-.138c.003-.373-.037-.748-.185-1.118a3 3 0 0 0-1.321-1.5c-.406-.227-.838-.31-1.272-.347Zm2.23 7.654-.024.192c-.056.434-.107.83-.158 1.195l1.404-.42A1.867 1.867 0 0 0 23.133 15h-.339l-.346 2.689Zm-16.495-5.66c-.309.026-.418.07-.467.098a1 1 0 0 0-.44.5c-.021.053-.052.167-.039.476.014.32.067.737.149 1.377l.38 2.954c.276 2.148.396 2.997.7 3.658a5 5 0 0 0 3.047 2.68c.694.217 1.551.228 3.717.228 2.166 0 3.023-.011 3.718-.229a5 5 0 0 0 3.046-2.68c.304-.66.424-1.51.7-3.657l.38-2.953c.083-.641.136-1.059.15-1.378.012-.31-.018-.423-.04-.476a1 1 0 0 0-.44-.5c-.049-.027-.158-.072-.466-.099-.319-.027-.74-.028-1.386-.028H7.338c-.646 0-1.067 0-1.385.028Z"
  }))), _defs || (_defs = /*#__PURE__*/createElement$2("defs", null, /*#__PURE__*/createElement$2("clipPath", {
    id: "coffee_steam_outline_svg__a"
  }, /*#__PURE__*/createElement$2("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};

var _path$1x;
function _extends$1z() { _extends$1z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1z.apply(this, arguments); }
var SvgColaboradores = function SvgColaboradores(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1z({
    width: 24,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1x || (_path$1x = /*#__PURE__*/createElement$2("path", {
    d: "M15.214 10.857c4.244 0 7.929 1.511 7.929 4.837 0 1.728-.67 2.449-2.105 2.449H9.39c-1.436 0-2.105-.72-2.105-2.45 0-3.325 3.684-4.836 7.928-4.836Zm0 1.714C11.832 12.571 9 13.733 9 15.694c0 .764-.061.74.319.735h11.719c.46 0 .39.074.39-.735 0-1.961-2.831-3.123-6.214-3.123ZM4.286 4c.473 0 .857.384.857.857V7.43h2.571a.857.857 0 0 1 0 1.714H5.143v2.571a.857.857 0 0 1-1.714 0V9.143H.857a.857.857 0 1 1 0-1.714H3.43V4.857c0-.473.383-.857.857-.857ZM15 .571a4.713 4.713 0 0 1 4.714 4.715A4.713 4.713 0 0 1 15 10a4.713 4.713 0 0 1-4.714-4.714A4.713 4.713 0 0 1 15 .57Zm0 1.715c-1.658 0-3 1.342-3 3 0 1.657 1.342 3 3 3s3-1.343 3-3c0-1.658-1.342-3-3-3Z",
    fill: "#023F80"
  })));
};

var _path$1y;
function _extends$1A() { _extends$1A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1A.apply(this, arguments); }
var SvgCommentDisableOutline = function SvgCommentDisableOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1A({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1y || (_path$1y = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.293 3.293a1 1 0 0 1 1.414 0l20 20a1 1 0 0 1-1.414 1.414L20.586 22h-3.294l-4.36 3.816c-.362.356-.775.632-1.244.73a1.654 1.654 0 0 1-1.35-.298 2.074 2.074 0 0 1-.65-.859A2.345 2.345 0 0 1 9.5 24.5V22H7.583c-1.102 0-2.098-.372-2.821-1.095-.724-.723-1.095-1.72-1.095-2.822V8.75c0-1.045.335-1.99.974-2.695L3.293 4.707a1 1 0 0 1 0-1.414Zm2.766 4.18c-.239.302-.392.723-.392 1.277v9.333c0 .648.211 1.11.509 1.408.297.297.76.509 1.407.509H10.5a1 1 0 0 1 1.001 1.001v3.417l.043-.042a.949.949 0 0 1 .049-.045l4.525-3.96a1.5 1.5 0 0 1 .988-.371h1.48L6.06 7.474Zm11.374 14.404-.328-.377.329.376ZM10 5.833a1 1 0 0 1 1-1h10.583c1.103 0 2.099.372 2.822 1.095.723.724 1.095 1.72 1.095 2.822v9.333a1 1 0 0 1-2 0V8.75c0-.648-.212-1.11-.51-1.407-.297-.298-.759-.51-1.407-.51H11a1 1 0 0 1-1-1Z",
    fill: "#023F80"
  })));
};

var _path$1z;
function _extends$1B() { _extends$1B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1B.apply(this, arguments); }
var SvgCommentOutline = function SvgCommentOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1B({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1z || (_path$1z = /*#__PURE__*/createElement$2("path", {
    d: "M16.895 4h-9.79c-1.152 0-1.74.113-2.35.44A3.172 3.172 0 0 0 3.44 5.754C3.113 6.367 3 6.954 3 8.104v5.791c0 1.152.113 1.74.44 2.35.302.565.75 1.013 1.315 1.315l.14.071c.517.25 1.05.352 1.954.367L7.1 18v2.215c0 .432.17.846.472 1.155l.116.108a1.65 1.65 0 0 0 2.217-.085L13.366 18h3.53c1.151 0 1.738-.113 2.35-.44a3.171 3.171 0 0 0 1.314-1.314c.327-.612.44-1.199.44-2.35V8.104c0-1.152-.113-1.74-.44-2.35a3.171 3.171 0 0 0-1.314-1.315c-.612-.327-1.199-.44-2.35-.44ZM6.912 5.801l9.983-.001c.88 0 1.187.06 1.502.228.25.134.441.325.576.575.168.315.227.622.227 1.502v5.79l-.004.368c-.017.607-.081.867-.224 1.134-.134.25-.325.441-.575.575-.315.169-.622.228-1.502.228H13l-.117.008a.9.9 0 0 0-.513.25L8.9 19.856V17.1a.9.9 0 0 0-.9-.9h-.895l-.368-.004c-.607-.017-.867-.081-1.134-.224a1.372 1.372 0 0 1-.575-.575c-.169-.315-.228-.622-.228-1.502v-5.79l.004-.368c.017-.607.081-.867.224-1.134.134-.25.325-.441.575-.575.291-.156.575-.218 1.309-.227Z",
    fill: "#023F80"
  })));
};

var _path$1A;
function _extends$1C() { _extends$1C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1C.apply(this, arguments); }
var SvgCompassOutline = function SvgCompassOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1C({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1A || (_path$1A = /*#__PURE__*/createElement$2("path", {
    d: "M14 2c6.627 0 12 5.373 12 12s-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2Zm0 2C8.477 4 4 8.477 4 14s4.477 10 10 10 10-4.477 10-10S19.523 4 14 4Zm4.949 6.316-2 6a1 1 0 0 1-.633.633l-6 2a1 1 0 0 1-1.265-1.265l2-6a1 1 0 0 1 .633-.633l6-2a1 1 0 0 1 1.265 1.265Zm-2.53 1.265-3.628 1.21-1.21 3.628 3.628-1.21 1.21-3.628Z",
    fill: "#023F80"
  })));
};

var _path$1B;
function _extends$1D() { _extends$1D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1D.apply(this, arguments); }
var SvgComputerOutline = function SvgComputerOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1D({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1B || (_path$1B = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1 10.5c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.14 4.1 7.26 4.1 9.5 4.1h5c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748c.436.856.436 1.976.436 4.216s0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.836.426-1.924.436-4.063.436l.55 2.2H17.1a.9.9 0 0 1 0 1.8H6.9a.9.9 0 1 1 0-1.8h1.897l.55-2.2c-2.138 0-3.227-.01-4.063-.436a4 4 0 0 1-1.748-1.748C3.1 13.86 3.1 12.74 3.1 10.5Zm11.4-4.6h-5c-1.15 0-1.904.001-2.48.048-.556.046-.787.125-.919.192a2.2 2.2 0 0 0-.961.961c-.067.132-.146.363-.191.918C4.902 8.596 4.9 9.35 4.9 10.5s.002 1.904.049 2.48c.045.556.124.787.19.919.212.414.548.75.962.961.132.067.363.146.918.192.577.047 1.331.048 2.481.048h5c1.15 0 1.904-.001 2.48-.048.556-.046.787-.125.919-.192a2.2 2.2 0 0 0 .961-.961c.067-.132.146-.363.192-.918.047-.577.048-1.331.048-2.481s-.001-1.904-.048-2.48c-.046-.556-.125-.787-.192-.919a2.2 2.2 0 0 0-.961-.961c-.132-.067-.363-.146-.918-.192-.577-.047-1.331-.048-2.48-.048Zm-3.297 11-.55 2.2h2.694l-.55-2.2h-1.594Z",
    fill: "#023F80"
  })));
};

var _path$1C;
function _extends$1E() { _extends$1E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1E.apply(this, arguments); }
var SvgConciliacion = function SvgConciliacion(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1E({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1C || (_path$1C = /*#__PURE__*/createElement$2("path", {
    d: "M16.033 2.4c.444 0 .804.358.804.8V6c0 .442-.36.8-.804.8h-2.815a.802.802 0 0 1-.805-.8c0-.442.36-.8.805-.8h1.039A6.43 6.43 0 0 0 10 3.6c-3.312 0-6.04 2.489-6.396 5.688a.803.803 0 0 1-.888.707.801.801 0 0 1-.711-.883C2.45 5.112 5.859 2 10 2a8.04 8.04 0 0 1 5.229 1.92V3.2c0-.442.36-.8.804-.8ZM17.284 10.005c.442.048.76.444.711.883C17.55 14.888 14.141 18 10 18a8.04 8.04 0 0 1-5.229-1.92v.72c0 .442-.36.8-.804.8a.802.802 0 0 1-.804-.8V14c0-.442.36-.8.804-.8h2.815c.445 0 .805.358.805.8 0 .442-.36.8-.805.8H5.743A6.43 6.43 0 0 0 10 16.4c3.312 0 6.04-2.489 6.396-5.688a.803.803 0 0 1 .888-.707Z",
    fill: "#023F80"
  })));
};

var _path$1D;
function _extends$1F() { _extends$1F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1F.apply(this, arguments); }
var SvgConfiguracion = function SvgConfiguracion(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1F({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1D || (_path$1D = /*#__PURE__*/createElement$2("path", {
    d: "M15.857 12.857c1.36 0 2.507.904 2.876 2.143h1.838a.857.857 0 1 1 0 1.714l-1.838.001a3.001 3.001 0 0 1-5.751 0H3.429a.857.857 0 0 1 0-1.715h9.552a3.001 3.001 0 0 1 2.876-2.143Zm0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM9 5.143c1.359 0 2.507.904 2.876 2.143h8.695a.857.857 0 1 1 0 1.714h-8.696a3.001 3.001 0 0 1-5.75 0H3.428a.857.857 0 0 1 0-1.714h2.695A3.001 3.001 0 0 1 9 5.143Zm0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
    fill: "#023F80"
  })));
};

var _path$1E;
function _extends$1G() { _extends$1G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1G.apply(this, arguments); }
var SvgContracargos1 = function SvgContracargos1(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1G({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1E || (_path$1E = /*#__PURE__*/createElement$2("path", {
    d: "M15.363 2.572c1.679.017 2.533.198 3.419.672a4.751 4.751 0 0 1 1.971 1.971c.474.886.655 1.74.673 3.419v6.73c-.018 1.678-.199 2.532-.673 3.418a4.751 4.751 0 0 1-1.971 1.971c-.886.474-1.74.655-3.419.673h-6.73c-1.678-.018-2.532-.199-3.418-.672a4.751 4.751 0 0 1-1.971-1.972c-.474-.886-.655-1.74-.673-3.418v-6.73c.018-1.679.199-2.533.673-3.419a4.751 4.751 0 0 1 1.971-1.971c.886-.474 1.74-.655 3.419-.672h6.73Zm-.287 1.712H8.92l-.478.005c-1.268.024-1.835.154-2.42.466-.548.294-.974.72-1.268 1.269-.312.584-.443 1.152-.467 2.42l-.004.477v6.155l.004.478c.024 1.268.155 1.836.467 2.42.294.548.72.974 1.269 1.268.584.312 1.151.443 2.42.467l.477.004h6.155l.478-.004c1.268-.024 1.835-.155 2.42-.467.548-.294.974-.72 1.268-1.269.312-.583.443-1.151.467-2.42l.004-.477V8.921l-.004-.478c-.024-1.267-.155-1.835-.467-2.42a3.037 3.037 0 0 0-1.269-1.268c-.584-.312-1.151-.442-2.42-.466l-.477-.005ZM12 7.714c.473 0 .857.384.857.858v2.571h2.572a.857.857 0 0 1 0 1.714h-2.572v2.572a.857.857 0 1 1-1.714 0v-2.572H8.57a.857.857 0 1 1 0-1.714h2.572V8.572c0-.474.384-.858.857-.858Z",
    fill: "#023F80"
  })));
};

var _path$1F;
function _extends$1H() { _extends$1H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1H.apply(this, arguments); }
var SvgContracargos = function SvgContracargos(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1H({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1F || (_path$1F = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.212 4.375c5.138 0 9.384 4.248 9.384 9.393 0 5.14-4.237 9.386-9.384 9.386-2.857 0-5.453-1.299-7.065-3.236-.251-.315-.362-.602-.362-.853 0-.528.435-.89.907-.89.279 0 .568.12.798.39 1.364 1.567 3.376 2.67 5.722 2.67 4.145 0 7.484-3.329 7.475-7.466a7.459 7.459 0 0 0-7.475-7.473 7.438 7.438 0 0 0-7.39 6.408l1.103-.9a.785.785 0 0 1 .537-.196c.455 0 .826.363.826.826 0 .279-.13.54-.361.696L7.42 14.976c-.24.165-.462.25-.721.25-.408 0-.678-.148-.993-.538l-2.012-2.44a.93.93 0 0 1-.195-.574c0-.482.381-.807.843-.807.297 0 .54.149.704.39l.864 1.234c.63-4.545 4.59-8.116 9.3-8.116Zm.17 4.48c.216 0 .393.067.53.2a.7.7 0 0 1 .204.525v.493l.29.057c.48.112.95.313 1.411.605a.771.771 0 0 1 .268.278.804.804 0 0 1 .079.373c0 .21-.063.392-.19.546-.125.154-.272.231-.44.231a.701.701 0 0 1-.242-.042 3.044 3.044 0 0 1-.336-.158 12.34 12.34 0 0 0-.325-.173 2.711 2.711 0 0 0-.54-.21 2.325 2.325 0 0 0-.615-.079c-.315 0-.57.069-.767.205a.64.64 0 0 0-.294.552c0 .224.112.392.336.504.224.111.578.223 1.06.335.519.12.944.245 1.277.379.332.132.62.346.86.64.242.294.363.69.363 1.187a2 2 0 0 1-.583 1.448c-.388.4-.912.662-1.57.788v.514l-.008.126a.667.667 0 0 1-.196.4.728.728 0 0 1-.53.199.728.728 0 0 1-.53-.2.7.7 0 0 1-.206-.524v-.473l-.326-.05c-.638-.116-1.195-.326-1.669-.633a.714.714 0 0 1-.267-.262.823.823 0 0 1-.08-.389.85.85 0 0 1 .185-.546c.122-.154.267-.23.435-.23.084 0 .168.014.252.041.084.028.193.081.326.158.308.168.595.287.86.357.267.07.55.105.851.105.371 0 .653-.061.846-.184a.61.61 0 0 0 .288-.551.448.448 0 0 0-.173-.362 1.319 1.319 0 0 0-.43-.226 12.793 12.793 0 0 0-.751-.21 10.119 10.119 0 0 1-1.292-.404 2.224 2.224 0 0 1-.871-.64c-.245-.291-.368-.681-.368-1.171 0-.56.196-1.047.588-1.46.392-.413.91-.686 1.554-.819V9.58l.009-.122a.675.675 0 0 1 .201-.398.722.722 0 0 1 .525-.205Z",
    fill: "#023F80"
  })));
};

var _path$1G;
function _extends$1I() { _extends$1I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1I.apply(this, arguments); }
var SvgCookieOutline = function SvgCookieOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1I({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1G || (_path$1G = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.248 3.981 6 4.95c.248-.969.249-.969.25-.968h.003l.009.003.025.007.083.023c.07.02.167.05.289.09.243.081.583.205.989.38.808.35 1.887.913 2.97 1.767 1.268.998 2.538 2.394 3.382 4.29.844-1.896 2.113-3.292 3.381-4.29a13.55 13.55 0 0 1 2.971-1.766 12.09 12.09 0 0 1 1.278-.47l.083-.024.025-.007.009-.002.003-.001c.001 0 .002 0 .25.968l-.248-.969a1 1 0 0 1 .975.283A11.962 11.962 0 0 1 26 12.5c0 6.627-5.373 12-12 12s-12-5.373-12-12c0-3.188 1.245-6.088 3.273-8.236a1 1 0 0 1 .975-.283Zm15.44 2.123a11.551 11.551 0 0 0-3.069 1.72C16.806 9.25 15 11.617 15 15.5a1 1 0 1 1-2 0c0-3.882-1.806-6.25-3.619-7.677a11.55 11.55 0 0 0-3.068-1.72A9.956 9.956 0 0 0 4 12.5c0 5.523 4.477 10 10 10s10-4.477 10-10a9.956 9.956 0 0 0-2.313-6.396Z",
    fill: "#023F80"
  })));
};

var _path$1H;
function _extends$1J() { _extends$1J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1J.apply(this, arguments); }
var SvgCopyOutline = function SvgCopyOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1J({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1H || (_path$1H = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12.3V12c0-1.47.005-2.547.075-3.403.074-.904.216-1.482.454-1.949a4.85 4.85 0 0 1 2.12-2.12c.466-.237 1.044-.379 1.948-.453C9.51 4.001 10.675 4 12.3 4H16.812a2.073 2.073 0 0 0-.174-.49 2.4 2.4 0 0 0-1.048-1.048 2.439 2.439 0 0 0-.931-.239 13.48 13.48 0 0 0-1.026-.023H12.26c-1.576 0-2.814 0-3.81.081-1.014.083-1.856.255-2.62.644A6.65 6.65 0 0 0 2.926 5.83c-.389.763-.56 1.605-.644 2.62-.081.995-.081 2.233-.081 3.809v1.373c0 .392 0 .738.023 1.025.025.306.081.623.239.931a2.4 2.4 0 0 0 1.048 1.05c.162.082.326.136.49.173V12.3ZM10.08 6h-.035c-.52 0-.964 0-1.329.03-.383.03-.755.097-1.112.276a2.9 2.9 0 0 0-1.298 1.298c-.179.357-.246.73-.277 1.112C6 9.081 6 9.524 6 10.046v7.909c0 .52 0 .964.03 1.329.03.382.097.755.276 1.112a2.9 2.9 0 0 0 1.298 1.298c.357.179.73.246 1.112.277.365.029.808.029 1.329.029h6.91c.52 0 .964 0 1.329-.03.382-.03.755-.097 1.112-.276a2.9 2.9 0 0 0 1.298-1.298c.179-.357.246-.73.277-1.112.029-.365.029-.808.029-1.33v-7.909c0-.52 0-.964-.03-1.329-.03-.382-.097-.755-.276-1.112a2.9 2.9 0 0 0-1.298-1.298c-.357-.179-.73-.246-1.112-.277C17.919 6 17.476 6 16.954 6H10.08ZM8.408 7.916c.065-.032.179-.07.452-.093.284-.022.655-.023 1.22-.023h6.84c.565 0 .936 0 1.22.023.273.022.387.06.452.093a1.1 1.1 0 0 1 .492.492c.032.065.07.179.093.452.022.284.023.655.023 1.22v7.84c0 .565 0 .936-.023 1.22-.023.273-.06.387-.093.452a1.1 1.1 0 0 1-.492.492c-.065.032-.18.07-.452.093-.284.022-.655.023-1.22.023h-6.84c-.565 0-.936 0-1.22-.023-.273-.023-.387-.06-.452-.093a1.1 1.1 0 0 1-.492-.492c-.032-.065-.07-.18-.093-.452a17.057 17.057 0 0 1-.023-1.22v-7.84c0-.565 0-.936.023-1.22.022-.273.06-.387.093-.452a1.1 1.1 0 0 1 .492-.492Z",
    fill: "#023F80"
  })));
};

var _path$1I, _path2$q;
function _extends$1K() { _extends$1K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1K.apply(this, arguments); }
var SvgCrop = function SvgCrop(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1K({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1I || (_path$1I = /*#__PURE__*/createElement$2("path", {
    d: "M6 1.006a.9.9 0 0 1 .9.9V14.8c0 .575 0 .952.024 1.24.023.278.062.393.096.46a1.1 1.1 0 0 0 .48.48c.066.034.182.073.46.096.288.023.665.024 1.24.024h12.898a.9.9 0 1 1 0 1.8H18.9v3.198a.9.9 0 0 1-1.8 0V18.9H9.165c-.53 0-.982 0-1.352-.03-.39-.032-.768-.102-1.13-.286a2.9 2.9 0 0 1-1.267-1.267c-.184-.362-.254-.741-.286-1.13-.03-.37-.03-.822-.03-1.352V6.9H1.902a.9.9 0 0 1 0-1.8H5.1V1.906a.9.9 0 0 1 .9-.9Z",
    fill: "#023F80"
  })), _path2$q || (_path2$q = /*#__PURE__*/createElement$2("path", {
    d: "M16.04 6.924c-.288-.023-.665-.024-1.24-.024H9.907a.9.9 0 0 1 0-1.8h4.928c.53 0 .981 0 1.352.03.389.032.768.102 1.13.286a2.9 2.9 0 0 1 1.267 1.267c.184.362.254.74.286 1.13.03.37.03.822.03 1.352v4.937a.9.9 0 0 1-1.8 0V9.2c0-.575 0-.952-.024-1.24-.023-.278-.062-.394-.096-.46a1.1 1.1 0 0 0-.48-.48c-.067-.034-.182-.073-.46-.096Z",
    fill: "#023F80"
  })));
};

var _path$1J, _path2$r;
function _extends$1L() { _extends$1L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1L.apply(this, arguments); }
var SvgCrossShieldOutline = function SvgCrossShieldOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1L({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1J || (_path$1J = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.697 2.152a.9.9 0 0 1 .606 0l7 2.5a.9.9 0 0 1 .597.848V13c0 2.85-1.568 5.077-3.243 6.55a11.885 11.885 0 0 1-2.531 1.71c-.758.374-1.537.64-2.126.64-.59 0-1.368-.265-2.125-.64a11.882 11.882 0 0 1-2.532-1.71C5.668 18.078 4.1 15.85 4.1 13V5.5a.9.9 0 0 1 .597-.848l7-2.5ZM5.9 6.134V13c0 2.15 1.182 3.923 2.632 5.2.72.633 1.482 1.12 2.14 1.446.696.345 1.167.454 1.328.454.16 0 .632-.11 1.328-.454.658-.325 1.42-.813 2.14-1.447C16.918 16.923 18.1 15.15 18.1 13V6.134L12 3.956 5.9 6.134Z",
    fill: "#023F80"
  })), _path2$r || (_path2$r = /*#__PURE__*/createElement$2("path", {
    d: "M10.136 8.864a.9.9 0 0 0-1.272 1.272L10.727 12l-1.863 1.864a.9.9 0 0 0 1.272 1.272L12 13.273l1.864 1.863a.9.9 0 0 0 1.272-1.272L13.274 12l1.864-1.864a.9.9 0 1 0-1.273-1.272L12 10.727l-1.864-1.863Z",
    fill: "#023F80"
  })));
};

var _path$1K;
function _extends$1M() { _extends$1M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1M.apply(this, arguments); }
var SvgCrownOutline = function SvgCrownOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1M({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1K || (_path$1K = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.012 2.229a2.344 2.344 0 0 0-2.02 0c-.47.233-.763.667-.979 1.054-.222.399-.462.935-.748 1.574L8.107 7.452l-1.15-.687c-.679-.405-1.24-.74-1.69-.958-.427-.206-.958-.416-1.507-.316a2.2 2.2 0 0 0-1.603 1.243c-.234.507-.162 1.073-.068 1.538.099.491.284 1.117.507 1.875l1.24 4.204c.066.227.1.341.127.457.05.219.082.441.096.666.007.118.007.237.007.474 0 .53 0 .981.03 1.352.032.389.101.767.286 1.13a2.9 2.9 0 0 0 1.267 1.267c.362.184.74.254 1.13.286.37.03.821.017 1.351.017h7.742c.53 0 .981.013 1.352-.017.389-.032.767-.102 1.13-.286a2.9 2.9 0 0 0 1.267-1.268c.184-.362.254-.74.285-1.13.03-.37.03-.821.03-1.35 0-.235 0-.352.007-.468.014-.227.046-.452.098-.673.026-.114.059-.226.125-.45l1.241-4.211c.224-.758.408-1.384.508-1.875.094-.465.165-1.031-.069-1.538a2.2 2.2 0 0 0-1.602-1.243c-.55-.1-1.08.11-1.508.316-.45.219-1.01.553-1.689.958l-1.15.687-1.159-2.595c-.286-.64-.525-1.175-.748-1.574-.216-.387-.508-.82-.978-1.054Zm5.125 13.683H5.866c0 .575 0 .953.024 1.241.023.278.062.393.096.46a1.1 1.1 0 0 0 .48.48c.066.033.182.073.46.096.288.023.665.024 1.24.024h7.67c.575 0 .953-.001 1.241-.024.278-.023.393-.063.459-.096a1.1 1.1 0 0 0 .48-.48c.034-.067.074-.182.096-.46.024-.288.025-.666.025-1.24ZM11.602 4.13c.185-.314.64-.286.817.031.178.32.385.78.693 1.47l1.554 3.48a.9.9 0 0 0 1.284.406l1.982-1.184c.725-.433.953-.58 1.589-.906l.022-.01c.326-.166.68.14.607.499-.081.404-.243.954-.481 1.764l-1.307 4.432H5.642L4.334 9.68a42.01 42.01 0 0 1-.482-1.764c-.09-.362.294-.65.63-.489.37.18.863.473 1.589.906l1.982 1.184a.9.9 0 0 0 1.283-.406l1.554-3.48c.308-.69.515-1.15.693-1.47l.018-.03Z",
    fill: "#023F80"
  })));
};

var _path$1L;
function _extends$1N() { _extends$1N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1N.apply(this, arguments); }
var SvgCubeBoxOutline = function SvgCubeBoxOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1N({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1L || (_path$1L = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.155 5.502-.1.044c-.45.2-.866.383-1.185.689a2.5 2.5 0 0 0-.622.957c-.15.416-.15.87-.148 1.362v6.992c-.001.457-.002.893.142 1.293a2.4 2.4 0 0 0 .598.92c.306.293.705.47 1.123.654l.097.043 6.353 2.823c.401.18.74.33 1.104.392.32.054.646.054.966 0 .363-.061.702-.212 1.104-.392l6.353-2.823.096-.043c.419-.185.818-.361 1.124-.655a2.4 2.4 0 0 0 .598-.92c.144-.399.143-.835.142-1.292V8.554c0-.491.002-.946-.148-1.362a2.5 2.5 0 0 0-.623-.957c-.318-.306-.734-.49-1.184-.689l-.1-.044-6.258-2.781c-.402-.18-.74-.33-1.104-.392a2.9 2.9 0 0 0-.966 0c-.364.062-.703.213-1.104.392L4.155 5.5Zm8.028-1.398a1.1 1.1 0 0 0-.366 0c-.111.019-.23.065-.751.296l-1.35.6L16.5 8.015 18.784 7l-5.85-2.6c-.52-.231-.64-.277-.751-.296Zm7.916 4.281-3.23 1.436-.006.003-3.276 1.456c-.246.109-.468.208-.687.283v8.052l6.31-2.804c.578-.257.656-.306.705-.353a.6.6 0 0 0 .15-.23c.022-.063.035-.154.035-.788V8.664l-.001-.279Zm-9 3.178c-.218-.075-.44-.174-.686-.284L3.9 8.386l-.001.279v6.776c0 .634.013.725.035.789a.599.599 0 0 0 .15.23c.048.046.127.095.706.352l6.309 2.804v-8.052ZM5.217 7l5.85 2.6c.52.231.64.277.75.296.122.02.246.02.367 0 .11-.019.23-.065.751-.296l1.35-.6L7.5 5.985 5.216 7Z",
    fill: "#023F80"
  })));
};

var _path$1M;
function _extends$1O() { _extends$1O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1O.apply(this, arguments); }
var SvgCupOutline = function SvgCupOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1O({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1M || (_path$1M = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.89 2.256c-.461-.157-.967-.157-1.57-.156H8.68c-.602 0-1.109-.001-1.57.156A2.991 2.991 0 0 0 5.242 4.28a3.031 3.031 0 0 0-.08.848 2.672 2.672 0 0 0-1.37.161C2.799 5.686 2.1 6.66 2.1 8c0 2.36 2.093 4.526 4.708 4.857.614 1.34 1.496 2.63 2.788 3.391-.018.628-.08 1.331-.517 1.82-.198.222-.42.418-.588.665-.252.369-.392.802-.392 1.367v.9a.9.9 0 0 0 .9.9h6a.9.9 0 0 0 .9-.9v-.9c0-.565-.14-.998-.392-1.367-.168-.247-.39-.443-.587-.665-.439-.489-.5-1.192-.518-1.82 1.292-.762 2.174-2.05 2.788-3.392 2.616-.33 4.71-2.497 4.71-4.856 0-1.34-.7-2.314-1.692-2.71a2.672 2.672 0 0 0-1.37-.162 3.031 3.031 0 0 0-.08-.848 2.991 2.991 0 0 0-1.87-2.024ZM8.8 3.9c-.788 0-.967.012-1.106.06-.319.109-.626.44-.71.767-.036.145-.035.297.02 1 .227 2.854.817 5.265 1.717 6.933.894 1.66 2.002 2.44 3.28 2.44 1.276 0 2.384-.78 3.279-2.44.899-1.668 1.489-4.08 1.716-6.933.055-.703.057-.855.02-1a1.197 1.197 0 0 0-.71-.768c-.139-.047-.318-.059-1.106-.059H8.8ZM4.46 6.96c-.26.104-.56.38-.56 1.04 0 1.077.86 2.282 2.163 2.818a22.987 22.987 0 0 1-.692-3.411.598.598 0 0 0-.055-.218c-.153-.313-.565-.345-.857-.228Zm15.08 0c.26.104.56.38.56 1.04 0 1.077-.86 2.282-2.163 2.818a22.99 22.99 0 0 0 .692-3.411.597.597 0 0 1 .055-.218c.153-.313.563-.346.857-.228Zm-9.12 12.31c-.143.16-.321.302-.443.48-.029.042-.077.115-.077.35h4.2c0-.235-.048-.308-.077-.35-.122-.178-.3-.32-.443-.48-.602-.673-.86-1.527-.943-2.411a5.025 5.025 0 0 1-1.274 0c-.083.884-.34 1.738-.942 2.41Z",
    fill: "#023F80"
  })));
};

var _path$1N;
function _extends$1P() { _extends$1P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1P.apply(this, arguments); }
var SvgCuponesEnVuelo = function SvgCuponesEnVuelo(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1P({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1N || (_path$1N = /*#__PURE__*/createElement$2("path", {
    d: "M20.571 11.01c0-.915-.063-1.241-.242-1.576a1.48 1.48 0 0 0-.62-.62c-.335-.18-.661-.243-1.577-.243H3.43v7.847c0 .915.062 1.241.242 1.576.144.27.35.477.62.62.335.18.661.243 1.577.243h13.49l-1.107-1.108a.857.857 0 1 1 1.212-1.212l2.572 2.571a.857.857 0 0 1 0 1.212l-2.572 2.572a.857.857 0 0 1-1.212-1.212l1.107-1.109H5.868c-1.175 0-1.768-.114-2.385-.444a3.194 3.194 0 0 1-1.324-1.324c-.33-.617-.445-1.21-.445-2.385V6.857h.002V6.81c.015-.857.12-1.336.386-1.832a2.804 2.804 0 0 1 1.161-1.162c.538-.288 1.055-.388 2.055-.388h9.935c1 0 1.517.1 2.055.388.498.267.895.663 1.162 1.162.272.509.376.998.386 1.897.724.046 1.186.173 1.661.427.569.304 1.02.755 1.324 1.323.33.618.445 1.211.445 2.386v3.56a.857.857 0 0 1-1.715 0v-3.56Zm-3.428 1.847a.857.857 0 0 1 0 1.714h-1.715a.857.857 0 1 1 0-1.714h1.715Zm-1.89-7.714H5.318c-.741 0-.99.048-1.246.185a1.09 1.09 0 0 0-.459.458c-.125.234-.176.464-.183 1.071h13.712c-.008-.607-.059-.837-.184-1.07a1.09 1.09 0 0 0-.458-.46c-.256-.136-.506-.184-1.247-.184Z",
    fill: "#023F80"
  })));
};

var _path$1O, _path2$s;
function _extends$1Q() { _extends$1Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Q.apply(this, arguments); }
var SvgDeleteArrowUpOutline = function SvgDeleteArrowUpOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1Q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1O || (_path$1O = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.1a.9.9 0 1 0 0 1.8h1.18l1.155 12.316c.045.484.084.898.143 1.237.062.359.157.704.35 1.03a2.9 2.9 0 0 0 1.25 1.137c.342.162.695.225 1.057.253.344.027.76.027 1.246.027h5.238c.486 0 .902 0 1.246-.027.362-.028.715-.09 1.057-.253a2.9 2.9 0 0 0 1.249-1.137c.194-.326.289-.671.35-1.03.06-.34.099-.753.144-1.237L19.82 5.9H21a.9.9 0 0 0 0-1.8h-5.204a3.902 3.902 0 0 0-7.592 0H3Zm4.124 13.915c.05.526.082.87.128 1.13.043.252.087.356.124.417a1.1 1.1 0 0 0 .474.432c.064.03.172.065.426.085.265.02.61.021 1.138.021h5.172c.528 0 .873 0 1.138-.021.254-.02.362-.055.426-.085a1.1 1.1 0 0 0 .474-.432c.037-.06.08-.166.124-.416.046-.262.079-.605.128-1.131L18.012 5.9H5.988l1.136 12.115ZM12 2.9a2.1 2.1 0 0 0-1.898 1.2h3.796A2.1 2.1 0 0 0 12 2.9Z",
    fill: "#023F80"
  })), _path2$s || (_path2$s = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.136 12.136a.9.9 0 0 1-1.272 0l-.964-.963V17a.9.9 0 0 1-1.8 0v-5.827l-.964.963a.9.9 0 1 1-1.272-1.272l2.5-2.5a.9.9 0 0 1 1.272 0l2.5 2.5a.9.9 0 0 1 0 1.272Z",
    fill: "#023F80"
  })));
};

var _path$1P, _path2$t;
function _extends$1R() { _extends$1R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1R.apply(this, arguments); }
var SvgDeleteOutline = function SvgDeleteOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1R({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1P || (_path$1P = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.556 8.102a.9.9 0 0 1 .842.954l-.5 8a.9.9 0 0 1-1.796-.112l.5-8a.9.9 0 0 1 .954-.842ZM9.444 8.102a.9.9 0 0 0-.842.954l.5 8a.9.9 0 0 0 1.796-.112l-.5-8a.9.9 0 0 0-.954-.842Z",
    fill: "#023F80"
  })), _path2$t || (_path2$t = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.1a.9.9 0 1 0 0 1.8h1.18l1.155 12.316c.045.484.084.898.143 1.237.062.359.157.704.35 1.03a2.9 2.9 0 0 0 1.25 1.137c.342.162.695.225 1.057.253.344.027.76.027 1.246.027h5.238c.486 0 .902 0 1.246-.027.362-.028.715-.09 1.057-.253a2.9 2.9 0 0 0 1.249-1.137c.194-.326.289-.671.35-1.03.06-.34.099-.753.144-1.237L19.82 5.9H21a.9.9 0 0 0 0-1.8h-5.204a3.902 3.902 0 0 0-7.592 0H3Zm4.124 13.915c.05.526.082.87.128 1.13.043.252.087.356.124.417a1.1 1.1 0 0 0 .474.432c.064.03.172.065.426.085.265.02.61.021 1.138.021h5.172c.528 0 .873 0 1.138-.021.254-.02.362-.055.426-.085a1.1 1.1 0 0 0 .474-.432c.037-.06.08-.166.124-.416.046-.262.079-.605.128-1.131L18.012 5.9H5.988l1.136 12.115ZM12 2.9a2.1 2.1 0 0 0-1.898 1.2h3.796A2.1 2.1 0 0 0 12 2.9Z",
    fill: "#023F80"
  })));
};

var _path$1Q;
function _extends$1S() { _extends$1S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1S.apply(this, arguments); }
var SvgDevicesOutline = function SvgDevicesOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1S({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1Q || (_path$1Q = /*#__PURE__*/createElement$2("path", {
    d: "m8.846 9 2.573.002c1.198.017 1.846.157 2.518.517.663.355 1.19.881 1.544 1.544.385.72.519 1.413.519 2.783v7.308c0 1.37-.134 2.063-.519 2.783a3.726 3.726 0 0 1-1.544 1.544c-.72.385-1.413.519-2.783.519H8.846c-1.37 0-2.063-.134-2.783-.519a3.726 3.726 0 0 1-1.544-1.544C4.134 23.217 4 22.524 4 21.154l.002-7.573c.017-1.198.157-1.846.517-2.518A3.726 3.726 0 0 1 6.063 9.52C6.783 9.134 7.476 9 8.846 9Zm9.026-7c1.777 0 2.648.168 3.553.652a4.634 4.634 0 0 1 1.922 1.923c.456.852.632 1.674.651 3.248l.002.305v11.744c0 1.777-.168 2.648-.652 3.553a4.634 4.634 0 0 1-1.923 1.922c-.884.473-1.732.644-3.416.653a1 1 0 0 1-.01-2c1.384-.008 1.921-.116 2.483-.416a2.634 2.634 0 0 0 1.102-1.102c.272-.508.388-1.003.411-2.126l.005-.484V8.128l-.005-.484c-.023-1.123-.14-1.618-.411-2.126a2.635 2.635 0 0 0-1.102-1.102c-.508-.272-1.003-.388-2.125-.411L17.873 4l-3.006.001c-1.29.016-1.803.123-2.35.415a2.635 2.635 0 0 0-1.1 1.102c-.1.187-.17.347-.224.526l-.049.186a1 1 0 1 1-1.95-.448c.103-.444.246-.81.458-1.207a4.635 4.635 0 0 1 1.923-1.923c.806-.43 1.58-.61 2.99-.645l.29-.005L17.872 2Zm-6.718 9-2.527.001c-.904.01-1.258.087-1.62.282-.315.168-.556.409-.724.723-.21.391-.283.772-.283 1.84v7.308c0 1.068.073 1.449.283 1.84.168.314.409.555.723.724.335.179.663.258 1.422.277l.418.005h2.308c1.068 0 1.449-.073 1.84-.282.314-.169.555-.41.723-.724.18-.335.26-.663.278-1.422l.005-.418v-7.308c0-1.068-.073-1.449-.283-1.84a1.727 1.727 0 0 0-.723-.723c-.391-.21-.772-.283-1.84-.283Z",
    fill: "#023F80"
  })));
};

var _path$1R;
function _extends$1T() { _extends$1T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1T.apply(this, arguments); }
var SvgDiamondOutline = function SvgDiamondOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1T({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1R || (_path$1R = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.063 4a1 1 0 0 0-.442.103L5.57 6.097a.995.995 0 0 0-.431.393l-2.985 4.975a.946.946 0 0 0-.11.237.994.994 0 0 0 .118.845c.04.063.089.121.144.174l10.98 10.98.04.039a.996.996 0 0 0 .601.257l.024.002h.002a.995.995 0 0 0 .759-.297l10.98-10.98a.993.993 0 0 0 .303-.808.993.993 0 0 0-.19-.506L22.32 6.427a.996.996 0 0 0-.348-.31l-3.544-1.989a1 1 0 0 0-.49-.128h-7.875ZM21.12 8.202l-3.39 1.233 1.205 3.214.003.008 4.432-1.24-2.25-3.215ZM16.932 13l-1.125-3h-3.614l-1.125 3h5.864Zm-7.871-.343c0-.003.002-.005.003-.008l1.19-3.177-3.81-1.27-1.912 3.188 4.529 1.267ZM8.627 6.82 10.295 6h7.381l1.434.805L15.824 8h-3.662L8.627 6.821Zm2.272 11.664L6.405 13.99l2.851.797 1.643 3.697ZM14 20.538 11.539 15h4.922L14 20.538Zm3.101-2.053 1.643-3.697 2.85-.797-4.493 4.494Z",
    fill: "#023F80"
  })));
};

var _path$1S, _path2$u;
function _extends$1U() { _extends$1U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1U.apply(this, arguments); }
var SvgDice1Outline = function SvgDice1Outline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1U({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1S || (_path$1S = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4 5h-2.8c-1.713 0-2.878.002-3.778.075-.877.072-1.325.202-1.638.361a4 4 0 0 0-1.748 1.748c-.16.313-.29.761-.361 1.638C5.001 9.722 5 10.887 5 12.6v2.8c0 1.713.001 2.878.075 3.778.072.877.201 1.325.36 1.638a4 4 0 0 0 1.749 1.748c.313.16.761.29 1.638.36.9.074 2.065.076 3.778.076h2.8c1.713 0 2.878-.002 3.778-.075.877-.072 1.325-.202 1.638-.361a4 4 0 0 0 1.748-1.748c.16-.313.29-.761.36-1.638.074-.9.076-2.065.076-3.778v-2.8c0-1.713-.002-2.878-.075-3.778-.072-.877-.202-1.325-.361-1.638a4 4 0 0 0-1.748-1.748c-.313-.16-.761-.29-1.638-.36C18.278 5.001 17.113 5 15.4 5ZM3.654 6.276C3 7.56 3 9.24 3 12.6v2.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C7.559 25 9.24 25 12.6 25h2.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C25 20.44 25 18.76 25 15.4v-2.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C20.44 3 18.76 3 15.4 3h-2.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622Z",
    fill: "#023F80"
  })), _path2$u || (_path2$u = /*#__PURE__*/createElement$2("path", {
    d: "M15.75 14a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z",
    fill: "#023F80"
  })));
};

var _path$1T;
function _extends$1V() { _extends$1V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1V.apply(this, arguments); }
var SvgDice2Outline = function SvgDice2Outline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1V({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1T || (_path$1T = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4 5h-2.8c-1.713 0-2.878.002-3.778.075-.877.072-1.325.202-1.638.361a4 4 0 0 0-1.748 1.748c-.16.313-.29.761-.361 1.638C5.001 9.722 5 10.887 5 12.6v2.8c0 1.713.001 2.878.075 3.778.072.877.202 1.325.36 1.638a4 4 0 0 0 1.749 1.748c.313.16.761.29 1.638.36.9.074 2.065.076 3.778.076h2.8c1.713 0 2.878-.002 3.778-.075.877-.072 1.325-.202 1.638-.361a4 4 0 0 0 1.748-1.748c.16-.313.29-.761.36-1.638.074-.9.076-2.065.076-3.778v-2.8c0-1.713-.002-2.878-.075-3.778-.072-.877-.202-1.325-.361-1.638a4 4 0 0 0-1.748-1.748c-.313-.16-.761-.29-1.638-.36C18.278 5.001 17.113 5 15.4 5ZM3.654 6.276C3 7.56 3 9.24 3 12.6v2.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C7.559 25 9.24 25 12.6 25h2.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C25 20.44 25 18.76 25 15.4v-2.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C20.44 3 18.76 3 15.4 3h-2.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622ZM11 9.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm7.75 11.25a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z",
    fill: "#023F80"
  })));
};

var _path$1U, _path2$v;
function _extends$1W() { _extends$1W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1W.apply(this, arguments); }
var SvgDice3Outline = function SvgDice3Outline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1W({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1U || (_path$1U = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4 5h-2.8c-1.713 0-2.878.002-3.778.075-.877.072-1.325.202-1.638.361a4 4 0 0 0-1.748 1.748c-.16.313-.29.761-.361 1.638C5.001 9.722 5 10.887 5 12.6v2.8c0 1.713.001 2.878.075 3.778.072.877.201 1.325.36 1.638a4 4 0 0 0 1.749 1.748c.313.16.761.29 1.638.36.9.074 2.065.076 3.778.076h2.8c1.713 0 2.878-.002 3.778-.075.877-.072 1.325-.202 1.638-.361a4 4 0 0 0 1.748-1.748c.16-.313.29-.761.36-1.638.074-.9.076-2.065.076-3.778v-2.8c0-1.713-.002-2.878-.075-3.778-.072-.877-.202-1.325-.361-1.638a4 4 0 0 0-1.748-1.748c-.313-.16-.761-.29-1.638-.36C18.278 5.001 17.113 5 15.4 5ZM3.654 6.276C3 7.56 3 9.24 3 12.6v2.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C7.559 25 9.24 25 12.6 25h2.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C25 20.44 25 18.76 25 15.4v-2.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C20.44 3 18.76 3 15.4 3h-2.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622Z",
    fill: "#023F80"
  })), _path2$v || (_path2$v = /*#__PURE__*/createElement$2("path", {
    d: "M11 9.25a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0ZM15.75 14a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0ZM20.5 18.75a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0Z",
    fill: "#023F80"
  })));
};

var _path$1V;
function _extends$1X() { _extends$1X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1X.apply(this, arguments); }
var SvgDice4Outline = function SvgDice4Outline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1X({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1V || (_path$1V = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4 5h-2.8c-1.713 0-2.878.002-3.778.075-.877.072-1.325.202-1.638.361a4 4 0 0 0-1.748 1.748c-.16.313-.29.761-.361 1.638C5.001 9.722 5 10.887 5 12.6v2.8c0 1.713.001 2.878.075 3.778.072.877.202 1.325.36 1.638a4 4 0 0 0 1.749 1.748c.313.16.761.29 1.638.36.9.074 2.065.076 3.778.076h2.8c1.713 0 2.878-.002 3.778-.075.877-.072 1.325-.202 1.638-.361a4 4 0 0 0 1.748-1.748c.16-.313.29-.761.36-1.638.074-.9.076-2.065.076-3.778v-2.8c0-1.713-.002-2.878-.075-3.778-.072-.877-.202-1.325-.361-1.638a4 4 0 0 0-1.748-1.748c-.313-.16-.761-.29-1.638-.36C18.278 5.001 17.113 5 15.4 5ZM3.654 6.276C3 7.56 3 9.24 3 12.6v2.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C7.559 25 9.24 25 12.6 25h2.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C25 20.44 25 18.76 25 15.4v-2.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C20.44 3 18.76 3 15.4 3h-2.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622ZM11 18.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM9.25 11a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM20.5 9.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM18.75 20.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z",
    fill: "#023F80"
  })));
};

var _path$1W;
function _extends$1Y() { _extends$1Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Y.apply(this, arguments); }
var SvgDice5Outline = function SvgDice5Outline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1Y({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1W || (_path$1W = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6 5h2.8c1.713 0 2.878.002 3.778.075.877.072 1.325.202 1.638.361a4 4 0 0 1 1.748 1.748c.16.313.29.761.36 1.638.074.9.076 2.065.076 3.778v2.8c0 1.713-.002 2.878-.075 3.778-.072.877-.202 1.325-.361 1.638a4 4 0 0 1-1.748 1.748c-.313.16-.761.29-1.638.36-.9.074-2.065.076-3.778.076h-2.8c-1.713 0-2.878-.002-3.778-.075-.877-.072-1.325-.202-1.638-.361a4 4 0 0 1-1.748-1.748c-.16-.313-.29-.761-.361-1.638C5.001 18.278 5 17.113 5 15.4v-2.8c0-1.713.001-2.878.075-3.778.072-.877.201-1.325.36-1.638a4 4 0 0 1 1.749-1.748c.313-.16.761-.29 1.638-.36C9.722 5.001 10.887 5 12.6 5ZM3 12.6c0-3.36 0-5.04.654-6.324a6 6 0 0 1 2.622-2.622C7.559 3 9.24 3 12.6 3h2.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C25 7.56 25 9.24 25 12.6v2.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C20.44 25 18.76 25 15.4 25h-2.8c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C3 20.44 3 18.76 3 15.4v-2.8Zm6.25 7.9a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM11 9.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm3 6.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Zm6.5-6.5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM18.75 20.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z",
    fill: "#023F80"
  })));
};

var _path$1X, _path2$w;
function _extends$1Z() { _extends$1Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Z.apply(this, arguments); }
var SvgDice6Outline = function SvgDice6Outline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1Z({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1X || (_path$1X = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4 5h-2.8c-1.713 0-2.878.002-3.778.075-.877.072-1.325.202-1.638.361a4 4 0 0 0-1.748 1.748c-.16.313-.29.761-.361 1.638C5.001 9.722 5 10.887 5 12.6v2.8c0 1.713.001 2.878.075 3.778.072.877.201 1.325.36 1.638a4 4 0 0 0 1.749 1.748c.313.16.761.29 1.638.36.9.074 2.065.076 3.778.076h2.8c1.713 0 2.878-.002 3.778-.075.877-.072 1.325-.202 1.638-.361a4 4 0 0 0 1.748-1.748c.16-.313.29-.761.36-1.638.074-.9.076-2.065.076-3.778v-2.8c0-1.713-.002-2.878-.075-3.778-.072-.877-.202-1.325-.361-1.638a4 4 0 0 0-1.748-1.748c-.313-.16-.761-.29-1.638-.36C18.278 5.001 17.113 5 15.4 5ZM3.654 6.276C3 7.56 3 9.24 3 12.6v2.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C7.559 25 9.24 25 12.6 25h2.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C25 20.44 25 18.76 25 15.4v-2.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C20.44 3 18.76 3 15.4 3h-2.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622Z",
    fill: "#023F80"
  })), _path2$w || (_path2$w = /*#__PURE__*/createElement$2("path", {
    d: "M10.5 19a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM10.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM10.5 14a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM20.5 14a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM20.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM20.5 19a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
    fill: "#023F80"
  })));
};

var _path$1Y, _path2$x;
function _extends$1_() { _extends$1_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1_.apply(this, arguments); }
var SvgDiscountOutline = function SvgDiscountOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1_({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1Y || (_path$1Y = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.713 3.072a3.18 3.18 0 0 1 4.574 0l.225.233c.3.31.725.464 1.153.42l.302-.032a3.2 3.2 0 0 1 3.525 2.958l.022.303c.03.43.256.821.613 1.062l.252.17a3.2 3.2 0 0 1 .799 4.533l-.178.245a1.4 1.4 0 0 0-.213 1.208l.083.292a3.2 3.2 0 0 1-2.301 3.986l-.295.073a1.4 1.4 0 0 0-.94.789l-.123.277a3.2 3.2 0 0 1-4.325 1.574l-.272-.133a1.4 1.4 0 0 0-1.227 0l-.273.133a3.2 3.2 0 0 1-4.325-1.574l-.123-.277a1.4 1.4 0 0 0-.94-.789l-.295-.073a3.2 3.2 0 0 1-2.3-3.986l.083-.292A1.4 1.4 0 0 0 3 12.964l-.179-.245a3.2 3.2 0 0 1 .8-4.533l.251-.17a1.4 1.4 0 0 0 .613-1.062l.022-.303a3.2 3.2 0 0 1 3.525-2.958l.302.031a1.4 1.4 0 0 0 1.153-.42l.225-.232Zm3.28 1.25a1.38 1.38 0 0 0-1.985 0l-.226.233a3.2 3.2 0 0 1-2.634.96l-.302-.032a1.4 1.4 0 0 0-1.543 1.294l-.021.303A3.2 3.2 0 0 1 4.88 9.508l-.251.17a1.4 1.4 0 0 0-.35 1.983l.178.245a3.2 3.2 0 0 1 .487 2.762l-.083.292a1.4 1.4 0 0 0 1.006 1.743l.295.074a3.2 3.2 0 0 1 2.148 1.802l.123.277a1.4 1.4 0 0 0 1.892.69l.273-.134a3.2 3.2 0 0 1 2.804 0l.273.133a1.4 1.4 0 0 0 1.892-.689l.123-.277a3.2 3.2 0 0 1 2.149-1.802l.294-.074a1.4 1.4 0 0 0 1.007-1.743l-.084-.292a3.2 3.2 0 0 1 .487-2.762l.178-.245a1.4 1.4 0 0 0-.35-1.983l-.25-.17a3.2 3.2 0 0 1-1.403-2.428l-.021-.303a1.4 1.4 0 0 0-1.543-1.294l-.301.031a3.2 3.2 0 0 1-2.635-.959l-.226-.233Z",
    fill: "#023F80"
  })), _path2$x || (_path2$x = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45 10.225v-.55a.375.375 0 0 0-.75 0v.55a.375.375 0 0 0 .75 0ZM9.075 8C8.15 8 7.4 8.75 7.4 9.675v.55a1.675 1.675 0 1 0 3.35 0v-.55C10.75 8.75 10 8 9.075 8ZM15.3 14.324v-.55a.375.375 0 0 0-.75 0v.55a.375.375 0 0 0 .75 0Zm-.375-2.225c-.925 0-1.675.75-1.675 1.675v.55a1.675 1.675 0 0 0 3.35 0v-.55c0-.925-.75-1.675-1.675-1.675ZM14.621 8.086a.675.675 0 0 1 .194.935l-4.4 6.7a.675.675 0 1 1-1.13-.742l4.401-6.7a.675.675 0 0 1 .935-.193Z",
    fill: "#023F80"
  })));
};

var _path$1Z;
function _extends$1$() { _extends$1$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$.apply(this, arguments); }
var SvgDocumentOutline = function SvgDocumentOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$1$({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1Z || (_path$1Z = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1 3.9h-2.5c-.995 0-1.687 0-2.226.045-.528.043-.828.123-1.054.238A2.6 2.6 0 0 0 6.183 5.32c-.115.226-.195.526-.238 1.054C5.9 6.913 5.9 7.605 5.9 8.6v6.8c0 .995 0 1.687.045 2.225.043.528.123.829.238 1.055a2.6 2.6 0 0 0 1.137 1.137c.226.115.526.195 1.054.238.539.044 1.231.045 2.226.045h3.8c.995 0 1.687 0 2.225-.045.529-.043.829-.123 1.055-.238a2.6 2.6 0 0 0 1.137-1.137c.115-.226.195-.527.238-1.055.044-.538.045-1.23.045-2.225V9.9H17.165c-.53 0-.982 0-1.352-.03-.39-.032-.768-.102-1.13-.286a2.9 2.9 0 0 1-1.267-1.267c-.184-.362-.254-.741-.286-1.13-.03-.37-.03-.822-.03-1.352V3.9Zm5.227 4.2L14.9 4.673V5.8c0 .575 0 .952.024 1.24.023.278.062.393.096.46a1.1 1.1 0 0 0 .48.48c.066.034.182.073.46.096.288.023.665.024 1.24.024h1.127ZM14.44 2.166c-.28-.067-.566-.066-.866-.066h-3.011c-.948 0-1.714 0-2.334.05-.64.053-1.203.163-1.726.43A4.4 4.4 0 0 0 4.58 4.502c-.267.523-.377 1.087-.43 1.726-.05.62-.05 1.386-.05 2.334v6.876c0 .948 0 1.714.05 2.334.053.64.163 1.203.43 1.726a4.4 4.4 0 0 0 1.922 1.922c.523.267 1.087.377 1.726.43.62.05 1.386.05 2.334.05H14.438c.948 0 1.714 0 2.334-.05.64-.053 1.203-.163 1.726-.43a4.4 4.4 0 0 0 1.922-1.923c.267-.522.377-1.086.43-1.725.05-.62.05-1.386.05-2.334V9.427c0-.3 0-.587-.066-.866a2.4 2.4 0 0 0-.288-.694c-.15-.245-.353-.447-.565-.659l-.048-.047-4.094-4.094-.047-.048c-.212-.212-.414-.415-.66-.565a2.4 2.4 0 0 0-.693-.288Z",
    fill: "#023F80"
  })));
};

var _path$1_, _path2$y, _path3$b;
function _extends$20() { _extends$20 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$20.apply(this, arguments); }
var SvgDollarCircleOutline = function SvgDollarCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$20({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1_ || (_path$1_ = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5a9.872 9.872 0 0 1 7-2.9c2.734 0 5.21 1.11 7 2.9a9.872 9.872 0 0 1 2.9 7c0 2.733-1.109 5.21-2.9 7a9.872 9.872 0 0 1-7 2.9A9.872 9.872 0 0 1 5 19a9.872 9.872 0 0 1-2.9-7c0-2.734 1.11-5.21 2.9-7Zm7-1.1c-2.237 0-4.26.906-5.727 2.372A8.072 8.072 0 0 0 3.9 12c0 2.237.906 4.26 2.373 5.727A8.072 8.072 0 0 0 12 20.1c2.237 0 4.26-.906 5.728-2.373A8.072 8.072 0 0 0 20.1 12c0-2.237-.905-4.26-2.372-5.728A8.072 8.072 0 0 0 12 3.9Z",
    fill: "#023F80"
  })), _path2$y || (_path2$y = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.748 7.768c.626-.463 1.418-.668 2.18-.668 1.252 0 2.61.543 3.087 1.8a.9.9 0 1 1-1.683.639c-.103-.273-.538-.639-1.404-.639-.463 0-.856.128-1.11.315a.839.839 0 0 0-.36.722c0 .196.042.308.084.38.046.075.124.159.267.249.323.203.792.335 1.45.51l.055.014c.573.152 1.312.347 1.898.722.321.204.628.48.851.86.226.384.337.824.337 1.309 0 1.033-.52 1.802-1.232 2.277-.68.454-1.526.642-2.301.642-1.264 0-2.432-.449-3.109-1.434a.9.9 0 1 1 1.484-1.019c.243.354.756.653 1.625.653.516 0 .988-.13 1.301-.34.282-.187.432-.428.432-.78a.753.753 0 0 0-.088-.395.786.786 0 0 0-.269-.257c-.321-.205-.79-.339-1.445-.513l-.071-.018c-.569-.15-1.298-.344-1.877-.708a2.56 2.56 0 0 1-.853-.85 2.5 2.5 0 0 1-.34-1.302c0-.943.44-1.687 1.09-2.169Z",
    fill: "#023F80"
  })), _path3$b || (_path3$b = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.6a.9.9 0 0 1 .9.9v1a.9.9 0 1 1-1.8 0v-1a.9.9 0 0 1 .9-.9ZM12 15.6a.9.9 0 0 1 .9.9v1a.9.9 0 0 1-1.8 0v-1a.9.9 0 0 1 .9-.9Z",
    fill: "#023F80"
  })));
};

var _path$1$, _path2$z;
function _extends$21() { _extends$21 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$21.apply(this, arguments); }
var SvgDonateOutline = function SvgDonateOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$21({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1$ || (_path$1$ = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.793 8.115a2 2 0 0 0-3.586 0l-1.005 2.034-2.245.327a2 2 0 0 0-1.108 3.411l1.624 1.584-.383 2.236a2 2 0 0 0 2.902 2.108L14 18.76l2.008 1.055a2 2 0 0 0 2.902-2.108l-.383-2.236 1.624-1.584a2 2 0 0 0-1.108-3.411l-2.245-.327-1.004-2.034Zm-3.262 3.862L14 9l1.47 2.977 3.285.478-2.377 2.318.56 3.272L14 16.5l-2.939 1.545.561-3.273-2.377-2.317 3.286-.478Z",
    fill: "#023F80"
  })), _path2$z || (_path2$z = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2C7.373 2 2 7.373 2 14s5.373 12 12 12 12-5.373 12-12S20.627 2 14 2ZM4 14C4 8.477 8.477 4 14 4s10 4.477 10 10-4.477 10-10 10S4 19.523 4 14Z",
    fill: "#023F80"
  })));
};

var _path$20;
function _extends$22() { _extends$22 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$22.apply(this, arguments); }
var SvgDoneOutline = function SvgDoneOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$22({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$20 || (_path$20 = /*#__PURE__*/createElement$2("path", {
    d: "m11 18.586-5.293-5.293a1 1 0 0 0-1.414 1.414l6 6a1 1 0 0 0 1.414 0l12-12a1 1 0 0 0-1.414-1.414L11 18.586Z",
    fill: "#023F80"
  })));
};

var _path$21;
function _extends$23() { _extends$23 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$23.apply(this, arguments); }
var SvgDoorArrowLeftOutline = function SvgDoorArrowLeftOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$23({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$21 || (_path$21 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.643 25H15a1 1 0 1 1 0-2h2.6c1.137 0 1.929 0 2.546-.051.605-.05.953-.142 1.216-.276a3 3 0 0 0 1.311-1.311c.134-.263.226-.611.276-1.216.05-.617.051-1.41.051-2.546v-7.2c0-1.137 0-1.929-.051-2.546-.05-.605-.142-.953-.276-1.216a3 3 0 0 0-1.311-1.311c-.263-.134-.611-.226-1.216-.276C19.529 5.001 18.736 5 17.6 5H15a1 1 0 1 1 0-2h2.643c1.084 0 1.958 0 2.666.058.729.06 1.369.185 1.961.487a5 5 0 0 1 2.185 2.185c.302.592.428 1.233.487 1.961C25 8.4 25 9.273 25 10.357v7.286c0 1.084 0 1.958-.058 2.666-.06.729-.185 1.369-.487 1.961a5 5 0 0 1-2.185 2.185c-.592.302-1.232.428-1.961.487C19.6 25 18.727 25 17.643 25ZM3 14a1 1 0 0 1 1-1h9.586l-2.293-2.293a1 1 0 0 1 1.414-1.414l4 4 .007.007a.996.996 0 0 1 .286.697v.006c0 .272-.11.518-.286.697l-.008.008-3.999 4a1 1 0 0 1-1.414-1.415L13.586 15H4a1 1 0 0 1-1-1Z",
    fill: "#023F80"
  })));
};

var _path$22;
function _extends$24() { _extends$24 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$24.apply(this, arguments); }
var SvgDoorArrowRightOutline = function SvgDoorArrowRightOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$24({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$22 || (_path$22 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.357 3H13a1 1 0 1 1 0 2h-2.6c-1.137 0-1.929 0-2.546.051-.605.05-.953.142-1.216.276a3 3 0 0 0-1.311 1.311c-.134.263-.226.611-.276 1.216C5.001 8.471 5 9.264 5 10.4v7.2c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051H13a1 1 0 1 1 0 2h-2.643c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.96-.487a5 5 0 0 1-2.186-2.185c-.302-.592-.428-1.232-.487-1.961C3 19.6 3 18.727 3 17.643v-7.286c0-1.084 0-1.958.058-2.666.06-.728.185-1.369.487-1.96A5 5 0 0 1 5.73 3.544c.592-.302 1.233-.428 1.961-.487C8.4 3 9.273 3 10.357 3Zm8.936 6.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L21.586 15H12a1 1 0 1 1 0-2h9.586l-2.293-2.293a1 1 0 0 1 0-1.414Z",
    fill: "#023F80"
  })));
};

var _path$23, _path2$A;
function _extends$25() { _extends$25 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$25.apply(this, arguments); }
var SvgDownloadCancelOutline = function SvgDownloadCancelOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$25({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$23 || (_path$23 = /*#__PURE__*/createElement$2("path", {
    d: "M21 22a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2h14ZM14 2a1 1 0 0 1 1 1v13.585l2.293-2.292a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-7-7a1 1 0 1 1 1.414-1.414L13 16.585V3a1 1 0 0 1 1-1Z",
    fill: "#023F80"
  })), _path2$A || (_path2$A = /*#__PURE__*/createElement$2("path", {
    d: "M18.535 4.536a5 5 0 1 1 7.072 7.07 5 5 0 0 1-7.072-7.07Zm1.179 1.178a.834.834 0 0 0-.065 1.106l.065.073 1.179 1.178-1.179 1.179a.833.833 0 0 0 1.106 1.243l.073-.065L22.07 9.25l1.179 1.178a.833.833 0 0 0 1.243-1.106l-.065-.072L23.25 8.07l1.178-1.178a.833.833 0 0 0-1.106-1.244l-.072.065-1.179 1.179-1.178-1.179a.833.833 0 0 0-1.179 0Z",
    fill: "#023F80"
  })));
};

var _path$24, _path2$B;
function _extends$26() { _extends$26 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$26.apply(this, arguments); }
var SvgDownloadCheckOutline = function SvgDownloadCheckOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$26({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$24 || (_path$24 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2a.9.9 0 0 1 .9.9v10.927l.827-.827A.9.9 0 1 1 15 14.273l-2.364 2.363a.9.9 0 0 1-1.272 0l-6.1-6.1a.9.9 0 0 1 1.272-1.272l4.564 4.563V2.9A.9.9 0 0 1 12 2ZM4 20a.9.9 0 0 1 .9-.9h14.2a.9.9 0 1 1 0 1.8H4.9A.9.9 0 0 1 4 20Z",
    fill: "#023F80"
  })), _path2$B || (_path2$B = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm2.78 3.22a.75.75 0 0 0-1.06 0l-2.47 2.47-.97-.97a.75.75 0 1 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0 0-1.06Z",
    fill: "#023F80"
  })));
};

var _path$25, _path2$C;
function _extends$27() { _extends$27 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$27.apply(this, arguments); }
var SvgDownloadCloudOutline = function SvgDownloadCloudOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$27({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$25 || (_path$25 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 11a1 1 0 0 1 1 1v10.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L13 22.586V12a1 1 0 0 1 1-1Z",
    fill: "#023F80"
  })), _path2$C || (_path2$C = /*#__PURE__*/createElement$2("path", {
    d: "M16.083 3c-1.712 0-3.32.662-4.506 1.81-1.474-.41-2.992-.039-4.123.781-1.125.815-1.939 2.125-1.954 3.651-1.503.793-2.5 2.346-2.5 4.102 0 2.61 2.213 4.583 4.706 4.656H10a1 1 0 1 0 0-2H7.75C6.217 15.948 5 14.744 5 13.344c0-1.132.745-2.148 1.863-2.515a1 1 0 0 0 .673-1.12c-.17-.994.285-1.915 1.091-2.498.81-.587 1.877-.76 2.81-.326a1 1 0 0 0 1.194-.272A4.453 4.453 0 0 1 16.083 5c2.621 0 4.676 2.309 4.389 4.769a1 1 0 0 0 .677 1.064c1.111.37 1.851 1.383 1.851 2.51 0 1.399-1.135 2.587-2.62 2.654H18a1 1 0 1 0 0 2l2.472-.002C22.98 17.882 25 15.855 25 13.344c0-1.756-.997-3.31-2.501-4.102C22.467 5.864 19.592 3 16.083 3Z",
    fill: "#023F80"
  })));
};

var _path$26;
function _extends$28() { _extends$28 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$28.apply(this, arguments); }
var SvgDownloadOutline = function SvgDownloadOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$28({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$26 || (_path$26 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2a.9.9 0 0 1 .9.9v10.927l4.564-4.563a.9.9 0 0 1 1.272 1.272l-6.1 6.1a.9.9 0 0 1-1.272 0l-6.1-6.1a.9.9 0 0 1 1.272-1.272l4.564 4.563V2.9A.9.9 0 0 1 12 2ZM4 20a.9.9 0 0 1 .9-.9h14.2a.9.9 0 1 1 0 1.8H4.9A.9.9 0 0 1 4 20Z",
    fill: "#023F80"
  })));
};

var _path$27;
function _extends$29() { _extends$29 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$29.apply(this, arguments); }
var SvgDraggableDots = function SvgDraggableDots(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$29({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$27 || (_path$27 = /*#__PURE__*/createElement$2("path", {
    d: "M4.962 6.942c-.366.08-.651.232-.939.501a1.983 1.983 0 0 0-.392 2.374c.142.267.541.667.79.793a2.124 2.124 0 0 0 1.551.15c.308-.096.69-.34.892-.573.218-.25.419-.699.469-1.048.146-1.017-.542-1.984-1.568-2.201-.323-.069-.469-.068-.803.004m7 0c-.366.08-.651.232-.939.501a1.983 1.983 0 0 0-.392 2.374c.142.267.541.667.79.793a2.124 2.124 0 0 0 1.551.15c.308-.096.69-.34.892-.573.218-.25.419-.699.469-1.048.146-1.017-.542-1.984-1.568-2.201-.323-.069-.469-.068-.803.004m7 0c-.366.08-.651.232-.939.501a1.983 1.983 0 0 0-.392 2.374c.142.267.541.667.79.793a2.124 2.124 0 0 0 1.551.15c.308-.096.69-.34.892-.573.218-.25.419-.699.469-1.048.146-1.017-.542-1.984-1.568-2.201-.323-.069-.469-.068-.803.004m-14 7c-.366.08-.651.232-.939.501a1.983 1.983 0 0 0-.392 2.374c.142.267.541.667.79.793a2.124 2.124 0 0 0 1.551.15c.308-.096.69-.34.892-.573.218-.25.419-.699.469-1.048.146-1.017-.542-1.984-1.568-2.201-.323-.069-.469-.068-.803.004m7 0c-.366.08-.651.232-.939.501a1.983 1.983 0 0 0-.392 2.374c.142.267.541.667.79.793a2.124 2.124 0 0 0 1.551.15c.308-.096.69-.34.892-.573.218-.25.419-.699.469-1.048.146-1.017-.542-1.984-1.568-2.201-.323-.069-.469-.068-.803.004m7 0c-.366.08-.651.232-.939.501a1.983 1.983 0 0 0-.392 2.374c.142.267.541.667.79.793a2.124 2.124 0 0 0 1.551.15c.308-.096.69-.34.892-.573.218-.25.419-.699.469-1.048.146-1.017-.542-1.984-1.568-2.201-.323-.069-.469-.068-.803.004",
    fill: "#000",
    fillRule: "evenodd"
  })));
};

var _path$28;
function _extends$2a() { _extends$2a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2a.apply(this, arguments); }
var SvgDrillOutline = function SvgDrillOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2a({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$28 || (_path$28 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2 4.9c.505 0 .83 0 1.076.02.236.02.32.053.36.073a.85.85 0 0 1 .372.371c.02.04.052.124.071.36.02.247.021.571.021 1.076v1.4c0 .505 0 .83-.02 1.076-.02.236-.053.32-.072.36a.85.85 0 0 1-.372.371c-.04.02-.124.053-.36.072-.246.02-.571.021-1.076.021H7.5a2.6 2.6 0 0 1 0-5.2h6.7Zm2.253-1.511c-.335-.171-.683-.234-1.03-.262a15.672 15.672 0 0 0-1.188-.027H7.5a4.4 4.4 0 0 0-.584 8.761L5.508 19.1H4a.9.9 0 1 0 0 1.8h11a.9.9 0 0 0 0-1.8h-3.658l1.4-7.2H14.235c.46 0 .859 0 1.188-.027.347-.028.695-.091 1.03-.262a2.65 2.65 0 0 0 1.184-1.211H18a2.901 2.901 0 0 0 2.758-2H22.1a.9.9 0 1 0 0-1.8h-1.342A2.901 2.901 0 0 0 18 4.6h-.363a2.65 2.65 0 0 0-1.184-1.211ZM19.1 7.5A1.1 1.1 0 0 0 18 6.4h-.1V8.6h.1a1.1 1.1 0 0 0 1.1-1.1Zm-8.192 4.4H8.742l-1.4 7.2h2.166l1.4-7.2Z",
    fill: "#023F80"
  })));
};

var _path$29;
function _extends$2b() { _extends$2b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2b.apply(this, arguments); }
var SvgEditOutline = function SvgEditOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2b({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$29 || (_path$29 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.782 3.335a3 3 0 0 0-2.724 0c-.428.218-.8.591-1.23 1.023L4.677 17.508c-.354.355-.609.609-.818.897a4.5 4.5 0 0 0-.804 1.94C3 20.698 3 21.058 3 21.558V22.681c-.001.282-.002.628.098.937a2 2 0 0 0 1.284 1.284c.309.1.655.1.937.098H6.443c.5 0 .86 0 1.211-.055a4.5 4.5 0 0 0 1.941-.804c.288-.21.542-.464.896-.818l13.151-13.15c.432-.431.805-.803 1.023-1.231a3 3 0 0 0 0-2.724c-.218-.428-.591-.8-1.023-1.23l-.63-.63c-.43-.432-.802-.805-1.23-1.023Zm-1.816 1.782a1 1 0 0 1 .908 0c.106.054.237.168.819.75l.44.44c.582.582.696.713.75.819a1 1 0 0 1 0 .908c-.054.106-.168.237-.75.819l-.858.858-2.986-2.986.858-.858c.582-.582.713-.696.82-.75ZM16.875 8.14 6.142 18.872c-.425.425-.56.564-.665.708a2.5 2.5 0 0 0-.446 1.079c-.028.176-.03.369-.03.97v.971c-.001.197 0 .305.004.383v.012h.012c.078.005.186.005.383.005h.97c.602 0 .795-.003.971-.03a2.5 2.5 0 0 0 1.079-.447c.144-.105.283-.24.708-.665l10.733-10.733-2.986-2.986Z",
    fill: "#023F80"
  })));
};

var _path$2a, _path2$D, _path3$c;
function _extends$2c() { _extends$2c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2c.apply(this, arguments); }
var SvgEducationOutline = function SvgEducationOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2c({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2a || (_path$2a = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.962 8.896 6.455-3.674a3.2 3.2 0 0 1 3.166 0l6.455 3.674c.032.018.041.033.046.04a.131.131 0 0 1 .014.064c0 .028-.007.05-.014.063-.005.008-.014.023-.046.041l-6.455 3.674a3.2 3.2 0 0 1-3.166 0L3.962 9.104c-.033-.018-.042-.033-.046-.04A.132.132 0 0 1 3.902 9c0-.029.007-.05.014-.063.004-.008.013-.023.046-.041Zm-.89 1.773c-1.294-.737-1.294-2.601 0-3.338l6.455-3.674a5 5 0 0 1 4.946 0l6.455 3.674c.646.368.97 1.017.97 1.667L21.9 9v4.1a.9.9 0 0 1-1.8 0v-1.96l-5.627 3.202a5 5 0 0 1-4.946 0L3.072 10.67Z",
    fill: "#023F80"
  })), _path2$D || (_path2$D = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2 11.1v2.008c0 1.415 0 2.422-.065 3.211-.064.778-.185 1.264-.382 1.65a4.1 4.1 0 0 1-1.792 1.793c-.386.197-.872.318-1.65.381-.38.031-.81.047-1.311.056v1.8a22.775 22.775 0 0 0 1.457-.062c.89-.072 1.639-.224 2.322-.572a5.901 5.901 0 0 0 2.578-2.578c.348-.683.5-1.432.572-2.321.071-.87.071-1.951.071-3.318V11.1h-1.8Z",
    fill: "#023F80"
  })), _path3$c || (_path3$c = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9 11.1v2.01c0 1.415 0 2.422.065 3.21.064.779.185 1.265.382 1.651a4.1 4.1 0 0 0 1.792 1.792c.386.197.872.318 1.65.382.354.029.752.045 1.211.054v1.8c-.503-.01-.953-.027-1.357-.06-.89-.073-1.639-.224-2.321-.572a5.9 5.9 0 0 1-2.579-2.579c-.348-.682-.5-1.431-.572-2.32-.07-.871-.07-1.952-.07-3.318V11.1h1.8Z",
    fill: "#023F80"
  })));
};

var _path$2b;
function _extends$2d() { _extends$2d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2d.apply(this, arguments); }
var SvgEmblemOutline = function SvgEmblemOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2d({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2b || (_path$2b = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2h20v12.044c0 1.363 0 2.447-.071 3.321-.074.896-.227 1.66-.583 2.359a6 6 0 0 1-2.622 2.622c-.7.356-1.463.51-2.359.583l-.174.013a1.005 1.005 0 0 1-.191.018c-.969 0-1.764.395-2.342.823a4.988 4.988 0 0 0-.816.765l-.035.042-.004.006a1 1 0 0 1-1.606 0l-.004-.006a3.812 3.812 0 0 0-.195-.224 4.988 4.988 0 0 0-.656-.583c-.578-.428-1.373-.823-2.342-.823-.065 0-.13-.006-.191-.018a16.014 16.014 0 0 1-.174-.013c-.896-.074-1.66-.227-2.359-.583a6 6 0 0 1-2.622-2.622c-.356-.7-.51-1.463-.583-2.359C4 16.491 4 15.407 4 14.044V2Zm6.5 18.982c1.295.117 2.325.67 3.033 1.195.173.128.329.256.467.378.138-.122.294-.25.467-.378.708-.526 1.738-1.078 3.033-1.195v-.007c.254-.01.486-.022.703-.04.771-.063 1.243-.182 1.613-.371a4 4 0 0 0 1.748-1.748c.189-.37.308-.841.371-1.613C22 16.419 22 15.417 22 14V4H6v10c0 1.417 0 2.419.065 3.203.063.771.182 1.243.371 1.613a4 4 0 0 0 1.748 1.748c.37.189.842.308 1.613.371.217.018.45.03.703.04v.007Z",
    fill: "#023F80"
  })));
};

var _path$2c;
function _extends$2e() { _extends$2e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2e.apply(this, arguments); }
var SvgEmployeeOutline = function SvgEmployeeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2e({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2c || (_path$2c = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9 2a.9.9 0 0 0-1.8 0v.175A5.404 5.404 0 0 0 6.66 6.7l-.07-.011a16.924 16.924 0 0 1-.391-.068l-.018-.004h-.003a.9.9 0 0 0-.353 1.764h.001l.002.001.008.002.025.005a10.747 10.747 0 0 0 .441.076c.26.043.618.096 1.06.151A4.649 4.649 0 0 0 12 13.6a4.649 4.649 0 0 0 4.64-4.983 29.056 29.056 0 0 0 1.501-.227l.026-.005.007-.002h.003a.9.9 0 0 0-.352-1.766l-.004.001-.018.004a16.828 16.828 0 0 1-.392.068l-.069.01a5.404 5.404 0 0 0-4.44-4.525V2Zm-1.8 2.013a.9.9 0 0 0 1.8 0 3.604 3.604 0 0 1 2.655 2.913 36.653 36.653 0 0 1-7.11 0A3.604 3.604 0 0 1 11.1 4.013ZM9.154 8.794a2.849 2.849 0 1 0 5.692 0 38.513 38.513 0 0 1-5.692 0ZM5.928 20.081c-.04-.035-.038-.12-.033-.316.002-.088.005-.198.005-.337 0-1.892 2.778-3.028 6.1-3.028 3.322 0 6.1 1.136 6.1 3.029 0 .138.003.248.005.336.006.197.008.28-.033.316-.03.026-.084.024-.18.021l-.127-.002H6.235l-.127.002c-.095.003-.15.005-.18-.021ZM12 14.6c-4.227 0-7.9 1.502-7.9 4.829 0 1.735.686 2.471 2.135 2.471h11.53c1.45 0 2.135-.736 2.135-2.471 0-3.327-3.673-4.829-7.9-4.829Z",
    fill: "#023F80"
  })));
};

var _path$2d;
function _extends$2f() { _extends$2f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2f.apply(this, arguments); }
var SvgErrorCircleOutline = function SvgErrorCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2f({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2d || (_path$2d = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9 12a8.1 8.1 0 1 1 16.2 0 8.1 8.1 0 0 1-16.2 0ZM12 2.1c-5.468 0-9.9 4.432-9.9 9.9s4.432 9.9 9.9 9.9 9.9-4.432 9.9-9.9-4.432-9.9-9.9-9.9Zm.9 5.8a.9.9 0 0 0-1.8 0v5.2a.9.9 0 1 0 1.8 0V7.9ZM13 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: "#023F80"
  })));
};

var _path$2e, _path2$E;
function _extends$2g() { _extends$2g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2g.apply(this, arguments); }
var SvgExplicitOutline = function SvgExplicitOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2g({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2e || (_path$2e = /*#__PURE__*/createElement$2("path", {
    d: "M18 8h-8v12h8v-2h-6v-3h5v-2h-5v-3h6V8Z",
    fill: "#023F80"
  })), _path2$E || (_path2$E = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.643 3h-7.286C9.273 3 8.4 3 7.691 3.058c-.728.06-1.369.185-1.96.487A5 5 0 0 0 3.544 5.73c-.302.592-.428 1.233-.487 1.961C3 8.4 3 9.273 3 10.357v7.286c0 1.084 0 1.958.058 2.666.06.729.185 1.369.487 1.961a5 5 0 0 0 2.185 2.185c.592.302 1.233.428 1.961.487C8.4 25 9.273 25 10.357 25h7.286c1.084 0 1.958 0 2.666-.058.729-.06 1.369-.185 1.961-.487a5 5 0 0 0 2.185-2.185c.302-.592.428-1.232.487-1.961C25 19.6 25 18.727 25 17.643v-7.286c0-1.084 0-1.958-.058-2.666-.06-.728-.185-1.369-.487-1.96a5 5 0 0 0-2.185-2.186c-.592-.302-1.232-.428-1.961-.487C19.6 3 18.727 3 17.643 3ZM6.638 5.327c.263-.134.611-.226 1.216-.276C8.471 5.001 9.264 5 10.4 5h7.2c1.137 0 1.929 0 2.546.051.605.05.953.142 1.216.276a3 3 0 0 1 1.311 1.311c.134.263.226.611.276 1.216.05.617.051 1.41.051 2.546v7.2c0 1.137 0 1.929-.051 2.546-.05.605-.142.953-.276 1.216a3 3 0 0 1-1.311 1.311c-.263.134-.611.226-1.216.276-.617.05-1.41.051-2.546.051h-7.2c-1.137 0-1.929 0-2.546-.051-.605-.05-.953-.142-1.216-.276a3 3 0 0 1-1.311-1.311c-.134-.263-.226-.611-.276-1.216C5.001 19.529 5 18.736 5 17.6v-7.2c0-1.137 0-1.929.051-2.546.05-.605.142-.953.276-1.216a3 3 0 0 1 1.311-1.311Z",
    fill: "#023F80"
  })));
};

var _path$2f, _path2$F;
function _extends$2h() { _extends$2h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2h.apply(this, arguments); }
var SvgExternalLinkOutline = function SvgExternalLinkOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2h({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2f || (_path$2f = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.146 3.634C5.91 3.227 6.658 3.1 8.228 3.1H10.1a.9.9 0 0 1 0 1.8H8.228c-1.487 0-1.87.128-2.233.321-.336.18-.594.438-.773.774-.194.362-.322.746-.322 2.233v7.544c0 1.487.128 1.87.322 2.233.18.336.437.594.773.773.362.194.746.322 2.233.322h7.544c1.487 0 1.87-.128 2.233-.322.336-.18.594-.437.774-.773.193-.362.321-.746.321-2.233V13.9a.9.9 0 1 1 1.8 0v1.872c0 1.57-.127 2.32-.534 3.082a3.647 3.647 0 0 1-1.512 1.512c-.762.407-1.512.534-3.082.534H8.228c-1.57 0-2.32-.127-3.082-.534a3.647 3.647 0 0 1-1.512-1.512c-.407-.762-.534-1.512-.534-3.082V8.228c0-1.57.127-2.32.534-3.082a3.647 3.647 0 0 1 1.512-1.512Z",
    fill: "#023F80"
  })), _path2$F || (_path2$F = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4a.9.9 0 0 1 .9-.9H20a.9.9 0 0 1 .9.9v5.1a.9.9 0 1 1-1.8 0V6.173l-6.564 6.563a.9.9 0 0 1-1.272-1.272L17.827 4.9H14.9A.9.9 0 0 1 14 4Z",
    fill: "#023F80"
  })));
};

var _path$2g;
function _extends$2i() { _extends$2i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2i.apply(this, arguments); }
var SvgFaceIdOutline = function SvgFaceIdOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2i({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2g || (_path$2g = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 5a1 1 0 1 1 .032-2c.681.002 1.26.011 1.748.051.646.053 1.224.165 1.763.44a4.5 4.5 0 0 1 1.966 1.966c.275.539.387 1.117.44 1.763A23.213 23.213 0 0 1 25 9a1 1 0 1 1-2 0 21.622 21.622 0 0 0-.044-1.617c-.043-.522-.122-.808-.229-1.018a2.5 2.5 0 0 0-1.092-1.093c-.21-.106-.496-.185-1.018-.228C20.198 5.01 19.684 5.002 19 5ZM5 9c.002-.684.01-1.198.044-1.617.043-.522.122-.808.228-1.018a2.5 2.5 0 0 1 1.093-1.093c.21-.106.496-.185 1.018-.228.419-.034.933-.042 1.617-.043a1 1 0 1 0-.032-2c-.681.001-1.26.01-1.748.05-.646.053-1.224.165-1.763.44A4.5 4.5 0 0 0 3.49 5.456c-.274.539-.386 1.117-.439 1.763A23.222 23.222 0 0 0 3 9a1 1 0 0 0 2 0ZM3 19.032c.002.681.011 1.26.051 1.748.053.646.165 1.224.44 1.763a4.5 4.5 0 0 0 1.966 1.966c.539.275 1.117.387 1.763.44A23.21 23.21 0 0 0 9 25a1 1 0 1 0 0-2 21.622 21.622 0 0 1-1.617-.044c-.522-.043-.808-.122-1.018-.229a2.5 2.5 0 0 1-1.093-1.092c-.106-.21-.185-.496-.228-1.018A21.7 21.7 0 0 1 5.001 19a1 1 0 1 0-2 .032ZM23 19a1 1 0 1 1 2 .032c-.002.681-.011 1.26-.051 1.748-.053.646-.165 1.224-.44 1.763a4.5 4.5 0 0 1-1.966 1.966c-.539.275-1.117.387-1.763.44A23.21 23.21 0 0 1 19 25a1 1 0 1 1 0-2c.684-.002 1.198-.01 1.617-.044.522-.043.808-.122 1.018-.229a2.5 2.5 0 0 0 1.092-1.092c.107-.21.186-.496.229-1.018.034-.419.042-.933.044-1.617Zm-5.097-.6a1 1 0 0 1-.474 1.333 7.973 7.973 0 0 1-3.429.77 7.974 7.974 0 0 1-3.43-.77 1 1 0 0 1 .86-1.806c.777.37 1.648.577 2.57.577.922 0 1.793-.208 2.57-.577a1 1 0 0 1 1.333.474ZM18.5 9a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1-1Zm-10 1a1 1 0 0 1 2 0v1a1 1 0 1 1-2 0v-1Zm6.5 0a1 1 0 1 0-2 0v3.5a.5.5 0 0 1-.5.5 1 1 0 1 0 0 2 2.5 2.5 0 0 0 2.5-2.5V10Z",
    fill: "#023F80"
  })));
};

var _path$2h;
function _extends$2j() { _extends$2j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2j.apply(this, arguments); }
var SvgFaceRecognitionOutline = function SvgFaceRecognitionOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2j({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2h || (_path$2h = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 14c0 5.523-4.477 10-10 10S4 19.523 4 14 8.477 4 14 4s10 4.477 10 10Zm2 0c0 6.627-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2s12 5.373 12 12ZM9.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM20 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-6 2V15h-1v2h3v-3.5h-2Zm-1.655 5.622A2 2 0 0 1 12.001 18H10a4 4 0 0 0 6.903 2.752l-1.775-1.1v-.001a1.998 1.998 0 0 1-2.783-.53Z",
    fill: "#023F80"
  })));
};

var _path$2i;
function _extends$2k() { _extends$2k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2k.apply(this, arguments); }
var SvgFavorite = function SvgFavorite(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2k({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2i || (_path$2i = /*#__PURE__*/createElement$2("path", {
    d: "m17.97 9.593 5.258.505c1.83.175 2.39 1.962.978 3.136l-4.116 3.42 1.528 5.573c.502 1.83-1.055 2.938-2.614 1.837l-5.002-3.533-5 3.533c-1.554 1.097-3.117-.006-2.615-1.837l1.528-5.572-4.116-3.421c-1.419-1.179-.86-2.96.977-3.136l5.257-.505 2.316-5.34c.725-1.671 2.582-1.67 3.307 0l2.315 5.34Z",
    fill: "#023F80"
  })));
};

var _path$2j;
function _extends$2l() { _extends$2l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2l.apply(this, arguments); }
var SvgFavoriteFilled = function SvgFavoriteFilled(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2l({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2j || (_path$2j = /*#__PURE__*/createElement$2("path", {
    d: "m15.403 8.223 4.507.432c1.568.15 2.049 1.682.838 2.688l-3.528 2.932 1.31 4.777c.43 1.569-.905 2.518-2.241 1.574l-4.287-3.028-4.287 3.028c-1.33.94-2.67-.005-2.24-1.574l1.31-4.777-3.529-2.932c-1.215-1.01-.736-2.537.838-2.688L8.6 8.223l1.985-4.577c.621-1.433 2.213-1.432 2.834 0l1.984 4.577Z",
    fill: "#023F80"
  })));
};

var _path$2k;
function _extends$2m() { _extends$2m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2m.apply(this, arguments); }
var SvgFavoriteOutline = function SvgFavoriteOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2m({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2k || (_path$2k = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.554 4.694a.6.6 0 0 0-1.109 0l-1.613 3.9a.9.9 0 0 1-.774.554l-4.125.266a.6.6 0 0 0-.357 1.05l3.267 2.859a.9.9 0 0 1 .282.888l-.93 3.852a.6.6 0 0 0 .883.66l3.472-2.003a.9.9 0 0 1 .9 0l3.472 2.004a.6.6 0 0 0 .883-.661l-.93-3.852a.9.9 0 0 1 .282-.888l3.267-2.858a.6.6 0 0 0-.357-1.05l-4.125-.267a.9.9 0 0 1-.774-.554l-1.614-3.9Zm-2.772-.689c.818-1.976 3.618-1.976 4.436 0l1.4 3.383 3.565.23c2.136.138 3.037 2.792 1.426 4.201l-2.856 2.5.802 3.322c.494 2.05-1.706 3.696-3.533 2.642L12 18.539l-3.022 1.744C7.15 21.337 4.95 19.69 5.445 17.64l.802-3.322-2.856-2.5c-1.611-1.41-.71-4.063 1.426-4.201l3.566-.23 1.4-3.383Z",
    fill: "#023F80"
  })));
};

var _path$2l, _path2$G, _path3$d;
function _extends$2n() { _extends$2n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2n.apply(this, arguments); }
var SvgFilmStripAddOutline = function SvgFilmStripAddOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2n({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2l || (_path$2l = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 17a5 5 0 1 0-10 0 5 5 0 0 0 10 0Zm-5.828-2.764a.833.833 0 0 1 1.661.097v1.834h1.834l.097.005a.833.833 0 0 1-.097 1.661h-1.834v1.834l-.005.097a.833.833 0 0 1-1.661-.097v-1.834h-1.834l-.097-.005a.833.833 0 0 1 .097-1.661h1.834v-1.834l.005-.097Z",
    fill: "#023F80"
  })), _path2$G || (_path2$G = /*#__PURE__*/createElement$2("path", {
    d: "M14.538 2.1H9.461c-1.017 0-1.836 0-2.498.054-.68.056-1.275.173-1.824.453a4.65 4.65 0 0 0-2.033 2.032c-.28.549-.397 1.144-.452 1.825C2.6 7.126 2.6 7.944 2.6 8.96v6.078c0 1.017 0 1.835.054 2.497.055.681.173 1.276.452 1.825a4.65 4.65 0 0 0 2.033 2.032c.549.28 1.143.397 1.824.453.662.054 1.48.054 2.498.054h1.957a.9.9 0 0 0 0-1.8H9.5c-1.065 0-1.81 0-2.39-.048-.57-.047-.901-.134-1.154-.263a2.85 2.85 0 0 1-1.246-1.245c-.129-.253-.216-.585-.262-1.154C4.4 16.81 4.4 16.065 4.4 15V9c0-1.065 0-1.81.048-2.39.046-.57.133-.901.262-1.154A2.85 2.85 0 0 1 5.956 4.21c.253-.128.584-.216 1.154-.262.58-.047 1.325-.048 2.39-.048h5c1.065 0 1.81 0 2.39.048.569.046.9.134 1.154.262.536.274.972.71 1.245 1.246.129.253.216.584.262 1.154.048.58.049 1.325.049 2.39v.71a.9.9 0 0 0 1.8 0v-.749c0-1.017 0-1.835-.054-2.497-.056-.681-.173-1.276-.453-1.825a4.65 4.65 0 0 0-2.032-2.032c-.55-.28-1.144-.397-1.825-.453-.662-.054-1.48-.054-2.498-.054Z",
    fill: "#023F80"
  })), _path3$d || (_path3$d = /*#__PURE__*/createElement$2("path", {
    d: "M8.25 5.75h-1a.75.75 0 0 0-.75.75v1c0 .414.335.75.75.75h1A.75.75 0 0 0 9 7.5v-1a.75.75 0 0 0-.75-.75ZM8.25 10.75h-1a.75.75 0 0 0-.75.75v1c0 .414.335.75.75.75h1A.75.75 0 0 0 9 12.5v-1a.75.75 0 0 0-.75-.75ZM7.25 15.75h1a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 .75-.75ZM15.75 5.75h1a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-.75.75h-1A.75.75 0 0 1 15 7.5v-1a.75.75 0 0 1 .75-.75Z",
    fill: "#023F80"
  })));
};

var _path$2m, _path2$H;
function _extends$2o() { _extends$2o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2o.apply(this, arguments); }
var SvgFilmStripOutline = function SvgFilmStripOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2o({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2m || (_path$2m = /*#__PURE__*/createElement$2("path", {
    d: "M8.6 9c0-.372 0-.558.049-.709a1 1 0 0 1 .642-.642c.15-.049.337-.049.71-.049.371 0 .558 0 .708.049a1 1 0 0 1 .642.642c.05.15.05.337.05.709 0 .372 0 .558-.05.709a1 1 0 0 1-.642.642c-.15.049-.337.049-.709.049-.372 0-.558 0-.709-.049a1 1 0 0 1-.642-.642C8.6 9.559 8.6 9.372 8.6 9ZM16.6 9c0-.372 0-.558.049-.709a1 1 0 0 1 .642-.642c.15-.049.337-.049.71-.049.371 0 .557 0 .708.049a1 1 0 0 1 .642.642c.05.15.05.337.05.709 0 .372 0 .558-.05.709a1 1 0 0 1-.642.642c-.15.049-.337.049-.709.049-.372 0-.558 0-.709-.049a1 1 0 0 1-.642-.642C16.6 9.559 16.6 9.372 16.6 9ZM16.6 14c0-.372 0-.558.049-.709a1 1 0 0 1 .642-.642c.15-.049.337-.049.71-.049.371 0 .557 0 .708.049a1 1 0 0 1 .642.642c.05.15.05.337.05.709 0 .372 0 .558-.05.709a1 1 0 0 1-.642.642c-.15.049-.337.049-.709.049-.372 0-.558 0-.709-.049a1 1 0 0 1-.642-.642c-.049-.15-.049-.337-.049-.709ZM16.649 18.291c-.049.15-.049.337-.049.709 0 .372 0 .558.049.709a1 1 0 0 0 .642.642c.15.049.337.049.71.049.371 0 .557 0 .708-.049a1 1 0 0 0 .642-.642c.05-.15.05-.337.05-.709 0-.372 0-.558-.05-.709a1 1 0 0 0-.642-.642c-.15-.049-.337-.049-.709-.049-.372 0-.558 0-.709.049a1 1 0 0 0-.642.642ZM8.649 13.291c-.049.15-.049.337-.049.709 0 .372 0 .558.049.709a1 1 0 0 0 .642.642c.15.049.337.049.71.049.371 0 .558 0 .708-.049a1 1 0 0 0 .642-.642c.05-.15.05-.337.05-.709 0-.372 0-.558-.05-.709a1 1 0 0 0-.642-.642c-.15-.049-.337-.049-.709-.049-.372 0-.558 0-.709.049a1 1 0 0 0-.642.642ZM8.6 19c0-.372 0-.558.049-.709a1 1 0 0 1 .642-.642c.15-.049.337-.049.71-.049.371 0 .558 0 .708.049a1 1 0 0 1 .642.642c.05.15.05.337.05.709 0 .372 0 .558-.05.709a1 1 0 0 1-.642.642c-.15.049-.337.049-.709.049-.372 0-.558 0-.709-.049a1 1 0 0 1-.642-.642C8.6 19.559 8.6 19.372 8.6 19Z",
    fill: "#023F80"
  })), _path2$H || (_path2$H = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.654 6.276C4 7.56 4 9.24 4 12.6v3.8c0 3.36 0 4.04.654 5.324a6 6 0 0 0 2.622 2.622C8.56 25 10.24 25 13.6 25h.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C24 20.44 24 18.76 24 15.4v-2.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C19.44 3 17.76 3 14.4 3h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622ZM14.4 5h-.8c-1.713 0-2.878.002-3.778.075-.877.072-1.325.202-1.638.361a4 4 0 0 0-1.748 1.748c-.16.313-.29.761-.36 1.638C6.001 9.722 6 10.887 6 12.6v2.8c0 1.713.002 2.878.075 3.778.072.877.202 1.325.361 1.638a4 4 0 0 0 1.748 1.748c.313.16.761.29 1.638.36.9.074 2.065.076 3.778.076h.8c1.713 0 2.878-.002 3.778-.075.877-.072 1.325-.202 1.638-.361a4 4 0 0 0 1.748-1.748c.16-.313.29-.761.36-1.638.074-.9.076-2.065.076-3.778v-2.8c0-1.713-.002-2.878-.075-3.778-.072-.877-.202-1.325-.361-1.638a4 4 0 0 0-1.748-1.748c-.313-.16-.761-.29-1.638-.36C17.278 5.001 16.113 5 14.4 5Z",
    fill: "#023F80"
  })));
};

var _path$2n;
function _extends$2p() { _extends$2p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2p.apply(this, arguments); }
var SvgFireOutline = function SvgFireOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2p({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2n || (_path$2n = /*#__PURE__*/createElement$2("path", {
    d: "M13.71 1.534a1.375 1.375 0 0 1 1.04 1.643c-.078.342-.183.626-.336.863-2.161 3.336-1.813 5.537-.372 5.75 1.41.209 2.197-.692 1.97-2.79l-.134-1.245a1.345 1.345 0 0 1 2.078-1.265c.745.49 1.58 1.327 2.534 2.517 2.71 3.379 3.547 6.333 3.509 9.359-.071 5.636-4.273 9.634-10 9.634C8.25 26 4 21.978 4 16.347c.03-4.98 2.74-10.39 7.811-14.008.197-.14.456-.33.778-.568.321-.239.73-.325 1.12-.237Zm-2.08 3.488C7.96 8.197 6.024 12.462 6 16.353 6 20.848 9.33 24 14 24c4.647 0 7.942-3.135 7.999-7.66.032-2.593-.678-5.1-3.07-8.082a18.583 18.583 0 0 0-.894-1.042c.163 3.068-1.613 4.948-4.286 4.553-2.706-.4-3.582-3.252-2.118-6.747Z",
    fill: "#023F80"
  })));
};

var _path$2o;
function _extends$2q() { _extends$2q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2q.apply(this, arguments); }
var SvgFolderOutline = function SvgFolderOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2o || (_path$2o = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53 3.053A2.703 2.703 0 0 0 8.886 3H6.065c-.53 0-.981 0-1.352.03-.389.032-.768.102-1.13.286a2.9 2.9 0 0 0-1.267 1.267c-.184.362-.254.741-.286 1.13C2 6.083 2 6.535 2 7.065v8.87c0 .53 0 .981.03 1.352.032.39.102.768.286 1.13a2.9 2.9 0 0 0 1.267 1.267c.362.184.741.254 1.13.286.37.03.822.03 1.352.03h11.87c.53 0 .981 0 1.352-.03.389-.032.768-.102 1.13-.286a2.9 2.9 0 0 0 1.267-1.267c.184-.362.254-.74.286-1.13.03-.37.03-.822.03-1.351V9.064c0-.53 0-.981-.03-1.352-.032-.389-.102-.768-.286-1.13a2.9 2.9 0 0 0-1.268-1.267c-.361-.184-.74-.254-1.129-.286-.37-.03-.821-.03-1.351-.03H12.16c-.13 0-.197 0-.247-.002-.048-.003-.033.003-.069-.03a6.227 6.227 0 0 1-.177-.173l-1.063-1.063-.036-.036c-.135-.135-.295-.296-.49-.416a1.901 1.901 0 0 0-.55-.227ZM8.836 4.8c.13 0 .198 0 .249.003.048.002.033-.004.069.028.037.034.085.082.177.174l1.063 1.063c.164.164.328.33.527.452.17.104.355.181.549.228.226.054.459.052.69.052h5.74c.574 0 .951 0 1.24.024.277.023.392.062.458.096a1.1 1.1 0 0 1 .481.48c.034.067.073.182.096.46.023.288.024.665.024 1.24H3.8v-2c0-.575 0-.952.024-1.24.023-.278.062-.393.096-.46a1.1 1.1 0 0 1 .48-.48c.066-.034.182-.073.46-.096.288-.023.665-.024 1.24-.024h2.737ZM3.8 10.9v5c0 .575 0 .952.024 1.24.023.278.062.393.096.46a1.1 1.1 0 0 0 .48.48c.066.034.182.073.46.096.288.023.665.024 1.24.024h11.8c.575 0 .952 0 1.24-.024.278-.023.393-.062.46-.096a1.1 1.1 0 0 0 .48-.48c.034-.067.073-.182.096-.46.023-.288.024-.665.024-1.24v-5H3.8Z",
    fill: "#023F80"
  })));
};

var _path$2p;
function _extends$2r() { _extends$2r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2r.apply(this, arguments); }
var SvgFortuneWheelOutline = function SvgFortuneWheelOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2r({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2p || (_path$2p = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3 23.443A9.982 9.982 0 0 1 14 24a9.995 9.995 0 0 1-8.596-4.888l8.112-3.783 3.784 8.114Zm1.812-.847-3.783-8.112 8.114-3.784A9.982 9.982 0 0 1 24 14a9.995 9.995 0 0 1-4.888 8.596Zm3.484-13.708-8.112 3.783L10.7 4.557A9.985 9.985 0 0 1 14 4a9.995 9.995 0 0 1 8.596 4.888ZM8.888 5.404A9.995 9.995 0 0 0 4 14c0 1.156.196 2.267.557 3.3l8.114-3.784-3.783-8.112ZM26 14c0 6.627-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2s12 5.373 12 12Z",
    fill: "#023F80"
  })));
};

var _path$2q, _path2$I, _path3$e;
function _extends$2s() { _extends$2s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2s.apply(this, arguments); }
var SvgForward10Outline = function SvgForward10Outline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2s({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2q || (_path$2q = /*#__PURE__*/createElement$2("path", {
    d: "M14.707 2.293a1 1 0 1 0-1.414 1.414l1.3 1.301c-.19-.01-.4-.008-.593-.008a9.972 9.972 0 0 0-7.071 2.929A9.972 9.972 0 0 0 4 15a9.972 9.972 0 0 0 2.929 7.071A9.972 9.972 0 0 0 14 25a9.972 9.972 0 0 0 7.071-2.929A9.972 9.972 0 0 0 24 15a1 1 0 1 0-2 0c0 2.21-.894 4.208-2.343 5.657A7.972 7.972 0 0 1 14 23a7.972 7.972 0 0 1-5.657-2.343A7.972 7.972 0 0 1 6 15c0-2.21.894-4.208 2.343-5.657a7.972 7.972 0 0 1 6.222-2.323l-1.272 1.273a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3Z",
    fill: "#023F80"
  })), _path2$I || (_path2$I = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 12c1.544 0 2.754.868 2.75 3.5-.004 2.632-1.206 3.5-2.75 3.5s-2.753-.868-2.75-3.5c.003-2.632 1.206-3.5 2.75-3.5Zm0 1.53c-.772 0-1.153.506-1.153 2.036s.374 2.036 1.153 2.036 1.16-.506 1.16-2.036c0-1.531-.388-2.037-1.16-2.037Z",
    fill: "#023F80"
  })), _path3$e || (_path3$e = /*#__PURE__*/createElement$2("path", {
    d: "M10.362 18.567c0 .24.198.433.443.433h.752a.438.438 0 0 0 .443-.433v-6.062c0-.31-.323-.52-.615-.4l-2.115.966a.433.433 0 0 0-.27.4v.601c0 .244.251.412.484.323l.878-.422v4.594Z",
    fill: "#023F80"
  })));
};

var _g$2, _defs$1;
function _extends$2t() { _extends$2t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2t.apply(this, arguments); }
var SvgGameOutline = function SvgGameOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2t({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/createElement$2("g", {
    clipPath: "url(#game_outline_svg__a)"
  }, /*#__PURE__*/createElement$2("path", {
    d: "M17.123 4.2c2.904 0 4.83 1.835 5.893 4.875.71 2.032.984 4.398.984 6.74 0 3.406-.837 4.756-3.39 4.756-1.254 0-2.115-.793-3.638-2.76-1.219-1.572-1.682-2.061-1.841-2.061H8.869c-.195 0-.835.616-2.034 2.065l-.016.02C5.037 19.987 4.435 20.57 3.39 20.57c-2.553 0-3.39-1.35-3.39-4.757 0-2.341.275-4.707.984-6.739C2.046 6.035 3.973 4.2 6.877 4.2h10.246Zm0 1.8H6.877C3.269 6 1.8 10.207 1.8 15.814c0 2.54.259 2.957 1.59 2.957.192 0 .826-.614 2.042-2.084l.017-.02c1.75-2.115 2.375-2.717 3.42-2.717h6.262c1.065 0 1.4.355 3.264 2.76 1.123 1.449 1.787 2.061 2.215 2.061 1.331 0 1.59-.417 1.59-2.957C22.2 10.207 20.73 6 17.123 6ZM7.14 7.714c.317 0 .574.257.574.575v1.14h1.14c.317 0 .575.257.575.574v.566a.574.574 0 0 1-.575.574h-1.14v1.14a.574.574 0 0 1-.574.574h-.566A.574.574 0 0 1 6 12.283v-1.14H4.86a.574.574 0 0 1-.574-.575v-.565c0-.317.257-.574.574-.574H6v-1.14c0-.318.257-.575.574-.575h.566Zm10.286 3.429c.317 0 .574.257.574.574v.566a.574.574 0 0 1-.574.574h-.566a.574.574 0 0 1-.574-.574v-.566c0-.317.257-.574.574-.574h.566ZM15.71 9.429c.318 0 .575.257.575.574v.566a.574.574 0 0 1-.575.574h-.565a.574.574 0 0 1-.575-.575v-.565c0-.317.258-.574.575-.574h.565Zm3.429 0c.317 0 .574.257.574.574v.566a.574.574 0 0 1-.574.574h-.566a.574.574 0 0 1-.574-.575v-.565c0-.317.257-.574.574-.574h.566Zm-1.714-1.715c.317 0 .574.257.574.575v.565a.574.574 0 0 1-.574.575h-.566a.574.574 0 0 1-.574-.575V8.29c0-.318.257-.575.574-.575h.566Z",
    fill: "#023F80"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/createElement$2("defs", null, /*#__PURE__*/createElement$2("clipPath", {
    id: "game_outline_svg__a"
  }, /*#__PURE__*/createElement$2("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

var _path$2r, _path2$J, _path3$f;
function _extends$2u() { _extends$2u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2u.apply(this, arguments); }
var SvgGestureOutline = function SvgGestureOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2u({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2r || (_path$2r = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 17.512c0 3.585 2.91 6.49 6.5 6.49h1V26h-1c-4.694 0-8.5-3.8-8.5-8.488h2ZM16.639 4.031a1.395 1.395 0 0 0-1.667 1.068l-.994 4.632a1 1 0 0 1-1.956-.419l.995-4.632A3.395 3.395 0 0 1 19.7 5.84l-.71 5.314a1 1 0 0 1-1.982-.264l.71-5.314a1.393 1.393 0 0 0-1.08-1.544Z",
    fill: "#023F80"
  })), _path2$J || (_path2$J = /*#__PURE__*/createElement$2("path", {
    d: "M8.223 6.055a1.403 1.403 0 0 1 2.762-.462l1.045 4.173a1 1 0 0 0 1.94-.484l-1.045-4.173a3.404 3.404 0 0 0-3.302-2.575A3.402 3.402 0 0 0 6.23 6.228l.74 8.494 1.904-1.188-.652-7.479Z",
    fill: "#023F80"
  })), _path3$f || (_path3$f = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.473 14.752a1.409 1.409 0 0 0-1.47-1.099l-1.236.082A3.497 3.497 0 0 0 6.5 17.223v.289a1 1 0 0 1-2 0v-.29a5.495 5.495 0 0 1 5.134-5.48l1.236-.082a3.405 3.405 0 0 1 .787 6.755l-.493.082a1 1 0 1 1-.328-1.97l.492-.082a1.408 1.408 0 0 0 1.145-1.693ZM22 16.014a3.997 3.997 0 0 0-4-3.994v-1.997c3.314 0 6 2.682 6 5.991v.158C24 21.6 19.593 26 14.158 26H13.5v-1.997h.658c4.331 0 7.842-3.506 7.842-7.831v-.158Z",
    fill: "#023F80"
  })));
};

var _path$2s;
function _extends$2v() { _extends$2v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2v.apply(this, arguments); }
var SvgGhostOutline = function SvgGhostOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2v({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2s || (_path$2s = /*#__PURE__*/createElement$2("path", {
    d: "M12 2c2.405 0 4.391.844 6.22 2.58C19.998 6.265 21 8.568 21 10.977l-.015 7.113c-.126 1.742-1.358 3.035-3.05 3.035-.644 0-1.09-.148-1.684-.468l-.309-.163c-.182-.088-.28-.103-.428-.077-.096.016-.208.077-.399.227l-.429.356c-.816.667-1.57 1-2.686 1-1.112 0-1.877-.334-2.694-.997l-.481-.395c-.165-.127-.263-.178-.34-.191-.172-.03-.276-.005-.526.127l-.21.113c-.595.32-1.04.468-1.684.468-1.687 0-2.97-1.289-3.052-3.099L3 10.976C3 8.567 4.003 6.264 5.78 4.58 7.565 2.884 9.623 2 12 2Zm0 1.818c-1.892 0-3.507.694-4.967 2.08C5.616 7.242 4.82 9.07 4.82 10.974l.012 7.009c.038.82.54 1.324 1.233 1.324.285 0 .467-.06.82-.25l.132-.072.284-.145c.494-.23.933-.311 1.493-.215.42.072.763.251 1.142.543.121.093.502.411.517.423l.152.12c.447.334.819.47 1.395.47.64 0 1.015-.165 1.533-.588l.453-.375c.408-.322.768-.515 1.22-.593.63-.108 1.108.008 1.68.308l.37.197c.266.133.435.177.68.177.685 0 1.173-.512 1.23-1.284l.014-7.048c0-1.905-.796-3.733-2.213-5.077-1.5-1.424-3.044-2.08-4.967-2.08Zm-1.654 10.33.085.065c.072.063.237.18.468.301.9.47 1.784.47 2.67-.301a.878.878 0 0 1 1.211.062.81.81 0 0 1-.064 1.17c-1.494 1.302-3.15 1.302-4.631.528a4.258 4.258 0 0 1-.801-.528.81.81 0 0 1-.064-1.17.878.878 0 0 1 1.126-.127ZM8.5 9a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm5.796 1.102c.918-.444 1.977-.444 2.91.309a.74.74 0 0 1 .066 1.125.962.962 0 0 1-1.255.06l-.09-.066c-.264-.176-.502-.163-.787-.025-.086.042-.144.08-.157.09l-.087.063a.964.964 0 0 1-1.168-.122.74.74 0 0 1 .066-1.125c.11-.09.28-.2.502-.309Z",
    fill: "#023F80"
  })));
};

var _path$2t;
function _extends$2w() { _extends$2w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2w.apply(this, arguments); }
var SvgGhostSimleOutline = function SvgGhostSimleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2w({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2t || (_path$2t = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.595 5.086C19.357 3.008 16.935 2 14 2c-2.9 0-5.409 1.056-7.595 3.086C4.229 7.106 3 9.87 3 12.76l.016 8.532c.1 2.138 1.636 3.65 3.647 3.65.683 0 1.177-.137 1.782-.433l.493-.256c.335-.171.492-.209.743-.167.12.02.26.092.48.257l.596.48C11.746 25.607 12.663 26 14 26c1.251 0 2.123-.34 3.036-1.028l.197-.152.133-.11c.137-.111.333-.271.399-.322.251-.195.408-.277.555-.302.214-.036.36-.013.608.102l.134.065.26.138c.717.378 1.247.55 2.015.55 2.016 0 3.492-1.516 3.644-3.578l.019-8.6c0-2.893-1.23-5.657-3.405-7.677ZM7.765 6.552C9.595 4.854 11.625 4 14 4c2.416 0 4.356.807 6.234 2.552C22.006 8.197 23 10.432 23 12.76l-.016 8.528c-.075.986-.725 1.654-1.647 1.654-.334 0-.564-.062-.92-.238l-.443-.23c-.683-.35-1.245-.485-1.986-.36-.465.078-.85.26-1.266.557l-.18.135a34.34 34.34 0 0 0-.475.384l-.084.068c-.662.53-1.154.742-1.983.742-.754 0-1.241-.18-1.822-.608L12 23.256a32.002 32.002 0 0 0-.637-.511c-.452-.34-.859-.548-1.35-.63-.742-.126-1.304.008-1.987.359l-.282.148c-.454.24-.7.32-1.08.32-.93 0-1.6-.66-1.649-1.7L5 12.758c0-2.326.994-4.56 2.766-6.206ZM12.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm6 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: "#023F80"
  })));
};

var _path$2u;
function _extends$2x() { _extends$2x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2x.apply(this, arguments); }
var SvgGiftOutline = function SvgGiftOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2x({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2u || (_path$2u = /*#__PURE__*/createElement$2("path", {
    d: "M12.002 3.61c1.41-2.54 4.075-2.85 5.598-1.327 1.244 1.244 1.265 3.254-.148 4.718L18 7a4 4 0 0 1 4 4v.43c0 1.006-.14 1.546-.4 2.035a2.744 2.744 0 0 1-1.598 1.336L20 16.872c0 1.783-.186 2.43-.534 3.082a3.635 3.635 0 0 1-1.512 1.512c-.652.348-1.299.534-3.082.534H9.128c-1.783 0-2.43-.186-3.082-.534a3.635 3.635 0 0 1-1.512-1.512C4.186 19.302 4 18.655 4 16.872v-2.071a2.744 2.744 0 0 1-1.6-1.336c-.239-.448-.376-.939-.397-1.793L2 11a4 4 0 0 1 4-4l.55.001C5.139 5.537 5.16 3.527 6.404 2.283c1.525-1.524 4.192-1.213 5.6 1.326ZM11.1 15H5.799l.002 2.116c.013.672-.005 1.38.32 1.989.55 1.026 1.725 1.085 2.763 1.094H11.1V15Zm7.1 0h-5.3v5.199h2.216c1.037-.02 2.213-.067 2.762-1.094.223-.417.31-.825.321-1.99L18.2 15ZM18 8.8l-5.1.001V13.2h5.624c.545-.004 1.2-.043 1.488-.583.117-.219.176-.464.186-.998L20.2 11A2.2 2.2 0 0 0 18 8.8Zm-12 0A2.2 2.2 0 0 0 3.8 11l.002.618c.01.534.069.78.186.998.288.54.94.579 1.485.584l5.627-.001V8.801L6 8.8Zm1.676-5.244C6.606 4.625 7.6 6.632 10.85 6.975l.254.023c-.26-3.46-2.229-4.64-3.427-3.442Zm8.651 0C15.13 2.358 13.16 3.538 12.9 6.998l.255-.023c3.25-.343 4.241-2.35 3.172-3.42Z",
    fill: "#023F80"
  })));
};

var _path$2v;
function _extends$2y() { _extends$2y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2y.apply(this, arguments); }
var SvgGlobeOutline = function SvgGlobeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2y({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2v || (_path$2v = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9 12c0-.726.096-1.43.275-2.1h4.05a17.728 17.728 0 0 0 0 4.2h-4.05A8.111 8.111 0 0 1 3.9 12Zm4.632 3.9H4.899a8.119 8.119 0 0 0 4.947 3.91 19.61 19.61 0 0 1-1.314-3.91Zm5.622 3.91A8.12 8.12 0 0 0 19.1 15.9h-3.633a19.612 19.612 0 0 1-1.314 3.91Zm-.534-3.91A17.81 17.81 0 0 1 12 20.098a17.806 17.806 0 0 1-1.62-4.198h3.24Zm.34-1.8h-3.92a15.961 15.961 0 0 1 0-4.2h3.92a15.971 15.971 0 0 1 0 4.2Zm1.814 0h4.051A8.11 8.11 0 0 0 20.1 12a8.11 8.11 0 0 0-.275-2.1h-4.05a17.72 17.72 0 0 1 0 4.2Zm-.306-6h3.633a8.119 8.119 0 0 0-4.947-3.91 19.61 19.61 0 0 1 1.314 3.91ZM9.846 4.19A8.119 8.119 0 0 0 4.9 8.1h3.633a19.608 19.608 0 0 1 1.314-3.91Zm.534 3.91h3.24A17.807 17.807 0 0 0 12 3.902 17.807 17.807 0 0 0 10.38 8.1Zm1.62-6c-5.468 0-9.9 4.432-9.9 9.9s4.432 9.9 9.9 9.9 9.9-4.432 9.9-9.9-4.432-9.9-9.9-9.9Z",
    fill: "#023F80"
  })));
};

var _path$2w;
function _extends$2z() { _extends$2z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2z.apply(this, arguments); }
var SvgGooglePlayOutline = function SvgGooglePlayOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2z({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2w || (_path$2w = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 11.402c2 1.155 2 4.041 0 5.196l-15 8.66C7.5 26.413 5 24.97 5 22.66V5.34c0-2.31 2.5-3.753 4.5-2.598l15 8.66Zm-1 3.464a1 1 0 0 0 0-1.732l-3.285-1.896L17.65 14l2.565 2.762 3.285-1.896Zm-5.061 2.922-9.283 5.36 7.13-7.678 2.153 2.318Zm-2.153-5.258-7.13-7.677 9.283 5.359-2.153 2.318ZM7 5.47v17.06L14.921 14 7 5.47Z",
    fill: "#023F80"
  })));
};

var _path$2x;
function _extends$2A() { _extends$2A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2A.apply(this, arguments); }
var SvgGraphOutline = function SvgGraphOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2A({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2x || (_path$2x = /*#__PURE__*/createElement$2("path", {
    d: "M6 16a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm5-12a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1Zm5 8a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V13a1 1 0 0 1 1-1Zm5-4a1 1 0 0 1 1 1v14a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Z",
    fill: "#023F80"
  })));
};

var _path$2y;
function _extends$2B() { _extends$2B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2B.apply(this, arguments); }
var SvgGridLayoutOutline = function SvgGridLayoutOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2B({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2y || (_path$2y = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6 3H21.446c.238 0 .523 0 .774.02.29.024.706.085 1.142.307a3 3 0 0 1 1.311 1.311c.222.436.283.852.307 1.142.02.251.02.535.02.774V7.446c0 .239 0 .523-.02.774-.024.29-.085.706-.307 1.142a3 3 0 0 1-1.311 1.311 3.017 3.017 0 0 1-1.142.307c-.251.02-.535.02-.774.02H18.554c-.238 0-.523 0-.774-.02a3.016 3.016 0 0 1-1.142-.307 3 3 0 0 1-1.311-1.311 3.015 3.015 0 0 1-.307-1.142C15 7.969 15 7.685 15 7.446V6.554c0-.238 0-.523.02-.774.024-.29.085-.706.307-1.142a3 3 0 0 1 1.311-1.311 3.015 3.015 0 0 1 1.142-.307c.251-.02.535-.02.774-.02h.046Zm-1.491 2.546C17 5.76 17 6.04 17 6.6v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C17.76 9 18.04 9 18.6 9h2.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C23 8.24 23 7.96 23 7.4v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C22.24 5 21.96 5 21.4 5h-2.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437ZM9.4 17H6.554c-.238 0-.523 0-.774.02-.29.024-.706.085-1.142.307a3 3 0 0 0-1.311 1.311 3.015 3.015 0 0 0-.307 1.142c-.02.251-.02.535-.02.774V21.446c0 .238 0 .523.02.774.024.29.085.706.307 1.142a3 3 0 0 0 1.311 1.311c.436.222.852.283 1.142.307.251.02.535.02.774.02H9.446c.239 0 .523 0 .774-.02.29-.024.706-.085 1.142-.307a3 3 0 0 0 1.311-1.311c.222-.436.283-.852.307-1.142.02-.251.02-.535.02-.774V20.554c0-.238 0-.523-.02-.774a3.016 3.016 0 0 0-.307-1.142 3 3 0 0 0-1.311-1.311 3.015 3.015 0 0 0-1.142-.307C9.969 17 9.685 17 9.446 17H9.4ZM5 20.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C5.76 19 6.04 19 6.6 19h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C11 19.76 11 20.04 11 20.6v.8c0 .56 0 .84-.109 1.054a.999.999 0 0 1-.437.437C10.24 23 9.96 23 9.4 23H6.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C5 22.24 5 21.96 5 21.4v-.8ZM21.4 13H18.554c-.238 0-.523 0-.774.02-.29.024-.706.085-1.142.307a3 3 0 0 0-1.311 1.311 3.014 3.014 0 0 0-.307 1.142c-.02.251-.02.536-.02.774v4.892c0 .238 0 .523.02.774.024.29.085.706.307 1.142a3 3 0 0 0 1.311 1.311c.436.222.852.283 1.142.307.251.02.535.02.774.02H21.446c.238 0 .523 0 .774-.02.29-.024.706-.085 1.142-.307a3 3 0 0 0 1.311-1.311c.222-.436.283-.852.307-1.142.02-.25.02-.535.02-.774v-4.892c0-.238 0-.523-.02-.774a3.016 3.016 0 0 0-.307-1.142 3 3 0 0 0-1.311-1.311 3.015 3.015 0 0 0-1.142-.307c-.251-.02-.535-.02-.774-.02H21.4ZM17 16.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C17.76 15 18.04 15 18.6 15h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C23 15.76 23 16.04 23 16.6v4.8c0 .56 0 .84-.109 1.054a.999.999 0 0 1-.437.437C22.24 23 21.96 23 21.4 23h-2.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C17 22.24 17 21.96 17 21.4v-4.8ZM9.4 3H6.554c-.238 0-.523 0-.774.02-.29.024-.706.085-1.142.307a3 3 0 0 0-1.311 1.311A3.016 3.016 0 0 0 3.02 5.78C3 6.031 3 6.316 3 6.554v4.892c0 .239 0 .523.02.774.024.29.085.706.307 1.142a3 3 0 0 0 1.311 1.311c.436.222.852.283 1.142.307.251.02.536.02.774.02H9.446c.239 0 .523 0 .774-.02.29-.024.706-.085 1.142-.307a3 3 0 0 0 1.311-1.311c.222-.436.283-.852.307-1.142.02-.251.02-.536.02-.774V6.554c0-.238 0-.523-.02-.774a3.017 3.017 0 0 0-.307-1.142 3 3 0 0 0-1.311-1.311 3.016 3.016 0 0 0-1.142-.307C9.969 3 9.685 3 9.446 3H9.4ZM5 6.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C5.76 5 6.04 5 6.6 5h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C11 5.76 11 6.04 11 6.6v4.8c0 .56 0 .84-.109 1.054a.999.999 0 0 1-.437.437C10.24 13 9.96 13 9.4 13H6.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C5 12.24 5 11.96 5 11.4V6.6Z",
    fill: "#023F80"
  })));
};

var _path$2z;
function _extends$2C() { _extends$2C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2C.apply(this, arguments); }
var SvgGunOutline = function SvgGunOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2C({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2z || (_path$2z = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.268 4a1.9 1.9 0 0 0-1.9 1.9V9c0 .944.623 1.728 1.762 1.875.213.028.38.21.316.414a1.966 1.966 0 0 1-.191.433l-.436.697c-.935 1.497-1.533 3.28-1.752 5.03l-.052.415A1.9 1.9 0 0 0 3.9 20h3.104a1.9 1.9 0 0 0 1.833-1.4l1.098-4.126a.1.1 0 0 1 .096-.074h3.482a1.9 1.9 0 0 0 1.827-1.378l.606-2.122H21.1A1.9 1.9 0 0 0 23 9V5.9A1.9 1.9 0 0 0 21.1 4H4.268Zm-.1 2.6c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.219c.106-.054.246-.054.527-.054H20.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219c.055.107.055.247.055.527v1.7c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218c-.107.055-.247.055-.527.055h-8.414c-.873 0-1.309 0-1.674.15a2 2 0 0 0-.82.624c-.242.312-.358.732-.59 1.573L8.198 14 7.1 18.126a.1.1 0 0 1-.096.074H3.9a.1.1 0 0 1-.099-.112l.052-.415c.186-1.492.696-3.025 1.492-4.3l.436-.697c.295-.47.54-1.178.551-1.825.005-.322-.046-.748-.301-1.118-.294-.424-.756-.633-1.263-.633-.093 0-.14 0-.179-.006a.5.5 0 0 1-.415-.416c-.006-.039-.006-.085-.006-.178V6.6Zm6.403 6h2.412c.216 0 .324 0 .415-.037a.5.5 0 0 0 .204-.154c.06-.077.09-.18.15-.388l.322-1.121H12.287c-.418 0-.626 0-.803.07a1 1 0 0 0-.402.292c-.122.146-.187.345-.316.741l-.195.597Z",
    fill: "#023F80"
  })));
};

var _path$2A;
function _extends$2D() { _extends$2D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2D.apply(this, arguments); }
var SvgHammerOutline = function SvgHammerOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2D({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2A || (_path$2A = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.123 3.84c-.283.24-.602.559-.977.933l-.49.49-.934-.935c-.222-.222-.449-.439-.754-.538a1.4 1.4 0 0 0-.865 0c-.215.07-.372.186-.479.276L4.066 5.624c-.09.107-.206.264-.276.479a1.4 1.4 0 0 0 0 .865c.099.306.316.533.538.754l.935.935-.49.49c-.374.374-.693.693-.934.976-.252.298-.47.615-.596 1.001a2.9 2.9 0 0 0 0 1.792c.125.387.344.704.596 1.001.24.284.56.603.934.977l1.33 1.33c.375.375.694.694.977.934.298.253.615.472 1.001.597a2.9 2.9 0 0 0 1.793 0c.386-.125.703-.344 1-.596.284-.241.603-.56.978-.935l.489-.489 5.547 5.547.016.016c.085.085.182.183.275.261.106.09.263.207.479.277a1.4 1.4 0 0 0 .865 0c.215-.07.372-.186.478-.277.093-.078.19-.176.276-.261l1.02-1.021c.086-.085.184-.183.262-.276a1.41 1.41 0 0 0 .277-.478 1.4 1.4 0 0 0 0-.866 1.409 1.409 0 0 0-.277-.478c-.078-.093-.176-.19-.261-.275l-.016-.016-5.547-5.547.49-.49c.374-.374.693-.693.933-.976.253-.298.472-.615.597-1.001a2.9 2.9 0 0 0 0-1.793c-.125-.386-.344-.703-.596-1-.241-.284-.56-.603-.935-.978l-1.33-1.33c-.374-.374-.693-.693-.977-.934-.297-.252-.614-.47-1-.596a2.9 2.9 0 0 0-1.793 0c-.386.125-.703.344-1 .596Zm-4.912 7.448c-.18.213-.234.322-.257.392a1.1 1.1 0 0 0 0 .68c.023.07.077.18.257.392.188.22.454.488.86.895l1.28 1.28c.407.406.674.672.894.86.213.18.322.233.393.256a1.1 1.1 0 0 0 .68 0c.07-.023.18-.076.392-.257.22-.187.487-.453.894-.86l4.322-4.322c.407-.407.673-.674.86-.894.18-.213.234-.322.257-.393a1.1 1.1 0 0 0 0-.68c-.023-.07-.076-.18-.257-.392-.187-.22-.453-.487-.86-.894l-1.28-1.28c-.406-.406-.673-.672-.894-.86-.212-.18-.322-.234-.392-.257a1.1 1.1 0 0 0-.68 0c-.07.023-.18.077-.392.257-.22.188-.488.454-.894.86L6.07 10.394c-.406.406-.672.674-.86.894Zm13.88 8.65.848-.848-5.477-5.476-.848.848 5.476 5.477ZM6.535 7.385l-.849-.848.849-.849.848.849-.848.848Z",
    fill: "#023F80"
  })));
};

var _path$2B, _path2$K;
function _extends$2E() { _extends$2E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2E.apply(this, arguments); }
var SvgHandSlashOutline = function SvgHandSlashOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2E({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2B || (_path$2B = /*#__PURE__*/createElement$2("path", {
    d: "M24.634 14.721a2.779 2.779 0 0 0-.192-2.663C23.357 10.43 21.3 10.24 20 11.518V7.255c0-1.806-1.79-3.137-3.504-2.65A2.748 2.748 0 0 0 13.75 2a2.749 2.749 0 0 0-2.679 2.125A2.737 2.737 0 0 0 10.25 4c-.67 0-1.47.249-1.47 1.06a1 1 0 0 0 1 1c.157 0 .305-.06.47-.06.414 0 .75.344.75.753v.517c0 .55.444 1 1 1 .552 0 1-.46 1-1V4.752a.749.749 0 1 1 1.5 0v6.018a1 1 0 1 0 2 0V7.247c0-.413.333-.747.75-.747.414 0 .75.332.75.755v6.947c0 1.138 1.476 1.584 2.107.638l1.122-1.683c.426-.64 1.12-.632 1.55.01a.787.787 0 0 1 .049.694l-1.49 3.128c-.363.645.116 1.491.872 1.491a1 1 0 0 0 .902-.567h.001l1.52-3.192Z",
    fill: "#023F80"
  })), _path2$K || (_path2$K = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 26c-4.422 0-8-3.58-8-8.009v-7.863a2.74 2.74 0 0 1 1.35-2.364L3.293 5.707a1 1 0 0 1 1.414-1.414l19.004 19.004a1 1 0 1 1-1.414 1.414l-2.007-2.006C18.055 25.02 15.15 26 12 26ZM8.5 14.5c.552 0 1-.457 1-1.008v-1.578l9.376 9.376C17.016 23.235 14.62 24 12 24c-3.314 0-6-2.681-6-6.009v-7.863a.751.751 0 0 1 1.5.01V13.5c0 .552.444.999 1 .999Z",
    fill: "#023F80"
  })));
};

var _path$2C;
function _extends$2F() { _extends$2F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2F.apply(this, arguments); }
var SvgHangerOutline = function SvgHangerOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2F({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2C || (_path$2C = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5c1.807 0 3.273 1.497 3.273 3.344 0 1.148-.744 2.234-2.182 3.354v.2l9.075 4.124A3.13 3.13 0 0 1 22.87 22H5.129a3.13 3.13 0 0 1-1.295-5.978l9.075-4.125v-.199c0-.696.318-1.352.86-1.773.89-.694 1.322-1.271 1.322-1.58 0-.616-.489-1.115-1.091-1.115s-1.09.499-1.09 1.114c0 .616-.49 1.115-1.092 1.115-.602 0-1.09-.5-1.09-1.115C10.727 6.497 12.192 5 14 5ZM4.662 17.843 14 13.598l9.338 4.245A1.129 1.129 0 0 1 22.871 20H5.129a1.13 1.13 0 0 1-.467-2.157Z",
    fill: "#023F80"
  })));
};

var _path$2D;
function _extends$2G() { _extends$2G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2G.apply(this, arguments); }
var SvgHashtagOutline = function SvgHashtagOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2G({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2D || (_path$2D = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.78 3.194a.998.998 0 0 0-1.958-.391L8.782 8H6a1 1 0 0 0 0 2h2.382l-.8 4H4.5a1 1 0 1 0 0 2h2.681l-.961 4.806a.998.998 0 0 0 1.958.392L9.218 16h3.963l-.961 4.806a.998.998 0 0 0 1.958.392L15.218 16H18a1 1 0 1 0 0-2h-2.382l.8-4H19.5a1 1 0 1 0 0-2h-2.681l.961-4.806a.998.998 0 0 0-1.958-.391L14.782 8h-3.963l.961-4.806ZM14.382 10h-3.963l-.8 4h3.962l.8-4Z",
    fill: "#023F80"
  })));
};

var _path$2E;
function _extends$2H() { _extends$2H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2H.apply(this, arguments); }
var SvgHeadphonesOutline = function SvgHeadphonesOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2H({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2E || (_path$2E = /*#__PURE__*/createElement$2("path", {
    d: "M5 21.059v-3.231a1.941 1.941 0 0 1 3.882 0v3.23a1.941 1.941 0 1 1-3.882 0Zm0-1.628v-5.034a3.94 3.94 0 0 0-2 3.43v3.232a3.941 3.941 0 1 0 7.882 0v-3.231A3.941 3.941 0 0 0 5 14.397V14a9 9 0 0 1 18 0v.397a3.941 3.941 0 0 0-5.882 3.43v3.232a3.941 3.941 0 0 0 7.882 0v-3.231a3.94 3.94 0 0 0-2-3.431v4.9a1 1 0 1 0 2 0V14c0-6.075-4.925-11-11-11S3 7.925 3 14v5.43a1 1 0 1 0 2 0Zm18-1.603v3.23a1.941 1.941 0 1 1-3.882 0v-3.23a1.941 1.941 0 0 1 3.882 0Z",
    fill: "#023F80"
  })));
};

var _path$2F, _path2$L;
function _extends$2I() { _extends$2I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2I.apply(this, arguments); }
var SvgHealthOutline = function SvgHealthOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2I({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2F || (_path$2F = /*#__PURE__*/createElement$2("path", {
    d: "M15.5 7.5a.9.9 0 0 1 .9.9v.7h.7a.9.9 0 1 1 0 1.8h-.7v.7a.9.9 0 1 1-1.8 0v-.7h-.7a.9.9 0 1 1 0-1.8h.7v-.7a.9.9 0 0 1 .9-.9Z",
    fill: "#023F80"
  })), _path2$L || (_path2$L = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.111 5.7c1.128-1.057 2.43-1.63 3.88-1.694L16.267 4C19.423 4 22 6.56 22 9.717c0 2.959-1.035 4.427-5.573 8.061l-.933.74-2.364 1.843a1.838 1.838 0 0 1-2.26 0l-2.688-2.098C3.127 14.269 2 12.805 2 9.717 2 6.56 4.577 4 7.734 4c1.54 0 2.929.576 4.138 1.695l.122.118.117-.113ZM20.2 9.717c0-2.16-1.769-3.917-3.934-3.917-1.357 0-2.527.616-3.564 1.908a.9.9 0 0 1-1.398.007C10.24 6.418 9.067 5.8 7.734 5.8 5.57 5.8 3.8 7.557 3.8 9.717c0 2.25.797 3.38 4.939 6.69l.874.691 2.364 1.843c.014.01.032.01.046 0l2.663-2.078c4.447-3.511 5.433-4.696 5.51-6.852l.004-.294Z",
    fill: "#023F80"
  })));
};

var _path$2G;
function _extends$2J() { _extends$2J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2J.apply(this, arguments); }
var SvgHeartCircleOutline = function SvgHeartCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2J({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2G || (_path$2G = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2a11.966 11.966 0 0 0-8.485 3.515A11.966 11.966 0 0 0 2 14c0 3.313 1.344 6.315 3.515 8.485A11.966 11.966 0 0 0 14 26c3.313 0 6.315-1.344 8.485-3.515A11.966 11.966 0 0 0 26 14c0-3.313-1.344-6.315-3.515-8.485A11.966 11.966 0 0 0 14 2ZM6.929 6.929A9.966 9.966 0 0 1 14 4a9.966 9.966 0 0 1 7.071 2.929A9.966 9.966 0 0 1 24 14a9.966 9.966 0 0 1-2.929 7.071A9.966 9.966 0 0 1 14 24a9.966 9.966 0 0 1-7.071-2.929A9.966 9.966 0 0 1 4 14a9.966 9.966 0 0 1 2.929-7.071ZM11.422 9C9.275 9 7.5 10.733 7.5 12.9c0 1.127.306 2.018 1.031 2.916.665.824 1.694 1.662 3.075 2.743l.004.002 1.429 1.11c.565.439 1.357.439 1.922 0l1.43-1.11.003-.002c1.38-1.081 2.41-1.92 3.075-2.743.725-.898 1.031-1.789 1.031-2.916 0-2.167-1.775-3.9-3.922-3.9-.98 0-1.845.334-2.583.937-.74-.6-1.6-.937-2.573-.937ZM9.5 12.9c0-1.043.86-1.9 1.922-1.9.62 0 1.214.267 1.806.987a1 1 0 0 0 1.55-.008c.572-.71 1.162-.979 1.8-.979 1.062 0 1.922.857 1.922 1.9 0 .675-.152 1.122-.587 1.66-.494.612-1.327 1.308-2.75 2.423l-.002.001-1.161.901-1.16-.901-.002-.001c-1.424-1.115-2.256-1.811-2.751-2.423-.434-.538-.587-.985-.587-1.66Z",
    fill: "#023F80"
  })));
};

var _path$2H, _path2$M, _path3$g, _path4$3;
function _extends$2K() { _extends$2K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2K.apply(this, arguments); }
var SvgHeartLockOutline = function SvgHeartLockOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2K({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2H || (_path$2H = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 7.5A5.5 5.5 0 0 1 14 2a1 1 0 1 1 0 2 3.5 3.5 0 0 0-3.5 3.5V10a1 1 0 1 1-2 0V7.5Z",
    fill: "#023F80"
  })), _path2$M || (_path2$M = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 7.5A5.5 5.5 0 0 0 14 2a1 1 0 1 0 0 2 3.5 3.5 0 0 1 3.5 3.5V10a1 1 0 1 0 2 0V7.5Z",
    fill: "#023F80"
  })), _path3$g || (_path3$g = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 14.834C3.5 11.564 6.268 9 9.547 9c1.683 0 3.17.632 4.447 1.805C15.26 9.629 16.753 9 18.454 9c3.278 0 6.046 2.563 6.046 5.834 0 1.737-.479 3.079-1.63 4.455-1.09 1.3-2.797 2.648-5.198 4.461l-.003.003-2.468 1.849a2.01 2.01 0 0 1-2.402 0l-2.468-1.85-.003-.002C7.927 21.937 6.22 20.59 5.13 19.29 3.979 17.912 3.5 16.57 3.5 14.834ZM9.547 11C7.284 11 5.5 12.754 5.5 14.834c0 1.266.313 2.154 1.164 3.17.915 1.093 2.422 2.303 4.867 4.15h.002L13.996 24h.008l2.463-1.846h.002c2.445-1.847 3.952-3.057 4.867-4.15.851-1.017 1.164-1.904 1.164-3.17 0-2.08-1.784-3.834-4.047-3.834-1.375 0-2.592.584-3.685 1.893a1 1 0 0 1-1.53.008C12.115 11.581 10.893 11 9.548 11Z",
    fill: "#023F80"
  })), _path4$3 || (_path4$3 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
    fill: "#023F80"
  })));
};

var _path$2I, _path2$N, _path3$h;
function _extends$2L() { _extends$2L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2L.apply(this, arguments); }
var SvgHeartUnlockOutline = function SvgHeartUnlockOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2L({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2I || (_path$2I = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 7.5a5.5 5.5 0 0 1 10.687-1.833 1 1 0 0 1-1.886.666A3.502 3.502 0 0 0 10.5 7.5V10a1 1 0 1 1-2 0V7.5Z",
    fill: "#023F80"
  })), _path2$N || (_path2$N = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 14.834C3.5 11.564 6.268 9 9.547 9c1.683 0 3.17.632 4.447 1.805C15.26 9.629 16.753 9 18.454 9c3.278 0 6.046 2.563 6.046 5.834 0 1.737-.479 3.079-1.63 4.455-1.09 1.3-2.797 2.648-5.198 4.461l-.003.003-2.468 1.849a2.01 2.01 0 0 1-2.402 0l-2.468-1.85-.003-.002C7.927 21.937 6.22 20.59 5.13 19.29 3.979 17.912 3.5 16.57 3.5 14.834ZM9.547 11C7.284 11 5.5 12.754 5.5 14.834c0 1.266.313 2.154 1.164 3.17.915 1.093 2.422 2.303 4.867 4.15h.002L13.996 24h.008l2.463-1.846h.002c2.445-1.847 3.952-3.057 4.867-4.15.851-1.017 1.164-1.904 1.164-3.17 0-2.08-1.784-3.834-4.047-3.834-1.375 0-2.592.584-3.685 1.893a1 1 0 0 1-1.53.008C12.115 11.581 10.893 11 9.548 11Z",
    fill: "#023F80"
  })), _path3$h || (_path3$h = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
    fill: "#023F80"
  })));
};

var _path$2J;
function _extends$2M() { _extends$2M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2M.apply(this, arguments); }
var SvgHelpCircleOutline = function SvgHelpCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2M({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2J || (_path$2J = /*#__PURE__*/createElement$2("path", {
    d: "M14 2c6.624 0 12 5.376 12 12s-5.376 12-12 12S2 20.624 2 14 7.376 2 14 2Zm0 2C8.48 4 4 8.48 4 14s4.48 10 10 10 10-4.48 10-10S19.52 4 14 4Zm0 14.1a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8Zm-.066-11.11c2.05 0 3.712 1.678 3.712 3.75 0 .825-.334 1.575-.863 2.11l-.835.862c-.497.509-.855.95-1.006 1.72-.014.07-.024.174-.03.31a.926.926 0 0 1-.925.883h-.01a.928.928 0 0 1-.928-.928v-.002c.001-.26.01-.43.025-.512a3.81 3.81 0 0 1 1.018-1.94l1.15-1.181a1.871 1.871 0 0 0-1.308-3.197c-.649 0-1.222.34-1.554.854a3.891 3.891 0 0 0-.248.485.928.928 0 0 1-1.147.499l-.035-.012a.886.886 0 0 1-.534-1.175c.066-.161.13-.304.19-.427.638-1.297 1.838-2.099 3.328-2.099Z",
    fill: "#023F80"
  })));
};

var _path$2K;
function _extends$2N() { _extends$2N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2N.apply(this, arguments); }
var SvgHelpOutline = function SvgHelpOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2N({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2K || (_path$2K = /*#__PURE__*/createElement$2("path", {
    d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm0 1.8a9.2 9.2 0 1 0 0 18.4 9.2 9.2 0 0 0 0-18.4Zm-.198 13.774a1.1 1.1 0 0 1 1.1 1.1v.027a1.1 1.1 0 0 1-2.199 0v-.027a1.1 1.1 0 0 1 1.1-1.1ZM11.74 5.8c1.967 0 3.561 1.63 3.561 3.642 0 .801-.32 1.53-.828 2.049l-.801.837c-.477.494-.82.923-.965 1.672a2.297 2.297 0 0 0-.03.31.887.887 0 0 1-.886.848.9.9 0 0 1-.9-.9v-.002c.001-.254.009-.42.024-.498a3.715 3.715 0 0 1 .976-1.885l1.104-1.147c.316-.322.526-.783.526-1.284 0-1.002-.802-1.821-1.781-1.821-.622 0-1.173.33-1.491.83-.06.094-.137.243-.227.446a.924.924 0 0 1-1.145.497.858.858 0 0 1-.516-1.132c.065-.16.127-.301.186-.424C9.158 6.58 10.31 5.8 11.74 5.8Z",
    fill: "#023F80"
  })));
};

var _path$2L;
function _extends$2O() { _extends$2O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2O.apply(this, arguments); }
var SvgHideOutline = function SvgHideOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2O({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2L || (_path$2L = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.593 6.41a.9.9 0 0 1-.092-1.797c2.759-.141 5.574.953 7.649 2.5.975.728 1.787 1.554 2.356 2.396.57.843.894 1.7.894 2.49 0 .941-.464 1.982-1.242 2.967a.9.9 0 1 1-1.413-1.116c.41-.519.855-1.168.855-1.85 0-.312-.139-.822-.585-1.483-.436-.646-1.097-1.33-1.941-1.96-1.836-1.37-4.169-2.265-6.48-2.147ZM4.85 16.886C6.8 18.341 9.4 19.4 12 19.4c1.967 0 3.93-.607 5.604-1.523l1.26 1.26a.9.9 0 0 0 1.272-1.273l-13.5-13.5a.9.9 0 0 0-1.272 1.272l.684.684c-.42.246-.82.512-1.198.794-.975.727-1.787 1.553-2.356 2.395-.57.843-.894 1.7-.894 2.49 0 .791.325 1.65.894 2.492.569.841 1.381 1.668 2.356 2.395ZM10.4 12a1.6 1.6 0 0 0 2.587 1.26l-2.247-2.247c-.213.272-.34.615-.34.987Zm1.6 3.4a3.4 3.4 0 0 1-2.537-5.664L7.37 7.643c-.513.273-.998.581-1.444.914-.844.63-1.505 1.314-1.94 1.96-.448.662-.586 1.17-.586 1.483 0 .312.138.821.585 1.483.436.645 1.097 1.33 1.941 1.96C7.631 16.715 9.862 17.6 12 17.6c1.44 0 2.925-.401 4.269-1.058l-2.005-2.005A3.39 3.39 0 0 1 12 15.4Z",
    fill: "#023F80"
  })));
};

var _path$2M;
function _extends$2P() { _extends$2P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2P.apply(this, arguments); }
var SvgHistorialBtnPago = function SvgHistorialBtnPago(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2P({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2M || (_path$2M = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.08 3.5a2.718 2.718 0 0 1 2.71 2.523l.006.194.046 11.978a2.718 2.718 0 0 1-2.523 2.71l-.194.007h-9.352l-3.074 2.98c-.745.722-1.97.248-2.076-.744l-.007-.138v-2.098H4.513a2.718 2.718 0 0 1-2.71-2.523l-.007-.194L1.75 6.217a2.718 2.718 0 0 1 2.523-2.71l.194-.007H23.08Zm0 1.336H4.466c-.712 0-1.298.539-1.373 1.227l-.008.15.045 11.982c0 .712.54 1.298 1.231 1.373l.15.008h4.104c.688 0 1.255.521 1.328 1.19l.008.146v1.844l2.892-2.803c.207-.201.473-.329.757-.365l.172-.012h9.352c.712 0 1.298-.538 1.373-1.226l.008-.15-.046-11.983c0-.763-.618-1.381-1.38-1.381Zm-10.483 4.04a.735.735 0 0 1 .196 1.441l-.123.024-.073.004h-1.633a1.805 1.805 0 0 0-.283 3.588l.188.019.095.002h1.633a.735.735 0 0 1 .196 1.442l-.123.025-.073.004h-1.633a3.275 3.275 0 0 1-.356-6.53l.238-.018 1.751-.002Zm3.765 0a3.275 3.275 0 0 1 .356 6.53l-.237.016-1.473.003a.735.735 0 0 1-.196-1.443l.123-.024.073-.004h1.354a1.805 1.805 0 0 0 .284-3.587l-.188-.02-.096-.002h-1.354a.735.735 0 0 1-.196-1.442l.123-.024.073-.004h1.354Zm-1.212 2.596a.678.678 0 0 1 .122 1.345l-.122.01h-2.655a.678.678 0 0 1-.122-1.344l.122-.01h2.655Z",
    fill: "#023F80"
  })));
};

var _path$2N;
function _extends$2Q() { _extends$2Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Q.apply(this, arguments); }
var SvgHistorial = function SvgHistorial(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2Q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2N || (_path$2N = /*#__PURE__*/createElement$2("path", {
    d: "M12 1.714c5.68 0 10.286 4.605 10.286 10.286 0 5.68-4.605 10.286-10.286 10.286a10.255 10.255 0 0 1-7.274-3.014.857.857 0 0 1 1.212-1.212A8.54 8.54 0 0 0 12 20.572 8.571 8.571 0 1 0 5.878 6h1.408a.857.857 0 0 1 .1 1.709l-.1.005H3.857a.857.857 0 0 1-.851-.757L3 6.857V3.43a.857.857 0 0 1 1.709-.1l.005.1v1.31c1.9-1.908 4.5-3.025 7.286-3.025Zm0 5.143c.44 0 .802.331.851.757l.006.1v3.931l2.32 2.32a.857.857 0 0 1-1.13 1.284l-.082-.071-2.571-2.572a.857.857 0 0 1-.244-.493L11.143 12V7.714c0-.473.384-.857.857-.857Z",
    fill: "#023F80"
  })));
};

var _path$2O;
function _extends$2R() { _extends$2R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2R.apply(this, arguments); }
var SvgHistoryBackwardOutline1 = function SvgHistoryBackwardOutline1(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2R({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2O || (_path$2O = /*#__PURE__*/createElement$2("path", {
    d: "M14 2c6.627 0 12 5.373 12 12s-5.373 12-12 12c-3.226 0-6.251-1.28-8.487-3.516a1 1 0 1 1 1.415-1.414A9.964 9.964 0 0 0 14 24c5.523 0 10-4.477 10-10S19.523 4 14 4a9.974 9.974 0 0 0-7.143 3H8.5a1 1 0 0 1 .117 1.993L8.5 9h-4a1 1 0 0 1-.993-.883L3.5 8V4a1 1 0 0 1 1.993-.117L5.5 4v1.529A11.973 11.973 0 0 1 14 2Zm0 6a1 1 0 0 1 .993.883L15 9v4.586l2.707 2.707a1 1 0 0 1-1.32 1.497l-.094-.083-3-3a1 1 0 0 1-.284-.576L13 14V9a1 1 0 0 1 1-1Z",
    fill: "#023F80"
  })));
};

var _path$2P, _path2$O;
function _extends$2S() { _extends$2S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2S.apply(this, arguments); }
var SvgHistoryBackwardOutline = function SvgHistoryBackwardOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2S({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2P || (_path$2P = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.1a.9.9 0 0 1 .9.9v3.727l2.236 2.237a.9.9 0 0 1-1.272 1.272l-2.5-2.5a.9.9 0 0 1-.264-.636V8a.9.9 0 0 1 .9-.9Z",
    fill: "#023F80"
  })), _path2$O || (_path2$O = /*#__PURE__*/createElement$2("path", {
    d: "M19 5a9.872 9.872 0 0 0-7-2.9 9.873 9.873 0 0 0-7.1 3V3a.9.9 0 0 0-1.8 0v4a.9.9 0 0 0 .9.9h4a.9.9 0 0 0 0-1.8H6.45A8.069 8.069 0 0 1 12 3.9c2.237 0 4.26.906 5.727 2.372A8.072 8.072 0 0 1 20.1 12c0 2.237-.906 4.26-2.373 5.727A8.072 8.072 0 0 1 12 20.1a8.064 8.064 0 0 1-5.203-1.891.9.9 0 1 0-1.156 1.379A9.864 9.864 0 0 0 12 21.9c2.733 0 5.21-1.11 7-2.9a9.872 9.872 0 0 0 2.9-7c0-2.734-1.11-5.21-2.9-7Z",
    fill: "#023F80"
  })));
};

var _path$2Q;
function _extends$2T() { _extends$2T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2T.apply(this, arguments); }
var SvgHistoryForwardOutline = function SvgHistoryForwardOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2T({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2Q || (_path$2Q = /*#__PURE__*/createElement$2("path", {
    d: "M14 2c3.25 0 6.283 1.303 8.5 3.529V4l.007-.117A1 1 0 0 1 24.5 4v4l-.007.117A1 1 0 0 1 23.5 9h-4l-.117-.007A1 1 0 0 1 19.5 7h1.643A9.974 9.974 0 0 0 14 4C8.477 4 4 8.477 4 14s4.477 10 10 10a9.964 9.964 0 0 0 7.072-2.93 1 1 0 1 1 1.415 1.414A11.964 11.964 0 0 1 14 26C7.373 26 2 20.627 2 14S7.373 2 14 2Zm-.5 6a1 1 0 0 1 1 1v4.586l2.707 2.707a1 1 0 0 1-1.414 1.414l-3-3A1 1 0 0 1 12.5 14V9a1 1 0 0 1 1-1Z",
    fill: "#023F80"
  })));
};

var _path$2R, _path2$P;
function _extends$2U() { _extends$2U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2U.apply(this, arguments); }
var SvgHomeHeartOutline = function SvgHomeHeartOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2U({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2R || (_path$2R = /*#__PURE__*/createElement$2("path", {
    d: "M14.625 10.47A1.47 1.47 0 0 0 13.155 9c-.435 0-.822.205-1.155.601-.333-.396-.72-.601-1.155-.601a1.47 1.47 0 0 0-1.47 1.47c0 .82.329 1.232 1.722 2.316l.634.493c.158.123.38.123.537 0l.635-.493c1.393-1.084 1.722-1.495 1.722-2.316Z",
    fill: "#023F80"
  })), _path2$P || (_path2$P = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.742 3.339a2.4 2.4 0 0 0-1.484 0 2.44 2.44 0 0 0-.826.49c-.22.186-.465.431-.742.708L4.245 9.982c-.291.291-.537.536-.718.831-.159.26-.276.542-.347.838-.08.337-.08.684-.08 1.095v4.887c0 .392 0 .738.023 1.026.025.305.081.622.239.93a2.4 2.4 0 0 0 1.048 1.05c.309.157.626.213.931.238.288.023.634.023 1.026.023h3.506c.567 0 1.027-.46 1.027-1.027V17.9a1.1 1.1 0 0 1 2.2 0v1.973c0 .567.46 1.027 1.027 1.027h3.506c.392 0 .738 0 1.025-.023.306-.025.623-.081.931-.239a2.4 2.4 0 0 0 1.05-1.048 2.44 2.44 0 0 0 .238-.931c.023-.288.023-.634.023-1.026v-4.887c0-.411 0-.758-.08-1.095a2.898 2.898 0 0 0-.347-.838c-.181-.295-.427-.54-.718-.83L14.31 4.536a13.485 13.485 0 0 0-.742-.708 2.44 2.44 0 0 0-.826-.49Zm-.928 1.712a.6.6 0 0 1 .371 0c.014.004.07.024.218.15.157.133.35.325.658.632l5.365 5.366c.377.376.457.465.512.555.06.098.105.205.132.318.024.102.03.222.03.754V17.6c0 .435 0 .707-.018.912-.015.194-.041.248-.047.26a.6.6 0 0 1-.263.263c-.012.006-.066.032-.26.047-.205.017-.477.018-.912.018h-2.7v-1.2a2.9 2.9 0 1 0-5.8 0v1.2H6.4c-.435 0-.707 0-.912-.018-.194-.015-.248-.041-.26-.047a.6.6 0 0 1-.263-.263c-.006-.012-.032-.066-.048-.26A12.65 12.65 0 0 1 4.9 17.6v-4.775c0-.531.006-.65.03-.753a1.1 1.1 0 0 1 .132-.318c.055-.09.135-.179.512-.555l5.365-5.366c.308-.307.5-.499.657-.632.15-.126.205-.146.219-.15Z",
    fill: "#023F80"
  })));
};

var _path$2S;
function _extends$2V() { _extends$2V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2V.apply(this, arguments); }
var SvgHomeOutline = function SvgHomeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2V({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2S || (_path$2S = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.185 4.85a.6.6 0 0 0-.37 0c-.014.005-.07.025-.218.151-.157.133-.35.325-.658.632L5.574 11c-.376.376-.457.465-.512.555a1.1 1.1 0 0 0-.132.318c-.024.102-.03.222-.03.754V17.6c0 .435 0 .707.018.912.015.194.041.248.047.26a.6.6 0 0 0 .263.263c.012.006.066.032.26.048.205.016.477.017.912.017h2.7v-3.2a2.9 2.9 0 0 1 5.8 0v3.2h2.7c.435 0 .707 0 .912-.017.194-.016.248-.042.26-.048a.6.6 0 0 0 .263-.263c.006-.012.032-.066.048-.26.016-.205.017-.477.017-.912v-4.975c0-.531-.006-.65-.03-.753a1.101 1.101 0 0 0-.132-.318c-.055-.09-.135-.179-.512-.555l-5.365-5.366c-.308-.307-.5-.499-.657-.632-.15-.126-.205-.146-.219-.15Zm-.927-1.711a2.4 2.4 0 0 1 1.484 0c.329.107.593.291.826.49.22.186.465.431.742.708l5.39 5.39.055.056c.291.29.537.535.718.83a2.9 2.9 0 0 1 .347.838c.08.337.08.684.08 1.095v5.087c0 .392 0 .738-.023 1.026-.025.305-.081.622-.238.93a2.4 2.4 0 0 1-1.05 1.05c-.308.157-.625.213-.93.238-.288.023-.634.023-1.026.023H14.19a1.089 1.089 0 0 1-1.089-1.089V15.9a1.1 1.1 0 0 0-2.2 0v3.911c0 .602-.487 1.089-1.089 1.089H6.367c-.392 0-.738 0-1.025-.023-.306-.025-.623-.081-.932-.238a2.4 2.4 0 0 1-1.048-1.05c-.158-.308-.214-.625-.239-.93-.023-.288-.023-.634-.023-1.026v-5.087c0-.411 0-.758.08-1.095a2.9 2.9 0 0 1 .347-.838c.181-.295.427-.54.718-.83l.056-.057 5.39-5.389c.276-.277.521-.522.74-.708a2.44 2.44 0 0 1 .827-.49Z",
    fill: "#023F80"
  })));
};

var _path$2T;
function _extends$2W() { _extends$2W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2W.apply(this, arguments); }
var SvgHorseToyOutline = function SvgHorseToyOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2W({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2T || (_path$2T = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.707 8.2H9c-2.631 0-4.08 2.106-4.415 3.783l-.704 3.52a2.61 2.61 0 0 0-.522 5.005c2.423.95 5.184 1.396 8.243 1.396s5.82-.446 8.244-1.395a2.61 2.61 0 0 0-.478-4.997l-.603-3.333c.086.004.154.003.198.003h.134a2.408 2.408 0 0 0 2.408-2.408V7.568c.317-.244.61-.608.739-1.15a2.162 2.162 0 0 0-.128-1.357 2.976 2.976 0 0 0-.473-.745c-.51-.601-1.132-1.178-1.95-1.593-.827-.42-1.751-.623-2.793-.623-3.496 0-6.045 2.837-6.193 6.1Zm5.772 1.455-.015-.083-.001-.008a.439.439 0 0 1-.004-.059c0-.182.064-.569.167-.61.1-.04.138-.01.246.074l.054.04 1.158.968c.129.128.236.216.332.276.208.129.364.129.574.129h.107a.608.608 0 0 0 .608-.608V6.707c0-.128 0-.192.02-.24a.224.224 0 0 1 .083-.104c.042-.03.118-.047.27-.08.49-.11.553-.377.192-.803a5.85 5.85 0 0 0-.484-.51 4.386 4.386 0 0 0-.439-.359c-.635-.45-1.403-.711-2.447-.711-2.505 0-4.4 2.1-4.4 4.6v.86c0 .224 0 .336-.044.422a.4.4 0 0 1-.174.174c-.086.044-.198.044-.422.044H9c-1.5 0-2.423 1.2-2.65 2.336l-.906 4.53c-.049.244-.073.366-.144.447a.413.413 0 0 1-.24.131c-.106.016-.217-.027-.44-.114l-.014-.005a.81.81 0 0 0-.591 1.508l.017.007a15.757 15.757 0 0 0 1.157.4 17.922 17.922 0 0 0 1.566.4c.341.071.69.134 1.045.19 1.19.183 2.457.274 3.802.274 1.345 0 2.613-.091 3.803-.275a20.078 20.078 0 0 0 1.077-.196 17.908 17.908 0 0 0 2.16-.597c.184-.065.367-.132.547-.203a.81.81 0 1 0-.59-1.508c-.22.085-.329.128-.433.113a.395.395 0 0 1-.251-.14c-.067-.081-.09-.202-.133-.444l-1.303-7.2Zm-.859 8.313c.033-.077.033-.15.033-.294a4.051 4.051 0 1 0-8.102 0c0 .144 0 .217.034.294l.002.005a.444.444 0 0 0 .146.17c.072.047.153.06.314.085 1.105.17 2.29.256 3.555.256 1.265 0 2.45-.086 3.556-.256.161-.025.242-.038.314-.085a.443.443 0 0 0 .146-.17l.002-.005Zm-2.037-1.365a2.25 2.25 0 0 0-3.961 0c.629.054 1.289.081 1.98.081.692 0 1.352-.027 1.98-.08Z",
    fill: "#023F80"
  })));
};

var _path$2U, _path2$Q;
function _extends$2X() { _extends$2X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2X.apply(this, arguments); }
var SvgImageFilterOutline = function SvgImageFilterOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2X({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2U || (_path$2U = /*#__PURE__*/createElement$2("path", {
    d: "M8.983 15.8a3.8 3.8 0 0 0 0-7.6A7.166 7.166 0 0 0 7.9 12c0 1.395.396 2.696 1.083 3.8Z",
    fill: "#023F80"
  })), _path2$Q || (_path2$Q = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9 4.6A7.4 7.4 0 1 0 12 18.721a7.4 7.4 0 1 0 0-13.443A7.372 7.372 0 0 0 8.9 4.6ZM3.3 12a5.6 5.6 0 1 1 11.2 0 5.6 5.6 0 0 1-11.2 0Zm10.586-5.468A7.381 7.381 0 0 1 16.3 12c0 2.166-.93 4.115-2.414 5.468a5.6 5.6 0 1 0 0-10.936Z",
    fill: "#023F80"
  })));
};

var _path$2V;
function _extends$2Y() { _extends$2Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Y.apply(this, arguments); }
var SvgInboxOutline = function SvgInboxOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2Y({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2V || (_path$2V = /*#__PURE__*/createElement$2("path", {
    d: "M19.814 4c1.205 0 1.805.096 2.45.38.603.268 1.109.673 1.5 1.205.419.567.642 1.132.903 2.308l1.31 5.89L26 14v3.872c0 1.777-.168 2.648-.652 3.553a4.634 4.634 0 0 1-1.923 1.922c-.905.485-1.776.653-3.553.653H8.128c-1.777 0-2.648-.168-3.553-.652a4.634 4.634 0 0 1-1.923-1.923C2.168 20.52 2 19.65 2 17.872V14l.024-.217 1.309-5.89c.261-1.176.484-1.74.903-2.308a3.701 3.701 0 0 1 1.5-1.204C6.383 4.096 6.982 4 8.187 4h11.628ZM4 17.872c0 1.475.108 2.034.416 2.61.255.478.624.846 1.102 1.102.576.308 1.135.416 2.61.416h11.744c1.475 0 2.034-.108 2.61-.416a2.634 2.634 0 0 0 1.102-1.102c.308-.576.416-1.135.416-2.61V15h-5.1a5.002 5.002 0 0 1-9.8 0H4v2.872ZM20.023 6.001 8.185 6c-.95 0-1.287.054-1.64.21-.285.126-.514.31-.7.561-.228.31-.354.629-.56 1.556L4.246 13H10a1 1 0 0 1 .993.883L11 14a3 3 0 1 0 6 0 1 1 0 0 1 1-1h5.753l-1.038-4.673c-.206-.927-.332-1.245-.56-1.556a1.702 1.702 0 0 0-.7-.561c-.326-.144-.639-.201-1.432-.209Z",
    fill: "#023F80"
  })));
};

var _path$2W;
function _extends$2Z() { _extends$2Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Z.apply(this, arguments); }
var SvgIncognitoOutline = function SvgIncognitoOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2Z({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2W || (_path$2W = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.284 3H16.716c.56 0 1.035 0 1.428.03.414.03.808.098 1.194.268a3.5 3.5 0 0 1 1.474 1.223c.239.348.377.723.484 1.124.101.381.189.848.292 1.398l.007.036L22.33 11H25a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h2.67l.735-3.921.007-.036c.103-.55.19-1.017.292-1.398.107-.401.245-.776.484-1.124a3.5 3.5 0 0 1 1.474-1.223c.386-.17.78-.238 1.194-.269C10.249 3 10.724 3 11.284 3Zm8.345 4.447L20.295 11H7.705l.666-3.553c.112-.595.186-.988.266-1.288.076-.288.141-.42.2-.507a1.5 1.5 0 0 1 .632-.524c.096-.043.239-.082.536-.104C10.315 5 10.715 5 11.32 5h5.36c.606 0 1.005 0 1.315.024.297.022.44.061.536.104a1.5 1.5 0 0 1 .631.524c.06.086.125.22.201.507.08.3.154.693.266 1.288ZM5 20a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-5a5 5 0 1 0 5 5.083 6.046 6.046 0 0 1 2 0 5 5 0 1 0 .367-1.966 8.048 8.048 0 0 0-2.734 0A5.002 5.002 0 0 0 8 15Zm12 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z",
    fill: "#023F80"
  })));
};

var _path$2X;
function _extends$2_() { _extends$2_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2_.apply(this, arguments); }
var SvgInfoCircleOutline = function SvgInfoCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2_({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2X || (_path$2X = /*#__PURE__*/createElement$2("path", {
    d: "M14 2c6.627 0 12 5.373 12 12s-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2Zm0 2C8.477 4 4 8.477 4 14s4.477 10 10 10 10-4.477 10-10S19.523 4 14 4Zm.074 8c.237 0 .386.037.517.107.13.07.232.172.302.302.07.13.107.28.107.517v6.148c0 .237-.037.386-.107.517a.726.726 0 0 1-.302.302c-.13.07-.28.107-.517.107h-.148c-.237 0-.386-.037-.517-.107a.726.726 0 0 1-.302-.302c-.07-.13-.107-.28-.107-.517v-6.148c0-.237.037-.386.107-.517a.726.726 0 0 1 .302-.302c.13-.07.28-.107.517-.107h.148ZM14 7.6a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8Z",
    fill: "#023F80"
  })));
};

var _path$2Y;
function _extends$2$() { _extends$2$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2$.apply(this, arguments); }
var SvgInformacion = function SvgInformacion(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$2$({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2Y || (_path$2Y = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.942 8.627c0-.71.57-1.28 1.281-1.28.72 0 1.277.57 1.277 1.28 0 .71-.557 1.269-1.277 1.269a1.267 1.267 0 0 1-1.281-1.27Zm-1.396 11.365c0-.36.292-.652.664-.652h1.675v-6.027h-1.523a.646.646 0 0 1-.664-.65.65.65 0 0 1 .664-.64h2.233c.465 0 .708.326.708.804v6.513h1.676c.372 0 .662.291.662.652 0 .36-.29.64-.662.64h-4.77c-.371 0-.663-.28-.663-.64Zm12.913-5.702A10.154 10.154 0 0 0 14.281 4.137 10.123 10.123 0 0 0 4.137 14.29a10.14 10.14 0 0 0 10.155 10.17 10.15 10.15 0 0 0 10.167-10.17Zm-21.834 0c0-6.384 5.27-11.665 11.656-11.665 6.397 0 11.677 5.28 11.677 11.665 0 6.388-5.28 11.668-11.666 11.668S2.625 20.678 2.625 14.29Z",
    fill: "#023F80"
  })));
};

var _path$2Z;
function _extends$30() { _extends$30 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$30.apply(this, arguments); }
var SvgInicio = function SvgInicio(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$30({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2Z || (_path$2Z = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.943 2.571h2.44c.204 0 .448 0 .662.018.25.02.606.072.98.263.483.246.877.64 1.123 1.123.19.374.243.73.263.98.018.214.018.458.018.662V6.383c0 .204 0 .447-.018.662-.02.25-.072.606-.263.98-.246.483-.64.877-1.123 1.123-.374.19-.73.243-.98.263a8.452 8.452 0 0 1-.663.017h-2.479c-.204 0-.448 0-.663-.017a2.584 2.584 0 0 1-.979-.263 2.571 2.571 0 0 1-1.124-1.124 2.585 2.585 0 0 1-.263-.979c-.017-.215-.017-.458-.017-.663V5.617c0-.204 0-.448.018-.663.02-.248.072-.605.262-.979.247-.484.64-.877 1.124-1.123.374-.19.73-.243.98-.263.214-.018.458-.018.662-.018h.04Zm-1.278 2.183c-.094.183-.094.423-.094.903v.686c0 .48 0 .72.094.903a.857.857 0 0 0 .374.375c.184.093.424.093.904.093h2.4c.48 0 .72 0 .903-.093a.857.857 0 0 0 .375-.375c.093-.183.093-.423.093-.903v-.686c0-.48 0-.72-.093-.903a.857.857 0 0 0-.375-.375c-.183-.093-.423-.093-.903-.093h-2.4c-.48 0-.72 0-.904.093a.857.857 0 0 0-.374.375ZM8.057 14.57h-2.44c-.204 0-.448 0-.662.018-.25.02-.606.072-.98.263-.483.246-.877.64-1.123 1.123-.19.374-.243.73-.263.98a8.452 8.452 0 0 0-.018.662V18.383c0 .204 0 .448.018.662.02.25.072.606.263.98.246.483.64.877 1.123 1.123.374.19.73.243.98.263.214.018.458.017.662.017h2.48c.204 0 .448 0 .663-.017.249-.02.605-.072.979-.263.484-.246.877-.64 1.124-1.124.19-.373.242-.73.263-.979.017-.215.017-.458.017-.663V17.617c0-.204 0-.448-.018-.663a2.586 2.586 0 0 0-.262-.979 2.571 2.571 0 0 0-1.124-1.123 2.583 2.583 0 0 0-.98-.263 8.419 8.419 0 0 0-.662-.018h-.04Zm-3.771 3.086c0-.48 0-.72.093-.903a.857.857 0 0 1 .375-.375c.183-.093.423-.093.903-.093h2.4c.48 0 .72 0 .904.093a.857.857 0 0 1 .374.375c.094.183.094.423.094.903v.686c0 .48 0 .72-.094.903a.857.857 0 0 1-.374.375c-.184.093-.424.093-.904.093h-2.4c-.48 0-.72 0-.903-.093a.857.857 0 0 1-.375-.375c-.093-.183-.093-.423-.093-.903v-.686Zm14.057-6.514h-2.44c-.204 0-.448 0-.663.017-.249.02-.605.073-.979.263a2.57 2.57 0 0 0-1.124 1.124c-.19.373-.242.73-.263.979-.017.215-.017.459-.017.663v4.194c0 .204 0 .448.018.662.02.25.072.606.262.98.247.483.64.877 1.124 1.123.374.19.73.243.98.263.214.018.458.017.662.017h2.48c.204 0 .448 0 .662-.017.25-.02.606-.072.98-.263.483-.246.877-.64 1.123-1.124.19-.373.243-.73.263-.979.018-.215.018-.458.018-.663V14.19c0-.204 0-.448-.018-.663a2.583 2.583 0 0 0-.263-.98 2.57 2.57 0 0 0-1.123-1.123 2.583 2.583 0 0 0-.98-.263 8.467 8.467 0 0 0-.663-.017h-.04Zm-3.772 3.085c0-.48 0-.72.094-.903a.857.857 0 0 1 .374-.375c.184-.093.424-.093.904-.093h2.4c.48 0 .72 0 .903.093a.857.857 0 0 1 .375.375c.093.183.093.423.093.903v4.115c0 .48 0 .72-.093.903a.857.857 0 0 1-.375.375c-.183.093-.423.093-.903.093h-2.4c-.48 0-.72 0-.904-.093a.857.857 0 0 1-.374-.375c-.094-.183-.094-.423-.094-.903v-4.114ZM8.057 2.572h-2.44c-.204 0-.448 0-.662.018-.25.02-.606.072-.98.263-.483.246-.877.64-1.123 1.123-.19.374-.243.73-.263.98a8.453 8.453 0 0 0-.018.662v4.194c0 .204 0 .448.018.663.02.249.072.605.263.979.246.484.64.877 1.123 1.124.374.19.73.242.98.263.214.017.458.017.662.017h2.48c.204 0 .448 0 .663-.017.249-.02.605-.073.979-.263.484-.247.877-.64 1.124-1.124.19-.374.242-.73.263-.98.017-.214.017-.458.017-.662V5.617c0-.204 0-.448-.018-.663a2.585 2.585 0 0 0-.262-.979 2.571 2.571 0 0 0-1.124-1.123 2.585 2.585 0 0 0-.98-.263 8.453 8.453 0 0 0-.662-.018h-.04ZM4.286 5.657c0-.48 0-.72.093-.903a.857.857 0 0 1 .375-.375c.183-.093.423-.093.903-.093h2.4c.48 0 .72 0 .904.093a.857.857 0 0 1 .374.375c.094.183.094.423.094.903v4.114c0 .48 0 .72-.094.904a.857.857 0 0 1-.374.374c-.184.094-.424.094-.904.094h-2.4c-.48 0-.72 0-.903-.094a.857.857 0 0 1-.375-.374c-.093-.184-.093-.424-.093-.904V5.657Z",
    fill: "#023F80"
  })));
};

var _path$2_;
function _extends$31() { _extends$31 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$31.apply(this, arguments); }
var SvgInsumoPapel = function SvgInsumoPapel(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$31({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2_ || (_path$2_ = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.104 4.375c5.218 0 9.327 1.806 9.475 4.136l.004.13v3.317H24.9a.474.474 0 0 1 .32.824l-1.515 1.389 1.515 1.387a.475.475 0 0 1 0 .7l-1.515 1.388 1.515 1.388a.475.475 0 0 1 0 .699l-1.515 1.388 1.515 1.389a.474.474 0 0 1-.32.823H12.104c-5.315 0-9.479-1.874-9.479-4.265V8.64c0-2.392 4.164-4.266 9.48-4.266ZM3.572 10.53v8.538c0 1.537 3.366 3.247 8.232 3.315l.3.002h11.579l-.998-.914a.474.474 0 0 1 0-.7l1.514-1.387-1.514-1.389a.476.476 0 0 1 0-.699l1.514-1.389-1.514-1.387a.475.475 0 0 1 0-.7l.998-.914H12.104c-3.798 0-7.009-.957-8.532-2.376Zm14.555 1.428h2.508l.001-1.428c-.598.557-1.457 1.043-2.509 1.428Zm-6.023-6.635c-5.028 0-8.531 1.749-8.531 3.318 0 1.568 3.503 3.317 8.531 3.317 5.028 0 8.531-1.749 8.531-3.317 0-1.57-3.503-3.318-8.53-3.318Zm0 1.422c2.283 0 4.74.593 4.74 1.896 0 1.302-2.457 1.895-4.74 1.895-2.282 0-4.74-.593-4.74-1.895 0-1.303 2.458-1.896 4.74-1.896Zm0 .948c-2.488 0-3.792.704-3.792.948 0 .243 1.304.948 3.792.948 2.488 0 3.792-.705 3.792-.948 0-.244-1.304-.948-3.792-.948Z",
    fill: "#023F80"
  })));
};

var _path$2$;
function _extends$32() { _extends$32 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$32.apply(this, arguments); }
var SvgIpadOutline = function SvgIpadOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$32({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2$ || (_path$2$ = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8 2h-.041c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C4 6.29 4 6.954 4 7.758v12.483c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C8.29 26 8.954 26 9.758 26h8.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V7.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C19.71 2 19.046 2 18.242 2H9.8ZM7.092 4.218c.156-.08.38-.145.819-.18C8.361 4 8.943 4 9.8 4h8.4c.857 0 1.439 0 1.889.038.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819C22 6.361 22 6.943 22 7.8v12.4c0 .857 0 1.439-.038 1.889-.035.438-.1.663-.18.819a2 2 0 0 1-.874.874c-.156.08-.38.145-.819.18-.45.037-1.032.038-1.889.038H9.8c-.857 0-1.439 0-1.889-.038-.438-.035-.663-.1-.819-.18a2 2 0 0 1-.874-.874c-.08-.156-.145-.38-.18-.819C6 21.639 6 21.057 6 20.2V7.8c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874ZM14 19a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
    fill: "#023F80"
  })));
};

var _path$30, _path2$R;
function _extends$33() { _extends$33 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$33.apply(this, arguments); }
var SvgKeyOutline = function SvgKeyOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$33({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$30 || (_path$30 = /*#__PURE__*/createElement$2("path", {
    d: "M8 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: "#023F80"
  })), _path2$R || (_path2$R = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7 2.1a.9.9 0 0 0-.64.267l-6.8 6.868A5.9 5.9 0 1 0 14.9 15c0-.435-.069-.97-.167-1.463a9.482 9.482 0 0 0-.15-.637H16a.9.9 0 0 0 .9-.9v-1.6H18a.9.9 0 0 0 .9-.9V7.9H20a.9.9 0 0 0 .9-.9V3a.9.9 0 0 0-.9-.9h-2.3Zm-6.527 8.773L18.076 3.9H19.1v2.2H18a.9.9 0 0 0-.9.9v1.6H16a.9.9 0 0 0-.9.9v1.6H14a.9.9 0 0 0-.636.264l-.5.5a.9.9 0 0 0-.189.996c.098.223.207.6.293 1.029.085.427.132.836.132 1.111a4.1 4.1 0 1 1-2.843-3.904.9.9 0 0 0 .916-.223Z",
    fill: "#023F80"
  })));
};

var _path$31;
function _extends$34() { _extends$34 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$34.apply(this, arguments); }
var SvgKeySquareOutline = function SvgKeySquareOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$34({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$31 || (_path$31 = /*#__PURE__*/createElement$2("path", {
    d: "M17.59 3c2.183 0 3.233.203 4.324.786a5.543 5.543 0 0 1 2.3 2.3c.553 1.034.764 2.03.784 3.988L25 17.59c0 2.183-.203 3.233-.786 4.324a5.543 5.543 0 0 1-2.3 2.3c-1.034.553-2.03.764-3.988.784L16 25a1 1 0 0 1-.117-1.993L16 23h1.59l.558-.005c1.479-.028 2.141-.18 2.823-.545a3.544 3.544 0 0 0 1.48-1.48c.364-.68.516-1.343.544-2.822L23 17.59v-7.18l-.005-.558c-.028-1.479-.18-2.141-.545-2.823a3.544 3.544 0 0 0-1.48-1.48c-.68-.364-1.343-.516-2.822-.544L17.59 5h-7.18l-.558.005c-1.479.028-2.141.18-2.823.545-.64.342-1.137.839-1.48 1.48-.364.68-.516 1.343-.544 2.822L5 10.41v1.593a1 1 0 0 1-1.993.117L3 12.003V10.41c0-2.183.203-3.233.786-4.324a5.543 5.543 0 0 1 2.3-2.3c1.034-.553 2.03-.764 3.988-.784L17.59 3ZM19 8a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-1.501l.001 1.5a1 1 0 0 1-.883.993l-.117.007-2.594-.001.029.153c.029.185.048.373.058.563L14 19.5a5.5 5.5 0 1 1-4.53-5.415l.025.005 5.798-5.797a1 1 0 0 1 .576-.284L16 8h3Zm-1.001 2h-1.585l-5.9 5.9a1 1 0 0 1-.878.278l-.119-.028a3.5 3.5 0 1 0 2.12 1.795 1 1 0 0 1 .895-1.445H15.5L15.5 15a1 1 0 0 1 .883-.993L16.5 14h1.499v-4ZM8 19a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z",
    fill: "#023F80"
  })));
};

var _path$32;
function _extends$35() { _extends$35 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$35.apply(this, arguments); }
var SvgKeyboardBotsOutline = function SvgKeyboardBotsOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$35({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$32 || (_path$32 = /*#__PURE__*/createElement$2("path", {
    d: "M16.308 3c2.59 0 3.818.237 5.094.92a6.451 6.451 0 0 1 2.678 2.678c.683 1.276.92 2.504.92 5.094v4.616c0 2.59-.237 3.818-.92 5.094a6.45 6.45 0 0 1-2.678 2.678c-1.276.683-2.504.92-5.094.92h-4.616c-2.59 0-3.818-.237-5.094-.92a6.451 6.451 0 0 1-2.678-2.678C3.237 20.126 3 18.898 3 16.308v-4.616c0-2.59.237-3.818.92-5.094A6.452 6.452 0 0 1 6.598 3.92C7.874 3.237 9.102 3 11.692 3h4.616Zm0 2h-4.616c-2.288 0-3.204.177-4.15.683a4.452 4.452 0 0 0-1.859 1.858C5.177 8.488 5 9.404 5 11.691v4.617c0 2.288.177 3.204.683 4.15a4.452 4.452 0 0 0 1.858 1.859c.947.506 1.863.683 4.15.683h4.617c2.288 0 3.204-.177 4.15-.683a4.452 4.452 0 0 0 1.859-1.858c.506-.947.683-1.863.683-4.15v-4.617c0-2.288-.177-3.204-.683-4.15a4.452 4.452 0 0 0-1.858-1.859C19.512 5.177 18.596 5 16.309 5ZM11 15a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm6 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm-6-6a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm6 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z",
    fill: "#023F80"
  })));
};

var _path$33;
function _extends$36() { _extends$36 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$36.apply(this, arguments); }
var SvgKeyboardOutline = function SvgKeyboardOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$36({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$33 || (_path$33 = /*#__PURE__*/createElement$2("path", {
    d: "M9.692 4h8.616c2.675 0 3.645.278 4.622.801A5.452 5.452 0 0 1 25.2 7.07c.522.978.801 1.948.801 4.623v4.616c0 2.675-.279 3.645-.801 4.622A5.452 5.452 0 0 1 22.93 23.2c-.977.522-1.947.801-4.622.801H9.692c-2.675 0-3.645-.279-4.623-.801a5.452 5.452 0 0 1-2.268-2.269C2.278 19.953 2 18.983 2 16.308v-4.616c0-2.675.278-3.645.801-4.623A5.452 5.452 0 0 1 5.07 4.801C6.047 4.278 7.017 4 9.692 4Zm0 2c-2.137 0-2.897.147-3.68.565a3.453 3.453 0 0 0-1.447 1.448C4.147 8.795 4 9.555 4 11.692v4.616c0 2.137.147 2.898.565 3.68.337.629.818 1.11 1.448 1.447.782.418 1.542.565 3.679.565h8.616c2.137 0 2.898-.147 3.68-.565a3.452 3.452 0 0 0 1.447-1.448c.418-.781.565-1.542.565-3.679v-4.616c0-2.137-.147-2.897-.565-3.68a3.452 3.452 0 0 0-1.448-1.447C21.206 6.147 20.445 6 18.308 6H9.692ZM8 11.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm4 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm4 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm4 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-4 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-4 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-4 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm1 2h10a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2Z",
    fill: "#023F80"
  })));
};

var _path$34;
function _extends$37() { _extends$37 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$37.apply(this, arguments); }
var SvgKnifeOutline = function SvgKnifeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$37({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$34 || (_path$34 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.348 3.796a2.731 2.731 0 0 1 3.797-.056 2.708 2.708 0 0 1 .063 3.888l-4.735 4.747.662.66c.221.22.316.512.238.847-.04.164-.127.307-.228.441a6.633 6.633 0 0 1-.517.585c-1.079 1.118-2.264 2.139-3.435 3.157C11 20 9.033 20.438 6.977 20.8c-1.477.2-2.84.2-3.482.2-1.5 0-2-1.495-.9-2.592L11.97 9.16l.003-.002 5.374-5.36Zm-4.742 7.264S7.5 16 4.456 19.128C7.799 19.128 10 18.5 12.8 16c1.821-1.584 1.988-1.78 2.476-2.28l-2.67-2.66Zm2.594.047 4.731-4.744a.917.917 0 0 0-.021-1.318.926.926 0 0 0-1.288.02l-4.74 4.728 1.318 1.314Z",
    fill: "#023F80"
  })));
};

var _path$35;
function _extends$38() { _extends$38 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$38.apply(this, arguments); }
var SvgLaptopOutline = function SvgLaptopOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$38({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$35 || (_path$35 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2 5.1h-.035c-.53 0-.981 0-1.352.03-.389.032-.768.102-1.13.286a2.9 2.9 0 0 0-1.267 1.267c-.184.362-.254.74-.286 1.13-.03.37-.03.822-.03 1.352V17.1H2.063c-1.13 0-1.322 1.618-.223 1.882l1.815.435c.23.055.464.083.7.083h15.29c.236 0 .47-.028.7-.083l1.815-.435c1.099-.264.908-1.882-.223-1.882H20.9V9.165c0-.53 0-.981-.03-1.352-.032-.39-.102-.768-.286-1.13a2.9 2.9 0 0 0-1.267-1.267c-.362-.184-.74-.254-1.13-.286-.37-.03-.822-.03-1.352-.03H7.2Zm11.9 12V9.2c0-.575 0-.952-.024-1.24-.023-.278-.062-.394-.096-.46a1.1 1.1 0 0 0-.48-.48c-.066-.034-.182-.073-.46-.096-.288-.023-.665-.024-1.24-.024H7.2c-.575 0-.952 0-1.24.024-.278.023-.393.062-.46.096a1.1 1.1 0 0 0-.48.48c-.034.066-.073.182-.096.46-.023.288-.024.665-.024 1.24v7.9h14.2Z",
    fill: "#023F80"
  })));
};

var _path$36;
function _extends$39() { _extends$39 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$39.apply(this, arguments); }
var SvgLifebuoyOutline = function SvgLifebuoyOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$39({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$36 || (_path$36 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.1A9.872 9.872 0 0 0 5 5a9.872 9.872 0 0 0-2.9 7c0 2.734 1.11 5.21 2.9 7a9.872 9.872 0 0 0 7 2.9c2.734 0 5.21-1.11 7-2.9a9.872 9.872 0 0 0 2.9-7c0-2.734-1.109-5.21-2.9-7a9.872 9.872 0 0 0-7-2.9Zm0 6.8c-.856 0-1.63.346-2.192.908A3.087 3.087 0 0 0 8.9 12c0 .856.346 1.63.908 2.192A3.087 3.087 0 0 0 12 15.1c.856 0 1.63-.346 2.192-.908A3.087 3.087 0 0 0 15.1 12c0-.856-.346-1.63-.908-2.192A3.087 3.087 0 0 0 12 8.9Zm8.1 3.1c0-1.913-.662-3.67-1.771-5.056L16.043 9.23A4.88 4.88 0 0 1 16.9 12a4.88 4.88 0 0 1-.857 2.77l2.286 2.286A8.063 8.063 0 0 0 20.1 12ZM12 20.1a8.063 8.063 0 0 1-5.056-1.771l2.286-2.287A4.88 4.88 0 0 0 12 16.9a4.88 4.88 0 0 0 2.77-.857l2.286 2.286A8.063 8.063 0 0 1 12 20.1ZM3.9 12c0-1.913.662-3.67 1.771-5.056L7.958 9.23A4.88 4.88 0 0 0 7.1 12a4.88 4.88 0 0 0 .858 2.77L5.67 17.056A8.063 8.063 0 0 1 3.901 12Zm3.044-6.329A8.063 8.063 0 0 1 12 3.9c1.913 0 3.67.662 5.056 1.771L14.77 7.957A4.88 4.88 0 0 0 12 7.1a4.88 4.88 0 0 0-2.77.857L6.944 5.671Z",
    fill: "#023F80"
  })));
};

var _path$37;
function _extends$3a() { _extends$3a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3a.apply(this, arguments); }
var SvgLightbulbOutline = function SvgLightbulbOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3a({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$37 || (_path$37 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2C8.446 2 4 6.48 4 12c0 2.85.986 4.693 2.165 6.128.45.55.94 1.05 1.379 1.499l.322.33c.492.51.897.962 1.202 1.437l.507 2.03.032.128c.128.518.257 1.037.563 1.446a2.5 2.5 0 0 0 1.033.807c.471.198 1.006.197 1.54.195H15.257c.534.002 1.069.003 1.54-.195a2.5 2.5 0 0 0 1.033-.807c.307-.409.435-.928.563-1.446l.032-.127.507-2.031c.305-.475.71-.927 1.202-1.436.103-.107.21-.218.322-.331.44-.45.928-.95 1.38-1.499C23.013 16.693 24 14.85 24 12c0-5.552-4.448-10-10-10ZM6 12c0-4.42 3.554-8 8-8 4.448 0 8 3.552 8 8 0 2.3-.764 3.707-1.71 4.86-.39.474-.802.895-1.234 1.337-.119.122-.24.245-.361.372-.42.435-.855.905-1.233 1.431H15v-2.5l1.6-1.2a1 1 0 0 0-1.2-1.6L14 15.75l-1.4-1.05a1 1 0 0 0-1.2 1.6l1.6 1.2V20h-2.463c-.377-.526-.811-.996-1.231-1.431l-.362-.372a20.744 20.744 0 0 1-1.234-1.338C6.764 15.707 6 14.3 6 12Zm5.28 10 .236.94c.185.74.224.818.255.86a.5.5 0 0 0 .206.161c.048.02.134.039.897.039h2.252c.763 0 .849-.02.897-.039a.5.5 0 0 0 .206-.161c.031-.042.07-.12.255-.86l.235-.94h-5.438Z",
    fill: "#023F80"
  })));
};

var _path$38;
function _extends$3b() { _extends$3b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3b.apply(this, arguments); }
var SvgLightbulbStarOutline = function SvgLightbulbStarOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3b({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$38 || (_path$38 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4 10.5a6.6 6.6 0 0 1 9.68-5.84.9.9 0 0 0 .84-1.59A8.352 8.352 0 0 0 12 2.1a8.4 8.4 0 0 0-8.4 8.4c0 2.373 1.02 3.953 2.107 5.156.355.393.743.772 1.089 1.11.158.154.307.3.44.434.424.428.727.78.914 1.117l.247 1.06c.072.308.136.584.208.812.076.246.177.494.349.728.255.349.599.622.996.791.268.114.532.156.789.175.238.017.521.017.837.017h.848c.316 0 .6 0 .838-.017.256-.02.52-.061.788-.175a2.4 2.4 0 0 0 .997-.79c.171-.235.272-.483.349-.729.07-.228.135-.504.207-.811l.248-1.062c.272-.492.76-.97 1.445-1.64.85-.83 1.676-1.693 2.25-2.745a.9.9 0 1 0-1.581-.862c-.507.93-1.266 1.676-2.017 2.408-.499.485-1.05 1.022-1.459 1.623H12.9v-2.118l1.1-.733a.9.9 0 1 0-1-1.498l-1 .667-1-.667a.9.9 0 0 0-1 1.498l1.1.733V17.1H9.512c-.292-.43-.65-.815-.997-1.167-.176-.177-.348-.344-.517-.51-.323-.315-.637-.62-.955-.973C6.13 13.439 5.4 12.27 5.4 10.5Zm4.744 8.44-.01-.04h3.732l-.01.04c-.08.345-.13.556-.179.713a.699.699 0 0 1-.083.201.6.6 0 0 1-.25.198.69.69 0 0 1-.214.035c-.165.012-.381.013-.734.013h-.791c-.354 0-.57 0-.735-.013a.69.69 0 0 1-.215-.035.6.6 0 0 1-.249-.198.695.695 0 0 1-.083-.2c-.05-.158-.099-.37-.18-.713Zm7.932-14.635a.447.447 0 0 1 .848 0l.457 1.373c.148.444.497.793.942.941l1.372.457a.447.447 0 0 1 0 .848l-1.372.457a1.489 1.489 0 0 0-.942.941l-.457 1.373a.447.447 0 0 1-.848 0l-.457-1.373a1.489 1.489 0 0 0-.941-.941l-1.373-.457a.447.447 0 0 1 0-.848l1.373-.457c.444-.148.793-.497.941-.941l.457-1.373Z",
    fill: "#023F80"
  })));
};

var _path$39;
function _extends$3c() { _extends$3c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3c.apply(this, arguments); }
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3c({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$39 || (_path$39 = /*#__PURE__*/createElement$2("path", {
    d: "M9.026 4.88A6.526 6.526 0 0 0 2.5 11.406c0 3.613 1.445 5.421 7.493 10.126l2.78 2.16a2 2 0 0 0 2.455 0l2.779-2.16c6.048-4.705 7.493-6.513 7.493-10.126a6.526 6.526 0 0 0-6.526-6.526c-1.872 0-3.538.85-4.974 2.487C12.564 5.73 10.898 4.88 9.026 4.88Z",
    fill: "#023F80"
  })));
};

var _path$3a;
function _extends$3d() { _extends$3d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3d.apply(this, arguments); }
var SvgLikeFilled = function SvgLikeFilled(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3d({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3a || (_path$3a = /*#__PURE__*/createElement$2("path", {
    d: "M7.737 4.183a5.594 5.594 0 0 0-5.594 5.594c0 3.097 1.238 4.647 6.423 8.679l2.381 1.852a1.714 1.714 0 0 0 2.105 0l2.382-1.852c5.185-4.032 6.423-5.582 6.423-8.68a5.594 5.594 0 0 0-5.594-5.593c-1.604 0-3.032.729-4.263 2.131-1.23-1.402-2.659-2.131-4.263-2.131Z",
    fill: "#023F80"
  })));
};

var _path$3b, _path2$S;
function _extends$3e() { _extends$3e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3e.apply(this, arguments); }
var SvgLikeLockOutline = function SvgLikeLockOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3e({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3b || (_path$3b = /*#__PURE__*/createElement$2("path", {
    d: "M9.078 5C5.483 5 2.5 7.875 2.5 11.478c0 1.93.516 3.418 1.77 4.954 1.193 1.461 3.068 2.98 5.725 5.038l3.394 2.621a1 1 0 1 0 1.222-1.582l-3.392-2.62c-2.7-2.091-4.378-3.47-5.4-4.722-.96-1.176-1.319-2.216-1.319-3.689C4.5 9.018 6.548 7 9.078 7c1.394 0 2.776.982 4.153 2.64a1 1 0 0 0 1.544-.009C16.116 7.985 17.498 7 18.922 7c2.53 0 4.578 2.019 4.578 4.478 0 .49-.04.92-.122 1.315l-.022.103-.014.062a1 1 0 1 0 1.944.47 6.285 6.285 0 0 0 .05-.226 8.472 8.472 0 0 0 .164-1.724C25.5 7.875 22.517 5 18.922 5c-1.966 0-3.608 1.11-4.928 2.493C12.662 6.114 11.022 5 9.078 5Z",
    fill: "#023F80"
  })), _path2$S || (_path2$S = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 18.492a2.994 2.994 0 0 0-3-2.992l-.176.005a3.003 3.003 0 0 0-2.824 2.996V20l-.748.001a.76.76 0 0 0-.752.76v4.48c0 .42.337.76.752.76h7.496a.76.76 0 0 0 .752-.76v-4.48c0-.42-.337-.76-.752-.76l-.748-.001v-1.507Zm-3.145-1.485L21.5 17c.828 0 1.5.666 1.5 1.5V20h-3v-1.5c0-.78.59-1.42 1.355-1.493Z",
    fill: "#023F80"
  })));
};

var _path$3c;
function _extends$3f() { _extends$3f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3f.apply(this, arguments); }
var SvgLikeOutline = function SvgLikeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3f({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3c || (_path$3c = /*#__PURE__*/createElement$2("path", {
    d: "M15.992 4.006c-1.452.064-2.753.637-3.881 1.694l-.117.113-.122-.118C10.662 4.576 9.275 4 7.734 4 4.577 4 2 6.56 2 9.717c0 3.088 1.127 4.552 6.182 8.546l2.688 2.098a1.838 1.838 0 0 0 2.26 0l2.364-1.843.933-.74C20.965 14.144 22 12.676 22 9.718 22 6.56 19.423 4 16.266 4l-.274.006Zm.274 1.794c2.165 0 3.934 1.757 3.934 3.917l-.005.294c-.076 2.156-1.062 3.341-5.509 6.852l-2.663 2.078a.038.038 0 0 1-.046 0l-2.364-1.843-.874-.691c-4.142-3.31-4.939-4.44-4.939-6.69C3.8 7.557 5.569 5.8 7.734 5.8c1.333 0 2.507.618 3.57 1.915a.9.9 0 0 0 1.398-.007C13.739 6.416 14.909 5.8 16.266 5.8Z",
    fill: "#023F80"
  })));
};

var _path$3d;
function _extends$3g() { _extends$3g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3g.apply(this, arguments); }
var SvgLinkCircleOutline = function SvgLinkCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3g({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3d || (_path$3d = /*#__PURE__*/createElement$2("path", {
    d: "M14 2c6.627 0 12 5.373 12 12s-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2Zm0 2C8.477 4 4 8.477 4 14s4.477 10 10 10 10-4.477 10-10S19.523 4 14 4Zm4 5a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-3.586l-6.293 6.293a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1 0-1.414L15.584 11H12a1 1 0 0 1-.993-.883L11 10a1 1 0 0 1 1-1h6Z",
    fill: "#023F80"
  })));
};

var _path$3e;
function _extends$3h() { _extends$3h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3h.apply(this, arguments); }
var SvgLinkOutline = function SvgLinkOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3h({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3e || (_path$3e = /*#__PURE__*/createElement$2("path", {
    d: "M20.708 6.292a1 1 0 0 1 1 1v10.5a1 1 0 1 1-2 0V9.705l-12 12.002a1 1 0 0 1-1.32.083l-.095-.083a1 1 0 0 1 0-1.414l12-12.001h-8.085a1 1 0 0 1-.993-.884l-.007-.116a1 1 0 0 1 1-1h10.5Z",
    fill: "#023F80"
  })));
};

var _path$3f;
function _extends$3i() { _extends$3i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3i.apply(this, arguments); }
var SvgLinkedOutline = function SvgLinkedOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3i({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3f || (_path$3f = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.49 4.293a4.402 4.402 0 0 1 6.225 6.225l-1.072 1.072a.9.9 0 0 1-1.273-1.274l1.071-1.071a2.601 2.601 0 1 0-3.678-3.679l-3.537 3.537a2.601 2.601 0 0 0 0 3.679.9.9 0 1 1-1.274 1.273 4.402 4.402 0 0 1 0-6.225l3.537-3.537Zm-.708 5.66a.9.9 0 0 1 1.273 0 4.402 4.402 0 0 1 0 6.224l-3.537 3.538a4.402 4.402 0 0 1-6.225-6.226l1.122-1.122a.9.9 0 0 1 1.273 1.274l-1.122 1.122a2.601 2.601 0 1 0 3.679 3.678l3.537-3.537a2.601 2.601 0 0 0 0-3.678.9.9 0 0 1 0-1.274Z",
    fill: "#023F80"
  })));
};

var _path$3g;
function _extends$3j() { _extends$3j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3j.apply(this, arguments); }
var SvgLiquidaciones1 = function SvgLiquidaciones1(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3j({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3g || (_path$3g = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.727 4.727A10.256 10.256 0 0 1 12 1.714c2.84 0 5.413 1.153 7.273 3.013A10.256 10.256 0 0 1 22.286 12c0 2.84-1.152 5.413-3.013 7.273A10.256 10.256 0 0 1 12 22.286c-2.84 0-5.413-1.152-7.273-3.013A10.256 10.256 0 0 1 1.714 12c0-2.84 1.152-5.413 3.013-7.273ZM12 3.429a8.542 8.542 0 0 0-6.061 2.51A8.542 8.542 0 0 0 3.429 12c0 2.367.958 4.509 2.51 6.061a8.542 8.542 0 0 0 6.06 2.51 8.542 8.542 0 0 0 6.062-2.51 8.542 8.542 0 0 0 2.51-6.06 8.542 8.542 0 0 0-2.51-6.062A8.542 8.542 0 0 0 12 3.43ZM12.19 6c.474 0 .858.384.858.857v1.226c.392.114.77.308 1.085.592l.008.007.005.006a.857.857 0 0 1-1.162 1.26l-.001-.002c-.178-.158-.473-.27-.803-.272-.335-.002-.586.108-.717.24l-.02.02-.02.018c-.057.052-.164.227-.184.499-.021.273.06.417.09.448l.007.006.005.007c.088.092.35.262.925.424.43.115.803.242 1.106.397l.004.002c.324.169.642.405.87.765.23.362.322.772.325 1.203v.003c.003.552-.152 1.043-.457 1.436-.292.378-.68.61-1.066.743v1.258a.857.857 0 0 1-1.715 0v-1.184a2.917 2.917 0 0 1-.572-.191l-.01-.005-.01-.005c-.335-.165-.756-.477-1-.677a.857.857 0 1 1 1.089-1.325c.211.174.502.38.657.459.263.116.682.155.996.051a.557.557 0 0 0 .276-.174c.043-.055.099-.16.098-.376-.002-.196-.04-.27-.057-.296-.018-.029-.064-.085-.212-.163-.147-.075-.388-.164-.77-.266l-.011-.003c-.666-.188-1.295-.461-1.707-.894-.492-.506-.614-1.211-.57-1.774.042-.559.262-1.197.732-1.629a2.492 2.492 0 0 1 1.071-.615V6.857c0-.473.384-.857.857-.857Z",
    fill: "#023F80"
  })));
};

var _path$3h;
function _extends$3k() { _extends$3k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3k.apply(this, arguments); }
var SvgLiquidaciones = function SvgLiquidaciones(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3k({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3h || (_path$3h = /*#__PURE__*/createElement$2("path", {
    d: "M15.253 3.428c1 0 1.517.1 2.055.388.498.267.895.663 1.162 1.162.272.509.376.998.386 1.897.724.046 1.186.173 1.661.427.569.304 1.02.755 1.324 1.323.33.618.445 1.211.445 2.386v5.407c0 1.174-.115 1.768-.445 2.385a3.194 3.194 0 0 1-1.324 1.324c-.617.33-1.21.444-2.385.444H5.868c-1.175 0-1.768-.114-2.385-.444a3.194 3.194 0 0 1-1.324-1.324c-.33-.617-.445-1.21-.445-2.385V6.857h.002V6.81c.015-.857.12-1.336.386-1.832a2.804 2.804 0 0 1 1.161-1.162c.538-.288 1.055-.388 2.055-.388h9.935Zm2.88 5.143H3.428v7.847c0 .915.062 1.241.242 1.576.144.27.35.477.62.62.335.18.661.243 1.577.243h12.264c.916 0 1.242-.063 1.577-.242.27-.144.476-.35.62-.62.18-.336.242-.662.242-1.577V11.01c0-.916-.063-1.242-.242-1.577a1.48 1.48 0 0 0-.62-.62c-.335-.18-.661-.243-1.577-.243Zm-.99 4.286a.857.857 0 0 1 0 1.714h-1.715a.857.857 0 1 1 0-1.714h1.715Zm-1.89-7.714H5.318c-.741 0-.99.048-1.246.185a1.09 1.09 0 0 0-.459.458c-.125.234-.176.464-.183 1.071h13.712c-.008-.607-.059-.837-.184-1.07a1.09 1.09 0 0 0-.458-.46c-.256-.136-.506-.184-1.247-.184Z",
    fill: "#023F80"
  })));
};

var _path$3i;
function _extends$3l() { _extends$3l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3l.apply(this, arguments); }
var SvgListAddOutline = function SvgListAddOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3l({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3i || (_path$3i = /*#__PURE__*/createElement$2("path", {
    d: "M17.9 11.9a.9.9 0 1 0-1.8 0v3.2h-3.2a.9.9 0 1 0 0 1.8h3.2v3.2a.9.9 0 0 0 1.8 0v-3.2h3.2a.9.9 0 0 0 0-1.8h-3.2v-3.2ZM3.9 6.9h14.2a.9.9 0 1 0 0-1.8H3.9a.9.9 0 1 0 0 1.8ZM3.9 10.1a.9.9 0 1 0 0 1.8h9.2a.9.9 0 0 0 0-1.8H3.9ZM3.9 15.1a.9.9 0 1 0 0 1.8h5.2a.9.9 0 0 0 0-1.8H3.9Z",
    fill: "#023F80"
  })));
};

var _path$3j;
function _extends$3m() { _extends$3m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3m.apply(this, arguments); }
var SvgListCheckOutline = function SvgListCheckOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3m({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3j || (_path$3j = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.701 14.287a1 1 0 0 1 .095 1.319l-.083.095-6.862 7a1 1 0 0 1-1.33.086l-.095-.084-4.137-4.188a1 1 0 0 1 1.329-1.49l.093.084 3.424 3.466 6.152-6.276a1 1 0 0 1 1.414-.012ZM9.5 17a1 1 0 1 1 0 2h-5a1 1 0 1 1 0-2h5Zm12-6a1 1 0 1 1 0 2h-17a1 1 0 1 1 0-2h17Zm0-6a1 1 0 1 1 0 2h-17a1 1 0 0 1 0-2h17Z",
    fill: "#023F80"
  })));
};

var _path$3k, _path2$T;
function _extends$3n() { _extends$3n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3n.apply(this, arguments); }
var SvgListLikeOutline = function SvgListLikeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3n({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3k || (_path$3k = /*#__PURE__*/createElement$2("path", {
    d: "M4 6.9h14.5a.9.9 0 0 0 0-1.8H4a.9.9 0 1 0 0 1.8ZM4 10.1a.9.9 0 1 0 0 1.8h3a.9.9 0 0 0 0-1.8H4ZM4 15.1a.9.9 0 1 0 0 1.8h2.5a.9.9 0 0 0 0-1.8H4Z",
    fill: "#023F80"
  })), _path2$T || (_path2$T = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.117 10C10.904 10 9 11.695 9 13.918c0 1.152.336 2.065 1.117 2.98.724.85 1.846 1.714 3.38 2.832l1.135.826a2.333 2.333 0 0 0 2.737 0l1.134-.826c1.534-1.118 2.656-1.983 3.38-2.832.78-.915 1.117-1.828 1.117-2.98C23 11.695 21.096 10 18.883 10c-1.024 0-2.036.384-2.883 1.107-.847-.723-1.859-1.107-2.883-1.107Zm-2.29 3.918c0-1.093.964-2.085 2.29-2.085.774 0 1.527.626 1.992 1.012l.178.147a6.2 6.2 0 0 1 .302.257c.17.153.238.214.411.214.17 0 .235-.059.396-.204.077-.069.175-.157.317-.267.069-.054.147-.12.234-.191.467-.388 1.166-.968 1.775-.968 1.326 0 2.452.992 2.452 2.085 0 .703-.173 1.196-.678 1.787-.56.657-1.498 1.399-3.065 2.54l-1.135.828a.513.513 0 0 1-.592 0l-1.135-.827c-1.567-1.142-2.505-1.884-3.065-2.54-.505-.592-.678-1.085-.678-1.788Z",
    fill: "#023F80"
  })));
};

var _path$3l;
function _extends$3o() { _extends$3o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3o.apply(this, arguments); }
var SvgListLikeSlashOutline = function SvgListLikeSlashOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3o({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3l || (_path$3l = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.707 3.293a1 1 0 0 0-1.414 1.414L5.586 6H4.5a1 1 0 0 0 0 2h3.086l5.014 5.014a4.544 4.544 0 0 0-1.6 3.253c-.01.665.04 1.244.204 1.788.169.554.438 1.012.783 1.458.718.925 1.903 1.982 3.814 3.408l1.143.85a2.613 2.613 0 0 0 3.105.006l1.927-1.387 2.317 2.317a1 1 0 0 0 1.542-1.258L7.293 4.907a1.005 1.005 0 0 1-.128-.156L5.707 3.293Zm7.29 4.489-.107-.106A1.038 1.038 0 0 1 12.65 7c0-.552.398-1 .95-1h7.9a1 1 0 1 1 0 2h-7.9a.921.921 0 0 1-.604-.218Zm1.028 6.658c-.585.417-.972 1.095-1.026 1.883-.007.539.038.884.12 1.151.078.26.208.503.449.813.543.7 1.544 1.624 3.43 3.032l1.142.85a.613.613 0 0 0 .72 0l.014-.01 1.669-1.202-6.518-6.517ZM8 18a1 1 0 1 1 0 2H4.5a1 1 0 1 1 0-2H8Zm.5-6a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h4Zm13.073 1.98a2.095 2.095 0 0 0-.943.197 1 1 0 1 1-.886-1.793c.206-.102.405-.168.542-.213h.002c.448-.148.886-.191 1.29-.191h.012c1.247.013 2.344.579 3.12 1.362.767.775 1.29 1.838 1.29 2.941 0 .631-.027 1.263-.259 1.909a1 1 0 0 1-1.882-.676c.108-.301.141-.64.141-1.232 0-.48-.242-1.06-.712-1.535-.462-.467-1.073-.76-1.715-.769Z",
    fill: "#023F80"
  })));
};

var _path$3m;
function _extends$3p() { _extends$3p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3p.apply(this, arguments); }
var SvgListOutline = function SvgListOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3p({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3m || (_path$3m = /*#__PURE__*/createElement$2("path", {
    d: "M4.5 14c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5-1.5.67-1.5 1.5Zm0-6c0 .83.67 1.5 1.5 1.5S7.5 8.83 7.5 8 6.83 6.5 6 6.5 4.5 7.17 4.5 8Zm0 12c0 .823.677 1.5 1.5 1.5s1.5-.677 1.5-1.5a1.5 1.5 0 1 0-3 0ZM25 20a1 1 0 0 0-1-1H10a1 1 0 1 0 0 2h14a1 1 0 0 0 1-1Zm0-6a1 1 0 0 0-1-1H10a1 1 0 1 0 0 2h14a1 1 0 0 0 1-1ZM10 9h14a1 1 0 1 0 0-2H10a1 1 0 0 0 0 2Z",
    fill: "#023F80"
  })));
};

var _path$3n, _path2$U, _path3$i;
function _extends$3q() { _extends$3q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3q.apply(this, arguments); }
var SvgLiveAddOutline = function SvgLiveAddOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3n || (_path$3n = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.9a8.1 8.1 0 0 0-1.006 16.138.9.9 0 1 1-.221 1.787C5.883 21.218 2.1 17.052 2.1 12c0-5.468 4.432-9.9 9.9-9.9 5.052 0 9.219 3.783 9.824 8.671a.9.9 0 0 1-1.786.222A8.102 8.102 0 0 0 12 3.9Z",
    fill: "#023F80"
  })), _path2$U || (_path2$U = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.9a4.1 4.1 0 0 0-1.3 7.99.9.9 0 1 1-.57 1.707A5.902 5.902 0 0 1 12 6.1a5.902 5.902 0 0 1 5.59 4.01.9.9 0 1 1-1.705.577A4.102 4.102 0 0 0 12 7.9ZM23 18a5 5 0 1 0-10 0 5 5 0 0 0 10 0Zm-5.828-2.764a.834.834 0 0 1 1.661.097v1.834h1.834l.097.005a.834.834 0 0 1-.097 1.661h-1.834v1.834l-.005.097a.833.833 0 0 1-1.661-.097v-1.834h-1.834l-.097-.005a.833.833 0 0 1 .097-1.661h1.834v-1.834l.005-.097Z",
    fill: "#023F80"
  })), _path3$i || (_path3$i = /*#__PURE__*/createElement$2("path", {
    d: "M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
    fill: "#023F80"
  })));
};

var _path$3o, _path2$V;
function _extends$3r() { _extends$3r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3r.apply(this, arguments); }
var SvgLiveDisableOutline = function SvgLiveDisableOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3r({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3o || (_path$3o = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.9c-1.06 0-2.071.203-2.997.572A.9.9 0 1 1 8.337 2.8 9.876 9.876 0 0 1 12 2.1c5.468 0 9.9 4.432 9.9 9.9a9.875 9.875 0 0 1-.7 3.662.9.9 0 1 1-1.672-.666A8.1 8.1 0 0 0 12 3.9Z",
    fill: "#023F80"
  })), _path2$V || (_path2$V = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.131 6.995a.9.9 0 0 1 .906-.895 5.9 5.9 0 0 1 5.863 5.854.9.9 0 0 1-1.8.014A4.1 4.1 0 0 0 12.026 7.9a.9.9 0 0 1-.895-.905ZM5 19a9.872 9.872 0 0 0 7 2.9c2.41 0 4.619-.862 6.335-2.292l1.129 1.128a.9.9 0 0 0 1.272-1.272l-16.2-16.2a.9.9 0 1 0-1.272 1.272l1.128 1.129A9.863 9.863 0 0 0 2.1 12c0 2.733 1.11 5.21 2.9 7Zm-1.1-7c0 2.237.906 4.26 2.372 5.727A8.072 8.072 0 0 0 12 20.1c1.913 0 3.67-.662 5.056-1.771l-1.57-1.57A5.877 5.877 0 0 1 12 17.9a5.884 5.884 0 0 1-4.172-1.728A5.884 5.884 0 0 1 6.1 12c0-1.304.424-2.51 1.14-3.487L5.671 6.944A8.063 8.063 0 0 0 3.9 12Zm4 0c0 1.132.458 2.156 1.2 2.9a4.084 4.084 0 0 0 2.9 1.2c.807 0 1.558-.232 2.193-.635l-1.646-1.645c-.661.199-1.4.013-1.89-.476a1.92 1.92 0 0 1-.477-1.891L8.535 9.807A4.078 4.078 0 0 0 7.9 12Z",
    fill: "#023F80"
  })));
};

var _path$3p, _path2$W, _path3$j;
function _extends$3s() { _extends$3s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3s.apply(this, arguments); }
var SvgLiveOutline = function SvgLiveOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3s({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3p || (_path$3p = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5a9.872 9.872 0 0 1 7-2.9c2.733 0 5.21 1.11 7 2.9a9.872 9.872 0 0 1 2.9 7c0 2.733-1.11 5.21-2.9 7a9.872 9.872 0 0 1-7 2.9A9.872 9.872 0 0 1 5 19a9.872 9.872 0 0 1-2.9-7c0-2.734 1.11-5.21 2.9-7Zm7-1.1c-2.237 0-4.26.906-5.728 2.372A8.072 8.072 0 0 0 3.9 12c0 2.237.906 4.26 2.372 5.727A8.072 8.072 0 0 0 12 20.1c2.237 0 4.26-.906 5.727-2.373A8.072 8.072 0 0 0 20.1 12c0-2.237-.906-4.26-2.373-5.728A8.072 8.072 0 0 0 12 3.9Z",
    fill: "#023F80"
  })), _path2$W || (_path2$W = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.828 7.828A5.884 5.884 0 0 1 12 6.1c1.629 0 3.105.661 4.172 1.728A5.884 5.884 0 0 1 17.9 12a5.884 5.884 0 0 1-1.728 4.172A5.884 5.884 0 0 1 12 17.9a5.884 5.884 0 0 1-4.172-1.728A5.884 5.884 0 0 1 6.1 12c0-1.629.661-3.105 1.728-4.172ZM12 7.9a4.084 4.084 0 0 0-2.9 1.2A4.084 4.084 0 0 0 7.9 12c0 1.132.458 2.156 1.2 2.9a4.084 4.084 0 0 0 2.9 1.2 4.084 4.084 0 0 0 2.9-1.2 4.084 4.084 0 0 0 1.2-2.9 4.084 4.084 0 0 0-1.2-2.9A4.084 4.084 0 0 0 12 7.9Z",
    fill: "#023F80"
  })), _path3$j || (_path3$j = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.344 10.656a1.897 1.897 0 0 0-2.688 0 1.897 1.897 0 0 0 0 2.688 1.897 1.897 0 0 0 2.688 0 1.897 1.897 0 0 0 0-2.688Z",
    fill: "#023F80"
  })));
};

var _path$3q, _path2$X, _path3$k;
function _extends$3t() { _extends$3t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3t.apply(this, arguments); }
var SvgLiveSlashOutline = function SvgLiveSlashOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3t({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3q || (_path$3q = /*#__PURE__*/createElement$2("path", {
    d: "M21.071 6.929A10.004 10.004 0 0 0 9.986 4.838a1 1 0 1 1-.802-1.832c4.393-1.923 9.704-1.089 13.301 2.509 3.6 3.599 4.433 8.913 2.507 13.306a1 1 0 1 1-1.832-.803 10.004 10.004 0 0 0-2.089-11.09Z",
    fill: "#023F80"
  })), _path2$X || (_path2$X = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.293 3.293a1 1 0 0 1 1.414 0l20 20a1 1 0 1 1-1.414 1.414l-1.544-1.544c-4.715 3.997-11.786 3.77-16.234-.678C1.067 18.037.84 10.965 4.837 6.251L3.293 4.707a1 1 0 0 1 0-1.414Zm14.9 16.314 2.136 2.136c-3.928 3.219-9.734 2.995-13.4-.672-3.667-3.667-3.89-9.472-.672-13.4l2.136 2.137a7.002 7.002 0 0 0 9.8 9.799Zm-7.729-2.072a5.002 5.002 0 0 1-.636-6.293l2.24 2.24a2 2 0 0 0 2.45 2.45l2.24 2.24a5.002 5.002 0 0 1-6.293-.637Z",
    fill: "#023F80"
  })), _path3$k || (_path3$k = /*#__PURE__*/createElement$2("path", {
    d: "M13.725 9.008a4.985 4.985 0 0 1 3.81 1.457 4.985 4.985 0 0 1 1.457 3.82 1 1 0 1 0 1.997.112 6.985 6.985 0 0 0-2.04-5.347 6.985 6.985 0 0 0-5.334-2.04 1 1 0 1 0 .11 1.998Z",
    fill: "#023F80"
  })));
};

var _path$3r, _path2$Y, _path3$l;
function _extends$3u() { _extends$3u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3u.apply(this, arguments); }
var SvgLocationMapOutline = function SvgLocationMapOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3u({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3r || (_path$3r = /*#__PURE__*/createElement$2("path", {
    d: "M14 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "#023F80"
  })), _path2$Y || (_path2$Y = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9a7 7 0 1 1 14 0c0 4.506-3.038 8.242-4.845 10.082a2.994 2.994 0 0 1-4.31 0C10.038 17.242 7 13.506 7 9Zm7-5a5 5 0 0 0-5 5c0 3.667 2.528 6.905 4.272 8.681a.995.995 0 0 0 1.456 0C16.472 15.905 19 12.667 19 9a5 5 0 0 0-5-5Z",
    fill: "#023F80"
  })), _path3$l || (_path3$l = /*#__PURE__*/createElement$2("path", {
    d: "M7.262 16.572a1 1 0 0 1-.108 1.41C6.372 18.653 6 19.393 6 20c0 .853.634 1.835 2.122 2.661C9.576 23.47 11.652 24 14 24c2.348 0 4.424-.53 5.878-1.339C21.366 21.835 22 20.853 22 20c0-.624-.343-1.315-1.143-1.988a1 1 0 0 1 1.287-1.53C23.22 17.386 24 18.588 24 20c0 1.909-1.38 3.427-3.15 4.41C19.046 25.412 16.622 26 14 26c-2.623 0-5.046-.588-6.85-1.59C5.38 23.427 4 21.909 4 20c0-1.395.81-2.642 1.852-3.536a1 1 0 0 1 1.41.108Z",
    fill: "#023F80"
  })));
};

var _path$3s;
function _extends$3v() { _extends$3v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3v.apply(this, arguments); }
var SvgLocationOutline = function SvgLocationOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3v({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3s || (_path$3s = /*#__PURE__*/createElement$2("path", {
    d: "M10.794 20.458a1.7 1.7 0 0 0 3.272.472l5.83-14.617a1.7 1.7 0 0 0-2.209-2.21L3.071 9.935a1.7 1.7 0 0 0 .47 3.272l6.633.62.62 6.632Zm7.344-14.596-5.59 14.015-.721-7.703-7.704-.722 14.015-5.59Z",
    fill: "#023F80"
  })));
};

var _path$3t, _path2$Z;
function _extends$3w() { _extends$3w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3w.apply(this, arguments); }
var SvgLockOpenOutline = function SvgLockOpenOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3w({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3t || (_path$3t = /*#__PURE__*/createElement$2("path", {
    d: "M12 13a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
    fill: "#023F80"
  })), _path2$Z || (_path2$Z = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1 7a4.9 4.9 0 0 1 9.395-1.954.9.9 0 1 1-1.65.718 3.082 3.082 0 0 0-.159-.314A3.1 3.1 0 0 0 8.9 7v1.1h6.338c.808 0 1.469 0 2.006.044.556.045 1.058.142 1.527.381a3.9 3.9 0 0 1 1.704 1.704c.239.47.336.971.381 1.527.044.537.044 1.198.044 2.006v2.476c0 .808 0 1.469-.044 2.006-.045.556-.142 1.058-.381 1.527a3.9 3.9 0 0 1-1.704 1.704c-.47.239-.971.336-1.527.381-.537.044-1.198.044-2.006.044H8.762c-.808 0-1.469 0-2.006-.044-.556-.045-1.058-.142-1.526-.381a3.9 3.9 0 0 1-1.705-1.704c-.239-.47-.336-.971-.381-1.527-.044-.537-.044-1.198-.044-2.006v-2.476c0-.808 0-1.469.044-2.006.045-.556.142-1.058.381-1.527A3.9 3.9 0 0 1 5.23 8.525c.468-.239.97-.336 1.526-.381.11-.01.224-.016.344-.022V7Zm-.197 2.938c-.445.036-.683.103-.856.19a2.1 2.1 0 0 0-.918.919c-.088.172-.155.411-.191.856-.037.455-.038 1.042-.038 1.897v2.4c0 .855 0 1.442.038 1.897.036.445.103.683.191.856a2.1 2.1 0 0 0 .918.918c.173.088.411.155.856.191.455.037 1.042.038 1.897.038h6.4c.855 0 1.442 0 1.897-.038.445-.036.684-.103.856-.19a2.1 2.1 0 0 0 .918-.919c.088-.172.155-.411.191-.856.037-.455.038-1.042.038-1.897v-2.4c0-.855 0-1.442-.038-1.897-.036-.445-.103-.684-.19-.856a2.1 2.1 0 0 0-.919-.918c-.172-.088-.411-.155-.856-.191C16.642 9.9 16.055 9.9 15.2 9.9H8.8c-.855 0-1.442 0-1.897.038Z",
    fill: "#023F80"
  })));
};

var _path$3u, _path2$_, _path3$m;
function _extends$3x() { _extends$3x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3x.apply(this, arguments); }
var SvgLockOutline = function SvgLockOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3x({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3u || (_path$3u = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
    fill: "#023F80"
  })), _path2$_ || (_path2$_ = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.77 8.525c-.578-.295-1.23-.373-1.87-.403V7a4.9 4.9 0 1 0-9.8 0v1.122c-.64.03-1.292.108-1.87.403a3.9 3.9 0 0 0-1.705 1.704c-.239.47-.336.971-.381 1.527-.044.537-.044 1.198-.044 2.006v2.476c0 .808 0 1.469.044 2.006.045.556.142 1.058.381 1.526a3.9 3.9 0 0 0 1.704 1.705c.47.239.971.336 1.527.381.537.044 1.198.044 2.006.044h6.476c.808 0 1.469 0 2.006-.044.556-.045 1.058-.142 1.526-.381a3.9 3.9 0 0 0 1.705-1.705c.239-.468.336-.97.381-1.526.044-.537.044-1.198.044-2.006v-2.476c0-.808 0-1.469-.044-2.006-.045-.556-.142-1.058-.381-1.527a3.9 3.9 0 0 0-1.705-1.704ZM6.903 9.938c-.445.036-.684.103-.856.19a2.1 2.1 0 0 0-.918.919c-.088.172-.155.411-.191.856-.037.455-.038 1.042-.038 1.897v2.4c0 .855 0 1.442.038 1.897.036.445.103.683.19.856a2.1 2.1 0 0 0 .919.918c.172.088.411.155.856.191.455.037 1.042.038 1.897.038h6.4c.855 0 1.442 0 1.897-.038.445-.036.683-.103.856-.19a2.1 2.1 0 0 0 .918-.919c.088-.172.155-.411.191-.856.037-.455.038-1.042.038-1.897v-2.4c0-.855 0-1.442-.038-1.897-.036-.445-.103-.684-.19-.856a2.1 2.1 0 0 0-.919-.918c-.172-.088-.411-.155-.856-.191C16.642 9.9 16.055 9.9 15.2 9.9H8.8c-.855 0-1.442 0-1.897.038ZM15.1 7a3.1 3.1 0 1 0-6.2 0v1.1h6.2V7Z",
    fill: "#023F80"
  })), _path3$m || (_path3$m = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 14a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Z",
    fill: "#023F80"
  })));
};

var _path$3v, _path2$$;
function _extends$3y() { _extends$3y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3y.apply(this, arguments); }
var SvgLogoVkOutline = function SvgLogoVkOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3y({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3v || (_path$3v = /*#__PURE__*/createElement$2("path", {
    d: "M8.469 9c.28 0 .385.124.49.43.535 1.574 1.437 2.95 1.808 2.95.125 0 .19-.052.2-.323l.003-.098V10.33c-.041-.75-.435-.81-.435-1.077a.26.26 0 0 1 .216-.248L10.813 9h1.72c.206 0 .292.099.309.318l.003.088v2.19c0 .234.1.316.17.316.14 0 .255-.082.51-.34.788-.89 1.345-2.26 1.345-2.26a.465.465 0 0 1 .388-.307L15.346 9h1.094c.33 0 .4.172.33.406-.128.595-1.274 2.257-1.449 2.509l-.022.032c-.116.188-.163.281 0 .492.115.164.498.492.753.796.47.534.824.985.923 1.296.082.285-.042.442-.304.466l-.075.003h-1.094c-.417 0-.54-.336-1.281-1.086-.65-.632-.928-.714-1.09-.714-.198 0-.271.051-.284.292l-.002.087v.991c0 .272-.086.43-.781.43-1.16 0-2.433-.71-3.337-2.022C7.37 11.058 7 9.605 7 9.313c0-.148.05-.283.289-.309L7.375 9h1.094Z",
    fill: "#023F80"
  })), _path2$$ || (_path2$$ = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.754 3.1h2.492c1.27 0 2.288 0 3.105.078.841.08 1.563.248 2.21.644a4.9 4.9 0 0 1 1.617 1.618c.396.646.564 1.368.644 2.208.078.818.078 1.836.078 3.106v2.492c0 1.27 0 2.288-.078 3.106-.08.84-.248 1.562-.644 2.208a4.9 4.9 0 0 1-1.618 1.618c-.646.396-1.368.564-2.209.644-.817.078-1.835.078-3.105.078h-2.492c-1.27 0-2.288 0-3.106-.078-.84-.08-1.562-.248-2.208-.644a4.9 4.9 0 0 1-1.618-1.618c-.396-.646-.564-1.368-.644-2.208-.078-.818-.078-1.836-.078-3.106v-2.492c0-1.27 0-2.288.078-3.106.08-.84.248-1.562.644-2.208A4.9 4.9 0 0 1 5.44 3.822c.646-.396 1.368-.564 2.208-.644.818-.078 1.836-.078 3.106-.078ZM7.82 4.97c-.71.067-1.123.193-1.439.387A3.1 3.1 0 0 0 5.357 6.38c-.194.316-.32.73-.387 1.439-.07.722-.07 1.654-.07 2.981v2.4c0 1.327 0 2.259.07 2.981.067.71.193 1.123.387 1.439.255.417.606.767 1.023 1.023.316.194.73.32 1.439.387.722.069 1.654.07 2.98.07h2.4c1.328 0 2.26-.001 2.982-.07.71-.067 1.123-.193 1.439-.387a3.101 3.101 0 0 0 1.023-1.023c.194-.316.32-.73.387-1.439.069-.722.07-1.654.07-2.981v-2.4c0-1.327-.001-2.259-.07-2.981-.067-.71-.193-1.123-.387-1.439a3.1 3.1 0 0 0-1.023-1.023c-.316-.194-.73-.32-1.439-.387-.722-.07-1.654-.07-2.981-.07h-2.4c-1.327 0-2.259 0-2.981.07Z",
    fill: "#023F80"
  })));
};

var _path$3w;
function _extends$3z() { _extends$3z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3z.apply(this, arguments); }
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3z({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3w || (_path$3w = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 14.18c0 .194.068.353.25.536l3.624 3.725c.148.137.296.217.49.217.376 0 .649-.297.649-.673a.657.657 0 0 0-.216-.501l-1.835-1.755-.9-.865 1.572.057h11.701c.4 0 .73-.342.73-.741 0-.399-.33-.73-.73-.73h-11.7l-1.584.058.911-.877 1.835-1.755a.698.698 0 0 0 .216-.513c0-.387-.273-.66-.65-.66a.65.65 0 0 0-.49.216l-3.622 3.726c-.183.182-.251.353-.251.535Zm24.735 6.186c0 2.165-1.083 3.259-3.225 3.259H12.357c-2.13 0-3.213-1.094-3.213-3.259v-3.041h1.481v3.019c0 1.162.616 1.788 1.812 1.788H23.18c1.196 0 1.811-.626 1.811-1.788V8.028c0-1.14-.615-1.8-1.811-1.8H12.437c-1.196 0-1.812.66-1.812 1.8v3.008h-1.48V7.993c0-2.164 1.093-3.247 3.212-3.247H23.26c2.13 0 3.225 1.083 3.225 3.247v12.373Z",
    fill: "#023F80"
  })));
};

var _path$3x, _path2$10, _path3$n, _path4$4;
function _extends$3A() { _extends$3A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3A.apply(this, arguments); }
var SvgLotusOutline = function SvgLotusOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3A({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3x || (_path$3x = /*#__PURE__*/createElement$2("path", {
    d: "M18.1 14.01c0 5.525-3.583 10.004-4.152 10.004s-4.151-4.48-4.151-10.004c0-5.525 3.557-10.003 4.151-10.003.594 0 4.151 4.478 4.151 10.003Z",
    stroke: "#023F80",
    strokeWidth: 2
  })), _path2$10 || (_path2$10 = /*#__PURE__*/createElement$2("path", {
    d: "M10.078 11.032C8.014 8.562 5.01 8.175 4.826 8.36c-.426.427-.004 3.926.82 5.574M17.439 11.032c2.063-2.47 5.066-2.857 5.252-2.671.425.427.003 3.926-.82 5.574",
    stroke: "#023F80",
    strokeWidth: 2
  })), _path3$n || (_path3$n = /*#__PURE__*/createElement$2("path", {
    d: "M10.209 14.944c-3.86-1.727-8.15-.916-8.463-.62-.366.347.556 3.913 5.15 6.764 2.482 1.45 6.632 2.912 7.064 2.911M17.803 14.946c3.856-1.73 8.141-.92 8.454-.623.364.346-.558 3.917-5.148 6.773-2.48 1.452-6.47 2.918-7.057 2.918",
    stroke: "#023F80",
    strokeWidth: 2
  })), _path4$4 || (_path4$4 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3 3.194c.102-.059.34-.187.648-.187s.546.128.647.187c.131.076.252.17.356.26.21.182.438.424.668.703.464.563 1 1.352 1.51 2.31.387.726.764 1.561 1.083 2.48a9.152 9.152 0 0 1 2.21-1.186 7.568 7.568 0 0 1 1.518-.4 3.59 3.59 0 0 1 .578-.042c.086.002.194.01.307.033h.003c.066.014.339.07.568.3.278.28.361.64.394.81.044.22.061.463.066.7.008.482-.036 1.066-.118 1.665a15.808 15.808 0 0 1-.418 2.045h.055c.847.013 1.587.093 2.148.193.28.05.528.108.73.17.1.03.205.067.302.11.072.031.239.108.389.25.208.198.293.43.33.57.04.154.052.302.053.425.001.246-.04.513-.107.778-.134.537-.4 1.194-.82 1.908-.842 1.436-2.336 3.16-4.766 4.671l-.011.007-.012.007c-1.3.762-2.97 1.513-4.374 2.07-.706.28-1.358.516-1.878.684-.26.084-.496.154-.695.204a2.66 2.66 0 0 1-.613.096v-.006a1.14 1.14 0 0 1-.486-.061 4.91 4.91 0 0 1-.188-.047c-.184-.05-.41-.118-.663-.201a36.995 36.995 0 0 1-1.88-.68c-1.42-.554-3.134-1.304-4.44-2.068l-.012-.006-.011-.008c-2.432-1.509-3.928-3.23-4.77-4.664-.42-.713-.686-1.369-.82-1.905a3.195 3.195 0 0 1-.107-.777c.001-.123.013-.27.053-.424.038-.141.123-.372.331-.57.15-.142.318-.219.39-.25.097-.043.2-.08.301-.11.204-.062.452-.12.732-.17.464-.083 1.05-.152 1.72-.18a15.78 15.78 0 0 1-.422-2.06c-.082-.6-.127-1.184-.118-1.665.004-.238.021-.481.065-.702.033-.168.117-.53.394-.809.23-.23.502-.286.569-.3h.002c.113-.024.221-.031.307-.033a3.59 3.59 0 0 1 .578.041c.414.06.94.187 1.518.4a9.126 9.126 0 0 1 2.511 1.418c.335-1.01.743-1.925 1.162-2.711.51-.958 1.046-1.747 1.51-2.31.23-.28.457-.521.668-.703.104-.09.224-.184.355-.26Zm-.768 4.213c-.91 1.71-1.735 4.049-1.735 6.603 0 2.553.83 4.892 1.744 6.603.456.853.921 1.53 1.291 1.98.04.049.08.095.116.137.037-.042.075-.088.116-.137.37-.45.835-1.127 1.29-1.98.915-1.711 1.745-4.05 1.745-6.603 0-2.554-.825-4.893-1.736-6.603a12.218 12.218 0 0 0-1.288-1.978 6.337 6.337 0 0 0-.127-.15c-.04.045-.083.095-.127.15-.37.449-.835 1.125-1.289 1.978Zm4.326 14.619c1.265-.516 2.661-1.16 3.737-1.788 2.154-1.343 3.412-2.83 4.086-3.977.285-.486.46-.901.556-1.21a11.607 11.607 0 0 0-1.894-.174c-1.27-.02-2.815.135-4.327.663-.255 2.351-1.056 4.44-1.897 6.015-.087.162-.174.319-.261.47Zm2.229-8.607c.715-.204 1.423-.34 2.1-.426.249-.677.455-1.58.573-2.44.059-.43.092-.822.099-1.139a7.071 7.071 0 0 0-3.065 1.642c.154.755.258 1.546.293 2.363Zm-8.31 8.136c.067.126.135.25.203.37-1.23-.5-2.556-1.105-3.569-1.695-2.155-1.34-3.415-2.824-4.089-3.97-.285-.485-.46-.9-.555-1.21l.067-.012c.45-.08 1.083-.15 1.829-.162 1.237-.019 2.737.127 4.213.62.25 2.37 1.055 4.474 1.901 6.059ZM9.041 11.37c-.119.649-.2 1.323-.23 2.016a14.513 14.513 0 0 0-2.502-.448c-.24-.671-.438-1.55-.553-2.386-.059-.43-.092-.822-.099-1.139a7.014 7.014 0 0 1 3.384 1.957ZM5.036 9.323Zm.651-.488a.09.09 0 0 1 .006-.023s-.001.009-.006.023Zm16.142 0a.088.088 0 0 0-.006-.023s.001.009.006.023Z",
    fill: "#023F80"
  })));
};

var _path$3y, _path2$11;
function _extends$3B() { _extends$3B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3B.apply(this, arguments); }
var SvgLoudspeakerSlashOutline = function SvgLoudspeakerSlashOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3B({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3y || (_path$3y = /*#__PURE__*/createElement$2("path", {
    d: "M21.463 7.158a.994.994 0 0 1 .753-.132.994.994 0 0 1 .784.976v12.352a1 1 0 1 0 2 0V8.002a3 3 0 0 0-4.611-2.53L16.417 8h-3.764a1 1 0 1 0 0 2H15v2.342a1 1 0 1 0 2 0V10l4.463-2.842Z",
    fill: "#023F80"
  })), _path2$11 || (_path2$11 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 17.34a1.015 1.015 0 0 0-.09-.091L4.71 5.299a1 1 0 0 0-1.414 1.414l2.186 2.186c-.18.125-.346.249-.494.368l-.008.006-.007.006A5.486 5.486 0 0 0 3 13.5c0 1.52.616 2.896 1.61 3.89a5.49 5.49 0 0 0 2.976 1.535l.457 2.594a2.994 2.994 0 0 0 1.234 1.937c.628.44 1.426.64 2.242.497a2.993 2.993 0 0 0 1.936-1.234c.44-.628.64-1.426.497-2.242L13.692 19h1.89l6.71 6.71a1 1 0 0 0 1.415-1.415L16.75 17.34Zm-9.824-6.997a7.37 7.37 0 0 0-.678.477A3.486 3.486 0 0 0 5 13.5c0 .966.391 1.84 1.026 2.475A3.486 3.486 0 0 0 8.5 17h5.083l-6.657-6.657Zm3.087 10.828L9.63 19h2.03l.322 1.824a.994.994 0 0 1-.165.747.994.994 0 0 1-.646.411.994.994 0 0 1-.747-.166.994.994 0 0 1-.411-.645Z",
    fill: "#023F80"
  })));
};

var _path$3z;
function _extends$3C() { _extends$3C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3C.apply(this, arguments); }
var SvgMagicHatOutline = function SvgMagicHatOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3C({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3z || (_path$3z = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm4.363 1.262a.383.383 0 0 0-.726 0l-.291.873a1.914 1.914 0 0 1-1.21 1.21l-.874.292a.383.383 0 0 0 0 .726l.873.291c.572.19 1.02.64 1.21 1.21l.292.874c.116.35.61.35.726 0l.291-.873c.19-.572.64-1.02 1.21-1.21l.874-.292a.383.383 0 0 0 0-.726l-.873-.291a1.914 1.914 0 0 1-1.21-1.21l-.292-.874ZM8.195 7.93a.95.95 0 0 0-.39-1.86c-1.35.283-2.473.676-3.283 1.186-.79.497-1.472 1.235-1.472 2.232 0 .8.445 1.44 1.018 1.908.497.407 1.155.74 1.923 1.013A62.617 62.617 0 0 1 6 13.5c0 3.838-.338 7.302-.97 9.76a.963.963 0 0 0-.03.24c0 1.38 3.28 2.5 9 2.5 5.72 0 9-1.12 9-2.5a.964.964 0 0 0-.03-.24c-.632-2.458-.97-5.922-.97-9.76a62.82 62.82 0 0 1 .01-1.09c.767-.273 1.425-.607 1.922-1.014.573-.467 1.018-1.108 1.018-1.908 0-.997-.682-1.735-1.472-2.232-.81-.51-1.933-.903-3.284-1.186a.95.95 0 0 0-.389 1.86c1.242.26 2.12.593 2.661.934.562.353.584.588.584.624 0 .033-.01.184-.32.437-.313.256-.843.535-1.636.788-1.577.504-3.969.837-7.094.837-3.125 0-5.517-.333-7.094-.837-.793-.253-1.323-.532-1.636-.788-.31-.253-.32-.404-.32-.437 0-.036.022-.27.584-.624.542-.34 1.42-.674 2.66-.934Zm11.907 4.996c-1.65.336-3.704.524-6.102.524s-4.453-.188-6.102-.524l.002.574c0 3.628-.293 7.015-.881 9.618.194.096.477.21.873.327 1.294.382 3.345.655 6.108.655 2.763 0 4.814-.273 6.108-.655a5.46 5.46 0 0 0 .873-.327c-.588-2.603-.881-5.99-.881-9.618 0-.192 0-.384.002-.574Z",
    fill: "#023F80"
  })));
};

var _path$3A, _path2$12;
function _extends$3D() { _extends$3D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3D.apply(this, arguments); }
var SvgMagicWandOutline = function SvgMagicWandOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3D({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3A || (_path$3A = /*#__PURE__*/createElement$2("path", {
    d: "M5.374 8.397a.2.2 0 0 1-.27-.27l.991-1.877-.992-1.876a.2.2 0 0 1 .27-.27l1.877.991 1.876-.992a.2.2 0 0 1 .27.27L8.406 6.25l.992 1.876a.2.2 0 0 1-.27.27L7.25 7.406l-1.876.992ZM17.25 6.905l-1.876.992a.2.2 0 0 1-.27-.27l.991-1.877-.991-1.876a.2.2 0 0 1 .27-.27l1.876.991 1.877-.992a.2.2 0 0 1 .27.27l-.992 1.877.992 1.876a.2.2 0 0 1-.27.27l-1.877-.991ZM15.374 17.397a.2.2 0 0 1-.27-.27l.991-1.877-.991-1.876a.2.2 0 0 1 .27-.27l1.876.991 1.877-.992a.2.2 0 0 1 .27.27l-.992 1.877.992 1.876a.2.2 0 0 1-.27.27l-1.877-.991-1.876.992Z",
    fill: "#023F80"
  })), _path2$12 || (_path2$12 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.136 10.364a.9.9 0 0 1 0 1.272l-9.5 9.5a.9.9 0 1 1-1.272-1.272l9.5-9.5a.9.9 0 0 1 1.272 0Z",
    fill: "#023F80"
  })));
};

var _path$3B, _path2$13;
function _extends$3E() { _extends$3E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3E.apply(this, arguments); }
var SvgMagnifierMinus = function SvgMagnifierMinus(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3E({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3B || (_path$3B = /*#__PURE__*/createElement$2("path", {
    d: "M10 12h6a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2Z",
    fill: "#023F80"
  })), _path2$13 || (_path2$13 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4a9 9 0 1 0 5.618 16.032l4.675 4.675a1 1 0 0 0 1.414-1.414l-4.675-4.675A9 9 0 0 0 13 4Zm0 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z",
    fill: "#023F80"
  })));
};

var _path$3C, _path2$14;
function _extends$3F() { _extends$3F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3F.apply(this, arguments); }
var SvgMagnifierPlus = function SvgMagnifierPlus(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3F({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3C || (_path$3C = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z",
    fill: "#023F80"
  })), _path2$14 || (_path2$14 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4a9 9 0 1 0 5.618 16.032l4.675 4.675a1 1 0 0 0 1.414-1.414l-4.675-4.675A9 9 0 0 0 13 4Zm0 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z",
    fill: "#023F80"
  })));
};

var _path$3D;
function _extends$3G() { _extends$3G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3G.apply(this, arguments); }
var SvgMailOutline = function SvgMailOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3G({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3D || (_path$3D = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8 4.1h-.038c-.808 0-1.469 0-2.006.044-.556.045-1.058.142-1.526.381A3.9 3.9 0 0 0 2.525 6.23c-.239.47-.336.971-.381 1.527C2.1 8.293 2.1 8.954 2.1 9.762V14.238c0 .808 0 1.469.044 2.006.045.556.142 1.058.381 1.527a3.9 3.9 0 0 0 1.705 1.704c.468.239.97.336 1.526.381.537.044 1.198.044 2.006.044h8.476c.808 0 1.469 0 2.006-.044.556-.045 1.058-.142 1.527-.381a3.9 3.9 0 0 0 1.704-1.704c.239-.47.336-.971.381-1.527.044-.537.044-1.198.044-2.006V9.762c0-.808 0-1.469-.044-2.006-.045-.556-.142-1.058-.381-1.527a3.9 3.9 0 0 0-1.704-1.704c-.47-.239-.971-.336-1.527-.381-.537-.044-1.198-.044-2.006-.044H7.8ZM5.38 6.012c.136-.031.305-.056.523-.074C6.358 5.9 6.945 5.9 7.8 5.9h8.4c.855 0 1.442 0 1.897.038.218.018.387.043.522.074L14.61 9.52c-.577.506-.973.851-1.303 1.097-.32.24-.524.343-.7.396a2.14 2.14 0 0 1-1.214 0c-.176-.053-.38-.156-.7-.396-.33-.246-.725-.591-1.303-1.097L5.38 6.012ZM4.05 7.24c-.049.156-.087.362-.112.663C3.901 8.358 3.9 8.945 3.9 9.8v4.4c0 .855 0 1.442.038 1.897.036.445.103.683.191.856a2.1 2.1 0 0 0 .918.918c.173.088.411.155.856.191.455.037 1.042.038 1.897.038h8.4c.855 0 1.442 0 1.897-.038.445-.036.684-.103.856-.19a2.1 2.1 0 0 0 .918-.919c.088-.172.155-.411.191-.856.037-.455.038-1.042.038-1.897V9.8c0-.855 0-1.442-.038-1.897a3.017 3.017 0 0 0-.112-.663l-4.154 3.635-.026.023c-.546.477-.993.868-1.384 1.16-.407.305-.806.544-1.269.68a3.94 3.94 0 0 1-2.234 0c-.462-.136-.862-.375-1.268-.68-.392-.292-.84-.683-1.384-1.16l-.027-.023L4.05 7.24Z",
    fill: "#023F80"
  })));
};

var _path$3E;
function _extends$3H() { _extends$3H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3H.apply(this, arguments); }
var SvgMailStackOutline = function SvgMailStackOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3H({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3E || (_path$3E = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.96 3.267C18.634 3.093 18.31 3 17.42 3h-6.873c-.891 0-1.215.093-1.54.267-.327.174-.582.43-.757.756-.131.246-.216.49-.25.976h11.966c-.034-.486-.119-.73-.25-.976a1.817 1.817 0 0 0-.756-.756Zm.216 3.735L9.129 7c-1.777 0-2.648.168-3.553.652a4.635 4.635 0 0 0-1.923 1.923c-.455.852-.631 1.674-.65 3.248L3 17.873c0 1.776.168 2.647.652 3.552a4.634 4.634 0 0 0 1.923 1.922c.905.485 1.776.653 3.553.653h9.744c1.777 0 2.648-.168 3.553-.652a4.634 4.634 0 0 0 1.922-1.923c.485-.905.653-1.776.653-3.553v-4.744c0-1.777-.168-2.648-.652-3.553a4.634 4.634 0 0 0-1.923-1.923c-.852-.455-1.674-.631-3.248-.65Zm-2.348 9.584 5.86-5.858c.229.515.312 1.104.312 2.4v4.744l-.005.484c-.023 1.123-.14 1.618-.411 2.126a2.634 2.634 0 0 1-1.102 1.102c-.576.308-1.135.416-2.61.416H9.128l-.484-.005c-1.123-.023-1.618-.14-2.126-.411a2.635 2.635 0 0 1-1.102-1.102C5.108 19.906 5 19.347 5 17.872v-4.744c0-1.296.083-1.885.313-2.4l5.859 5.858.159.15a4 4 0 0 0 5.497-.15ZM9.128 9h9.744c1.296 0 1.885.083 2.4.313l-5.858 5.859-.127.116a2 2 0 0 1-2.701-.116l-5.858-5.86C7.243 9.084 7.832 9 9.128 9Z",
    fill: "#023F80"
  })));
};

var _path$3F;
function _extends$3I() { _extends$3I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3I.apply(this, arguments); }
var SvgMarketAddBadgeOutline = function SvgMarketAddBadgeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3I({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3F || (_path$3F = /*#__PURE__*/createElement$2("path", {
    d: "M21.154 8c1.337 0 1.822.14 2.311.4.49.262.873.646 1.134 1.135l.093.185c.201.438.308.956.308 2.126V13a1 1 0 1 1-2 0v-1.154c0-.918-.043-1.142-.164-1.368a.728.728 0 0 0-.314-.314c-.194-.103-.386-.15-1.015-.161L21.154 10H6.846l-.353.003c-.629.011-.821.058-1.015.161a.728.728 0 0 0-.314.314c-.112.21-.157.418-.163 1.182L5 18.95c0 1.933.13 2.604.498 3.293.293.548.711.966 1.259 1.259.69.368 1.36.498 3.294.498H12a1 1 0 1 1 0 2h-1.95l-.58-.005c-2.02-.04-2.835-.29-3.656-.73a4.998 4.998 0 0 1-2.08-2.079c-.459-.859-.712-1.71-.733-3.938L3 11.846c0-1.338.14-1.822.4-2.311A2.726 2.726 0 0 1 4.536 8.4l.185-.093c.407-.187.882-.292 1.885-.306L21.155 8ZM19 14a6 6 0 1 1 0 12 6 6 0 0 1 0-12Zm0 2a1 1 0 0 0-.993.883L18 17v2h-2a1 1 0 0 0-.117 1.993L16 21h2v2a1 1 0 0 0 1.993.117L20 23v-2h2a1 1 0 0 0 .117-1.993L22 19h-2v-2a1 1 0 0 0-1-1ZM9 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm5-10a6 6 0 0 1 6 6h-2a4 4 0 0 0-8 0H8a6 6 0 0 1 6-6Z",
    fill: "#023F80"
  })));
};

var _path$3G, _path2$15;
function _extends$3J() { _extends$3J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3J.apply(this, arguments); }
var SvgMarketLikeOutline = function SvgMarketLikeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3J({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3G || (_path$3G = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.575 15.007a4.752 4.752 0 0 0-2.438.817L19 15.92l-.137-.096A4.764 4.764 0 0 0 16.158 15 4.158 4.158 0 0 0 12 19.158c0 2.242.892 3.487 4.447 6.252l1.647 1.28c.533.415 1.28.415 1.812 0l1.647-1.28C25.108 22.645 26 21.4 26 19.158A4.158 4.158 0 0 0 21.842 15l-.267.007ZM21.842 17c1.192 0 2.158.966 2.158 2.158l-.002.122c-.032 1.252-.598 2.124-3.153 4.144L19 24.862l-1.325-1.03C14.585 21.428 14 20.568 14 19.158c0-1.192.966-2.158 2.158-2.158.803 0 1.498.3 2.135.937l.354.354a.5.5 0 0 0 .706 0l.354-.354c.637-.636 1.332-.937 2.135-.937ZM9 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
    fill: "#023F80"
  })), _path2$15 || (_path2$15 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2a6 6 0 0 1 6 6h1.154c1.337 0 1.822.14 2.311.4.49.262.873.646 1.134 1.135l.093.185c.201.438.308.956.308 2.126v.654a1 1 0 1 1-2 0v-.654c0-.918-.043-1.142-.164-1.368a.728.728 0 0 0-.314-.314c-.194-.103-.386-.15-1.015-.161L21.154 10H6.846l-.353.003c-.629.011-.821.058-1.015.161a.728.728 0 0 0-.314.314c-.12.226-.164.45-.164 1.368v7.103c0 1.934.13 2.605.498 3.294.293.548.711.966 1.259 1.259.69.368 1.36.498 3.294.498H11.5a1 1 0 1 1 0 2h-1.45l-.58-.005c-2.02-.04-2.835-.29-3.656-.73a4.998 4.998 0 0 1-2.08-2.079c-.459-.859-.712-1.71-.733-3.938L3 11.846c0-1.338.14-1.822.4-2.311A2.726 2.726 0 0 1 4.536 8.4l.185-.093c.407-.187.882-.292 1.885-.306L8 8a6 6 0 0 1 6-6Zm-4 6a4 4 0 0 1 8 0h-8Z",
    fill: "#023F80"
  })));
};

var _path$3H;
function _extends$3K() { _extends$3K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3K.apply(this, arguments); }
var SvgMarketOutline = function SvgMarketOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3K({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3H || (_path$3H = /*#__PURE__*/createElement$2("path", {
    d: "M12 1.1a5 5 0 0 1 5 5h.054c1.338 0 1.823.14 2.311.4.49.262.873.646 1.134 1.135.262.489.401.974.401 2.31v4.89c0 2.088-.22 2.86-.634 3.635a4.316 4.316 0 0 1-1.796 1.796c-.774.414-1.546.634-3.636.634H9.166c-2.09 0-2.862-.22-3.636-.634a4.316 4.316 0 0 1-1.795-1.796c-.414-.774-.635-1.547-.635-3.636V9.946c0-1.337.14-1.822.4-2.311A2.726 2.726 0 0 1 4.636 6.5c.489-.262.974-.401 2.31-.401H7a5 5 0 0 1 5-5Zm5.247 6.8H6.946c-.948 0-1.203.05-1.462.188a.927.927 0 0 0-.396.396c-.139.259-.188.514-.188 1.462v4.888c0 1.635.11 2.205.422 2.787.246.46.597.811 1.057 1.057.582.311 1.152.422 2.787.422h5.668c1.636 0 2.205-.11 2.787-.422.46-.246.811-.597 1.057-1.057.312-.582.422-1.152.422-2.787V9.946c0-.948-.05-1.203-.188-1.462a.927.927 0 0 0-.395-.396c-.241-.129-.479-.18-1.27-.187Zm-1.3 1.1c.204 0 .347.035.47.1a.681.681 0 0 1 .283.284c.065.122.1.265.1.47v.092a.953.953 0 0 1-.1.47.681.681 0 0 1-.284.284.953.953 0 0 1-.47.1h-.092a.953.953 0 0 1-.47-.1.681.681 0 0 1-.284-.284.953.953 0 0 1-.1-.47v-.092c0-.205.035-.348.1-.47a.681.681 0 0 1 .284-.284.953.953 0 0 1 .47-.1h.092Zm-8 0c.204 0 .347.035.47.1a.681.681 0 0 1 .283.284c.065.122.1.265.1.47v.092a.953.953 0 0 1-.1.47.681.681 0 0 1-.284.284.953.953 0 0 1-.47.1h-.092a.953.953 0 0 1-.47-.1.681.681 0 0 1-.284-.284.953.953 0 0 1-.1-.47v-.092c0-.205.035-.348.1-.47a.682.682 0 0 1 .284-.284.954.954 0 0 1 .47-.1h.092ZM12 2.9a3.2 3.2 0 0 0-3.2 3.2h6.4A3.2 3.2 0 0 0 12 2.9Z",
    fill: "#023F80"
  })));
};

var _path$3I, _path2$16, _path3$o;
function _extends$3L() { _extends$3L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3L.apply(this, arguments); }
var SvgMarketSlashOutline = function SvgMarketSlashOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3L({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3I || (_path$3I = /*#__PURE__*/createElement$2("path", {
    d: "M19 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z",
    fill: "#023F80"
  })), _path2$16 || (_path2$16 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.032 10.024C21.75 10 21.377 10 20.8 10h-6.144a1 1 0 1 1 0-2h6.182c.528 0 .982 0 1.357.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356v6.192a1 1 0 0 1-2-.003V12.2c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085ZM4.293 4.293a1 1 0 0 1 1.414 0l20 20a1 1 0 0 1-1.414 1.414l-1.116-1.116-1.418-1.418L8.582 9.997 6.587 8.002 4.293 5.707a1 1 0 0 1 0-1.414Z",
    fill: "#023F80"
  })), _path3$o || (_path3$o = /*#__PURE__*/createElement$2("path", {
    d: "M7.2 10h1.3c.028 0 .055-.001.082-.003L6.587 8.002c-.29.002-.551.01-.782.029-.395.032-.789.103-1.167.296a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167C3 11.18 3 11.635 3 12.162v5.681c0 1.224 0 2.203.065 2.994.066.812.205 1.514.534 2.16A5.5 5.5 0 0 0 6.003 25.4c.646.329 1.348.468 2.16.534.791.065 1.77.065 2.994.065h5.686c1.224 0 2.203 0 2.994-.065.812-.066 1.514-.205 2.16-.534.43-.22.825-.492 1.18-.81l-1.418-1.418a3.499 3.499 0 0 1-.67.446c-.317.161-.726.267-1.415.323-.7.057-1.597.058-2.874.058h-5.6c-1.277 0-2.174 0-2.874-.058-.689-.056-1.098-.162-1.415-.323a3.5 3.5 0 0 1-1.53-1.53c-.161-.317-.267-.726-.323-1.415C5.001 19.974 5 19.077 5 17.8v-5.6c0-.577 0-.949.024-1.232.022-.272.06-.373.085-.422a1 1 0 0 1 .437-.437c.05-.025.15-.063.422-.085C6.25 10 6.623 10 7.2 10ZM18 8h2A6 6 0 0 0 9.55 3.975a1 1 0 1 0 1.483 1.342A4 4 0 0 1 18 8Z",
    fill: "#023F80"
  })));
};

var _path$3J, _path2$17;
function _extends$3M() { _extends$3M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3M.apply(this, arguments); }
var SvgMasksOutline = function SvgMasksOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3M({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3J || (_path$3J = /*#__PURE__*/createElement$2("path", {
    d: "M16.285 15.84c-.485.25-1.177.608-2.285.608s-1.8-.357-2.285-.608c-.447-.23-.719-.37-.979-.062-.544.644.544 3.22 3.264 3.22 2.72 0 3.808-2.576 3.264-3.22-.26-.309-.533-.168-.979.062ZM10.811 10.008c.937.08 1.647.701 1.585 1.387-.061.686-.87 1.176-1.807 1.097-.937-.08-1.647-.701-1.585-1.387.061-.686.87-1.176 1.807-1.097ZM18.996 11.105c-.061-.686-.87-1.176-1.807-1.097-.937.08-1.647.701-1.585 1.387.061.686.87 1.176 1.807 1.097.937-.08 1.647-.701 1.585-1.387Z",
    fill: "#023F80"
  })), _path2$17 || (_path2$17 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.443 4.262c2.36 2.44 1.77 9.15 0 13.419C21.673 21.95 18.13 25 14 25c-4.131 0-7.672-3.05-9.443-7.32-1.77-4.269-2.36-10.978 0-13.418C6.11 2.657 7.663 2.908 9.89 3.267c1.157.187 2.496.404 4.111.404 1.615 0 2.954-.217 4.111-.404 2.226-.359 3.779-.61 5.332.995Zm-1.437 1.391c.253.262.536.762.737 1.6.197.822.283 1.838.25 2.974-.067 2.282-.609 4.786-1.397 6.688C20.024 20.705 17.068 23 14 23c-3.068 0-6.024-2.295-7.596-6.085-.788-1.902-1.33-4.406-1.397-6.688-.033-1.136.053-2.152.25-2.973.201-.839.484-1.34.737-1.601.37-.381.653-.517.893-.582.28-.076.66-.098 1.295-.03.301.031.694.094 1.157.168 1.204.193 2.882.462 4.661.462 1.78 0 3.457-.269 4.661-.462.463-.074.856-.137 1.157-.169.635-.067 1.014-.045 1.295.031.24.065.524.2.893.582Z",
    fill: "#023F80"
  })));
};

var _path$3K, _path2$18;
function _extends$3N() { _extends$3N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3N.apply(this, arguments); }
var SvgMegafonOutline = function SvgMegafonOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3N({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3K || (_path$3K = /*#__PURE__*/createElement$2("path", {
    d: "M13 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM16 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM19 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM22 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: "#023F80"
  })), _path2$18 || (_path2$18 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14C2 7.373 7.373 2 14 2s12 5.373 12 12-5.373 12-12 12S2 20.627 2 14Zm2 0C4 8.477 8.477 4 14 4v9h-1.5a1.5 1.5 0 0 0-1.5 1.5v9.042C6.943 22.268 4 18.478 4 14Zm8-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm2 12c5.523 0 10-4.477 10-10 0-4.838-3.436-8.873-8-9.8v9.3a1.5 1.5 0 0 1-1.5 1.5H13v8.95c.329.033.662.05 1 .05Zm2-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: "#023F80"
  })));
};

var _path$3L;
function _extends$3O() { _extends$3O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3O.apply(this, arguments); }
var SvgMentionOutline = function SvgMentionOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3O({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3L || (_path$3L = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 11.97c0 6.103 4.155 9.73 9.917 9.73 1.467 0 2.77-.188 3.639-.481.704-.235.95-.552.95-.963 0-.41-.27-.669-.75-.669-.118 0-.27.012-.459.047-1.056.259-1.866.423-3.016.423-5.047 0-8.45-2.934-8.45-8.016 0-4.918 3.157-8.31 7.957-8.31 4.19 0 7.582 2.57 7.582 7.3 0 2.465-.892 4.19-2.195 4.19-.845 0-1.302-.457-1.302-1.255V8.144c0-.657-.376-1.056-1.01-1.056-.622 0-1.01.4-1.01 1.056v.587h-.117c-.48-1.044-1.572-1.643-2.863-1.643-2.336 0-3.99 1.972-3.99 4.87 0 2.947 1.654 4.965 4.072 4.965 1.361 0 2.418-.68 2.934-1.878h.118c.21 1.186 1.314 1.878 2.77 1.878 2.734 0 4.424-2.523 4.424-6.032 0-5.352-3.932-8.791-9.39-8.791C6.515 2.1 2.5 5.985 2.5 11.97Zm9.366 3.122c-1.456 0-2.312-1.173-2.312-3.122 0-1.936.868-3.086 2.312-3.086 1.479 0 2.418 1.197 2.418 3.075 0 1.925-.951 3.133-2.418 3.133Z",
    fill: "#023F80"
  })));
};

var _path$3M;
function _extends$3P() { _extends$3P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3P.apply(this, arguments); }
var SvgMenuOutline = function SvgMenuOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3P({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3M || (_path$3M = /*#__PURE__*/createElement$2("path", {
    d: "M21 11H3a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2Zm0-7H3a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2ZM3 20h18a1 1 0 1 0 0-2H3a1 1 0 1 0 0 2Z",
    fill: "#023F80"
  })));
};

var _path$3N, _path2$19;
function _extends$3Q() { _extends$3Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Q.apply(this, arguments); }
var SvgMessageAddBadgeOutline = function SvgMessageAddBadgeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3Q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3N || (_path$3N = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8a5 5 0 1 0-10 0 5 5 0 0 0 10 0Zm-5.828-2.764a.834.834 0 0 1 1.661.097v1.834h1.834l.097.005a.833.833 0 0 1-.097 1.661h-1.834v1.834l-.005.097a.833.833 0 0 1-1.661-.097V8.833h-1.834l-.097-.005a.833.833 0 0 1 .097-1.661h1.834V5.333l.005-.097Z",
    fill: "#023F80"
  })), _path2$19 || (_path2$19 = /*#__PURE__*/createElement$2("path", {
    d: "M10.187 4.88a.9.9 0 1 0-.374-1.76c-4.24.899-7.681 4.457-7.681 8.587a7.72 7.72 0 0 0 1.377 4.38c-.04.519-.187 1.07-.404 1.657a22.756 22.756 0 0 1-.662 1.55c-.077.17-.155.34-.232.513-.39.865.282 1.828 1.21 1.792 2.195-.086 4-.638 5.247-1.79 1.048.327 2.175.505 3.348.505 3.643 0 7.02-1.636 8.742-4.329a.9.9 0 0 0-1.516-.97c-1.331 2.08-4.074 3.499-7.226 3.499a9.338 9.338 0 0 1-3.281-.586.9.9 0 0 0-1.002.26c-.678.797-1.8 1.353-3.513 1.547.197-.434.4-.9.574-1.367.289-.783.525-1.653.525-2.553a.9.9 0 0 0-.177-.537c-.773-1.04-1.21-2.265-1.21-3.571 0-3.103 2.66-6.064 6.255-6.827Z",
    fill: "#023F80"
  })));
};

var _path$3O, _path2$1a, _path3$p;
function _extends$3R() { _extends$3R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3R.apply(this, arguments); }
var SvgMessageArrowRightOutline = function SvgMessageArrowRightOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3R({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3O || (_path$3O = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.016 4.9c-4.6 0-8.084 3.172-8.084 6.807 0 1.306.437 2.532 1.21 3.57a.9.9 0 0 1 .177.538c0 .9-.236 1.77-.525 2.553-.173.467-.377.933-.574 1.367 1.714-.194 2.835-.75 3.513-1.547a.9.9 0 0 1 1.002-.26c1 .376 2.11.586 3.28.586 4.6 0 8.085-3.172 8.085-6.807 0-3.635-3.485-6.807-8.084-6.807ZM3.852 20.546l.002-.003-.002.003Zm-1.72-8.84c0-4.877 4.56-8.606 9.884-8.606 5.324 0 9.884 3.729 9.884 8.607 0 4.878-4.56 8.607-9.884 8.607-1.173 0-2.3-.178-3.348-.506C7.42 20.961 5.616 21.513 3.42 21.6c-.927.036-1.598-.927-1.209-1.792.077-.173.155-.344.232-.513a22.77 22.77 0 0 0 .662-1.55c.217-.587.364-1.138.404-1.656a7.72 7.72 0 0 1-1.377-4.381Z",
    fill: "#023F80"
  })), _path2$1a || (_path2$1a = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6 11.5a.9.9 0 0 1 .9-.9h7a.9.9 0 1 1 0 1.8h-7a.9.9 0 0 1-.9-.9Z",
    fill: "#023F80"
  })), _path3$p || (_path3$p = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.264 8.264a.9.9 0 0 1 1.272 0l2.6 2.6a.9.9 0 0 1 0 1.272l-2.6 2.6a.9.9 0 0 1-1.272-1.272l1.963-1.964-1.963-1.964a.9.9 0 0 1 0-1.272Z",
    fill: "#023F80"
  })));
};

var _path$3P, _path2$1b;
function _extends$3S() { _extends$3S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3S.apply(this, arguments); }
var SvgMessageCheckOutline = function SvgMessageCheckOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3S({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3P || (_path$3P = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.537 13.499c0-5.66 5.289-9.999 11.482-9.999C20.21 3.5 25.5 7.839 25.5 13.499s-5.289 9.999-11.482 9.999c-1.373 0-2.693-.21-3.918-.597C8.657 24.25 6.556 24.898 3.989 25c-1.046.041-1.8-1.047-1.363-2.021.622-1.391 1.424-2.987 1.52-4.378-1.017-1.48-1.608-3.228-1.608-5.101ZM14.019 5.5c-5.386 0-9.482 3.719-9.482 7.999 0 1.537.515 2.979 1.422 4.2a1 1 0 0 1 .197.597c0 1.634-.651 3.175-1.315 4.638 2.057-.219 3.405-.877 4.219-1.834a1 1 0 0 1 1.113-.289c1.172.44 2.473.687 3.845.687 5.386 0 9.482-3.719 9.482-8 0-4.28-4.096-7.998-9.482-7.998Z",
    fill: "#023F80"
  })), _path2$1b || (_path2$1b = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.207 10.293a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414l1.293 1.293 4.293-4.293a1 1 0 0 1 1.414 0Z",
    fill: "#023F80"
  })));
};

var _path$3Q, _path2$1c;
function _extends$3T() { _extends$3T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3T.apply(this, arguments); }
var SvgMessageCrossOutline = function SvgMessageCrossOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3T({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3Q || (_path$3Q = /*#__PURE__*/createElement$2("path", {
    d: "M17.457 10.043a1 1 0 0 1 0 1.414L15.414 13.5l2.043 2.043a1 1 0 0 1-1.414 1.414L14 14.914l-2.043 2.043a1 1 0 0 1-1.414-1.414l2.043-2.043-2.043-2.043a1 1 0 0 1 1.414-1.414L14 12.086l2.043-2.043a1 1 0 0 1 1.414 0Z",
    fill: "#023F80"
  })), _path2$1c || (_path2$1c = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.018 3.5c-6.192 0-11.481 4.339-11.481 9.999 0 1.873.59 3.62 1.608 5.101-.045.617-.22 1.272-.475 1.966-.228.616-.499 1.21-.775 1.815l-.27.597c-.438.974.317 2.062 1.363 2.02 2.568-.1 4.668-.748 6.113-2.097 1.224.387 2.544.597 3.917.597 6.193 0 11.482-4.34 11.482-10C25.5 7.84 20.211 3.5 14.018 3.5Zm-9.481 9.999c0-4.28 4.096-7.999 9.482-7.999 5.385 0 9.481 3.719 9.481 7.999 0 4.28-4.096 7.999-9.482 7.999-1.372 0-2.673-.246-3.845-.687a1 1 0 0 0-1.113.289c-.814.957-2.162 1.615-4.219 1.834.24-.53.493-1.102.705-1.675.336-.911.61-1.921.61-2.963a1 1 0 0 0-.197-.596c-.907-1.222-1.422-2.664-1.422-4.201Z",
    fill: "#023F80"
  })));
};

var _path$3R, _path2$1d;
function _extends$3U() { _extends$3U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3U.apply(this, arguments); }
var SvgMessageForwardOutline = function SvgMessageForwardOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3U({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3R || (_path$3R = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.656 3.96a.9.9 0 0 1 .944-.854c5.063.257 9.3 3.895 9.3 8.596 0 4.88-4.56 8.61-9.884 8.61-1.173 0-2.3-.177-3.348-.505C7.42 20.961 5.616 21.513 3.42 21.6c-.927.036-1.598-.928-1.209-1.793.077-.173.155-.344.232-.513.237-.518.468-1.025.662-1.551.217-.587.364-1.139.404-1.657a7.771 7.771 0 0 1-1.346-3.695.9.9 0 1 1 1.792-.163 6.007 6.007 0 0 0 1.187 3.048.9.9 0 0 1 .177.537c0 .9-.236 1.771-.525 2.554-.173.468-.377.933-.574 1.369 1.714-.195 2.835-.752 3.513-1.549a.9.9 0 0 1 1.002-.26c1 .376 2.11.586 3.28.586 4.6 0 8.085-3.174 8.085-6.81 0-3.506-3.232-6.576-7.591-6.798a.9.9 0 0 1-.853-.944ZM3.852 20.545l.002-.003-.002.003Z",
    fill: "#023F80"
  })), _path2$1d || (_path2$1d = /*#__PURE__*/createElement$2("path", {
    d: "m7.465 10.176 3.148-2.465c.173-.135.26-.203.316-.268a.95.95 0 0 0 0-1.26c-.057-.065-.143-.133-.316-.268L7.465 3.45c-.206-.161-.309-.242-.385-.278a.75.75 0 0 0-1.051.512c-.019.083-.019.213-.019.475v1.053c-2.53.398-3.477 2.074-3.822 3.446-.059.234-.088.35-.089.417a.535.535 0 0 0 .725.526c.062-.02.234-.128.577-.344a4.838 4.838 0 0 1 2.609-.743v.953c0 .261 0 .392.019.474a.75.75 0 0 0 1.05.513c.077-.036.18-.117.386-.278Z",
    fill: "#023F80"
  })));
};

var _path$3S, _path2$1e;
function _extends$3V() { _extends$3V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3V.apply(this, arguments); }
var SvgMessageHeartOutline = function SvgMessageHeartOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3V({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3S || (_path$3S = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.019 5.5c-5.385 0-9.482 3.719-9.482 7.999 0 1.537.515 2.979 1.422 4.2a1 1 0 0 1 .197.597c0 1.042-.273 2.052-.61 2.963a25.572 25.572 0 0 1-.704 1.675c2.056-.219 3.405-.877 4.218-1.834a1 1 0 0 1 1.114-.289c.58.218 1.19.388 1.825.505a1 1 0 0 1-.36 1.967 12.739 12.739 0 0 1-1.538-.382C8.656 24.25 6.557 24.898 3.989 25c-1.047.041-1.802-1.047-1.364-2.021l.27-.597c.276-.605.547-1.199.775-1.815.256-.694.43-1.349.475-1.966-1.017-1.48-1.608-3.228-1.608-5.101 0-5.66 5.29-9.999 11.482-9.999 4.247 0 8.012 2.013 10.004 5.085a1 1 0 1 1-1.678 1.088c-1.588-2.45-4.69-4.173-8.326-4.173Z",
    fill: "#023F80"
  })), _path2$1e || (_path2$1e = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.137 12.824a4.752 4.752 0 0 1 2.438-.817l.267-.007A4.158 4.158 0 0 1 26 16.158c0 2.242-.892 3.358-4.447 6.123l-1.647 1.281a1.476 1.476 0 0 1-1.812 0l-1.647-1.28C12.892 19.516 12 18.4 12 16.158A4.158 4.158 0 0 1 16.158 12c.986 0 1.895.28 2.705.824l.137.096.137-.096ZM24 16.158A2.158 2.158 0 0 0 21.842 14c-.803 0-1.498.3-2.135.937l-.354.354a.5.5 0 0 1-.706 0l-.354-.354c-.637-.636-1.332-.937-2.135-.937A2.158 2.158 0 0 0 14 16.158c0 1.41.584 2.14 3.675 4.545L19 21.733l1.845-1.438c2.555-2.02 3.12-2.763 3.153-4.015l.002-.122Z",
    fill: "#023F80"
  })));
};

var _path$3T;
function _extends$3W() { _extends$3W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3W.apply(this, arguments); }
var SvgMessageOutline = function SvgMessageOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3W({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3T || (_path$3T = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.016 4.9c-4.6 0-8.084 3.172-8.084 6.807 0 1.306.437 2.532 1.21 3.57a.9.9 0 0 1 .177.538c0 1.38-.54 2.684-1.099 3.92 1.714-.194 2.835-.75 3.513-1.547a.9.9 0 0 1 1.002-.26c1 .376 2.11.586 3.28.586 4.6 0 8.085-3.172 8.085-6.807 0-3.635-3.485-6.807-8.084-6.807Zm-9.884 6.807c0-4.878 4.56-8.607 9.884-8.607 5.324 0 9.884 3.729 9.884 8.607 0 4.878-4.56 8.607-9.884 8.607-1.173 0-2.3-.178-3.348-.506C7.42 20.961 5.616 21.513 3.42 21.6c-.927.036-1.598-.927-1.209-1.792.529-1.183 1.197-2.403 1.298-3.72a7.72 7.72 0 0 1-1.377-4.38Z",
    fill: "#023F80"
  })));
};

var _path$3U;
function _extends$3X() { _extends$3X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3X.apply(this, arguments); }
var SvgMessageReplyOutline = function SvgMessageReplyOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3X({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3U || (_path$3U = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.397 7.598 3.148 2.464c.206.16.31.241.385.277a.75.75 0 0 0 1.051-.512C18 9.745 18 9.614 18 9.353V8.4c1.1 0 1.967.34 2.609.743.343.216.515.323.577.344a.535.535 0 0 0 .725-.526c0-.066-.03-.183-.09-.416C21.478 7.173 20.532 5.498 18 5.1V4.047c0-.261 0-.392-.019-.474a.75.75 0 0 0-1.05-.512c-.077.036-.18.116-.386.277l-3.148 2.464c-.173.135-.259.203-.316.268a.95.95 0 0 0 0 1.26c.057.065.143.133.316.268ZM11.374 4.92a.9.9 0 0 0-.116-1.796C6.26 3.446 2.1 7.06 2.1 11.714c0 1.606.504 3.104 1.373 4.375-.035.289-.123.684-.288 1.2-.217.683-.55 1.525-1.005 2.531a1.272 1.272 0 0 0 1.21 1.795c2.2-.086 4.007-.639 5.257-1.793 1.049.329 2.178.507 3.353.507 5.098 0 9.48-3.4 9.872-7.963a.9.9 0 1 0-1.793-.154c-.294 3.42-3.686 6.317-8.079 6.317a9.362 9.362 0 0 1-3.287-.586.9.9 0 0 0-1.001.26c-.681.8-1.81 1.358-3.537 1.55.303-.712.545-1.351.725-1.917.242-.759.39-1.442.39-2.01a.9.9 0 0 0-.178-.537C4.338 14.248 3.9 13.021 3.9 11.714c0-3.472 3.17-6.517 7.474-6.794Z",
    fill: "#023F80"
  })));
};

var _path$3V;
function _extends$3Y() { _extends$3Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Y.apply(this, arguments); }
var SvgMessageUnreadOutline = function SvgMessageUnreadOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3Y({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3V || (_path$3V = /*#__PURE__*/createElement$2("path", {
    d: "M14 3.5c6.32 0 11.5 4.44 11.5 10s-5.18 10-11.5 10c-1.355 0-2.678-.204-3.924-.597-1.402 1.306-3.458 1.994-6.124 2.098a1.434 1.434 0 0 1-1.363-2.023c.911-2.015 1.413-3.498 1.514-4.379C3.062 17.073 2.5 15.323 2.5 13.5c0-5.56 5.18-10 11.5-10Zm0 2c-5.278 0-9.5 3.619-9.5 8 0 1.508.497 2.955 1.426 4.213a1 1 0 0 1 .196.598c-.004 1.047-.45 2.567-1.33 4.627 1.987-.208 3.388-.831 4.245-1.837a1 1 0 0 1 1.111-.287c1.202.45 2.506.686 3.852.686 5.278 0 9.5-3.619 9.5-8s-4.222-8-9.5-8Zm0 6.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z",
    fill: "#023F80"
  })));
};

var _path$3W;
function _extends$3Z() { _extends$3Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Z.apply(this, arguments); }
var SvgMessageUnreadTopOutline = function SvgMessageUnreadTopOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3Z({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3W || (_path$3W = /*#__PURE__*/createElement$2("path", {
    d: "M14.023 3c.926 0 1.828.09 2.695.26.548.108.766.755.561 1.274-.17.435-.623.747-1.083.662A12.012 12.012 0 0 0 14.023 5c-5.545 0-9.978 3.727-9.978 8.23 0 1.548.521 3.034 1.493 4.315a1 1 0 0 1 .203.604c0 .988-.393 2.384-1.173 4.25l-.151.354-.083.187.408-.046c1.698-.22 2.965-.74 3.825-1.542l.167-.164.14-.153a1 1 0 0 1 1.1-.283c1.263.464 2.634.707 4.049.707 5.545 0 9.977-3.726 9.977-8.23 0-1.05-.24-2.057-.68-2.985-.195-.411-.057-.914.288-1.21.435-.375 1.152-.385 1.412.128.63 1.243.98 2.618.98 4.068 0 5.692-5.397 10.23-11.977 10.23-1.181 0-2.34-.147-3.447-.43l-.471-.13-.202-.063-.08.076c-1.32 1.177-3.184 1.849-5.564 2.042l-.401.028-.371.017a1.433 1.433 0 0 1-1.474-1.628c.566-1.541 1.376-3.018 1.669-4.647l.027-.168.013-.109-.188-.278a9.067 9.067 0 0 1-1.46-4.24l-.021-.35-.007-.35C2.046 7.538 7.443 3 14.023 3ZM21 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z",
    fill: "#023F80"
  })));
};

var _path$3X;
function _extends$3_() { _extends$3_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3_.apply(this, arguments); }
var SvgMessagesOutline = function SvgMessagesOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3_({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3X || (_path$3X = /*#__PURE__*/createElement$2("path", {
    d: "M23.706 9.662C25.171 11.114 26 12.998 26 15a7.25 7.25 0 0 1-.96 3.599c.101.603.393 1.519.876 2.716l.258.624.057.168.025.098a1.4 1.4 0 0 1-1.446 1.675c-1.908-.1-3.43-.566-4.54-1.424A9.99 9.99 0 0 1 17 23a9.981 9.981 0 0 1-3.332-.566 1 1 0 1 1 .668-1.885c.837.296 1.737.451 2.664.451a7.923 7.923 0 0 0 3.087-.615 1 1 0 0 1 1.1.218c.55.555 1.371.941 2.481 1.14l.284.047c-.574-1.456-.888-2.555-.943-3.343a1 1 0 0 1 .153-.604A5.279 5.279 0 0 0 24 15c0-1.454-.607-2.832-1.702-3.918a1 1 0 1 1 1.409-1.42ZM11 3c4.943 0 9 3.55 9 8s-4.057 8-9 8a9.99 9.99 0 0 1-3.27-.544c-1.11.858-2.632 1.323-4.54 1.424a1.4 1.4 0 0 1-1.446-1.675l.025-.098.057-.168.134-.319c.515-1.244.838-2.209.971-2.864l.03-.157-.151-.279A7.229 7.229 0 0 1 2 11c0-4.45 4.057-8 9-8Zm0 2c-3.893 0-7 2.718-7 6 0 1.007.29 1.976.838 2.843a1 1 0 0 1 .153.604c-.05.732-.325 1.732-.824 3.036l-.119.307.284-.046c1.11-.2 1.932-.586 2.482-1.141a1 1 0 0 1 1.1-.218c.95.403 2 .615 3.086.615 3.893 0 7-2.718 7-6s-3.107-6-7-6Z",
    fill: "#023F80"
  })));
};

var _path$3Y;
function _extends$3$() { _extends$3$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3$.apply(this, arguments); }
var SvgMicrophoneSlashOutline = function SvgMicrophoneSlashOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$3$({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3Y || (_path$3Y = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.193 2.883A4.9 4.9 0 0 1 16.9 6.9v3.018a.9.9 0 0 1-1.8 0V6.9a3.1 3.1 0 0 0-4.875-2.542.9.9 0 1 1-1.032-1.475ZM7.1 11.1a4.9 4.9 0 0 0 7.729 4.001l1.449 1.45A7.007 7.007 0 0 1 12 18a7.061 7.061 0 0 1-6.12-3.55.9.9 0 1 0-1.56.9 8.872 8.872 0 0 0 6.78 4.405V22.1a.9.9 0 1 0 1.8 0v-2.345a8.808 8.808 0 0 0 4.66-1.923l1.804 1.804a.9.9 0 0 0 1.272-1.272l-15-15a.9.9 0 0 0-1.272 1.272L7.1 7.373V11.1Zm1.8 0a3.1 3.1 0 0 0 4.626 2.7L8.9 9.172V11.1Z",
    fill: "#023F80"
  })));
};

var _path$3Z, _path2$1f, _path3$q;
function _extends$40() { _extends$40 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$40.apply(this, arguments); }
var SvgMicrophoneVideocamOutline = function SvgMicrophoneVideocamOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$40({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3Z || (_path$3Z = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9.5a4.5 4.5 0 0 1 9 0v4a4.5 4.5 0 1 1-9 0v-4ZM9.5 7A2.5 2.5 0 0 0 7 9.5v4a2.5 2.5 0 0 0 5 0v-4A2.5 2.5 0 0 0 9.5 7Z",
    fill: "#023F80"
  })), _path2$1f || (_path2$1f = /*#__PURE__*/createElement$2("path", {
    d: "M10.5 21.942a8.504 8.504 0 0 0 6.366-4.198 1 1 0 0 0-1.732-1A6.497 6.497 0 0 1 9.5 20a6.497 6.497 0 0 1-5.634-3.256 1 1 0 0 0-1.732 1A8.503 8.503 0 0 0 8.5 21.942V23a1 1 0 1 0 2 0v-1.058Z",
    fill: "#023F80"
  })), _path3$q || (_path3$q = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12a1 1 0 1 1 0-2c1.686.009 2.317.194 2.953.534.652.349 1.164.86 1.512 1.512.188.35.328.699.418 1.223l1.057-.66c1.332-.833 3.06.124 3.06 1.695v4.392c0 1.57-1.728 2.528-3.06 1.696l-1.057-.66c-.09.523-.23.872-.418 1.222a3.636 3.636 0 0 1-1.512 1.512c-.632.337-1.259.522-2.92.534H17a1 1 0 1 1 0-2c1.221-.005 1.611-.085 2.01-.298.303-.162.529-.388.691-.692.22-.411.298-.814.298-2.138V14.89c-.01-1.136-.091-1.515-.298-1.9a1.636 1.636 0 0 0-.692-.692c-.398-.213-.788-.293-2.009-.298Zm5 5.446 2 1.25v-4.392l-2 1.25v1.892Z",
    fill: "#023F80"
  })));
};

var _path$3_, _path2$1g;
function _extends$41() { _extends$41 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$41.apply(this, arguments); }
var SvgMicrophoneVideocamSlashOutline = function SvgMicrophoneVideocamSlashOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$41({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3_ || (_path$3_ = /*#__PURE__*/createElement$2("path", {
    d: "M9.44 5h.06A4.5 4.5 0 0 1 14 9.5v.24a1 1 0 1 1-2 0V9.5A2.5 2.5 0 0 0 9.5 7h-.034a1 1 0 1 1-.026-2Z",
    fill: "#023F80"
  })), _path2$1g || (_path2$1g = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.088 8.608-1.795-1.9a1 1 0 0 1 1.414-1.415l17 18a1 1 0 1 1-1.414 1.414l-1.702-1.802c-.4.058-.897.09-1.558.095H17a1 1 0 0 1-.191-1.982l-1.364-1.444a8.476 8.476 0 0 1-4.945 2.368V23a1 1 0 1 1-2 0v-1.058a8.503 8.503 0 0 1-6.366-4.198 1 1 0 1 1 1.732-1A6.497 6.497 0 0 0 9.5 20a6.477 6.477 0 0 0 4.572-1.88l-1.374-1.454A4.5 4.5 0 0 1 5 13.5v-4c0-.305.03-.603.088-.892Zm6.236 6.602A2.5 2.5 0 0 1 7 13.5v-2.868l4.324 4.578ZM17 12a1 1 0 1 1 0-2c1.686.009 2.317.194 2.953.534.652.349 1.164.86 1.512 1.512.188.35.328.699.418 1.223l1.057-.66c1.332-.833 3.06.124 3.06 1.695v4.392c0 1.57-1.728 2.528-3.06 1.696l-2.46-1.537a1.027 1.027 0 0 1-.276-.249.995.995 0 0 1-.184-.407h-.023c.002-.102.002-.21.002-.327V14.89c-.01-1.136-.091-1.515-.298-1.9a1.636 1.636 0 0 0-.692-.692c-.398-.213-.788-.293-2.009-.298Zm5 5.446 2 1.25v-4.392l-2 1.25v1.892Z",
    fill: "#023F80"
  })));
};

var _path$3$;
function _extends$42() { _extends$42 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$42.apply(this, arguments); }
var SvgMinusOutline = function SvgMinusOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$42({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3$ || (_path$3$ = /*#__PURE__*/createElement$2("path", {
    d: "M23 13H5a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2Z",
    fill: "#023F80"
  })));
};

var _path$40;
function _extends$43() { _extends$43 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$43.apply(this, arguments); }
var SvgMoneyCircleOutline = function SvgMoneyCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$43({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$40 || (_path$40 = /*#__PURE__*/createElement$2("path", {
    d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm0 1.8a9.2 9.2 0 1 0 0 18.4 9.2 9.2 0 0 0 0-18.4ZM13.253 7a3.357 3.357 0 0 1 0 6.714H11V15h1.5a.75.75 0 0 1 0 1.5H11v.65a.85.85 0 1 1-1.7 0l-.001-.65H8.5a.75.75 0 0 1 0-1.5h.799v-1.286h-.692a.857.857 0 0 1 0-1.714H9.3L9.3 7.85c0-.47.38-.85.85-.85h3.103Zm.033 1.571H11V12h2.286a1.714 1.714 0 1 0 0-3.429Z",
    fill: "#023F80"
  })));
};

var _path$41;
function _extends$44() { _extends$44 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$44.apply(this, arguments); }
var SvgMoneyHistoryBackwardOutline = function SvgMoneyHistoryBackwardOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$44({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$41 || (_path$41 = /*#__PURE__*/createElement$2("path", {
    d: "M14 2c6.627 0 12 5.373 12 12s-5.373 12-12 12c-3.226 0-6.251-1.28-8.487-3.516a1 1 0 1 1 1.415-1.414A9.964 9.964 0 0 0 14 24c5.523 0 10-4.477 10-10S19.523 4 14 4a9.974 9.974 0 0 0-7.143 3H8.5a1 1 0 0 1 .117 1.993L8.5 9h-4a1 1 0 0 1-.993-.883L3.5 8V4a1 1 0 0 1 1.993-.117L5.5 4v1.529A11.973 11.973 0 0 1 14 2Zm1.177 6.67c2.481 0 3.884 1.386 3.884 3.56 0 2.084-1.295 3.52-3.91 3.52h-1.593v1.195h1.793c.523 0 .847.282.847.74 0 .456-.332.73-.847.73h-1.835v.78c-.116.58-.547.888-1.079.888-.523 0-.963-.307-1.079-.888v-.78h-.78c-.531 0-.847-.274-.847-.73 0-.457.316-.74.847-.74h.739V15.75h-.615c-.606-.008-.97-.332-.97-.872 0-.53.364-.863.97-.88h.615v-3.602c0-1.187.547-1.727 1.71-1.727h2.15Zm-.382 1.784H13.55v3.544h1.054c1.477 0 2.175-.473 2.175-1.76 0-1.278-.706-1.784-1.984-1.784Z",
    fill: "#023F80"
  })));
};

var _path$42;
function _extends$45() { _extends$45 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$45.apply(this, arguments); }
var SvgMoneyRequestOutline = function SvgMoneyRequestOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$45({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$42 || (_path$42 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.995 4.978C15.787 4.911 15.5 4.9 14.5 4.9H7c-.715 0-1.197 0-1.569.031-.36.03-.538.083-.657.143a1.6 1.6 0 0 0-.7.7c-.06.119-.113.296-.143.657-.015.19-.023.407-.027.669h13.195c-.003-.684-.02-.918-.077-1.094a1.6 1.6 0 0 0-1.027-1.028ZM18.9 7.155c0-.692-.013-1.235-.166-1.706a3.4 3.4 0 0 0-2.183-2.183c-.516-.167-1.118-.167-1.907-.166H6.963c-.668 0-1.224 0-1.678.037-.473.039-.913.122-1.328.334A3.4 3.4 0 0 0 2.47 4.956c-.212.416-.295.856-.334 1.329-.037.453-.037 1.01-.037 1.678V16.037c0 .669 0 1.225.037 1.678.039.473.122.913.334 1.329a3.4 3.4 0 0 0 1.486 1.485c.415.212.855.295 1.328.334.454.037 1.01.037 1.678.037H11.1a.9.9 0 0 0 0-1.8H7c-.715 0-1.197 0-1.569-.031-.36-.03-.538-.083-.657-.143a1.6 1.6 0 0 1-.7-.7c-.06-.119-.113-.296-.143-.657-.03-.372-.03-.854-.03-1.569V8.9H17c.714 0 1.196 0 1.568.031.361.03.538.083.658.143a1.6 1.6 0 0 1 .699.7c.06.119.114.296.143.657.03.372.031.854.031 1.569v4.1a.9.9 0 0 0 1.8 0v-4.137c0-.669 0-1.224-.037-1.678-.039-.473-.122-.913-.334-1.329a3.4 3.4 0 0 0-1.485-1.485c-.361-.184-.74-.271-1.144-.316Zm-3 5.945a.9.9 0 1 0 0 1.8h1.2a.9.9 0 0 0 0-1.8h-1.2Zm1.836 4.936a.9.9 0 1 0-1.272-1.272l-2.6 2.6a.9.9 0 0 0 0 1.272l2.6 2.6a.9.9 0 1 0 1.273-1.272L16.672 20.9H22.1a.9.9 0 0 0 0-1.8h-5.427l1.064-1.064Z",
    fill: "#023F80"
  })));
};

var _path$43;
function _extends$46() { _extends$46 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$46.apply(this, arguments); }
var SvgMoneySendOutline = function SvgMoneySendOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$46({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$43 || (_path$43 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.995 4.978C15.787 4.911 15.5 4.9 14.5 4.9H7c-.715 0-1.197 0-1.569.031-.36.03-.538.083-.657.143a1.6 1.6 0 0 0-.7.7c-.06.119-.113.296-.143.657-.015.19-.023.407-.027.669h13.195c-.003-.684-.02-.918-.077-1.094a1.6 1.6 0 0 0-1.027-1.028ZM18.9 7.155c0-.692-.013-1.235-.166-1.706a3.4 3.4 0 0 0-2.183-2.183c-.516-.167-1.118-.167-1.907-.166H6.963c-.668 0-1.224 0-1.678.037-.473.039-.913.122-1.328.334A3.4 3.4 0 0 0 2.47 4.956c-.212.416-.295.856-.334 1.329-.037.453-.037 1.01-.037 1.678V16.037c0 .669 0 1.225.037 1.678.039.473.122.913.334 1.329a3.4 3.4 0 0 0 1.486 1.485c.415.212.855.295 1.328.334.454.037 1.01.037 1.678.037h11.964l-.963.964a.9.9 0 1 0 1.273 1.272l2.5-2.5a.9.9 0 0 0 0-1.272l-2.5-2.5a.9.9 0 1 0-1.273 1.272l.963.964H7c-.715 0-1.197 0-1.569-.031-.36-.03-.538-.083-.657-.143a1.6 1.6 0 0 1-.7-.7c-.06-.119-.113-.296-.143-.657-.03-.372-.03-.854-.03-1.569V8.9H17c.714 0 1.196 0 1.568.031.361.03.538.083.658.143a1.6 1.6 0 0 1 .699.7c.06.119.114.296.143.657.03.372.031.854.031 1.569v2.6a.9.9 0 0 0 1.8 0v-2.637c0-.669 0-1.224-.037-1.678-.039-.473-.122-.913-.334-1.329a3.4 3.4 0 0 0-1.485-1.485c-.361-.184-.74-.271-1.144-.316Zm-3 5.945a.9.9 0 1 0 0 1.8h1.2a.9.9 0 0 0 0-1.8h-1.2Z",
    fill: "#023F80"
  })));
};

var _path$44;
function _extends$47() { _extends$47 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$47.apply(this, arguments); }
var SvgMoneyTransferOutline = function SvgMoneyTransferOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$47({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$44 || (_path$44 = /*#__PURE__*/createElement$2("path", {
    d: "M17.795 3.1c1.152 0 1.74.113 2.35.44.565.302 1.013.75 1.315 1.315.302.564.421 1.107.438 2.094l.002.256V12a.9.9 0 0 1-1.793.113L20.1 12V8.9H3.9v5.895c0 .88.06 1.187.228 1.502.134.25.325.441.575.575.291.156.575.218 1.309.227l.193.001h12.622l-1.463-1.464a.9.9 0 0 1-.08-1.18l.08-.092a.9.9 0 0 1 1.18-.08l.093.08 3 3a.9.9 0 0 1 .08 1.18l-.08.092-3 3a.9.9 0 0 1-1.354-1.18l.08-.092 1.464-1.464H6.205c-1.063 0-1.646-.097-2.21-.369l-.14-.071a3.17 3.17 0 0 1-1.315-1.315c-.301-.564-.421-1.107-.438-2.094l-.002-.256v-7.59c0-1.152.113-1.74.44-2.35A3.171 3.171 0 0 1 3.855 3.54c.564-.301 1.108-.421 2.094-.438l.256-.002h11.59Zm0 1.8H6.205c-.88 0-1.187.06-1.502.228-.25.134-.441.325-.575.575-.156.291-.218.574-.227 1.309V7.1h16.197l.001-.088c-.009-.734-.071-1.018-.227-1.309a1.372 1.372 0 0 0-.575-.575c-.29-.156-.574-.218-1.309-.227l-.193-.001Z",
    fill: "#023F80"
  })));
};

var _path$45;
function _extends$48() { _extends$48 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$48.apply(this, arguments); }
var SvgMoneyWadOutline = function SvgMoneyWadOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$48({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$45 || (_path$45 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.759 5.5H20.24c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564.044.541.044 1.206.044 2.01v5.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 18.21 2 17.546 2 16.742v-5.483c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 5.5 6.954 5.5 7.758 5.5ZM5.91 7.538c-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 9.861 4 10.443 4 11.3v5.4c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18.45.037 1.032.038 1.889.038H9V17a3 3 0 1 1 0-6V7.5H7.8c-.857 0-1.439 0-1.889.038ZM17 20.5h-6v-13h6v13Zm2 0h1.2c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889v-5.4c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18-.45-.037-1.032-.038-1.889-.038H19V11a3 3 0 1 1 0 6v3.5Z",
    fill: "#023F80"
  })));
};

var _path$46;
function _extends$49() { _extends$49 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$49.apply(this, arguments); }
var SvgMoreHorizontal = function SvgMoreHorizontal(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$49({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$46 || (_path$46 = /*#__PURE__*/createElement$2("path", {
    d: "M8.5 14a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM16.5 14a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM22 16.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    fill: "#023F80"
  })));
};

var _path$47;
function _extends$4a() { _extends$4a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4a.apply(this, arguments); }
var SvgMoreVertical = function SvgMoreVertical(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4a({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$47 || (_path$47 = /*#__PURE__*/createElement$2("path", {
    d: "M16.25 7a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm0 7a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm0 7a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z",
    fill: "#023F80"
  })));
};

var _path$48;
function _extends$4b() { _extends$4b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4b.apply(this, arguments); }
var SvgMortarOutline = function SvgMortarOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4b({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$48 || (_path$48 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.986 5.517a2.65 2.65 0 0 1 5.119-1.372l.792 2.955h6.633c.444 0 .834 0 1.154.027.337.03.688.094 1.02.282.482.27.855.699 1.057 1.213.14.355.156.712.138 1.05-.017.32-.07.706-.132 1.146l-.005.036-.104.75-.005.036c-.131.948-.237 1.71-.371 2.325-.138.634-.32 1.177-.634 1.67a4.9 4.9 0 0 1-2.248 1.888V17.835c0 .53 0 .981-.03 1.352-.032.389-.102.768-.286 1.13a2.9 2.9 0 0 1-1.267 1.267c-.362.184-.74.254-1.13.286-.37.03-.822.03-1.351.03H9.665c-.53 0-.981 0-1.352-.03-.389-.032-.768-.102-1.13-.286a2.9 2.9 0 0 1-1.267-1.267c-.184-.362-.254-.741-.286-1.13-.03-.37-.03-.822-.03-1.352V17.523a4.9 4.9 0 0 1-2.248-1.887c-.315-.494-.495-1.037-.633-1.67-.134-.616-.24-1.378-.372-2.326l-.005-.036-.104-.75-.005-.036c-.061-.44-.115-.826-.132-1.146-.017-.338-.001-.695.138-1.05a2.4 2.4 0 0 1 1.057-1.213c.332-.188.684-.253 1.02-.282.32-.027.71-.027 1.154-.027H6.41l-.424-1.583ZM8.273 7.1h1.76l-.667-2.49a.85.85 0 1 0-1.642.44l.55 2.05Zm1.243 9H14.484c.972 0 1.656-.001 2.196-.043.54-.041.867-.119 1.13-.239a3.1 3.1 0 0 0 1.32-1.15c.156-.244.278-.557.393-1.086.117-.54.215-1.234.352-2.225l.105-.75c.067-.487.11-.796.121-1.03.012-.224-.011-.286-.015-.297a.6.6 0 0 0-.264-.303c-.01-.006-.068-.037-.292-.056-.233-.02-.545-.021-1.036-.021H5.506c-.49 0-.802 0-1.035.02-.225.02-.282.051-.292.057a.6.6 0 0 0-.265.303c-.004.011-.027.073-.015.297.012.234.054.543.122 1.03l.104.75c.138.992.235 1.685.352 2.225.115.528.238.842.392 1.085a3.1 3.1 0 0 0 1.322 1.151c.262.12.59.198 1.13.24.54.04 1.224.042 2.195.042Zm-.073 1.8H7.4c0 .52.002.869.024 1.14.023.278.062.393.096.46a1.1 1.1 0 0 0 .48.48c.067.034.182.073.46.096.288.023.665.024 1.24.024h4.6c.575 0 .952 0 1.24-.024.278-.023.394-.062.46-.096a1.1 1.1 0 0 0 .48-.48c.034-.067.073-.182.096-.46.022-.271.024-.62.024-1.14H9.443Z",
    fill: "#023F80"
  })));
};

var _path$49;
function _extends$4c() { _extends$4c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4c.apply(this, arguments); }
var SvgMotorcycleOutline = function SvgMotorcycleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4c({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$49 || (_path$49 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1 5a.9.9 0 0 1 .9-.9h3.5a.9.9 0 0 1 .854.615l.461 1.385h1.435a2.65 2.65 0 0 1 .326 5.28l.574 1.723A3.9 3.9 0 1 1 14.1 16.9h-3.2v.1a3.9 3.9 0 0 1-7.8 0v-.1h-.6a.9.9 0 0 1-.9-.9v-1.037c0-.669 0-1.225.036-1.678.039-.473.122-.913.334-1.329a3.4 3.4 0 0 1 1.486-1.485c.415-.212.855-.295 1.328-.334.454-.037 1.01-.037 1.678-.037h1.214c1.225 0 2.068-.001 2.776.247a4.4 4.4 0 0 1 2.7 2.7c.196.56.237 1.203.245 2.053h1.195a3.916 3.916 0 0 1 1.777-1.644L13.851 5.9h-2.85a.9.9 0 0 1-.9-.9Zm6.882 4.6h.268a.85.85 0 0 0 0-1.7h-.835l.567 1.7ZM7.5 11.9c1.472 0 1.978.013 2.359.146a2.6 2.6 0 0 1 1.595 1.595c.102.29.133.653.143 1.459H3.4V15c0-.715 0-1.197.031-1.569.03-.361.083-.538.143-.657a1.6 1.6 0 0 1 .7-.7c.12-.06.296-.113.657-.143.372-.03.854-.031 1.57-.031h1Zm-2.6 5v.1a2.1 2.1 0 1 0 4.2 0v-.1H4.9Zm13.1-2a2.1 2.1 0 1 0 0 4.2 2.1 2.1 0 0 0 0-4.2Z",
    fill: "#023F80"
  })));
};

var _path$4a, _path2$1h;
function _extends$4d() { _extends$4d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4d.apply(this, arguments); }
var SvgMovieReelOutline = function SvgMovieReelOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4d({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4a || (_path$4a = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14C4 8.477 8.477 4 14 4s10 4.477 10 10-4.477 10-10 10S4 19.523 4 14Zm16.636 10A11.989 11.989 0 0 0 26 14c0-6.627-5.373-12-12-12S2 7.373 2 14s5.373 12 12 12h11a1 1 0 1 0 0-2h-4.364Z",
    fill: "#023F80"
  })), _path2$1h || (_path2$1h = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 10.25a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0Zm2.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM10.25 15a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5Zm-.75 2.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0ZM15 10.25a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0Zm2.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM17.75 15a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5ZM17 17.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z",
    fill: "#023F80"
  })));
};

var _path$4b;
function _extends$4e() { _extends$4e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4e.apply(this, arguments); }
var SvgMovimientos = function SvgMovimientos(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4e({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4b || (_path$4b = /*#__PURE__*/createElement$2("path", {
    d: "M18.502 5.4c.105 0 .206.032.291.092l3.163 2.243a.503.503 0 0 1 0 .82l-3.163 2.242a.503.503 0 0 1-.793-.41V9h-3.6c-1.022 0-1.88.756-3.562 3 1.626 2.169 2.482 2.948 3.46 2.997L14.4 15H18v-1.387a.503.503 0 0 1 .793-.41l3.163 2.242a.503.503 0 0 1 0 .82l-3.163 2.242a.503.503 0 0 1-.793-.41v-1.383h-3.6c-1.704 0-2.77-.848-4.628-3.281-1.86 2.433-2.925 3.281-4.63 3.281h-2.57a.857.857 0 0 1 0-1.714h2.57c1.023 0 1.88-.756 3.562-2.999-1.625-2.17-2.48-2.949-3.459-2.999L5.143 9H2.57a.857.857 0 0 1-.1-1.709l.1-.005h2.572c1.704 0 2.77.848 4.628 3.28 1.86-2.432 2.925-3.28 4.629-3.28H18V5.902c0-.277.225-.502.502-.502Z",
    fill: "#023F80"
  })));
};

var _path$4c, _path2$1i;
function _extends$4f() { _extends$4f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4f.apply(this, arguments); }
var SvgMusicMicOutline = function SvgMusicMicOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4f({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4c || (_path$4c = /*#__PURE__*/createElement$2("path", {
    d: "M9.249 12.83a.9.9 0 1 0-1.35-1.19l-3.978 4.508a3.029 3.029 0 0 0 4.275 4.275l4.508-3.978a.9.9 0 1 0-1.19-1.35l-4.51 3.979a1.229 1.229 0 0 1-1.734-1.735L9.25 12.83Z",
    fill: "#023F80"
  })), _path2$1i || (_path2$1i = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1 12.3a4.2 4.2 0 1 0 0-8.4 4.2 4.2 0 0 0 0 8.4Zm0 1.8a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
    fill: "#023F80"
  })));
};

var _path$4d;
function _extends$4g() { _extends$4g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4g.apply(this, arguments); }
var SvgMusicOutline = function SvgMusicOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4g({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4d || (_path$4d = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.716 4.065c.61-.127 1.01-.21 1.317-.246.299-.036.408-.013.456.004a.9.9 0 0 1 .486.395c.026.043.07.146.097.446.027.304.028.705.028 1.314L8.9 8.103v-.54c0-.477 0-.786.018-1.024.017-.228.046-.328.073-.39a1.1 1.1 0 0 1 .374-.46c.055-.039.147-.088.366-.15.23-.067.533-.13 1-.228l5.985-1.246ZM7.1 15.06h-.2c-1.795 0-3.125.452-4.021 1.215-.902.768-1.279 1.782-1.279 2.71a3.375 3.375 0 0 0 3.375 3.375c.928 0 1.942-.377 2.71-1.28.763-.895 1.215-2.225 1.215-4.02V9.942l10.2-2.125v5.243h-.2c-1.795 0-3.125.452-4.021 1.215-.902.768-1.279 1.782-1.279 2.71a3.375 3.375 0 0 0 3.375 3.375c.928 0 1.942-.377 2.71-1.28.763-.895 1.215-2.225 1.215-4.02V5.964c0-.573 0-1.061-.035-1.457-.036-.412-.116-.824-.34-1.204a2.7 2.7 0 0 0-1.457-1.185c-.417-.141-.837-.135-1.247-.087-.395.047-.873.147-1.434.264l-.038.007-5.985 1.247-.03.007c-.429.089-.797.166-1.099.252-.32.092-.624.21-.908.41a2.9 2.9 0 0 0-.987 1.214c-.139.32-.192.642-.217.974-.023.313-.023.689-.023 1.126v7.528Zm8.946.585c-.473.403-.646.901-.646 1.34 0 .87.705 1.575 1.575 1.575.439 0 .937-.173 1.34-.646.408-.479.785-1.349.785-2.854v-.2h-.2c-1.505 0-2.375.377-2.854.785ZM3.4 18.985c0-.439.173-.937.646-1.34.479-.408 1.349-.785 2.854-.785h.2v.2c0 1.505-.377 2.375-.785 2.854-.403.473-.901.646-1.34.646-.87 0-1.575-.705-1.575-1.575Z",
    fill: "#023F80"
  })));
};

var _path$4e;
function _extends$4h() { _extends$4h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4h.apply(this, arguments); }
var SvgMuteOutline = function SvgMuteOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4h({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4e || (_path$4e = /*#__PURE__*/createElement$2("path", {
    d: "M6.264 4.264a.9.9 0 0 1 1.272 0l12.2 12.2a.9.9 0 1 1-1.272 1.272L16 15.273v3.038c0 .995-.848 1.689-1.75 1.689-.762 0-1.505-.28-2.063-.798l-4.24-3.935H6.14c-1.118 0-2.14-.856-2.14-2.05v-2.433c0-1.195 1.022-2.05 2.14-2.05h1.807l.785-.73-2.468-2.468a.9.9 0 0 1 0-1.272Zm3.751 5.024c-.368.335-.74.668-1.103 1.005a.9.9 0 0 1-.612.24H6.14a.386.386 0 0 0-.265.097.208.208 0 0 0-.075.154v2.432c0 .047.019.101.075.154.058.054.15.097.265.097H8.3a.9.9 0 0 1 .612.24l4.5 4.175c.2.187.481.305.788.317v-4.726l-4.185-4.185ZM14.25 4c.902 0 1.75.694 1.75 1.689V8.01a.9.9 0 1 1-1.8 0V5.8a1.23 1.23 0 0 0-.789.316l-.13.122a.9.9 0 1 1-1.225-1.32l.13-.12A3.035 3.035 0 0 1 14.25 4Z",
    fill: "#023F80"
  })));
};

var _path$4f;
function _extends$4i() { _extends$4i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4i.apply(this, arguments); }
var SvgNameTagOutline = function SvgNameTagOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4i({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4f || (_path$4f = /*#__PURE__*/createElement$2("path", {
    d: "M10.41 5c1.333 0 1.333 2 0 2l-.558.005c-1.479.028-2.141.18-2.823.545-.64.342-1.137.839-1.48 1.48-.364.68-.516 1.343-.544 2.822L5 12.41v5.18c0 1.881.142 2.62.55 3.38.342.641.839 1.138 1.48 1.48.68.365 1.343.517 2.822.545l.558.005h7.18c1.881 0 2.62-.142 3.38-.55a3.544 3.544 0 0 0 1.48-1.48c.365-.68.517-1.343.545-2.822L23 17.59v-5.18l-.005-.558c-.028-1.479-.18-2.141-.545-2.823a3.544 3.544 0 0 0-1.48-1.48c-.68-.364-1.343-.516-2.822-.544L17.59 7l-.133-.007c-1.156-.124-1.156-1.862 0-1.986L17.59 5H18l.071.003.172.004c1.649.038 2.581.232 3.499.69l.172.089a5.543 5.543 0 0 1 2.3 2.3c.553 1.034.764 2.03.784 3.988l.002.336v5.18c0 2.183-.203 3.233-.786 4.324a5.543 5.543 0 0 1-2.3 2.3c-1.034.553-2.03.764-3.988.784L10.41 25c-2.183 0-3.233-.203-4.324-.786a5.543 5.543 0 0 1-2.3-2.3c-.553-1.034-.764-2.03-.784-3.988L3 12.41c0-2.183.203-3.233.786-4.324a5.543 5.543 0 0 1 2.3-2.3c.976-.522 1.92-.74 3.67-.779l.172-.004L10 5h.41ZM15 17a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h6Zm4-5a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h10Zm-5-9a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Z",
    fill: "#023F80"
  })));
};

var _path$4g;
function _extends$4j() { _extends$4j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4j.apply(this, arguments); }
var SvgNarrativeActiveOutline = function SvgNarrativeActiveOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4j({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4g || (_path$4g = /*#__PURE__*/createElement$2("path", {
    d: "M14.298 1.435c.732.17 1.377.543 1.891 1.092.521.556.825 1.145 1.151 2.298l.79 2.944a1 1 0 0 1-1.931.518l-.72-2.69-.113-.401c-.215-.729-.377-1.024-.636-1.302a1.726 1.726 0 0 0-.887-.512c-.37-.086-.707-.078-1.445.1l-.405.104L6.866 4.96c-.854.228-1.254.394-1.51.583l-.06.047-.134.119c-.26.243-.43.539-.512.886-.093.4-.076.763.148 1.638l2.723 10.17.113.401c.215.729.377 1.024.636 1.302.244.26.54.43.887.512.401.093.745.076 1.607-.14a1 1 0 0 1 .487 1.94c-1.148.288-1.805.32-2.549.147a3.726 3.726 0 0 1-1.891-1.092c-.521-.556-.825-1.145-1.151-2.298L2.922 8.963c-.355-1.324-.405-2.027-.22-2.823a3.722 3.722 0 0 1 .93-1.728l.183-.182.179-.157c.496-.412 1.077-.685 2.091-.973l.263-.072 5.128-1.374c1.323-.355 2.026-.405 2.822-.22ZM18.368 11c2 0 3.632 1.591 3.632 3.567 0 1.91-.772 2.851-3.78 5.134l-1.328 1.007c-.527.4-1.257.4-1.784 0l-1.328-1.007C10.772 17.418 10 16.476 10 14.567 10 12.591 11.631 11 13.632 11c.829 0 1.595.224 2.282.66l.086.057.086-.057a4.174 4.174 0 0 1 2.036-.653l.246-.007Z",
    fill: "#023F80"
  })));
};

var _path$4h;
function _extends$4k() { _extends$4k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4k.apply(this, arguments); }
var SvgNarrativeOutline = function SvgNarrativeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4k({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4h || (_path$4h = /*#__PURE__*/createElement$2("path", {
    d: "M14.3 1.106c.733.17 1.378.543 1.892 1.092.521.556.825 1.145 1.151 2.298l.791 2.944a1 1 0 0 1-1.932.518l-.72-2.689-.113-.402c-.215-.729-.376-1.024-.636-1.302a1.726 1.726 0 0 0-.887-.512c-.37-.086-.706-.078-1.445.1l-.405.104L6.87 4.63c-.854.228-1.254.394-1.509.583l-.06.047-.135.119c-.26.244-.43.539-.512.886-.093.4-.076.763.148 1.638l2.724 10.17.112.401c.215.729.377 1.024.637 1.302.244.26.539.43.886.512.401.093.745.076 1.607-.14a1 1 0 0 1 .488 1.94c-1.15.288-1.806.32-2.55.147a3.725 3.725 0 0 1-1.89-1.092c-.522-.556-.825-1.145-1.152-2.298L2.925 8.634C2.57 7.31 2.52 6.607 2.705 5.81a3.722 3.722 0 0 1 .93-1.728l.183-.182.18-.157c.495-.412 1.076-.685 2.09-.973l.263-.072 5.128-1.374C12.802.97 13.506.92 14.3 1.105Zm4.072 9.565c2 0 3.631 1.591 3.631 3.567 0 1.91-.771 2.851-3.78 5.134l-1.328 1.007c-.527.4-1.256.4-1.784 0l-1.328-1.007c-3.008-2.283-3.78-3.225-3.78-5.134 0-1.976 1.632-3.567 3.632-3.567.829 0 1.596.224 2.282.66l.086.057.086-.057a4.174 4.174 0 0 1 2.036-.653l.247-.007Zm0 2c-.63 0-1.17.228-1.67.716l-.35.34a.5.5 0 0 1-.698 0l-.349-.34c-.5-.488-1.04-.716-1.67-.716-.907 0-1.632.707-1.632 1.567 0 .993.401 1.546 2.525 3.186l1.474 1.122 1.012-.767c2.45-1.859 2.957-2.442 2.988-3.44l.001-.1c0-.86-.725-1.568-1.631-1.568Z",
    fill: "#023F80"
  })));
};

var _path$4i;
function _extends$4l() { _extends$4l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4l.apply(this, arguments); }
var SvgNewsfeedOutline = function SvgNewsfeedOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4l({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4i || (_path$4i = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.228 3.1c-1.57 0-2.32.127-3.082.534a3.647 3.647 0 0 0-1.512 1.512c-.407.762-.534 1.512-.534 3.082v7.544c0 1.57.127 2.32.534 3.082.348.65.863 1.164 1.512 1.512.762.407 1.512.534 3.082.534h7.544c1.57 0 2.32-.127 3.082-.534a3.647 3.647 0 0 0 1.512-1.512c.407-.762.534-1.512.534-3.082V8.228c0-1.57-.127-2.32-.534-3.082a3.647 3.647 0 0 0-1.512-1.512c-.762-.407-1.512-.534-3.082-.534H8.228ZM5.995 5.221c.362-.193.746-.321 2.233-.321h7.544c1.487 0 1.87.128 2.233.321.336.18.594.438.773.774.188.352.314.724.322 2.105H4.9c.008-1.381.134-1.753.321-2.105.18-.336.438-.594.774-.774ZM4.9 9.9v5.872c0 1.487.128 1.87.321 2.233.18.336.438.594.774.773.362.194.746.322 2.233.322h7.544c1.487 0 1.87-.128 2.233-.322.336-.18.594-.437.773-.773.194-.362.322-.746.322-2.233V9.9H4.9Z",
    fill: "#023F80"
  })));
};

var _path$4j, _path2$1j;
function _extends$4m() { _extends$4m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4m.apply(this, arguments); }
var SvgNoSmokingSignOutline = function SvgNoSmokingSignOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4m({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4j || (_path$4j = /*#__PURE__*/createElement$2("path", {
    d: "M18 13a1 1 0 1 0 0 2h1.5a1 1 0 1 0 0-2H18Z",
    fill: "#023F80"
  })), _path2$1j || (_path2$1j = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14C2 7.373 7.373 2 14 2s12 5.373 12 12-5.373 12-12 12S2 20.627 2 14Zm3.929-5.905A9.955 9.955 0 0 0 4 14c0 5.523 4.477 10 10 10 2.209 0 4.25-.716 5.905-1.929L12.833 15H8.5a1 1 0 1 1 0-2h2.333L5.93 8.095Zm1.338-1.49 14.127 14.128A9.964 9.964 0 0 0 24 14c0-5.523-4.477-10-10-10a9.964 9.964 0 0 0-6.732 2.606Z",
    fill: "#023F80"
  })));
};

var _path$4k, _path2$1k, _path3$r;
function _extends$4n() { _extends$4n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4n.apply(this, arguments); }
var SvgNotebookAddBadgeOutline = function SvgNotebookAddBadgeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4n({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4k || (_path$4k = /*#__PURE__*/createElement$2("path", {
    d: "M8 1.5a1 1 0 0 1 1 1v.505C9.411 3 9.862 3 10.357 3H12v-.5a1 1 0 1 1 2 0V3h1.643c.494 0 .945 0 1.357.005V2.5a1 1 0 1 1 2 0v.642c.453.077.872.2 1.27.403a5 5 0 0 1 2.185 2.185c.302.592.428 1.233.487 1.961C23 8.4 23 9.273 23 10.357v1.893a1 1 0 0 1-2 0V10.4c0-1.137 0-1.929-.051-2.546-.05-.605-.142-.953-.276-1.216a3 3 0 0 0-1.311-1.311 1.964 1.964 0 0 0-.362-.14V5.5a1 1 0 1 1-2 0v-.494A106.8 106.8 0 0 0 15.6 5H14v.5a1 1 0 1 1-2 0V5h-1.6c-.538 0-.998 0-1.4.006V5.5a1 1 0 1 1-2 0v-.312c-.14.04-.258.086-.362.139a3 3 0 0 0-1.311 1.311c-.134.263-.226.611-.276 1.216C5.001 8.471 5 9.264 5 10.4v7.2c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051h1.1a1 1 0 1 1 0 2h-1.142c-1.084 0-1.959 0-2.666-.058-.73-.06-1.37-.185-1.962-.487a5 5 0 0 1-2.185-2.185c-.302-.592-.428-1.232-.487-1.961C3 19.6 3 18.727 3 17.643v-7.286c0-1.084 0-1.958.058-2.666.06-.728.185-1.369.487-1.96A5 5 0 0 1 5.73 3.544 4.366 4.366 0 0 1 7 3.142V2.5a1 1 0 0 1 1-1Z",
    fill: "#023F80"
  })), _path2$1k || (_path2$1k = /*#__PURE__*/createElement$2("path", {
    d: "M17.907 11.707a1 1 0 0 0-1.414-1.414l-4.9 4.9L9.7 13.34a1 1 0 1 0-1.4 1.43l2.6 2.545a1 1 0 0 0 1.407-.008l5.6-5.6Z",
    fill: "#023F80"
  })), _path3$r || (_path3$r = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 27a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm1-9a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z",
    fill: "#023F80"
  })));
};

var _path$4l;
function _extends$4o() { _extends$4o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4o.apply(this, arguments); }
var SvgNotebookCheckOutline = function SvgNotebookCheckOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4o({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4l || (_path$4l = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.75a.9.9 0 0 1 .9.9v.577c.478.075.914.198 1.324.407a4.9 4.9 0 0 1 2.142 2.141c.293.576.417 1.202.476 1.924.058.704.058 1.575.058 2.662v4.278c0 1.087 0 1.958-.058 2.662-.059.722-.183 1.348-.476 1.924a4.9 4.9 0 0 1-2.142 2.14c-.576.294-1.201.418-1.924.478-.704.057-1.574.057-2.661.057H10.36c-1.087 0-1.958 0-2.662-.057-.723-.06-1.348-.184-1.924-.477a4.9 4.9 0 0 1-2.141-2.142c-.294-.575-.418-1.2-.477-1.924-.057-.703-.057-1.574-.057-2.661V10.36c0-1.087 0-1.958.057-2.662.06-.722.183-1.348.477-1.924a4.9 4.9 0 0 1 2.141-2.141c.41-.21.846-.332 1.325-.407V2.65a.9.9 0 1 1 1.8 0v.457c.438-.007.923-.007 1.46-.007h.74v-.45a.9.9 0 0 1 1.8 0v.45h.739c.538 0 1.023 0 1.46.007V2.65a.9.9 0 0 1 .9-.9ZM6.592 5.238a2.2 2.2 0 0 1 .508-.18v.292a.9.9 0 1 0 1.8 0v-.443a96.13 96.13 0 0 1 1.5-.007h.7v.45a.9.9 0 0 0 1.8 0V4.9h.7c.581 0 1.074 0 1.5.007v.443a.9.9 0 0 0 1.8 0v-.291a2.2 2.2 0 0 1 .507.179 3.1 3.1 0 0 1 1.355 1.355c.142.28.236.642.286 1.253.05.622.052 1.419.052 2.554v4.2c0 1.135-.001 1.932-.052 2.554-.05.611-.144.974-.286 1.253a3.1 3.1 0 0 1-1.355 1.355c-.28.143-.642.236-1.253.287-.622.05-1.42.051-2.554.051h-3.2c-1.135 0-1.932 0-2.554-.052-.612-.05-.974-.143-1.254-.286a3.1 3.1 0 0 1-1.355-1.355c-.142-.28-.236-.642-.286-1.253-.05-.622-.051-1.42-.051-2.554v-4.2c0-1.135 0-1.932.051-2.554.05-.611.144-.974.286-1.253a3.1 3.1 0 0 1 1.355-1.355Zm9.794 5.648a.9.9 0 1 0-1.273-1.272L11 13.727l-1.864-1.863a.9.9 0 1 0-1.273 1.272l2.5 2.5a.9.9 0 0 0 1.273 0l4.75-4.75Z",
    fill: "#023F80"
  })));
};

var _path$4m;
function _extends$4p() { _extends$4p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4p.apply(this, arguments); }
var SvgNotificationAddOutline = function SvgNotificationAddOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4p({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4m || (_path$4m = /*#__PURE__*/createElement$2("path", {
    d: "M13.955 3.35c.78 0 1.542.116 2.27.341a.9.9 0 1 1-.533 1.72 5.85 5.85 0 0 0-1.737-.261c-3.348 0-5.988 2.76-6.101 6.433l-.004.246v1.828c0 .52-.148.995-.412 1.462a6.25 6.25 0 0 1-.612.869l-.232.277-.36.418-.251.304-.2.258c-.354.479-.433.739-.433 1.093l.004.202c.008.135.028.2.073.298.133.283.5.484 1.337.51l.186.002h14c.937 0 1.356-.21 1.512-.515.072-.142.088-.222.088-.497 0-.384-.093-.657-.527-1.216l-.226-.28-.28-.33a.9.9 0 0 1 1.362-1.177c1.13 1.308 1.471 1.98 1.471 3.003 0 .54-.072.895-.284 1.312-.466.918-1.437 1.44-2.86 1.495l-.256.005h-2.677l-.02.072c-.328 1.113-.863 1.97-1.587 2.55-.726.58-1.639.878-2.716.878-1.077 0-1.99-.298-2.716-.879-.663-.53-1.168-1.295-1.5-2.276l-.109-.345H6.95c-1.612 0-2.68-.544-3.151-1.546-.188-.4-.249-.73-.249-1.266 0-.966.303-1.619 1.288-2.79l.451-.528c.277-.326.463-.577.582-.787.097-.173.154-.325.172-.469l.007-.107V11.83c0-4.762 3.459-8.479 7.905-8.479Zm2.421 17.802h-4.852c.217.547.5.947.835 1.214.395.316.91.484 1.591.484.682 0 1.196-.168 1.592-.484.334-.268.617-.668.834-1.214ZM19.95 4.75a1 1 0 0 1 .993.883l.007.117v2.5h2.5a1 1 0 0 1 .117 1.993l-.117.007h-2.5v2.5a1 1 0 0 1-1.993.117l-.007-.117v-2.5h-2.5a1 1 0 0 1-.117-1.993l.117-.007h2.5v-2.5a1 1 0 0 1 1-1Z",
    fill: "#023F80"
  })));
};

var _path$4n;
function _extends$4q() { _extends$4q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4q.apply(this, arguments); }
var SvgNotificationCheckOutline = function SvgNotificationCheckOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4n || (_path$4n = /*#__PURE__*/createElement$2("path", {
    d: "M12.004 2.1c.675 0 1.326.092 1.944.273a.9.9 0 0 1-.506 1.728 5.097 5.097 0 0 0-1.438-.201c-2.895 0-5 2.31-5.1 5.491l-.004.24v1.6c0 .792-.336 1.375-1.055 2.147l-.727.75c-.535.572-.718.884-.718 1.2 0 .191.014.291.057.381.1.208.387.367 1.106.389l.174.002h12.526c.82 0 1.153-.169 1.272-.397.05-.095.065-.197.065-.376 0-.315-.183-.627-.718-1.198l-.554-.57-.258-.273a6.752 6.752 0 0 1-.216-.249.9.9 0 1 1 1.389-1.145c.074.09.159.185.265.297l.383.393c1.081 1.097 1.509 1.729 1.509 2.745 0 .445-.052.791-.268 1.206-.43.826-1.311 1.308-2.619 1.362l-.25.005h-1.886a1.013 1.013 0 0 1-.006.026C15.754 20.306 14.245 21.6 12 21.6c-2.245 0-3.754-1.294-4.371-3.674l-.006-.026H5.737c-1.488 0-2.466-.502-2.902-1.41-.191-.398-.235-.72-.235-1.163 0-.953.376-1.568 1.314-2.544l.465-.476.237-.253c.315-.35.455-.582.48-.764l.004-.059v-1.6C5.1 5.38 7.988 2.1 12.004 2.1Zm2.498 15.8H9.498c.45 1.319 1.245 1.9 2.502 1.9 1.257 0 2.052-.582 2.502-1.9Zm4.962-13.636a.9.9 0 0 1 1.272 1.272l-4.2 4.2a.9.9 0 0 1-1.272 0l-2-2a.9.9 0 1 1 1.272-1.272L15.9 7.827l3.564-3.563Z",
    fill: "#023F80"
  })));
};

var _path$4o;
function _extends$4r() { _extends$4r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4r.apply(this, arguments); }
var SvgNotificationDisableOutline = function SvgNotificationDisableOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4r({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4o || (_path$4o = /*#__PURE__*/createElement$2("path", {
    d: "M4.293 4.293a1 1 0 0 1 1.414 0l18.385 18.385a1 1 0 0 1-1.414 1.414l-2.596-2.595A1.007 1.007 0 0 1 20 21.5h-1.601C17.73 23.766 16.212 25 14 25s-3.731-1.235-4.399-3.5H7c-1.665 0-2.758-.574-3.242-1.604-.21-.446-.258-.809-.258-1.308 0-1.113.425-1.83 1.493-3.068.139-.16.203-.235.27-.314.539-.635.737-.99.737-1.299V12.08c0-1.36.283-2.67.818-3.845L4.293 5.707a1 1 0 0 1 0-1.414ZM16.279 21.5h-4.558C12.17 22.543 12.899 23 14 23s1.829-.457 2.28-1.5ZM14.005 3.5C18.535 3.5 22 7.294 22 12.082l-.005 1.825c0 .308.199.663.738 1.298l.271.315c.804.93 1.163 1.45 1.376 2.207.079.282.12.569.12.861a1 1 0 1 1-2 0c0-.106-.015-.21-.046-.32-.106-.378-.35-.731-.963-1.44l-.282-.328c-.828-.976-1.214-1.665-1.214-2.595L20 12.079C20 8.36 17.389 5.5 14.005 5.5a5.683 5.683 0 0 0-2.92.79 1 1 0 0 1-1.019-1.72 7.683 7.683 0 0 1 3.939-1.07Zm4.081 16L8.361 9.776C8.124 10.499 8 11.275 8 12.079v1.828c0 .928-.384 1.617-1.212 2.592l-.28.328c-.76.88-1.008 1.298-1.008 1.761 0 .226.016.347.068.457.124.264.488.455 1.432.455h11.086Z",
    fill: "#023F80"
  })));
};

var _path$4p;
function _extends$4s() { _extends$4s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4s.apply(this, arguments); }
var SvgNotificationOutline = function SvgNotificationOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4s({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4p || (_path$4p = /*#__PURE__*/createElement$2("path", {
    d: "M12.004 2.1c4.015 0 6.896 3.278 6.896 7.532v1.6c0 .228.193.531.72 1.075l.27.275c1.082 1.097 1.51 1.729 1.51 2.745 0 .445-.052.791-.268 1.206-.456.878-1.423 1.367-2.869 1.367l-1.912.001c-.629 2.332-2.13 3.6-4.351 3.6-2.245 0-3.754-1.295-4.371-3.675l.019.074H5.737c-1.488 0-2.466-.502-2.902-1.41-.191-.398-.235-.72-.235-1.163 0-1.016.428-1.648 1.51-2.745l.27-.275c.527-.544.72-.847.72-1.076v-1.6C5.1 5.38 7.988 2.1 12.004 2.1Zm2.462 15.802H9.534C9.99 19.148 10.776 19.7 12 19.7c1.224 0 2.01-.552 2.466-1.798ZM12.004 3.9C9.036 3.9 6.9 6.327 6.9 9.632v1.6c0 .852-.39 1.463-1.228 2.328-.073.075-.142.146-.281.286-.747.758-.991 1.118-.991 1.481 0 .192.014.292.057.382.107.224.433.391 1.28.391h12.526c.82 0 1.153-.169 1.272-.397.05-.095.065-.197.065-.376 0-.363-.244-.723-.99-1.48-.14-.141-.209-.212-.282-.287-.839-.865-1.228-1.476-1.228-2.329v-1.6c0-3.307-2.13-5.731-5.096-5.731Z",
    fill: "#023F80"
  })));
};

var _path$4q;
function _extends$4t() { _extends$4t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4t.apply(this, arguments); }
var SvgNotificationSlashOutline = function SvgNotificationSlashOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4t({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4q || (_path$4q = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.004 2.1c4.163 0 6.896 3.446 6.896 7.532v1.6c0 .249.146.537.578.99.474.498 1.016.935 1.402 1.51.317.474.532 1.043.52 1.689a.9.9 0 0 1-1.8-.037c.016-.815-.931-1.402-1.425-1.92-.474-.497-1.075-1.234-1.075-2.233v-1.6c0-3.311-2.134-5.731-5.096-5.731-1.008 0-1.884.269-2.623.735a.9.9 0 0 1-.961-1.521A6.666 6.666 0 0 1 12.004 2.1ZM16.351 17.901c-.629 2.332-2.13 3.6-4.351 3.6S8.277 20.232 7.648 17.9H5.737c-1.488 0-2.466-.502-2.902-1.41-.191-.398-.235-.72-.235-1.163 0-1.293.942-2.156 1.78-3.02.527-.544.72-.847.72-1.076 0-1.493-.038-2.969.455-4.403L3.264 4.536a.9.9 0 1 1 1.272-1.272l16.2 16.2a.9.9 0 0 1-1.272 1.272l-2.836-2.835h-.277Zm-6.817 0h4.932c-.456 1.247-1.242 1.8-2.466 1.8-1.224 0-2.01-.553-2.466-1.8ZM6.9 11.232c0-.976-.06-1.971.123-2.935l7.804 7.804h-9.09c-.847 0-1.173-.167-1.28-.39-.335-.698.52-1.445.934-1.864.722-.731 1.509-1.517 1.509-2.615Z",
    fill: "#023F80"
  })));
};

var _path$4r;
function _extends$4u() { _extends$4u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4u.apply(this, arguments); }
var SvgNotificationSubtractOutline = function SvgNotificationSubtractOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4u({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4r || (_path$4r = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.303 4.186a.9.9 0 0 0-.606-1.695C6.825 3.517 5.1 6.38 5.1 9.63v1.6c0 .103-.041.256-.22.503-.18.249-.426.499-.742.82l-.029.028c-.305.31-.676.688-.964 1.113-.295.436-.545.98-.545 1.632v.02c0 .228-.002.906.464 1.517.511.67 1.393 1.036 2.673 1.036h1.911c.293 1.085.783 1.993 1.53 2.633.775.665 1.74.967 2.822.967 1.081 0 2.047-.302 2.822-.967.747-.64 1.237-1.548 1.53-2.633h1.911c1.293 0 2.172-.387 2.678-1.062.46-.614.46-1.287.459-1.496v-.015c0-.74-.322-1.34-.668-1.804-.275-.368-.622-.72-.91-1.012h-.001l-.176-.179a.9.9 0 1 0-1.29 1.256l.221.225c.284.287.52.528.714.787.23.308.31.533.31.727 0 .17-.013.316-.1.432-.053.071-.293.341-1.237.341H5.737c-.957 0-1.194-.265-1.242-.328-.08-.104-.095-.24-.095-.445 0-.171.062-.366.236-.623.18-.267.435-.534.755-.858l.063-.064c.283-.287.621-.629.885-.994.29-.401.561-.923.561-1.557v-1.6c0-2.639 1.379-4.722 3.403-5.445ZM14.466 17.9H9.534c.218.59.5.996.816 1.267.391.335.917.533 1.65.533.733 0 1.259-.198 1.65-.533.317-.271.598-.678.816-1.267Z",
    fill: "#023F80"
  })));
};

var _path$4s;
function _extends$4v() { _extends$4v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4v.apply(this, arguments); }
var SvgOnOffOutline = function SvgOnOffOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4v({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4s || (_path$4s = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2a1 1 0 1 0-2 0v11a1 1 0 1 0 2 0V2ZM9.834 4.909A1 1 0 1 0 9 3.09c-4.13 1.895-7 6.066-7 10.91C2 20.628 7.373 26 14 26s12-5.372 12-11.999c0-4.844-2.87-9.015-7-10.91a1 1 0 0 0-.834 1.818A10 10 0 0 1 24 14C24 19.523 19.523 24 14 24S4 19.523 4 14.001A10 10 0 0 1 9.834 4.91Z",
    fill: "#023F80"
  })));
};

var _path$4t;
function _extends$4w() { _extends$4w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4w.apply(this, arguments); }
var SvgPaintRollerOutline = function SvgPaintRollerOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4w({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4t || (_path$4t = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.367 2.1h7.266c.392 0 .738 0 1.026.023.305.025.622.081.93.239a2.4 2.4 0 0 1 1.05 1.048c.157.309.213.626.238.932.006.082.011.17.015.261.354.009.666.036.95.122a2.9 2.9 0 0 1 1.933 1.933c.126.416.126.894.125 1.472v.24c0 .578.001 1.056-.125 1.472a2.9 2.9 0 0 1-1.933 1.933c-.415.126-.894.126-1.472.125h-4.156c-.726 0-.9.009-1.018.043a1.1 1.1 0 0 0-.753.752c-.021.074-.033.17-.038.406.067.001.134.004.197.009.139.011.332.04.534.143a1.4 1.4 0 0 1 .612.611c.102.202.13.395.142.534.01.121.01.26.01.38v5.444c0 .12 0 .259-.01.38-.011.139-.04.332-.143.534a1.4 1.4 0 0 1-.611.611 1.409 1.409 0 0 1-.534.143c-.121.01-.26.01-.38.01H9.778c-.12 0-.259 0-.38-.01a1.408 1.408 0 0 1-.533-.143 1.4 1.4 0 0 1-.612-.611 1.408 1.408 0 0 1-.143-.534c-.01-.121-.01-.26-.01-.38v-5.444c0-.12 0-.259.01-.38.011-.139.04-.332.143-.534a1.4 1.4 0 0 1 .612-.611c.201-.103.394-.132.533-.143.066-.005.136-.008.205-.01.008-.335.033-.633.11-.903a2.9 2.9 0 0 1 1.984-1.984c.397-.114.853-.114 1.403-.113H17.25c.763 0 .945-.01 1.07-.047a1.1 1.1 0 0 0 .733-.734c.037-.124.047-.306.047-1.069 0-.763-.01-.945-.047-1.07a1.1 1.1 0 0 0-.734-.733c-.077-.023-.177-.036-.428-.042a5.952 5.952 0 0 1-.014.253c-.025.306-.081.623-.238.932a2.4 2.4 0 0 1-1.05 1.048 2.439 2.439 0 0 1-.93.239c-.288.023-.634.023-1.026.023H7.367c-.392 0-.738 0-1.025-.023-.306-.025-.623-.081-.931-.239A2.4 2.4 0 0 1 4.36 7.59c-.156-.309-.212-.626-.237-.932C4.1 6.371 4.1 6.025 4.1 5.633v-.266c0-.392 0-.738.024-1.025.025-.306.08-.623.238-.932A2.4 2.4 0 0 1 5.41 2.362c.308-.158.625-.214.93-.239.288-.023.634-.023 1.026-.023ZM9.9 14.9v5.2h1.2v-5.2H9.9ZM6.488 3.917c-.194.016-.248.042-.26.048a.6.6 0 0 0-.263.263c-.006.012-.032.066-.047.26A12.65 12.65 0 0 0 5.9 5.4v.2c0 .435 0 .707.018.912.015.194.041.248.047.26a.6.6 0 0 0 .263.263c.012.006.066.032.26.048.205.016.477.017.912.017h7.2c.435 0 .707 0 .912-.017.194-.016.248-.042.26-.048a.6.6 0 0 0 .263-.263c.006-.012.032-.066.048-.26.016-.205.017-.477.017-.912v-.2c0-.435 0-.707-.017-.912-.016-.194-.042-.248-.048-.26a.6.6 0 0 0-.262-.263c-.013-.006-.066-.032-.261-.048A12.65 12.65 0 0 0 14.6 3.9H7.4c-.435 0-.707 0-.912.017Z",
    fill: "#023F80"
  })));
};

var _path$4u, _path2$1l;
function _extends$4x() { _extends$4x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4x.apply(this, arguments); }
var SvgPaletteOutline = function SvgPaletteOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4x({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4u || (_path$4u = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5a9.872 9.872 0 0 1 7-2.9c2.734 0 5.21 1.11 7 2.9a9.872 9.872 0 0 1 2.9 7c0 1.933-.61 3.282-1.77 4.041-1.073.702-2.416.763-3.654.631-.444-.047-.888-.096-1.332-.142-.657-.045-.948.14-1.063.28-.116.14-.244.46-.077 1.096.052.197.109.378.172.58.034.106.069.217.105.339a2.384 2.384 0 0 1-2.28 3.075A9.872 9.872 0 0 1 5 19a9.872 9.872 0 0 1-2.9-7c0-2.734 1.11-5.21 2.9-7Zm7-1.1c-2.237 0-4.26.906-5.727 2.372A8.072 8.072 0 0 0 3.9 12c0 2.237.906 4.26 2.373 5.727A8.072 8.072 0 0 0 12 20.1a.584.584 0 0 0 .559-.753 25.023 25.023 0 0 0-.083-.267c-.071-.225-.15-.478-.213-.717-.256-.976-.18-1.964.431-2.701.61-.738 1.567-.997 2.573-.928.056.004.462.048 1.199.127l.204.022c1.074.115 1.918.016 2.474-.348.486-.318.956-.98.956-2.535 0-2.237-.905-4.26-2.372-5.728A8.072 8.072 0 0 0 12 3.9Z",
    fill: "#023F80"
  })), _path2$1l || (_path2$1l = /*#__PURE__*/createElement$2("path", {
    d: "M13 7.4a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0ZM15.75 11.4a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0ZM5.45 11.4a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0ZM8 7.4a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0Z",
    fill: "#023F80"
  })));
};

var _rect$2;
function _extends$4y() { _extends$4y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4y.apply(this, arguments); }
var SvgParcialOutline = function SvgParcialOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4y({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$2 || (_rect$2 = /*#__PURE__*/createElement$2("rect", {
    x: 3,
    y: 11,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#023F80"
  })));
};

var _path$4v;
function _extends$4z() { _extends$4z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4z.apply(this, arguments); }
var SvgPawOutline = function SvgPawOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4z({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4v || (_path$4v = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.929 3.848c.568.571.975 1.377 1.14 2.275.166.898.073 1.794-.26 2.525-.333.728-.95 1.37-1.84 1.521-.885.15-1.684-.25-2.248-.817-.568-.571-.976-1.377-1.141-2.275-.166-.898-.072-1.793.261-2.525.332-.728.95-1.37 1.84-1.52.885-.15 1.684.248 2.248.816ZM8.652 5.117c-.288-.29-.53-.335-.672-.311-.137.023-.339.138-.501.493-.16.353-.237.868-.129 1.451.108.584.364 1.048.647 1.333.288.29.53.335.673.311.137-.023.339-.138.5-.493.162-.353.237-.868.13-1.451-.108-.584-.364-1.048-.648-1.333Zm6.696 0c-.284.285-.54.75-.648 1.333-.108.583-.032 1.098.129 1.45.162.356.364.47.501.494.142.024.384-.021.672-.31.284-.286.54-.75.648-1.334.107-.583.032-1.098-.13-1.45-.161-.356-.363-.47-.5-.494-.143-.024-.385.021-.672.31Zm-1.277-1.27c.564-.567 1.363-.965 2.248-.816.89.15 1.507.793 1.84 1.521.333.732.426 1.627.26 2.525-.165.898-.572 1.704-1.14 2.275-.564.568-1.363.966-2.248.817-.89-.15-1.508-.793-1.84-1.521-.333-.731-.427-1.627-.261-2.525.165-.898.573-1.704 1.141-2.275Zm-9.08 5.689c.657.415 1.217 1.093 1.582 1.906.366.815.502 1.688.388 2.462-.112.76-.495 1.554-1.29 1.94-.805.39-1.66.182-2.312-.23-.657-.415-1.217-1.092-1.583-1.906-.365-.815-.5-1.688-.387-2.462.112-.76.495-1.554 1.29-1.94.805-.39 1.66-.182 2.312.23Zm-.962 1.521c-.318-.201-.499-.162-.565-.13-.076.037-.235.176-.294.581-.058.392.005.92.249 1.463s.589.924.902 1.122c.318.201.498.162.565.13.076-.037.234-.176.294-.581.058-.392-.005-.92-.249-1.463s-.589-.924-.902-1.122Zm15.942 0c-.313.198-.658.579-.902 1.122-.244.543-.307 1.07-.25 1.463.06.405.219.545.295.581.066.032.247.071.565-.13.313-.198.658-.579.902-1.122.244-.543.307-1.07.249-1.463-.06-.405-.218-.544-.294-.581-.067-.032-.247-.071-.566.13Zm-.962-1.521c.651-.412 1.507-.62 2.312-.23.794.386 1.178 1.18 1.29 1.94.114.774-.022 1.647-.388 2.462-.365.814-.925 1.491-1.582 1.906-.652.412-1.507.62-2.312.23-.795-.386-1.178-1.18-1.29-1.94-.114-.774.022-1.647.387-2.462.366-.813.926-1.491 1.583-1.906Zm-9.716 2.94c.612-.78 1.46-1.376 2.707-1.376 1.248 0 2.095.597 2.707 1.377.457.58.826 1.326 1.16 2 .075.152.148.301.22.443.3.587.586 1.046.856 1.476.1.16.197.316.292.473.319.529.665 1.157.665 1.885 0 .583-.14 1.096-.429 1.518-.287.42-.674.68-1.053.84-.69.29-1.47.289-1.876.288H14.5c-.462 0-.807-.063-1.107-.118A6.594 6.594 0 0 0 12 21.15a6.594 6.594 0 0 0-1.393.132c-.3.055-.645.118-1.107.118h-.043c-.406 0-1.186.001-1.875-.289-.38-.16-.766-.42-1.054-.84-.288-.421-.428-.934-.428-1.517 0-.728.346-1.356.665-1.885.095-.157.192-.313.292-.473a18.217 18.217 0 0 0 1.077-1.92c.333-.673.702-1.418 1.159-2Zm.495 2.719a65.69 65.69 0 0 1-.272.542c-.338.664-.688 1.223-.965 1.666-.09.145-.173.277-.245.396-.324.537-.406.779-.406.955 0 .29.067.432.114.501a.572.572 0 0 0 .266.197c.324.136.762.148 1.22.148.291 0 .483-.035.782-.089l.122-.022A8.382 8.382 0 0 1 12 19.35c.742 0 1.21.07 1.596.139l.121.022c.3.054.492.089.783.089.457 0 .896-.012 1.22-.148a.571.571 0 0 0 .266-.197c.047-.069.114-.21.114-.501 0-.176-.083-.418-.406-.955-.072-.12-.155-.251-.245-.396-.278-.443-.628-1.002-.966-1.666a66.03 66.03 0 0 1-.271-.542c-.327-.657-.59-1.186-.92-1.606-.364-.464-.731-.689-1.292-.689-.56 0-.928.225-1.292.689-.33.42-.593.95-.92 1.606Z",
    fill: "#023F80"
  })));
};

var _path$4w, _path2$1m;
function _extends$4A() { _extends$4A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4A.apply(this, arguments); }
var SvgPaymentCardOutline = function SvgPaymentCardOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4A({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4w || (_path$4w = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.795 4.1c1.152 0 1.74.113 2.35.44.565.302 1.013.75 1.315 1.314.302.565.421 1.108.438 2.095l.002.256v7.59l-.002.256c-.017.987-.136 1.53-.438 2.095a3.172 3.172 0 0 1-1.314 1.314l-.141.071c-.564.272-1.146.369-2.21.369H6.205c-1.063 0-1.646-.097-2.21-.369l-.14-.071a3.172 3.172 0 0 1-1.315-1.315c-.301-.564-.421-1.107-.438-2.094l-.002-.256v-7.59c0-1.152.113-1.74.44-2.35A3.171 3.171 0 0 1 3.855 4.54c.564-.301 1.108-.421 2.094-.438l.256-.002h11.59ZM20.1 9.9l.001 5.895c0 .88-.06 1.187-.228 1.502-.134.25-.325.441-.575.575-.29.156-.574.218-1.309.227l-.193.001H6.205l-.193-.001c-.734-.009-1.018-.071-1.309-.227a1.372 1.372 0 0 1-.575-.575c-.169-.315-.228-.622-.228-1.502V9.9h16.2Zm-13.894-4h11.59l.193.001c.735.009 1.018.071 1.309.227.25.134.441.325.575.575.156.29.218.574.227 1.309V8.1H3.9l.001-.088c.009-.735.071-1.018.227-1.309.134-.25.325-.441.575-.575.315-.169.622-.228 1.502-.228Z",
    fill: "#023F80"
  })), _path2$1m || (_path2$1m = /*#__PURE__*/createElement$2("path", {
    d: "M6 14.8c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.218C6.38 14 6.52 14 6.8 14h.4c.28 0 .42 0 .527.055a.5.5 0 0 1 .219.218C8 14.38 8 14.52 8 14.8v.4c0 .28 0 .42-.054.527a.5.5 0 0 1-.219.218C7.62 16 7.48 16 7.2 16h-.4c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C6 15.62 6 15.48 6 15.2v-.4Z",
    fill: "#023F80"
  })));
};

var _path$4x, _path2$1n;
function _extends$4B() { _extends$4B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4B.apply(this, arguments); }
var SvgPaymentCardVerticalOutline = function SvgPaymentCardVerticalOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4B({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4x || (_path$4x = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1 6.205c0-1.152.114-1.74.44-2.35A3.171 3.171 0 0 1 5.855 2.54c.564-.301 1.108-.421 2.094-.438l.256-.002h7.59l.256.002c.987.017 1.53.137 2.095.438.564.302 1.012.75 1.314 1.314l.072.141c.271.564.368 1.147.368 2.21v11.59c0 1.063-.096 1.646-.368 2.21l-.072.14a3.172 3.172 0 0 1-1.314 1.315c-.565.301-1.108.421-2.095.438l-.256.002h-7.59c-1.152 0-1.74-.113-2.35-.44a3.172 3.172 0 0 1-1.315-1.315c-.301-.564-.421-1.107-.438-2.094l-.002-.256V6.205ZM9.9 3.9l5.895-.001c.88 0 1.187.06 1.502.228.25.134.441.325.575.575.156.291.218.574.227 1.309l.001.193v11.59l-.001.193c-.009.735-.071 1.018-.227 1.309-.134.25-.325.441-.575.575-.315.169-.622.228-1.502.228l-5.895.001v-16.2Zm-4 13.894V6.205l.001-.193c.009-.735.071-1.018.227-1.309.134-.25.325-.441.575-.575.291-.156.575-.218 1.309-.227l.088.001V20.1l-.088-.001c-.734-.009-1.018-.071-1.309-.227a1.372 1.372 0 0 1-.575-.575c-.169-.315-.228-.622-.228-1.502Z",
    fill: "#023F80"
  })), _path2$1n || (_path2$1n = /*#__PURE__*/createElement$2("path", {
    d: "M14.8 18c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C14 17.62 14 17.48 14 17.2v-.4c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.218C14.38 16 14.52 16 14.8 16h.4c.28 0 .42 0 .527.055a.5.5 0 0 1 .219.218c.054.107.054.247.054.527v.4c0 .28 0 .42-.054.527a.5.5 0 0 1-.219.218C15.62 18 15.48 18 15.2 18h-.4Z",
    fill: "#023F80"
  })));
};

var _path$4y;
function _extends$4C() { _extends$4C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4C.apply(this, arguments); }
var SvgPaymentDivider = function SvgPaymentDivider(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4C({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4y || (_path$4y = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.414 8.678v3.343c0 .947-.768 1.714-1.715 1.714H5.285a1.714 1.714 0 0 1-1.714-1.714V8.678h10.843Zm0-1.714a1.714 1.714 0 0 0-1.715-1.68H5.285c-.935 0-1.696.75-1.714 1.68h10.842ZM12.698 3.57a3.429 3.429 0 0 1 3.429 3.428v2.439h1.81a3.429 3.429 0 0 1 3.429 3.428v5.226a3.429 3.429 0 0 1-3.429 3.43h-7.494a3.429 3.429 0 0 1-3.428-3.43V15.45H5.285a3.429 3.429 0 0 1-3.429-3.428V6.998A3.429 3.429 0 0 1 5.285 3.57h7.414ZM8.73 15.45v2.642c0 .946.768 1.714 1.714 1.714h7.494c.947 0 1.715-.768 1.715-1.715v-3.508h-4.675a3.416 3.416 0 0 1-2.279.866H8.73Zm10.923-2.585v.003h-3.63c.068-.27.105-.555.105-.847v-.87h1.81c.947 0 1.715.767 1.715 1.714Zm-8.081 3.565c.237 0 .428.191.428.428v.773a.429.429 0 0 1-.428.428h-.773a.429.429 0 0 1-.429-.428v-.773c0-.237.192-.428.429-.428h.773Zm-4.678-5.492a.429.429 0 0 0-.428-.429h-.773a.429.429 0 0 0-.429.429v.772c0 .237.192.429.429.429h.773a.429.429 0 0 0 .428-.429v-.772Z",
    fill: "#003980"
  })));
};

var _path$4z;
function _extends$4D() { _extends$4D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4D.apply(this, arguments); }
var SvgPaymentHandOutline = function SvgPaymentHandOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4D({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4z || (_path$4z = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.305 8.412a8.293 8.293 0 0 0 .061 1.551h-.18c-.436 0-.729.273-.729.68 0 .377.237.662.602.715l.126.009h.498c.162.501.37.981.621 1.435L6.535 12.8c-.439 0-.73.283-.73.69 0 .388.236.654.603.704l.127.008h4.75a8.104 8.104 0 0 0 1.653 1.447H5.235c-.438 0-.739.293-.739.712 0 .367.237.64.61.692l.129.008h8.723c.415 0 .729.315.729.7a.722.722 0 0 1-.607.726l-.122.01H6.535c-.439 0-.73.293-.73.711 0 .367.236.641.603.692l.127.009h10.273c.53 0 .893.325.893.785 0 .359-.143.667-.58.915l-.157.08-3.173 1.457c-.416.187-.623.533-.477.909.13.34.447.485.872.38l.146-.044 5.157-1.854c3.525-1.267 4.908-3.486 4.908-6.534 0-.938-.15-1.786-.439-2.529.365-.53.67-1.109.902-1.722.742 1.185 1.14 2.645 1.14 4.304 0 3.696-1.908 6.308-5.654 7.762l-.357.132-5.167 1.853c-1.34.483-2.475.053-2.89-1.078-.343-.956.023-1.903.995-2.411l.19-.09 1.433-.598c.054-.02.073-.053.073-.083 0-.047-.017-.071-.052-.08l-.04-.004H6.379c-1.258 0-2.07-.817-2.07-2.063a1.7 1.7 0 0 1 .373-1.078C3.633 18.14 3 17.429 3 16.362c0-1.038.654-1.781 1.664-1.969a1.551 1.551 0 0 1-.355-.996c0-1.087.704-1.838 1.799-1.919l.197-.007h1.03c-.26-.273-.395-.68-.395-1.1 0-1.087.752-1.867 1.86-1.95l.198-.008h.307ZM17.34 2c3.766 0 6.818 3.074 6.818 6.866 0 3.791-3.052 6.865-6.818 6.865-3.765 0-6.818-3.074-6.818-6.865C10.521 5.074 13.574 2 17.34 2Zm0 1.43c-2.981 0-5.398 2.433-5.398 5.436 0 3.002 2.417 5.436 5.398 5.436 2.982 0 5.399-2.434 5.399-5.436 0-3.003-2.417-5.436-5.399-5.436Zm.044 1.264c.181 0 .329.056.443.168.091.09.146.201.164.336l.007.105v.415l.29.06a3.83 3.83 0 0 1 1.13.496c.105.071.18.149.224.234a.68.68 0 0 1 .066.314c0 .176-.053.33-.158.459-.105.13-.228.194-.369.194a.582.582 0 0 1-.201-.035 2.538 2.538 0 0 1-.28-.133c-.042-.023-.132-.072-.273-.145a2.255 2.255 0 0 0-.451-.177 1.93 1.93 0 0 0-.513-.066c-.263 0-.476.057-.64.172a.538.538 0 0 0-.245.464c0 .188.093.33.28.423.187.095.482.189.886.283.432.1.787.206 1.065.318.277.112.517.291.719.538.201.247.302.58.302.998 0 .477-.162.883-.486 1.218-.278.288-.64.491-1.082.61l-.229.052v.433l-.007.105a.562.562 0 0 1-.164.337.606.606 0 0 1-.443.167.605.605 0 0 1-.442-.168.563.563 0 0 1-.165-.336l-.006-.105v-.397l-.273-.042a3.769 3.769 0 0 1-1.393-.532.599.599 0 0 1-.224-.22.696.696 0 0 1-.066-.328c0-.176.051-.33.154-.459.102-.13.223-.194.364-.194.07 0 .14.012.21.035.07.024.16.068.272.133.257.141.497.241.719.3.222.059.459.088.71.088.31 0 .545-.051.706-.154a.514.514 0 0 0 .24-.464.377.377 0 0 0-.144-.304 1.1 1.1 0 0 0-.36-.19 10.606 10.606 0 0 0-.626-.177 8.412 8.412 0 0 1-1.079-.34 1.858 1.858 0 0 1-.727-.538c-.205-.244-.307-.573-.307-.985 0-.47.164-.88.49-1.227.281-.297.64-.509 1.074-.633l.224-.055v-.442l.011-.126a.567.567 0 0 1 .165-.31.6.6 0 0 1 .438-.173Z",
    fill: "#023F80"
  })));
};

var _path$4A;
function _extends$4E() { _extends$4E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4E.apply(this, arguments); }
var SvgPaywaveOutline = function SvgPaywaveOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4E({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4A || (_path$4A = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.423 3.421a1 1 0 1 0-1.776.92 21 21 0 0 1 0 19.32 1 1 0 1 0 1.775.92 23 23 0 0 0 0-21.16Zm-5.66 2.09a1 1 0 0 1 1.341.448 18 18 0 0 1 0 16.084 1 1 0 0 1-1.79-.894 16 16 0 0 0 0-14.297 1 1 0 0 1 .449-1.341Zm-2.98 2.995a1 1 0 1 0-1.813.846 11 11 0 0 1 0 9.294 1 1 0 1 0 1.813.845 13 13 0 0 0 0-10.985ZM7.46 11.11a1 1 0 1 0-1.865.722 6 6 0 0 1-.004 4.346 1 1 0 0 0 1.864.726 8 8 0 0 0 .005-5.794Z",
    fill: "#023F80"
  })));
};

var _path$4B, _path2$1o;
function _extends$4F() { _extends$4F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4F.apply(this, arguments); }
var SvgPenKeyholeOutline = function SvgPenKeyholeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4F({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4B || (_path$4B = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.058 2.327a3 3 0 0 1 2.724 0c.428.218.8.59 1.23 1.022l.63.63c.432.43.805.803 1.023 1.23a3 3 0 0 1 0 2.725c-.218.427-.591.8-1.023 1.23l-2.636 2.635a1 1 0 0 1-1.414-1.414l.269-.268-2.986-2.986L6.142 17.863c-.425.426-.56.564-.665.709a2.5 2.5 0 0 0-.446 1.078c-.028.177-.03.37-.03.971v.97c-.001.198 0 .305.004.384v.011l.012.001c.078.004.186.005.383.005h.97c.602 0 .795-.003.971-.031a2.5 2.5 0 0 0 1.079-.447c.144-.105.283-.24.708-.665l.259-.258a1 1 0 0 1 1.414 1.414l-.31.31c-.354.354-.608.608-.896.817a4.5 4.5 0 0 1-1.94.804c-.352.056-.712.056-1.212.056H5.32c-.283 0-.63.002-.938-.098a2 2 0 0 1-1.284-1.284c-.1-.31-.1-.656-.098-.937V20.549c0-.5 0-.86.055-1.212a4.5 4.5 0 0 1 .804-1.94c.21-.288.464-.543.818-.897l13.15-13.15c.431-.432.803-.805 1.231-1.023Zm3.075 5.517-.858.859-2.986-2.986.858-.858c.582-.582.713-.696.82-.75a1 1 0 0 1 .907 0c.106.054.237.168.819.75l.44.44c.582.581.696.713.75.819a1 1 0 0 1 0 .908c-.054.105-.168.237-.75.818Z",
    fill: "#023F80"
  })), _path2$1o || (_path2$1o = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 26a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm2-7a2 2 0 0 1-1 1.732V22.5a1 1 0 1 1-2 0v-1.768A2 2 0 0 1 19 17a2 2 0 0 1 2 2Z",
    fill: "#023F80"
  })));
};

var _path$4C, _path2$1p, _path3$s;
function _extends$4G() { _extends$4G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4G.apply(this, arguments); }
var SvgPenStackLockOutline = function SvgPenStackLockOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4G({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4C || (_path$4C = /*#__PURE__*/createElement$2("path", {
    d: "M19.994 4.85A2 2 0 0 0 18 3h-8a2 2 0 0 0-2 2h12l-.006-.15ZM15.687 15.363a1.096 1.096 0 1 0-1.55-1.55l-2.881 2.88a7.105 7.105 0 0 0-1.548 2.324l-.178.433a.399.399 0 0 0 .52.52l.433-.178a7.107 7.107 0 0 0 2.323-1.548l2.881-2.88ZM17.304 11a1.196 1.196 0 1 1 0 2.392 1.196 1.196 0 0 1 0-2.392Z",
    fill: "#023F80"
  })), _path2$1p || (_path2$1p = /*#__PURE__*/createElement$2("path", {
    d: "M8.759 7H19.24c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564.044.541.044 1.206.044 2.01V13a1 1 0 1 1-2 0v-.2c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18C20.639 9 20.057 9 19.2 9H8.8c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C5 11.361 5 11.943 5 12.8v5.4c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C7.361 22 7.943 22 8.8 22H14a1 1 0 1 1 0 2H8.759c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 19.71 3 19.046 3 18.242v-5.483c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C7.29 7 7.954 7 8.758 7Z",
    fill: "#023F80"
  })), _path3$s || (_path3$s = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 18.492a2.994 2.994 0 0 0-3-2.992l-.176.005a3.003 3.003 0 0 0-2.824 2.996V20l-.748.001a.76.76 0 0 0-.752.76v4.48c0 .42.337.76.752.76h7.496a.76.76 0 0 0 .752-.76v-4.48c0-.42-.337-.76-.752-.76l-.748-.001v-1.507Zm-3.145-1.485L21.5 17c.828 0 1.5.666 1.5 1.5V20h-3v-1.5c0-.78.59-1.42 1.355-1.493Z",
    fill: "#023F80"
  })));
};

var _path$4D, _path2$1q;
function _extends$4H() { _extends$4H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4H.apply(this, arguments); }
var SvgPenStackOutline = function SvgPenStackOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4H({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4D || (_path$4D = /*#__PURE__*/createElement$2("path", {
    d: "M18 3a2 2 0 0 1 1.994 1.85L20 5H8a2 2 0 0 1 2-2h8ZM15.687 13.813a1.096 1.096 0 0 1 0 1.55l-2.88 2.881a7.107 7.107 0 0 1-2.324 1.548l-.433.178a.399.399 0 0 1-.52-.52l.178-.433a7.105 7.105 0 0 1 1.548-2.323l2.88-2.881a1.096 1.096 0 0 1 1.551 0ZM17.304 11a1.196 1.196 0 1 1 0 2.392 1.196 1.196 0 0 1 0-2.392Z",
    fill: "#023F80"
  })), _path2$1q || (_path2$1q = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 13.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 7 7.16 7 9.4 7h9.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C25 10.04 25 11.16 25 13.4v4.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C21.96 24 20.84 24 18.6 24H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 20.96 3 19.84 3 17.6v-4.2ZM9.4 9h9.2c1.153 0 1.898.002 2.464.048.544.044.745.12.844.17a2 2 0 0 1 .874.874c.05.099.126.3.17.844.046.566.048 1.31.048 2.464v4.2c0 1.153-.002 1.898-.048 2.464-.044.544-.12.745-.17.844a2 2 0 0 1-.874.874c-.099.05-.3.126-.844.17-.566.046-1.31.048-2.464.048H9.4c-1.153 0-1.898-.002-2.464-.048-.544-.044-.745-.12-.844-.17a2 2 0 0 1-.874-.874c-.05-.099-.126-.3-.17-.844C5.002 19.498 5 18.754 5 17.6v-4.2c0-1.153.002-1.898.048-2.464.044-.544.12-.745.17-.844a2 2 0 0 1 .874-.874c.099-.05.3-.126.844-.17C7.502 9.002 8.246 9 9.4 9Z",
    fill: "#023F80"
  })));
};

var _path$4E;
function _extends$4I() { _extends$4I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4I.apply(this, arguments); }
var SvgPhoneAddOutline = function SvgPhoneAddOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4I({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4E || (_path$4E = /*#__PURE__*/createElement$2("path", {
    d: "M4.495 4.123c-2.92 3.213-1.36 8.186 2.928 12.494 4.198 4.217 9.394 5.794 12.47 2.932 1.681-1.565 1.433-4.337-.645-6.19-1.88-1.596-4.832-1.872-6.714-.106-.634-.533-1.174-1.164-1.754-1.753 1.626-1.706 1.621-4.676-.055-6.679C8.84 2.57 5.98 2.49 4.495 4.123Zm4.851 1.852c1.059 1.265 1.2 3.28-.05 4.46-.628.565-1.243.899 1.032 3.213 2.455 2.496 2.76 1.62 3.4.95 1.005-1.008 2.972-1.102 4.324.104 1.495 1.332 1.333 2.864.616 3.531-2.219 2.065-6.468.635-9.97-2.884-3.504-3.52-5.058-7.612-2.873-10.017.508-.558 2.099-1.057 3.521.643ZM18.5 2a.9.9 0 0 1 .9.9v1.7h1.7a.9.9 0 0 1 0 1.8h-1.7v1.7a.9.9 0 1 1-1.8 0V6.4h-1.7a.9.9 0 0 1 0-1.8h1.7V2.9a.9.9 0 0 1 .9-.9Z",
    fill: "#023F80"
  })));
};

var _path$4F;
function _extends$4J() { _extends$4J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4J.apply(this, arguments); }
var SvgPhoneOutline = function SvgPhoneOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4J({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4F || (_path$4F = /*#__PURE__*/createElement$2("path", {
    d: "M4.495 4.123c-2.92 3.213-1.36 8.186 2.928 12.494 4.198 4.217 9.394 5.794 12.47 2.932 1.681-1.565 1.433-4.337-.645-6.19l-.19-.16c-1.928-1.562-4.727-1.567-6.436-.028l-.088.082-.05-.041c-.187-.16-.43-.381-.723-.673l-.297-.302-.306-.326c-.092-.1-.174-.193-.246-.277l-.124-.146-.07.075c1.688-1.695 1.704-4.714.007-6.742C8.84 2.57 5.98 2.49 4.495 4.123Zm4.851 1.852c1.18 1.409 1.047 3.367.099 4.32l-.148.14c-.63.565-1.244.899 1.031 3.213 2.455 2.496 2.76 1.62 3.4.95 1.005-1.008 2.972-1.102 4.324.104 1.495 1.332 1.333 2.864.616 3.531-2.219 2.065-6.468.635-9.97-2.884-3.504-3.52-5.058-7.612-2.873-10.017.508-.558 2.099-1.057 3.521.643Z",
    fill: "#023F80"
  })));
};

var _path$4G, _path2$1r, _path3$t;
function _extends$4K() { _extends$4K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4K.apply(this, arguments); }
var SvgPhoneWaveOutline = function SvgPhoneWaveOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4K({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4G || (_path$4G = /*#__PURE__*/createElement$2("path", {
    d: "M15.574 3.13a1 1 0 0 1 1-1 9.283 9.283 0 0 1 9.283 9.283 1 1 0 1 1-2 0 7.283 7.283 0 0 0-7.283-7.283 1 1 0 0 1-1-1Z",
    fill: "#023F80"
  })), _path2$1r || (_path2$1r = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.31 14.698c.525.524.981.92 1.35 1.191 2.124-2.123 5.428-2.317 7.652-.447l1.023.862c2.03 1.708 2.232 4.751.49 6.798-.896 1.036-2.156 1.687-3.442 1.808-3.982.536-7.987-1.303-11.984-5.3-3.997-3.998-5.837-8.004-5.31-11.896.036-.414.122-.822.257-1.22a5.33 5.33 0 0 1 1.572-2.321c2.037-1.732 5.079-1.53 6.785.5l.86 1.023c1.873 2.22 1.681 5.527-.4 7.607.227.414.624.87 1.148 1.395Zm2.81 2.561-.734.734a.712.712 0 0 1-.75.166c-.73-.269-1.643-.95-2.74-2.047-1.095-1.096-1.778-2.01-2.045-2.74a.712.712 0 0 1 .164-.75l.736-.734c1.354-1.354 1.478-3.487.284-4.903l-.862-1.024c-.984-1.17-2.756-1.288-3.96-.264A3.319 3.319 0 0 0 5.24 7.14a3.25 3.25 0 0 0-.159.752c-.44 3.272 1.137 6.707 4.733 10.303 3.596 3.596 7.03 5.174 10.303 4.733a3.318 3.318 0 0 0 2.195-1.134c1.024-1.202.905-2.976-.264-3.96l-1.024-.862c-1.417-1.192-3.55-1.067-4.903.287Z",
    fill: "#023F80"
  })), _path3$t || (_path3$t = /*#__PURE__*/createElement$2("path", {
    d: "M19.6 10.895c.609-.068 1.018-.668.728-1.207a5.01 5.01 0 0 0-2.031-2.029c-.539-.29-1.139.12-1.207.728l-.176 1.58a1 1 0 0 0 1.105 1.105l1.582-.177Z",
    fill: "#023F80"
  })));
};

var _path$4H, _path2$1s, _path3$u;
function _extends$4L() { _extends$4L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4L.apply(this, arguments); }
var SvgPhotosStackOutline = function SvgPhotosStackOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4L({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4H || (_path$4H = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1 11.5a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0Z",
    fill: "#023F80"
  })), _path2$1s || (_path2$1s = /*#__PURE__*/createElement$2("path", {
    d: "M7 3.9a1.8 1.8 0 0 1 1.8-1.8h6.4A1.8 1.8 0 0 1 17 3.9H7Z",
    fill: "#023F80"
  })), _path3$u || (_path3$u = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.762 6.1h8.476c.808 0 1.469 0 2.006.044.556.045 1.058.142 1.527.381a3.9 3.9 0 0 1 1.704 1.704c.239.47.336.971.381 1.527.044.537.044 1.198.044 2.006v3.476c0 .808 0 1.469-.044 2.006-.045.556-.142 1.058-.381 1.527a3.9 3.9 0 0 1-1.704 1.704c-.47.239-.971.336-1.527.381-.537.044-1.198.044-2.006.044H7.762c-.808 0-1.469 0-2.006-.044-.556-.045-1.058-.142-1.527-.381a3.9 3.9 0 0 1-1.704-1.704c-.239-.47-.336-.971-.381-1.527-.044-.537-.044-1.198-.044-2.006v-3.476c0-.808 0-1.469.044-2.006.045-.556.142-1.058.381-1.527A3.9 3.9 0 0 1 4.23 6.525c.47-.239.971-.336 1.527-.381C6.293 6.1 6.954 6.1 7.762 6.1Zm3.873 11.393c.092.077.199.166.298.236.114.081.28.183.502.234.288.066.59.04.863-.077a1.41 1.41 0 0 0 .452-.32c.085-.086.174-.192.251-.285l3.533-4.236 2.566 2.001.001.4c.003.55.006 1.103-.039 1.651-.036.445-.103.683-.19.856a2.1 2.1 0 0 1-.919.918c-.172.088-.411.155-.856.191-.455.037-1.042.038-1.897.038H7.8c-.463 0-.848 0-1.175-.006l3.155-3.156 1.855 1.555Zm6.615-6.16c.099.065.205.148.297.22l1.553 1.21V11.8c0-.855 0-1.442-.038-1.897-.036-.445-.103-.684-.19-.856a2.1 2.1 0 0 0-.919-.918c-.172-.088-.411-.155-.856-.191C17.642 7.9 17.055 7.9 16.2 7.9H7.8c-.855 0-1.442 0-1.897.038-.445.036-.683.103-.856.19a2.1 2.1 0 0 0-.918.919c-.088.172-.155.411-.191.856-.037.455-.038 1.042-.038 1.897v3.4c0 .855 0 1.442.038 1.897.036.445.103.683.19.856.12.235.282.443.476.616l3.983-3.983c.078-.078.169-.17.256-.244.49-.418 1.199-.454 1.73-.076.093.066.192.15.277.22l1.847 1.548 3.53-4.232c.075-.09.16-.194.244-.278.096-.098.238-.225.44-.314a1.4 1.4 0 0 1 .842-.09c.216.044.382.138.497.213ZM7.5 10.1a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8Z",
    fill: "#023F80"
  })));
};

var _path$4I, _path2$1t;
function _extends$4M() { _extends$4M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4M.apply(this, arguments); }
var SvgPictureInPicture16X9Outline = function SvgPictureInPicture16X9Outline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4M({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4I || (_path$4I = /*#__PURE__*/createElement$2("path", {
    d: "M7.762 4.1h6.476c.808 0 1.469 0 2.006.044.556.045 1.058.142 1.526.381a3.9 3.9 0 0 1 1.705 1.704c.239.47.336.971.381 1.527.044.537.044 1.198.044 2.006V11.3a.9.9 0 0 1-1.8 0V9.8c0-.855 0-1.442-.038-1.897-.036-.445-.103-.684-.19-.856a2.1 2.1 0 0 0-.919-.918c-.172-.088-.411-.155-.856-.191C15.642 5.9 15.055 5.9 14.2 5.9H7.8c-.855 0-1.442 0-1.897.038-.445.036-.684.103-.856.19a2.1 2.1 0 0 0-.918.919c-.088.172-.155.411-.191.856C3.9 8.358 3.9 8.945 3.9 9.8v2.4c0 .855 0 1.442.038 1.897.036.445.103.684.19.856a2.1 2.1 0 0 0 .919.918c.172.088.411.155.856.191.455.037 1.042.038 1.897.038h2.5a.9.9 0 0 1 0 1.8H7.762c-.808 0-1.469 0-2.006-.044-.556-.045-1.058-.142-1.527-.381a3.9 3.9 0 0 1-1.704-1.705c-.239-.468-.336-.97-.381-1.526-.044-.537-.044-1.198-.044-2.006V9.762c0-.808 0-1.469.044-2.006.045-.556.142-1.058.381-1.527a3.9 3.9 0 0 1 1.704-1.704c.47-.239.971-.336 1.527-.381C6.293 4.1 6.954 4.1 7.762 4.1Z",
    fill: "#023F80"
  })), _path2$1t || (_path2$1t = /*#__PURE__*/createElement$2("path", {
    d: "M13 16.8c0-.98 0-1.47.19-1.845a1.75 1.75 0 0 1 .766-.764C14.33 14 14.82 14 15.8 14h3.4c.98 0 1.47 0 1.845.19.329.168.596.436.764.766.191.374.191.864.191 1.844v.4c0 .98 0 1.47-.19 1.845a1.75 1.75 0 0 1-.765.764C20.67 20 20.18 20 19.2 20h-3.4c-.98 0-1.47 0-1.845-.19a1.75 1.75 0 0 1-.764-.765C13 18.67 13 18.18 13 17.2v-.4ZM7.636 8.364a.9.9 0 0 0-1.272 1.272L8.827 12.1H7.9a.9.9 0 1 0 0 1.8H11a.9.9 0 0 0 .9-.9V9.9a.9.9 0 0 0-1.8 0v.927L7.636 8.364Z",
    fill: "#023F80"
  })));
};

var _path$4J;
function _extends$4N() { _extends$4N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4N.apply(this, arguments); }
var SvgPictureOutline = function SvgPictureOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4N({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4J || (_path$4J = /*#__PURE__*/createElement$2("path", {
    d: "m9.41 2.1 5.513.002c1.944.02 2.926.228 3.943.772a5.443 5.443 0 0 1 2.26 2.26c.574 1.074.774 2.108.774 4.276v5.18c0 2.168-.2 3.202-.774 4.276a5.443 5.443 0 0 1-2.26 2.26c-1.074.574-2.108.774-4.276.774H9.41c-2.168 0-3.202-.2-4.277-.774a5.443 5.443 0 0 1-2.259-2.26C2.3 17.792 2.1 16.758 2.1 14.59l.002-5.513c.02-1.944.228-2.926.772-3.944a5.443 5.443 0 0 1 2.26-2.259C6.207 2.3 7.241 2.1 9.41 2.1Zm5.68 11.192-3.728 4.53a.9.9 0 0 1-1.266.124L8.054 16.27l-2.806 2.755c.22.197.465.368.734.512.696.373 1.373.528 2.866.557l.562.005h5.18l.562-.005c1.318-.025 2-.15 2.62-.434l.246-.123a3.644 3.644 0 0 0 1.52-1.52c.1-.187.185-.372.255-.572l-4.704-4.154Zm-.5-9.392H9.41l-.562.005c-1.318.025-2 .15-2.62.434l-.246.122a3.644 3.644 0 0 0-1.52 1.521l-.123.246C4.016 6.931 3.9 7.713 3.9 9.41v5.18l.005.562c.022 1.133.117 1.796.324 2.353l3.14-3.085a.9.9 0 0 1 1.202-.053l1.972 1.617 3.749-4.556a.9.9 0 0 1 1.29-.103l4.51 3.985.003-.158.005-.562V9.41l-.005-.562c-.025-1.318-.15-2-.434-2.62l-.123-.246a3.644 3.644 0 0 0-1.52-1.52c-.696-.373-1.373-.528-2.866-.557L14.59 3.9ZM8.5 7a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z",
    fill: "#023F80"
  })));
};

var _path$4K;
function _extends$4O() { _extends$4O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4O.apply(this, arguments); }
var SvgPillOutline = function SvgPillOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4O({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4K || (_path$4K = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.953 23.035a6.688 6.688 0 0 1 0-9.459l8.6-8.599a6.688 6.688 0 1 1 9.458 9.459l-8.599 8.599a6.688 6.688 0 0 1-9.459 0Zm6.268-12.899 3.745-3.745a4.688 4.688 0 0 1 6.63 6.63l-3.744 3.746-6.63-6.63Zm-1.414 1.415-3.44 3.44a4.688 4.688 0 0 0 6.63 6.63l3.44-3.44-6.63-6.63Z",
    fill: "#023F80"
  })));
};

var _path$4L;
function _extends$4P() { _extends$4P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4P.apply(this, arguments); }
var SvgPinDotOutline = function SvgPinDotOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4P({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4L || (_path$4L = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.677 3.264a.9.9 0 0 0-1.519.46l-.36 1.8a.324.324 0 0 1-.088.166L9.83 8.57a.324.324 0 0 1-.205.095l-4.511.347a1.206 1.206 0 0 0-.76.35l-.089.097a1.206 1.206 0 0 0 .088 1.608l3.654 3.653-4.743 4.744-.08.093a.9.9 0 0 0 1.352 1.18l4.744-4.744 3.654 3.655a1.206 1.206 0 0 0 2.055-.76l.347-4.512a.324.324 0 0 1 .094-.205l2.88-2.88a.325.325 0 0 1 .166-.088l1.8-.36a.9.9 0 0 0 .46-1.52l-6.059-6.059Zm-.114 2.614.03-.152 3.681 3.68-.151.032a2.124 2.124 0 0 0-1.085.58l-2.88 2.88-.128.14a2.124 2.124 0 0 0-.489 1.2l-.248 3.223-6.754-6.754 3.224-.248c.506-.039.98-.257 1.34-.616l2.88-2.88c.296-.296.498-.674.58-1.085ZM10 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
    fill: "#023F80"
  })));
};

var _path$4M, _path2$1u;
function _extends$4Q() { _extends$4Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4Q.apply(this, arguments); }
var SvgPinDotSlashOutline = function SvgPinDotSlashOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4Q({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4M || (_path$4M = /*#__PURE__*/createElement$2("path", {
    d: "M15.044 6.162a.5.5 0 0 1-.137.255l-1.925 1.925a1 1 0 1 0 1.446 1.383l1.893-1.893a2.5 2.5 0 0 0 .684-1.278l.075-.374 4.782 4.782-.374.075a2.5 2.5 0 0 0-1.278.684l-1.864 1.864a1 1 0 1 0 1.353 1.47l.003.002 1.923-1.922a.5.5 0 0 1 .255-.137l2.206-.441a1 1 0 0 0 .511-1.688l-7.424-7.424a1 1 0 0 0-1.688.51l-.441 2.207ZM10.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: "#023F80"
  })), _path2$1u || (_path2$1u = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.293 5.293a1 1 0 0 1 1.414 0l17 17a1 1 0 1 1-1.414 1.414l-3.584-3.584-.184 2.384a1.375 1.375 0 0 1-2.343.867l-4.55-4.55-5.657 5.657c-.943.943-2.357-.471-1.414-1.414l5.657-5.657-4.55-4.55a1.375 1.375 0 0 1 .867-2.343l2.384-.184-3.626-3.626a1 1 0 0 1 0-1.414Zm5.489 6.903-2.74.21L15.636 21l.211-2.739-6.064-6.064Z",
    fill: "#023F80"
  })));
};

var _path$4N;
function _extends$4R() { _extends$4R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4R.apply(this, arguments); }
var SvgPinOutline = function SvgPinOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4R({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4N || (_path$4N = /*#__PURE__*/createElement$2("path", {
    d: "M13.158 3.724a.9.9 0 0 1 1.52-.46l6.058 6.06a.9.9 0 0 1-.46 1.518l-1.8.36a.325.325 0 0 0-.166.09l-2.88 2.88a.324.324 0 0 0-.094.204l-.347 4.511a1.206 1.206 0 0 1-2.055.76L9.28 15.994l-4.744 4.744a.9.9 0 0 1-1.353-1.18l.08-.093 4.744-4.744-3.654-3.653a1.206 1.206 0 0 1-.088-1.608l.088-.098c.204-.203.473-.327.76-.35l4.512-.346a.324.324 0 0 0 .204-.094l2.88-2.88a.324.324 0 0 0 .09-.166l.36-1.8Zm1.435 2.002-.03.152a2.125 2.125 0 0 1-.58 1.085l-2.88 2.88a2.125 2.125 0 0 1-1.34.616l-3.224.248 6.754 6.754.248-3.223c.034-.443.206-.862.489-1.2l.127-.14 2.88-2.88a2.124 2.124 0 0 1 1.086-.58l.151-.031-3.681-3.681Z",
    fill: "#023F80"
  })));
};

var _path$4O;
function _extends$4S() { _extends$4S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4S.apply(this, arguments); }
var SvgPinSlashOutline = function SvgPinSlashOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4S({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4O || (_path$4O = /*#__PURE__*/createElement$2("path", {
    d: "m5.944 3.683.092.08 14.2 14.2a.9.9 0 0 1-1.18 1.354l-.092-.08-3.716-3.716-.259 3.366a1.206 1.206 0 0 1-2.055.76L9.28 15.994l-4.744 4.744a.9.9 0 0 1-1.353-1.18l.08-.093 4.744-4.744-3.654-3.653a1.206 1.206 0 0 1-.088-1.608l.088-.098c.204-.203.473-.327.76-.35l3.366-.259-3.715-3.716a.9.9 0 0 1 1.18-1.353Zm4.182 6.716c-.118.03-.24.05-.363.06l-3.224.248 6.754 6.754.248-3.223c.01-.124.03-.245.06-.364L10.126 10.4Zm4.46-7.213.088.077 6.064 6.06a.9.9 0 0 1-.35 1.49l-.114.03-1.83.356-.053.027-.532.534a.9.9 0 0 1-1.356-1.178l.08-.092.534-.535a1.9 1.9 0 0 1 .845-.492l.305-.064-3.674-3.672-.03.15a1.9 1.9 0 0 1-.416.891l-.113.124-.529.524a.9.9 0 0 1-1.348-1.186l.08-.092.526-.522.008-.012.023-.058.36-1.82a.9.9 0 0 1 1.431-.54Z",
    fill: "#023F80"
  })));
};

var _path$4P;
function _extends$4T() { _extends$4T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4T.apply(this, arguments); }
var SvgPincodeLockOutline = function SvgPincodeLockOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4T({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4P || (_path$4P = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 7a3 3 0 0 0-3 3v1.065c-.292.043-.581.119-.862.262a3 3 0 0 0-1.311 1.311c-.193.378-.264.772-.296 1.167-.031.375-.031.83-.031 1.357V17.837c0 .528 0 .982.03 1.357.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031h2.677c.528 0 .982 0 1.357-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.357V15.162c0-.528 0-.982-.03-1.357-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.28-.143-.57-.22-.862-.262V10a3 3 0 0 0-3-3Zm-1.3 6c-.577 0-.949 0-1.232.024-.272.022-.372.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C17 14.25 17 14.623 17 15.2v2.6c0 .577 0 .949.024 1.232.022.272.06.372.085.422a1 1 0 0 0 .437.437c.05.025.15.063.422.085.283.023.655.024 1.232.024h2.6c.577 0 .949 0 1.232-.024.272-.022.372-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.063-.15.085-.422C24 18.75 24 18.377 24 17.8v-2.6c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085C22.75 13 22.377 13 21.8 13h-2.6Zm2.3-2v-1a1 1 0 1 0-2 0v1h2ZM7.759 8H14.5a1 1 0 1 1 0 2H7.8c-.857 0-1.439 0-1.889.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 12.361 4 12.943 4 13.8v.4c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C6.361 18 6.943 18 7.8 18H12a1 1 0 1 1 0 2H7.759c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 15.71 2 15.046 2 14.242v-.483c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C6.29 8 6.954 8 7.758 8ZM12 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm14 1.866v.634a.5.5 0 0 1-1 0v-.634a1 1 0 1 1 1 0Z",
    fill: "#023F80"
  })));
};

var _path$4Q;
function _extends$4U() { _extends$4U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4U.apply(this, arguments); }
var SvgPincodeOutline = function SvgPincodeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4U({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4Q || (_path$4Q = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8 7h-.041c-.805 0-1.47 0-2.01.044-.563.046-1.08.145-1.565.392a4 4 0 0 0-1.748 1.748c-.247.485-.346 1.002-.392 1.564C2 11.29 2 11.954 2 12.758V15.242c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C6.29 21 6.954 21 7.758 21h12.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V12.758c0-.805 0-1.47-.044-2.01-.046-.563-.145-1.08-.392-1.565a4 4 0 0 0-1.748-1.748c-.485-.247-1.002-.346-1.564-.392C21.71 7 21.046 7 20.242 7H7.8ZM5.092 9.218c.156-.08.38-.145.819-.18C6.361 9 6.943 9 7.8 9h12.4c.857 0 1.439 0 1.889.038.438.035.663.1.819.18a2 2 0 0 1 .874.874c.08.156.145.38.18.819.037.45.038 1.032.038 1.889v2.4c0 .857 0 1.439-.038 1.889-.035.438-.1.663-.18.819a2 2 0 0 1-.874.874c-.156.08-.38.145-.819.18-.45.037-1.032.038-1.889.038H7.8c-.857 0-1.439 0-1.889-.038-.438-.035-.663-.1-.819-.18a2 2 0 0 1-.874-.874c-.08-.156-.145-.38-.18-.819C4 16.639 4 16.057 4 15.2v-2.4c0-.857 0-1.439.038-1.889.035-.438.1-.663.18-.819a2 2 0 0 1 .874-.874ZM9 12.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm3.5 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
    fill: "#023F80"
  })));
};

var _path$4R, _path2$1v;
function _extends$4V() { _extends$4V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4V.apply(this, arguments); }
var SvgPlaceOutline = function SvgPlaceOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4V({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4R || (_path$4R = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm0-1.8a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4Z",
    fill: "#023F80"
  })), _path2$1v || (_path2$1v = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.243 9.77C4.243 5.48 7.714 2 12 2s7.757 3.48 7.757 7.77c0 3.133-1.974 6.852-5.565 11.098a2.871 2.871 0 0 1-4.384 0l-.567-.67.005-.006C6.012 16.227 4.243 12.736 4.243 9.77Zm6.942 9.94a1.071 1.071 0 0 0 1.633-.005c3.545-4.191 5.14-7.483 5.14-9.935 0-3.299-2.67-5.97-5.958-5.97-3.288 0-5.957 2.671-5.957 5.97 0 2.452 1.594 5.744 5.139 9.936l.003.003Z",
    fill: "#023F80"
  })));
};

var _path$4S;
function _extends$4W() { _extends$4W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4W.apply(this, arguments); }
var SvgPlaneOutline = function SvgPlaneOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4W({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4S || (_path$4S = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98 21.86a2.418 2.418 0 0 0 1.599-2.58l-.162-1.312c.311-.218.632-.457.96-.713l1.831 2.633a2.625 2.625 0 0 0 4.733-1.992l-1.104-5.764 1.461-1.46c.986-.986 1.784-2.088 2.246-3.126.228-.514.414-1.102.443-1.707.029-.605-.1-1.428-.75-2.077-.649-.65-1.471-.779-2.077-.75-.605.029-1.193.215-1.707.444-1.035.46-2.132 1.254-3.115 2.236l-.01.01L11.87 7.16 6.105 6.052a2.627 2.627 0 0 0-1.996 4.736l2.636 1.834c-.256.328-.496.65-.715.962l-1.31-.162a2.418 2.418 0 0 0-1.594 4.441l1.842 1.17 1.17 1.841a2.418 2.418 0 0 0 2.841.986Zm-1.323-1.951-.812-1.277c-.214-.337-.32-.505-.448-.657a2.996 2.996 0 0 0-.371-.371c-.152-.127-.32-.235-.657-.449l-1.277-.811a.618.618 0 0 1 .407-1.136l1.906.236c.187.023.28.034.363.017a.483.483 0 0 0 .2-.093c.067-.052.122-.135.23-.302.288-.438.633-.914 1.027-1.414.18-.23.372-.463.572-.702.207-.244.31-.367.335-.492a.492.492 0 0 0-.042-.323c-.057-.114-.186-.204-.442-.382L5.138 9.31a.827.827 0 0 1 .627-1.49l6.286 1.207c.152.03.229.044.302.037a.5.5 0 0 0 .185-.057c.065-.035.12-.09.23-.2L14.6 6.974c1.74-1.74 3.694-2.61 4.364-1.94.67.67-.199 2.624-1.94 4.365l-.022.022-1.813 1.813c-.11.11-.165.164-.2.23a.502.502 0 0 0-.056.184c-.008.074.007.15.036.302l1.203 6.284a.825.825 0 0 1-1.487.626l-2.44-3.508c-.178-.256-.268-.385-.382-.442a.491.491 0 0 0-.323-.043c-.125.026-.248.13-.492.335-.239.201-.473.392-.702.572-.5.394-.975.739-1.413 1.026-.166.109-.25.163-.301.23a.483.483 0 0 0-.093.2c-.018.083-.006.177.017.364l.236 1.907a.618.618 0 0 1-1.136.408Z",
    fill: "#023F80"
  })));
};

var _path$4T;
function _extends$4X() { _extends$4X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4X.apply(this, arguments); }
var SvgPlanesGobierno = function SvgPlanesGobierno(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4X({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4T || (_path$4T = /*#__PURE__*/createElement$2("path", {
    d: "M16.792 3.428c1.91 0 2.603.2 3.301.573a3.894 3.894 0 0 1 1.62 1.62c.374.698.573 1.391.573 3.302v6.154c0 1.91-.2 2.603-.573 3.302a3.894 3.894 0 0 1-1.62 1.62c-.698.373-1.391.572-3.301.572H7.208c-1.91 0-2.603-.199-3.301-.572a3.894 3.894 0 0 1-1.62-1.62c-.374-.699-.573-1.391-.573-3.302V8.923c0-1.91.2-2.604.573-3.302A3.894 3.894 0 0 1 3.907 4c.698-.374 1.39-.573 3.301-.573h9.584Zm3.778 7.715H3.428v4.418c0 1.146.12 1.561.344 1.98.224.42.553.748.972.973.393.21.783.328 1.774.342l.207.001h10.55c1.146 0 1.562-.12 1.98-.343.42-.224.749-.553.973-.972.21-.393.328-.783.342-1.775l.001-.206v-4.418ZM7.496 13.714c.354 0 .497.04.637.115.14.074.25.184.324.324.075.14.114.283.114.637v.42c0 .354-.04.497-.114.637a.779.779 0 0 1-.324.324c-.14.075-.283.115-.637.115h-.42c-.355 0-.498-.04-.638-.115a.779.779 0 0 1-.324-.324C6.04 15.707 6 15.564 6 15.21v-.42c0-.354.04-.498.114-.637a.779.779 0 0 1 .324-.324c.14-.075.283-.115.637-.115h.421Zm9.779-8.571H6.725c-1.146 0-1.562.12-1.981.343a2.336 2.336 0 0 0-.972.972c-.21.393-.328.783-.342 1.775l-.001.206-.001.132H20.57l.001-.132c0-1.146-.119-1.562-.343-1.98a2.337 2.337 0 0 0-.972-.973c-.393-.21-.783-.328-1.774-.342l-.207-.001Z",
    fill: "#023F80"
  })));
};

var _path$4U, _path2$1w;
function _extends$4Y() { _extends$4Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4Y.apply(this, arguments); }
var SvgPlayCards2Outline = function SvgPlayCards2Outline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4Y({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4U || (_path$4U = /*#__PURE__*/createElement$2("path", {
    d: "M20.325 8.198c.099.545.625.908 1.177.81.551-.097.918-.617.82-1.162-.312-1.73-.55-2.969-1.255-3.893a5.071 5.071 0 0 0-2.568-1.776c-.644-.195-1.306-.208-2.044-.14-.718.066-1.59.219-2.673.407l-5.28.92c-1.082.189-1.955.341-2.652.521-.718.186-1.335.421-1.873.822a5.012 5.012 0 0 0-1.798 2.538c-.191.618-.209 1.251-.147 1.954.06.692.207 1.526.39 2.554.097.545.623.91 1.175.813.552-.096.92-.616.823-1.16-.188-1.055-.316-1.795-.367-2.38-.05-.574-.02-.92.066-1.195a3.007 3.007 0 0 1 1.078-1.523c.24-.178.57-.33 1.167-.484.607-.157 1.398-.295 2.533-.493l5.194-.905c1.135-.198 1.927-.335 2.552-.393.613-.056.977-.026 1.263.06a3.043 3.043 0 0 1 1.54 1.067c.353.462.54 1.158.88 3.038ZM14.862 14.57a.5.5 0 0 0-.834.282l-.869 5.105a.5.5 0 0 0 .68.547l4.433-1.792a.5.5 0 0 0 .153-.83l-3.563-3.312Z",
    fill: "#023F80"
  })), _path2$1w || (_path2$1w = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.5 19.574.05-.282c.191-1.07.345-1.932.412-2.641.069-.73.056-1.384-.141-2.02a5.012 5.012 0 0 0-1.798-2.538c-.538-.4-1.155-.636-1.873-.822-.697-.18-1.57-.333-2.652-.521l-5.28-.92c-1.082-.189-1.955-.34-2.672-.407-.739-.068-1.4-.055-2.045.14a5.071 5.071 0 0 0-2.568 1.776c-.405.532-.644 1.142-.832 1.851-.182.689-.336 1.552-.527 2.621l-.05.282c-.191 1.07-.345 1.933-.412 2.642-.069.73-.056 1.383.141 2.02a5.012 5.012 0 0 0 1.798 2.537c.538.401 1.156.637 1.873.823.697.18 1.57.332 2.653.52l5.279.92c1.082.19 1.955.341 2.673.407.738.069 1.4.056 2.044-.139a5.071 5.071 0 0 0 2.568-1.776c.406-.533.644-1.143.832-1.852.182-.688.336-1.551.527-2.62Zm-1.619-4.358c.088.284.119.643.061 1.249-.058.617-.197 1.4-.397 2.521l-.035.198c-.2 1.122-.34 1.904-.5 2.504-.155.588-.309.916-.49 1.152-.386.507-.925.88-1.54 1.066-.286.087-.65.117-1.263.06-.625-.057-1.416-.194-2.552-.392l-5.193-.905c-1.136-.198-1.927-.337-2.534-.494-.596-.154-.927-.305-1.166-.483a3.007 3.007 0 0 1-1.079-1.523c-.088-.283-.118-.642-.061-1.248.058-.618.197-1.4.397-2.522l.035-.197c.2-1.122.34-1.904.5-2.504.156-.589.309-.916.49-1.153.386-.507.925-.88 1.54-1.066.286-.086.65-.117 1.263-.06.625.057 1.417.195 2.552.393l5.194.905c1.135.197 1.926.336 2.533.493.596.154.927.306 1.167.484.513.382.89.915 1.078 1.522Z",
    fill: "#023F80"
  })));
};

var _path$4V;
function _extends$4Z() { _extends$4Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4Z.apply(this, arguments); }
var SvgPlayNextOutline = function SvgPlayNextOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4Z({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4V || (_path$4V = /*#__PURE__*/createElement$2("path", {
    d: "M3.857 5.1C3.384 5.1 3 5.503 3 6s.384.9.857.9h14.286c.473 0 .857-.403.857-.9s-.384-.9-.857-.9H3.857ZM3.87 10.1c-.48 0-.87.403-.87.9s.39.9.87.9h7.26c.48 0 .87-.403.87-.9s-.39-.9-.87-.9H3.87ZM3 16c0-.497.39-.9.87-.9h7.26c.48 0 .87.403.87.9s-.39.9-.87.9H3.87c-.48 0-.87-.403-.87-.9ZM21.493 16.965c.676-.448.676-1.482 0-1.93l-5.83-3.858c-.722-.478-1.663.068-1.663.965v7.716c0 .897.94 1.443 1.663.965l5.83-3.858Z",
    fill: "#023F80"
  })));
};

var _path$4W;
function _extends$4_() { _extends$4_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4_.apply(this, arguments); }
var SvgPlaySpeedOutline = function SvgPlaySpeedOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4_({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4W || (_path$4W = /*#__PURE__*/createElement$2("path", {
    d: "M16.179 2.197a12.003 12.003 0 0 1-.001 23.606 1 1 0 1 1-.361-1.967 10.003 10.003 0 0 0 0-19.671 1 1 0 0 1 .362-1.968ZM6.375 20.471a10.006 10.006 0 0 0 5.802 3.363 1 1 0 0 1-.362 1.967 12.005 12.005 0 0 1-6.964-4.036 1 1 0 1 1 1.524-1.294ZM3.992 9.32a1 1 0 0 1 .6 1.28A9.98 9.98 0 0 0 4 14c0 1.127.186 2.228.547 3.27a1 1 0 1 1-1.89.654A11.984 11.984 0 0 1 2 14c0-1.407.243-2.783.712-4.08a1 1 0 0 1 1.28-.6Zm8.208.758a.8.8 0 0 1 .397.106l5.463 3.121a.8.8 0 0 1 0 1.39l-5.463 3.121a.8.8 0 0 1-1.197-.694v-6.243a.8.8 0 0 1 .8-.8Zm.781-7.077a1 1 0 0 1-.802 1.164 9.987 9.987 0 0 0-5.747 3.298A1 1 0 1 1 4.92 6.155a11.987 11.987 0 0 1 6.898-3.957 1 1 0 0 1 1.164.803Z",
    fill: "#023F80"
  })));
};

var _path$4X;
function _extends$4$() { _extends$4$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4$.apply(this, arguments); }
var SvgPlaylistOutline = function SvgPlaylistOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$4$({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4X || (_path$4X = /*#__PURE__*/createElement$2("path", {
    d: "M24.78 4.025A1 1 0 0 1 26 5v2.102a3.6 3.6 0 0 1-2.672 3.479L20 11.468v7.926c0 4.688-4.582 7.1-7.073 4.61-2.576-2.578-.107-6.805 5.074-7.062L18 10.723V8.931c-.027-1.922.91-3.288 2.684-3.88.641-.213 1.993-.551 4.096-1.026ZM18 18.944c-3.538.196-4.845 2.459-3.659 3.645C15.484 23.732 18 22.408 18 19.394v-.45ZM8.5 17a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h4Zm5-6a1 1 0 1 1 0 2h-9a1 1 0 1 1 0-2h9ZM24 6.256c-1.348.315-2.249.548-2.684.693-.934.311-1.331.89-1.316 1.968v.481l2.812-.75A1.6 1.6 0 0 0 24 7.102v-.846ZM15 5a1 1 0 1 1 0 2H4.5a1 1 0 0 1 0-2H15Z",
    fill: "#023F80"
  })));
};

var _path$4Y;
function _extends$50() { _extends$50 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$50.apply(this, arguments); }
var SvgPodcastOutline = function SvgPodcastOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$50({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4Y || (_path$4Y = /*#__PURE__*/createElement$2("path", {
    d: "M14 6a6 6 0 0 1 6 6v6a6.002 6.002 0 0 1-5 5.917V25.5a1 1 0 1 1-2 0v-1.583A6.002 6.002 0 0 1 8 18v-6a6 6 0 0 1 6-6Zm0 2a4 4 0 0 0-4 4h2.5a1 1 0 1 1 0 2H10v2h2.5a1 1 0 1 1 0 2H10a4 4 0 0 0 8 0h-1a1 1 0 0 1-.117-1.993L17 16h1v-2h-1a1 1 0 0 1-.117-1.993L17 12h1a4 4 0 0 0-4-4Zm0-6c5.19 0 9.456 3.953 9.952 9.012.87.1 1.548.84 1.548 1.738v4.5a1.75 1.75 0 1 1-3.5 0V12a8 8 0 1 0-16 0v5.25a1.75 1.75 0 1 1-3.5 0v-4.5a1.75 1.75 0 0 1 1.549-1.739C4.544 5.953 8.81 2 14 2Z",
    fill: "#023F80"
  })));
};

var _path$4Z;
function _extends$51() { _extends$51 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$51.apply(this, arguments); }
var SvgPollOutline = function SvgPollOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$51({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4Z || (_path$4Z = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.039 3.1H9.96c-1.017 0-1.835 0-2.497.054-.681.056-1.276.173-1.825.453a4.65 4.65 0 0 0-2.032 2.032c-.28.549-.397 1.144-.453 1.825C3.1 8.126 3.1 8.944 3.1 9.96v4.078c0 1.017 0 1.835.054 2.497.056.681.173 1.276.453 1.825a4.65 4.65 0 0 0 2.032 2.032c.549.28 1.144.397 1.825.453.662.054 1.48.054 2.497.054h4.078c1.017 0 1.835 0 2.497-.054.681-.056 1.276-.173 1.825-.453a4.65 4.65 0 0 0 2.032-2.032c.28-.55.397-1.144.453-1.825.054-.662.054-1.48.054-2.497V9.96c0-1.017 0-1.835-.054-2.497-.056-.681-.173-1.276-.453-1.825a4.65 4.65 0 0 0-2.032-2.032c-.55-.28-1.144-.397-1.825-.453-.662-.054-1.48-.054-2.497-.054ZM6.456 5.21c.253-.128.585-.215 1.154-.262C8.19 4.901 8.935 4.9 10 4.9h4c1.065 0 1.81 0 2.39.048.57.047.9.134 1.154.263.536.273.972.709 1.245 1.245.13.253.216.585.263 1.154.047.58.048 1.325.048 2.39v4c0 1.065 0 1.81-.048 2.39-.047.57-.134.9-.263 1.154a2.85 2.85 0 0 1-1.245 1.245c-.253.13-.585.216-1.154.263-.58.047-1.325.048-2.39.048h-4c-1.065 0-1.81 0-2.39-.048-.57-.047-.9-.134-1.154-.263a2.85 2.85 0 0 1-1.245-1.245c-.13-.253-.216-.585-.263-1.154-.047-.58-.048-1.325-.048-2.39v-4c0-1.065 0-1.81.048-2.39.047-.57.134-.9.263-1.154a2.85 2.85 0 0 1 1.245-1.245ZM12.9 7.9a.9.9 0 0 0-1.8 0v8.2a.9.9 0 0 0 1.8 0V7.9ZM8 10a.9.9 0 0 1 .9.9v5.2a.9.9 0 1 1-1.8 0v-5.2A.9.9 0 0 1 8 10Zm8.9 2.9a.9.9 0 0 0-1.8 0v3.2a.9.9 0 1 0 1.8 0v-3.2Z",
    fill: "#023F80"
  })));
};

var _path$4_;
function _extends$52() { _extends$52 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$52.apply(this, arguments); }
var SvgPollSquareOutline = function SvgPollSquareOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$52({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4_ || (_path$4_ = /*#__PURE__*/createElement$2("path", {
    d: "M10.692 5c-2.137 0-2.897.147-3.68.565a3.453 3.453 0 0 0-1.447 1.448C5.147 7.795 5 8.555 5 10.692v6.616c0 2.137.147 2.898.565 3.68.337.629.818 1.11 1.448 1.447.782.418 1.542.565 3.679.565h6.616c2.137 0 2.898-.147 3.68-.565a3.452 3.452 0 0 0 1.447-1.448c.418-.781.565-1.542.565-3.679v-6.616c0-2.137-.147-2.897-.565-3.68a3.452 3.452 0 0 0-1.448-1.447C20.206 5.147 19.445 5 17.308 5h-6.616Zm0-2h6.616c2.675 0 3.645.278 4.622.801A5.452 5.452 0 0 1 24.2 6.07c.522.978.801 1.948.801 4.623v6.616c0 2.675-.279 3.645-.801 4.622A5.452 5.452 0 0 1 21.93 24.2c-.977.522-1.947.801-4.622.801h-6.616c-2.675 0-3.645-.279-4.623-.801a5.452 5.452 0 0 1-2.268-2.269C3.278 20.953 3 19.983 3 17.308v-6.616c0-2.675.278-3.645.801-4.623A5.452 5.452 0 0 1 6.07 3.801C7.047 3.278 8.017 3 10.692 3ZM11 19a1 1 0 1 1-2 0v-6a1 1 0 1 1 2 0v6Zm4 0a1 1 0 1 1-2 0V9a1 1 0 1 1 2 0v10Zm4 0a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0v4Z",
    fill: "#023F80"
  })));
};

var _path$4$;
function _extends$53() { _extends$53 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$53.apply(this, arguments); }
var SvgPowerSocketOutline = function SvgPowerSocketOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$53({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4$ || (_path$4$ = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.912 3.784c-1.033-.552-2.03-.763-3.988-.784h-7.851c-1.959.02-2.955.232-3.988.784a5.543 5.543 0 0 0-2.3 2.3C3.231 7.119 3.02 8.115 3 10.074v7.851c.02 1.958.232 2.955.784 3.988a5.543 5.543 0 0 0 2.3 2.3c1.034.553 2.03.764 3.989.785h7.851c1.958-.021 2.955-.232 3.988-.785a5.543 5.543 0 0 0 2.3-2.3c.553-1.033.764-2.03.785-3.988v-7.851c-.021-1.959-.232-2.955-.785-3.988a5.543 5.543 0 0 0-2.3-2.3ZM10.408 4.998h7.18l.558.005c1.48.028 2.142.18 2.823.545.64.343 1.137.84 1.48 1.48.364.681.516 1.343.544 2.823l.005.557v7.18l-.005.558c-.028 1.48-.18 2.142-.544 2.823a3.542 3.542 0 0 1-1.48 1.48c-.681.364-1.344.516-2.823.544l-.557.005h-7.181l-.557-.005c-1.48-.028-2.142-.18-2.823-.544a3.543 3.543 0 0 1-1.48-1.48c-.364-.681-.517-1.344-.545-2.823l-.005-.557v-7.181l.005-.557c.028-1.48.18-2.142.545-2.823.343-.64.84-1.137 1.48-1.48.681-.364 1.343-.517 2.823-.545l.557-.005ZM19 14a5.002 5.002 0 0 1-4 4.9v-.1c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C14.62 18 14.48 18 14.2 18h-.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C13 18.38 13 18.52 13 18.8v.1a5.002 5.002 0 0 1 0-9.8v.1c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C15 9.62 15 9.48 15 9.2v-.1c2.282.463 4 2.481 4 4.9Zm2 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm3 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
    fill: "#023F80"
  })));
};

var _path$50;
function _extends$54() { _extends$54 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$54.apply(this, arguments); }
var SvgPrestamos1 = function SvgPrestamos1(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$54({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$50 || (_path$50 = /*#__PURE__*/createElement$2("path", {
    d: "M16.537 16.537a.857.857 0 1 1 1.212 1.212l-1.11 1.108h6.504c.44 0 .802.33.851.757l.006.1a.857.857 0 0 1-.857.857H16.64l1.108 1.108a.857.857 0 0 1 .071 1.132l-.071.08a.857.857 0 0 1-1.212 0l-2.572-2.57a.857.857 0 0 1 0-1.213l2.572-2.571Zm4.034-5.526c0-.916-.063-1.242-.242-1.577a1.48 1.48 0 0 0-.62-.62c-.335-.18-.661-.243-1.577-.243H3.43v7.847c0 .915.062 1.241.242 1.576.144.27.35.477.62.62.335.18.661.243 1.577.243h5.275a.857.857 0 0 1 0 1.714H5.868c-1.175 0-1.768-.114-2.385-.444a3.194 3.194 0 0 1-1.324-1.324c-.33-.617-.445-1.21-.445-2.385V6.857h.002V6.81c.015-.857.12-1.336.386-1.832a2.804 2.804 0 0 1 1.161-1.162c.538-.288 1.055-.388 2.055-.388h9.935c1 0 1.517.1 2.055.388.498.267.895.663 1.162 1.162.272.509.376.998.386 1.897.724.046 1.186.173 1.661.427.569.304 1.02.755 1.324 1.323.33.618.445 1.211.445 2.386v5.275a.857.857 0 0 1-1.715 0V11.01Zm-3.428 1.846a.857.857 0 0 1 0 1.714h-1.715a.857.857 0 1 1 0-1.714h1.715Zm-1.89-7.714H5.318c-.741 0-.99.048-1.246.185a1.09 1.09 0 0 0-.459.458c-.125.234-.176.464-.183 1.071h13.712c-.008-.607-.059-.837-.184-1.07a1.09 1.09 0 0 0-.458-.46c-.256-.136-.506-.184-1.247-.184Z",
    fill: "#023F80"
  })));
};

var _path$51;
function _extends$55() { _extends$55 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$55.apply(this, arguments); }
var SvgPrestamos = function SvgPrestamos(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$55({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$51 || (_path$51 = /*#__PURE__*/createElement$2("path", {
    d: "M15.363 2.572c1.679.017 2.533.198 3.419.672a4.751 4.751 0 0 1 1.971 1.971c.474.886.655 1.74.673 3.419v6.73c-.018 1.678-.199 2.532-.673 3.418a4.751 4.751 0 0 1-1.971 1.971c-.886.474-1.74.655-3.419.673h-6.73c-1.678-.018-2.532-.199-3.418-.672a4.751 4.751 0 0 1-1.971-1.972c-.474-.886-.655-1.74-.673-3.418v-6.73c.018-1.679.199-2.533.673-3.419a4.751 4.751 0 0 1 1.971-1.971c.886-.474 1.74-.655 3.419-.672h6.73Zm-.287 1.712H8.92l-.478.005c-1.268.024-1.835.154-2.42.466-.548.294-.974.72-1.268 1.269-.312.584-.443 1.152-.467 2.42l-.004.477v6.155l.004.478c.024 1.268.155 1.836.467 2.42.294.548.72.974 1.269 1.268.584.312 1.151.443 2.42.467l.477.004h6.155l.478-.004c1.268-.024 1.835-.155 2.42-.467.548-.294.974-.72 1.268-1.269.312-.583.443-1.151.467-2.42l.004-.477V8.921l-.004-.478c-.024-1.267-.155-1.835-.467-2.42a3.037 3.037 0 0 0-1.269-1.268c-.584-.312-1.151-.442-2.42-.466l-.477-.005ZM12.299 8.35a.857.857 0 0 1 1.209.093l2.571 3a.854.854 0 0 1 .006 1.108l-.006.008-2.571 3a.857.857 0 1 1-1.302-1.116l1.358-1.585H8.571a.857.857 0 1 1 0-1.714h4.993l-1.358-1.585a.857.857 0 0 1 .016-1.134l.077-.075Z",
    fill: "#023F80"
  })));
};

var _path$52;
function _extends$56() { _extends$56 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$56.apply(this, arguments); }
var SvgPrinterOutline = function SvgPrinterOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$56({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$52 || (_path$52 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2 3.1h-.035c-.53 0-.981 0-1.352.03-.389.032-.768.102-1.13.286a2.9 2.9 0 0 0-1.267 1.267c-.184.362-.254.74-.286 1.13-.029.355-.03.785-.03 1.287-.502 0-.931.001-1.287.03-.389.032-.768.102-1.13.286a2.9 2.9 0 0 0-1.267 1.267c-.184.362-.254.74-.286 1.13-.03.37-.03.822-.03 1.352v1.67c0 .53 0 .981.03 1.352.032.389.102.768.286 1.13a2.9 2.9 0 0 0 1.268 1.267c.361.184.74.254 1.13.286.354.029.784.03 1.286.03 0 .502.001.932.03 1.287.032.389.102.768.286 1.13a2.9 2.9 0 0 0 1.268 1.267c.361.184.74.254 1.13.286.37.03.82.03 1.35.03h1.671c.53 0 .982 0 1.352-.03.39-.032.768-.102 1.13-.286a2.9 2.9 0 0 0 1.267-1.267c.184-.362.254-.741.286-1.13.029-.355.03-.785.03-1.287.502 0 .932-.001 1.287-.03.39-.032.768-.102 1.13-.286a2.9 2.9 0 0 0 1.267-1.267c.184-.362.254-.741.286-1.13.03-.37.03-.822.03-1.351v-1.671c0-.53 0-.981-.03-1.352-.032-.39-.102-.768-.286-1.13a2.9 2.9 0 0 0-1.267-1.267c-.362-.184-.74-.254-1.13-.286A16.91 16.91 0 0 0 16.9 7.1c0-.502-.001-.932-.03-1.287-.032-.39-.102-.768-.286-1.13a2.9 2.9 0 0 0-1.267-1.267c-.362-.184-.74-.254-1.13-.286-.37-.03-.822-.03-1.351-.03H11.2ZM7.1 14v1.1c-.52 0-.869-.002-1.14-.024-.278-.023-.393-.062-.46-.096a1.1 1.1 0 0 1-.48-.48c-.034-.066-.073-.182-.096-.46-.023-.288-.024-.665-.024-1.24v-1.6c0-.575 0-.952.024-1.24.023-.278.062-.394.096-.46a1.1 1.1 0 0 1 .48-.48c.067-.034.182-.073.46-.096.288-.023.665-.024 1.24-.024H16.8c.575 0 .952 0 1.24.024.278.023.394.062.46.096a1.1 1.1 0 0 1 .48.48c.034.066.073.182.096.46.023.288.024.665.024 1.24v1.6c0 .575 0 .952-.024 1.24-.023.278-.062.394-.096.46a1.1 1.1 0 0 1-.48.48c-.066.034-.182.073-.46.096-.27.022-.62.024-1.14.024V14a.9.9 0 0 0-.9-.9H8a.9.9 0 0 0-.9.9Zm8-6.9c0-.52-.002-.869-.024-1.14-.023-.278-.062-.394-.096-.46a1.1 1.1 0 0 0-.48-.48c-.066-.034-.182-.073-.46-.096-.288-.023-.665-.024-1.24-.024h-1.6c-.575 0-.952 0-1.24.024-.278.023-.393.062-.46.096a1.1 1.1 0 0 0-.48.48c-.034.066-.073.182-.096.46-.022.271-.024.62-.024 1.14h6.2Zm-6.2 7.8v1.9c0 .575 0 .952.024 1.24.023.278.062.393.096.46a1.1 1.1 0 0 0 .48.48c.067.034.182.073.46.096.288.023.665.024 1.24.024h1.6c.575 0 .952 0 1.24-.024.278-.023.394-.062.46-.096a1.1 1.1 0 0 0 .48-.48c.034-.067.073-.182.096-.46.023-.288.024-.665.024-1.24v-1.9H8.9Zm8.1-4.8a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8Z",
    fill: "#023F80"
  })));
};

var _path$53;
function _extends$57() { _extends$57 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$57.apply(this, arguments); }
var SvgPrivacyOutline = function SvgPrivacyOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$57({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$53 || (_path$53 = /*#__PURE__*/createElement$2("path", {
    d: "M24.442 12.058c.513.77.588 1.831.192 2.663l-2.679 5.625C20.435 23.538 16.54 26 12.998 26H12c-4.422 0-8-3.58-8-8.009v-7.863a2.746 2.746 0 0 1 3.5-2.642v-.732a2.75 2.75 0 0 1 3.571-2.629A2.749 2.749 0 0 1 13.75 2c1.47 0 2.67 1.15 2.746 2.604A2.748 2.748 0 0 1 20 7.254v4.264c1.299-1.278 3.357-1.087 4.442.54ZM6.75 9.383a.746.746 0 0 0-.75.745v7.863A5.998 5.998 0 0 0 12 24h.998c2.773 0 5.964-2.02 7.152-4.514l2.678-5.625a.787.787 0 0 0-.05-.694c-.428-.642-1.123-.65-1.55-.01l-2.177 3.267c-.576.864-1.051.726-1.051-.323V7.255a.748.748 0 0 0-.75-.755.746.746 0 0 0-.75.747v5.757c0 .55-.448.996-1 .996-.556 0-1-.446-1-.995V4.752a.749.749 0 1 0-1.5 0v8.253c0 .54-.448.995-1 .995-.556 0-1-.446-1-.997v-6.25A.756.756 0 0 0 10.25 6a.75.75 0 0 0-.75.754v6.738c0 .551-.448 1.008-1 1.008-.556 0-1-.447-1-.999v-3.363a.751.751 0 0 0-.75-.755Z",
    fill: "#023F80"
  })));
};

var _path$54;
function _extends$58() { _extends$58 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$58.apply(this, arguments); }
var SvgQrCode = function SvgQrCode(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$58({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$54 || (_path$54 = /*#__PURE__*/createElement$2("path", {
    d: "M8.5 13a2.5 2.5 0 0 1 2.5 2.5v4A2.5 2.5 0 0 1 8.5 22h-4A2.5 2.5 0 0 1 2 19.5v-4A2.5 2.5 0 0 1 4.5 13h4ZM21 19a.5.5 0 0 1 .5.5V21a.5.5 0 0 1-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5H21Zm-5.5 0a.5.5 0 0 1 .5.5V21a.5.5 0 0 1-.5.5H14a.5.5 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5h1.5Zm-7.25-4.25h-3.5a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1Zm10 1.5a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5h1.5Zm-11 0a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5h1.5ZM21 13.5a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-.5.5h-1.5a.5.5 0 0 1-.5-.5V14a.5.5 0 0 1 .5-.5H21Zm-5.5 0a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-.5.5H14a.5.5 0 0 1-.5-.5V14a.5.5 0 0 1 .5-.5h1.5Zm4-11.5A2.5 2.5 0 0 1 22 4.5v4a2.5 2.5 0 0 1-2.5 2.5h-4A2.5 2.5 0 0 1 13 8.5v-4A2.5 2.5 0 0 1 15.5 2h4Zm-11 0A2.5 2.5 0 0 1 11 4.5v4A2.5 2.5 0 0 1 8.5 11h-4A2.5 2.5 0 0 1 2 8.5v-4A2.5 2.5 0 0 1 4.5 2h4Zm10.75 1.75h-3.5a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1Zm-11 0h-3.5a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1Zm10 1.5a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5h1.5Zm-11 0a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5h1.5Z",
    fill: "#023F80"
  })));
};

var _path$55;
function _extends$59() { _extends$59 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$59.apply(this, arguments); }
var SvgQrCodeOutline = function SvgQrCodeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$59({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$55 || (_path$55 = /*#__PURE__*/createElement$2("path", {
    d: "M9.346 15c1.27 0 1.732.132 2.196.38a2.59 2.59 0 0 1 1.077 1.078c.249.464.381.925.381 2.196v2.692c0 1.27-.132 1.732-.38 2.196a2.59 2.59 0 0 1-1.078 1.077c-.464.249-.925.381-2.196.381H6.654c-1.27 0-1.732-.132-2.196-.38a2.59 2.59 0 0 1-1.077-1.078C3.132 23.078 3 22.617 3 21.346v-2.692c0-1.27.132-1.732.38-2.196a2.59 2.59 0 0 1 1.078-1.077c.464-.249.925-.381 2.196-.381h2.692Zm14.192 7c.335 0 .456.035.578.1a.681.681 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.681.681 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.681.681 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.681.681 0 0 1 .284-.284c.122-.065.243-.1.578-.1h.576Zm-6.5 0c.335 0 .456.035.578.1a.681.681 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.681.681 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.681.681 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.681.681 0 0 1 .284-.284c.122-.065.243-.1.578-.1h.576ZM9.52 17H6.654c-.857 0-1.054.038-1.253.144a.591.591 0 0 0-.257.257c-.098.184-.138.368-.143 1.079L5 21.346c0 .857.038 1.054.144 1.253a.591.591 0 0 0 .257.257c.199.106.396.144 1.253.144h2.692c.857 0 1.054-.038 1.253-.144a.592.592 0 0 0 .257-.257c.106-.199.144-.396.144-1.253v-2.692c0-.857-.038-1.054-.144-1.253a.592.592 0 0 0-.257-.257c-.184-.098-.368-.138-1.079-.143ZM8.29 18.75c.334 0 .455.035.577.1a.681.681 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.681.681 0 0 1-.284.284c-.122.065-.243.1-.577.1H7.71c-.334 0-.455-.035-.577-.1a.681.681 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.681.681 0 0 1 .284-.284c.122-.065.243-.1.577-.1h.578Zm12 0c.334 0 .455.035.577.1a.681.681 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.681.681 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.681.681 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.681.681 0 0 1 .284-.284c.122-.065.243-.1.578-.1h.576Zm-3.25-3.25c.334 0 .455.035.577.1a.681.681 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.681.681 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.681.681 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.681.681 0 0 1 .284-.284c.122-.065.243-.1.578-.1h.576Zm6.5 0c.334 0 .455.035.577.1a.681.681 0 0 1 .284.284c.065.122.1.243.1.578v.576c0 .335-.035.456-.1.578a.681.681 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.681.681 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.578v-.576c0-.335.035-.456.1-.578a.681.681 0 0 1 .284-.284c.122-.065.243-.1.578-.1h.576ZM9.345 3c1.27 0 1.732.132 2.196.38a2.59 2.59 0 0 1 1.077 1.078c.249.464.381.925.381 2.196v2.692c0 1.27-.132 1.732-.38 2.196a2.59 2.59 0 0 1-1.078 1.077c-.464.249-.925.381-2.196.381H6.654c-1.27 0-1.732-.132-2.196-.38a2.59 2.59 0 0 1-1.077-1.078C3.132 11.078 3 10.617 3 9.346V6.654c0-1.27.132-1.732.38-2.196a2.59 2.59 0 0 1 1.078-1.077C4.922 3.132 5.383 3 6.654 3h2.692Zm12 0c1.27 0 1.732.132 2.196.38a2.59 2.59 0 0 1 1.077 1.078c.249.464.381.925.381 2.196v2.692c0 1.27-.132 1.732-.38 2.196a2.59 2.59 0 0 1-1.078 1.077c-.464.249-.925.381-2.196.381h-2.692c-1.27 0-1.732-.132-2.196-.38a2.59 2.59 0 0 1-1.077-1.078c-.249-.464-.381-.925-.381-2.196V6.654c0-1.27.132-1.732.38-2.196a2.59 2.59 0 0 1 1.078-1.077c.464-.249.925-.381 2.196-.381h2.692ZM9.52 5H6.654c-.857 0-1.054.038-1.253.144a.591.591 0 0 0-.257.257c-.098.184-.138.368-.143 1.079L5 9.346c0 .857.038 1.054.144 1.253a.591.591 0 0 0 .257.257c.199.106.396.144 1.253.144h2.692c.857 0 1.054-.038 1.253-.144a.592.592 0 0 0 .257-.257c.106-.199.144-.396.144-1.253V6.654c0-.857-.038-1.054-.144-1.253a.591.591 0 0 0-.257-.257c-.184-.098-.368-.138-1.079-.143Zm12 0h-2.866c-.857 0-1.054.038-1.253.144a.591.591 0 0 0-.257.257c-.098.184-.138.368-.143 1.079L17 9.346c0 .857.038 1.054.144 1.253a.592.592 0 0 0 .257.257c.199.106.396.144 1.253.144h2.692c.857 0 1.054-.038 1.253-.144a.592.592 0 0 0 .257-.257c.106-.199.144-.396.144-1.253V6.654c0-.857-.038-1.054-.144-1.253a.591.591 0 0 0-.257-.257c-.184-.098-.368-.138-1.079-.143ZM8.29 6.75c.334 0 .455.035.577.1a.682.682 0 0 1 .284.284c.065.122.1.243.1.577v.578c0 .334-.035.455-.1.577a.682.682 0 0 1-.284.284c-.122.065-.243.1-.577.1H7.71c-.334 0-.455-.035-.577-.1a.682.682 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.577V7.71c0-.334.035-.455.1-.577a.682.682 0 0 1 .284-.284c.122-.065.243-.1.577-.1h.578Zm12 0c.334 0 .455.035.577.1a.681.681 0 0 1 .284.284c.065.122.1.243.1.577v.578c0 .334-.035.455-.1.577a.681.681 0 0 1-.284.284c-.122.065-.243.1-.578.1h-.576c-.335 0-.456-.035-.578-.1a.681.681 0 0 1-.284-.284c-.065-.122-.1-.243-.1-.577V7.71c0-.334.035-.455.1-.577a.681.681 0 0 1 .284-.284c.122-.065.243-.1.578-.1h.576Z",
    fill: "#023F80"
  })));
};

var _path$56;
function _extends$5a() { _extends$5a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5a.apply(this, arguments); }
var SvgQuestionOutline = function SvgQuestionOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5a({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$56 || (_path$56 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.932 11.707c0-3.635 3.485-6.807 8.084-6.807 4.6 0 8.084 3.172 8.084 6.807 0 3.634-3.485 6.807-8.084 6.807a9.336 9.336 0 0 1-3.281-.586.9.9 0 0 0-1.002.26c-.678.797-1.8 1.353-3.513 1.547.197-.434.4-.9.574-1.367.289-.783.525-1.653.525-2.553a.9.9 0 0 0-.177-.537c-.773-1.04-1.21-2.265-1.21-3.571ZM12.016 3.1c-5.325 0-9.884 3.729-9.884 8.607a7.72 7.72 0 0 0 1.377 4.38c-.04.519-.187 1.07-.404 1.657a22.77 22.77 0 0 1-.662 1.55c-.077.17-.155.34-.232.513-.39.865.282 1.828 1.21 1.792 2.195-.086 4-.638 5.247-1.79a11.21 11.21 0 0 0 3.348.505c5.324 0 9.884-3.73 9.884-8.607 0-4.878-4.56-8.607-9.884-8.607ZM12 8.9a.6.6 0 0 0-.566.4.9.9 0 0 1-1.697-.6 2.4 2.4 0 0 1 4.663.8c0 1.093-.528 1.732-.922 2.174l-.012.013c-.39.439-.536.602-.572.916a.9.9 0 0 1-1.788-.206c.104-.902.62-1.47.946-1.83l.082-.09c.32-.36.466-.57.466-.977a.6.6 0 0 0-.6-.6Zm1 6.6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: "#023F80"
  })));
};

var _path$57;
function _extends$5b() { _extends$5b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5b.apply(this, arguments); }
var SvgRadiowavesLeftAndRightOutline = function SvgRadiowavesLeftAndRightOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5b({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$57 || (_path$57 = /*#__PURE__*/createElement$2("path", {
    d: "M7.491 5.698a1 1 0 0 1-.033 1.414l-.033.03-.02.02A9.468 9.468 0 0 0 4.5 14a9.468 9.468 0 0 0 2.935 6.866 1 1 0 1 1-1.383 1.446A11.468 11.468 0 0 1 2.5 14c0-3.163 1.284-6.124 3.516-8.276l.026-.025.035-.034a1 1 0 0 1 1.414.033Zm13.018 0a1 1 0 0 1 1.45 0l.026.026A11.467 11.467 0 0 1 25.5 14c0 3.18-1.299 6.157-3.552 8.312a1 1 0 0 1-1.383-1.446A9.468 9.468 0 0 0 23.5 14a9.467 9.467 0 0 0-2.904-6.837l-.021-.02-.033-.031a1 1 0 0 1-.033-1.414Zm-9.671 3.396a1 1 0 0 1-.057 1.413A4.734 4.734 0 0 0 9.25 14c0 1.345.56 2.598 1.53 3.492a1 1 0 1 1-1.356 1.47A6.733 6.733 0 0 1 7.25 14c0-1.91.799-3.694 2.175-4.963a1 1 0 0 1 1.413.057Zm6.324 0a1 1 0 0 1 1.413-.057A6.733 6.733 0 0 1 20.75 14c0 1.91-.798 3.693-2.174 4.962a1 1 0 1 1-1.356-1.47A4.734 4.734 0 0 0 18.75 14c0-1.345-.56-2.598-1.53-3.493a1 1 0 0 1-.058-1.413ZM14 11.75a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5Z",
    fill: "#023F80"
  })));
};

var _path$58, _path2$1x;
function _extends$5c() { _extends$5c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5c.apply(this, arguments); }
var SvgRecorderTapeOutline = function SvgRecorderTapeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5c({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$58 || (_path$58 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 11a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0ZM20.5 11a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z",
    fill: "#023F80"
  })), _path2$1x || (_path2$1x = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 19h-13v-2h13v2Z",
    fill: "#023F80"
  })));
};

var _path$59;
function _extends$5d() { _extends$5d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5d.apply(this, arguments); }
var SvgReceiptOutline = function SvgReceiptOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5d({
    width: 30,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$59 || (_path$59 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.473.15a1 1 0 0 1 .973-.044L11 .882l1.553-.776a1 1 0 0 1 .895 0l1.551.777 1.578-.78a1 1 0 0 1 .893.004L19 .88l1.538-.773a1 1 0 0 1 .897-.001l1.55.777 1.571-.779a1 1 0 0 1 .891.002L27 .882l1.552-.776A1 1 0 0 1 29.999 1v21a6 6 0 0 1-6 6H6c-1.248 0-2.299-.204-3.162-.638a4.415 4.415 0 0 1-1.934-1.885C.088 23.972 0 21.97 0 20.004A1.99 1.99 0 0 1 2.003 18h5.996V1a1 1 0 0 1 .474-.85ZM10 18h9a1 1 0 0 1 1 1v3a4 4 0 1 0 8 0V2.618l-.552.276a1 1 0 0 1-.894 0l-1.556-.777-1.571.779a1 1 0 0 1-.892-.002l-1.547-.775-1.538.774a1 1 0 0 1-.9 0l-1.535-.775-1.575.778a1 1 0 0 1-.891-.002l-1.55-.776-1.552.776a1 1 0 0 1-.894 0l-.553-.276V18Zm9.528 8A6 6 0 0 1 18 22v-2H2c0 2.032.123 3.529.662 4.523.25.46.587.807 1.075 1.052.503.254 1.222.425 2.263.425h13.528ZM12 7a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1Zm4 5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1Z",
    fill: "#647D96"
  })));
};

var _path$5a;
function _extends$5e() { _extends$5e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5e.apply(this, arguments); }
var SvgRefreshOutline = function SvgRefreshOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5e({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5a || (_path$5a = /*#__PURE__*/createElement$2("path", {
    d: "M12.293 1.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 1 1-1.414-1.414l1.28-1.282a8 8 0 1 0 6.393 2.66 1 1 0 1 1 1.491-1.334A9.965 9.965 0 0 1 24 14c0 5.523-4.477 10-10 10S4 19.523 4 14c0-5.386 4.259-9.778 9.593-9.992l-1.3-1.3a1 1 0 0 1 0-1.415Z",
    fill: "#023F80"
  })));
};

var _path$5b;
function _extends$5f() { _extends$5f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5f.apply(this, arguments); }
var SvgRemoveCircleOutline = function SvgRemoveCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5f({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5b || (_path$5b = /*#__PURE__*/createElement$2("path", {
    d: "M14 2c6.627 0 12 5.373 12 12s-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2Zm0 2C8.477 4 4 8.477 4 14s4.477 10 10 10 10-4.477 10-10S19.523 4 14 4Zm5 9a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h10Z",
    fill: "#023F80"
  })));
};

var _path$5c, _path2$1y;
function _extends$5g() { _extends$5g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5g.apply(this, arguments); }
var SvgRepeat1Outline = function SvgRepeat1Outline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5g({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5c || (_path$5c = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.475 9.132a.9.9 0 0 1 .429.766v4.203a.9.9 0 0 1-1.8 0v-2.74a.9.9 0 0 1-.807-1.61l1.3-.656a.9.9 0 0 1 .878.037Z",
    fill: "#023F80"
  })), _path2$1y || (_path2$1y = /*#__PURE__*/createElement$2("path", {
    d: "M2.005 12c0-3.258 2.642-5.9 5.902-5.9h10.026l-.564-.564a.9.9 0 1 1 1.273-1.272l2.1 2.1a.9.9 0 0 1 0 1.272l-2.1 2.1a.9.9 0 0 1-1.273-1.272l.564-.564H7.907A4.1 4.1 0 0 0 3.805 12v.097a.9.9 0 0 1-1.8 0V12ZM21.104 11.003a.9.9 0 0 1 .9.9V12c0 3.258-2.642 5.9-5.902 5.9H6.074l.564.564a.9.9 0 1 1-1.273 1.272l-2.101-2.1a.9.9 0 0 1 0-1.272l2.1-2.1a.9.9 0 0 1 1.274 1.272l-.564.564h10.028a4.1 4.1 0 0 0 4.102-4.1v-.097a.9.9 0 0 1 .9-.9Z",
    fill: "#023F80"
  })));
};

var _path$5d;
function _extends$5h() { _extends$5h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5h.apply(this, arguments); }
var SvgRepeatOutline = function SvgRepeatOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5h({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5d || (_path$5d = /*#__PURE__*/createElement$2("path", {
    d: "M2.005 12c0-3.258 2.642-5.9 5.902-5.9h10.026l-.564-.564a.9.9 0 1 1 1.273-1.272l2.1 2.1a.9.9 0 0 1 0 1.272l-2.1 2.1a.9.9 0 0 1-1.273-1.272l.564-.564H7.907A4.1 4.1 0 0 0 3.805 12v.097a.9.9 0 0 1-1.8 0V12ZM21.104 11.003a.9.9 0 0 1 .9.9V12c0 3.258-2.642 5.9-5.902 5.9H6.074l.564.564a.9.9 0 1 1-1.273 1.272l-2.101-2.1a.9.9 0 0 1 0-1.272l2.1-2.1a.9.9 0 0 1 1.274 1.272l-.564.564h10.028a4.1 4.1 0 0 0 4.102-4.1v-.097a.9.9 0 0 1 .9-.9Z",
    fill: "#023F80"
  })));
};

var _path$5e, _path2$1z, _path3$v;
function _extends$5i() { _extends$5i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5i.apply(this, arguments); }
var SvgReplay10Outline = function SvgReplay10Outline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5i({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5e || (_path$5e = /*#__PURE__*/createElement$2("path", {
    d: "M13.293 2.293a1 1 0 1 1 1.414 1.414l-1.3 1.301c.19-.01.4-.008.593-.008a9.972 9.972 0 0 1 7.071 2.929A9.972 9.972 0 0 1 24 15a9.972 9.972 0 0 1-2.929 7.071A9.972 9.972 0 0 1 14 25a9.972 9.972 0 0 1-7.071-2.929A9.972 9.972 0 0 1 4 15a1 1 0 1 1 2 0c0 2.21.894 4.208 2.343 5.657A7.972 7.972 0 0 0 14 23c2.21 0 4.208-.894 5.657-2.343A7.972 7.972 0 0 0 22 15c0-2.21-.894-4.208-2.343-5.657a7.972 7.972 0 0 0-6.222-2.323l1.272 1.273a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3Z",
    fill: "#023F80"
  })), _path2$1z || (_path2$1z = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 15.5c.004-2.632-1.206-3.5-2.75-3.5s-2.747.868-2.75 3.5c-.003 2.632 1.206 3.5 2.75 3.5s2.746-.868 2.75-3.5Zm-3.903.066c0-1.53.38-2.037 1.153-2.037.772 0 1.16.506 1.16 2.037 0 1.53-.381 2.036-1.16 2.036-.779 0-1.153-.506-1.153-2.036Z",
    fill: "#023F80"
  })), _path3$v || (_path3$v = /*#__PURE__*/createElement$2("path", {
    d: "M10.805 19a.438.438 0 0 1-.443-.433v-4.594l-.878.422A.353.353 0 0 1 9 14.072v-.602c0-.174.106-.33.27-.399l2.115-.965a.442.442 0 0 1 .615.399v6.062c0 .24-.198.433-.443.433h-.752Z",
    fill: "#023F80"
  })));
};

var _path$5f;
function _extends$5j() { _extends$5j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5j.apply(this, arguments); }
var SvgReplayOutline = function SvgReplayOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5j({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5f || (_path$5f = /*#__PURE__*/createElement$2("path", {
    d: "M16.808 2.62a1.143 1.143 0 0 0-1.616 0L11.763 6.05a1.143 1.143 0 0 0 0 1.616l3.429 3.429a1.143 1.143 0 1 0 1.616-1.616l-1.454-1.456a9.11 9.11 0 0 1 7.11 2.655 9.11 9.11 0 0 1 2.679 6.466 9.11 9.11 0 0 1-2.678 6.465A9.11 9.11 0 0 1 16 26.286a9.111 9.111 0 0 1-6.465-2.678 9.11 9.11 0 0 1-2.678-6.465 1.143 1.143 0 1 0-2.285 0c0 3.155 1.28 6.014 3.347 8.081A11.396 11.396 0 0 0 16 28.571c3.156 0 6.014-1.28 8.081-3.347a11.396 11.396 0 0 0 3.348-8.081c0-3.156-1.28-6.014-3.348-8.081a11.396 11.396 0 0 0-8.08-3.348c-.22 0-.462-.003-.678.01l1.485-1.487a1.143 1.143 0 0 0 0-1.617Z",
    fill: "#023F80"
  })));
};

var _path$5g;
function _extends$5k() { _extends$5k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5k.apply(this, arguments); }
var SvgReplyOutline = function SvgReplyOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5k({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5g || (_path$5g = /*#__PURE__*/createElement$2("path", {
    d: "M12.024 3.725A2.15 2.15 0 0 1 14.02 5.87l.001 2.117.02.005a9.904 9.904 0 0 1 7.827 10.721c-.083.811-1.116 1.103-1.611.455l-.187-.237a9.082 9.082 0 0 0-5.835-3.265l-.214-.026-.001 2.494a2.15 2.15 0 0 1-3.476 1.692L2.72 13.694a2.148 2.148 0 0 1 0-3.384l7.824-6.132a2.15 2.15 0 0 1 1.326-.458l.154.005ZM11.87 5.52a.35.35 0 0 0-.216.075L3.83 11.727a.35.35 0 0 0 0 .55l7.824 6.133a.35.35 0 0 0 .566-.276l.001-3.447a.9.9 0 0 1 .915-.9l.233.004.342.017a10.88 10.88 0 0 1 6.119 2.365l.174.144-.024-.135a8.103 8.103 0 0 0-6.968-6.537.9.9 0 0 1-.791-.893L12.22 5.87a.35.35 0 0 0-.35-.35Z",
    fill: "#023F80"
  })));
};

var _path$5h;
function _extends$5l() { _extends$5l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5l.apply(this, arguments); }
var SvgReportOutline = function SvgReportOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5l({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5h || (_path$5h = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.863 2.1h6.274c.674-.002 1.2.211 1.683.697l4.383 4.383c.478.476.699.998.697 1.683v6.274c.002.685-.22 1.207-.697 1.683l-4.383 4.383c-.476.478-.998.699-1.683.697H8.863c-.686.002-1.207-.22-1.683-.697L2.797 16.82c-.478-.476-.699-.998-.697-1.683V8.863c-.002-.685.22-1.207.697-1.683L7.18 2.797c.484-.486 1.009-.699 1.683-.697Zm-.445 2.005L4.105 8.418c-.18.18-.205.242-.205.495v6.174c0 .25.025.316.205.495l4.313 4.313c.179.179.24.205.495.205h6.174c.253 0 .316-.026.495-.205l4.313-4.313c.18-.18.205-.245.205-.495V8.913c0-.254-.026-.316-.205-.495l-4.313-4.313c-.18-.18-.242-.205-.495-.205H8.913c-.254 0-.319.029-.495.205ZM13 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-.1-8.1a.9.9 0 1 0-1.8 0v5.2a.9.9 0 0 0 1.8 0V7.9Z",
    fill: "#023F80"
  })));
};

var _path$5i;
function _extends$5m() { _extends$5m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5m.apply(this, arguments); }
var SvgReportes1 = function SvgReportes1(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5m({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5i || (_path$5i = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.943 2.571h2.44c.204 0 .448 0 .662.018.25.02.606.072.98.263.483.246.877.64 1.123 1.123.19.374.243.73.263.98.018.214.018.458.018.662V6.383c0 .204 0 .447-.018.662-.02.25-.072.606-.263.98-.246.483-.64.877-1.123 1.123-.374.19-.73.243-.98.263a8.452 8.452 0 0 1-.663.017h-2.479c-.204 0-.448 0-.663-.017a2.584 2.584 0 0 1-.979-.263 2.571 2.571 0 0 1-1.124-1.124 2.585 2.585 0 0 1-.263-.979c-.017-.215-.017-.458-.017-.663V5.617c0-.204 0-.448.018-.663.02-.248.072-.605.262-.979.247-.484.64-.877 1.124-1.123.374-.19.73-.243.98-.263.214-.018.458-.018.662-.018h.04Zm-1.278 2.183c-.094.183-.094.423-.094.903v.686c0 .48 0 .72.094.903a.857.857 0 0 0 .374.375c.184.093.424.093.904.093h2.4c.48 0 .72 0 .903-.093a.857.857 0 0 0 .375-.375c.093-.183.093-.423.093-.903v-.686c0-.48 0-.72-.093-.903a.857.857 0 0 0-.375-.375c-.183-.093-.423-.093-.903-.093h-2.4c-.48 0-.72 0-.904.093a.857.857 0 0 0-.374.375ZM8.057 14.57h-2.44c-.204 0-.448 0-.662.018-.25.02-.606.072-.98.263-.483.246-.877.64-1.123 1.123-.19.374-.243.73-.263.98a8.452 8.452 0 0 0-.018.662V18.383c0 .204 0 .448.018.662.02.25.072.606.263.98.246.483.64.877 1.123 1.123.374.19.73.243.98.263.214.018.458.017.662.017h2.48c.204 0 .448 0 .663-.017.249-.02.605-.072.979-.263.484-.246.877-.64 1.124-1.124.19-.373.242-.73.263-.979.017-.215.017-.458.017-.663V17.617c0-.204 0-.448-.018-.663a2.586 2.586 0 0 0-.262-.979 2.571 2.571 0 0 0-1.124-1.123 2.583 2.583 0 0 0-.98-.263 8.419 8.419 0 0 0-.662-.018h-.04Zm-3.771 3.086c0-.48 0-.72.093-.903a.857.857 0 0 1 .375-.375c.183-.093.423-.093.903-.093h2.4c.48 0 .72 0 .904.093a.857.857 0 0 1 .374.375c.094.183.094.423.094.903v.686c0 .48 0 .72-.094.903a.857.857 0 0 1-.374.375c-.184.093-.424.093-.904.093h-2.4c-.48 0-.72 0-.903-.093a.857.857 0 0 1-.375-.375c-.093-.183-.093-.423-.093-.903v-.686Zm14.057-6.514h-2.44c-.204 0-.448 0-.663.017-.249.02-.605.073-.979.263a2.57 2.57 0 0 0-1.124 1.124c-.19.373-.242.73-.263.979-.017.215-.017.459-.017.663v4.194c0 .204 0 .448.018.662.02.25.072.606.262.98.247.483.64.877 1.124 1.123.374.19.73.243.98.263.214.018.458.017.662.017h2.48c.204 0 .448 0 .662-.017.25-.02.606-.072.98-.263.483-.246.877-.64 1.123-1.124.19-.373.243-.73.263-.979.018-.215.018-.458.018-.663V14.19c0-.204 0-.448-.018-.663a2.583 2.583 0 0 0-.263-.98 2.57 2.57 0 0 0-1.123-1.123 2.583 2.583 0 0 0-.98-.263 8.467 8.467 0 0 0-.663-.017h-.04Zm-3.772 3.085c0-.48 0-.72.094-.903a.857.857 0 0 1 .374-.375c.184-.093.424-.093.904-.093h2.4c.48 0 .72 0 .903.093a.857.857 0 0 1 .375.375c.093.183.093.423.093.903v4.115c0 .48 0 .72-.093.903a.857.857 0 0 1-.375.375c-.183.093-.423.093-.903.093h-2.4c-.48 0-.72 0-.904-.093a.857.857 0 0 1-.374-.375c-.094-.183-.094-.423-.094-.903v-4.114ZM8.057 2.572h-2.44c-.204 0-.448 0-.662.018-.25.02-.606.072-.98.263-.483.246-.877.64-1.123 1.123-.19.374-.243.73-.263.98a8.453 8.453 0 0 0-.018.662v4.194c0 .204 0 .448.018.663.02.249.072.605.263.979.246.484.64.877 1.123 1.124.374.19.73.242.98.263.214.017.458.017.662.017h2.48c.204 0 .448 0 .663-.017.249-.02.605-.073.979-.263.484-.247.877-.64 1.124-1.124.19-.374.242-.73.263-.98.017-.214.017-.458.017-.662V5.617c0-.204 0-.448-.018-.663a2.585 2.585 0 0 0-.262-.979 2.571 2.571 0 0 0-1.124-1.123 2.585 2.585 0 0 0-.98-.263 8.453 8.453 0 0 0-.662-.018h-.04ZM4.286 5.657c0-.48 0-.72.093-.903a.857.857 0 0 1 .375-.375c.183-.093.423-.093.903-.093h2.4c.48 0 .72 0 .904.093a.857.857 0 0 1 .374.375c.094.183.094.423.094.903v4.114c0 .48 0 .72-.094.904a.857.857 0 0 1-.374.374c-.184.094-.424.094-.904.094h-2.4c-.48 0-.72 0-.903-.094a.857.857 0 0 1-.375-.374c-.093-.184-.093-.424-.093-.904V5.657Z",
    fill: "#023F80"
  })));
};

var _path$5j;
function _extends$5n() { _extends$5n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5n.apply(this, arguments); }
var SvgReportes = function SvgReportes(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5n({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5j || (_path$5j = /*#__PURE__*/createElement$2("path", {
    d: "M13.033 1.819c.348.08.661.21.963.399.306.19.54.391 1.022.874l4.176 4.175c.483.483.683.717.874 1.022.189.303.319.616.399.964.08.35.104.657.104 1.34v5.891c0 1.697-.159 2.52-.616 3.376a4.363 4.363 0 0 1-1.81 1.81c-.855.457-1.678.616-3.375.616H9.23c-1.697 0-2.52-.16-3.375-.617a4.362 4.362 0 0 1-1.81-1.81c-.457-.855-.616-1.678-.616-3.375v-9.57c0-1.102.198-1.992.616-2.773a4.362 4.362 0 0 1 1.81-1.81c.781-.418 1.672-.617 2.773-.617h3.065c.682 0 .99.024 1.34.105Zm-1.182 1.61H8.628c-.833 0-1.447.137-1.965.414-.479.256-.85.627-1.106 1.106-.277.518-.414 1.132-.414 1.965v9.57c0 1.438.107 1.994.414 2.567.256.48.627.85 1.106 1.107.573.306 1.13.413 2.567.413h5.54c1.438 0 1.994-.107 2.567-.413.479-.257.85-.628 1.106-1.107.307-.573.414-1.129.414-2.567v-5.89c0-.118 0-.22-.002-.309h-4.712A2.143 2.143 0 0 1 12 8.144l.001-4.712-.15-.002Zm1.955.875-.092-.091v3.93c0 .21.152.385.352.422l.077.007 3.932.001-.093-.093-4.176-4.176Z",
    fill: "#023F80"
  })));
};

var _path$5k, _path2$1A;
function _extends$5o() { _extends$5o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5o.apply(this, arguments); }
var SvgRobotOutline = function SvgRobotOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5o({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5k || (_path$5k = /*#__PURE__*/createElement$2("path", {
    d: "M10 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM9.724 15.373a.85.85 0 0 1 1.184-.205 1.878 1.878 0 0 0 1.092.345 1.888 1.888 0 0 0 1.092-.345.85.85 0 0 1 .979 1.39 3.581 3.581 0 0 1-2.07.654 3.587 3.587 0 0 1-2.072-.654.85.85 0 0 1-.205-1.185ZM14.826 12.456a.643.643 0 0 1 .649 0 .657.657 0 0 1 .108.08.85.85 0 0 0 1.134-1.267 2.346 2.346 0 0 0-3.134 0 .85.85 0 1 0 1.134 1.266.657.657 0 0 1 .109-.079Z",
    fill: "#023F80"
  })), _path2$1A || (_path2$1A = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3a2 2 0 0 1-1.1 1.787V6.1h2.338c.808 0 1.469 0 2.006.044.556.045 1.058.142 1.527.381a3.9 3.9 0 0 1 1.704 1.704c.239.47.336.971.381 1.527.044.537.044 1.198.044 2.006v3.476c0 .808 0 1.469-.044 2.006-.045.556-.142 1.058-.381 1.526a3.9 3.9 0 0 1-1.704 1.705c-.47.239-.971.336-1.527.381-.537.044-1.198.044-2.006.044H8.762c-.808 0-1.469 0-2.006-.044-.556-.045-1.058-.142-1.526-.381a3.9 3.9 0 0 1-1.705-1.705c-.239-.468-.336-.97-.381-1.526-.044-.537-.044-1.198-.044-2.006v-3.476c0-.808 0-1.469.044-2.006.045-.556.142-1.058.381-1.527A3.9 3.9 0 0 1 5.23 6.525c.468-.239.97-.336 1.526-.381C7.293 6.1 7.954 6.1 8.762 6.1H11.1V4.787A2 2 0 1 1 14 3ZM6.903 7.938c-.445.036-.683.103-.856.19a2.1 2.1 0 0 0-.918.919c-.088.172-.155.411-.191.856-.037.455-.038 1.042-.038 1.897v3.4c0 .855 0 1.442.038 1.897.036.445.103.683.191.856a2.1 2.1 0 0 0 .918.918c.173.088.411.155.856.191.455.037 1.042.038 1.897.038h6.4c.855 0 1.442 0 1.897-.038.445-.036.684-.103.856-.19a2.1 2.1 0 0 0 .918-.919c.088-.172.155-.411.191-.856.037-.455.038-1.042.038-1.897v-3.4c0-.855 0-1.442-.038-1.897-.036-.445-.103-.684-.19-.856a2.1 2.1 0 0 0-.919-.918c-.172-.088-.411-.155-.856-.191C16.642 7.9 16.055 7.9 15.2 7.9H8.8c-.855 0-1.442 0-1.897.038Z",
    fill: "#023F80"
  })));
};

var _path$5l, _path2$1B;
function _extends$5p() { _extends$5p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5p.apply(this, arguments); }
var SvgRoubleBadgeOutline = function SvgRoubleBadgeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5p({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5l || (_path$5l = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2 8.2a.9.9 0 0 1 .9-.9h3c1.602 0 2.9 1.198 2.9 2.8a2.9 2.9 0 0 1-2.9 2.9H11v1h1.886a.9.9 0 0 1 0 1.8H11v.6a.9.9 0 1 1-1.8 0v-.6h-.3a.9.9 0 0 1 0-1.8h.3v-1h-.3a.9.9 0 0 1 0-1.8h.3v-3Zm1.8 3h2.1a1.1 1.1 0 1 0 0-2.2H11v2.2Z",
    fill: "#023F80"
  })), _path2$1B || (_path2$1B = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.713 3.072a3.18 3.18 0 0 1 4.574 0l.225.233c.3.31.725.464 1.153.42l.302-.032a3.2 3.2 0 0 1 3.525 2.958l.022.303c.03.43.256.821.613 1.062l.252.17a3.2 3.2 0 0 1 .799 4.532l-.178.246a1.4 1.4 0 0 0-.213 1.208l.083.292a3.2 3.2 0 0 1-2.301 3.986l-.295.073a1.4 1.4 0 0 0-.94.789l-.123.277a3.2 3.2 0 0 1-4.325 1.574l-.272-.133a1.4 1.4 0 0 0-1.227 0l-.273.133a3.2 3.2 0 0 1-4.325-1.574l-.123-.277a1.4 1.4 0 0 0-.94-.789l-.295-.073a3.2 3.2 0 0 1-2.3-3.986l.083-.292A1.4 1.4 0 0 0 3 12.964l-.179-.246a3.2 3.2 0 0 1 .8-4.532l.251-.17a1.4 1.4 0 0 0 .613-1.062l.022-.303a3.2 3.2 0 0 1 3.525-2.958l.302.031a1.4 1.4 0 0 0 1.153-.42l.225-.232Zm3.28 1.25a1.38 1.38 0 0 0-1.985 0l-.226.233a3.2 3.2 0 0 1-2.634.96l-.302-.032a1.4 1.4 0 0 0-1.543 1.294l-.021.303A3.2 3.2 0 0 1 4.88 9.508l-.251.17a1.4 1.4 0 0 0-.35 1.983l.178.245a3.2 3.2 0 0 1 .487 2.762l-.083.292a1.4 1.4 0 0 0 1.006 1.743l.295.074a3.2 3.2 0 0 1 2.148 1.802l.123.277a1.4 1.4 0 0 0 1.892.689l.273-.133a3.2 3.2 0 0 1 2.804 0l.273.133a1.4 1.4 0 0 0 1.892-.689l.123-.277a3.2 3.2 0 0 1 2.149-1.802l.294-.074a1.4 1.4 0 0 0 1.007-1.743l-.084-.292a3.2 3.2 0 0 1 .487-2.762l.178-.245a1.4 1.4 0 0 0-.35-1.983l-.25-.17a3.2 3.2 0 0 1-1.403-2.428l-.021-.303a1.4 1.4 0 0 0-1.543-1.294l-.301.031a3.2 3.2 0 0 1-2.635-.959l-.226-.233Z",
    fill: "#023F80"
  })));
};

var _path$5m, _path2$1C;
function _extends$5q() { _extends$5q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5q.apply(this, arguments); }
var SvgRssFeedOutline = function SvgRssFeedOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5q({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5m || (_path$5m = /*#__PURE__*/createElement$2("path", {
    d: "M6.85 6c-.268 0-.534.007-.798.02a1 1 0 1 1-.104-1.997c.299-.015.6-.023.902-.023C16.322 4 24 11.678 24 21.15c0 .302-.008.603-.023.902a1 1 0 0 1-1.998-.104c.014-.264.02-.53.02-.798C22 12.783 15.218 6 6.85 6ZM6.165 16.07a5 5 0 0 1 5.765 5.765 1 1 0 0 0 1.973.33 7 7 0 0 0-8.069-8.069 1 1 0 0 0 .331 1.973ZM9 21a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
    fill: "#023F80"
  })), _path2$1C || (_path2$1C = /*#__PURE__*/createElement$2("path", {
    d: "M6.09 11.04c.3-.026.603-.04.91-.04 5.523 0 10 4.477 10 10 0 .307-.014.61-.04.91a1 1 0 0 0 1.991.18c.032-.36.049-.723.049-1.09 0-6.627-5.373-12-12-12-.367 0-.73.017-1.09.049a1 1 0 0 0 .18 1.992Z",
    fill: "#023F80"
  })));
};

var _path$5n, _path2$1D, _path3$w, _path4$5;
function _extends$5r() { _extends$5r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5r.apply(this, arguments); }
var SvgRssVideoOutline = function SvgRssVideoOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5r({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5n || (_path$5n = /*#__PURE__*/createElement$2("path", {
    d: "M13.6 5h.8c1.713 0 2.878.002 3.778.075.877.072 1.325.202 1.638.361a4 4 0 0 1 1.748 1.748c.16.313.29.761.36 1.638.075.9.076 2.065.076 3.778v2.8c0 1.713-.002 2.878-.075 3.778-.072.877-.201 1.325-.36 1.638a4 4 0 0 1-1.749 1.748c-.224.114-.518.213-.989.287a1 1 0 1 0 .36 1.968c.596-.097 1.09-.246 1.537-.473a6 6 0 0 0 2.622-2.622C24 20.44 24 18.76 24 15.4v-2.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C19.44 3 17.76 3 14.4 3h-.8c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622c-.458.9-.595 1.994-.636 3.724h.002v.02a1 1 0 1 0 1.999-.05c.01-.43.028-.808.056-1.148.072-.877.202-1.325.361-1.638a4 4 0 0 1 1.748-1.748c.313-.16.761-.29 1.638-.36.9-.074 2.065-.076 3.778-.076Z",
    fill: "#023F80"
  })), _path2$1D || (_path2$1D = /*#__PURE__*/createElement$2("path", {
    d: "M8.65 8.291c-.05.15-.05.337-.05.709 0 .372 0 .558.05.709a1 1 0 0 0 .641.642c.15.049.337.049.71.049.371 0 .558 0 .708-.049a1 1 0 0 0 .642-.642c.05-.15.05-.337.05-.709 0-.372 0-.558-.05-.709a1 1 0 0 0-.642-.642C10.56 7.6 10.372 7.6 10 7.6c-.372 0-.558 0-.709.049a1 1 0 0 0-.642.642ZM16.65 8.291c-.05.15-.05.337-.05.709 0 .372 0 .558.05.709a1 1 0 0 0 .641.642c.15.049.337.049.71.049.371 0 .557 0 .708-.049a1 1 0 0 0 .642-.642c.05-.15.05-.337.05-.709 0-.372 0-.558-.05-.709a1 1 0 0 0-.642-.642C18.56 7.6 18.372 7.6 18 7.6c-.372 0-.558 0-.709.049a1 1 0 0 0-.642.642ZM16.65 13.291c-.05.15-.05.337-.05.709 0 .372 0 .558.05.709a1 1 0 0 0 .641.642c.15.049.337.049.71.049.371 0 .557 0 .708-.049a1 1 0 0 0 .642-.642c.05-.15.05-.337.05-.709 0-.372 0-.558-.05-.709a1 1 0 0 0-.642-.642c-.15-.049-.337-.049-.709-.049-.372 0-.558 0-.709.049a1 1 0 0 0-.642.642ZM16.6 19c0-.372 0-.558.05-.709a1 1 0 0 1 .641-.642c.15-.049.337-.049.71-.049.371 0 .557 0 .708.049a1 1 0 0 1 .642.642c.05.15.05.337.05.709 0 .372 0 .558-.05.709a1 1 0 0 1-.642.642c-.15.049-.337.049-.709.049-.372 0-.558 0-.709-.049a1 1 0 0 1-.642-.642c-.049-.15-.049-.337-.049-.709ZM5.09 15.033a8.167 8.167 0 0 1 8.877 8.877 1 1 0 0 0 1.992.18c.027-.305.041-.612.041-.923C16 17.552 11.448 13 5.833 13c-.31 0-.618.014-.923.041a1 1 0 0 0 .18 1.992Z",
    fill: "#023F80"
  })), _path3$w || (_path3$w = /*#__PURE__*/createElement$2("path", {
    d: "M5.857 19c-.236 0-.467.02-.691.057a1 1 0 1 1-.331-1.972 6.143 6.143 0 0 1 7.08 7.08 1 1 0 0 1-1.972-.33A4.143 4.143 0 0 0 5.857 19Z",
    fill: "#023F80"
  })), _path4$5 || (_path4$5 = /*#__PURE__*/createElement$2("path", {
    d: "M6 25a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "#023F80"
  })));
};

var _path$5o, _path2$1E;
function _extends$5s() { _extends$5s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5s.apply(this, arguments); }
var SvgSadFaceOutline = function SvgSadFaceOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5s({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5o || (_path$5o = /*#__PURE__*/createElement$2("path", {
    d: "M15.562 16.303a.9.9 0 0 1-1.259-.133 2.487 2.487 0 0 0-.53-.432A3.295 3.295 0 0 0 12 15.25c-.803 0-1.39.249-1.773.488-.191.12-.381.26-.53.432a.9.9 0 0 1-1.4-1.132c.273-.329.616-.601.976-.826A5.094 5.094 0 0 1 12 13.45c1.197 0 2.11.376 2.727.762.36.224.706.497.976.826a.9.9 0 0 1-.14 1.265ZM10.25 10.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM15 11.5A1.25 1.25 0 1 0 15 9a1.25 1.25 0 0 0 0 2.5Z",
    fill: "#023F80"
  })), _path2$1E || (_path2$1E = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.1c-5.468 0-9.9 4.432-9.9 9.9s4.432 9.9 9.9 9.9 9.9-4.432 9.9-9.9-4.432-9.9-9.9-9.9ZM3.9 12a8.1 8.1 0 1 1 16.2 0 8.1 8.1 0 0 1-16.2 0Z",
    fill: "#023F80"
  })));
};

var _path$5p;
function _extends$5t() { _extends$5t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5t.apply(this, arguments); }
var SvgScanViewfinderOutline = function SvgScanViewfinderOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5t({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5p || (_path$5p = /*#__PURE__*/createElement$2("path", {
    d: "M21 16.1a.9.9 0 0 1 .893.787L21.9 17v.43c0 1.082-.148 1.788-.507 2.46a3.626 3.626 0 0 1-1.503 1.503c-.61.326-1.25.478-2.174.503l-.287.004H17a.9.9 0 0 1-.113-1.793L17 20.1h.43c.806 0 1.224-.088 1.61-.294.333-.178.588-.433.766-.765.188-.351.277-.73.292-1.4l.002-.211V17a.9.9 0 0 1 .9-.9Zm-18 0a.9.9 0 0 1 .893.787L3.9 17v.43c0 .806.088 1.224.294 1.61.178.333.433.588.765.766.351.188.73.277 1.4.292l.212.002H7a.9.9 0 0 1 .113 1.793L7 21.9h-.43c-1.083 0-1.788-.148-2.46-.507a3.626 3.626 0 0 1-1.503-1.503c-.326-.61-.478-1.25-.503-2.174l-.004-.287V17a.9.9 0 0 1 .9-.9Zm14-2.7a.9.9 0 0 1 .893.787l.007.113v.384c0 .705-.114 1.232-.373 1.717a2.717 2.717 0 0 1-1.126 1.125c-.425.228-.88.343-1.46.369l-.257.005H9.316c-.705 0-1.232-.114-1.717-.373A2.717 2.717 0 0 1 6.473 16.4c-.227-.425-.342-.88-.368-1.46l-.005-.257V14.3a.9.9 0 0 1 1.793-.113l.007.113v.384c0 .426.051.664.16.868.091.17.218.297.388.387.175.094.375.145.696.158l.172.003h5.368c.426 0 .664-.051.868-.16a.917.917 0 0 0 .387-.388c.094-.175.145-.375.158-.696l.003-.172V14.3a.9.9 0 0 1 .9-.9Zm-2.564-7.3c.949 0 1.447.096 1.965.374.483.258.867.642 1.125 1.125.255.475.357.933.372 1.737l.002.228-.001.535 2.201.001a.9.9 0 0 1 0 1.8H3.9a.9.9 0 1 1 0-1.8l2.199-.001.001-.535c0-.949.096-1.447.373-1.965A2.717 2.717 0 0 1 7.6 6.474c.475-.255.933-.357 1.737-.372l.228-.002h4.872Zm0 1.8H9.564c-.677 0-.894.042-1.116.16a.918.918 0 0 0-.387.388c-.096.18-.142.355-.156.774l-.005.342-.001.535h8.2l.001-.535-.004-.327c-.014-.43-.06-.608-.157-.79a.917.917 0 0 0-.387-.386c-.18-.096-.355-.142-.774-.156l-.342-.005ZM7 2.1a.9.9 0 0 1 .113 1.793l-.113.007H6.57c-.806 0-1.225.088-1.61.294a1.826 1.826 0 0 0-.766.765c-.188.351-.277.73-.292 1.4L3.9 7a.9.9 0 0 1-1.793.113L2.1 7v-.43c0-1.083.148-1.788.507-2.46A3.626 3.626 0 0 1 4.11 2.607c.61-.326 1.25-.478 2.174-.503L6.57 2.1H7Zm10.43 0c1.084 0 1.79.148 2.46.507a3.626 3.626 0 0 1 1.504 1.503c.326.61.478 1.25.503 2.174l.004.287V7a.9.9 0 0 1-1.793.113L20.1 7v-.43c0-.806-.088-1.224-.294-1.61a1.825 1.825 0 0 0-.765-.766c-.351-.187-.73-.277-1.401-.292L17 3.9a.9.9 0 0 1-.113-1.793L17 2.1h.43Z",
    fill: "#023F80"
  })));
};

var _path$5q;
function _extends$5u() { _extends$5u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5u.apply(this, arguments); }
var SvgSchoolOutline = function SvgSchoolOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5u({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5q || (_path$5q = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.637 6.104a2 2 0 0 0-1.274 0c-.17.057-.38.177-.724.483-.353.314-.774.754-1.39 1.402l-3.525 3.7A1 1 0 0 1 7 12H4v7c0 .717 0 1.194.03 1.56.03.356.081.518.133.621a1.5 1.5 0 0 0 .656.655c.103.053.265.104.62.133C5.806 22 6.283 22 7 22h3.5v-3.5a3.5 3.5 0 1 1 7 0V22H21c.717 0 1.194 0 1.56-.03.356-.03.518-.081.621-.133a1.5 1.5 0 0 0 .655-.656c.053-.103.104-.265.133-.62C24 20.194 24 19.717 24 19v-7h-3a1 1 0 0 1-.724-.31l-3.524-3.7c-.617-.649-1.038-1.09-1.39-1.403-.345-.306-.555-.426-.725-.483ZM15.5 18.5V22h-3v-3.5a1.5 1.5 0 0 1 3 0ZM7 24h14.04c.666 0 1.226 0 1.683-.037.48-.04.934-.124 1.366-.345a3.5 3.5 0 0 0 1.53-1.529c.22-.432.305-.887.344-1.366.037-.457.037-1.017.037-1.683V10.96c0-.666 0-1.226-.037-1.683-.04-.48-.124-.934-.345-1.366a3.5 3.5 0 0 0-1.529-1.53c-.432-.22-.887-.305-1.366-.344C22.266 6 21.706 6 21.04 6h-3.423a17.647 17.647 0 0 0-.927-.908c-.438-.389-.883-.705-1.417-.884a4 4 0 0 0-2.546 0c-.534.18-.98.495-1.417.884-.28.25-.584.554-.927.908H6.96c-.666 0-1.226 0-1.683.037-.48.04-.934.124-1.366.344a3.5 3.5 0 0 0-1.53 1.53c-.22.432-.304.887-.344 1.366C2 9.734 2 10.294 2 10.96V19.04c0 .666 0 1.226.037 1.683.04.48.124.934.344 1.366a3.5 3.5 0 0 0 1.53 1.53c.432.22.887.305 1.366.344C5.734 24 6.294 24 6.96 24H7Zm16.994-14a9.244 9.244 0 0 0-.025-.56c-.029-.356-.08-.518-.133-.621a1.5 1.5 0 0 0-.655-.656c-.103-.052-.265-.103-.62-.132C22.194 8 21.717 8 21 8h-1.476l1.905 2h2.565ZM8.476 8H7c-.717 0-1.194 0-1.56.03-.356.03-.518.081-.621.133a1.5 1.5 0 0 0-.656.656c-.052.103-.103.265-.132.62-.013.162-.021.345-.025.561H6.57l1.905-2ZM14 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
    fill: "#023F80"
  })));
};

var _path$5r;
function _extends$5v() { _extends$5v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5v.apply(this, arguments); }
var SvgScreenGridHorizon2LineOutline = function SvgScreenGridHorizon2LineOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5v({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5r || (_path$5r = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.357 2H15.643c1.084 0 1.958 0 2.666.058.729.06 1.369.185 1.961.487a5 5 0 0 1 2.185 2.185c.302.592.428 1.233.487 1.961C23 7.4 23 8.273 23 9.357V18.643c0 1.084 0 1.958-.058 2.666-.06.729-.185 1.369-.487 1.961a5 5 0 0 1-2.185 2.185c-.592.302-1.232.428-1.961.487C17.6 26 16.727 26 15.643 26H12.357c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.961-.487a5 5 0 0 1-2.185-2.185c-.302-.592-.428-1.232-.487-1.961C5 20.6 5 19.727 5 18.643V9.357c0-1.084 0-1.958.058-2.666.06-.728.185-1.369.487-1.96A5 5 0 0 1 7.73 2.544c.592-.302 1.233-.428 1.961-.487C10.4 2 11.273 2 12.357 2ZM9.854 4.051c-.605.05-.953.142-1.216.276a3 3 0 0 0-1.311 1.311c-.134.263-.226.611-.276 1.216C7.001 7.471 7 8.264 7 9.4v.1h14v-.1c0-1.137 0-1.929-.051-2.546-.05-.605-.142-.953-.276-1.216a3 3 0 0 0-1.311-1.311c-.263-.134-.611-.226-1.216-.276C17.529 4.001 16.736 4 15.6 4h-3.2c-1.137 0-1.929 0-2.546.051ZM21 11.5H7v5h14v-5ZM7 18.6v-.1h14v.1c0 1.137 0 1.929-.051 2.546-.05.605-.142.953-.276 1.216a3 3 0 0 1-1.311 1.311c-.263.134-.611.226-1.216.276-.617.05-1.41.051-2.546.051h-3.2c-1.137 0-1.929 0-2.546-.051-.605-.05-.953-.142-1.216-.276a3 3 0 0 1-1.311-1.311c-.134-.263-.226-.611-.276-1.216C7.001 20.529 7 19.736 7 18.6Z",
    fill: "#023F80"
  })));
};

var _path$5s;
function _extends$5w() { _extends$5w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5w.apply(this, arguments); }
var SvgScreenGridHorizonLineOutline = function SvgScreenGridHorizonLineOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5w({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5s || (_path$5s = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4 2h-.043c-1.084 0-1.958 0-2.666.058-.728.06-1.369.185-1.961.487A5 5 0 0 0 5.545 4.73c-.302.592-.428 1.233-.487 1.961C5 7.4 5 8.273 5 9.357V18.643c0 1.084 0 1.958.058 2.666.06.729.185 1.369.487 1.961a5 5 0 0 0 2.185 2.185c.592.302 1.233.428 1.961.487.708.058 1.582.058 2.666.058H15.643c1.084 0 1.958 0 2.666-.058.729-.06 1.369-.185 1.961-.487a5 5 0 0 0 2.185-2.185c.302-.592.428-1.232.487-1.961C23 20.6 23 19.727 23 18.643V9.357c0-1.084 0-1.958-.058-2.666-.06-.728-.185-1.369-.487-1.96a5 5 0 0 0-2.185-2.186c-.592-.302-1.232-.428-1.961-.487C17.6 2 16.727 2 15.643 2H12.4ZM8.638 4.327c.263-.134.611-.226 1.216-.276.617-.05 1.41-.051 2.546-.051h3.2c1.137 0 1.929 0 2.546.051.605.05.953.142 1.216.276a3 3 0 0 1 1.311 1.311c.134.263.226.611.276 1.216.05.617.051 1.41.051 2.546V13H7V9.4c0-1.137 0-1.929.051-2.546.05-.605.142-.953.276-1.216a3 3 0 0 1 1.311-1.311ZM7 15v3.6c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051h3.2c1.137 0 1.929 0 2.546-.051.605-.05.953-.142 1.216-.276a3 3 0 0 0 1.311-1.311c.134-.263.226-.611.276-1.216.05-.617.051-1.41.051-2.546V15H7Z",
    fill: "#023F80"
  })));
};

var _path$5t;
function _extends$5x() { _extends$5x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5x.apply(this, arguments); }
var SvgScreenGridTileOutline = function SvgScreenGridTileOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5x({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5t || (_path$5t = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.357 2h3.286c1.084 0 1.958 0 2.666.058.729.06 1.369.185 1.961.487a5 5 0 0 1 2.185 2.185c.302.592.428 1.233.487 1.961C23 7.4 23 8.273 23 9.357v9.286c0 1.084 0 1.958-.058 2.666-.06.729-.185 1.369-.487 1.961a5 5 0 0 1-2.185 2.185c-.592.302-1.232.428-1.961.487C17.6 26 16.727 26 15.643 26h-3.286c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.961-.487a5 5 0 0 1-2.185-2.185c-.302-.592-.428-1.232-.487-1.961C5 20.6 5 19.727 5 18.643V9.357c0-1.084 0-1.958.058-2.666.06-.728.185-1.369.487-1.96A5 5 0 0 1 7.73 2.544c.592-.302 1.233-.428 1.961-.487C10.4 2 11.273 2 12.357 2ZM9.854 4.051c-.605.05-.953.142-1.216.276a3 3 0 0 0-1.311 1.311c-.134.263-.226.611-.276 1.216C7.001 7.471 7 8.264 7 9.4V13h6V4h-.6c-1.137 0-1.929 0-2.546.051ZM15 4v9h6V9.4c0-1.137 0-1.929-.051-2.546-.05-.605-.142-.953-.276-1.216a3 3 0 0 0-1.311-1.311c-.263-.134-.611-.226-1.216-.276C17.529 4.001 16.736 4 15.6 4H15Zm-2 11H7v3.6c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051h.6v-9Zm2 9v-9h6v3.6c0 1.137 0 1.929-.051 2.546-.05.605-.142.953-.276 1.216a3 3 0 0 1-1.311 1.311c-.263.134-.611.226-1.216.276-.617.05-1.41.051-2.546.051H15Z",
    fill: "#023F80"
  })));
};

var _path$5u;
function _extends$5y() { _extends$5y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5y.apply(this, arguments); }
var SvgScreenGridVerticalLineOutline = function SvgScreenGridVerticalLineOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5y({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5u || (_path$5u = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4 2h-.043c-1.084 0-1.958 0-2.666.058-.728.06-1.369.185-1.961.487A5 5 0 0 0 5.545 4.73c-.302.592-.428 1.233-.487 1.961C5 7.4 5 8.273 5 9.357V18.643c0 1.084 0 1.958.058 2.666.06.729.185 1.369.487 1.961a5 5 0 0 0 2.185 2.185c.592.302 1.233.428 1.961.487.708.058 1.582.058 2.666.058H15.643c1.084 0 1.958 0 2.666-.058.729-.06 1.369-.185 1.961-.487a5 5 0 0 0 2.185-2.185c.302-.592.428-1.232.487-1.961C23 20.6 23 19.727 23 18.643V9.357c0-1.084 0-1.958-.058-2.666-.06-.728-.185-1.369-.487-1.96a5 5 0 0 0-2.185-2.186c-.592-.302-1.232-.428-1.961-.487C17.6 2 16.727 2 15.643 2H12.4ZM8.638 4.327c.263-.134.611-.226 1.216-.276.617-.05 1.41-.051 2.546-.051h.6v20h-.6c-1.137 0-1.929 0-2.546-.051-.605-.05-.953-.142-1.216-.276a3 3 0 0 1-1.311-1.311c-.134-.263-.226-.611-.276-1.216C7.001 20.529 7 19.736 7 18.6V9.4c0-1.137 0-1.929.051-2.546.05-.605.142-.953.276-1.216a3 3 0 0 1 1.311-1.311ZM15 24h.6c1.137 0 1.929 0 2.546-.051.605-.05.953-.142 1.216-.276a3 3 0 0 0 1.311-1.311c.134-.263.226-.611.276-1.216.05-.617.051-1.41.051-2.546V9.4c0-1.137 0-1.929-.051-2.546-.05-.605-.142-.953-.276-1.216a3 3 0 0 0-1.311-1.311c-.263-.134-.611-.226-1.216-.276C17.529 4.001 16.736 4 15.6 4H15v20Z",
    fill: "#023F80"
  })));
};

var _path$5v, _path2$1F, _path3$x;
function _extends$5z() { _extends$5z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5z.apply(this, arguments); }
var SvgScreencastOutline = function SvgScreencastOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5z({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5v || (_path$5v = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.857 18c-.236 0-.467.02-.692.057a1 1 0 1 1-.33-1.972 6.143 6.143 0 0 1 7.08 7.08 1 1 0 0 1-1.972-.33A4.143 4.143 0 0 0 3.857 18Z",
    fill: "#023F80"
  })), _path2$1F || (_path2$1F = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 24a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM3.833 14c-.25 0-.499.011-.743.033a1 1 0 1 1-.18-1.992c.304-.027.612-.041.923-.041C9.448 12 14 16.552 14 22.167c0 .31-.014.618-.041.923a1 1 0 0 1-1.992-.18A8.167 8.167 0 0 0 3.834 14Z",
    fill: "#023F80"
  })), _path3$x || (_path3$x = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.956 4h6.088c1.363 0 2.447 0 3.321.071.896.074 1.66.227 2.359.583a6 6 0 0 1 2.622 2.622c.356.7.51 1.463.582 2.359.072.874.072 1.958.072 3.321v2.088c0 1.363 0 2.447-.072 3.321-.073.896-.226 1.66-.582 2.359a6 6 0 0 1-2.622 2.622c-.7.356-1.463.51-2.359.583-.874.071-1.958.071-3.321.071H17a1 1 0 1 1 0-2c1.416 0 2.419 0 3.202-.065.772-.063 1.243-.182 1.614-.371a4 4 0 0 0 1.748-1.748c.189-.37.308-.841.371-1.613C24 17.419 24 16.417 24 15v-2c0-1.417 0-2.419-.065-3.203-.063-.771-.182-1.243-.371-1.613a4 4 0 0 0-1.748-1.748c-.37-.189-.842-.308-1.614-.371C19.42 6 18.416 6 17 6h-6c-1.417 0-2.42 0-3.203.065-1.775.145-3.35 1.222-3.657 3.097a1 1 0 1 1-1.974-.324c.296-1.805 1.479-3.353 3.11-4.184.7-.356 1.463-.51 2.358-.583C8.51 4 9.594 4 10.956 4Z",
    fill: "#023F80"
  })));
};

var _path$5w;
function _extends$5A() { _extends$5A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5A.apply(this, arguments); }
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5A({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5w || (_path$5w = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.143 3.428a7.714 7.714 0 1 0 4.815 13.742l4.007 4.007a.857.857 0 1 0 1.212-1.212l-4.007-4.007a7.714 7.714 0 0 0-6.027-12.53Zm0 1.715a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z",
    fill: "#023F80"
  })));
};

var _path$5x, _path2$1G;
function _extends$5B() { _extends$5B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5B.apply(this, arguments); }
var SvgSearchLikeFilledOutline = function SvgSearchLikeFilledOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5B({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5x || (_path$5x = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.9C12 4.733 13.775 3 15.922 3c.973 0 1.834.336 2.573.937.738-.603 1.603-.937 2.583-.937C23.225 3 25 4.733 25 6.9c0 1.127-.306 2.018-1.031 2.916-.665.824-1.694 1.662-3.076 2.743l-.003.002-1.428 1.11c-.566.439-1.358.439-1.924 0l-1.428-1.11-.003-.002c-1.382-1.081-2.41-1.92-3.076-2.743C12.306 8.918 12 8.027 12 6.9Z",
    fill: "#023F80"
  })), _path2$1G || (_path2$1G = /*#__PURE__*/createElement$2("path", {
    d: "M9.549 6.908A1 1 0 0 0 8.56 5.17a9 9 0 1 0 10.057 14.862l4.675 4.676a1 1 0 0 0 1.414-1.414l-4.675-4.675c.356-.446.671-.927.94-1.436a1 1 0 1 0-1.771-.93 7 7 0 1 1-9.652-9.343Z",
    fill: "#023F80"
  })));
};

var _path$5y, _path2$1H, _path3$y, _path4$6;
function _extends$5C() { _extends$5C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5C.apply(this, arguments); }
var SvgSearchLikeOutline = function SvgSearchLikeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5C({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5y || (_path$5y = /*#__PURE__*/createElement$2("path", {
    d: "M15.922 4C14.318 4 13 5.295 13 6.9c0 1.802.917 2.675 3.723 4.871l1.429 1.11a.569.569 0 0 0 .696 0l1.43-1.11C23.082 9.575 24 8.703 24 6.901 24 5.294 22.682 4 21.078 4c-.993 0-1.852.45-2.578 1.352C17.759 4.45 16.9 4 15.922 4Z",
    stroke: "#023F80",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2$1H || (_path2$1H = /*#__PURE__*/createElement$2("path", {
    d: "M9.055 6.039a8 8 0 1 0 11.031 10.678M19 19l5 5",
    stroke: "#023F80",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3$y || (_path3$y = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.9C12 4.733 13.775 3 15.922 3c.973 0 1.834.336 2.573.937.738-.603 1.603-.937 2.583-.937C23.225 3 25 4.733 25 6.9c0 1.127-.306 2.018-1.031 2.916-.665.824-1.694 1.662-3.076 2.743l-.003.002-1.428 1.11c-.566.439-1.358.439-1.924 0l-1.428-1.11-.003-.002c-1.382-1.081-2.41-1.92-3.076-2.743C12.306 8.918 12 8.027 12 6.9ZM15.922 5A1.915 1.915 0 0 0 14 6.9c0 .675.152 1.122.587 1.66.495.612 1.327 1.308 2.75 2.423l.002.001 1.161.901 1.16-.901.002-.001c1.424-1.115 2.257-1.811 2.751-2.423.434-.538.587-.985.587-1.66 0-1.043-.86-1.9-1.922-1.9-.639 0-1.228.27-1.8.979a1 1 0 0 1-1.55.008C17.136 5.267 16.542 5 15.922 5Z",
    fill: "#023F80"
  })), _path4$6 || (_path4$6 = /*#__PURE__*/createElement$2("path", {
    d: "M9.549 6.908A1 1 0 0 0 8.56 5.17a9 9 0 1 0 10.057 14.862l4.675 4.676a1 1 0 0 0 1.414-1.414l-4.675-4.675c.356-.446.671-.927.94-1.436a1 1 0 1 0-1.771-.93 7 7 0 1 1-9.652-9.343Z",
    fill: "#023F80"
  })));
};

var _path$5z;
function _extends$5D() { _extends$5D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5D.apply(this, arguments); }
var SvgSearchOutline = function SvgSearchOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5D({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5z || (_path$5z = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 3.5a7.25 7.25 0 1 0 4.45 12.974l4.264 4.262a.9.9 0 1 0 1.272-1.272L16.474 15.2A7.25 7.25 0 0 0 10.75 3.5Zm0 1.8a5.45 5.45 0 1 0 0 10.9 5.45 5.45 0 0 0 0-10.9Z",
    fill: "#023F80"
  })));
};

var _path$5A;
function _extends$5E() { _extends$5E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5E.apply(this, arguments); }
var SvgSearchSlashOutline = function SvgSearchSlashOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5E({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5A || (_path$5A = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 5.3c-.35 0-.69.033-1.02.095a.9.9 0 0 1-.334-1.769 7.25 7.25 0 0 1 8.476 8.485.9.9 0 1 1-1.768-.336A5.45 5.45 0 0 0 10.75 5.3ZM3.5 10.75a7.25 7.25 0 0 0 11.7 5.724l4.264 4.262a.9.9 0 1 0 1.272-1.272l-16.2-16.2a.9.9 0 1 0-1.273 1.272L5.026 6.3A7.222 7.222 0 0 0 3.5 10.75Zm1.8 0a5.45 5.45 0 0 0 8.615 4.438L6.312 7.585A5.422 5.422 0 0 0 5.3 10.75Z",
    fill: "#023F80"
  })));
};

var _path$5B;
function _extends$5F() { _extends$5F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5F.apply(this, arguments); }
var SvgSendOutline = function SvgSendOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5F({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5B || (_path$5B = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.891 9.77c-.562-1.438-.959-2.555-1.135-3.273l-.076-.305c-.077-.31-.154-.618-.204-.862a4.4 4.4 0 0 1-.086-.6 2.303 2.303 0 0 1 .154-1.018 1.958 1.958 0 0 1 1.363-1.17 2.249 2.249 0 0 1 1.123.035c.413.114.857.343 1.22.537 1.04.557 5.078 2.674 8.151 4.284a3125.741 3125.741 0 0 1 3.493 1.832c.498.262.962.505 1.298.715.193.121.453.296.682.529.22.223.61.701.639 1.42.03.746-.346 1.265-.584 1.521a3.44 3.44 0 0 1-.686.552c-.313.197-.744.424-1.19.659l-.256.135c-.461.243-1.338.708-2.415 1.279-3.115 1.65-7.907 4.19-9.153 4.837-.391.202-.847.43-1.254.544a2.242 2.242 0 0 1-1.152.032 1.943 1.943 0 0 1-1.379-1.3c-.14-.434-.1-.828-.081-.991.024-.206.069-.407.107-.566.037-.154.082-.326.126-.492l.009-.034c.048-.183.099-.376.151-.588.174-.707.564-1.814 1.118-3.242a4.894 4.894 0 0 1 1.771-2.245 4.893 4.893 0 0 1-1.754-2.224Zm4.194 1.312.372.074.32.064.3.06c.93.187 1.403.296 1.507.466a.501.501 0 0 1-.002.523c-.105.169-.579.274-1.509.456a187.113 187.113 0 0 1-1.12.215c-1.099.202-2.01.942-2.4 1.951-.49 1.261-.82 2.193-.989 2.793a7.055 7.055 0 0 0-.06.228l-.003.012c-.058.234-.113.445-.163.632-.333 1.264-.389 1.475 1.062.723l.466-.244.24-.126c1.826-.958 5.735-3.03 8.418-4.451l2.431-1.289.327-.172.016-.008c.936-.493 1.414-.75 1.416-1.013.003-.26-.462-.523-1.411-1.023a1.44 1.44 0 0 1-.017-.009l-.457-.24c-.604-.318-1.817-.954-3.242-1.7C12 7.648 8.716 5.927 7.113 5.08A308.858 308.858 0 0 1 6.4 4.7c-1.428-.764-1.361-.499-.983 1.018l.087.35.003.013a6.95 6.95 0 0 0 .057.214c.172.608.506 1.548 1.003 2.82.393 1.006 1.301 1.742 2.397 1.944l.121.023Z",
    fill: "#023F80"
  })));
};

var _path$5C;
function _extends$5G() { _extends$5G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5G.apply(this, arguments); }
var SvgServicesGibdd = function SvgServicesGibdd(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5G({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5C || (_path$5C = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.96 2h-.03c-.422 0-.785 0-1.086.02-.317.02-.634.066-.948.19A3 3 0 0 0 8.21 3.897c-.125.314-.17.631-.191.948-.004.05-.006.102-.009.156H6.316c-.279 0-.536 0-.739.013h-.003c-.156.01-.528.035-.844.255a1.5 1.5 0 0 0-.552 1.75c.134.362.424.595.546.693l.002.002c.158.127.37.275.598.435l.026.017L8 10.021V11H6.316c-.279 0-.536 0-.739.013h-.003c-.156.01-.528.035-.844.255a1.5 1.5 0 0 0-.552 1.75c.134.362.424.595.546.693l.002.002c.158.127.37.275.598.435l.026.018L8 16.02V17H6.316c-.279 0-.536 0-.739.013h-.003c-.156.01-.528.035-.844.255a1.5 1.5 0 0 0-.552 1.75c.134.362.424.595.546.693l.002.002c.158.127.37.274.598.434l.026.019L8 22.02v.049c0 .422 0 .785.02 1.086.02.317.066.634.19.948a3 3 0 0 0 1.686 1.685c.314.125.631.17.948.191.301.02.664.02 1.085.02h4.141c.422 0 .785 0 1.086-.02a3.07 3.07 0 0 0 .948-.19 3 3 0 0 0 1.685-1.686 3.07 3.07 0 0 0 .191-.948c.02-.301.02-.664.02-1.085V22.02l2.65-1.854.026-.018c.229-.16.44-.308.598-.435l.002-.002c.122-.098.412-.331.546-.693a1.5 1.5 0 0 0-.552-1.75c-.316-.22-.688-.244-.844-.255h-.003c-.202-.013-.46-.013-.74-.013H20v-.98l2.65-1.854.026-.018c.229-.16.44-.308.598-.435l.002-.002c.122-.098.412-.331.546-.693a1.5 1.5 0 0 0-.552-1.75c-.316-.22-.688-.244-.844-.255h-.003c-.202-.013-.46-.013-.74-.013H20v-.98l2.65-1.855.026-.017c.229-.16.44-.308.598-.435l.002-.002c.122-.098.412-.331.546-.693a1.5 1.5 0 0 0-.552-1.75c-.316-.22-.688-.244-.844-.254h-.003C22.221 5 21.963 5 21.683 5H19.99a6.865 6.865 0 0 0-.009-.156 3.07 3.07 0 0 0-.19-.948 3 3 0 0 0-1.686-1.685 3.072 3.072 0 0 0-.948-.191C16.855 2 16.492 2 16.07 2H11.96Zm-1.328 2.07c.04-.016.124-.04.343-.055.228-.014.525-.015.985-.015h4.08c.46 0 .758 0 .985.015.22.015.303.04.343.055a1 1 0 0 1 .562.562c.016.04.04.124.055.343.015.228.015.525.015.985V6a1 1 0 0 0 1 1h1.828l-2.401 1.68A1 1 0 0 0 18 9.5V12a1 1 0 0 0 1 1h1.828l-2.401 1.68a1 1 0 0 0-.427.82V18a1 1 0 0 0 1 1h1.828l-2.401 1.68a1 1 0 0 0-.427.82v.54c0 .46 0 .758-.015.985-.015.22-.04.303-.055.343a1 1 0 0 1-.562.562c-.04.016-.124.04-.343.055-.227.015-.525.015-.985.015h-4.08c-.46 0-.757 0-.985-.015-.22-.015-.303-.04-.343-.055a1 1 0 0 1-.562-.562c-.016-.04-.04-.124-.055-.343A16.913 16.913 0 0 1 10 22.04v-.54a1 1 0 0 0-.427-.82L7.173 19H9a1 1 0 0 0 1-1v-2.5a1 1 0 0 0-.427-.82L7.173 13H9a1 1 0 0 0 1-1V9.5a1 1 0 0 0-.427-.82L7.173 7H9a1 1 0 0 0 1-1v-.04c0-.46 0-.757.015-.985.015-.22.04-.303.055-.343a1 1 0 0 1 .562-.562ZM14 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm1.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM14 21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: "#023F80"
  })));
};

var _path$5D;
function _extends$5H() { _extends$5H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5H.apply(this, arguments); }
var SvgServicesOutline = function SvgServicesOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5H({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5D || (_path$5D = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.794 4.69.024-.023.848-.849.024-.024c.277-.276.522-.521.742-.708a2.44 2.44 0 0 1 .826-.49 2.4 2.4 0 0 1 1.484 0c.329.107.592.292.826.49.22.187.465.432.742.708l.023.024.849.849.024.023c.276.277.521.522.708.742.198.233.383.497.49.826a2.4 2.4 0 0 1 0 1.484c-.107.329-.292.593-.49.826-.187.22-.432.465-.709.742l-.023.023-.849.849-.023.024a13.52 13.52 0 0 1-.742.708 2.44 2.44 0 0 1-.826.49 2.4 2.4 0 0 1-1.484 0 2.44 2.44 0 0 1-.826-.49c-.22-.187-.465-.432-.742-.708l-.024-.024-.848-.849-.024-.023c-.277-.277-.521-.522-.708-.742a2.438 2.438 0 0 1-.49-.826 2.4 2.4 0 0 1 0-1.484c.107-.329.291-.593.49-.826.187-.22.431-.465.708-.742Zm.664 1.907c-.126.148-.146.204-.15.218a.6.6 0 0 0 0 .37c.004.014.024.07.15.219.133.156.325.35.633.657l.848.848c.308.308.5.5.657.633.15.126.205.146.218.15a.6.6 0 0 0 .371 0c.014-.004.07-.024.219-.15.156-.133.35-.325.657-.633l.848-.848c.308-.308.5-.5.633-.657.126-.15.146-.205.15-.219a.6.6 0 0 0 0-.37c-.004-.014-.024-.07-.15-.218-.134-.157-.325-.35-.633-.658l-.848-.848c-.308-.308-.5-.5-.657-.633-.15-.126-.205-.146-.219-.15a.6.6 0 0 0-.37 0c-.014.004-.07.024-.219.15-.156.133-.35.325-.657.633l-.848.848c-.308.308-.5.5-.633.658ZM7.6 10.9h.033c.392 0 .738 0 1.025-.023.306-.025.623-.081.932-.239a2.4 2.4 0 0 0 1.048-1.048c.158-.309.214-.626.239-.931.023-.288.023-.634.023-1.026V6.367c0-.392 0-.738-.023-1.025-.025-.306-.081-.623-.239-.932A2.4 2.4 0 0 0 9.59 3.362c-.309-.158-.626-.214-.932-.239C8.371 3.1 8.025 3.1 7.633 3.1H6.367c-.392 0-.738 0-1.026.023-.305.025-.622.081-.93.239A2.4 2.4 0 0 0 3.36 4.41c-.157.309-.213.626-.238.932-.023.287-.023.633-.023 1.025V7.633c0 .392 0 .738.023 1.026.025.305.081.622.239.93a2.4 2.4 0 0 0 1.048 1.05c.309.157.626.213.931.238.288.023.634.023 1.026.023H7.6Zm1.172-1.865c-.012.006-.066.032-.26.048A12.65 12.65 0 0 1 7.6 9.1H6.4c-.435 0-.707 0-.912-.017-.194-.016-.248-.042-.26-.048a.6.6 0 0 1-.263-.263c-.006-.012-.032-.066-.048-.26A12.65 12.65 0 0 1 4.9 7.6V6.4c0-.435 0-.707.017-.912.016-.194.042-.248.048-.26a.6.6 0 0 1 .263-.263c.012-.006.066-.032.26-.048.205-.016.477-.017.912-.017h1.2c.435 0 .707 0 .912.017.194.016.248.042.26.048a.6.6 0 0 1 .263.263c.006.012.032.066.048.26.016.205.017.477.017.912v1.2c0 .435 0 .707-.017.912-.016.194-.042.248-.048.26a.6.6 0 0 1-.263.263ZM7.6 20.9h.033c.392 0 .738 0 1.025-.023.306-.025.623-.081.932-.239a2.4 2.4 0 0 0 1.048-1.048c.158-.309.214-.626.239-.931.023-.288.023-.634.023-1.026V16.367c0-.392 0-.738-.023-1.026-.025-.305-.081-.622-.239-.93a2.4 2.4 0 0 0-1.048-1.05c-.309-.157-.626-.213-.932-.238-.287-.023-.633-.023-1.025-.023H6.367c-.392 0-.738 0-1.026.023-.305.025-.622.081-.93.239a2.4 2.4 0 0 0-1.05 1.048 2.44 2.44 0 0 0-.238.931c-.023.288-.023.634-.023 1.026V17.633c0 .392 0 .738.023 1.026.025.305.081.622.239.93a2.4 2.4 0 0 0 1.048 1.05c.309.157.626.213.931.238.288.023.634.023 1.026.023H7.6Zm1.172-1.865c-.012.006-.066.032-.26.048-.205.016-.477.017-.912.017H6.4c-.435 0-.707 0-.912-.017-.194-.016-.248-.042-.26-.048a.6.6 0 0 1-.263-.263c-.006-.012-.032-.066-.048-.26A12.65 12.65 0 0 1 4.9 17.6v-1.2c0-.435 0-.707.017-.912.016-.194.042-.248.048-.26a.6.6 0 0 1 .263-.263c.012-.006.066-.032.26-.047.205-.017.477-.018.912-.018h1.2c.435 0 .707 0 .912.018.194.015.248.041.26.047a.6.6 0 0 1 .263.263c.006.012.032.066.048.26.016.205.017.477.017.912v1.2c0 .435 0 .707-.017.912-.016.194-.042.248-.048.26a.6.6 0 0 1-.263.263ZM17.6 20.9h.033c.392 0 .738 0 1.026-.023.305-.025.622-.081.93-.239a2.4 2.4 0 0 0 1.05-1.048c.157-.309.213-.626.238-.931.023-.288.023-.634.023-1.026V16.367c0-.392 0-.738-.023-1.026-.025-.305-.081-.622-.239-.93a2.4 2.4 0 0 0-1.048-1.05c-.309-.157-.626-.213-.931-.238-.288-.023-.634-.023-1.026-.023H16.367c-.392 0-.738 0-1.026.023-.305.025-.622.081-.93.239a2.4 2.4 0 0 0-1.05 1.048c-.157.309-.213.626-.238.931-.023.288-.023.634-.023 1.026V17.633c0 .392 0 .738.023 1.026.025.305.081.622.239.93a2.4 2.4 0 0 0 1.048 1.05c.309.157.626.213.931.238.288.023.634.023 1.025.023H17.6Zm1.172-1.865c-.012.006-.066.032-.26.048-.205.016-.477.017-.912.017h-1.2c-.435 0-.707 0-.912-.017-.194-.016-.248-.042-.26-.048a.6.6 0 0 1-.263-.263c-.006-.012-.032-.066-.048-.26a12.688 12.688 0 0 1-.017-.912v-1.2c0-.435 0-.707.017-.912.016-.194.042-.248.048-.26a.6.6 0 0 1 .263-.263c.012-.006.066-.032.26-.047.205-.017.477-.018.912-.018h1.2c.435 0 .707 0 .912.018.194.015.248.041.26.047a.6.6 0 0 1 .263.263c.006.012.032.066.047.26.017.205.018.477.018.912v1.2c0 .435 0 .707-.018.912-.015.194-.041.248-.047.26a.6.6 0 0 1-.263.263Z",
    fill: "#023F80"
  })));
};

var _path$5E;
function _extends$5I() { _extends$5I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5I.apply(this, arguments); }
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5I({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5E || (_path$5E = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.714 2.625c1.155 0 2.094.94 2.094 2.094v.483c.491.157.968.355 1.426.592l.343-.342a2.094 2.094 0 0 1 2.962 0l1.009 1.01c.806.805.83 2.133 0 2.962l-.342.342c.237.458.435.935.592 1.426h.483c1.155 0 2.094.94 2.094 2.094v1.428c0 1.155-.94 2.094-2.094 2.094h-.483a9.194 9.194 0 0 1-.592 1.426l.342.343c.83.828.807 2.156 0 2.962l-1.01 1.009a2.094 2.094 0 0 1-2.962 0l-.342-.342a9.194 9.194 0 0 1-1.426.592v.483c0 1.155-.94 2.094-2.094 2.094h-1.428a2.097 2.097 0 0 1-2.094-2.094v-.483a9.191 9.191 0 0 1-1.426-.592l-.343.342c-.829.83-2.157.806-2.962 0l-1.01-1.01a2.094 2.094 0 0 1 .001-2.962l.342-.342a9.19 9.19 0 0 1-.592-1.426H4.72a2.097 2.097 0 0 1-2.094-2.094v-1.428c0-1.155.94-2.094 2.094-2.094h.483c.157-.491.355-.968.592-1.426l-.342-.343a2.094 2.094 0 0 1 0-2.962l1.01-1.009a2.094 2.094 0 0 1 2.962 0l.342.342a9.193 9.193 0 0 1 1.426-.592V4.72c0-1.155.94-2.094 2.094-2.094h1.428Zm0 1.333h-1.428a.762.762 0 0 0-.761.761v.984c0 .304-.206.57-.5.646-.715.184-1.4.469-2.037.845a.667.667 0 0 1-.81-.102l-.697-.697a.761.761 0 0 0-1.077 0l-1.01 1.01a.761.761 0 0 0 0 1.075l.698.698a.667.667 0 0 1 .102.81 7.856 7.856 0 0 0-.845 2.037.666.666 0 0 1-.646.5H4.72a.762.762 0 0 0-.761.761v1.428c0 .42.342.761.761.761h.984c.304 0 .57.206.646.5.184.715.469 1.4.845 2.037a.666.666 0 0 1-.102.81l-.697.697a.761.761 0 0 0 0 1.077l1.009 1.01a.761.761 0 0 0 1.076 0l.698-.698a.67.67 0 0 1 .81-.102c.637.376 1.322.66 2.037.845.294.076.5.342.5.646v.984c0 .42.341.761.761.761h1.428c.42 0 .761-.341.761-.761v-.984c0-.304.206-.57.5-.646a7.854 7.854 0 0 0 2.037-.845.666.666 0 0 1 .81.102l.697.697c.3.301.784.294 1.077 0l1.01-1.01a.761.761 0 0 0 0-1.075l-.698-.698a.667.667 0 0 1-.102-.81c.377-.637.66-1.322.845-2.037a.666.666 0 0 1 .646-.5h.984c.42 0 .761-.341.761-.761v-1.428a.762.762 0 0 0-.761-.761h-.984a.666.666 0 0 1-.646-.5 7.86 7.86 0 0 0-.845-2.037.667.667 0 0 1 .102-.81l.697-.697a.761.761 0 0 0 0-1.077l-1.009-1.01a.761.761 0 0 0-1.076 0l-.698.698a.667.667 0 0 1-.81.102 7.857 7.857 0 0 0-2.037-.845.666.666 0 0 1-.5-.646V4.72a.762.762 0 0 0-.761-.761ZM14 9.05c2.73 0 4.95 2.22 4.95 4.95s-2.22 4.95-4.95 4.95S9.05 16.73 9.05 14 11.27 9.05 14 9.05Zm0 1.333A3.621 3.621 0 0 0 10.383 14 3.621 3.621 0 0 0 14 17.617 3.621 3.621 0 0 0 17.617 14 3.621 3.621 0 0 0 14 10.383Z",
    fill: "#023F80"
  })));
};

var _path$5F;
function _extends$5J() { _extends$5J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5J.apply(this, arguments); }
var SvgSettingsOutline = function SvgSettingsOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5J({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5F || (_path$5F = /*#__PURE__*/createElement$2("path", {
    d: "M15.148 2.04c.428.07.832.233 1.195.523.595.476.878 1.076 1.097 1.952.056.224.153.486.275.74.278.117.55.249.815.393.262-.065.513-.15.714-.244 1.412-.658 2.597-.623 3.567.423.082.089.131.148.238.28l.629.776c.17.21.241.305.348.482.692 1.152.422 2.224-.452 3.386a4.11 4.11 0 0 0-.417.71c.078.283.143.57.195.86.223.178.46.334.668.441.805.41 1.325.822 1.655 1.508.202.42.27.85.24 1.282-.015.229-.04.356-.105.64l-.226.975c-.065.285-.099.41-.185.622a2.516 2.516 0 0 1-.778 1.047c-.598.473-1.246.614-2.148.63a4.07 4.07 0 0 0-.773.1c-.177.243-.364.478-.563.704.003.275.03.544.077.764.187.884.196 1.547-.13 2.236-.2.42-.491.744-.845.993a3.484 3.484 0 0 1-.565.32l-.899.44c-.263.127-.381.18-.6.247-.414.125-.85.156-1.303.054-.744-.167-1.261-.582-1.842-1.273a4.11 4.11 0 0 0-.591-.561 9.553 9.553 0 0 1-.877 0c-.229.18-.438.378-.592.56-.58.692-1.098 1.107-1.842 1.274a2.515 2.515 0 0 1-1.303-.054 3.483 3.483 0 0 1-.6-.248l-.899-.438a6.996 6.996 0 0 1-.185-.093c-1.312-.683-1.696-1.847-1.355-3.457.047-.22.074-.49.077-.764a9.559 9.559 0 0 1-.563-.705 4.07 4.07 0 0 0-.772-.099c-.903-.016-1.551-.157-2.149-.63a2.516 2.516 0 0 1-.778-1.047 3.481 3.481 0 0 1-.185-.622l-.225-.974a3.382 3.382 0 0 1-.109-.681 2.509 2.509 0 0 1 .296-1.346c.339-.629.84-1.015 1.602-1.404.209-.107.446-.263.668-.441.052-.29.117-.577.195-.86a4.113 4.113 0 0 0-.417-.71c-.874-1.162-1.144-2.234-.452-3.386.107-.177.179-.273.348-.482l.63-.777c.106-.131.155-.19.237-.279.97-1.046 2.155-1.08 3.567-.423.201.093.452.18.714.244.265-.144.537-.276.816-.394.12-.253.218-.515.274-.74.219-.875.502-1.475 1.097-1.95.363-.291.768-.455 1.195-.523.18-.03.3-.038.49-.04L14.5 2c.293 0 .422.005.648.04ZM14.586 4H13.5c-.5 0-.75 0-1 1a6.348 6.348 0 0 1-.836 1.87 7.468 7.468 0 0 0-1.8.872 6.35 6.35 0 0 1-1.952-.525c-.934-.435-1.092-.24-1.406.148l-.63.777c-.314.389-.472.583.148 1.406.35.464.721 1.15.937 1.857a7.459 7.459 0 0 0-.429 1.894 6.347 6.347 0 0 1-1.643 1.245c-.918.468-.862.712-.75 1.199l.225.974c.113.487.17.731 1.2.75.57.01 1.323.135 2.003.39.345.575.765 1.1 1.247 1.56a6.35 6.35 0 0 1-.072 2.032c-.213 1.008.011 1.118.46 1.337l.9.438c.45.22.674.33 1.337-.46a6.345 6.345 0 0 1 1.59-1.326 7.566 7.566 0 0 0 1.942 0 6.347 6.347 0 0 1 1.59 1.326c.663.79.888.68 1.337.46l.9-.438c.449-.219.673-.329.46-1.337a6.35 6.35 0 0 1-.072-2.031 7.535 7.535 0 0 0 1.248-1.56 6.346 6.346 0 0 1 2.002-.391c1.031-.019 1.087-.263 1.2-.75l.225-.974c.112-.487.168-.73-.75-1.2a6.346 6.346 0 0 1-1.643-1.244 7.459 7.459 0 0 0-.43-1.894 6.341 6.341 0 0 1 .938-1.857c.62-.823.462-1.017.148-1.406l-.63-.777c-.314-.389-.472-.583-1.406-.148a6.35 6.35 0 0 1-1.952.525 7.47 7.47 0 0 0-1.8-.871A6.348 6.348 0 0 1 15.5 5c-.235-.941-.47-.997-.914-1ZM14 9.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z",
    fill: "#023F80"
  })));
};

var _path$5G;
function _extends$5K() { _extends$5K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5K.apply(this, arguments); }
var SvgShareExternal = function SvgShareExternal(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5K({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5G || (_path$5G = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.85 7.594a.889.889 0 0 1-1.256 1.257l-3.816-3.816v10.298a.889.889 0 1 1-1.778 0V5.035L7.184 8.85a.889.889 0 0 1-1.257-1.257L11.26 2.26c.173-.172.4-.26.626-.26h.006a.886.886 0 0 1 .622.257m5.337 5.337L12.518 2.26l5.333 5.333ZM3 15.904v-1.46a.889.889 0 0 1 1.778 0v1.423c0 1.01 0 1.714.045 2.263.044.538.126.847.245 1.08.256.502.664.91 1.166 1.166.234.12.543.201 1.08.245.55.045 1.253.046 2.264.046H14.2c1.01 0 1.715-.001 2.263-.046.538-.044.847-.126 1.081-.245.502-.256.91-.664 1.165-1.165.12-.234.202-.543.245-1.081.045-.549.046-1.253.046-2.263v-1.423a.889.889 0 0 1 1.778 0v1.46c0 .964 0 1.741-.052 2.37-.052.648-.164 1.217-.433 1.744a4.445 4.445 0 0 1-1.942 1.942c-.526.268-1.095.38-1.743.433-.63.052-1.407.052-2.37.051H9.54c-.964 0-1.74 0-2.37-.05-.648-.054-1.217-.166-1.743-.434a4.444 4.444 0 0 1-1.943-1.942c-.268-.527-.38-1.096-.433-1.744C3 17.645 3 16.868 3 15.904Z",
    fill: "#023F80"
  })));
};

var _path$5H;
function _extends$5L() { _extends$5L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5L.apply(this, arguments); }
var SvgShareOutline = function SvgShareOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5L({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5H || (_path$5H = /*#__PURE__*/createElement$2("path", {
    d: "M11.996 3.725A2.15 2.15 0 0 0 10 5.87l-.001 2.117-.02.005a9.904 9.904 0 0 0-7.827 10.721c.083.811 1.116 1.103 1.611.455l.187-.237a9.082 9.082 0 0 1 5.835-3.265L10 15.64 10 18.134a2.15 2.15 0 0 0 3.476 1.692l7.824-6.132a2.15 2.15 0 0 0 0-3.384l-7.824-6.132a2.15 2.15 0 0 0-1.326-.458l-.154.005Zm.154 1.795a.35.35 0 0 1 .216.075l7.824 6.132a.35.35 0 0 1 0 .55l-7.824 6.133a.35.35 0 0 1-.566-.276l-.001-3.447a.9.9 0 0 0-.915-.9l-.233.004-.342.017a10.88 10.88 0 0 0-6.119 2.365l-.174.144.024-.135a8.103 8.103 0 0 1 6.968-6.537.9.9 0 0 0 .791-.893L11.8 5.87a.35.35 0 0 1 .35-.35Z",
    fill: "#023F80"
  })));
};

var _path$5I, _path2$1I;
function _extends$5M() { _extends$5M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5M.apply(this, arguments); }
var SvgShieldKeyholeOutline = function SvgShieldKeyholeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5M({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5I || (_path$5I = /*#__PURE__*/createElement$2("path", {
    d: "M16.5 12.5a2.5 2.5 0 0 1-1.5 2.292V17a1 1 0 1 1-2 0v-2.208a2.5 2.5 0 1 1 3.5-2.292Z",
    fill: "#023F80"
  })), _path2$1I || (_path2$1I = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.594 2.045a4 4 0 0 0-1.188 0c-.446.067-.868.232-1.427.45L5.654 4.968l-.078.03c-.282.11-.636.246-.913.495a2 2 0 0 0-.535.784c-.131.348-.13.727-.128 1.03V16c0 2.647 1.346 7.118 7.65 10.331l.06.031c.523.267.928.473 1.5.58a4.485 4.485 0 0 0 1.523-.012c.57-.116.99-.339 1.534-.627l.068-.036C19.393 24.647 24 21.51 24 16V7.304c.002-.303.003-.682-.128-1.03a2 2 0 0 0-.535-.785c-.277-.248-.631-.385-.913-.494l-.078-.03-6.325-2.47c-.56-.218-.982-.383-1.428-.45Zm-.89 1.978a2 2 0 0 1 .593 0c.196.03.398.102 1.086.37l6.235 2.435c.126.05.254.096.376.154.01.134.006.27.006.405V16c0 4.256-3.564 6.891-6.601 8.5-.631.334-.804.417-1.062.47-.196.039-.566.042-.762.005-.261-.048-.421-.122-1.016-.426C6.934 21.683 6 17.907 6 16V7.389c0-.135-.003-.27.006-.405.122-.058.25-.105.376-.154l6.236-2.436c.687-.269.89-.342 1.085-.371Z",
    fill: "#023F80"
  })));
};

var _path$5J;
function _extends$5N() { _extends$5N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5N.apply(this, arguments); }
var SvgShoppingCartOutline = function SvgShoppingCartOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5N({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5J || (_path$5J = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.494 4.934c-.086-.025-.211-.034-.835-.034H2a.9.9 0 1 1 0-1.8h.76c.463 0 .87-.001 1.235.105A2.65 2.65 0 0 1 5.654 4.62c.07.15.122.31.164.48h12.318c.43 0 .793 0 1.088.017.305.018.607.057.899.167a2.9 2.9 0 0 1 1.856 2.314 3.04 3.04 0 0 1-.033.913c-.047.292-.125.646-.219 1.066l-.006.026-.633 2.851-.025.113c-.14.633-.248 1.12-.467 1.53a3.4 3.4 0 0 1-2.093 1.68c-.449.124-.947.123-1.596.123H9.365c-.686 0-1.212 0-1.68-.135a3.4 3.4 0 0 1-2.127-1.816c-.207-.44-.29-.96-.397-1.637l-.02-.12-.951-5.986c-.098-.616-.127-.738-.165-.818a.85.85 0 0 0-.531-.454ZM6.123 6.9l.797 5.008c.136.856.183 1.097.266 1.274a1.6 1.6 0 0 0 1.002.854c.188.055.434.064 1.3.064h7.305c.817 0 1.048-.008 1.23-.058a1.6 1.6 0 0 0 .984-.79c.088-.166.146-.39.324-1.188l.633-2.852c.1-.453.168-.754.205-.988.037-.23.034-.327.027-.377a1.1 1.1 0 0 0-.704-.877c-.046-.018-.141-.042-.374-.056A19.226 19.226 0 0 0 18.11 6.9H6.123ZM7 19.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0Zm10.25-1.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Z",
    fill: "#023F80"
  })));
};

var _path$5K, _path2$1J;
function _extends$5O() { _extends$5O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5O.apply(this, arguments); }
var SvgShuffleOutline = function SvgShuffleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5O({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5K || (_path$5K = /*#__PURE__*/createElement$2("path", {
    d: "M2.896 6.1a.9.9 0 0 0 0 1.8c2.63 0 4.501 1.612 6.384 3.704-1.007 1.184-1.951 2.279-2.973 3.108C5.23 15.586 4.14 16.1 2.901 16.1a.9.9 0 1 0 0 1.8c1.791 0 3.27-.76 4.54-1.79 1.097-.89 2.094-2.03 3.035-3.133.952 1.11 1.951 2.264 3.049 3.158 1.248 1.017 2.7 1.765 4.475 1.765h.927l-.563.564a.9.9 0 0 0 1.272 1.272l2.1-2.1a.9.9 0 0 0 0-1.272l-2.1-2.1a.9.9 0 1 0-1.272 1.272l.563.564H18c-1.224 0-2.286-.502-3.338-1.36-.997-.812-1.917-1.883-2.92-3.052l-.237-.275C9.396 8.962 6.865 6.1 2.896 6.1Z",
    fill: "#023F80"
  })), _path2$1J || (_path2$1J = /*#__PURE__*/createElement$2("path", {
    d: "M12.318 8.408C13.805 7.16 15.701 6.1 18 6.1h.927l-.563-.564a.9.9 0 0 1 1.272-1.272l2.1 2.1a.9.9 0 0 1 0 1.272l-2.1 2.1a.9.9 0 0 1-1.272-1.272l.563-.564H18c-1.717 0-3.215.787-4.524 1.886a.9.9 0 1 1-1.158-1.378Z",
    fill: "#023F80"
  })));
};

var _path$5L, _path2$1K;
function _extends$5P() { _extends$5P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5P.apply(this, arguments); }
var SvgSinEspecificar = function SvgSinEspecificar(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5P({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5L || (_path$5L = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.454 3.823c0-1.628-1.36-2.948-3.037-2.948H4.787C3.11.875 1.75 2.195 1.75 3.823v19.161c0 1.628 1.36 2.948 3.037 2.948h10.395a6.568 6.568 0 0 1-.92-1.474H4.787c-.839 0-1.518-.66-1.518-1.474V3.823c0-.814.68-1.474 1.518-1.474h10.63c.84 0 1.519.66 1.519 1.474v12.264a6.524 6.524 0 0 1 1.518-.647V3.823Zm-5.73 17.924a.77.77 0 0 0-.782-.758H7.967a.77.77 0 0 0-.781.758v.276c0 .419.35.758.78.758h3.976a.77.77 0 0 0 .781-.758v-.276Z",
    fill: "#023F80"
  })), _path2$1K || (_path2$1K = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.244 27.125c2.934 0 5.37-2.413 5.37-5.37 0-2.944-2.436-5.369-5.37-5.369-2.945 0-5.369 2.425-5.369 5.37 0 2.956 2.424 5.369 5.37 5.369Zm-.584-2.386a.578.578 0 0 1-.434-.213l-1.85-2.34c-.084-.094-.115-.259-.115-.4 0-.343.228-.615.528-.615.186 0 .32.106.413.224l1.438 1.76 2.605-4.122a.526.526 0 0 1 .445-.26c.29 0 .537.248.537.602a.712.712 0 0 1-.124.366l-2.998 4.761a.532.532 0 0 1-.445.237ZM10.155 5.648c.217 0 .394.064.53.192a.66.66 0 0 1 .205.505v.474l.29.055c.48.107.95.301 1.411.582.126.08.216.17.268.267a.749.749 0 0 1 .079.36.784.784 0 0 1-.19.524.565.565 0 0 1-.44.223.727.727 0 0 1-.242-.04 3.11 3.11 0 0 1-.336-.152 12.474 12.474 0 0 0-.325-.167 2.774 2.774 0 0 0-.541-.202 2.414 2.414 0 0 0-.615-.076c-.315 0-.57.066-.767.197a.609.609 0 0 0-.294.53c0 .216.112.378.336.485.224.108.578.216 1.061.324.518.114.944.235 1.276.363.333.128.62.333.862.616.241.283.362.664.362 1.142 0 .545-.194 1.01-.583 1.394-.389.383-.912.636-1.57.757v.495l-.008.12a.632.632 0 0 1-.197.385.744.744 0 0 1-.53.192.744.744 0 0 1-.53-.192.66.66 0 0 1-.206-.505v-.454l-.326-.048c-.639-.112-1.195-.314-1.67-.609a.702.702 0 0 1-.267-.252.767.767 0 0 1-.079-.374c0-.202.061-.377.184-.525a.55.55 0 0 1 .436-.223c.084 0 .168.014.252.04.084.028.192.078.326.152.308.162.595.276.86.344.267.067.55.1.852.1.37 0 .652-.058.845-.176a.581.581 0 0 0 .289-.53.424.424 0 0 0-.173-.349 1.336 1.336 0 0 0-.431-.217 13.186 13.186 0 0 0-.751-.202 10.429 10.429 0 0 1-1.292-.389 2.221 2.221 0 0 1-.872-.616c-.245-.28-.367-.655-.367-1.126 0-.54.196-1.007.588-1.404.392-.398.91-.66 1.554-.788v-.505l.009-.117a.641.641 0 0 1 .201-.383.738.738 0 0 1 .526-.197Z",
    fill: "#023F80"
  })));
};

var _path$5M;
function _extends$5Q() { _extends$5Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5Q.apply(this, arguments); }
var SvgSkirtOutline = function SvgSkirtOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5Q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5M || (_path$5M = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.343 2.1H15.657c.215 0 .428 0 .608.015.198.016.436.054.676.177.33.168.6.437.768.767.122.24.16.478.176.676.015.18.015.393.015.608v1.584l3.73 11.123.014.04c.063.186.148.435.14.75a1.8 1.8 0 0 1-.063.402 1.803 1.803 0 0 1-.145.381 1.827 1.827 0 0 1-.441.538l-.016.014C19.994 20.182 17.286 21.9 12 21.9s-7.994-1.718-9.12-2.725a1.826 1.826 0 0 1-.457-.552 1.804 1.804 0 0 1-.144-.381 1.801 1.801 0 0 1-.062-.403 2.066 2.066 0 0 1 .139-.75l.013-.039L6.1 5.927V4.343c0-.215 0-.428.015-.608.016-.198.054-.436.177-.676.168-.33.437-.599.767-.767.24-.123.478-.161.676-.177.18-.015.393-.015.608-.015ZM7.9 5.6h8.2V4.371c0-.233 0-.368-.007-.464a8.255 8.255 0 0 0-.464-.007H8.37c-.233 0-.368 0-.464.007-.006.096-.007.23-.007.464V5.6Zm-.395 1.8-3.43 10.223a8.068 8.068 0 0 0-.051.159l.058.052c.469.42 1.472 1.148 3.242 1.666L9.22 7.4H7.505Zm3.537 0L9.085 19.888c.848.132 1.815.212 2.915.212s2.067-.08 2.915-.212L12.958 7.4h-1.916Zm3.738 0 1.896 12.1c1.77-.518 2.774-1.246 3.242-1.666a6.53 6.53 0 0 0 .058-.052l-.009-.029a7.497 7.497 0 0 0-.043-.13L16.496 7.4H14.78Z",
    fill: "#023F80"
  })));
};

var _path$5N, _path2$1L, _path3$z;
function _extends$5R() { _extends$5R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5R.apply(this, arguments); }
var SvgSkullOutline = function SvgSkullOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5R({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5N || (_path$5N = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 7.85a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8Zm-.6 2.4a.6.6 0 1 1 1.2 0 .6.6 0 0 1-1.2 0ZM12.85 10.25a2.4 2.4 0 1 1 4.8 0 2.4 2.4 0 0 1-4.8 0Zm2.4-.6a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2Z",
    fill: "#023F80"
  })), _path2$1L || (_path2$1L = /*#__PURE__*/createElement$2("path", {
    d: "M12.9 13.9a.9.9 0 1 0-1.8 0v.5a.9.9 0 0 0 1.8 0v-.5Z",
    fill: "#023F80"
  })), _path3$z || (_path3$z = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.467 3.1h1.066c1.137 0 2.036 0 2.764.05.743.05 1.374.156 1.96.4a5.9 5.9 0 0 1 3.194 3.192c.243.588.349 1.218.4 1.96.05.729.05 1.628.05 2.765v.064c0 .673 0 1.223-.032 1.672-.031.464-.099.886-.266 1.29a3.9 3.9 0 0 1-2.11 2.11c-.216.09-.381.203-.481.313-.092.1-.112.175-.112.236V20.1a.9.9 0 0 1-1.8 0v-1.2h-3.2v1.2a.9.9 0 0 1-1.8 0v-1.2H7.9v1.2a.9.9 0 0 1-1.8 0v-2.948c0-.06-.02-.135-.111-.236-.1-.11-.266-.224-.481-.313a3.9 3.9 0 0 1-2.111-2.11c-.167-.404-.235-.826-.266-1.29-.03-.45-.03-1-.03-1.672v-.064c0-1.137 0-2.036.049-2.764.05-.743.156-1.373.4-1.96a5.9 5.9 0 0 1 3.192-3.194c.588-.243 1.218-.349 1.961-.4.728-.049 1.627-.049 2.764-.049ZM8.826 4.945c-.652.045-1.063.13-1.395.267a4.1 4.1 0 0 0-2.219 2.219c-.137.331-.222.743-.266 1.394-.045.66-.046 1.498-.046 2.675 0 .711 0 1.2.027 1.58.025.373.072.576.133.724a2.1 2.1 0 0 0 1.136 1.136c.712.295 1.676.98 1.703 2.16h8.202c.027-1.18.992-1.865 1.703-2.16a2.1 2.1 0 0 0 1.136-1.136c.061-.148.108-.351.134-.724.026-.38.026-.869.026-1.58 0-1.177 0-2.015-.045-2.675-.045-.651-.13-1.063-.267-1.394a4.1 4.1 0 0 0-2.219-2.219c-.331-.137-.743-.222-1.394-.267-.66-.045-1.498-.045-2.675-.045h-1c-1.177 0-2.015 0-2.674.045Z",
    fill: "#023F80"
  })));
};

var _path$5O;
function _extends$5S() { _extends$5S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5S.apply(this, arguments); }
var SvgSlidersOutline = function SvgSlidersOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5S({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5O || (_path$5O = /*#__PURE__*/createElement$2("path", {
    d: "M18.5 15a3.501 3.501 0 0 1 3.355 2.5H24a1 1 0 1 1 0 2h-2.145a3.501 3.501 0 0 1-6.71 0H4a1 1 0 1 1 0-2h11.145A3.501 3.501 0 0 1 18.5 15Zm0 1.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5ZM10.5 6a3.501 3.501 0 0 1 3.355 2.5H24a1 1 0 1 1 0 2H13.855a3.501 3.501 0 0 1-6.71 0H4a1 1 0 1 1 0-2h3.145A3.502 3.502 0 0 1 10.5 6Zm0 1.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Z",
    fill: "#023F80"
  })));
};

var _path$5P;
function _extends$5T() { _extends$5T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5T.apply(this, arguments); }
var SvgSmartphoneOutline = function SvgSmartphoneOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5T({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5P || (_path$5P = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.18 3.9h1.64c1.094 0 1.806.001 2.35.046.522.042.728.116.838.172a2 2 0 0 1 .874.874c.056.11.13.316.172.839.045.543.046 1.255.046 2.349v7.64c0 1.094-.001 1.806-.046 2.35-.042.522-.116.728-.172.838a2 2 0 0 1-.874.874c-.11.056-.316.13-.839.172-.543.045-1.255.046-2.349.046h-1.64c-1.094 0-1.806-.001-2.35-.046-.521-.042-.727-.116-.838-.172a2 2 0 0 1-.874-.874c-.056-.11-.13-.316-.172-.839-.044-.543-.046-1.255-.046-2.349V8.18c0-1.094.002-1.806.046-2.35.043-.522.116-.728.172-.838a2 2 0 0 1 .874-.874c.11-.056.317-.13.839-.172.543-.045 1.255-.046 2.35-.046ZM5.1 8.18c0-2.128 0-3.192.414-4.005a3.8 3.8 0 0 1 1.66-1.66C7.989 2.1 9.053 2.1 11.18 2.1h1.64c2.128 0 3.192 0 4.005.414a3.8 3.8 0 0 1 1.66 1.66c.415.814.415 1.878.415 4.006v7.64c0 2.128 0 3.192-.414 4.005a3.8 3.8 0 0 1-1.66 1.66c-.814.415-1.878.415-4.006.415h-1.64c-2.128 0-3.192 0-4.005-.414a3.8 3.8 0 0 1-1.66-1.66C5.1 19.011 5.1 17.947 5.1 15.82V8.18Zm6.15 8.02a.9.9 0 1 0 0 1.8h1.5a.9.9 0 0 0 0-1.8h-1.5Z",
    fill: "#023F80"
  })));
};

var _path$5Q, _path2$1M;
function _extends$5U() { _extends$5U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5U.apply(this, arguments); }
var SvgSmileOutline = function SvgSmileOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5U({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5Q || (_path$5Q = /*#__PURE__*/createElement$2("path", {
    d: "M8.438 14.297a.9.9 0 0 1 1.259.133c.013.016.196.223.53.432.383.24.97.488 1.773.488.803 0 1.39-.249 1.773-.488.191-.12.382-.26.53-.432a.9.9 0 0 1 1.4 1.132c-.273.329-.616.6-.976.826A5.095 5.095 0 0 1 12 17.15a5.095 5.095 0 0 1-2.727-.762 3.987 3.987 0 0 1-.976-.826.9.9 0 0 1 .14-1.265ZM10.25 10.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM15 11.5A1.25 1.25 0 1 0 15 9a1.25 1.25 0 0 0 0 2.5Z",
    fill: "#023F80"
  })), _path2$1M || (_path2$1M = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.1c-5.468 0-9.9 4.432-9.9 9.9s4.432 9.9 9.9 9.9 9.9-4.432 9.9-9.9-4.432-9.9-9.9-9.9ZM3.9 12a8.1 8.1 0 1 1 16.2 0 8.1 8.1 0 0 1-16.2 0Z",
    fill: "#023F80"
  })));
};

var _path$5R;
function _extends$5V() { _extends$5V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5V.apply(this, arguments); }
var SvgSmiles2Outline = function SvgSmiles2Outline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5V({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5R || (_path$5R = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm7.5 11.975a4.99 4.99 0 0 0 4.249-1.668 1 1 0 1 0-1.499-1.323 2.993 2.993 0 0 1-1.747.974A8.987 8.987 0 0 0 19 14a8.978 8.978 0 0 0-3.002-6.71 7 7 0 1 1 0 13.42 9.05 9.05 0 0 0 1.503-1.735Zm-3.5 3.09A9 9 0 1 1 10 5c1.437-.001 2.795.336 4 .935a9 9 0 1 1 0 16.129Zm-7.662-6.169a1 1 0 0 1 1.412.088A2.99 2.99 0 0 0 10 17c.896 0 1.7-.391 2.25-1.016a1 1 0 1 1 1.5 1.324A4.99 4.99 0 0 1 10 19a4.99 4.99 0 0 1-3.75-1.692 1 1 0 0 1 .088-1.412ZM6.75 11a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM12 12.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm8 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
    fill: "#023F80"
  })));
};

var _path$5S;
function _extends$5W() { _extends$5W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5W.apply(this, arguments); }
var SvgSneakerOutline = function SvgSneakerOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5W({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5S || (_path$5S = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.49 20.96C26.153 23.22 24.157 25 21 25h-5.493a7 7 0 0 1-4.98-2.08L3.29 15.592A4.5 4.5 0 0 1 3.2 9.36l4.837-5.187C9.276 2.847 11.5 3.723 11.5 5.538V6a1 1 0 0 0 1 1h2.565l-.422-1.774a1 1 0 0 1 1.946-.463l1.997 8.382a2 2 0 0 0 1.313 1.434l2.917.972c2.672.891 4 3.202 3.673 5.408ZM15.542 9l.275 1.155-3.093.884a1 1 0 1 0 .55 1.922l3.007-.859.358 1.507c.047.194.107.382.18.564l-1.136.378a1 1 0 1 0 .632 1.898l1.78-.594c.349.267.743.479 1.17.621l2.918.973c1.828.609 2.5 2.048 2.327 3.217C24.346 21.781 23.342 23 21 23h-5.493a5 5 0 0 1-3.557-1.486l-7.238-7.327a2.5 2.5 0 0 1-.05-3.462L9.5 5.538V6a3 3 0 0 0 3 3h3.043Z",
    fill: "#023F80"
  })));
};

var _path$5T;
function _extends$5X() { _extends$5X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5X.apply(this, arguments); }
var SvgSnowflakeOutline = function SvgSnowflakeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5X({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5T || (_path$5T = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.293 2.793a1 1 0 0 1 1.414 0L14 5.086l2.293-2.293a1 1 0 0 1 1.414 1.414L15 6.914v5.354l4.637-2.677.99-3.698a1 1 0 1 1 1.932.518l-.839 3.132 3.132.84a1 1 0 0 1-.518 1.931l-3.697-.99L16 14l4.637 2.677 3.697-.991a1 1 0 1 1 .518 1.932l-3.132.84.84 3.131a1 1 0 1 1-1.933.518l-.99-3.698L15 15.732v5.354l2.707 2.707a1 1 0 0 1-1.414 1.414L14 22.914l-2.293 2.293a1 1 0 0 1-1.414-1.414L13 21.086v-5.354l-4.636 2.677-.991 3.698a1 1 0 1 1-1.932-.518l.84-3.132-3.133-.84a1 1 0 1 1 .518-1.931l3.698.99L12 14l-4.636-2.677-3.698.991a1 1 0 0 1-.518-1.932l3.132-.84-.84-3.131a1 1 0 0 1 1.933-.518l.99 3.698L13 12.268V6.914l-2.707-2.707a1 1 0 0 1 0-1.414Z",
    fill: "#023F80"
  })));
};

var _path$5U;
function _extends$5Y() { _extends$5Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5Y.apply(this, arguments); }
var SvgSongOutline = function SvgSongOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5Y({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5U || (_path$5U = /*#__PURE__*/createElement$2("path", {
    d: "M19.78 3.025A1 1 0 0 1 21 4v2.102a3.6 3.6 0 0 1-2.672 3.479L15 10.468v9.926c0 4.688-4.583 7.1-7.073 4.61C5.351 22.426 7.82 18.2 13 17.942V7.93c-.027-1.922.91-3.288 2.684-3.88.64-.213 1.993-.551 4.096-1.026ZM13 19.944c-3.538.196-4.845 2.459-3.659 3.645C10.484 24.732 13 23.408 13 20.394v-.45Zm6-14.688c-1.348.315-2.249.548-2.684.693-.934.311-1.331.89-1.316 1.968v.481l2.812-.75A1.6 1.6 0 0 0 19 6.102v-.846Z",
    fill: "#023F80"
  })));
};

var _path$5V;
function _extends$5Z() { _extends$5Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5Z.apply(this, arguments); }
var SvgSortHorizontalOutline = function SvgSortHorizontalOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5Z({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5V || (_path$5V = /*#__PURE__*/createElement$2("path", {
    d: "m16.613 14.21.094.083 4 4a1 1 0 0 1 .083 1.32l-.083.094-4 4a1 1 0 0 1-1.497-1.32l.083-.094L17.585 20H8a1 1 0 0 1-.117-1.993L8 18h9.585l-2.292-2.293a1 1 0 0 1-.083-1.32l.083-.094a1 1 0 0 1 1.32-.083Zm-3.906-9.917a1 1 0 0 1 .083 1.32l-.083.094L10.414 8H20a1 1 0 0 1 .117 1.993L20 10h-9.586l2.293 2.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.083l-.094-.083-4-4a1 1 0 0 1-.083-1.32l.083-.094 4-4a1 1 0 0 1 1.414 0Z",
    fill: "#023F80"
  })));
};

var _path$5W, _path2$1N;
function _extends$5_() { _extends$5_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5_.apply(this, arguments); }
var SvgSortOutline = function SvgSortOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5_({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5W || (_path$5W = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6 18.398a.9.9 0 0 1-.9-.9V9.053l-2.064 2.063a.9.9 0 1 1-1.272-1.272l3.529-3.53a1 1 0 0 1 1.414 0l3.53 3.53a.9.9 0 0 1-1.273 1.272L17.5 9.053v8.445a.9.9 0 0 1-.9.9ZM6.6 17.118V6.9a.9.9 0 1 1 1.8 0v10.218a.9.9 0 1 1-1.8 0Z",
    fill: "#023F80"
  })), _path2$1N || (_path2$1N = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.736 13.282a.9.9 0 0 1 0 1.273l-3.529 3.53a1 1 0 0 1-1.414 0l-3.53-3.53a.9.9 0 0 1 1.273-1.273L7.5 16.246l2.964-2.964a.9.9 0 0 1 1.272 0Z",
    fill: "#023F80"
  })));
};

var _path$5X;
function _extends$5$() { _extends$5$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5$.apply(this, arguments); }
var SvgSparkleOutline = function SvgSparkleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$5$({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5X || (_path$5X = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.991 2.96a1 1 0 0 1 1-.96h.019a1 1 0 0 1 .999.96c.236 5.985 4.046 9.796 10.03 10.031a1 1 0 0 1 .961 1v.019a1 1 0 0 1-.96.999c-5.985.236-9.795 4.046-10.031 10.03a1 1 0 0 1-1 .961h-.019a1 1 0 0 1-.999-.96c-.236-5.985-4.046-9.795-10.03-10.031a1 1 0 0 1-.961-1v-.019a1 1 0 0 1 .96-.999c5.985-.236 9.796-4.046 10.031-10.03ZM14 7.609c-1.37 3.348-3.044 5.023-6.392 6.392 3.348 1.37 5.023 3.044 6.392 6.392 1.37-3.348 3.044-5.023 6.392-6.392-3.348-1.37-5.023-3.044-6.392-6.392Z",
    fill: "#023F80"
  })));
};

var _path$5Y, _path2$1O;
function _extends$60() { _extends$60 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$60.apply(this, arguments); }
var SvgSpeedometerMaxOutline = function SvgSpeedometerMaxOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$60({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5Y || (_path$5Y = /*#__PURE__*/createElement$2("path", {
    d: "M14 2c1.687 0 3.294.348 4.751.978l.328.147a11.994 11.994 0 0 1 3.406 2.39A11.965 11.965 0 0 1 26 14c0 .425-.022.845-.065 1.26a1 1 0 0 1-1.99-.208 9.966 9.966 0 0 0-2.874-8.123 10.048 10.048 0 0 0-3.112-2.115l-.005-.002A9.964 9.964 0 0 0 14 4a9.959 9.959 0 0 0-4.7 1.17l-.066.036A10.038 10.038 0 0 0 6.93 6.93 9.966 9.966 0 0 0 4 14c0 2.014.594 3.886 1.617 5.454a1 1 0 1 1-1.676 1.092A11.949 11.949 0 0 1 2 14c0-3.313 1.344-6.315 3.515-8.485a12.038 12.038 0 0 1 3.74-2.54l.006-.002A11.964 11.964 0 0 1 14 2Z",
    fill: "#023F80"
  })), _path2$1O || (_path2$1O = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.077 11.8 8.905 7.247c1 .813.084 2.4-1.12 1.94L13.131 16.9a3.04 3.04 0 0 1-.318-.143 3 3 0 1 1 2.979-5.162c.097.062.192.13.284.205ZM14.5 13.133a1 1 0 1 0-1 1.732 1 1 0 0 0 1-1.732Z",
    fill: "#023F80"
  })));
};

var _path$5Z, _path2$1P;
function _extends$61() { _extends$61 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$61.apply(this, arguments); }
var SvgSpeedometerMiddleOutline = function SvgSpeedometerMiddleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$61({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5Z || (_path$5Z = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.944 13.302 15.121 1.966c-.205-1.273-2.037-1.273-2.242 0l-1.823 11.336c-.019.117-.03.232-.036.347a3 3 0 1 0 5.96.001 3.048 3.048 0 0 0-.036-.348ZM15 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: "#023F80"
  })), _path2$1P || (_path2$1P = /*#__PURE__*/createElement$2("path", {
    d: "M17.431 3.498a1 1 0 0 1 1.314-.523 12.02 12.02 0 0 1 3.74 2.54A11.966 11.966 0 0 1 26 14c0 2.413-.713 4.663-1.941 6.546a1 1 0 1 1-1.676-1.092A9.948 9.948 0 0 0 24 14a9.965 9.965 0 0 0-2.929-7.071 10.017 10.017 0 0 0-3.117-2.117 1 1 0 0 1-.523-1.314ZM10.563 3.5a1 1 0 0 1-.522 1.314A10.022 10.022 0 0 0 6.93 6.929 9.966 9.966 0 0 0 4 14c0 2.014.594 3.886 1.617 5.454a1 1 0 1 1-1.676 1.092A11.948 11.948 0 0 1 2 14c0-3.313 1.344-6.315 3.515-8.485a12.022 12.022 0 0 1 3.734-2.537 1 1 0 0 1 1.314.521Z",
    fill: "#023F80"
  })));
};

var _path$5_, _path2$1Q;
function _extends$62() { _extends$62 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$62.apply(this, arguments); }
var SvgSpeedometerMinOutline = function SvgSpeedometerMinOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$62({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5_ || (_path$5_ = /*#__PURE__*/createElement$2("path", {
    d: "M14 2c-1.687 0-3.293.348-4.751.978l-.328.147a11.968 11.968 0 0 0-3.406 2.39A11.966 11.966 0 0 0 2 14c0 .425.022.845.065 1.26a1 1 0 0 0 1.99-.208A10.128 10.128 0 0 1 4 14a9.966 9.966 0 0 1 2.929-7.071 10.047 10.047 0 0 1 3.112-2.115l.005-.002A9.964 9.964 0 0 1 14 4a9.959 9.959 0 0 1 4.7 1.17l.066.036c.85.462 1.626 1.044 2.305 1.723A9.966 9.966 0 0 1 24 14a9.948 9.948 0 0 1-1.617 5.454 1 1 0 1 0 1.676 1.092A11.949 11.949 0 0 0 26 14c0-3.313-1.344-6.315-3.515-8.485a12.04 12.04 0 0 0-3.74-2.54l-.006-.002A11.963 11.963 0 0 0 14 2Z",
    fill: "#023F80"
  })), _path2$1Q || (_path2$1Q = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.923 11.8-8.905 7.247c-1 .813-.084 2.4 1.12 1.94l10.73-4.088c.11-.042.216-.09.318-.143a3 3 0 1 0-2.979-5.162c-.097.062-.192.13-.284.205Zm1.577 1.334a1 1 0 1 1 1 1.732 1 1 0 0 1-1-1.732Z",
    fill: "#023F80"
  })));
};

var _path$5$;
function _extends$63() { _extends$63 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$63.apply(this, arguments); }
var SvgSquare4Outline = function SvgSquare4Outline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$63({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5$ || (_path$5$ = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04 3h-.08c-.666 0-1.226 0-1.683.037-.48.04-.934.124-1.366.344a3.5 3.5 0 0 0-1.53 1.53c-.22.432-.304.887-.344 1.366C3 6.734 3 7.294 3 7.96v.08c0 .666 0 1.226.037 1.683.04.48.124.934.344 1.366a3.5 3.5 0 0 0 1.53 1.53c.432.22.887.305 1.366.344C6.734 13 7.294 13 7.96 13h.08c.666 0 1.226 0 1.683-.037.48-.04.934-.124 1.366-.345a3.5 3.5 0 0 0 1.53-1.529c.22-.432.305-.887.344-1.366C13 9.266 13 8.706 13 8.04v-.08c0-.666 0-1.226-.037-1.683-.04-.48-.124-.934-.345-1.366a3.5 3.5 0 0 0-1.529-1.53c-.432-.22-.887-.304-1.366-.344C9.266 3 8.706 3 8.04 3ZM5.82 5.163c.103-.052.265-.103.62-.132C6.806 5 7.283 5 8 5s1.194 0 1.56.03c.356.03.518.081.621.133a1.5 1.5 0 0 1 .655.656c.053.103.104.265.133.62C11 6.806 11 7.283 11 8s0 1.194-.03 1.56c-.03.356-.081.518-.134.621a1.5 1.5 0 0 1-.655.655c-.103.053-.265.104-.62.133C9.194 11 8.717 11 8 11s-1.194 0-1.56-.03c-.356-.03-.518-.081-.621-.134a1.5 1.5 0 0 1-.656-.655c-.052-.103-.103-.265-.132-.62C5 9.194 5 8.717 5 8s0-1.194.03-1.56c.03-.356.081-.518.133-.621a1.5 1.5 0 0 1 .656-.656Zm3.904 9.874C9.266 15 8.706 15 8.04 15h-.08c-.666 0-1.226 0-1.683.037-.48.04-.934.124-1.366.345a3.5 3.5 0 0 0-1.53 1.529c-.22.432-.304.887-.344 1.366C3 18.734 3 19.294 3 19.96v.08c0 .666 0 1.226.037 1.683.04.48.124.934.344 1.366a3.5 3.5 0 0 0 1.53 1.53c.432.22.887.305 1.366.344C6.734 25 7.294 25 7.96 25h.08c.666 0 1.226 0 1.683-.037.48-.04.934-.124 1.366-.345a3.5 3.5 0 0 0 1.53-1.529c.22-.432.305-.887.344-1.366.037-.457.037-1.017.037-1.683v-.08c0-.666 0-1.226-.037-1.683-.04-.48-.124-.934-.345-1.366a3.5 3.5 0 0 0-1.529-1.53c-.432-.22-.887-.305-1.366-.344ZM5.82 17.163c.103-.052.265-.103.62-.132C6.806 17 7.283 17 8 17s1.194 0 1.56.03c.356.03.518.081.621.133a1.5 1.5 0 0 1 .655.656c.053.103.104.265.133.62.03.367.031.844.031 1.561s0 1.194-.03 1.56c-.03.356-.081.518-.134.621a1.5 1.5 0 0 1-.655.655c-.103.053-.265.104-.62.133C9.194 23 8.717 23 8 23s-1.194 0-1.56-.03c-.356-.03-.518-.081-.621-.133a1.5 1.5 0 0 1-.656-.656c-.052-.103-.103-.265-.132-.62C5 21.194 5 20.717 5 20s0-1.194.03-1.56c.03-.356.081-.518.133-.621a1.5 1.5 0 0 1 .656-.655Zm12.458-2.126C18.734 15 19.294 15 19.96 15h.08c.666 0 1.226 0 1.683.037.48.04.934.124 1.366.345a3.5 3.5 0 0 1 1.53 1.529c.22.432.305.887.344 1.366.037.457.037 1.017.037 1.683v.08c0 .666 0 1.226-.037 1.683-.04.48-.124.934-.345 1.366a3.5 3.5 0 0 1-1.529 1.53c-.432.22-.887.305-1.366.344-.457.037-1.017.037-1.683.037h-.08c-.666 0-1.226 0-1.683-.037-.48-.04-.934-.124-1.366-.345a3.5 3.5 0 0 1-1.53-1.529c-.22-.432-.305-.887-.344-1.366C15 21.266 15 20.706 15 20.04v-.08c0-.666 0-1.226.037-1.683.04-.48.124-.934.345-1.366a3.5 3.5 0 0 1 1.529-1.53c.432-.22.887-.305 1.366-.344Zm.162 1.994c-.355.029-.517.08-.62.133a1.5 1.5 0 0 0-.655.655c-.053.103-.104.265-.133.62C17 18.806 17 19.283 17 20s0 1.194.03 1.56c.03.356.081.518.133.621a1.5 1.5 0 0 0 .656.655c.103.053.265.104.62.133.367.03.844.031 1.561.031s1.194 0 1.56-.03c.356-.03.518-.081.621-.133a1.5 1.5 0 0 0 .655-.656c.053-.103.104-.265.133-.62C23 21.194 23 20.717 23 20s0-1.194-.03-1.56c-.03-.356-.081-.518-.133-.621a1.5 1.5 0 0 0-.656-.655c-.103-.053-.265-.104-.62-.133C21.194 17 20.717 17 20 17s-1.194 0-1.56.03ZM20.04 3h-.08c-.666 0-1.226 0-1.683.037-.48.04-.934.124-1.366.344a3.5 3.5 0 0 0-1.53 1.53c-.22.432-.305.887-.344 1.366C15 6.734 15 7.294 15 7.96v.08c0 .666 0 1.226.037 1.683.04.48.124.934.345 1.366a3.5 3.5 0 0 0 1.529 1.53c.432.22.887.305 1.366.344.457.037 1.017.037 1.683.037h.08c.666 0 1.226 0 1.683-.037.48-.04.934-.124 1.366-.345a3.5 3.5 0 0 0 1.53-1.529c.22-.432.305-.887.344-1.366C25 9.266 25 8.706 25 8.04v-.08c0-.666 0-1.226-.037-1.683-.04-.48-.124-.934-.345-1.366a3.5 3.5 0 0 0-1.529-1.53c-.432-.22-.887-.304-1.366-.344C21.266 3 20.706 3 20.04 3ZM17.82 5.163c.103-.052.265-.103.62-.132C18.806 5 19.283 5 20 5s1.194 0 1.56.03c.356.03.518.081.621.133a1.5 1.5 0 0 1 .655.656c.053.103.104.265.133.62C23 6.806 23 7.283 23 8s0 1.194-.03 1.56c-.03.356-.081.518-.133.621a1.5 1.5 0 0 1-.656.655c-.103.053-.265.104-.62.133C21.194 11 20.717 11 20 11s-1.194 0-1.56-.03c-.356-.03-.518-.081-.621-.134a1.5 1.5 0 0 1-.655-.655c-.053-.103-.104-.265-.133-.62C17 9.194 17 8.717 17 8s0-1.194.03-1.56c.03-.356.081-.518.133-.621a1.5 1.5 0 0 1 .656-.656Z",
    fill: "#023F80"
  })));
};

var _path$60, _path2$1R;
function _extends$64() { _extends$64 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$64.apply(this, arguments); }
var SvgStarsOutline = function SvgStarsOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$64({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$60 || (_path$60 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.005 10.444c-.367.761-.836 1.532-1.432 2.128-.597.597-1.368 1.066-2.129 1.433.761.367 1.532.836 2.129 1.432.596.597 1.064 1.366 1.432 2.126.368-.76.836-1.53 1.433-2.126.596-.596 1.365-1.064 2.125-1.432-.76-.368-1.529-.836-2.125-1.433-.597-.596-1.065-1.367-1.433-2.128Zm-.946-2.463c-.434 1.28-1.02 2.579-1.76 3.319-.739.74-2.037 1.325-3.317 1.759a21.783 21.783 0 0 1-1.449.437l-.247.066c-.381.098-.381.788 0 .886l.247.066a25.117 25.117 0 0 1 1.449.437c1.28.434 2.578 1.02 3.318 1.76.74.739 1.325 2.033 1.759 3.31a24.801 24.801 0 0 1 .503 1.692c.099.38.787.38.886-.001a24.875 24.875 0 0 1 .503-1.692c.435-1.276 1.02-2.57 1.76-3.31.739-.74 2.033-1.325 3.31-1.759a24.798 24.798 0 0 1 1.691-.503c.381-.099.381-.787 0-.886a25.622 25.622 0 0 1-1.691-.503c-1.277-.435-2.571-1.02-3.31-1.76-.74-.739-1.326-2.037-1.76-3.317a25.117 25.117 0 0 1-.503-1.695c-.098-.382-.787-.382-.886 0a24.824 24.824 0 0 1-.503 1.694Z",
    fill: "#023F80"
  })), _path2$1R || (_path2$1R = /*#__PURE__*/createElement$2("path", {
    d: "M6.426 2.318a.47.47 0 0 0-.892 0l-.52 1.558a1.8 1.8 0 0 1-1.138 1.139l-1.558.52a.47.47 0 0 0 0 .89l1.554.519a1.8 1.8 0 0 1 1.14 1.145l.522 1.584a.47.47 0 0 0 .893 0l.52-1.58a1.8 1.8 0 0 1 1.146-1.147l1.58-.52a.47.47 0 0 0 0-.893l-1.584-.52a1.8 1.8 0 0 1-1.145-1.141l-.518-1.554Z",
    fill: "#023F80"
  })));
};

var _path$61;
function _extends$65() { _extends$65 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$65.apply(this, arguments); }
var SvgStatisticsOutline = function SvgStatisticsOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$65({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$61 || (_path$61 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1 19a.9.9 0 0 1 .9-.9h18a.9.9 0 1 1 0 1.8H3a.9.9 0 0 1-.9-.9ZM16.5 5.9a.9.9 0 1 1 0-1.8H21a.9.9 0 0 1 .9.9v4.5a.9.9 0 1 1-1.8 0V7.173l-5.964 5.963a.9.9 0 0 1-1.272 0L9.5 9.773l-5.864 5.863a.9.9 0 0 1-1.272-1.272l6.5-6.5a.9.9 0 0 1 1.272 0l3.364 3.363L18.827 5.9H16.5Z",
    fill: "#023F80"
  })));
};

var _path$62;
function _extends$66() { _extends$66 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$66.apply(this, arguments); }
var SvgStickerOutline = function SvgStickerOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$66({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$62 || (_path$62 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.639 2.106a.9.9 0 0 1 .668.264l9.324 9.323a.9.9 0 0 1 .262.668A9.87 9.87 0 0 1 19 19.002a9.872 9.872 0 0 1-7 2.899A9.872 9.872 0 0 1 5 19a9.872 9.872 0 0 1-2.9-7c0-2.734 1.11-5.21 2.9-7a9.87 9.87 0 0 1 6.639-2.894Zm-1.301 1.965a8.081 8.081 0 0 0-4.066 2.201A8.072 8.072 0 0 0 3.9 12c0 2.237.906 4.26 2.372 5.728A8.072 8.072 0 0 0 12 20.1c2.237 0 4.26-.906 5.727-2.372a8.08 8.08 0 0 0 2.202-4.066A7.912 7.912 0 0 1 18 13.9a7.878 7.878 0 0 1-5.586-2.314A7.878 7.878 0 0 1 10.1 6c0-.665.082-1.311.238-1.93Zm1.71.585A6.12 6.12 0 0 0 11.9 6c0 1.685.682 3.208 1.787 4.313A6.078 6.078 0 0 0 18 12.1c.462 0 .912-.051 1.344-.148l-7.296-7.296Z",
    fill: "#023F80"
  })));
};

var _path$63, _path2$1S;
function _extends$67() { _extends$67 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$67.apply(this, arguments); }
var SvgStopwatchOutline = function SvgStopwatchOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$67({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$63 || (_path$63 = /*#__PURE__*/createElement$2("path", {
    d: "M18.287 11.707a1 1 0 0 0-1.414 0l-2.829 2.829a1 1 0 0 0 1.415 1.414l2.828-2.829a1 1 0 0 0 0-1.414Z",
    fill: "#023F80"
  })), _path2$1S || (_path2$1S = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.588 2a1 1 0 1 0 0 2H13v2.05C7.947 6.55 4 10.814 4 16c0 5.523 4.477 10 10 10s10-4.477 10-10a9.959 9.959 0 0 0-2.269-6.343l1.406-1.406a1 1 0 0 0-1.414-1.414l-1.409 1.408A9.953 9.953 0 0 0 15 6.05V4h1.413a1 1 0 1 0 0-2h-4.825ZM6 16a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z",
    fill: "#023F80"
  })));
};

var _path$64, _path2$1T, _path3$A, _path4$7, _path5$1, _path6$1, _path7$1;
function _extends$68() { _extends$68 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$68.apply(this, arguments); }
var SvgStorefrontOutline = function SvgStorefrontOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$68({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$64 || (_path$64 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14a.9.9 0 0 1 .9.9v4.2h8.2v-4.2a.9.9 0 0 1 1.8 0V20a.9.9 0 0 1-.9.9H7a.9.9 0 0 1-.9-.9v-5.1A.9.9 0 0 1 7 14Z",
    fill: "#023F80"
  })), _path2$1T || (_path2$1T = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 20a.9.9 0 0 1 .9-.9h16.2a.9.9 0 1 1 0 1.8H3.9A.9.9 0 0 1 3 20ZM16.9 10a1.1 1.1 0 0 0 2.2 0h1.8a2.9 2.9 0 0 1-5.8 0h1.8Z",
    fill: "#023F80"
  })), _path3$A || (_path3$A = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9.1a.9.9 0 0 1 .9.9 1.1 1.1 0 0 0 2.2 0 .9.9 0 1 1 1.8 0 2.9 2.9 0 0 1-5.8 0 .9.9 0 0 1 .9-.9Z",
    fill: "#023F80"
  })), _path4$7 || (_path4$7 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9.1a.9.9 0 0 1 .9.9 1.1 1.1 0 0 0 2.2 0 .9.9 0 1 1 1.8 0 2.9 2.9 0 0 1-5.8 0 .9.9 0 0 1 .9-.9Z",
    fill: "#023F80"
  })), _path5$1 || (_path5$1 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.1a.9.9 0 0 1 .9.9 1.1 1.1 0 0 0 2.2 0 .9.9 0 1 1 1.8 0 2.9 2.9 0 0 1-5.8 0 .9.9 0 0 1 .9-.9Z",
    fill: "#023F80"
  })), _path6$1 || (_path6$1 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9.1a.9.9 0 0 1 .9.9 1.1 1.1 0 0 0 2.2 0 .9.9 0 0 1 1.8 0 2.9 2.9 0 0 1-5.8 0 .9.9 0 0 1 .9-.9Z",
    fill: "#023F80"
  })), _path7$1 || (_path7$1 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.703 3.1h6.594c.553 0 1.019-.001 1.453.137a2.9 2.9 0 0 1 1.033.585c.342.301.581.7.865 1.175l.056.094 1.612 2.686.027.045c.143.239.264.44.352.66.077.195.133.397.167.604.038.234.038.47.038.747V10h-1.8v-.114c0-.358-.003-.438-.014-.51a1.1 1.1 0 0 0-.064-.228c-.027-.068-.066-.138-.25-.445L17.16 6.017c-.37-.618-.462-.752-.566-.843a1.1 1.1 0 0 0-.392-.222c-.131-.042-.294-.052-1.014-.052H8.812c-.72 0-.883.01-1.014.052a1.1 1.1 0 0 0-.392.222c-.104.091-.196.225-.566.843L5.228 8.703c-.185.307-.223.377-.25.445a1.1 1.1 0 0 0-.064.228c-.011.072-.014.152-.014.51V10H3.1v-.167c0-.278 0-.513.038-.747a2.9 2.9 0 0 1 .167-.603c.088-.22.209-.422.352-.66l.027-.046L5.296 5.09l.056-.094c.284-.474.523-.874.865-1.175a2.9 2.9 0 0 1 1.033-.585c.434-.138.9-.138 1.453-.137Z",
    fill: "#023F80"
  })));
};

var _path$65, _path2$1U, _path3$B;
function _extends$69() { _extends$69 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$69.apply(this, arguments); }
var SvgStoryAddOutline = function SvgStoryAddOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$69({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$65 || (_path$65 = /*#__PURE__*/createElement$2("path", {
    d: "M13.1 4a1 1 0 0 1 .117 1.993L13.1 6h-1.837c-1.828 0-2.538.144-3.273.558a3.564 3.564 0 0 0-1.446 1.526c-.381.75-.528 1.482-.543 3.211L6 16.407c0 1.946.141 2.716.544 3.51a3.564 3.564 0 0 0 1.446 1.525c.617.347 1.216.505 2.472.546l.26.007.541.005h5.474l.541-.005c1.436-.028 2.074-.183 2.732-.553a3.564 3.564 0 0 0 1.446-1.526c.338-.665.492-1.314.532-2.655l.007-.277.005-.577V14a1 1 0 0 1 1.993-.117L24 14v2.407c0 2.235-.196 3.303-.761 4.415a5.563 5.563 0 0 1-2.248 2.363c-1.018.573-2.002.792-3.925.813l-.33.002h-5.473c-2.143 0-3.18-.21-4.254-.816a5.563 5.563 0 0 1-2.248-2.362c-.537-1.057-.74-2.073-.76-4.088L4 11.593c0-2.235.196-3.303.761-4.415a5.563 5.563 0 0 1 2.248-2.362c1.018-.573 2.002-.793 3.925-.814L13.1 4Z",
    fill: "#023F80"
  })), _path2$1U || (_path2$1U = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9.7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z",
    fill: "#023F80"
  })), _path3$B || (_path3$B = /*#__PURE__*/createElement$2("path", {
    d: "M21 1a1 1 0 0 1 .993.883L22 2v3h3a1 1 0 0 1 .993.883L26 6a1 1 0 0 1-.883.993L25 7h-3v3a1 1 0 0 1-1.993.117L20 10V7h-3a1 1 0 0 1-.993-.883L16 6a1 1 0 0 1 .883-.993L17 5h3V2a1 1 0 0 1 1-1Z",
    fill: "#023F80"
  })));
};

var _path$66;
function _extends$6a() { _extends$6a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6a.apply(this, arguments); }
var SvgStoryOutline = function SvgStoryOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6a({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$66 || (_path$66 = /*#__PURE__*/createElement$2("path", {
    d: "m9.128 3.1 6.046.002c1.56.018 2.367.191 3.204.639a4.534 4.534 0 0 1 1.881 1.88c.476.89.641 1.745.641 3.507v5.744c0 1.762-.165 2.617-.64 3.506a4.534 4.534 0 0 1-1.882 1.881c-.889.476-1.744.641-3.506.641H9.128c-1.762 0-2.617-.165-3.506-.64a4.534 4.534 0 0 1-1.881-1.882c-.476-.889-.641-1.744-.641-3.506l.002-6.046c.018-1.56.191-2.367.639-3.204A4.534 4.534 0 0 1 5.62 3.74c.89-.476 1.745-.641 3.507-.641Zm5.744 1.8H9.128c-1.315 0-1.917.086-2.447.324l-.21.104A2.735 2.735 0 0 0 5.328 6.47C5.01 7.063 4.9 7.638 4.9 9.128v5.744c0 1.315.086 1.917.324 2.447l.104.21c.265.495.648.878 1.143 1.143.523.28 1.032.399 2.167.423l.49.005h5.744c1.315 0 1.917-.086 2.447-.325l.21-.103a2.736 2.736 0 0 0 1.143-1.143c.28-.523.399-1.032.423-2.168l.005-.489V9.128c0-1.315-.086-1.917-.325-2.447l-.103-.21a2.735 2.735 0 0 0-1.143-1.143c-.592-.317-1.167-.428-2.657-.428ZM12 8.1a3.9 3.9 0 1 1 0 7.8 3.9 3.9 0 0 1 0-7.8Zm0 1.8a2.1 2.1 0 1 0 0 4.2 2.1 2.1 0 0 0 0-4.2Z",
    fill: "#023F80"
  })));
};

var _path$67, _path2$1V;
function _extends$6b() { _extends$6b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6b.apply(this, arguments); }
var SvgStudOutline = function SvgStudOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6b({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$67 || (_path$67 = /*#__PURE__*/createElement$2("path", {
    d: "M8 9.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM13 9.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM14.5 13a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM8 14.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
    fill: "#023F80"
  })), _path2$1V || (_path2$1V = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.1A9.872 9.872 0 0 0 5 5a9.872 9.872 0 0 0-2.9 7c0 2.733 1.11 5.21 2.9 7a9.872 9.872 0 0 0 7 2.9c2.734 0 5.21-1.11 7-2.9a9.872 9.872 0 0 0 2.9-7c0-2.734-1.109-5.21-2.9-7a9.872 9.872 0 0 0-7-2.9ZM6.273 6.272A8.072 8.072 0 0 1 12 3.9c2.237 0 4.26.905 5.728 2.372A8.072 8.072 0 0 1 20.1 12c0 2.237-.905 4.26-2.372 5.727A8.072 8.072 0 0 1 12 20.1a8.072 8.072 0 0 1-5.727-2.373A8.072 8.072 0 0 1 3.9 12c0-2.237.906-4.261 2.373-5.728Z",
    fill: "#023F80"
  })));
};

var _path$68;
function _extends$6c() { _extends$6c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6c.apply(this, arguments); }
var SvgSubtitlesOutline = function SvgSubtitlesOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6c({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$68 || (_path$68 = /*#__PURE__*/createElement$2("path", {
    d: "M18.308 4c2.675 0 3.645.278 4.622.801A5.452 5.452 0 0 1 25.2 7.07c.522.978.801 1.948.801 4.623v4.616c0 2.675-.279 3.645-.801 4.622A5.452 5.452 0 0 1 22.93 23.2c-.977.522-1.947.801-4.622.801H9.692c-2.675 0-3.645-.279-4.623-.801a5.452 5.452 0 0 1-2.268-2.269C2.278 19.953 2 18.983 2 16.308v-4.616c0-2.675.278-3.645.801-4.623A5.452 5.452 0 0 1 5.07 4.801C6.047 4.278 7.017 4 9.692 4h8.616Zm.283 2h-8.9c-2.136 0-2.896.147-3.678.565a3.453 3.453 0 0 0-1.448 1.448c-.4.746-.551 1.473-.564 3.396L4 16.309c0 2.136.147 2.896.565 3.678.337.63.818 1.112 1.448 1.448.782.418 1.542.565 3.679.565h8.616c2.137 0 2.898-.147 3.68-.565a3.452 3.452 0 0 0 1.447-1.448c.418-.781.565-1.542.565-3.679v-4.616c0-2.137-.147-2.897-.565-3.68a3.452 3.452 0 0 0-1.448-1.447c-.746-.4-1.473-.551-3.396-.564ZM14 16a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h6Zm6 0a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2h2Zm0-4a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2h6Zm-10 0a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h2Z",
    fill: "#023F80"
  })));
};

var _path$69, _path2$1W;
function _extends$6d() { _extends$6d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6d.apply(this, arguments); }
var SvgSunOutline = function SvgSunOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6d({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$69 || (_path$69 = /*#__PURE__*/createElement$2("path", {
    d: "M15 2a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0V2ZM15 23a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3ZM23.892 20.866a1 1 0 1 0 1-1.732l-2.598-1.5a1 1 0 1 0-1 1.732l2.598 1.5ZM5.706 10.366a1 1 0 1 0 1-1.732l-2.598-1.5a1 1 0 0 0-1 1.732l2.598 1.5ZM2.742 20.5a1 1 0 0 1 .366-1.366l2.598-1.5a1 1 0 1 1 1 1.732l-2.598 1.5a1 1 0 0 1-1.366-.366ZM20.928 10a1 1 0 0 1 .366-1.366l2.598-1.5a1 1 0 1 1 1 1.732l-2.598 1.5A1 1 0 0 1 20.928 10Z",
    fill: "#023F80"
  })), _path2$1W || (_path2$1W = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8.031a5.969 5.969 0 1 0 0 11.938A5.969 5.969 0 0 0 14 8.03ZM9.992 14c0-2.355 1.653-4.008 4.008-4.008s4.016 1.653 4.016 4.008-1.661 4-4.016 4-4.008-1.645-4.008-4Z",
    fill: "#023F80"
  })));
};

var _path$6a;
function _extends$6e() { _extends$6e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6e.apply(this, arguments); }
var SvgSuccessCircleFilled = function SvgSuccessCircleFilled(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6e({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6a || (_path$6a = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.25c6.168 0 11.25-5.092 11.25-11.256C23.25 5.842 18.156.75 12 .75 5.833.75.75 5.842.75 11.994.75 18.158 5.844 23.25 12 23.25Zm-1.337-5.5c-.33 0-.577-.13-.847-.462l-3.33-4.066a1.098 1.098 0 0 1-.236-.64c0-.462.365-.806.788-.806.271 0 .506.107.742.403l2.836 3.591L15.97 7.2c.188-.296.447-.45.694-.45.424 0 .836.284.836.747 0 .17-.075.356-.172.52l-5.865 9.259c-.212.32-.482.474-.8.474Z",
    fill: "#023F80"
  })));
};

var _path$6b;
function _extends$6f() { _extends$6f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6f.apply(this, arguments); }
var SvgSwitchOutline = function SvgSwitchOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6f({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6b || (_path$6b = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 6.203A9.001 9.001 0 0 1 22.945 13H21.16a.556.556 0 0 0-.454.88l2.792 3.888c.222.31.684.31.906 0l2.792-3.888a.556.556 0 0 0-.454-.88h-1.786C24.45 7.394 19.738 3 14 3c-2.002 0-3.882.536-5.5 1.472a1 1 0 1 0 1 1.731ZM3.046 15H1.259a.556.556 0 0 1-.454-.88l2.792-3.888a.558.558 0 0 1 .906 0l2.792 3.888c.264.368 0 .88-.454.88H5.055a9.001 9.001 0 0 0 13.484 6.773 1 1 0 0 1 1.01 1.726C17.92 24.453 16.022 25 14 25 8.262 25 3.55 20.607 3.045 15Z",
    fill: "#023F80"
  })));
};

var _path$6c;
function _extends$6g() { _extends$6g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6g.apply(this, arguments); }
var SvgSyncOutline = function SvgSyncOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6g({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6c || (_path$6c = /*#__PURE__*/createElement$2("path", {
    d: "M21.509 4.5a1 1 0 0 1 1 1V9a1 1 0 0 1-1 1h-3.502a1 1 0 1 1 0-2h1.292a7.975 7.975 0 0 0-5.294-2 8.004 8.004 0 0 0-7.955 7.11 1 1 0 0 1-1.989-.22A10.004 10.004 0 0 1 14.005 4a9.97 9.97 0 0 1 6.503 2.4v-.9a1 1 0 0 1 1-1ZM23.064 14.006a1 1 0 0 1 .885 1.104A10.004 10.004 0 0 1 14.005 24a9.97 9.97 0 0 1-6.503-2.4v.9a1 1 0 0 1-2.001 0V19a1 1 0 0 1 1-1h3.502a1 1 0 1 1 0 2H8.71a7.974 7.974 0 0 0 5.295 2 8.004 8.004 0 0 0 7.955-7.11 1 1 0 0 1 1.104-.884Z",
    fill: "#023F80"
  })));
};

var _path$6d;
function _extends$6h() { _extends$6h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6h.apply(this, arguments); }
var SvgTShirtOutline = function SvgTShirtOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6h({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6d || (_path$6d = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.824 3.61c.442-.737 1.392-1.148 2.283-.735.812.377 2.11 1.118 3.305 2.415 1.355 1.471 1.878 2.854 2.073 3.58l.005.021c.028.1.079.286.064.52a1.47 1.47 0 0 1-.168.58 1.645 1.645 0 0 1-.353.427l-.02.019-2.113 1.956v5.139c0 .462 0 .863-.154 1.32-.12.351-.396.806-.653 1.074-.333.346-.62.495-.954.669l-.03.015c-1.148.595-2.947 1.29-5.109 1.29s-3.961-.695-5.11-1.29l-.029-.015c-.334-.174-.621-.323-.954-.67a3.304 3.304 0 0 1-.653-1.073c-.155-.457-.154-.858-.154-1.32v-5.139l-2.113-1.956-.02-.019c-.082-.075-.24-.218-.353-.427a1.469 1.469 0 0 1-.168-.58 1.53 1.53 0 0 1 .07-.54c.194-.727.717-2.11 2.072-3.58a10.635 10.635 0 0 1 3.305-2.416c.89-.413 1.84-.002 2.282.735.827 1.377 2.823 1.377 3.65 0Zm1.554.911a.09.09 0 0 0-.01.015c-1.526 2.543-5.21 2.542-6.736 0a.097.097 0 0 0-.01-.015c-.67.314-1.735.93-2.71 1.989-1.027 1.115-1.45 2.137-1.618 2.684l2.317 2.146a.9.9 0 0 1 .29.66v5.462c0 .558.008.664.058.81.034.103.172.33.247.408.116.12.168.153.513.332.989.513 2.5 1.088 4.281 1.088 1.782 0 3.292-.575 4.281-1.088.345-.18.397-.211.513-.332.075-.078.213-.305.247-.408.05-.146.059-.252.059-.81V12a.9.9 0 0 1 .289-.66l2.316-2.146c-.167-.547-.59-1.569-1.617-2.684a8.836 8.836 0 0 0-2.71-1.989Z",
    fill: "#023F80"
  })));
};

var _path$6e;
function _extends$6i() { _extends$6i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6i.apply(this, arguments); }
var SvgTagOutline = function SvgTagOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6i({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6e || (_path$6e = /*#__PURE__*/createElement$2("path", {
    d: "m23.353 19.01-4.661 4.6a4.856 4.856 0 0 1-6.822 0l-6.915-6.825A6.57 6.57 0 0 1 3 12.11V7.856A4.856 4.856 0 0 1 7.856 3h4.407a6.57 6.57 0 0 1 4.615 1.894l6.475 6.391a5.427 5.427 0 0 1 .05 7.675l-.05.05Zm-1.405-1.424.032-.031a3.427 3.427 0 0 0-.032-4.846l-6.475-6.392A4.57 4.57 0 0 0 12.263 5H7.856A2.856 2.856 0 0 0 5 7.856v4.254a4.57 4.57 0 0 0 1.36 3.252l6.915 6.825a2.856 2.856 0 0 0 4.012 0l4.661-4.6ZM10 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z",
    fill: "#023F80"
  })));
};

var _path$6f, _path2$1X;
function _extends$6j() { _extends$6j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6j.apply(this, arguments); }
var SvgTargetOutline = function SvgTargetOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6j({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6f || (_path$6f = /*#__PURE__*/createElement$2("path", {
    d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "#023F80"
  })), _path2$1X || (_path2$1X = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9 1.9a.9.9 0 0 0-1.8 0v1.245A8.903 8.903 0 0 0 3.145 11.1H1.9a.9.9 0 1 0 0 1.8h1.245a8.903 8.903 0 0 0 7.955 7.955V22.1a.9.9 0 1 0 1.8 0v-1.245a8.903 8.903 0 0 0 7.955-7.955H22.1a.9.9 0 0 0 0-1.8h-1.245A8.903 8.903 0 0 0 12.9 3.145V1.9Zm-6.8 11H4.956a7.104 7.104 0 0 0 6.144 6.144V17.9a.9.9 0 1 1 1.8 0v1.144a7.104 7.104 0 0 0 6.144-6.144H17.9a.9.9 0 0 1 0-1.8h1.144A7.104 7.104 0 0 0 12.9 4.956V6.1a.9.9 0 0 1-1.8 0V4.956A7.104 7.104 0 0 0 4.956 11.1H6.1a.9.9 0 1 1 0 1.8Z",
    fill: "#023F80"
  })));
};

var _path$6g, _path2$1Y;
function _extends$6k() { _extends$6k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6k.apply(this, arguments); }
var SvgTearOffFlyerOutline = function SvgTearOffFlyerOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6k({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6g || (_path$6g = /*#__PURE__*/createElement$2("path", {
    d: "M8.5 9a1 1 0 0 0 0 2h11a1 1 0 1 0 0-2h-11ZM7.5 15a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2h-11a1 1 0 0 1-1-1Z",
    fill: "#023F80"
  })), _path2$1Y || (_path2$1Y = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.995 3h-3.99c-1.386 0-2.488 0-3.377.074-.91.075-1.685.234-2.394.602a6 6 0 0 0-2.558 2.558c-.368.709-.527 1.484-.602 2.394C3 9.518 3 10.62 3 12.005v3.99c0 1.386 0 2.488.074 3.377.075.91.234 1.686.602 2.394a6 6 0 0 0 2.558 2.559c.709.367 1.484.526 2.394.601.89.074 1.992.074 3.377.074h3.99c1.386 0 2.488 0 3.377-.074.91-.075 1.686-.233 2.394-.601a6 6 0 0 0 2.559-2.56c.367-.707.526-1.483.601-2.393.074-.89.074-1.991.074-3.377v-3.99c0-1.386 0-2.488-.074-3.377-.075-.91-.233-1.685-.601-2.394a6 6 0 0 0-2.56-2.558c-.707-.368-1.483-.527-2.393-.602C18.482 3 17.38 3 15.995 3ZM7.155 5.45c.375-.195.854-.318 1.638-.383C9.59 5 10.61 5 12.05 5h3.9c1.44 0 2.46 0 3.256.067.785.065 1.263.188 1.638.383a4 4 0 0 1 1.706 1.706c.195.375.318.854.383 1.638C23 9.59 23 10.61 23 12.05v3.9c0 1.44 0 2.46-.067 3.256-.065.785-.188 1.263-.383 1.638a4 4 0 0 1-1.706 1.706c-.375.195-.854.318-1.638.383-.352.03-.749.046-1.206.055V20a1 1 0 1 0-2 0v3H12v-3a1 1 0 1 0-2 0v2.988a19.64 19.64 0 0 1-1.206-.055c-.784-.065-1.263-.188-1.638-.383a4 4 0 0 1-1.706-1.706c-.195-.375-.318-.854-.383-1.638C5 18.41 5 17.39 5 15.95v-3.9c0-1.44 0-2.46.067-3.256.065-.784.188-1.263.383-1.638A4 4 0 0 1 7.156 5.45Z",
    fill: "#023F80"
  })));
};

var _path$6h, _path2$1Z;
function _extends$6l() { _extends$6l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6l.apply(this, arguments); }
var SvgTerminales1 = function SvgTerminales1(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6l({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6h || (_path$6h = /*#__PURE__*/createElement$2("path", {
    d: "M11.143 17.143a.857.857 0 0 0 0 1.714h1.714a.857.857 0 1 0 0-1.714h-1.714Z",
    fill: "#023F80"
  })), _path2$1Z || (_path2$1Z = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.143 7.2c0-1.92 0-2.88.374-3.614a3.429 3.429 0 0 1 1.498-1.498c.733-.374 1.693-.374 3.614-.374h2.742c1.92 0 2.88 0 3.614.374.645.329 1.17.853 1.498 1.498.374.734.374 1.694.374 3.614v9.6c0 1.92 0 2.88-.374 3.614a3.428 3.428 0 0 1-1.498 1.498c-.733.374-1.693.374-3.614.374H10.63c-1.92 0-2.88 0-3.614-.374a3.428 3.428 0 0 1-1.498-1.498c-.374-.734-.374-1.694-.374-3.614V7.2Zm5.486-3.771h2.742c.989 0 1.627.001 2.113.04.465.039.638.103.723.146.322.165.585.427.749.75.043.084.108.257.146.723.04.486.04 1.124.04 2.112v9.6c0 .988 0 1.627-.04 2.112-.038.466-.103.639-.146.724a1.714 1.714 0 0 1-.75.749c-.084.043-.257.107-.722.145-.486.04-1.124.041-2.113.041H10.63c-.989 0-1.627 0-2.113-.04-.465-.039-.638-.103-.723-.146a1.714 1.714 0 0 1-.75-.75c-.042-.084-.107-.257-.145-.723-.04-.485-.04-1.124-.04-2.112V7.2c0-.988 0-1.626.04-2.112.038-.466.103-.639.146-.723.164-.323.427-.585.75-.75.084-.043.257-.107.722-.145.486-.04 1.124-.041 2.113-.041Z",
    fill: "#023F80"
  })));
};

var _path$6i, _path2$1_;
function _extends$6m() { _extends$6m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6m.apply(this, arguments); }
var SvgTerminales = function SvgTerminales(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6m({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6i || (_path$6i = /*#__PURE__*/createElement$2("path", {
    d: "M11.143 17.143a.857.857 0 0 0 0 1.714h1.714a.857.857 0 1 0 0-1.714h-1.714Z",
    fill: "#023F80"
  })), _path2$1_ || (_path2$1_ = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.143 7.2c0-1.92 0-2.88.374-3.614a3.429 3.429 0 0 1 1.498-1.498c.733-.374 1.693-.374 3.614-.374h2.742c1.92 0 2.88 0 3.614.374.645.329 1.17.853 1.498 1.498.374.734.374 1.694.374 3.614v9.6c0 1.92 0 2.88-.374 3.614a3.428 3.428 0 0 1-1.498 1.498c-.733.374-1.693.374-3.614.374H10.63c-1.92 0-2.88 0-3.614-.374a3.428 3.428 0 0 1-1.498-1.498c-.374-.734-.374-1.694-.374-3.614V7.2Zm5.486-3.771h2.742c.989 0 1.627.001 2.113.04.465.039.638.103.723.146.322.165.585.427.749.75.043.084.108.257.146.723.04.486.04 1.124.04 2.112v9.6c0 .988 0 1.627-.04 2.112-.038.466-.103.639-.146.724a1.714 1.714 0 0 1-.75.749c-.084.043-.257.107-.722.145-.486.04-1.124.041-2.113.041H10.63c-.989 0-1.627 0-2.113-.04-.465-.039-.638-.103-.723-.146a1.714 1.714 0 0 1-.75-.75c-.042-.084-.107-.257-.145-.723-.04-.485-.04-1.124-.04-2.112V7.2c0-.988 0-1.626.04-2.112.038-.466.103-.639.146-.723.164-.323.427-.585.75-.75.084-.043.257-.107.722-.145.486-.04 1.124-.041 2.113-.041Z",
    fill: "#023F80"
  })));
};

var _path$6j, _path2$1$;
function _extends$6n() { _extends$6n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6n.apply(this, arguments); }
var SvgTextCircleOutline = function SvgTextCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6n({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6j || (_path$6j = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.82 17.186c-.192.643-.466.896-.958.896-.506 0-.854-.308-.854-.772 0-.185.048-.397.164-.745l2.351-6.74c.294-.869.711-1.231 1.49-1.231.773 0 1.183.355 1.477 1.23l2.352 6.74c.096.294.143.52.143.711 0 .493-.348.807-.875.807-.499 0-.786-.26-.97-.896l-.527-1.585H12.34l-.52 1.585Zm2.118-6.733-1.189 3.774h2.461l-1.183-3.774h-.088Z",
    fill: "#023F80"
  })), _path2$1$ || (_path2$1$ = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2C7.373 2 2 7.373 2 14s5.373 12 12 12 12-5.373 12-12S20.627 2 14 2ZM4 14C4 8.477 8.477 4 14 4s10 4.477 10 10-4.477 10-10 10S4 19.523 4 14Z",
    fill: "#023F80"
  })));
};

var _path$6k, _path2$20, _path3$C;
function _extends$6o() { _extends$6o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6o.apply(this, arguments); }
var SvgTextLiveOutline = function SvgTextLiveOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6o({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6k || (_path$6k = /*#__PURE__*/createElement$2("path", {
    d: "M19.412 5.287A9.964 9.964 0 0 1 22 12c0 2.583-.98 4.938-2.588 6.713m-14.824 0A9.963 9.963 0 0 1 2 12c0-2.584.98-4.938 2.588-6.713M16.585 8.13A5.976 5.976 0 0 1 18 12a5.976 5.976 0 0 1-1.415 3.87m-9.17 0A5.976 5.976 0 0 1 6 12c0-1.475.532-2.825 1.415-3.87M12 14.5V10M10 10h4",
    stroke: "#023F80",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$20 || (_path2$20 = /*#__PURE__*/createElement$2("path", {
    d: "M5.255 5.892a.9.9 0 1 0-1.334-1.21A10.863 10.863 0 0 0 1.1 12c0 2.816 1.069 5.383 2.82 7.317a.9.9 0 0 0 1.335-1.209A9.063 9.063 0 0 1 2.9 12c0-2.351.89-4.493 2.355-6.108ZM20.08 4.683a.9.9 0 0 0-1.335 1.209A9.064 9.064 0 0 1 21.1 12c0 2.351-.89 4.493-2.355 6.108a.9.9 0 1 0 1.334 1.21A10.863 10.863 0 0 0 22.9 12c0-2.815-1.069-5.383-2.82-7.317Z",
    fill: "#023F80"
  })), _path3$C || (_path3$C = /*#__PURE__*/createElement$2("path", {
    d: "M8.102 8.71A.9.9 0 1 0 6.727 7.55 6.876 6.876 0 0 0 5.1 12c0 1.695.613 3.25 1.627 4.451a.9.9 0 1 0 1.375-1.162A5.076 5.076 0 0 1 6.9 12c0-1.254.452-2.4 1.202-3.29ZM17.273 7.549a.9.9 0 1 0-1.375 1.162A5.076 5.076 0 0 1 17.1 12c0 1.254-.452 2.4-1.202 3.29a.9.9 0 0 0 1.375 1.161A6.876 6.876 0 0 0 18.9 12c0-1.695-.613-3.25-1.627-4.451ZM12.9 10.9H14a.9.9 0 0 0 0-1.8h-4a.9.9 0 1 0 0 1.8h1.1v3.6a.9.9 0 1 0 1.8 0v-3.6Z",
    fill: "#023F80"
  })));
};

var _path$6l;
function _extends$6p() { _extends$6p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6p.apply(this, arguments); }
var SvgTextOutline = function SvgTextOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6p({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6l || (_path$6l = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.038 18.111c.566 0 .881-.278 1.104-1.002l.872-2.616h4.583l.872 2.616c.213.715.547 1.002 1.113 1.002.603 0 1.002-.352 1.002-.909 0-.232-.056-.482-.158-.788L8.947 6.57c-.315-.937-.77-1.336-1.614-1.336-.844 0-1.299.409-1.624 1.336L2.23 16.414c-.12.352-.176.593-.176.816 0 .538.4.881.984.881Zm2.477-5.232 1.744-5.353h.102l1.735 5.353H5.515ZM19.765 16.729h.102v.436c.046.585.408.928.974.928.64 0 1.002-.408 1.002-1.113v-5.613c0-2.134-1.383-3.322-3.86-3.322-1.02 0-1.8.177-2.393.501-.826.446-1.216 1.002-1.216 1.568 0 .446.297.752.752.752.353 0 .594-.093.844-.334.566-.575 1.104-.854 1.883-.854 1.253 0 1.93.575 1.93 1.68v.871h-2.449c-2.19.01-3.507 1.114-3.507 2.923 0 1.781 1.29 2.987 3.2 2.987 1.216 0 2.2-.5 2.738-1.41Zm-3.869-1.68c0-.9.63-1.41 1.726-1.41h2.161v1.058c0 1.058-.918 1.874-2.115 1.874-1.058 0-1.772-.612-1.772-1.521Z",
    fill: "#023F80"
  })));
};

var _path$6m, _path2$21;
function _extends$6q() { _extends$6q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6q.apply(this, arguments); }
var SvgTextTtOutline = function SvgTextTtOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6m || (_path$6m = /*#__PURE__*/createElement$2("path", {
    d: "M7.1 6.8h1.8v11.3a.9.9 0 1 1-1.8 0V6.8ZM2 5.9a.9.9 0 0 1 .9-.9h10.2a.9.9 0 1 1 0 1.8H2.9a.9.9 0 0 1-.9-.9ZM12 9.9a.9.9 0 0 1 .9-.9h8.2a.9.9 0 1 1 0 1.8h-8.2a.9.9 0 0 1-.9-.9Z",
    fill: "#023F80"
  })), _path2$21 || (_path2$21 = /*#__PURE__*/createElement$2("path", {
    d: "M16.1 10.796h1.8V18.1a.9.9 0 1 1-1.8 0v-7.304Z",
    fill: "#023F80"
  })));
};

var _path$6n;
function _extends$6r() { _extends$6r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6r.apply(this, arguments); }
var SvgThumbsUpOutline = function SvgThumbsUpOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6r({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6n || (_path$6n = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.521 9.206.582-.582a.39.39 0 0 0 .104-.187l.978-4.207a2.895 2.895 0 0 1 5.715.655V7.1h.1c1.854 0 3.392.394 4.449 1.451S21.9 11.146 21.9 13v1c0 1.922-.553 3.442-1.663 4.472C19.14 19.491 17.638 19.9 16 19.9H8.45a2.4 2.4 0 0 1-1.329.918c-.31.083-.658.083-1.031.082h-.18c-.373 0-.722.001-1.031-.082a2.4 2.4 0 0 1-1.697-1.697c-.083-.31-.083-.658-.082-1.031v-7.18c0-.373-.001-.722.082-1.031a2.4 2.4 0 0 1 1.697-1.697c.31-.083.658-.083 1.031-.082h.18c.373 0 .722-.001 1.031.082a2.4 2.4 0 0 1 1.4 1.024Zm3.418-4.569a1.095 1.095 0 0 1 2.161.248V8a.9.9 0 0 0 .9.9h1c1.646 0 2.608.356 3.176.924.568.568.924 1.53.924 3.176v1c0 1.579-.447 2.558-1.087 3.153-.653.606-1.651.947-3.013.947-.602 0-7.1.01-7.1-.01v-6.717l1.476-1.476c.289-.29.492-.654.584-1.052l.979-4.208ZM7.1 11.006V18c0 .523-.008.608-.02.655a.6.6 0 0 1-.425.425c-.047.012-.132.02-.655.02s-.608-.008-.655-.02a.6.6 0 0 1-.425-.425c-.012-.047-.02-.132-.02-.655v-7c0-.523.008-.608.02-.655a.6.6 0 0 1 .425-.425c.047-.012.132-.02.655-.02s.608.008.655.02a.6.6 0 0 1 .425.425c.012.047.017.139.02.66Z",
    fill: "#023F80"
  })));
};

var _path$6o;
function _extends$6s() { _extends$6s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6s.apply(this, arguments); }
var SvgTicketOutline = function SvgTicketOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6s({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6o || (_path$6o = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.376 3.405c-.57-.57-1.042-1.041-1.459-1.393-.425-.36-.856-.651-1.369-.818a4 4 0 0 0-2.472 0c-.518.169-.953.464-1.383.83-.414.35-.884.82-1.453 1.39L3.414 12.24c-.57.57-1.04 1.04-1.39 1.453-.366.43-.661.865-.83 1.383a4 4 0 0 0 0 2.472c.167.513.458.944.818 1.37.352.416.823.887 1.393 1.458a1 1 0 0 0 1.336.07 2 2 0 0 1 2.812 2.813 1 1 0 0 0 .071 1.336c.57.57 1.042 1.042 1.458 1.393.426.36.857.651 1.37.818a3.999 3.999 0 0 0 2.472 0c.518-.169.953-.464 1.383-.83.414-.35.884-.82 1.453-1.39l8.826-8.826c.57-.57 1.04-1.04 1.39-1.453.366-.43.661-.865.83-1.383a4 4 0 0 0 0-2.472c-.167-.513-.458-.944-.818-1.37-.352-.416-.823-.887-1.393-1.458a1 1 0 0 0-1.336-.07 2 2 0 0 1-2.813-2.813 1 1 0 0 0-.07-1.336Zm-3.446-.309c.165.054.367.165.697.443.218.185.465.419.773.721a4 4 0 0 0 5.34 5.34c.302.308.536.555.72.774.28.329.39.53.444.696a2 2 0 0 1 0 1.236c-.055.167-.167.371-.452.707-.292.344-.703.756-1.31 1.362l-1.676 1.677-1.259-1.26a1 1 0 0 0-1.414 1.415l1.259 1.259-5.677 5.677c-.606.606-1.018 1.017-1.363 1.31-.335.284-.54.396-.706.45a2 2 0 0 1-1.236 0c-.165-.053-.367-.164-.697-.442a14.504 14.504 0 0 1-.772-.721 4 4 0 0 0-5.34-5.34 14.448 14.448 0 0 1-.722-.773c-.278-.33-.389-.532-.443-.697a2 2 0 0 1 0-1.236c.055-.167.167-.371.452-.707.292-.344.703-.756 1.31-1.362l5.676-5.677 1.259 1.26a1 1 0 1 0 1.414-1.415l-1.259-1.259 1.677-1.677c.606-.606 1.018-1.017 1.363-1.309.335-.285.54-.397.706-.452a2 2 0 0 1 1.236 0Zm-.973 7.447a1 1 0 0 0-1.414 1.414l1.5 1.5a1 1 0 0 0 1.414-1.414l-1.5-1.5Z",
    fill: "#023F80"
  })));
};

var _path$6p;
function _extends$6t() { _extends$6t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6t.apply(this, arguments); }
var SvgTouchIdOutline = function SvgTouchIdOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6t({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6p || (_path$6p = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.493 5h-.9c-4.039 0-8.64 3.84-8.64 9.056v6.742a1 1 0 0 1-2 0v-6.742C2.952 7.98 8.102 3 13.592 3c.37 0 .736.018 1.098.054a1 1 0 0 1 .896 1.094c-.054.55-.547.888-1.094.852Zm3.48.914a1 1 0 0 1-.516-1.316c.221-.506.817-.751 1.317-.516 3.457 1.625 6.276 5.395 6.223 9.94v1.973a1 1 0 1 1-2 0v-1.973c-.017-3.476-2.122-6.784-5.024-8.108Zm5.024 14.107a1 1 0 1 1 2 0v1.985a1 1 0 0 1-2 0V20.02ZM14 9c-2.761 0-5 2.489-5 5.25a1 1 0 0 1-1 1c-.552 0-.992-.448-1-1C6.938 9.943 10.266 7 14 7c.603 0 1.19.076 1.75.22a1 1 0 1 1-.5 1.937A5.01 5.01 0 0 0 14 9Zm4.069.542a1 1 0 0 1 1.412.078C20.604 10.875 21 12.446 21 14.25v6.5a1 1 0 1 1-2 0v-6.5c0-1.281-.217-2.41-1.01-3.296a1 1 0 0 1 .079-1.412ZM8 17.212a1 1 0 0 1 1 1v3.968a1 1 0 1 1-2 0v-3.969a1 1 0 0 1 1-1Zm6-4.204a1 1 0 0 0-1 1v8.984a1 1 0 1 1-2 0v-8.984a3 3 0 0 1 6 0v1.984a1 1 0 0 1-2 0v-1.984a1 1 0 0 0-1-1Zm2 6.008a1 1 0 0 1 1 1v3.96a1 1 0 1 1-2 0v-3.96a1 1 0 0 1 1-1Z",
    fill: "#023F80"
  })));
};

var _path$6q;
function _extends$6u() { _extends$6u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6u.apply(this, arguments); }
var SvgTrainOutline = function SvgTrainOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6u({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6q || (_path$6q = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2h-.044c-1.363 0-2.447 0-3.321.071-.896.074-1.66.227-2.359.583a6 6 0 0 0-2.622 2.622c-.356.7-.51 1.463-.583 2.359C4 8.509 4 9.593 4 10.956V16.643c0 1.084 0 1.958.058 2.666.06.729.185 1.369.487 1.961a5 5 0 0 0 2.185 2.185c.142.073.287.135.436.189l-.594 1.485a1 1 0 0 0 1.856.742L9.177 24h9.646l.748 1.871a1 1 0 0 0 1.857-.742l-.594-1.486c.149-.053.294-.116.436-.188a5 5 0 0 0 2.185-2.185c.302-.592.428-1.232.487-1.961C24 18.6 24 17.727 24 16.643V10.956c0-1.363 0-2.447-.071-3.321-.074-.896-.227-1.66-.583-2.359a6 6 0 0 0-2.622-2.622c-.7-.356-1.463-.51-2.359-.583C17.491 2 16.407 2 15.044 2H13Zm3.68 20c1.094 0 1.863-.002 2.466-.051.605-.05.953-.142 1.216-.276a3 3 0 0 0 1.311-1.311c.134-.263.226-.611.276-1.216.05-.617.051-1.41.051-2.546V16H6v.6c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.603.049 1.372.05 2.467.051h5.359ZM6 14h16v-3c0-1.417 0-2.419-.065-3.203-.063-.771-.182-1.243-.371-1.613a4 4 0 0 0-1.748-1.748c-.37-.189-.841-.308-1.613-.371A19.684 19.684 0 0 0 17 4.01a3 3 0 0 1-6 0c-.457.01-.851.025-1.203.054-.771.063-1.243.182-1.613.371a4 4 0 0 0-1.748 1.748c-.189.37-.308.842-.371 1.613C6 8.581 6 9.583 6 11v3Zm7-10a1 1 0 0 0 2 0h-2ZM9 18a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2H9Zm8 1a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Z",
    fill: "#023F80"
  })));
};

var _path$6r;
function _extends$6v() { _extends$6v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6v.apply(this, arguments); }
var SvgTshirtOutline = function SvgTshirtOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6v({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6r || (_path$6r = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.788 11.635c.434.109.65.163.812.284a1 1 0 0 1 .322.413c.078.186.078.409.078.856v8.486l.001.207a4.407 4.407 0 0 0 .025.039c.906.427 2.878 1.08 6.475 1.08 2.947 0 4.659-.63 5.477-1.047l.011-.02.01-.016.001-.018.001-.225v-8.486c0-.447 0-.67.078-.856a.999.999 0 0 1 .323-.413c.161-.12.378-.175.81-.283l.288-.072.004-.002.1-.03c.099-.034.262-.095.473-.189a7.994 7.994 0 0 0 1.365-.788l-2.076-3.636A3.809 3.809 0 0 0 18.059 5h-.016c-2.027 2.668-6.059 2.668-8.086 0h-.013a3.81 3.81 0 0 0-3.308 1.92L4.56 10.554a7.98 7.98 0 0 0 1.365.788 5.45 5.45 0 0 0 .573.22H6.5l.287.072ZM22.001 13.5s1.38-.345 2.994-1.61c.624-.488.732-1.367.339-2.056l-2.232-3.907A5.808 5.808 0 0 0 18.06 3h-.57a.932.932 0 0 0-.767.403l-.182.264c-1.226 1.778-3.854 1.778-5.08 0l-.183-.265A.93.93 0 0 0 10.511 3h-.567A5.81 5.81 0 0 0 4.9 5.927L2.667 9.834c-.393.689-.285 1.568.339 2.057C4.619 13.155 6 13.5 6 13.5v8.174c0 .383 0 .574.113.895.07.198.326.606.474.754.24.24.338.287.531.38 1.2.576 3.48 1.297 7.383 1.297 3.253 0 5.282-.7 6.397-1.272.208-.106.311-.16.542-.398.146-.151.386-.544.454-.743.107-.314.107-.514.107-.913V13.5Z",
    fill: "#023F80"
  })));
};

var _path$6s;
function _extends$6w() { _extends$6w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6w.apply(this, arguments); }
var SvgTvOutline = function SvgTvOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6w({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6s || (_path$6s = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6 4c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C26 7.04 26 8.16 26 10.4v4.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C22.96 21 21.84 21 19.6 21h-1.1l1.133 1.36a1 1 0 0 1-.768 1.64h-9.73a1 1 0 0 1-.768-1.64L9.5 21H8.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 17.96 2 16.84 2 14.6v-4.2c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C5.04 4 6.16 4 8.4 4h11.2Zm4.4 6.4v4.2c0 1.153-.002 1.898-.048 2.464-.044.544-.12.745-.17.844a2 2 0 0 1-.874.874c-.099.05-.3.126-.844.17-.566.046-1.31.048-2.464.048H8.4c-1.153 0-1.898-.002-2.464-.048-.544-.044-.745-.12-.844-.17a2 2 0 0 1-.874-.874c-.05-.099-.126-.3-.17-.844C4.002 16.498 4 15.754 4 14.6v-4.2c0-1.153.002-1.898.048-2.464.044-.544.12-.745.17-.844a2 2 0 0 1 .874-.874c.099-.05.3-.126.844-.17C6.502 6.002 7.246 6 8.4 6h11.2c1.153 0 1.898.002 2.464.048.544.044.745.12.844.17a2 2 0 0 1 .874.874c.05.099.126.3.17.844.046.566.048 1.31.048 2.464Z",
    fill: "#023F80"
  })));
};

var _path$6t, _path2$22;
function _extends$6x() { _extends$6x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6x.apply(this, arguments); }
var SvgUnarchiveOutline = function SvgUnarchiveOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6x({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6t || (_path$6t = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.165 3.1h11.67c.53 0 .981 0 1.352.03.389.032.768.102 1.13.286a2.9 2.9 0 0 1 1.267 1.267c.184.362.254.74.286 1.13.03.37.03.822.03 1.352v.265c0 .254 0 .496-.017.7-.018.222-.06.478-.19.733a1.9 1.9 0 0 1-.83.83c-.255.13-.51.172-.733.19-.204.017-.446.017-.7.017H4.57c-.254 0-.496 0-.7-.017a1.922 1.922 0 0 1-.733-.19 1.9 1.9 0 0 1-.83-.83 1.922 1.922 0 0 1-.19-.733 9.126 9.126 0 0 1-.017-.7v-.265c0-.53 0-.981.03-1.352.032-.39.102-.768.286-1.13a2.9 2.9 0 0 1 1.267-1.267c.362-.184.74-.254 1.13-.286.37-.03.822-.03 1.352-.03ZM4.96 4.924c-.278.023-.394.062-.46.096a1.1 1.1 0 0 0-.48.48c-.034.066-.073.182-.096.46-.023.288-.024.665-.024 1.24v.2c0 .295 0 .462.01.583a.849.849 0 0 0 .01.077.1.1 0 0 0 .02.02.84.84 0 0 0 .076.01c.122.01.29.01.584.01h14.8c.295 0 .462 0 .584-.01a.84.84 0 0 0 .075-.01.099.099 0 0 0 .021-.02.823.823 0 0 0 .01-.077c.01-.121.01-.288.01-.583v-.2c0-.575 0-.952-.024-1.24-.023-.278-.062-.394-.096-.46a1.1 1.1 0 0 0-.48-.48c-.067-.034-.182-.073-.46-.096-.288-.023-.665-.024-1.24-.024H6.2c-.575 0-.952 0-1.24.024Z",
    fill: "#023F80"
  })), _path2$22 || (_path2$22 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.835 20.9h-7.67c-.53 0-.981 0-1.352-.03-.39-.032-.768-.102-1.13-.286a2.9 2.9 0 0 1-1.267-1.267c-.184-.362-.254-.741-.286-1.13-.03-.37-.03-.822-.03-1.352V8.1h15.8v8.735c0 .53 0 .981-.03 1.352-.032.389-.102.768-.286 1.13a2.9 2.9 0 0 1-1.267 1.267c-.362.184-.741.254-1.13.286-.37.03-.822.03-1.352.03ZM5.9 9.9h12.2v6.9c0 .575 0 .952-.024 1.24-.023.278-.062.393-.096.46a1.101 1.101 0 0 1-.48.48c-.067.034-.182.073-.46.096-.288.023-.665.024-1.24.024h-2.9v-3.963l.85.886a.9.9 0 1 0 1.3-1.246l-2.4-2.5a.9.9 0 0 0-1.286-.013l-2.5 2.5a.9.9 0 1 0 1.272 1.272l.964-.963V19.1H8.2c-.575 0-.952 0-1.24-.024-.278-.023-.394-.062-.46-.096a1.1 1.1 0 0 1-.48-.48c-.034-.067-.073-.182-.096-.46-.023-.288-.024-.665-.024-1.24V9.9Z",
    fill: "#023F80"
  })));
};

var _path$6u, _path2$23;
function _extends$6y() { _extends$6y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6y.apply(this, arguments); }
var SvgUnblockOutline = function SvgUnblockOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6y({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6u || (_path$6u = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.9a8.1 8.1 0 1 0 0 16.2 8.1 8.1 0 0 0 0-16.2ZM2.1 12c0-5.468 4.432-9.9 9.9-9.9s9.9 4.432 9.9 9.9-4.432 9.9-9.9 9.9-9.9-4.432-9.9-9.9Z",
    fill: "#023F80"
  })), _path2$23 || (_path2$23 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12a.9.9 0 0 1 .9-.9h8.2a.9.9 0 0 1 0 1.8H7.9A.9.9 0 0 1 7 12Z",
    fill: "#023F80"
  })));
};

var _path$6v;
function _extends$6z() { _extends$6z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6z.apply(this, arguments); }
var SvgUnfavoriteOutline = function SvgUnfavoriteOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6z({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6v || (_path$6v = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.782 4.005c.818-1.976 3.618-1.976 4.436 0l1.4 3.383 3.565.23c2.136.138 3.037 2.792 1.426 4.201l-1.477 1.292a.9.9 0 1 1-1.185-1.354l1.477-1.292a.6.6 0 0 0-.357-1.05l-4.125-.267a.9.9 0 0 1-.774-.554l-1.614-3.9a.6.6 0 0 0-1.109 0c-.203.492-.68.835-1.226.61-.545-.227-.64-.806-.437-1.299ZM12 18.54l3.022 1.743c1.456.84 3.149-.035 3.526-1.462l1.416 1.415a.9.9 0 1 0 1.272-1.272l-15.2-15.2a.9.9 0 0 0-1.272 1.272l2.428 2.429-2.375.153C2.68 7.756 1.78 10.41 3.39 11.819l2.856 2.5-.802 3.322c-.495 2.05 1.706 3.696 3.533 2.642L12 18.539ZM4.933 9.413a.6.6 0 0 0-.357 1.05l3.267 2.859a.9.9 0 0 1 .282.888l-.93 3.852a.6.6 0 0 0 .883.66l3.472-2.003a.9.9 0 0 1 .9 0l3.472 2.004a.6.6 0 0 0 .883-.66l-.284-1.177a.915.915 0 0 1-.02-.113L8.886 9.159l-3.953.255Z",
    fill: "#023F80"
  })));
};

var _path$6w;
function _extends$6A() { _extends$6A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6A.apply(this, arguments); }
var SvgUnpinOutline = function SvgUnpinOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6A({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6w || (_path$6w = /*#__PURE__*/createElement$2("path", {
    d: "m12.37 8.954 1.414 1.414 3.889 3.89 1.415 1.414 4.62 4.62a1 1 0 0 1-1.415 1.415l-4.37-4.37-.398 5.17a1.375 1.375 0 0 1-2.343.867l-4.55-4.55-5.657 5.657c-.943.943-2.357-.471-1.414-1.414l5.657-5.657-4.55-4.55a1.375 1.375 0 0 1 .867-2.343l5.17-.398-4.412-4.412a1 1 0 0 1 1.414-1.414l4.662 4.662h.001Zm2.121-2.121.416-.416a.5.5 0 0 0 .137-.255l.441-2.206a1 1 0 0 1 1.688-.511l7.424 7.424a1 1 0 0 1-.51 1.688l-2.207.441a.5.5 0 0 0-.255.137l-.416.415a1 1 0 0 1-1.414-1.414l.415-.415a2.5 2.5 0 0 1 1.278-.684l.374-.075L17.08 6.18l-.075.374a2.5 2.5 0 0 1-.684 1.278l-.415.415a1 1 0 1 1-1.415-1.414Zm-2.173 4.9a2.5 2.5 0 0 1-1.102.353l-4.173.32L15.635 21l.321-4.173a2.5 2.5 0 0 1 .354-1.102l-3.992-3.992Z",
    fill: "#023F80"
  })));
};

var _path$6x;
function _extends$6B() { _extends$6B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6B.apply(this, arguments); }
var SvgUploadOutline = function SvgUploadOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6B({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6x || (_path$6x = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.364 2.364a.9.9 0 0 1 1.272 0l6 6a.9.9 0 1 1-1.272 1.272L12.9 5.173V16a.9.9 0 0 1-1.8 0V5.173L6.636 9.636a.9.9 0 0 1-1.272-1.272l6-6ZM4.1 20a.9.9 0 0 1 .9-.9h14a.9.9 0 1 1 0 1.8H5a.9.9 0 0 1-.9-.9Z",
    fill: "#023F80"
  })));
};

var _path$6y, _path2$24;
function _extends$6C() { _extends$6C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6C.apply(this, arguments); }
var SvgUserAddBadgeOutline = function SvgUserAddBadgeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6C({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6y || (_path$6y = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm0-2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM19 26a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm1-9a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z",
    fill: "#023F80"
  })), _path2$24 || (_path2$24 = /*#__PURE__*/createElement$2("path", {
    d: "M11.187 17.739a1 1 0 0 0-.374-1.965c-2.728.52-4.228 1.714-5.021 2.909a4.9 4.9 0 0 0-.686 1.553 4.012 4.012 0 0 0-.104.677 2.115 2.115 0 0 0-.002.053v.032S5 21 6 21H5v.5A2.5 2.5 0 0 0 7.5 24h3a1 1 0 1 0 0-2h-3a.5.5 0 0 1-.5-.5v-.488l.004-.05c.006-.052.018-.141.046-.256.056-.23.17-.559.408-.917.457-.689 1.457-1.617 3.73-2.05Z",
    fill: "#023F80"
  })));
};

var _path$6z;
function _extends$6D() { _extends$6D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6D.apply(this, arguments); }
var SvgUserAddOutline = function SvgUserAddOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6D({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6z || (_path$6z = /*#__PURE__*/createElement$2("path", {
    d: "M18.85 7.95A2.849 2.849 0 0 0 16 5.1a2.849 2.849 0 0 0-2.85 2.85A2.849 2.849 0 0 0 16 10.8a2.849 2.849 0 0 0 2.85-2.85Zm1.8 0A4.649 4.649 0 0 1 16 12.6a4.649 4.649 0 0 1-4.65-4.65A4.649 4.649 0 0 1 16 3.3a4.649 4.649 0 0 1 4.65 4.65ZM9.9 18.429c0 .768-.09.671.335.671h11.53c.426 0 .335.097.335-.671 0-1.893-2.778-3.029-6.1-3.029-3.322 0-6.1 1.136-6.1 3.029ZM16 13.6c4.227 0 7.9 1.502 7.9 4.829 0 1.735-.685 2.471-2.135 2.471h-11.53c-1.45 0-2.135-.736-2.135-2.471 0-3.327 3.673-4.829 7.9-4.829ZM5 6.5a.9.9 0 0 1 .9.9l-.001 2.7H8.6a.9.9 0 1 1 0 1.8H5.899l.001 2.7a.9.9 0 0 1-1.8 0l-.001-2.7H1.4a.9.9 0 0 1 0-1.8h2.699L4.1 7.4a.9.9 0 0 1 .9-.9Z",
    fill: "#023F80"
  })));
};

var _path$6A;
function _extends$6E() { _extends$6E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6E.apply(this, arguments); }
var SvgUserAddedOutline = function SvgUserAddedOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6E({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6A || (_path$6A = /*#__PURE__*/createElement$2("path", {
    d: "M18.85 7.95A2.849 2.849 0 0 0 16 5.1a2.849 2.849 0 0 0-2.85 2.85A2.849 2.849 0 0 0 16 10.8a2.849 2.849 0 0 0 2.85-2.85Zm1.8 0A4.649 4.649 0 0 1 16 12.6a4.649 4.649 0 0 1-4.65-4.65A4.649 4.649 0 0 1 16 3.3a4.649 4.649 0 0 1 4.65 4.65ZM9.9 18.429c0 .768-.09.671.335.671h11.53c.426 0 .335.097.335-.671 0-1.893-2.778-3.029-6.1-3.029-3.322 0-6.1 1.136-6.1 3.029ZM16 13.6c4.227 0 7.9 1.502 7.9 4.829 0 1.735-.685 2.471-2.135 2.471h-11.53c-1.45 0-2.135-.736-2.135-2.471 0-3.327 3.673-4.829 7.9-4.829ZM9.636 8.864a.9.9 0 0 1 0 1.272l-5 5a.9.9 0 0 1-1.272 0l-2.5-2.5a.9.9 0 0 1 1.272-1.272L4 13.227l4.364-4.363a.9.9 0 0 1 1.272 0Z",
    fill: "#023F80"
  })));
};

var _path$6B;
function _extends$6F() { _extends$6F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6F.apply(this, arguments); }
var SvgUserBackgroundOutline = function SvgUserBackgroundOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6F({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6B || (_path$6B = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.707 3.293a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1-1.414-1.414l2-2a1 1 0 0 1 1.414 0Zm6 0a1 1 0 0 1 0 1.414l-1.5 1.5a1 1 0 0 1-1.414-1.414l1.5-1.5a1 1 0 0 1 1.414 0Zm-4.5 4.5a1 1 0 0 1 0 1.414l-3.5 3.5a1 1 0 0 1-1.414-1.414l3.5-3.5a1 1 0 0 1 1.414 0Zm15 10.414 1.5-1.5a1 1 0 0 0-1.414-1.414l-1.5 1.5a1 1 0 0 0 1.414 1.414Zm-4.5-14.914a1 1 0 0 1 0 1.414l-1 1a1 1 0 1 1-1.414-1.414l1-1a1 1 0 0 1 1.414 0Zm-10.5 10.5a1 1 0 0 1 0 1.414l-3.5 3.5a1 1 0 0 1-1.414-1.414l3.5-3.5a1 1 0 0 1 1.414 0Zm16.5-3.086a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 1.414 1.414l3-3Zm-1-6.414a1 1 0 0 1 0 1.414l-3 3a1 1 0 1 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0ZM21.5 22.429c0-3.387-3.503-4.929-7.5-4.929s-7.5 1.542-7.5 4.929C6.5 24.203 7.19 25 8.647 25h10.706c1.458 0 2.147-.797 2.147-2.571Zm-13 0c0-1.834 2.488-2.929 5.5-2.929s5.5 1.095 5.5 2.929c0 .28-.017.462-.03.56l-.002.014-.013-.001L19.43 23H8.564l-.02.002-.013.001-.001-.015a4.427 4.427 0 0 1-.03-.56Zm9.75-10.679A4.25 4.25 0 0 0 14 7.5a4.25 4.25 0 0 0-4.25 4.25A4.25 4.25 0 0 0 14 16a4.25 4.25 0 0 0 4.25-4.25Zm-6.5 0a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 1 1-4.5 0Z",
    fill: "#023F80"
  })));
};

var _path$6C, _path2$25;
function _extends$6G() { _extends$6G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6G.apply(this, arguments); }
var SvgUserCircleOutline = function SvgUserCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6G({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6C || (_path$6C = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.8a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4Zm-3.5 1.7a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z",
    fill: "#023F80"
  })), _path2$25 || (_path2$25 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.1A9.872 9.872 0 0 0 5 5a9.872 9.872 0 0 0-2.9 7c0 2.733 1.11 5.21 2.9 7a9.872 9.872 0 0 0 7 2.9c2.734 0 5.21-1.11 7-2.9a9.872 9.872 0 0 0 2.9-7c0-2.734-1.109-5.21-2.9-7a9.872 9.872 0 0 0-7-2.9Zm4.383 16.713A7.067 7.067 0 0 0 12 17.3a7.066 7.066 0 0 0-4.382 1.513A8.06 8.06 0 0 0 12 20.1a8.06 8.06 0 0 0 4.383-1.287ZM6.273 6.273A8.072 8.072 0 0 1 12 3.9c2.237 0 4.26.906 5.728 2.372A8.072 8.072 0 0 1 20.1 12a8.07 8.07 0 0 1-2.297 5.651A8.868 8.868 0 0 0 12 15.5a8.869 8.869 0 0 0-5.803 2.151A8.07 8.07 0 0 1 3.9 12c0-2.237.906-4.26 2.373-5.728ZM8.5 10.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM12 8.8a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4Z",
    fill: "#023F80"
  })));
};

var _path$6D;
function _extends$6H() { _extends$6H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6H.apply(this, arguments); }
var SvgUserIncomingOutline = function SvgUserIncomingOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6H({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6D || (_path$6D = /*#__PURE__*/createElement$2("path", {
    d: "M10.25 15c4.951 0 9.25 1.763 9.25 5.643 0 2.016-.781 2.857-2.456 2.857H3.456C1.78 23.5 1 22.66 1 20.643 1 16.763 5.299 15 10.25 15Zm0 2C6.304 17 3 18.355 3 20.643c0 .89-.071.863.372.858l13.672-.001c.536 0 .456.086.456-.857 0-2.288-3.304-3.643-7.25-3.643Zm12.457-9.707a1 1 0 0 1 0 1.414L20.414 11H26a1 1 0 0 1 .993.883L27 12a1 1 0 0 1-1 1h-5.586l2.293 2.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0ZM10 3c3.039 0 5.5 2.461 5.5 5.5S13.039 14 10 14a5.499 5.499 0 0 1-5.5-5.5C4.5 5.461 6.961 3 10 3Zm0 2a3.499 3.499 0 0 0-3.5 3.5c0 1.934 1.566 3.5 3.5 3.5s3.5-1.566 3.5-3.5S11.934 5 10 5Z",
    fill: "#023F80"
  })));
};

var _path$6E;
function _extends$6I() { _extends$6I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6I.apply(this, arguments); }
var SvgUserMicrophoneBadgeOutline = function SvgUserMicrophoneBadgeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6I({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6E || (_path$6E = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 14.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm0-2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM19 27a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm-7.018-10.431a1 1 0 0 1-.795 1.17c-2.272.433-3.272 1.361-3.729 2.05a2.902 2.902 0 0 0-.408.917 2.016 2.016 0 0 0-.05.306v.488a.5.5 0 0 0 .5.5h3a1 1 0 1 1 0 2h-3A2.5 2.5 0 0 1 5 21.5V21h1c-1 0-1-.002-1-.002v-.032a2.115 2.115 0 0 1 .015-.215c.014-.13.04-.306.091-.515a4.9 4.9 0 0 1 .686-1.553c.793-1.195 2.293-2.389 5.02-2.909a1 1 0 0 1 1.17.795ZM19 16.75a1.5 1.5 0 0 0-1.5 1.5v2a1.5 1.5 0 0 0 3 0v-2a1.5 1.5 0 0 0-1.5-1.5Zm-2.42 4.327a.75.75 0 1 0-1.46.346c.346 1.459 1.603 2.54 3.13 2.811V25a.75.75 0 0 0 1.5 0v-.766c1.527-.27 2.784-1.352 3.13-2.811a.75.75 0 1 0-1.46-.346c-.222.937-1.18 1.723-2.42 1.723s-2.198-.786-2.42-1.723Z",
    fill: "#023F80"
  })));
};

var _path$6F;
function _extends$6J() { _extends$6J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6J.apply(this, arguments); }
var SvgUserMicrophoneBadgeSlashOutline = function SvgUserMicrophoneBadgeSlashOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6J({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6F || (_path$6F = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 9a3.5 3.5 0 0 0-6.107-2.336l-.002-.002a1 1 0 1 1-1.419-1.407 5.5 5.5 0 1 1 7.773 7.773 1 1 0 1 1-1.408-1.417l-.003-.003A3.491 3.491 0 0 0 17.5 9ZM4.293 5.293a1 1 0 0 1 1.414 0l21 21a1 1 0 1 1-1.414 1.414l-2.262-2.262a6 6 0 0 1-8.475-8.475L4.292 6.707a1 1 0 0 1 0-1.414ZM17.5 19.914v.336a1.5 1.5 0 0 0 1.805 1.469L17.5 19.914Zm2.642 2.642A2.73 2.73 0 0 1 19 22.8c-1.24 0-2.198-.786-2.42-1.723a.75.75 0 1 0-1.46.346c.346 1.459 1.603 2.54 3.13 2.811V25a.75.75 0 1 0 1.5 0v-.766a4.162 4.162 0 0 0 1.495-.575l-1.103-1.103Zm-8.16-5.987a1 1 0 0 1-.795 1.17c-2.272.433-3.272 1.361-3.729 2.05a2.902 2.902 0 0 0-.408.917 2.016 2.016 0 0 0-.05.306v.488a.5.5 0 0 0 .5.5h3a1 1 0 0 1 0 2h-3A2.5 2.5 0 0 1 5 21.5V21h1c-1 0-1-.002-1-.002v-.032a2.098 2.098 0 0 1 .015-.215c.014-.13.04-.306.091-.515a4.9 4.9 0 0 1 .686-1.553c.793-1.195 2.293-2.389 5.02-2.909a1 1 0 0 1 1.17.795Zm12.469 4.64c.205.205.55.082.55-.209a6 6 0 0 0-6-6c-.291 0-.415.344-.21.55l5.66 5.658Z",
    fill: "#023F80"
  })));
};

var _path$6G;
function _extends$6K() { _extends$6K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6K.apply(this, arguments); }
var SvgUserOutgoingOutline = function SvgUserOutgoingOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6K({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6G || (_path$6G = /*#__PURE__*/createElement$2("path", {
    d: "M10.25 15c4.951 0 9.25 1.763 9.25 5.643 0 2.016-.781 2.857-2.456 2.857H3.456C1.78 23.5 1 22.66 1 20.643 1 16.763 5.299 15 10.25 15Zm0 2C6.304 17 3 18.355 3 20.643c0 .89-.071.863.372.858l13.672-.001c.536 0 .456.086.456-.857 0-2.288-3.304-3.643-7.25-3.643Zm12.043-9.707a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L24.585 13H18.5a1 1 0 0 1-.993-.883L17.5 12a1 1 0 0 1 1-1h6.085l-2.292-2.293a1 1 0 0 1-.083-1.32l.083-.094ZM10 3c3.039 0 5.5 2.461 5.5 5.5S13.039 14 10 14a5.499 5.499 0 0 1-5.5-5.5C4.5 5.461 6.961 3 10 3Zm0 2a3.499 3.499 0 0 0-3.5 3.5c0 1.934 1.566 3.5 3.5 3.5s3.5-1.566 3.5-3.5S11.934 5 10 5Z",
    fill: "#023F80"
  })));
};

var _path$6H;
function _extends$6L() { _extends$6L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6L.apply(this, arguments); }
var SvgUserOutline = function SvgUserOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6L({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6H || (_path$6H = /*#__PURE__*/createElement$2("path", {
    d: "M14.85 7.95A2.849 2.849 0 0 0 12 5.1a2.849 2.849 0 0 0-2.85 2.85A2.849 2.849 0 0 0 12 10.8a2.849 2.849 0 0 0 2.85-2.85Zm1.8 0A4.649 4.649 0 0 1 12 12.6a4.649 4.649 0 0 1-4.65-4.65A4.649 4.649 0 0 1 12 3.3a4.649 4.649 0 0 1 4.65 4.65ZM5.9 18.429c0 .768-.09.671.335.671h11.53c.426 0 .335.097.335-.671 0-1.893-2.778-3.029-6.1-3.029-3.322 0-6.1 1.136-6.1 3.029Zm-1.8 0c0-3.327 3.673-4.829 7.9-4.829s7.9 1.502 7.9 4.829c0 1.735-.685 2.471-2.135 2.471H6.235c-1.45 0-2.135-.736-2.135-2.471Z",
    fill: "#023F80"
  })));
};

var _path$6I, _path2$26;
function _extends$6M() { _extends$6M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6M.apply(this, arguments); }
var SvgUserSquareOutline = function SvgUserSquareOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6M({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6I || (_path$6I = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.8a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4Zm-3.5 1.7a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z",
    fill: "#023F80"
  })), _path2$26 || (_path2$26 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.228 3.1c-1.57 0-2.32.127-3.082.534a3.647 3.647 0 0 0-1.512 1.512c-.407.762-.534 1.512-.534 3.082v7.544c0 1.57.127 2.32.534 3.082.348.65.863 1.164 1.512 1.512.763.407 1.512.534 3.082.534h7.544c1.57 0 2.32-.127 3.082-.534a3.647 3.647 0 0 0 1.512-1.512c.407-.762.534-1.512.534-3.082V8.228c0-1.57-.127-2.32-.534-3.082a3.647 3.647 0 0 0-1.512-1.512c-.762-.407-1.512-.534-3.082-.534H8.228Zm0 1.8c-1.487 0-1.87.128-2.233.321-.336.18-.594.438-.773.774-.194.362-.322.746-.322 2.233v7.544c0 1.487.128 1.87.322 2.233.069.13.15.247.243.354A8.877 8.877 0 0 1 12 15.499a8.877 8.877 0 0 1 6.536 2.86c.092-.107.173-.225.243-.354.193-.362.321-.746.321-2.233V8.228c0-1.487-.128-1.87-.321-2.233a1.847 1.847 0 0 0-.774-.774c-.362-.193-.746-.321-2.233-.321H8.228ZM12 7a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm-1.7 3.5a1.7 1.7 0 1 1 3.4 0 1.7 1.7 0 0 1-3.4 0Zm-2.072 8.6h7.544c.373 0 .676-.008.927-.023A7.072 7.072 0 0 0 12 17.3c-1.801 0-3.446.67-4.699 1.777.251.015.555.023.927.023Z",
    fill: "#023F80"
  })));
};

var _path$6J;
function _extends$6N() { _extends$6N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6N.apply(this, arguments); }
var SvgUserStarBadgeOutline = function SvgUserStarBadgeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6N({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6J || (_path$6J = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 14.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm0-2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM19 27a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm-7.018-10.431a1 1 0 0 1-.795 1.17c-2.272.433-3.272 1.361-3.729 2.05a2.902 2.902 0 0 0-.408.917 2.016 2.016 0 0 0-.05.306v.488a.5.5 0 0 0 .5.5h3a1 1 0 1 1 0 2h-3A2.5 2.5 0 0 1 5 21.5V21h1c-1 0-1-.002-1-.002v-.032a2.115 2.115 0 0 1 .015-.215c.014-.13.04-.306.091-.515a4.9 4.9 0 0 1 .686-1.553c.793-1.195 2.293-2.389 5.02-2.909a1 1 0 0 1 1.17.795Zm9.954 2.942-1.673-.165-.736-1.738c-.23-.544-.822-.544-1.052 0l-.737 1.738-1.673.165c-.584.057-.762.637-.31 1.02l1.309 1.114-.486 1.814c-.16.596.337.955.832.598l1.59-1.15 1.592 1.15c.496.359.992-.002.832-.598l-.486-1.814 1.31-1.113c.449-.383.27-.964-.312-1.021Z",
    fill: "#023F80"
  })));
};

var _path$6K;
function _extends$6O() { _extends$6O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6O.apply(this, arguments); }
var SvgUserStarBadgeSlashOutline = function SvgUserStarBadgeSlashOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6O({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6K || (_path$6K = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 9a3.5 3.5 0 0 0-6.106-2.336l-.003-.002a1 1 0 1 1-1.419-1.407 5.5 5.5 0 1 1 7.773 7.773 1 1 0 1 1-1.408-1.417l-.003-.003A3.491 3.491 0 0 0 17.5 9ZM5.707 5.293a1 1 0 0 0-1.414 1.414L14.555 16.97a6 6 0 0 0 8.475 8.475l2.263 2.263a1 1 0 1 0 1.414-1.414l-21-21ZM16.065 19.51l.94-.093 4.428 4.43c-.092.34-.466.48-.841.21l-1.591-1.15-1.591 1.15c-.495.356-.992-.003-.832-.599l.486-1.814-1.31-1.113c-.451-.384-.273-.964.311-1.021Zm-5.54-1.624c-1.81.474-2.657 1.285-3.067 1.902a2.902 2.902 0 0 0-.408.917 2.017 2.017 0 0 0-.05.306v.488a.5.5 0 0 0 .5.5h3a1 1 0 1 1 0 2h-3A2.5 2.5 0 0 1 5 21.5v-.534a2.115 2.115 0 0 1 .015-.215c.014-.13.04-.306.091-.515.1-.417.299-.97.686-1.553.707-1.066 1.978-2.131 4.18-2.718a1 1 0 1 1 .553 1.922Zm13.926 3.321c.205.206.549.083.549-.208a6 6 0 0 0-6-6c-.29 0-.414.344-.208.55l5.659 5.658Z",
    fill: "#023F80"
  })));
};

var _path$6L, _path2$27;
function _extends$6P() { _extends$6P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6P.apply(this, arguments); }
var SvgUserTagOutline = function SvgUserTagOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6P({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6L || (_path$6L = /*#__PURE__*/createElement$2("path", {
    d: "M14 9.4a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
    fill: "#023F80"
  })), _path2$27 || (_path2$27 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.564 2.5h8.872c.6 0 1.103 0 1.515.034.43.035.84.111 1.229.31a3.15 3.15 0 0 1 1.377 1.376c.198.389.274.798.31 1.229.033.412.033.916.033 1.515v8.603c0 .5 0 .92-.024 1.264-.024.36-.078.705-.217 1.04a3.15 3.15 0 0 1-1.702 1.702c-.335.14-.68.193-1.04.217-.345.024-.764.024-1.264.024h-.03c-.566 0-.742.003-.904.031a2.101 2.101 0 0 0-.679.245c-.142.082-.28.192-.716.553l-.495.41c-.209.173-.401.333-.574.456a2.163 2.163 0 0 1-.667.336 2.15 2.15 0 0 1-1.175 0 2.164 2.164 0 0 1-.668-.336c-.172-.123-.365-.283-.574-.456l-.496-.41c-.435-.361-.573-.471-.716-.553-.21-.12-.44-.203-.679-.245-.161-.028-.338-.031-.903-.031h-.03c-.5 0-.92 0-1.265-.024-.36-.024-.704-.078-1.04-.217a3.15 3.15 0 0 1-1.702-1.702c-.139-.335-.192-.68-.217-1.04-.023-.345-.023-.764-.023-1.264V6.964c0-.6 0-1.103.034-1.515.035-.43.111-.84.31-1.23A3.15 3.15 0 0 1 4.82 2.844c.388-.198.798-.274 1.229-.31.412-.033.915-.033 1.515-.033ZM6.195 4.328c-.32.026-.465.072-.558.12a1.35 1.35 0 0 0-.59.59c-.047.092-.093.238-.12.557-.026.33-.027.76-.027 1.405v8.537c0 .537 0 .895.02 1.172.018.268.05.393.083.472.117.281.324.514.587.66a6.902 6.902 0 0 1 12.82 0c.263-.147.47-.379.587-.66.032-.079.065-.204.084-.472.018-.277.019-.635.019-1.172V7c0-.645 0-1.074-.028-1.405-.026-.319-.072-.465-.12-.558a1.35 1.35 0 0 0-.59-.59c-.092-.047-.238-.093-.558-.12-.33-.026-.76-.027-1.404-.027H7.6c-.645 0-1.075 0-1.405.028ZM16.51 18.014A5.1 5.1 0 0 0 12 15.3a5.1 5.1 0 0 0-4.509 2.714c.445 0 .776.002 1.1.058.443.078.87.232 1.26.455.296.168.56.386.92.685l.527.438c.238.196.378.312.49.391.075.054.109.07.117.072a.35.35 0 0 0 .19 0 .663.663 0 0 0 .118-.072 9.54 9.54 0 0 0 .489-.392l.527-.437c.36-.298.623-.516.919-.685a3.902 3.902 0 0 1 1.261-.455c.324-.057.655-.058 1.1-.058Z",
    fill: "#023F80"
  })));
};

var _path$6M, _path2$28;
function _extends$6Q() { _extends$6Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6Q.apply(this, arguments); }
var SvgUsers3Outline = function SvgUsers3Outline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6Q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6M || (_path$6M = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 8.1a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM12 9.8a1.7 1.7 0 1 1 0-3.4 1.7 1.7 0 0 1 0 3.4ZM12 13.1c-1.504 0-2.925.354-4.002 1.015-1.078.662-1.898 1.702-1.898 3.04 0 .81.279 1.532.851 2.043.559.497 1.294.702 2.05.702h6c.754 0 1.49-.205 2.048-.702.573-.51.851-1.234.851-2.043 0-1.338-.82-2.378-1.898-3.04C14.926 13.454 13.504 13.1 12 13.1Zm-4.1 4.055c0-.518.306-1.055 1.04-1.506.737-.453 1.815-.749 3.06-.749s2.324.296 3.06.749c.735.451 1.04.988 1.04 1.506 0 .386-.121.585-.249.699-.141.126-.406.246-.85.246H9c-.446 0-.71-.12-.852-.246-.127-.114-.249-.313-.249-.7Z",
    fill: "#023F80"
  })), _path2$28 || (_path2$28 = /*#__PURE__*/createElement$2("path", {
    d: "M5.903 13.7a.9.9 0 0 0-.9-.9c-2.007 0-3.95 1.276-3.95 3.357 0 1.263.87 2.743 2.607 2.743a.9.9 0 1 0 0-1.8.704.704 0 0 1-.575-.254 1.088 1.088 0 0 1-.232-.689c0-.73.74-1.557 2.15-1.557a.9.9 0 0 0 .9-.9ZM6.314 5.46a.9.9 0 1 1 .255 1.78A1.243 1.243 0 0 0 5.5 8.467c0 .68.555 1.239 1.25 1.239a.9.9 0 0 1 0 1.8A3.044 3.044 0 0 1 3.7 8.466 3.043 3.043 0 0 1 6.314 5.46ZM18.096 13.7a.9.9 0 0 1 .9-.9c2.007 0 3.95 1.276 3.95 3.357 0 1.263-.87 2.743-2.607 2.743a.9.9 0 1 1 0-1.8c.272 0 .45-.104.576-.254.14-.167.231-.417.231-.689 0-.73-.739-1.557-2.15-1.557a.9.9 0 0 1-.9-.9ZM17.686 5.46a.9.9 0 1 0-.255 1.78A1.243 1.243 0 0 1 18.5 8.467c0 .68-.555 1.239-1.25 1.239a.9.9 0 0 0 0 1.8c1.68 0 3.05-1.356 3.05-3.039a3.043 3.043 0 0 0-2.614-3.007Z",
    fill: "#023F80"
  })));
};

var _path$6N;
function _extends$6R() { _extends$6R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6R.apply(this, arguments); }
var SvgUsersOutline = function SvgUsersOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6R({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6N || (_path$6N = /*#__PURE__*/createElement$2("path", {
    d: "M17 13.5c3.689 0 6.9 1.31 6.9 4.257 0 1.554-.644 2.243-1.959 2.243h-5.596c-.543 0-.927-.551-.82-1.084.076-.373.39-.716.77-.716l5.783.002s.022-.297.022-.445c0-1.512-2.318-2.457-5.1-2.457-.472 0-.93.027-1.367.08a.902.902 0 0 1-.85-.398c-.35-.516-.166-1.296.453-1.375A14.063 14.063 0 0 1 17 13.5Zm-10 0c3.688 0 6.9 1.31 6.9 4.257 0 1.554-.644 2.243-1.959 2.243H2.06C.744 20 .1 19.311.1 17.757.1 14.81 3.312 13.5 7 13.5Zm0 1.8c-2.782 0-5.1.945-5.1 2.457 0 .149.02.445.02.445h10.158s.022-.297.022-.445c0-1.512-2.318-2.457-5.1-2.457ZM17 4.2a4.15 4.15 0 0 1 4.15 4.15A4.15 4.15 0 0 1 17 12.5a4.15 4.15 0 0 1-4.15-4.15A4.15 4.15 0 0 1 17 4.2Zm-10 0a4.15 4.15 0 0 1 4.15 4.15A4.15 4.15 0 0 1 7 12.5a4.15 4.15 0 0 1-4.15-4.15A4.15 4.15 0 0 1 7 4.2ZM17 6a2.35 2.35 0 1 0 0 4.7A2.35 2.35 0 1 0 17 6ZM7 6a2.35 2.35 0 1 0 0 4.7A2.35 2.35 0 1 0 7 6Z",
    fill: "#023F80"
  })));
};

var _path$6O, _path2$29;
function _extends$6S() { _extends$6S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6S.apply(this, arguments); }
var SvgVideoCircleOutline = function SvgVideoCircleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6S({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6O || (_path$6O = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12 15.637 3.3-1.905c1.333-.77 1.333-2.694 0-3.464L12 8.363c-1.333-.77-3 .192-3 1.732v3.81c0 1.54 1.667 2.502 3 1.732Zm2.4-3.81a.2.2 0 0 1 0 .346l-3.3 1.905a.2.2 0 0 1-.3-.173v-3.81a.2.2 0 0 1 .3-.173l3.3 1.905Z",
    fill: "#023F80"
  })), _path2$29 || (_path2$29 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5a9.872 9.872 0 0 1 7-2.9c2.733 0 5.21 1.11 7 2.9a9.872 9.872 0 0 1 2.9 7c0 2.733-1.11 5.21-2.9 7a9.872 9.872 0 0 1-7 2.9A9.872 9.872 0 0 1 5 19a9.872 9.872 0 0 1-2.9-7c0-2.734 1.11-5.21 2.9-7Zm7-1.1c-2.237 0-4.26.906-5.728 2.372A8.072 8.072 0 0 0 3.9 12c0 2.237.906 4.26 2.372 5.727A8.072 8.072 0 0 0 12 20.1c2.237 0 4.26-.906 5.727-2.373A8.072 8.072 0 0 0 20.1 12c0-2.237-.906-4.26-2.373-5.728A8.072 8.072 0 0 0 12 3.9Z",
    fill: "#023F80"
  })));
};

var _path$6P, _path2$2a;
function _extends$6T() { _extends$6T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6T.apply(this, arguments); }
var SvgVideoOutline = function SvgVideoOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6T({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6P || (_path$6P = /*#__PURE__*/createElement$2("path", {
    d: "M7.25 15.75h1a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 .75-.75ZM15.75 15.75h1a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 .75-.75ZM7.25 10.75h1a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 .75-.75ZM15.75 10.75h1a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 .75-.75ZM7.25 5.75h1A.75.75 0 0 1 9 6.5v1a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 .75-.75ZM15.75 5.75h1a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-.75.75h-1A.75.75 0 0 1 15 7.5v-1a.75.75 0 0 1 .75-.75Z",
    fill: "#023F80"
  })), _path2$2a || (_path2$2a = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.461 2.1h5.078c1.017 0 1.835 0 2.497.054.681.056 1.276.173 1.825.453a4.65 4.65 0 0 1 2.032 2.032c.28.549.397 1.144.453 1.825.054.662.054 1.48.054 2.497v6.078c0 1.017 0 1.835-.054 2.497-.056.681-.173 1.276-.453 1.825a4.65 4.65 0 0 1-2.032 2.032c-.55.28-1.144.397-1.825.453-.662.054-1.48.054-2.497.054H9.46c-1.017 0-1.835 0-2.497-.054-.681-.056-1.276-.173-1.825-.453a4.65 4.65 0 0 1-2.032-2.032c-.28-.55-.397-1.144-.453-1.825-.054-.662-.054-1.48-.054-2.497V8.96c0-1.017 0-1.835.054-2.497.056-.681.173-1.276.453-1.825a4.65 4.65 0 0 1 2.032-2.032c.549-.28 1.144-.397 1.825-.453C7.626 2.1 8.444 2.1 9.46 2.1Zm-2.35 1.848c-.57.047-.902.134-1.155.263a2.85 2.85 0 0 0-1.245 1.245c-.13.253-.216.585-.263 1.154C4.401 7.19 4.4 7.935 4.4 9v6c0 1.065 0 1.81.048 2.39.047.57.134.9.263 1.154.273.536.709.972 1.245 1.245.253.13.585.216 1.154.263.58.047 1.325.048 2.39.048h5c1.065 0 1.81 0 2.39-.048.57-.047.9-.134 1.154-.263a2.85 2.85 0 0 0 1.245-1.245c.13-.253.216-.585.263-1.154.047-.58.048-1.325.048-2.39V9c0-1.065 0-1.81-.048-2.39-.047-.57-.134-.9-.263-1.154a2.85 2.85 0 0 0-1.245-1.245c-.253-.13-.585-.216-1.154-.263-.58-.047-1.325-.048-2.39-.048h-5c-1.065 0-1.81 0-2.39.048Z",
    fill: "#023F80"
  })));
};

var _path$6Q, _path2$2b;
function _extends$6U() { _extends$6U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6U.apply(this, arguments); }
var SvgVideocamAddOutline = function SvgVideocamAddOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6U({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6Q || (_path$6Q = /*#__PURE__*/createElement$2("path", {
    d: "M9.9 9.4a.9.9 0 1 0-1.8 0v1.7H6.4a.9.9 0 1 0 0 1.8h1.7v1.7a.9.9 0 0 0 1.8 0v-1.7h1.7a.9.9 0 0 0 0-1.8H9.9V9.4Z",
    fill: "#023F80"
  })), _path2$2b || (_path2$2b = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.954 5.034c-.652-.348-1.299-.534-3.082-.534H6.128c-1.783 0-2.43.186-3.082.534a3.635 3.635 0 0 0-1.512 1.512C1.186 7.198 1 7.845 1 9.628v4.744c0 1.783.186 2.43.534 3.082.349.651.86 1.163 1.512 1.512.652.348 1.299.534 3.082.534h5.744c1.783 0 2.43-.186 3.082-.534a3.635 3.635 0 0 0 1.512-1.512c.21-.393.36-.783.447-1.42l2.478 1.444A2.4 2.4 0 0 0 23 15.405v-6.81a2.4 2.4 0 0 0-3.61-2.073l-2.477 1.444c-.087-.637-.238-1.027-.447-1.42a3.635 3.635 0 0 0-1.512-1.512ZM6.128 6.3h5.744c1.354 0 1.788.084 2.233.322.338.18.593.435.774.773.237.445.321.879.321 2.233v4.744c0 1.354-.084 1.788-.321 2.233-.181.338-.436.593-.774.773-.445.238-.879.322-2.233.322H6.128c-1.354 0-1.788-.084-2.233-.322a1.835 1.835 0 0 1-.773-.773c-.238-.445-.322-.879-.322-2.233V9.628c0-1.354.084-1.788.322-2.233.18-.338.435-.593.773-.773.445-.238.879-.322 2.233-.322ZM17 10l3.298-1.924a.6.6 0 0 1 .902.519v6.81a.6.6 0 0 1-.902.519L17 14v-4Z",
    fill: "#023F80"
  })));
};

var _path$6R, _path2$2c;
function _extends$6V() { _extends$6V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6V.apply(this, arguments); }
var SvgVideocamArrowUpOutline = function SvgVideocamArrowUpOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6V({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6R || (_path$6R = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.357 5h4.286c1.084 0 1.958 0 2.666.058.729.06 1.369.185 1.961.487a5 5 0 0 1 2.185 2.185c.231.454.36.936.433 1.464l.437-.284.903-.585c.239-.155.52-.338.773-.471.255-.134.794-.395 1.482-.348a2.7 2.7 0 0 1 1.975 1.07c.415.552.49 1.148.516 1.434.026.285.026.62.026.904v6.172c0 .284 0 .619-.026.904-.026.286-.1.882-.516 1.434a2.7 2.7 0 0 1-1.975 1.07c-.688.047-1.227-.214-1.482-.348a10.407 10.407 0 0 1-.773-.47l-.905-.588-.435-.282c-.074.528-.202 1.01-.433 1.464a5 5 0 0 1-2.185 2.185c-.592.302-1.232.428-1.961.487C15.6 23 14.727 23 13.643 23H9.357c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.96-.487a5 5 0 0 1-2.186-2.185c-.302-.592-.428-1.232-.487-1.961C2 17.6 2 16.727 2 15.643v-3.286c0-1.084 0-1.958.058-2.666.06-.728.185-1.369.487-1.961A5 5 0 0 1 4.73 5.545c.592-.302 1.233-.428 1.961-.487C7.4 5 8.273 5 9.357 5ZM21 15.643v-4.138l2.27-1.472c.563-.365.844-.548 1.077-.532a.7.7 0 0 1 .513.277c.14.187.14.522.14 1.192v6.06c0 .67 0 1.005-.14 1.192a.7.7 0 0 1-.513.277c-.233.016-.514-.167-1.077-.532L21 16.495v-.852ZM6.854 7.05c-.605.05-.953.142-1.216.276a3 3 0 0 0-1.311 1.311c-.134.263-.226.611-.276 1.216-.05.617-.051 1.41-.051 2.546v3.2c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051h4.2c1.137 0 1.929 0 2.546-.051.605-.05.953-.142 1.216-.276a3 3 0 0 0 1.311-1.311c.134-.263.226-.611.276-1.216.05-.617.051-1.41.051-2.546v-3.2c0-1.137 0-1.929-.051-2.546-.05-.605-.142-.953-.276-1.216a3 3 0 0 0-1.311-1.311c-.263-.134-.611-.226-1.216-.276C15.529 7.001 14.736 7 13.6 7H9.4c-1.137 0-1.929 0-2.546.051Z",
    fill: "#023F80"
  })), _path2$2c || (_path2$2c = /*#__PURE__*/createElement$2("path", {
    d: "M12.5 13.414V17a1 1 0 1 1-2 0v-3.586l-1.293 1.293a1 1 0 0 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L12.5 13.414Z",
    fill: "#023F80"
  })));
};

var _path$6S;
function _extends$6W() { _extends$6W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6W.apply(this, arguments); }
var SvgVideocamArrowUpSlashOutline = function SvgVideocamArrowUpSlashOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6W({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6S || (_path$6S = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6 7c1.137 0 1.929 0 2.546.051.605.05.953.142 1.216.276a3 3 0 0 1 1.311 1.311c.134.263.226.611.276 1.216.05.617.051 1.41.051 2.546v4.095a2 2 0 0 0 .912 1.678l.76.493c.52.336 1.038.673 1.556 1.01.239.154.52.337.773.47.255.134.794.395 1.482.348a2.7 2.7 0 0 0 1.975-1.07c.415-.552.49-1.148.516-1.434.026-.285.026-.62.026-.904v-6.172c0-.284 0-.619-.026-.904-.026-.286-.1-.882-.516-1.434a2.7 2.7 0 0 0-1.975-1.07c-.688-.047-1.227.214-1.482.348-.253.133-.534.316-.773.47a1651.01 1651.01 0 0 1-1.34.87c-.074-.528-.202-1.01-.433-1.464a5 5 0 0 0-2.185-2.185c-.592-.302-1.232-.428-1.961-.487C15.6 5 14.727 5 13.643 5H8.656a1 1 0 0 0 0 2H13.6Zm7.4 9.495 2.27 1.472c.563.365.844.548 1.077.532a.7.7 0 0 0 .513-.277c.14-.187.14-.522.14-1.192v-6.06c0-.67 0-1.005-.14-1.192a.7.7 0 0 0-.513-.277c-.233-.016-.514.167-1.077.532L21 11.505v4.99ZM13.643 23H9.357c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.96-.487a5 5 0 0 1-2.186-2.185c-.302-.592-.428-1.232-.487-1.961C2 17.6 2 16.727 2 15.643v-3.286c0-1.084 0-1.958.058-2.666.06-.728.185-1.369.487-1.961a5 5 0 0 1 .284-.487L1.293 5.707a1 1 0 0 1 1.414-1.414l19 19a1 1 0 0 1-1.414 1.414l-2.178-2.178c-.549.25-1.14.359-1.806.413C15.6 23 14.727 23 13.643 23ZM4.05 9.854C4.001 10.471 4 11.264 4 12.4v3.2c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051h4.2c1.137 0 1.929 0 2.546-.051.128-.01.245-.023.351-.037L12.5 16.914V17a1 1 0 1 1-2 0v-2.086l-.75-.75-.543.543a1 1 0 0 1-1.414-1.414l.543-.543-4.043-4.042c-.116.255-.197.593-.242 1.146Z",
    fill: "#023F80"
  })));
};

var _path$6T;
function _extends$6X() { _extends$6X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6X.apply(this, arguments); }
var SvgVideocamOutline = function SvgVideocamOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6X({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6T || (_path$6T = /*#__PURE__*/createElement$2("path", {
    d: "M11.872 4.5c1.783 0 2.43.186 3.082.534.651.349 1.163.86 1.512 1.512.21.393.36.783.447 1.42l2.478-1.444A2.4 2.4 0 0 1 23 8.595v6.81a2.4 2.4 0 0 1-3.61 2.073l-2.477-1.444c-.087.637-.238 1.027-.447 1.42a3.635 3.635 0 0 1-1.512 1.512c-.652.348-1.299.534-3.082.534H6.128c-1.783 0-2.43-.186-3.082-.534a3.635 3.635 0 0 1-1.512-1.512C1.186 16.802 1 16.155 1 14.372V9.628c0-1.783.186-2.43.534-3.082a3.635 3.635 0 0 1 1.512-1.512c.652-.348 1.299-.534 3.082-.534h5.744Zm0 1.8H6.128c-1.354 0-1.788.084-2.233.322-.338.18-.593.435-.773.773-.238.445-.322.879-.322 2.233v4.744c0 1.354.084 1.788.322 2.233.18.338.435.593.773.773.445.238.879.322 2.233.322h5.744c1.354 0 1.788-.084 2.233-.322.338-.18.593-.435.774-.773.237-.445.321-.879.321-2.233V9.628c0-1.354-.084-1.788-.321-2.233a1.835 1.835 0 0 0-.774-.773c-.445-.238-.879-.322-2.233-.322Zm8.426 1.776L17 10v4l3.298 1.924a.6.6 0 0 0 .902-.519v-6.81a.6.6 0 0 0-.902-.519Z",
    fill: "#023F80"
  })));
};

var _path$6U;
function _extends$6Y() { _extends$6Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6Y.apply(this, arguments); }
var SvgVideocamSlashOutline = function SvgVideocamSlashOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6Y({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6U || (_path$6U = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.357 23h4.286c1.084 0 1.958 0 2.666-.058.665-.054 1.257-.164 1.806-.413l2.178 2.178a1 1 0 0 0 1.414-1.414l-19-19a1 1 0 0 0-1.414 1.414l1.536 1.536a5 5 0 0 0-.284.487c-.302.592-.428 1.233-.487 1.961C2 10.4 2 11.273 2 12.357v3.286c0 1.084 0 1.958.058 2.666.06.729.185 1.369.487 1.961a5 5 0 0 0 2.185 2.185c.592.302 1.233.428 1.961.487C7.4 23 8.273 23 9.357 23ZM4.051 9.854C4.001 10.471 4 11.264 4 12.4v3.2c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051h4.2c1.137 0 1.929 0 2.546-.051.128-.01.245-.023.351-.037L4.293 8.708c-.116.255-.197.593-.242 1.146ZM13.6 7c1.137 0 1.929 0 2.546.051.605.05.953.142 1.216.276a3 3 0 0 1 1.311 1.311c.134.263.226.611.276 1.216.05.617.051 1.41.051 2.546v4.095a2 2 0 0 0 .912 1.678l.76.493c.52.336 1.038.673 1.556 1.01.239.154.52.337.773.47.255.134.794.395 1.482.348a2.7 2.7 0 0 0 1.975-1.07c.415-.552.49-1.148.516-1.434.026-.285.026-.62.026-.904v-6.172c0-.284 0-.619-.026-.904-.026-.286-.1-.882-.516-1.434a2.7 2.7 0 0 0-1.975-1.07c-.688-.047-1.227.214-1.482.348-.253.133-.534.316-.773.47a1651.01 1651.01 0 0 1-1.34.87c-.074-.528-.202-1.01-.433-1.464a5 5 0 0 0-2.185-2.185c-.592-.302-1.232-.428-1.961-.487C15.6 5 14.727 5 13.643 5H8.656a1 1 0 0 0 0 2H13.6Zm7.4 5.357v4.138l2.27 1.472c.563.365.844.548 1.077.532a.7.7 0 0 0 .513-.277c.14-.187.14-.522.14-1.192v-6.06c0-.67 0-1.005-.14-1.192a.7.7 0 0 0-.513-.277c-.233-.016-.514.167-1.077.532L21 11.505v.852Z",
    fill: "#023F80"
  })));
};

var _path$6V;
function _extends$6Z() { _extends$6Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6Z.apply(this, arguments); }
var SvgViewOutline = function SvgViewOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6Z({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6V || (_path$6V = /*#__PURE__*/createElement$2("path", {
    d: "M12 4.6c5.2 0 10.4 4.237 10.4 7.4 0 3.163-5.2 7.4-10.4 7.4S1.6 15.163 1.6 12c0-3.163 5.2-7.4 10.4-7.4Zm0 1.8c-4.278 0-8.6 3.522-8.6 5.6s4.322 5.6 8.6 5.6c4.277 0 8.6-3.522 8.6-5.6S16.277 6.4 12 6.4Zm0 2.2a3.4 3.4 0 1 1 0 6.8 3.4 3.4 0 0 1 0-6.8Zm0 1.8a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2Z",
    fill: "#023F80"
  })));
};

var _path$6W, _path2$2d, _path3$D;
function _extends$6_() { _extends$6_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6_.apply(this, arguments); }
var SvgVinylOutline = function SvgVinylOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6_({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6W || (_path$6W = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0-1.8a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z",
    fill: "#023F80"
  })), _path2$2d || (_path2$2d = /*#__PURE__*/createElement$2("path", {
    d: "M7.4 12A4.6 4.6 0 0 1 12 7.4a.9.9 0 1 0 0-1.8A6.4 6.4 0 0 0 5.6 12a.9.9 0 1 0 1.8 0ZM18.4 12a.9.9 0 1 0-1.8 0 4.6 4.6 0 0 1-4.6 4.6.9.9 0 1 0 0 1.8 6.4 6.4 0 0 0 6.4-6.4Z",
    fill: "#023F80"
  })), _path3$D || (_path3$D = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5a9.872 9.872 0 0 1 7-2.9c2.734 0 5.21 1.11 7 2.9a9.872 9.872 0 0 1 2.9 7c0 2.734-1.109 5.21-2.9 7a9.872 9.872 0 0 1-7 2.9A9.872 9.872 0 0 1 5 19a9.872 9.872 0 0 1-2.9-7c0-2.734 1.11-5.21 2.9-7Zm7-1.1c-2.237 0-4.26.906-5.727 2.372A8.072 8.072 0 0 0 3.9 12c0 2.237.906 4.26 2.373 5.728A8.072 8.072 0 0 0 12 20.1c2.237 0 4.26-.906 5.728-2.372A8.072 8.072 0 0 0 20.1 12c0-2.237-.905-4.26-2.372-5.728A8.072 8.072 0 0 0 12 3.9Z",
    fill: "#023F80"
  })));
};

var _path$6X;
function _extends$6$() { _extends$6$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6$.apply(this, arguments); }
var SvgVmojiOutline = function SvgVmojiOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$6$({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6X || (_path$6X = /*#__PURE__*/createElement$2("path", {
    d: "M12 3a1 1 0 0 1-1 1 7 7 0 0 0-7 7 1 1 0 1 1-2 0 9 9 0 0 1 9-9 1 1 0 0 1 1 1ZM12 25a1 1 0 0 0-1-1 7 7 0 0 1-7-7 1 1 0 1 0-2 0 9 9 0 0 0 9 9 1 1 0 0 0 1-1ZM9.75 11a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm7.145.878c1.033-.556 2.224-.556 3.274.385.41.368.444.998.074 1.407a1.003 1.003 0 0 1-1.412.074l-.1-.082c-.298-.22-.565-.203-.886-.03-.096.051-.162.1-.176.112l-.099.078a1.003 1.003 0 0 1-1.313-.152.994.994 0 0 1 .074-1.407c.124-.111.314-.25.564-.385ZM16 16.5c.552 0 1 .45.921.996-.037.26-.087.501-.15.652a3 3 0 0 1-5.543 0 3.007 3.007 0 0 1-.15-.652c-.077-.546.37-.996.922-.996h4ZM16 3a1 1 0 0 0 1 1 7 7 0 0 1 7 7 1 1 0 1 0 2 0 9 9 0 0 0-9-9 1 1 0 0 0-1 1ZM16 25a1 1 0 0 1 1-1 7 7 0 0 0 7-7 1 1 0 1 1 2 0 9 9 0 0 1-9 9 1 1 0 0 1-1-1Z",
    fill: "#023F80"
  })));
};

var _path$6Y, _path2$2e;
function _extends$70() { _extends$70 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$70.apply(this, arguments); }
var SvgVoiceOutline = function SvgVoiceOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$70({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6Y || (_path$6Y = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1 6.9a4.9 4.9 0 0 1 9.8 0v4.2a4.9 4.9 0 1 1-9.8 0V6.9ZM12 3.8a3.1 3.1 0 0 0-3.1 3.1v4.2a3.1 3.1 0 1 0 6.2 0V6.9A3.1 3.1 0 0 0 12 3.8Z",
    fill: "#023F80"
  })), _path2$2e || (_path2$2e = /*#__PURE__*/createElement$2("path", {
    d: "M19.68 15.35a.9.9 0 0 0-1.56-.9A7.061 7.061 0 0 1 12 18a7.061 7.061 0 0 1-6.12-3.55.9.9 0 0 0-1.56.9 8.872 8.872 0 0 0 6.78 4.405V22.1a.9.9 0 1 0 1.8 0v-2.345a8.872 8.872 0 0 0 6.78-4.405Z",
    fill: "#023F80"
  })));
};

var _path$6Z;
function _extends$71() { _extends$71 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$71.apply(this, arguments); }
var SvgVolumeOutline = function SvgVolumeOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$71({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6Z || (_path$6Z = /*#__PURE__*/createElement$2("path", {
    d: "M14.25 4c.902 0 1.75.694 1.75 1.689V18.31c0 .995-.848 1.689-1.75 1.689-.762 0-1.505-.28-2.063-.798l-4.24-3.935H6.14c-1.118 0-2.14-.856-2.14-2.05v-2.433c0-1.195 1.022-2.05 2.14-2.05h1.807l4.24-3.936A3.035 3.035 0 0 1 14.25 4Zm-.05 1.801a1.23 1.23 0 0 0-.789.316l-4.499 4.176a.9.9 0 0 1-.612.24H6.14c-.14 0-.34.085-.34.25v2.433c0 .166.2.25.34.25H8.3a.9.9 0 0 1 .612.241l4.5 4.175c.2.187.481.305.788.317V5.801Zm7.338.464C23.058 7.792 24 9.792 24 12s-.943 4.208-2.462 5.735a.9.9 0 1 1-1.276-1.27C21.489 15.232 22.2 13.675 22.2 12c0-1.674-.71-3.232-1.938-4.465a.9.9 0 1 1 1.276-1.27Zm-2.551 3.053C19.613 10.058 20 10.983 20 12s-.387 1.943-1.013 2.682a.9.9 0 0 1-1.374-1.164c.383-.451.587-.974.587-1.518s-.204-1.067-.587-1.518a.9.9 0 0 1 1.374-1.164Z",
    fill: "#023F80"
  })));
};

var _path$6_;
function _extends$72() { _extends$72 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$72.apply(this, arguments); }
var SvgWalletOutline = function SvgWalletOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$72({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6_ || (_path$6_ = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.762 3.1H15.5a3.4 3.4 0 0 1 3.4 3.4v.732c.305.06.594.152.87.293a3.9 3.9 0 0 1 1.705 1.704c.239.47.336.971.381 1.527.044.537.044 1.198.044 2.006v1.476c0 .808 0 1.469-.044 2.006-.045.556-.142 1.058-.381 1.526a3.9 3.9 0 0 1-1.704 1.705c-.47.239-.971.336-1.527.381-.537.044-1.198.044-2.006.044H7.762c-.808 0-1.469 0-2.006-.044a8.285 8.285 0 0 1-.103-.009c-.515-.049-.984-.148-1.423-.372a3.9 3.9 0 0 1-1.704-1.704c-.24-.47-.337-.971-.382-1.527-.044-.537-.044-1.198-.044-2.006V8.762c0-.808 0-1.469.044-2.006.045-.556.142-1.058.381-1.527A3.9 3.9 0 0 1 4.23 3.525c.468-.239.97-.336 1.526-.381C6.293 3.1 6.954 3.1 7.762 3.1ZM3.9 9v5.2c0 .855 0 1.442.038 1.897.036.445.103.683.191.856a2.1 2.1 0 0 0 .918.918c.173.088.411.155.856.191.455.037 1.042.038 1.897.038h8.4c.855 0 1.442 0 1.897-.038.445-.036.684-.103.856-.19a2.1 2.1 0 0 0 .918-.919c.088-.172.155-.411.191-.856.037-.455.038-1.042.038-1.897v-1.4c0-.855 0-1.442-.038-1.897-.036-.445-.103-.684-.19-.856a2.1 2.1 0 0 0-.919-.918c-.172-.088-.411-.155-.856-.191C17.642 8.9 17.055 8.9 16.2 8.9H3.9V9Zm.025-1.9h12.313c.308 0 .595 0 .862.002V6.5a1.6 1.6 0 0 0-1.6-1.6H7.8c-.855 0-1.442 0-1.897.038-.445.036-.683.103-.856.19a2.1 2.1 0 0 0-.918.919c-.088.172-.155.411-.191.856-.005.063-.01.129-.013.197ZM15.1 14a.9.9 0 0 1 .9-.9h1.2a.9.9 0 1 1 0 1.8H16a.9.9 0 0 1-.9-.9Z",
    fill: "#023F80"
  })));
};

var _path$6$, _path2$2f, _path3$E;
function _extends$73() { _extends$73 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$73.apply(this, arguments); }
var SvgWarningTriangleOutline = function SvgWarningTriangleOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$73({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6$ || (_path$6$ = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.489 4.55c1.116-1.933 3.906-1.933 5.022 0l6.929 12c1.116 1.933-.28 4.35-2.512 4.35H5.072c-2.233 0-3.628-2.417-2.512-4.35l6.929-12Zm3.464.9a1.1 1.1 0 0 0-1.906 0l-6.928 12a1.1 1.1 0 0 0 .953 1.65h13.856a1.1 1.1 0 0 0 .953-1.65l-6.928-12Z",
    fill: "#023F80"
  })), _path2$2f || (_path2$2f = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8c.497 0 .9.374.9.836v4.828c0 .462-.403.836-.9.836s-.9-.374-.9-.836V8.836c0-.462.403-.836.9-.836Z",
    fill: "#023F80"
  })), _path3$E || (_path3$E = /*#__PURE__*/createElement$2("path", {
    d: "M13 16.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: "#023F80"
  })));
};

var _path$70;
function _extends$74() { _extends$74 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$74.apply(this, arguments); }
var SvgWarningCircleFilled = function SvgWarningCircleFilled(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$74({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$70 || (_path$70 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23c6.03 0 11-4.979 11-11.006C23 5.98 18.019 1 12 1 5.97 1 1 5.979 1 11.994 1 18.021 5.981 23 12 23Zm.185-9.296c.496 0 .802-.306.802-.854l.153-6.407c.013-.535-.408-.943-.968-.943-.573 0-.968.395-.955.943l.14 6.407c.012.548.305.854.828.854Zm0 3.796c-.637 0-1.185-.522-1.185-1.146 0-.637.535-1.147 1.185-1.147s1.184.497 1.184 1.146c0 .637-.547 1.147-1.184 1.147Z",
    fill: "#023F80"
  })));
};

var _path$71;
function _extends$75() { _extends$75 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$75.apply(this, arguments); }
var SvgWasherOutline = function SvgWasherOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$75({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$71 || (_path$71 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.762 2.1H14.238c.808 0 1.469 0 2.006.044.556.045 1.058.142 1.527.381a3.9 3.9 0 0 1 1.704 1.704c.239.47.336.971.381 1.527.044.537.044 1.198.044 2.006v8.476c0 .808 0 1.469-.044 2.006-.045.556-.142 1.058-.381 1.526a3.9 3.9 0 0 1-1.704 1.705c-.47.239-.971.336-1.527.381-.537.044-1.198.044-2.006.044H9.762c-.808 0-1.469 0-2.006-.044-.556-.045-1.058-.142-1.526-.381a3.9 3.9 0 0 1-1.705-1.705c-.239-.468-.336-.97-.381-1.526-.044-.537-.044-1.198-.044-2.006V7.762c0-.808 0-1.469.044-2.006.045-.556.142-1.058.381-1.527A3.9 3.9 0 0 1 6.23 2.525c.468-.239.97-.336 1.526-.381C8.293 2.1 8.954 2.1 9.762 2.1ZM7.903 3.938c-.445.036-.683.103-.856.19a2.1 2.1 0 0 0-.918.919c-.088.172-.155.411-.191.856C5.901 6.358 5.9 6.945 5.9 7.8v.3h12.2v-.3c0-.855 0-1.442-.038-1.897-.036-.445-.103-.684-.19-.856a2.1 2.1 0 0 0-.919-.918c-.172-.088-.411-.155-.856-.191C15.642 3.9 15.055 3.9 14.2 3.9H9.8c-.855 0-1.442 0-1.897.038ZM5.9 16.2V9.9h12.2v6.3c0 .855 0 1.442-.038 1.897-.036.445-.103.683-.19.856a2.1 2.1 0 0 1-.919.918c-.172.088-.411.155-.856.191-.455.037-1.042.038-1.897.038H9.8c-.855 0-1.442 0-1.897-.038-.445-.036-.683-.103-.856-.19a2.1 2.1 0 0 1-.918-.919c-.088-.172-.155-.411-.191-.856-.037-.455-.038-1.042-.038-1.897Zm4.5-1.2a1.6 1.6 0 1 1 3.2 0 1.6 1.6 0 0 1-3.2 0Zm1.6-3.4a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8ZM13 6a.9.9 0 0 1 .9-.9h1.5a.9.9 0 0 1 0 1.8h-1.5A.9.9 0 0 1 13 6Zm-2-.9a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8Z",
    fill: "#023F80"
  })));
};

var _path$72;
function _extends$76() { _extends$76 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$76.apply(this, arguments); }
var SvgWaterDropOutline = function SvgWaterDropOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$76({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$72 || (_path$72 = /*#__PURE__*/createElement$2("path", {
    d: "M13.983 2.5C17.354 2.5 24 10.384 24 16c0 5.523-4.477 10-10 10S4 21.523 4 16c0-5.618 6.617-13.5 9.983-13.5Zm0 2c-.652 0-2.738 1.565-4.482 3.643C7.338 10.72 6 13.56 6 16a8 8 0 1 0 16 0c0-2.439-1.344-5.278-3.517-7.855-1.75-2.078-3.846-3.645-4.5-3.645Z",
    fill: "#023F80"
  })));
};

var _path$73;
function _extends$77() { _extends$77 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$77.apply(this, arguments); }
var SvgWheelOutline = function SvgWheelOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$77({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$73 || (_path$73 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9 12a8.1 8.1 0 1 1 16.2 0 8.1 8.1 0 0 1-16.2 0ZM12 2.1c-5.468 0-9.9 4.432-9.9 9.9s4.432 9.9 9.9 9.9 9.9-4.432 9.9-9.9-4.432-9.9-9.9-9.9Zm-1.426 5.63c.448-.149.928-.23 1.426-.23.498 0 .978.081 1.426.23l-.205.356a.9.9 0 1 0 1.559.9l.204-.354A4.496 4.496 0 0 1 16.41 11.1H16a.9.9 0 1 0 0 1.8h.41a4.496 4.496 0 0 1-1.426 2.468l-.204-.354a.9.9 0 0 0-1.56.9l.206.355c-.448.15-.928.231-1.426.231-.498 0-.978-.081-1.426-.23l.206-.356a.9.9 0 0 0-1.56-.9l-.204.354A4.496 4.496 0 0 1 7.59 12.9H8a.9.9 0 0 0 0-1.8h-.41a4.496 4.496 0 0 1 1.426-2.468l.205.354a.9.9 0 1 0 1.559-.9l-.206-.355ZM12 5.7a6.3 6.3 0 1 0 0 12.6 6.3 6.3 0 0 0 0-12.6ZM10.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
    fill: "#023F80"
  })));
};

var _path$74;
function _extends$78() { _extends$78 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$78.apply(this, arguments); }
var SvgWindowCheck = function SvgWindowCheck(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$78({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$74 || (_path$74 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6 6h4.8c1.713 0 2.878.002 3.778.075.877.072 1.325.202 1.638.361a4 4 0 0 1 1.748 1.748c.16.313.29.761.36 1.638.074.9.076 2.065.076 3.778v.8c0 1.713-.002 2.878-.075 3.778-.072.877-.202 1.325-.361 1.638a4 4 0 0 1-1.748 1.748c-.313.16-.761.29-1.638.36-.9.074-2.065.076-3.778.076h-4.8c-1.713 0-2.878-.002-3.778-.075-.877-.072-1.325-.202-1.638-.361a4 4 0 0 1-1.748-1.748c-.16-.313-.29-.761-.36-1.638C4.001 17.278 4 16.113 4 14.4v-.8c0-1.713.002-2.878.075-3.778.072-.877.202-1.325.361-1.638a4 4 0 0 1 1.748-1.748c.313-.16.761-.29 1.638-.36C8.722 6.001 9.887 6 11.6 6ZM2 13.6c0-3.36 0-5.04.654-6.324a6 6 0 0 1 2.622-2.622C6.56 4 8.24 4 11.6 4h4.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C26 8.56 26 10.24 26 13.6v.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C21.44 24 19.76 24 16.4 24h-4.8c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C2 19.44 2 17.76 2 14.4v-.8Zm6.5-4.35a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0Zm3.5 0a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0ZM14.25 8a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm3.919 4.257a1 1 0 0 1 .074 1.412l-4.5 5a1 1 0 0 1-1.383.1l-3-2.5a1 1 0 1 1 1.28-1.537l2.26 1.884 3.857-4.285a1 1 0 0 1 1.412-.074Z",
    fill: "#023F80"
  })));
};

var _path$75;
function _extends$79() { _extends$79 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$79.apply(this, arguments); }
var SvgWorkOutline = function SvgWorkOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$79({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$75 || (_path$75 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.165 3.1h1.67c.53 0 .982 0 1.352.03.39.032.768.102 1.13.286a2.9 2.9 0 0 1 1.267 1.267c.184.362.254.74.286 1.13.029.355.03.785.03 1.287h.935c.53 0 .982 0 1.352.03.39.032.768.102 1.13.286a2.9 2.9 0 0 1 1.267 1.267c.184.362.254.74.286 1.13.03.37.03.822.03 1.351V12.634c0 .392 0 .738-.023 1.026-.025.305-.081.622-.238.93a2.4 2.4 0 0 1-1.05 1.05c-.227.116-.46.176-.689.21V16.436c0 .6 0 1.103-.034 1.515-.035.43-.111.84-.31 1.229a3.15 3.15 0 0 1-1.376 1.377c-.389.198-.798.274-1.229.31-.412.033-.915.033-1.515.033H8.564c-.6 0-1.103 0-1.515-.034-.43-.035-.84-.111-1.229-.31a3.15 3.15 0 0 1-1.377-1.376c-.198-.389-.274-.798-.31-1.229-.033-.412-.033-.916-.033-1.515V15.85a2.21 2.21 0 0 1-.69-.212 2.4 2.4 0 0 1-1.048-1.048 2.44 2.44 0 0 1-.238-.931 13.482 13.482 0 0 1-.024-1.026V11.165c0-.53 0-.981.03-1.352.032-.39.102-.768.286-1.13a2.9 2.9 0 0 1 1.268-1.267c.361-.184.74-.254 1.13-.286.37-.03.82-.03 1.35-.03H7.1c0-.502.001-.932.03-1.287.032-.39.102-.768.286-1.13a2.9 2.9 0 0 1 1.268-1.267c.361-.184.74-.254 1.13-.286.37-.03.82-.03 1.35-.03ZM5.4 14.1h13.2c.435 0 .707 0 .912-.018.194-.015.248-.041.26-.047a.6.6 0 0 0 .263-.263c.006-.012.032-.066.048-.26.016-.205.017-.477.017-.912v-1.4c0-.575 0-.952-.024-1.24-.023-.278-.062-.394-.096-.46a1.1 1.1 0 0 0-.48-.48c-.066-.034-.182-.073-.46-.096-.288-.023-.665-.024-1.24-.024H6.2c-.575 0-.952 0-1.24.024-.278.023-.393.062-.46.096a1.1 1.1 0 0 0-.48.48c-.034.066-.073.182-.096.46-.023.288-.024.665-.024 1.24v1.4c0 .435 0 .707.018.912.015.194.041.248.047.26a.6.6 0 0 0 .263.263c.012.006.066.032.26.047.205.017.477.018.912.018Zm.5 1.8v.5c0 .645 0 1.074.028 1.405.026.319.072.465.12.558.129.254.335.46.59.59.092.047.238.093.558.12.33.026.76.027 1.404.027h6.8c.645 0 1.075 0 1.405-.028.32-.026.465-.072.558-.12.254-.129.46-.335.59-.59.047-.092.093-.238.12-.557.026-.33.027-.76.027-1.405v-.5H5.9Zm9.176-9.94c.022.271.024.62.024 1.14H8.9c0-.52.002-.869.024-1.14.023-.278.062-.394.096-.46a1.1 1.1 0 0 1 .48-.48c.067-.034.182-.073.46-.096.288-.023.665-.024 1.24-.024h1.6c.575 0 .952 0 1.24.024.278.023.394.062.46.096a1.1 1.1 0 0 1 .48.48c.034.066.073.182.096.46Z",
    fill: "#023F80"
  })));
};

var _path$76;
function _extends$7a() { _extends$7a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7a.apply(this, arguments); }
var SvgWristWatchOutline = function SvgWristWatchOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7a({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$76 || (_path$76 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.498 4.412A3 3 0 0 1 12.44 2h3.12a3 3 0 0 1 2.942 2.412l.41 2.045a9.008 9.008 0 0 1 3.902 5.716 2 2 0 0 1 0 3.654 9.008 9.008 0 0 1-3.903 5.716l-.409 2.045A3 3 0 0 1 15.56 26h-3.12a3 3 0 0 1-2.942-2.412l-.41-2.045A8.992 8.992 0 0 1 5 14a8.992 8.992 0 0 1 4.089-7.543l.409-2.045Zm1.842.988c.84-.26 1.734-.4 2.66-.4.926 0 1.82.14 2.66.4l-.119-.596a1 1 0 0 0-.98-.804H12.44a1 1 0 0 0-.981.804l-.12.596Zm0 17.2.119.596a1 1 0 0 0 .98.804h3.121a1 1 0 0 0 .981-.804l.12-.596A9 9 0 0 1 14 23a9 9 0 0 1-2.66-.4ZM21 14a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-6-4a1 1 0 1 0-2 0v4a1 1 0 0 0 .606.92l3.5 1.5a1 1 0 1 0 .788-1.84L15 13.34V10Z",
    fill: "#023F80"
  })));
};

var _path$77, _path2$2g;
function _extends$7b() { _extends$7b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7b.apply(this, arguments); }
var SvgWriteOutline = function SvgWriteOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7b({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$77 || (_path$77 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.562 4.1H13.1a.9.9 0 0 1 0 1.8H9.6c-.995 0-1.687 0-2.226.045-.527.043-.828.123-1.054.238A2.6 2.6 0 0 0 5.183 7.32c-.115.226-.195.527-.238 1.054C4.9 8.913 4.9 9.605 4.9 10.6v3.8c0 .995 0 1.687.045 2.225.043.529.123.83.238 1.055a2.6 2.6 0 0 0 1.137 1.137c.226.115.526.195 1.054.238.539.044 1.231.045 2.226.045h3.8c.995 0 1.687 0 2.226-.045.528-.043.828-.123 1.054-.238a2.6 2.6 0 0 0 1.137-1.137c.115-.226.195-.526.238-1.055.044-.538.045-1.23.045-2.225v-3.5a.9.9 0 1 1 1.8 0v3.538c0 .948 0 1.714-.05 2.334-.053.64-.163 1.203-.43 1.726a4.4 4.4 0 0 1-1.923 1.922c-.522.267-1.086.377-1.725.43-.62.05-1.386.05-2.334.05H9.562c-.948 0-1.714 0-2.334-.05-.64-.053-1.203-.163-1.726-.43a4.4 4.4 0 0 1-1.922-1.922c-.267-.523-.377-1.087-.43-1.726-.05-.62-.05-1.386-.05-2.334v-3.876c0-.948 0-1.714.05-2.334.053-.64.163-1.203.43-1.726A4.4 4.4 0 0 1 5.502 4.58c.523-.267 1.087-.377 1.726-.43.62-.05 1.386-.05 2.334-.05Z",
    fill: "#023F80"
  })), _path2$2g || (_path2$2g = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.125 3.326A1.1 1.1 0 0 1 20.68 4.88l-.353.354a.4.4 0 0 1-.566 0l-.99-.99a.4.4 0 0 1 0-.566l.354-.353ZM18.524 5.9l-.424-.424c-.437-.437-.72-.411-1.132 0l-5.126 5.126c-1.953 1.953-3.187 3.884-2.758 4.314.43.43 2.36-.805 4.314-2.758l5.126-5.126c.437-.437.411-.72 0-1.132Z",
    fill: "#023F80"
  })));
};

var _path$78;
function _extends$7c() { _extends$7c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7c.apply(this, arguments); }
var SvgWriteSquareOutline = function SvgWriteSquareOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7c({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$78 || (_path$78 = /*#__PURE__*/createElement$2("path", {
    d: "M10.074 3.002h7.928l.003 2h-7.883c-1.671.014-2.371.162-3.093.548-.64.342-1.137.839-1.48 1.48C5.143 7.79 5 8.528 5 10.41v7.18c0 1.881.142 2.62.55 3.38.342.641.839 1.138 1.48 1.48.68.365 1.343.517 2.822.545l.558.005h7.18l.558-.005c1.479-.028 2.141-.18 2.823-.545a3.544 3.544 0 0 0 1.48-1.48c.364-.68.516-1.343.544-2.822L23 17.59 22.996 10l2.001-.001L25 17.59c0 2.183-.203 3.233-.786 4.324a5.543 5.543 0 0 1-2.3 2.3c-1.091.583-2.14.786-4.324.786h-7.18c-2.183 0-3.233-.203-4.324-.786a5.543 5.543 0 0 1-2.3-2.3c-.553-1.034-.764-2.03-.784-3.988v-7.852c.02-1.958.231-2.954.784-3.988a5.543 5.543 0 0 1 2.3-2.3c1.034-.553 2.03-.764 3.988-.784Zm13.104 1.82a1.1 1.1 0 0 1 0 1.555l-8.89 8.89a7.13 7.13 0 0 1-2.331 1.554l-.434.178a.4.4 0 0 1-.522-.522l.178-.434a7.13 7.13 0 0 1 1.553-2.33l8.89-8.891a1.1 1.1 0 0 1 1.556 0ZM24 9a1 1 0 0 1 .993.883L25 10h-2a1 1 0 0 1 1-1Zm-6-6a1 1 0 0 1 .117 1.993L18 5V3Zm6.8-1a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4Z",
    fill: "#023F80"
  })));
};

var _path$79;
function _extends$7d() { _extends$7d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7d.apply(this, arguments); }
var SvgZipOutline = function SvgZipOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7d({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$79 || (_path$79 = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4h1.2c1.573 0 2.633.002 3.45.068.793.065 1.18.181 1.439.313a3.5 3.5 0 0 1 1.53 1.53c.132.26.248.646.313 1.44.066.816.068 1.876.068 3.449v6.4c0 1.573-.002 2.633-.068 3.45-.065.793-.181 1.18-.313 1.439a3.5 3.5 0 0 1-1.53 1.53c-.26.132-.646.248-1.44.313-.816.066-1.876.068-3.449.068h-2.4c-1.573 0-2.633-.002-3.45-.068-.793-.065-1.18-.181-1.439-.313a3.5 3.5 0 0 1-1.53-1.53c-.132-.26-.248-.646-.313-1.44C6.002 19.834 6 18.773 6 17.2v-6.4c0-1.573.002-2.633.068-3.45.065-.793.181-1.18.313-1.439a3.5 3.5 0 0 1 1.53-1.53c.26-.132.646-.248 1.44-.313.67-.054 1.503-.065 2.649-.067V5.2c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218C12.38 6 12.52 6 12.8 6H14v2h-1.2c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C12 8.38 12 8.52 12 8.8v.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055H14v1.2c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h.4c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C16 11.62 16 11.48 16 11.2v-.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C15.62 10 15.48 10 15.2 10H14V8h1.2c.28 0 .42 0 .527-.054a.5.5 0 0 0 .218-.219C16 7.62 16 7.48 16 7.2v-.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C15.62 6 15.48 6 15.2 6H14V4ZM4 10.8c0-3.08 0-4.62.6-5.797a5.5 5.5 0 0 1 2.403-2.404C8.18 2 9.72 2 12.8 2h2.4c3.08 0 4.62 0 5.797.6A5.5 5.5 0 0 1 23.4 5.002C24 6.18 24 7.72 24 10.8v6.4c0 3.08 0 4.62-.6 5.797a5.5 5.5 0 0 1-2.403 2.404C19.82 26 18.28 26 15.2 26h-2.4c-3.08 0-4.62 0-5.797-.6A5.5 5.5 0 0 1 4.6 22.998C4 21.82 4 20.28 4 17.2v-6.4ZM16 16v-1.2c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C15.62 14 15.48 14 15.2 14h-2.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C12 14.38 12 14.52 12 14.8V16a2 2 0 1 0 4 0Z",
    fill: "#023F80"
  })));
};

var _path$7a;
function _extends$7e() { _extends$7e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7e.apply(this, arguments); }
var SvgTerminalClasica = function SvgTerminalClasica(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7e({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7a || (_path$7a = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.886 1c1.053 0 1.91.828 1.91 1.846v1.927H16.25v1.23h.84c1.054 0 1.91.829 1.91 1.847V22H5l.004-14.151c0-1.017.857-1.845 1.91-1.845h.836V2.846C7.75 1.828 8.607 1 9.66 1h7.226Zm.205 6.234H6.913a.627.627 0 0 0-.636.615l-.004 12.92h11.454V7.85a.627.627 0 0 0-.636-.615ZM11.364 18.31v1.23H10.09v-1.23h1.273Zm-2.546 0v1.23H7.546v-1.23h1.272Zm5.091 0v1.23h-1.273v-1.23h1.273Zm2.546 0v1.23h-1.273v-1.23h1.273Zm-5.091-2.461v1.23H10.09v-1.23h1.273Zm-2.546 0v1.23H7.546v-1.23h1.272Zm5.091 0v1.23h-1.273v-1.23h1.273Zm2.546-2.461v3.691h-1.273v-3.691h1.273Zm-5.091 0v1.23H10.09v-1.23h1.273Zm-2.546 0v1.23H7.546v-1.23h1.272Zm5.091 0v1.23h-1.273v-1.23h1.273Zm2.546-4.922v3.691h-8.91V8.465h8.91Zm-1.273 1.23H8.818v1.23h6.364v-1.23Zm-.096-7.465H9.66a.627.627 0 0 0-.636.616v3.158h5.954V2.846c0-.216.038-.423.11-.616Zm1.8 0a.627.627 0 0 0-.636.616v.697h1.273v-.697a.627.627 0 0 0-.637-.616Z",
    fill: "#023F80"
  })));
};

var _path$7b;
function _extends$7f() { _extends$7f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7f.apply(this, arguments); }
var SvgTerminalSinEspecificar = function SvgTerminalSinEspecificar(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7f({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7b || (_path$7b = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.588 6.348h1.78c.727 0 1.315.562 1.316 1.255v13.14c0 .693-.59 1.254-1.316 1.255H7.317C6.59 21.997 6 21.436 6 20.743V7.603c0-.693.59-1.255 1.316-1.255h.965v-2.57c0-.98.837-1.778 1.866-1.778h7.063c1.03 0 1.866.798 1.866 1.779v1.857h-2.488v.712Zm-7.063 0V3.464c0-.327.279-.593.622-.593h5.558a1.696 1.696 0 0 0-.107.593v2.884H9.525Zm8.337-2.765c0-.327-.309-.593-.652-.593s-.673.266-.673.592v.93h1.325v-.93Zm-.407 17.142c.494 0 .894-.381.894-.852v-11.4c0-.471-.4-.852-.894-.853H8.23c-.494 0-.893.382-.894.852v11.401c0 .47.4.852.894.852h9.226Zm-6.349-5.808a.195.195 0 0 0-.058.196c.02.07.077.125.151.144a.218.218 0 0 0 .206-.055l3.228-3.512a.195.195 0 0 0 .057-.195.207.207 0 0 0-.151-.144.218.218 0 0 0-.205.054l-3.228 3.512Zm2.262.284 1.666-2.023a.195.195 0 0 0 .057-.195.206.206 0 0 0-.15-.144.218.218 0 0 0-.205.054l-1.667 2.024a.195.195 0 0 0 0 .284.219.219 0 0 0 .299 0Zm.067 4.432h-1.186a.207.207 0 0 0-.21.201c0 .111.094.202.21.202h1.186c.116 0 .211-.09.211-.202a.207.207 0 0 0-.211-.201Z",
    fill: "#023F80"
  })));
};

var _path$7c;
function _extends$7g() { _extends$7g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7g.apply(this, arguments); }
var SvgErrorCircleFilled = function SvgErrorCircleFilled(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7g({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7c || (_path$7c = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.25c6.168 0 11.25-5.092 11.25-11.256C23.25 5.842 18.156.75 12 .75 5.833.75.75 5.842.75 11.994.75 18.158 5.844 23.25 12 23.25ZM8.065 17a.81.81 0 0 1-.815-.816c0-.224.083-.425.236-.567l3.475-3.486-3.475-3.486a.757.757 0 0 1-.236-.568c0-.46.355-.803.815-.803.225 0 .414.082.568.236l3.486 3.475 3.498-3.475a.75.75 0 0 1 .567-.26c.45 0 .816.366.816.815 0 .225-.07.402-.248.568l-3.486 3.498 3.486 3.463a.83.83 0 0 1 .236.59.81.81 0 0 1-.815.816.82.82 0 0 1-.591-.248l-3.463-3.475-3.474 3.475a.793.793 0 0 1-.58.248Z",
    fill: "#023F80"
  })));
};

var _path$7d, _path2$2h;
function _extends$7h() { _extends$7h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7h.apply(this, arguments); }
var SvgUploadCloudOutline = function SvgUploadCloudOutline(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7h({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7d || (_path$7d = /*#__PURE__*/createElement$2("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.5a.857.857 0 0 0 .857-.857v-9.074l1.966 1.966a.857.857 0 1 0 1.212-1.213l-3.429-3.428a.857.857 0 0 0-1.212 0l-3.429 3.428a.857.857 0 0 0 1.213 1.213l1.965-1.966v9.074c0 .473.384.857.857.857Z",
    fill: "#023F80"
  })), _path2$2h || (_path2$2h = /*#__PURE__*/createElement$2("path", {
    d: "M13.786 2.572a5.545 5.545 0 0 0-3.863 1.552c-1.263-.353-2.564-.034-3.534.668-.964.699-1.661 1.822-1.675 3.13a3.98 3.98 0 0 0-2.143 3.516c0 2.236 1.897 3.928 4.034 3.99H8.57a.857.857 0 0 0 0-1.714H6.643c-1.314-.044-2.357-1.076-2.357-2.276 0-.97.638-1.841 1.596-2.156a.857.857 0 0 0 .577-.96c-.146-.852.245-1.641.936-2.141.694-.503 1.609-.65 2.409-.28a.857.857 0 0 0 1.023-.233 3.817 3.817 0 0 1 2.959-1.382c2.246 0 4.007 1.979 3.761 4.087a.857.857 0 0 0 .58.913c.953.317 1.587 1.185 1.587 2.152 0 1.198-.972 2.216-2.245 2.274h-2.04a.857.857 0 1 0 0 1.714l2.118-.002c2.15-.097 3.882-1.834 3.882-3.986a3.98 3.98 0 0 0-2.144-3.516c-.028-2.896-2.492-5.35-5.5-5.35Z",
    fill: "#023F80"
  })));
};

var _path$7e;
function _extends$7i() { _extends$7i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7i.apply(this, arguments); }
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7i({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7e || (_path$7e = /*#__PURE__*/createElement$2("path", {
    d: "M12.012 2c-5.506 0-9.989 4.478-9.99 9.984a9.964 9.964 0 0 0 1.333 4.993L2 22l5.232-1.236a9.981 9.981 0 0 0 4.774 1.215h.004c5.505 0 9.985-4.48 9.988-9.985a9.922 9.922 0 0 0-2.922-7.066A9.923 9.923 0 0 0 12.012 2Zm-.002 2a7.95 7.95 0 0 1 5.652 2.342 7.929 7.929 0 0 1 2.336 5.65c-.002 4.404-3.584 7.986-7.99 7.986a7.999 7.999 0 0 1-3.817-.97l-.673-.367-.745.175-1.968.465.48-1.785.217-.8-.414-.72a7.98 7.98 0 0 1-1.067-3.992C4.023 7.582 7.607 4 12.01 4ZM8.477 7.375a.917.917 0 0 0-.666.313c-.23.248-.875.852-.875 2.08 0 1.228.894 2.415 1.02 2.582.123.166 1.726 2.765 4.263 3.765 2.108.831 2.536.667 2.994.625.458-.04 1.477-.602 1.685-1.185.208-.583.209-1.085.147-1.188-.062-.104-.229-.166-.479-.29-.249-.126-1.476-.728-1.705-.811-.229-.083-.396-.125-.562.125-.166.25-.643.81-.79.976-.145.167-.29.19-.54.065-.25-.126-1.054-.39-2.008-1.24-.742-.662-1.243-1.477-1.389-1.727-.145-.25-.013-.386.112-.51.112-.112.248-.291.373-.437.124-.146.167-.25.25-.416.083-.166.04-.313-.022-.438s-.547-1.357-.77-1.851c-.186-.415-.384-.425-.562-.432-.145-.006-.31-.006-.476-.006Z",
    fill: "#023F80"
  })));
};

var IconSource = {
  QR: SvgQr,
  'puntos-venta': SvgPuntosVenta,
  accessibility_outline: SvgAccessibilityOutline,
  aceleraciones: SvgAceleraciones,
  add_award_outline: SvgAddAwardOutline,
  add_awards_outline: SvgAddAwardsOutline,
  add_circle_dashed_outline: SvgAddCircleDashedOutline,
  add_circle_outline: SvgAddCircleOutline,
  add_outline: SvgAddOutline,
  add_square_outline: SvgAddSquareOutline,
  advertising_outline: SvgAdvertisingOutline,
  'ahora-12': SvgAhora12,
  'ahora-12-b': SvgAhora12B,
  airplay_audio_outline: SvgAirplayAudioOutline,
  airplay_video_outline: SvgAirplayVideoOutline,
  all_categories_outline: SvgAllCategoriesOutline,
  anses: SvgAnses,
  app_badge_outline: SvgAppBadgeOutline,
  apple_outline: SvgAppleOutline,
  apple_watch_outlite: SvgAppleWatchOutlite,
  archive_outline: SvgArchiveOutline,
  armchair_outline: SvgArmchairOutline,
  arrow_down_outline: SvgArrowDownOutline,
  arrow_left_outline: SvgArrowLeftOutline,
  arrow_pop_down_outline: SvgArrowPopDownOutline,
  arrow_pop_up_outline: SvgArrowPopUpOutline,
  arrow_right_circle_outline: SvgArrowRightCircleOutline,
  arrow_right_outline: SvgArrowRightOutline,
  arrow_right_square_outline: SvgArrowRightSquareOutline,
  arrow_up_circle_outline: SvgArrowUpCircleOutline,
  arrow_up_outline: SvgArrowUpOutline,
  arrow_up_rectangle_outline: SvgArrowUpRectangleOutline,
  arrow_uturn_left_outline: SvgArrowUturnLeftOutline,
  arrow_uturn_right_outline: SvgArrowUturnRightOutline,
  article_outline: SvgArticleOutline,
  articles_outline: SvgArticlesOutline,
  attach_outline: SvgAttachOutline,
  baby_bottle_outline: SvgBabyBottleOutline,
  backspace_outline: SvgBackspaceOutline,
  ball_outline: SvgBallOutline,
  bank_outline: SvgBankOutline,
  basketball_ball_outline: SvgBasketballBallOutline,
  beauty_outline: SvgBeautyOutline,
  bidy_outline: SvgBidyOutline,
  billhead_outline: SvgBillheadOutline,
  block_outline: SvgBlockOutline,
  body_outline: SvgBodyOutline,
  bomb_outline: SvgBombOutline,
  book_outline: SvgBookOutline,
  bookmark_outline: SvgBookmarkOutline,
  books_outline: SvgBooksOutline,
  'boton-de-pago': SvgBotonDePago,
  bowl_sticks_outline: SvgBowlSticksOutline,
  box_heart_outline: SvgBoxHeartOutline,
  brain_outline: SvgBrainOutline,
  briefcase_outline: SvgBriefcaseOutline,
  broadcast_outline: SvgBroadcastOutline,
  brush_outline: SvgBrushOutline,
  bug_outline: SvgBugOutline,
  building_outline: SvgBuildingOutline,
  bus_outline: SvgBusOutline,
  cactus_outline: SvgCactusOutline,
  calendar_outline: SvgCalendarOutline,
  camera_outline: SvgCameraOutline,
  camera_slash_outline: SvgCameraSlashOutline,
  cancel_circle_outline: SvgCancelCircleOutline,
  cancel_outline: SvgCancelOutline,
  cancel_shield_outline: SvgCancelShieldOutline,
  canister_outline: SvgCanisterOutline,
  car_outline: SvgCarOutline,
  cards_2_outline: SvgCards2Outline,
  cash_out_outline: SvgCashOutOutline,
  chain_outline: SvgChainOutline,
  check_circle_device_outline: SvgCheckCircleDeviceOutline,
  check_circle_outline: SvgCheckCircleOutline,
  check_shield_device_outline: SvgCheckShieldDeviceOutline,
  check_shield_outline: SvgCheckShieldOutline,
  check_square_outline: SvgCheckSquareOutline,
  checks_outline: SvgChecksOutline,
  chef_hat_outline: SvgChefHatOutline,
  chevron_down_outline: SvgChevronDownOutline,
  chevron_down_small: SvgChevronDownSmall,
  chevron_left_outline: SvgChevronLeftOutline,
  chevron_left_small: SvgChevronLeftSmall,
  chevron_right_circle_outline: SvgChevronRightCircleOutline,
  chevron_right_outline: SvgChevronRightOutline,
  chevron_right_small: SvgChevronRightSmall,
  chevron_up_outline: SvgChevronUpOutline,
  chevron_up_small: SvgChevronUpSmall,
  chevrons_2_left_outline: SvgChevrons2LeftOutline,
  chevrons_2_right_outline: SvgChevrons2RightOutline,
  clear_data_outline: SvgClearDataOutline,
  clip_outline: SvgClipOutline,
  clock_outline: SvgClockOutline,
  clock_rectangle_stack_outline: SvgClockRectangleStackOutline,
  cloud_outline: SvgCloudOutline,
  'cobro-anticipado': SvgCobroAnticipado,
  coffee_steam_outline: SvgCoffeeSteamOutline,
  colaboradores: SvgColaboradores,
  comment_disable_outline: SvgCommentDisableOutline,
  comment_outline: SvgCommentOutline,
  compass_outline: SvgCompassOutline,
  computer_outline: SvgComputerOutline,
  conciliacion: SvgConciliacion,
  configuracion: SvgConfiguracion,
  'contracargos-1': SvgContracargos1,
  contracargos: SvgContracargos,
  cookie_outline: SvgCookieOutline,
  copy_outline: SvgCopyOutline,
  crop: SvgCrop,
  cross_shield_outline: SvgCrossShieldOutline,
  crown_outline: SvgCrownOutline,
  cube_box_outline: SvgCubeBoxOutline,
  cup_outline: SvgCupOutline,
  'cupones-en-vuelo': SvgCuponesEnVuelo,
  delete_arrow_up_outline: SvgDeleteArrowUpOutline,
  delete_outline: SvgDeleteOutline,
  devices_outline: SvgDevicesOutline,
  diamond_outline: SvgDiamondOutline,
  dice_1_outline: SvgDice1Outline,
  dice_2_outline: SvgDice2Outline,
  dice_3_outline: SvgDice3Outline,
  dice_4_outline: SvgDice4Outline,
  dice_5_outline: SvgDice5Outline,
  dice_6_outline: SvgDice6Outline,
  discount_outline: SvgDiscountOutline,
  document_outline: SvgDocumentOutline,
  dollar_circle_outline: SvgDollarCircleOutline,
  donate_outline: SvgDonateOutline,
  done_outline: SvgDoneOutline,
  door_arrow_left_outline: SvgDoorArrowLeftOutline,
  door_arrow_right_outline: SvgDoorArrowRightOutline,
  download_cancel_outline: SvgDownloadCancelOutline,
  download_check_outline: SvgDownloadCheckOutline,
  download_cloud_outline: SvgDownloadCloudOutline,
  download_outline: SvgDownloadOutline,
  draggable_dots: SvgDraggableDots,
  drill_outline: SvgDrillOutline,
  edit_outline: SvgEditOutline,
  education_outline: SvgEducationOutline,
  emblem_outline: SvgEmblemOutline,
  employee_outline: SvgEmployeeOutline,
  error_circle_filled: SvgErrorCircleFilled,
  error_circle_outline: SvgErrorCircleOutline,
  explicit_outline: SvgExplicitOutline,
  external_link_outline: SvgExternalLinkOutline,
  face_id_outline: SvgFaceIdOutline,
  face_recognition_outline: SvgFaceRecognitionOutline,
  favorite: SvgFavorite,
  favorite_filled: SvgFavoriteFilled,
  favorite_outline: SvgFavoriteOutline,
  film_strip_add_outline: SvgFilmStripAddOutline,
  film_strip_outline: SvgFilmStripOutline,
  fire_outline: SvgFireOutline,
  folder_outline: SvgFolderOutline,
  fortune_wheel_outline: SvgFortuneWheelOutline,
  forward_10_outline: SvgForward10Outline,
  game_outline: SvgGameOutline,
  gesture_outline: SvgGestureOutline,
  ghost_outline: SvgGhostOutline,
  ghost_simle_outline: SvgGhostSimleOutline,
  gift_outline: SvgGiftOutline,
  globe_outline: SvgGlobeOutline,
  google_play_outline: SvgGooglePlayOutline,
  graph_outline: SvgGraphOutline,
  grid_layout_outline: SvgGridLayoutOutline,
  gun_outline: SvgGunOutline,
  hammer_outline: SvgHammerOutline,
  hand_slash_outline: SvgHandSlashOutline,
  hanger_outline: SvgHangerOutline,
  hashtag_outline: SvgHashtagOutline,
  headphones_outline: SvgHeadphonesOutline,
  health_outline: SvgHealthOutline,
  heart_circle_outline: SvgHeartCircleOutline,
  heart_lock_outline: SvgHeartLockOutline,
  heart_unlock_outline: SvgHeartUnlockOutline,
  help_circle_outline: SvgHelpCircleOutline,
  help_outline: SvgHelpOutline,
  hide_outline: SvgHideOutline,
  'historial-btn-pago': SvgHistorialBtnPago,
  historial: SvgHistorial,
  'history_backward_outline-1': SvgHistoryBackwardOutline1,
  history_backward_outline: SvgHistoryBackwardOutline,
  history_forward_outline: SvgHistoryForwardOutline,
  home_heart_outline: SvgHomeHeartOutline,
  home_outline: SvgHomeOutline,
  horse_toy_outline: SvgHorseToyOutline,
  image_filter_outline: SvgImageFilterOutline,
  inbox_outline: SvgInboxOutline,
  incognito_outline: SvgIncognitoOutline,
  info_circle_outline: SvgInfoCircleOutline,
  informacion: SvgInformacion,
  inicio: SvgInicio,
  'insumo-papel': SvgInsumoPapel,
  ipad_outline: SvgIpadOutline,
  key_outline: SvgKeyOutline,
  key_square_outline: SvgKeySquareOutline,
  keyboard_bots_outline: SvgKeyboardBotsOutline,
  keyboard_outline: SvgKeyboardOutline,
  knife_outline: SvgKnifeOutline,
  laptop_outline: SvgLaptopOutline,
  lifebuoy_outline: SvgLifebuoyOutline,
  lightbulb_outline: SvgLightbulbOutline,
  lightbulb_star_outline: SvgLightbulbStarOutline,
  like: SvgLike,
  like_filled: SvgLikeFilled,
  like_lock_outline: SvgLikeLockOutline,
  like_outline: SvgLikeOutline,
  link_circle_outline: SvgLinkCircleOutline,
  link_outline: SvgLinkOutline,
  linked_outline: SvgLinkedOutline,
  'liquidaciones-1': SvgLiquidaciones1,
  liquidaciones: SvgLiquidaciones,
  list_add_outline: SvgListAddOutline,
  list_check_outline: SvgListCheckOutline,
  list_like_outline: SvgListLikeOutline,
  list_like_slash_outline: SvgListLikeSlashOutline,
  list_outline: SvgListOutline,
  live_add_outline: SvgLiveAddOutline,
  live_disable_outline: SvgLiveDisableOutline,
  live_outline: SvgLiveOutline,
  live_slash_outline: SvgLiveSlashOutline,
  location_map_outline: SvgLocationMapOutline,
  location_outline: SvgLocationOutline,
  lock_open_outline: SvgLockOpenOutline,
  lock_outline: SvgLockOutline,
  logo_vk_outline: SvgLogoVkOutline,
  logout: SvgLogout,
  lotus_outline: SvgLotusOutline,
  loudspeaker_slash_outline: SvgLoudspeakerSlashOutline,
  magic_hat_outline: SvgMagicHatOutline,
  magic_wand_outline: SvgMagicWandOutline,
  magnifier_minus: SvgMagnifierMinus,
  magnifier_plus: SvgMagnifierPlus,
  mail_outline: SvgMailOutline,
  mail_stack_outline: SvgMailStackOutline,
  market_add_badge_outline: SvgMarketAddBadgeOutline,
  market_like_outline: SvgMarketLikeOutline,
  market_outline: SvgMarketOutline,
  market_slash_outline: SvgMarketSlashOutline,
  masks_outline: SvgMasksOutline,
  megafon_outline: SvgMegafonOutline,
  mention_outline: SvgMentionOutline,
  menu_outline: SvgMenuOutline,
  message_add_badge_outline: SvgMessageAddBadgeOutline,
  message_arrow_right_outline: SvgMessageArrowRightOutline,
  message_check_outline: SvgMessageCheckOutline,
  message_cross_outline: SvgMessageCrossOutline,
  message_forward_outline: SvgMessageForwardOutline,
  message_heart_outline: SvgMessageHeartOutline,
  message_outline: SvgMessageOutline,
  message_reply_outline: SvgMessageReplyOutline,
  message_unread_outline: SvgMessageUnreadOutline,
  message_unread_top_outline: SvgMessageUnreadTopOutline,
  messages_outline: SvgMessagesOutline,
  microphone_slash_outline: SvgMicrophoneSlashOutline,
  microphone_videocam_outline: SvgMicrophoneVideocamOutline,
  microphone_videocam_slash_outline: SvgMicrophoneVideocamSlashOutline,
  minus_outline: SvgMinusOutline,
  money_circle_outline: SvgMoneyCircleOutline,
  money_history_backward_outline: SvgMoneyHistoryBackwardOutline,
  money_request_outline: SvgMoneyRequestOutline,
  money_send_outline: SvgMoneySendOutline,
  money_transfer_outline: SvgMoneyTransferOutline,
  money_wad_outline: SvgMoneyWadOutline,
  more_horizontal: SvgMoreHorizontal,
  more_vertical: SvgMoreVertical,
  mortar_outline: SvgMortarOutline,
  motorcycle_outline: SvgMotorcycleOutline,
  movie_reel_outline: SvgMovieReelOutline,
  movimientos: SvgMovimientos,
  music_mic_outline: SvgMusicMicOutline,
  music_outline: SvgMusicOutline,
  mute_outline: SvgMuteOutline,
  name_tag_outline: SvgNameTagOutline,
  narrative_active_outline: SvgNarrativeActiveOutline,
  narrative_outline: SvgNarrativeOutline,
  newsfeed_outline: SvgNewsfeedOutline,
  no_smoking_sign_outline: SvgNoSmokingSignOutline,
  notebook_add_badge_outline: SvgNotebookAddBadgeOutline,
  notebook_check_outline: SvgNotebookCheckOutline,
  notification_add_outline: SvgNotificationAddOutline,
  notification_check_outline: SvgNotificationCheckOutline,
  notification_disable_outline: SvgNotificationDisableOutline,
  notification_outline: SvgNotificationOutline,
  notification_slash_outline: SvgNotificationSlashOutline,
  notification_subtract_outline: SvgNotificationSubtractOutline,
  on_off_outline: SvgOnOffOutline,
  paint_roller_outline: SvgPaintRollerOutline,
  palette_outline: SvgPaletteOutline,
  parcial_outline: SvgParcialOutline,
  paw_outline: SvgPawOutline,
  payment_card_outline: SvgPaymentCardOutline,
  payment_card_vertical_outline: SvgPaymentCardVerticalOutline,
  payment_divider: SvgPaymentDivider,
  payment_hand_outline: SvgPaymentHandOutline,
  paywave_outline: SvgPaywaveOutline,
  pen_keyhole_outline: SvgPenKeyholeOutline,
  pen_stack_lock_outline: SvgPenStackLockOutline,
  pen_stack_outline: SvgPenStackOutline,
  phone_add_outline: SvgPhoneAddOutline,
  phone_outline: SvgPhoneOutline,
  phone_wave_outline: SvgPhoneWaveOutline,
  photos_stack_outline: SvgPhotosStackOutline,
  picture_in_picture_16x9_outline: SvgPictureInPicture16X9Outline,
  picture_outline: SvgPictureOutline,
  pill_outline: SvgPillOutline,
  pin_dot_outline: SvgPinDotOutline,
  pin_dot_slash_outline: SvgPinDotSlashOutline,
  pin_outline: SvgPinOutline,
  pin_slash_outline: SvgPinSlashOutline,
  pincode_lock_outline: SvgPincodeLockOutline,
  pincode_outline: SvgPincodeOutline,
  place_outline: SvgPlaceOutline,
  plane_outline: SvgPlaneOutline,
  'planes-gobierno': SvgPlanesGobierno,
  play_cards_2_outline: SvgPlayCards2Outline,
  play_next_outline: SvgPlayNextOutline,
  play_speed_outline: SvgPlaySpeedOutline,
  playlist_outline: SvgPlaylistOutline,
  podcast_outline: SvgPodcastOutline,
  poll_outline: SvgPollOutline,
  poll_square_outline: SvgPollSquareOutline,
  power_socket_outline: SvgPowerSocketOutline,
  'prestamos-1': SvgPrestamos1,
  prestamos: SvgPrestamos,
  printer_outline: SvgPrinterOutline,
  privacy_outline: SvgPrivacyOutline,
  qr_code: SvgQrCode,
  qr_code_outline: SvgQrCodeOutline,
  question_outline: SvgQuestionOutline,
  radiowaves_left_and_right_outline: SvgRadiowavesLeftAndRightOutline,
  recorder_tape_outline: SvgRecorderTapeOutline,
  receipt_outline: SvgReceiptOutline,
  refresh_outline: SvgRefreshOutline,
  remove_circle_outline: SvgRemoveCircleOutline,
  repeat_1_outline: SvgRepeat1Outline,
  repeat_outline: SvgRepeatOutline,
  replay_10_outline: SvgReplay10Outline,
  replay_outline: SvgReplayOutline,
  reply_outline: SvgReplyOutline,
  report_outline: SvgReportOutline,
  'reportes-1': SvgReportes1,
  reportes: SvgReportes,
  robot_outline: SvgRobotOutline,
  rouble_badge_outline: SvgRoubleBadgeOutline,
  rss_feed_outline: SvgRssFeedOutline,
  rss_video_outline: SvgRssVideoOutline,
  sad_face_outline: SvgSadFaceOutline,
  scan_viewfinder_outline: SvgScanViewfinderOutline,
  school_outline: SvgSchoolOutline,
  screen_grid_horizon_2_line_outline: SvgScreenGridHorizon2LineOutline,
  screen_grid_horizon_line_outline: SvgScreenGridHorizonLineOutline,
  screen_grid_tile_outline: SvgScreenGridTileOutline,
  screen_grid_vertical_line_outline: SvgScreenGridVerticalLineOutline,
  screencast_outline: SvgScreencastOutline,
  search: SvgSearch,
  search_like_filled_outline: SvgSearchLikeFilledOutline,
  search_like_outline: SvgSearchLikeOutline,
  search_outline: SvgSearchOutline,
  search_slash_outline: SvgSearchSlashOutline,
  send_outline: SvgSendOutline,
  services_gibdd: SvgServicesGibdd,
  services_outline: SvgServicesOutline,
  settings: SvgSettings,
  settings_outline: SvgSettingsOutline,
  share_external: SvgShareExternal,
  share_outline: SvgShareOutline,
  shield_keyhole_outline: SvgShieldKeyholeOutline,
  shopping_cart_outline: SvgShoppingCartOutline,
  shuffle_outline: SvgShuffleOutline,
  'sin-especificar': SvgSinEspecificar,
  skirt_outline: SvgSkirtOutline,
  skull_outline: SvgSkullOutline,
  sliders_outline: SvgSlidersOutline,
  smartphone_outline: SvgSmartphoneOutline,
  smile_outline: SvgSmileOutline,
  smiles_2_outline: SvgSmiles2Outline,
  sneaker_outline: SvgSneakerOutline,
  snowflake_outline: SvgSnowflakeOutline,
  song_outline: SvgSongOutline,
  sort_horizontal_outline: SvgSortHorizontalOutline,
  sort_outline: SvgSortOutline,
  sparkle_outline: SvgSparkleOutline,
  speedometer_max_outline: SvgSpeedometerMaxOutline,
  speedometer_middle_outline: SvgSpeedometerMiddleOutline,
  speedometer_min_outline: SvgSpeedometerMinOutline,
  square_4_outline: SvgSquare4Outline,
  stars_outline: SvgStarsOutline,
  statistics_outline: SvgStatisticsOutline,
  sticker_outline: SvgStickerOutline,
  stopwatch_outline: SvgStopwatchOutline,
  storefront_outline: SvgStorefrontOutline,
  story_add_outline: SvgStoryAddOutline,
  story_outline: SvgStoryOutline,
  stud_outline: SvgStudOutline,
  subtitles_outline: SvgSubtitlesOutline,
  sun_outline: SvgSunOutline,
  success_circle_filled: SvgSuccessCircleFilled,
  switch_outline: SvgSwitchOutline,
  sync_outline: SvgSyncOutline,
  't-shirt_outline': SvgTShirtOutline,
  tag_outline: SvgTagOutline,
  target_outline: SvgTargetOutline,
  tear_off_flyer_outline: SvgTearOffFlyerOutline,
  'terminales-1': SvgTerminales1,
  terminales: SvgTerminales,
  text_circle_outline: SvgTextCircleOutline,
  text_live_outline: SvgTextLiveOutline,
  text_outline: SvgTextOutline,
  text_tt_outline: SvgTextTtOutline,
  thumbs_up_outline: SvgThumbsUpOutline,
  ticket_outline: SvgTicketOutline,
  touch_id_outline: SvgTouchIdOutline,
  train_outline: SvgTrainOutline,
  tshirt_outline: SvgTshirtOutline,
  tv_outline: SvgTvOutline,
  unarchive_outline: SvgUnarchiveOutline,
  unblock_outline: SvgUnblockOutline,
  unfavorite_outline: SvgUnfavoriteOutline,
  unpin_outline: SvgUnpinOutline,
  upload_outline: SvgUploadOutline,
  user_add_badge_outline: SvgUserAddBadgeOutline,
  user_add_outline: SvgUserAddOutline,
  user_added_outline: SvgUserAddedOutline,
  user_background_outline: SvgUserBackgroundOutline,
  user_circle_outline: SvgUserCircleOutline,
  user_incoming_outline: SvgUserIncomingOutline,
  user_microphone_badge_outline: SvgUserMicrophoneBadgeOutline,
  user_microphone_badge_slash_outline: SvgUserMicrophoneBadgeSlashOutline,
  user_outgoing_outline: SvgUserOutgoingOutline,
  user_outline: SvgUserOutline,
  user_square_outline: SvgUserSquareOutline,
  user_star_badge_outline: SvgUserStarBadgeOutline,
  user_star_badge_slash_outline: SvgUserStarBadgeSlashOutline,
  user_tag_outline: SvgUserTagOutline,
  users_3_outline: SvgUsers3Outline,
  users_outline: SvgUsersOutline,
  video_circle_outline: SvgVideoCircleOutline,
  video_outline: SvgVideoOutline,
  videocam_add_outline: SvgVideocamAddOutline,
  videocam_arrow_up_outline: SvgVideocamArrowUpOutline,
  videocam_arrow_up_slash_outline: SvgVideocamArrowUpSlashOutline,
  videocam_outline: SvgVideocamOutline,
  videocam_slash_outline: SvgVideocamSlashOutline,
  view_outline: SvgViewOutline,
  vinyl_outline: SvgVinylOutline,
  vmoji_outline: SvgVmojiOutline,
  voice_outline: SvgVoiceOutline,
  volume_outline: SvgVolumeOutline,
  wallet_outline: SvgWalletOutline,
  warning_triangle_outline: SvgWarningTriangleOutline,
  warning_circle_filled: SvgWarningCircleFilled,
  washer_outline: SvgWasherOutline,
  water_drop_outline: SvgWaterDropOutline,
  wheel_outline: SvgWheelOutline,
  window_check: SvgWindowCheck,
  work_outline: SvgWorkOutline,
  wrist_watch_outline: SvgWristWatchOutline,
  write_outline: SvgWriteOutline,
  write_square_outline: SvgWriteSquareOutline,
  zip_outline: SvgZipOutline,
  terminal_clasica: SvgTerminalClasica,
  terminal_sin_especificar: SvgTerminalSinEspecificar,
  upload_cloud_outline: SvgUploadCloudOutline,
  whatsapp: SvgWhatsapp
};

var Icon$1 = function Icon$1(_ref) {
  var cursor = _ref.cursor,
    height = _ref.height,
    modifier = _ref.modifier,
    name = _ref.name,
    onClick = _ref.onClick,
    variant = _ref.variant,
    width = _ref.width,
    disabled = _ref.disabled;
  var CurrentIcon = IconSource["".concat(name)] || false;
  return CurrentIcon && /*#__PURE__*/React__default.createElement(Icon, {
    variant: disabled ? 'neutral' : variant,
    cursor: disabled ? 'auto' : cursor,
    modifier: disabled ? 'regular' : modifier,
    "data-testid": "icon-".concat(name),
    onClick: disabled ? undefined : onClick,
    disabled: disabled
  }, /*#__PURE__*/React__default.createElement(CurrentIcon, {
    width: width,
    height: height
  }));
};
Icon$1.defaultProps = {
  cursor: 'default',
  height: 24,
  modifier: 'regular',
  variant: 'primary',
  width: 24,
  disabled: false
};
Icon$1.propTypes = {
  height: PropTypes.number,
  name: PropTypes.string.isRequired,
  width: PropTypes.number,
  cursor: PropTypes.oneOf(['not-allowed', 'pointer', 'default', 'none']),
  modifier: PropTypes.oneOf(['regular', 'strong', 'weak', 'inverted']),
  variant: PropTypes.oneOf(['primary', 'secondary-1', 'secondary-2', 'secondary-3', 'neutral', 'danger', 'warning', 'info', 'success']).isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

var _templateObject$3, _templateObject2$3, _templateObject3$3, _templateObject4$2, _templateObject5$2, _templateObject6$2, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;
var getAlign = function getAlign(align) {
  switch (align) {
    case 'center':
      return css$1(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n        text-align: center;\n      "])));
    case 'right':
      return css$1(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n        text-align: right;\n      "])));
    case 'left':
      return css$1(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n        text-align: left;\n      "])));
  }
};
var getVariant$1 = function getVariant(variant, modifier) {
  var _theme$colors$variant;
  switch (variant) {
    case 'neutral-1':
      return css$1(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), theme.colors['neutral'].text[modifier]);
    default:
      return css$1(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), (_theme$colors$variant = theme.colors[variant]) === null || _theme$colors$variant === void 0 ? void 0 : _theme$colors$variant.text[modifier]);
  }
};
var types = {
  span: {
    1: theme.textStyles['text-preset-8'],
    2: theme.textStyles['text-preset-9'],
    4: theme.textStyles['text-preset-10'],
    5: theme.textStyles['text-preset-11']
  },
  label: {
    1: theme.textStyles['text-preset-8'],
    2: theme.textStyles['text-preset-9'],
    4: theme.textStyles['text-preset-10'],
    5: theme.textStyles['text-preset-11']
  },
  h: {
    1: theme.textStyles['text-preset-1'],
    2: theme.textStyles['text-preset-2'],
    3: theme.textStyles['text-preset-3'],
    4: theme.textStyles['text-preset-4'],
    5: theme.textStyles['text-preset-5'],
    6: theme.textStyles['text-preset-6']
  }
};
var getType = function getType(component, type) {
  return css$1(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n    ", ";\n  "])), types[component][type]);
};
var weight = {
  h: {
    regular: css$1(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n      font-weight: normal;\n    "]))),
    bold: css$1(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n      font-weight: 500;\n    "])))
  },
  label: {
    regular: css$1(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n      font-weight: normal;\n    "]))),
    bold: css$1(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n      font-weight: 700;\n    "])))
  },
  span: {
    regular: css$1(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral(["\n      font-weight: normal;\n    "]))),
    bold: css$1(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n      font-weight: 700;\n    "])))
  }
};
var getWeight = function getWeight(component, type) {
  return css$1(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    ", ";\n  "])), weight[component][type]);
};
var fonts = {
  h: {
    primary: css$1(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      font-family: Rubik, serif;\n    "]))),
    secondary: css$1(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n      font-family: Roboto, serif;\n    "])))
  },
  span: {
    primary: css$1(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n      font-family: Roboto, serif;\n    "]))),
    secondary: css$1(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n      font-family: Rubik, serif;\n    "])))
  }
};
var getFont = function getFont(component, type) {
  return css$1(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    ", ";\n  "])), fonts[component][type]);
};

var _templateObject$4;
var H = styled.h1(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var type = _ref.type;
  return getType('h', type);
}, function (_ref2) {
  var variant = _ref2.variant,
    modifier = _ref2.modifier;
  return getVariant$1(variant, modifier);
}, function (_ref3) {
  var weight = _ref3.weight;
  return getWeight('h', weight);
}, function (_ref4) {
  var font = _ref4.font;
  return getFont('h', font);
}, function (_ref5) {
  var align = _ref5.align;
  return getAlign(align);
});

var H$1 = function H$1(_ref) {
  var align = _ref.align,
    children = _ref.children,
    font = _ref.font,
    type = _ref.type,
    variant = _ref.variant,
    weight = _ref.weight,
    modifier = _ref.modifier;
  return /*#__PURE__*/React__default.createElement(H, {
    align: align,
    as: "h".concat(type),
    font: font,
    type: type,
    variant: variant,
    weight: weight,
    modifier: modifier
  }, children);
};
H$1.defaultProps = {
  type: '1',
  variant: 'neutral',
  font: 'primary',
  weight: 'regular',
  align: 'left',
  modifier: 'regular'
};
H$1.propTypes = {
  type: PropTypes.oneOf(['1', '2', '3', '4', '5', '6']).isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary-1', 'secondary-2', 'secondary-3', 'neutral', 'neutral-1', 'danger', 'warning', 'info', 'success']).isRequired,
  weight: PropTypes.oneOf(['regular', 'bold']).isRequired,
  align: PropTypes.oneOf(['center', 'right', 'left']).isRequired,
  modifier: PropTypes.oneOf(['regular', 'strong', 'weak', 'inverted']).isRequired
};

var _templateObject$5;
var Span = styled.span(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var type = _ref.type;
  return getType('span', type);
}, function (_ref2) {
  var variant = _ref2.variant,
    modifier = _ref2.modifier;
  return getVariant$1(variant, modifier);
}, function (_ref3) {
  var weight = _ref3.weight;
  return getWeight('span', weight);
}, function (_ref4) {
  var font = _ref4.font;
  return getFont('span', font);
});

var _templateObject$6;
var P = styled(Span)(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var align = _ref.align;
  return getAlign(align);
});

var P$1 = function P$1(_ref) {
  var align = _ref.align,
    children = _ref.children,
    font = _ref.font,
    type = _ref.type,
    variant = _ref.variant,
    weight = _ref.weight,
    modifier = _ref.modifier;
  return /*#__PURE__*/React__default.createElement(P, {
    align: align,
    font: font,
    type: type,
    variant: variant,
    weight: weight,
    modifier: modifier,
    as: "p"
  }, children);
};
P$1.defaultProps = {
  align: 'left',
  font: 'primary',
  type: '1',
  variant: 'primary',
  weight: 'regular',
  modifier: 'regular'
};
P$1.propTypes = {
  align: PropTypes.oneOf(['center', 'right', 'left']).isRequired,
  font: PropTypes.oneOf(['primary', 'secondary']).isRequired,
  type: PropTypes.oneOf(['1', '2', '3', '4', '5', '6']).isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary-1', 'secondary-2', 'secondary-3', 'neutral', 'neutral-1', 'danger', 'warning', 'info', 'success']).isRequired,
  weight: PropTypes.oneOf(['regular', 'bold']).isRequired,
  modifier: PropTypes.oneOf(['regular', 'strong', 'weak', 'inverted']).isRequired
};

var _templateObject$7, _templateObject2$4, _templateObject3$4, _templateObject4$3, _templateObject5$3, _templateObject6$3, _templateObject7$2, _templateObject8$2;
var Link = styled.a(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  cursor: pointer;\n\n  text-decoration: none;\n\n  ", "\n\n  ", "\n\n  ", ";\n"])), function (_ref) {
  var size = _ref.size;
  return getSize(size);
}, function (_ref2) {
  var variant = _ref2.variant;
  return getVariant$2(variant);
}, function (_ref3) {
  var icons = _ref3.icons;
  return css$1(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n    i {\n      margin-right: ", ";\n      margin-left: ", ";\n\n      ", "\n    }\n  "])), icons !== null && icons !== void 0 && icons.iconLeft ? theme.spacing['spacing-2'] : 0, icons !== null && icons !== void 0 && icons.iconRight ? theme.spacing['spacing-2'] : 0, (icons === null || icons === void 0 ? void 0 : icons.iconLeft) && (icons === null || icons === void 0 ? void 0 : icons.iconRight) && "&:first-child {margin-right: ".concat(theme.spacing['spacing-2'], "; margin-left: 0;}\n       &:last-child {margin-right: 0; margin-left: ").concat(theme.spacing['spacing-2'], ";}"));
});
var HyperlinkContent = styled.div(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n"])));
var getVariant$2 = function getVariant(variant) {
  switch (variant) {
    case 'primary':
      return css$1(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n        color: ", ";\n\n        &:hover {\n          color: ", ";\n          text-decoration: underline;\n\n          svg path {\n            fill: ", ";\n          }\n        }\n        &:not([href]) {\n          color: ", ";\n          &:hover {\n            color: ", ";\n          }\n        }\n        &:focus,\n        &:active {\n          color: ", ";\n\n          svg path {\n            fill: ", ";\n          }\n        }\n      "])), theme.colors.primary.text.weak, theme.colors.primary.text.strong, theme.colors.primary.ic.strong, theme.colors.primary.text.weak, theme.colors.primary.text.strong, theme.colors['secondary-1'].text.strong, theme.colors['secondary-1'].ic.strong);
    case 'inverted':
      return css$1(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n        color: ", ";\n        &:not([href]) {\n          color: ", ";\n        }\n        &:hover {\n          text-decoration: underline;\n        }\n      "])), theme.colors.neutral.text.inverted, theme.colors.neutral.text.inverted);
  }
};
var getSize = function getSize(size) {
  switch (size) {
    case 'xs':
      return css$1(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral(["\n        ", ";\n      "])), theme.textStyles['text-preset-10']);
    case 'sm':
      return css$1(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["\n        ", ";\n      "])), theme.textStyles['text-preset-9']);
    case 'md':
      return css$1(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral(["\n        ", ";\n      "])), theme.textStyles['text-preset-8']);
  }
};

var Link$1 = function Link$1(_ref) {
  var children = _ref.children,
    href = _ref.href,
    size = _ref.size,
    target = _ref.target,
    variant = _ref.variant,
    icons = _ref.icons,
    onClick = _ref.onClick;
  var renderIcon = function renderIcon(name) {
    var iconSizes = {
      sm: 20,
      md: 24
    };
    return /*#__PURE__*/React__default.createElement(Icon$1, {
      cursor: "pointer",
      name: name,
      width: iconSizes[size],
      height: iconSizes[size],
      variant: variant === 'primary' ? 'primary' : 'neutral',
      modifier: variant === 'primary' ? 'weak' : 'inverted'
    });
  };
  return /*#__PURE__*/React__default.createElement(Link, {
    href: href,
    icons: icons,
    size: size,
    target: target,
    variant: variant,
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(HyperlinkContent, null, (icons === null || icons === void 0 ? void 0 : icons.iconLeft) && renderIcon(icons.iconLeft), children, (icons === null || icons === void 0 ? void 0 : icons.iconRight) && renderIcon(icons.iconRight)));
};
Link$1.defaultProps = {
  size: 'sm',
  target: '_self',
  variant: 'primary'
};
Link$1.propTypes = {
  href: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top', 'framename']),
  variant: PropTypes.oneOf(['primary', 'inverted']),
  icons: PropTypes.shape({
    iconLeft: PropTypes.string,
    iconRight: PropTypes.string,
    iconCenter: PropTypes.string
  }),
  onClick: PropTypes.func
};

var Alert$1 = function Alert$1(_ref) {
  var variant = _ref.variant,
    icon = _ref.icon,
    title = _ref.title,
    description = _ref.description,
    textLink = _ref.textLink,
    href = _ref.href,
    onClickLink = _ref.onClickLink;
  var nameIcons = {
    info: 'info_circle_outline',
    success: 'check_circle_outline',
    warning: 'error_circle_outline',
    danger: 'cancel_circle_outline'
  };
  var renderIcon = function renderIcon() {
    return /*#__PURE__*/React__default.createElement(IconBaseAlert, null, /*#__PURE__*/React__default.createElement(Icon$1, {
      variant: variant,
      name: nameIcons[variant],
      modifier: "regular",
      width: 24,
      height: 24
    }));
  };
  var renderTitle = function renderTitle() {
    return /*#__PURE__*/React__default.createElement(AlertTitle, null, /*#__PURE__*/React__default.createElement(H$1, {
      variant: variant,
      modifier: "regular",
      type: "6",
      weight: "bold"
    }, title));
  };
  var renderDescription = function renderDescription() {
    return /*#__PURE__*/React__default.createElement(P$1, {
      variant: variant,
      modifier: "regular",
      type: "2",
      weight: "regular"
    }, description);
  };
  var renderTextLink = function renderTextLink() {
    return /*#__PURE__*/React__default.createElement(LinkAlert, null, /*#__PURE__*/React__default.createElement(Link$1, {
      variant: "primary",
      href: href,
      target: "_blank",
      size: "sm",
      onClick: onClickLink
    }, textLink));
  };
  return /*#__PURE__*/React__default.createElement(Alert, {
    variant: variant
  }, icon && renderIcon(), /*#__PURE__*/React__default.createElement(TextWrapper, null, title && renderTitle(), description && renderDescription(), textLink && renderTextLink()));
};
Alert$1.defaultProps = {
  variant: 'info'
};
Alert$1.propTypes = {
  icon: PropTypes.bool,
  variant: PropTypes.oneOf(['info', 'success', 'warning', 'danger']).isRequired,
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
  textLink: PropTypes.string,
  href: PropTypes.string,
  onClickLink: PropTypes.func
};

var _templateObject$8, _templateObject2$5, _templateObject3$5, _templateObject4$4, _templateObject5$4, _templateObject6$4, _templateObject7$3, _templateObject8$3, _templateObject9$2, _templateObject10$2, _templateObject11$2, _templateObject12$1;
var Badge = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: ", ";\n  height: 24px;\n  padding: ", " ", ";\n  ", "\n  > i {\n    margin-right: ", ";\n  }\n"])), theme.borderRadius['border-radius-5'], theme.spacing['spacing-2'], theme.spacing['spacing-3'], function (_ref) {
  var variant = _ref.variant,
    type = _ref.type,
    modifier = _ref.modifier,
    size = _ref.size,
    border = _ref.border;
  return isOldVariant(variant) ? oldStyles(variant, size, border) : getBadgeVariant(variant, type, modifier);
}, theme.spacing['spacing-2']);
var getBadgeVariant = function getBadgeVariant(variant, type, modifier) {
  switch (type) {
    case 'dot':
      return css$1(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n        background-color: ", ";\n        box-shadow: inset 0 0 0 1px ", ";\n      "])), theme.colors.neutral.bg.weak, theme.colors.neutral.border.weak);
    case 'notification':
      return css$1(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n        min-width: 24px;\n        height: 16px;\n        background-color: ", ";\n      "])), theme.colors['secondary-2'].bg.regular);
    default:
      return css$1(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), theme.colors[variant].bg[modifier]);
  }
};
var oldVariants = ['primary', 'default', 'neutral-n-4', 'white'];
var isOldVariant = function isOldVariant(variant) {
  return oldVariants.includes(variant);
};
var oldStyles = function oldStyles(variant, size, border) {
  switch (variant) {
    case 'primary':
      return css$1(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), theme.oldColors['palette-primary-p-1-p-1']);
    case 'neutral-n-4':
      return css$1(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), theme.oldColors['palette-neutral-n-4']);
    case 'white':
      return css$1(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), theme.oldColors['palette-background-cards-white']);
    case 'default':
      return css$1(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteral(["\n        font-size: 14px;\n        background-color: ", ";\n        color: ", ";\n      "])), theme.oldColors.white[600], theme.oldColors['text-gray']);
  }
  switch (size) {
    case 'sm':
      return css$1(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteral(["\n        padding: 5px 10px;\n      "])));
    case 'md':
      return css$1(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteral(["\n        padding: 5px 15px;\n      "])));
  }
  switch (border) {
    case 'none':
      return css$1(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteral([""])));
    default:
      return css$1(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral(["\n        border: solid 1px ", ";\n      "])), getBorderColor(border));
  }
};
var getBorderColor = function getBorderColor(border) {
  switch (border) {
    case 'primary':
      return "".concat(theme.oldColors['palette-primary-p-1-p-1'], ";");
    case 'primary-5':
      return "".concat(theme.oldColors['palette-primary-p-5-p-5'], ";");
    case 'neutral-2':
      return "".concat(theme.oldColors['palette-neutral-n-2'], ";");
    case 'neutral-3':
      return "".concat(theme.oldColors['palette-neutral-n-3'], ";");
    case 'success':
      return "".concat(theme.oldColors['palette-message-success'], ";");
    case 'error':
      return "".concat(theme.oldColors['palette-message-error'], ";");
    case 'info':
      return "".concat(theme.oldColors['palette-message-info'], ";");
  }
};

var _templateObject$9, _templateObject2$6;
var Dot = styled.div.attrs(function () {
  return {
    'data-testid': 'dot-pill'
  };
})(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  width: 8px;\n  height: 8px;\n  border-radius: ", ";\n  margin: ", " ", "\n    ", " 0;\n  ", "\n"])), theme.borderRadius['border-radius-5'], theme.spacing['spacing-2'], theme.spacing['spacing-2'], theme.spacing['spacing-2'], function (_ref) {
  var variant = _ref.variant,
    modifier = _ref.modifier;
  return getVariant$3(variant, modifier);
});
var getVariant$3 = function getVariant(variant, modifier) {
  return css$1(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), theme.colors[variant].bg[modifier]);
};

var Dot$1 = function Dot$1(_ref) {
  var variant = _ref.variant,
    modifier = _ref.modifier;
  return /*#__PURE__*/React__default.createElement(Dot, {
    variant: variant,
    modifier: modifier
  });
};
Dot$1.defaultProps = {
  modifier: 'regular',
  variant: 'neutral'
};
Dot$1.propTypes = {
  modifier: PropTypes.oneOf(['regular', 'strong', 'weak', 'inverted']).isRequired,
  variant: PropTypes.oneOf(['danger', 'info', 'warning', 'success', 'neutral']).isRequired
};

var Span$1 = function Span$1(_ref) {
  var children = _ref.children,
    font = _ref.font,
    type = _ref.type,
    variant = _ref.variant,
    weight = _ref.weight,
    modifier = _ref.modifier;
  return /*#__PURE__*/React__default.createElement(Span, {
    font: font,
    type: type,
    variant: variant,
    weight: weight,
    modifier: modifier
  }, children);
};
Span$1.defaultProps = {
  font: 'primary',
  type: '1',
  variant: 'primary',
  weight: 'regular',
  modifier: 'regular'
};
Span$1.propTypes = {
  font: PropTypes.oneOf(['primary', 'secondary']).isRequired,
  type: PropTypes.oneOf(['1', '2', '3', '4', '5', '6']).isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary-1', 'secondary-2', 'secondary-3', 'neutral', 'neutral-1', 'danger', 'warning', 'info', 'success']).isRequired,
  weight: PropTypes.oneOf(['regular', 'bold']).isRequired,
  modifier: PropTypes.oneOf(['regular', 'strong', 'weak', 'inverted']).isRequired
};

var Badge$1 = function Badge$1(_ref) {
  var children = _ref.children,
    type = _ref.type,
    variant = _ref.variant,
    iconName = _ref.iconName,
    size = _ref.size,
    border = _ref.border,
    oval = _ref.oval;
  var innerProps = {
    danger: {
      bg: {
        variant: 'danger',
        modifier: 'weak'
      },
      text: {
        variant: 'danger',
        modifier: 'strong'
      },
      ic: {
        variant: 'danger',
        modifier: 'regular'
      }
    },
    info: {
      bg: {
        variant: 'info',
        modifier: 'weak'
      },
      text: {
        variant: 'info',
        modifier: 'regular'
      },
      ic: {
        variant: 'info',
        modifier: 'regular'
      }
    },
    warning: {
      bg: {
        variant: 'warning',
        modifier: 'weak'
      },
      text: {
        variant: 'warning',
        modifier: 'regular'
      },
      ic: {
        variant: 'warning',
        modifier: 'regular'
      }
    },
    success: {
      bg: {
        variant: 'success',
        modifier: 'weak'
      },
      text: {
        variant: 'success',
        modifier: 'regular'
      },
      ic: {
        variant: 'success',
        modifier: 'regular'
      }
    },
    'neutral-1': {
      bg: {
        variant: 'neutral',
        modifier: 'regular'
      },
      text: {
        variant: 'neutral-1',
        modifier: 'strong'
      },
      ic: {
        variant: 'neutral',
        modifier: 'strong'
      }
    },
    'neutral-2': {
      bg: {
        variant: 'neutral',
        modifier: 'inverted'
      },
      text: {
        variant: 'neutral-1',
        modifier: 'inverted'
      },
      ic: {
        variant: 'neutral',
        modifier: 'inverted'
      }
    }
  };
  var renderDotBadge = function renderDotBadge() {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Dot$1, {
      variant: innerProps[variant].ic.variant,
      modifier: innerProps[variant].ic.modifier
    }), /*#__PURE__*/React__default.createElement(Span$1, {
      type: "5",
      variant: "neutral-1",
      modifier: "strong"
    }, children));
  };
  var renderNotificationBadge = function renderNotificationBadge() {
    return /*#__PURE__*/React__default.createElement(Span$1, {
      type: "5",
      variant: "neutral-1",
      modifier: "inverted"
    }, children);
  };
  var renderTextBadge = function renderTextBadge() {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, iconName && /*#__PURE__*/React__default.createElement(Icon$1, {
      name: iconName,
      variant: innerProps[variant].ic.variant,
      modifier: innerProps[variant].ic.modifier,
      height: 16,
      width: 16
    }), /*#__PURE__*/React__default.createElement(Span$1, {
      type: "5",
      variant: innerProps[variant].text.variant,
      modifier: innerProps[variant].text.modifier
    }, children));
  };
  var badgeToRender = {
    dot: function dot() {
      return renderDotBadge();
    },
    notification: function notification() {
      return renderNotificationBadge();
    },
    text: function text() {
      return renderTextBadge();
    }
  };
  return /*#__PURE__*/React__default.createElement(Badge, {
    variant: innerProps[variant].bg.variant,
    type: type,
    modifier: innerProps[variant].bg.modifier,
    size: size,
    border: border
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, badgeToRender[type]()));
};
Badge$1.defaultProps = {
  type: 'text',
  variant: 'neutral-1',
  size: 'md',
  withOval: false,
  border: null
};
Badge$1.propTypes = {
  type: PropTypes.oneOf(['dot', 'text', 'notification']).isRequired,
  variant: PropTypes.oneOf(['danger', 'info', 'warning', 'success', 'neutral-1', 'neutral-2', 'primary', 'default', 'neutral-n-4', 'white']).isRequired,
  size: PropTypes.oneOf(['sm', 'md']),
  border: PropTypes.oneOf(['primary', 'primary-5', 'neutral-2', 'neutral-3', 'success', 'info', 'error', 'none']),
  oval: PropTypes.oneOf(['primary-5', 'success', 'neutral-2', 'info', 'error'])
};

var _templateObject$a, _templateObject2$7, _templateObject3$6, _templateObject4$5, _templateObject5$5, _templateObject6$5, _templateObject7$4, _templateObject8$4, _templateObject9$3, _templateObject10$3, _templateObject11$3, _templateObject12$2, _templateObject13$1;
var Button = styled.button(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  border: none;\n\n  &:focus,\n  &:focus-visible {\n    outline: none;\n  }\n\n  outline: none;\n\n  &::-moz-focus-inner {\n    border: 0;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n    \n  ", "\n    \n  ", "\n"])), function (_ref) {
  var size = _ref.size;
  return getSize$1(size);
}, function (_ref2) {
  var size = _ref2.size,
    iconAlign = _ref2.iconAlign;
  return getPadding(size, iconAlign);
}, function (_ref3) {
  var fullwidth = _ref3.fullwidth;
  return fullwidth && getFullWidth();
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled && getDisabled();
}, function (props) {
  return getVariant$4(props);
});
var getVariant$4 = function getVariant(props) {
  switch (props.variant) {
    case 'primary':
      return css$1(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n        background-color: ", ";\n        color: ", ";\n\n        &:hover {\n          background-color: ", ";\n        }\n\n        &:active {\n          background-color: ", ";\n        }\n\n        ", "\n      "])), theme.colors['primary'].bg.regular, theme.colors['neutral'].text.inverted, theme.colors['primary'].bg.strong, theme.colors['secondary-1'].bg.regular, function (props) {
        return props.disabled && "\n            background-color: ".concat(theme.colors['neutral'].bg.stronger, ";\n            color: ").concat(theme.colors['neutral'].text.regular, ";\n          ");
      });
    case 'secondary':
      return css$1(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n        background-color: transparent;\n        box-shadow: inset 0 0 0 2px ", ";\n        color: ", ";\n\n        &:hover {\n          background-color: ", ";\n          box-shadow: inset 0 0 0 2px ", ";\n        }\n\n        &:active {\n          background-color: ", ";\n          box-shadow: inset 0 0 0 2px\n            ", ";\n        }\n\n        ", "\n      "])), theme.colors['primary'].border.regular, theme.colors['primary'].text.regular, theme.colors['primary'].bg.weak, theme.colors['primary'].border.strong, theme.colors['secondary-1'].bg.weak, theme.colors['secondary-1'].border.strong, function (props) {
        return props.disabled && css$1(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["\n            box-shadow: inset 0 0 0 2px ", ";\n            color: ", ";\n          "])), theme.colors['neutral'].border.strong, theme.colors['neutral'].text.regular);
      });

    //TODO: revisar al hacer el componente cuit
    case 'link':
      return css$1(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral(["\n        color: ", ";\n        border: none;\n        background-color: transparent;\n        svg path[fill] {\n          fill: ", ";\n        }\n\n        &:hover {\n          color: ", ";\n\n          svg path[fill] {\n            fill: ", ";\n          }\n        }\n      "])), theme.oldColors['palette-input-link-normal'], theme.oldColors['palette-input-link-normal'], theme.oldColors['palette-input-link-hover'], theme.oldColors['palette-input-link-hover']);
    case 'tertiary':
      return css$1(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteral(["\n        border: none;\n        background-color: transparent;\n        color: ", ";\n        svg path[fill] {\n          fill: ", ";\n        }\n\n        &:hover {\n          color: ", ";\n          svg path[fill] {\n            fill: ", ";\n          }\n        }\n\n        &:active {\n          color: ", ";\n          svg path[fill] {\n            fill: ", ";\n          }\n        }\n\n        ", "\n      "])), theme.colors['primary'].text.regular, theme.colors['primary'].text.regular, theme.colors['primary'].text.strong, theme.colors['primary'].text.strong, theme.colors['secondary-1'].text.strong, theme.colors['secondary-1'].text.strong, function (props) {
        return props.disabled && "\n              color: ".concat(theme.colors['neutral'].text.regular, ";\n              svg path[fill] {\n                fill: ").concat(theme.colors['neutral'].text.regular, ";\n              }\n            ");
      });
  }
};
var getSize$1 = function getSize(size) {
  switch (size) {
    case 'sm':
      return css$1(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteral(["\n        border-radius: ", ";\n        ", ";\n      "])), theme.borderRadius['border-radius-5'], theme.textStyles['text-preset-7']);
    case 'md':
      return css$1(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteral(["\n        border-radius: ", ";\n        ", ";\n      "])), theme.borderRadius['border-radius-5'], theme.textStyles['text-preset-6']);
    case 'lg':
      return css$1(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteral(["\n        border-radius: ", ";\n        ", ";\n      "])), theme.borderRadius['border-radius-5'], theme.textStyles['text-preset-5']);
    case 'md-full':
      return css$1(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteral(["\n        border-radius: ", ";\n        ", ";\n        ", "\n      "])), theme.borderRadius['border-radius-5'], theme.textStyles['text-preset-6'], getFullWidth());
  }
};
var getPadding = function getPadding(size, iconAlign) {
  var paddingsBySize = {
    sm: {
      none: "\n        ".concat(theme.spacing['spacing-2'], "\n        ").concat(theme.spacing['spacing-4']),
      left: "\n        ".concat(theme.spacing['spacing-2'], "\n        ").concat(theme.spacing['spacing-4']),
      right: "\n        ".concat(theme.spacing['spacing-2'], "\n        ").concat(theme.spacing['spacing-4']),
      center: "".concat(theme.spacing['spacing-2'])
    },
    md: {
      none: "\n        ".concat(theme.spacing['spacing-3'], "\n        ").concat(theme.spacing['spacing-5']),
      left: "\n        ".concat(theme.spacing['spacing-3'], "\n        ").concat(theme.spacing['spacing-5']),
      right: "\n        ".concat(theme.spacing['spacing-3'], "\n        ").concat(theme.spacing['spacing-5']),
      center: "".concat(theme.spacing['spacing-3'])
    },
    lg: {
      none: "\n          ".concat(theme.spacing['spacing-4'], "\n          ").concat(theme.spacing['spacing-6']),
      left: "\n          ".concat(theme.spacing['spacing-4'], "\n          ").concat(theme.spacing['spacing-6']),
      right: "\n          ".concat(theme.spacing['spacing-4'], "\n          ").concat(theme.spacing['spacing-6']),
      center: "".concat(theme.spacing['spacing-4'])
    },
    'md-full': {
      none: "".concat(theme.spacing['spacing-4']),
      left: "".concat(theme.spacing['spacing-4']),
      right: "".concat(theme.spacing['spacing-4']),
      center: "".concat(theme.spacing['spacing-4'])
    }
  };
  return css$1(_templateObject11$3 || (_templateObject11$3 = _taggedTemplateLiteral(["\n    padding: ", ";\n    ", "\n\n    i {\n      margin-right: ", ";\n      margin-left: ", ";\n    }\n  "])), paddingsBySize[size][iconAlign], iconAlign === 'center' && size !== 'md-full' && "\n          display: flex;\n          justify-content: center;\n          align-items: center; \n        ", iconAlign === 'left' ? theme.spacing['spacing-3'] : 0, iconAlign === 'right' ? theme.spacing['spacing-3'] : 0);
};
var getFullWidth = function getFullWidth() {
  return css$1(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteral(["\n  width: 100%;\n  justify-content: center;\n"])));
};
var getDisabled = function getDisabled() {
  return css$1(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteral(["\n  cursor: not-allowed;\n  pointer-events: none;\n"])));
};

var Button$1 = function Button$1(_ref) {
  var disabled = _ref.disabled,
    size = _ref.size,
    variant = _ref.variant,
    animated = _ref.animated,
    type = _ref.type,
    onClick = _ref.onClick,
    fullwidth = _ref.fullwidth,
    children = _ref.children,
    id = _ref.id,
    icon = _ref.icon,
    iconAlign = _ref.iconAlign;
  var renderIcon = function renderIcon() {
    var iconSizes = {
      sm: 20,
      md: 24,
      lg: 28,
      'full-md': 20
    };
    return /*#__PURE__*/React__default.createElement(Icon$1, {
      cursor: disabled ? 'not-allowed' : 'pointer',
      variant: variant === 'primary' ? 'neutral' : 'primary',
      name: icon,
      modifier: variant === 'primary' ? 'inverted' : 'regular',
      width: iconSizes[size],
      height: iconSizes[size]
    });
  };
  return /*#__PURE__*/React__default.createElement(Button, {
    id: id,
    disabled: disabled,
    size: size,
    variant: variant,
    animated: animated,
    type: type,
    onClick: onClick,
    fullwidth: fullwidth,
    icon: icon,
    iconAlign: iconAlign
  }, icon && (iconAlign === 'left' || iconAlign === 'center') && renderIcon(), children, icon && iconAlign === 'right' && renderIcon());
};
Button$1.defaultProps = {
  animated: false,
  disabled: false,
  iconAlign: 'none',
  size: 'lg',
  type: 'button',
  variant: 'primary'
};
Button$1.propTypes = {
  animated: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  iconAlign: PropTypes.oneOf(['center', 'left', 'right', 'none']),
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'md-full']),
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary'])
};

var css_248z$7 = ":root {\n  --primary-text: #023F80;\n  --primary-text-strong: #002A55;\n  --primary-text-weak: #0A7FE4;\n  --primary-bg: #023F80;\n  --primary-bg-strong: #002A55;\n  --primary-bg-weak: #D8EBFF;\n  --primary-border: #023F80;\n  --primary-border-strong: #002A55;\n  --primary-border-weak: #479EF8;\n  --primary-ic: #023F80;\n  --primary-ic-strong: #002A55;\n  --primary-ic-weak: #0A7FE4;\n  --secondary-1-text: #1AAAAD;\n  --secondary-1-text-strong: #076568;\n  --secondary-1-text-weak: #71D7D9;\n  --secondary-1-bg: #1AAAAD;\n  --secondary-1-bg-strong: #137F82;\n  --secondary-1-bg-weak: #E0FBFD;\n  --secondary-1-border: #1AAAAD;\n  --secondary-1-border-strong: #137F82;\n  --secondary-1-border-weak: #71D7D9;\n  --secondary-1-ic: #1AAAAD;\n  --secondary-1-ic-strong: #137F82;\n  --secondary-1-ic-weak: #71D7D9;\n  --secondary-2-text: #DD2457;\n  --secondary-2-text-strong: #921034;\n  --secondary-2-text-weak: #FF95B3;\n  --secondary-2-bg: #DD2457;\n  --secondary-2-bg-strong: #B11E47;\n  --secondary-2-bg-weak: #FF95B3;\n  --secondary-2-border: #DD2457;\n  --secondary-2-border-strong: #B11E47;\n  --secondary-2-border-weak: #FF95B3;\n  --secondary-2-ic: #DD2457;\n  --secondary-2-ic-strong: #B11E47;\n  --secondary-2-ic-weak: #FF95B3;\n  --secondary-3-bg: #FECF2F;\n  --secondary-3-bg-strong: #FFA53F;\n  --secondary-3-bg-weak: #FFF0BD;\n  --secondary-3-border: #FECF2F;\n  --secondary-3-border-strong: #FFA53F;\n  --secondary-3-border-weak: #FFF0BD;\n  --secondary-3-ic: #FECF2F;\n  --secondary-3-ic-strong: #FFA53F;\n  --secondary-3-ic-weak: #FFF0BD;\n  --neutral-text: #647180;\n  --neutral-text-strong: #373E45;\n  --neutral-text-weak: #B6C5D5;\n  --neutral-text-inverted: #FFFFFF;\n  --neutral-bg: #F0F5FB;\n  --neutral-bg-strong: #EAF1F8;\n  --neutral-bg-stronger: #B6C5D5;\n  --neutral-bg-weak: #FFFFFF;\n  --neutral-bg-inverted:#373E45;\n  --neutral-border: #B6C5D5;\n  --neutral-border-strong: #647180;\n  --neutral-border-weak: #DEE8F3;\n  --neutral-ic: #647180;\n  --neutral-ic-strong: #373E45;\n  --neutral-ic-weak: #B6C5D5;\n  --neutral-ic-inverted: #FFFFFF;\n  --danger-text: #DD2457;\n  --danger-text-strong: #921034;\n  --danger-text-weak: #FF95B3;\n  --danger-bg:#DD2457;\n  --danger-bg-strong:#B11E47;\n  --danger-bg-weak: #FFF0F4;\n  --danger-border: #DD2457;\n  --danger-border-strong: #B11E47;\n  --danger-ic: #DD2457;\n  --warning-text: #623311;\n  --warning-bg: #FECF2F;\n  --warning-bg-strong: #FFA53F;\n  --warning-bg-weak: #FFF4CD;\n  --warning-border: #FECF2F;\n  --warning-border-strong: #FFA53F;\n  --warning-ic: #FFA53F;\n  --info-text:#023F80;\n  --info-bg: #479EF8;\n  --info-bg-strong: #023F80;\n  --info-bg-weak: #D8EBFF;\n  --info-border: #479EF8;\n  --info-border-strong: #023F80;\n  --info-ic: #479EF8;\n  --success-text: #035456;\n  --success-bg: #1AAAAD;\n  --success-bg-strong: #137F82;\n  --success-bg-weak: #E0FBFD;\n  --success-border: #1AAAAD;\n  --success-border-strong: #137F82;\n  --success-border-weak: #71D7D9;\n  --success-ic: #1AAAAD; }\n\n.rsg--content-3 {\n  max-width: none;\n  padding: 0;\n  margin: auto;\n  background-color: #f5f5f5; }\n\ndiv[class*='rsg--preview-'] {\n  padding: 0;\n  border: none; }\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box; }\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nlabel {\n  font-weight: normal;\n  margin: 0; }\n\ncode[class*='rsg--code-'] {\n  color: darkgreen;\n  font-size: 14px; }\n\n.button-rounded {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: bold;\n  padding: 13px 30px;\n  width: 100%;\n  border-radius: 24px;\n  outline: none; }\n  .button-rounded:focus, .button-rounded:focus-visible {\n    outline: none; }\n  .button-rounded::-moz-focus-inner {\n    border: 0; }\n  .button-rounded.button-rounded--disabled {\n    cursor: not-allowed;\n    pointer-events: none; }\n  .button-rounded.button-rounded--primary {\n    background-image: linear-gradient(to bottom, #05e9ea, #26cbcc);\n    color: white;\n    border: none; }\n    .button-rounded.button-rounded--primary svg {\n      position: absolute;\n      right: 30px; }\n    .button-rounded.button-rounded--primary svg path[fill] {\n      fill: white; }\n    .button-rounded.button-rounded--primary:hover {\n      background-image: linear-gradient(to bottom, #06e1e3, #20b9ba); }\n    .button-rounded.button-rounded--primary:active {\n      background-image: linear-gradient(to bottom, #06aaab, #20b9ba); }\n    .button-rounded.button-rounded--primary:focus {\n      border-color: var(--info-bg);\n      background-image: linear-gradient(to bottom, #05e9ea, #26cbcc); }\n    .button-rounded.button-rounded--primary.button-rounded--disabled {\n      background-image: none;\n      background-color: var(--neutral-bg-stronger);\n      color: var(--neutral-text); }\n      .button-rounded.button-rounded--primary.button-rounded--disabled svg path[fill] {\n        fill: darkgray; }\n";
styleInject(css_248z$7);

var ButtonRound = function ButtonRound(_ref) {
  var id = _ref.id,
    children = _ref.children,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    variant = _ref.variant,
    type = _ref.type;
  return /*#__PURE__*/React__default.createElement("button", {
    id: id,
    type: type,
    className: "button-rounded  \n            button-rounded--".concat(variant, " \n            ").concat(disabled ? 'button-rounded--disabled' : ''),
    onClick: onClick,
    disabled: disabled
  }, children);
};
ButtonRound.defaultProps = {
  disabled: false,
  variant: 'primary',
  type: 'button'
};
ButtonRound.propTypes = {
  text: PropTypes.string,
  disabled: PropTypes.bool,
  variant: PropTypes.string
};

var _templateObject$b, _templateObject2$8, _templateObject3$7, _templateObject4$6, _templateObject5$6;
var Checkbox = styled.div(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  align-items: center;\n  ", ";\n"])), theme.textStyles['text-preset-9']);
var CheckboxInput = styled.div(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n  input {\n    position: absolute;\n    z-index: 10;\n    opacity: 0;\n    cursor: pointer;\n    ", "\n  }\n"])), function (_ref) {
  var size = _ref.size;
  return getSizeCheckbox(size);
});
var CheckboxChecked = styled.span(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  height: 14px;\n  width: 14px;\n  ", "\n  position: relative;\n  border-radius: ", ";\n  ", "\n  ", " input:not(:checked) + & {\n    background: ", ";\n    box-shadow: inset 0 0 0 1px ", ";\n    i {\n      visibility: hidden;\n    }\n  }\n  ", " input:checked + & {\n    box-shadow: inset 0 0 0 1px ", ";\n    background: ", ";\n    i {\n      visibility: visible;\n    }\n  }\n  ", " input:checked:hover:not(:disabled)  + & {\n    background: ", ";\n    box-shadow: inset 0 0 0 1px ", ";\n  }\n  ", " input:disabled + & {\n    background: ", ";\n    box-shadow: inset 0 0 0 1px ", ";\n  }\n  ", " input:hover:not(:checked):not(:disabled)  + & {\n    background: ", ";\n  }\n"])), function (_ref2) {
  var size = _ref2.size;
  return getSizeCheckbox(size);
}, theme.borderRadius['border-radius-1'], function (_ref3) {
  var modifier = _ref3.modifier,
    variant = _ref3.variant;
  return "\n    svg {\n      path, \n      rect {\n        fill: ".concat(theme.colors[variant].ic[modifier], ";\n      }\n    }\n  ");
}, Checkbox, theme.colors['neutral'].bg.weak, theme.colors['neutral'].border.regular, Checkbox, theme.colors['secondary-1'].bg.regular, theme.colors['secondary-1'].bg.regular, Checkbox, theme.colors['secondary-1'].bg.strong, theme.colors['secondary-1'].bg.strong, Checkbox, theme.colors['neutral'].bg.strong, theme.colors['neutral'].border.regular, Checkbox, theme.colors['neutral'].bg.regular);
var TextWrapper$1 = styled.div(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral(["\n  margin-left: ", ";\n"])), theme.spacing['spacing-3']);
var getSizeCheckbox = function getSizeCheckbox(size) {
  var sizes = {
    sm: '14px',
    md: '20px',
    lg: '24px'
  };
  return css$1(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteral(["\n    height: ", ";\n    width: ", ";\n  "])), sizes[size], sizes[size]);
};

var _templateObject$c;
var Label = styled.label(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var type = _ref.type;
  return getType('label', type);
}, function (_ref2) {
  var variant = _ref2.variant,
    modifier = _ref2.modifier;
  return getVariant$1(variant, modifier);
}, function (_ref3) {
  var weight = _ref3.weight;
  return getWeight('label', weight);
});

var Label$1 = function Label$1(_ref) {
  var variant = _ref.variant,
    type = _ref.type,
    weight = _ref.weight,
    children = _ref.children,
    id = _ref.id,
    modifier = _ref.modifier;
  return /*#__PURE__*/React__default.createElement(Label, {
    htmlFor: id,
    type: type,
    variant: variant,
    weight: weight,
    modifier: modifier
  }, children);
};
Label$1.defaultProps = {
  type: '5',
  variant: 'neutral',
  weight: 'regular',
  modifier: 'regular'
};
Label$1.propTypes = {
  type: PropTypes.oneOf(['1', '2', '3', '4', '5']).isRequired,
  variant: PropTypes.oneOf(['neutral', 'neutral-1', 'danger']).isRequired,
  weight: PropTypes.oneOf(['regular', 'bold']).isRequired,
  modifier: PropTypes.oneOf(['regular', 'strong', 'weak', 'inverted']).isRequired
};

var _excluded = ["id", "isSelectAllCheck", "children", "onChange", "checked", "disabled", "size", "className"];
var Checkbox$1 = function Checkbox$1(_ref) {
  var id = _ref.id,
    isSelectAllCheck = _ref.isSelectAllCheck,
    children = _ref.children,
    onChange = _ref.onChange,
    checked = _ref.checked,
    disabled = _ref.disabled,
    size = _ref.size,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(checked),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setChecked = _useState2[1];
  useEffect(function () {
    setChecked(checked);
  }, [checked]);
  var handleChange = function handleChange(_ref2) {
    var checked = _ref2.target.checked;
    setChecked(checked);
    onChange && onChange(checked);
  };
  var renderText = function renderText() {
    return /*#__PURE__*/React__default.createElement(TextWrapper$1, null, /*#__PURE__*/React__default.createElement(Label$1, {
      type: "2",
      variant: "neutral",
      modifier: disabled ? 'regular' : 'strong',
      id: "checkbox-".concat(id),
      cursor: "pointer"
    }, children));
  };
  var iconsSizes = {
    sm: 12,
    md: 14,
    lg: 16
  };
  return /*#__PURE__*/React__default.createElement(Checkbox, {
    size: size
  }, /*#__PURE__*/React__default.createElement(CheckboxInput, {
    size: size
  }, /*#__PURE__*/React__default.createElement("input", {
    "data-testid": "".concat(props['data-testid'], "--checkbox"),
    id: "checkbox-".concat(id),
    type: "checkbox",
    checked: isChecked,
    disabled: disabled,
    onChange: handleChange
  }), /*#__PURE__*/React__default.createElement(CheckboxChecked, {
    variant: "neutral",
    modifier: disabled ? 'weak' : 'inverted',
    size: size
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: isSelectAllCheck ? 'parcial_outline' : 'done_outline',
    width: iconsSizes[size],
    height: iconsSizes[size]
  }))), children && renderText());
};
Checkbox$1.defaultProps = {
  isSelectAllCheck: false,
  checked: false,
  disabled: false,
  size: 'sm',
  'data-testid': 'checkbox',
  className: ''
};
Checkbox$1.propTypes = {
  id: PropTypes.string,
  isSelectAllCheck: PropTypes.bool,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
  'data-testid': PropTypes.string
};

var _templateObject$d, _templateObject2$9, _templateObject3$8, _templateObject4$7, _templateObject5$7, _templateObject6$6, _templateObject7$5;
var DynamicListWrapper = styled.div(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  *[draggable='true'] {\n    -moz-user-select: none;\n    -khtml-user-drag: element;\n    -webkit-user-drag: element;\n    -khtml-user-select: none;\n    -webkit-user-select: none;\n    cursor: grab;\n  }\n"])));
var DynamicItemWrapper = styled.div(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n  display: block;\n"])));
var DynamicListItem = styled.div(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-evenly;\n  z-index: 1;\n  background-color: ", ";\n  margin: ", " ", ";\n  padding: ", ";\n  border-radius: ", ";\n  border: 1px solid ", ";\n  box-shadow: 0px 2px 4px -2px ", ",\n    0px 2px 4px -2px ", ";\n\n  &:active {\n    ", "\n    box-shadow: 0px 2px 4px -2px ", ",\n      0px 2px 4px -2px ", ";\n  }\n"])), theme.colors.neutral.bg['weak'], theme.spacing['spacing-5'], theme.spacing['spacing-0'], theme.spacing['spacing-3'], theme.borderRadius['border-radius-2'], theme.colors.neutral.border.weak, theme.colors.neutral.border.weak, theme.colors.neutral.border.weak, function (_ref) {
  var isDraggable = _ref.isDraggable;
  return isDraggable && css$1(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), theme.colors.neutral.bg['regular']);
}, theme.colors.neutral.border.weak, theme.colors.neutral.border.weak);
var DynamicListItemValue = styled.div(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: flex-start;\n  z-index: 0;\n"])));
var DynamicListItemDraggable = styled.div(_templateObject6$6 || (_templateObject6$6 = _taggedTemplateLiteral(["\n  z-index: 0;\n  display: flex;\n  justify-content: flex-end;\n"])));
var DynamicListItemPlaceHolder = styled.div(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteral(["\n  cursor: grabbing;\n  height: ", ";\n  margin: ", " ", ";\n  padding: ", ";\n  background-color: ", ";\n  box-shadow: 0px 2px 4px -2px ", ",\n    0px 2px 4px -2px ", ";\n"])), theme.spacing['spacing-8'], theme.spacing['spacing-5'], theme.spacing['spacing-0'], theme.spacing['spacing-3'], theme.colors.neutral.bg['regular'], theme.colors.neutral.border.weak, theme.colors.neutral.border.weak);

var useDynamicListEvent = function useDynamicListEvent() {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    refElement = _useState2[0],
    setRefElement = _useState2[1];
  var changeEffectDraggable = useCallback(function (event, evt) {
    evt !== 'dragstart' && event.preventDefault();
    if (evt == 'dragover' || evt == 'drop') {
      event.preventDefault();
      event.stopPropagation();
    }
    if (typeof event.dataTransfer !== 'undefined') {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.dropEffect = 'move';
    }
  });
  useEffect(function () {
    if (refElement !== null && refElement !== void 0 && refElement.current) {
      var items = refElement.current.querySelectorAll(':scope > div');
      ['dragenter', 'dragend', 'dragstart', 'dragover', 'drop'].forEach(function (evt) {
        items.forEach(function (element) {
          return element.addEventListener(evt, function (event) {
            changeEffectDraggable(event, evt);
          }, false);
        });
      });
    }
  }, [refElement === null || refElement === void 0 ? void 0 : refElement.current]);
  return {
    setRefElement: setRefElement
  };
};

var DynamicList = function DynamicList(_ref) {
  var onChange = _ref.onChange,
    defaultValue = _ref.defaultValue,
    disabled = _ref.disabled,
    label = _ref.label,
    data = _ref.data,
    draggable = _ref.draggable;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var refDynamicList = useRef(null);
  var _useDynamicListEvent = useDynamicListEvent(),
    setRefElement = _useDynamicListEvent.setRefElement;
  useEffect(function () {
    setItems(data);
  }, [data]);
  useEffect(function () {
    onChange && onChange(items);
  }, [items]);
  useEffect(function () {
    refDynamicList.current && setRefElement(refDynamicList);
  }, [refDynamicList.current]);
  var cleanItems = function cleanItems(item) {
    return _objectSpread2(_objectSpread2({}, item), {}, {
      active: false,
      draggable: null,
      draggableOver: null,
      isDraggedBottom: null,
      isDraggedTop: null
    });
  };
  var getActiveItems = useCallback(function (items) {
    var currentItems = items;
    var active = currentItems.find(function (item) {
      return !!item.active;
    });
    currentItems.splice(active.draggableOver, 0, currentItems.splice(active.draggable, 1)[0]);
    return currentItems.map(cleanItems);
  });
  var handleOnDragStart = function handleOnDragStart(event, index) {
    setItems(function (items) {
      return items.map(function (item, indexItem) {
        return _objectSpread2(_objectSpread2({}, item), {}, {
          active: indexItem === index,
          draggable: index
        });
      });
    });
  };
  var handleOnDragEnter = function handleOnDragEnter(event, index) {
    setItems(items.map(function (item, indexItem) {
      return _objectSpread2(_objectSpread2({}, item), {}, {
        draggableOver: index,
        isDraggedBottom: indexItem === index && index > item.draggable,
        isDraggedTop: indexItem === index && index < item.draggable
      });
    }));
  };
  var handleOnDragEnd = function handleOnDragEnd(event) {
    setItems(function (items) {
      return getActiveItems(items);
    });
  };
  var getRenderCard = function getRenderCard(_ref2) {
    var isDraggedTop = _ref2.isDraggedTop,
      value = _ref2.value,
      disabled = _ref2.disabled,
      checked = _ref2.checked,
      label = _ref2.label,
      active = _ref2.active,
      isDraggedBottom = _ref2.isDraggedBottom;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isDraggedTop && /*#__PURE__*/React__default.createElement(DynamicListItemPlaceHolder, null), /*#__PURE__*/React__default.createElement(DynamicListItem, {
      isDraggable: draggable
    }, /*#__PURE__*/React__default.createElement(DynamicListItemValue, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
      id: value,
      disabled: disabled,
      checked: checked
    }, label)), draggable && /*#__PURE__*/React__default.createElement(DynamicListItemDraggable, null, /*#__PURE__*/React__default.createElement(Icon$1, {
      name: "draggable_dots",
      variant: active ? 'primary' : 'neutral'
    }))), isDraggedBottom && /*#__PURE__*/React__default.createElement(DynamicListItemPlaceHolder, null));
  };
  return /*#__PURE__*/React__default.createElement(DynamicListWrapper, {
    ref: refDynamicList
  }, !!items && items.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(DynamicItemWrapper, {
      key: index,
      draggable: draggable,
      onDragStart: function onDragStart(event) {
        return handleOnDragStart(event, index);
      },
      onDragEnter: function onDragEnter(event) {
        return handleOnDragEnter(event, index);
      },
      onDragEnd: function onDragEnd(event) {
        return handleOnDragEnd();
      },
      onMouseDown: function onMouseDown(event) {
        return handleOnDragStart(event, index);
      },
      "data-testid": 'dynamic-item-container'
    }, getRenderCard(item));
  }));
};
DynamicList.defaultProps = {
  draggable: true
};
DynamicList.propTypes = {
  defaultValue: PropTypes.array,
  draggable: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string
};

var hasParentBySelector = function hasParentBySelector(el) {
  return function (selector) {
    var isIDSelector = selector.indexOf('#') === 0;
    if (selector.indexOf('.') === 0 || selector.indexOf('#') === 0) {
      selector = selector.slice(1);
    }
    while (el && el.tagName !== 'BODY') {
      if (isIDSelector) {
        if (el.id === selector) {
          return true;
        }
      } else if (el.classList.contains(selector)) {
        return true;
      }
      el = el.parentElement;
    }
    return false;
  };
};
var useOutsideAlerter = function useOutsideAlerter(ref, outSideClickAction, excludeList) {
  useEffect(function () {
    if (ref) {
      var handleClickOutside = function handleClickOutside(event) {
        var isInExcludeList = false;
        if (excludeList) {
          isInExcludeList = excludeList.some(hasParentBySelector(event.target));
        }
        if (ref.current && !ref.current.contains(event.target) && !isInExcludeList) {
          outSideClickAction && outSideClickAction();
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return function () {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [ref]);
};
var OutsideAlerter = function OutsideAlerter(props) {
  var wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, props.handleOutSideClick, props.exclude);
  if (props.active === false) return props.children;
  return /*#__PURE__*/React__default.createElement("div", {
    ref: wrapperRef
  }, props.children);
};
OutsideAlerter.propTypes = {
  children: PropTypes.element.isRequired
};

var _templateObject$e, _templateObject2$a, _templateObject3$9, _templateObject4$8, _templateObject5$8, _templateObject6$7, _templateObject7$6, _templateObject8$5, _templateObject9$4, _templateObject10$4, _templateObject11$4, _templateObject12$3, _templateObject13$2, _templateObject14$1, _templateObject15$1;
var Input = styled.div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  width: 100%;\n  position: relative;\n\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active {\n    -webkit-transition: 'color 9999s ease-out, background-color 9999s ease-out';\n    -webkit-transition-delay: 9999s;\n  }\n"])));
var LabelWrapper = styled.div(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n  padding: ", " ", "\n    ", " ", ";\n  display: flex;\n"])), theme.spacing['spacing-2'], theme.spacing['spacing-2'], theme.spacing['spacing-2'], theme.spacing['spacing-5']);
var BaseInput = styled.div(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  padding: ", " ", "\n    ", " ", ";\n  display: flex;\n  align-items: center;\n  width: 100%;\n  ", ";\n\n  &:focus,\n  &:focus-visible {\n    outline: none;\n  }\n\n  outline: none;\n\n  &::-moz-focus-inner {\n    border: 0;\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), theme.colors.neutral.bg.weak, theme.borderRadius['border-radius-5'], theme.spacing['spacing-3'], theme.spacing['spacing-3'], theme.spacing['spacing-3'], theme.spacing['spacing-5'], theme.textStyles['text-preset-9'], function (_ref) {
  var size = _ref.size;
  return getSize$2(size);
}, function (_ref2) {
  var hasFocus = _ref2.hasFocus;
  return css$1(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteral(["\n      box-shadow: inset 0 0 0 1px\n        ", ";\n      input {\n        caret-color: ", ";\n      }\n    "])), theme.colors["".concat(hasFocus ? 'secondary-1' : 'neutral')].border.regular, theme.colors['secondary-1'].border.regular);
}, function (_ref3) {
  var status = _ref3.status;
  return status === 'error' && css$1(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteral(["\n      box-shadow: inset 0 0 0 1px ", ";\n      input {\n        caret-color: ", ";\n      }\n    "])), theme.colors['danger'].border.regular, theme.colors['danger'].border.regular);
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled === true && css$1(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteral(["\n      input {\n        color: ", ";\n        background-color: ", ";\n      }\n      box-shadow: inset 0 0 0 1px ", ";\n      background-color: ", ";\n      &:hover,\n      &:focus {\n        box-shadow: inset 0 0 0 1px ", ";\n      }\n    "])), theme.colors['neutral'].text.regular, theme.colors['neutral'].bg.regular, theme.colors['neutral'].border.regular, theme.colors['neutral'].bg.regular, theme.colors['neutral'].border.regular);
}, function (_ref5) {
  var readOnly = _ref5.readOnly;
  return readOnly === true && css$1(_templateObject7$6 || (_templateObject7$6 = _taggedTemplateLiteral(["\n      box-shadow: inset 0 0 0 1px ", ";\n      input {\n        color: ", ";\n      }\n      &:hover,\n      &:focus {\n        box-shadow: inset 0 0 0 1px ", ";\n      }\n    "])), theme.colors['neutral'].border.weak, theme.colors['neutral'].text.regular, theme.colors['neutral'].border.weak);
}, function (_ref6) {
  var onlyNumbers = _ref6.onlyNumbers;
  return onlyNumbers === true && css$1(_templateObject8$5 || (_templateObject8$5 = _taggedTemplateLiteral(["\n      input::-webkit-outer-spin-button,\n      input::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n      }\n\n      input[type='number'] {\n        -moz-appearance: textfield;\n      }\n    "])));
});
var InputTag = styled.input(_templateObject9$4 || (_templateObject9$4 = _taggedTemplateLiteral(["\n  min-height: 24px;\n  width: 100%;\n  border: none;\n  background-color: ", ";\n  color: ", ";\n  &:focus,\n  &:focus-visible {\n    outline: none;\n  }\n\n  outline: none;\n\n  &::-moz-focus-inner {\n    border: 0;\n  }\n\n  * + & {\n    margin-left: ", ";\n  }\n\n  & + * {\n    margin-left: ", ";\n  }\n"])), theme.colors.neutral.bg.weak, theme.colors.neutral.text.strong, theme.spacing['spacing-1'], theme.spacing['spacing-1']);
var HelpText = styled.div(_templateObject10$4 || (_templateObject10$4 = _taggedTemplateLiteral(["\n  padding: ", " ", "\n    ", " ", ";\n  display: flex;\n  align-items: flex-start;\n  position: absolute;\n  ", "\n"])), theme.spacing['spacing-2'], theme.spacing['spacing-2'], theme.spacing['spacing-2'], theme.spacing['spacing-5'], function (_ref7) {
  var status = _ref7.status;
  return status === 'error' && css$1(_templateObject11$4 || (_templateObject11$4 = _taggedTemplateLiteral(["\n      > * {\n        &:first-child {\n          margin-right: ", ";\n        }\n      }\n    "])), theme.spacing['spacing-2']);
});
var SiblingInputTag = styled.div(_templateObject12$3 || (_templateObject12$3 = _taggedTemplateLiteral(["\n  height: 24px;\n  display: flex;\n  align-items: center;\n"])));
var getSize$2 = function getSize(size) {
  switch (size) {
    case 'sm':
      return css$1(_templateObject13$2 || (_templateObject13$2 = _taggedTemplateLiteral(["\n        width: 215px;\n      "])));
    case 'md':
      return css$1(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteral(["\n        width: 325px;\n      "])));
    case 'lg':
      return css$1(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteral(["\n        width: 560px;\n      "])));
  }
};

var spanVariantByStatus = {
  normal: 'neutral',
  error: 'danger'
};
var validateOnlyNumbers = function validateOnlyNumbers(onlyNumbers, e, innerValue, setInnerValue) {
  if (onlyNumbers) {
    var numberValue = e.target.validity.valid ? e.target.value : innerValue;
    setInnerValue(numberValue);
    e.target.value = numberValue;
  }
};
var Input$1 = function Input$1(_ref) {
  var id = _ref.id,
    name = _ref.name,
    value = _ref.value,
    label = _ref.label,
    type = _ref.type,
    size = _ref.size,
    maxLength = _ref.maxLength,
    inputStatus = _ref.inputStatus,
    readOnly = _ref.readOnly,
    placeHolder = _ref.placeHolder,
    message = _ref.message,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    onKeyDown = _ref.onKeyDown,
    disabled = _ref.disabled,
    _ref$showPasswordButt = _ref.showPasswordButton,
    showPasswordButton = _ref$showPasswordButt === void 0 ? false : _ref$showPasswordButt,
    onClick = _ref.onClick,
    inputRef = _ref.inputRef,
    _ref$maxLengthHelpTex = _ref.maxLengthHelpText,
    maxLengthHelpText = _ref$maxLengthHelpTex === void 0 ? false : _ref$maxLengthHelpTex,
    _ref$onlyNumbers = _ref.onlyNumbers,
    onlyNumbers = _ref$onlyNumbers === void 0 ? false : _ref$onlyNumbers,
    pattern = _ref.pattern,
    autocomplete = _ref.autocomplete,
    icons = _ref.icons;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPassword = _useState2[0],
    setShowPassword = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    characterCount = _useState4[0],
    setCharacterCount = _useState4[1];
  var _useState5 = useState(onlyNumbers ? 'text' : type),
    _useState6 = _slicedToArray(_useState5, 2),
    inputType = _useState6[0],
    setInputType = _useState6[1];
  var _useState7 = useState(value),
    _useState8 = _slicedToArray(_useState7, 2),
    innerValue = _useState8[0],
    setInnerValue = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    hasFocus = _useState10[0],
    setFocus = _useState10[1];
  var handleShowPasswordClick = function handleShowPasswordClick() {
    setInputType(!showPassword ? 'text' : 'password');
    setShowPassword(!showPassword);
  };
  var proxyOnChange = function proxyOnChange(e) {
    validateOnlyNumbers(onlyNumbers, e, innerValue, setInnerValue);
    setCharacterCount(e.target.value.length);
    onChange && onChange(e);
  };
  var proxyOnBlur = function proxyOnBlur(e) {
    validateOnlyNumbers(onlyNumbers, e, innerValue, setInnerValue);
    setFocus(false);
    onBlur && onBlur(e);
  };
  var proxyOnFocus = function proxyOnFocus(e) {
    validateOnlyNumbers(onlyNumbers, e, innerValue, setInnerValue);
    setFocus(true);
    onFocus && onFocus(e);
  };
  var renderShowPasswordButton = function renderShowPasswordButton() {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, type === 'password' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showPassword ? /*#__PURE__*/React__default.createElement(Icon$1, {
      onClick: handleShowPasswordClick,
      name: "view_outline",
      variant: "neutral",
      cursor: disabled ? 'not-allowed' : 'pointer',
      modifier: disabled ? 'regular' : 'strong'
    }) : /*#__PURE__*/React__default.createElement(Icon$1, {
      onClick: handleShowPasswordClick,
      name: "hide_outline",
      variant: "neutral",
      cursor: disabled ? 'not-allowed' : 'pointer',
      modifier: disabled ? 'regular' : 'strong'
    })));
  };
  var renderMaxLengthHelpText = function renderMaxLengthHelpText() {
    return /*#__PURE__*/React__default.createElement(SiblingInputTag, null, /*#__PURE__*/React__default.createElement(Span$1, {
      type: "2",
      variant: "disabled",
      align: "right"
    }, "".concat(characterCount, "/").concat(maxLength)));
  };
  var renderIcon = function renderIcon(icon, align) {
    var _icon$name = icon.name,
      name = _icon$name === void 0 ? icon : _icon$name,
      callback = icon.callback,
      cursor = icon.cursor;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, disabled ? /*#__PURE__*/React__default.createElement(Icon$1, {
      name: name,
      variant: "neutral",
      cursor: 'not-allowed'
    }) : /*#__PURE__*/React__default.createElement(Icon$1, {
      name: name,
      variant: "neutral",
      cursor: callback ? 'pointer' : 'default',
      modifier: align == 'left' ? 'weak' : 'strong',
      onClick: function onClick() {
        return callback && callback();
      }
    }));
  };
  return /*#__PURE__*/React__default.createElement(Input, null, label && /*#__PURE__*/React__default.createElement(LabelWrapper, null, /*#__PURE__*/React__default.createElement(Label$1, {
    id: id,
    type: "4"
  }, label)), /*#__PURE__*/React__default.createElement(BaseInput, {
    hasFocus: hasFocus,
    size: size,
    status: inputStatus,
    disabled: disabled,
    readOnly: readOnly,
    onlyNumbers: onlyNumbers
  }, (icons === null || icons === void 0 ? void 0 : icons.iconLeft) && renderIcon(icons.iconLeft, 'left'), /*#__PURE__*/React__default.createElement(InputTag, {
    id: id,
    name: name,
    type: inputType,
    placeholder: placeHolder,
    onClick: onClick,
    onChange: proxyOnChange,
    onBlur: proxyOnBlur,
    onFocus: proxyOnFocus,
    onKeyDown: onKeyDown,
    pattern: onlyNumbers ? '^[0-9]+$' : pattern,
    value: onlyNumbers ? innerValue : value,
    disabled: disabled,
    readOnly: readOnly,
    maxLength: maxLength,
    ref: inputRef,
    autoComplete: autocomplete
  }), (icons === null || icons === void 0 ? void 0 : icons.iconRight) && renderIcon(icons.iconRight, 'right'), showPasswordButton && renderShowPasswordButton(), maxLengthHelpText && renderMaxLengthHelpText()), message && /*#__PURE__*/React__default.createElement(HelpText, {
    status: inputStatus
  }, inputStatus === 'error' && /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "error_circle_outline",
    variant: "danger",
    width: "16",
    height: "16"
  }), /*#__PURE__*/React__default.createElement(Span$1, {
    id: id,
    type: "4",
    variant: spanVariantByStatus[inputStatus]
  }, message)));
};
Input$1.defaultProps = {
  type: 'text',
  inputStatus: 'normal',
  readOnly: false,
  disabled: false,
  autocomplete: 'on'
};
Input$1.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(['text', 'number', 'password', 'checkbox', 'email']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  inputStatus: PropTypes.oneOf(['normal', 'error']),
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onKeydown: PropTypes.func,
  placeHolder: PropTypes.string,
  message: PropTypes.string,
  disabled: PropTypes.bool,
  maxLength: PropTypes.string,
  autocomplete: PropTypes.string,
  icons: PropTypes.shape({
    iconLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
      name: PropTypes.string,
      callback: PropTypes.func
    })]),
    iconRight: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
      name: PropTypes.string,
      callback: PropTypes.func
    })])
  })
};

var _templateObject$f, _templateObject2$b, _templateObject3$a, _templateObject4$9, _templateObject5$9, _templateObject6$8, _templateObject7$7, _templateObject8$6, _templateObject9$5, _templateObject10$5;
var MultiSelectContainer = styled.div(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var MultiSelectMenuContainer = styled.div(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  height: 40px;\n  ", "\n  ", ";\n  color: ", ";\n"])), function (props) {
  return props.disabled ? 'cursor: default;' : 'cursor: pointer;';
}, theme.textStyles['text-preset-9'], theme.colors.neutral.text.strong);
var MultiSelectMenuImageContainer = styled.div(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: inherit;\n  margin-left: ", ";\n  margin-right: ", ";\n  img {\n    max-height: 20px;\n    width: 24px;\n    &:disabled {\n      opacity: 0.5;\n    }\n  }\n  ", "\n"])), theme.spacing['spacing-4'], theme.spacing['spacing-4'], function (_ref) {
  var disabled = _ref.disabled;
  return disabled && " img {\n        filter: grayscale(1);\n        opacity: 0.5;\n      }\n    ";
});
var MultiSelectCheckboxContainer = styled.div(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteral([""])));
var MultiSelectLabelContainer = styled.div(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 0;\n  cursor: inherit;\n  label {\n    cursor: inherit;\n  }\n  div:nth-child(1) + & {\n    margin-left: ", ";\n  }\n"])), theme.spacing['spacing-4']);
var MultiSelectButtonGroup = styled.div(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  justify-content: right;\n  padding-top: ", ";\n  button {\n    margin-left: ", ";\n  }\n"])), theme.spacing['spacing-7'], theme.spacing['spacing-4']);
var MultiSelectEmptyButton = styled.div(_templateObject7$7 || (_templateObject7$7 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  padding: ", " ", "\n    ", " ", ";\n"])), theme.spacing['spacing-1'], theme.spacing['spacing-1'], theme.spacing['spacing-1'], theme.spacing['spacing-5']);
var MultiValueContainer = styled.div(_templateObject8$6 || (_templateObject8$6 = _taggedTemplateLiteral(["\n  input {\n    caret-color: transparent;\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n    &:focus {\n      cursor: pointer;\n    }\n  }\n"])));
var MultiSelectMenu = styled.div(_templateObject9$5 || (_templateObject9$5 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  top: ", ";\n  margin-top: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  z-index: 1;\n  background-color: ", ";\n"])), theme.spacing['spacing-11'], theme.spacing['spacing-2'], theme.spacing['spacing-5'], theme.borderRadius['border-radius-3'], theme.elevations['elevation-1'], theme.colors.neutral.bg.weak);
var MultiSelectOptions = styled.div(_templateObject10$5 || (_templateObject10$5 = _taggedTemplateLiteral(["\n  max-height: 244px;\n  overflow-y: scroll;\n  scrollbar-width: thin;\n  scrollbar-color: ", " white;\n  &::-webkit-scrollbar {\n    width: 8px;\n    height: 10px;\n  }\n  &::-webkit-scrollbar-track {\n    background: white;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n    border-radius: ", ";\n    margin: ", " ", "\n      ", ";\n  }\n"])), theme.colors.neutral.border.regular, theme.colors.neutral.border.regular, theme.borderRadius['border-radius-2'], theme.spacing['spacing-5'], theme.spacing['spacing-0'], theme.spacing['spacing-0']);

var MultiSelectOption = function MultiSelectOption(_ref) {
  var _onClick = _ref.onClick,
    options = _ref.options;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, options.map(function (option) {
    return /*#__PURE__*/React__default.createElement(MultiSelectMenuContainer, {
      key: option.value,
      disabled: option.isDisabled,
      onClick: function onClick() {
        return !option.isDisabled && _onClick(option);
      }
    }, /*#__PURE__*/React__default.createElement(MultiSelectCheckboxContainer, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
      checked: option.isSelected,
      disabled: option.isDisabled ? true : false,
      onChange: function onChange(e) {
        return e.preventDefault;
      },
      id: option.value
    })), (option === null || option === void 0 ? void 0 : option.icon) && /*#__PURE__*/React__default.createElement(MultiSelectMenuImageContainer, {
      disabled: option.isDisabled
    }, /*#__PURE__*/React__default.createElement("img", {
      src: option === null || option === void 0 ? void 0 : option.icon,
      alt: option.label
    })), /*#__PURE__*/React__default.createElement(MultiSelectLabelContainer, null, /*#__PURE__*/React__default.createElement(Label$1, {
      type: "4",
      align: "left",
      variant: "neutral",
      modifier: option.isDisabled ? 'weak' : 'strong',
      weight: "regular"
    }, option.label)));
  }));
};

var MultiSelectMenu$1 = function MultiSelectMenu$1(_ref) {
  var handleApply = _ref.handleApply,
    handleCancel = _ref.handleCancel,
    handleOnChange = _ref.handleOnChange,
    isApplyButtonDisabled = _ref.isApplyButtonDisabled,
    value = _ref.value,
    options = _ref.options;
  var newOptions = options.map(function (option) {
    var valuesSelected = value.find(function (_ref2) {
      var value = _ref2.value;
      return value === option.value;
    });
    return _objectSpread2(_objectSpread2({}, option), {}, {
      isSelected: !!valuesSelected
    });
  });
  var handleOnClick = function handleOnClick(selectedOption) {
    var localOptions = newOptions.map(function (option) {
      return option.value === selectedOption.value ? _objectSpread2(_objectSpread2({}, option), {}, {
        isSelected: !option.isSelected
      }) : option;
    });
    var localOptionsSelected = localOptions.filter(function (option) {
      return option.isSelected;
    });
    handleOnChange(localOptionsSelected);
  };
  return /*#__PURE__*/React__default.createElement(MultiSelectMenu, null, /*#__PURE__*/React__default.createElement(MultiSelectOptions, null, /*#__PURE__*/React__default.createElement(MultiSelectOption, {
    onClick: handleOnClick,
    options: newOptions
  })), /*#__PURE__*/React__default.createElement(MultiSelectButtonGroup, null, /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "secondary",
    size: "sm",
    onClick: handleCancel
  }, "Cancelar"), /*#__PURE__*/React__default.createElement(Button$1, {
    size: "sm",
    variant: "primary",
    onClick: handleApply,
    disabled: isApplyButtonDisabled
  }, "Aplicar")));
};

var _excluded$1 = ["defaultValue", "disabled", "onChange", "label", "placeHolder", "showResetButton", "status", "message"];
var OPTION_ALL = {
  label: 'Todas',
  value: 'TODAS'
};
var MultiSelect = function MultiSelect(_ref) {
  var defaultValue = _ref.defaultValue,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    label = _ref.label,
    placeHolder = _ref.placeHolder,
    showResetButton = _ref.showResetButton,
    status = _ref.status,
    message = _ref.message,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var initialValue = defaultValue || [];
  var _useState = useState(props.options),
    _useState2 = _slicedToArray(_useState, 2),
    options = _useState2[0],
    setOptions = _useState2[1];
  var _useState3 = useState(initialValue),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    open = _useState6[0],
    setOpen = _useState6[1];
  var lastValueRef = useRef(initialValue);
  var inputEl = useRef(null);
  var optionAll = options === null || options === void 0 ? void 0 : options.find(function (option) {
    return option.value === OPTION_ALL.value;
  });
  var optionAllIsSelected = (value === null || value === void 0 ? void 0 : value.length) && (value === null || value === void 0 ? void 0 : value.find(function (_ref2) {
    var value = _ref2.value;
    return value === (optionAll === null || optionAll === void 0 ? void 0 : optionAll.value);
  }));
  var isApplyButtonDisabled = !value.length;
  useEffect(function () {
    if (JSON.stringify(options) !== JSON.stringify(props.options)) {
      validateAllOption(props.options);
    }
  }, [props.options]);
  useEffect(function () {
    if (JSON.stringify(value) !== JSON.stringify(props.value)) {
      setValue(props.value || initialValue);
      setLastValue(props.value || initialValue);
    }
  }, [props.value]);
  useEffect(function () {
    validateAllOption(options);
  }, [value]);
  var validateAllOption = function validateAllOption(localOptions) {
    setOptions(optionAll ? enableOptionAll(localOptions) : localOptions);
    optionAllIsSelected && value.length > 1 && setValue(value.filter(function (element) {
      return element.value !== optionAll.value;
    }));
  };
  var enableOptionAll = function enableOptionAll(localOptions) {
    return localOptions.map(function (option) {
      return option.value === optionAll.value ? _objectSpread2(_objectSpread2({}, option), {}, {
        isDisabled: value.length && !optionAllIsSelected
      }) : option;
    }).filter(removeDuplicateOptions);
  };
  var removeDuplicateOptions = function removeDuplicateOptions(option, index, array) {
    return array.findIndex(function (item) {
      return item.value === option.value;
    }) === index;
  };
  var setLastValue = function setLastValue(lastValue) {
    lastValueRef.current = lastValue;
  };
  var handleApply = function handleApply() {
    handleClose();
    onChange && onChange(value);
    setLastValue(value);
  };
  var handleCancel = function handleCancel() {
    setValue(lastValueRef.current);
    handleClose();
  };
  var handleOnChange = function handleOnChange(optionsSelected) {
    return setValue(optionsSelected);
  };
  var handleReset = function handleReset() {
    onChange && onChange(null);
    setValue(initialValue);
    setLastValue(initialValue);
    handleClose();
  };
  var handleClose = function handleClose() {
    return setOpen(false);
  };
  var multiValueText = function multiValueText(values) {
    if (values.length) {
      return values.map(function (_ref3) {
        var label = _ref3.label;
        return label;
      }).join(', ');
    } else return '';
  };
  var handleOpenMenu = function handleOpenMenu() {
    open ? handleCancel() : setOpen(!disabled);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OutsideAlerter, {
    handleOutSideClick: handleCancel
  }, /*#__PURE__*/React__default.createElement(MultiSelectContainer, {
    "data-testid": "multi-select-component",
    className: "multi-select-component"
  }, /*#__PURE__*/React__default.createElement(MultiValueContainer, {
    disabled: disabled
  }, /*#__PURE__*/React__default.createElement(Input$1, {
    label: label,
    value: multiValueText(value),
    icons: {
      iconRight: {
        name: !open ? 'chevron_down_outline' : 'chevron_up_outline',
        callback: handleOpenMenu
      }
    },
    message: !showResetButton ? message : '',
    placeHolder: placeHolder,
    disabled: disabled,
    inputStatus: status,
    onClick: handleOpenMenu
  }), showResetButton && /*#__PURE__*/React__default.createElement(MultiSelectEmptyButton, null, /*#__PURE__*/React__default.createElement(Link$1, {
    variant: "primary",
    size: "xs",
    onClick: handleReset
  }, "Limpiar"))), open && /*#__PURE__*/React__default.createElement(MultiSelectMenu$1, {
    handleApply: handleApply,
    handleCancel: handleCancel,
    handleOnChange: handleOnChange,
    isApplyButtonDisabled: isApplyButtonDisabled,
    options: options,
    value: value
  }))));
};
MultiSelect.defaultProps = {
  options: [],
  placeHolder: '',
  noOptionsMessage: '',
  defaultValue: [],
  showResetButton: false,
  disabled: false,
  status: 'normal'
};
MultiSelect.propTypes = {
  defaultValue: PropTypes.array,
  noOptionsMessage: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
  placeHolder: PropTypes.string,
  showResetButton: PropTypes.bool,
  value: PropTypes.array,
  disabled: PropTypes.bool,
  message: PropTypes.string,
  label: PropTypes.string,
  status: PropTypes.oneOf(['normal', 'error'])
};
MultiSelect.OPTION_ALL = OPTION_ALL;

var _templateObject$g;
var getSpacingCard = function getSpacingCard(spacing) {
  return _typeof(spacing) === 'object' ? Object.keys(spacing).map(function (space) {
    return "padding-".concat(space, ": ").concat(theme.spacing["spacing-".concat(spacing[space])], ";");
  }).join(' ') : "padding: ".concat(theme.spacing["spacing-".concat(spacing)], ";");
};
var getBorderRadiusCard = function getBorderRadiusCard(borderRadius) {
  return _typeof(borderRadius) === 'object' ? "\n    border-radius: \n    ".concat(borderRadius.topLeft ? theme.borderRadius["border-radius-4"] : '0', "\n    ").concat(borderRadius.topRight ? theme.borderRadius["border-radius-4"] : '0', "\n    ").concat(borderRadius.bottomLeft ? theme.borderRadius["border-radius-4"] : '0', "\n    ").concat(borderRadius.bottomRight ? theme.borderRadius["border-radius-4"] : '0', ";\n  ") : borderRadius && "border-radius: ".concat(theme.borderRadius["border-radius-4"], ";");
};
var Card = styled.div(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n   ", "\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant,
    modifier = _ref.modifier;
  return "background: ".concat(theme.colors[variant].bg[modifier], ";");
}, function (_ref2) {
  var spacing = _ref2.spacing;
  return spacing && getSpacingCard(spacing);
}, function (_ref3) {
  var borderRadius = _ref3.borderRadius;
  return borderRadius && getBorderRadiusCard(borderRadius);
}, function (_ref4) {
  var hasHover = _ref4.hasHover;
  return hasHover && getElevationCard(hasHover);
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled && "\n    background: ".concat(theme.colors.neutral.bg.regular, ";");
}, function (_ref6) {
  var border = _ref6.border;
  return border && "\n    box-shadow:  inset 0 0 0 1px ".concat(theme.colors.neutral.border.weak, ";\n  ");
}, function (_ref7) {
  var pressed = _ref7.pressed;
  return pressed && "\n    background: ".concat(theme.colors['secondary-1'].bg.weak, ";\n  ");
}, function (_ref8) {
  var border = _ref8.border,
    pressed = _ref8.pressed;
  return border && pressed && "\n    box-shadow:  inset 0 0 0 1px ".concat(theme.colors['secondary-1'].border.weak, ";");
}, function (_ref9) {
  var hasCursorPointer = _ref9.hasCursorPointer;
  return hasCursorPointer && "\n    cursor: pointer;\n  ";
});
var getElevationCard = function getElevationCard(hasHover) {
  return hasHover && "\n  &:hover {\n    box-shadow: ".concat(theme.elevations["elevation-2"], ";\n    cursor: pointer;\n  }\n");
};

var Card$1 = function Card$1(_ref) {
  var borderRadius = _ref.borderRadius,
    spacing = _ref.spacing,
    hasHover = _ref.hasHover,
    border = _ref.border,
    children = _ref.children,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    pressed = _ref.pressed,
    variant = _ref.variant,
    modifier = _ref.modifier;
  return /*#__PURE__*/React__default.createElement(Card, {
    borderRadius: borderRadius,
    spacing: spacing,
    hasHover: hasHover,
    border: border,
    disabled: disabled,
    onClick: onClick,
    pressed: pressed,
    hasCursorPointer: onClick && true,
    variant: variant,
    modifier: modifier
  }, children);
};
var propTypesSpacing = PropTypes.oneOf(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11']);
Card$1.defaultProps = {
  spacing: '0',
  hasHover: false,
  disabled: false,
  pressed: false,
  borderRadius: true,
  variant: 'neutral',
  modifier: 'weak'
};
Card$1.propTypes = {
  spacing: PropTypes.oneOfType([propTypesSpacing, PropTypes.shape({
    top: propTypesSpacing,
    left: propTypesSpacing,
    right: propTypesSpacing,
    bottom: propTypesSpacing
  })]),
  hasHover: PropTypes.bool,
  border: PropTypes.bool,
  disabled: PropTypes.bool,
  pressed: PropTypes.bool,
  borderRadius: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    topLeft: PropTypes.bool,
    topRight: PropTypes.bool,
    bottomLeft: PropTypes.bool,
    bottomRight: PropTypes.bool
  })]),
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['neutral']).isRequired,
  modifier: PropTypes.oneOf(['regular', 'weak']).isRequired
};

var css_248z$8 = ":root {\n  --primary-text: #023F80;\n  --primary-text-strong: #002A55;\n  --primary-text-weak: #0A7FE4;\n  --primary-bg: #023F80;\n  --primary-bg-strong: #002A55;\n  --primary-bg-weak: #D8EBFF;\n  --primary-border: #023F80;\n  --primary-border-strong: #002A55;\n  --primary-border-weak: #479EF8;\n  --primary-ic: #023F80;\n  --primary-ic-strong: #002A55;\n  --primary-ic-weak: #0A7FE4;\n  --secondary-1-text: #1AAAAD;\n  --secondary-1-text-strong: #076568;\n  --secondary-1-text-weak: #71D7D9;\n  --secondary-1-bg: #1AAAAD;\n  --secondary-1-bg-strong: #137F82;\n  --secondary-1-bg-weak: #E0FBFD;\n  --secondary-1-border: #1AAAAD;\n  --secondary-1-border-strong: #137F82;\n  --secondary-1-border-weak: #71D7D9;\n  --secondary-1-ic: #1AAAAD;\n  --secondary-1-ic-strong: #137F82;\n  --secondary-1-ic-weak: #71D7D9;\n  --secondary-2-text: #DD2457;\n  --secondary-2-text-strong: #921034;\n  --secondary-2-text-weak: #FF95B3;\n  --secondary-2-bg: #DD2457;\n  --secondary-2-bg-strong: #B11E47;\n  --secondary-2-bg-weak: #FF95B3;\n  --secondary-2-border: #DD2457;\n  --secondary-2-border-strong: #B11E47;\n  --secondary-2-border-weak: #FF95B3;\n  --secondary-2-ic: #DD2457;\n  --secondary-2-ic-strong: #B11E47;\n  --secondary-2-ic-weak: #FF95B3;\n  --secondary-3-bg: #FECF2F;\n  --secondary-3-bg-strong: #FFA53F;\n  --secondary-3-bg-weak: #FFF0BD;\n  --secondary-3-border: #FECF2F;\n  --secondary-3-border-strong: #FFA53F;\n  --secondary-3-border-weak: #FFF0BD;\n  --secondary-3-ic: #FECF2F;\n  --secondary-3-ic-strong: #FFA53F;\n  --secondary-3-ic-weak: #FFF0BD;\n  --neutral-text: #647180;\n  --neutral-text-strong: #373E45;\n  --neutral-text-weak: #B6C5D5;\n  --neutral-text-inverted: #FFFFFF;\n  --neutral-bg: #F0F5FB;\n  --neutral-bg-strong: #EAF1F8;\n  --neutral-bg-stronger: #B6C5D5;\n  --neutral-bg-weak: #FFFFFF;\n  --neutral-bg-inverted:#373E45;\n  --neutral-border: #B6C5D5;\n  --neutral-border-strong: #647180;\n  --neutral-border-weak: #DEE8F3;\n  --neutral-ic: #647180;\n  --neutral-ic-strong: #373E45;\n  --neutral-ic-weak: #B6C5D5;\n  --neutral-ic-inverted: #FFFFFF;\n  --danger-text: #DD2457;\n  --danger-text-strong: #921034;\n  --danger-text-weak: #FF95B3;\n  --danger-bg:#DD2457;\n  --danger-bg-strong:#B11E47;\n  --danger-bg-weak: #FFF0F4;\n  --danger-border: #DD2457;\n  --danger-border-strong: #B11E47;\n  --danger-ic: #DD2457;\n  --warning-text: #623311;\n  --warning-bg: #FECF2F;\n  --warning-bg-strong: #FFA53F;\n  --warning-bg-weak: #FFF4CD;\n  --warning-border: #FECF2F;\n  --warning-border-strong: #FFA53F;\n  --warning-ic: #FFA53F;\n  --info-text:#023F80;\n  --info-bg: #479EF8;\n  --info-bg-strong: #023F80;\n  --info-bg-weak: #D8EBFF;\n  --info-border: #479EF8;\n  --info-border-strong: #023F80;\n  --info-ic: #479EF8;\n  --success-text: #035456;\n  --success-bg: #1AAAAD;\n  --success-bg-strong: #137F82;\n  --success-bg-weak: #E0FBFD;\n  --success-border: #1AAAAD;\n  --success-border-strong: #137F82;\n  --success-border-weak: #71D7D9;\n  --success-ic: #1AAAAD; }\n\n.rsg--content-3 {\n  max-width: none;\n  padding: 0;\n  margin: auto;\n  background-color: #f5f5f5; }\n\ndiv[class*='rsg--preview-'] {\n  padding: 0;\n  border: none; }\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box; }\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nlabel {\n  font-weight: normal;\n  margin: 0; }\n\ncode[class*='rsg--code-'] {\n  color: darkgreen;\n  font-size: 14px; }\n\n.card-with-colored-header {\n  padding: 0; }\n  .card-with-colored-header .header-card {\n    padding: 25px 25px 15px 25px;\n    border-top-right-radius: inherit;\n    border-top-left-radius: inherit; }\n    .card-with-colored-header .header-card.header-card--orange {\n      background-image: linear-gradient(to bottom, #fdbc73 1%, #ffa53f); }\n    .card-with-colored-header .header-card.header-card--blue {\n      background-image: linear-gradient(to bottom, #5a96fc, #3773dc); }\n    .card-with-colored-header .header-card.header-card--green {\n      background-image: linear-gradient(to bottom, #05e9ea, #26cbcc); }\n";
styleInject(css_248z$8);

//Componente a Deprecar mover a Card
var CardWithColoredHeader = function CardWithColoredHeader(_ref) {
  var body = _ref.body;
  return /*#__PURE__*/React__default.createElement(Card$1, null, body);
};
CardWithColoredHeader.propTypes = {
  body: PropTypes.string
};

var _excluded$2 = ["children"];
var Pill = function Pill(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return /*#__PURE__*/React__default.createElement(Badge$1, props, children);
};

var _templateObject$h, _templateObject2$c;
var Flex = styled.div(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n  display: flex;\n  ", "\n"])), function (prop) {
  return prop.column && css$1(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n      flex-direction: column;\n    "])));
});

var _templateObject$i, _templateObject2$d;
var Bullet = styled.div(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  margin-left: auto;\n\n  ", "\n"])), function (prop) {
  return css$1(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n    background: ", ";\n  "])), prop.color);
});

var _templateObject$j, _templateObject2$e, _templateObject3$b, _templateObject4$a, _templateObject5$a, _templateObject6$9;
var statusColors = {
  PAID: theme.oldColors.teal,
  TO_BE_PAID: theme.oldColors.blue,
  ESTIMATED: theme.oldColors.orange,
  HOLIDAY: theme.oldColors.red
};
var CalendarItem = function CalendarItem(_ref) {
  var state = _ref.state,
    day = _ref.day,
    text = _ref.text,
    status = _ref.status;
  var bulletColor = statusColors[status] ? statusColors[status]['100'] : '';
  return /*#__PURE__*/React__default.createElement(Container, {
    column: true,
    state: state,
    status: status,
    "data-testid": "calendar-item-data-test-id"
  }, /*#__PURE__*/React__default.createElement(Flex, null, /*#__PURE__*/React__default.createElement(DayText, null, day), /*#__PURE__*/React__default.createElement(Bullet, {
    color: bulletColor
  })), /*#__PURE__*/React__default.createElement(Content, {
    state: state
  }, text));
};
CalendarItem.propTypes = {
  day: PropTypes.string,
  text: PropTypes.string,
  state: PropTypes.oneOf(['PAST', 'PREVIOUS', 'NEXT', 'FUTURE']),
  status: PropTypes.oneOf(['PAID', 'TO_BE_PAID', 'ESTIMATED', 'HOLIDAY'])
};
var Container = styled(Flex)(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n  height: 100px;\n  flex: 1;\n  padding: 10px 10px 25px 15px;\n  border: 1px solid;\n  border-color: #e5e5e5;\n  min-width: 230px;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (prop) {
  return prop.state === 'past' && css$1(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), theme.oldColors.grey[300]);
}, function (prop) {
  return (prop.state === 'previous' || prop.state === 'next') && prop.status !== 'HOLIDAY' && css$1(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral(["\n      background-image: ", ";\n    "])), statusColors[prop.status]['200']);
}, function (prop) {
  return prop.state === 'future' && css$1(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), theme.oldColors.white[500]);
});
var DayText = styled.span(_templateObject5$a || (_templateObject5$a = _taggedTemplateLiteral(["\n  font-size: 16px;\n  color: ", ";\n"])), theme.oldColors.grey[500]);
var Content = styled.span(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  margin-top: auto;\n  color: ", ";\n"])), theme.oldColors.black[500]);

var CalendarRow = function CalendarRow(props) {
  var items = props.row.map(function (item, idx) {
    return /*#__PURE__*/React__default.createElement(CalendarItem, _extends({
      key: idx
    }, item));
  });
  return /*#__PURE__*/React__default.createElement(Flex, {
    "data-testid": "calendar-row-data-test-id"
  }, items);
};
CalendarRow.propTypes = {
  row: PropTypes.array
};

var _templateObject$k, _templateObject2$f, _templateObject3$c;
var weekDays = ['LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES'];
var DaysHeader = function DaysHeader() {
  var days = weekDays.map(function (day) {
    return /*#__PURE__*/React__default.createElement(DaysContainer, {
      key: day
    }, /*#__PURE__*/React__default.createElement(DayText$1, null, day));
  });
  return /*#__PURE__*/React__default.createElement(Header, {
    key: 'pepe'
  }, days);
};
var Header = styled(Flex)(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n  height: 50px;\n  background-color: ", ";\n  align-items: center;\n"])), theme.oldColors.grey[400]);
var DaysContainer = styled.div(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral(["\n  flex: 1;\n  height: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var DayText$1 = styled.div(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteral(["\n  font-size: 12px;\n"])));

var _templateObject$l, _templateObject2$g, _templateObject3$d;
var PillsInfo = function PillsInfo() {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Pill$1, null, /*#__PURE__*/React__default.createElement(InfoBullet, {
    color: theme.oldColors.teal[100]
  }), /*#__PURE__*/React__default.createElement(PillText, {
    color: theme.oldColors.grey[600]
  }, "Acreditados")), /*#__PURE__*/React__default.createElement(Pill$1, null, /*#__PURE__*/React__default.createElement(InfoBullet, {
    color: theme.oldColors.blue[100]
  }), /*#__PURE__*/React__default.createElement(PillText, {
    color: theme.oldColors.grey[600]
  }, "Por Acreditar")), /*#__PURE__*/React__default.createElement(Pill$1, null, /*#__PURE__*/React__default.createElement(InfoBullet, {
    color: theme.oldColors.orange[100]
  }), /*#__PURE__*/React__default.createElement(PillText, {
    color: theme.oldColors.grey[600]
  }, "Estimados")), /*#__PURE__*/React__default.createElement(Pill$1, null, /*#__PURE__*/React__default.createElement(InfoBullet, {
    color: theme.oldColors.red[200]
  }), /*#__PURE__*/React__default.createElement(PillText, {
    color: theme.oldColors.grey[600]
  }, "Feriado")));
};
var Pill$1 = styled(Flex)(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n  border-radius: 20px;\n  border: solid 1px #e8e8e8;\n  align-items: center;\n  padding: 5px 20px 5px 1px;\n  margin-left: 20px;\n"])));
var PillText = styled.span(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: ", ";\n"])), theme.oldColors.grey[600]);
var InfoBullet = styled(Bullet)(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteral(["\n  margin: 10px;\n"])));

var _templateObject$m, _templateObject2$h, _templateObject3$e, _templateObject4$b, _templateObject5$b;
var CalendarHeader = function CalendarHeader(_ref) {
  var header = _ref.header;
  return /*#__PURE__*/React__default.createElement(Container$1, null, /*#__PURE__*/React__default.createElement(Information, null, /*#__PURE__*/React__default.createElement(Flex, null, /*#__PURE__*/React__default.createElement(Month, null, header.month), /*#__PURE__*/React__default.createElement(Year, null, header.year)), /*#__PURE__*/React__default.createElement(PillContainer, null, /*#__PURE__*/React__default.createElement(PillsInfo, null))), /*#__PURE__*/React__default.createElement(DaysHeader, null));
};
var Container$1 = styled.div(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n  height: 100px;\n"])));
var Information = styled(Flex)(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteral(["\n  height: 50px;\n  padding: 10px 20px 15px 20px;\n  background-color: ", ";\n"])), theme.oldColors.white[500]);
var Month = styled.span(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteral(["\n  font-size: 20px;\n  color: ", ";\n  margin-left: 10px;\n"])), theme.oldColors.grey[500]);
var Year = styled(Month)(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteral(["\n  font-weight: bold;\n"])));
var PillContainer = styled(Flex)(_templateObject5$b || (_templateObject5$b = _taggedTemplateLiteral(["\n  margin-left: auto;\n"])));

var _templateObject$n;
var Calendar = function Calendar(props) {
  var weeks = props.weeks.map(function (row, idx) {
    return /*#__PURE__*/React__default.createElement(CalendarRow, {
      key: 'week' + idx,
      row: row
    });
  });
  return /*#__PURE__*/React__default.createElement(Container$2, {
    "data-testid": "calendar-data-test-id"
  }, /*#__PURE__*/React__default.createElement(CalendarHeader, {
    header: props.header
  }), weeks);
};
Calendar.propTypes = {
  header: PropTypes.shape({
    year: PropTypes.string,
    month: PropTypes.string
  }).isRequired,
  weeks: PropTypes.array.isRequired
};
var Container$2 = styled.div(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n  background-color: ", ";\n  min-width: 1150px;\n"])), theme.oldColors.white[600]);

var _excluded$3 = ["from", "to"];
var RangeInput = function RangeInput(_ref) {
  var from = _ref.from,
    to = _ref.to,
    props = _objectWithoutProperties(_ref, _excluded$3);
  return /*#__PURE__*/React__default.createElement(Input$1, _extends({
    value: "".concat(from).concat(to)
  }, props));
};
var NumberInput = function NumberInput(_ref2) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return /*#__PURE__*/React__default.createElement(Input$1, _extends({}, props, {
    onlyNumbers: true
  }));
};

var _templateObject$o, _templateObject2$i, _templateObject3$f, _templateObject4$c, _templateObject5$c, _templateObject6$a, _templateObject7$8, _templateObject8$7, _templateObject9$6, _templateObject10$6, _templateObject11$5;
var SelectButton = styled.ul(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n  font-family: Ubuntu, serif;\n  font-size: 16px;\n  list-style-type: none;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  display: flex;\n  text-align: center;\n  ", "\n"])), function (_ref) {
  var fullWidth = _ref.fullWidth;
  return fullWidth === true && css$1(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteral(["\n      display: grid;\n      grid-template-columns: 100%;\n    "])));
});
var TitleLabel = styled(Label)(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteral(["\n  display: block;\n  margin: 10px 20px 20px;\n  font-size: 11px;\n  color: ", ";\n"])), theme.oldColors['palette-neutral-n-2']);
var Option = styled.li(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteral(["\n  text-align: center;\n\n  ", "\n"])), function (_ref2) {
  var type = _ref2.type;
  return getType$1(type);
});
var getType$1 = function getType(type) {
  switch (type) {
    case 'basic':
      return css$1(_templateObject5$c || (_templateObject5$c = _taggedTemplateLiteral(["\n        flex-basis: 48%;\n      "])));
    case 'multiple':
      return css$1(_templateObject6$a || (_templateObject6$a = _taggedTemplateLiteral(["\n        flex-basis: 30%;\n      "])));
  }
};
var Input$2 = styled.input(_templateObject7$8 || (_templateObject7$8 = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n  ", "\n"])), function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled === true ? css$1(_templateObject8$7 || (_templateObject8$7 = _taggedTemplateLiteral(["\n          &:checked {\n            + {\n              label {\n                color: ", ";\n                background-color: ", ";\n                border-color: ", ";\n              }\n            }\n          }\n          cursor: not-allowed;\n          pointer-events: none;\n        "])), theme.oldColors['palette-input-disabled-text'], theme.oldColors['palette-buttons-primary-disabled'], theme.oldColors['palette-buttons-primary-disabled']) : css$1(_templateObject9$6 || (_templateObject9$6 = _taggedTemplateLiteral(["\n          &:checked {\n            + {\n              label {\n                color: ", ";\n                background-color: ", ";\n                border-color: ", ";\n              }\n            }\n          }\n        "])), theme.oldColors['palette-background-cards-white'], theme.oldColors['palette-primary-p-1-p-1'], theme.oldColors['palette-primary-p-1-p-1']);
});
var OptionLabel = styled(Label)(_templateObject10$6 || (_templateObject10$6 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 5px;\n  border: solid 1px ", ";\n  border-radius: 20px;\n  ", "\n"])), theme.oldColors['border-row-table'], function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled === true ? css$1(_templateObject11$5 || (_templateObject11$5 = _taggedTemplateLiteral(["\n          color: ", ";\n          cursor: not-allowed;\n          pointer-events: none;\n        "])), theme.oldColors['palette-input-disabled-text']) : "cursor: pointer;\n         color: ".concat(theme.colors['palette-neutral-n-2'], ";\n        &:hover {\n          background: ").concat(theme.oldColors['border-row-table'], ";\n        }");
});

var SelectableButton = function SelectableButton(_ref) {
  var label = _ref.label,
    name = _ref.name,
    options = _ref.options,
    onClick = _ref.onClick,
    _onChange = _ref.onChange,
    value = _ref.value,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    disabled = _ref.disabled;
  var handleChecked = function handleChecked(option) {
    return value === option;
  };
  return /*#__PURE__*/React__default.createElement(SelectButton, {
    fullWidth: fullWidth
  }, label && /*#__PURE__*/React__default.createElement(TitleLabel, null, label), options.map(function (option) {
    return /*#__PURE__*/React__default.createElement(Option, {
      type: options.length <= 2 ? 'basic' : 'multiple',
      key: option.id,
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement(Input$2, {
      type: "radio",
      id: option.id,
      value: option.value,
      name: name,
      onClick: onClick,
      onChange: function onChange(e) {
        return _onChange && _onChange(e);
      },
      checked: value && handleChecked(option.value),
      disabled: disabled
    }), /*#__PURE__*/React__default.createElement(OptionLabel, {
      disabled: disabled,
      htmlFor: option.id
    }, option.label));
  }));
};
SelectableButton.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

var _templateObject$p, _templateObject2$j, _templateObject3$g, _templateObject4$d;
var ChipsContainer = styled.div(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), theme.spacing['spacing-2']);
var SelectableChips = styled.div(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteral(["\n  display: flex;\n  ", "\n  flex-wrap: wrap;\n"])), function (_ref) {
  var direction = _ref.direction;
  return css$1(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteral(["\n      flex-direction: ", ";\n    "])), direction);
});
var ChipWrapper = styled.div(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteral(["\n  padding: ", " ", "\n    ", " ", ";\n"])), theme.spacing['spacing-0'], theme.spacing['spacing-4'], theme.spacing['spacing-4'], theme.spacing['spacing-0']);

var _templateObject$q, _templateObject2$k, _templateObject3$h, _templateObject4$e, _templateObject5$d, _templateObject6$b, _templateObject7$9;
var Chip = styled.div(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  cursor: pointer;\n  padding: ", " ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: inset 0 0 0 1px ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  ", "\n  ", "\n  ", "\n"])), theme.spacing['spacing-2'], theme.spacing['spacing-4'], theme.colors.neutral.bg.weak, theme.borderRadius['border-radius-5'], theme.colors.neutral.border.regular, theme.colors.neutral.bg.strong, function (_ref) {
  var active = _ref.active;
  return active === true && css$1(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteral(["\n      background-color: ", ";\n      box-shadow: inset 0 0 0 1px ", ";\n      &:hover {\n        background-color: ", ";\n        box-shadow: inset 0 0 0 1px\n          ", ";\n      }\n    "])), theme.colors['secondary-1'].bg.weak, theme.colors['secondary-1'].border.regular, theme.colors['secondary-1'].bg.weak, theme.colors['secondary-1'].border.regular);
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled === true && css$1(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteral(["\n      background-color: ", ";\n      box-shadow: inset 0 0 0 1px ", ";\n      &:hover {\n        color: ", ";\n        background-color: ", ";\n        box-shadow: inset 0 0 0 1px ", ";\n        cursor: default;\n      }\n    "])), theme.colors['neutral'].bg.regular, theme.colors.neutral.border.weak, theme.colors['neutral'].text.regular, theme.colors['neutral'].bg.regular, theme.colors.neutral.border.weak);
}, function (_ref3) {
  var iconExit = _ref3.iconExit;
  return iconExit === true && css$1(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteral(["\n      padding: ", " ", "\n        ", " ", ";\n    "])), theme.spacing['spacing-2'], theme.spacing['spacing-3'], theme.spacing['spacing-2'], theme.spacing['spacing-4']);
});
var TextWrapper$2 = styled.div(_templateObject5$d || (_templateObject5$d = _taggedTemplateLiteral([""])));
var IconLeft = styled.div(_templateObject6$b || (_templateObject6$b = _taggedTemplateLiteral(["\n  margin-right: ", ";\n"])), theme.spacing['spacing-3']);
var IconRight = styled.div(_templateObject7$9 || (_templateObject7$9 = _taggedTemplateLiteral(["\n  margin-left: ", ";\n"])), theme.spacing['spacing-3']);

var Chip$1 = function Chip$1(_ref) {
  var text = _ref.text,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? text : _ref$value,
    iconLeft = _ref.iconLeft,
    closeButton = _ref.closeButton,
    onClickClose = _ref.onClickClose,
    disabled = _ref.disabled,
    active = _ref.active,
    _onClick = _ref.onClick;
  var state = disabled ? 'disabled' : active ? 'active' : 'default';
  var renderIconLeft = function renderIconLeft() {
    var states = {
      disabled: {
        variant: 'neutral',
        modifier: 'regular'
      },
      active: {
        variant: 'secondary-1',
        modifier: 'strong'
      },
      "default": {
        variant: 'neutral',
        modifier: 'strong'
      }
    };
    return /*#__PURE__*/React__default.createElement(IconLeft, null, /*#__PURE__*/React__default.createElement(Icon$1, {
      name: iconLeft,
      variant: states[state].variant,
      modifier: states[state].modifier,
      cursor: "default",
      width: 24,
      height: 24
    }));
  };
  var renderIconClose = function renderIconClose() {
    var states = {
      disabled: {
        variant: 'neutral',
        modifier: 'regular',
        cursor: 'not-allowed'
      },
      active: {
        variant: 'secondary-1',
        modifier: 'strong',
        cursor: 'pointer'
      },
      "default": {
        variant: 'neutral',
        modifier: 'strong',
        cursor: 'pointer'
      }
    };
    return /*#__PURE__*/React__default.createElement(IconRight, null, /*#__PURE__*/React__default.createElement(Icon$1, {
      variant: states[state].variant,
      name: "cancel_outline",
      modifier: states[state].modifier,
      width: 24,
      height: 24,
      cursor: states[state].cursor,
      onClick: disabled ? null : onClickClose
    }));
  };
  var renderText = function renderText() {
    var states = {
      disabled: {
        variant: 'neutral',
        modifier: 'regular'
      },
      active: {
        variant: 'secondary-1',
        modifier: 'strong'
      },
      "default": {
        variant: 'neutral',
        modifier: 'strong'
      }
    };
    return /*#__PURE__*/React__default.createElement(TextWrapper$2, null, /*#__PURE__*/React__default.createElement(Span$1, {
      type: "2",
      variant: states[state].variant,
      modifier: states[state].modifier
    }, text));
  };
  return /*#__PURE__*/React__default.createElement(Chip, {
    active: active,
    disabled: disabled,
    iconExit: closeButton,
    onClick: function onClick() {
      return disabled || !_onClick ? undefined : _onClick(value);
    },
    key: value
  }, iconLeft && renderIconLeft(), text && renderText(), closeButton && renderIconClose());
};
Chip$1.defaultProps = {
  disabled: false,
  active: false
};
Chip$1.propTypes = {
  text: PropTypes.string.isRequired,
  value: PropTypes.string,
  iconLeft: PropTypes.string,
  closeButton: PropTypes.bool,
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  onClickClose: PropTypes.func,
  onClick: PropTypes.func
};

var SelectableChips$1 = function SelectableChips$1(_ref) {
  var direction = _ref.direction,
    options = _ref.options,
    onChange = _ref.onChange,
    multiSelect = _ref.multiSelect,
    selectAll = _ref.selectAll,
    disabled = _ref.disabled;
  var _useState = useState(options),
    _useState2 = _slicedToArray(_useState, 2),
    list = _useState2[0],
    setList = _useState2[1];
  var handleOnClick = function handleOnClick(text) {
    var toggleActiveList = list.map(function (itemChip) {
      var isItemSelected = (itemChip.value ? itemChip.value : itemChip.text) === text;
      if (multiSelect) {
        return isItemSelected ? _objectSpread2(_objectSpread2({}, itemChip), {}, {
          active: !itemChip.active
        }) : _objectSpread2({}, itemChip);
      } else {
        return _objectSpread2(_objectSpread2({}, itemChip), {}, {
          active: isItemSelected
        });
      }
    });
    setList(toggleActiveList);
    onChange(toggleActiveList);
  };
  var quantitySelected = list.filter(function (_ref2) {
    var active = _ref2.active;
    return active;
  }).length;
  var handleSelectAll = function handleSelectAll() {
    var toggleSelectAllList = list.map(function (itemChip) {
      return _objectSpread2(_objectSpread2({}, itemChip), {}, {
        active: quantitySelected === 0
      });
    });
    setList(toggleSelectAllList);
    onChange(toggleSelectAllList);
  };
  var SelectAll = function SelectAll() {
    return /*#__PURE__*/React__default.createElement(Checkbox$1, {
      id: "select-all",
      checked: quantitySelected > 0,
      onChange: disabled ? undefined : handleSelectAll,
      isSelectAllCheck: true,
      size: "sm",
      disabled: disabled
    }, /*#__PURE__*/React__default.createElement(Span$1, {
      variant: "neutral",
      modifier: "strong",
      type: "2",
      align: "left"
    }, quantitySelected === 0 && 'Seleccionar todos', quantitySelected === 1 && "".concat(quantitySelected, " Seleccionado"), quantitySelected > 1 && "".concat(quantitySelected, " Seleccionados")));
  };
  useEffect(function () {
    setList(options);
  }, [options]);
  var chips = list.map(function (item) {
    return /*#__PURE__*/React__default.createElement(ChipWrapper, {
      key: item.text
    }, /*#__PURE__*/React__default.createElement(Chip$1, {
      active: item.active,
      text: item.text,
      value: item.value,
      onClick: handleOnClick,
      disabled: disabled
    }));
  });
  return /*#__PURE__*/React__default.createElement(ChipsContainer, null, multiSelect && selectAll && /*#__PURE__*/React__default.createElement(SelectAll, null), /*#__PURE__*/React__default.createElement(SelectableChips, {
    direction: direction
  }, chips));
};
SelectableChips$1.defaultProps = {
  direction: 'row',
  multiSelect: false,
  selectAll: false,
  disabled: false
};
SelectableChips$1.propTypes = {
  options: PropTypes.array.isRequired,
  direction: PropTypes.oneOf(['row', 'column']),
  onChange: PropTypes.func,
  multiSelect: PropTypes.bool,
  selectAll: PropTypes.bool,
  disabled: PropTypes.bool
};

var _templateObject$r, _templateObject2$l, _templateObject3$i, _templateObject4$f, _templateObject5$e, _templateObject6$c;
var SelectButton$1 = styled.ul(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral(["\n  font-family: Roboto, serif;\n  font-size: 14px;\n  list-style-type: none;\n  flex-wrap: wrap;\n  display: flex;\n  text-align: center;\n  justify-content: flex-start;\n"])));
var Option$1 = styled.li(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteral(["\n  text-align: center;\n  padding: 5px;\n"])));
var Input$3 = styled.input(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n  &:checked {\n    + {\n      label {\n        color: ", ";\n        background-color: ", ";\n        border-color: ", ";\n      }\n    }\n  }\n"])), theme.oldColors['palette-background-cards-white'], theme.oldColors['palette-primary-p-1-p-1'], theme.oldColors['palette-primary-p-1-p-1']);
var OptionLabel$1 = styled(Label)(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 1px 10px;\n  border: solid 2px ", ";\n  border-radius: 20px;\n  cursor: pointer;\n  &:hover {\n    background: ", ";\n  }\n"])), theme.oldColors['palette-primary-p-1-p-1'], theme.oldColors['border-row-table']);
var SelectAll = styled(Checkbox$1)(_templateObject5$e || (_templateObject5$e = _taggedTemplateLiteral(["\n  margin-bottom: 5px;\n"])));
var SelectAllContent = styled(Span)(_templateObject6$c || (_templateObject6$c = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-left: 5px;\n"])));

var useMultiSelect = function useMultiSelect(options, initialValue, OPTION_ALL) {
  var _useState = useState(initialValue),
    _useState2 = _slicedToArray(_useState, 2),
    values = _useState2[0],
    setValues = _useState2[1];
  var indexAllOption = values.findIndex(function (e) {
    return e === OPTION_ALL.value;
  });
  var checkOption = function checkOption(option) {
    if (option.value === OPTION_ALL.value) {
      if (values.length > 0) {
        setValues([]);
      } else {
        setValues(options.map(function (_ref) {
          var value = _ref.value;
          return value;
        }));
      }
    } else {
      var oldOption = optionsObject[option.value];
      if (oldOption.isSelected) {
        setValues(function (prevState) {
          return [].concat(_toConsumableArray(prevState.slice(0, oldOption.currentIndex)), _toConsumableArray(prevState.slice(oldOption.currentIndex + 1)));
        });
      } else {
        if (indexAllOption >= 0) {
          setValues(function (prevState) {
            return Array.from(new Set([].concat(_toConsumableArray(prevState.slice(0, indexAllOption)), _toConsumableArray(prevState.slice(indexAllOption + 1)), [option.value])));
          });
        } else {
          setValues(function (prevState) {
            return Array.from(new Set([].concat(_toConsumableArray(prevState), [option.value])));
          });
        }
      }
    }
  };
  var optionsObject = options.reduce(function (acc, b) {
    var currentIndex = values.findIndex(function (e) {
      return e === b.value;
    });
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, b.value, _objectSpread2(_objectSpread2({}, b), {}, {
      isSelected: currentIndex >= 0,
      currentIndex: currentIndex
    })));
  }, {});
  return {
    values: Object.values(optionsObject),
    setValues: setValues,
    checkOption: checkOption
  };
};

var hasKeys = function hasKeys(keys) {
  return keys && Object.keys(keys).length > 0;
};
var hasValues = function hasValues(values) {
  return values && Object.values(values).some(function (e) {
    return e;
  });
};
var fillObject = function fillObject(object, value) {
  return Object.keys(object).reduce(function (acc, current) {
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, current, value));
  }, {});
};
var isSameArray = function isSameArray(array1, array2) {
  var array2Sorted = array2.slice().sort();
  return array1.length === array2.length && array1.slice().sort().every(function (value, index) {
    return value === array2Sorted[index];
  });
};
var capitalize = function capitalize(word) {
  var lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
};

// Locale 'es-AR' helps formatting $1000 to $1.000,00
var numberFormatter = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  currencyDisplay: 'symbol'
});

var OPTION_ALL$1 = {
  label: 'Todas',
  value: 'TODAS'
};
var MultiSelectableButton = function MultiSelectableButton(_ref) {
  var name = _ref.name,
    onChange = _ref.onChange,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? [] : _ref$value,
    options = _ref.options;
  var initialValue = value || [];
  var _useMultiSelect = useMultiSelect(options, initialValue, OPTION_ALL$1),
    values = _useMultiSelect.values,
    checkOption = _useMultiSelect.checkOption,
    setValues = _useMultiSelect.setValues;
  var valuesSelected = values.filter(function (_ref2) {
    var isSelected = _ref2.isSelected;
    return isSelected;
  }).map(function (_ref3) {
    var value = _ref3.value;
    return value;
  });
  var quantitySelected = valuesSelected.length;
  var handleOnChange = function handleOnChange(selectedOption) {
    checkOption(selectedOption);
  };
  useEffect(function () {
    if (!isSameArray(value, valuesSelected)) {
      onChange && onChange(valuesSelected);
    }
  }, [values]);
  useEffect(function () {
    if (!isSameArray(value, valuesSelected)) {
      setValues(value);
    }
  }, [value]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SelectAll, {
    id: "select-all",
    checked: quantitySelected > 0,
    onChange: function onChange() {
      return handleOnChange(OPTION_ALL$1);
    },
    isSelectAllCheck: true,
    size: "sm"
  }, /*#__PURE__*/React__default.createElement(SelectAllContent, {
    type: "2",
    align: "left"
  }, quantitySelected === 0 && 'Seleccionar todos', quantitySelected > 0 && "".concat(quantitySelected, " Seleccionados"))), /*#__PURE__*/React__default.createElement(SelectButton$1, null, values.filter(function (_ref4) {
    var value = _ref4.value;
    return value != OPTION_ALL$1.value;
  }).map(function (option) {
    return /*#__PURE__*/React__default.createElement(Option$1, {
      key: "multiselect-option-".concat(option.value)
    }, /*#__PURE__*/React__default.createElement(Input$3, {
      type: "checkbox",
      id: "multiselect-option-".concat(option.value),
      value: option.value,
      name: name,
      onChange: function onChange() {
        return handleOnChange(option);
      },
      checked: option.isSelected
    }), /*#__PURE__*/React__default.createElement(OptionLabel$1, {
      htmlFor: "multiselect-option-".concat(option.value)
    }, option.label));
  })));
};
MultiSelectableButton.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  onChange: PropTypes.func
};
MultiSelectableButton.OPTION_ALL = OPTION_ALL$1;

var _templateObject$s, _templateObject2$m, _templateObject3$j, _templateObject4$g, _templateObject5$f, _templateObject6$d, _templateObject7$a;
var Select = styled.div(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral(["\n  width: 100%;\n  position: relative;\n\n  select:-webkit-autofill,\n  select:-webkit-autofill:hover,\n  select:-webkit-autofill:focus,\n  select:-webkit-autofill:active {\n    -webkit-transition: 'color 9999s ease-out, background-color 9999s ease-out';\n    -webkit-transition-delay: 9999s;\n  }\n"])));
var LabelWrapper$1 = styled.div(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteral(["\n  padding: ", " ", "\n    ", " ", ";\n  display: flex;\n"])), theme.spacing['spacing-2'], theme.spacing['spacing-2'], theme.spacing['spacing-2'], theme.spacing['spacing-5']);
var SelectTag = styled.select(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteral(["\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: none;\n  width: 100%;\n  height: 40px;\n  background-color: ", ";\n  border-radius: ", ";\n  padding: ", " ", "\n    ", " ", ";\n  box-shadow: inset 0 0 0 1px ", ";\n  ", ";\n  color: ", ";\n  ", "\n  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy43MzY0IDkuMjYzNjNDMTcuMzg0OSA4LjkxMjE2IDE2LjgxNTEgOC45MTIxNiAxNi40NjM2IDkuMjYzNjNMMTIgMTMuNzI3Mkw3LjUzNjM5IDkuMjYzNjNDNy4xODQ5MiA4LjkxMjE2IDYuNjE1MDcgOC45MTIxNiA2LjI2MzYgOS4yNjM2M0M1LjkxMjEzIDkuNjE1MSA1LjkxMjEzIDEwLjE4NSA2LjI2MzYgMTAuNTM2NEwxMS4zNjM2IDE1LjYzNjRDMTEuNzE1MSAxNS45ODc5IDEyLjI4NSAxNS45ODc5IDEyLjYzNjQgMTUuNjM2NEwxNy43MzY0IDEwLjUzNjRDMTguMDg3OSAxMC4xODQ5IDE4LjA4NzkgOS42MTUxIDE3LjczNjQgOS4yNjM2M1oiIGZpbGw9IiMwMjNGODAiLz4KPC9zdmc+Cg==');\n  background-repeat: no-repeat;\n  background-position-x: calc(100% - 10px);\n  background-position-y: 50%;\n\n  &:focus,\n  &:focus-visible {\n    outline: none;\n    box-shadow: inset 0 0 0 1px ", ";\n  }\n\n  outline: none;\n  ", "\n\n  option {\n    ", ";\n  }\n"])), theme.colors.neutral.bg.weak, theme.borderRadius['border-radius-5'], theme.spacing['spacing-3'], theme.spacing['spacing-3'], theme.spacing['spacing-3'], theme.spacing['spacing-5'], theme.colors['neutral'].border.regular, theme.textStyles['text-preset-9'], theme.colors['neutral'].text.strong, function (_ref) {
  var error = _ref.error;
  return error === true && css$1(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteral(["\n      box-shadow: inset 0 0 0 1px ", ";\n    "])), theme.colors['danger'].border.regular);
}, theme.colors['secondary-1'].border.regular, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled === true && css$1(_templateObject5$f || (_templateObject5$f = _taggedTemplateLiteral(["\n      background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy43MzY0IDkuMjYzNjNDMTcuMzg0OSA4LjkxMjE2IDE2LjgxNTEgOC45MTIxNiAxNi40NjM2IDkuMjYzNjNMMTIgMTMuNzI3Mkw3LjUzNjM5IDkuMjYzNjNDNy4xODQ5MiA4LjkxMjE2IDYuNjE1MDcgOC45MTIxNiA2LjI2MzYgOS4yNjM2M0M1LjkxMjEzIDkuNjE1MSA1LjkxMjEzIDEwLjE4NSA2LjI2MzYgMTAuNTM2NEwxMS4zNjM2IDE1LjYzNjRDMTEuNzE1MSAxNS45ODc5IDEyLjI4NSAxNS45ODc5IDEyLjYzNjQgMTUuNjM2NEwxNy43MzY0IDEwLjUzNjRDMTguMDg3OSAxMC4xODQ5IDE4LjA4NzkgOS42MTUxIDE3LjczNjQgOS4yNjM2M1oiIGZpbGw9IiM2NDcxODAiLz4KPC9zdmc+Cg==');\n      color: ", ";\n      background-color: ", ";\n      box-shadow: inset 0 0 0 1px ", ";\n      background-color: ", ";\n      &:hover,\n      &:focus {\n        box-shadow: inset 0 0 0 1px ", ";\n      }\n    "])), theme.colors['neutral'].text.regular, theme.colors['neutral'].bg.regular, theme.colors['neutral'].border.regular, theme.colors['neutral'].bg.regular, theme.colors['neutral'].border.regular);
}, theme.textStyles['text-preset-9']);
var HelpText$1 = styled.div(_templateObject6$d || (_templateObject6$d = _taggedTemplateLiteral(["\n  padding: ", " ", "\n    ", " ", ";\n  display: flex;\n  align-items: center;\n  position: absolute;\n  ", "\n"])), theme.spacing['spacing-2'], theme.spacing['spacing-2'], theme.spacing['spacing-2'], theme.spacing['spacing-5'], function (_ref3) {
  var status = _ref3.status;
  return status === true && css$1(_templateObject7$a || (_templateObject7$a = _taggedTemplateLiteral(["\n      > * {\n        &:first-child {\n          margin-right: ", " !important;\n        }\n      }\n    "])), theme.spacing['spacing-2']);
});

var Select$1 = function Select$1(_ref) {
  var id = _ref.id,
    options = _ref.options,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Seleccione...' : _ref$placeholder,
    name = _ref.name,
    label = _ref.label,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    error = _ref.error,
    message = _ref.message,
    disabled = _ref.disabled,
    reset = _ref.reset,
    value = _ref.value;
  var defaultValue = value ? value : placeholder;
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOption = _useState2[0],
    setSelectedOption = _useState2[1];
  useEffect(function () {
    if (selectedOption !== defaultValue && reset) {
      setSelectedOption(defaultValue);
    }
  }, [reset]);
  var handleChange = function handleChange(event) {
    setSelectedOption(event.target.value);
    onChange && onChange(event);
  };
  return /*#__PURE__*/React__default.createElement(Select, null, label && /*#__PURE__*/React__default.createElement(LabelWrapper$1, null, /*#__PURE__*/React__default.createElement(Label$1, {
    id: id,
    type: "4"
  }, label)), /*#__PURE__*/React__default.createElement(SelectTag, {
    value: selectedOption,
    name: name,
    onChange: handleChange,
    onBlur: onBlur,
    error: error,
    disabled: disabled
  }, /*#__PURE__*/React__default.createElement("option", {
    disabled: true,
    hidden: true
  }, placeholder), options.length > 0 && options.map(function (_ref2) {
    var value = _ref2.value,
      label = _ref2.label,
      disabled = _ref2.disabled;
    return /*#__PURE__*/React__default.createElement("option", {
      key: value,
      value: value,
      disabled: !!disabled
    }, label);
  })), message && /*#__PURE__*/React__default.createElement(HelpText$1, {
    status: error
  }, error && /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "error_circle_outline",
    variant: "danger",
    width: "16",
    height: "16"
  }), /*#__PURE__*/React__default.createElement(Span$1, {
    id: id,
    type: "4",
    variant: error ? 'danger' : 'neutral'
  }, message)));
};
Select$1.defaultProps = {
  placeholder: 'Seleccione...'
};
Select$1.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  error: PropTypes.bool,
  message: PropTypes.string,
  disabled: PropTypes.bool,
  reset: PropTypes.bool,
  value: PropTypes.string
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var classnames = createCommonjsModule(function (module) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var _const = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  SORT_ASC: 'asc',
  SORT_DESC: 'desc',
  ROW_SELECT_SINGLE: 'radio',
  ROW_SELECT_MULTIPLE: 'checkbox',
  ROW_SELECT_DISABLED: 'ROW_SELECT_DISABLED',
  CHECKBOX_STATUS_CHECKED: 'checked',
  CHECKBOX_STATUS_INDETERMINATE: 'indeterminate',
  CHECKBOX_STATUS_UNCHECKED: 'unchecked',
  INDICATOR_POSITION_LEFT: 'left',
  INDICATOR_POSITION_RIGHT: 'right',
  TYPE_STRING: 'string',
  TYPE_NUMBER: 'number',
  TYPE_BOOLEAN: 'bool',
  TYPE_DATE: 'date',
  FILTERS_POSITION_INLINE: 'inline',
  FILTERS_POSITION_TOP: 'top',
  FILTERS_POSITION_BOTTOM: 'bottom'
};
});

unwrapExports(_const);

var bootstrap = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BootstrapContext = undefined;



var _react2 = _interopRequireDefault(React__default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BootstrapContext = exports.BootstrapContext = _react2.default.createContext({
  bootstrap4: false
});
});

unwrapExports(bootstrap);
var bootstrap_1 = bootstrap.BootstrapContext;

var symbol = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SortSymbol = function SortSymbol() {
  return _react2.default.createElement(
    bootstrap.BootstrapContext.Consumer,
    null,
    function (_ref) {
      var bootstrap4 = _ref.bootstrap4;
      return bootstrap4 ? _react2.default.createElement('span', { className: 'order-4' }) : _react2.default.createElement(
        'span',
        { className: 'order' },
        _react2.default.createElement(
          'span',
          { className: 'dropdown' },
          _react2.default.createElement('span', { className: 'caret' })
        ),
        _react2.default.createElement(
          'span',
          { className: 'dropup' },
          _react2.default.createElement('span', { className: 'caret' })
        )
      );
    }
  );
};

exports.default = SortSymbol;
});

unwrapExports(symbol);

var caret = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _classnames2 = _interopRequireDefault(classnames);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _const2 = _interopRequireDefault(_const);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SortCaret = function SortCaret(_ref) {
  var order = _ref.order;

  var orderClass = (0, _classnames2.default)('react-bootstrap-table-sort-order', {
    dropup: order === _const2.default.SORT_ASC
  });

  return _react2.default.createElement(
    bootstrap.BootstrapContext.Consumer,
    null,
    function (_ref2) {
      var bootstrap4 = _ref2.bootstrap4;
      return bootstrap4 ? _react2.default.createElement('span', { className: 'caret-4-' + order }) : _react2.default.createElement(
        'span',
        { className: orderClass },
        _react2.default.createElement('span', { className: 'caret' })
      );
    }
  );
};

SortCaret.propTypes = {
  order: _propTypes2.default.oneOf([_const2.default.SORT_ASC, _const2.default.SORT_DESC]).isRequired
};

exports.default = SortCaret;
});

unwrapExports(caret);

var underscore = createCommonjsModule(function (module, exports) {
//     Underscore.js 1.9.1
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof commonjsGlobal == 'object' && commonjsGlobal.global === commonjsGlobal && commonjsGlobal ||
            this ||
            {};

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for their old module API. If we're in
  // the browser, add `_` as a global object.
  // (`nodeType` is checked to ensure that `module`
  // and `exports` are not HTML elements.)
  if ( !exports.nodeType) {
    if ( !module.nodeType && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.9.1';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  var builtinIteratee;

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
    return _.property(value);
  };

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only argCount argument.
  _.iteratee = builtinIteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  var restArguments = function(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var shallowProperty = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  var has = function(obj, path) {
    return obj != null && hasOwnProperty.call(obj, path);
  };

  var deepGet = function(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = shallowProperty('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  var createReduce = function(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  };

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (_.isFunction(path)) {
      func = path;
    } else if (_.isArray(path)) {
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return _.map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection.
  _.shuffle = function(obj) {
    return _.sample(obj, Infinity);
  };

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = _.random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (has(result, key)) result[key]++; else result[key] = 1;
  });

  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (_.isString(obj)) {
      // Keep surrogate pair characters together
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, Boolean);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    output = output || [];
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        // Flatten current level of array or arguments object.
        if (shallow) {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        } else {
          flatten(value, shallow, strict, output);
          idx = output.length;
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = restArguments(function(array, otherArrays) {
    return _.difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = restArguments(function(arrays) {
    return _.uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = restArguments(function(array, rest) {
    rest = flatten(rest, true, true);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  });

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = restArguments(_.unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of _.pairs.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions.
  var createPredicateIndexFinder = function(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  };

  // Returns the first index on an array-like that passes a predicate test.
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions.
  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  _.chunk = function(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments.
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = restArguments(function(func, context, args) {
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  _.partial = restArguments(function(func, boundArgs) {
    var placeholder = _.partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  _.partial.placeholder = _;

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = restArguments(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = _.bind(obj[key], obj);
    }
  });

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, result;

    var later = function(context, args) {
      timeout = null;
      if (args) result = func.apply(context, args);
    };

    var debounced = restArguments(function(args) {
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(this, args);
      } else {
        timeout = _.delay(later, wait, this, args);
      }

      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = null;
    };

    return debounced;
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  _.restArguments = restArguments;

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  var collectNonEnumProps = function(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  };

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object.
  // In contrast to _.map it returns an object.
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
        length = keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of _.object.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`.
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test.
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Internal pick helper function to determine if `obj` has key `key`.
  var keyInObj = function(value, key, obj) {
    return key in obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = _.allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the blacklisted properties.
  _.omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = _.map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  });

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq, deepEq;
  eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  };

  // Internal recursive comparison function for `isEqual`.
  deepEq = function(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`?
  _.isNaN = function(obj) {
    return _.isNumber(obj) && isNaN(obj);
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, path) {
    if (!_.isArray(path)) {
      return has(obj, path);
    }
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (obj == null || !hasOwnProperty.call(obj, key)) {
        return false;
      }
      obj = obj[key];
    }
    return !!length;
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indexes.
  _.property = function(path) {
    if (!_.isArray(path)) {
      return shallowProperty(path);
    }
    return function(obj) {
      return deepGet(obj, path);
    };
  };

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    if (obj == null) {
      return function(){};
    }
    return function(path) {
      return !_.isArray(path) ? obj[path] : deepGet(obj, path);
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  _.result = function(obj, path, fallback) {
    if (!_.isArray(path)) path = [path];
    var length = path.length;
    if (!length) {
      return _.isFunction(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = _.isFunction(prop) ? prop.call(obj) : prop;
    }
    return obj;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var chainResult = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
    return _;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return chainResult(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return chainResult(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return String(this._wrapped);
  };
}());
});
var underscore_1 = underscore._;

var utils = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _underscore2 = _interopRequireDefault(underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function splitNested(str) {
  return [str].join('.').replace(/\[/g, '.').replace(/\]/g, '').split('.');
} /* eslint no-empty: 0 */
/* eslint no-param-reassign: 0 */
/* eslint prefer-rest-params: 0 */


function contains(list, value) {
  if (_underscore2.default.includes) {
    return _underscore2.default.includes(list, value);
  }

  return list.indexOf(value) > -1;
}

function get(target, field) {
  var directGet = target[field];
  if (directGet !== undefined && directGet !== null) {
    return directGet;
  }

  var pathArray = splitNested(field);
  var result = void 0;
  try {
    result = pathArray.reduce(function (curr, path) {
      return curr[path];
    }, target);
  } catch (e) {}
  return result;
}

function set(target, field, value) {
  var safe = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var pathArray = splitNested(field);
  var level = 0;
  pathArray.reduce(function (a, b) {
    level += 1;
    if (typeof a[b] === 'undefined') {
      if (!safe) throw new Error(a + '.' + b + ' is undefined');
      a[b] = {};
      return a[b];
    }

    if (level === pathArray.length) {
      a[b] = value;
      return value;
    }
    return a[b];
  }, target);
}

function isEmptyObject(obj) {
  if (!_underscore2.default.isObject(obj)) return false;

  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var keys = Object.keys(obj);

  for (var i = 0; i < keys.length; i += 1) {
    if (hasOwnProperty.call(obj, keys[i])) return false;
  }

  return true;
}

function isDefined(value) {
  return typeof value !== 'undefined' && value !== null;
}

function sleep(fn, ms) {
  return setTimeout(function () {
    return fn();
  }, ms);
}

function debounce(func, wait, immediate) {
  var _this = this,
      _arguments = arguments;

  var timeout = void 0;

  return function () {
    var later = function later() {
      timeout = null;

      if (!immediate) {
        func.apply(_this, _arguments);
      }
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);
    timeout = setTimeout(later, wait || 0);

    if (callNow) {
      func.apply(_this, _arguments);
    }
  };
}

exports.default = Object.assign(_underscore2.default, {
  get: get,
  set: set,
  isDefined: isDefined,
  isEmptyObject: isEmptyObject,
  sleep: sleep,
  debounce: debounce,
  contains: contains
});
});

unwrapExports(utils);

var cellEventDelegater = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _utils2 = _interopRequireDefault(utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = ['onClick', 'onDoubleClick', 'onMouseEnter', 'onMouseLeave', 'onContextMenu', 'onAuxClick'];

exports.default = function (ExtendBase) {
  return function (_ExtendBase) {
    _inherits(CellEventDelegater, _ExtendBase);

    function CellEventDelegater(props) {
      _classCallCheck(this, CellEventDelegater);

      var _this = _possibleConstructorReturn(this, (CellEventDelegater.__proto__ || Object.getPrototypeOf(CellEventDelegater)).call(this, props));

      _this.createDefaultEventHandler = _this.createDefaultEventHandler.bind(_this);
      return _this;
    }

    _createClass(CellEventDelegater, [{
      key: 'createDefaultEventHandler',
      value: function createDefaultEventHandler(cb) {
        var _this2 = this;

        return function (e) {
          var _props = _this2.props,
              column = _props.column,
              columnIndex = _props.columnIndex,
              index = _props.index;

          cb(e, column, typeof columnIndex !== 'undefined' ? columnIndex : index);
        };
      }
    }, {
      key: 'delegate',
      value: function delegate() {
        var _this3 = this;

        var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var newAttrs = _extends({}, attrs);
        Object.keys(attrs).forEach(function (attr) {
          if (_utils2.default.contains(events, attr)) {
            newAttrs[attr] = _this3.createDefaultEventHandler(attrs[attr]);
          }
        });
        return newAttrs;
      }
    }]);

    return CellEventDelegater;
  }(ExtendBase);
};
});

unwrapExports(cellEventDelegater);

var headerCell = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _classnames2 = _interopRequireDefault(classnames);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _const2 = _interopRequireDefault(_const);



var _symbol2 = _interopRequireDefault(symbol);



var _caret2 = _interopRequireDefault(caret);



var _utils2 = _interopRequireDefault(utils);



var _cellEventDelegater2 = _interopRequireDefault(cellEventDelegater);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/require-default-props: 0 */


var HeaderCell = function (_eventDelegater) {
  _inherits(HeaderCell, _eventDelegater);

  function HeaderCell() {
    _classCallCheck(this, HeaderCell);

    return _possibleConstructorReturn(this, (HeaderCell.__proto__ || Object.getPrototypeOf(HeaderCell)).apply(this, arguments));
  }

  _createClass(HeaderCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          column = _props.column,
          index = _props.index,
          onSort = _props.onSort,
          sorting = _props.sorting,
          sortOrder = _props.sortOrder,
          isLastSorting = _props.isLastSorting,
          onFilter = _props.onFilter,
          currFilters = _props.currFilters,
          filterPosition = _props.filterPosition,
          onExternalFilter = _props.onExternalFilter,
          globalSortCaret = _props.globalSortCaret;
      var text = column.text,
          sort = column.sort,
          sortCaret = column.sortCaret,
          filter = column.filter,
          filterRenderer = column.filterRenderer,
          headerTitle = column.headerTitle,
          headerAlign = column.headerAlign,
          headerFormatter = column.headerFormatter,
          headerEvents = column.headerEvents,
          headerClasses = column.headerClasses,
          headerStyle = column.headerStyle,
          headerAttrs = column.headerAttrs,
          headerSortingClasses = column.headerSortingClasses,
          headerSortingStyle = column.headerSortingStyle;


      var sortCaretfunc = sortCaret || globalSortCaret;

      var delegateEvents = this.delegate(headerEvents);

      var customAttrs = _utils2.default.isFunction(headerAttrs) ? headerAttrs(column, index) : headerAttrs || {};

      var cellAttrs = _extends({}, customAttrs, delegateEvents, {
        tabIndex: _utils2.default.isDefined(customAttrs.tabIndex) ? customAttrs.tabIndex : 0
      });

      var sortSymbol = void 0;
      var filterElm = void 0;
      var cellStyle = {};
      var cellClasses = _utils2.default.isFunction(headerClasses) ? headerClasses(column, index) : headerClasses;

      if (headerStyle) {
        cellStyle = _utils2.default.isFunction(headerStyle) ? headerStyle(column, index) : headerStyle;
        cellStyle = cellStyle ? _extends({}, cellStyle) : cellStyle;
      }

      if (headerTitle) {
        cellAttrs.title = _utils2.default.isFunction(headerTitle) ? headerTitle(column, index) : text;
      }

      if (headerAlign) {
        cellStyle.textAlign = _utils2.default.isFunction(headerAlign) ? headerAlign(column, index) : headerAlign;
      }

      if (sort) {
        var customClick = cellAttrs.onClick;
        cellAttrs['aria-label'] = sorting ? text + ' sort ' + sortOrder : text + ' sortable';
        cellAttrs.onKeyUp = function (e) {
          if (e.key === 'Enter') {
            onSort(column);
            if (_utils2.default.isFunction(customClick)) customClick(e);
          }
        };
        cellAttrs.onClick = function (e) {
          onSort(column);
          if (_utils2.default.isFunction(customClick)) customClick(e);
        };
        cellAttrs.className = (0, _classnames2.default)(cellAttrs.className, 'sortable');

        if (sorting) {
          sortSymbol = sortCaretfunc ? sortCaretfunc(sortOrder, column) : _react2.default.createElement(_caret2.default, { order: sortOrder });

          // append customized classes or style if table was sorting based on the current column.
          cellClasses = (0, _classnames2.default)(cellClasses, _utils2.default.isFunction(headerSortingClasses) ? headerSortingClasses(column, sortOrder, isLastSorting, index) : headerSortingClasses);

          cellStyle = _extends({}, cellStyle, _utils2.default.isFunction(headerSortingStyle) ? headerSortingStyle(column, sortOrder, isLastSorting, index) : headerSortingStyle);
        } else {
          sortSymbol = sortCaretfunc ? sortCaretfunc(undefined, column) : _react2.default.createElement(_symbol2.default, null);
        }
      }

      if (cellClasses) cellAttrs.className = (0, _classnames2.default)(cellAttrs.className, cellClasses);
      if (!_utils2.default.isEmptyObject(cellStyle)) cellAttrs.style = cellStyle;

      if (filterPosition === _const2.default.FILTERS_POSITION_INLINE) {
        if (filterRenderer) {
          var onCustomFilter = onExternalFilter(column, filter.props.type);
          filterElm = filterRenderer(onCustomFilter, column);
        } else if (filter) {
          filterElm = _react2.default.createElement(filter.Filter, _extends({}, filter.props, {
            filterState: currFilters[column.dataField],
            onFilter: onFilter,
            column: column
          }));
        }
      }

      var children = headerFormatter ? headerFormatter(column, index, { sortElement: sortSymbol, filterElement: filterElm }) : text;

      if (headerFormatter) {
        return _react2.default.createElement('th', cellAttrs, children);
      }

      return _react2.default.createElement('th', cellAttrs, children, sortSymbol, filterElm);
    }
  }]);

  return HeaderCell;
}((0, _cellEventDelegater2.default)(_react2.default.Component));

HeaderCell.propTypes = {
  column: _propTypes2.default.shape({
    dataField: _propTypes2.default.string.isRequired,
    text: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.oneOf([_const2.default.TYPE_STRING, _const2.default.TYPE_NUMBER, _const2.default.TYPE_BOOLEAN, _const2.default.TYPE_DATE]),
    isDummyField: _propTypes2.default.bool,
    hidden: _propTypes2.default.bool,
    headerFormatter: _propTypes2.default.func,
    formatter: _propTypes2.default.func,
    formatExtraData: _propTypes2.default.any,
    headerClasses: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    classes: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    headerStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    style: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    headerTitle: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
    title: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
    headerEvents: _propTypes2.default.object,
    events: _propTypes2.default.object,
    headerAlign: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    align: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    headerAttrs: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    attrs: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    sort: _propTypes2.default.bool,
    sortFunc: _propTypes2.default.func,
    onSort: _propTypes2.default.func,
    editor: _propTypes2.default.object,
    editable: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
    editCellStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    editCellClasses: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    editorStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    editorClasses: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    editorRenderer: _propTypes2.default.func,
    validator: _propTypes2.default.func,
    filter: _propTypes2.default.object,
    filterRenderer: _propTypes2.default.func,
    filterValue: _propTypes2.default.func,
    searchable: _propTypes2.default.bool
  }).isRequired,
  index: _propTypes2.default.number.isRequired,
  onSort: _propTypes2.default.func,
  sorting: _propTypes2.default.bool,
  sortOrder: _propTypes2.default.oneOf([_const2.default.SORT_ASC, _const2.default.SORT_DESC]),
  sortCaret: _propTypes2.default.func,
  isLastSorting: _propTypes2.default.bool,
  onFilter: _propTypes2.default.func,
  filterPosition: _propTypes2.default.oneOf([_const2.default.FILTERS_POSITION_INLINE, _const2.default.FILTERS_POSITION_BOTTOM, _const2.default.FILTERS_POSITION_TOP]),
  currFilters: _propTypes2.default.object,
  onExternalFilter: _propTypes2.default.func
};

exports.default = HeaderCell;
});

unwrapExports(headerCell);

var selectionHeaderCell = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckBox = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _const2 = _interopRequireDefault(_const);





var _utils2 = _interopRequireDefault(utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/require-default-props: 0 */


var CheckBox = exports.CheckBox = function CheckBox(_ref) {
  var className = _ref.className,
      checked = _ref.checked,
      indeterminate = _ref.indeterminate;
  return _react2.default.createElement('input', {
    type: 'checkbox',
    checked: checked,
    className: className,
    ref: function ref(input) {
      if (input) input.indeterminate = indeterminate; // eslint-disable-line no-param-reassign
    },
    onChange: function onChange() {}
  });
};

CheckBox.propTypes = {
  checked: _propTypes2.default.bool.isRequired,
  indeterminate: _propTypes2.default.bool.isRequired,
  className: _propTypes2.default.string
};

var SelectionHeaderCell = function (_Component) {
  _inherits(SelectionHeaderCell, _Component);

  function SelectionHeaderCell() {
    _classCallCheck(this, SelectionHeaderCell);

    var _this = _possibleConstructorReturn(this, (SelectionHeaderCell.__proto__ || Object.getPrototypeOf(SelectionHeaderCell)).call(this));

    _this.handleCheckBoxClick = _this.handleCheckBoxClick.bind(_this);
    return _this;
  }

  /**
   * avoid updating if button is
   * 1. radio
   * 2. status was not changed.
   */


  _createClass(SelectionHeaderCell, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var ROW_SELECT_SINGLE = _const2.default.ROW_SELECT_SINGLE;
      var _props = this.props,
          mode = _props.mode,
          checkedStatus = _props.checkedStatus;


      if (mode === ROW_SELECT_SINGLE) return false;

      return nextProps.checkedStatus !== checkedStatus;
    }
  }, {
    key: 'handleCheckBoxClick',
    value: function handleCheckBoxClick(e) {
      var _props2 = this.props,
          onAllRowsSelect = _props2.onAllRowsSelect,
          checkedStatus = _props2.checkedStatus;

      var isUnSelect = checkedStatus === _const2.default.CHECKBOX_STATUS_CHECKED || checkedStatus === _const2.default.CHECKBOX_STATUS_INDETERMINATE;

      onAllRowsSelect(e, isUnSelect);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var CHECKBOX_STATUS_CHECKED = _const2.default.CHECKBOX_STATUS_CHECKED,
          CHECKBOX_STATUS_INDETERMINATE = _const2.default.CHECKBOX_STATUS_INDETERMINATE,
          ROW_SELECT_MULTIPLE = _const2.default.ROW_SELECT_MULTIPLE;
      var _props3 = this.props,
          mode = _props3.mode,
          checkedStatus = _props3.checkedStatus,
          selectionHeaderRenderer = _props3.selectionHeaderRenderer,
          hideSelectAll = _props3.hideSelectAll,
          headerColumnStyle = _props3.headerColumnStyle;

      if (hideSelectAll) {
        return _react2.default.createElement('th', { 'data-row-selection': true });
      }

      var checked = checkedStatus === CHECKBOX_STATUS_CHECKED;

      var indeterminate = checkedStatus === CHECKBOX_STATUS_INDETERMINATE;

      var attrs = {};
      var content = void 0;
      if (selectionHeaderRenderer || mode === ROW_SELECT_MULTIPLE) {
        attrs.onClick = this.handleCheckBoxClick;
      }

      attrs.style = _utils2.default.isFunction(headerColumnStyle) ? headerColumnStyle(checkedStatus) : headerColumnStyle;

      return _react2.default.createElement(
        bootstrap.BootstrapContext.Consumer,
        null,
        function (_ref2) {
          var bootstrap4 = _ref2.bootstrap4;

          if (selectionHeaderRenderer) {
            content = selectionHeaderRenderer({
              mode: mode,
              checked: checked,
              indeterminate: indeterminate
            });
          } else if (mode === ROW_SELECT_MULTIPLE) {
            content = _react2.default.createElement(CheckBox, _extends({}, _this2.props, {
              checked: checked,
              className: bootstrap4 ? 'selection-input-4' : '',
              indeterminate: indeterminate
            }));
          }
          return _react2.default.createElement(
            'th',
            _extends({ className: 'selection-cell-header', 'data-row-selection': true }, attrs),
            content
          );
        }
      );
    }
  }]);

  return SelectionHeaderCell;
}(React__default.Component);

SelectionHeaderCell.propTypes = {
  mode: _propTypes2.default.string.isRequired,
  checkedStatus: _propTypes2.default.string,
  onAllRowsSelect: _propTypes2.default.func,
  hideSelectAll: _propTypes2.default.bool,
  selectionHeaderRenderer: _propTypes2.default.func,
  headerColumnStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
};
exports.default = SelectionHeaderCell;
});

unwrapExports(selectionHeaderCell);
var selectionHeaderCell_1 = selectionHeaderCell.CheckBox;

var expandHeaderCell = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/require-default-props: 0 */
/* eslint no-nested-ternary: 0 */


var ExpansionHeaderCell = function (_Component) {
  _inherits(ExpansionHeaderCell, _Component);

  function ExpansionHeaderCell() {
    _classCallCheck(this, ExpansionHeaderCell);

    var _this = _possibleConstructorReturn(this, (ExpansionHeaderCell.__proto__ || Object.getPrototypeOf(ExpansionHeaderCell)).call(this));

    _this.handleCheckBoxClick = _this.handleCheckBoxClick.bind(_this);
    return _this;
  }

  _createClass(ExpansionHeaderCell, [{
    key: 'handleCheckBoxClick',
    value: function handleCheckBoxClick(e) {
      var _props = this.props,
          isAnyExpands = _props.isAnyExpands,
          onAllRowExpand = _props.onAllRowExpand;


      onAllRowExpand(e, !isAnyExpands);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          isAnyExpands = _props2.isAnyExpands,
          expandHeaderColumnRenderer = _props2.expandHeaderColumnRenderer;

      var attrs = {
        onClick: this.handleCheckBoxClick
      };

      return _react2.default.createElement(
        'th',
        _extends({ className: 'expand-cell-header', 'data-row-selection': true }, attrs),
        expandHeaderColumnRenderer ? expandHeaderColumnRenderer({ isAnyExpands: isAnyExpands }) : isAnyExpands ? '(-)' : '(+)'
      );
    }
  }]);

  return ExpansionHeaderCell;
}(React__default.Component);

ExpansionHeaderCell.propTypes = {
  isAnyExpands: _propTypes2.default.bool.isRequired,
  onAllRowExpand: _propTypes2.default.func.isRequired,
  expandHeaderColumnRenderer: _propTypes2.default.func
};
exports.default = ExpansionHeaderCell;
});

unwrapExports(expandHeaderCell);

var rows = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRowByRowId = exports.matchRow = undefined;



var _utils2 = _interopRequireDefault(utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var matchRow = exports.matchRow = function matchRow(keyField, id) {
  return function (row) {
    return _utils2.default.get(row, keyField) === id;
  };
};

var getRowByRowId = exports.getRowByRowId = function getRowByRowId(data, keyField, id) {
  return data.find(matchRow(keyField, id));
};
});

unwrapExports(rows);
var rows_1 = rows.getRowByRowId;
var rows_2 = rows.matchRow;

var selection = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedRows = exports.unSelectableKeys = exports.selectableKeys = exports.getSelectionSummary = undefined;



var _utils2 = _interopRequireDefault(utils);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSelectionSummary = exports.getSelectionSummary = function getSelectionSummary() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var keyField = arguments[1];
  var selected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var allRowsSelected = data.length > 0;
  var allRowsNotSelected = true;

  var rowKeys = data.map(function (d) {
    return _utils2.default.get(d, keyField);
  });

  var _loop = function _loop(i) {
    var curr = rowKeys[i];
    if (typeof selected.find(function (x) {
      return x === curr;
    }) === 'undefined') {
      allRowsSelected = false;
    } else {
      allRowsNotSelected = false;
    }
  };

  for (var i = 0; i < rowKeys.length; i += 1) {
    _loop(i);
  }
  return {
    allRowsSelected: allRowsSelected,
    allRowsNotSelected: allRowsNotSelected
  };
};

var selectableKeys = exports.selectableKeys = function selectableKeys() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var keyField = arguments[1];
  var skips = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (skips.length === 0) {
    return data.map(function (row) {
      return _utils2.default.get(row, keyField);
    });
  }
  return data.filter(function (row) {
    return !_utils2.default.contains(skips, _utils2.default.get(row, keyField));
  }).map(function (row) {
    return _utils2.default.get(row, keyField);
  });
};

var unSelectableKeys = exports.unSelectableKeys = function unSelectableKeys(selected) {
  var skips = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skips.length === 0) {
    return [];
  }
  return selected.filter(function (x) {
    return _utils2.default.contains(skips, x);
  });
};

var getSelectedRows = exports.getSelectedRows = function getSelectedRows() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var keyField = arguments[1];
  var selected = arguments[2];
  return selected.map(function (k) {
    return (0, rows.getRowByRowId)(data, keyField, k);
  }).filter(function (x) {
    return !!x;
  });
};
});

unwrapExports(selection);
var selection_1 = selection.getSelectedRows;
var selection_2 = selection.unSelectableKeys;
var selection_3 = selection.selectableKeys;
var selection_4 = selection.getSelectionSummary;

var expand = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExpandedRows = exports.expandableKeys = exports.isAnyExpands = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var _utils2 = _interopRequireDefault(utils);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAnyExpands = exports.isAnyExpands = function isAnyExpands(data, keyField) {
  var expanded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var _loop = function _loop(i) {
    var rowKey = _utils2.default.get(data[i], keyField);
    if (typeof expanded.find(function (x) {
      return x === rowKey;
    }) !== 'undefined') {
      return {
        v: true
      };
    }
  };

  for (var i = 0; i < data.length; i += 1) {
    var _ret = _loop(i);

    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
  }
  return false;
};

var expandableKeys = exports.expandableKeys = function expandableKeys(data, keyField) {
  var skips = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (skips.length === 0) {
    return data.map(function (row) {
      return _utils2.default.get(row, keyField);
    });
  }
  return data.filter(function (row) {
    return !_utils2.default.contains(skips, _utils2.default.get(row, keyField));
  }).map(function (row) {
    return _utils2.default.get(row, keyField);
  });
};

var getExpandedRows = exports.getExpandedRows = function getExpandedRows(data, keyField, expanded) {
  return expanded.map(function (k) {
    return (0, rows.getRowByRowId)(data, keyField, k);
  });
};
});

unwrapExports(expand);
var expand_1 = expand.getExpandedRows;
var expand_2 = expand.expandableKeys;
var expand_3 = expand.isAnyExpands;

var mutate = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editCell = undefined;



var _utils2 = _interopRequireDefault(utils);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var editCell = exports.editCell = function editCell(data, keyField, rowId, dataField, newValue) {
  var row = (0, rows.getRowByRowId)(data, keyField, rowId);
  if (row) _utils2.default.set(row, dataField, newValue);
};
});

unwrapExports(mutate);
var mutate_1 = mutate.editCell;

var sort_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nextOrder = exports.sort = undefined;



var _utils2 = _interopRequireDefault(utils);



var _const2 = _interopRequireDefault(_const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint no-nested-ternary: 0 */
/* eslint no-lonely-if: 0 */
/* eslint no-underscore-dangle: 0 */


function comparator(a, b) {
  var result = void 0;
  if (typeof b === 'string') {
    result = b.localeCompare(a);
  } else {
    result = a > b ? -1 : a < b ? 1 : 0;
  }
  return result;
}

var sort = exports.sort = function sort(data, sortOrder, _ref) {
  var dataField = _ref.dataField,
      sortFunc = _ref.sortFunc,
      sortValue = _ref.sortValue;

  var _data = [].concat(_toConsumableArray(data));
  _data.sort(function (a, b) {
    var result = void 0;
    var valueA = _utils2.default.get(a, dataField);
    var valueB = _utils2.default.get(b, dataField);
    if (sortValue) {
      valueA = sortValue(valueA, a);
      valueB = sortValue(valueB, b);
    } else {
      valueA = _utils2.default.isDefined(valueA) ? valueA : '';
      valueB = _utils2.default.isDefined(valueB) ? valueB : '';
    }

    if (sortFunc) {
      result = sortFunc(valueA, valueB, sortOrder, dataField, a, b);
    } else {
      if (sortOrder === _const2.default.SORT_DESC) {
        result = comparator(valueA, valueB);
      } else {
        result = comparator(valueB, valueA);
      }
    }
    return result;
  });
  return _data;
};

var nextOrder = exports.nextOrder = function nextOrder(currentSortColumn, _ref2) {
  var sortOrder = _ref2.sortOrder,
      sortColumn = _ref2.sortColumn;
  var defaultOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _const2.default.SORT_DESC;

  if (!sortColumn || currentSortColumn.dataField !== sortColumn.dataField) return defaultOrder;
  return sortOrder === _const2.default.SORT_DESC ? _const2.default.SORT_ASC : _const2.default.SORT_DESC;
};
});

unwrapExports(sort_1);
var sort_2 = sort_1.nextOrder;
var sort_3 = sort_1.sort;

var type = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeConvert = undefined;



var _const2 = _interopRequireDefault(_const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var typeConvert = exports.typeConvert = function typeConvert(type, value) {
  if (type === _const2.default.TYPE_STRING) {
    return String(value);
  } else if (type === _const2.default.TYPE_NUMBER) {
    return Number(value);
  } else if (type === _const2.default.TYPE_BOOLEAN) {
    if (typeof value === 'boolean') {
      return value;
    }
    return value === 'true';
  } else if (type === _const2.default.TYPE_DATE) {
    return new Date(value);
  }
  return value;
};
});

unwrapExports(type);
var type_1 = type.typeConvert;

var operators = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var rows$1 = _interopRequireWildcard(rows);



var selection$1 = _interopRequireWildcard(selection);



var expand$1 = _interopRequireWildcard(expand);



var mutate$1 = _interopRequireWildcard(mutate);



var sort = _interopRequireWildcard(sort_1);



var type$1 = _interopRequireWildcard(type);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = _extends({}, rows$1, selection$1, expand$1, mutate$1, sort, type$1);
});

unwrapExports(operators);

var selectionContext = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _const2 = _interopRequireDefault(_const);



var _utils2 = _interopRequireDefault(utils);



var _operators2 = _interopRequireDefault(operators);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint camelcase: 0 */
/* eslint react/prop-types: 0 */


var SelectionContext = _react2.default.createContext();

var SelectionProvider = function (_React$Component) {
  _inherits(SelectionProvider, _React$Component);

  function SelectionProvider(props) {
    _classCallCheck(this, SelectionProvider);

    var _this = _possibleConstructorReturn(this, (SelectionProvider.__proto__ || Object.getPrototypeOf(SelectionProvider)).call(this, props));

    _this.handleRowSelect = function (rowKey, checked, rowIndex, e) {
      var _this$props = _this.props,
          data = _this$props.data,
          keyField = _this$props.keyField,
          _this$props$selectRow = _this$props.selectRow,
          mode = _this$props$selectRow.mode,
          onSelect = _this$props$selectRow.onSelect;
      var ROW_SELECT_SINGLE = _const2.default.ROW_SELECT_SINGLE;


      var currSelected = [].concat(_toConsumableArray(_this.selected));

      var result = true;
      if (onSelect) {
        var row = _operators2.default.getRowByRowId(data, keyField, rowKey);
        result = onSelect(row, checked, rowIndex, e);
      }

      if (result === true || result === undefined) {
        if (mode === ROW_SELECT_SINGLE) {
          // when select mode is radio
          currSelected = [rowKey];
        } else if (checked) {
          // when select mode is checkbox
          currSelected.push(rowKey);
        } else {
          currSelected = currSelected.filter(function (value) {
            return value !== rowKey;
          });
        }
      }
      _this.selected = currSelected;
      _this.forceUpdate();
    };

    _this.handleAllRowsSelect = function (e, isUnSelect) {
      var _this$props2 = _this.props,
          data = _this$props2.data,
          keyField = _this$props2.keyField,
          _this$props2$selectRo = _this$props2.selectRow,
          onSelectAll = _this$props2$selectRo.onSelectAll,
          nonSelectable = _this$props2$selectRo.nonSelectable;
      var selected = _this.selected;


      var currSelected = void 0;

      if (!isUnSelect) {
        currSelected = selected.concat(_operators2.default.selectableKeys(data, keyField, nonSelectable));
      } else {
        currSelected = selected.filter(function (s) {
          return typeof data.find(function (d) {
            return _utils2.default.get(d, keyField) === s;
          }) === 'undefined';
        });
      }

      var result = void 0;
      if (onSelectAll) {
        result = onSelectAll(!isUnSelect, _operators2.default.getSelectedRows(data, keyField, isUnSelect ? selected : currSelected), e);
        if (Array.isArray(result)) {
          currSelected = result;
        }
      }
      _this.selected = currSelected;
      _this.forceUpdate();
    };

    _this.selected = props.selectRow.selected || [];
    return _this;
  }

  // exposed API


  _createClass(SelectionProvider, [{
    key: 'getSelected',
    value: function getSelected() {
      return this.selected;
    }
  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.selectRow) {
        this.selected = nextProps.selectRow.selected || this.selected;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _getSelectionSummary = (0, selection.getSelectionSummary)(this.props.data, this.props.keyField, this.selected),
          allRowsSelected = _getSelectionSummary.allRowsSelected,
          allRowsNotSelected = _getSelectionSummary.allRowsNotSelected;

      var checkedStatus = void 0;

      // checkbox status depending on selected rows counts
      if (allRowsSelected) checkedStatus = _const2.default.CHECKBOX_STATUS_CHECKED;else if (allRowsNotSelected) checkedStatus = _const2.default.CHECKBOX_STATUS_UNCHECKED;else checkedStatus = _const2.default.CHECKBOX_STATUS_INDETERMINATE;

      return _react2.default.createElement(
        SelectionContext.Provider,
        {
          value: _extends({}, this.props.selectRow, {
            selected: this.selected,
            onRowSelect: this.handleRowSelect,
            onAllRowsSelect: this.handleAllRowsSelect,
            allRowsSelected: allRowsSelected,
            allRowsNotSelected: allRowsNotSelected,
            checkedStatus: checkedStatus
          })
        },
        this.props.children
      );
    }
  }]);

  return SelectionProvider;
}(_react2.default.Component);

SelectionProvider.propTypes = {
  children: _propTypes2.default.node.isRequired,
  data: _propTypes2.default.array.isRequired,
  keyField: _propTypes2.default.string.isRequired
};
exports.default = {
  Provider: SelectionProvider,
  Consumer: SelectionContext.Consumer
};
});

unwrapExports(selectionContext);

var selectionHeaderCellConsumer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _selectionContext2 = _interopRequireDefault(selectionContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Component) {
  return function () {
    return _react2.default.createElement(
      _selectionContext2.default.Consumer,
      null,
      function (selectRow) {
        return _react2.default.createElement(Component, selectRow);
      }
    );
  };
};
});

unwrapExports(selectionHeaderCellConsumer);

var rowExpandContext = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _operators2 = _interopRequireDefault(operators);



var _utils2 = _interopRequireDefault(utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint camelcase: 0 */
/* eslint react/prop-types: 0 */


var RowExpandContext = _react2.default.createContext();

var RowExpandProvider = function (_React$Component) {
  _inherits(RowExpandProvider, _React$Component);

  function RowExpandProvider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RowExpandProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RowExpandProvider.__proto__ || Object.getPrototypeOf(RowExpandProvider)).call.apply(_ref, [this].concat(args))), _this), _this.state = { expanded: _this.props.expandRow.expanded || [],
      isClosing: _this.props.expandRow.isClosing || [] }, _this.onClosed = function (closedRow) {
      _this.setState({ isClosing: _this.state.isClosing.filter(function (value) {
          return value !== closedRow;
        }) });
    }, _this.handleRowExpand = function (rowKey, expanded, rowIndex, e) {
      var _this$props = _this.props,
          data = _this$props.data,
          keyField = _this$props.keyField,
          _this$props$expandRow = _this$props.expandRow,
          onExpand = _this$props$expandRow.onExpand,
          onlyOneExpanding = _this$props$expandRow.onlyOneExpanding,
          nonExpandable = _this$props$expandRow.nonExpandable;

      if (nonExpandable && _utils2.default.contains(nonExpandable, rowKey)) {
        return;
      }

      var currExpanded = [].concat(_toConsumableArray(_this.state.expanded));
      var isClosing = [].concat(_toConsumableArray(_this.state.isClosing));

      if (expanded) {
        if (onlyOneExpanding) {
          isClosing = isClosing.concat(currExpanded);
          currExpanded = [rowKey];
        } else currExpanded.push(rowKey);
      } else {
        isClosing.push(rowKey);
        currExpanded = currExpanded.filter(function (value) {
          return value !== rowKey;
        });
      }

      if (onExpand) {
        var row = _operators2.default.getRowByRowId(data, keyField, rowKey);
        onExpand(row, expanded, rowIndex, e);
      }
      _this.setState(function () {
        return { expanded: currExpanded, isClosing: isClosing };
      });
    }, _this.handleAllRowExpand = function (e, expandAll) {
      var _this$props2 = _this.props,
          data = _this$props2.data,
          keyField = _this$props2.keyField,
          _this$props2$expandRo = _this$props2.expandRow,
          onExpandAll = _this$props2$expandRo.onExpandAll,
          nonExpandable = _this$props2$expandRo.nonExpandable;
      var expanded = _this.state.expanded;


      var currExpanded = void 0;

      if (expandAll) {
        currExpanded = expanded.concat(_operators2.default.expandableKeys(data, keyField, nonExpandable));
      } else {
        currExpanded = expanded.filter(function (s) {
          return typeof data.find(function (d) {
            return _utils2.default.get(d, keyField) === s;
          }) === 'undefined';
        });
      }

      if (onExpandAll) {
        onExpandAll(expandAll, _operators2.default.getExpandedRows(data, keyField, currExpanded), e);
      }

      _this.setState(function () {
        return { expanded: currExpanded };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RowExpandProvider, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.expandRow) {
        var nextExpanded = [].concat(_toConsumableArray(nextProps.expandRow.expanded || this.state.expanded));
        var _nextProps$expandRow$ = nextProps.expandRow.nonExpandable,
            nonExpandable = _nextProps$expandRow$ === undefined ? [] : _nextProps$expandRow$;

        nextExpanded = nextExpanded.filter(function (rowId) {
          return !_utils2.default.contains(nonExpandable, rowId);
        });
        var isClosing = this.state.expanded.reduce(function (acc, cur) {
          if (!_utils2.default.contains(nextExpanded, cur)) {
            acc.push(cur);
          }
          return acc;
        }, []);

        this.setState(function () {
          return {
            expanded: nextExpanded,
            isClosing: isClosing
          };
        });
      } else {
        this.setState(function () {
          return {
            expanded: _this2.state.expanded
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          keyField = _props.keyField;

      return _react2.default.createElement(
        RowExpandContext.Provider,
        {
          value: _extends({}, this.props.expandRow, {
            nonExpandable: this.props.expandRow.nonExpandable,
            expanded: this.state.expanded,
            isClosing: this.state.isClosing,
            onClosed: this.onClosed,
            isAnyExpands: _operators2.default.isAnyExpands(data, keyField, this.state.expanded),
            onRowExpand: this.handleRowExpand,
            onAllRowExpand: this.handleAllRowExpand
          })
        },
        this.props.children
      );
    }
  }]);

  return RowExpandProvider;
}(_react2.default.Component);

RowExpandProvider.propTypes = {
  children: _propTypes2.default.node.isRequired,
  data: _propTypes2.default.array.isRequired,
  keyField: _propTypes2.default.string.isRequired
};
exports.default = {
  Provider: RowExpandProvider,
  Consumer: RowExpandContext.Consumer
};
});

unwrapExports(rowExpandContext);

var expandHeaderCellConsumer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _rowExpandContext2 = _interopRequireDefault(rowExpandContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Component) {
  return function () {
    return _react2.default.createElement(
      _rowExpandContext2.default.Consumer,
      null,
      function (expandRow) {
        return _react2.default.createElement(Component, expandRow);
      }
    );
  };
};
});

unwrapExports(expandHeaderCellConsumer);

var header = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _headerCell2 = _interopRequireDefault(headerCell);



var _selectionHeaderCell2 = _interopRequireDefault(selectionHeaderCell);



var _expandHeaderCell2 = _interopRequireDefault(expandHeaderCell);



var _selectionHeaderCellConsumer2 = _interopRequireDefault(selectionHeaderCellConsumer);



var _expandHeaderCellConsumer2 = _interopRequireDefault(expandHeaderCellConsumer);



var _const2 = _interopRequireDefault(_const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint react/require-default-props: 0 */
var Header = function Header(props) {
  var className = props.className,
      columns = props.columns,
      onSort = props.onSort,
      onFilter = props.onFilter,
      sortField = props.sortField,
      sortOrder = props.sortOrder,
      selectRow = props.selectRow,
      expandRow = props.expandRow,
      currFilters = props.currFilters,
      onExternalFilter = props.onExternalFilter,
      filterPosition = props.filterPosition,
      globalSortCaret = props.globalSortCaret,
      wrapperClasses = props.wrapperClasses;


  var SelectionHeaderCellComp = function SelectionHeaderCellComp() {
    return null;
  };
  var ExpansionHeaderCellComp = function ExpansionHeaderCellComp() {
    return null;
  };

  if (expandRow.showExpandColumn) {
    ExpansionHeaderCellComp = (0, _expandHeaderCellConsumer2.default)(_expandHeaderCell2.default);
  }

  if (selectRow) {
    SelectionHeaderCellComp = (0, _selectionHeaderCellConsumer2.default)(_selectionHeaderCell2.default);
  }

  var isRenderFunctionColumnInLeft = function isRenderFunctionColumnInLeft() {
    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _const2.default.INDICATOR_POSITION_LEFT;
    return position === _const2.default.INDICATOR_POSITION_LEFT;
  };

  var childrens = [columns.map(function (column, i) {
    var currSort = column.dataField === sortField;
    var isLastSorting = column.dataField === sortField;

    return _react2.default.createElement(_headerCell2.default, {
      index: i,
      key: column.dataField,
      column: column,
      onSort: onSort,
      sorting: currSort,
      sortOrder: sortOrder,
      globalSortCaret: globalSortCaret,
      isLastSorting: isLastSorting,
      onFilter: onFilter,
      currFilters: currFilters,
      onExternalFilter: onExternalFilter,
      filterPosition: filterPosition
    });
  })];

  if (!selectRow.hideSelectColumn) {
    if (isRenderFunctionColumnInLeft(selectRow.selectColumnPosition)) {
      childrens.unshift(_react2.default.createElement(SelectionHeaderCellComp, { key: 'selection' }));
    } else {
      childrens.push(_react2.default.createElement(SelectionHeaderCellComp, { key: 'selection' }));
    }
  }

  if (expandRow.showExpandColumn) {
    if (isRenderFunctionColumnInLeft(expandRow.expandColumnPosition)) {
      childrens.unshift(_react2.default.createElement(ExpansionHeaderCellComp, { key: 'expansion' }));
    } else {
      childrens.push(_react2.default.createElement(ExpansionHeaderCellComp, { key: 'expansion' }));
    }
  }

  return _react2.default.createElement(
    'thead',
    { className: wrapperClasses },
    _react2.default.createElement(
      'tr',
      { className: className },
      childrens
    )
  );
};

Header.propTypes = {
  columns: _propTypes2.default.array.isRequired,
  onSort: _propTypes2.default.func,
  onFilter: _propTypes2.default.func,
  sortField: _propTypes2.default.string,
  sortOrder: _propTypes2.default.string,
  selectRow: _propTypes2.default.object,
  currFilters: _propTypes2.default.object,
  onExternalFilter: _propTypes2.default.func,
  globalSortCaret: _propTypes2.default.func,
  className: _propTypes2.default.string,
  wrapperClasses: _propTypes2.default.string,
  expandRow: _propTypes2.default.object,
  filterPosition: _propTypes2.default.oneOf([_const2.default.FILTERS_POSITION_TOP, _const2.default.FILTERS_POSITION_INLINE, _const2.default.FILTERS_POSITION_BOTTOM])
};

exports.default = Header;
});

unwrapExports(header);

var filtersCell = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _utils2 = _interopRequireDefault(utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FiltersCell = function FiltersCell(props) {
  var index = props.index,
      column = props.column,
      onExternalFilter = props.onExternalFilter,
      currFilters = props.currFilters,
      onFilter = props.onFilter;
  var filterRenderer = column.filterRenderer,
      filter = column.filter;

  var filterElm = void 0;
  var cellAttrs = {};
  var cellStyle = {};
  cellAttrs.style = cellStyle;
  if (column.headerAlign) {
    cellStyle.textAlign = _utils2.default.isFunction(column.headerAlign) ? column.headerAlign(column, index) : column.headerAlign;
  }
  if (column.filterRenderer) {
    var onCustomFilter = onExternalFilter(column, filter.props.type);
    filterElm = filterRenderer(onCustomFilter, column);
  } else if (filter) {
    filterElm = _react2.default.createElement(filter.Filter, _extends({}, filter.props, {
      filterState: currFilters[column.dataField],
      onFilter: onFilter,
      column: column
    }));
  }
  return _react2.default.createElement('th', cellAttrs, filterElm);
};

FiltersCell.propTypes = {
  index: _propTypes2.default.number.isRequired,
  column: _propTypes2.default.object.isRequired,
  currFilters: _propTypes2.default.object.isRequired,
  onFilter: _propTypes2.default.func,
  onExternalFilter: _propTypes2.default.func
};

FiltersCell.defaultProps = {
  onFilter: function onFilter() {},
  onExternalFilter: function onExternalFilter() {}
};

exports.default = FiltersCell;
});

unwrapExports(filtersCell);

var rowTemplate = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _const2 = _interopRequireDefault(_const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint react/require-default-props: 0 */


var RowTemplate = function RowTemplate(props) {
  var renderContent = props.renderContent,
      selectRow = props.selectRow,
      expandRow = props.expandRow,
      cellEl = props.cellEl,
      rest = _objectWithoutProperties(props, ['renderContent', 'selectRow', 'expandRow', 'cellEl']);

  var isRenderFunctionColumnInLeft = function isRenderFunctionColumnInLeft() {
    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _const2.default.INDICATOR_POSITION_LEFT;
    return position === _const2.default.INDICATOR_POSITION_LEFT;
  };

  var childrens = renderContent() || [];

  if (selectRow && selectRow.hideSelectColumn !== true) {
    if (isRenderFunctionColumnInLeft(selectRow.selectColumnPosition)) {
      childrens.unshift(_react2.default.createElement(cellEl, { key: 'selection' }));
    } else {
      childrens.push(_react2.default.createElement(cellEl, { key: 'selection' }));
    }
  }

  if (expandRow.showExpandColumn) {
    if (isRenderFunctionColumnInLeft(expandRow.expandColumnPosition)) {
      childrens.unshift(_react2.default.createElement(cellEl, { key: 'expansion' }));
    } else {
      childrens.push(_react2.default.createElement(cellEl, { key: 'expansion' }));
    }
  }

  return _react2.default.createElement(
    'tr',
    rest,
    childrens
  );
};

RowTemplate.propTypes = {
  renderContent: _propTypes2.default.func.isRequired,
  cellEl: _propTypes2.default.string.isRequired,
  selectRow: _propTypes2.default.object,
  expandRow: _propTypes2.default.object
};

exports.default = RowTemplate;
});

unwrapExports(rowTemplate);

var filters = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _filtersCell2 = _interopRequireDefault(filtersCell);



var _const2 = _interopRequireDefault(_const);



var _rowTemplate2 = _interopRequireDefault(rowTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Filters = function Filters(props) {
  var columns = props.columns,
      onFilter = props.onFilter,
      currFilters = props.currFilters,
      filterPosition = props.filterPosition,
      onExternalFilter = props.onExternalFilter,
      className = props.className,
      selectRow = props.selectRow,
      expandRow = props.expandRow;


  function renderContent() {
    var filterColumns = [];

    columns.forEach(function (column, i) {
      filterColumns.push(_react2.default.createElement(_filtersCell2.default, {
        index: i,
        key: column.dataField,
        column: column,
        currFilters: currFilters,
        onExternalFilter: onExternalFilter,
        onFilter: onFilter
      }));

      if (column.filterRenderer || column.filter) ;
    });
    return filterColumns;
  }

  return _react2.default.createElement(
    'tbody',
    {
      className: className,
      style: {
        display: filterPosition === _const2.default.FILTERS_POSITION_TOP ? 'table-header-group' : 'table-footer-group'
      }
    },
    _react2.default.createElement(_rowTemplate2.default, {
      renderContent: renderContent,
      selectRow: selectRow,
      expandRow: expandRow,
      cellEl: 'td'
    })
  );
}; /* eslint react/require-default-props: 0 */


Filters.propTypes = {
  columns: _propTypes2.default.array.isRequired,
  onFilter: _propTypes2.default.func,
  filterPosition: _propTypes2.default.oneOf([_const2.default.FILTERS_POSITION_TOP, _const2.default.FILTERS_POSITION_INLINE, _const2.default.FILTERS_POSITION_BOTTOM]),
  currFilters: _propTypes2.default.object,
  onExternalFilter: _propTypes2.default.func,
  className: _propTypes2.default.string,
  selectRow: _propTypes2.default.object,
  expandRow: _propTypes2.default.object
};

Filters.defaultProps = {
  position: _const2.default.FILTERS_POSITION_TOP
};

exports.default = Filters;
});

unwrapExports(filters);

var caption = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint react/require-default-props: 0 */
var Caption = function Caption(props) {
  if (!props.children) return null;

  var caption = props.bootstrap4 ? _react2.default.createElement(
    'caption',
    { style: { captionSide: 'top' } },
    props.children
  ) : _react2.default.createElement(
    'caption',
    null,
    props.children
  );

  return caption;
};

Caption.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  bootstrap4: _propTypes2.default.bool
};

exports.default = Caption;
});

unwrapExports(caption);

var cell = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _cellEventDelegater2 = _interopRequireDefault(cellEventDelegater);



var _utils2 = _interopRequireDefault(utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var Cell = function (_eventDelegater) {
  _inherits(Cell, _eventDelegater);

  function Cell(props) {
    _classCallCheck(this, Cell);

    var _this = _possibleConstructorReturn(this, (Cell.__proto__ || Object.getPrototypeOf(Cell)).call(this, props));

    _this.createHandleEditingCell = function (originFunc) {
      return function (e) {
        var _this$props = _this.props,
            onStart = _this$props.onStart,
            rowIndex = _this$props.rowIndex,
            columnIndex = _this$props.columnIndex,
            clickToEdit = _this$props.clickToEdit,
            dbclickToEdit = _this$props.dbclickToEdit;

        if ((clickToEdit || dbclickToEdit) && _utils2.default.isFunction(originFunc)) {
          originFunc(e);
        }
        if (onStart) {
          onStart(rowIndex, columnIndex);
        }
      };
    };

    _this.createHandleEditingCell = _this.createHandleEditingCell.bind(_this);
    return _this;
  }

  _createClass(Cell, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var shouldUpdate = false;
      if (nextProps.column.isDummyField) {
        shouldUpdate = !_utils2.default.isEqual(this.props.row, nextProps.row);
      } else {
        shouldUpdate = _utils2.default.get(this.props.row, this.props.column.dataField) !== _utils2.default.get(nextProps.row, nextProps.column.dataField);
      }

      if (shouldUpdate) return true;

      // if (nextProps.formatter)

      shouldUpdate = (nextProps.column.formatter ? !_utils2.default.isEqual(this.props.row, nextProps.row) : false) || this.props.column.hidden !== nextProps.column.hidden || this.props.column.isDummyField !== nextProps.column.isDummyField || this.props.rowIndex !== nextProps.rowIndex || this.props.columnIndex !== nextProps.columnIndex || this.props.className !== nextProps.className || this.props.title !== nextProps.title || this.props.editable !== nextProps.editable || this.props.clickToEdit !== nextProps.clickToEdit || this.props.dbclickToEdit !== nextProps.dbclickToEdit || !_utils2.default.isEqual(this.props.style, nextProps.style) || !_utils2.default.isEqual(this.props.column.formatExtraData, nextProps.column.formatExtraData) || !_utils2.default.isEqual(this.props.column.events, nextProps.column.events) || !_utils2.default.isEqual(this.props.column.attrs, nextProps.column.attrs) || this.props.tabIndex !== nextProps.tabIndex;
      return shouldUpdate;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          row = _props.row,
          rowIndex = _props.rowIndex,
          column = _props.column,
          columnIndex = _props.columnIndex,
          onStart = _props.onStart,
          editable = _props.editable,
          clickToEdit = _props.clickToEdit,
          dbclickToEdit = _props.dbclickToEdit,
          rest = _objectWithoutProperties(_props, ['row', 'rowIndex', 'column', 'columnIndex', 'onStart', 'editable', 'clickToEdit', 'dbclickToEdit']);

      var dataField = column.dataField,
          formatter = column.formatter,
          formatExtraData = column.formatExtraData;

      var attrs = this.delegate(_extends({}, rest));
      var content = column.isDummyField ? null : _utils2.default.get(row, dataField);

      if (formatter) {
        content = column.formatter(content, row, rowIndex, formatExtraData);
      }

      if (clickToEdit && editable) {
        attrs.onClick = this.createHandleEditingCell(attrs.onClick);
      } else if (dbclickToEdit && editable) {
        attrs.onDoubleClick = this.createHandleEditingCell(attrs.onDoubleClick);
      }

      return _react2.default.createElement(
        'td',
        attrs,
        typeof content === 'boolean' ? '' + content : content
      );
    }
  }]);

  return Cell;
}((0, _cellEventDelegater2.default)(React__default.Component));

Cell.propTypes = {
  row: _propTypes2.default.object.isRequired,
  rowIndex: _propTypes2.default.number.isRequired,
  column: _propTypes2.default.object.isRequired,
  columnIndex: _propTypes2.default.number.isRequired
};

exports.default = Cell;
});

unwrapExports(cell);

var rowPureContent = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _utils2 = _interopRequireDefault(utils);



var _cell2 = _interopRequireDefault(cell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
/* eslint react/no-array-index-key: 0 */
/* eslint no-plusplus: 0 */


var RowPureContent = function (_React$Component) {
  _inherits(RowPureContent, _React$Component);

  function RowPureContent() {
    _classCallCheck(this, RowPureContent);

    return _possibleConstructorReturn(this, (RowPureContent.__proto__ || Object.getPrototypeOf(RowPureContent)).apply(this, arguments));
  }

  _createClass(RowPureContent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (typeof nextProps.shouldUpdate !== 'undefined') {
        return nextProps.shouldUpdate;
      }
      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          row = _props.row,
          keyField = _props.keyField,
          columns = _props.columns,
          rowIndex = _props.rowIndex,
          editable = _props.editable,
          editingRowIdx = _props.editingRowIdx,
          editingColIdx = _props.editingColIdx,
          onStart = _props.onStart,
          clickToEdit = _props.clickToEdit,
          dbclickToEdit = _props.dbclickToEdit,
          EditingCellComponent = _props.EditingCellComponent,
          tabIndexStart = _props.tabIndexStart;


      var tabIndex = tabIndexStart;

      return columns.map(function (column, index) {
        var dataField = column.dataField;

        var content = _utils2.default.get(row, dataField);
        if (rowIndex === editingRowIdx && index === editingColIdx) {
          return _react2.default.createElement(EditingCellComponent, {
            key: content + '-' + index + '-editing',
            row: row,
            rowIndex: rowIndex,
            column: column,
            columnIndex: index
          });
        }
        // render cell
        var cellTitle = void 0;
        var cellStyle = {};
        var cellAttrs = _extends({}, _utils2.default.isFunction(column.attrs) ? column.attrs(content, row, rowIndex, index) : column.attrs);

        if (column.events) {
          var events = Object.assign({}, column.events);
          Object.keys(Object.assign({}, column.events)).forEach(function (key) {
            var originFn = events[key];
            events[key] = function () {
              for (var _len = arguments.length, rest = Array(_len), _key = 0; _key < _len; _key++) {
                rest[_key] = arguments[_key];
              }

              return originFn.apply(undefined, rest.concat([row, rowIndex]));
            };
          });
          cellAttrs = _extends({}, cellAttrs, events);
        }

        var cellClasses = _utils2.default.isFunction(column.classes) ? column.classes(content, row, rowIndex, index) : column.classes;

        if (column.style) {
          cellStyle = _utils2.default.isFunction(column.style) ? column.style(content, row, rowIndex, index) : column.style;
          cellStyle = Object.assign({}, cellStyle) || {};
        }

        if (column.title) {
          cellTitle = _utils2.default.isFunction(column.title) ? column.title(content, row, rowIndex, index) : content;
          cellAttrs.title = cellTitle;
        }

        if (column.align) {
          cellStyle.textAlign = _utils2.default.isFunction(column.align) ? column.align(content, row, rowIndex, index) : column.align;
        }

        if (cellClasses) cellAttrs.className = cellClasses;
        if (!_utils2.default.isEmptyObject(cellStyle)) cellAttrs.style = cellStyle;

        var editableCell = _utils2.default.isDefined(column.editable) ? column.editable : true;
        if (column.dataField === keyField || !editable) editableCell = false;
        if (_utils2.default.isFunction(column.editable)) {
          editableCell = column.editable(content, row, rowIndex, index);
        }

        if (tabIndexStart !== -1) {
          cellAttrs.tabIndex = tabIndex++;
        }

        return _react2.default.createElement(_cell2.default, _extends({
          key: content + '-' + index,
          row: row,
          editable: editableCell,
          rowIndex: rowIndex,
          columnIndex: index,
          column: column,
          onStart: onStart,
          clickToEdit: clickToEdit,
          dbclickToEdit: dbclickToEdit
        }, cellAttrs));
      });
    }
  }]);

  return RowPureContent;
}(_react2.default.Component);

exports.default = RowPureContent;
});

unwrapExports(rowPureContent);

var eventDelegater = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _utils2 = _interopRequireDefault(utils);



var _const2 = _interopRequireDefault(_const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = ['onClick', 'onDoubleClick', 'onMouseEnter', 'onMouseLeave', 'onContextMenu', 'onAuxClick'];

exports.default = function (ExtendBase) {
  return function (_ExtendBase) {
    _inherits(RowEventDelegater, _ExtendBase);

    function RowEventDelegater(props) {
      _classCallCheck(this, RowEventDelegater);

      var _this = _possibleConstructorReturn(this, (RowEventDelegater.__proto__ || Object.getPrototypeOf(RowEventDelegater)).call(this, props));

      _this.clickNum = 0;
      _this.createDefaultEventHandler = _this.createDefaultEventHandler.bind(_this);
      _this.createClickEventHandler = _this.createClickEventHandler.bind(_this);
      return _this;
    }

    _createClass(RowEventDelegater, [{
      key: 'createClickEventHandler',
      value: function createClickEventHandler(cb) {
        var _this2 = this;

        return function (e) {
          var _props = _this2.props,
              row = _props.row,
              selected = _props.selected,
              keyField = _props.keyField,
              selectable = _props.selectable,
              expandable = _props.expandable,
              rowIndex = _props.rowIndex,
              expanded = _props.expanded,
              expandRow = _props.expandRow,
              selectRow = _props.selectRow,
              DELAY_FOR_DBCLICK = _props.DELAY_FOR_DBCLICK;

          var clickFn = function clickFn() {
            if (cb) {
              cb(e, row, rowIndex);
            }
            var key = _utils2.default.get(row, keyField);
            if (expandRow && expandable && !expandRow.expandByColumnOnly) {
              if (selectRow.mode !== _const2.default.ROW_SELECT_DISABLED && selectRow.clickToExpand || selectRow.mode === _const2.default.ROW_SELECT_DISABLED) {
                expandRow.onRowExpand(key, !expanded, rowIndex, e);
              }
            }
            if (selectRow.clickToSelect && selectable) {
              selectRow.onRowSelect(key, !selected, rowIndex, e);
            }
          };

          if (DELAY_FOR_DBCLICK) {
            _this2.clickNum += 1;
            _utils2.default.debounce(function () {
              if (_this2.clickNum === 1) {
                clickFn();
              }
              _this2.clickNum = 0;
            }, DELAY_FOR_DBCLICK)();
          } else {
            clickFn();
          }
        };
      }
    }, {
      key: 'createDefaultEventHandler',
      value: function createDefaultEventHandler(cb) {
        var _this3 = this;

        return function (e) {
          var _props2 = _this3.props,
              row = _props2.row,
              rowIndex = _props2.rowIndex;

          cb(e, row, rowIndex);
        };
      }
    }, {
      key: 'delegate',
      value: function delegate() {
        var _this4 = this;

        var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var newAttrs = _extends({}, attrs);
        Object.keys(attrs).forEach(function (attr) {
          if (_utils2.default.contains(events, attr)) {
            newAttrs[attr] = _this4.createDefaultEventHandler(attrs[attr]);
          }
        });
        return newAttrs;
      }
    }]);

    return RowEventDelegater;
  }(ExtendBase);
};
});

unwrapExports(eventDelegater);

var shouldUpdater = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _utils2 = _interopRequireDefault(utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


exports.default = function (ExtendBase) {
  return function (_ExtendBase) {
    _inherits(RowShouldUpdater, _ExtendBase);

    function RowShouldUpdater() {
      _classCallCheck(this, RowShouldUpdater);

      return _possibleConstructorReturn(this, (RowShouldUpdater.__proto__ || Object.getPrototypeOf(RowShouldUpdater)).apply(this, arguments));
    }

    _createClass(RowShouldUpdater, [{
      key: 'shouldUpdateByCellEditing',
      value: function shouldUpdateByCellEditing(nextProps) {
        if (!(this.props.clickToEdit || this.props.dbclickToEdit)) return false;
        return nextProps.editingRowIdx === nextProps.rowIndex || this.props.editingRowIdx === nextProps.rowIndex && nextProps.editingRowIdx === null || this.props.editingRowIdx === nextProps.rowIndex;
      }
    }, {
      key: 'shouldUpdatedBySelfProps',
      value: function shouldUpdatedBySelfProps(nextProps) {
        return this.props.className !== nextProps.className || !_utils2.default.isEqual(this.props.style, nextProps.style) || !_utils2.default.isEqual(this.props.attrs, nextProps.attrs);
      }

      // Only use for simple-row

    }, {
      key: 'shouldUpdateByColumnsForSimpleCheck',
      value: function shouldUpdateByColumnsForSimpleCheck(nextProps) {
        if (this.props.columns.length !== nextProps.columns.length) {
          return true;
        }
        for (var i = 0; i < this.props.columns.length; i += 1) {
          if (!_utils2.default.isEqual(this.props.columns[i], nextProps.columns[i])) {
            return true;
          }
        }
        return false;
      }
    }, {
      key: 'shouldUpdatedByNormalProps',
      value: function shouldUpdatedByNormalProps(nextProps) {
        var shouldUpdate = this.props.rowIndex !== nextProps.rowIndex || this.props.editable !== nextProps.editable || !_utils2.default.isEqual(this.props.row, nextProps.row) || this.props.columns.length !== nextProps.columns.length;

        return shouldUpdate;
      }
    }, {
      key: 'shouldUpdateChild',
      value: function shouldUpdateChild(nextProps) {
        return this.shouldUpdateByCellEditing(nextProps) || this.shouldUpdatedByNormalProps(nextProps);
      }
    }, {
      key: 'shouldRowContentUpdate',
      value: function shouldRowContentUpdate(nextProps) {
        return this.shouldUpdateChild(nextProps) || this.shouldUpdateByColumnsForSimpleCheck(nextProps);
      }
    }]);

    return RowShouldUpdater;
  }(ExtendBase);
};
});

unwrapExports(shouldUpdater);

var simpleRow = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _rowPureContent2 = _interopRequireDefault(rowPureContent);



var _eventDelegater2 = _interopRequireDefault(eventDelegater);



var _shouldUpdater3 = _interopRequireDefault(shouldUpdater);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
/* eslint react/no-array-index-key: 0 */


var SimpleRow = function (_shouldUpdater) {
  _inherits(SimpleRow, _shouldUpdater);

  function SimpleRow(props) {
    _classCallCheck(this, SimpleRow);

    var _this = _possibleConstructorReturn(this, (SimpleRow.__proto__ || Object.getPrototypeOf(SimpleRow)).call(this, props));

    _this.shouldUpdateRowContent = false;
    return _this;
  }

  _createClass(SimpleRow, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      this.shouldUpdateRowContent = false;
      this.shouldUpdateRowContent = this.shouldRowContentUpdate(nextProps);
      if (this.shouldUpdateRowContent) return true;

      return this.shouldUpdatedBySelfProps(nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          attrs = _props.attrs,
          visibleColumnSize = _props.visibleColumnSize,
          tabIndexCell = _props.tabIndexCell,
          rest = _objectWithoutProperties(_props, ['className', 'style', 'attrs', 'visibleColumnSize', 'tabIndexCell']);

      var trAttrs = this.delegate(attrs);
      var tabIndexStart = this.props.rowIndex * visibleColumnSize + 1;

      return _react2.default.createElement(
        'tr',
        _extends({ style: style, className: className }, trAttrs),
        _react2.default.createElement(_rowPureContent2.default, _extends({
          shouldUpdate: this.shouldUpdateRowContent,
          tabIndexStart: tabIndexCell ? tabIndexStart : -1
        }, rest))
      );
    }
  }]);

  return SimpleRow;
}((0, _shouldUpdater3.default)((0, _eventDelegater2.default)(React__default.Component)));

SimpleRow.propTypes = {
  row: _propTypes2.default.object.isRequired,
  rowIndex: _propTypes2.default.number.isRequired,
  columns: _propTypes2.default.array.isRequired,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  attrs: _propTypes2.default.object
};

SimpleRow.defaultProps = {
  editable: true,
  style: {},
  className: null,
  attrs: {}
};

exports.default = SimpleRow;
});

unwrapExports(simpleRow);

var expandCell = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 react/require-default-props: 0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 jsx-a11y/no-noninteractive-element-interactions: 0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
/* eslint no-nested-ternary: 0 */


var ExpandCell = function (_Component) {
  _inherits(ExpandCell, _Component);

  function ExpandCell() {
    _classCallCheck(this, ExpandCell);

    var _this = _possibleConstructorReturn(this, (ExpandCell.__proto__ || Object.getPrototypeOf(ExpandCell)).call(this));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(ExpandCell, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var shouldUpdate = this.props.rowIndex !== nextProps.rowIndex || this.props.expanded !== nextProps.expanded || this.props.rowKey !== nextProps.rowKey || this.props.tabIndex !== nextProps.tabIndex;

      return shouldUpdate;
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      var _props = this.props,
          rowKey = _props.rowKey,
          expanded = _props.expanded,
          onRowExpand = _props.onRowExpand,
          rowIndex = _props.rowIndex;

      e.stopPropagation();
      onRowExpand(rowKey, !expanded, rowIndex, e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          expanded = _props2.expanded,
          expandable = _props2.expandable,
          expandColumnRenderer = _props2.expandColumnRenderer,
          tabIndex = _props2.tabIndex,
          rowKey = _props2.rowKey;

      var attrs = {};
      if (tabIndex !== -1) attrs.tabIndex = tabIndex;

      return _react2.default.createElement(
        'td',
        _extends({ className: 'expand-cell', onClick: this.handleClick }, attrs),
        expandColumnRenderer ? expandColumnRenderer({
          expandable: expandable,
          expanded: expanded,
          rowKey: rowKey
        }) : expandable ? expanded ? '(-)' : '(+)' : ''
      );
    }
  }]);

  return ExpandCell;
}(React__default.Component);

ExpandCell.propTypes = {
  rowKey: _propTypes2.default.any,
  expanded: _propTypes2.default.bool.isRequired,
  expandable: _propTypes2.default.bool.isRequired,
  onRowExpand: _propTypes2.default.func.isRequired,
  expandColumnRenderer: _propTypes2.default.func,
  rowIndex: _propTypes2.default.number,
  tabIndex: _propTypes2.default.number
};
exports.default = ExpandCell;
});

unwrapExports(expandCell);

var selectionCell = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _const2 = _interopRequireDefault(_const);



var _utils2 = _interopRequireDefault(utils);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 react/require-default-props: 0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 jsx-a11y/no-noninteractive-element-interactions: 0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */


var SelectionCell = function (_Component) {
  _inherits(SelectionCell, _Component);

  function SelectionCell() {
    _classCallCheck(this, SelectionCell);

    var _this = _possibleConstructorReturn(this, (SelectionCell.__proto__ || Object.getPrototypeOf(SelectionCell)).call(this));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(SelectionCell, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var shouldUpdate = this.props.rowIndex !== nextProps.rowIndex || this.props.selected !== nextProps.selected || this.props.disabled !== nextProps.disabled || this.props.rowKey !== nextProps.rowKey || this.props.tabIndex !== nextProps.tabIndex || this.props.selectColumnStyle !== nextProps.selectColumnStyle;

      return shouldUpdate;
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      var _props = this.props,
          inputType = _props.mode,
          rowKey = _props.rowKey,
          selected = _props.selected,
          onRowSelect = _props.onRowSelect,
          disabled = _props.disabled,
          rowIndex = _props.rowIndex;

      e.stopPropagation();
      if (disabled) return;

      var checked = inputType === _const2.default.ROW_SELECT_SINGLE ? true : !selected;

      onRowSelect(rowKey, checked, rowIndex, e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          rowKey = _props2.rowKey,
          inputType = _props2.mode,
          selected = _props2.selected,
          disabled = _props2.disabled,
          tabIndex = _props2.tabIndex,
          rowIndex = _props2.rowIndex,
          selectionRenderer = _props2.selectionRenderer,
          selectColumnStyle = _props2.selectColumnStyle;


      var attrs = {};
      if (tabIndex !== -1) attrs.tabIndex = tabIndex;

      attrs.style = _utils2.default.isFunction(selectColumnStyle) ? selectColumnStyle({
        checked: selected,
        disabled: disabled,
        rowIndex: rowIndex,
        rowKey: rowKey
      }) : selectColumnStyle;

      return _react2.default.createElement(
        bootstrap.BootstrapContext.Consumer,
        null,
        function (_ref) {
          var bootstrap4 = _ref.bootstrap4;
          return _react2.default.createElement(
            'td',
            _extends({ className: 'selection-cell', onClick: _this2.handleClick }, attrs),
            selectionRenderer ? selectionRenderer({
              mode: inputType,
              checked: selected,
              disabled: disabled,
              rowIndex: rowIndex,
              rowKey: rowKey
            }) : _react2.default.createElement('input', {
              type: inputType,
              checked: selected,
              disabled: disabled,
              className: bootstrap4 ? 'selection-input-4' : '',
              onChange: function onChange() {}
            })
          );
        }
      );
    }
  }]);

  return SelectionCell;
}(React__default.Component);

SelectionCell.propTypes = {
  mode: _propTypes2.default.string.isRequired,
  rowKey: _propTypes2.default.any,
  selected: _propTypes2.default.bool,
  onRowSelect: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,
  rowIndex: _propTypes2.default.number,
  tabIndex: _propTypes2.default.number,
  clickToSelect: _propTypes2.default.bool,
  selectionRenderer: _propTypes2.default.func,
  selectColumnStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
};
exports.default = SelectionCell;
});

unwrapExports(selectionCell);

var aggregateRow = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _utils2 = _interopRequireDefault(utils);



var _expandCell2 = _interopRequireDefault(expandCell);



var _selectionCell2 = _interopRequireDefault(selectionCell);



var _shouldUpdater3 = _interopRequireDefault(shouldUpdater);



var _eventDelegater2 = _interopRequireDefault(eventDelegater);



var _rowPureContent2 = _interopRequireDefault(rowPureContent);



var _const2 = _interopRequireDefault(_const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint class-methods-use-this: 0 */
/* eslint react/prop-types: 0 */
/* eslint no-plusplus: 0 */


var RowAggregator = function (_shouldUpdater) {
  _inherits(RowAggregator, _shouldUpdater);

  function RowAggregator(props) {
    _classCallCheck(this, RowAggregator);

    var _this = _possibleConstructorReturn(this, (RowAggregator.__proto__ || Object.getPrototypeOf(RowAggregator)).call(this, props));

    _this.clickNum = 0;
    _this.shouldUpdateRowContent = false;
    _this.createClickEventHandler = _this.createClickEventHandler.bind(_this);
    return _this;
  }

  _createClass(RowAggregator, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.selected !== nextProps.selected || this.props.expanded !== nextProps.expanded || this.props.expandable !== nextProps.expandable || this.props.selectable !== nextProps.selectable || this.props.selectRow.hideSelectColumn !== nextProps.selectRow.hideSelectColumn || this.shouldUpdatedBySelfProps(nextProps)) {
        this.shouldUpdateRowContent = this.shouldRowContentUpdate(nextProps);
        return true;
      }
      this.shouldUpdateRowContent = this.shouldRowContentUpdate(nextProps);

      return this.shouldUpdateRowContent;
    }
  }, {
    key: 'isRenderFunctionColumnInLeft',
    value: function isRenderFunctionColumnInLeft() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _const2.default.INDICATOR_POSITION_LEFT;

      return position === _const2.default.INDICATOR_POSITION_LEFT;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          row = _props.row,
          columns = _props.columns,
          keyField = _props.keyField,
          rowIndex = _props.rowIndex,
          style = _props.style,
          className = _props.className,
          attrs = _props.attrs,
          selectRow = _props.selectRow,
          expandRow = _props.expandRow,
          expanded = _props.expanded,
          expandable = _props.expandable,
          selected = _props.selected,
          selectable = _props.selectable,
          visibleColumnSize = _props.visibleColumnSize,
          tabIndexCell = _props.tabIndexCell,
          rest = _objectWithoutProperties(_props, ['row', 'columns', 'keyField', 'rowIndex', 'style', 'className', 'attrs', 'selectRow', 'expandRow', 'expanded', 'expandable', 'selected', 'selectable', 'visibleColumnSize', 'tabIndexCell']);

      var key = _utils2.default.get(row, keyField);
      var hideSelectColumn = selectRow.hideSelectColumn,
          selectColumnPosition = selectRow.selectColumnPosition,
          clickToSelect = selectRow.clickToSelect;
      var showExpandColumn = expandRow.showExpandColumn,
          expandColumnPosition = expandRow.expandColumnPosition;


      var newAttrs = this.delegate(_extends({}, attrs));
      if (clickToSelect || !!expandRow.renderer) {
        newAttrs.onClick = this.createClickEventHandler(newAttrs.onClick);
      }

      var tabIndexStart = rowIndex * visibleColumnSize + 1;

      var childrens = [_react2.default.createElement(_rowPureContent2.default, _extends({
        key: 'row',
        row: row,
        columns: columns,
        keyField: keyField,
        rowIndex: rowIndex,
        shouldUpdate: this.shouldUpdateRowContent,
        tabIndexStart: tabIndexCell ? tabIndexStart : -1
      }, rest))];

      if (!hideSelectColumn) {
        var selectCell = _react2.default.createElement(_selectionCell2.default, _extends({}, selectRow, {
          key: 'selection-cell',
          rowKey: key,
          rowIndex: rowIndex,
          selected: selected,
          disabled: !selectable,
          tabIndex: tabIndexCell ? tabIndexStart++ : -1
        }));
        if (this.isRenderFunctionColumnInLeft(selectColumnPosition)) {
          childrens.unshift(selectCell);
        } else {
          childrens.push(selectCell);
        }
      }

      if (showExpandColumn) {
        var expandCell = _react2.default.createElement(_expandCell2.default, _extends({}, expandRow, {
          key: 'expand-cell',
          rowKey: key,
          rowIndex: rowIndex,
          expanded: expanded,
          expandable: expandable,
          tabIndex: tabIndexCell ? tabIndexStart++ : -1
        }));
        if (this.isRenderFunctionColumnInLeft(expandColumnPosition)) {
          childrens.unshift(expandCell);
        } else {
          childrens.push(expandCell);
        }
      }

      return _react2.default.createElement(
        'tr',
        _extends({
          style: style,
          className: className
        }, newAttrs),
        childrens
      );
    }
  }]);

  return RowAggregator;
}((0, _shouldUpdater3.default)((0, _eventDelegater2.default)(_react2.default.Component)));

RowAggregator.propTypes = {
  attrs: _propTypes2.default.object,
  style: _propTypes2.default.object
};
RowAggregator.defaultProps = {
  attrs: {},
  style: {}
};
exports.default = RowAggregator;
});

unwrapExports(aggregateRow);

var rowSection = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RowSection = function RowSection(_ref) {
  var content = _ref.content,
      colSpan = _ref.colSpan;
  return _react2.default.createElement(
    'tr',
    null,
    _react2.default.createElement(
      'td',
      {
        'data-toggle': 'collapse',
        colSpan: colSpan,
        className: 'react-bs-table-no-data'
      },
      content
    )
  );
};

RowSection.propTypes = {
  content: _propTypes2.default.any,
  colSpan: _propTypes2.default.number
};

RowSection.defaultProps = {
  content: null,
  colSpan: 1
};

exports.default = RowSection;
});

unwrapExports(rowSection);

var rowConsumer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint react/prop-types: 0 */




var _react2 = _interopRequireDefault(React__default);



var _classnames2 = _interopRequireDefault(classnames);



var _utils2 = _interopRequireDefault(utils);



var _selectionContext2 = _interopRequireDefault(selectionContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Component) {
  var renderWithSelection = function renderWithSelection(props, selectRow) {
    var key = props.value;
    var selected = _utils2.default.contains(selectRow.selected, key);
    var selectable = !selectRow.nonSelectable || !_utils2.default.contains(selectRow.nonSelectable, key);
    var notSelectable = _utils2.default.contains(selectRow.nonSelectable, key);

    var style = props.style,
        className = props.className;


    if (selected) {
      var selectedStyle = _utils2.default.isFunction(selectRow.style) ? selectRow.style(props.row, props.rowIndex) : selectRow.style;

      var selectedClasses = _utils2.default.isFunction(selectRow.classes) ? selectRow.classes(props.row, props.rowIndex) : selectRow.classes;

      style = _extends({}, style, selectedStyle);
      className = (0, _classnames2.default)(className, selectedClasses) || undefined;

      if (selectRow.bgColor) {
        style = style || {};
        style.backgroundColor = _utils2.default.isFunction(selectRow.bgColor) ? selectRow.bgColor(props.row, props.rowIndex) : selectRow.bgColor;
      }
    }

    if (notSelectable) {
      var notSelectableStyle = _utils2.default.isFunction(selectRow.nonSelectableStyle) ? selectRow.nonSelectableStyle(props.row, props.rowIndex) : selectRow.nonSelectableStyle;

      var notSelectableClasses = _utils2.default.isFunction(selectRow.nonSelectableClasses) ? selectRow.nonSelectableClasses(props.row, props.rowIndex) : selectRow.nonSelectableClasses;

      style = _extends({}, style, notSelectableStyle);
      className = (0, _classnames2.default)(className, notSelectableClasses) || undefined;
    }

    return _react2.default.createElement(Component, _extends({}, props, {
      style: style,
      className: className,
      selectRow: selectRow,
      selected: selected,
      selectable: selectable
    }));
  };

  function withConsumer(props) {
    return _react2.default.createElement(
      _selectionContext2.default.Consumer,
      null,
      function (selectRow) {
        return renderWithSelection(props, selectRow);
      }
    );
  }

  withConsumer.displayName = 'WithSelectionRowConsumer';
  return withConsumer;
};
});

unwrapExports(rowConsumer);

function _extends$7j() {
  _extends$7j = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$7j.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = _objectWithoutPropertiesLoose$1(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};

var removeClass$1 = function removeClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      if (node) forceReflow(node);
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass$1(node, baseClassName);
    }

    if (activeClassName) {
      removeClass$1(node, activeClassName);
    }

    if (doneClassName) {
      removeClass$1(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = _objectWithoutPropertiesLoose$1(_this$props, ["classNames"]);

    return /*#__PURE__*/React__default.createElement(Transition, _extends$7j({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React__default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$7j({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$7j({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose$1(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default.createElement(Component, props, children));
  };

  return TransitionGroup;
}(React__default.Component);

TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;
    var child = React__default.Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);

    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : ReactDOM.findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose$1(_this$props, ["children", "in"]);

    var _React$Children$toArr = React__default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return /*#__PURE__*/React__default.createElement(TransitionGroup, props, inProp ? React__default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : React__default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(React__default.Component);

ReplaceTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  in: PropTypes.bool.isRequired,
  children: function children(props, propName) {
    if (React__default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};

var _leaveRenders, _enterRenders;

function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;

  if (React__default.isValidElement(oldChildren) && React__default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }

  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */


var modes = {
  out: 'out-in',
  in: 'in-out'
};

var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;

    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};

var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
      changeState = _ref.changeState;
  return React__default.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERING, null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
      changeState = _ref2.changeState,
      children = _ref2.children;
  return [current, React__default.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERING);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
      changeState = _ref3.changeState;
  return React__default.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERED, React__default.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
      children = _ref4.children,
      changeState = _ref4.changeState;
  return [React__default.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERED, React__default.cloneElement(children, {
        in: true
      }));
    })
  }), React__default.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SwitchTransition, _React$Component);

  function SwitchTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: ENTERED,
      current: null
    };
    _this.appeared = false;

    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }

      _this.setState({
        status: status,
        current: current
      });
    };

    return _this;
  }

  var _proto = SwitchTransition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }

    if (state.status === ENTERING && props.mode === modes.in) {
      return {
        status: ENTERING
      };
    }

    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: EXITING
      };
    }

    return {
      current: React__default.cloneElement(props.children, {
        in: true
      })
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        mode = _this$props.mode,
        _this$state = this.state,
        status = _this$state.status,
        current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;

    switch (status) {
      case ENTERING:
        component = enterRenders[mode](data);
        break;

      case EXITING:
        component = leaveRenders[mode](data);
        break;

      case ENTERED:
        component = current;
    }

    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };

  return SwitchTransition;
}(React__default.Component);

SwitchTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
   *
   * @type {'out-in'|'in-out'}
   */
  mode: PropTypes.oneOf([modes.in, modes.out]),

  /**
   * Any `Transition` or `CSSTransition` component.
   */
  children: PropTypes.oneOfType([PropTypes.element.isRequired])
} : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};



var esm = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CSSTransition: CSSTransition,
  ReplaceTransition: ReplaceTransition,
  SwitchTransition: SwitchTransition,
  TransitionGroup: TransitionGroup,
  Transition: Transition,
  config: config
});

var expandRow = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _classnames2 = _interopRequireDefault(classnames);



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ExpandRow = function ExpandRow(_ref) {
  var children = _ref.children,
      expanded = _ref.expanded,
      onClosed = _ref.onClosed,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ['children', 'expanded', 'onClosed', 'className']);

  return _react2.default.createElement(
    'tr',
    null,
    _react2.default.createElement(
      'td',
      _extends({ className: (0, _classnames2.default)('reset-expansion-style', className) }, rest),
      _react2.default.createElement(
        esm.CSSTransition,
        {
          appear: true,
          'in': expanded,
          timeout: 400,
          classNames: 'row-expand-slide',
          onExited: onClosed
        },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'row-expansion-style' },
            children
          )
        )
      )
    )
  );
};

ExpandRow.propTypes = {
  children: _propTypes2.default.node,
  expanded: _propTypes2.default.bool,
  onClosed: _propTypes2.default.func,
  className: _propTypes2.default.string
};

ExpandRow.defaultProps = {
  children: null,
  expanded: false,
  onClosed: null,
  className: ''
};

exports.default = ExpandRow;
});

unwrapExports(expandRow);

var rowConsumer$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint react/prop-types: 0 */




var _react2 = _interopRequireDefault(React__default);



var _classnames2 = _interopRequireDefault(classnames);



var _expandRow2 = _interopRequireDefault(expandRow);



var _utils2 = _interopRequireDefault(utils);



var _rowExpandContext2 = _interopRequireDefault(rowExpandContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Component) {
  var renderWithExpansion = function renderWithExpansion(props, expandRow) {
    var parentClassName = '';
    var className = '';
    var key = props.value;

    var expanded = _utils2.default.contains(expandRow.expanded, key);
    var isClosing = _utils2.default.contains(expandRow.isClosing, key);
    var expandable = !expandRow.nonExpandable || !_utils2.default.contains(expandRow.nonExpandable, key);
    if (expanded) {
      parentClassName = _utils2.default.isFunction(expandRow.parentClassName) ? expandRow.parentClassName(expanded, props.row, props.rowIndex) : expandRow.parentClassName || '';

      className = _utils2.default.isFunction(expandRow.className) ? expandRow.className(expanded, props.row, props.rowIndex) : expandRow.className || '';
    }

    return [_react2.default.createElement(Component, _extends({}, props, {
      key: key,
      expanded: expanded,
      expandable: expandable,
      expandRow: _extends({}, expandRow),
      className: (0, _classnames2.default)(props.className, parentClassName)
    })), expanded || isClosing ? _react2.default.createElement(
      _expandRow2.default,
      {
        key: key + '-expanding',
        colSpan: props.visibleColumnSize,
        expanded: expanded,
        onClosed: function onClosed() {
          return expandRow.onClosed(key);
        },
        className: className
      },
      expandRow.renderer(props.row, props.rowIndex)
    ) : null];
  };
  return function (props) {
    return _react2.default.createElement(
      _rowExpandContext2.default.Consumer,
      null,
      function (expandRow) {
        return renderWithExpansion(props, expandRow);
      }
    );
  };
};
});

unwrapExports(rowConsumer$1);

var body = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _utils2 = _interopRequireDefault(utils);



var _simpleRow2 = _interopRequireDefault(simpleRow);



var _aggregateRow2 = _interopRequireDefault(aggregateRow);



var _rowSection2 = _interopRequireDefault(rowSection);



var _const2 = _interopRequireDefault(_const);



var _rowConsumer2 = _interopRequireDefault(rowConsumer);



var _rowConsumer4 = _interopRequireDefault(rowConsumer$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
/* eslint react/require-default-props: 0 */

var Body = function (_React$Component) {
  _inherits(Body, _React$Component);

  function Body(props) {
    _classCallCheck(this, Body);

    var _this = _possibleConstructorReturn(this, (Body.__proto__ || Object.getPrototypeOf(Body)).call(this, props));

    var keyField = props.keyField,
        cellEdit = props.cellEdit,
        selectRow = props.selectRow,
        expandRow = props.expandRow;

    // Construct Editing Cell Component

    if (cellEdit.createContext) {
      _this.EditingCell = cellEdit.createEditingCell(_utils2.default, cellEdit.options.onStartEdit);
    }

    // Construct Row Component
    var RowComponent = _simpleRow2.default;
    var selectRowEnabled = selectRow.mode !== _const2.default.ROW_SELECT_DISABLED;
    var expandRowEnabled = !!expandRow.renderer;

    if (expandRowEnabled) {
      RowComponent = (0, _rowConsumer4.default)(_aggregateRow2.default);
    }

    if (selectRowEnabled) {
      RowComponent = (0, _rowConsumer2.default)(expandRowEnabled ? RowComponent : _aggregateRow2.default);
    }

    if (cellEdit.createContext) {
      RowComponent = cellEdit.withRowLevelCellEdit(RowComponent, selectRowEnabled, keyField, _utils2.default);
    }
    _this.RowComponent = RowComponent;
    return _this;
  }

  _createClass(Body, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          columns = _props.columns,
          data = _props.data,
          tabIndexCell = _props.tabIndexCell,
          keyField = _props.keyField,
          isEmpty = _props.isEmpty,
          noDataIndication = _props.noDataIndication,
          visibleColumnSize = _props.visibleColumnSize,
          cellEdit = _props.cellEdit,
          selectRow = _props.selectRow,
          rowStyle = _props.rowStyle,
          rowClasses = _props.rowClasses,
          rowEvents = _props.rowEvents,
          expandRow = _props.expandRow,
          className = _props.className;


      var content = void 0;

      if (isEmpty) {
        var indication = _utils2.default.isFunction(noDataIndication) ? noDataIndication() : noDataIndication;
        if (!indication) {
          return null;
        }
        content = _react2.default.createElement(_rowSection2.default, { content: indication, colSpan: visibleColumnSize });
      } else {
        var selectRowEnabled = selectRow.mode !== _const2.default.ROW_SELECT_DISABLED;
        var expandRowEnabled = !!expandRow.renderer;

        var additionalRowProps = {};

        if (cellEdit.createContext) {
          additionalRowProps.EditingCellComponent = this.EditingCell;
        }

        if (selectRowEnabled || expandRowEnabled) {
          additionalRowProps.expandRow = expandRow;
          additionalRowProps.selectRow = selectRow;
        }

        content = data.map(function (row, index) {
          var key = _utils2.default.get(row, keyField);
          var baseRowProps = _extends({
            key: key,
            row: row,
            tabIndexCell: tabIndexCell,
            columns: columns,
            keyField: keyField,
            cellEdit: cellEdit,
            value: key,
            rowIndex: index,
            visibleColumnSize: visibleColumnSize,
            attrs: rowEvents || {}
          }, additionalRowProps);

          baseRowProps.style = _utils2.default.isFunction(rowStyle) ? rowStyle(row, index) : rowStyle;
          baseRowProps.className = _utils2.default.isFunction(rowClasses) ? rowClasses(row, index) : rowClasses;

          return _react2.default.createElement(_this2.RowComponent, baseRowProps);
        });
      }

      return _react2.default.createElement(
        'tbody',
        { className: className },
        content
      );
    }
  }]);

  return Body;
}(_react2.default.Component);

Body.propTypes = {
  keyField: _propTypes2.default.string.isRequired,
  data: _propTypes2.default.array.isRequired,
  columns: _propTypes2.default.array.isRequired,
  selectRow: _propTypes2.default.object
};

exports.default = Body;
});

unwrapExports(body);

var footerCell = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _classnames2 = _interopRequireDefault(classnames);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _utils2 = _interopRequireDefault(utils);



var _cellEventDelegater2 = _interopRequireDefault(cellEventDelegater);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/require-default-props: 0 */


var FooterCell = function (_eventDelegater) {
  _inherits(FooterCell, _eventDelegater);

  function FooterCell() {
    _classCallCheck(this, FooterCell);

    return _possibleConstructorReturn(this, (FooterCell.__proto__ || Object.getPrototypeOf(FooterCell)).apply(this, arguments));
  }

  _createClass(FooterCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          index = _props.index,
          column = _props.column,
          columnData = _props.columnData;
      var footer = column.footer,
          footerTitle = column.footerTitle,
          footerAlign = column.footerAlign,
          footerFormatter = column.footerFormatter,
          footerEvents = column.footerEvents,
          footerClasses = column.footerClasses,
          footerStyle = column.footerStyle,
          footerAttrs = column.footerAttrs;


      var delegateEvents = this.delegate(footerEvents);
      var cellAttrs = _extends({}, _utils2.default.isFunction(footerAttrs) ? footerAttrs(column, index) : footerAttrs, delegateEvents);

      var text = '';
      if (_utils2.default.isString(footer)) {
        text = footer;
      } else if (_utils2.default.isFunction(footer)) {
        text = footer(columnData, column, index);
      }

      var cellStyle = {};
      var cellClasses = _utils2.default.isFunction(footerClasses) ? footerClasses(column, index) : footerClasses;

      if (footerStyle) {
        cellStyle = _utils2.default.isFunction(footerStyle) ? footerStyle(column, index) : footerStyle;
        cellStyle = cellStyle ? _extends({}, cellStyle) : cellStyle;
      }

      if (footerTitle) {
        cellAttrs.title = _utils2.default.isFunction(footerTitle) ? footerTitle(column, index) : text;
      }

      if (footerAlign) {
        cellStyle.textAlign = _utils2.default.isFunction(footerAlign) ? footerAlign(column, index) : footerAlign;
      }

      if (cellClasses) cellAttrs.className = (0, _classnames2.default)(cellAttrs.className, cellClasses);
      if (!_utils2.default.isEmptyObject(cellStyle)) cellAttrs.style = cellStyle;

      var children = footerFormatter ? footerFormatter(column, index, { text: text }) : text;

      return _react2.default.createElement('th', cellAttrs, children);
    }
  }]);

  return FooterCell;
}((0, _cellEventDelegater2.default)(_react2.default.Component));

FooterCell.propTypes = {
  columnData: _propTypes2.default.array,
  index: _propTypes2.default.number,
  column: _propTypes2.default.object
};

exports.default = FooterCell;
});

unwrapExports(footerCell);

var footer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _rowTemplate2 = _interopRequireDefault(rowTemplate);



var _footerCell2 = _interopRequireDefault(footerCell);



var _utils2 = _interopRequireDefault(utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer(props) {
  var data = props.data,
      className = props.className,
      columns = props.columns,
      selectRow = props.selectRow,
      expandRow = props.expandRow;


  function renderContent() {
    return columns.map(function (column, i) {
      if (column.footer === undefined || column.footer === null) {
        return false;
      }

      var columnData = _utils2.default.pluck(data, column.dataField);

      return _react2.default.createElement(_footerCell2.default, {
        index: i,
        key: column.dataField,
        column: column,
        columnData: columnData
      });
    });
  }

  return _react2.default.createElement(
    'tfoot',
    null,
    _react2.default.createElement(_rowTemplate2.default, {
      renderContent: renderContent,
      selectRow: selectRow,
      expandRow: expandRow,
      className: className,
      cellEl: 'th'
    })
  );
}; /* eslint react/require-default-props: 0 */


Footer.propTypes = {
  data: _propTypes2.default.array,
  className: _propTypes2.default.string,
  columns: _propTypes2.default.array,
  selectRow: _propTypes2.default.object,
  expandRow: _propTypes2.default.object
};

exports.default = Footer;
});

unwrapExports(footer);

var columnResolver = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (ExtendBase) {
  return function (_ExtendBase) {
    _inherits(ColumnResolver, _ExtendBase);

    function ColumnResolver() {
      _classCallCheck(this, ColumnResolver);

      return _possibleConstructorReturn(this, (ColumnResolver.__proto__ || Object.getPrototypeOf(ColumnResolver)).apply(this, arguments));
    }

    _createClass(ColumnResolver, [{
      key: "visibleColumnSize",
      value: function visibleColumnSize() {
        var includeSelectColumn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        var columnLen = void 0;
        if (this.props.columnToggle && this.props.columnToggle.toggles) {
          var columns = this.props.columnToggle.toggles;
          columnLen = Object.keys(columns).filter(function (name) {
            return columns[name];
          }).length;
        } else {
          columnLen = this.props.columns.filter(function (c) {
            return !c.hidden;
          }).length;
        }
        if (!includeSelectColumn) return columnLen;
        if (this.props.selectRow && !this.props.selectRow.hideSelectColumn) {
          columnLen += 1;
        }
        if (this.props.expandRow && this.props.expandRow.showExpandColumn) {
          columnLen += 1;
        }
        return columnLen;
      }
    }]);

    return ColumnResolver;
  }(ExtendBase);
};
});

unwrapExports(columnResolver);

var propsResolver = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _utils2 = _interopRequireDefault(utils);



var _columnResolver2 = _interopRequireDefault(columnResolver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (ExtendBase) {
  return function (_ColumnResolver) {
    _inherits(TableResolver, _ColumnResolver);

    function TableResolver() {
      _classCallCheck(this, TableResolver);

      return _possibleConstructorReturn(this, (TableResolver.__proto__ || Object.getPrototypeOf(TableResolver)).apply(this, arguments));
    }

    _createClass(TableResolver, [{
      key: 'validateProps',
      value: function validateProps() {
        var keyField = this.props.keyField;

        if (!keyField) {
          throw new Error('Please specify a field as key via keyField');
        }
        if (this.visibleColumnSize(false) <= 0) {
          throw new Error('No visible columns detected');
        }
      }
    }, {
      key: 'isEmpty',
      value: function isEmpty() {
        return this.props.data.length === 0;
      }
    }, {
      key: 'visibleRows',
      value: function visibleRows() {
        var _props = this.props,
            data = _props.data,
            hiddenRows = _props.hiddenRows,
            keyField = _props.keyField;

        if (!hiddenRows || hiddenRows.length === 0) return data;
        return data.filter(function (row) {
          var key = _utils2.default.get(row, keyField);
          return !_utils2.default.contains(hiddenRows, key);
        });
      }
    }]);

    return TableResolver;
  }((0, _columnResolver2.default)(ExtendBase));
};
});

unwrapExports(propsResolver);

var bootstrapTable = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _classnames2 = _interopRequireDefault(classnames);



var _header2 = _interopRequireDefault(header);



var _filters2 = _interopRequireDefault(filters);



var _caption2 = _interopRequireDefault(caption);



var _body2 = _interopRequireDefault(body);



var _footer2 = _interopRequireDefault(footer);



var _propsResolver2 = _interopRequireDefault(propsResolver);



var _const2 = _interopRequireDefault(_const);



var _utils2 = _interopRequireDefault(utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint camelcase: 0 */
/* eslint arrow-body-style: 0 */

var BootstrapTable = function (_PropsBaseResolver) {
  _inherits(BootstrapTable, _PropsBaseResolver);

  function BootstrapTable(props) {
    _classCallCheck(this, BootstrapTable);

    var _this = _possibleConstructorReturn(this, (BootstrapTable.__proto__ || Object.getPrototypeOf(BootstrapTable)).call(this, props));

    _this.getData = function () {
      return _this.visibleRows();
    };

    _this.validateProps();
    return _this;
  }

  _createClass(BootstrapTable, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.onDataSizeChange && !nextProps.pagination) {
        if (nextProps.data.length !== this.props.data.length) {
          nextProps.onDataSizeChange({ dataSize: nextProps.data.length });
        }
      }
    }

    // Exposed APIs

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          overlay = _props.overlay;

      if (overlay) {
        var LoadingOverlay = overlay(loading);
        return _react2.default.createElement(
          LoadingOverlay,
          null,
          this.renderTable()
        );
      }
      return this.renderTable();
    }
  }, {
    key: 'renderTable',
    value: function renderTable() {
      var _props2 = this.props,
          columns = _props2.columns,
          keyField = _props2.keyField,
          tabIndexCell = _props2.tabIndexCell,
          id = _props2.id,
          classes = _props2.classes,
          bootstrap4 = _props2.bootstrap4,
          striped = _props2.striped,
          hover = _props2.hover,
          bordered = _props2.bordered,
          condensed = _props2.condensed,
          noDataIndication = _props2.noDataIndication,
          caption = _props2.caption,
          rowStyle = _props2.rowStyle,
          rowClasses = _props2.rowClasses,
          wrapperClasses = _props2.wrapperClasses,
          rowEvents = _props2.rowEvents,
          selectRow = _props2.selectRow,
          expandRow = _props2.expandRow,
          cellEdit = _props2.cellEdit,
          filterPosition = _props2.filterPosition;


      var tableWrapperClass = (0, _classnames2.default)('react-bootstrap-table', wrapperClasses);

      var tableClass = (0, _classnames2.default)('table', _defineProperty({
        'table-striped': striped,
        'table-hover': hover,
        'table-bordered': bordered
      }, bootstrap4 ? 'table-sm' : 'table-condensed', condensed), classes);

      var hasFilters = columns.some(function (col) {
        return col.filter || col.filterRenderer;
      });

      var hasFooter = _utils2.default.filter(columns, function (col) {
        return _utils2.default.has(col, 'footer');
      }).length > 0;

      var tableCaption = caption && _react2.default.createElement(
        _caption2.default,
        { bootstrap4: bootstrap4 },
        caption
      );

      return _react2.default.createElement(
        'div',
        { className: tableWrapperClass },
        _react2.default.createElement(
          'table',
          { id: id, className: tableClass },
          tableCaption,
          _react2.default.createElement(_header2.default, {
            columns: columns,
            className: this.props.headerClasses,
            wrapperClasses: this.props.headerWrapperClasses,
            sortField: this.props.sortField,
            sortOrder: this.props.sortOrder,
            onSort: this.props.onSort,
            globalSortCaret: this.props.sort && this.props.sort.sortCaret,
            onFilter: this.props.onFilter,
            currFilters: this.props.currFilters,
            onExternalFilter: this.props.onExternalFilter,
            selectRow: selectRow,
            expandRow: expandRow,
            filterPosition: filterPosition
          }),
          hasFilters && filterPosition !== _const2.default.FILTERS_POSITION_INLINE && _react2.default.createElement(_filters2.default, {
            columns: columns,
            className: this.props.filtersClasses,
            onSort: this.props.onSort,
            onFilter: this.props.onFilter,
            currFilters: this.props.currFilters,
            filterPosition: this.props.filterPosition,
            onExternalFilter: this.props.onExternalFilter,
            selectRow: selectRow,
            expandRow: expandRow
          }),
          _react2.default.createElement(_body2.default, {
            className: this.props.bodyClasses,
            data: this.getData(),
            keyField: keyField,
            tabIndexCell: tabIndexCell,
            columns: columns,
            isEmpty: this.isEmpty(),
            visibleColumnSize: this.visibleColumnSize(),
            noDataIndication: noDataIndication,
            cellEdit: cellEdit,
            selectRow: selectRow,
            expandRow: expandRow,
            rowStyle: rowStyle,
            rowClasses: rowClasses,
            rowEvents: rowEvents
          }),
          hasFooter && _react2.default.createElement(_footer2.default, {
            data: this.getData(),
            columns: columns,
            selectRow: selectRow,
            expandRow: expandRow,
            className: this.props.footerClasses
          })
        )
      );
    }
  }]);

  return BootstrapTable;
}((0, _propsResolver2.default)(React__default.Component));

BootstrapTable.propTypes = {
  keyField: _propTypes2.default.string.isRequired,
  data: _propTypes2.default.array.isRequired,
  columns: _propTypes2.default.array.isRequired,
  bootstrap4: _propTypes2.default.bool,
  remote: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    pagination: _propTypes2.default.bool
  })]),
  noDataIndication: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  striped: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  hover: _propTypes2.default.bool,
  tabIndexCell: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  classes: _propTypes2.default.string,
  headerClasses: _propTypes2.default.string,
  bodyClasses: _propTypes2.default.string,
  wrapperClasses: _propTypes2.default.string,
  headerWrapperClasses: _propTypes2.default.string,
  condensed: _propTypes2.default.bool,
  caption: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  pagination: _propTypes2.default.object,
  filter: _propTypes2.default.object,
  cellEdit: _propTypes2.default.object,
  selectRow: _propTypes2.default.shape({
    mode: _propTypes2.default.oneOf([_const2.default.ROW_SELECT_SINGLE, _const2.default.ROW_SELECT_MULTIPLE, _const2.default.ROW_SELECT_DISABLED]).isRequired,
    clickToSelect: _propTypes2.default.bool,
    clickToExpand: _propTypes2.default.bool,
    clickToEdit: _propTypes2.default.bool,
    hideSelectAll: _propTypes2.default.bool,
    onSelect: _propTypes2.default.func,
    onSelectAll: _propTypes2.default.func,
    style: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    classes: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    nonSelectable: _propTypes2.default.array,
    nonSelectableStyle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    nonSelectableClasses: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    bgColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    hideSelectColumn: _propTypes2.default.bool,
    selectionRenderer: _propTypes2.default.func,
    selectionHeaderRenderer: _propTypes2.default.func,
    headerColumnStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    selectColumnStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    selectColumnPosition: _propTypes2.default.oneOf([_const2.default.INDICATOR_POSITION_LEFT, _const2.default.INDICATOR_POSITION_RIGHT])
  }),
  expandRow: _propTypes2.default.shape({
    renderer: _propTypes2.default.func,
    expanded: _propTypes2.default.array,
    onExpand: _propTypes2.default.func,
    onExpandAll: _propTypes2.default.func,
    nonExpandable: _propTypes2.default.array,
    showExpandColumn: _propTypes2.default.bool,
    onlyOneExpanding: _propTypes2.default.bool,
    expandByColumnOnly: _propTypes2.default.bool,
    expandColumnRenderer: _propTypes2.default.func,
    expandHeaderColumnRenderer: _propTypes2.default.func,
    expandColumnPosition: _propTypes2.default.oneOf([_const2.default.INDICATOR_POSITION_LEFT, _const2.default.INDICATOR_POSITION_RIGHT]),
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    parentClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
  }),
  rowStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  rowEvents: _propTypes2.default.object,
  rowClasses: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  filtersClasses: _propTypes2.default.string,
  filterPosition: _propTypes2.default.oneOf([_const2.default.FILTERS_POSITION_TOP, _const2.default.FILTERS_POSITION_INLINE, _const2.default.FILTERS_POSITION_BOTTOM]),
  footerClasses: _propTypes2.default.string,
  defaultSorted: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    dataField: _propTypes2.default.string.isRequired,
    order: _propTypes2.default.oneOf([_const2.default.SORT_DESC, _const2.default.SORT_ASC]).isRequired
  })),
  sort: _propTypes2.default.shape({
    dataField: _propTypes2.default.string,
    order: _propTypes2.default.oneOf([_const2.default.SORT_DESC, _const2.default.SORT_ASC]),
    sortFunc: _propTypes2.default.func,
    sortCaret: _propTypes2.default.func
  }),
  defaultSortDirection: _propTypes2.default.oneOf([_const2.default.SORT_DESC, _const2.default.SORT_ASC]),
  overlay: _propTypes2.default.func,
  onTableChange: _propTypes2.default.func,
  onSort: _propTypes2.default.func,
  onFilter: _propTypes2.default.func,
  onExternalFilter: _propTypes2.default.func,
  onDataSizeChange: _propTypes2.default.func,
  // Inject from toolkit
  search: _propTypes2.default.shape({
    searchText: _propTypes2.default.string,
    searchContext: _propTypes2.default.func
  }),
  setDependencyModules: _propTypes2.default.func
};

BootstrapTable.defaultProps = {
  bootstrap4: false,
  remote: false,
  striped: false,
  bordered: true,
  hover: false,
  condensed: false,
  noDataIndication: null,
  selectRow: {
    mode: _const2.default.ROW_SELECT_DISABLED,
    selected: [],
    hideSelectColumn: true
  },
  expandRow: {
    renderer: undefined,
    expanded: [],
    nonExpandable: []
  },
  cellEdit: {
    mode: null,
    nonEditableRows: []
  },
  filterPosition: _const2.default.FILTERS_POSITION_INLINE
};

exports.default = BootstrapTable;
});

unwrapExports(bootstrapTable);

var dataContext = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint camelcase: 0 */


exports.default = function () {
  var DataContext = _react2.default.createContext();

  var DataProvider = function (_Component) {
    _inherits(DataProvider, _Component);

    function DataProvider() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, DataProvider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DataProvider.__proto__ || Object.getPrototypeOf(DataProvider)).call.apply(_ref, [this].concat(args))), _this), _this.state = { data: _this.props.data }, _this.getData = function (filterProps, searchProps, sortProps, paginationProps) {
        if (paginationProps) return paginationProps.data;else if (sortProps) return sortProps.data;else if (searchProps) return searchProps.data;else if (filterProps) return filterProps.data;
        return _this.props.data;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DataProvider, [{
      key: 'UNSAFE_componentWillReceiveProps',
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState(function () {
          return { data: nextProps.data };
        });
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          DataContext.Provider,
          {
            value: {
              data: this.state.data,
              getData: this.getData
            }
          },
          this.props.children
        );
      }
    }]);

    return DataProvider;
  }(React__default.Component);

  DataProvider.propTypes = {
    data: _propTypes2.default.array.isRequired,
    children: _propTypes2.default.node.isRequired
  };

  return {
    Provider: DataProvider,
    Consumer: DataContext.Consumer
  };
};
});

unwrapExports(dataContext);

var columnContext = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
/* eslint react/prefer-stateless-function: 0 */


exports.default = function () {
  var ColumnManagementContext = _react2.default.createContext();

  var ColumnManagementProvider = function (_React$Component) {
    _inherits(ColumnManagementProvider, _React$Component);

    function ColumnManagementProvider() {
      _classCallCheck(this, ColumnManagementProvider);

      return _possibleConstructorReturn(this, (ColumnManagementProvider.__proto__ || Object.getPrototypeOf(ColumnManagementProvider)).apply(this, arguments));
    }

    _createClass(ColumnManagementProvider, [{
      key: 'render',
      value: function render() {
        var toggleColumn = void 0;
        var _props = this.props,
            columns = _props.columns,
            toggles = _props.toggles;

        if (toggles) {
          toggleColumn = columns.filter(function (column) {
            return toggles[column.dataField];
          });
        } else {
          toggleColumn = columns.filter(function (column) {
            return !column.hidden;
          });
        }
        return _react2.default.createElement(
          ColumnManagementContext.Provider,
          { value: { columns: toggleColumn } },
          this.props.children
        );
      }
    }]);

    return ColumnManagementProvider;
  }(_react2.default.Component);

  ColumnManagementProvider.propTypes = {
    columns: _propTypes2.default.array.isRequired,
    toggles: _propTypes2.default.object
  };
  ColumnManagementProvider.defaultProps = {
    toggles: null
  };


  return {
    Provider: ColumnManagementProvider,
    Consumer: ColumnManagementContext.Consumer
  };
};
});

unwrapExports(columnContext);

var sortContext = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _const2 = _interopRequireDefault(_const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint camelcase: 0 */
/* eslint react/require-default-props: 0 */


exports.default = function (dataOperator, isRemoteSort, handleSortChange) {
  var SortContext = _react2.default.createContext();

  var SortProvider = function (_React$Component) {
    _inherits(SortProvider, _React$Component);

    function SortProvider(props) {
      _classCallCheck(this, SortProvider);

      var _this = _possibleConstructorReturn(this, (SortProvider.__proto__ || Object.getPrototypeOf(SortProvider)).call(this, props));

      _initialiseProps.call(_this);

      var sortOrder = void 0;
      var sortColumn = void 0;
      var defaultSorted = props.defaultSorted,
          defaultSortDirection = props.defaultSortDirection,
          sort = props.sort;


      if (defaultSorted && defaultSorted.length > 0) {
        sortOrder = defaultSorted[0].order || defaultSortDirection;
        sortColumn = _this.initSort(defaultSorted[0].dataField, sortOrder);
      } else if (sort && sort.dataField && sort.order) {
        sortOrder = sort.order;
        sortColumn = _this.initSort(sort.dataField, sortOrder);
      }
      _this.state = { sortOrder: sortOrder, sortColumn: sortColumn };
      return _this;
    }

    _createClass(SortProvider, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _state = this.state,
            sortOrder = _state.sortOrder,
            sortColumn = _state.sortColumn;

        if (isRemoteSort() && sortOrder && sortColumn) {
          handleSortChange(sortColumn.dataField, sortOrder);
        }
      }
    }, {
      key: 'UNSAFE_componentWillReceiveProps',
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        var sort = nextProps.sort,
            columns = nextProps.columns;

        if (sort && sort.dataField && sort.order) {
          this.setState({
            sortOrder: sort.order,
            sortColumn: columns.find(function (col) {
              return col.dataField === sort.dataField;
            })
          });
        }
      }
    }, {
      key: 'initSort',
      value: function initSort(sortField, sortOrder) {
        var sortColumn = void 0;
        var columns = this.props.columns;

        var sortColumns = columns.filter(function (col) {
          return col.dataField === sortField;
        });
        if (sortColumns.length > 0) {
          sortColumn = sortColumns[0];

          if (sortColumn.onSort) {
            sortColumn.onSort(sortField, sortOrder);
          }
        }
        return sortColumn;
      }
    }, {
      key: 'render',
      value: function render() {
        var data = this.props.data;
        var sort = this.props.sort;
        var _state2 = this.state,
            sortOrder = _state2.sortOrder,
            sortColumn = _state2.sortColumn;

        if (!isRemoteSort() && sortColumn) {
          var sortFunc = sortColumn.sortFunc ? sortColumn.sortFunc : sort && sort.sortFunc;
          data = dataOperator.sort(data, sortOrder, _extends({}, sortColumn, { sortFunc: sortFunc }));
        }

        return _react2.default.createElement(
          SortContext.Provider,
          {
            value: {
              data: data,
              sortOrder: sortOrder,
              onSort: this.handleSort,
              sortField: sortColumn ? sortColumn.dataField : null
            }
          },
          this.props.children
        );
      }
    }]);

    return SortProvider;
  }(_react2.default.Component);

  SortProvider.propTypes = {
    data: _propTypes2.default.array.isRequired,
    columns: _propTypes2.default.array.isRequired,
    children: _propTypes2.default.node.isRequired,
    defaultSorted: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      dataField: _propTypes2.default.string.isRequired,
      order: _propTypes2.default.oneOf([_const2.default.SORT_DESC, _const2.default.SORT_ASC]).isRequired
    })),
    sort: _propTypes2.default.shape({
      dataField: _propTypes2.default.string,
      order: _propTypes2.default.oneOf([_const2.default.SORT_DESC, _const2.default.SORT_ASC]),
      sortFunc: _propTypes2.default.func
    }),
    defaultSortDirection: _propTypes2.default.oneOf([_const2.default.SORT_DESC, _const2.default.SORT_ASC])
  };

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.handleSort = function (column) {
      var sortOrder = dataOperator.nextOrder(column, _this2.state, _this2.props.defaultSortDirection);

      if (column.onSort) {
        column.onSort(column.dataField, sortOrder);
      }

      if (isRemoteSort()) {
        handleSortChange(column.dataField, sortOrder);
      }
      _this2.setState(function () {
        return {
          sortOrder: sortOrder,
          sortColumn: column
        };
      });
    };
  };

  return {
    Provider: SortProvider,
    Consumer: SortContext.Consumer
  };
};
});

unwrapExports(sortContext);

var remoteResolver = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _events2 = _interopRequireDefault(events);



var _utils2 = _interopRequireDefault(utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (ExtendBase) {
  return function (_ExtendBase) {
    _inherits(RemoteResolver, _ExtendBase);

    function RemoteResolver(props) {
      _classCallCheck(this, RemoteResolver);

      var _this = _possibleConstructorReturn(this, (RemoteResolver.__proto__ || Object.getPrototypeOf(RemoteResolver)).call(this, props));

      _this.getNewestState = function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var sortOrder = void 0;
        var sortField = void 0;
        var page = void 0;
        var sizePerPage = void 0;
        var searchText = void 0;
        var filters = {};

        if (_this.sortContext) {
          sortOrder = _this.sortContext.state.sortOrder;
          sortField = _this.sortContext.state.sortColumn ? _this.sortContext.state.sortColumn.dataField : null;
        }

        if (_this.filterContext) {
          filters = _this.filterContext.currFilters;
        }

        if (_this.paginationContext) {
          page = _this.paginationContext.currPage;
          sizePerPage = _this.paginationContext.currSizePerPage;
        }

        if (_this.searchContext) {
          searchText = _this.props.search.searchText;
        }

        return _extends({
          sortOrder: sortOrder,
          sortField: sortField,
          filters: filters,
          page: page,
          sizePerPage: sizePerPage,
          searchText: searchText
        }, state, {
          data: _this.props.data
        });
      };

      _this.isRemoteSearch = function () {
        var remote = _this.props.remote;

        return remote === true || _utils2.default.isObject(remote) && remote.search || _this.isRemotePagination();
      };

      _this.isRemotePagination = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var remote = _this.props.remote;

        e.result = remote === true || _utils2.default.isObject(remote) && remote.pagination;
        return e.result;
      };

      _this.isRemoteFiltering = function () {
        var remote = _this.props.remote;

        return remote === true || _utils2.default.isObject(remote) && remote.filter || _this.isRemotePagination();
      };

      _this.isRemoteSort = function () {
        var remote = _this.props.remote;

        return remote === true || _utils2.default.isObject(remote) && remote.sort || _this.isRemotePagination();
      };

      _this.isRemoteCellEdit = function () {
        var remote = _this.props.remote;

        return remote === true || _utils2.default.isObject(remote) && remote.cellEdit;
      };

      _this.handleRemotePageChange = function (page, sizePerPage) {
        _this.props.onTableChange('pagination', _this.getNewestState({ page: page, sizePerPage: sizePerPage }));
      };

      _this.handleRemoteFilterChange = function (filters) {
        var newState = { filters: filters };
        if (_this.isRemotePagination()) {
          var options = _this.props.pagination.options || {};
          newState.page = _utils2.default.isDefined(options.pageStartIndex) ? options.pageStartIndex : 1;
        }
        _this.props.onTableChange('filter', _this.getNewestState(newState));
      };

      _this.handleRemoteSortChange = function (sortField, sortOrder) {
        _this.props.onTableChange('sort', _this.getNewestState({ sortField: sortField, sortOrder: sortOrder }));
      };

      _this.handleRemoteCellChange = function (rowId, dataField, newValue) {
        var cellEdit = { rowId: rowId, dataField: dataField, newValue: newValue };
        _this.props.onTableChange('cellEdit', _this.getNewestState({ cellEdit: cellEdit }));
      };

      _this.handleRemoteSearchChange = function (searchText) {
        _this.props.onTableChange('search', _this.getNewestState({ searchText: searchText }));
      };

      _this.remoteEmitter = new _events2.default();
      _this.remoteEmitter.on('paginationChange', _this.handleRemotePageChange);
      _this.remoteEmitter.on('isRemotePagination', _this.isRemotePagination);
      return _this;
    }

    return RemoteResolver;
  }(ExtendBase);
};
});

unwrapExports(remoteResolver);

var contexts = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _events2 = _interopRequireDefault(events);



var _utils2 = _interopRequireDefault(utils);



var _dataContext2 = _interopRequireDefault(dataContext);



var _columnContext2 = _interopRequireDefault(columnContext);



var _sortContext2 = _interopRequireDefault(sortContext);



var _selectionContext2 = _interopRequireDefault(selectionContext);



var _rowExpandContext2 = _interopRequireDefault(rowExpandContext);



var _remoteResolver3 = _interopRequireDefault(remoteResolver);





var _operators2 = _interopRequireDefault(operators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint camelcase: 0 */
/* eslint no-return-assign: 0 */
/* eslint no-param-reassign: 0 */
/* eslint class-methods-use-this: 0 */


var withContext = function withContext(Base) {
  return function (_remoteResolver) {
    _inherits(BootstrapTableContainer, _remoteResolver);

    function BootstrapTableContainer(props) {
      _classCallCheck(this, BootstrapTableContainer);

      var _this = _possibleConstructorReturn(this, (BootstrapTableContainer.__proto__ || Object.getPrototypeOf(BootstrapTableContainer)).call(this, props));

      _this.DataContext = (0, _dataContext2.default)();

      if (props.registerExposedAPI) {
        var exposedAPIEmitter = new _events2.default();
        exposedAPIEmitter.on('get.table.data', function (payload) {
          return payload.result = _this.table.getData();
        });
        exposedAPIEmitter.on('get.selected.rows', function (payload) {
          return payload.result = _this.selectionContext.getSelected();
        });
        exposedAPIEmitter.on('get.filtered.rows', function (payload) {
          if (_this.searchContext) {
            payload.result = _this.searchContext.getSearched();
          } else if (_this.filterContext) {
            payload.result = _this.filterContext.getFiltered();
          } else {
            payload.result = _this.table.getData();
          }
        });
        props.registerExposedAPI(exposedAPIEmitter);
      }

      if (props.columns.filter(function (col) {
        return col.sort;
      }).length > 0) {
        _this.SortContext = (0, _sortContext2.default)(_operators2.default, _this.isRemoteSort, _this.handleRemoteSortChange);
      }

      if (props.columnToggle || props.columns.filter(function (col) {
        return col.hidden;
      }).length > 0) {
        _this.ColumnManagementContext = (0, _columnContext2.default)();
      }

      if (props.selectRow) {
        _this.SelectionContext = _selectionContext2.default;
      }

      if (props.expandRow) {
        _this.RowExpandContext = _rowExpandContext2.default;
      }

      if (props.cellEdit && props.cellEdit.createContext) {
        _this.CellEditContext = props.cellEdit.createContext(_utils2.default, _operators2.default, _this.isRemoteCellEdit, _this.handleRemoteCellChange);
      }

      if (props.filter) {
        _this.FilterContext = props.filter.createContext(_utils2.default, _this.isRemoteFiltering, _this.handleRemoteFilterChange);
      }

      if (props.pagination) {
        _this.PaginationContext = props.pagination.createContext();
      }

      if (props.search && props.search.searchContext) {
        _this.SearchContext = props.search.searchContext(_utils2.default, _this.isRemoteSearch, _this.handleRemoteSearchChange);
      }

      if (props.setDependencyModules) {
        props.setDependencyModules(_utils2.default);
      }

      if (props.setPaginationRemoteEmitter) {
        props.setPaginationRemoteEmitter(_this.remoteEmitter);
      }
      return _this;
    }

    _createClass(BootstrapTableContainer, [{
      key: 'UNSAFE_componentWillReceiveProps',
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.columns.filter(function (col) {
          return col.sort;
        }).length <= 0) {
          this.SortContext = null;
        } else if (!this.SortContext) {
          this.SortContext = (0, _sortContext2.default)(_operators2.default, this.isRemoteSort, this.handleRemoteSortChange);
        }
        if (!nextProps.pagination && this.props.pagination) {
          this.PaginationContext = null;
        }
        if (nextProps.pagination && !this.props.pagination) {
          this.PaginationContext = nextProps.pagination.createContext(this.isRemotePagination, this.handleRemotePageChange);
        }
        if (!nextProps.cellEdit && this.props.cellEdit) {
          this.CellEditContext = null;
        }
        if (nextProps.cellEdit && !this.props.cellEdit) {
          this.CellEditContext = nextProps.cellEdit.createContext(_utils2.default, _operators2.default, this.isRemoteCellEdit, this.handleRemoteCellChange);
        }
      }
    }, {
      key: 'renderBase',
      value: function renderBase() {
        var _this2 = this;

        return function (rootProps, filterProps, searchProps, sortProps, paginationProps, columnToggleProps) {
          return _react2.default.createElement(Base, _extends({
            ref: function ref(n) {
              return _this2.table = n;
            }
          }, _this2.props, sortProps, filterProps, searchProps, paginationProps, columnToggleProps, {
            data: rootProps.getData(filterProps, searchProps, sortProps, paginationProps)
          }));
        };
      }
    }, {
      key: 'renderWithColumnManagementCtx',
      value: function renderWithColumnManagementCtx(base, baseProps) {
        var _this3 = this;

        return function (rootProps, filterProps, searchProps, sortProps, paginationProps) {
          return _react2.default.createElement(
            _this3.ColumnManagementContext.Provider,
            _extends({}, baseProps, {
              toggles: _this3.props.columnToggle ? _this3.props.columnToggle.toggles : null
            }),
            _react2.default.createElement(
              _this3.ColumnManagementContext.Consumer,
              null,
              function (columnToggleProps) {
                return base(rootProps, filterProps, searchProps, sortProps, paginationProps, columnToggleProps);
              }
            )
          );
        };
      }
    }, {
      key: 'renderWithSelectionCtx',
      value: function renderWithSelectionCtx(base, baseProps) {
        var _this4 = this;

        return function (rootProps, filterProps, searchProps, sortProps, paginationProps) {
          return _react2.default.createElement(
            _this4.SelectionContext.Provider,
            _extends({}, baseProps, {
              ref: function ref(n) {
                return _this4.selectionContext = n;
              },
              selectRow: _this4.props.selectRow,
              data: rootProps.getData(filterProps, searchProps, sortProps, paginationProps)
            }),
            base(rootProps, filterProps, searchProps, sortProps, paginationProps)
          );
        };
      }
    }, {
      key: 'renderWithRowExpandCtx',
      value: function renderWithRowExpandCtx(base, baseProps) {
        var _this5 = this;

        return function (rootProps, filterProps, searchProps, sortProps, paginationProps) {
          return _react2.default.createElement(
            _this5.RowExpandContext.Provider,
            _extends({}, baseProps, {
              ref: function ref(n) {
                return _this5.rowExpandContext = n;
              },
              expandRow: _this5.props.expandRow,
              data: rootProps.getData(filterProps, searchProps, sortProps, paginationProps)
            }),
            base(rootProps, filterProps, searchProps, sortProps, paginationProps)
          );
        };
      }
    }, {
      key: 'renderWithPaginationCtx',
      value: function renderWithPaginationCtx(base) {
        var _this6 = this;

        return function (rootProps, filterProps, searchProps, sortProps) {
          return _react2.default.createElement(
            _this6.PaginationContext.Provider,
            {
              ref: function ref(n) {
                return _this6.paginationContext = n;
              },
              pagination: _this6.props.pagination,
              data: rootProps.getData(filterProps, searchProps, sortProps),
              bootstrap4: _this6.props.bootstrap4,
              isRemotePagination: _this6.isRemotePagination,
              remoteEmitter: _this6.remoteEmitter,
              onDataSizeChange: _this6.props.onDataSizeChange,
              tableId: _this6.props.id
            },
            _react2.default.createElement(
              _this6.PaginationContext.Consumer,
              null,
              function (paginationProps) {
                return base(rootProps, filterProps, searchProps, sortProps, paginationProps);
              }
            )
          );
        };
      }
    }, {
      key: 'renderWithSortCtx',
      value: function renderWithSortCtx(base, baseProps) {
        var _this7 = this;

        return function (rootProps, filterProps, searchProps) {
          return _react2.default.createElement(
            _this7.SortContext.Provider,
            _extends({}, baseProps, {
              ref: function ref(n) {
                return _this7.sortContext = n;
              },
              defaultSorted: _this7.props.defaultSorted,
              defaultSortDirection: _this7.props.defaultSortDirection,
              sort: _this7.props.sort,
              data: rootProps.getData(filterProps, searchProps)
            }),
            _react2.default.createElement(
              _this7.SortContext.Consumer,
              null,
              function (sortProps) {
                return base(rootProps, filterProps, searchProps, sortProps);
              }
            )
          );
        };
      }
    }, {
      key: 'renderWithSearchCtx',
      value: function renderWithSearchCtx(base, baseProps) {
        var _this8 = this;

        return function (rootProps, filterProps) {
          return _react2.default.createElement(
            _this8.SearchContext.Provider,
            _extends({}, baseProps, {
              ref: function ref(n) {
                return _this8.searchContext = n;
              },
              data: rootProps.getData(filterProps),
              searchText: _this8.props.search.searchText,
              dataChangeListener: _this8.props.dataChangeListener
            }),
            _react2.default.createElement(
              _this8.SearchContext.Consumer,
              null,
              function (searchProps) {
                return base(rootProps, filterProps, searchProps);
              }
            )
          );
        };
      }
    }, {
      key: 'renderWithFilterCtx',
      value: function renderWithFilterCtx(base, baseProps) {
        var _this9 = this;

        return function (rootProps) {
          return _react2.default.createElement(
            _this9.FilterContext.Provider,
            _extends({}, baseProps, {
              ref: function ref(n) {
                return _this9.filterContext = n;
              },
              data: rootProps.getData(),
              filter: _this9.props.filter.options || {},
              dataChangeListener: _this9.props.dataChangeListener
            }),
            _react2.default.createElement(
              _this9.FilterContext.Consumer,
              null,
              function (filterProps) {
                return base(rootProps, filterProps);
              }
            )
          );
        };
      }
    }, {
      key: 'renderWithCellEditCtx',
      value: function renderWithCellEditCtx(base, baseProps) {
        var _this10 = this;

        return function (rootProps) {
          return _react2.default.createElement(
            _this10.CellEditContext.Provider,
            _extends({}, baseProps, {
              ref: function ref(n) {
                return _this10.cellEditContext = n;
              },
              selectRow: _this10.props.selectRow,
              cellEdit: _this10.props.cellEdit,
              data: rootProps.getData()
            }),
            base(rootProps)
          );
        };
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            keyField = _props.keyField,
            columns = _props.columns,
            bootstrap4 = _props.bootstrap4;

        var baseProps = { keyField: keyField, columns: columns };

        var base = this.renderBase();

        if (this.ColumnManagementContext) {
          base = this.renderWithColumnManagementCtx(base, baseProps);
        }

        if (this.SelectionContext) {
          base = this.renderWithSelectionCtx(base, baseProps);
        }

        if (this.RowExpandContext) {
          base = this.renderWithRowExpandCtx(base, baseProps);
        }

        if (this.PaginationContext) {
          base = this.renderWithPaginationCtx(base, baseProps);
        }

        if (this.SortContext) {
          base = this.renderWithSortCtx(base, baseProps);
        }

        if (this.SearchContext) {
          base = this.renderWithSearchCtx(base, baseProps);
        }

        if (this.FilterContext) {
          base = this.renderWithFilterCtx(base, baseProps);
        }

        if (this.CellEditContext) {
          base = this.renderWithCellEditCtx(base, baseProps);
        }

        return _react2.default.createElement(
          bootstrap.BootstrapContext.Provider,
          { value: { bootstrap4: bootstrap4 } },
          _react2.default.createElement(
            this.DataContext.Provider,
            _extends({}, baseProps, {
              data: this.props.data
            }),
            _react2.default.createElement(
              this.DataContext.Consumer,
              null,
              base
            )
          )
        );
      }
    }]);

    return BootstrapTableContainer;
  }((0, _remoteResolver3.default)(React__default.Component));
};

exports.default = withContext;
});

unwrapExports(contexts);

var lib = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _bootstrapTable2 = _interopRequireDefault(bootstrapTable);



var _contexts2 = _interopRequireDefault(contexts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _contexts2.default)(_bootstrapTable2.default);
});

var BootstrapTable = unwrapExports(lib);

var _const$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  PAGINATION_SIZE: 5,
  PAGE_START_INDEX: 1,
  With_FIRST_AND_LAST: true,
  SHOW_ALL_PAGE_BTNS: false,
  SHOW_TOTAL: false,
  PAGINATION_TOTAL: null,
  FIRST_PAGE_TEXT: '<<',
  PRE_PAGE_TEXT: '<',
  NEXT_PAGE_TEXT: '>',
  LAST_PAGE_TEXT: '>>',
  NEXT_PAGE_TITLE: 'next page',
  LAST_PAGE_TITLE: 'last page',
  PRE_PAGE_TITLE: 'previous page',
  FIRST_PAGE_TITLE: 'first page',
  SIZE_PER_PAGE_LIST: [10, 25, 30, 50],
  HIDE_SIZE_PER_PAGE: false,
  HIDE_PAGE_LIST_ONLY_ONE_PAGE: false
};
});

unwrapExports(_const$1);

var page = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getByCurrPage = exports.alignPage = undefined;



var _const2 = _interopRequireDefault(_const$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getNormalizedPage = function getNormalizedPage(page, pageStartIndex) {
  var offset = Math.abs(1 - pageStartIndex);
  return page + offset;
};

var endIndex = function endIndex(page, sizePerPage, pageStartIndex) {
  return getNormalizedPage(page, pageStartIndex) * sizePerPage - 1;
};

var startIndex = function startIndex(end, sizePerPage) {
  return end - (sizePerPage - 1);
};

var alignPage = exports.alignPage = function alignPage(dataSize, prevDataSize, page, sizePerPage, pageStartIndex) {
  if (prevDataSize < dataSize) return page;
  if (page < pageStartIndex) return pageStartIndex;
  if (dataSize <= 0) return pageStartIndex;
  if (page >= Math.floor(dataSize / sizePerPage) + pageStartIndex && pageStartIndex === 1) {
    return Math.ceil(dataSize / sizePerPage);
  }
  if (page >= Math.floor(dataSize / sizePerPage) && pageStartIndex === 0) {
    var newPage = Math.ceil(dataSize / sizePerPage);
    return newPage - Math.abs(_const2.default.PAGE_START_INDEX - pageStartIndex);
  }
  return page;
};

var getByCurrPage = exports.getByCurrPage = function getByCurrPage(data, page, sizePerPage, pageStartIndex) {
  var dataSize = data.length;
  if (!dataSize) return [];

  var end = endIndex(page, sizePerPage, pageStartIndex);
  var start = startIndex(end, sizePerPage);

  var result = [];
  for (var i = start; i <= end; i += 1) {
    result.push(data[i]);
    if (i + 1 === dataSize) break;
  }
  return result;
};
});

unwrapExports(page);
var page_1 = page.getByCurrPage;
var page_2 = page.alignPage;

var stateContext = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _events2 = _interopRequireDefault(events);



var _const2 = _interopRequireDefault(_const$1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
/* eslint react/require-default-props: 0 */
/* eslint no-lonely-if: 0 */
/* eslint camelcase: 0 */


var StateContext = _react2.default.createContext();

var StateProvider = function (_React$Component) {
  _inherits(StateProvider, _React$Component);

  function StateProvider(props) {
    _classCallCheck(this, StateProvider);

    var _this = _possibleConstructorReturn(this, (StateProvider.__proto__ || Object.getPrototypeOf(StateProvider)).call(this, props));

    _initialiseProps.call(_this);

    _this.handleChangePage = _this.handleChangePage.bind(_this);
    _this.handleDataSizeChange = _this.handleDataSizeChange.bind(_this);
    _this.handleChangeSizePerPage = _this.handleChangeSizePerPage.bind(_this);

    var currPage = void 0;
    var currSizePerPage = void 0;
    var options = props.pagination.options;

    var sizePerPageList = options.sizePerPageList || _const2.default.SIZE_PER_PAGE_LIST;

    // initialize current page
    if (typeof options.page !== 'undefined') {
      currPage = options.page;
    } else if (typeof options.pageStartIndex !== 'undefined') {
      currPage = options.pageStartIndex;
    } else {
      currPage = _const2.default.PAGE_START_INDEX;
    }

    // initialize current sizePerPage
    if (typeof options.sizePerPage !== 'undefined') {
      currSizePerPage = options.sizePerPage;
    } else if (_typeof(sizePerPageList[0]) === 'object') {
      currSizePerPage = sizePerPageList[0].value;
    } else {
      currSizePerPage = sizePerPageList[0];
    }

    _this.currPage = currPage;
    _this.dataSize = options.totalSize;
    _this.currSizePerPage = currSizePerPage;
    _this.dataChangeListener = new _events2.default();
    _this.dataChangeListener.on('filterChanged', _this.handleDataSizeChange);
    return _this;
  }

  _createClass(StateProvider, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var custom = nextProps.pagination.options.custom;

      // user should align the page when the page is not fit to the data size when remote enable

      if (this.isRemotePagination() || custom) {
        if (typeof nextProps.pagination.options.page !== 'undefined') {
          this.currPage = nextProps.pagination.options.page;
        }
        if (typeof nextProps.pagination.options.sizePerPage !== 'undefined') {
          this.currSizePerPage = nextProps.pagination.options.sizePerPage;
        }
        if (typeof nextProps.pagination.options.totalSize !== 'undefined') {
          this.dataSize = nextProps.pagination.options.totalSize;
        }
      }
    }
  }, {
    key: 'handleDataSizeChange',
    value: function handleDataSizeChange(newDataSize) {
      var options = this.props.pagination.options;

      var pageStartIndex = typeof options.pageStartIndex === 'undefined' ? _const2.default.PAGE_START_INDEX : options.pageStartIndex;
      this.currPage = (0, page.alignPage)(newDataSize, this.dataSize, this.currPage, this.currSizePerPage, pageStartIndex);
      this.dataSize = newDataSize;
      this.forceUpdate();
    }
  }, {
    key: 'handleChangePage',
    value: function handleChangePage(currPage) {
      var currSizePerPage = this.currSizePerPage;
      var options = this.props.pagination.options;


      if (options.onPageChange) {
        options.onPageChange(currPage, currSizePerPage);
      }

      this.currPage = currPage;

      if (this.isRemotePagination()) {
        this.getPaginationRemoteEmitter().emit('paginationChange', currPage, currSizePerPage);
        return;
      }
      this.forceUpdate();
    }
  }, {
    key: 'handleChangeSizePerPage',
    value: function handleChangeSizePerPage(currSizePerPage, currPage) {
      var options = this.props.pagination.options;


      if (options.onSizePerPageChange) {
        options.onSizePerPageChange(currSizePerPage, currPage);
      }

      this.currPage = currPage;
      this.currSizePerPage = currSizePerPage;

      if (this.isRemotePagination()) {
        this.getPaginationRemoteEmitter().emit('paginationChange', currPage, currSizePerPage);
        return;
      }
      this.forceUpdate();
    }
  }, {
    key: 'render',
    value: function render() {
      var paginationProps = this.getPaginationProps();
      var pagination = _extends({}, this.props.pagination, {
        options: paginationProps
      });

      return _react2.default.createElement(
        StateContext.Provider,
        {
          value: {
            paginationProps: paginationProps,
            paginationTableProps: {
              pagination: pagination,
              setPaginationRemoteEmitter: this.setPaginationRemoteEmitter,
              dataChangeListener: this.dataChangeListener
            }
          }
        },
        this.props.children
      );
    }
  }]);

  return StateProvider;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getPaginationProps = function () {
    var _props = _this2.props,
        options = _props.pagination.options,
        bootstrap4 = _props.bootstrap4,
        tableId = _props.tableId;
    var currPage = _this2.currPage,
        currSizePerPage = _this2.currSizePerPage,
        dataSize = _this2.dataSize;

    var withFirstAndLast = typeof options.withFirstAndLast === 'undefined' ? _const2.default.With_FIRST_AND_LAST : options.withFirstAndLast;
    var alwaysShowAllBtns = typeof options.alwaysShowAllBtns === 'undefined' ? _const2.default.SHOW_ALL_PAGE_BTNS : options.alwaysShowAllBtns;
    var hideSizePerPage = typeof options.hideSizePerPage === 'undefined' ? _const2.default.HIDE_SIZE_PER_PAGE : options.hideSizePerPage;
    var hidePageListOnlyOnePage = typeof options.hidePageListOnlyOnePage === 'undefined' ? _const2.default.HIDE_PAGE_LIST_ONLY_ONE_PAGE : options.hidePageListOnlyOnePage;
    var pageStartIndex = typeof options.pageStartIndex === 'undefined' ? _const2.default.PAGE_START_INDEX : options.pageStartIndex;
    return _extends({}, options, {
      bootstrap4: bootstrap4,
      tableId: tableId,
      page: currPage,
      sizePerPage: currSizePerPage,
      pageStartIndex: pageStartIndex,
      hidePageListOnlyOnePage: hidePageListOnlyOnePage,
      hideSizePerPage: hideSizePerPage,
      alwaysShowAllBtns: alwaysShowAllBtns,
      withFirstAndLast: withFirstAndLast,
      dataSize: dataSize,
      sizePerPageList: options.sizePerPageList || _const2.default.SIZE_PER_PAGE_LIST,
      paginationSize: options.paginationSize || _const2.default.PAGINATION_SIZE,
      showTotal: options.showTotal,
      pageListRenderer: options.pageListRenderer,
      pageButtonRenderer: options.pageButtonRenderer,
      sizePerPageRenderer: options.sizePerPageRenderer,
      paginationTotalRenderer: options.paginationTotalRenderer,
      sizePerPageOptionRenderer: options.sizePerPageOptionRenderer,
      firstPageText: options.firstPageText || _const2.default.FIRST_PAGE_TEXT,
      prePageText: options.prePageText || _const2.default.PRE_PAGE_TEXT,
      nextPageText: options.nextPageText || _const2.default.NEXT_PAGE_TEXT,
      lastPageText: options.lastPageText || _const2.default.LAST_PAGE_TEXT,
      prePageTitle: options.prePageTitle || _const2.default.PRE_PAGE_TITLE,
      nextPageTitle: options.nextPageTitle || _const2.default.NEXT_PAGE_TITLE,
      firstPageTitle: options.firstPageTitle || _const2.default.FIRST_PAGE_TITLE,
      lastPageTitle: options.lastPageTitle || _const2.default.LAST_PAGE_TITLE,
      onPageChange: _this2.handleChangePage,
      onSizePerPageChange: _this2.handleChangeSizePerPage
    });
  };

  this.setPaginationRemoteEmitter = function (remoteEmitter) {
    _this2.remoteEmitter = remoteEmitter;
  };

  this.getPaginationRemoteEmitter = function () {
    return _this2.remoteEmitter || _this2.props.remoteEmitter;
  };

  this.isRemotePagination = function () {
    var e = {};
    _this2.remoteEmitter.emit('isRemotePagination', e);
    return e.result;
  };
};

exports.default = function () {
  return {
    Provider: StateProvider,
    Consumer: StateContext.Consumer
  };
};
});

unwrapExports(stateContext);

var pageResolver = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _const2 = _interopRequireDefault(_const$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-mixed-operators: 0 */


exports.default = function (ExtendBase) {
  return function (_ExtendBase) {
    _inherits(PageResolver, _ExtendBase);

    function PageResolver() {
      _classCallCheck(this, PageResolver);

      return _possibleConstructorReturn(this, (PageResolver.__proto__ || Object.getPrototypeOf(PageResolver)).apply(this, arguments));
    }

    _createClass(PageResolver, [{
      key: 'backToPrevPage',
      value: function backToPrevPage() {
        var _props = this.props,
            currPage = _props.currPage,
            pageStartIndex = _props.pageStartIndex;

        return currPage - 1 < pageStartIndex ? pageStartIndex : currPage - 1;
      }
    }, {
      key: 'initialState',
      value: function initialState() {
        var totalPages = this.calculateTotalPage();
        var lastPage = this.calculateLastPage(totalPages);
        return { totalPages: totalPages, lastPage: lastPage };
      }
    }, {
      key: 'calculateTotalPage',
      value: function calculateTotalPage() {
        var sizePerPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.currSizePerPage;
        var dataSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.dataSize;

        return Math.ceil(dataSize / sizePerPage);
      }
    }, {
      key: 'calculateLastPage',
      value: function calculateLastPage(totalPages) {
        var pageStartIndex = this.props.pageStartIndex;

        return pageStartIndex + totalPages - 1;
      }
    }, {
      key: 'calculateFromTo',
      value: function calculateFromTo() {
        var _props2 = this.props,
            dataSize = _props2.dataSize,
            currPage = _props2.currPage,
            currSizePerPage = _props2.currSizePerPage,
            pageStartIndex = _props2.pageStartIndex;

        var offset = Math.abs(_const2.default.PAGE_START_INDEX - pageStartIndex);

        var from = (currPage - pageStartIndex) * currSizePerPage;
        from = dataSize === 0 ? 0 : from + 1;
        var to = Math.min(currSizePerPage * (currPage + offset), dataSize);
        if (to > dataSize) to = dataSize;

        return [from, to];
      }
    }, {
      key: 'calculatePages',
      value: function calculatePages(totalPages, lastPage) {
        var _props3 = this.props,
            currPage = _props3.currPage,
            paginationSize = _props3.paginationSize,
            pageStartIndex = _props3.pageStartIndex,
            withFirstAndLast = _props3.withFirstAndLast,
            firstPageText = _props3.firstPageText,
            prePageText = _props3.prePageText,
            nextPageText = _props3.nextPageText,
            lastPageText = _props3.lastPageText,
            alwaysShowAllBtns = _props3.alwaysShowAllBtns;


        var pages = [];
        var endPage = totalPages;
        if (endPage <= 0) return [];

        var startPage = Math.max(currPage - Math.floor(paginationSize / 2), pageStartIndex);
        endPage = startPage + paginationSize - 1;

        if (endPage > lastPage) {
          endPage = lastPage;
          startPage = endPage - paginationSize + 1;
        }

        if (alwaysShowAllBtns) {
          if (withFirstAndLast) {
            pages = [firstPageText, prePageText];
          } else {
            pages = [prePageText];
          }
        }

        if (startPage !== pageStartIndex && totalPages > paginationSize && withFirstAndLast && pages.length === 0) {
          pages = [firstPageText, prePageText];
        } else if (totalPages > 1 && pages.length === 0) {
          pages = [prePageText];
        }

        for (var i = startPage; i <= endPage; i += 1) {
          if (i >= pageStartIndex) pages.push(i);
        }

        if (alwaysShowAllBtns || endPage <= lastPage && pages.length > 1) {
          pages.push(nextPageText);
        }
        if (endPage !== lastPage && withFirstAndLast || withFirstAndLast && alwaysShowAllBtns) {
          pages.push(lastPageText);
        }

        // if ((endPage <= lastPage && pages.length > 1) || alwaysShowAllBtns) {
        //   pages.push(nextPageText);
        // }
        // if (endPage !== lastPage && withFirstAndLast) {
        //   pages.push(lastPageText);
        // }

        return pages;
      }
    }, {
      key: 'calculatePageStatus',
      value: function calculatePageStatus() {
        var pages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var _this2 = this;

        var lastPage = arguments[1];
        var disablePageTitle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var _props4 = this.props,
            currPage = _props4.currPage,
            pageStartIndex = _props4.pageStartIndex,
            firstPageText = _props4.firstPageText,
            prePageText = _props4.prePageText,
            nextPageText = _props4.nextPageText,
            lastPageText = _props4.lastPageText,
            alwaysShowAllBtns = _props4.alwaysShowAllBtns;

        var isStart = function isStart(page) {
          return currPage === pageStartIndex && (page === firstPageText || page === prePageText);
        };
        var isEnd = function isEnd(page) {
          return currPage === lastPage && (page === nextPageText || page === lastPageText);
        };

        return pages.filter(function (page) {
          if (alwaysShowAllBtns) {
            return true;
          }
          return !(isStart(page) || isEnd(page));
        }).map(function (page) {
          var title = void 0;
          var active = page === currPage;
          var disabled = isStart(page) || isEnd(page);

          if (page === nextPageText) {
            title = _this2.props.nextPageTitle;
          } else if (page === prePageText) {
            title = _this2.props.prePageTitle;
          } else if (page === firstPageText) {
            title = _this2.props.firstPageTitle;
          } else if (page === lastPageText) {
            title = _this2.props.lastPageTitle;
          } else {
            title = '' + page;
          }

          var pageResult = { page: page, active: active, disabled: disabled };
          if (!disablePageTitle) {
            pageResult.title = title;
          }
          return pageResult;
        });
      }
    }, {
      key: 'calculateSizePerPageStatus',
      value: function calculateSizePerPageStatus() {
        var sizePerPageList = this.props.sizePerPageList;

        return sizePerPageList.map(function (_sizePerPage) {
          var pageText = typeof _sizePerPage.text !== 'undefined' ? _sizePerPage.text : _sizePerPage;
          var pageNumber = typeof _sizePerPage.value !== 'undefined' ? _sizePerPage.value : _sizePerPage;
          return {
            text: '' + pageText,
            page: pageNumber
          };
        });
      }
    }]);

    return PageResolver;
  }(ExtendBase);
};
});

unwrapExports(pageResolver);

var paginationHandler = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _pageResolver3 = _interopRequireDefault(pageResolver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
/* eslint camelcase: 0 */


exports.default = function (WrappedComponent) {
  return function (_pageResolver) {
    _inherits(PaginationHandler, _pageResolver);

    function PaginationHandler(props) {
      _classCallCheck(this, PaginationHandler);

      var _this = _possibleConstructorReturn(this, (PaginationHandler.__proto__ || Object.getPrototypeOf(PaginationHandler)).call(this, props));

      _this.handleChangePage = _this.handleChangePage.bind(_this);
      _this.handleChangeSizePerPage = _this.handleChangeSizePerPage.bind(_this);
      _this.state = _this.initialState();
      return _this;
    }

    _createClass(PaginationHandler, [{
      key: 'UNSAFE_componentWillReceiveProps',
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        var dataSize = nextProps.dataSize,
            currSizePerPage = nextProps.currSizePerPage;

        if (currSizePerPage !== this.props.currSizePerPage || dataSize !== this.props.dataSize) {
          var totalPages = this.calculateTotalPage(currSizePerPage, dataSize);
          var lastPage = this.calculateLastPage(totalPages);
          this.setState({ totalPages: totalPages, lastPage: lastPage });
        }
      }
    }, {
      key: 'handleChangeSizePerPage',
      value: function handleChangeSizePerPage(sizePerPage) {
        var _props = this.props,
            currSizePerPage = _props.currSizePerPage,
            onSizePerPageChange = _props.onSizePerPageChange;

        var selectedSize = typeof sizePerPage === 'string' ? parseInt(sizePerPage, 10) : sizePerPage;
        var currPage = this.props.currPage;

        if (selectedSize !== currSizePerPage) {
          var newTotalPages = this.calculateTotalPage(selectedSize);
          var newLastPage = this.calculateLastPage(newTotalPages);
          if (currPage > newLastPage) currPage = newLastPage;
          onSizePerPageChange(selectedSize, currPage);
        }
      }
    }, {
      key: 'handleChangePage',
      value: function handleChangePage(newPage) {
        var page = void 0;
        var _props2 = this.props,
            currPage = _props2.currPage,
            pageStartIndex = _props2.pageStartIndex,
            prePageText = _props2.prePageText,
            nextPageText = _props2.nextPageText,
            lastPageText = _props2.lastPageText,
            firstPageText = _props2.firstPageText,
            onPageChange = _props2.onPageChange;
        var lastPage = this.state.lastPage;


        if (newPage === prePageText) {
          page = this.backToPrevPage();
        } else if (newPage === nextPageText) {
          page = currPage + 1 > lastPage ? lastPage : currPage + 1;
        } else if (newPage === lastPageText) {
          page = lastPage;
        } else if (newPage === firstPageText) {
          page = pageStartIndex;
        } else {
          page = parseInt(newPage, 10);
        }
        if (page !== currPage) {
          onPageChange(page);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
          lastPage: this.state.lastPage,
          totalPages: this.state.totalPages,
          onPageChange: this.handleChangePage,
          onSizePerPageChange: this.handleChangeSizePerPage
        }));
      }
    }]);

    return PaginationHandler;
  }((0, _pageResolver3.default)(React__default.Component));
};
});

unwrapExports(paginationHandler);

var sizePerPageOption = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint jsx-a11y/href-no-hash: 0 */
var SizePerPageOption = function SizePerPageOption(_ref) {
  var text = _ref.text,
      page = _ref.page,
      onSizePerPageChange = _ref.onSizePerPageChange,
      bootstrap4 = _ref.bootstrap4;
  return bootstrap4 ? _react2.default.createElement(
    'a',
    {
      href: '#',
      tabIndex: '-1',
      role: 'menuitem',
      className: 'dropdown-item',
      'data-page': page,
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
        onSizePerPageChange(page);
      }
    },
    text
  ) : _react2.default.createElement(
    'li',
    {
      key: text,
      role: 'presentation',
      className: 'dropdown-item'
    },
    _react2.default.createElement(
      'a',
      {
        href: '#',
        tabIndex: '-1',
        role: 'menuitem',
        'data-page': page,
        onMouseDown: function onMouseDown(e) {
          e.preventDefault();
          onSizePerPageChange(page);
        }
      },
      text
    )
  );
};

SizePerPageOption.propTypes = {
  text: _propTypes2.default.string.isRequired,
  page: _propTypes2.default.number.isRequired,
  onSizePerPageChange: _propTypes2.default.func.isRequired,
  bootstrap4: _propTypes2.default.bool
};

SizePerPageOption.defaultProps = {
  bootstrap4: false
};

exports.default = SizePerPageOption;
});

unwrapExports(sizePerPageOption);

var sizePerPageDropdown = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default);



var _classnames2 = _interopRequireDefault(classnames);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _sizePerPageOption2 = _interopRequireDefault(sizePerPageOption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sizePerPageDefaultClass = 'react-bs-table-sizePerPage-dropdown';

var SizePerPageDropDown = function SizePerPageDropDown(props) {
  var open = props.open,
      tableId = props.tableId,
      hidden = props.hidden,
      onClick = props.onClick,
      onBlur = props.onBlur,
      options = props.options,
      className = props.className,
      variation = props.variation,
      bootstrap4 = props.bootstrap4,
      btnContextual = props.btnContextual,
      optionRenderer = props.optionRenderer,
      currSizePerPage = props.currSizePerPage,
      onSizePerPageChange = props.onSizePerPageChange;


  var dropDownStyle = { visibility: hidden ? 'hidden' : 'visible' };
  var openClass = open ? 'open show' : '';
  var dropdownClasses = (0, _classnames2.default)(openClass, sizePerPageDefaultClass, variation, className);

  var id = tableId ? tableId + '-pageDropDown' : 'pageDropDown';

  return _react2.default.createElement(
    'span',
    {
      style: dropDownStyle,
      className: dropdownClasses
    },
    _react2.default.createElement(
      'button',
      {
        id: id,
        type: 'button',
        className: 'btn ' + btnContextual + ' dropdown-toggle',
        'data-toggle': 'dropdown',
        'aria-expanded': open,
        onClick: onClick,
        onBlur: onBlur
      },
      currSizePerPage,
      ' ',
      bootstrap4 ? null : _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('span', { className: 'caret' })
      )
    ),
    _react2.default.createElement(
      'ul',
      {
        className: 'dropdown-menu ' + openClass,
        role: 'menu',
        'aria-labelledby': id
      },
      options.map(function (option) {
        if (optionRenderer) {
          return optionRenderer(_extends({}, option, {
            onSizePerPageChange: onSizePerPageChange
          }));
        }
        return _react2.default.createElement(_sizePerPageOption2.default, _extends({}, option, {
          key: option.text,
          bootstrap4: bootstrap4,
          onSizePerPageChange: onSizePerPageChange
        }));
      })
    )
  );
};

SizePerPageDropDown.propTypes = {
  currSizePerPage: _propTypes2.default.string.isRequired,
  options: _propTypes2.default.array.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func.isRequired,
  onSizePerPageChange: _propTypes2.default.func.isRequired,
  bootstrap4: _propTypes2.default.bool,
  tableId: _propTypes2.default.string,
  open: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool,
  btnContextual: _propTypes2.default.string,
  variation: _propTypes2.default.oneOf(['dropdown', 'dropup']),
  className: _propTypes2.default.string,
  optionRenderer: _propTypes2.default.func
};
SizePerPageDropDown.defaultProps = {
  open: false,
  hidden: false,
  btnContextual: 'btn-default btn-secondary',
  variation: 'dropdown',
  className: '',
  optionRenderer: null,
  bootstrap4: false,
  tableId: null
};

exports.default = SizePerPageDropDown;
});

unwrapExports(sizePerPageDropdown);

var sizePerPageDropdownAdapter_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizePerPageDropdownWithAdapter = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _pageResolver3 = _interopRequireDefault(pageResolver);



var _sizePerPageDropdown2 = _interopRequireDefault(sizePerPageDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var sizePerPageDropdownAdapter = function sizePerPageDropdownAdapter(WrappedComponent) {
  return function (_pageResolver) {
    _inherits(SizePerPageDropdownAdapter, _pageResolver);

    function SizePerPageDropdownAdapter(props) {
      _classCallCheck(this, SizePerPageDropdownAdapter);

      var _this = _possibleConstructorReturn(this, (SizePerPageDropdownAdapter.__proto__ || Object.getPrototypeOf(SizePerPageDropdownAdapter)).call(this, props));

      _this.closeDropDown = _this.closeDropDown.bind(_this);
      _this.toggleDropDown = _this.toggleDropDown.bind(_this);
      _this.handleChangeSizePerPage = _this.handleChangeSizePerPage.bind(_this);
      _this.state = { dropdownOpen: false };
      return _this;
    }

    _createClass(SizePerPageDropdownAdapter, [{
      key: 'toggleDropDown',
      value: function toggleDropDown() {
        var dropdownOpen = !this.state.dropdownOpen;
        this.setState(function () {
          return { dropdownOpen: dropdownOpen };
        });
      }
    }, {
      key: 'closeDropDown',
      value: function closeDropDown() {
        this.setState(function () {
          return { dropdownOpen: false };
        });
      }
    }, {
      key: 'handleChangeSizePerPage',
      value: function handleChangeSizePerPage(sizePerPage) {
        this.props.onSizePerPageChange(sizePerPage);
        this.closeDropDown();
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            tableId = _props.tableId,
            bootstrap4 = _props.bootstrap4,
            sizePerPageList = _props.sizePerPageList,
            currSizePerPage = _props.currSizePerPage,
            hideSizePerPage = _props.hideSizePerPage,
            sizePerPageRenderer = _props.sizePerPageRenderer,
            sizePerPageOptionRenderer = _props.sizePerPageOptionRenderer;
        var open = this.state.dropdownOpen;


        if (sizePerPageList.length > 1 && !hideSizePerPage) {
          if (sizePerPageRenderer) {
            return sizePerPageRenderer({
              options: this.calculateSizePerPageStatus(),
              currSizePerPage: '' + currSizePerPage,
              onSizePerPageChange: this.handleChangeSizePerPage
            });
          }
          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
            currSizePerPage: '' + currSizePerPage,
            options: this.calculateSizePerPageStatus(),
            optionRenderer: sizePerPageOptionRenderer,
            onSizePerPageChange: this.handleChangeSizePerPage,
            onClick: this.toggleDropDown,
            onBlur: this.closeDropDown,
            open: open,
            tableId: tableId,
            bootstrap4: bootstrap4
          }));
        }
        return null;
      }
    }]);

    return SizePerPageDropdownAdapter;
  }((0, _pageResolver3.default)(React__default.Component));
};

var SizePerPageDropdownWithAdapter = exports.SizePerPageDropdownWithAdapter = sizePerPageDropdownAdapter(_sizePerPageDropdown2.default);
exports.default = sizePerPageDropdownAdapter;
});

unwrapExports(sizePerPageDropdownAdapter_1);
var sizePerPageDropdownAdapter_2 = sizePerPageDropdownAdapter_1.SizePerPageDropdownWithAdapter;

var pageButton = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _classnames2 = _interopRequireDefault(classnames);



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/require-default-props: 0 */
/* eslint jsx-a11y/href-no-hash: 0 */


var PageButton = function (_Component) {
  _inherits(PageButton, _Component);

  function PageButton(props) {
    _classCallCheck(this, PageButton);

    var _this = _possibleConstructorReturn(this, (PageButton.__proto__ || Object.getPrototypeOf(PageButton)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(PageButton, [{
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();
      this.props.onPageChange(this.props.page);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          page = _props.page,
          title = _props.title,
          active = _props.active,
          disabled = _props.disabled,
          className = _props.className;

      var classes = (0, _classnames2.default)({
        active: active,
        disabled: disabled,
        'page-item': true
      }, className);

      return _react2.default.createElement(
        'li',
        { className: classes, title: title },
        _react2.default.createElement(
          'a',
          { href: '#', onClick: this.handleClick, className: 'page-link' },
          page
        )
      );
    }
  }]);

  return PageButton;
}(React__default.Component);

PageButton.propTypes = {
  onPageChange: _propTypes2.default.func.isRequired,
  page: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.number, _propTypes2.default.string]).isRequired,
  active: _propTypes2.default.bool.isRequired,
  disabled: _propTypes2.default.bool.isRequired,
  className: _propTypes2.default.string,
  title: _propTypes2.default.string
};

exports.default = PageButton;
});

unwrapExports(pageButton);

var paginationList = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _pageButton2 = _interopRequireDefault(pageButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginatonList = function PaginatonList(props) {
  return _react2.default.createElement(
    'ul',
    { className: 'pagination react-bootstrap-table-page-btns-ul' },
    props.pages.map(function (pageProps) {
      if (props.pageButtonRenderer) {
        return props.pageButtonRenderer(_extends({}, pageProps, {
          onPageChange: props.onPageChange
        }));
      }
      return _react2.default.createElement(_pageButton2.default, _extends({
        key: pageProps.page
      }, pageProps, {
        onPageChange: props.onPageChange
      }));
    })
  );
};

PaginatonList.propTypes = {
  pages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    page: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.number, _propTypes2.default.string]),
    active: _propTypes2.default.bool,
    disable: _propTypes2.default.bool,
    title: _propTypes2.default.string
  })).isRequired,
  onPageChange: _propTypes2.default.func.isRequired,
  pageButtonRenderer: _propTypes2.default.func
};

PaginatonList.defaultProps = {
  pageButtonRenderer: null
};

exports.default = PaginatonList;
});

unwrapExports(paginationList);

var paginationListAdapter_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationListWithAdapter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _pageResolver3 = _interopRequireDefault(pageResolver);



var _paginationList2 = _interopRequireDefault(paginationList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var paginationListAdapter = function paginationListAdapter(WrappedComponent) {
  return function (_pageResolver) {
    _inherits(PaginationListAdapter, _pageResolver);

    function PaginationListAdapter() {
      _classCallCheck(this, PaginationListAdapter);

      return _possibleConstructorReturn(this, (PaginationListAdapter.__proto__ || Object.getPrototypeOf(PaginationListAdapter)).apply(this, arguments));
    }

    _createClass(PaginationListAdapter, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            lastPage = _props.lastPage,
            totalPages = _props.totalPages,
            pageButtonRenderer = _props.pageButtonRenderer,
            onPageChange = _props.onPageChange,
            disablePageTitle = _props.disablePageTitle,
            hidePageListOnlyOnePage = _props.hidePageListOnlyOnePage;

        var pages = this.calculatePageStatus(this.calculatePages(totalPages, lastPage), lastPage, disablePageTitle);
        if (totalPages === 1 && hidePageListOnlyOnePage) {
          return null;
        }
        return _react2.default.createElement(WrappedComponent, {
          pageButtonRenderer: pageButtonRenderer,
          onPageChange: onPageChange,
          pages: pages
        });
      }
    }]);

    return PaginationListAdapter;
  }((0, _pageResolver3.default)(React__default.Component));
};

var PaginationListWithAdapter = exports.PaginationListWithAdapter = paginationListAdapter(_paginationList2.default);
exports.default = paginationListAdapter;
});

unwrapExports(paginationListAdapter_1);
var paginationListAdapter_2 = paginationListAdapter_1.PaginationListWithAdapter;

var paginationTotal = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationTotal = function PaginationTotal(props) {
  if (props.paginationTotalRenderer) {
    return props.paginationTotalRenderer(props.from, props.to, props.dataSize);
  }
  return _react2.default.createElement(
    'span',
    { className: 'react-bootstrap-table-pagination-total' },
    '\xA0Showing rows ',
    props.from,
    ' to\xA0',
    props.to,
    ' of\xA0',
    props.dataSize
  );
};

PaginationTotal.propTypes = {
  from: _propTypes2.default.number.isRequired,
  to: _propTypes2.default.number.isRequired,
  dataSize: _propTypes2.default.number.isRequired,
  paginationTotalRenderer: _propTypes2.default.func
};

PaginationTotal.defaultProps = {
  paginationTotalRenderer: undefined
};

exports.default = PaginationTotal;
});

unwrapExports(paginationTotal);

var paginationTotalAdapter_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationTotalWithAdapter = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _pageResolver3 = _interopRequireDefault(pageResolver);



var _paginationTotal2 = _interopRequireDefault(paginationTotal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var paginationTotalAdapter = function paginationTotalAdapter(WrappedComponent) {
  return function (_pageResolver) {
    _inherits(PaginationTotalAdapter, _pageResolver);

    function PaginationTotalAdapter() {
      _classCallCheck(this, PaginationTotalAdapter);

      return _possibleConstructorReturn(this, (PaginationTotalAdapter.__proto__ || Object.getPrototypeOf(PaginationTotalAdapter)).apply(this, arguments));
    }

    _createClass(PaginationTotalAdapter, [{
      key: 'render',
      value: function render() {
        var _calculateFromTo = this.calculateFromTo(),
            _calculateFromTo2 = _slicedToArray(_calculateFromTo, 2),
            from = _calculateFromTo2[0],
            to = _calculateFromTo2[1];

        return _react2.default.createElement(WrappedComponent, {
          from: from,
          to: to,
          dataSize: this.props.dataSize,
          paginationTotalRenderer: this.props.paginationTotalRenderer
        });
      }
    }]);

    return PaginationTotalAdapter;
  }((0, _pageResolver3.default)(React__default.Component));
};

var PaginationTotalWithAdapter = exports.PaginationTotalWithAdapter = paginationTotalAdapter(_paginationTotal2.default);
exports.default = paginationTotalAdapter;
});

unwrapExports(paginationTotalAdapter_1);
var paginationTotalAdapter_2 = paginationTotalAdapter_1.PaginationTotalWithAdapter;

var pagination = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _classnames2 = _interopRequireDefault(classnames);



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _pageResolver3 = _interopRequireDefault(pageResolver);



var _paginationHandler2 = _interopRequireDefault(paginationHandler);









var _const2 = _interopRequireDefault(_const$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/require-default-props: 0 */
/* eslint arrow-body-style: 0 */


var Pagination = function (_pageResolver) {
  _inherits(Pagination, _pageResolver);

  function Pagination() {
    _classCallCheck(this, Pagination);

    return _possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).apply(this, arguments));
  }

  _createClass(Pagination, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          tableId = _props.tableId,
          currPage = _props.currPage,
          pageStartIndex = _props.pageStartIndex,
          showTotal = _props.showTotal,
          dataSize = _props.dataSize,
          pageListRenderer = _props.pageListRenderer,
          pageButtonRenderer = _props.pageButtonRenderer,
          paginationTotalRenderer = _props.paginationTotalRenderer,
          hidePageListOnlyOnePage = _props.hidePageListOnlyOnePage,
          totalPages = _props.totalPages,
          lastPage = _props.lastPage,
          onPageChange = _props.onPageChange,
          sizePerPageList = _props.sizePerPageList,
          currSizePerPage = _props.currSizePerPage,
          hideSizePerPage = _props.hideSizePerPage,
          sizePerPageRenderer = _props.sizePerPageRenderer,
          sizePerPageOptionRenderer = _props.sizePerPageOptionRenderer,
          onSizePerPageChange = _props.onSizePerPageChange,
          bootstrap4 = _props.bootstrap4,
          rest = _objectWithoutProperties(_props, ['tableId', 'currPage', 'pageStartIndex', 'showTotal', 'dataSize', 'pageListRenderer', 'pageButtonRenderer', 'paginationTotalRenderer', 'hidePageListOnlyOnePage', 'totalPages', 'lastPage', 'onPageChange', 'sizePerPageList', 'currSizePerPage', 'hideSizePerPage', 'sizePerPageRenderer', 'sizePerPageOptionRenderer', 'onSizePerPageChange', 'bootstrap4']);

      var pages = this.calculatePageStatus(this.calculatePages(totalPages, lastPage), lastPage);
      var pageListClass = (0, _classnames2.default)('react-bootstrap-table-pagination-list', 'col-md-6 col-xs-6 col-sm-6 col-lg-6', {
        'react-bootstrap-table-pagination-list-hidden': hidePageListOnlyOnePage && totalPages === 1
      });
      return _react2.default.createElement(
        'div',
        { className: 'row react-bootstrap-table-pagination' },
        _react2.default.createElement(
          'div',
          { className: 'col-md-6 col-xs-6 col-sm-6 col-lg-6' },
          _react2.default.createElement(sizePerPageDropdownAdapter_1.SizePerPageDropdownWithAdapter, {
            bootstrap4: bootstrap4,
            tableId: tableId,
            sizePerPageList: sizePerPageList,
            currSizePerPage: currSizePerPage,
            hideSizePerPage: hideSizePerPage,
            sizePerPageRenderer: sizePerPageRenderer,
            sizePerPageOptionRenderer: sizePerPageOptionRenderer,
            onSizePerPageChange: onSizePerPageChange
          }),
          showTotal ? _react2.default.createElement(paginationTotalAdapter_1.PaginationTotalWithAdapter, {
            currPage: currPage,
            currSizePerPage: currSizePerPage,
            pageStartIndex: pageStartIndex,
            dataSize: dataSize,
            paginationTotalRenderer: paginationTotalRenderer
          }) : null
        ),
        pageListRenderer ? pageListRenderer({
          pages: pages,
          onPageChange: onPageChange
        }) : _react2.default.createElement(
          'div',
          { className: pageListClass },
          _react2.default.createElement(paginationListAdapter_1.PaginationListWithAdapter, _extends({}, rest, {
            currPage: currPage,
            currSizePerPage: currSizePerPage,
            pageStartIndex: pageStartIndex,
            lastPage: lastPage,
            totalPages: totalPages,
            pageButtonRenderer: pageButtonRenderer,
            onPageChange: onPageChange
          }))
        )
      );
    }
  }]);

  return Pagination;
}((0, _pageResolver3.default)(React__default.Component));

Pagination.propTypes = {
  dataSize: _propTypes2.default.number.isRequired,
  sizePerPageList: _propTypes2.default.array.isRequired,
  currPage: _propTypes2.default.number.isRequired,
  currSizePerPage: _propTypes2.default.number.isRequired,
  onPageChange: _propTypes2.default.func.isRequired,
  onSizePerPageChange: _propTypes2.default.func.isRequired,
  disablePageTitle: _propTypes2.default.bool,
  pageStartIndex: _propTypes2.default.number,
  paginationSize: _propTypes2.default.number,
  showTotal: _propTypes2.default.bool,
  pageListRenderer: _propTypes2.default.func,
  pageButtonRenderer: _propTypes2.default.func,
  sizePerPageRenderer: _propTypes2.default.func,
  paginationTotalRenderer: _propTypes2.default.func,
  sizePerPageOptionRenderer: _propTypes2.default.func,
  firstPageText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  prePageText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  nextPageText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  lastPageText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  nextPageTitle: _propTypes2.default.string,
  prePageTitle: _propTypes2.default.string,
  firstPageTitle: _propTypes2.default.string,
  lastPageTitle: _propTypes2.default.string,
  withFirstAndLast: _propTypes2.default.bool,
  alwaysShowAllBtns: _propTypes2.default.bool,
  hideSizePerPage: _propTypes2.default.bool,
  hidePageListOnlyOnePage: _propTypes2.default.bool,
  bootstrap4: _propTypes2.default.bool
};

Pagination.defaultProps = {
  disablePageTitle: false,
  bootstrap4: false,
  pageStartIndex: _const2.default.PAGE_START_INDEX,
  paginationSize: _const2.default.PAGINATION_SIZE,
  withFirstAndLast: _const2.default.With_FIRST_AND_LAST,
  alwaysShowAllBtns: _const2.default.SHOW_ALL_PAGE_BTNS,
  showTotal: _const2.default.SHOW_TOTAL,
  pageListRenderer: null,
  pageButtonRenderer: null,
  sizePerPageRenderer: null,
  paginationTotalRenderer: _const2.default.PAGINATION_TOTAL,
  sizePerPageOptionRenderer: null,
  firstPageText: _const2.default.FIRST_PAGE_TEXT,
  prePageText: _const2.default.PRE_PAGE_TEXT,
  nextPageText: _const2.default.NEXT_PAGE_TEXT,
  lastPageText: _const2.default.LAST_PAGE_TEXT,
  sizePerPageList: _const2.default.SIZE_PER_PAGE_LIST,
  nextPageTitle: _const2.default.NEXT_PAGE_TITLE,
  prePageTitle: _const2.default.PRE_PAGE_TITLE,
  firstPageTitle: _const2.default.FIRST_PAGE_TITLE,
  lastPageTitle: _const2.default.LAST_PAGE_TITLE,
  hideSizePerPage: _const2.default.HIDE_SIZE_PER_PAGE,
  hidePageListOnlyOnePage: _const2.default.HIDE_PAGE_LIST_ONLY_ONE_PAGE
};

exports.default = (0, _paginationHandler2.default)(Pagination);
});

unwrapExports(pagination);

var dataContext$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _const2 = _interopRequireDefault(_const$1);



var _pagination2 = _interopRequireDefault(pagination);





var _stateContext2 = _interopRequireDefault(stateContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
/* eslint react/require-default-props: 0 */
/* eslint no-lonely-if: 0 */


var _createBaseContext = (0, _stateContext2.default)(),
    Provider = _createBaseContext.Provider;

var PaginationDataContext = _react2.default.createContext();

var PaginationDataProvider = function (_Provider) {
  _inherits(PaginationDataProvider, _Provider);

  function PaginationDataProvider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PaginationDataProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaginationDataProvider.__proto__ || Object.getPrototypeOf(PaginationDataProvider)).call.apply(_ref, [this].concat(args))), _this), _this.isRemotePagination = function () {
      return _this.props.isRemotePagination();
    }, _this.renderDefaultPagination = function () {
      if (!_this.props.pagination.options.custom) {
        var _this$getPaginationPr = _this.getPaginationProps(),
            currPage = _this$getPaginationPr.page,
            currSizePerPage = _this$getPaginationPr.sizePerPage,
            dataSize = _this$getPaginationPr.dataSize,
            rest = _objectWithoutProperties(_this$getPaginationPr, ['page', 'sizePerPage', 'dataSize']);

        return _react2.default.createElement(_pagination2.default, _extends({}, rest, {
          key: 'pagination',
          dataSize: dataSize || _this.props.data.length,
          currPage: currPage,
          currSizePerPage: currSizePerPage
        }));
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PaginationDataProvider, [{
    key: 'UNSAFE_componentWillReceiveProps',


    // eslint-disable-next-line camelcase, react/sort-comp
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      _get(PaginationDataProvider.prototype.__proto__ || Object.getPrototypeOf(PaginationDataProvider.prototype), 'UNSAFE_componentWillReceiveProps', this).call(this, nextProps);
      var currSizePerPage = this.currSizePerPage;
      var _nextProps$pagination = nextProps.pagination.options,
          custom = _nextProps$pagination.custom,
          onPageChange = _nextProps$pagination.onPageChange;


      var pageStartIndex = typeof nextProps.pagination.options.pageStartIndex !== 'undefined' ? nextProps.pagination.options.pageStartIndex : _const2.default.PAGE_START_INDEX;

      // user should align the page when the page is not fit to the data size when remote enable
      if (!this.isRemotePagination() && !custom) {
        var newPage = (0, page.alignPage)(nextProps.data.length, this.props.data.length, this.currPage, currSizePerPage, pageStartIndex);

        if (this.currPage !== newPage) {
          if (onPageChange) {
            onPageChange(newPage, currSizePerPage);
          }
          this.currPage = newPage;
        }
      }
      if (nextProps.onDataSizeChange && nextProps.data.length !== this.props.data.length) {
        nextProps.onDataSizeChange({ dataSize: nextProps.data.length });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.data;
      var options = this.props.pagination.options;
      var currPage = this.currPage,
          currSizePerPage = this.currSizePerPage;

      var pageStartIndex = typeof options.pageStartIndex === 'undefined' ? _const2.default.PAGE_START_INDEX : options.pageStartIndex;

      data = this.isRemotePagination() ? data : (0, page.getByCurrPage)(data, currPage, currSizePerPage, pageStartIndex);

      return _react2.default.createElement(
        PaginationDataContext.Provider,
        { value: { data: data, setRemoteEmitter: this.setRemoteEmitter } },
        this.props.children,
        this.renderDefaultPagination()
      );
    }
  }]);

  return PaginationDataProvider;
}(Provider);

PaginationDataProvider.propTypes = {
  data: _propTypes2.default.array.isRequired,
  remoteEmitter: _propTypes2.default.object.isRequired,
  isRemotePagination: _propTypes2.default.func.isRequired };

exports.default = function () {
  return {
    Provider: PaginationDataProvider,
    Consumer: PaginationDataContext.Consumer
  };
};
});

unwrapExports(dataContext$1);

var standaloneAdapter = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint react/prop-types: 0 */


exports.default = function (WrappedComponent) {
  return function (_ref) {
    var page = _ref.page,
        sizePerPage = _ref.sizePerPage,
        rest = _objectWithoutProperties(_ref, ['page', 'sizePerPage']);

    return _react2.default.createElement(WrappedComponent, _extends({}, rest, {
      currPage: page,
      currSizePerPage: sizePerPage
    }));
  };
};
});

unwrapExports(standaloneAdapter);

var paginationListStandalone = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _paginationList2 = _interopRequireDefault(paginationList);



var _standaloneAdapter2 = _interopRequireDefault(standaloneAdapter);



var _paginationHandler2 = _interopRequireDefault(paginationHandler);



var _paginationListAdapter2 = _interopRequireDefault(paginationListAdapter_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationListStandalone = function PaginationListStandalone(props) {
  return _react2.default.createElement(_paginationList2.default, props);
};

exports.default = (0, _standaloneAdapter2.default)((0, _paginationHandler2.default)((0, _paginationListAdapter2.default)(PaginationListStandalone)));
});

unwrapExports(paginationListStandalone);

var sizePerPageDropdownStandalone = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _sizePerPageDropdown2 = _interopRequireDefault(sizePerPageDropdown);



var _standaloneAdapter2 = _interopRequireDefault(standaloneAdapter);



var _paginationHandler2 = _interopRequireDefault(paginationHandler);



var _sizePerPageDropdownAdapter2 = _interopRequireDefault(sizePerPageDropdownAdapter_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SizePerPageDropdownStandalone = function SizePerPageDropdownStandalone(props) {
  return _react2.default.createElement(_sizePerPageDropdown2.default, props);
};

exports.default = (0, _standaloneAdapter2.default)((0, _paginationHandler2.default)((0, _sizePerPageDropdownAdapter2.default)(SizePerPageDropdownStandalone)));
});

unwrapExports(sizePerPageDropdownStandalone);

var paginationTotalStandalone = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _paginationTotal2 = _interopRequireDefault(paginationTotal);



var _standaloneAdapter2 = _interopRequireDefault(standaloneAdapter);



var _paginationTotalAdapter2 = _interopRequireDefault(paginationTotalAdapter_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationTotalStandalone = function PaginationTotalStandalone(props) {
  return _react2.default.createElement(_paginationTotal2.default, props);
};

exports.default = (0, _standaloneAdapter2.default)((0, _paginationTotalAdapter2.default)(PaginationTotalStandalone));
});

unwrapExports(paginationTotalStandalone);

var lib$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationTotalStandalone = exports.SizePerPageDropdownStandalone = exports.PaginationListStandalone = exports.PaginationProvider = undefined;



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _stateContext2 = _interopRequireDefault(stateContext);



var _dataContext2 = _interopRequireDefault(dataContext$1);



var _paginationListStandalone2 = _interopRequireDefault(paginationListStandalone);



var _sizePerPageDropdownStandalone2 = _interopRequireDefault(sizePerPageDropdownStandalone);



var _paginationTotalStandalone2 = _interopRequireDefault(paginationTotalStandalone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    createContext: _dataContext2.default,
    options: options
  };
};

var _createBaseContext = (0, _stateContext2.default)(),
    Provider = _createBaseContext.Provider,
    Consumer = _createBaseContext.Consumer;

var CustomizableProvider = function CustomizableProvider(props) {
  return _react2.default.createElement(
    Provider,
    props,
    _react2.default.createElement(
      Consumer,
      null,
      function (paginationProps) {
        return props.children(paginationProps);
      }
    )
  );
};

CustomizableProvider.propTypes = {
  children: _propTypes2.default.func.isRequired
};

var PaginationProvider = exports.PaginationProvider = CustomizableProvider;
exports.PaginationListStandalone = _paginationListStandalone2.default;
exports.SizePerPageDropdownStandalone = _sizePerPageDropdownStandalone2.default;
exports.PaginationTotalStandalone = _paginationTotalStandalone2.default;
});

var paginationFactory = unwrapExports(lib$1);
var lib_1 = lib$1.PaginationTotalStandalone;
var lib_2 = lib$1.SizePerPageDropdownStandalone;
var lib_3 = lib$1.PaginationListStandalone;
var lib_4 = lib$1.PaginationProvider;

var SearchBar_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _arguments = arguments; /* eslint camelcase: 0 */
/* eslint no-return-assign: 0 */



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var handleDebounce = function handleDebounce(func, wait, immediate) {
  var timeout = void 0;

  return function () {
    var later = function later() {
      timeout = null;

      if (!immediate) {
        func.apply(undefined, _arguments);
      }
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait || 0);

    if (callNow) {
      func.appy(undefined, _arguments);
    }
  };
};

var SearchBar = function (_React$Component) {
  _inherits(SearchBar, _React$Component);

  function SearchBar(props) {
    _classCallCheck(this, SearchBar);

    var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));

    _this.onChangeValue = function (e) {
      _this.setState({ value: e.target.value });
    };

    _this.onKeyup = function () {
      var _this$props = _this.props,
          delay = _this$props.delay,
          onSearch = _this$props.onSearch;

      var debounceCallback = handleDebounce(function () {
        onSearch(_this.input.value);
      }, delay);
      debounceCallback();
    };

    _this.state = {
      value: props.searchText
    };
    return _this;
  }

  _createClass(SearchBar, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({ value: nextProps.searchText });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          style = _props.style,
          placeholder = _props.placeholder,
          tableId = _props.tableId,
          srText = _props.srText;


      return _react2.default.createElement(
        'label',
        {
          htmlFor: 'search-bar-' + tableId,
          className: 'search-label'
        },
        _react2.default.createElement(
          'span',
          { id: 'search-bar-' + tableId + '-label', className: 'sr-only' },
          srText
        ),
        _react2.default.createElement('input', {
          ref: function ref(n) {
            return _this2.input = n;
          },
          id: 'search-bar-' + tableId,
          type: 'text',
          style: style,
          'aria-labelledby': 'search-bar-' + tableId + '-label',
          onKeyUp: function onKeyUp() {
            return _this2.onKeyup();
          },
          onChange: this.onChangeValue,
          className: 'form-control ' + className,
          value: this.state.value,
          placeholder: placeholder || SearchBar.defaultProps.placeholder
        })
      );
    }
  }]);

  return SearchBar;
}(_react2.default.Component);

SearchBar.propTypes = {
  onSearch: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  style: _propTypes2.default.object,
  delay: _propTypes2.default.number,
  searchText: _propTypes2.default.string,
  tableId: _propTypes2.default.string,
  srText: _propTypes2.default.string
};

SearchBar.defaultProps = {
  className: '',
  style: {},
  placeholder: 'Search',
  delay: 250,
  searchText: '',
  tableId: '0',
  srText: 'Search this table'
};

exports.default = SearchBar;
});

unwrapExports(SearchBar_1);

var clearButton = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClearButton = function ClearButton(_ref) {
  var onClear = _ref.onClear,
      text = _ref.text,
      className = _ref.className;
  return _react2.default.createElement(
    'button',
    { className: 'btn btn-default ' + className, onClick: onClear },
    text
  );
};

ClearButton.propTypes = {
  onClear: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string,
  text: _propTypes2.default.string
};

ClearButton.defaultProps = {
  text: 'Clear',
  className: ''
};

exports.default = ClearButton;
});

unwrapExports(clearButton);

var search = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _SearchBar2 = _interopRequireDefault(SearchBar_1);



var _clearButton2 = _interopRequireDefault(clearButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { SearchBar: _SearchBar2.default, ClearSearchButton: _clearButton2.default };
});

unwrapExports(search);

var button = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ExportCSVButton = function ExportCSVButton(props) {
  var onExport = props.onExport,
      children = props.children,
      className = props.className,
      rest = _objectWithoutProperties(props, ['onExport', 'children', 'className']);

  return _react2.default.createElement(
    'button',
    _extends({
      type: 'button',
      className: 'react-bs-table-csv-btn btn btn-default ' + className,
      onClick: function onClick() {
        return onExport();
      }
    }, rest),
    children
  );
};

ExportCSVButton.propTypes = {
  children: _propTypes2.default.node.isRequired,
  onExport: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object
};
ExportCSVButton.defaultProps = {
  className: '',
  style: {}
};

exports.default = ExportCSVButton;
});

unwrapExports(button);

var csv = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _button2 = _interopRequireDefault(button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { ExportCSVButton: _button2.default };
});

unwrapExports(csv);

var toggleList = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleList = function ToggleList(_ref) {
  var columns = _ref.columns,
      onColumnToggle = _ref.onColumnToggle,
      toggles = _ref.toggles,
      contextual = _ref.contextual,
      className = _ref.className,
      btnClassName = _ref.btnClassName;
  return _react2.default.createElement(
    'div',
    { className: 'btn-group btn-group-toggle ' + className, 'data-toggle': 'buttons' },
    columns.map(function (column) {
      return _extends({}, column, {
        toggle: toggles[column.dataField]
      });
    }).map(function (column) {
      return _react2.default.createElement(
        'button',
        {
          type: 'button',
          key: column.dataField,
          className: btnClassName + ' btn btn-' + contextual + ' ' + (column.toggle ? 'active' : ''),
          'data-toggle': 'button',
          'aria-pressed': column.toggle ? 'true' : 'false',
          onClick: function onClick() {
            return onColumnToggle(column.dataField);
          }
        },
        column.text
      );
    })
  );
};

ToggleList.propTypes = {
  columns: _propTypes2.default.array.isRequired,
  toggles: _propTypes2.default.object.isRequired,
  onColumnToggle: _propTypes2.default.func.isRequired,
  btnClassName: _propTypes2.default.string,
  className: _propTypes2.default.string,
  contextual: _propTypes2.default.string
};

ToggleList.defaultProps = {
  btnClassName: '',
  className: '',
  contextual: 'primary'
};

exports.default = ToggleList;
});

unwrapExports(toggleList);

var columnToggle = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _toggleList2 = _interopRequireDefault(toggleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { ToggleList: _toggleList2.default };
});

unwrapExports(columnToggle);

var FileSaver_min = createCommonjsModule(function (module, exports) {
(function(a,b){b();})(commonjsGlobal,function(){function b(a,b){return "undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(b,c,d){var e=new XMLHttpRequest;e.open("GET",b),e.responseType="blob",e.onload=function(){a(e.response,c,d);},e.onerror=function(){console.error("could not download file");},e.send();}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send();}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"));}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b);}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof commonjsGlobal&&commonjsGlobal.global===commonjsGlobal?commonjsGlobal:void 0,a=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href);},4E4),setTimeout(function(){e(j);},0));}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else {var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i);});}}:function(a,b,d,e){if(e=e||open("","_blank"),e&&(e.document.title=e.document.body.innerText="downloading..."),"string"==typeof a)return c(a,b,d);var g="application/octet-stream"===a.type,h=/constructor/i.test(f.HTMLElement)||f.safari,i=/CriOS\/[\d]+/.test(navigator.userAgent);if((i||g&&h)&&"object"==typeof FileReader){var j=new FileReader;j.onloadend=function(){var a=j.result;a=i?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),e?e.location.href=a:location=a,e=null;},j.readAsDataURL(a);}else {var k=f.URL||f.webkitURL,l=k.createObjectURL(a);e?e.location=l:location.href=l,e=null,setTimeout(function(){k.revokeObjectURL(l);},4E4);}});f.saveAs=a.saveAs=a,(module.exports=a);});


});

var exporter = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.save = exports.transform = exports.getMetaInfo = undefined;



var _fileSaver2 = _interopRequireDefault(FileSaver_min);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMetaInfo = exports.getMetaInfo = function getMetaInfo(columns) {
  return columns.map(function (column) {
    return {
      field: column.dataField,
      type: column.csvType || String,
      formatter: column.csvFormatter,
      formatExtraData: column.formatExtraData,
      header: column.csvText || column.text,
      export: column.csvExport === false ? false : true,
      row: Number(column.row) || 0,
      rowSpan: Number(column.rowSpan) || 1,
      colSpan: Number(column.colSpan) || 1,
      footer: column.footer,
      footerFormatter: column.footerFormatter
    };
  }).filter(function (_) {
    return _.export;
  });
}; /* eslint no-unneeded-ternary: 0 */
var transform = exports.transform = function transform(data, meta, columns, _, _ref) {
  var separator = _ref.separator,
      ignoreHeader = _ref.ignoreHeader,
      ignoreFooter = _ref.ignoreFooter;

  var visibleColumns = meta.filter(function (m) {
    return m.export;
  });
  var content = '';
  // extract csv header
  if (!ignoreHeader) {
    content += visibleColumns.map(function (m) {
      return '"' + m.header + '"';
    }).join(separator);
    content += '\n';
  }
  // extract csv body
  if (data.length === 0) return content;
  content += data.map(function (row, rowIndex) {
    return visibleColumns.map(function (m) {
      var cellContent = _.get(row, m.field);
      if (m.formatter) {
        cellContent = m.formatter(cellContent, row, rowIndex, m.formatExtraData);
      }
      if (m.type === String) {
        return '"' + ('' + cellContent).replace(/"/g, '""') + '"';
      }
      return cellContent;
    }).join(separator);
  }).join('\n');

  if (!ignoreFooter) {
    content += '\n';
    content += visibleColumns.map(function (m, i) {
      if (typeof m.footer === 'function') {
        var columnData = _.pluck(data, columns[i].dataField);
        return '"' + m.footer(columnData, columns[i], i) + '"';
      } else if (m.footerFormatter) {
        return '"' + m.footerFormatter(columns[i], i) + '"';
      }
      return '"' + m.footer + '"';
    }).join(separator);
  }
  return content;
};

var save = exports.save = function save(content, _ref2) {
  var noAutoBOM = _ref2.noAutoBOM,
      fileName = _ref2.fileName,
      blobType = _ref2.blobType;

  _fileSaver2.default.saveAs(new Blob([content], { type: blobType }), fileName, noAutoBOM);
};
});

unwrapExports(exporter);
var exporter_1 = exporter.save;
var exporter_2 = exporter.transform;
var exporter_3 = exporter.getMetaInfo;

var csv$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var csvDefaultOptions = {
  fileName: 'spreadsheet.csv',
  separator: ',',
  ignoreHeader: false,
  ignoreFooter: true,
  noAutoBOM: true,
  blobType: 'text/plain;charset=utf-8',
  exportAll: true,
  onlyExportSelection: false
};

exports.default = function (Base) {
  return function (_Base) {
    _inherits(CSVOperation, _Base);

    function CSVOperation() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, CSVOperation);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CSVOperation.__proto__ || Object.getPrototypeOf(CSVOperation)).call.apply(_ref, [this].concat(args))), _this), _this.handleExportCSV = function (source) {
        var _this$props = _this.props,
            columns = _this$props.columns,
            exportCSV = _this$props.exportCSV,
            keyField = _this$props.keyField;

        var meta = (0, exporter.getMetaInfo)(columns);
        var options = exportCSV === true ? csvDefaultOptions : _extends({}, csvDefaultOptions, exportCSV);

        // get data for csv export
        var data = void 0;
        if (typeof source !== 'undefined') {
          data = source;
        } else if (options.exportAll) {
          data = _this.props.data;
        } else if (options.onlyExportFiltered) {
          var payload = {};
          _this.tableExposedAPIEmitter.emit('get.filtered.rows', payload);
          data = payload.result;
        } else {
          var _payload = {};
          _this.tableExposedAPIEmitter.emit('get.table.data', _payload);
          data = _payload.result;
        }

        // filter data by row selection
        if (options.onlyExportSelection) {
          var _payload2 = {};
          _this.tableExposedAPIEmitter.emit('get.selected.rows', _payload2);
          var selections = _payload2.result;
          data = data.filter(function (row) {
            return !!selections.find(function (sel) {
              return row[keyField] === sel;
            });
          });
        }

        var content = (0, exporter.transform)(data, meta, columns, _this._, options);
        (0, exporter.save)(content, options);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return CSVOperation;
  }(Base);
};
});

unwrapExports(csv$1);

var op = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _csv2 = _interopRequireDefault(csv$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  csvOperation: _csv2.default
};
});

unwrapExports(op);

var statelessOp = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _op2 = _interopRequireDefault(op);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Base) {
  return function (_Operation$csvOperati) {
    _inherits(StatelessOperation, _Operation$csvOperati);

    function StatelessOperation() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, StatelessOperation);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StatelessOperation.__proto__ || Object.getPrototypeOf(StatelessOperation)).call.apply(_ref, [this].concat(args))), _this), _this.registerExposedAPI = function (tableExposedAPIEmitter) {
        _this.tableExposedAPIEmitter = tableExposedAPIEmitter;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return StatelessOperation;
  }(_op2.default.csvOperation(Base));
};
});

unwrapExports(statelessOp);

var context = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
/* eslint react/require-default-props: 0 */
/* eslint no-continue: 0 */
/* eslint no-lonely-if: 0 */
/* eslint class-methods-use-this: 0 */
/* eslint camelcase: 0 */


exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    searchFormatted: false,
    afterSearch: null,
    onColumnMatch: null
  };
  return function (_, isRemoteSearch, handleRemoteSearchChange) {
    var SearchContext = _react2.default.createContext();

    var SearchProvider = function (_React$Component) {
      _inherits(SearchProvider, _React$Component);

      function SearchProvider(props) {
        _classCallCheck(this, SearchProvider);

        var _this = _possibleConstructorReturn(this, (SearchProvider.__proto__ || Object.getPrototypeOf(SearchProvider)).call(this, props));

        var initialData = props.data;
        if (isRemoteSearch() && _this.props.searchText !== '') {
          handleRemoteSearchChange(_this.props.searchText);
        } else {
          initialData = _this.search(props);
          _this.triggerListener(initialData, true);
        }
        _this.state = { data: initialData };
        return _this;
      }

      _createClass(SearchProvider, [{
        key: 'getSearched',
        value: function getSearched() {
          return this.state.data;
        }
      }, {
        key: 'triggerListener',
        value: function triggerListener(result, skipInit) {
          if (options.afterSearch && !skipInit) {
            options.afterSearch(result);
          }
          if (this.props.dataChangeListener) {
            this.props.dataChangeListener.emit('filterChanged', result.length);
          }
        }
      }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
          if (nextProps.searchText !== this.props.searchText) {
            if (isRemoteSearch()) {
              handleRemoteSearchChange(nextProps.searchText);
            } else {
              var result = this.search(nextProps);
              this.triggerListener(result);
              this.setState({
                data: result
              });
            }
          } else {
            if (isRemoteSearch()) {
              this.setState({ data: nextProps.data });
            } else if (!_.isEqual(nextProps.data, this.props.data)) {
              var _result = this.search(nextProps);
              this.triggerListener(_result);
              this.setState({
                data: _result
              });
            }
          }
        }
      }, {
        key: 'search',
        value: function search(props) {
          var data = props.data,
              columns = props.columns;

          var searchText = props.searchText.toLowerCase();
          return data.filter(function (row, ridx) {
            for (var cidx = 0; cidx < columns.length; cidx += 1) {
              var column = columns[cidx];
              if (column.searchable === false) continue;
              var targetValue = _.get(row, column.dataField);
              if (column.formatter && options.searchFormatted) {
                targetValue = column.formatter(targetValue, row, ridx, column.formatExtraData);
              } else if (column.filterValue) {
                targetValue = column.filterValue(targetValue, row);
              }
              if (options.onColumnMatch) {
                if (options.onColumnMatch({
                  searchText: searchText,
                  value: targetValue,
                  column: column,
                  row: row
                })) {
                  return true;
                }
              } else {
                if (targetValue !== null && typeof targetValue !== 'undefined') {
                  targetValue = targetValue.toString().toLowerCase();
                  if (targetValue.indexOf(searchText) > -1) {
                    return true;
                  }
                }
              }
            }
            return false;
          });
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            SearchContext.Provider,
            { value: { data: this.state.data } },
            this.props.children
          );
        }
      }]);

      return SearchProvider;
    }(_react2.default.Component);

    SearchProvider.propTypes = {
      data: _propTypes2.default.array.isRequired,
      columns: _propTypes2.default.array.isRequired,
      searchText: _propTypes2.default.string,
      dataChangeListener: _propTypes2.default.object
    };


    return {
      Provider: SearchProvider,
      Consumer: SearchContext.Consumer
    };
  };
};
});

unwrapExports(context);

var context$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _statelessOp2 = _interopRequireDefault(statelessOp);



var _context2 = _interopRequireDefault(context);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-param-reassign: 0 */

var ToolkitContext = _react2.default.createContext();

var ToolkitProvider = function (_statelessDecorator) {
  _inherits(ToolkitProvider, _statelessDecorator);

  function ToolkitProvider(props) {
    _classCallCheck(this, ToolkitProvider);

    var _this = _possibleConstructorReturn(this, (ToolkitProvider.__proto__ || Object.getPrototypeOf(ToolkitProvider)).call(this, props));

    var state = {};
    _this._ = null;
    _this.onClear = _this.onClear.bind(_this);
    _this.onSearch = _this.onSearch.bind(_this);
    _this.onColumnToggle = _this.onColumnToggle.bind(_this);
    _this.setDependencyModules = _this.setDependencyModules.bind(_this);

    if (props.columnToggle) {
      state.columnToggle = props.columns.reduce(function (obj, column) {
        obj[column.dataField] = !column.hidden;
        return obj;
      }, {});
    }
    state.searchText = _typeof(props.search) === 'object' ? props.search.defaultSearch || '' : '';
    _this.state = state;
    return _this;
  }

  // eslint-disable-next-line camelcase


  _createClass(ToolkitProvider, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var columnToggle = this.state.columnToggle;
      if (nextProps.columnToggle) {
        columnToggle = nextProps.columns.reduce(function (obj, column) {
          obj[column.dataField] = !column.hidden;
          return obj;
        }, {});
      } else {
        columnToggle = null;
      }
      this.setState(_extends({}, this.state, {
        columnToggle: columnToggle
      }));
    }
  }, {
    key: 'onSearch',
    value: function onSearch(searchText) {
      if (searchText !== this.state.searchText) {
        this.setState({ searchText: searchText });
      }
    }
  }, {
    key: 'onClear',
    value: function onClear() {
      this.setState({ searchText: '' });
    }
  }, {
    key: 'onColumnToggle',
    value: function onColumnToggle(dataField) {
      var columnToggle = this.state.columnToggle;

      columnToggle[dataField] = !columnToggle[dataField];
      this.setState(_extends({}, this.state, {
        columnToggle: columnToggle
      }));
    }
    /**
     * 
     * @param {*} _ 
     * this function will be called only one time when table render
     * react-bootstrap-table-next/src/context/index.js will call this cb for passing the _ module
     * Please consider to extract a common module to handle _ module.
     * this is just a quick fix
     */

  }, {
    key: 'setDependencyModules',
    value: function setDependencyModules(_) {
      this._ = _;
    }
  }, {
    key: 'render',
    value: function render() {
      var baseProps = {
        keyField: this.props.keyField,
        columns: this.props.columns,
        data: this.props.data,
        bootstrap4: this.props.bootstrap4,
        setDependencyModules: this.setDependencyModules,
        registerExposedAPI: this.registerExposedAPI
      };
      if (this.props.search) {
        baseProps.search = {
          searchContext: (0, _context2.default)(this.props.search),
          searchText: this.state.searchText
        };
      }
      if (this.props.columnToggle) {
        baseProps.columnToggle = {
          toggles: this.state.columnToggle
        };
      }
      return _react2.default.createElement(
        ToolkitContext.Provider,
        { value: {
            searchProps: {
              searchText: this.state.searchText,
              onSearch: this.onSearch,
              onClear: this.onClear
            },
            csvProps: {
              onExport: this.handleExportCSV
            },
            columnToggleProps: {
              columns: this.props.columns,
              toggles: this.state.columnToggle,
              onColumnToggle: this.onColumnToggle
            },
            baseProps: baseProps
          }
        },
        this.props.children
      );
    }
  }]);

  return ToolkitProvider;
}((0, _statelessOp2.default)(_react2.default.Component));

ToolkitProvider.propTypes = {
  keyField: _propTypes2.default.string.isRequired,
  data: _propTypes2.default.array.isRequired,
  columns: _propTypes2.default.array.isRequired,
  children: _propTypes2.default.node.isRequired,
  bootstrap4: _propTypes2.default.bool,
  search: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    defaultSearch: _propTypes2.default.string,
    searchFormatted: _propTypes2.default.bool
  })]),
  exportCSV: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    fileName: _propTypes2.default.string,
    separator: _propTypes2.default.string,
    ignoreHeader: _propTypes2.default.bool,
    ignoreFooter: _propTypes2.default.bool,
    noAutoBOM: _propTypes2.default.bool,
    blobType: _propTypes2.default.string,
    exportAll: _propTypes2.default.bool,
    onlyExportFiltered: _propTypes2.default.bool,
    onlyExportSelection: _propTypes2.default.bool
  })])
};
ToolkitProvider.defaultProps = {
  search: false,
  exportCSV: false,
  bootstrap4: false
};
exports.default = {
  Provider: ToolkitProvider,
  Consumer: ToolkitContext.Consumer
};
});

unwrapExports(context$1);

var provider = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _context2 = _interopRequireDefault(context$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toolkitprovider = function Toolkitprovider(props) {
  return _react2.default.createElement(
    _context2.default.Provider,
    props,
    _react2.default.createElement(
      _context2.default.Consumer,
      null,
      function (tookKitProps) {
        return props.children(tookKitProps);
      }
    )
  );
};

Toolkitprovider.propTypes = {
  children: _propTypes2.default.func.isRequired
};

exports.default = Toolkitprovider;
});

unwrapExports(provider);

var lib$2 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnToggle = exports.CSVExport = exports.Search = exports.ToolkitContext = undefined;



Object.defineProperty(exports, 'Search', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(search).default;
  }
});



Object.defineProperty(exports, 'CSVExport', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(csv).default;
  }
});



Object.defineProperty(exports, 'ColumnToggle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(columnToggle).default;
  }
});



var _context2 = _interopRequireDefault(context$1);



var _provider2 = _interopRequireDefault(provider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _provider2.default;
var ToolkitContext = exports.ToolkitContext = _context2.default;
});

var ToolkitProvider = unwrapExports(lib$2);
var lib_1$1 = lib$2.ColumnToggle;
var lib_2$1 = lib$2.CSVExport;
var lib_3$1 = lib$2.Search;
var lib_4$1 = lib$2.ToolkitContext;

var _templateObject$t, _templateObject2$n;
var Table = styled.div(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral(["\n  .react-bootstrap-table {\n    \n    .table {\n      width: 100%;\n      table-layout: fixed;\n      border-collapse: collapse;\n      margin-bottom: 0;\n\n      tr {\n        border: none;\n      }\n\n      td {\n        padding: 0;\n      }\n\n      thead {\n        th {\n          vertical-align: unset;\n        }\n      }\n    }\n    ", "\n  }\n\n  .headerClasses {\n    th {\n      padding: ", ";\n      background-color: ", ";\n      \n    }\n  }\n\n\n  tbody {\n    tr {\n      box-shadow: inset 0 -1px 0 ", ";\n      height: 48px;\n\n      ", "\n    }\n\n    td {\n      vertical-align: middle;\n      padding-left: ", " !important;\n      padding-right: ", " !important;\n      ", "\n      &.react-bs-table-no-data {\n        text-align: center;\n      }\n    }\n  }\n}\n\n.react-bootstrap-table-pagination {\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n  align-items: center;\n  padding: ", ";\n  ", ";\n\n  .pagination__total {\n    text-align: center;\n    color: ", ";\n  }\n\n  .pagination__list-of-buttons {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: ", ";\n\n    .pagination-list-of-buttons__button {\n    @extend . pagination__total;\n      font: inherit;\n      cursor: pointer;\n      background: none;\n      color: inherit;\n      border: none;\n      outline: none;\n      padding: 0;\n      height: 28px;\n      width: 28px;\n      margin-right: ", ";\n\n      &:hover {\n        background-color: ", ";\n        border-radius: ", ";\n\n        svg {\n          path {\n            fill: ", ";\n          }\n        }\n      }\n\n      &:active {\n        svg {\n          path {\n            fill: ", ";\n          }\n        }\n      }\n\n      &:first-child,\n      &:nth-child(2),\n      &:last-child,\n      &:nth-last-child(2) {\n        background-color: transparent;\n      }\n    }\n\n    .page--active {\n      color: ", ";\n      background-color: ", ";\n      border-radius: ", ";\n\n      &:hover {\n        color: ", ";\n        background-color: ", ";\n      }\n    }\n\n    .page--active-pill {\n    @extend . page--active;\n      height: auto;\n      width: auto;\n    }\n  }\n}\n"])), function (_ref) {
  var scroll = _ref.scroll;
  return scroll && getScroll();
}, theme.spacing['spacing-5'], theme.colors.neutral.bg.strong, theme.colors.neutral.border.weak, function (_ref2) {
  var clickableRows = _ref2.clickableRows;
  return clickableRows ? "\n        &:hover {\n          cursor: pointer;\n          background-color: ".concat(theme.colors.neutral.bg.regular, " !important;\n          box-shadow: inset 0 -1px 0 ").concat(theme.colors.neutral.border.regular, ";\n        }\n  \n        &:active {\n          background-color: ").concat(theme.colors['secondary-1'].bg.weak, " !important;\n          box-shadow: inset 0 -1px 0 ").concat(theme.colors['secondary-1'].border.regular, ";\n        }") : "        \n        &:hover {\n           background-color: ".concat(theme.colors.neutral.bg.regular, " !important;\n           box-shadow: inset 0 -1px 0 ").concat(theme.colors.neutral.border.regular, ";\n        }");
}, theme.spacing['spacing-5'], theme.spacing['spacing-5'], theme.textStyles['text-preset-10'](), theme.spacing['spacing-6'], theme.textStyles['text-preset-10'](), theme.colors.neutral.text.regular, theme.colors.neutral.text.strong, theme.spacing['spacing-4'], theme.colors.neutral.bg.regular, theme.borderRadius['border-radius-5'], theme.colors.primary.ic.strong, theme.colors['secondary-1'].ic.strong, theme.colors.neutral.text.inverted, theme.colors['secondary-1'].bg.regular, theme.borderRadius['border-radius-5'], theme.colors.neutral.text.inverted, theme.colors['secondary-1'].bg.strong);
var getScroll = function getScroll() {
  return css$1(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteral(["\n  @media (max-width: ", ") {\n    .table {\n      width: 100vw;\n      table-layout: auto;\n    }\n    overflow-y: scroll;\n    scrollbar-width: thin;\n    scrollbar-color: ", "\n      ", ";\n\n    &::-webkit-scrollbar {\n      height: 8px;\n    }\n    &::-webkit-scrollbar-track {\n      background: ", ";\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: ", ";\n      height: 24px;\n      border-radius: ", ";\n      margin: ", " ", "\n        ", ";\n      padding: ", " ", "\n        ", " ", ";\n    }\n  }\n"])), theme.breakpoints['s'].max, theme.colors['neutral'].border, theme.colors['neutral'].bg.weak, theme.colors['neutral'].bg.weak, theme.colors['neutral'].bg.stronger, theme.borderRadius['border-radius-5'], theme.spacing['spacing-5'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-6'], theme.spacing['spacing-13'], theme.spacing['spacing-5'], theme.spacing['spacing-12']);
};

var textColors = {
  negative: {
    variant: 'danger',
    modifier: 'regular'
  },
  positive: {
    variant: 'neutral',
    modifier: 'strong'
  }
};
var AmountFormatter = function AmountFormatter(_ref) {
  var cell = _ref.cell,
    formatExtraData = _ref.formatExtraData;
  var AmountRender = function AmountRender(_ref2) {
    var amount = _ref2.amount,
      sign = _ref2.sign;
    return /*#__PURE__*/React__default.createElement(Span$1, {
      variant: textColors[sign].variant,
      modifier: textColors[sign].modifier,
      type: "4"
    }, amount);
  };
  if (cell || cell === 0) {
    var amount = numberFormatter.format((cell === null || cell === void 0 ? void 0 : cell.amount) || cell);
    var sign = amount.includes('-$') ? 'negative' : 'positive';
    switch (formatExtraData.format) {
      case 'helperText':
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AmountRender, {
          amount: amount,
          sign: sign
        }), /*#__PURE__*/React__default.createElement(P$1, {
          variant: "neutral",
          type: "5",
          align: "right"
        }, cell.helperText));
      default:
        return /*#__PURE__*/React__default.createElement(AmountRender, {
          amount: amount,
          sign: sign
        });
    }
  } else return null;
};

var months = {
  '01': 'Ene',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Abr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Ago',
  '09': 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dic'
};
var fullMonths = {
  '01': 'Enero',
  '02': 'Febrero',
  '03': 'Marzo',
  '04': 'Abril',
  '05': 'Mayo',
  '06': 'Junio',
  '07': 'Julio',
  '08': 'Agosto',
  '09': 'Septiembre',
  10: 'Octubre',
  11: 'Noviembre',
  12: 'Diciembre'
};

/*
  input: 'yyyy-MM-dd' ó 'yyyy-MM-dd ##:##:##'
  output: 'dd/MM/yyyy
*/
var fullDateFormatter = function fullDateFormatter(date) {
  var dateSplitted = date.split(/[-,' ']/);
  return dateSplitted[2] + '/' + dateSplitted[1] + '/' + dateSplitted[0];
};

/*
  input: yyyy-mm-ddT##:##:##Z
  output: dd/mm/yyyy
*/
var fullUTCDateFormatter = function fullUTCDateFormatter(date) {
  var d = new Date(date);
  return fullDateFormatter(d.toISOString().split('T')[0]);
};

/*
  input: 'yyyy-MM-dd ##:##:##'
  output: 'dd/MM/yyyy ##:##:##'
*/
var fullDateTimeFormatter = function fullDateTimeFormatter(date) {
  var dateTimeSplitted = date.split(' ');
  var _dateTimeSplitted$0$s = dateTimeSplitted[0].split('-'),
    _dateTimeSplitted$0$s2 = _slicedToArray(_dateTimeSplitted$0$s, 3),
    year = _dateTimeSplitted$0$s2[0],
    month = _dateTimeSplitted$0$s2[1],
    day = _dateTimeSplitted$0$s2[2];
  var _dateTimeSplitted$1$s = dateTimeSplitted[1].split(':'),
    _dateTimeSplitted$1$s2 = _slicedToArray(_dateTimeSplitted$1$s, 2),
    hours = _dateTimeSplitted$1$s2[0],
    minutes = _dateTimeSplitted$1$s2[1];
  return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes;
};

/*
  input: ['yyyy-MM-dd', 'yyyy-MM-dd']
  output: 'dd/MM/yyyy - dd/MM/yyyy'
*/
var dateRangeFormatter = function dateRangeFormatter(date) {
  var _date = _slicedToArray(date, 2),
    inicialDate = _date[0],
    endDate = _date[1];
  var formattedInicialDate = fullDateFormatter(inicialDate);
  var formattedEndDate = fullDateFormatter(endDate);
  return formattedInicialDate + ' - ' + formattedEndDate;
};

/*
  input: 'yyyy-MM'
  output: 'MES yyyy'
*/
var monthYearFormatter = function monthYearFormatter(yearMonth) {
  var _yearMonth$split = yearMonth.split('-'),
    _yearMonth$split2 = _slicedToArray(_yearMonth$split, 2),
    year = _yearMonth$split2[0],
    month = _yearMonth$split2[1];
  return "".concat(months[month], " ").concat(year);
};

/*
  input: 'yyyy-MM'
  output: 'MES'
*/
var monthFormatter = function monthFormatter(yearMonth) {
  var _yearMonth$split3 = yearMonth.split('-'),
    _yearMonth$split4 = _slicedToArray(_yearMonth$split3, 2),
    month = _yearMonth$split4[1];
  return "".concat(fullMonths[month]);
};

/*
  input: 'yyyy-MM'
  output: 'MES'
*/
var yearFormatter = function yearFormatter(yearMonth) {
  var _yearMonth$split5 = yearMonth.split('-'),
    _yearMonth$split6 = _slicedToArray(_yearMonth$split5, 1),
    year = _yearMonth$split6[0];
  return "".concat(year);
};
var dateFormatters = {
  fullDate: fullDateFormatter,
  partialDate: monthYearFormatter,
  fullDateTime: fullDateTimeFormatter,
  dateRange: dateRangeFormatter,
  fullUTCDate: fullUTCDateFormatter,
  monthDate: monthFormatter,
  yearDate: yearFormatter
};
var DateFormatter = function DateFormatter(_ref) {
  var cell = _ref.cell,
    formatExtraData = _ref.formatExtraData;
  if (cell) {
    var formattedDate = dateFormatters[formatExtraData.format](cell);
    switch (formatExtraData.format) {
      case 'fullDateTime':
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Span$1, {
          variant: "neutral",
          modifier: "strong",
          type: "4"
        }, formattedDate.split(' ')[0]), /*#__PURE__*/React__default.createElement(P$1, {
          variant: "neutral",
          type: "5"
        }, formattedDate.split(' ')[1] + ' h'));
      default:
        return /*#__PURE__*/React__default.createElement(Span$1, {
          variant: "neutral",
          modifier: "strong",
          type: "4"
        }, formattedDate);
    }
  } else {
    return null;
  }
};

var _templateObject$u, _templateObject2$o, _templateObject3$k, _templateObject4$h, _templateObject5$g, _templateObject6$e, _templateObject7$b, _templateObject8$8, _templateObject9$7, _templateObject10$7, _templateObject11$6, _templateObject12$4, _templateObject13$3, _templateObject14$2, _templateObject15$2, _templateObject16$1, _templateObject17$1, _templateObject18$1, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23;
var Tooltip = styled.div(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral(["\n  & {\n    position: relative;\n  }\n  display: inline-block;\n"])));
var TooltipOverlay = styled.div(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 100;\n"])));
var TooltipWrapper = styled.div(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  ", "\n"])), function (_ref) {
  var position = _ref.position;
  return getPositionWrapper(position);
});
var TooltipArrow = styled.div(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteral(["\n  z-index: 12;\n  position: absolute;\n  display: block;\n  width: 10px;\n  height: 8px;\n  border-style: solid;\n  border-color: transparent;\n  transform-origin: center bottom;\n  ", ";\n  ", ";\n"])), function (_ref2) {
  var position = _ref2.position;
  return getArrow(position);
}, function (_ref3) {
  var position = _ref3.position;
  return getPositionArrow(position);
});
var TooltipMessage = styled.div(_templateObject5$g || (_templateObject5$g = _taggedTemplateLiteral(["\n  pointer-events: none;\n  will-change: transform;\n  min-width: 50px;\n  width: max-content;\n  width: -moz-max-content;\n  white-space: pre-wrap;\n  border-radius: ", ";\n  padding: ", " ", ";\n  background-color: ", ";\n  color: ", ";\n"])), theme.spacing['spacing-1'], theme.spacing['spacing-3'], theme.spacing['spacing-4'], theme.colors.neutral.bg.inverted, theme.colors.neutral.text.inverted);
var ChildrenWrapper = styled.div(_templateObject6$e || (_templateObject6$e = _taggedTemplateLiteral([""])));
var getPositionArrow = function getPositionArrow(position) {
  switch (position) {
    case 'top':
      return css$1(_templateObject7$b || (_templateObject7$b = _taggedTemplateLiteral(["\n        border-width: 6px 6px 0 6px;\n        bottom: 0;\n        left: calc(50% - 6px);\n      "])));
    case 'top-right':
      return css$1(_templateObject8$8 || (_templateObject8$8 = _taggedTemplateLiteral(["\n        bottom: 0;\n        border-width: 6px 6px 0 6px;\n        right: calc(0% + 6px);\n      "])));
    case 'top-left':
      return css$1(_templateObject9$7 || (_templateObject9$7 = _taggedTemplateLiteral(["\n        bottom: 0;\n        border-width: 6px 6px 0 6px;\n        left: calc(0% + 6px);\n      "])));
    case 'bottom':
      return css$1(_templateObject10$7 || (_templateObject10$7 = _taggedTemplateLiteral(["\n        border-width: 0px 6px 6px 6px;\n        top: 0;\n        left: calc(50% - 6px);\n      "])));
    case 'bottom-left':
      return css$1(_templateObject11$6 || (_templateObject11$6 = _taggedTemplateLiteral(["\n        border-width: 0px 6px 6px 6px;\n        left: calc(0% + 6px);\n        top: 0;\n      "])));
    case 'bottom-right':
      return css$1(_templateObject12$4 || (_templateObject12$4 = _taggedTemplateLiteral(["\n        border-width: 0px 6px 6px 6px;\n        right: calc(0% + 6px);\n        top: 0;\n      "])));
    case 'right':
      return css$1(_templateObject13$3 || (_templateObject13$3 = _taggedTemplateLiteral(["\n        border-width: 6px 6px 6px 0px;\n        left: 0;\n        top: calc(50% - 6px);\n      "])));
    case 'left':
      return css$1(_templateObject14$2 || (_templateObject14$2 = _taggedTemplateLiteral(["\n        border-width: 6px 0px 6px 6px;\n        right: 0;\n        top: calc(50% - 6px);\n      "])));
  }
};
var getPositionWrapper = function getPositionWrapper(position) {
  switch (position) {
    case 'top':
      return css$1(_templateObject15$2 || (_templateObject15$2 = _taggedTemplateLiteral(["\n        padding: ", " ", "\n          ", " ", ";\n        margin: ", " ", "\n          ", " ", ";\n      "])), theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-3'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-2'], theme.spacing['spacing-0']);
    case 'top-left':
      return css$1(_templateObject16$1 || (_templateObject16$1 = _taggedTemplateLiteral(["\n        padding: ", " ", "\n          ", " ", ";\n        margin: ", " ", "\n          ", " ", ";\n      "])), theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-3'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-2'], theme.spacing['spacing-0']);
    case 'top-right':
      return css$1(_templateObject17$1 || (_templateObject17$1 = _taggedTemplateLiteral(["\n        padding: ", " ", "\n          ", " ", ";\n        margin: ", " ", "\n          ", ";\n      "])), theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-3'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-2']);
    case 'bottom':
      return css$1(_templateObject18$1 || (_templateObject18$1 = _taggedTemplateLiteral(["\n        padding: ", " ", "\n          ", " ", ";\n        margin: ", " ", "\n          ", " ", ";\n      "])), theme.spacing['spacing-3'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-2'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-0']);
    case 'bottom-left':
      return css$1(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n        padding: ", " ", "\n          ", " ", ";\n        margin: ", " ", "\n          ", " ", ";\n      "])), theme.spacing['spacing-3'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-2'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-0']);
    case 'bottom-right':
      return css$1(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n        padding: ", " ", "\n          ", " ", ";\n        margin: ", " ", "\n          ", " ", ";\n      "])), theme.spacing['spacing-3'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-2'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-0']);
    case 'right':
      return css$1(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n        padding: ", " ", "\n          ", " ", ";\n        margin: ", " ", "\n          ", " ", ";\n      "])), theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-3'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-2']);
    case 'left':
      return css$1(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n        padding: ", " ", "\n          ", " ", ";\n        margin: ", " ", "\n          ", " ", ";\n      "])), theme.spacing['spacing-0'], theme.spacing['spacing-3'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-2'], theme.spacing['spacing-0'], theme.spacing['spacing-0']);
  }
};
var getArrow = function getArrow(position) {
  var aux = position.indexOf('-');
  var positions;
  aux == -1 ? positions = position : positions = position.slice(0, aux);
  return css$1(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n    border-color: transparent;\n    border-", "-color: ", ""])), positions, theme.colors.neutral.bg.inverted);
};

/* eslint-disable no-bitwise, no-cond-assign */

/**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */
function contains(context, node) {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  if (context.contains) return context.contains(node);
  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

/**
 * Track whether a component is current mounted. Generally less preferable than
 * properlly canceling effects so they don't run after a component is unmounted,
 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
 *
 * @returns a function that returns the current isMounted state of the component
 *
 * ```ts
 * const [data, setData] = useState(null)
 * const isMounted = useMounted()
 *
 * useEffect(() => {
 *   fetchdata().then((newData) => {
 *      if (isMounted()) {
 *        setData(newData);
 *      }
 *   })
 * })
 * ```
 */

function useMounted() {
  var mounted = useRef(true);
  var isMounted = useRef(function () {
    return mounted.current;
  });
  useEffect(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  return isMounted.current;
}

/**
 * Returns a ref that is immediately updated with the new value
 *
 * @param value The Ref value
 * @category refs
 */

function useUpdatedRef(value) {
  var valueRef = useRef(value);
  valueRef.current = value;
  return valueRef;
}

/**
 * Attach a callback that fires when a component unmounts
 *
 * @param fn Handler to run when the component unmounts
 * @category effects
 */

function useWillUnmount(fn) {
  var onUnmount = useUpdatedRef(fn);
  useEffect(function () {
    return function () {
      return onUnmount.current();
    };
  }, []);
}

/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */

var MAX_DELAY_MS = Math.pow(2, 31) - 1;

function setChainedTimeout(handleRef, fn, timeoutAtMs) {
  var delayMs = timeoutAtMs - Date.now();
  handleRef.current = delayMs <= MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(function () {
    return setChainedTimeout(handleRef, fn, timeoutAtMs);
  }, MAX_DELAY_MS);
}
/**
 * Returns a controller object for setting a timeout that is properly cleaned up
 * once the component unmounts. New timeouts cancel and replace existing ones.
 *
 *
 *
 * ```tsx
 * const { set, clear } = useTimeout();
 * const [hello, showHello] = useState(false);
 * //Display hello after 5 seconds
 * set(() => showHello(true), 5000);
 * return (
 *   <div className="App">
 *     {hello ? <h3>Hello</h3> : null}
 *   </div>
 * );
 * ```
 */


function useTimeout() {
  var isMounted = useMounted(); // types are confused between node and web here IDK

  var handleRef = useRef();
  useWillUnmount(function () {
    return clearTimeout(handleRef.current);
  });
  return useMemo(function () {
    var clear = function clear() {
      return clearTimeout(handleRef.current);
    };

    function set(fn, delayMs) {
      if (delayMs === void 0) {
        delayMs = 0;
      }

      if (!isMounted()) return;
      clear();

      if (delayMs <= MAX_DELAY_MS) {
        // For simplicity, if the timeout is short, just set a normal timeout.
        handleRef.current = setTimeout(fn, delayMs);
      } else {
        setChainedTimeout(handleRef, fn, Date.now() + delayMs);
      }
    }

    return {
      set: set,
      clear: clear
    };
  }, []);
}

function safeFindDOMNode(componentOrElement) {
  if (componentOrElement && 'setState' in componentOrElement) {
    return ReactDOM.findDOMNode(componentOrElement);
  }

  return componentOrElement != null ? componentOrElement : null;
}

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = process.env.NODE_ENV;

function useUncontrolledProp(propValue, defaultValue, handler) {
  var wasPropRef = useRef(propValue !== undefined);

  var _useState = useState(defaultValue),
      stateValue = _useState[0],
      setState = _useState[1];

  var isProp = propValue !== undefined;
  var wasProp = wasPropRef.current;
  wasPropRef.current = isProp;
  /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */

  if (!isProp && wasProp && stateValue !== defaultValue) {
    setState(defaultValue);
  }

  return [isProp ? propValue : stateValue, useCallback(function (value) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (handler) handler.apply(void 0, [value].concat(args));
    setState(value);
  }, [handler])];
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var reactLifecyclesCompat_es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  polyfill: polyfill
});

/**
 * A convenience hook around `useState` designed to be paired with
 * the component [callback ref](https://reactjs.org/docs/refs-and-the-dom.html#callback-refs) api.
 * Callback refs are useful over `useRef()` when you need to respond to the ref being set
 * instead of lazily accessing it in an effect.
 *
 * ```ts
 * const [element, attachRef] = useCallbackRef<HTMLDivElement>()
 *
 * useEffect(() => {
 *   if (!element) return
 *
 *   const calendar = new FullCalendar.Calendar(element)
 *
 *   return () => {
 *     calendar.destroy()
 *   }
 * }, [element])
 *
 * return <div ref={attachRef} />
 * ```
 *
 * @category refs
 */

function useCallbackRef() {
  return useState(null);
}

var toFnRef = function toFnRef(ref) {
  return !ref || typeof ref === 'function' ? ref : function (value) {
    ref.current = value;
  };
};

function mergeRefs(refA, refB) {
  var a = toFnRef(refA);
  var b = toFnRef(refB);
  return function (value) {
    if (a) a(value);
    if (b) b(value);
  };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */

function useMergedRefs(refA, refB) {
  return useMemo(function () {
    return mergeRefs(refA, refB);
  }, [refA, refB]);
}

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains$1(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains$1(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle$1(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect$1(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect$1,
  data: {}
};

var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

var hash$1 = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash$1[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains$1(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;

    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
    .filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

          break;

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (modifier.effect != null && typeof modifier.effect !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle$1(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

// This is b/c the Popper lib is all esm files, and would break in a common js only environment

var createPopper = popperGenerator({
  defaultModifiers: [hide$1, popperOffsets$1, computeStyles$1, eventListeners, offset$1, flip$1, preventOverflow$1, arrow$1]
});

function useSafeState(state) {
  var isMounted = useMounted();
  return [state[0], useCallback(function (nextState) {
    if (!isMounted()) return;
    return state[1](nextState);
  }, [isMounted, state[1]])];
}

var initialPopperStyles = function initialPopperStyles(position) {
  return {
    position: position,
    top: '0',
    left: '0',
    opacity: '0',
    pointerEvents: 'none'
  };
};

var disabledApplyStylesModifier = {
  name: 'applyStyles',
  enabled: false
}; // In order to satisfy the current usage of options, including undefined

var ariaDescribedByModifier = {
  name: 'ariaDescribedBy',
  enabled: true,
  phase: 'afterWrite',
  effect: function effect(_ref) {
    var state = _ref.state;
    return function () {
      var _state$elements = state.elements,
          reference = _state$elements.reference,
          popper = _state$elements.popper;

      if ('removeAttribute' in reference) {
        var ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(function (id) {
          return id.trim() !== popper.id;
        });
        if (!ids.length) reference.removeAttribute('aria-describedby');else reference.setAttribute('aria-describedby', ids.join(','));
      }
    };
  },
  fn: function fn(_ref2) {
    var _popper$getAttribute;

    var state = _ref2.state;
    var _state$elements2 = state.elements,
        popper = _state$elements2.popper,
        reference = _state$elements2.reference;
    var role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();

    if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
      var ids = reference.getAttribute('aria-describedby');

      if (ids && ids.split(',').indexOf(popper.id) !== -1) {
        return;
      }

      reference.setAttribute('aria-describedby', ids ? ids + "," + popper.id : popper.id);
    }
  }
};
var EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {boolean=}    options.eventsEnabled have Popper listen on window resize events to reposition the element
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */

function usePopper(referenceElement, popperElement, _temp) {
  var _ref3 = _temp === void 0 ? {} : _temp,
      _ref3$enabled = _ref3.enabled,
      enabled = _ref3$enabled === void 0 ? true : _ref3$enabled,
      _ref3$placement = _ref3.placement,
      placement = _ref3$placement === void 0 ? 'bottom' : _ref3$placement,
      _ref3$strategy = _ref3.strategy,
      strategy = _ref3$strategy === void 0 ? 'absolute' : _ref3$strategy,
      _ref3$modifiers = _ref3.modifiers,
      modifiers = _ref3$modifiers === void 0 ? EMPTY_MODIFIERS : _ref3$modifiers,
      config = _objectWithoutPropertiesLoose$1(_ref3, ["enabled", "placement", "strategy", "modifiers"]);

  var popperInstanceRef = useRef();
  var update = useCallback(function () {
    var _popperInstanceRef$cu;

    (_popperInstanceRef$cu = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu.update();
  }, []);
  var forceUpdate = useCallback(function () {
    var _popperInstanceRef$cu2;

    (_popperInstanceRef$cu2 = popperInstanceRef.current) == null ? void 0 : _popperInstanceRef$cu2.forceUpdate();
  }, []);

  var _useSafeState = useSafeState(useState({
    placement: placement,
    update: update,
    forceUpdate: forceUpdate,
    attributes: {},
    styles: {
      popper: initialPopperStyles(strategy),
      arrow: {}
    }
  })),
      popperState = _useSafeState[0],
      setState = _useSafeState[1];

  var updateModifier = useMemo(function () {
    return {
      name: 'updateStateModifier',
      enabled: true,
      phase: 'write',
      requires: ['computeStyles'],
      fn: function fn(_ref4) {
        var state = _ref4.state;
        var styles = {};
        var attributes = {};
        Object.keys(state.elements).forEach(function (element) {
          styles[element] = state.styles[element];
          attributes[element] = state.attributes[element];
        });
        setState({
          state: state,
          styles: styles,
          attributes: attributes,
          update: update,
          forceUpdate: forceUpdate,
          placement: state.placement
        });
      }
    };
  }, [update, forceUpdate, setState]);
  useEffect(function () {
    if (!popperInstanceRef.current || !enabled) return;
    popperInstanceRef.current.setOptions({
      placement: placement,
      strategy: strategy,
      modifiers: [].concat(modifiers, [updateModifier, disabledApplyStylesModifier])
    }); // intentionally NOT re-running on new modifiers
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [strategy, placement, updateModifier, enabled]);
  useEffect(function () {
    if (!enabled || referenceElement == null || popperElement == null) {
      return undefined;
    }

    popperInstanceRef.current = createPopper(referenceElement, popperElement, _extends$7j({}, config, {
      placement: placement,
      strategy: strategy,
      modifiers: [].concat(modifiers, [ariaDescribedByModifier, updateModifier])
    }));
    return function () {
      if (popperInstanceRef.current != null) {
        popperInstanceRef.current.destroy();
        popperInstanceRef.current = undefined;
        setState(function (s) {
          return _extends$7j({}, s, {
            attributes: {},
            styles: {
              popper: initialPopperStyles(strategy)
            }
          });
        });
      }
    }; // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, referenceElement, popperElement]);
  return popperState;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/* eslint-disable no-return-assign */
var optionsSupported = false;
var onceSupported = false;

try {
  var options = {
    get passive() {
      return optionsSupported = true;
    },

    get once() {
      // eslint-disable-next-line no-multi-assign
      return onceSupported = optionsSupported = true;
    }

  };

  if (canUseDOM) {
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, true);
  }
} catch (e) {
  /* */
}

/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function addEventListener(node, eventName, handler, options) {
  if (options && typeof options !== 'boolean' && !onceSupported) {
    var once = options.once,
        capture = options.capture;
    var wrappedHandler = handler;

    if (!onceSupported && once) {
      wrappedHandler = handler.__once || function onceHandler(event) {
        this.removeEventListener(eventName, onceHandler, capture);
        handler.call(this, event);
      };

      handler.__once = wrappedHandler;
    }

    node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
  }

  node.addEventListener(eventName, handler, options);
}

/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function removeEventListener(node, eventName, handler, options) {
  var capture = options && typeof options !== 'boolean' ? options.capture : options;
  node.removeEventListener(eventName, handler, capture);

  if (handler.__once) {
    node.removeEventListener(eventName, handler.__once, capture);
  }
}

function listen(node, eventName, handler, options) {
  addEventListener(node, eventName, handler, options);
  return function () {
    removeEventListener(node, eventName, handler, options);
  };
}

/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */

function useCommittedRef(value) {
  var ref = useRef(value);
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref;
}

function useEventCallback(fn) {
  var ref = useCommittedRef(fn);
  return useCallback(function () {
    return ref.current && ref.current.apply(ref, arguments);
  }, [ref]);
}

/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

var ownerDocument$1 = (function (componentOrElement) {
  return ownerDocument(safeFindDOMNode(componentOrElement));
});

var escapeKeyCode = 27;

var noop$1 = function noop() {};

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var getRefTarget = function getRefTarget(ref) {
  return ref && ('current' in ref ? ref.current : ref);
};

/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */
function useRootClose(ref, onRootClose, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      disabled = _ref.disabled,
      _ref$clickTrigger = _ref.clickTrigger,
      clickTrigger = _ref$clickTrigger === void 0 ? 'click' : _ref$clickTrigger;

  var preventMouseRootCloseRef = useRef(false);
  var onClose = onRootClose || noop$1;
  var handleMouseCapture = useCallback(function (e) {
    var _e$composedPath$;

    var currentTarget = getRefTarget(ref);
    warning_1(!!currentTarget, 'RootClose captured a close event but does not have a ref to compare it to. ' + 'useRootClose(), should be passed a ref that resolves to a DOM node');
    preventMouseRootCloseRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || !!contains(currentTarget, (_e$composedPath$ = e.composedPath == null ? void 0 : e.composedPath()[0]) != null ? _e$composedPath$ : e.target);
  }, [ref]);
  var handleMouse = useEventCallback(function (e) {
    if (!preventMouseRootCloseRef.current) {
      onClose(e);
    }
  });
  var handleKeyUp = useEventCallback(function (e) {
    if (e.keyCode === escapeKeyCode) {
      onClose(e);
    }
  });
  useEffect(function () {
    if (disabled || ref == null) return undefined; // Store the current event to avoid triggering handlers immediately
    // https://github.com/facebook/react/issues/20074

    var currentEvent = window.event;
    var doc = ownerDocument$1(getRefTarget(ref)); // Use capture for this listener so it fires before React's listener, to
    // avoid false positives in the contains() check below if the target DOM
    // element is removed in the React mouse callback.

    var removeMouseCaptureListener = listen(doc, clickTrigger, handleMouseCapture, true);
    var removeMouseListener = listen(doc, clickTrigger, function (e) {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }

      handleMouse(e);
    });
    var removeKeyupListener = listen(doc, 'keyup', function (e) {
      // skip if this event is the same as the one running when we added the handlers
      if (e === currentEvent) {
        currentEvent = undefined;
        return;
      }

      handleKeyUp(e);
    });
    var mobileSafariHackListeners = [];

    if ('ontouchstart' in doc.documentElement) {
      mobileSafariHackListeners = [].slice.call(doc.body.children).map(function (el) {
        return listen(el, 'mousemove', noop$1);
      });
    }

    return function () {
      removeMouseCaptureListener();
      removeMouseListener();
      removeKeyupListener();
      mobileSafariHackListeners.forEach(function (remove) {
        return remove();
      });
    };
  }, [ref, disabled, clickTrigger, handleMouseCapture, handleMouse, handleKeyUp]);
}

var resolveContainerRef = function resolveContainerRef(ref) {
  var _ref;

  if (typeof document === 'undefined') return null;
  if (ref == null) return ownerDocument().body;
  if (typeof ref === 'function') ref = ref();
  if (ref && 'current' in ref) ref = ref.current;
  if ((_ref = ref) != null && _ref.nodeType) return ref || null;
  return null;
};
function useWaitForDOMRef(ref, onResolved) {
  var _useState = useState(function () {
    return resolveContainerRef(ref);
  }),
      resolvedRef = _useState[0],
      setRef = _useState[1];

  if (!resolvedRef) {
    var earlyRef = resolveContainerRef(ref);
    if (earlyRef) setRef(earlyRef);
  }

  useEffect(function () {
    if (onResolved && resolvedRef) {
      onResolved(resolvedRef);
    }
  }, [onResolved, resolvedRef]);
  useEffect(function () {
    var nextRef = resolveContainerRef(ref);

    if (nextRef !== resolvedRef) {
      setRef(nextRef);
    }
  }, [ref, resolvedRef]);
  return resolvedRef;
}

function toModifierMap(modifiers) {
  var result = {};

  if (!Array.isArray(modifiers)) {
    return modifiers || result;
  } // eslint-disable-next-line no-unused-expressions


  modifiers == null ? void 0 : modifiers.forEach(function (m) {
    result[m.name] = m;
  });
  return result;
}
function toModifierArray(map) {
  if (map === void 0) {
    map = {};
  }

  if (Array.isArray(map)) return map;
  return Object.keys(map).map(function (k) {
    map[k].name = k;
    return map[k];
  });
}
function mergeOptionsWithPopperConfig(_ref) {
  var _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;

  var enabled = _ref.enabled,
      enableEvents = _ref.enableEvents,
      placement = _ref.placement,
      flip = _ref.flip,
      offset = _ref.offset,
      fixed = _ref.fixed,
      containerPadding = _ref.containerPadding,
      arrowElement = _ref.arrowElement,
      _ref$popperConfig = _ref.popperConfig,
      popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig;
  var modifiers = toModifierMap(popperConfig.modifiers);
  return _extends$7j({}, popperConfig, {
    placement: placement,
    enabled: enabled,
    strategy: fixed ? 'fixed' : popperConfig.strategy,
    modifiers: toModifierArray(_extends$7j({}, modifiers, {
      eventListeners: {
        enabled: enableEvents
      },
      preventOverflow: _extends$7j({}, modifiers.preventOverflow, {
        options: containerPadding ? _extends$7j({
          padding: containerPadding
        }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
      }),
      offset: {
        options: _extends$7j({
          offset: offset
        }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
      },
      arrow: _extends$7j({}, modifiers.arrow, {
        enabled: !!arrowElement,
        options: _extends$7j({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
          element: arrowElement
        })
      }),
      flip: _extends$7j({
        enabled: !!flip
      }, modifiers.flip)
    }))
  });
}

/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */
var Overlay = /*#__PURE__*/React__default.forwardRef(function (props, outerRef) {
  var flip = props.flip,
      offset = props.offset,
      placement = props.placement,
      _props$containerPaddi = props.containerPadding,
      containerPadding = _props$containerPaddi === void 0 ? 5 : _props$containerPaddi,
      _props$popperConfig = props.popperConfig,
      popperConfig = _props$popperConfig === void 0 ? {} : _props$popperConfig,
      Transition = props.transition;

  var _useCallbackRef = useCallbackRef(),
      rootElement = _useCallbackRef[0],
      attachRef = _useCallbackRef[1];

  var _useCallbackRef2 = useCallbackRef(),
      arrowElement = _useCallbackRef2[0],
      attachArrowRef = _useCallbackRef2[1];

  var mergedRef = useMergedRefs(attachRef, outerRef);
  var container = useWaitForDOMRef(props.container);
  var target = useWaitForDOMRef(props.target);

  var _useState = useState(!props.show),
      exited = _useState[0],
      setExited = _useState[1];

  var _usePopper = usePopper(target, rootElement, mergeOptionsWithPopperConfig({
    placement: placement,
    enableEvents: !!props.show,
    containerPadding: containerPadding || 5,
    flip: flip,
    offset: offset,
    arrowElement: arrowElement,
    popperConfig: popperConfig
  })),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      popper = _objectWithoutPropertiesLoose$1(_usePopper, ["styles", "attributes"]);

  if (props.show) {
    if (exited) setExited(false);
  } else if (!props.transition && !exited) {
    setExited(true);
  }

  var handleHidden = function handleHidden() {
    setExited(true);

    if (props.onExited) {
      props.onExited.apply(props, arguments);
    }
  }; // Don't un-render the overlay while it's transitioning out.


  var mountOverlay = props.show || Transition && !exited;
  useRootClose(rootElement, props.onHide, {
    disabled: !props.rootClose || props.rootCloseDisabled,
    clickTrigger: props.rootCloseEvent
  });

  if (!mountOverlay) {
    // Don't bother showing anything if we don't have to.
    return null;
  }

  var child = props.children(_extends$7j({}, popper, {
    show: !!props.show,
    props: _extends$7j({}, attributes.popper, {
      style: styles.popper,
      ref: mergedRef
    }),
    arrowProps: _extends$7j({}, attributes.arrow, {
      style: styles.arrow,
      ref: attachArrowRef
    })
  }));

  if (Transition) {
    var onExit = props.onExit,
        onExiting = props.onExiting,
        onEnter = props.onEnter,
        onEntering = props.onEntering,
        onEntered = props.onEntered;
    child = /*#__PURE__*/React__default.createElement(Transition, {
      "in": props.show,
      appear: true,
      onExit: onExit,
      onExiting: onExiting,
      onExited: handleHidden,
      onEnter: onEnter,
      onEntering: onEntering,
      onEntered: onEntered
    }, child);
  }

  return container ? /*#__PURE__*/ReactDOM.createPortal(child, container) : null;
});
Overlay.displayName = 'Overlay';
Overlay.propTypes = {
  /**
   * Set the visibility of the Overlay
   */
  show: PropTypes.bool,

  /** Specify where the overlay element is positioned in relation to the target element */
  placement: PropTypes.oneOf(placements),

  /**
   * A DOM Element, Ref to an element, or function that returns either. The `target` element is where
   * the overlay is positioned relative to.
   */
  target: PropTypes.any,

  /**
   * A DOM Element, Ref to an element, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: PropTypes.any,

  /**
   * Enables the Popper.js `flip` modifier, allowing the Overlay to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */
  flip: PropTypes.bool,

  /**
   * A render prop that returns an element to overlay and position. See
   * the [react-popper documentation](https://github.com/FezVrasta/react-popper#children) for more info.
   *
   * @type {Function ({
   *   show: boolean,
   *   placement: Placement,
   *   update: () => void,
   *   forceUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *     [string]: string | number,
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     [string]: string | number,
   *   },
   * }) => React.Element}
   */
  children: PropTypes.func.isRequired,

  /**
   * Control how much space there is between the edge of the boundary element and overlay.
   * A convenience shortcut to setting `popperConfig.modfiers.preventOverflow.padding`
   */
  containerPadding: PropTypes.number,

  /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */
  popperConfig: PropTypes.object,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: PropTypes.bool,

  /**
   * Specify event for toggling overlay
   */
  rootCloseEvent: PropTypes.oneOf(['click', 'mousedown']),

  /**
   * Specify disabled for disable RootCloseWrapper
   */
  rootCloseDisabled: PropTypes.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (props.rootClose) {
      var _PropTypes$func;

      return (_PropTypes$func = PropTypes.func).isRequired.apply(_PropTypes$func, [props].concat(args));
    }

    return PropTypes.func.apply(PropTypes, [props].concat(args));
  },

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  // @ts-ignore
  transition: PropTypes.elementType,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: PropTypes.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: PropTypes.func
};

var ThemeContext = /*#__PURE__*/React__default.createContext({});
var Consumer = ThemeContext.Consumer,
    Provider = ThemeContext.Provider;

function useBootstrapPrefix(prefix, defaultPrefix) {
  var prefixes = useContext(ThemeContext);
  return prefix || prefixes[defaultPrefix] || defaultPrefix;
}

function getMargins(element) {
  var styles = window.getComputedStyle(element);
  var top = parseFloat(styles.marginTop) || 0;
  var right = parseFloat(styles.marginRight) || 0;
  var bottom = parseFloat(styles.marginBottom) || 0;
  var left = parseFloat(styles.marginLeft) || 0;
  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
}

function usePopperMarginModifiers() {
  var overlayRef = useRef(null);
  var margins = useRef(null);
  var arrowMargins = useRef(null);
  var popoverClass = useBootstrapPrefix(undefined, 'popover');
  var dropdownMenuClass = useBootstrapPrefix(undefined, 'dropdown-menu');
  var callback = useCallback(function (overlay) {
    if (!overlay || !(hasClass(overlay, popoverClass) || hasClass(overlay, dropdownMenuClass))) return;
    margins.current = getMargins(overlay);
    overlay.style.margin = '0';
    overlayRef.current = overlay;
  }, [popoverClass, dropdownMenuClass]);
  var offset = useMemo(function () {
    return {
      name: 'offset',
      options: {
        offset: function offset(_ref) {
          var placement = _ref.placement;
          if (!margins.current) return [0, 0];
          var _margins$current = margins.current,
              top = _margins$current.top,
              left = _margins$current.left,
              bottom = _margins$current.bottom,
              right = _margins$current.right;

          switch (placement.split('-')[0]) {
            case 'top':
              return [0, bottom];

            case 'left':
              return [0, right];

            case 'bottom':
              return [0, top];

            case 'right':
              return [0, left];

            default:
              return [0, 0];
          }
        }
      }
    };
  }, [margins]);
  var arrow = useMemo(function () {
    return {
      name: 'arrow',
      options: {
        padding: function padding() {
          // The options here are used for Popper 2.8.4 and up.
          // For earlier version, padding is handled in popoverArrowMargins below.
          if (!arrowMargins.current) {
            return 0;
          }

          var _arrowMargins$current = arrowMargins.current,
              top = _arrowMargins$current.top,
              right = _arrowMargins$current.right;
          var padding = top || right;
          return {
            top: padding,
            left: padding,
            right: padding,
            bottom: padding
          };
        }
      }
    };
  }, [arrowMargins]); // Converts popover arrow margin to arrow modifier padding

  var popoverArrowMargins = useMemo(function () {
    return {
      name: 'popoverArrowMargins',
      enabled: true,
      phase: 'main',
      fn: function fn() {
        return undefined;
      },
      requiresIfExists: ['arrow'],
      effect: function effect(_ref2) {
        var state = _ref2.state;

        if (!overlayRef.current || !state.elements.arrow || !hasClass(overlayRef.current, popoverClass)) {
          return undefined;
        }

        if (state.modifiersData['arrow#persistent']) {
          // @popperjs/core <= 2.8.3 uses arrow#persistent to pass padding to arrow modifier.
          var _getMargins = getMargins(state.elements.arrow),
              top = _getMargins.top,
              right = _getMargins.right;

          var padding = top || right;
          state.modifiersData['arrow#persistent'].padding = {
            top: padding,
            left: padding,
            right: padding,
            bottom: padding
          };
        } else {
          // @popperjs/core >= 2.8.4 gets the padding from the arrow modifier options,
          // so we'll get the margins here, and let the arrow modifier above pass
          // it to popper.
          arrowMargins.current = getMargins(state.elements.arrow);
        }

        state.elements.arrow.style.margin = '0';
        return function () {
          if (state.elements.arrow) state.elements.arrow.style.margin = '';
        };
      }
    };
  }, [popoverClass]);
  return [callback, [offset, arrow, popoverArrowMargins]];
}

/**
 * Returns the owner window of a given element.
 * 
 * @param node the element
 */

function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc && doc.defaultView || window;
}

/**
 * Returns one or all computed style properties of an element.
 * 
 * @param node the element
 * @param psuedoElement the style property
 */

function getComputedStyle$2(node, psuedoElement) {
  return ownerWindow(node).getComputedStyle(node, psuedoElement);
}

var rUpper = /([A-Z])/g;
function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function isTransform(value) {
  return !!(value && supportedTransforms.test(value));
}

function style(node, property) {
  var css = '';
  var transforms = '';

  if (typeof property === 'string') {
    return node.style.getPropertyValue(hyphenateStyleName(property)) || getComputedStyle$2(node).getPropertyValue(hyphenateStyleName(property));
  }

  Object.keys(property).forEach(function (key) {
    var value = property[key];

    if (!value && value !== 0) {
      node.style.removeProperty(hyphenateStyleName(key));
    } else if (isTransform(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += hyphenateStyleName(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += "transform: " + transforms + ";";
  }

  node.style.cssText += ";" + css;
}

/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */
function triggerEvent(node, eventName, bubbles, cancelable) {
  if (bubbles === void 0) {
    bubbles = false;
  }

  if (cancelable === void 0) {
    cancelable = true;
  }

  if (node) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent(eventName, bubbles, cancelable);
    node.dispatchEvent(event);
  }
}

function parseDuration(node) {
  var str = style(node, 'transitionDuration') || '';
  var mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

function emulateTransitionEnd(element, duration, padding) {
  if (padding === void 0) {
    padding = 5;
  }

  var called = false;
  var handle = setTimeout(function () {
    if (!called) triggerEvent(element, 'transitionend', true);
  }, duration + padding);
  var remove = listen(element, 'transitionend', function () {
    called = true;
  }, {
    once: true
  });
  return function () {
    clearTimeout(handle);
    remove();
  };
}

function transitionEnd(element, handler, duration, padding) {
  if (duration == null) duration = parseDuration(element) || 0;
  var removeEmulate = emulateTransitionEnd(element, duration, padding);
  var remove = listen(element, 'transitionend', handler);
  return function () {
    removeEmulate();
    remove();
  };
}

function parseDuration$1(node, property) {
  var str = style(node, property) || '';
  var mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

function transitionEndListener(element, handler) {
  var duration = parseDuration$1(element, 'transitionDuration');
  var delay = parseDuration$1(element, 'transitionDelay');
  var remove = transitionEnd(element, function (e) {
    if (e.target === element) {
      remove();
      handler(e);
    }
  }, duration + delay);
}

// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  node.offsetHeight;
}

var _excluded$4 = ["className", "children"];

var _fadeStyles;
var defaultProps$1 = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
var fadeStyles = (_fadeStyles = {}, _fadeStyles[ENTERING] = 'show', _fadeStyles[ENTERED] = 'show', _fadeStyles);
var Fade = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose$1(_ref, _excluded$4);

  var handleEnter = useCallback(function (node) {
    triggerBrowserReflow(node);
    if (props.onEnter) props.onEnter(node);
  }, [props]);
  return /*#__PURE__*/React__default.createElement(Transition, _extends$7j({
    ref: ref,
    addEndListener: transitionEndListener
  }, props, {
    onEnter: handleEnter
  }), function (status, innerProps) {
    return /*#__PURE__*/React__default.cloneElement(children, _extends$7j({}, innerProps, {
      className: classnames('fade', className, children.props.className, fadeStyles[status])
    }));
  });
});
Fade.defaultProps = defaultProps$1;
Fade.displayName = 'Fade';

var _excluded$5 = ["children", "transition", "popperConfig"],
    _excluded2 = ["props", "arrowProps", "show", "update", "forceUpdate", "placement", "state"];
var defaultProps$2 = {
  transition: Fade,
  rootClose: false,
  show: false,
  placement: 'top'
};

function wrapRefs(props, arrowProps) {
  var ref = props.ref;
  var aRef = arrowProps.ref;

  props.ref = ref.__wrapped || (ref.__wrapped = function (r) {
    return ref(safeFindDOMNode(r));
  });

  arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = function (r) {
    return aRef(safeFindDOMNode(r));
  });
}

function Overlay$1(_ref) {
  var overlay = _ref.children,
      transition = _ref.transition,
      _ref$popperConfig = _ref.popperConfig,
      popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig,
      outerProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$5);

  var popperRef = useRef({});

  var _usePopperMarginModif = usePopperMarginModifiers(),
      ref = _usePopperMarginModif[0],
      marginModifiers = _usePopperMarginModif[1];

  var actualTransition = transition === true ? Fade : transition || null;
  return /*#__PURE__*/React__default.createElement(Overlay, _extends$7j({}, outerProps, {
    ref: ref,
    popperConfig: _extends$7j({}, popperConfig, {
      modifiers: marginModifiers.concat(popperConfig.modifiers || [])
    }),
    transition: actualTransition
  }), function (_ref2) {
    var _state$modifiersData$;

    var overlayProps = _ref2.props,
        arrowProps = _ref2.arrowProps,
        show = _ref2.show,
        update = _ref2.update,
        _ = _ref2.forceUpdate,
        placement = _ref2.placement,
        state = _ref2.state,
        props = _objectWithoutPropertiesLoose$1(_ref2, _excluded2);

    wrapRefs(overlayProps, arrowProps);
    var popper = Object.assign(popperRef.current, {
      state: state,
      scheduleUpdate: update,
      placement: placement,
      outOfBoundaries: (state == null ? void 0 : (_state$modifiersData$ = state.modifiersData.hide) == null ? void 0 : _state$modifiersData$.isReferenceHidden) || false
    });
    if (typeof overlay === 'function') return overlay(_extends$7j({}, props, overlayProps, {
      placement: placement,
      show: show
    }, !transition && show && {
      className: 'show'
    }, {
      popper: popper,
      arrowProps: arrowProps
    }));
    return /*#__PURE__*/React__default.cloneElement(overlay, _extends$7j({}, props, overlayProps, {
      placement: placement,
      arrowProps: arrowProps,
      popper: popper,
      className: classnames(overlay.props.className, !transition && show && 'show'),
      style: _extends$7j({}, overlay.props.style, overlayProps.style)
    }));
  });
}

Overlay$1.defaultProps = defaultProps$2;

var _excluded$6 = ["trigger", "overlay", "children", "popperConfig", "show", "defaultShow", "onToggle", "delay", "placement", "flip"];

var RefHolder = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(RefHolder, _React$Component);

  function RefHolder() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = RefHolder.prototype;

  _proto.render = function render() {
    return this.props.children;
  };

  return RefHolder;
}(React__default.Component);

function normalizeDelay(delay) {
  return delay && typeof delay === 'object' ? delay : {
    show: delay,
    hide: delay
  };
} // Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.


function handleMouseOverOut( // eslint-disable-next-line @typescript-eslint/no-shadow
handler, args, relatedNative) {
  var e = args[0];
  var target = e.currentTarget;
  var related = e.relatedTarget || e.nativeEvent[relatedNative];

  if ((!related || related !== target) && !contains(target, related)) {
    handler.apply(void 0, args);
  }
}

var defaultProps$3 = {
  defaultShow: false,
  trigger: ['hover', 'focus']
};

function OverlayTrigger(_ref) {
  var trigger = _ref.trigger,
      overlay = _ref.overlay,
      children = _ref.children,
      _ref$popperConfig = _ref.popperConfig,
      popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig,
      propsShow = _ref.show,
      _ref$defaultShow = _ref.defaultShow,
      defaultShow = _ref$defaultShow === void 0 ? false : _ref$defaultShow,
      onToggle = _ref.onToggle,
      propsDelay = _ref.delay,
      placement = _ref.placement,
      _ref$flip = _ref.flip,
      flip = _ref$flip === void 0 ? placement && placement.indexOf('auto') !== -1 : _ref$flip,
      props = _objectWithoutPropertiesLoose$1(_ref, _excluded$6);

  var triggerNodeRef = useRef(null);
  var timeout = useTimeout();
  var hoverStateRef = useRef('');

  var _useUncontrolledProp = useUncontrolledProp(propsShow, defaultShow, onToggle),
      show = _useUncontrolledProp[0],
      setShow = _useUncontrolledProp[1];

  var delay = normalizeDelay(propsDelay);

  var _ref2 = typeof children !== 'function' ? React__default.Children.only(children).props : {},
      onFocus = _ref2.onFocus,
      onBlur = _ref2.onBlur,
      onClick = _ref2.onClick;

  var getTarget = useCallback(function () {
    return safeFindDOMNode(triggerNodeRef.current);
  }, []);
  var handleShow = useCallback(function () {
    timeout.clear();
    hoverStateRef.current = 'show';

    if (!delay.show) {
      setShow(true);
      return;
    }

    timeout.set(function () {
      if (hoverStateRef.current === 'show') setShow(true);
    }, delay.show);
  }, [delay.show, setShow, timeout]);
  var handleHide = useCallback(function () {
    timeout.clear();
    hoverStateRef.current = 'hide';

    if (!delay.hide) {
      setShow(false);
      return;
    }

    timeout.set(function () {
      if (hoverStateRef.current === 'hide') setShow(false);
    }, delay.hide);
  }, [delay.hide, setShow, timeout]);
  var handleFocus = useCallback(function () {
    handleShow();

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    onFocus == null ? void 0 : onFocus.apply(void 0, args);
  }, [handleShow, onFocus]);
  var handleBlur = useCallback(function () {
    handleHide();

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    onBlur == null ? void 0 : onBlur.apply(void 0, args);
  }, [handleHide, onBlur]);
  var handleClick = useCallback(function () {
    setShow(!show);
    if (onClick) onClick.apply(void 0, arguments);
  }, [onClick, setShow, show]);
  var handleMouseOver = useCallback(function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    handleMouseOverOut(handleShow, args, 'fromElement');
  }, [handleShow]);
  var handleMouseOut = useCallback(function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    handleMouseOverOut(handleHide, args, 'toElement');
  }, [handleHide]);
  var triggers = trigger == null ? [] : [].concat(trigger);
  var triggerProps = {};

  if (triggers.indexOf('click') !== -1) {
    triggerProps.onClick = handleClick;
  }

  if (triggers.indexOf('focus') !== -1) {
    triggerProps.onFocus = handleFocus;
    triggerProps.onBlur = handleBlur;
  }

  if (triggers.indexOf('hover') !== -1) {
    process.env.NODE_ENV !== "production" ? warning_1(triggers.length > 1, '[react-bootstrap] Specifying only the `"hover"` trigger limits the visibility of the overlay to just mouse users. Consider also including the `"focus"` trigger so that touch and keyboard only users can see the overlay as well.') : void 0;
    triggerProps.onMouseOver = handleMouseOver;
    triggerProps.onMouseOut = handleMouseOut;
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, typeof children === 'function' ? children(_extends$7j({}, triggerProps, {
    ref: triggerNodeRef
  })) : /*#__PURE__*/React__default.createElement(RefHolder, {
    ref: triggerNodeRef
  }, /*#__PURE__*/cloneElement(children, triggerProps)), /*#__PURE__*/React__default.createElement(Overlay$1, _extends$7j({}, props, {
    show: show,
    onHide: handleHide,
    flip: flip,
    placement: placement,
    popperConfig: popperConfig,
    target: getTarget
  }), overlay));
}

OverlayTrigger.defaultProps = defaultProps$3;

var _excluded$7 = ["ref"];
var Tooltip$1 = function Tooltip$1(_ref) {
  var position = _ref.position,
    showArrow = _ref.showArrow,
    children = _ref.children,
    msg = _ref.msg,
    show = _ref.show,
    align = _ref.align;
  var positionTranslate = {
    top: 'top',
    right: 'right',
    bottom: 'bottom',
    left: 'left',
    'top-right': 'top-end',
    'top-left': 'top-start',
    'bottom-right': 'bottom-end',
    'bottom-left': 'bottom-start'
  };
  var alignText = {
    top: 'center',
    right: 'left',
    bottom: 'center',
    left: 'right',
    'top-right': 'left',
    'top-left': 'right',
    'bottom-right': 'left',
    'bottom-left': 'right'
  };
  var ChildrenWrapper$1 = function ChildrenWrapper$1() {
    return /*#__PURE__*/React__default.createElement(OverlayTrigger, {
      placement: positionTranslate[position],
      overlay: /*#__PURE__*/React__default.createElement(TooltipOverlay, {
        position: position
      }, /*#__PURE__*/React__default.createElement(TooltipWrapper, {
        "data-testid": "tooltip",
        position: position
      }, /*#__PURE__*/React__default.createElement(TooltipMessage, null, /*#__PURE__*/React__default.createElement(P$1, {
        type: "4",
        variant: "neutral",
        modifier: "inverted",
        align: align ? align : alignText[position]
      }, msg)), showArrow && /*#__PURE__*/React__default.createElement(TooltipArrow, {
        "data-testid": "tooltip-arrow",
        position: position
      })))
    }, function (_ref2) {
      var ref = _ref2.ref,
        triggerHandler = _objectWithoutProperties(_ref2, _excluded$7);
      return /*#__PURE__*/React__default.createElement(ChildrenWrapper, _extends({}, triggerHandler, {
        ref: ref
      }), children);
    });
  };
  return /*#__PURE__*/React__default.createElement(Tooltip, {
    position: position,
    msg: msg,
    showArrow: showArrow,
    show: show
  }, ChildrenWrapper$1());
};
Tooltip$1.defaultProps = {
  position: 'top',
  size: 'md',
  showArrow: true
};
Tooltip$1.propTypes = {
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left', 'top-right', 'top-left', 'bottom-right', 'bottom-left']),
  showArrow: PropTypes.bool,
  show: PropTypes.bool,
  msg: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  align: PropTypes.oneOf(['center', 'right', 'left'])
};

var _templateObject$v, _templateObject2$p, _templateObject3$l;
var CellWrapper = styled.div(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n"])));
var ItemWrapper = styled.div(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  ", ";\n"])), function (_ref) {
  var leftSpacing = _ref.leftSpacing;
  return css$1(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteral(["\n      margin-left: ", "\n    "])), theme.spacing[leftSpacing]);
});

var IdNumberFormatter = function IdNumberFormatter(_ref) {
  var cell = _ref.cell,
    row = _ref.row,
    _ref$formatExtraData = _ref.formatExtraData,
    pad = _ref$formatExtraData.pad,
    showPill = _ref$formatExtraData.showPill,
    pill = _ref$formatExtraData.pill,
    showTooltip = _ref$formatExtraData.showTooltip,
    tooltip = _ref$formatExtraData.tooltip;
  var renderCell = function renderCell() {
    return /*#__PURE__*/React__default.createElement(ItemWrapper, {
      leftSpacing: "spacing-0"
    }, /*#__PURE__*/React__default.createElement(Span$1, {
      variant: "neutral",
      modifier: "strong",
      type: "4"
    }, pad ? cell.toString().padStart(pad.targetLength, pad.padString) : cell));
  };
  var renderPill = function renderPill() {
    if (pill !== null && pill !== void 0 && pill.flagName && row[pill === null || pill === void 0 ? void 0 : pill.flagName] || showPill) {
      return /*#__PURE__*/React__default.createElement(ItemWrapper, {
        leftSpacing: "spacing-6"
      }, /*#__PURE__*/React__default.createElement(Pill, {
        variant: pill.variant
      }, pill === null || pill === void 0 ? void 0 : pill.text));
    }
  };
  var renderTooltip = function renderTooltip() {
    if (tooltip !== null && tooltip !== void 0 && tooltip.flagName && row[tooltip === null || tooltip === void 0 ? void 0 : tooltip.flagName] || showTooltip) {
      return /*#__PURE__*/React__default.createElement(ItemWrapper, {
        leftSpacing: "spacing-3"
      }, /*#__PURE__*/React__default.createElement(Tooltip$1, {
        msg: tooltip.msg,
        position: tooltip.position
      }, tooltip.children));
    }
  };
  return cell || cell === 0 ? /*#__PURE__*/React__default.createElement(CellWrapper, null, renderCell(), renderPill(), renderTooltip()) : null;
};

var _templateObject$w;
var Description = styled.div(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral(["\n  padding-top: ", ";\n  padding-bottom: ", ";\n  ", "\n"])), theme.spacing['spacing-4'], theme.spacing['spacing-4'], function (_ref) {
  var overflowHidden = _ref.overflowHidden;
  return overflowHidden && "\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n  ";
});

var DescriptionFormatter = function DescriptionFormatter(_ref) {
  var cell = _ref.cell,
    formatExtraData = _ref.formatExtraData;
  return cell ? /*#__PURE__*/React__default.createElement(Description, {
    overflowHidden: formatExtraData === null || formatExtraData === void 0 ? void 0 : formatExtraData.overflowHidden
  }, /*#__PURE__*/React__default.createElement(Span$1, {
    variant: "neutral",
    modifier: "strong",
    type: "4"
  }, cell)) : null;
};

var _templateObject$x, _templateObject2$q, _templateObject3$m;
var Header$1 = styled.div(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral(["\n  display: flex;\n\n  ", "\n"])), function (_ref) {
  var align = _ref.align;
  var aligns = {
    left: 'flex-start',
    right: 'flex-end',
    center: 'center'
  };
  return css$1(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteral(["\n      justify-content: ", ";\n    "])), aligns[align]);
});
var IconWrapper = styled.div(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteral(["\n  margin-left: ", ";\n"])), theme.spacing['spacing-3']);

var HeaderFormatter = function HeaderFormatter(_ref) {
  var _column$customHeader;
  var column = _ref.column;
  return /*#__PURE__*/React__default.createElement(Header$1, {
    align: column.align
  }, /*#__PURE__*/React__default.createElement(Span$1, {
    variant: "neutral",
    modifier: "regular",
    type: "4",
    weight: "bold"
  }, column.text), ((_column$customHeader = column.customHeader) === null || _column$customHeader === void 0 ? void 0 : _column$customHeader.tooltip) && /*#__PURE__*/React__default.createElement(IconWrapper, null, /*#__PURE__*/React__default.createElement(Tooltip$1, {
    align: "center",
    msg: /*#__PURE__*/React__default.createElement(Span$1, {
      type: "2",
      variant: 'neutral',
      modifier: 'inverted'
    }, column.customHeader.tooltip)
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "info_circle_outline",
    cursor: "pointer",
    width: 16,
    height: 16,
    variant: "neutral",
    modifier: "regular"
  }))));
};

var _templateObject$y, _templateObject2$r;
var Cell = styled.div(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral(["\n  display: flex;\n  ", "\n"])), function (_ref) {
  var align = _ref.align,
    _ref$cursor = _ref.cursor,
    cursor = _ref$cursor === void 0 ? 'inherit' : _ref$cursor;
  var aligns = {
    left: 'flex-start',
    right: 'flex-end',
    center: 'center'
  };
  return css$1(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteral(["\n      justify-content: ", ";\n      cursor: ", ";\n    "])), aligns[align], cursor);
});

var NumberFormatter = function NumberFormatter(_ref) {
  var cell = _ref.cell,
    formatExtraData = _ref.formatExtraData;
  return cell ? /*#__PURE__*/React__default.createElement(Cell, {
    align: formatExtraData.align
  }, /*#__PURE__*/React__default.createElement(Pill, {
    variant: "info"
  }, cell.text)) : null;
};

var ButtonFormatter = function ButtonFormatter(_ref) {
  var cell = _ref.cell,
    formatExtraData = _ref.formatExtraData;
  return cell ? /*#__PURE__*/React__default.createElement(Cell, {
    align: formatExtraData.align
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "secondary",
    size: "sm",
    onClick: cell.callback,
    disabled: cell.disabled
  }, cell.text)) : null;
};

var _templateObject$z, _templateObject2$s, _templateObject3$n, _templateObject4$i, _templateObject5$h, _templateObject6$f, _templateObject7$c, _templateObject8$9, _templateObject9$8, _templateObject10$8, _templateObject11$7;
var Toggle = styled.div(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  align-items: center;\n"])));
var ToggleWrapper = styled.label(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  ", "\n  ", "\n"])), theme.textStyles['text-preset-9'](), function (_ref) {
  var disabled = _ref.disabled;
  return disabled && "\n    color: ".concat(theme.colors.neutral.text.regular, ";\n  ");
});
var ToggleCheckbox = styled.input.attrs(function () {
  return {
    type: 'checkbox'
  };
})(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteral(["\n  opacity: ", ";\n"])), theme.opacities['opacity-4']);
var ToggleSwitch = styled.span(_templateObject4$i || (_templateObject4$i = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  min-width: 42px;\n  height: 24px;\n  margin-left: ", ";\n  ", ";\n"])), theme.spacing['spacing-3'], function (_ref2) {
  var size = _ref2.size;
  return getToggleSize(size);
});
var Switch = styled.span(_templateObject5$h || (_templateObject5$h = _taggedTemplateLiteral(["\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  border-radius: ", ";\n  box-shadow: inset 0 0 0 1px ", ";\n  background: ", ";\n\n  &:before {\n    position: absolute;\n    content: '';\n    background-color: ", ";\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n    border-radius: ", ";\n    ", "\n  }\n\n  ", ":hover:not(:disabled) + & {\n    box-shadow: inset 0 0 0 1px ", ";\n  }\n\n  ", ":disabled + & {\n    background: ", ";\n  }\n  ", ":checked + & {\n    background: ", ";\n  }\n\n  ", ":checked:disabled + & {\n    background: ", ";\n  }\n\n  ", ":checked + &:before {\n    ", "\n    background-color: ", ";\n  }\n  ", ":checked:hover:not(:disabled) + & {\n    background-color: ", ";\n  }\n\n  ", ":disabled + &:before {\n    background-color: ", ";\n  }\n\n  ", ":checked:disabled + &:before {\n    background-color: ", ";\n  }\n"])), theme.borderRadius['border-radius-5'], theme.colors['neutral'].border.weak, theme.colors.neutral.bg.regular, theme.colors.neutral.bg.stronger, theme.borderRadius['border-radius-5'], function (_ref3) {
  var size = _ref3.size;
  return getSpanSize(size);
}, ToggleCheckbox, theme.colors['neutral'].border.regular, ToggleCheckbox, theme.colors.neutral.bg.strong, ToggleCheckbox, theme.colors['secondary-1'].bg.regular, ToggleCheckbox, theme.colors.neutral.bg.strong, ToggleCheckbox, function (_ref4) {
  var size = _ref4.size;
  return getSpanTransform(size);
}, theme.colors.neutral.bg.weak, ToggleCheckbox, theme.colors['secondary-1'].bg.strong, ToggleCheckbox, theme.colors.neutral.bg.regular, ToggleCheckbox, theme.colors.neutral.bg.regular);
var getToggleSize = function getToggleSize(size) {
  switch (size) {
    case 'sm':
      return css$1(_templateObject6$f || (_templateObject6$f = _taggedTemplateLiteral(["\n        width: 42px;\n        height: 24px;\n      "])));
    case 'md':
      return css$1(_templateObject7$c || (_templateObject7$c = _taggedTemplateLiteral(["\n        width: 60px;\n        height: 34px;\n      "])));
  }
};
var getSpanSize = function getSpanSize(size) {
  switch (size) {
    case 'sm':
      return css$1(_templateObject8$9 || (_templateObject8$9 = _taggedTemplateLiteral(["\n        height: 20px;\n        width: 20px;\n        left: ", ";\n        bottom: ", ";\n      "])), theme.spacing['spacing-1'], theme.spacing['spacing-1']);
    case 'md':
      return css$1(_templateObject9$8 || (_templateObject9$8 = _taggedTemplateLiteral(["\n        height: 26px;\n        width: 26px;\n        left: ", ";\n        bottom: ", ";\n      "])), theme.spacing['spacing-2'], theme.spacing['spacing-2']);
  }
};
var getSpanTransform = function getSpanTransform(size) {
  switch (size) {
    case 'sm':
      return css$1(_templateObject10$8 || (_templateObject10$8 = _taggedTemplateLiteral(["\n        -webkit-transform: translateX(18px);\n        -ms-transform: translateX(18px);\n        transform: translateX(18px);\n      "])));
    case 'md':
      return css$1(_templateObject11$7 || (_templateObject11$7 = _taggedTemplateLiteral(["\n        -webkit-transform: translateX(26px);\n        -ms-transform: translateX(26px);\n        transform: translateX(26px);\n      "])));
  }
};

var Toggle$1 = function Toggle$1(_ref) {
  var disabled = _ref.disabled,
    checked = _ref.checked,
    onChange = _ref.onChange,
    size = _ref.size,
    children = _ref.children,
    onClick = _ref.onClick;
  var _useState = useState(checked),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setChecked = _useState2[1];
  useEffect(function () {
    setChecked(checked);
  }, [checked]);
  var handleChange = function handleChange(_ref2) {
    var checked = _ref2.target.checked;
    if (onChange) {
      setChecked(checked);
      onChange(checked);
    }
  };
  var handleClick = function handleClick(_ref3) {
    var checked = _ref3.target.checked;
    onClick && onClick(checked);
  };
  return /*#__PURE__*/React__default.createElement(Toggle, null, /*#__PURE__*/React__default.createElement(ToggleWrapper, {
    disabled: disabled
  }, children, /*#__PURE__*/React__default.createElement(ToggleSwitch, {
    size: size
  }, /*#__PURE__*/React__default.createElement(ToggleCheckbox, {
    disabled: disabled,
    checked: isChecked,
    onChange: handleChange,
    onClick: handleClick
  }), /*#__PURE__*/React__default.createElement(Switch, {
    size: size
  }))));
};
Toggle$1.defaultProps = {
  disabled: false,
  checked: false,
  size: 'sm'
};
Toggle$1.propTypes = {
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md']),
  onChange: PropTypes.func,
  onClick: PropTypes.func
};

var ToggleFormatter = function ToggleFormatter(_ref) {
  var cell = _ref.cell,
    formatExtraData = _ref.formatExtraData;
  return cell ? /*#__PURE__*/React__default.createElement(Cell, {
    align: formatExtraData.align
  }, /*#__PURE__*/React__default.createElement(Toggle$1, cell, cell.text)) : null;
};

var _templateObject$A, _templateObject2$t;
var Image = styled.img(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var cursor = _ref.cursor;
  return css$1(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteral(["\n      cursor: ", ";\n    "])), cursor);
});

var AmexColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=American_Express, Color=On\">\n<g id=\"american\">\n<path id=\"Vector\" d=\"M37.9119 29.6473H24.2003H10.0298V15.6544V2H23.912H37.9119V15.6544V29.6473Z\" fill=\"white\"/>\n<path id=\"Vector_2\" d=\"M36.864 21.5305H27.6955L27.1188 20.7719V21.5305H25.1356V20.3343C24.8885 20.4335 24.606 20.4743 24.2882 20.4743H23.9587V21.513H21.0045L20.5573 20.8828L20.1277 21.513H15.3375V16.9323H20.1454L20.5926 17.545L21.0398 16.9323H37.9174V2H10.0294V13.227L10.9945 10.9862H12.9247L13.4308 12.13V10.9862H15.7906L16.1084 11.8965L16.4262 10.9862H26.6421V11.4122C27.0305 11.1146 27.519 10.9862 28.0663 10.9862H31.244L31.7501 12.13V10.9862H33.6509L34.21 11.844V10.9862H36.252V15.5669H34.2453L33.7274 14.7675V15.5669H30.8792L30.6085 14.8842H30.0024L29.7317 15.5669H27.9898C27.5425 15.5669 27.0247 15.4794 26.6245 15.1701V15.5669H23.7351L23.1466 14.8083V15.5669H12.5305L12.2598 14.8842H11.6536L11.3829 15.5669H10V29.6473H37.9115V21.2329C37.6408 21.4138 37.2759 21.5305 36.864 21.5305Z\" fill=\"#276EB6\"/>\n<path id=\"Vector_3\" d=\"M36.8644 20.1301H35.1695V20.8595H36.8644C37.5823 20.8595 38.0001 20.4336 38.0001 19.8034C38.0001 19.2199 37.6235 18.8639 36.9762 18.8639H36.1994C36.0287 18.8639 35.8993 18.7472 35.8993 18.5955C35.8993 18.4438 36.017 18.3271 36.1994 18.3271H37.6235L37.953 17.5977H36.2288C35.5109 17.5977 35.093 18.0236 35.093 18.6247C35.093 19.2374 35.4932 19.5933 36.117 19.5933H36.8938C37.0644 19.5933 37.1939 19.71 37.1939 19.8617C37.1645 20.0309 37.035 20.1301 36.8644 20.1301ZM33.8572 20.1301H32.1624V20.8595H33.8572C34.5752 20.8595 34.993 20.4336 34.993 19.8034C34.993 19.2199 34.6164 18.8639 33.9691 18.8639H33.1923C33.0216 18.8639 32.8921 18.7472 32.8921 18.5955C32.8921 18.4438 33.0098 18.3271 33.1923 18.3271H34.6164L34.9459 17.5977H33.2217C32.5037 17.5977 32.0859 18.0236 32.0859 18.6247C32.0859 19.2374 32.4861 19.5933 33.1216 19.5933H33.8984C34.0691 19.5933 34.1986 19.71 34.1986 19.8617C34.1574 20.0309 34.0279 20.1301 33.8572 20.1301ZM31.7858 18.3329V17.6035H29.1082V20.8537H31.7858V20.1243H29.9439V19.57H31.7446V18.8581H29.9439V18.3329H31.7858ZM27.5546 18.3329C27.8136 18.3329 27.943 18.4904 27.943 18.6597C27.943 18.8464 27.8136 18.9864 27.5546 18.9864H26.6484V18.3154H27.5546V18.3329ZM26.6484 19.7158H26.9779L27.9548 20.8712H28.9788L27.9136 19.6867C28.4609 19.57 28.7787 19.1732 28.7787 18.6713C28.7787 18.0411 28.3491 17.6152 27.6429 17.6152H25.8186V20.8654H26.6543L26.6484 19.7158ZM24.6181 18.7064C24.6181 18.9047 24.4887 19.0623 24.2297 19.0623H23.2941V18.3212H24.2297C24.4769 18.3329 24.6181 18.508 24.6181 18.7064ZM22.4584 17.6093V20.8595H23.2941V19.8034H24.2886C25.0065 19.8034 25.4538 19.3307 25.4538 18.7064C25.4538 18.0528 25.0242 17.6093 24.318 17.6093H22.4584ZM21.3403 20.8595H22.3878L21.0637 19.2199L22.3702 17.6093H21.3639L20.5871 18.6072L19.8103 17.6093H18.7628L20.0692 19.249L18.7628 20.8771H19.7867L20.5635 19.8617L21.3403 20.8595ZM18.7039 18.3329V17.6035H16.0264V20.8537H18.7039V20.1243H16.862V19.57H18.6627V18.8581H16.862V18.3329H18.7039Z\" fill=\"#276EB6\"/>\n<path id=\"Vector_4\" d=\"M34.4869 14.9074H35.5109V11.6572H34.6752V13.682L33.3688 11.6572H32.3037V14.9074H33.1393V12.8126L34.4869 14.9074ZM29.7968 13.542L30.2558 12.4275L30.7148 13.542H29.7968ZM31.2797 14.9074H32.2154L30.803 11.6572H29.7261L28.3138 14.9074H29.2318L29.5025 14.2364H30.9972L31.2797 14.9074ZM27.896 14.9074H27.9666L28.3138 14.178H28.0431C27.5135 14.178 27.2074 13.8629 27.2074 13.3086V13.2677C27.2074 12.7834 27.4781 12.4099 28.0254 12.4099H28.9023V11.6514H27.9548C26.9191 11.6514 26.3718 12.3341 26.3718 13.2619V13.3027C26.3718 14.3122 26.9485 14.9074 27.896 14.9074ZM25.136 14.9074H25.9716V13.2794V11.6514H25.136V13.2794V14.9074ZM23.5707 12.3866C23.8296 12.3866 23.9591 12.5442 23.9591 12.7134C23.9591 12.9001 23.8296 13.0402 23.5707 13.0402H22.6644V12.3691H23.5707V12.3866ZM22.6585 13.752H22.9881L23.9649 14.9074H24.9889L23.9237 13.7229C24.471 13.6062 24.7888 13.2094 24.7888 12.7075C24.7888 12.0773 24.3592 11.6514 23.653 11.6514H21.8288V14.9016H22.6644V13.752H22.6585ZM21.3639 12.3866V11.6572H18.6863V14.9074H21.3639V14.1839H19.5219V13.6295H21.3227V12.9176H19.5219V12.3924H21.3639V12.3866ZM15.7145 14.9074H16.4501L17.3151 12.4975V14.9074H18.1331V11.6572H16.8267L16.0911 13.7404L15.3555 11.6572H14.0314V14.9074H14.8494V12.4975L15.7145 14.9074ZM11.5127 13.542L11.9718 12.4275L12.4308 13.542H11.5127ZM12.9957 14.9074H13.9314L12.519 11.6572H11.4421L10.0298 14.9074H10.9478L11.2185 14.2364H12.7132L12.9957 14.9074Z\" fill=\"#276EB6\"/>\n</g>\n</g>\n</svg>";

var BBVAColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=BBVA, Color=On\">\n<g id=\"BBVA\">\n<g id=\"Group\">\n<path id=\"Vector\" d=\"M31.22 4C28.8832 4 26.7877 5.01168 25.3614 6.61233L20.1567 11.6396L25.4395 16.7531C25.6448 16.9765 25.8632 17.1878 26.0926 17.3852L26.0936 17.3862C27.4628 18.5641 29.2558 19.2783 31.219 19.2783C35.5162 19.2783 38.9999 15.8586 38.9999 11.6396C38.9999 7.42066 35.5172 4 31.22 4ZM31.2912 16.1311C28.7319 16.1311 26.6565 14.1198 26.6565 11.6396C26.6565 9.15954 28.7319 7.14821 31.2912 7.14821C33.8504 7.14821 35.9258 9.15954 35.9258 11.6396C35.9258 14.1198 33.8504 16.1311 31.2912 16.1311Z\" fill=\"#2DCCCD\"/>\n<path id=\"Vector_2\" d=\"M21.6603 14.0997L19.7281 12.1815L17.4523 14.4362L19.0009 15.9738C18.6123 16.0759 18.2036 16.131 17.7819 16.131C15.2226 16.131 13.1472 14.1197 13.1472 11.6396C13.1472 9.15948 15.2226 7.14815 17.7819 7.14815C18.2126 7.14815 18.6303 7.20524 19.0259 7.31242C20.1278 7.60991 21.0643 8.29104 21.6723 9.19954L23.92 6.96785C23.2509 6.12545 22.4055 5.42429 21.4379 4.91746C20.3481 4.34651 19.1031 4.02197 17.7809 4.02197C13.4838 4.02197 10 7.44163 10 11.6606C10 15.8796 13.4838 19.2993 17.7809 19.2993C19.1061 19.2993 20.3531 18.9737 21.4449 18.4008C22.4115 17.8929 23.2559 17.1918 23.924 16.3484L21.6603 14.0997Z\" fill=\"#004480\"/>\n</g>\n<g id=\"Group_2\">\n<path id=\"Vector_3\" d=\"M28.7058 23.7847L27.0461 26.943C27.011 27.0101 26.9078 27.0101 26.8728 26.943L25.213 23.7847C25.197 23.7527 25.165 23.7336 25.1299 23.7336H24.3256C24.2705 23.7336 24.2354 23.7917 24.2615 23.8398L26.8758 28.7349C26.9108 28.802 27.008 28.802 27.0461 28.7349L29.6604 23.8398C29.6864 23.7917 29.6504 23.7336 29.5963 23.7336H28.792C28.7539 23.7336 28.7218 23.7527 28.7058 23.7847Z\" fill=\"#004480\"/>\n<path id=\"Vector_4\" d=\"M29.7906 28.0017L31.4504 24.8435C31.4854 24.7764 31.5886 24.7764 31.6237 24.8435L33.2834 28.0017C33.2994 28.0338 33.3315 28.0528 33.3665 28.0528H34.1709C34.226 28.0528 34.261 27.9947 34.235 27.9467L31.6207 23.0516C31.5856 22.9844 31.4884 22.9844 31.4504 23.0516L28.836 27.9467C28.81 27.9947 28.8461 28.0528 28.9002 28.0528H29.7045C29.7385 28.0498 29.7746 28.0298 29.7906 28.0017Z\" fill=\"#004480\"/>\n<path id=\"Vector_5\" d=\"M18.1275 26.0616C18.475 25.8883 18.6904 25.5117 18.6904 25.0519C18.6904 24.2636 18.0764 23.7297 17.2109 23.7297H14.7248C14.6697 23.7297 14.6287 23.7718 14.6287 23.8259V28.6859C14.6287 28.741 14.6707 28.7821 14.7248 28.7821H17.1048C18.2947 28.7821 18.9218 28.2703 18.9218 27.2676C18.9218 26.29 18.1275 26.0616 18.1275 26.0616ZM15.5612 24.463H17.0376C17.5815 24.463 17.858 24.6943 17.858 25.125C17.858 25.5558 17.5815 25.7871 17.0376 25.7871H15.5612C15.5101 25.7871 15.465 25.7451 15.465 25.691V24.5591C15.465 24.505 15.5061 24.463 15.5612 24.463ZM17.0567 28.0499H15.5612C15.5061 28.0499 15.465 28.0078 15.465 27.9537V26.6125C15.465 26.5614 15.5071 26.5164 15.5612 26.5164H17.0567C17.7709 26.5164 18.0894 26.7187 18.0894 27.2816C18.0864 27.8506 17.7769 28.0499 17.0567 28.0499Z\" fill=\"#004480\"/>\n<path id=\"Vector_6\" d=\"M23.3741 26.0616C23.7217 25.8883 23.937 25.5117 23.937 25.0519C23.937 24.2636 23.323 23.7297 22.4576 23.7297H19.9685C19.9134 23.7297 19.8723 23.7718 19.8723 23.8259V28.6859C19.8723 28.741 19.9144 28.7821 19.9685 28.7821H22.3484C23.5384 28.7821 24.1654 28.2703 24.1654 27.2676C24.1684 26.29 23.3741 26.0616 23.3741 26.0616ZM20.8069 24.463H22.2833C22.8272 24.463 23.1037 24.6943 23.1037 25.125C23.1037 25.5558 22.8272 25.7871 22.2833 25.7871H20.8069C20.7518 25.7871 20.7107 25.7451 20.7107 25.691V24.5591C20.7107 24.505 20.7528 24.463 20.8069 24.463ZM22.2993 28.0499H20.8039C20.7528 28.0499 20.7077 28.0078 20.7077 27.9537V26.6125C20.7077 26.5614 20.7498 26.5164 20.8039 26.5164H22.2993C23.0135 26.5164 23.332 26.7187 23.332 27.2816C23.332 27.8506 23.0195 28.0499 22.2993 28.0499Z\" fill=\"#004480\"/>\n</g>\n</g>\n</g>\n</svg>";

var BimoColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Bimo, Color=On\">\n<g id=\"Bimo\">\n<g id=\"XMLID 492\">\n<path id=\"XMLID 501\" d=\"M24.98 15.0874C24.98 15.1638 24.98 19.5783 24.98 19.6602C25.2584 19.864 26.1591 19.864 26.5067 19.6602C26.5067 19.4491 26.5067 15.2839 26.5067 15.0874C26.1591 14.8836 25.2584 14.8836 24.98 15.0874Z\" fill=\"url(#paint0_radial_201_788)\"/>\n<path id=\"XMLID 498\" d=\"M38.3034 14.7852C36.7148 14.7852 35.6067 15.7951 35.6067 17.3254C35.6067 18.8648 36.7148 19.8947 38.3034 19.8947C39.9029 19.8947 41.0001 18.8648 41.0001 17.3254C41.0019 15.7951 39.9029 14.7852 38.3034 14.7852ZM38.3034 18.5318C37.6174 18.5318 37.1261 18.0514 37.1261 17.3254C37.1261 16.6194 37.6174 16.1481 38.3034 16.1481C38.9894 16.1481 39.4807 16.6194 39.4807 17.3254C39.4807 18.0514 38.9912 18.5318 38.3034 18.5318Z\" fill=\"url(#paint1_radial_201_788)\"/>\n<path id=\"XMLID 497\" d=\"M32.8191 14.8215C32.1804 14.8215 31.72 15.0017 31.2833 15.2128C30.9303 14.9726 30.3626 14.8215 29.9222 14.8215C28.643 14.8215 27.9315 15.2546 27.5076 15.6058V16.8049C27.5076 16.8049 27.5076 18.0587 27.5076 18.9066C27.5076 19.3124 27.5076 19.6254 27.5076 19.66C27.786 19.8638 28.6867 19.8638 29.0342 19.66C29.0342 19.3743 29.0342 16.8049 29.0342 16.8049H29.0324V16.4683C29.0324 16.4683 29.3363 16.2863 29.5656 16.2863C30.0769 16.2863 30.3917 16.492 30.4117 17.0979C30.4117 17.8094 30.4117 19.5708 30.4117 19.6581C30.6901 19.8619 31.5908 19.8619 31.9384 19.6581C31.9384 19.3724 31.9384 16.8031 31.9384 16.8031H31.9366C31.9329 16.6776 31.9238 16.6485 31.9075 16.5065C31.9075 16.5065 32.2222 16.2845 32.4606 16.2845C32.9738 16.2845 33.2867 16.4847 33.3159 17.0724C33.3159 17.7675 33.3159 19.569 33.3159 19.6581C33.5943 19.8619 34.495 19.8619 34.8425 19.6581C34.8425 19.5708 34.8425 19.2742 34.8425 18.9048C34.8425 18.0514 34.8425 16.8031 34.8425 16.8031V16.6848C34.8443 15.3802 34.0055 14.8215 32.8191 14.8215Z\" fill=\"url(#paint2_radial_201_788)\"/>\n<path id=\"XMLID 496\" d=\"M25.748 12.5798C25.2385 12.5798 24.8328 12.9583 24.8328 13.486C24.8328 13.9955 25.2404 14.374 25.748 14.374C26.2393 14.374 26.6542 13.9955 26.6542 13.486C26.6542 12.9601 26.2393 12.5798 25.748 12.5798Z\" fill=\"url(#paint3_radial_201_788)\"/>\n<path id=\"XMLID 493\" d=\"M22.3178 14.9853C21.7938 14.9853 21.217 15.1527 20.8603 15.5003V15.4602C20.8603 15.4602 20.8603 13.5897 20.8603 13.304C20.5146 13.1002 19.6139 13.1002 19.3354 13.304C19.3354 13.3367 19.3354 19.6181 19.3354 19.6181C19.9687 19.8456 20.762 19.9547 21.4462 19.9547C23.3459 19.9547 24.1484 19.054 24.1484 17.3909C24.1502 15.846 23.497 14.9853 22.3178 14.9853ZM21.5463 18.8066C21.3789 18.8066 21.0495 18.7865 20.8621 18.7374V16.3519C21.0696 16.2227 21.428 16.1644 21.6555 16.1644C22.2487 16.1644 22.5653 16.6503 22.5653 17.4418C22.5653 18.2807 22.1886 18.8066 21.5463 18.8066Z\" fill=\"url(#paint4_radial_201_788)\"/>\n</g>\n<g id=\"XMLID 486\">\n<path id=\"XMLID 489\" d=\"M16.1146 11.8247C15.8798 11.6537 15.1192 11.6573 14.8263 11.8302C14.8263 11.9103 14.8263 12.1741 14.8281 12.4653C14.8244 13.4497 14.6807 13.9191 14.5933 14.112C14.5497 14.2103 14.4714 14.2995 14.3805 14.3777C13.8964 13.3387 12.8429 12.6145 11.6237 12.6145C10.1516 12.6145 8.92154 13.6644 8.64313 15.0564C8.29194 15.2893 7.74605 15.7461 7.58956 16.4157C7.54589 16.6049 7.49312 16.8087 7.43853 17.0034C7.40032 17.1381 7.30206 17.4765 7.20744 17.8004C7.18924 17.8623 7.1765 17.8987 7.1765 17.9005C7.17105 17.9187 7.16559 17.9387 7.16195 17.9569C7.08734 18.2171 7.02002 18.4446 7 18.5156C7.23291 18.763 7.96259 18.9759 8.23553 18.8777C8.23917 18.8667 8.46299 18.1007 8.46299 18.1007L8.45935 18.097C8.54123 17.8259 8.69408 17.3019 8.81236 16.8197C9.05073 17.3947 9.46197 17.8805 9.98057 18.2135L9.86229 19.6983H9.43286C9.22906 19.6983 9.05801 19.6983 8.99432 19.6983C8.82146 19.9895 8.81782 20.7501 8.98886 20.9866C9.0016 20.9866 10.1116 20.9866 10.1116 20.9866H10.4573C10.7921 20.9866 11.0705 20.7282 11.0978 20.3952L11.2361 18.672C11.3617 18.6884 11.4909 18.6975 11.6219 18.6975C12.0986 18.6975 12.5481 18.5865 12.9502 18.3918L13.5471 20.519C13.6253 20.7956 13.8782 20.9884 14.1657 20.9884H14.5752C14.9336 21.0048 15.3867 21.023 15.394 21.0248C15.5741 20.7974 15.6032 20.035 15.4413 19.7365C15.3758 19.7347 15.1829 19.7256 14.9518 19.7165C14.91 19.7074 14.8681 19.7038 14.8244 19.7038H14.6516L14.0384 17.5002C14.415 17.0071 14.6443 16.3975 14.6625 15.7333C15.0264 15.5386 15.5214 15.1874 15.767 14.6397C15.9981 14.1266 16.1146 13.3842 16.1146 12.4343C16.1146 12.4343 16.1146 11.8357 16.1146 11.8247ZM9.86957 15.6551C9.86957 14.6889 10.6557 13.901 11.6237 13.901C12.5917 13.901 13.3778 14.687 13.3778 15.6551C13.3778 16.6231 12.5899 17.4092 11.6237 17.4092C10.6575 17.4092 9.86957 16.6231 9.86957 15.6551Z\" fill=\"#FCC454\"/>\n<path id=\"XMLID 488\" d=\"M10.9832 11.1296C10.9832 11.1915 10.9832 15.1092 10.9832 15.1765C11.2179 15.3494 11.9803 15.3494 12.2733 15.1765C12.2733 15.0018 12.2733 11.2861 12.2733 11.1296C11.9785 10.9568 11.2179 10.9568 10.9832 11.1296Z\" fill=\"url(#paint5_radial_201_788)\"/>\n</g>\n</g>\n</g>\n<defs>\n<radialGradient id=\"paint0_radial_201_788\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(25.7436 17.3738) scale(1.80764)\">\n<stop offset=\"0.1744\" stop-color=\"#623F91\"/>\n<stop offset=\"0.8\" stop-color=\"#4B2784\"/>\n</radialGradient>\n<radialGradient id=\"paint1_radial_201_788\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(38.3039 17.3407) scale(2.62723)\">\n<stop offset=\"0.1744\" stop-color=\"#623F91\"/>\n<stop offset=\"0.8\" stop-color=\"#4B2784\"/>\n</radialGradient>\n<radialGradient id=\"paint2_radial_201_788\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(31.1761 17.3172) scale(3.13695)\">\n<stop offset=\"0.1744\" stop-color=\"#623F91\"/>\n<stop offset=\"0.8\" stop-color=\"#4B2784\"/>\n</radialGradient>\n<radialGradient id=\"paint3_radial_201_788\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(25.7437 13.4781) scale(0.904522)\">\n<stop offset=\"0.1744\" stop-color=\"#623F91\"/>\n<stop offset=\"0.8\" stop-color=\"#4B2784\"/>\n</radialGradient>\n<radialGradient id=\"paint4_radial_201_788\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(21.743 16.5529) scale(2.94617)\">\n<stop offset=\"0.1744\" stop-color=\"#623F91\"/>\n<stop offset=\"0.8\" stop-color=\"#4B2784\"/>\n</radialGradient>\n<radialGradient id=\"paint5_radial_201_788\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(11.6276 13.1527) scale(1.58922)\">\n<stop offset=\"0.1744\" stop-color=\"#623F91\"/>\n<stop offset=\"0.8\" stop-color=\"#4B2784\"/>\n</radialGradient>\n</defs>\n</svg>";

var BNAColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=BNA+, Color=On\">\n<g id=\"BNA+\">\n<g id=\"Group\">\n<path id=\"Vector\" d=\"M7 20.9662V19.9124L8.11463 19.7069V12.2666L7 12.0612V11.0005H8.11463H11.1358C12.193 11.0005 13.0183 11.2274 13.6116 11.6819C14.2048 12.1357 14.5019 12.8145 14.5019 13.7186C14.5019 14.1706 14.3786 14.5755 14.1329 14.9334C13.8872 15.2921 13.5457 15.5575 13.1099 15.7312C13.49 15.8177 13.8093 15.9752 14.0679 16.2038C14.3264 16.4324 14.5242 16.7089 14.6603 17.0359C14.7964 17.3621 14.864 17.7191 14.864 18.1069C14.864 19.0426 14.5738 19.7531 13.9934 20.2394C13.413 20.7257 12.6048 20.9688 11.5689 20.9688H7V20.9662ZM9.74633 15.203H11.3181C11.8018 15.203 12.181 15.0798 12.4576 14.8332C12.7341 14.5866 12.8719 14.2425 12.8719 13.7999C12.8719 13.3025 12.7255 12.9335 12.4319 12.6947C12.1382 12.455 11.7068 12.3351 11.1375 12.3351H9.74719V15.203H9.74633ZM9.74633 19.6384H11.5707C12.1057 19.6384 12.5166 19.5074 12.8034 19.2446C13.0902 18.9827 13.234 18.6026 13.234 18.1052C13.234 17.7542 13.1801 17.4545 13.0722 17.2088C12.9644 16.9623 12.8 16.7731 12.58 16.6404C12.36 16.5077 12.0775 16.4418 11.7316 16.4418H9.74548V19.6384H9.74633Z\" fill=\"#23B0DE\"/>\n</g>\n<g id=\"Group_2\">\n<path id=\"Vector_2\" d=\"M15.6028 20.9665V19.9126L16.7268 19.7072V12.2669L15.6028 12.0614V11.0007H16.7268H18.3585L23.5105 18.2775L23.5533 18.2638V12.2677L22.3376 12.0623V11.0016H24.9872H26.1113V12.0623L24.9872 12.2677V20.9682H23.5541L18.2892 13.4577L18.2464 13.4646V19.7089L19.462 19.9143V20.9682H15.6028V20.9665Z\" fill=\"#23B0DE\"/>\n</g>\n<g id=\"Group_3\">\n<path id=\"Vector_3\" d=\"M25.9402 20.9666V19.9127L26.7646 19.81L30.1256 11H31.8344L35.1534 19.81L36.0626 19.9127V20.9666H32.5792V19.9127L33.389 19.7826L32.8522 18.2151H29.0726L28.5213 19.7826L29.2532 19.9127V20.9666H25.9402V20.9666ZM29.5332 16.8942H32.3994L31.081 13.2044L30.9903 12.9373H30.9483L30.8507 13.2181L29.5332 16.8942Z\" fill=\"#23B0DE\"/>\n</g>\n<path id=\"Vector_4\" d=\"M38.7456 11H37.2671V16.9883H38.7456V11Z\" fill=\"#F39555\"/>\n<path id=\"Vector_5\" d=\"M35.0117 13.2557V14.7341H41.0001V13.2557H35.0117Z\" fill=\"#F39555\"/>\n</g>\n</g>\n</svg>";

var BrubankColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Brubank, Color=On\">\n<g id=\"Brubank\">\n<g id=\"Desktop HD Copy 2\">\n<g id=\"logo violeta copy\">\n<g id=\"Group 3\">\n<mask id=\"mask0_201_800\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"7\" y=\"12\" width=\"5\" height=\"8\">\n<g id=\"mask 2\">\n<path id=\"Vector\" d=\"M7 12H11.8221V19.0054H7V12Z\" fill=\"white\"/>\n</g>\n</mask>\n<g mask=\"url(#mask0_201_800)\">\n<path id=\"Fill 1\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.40891 17.6309C8.80541 17.6309 8.3146 17.1183 8.3146 16.4883C8.3146 15.8582 8.80541 15.3456 9.40891 15.3456C10.0124 15.3456 10.5032 15.8582 10.5032 16.4883C10.5032 17.1183 10.0124 17.6309 9.40891 17.6309ZM9.41117 13.9711C9.04961 13.9711 8.70192 14.0527 8.37773 14.2135L8.31658 14.2438V12.6873C8.31658 12.3083 8.02127 12 7.65843 12C7.29531 12 7 12.3083 7 12.6873V16.4906C7.00113 17.8773 8.08285 19.0054 9.41117 19.0054C10.7405 19.0054 11.8221 17.8762 11.8221 16.4883C11.8221 15.1003 10.7405 13.9711 9.41117 13.9711Z\" fill=\"#614AD9\"/>\n</g>\n</g>\n<g id=\"Group 6\">\n<mask id=\"mask1_201_800\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"20\" y=\"12\" width=\"6\" height=\"8\">\n<g id=\"mask 4\">\n<path id=\"Vector_2\" d=\"M20.9834 12H25.8055V19.0054H20.9834V12Z\" fill=\"white\"/>\n</g>\n</mask>\n<g mask=\"url(#mask1_201_800)\">\n<path id=\"Fill 4\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23.3923 17.6309C22.7888 17.6309 22.298 17.1183 22.298 16.4883C22.298 15.8582 22.7888 15.3456 23.3923 15.3456C23.9958 15.3456 24.4866 15.8582 24.4866 16.4883C24.4866 17.1183 23.9958 17.6309 23.3923 17.6309ZM23.3946 13.9711C23.033 13.9711 22.6853 14.0527 22.3611 14.2135L22.3 14.2438V12.6873C22.3 12.3083 22.0047 12 21.6418 12C21.2787 12 20.9834 12.3083 20.9834 12.6873V16.4906C20.9845 17.8773 22.0662 19.0054 23.3946 19.0054C24.7239 19.0054 25.8055 17.8762 25.8055 16.4883C25.8055 15.1003 24.7239 13.9711 23.3946 13.9711Z\" fill=\"#614AD9\"/>\n</g>\n</g>\n<path id=\"Fill 7\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.6775 13.9712C19.3147 13.9712 19.0194 14.2795 19.0194 14.6585V16.5994H19.0212C19.0212 17.2009 18.5795 17.6903 18.0365 17.6903C17.4935 17.6903 17.0519 17.2009 17.0519 16.5994H17.0536V14.6585C17.0536 14.2795 16.7583 13.9712 16.3955 13.9712C16.0324 13.9712 15.7371 14.2795 15.7371 14.6585V16.6017C15.7381 17.9246 16.7695 19.001 18.0365 19.0022C19.3035 19.001 20.3349 17.9246 20.336 16.6017H20.336V14.6585C20.336 14.2795 20.0407 13.9712 19.6775 13.9712Z\" fill=\"#614AD9\"/>\n<path id=\"Fill 13\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M33.8297 13.9712C32.5628 13.9724 31.5314 15.0488 31.5303 16.3717H31.5303V18.315C31.5303 18.6939 31.8256 19.0022 32.1887 19.0022C32.5515 19.0022 32.8469 18.6939 32.8469 18.315V16.374H32.8451C32.8451 15.7725 33.2867 15.2831 33.8297 15.2831C34.3728 15.2831 34.8144 15.7725 34.8144 16.374H34.8126V18.315C34.8126 18.6939 35.1079 19.0022 35.4707 19.0022C35.8339 19.0022 36.1292 18.6939 36.1292 18.315V16.3717C36.1281 15.0488 35.0967 13.9724 33.8297 13.9712Z\" fill=\"#614AD9\"/>\n<g id=\"Group 17\">\n<mask id=\"mask2_201_800\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"26\" y=\"13\" width=\"5\" height=\"7\">\n<g id=\"mask 6\">\n<path id=\"Vector_3\" d=\"M26.1538 13.9712H30.9759V19.0149H26.1538V13.9712Z\" fill=\"white\"/>\n</g>\n</mask>\n<g mask=\"url(#mask2_201_800)\">\n<path id=\"Fill 15\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M28.549 17.631C27.9455 17.631 27.4547 17.1184 27.4547 16.4883C27.4547 15.8583 27.9455 15.3457 28.549 15.3457C29.1525 15.3457 29.6433 15.8583 29.6433 16.4883C29.6433 17.1184 29.1525 17.631 28.549 17.631ZM28.5647 13.9712C27.2354 13.9712 26.1538 15.1004 26.1538 16.4883C26.1538 17.818 27.1463 18.9101 28.3984 18.9996C28.9305 19.0396 29.4667 18.7772 29.7665 18.2716L29.7673 18.3906C29.7687 18.569 29.8248 18.7188 29.9342 18.8359C30.0449 18.9547 30.192 19.0149 30.3717 19.0149C30.5451 19.0149 30.6909 18.9547 30.8046 18.836C30.9183 18.7173 30.9759 18.5653 30.9759 18.3841V16.486C30.9747 15.0993 29.893 13.9712 28.5647 13.9712Z\" fill=\"#614AD9\"/>\n</g>\n</g>\n<g id=\"Group 20\">\n<mask id=\"mask3_201_800\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"36\" y=\"12\" width=\"5\" height=\"8\">\n<g id=\"mask 8\">\n<path id=\"Vector_4\" d=\"M36.7292 12.002H40.9999V19.0042H36.7292V12.002Z\" fill=\"white\"/>\n</g>\n</mask>\n<g mask=\"url(#mask3_201_800)\">\n<path id=\"Fill 18\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M40.8354 17.9472L39.3873 16.371L40.7327 15.0232C40.9684 14.7871 40.9762 14.3947 40.7499 14.1485C40.5238 13.9025 40.148 13.8944 39.9123 14.1306L38.0458 16.0004L38.0458 12.6892C38.0458 12.3103 37.7505 12.002 37.3874 12.002C37.0246 12.002 36.7293 12.3103 36.7293 12.6892L36.7292 18.317C36.7292 18.6959 37.0246 19.0042 37.3877 19.0042C37.7505 19.0042 38.0458 18.6959 38.0458 18.317V16.698L39.9802 18.8035C40.2063 19.0497 40.5821 19.0578 40.8178 18.8218C41.0536 18.5857 41.0615 18.1933 40.8354 17.9472Z\" fill=\"#614AD9\"/>\n</g>\n</g>\n<path id=\"Fill 21\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.0366 13.9948C14.44 13.9075 13.8696 14.2055 13.5658 14.7121V14.6585C13.5658 14.2795 13.2705 13.9712 12.9077 13.9712C12.5446 13.9712 12.2493 14.2795 12.2493 14.6585V16.3368V16.6017V18.2801C12.2493 18.659 12.5446 18.9674 12.9077 18.9674C13.2705 18.9674 13.5658 18.659 13.5658 18.2801V16.5994V16.3392V16.2745C13.5961 15.703 14.0253 15.2482 14.5487 15.2482C14.6231 15.2482 14.6956 15.2574 14.7654 15.2748C15.1015 15.3667 15.4453 15.1566 15.5333 14.8057C15.5485 14.745 15.5551 14.6841 15.5538 14.6243C15.5538 14.3056 15.3294 14.0415 15.0366 13.9948Z\" fill=\"#614AD9\"/>\n</g>\n</g>\n</g>\n</g>\n</svg>";

var CabalColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Cabal, Color=On\">\n<g id=\"cabal\">\n<path id=\"Vector\" d=\"M7 21.4832H38.748C39.9925 21.4832 41 20.4757 41 19.2312V10H7V21.4832Z\" fill=\"#02558E\"/>\n<path id=\"Vector_2\" d=\"M25.0265 16.3691L24.3258 14.1729L23.6425 16.3761H25.03V16.3691H25.0265ZM24.9846 13.4478L26.5604 18.1017H25.5703L25.2566 17.1361H23.4089L23.0882 18.1017H22.0981L23.5519 13.8033C23.6251 13.5872 23.8238 13.4478 24.0469 13.4478C24.0434 13.4478 24.9846 13.4478 24.9846 13.4478Z\" fill=\"white\"/>\n<path id=\"Vector_3\" d=\"M29.4815 16.913C29.4815 17.2511 29.3002 17.3662 28.8714 17.3662H27.9057V16.0972H28.9551C29.3246 16.0972 29.4815 16.2541 29.4815 16.5679V16.913V16.913ZM27.9057 14.1729H28.8121C29.1573 14.1729 29.3072 14.2879 29.3072 14.5529V14.9643C29.3072 15.2362 29.1747 15.393 28.8052 15.393H27.9057V14.1729ZM29.6941 15.6754C30.0741 15.5185 30.2484 15.3059 30.2484 14.9259V14.4483C30.2484 13.8208 29.8684 13.4583 28.9202 13.4583H26.9575V18.1122H29.0527C29.9591 18.1122 30.4122 17.7008 30.4122 17.0489V16.5539C30.4192 16.0798 30.1473 15.7661 29.6941 15.6754Z\" fill=\"white\"/>\n<path id=\"Vector_4\" d=\"M20.3724 14.0997H21.7251V13.7615C21.7251 13.507 21.5194 13.2979 21.2614 13.2979H20.362C19.1488 13.3048 18.6294 13.7999 18.6294 14.6435V16.7386C18.6294 17.5788 19.1488 18.0738 20.362 18.0843H21.6658V17.7461C21.6658 17.4916 21.4601 17.2825 21.2021 17.2825H20.362C19.7694 17.265 19.5706 17.0594 19.5706 16.5818V14.7899C19.5811 14.3297 19.7763 14.1171 20.3724 14.0997Z\" fill=\"white\"/>\n<path id=\"Vector_5\" d=\"M36.3773 17.3243V14.1729V13.3711H35.9555C35.6661 13.3711 35.436 13.6012 35.436 13.8905V14.1694V18.0878H38.4306V17.3139H36.3773V17.3243V17.3243Z\" fill=\"white\"/>\n<path id=\"Vector_6\" d=\"M33.5638 16.3691L32.8631 14.1729L32.1798 16.3761H33.5673V16.3691H33.5638ZM33.522 13.4478L35.0977 18.1017H34.1077L33.7939 17.1361H31.9463L31.6255 18.1017H30.6355L32.0474 13.9358C32.145 13.6465 32.4169 13.4478 32.7237 13.4478C32.7237 13.4478 33.522 13.4478 33.522 13.4478Z\" fill=\"white\"/>\n<path id=\"Vector_7\" d=\"M13.5081 12.0115L16.9558 15.4035C17.1441 15.5917 17.1441 15.9055 16.9558 16.0867L13.5081 19.4787V17.5823L15.1256 15.9821C15.2581 15.8497 15.2581 15.637 15.1256 15.5046L13.5081 13.9044V12.0115Z\" fill=\"white\"/>\n<path id=\"Vector_8\" d=\"M12.8739 12.0115L9.4261 15.4035C9.23785 15.5917 9.23785 15.9055 9.4261 16.0867L12.8739 19.4787V17.5823L11.2563 15.9821C11.1238 15.8497 11.1238 15.637 11.2563 15.5046L12.8739 13.9044V12.0115Z\" fill=\"white\"/>\n</g>\n</g>\n</svg>";

var CabalDebitoColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Cabal_Debito, Color=On\">\n<g id=\"Cabal_Debito\">\n<path id=\"Vector\" d=\"M26.0298 21.6709C26.573 21.6709 26.7613 21.9461 26.7613 22.2684V23.2932C26.7613 23.6047 26.573 23.8907 26.0298 23.8907H25.2114V21.6818H26.0298V21.6709ZM25.6279 23.5141H25.9828C26.2688 23.5141 26.3376 23.3982 26.3376 23.1954V22.377C26.3376 22.1634 26.258 22.0584 25.9828 22.0584H25.6279V23.5141Z\" fill=\"#01578E\"/>\n<path id=\"Vector_2\" d=\"M27.2102 21.6708H28.5646V22.0366H27.6303V22.5689H28.4921V22.9346H27.6303V23.5032H28.5646V23.8689H27.2102V21.6708ZM27.6665 21.3087C27.8258 21.2109 27.9707 21.1132 28.101 21.0154L28.2531 21.2616C28.101 21.3666 27.9852 21.4391 27.8077 21.5368L27.6665 21.3087Z\" fill=\"#01578E\"/>\n<path id=\"Vector_3\" d=\"M28.9919 23.8799V21.6709H29.8647C30.2847 21.6709 30.4513 21.8411 30.4513 22.1417V22.3734C30.4513 22.5509 30.3716 22.6595 30.2123 22.7283C30.4187 22.7718 30.531 22.9239 30.531 23.1375V23.3693C30.531 23.6807 30.3246 23.8762 29.9262 23.8762L28.9919 23.8799ZM30.024 22.196C30.024 22.0729 29.9624 22.0185 29.8031 22.0185H29.4011V22.5979H29.8031C29.9624 22.5979 30.024 22.5183 30.024 22.3915V22.196ZM30.1037 23.1484C30.1037 22.9963 30.0421 22.9275 29.8719 22.9275H29.4084V23.5322H29.8357C30.024 23.5322 30.1037 23.4779 30.1037 23.3186V23.1484Z\" fill=\"#01578E\"/>\n<path id=\"Vector_4\" d=\"M31.3349 21.6709H30.9148V23.8799H31.3349V21.6709Z\" fill=\"#01578E\"/>\n<path id=\"Vector_5\" d=\"M32.2946 22.0366H31.679V21.6709H33.3266V22.0366H32.711V23.8799H32.2946V22.0366Z\" fill=\"#01578E\"/>\n<path id=\"Vector_6\" d=\"M35.2204 23.2315C35.2204 23.5972 35.0067 23.9087 34.3839 23.9087C33.761 23.9087 33.5474 23.5972 33.5474 23.2315V22.3117C33.5474 21.946 33.761 21.6345 34.3839 21.6345C35.0067 21.6345 35.2204 21.946 35.2204 22.3117V23.2315ZM33.9674 23.2134C33.9674 23.4198 34.0724 23.5502 34.3875 23.5502C34.6989 23.5502 34.8076 23.427 34.8076 23.2134V22.3479C34.8076 22.1415 34.7025 22.0111 34.3875 22.0111C34.0761 22.0111 33.9674 22.1343 33.9674 22.3479V23.2134Z\" fill=\"#01578E\"/>\n<path id=\"Vector_7\" d=\"M7 20.4903H38.7476C39.9933 20.4903 41 19.4835 41 18.2378V9H7V20.4903Z\" fill=\"#01578E\"/>\n<path id=\"Vector_8\" d=\"M25.0229 15.3699L24.3204 13.1718L23.636 15.3699H25.0229ZM24.9794 12.4512L26.5547 17.1081H25.5661L25.2547 16.1485H23.4042L23.0855 17.1081H22.0969L23.549 12.8097C23.6215 12.596 23.817 12.4548 24.0488 12.4548H24.9794V12.4512Z\" fill=\"white\"/>\n<path id=\"Vector_9\" d=\"M29.4734 15.924C29.4734 16.2607 29.296 16.3766 28.8687 16.3766H27.8982V15.1056H28.9484C29.3213 15.1056 29.4734 15.2576 29.4734 15.5763V15.924ZM27.8982 13.1718H28.8071C29.1548 13.1718 29.3069 13.2877 29.3069 13.5448V13.954C29.3069 14.2292 29.1729 14.3885 28.8071 14.3885H27.9091V13.1682H27.8982V13.1718ZM29.6871 14.6782C30.0709 14.5262 30.2375 14.3053 30.2375 13.9214V13.4398C30.2375 12.8097 29.8537 12.4512 28.9121 12.4512H26.9458V17.1045H29.0461C29.9551 17.1045 30.4077 16.6953 30.4077 16.0362V15.5401C30.415 15.0874 30.147 14.7652 29.6871 14.6782Z\" fill=\"white\"/>\n<path id=\"Vector_10\" d=\"M20.3659 13.1028H21.7203V12.766C21.7203 12.5089 21.5139 12.3025 21.2568 12.3025H20.3587C19.1564 12.3206 18.6313 12.8095 18.6313 13.6568V15.7499C18.6313 16.5937 19.1492 17.0862 20.3659 17.0934H21.6732V16.7566C21.6732 16.4995 21.4668 16.2931 21.2097 16.2931H20.3659C19.7793 16.275 19.5729 16.0722 19.5729 15.5906V13.8089C19.5837 13.3345 19.7793 13.1209 20.3659 13.1028Z\" fill=\"white\"/>\n<path id=\"Vector_11\" d=\"M36.3685 16.3222V13.179V12.3787H35.9484C35.6551 12.3787 35.4233 12.6104 35.4233 12.9037V13.179V17.1044H38.4218V16.3222H36.3685Z\" fill=\"white\"/>\n<path id=\"Vector_12\" d=\"M33.5583 15.3699L32.8631 13.1718L32.1786 15.3699H33.5583ZM33.5221 12.4512L35.0974 17.1045H34.1088L33.7973 16.1449H31.9469L31.6246 17.1081H30.636L32.041 12.9437C32.1388 12.6503 32.414 12.4548 32.7182 12.4548H33.5221V12.4512Z\" fill=\"white\"/>\n<path id=\"Vector_13\" d=\"M13.5073 11.0098L16.9511 14.3993C17.1467 14.5876 17.1467 14.899 16.9511 15.0837L13.5073 18.4659V16.572L15.126 14.9714C15.26 14.8374 15.26 14.6238 15.126 14.4898L13.5073 12.8892V11.0098Z\" fill=\"white\"/>\n<path id=\"Vector_14\" d=\"M12.8664 11.0098L9.42254 14.3993C9.22699 14.5876 9.22699 14.899 9.42254 15.0837L12.8664 18.4659V16.572L11.2477 14.9714C11.1137 14.8374 11.1137 14.6238 11.2477 14.4898L12.8664 12.8892V11.0098Z\" fill=\"white\"/>\n</g>\n</g>\n</svg>";

var CuentaDNIColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Cuenta_DNI, Color=On\">\n<g id=\"Cuenta DNI\">\n<path id=\"Vector\" d=\"M11.7007 21.4806H11.4539C9.60878 21.4806 7.98061 20.3325 7.30595 18.5544C7.21799 18.3237 7.32794 18.062 7.55182 17.972C7.77471 17.881 8.02758 17.9948 8.11454 18.2265C8.65726 19.657 9.9686 20.5818 11.4539 20.5818H11.7007C11.9406 20.5818 12.1355 20.7835 12.1355 21.0317C12.1355 21.28 11.9406 21.4806 11.7007 21.4806Z\" fill=\"#A2C61F\"/>\n<path id=\"Vector_2\" d=\"M17.5886 13.548C17.3487 13.548 17.1538 13.3463 17.1538 13.098V11.0531C17.1538 10.9724 17.0869 10.9072 17.0039 10.9072H15.0129C14.773 10.9072 14.5781 10.7055 14.5781 10.4573C14.5781 10.209 14.773 10.0073 15.0129 10.0073H17.0039C17.5656 10.0073 18.0224 10.4759 18.0224 11.052V13.097C18.0234 13.3473 17.8285 13.548 17.5886 13.548Z\" fill=\"#575756\"/>\n<path id=\"Vector_3\" d=\"M7.43478 13.5462C7.1949 13.5462 7 13.3445 7 13.0963V11.0513C7 10.4752 7.45677 10.0066 8.01849 10.0066H10.0095C10.2494 10.0066 10.4443 10.2083 10.4443 10.4565C10.4443 10.7048 10.2494 10.9065 10.0095 10.9065H8.01849C7.93553 10.9065 7.86856 10.9717 7.86856 11.0523V13.0973C7.86956 13.3455 7.67466 13.5462 7.43478 13.5462Z\" fill=\"#575756\"/>\n<path id=\"Vector_4\" d=\"M17.0039 21.4806H15.0129C14.773 21.4806 14.5781 21.2789 14.5781 21.0306C14.5781 20.7824 14.773 20.5807 15.0129 20.5807H17.0039C17.0869 20.5807 17.1538 20.5155 17.1538 20.4348V18.3899C17.1538 18.1416 17.3487 17.9399 17.5886 17.9399C17.8285 17.9399 18.0234 18.1416 18.0234 18.3899V20.4348C18.0234 21.012 17.5656 21.4806 17.0039 21.4806Z\" fill=\"#575756\"/>\n<path id=\"Vector_5\" d=\"M20.4575 12.6739C20.4575 11.8815 20.4945 11.6147 20.5974 11.2723C20.8623 10.4272 21.51 10 22.3855 10C23.1362 10 23.6879 10.3579 23.9388 10.8223C23.9977 10.9289 24.0347 11.0354 24.0347 11.1575C24.0347 11.4543 23.8138 11.6602 23.542 11.6602C23.3581 11.6602 23.2111 11.5836 23.0632 11.3705C22.8793 11.112 22.7024 10.9899 22.3855 10.9899C21.9808 10.9899 21.7449 11.2113 21.6349 11.5609C21.576 11.7512 21.554 11.9343 21.554 12.6728C21.554 13.4114 21.576 13.5944 21.6349 13.7848C21.7449 14.1354 21.9808 14.3557 22.3855 14.3557C22.7024 14.3557 22.8783 14.2337 23.0632 13.9751C23.2101 13.762 23.3581 13.6855 23.542 13.6855C23.8138 13.6855 24.0347 13.8913 24.0347 14.1882C24.0347 14.3102 23.9977 14.4168 23.9388 14.5233C23.6889 14.9877 23.1362 15.3456 22.3855 15.3456C21.51 15.3456 20.8623 14.9195 20.5974 14.0734C20.4945 13.732 20.4575 13.4662 20.4575 12.6739Z\" fill=\"#373E45\"/>\n<path id=\"Vector_6\" d=\"M26.6192 14.9206H26.6122C26.4353 15.1565 26.1265 15.3468 25.6697 15.3468C24.8821 15.3468 24.4773 14.7758 24.4773 13.9752V12.0947C24.4773 11.7441 24.6982 11.531 25 11.531C25.2949 11.531 25.5078 11.7441 25.5078 12.0947V13.7704C25.5078 14.1738 25.6847 14.4407 26.0525 14.4407C26.4133 14.4407 26.5972 14.1738 26.5972 13.7704V12.0947C26.5972 11.7441 26.8111 11.531 27.112 11.531C27.4068 11.531 27.6267 11.7441 27.6267 12.0947V14.7458C27.6267 15.0965 27.4138 15.3096 27.112 15.3096C26.8691 15.3096 26.6782 15.1648 26.6192 14.9206Z\" fill=\"#373E45\"/>\n<path id=\"Vector_7\" d=\"M28.2019 14.2958C28.128 14.0672 28.084 13.8004 28.084 13.4197C28.084 13.0308 28.121 12.765 28.1939 12.5364C28.4078 11.8661 28.9745 11.4927 29.7321 11.4927C30.5198 11.4927 31.0645 11.8733 31.2704 12.5291C31.3513 12.7877 31.3883 13.0473 31.3883 13.3897C31.3883 13.5956 31.2634 13.7404 31.0495 13.7404H29.1574C29.1285 13.7404 29.1135 13.7559 29.1135 13.7859C29.1135 13.8624 29.1285 13.9307 29.1504 13.999C29.2464 14.3113 29.5183 14.4789 29.8861 14.4789C30.1289 14.4789 30.3648 14.3951 30.5557 14.2886C30.6807 14.212 30.8056 14.1748 30.9086 14.1748C31.1224 14.1748 31.2844 14.3424 31.2844 14.571C31.2844 14.7313 31.2104 14.8606 31.0785 14.9516C30.7396 15.1957 30.3428 15.3478 29.7901 15.3478C28.9675 15.3468 28.4078 14.9589 28.2019 14.2958ZM30.3288 13.0318C30.3578 13.0318 30.3728 13.0163 30.3728 12.9863C30.3728 12.8643 30.3578 12.7877 30.3358 12.7122C30.2549 12.4536 30.034 12.3088 29.7401 12.3088C29.4453 12.3088 29.2324 12.4536 29.1514 12.7122C29.1295 12.7887 29.1145 12.8643 29.1145 12.9863C29.1145 13.0163 29.1295 13.0318 29.1584 13.0318H30.3288Z\" fill=\"#373E45\"/>\n<path id=\"Vector_8\" d=\"M33.9869 14.7457V13.07C33.9869 12.6666 33.795 12.3998 33.4272 12.3998C33.0593 12.3998 32.8754 12.6666 32.8754 13.07V14.7457C32.8754 15.0964 32.6545 15.3095 32.3607 15.3095C32.0588 15.3095 31.8459 15.0964 31.8459 14.7457V12.0946C31.8459 11.744 32.0598 11.5309 32.3607 11.5309C32.6036 11.5309 32.7945 11.6757 32.8534 11.9198H32.8604C33.0373 11.684 33.3462 11.4937 33.803 11.4937C34.5906 11.4937 35.0174 12.0646 35.0174 12.8642V14.7457C35.0174 15.0964 34.8035 15.3095 34.5026 15.3095C34.2078 15.3095 33.9869 15.0953 33.9869 14.7457Z\" fill=\"#373E45\"/>\n<path id=\"Vector_9\" d=\"M36.8339 15.3094C35.9943 15.3094 35.6934 14.9132 35.6934 14.0754V12.4152C35.6934 12.3852 35.6714 12.3697 35.6415 12.3697H35.6125C35.3476 12.3697 35.2007 12.2094 35.2007 11.9735C35.2007 11.7377 35.3476 11.5774 35.6125 11.5774H35.6415C35.6704 11.5774 35.6934 11.5619 35.6934 11.5319V10.9837C35.6934 10.633 35.9073 10.4199 36.2092 10.4199C36.504 10.4199 36.7169 10.633 36.7169 10.9837V11.5319C36.7169 11.5619 36.7319 11.5774 36.7609 11.5774H37.0407C37.3056 11.5774 37.4525 11.7377 37.4525 11.9735C37.4525 12.2094 37.3056 12.3697 37.0407 12.3697H36.7609C36.7319 12.3697 36.7169 12.3852 36.7169 12.4152V14.0454C36.7169 14.2668 36.7979 14.3578 36.9888 14.3805C37.3126 14.4188 37.4455 14.6246 37.4455 14.8532C37.4455 15.1118 37.2686 15.3104 36.8788 15.3104H36.8339V15.3094Z\" fill=\"#373E45\"/>\n<path id=\"Vector_10\" d=\"M41 14.8139C41 15.0953 40.7721 15.3094 40.4852 15.3094C40.3083 15.3094 40.1614 15.2411 40.0654 15.1036L39.9775 14.9743H39.9705C39.7866 15.2101 39.4038 15.3477 38.962 15.3477C38.0494 15.3477 37.6077 14.9215 37.6077 14.2202C37.6077 13.4051 38.1964 13.0317 39.0799 13.0317H39.7206C39.7506 13.0317 39.7646 13.0162 39.7646 12.9862V12.9479C39.7646 12.6055 39.5287 12.3997 39.036 12.3997C38.8151 12.3997 38.5942 12.4535 38.4622 12.5062C38.3743 12.5362 38.2933 12.56 38.2194 12.56C37.9765 12.56 37.8076 12.3925 37.8076 12.1339C37.8076 11.9735 37.8815 11.806 38.0724 11.7077C38.3083 11.5857 38.6681 11.4946 39.1619 11.4946C40.2364 11.4946 40.7521 12.0584 40.7521 12.98V13.9854C40.7521 14.1602 40.7671 14.244 40.8181 14.3361L40.914 14.5036C40.971 14.6009 41 14.7074 41 14.8139ZM39.7636 14.0371V13.7858C39.7636 13.7558 39.7486 13.7403 39.7196 13.7403H39.2189C38.7841 13.7403 38.5862 13.8778 38.5862 14.1592C38.5862 14.4178 38.7631 14.5481 39.1009 14.5481C39.5357 14.5471 39.7636 14.3795 39.7636 14.0371Z\" fill=\"#373E45\"/>\n<path id=\"Vector_11\" d=\"M20.4429 16.7481C20.4429 16.4513 20.6198 16.2527 20.9136 16.2527H22.099C23.1665 16.2527 23.8282 16.6033 24.094 17.4484C24.19 17.7453 24.241 18.1032 24.241 18.8428C24.241 19.5813 24.189 19.9392 24.094 20.2371C23.8292 21.0822 23.1665 21.4328 22.099 21.4328H20.9136C20.6188 21.4328 20.4429 21.2425 20.4429 20.9456V16.7481ZM21.5693 20.4347H22.07C22.5708 20.4347 22.9316 20.2598 23.0566 19.8482C23.1085 19.6734 23.1445 19.3682 23.1445 18.8428C23.1445 18.3173 23.1075 18.0122 23.0566 17.8373C22.9316 17.4257 22.5708 17.2509 22.07 17.2509H21.5693C21.5403 17.2509 21.5253 17.2664 21.5253 17.2964V20.3891C21.5243 20.4191 21.5393 20.4347 21.5693 20.4347Z\" fill=\"#A2C61F\"/>\n<path id=\"Vector_12\" d=\"M24.7703 16.8775C24.7703 16.4659 25.0062 16.2073 25.374 16.2073C25.6828 16.2073 25.8887 16.3976 26.0876 16.7555L27.6189 19.5814H27.6478V16.7483C27.6478 16.4059 27.8467 16.2073 28.1406 16.2073C28.4344 16.2073 28.6333 16.4048 28.6333 16.7483V20.8082C28.6333 21.2198 28.3975 21.4784 28.0296 21.4784C27.7208 21.4784 27.5149 21.2881 27.316 20.9302L25.7848 18.1116H25.7558V20.9375C25.7558 21.2798 25.5569 21.4784 25.262 21.4784C24.9682 21.4784 24.7693 21.2809 24.7693 20.9375V16.8775H24.7703Z\" fill=\"#A2C61F\"/>\n<path id=\"Vector_13\" d=\"M29.3958 16.801C29.3958 16.4431 29.6236 16.2073 29.9405 16.2073C30.2493 16.2073 30.4782 16.4431 30.4782 16.801V20.8837C30.4782 21.2416 30.2503 21.4774 29.9405 21.4774C29.6236 21.4774 29.3958 21.2416 29.3958 20.8837V16.801Z\" fill=\"#A2C61F\"/>\n<path id=\"Vector_14\" d=\"M8.99784 14.3373C8.92088 14.3373 8.84192 14.3155 8.77095 14.2711C8.56605 14.1418 8.50209 13.8646 8.62802 13.6525C8.99984 13.0236 9.64751 12.6492 10.3592 12.6492C10.599 12.6492 10.7939 12.8509 10.7939 13.0991C10.7939 13.3474 10.599 13.5491 10.3592 13.5491C9.95236 13.5491 9.58154 13.7642 9.36865 14.1242C9.28669 14.2607 9.14377 14.3373 8.99784 14.3373Z\" fill=\"#A2C61F\"/>\n<path id=\"Vector_15\" d=\"M9.69419 14.7767C9.61024 14.7767 9.54327 14.6991 9.55826 14.6143C9.63222 14.2006 9.98205 13.8882 10.4028 13.8882C10.8236 13.8882 11.1734 14.2006 11.2474 14.6143C11.2624 14.6991 11.1954 14.7767 11.1115 14.7767H9.69419Z\" fill=\"#A2C61F\"/>\n<path id=\"Vector_16\" d=\"M14.3392 14.7767C14.2553 14.7767 14.1883 14.6991 14.2033 14.6143C14.2772 14.2006 14.6271 13.8882 15.0479 13.8882C15.4687 13.8882 15.8185 14.2006 15.8924 14.6143C15.9074 14.6991 15.8405 14.7767 15.7565 14.7767H14.3392Z\" fill=\"#A2C61F\"/>\n<path id=\"Vector_17\" d=\"M12.8312 18.9214H11.7798C11.5399 18.9214 11.345 18.7197 11.345 18.4715C11.345 18.2232 11.5399 18.0215 11.7798 18.0215H12.8312C12.9102 18.0215 12.9752 17.9553 12.9752 17.8726V14.7477C12.9752 13.5903 13.8857 12.6479 15.0041 12.6479C15.244 12.6479 15.4389 12.8497 15.4389 13.0979C15.4389 13.3462 15.244 13.5479 15.0041 13.5479C14.3645 13.5479 13.8437 14.0868 13.8437 14.7488V17.8736C13.8437 18.4518 13.3889 18.9214 12.8312 18.9214Z\" fill=\"#A2C61F\"/>\n</g>\n</g>\n</svg>";

var MaestroColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Maestro, Color=On\">\n<g id=\"maestro\">\n<path id=\"Vector\" d=\"M18.7624 27.4295V25.9404C18.7624 25.3773 18.3995 25.0051 17.8271 25.0051C17.5293 25.0051 17.2128 25.0935 16.9895 25.4285C16.8266 25.1679 16.566 25.0051 16.203 25.0051C15.9518 25.0051 15.7051 25.0795 15.505 25.3541V25.0655H14.9932V27.4388H15.519V26.1265C15.519 25.7124 15.7424 25.489 16.096 25.489C16.445 25.489 16.6079 25.7124 16.6079 26.1126V27.4388H17.1337V26.1265C17.1337 25.7124 17.3711 25.489 17.7201 25.489C18.0691 25.489 18.2459 25.7124 18.2459 26.1126V27.4388H18.7717V27.4295H18.7624ZM21.6754 26.2382V25.0516H21.1496V25.3401C20.9867 25.126 20.7355 24.9911 20.4004 24.9911C19.7396 24.9911 19.2138 25.5169 19.2138 26.2429C19.2138 26.9688 19.7396 27.4946 20.4004 27.4946C20.7401 27.4946 20.9867 27.355 21.1496 27.1456V27.4341H21.6754V26.2382ZM19.7489 26.2382C19.7489 25.824 20.0235 25.475 20.4749 25.475C20.8983 25.475 21.1868 25.8008 21.1868 26.2382C21.1868 26.6756 20.8983 27.0014 20.4749 27.0014C20.0235 27.0014 19.7489 26.6524 19.7489 26.2382ZM32.7366 24.9911C32.9227 24.9911 33.0856 25.0283 33.2485 25.0888C33.3974 25.1493 33.537 25.2377 33.6486 25.3494C33.7603 25.4611 33.8487 25.6007 33.9092 25.7496C33.9697 25.8985 34.007 26.0753 34.007 26.2475C34.007 26.4336 33.9837 26.5965 33.9092 26.7454C33.8487 26.8943 33.7603 27.0339 33.6486 27.1456C33.537 27.2573 33.3974 27.3457 33.2485 27.4062C33.0856 27.4667 32.9227 27.5039 32.7366 27.5039C32.5504 27.5039 32.3876 27.4667 32.2247 27.4062C32.0618 27.3457 31.9362 27.2573 31.8106 27.1456C31.6989 27.0339 31.6105 26.8943 31.55 26.7454C31.4895 26.5965 31.4522 26.4336 31.4522 26.2475C31.4522 26.0707 31.4755 25.9078 31.55 25.7496C31.6105 25.6007 31.6989 25.4611 31.8106 25.3494C31.9222 25.2377 32.0618 25.1493 32.2247 25.0888C32.3876 25.0283 32.5644 24.9911 32.7366 24.9911ZM32.7366 25.4797C32.6389 25.4797 32.5365 25.503 32.4481 25.5402C32.3504 25.5774 32.2712 25.6286 32.2107 25.6891C32.1503 25.7636 32.0991 25.838 32.0479 25.9264C32.0107 26.0148 31.9967 26.1265 31.9967 26.2242C31.9967 26.3359 32.02 26.4383 32.0479 26.536C32.0851 26.6244 32.1363 26.7129 32.2107 26.7733C32.2712 26.8338 32.3504 26.899 32.4481 26.9223C32.5365 26.9595 32.6342 26.9827 32.7366 26.9827C32.8343 26.9827 32.9367 26.9595 33.0344 26.9223C33.1228 26.885 33.2112 26.8338 33.2717 26.7733C33.3322 26.7129 33.3974 26.6244 33.4346 26.536C33.4718 26.4383 33.4858 26.3359 33.4858 26.2242C33.4858 26.1126 33.4718 26.0102 33.4346 25.9264C33.3974 25.8287 33.3462 25.7496 33.2717 25.6891C33.2112 25.6286 33.1228 25.5774 33.0344 25.5402C32.9506 25.503 32.8529 25.4797 32.7366 25.4797ZM24.4861 26.2382C24.4721 25.503 24.0254 24.9864 23.36 24.9864C22.662 24.9864 22.1734 25.4844 22.1734 26.2382C22.1734 27.0014 22.6852 27.49 23.3972 27.49C23.7462 27.49 24.0859 27.4016 24.3744 27.1503L24.1278 26.764C23.9277 26.9269 23.6764 27.0153 23.4391 27.0153C23.0994 27.0153 22.8016 26.8664 22.7271 26.429H24.4908C24.4861 26.3778 24.4861 26.3173 24.4861 26.2382ZM22.7271 26.0288C22.7783 25.6798 22.9877 25.4518 23.3646 25.4518C23.7043 25.4518 23.9137 25.6658 23.9649 26.0288H22.7271ZM26.6779 25.6658C26.5289 25.5774 26.2404 25.4657 25.9426 25.4657C25.6681 25.4657 25.4912 25.5635 25.4912 25.7403C25.4912 25.9032 25.6681 25.9404 25.8914 25.9776L26.1427 26.0148C26.6546 26.0893 26.9664 26.3127 26.9664 26.7268C26.9664 27.1782 26.5662 27.5039 25.8775 27.5039C25.4912 27.5039 25.1283 27.4062 24.8537 27.2061L25.091 26.8059C25.2679 26.9455 25.5285 27.0572 25.8775 27.0572C26.2265 27.0572 26.4173 26.9595 26.4173 26.7687C26.4173 26.6291 26.2777 26.5546 26.0031 26.5174L25.7518 26.4802C25.226 26.4057 24.9282 26.1684 24.9282 25.7822C24.9282 25.3075 25.3144 25.019 25.9147 25.019C26.2916 25.019 26.6406 25.1074 26.8919 25.2703L26.6779 25.6658ZM29.1488 25.5262H28.3112V26.6012C28.3112 26.8385 28.3996 27.0014 28.6509 27.0014C28.7905 27.0014 28.9487 26.9641 29.1116 26.8618L29.2605 27.3131C29.0976 27.4248 28.837 27.4993 28.609 27.4993C27.9948 27.4993 27.7854 27.1735 27.7854 26.6244V25.5355H27.2968V25.0609H27.7854V24.335H28.3112V25.0609H29.1488V25.5262ZM30.9497 24.9911C31.0474 24.9911 31.201 25.0051 31.3126 25.0516L31.1637 25.5402C31.0521 25.489 30.9404 25.4797 30.838 25.4797C30.4983 25.4797 30.3401 25.6938 30.3401 26.0939V27.4295H29.8142V25.0562H30.3261V25.3448C30.4518 25.126 30.6519 24.9911 30.9497 24.9911ZM34.5281 27.0758C34.5654 27.0758 34.5886 27.0758 34.6259 27.0898C34.6491 27.1037 34.677 27.113 34.7003 27.141C34.7236 27.1642 34.7375 27.1922 34.7515 27.2154C34.7655 27.2387 34.7655 27.2759 34.7655 27.3038C34.7655 27.3411 34.7515 27.3643 34.7515 27.4016C34.7375 27.4248 34.7143 27.4527 34.7003 27.476C34.677 27.4993 34.6491 27.5132 34.6259 27.5272C34.6026 27.5412 34.5654 27.5412 34.5281 27.5412C34.4909 27.5412 34.4676 27.5272 34.4397 27.5272C34.4165 27.5132 34.3885 27.5039 34.3653 27.476C34.342 27.4527 34.328 27.4248 34.3141 27.4016C34.3001 27.3643 34.3001 27.3411 34.3001 27.3038C34.3001 27.2666 34.3141 27.2433 34.3141 27.2154C34.328 27.1922 34.3374 27.1642 34.3653 27.141C34.3885 27.1177 34.4165 27.1037 34.4397 27.0898C34.4537 27.0898 34.4909 27.0758 34.5281 27.0758ZM34.5281 27.5039C34.5514 27.5039 34.5793 27.5039 34.6026 27.49C34.6259 27.476 34.6398 27.4667 34.6631 27.4527C34.677 27.4388 34.6864 27.4155 34.7003 27.3922C34.7143 27.369 34.7143 27.3411 34.7143 27.3178C34.7143 27.2945 34.7143 27.2666 34.7003 27.2433C34.6864 27.2201 34.677 27.2061 34.6631 27.1828C34.6491 27.1689 34.6259 27.1596 34.6026 27.1456C34.5793 27.1317 34.5514 27.1317 34.5281 27.1317C34.5049 27.1317 34.477 27.1317 34.4676 27.1456C34.4444 27.1596 34.4165 27.1689 34.4072 27.1828C34.3932 27.1968 34.3839 27.2201 34.3699 27.2433C34.356 27.2666 34.356 27.2945 34.356 27.3178C34.356 27.3411 34.356 27.369 34.3699 27.3922C34.3839 27.4155 34.3932 27.4295 34.4072 27.4527C34.4211 27.4667 34.4444 27.49 34.4676 27.49C34.477 27.5039 34.5002 27.5039 34.5281 27.5039ZM34.5374 27.2015C34.5607 27.2015 34.5886 27.2154 34.5979 27.2247C34.6119 27.2387 34.6212 27.248 34.6212 27.2759C34.6212 27.2899 34.6212 27.3131 34.6073 27.3271C34.5933 27.3411 34.57 27.3504 34.5561 27.3504L34.6305 27.4388H34.57L34.5095 27.3504H34.4863V27.4388H34.4351V27.2154H34.5328V27.2015H34.5374ZM34.4909 27.2526V27.3131H34.5421C34.5561 27.3131 34.5654 27.3131 34.5654 27.2992C34.5793 27.2852 34.5793 27.2852 34.5793 27.2759C34.5793 27.2666 34.5793 27.262 34.5654 27.262C34.5514 27.248 34.5514 27.248 34.5421 27.248L34.4909 27.2526Z\" fill=\"#373E45\"/>\n<g id=\"XMLID 150\">\n<path id=\"Vector_2\" d=\"M28.4135 6.9126H20.5771V21.0031H28.4135V6.9126Z\" fill=\"#7C79B8\"/>\n<path id=\"XMLID 154\" d=\"M21.0751 13.9625C21.0751 11.1006 22.4106 8.55985 24.5 6.91255C22.9737 5.71197 21.0518 5 18.9624 5C14.0112 5 10 9.01123 10 13.9625C10 18.9137 14.0112 22.9249 18.9624 22.9249C21.0518 22.9249 22.9737 22.2129 24.5 21.0124C22.4153 19.3651 21.0751 16.815 21.0751 13.9625Z\" fill=\"#DE0A1A\"/>\n<path id=\"Vector_3\" d=\"M38.1393 19.514V19.2255H38.2509V19.165H37.9531V19.2255H38.0648V19.514H38.1393V19.514ZM38.7163 19.514V19.165H38.6279L38.5301 19.4024L38.4185 19.165H38.3301V19.514H38.3905V19.2535L38.4883 19.4768H38.5488L38.6465 19.2535V19.514H38.7163Z\" fill=\"#23A6E0\"/>\n<path id=\"Vector_4\" d=\"M39 13.9625C39 18.9137 34.9888 22.9249 30.0375 22.9249C27.9482 22.9249 26.0263 22.2129 24.5 21.0124C26.5894 19.3744 27.9249 16.8243 27.9249 13.9625C27.9249 11.1006 26.5894 8.55985 24.5 6.91255C26.0263 5.71197 27.9482 5 30.0375 5C34.9888 5 39 9.01589 39 13.9625Z\" fill=\"#23A6E0\"/>\n</g>\n</g>\n</g>\n</svg>";

var MasterCardColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Mastercard, Color=On\">\n<g id=\"mastercard\">\n<path id=\"Vector\" d=\"M15.2379 27.4226V25.9226C15.2379 25.3595 14.8981 24.9857 14.3253 24.9857C14.0243 24.9857 13.7137 25.0731 13.4855 25.4129C13.3253 25.1508 13.0583 24.9857 12.6991 24.9857C12.4515 24.9857 12.1748 25.0585 11.9855 25.3352V25.0488H11.5098V27.4226H11.9952V26.0585C11.9952 25.6459 12.2428 25.4226 12.5972 25.4226C12.9467 25.4226 13.136 25.6459 13.136 26.0488V27.4129H13.6214V26.0488C13.6214 25.6362 13.8836 25.4129 14.2234 25.4129C14.5729 25.4129 14.7622 25.6362 14.7622 26.0391V27.4032H15.2379V27.4226V27.4226ZM23.0001 25.0488H22.1361V24.3255H21.6506V25.0488H21.1506V25.4857H21.6506V26.6119C21.6506 27.1605 21.8496 27.5003 22.4613 27.5003C22.6846 27.5003 22.9467 27.4275 23.1118 27.311L22.9613 26.8838C22.8011 26.9712 22.6361 27.0197 22.5001 27.0197C22.238 27.0197 22.1361 26.8595 22.1361 26.6216V25.4857H23.0001V25.0488ZM27.4225 24.9857C27.1215 24.9857 26.9079 25.1216 26.772 25.3352V25.0488H26.2963V27.4226H26.772V26.0828C26.772 25.6847 26.9613 25.4323 27.2963 25.4323C27.3982 25.4323 27.5099 25.4469 27.6215 25.4954L27.772 25.044C27.6749 25.0003 27.5244 24.9857 27.4225 24.9857ZM20.738 25.2381C20.4904 25.0779 20.136 24.9906 19.7623 24.9906C19.1603 24.9906 18.7865 25.277 18.7865 25.7527C18.7865 26.1411 19.0487 26.3789 19.5875 26.4517L19.8351 26.4906C20.1215 26.5294 20.272 26.6265 20.272 26.7673C20.272 26.9566 20.0584 27.0682 19.7089 27.0682C19.3351 27.0682 19.0972 26.9566 18.9224 26.8207L18.6846 27.1945C19.0341 27.4566 19.4613 27.5051 19.7089 27.5051C20.3982 27.5051 20.772 27.1799 20.772 26.7284C20.772 26.3013 20.4856 26.0925 19.9613 26.0148L19.7137 25.976C19.4904 25.9517 19.2865 25.8741 19.2865 25.7139C19.2865 25.5391 19.4758 25.4129 19.7623 25.4129C20.0632 25.4129 20.3642 25.5245 20.5098 25.6119L20.738 25.2381ZM27.9759 26.2381C27.9759 26.9615 28.4613 27.4857 29.2235 27.4857C29.5876 27.4857 29.8254 27.4129 30.0876 27.1993L29.84 26.8255C29.641 26.9615 29.4419 27.0391 29.2138 27.0391C28.8012 27.0391 28.4759 26.7139 28.4759 26.2381C28.4759 25.7624 28.8012 25.4372 29.2138 25.4275C29.4371 25.4275 29.641 25.5003 29.84 25.6411L30.0876 25.2673C29.8254 25.0682 29.5876 24.9809 29.2235 24.9809C28.4468 24.9857 27.9759 25.51 27.9759 26.2381ZM24.6264 24.9857C23.9273 24.9857 23.4516 25.4857 23.4516 26.2333C23.4516 26.9954 23.9516 27.4954 24.6652 27.4954C25.0293 27.4954 25.3545 27.4081 25.6409 27.1556L25.3934 26.8061C25.1943 26.9663 24.9322 27.0537 24.6943 27.0537C24.3545 27.0537 24.0196 26.8644 23.9565 26.4275H25.7332C25.7332 26.3644 25.7477 26.3013 25.7477 26.2284C25.738 25.4857 25.2866 24.9857 24.6264 24.9857ZM24.6118 25.4226C24.9613 25.4226 25.1992 25.6459 25.238 26.0246H23.9516C24.0001 25.675 24.2235 25.4226 24.6118 25.4226ZM18.1603 26.2381V25.0488H17.6846V25.3352C17.5244 25.1216 17.2477 24.9857 16.9079 24.9857C16.2477 24.9857 15.7331 25.51 15.7331 26.2333C15.7331 26.9566 16.2477 27.4809 16.9079 27.4809C17.2477 27.4809 17.5098 27.345 17.6846 27.1314V27.4178H18.1603V26.2381ZM16.2234 26.2381C16.2234 25.7867 16.5098 25.4275 16.971 25.4275C17.4079 25.4275 17.6943 25.7673 17.6943 26.2381C17.6943 26.6993 17.4079 27.0391 16.971 27.0391C16.5098 27.0343 16.2234 26.6848 16.2234 26.2381ZM34.6216 24.9857C34.3206 24.9857 34.107 25.1216 33.9711 25.3352V25.0488H33.4954V27.4226H33.9711V26.0828C33.9711 25.6847 34.1604 25.4323 34.4954 25.4323C34.5973 25.4323 34.709 25.4469 34.8206 25.4954L34.9808 25.044C34.874 25.0003 34.7235 24.9857 34.6216 24.9857ZM38.4614 27.0731C38.5003 27.0731 38.5245 27.0877 38.5634 27.0974C38.5876 27.1119 38.6119 27.1216 38.6362 27.1459C38.6605 27.1702 38.675 27.1945 38.6847 27.2187C38.6944 27.243 38.709 27.2818 38.709 27.3061C38.709 27.3304 38.6944 27.3692 38.6847 27.3935C38.6702 27.4178 38.6605 27.442 38.6362 27.4663C38.6119 27.4906 38.5876 27.5051 38.5634 27.5149C38.5391 27.5294 38.5003 27.5391 38.4614 27.5391C38.4226 27.5391 38.3983 27.5391 38.3595 27.5149C38.3352 27.5003 38.3109 27.4906 38.2867 27.4663C38.2624 27.442 38.2478 27.4178 38.2381 27.3935C38.2236 27.3692 38.2236 27.3304 38.2236 27.3061C38.2236 27.2673 38.2381 27.243 38.2381 27.2187C38.2527 27.1945 38.2624 27.1702 38.2867 27.1459C38.3109 27.1216 38.3352 27.1071 38.3595 27.0974C38.3983 27.0877 38.4226 27.0731 38.4614 27.0731ZM38.4614 27.5003C38.4857 27.5003 38.51 27.4857 38.5342 27.4857C38.5585 27.4712 38.5731 27.4615 38.5973 27.4469C38.6119 27.4323 38.6216 27.4081 38.6362 27.3838C38.6507 27.3595 38.6507 27.3352 38.6507 27.311C38.6507 27.2867 38.6507 27.2624 38.6362 27.2382C38.6216 27.2139 38.6119 27.1993 38.5973 27.175C38.5828 27.1605 38.5585 27.1508 38.5342 27.1362C38.51 27.1216 38.4857 27.1216 38.4614 27.1216C38.4372 27.1216 38.4129 27.1216 38.3886 27.1362C38.3643 27.1508 38.3498 27.1605 38.3255 27.175C38.3109 27.1896 38.2867 27.2139 38.2867 27.2382C38.2721 27.2624 38.2721 27.2867 38.2721 27.311C38.2721 27.3352 38.2721 27.3595 38.2867 27.3838C38.3012 27.4081 38.3109 27.4226 38.3255 27.4469C38.3401 27.4615 38.3643 27.4712 38.3886 27.4857C38.4129 27.5003 38.4372 27.5003 38.4614 27.5003ZM38.4711 27.1993C38.4954 27.1993 38.5197 27.2139 38.5342 27.2236C38.5488 27.2382 38.5585 27.2479 38.5585 27.2721C38.5585 27.2867 38.5585 27.311 38.5439 27.3207C38.5294 27.3352 38.5197 27.345 38.4954 27.345L38.5682 27.4178H38.5051L38.442 27.345H38.4177V27.4178H38.3692V27.2042H38.4711V27.1993V27.1993ZM38.4226 27.2479V27.2964H38.4711C38.4857 27.2964 38.4954 27.2964 38.4954 27.2964C38.51 27.2964 38.51 27.2818 38.51 27.2721C38.51 27.2576 38.51 27.2576 38.4954 27.2479C38.4808 27.2479 38.4808 27.2333 38.4711 27.2333H38.4226V27.2479ZM32.7866 26.2381V25.0488H32.3109V25.3352C32.1507 25.1216 31.874 24.9857 31.5342 24.9857C30.874 24.9857 30.3594 25.51 30.3594 26.2333C30.3594 26.9566 30.874 27.4809 31.5342 27.4809C31.874 27.4809 32.1458 27.345 32.3109 27.1314V27.4178H32.7866V26.2381ZM30.8594 26.2381C30.8594 25.7867 31.1458 25.4275 31.607 25.4275C32.0439 25.4275 32.3303 25.7673 32.3303 26.2381C32.3303 26.6993 32.0439 27.0391 31.607 27.0391C31.1361 27.0343 30.8594 26.6848 30.8594 26.2381ZM37.5973 26.2381V24.0876H37.1216V25.3352C36.9614 25.1216 36.6847 24.9857 36.3449 24.9857C35.6701 24.9857 35.1701 25.51 35.1701 26.2333C35.1701 26.9566 35.6847 27.4809 36.3449 27.4809C36.6847 27.4809 36.9468 27.345 37.1216 27.1314V27.4178H37.5973V26.2381ZM35.675 26.2381C35.675 25.7867 35.9614 25.4275 36.4129 25.4275C36.8498 25.4275 37.1362 25.7673 37.1362 26.2381C37.1362 26.6993 36.8498 27.0391 36.4129 27.0391C35.9468 27.0343 35.675 26.6848 35.675 26.2381Z\" fill=\"#373E45\"/>\n<path id=\"Vector_2\" d=\"M28.8104 6.9126H20.1841V21.0001H28.8104V6.9126Z\" fill=\"#EA580F\"/>\n<path id=\"Vector_3\" d=\"M21.0729 13.9612C21.0729 11.0971 22.4127 8.56313 24.5001 6.91264C22.9758 5.7136 21.0486 5 18.9612 5C14.0097 5 10 9.01459 10 13.9612C10 18.9079 14.0146 22.9225 18.9612 22.9225C21.0486 22.9225 22.9758 22.2089 24.5001 21.0098C22.4127 19.3593 21.0729 16.8108 21.0729 13.9612Z\" fill=\"#E20D18\"/>\n<path id=\"Vector_4\" d=\"M38.1354 19.5099V19.2235H38.247V19.1604H37.946V19.2235H38.0577V19.5099H38.1354ZM38.7082 19.5099V19.1604H38.6208L38.5189 19.3983L38.4072 19.1604H38.3198V19.5099H38.3829V19.2478L38.4849 19.4711H38.548L38.6499 19.2478V19.5099H38.7082Z\" fill=\"#F59E07\"/>\n<path id=\"Vector_5\" d=\"M39.0001 13.9612C39.0001 18.9127 34.9855 22.9225 30.0389 22.9225C27.9515 22.9225 26.0243 22.2089 24.5 21.0098C26.5874 19.3739 27.9272 16.8205 27.9272 13.9612C27.9272 11.102 26.5874 8.56313 24.5 6.91264C26.0243 5.7136 27.9515 5 30.0389 5C34.9855 5 39.0001 9.00974 39.0001 13.9612Z\" fill=\"#F59E07\"/>\n</g>\n</g>\n</svg>";

var MasterCardDebitoColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Mastercard_Debito, Color=On\">\n<g id=\"Logos/TDC/Color/Mastercard-debito_42x32\">\n<g id=\"Group\">\n<path id=\"d&#195;&#169;bito\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M29.3489 28.7501C29.6071 28.9355 29.7567 29.202 29.8048 29.5385C29.8528 29.8741 29.7917 30.185 29.607 30.4574C29.443 30.6994 29.2211 30.8418 28.9539 30.8927C28.6948 30.9421 28.4457 30.9057 28.2144 30.7619C27.9252 30.5822 27.758 30.3036 27.7018 29.9408C27.6914 29.8737 27.6889 29.8051 27.6855 29.768C27.6892 29.3976 27.7917 29.1044 28.0146 28.8706C28.1764 28.7007 28.3713 28.605 28.5908 28.5729C28.8617 28.5333 29.1167 28.5834 29.3489 28.7501ZM28.7479 28.9257C28.7343 28.9266 28.7156 28.9274 28.697 28.929C28.4682 28.9487 28.2843 29.0596 28.1579 29.2755C28.0466 29.4655 28.0197 29.6772 28.054 29.8986C28.083 30.0851 28.1594 30.2435 28.291 30.3654C28.4121 30.4775 28.5515 30.538 28.7086 30.5469C28.9115 30.5584 29.0923 30.4943 29.2401 30.3366C29.4284 30.1356 29.4915 29.8822 29.4536 29.6005C29.3991 29.1948 29.1154 28.9267 28.7479 28.9257ZM27.3939 30.6882C27.3205 30.75 27.2423 30.7962 27.1594 30.833C26.9513 30.9254 26.7385 30.9396 26.5237 30.8705C26.3105 30.8019 26.1837 30.6346 26.1299 30.3997C26.107 30.2997 26.0935 30.1944 26.0922 30.0913C26.0877 29.7306 26.0904 29.3699 26.0904 29.0091V28.9634H25.6625V28.6093H26.0894V27.9017H26.4381V28.6077H27.2835V28.9618H26.4386V28.9998C26.4386 29.3559 26.4385 29.712 26.4387 30.0681C26.4387 30.1497 26.4474 30.23 26.4755 30.3061C26.5294 30.4516 26.629 30.5291 26.7673 30.545C26.9243 30.563 27.0652 30.5083 27.1981 30.4204C27.2086 30.4134 27.2189 30.406 27.2312 30.3975C27.2856 30.4947 27.3392 30.5905 27.3939 30.6882ZM21.1927 28.7499C21.3872 28.9041 21.5 29.1215 21.56 29.3754C21.5973 29.5337 21.6068 29.6951 21.5926 29.8581C21.5922 29.8626 21.591 29.8669 21.5895 29.8744H20.0074C20.0192 30.005 20.052 30.124 20.1124 30.2323C20.2243 30.433 20.3898 30.5394 20.597 30.5654C20.8643 30.5989 21.0963 30.5027 21.302 30.3159C21.3052 30.3131 21.3086 30.3106 21.3152 30.3052C21.3772 30.3944 21.4375 30.4812 21.4991 30.5699C21.3875 30.6865 21.2636 30.7793 21.1184 30.8319C20.8582 30.9262 20.5945 30.9485 20.331 30.8547C19.9725 30.7272 19.7586 30.4454 19.6776 30.041C19.6104 29.7051 19.6431 29.3778 19.803 29.0782C19.9572 28.7893 20.1903 28.6245 20.4868 28.5742C20.7418 28.5309 20.9802 28.5813 21.1927 28.7499ZM20.6524 28.9049C20.4866 28.9017 20.3356 28.9545 20.2142 29.0889C20.0973 29.2183 20.0356 29.3774 20.0115 29.5594H21.2411C21.2255 29.2799 21.0481 28.9126 20.6524 28.9049ZM24.8356 30.8636H25.1785V28.6107H24.8356V30.8636ZM25.2511 27.8081C25.2521 27.9612 25.1451 28.0823 25.0062 28.0852C24.8721 28.088 24.7608 27.966 24.7592 27.8144C24.7576 27.6609 24.8637 27.5381 24.9991 27.5368C25.1409 27.5354 25.25 27.6528 25.2511 27.8081ZM22.5289 27.4451V28.9038C22.5394 28.8938 22.5455 28.889 22.5505 28.883C22.7081 28.6923 22.9034 28.5888 23.1338 28.5664C23.4076 28.5396 23.6565 28.6123 23.8711 28.8076C24.0694 28.9882 24.1856 29.2241 24.2303 29.5054C24.2709 29.7611 24.2498 30.0106 24.1547 30.2465C24.0101 30.605 23.7629 30.825 23.4141 30.8933C23.1652 30.9421 22.9289 30.9031 22.7152 30.7454C22.65 30.6973 22.5929 30.6356 22.5321 30.5802V30.8622H22.1855V27.4451H22.5289ZM23.1804 28.9257C22.9569 28.9312 22.7596 29.0364 22.6263 29.269C22.5152 29.463 22.4858 29.6779 22.5218 29.9028C22.5523 30.0934 22.6288 30.2577 22.7659 30.3808C22.911 30.5109 23.0778 30.5623 23.2622 30.5453C23.451 30.5278 23.61 30.4421 23.728 30.2752C23.8791 30.0614 23.9213 29.8167 23.8757 29.5513C23.812 29.1802 23.5365 28.9253 23.1804 28.9257ZM20.3585 28.2553C20.3648 28.2438 20.369 28.235 20.374 28.2268C20.5077 28.0078 20.6417 27.7891 20.7748 27.5697C20.7859 27.5513 20.7971 27.5439 20.8173 27.544C20.9519 27.5451 21.0865 27.5446 21.2284 27.5446C21.2113 27.5684 21.198 27.5878 21.1839 27.6066C21.0272 27.8164 20.8704 28.0263 20.713 28.2355C20.7048 28.2464 20.6898 28.2572 20.6779 28.2574C20.5774 28.2591 20.4768 28.2584 20.3763 28.2582C20.3715 28.2582 20.3667 28.2567 20.3585 28.2553ZM19.0644 27.4452V30.8622H18.7169V30.5717C18.669 30.6193 18.6246 30.6674 18.5765 30.7104C18.4597 30.8147 18.3237 30.8725 18.1777 30.8977C17.9616 30.935 17.7522 30.908 17.5554 30.7961C17.259 30.6277 17.0855 30.3536 17.0203 29.9935C16.9697 29.7144 16.9946 29.4412 17.1082 29.1843C17.2606 28.8395 17.5096 28.6338 17.8495 28.5745C18.0892 28.5326 18.3189 28.5711 18.525 28.7227C18.5935 28.7731 18.6534 28.8382 18.7162 28.8956V27.4452H19.0644ZM18.0456 28.9262C17.8562 28.9261 17.6893 28.9952 17.5557 29.1483C17.4139 29.3109 17.3552 29.5118 17.3514 29.7512C17.3536 29.7785 17.3555 29.8214 17.3606 29.8638C17.4099 30.274 17.6899 30.5305 18.001 30.5464C18.2662 30.5599 18.4791 30.4508 18.6241 30.1981C18.7247 30.0227 18.7532 29.8269 18.7316 29.6214C18.7131 29.4449 18.6533 29.288 18.5442 29.1581C18.4096 28.998 18.2398 28.9264 18.0456 28.9262Z\" fill=\"#231F20\"/>\n<path id=\"mastercard\" d=\"M36.5514 23.6688V23.7276H36.6024C36.6137 23.7276 36.6234 23.7247 36.6303 23.7202C36.6368 23.7156 36.6406 23.7076 36.6406 23.6979C36.6406 23.6882 36.6368 23.6808 36.6303 23.6762C36.6234 23.6711 36.6137 23.6688 36.6024 23.6688H36.5514ZM36.603 23.6277C36.6293 23.6277 36.6497 23.634 36.6642 23.6465C36.6787 23.6591 36.6857 23.6762 36.6857 23.6979C36.6857 23.7162 36.6803 23.731 36.6685 23.743C36.6572 23.7544 36.6411 23.7618 36.6196 23.7647L36.6873 23.8475H36.6346L36.5718 23.7653H36.5514V23.8475H36.5073V23.6277H36.603ZM36.5895 23.9234C36.6137 23.9234 36.6363 23.9183 36.6567 23.9085C36.6776 23.8988 36.6959 23.8857 36.7115 23.8692C36.7271 23.8526 36.7394 23.8332 36.7485 23.8104C36.7571 23.7881 36.762 23.7641 36.762 23.7384C36.762 23.7127 36.7571 23.6888 36.7485 23.6665C36.7394 23.6442 36.7271 23.6243 36.7115 23.6077C36.6959 23.5911 36.6776 23.578 36.6567 23.5683C36.6363 23.5592 36.6137 23.5546 36.5895 23.5546C36.5653 23.5546 36.5422 23.5592 36.5213 23.5683C36.4998 23.578 36.481 23.5911 36.4654 23.6077C36.4498 23.6243 36.4375 23.6442 36.4289 23.6665C36.4197 23.6888 36.4155 23.7127 36.4155 23.7384C36.4155 23.7641 36.4197 23.7881 36.4289 23.8104C36.4375 23.8332 36.4498 23.8526 36.4654 23.8692C36.481 23.8857 36.4998 23.8988 36.5213 23.9085C36.5422 23.9183 36.5653 23.9234 36.5895 23.9234ZM36.5895 23.5015C36.6212 23.5015 36.6502 23.5078 36.6782 23.5204C36.7056 23.5323 36.7292 23.5495 36.7502 23.5712C36.7706 23.5923 36.7867 23.6174 36.7985 23.6465C36.8103 23.6751 36.8162 23.7059 36.8162 23.7384C36.8162 23.771 36.8103 23.8018 36.7985 23.8303C36.7867 23.8589 36.7706 23.884 36.7502 23.9057C36.7292 23.9268 36.7056 23.9439 36.6782 23.9565C36.6502 23.9691 36.6212 23.9753 36.5895 23.9753C36.5573 23.9753 36.5277 23.9691 36.4998 23.9565C36.4719 23.9439 36.4477 23.9268 36.4273 23.9057C36.4069 23.884 36.3907 23.8589 36.3789 23.8303C36.3671 23.8018 36.3612 23.771 36.3612 23.7384C36.3612 23.7059 36.3671 23.6751 36.3789 23.6465C36.3907 23.6174 36.4069 23.5923 36.4273 23.5712C36.4477 23.5495 36.4719 23.5323 36.4998 23.5204C36.5277 23.5078 36.5573 23.5015 36.5895 23.5015ZM15.6579 22.6549C15.6579 22.2359 15.9163 21.8916 16.3386 21.8916C16.7421 21.8916 17.0145 22.221 17.0145 22.6549C17.0145 23.0888 16.7421 23.4182 16.3386 23.4182C15.9163 23.4182 15.6579 23.0739 15.6579 22.6549ZM17.4743 22.6549V21.4629H16.9865V21.7524C16.8318 21.5377 16.597 21.403 16.2779 21.403C15.6488 21.403 15.1556 21.927 15.1556 22.6549C15.1556 23.3833 15.6488 23.9068 16.2779 23.9068C16.597 23.9068 16.8318 23.7721 16.9865 23.5575V23.8469H17.4743V22.6549ZM33.9592 22.6549C33.9592 22.2359 34.2176 21.8916 34.6399 21.8916C35.0439 21.8916 35.3157 22.221 35.3157 22.6549C35.3157 23.0888 35.0439 23.4182 34.6399 23.4182C34.2176 23.4182 33.9592 23.0739 33.9592 22.6549ZM35.7761 22.6549V20.5056H35.2878V21.7524C35.133 21.5377 34.8983 21.403 34.5791 21.403C33.95 21.403 33.4568 21.927 33.4568 22.6549C33.4568 23.3833 33.95 23.9068 34.5791 23.9068C34.8983 23.9068 35.133 23.7721 35.2878 23.5575V23.8469H35.7761V22.6549ZM23.5296 21.8671C23.8439 21.8671 24.0459 22.0766 24.0975 22.4454H22.9333C22.9854 22.1012 23.182 21.8671 23.5296 21.8671ZM23.5393 21.403C22.8817 21.403 22.4218 21.9116 22.4218 22.6549C22.4218 23.413 22.9005 23.9068 23.5721 23.9068C23.91 23.9068 24.2195 23.8172 24.4918 23.5729L24.2528 23.1887C24.0647 23.3479 23.8251 23.4381 23.6 23.4381C23.2857 23.4381 22.9994 23.2834 22.929 22.8541H24.595C24.5998 22.7896 24.6047 22.7246 24.6047 22.6549C24.5998 21.9116 24.1679 21.403 23.5393 21.403ZM29.4297 22.6549C29.4297 22.2359 29.6881 21.8916 30.1103 21.8916C30.5138 21.8916 30.7862 22.221 30.7862 22.6549C30.7862 23.0888 30.5138 23.4182 30.1103 23.4182C29.6881 23.4182 29.4297 23.0739 29.4297 22.6549ZM31.2461 22.6549V21.4629H30.7583V21.7524C30.603 21.5377 30.3688 21.403 30.0496 21.403C29.4205 21.403 28.9273 21.927 28.9273 22.6549C28.9273 23.3833 29.4205 23.9068 30.0496 23.9068C30.3688 23.9068 30.603 23.7721 30.7583 23.5575V23.8469H31.2461V22.6549ZM26.6747 22.6549C26.6747 23.3782 27.1485 23.9068 27.8716 23.9068C28.2096 23.9068 28.4347 23.8269 28.6786 23.6225L28.4443 23.2035C28.2611 23.3434 28.0688 23.4182 27.8571 23.4182C27.4676 23.413 27.1813 23.1139 27.1813 22.6549C27.1813 22.1959 27.4676 21.8968 27.8571 21.8916C28.0688 21.8916 28.2611 21.9664 28.4443 22.1063L28.6786 21.6873C28.4347 21.4829 28.2096 21.403 27.8716 21.403C27.1485 21.403 26.6747 21.9316 26.6747 22.6549ZM32.9642 21.403C32.6827 21.403 32.4995 21.5428 32.3727 21.7524V21.4629H31.8892V23.8469H32.3775V22.5105C32.3775 22.116 32.5371 21.8968 32.8562 21.8968C32.9551 21.8968 33.0582 21.9116 33.1614 21.9567L33.3118 21.4681C33.2038 21.423 33.063 21.403 32.9642 21.403ZM19.8871 21.6525C19.6523 21.488 19.3289 21.403 18.9722 21.403C18.4038 21.403 18.0379 21.6924 18.0379 22.1662C18.0379 22.555 18.3103 22.7948 18.8121 22.8696L19.0426 22.9044C19.3101 22.9443 19.4364 23.0191 19.4364 23.1539C19.4364 23.3382 19.258 23.4433 18.9249 23.4433C18.587 23.4433 18.3431 23.3285 18.1787 23.1938L17.9487 23.5974C18.2163 23.8069 18.5542 23.9068 18.9201 23.9068C19.568 23.9068 19.9435 23.5826 19.9435 23.1287C19.9435 22.7097 19.648 22.4905 19.1597 22.4157L18.9297 22.3803C18.7186 22.3506 18.5494 22.3061 18.5494 22.1463C18.5494 21.9716 18.7089 21.8671 18.9765 21.8671C19.2628 21.8671 19.5401 21.9818 19.676 22.0715L19.8871 21.6525ZM26.1815 21.403C25.9 21.403 25.7168 21.5428 25.5905 21.7524V21.4629H25.107V23.8469H25.5948V22.5105C25.5948 22.116 25.7544 21.8968 26.0735 21.8968C26.1723 21.8968 26.2755 21.9116 26.3786 21.9567L26.5291 21.4681C26.4211 21.423 26.2803 21.403 26.1815 21.403ZM22.0184 21.4629H21.2206V20.7396H20.7274V21.4629H20.2723V21.9367H20.7274V23.0243C20.7274 23.5774 20.9294 23.9068 21.5064 23.9068C21.718 23.9068 21.962 23.8372 22.1167 23.7224L21.9759 23.2783C21.8303 23.3679 21.6708 23.413 21.544 23.413C21.3001 23.413 21.2206 23.2532 21.2206 23.014V21.9367H22.0184V21.4629ZM14.7242 23.8469V22.3506C14.7242 21.7872 14.3863 21.4081 13.8415 21.403C13.5551 21.3978 13.2597 21.4926 13.0528 21.8271C12.8981 21.5628 12.6542 21.403 12.3114 21.403C12.0718 21.403 11.8376 21.4778 11.6544 21.7569V21.4629H11.166V23.8469H11.6587V22.5253C11.6587 22.1114 11.8746 21.8916 12.2083 21.8916C12.5322 21.8916 12.6961 22.116 12.6961 22.5202V23.8469H13.1893V22.5253C13.1893 22.1114 13.4144 21.8916 13.7383 21.8916C14.0714 21.8916 14.231 22.116 14.231 22.5202V23.8469H14.7242Z\" fill=\"#231F20\"/>\n<g id=\"Medios-de-Pago/color/logo_mediopago_Mastercard_iso_color\">\n<path id=\"Fill-4\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M37.9998 16.847V15.5898H37.8486L37.6746 16.454L37.501 15.5898H37.3497V16.847H37.4562V15.8992L37.6195 16.7157H37.7301L37.8934 15.8965V16.847H37.9998ZM37.0423 16.847V15.8039H37.2362V15.5925H36.7427V15.8039H36.9366V16.847H37.0423Z\" fill=\"#F79E1B\"/>\n<path id=\"Fill-1\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.1165 17.355H27.6156V3.83789H20.1165V17.355Z\" fill=\"#FF5F00\"/>\n<path id=\"Fill-2\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.5931 10.5965C20.5931 7.85424 21.8731 5.41211 23.8665 3.83799C22.4086 2.68677 20.5692 2 18.57 2C13.8369 2 10 5.84886 10 10.5965C10 15.3442 13.8369 19.1931 18.57 19.1931C20.5692 19.1931 22.4086 18.5063 23.8665 17.3551C21.8731 15.781 20.5931 13.3386 20.5931 10.5965Z\" fill=\"#EB001B\"/>\n<path id=\"Fill-3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M37.7327 10.5965C37.7327 15.3442 33.8958 19.1931 29.163 19.1931C27.1637 19.1931 25.3241 18.5063 23.8665 17.3551C25.8598 15.781 27.1396 13.3386 27.1396 10.5965C27.1396 7.85424 25.8598 5.41211 23.8665 3.83799C25.3241 2.68677 27.1637 2 29.163 2C33.8958 2 37.7327 5.84886 37.7327 10.5965Z\" fill=\"#F79E1B\"/>\n</g>\n<path id=\"Path\" d=\"M37.9821 26.3332H10V26.2437H37.9821V26.3332Z\" fill=\"#231F20\"/>\n</g>\n</g>\n</g>\n</svg>";

var ModoColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Modo, Color=On\">\n<g id=\"Modo\">\n<path id=\"Vector\" d=\"M14.603 12.1096C14.2856 12.0075 13.9385 12.1225 13.7444 12.3936L11.0688 16.1303L11.661 16.9571C11.7718 17.0905 11.8384 17.2619 11.8384 17.4487C11.8384 17.5955 11.7972 17.7327 11.7258 17.8494L13.6006 15.2306V18.9876C13.6006 19.4114 13.9441 19.7551 14.3681 19.7551C14.7921 19.7551 15.1357 19.4116 15.1357 18.9876V12.8404C15.1359 12.5068 14.9205 12.2116 14.603 12.1096Z\" fill=\"#00B6AB\"/>\n<g id=\"Group\">\n<path id=\"Vector_2\" d=\"M7.76974 19.7557C7.34572 19.7557 7.0022 19.4121 7.0022 18.9881V16.6794C7.0022 16.2554 7.34572 15.9119 7.76974 15.9119C8.19376 15.9119 8.53728 16.2554 8.53728 16.6794V18.9881C8.53728 19.4119 8.19351 19.7557 7.76974 19.7557Z\" fill=\"#00C49A\"/>\n</g>\n<g id=\"Group_2\" opacity=\"0.4\">\n<path id=\"Vector_3\" opacity=\"0.4\" d=\"M7.76957 17.449C8.19459 17.449 8.53914 17.1045 8.53914 16.6795C8.53914 16.2545 8.19459 15.9099 7.76957 15.9099C7.34455 15.9099 7 16.2545 7 16.6795C7 17.1045 7.34455 17.449 7.76957 17.449Z\" fill=\"white\"/>\n</g>\n<path id=\"Vector_4\" opacity=\"0.4\" d=\"M14.3684 19.7556C14.7924 19.7556 15.1359 19.4121 15.1359 18.9881V18.9352C15.1086 18.5349 14.7754 18.2185 14.3684 18.2185C13.9613 18.2185 13.6282 18.5347 13.6008 18.9349V18.9881C13.6008 19.4118 13.9444 19.7556 14.3684 19.7556Z\" fill=\"white\"/>\n<path id=\"Vector_5\" opacity=\"0.4\" d=\"M14.3684 13.61C14.7755 13.61 15.1086 13.2938 15.136 12.8933V12.8404C15.136 12.507 14.9206 12.2116 14.6031 12.1096C14.2857 12.0075 13.9386 12.1225 13.7444 12.3936L13.7115 12.4397C13.6401 12.5564 13.5991 12.6936 13.5991 12.8404C13.5989 13.2654 13.9434 13.61 14.3684 13.61Z\" fill=\"white\"/>\n<path id=\"Vector_6\" d=\"M11.6609 16.957L11.0691 16.1303L8.39357 12.3936C8.14675 12.0488 7.66729 11.9695 7.32275 12.2163C6.97797 12.4632 6.89873 12.9426 7.14555 13.2872L10.4119 17.8496C10.5471 18.0709 10.7909 18.2185 11.0691 18.2185C11.4941 18.2185 11.8387 17.8739 11.8387 17.4489C11.8384 17.2618 11.7718 17.0905 11.6609 16.957Z\" fill=\"#00C49A\"/>\n<g id=\"Group_3\" opacity=\"0.4\">\n<path id=\"Vector_7\" opacity=\"0.4\" d=\"M11.0689 18.2186C11.4939 18.2186 11.8385 17.874 11.8385 17.449C11.8385 17.024 11.4939 16.6794 11.0689 16.6794C10.6439 16.6794 10.2993 17.024 10.2993 17.449C10.2993 17.874 10.6439 18.2186 11.0689 18.2186Z\" fill=\"white\"/>\n</g>\n<path id=\"Vector_8\" d=\"M20.1895 19.8342C20.2183 19.8375 20.2474 19.8393 20.277 19.8393C20.3067 19.8393 20.3355 19.8375 20.3644 19.8342C20.3353 19.8347 20.3062 19.8352 20.277 19.8352C20.2477 19.8352 20.2186 19.8347 20.1895 19.8342Z\" fill=\"#FF7BAC\"/>\n<path id=\"Vector_9\" d=\"M20.3409 12.0028C20.3199 12.001 20.2987 12 20.2771 12C19.8521 12 19.5076 12.3445 19.5076 12.7696C19.5076 13.1946 19.8521 13.5391 20.2771 13.5391C20.2923 13.5391 20.3075 13.5386 20.3225 13.5376C21.6148 13.5619 22.6585 14.6206 22.6585 15.9185C22.6585 16.5562 22.4112 17.1548 21.9623 17.6037C21.5138 18.0523 20.9156 18.2996 20.2784 18.2998C20.7029 18.3006 21.0467 18.6449 21.0467 19.0694C21.0467 19.4648 20.7482 19.7906 20.3645 19.8339C21.3796 19.8119 22.3297 19.4076 23.0478 18.6892C23.7868 17.9502 24.1936 16.9663 24.1936 15.9185C24.1938 13.7804 22.4712 12.0372 20.3409 12.0028Z\" fill=\"#00A7BD\"/>\n<path id=\"Vector_10\" d=\"M20.277 18.3001C20.2765 18.3001 20.2763 18.3001 20.2758 18.3001C18.9632 18.2994 17.8954 17.2313 17.8954 15.9188C17.8954 15.2867 18.1438 14.6862 18.5949 14.2283C18.8923 13.9263 18.8885 13.4402 18.5865 13.1428C18.2845 12.8453 17.7985 12.8491 17.501 13.1511C16.7656 13.8982 16.3606 14.8809 16.3606 15.9188C16.3606 18.049 18.0701 19.7874 20.1895 19.8342C20.2183 19.8375 20.2474 19.8393 20.277 19.8393C20.7021 19.8393 21.0466 19.4947 21.0466 19.0697C21.0466 18.6447 20.7021 18.3001 20.277 18.3001Z\" fill=\"#00B6AB\"/>\n<g id=\"Group_4\" opacity=\"0.4\">\n<path id=\"Vector_11\" opacity=\"0.4\" d=\"M20.2771 19.8392C20.7022 19.8392 21.0467 19.4946 21.0467 19.0696C21.0467 18.6446 20.7022 18.3 20.2771 18.3C19.8521 18.3 19.5076 18.6446 19.5076 19.0696C19.5076 19.4946 19.8521 19.8392 20.2771 19.8392Z\" fill=\"white\"/>\n</g>\n<g id=\"Group_5\" opacity=\"0.4\">\n<path id=\"Vector_12\" opacity=\"0.4\" d=\"M20.2771 13.5391C20.7022 13.5391 21.0467 13.1946 21.0467 12.7696C21.0467 12.3445 20.7022 12 20.2771 12C19.8521 12 19.5076 12.3445 19.5076 12.7696C19.5076 13.1946 19.8521 13.5391 20.2771 13.5391Z\" fill=\"white\"/>\n</g>\n<path id=\"Vector_13\" d=\"M31.1208 13.0408C30.4115 12.4077 29.4483 12.073 28.3355 12.073H26.0356C25.6118 12.073 25.2681 12.4165 25.2681 12.8405C25.2681 13.2646 25.6116 13.6081 26.0356 13.6081H28.3355C29.0653 13.6081 29.6751 13.8081 30.0989 14.186C30.5442 14.5835 30.7702 15.1665 30.7702 15.9188C30.7702 16.6686 30.5439 17.2496 30.0974 17.6455C29.6731 18.0217 29.064 18.2207 28.3355 18.2207H26.8032V18.907C26.8059 18.933 26.8072 18.9594 26.8072 18.9862C26.8072 19.4112 26.4627 19.7558 26.0376 19.7558H28.3355C29.445 19.7558 30.4065 19.4231 31.1158 18.7941C31.8937 18.104 32.3051 17.1099 32.3051 15.9188C32.3048 14.7273 31.8955 13.7321 31.1208 13.0408Z\" fill=\"#0099CE\"/>\n<path id=\"Vector_14\" d=\"M26.8029 18.9066V18.2203V15.1491C26.8029 14.7251 26.4594 14.3816 26.0354 14.3816C25.6116 14.3816 25.2678 14.7251 25.2678 15.1491V18.9861C25.2678 19.4109 25.6119 19.7552 26.0364 19.7557C26.0361 19.7557 26.0356 19.7557 26.0354 19.7557H26.0374C26.4624 19.7557 26.807 19.4111 26.807 18.9861C26.807 18.9593 26.8057 18.9327 26.8029 18.9066Z\" fill=\"#00A7BD\"/>\n<g id=\"Group_6\" opacity=\"0.4\">\n<path id=\"Vector_15\" opacity=\"0.4\" d=\"M26.0354 13.6081C26.4593 13.6081 26.8029 13.2644 26.8029 12.8405C26.8029 12.4166 26.4593 12.073 26.0354 12.073C25.6115 12.073 25.2678 12.4166 25.2678 12.8405C25.2678 13.2644 25.6115 13.6081 26.0354 13.6081Z\" fill=\"white\"/>\n</g>\n<g id=\"Group_7\" opacity=\"0.4\">\n<path id=\"Vector_16\" opacity=\"0.4\" d=\"M26.0374 19.7557C26.4624 19.7557 26.807 19.4111 26.807 18.9861C26.807 18.5611 26.4624 18.2166 26.0374 18.2166C25.6124 18.2166 25.2678 18.5611 25.2678 18.9861C25.2678 19.4111 25.6124 19.7557 26.0374 19.7557Z\" fill=\"white\"/>\n</g>\n<path id=\"Vector_17\" d=\"M37.1473 12.0028C37.1263 12.001 37.1051 12 37.0835 12C36.6585 12 36.314 12.3445 36.314 12.7696C36.314 13.1946 36.6585 13.5391 37.0835 13.5391C37.0987 13.5391 37.1139 13.5386 37.1288 13.5376C38.4212 13.5619 39.4649 14.6206 39.4649 15.9185C39.4649 16.5562 39.2176 17.1548 38.7687 17.6037C38.3202 18.0523 37.722 18.2996 37.0848 18.2998C37.5093 18.3006 37.8531 18.6449 37.8531 19.0694C37.8531 19.4648 37.5546 19.7906 37.1709 19.8339C38.186 19.8119 39.1361 19.4076 39.8542 18.6892C40.5932 17.9502 41 16.9663 41 15.9185C41.0002 13.7804 39.2776 12.0372 37.1473 12.0028Z\" fill=\"#008AE0\"/>\n<path id=\"Vector_18\" d=\"M37.0834 18.3001C37.0829 18.3001 37.0827 18.3001 37.0822 18.3001C35.7696 18.2994 34.7018 17.2313 34.7018 15.9188C34.7018 15.2867 34.9502 14.6862 35.4013 14.2283C35.6987 13.9263 35.6949 13.4402 35.3929 13.1428C35.0909 12.8453 34.6049 12.8491 34.3074 13.1511C33.572 13.8982 33.167 14.8809 33.167 15.9188C33.167 18.049 34.8765 19.7874 36.9959 19.8342C37.0247 19.8375 37.0538 19.8393 37.0834 19.8393C37.5085 19.8393 37.853 19.4947 37.853 19.0697C37.853 18.6447 37.5085 18.3001 37.0834 18.3001Z\" fill=\"#0099CE\"/>\n<g id=\"Group_8\" opacity=\"0.4\">\n<path id=\"Vector_19\" opacity=\"0.4\" d=\"M37.0835 19.8392C37.5086 19.8392 37.8531 19.4946 37.8531 19.0696C37.8531 18.6446 37.5086 18.3 37.0835 18.3C36.6585 18.3 36.314 18.6446 36.314 19.0696C36.314 19.4946 36.6585 19.8392 37.0835 19.8392Z\" fill=\"white\"/>\n</g>\n<g id=\"Group_9\" opacity=\"0.4\">\n<path id=\"Vector_20\" opacity=\"0.4\" d=\"M37.0835 13.5391C37.5086 13.5391 37.8531 13.1946 37.8531 12.7696C37.8531 12.3445 37.5086 12 37.0835 12C36.6585 12 36.314 12.3445 36.314 12.7696C36.314 13.1946 36.6585 13.5391 37.0835 13.5391Z\" fill=\"white\"/>\n</g>\n</g>\n</g>\n</svg>";

var NaranjaColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Naranja, Color=On\">\n<g id=\"Naranja\">\n<g id=\"Group\">\n<g id=\"Group_2\">\n<path id=\"Vector\" d=\"M8 18.166V16.3052C9.54218 16.3052 10.7925 15.0548 10.7925 13.5126V10.9316H12.6453V13.5126C12.6453 16.0803 10.5596 18.166 8 18.166Z\" fill=\"#F59C26\"/>\n<path id=\"Vector_2\" d=\"M8 18.166V16.3052C9.54218 16.3052 10.7925 15.0548 10.7925 13.5126V10.9316H12.6453V13.5126C12.6453 16.0803 10.5596 18.166 8 18.166Z\" fill=\"url(#paint0_linear_201_1235)\"/>\n</g>\n<path id=\"Vector_3\" d=\"M17.8365 10.3803C17.8793 10.4312 17.9007 10.4901 17.9007 10.5544C17.9007 10.6347 17.8713 10.6989 17.8124 10.7498C17.7615 10.7927 17.7026 10.8141 17.6383 10.8141C17.566 10.8141 17.4991 10.7846 17.4482 10.7338C17.3974 10.6829 17.3679 10.6186 17.3679 10.5437C17.3679 10.4687 17.3974 10.4044 17.4563 10.3536C17.5071 10.3107 17.566 10.2893 17.6303 10.2893C17.7187 10.2947 17.7856 10.3214 17.8365 10.3803ZM17.4857 10.4178C17.4482 10.4553 17.4349 10.5062 17.4349 10.557C17.4349 10.6079 17.4643 10.6668 17.4991 10.7097C17.5366 10.7471 17.5875 10.7605 17.6383 10.7605C17.7026 10.7605 17.7535 10.7391 17.7909 10.6963C17.8284 10.6588 17.8418 10.6079 17.8418 10.557C17.8418 10.4981 17.8204 10.4473 17.7776 10.4044C17.7401 10.367 17.6892 10.3536 17.6383 10.3536C17.5741 10.3509 17.5312 10.3723 17.4857 10.4178ZM17.7267 10.5035C17.6972 10.466 17.6758 10.4607 17.6464 10.4607C17.6169 10.4607 17.5955 10.4687 17.5821 10.4901C17.5687 10.5035 17.5527 10.5329 17.5527 10.5544C17.5527 10.5838 17.5607 10.6052 17.5821 10.6186C17.5955 10.632 17.6196 10.6481 17.6464 10.6481C17.6598 10.6481 17.6758 10.6481 17.6839 10.64C17.6919 10.632 17.7053 10.6267 17.7267 10.6026L17.7695 10.6454L17.7615 10.6534C17.724 10.6909 17.6892 10.7043 17.6464 10.7043C17.5955 10.7043 17.558 10.6909 17.5312 10.6534C17.5018 10.624 17.4938 10.5892 17.4938 10.5517C17.4938 10.5089 17.5071 10.4633 17.5446 10.4366C17.5741 10.4071 17.6089 10.3937 17.6544 10.3937C17.6999 10.3937 17.7347 10.4151 17.7776 10.4526L17.7267 10.5035Z\" fill=\"#EA541E\"/>\n<path id=\"Vector_4\" d=\"M16.1581 19.8955C15.8315 19.8955 15.5102 19.7215 15.3442 19.4083L10.9024 11.3761C10.6561 10.9263 10.8221 10.3667 11.2719 10.1177C11.7217 9.8714 12.2812 10.0374 12.5302 10.4872L16.972 18.5194C17.2184 18.9692 17.0524 19.5287 16.6026 19.7777C16.4633 19.8607 16.3107 19.8955 16.1581 19.8955Z\" fill=\"#97272D\"/>\n<path id=\"Vector_5\" d=\"M16.1581 19.8956C15.6413 19.8956 15.2263 19.4806 15.2263 18.9639V10.9317C15.2263 10.423 15.6413 10 16.1581 10C16.6748 10 17.0898 10.415 17.0898 10.9317V18.9639C17.0871 19.4806 16.6721 19.8956 16.1581 19.8956Z\" fill=\"#EA541E\"/>\n</g>\n<g id=\"Group_3\">\n<g id=\"Group_4\">\n<g id=\"Group_5\">\n<path id=\"Vector_6\" d=\"M18.9402 19.5771V15.2451H19.6042L21.8585 18.2545V15.2451H22.6296V19.5771H21.9683L19.7113 16.5677V19.5771H18.9402V19.5771Z\" fill=\"#EA541E\"/>\n<path id=\"Vector_7\" d=\"M26.1446 19.5771H25.403V19.3951C25.1566 19.5852 24.9023 19.6708 24.6319 19.6708C24.1821 19.6708 23.8099 19.5048 23.5127 19.1702C23.2503 18.8783 23.1191 18.5383 23.1191 18.1367C23.1191 17.6708 23.2851 17.2933 23.6198 16.9881C23.9116 16.7337 24.2436 16.6025 24.6292 16.6025C24.8969 16.6025 25.1593 16.6962 25.4003 16.8783V16.6962H26.1419V19.5771H26.1446ZM24.0375 17.5691C23.9224 17.7137 23.8635 17.9038 23.8635 18.1367C23.8635 18.4044 23.9357 18.624 24.0964 18.7766C24.241 18.9212 24.423 19.0015 24.6426 19.0015C24.8969 19.0015 25.0924 18.8997 25.245 18.7043C25.3548 18.5517 25.411 18.3616 25.411 18.1313C25.411 17.8689 25.3387 17.6601 25.1861 17.4995C25.0415 17.3469 24.8594 17.2746 24.6345 17.2746C24.3855 17.2799 24.1901 17.3736 24.0375 17.5691Z\" fill=\"#EA541E\"/>\n<path id=\"Vector_8\" d=\"M27.5693 16.8863C27.7353 16.7471 27.9173 16.6829 28.1369 16.6829C28.2092 16.6829 28.3029 16.6909 28.4127 16.7043V17.3656C28.2975 17.3576 28.2092 17.3522 28.1449 17.3522C27.9281 17.3522 27.7808 17.4111 27.6951 17.5343C27.6148 17.6574 27.572 17.877 27.572 18.1956V19.5771H26.8303V16.6989H27.572L27.5693 16.8863Z\" fill=\"#EA541E\"/>\n<path id=\"Vector_9\" d=\"M31.6683 19.5771H30.9293V19.3951C30.683 19.5852 30.4286 19.6708 30.1502 19.6708C29.7004 19.6708 29.3282 19.5048 29.031 19.1702C28.7686 18.8783 28.6375 18.5383 28.6375 18.1367C28.6375 17.6708 28.8034 17.2933 29.1381 16.9881C29.43 16.7337 29.762 16.6025 30.1475 16.6025C30.4152 16.6025 30.6776 16.6962 30.9266 16.8783V16.6962H31.6683V19.5771ZM29.5612 17.5691C29.446 17.7137 29.3871 17.9038 29.3871 18.1367C29.3871 18.4044 29.4594 18.624 29.6201 18.7766C29.7727 18.9212 29.9467 19.0015 30.1662 19.0015C30.4206 19.0015 30.616 18.8997 30.7687 18.7043C30.8784 18.5517 30.9347 18.3616 30.9347 18.1313C30.9347 17.8689 30.8624 17.6601 30.7098 17.4995C30.5652 17.3469 30.3831 17.2746 30.1582 17.2746C29.9092 17.2799 29.7138 17.3736 29.5612 17.5691Z\" fill=\"#EA541E\"/>\n<path id=\"Vector_10\" d=\"M33.0949 16.8515C33.2984 16.6855 33.5233 16.6052 33.7643 16.6052C34.107 16.6052 34.439 16.7498 34.6585 16.9908C34.8834 17.2317 34.9771 17.5423 34.9771 18.0376V19.5798H34.2355V18.0831C34.2355 17.7645 34.1846 17.545 34.0909 17.4352C33.9972 17.3335 33.866 17.2826 33.7054 17.2826C33.4938 17.2826 33.3359 17.3469 33.2261 17.4781C33.1377 17.5878 33.0949 17.8047 33.0949 18.1394V19.5798H32.3533V16.6989H33.0949V16.8515Z\" fill=\"#EA541E\"/>\n<path id=\"Vector_11\" d=\"M36.4314 15.4031C36.5198 15.4968 36.5626 15.5985 36.5626 15.7217C36.5626 15.8448 36.5198 15.9546 36.4314 16.0483C36.3377 16.1367 36.236 16.1795 36.1048 16.1795C35.9736 16.1795 35.8638 16.1367 35.7781 16.0483C35.6844 15.96 35.6389 15.8529 35.6389 15.7217C35.6389 15.5985 35.6818 15.4887 35.7781 15.4031C35.8719 15.3147 35.9816 15.2719 36.1128 15.2719C36.2279 15.2665 36.335 15.3174 36.4314 15.4031Z\" fill=\"#EA541E\"/>\n<path id=\"Vector_12\" d=\"M40.0001 19.5771H39.2584V19.3951C39.0121 19.5852 38.7578 19.6708 38.4873 19.6708C38.0375 19.6708 37.6654 19.5048 37.3682 19.1702C37.1058 18.8783 36.9746 18.5383 36.9746 18.1367C36.9746 17.6708 37.1406 17.2933 37.4753 16.9881C37.7671 16.7337 38.0991 16.6025 38.4847 16.6025C38.7524 16.6025 39.0148 16.6962 39.2558 16.8783V16.6962H39.9974V19.5771H40.0001ZM37.8983 17.5691C37.7832 17.7137 37.7243 17.9038 37.7243 18.1367C37.7243 18.4044 37.7966 18.624 37.9572 18.7766C38.1098 18.9212 38.2839 19.0015 38.5034 19.0015C38.7578 19.0015 38.9532 18.8997 39.1058 18.7043C39.2156 18.5517 39.2718 18.3616 39.2718 18.1313C39.2718 17.8689 39.1995 17.6601 39.0469 17.4995C38.9023 17.3469 38.7203 17.2746 38.4954 17.2746C38.2491 17.2799 38.0509 17.3736 37.8983 17.5691Z\" fill=\"#EA541E\"/>\n<path id=\"Vector_13\" d=\"M35.7246 16.699V19.7003C35.7246 19.8101 35.6737 20.3242 34.9963 20.3616V21.0738C34.9963 21.0738 36.3993 21.0524 36.4582 19.7592V16.699H35.7246Z\" fill=\"#EA541E\"/>\n</g>\n</g>\n</g>\n</g>\n</g>\n<defs>\n<linearGradient id=\"paint0_linear_201_1235\" x1=\"8.00086\" y1=\"14.5495\" x2=\"12.6459\" y2=\"14.5495\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#F59C26\" stop-opacity=\"0\"/>\n<stop offset=\"0.0583\" stop-color=\"#F28F25\" stop-opacity=\"0.0626\"/>\n<stop offset=\"0.2406\" stop-color=\"#ED6C21\" stop-opacity=\"0.2585\"/>\n<stop offset=\"0.4217\" stop-color=\"#E94D1E\" stop-opacity=\"0.4531\"/>\n<stop offset=\"0.599\" stop-color=\"#E5371E\" stop-opacity=\"0.6436\"/>\n<stop offset=\"0.7708\" stop-color=\"#E32C1E\" stop-opacity=\"0.8281\"/>\n<stop offset=\"0.9307\" stop-color=\"#E2271D\"/>\n</linearGradient>\n</defs>\n</svg>";

var NoneColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=None, Color=On\">\n<g id=\"planes-gobierno_24\">\n<path id=\"icon-fill\" d=\"M28.7917 7.42847C30.7021 7.42847 31.3949 7.62738 32.0933 8.00089C32.7917 8.37441 33.3398 8.92253 33.7134 9.62094C34.0869 10.3194 34.2858 11.0121 34.2858 12.9225V19.0773C34.2858 20.9877 34.0869 21.6804 33.7134 22.3788C33.3398 23.0773 32.7917 23.6254 32.0933 23.9989C31.3949 24.3724 30.7021 24.5713 28.7917 24.5713H19.2084C17.298 24.5713 16.6052 24.3724 15.9068 23.9989C15.2084 23.6254 14.6603 23.0773 14.2868 22.3788C13.9133 21.6804 13.7144 20.9877 13.7144 19.0773V12.9225C13.7144 11.0121 13.9133 10.3194 14.2868 9.62094C14.6603 8.92253 15.2084 8.37441 15.9068 8.00089C16.6052 7.62738 17.298 7.42847 19.2084 7.42847H28.7917ZM32.5706 15.1428H15.4278L15.4286 19.5606C15.4286 20.7069 15.548 21.1225 15.7721 21.5416C15.9962 21.9606 16.3251 22.2895 16.7441 22.5136C17.137 22.7237 17.5269 22.8417 18.5185 22.8556L18.7251 22.857H29.2751C30.4213 22.857 30.837 22.7377 31.256 22.5136C31.6751 22.2895 32.0039 21.9606 32.228 21.5416C32.4381 21.1487 32.5562 20.7588 32.5701 19.7671L32.5715 19.5606L32.5706 15.1428ZM19.4961 17.7142C19.8501 17.7142 19.9933 17.754 20.133 17.8287C20.2727 17.9034 20.3823 18.013 20.457 18.1527C20.5317 18.2924 20.5715 18.4356 20.5715 18.7896V19.2102C20.5715 19.5642 20.5317 19.7074 20.457 19.8471C20.3823 19.9868 20.2727 20.0964 20.133 20.1711C19.9933 20.2458 19.8501 20.2856 19.4961 20.2856H19.0754C18.7215 20.2856 18.5782 20.2458 18.4386 20.1711C18.2989 20.0964 18.1893 19.9868 18.1146 19.8471C18.0399 19.7074 18.0001 19.5642 18.0001 19.2102V18.7896C18.0001 18.4356 18.0399 18.2924 18.1146 18.1527C18.1893 18.013 18.2989 17.9034 18.4386 17.8287C18.5782 17.754 18.7215 17.7142 19.0754 17.7142H19.4961ZM29.2751 9.14275H18.7251C17.5788 9.14275 17.1632 9.2621 16.7441 9.48621C16.3251 9.71032 15.9962 10.0392 15.7721 10.4582C15.562 10.8511 15.444 11.241 15.43 12.2326L15.4286 12.4392L15.4278 12.5713H32.5706L32.5715 12.4392C32.5715 11.2929 32.4521 10.8773 32.228 10.4582C32.0039 10.0392 31.6751 9.71032 31.256 9.48621C30.8632 9.27611 30.4733 9.15808 29.4816 9.14415L29.2751 9.14275Z\" fill=\"#373E45\"/>\n</g>\n</g>\n</svg>";

var TodoPagoColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Todopago, Color=On\">\n<g id=\"Todopago\">\n<g id=\"Header/desktop Copy\">\n<g id=\"Varios/color/logo TodoPago color\">\n<path id=\"TODO PAGO\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M33.4596 15.93C34.1675 15.93 34.635 16.0914 35.0557 16.3873C35.1559 16.4613 35.2694 16.6026 35.2694 16.8044C35.2694 17.0869 35.0423 17.3156 34.7619 17.3156C34.6149 17.3156 34.5214 17.2618 34.448 17.208C34.1675 17.0061 33.867 16.8851 33.4262 16.8851C32.6783 16.8851 32.0839 17.551 32.0839 18.3514V18.3649C32.0839 19.2259 32.6716 19.8581 33.4997 19.8581C33.8736 19.8581 34.2076 19.7639 34.4681 19.5756V18.9029H33.6033C33.3562 18.9029 33.1559 18.7079 33.1559 18.459C33.1559 18.2102 33.3562 18.0084 33.6033 18.0084H34.9488C35.236 18.0084 35.463 18.2371 35.463 18.5263V19.6698C35.463 19.9725 35.3495 20.181 35.1024 20.3289C34.7218 20.5644 34.1675 20.7998 33.4663 20.7998C32.0105 20.7998 31.0088 19.7707 31.0088 18.3783V18.3649C31.0088 17.0263 32.0438 15.93 33.4596 15.93ZM38.5225 15.93C39.9649 15.93 41.0001 17.0129 41.0001 18.3514V18.3649C41.0001 19.7034 39.9516 20.7998 38.5091 20.7998C37.0666 20.7998 36.0316 19.7168 36.0316 18.3783V18.3649C36.0316 17.0263 37.08 15.93 38.5225 15.93ZM24.1993 16.0106C25.3145 16.0106 25.9891 16.6766 25.9891 17.6384V17.6519C25.9891 18.7415 25.1476 19.3066 24.0991 19.3066H23.3178V20.2415C23.3178 20.5308 23.0907 20.7595 22.8036 20.7595C22.5164 20.7595 22.2894 20.5308 22.2894 20.2415V16.5286C22.2894 16.2394 22.5164 16.0106 22.8036 16.0106H24.1993ZM28.4253 15.9367C28.7058 15.9367 28.9061 16.0914 29.0197 16.347L30.6491 20.0532C30.6825 20.1272 30.7025 20.1944 30.7025 20.2617C30.7025 20.5375 30.4889 20.7594 30.215 20.7594C29.9746 20.7594 29.8144 20.6182 29.7208 20.403L29.407 19.6631H27.3501L27.0229 20.4365C26.936 20.6384 26.7624 20.7594 26.5487 20.7594C26.2816 20.7594 26.0746 20.5442 26.0746 20.2751C26.0746 20.2011 26.1013 20.1272 26.1347 20.0532L27.7642 16.347C27.8777 16.0914 28.0847 15.9367 28.3652 15.9367H28.4253ZM38.5091 16.8851C37.681 16.8851 37.1067 17.5443 37.1067 18.3514V18.3649C37.1067 19.172 37.6944 19.8446 38.5225 19.8446C39.3506 19.8446 39.9249 19.1855 39.9249 18.3783V18.3649C39.9249 17.5577 39.3372 16.8851 38.5091 16.8851ZM28.3786 17.1945L27.7308 18.7482H29.0263L28.3786 17.1945ZM24.1125 16.9456H23.3178V18.385H24.1325C24.6468 18.385 24.9472 18.0756 24.9472 17.6721V17.6586C24.9472 17.1945 24.6267 16.9456 24.1125 16.9456ZM28.2249 10.2732C29.6674 10.2732 30.7025 11.3561 30.7025 12.6946V12.7081C30.7025 14.0466 29.6541 15.143 28.2116 15.143C26.7691 15.143 25.734 14.06 25.734 12.7215V12.7081C25.734 11.3695 26.7825 10.2732 28.2249 10.2732ZM38.5225 10.2732C39.9649 10.2732 41.0001 11.3561 41.0001 12.6946V12.7081C41.0001 14.0466 39.9516 15.143 38.5091 15.143C37.0667 15.143 36.0316 14.06 36.0316 12.7215V12.7081C36.0316 11.3695 37.08 10.2732 38.5225 10.2732ZM25.4056 10.3539C25.6661 10.3539 25.8798 10.5691 25.8798 10.8315C25.8798 11.0937 25.6661 11.309 25.4056 11.309H24.3316V14.5847C24.3316 14.874 24.1045 15.1026 23.8174 15.1026C23.5301 15.1026 23.3031 14.874 23.3031 14.5847V11.309H22.1897C21.9293 11.309 21.7156 11.0937 21.7156 10.8315C21.7156 10.5691 21.9293 10.3539 22.1897 10.3539H25.4056ZM33.099 10.3539C34.5682 10.3539 35.5833 11.3695 35.5833 12.6946V12.7081C35.5833 14.0331 34.5682 15.0622 33.099 15.0622H31.7901C31.5029 15.0622 31.2759 14.8335 31.2759 14.5443V10.8718C31.2759 10.5825 31.5029 10.3539 31.7901 10.3539H33.099ZM28.2116 11.2283C27.3835 11.2283 26.8092 11.8875 26.8092 12.6946V12.7081C26.8092 13.5152 27.3968 14.1878 28.2249 14.1878C29.0531 14.1878 29.6274 13.5286 29.6274 12.7215V12.7081C29.6274 11.9009 29.0396 11.2283 28.2116 11.2283ZM38.5091 11.2283C37.681 11.2283 37.1067 11.8875 37.1067 12.6946V12.7081C37.1067 13.5152 37.6944 14.1878 38.5225 14.1878C39.3506 14.1878 39.9249 13.5286 39.9249 12.7215V12.7081C39.9249 11.9009 39.3372 11.2283 38.5091 11.2283ZM33.099 11.2888H32.3043V14.1273H33.099C33.9404 14.1273 34.5081 13.5555 34.5081 12.7216V12.7081C34.5081 11.874 33.9404 11.2888 33.099 11.2888Z\" fill=\"#323E48\"/>\n<g id=\"Varios/color/logo TodoPago iso color\">\n<path id=\"fondo\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.31239 9H18.8115C19.5364 9 20.1239 9.59181 20.1239 10.3219V20.8967C20.1239 21.6267 19.5364 22.2185 18.8115 22.2185H8.31239C7.58758 22.2185 7 21.6267 7 20.8967V10.3219C7 9.59181 7.58758 9 8.31239 9Z\" fill=\"#DA167B\"/>\n<path id=\"TP\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.0311 12.2085H9.26424C8.90226 12.2085 8.60522 12.5077 8.60522 12.8723C8.60522 13.2368 8.90226 13.536 9.26424 13.536H10.8117V18.2902C10.8117 18.6923 11.1273 19.0101 11.5264 19.0101C11.9255 19.0101 12.2411 18.6923 12.2411 18.2902V13.9908L11.8946 13.6846C11.8106 13.623 11.8209 13.5353 11.9348 13.5353H15.9104C16.6252 13.5353 17.0707 13.8538 17.0707 14.4989V14.5176C17.0707 15.0785 16.653 15.5051 15.9383 15.5051H14.6598C14.0302 15.5051 13.6187 15.9223 13.6187 16.4466V18.2902C13.6187 18.6923 13.9343 19.0101 14.3334 19.0101C14.7325 19.0101 15.0481 18.6923 15.0481 18.2902V17.2428L14.6764 16.912C14.6255 16.8654 14.6479 16.7893 14.7212 16.7893C14.7424 16.7893 15.8919 16.7893 15.8919 16.7893C17.3491 16.7893 18.5186 16.004 18.5186 14.4896V14.4709C18.5186 13.134 17.5812 12.2085 16.0311 12.2085Z\" fill=\"white\"/>\n</g>\n</g>\n</g>\n</g>\n</g>\n</svg>";

var UnionPayColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Unionpay, Color=On\">\n<g id=\"Unionpay\">\n<path id=\"Vector\" d=\"M14.8769 7H22.364C23.4098 7 24.0603 7.85457 23.818 8.90046L20.3317 23.8661C20.0851 24.912 19.035 25.7665 17.9933 25.7665H10.502C9.45612 25.7665 8.80563 24.912 9.05222 23.8661L12.5385 8.90046C12.7809 7.85457 13.8268 7 14.8769 7Z\" fill=\"#E52628\"/>\n<path id=\"Vector_2\" d=\"M21.7438 7H30.3533C31.3992 7 30.9273 7.85457 30.6807 8.90046L27.1944 23.8661C26.952 24.912 27.0286 25.7665 25.9784 25.7665H17.369C16.3231 25.7665 15.6726 24.912 15.9192 23.8661L19.4012 8.90046C19.6521 7.85457 20.6937 7 21.7438 7Z\" fill=\"#213460\"/>\n<path id=\"Vector_3\" d=\"M30.0081 7H37.4952C38.5411 7 39.1916 7.85457 38.9492 8.90046L35.4629 23.8661C35.2163 24.912 34.1705 25.7665 33.1203 25.7665H25.6375C24.5916 25.7665 23.9411 24.912 24.1835 23.8661L27.6698 8.90046C27.9164 7.85457 28.9623 7 30.0081 7Z\" fill=\"#056C67\"/>\n<path id=\"Vector_4\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M28.7589 21.0812H29.4646L29.6687 20.4052H28.9629L28.7589 21.0812ZM29.3243 19.2105L29.082 20.0141C29.082 20.0141 29.3498 19.878 29.4944 19.8312C29.6389 19.7972 29.86 19.7717 29.86 19.7717L30.0343 19.2105H29.3243ZM29.6772 18.0541L29.4434 18.8236C29.4434 18.8236 29.707 18.7046 29.8515 18.6663C30.0003 18.628 30.2129 18.6153 30.2129 18.6153L30.383 18.0541H29.6772V18.0541ZM31.2375 18.0541L30.3234 21.0727H30.57L30.3787 21.6977H30.1364L30.0768 21.889H29.2095L29.269 21.6977H27.5046L27.6832 21.1195H27.8618L28.7886 18.0541L28.9714 17.4333H29.8558L29.7622 17.7437C29.7622 17.7437 30.0003 17.5737 30.2214 17.5184C30.4425 17.4589 31.7265 17.4376 31.7265 17.4376L31.5351 18.0541H31.2375Z\" fill=\"white\"/>\n<path id=\"Vector_5\" d=\"M31.6287 17.4377H32.5768L32.5853 17.7906C32.581 17.8501 32.632 17.8757 32.7426 17.8757H32.9339L32.7596 18.4581H32.2494C31.8072 18.4921 31.6414 18.3008 31.6499 18.0882L31.6287 17.4377Z\" fill=\"white\"/>\n<path id=\"Vector_6\" d=\"M31.7519 20.197H30.8506L31.0036 19.6783H32.0325L32.1813 19.2063H31.1609L31.3353 18.6196H34.1668L33.9883 19.2063H33.0402L32.8913 19.6783H33.8437L33.6864 20.197H32.6575L32.4747 20.4181H32.8913L32.9934 21.0685C33.0019 21.1323 33.0061 21.1748 33.0274 21.2046C33.0487 21.2301 33.172 21.2386 33.2485 21.2386H33.376L33.1847 21.8721H32.8616C32.8106 21.8721 32.7383 21.8721 32.6363 21.8636C32.5385 21.8551 32.4704 21.7998 32.4067 21.7658C32.3471 21.736 32.2579 21.668 32.2409 21.5447L32.1431 20.8942L31.6754 21.5362C31.5266 21.736 31.3268 21.8934 30.9824 21.8934H30.3276L30.4977 21.3279H30.7485C30.8208 21.3279 30.8846 21.2981 30.9314 21.2769C30.9824 21.2556 31.0249 21.2301 31.0717 21.1621L31.7519 20.197Z\" fill=\"white\"/>\n<path id=\"Vector_7\" d=\"M21.8793 18.7812H24.2644L24.0901 19.351H23.1377L22.9889 19.8356H23.9668L23.7882 20.4224H22.8146L22.5765 21.2089C22.551 21.2939 22.8061 21.3109 22.8997 21.3109L23.3886 21.2429L23.193 21.8934H22.0919C22.0026 21.8934 21.9388 21.8807 21.841 21.8594C21.7475 21.8381 21.7092 21.7956 21.6667 21.7319C21.6284 21.6681 21.5647 21.6128 21.6072 21.4768L21.9218 20.4309H21.3818L21.5604 19.8356H22.1046L22.2492 19.351H21.7092L21.8793 18.7812Z\" fill=\"white\"/>\n<path id=\"Vector_8\" d=\"M23.4863 17.7566H24.4642L24.2856 18.3518H22.9506L22.8018 18.4751C22.7423 18.5346 22.7168 18.5091 22.636 18.5559C22.5595 18.5941 22.4022 18.6664 22.1939 18.6664H21.7729L21.9473 18.0967H22.0791C22.1896 18.0967 22.2619 18.0882 22.3001 18.0627C22.3427 18.0372 22.3894 17.9777 22.4447 17.8756L22.6913 17.4292H23.6649L23.4863 17.7566Z\" fill=\"white\"/>\n<path id=\"Vector_9\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M25.3657 18.7343C25.3657 18.7343 25.6335 18.492 26.0885 18.4112C26.1905 18.39 26.8453 18.3985 26.8453 18.3985L26.943 18.0711H25.5655L25.3657 18.7343ZM26.6582 18.9852H25.2934L25.2084 19.2615H26.3946C26.5349 19.2445 26.5646 19.2658 26.5774 19.2573L26.6582 18.9852ZM24.8853 17.4376H25.7186L25.5995 17.8585C25.5995 17.8585 25.8631 17.6502 26.046 17.5737C26.2288 17.5056 26.6454 17.4419 26.6454 17.4419L27.9932 17.4333L27.534 18.9639C27.4575 19.2275 27.3682 19.3976 27.3087 19.4741C27.2577 19.5506 27.1981 19.6187 27.0791 19.6824C26.9643 19.742 26.8623 19.776 26.7645 19.7887C26.6752 19.7972 26.5391 19.7972 26.3478 19.7972H25.0468L24.6812 21.0089C24.6472 21.128 24.6302 21.1875 24.6557 21.2173C24.6727 21.247 24.7195 21.2768 24.779 21.2768L25.3529 21.2215L25.1574 21.889H24.5154C24.3113 21.889 24.1625 21.8848 24.0605 21.8763C23.9627 21.8678 23.8564 21.8763 23.7883 21.8252C23.7288 21.7742 23.6353 21.7062 23.6395 21.6339C23.648 21.5659 23.6736 21.4596 23.7161 21.3108L24.8853 17.4376Z\" fill=\"white\"/>\n<path id=\"Vector_10\" d=\"M27.3177 19.9078L27.2412 20.2735C27.2072 20.3882 27.1774 20.4733 27.0924 20.5498C27.0031 20.6263 26.8926 20.7071 26.6417 20.7071L26.1783 20.7241L26.174 21.1408C26.1655 21.2598 26.1995 21.2471 26.2166 21.2683C26.2378 21.2896 26.2548 21.2981 26.2761 21.3066L26.4249 21.2981L26.867 21.2726L26.6842 21.8806H26.174C25.8169 21.8806 25.5533 21.8721 25.4683 21.804C25.3832 21.753 25.3705 21.6807 25.3747 21.5659L25.4087 19.9418H26.2208L26.208 20.2735H26.4079C26.4759 20.2735 26.5184 20.265 26.5482 20.2479C26.5737 20.2309 26.5907 20.2054 26.6034 20.1629L26.6842 19.9036L27.3177 19.9078Z\" fill=\"white\"/>\n<path id=\"Vector_11\" d=\"M15.7659 11.7829C15.7362 11.9147 15.2175 14.3126 15.2132 14.3126C15.1027 14.7973 15.0219 15.1459 14.7455 15.367C14.5882 15.4946 14.4054 15.5583 14.1928 15.5583C13.8527 15.5583 13.6529 15.3883 13.6189 15.0651L13.6104 14.9546C13.6104 14.9546 13.7124 14.3041 13.7124 14.2999C13.7124 14.2999 14.2566 12.1145 14.3544 11.8254C14.3586 11.8084 14.3629 11.7999 14.3629 11.7914C13.3 11.7999 13.1129 11.7914 13.1002 11.7744C13.0917 11.7957 13.0662 11.9317 13.0662 11.9317L12.5092 14.3934L12.4582 14.606L12.3689 15.2905C12.3689 15.4903 12.4072 15.6561 12.4879 15.7964C12.743 16.2386 13.4658 16.3066 13.874 16.3066C14.4012 16.3066 14.8943 16.1961 15.2302 15.9877C15.8084 15.6434 15.9657 15.1077 16.0975 14.6315L16.1613 14.3891C16.1613 14.3891 16.7225 12.1188 16.8203 11.8212C16.8203 11.8042 16.8246 11.7957 16.8288 11.7872C16.0635 11.8084 15.8382 11.7999 15.7659 11.7829Z\" fill=\"white\"/>\n<path id=\"Vector_12\" d=\"M18.8696 16.2854C18.4955 16.2811 18.3594 16.2811 17.9215 16.3024L17.9045 16.2684C17.9428 16.1026 17.9853 15.9368 18.0235 15.7667L18.0788 15.5414C18.1596 15.1842 18.2404 14.7718 18.2489 14.6443C18.2574 14.5678 18.2829 14.3807 18.0661 14.3807C17.9725 14.3807 17.879 14.4232 17.7812 14.4657C17.7302 14.657 17.6196 15.1885 17.5686 15.4308C17.4581 15.941 17.4538 16.0005 17.4028 16.2514L17.3688 16.2854C16.9819 16.2811 16.8458 16.2811 16.3994 16.3024L16.3782 16.2641C16.4547 15.9623 16.527 15.6519 16.5993 15.35C16.7863 14.5252 16.8288 14.2106 16.8841 13.794L16.9181 13.7685C17.3518 13.7089 17.4581 13.6962 17.93 13.5984L17.9683 13.6452L17.896 13.9045C17.9768 13.8577 18.0533 13.811 18.1341 13.7642C18.3552 13.6579 18.6018 13.6239 18.7378 13.6239C18.9461 13.6239 19.1715 13.6792 19.265 13.9215C19.3543 14.1341 19.2948 14.3977 19.18 14.9121L19.1204 15.1757C19.0014 15.7497 18.9801 15.856 18.9121 16.2514L18.8696 16.2854Z\" fill=\"white\"/>\n<path id=\"Vector_13\" d=\"M20.4002 16.2854C20.1749 16.2854 20.0261 16.2812 19.8858 16.2854C19.7455 16.2854 19.6052 16.2939 19.3968 16.3024L19.3841 16.2854L19.3713 16.2684C19.4266 16.0516 19.4606 15.975 19.4904 15.8985C19.5201 15.822 19.5457 15.7412 19.5967 15.5244C19.6604 15.2395 19.703 15.0354 19.7327 14.8569C19.7625 14.6868 19.7795 14.538 19.8007 14.3722L19.8178 14.3594L19.8348 14.3424C20.0601 14.3127 20.2046 14.2914 20.3492 14.2659C20.498 14.2446 20.6468 14.2149 20.8807 14.1724L20.8892 14.1936L20.8977 14.2106C20.8551 14.3892 20.8126 14.5678 20.7701 14.7506C20.7276 14.9334 20.6851 15.112 20.6468 15.2863C20.5618 15.6647 20.5278 15.805 20.5065 15.907C20.4853 16.0005 20.481 16.0558 20.447 16.2514L20.4257 16.2684L20.4002 16.2854Z\" fill=\"white\"/>\n<path id=\"Vector_14\" d=\"M22.7975 14.9504C22.7763 15.0439 22.6955 15.4095 22.5764 15.5626C22.4957 15.6774 22.4021 15.7454 22.2916 15.7454C22.2618 15.7454 22.0747 15.7454 22.0747 15.4691C22.0747 15.333 22.1003 15.1927 22.1343 15.0439C22.2321 14.6017 22.3511 14.2361 22.6487 14.2361C22.8826 14.2361 22.8996 14.5082 22.7975 14.9504ZM23.7839 14.9886C23.9157 14.4104 23.8136 14.1426 23.6861 13.9725C23.4863 13.7216 23.1419 13.6409 22.7848 13.6409C22.5679 13.6409 22.0535 13.6621 21.6538 14.032C21.369 14.2999 21.2329 14.6613 21.1522 15.0099C21.0714 15.3628 20.9778 16.0048 21.5646 16.2386C21.7474 16.3151 22.0067 16.3364 22.1768 16.3364C22.6105 16.3364 23.0484 16.2173 23.38 15.8687C23.6266 15.5881 23.7414 15.1629 23.7839 14.9886Z\" fill=\"white\"/>\n<path id=\"Vector_15\" d=\"M32.9887 16.3279C32.5338 16.3236 32.402 16.3236 31.9811 16.3407L31.9556 16.3066C32.0704 15.873 32.1852 15.4436 32.2872 15.0099C32.419 14.4444 32.4487 14.2021 32.4913 13.8705L32.5253 13.8407C32.9759 13.7769 33.0992 13.7599 33.5712 13.6707L33.5882 13.7089C33.5031 14.0618 33.4139 14.4189 33.3331 14.7761C33.1588 15.5201 33.095 15.9027 33.0312 16.2939L32.9887 16.3279Z\" fill=\"white\"/>\n<path id=\"Vector_16\" d=\"M32.3086 15.0014C32.2831 15.095 32.2023 15.4606 32.0833 15.6137C32.0068 15.7242 31.8239 15.788 31.7177 15.788C31.6879 15.788 31.5051 15.788 31.4966 15.5159C31.4966 15.3798 31.5221 15.2395 31.5561 15.0865C31.6539 14.657 31.7729 14.2914 32.0705 14.2914C32.3086 14.2914 32.4064 14.5593 32.3086 15.0014ZM33.2057 15.0439C33.3375 14.4657 32.8061 14.9929 32.721 14.8016C32.5935 14.5082 32.6743 13.9045 32.1513 13.7047C31.9515 13.6282 31.4753 13.7302 31.0757 14.1001C30.7908 14.3637 30.6505 14.7251 30.574 15.0695C30.4932 15.4181 30.3997 16.0558 30.9821 16.2854C31.1692 16.3619 31.335 16.3874 31.5051 16.3789C32.0918 16.3449 32.5382 15.4606 32.8698 15.1077C33.1207 14.8271 33.1675 15.214 33.2057 15.0439Z\" fill=\"white\"/>\n<path id=\"Vector_17\" d=\"M26.3518 16.2854C25.9734 16.2811 25.8458 16.2811 25.4037 16.3024L25.3867 16.2684C25.4249 16.1026 25.4632 15.9368 25.5057 15.7667L25.5567 15.5414C25.6375 15.1842 25.7183 14.7718 25.7268 14.6443C25.7353 14.5678 25.7608 14.3807 25.544 14.3807C25.4504 14.3807 25.3569 14.4232 25.2591 14.4657C25.2081 14.657 25.0976 15.1885 25.0465 15.4308C24.9403 15.941 24.936 16.0005 24.885 16.2514L24.851 16.2854C24.4641 16.2811 24.328 16.2811 23.8816 16.3024L23.8604 16.2641C23.9369 15.9623 24.0092 15.6519 24.0772 15.35C24.2642 14.5252 24.3068 14.2106 24.362 13.794L24.396 13.7685C24.8297 13.7089 24.936 13.6962 25.4079 13.5984L25.4462 13.6452L25.3782 13.9045C25.4547 13.8577 25.5355 13.811 25.612 13.7642C25.8331 13.6579 26.0839 13.6239 26.2157 13.6239C26.4198 13.6239 26.6494 13.6792 26.7429 13.9215C26.8322 14.1341 26.7727 14.3977 26.6536 14.9121L26.5941 15.1757C26.4708 15.7497 26.4538 15.856 26.3858 16.2514L26.3518 16.2854Z\" fill=\"white\"/>\n<path id=\"Vector_18\" d=\"M29.6175 11.7787L29.3072 11.7829C28.4951 11.7914 28.1677 11.7914 28.0317 11.7744C28.0189 11.8339 27.9977 11.9402 27.9977 11.9402L27.7086 13.2922C27.7086 13.2922 27.0113 16.1663 26.9773 16.3024C27.6873 16.2939 27.9807 16.2939 28.0997 16.3066C28.1295 16.1706 28.2953 15.3713 28.2953 15.3713C28.2953 15.3713 28.4356 14.7845 28.4441 14.759C28.4441 14.759 28.4866 14.6995 28.5334 14.674H28.5972C29.2094 14.674 29.9024 14.674 30.4466 14.2744C30.8165 13.998 31.0673 13.5983 31.1821 13.1052C31.2119 12.9861 31.2331 12.8373 31.2331 12.697C31.2331 12.5099 31.1991 12.3229 31.0843 12.1783C30.8037 11.7872 30.2553 11.7829 29.6175 11.7787ZM30.0257 13.1859C29.9577 13.4878 29.7663 13.7386 29.5155 13.8619C29.3072 13.964 29.0563 13.9725 28.797 13.9725H28.6312L28.6439 13.9045L28.9543 12.5567L28.9585 12.4929L28.967 12.4419L29.0903 12.4547C29.0903 12.4547 29.7281 12.5099 29.7451 12.5099C29.9959 12.6035 30.098 12.8586 30.0257 13.1859Z\" fill=\"white\"/>\n<path id=\"Vector_19\" d=\"M36.7089 13.6664L36.6749 13.6282C36.2072 13.7217 36.1264 13.7387 35.697 13.794L35.6673 13.828C35.6673 13.8323 35.663 13.8408 35.663 13.8493V13.8408C35.3441 14.5763 35.3527 14.419 35.0933 14.9972C35.0933 14.9717 35.0933 14.9547 35.0891 14.9249L35.0253 13.6707L34.9828 13.6324C34.4981 13.726 34.4853 13.743 34.0347 13.7982L34.0006 13.8323C33.9964 13.8493 33.9964 13.8663 33.9964 13.8833V13.8918C34.0517 14.1766 34.0389 14.1129 34.0942 14.5678C34.1197 14.7931 34.1537 15.0142 34.1792 15.2353C34.2217 15.6009 34.2472 15.7837 34.3025 16.3449C34.0006 16.8466 33.9241 17.0379 33.635 17.4759L33.652 17.5184C34.0899 17.5014 34.192 17.5014 34.5193 17.5014L34.5916 17.4206C34.8382 16.8764 36.7089 13.6664 36.7089 13.6664Z\" fill=\"white\"/>\n<path id=\"Vector_20\" d=\"M20.8122 13.9768C21.063 13.8025 21.0928 13.5601 20.8802 13.4411C20.6676 13.3136 20.2977 13.3561 20.0469 13.5261C19.796 13.6962 19.7663 13.9385 19.9789 14.0618C20.1914 14.1894 20.5613 14.1511 20.8122 13.9768Z\" fill=\"white\"/>\n<path id=\"Vector_21\" d=\"M34.5574 17.4504L34.1917 18.0754C34.0727 18.2923 33.8644 18.4496 33.52 18.4538L32.9375 18.4453L33.1076 17.8841H33.2224C33.2819 17.8841 33.3244 17.8799 33.3584 17.8628C33.3882 17.8543 33.4094 17.8288 33.4349 17.7948L33.6518 17.4547H34.5574V17.4504Z\" fill=\"white\"/>\n</g>\n</g>\n</svg>";

var VisaColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Visa, Color=On\">\n<g id=\"Visa\">\n<path id=\"Vector\" d=\"M19.4238 10.1988L14.4495 22.1217H11.202L8.75842 12.608C8.60792 12.0236 8.47723 11.801 8.02574 11.5545C7.29307 11.1569 6.06931 10.7713 5 10.5367L5.07129 10.1988H10.299C10.9644 10.1988 11.5663 10.6441 11.7208 11.4153L13.0119 18.313L16.204 10.2028H19.4238V10.1988ZM32.1485 18.2296C32.1604 15.0848 27.8158 14.9099 27.8396 13.5065C27.8515 13.0732 28.2594 12.6199 29.1426 12.5126C29.5861 12.453 30.7941 12.4092 32.1683 13.0493L32.703 10.5248C31.9584 10.2544 31.0158 10 29.8277 10C26.7901 10 24.6594 11.626 24.6356 13.9398C24.6119 15.6573 26.1604 16.6154 27.3248 17.1879C28.5248 17.7724 28.9208 18.1461 28.9208 18.6708C28.9089 19.4779 27.9663 19.8278 27.0792 19.8397C25.5307 19.8635 24.6475 19.4183 23.9228 19.0923L23.3644 21.7003C24.0851 22.0263 25.4 22.3205 26.7743 22.3324C30.0297 22.3085 32.1366 20.7064 32.1485 18.2296ZM40.1604 22.1217H43L40.5208 10.1988H37.903C37.3089 10.1988 36.8218 10.5367 36.6 11.0734L31.9861 22.1217H35.2099L35.8515 20.3446H39.8L40.1604 22.1217ZM36.7347 17.9036L38.3545 13.427L39.2852 17.9036H36.7347ZM23.8119 10.1988L21.2733 22.1217H18.2L20.7386 10.1988H23.8119Z\" fill=\"url(#paint0_linear_201_826)\"/>\n</g>\n</g>\n<defs>\n<linearGradient id=\"paint0_linear_201_826\" x1=\"8.91794\" y1=\"21.9803\" x2=\"40.4075\" y2=\"9.94885\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#262955\"/>\n<stop offset=\"1\" stop-color=\"#233984\"/>\n</linearGradient>\n</defs>\n</svg>";

var VisaDebitoColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Visa_Debito, Color=On\">\n<g id=\"Visa_Debito\">\n<g id=\"Group\">\n<path id=\"Vector\" d=\"M20.1837 19.3514C20.5702 19.2919 21.0289 19.241 21.5343 19.241C22.439 19.241 23.0931 19.4576 23.5136 19.8568C23.9468 20.2561 24.2144 20.821 24.2144 21.6195C24.2144 22.418 23.9596 23.0806 23.5009 23.5138C23.0294 23.9725 22.2819 24.2146 21.3262 24.2146C20.8675 24.2146 20.4937 24.1891 20.1794 24.1551L20.1837 19.3514ZM20.825 23.6879C20.9822 23.7134 21.2243 23.7134 21.4664 23.7134C22.8298 23.7134 23.5561 22.9659 23.5561 21.6365C23.5688 20.4769 22.9147 19.7422 21.5768 19.7422C21.2498 19.7422 20.9992 19.7676 20.842 19.8016L20.825 23.6879Z\" fill=\"#1C3459\"/>\n<path id=\"Vector_2\" d=\"M25.5822 22.5411C25.5949 23.4118 26.1386 23.7601 26.7884 23.7601C27.2471 23.7601 27.5359 23.6879 27.7653 23.5774L27.8842 24.0362C27.6549 24.1466 27.2684 24.2655 26.6992 24.2655C25.6119 24.2655 24.9621 23.5392 24.9748 22.4774C24.9748 21.4155 25.6034 20.5958 26.627 20.5958C27.7865 20.5958 28.0754 21.5982 28.0754 22.248C28.0754 22.3797 28.0754 22.4774 28.0499 22.5496L25.5822 22.5411ZM27.451 22.0951C27.4637 21.6959 27.2811 21.0588 26.5591 21.0588C25.905 21.0588 25.6289 21.6491 25.5822 22.0951H27.451ZM27.6081 19.1475L26.7162 20.1838H26.2702L26.9116 19.1475H27.6081Z\" fill=\"#1C3459\"/>\n<path id=\"Vector_3\" d=\"M29.0563 19.0286H29.6976V21.2372H29.7104C29.9397 20.8507 30.3517 20.5958 30.9039 20.5958C31.7873 20.5958 32.399 21.3221 32.399 22.384C32.399 23.6412 31.592 24.2655 30.8189 24.2655C30.3135 24.2655 29.9015 24.0744 29.6339 23.603H29.6212L29.583 24.1806H29.0393C29.052 23.9385 29.0775 23.5902 29.0775 23.2759L29.0563 19.0286ZM29.6849 22.7832C29.6849 22.8682 29.6976 22.9404 29.7104 23.0126C29.8293 23.4585 30.2073 23.7601 30.6745 23.7601C31.3499 23.7601 31.7491 23.2164 31.7491 22.4094C31.7491 21.6959 31.3881 21.0928 30.7 21.0928C30.2668 21.0928 29.8675 21.3943 29.7359 21.8785C29.7104 21.9635 29.6976 22.0484 29.6976 22.1461V22.7875H29.6849V22.7832Z\" fill=\"#1C3459\"/>\n<path id=\"Vector_4\" d=\"M34.081 19.6912C34.081 19.9079 33.9366 20.0905 33.669 20.0905C33.4396 20.0905 33.2825 19.9079 33.2825 19.6912C33.2825 19.4746 33.4396 19.292 33.6817 19.292C33.9238 19.292 34.081 19.4619 34.081 19.6912ZM33.3674 24.2062V20.6809H34.0088V24.2062H33.3674V24.2062Z\" fill=\"#1C3459\"/>\n<path id=\"Vector_5\" d=\"M36.0348 19.8357V20.6809H36.9522V21.1651H36.0348V23.0594C36.0348 23.4927 36.1537 23.7475 36.519 23.7475C36.6889 23.7475 36.7951 23.7348 36.8928 23.7008L36.9183 24.1977C36.7993 24.2444 36.5912 24.2827 36.3491 24.2827C36.0476 24.2827 35.8055 24.1722 35.6611 24.0066C35.4912 23.8155 35.4062 23.5012 35.4062 23.0764V21.1524H34.8625V20.6682H35.4062V20.0183L36.0348 19.8357Z\" fill=\"#1C3459\"/>\n<path id=\"Vector_6\" d=\"M40.9872 22.418C40.9872 23.7219 40.0698 24.291 39.2246 24.291C38.2817 24.291 37.5469 23.5902 37.5469 22.4817C37.5469 21.3094 38.3326 20.6213 39.2968 20.6213C40.3119 20.6213 40.9872 21.3561 40.9872 22.418ZM38.1967 22.4562C38.1967 23.2292 38.63 23.8068 39.2586 23.8068C39.8617 23.8068 40.3331 23.2377 40.3331 22.4434C40.3331 21.8403 40.0316 21.0928 39.284 21.0928C38.5365 21.0928 38.2095 21.7894 38.1967 22.4562Z\" fill=\"#1C3459\"/>\n</g>\n<g id=\"Group_2\">\n<path id=\"Vector_7\" d=\"M19.9204 7.19538L15.465 17.818H12.5683L10.3681 9.34453C10.2365 8.82636 10.1133 8.63098 9.7183 8.41437C9.05571 8.05334 7.96839 7.71355 7 7.50968L7.05946 7.19538H11.7315C12.3347 7.19538 12.8656 7.59463 12.9973 8.2827L14.1568 14.4286L17.0195 7.19538C17.0195 7.19538 19.9204 7.19538 19.9204 7.19538ZM31.3033 14.3522C31.316 11.5532 27.4297 11.396 27.451 10.1388C27.4637 9.75228 27.8247 9.35303 28.6232 9.24685C29.0225 9.20013 30.1098 9.14916 31.3288 9.7183L31.813 7.47146C31.1504 7.22936 30.3052 7 29.2433 7C26.525 7 24.618 8.44834 24.5967 10.5126C24.584 12.0458 25.9601 12.8911 27.0007 13.4092C28.0753 13.9274 28.4236 14.2672 28.4236 14.7259C28.4109 15.4395 27.5656 15.7538 26.7799 15.7623C25.391 15.7878 24.5925 15.3885 23.9554 15.0869L23.4585 17.4187C24.0998 17.7076 25.2933 17.9751 26.5123 17.9879C29.3962 17.9879 31.2906 16.5523 31.3033 14.3522ZM38.4643 17.818H41L38.7786 7.19538H36.4383C35.9074 7.19538 35.4742 7.49694 35.2661 7.98114L31.1504 17.8222H34.0343L34.6035 16.2422H38.1288L38.4643 17.818ZM35.4105 14.0506L36.8588 10.0666L37.6913 14.0506H35.4105ZM23.8407 7.19538L21.5726 17.818H18.8204L21.0884 7.19538H23.8407V7.19538Z\" fill=\"url(#paint0_linear_201_1064)\"/>\n</g>\n</g>\n</g>\n<defs>\n<linearGradient id=\"paint0_linear_201_1064\" x1=\"10.5252\" y1=\"17.6863\" x2=\"38.6596\" y2=\"6.89539\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#1E2D50\"/>\n<stop offset=\"1\" stop-color=\"#18407F\"/>\n</linearGradient>\n</defs>\n</svg>";

var AmexGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=American_Express, Color=Off\">\n<path id=\"Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M36.864 21.5305H27.6955L27.1188 20.7719V21.5305H25.1356V20.3343C24.8885 20.4335 24.606 20.4743 24.2882 20.4743H23.9587V21.513H21.0045L20.5573 20.8828L20.1277 21.513H15.3375V16.9323H20.1454L20.5926 17.545L21.0398 16.9323H37.9174V2H10.0294V13.227L10.9945 10.9862H12.9247L13.4308 12.13V10.9862H15.7906L16.1084 11.8965L16.4262 10.9862H26.6421V11.4122C27.0305 11.1146 27.519 10.9862 28.0663 10.9862H31.244L31.7501 12.13V10.9862H33.6509L34.21 11.844V10.9862H36.252V15.5669H34.2453L33.7274 14.7675V15.5669H30.8792L30.6085 14.8842H30.0024L29.7317 15.5669H27.9898C27.5425 15.5669 27.0247 15.4794 26.6245 15.1701V15.5669H23.7351L23.1466 14.8083V15.5669H12.5305L12.2598 14.8842H11.6536L11.3829 15.5669H10V29.6473H37.9115V21.2329C37.6408 21.4138 37.2759 21.5305 36.864 21.5305ZM36.8644 20.1301H35.1695V20.8596H36.8644C37.5823 20.8596 38.0001 20.4336 38.0001 19.8034C38.0001 19.2199 37.6235 18.8639 36.9762 18.8639H36.1994C36.0287 18.8639 35.8993 18.7472 35.8993 18.5955C35.8993 18.4438 36.017 18.3271 36.1994 18.3271H37.6235L37.953 17.5977H36.2288C35.5109 17.5977 35.093 18.0236 35.093 18.6247C35.093 19.2374 35.4932 19.5933 36.117 19.5933H36.8938C37.0644 19.5933 37.1939 19.71 37.1939 19.8617C37.1645 20.0309 37.035 20.1301 36.8644 20.1301ZM33.8572 20.1301H32.1624V20.8596H33.8572C34.5752 20.8596 34.993 20.4336 34.993 19.8034C34.993 19.2199 34.6164 18.8639 33.969 18.8639H33.1923C33.0216 18.8639 32.8921 18.7472 32.8921 18.5955C32.8921 18.4438 33.0098 18.3271 33.1923 18.3271H34.6164L34.9459 17.5977H33.2217C32.5037 17.5977 32.0859 18.0236 32.0859 18.6247C32.0859 19.2374 32.4861 19.5933 33.1216 19.5933H33.8984C34.0691 19.5933 34.1986 19.71 34.1986 19.8617C34.1574 20.0309 34.0279 20.1301 33.8572 20.1301ZM31.7858 18.3329V17.6035H29.1082V20.8537H31.7858V20.1243H29.9439V19.57H31.7446V18.8581H29.9439V18.3329H31.7858ZM27.5546 18.3329C27.8136 18.3329 27.943 18.4904 27.943 18.6597C27.943 18.8464 27.8136 18.9864 27.5546 18.9864H26.6484V18.3154H27.5546V18.3329ZM26.6484 19.7158H26.9779L27.9548 20.8712H28.9788L27.9136 19.6867C28.4609 19.57 28.7787 19.1732 28.7787 18.6713C28.7787 18.0411 28.3491 17.6152 27.6429 17.6152H25.8186V20.8654H26.6543L26.6484 19.7158ZM24.6181 18.7064C24.6181 18.9047 24.4887 19.0623 24.2297 19.0623H23.2941V18.3212H24.2297C24.4769 18.3329 24.6181 18.508 24.6181 18.7064ZM22.4584 17.6093V20.8596H23.2941V19.8034H24.2886C25.0065 19.8034 25.4538 19.3307 25.4538 18.7064C25.4538 18.0528 25.0242 17.6093 24.318 17.6093H22.4584ZM21.3403 20.8596H22.3878L21.0637 19.2199L22.3702 17.6093H21.3639L20.5871 18.6072L19.8103 17.6093H18.7628L20.0692 19.249L18.7628 20.8771H19.7867L20.5635 19.8617L21.3403 20.8596ZM18.7039 18.3329V17.6035H16.0264V20.8537H18.7039V20.1243H16.862V19.57H18.6627V18.8581H16.862V18.3329H18.7039ZM35.5109 14.9074H34.4869L33.1393 12.8126V14.9074H32.3037V11.6572H33.3688L34.6752 13.682V11.6572H35.5109V14.9074ZM30.2558 12.4275L29.7968 13.542H30.7148L30.2558 12.4275ZM32.2154 14.9074H31.2797L30.9972 14.2364H29.5025L29.2318 14.9074H28.3138L29.7261 11.6572H30.803L32.2154 14.9074ZM27.9666 14.9074H27.896C26.9485 14.9074 26.3718 14.3122 26.3718 13.3027V13.2619C26.3718 12.3341 26.9191 11.6514 27.9548 11.6514H28.9023V12.4099H28.0254C27.4781 12.4099 27.2074 12.7834 27.2074 13.2677V13.3086C27.2074 13.8629 27.5135 14.178 28.0431 14.178H28.3138L27.9666 14.9074ZM25.9716 14.9074H25.136V13.2794V11.6514H25.9716V13.2794V14.9074ZM23.9591 12.7134C23.9591 12.5442 23.8296 12.3866 23.5707 12.3866V12.3691H22.6644V13.0402H23.5707C23.8296 13.0402 23.9591 12.9001 23.9591 12.7134ZM22.9881 13.752H22.6644V14.9016H21.8288V11.6514H23.653C24.3592 11.6514 24.7888 12.0773 24.7888 12.7075C24.7888 13.2094 24.471 13.6062 23.9237 13.7229L24.9889 14.9074H23.9649L22.9881 13.752ZM21.3639 11.6572V12.3866V12.3924H19.5219V12.9176H21.3227V13.6295H19.5219V14.1839H21.3639V14.9074H18.6863V11.6572H21.3639ZM16.4501 14.9074H15.7145L14.8494 12.4975V14.9074H14.0314V11.6572H15.3555L16.0911 13.7404L16.8267 11.6572H18.1331V14.9074H17.3151V12.4975L16.4501 14.9074ZM11.9718 12.4275L11.5127 13.542H12.4308L11.9718 12.4275ZM13.9314 14.9074H12.9957L12.7132 14.2364H11.2185L10.9478 14.9074H10.0298L11.4421 11.6572H12.519L13.9314 14.9074Z\" fill=\"#647180\"/>\n</g>\n</svg>";

var BBVAGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=BBVA, Color=Off\">\n<path id=\"Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M25.3614 6.61233C26.7878 5.01168 28.8833 4 31.2201 4C35.5172 4 39 7.42066 39 11.6396C39 15.8586 35.5162 19.2783 31.2191 19.2783C29.2559 19.2783 27.4629 18.5641 26.0936 17.3862L26.0926 17.3852C25.8633 17.1878 25.6449 16.9765 25.4395 16.7531L20.1568 11.6396L25.3614 6.61233ZM26.6566 11.6396C26.6566 14.1198 28.732 16.1311 31.2912 16.1311C33.8505 16.1311 35.9259 14.1198 35.9259 11.6396C35.9259 9.15954 33.8505 7.14821 31.2912 7.14821C28.732 7.14821 26.6566 9.15954 26.6566 11.6396ZM19.7281 12.1815L21.6603 14.0996L23.924 16.3484C23.2559 17.1917 22.4115 17.8929 21.4449 18.4008C20.3531 18.9737 19.1061 19.2992 17.7809 19.2992C13.4838 19.2992 10 15.8796 10 11.6606C10 7.44161 13.4838 4.02195 17.7809 4.02195C19.1031 4.02195 20.3481 4.34649 21.4379 4.91743C22.4055 5.42427 23.2509 6.12543 23.92 6.96783L21.6723 9.19952C21.0643 8.29102 20.1278 7.60989 19.0259 7.3124C18.6303 7.20522 18.2126 7.14813 17.7819 7.14813C15.2226 7.14813 13.1472 9.15946 13.1472 11.6396C13.1472 14.1197 15.2226 16.131 17.7819 16.131C18.2036 16.131 18.6123 16.0759 19.0009 15.9737L17.4523 14.4362L19.7281 12.1815ZM28.7059 23.7848L27.0461 26.943C27.0111 27.0101 26.9079 27.0101 26.8728 26.943L25.2131 23.7848C25.1971 23.7527 25.165 23.7337 25.13 23.7337H24.3256C24.2705 23.7337 24.2355 23.7918 24.2615 23.8398L26.8758 28.735C26.9109 28.8021 27.0081 28.8021 27.0461 28.735L29.6605 23.8398C29.6865 23.7918 29.6504 23.7337 29.5963 23.7337H28.792C28.754 23.7337 28.7219 23.7527 28.7059 23.7848ZM31.4504 24.8435L29.7906 28.0017C29.7746 28.0298 29.7386 28.0498 29.7045 28.0528H28.9002C28.8461 28.0528 28.81 27.9947 28.8361 27.9466L31.4504 23.0515C31.4885 22.9844 31.5856 22.9844 31.6207 23.0515L34.235 27.9466C34.261 27.9947 34.226 28.0528 34.1709 28.0528H33.3666C33.3315 28.0528 33.2995 28.0338 33.2834 28.0017L31.6237 24.8435C31.5886 24.7764 31.4855 24.7764 31.4504 24.8435ZM18.1274 26.0615C18.4749 25.8882 18.6903 25.5116 18.6903 25.0518C18.6903 24.2635 18.0763 23.7297 17.2109 23.7297H14.7247C14.6697 23.7297 14.6286 23.7717 14.6286 23.8258V28.6859C14.6286 28.7409 14.6707 28.782 14.7247 28.782H17.1047C18.2947 28.782 18.9217 28.2702 18.9217 27.2675C18.9217 26.2899 18.1274 26.0615 18.1274 26.0615ZM15.5611 24.4629H17.0376C17.5815 24.4629 17.8579 24.6943 17.8579 25.125C17.8579 25.5557 17.5815 25.7871 17.0376 25.7871H15.5611C15.51 25.7871 15.465 25.745 15.465 25.6909V24.559C15.465 24.5049 15.506 24.4629 15.5611 24.4629ZM17.0566 28.0498H15.5611C15.506 28.0498 15.465 28.0077 15.465 27.9536V26.6124C15.465 26.5613 15.507 26.5163 15.5611 26.5163H17.0566C17.7708 26.5163 18.0893 26.7186 18.0893 27.2815C18.0863 27.8505 17.7768 28.0498 17.0566 28.0498ZM23.937 25.0518C23.937 25.5116 23.7216 25.8882 23.374 26.0615C23.374 26.0615 24.1683 26.2899 24.1653 27.2675C24.1653 28.2702 23.5383 28.782 22.3483 28.782H19.9684C19.9143 28.782 19.8722 28.7409 19.8722 28.6859V23.8258C19.8722 23.7717 19.9133 23.7297 19.9684 23.7297H22.4575C23.3229 23.7297 23.937 24.2635 23.937 25.0518ZM22.2832 24.4629H20.8068C20.7527 24.4629 20.7106 24.5049 20.7106 24.559V25.6909C20.7106 25.745 20.7517 25.7871 20.8068 25.7871H22.2832C22.8271 25.7871 23.1036 25.5557 23.1036 25.125C23.1036 24.6943 22.8271 24.4629 22.2832 24.4629ZM20.8038 28.0498H22.2992C23.0194 28.0498 23.332 27.8505 23.332 27.2815C23.332 26.7186 23.0134 26.5163 22.2992 26.5163H20.8038C20.7497 26.5163 20.7076 26.5613 20.7076 26.6124V27.9536C20.7076 28.0077 20.7527 28.0498 20.8038 28.0498Z\" fill=\"#647180\"/>\n</g>\n</svg>";

var BimoGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Bimo, Color=Off\">\n<g id=\"Bimo\">\n<g id=\"XMLID 492\">\n<path id=\"XMLID 501\" d=\"M24.98 15.0874C24.98 15.1638 24.98 19.5783 24.98 19.6602C25.2584 19.864 26.1591 19.864 26.5067 19.6602C26.5067 19.4491 26.5067 15.2839 26.5067 15.0874C26.1591 14.8836 25.2584 14.8836 24.98 15.0874Z\" fill=\"#647180\"/>\n<path id=\"XMLID 498\" d=\"M38.3034 14.7852C36.7148 14.7852 35.6067 15.7951 35.6067 17.3254C35.6067 18.8648 36.7148 19.8947 38.3034 19.8947C39.9029 19.8947 41.0001 18.8648 41.0001 17.3254C41.0019 15.7951 39.9029 14.7852 38.3034 14.7852ZM38.3034 18.5318C37.6174 18.5318 37.1261 18.0514 37.1261 17.3254C37.1261 16.6194 37.6174 16.1481 38.3034 16.1481C38.9894 16.1481 39.4807 16.6194 39.4807 17.3254C39.4807 18.0514 38.9912 18.5318 38.3034 18.5318Z\" fill=\"#647180\"/>\n<path id=\"XMLID 497\" d=\"M32.8191 14.8215C32.1804 14.8215 31.72 15.0017 31.2833 15.2128C30.9303 14.9726 30.3626 14.8215 29.9222 14.8215C28.643 14.8215 27.9315 15.2546 27.5076 15.6058V16.8049C27.5076 16.8049 27.5076 18.0587 27.5076 18.9066C27.5076 19.3124 27.5076 19.6254 27.5076 19.66C27.786 19.8638 28.6867 19.8638 29.0342 19.66C29.0342 19.3743 29.0342 16.8049 29.0342 16.8049H29.0324V16.4683C29.0324 16.4683 29.3363 16.2863 29.5656 16.2863C30.0769 16.2863 30.3917 16.492 30.4117 17.0979C30.4117 17.8094 30.4117 19.5708 30.4117 19.6581C30.6901 19.8619 31.5908 19.8619 31.9384 19.6581C31.9384 19.3724 31.9384 16.8031 31.9384 16.8031H31.9366C31.9329 16.6776 31.9238 16.6485 31.9075 16.5065C31.9075 16.5065 32.2222 16.2845 32.4606 16.2845C32.9738 16.2845 33.2867 16.4847 33.3159 17.0724C33.3159 17.7675 33.3159 19.569 33.3159 19.6581C33.5943 19.8619 34.495 19.8619 34.8425 19.6581C34.8425 19.5708 34.8425 19.2742 34.8425 18.9048C34.8425 18.0514 34.8425 16.8031 34.8425 16.8031V16.6848C34.8443 15.3802 34.0055 14.8215 32.8191 14.8215Z\" fill=\"#647180\"/>\n<path id=\"XMLID 496\" d=\"M25.748 12.5798C25.2385 12.5798 24.8328 12.9583 24.8328 13.486C24.8328 13.9955 25.2404 14.374 25.748 14.374C26.2393 14.374 26.6542 13.9955 26.6542 13.486C26.6542 12.9601 26.2393 12.5798 25.748 12.5798Z\" fill=\"#647180\"/>\n<path id=\"XMLID 493\" d=\"M22.3178 14.9853C21.7938 14.9853 21.217 15.1527 20.8603 15.5003V15.4602C20.8603 15.4602 20.8603 13.5897 20.8603 13.304C20.5146 13.1002 19.6139 13.1002 19.3354 13.304C19.3354 13.3367 19.3354 19.6181 19.3354 19.6181C19.9687 19.8456 20.762 19.9547 21.4462 19.9547C23.3459 19.9547 24.1484 19.054 24.1484 17.3909C24.1502 15.846 23.497 14.9853 22.3178 14.9853ZM21.5463 18.8066C21.3789 18.8066 21.0495 18.7865 20.8621 18.7374V16.3519C21.0696 16.2227 21.428 16.1644 21.6555 16.1644C22.2487 16.1644 22.5653 16.6503 22.5653 17.4418C22.5653 18.2807 22.1886 18.8066 21.5463 18.8066Z\" fill=\"#647180\"/>\n</g>\n<g id=\"XMLID 486\">\n<path id=\"XMLID 489\" d=\"M16.1146 11.8247C15.8798 11.6537 15.1192 11.6573 14.8263 11.8302C14.8263 11.9103 14.8263 12.1741 14.8281 12.4653C14.8244 13.4497 14.6807 13.9191 14.5933 14.112C14.5497 14.2103 14.4714 14.2995 14.3805 14.3777C13.8964 13.3387 12.8429 12.6145 11.6237 12.6145C10.1516 12.6145 8.92154 13.6644 8.64313 15.0564C8.29194 15.2893 7.74605 15.7461 7.58956 16.4157C7.54589 16.6049 7.49312 16.8087 7.43853 17.0034C7.40032 17.1381 7.30206 17.4765 7.20744 17.8004C7.18924 17.8623 7.1765 17.8987 7.1765 17.9005C7.17105 17.9187 7.16559 17.9387 7.16195 17.9569C7.08734 18.2171 7.02002 18.4446 7 18.5156C7.23291 18.763 7.96259 18.9759 8.23553 18.8777C8.23917 18.8667 8.46299 18.1007 8.46299 18.1007L8.45935 18.097C8.54123 17.8259 8.69408 17.3019 8.81236 16.8197C9.05073 17.3947 9.46197 17.8805 9.98057 18.2135L9.86229 19.6983H9.43286C9.22906 19.6983 9.05801 19.6983 8.99432 19.6983C8.82146 19.9895 8.81782 20.7501 8.98886 20.9866C9.0016 20.9866 10.1116 20.9866 10.1116 20.9866H10.4573C10.7921 20.9866 11.0705 20.7282 11.0978 20.3952L11.2361 18.672C11.3617 18.6884 11.4909 18.6975 11.6219 18.6975C12.0986 18.6975 12.5481 18.5865 12.9502 18.3918L13.5471 20.519C13.6253 20.7956 13.8782 20.9884 14.1657 20.9884H14.5752C14.9336 21.0048 15.3867 21.023 15.394 21.0248C15.5741 20.7974 15.6032 20.035 15.4413 19.7365C15.3758 19.7347 15.1829 19.7256 14.9518 19.7165C14.91 19.7074 14.8681 19.7038 14.8244 19.7038H14.6516L14.0384 17.5002C14.415 17.0071 14.6443 16.3975 14.6625 15.7333C15.0264 15.5386 15.5214 15.1874 15.767 14.6397C15.9981 14.1266 16.1146 13.3842 16.1146 12.4343C16.1146 12.4343 16.1146 11.8357 16.1146 11.8247ZM9.86957 15.6551C9.86957 14.6889 10.6557 13.901 11.6237 13.901C12.5917 13.901 13.3778 14.687 13.3778 15.6551C13.3778 16.6231 12.5899 17.4092 11.6237 17.4092C10.6575 17.4092 9.86957 16.6231 9.86957 15.6551Z\" fill=\"#647180\"/>\n<path id=\"XMLID 488\" d=\"M10.9832 11.1296C10.9832 11.1915 10.9832 15.1092 10.9832 15.1765C11.2179 15.3494 11.9803 15.3494 12.2733 15.1765C12.2733 15.0018 12.2733 11.2861 12.2733 11.1296C11.9785 10.9568 11.2179 10.9568 10.9832 11.1296Z\" fill=\"#647180\"/>\n</g>\n</g>\n</g>\n</svg>";

var BNAGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=BNA+, Color=Off\">\n<path id=\"Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M25.9401 19.9127V20.9666H29.2532V19.9127L28.5212 19.7826L29.0725 18.2151H32.8521L33.3889 19.7826L32.5791 19.9127V20.9666H36.0625V19.9127L35.1533 19.81L31.8343 11H30.1255L26.7645 19.81L25.9401 19.9127ZM32.3993 16.8942H29.5331L30.8506 13.2181L30.9482 12.9373H30.9902L31.0809 13.2044L32.3993 16.8942ZM7 20.9663V19.9125L8.11463 19.707V12.2667L7 12.0613V11.0006H8.11463H11.1358C12.193 11.0006 13.0183 11.2275 13.6116 11.682C14.2048 12.1358 14.5019 12.8146 14.5019 13.7187C14.5019 14.1707 14.3786 14.5756 14.1329 14.9335C13.8872 15.2922 13.5457 15.5576 13.1099 15.7313C13.49 15.8178 13.8093 15.9753 14.0679 16.2039C14.3264 16.4325 14.5242 16.709 14.6603 17.036C14.7964 17.3622 14.864 17.7192 14.864 18.107C14.864 19.0427 14.5738 19.7532 13.9934 20.2395C13.413 20.7258 12.6048 20.9689 11.5689 20.9689H7V20.9663ZM9.74719 15.2031H11.3181C11.8018 15.2031 12.181 15.0799 12.4576 14.8333C12.7341 14.5867 12.8719 14.2426 12.8719 13.8C12.8719 13.3026 12.7255 12.9336 12.4319 12.6948C12.1382 12.4551 11.7068 12.3352 11.1375 12.3352H9.74719V15.2031ZM9.74633 19.6385H11.5707C12.1057 19.6385 12.5166 19.5075 12.8034 19.2447C13.0902 18.9828 13.234 18.6027 13.234 18.1053C13.234 17.7543 13.1801 17.4546 13.0722 17.2089C12.9644 16.9624 12.8 16.7732 12.58 16.6405C12.36 16.5078 12.0775 16.4419 11.7316 16.4419H9.74548V19.6385H9.74633ZM15.6028 20.9666V19.9127L16.7269 19.7073V12.267L15.6028 12.0615V11.0008H16.7269H18.3586L23.5105 18.2776L23.5533 18.2639V12.2678L22.3377 12.0624V11.0017H24.9873H26.1113V12.0624L24.9873 12.2678V20.9683H23.5542L18.2893 13.4578L18.2464 13.4647V19.709L19.4621 19.9144V20.9683H15.6028V20.9666ZM38.7455 11H37.267V13.2555H35.0117V14.734H37.267V16.9883H38.7455V14.734H41V13.2555H38.7455V11Z\" fill=\"#647180\"/>\n</g>\n</svg>";

var BrubankGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Brubank, Color=Off\">\n<g id=\"Brubank\">\n<g id=\"Desktop HD Copy 2\">\n<g id=\"logo violeta copy\">\n<path id=\"Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 12.6873V16.4906C7.00113 17.8757 8.08041 19.0029 9.40669 19.0054H9.41566C10.7429 19.0029 11.8221 17.8747 11.8221 16.4883C11.8221 15.1003 10.7405 13.9711 9.41117 13.9711C9.04961 13.9711 8.70192 14.0527 8.37773 14.2135L8.31658 14.2438V12.6873C8.31658 12.3083 8.02127 12 7.65843 12C7.29531 12 7 12.3083 7 12.6873ZM8.3146 16.4883C8.3146 17.1183 8.80541 17.6309 9.40891 17.6309C10.0124 17.6309 10.5032 17.1183 10.5032 16.4883C10.5032 15.8582 10.0124 15.3456 9.40891 15.3456C8.80541 15.3456 8.3146 15.8582 8.3146 16.4883ZM20.9834 12.6873V16.4906C20.9845 17.8757 22.0638 19.0029 23.3901 19.0054H23.3991C24.7263 19.0029 25.8055 17.8747 25.8055 16.4883C25.8055 15.1003 24.7239 13.9711 23.3946 13.9711C23.033 13.9711 22.6853 14.0527 22.3611 14.2135L22.3 14.2438V12.6873C22.3 12.3083 22.0047 12 21.6418 12C21.2787 12 20.9834 12.3083 20.9834 12.6873ZM22.298 16.4883C22.298 17.1183 22.7888 17.6309 23.3923 17.6309C23.9958 17.6309 24.4866 17.1183 24.4866 16.4883C24.4866 15.8582 23.9958 15.3456 23.3923 15.3456C22.7888 15.3456 22.298 15.8582 22.298 16.4883ZM19.0194 14.6585C19.0194 14.2795 19.3147 13.9712 19.6775 13.9712C20.0407 13.9712 20.336 14.2795 20.336 14.6585V16.6017H20.336C20.3349 17.9246 19.3035 19.001 18.0365 19.0022C16.7695 19.001 15.7381 17.9246 15.7371 16.6017V14.6585C15.7371 14.2795 16.0324 13.9712 16.3955 13.9712C16.7583 13.9712 17.0536 14.2795 17.0536 14.6585V16.5994H17.0519C17.0519 17.2009 17.4935 17.6903 18.0365 17.6903C18.5795 17.6903 19.0212 17.2009 19.0212 16.5994H19.0194V14.6585ZM33.8297 13.9712C32.5628 13.9724 31.5314 15.0488 31.5303 16.3717V18.315C31.5303 18.6939 31.8256 19.0022 32.1887 19.0022C32.5515 19.0022 32.8469 18.6939 32.8469 18.315V16.374H32.8451C32.8451 15.7725 33.2867 15.2831 33.8297 15.2831C34.3728 15.2831 34.8144 15.7725 34.8144 16.374H34.8126V18.315C34.8126 18.6939 35.1079 19.0022 35.4707 19.0022C35.8339 19.0022 36.1292 18.6939 36.1292 18.315V16.3717C36.1281 15.0488 35.0967 13.9724 33.8297 13.9712ZM29.9342 18.8359C30.0443 18.9541 30.1904 19.0142 30.3688 19.0149H30.3745C30.5467 19.0142 30.6915 18.9541 30.8046 18.836C30.9183 18.7173 30.9759 18.5653 30.9759 18.3841V16.486C30.9748 15.0993 29.893 13.9712 28.5647 13.9712C27.2354 13.9712 26.1538 15.1004 26.1538 16.4883C26.1538 17.818 27.1463 18.9101 28.3984 18.9996C28.9305 19.0396 29.4667 18.7772 29.7665 18.2716L29.7673 18.3906C29.7687 18.569 29.8248 18.7188 29.9342 18.8359ZM28.549 17.631C27.9455 17.631 27.4547 17.1184 27.4547 16.4883C27.4547 15.8583 27.9455 15.3457 28.549 15.3457C29.1525 15.3457 29.6433 15.8583 29.6433 16.4883C29.6433 17.1184 29.1525 17.631 28.549 17.631ZM37.3877 19.0042C37.0246 19.0042 36.7292 18.6959 36.7292 18.317L36.7293 12.6892C36.7293 12.3103 37.0246 12.002 37.3874 12.002C37.7505 12.002 38.0458 12.3103 38.0458 12.6892L38.0458 16.0004L39.9123 14.1306C40.148 13.8944 40.5238 13.9025 40.7499 14.1485C40.9762 14.3947 40.9684 14.7871 40.7327 15.0232L39.3873 16.371L40.8354 17.9472C40.9448 18.0663 40.9994 18.2197 40.9999 18.3731V18.3773C40.9994 18.5394 40.9384 18.701 40.8178 18.8218C40.5821 19.0578 40.2063 19.0497 39.9802 18.8035L38.0458 16.698V18.317C38.0458 18.6959 37.7505 19.0042 37.3877 19.0042ZM13.5658 14.7121C13.8696 14.2055 14.44 13.9075 15.0366 13.9948C15.3294 14.0415 15.5538 14.3056 15.5538 14.6243C15.5551 14.6841 15.5485 14.745 15.5333 14.8057C15.4453 15.1566 15.1015 15.3667 14.7654 15.2748C14.6956 15.2574 14.6231 15.2482 14.5487 15.2482C14.0253 15.2482 13.5961 15.703 13.5658 16.2745V16.3392V16.5994V18.2801C13.5658 18.659 13.2705 18.9674 12.9077 18.9674C12.5446 18.9674 12.2493 18.659 12.2493 18.2801V16.6017V16.3368V14.6585C12.2493 14.2795 12.5446 13.9712 12.9077 13.9712C13.2705 13.9712 13.5658 14.2795 13.5658 14.6585V14.7121Z\" fill=\"#647180\"/>\n</g>\n</g>\n</g>\n</g>\n</svg>";

var CabalGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Cabal, Color=Off\">\n<path id=\"Exclude\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M38.748 21.4832H7V10H41V19.2312C41 20.4757 39.9925 21.4832 38.748 21.4832ZM24.3257 14.1729L25.0264 16.3692H25.0299V16.3761H23.6424L24.3257 14.1729ZM26.5603 18.1017L24.9846 13.4478H24.0468C23.8237 13.4478 23.625 13.5872 23.5518 13.8034L22.0981 18.1017H23.0881L23.4088 17.1361H25.2565L25.5702 18.1017H26.5603ZM29.4815 16.9129C29.4815 17.2511 29.3002 17.3661 28.8714 17.3661H27.9057V16.0972H28.955C29.3246 16.0972 29.4815 16.2541 29.4815 16.5678V16.9129ZM27.9057 14.1729H28.8121C29.1572 14.1729 29.3071 14.2879 29.3071 14.5529V14.9642C29.3071 15.2361 29.1747 15.393 28.8051 15.393H27.9057V14.1729ZM29.6941 15.6754C30.0741 15.5185 30.2484 15.3059 30.2484 14.9259V14.4483C30.2484 13.8208 29.8684 13.4582 28.9202 13.4582H26.9575V18.1122H29.0527C29.959 18.1122 30.4122 17.7008 30.4122 17.0489V16.5539C30.4192 16.0798 30.1473 15.766 29.6941 15.6754ZM21.7251 14.0997H20.3725C19.7763 14.1171 19.5811 14.3298 19.5707 14.7899V16.5818C19.5707 17.0594 19.7694 17.2651 20.362 17.2825H21.2022C21.4601 17.2825 21.6658 17.4917 21.6658 17.7461V18.0843H20.362C19.1488 18.0738 18.6294 17.5788 18.6294 16.7387V14.6435C18.6294 13.7999 19.1488 13.3048 20.362 13.2979H21.2614C21.5194 13.2979 21.7251 13.507 21.7251 13.7615V14.0997ZM36.3773 17.3138V14.1728V13.371H35.9555C35.6662 13.371 35.4361 13.6011 35.4361 13.8905V14.1693V18.0877H38.4307V17.3138H36.3773ZM32.8632 14.1729L33.5639 16.3692H33.5674V16.3761H32.1799L32.8632 14.1729ZM35.0978 18.1017L33.522 13.4478H32.7237C32.4169 13.4478 32.145 13.6465 32.0474 13.9358L30.6355 18.1017H31.6256L31.9463 17.1361H33.794L34.1077 18.1017H35.0978ZM13.5081 12.0115L16.9559 15.4034C17.1441 15.5917 17.1441 15.9054 16.9559 16.0867L13.5081 19.4787V17.5823L15.1256 15.9821C15.2581 15.8497 15.2581 15.637 15.1256 15.5045L13.5081 13.9044V12.0115ZM9.42607 15.4034L12.8738 12.0115V13.9044L11.2563 15.5045C11.1238 15.637 11.1238 15.8497 11.2563 15.9821L12.8738 17.5823V19.4787L9.42607 16.0867C9.23782 15.9054 9.23782 15.5917 9.42607 15.4034Z\" fill=\"#647180\"/>\n</g>\n</svg>";

var CabalDebitoGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Cabal_Debito, Color=Off\">\n<path id=\"Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 20.4903H38.7476C39.9933 20.4903 41 19.4835 41 18.2378V9H7V20.4903ZM25.0229 15.3699L24.3204 13.1718L23.636 15.3699H25.0229ZM24.9794 12.4512L26.5547 17.1081H25.5661L25.2547 16.1485H23.4042L23.0855 17.1081H22.0969L23.549 12.8097C23.6215 12.596 23.817 12.4548 24.0488 12.4548H24.9794V12.4512ZM28.8687 16.3766C29.296 16.3766 29.4734 16.2607 29.4734 15.924V15.5763C29.4734 15.2576 29.3213 15.1056 28.9484 15.1056H27.8982V16.3766H28.8687ZM27.9091 13.1718V14.3885H28.8071C29.1729 14.3885 29.3069 14.2292 29.3069 13.954V13.5448C29.3069 13.2877 29.1548 13.1718 28.8071 13.1718H27.9091ZM30.2375 13.9214C30.2375 14.3053 30.0709 14.5262 29.6871 14.6782C30.147 14.7652 30.415 15.0874 30.4077 15.5401V16.0362C30.4077 16.6953 29.9551 17.1045 29.0461 17.1045H26.9458V12.4512H28.9121C29.8537 12.4512 30.2375 12.8097 30.2375 13.4398V13.9214ZM20.3659 13.1028H21.7203V12.766C21.7203 12.5089 21.5139 12.3025 21.2568 12.3025H20.3587C19.1564 12.3206 18.6313 12.8095 18.6313 13.6568V15.7499C18.6313 16.5937 19.1492 17.0862 20.3659 17.0934H21.6732V16.7566C21.6732 16.4995 21.4668 16.2931 21.2097 16.2931H20.3659C19.7793 16.275 19.5729 16.0722 19.5729 15.5906V13.8089C19.5837 13.3345 19.7793 13.1209 20.3659 13.1028ZM36.3685 13.179V16.3222H38.4218V17.1044H35.4233V13.179V12.9037C35.4233 12.6104 35.6551 12.3787 35.9484 12.3787H36.3685V13.179ZM33.5583 15.3699L32.8631 13.1718L32.1786 15.3699H33.5583ZM33.5221 12.4512L35.0974 17.1045H34.1088L33.7973 16.1449H31.9469L31.6246 17.1081H30.636L32.041 12.9437C32.1388 12.6503 32.414 12.4548 32.7182 12.4548H33.5221V12.4512ZM16.9511 14.3993L13.5073 11.0098V12.8892L15.126 14.4898C15.26 14.6238 15.26 14.8374 15.126 14.9714L13.5073 16.572V18.4659L16.9511 15.0837C17.1467 14.899 17.1467 14.5876 16.9511 14.3993ZM12.8664 11.0098L9.42254 14.3993C9.22699 14.5876 9.22699 14.899 9.42254 15.0837L12.8664 18.4659V16.572L11.2477 14.9714C11.1137 14.8374 11.1137 14.6238 11.2477 14.4898L12.8664 12.8892V11.0098ZM27.2102 21.6708H28.5646V22.0365H27.6303V22.5689H28.4922V22.9346H27.6303V23.5031H28.5646V23.8689H27.2102V21.6708ZM27.6665 21.3087C27.8259 21.2109 27.9707 21.1131 28.1011 21.0153L28.2532 21.2616C28.1011 21.3666 27.9852 21.439 27.8077 21.5368L27.6665 21.3087ZM26.0297 21.6708C26.5729 21.6708 26.7612 21.946 26.7612 22.2683V23.2931C26.7612 23.6045 26.5729 23.8906 26.0297 23.8906H25.2113V21.6817H26.0297V21.6708ZM25.6278 23.514H25.9826C26.2687 23.514 26.3375 23.3981 26.3375 23.1953V22.3769C26.3375 22.1633 26.2578 22.0583 25.9826 22.0583H25.6278V23.514ZM28.9919 21.6708V23.8798L29.9262 23.8761C30.3245 23.8761 30.5309 23.6806 30.5309 23.3692V23.1374C30.5309 22.9238 30.4187 22.7717 30.2123 22.7282C30.3716 22.6594 30.4513 22.5508 30.4513 22.3733V22.1416C30.4513 21.841 30.2847 21.6708 29.8646 21.6708H28.9919ZM29.8031 22.0184C29.9624 22.0184 30.024 22.0728 30.024 22.1959V22.3914C30.024 22.5182 29.9624 22.5978 29.8031 22.5978H29.4011V22.0184H29.8031ZM29.8719 22.9274C30.0421 22.9274 30.1036 22.9962 30.1036 23.1483V23.3185C30.1036 23.4778 30.024 23.5321 29.8357 23.5321H29.4084V22.9274H29.8719ZM31.3349 21.6708H30.9148V23.8798H31.3349V21.6708ZM31.6789 22.0365H32.2945V23.8798H32.7109V22.0365H33.3266V21.6708H31.6789V22.0365ZM35.2205 23.2316C35.2205 23.5973 35.0068 23.9087 34.3839 23.9087C33.7611 23.9087 33.5474 23.5973 33.5474 23.2316V22.3118C33.5474 21.946 33.7611 21.6346 34.3839 21.6346C35.0068 21.6346 35.2205 21.946 35.2205 22.3118V23.2316ZM33.9675 23.2135C33.9675 23.4199 34.0725 23.5502 34.3876 23.5502C34.699 23.5502 34.8076 23.4271 34.8076 23.2135V22.348C34.8076 22.1416 34.7026 22.0112 34.3876 22.0112C34.0761 22.0112 33.9675 22.1343 33.9675 22.348V23.2135Z\" fill=\"#647180\"/>\n</g>\n</svg>";

var CuentaDNIGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Cuenta_DNI, Color=Off\">\n<g id=\"Cuenta DNI\">\n<path id=\"Vector\" d=\"M11.7007 21.4806H11.4539C9.60878 21.4806 7.98061 20.3325 7.30595 18.5544C7.21799 18.3237 7.32794 18.062 7.55182 17.972C7.77471 17.881 8.02758 17.9948 8.11454 18.2265C8.65726 19.657 9.9686 20.5818 11.4539 20.5818H11.7007C11.9406 20.5818 12.1355 20.7835 12.1355 21.0317C12.1355 21.28 11.9406 21.4806 11.7007 21.4806Z\" fill=\"#647180\"/>\n<path id=\"Vector_2\" d=\"M17.5886 13.548C17.3487 13.548 17.1538 13.3463 17.1538 13.098V11.0531C17.1538 10.9724 17.0869 10.9072 17.0039 10.9072H15.0129C14.773 10.9072 14.5781 10.7055 14.5781 10.4573C14.5781 10.209 14.773 10.0073 15.0129 10.0073H17.0039C17.5656 10.0073 18.0224 10.4759 18.0224 11.052V13.097C18.0234 13.3473 17.8285 13.548 17.5886 13.548Z\" fill=\"#647180\"/>\n<path id=\"Vector_3\" d=\"M7.43478 13.5462C7.1949 13.5462 7 13.3445 7 13.0963V11.0513C7 10.4752 7.45677 10.0066 8.01849 10.0066H10.0095C10.2494 10.0066 10.4443 10.2083 10.4443 10.4565C10.4443 10.7048 10.2494 10.9065 10.0095 10.9065H8.01849C7.93553 10.9065 7.86856 10.9717 7.86856 11.0523V13.0973C7.86956 13.3455 7.67466 13.5462 7.43478 13.5462Z\" fill=\"#647180\"/>\n<path id=\"Vector_4\" d=\"M17.0039 21.4806H15.0129C14.773 21.4806 14.5781 21.2789 14.5781 21.0306C14.5781 20.7824 14.773 20.5807 15.0129 20.5807H17.0039C17.0869 20.5807 17.1538 20.5155 17.1538 20.4348V18.3899C17.1538 18.1416 17.3487 17.9399 17.5886 17.9399C17.8285 17.9399 18.0234 18.1416 18.0234 18.3899V20.4348C18.0234 21.012 17.5656 21.4806 17.0039 21.4806Z\" fill=\"#647180\"/>\n<path id=\"Vector_5\" d=\"M20.4575 12.6739C20.4575 11.8815 20.4945 11.6147 20.5974 11.2723C20.8623 10.4272 21.51 10 22.3855 10C23.1362 10 23.6879 10.3579 23.9388 10.8223C23.9977 10.9289 24.0347 11.0354 24.0347 11.1575C24.0347 11.4543 23.8138 11.6602 23.542 11.6602C23.3581 11.6602 23.2111 11.5836 23.0632 11.3705C22.8793 11.112 22.7024 10.9899 22.3855 10.9899C21.9808 10.9899 21.7449 11.2113 21.6349 11.5609C21.576 11.7512 21.554 11.9343 21.554 12.6728C21.554 13.4114 21.576 13.5944 21.6349 13.7848C21.7449 14.1354 21.9808 14.3557 22.3855 14.3557C22.7024 14.3557 22.8783 14.2337 23.0632 13.9751C23.2101 13.762 23.3581 13.6855 23.542 13.6855C23.8138 13.6855 24.0347 13.8913 24.0347 14.1882C24.0347 14.3102 23.9977 14.4168 23.9388 14.5233C23.6889 14.9877 23.1362 15.3456 22.3855 15.3456C21.51 15.3456 20.8623 14.9195 20.5974 14.0734C20.4945 13.732 20.4575 13.4662 20.4575 12.6739Z\" fill=\"#647180\"/>\n<path id=\"Vector_6\" d=\"M26.6192 14.9206H26.6122C26.4353 15.1565 26.1265 15.3468 25.6697 15.3468C24.8821 15.3468 24.4773 14.7758 24.4773 13.9752V12.0947C24.4773 11.7441 24.6982 11.531 25 11.531C25.2949 11.531 25.5078 11.7441 25.5078 12.0947V13.7704C25.5078 14.1738 25.6847 14.4407 26.0525 14.4407C26.4133 14.4407 26.5972 14.1738 26.5972 13.7704V12.0947C26.5972 11.7441 26.8111 11.531 27.112 11.531C27.4068 11.531 27.6267 11.7441 27.6267 12.0947V14.7458C27.6267 15.0965 27.4138 15.3096 27.112 15.3096C26.8691 15.3096 26.6782 15.1648 26.6192 14.9206Z\" fill=\"#647180\"/>\n<path id=\"Vector_7\" d=\"M28.2019 14.2958C28.128 14.0672 28.084 13.8004 28.084 13.4197C28.084 13.0308 28.121 12.765 28.1939 12.5364C28.4078 11.8661 28.9745 11.4927 29.7321 11.4927C30.5198 11.4927 31.0645 11.8733 31.2704 12.5291C31.3513 12.7877 31.3883 13.0473 31.3883 13.3897C31.3883 13.5956 31.2634 13.7404 31.0495 13.7404H29.1574C29.1285 13.7404 29.1135 13.7559 29.1135 13.7859C29.1135 13.8624 29.1285 13.9307 29.1504 13.999C29.2464 14.3113 29.5183 14.4789 29.8861 14.4789C30.1289 14.4789 30.3648 14.3951 30.5557 14.2886C30.6807 14.212 30.8056 14.1748 30.9086 14.1748C31.1224 14.1748 31.2844 14.3424 31.2844 14.571C31.2844 14.7313 31.2104 14.8606 31.0785 14.9516C30.7396 15.1957 30.3428 15.3478 29.7901 15.3478C28.9675 15.3468 28.4078 14.9589 28.2019 14.2958ZM30.3288 13.0318C30.3578 13.0318 30.3728 13.0163 30.3728 12.9863C30.3728 12.8643 30.3578 12.7877 30.3358 12.7122C30.2549 12.4536 30.034 12.3088 29.7401 12.3088C29.4453 12.3088 29.2324 12.4536 29.1514 12.7122C29.1295 12.7887 29.1145 12.8643 29.1145 12.9863C29.1145 13.0163 29.1295 13.0318 29.1584 13.0318H30.3288Z\" fill=\"#647180\"/>\n<path id=\"Vector_8\" d=\"M33.9869 14.7457V13.07C33.9869 12.6666 33.795 12.3998 33.4272 12.3998C33.0593 12.3998 32.8754 12.6666 32.8754 13.07V14.7457C32.8754 15.0964 32.6545 15.3095 32.3607 15.3095C32.0588 15.3095 31.8459 15.0964 31.8459 14.7457V12.0946C31.8459 11.744 32.0598 11.5309 32.3607 11.5309C32.6036 11.5309 32.7945 11.6757 32.8534 11.9198H32.8604C33.0373 11.684 33.3462 11.4937 33.803 11.4937C34.5906 11.4937 35.0174 12.0646 35.0174 12.8642V14.7457C35.0174 15.0964 34.8035 15.3095 34.5026 15.3095C34.2078 15.3095 33.9869 15.0953 33.9869 14.7457Z\" fill=\"#647180\"/>\n<path id=\"Vector_9\" d=\"M36.8339 15.3094C35.9943 15.3094 35.6934 14.9132 35.6934 14.0754V12.4152C35.6934 12.3852 35.6714 12.3697 35.6415 12.3697H35.6125C35.3476 12.3697 35.2007 12.2094 35.2007 11.9735C35.2007 11.7377 35.3476 11.5774 35.6125 11.5774H35.6415C35.6704 11.5774 35.6934 11.5619 35.6934 11.5319V10.9837C35.6934 10.633 35.9073 10.4199 36.2092 10.4199C36.504 10.4199 36.7169 10.633 36.7169 10.9837V11.5319C36.7169 11.5619 36.7319 11.5774 36.7609 11.5774H37.0407C37.3056 11.5774 37.4525 11.7377 37.4525 11.9735C37.4525 12.2094 37.3056 12.3697 37.0407 12.3697H36.7609C36.7319 12.3697 36.7169 12.3852 36.7169 12.4152V14.0454C36.7169 14.2668 36.7979 14.3578 36.9888 14.3805C37.3126 14.4188 37.4455 14.6246 37.4455 14.8532C37.4455 15.1118 37.2686 15.3104 36.8788 15.3104H36.8339V15.3094Z\" fill=\"#647180\"/>\n<path id=\"Vector_10\" d=\"M41 14.8139C41 15.0953 40.7721 15.3094 40.4852 15.3094C40.3083 15.3094 40.1614 15.2411 40.0654 15.1036L39.9775 14.9743H39.9705C39.7866 15.2101 39.4038 15.3477 38.962 15.3477C38.0494 15.3477 37.6077 14.9215 37.6077 14.2202C37.6077 13.4051 38.1964 13.0317 39.0799 13.0317H39.7206C39.7506 13.0317 39.7646 13.0162 39.7646 12.9862V12.9479C39.7646 12.6055 39.5287 12.3997 39.036 12.3997C38.8151 12.3997 38.5942 12.4535 38.4622 12.5062C38.3743 12.5362 38.2933 12.56 38.2194 12.56C37.9765 12.56 37.8076 12.3925 37.8076 12.1339C37.8076 11.9735 37.8815 11.806 38.0724 11.7077C38.3083 11.5857 38.6681 11.4946 39.1619 11.4946C40.2364 11.4946 40.7521 12.0584 40.7521 12.98V13.9854C40.7521 14.1602 40.7671 14.244 40.8181 14.3361L40.914 14.5036C40.971 14.6009 41 14.7074 41 14.8139ZM39.7636 14.0371V13.7858C39.7636 13.7558 39.7486 13.7403 39.7196 13.7403H39.2189C38.7841 13.7403 38.5862 13.8778 38.5862 14.1592C38.5862 14.4178 38.7631 14.5481 39.1009 14.5481C39.5357 14.5471 39.7636 14.3795 39.7636 14.0371Z\" fill=\"#647180\"/>\n<path id=\"Vector_11\" d=\"M20.4429 16.7481C20.4429 16.4513 20.6198 16.2527 20.9136 16.2527H22.099C23.1665 16.2527 23.8282 16.6033 24.094 17.4484C24.19 17.7453 24.241 18.1032 24.241 18.8428C24.241 19.5813 24.189 19.9392 24.094 20.2371C23.8292 21.0822 23.1665 21.4328 22.099 21.4328H20.9136C20.6188 21.4328 20.4429 21.2425 20.4429 20.9456V16.7481ZM21.5693 20.4347H22.07C22.5708 20.4347 22.9316 20.2598 23.0566 19.8482C23.1085 19.6734 23.1445 19.3682 23.1445 18.8428C23.1445 18.3173 23.1075 18.0122 23.0566 17.8373C22.9316 17.4257 22.5708 17.2509 22.07 17.2509H21.5693C21.5403 17.2509 21.5253 17.2664 21.5253 17.2964V20.3891C21.5243 20.4191 21.5393 20.4347 21.5693 20.4347Z\" fill=\"#647180\"/>\n<path id=\"Vector_12\" d=\"M24.7703 16.8775C24.7703 16.4659 25.0062 16.2073 25.374 16.2073C25.6828 16.2073 25.8887 16.3976 26.0876 16.7555L27.6189 19.5814H27.6478V16.7483C27.6478 16.4059 27.8467 16.2073 28.1406 16.2073C28.4344 16.2073 28.6333 16.4048 28.6333 16.7483V20.8082C28.6333 21.2198 28.3975 21.4784 28.0296 21.4784C27.7208 21.4784 27.5149 21.2881 27.316 20.9302L25.7848 18.1116H25.7558V20.9375C25.7558 21.2798 25.5569 21.4784 25.262 21.4784C24.9682 21.4784 24.7693 21.2809 24.7693 20.9375V16.8775H24.7703Z\" fill=\"#647180\"/>\n<path id=\"Vector_13\" d=\"M29.3958 16.801C29.3958 16.4431 29.6236 16.2073 29.9405 16.2073C30.2493 16.2073 30.4782 16.4431 30.4782 16.801V20.8837C30.4782 21.2416 30.2503 21.4774 29.9405 21.4774C29.6236 21.4774 29.3958 21.2416 29.3958 20.8837V16.801Z\" fill=\"#647180\"/>\n<path id=\"Vector_14\" d=\"M8.99784 14.3373C8.92088 14.3373 8.84192 14.3155 8.77095 14.2711C8.56605 14.1418 8.50209 13.8646 8.62802 13.6525C8.99984 13.0236 9.64751 12.6492 10.3592 12.6492C10.599 12.6492 10.7939 12.8509 10.7939 13.0991C10.7939 13.3474 10.599 13.5491 10.3592 13.5491C9.95236 13.5491 9.58154 13.7642 9.36865 14.1242C9.28669 14.2607 9.14377 14.3373 8.99784 14.3373Z\" fill=\"#647180\"/>\n<path id=\"Vector_15\" d=\"M9.69419 14.7767C9.61024 14.7767 9.54327 14.6991 9.55826 14.6143C9.63222 14.2006 9.98205 13.8882 10.4028 13.8882C10.8236 13.8882 11.1734 14.2006 11.2474 14.6143C11.2624 14.6991 11.1954 14.7767 11.1115 14.7767H9.69419Z\" fill=\"#647180\"/>\n<path id=\"Vector_16\" d=\"M14.3392 14.7767C14.2553 14.7767 14.1883 14.6991 14.2033 14.6143C14.2772 14.2006 14.6271 13.8882 15.0479 13.8882C15.4687 13.8882 15.8185 14.2006 15.8924 14.6143C15.9074 14.6991 15.8405 14.7767 15.7565 14.7767H14.3392Z\" fill=\"#647180\"/>\n<path id=\"Vector_17\" d=\"M12.8312 18.9214H11.7798C11.5399 18.9214 11.345 18.7197 11.345 18.4715C11.345 18.2232 11.5399 18.0215 11.7798 18.0215H12.8312C12.9102 18.0215 12.9752 17.9553 12.9752 17.8726V14.7477C12.9752 13.5903 13.8857 12.6479 15.0041 12.6479C15.244 12.6479 15.4389 12.8497 15.4389 13.0979C15.4389 13.3462 15.244 13.5479 15.0041 13.5479C14.3645 13.5479 13.8437 14.0868 13.8437 14.7488V17.8736C13.8437 18.4518 13.3889 18.9214 12.8312 18.9214Z\" fill=\"#647180\"/>\n</g>\n</g>\n</svg>";

var MaestroGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Maestro, Color=Off\">\n<g id=\"maestro\">\n<path id=\"Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M39 13.9999C39 9.02946 34.9922 5 30.0483 5C28.1678 5 26.4232 5.58334 24.9826 6.57924C27.2097 8.40934 28.4842 11.1044 28.4842 13.9999C28.4842 16.8954 27.2097 19.5904 24.9826 21.4207C26.4232 22.4165 28.1678 23 30.0483 23C34.9922 23 39 18.9705 39 13.9999ZM24.0175 6.57926C22.5769 5.58336 20.8323 5.00002 18.9518 5.00002C14.0079 5.00002 10 9.02948 10 14C10 18.9705 14.0079 23 18.9518 23C20.8323 23 22.5769 22.4166 24.0175 21.4207C21.7904 19.5904 20.5158 16.8954 20.5158 14C20.5158 11.1045 21.7904 8.40955 24.0175 6.57926ZM27.9035 14C27.9035 11.1364 26.5731 8.58538 24.5 6.93705C22.427 8.58538 21.0965 11.1364 21.0965 14C21.0965 16.8636 22.427 19.4145 24.5 21.063C26.5731 19.4145 27.9035 16.8636 27.9035 14ZM18.7624 25.9404V27.4295H18.7717V27.4388H18.2459V26.1126C18.2459 25.7124 18.0691 25.489 17.7201 25.489C17.3711 25.489 17.1337 25.7124 17.1337 26.1265V27.4388H16.6079V26.1126C16.6079 25.7124 16.445 25.489 16.096 25.489C15.7424 25.489 15.519 25.7124 15.519 26.1265V27.4388H14.9932V25.0655H15.505V25.3541C15.7051 25.0795 15.9518 25.0051 16.203 25.0051C16.566 25.0051 16.8266 25.1679 16.9895 25.4285C17.2128 25.0935 17.5293 25.0051 17.8271 25.0051C18.3995 25.0051 18.7624 25.3773 18.7624 25.9404ZM21.6754 25.0516V26.2382V27.4341H21.1496V27.1456C20.9867 27.355 20.7401 27.4946 20.4004 27.4946C19.7396 27.4946 19.2138 26.9688 19.2138 26.2429C19.2138 25.5169 19.7396 24.9911 20.4004 24.9911C20.7355 24.9911 20.9867 25.126 21.1496 25.3401V25.0516H21.6754ZM20.4749 25.475C20.0235 25.475 19.7489 25.824 19.7489 26.2382C19.7489 26.6524 20.0235 27.0014 20.4749 27.0014C20.8983 27.0014 21.1868 26.6756 21.1868 26.2382C21.1868 25.8008 20.8983 25.475 20.4749 25.475ZM33.2485 25.0888C33.0856 25.0283 32.9227 24.9911 32.7366 24.9911C32.5644 24.9911 32.3876 25.0283 32.2247 25.0888C32.0618 25.1493 31.9222 25.2377 31.8106 25.3494C31.6989 25.4611 31.6105 25.6007 31.55 25.7496C31.4755 25.9078 31.4522 26.0707 31.4522 26.2475C31.4522 26.4336 31.4895 26.5965 31.55 26.7454C31.6105 26.8943 31.6989 27.0339 31.8106 27.1456C31.9362 27.2573 32.0618 27.3457 32.2247 27.4062C32.3876 27.4667 32.5504 27.5039 32.7366 27.5039C32.9227 27.5039 33.0856 27.4667 33.2485 27.4062C33.3974 27.3457 33.537 27.2573 33.6486 27.1456C33.7603 27.0339 33.8487 26.8943 33.9092 26.7454C33.9837 26.5965 34.007 26.4336 34.007 26.2475C34.007 26.0753 33.9697 25.8985 33.9092 25.7496C33.8487 25.6007 33.7603 25.4611 33.6486 25.3494C33.537 25.2377 33.3974 25.1493 33.2485 25.0888ZM32.4481 25.5402C32.5365 25.503 32.6389 25.4797 32.7366 25.4797C32.8529 25.4797 32.9506 25.503 33.0344 25.5402C33.1228 25.5774 33.2112 25.6286 33.2717 25.6891C33.3462 25.7496 33.3974 25.8287 33.4346 25.9264C33.4718 26.0102 33.4858 26.1126 33.4858 26.2242C33.4858 26.3359 33.4718 26.4383 33.4346 26.536C33.3974 26.6244 33.3322 26.7129 33.2717 26.7733C33.2112 26.8338 33.1228 26.885 33.0344 26.9223C32.9367 26.9595 32.8343 26.9827 32.7366 26.9827C32.6342 26.9827 32.5365 26.9595 32.4481 26.9223C32.3504 26.899 32.2712 26.8338 32.2107 26.7733C32.1363 26.7129 32.0851 26.6244 32.0479 26.536C32.02 26.4383 31.9967 26.3359 31.9967 26.2242C31.9967 26.1265 32.0107 26.0148 32.0479 25.9264C32.0991 25.838 32.1503 25.7636 32.2107 25.6891C32.2712 25.6286 32.3504 25.5774 32.4481 25.5402ZM23.36 24.9864C24.0254 24.9864 24.4721 25.503 24.4861 26.2382V26.2383C24.4861 26.3174 24.4861 26.3778 24.4908 26.429H22.7271C22.8016 26.8664 23.0994 27.0153 23.4391 27.0153C23.6764 27.0153 23.9277 26.9269 24.1278 26.764L24.3744 27.1503C24.0859 27.4016 23.7462 27.49 23.3972 27.49C22.6852 27.49 22.1734 27.0014 22.1734 26.2382C22.1734 25.4844 22.662 24.9864 23.36 24.9864ZM23.3646 25.4518C22.9877 25.4518 22.7783 25.6798 22.7271 26.0288H23.9649C23.9137 25.6658 23.7043 25.4518 23.3646 25.4518ZM25.9426 25.4657C26.2404 25.4657 26.5289 25.5774 26.6779 25.6658L26.8919 25.2703C26.6406 25.1074 26.2916 25.019 25.9147 25.019C25.3144 25.019 24.9282 25.3075 24.9282 25.7822C24.9282 26.1684 25.226 26.4057 25.7518 26.4802L26.0031 26.5174C26.2777 26.5546 26.4173 26.6291 26.4173 26.7687C26.4173 26.9595 26.2265 27.0572 25.8775 27.0572C25.5285 27.0572 25.2679 26.9455 25.091 26.8059L24.8537 27.2061C25.1283 27.4062 25.4912 27.5039 25.8775 27.5039C26.5662 27.5039 26.9664 27.1782 26.9664 26.7268C26.9664 26.3127 26.6546 26.0893 26.1427 26.0148L25.8914 25.9776C25.6681 25.9404 25.4912 25.9032 25.4912 25.7403C25.4912 25.5635 25.6681 25.4657 25.9426 25.4657ZM28.3112 25.5262H29.1488V25.0609H28.3112V24.335H27.7854V25.0609H27.2968V25.5355H27.7854V26.6244C27.7854 27.1735 27.9948 27.4993 28.609 27.4993C28.837 27.4993 29.0976 27.4248 29.2605 27.3131L29.1116 26.8618C28.9487 26.9641 28.7905 27.0014 28.6509 27.0014C28.3996 27.0014 28.3112 26.8385 28.3112 26.6012V25.5262ZM31.3126 25.0516C31.201 25.0051 31.0474 24.9911 30.9497 24.9911C30.6519 24.9911 30.4518 25.126 30.3261 25.3447V25.0562H29.8142V27.4295H30.3401V26.0939C30.3401 25.6938 30.4983 25.4797 30.838 25.4797C30.9404 25.4797 31.0521 25.489 31.1637 25.5402L31.3126 25.0516ZM34.6259 27.0898C34.5886 27.0758 34.5654 27.0758 34.5281 27.0758C34.5051 27.0758 34.482 27.0812 34.4644 27.0853C34.4537 27.0878 34.445 27.0898 34.4397 27.0898C34.4355 27.0923 34.431 27.0949 34.4265 27.0975C34.4064 27.1092 34.3843 27.122 34.3653 27.141C34.3444 27.1584 34.3339 27.1784 34.3241 27.1971C34.3208 27.2034 34.3176 27.2096 34.3141 27.2154C34.3141 27.2284 34.3111 27.2403 34.3079 27.2531C34.3041 27.2679 34.3001 27.2839 34.3001 27.3038C34.3001 27.3411 34.3001 27.3643 34.3141 27.4016C34.3166 27.4058 34.3192 27.4102 34.3218 27.4148C34.3335 27.4349 34.3463 27.457 34.3653 27.476C34.3827 27.4969 34.4027 27.5074 34.4214 27.5172C34.4277 27.5205 34.4339 27.5237 34.4397 27.5272C34.4527 27.5272 34.4646 27.5302 34.4775 27.5334C34.4923 27.5371 34.5082 27.5412 34.5281 27.5412C34.5654 27.5412 34.6026 27.5412 34.6259 27.5272C34.6491 27.5132 34.677 27.4993 34.7003 27.476C34.7073 27.4644 34.7166 27.4516 34.7259 27.4388C34.7352 27.426 34.7445 27.4132 34.7515 27.4016C34.7515 27.3829 34.755 27.3678 34.7585 27.3527C34.762 27.3376 34.7655 27.3224 34.7655 27.3038C34.7655 27.2759 34.7655 27.2387 34.7515 27.2154C34.7489 27.2112 34.7464 27.2067 34.7438 27.2022C34.7321 27.1821 34.7193 27.16 34.7003 27.141C34.6829 27.1201 34.6629 27.1096 34.6442 27.0998C34.6379 27.0965 34.6317 27.0933 34.6259 27.0898ZM34.6328 27.4714C34.6235 27.4772 34.6142 27.483 34.6026 27.49C34.5793 27.5039 34.5514 27.5039 34.5281 27.5039C34.5002 27.5039 34.477 27.5039 34.4676 27.49C34.4444 27.49 34.4211 27.4667 34.4072 27.4527C34.3932 27.4295 34.3839 27.4155 34.3699 27.3922C34.356 27.369 34.356 27.3411 34.356 27.3178C34.356 27.2945 34.356 27.2666 34.3699 27.2433C34.3745 27.2358 34.3785 27.2282 34.3824 27.2209C34.3904 27.2059 34.3977 27.1923 34.4072 27.1828C34.4134 27.1735 34.4278 27.1663 34.4437 27.1584C34.4516 27.1544 34.4599 27.1503 34.4676 27.1456C34.477 27.1317 34.5049 27.1317 34.5281 27.1317C34.5514 27.1317 34.5793 27.1317 34.6026 27.1456C34.6102 27.1502 34.6178 27.1542 34.625 27.1581C34.64 27.1661 34.6537 27.1734 34.6631 27.1828C34.6701 27.1945 34.6759 27.2038 34.6817 27.2131C34.6875 27.2224 34.6933 27.2317 34.7003 27.2433C34.7143 27.2666 34.7143 27.2945 34.7143 27.3178C34.7143 27.3411 34.7143 27.369 34.7003 27.3922C34.6958 27.3998 34.6917 27.4074 34.6878 27.4147C34.6798 27.4297 34.6725 27.4433 34.6631 27.4527C34.6514 27.4597 34.6421 27.4655 34.6328 27.4714ZM34.5979 27.2247C34.5886 27.2154 34.5607 27.2015 34.5374 27.2015H34.5328V27.2154H34.4351V27.4388H34.4863V27.3504H34.5095L34.57 27.4388H34.6305L34.5561 27.3504C34.57 27.3504 34.5933 27.3411 34.6073 27.3271C34.6212 27.3131 34.6212 27.2899 34.6212 27.2759C34.6212 27.248 34.6119 27.2387 34.5979 27.2247ZM34.4909 27.3131V27.2526L34.5421 27.248C34.5514 27.248 34.5514 27.248 34.5654 27.262C34.5793 27.262 34.5793 27.2666 34.5793 27.2759C34.5793 27.2852 34.5793 27.2852 34.5654 27.2992C34.5654 27.3131 34.5561 27.3131 34.5421 27.3131H34.4909Z\" fill=\"#647180\"/>\n</g>\n</g>\n</svg>";

var MasterCardGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Mastercard, Color=Off\">\n<path id=\"Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M39 13.9999C39 9.02946 34.9922 5 30.0483 5C28.1678 5 26.4232 5.58334 24.9826 6.57924C27.2097 8.40934 28.4842 11.1044 28.4842 13.9999C28.4842 16.8954 27.2097 19.5904 24.9826 21.4207C26.4232 22.4165 28.1678 23 30.0483 23C34.9922 23 39 18.9705 39 13.9999ZM24.0175 6.57926C22.5769 5.58336 20.8323 5.00002 18.9518 5.00002C14.0079 5.00002 10 9.02948 10 14C10 18.9705 14.0079 23 18.9518 23C20.8323 23 22.5769 22.4166 24.0175 21.4207C21.7904 19.5904 20.5158 16.8954 20.5158 14C20.5158 11.1045 21.7904 8.40955 24.0175 6.57926ZM27.9035 14C27.9035 11.1364 26.5731 8.58538 24.5 6.93705C22.427 8.58538 21.0965 11.1364 21.0965 14C21.0965 16.8636 22.427 19.4145 24.5 21.063C26.5731 19.4145 27.9035 16.8636 27.9035 14ZM15.238 25.9225V27.4031H14.7623V26.039C14.7623 25.6361 14.573 25.4128 14.2235 25.4128C13.8837 25.4128 13.6215 25.6361 13.6215 26.0487V27.4128H13.1361V26.0487C13.1361 25.6458 12.9468 25.4225 12.5972 25.4225C12.2429 25.4225 11.9953 25.6458 11.9953 26.0584V27.4225H11.5099V25.0487H11.9856V25.3351C12.1749 25.0584 12.4516 24.9856 12.6992 24.9856C13.0584 24.9856 13.3254 25.1506 13.4856 25.4128C13.7138 25.073 14.0244 24.9856 14.3254 24.9856C14.8982 24.9856 15.238 25.3594 15.238 25.9225ZM22.1361 25.0487H23.0002V25.4856H22.1361V26.6215C22.1361 26.8594 22.2381 27.0196 22.5002 27.0196C22.6362 27.0196 22.8012 26.971 22.9614 26.8837L23.1119 27.3109C22.9468 27.4274 22.6847 27.5002 22.4614 27.5002C21.8497 27.5002 21.6507 27.1604 21.6507 26.6118V25.4856H21.1507V25.0487H21.6507V24.3254H22.1361V25.0487ZM26.7721 25.3351C26.908 25.1215 27.1216 24.9856 27.4226 24.9856C27.5245 24.9856 27.675 25.0002 27.7721 25.0438L27.6216 25.4953C27.51 25.4468 27.3983 25.4322 27.2964 25.4322C26.9614 25.4322 26.7721 25.6846 26.7721 26.0827V27.4225H26.2964V25.0487H26.7721V25.3351ZM19.7623 24.9904C20.1361 24.9904 20.4905 25.0778 20.7381 25.238L20.5099 25.6118C20.3643 25.5244 20.0633 25.4128 19.7623 25.4128C19.4759 25.4128 19.2866 25.539 19.2866 25.7138C19.2866 25.874 19.4905 25.9516 19.7138 25.9759L19.9614 26.0147C20.4857 26.0924 20.7721 26.3011 20.7721 26.7283C20.7721 27.1798 20.3983 27.505 19.7089 27.505C19.4614 27.505 19.0342 27.4565 18.6847 27.1943L18.9225 26.8206C19.0973 26.9565 19.3352 27.0681 19.7089 27.0681C20.0585 27.0681 20.2721 26.9565 20.2721 26.7672C20.2721 26.6264 20.1216 26.5293 19.8352 26.4905L19.5876 26.4516C19.0487 26.3788 18.7866 26.1409 18.7866 25.7526C18.7866 25.2769 19.1604 24.9904 19.7623 24.9904ZM29.2236 27.4856C28.4614 27.4856 27.976 26.9613 27.976 26.238C27.976 25.5099 28.4469 24.9856 29.2236 24.9807C29.5877 24.9807 29.8255 25.0681 30.0877 25.2672L29.8401 25.6409C29.6411 25.5002 29.4372 25.4273 29.2139 25.4273C28.8012 25.4371 28.476 25.7623 28.476 26.238C28.476 26.7138 28.8012 27.039 29.2139 27.039C29.442 27.039 29.6411 26.9613 29.8401 26.8254L30.0877 27.1992C29.8255 27.4128 29.5877 27.4856 29.2236 27.4856ZM23.4517 26.2332C23.4517 25.4856 23.9274 24.9856 24.6265 24.9856C25.2867 24.9856 25.7381 25.4856 25.7478 26.2283C25.7478 26.266 25.7439 26.3011 25.7402 26.335C25.7366 26.3665 25.7333 26.3969 25.7333 26.4274H23.9565C24.0197 26.8642 24.3546 27.0536 24.6944 27.0536C24.9323 27.0536 25.1944 26.9662 25.3935 26.806L25.641 27.1555C25.3546 27.4079 25.0294 27.4953 24.6653 27.4953C23.9517 27.4953 23.4517 26.9953 23.4517 26.2332ZM25.2381 26.0244C25.1993 25.6458 24.9614 25.4225 24.6119 25.4225C24.2235 25.4225 24.0002 25.6749 23.9517 26.0244H25.2381ZM18.1604 25.0487V26.238V27.4177H17.6847V27.1312C17.5099 27.3448 17.2478 27.4808 16.908 27.4808C16.2478 27.4808 15.7332 26.9565 15.7332 26.2332C15.7332 25.5099 16.2478 24.9856 16.908 24.9856C17.2478 24.9856 17.5245 25.1215 17.6847 25.3351V25.0487H18.1604ZM16.9711 25.4273C16.5099 25.4273 16.2235 25.7866 16.2235 26.238C16.2235 26.6846 16.5099 27.0342 16.9711 27.039C17.408 27.039 17.6944 26.6992 17.6944 26.238C17.6944 25.7672 17.408 25.4273 16.9711 25.4273ZM33.9712 25.3351C34.1071 25.1215 34.3207 24.9856 34.6217 24.9856C34.7236 24.9856 34.8741 25.0002 34.9809 25.0438L34.8207 25.4953C34.7091 25.4468 34.5974 25.4322 34.4955 25.4322C34.1605 25.4322 33.9712 25.6846 33.9712 26.0827V27.4225H33.4955V25.0487H33.9712V25.3351ZM38.5284 27.0867C38.5068 27.0795 38.4874 27.073 38.4615 27.073C38.4356 27.073 38.4162 27.0795 38.3946 27.0867C38.3838 27.0902 38.3725 27.094 38.3596 27.0973C38.3353 27.107 38.311 27.1215 38.2868 27.1458C38.2686 27.164 38.2585 27.1822 38.2485 27.2004C38.2452 27.2065 38.2418 27.2126 38.2382 27.2186C38.2382 27.2293 38.2354 27.2401 38.2322 27.252C38.2282 27.2672 38.2236 27.2843 38.2236 27.306C38.2236 27.3303 38.2236 27.3691 38.2382 27.3934C38.2479 27.4177 38.2625 27.4419 38.2868 27.4662C38.305 27.4844 38.3232 27.4944 38.3414 27.5044C38.3474 27.5078 38.3535 27.5111 38.3596 27.5147C38.3984 27.539 38.4227 27.539 38.4615 27.539C38.5003 27.539 38.5392 27.5293 38.5635 27.5147C38.5877 27.505 38.612 27.4905 38.6363 27.4662C38.6545 27.448 38.6645 27.4298 38.6745 27.4116C38.6778 27.4055 38.6812 27.3994 38.6848 27.3934C38.6945 27.3691 38.7091 27.3303 38.7091 27.306C38.7091 27.2817 38.6945 27.2429 38.6848 27.2186C38.6751 27.1943 38.6605 27.1701 38.6363 27.1458C38.6181 27.1276 38.5999 27.1176 38.5817 27.1076C38.5756 27.1042 38.5695 27.1009 38.5635 27.0973C38.5505 27.094 38.5392 27.0902 38.5284 27.0867ZM38.4979 27.4929C38.4858 27.4965 38.4736 27.5002 38.4615 27.5002C38.4372 27.5002 38.413 27.5002 38.3887 27.4856C38.3808 27.4809 38.3729 27.4766 38.3653 27.4726C38.3496 27.4642 38.3354 27.4566 38.3256 27.4468C38.3228 27.4421 38.3202 27.4378 38.3177 27.4337C38.3071 27.4166 38.2985 27.4033 38.2868 27.3837C38.2722 27.3594 38.2722 27.3351 38.2722 27.3109C38.2722 27.2866 38.2722 27.2623 38.2868 27.238C38.2868 27.2138 38.311 27.1895 38.3256 27.1749C38.3377 27.1676 38.3474 27.1616 38.3571 27.1555C38.3669 27.1494 38.3766 27.1434 38.3887 27.1361C38.413 27.1215 38.4372 27.1215 38.4615 27.1215C38.4858 27.1215 38.5101 27.1215 38.5343 27.1361C38.5422 27.1408 38.5501 27.1451 38.5577 27.1491C38.5734 27.1575 38.5876 27.1651 38.5974 27.1749C38.612 27.1992 38.6217 27.2138 38.6363 27.238C38.6508 27.2623 38.6508 27.2866 38.6508 27.3109C38.6508 27.3351 38.6508 27.3594 38.6363 27.3837C38.6315 27.3916 38.6273 27.3995 38.6232 27.4071C38.6149 27.4227 38.6073 27.437 38.5974 27.4468C38.5853 27.4541 38.5756 27.4601 38.5659 27.4662C38.5562 27.4723 38.5465 27.4783 38.5343 27.4856C38.5222 27.4856 38.5101 27.4893 38.4979 27.4929ZM38.5343 27.2235C38.5198 27.2138 38.4955 27.1992 38.4712 27.1992V27.2041H38.3693V27.4177H38.4178V27.3448H38.4421L38.5052 27.4177H38.5683L38.4955 27.3448C38.5198 27.3448 38.5295 27.3351 38.544 27.3206C38.5586 27.3109 38.5586 27.2866 38.5586 27.272C38.5586 27.2477 38.5489 27.238 38.5343 27.2235ZM38.4227 27.2963V27.2477V27.2332H38.4712C38.4756 27.2332 38.478 27.2361 38.4806 27.2394C38.4839 27.2433 38.4875 27.2477 38.4955 27.2477C38.5033 27.253 38.5069 27.2554 38.5086 27.2588C38.5101 27.2617 38.5101 27.2653 38.5101 27.272C38.5101 27.2817 38.5101 27.2963 38.4955 27.2963H38.4712H38.4227ZM32.7867 25.0487V26.238V27.4177H32.311V27.1312C32.1459 27.3448 31.8741 27.4808 31.5343 27.4808C30.8741 27.4808 30.3595 26.9565 30.3595 26.2332C30.3595 25.5099 30.8741 24.9856 31.5343 24.9856C31.8741 24.9856 32.1508 25.1215 32.311 25.3351V25.0487H32.7867ZM31.6071 25.4273C31.1459 25.4273 30.8595 25.7866 30.8595 26.238C30.8595 26.6846 31.1362 27.0342 31.6071 27.039C32.044 27.039 32.3304 26.6992 32.3304 26.238C32.3304 25.7672 32.044 25.4273 31.6071 25.4273ZM37.5974 24.0875V26.238V27.4177H37.1217V27.1312C36.9469 27.3448 36.6848 27.4808 36.345 27.4808C35.6848 27.4808 35.1702 26.9565 35.1702 26.2332C35.1702 25.5099 35.6702 24.9856 36.345 24.9856C36.6848 24.9856 36.9615 25.1215 37.1217 25.3351V24.0875H37.5974ZM36.413 25.4273C35.9615 25.4273 35.6751 25.7866 35.6751 26.238C35.6751 26.6846 35.9469 27.0342 36.413 27.039C36.8499 27.039 37.1363 26.6992 37.1363 26.238C37.1363 25.7672 36.8499 25.4273 36.413 25.4273Z\" fill=\"#647180\"/>\n</g>\n</svg>";

var MasterCardDebitoGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Mastercard_Debito, Color=Off\">\n<path id=\"Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M29.0483 2C33.9922 2 38 6.02946 38 10.9999C38 15.9705 33.9922 20 29.0483 20C27.1678 20 25.4232 19.4165 23.9826 18.4207C26.2097 16.5904 27.4842 13.8954 27.4842 10.9999C27.4842 8.10437 26.2097 5.40934 23.9826 3.57924C25.4232 2.58334 27.1678 2 29.0483 2ZM17.9518 2.00002C19.8323 2.00002 21.5769 2.58336 23.0175 3.57926C20.7904 5.40955 19.5158 8.10449 19.5158 11C19.5158 13.8954 20.7904 16.5904 23.0175 18.4207C21.5769 19.4166 19.8323 20 17.9518 20C13.0079 20 9 15.9705 9 11C9 6.02948 13.0079 2.00002 17.9518 2.00002ZM23.5 3.93705C25.5731 5.58538 26.9035 8.1364 26.9035 11C26.9035 13.8636 25.5731 16.4145 23.5 18.063C21.427 16.4145 20.0965 13.8636 20.0965 11C20.0965 8.1364 21.427 5.58538 23.5 3.93705ZM36.5514 23.7276V23.6688H36.6024C36.6137 23.6688 36.6234 23.6711 36.6304 23.6762C36.6368 23.6808 36.6406 23.6882 36.6406 23.6979C36.6406 23.7076 36.6368 23.7156 36.6304 23.7202C36.6234 23.7247 36.6137 23.7276 36.6024 23.7276H36.5514ZM36.6642 23.6465C36.6497 23.634 36.6293 23.6277 36.603 23.6277H36.5073V23.8475H36.5514V23.7653H36.5718L36.6346 23.8475H36.6873L36.6196 23.7647C36.6411 23.7618 36.6572 23.7544 36.6685 23.743C36.6803 23.731 36.6857 23.7162 36.6857 23.6979C36.6857 23.6762 36.6787 23.6591 36.6642 23.6465ZM36.6567 23.9085C36.6363 23.9183 36.6137 23.9234 36.5895 23.9234C36.5653 23.9234 36.5422 23.9183 36.5213 23.9085C36.4998 23.8988 36.481 23.8857 36.4654 23.8692C36.4498 23.8526 36.4375 23.8332 36.4289 23.8104C36.4198 23.7881 36.4155 23.7641 36.4155 23.7384C36.4155 23.7127 36.4198 23.6888 36.4289 23.6665C36.4375 23.6442 36.4498 23.6243 36.4654 23.6077C36.481 23.5911 36.4998 23.578 36.5213 23.5683C36.5422 23.5592 36.5653 23.5546 36.5895 23.5546C36.6137 23.5546 36.6363 23.5592 36.6567 23.5683C36.6776 23.578 36.6959 23.5911 36.7115 23.6077C36.7271 23.6243 36.7394 23.6442 36.7485 23.6665C36.7571 23.6888 36.762 23.7127 36.762 23.7384C36.762 23.7641 36.7571 23.7881 36.7485 23.8104C36.7394 23.8332 36.7271 23.8526 36.7115 23.8692C36.6959 23.8857 36.6776 23.8988 36.6567 23.9085ZM36.6782 23.5204C36.6502 23.5078 36.6212 23.5015 36.5895 23.5015C36.5573 23.5015 36.5277 23.5078 36.4998 23.5204C36.4719 23.5323 36.4477 23.5495 36.4273 23.5712C36.4069 23.5923 36.3907 23.6174 36.3789 23.6465C36.3671 23.6751 36.3612 23.7059 36.3612 23.7384C36.3612 23.771 36.3671 23.8018 36.3789 23.8303C36.3907 23.8589 36.4069 23.884 36.4273 23.9057C36.4477 23.9268 36.4719 23.9439 36.4998 23.9565C36.5277 23.9691 36.5573 23.9753 36.5895 23.9753C36.6212 23.9753 36.6502 23.9691 36.6782 23.9565C36.7056 23.9439 36.7292 23.9268 36.7502 23.9057C36.7706 23.884 36.7867 23.8589 36.7985 23.8303C36.8103 23.8018 36.8162 23.771 36.8162 23.7384C36.8162 23.7059 36.8103 23.6751 36.7985 23.6465C36.7867 23.6174 36.7706 23.5923 36.7502 23.5712C36.7292 23.5495 36.7056 23.5323 36.6782 23.5204ZM16.3386 21.8916C15.9163 21.8916 15.6579 22.2359 15.6579 22.6549C15.6579 23.0739 15.9163 23.4182 16.3386 23.4182C16.7421 23.4182 17.0145 23.0888 17.0145 22.6549C17.0145 22.221 16.7421 21.8916 16.3386 21.8916ZM17.4743 21.4629V22.6549V23.8469H16.9865V23.5575C16.8318 23.7721 16.597 23.9068 16.2779 23.9068C15.6488 23.9068 15.1556 23.3833 15.1556 22.6549C15.1556 21.927 15.6488 21.403 16.2779 21.403C16.597 21.403 16.8318 21.5377 16.9865 21.7524V21.4629H17.4743ZM34.6399 21.8916C34.2176 21.8916 33.9592 22.2359 33.9592 22.6549C33.9592 23.0739 34.2176 23.4182 34.6399 23.4182C35.0439 23.4182 35.3157 23.0888 35.3157 22.6549C35.3157 22.221 35.0439 21.8916 34.6399 21.8916ZM35.7761 20.5056V22.6549V23.8469H35.2878V23.5575C35.133 23.7721 34.8983 23.9068 34.5791 23.9068C33.95 23.9068 33.4568 23.3833 33.4568 22.6549C33.4568 21.927 33.95 21.403 34.5791 21.403C34.8983 21.403 35.133 21.5377 35.2878 21.7524V20.5056H35.7761ZM24.0975 22.4454C24.0459 22.0766 23.8439 21.8671 23.5296 21.8671C23.182 21.8671 22.9854 22.1012 22.9333 22.4454H24.0975ZM22.4218 22.6549C22.4218 21.9116 22.8817 21.403 23.5393 21.403C24.1679 21.403 24.5998 21.9116 24.6047 22.6549C24.6047 22.7246 24.5998 22.7896 24.595 22.8541H22.929C22.9994 23.2834 23.2857 23.4381 23.6 23.4381C23.8251 23.4381 24.0647 23.3479 24.2528 23.1887L24.4918 23.5729C24.2195 23.8172 23.91 23.9068 23.5721 23.9068C22.9005 23.9068 22.4218 23.413 22.4218 22.6549ZM30.1103 21.8916C29.6881 21.8916 29.4297 22.2359 29.4297 22.6549C29.4297 23.0739 29.6881 23.4182 30.1103 23.4182C30.5138 23.4182 30.7862 23.0888 30.7862 22.6549C30.7862 22.221 30.5138 21.8916 30.1103 21.8916ZM31.2461 21.4629V22.6549V23.8469H30.7583V23.5575C30.603 23.7721 30.3688 23.9068 30.0496 23.9068C29.4205 23.9068 28.9273 23.3833 28.9273 22.6549C28.9273 21.927 29.4205 21.403 30.0496 21.403C30.3688 21.403 30.603 21.5377 30.7583 21.7524V21.4629H31.2461ZM27.8716 23.9068C27.1485 23.9068 26.6747 23.3782 26.6747 22.6549C26.6747 21.9316 27.1485 21.403 27.8716 21.403C28.2096 21.403 28.4347 21.4829 28.6786 21.6873L28.4443 22.1063C28.2611 21.9664 28.0688 21.8916 27.8571 21.8916C27.4676 21.8968 27.1813 22.1959 27.1813 22.6549C27.1813 23.1139 27.4676 23.413 27.8571 23.4182C28.0688 23.4182 28.2611 23.3434 28.4443 23.2035L28.6786 23.6225C28.4347 23.8269 28.2096 23.9068 27.8716 23.9068ZM32.3727 21.7524C32.4995 21.5428 32.6827 21.403 32.9642 21.403C33.063 21.403 33.2038 21.423 33.3118 21.4681L33.1614 21.9567C33.0582 21.9116 32.9551 21.8968 32.8562 21.8968C32.5371 21.8968 32.3775 22.116 32.3775 22.5105V23.8469H31.8892V21.4629H32.3727V21.7524ZM18.9722 21.403C19.3289 21.403 19.6523 21.488 19.8871 21.6525L19.676 22.0715C19.5401 21.9818 19.2628 21.8671 18.9765 21.8671C18.7089 21.8671 18.5494 21.9716 18.5494 22.1463C18.5494 22.3061 18.7186 22.3506 18.9297 22.3803L19.1597 22.4157C19.648 22.4905 19.9435 22.7097 19.9435 23.1287C19.9435 23.5826 19.568 23.9068 18.9201 23.9068C18.5542 23.9068 18.2163 23.8069 17.9487 23.5974L18.1787 23.1938C18.3431 23.3285 18.587 23.4433 18.9249 23.4433C19.258 23.4433 19.4364 23.3382 19.4364 23.1539C19.4364 23.0191 19.3101 22.9443 19.0426 22.9044L18.8121 22.8696C18.3103 22.7948 18.0379 22.555 18.0379 22.1662C18.0379 21.6924 18.4038 21.403 18.9722 21.403ZM25.5905 21.7524C25.7168 21.5428 25.9 21.403 26.1815 21.403C26.2803 21.403 26.4211 21.423 26.5291 21.4681L26.3786 21.9567C26.2755 21.9116 26.1723 21.8968 26.0735 21.8968C25.7544 21.8968 25.5948 22.116 25.5948 22.5105V23.8469H25.107V21.4629H25.5905V21.7524ZM21.2206 21.4629H22.0184V21.9367H21.2206V23.014C21.2206 23.2532 21.3001 23.413 21.544 23.413C21.6708 23.413 21.8303 23.3679 21.9759 23.2783L22.1167 23.7224C21.962 23.8372 21.718 23.9068 21.5064 23.9068C20.9294 23.9068 20.7274 23.5774 20.7274 23.0243V21.9367H20.2723V21.4629H20.7274V20.7396H21.2206V21.4629ZM14.7242 22.3506V23.8469H14.231V22.5202C14.231 22.116 14.0714 21.8916 13.7383 21.8916C13.4144 21.8916 13.1893 22.1114 13.1893 22.5253V23.8469H12.6961V22.5202C12.6961 22.116 12.5322 21.8916 12.2083 21.8916C11.8746 21.8916 11.6587 22.1114 11.6587 22.5253V23.8469H11.166V21.4629H11.6544V21.7569C11.8376 21.4778 12.0718 21.403 12.3114 21.403C12.6542 21.403 12.8981 21.5628 13.0528 21.8271C13.2597 21.4926 13.5551 21.3978 13.8415 21.403C14.3863 21.4081 14.7242 21.7872 14.7242 22.3506ZM29.8048 29.5385C29.7567 29.202 29.6071 28.9355 29.3489 28.7501C29.1167 28.5834 28.8617 28.5333 28.5908 28.5729C28.3713 28.605 28.1764 28.7007 28.0146 28.8706C27.7917 29.1044 27.6892 29.3976 27.6855 29.768L27.6867 29.7818L27.6883 29.8048C27.6909 29.8425 27.6943 29.8921 27.7018 29.9408C27.758 30.3036 27.9252 30.5822 28.2144 30.7619C28.4457 30.9057 28.6948 30.9421 28.9539 30.8927C29.2211 30.8418 29.443 30.6994 29.607 30.4574C29.7917 30.185 29.8528 29.8741 29.8048 29.5385ZM28.7346 28.9265L28.7479 28.9257C29.1154 28.9267 29.3991 29.1948 29.4536 29.6005C29.4915 29.8822 29.4284 30.1356 29.2401 30.3366C29.0923 30.4943 28.9115 30.5584 28.7086 30.5469C28.5515 30.538 28.4121 30.4775 28.291 30.3654C28.1594 30.2435 28.083 30.0851 28.054 29.8986C28.0197 29.6772 28.0466 29.4655 28.1579 29.2755C28.2843 29.0596 28.4682 28.9487 28.697 28.929C28.7101 28.9278 28.7233 28.9271 28.7346 28.9265ZM27.1594 30.833C27.2423 30.7962 27.3205 30.75 27.3939 30.6882L27.2312 30.3975L27.2138 30.4096L27.1981 30.4204C27.0652 30.5083 26.9243 30.563 26.7673 30.545C26.629 30.5291 26.5294 30.4516 26.4755 30.3061C26.4474 30.23 26.4387 30.1497 26.4387 30.0681C26.4385 29.8093 26.4385 29.5504 26.4386 29.2916L26.4386 28.9998V28.9618H27.2835V28.6077H26.4381V27.9017H26.0894V28.6093H25.6625V28.9634H26.0904V29.0091C26.0904 29.1085 26.0902 29.2078 26.09 29.3072C26.0895 29.5686 26.089 29.83 26.0922 30.0913C26.0935 30.1945 26.107 30.2997 26.1299 30.3997C26.1837 30.6346 26.3105 30.8019 26.5237 30.8705C26.7385 30.9396 26.9513 30.9254 27.1594 30.833ZM21.56 29.3755C21.5 29.1215 21.3872 28.9041 21.1927 28.7499C20.9802 28.5813 20.7418 28.5309 20.4868 28.5742C20.1903 28.6245 19.9572 28.7893 19.803 29.0782C19.6431 29.3778 19.6104 29.7051 19.6776 30.041C19.7586 30.4454 19.9725 30.7272 20.331 30.8547C20.5945 30.9485 20.8582 30.9262 21.1184 30.8319C21.2636 30.7793 21.3875 30.6865 21.4991 30.5699L21.3152 30.3052C21.3086 30.3106 21.3052 30.3131 21.302 30.3159C21.0963 30.5027 20.8643 30.5989 20.597 30.5654C20.3898 30.5394 20.2243 30.433 20.1124 30.2323C20.052 30.124 20.0192 30.005 20.0074 29.8744H21.5895C21.591 29.8669 21.5922 29.8626 21.5926 29.8581C21.6068 29.6951 21.5973 29.5337 21.56 29.3755ZM20.2142 29.0889C20.3356 28.9545 20.4866 28.9017 20.6524 28.9049C21.0481 28.9126 21.2255 29.2799 21.2411 29.5594H20.0115C20.0356 29.3774 20.0973 29.2183 20.2142 29.0889ZM25.1785 30.8636H24.8356V28.6107H25.1785V30.8636ZM25.0062 28.0852C25.1451 28.0823 25.2521 27.9612 25.2511 27.8081C25.25 27.6528 25.1409 27.5354 24.9991 27.5368C24.8637 27.5381 24.7576 27.6609 24.7592 27.8144C24.7608 27.966 24.8721 28.088 25.0062 28.0852ZM22.5289 28.9038V27.4451H22.1855V30.8622H22.5321V30.5802C22.5512 30.5976 22.57 30.6156 22.5887 30.6337L22.5887 30.6337C22.6296 30.6731 22.6705 30.7124 22.7152 30.7454C22.9289 30.9031 23.1652 30.9421 23.4141 30.8933C23.7629 30.825 24.0101 30.605 24.1547 30.2465C24.2498 30.0106 24.2709 29.7611 24.2303 29.5054C24.1856 29.2241 24.0694 28.9882 23.8711 28.8076C23.6565 28.6123 23.4076 28.5396 23.1338 28.5664C22.9034 28.5888 22.7081 28.6923 22.5505 28.883C22.5455 28.889 22.5394 28.8938 22.5289 28.9038ZM22.6263 29.269C22.7596 29.0364 22.9569 28.9312 23.1804 28.9257C23.5365 28.9253 23.812 29.1803 23.8757 29.5513C23.9213 29.8167 23.8791 30.0614 23.728 30.2752C23.61 30.4421 23.451 30.5278 23.2622 30.5453C23.0778 30.5623 22.911 30.5109 22.7659 30.3808C22.6288 30.2577 22.5523 30.0934 22.5218 29.9028C22.4858 29.6779 22.5152 29.463 22.6263 29.269ZM20.374 28.2268C20.369 28.235 20.3648 28.2438 20.3585 28.2553L20.366 28.2568L20.3661 28.2568C20.3701 28.2576 20.3732 28.2582 20.3763 28.2582L20.4338 28.2584C20.5152 28.2586 20.5965 28.2588 20.6779 28.2574C20.6898 28.2572 20.7048 28.2464 20.713 28.2355C20.8594 28.041 21.0051 27.8459 21.1509 27.6508L21.1511 27.6506L21.1512 27.6503L21.1839 27.6066C21.1933 27.5941 21.2023 27.5813 21.2123 27.5672L21.2284 27.5446L21.1241 27.5447C21.0198 27.5448 20.9185 27.5449 20.8173 27.544C20.7971 27.5439 20.7859 27.5513 20.7748 27.5697C20.6765 27.7317 20.5777 27.8933 20.479 28.055L20.4786 28.0557L20.4782 28.0563L20.374 28.2268ZM19.0644 30.8622V27.4452H18.7162V28.8956C18.6966 28.8777 18.6772 28.8589 18.6578 28.8402L18.6577 28.8401L18.6577 28.8401C18.6151 28.7989 18.5721 28.7573 18.525 28.7227C18.3189 28.5711 18.0892 28.5326 17.8495 28.5745C17.5096 28.6338 17.2606 28.8395 17.1082 29.1843C16.9946 29.4412 16.9697 29.7144 17.0203 29.9935C17.0855 30.3536 17.259 30.6277 17.5554 30.7961C17.7522 30.908 17.9616 30.935 18.1777 30.8977C18.3237 30.8725 18.4597 30.8147 18.5765 30.7104C18.6094 30.681 18.6406 30.6491 18.6724 30.6167L18.6858 30.603C18.6961 30.5926 18.7064 30.5822 18.7169 30.5717V30.8622H19.0644ZM17.5557 29.1483C17.6893 28.9952 17.8562 28.9261 18.0456 28.9262C18.2398 28.9264 18.4096 28.998 18.5442 29.1581C18.6533 29.288 18.7131 29.4449 18.7316 29.6214C18.7532 29.8269 18.7247 30.0227 18.6241 30.1981C18.4791 30.4508 18.2662 30.5599 18.001 30.5464C17.6899 30.5305 17.4099 30.274 17.3606 29.8638C17.357 29.8335 17.3549 29.8029 17.3533 29.778L17.3514 29.7512C17.3552 29.5118 17.4139 29.3109 17.5557 29.1483ZM10 26.3333H37.9821V26.2437H10V26.3333Z\" fill=\"#647180\"/>\n</g>\n</svg>";

var ModoGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Modo, Color=Off\">\n<g id=\"Modo\">\n<g id=\"Group\">\n<path id=\"Vector\" d=\"M7.76974 19.7557C7.34572 19.7557 7.0022 19.4121 7.0022 18.9881V16.6794C7.0022 16.2554 7.34572 15.9119 7.76974 15.9119C8.19376 15.9119 8.53728 16.2554 8.53728 16.6794V18.9881C8.53728 19.4119 8.19351 19.7557 7.76974 19.7557Z\" fill=\"#647180\"/>\n</g>\n<path id=\"Vector_2\" opacity=\"0.4\" d=\"M14.3684 19.7556C14.7924 19.7556 15.1359 19.4121 15.1359 18.9881V18.9352C15.1086 18.5349 14.7754 18.2185 14.3684 18.2185C13.9613 18.2185 13.6282 18.5347 13.6008 18.9349V18.9881C13.6008 19.4118 13.9444 19.7556 14.3684 19.7556Z\" fill=\"#647180\"/>\n<path id=\"Vector_3\" opacity=\"0.4\" d=\"M14.3684 13.61C14.7755 13.61 15.1086 13.2938 15.136 12.8933V12.8404C15.136 12.507 14.9206 12.2116 14.6031 12.1096C14.2857 12.0075 13.9386 12.1225 13.7444 12.3936L13.7115 12.4397C13.6401 12.5564 13.5991 12.6936 13.5991 12.8404C13.5989 13.2654 13.9434 13.61 14.3684 13.61Z\" fill=\"#647180\"/>\n<g id=\"Group_2\" opacity=\"0.4\">\n<path id=\"Vector_4\" opacity=\"0.4\" d=\"M11.0689 18.2186C11.4939 18.2186 11.8385 17.874 11.8385 17.449C11.8385 17.024 11.4939 16.6794 11.0689 16.6794C10.6439 16.6794 10.2993 17.024 10.2993 17.449C10.2993 17.874 10.6439 18.2186 11.0689 18.2186Z\" fill=\"#647180\"/>\n</g>\n<path id=\"Vector_5\" d=\"M20.1895 19.8342C20.2183 19.8375 20.2474 19.8393 20.277 19.8393C20.3067 19.8393 20.3355 19.8375 20.3644 19.8342C20.3353 19.8347 20.3062 19.8352 20.277 19.8352C20.2477 19.8352 20.2186 19.8347 20.1895 19.8342Z\" fill=\"#647180\"/>\n<path id=\"Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.3409 12.0028C20.3199 12.001 20.2987 12 20.2771 12C19.8521 12 19.5076 12.3445 19.5076 12.7696C19.5076 13.1946 19.8521 13.5391 20.2771 13.5391C20.2923 13.5391 20.3075 13.5386 20.3225 13.5376C21.6148 13.5619 22.6585 14.6206 22.6585 15.9185C22.6585 16.5562 22.4112 17.1548 21.9623 17.6037C21.5138 18.0523 20.9156 18.2996 20.2784 18.2998C20.7029 18.3006 21.0467 18.6449 21.0467 19.0694C21.0467 19.1366 21.0381 19.2019 21.0219 19.264C21.038 19.202 21.0466 19.1368 21.0466 19.0697C21.0466 18.6447 20.7021 18.3001 20.277 18.3001H20.2758C18.9632 18.2994 17.8954 17.2313 17.8954 15.9188C17.8954 15.2867 18.1438 14.6862 18.5949 14.2283C18.8923 13.9263 18.8885 13.4402 18.5865 13.1428C18.2845 12.8453 17.7985 12.8491 17.501 13.1511C16.7656 13.8982 16.3606 14.8809 16.3606 15.9188C16.3606 18.049 18.0701 19.7874 20.1895 19.8342C20.2183 19.8375 20.2474 19.8393 20.277 19.8393C20.3083 19.8393 20.3391 19.8374 20.3693 19.8338C21.3826 19.8106 22.3308 19.4065 23.0478 18.6892C23.7868 17.9502 24.1936 16.9663 24.1936 15.9185C24.1938 13.7804 22.4712 12.0372 20.3409 12.0028ZM13.7444 12.3936C13.9385 12.1225 14.2856 12.0075 14.603 12.1096C14.9205 12.2116 15.1359 12.5068 15.1357 12.8404V18.9876C15.1357 19.4116 14.7921 19.7551 14.3681 19.7551C13.9441 19.7551 13.6006 19.4114 13.6006 18.9876V15.2306L11.7295 17.8442C11.595 18.0684 11.3496 18.2185 11.0691 18.2185C10.7909 18.2185 10.5471 18.0709 10.4119 17.8496L7.14555 13.2872C6.89873 12.9426 6.97797 12.4632 7.32275 12.2163C7.66729 11.9695 8.14675 12.0488 8.39357 12.3936L11.069 16.1301L13.7444 12.3936ZM7.76957 17.449C8.19459 17.449 8.53914 17.1045 8.53914 16.6795C8.53914 16.2545 8.19459 15.9099 7.76957 15.9099C7.34455 15.9099 7 16.2545 7 16.6795C7 17.1045 7.34455 17.449 7.76957 17.449Z\" fill=\"#647180\"/>\n<g id=\"Group_3\" opacity=\"0.4\">\n<path id=\"Vector_6\" opacity=\"0.4\" d=\"M20.2771 19.8392C20.7022 19.8392 21.0467 19.4946 21.0467 19.0696C21.0467 18.6446 20.7022 18.3 20.2771 18.3C19.8521 18.3 19.5076 18.6446 19.5076 19.0696C19.5076 19.4946 19.8521 19.8392 20.2771 19.8392Z\" fill=\"#647180\"/>\n</g>\n<g id=\"Group_4\" opacity=\"0.4\">\n<path id=\"Vector_7\" opacity=\"0.4\" d=\"M20.2771 13.5391C20.7022 13.5391 21.0467 13.1946 21.0467 12.7696C21.0467 12.3445 20.7022 12 20.2771 12C19.8521 12 19.5076 12.3445 19.5076 12.7696C19.5076 13.1946 19.8521 13.5391 20.2771 13.5391Z\" fill=\"#647180\"/>\n</g>\n<path id=\"Vector_8\" d=\"M31.1208 13.0408C30.4115 12.4077 29.4483 12.073 28.3355 12.073H26.0356C25.6118 12.073 25.2681 12.4165 25.2681 12.8405C25.2681 13.2646 25.6116 13.6081 26.0356 13.6081H28.3355C29.0653 13.6081 29.6751 13.8081 30.0989 14.186C30.5442 14.5835 30.7702 15.1665 30.7702 15.9188C30.7702 16.6686 30.5439 17.2496 30.0974 17.6455C29.6731 18.0217 29.064 18.2207 28.3355 18.2207H26.8032V18.907C26.8059 18.933 26.8072 18.9594 26.8072 18.9862C26.8072 19.4112 26.4627 19.7558 26.0376 19.7558H28.3355C29.445 19.7558 30.4065 19.4231 31.1158 18.7941C31.8937 18.104 32.3051 17.1099 32.3051 15.9188C32.3048 14.7273 31.8955 13.7321 31.1208 13.0408Z\" fill=\"#647180\"/>\n<path id=\"Vector_9\" d=\"M26.8029 18.9066V18.2203V15.1491C26.8029 14.7251 26.4594 14.3816 26.0354 14.3816C25.6116 14.3816 25.2678 14.7251 25.2678 15.1491V18.9861C25.2678 19.4109 25.6119 19.7552 26.0364 19.7557C26.0361 19.7557 26.0356 19.7557 26.0354 19.7557H26.0374C26.4624 19.7557 26.807 19.4111 26.807 18.9861C26.807 18.9593 26.8057 18.9327 26.8029 18.9066Z\" fill=\"#647180\"/>\n<g id=\"Group_5\" opacity=\"0.4\">\n<path id=\"Vector_10\" opacity=\"0.4\" d=\"M26.0354 13.6081C26.4593 13.6081 26.8029 13.2644 26.8029 12.8405C26.8029 12.4166 26.4593 12.073 26.0354 12.073C25.6115 12.073 25.2678 12.4166 25.2678 12.8405C25.2678 13.2644 25.6115 13.6081 26.0354 13.6081Z\" fill=\"#647180\"/>\n</g>\n<g id=\"Group_6\" opacity=\"0.4\">\n<path id=\"Vector_11\" opacity=\"0.4\" d=\"M26.0374 19.7557C26.4624 19.7557 26.807 19.4111 26.807 18.9861C26.807 18.5611 26.4624 18.2166 26.0374 18.2166C25.6124 18.2166 25.2678 18.5611 25.2678 18.9861C25.2678 19.4111 25.6124 19.7557 26.0374 19.7557Z\" fill=\"#647180\"/>\n</g>\n<path id=\"Vector_12\" d=\"M37.1473 12.0028C37.1263 12.001 37.1051 12 37.0835 12C36.6585 12 36.314 12.3445 36.314 12.7696C36.314 13.1946 36.6585 13.5391 37.0835 13.5391C37.0987 13.5391 37.1139 13.5386 37.1288 13.5376C38.4212 13.5619 39.4649 14.6206 39.4649 15.9185C39.4649 16.5562 39.2176 17.1548 38.7687 17.6037C38.3202 18.0523 37.722 18.2996 37.0848 18.2998C37.5093 18.3006 37.8531 18.6449 37.8531 19.0694C37.8531 19.4648 37.5546 19.7906 37.1709 19.8339C38.186 19.8119 39.1361 19.4076 39.8542 18.6892C40.5932 17.9502 41 16.9663 41 15.9185C41.0002 13.7804 39.2776 12.0372 37.1473 12.0028Z\" fill=\"#647180\"/>\n<path id=\"Vector_13\" d=\"M37.0834 18.3001C37.0829 18.3001 37.0827 18.3001 37.0822 18.3001C35.7696 18.2994 34.7018 17.2313 34.7018 15.9188C34.7018 15.2867 34.9502 14.6862 35.4013 14.2283C35.6987 13.9263 35.6949 13.4402 35.3929 13.1428C35.0909 12.8453 34.6049 12.8491 34.3074 13.1511C33.572 13.8982 33.167 14.8809 33.167 15.9188C33.167 18.049 34.8765 19.7874 36.9959 19.8342C37.0247 19.8375 37.0538 19.8393 37.0834 19.8393C37.5085 19.8393 37.853 19.4947 37.853 19.0697C37.853 18.6447 37.5085 18.3001 37.0834 18.3001Z\" fill=\"#647180\"/>\n<g id=\"Group_7\" opacity=\"0.4\">\n<path id=\"Vector_14\" opacity=\"0.4\" d=\"M37.0835 19.8392C37.5086 19.8392 37.8531 19.4946 37.8531 19.0696C37.8531 18.6446 37.5086 18.3 37.0835 18.3C36.6585 18.3 36.314 18.6446 36.314 19.0696C36.314 19.4946 36.6585 19.8392 37.0835 19.8392Z\" fill=\"#647180\"/>\n</g>\n<g id=\"Group_8\" opacity=\"0.4\">\n<path id=\"Vector_15\" opacity=\"0.4\" d=\"M37.0835 13.5391C37.5086 13.5391 37.8531 13.1946 37.8531 12.7696C37.8531 12.3445 37.5086 12 37.0835 12C36.6585 12 36.314 12.3445 36.314 12.7696C36.314 13.1946 36.6585 13.5391 37.0835 13.5391Z\" fill=\"#647180\"/>\n</g>\n</g>\n</g>\n</svg>";

var NaranjaGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Naranja, Color=Off\">\n<g id=\"Naranja\">\n<path id=\"Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.2984 19.3254C15.4388 19.6613 15.7697 19.8956 16.1581 19.8956C16.181 19.8956 16.2037 19.8948 16.2262 19.8932C16.2802 19.8894 16.334 19.881 16.3869 19.8674C16.7899 19.7657 17.0875 19.4012 17.0898 18.9639V10.9317C17.0898 10.415 16.6748 10 16.1581 10C15.6413 10 15.2263 10.423 15.2263 10.9317V15.3626L12.5302 10.4872C12.2812 10.0374 11.7217 9.8714 11.2719 10.1177C10.9359 10.3037 10.7582 10.663 10.7925 11.0204V13.5126C10.7925 15.0548 9.54218 16.3052 8 16.3052V18.166C10.2638 18.166 12.1568 16.5345 12.5642 14.3811L15.2984 19.3254ZM17.9007 10.5544C17.9007 10.4901 17.8793 10.4312 17.8365 10.3803C17.7856 10.3214 17.7187 10.2947 17.6303 10.2893C17.566 10.2893 17.5071 10.3107 17.4563 10.3536C17.3974 10.4044 17.3679 10.4687 17.3679 10.5437C17.3679 10.6186 17.3974 10.6829 17.4482 10.7338C17.4991 10.7846 17.566 10.8141 17.6383 10.8141C17.7026 10.8141 17.7615 10.7927 17.8124 10.7498C17.8713 10.6989 17.9007 10.6347 17.9007 10.5544ZM17.4349 10.557C17.4349 10.5062 17.4482 10.4553 17.4857 10.4178C17.5312 10.3723 17.5741 10.3509 17.6383 10.3536C17.6892 10.3536 17.7401 10.367 17.7776 10.4044C17.8204 10.4473 17.8418 10.4981 17.8418 10.557C17.8418 10.6079 17.8284 10.6588 17.7909 10.6963C17.7535 10.7391 17.7026 10.7605 17.6383 10.7605C17.5875 10.7605 17.5366 10.7471 17.4991 10.7097C17.4643 10.6668 17.4349 10.6079 17.4349 10.557ZM17.6464 10.4607C17.6758 10.4607 17.6972 10.466 17.7267 10.5035L17.7776 10.4526C17.7347 10.4151 17.6999 10.3937 17.6544 10.3937C17.6089 10.3937 17.5741 10.4071 17.5446 10.4366C17.5071 10.4633 17.4938 10.5089 17.4938 10.5517C17.4938 10.5892 17.5018 10.624 17.5312 10.6534C17.558 10.6909 17.5955 10.7043 17.6464 10.7043C17.6892 10.7043 17.724 10.6909 17.7615 10.6534L17.7695 10.6454L17.7267 10.6026C17.7125 10.6185 17.7018 10.6263 17.6939 10.632C17.6899 10.6349 17.6866 10.6373 17.6839 10.64C17.6758 10.6481 17.6598 10.6481 17.6464 10.6481C17.6196 10.6481 17.5955 10.632 17.5821 10.6186C17.5607 10.6052 17.5527 10.5838 17.5527 10.5544C17.5527 10.5329 17.5687 10.5035 17.5821 10.4901C17.5955 10.4687 17.6169 10.4607 17.6464 10.4607ZM18.9402 19.5771V15.2451H19.6042L21.8585 18.2545V15.2451H22.6296V19.5771H21.9683L19.7113 16.5677V19.5771H18.9402ZM25.403 19.5771H26.1419V16.6962H25.4003V16.8783C25.1593 16.6962 24.8969 16.6025 24.6292 16.6025C24.2436 16.6025 23.9116 16.7337 23.6198 16.9881C23.2851 17.2933 23.1191 17.6708 23.1191 18.1367C23.1191 18.5383 23.2503 18.8783 23.5127 19.1701C23.8099 19.5048 24.1821 19.6708 24.6319 19.6708C24.9023 19.6708 25.1566 19.5851 25.403 19.395V19.5771ZM23.8635 18.1367C23.8635 17.9037 23.9224 17.7136 24.0375 17.5691C24.1901 17.3736 24.3855 17.2799 24.6345 17.2746C24.8594 17.2746 25.0415 17.3468 25.1861 17.4995C25.3387 17.6601 25.411 17.8689 25.411 18.1313C25.411 18.3616 25.3548 18.5517 25.245 18.7043C25.0924 18.8997 24.8969 19.0015 24.6426 19.0015C24.423 19.0015 24.241 18.9211 24.0964 18.7766C23.9357 18.624 23.8635 18.4044 23.8635 18.1367ZM27.5694 16.8863C27.7354 16.7471 27.9174 16.6828 28.137 16.6828C28.2093 16.6828 28.303 16.6909 28.4128 16.7043V17.3656C28.2976 17.3575 28.2093 17.3522 28.145 17.3522C27.9282 17.3522 27.7809 17.4111 27.6952 17.5343C27.6149 17.6574 27.5721 17.877 27.5721 18.1956V19.5771H26.8304V16.6989H27.5721L27.5694 16.8863ZM30.9294 19.5771H31.6683V16.6962H30.9267V16.8783C30.6777 16.6962 30.4153 16.6025 30.1476 16.6025C29.762 16.6025 29.43 16.7337 29.1382 16.9881C28.8035 17.2933 28.6375 17.6708 28.6375 18.1367C28.6375 18.5383 28.7687 18.8783 29.0311 19.1701C29.3283 19.5048 29.7004 19.6708 30.1502 19.6708C30.4287 19.6708 30.683 19.5851 30.9294 19.395V19.5771ZM29.3872 18.1367C29.3872 17.9037 29.4461 17.7136 29.5612 17.5691C29.7138 17.3736 29.9093 17.2799 30.1583 17.2746C30.3832 17.2746 30.5652 17.3468 30.7098 17.4995C30.8624 17.6601 30.9347 17.8689 30.9347 18.1313C30.9347 18.3616 30.8785 18.5517 30.7687 18.7043C30.6161 18.8997 30.4206 19.0015 30.1663 19.0015C29.9468 19.0015 29.7727 18.9211 29.6201 18.7766C29.4595 18.624 29.3872 18.4044 29.3872 18.1367ZM33.095 16.8515C33.2985 16.6855 33.5234 16.6052 33.7644 16.6052C34.1071 16.6052 34.4391 16.7498 34.6586 16.9907C34.8835 17.2317 34.9772 17.5423 34.9772 18.0376V19.5798H34.2356V18.0831C34.2356 17.7645 34.1847 17.5449 34.091 17.4352C33.9973 17.3334 33.8661 17.2826 33.7055 17.2826C33.4939 17.2826 33.336 17.3468 33.2262 17.478C33.1378 17.5878 33.095 17.8046 33.095 18.1393V19.5798H32.3534V16.6989H33.095V16.8515ZM36.5625 15.7217C36.5625 15.5985 36.5197 15.4968 36.4313 15.4031C36.3349 15.3174 36.2278 15.2665 36.1127 15.2719C35.9815 15.2719 35.8718 15.3147 35.778 15.4031C35.6817 15.4887 35.6388 15.5985 35.6388 15.7217C35.6388 15.8529 35.6843 15.96 35.778 16.0483C35.8637 16.1367 35.9735 16.1795 36.1047 16.1795C36.2359 16.1795 36.3376 16.1367 36.4313 16.0483C36.5197 15.9546 36.5625 15.8448 36.5625 15.7217ZM39.9974 19.5771H39.2585V19.395C39.0122 19.5851 38.7578 19.6708 38.4874 19.6708C38.0376 19.6708 37.6654 19.5048 37.3682 19.1701C37.1058 18.8783 36.9747 18.5383 36.9747 18.1367C36.9747 17.6708 37.1407 17.2933 37.4753 16.9881C37.7672 16.7337 38.0992 16.6025 38.4847 16.6025C38.7524 16.6025 39.0148 16.6962 39.2558 16.8783V16.6962H39.9974V19.5771ZM37.8984 17.5691C37.7832 17.7136 37.7243 17.9037 37.7243 18.1367C37.7243 18.4044 37.7966 18.624 37.9573 18.7766C38.1099 18.9211 38.2839 19.0015 38.5035 19.0015C38.7578 19.0015 38.9533 18.8997 39.1059 18.7043C39.2156 18.5517 39.2719 18.3616 39.2719 18.1313C39.2719 17.8689 39.1996 17.6601 39.047 17.4995C38.9024 17.3468 38.7203 17.2746 38.4954 17.2746C38.2491 17.2799 38.051 17.3736 37.8984 17.5691ZM35.7246 19.7003V16.6989H36.4582V19.7592C36.3993 21.0524 34.9963 21.0738 34.9963 21.0738V20.3616C35.6737 20.3241 35.7246 19.8101 35.7246 19.7003Z\" fill=\"#647180\"/>\n</g>\n</g>\n</svg>";

var NoneGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=None, Color=Off\">\n<g id=\"planes-gobierno_24\">\n<path id=\"icon-fill\" d=\"M28.7917 7.42847C30.7021 7.42847 31.3949 7.62738 32.0933 8.00089C32.7917 8.37441 33.3398 8.92253 33.7134 9.62094C34.0869 10.3194 34.2858 11.0121 34.2858 12.9225V19.0773C34.2858 20.9877 34.0869 21.6804 33.7134 22.3788C33.3398 23.0773 32.7917 23.6254 32.0933 23.9989C31.3949 24.3724 30.7021 24.5713 28.7917 24.5713H19.2084C17.298 24.5713 16.6052 24.3724 15.9068 23.9989C15.2084 23.6254 14.6603 23.0773 14.2868 22.3788C13.9133 21.6804 13.7144 20.9877 13.7144 19.0773V12.9225C13.7144 11.0121 13.9133 10.3194 14.2868 9.62094C14.6603 8.92253 15.2084 8.37441 15.9068 8.00089C16.6052 7.62738 17.298 7.42847 19.2084 7.42847H28.7917ZM32.5706 15.1428H15.4278L15.4286 19.5606C15.4286 20.7069 15.548 21.1225 15.7721 21.5416C15.9962 21.9606 16.3251 22.2895 16.7441 22.5136C17.137 22.7237 17.5269 22.8417 18.5185 22.8556L18.7251 22.857H29.2751C30.4213 22.857 30.837 22.7377 31.256 22.5136C31.6751 22.2895 32.0039 21.9606 32.228 21.5416C32.4381 21.1487 32.5562 20.7588 32.5701 19.7671L32.5715 19.5606L32.5706 15.1428ZM19.4961 17.7142C19.8501 17.7142 19.9933 17.754 20.133 17.8287C20.2727 17.9034 20.3823 18.013 20.457 18.1527C20.5317 18.2924 20.5715 18.4356 20.5715 18.7896V19.2102C20.5715 19.5642 20.5317 19.7074 20.457 19.8471C20.3823 19.9868 20.2727 20.0964 20.133 20.1711C19.9933 20.2458 19.8501 20.2856 19.4961 20.2856H19.0754C18.7215 20.2856 18.5782 20.2458 18.4386 20.1711C18.2989 20.0964 18.1893 19.9868 18.1146 19.8471C18.0399 19.7074 18.0001 19.5642 18.0001 19.2102V18.7896C18.0001 18.4356 18.0399 18.2924 18.1146 18.1527C18.1893 18.013 18.2989 17.9034 18.4386 17.8287C18.5782 17.754 18.7215 17.7142 19.0754 17.7142H19.4961ZM29.2751 9.14275H18.7251C17.5788 9.14275 17.1632 9.2621 16.7441 9.48621C16.3251 9.71032 15.9962 10.0392 15.7721 10.4582C15.562 10.8511 15.444 11.241 15.43 12.2326L15.4286 12.4392L15.4278 12.5713H32.5706L32.5715 12.4392C32.5715 11.2929 32.4521 10.8773 32.228 10.4582C32.0039 10.0392 31.6751 9.71032 31.256 9.48621C30.8632 9.27611 30.4733 9.15808 29.4816 9.14415L29.2751 9.14275Z\" fill=\"#647180\"/>\n</g>\n</g>\n</svg>";

var TodoPagoGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Todopago, Color=Off\">\n<g id=\"Todopago\">\n<g id=\"Header/desktop Copy\">\n<g id=\"Varios/color/logo TodoPago color\">\n<g id=\"Varios/color/logo TodoPago iso color\">\n<path id=\"Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.8115 9H8.31239C7.58758 9 7 9.59181 7 10.3219V20.8967C7 21.6267 7.58758 22.2185 8.31239 22.2185H18.8115C19.5364 22.2185 20.1239 21.6267 20.1239 20.8967V10.3219C20.1239 9.59181 19.5364 9 18.8115 9ZM9.26424 12.2085H16.0311C17.5812 12.2085 18.5186 13.134 18.5186 14.4709V14.4896C18.5186 16.004 17.3491 16.7893 15.8919 16.7893L14.7212 16.7893C14.6479 16.7893 14.6255 16.8654 14.6764 16.912L15.0481 17.2428V18.2902C15.0481 18.6923 14.7325 19.0101 14.3334 19.0101C13.9343 19.0101 13.6187 18.6923 13.6187 18.2902V16.4466C13.6187 15.9223 14.0302 15.5051 14.6598 15.5051H15.9383C16.653 15.5051 17.0707 15.0785 17.0707 14.5176V14.4989C17.0707 13.8538 16.6252 13.5353 15.9104 13.5353H11.9348C11.8209 13.5353 11.8106 13.623 11.8946 13.6846L12.2411 13.9908V18.2902C12.2411 18.6923 11.9255 19.0101 11.5264 19.0101C11.1273 19.0101 10.8117 18.6923 10.8117 18.2902V13.536H9.26424C8.90226 13.536 8.60522 13.2368 8.60522 12.8723C8.60522 12.5077 8.90226 12.2085 9.26424 12.2085ZM35.0557 16.3873C34.635 16.0914 34.1675 15.93 33.4596 15.93C32.0438 15.93 31.0088 17.0263 31.0088 18.3649V18.3783C31.0088 19.7707 32.0105 20.7998 33.4663 20.7998C34.1675 20.7998 34.7218 20.5644 35.1024 20.3289C35.3495 20.181 35.463 19.9725 35.463 19.6698V18.5263C35.463 18.2371 35.236 18.0084 34.9488 18.0084H33.6033C33.3562 18.0084 33.1559 18.2102 33.1559 18.459C33.1559 18.7079 33.3562 18.9029 33.6033 18.9029H34.4681V19.5756C34.2076 19.7639 33.8736 19.8581 33.4997 19.8581C32.6716 19.8581 32.0839 19.2259 32.0839 18.3649V18.3514C32.0839 17.551 32.6783 16.8851 33.4262 16.8851C33.867 16.8851 34.1675 17.0061 34.448 17.208C34.5214 17.2618 34.6149 17.3156 34.7619 17.3156C35.0423 17.3156 35.2694 17.0869 35.2694 16.8044C35.2694 16.6026 35.1559 16.4613 35.0557 16.3873ZM41.0001 18.3514C41.0001 17.0129 39.9649 15.93 38.5225 15.93C37.08 15.93 36.0315 17.0263 36.0315 18.3649V18.3783C36.0315 19.7168 37.0666 20.7998 38.5091 20.7998C39.9516 20.7998 41.0001 19.7034 41.0001 18.3649V18.3514ZM25.9891 17.6384C25.9891 16.6766 25.3145 16.0106 24.1993 16.0106H22.8036C22.5164 16.0106 22.2894 16.2394 22.2894 16.5286V20.2415C22.2894 20.5308 22.5164 20.7595 22.8036 20.7595C23.0907 20.7595 23.3178 20.5308 23.3178 20.2415V19.3066H24.0991C25.1476 19.3066 25.9891 18.7415 25.9891 17.6519V17.6384ZM29.0197 16.347C28.9061 16.0914 28.7058 15.9367 28.4253 15.9367H28.3652C28.0847 15.9367 27.8777 16.0914 27.7642 16.347L26.1347 20.0532C26.1013 20.1272 26.0746 20.2011 26.0746 20.2751C26.0746 20.5442 26.2816 20.7594 26.5487 20.7594C26.7624 20.7594 26.936 20.6384 27.0229 20.4365L27.3501 19.6631H29.407L29.7208 20.403C29.8144 20.6182 29.9746 20.7594 30.215 20.7594C30.4889 20.7594 30.7025 20.5375 30.7025 20.2617C30.7025 20.1944 30.6825 20.1272 30.6492 20.0532L29.0197 16.347ZM37.1067 18.3649V18.3514C37.1067 17.5443 37.681 16.8851 38.5091 16.8851C39.3372 16.8851 39.9249 17.5577 39.9249 18.3649V18.3783C39.9249 19.1855 39.3506 19.8446 38.5225 19.8446C37.6944 19.8446 37.1067 19.172 37.1067 18.3649ZM27.7308 18.7482L28.3786 17.1945L29.0263 18.7482H27.7308ZM23.3178 16.9456H24.1125C24.6267 16.9456 24.9472 17.1945 24.9472 17.6586V17.6721C24.9472 18.0756 24.6468 18.385 24.1325 18.385H23.3178V16.9456ZM30.7025 12.6946C30.7025 11.3561 29.6674 10.2732 28.2249 10.2732C26.7825 10.2732 25.734 11.3695 25.734 12.7081V12.7215C25.734 14.06 26.7691 15.143 28.2116 15.143C29.6541 15.143 30.7025 14.0466 30.7025 12.7081V12.6946ZM41.0001 12.6946C41.0001 11.3561 39.9649 10.2732 38.5225 10.2732C37.08 10.2732 36.0315 11.3695 36.0315 12.7081V12.7215C36.0315 14.06 37.0667 15.143 38.5091 15.143C39.9516 15.143 41.0001 14.0466 41.0001 12.7081V12.6946ZM25.8798 10.8315C25.8798 10.5691 25.6661 10.3539 25.4056 10.3539H22.1897C21.9293 10.3539 21.7156 10.5691 21.7156 10.8315C21.7156 11.0937 21.9293 11.309 22.1897 11.309H23.3031V14.5847C23.3031 14.874 23.5301 15.1026 23.8174 15.1026C24.1045 15.1026 24.3316 14.874 24.3316 14.5847V11.309H25.4056C25.6661 11.309 25.8798 11.0937 25.8798 10.8315ZM35.5833 12.6946C35.5833 11.3695 34.5682 10.3539 33.099 10.3539H31.7901C31.5029 10.3539 31.2759 10.5825 31.2759 10.8718V14.5443C31.2759 14.8335 31.5029 15.0622 31.7901 15.0622H33.099C34.5682 15.0622 35.5833 14.0331 35.5833 12.7081V12.6946ZM26.8092 12.6946C26.8092 11.8875 27.3835 11.2283 28.2116 11.2283C29.0396 11.2283 29.6274 11.9009 29.6274 12.7081V12.7215C29.6274 13.5286 29.0531 14.1878 28.2249 14.1878C27.3968 14.1878 26.8092 13.5152 26.8092 12.7081V12.6946ZM37.1067 12.6946C37.1067 11.8875 37.681 11.2283 38.5091 11.2283C39.3372 11.2283 39.9249 11.9009 39.9249 12.7081V12.7215C39.9249 13.5286 39.3506 14.1878 38.5225 14.1878C37.6944 14.1878 37.1067 13.5152 37.1067 12.7081V12.6946ZM32.3043 11.2888H33.099C33.9404 11.2888 34.5081 11.874 34.5081 12.7081V12.7215C34.5081 13.5555 33.9404 14.1273 33.099 14.1273H32.3043V11.2888Z\" fill=\"#647180\"/>\n</g>\n</g>\n</g>\n</g>\n</g>\n</svg>";

var UnionPayGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Unionpay, Color=Off\">\n<g id=\"Unionpay\">\n<path id=\"Intersect\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 24.438V24.7229C8.06683 25.4513 8.62901 25.9828 9.43058 26H16.2467C15.2456 25.9768 14.625 25.1599 14.857 24.1617L15.6654 20.6029H16.3763L15.5636 24.1617C15.3369 25.1642 15.9576 25.9768 16.9575 26H25.1994C24.1984 25.9768 23.582 25.1599 23.8098 24.1617L24.0807 22.9672H24.6897L24.4188 24.1617C24.1878 25.1642 24.8085 25.9768 25.8084 26H33.5797C34.5686 25.9483 35.5304 25.1504 35.7544 24.1692L39.2468 8.8439C39.2788 8.70409 39.2943 8.56798 39.2945 8.4372C39.2945 8.4355 39.2945 8.43381 39.2945 8.43212C39.2933 7.61398 38.6942 7.00538 37.8165 7.00538H30.4295H30.4133C29.4012 7.03441 28.1355 7.84078 27.9069 8.8353L27.2513 11.7167H26.6412L27.2979 8.8353C27.5298 7.84078 28.7922 7.03441 29.8075 7.00538H26.8699L21.6252 7H21.583C20.5676 7.02043 19.289 7.83647 19.056 8.8353L18.4004 11.7167H17.6928L18.3452 8.8353C18.5781 7.83647 19.8557 7.02043 20.8721 7H14.0996C13.0799 7 11.7677 7.82357 11.5347 8.8353L8.04226 24.1649C8.02167 24.2574 8.00867 24.3499 8 24.438ZM34.8485 13.6703H35.6319L34.0574 16.8356C33.7735 17.4334 33.5026 17.7806 33.3466 17.9408C33.3351 17.9521 33.323 17.9645 33.3099 17.9777C33.1391 18.151 32.8226 18.472 32.1189 18.444L32.1817 17.9914C32.7415 17.8217 33.0781 17.1182 33.2829 16.6902C33.3104 16.6327 33.3355 16.5801 33.3585 16.5345L33.1266 13.6746L33.6175 13.6703H34.0293L34.0748 15.4594L34.8485 13.6703ZM30.4631 18.6547H33.1938L33.0334 19.2127H32.1655L32.017 19.7342H32.885L32.7192 20.2922H31.7548L31.5348 20.6212H32.0083L32.1189 21.2792C32.1329 21.3469 32.1904 21.377 32.2879 21.377H32.4364L32.2792 21.9189H31.7591C31.4925 21.9307 31.3528 21.8426 31.3398 21.6501L31.213 21.048L30.7849 21.6878C30.6842 21.8684 30.5227 21.9512 30.3157 21.9383H29.5193L29.6764 21.3975H29.9213C30.0232 21.3975 30.1077 21.3512 30.1846 21.2631L30.8619 20.2976H29.9896L30.15 19.7342H31.0949L31.2466 19.2127H30.3027L30.4631 18.6547ZM29.6591 21.1125L29.4944 21.6921H29.321L29.2441 21.9383H28.3772L28.453 21.6921H26.7388L26.9035 21.1125H27.0769L27.9112 18.1881H27.7422L27.9156 17.572H28.8128L28.7749 17.7989C28.7749 17.7989 29.2321 17.572 29.5616 17.572H30.6712L30.4978 18.1881H30.3201L29.4857 21.1125H29.6591ZM26.8991 17.5419L26.3324 19.5783C26.2858 19.8105 26.0832 19.9266 25.7267 19.9266H24.0471L23.6527 21.3545C23.6321 21.4308 23.6613 21.4738 23.7459 21.4738H24.0764L23.9582 21.9189H23.1152C22.7934 21.9189 22.6579 21.8222 22.7088 21.6276L23.8228 17.5495H24.6095L24.5716 17.8688C24.5716 17.8688 25.0158 17.5419 25.4179 17.5419H26.8991ZM25.6595 20.0836H26.2945L26.2143 20.39C26.1417 20.6492 25.951 20.7836 25.6422 20.7975H25.2358L25.2315 21.3588C25.2271 21.4469 25.3084 21.4932 25.4775 21.4932H25.8578L25.731 21.9383H24.8186C24.5586 21.9469 24.4318 21.8265 24.4361 21.5695L24.4914 20.061H25.2575L25.2401 20.39H25.4482C25.549 20.39 25.5999 20.3556 25.5999 20.2922L25.6595 20.0836ZM21.8246 21.4351H22.5691L22.4336 21.9383H20.9989C20.7237 21.9383 20.6305 21.7845 20.715 21.4738L20.9902 20.4868H20.4018L20.5503 19.9449H21.1387L21.2828 19.4235H20.7193L20.8678 18.8816H23.2127L23.0643 19.4235H22.1204L21.9763 19.9492H22.8952L22.7468 20.49H21.829L21.6122 21.2588C21.5624 21.3889 21.6296 21.4469 21.8246 21.4351ZM20.559 16.1174C20.3639 15.9367 20.2664 15.6948 20.2664 15.3798C20.2664 15.3295 20.27 15.2747 20.274 15.2153C20.2744 15.21 20.2747 15.2046 20.2751 15.1992C20.2837 15.1304 20.2924 15.0691 20.3043 15.0046C20.3943 14.5734 20.5796 14.2315 20.8635 13.981C21.1517 13.7251 21.4941 13.5983 21.9005 13.5983C22.231 13.5983 22.4932 13.6907 22.6839 13.8746C22.8746 14.0552 22.9711 14.3079 22.9711 14.6229C22.9711 14.6777 22.9667 14.7401 22.9592 14.8078L22.9585 14.8132C22.95 14.8781 22.9415 14.9439 22.9288 15.0046C22.8443 15.4293 22.6579 15.769 22.3708 16.0174C22.0869 16.2657 21.7444 16.3904 21.3413 16.3904C21.0119 16.3904 20.7497 16.298 20.559 16.1174ZM19.4028 12.6994H20.144L20.0042 13.3456H19.2651L19.4028 12.6994ZM19.1709 13.6703H19.9066L19.3312 16.3206H18.5987L19.1709 13.6703ZM22.6037 17.5538L22.4174 17.8828H23.488L23.3525 18.3827H22.0782C21.9341 18.601 21.752 18.701 21.5364 18.6891H20.8721L21.0163 18.1677H21.143C21.2611 18.1677 21.3413 18.1258 21.3803 18.0494L21.7141 17.5538H22.6037ZM23.8434 16.3238H23.1618L23.6993 13.6703H24.3603L24.2877 14.0509L24.3765 13.9434C24.5921 13.7122 24.8555 13.5983 25.1643 13.5983C25.4439 13.5983 25.6422 13.6821 25.7689 13.8412C25.8925 14.0057 25.9261 14.2283 25.8665 14.5132L25.5024 16.3238H24.8208L25.1513 14.6809C25.1849 14.5132 25.1773 14.3885 25.1264 14.3079C25.0711 14.224 24.9736 14.1853 24.8338 14.1853C24.6561 14.1853 24.5076 14.2401 24.3895 14.3466C24.2671 14.4541 24.1869 14.6057 24.1479 14.8003L23.8434 16.3238ZM26.9858 16.3238H26.0864L26.9761 12.0188H28.906C29.2744 12.0188 29.5594 12.1027 29.7566 12.2672C29.956 12.4349 30.0535 12.6704 30.0535 12.98V12.9886C30.0535 13.0489 30.0492 13.1144 30.0405 13.1875L30.0399 13.1923C30.0314 13.2607 30.0227 13.3312 30.0026 13.4058C29.9181 13.8133 29.723 14.1434 29.4185 14.3928C29.1086 14.639 28.7489 14.7659 28.3349 14.7659H27.3022L26.9858 16.3238ZM31.5911 17.8408C31.5814 17.9193 31.6323 17.957 31.7288 17.957H31.8772L31.7266 18.4784H31.1068C30.8695 18.4902 30.7514 18.4021 30.7383 18.2096L30.7091 17.5333H31.5511L31.5911 17.8408ZM31.2 16.3023L31.0732 16.1561C28.9276 17.0624 29.5789 14.3122 30.358 13.9509C30.9334 13.6864 31.2303 13.8466 31.5554 14.0971L31.8642 13.8832L32.6011 13.8208L32.0463 16.3238L31.2 16.3023ZM17.5617 13.5983C17.8413 13.5983 18.0407 13.6789 18.1675 13.8412C18.2899 14.0057 18.3235 14.2283 18.265 14.5132L17.9009 16.3238H17.2193L17.5498 14.6809C17.5834 14.5132 17.5747 14.3885 17.5195 14.3079C17.4685 14.224 17.371 14.1853 17.228 14.1853C17.0535 14.1853 16.9061 14.2401 16.7826 14.3466C16.6645 14.4541 16.5843 14.6057 16.5464 14.8003L16.2408 16.3238H15.5603L16.0934 13.6649H16.7577L16.6818 14.0509L16.775 13.9434C16.9907 13.7122 17.2529 13.5983 17.5617 13.5983ZM15.8518 11.864L15.2298 14.8379C15.1236 15.3411 14.8863 15.7281 14.5146 16.0055C14.1462 16.2743 13.6673 16.4087 13.0832 16.4087C12.5381 16.4087 12.1307 16.27 11.8771 15.9916C11.6994 15.7948 11.6106 15.5421 11.6106 15.2411C11.6106 15.1142 11.6236 14.9798 11.6528 14.8379L12.2748 11.864H13.2143L12.601 14.8035C12.5836 14.8841 12.5761 14.9583 12.5761 15.0304C12.5761 15.1766 12.614 15.3035 12.6898 15.3991C12.8004 15.5421 12.9824 15.6142 13.2316 15.6142C13.5199 15.6142 13.7561 15.5421 13.9425 15.3991C14.1289 15.2605 14.2481 15.0648 14.3022 14.8035L14.9166 11.864H15.8518ZM24.9736 18.5171C24.6052 18.5203 24.3852 18.6795 24.3852 18.6795L24.5423 18.129H25.8665L25.7614 18.5171C25.7614 18.5171 25.342 18.5085 24.9736 18.5171ZM29.2061 18.7891C28.8724 18.8321 28.478 18.9784 28.478 18.9784L28.7066 18.1881H29.3795C29.3795 18.1881 29.2831 18.5128 29.2061 18.7891ZM28.8724 19.9492C28.5798 19.9643 28.1442 20.1793 28.1442 20.1793L28.3728 19.3514H29.0458C29.0458 19.3514 28.9612 19.6299 28.8724 19.9492ZM28.5419 21.1125H27.8733L28.0423 20.5105H28.7109L28.5419 21.1125ZM25.3843 19.403H24.1901L24.3007 18.9999H25.6259L25.5446 19.2891C25.5414 19.3772 25.4861 19.4149 25.3843 19.403ZM31.3863 15.2529C31.2509 15.6486 30.9464 15.9131 30.7091 15.8367C30.4718 15.7647 30.3873 15.383 30.527 14.9841C30.6582 14.5853 30.967 14.3197 31.2 14.3971C31.4373 14.467 31.5218 14.854 31.3863 15.2529ZM21.9601 15.5938C21.829 15.7368 21.6632 15.8023 21.4605 15.8023C21.3034 15.8023 21.1853 15.7604 21.1008 15.6722C21.0163 15.5841 20.974 15.4594 20.974 15.2949C20.974 15.2572 20.974 15.2153 20.9783 15.1723C20.9816 15.1304 20.9902 15.0841 20.9989 15.0422C21.0585 14.7541 21.1517 14.539 21.2828 14.3971C21.4096 14.2584 21.5786 14.1853 21.7824 14.1853C21.9341 14.1853 22.0533 14.2315 22.1378 14.3197C22.2223 14.4122 22.2646 14.539 22.2646 14.7035C22.2646 14.7212 22.2636 14.7401 22.2625 14.7596C22.2614 14.7806 22.2602 14.8023 22.2602 14.8239C22.2569 14.8624 22.2511 14.8959 22.2452 14.93C22.2433 14.9408 22.2415 14.9516 22.2396 14.9626C22.18 15.2454 22.0912 15.454 21.9601 15.5938ZM27.4626 14.0176H28.3176C28.5419 14.0176 28.7153 13.967 28.8464 13.867C28.9732 13.7628 29.0588 13.6058 29.1054 13.3918C29.1085 13.3767 29.1111 13.3614 29.1136 13.3463C29.1173 13.3247 29.1209 13.3034 29.1259 13.2832C29.1259 13.2682 29.127 13.2537 29.1281 13.2392C29.1292 13.2246 29.1303 13.2101 29.1303 13.1951C29.1303 13.0445 29.0794 12.9306 28.9699 12.8639C28.8594 12.7919 28.686 12.7575 28.4487 12.7575H27.7205L27.4626 14.0176Z\" fill=\"#647180\"/>\n</g>\n</g>\n</svg>";

var VisaGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Visa, Color=Off\">\n<path id=\"Vector\" d=\"M19.4238 10.1988L14.4495 22.1217H11.202L8.75842 12.608C8.60792 12.0236 8.47723 11.801 8.02574 11.5545C7.29307 11.1569 6.06931 10.7713 5 10.5367L5.07129 10.1988H10.299C10.9644 10.1988 11.5663 10.6441 11.7208 11.4153L13.0119 18.313L16.204 10.2028H19.4238V10.1988ZM32.1485 18.2296C32.1604 15.0848 27.8158 14.9099 27.8396 13.5065C27.8515 13.0732 28.2594 12.6199 29.1426 12.5126C29.5861 12.453 30.7941 12.4092 32.1683 13.0493L32.703 10.5248C31.9584 10.2544 31.0158 10 29.8277 10C26.7901 10 24.6594 11.626 24.6356 13.9398C24.6119 15.6573 26.1604 16.6154 27.3248 17.1879C28.5248 17.7724 28.9208 18.1461 28.9208 18.6708C28.9089 19.4779 27.9663 19.8278 27.0792 19.8397C25.5307 19.8635 24.6475 19.4183 23.9228 19.0923L23.3644 21.7003C24.0851 22.0263 25.4 22.3205 26.7743 22.3324C30.0297 22.3085 32.1366 20.7064 32.1485 18.2296ZM40.1604 22.1217H43L40.5208 10.1988H37.903C37.3089 10.1988 36.8218 10.5367 36.6 11.0734L31.9861 22.1217H35.2099L35.8515 20.3446H39.8L40.1604 22.1217ZM36.7347 17.9036L38.3545 13.427L39.2852 17.9036H36.7347ZM23.8119 10.1988L21.2733 22.1217H18.2L20.7386 10.1988H23.8119Z\" fill=\"#647180\"/>\n</g>\n</svg>";

var VisaDebitoGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Visa_Debito, Color=Off\">\n<path id=\"Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.465 17.818L19.9204 7.19538H17.0195L14.1568 14.4286L12.9973 8.2827C12.8656 7.59463 12.3347 7.19538 11.7315 7.19538H7.05946L7 7.50968C7.96839 7.71355 9.05571 8.05334 9.7183 8.41437C10.1133 8.63098 10.2365 8.82636 10.3681 9.34453L12.5683 17.818H15.465ZM28.8129 11.3649C29.9244 11.9494 31.3109 12.6785 31.3033 14.3522C31.2906 16.5523 29.3962 17.9879 26.5123 17.9879C25.2933 17.9751 24.0998 17.7076 23.4585 17.4187L23.9554 15.0869C23.9739 15.0957 23.9926 15.1046 24.0115 15.1135C24.6395 15.4114 25.4314 15.787 26.7799 15.7623C27.5656 15.7538 28.4109 15.4395 28.4236 14.7259C28.4236 14.2672 28.0753 13.9274 27.0007 13.4092C25.9601 12.8911 24.584 12.0458 24.5968 10.5126C24.618 8.44834 26.525 7 29.2433 7C30.3052 7 31.1504 7.22936 31.813 7.47146L31.3288 9.7183C30.1098 9.14916 29.0225 9.20013 28.6232 9.24685C27.8247 9.35303 27.4637 9.75228 27.451 10.1388C27.4424 10.6442 28.0655 10.9719 28.8129 11.3649ZM41 17.818H38.4643L38.1288 16.2422H34.6035L34.0343 17.8222H31.1504L35.2661 7.98114C35.4742 7.49694 35.9074 7.19538 36.4383 7.19538H38.7786L41 17.818ZM36.8588 10.0666L35.4105 14.0506H37.6913L36.8588 10.0666ZM21.5726 17.818L23.8407 7.19538H21.0884L18.8204 17.818H21.5726ZM29.6978 19.0285H29.0565L29.0777 23.2759C29.0777 23.5217 29.0621 23.7884 29.0492 24.0088V24.0088L29.0492 24.0089L29.0492 24.0099L29.0491 24.0107C29.0456 24.0713 29.0422 24.1284 29.0395 24.1805H29.5831L29.6214 23.6029H29.6341C29.9017 24.0744 30.3137 24.2655 30.8191 24.2655C31.5921 24.2655 32.3991 23.6411 32.3991 22.3839C32.3991 21.3221 31.7875 20.5958 30.9041 20.5958C30.3519 20.5958 29.9399 20.8506 29.7106 21.2371H29.6978V19.0285ZM29.7106 23.0125L29.7105 23.0124C29.698 22.9414 29.6855 22.8705 29.6851 22.7874H29.6978V22.1461C29.6978 22.0484 29.7106 21.9634 29.736 21.8785C29.8677 21.3943 30.267 21.0927 30.7002 21.0927C31.3883 21.0927 31.7493 21.6958 31.7493 22.4094C31.7493 23.2164 31.35 23.7601 30.6747 23.7601C30.2075 23.7601 29.8295 23.4585 29.7106 23.0125ZM25.5821 22.5411C25.5949 23.4118 26.1385 23.7601 26.7884 23.7601C27.2471 23.7601 27.5359 23.6879 27.7653 23.5774L27.8842 24.0361C27.6548 24.1466 27.2683 24.2655 26.6992 24.2655C25.6119 24.2655 24.962 23.5392 24.9748 22.4774C24.9748 21.4155 25.6034 20.5958 26.627 20.5958C27.7865 20.5958 28.0753 21.5982 28.0753 22.248V22.248C28.0753 22.3797 28.0753 22.4774 28.0498 22.5496L25.5821 22.5411ZM27.451 22.0951C27.4637 21.6958 27.2811 21.0587 26.559 21.0587C25.9049 21.0587 25.6289 21.6491 25.5821 22.0951H27.451ZM27.6081 19.1474L26.7162 20.1838H26.2702L26.9116 19.1474H27.6081ZM20.1838 19.3513C20.5703 19.2918 21.029 19.2409 21.5344 19.2409C22.4391 19.2409 23.0932 19.4575 23.5137 19.8567C23.9469 20.256 24.2145 20.8209 24.2145 21.6194C24.2145 22.4179 23.9597 23.0805 23.5009 23.5137C23.0295 23.9724 22.282 24.2145 21.3263 24.2145C20.8676 24.2145 20.4938 24.189 20.1795 24.1551L20.1838 19.3513ZM20.8251 23.6878C20.9823 23.7133 21.2244 23.7133 21.4665 23.7133C22.8299 23.7133 23.5562 22.9658 23.5562 21.6364C23.5689 20.4769 22.9148 19.7421 21.5769 19.7421C21.2498 19.7421 20.9993 19.7675 20.8421 19.8015L20.8251 23.6878ZM34.0811 19.6911C34.0811 19.9077 33.9367 20.0903 33.6691 20.0903C33.4397 20.0903 33.2826 19.9077 33.2826 19.6911C33.2826 19.4745 33.4397 19.2918 33.6818 19.2918C33.9239 19.2918 34.0811 19.4617 34.0811 19.6911ZM33.3675 24.206V20.6807H34.0089V24.206H33.3675ZM36.0349 20.6807V19.8355L35.4063 20.0182V20.668H34.8626V21.1522H35.4063V23.0762C35.4063 23.501 35.4912 23.8153 35.6611 24.0064C35.8055 24.1721 36.0476 24.2825 36.3492 24.2825C36.5913 24.2825 36.7994 24.2443 36.9183 24.1975L36.8928 23.7006C36.7951 23.7346 36.6889 23.7473 36.5191 23.7473C36.1538 23.7473 36.0349 23.4925 36.0349 23.0592V21.1649H36.9523V20.6807H36.0349ZM40.9873 22.4179C40.9873 23.7218 40.0698 24.291 39.2246 24.291C38.2817 24.291 37.5469 23.5902 37.5469 22.4816C37.5469 21.3093 38.3327 20.6213 39.2968 20.6213C40.3119 20.6213 40.9873 21.3561 40.9873 22.4179ZM38.1968 22.4561C38.1968 23.2291 38.63 23.8068 39.2586 23.8068C39.8617 23.8068 40.3332 23.2376 40.3332 22.4434C40.3332 21.8403 40.0316 21.0927 39.2841 21.0927C38.5365 21.0927 38.2095 21.7893 38.1968 22.4561Z\" fill=\"#647180\"/>\n</g>\n</svg>";

var MercadoPagoGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Mercado-pago, Color=Off\">\n<g id=\"Mercadopago\">\n<path id=\"Vector\" d=\"M32.9181 8.81018C32.9181 5.60983 28.9411 3 24.0348 3C19.1285 3 15.1528 5.60983 15.1528 8.81018C15.1528 8.8932 15.1528 9.12084 15.1528 9.1503C15.1528 12.5462 18.6344 15.2966 24.0348 15.2966C29.4754 15.2966 32.9195 12.5462 32.9195 9.1503L32.9181 8.81018Z\" fill=\"#647180\"/>\n<path id=\"Vector_2\" d=\"M32.578 8.80747C32.578 11.8244 28.7536 14.2708 24.0361 14.2708C19.3186 14.2708 15.4902 11.8244 15.4902 8.80747C15.4902 5.79057 19.3199 3.34277 24.0361 3.34277C28.7523 3.34277 32.578 5.78923 32.578 8.80747Z\" fill=\"#B6C5D5\"/>\n<path id=\"Vector_3\" d=\"M21.1996 7.08284C21.1996 7.09221 21.1113 7.18059 21.1662 7.25156C21.3001 7.42296 21.7165 7.51937 22.1383 7.42698C22.3887 7.37074 22.7101 7.11498 23.0208 6.86859C23.3582 6.60078 23.6903 6.33297 24.0291 6.22584C24.2654 6.13912 24.5237 6.13253 24.7642 6.20709C25.0085 6.29732 25.2352 6.42966 25.4338 6.5981C26.0176 7.03731 28.3676 9.08741 28.7734 9.44226C29.9813 8.92036 31.237 8.51676 32.5227 8.23711C32.3513 7.18327 31.7113 6.22048 30.7391 5.42508C29.3853 5.99418 27.7316 6.29012 26.1127 5.50007C26.1046 5.50007 25.2289 5.08228 24.3719 5.09835C23.0904 5.14254 22.5333 5.69156 21.9455 6.28074L21.1996 7.08284Z\" fill=\"white\"/>\n<path id=\"Vector_4\" d=\"M28.6798 9.66583C28.653 9.64173 25.9173 7.24749 25.2973 6.7815C24.9385 6.51369 24.739 6.44406 24.5301 6.41728C24.4071 6.40805 24.2835 6.41982 24.1645 6.45209C23.8766 6.5311 23.495 6.78284 23.1642 7.04797C22.8335 7.31311 22.4947 7.5836 22.188 7.65189C21.823 7.7257 21.4437 7.66832 21.1168 7.48986C21.0398 7.44326 20.9779 7.37536 20.9387 7.29436C20.917 7.23241 20.9141 7.16545 20.9303 7.10186C20.9465 7.03825 20.9811 6.98085 21.0298 6.93683L21.7837 6.12L22.0515 5.85889C21.8186 5.89398 21.5886 5.9459 21.3632 6.01422C21.1034 6.10037 20.8331 6.15083 20.5598 6.16419C20.2843 6.13453 20.0108 6.08983 19.7402 6.03029C18.9905 5.83801 18.261 5.57435 17.5616 5.24292C16.4904 6.04636 15.7713 7.04128 15.5637 8.14198C15.7177 8.18216 15.9654 8.2558 16.0712 8.27589C18.4989 8.81151 19.2555 9.37258 19.3934 9.48908C19.4741 9.39818 19.5743 9.32677 19.6865 9.2802C19.7987 9.23363 19.92 9.21311 20.0413 9.22019C20.1626 9.22729 20.2807 9.2618 20.3868 9.32112C20.4928 9.38045 20.584 9.46306 20.6535 9.56273C20.8173 9.43061 21.0215 9.35877 21.232 9.35919C21.3502 9.36045 21.4674 9.38126 21.5788 9.42079C21.6872 9.45501 21.787 9.51219 21.8713 9.58845C21.9557 9.6647 22.0226 9.75823 22.0675 9.86268C22.174 9.81463 22.2895 9.78996 22.4063 9.79037C22.5448 9.79225 22.6815 9.82232 22.808 9.87874C23.2566 10.0716 23.3262 10.5108 23.2861 10.8429C23.3182 10.8408 23.3504 10.8408 23.3825 10.8429C23.5491 10.8426 23.7128 10.8856 23.8577 10.9677C24.0027 11.0498 24.1238 11.1681 24.2092 11.311C24.2948 11.454 24.3415 11.6167 24.3453 11.7832C24.3489 11.9497 24.3093 12.1144 24.2301 12.2609C24.3747 12.3426 24.743 12.5287 25.0657 12.4846C25.3241 12.4524 25.4219 12.364 25.4567 12.3145C25.4915 12.2649 25.5062 12.2408 25.4835 12.2114L24.7979 11.4508C24.7979 11.4508 24.6854 11.3437 24.7215 11.3022C24.7577 11.2607 24.83 11.3209 24.8796 11.3624C25.2291 11.653 25.6549 12.0935 25.6549 12.0935C25.6549 12.0935 25.6897 12.1538 25.8477 12.1819C25.9414 12.1964 26.037 12.192 26.129 12.169C26.221 12.146 26.3074 12.1049 26.3833 12.048C26.4276 12.0122 26.4677 11.9713 26.5025 11.9262H26.4945C26.5425 11.8598 26.5669 11.7792 26.5634 11.6973C26.5601 11.6154 26.5291 11.537 26.4757 11.4749L25.6723 10.5764C25.6723 10.5764 25.5585 10.4706 25.5973 10.4278C25.6361 10.3849 25.7058 10.4478 25.7553 10.4894C26.0084 10.7009 26.3673 11.0598 26.7101 11.3959C26.8243 11.4734 26.9602 11.5125 27.0981 11.5077C27.236 11.5029 27.3687 11.4544 27.4773 11.3691C27.5662 11.32 27.6399 11.2472 27.69 11.1588C27.7401 11.0704 27.7647 10.9699 27.7612 10.8683C27.7443 10.7409 27.6849 10.6229 27.5925 10.5335L26.4998 9.43552C26.4998 9.43552 26.3847 9.33643 26.4248 9.28688C26.465 9.23733 26.5333 9.30563 26.5828 9.3458C26.931 9.63771 27.8724 10.5014 27.8724 10.5014C27.9836 10.5724 28.1135 10.6088 28.2456 10.6062C28.3774 10.6036 28.5057 10.562 28.6142 10.4867C28.6836 10.4462 28.7419 10.3894 28.7844 10.3213C28.8268 10.2532 28.8521 10.1757 28.8579 10.0957C28.8594 10.0156 28.8444 9.93612 28.8137 9.86215C28.783 9.78818 28.7375 9.72135 28.6798 9.66583Z\" fill=\"white\"/>\n<path id=\"Vector_5\" d=\"M23.3798 11.0582C23.2097 11.0582 23.0249 11.1572 23.0008 11.1425C22.9767 11.1278 23.0102 11.0648 23.0262 11.026C23.0423 10.9872 23.2659 10.315 22.7223 10.0887C22.6005 10.0235 22.461 9.99943 22.3245 10.0199C22.1879 10.0404 22.0616 10.1045 21.9644 10.2025C21.9403 10.2266 21.9309 10.2239 21.9282 10.1945C21.9252 10.0689 21.8828 9.94756 21.8072 9.84739C21.7315 9.74721 21.6263 9.6733 21.5064 9.63607C21.3372 9.58342 21.1555 9.58677 20.9883 9.64563C20.8211 9.7045 20.6774 9.81573 20.5784 9.9628C20.5612 9.82977 20.4996 9.70643 20.4036 9.61274C20.3076 9.51906 20.1828 9.46052 20.0494 9.44658C19.916 9.43265 19.7818 9.46414 19.6685 9.53596C19.5552 9.60778 19.4694 9.71572 19.4251 9.84233C19.3807 9.96893 19.3804 10.1068 19.4242 10.2336C19.4679 10.3604 19.5532 10.4687 19.6662 10.5411C19.7791 10.6134 19.9132 10.6455 20.0467 10.6322C20.1802 10.6188 20.3052 10.5609 20.4017 10.4676C20.4017 10.4676 20.4017 10.477 20.4017 10.4877C20.361 10.6716 20.388 10.864 20.4778 11.0296C20.5676 11.1951 20.7141 11.3227 20.8904 11.3889C20.9858 11.4259 21.0891 11.4372 21.1902 11.4217C21.2912 11.4061 21.3864 11.3644 21.4662 11.3005C21.5131 11.267 21.5211 11.2818 21.5144 11.326C21.4944 11.4599 21.5144 11.7585 21.9336 11.9259C22.0361 11.9753 22.1518 11.9909 22.2637 11.9701C22.3757 11.9494 22.4782 11.8936 22.5562 11.8107C22.6085 11.7625 22.6232 11.7692 22.6259 11.8442C22.6324 11.9909 22.6819 12.1324 22.7682 12.2513C22.8545 12.3701 22.9737 12.461 23.1112 12.5127C23.2487 12.5643 23.3982 12.5745 23.5415 12.5419C23.6847 12.5093 23.8151 12.4353 23.9167 12.3292C24.0182 12.2232 24.0864 12.0896 24.1128 11.9451C24.139 11.8006 24.1224 11.6516 24.0648 11.5165C24.0071 11.3815 23.9111 11.2663 23.7887 11.1852C23.6662 11.1042 23.5226 11.061 23.3757 11.0608L23.3798 11.0582Z\" fill=\"white\"/>\n<path id=\"Vector_6\" d=\"M28.7856 9.37921C27.9433 8.64407 25.9963 6.95016 25.4687 6.55513C25.2645 6.38207 25.0315 6.24611 24.7804 6.15342C24.6713 6.11853 24.5575 6.10093 24.443 6.10119C24.2973 6.10299 24.1527 6.12739 24.0145 6.1735C23.673 6.28063 23.3343 6.55112 23.0062 6.81223L22.9888 6.82562C22.6821 7.06799 22.3661 7.31974 22.1278 7.3733C22.0228 7.39736 21.9154 7.40949 21.8077 7.40945C21.5399 7.40945 21.2989 7.33179 21.2092 7.21663C21.1944 7.19654 21.2092 7.16575 21.2386 7.12156L21.9805 6.31812C22.5603 5.73831 23.1093 5.18929 24.372 5.16117H24.435C25.0081 5.18446 25.5713 5.31766 26.0941 5.55352C26.7965 5.90525 27.5702 6.09123 28.3557 6.09718C29.2173 6.08223 30.0652 5.87886 30.8397 5.50129C30.7423 5.42095 30.6419 5.34195 30.5384 5.26428C29.8536 5.57793 29.1115 5.74661 28.3584 5.75973C27.623 5.75337 26.8988 5.57887 26.2414 5.24955C25.6731 4.99047 25.0592 4.84578 24.435 4.82373H24.364C23.3035 4.84917 22.7062 5.22545 22.3045 5.55486C21.9556 5.57328 21.6104 5.63629 21.2775 5.74233C21.043 5.81901 20.7994 5.86405 20.553 5.87623C20.4606 5.87623 20.2932 5.8682 20.2852 5.86686C20.0228 5.86284 18.7172 5.54414 17.6781 5.14912C17.5723 5.22545 17.4705 5.30177 17.3714 5.38078C18.4561 5.82669 19.7817 6.17082 20.1928 6.19761C20.3093 6.2043 20.4325 6.21769 20.557 6.21769C20.8349 6.20457 21.1097 6.15367 21.3739 6.06638C21.5305 6.02219 21.7046 5.97398 21.8867 5.93917L21.7408 6.07977L20.9882 6.89526C20.9307 6.9459 20.8899 7.01292 20.8715 7.08734C20.8531 7.16177 20.8578 7.24005 20.8851 7.3117C20.9287 7.40244 20.9975 7.47868 21.0833 7.53131C21.3282 7.66946 21.6056 7.73929 21.8867 7.73351C21.9939 7.73435 22.1008 7.72312 22.2054 7.70003C22.5214 7.6304 22.8522 7.36527 23.203 7.08674C23.4829 6.86446 23.8792 6.58325 24.1832 6.50023C24.2707 6.47721 24.3606 6.46463 24.451 6.46274C24.4747 6.46129 24.4984 6.46129 24.522 6.46274C24.7229 6.48818 24.9237 6.55647 25.2638 6.81625C25.8825 7.28091 28.6182 9.67514 28.645 9.69791C28.6989 9.74966 28.7415 9.81214 28.7699 9.88133C28.7982 9.95052 28.8118 10.0249 28.8097 10.0996C28.8046 10.1712 28.7818 10.2405 28.7435 10.3012C28.7052 10.3619 28.6525 10.4123 28.5901 10.4478C28.484 10.5194 28.3592 10.5585 28.2312 10.5603C28.1187 10.5605 28.0086 10.5285 27.9138 10.4679C27.9045 10.4598 26.9671 9.60016 26.6216 9.31226C26.5785 9.26646 26.5216 9.23592 26.4596 9.22522C26.4461 9.22506 26.4326 9.22799 26.4202 9.23379C26.4079 9.23959 26.3972 9.2481 26.3886 9.2587C26.3337 9.32565 26.3886 9.41804 26.4663 9.47964L27.5617 10.5803C27.6432 10.6597 27.6964 10.7637 27.713 10.8763C27.7159 10.9686 27.6932 11.0598 27.6472 11.14C27.6014 11.2201 27.5342 11.286 27.4532 11.3302C27.3399 11.4124 27.2047 11.459 27.0649 11.4641C26.9537 11.4645 26.845 11.4314 26.7529 11.3691L26.5949 11.2151C26.3083 10.9325 26.011 10.6406 25.7914 10.4598C25.7482 10.4144 25.6913 10.3843 25.6294 10.3741C25.6164 10.3742 25.6036 10.3768 25.5916 10.3819C25.5797 10.3869 25.5689 10.3943 25.5598 10.4036C25.5357 10.4317 25.5183 10.4813 25.5799 10.5629C25.5967 10.5847 25.6151 10.6053 25.6348 10.6245L26.4382 11.5217C26.4844 11.574 26.5113 11.6404 26.5145 11.7101C26.5177 11.7798 26.4968 11.8485 26.4556 11.9047L26.4275 11.9408C26.4046 11.9662 26.3801 11.9899 26.3538 12.0118C26.2407 12.0952 26.1033 12.139 25.9628 12.1363C25.9265 12.1361 25.8902 12.133 25.8544 12.127C25.7962 12.1223 25.7412 12.0988 25.6977 12.06L25.6883 12.0506C25.6441 12.0051 25.2411 11.594 24.9076 11.3155C24.8667 11.2711 24.812 11.2418 24.7523 11.2325C24.7387 11.2323 24.7251 11.2351 24.7127 11.2407C24.7002 11.2462 24.6891 11.2544 24.68 11.2646C24.6144 11.3369 24.7135 11.4454 24.755 11.4842L25.4366 12.2394C25.4308 12.256 25.4222 12.2714 25.4111 12.285C25.387 12.3184 25.304 12.4015 25.0576 12.4323C25.0274 12.4343 24.9968 12.4343 24.9666 12.4323C24.7313 12.4179 24.5023 12.3501 24.297 12.2341C24.3609 12.0994 24.3939 11.952 24.3934 11.8029C24.3934 11.5332 24.2865 11.2746 24.0959 11.0838C23.9052 10.893 23.6468 10.7856 23.3771 10.7852H23.3409C23.3597 10.5295 23.3235 10.0447 22.8254 9.83181C22.692 9.77145 22.5474 9.73953 22.4009 9.73808C22.2944 9.73745 22.1886 9.75652 22.0889 9.79432C21.9854 9.59291 21.8063 9.44075 21.5908 9.37118C21.4738 9.32956 21.3507 9.30784 21.2266 9.3069C21.0224 9.30599 20.8232 9.36974 20.6575 9.48901C20.5816 9.39583 20.487 9.31965 20.3798 9.26545C20.2726 9.21124 20.1552 9.18023 20.0352 9.17442C19.9152 9.1686 19.7953 9.18813 19.6833 9.23171C19.5714 9.27531 19.4698 9.34199 19.3854 9.42742C19.1725 9.26539 18.3315 8.73111 16.0792 8.22226C15.9694 8.19816 15.719 8.12585 15.5664 8.08166C15.5405 8.20372 15.5212 8.32709 15.5088 8.45124L16.0056 8.56908C18.3021 9.07257 19.0667 9.60417 19.1952 9.7046C19.1517 9.80949 19.129 9.92181 19.1283 10.0354C19.1283 10.2643 19.219 10.4839 19.3807 10.6461C19.5423 10.8082 19.7617 10.8997 19.9906 10.9004C20.0436 10.9002 20.0965 10.8953 20.1486 10.8857C20.183 11.0564 20.261 11.2154 20.375 11.347C20.4891 11.4787 20.6353 11.5785 20.7994 11.6369C20.8972 11.6751 21.0011 11.695 21.1061 11.6958C21.1724 11.6958 21.2385 11.6877 21.3029 11.6717C21.3524 11.7879 21.4256 11.8924 21.5178 11.9787C21.6101 12.0649 21.7193 12.1309 21.8385 12.1725C21.946 12.2169 22.061 12.2406 22.1773 12.2421C22.2687 12.2426 22.3594 12.2267 22.4451 12.1953C22.5089 12.3513 22.6105 12.489 22.7408 12.5959C22.8712 12.7027 23.0261 12.7754 23.1917 12.8073C23.3572 12.8392 23.528 12.8294 23.6888 12.7786C23.8495 12.7279 23.9951 12.6378 24.1122 12.5166C24.3728 12.6696 24.6662 12.7582 24.9679 12.7751C25.0126 12.7753 25.0574 12.7726 25.1018 12.767C25.4486 12.7228 25.6107 12.5876 25.6843 12.4818C25.6981 12.4633 25.7101 12.4436 25.7205 12.4229C25.8099 12.4504 25.9028 12.4648 25.9963 12.4657C26.1982 12.4621 26.3933 12.3925 26.552 12.2676C26.7203 12.1576 26.8386 11.9859 26.8814 11.7895V11.7828C26.9426 11.7957 27.005 11.802 27.0676 11.8016C27.2719 11.7992 27.4709 11.7363 27.6393 11.6208C27.7675 11.5469 27.8733 11.4396 27.9454 11.3104C28.0176 11.1812 28.0534 11.0349 28.0491 10.887C28.1113 10.8992 28.1746 10.9055 28.2379 10.9057C28.4286 10.9039 28.6147 10.8467 28.7735 10.741C28.8798 10.6768 28.9693 10.5881 29.0345 10.4824C29.0997 10.3767 29.1387 10.2569 29.1484 10.1331C29.1609 9.96172 29.1193 9.79074 29.0293 9.64435C30.1793 9.17495 31.3667 8.80316 32.5791 8.53293C32.5697 8.40839 32.551 8.28654 32.5296 8.16468C31.2453 8.44791 29.9915 8.85463 28.7856 9.37921ZM23.3798 12.5073C23.1995 12.5084 23.0259 12.439 22.896 12.3139C22.7662 12.1888 22.6904 12.0179 22.6848 11.8377C22.6848 11.8056 22.6848 11.7212 22.6085 11.7212C22.5759 11.7251 22.5459 11.7408 22.5241 11.7654C22.4807 11.8125 22.4285 11.8506 22.3703 11.8775C22.3122 11.9043 22.2493 11.9195 22.1853 11.9221C22.108 11.9205 22.0316 11.9041 21.9604 11.8739C21.5587 11.7132 21.5587 11.44 21.5747 11.3383C21.5785 11.324 21.5791 11.309 21.5765 11.2945C21.574 11.2799 21.5684 11.2661 21.56 11.2539L21.5359 11.2325H21.5158C21.4902 11.2342 21.4658 11.244 21.4462 11.2606C21.3495 11.3347 21.2319 11.3764 21.1101 11.3798C21.0459 11.3793 20.9824 11.367 20.9226 11.3436C20.7559 11.2831 20.6169 11.164 20.5317 11.0085C20.4464 10.853 20.4207 10.6718 20.4593 10.4987C20.4623 10.4861 20.4618 10.4729 20.4578 10.4606C20.4538 10.4483 20.4464 10.4374 20.4365 10.429L20.4004 10.3982L20.3656 10.4317C20.2901 10.5084 20.1932 10.5607 20.0877 10.5815C19.9821 10.6024 19.8727 10.591 19.7737 10.5488C19.6747 10.5066 19.5907 10.4356 19.5326 10.3449C19.4746 10.2543 19.4452 10.1483 19.4483 10.0407C19.4438 9.97037 19.4532 9.89984 19.476 9.83314C19.4988 9.76643 19.5345 9.70487 19.581 9.65196C19.6276 9.59906 19.6841 9.55583 19.7474 9.52478C19.8107 9.49371 19.8794 9.47542 19.9498 9.47094C20.0918 9.46188 20.2317 9.50962 20.3385 9.60368C20.3914 9.65024 20.4347 9.70677 20.4657 9.77004C20.4968 9.83331 20.5151 9.90207 20.5195 9.97241L20.5383 10.1184L20.6186 9.99518C20.6892 9.89211 20.7831 9.80712 20.8927 9.74709C21.0023 9.68707 21.1245 9.65371 21.2493 9.6497C21.3294 9.65002 21.4088 9.66268 21.485 9.68719C21.5943 9.72139 21.69 9.78904 21.7587 9.88058C21.8274 9.97212 21.8656 10.0829 21.868 10.1974C21.868 10.2683 21.9242 10.271 21.9336 10.271C21.9457 10.2702 21.9575 10.2669 21.9684 10.2614C21.9792 10.2559 21.9888 10.2482 21.9965 10.2389C22.0483 10.1847 22.1107 10.1418 22.1798 10.1127C22.249 10.0837 22.3233 10.0692 22.3982 10.0702C22.5017 10.0722 22.6037 10.0949 22.6982 10.1371C23.2084 10.3567 22.9767 11.0048 22.974 11.0115C22.9299 11.1186 22.9285 11.1669 22.974 11.1936L22.9941 11.203H23.0102C23.0439 11.1994 23.0768 11.1908 23.108 11.1776C23.1935 11.1437 23.2839 11.1233 23.3758 11.1173C23.5604 11.1173 23.7376 11.1907 23.8681 11.3212C23.9987 11.4518 24.0721 11.629 24.0721 11.8136C24.0721 11.9983 23.9987 12.1754 23.8681 12.306C23.7376 12.4366 23.5604 12.5099 23.3758 12.5099L23.3798 12.5073Z\" fill=\"#647180\"/>\n<path id=\"Vector_7\" d=\"M37.5378 18.7659C37.2174 18.3642 36.7303 18.1633 36.0769 18.1633C35.4234 18.1633 34.9369 18.3642 34.6173 18.7659C34.3054 19.1762 34.1367 19.6774 34.1367 20.1927C34.1367 20.7079 34.3054 21.2092 34.6173 21.6194C34.9387 22.0158 35.4252 22.214 36.0769 22.214C36.7286 22.214 37.2155 22.0158 37.5378 21.6194C37.8495 21.2092 38.0184 20.7079 38.0184 20.1927C38.0184 19.6774 37.8495 19.1762 37.5378 18.7659ZM36.7437 21.0771C36.661 21.1738 36.5583 21.2515 36.4427 21.3046C36.3272 21.3579 36.2014 21.3855 36.0742 21.3855C35.947 21.3855 35.8213 21.3579 35.7057 21.3046C35.5901 21.2515 35.4874 21.1738 35.4047 21.0771C35.2326 20.8168 35.1504 20.5074 35.1703 20.196C35.1508 19.8855 35.233 19.5771 35.4047 19.3176C35.4877 19.2213 35.5904 19.1441 35.706 19.091C35.8215 19.0381 35.9471 19.0107 36.0742 19.0107C36.2013 19.0107 36.3269 19.0381 36.4424 19.091C36.558 19.1441 36.6607 19.2213 36.7437 19.3176C36.9143 19.5775 36.996 19.8858 36.9767 20.196C36.9964 20.5072 36.9147 20.8164 36.7437 21.0771Z\" fill=\"#647180\"/>\n<path id=\"Vector_8\" d=\"M29.3429 18.43C28.9961 18.26 28.6136 18.1751 28.2274 18.1823C27.5829 18.1823 27.1285 18.3501 26.8643 18.6858C26.6895 18.9251 26.5914 19.2118 26.5831 19.508H27.5418C27.5562 19.3809 27.6048 19.2601 27.6824 19.1585C27.7491 19.0941 27.8292 19.0451 27.9168 19.0147C28.0045 18.9844 28.0977 18.9736 28.1899 18.9831C28.356 18.9734 28.5219 19.0042 28.6733 19.0728C28.7289 19.1049 28.7742 19.1526 28.8034 19.2098C28.8326 19.2671 28.8446 19.3315 28.838 19.3955C28.8372 19.4595 28.8161 19.5215 28.7775 19.5727C28.739 19.6237 28.6851 19.661 28.6238 19.6794C28.4943 19.7258 28.3592 19.7552 28.2221 19.7664L27.8806 19.8079C27.5746 19.8339 27.2762 19.9169 27.0009 20.053C26.6366 20.2628 26.4545 20.602 26.4545 21.0707C26.4451 21.2267 26.4709 21.3828 26.5296 21.5277C26.5886 21.6724 26.6791 21.8023 26.7946 21.9076C27.0379 22.1035 27.342 22.2082 27.6543 22.2035C29.8289 22.2999 29.8048 21.0573 29.8249 20.7988V19.3674C29.8316 18.9094 29.6683 18.5961 29.3429 18.43ZM28.838 20.602C28.8309 20.9358 28.7359 21.1653 28.5528 21.2903C28.3767 21.4137 28.1666 21.4797 27.9516 21.4791C27.8252 21.4828 27.7015 21.4431 27.6008 21.3666C27.55 21.3203 27.5106 21.2627 27.4857 21.1985C27.461 21.1345 27.4512 21.0654 27.4575 20.997C27.4529 20.9114 27.4727 20.8264 27.5144 20.7516C27.556 20.6767 27.618 20.6151 27.6932 20.5739C27.8375 20.5046 27.9922 20.4594 28.1511 20.44L28.3787 20.3971C28.4697 20.3816 28.5593 20.3588 28.6466 20.3288C28.7142 20.3038 28.7787 20.2714 28.8394 20.2324L28.838 20.602Z\" fill=\"#647180\"/>\n<path id=\"Vector_9\" d=\"M24.384 19.0351C24.4873 19.0268 24.5911 19.0434 24.6865 19.0834C24.7822 19.1236 24.8666 19.186 24.9331 19.2654C25.0138 19.3789 25.0658 19.5103 25.0844 19.6484H26.1556C26.0967 19.1074 25.9075 18.7298 25.5879 18.5155C25.2171 18.2889 24.7874 18.1775 24.3532 18.1955C23.7627 18.1955 23.2981 18.3762 22.9633 18.7391C22.6285 19.102 22.4598 19.6042 22.4598 20.2603C22.4374 20.7695 22.5995 21.2698 22.9164 21.669C23.2209 22.0323 23.6954 22.214 24.3399 22.214C24.9843 22.214 25.471 21.9967 25.7994 21.5619C25.996 21.3162 26.1161 21.0182 26.1449 20.7049H25.0737C25.0605 20.8823 24.9953 21.0518 24.8862 21.1923C24.8184 21.2606 24.7362 21.3128 24.6457 21.3453C24.555 21.3778 24.4584 21.3895 24.3626 21.3798C24.209 21.3898 24.0564 21.3488 23.9285 21.2631C23.8006 21.1773 23.7046 21.0517 23.6556 20.9057C23.5795 20.6909 23.5446 20.4638 23.5525 20.2362C23.5445 19.998 23.5794 19.7603 23.6556 19.5345C23.7043 19.3823 23.8024 19.2505 23.9343 19.1601C24.0662 19.0696 24.2244 19.0257 24.384 19.0351Z\" fill=\"#647180\"/>\n<path id=\"Vector_10\" d=\"M22.1735 18.1958C19.9695 18.1958 20.0993 20.1468 20.0993 20.1468V22.1286H21.0996V20.274C21.0863 20.0428 21.1256 19.8115 21.2148 19.5978C21.3514 19.338 21.6192 19.2081 22.0182 19.2081H22.1374C22.1856 19.2081 22.2405 19.2081 22.3048 19.2215V18.2038H22.2191L22.1735 18.1958Z\" fill=\"#647180\"/>\n<path id=\"Vector_11\" d=\"M18.4989 21.0919C18.462 21.1487 18.4169 21.1997 18.365 21.2432C18.2019 21.3577 18.004 21.4117 17.8053 21.3959C17.6174 21.4053 17.431 21.3587 17.2697 21.262C17.0206 21.1093 16.88 20.8495 16.8679 20.4679H19.6331C19.6411 20.2162 19.6299 19.9642 19.5996 19.714C19.5592 19.4347 19.4557 19.1681 19.297 18.9347C19.1357 18.6891 18.9082 18.4941 18.6409 18.3723C18.359 18.2506 18.0547 18.1899 17.7477 18.1942C17.4973 18.1847 17.2475 18.2265 17.0138 18.317C16.7801 18.4075 16.5673 18.5448 16.3886 18.7204C16.0404 19.0722 15.8659 19.577 15.865 20.2349C15.865 20.9383 16.0583 21.4454 16.4448 21.7561C16.8226 22.0641 17.2965 22.2295 17.7839 22.2234C18.3954 22.2234 18.8716 22.0386 19.2126 21.6691C19.3755 21.5093 19.4949 21.3107 19.5595 21.0919H18.4989ZM17.1599 19.2306C17.2385 19.1556 17.3318 19.0977 17.4338 19.0603C17.5359 19.0229 17.6446 19.0071 17.7531 19.0137C17.968 19.0069 18.1779 19.0798 18.3423 19.2186C18.4253 19.2952 18.4919 19.3878 18.5379 19.4909C18.584 19.594 18.6085 19.7056 18.6101 19.8185H16.8907C16.9134 19.5993 17.0059 19.3933 17.1545 19.2306H17.1599Z\" fill=\"#647180\"/>\n<path id=\"Vector_12\" d=\"M15.4634 22.1272H14.5528V19.828C14.5528 19.6178 14.4832 19.1183 13.8833 19.1183C13.79 19.115 13.697 19.1312 13.6103 19.1659C13.5237 19.2007 13.4452 19.253 13.38 19.3199C13.3148 19.3868 13.2643 19.4665 13.2318 19.5539C13.1992 19.6415 13.1853 19.7348 13.191 19.828V22.1272H12.2764V19.828C12.2764 19.6178 12.2148 19.1183 11.6069 19.1183C11.5136 19.115 11.4206 19.1312 11.3339 19.1659C11.2473 19.2007 11.1688 19.253 11.1036 19.3199C11.0384 19.3868 10.9879 19.4665 10.9554 19.5539C10.9228 19.6415 10.9089 19.7348 10.9146 19.828V22.1272H10V19.8508C10 18.9014 10.6307 18.1837 11.6069 18.1837C11.8247 18.179 12.0406 18.2249 12.2377 18.3178C12.4347 18.4108 12.6075 18.5482 12.7424 18.7193C12.8799 18.5511 13.0532 18.4159 13.2496 18.3232C13.4461 18.2305 13.6607 18.1829 13.8779 18.1837C14.8755 18.1837 15.4634 18.872 15.4634 19.8508V22.1272Z\" fill=\"#647180\"/>\n<path id=\"Vector_13\" d=\"M33.8354 16.9932C33.8354 16.9932 32.8271 16.8861 32.8271 17.6949V18.7661C32.72 18.5918 32.5703 18.4474 32.3919 18.347C32.2036 18.2439 31.9918 18.1918 31.7773 18.1957C31.548 18.1877 31.32 18.234 31.112 18.3308C30.904 18.4276 30.7217 18.5722 30.5802 18.7527C30.2816 19.125 30.1329 19.6606 30.1329 20.3087C30.1119 20.8094 30.2737 21.3006 30.5882 21.6906C30.8908 22.0495 31.4854 22.2075 32.0143 22.2075C33.8555 22.2075 33.8341 20.6274 33.8341 20.6274L33.8354 16.9932ZM32.6303 21.0787C32.5592 21.1815 32.4628 21.2644 32.3505 21.3196C32.2382 21.3746 32.1138 21.4001 31.9889 21.3934C31.8654 21.4009 31.7422 21.3756 31.6316 21.32C31.5211 21.2646 31.4273 21.1809 31.3595 21.0774C31.2098 20.8136 31.1379 20.5127 31.1519 20.2096C31.1422 19.9238 31.2126 19.6407 31.3555 19.3928C31.4223 19.285 31.5171 19.1974 31.6299 19.1393C31.7426 19.0814 31.869 19.0551 31.9956 19.0634C32.1793 19.061 32.3576 19.1253 32.4977 19.2442C32.732 19.4437 32.8499 19.8026 32.8499 20.2672C32.8649 20.5524 32.7915 20.8354 32.6396 21.0774L32.6303 21.0787Z\" fill=\"#647180\"/>\n<path id=\"Vector_14\" d=\"M17.278 28.1742C17.279 28.2393 17.2665 28.3038 17.2411 28.3638C17.2157 28.4238 17.1781 28.4778 17.1307 28.5224C17.0849 28.5696 17.0299 28.6069 16.9691 28.632C16.9083 28.6571 16.843 28.6695 16.7772 28.6683H16.2764V25.1868C16.2764 24.5106 16.5053 24.0861 16.8803 23.7995C17.1293 23.6107 17.4989 23.4299 18.1912 23.4299C18.6586 23.4299 19.2062 23.6107 19.5022 23.9722C19.8342 24.374 19.9722 24.8292 19.9722 25.4198C19.9722 26.0304 19.8249 26.5232 19.5316 26.9021C19.3995 27.0771 19.2279 27.2183 19.0308 27.3141C18.8336 27.41 18.6166 27.458 18.3974 27.4538C18.1742 27.4574 17.9529 27.4116 17.7493 27.3199C17.5505 27.2203 17.3862 27.0629 17.278 26.8686V28.1742ZM18.9572 25.464C18.9762 25.1575 18.8989 24.8527 18.7362 24.5922C18.6641 24.4933 18.5684 24.4137 18.4578 24.3612C18.3472 24.3086 18.2252 24.2844 18.1028 24.2909C17.9822 24.2861 17.8624 24.3116 17.7541 24.3649C17.6458 24.4182 17.5526 24.4977 17.4829 24.5963C17.349 24.7797 17.278 25.0716 17.278 25.468C17.278 25.8366 17.3516 26.1125 17.4989 26.2955C17.5706 26.3953 17.6661 26.4755 17.7767 26.5288C17.8874 26.5821 18.0096 26.6068 18.1323 26.6008C18.2505 26.6044 18.3677 26.5785 18.4732 26.5252C18.5787 26.4717 18.6691 26.3929 18.7362 26.2955C18.8956 26.0501 18.973 25.7603 18.9572 25.468\" fill=\"#B6C5D5\"/>\n<path id=\"Vector_15\" d=\"M26.6044 27.1339V26.8875C26.5278 27.0151 26.426 27.1259 26.3055 27.213C26.1849 27.3004 26.0479 27.3622 25.9027 27.395C25.6108 27.4622 25.3052 27.4369 25.0283 27.3227C24.7189 27.1893 24.4584 26.9633 24.2825 26.676C24.0599 26.3014 23.952 25.8698 23.9718 25.4346C23.9718 24.8347 24.1093 24.3483 24.3842 23.9751C24.6587 23.6028 25.1006 23.4394 25.7072 23.4167C26.3138 23.3939 26.6539 23.5359 26.9954 23.7943C27.3676 24.0768 27.5873 24.5107 27.5873 25.1883V27.237C27.5873 27.8891 27.1347 29.097 25.7126 28.9939C24.8288 28.9296 24.3387 28.5667 24.0642 27.7445H25.1207C25.2055 27.883 25.3301 27.9925 25.4782 28.0588C25.6265 28.1249 25.7913 28.1448 25.9509 28.1154C26.1238 28.0725 26.2771 27.9724 26.3861 27.8316C26.5327 27.6291 26.6111 27.3853 26.6097 27.1353L26.6044 27.1339ZM24.9614 25.4654C24.9614 26.134 25.1542 26.5042 25.5398 26.5755C25.9241 26.6478 26.2094 26.5581 26.3928 26.3077C26.4967 26.1599 26.5613 25.9879 26.5803 25.8082C26.6184 25.5869 26.6213 25.3609 26.5883 25.1387C26.5578 24.9238 26.4761 24.7195 26.35 24.5428C26.2874 24.4567 26.2043 24.3878 26.1081 24.3421C26.012 24.2964 25.9058 24.2757 25.7996 24.2817C25.4715 24.2817 25.2506 24.4022 25.1301 24.6433C25.0112 24.9032 24.9521 25.1864 24.9573 25.4721\" fill=\"#B6C5D5\"/>\n<path id=\"Vector_16\" d=\"M23.1229 23.6925C22.7755 23.5225 22.3927 23.4376 22.0061 23.4447C21.3607 23.4447 20.9054 23.6125 20.6403 23.9482C20.4657 24.1882 20.3677 24.4752 20.3591 24.7718H21.3232C21.3382 24.6459 21.3862 24.5262 21.4624 24.4249C21.529 24.3608 21.6088 24.3119 21.6962 24.2818C21.7837 24.2518 21.8766 24.2412 21.9686 24.2509C22.1351 24.2411 22.3014 24.2719 22.4534 24.3406C22.5091 24.3727 22.5545 24.4203 22.5839 24.4774C22.6134 24.5347 22.6257 24.5993 22.6194 24.6633C22.6183 24.7274 22.5969 24.7894 22.5581 24.8406C22.5193 24.8916 22.4653 24.929 22.4038 24.9472C22.2742 24.9936 22.1392 25.0232 22.0021 25.0356L21.6606 25.0771C21.3536 25.1022 21.0542 25.1854 20.7782 25.3221C20.414 25.5327 20.2319 25.8725 20.2319 26.3411C20.2238 26.4973 20.2508 26.6531 20.3108 26.7975C20.3708 26.9418 20.4623 27.0709 20.5787 27.1754C20.8223 27.3715 21.1269 27.4763 21.4397 27.4713C23.6183 27.5691 23.5929 26.3237 23.613 26.0653V24.6312C23.613 24.1719 23.451 23.8585 23.1242 23.6938L23.1229 23.6925ZM22.614 25.8684C22.614 26.2019 22.5123 26.4308 22.3288 26.5581C22.1527 26.6815 21.9427 26.7475 21.7276 26.7469C21.601 26.7505 21.4771 26.7103 21.3768 26.633C21.3256 26.587 21.2859 26.5295 21.2608 26.4654C21.2357 26.4013 21.2259 26.332 21.2321 26.2635C21.2276 26.1779 21.2473 26.0929 21.289 26.018C21.3307 25.9432 21.3927 25.8816 21.4678 25.8403C21.6126 25.771 21.7677 25.7257 21.9271 25.7064L22.1547 25.6649C22.2456 25.6484 22.3352 25.6251 22.4226 25.5953C22.4898 25.5693 22.554 25.5361 22.614 25.4962V25.8684Z\" fill=\"#B6C5D5\"/>\n<path id=\"Vector_17\" d=\"M31.382 24.0087C31.0606 23.606 30.5728 23.4048 29.9184 23.4048C29.264 23.4048 28.7766 23.606 28.4562 24.0087C28.1443 24.4201 27.9756 24.9219 27.9756 25.4381C27.9756 25.9544 28.1443 26.4562 28.4562 26.8676C28.7789 27.2626 29.2596 27.4621 29.9184 27.4621C30.5772 27.4621 31.0606 27.2626 31.382 26.8676C31.6947 26.4566 31.8639 25.9545 31.8639 25.4381C31.8639 24.9218 31.6947 24.4197 31.382 24.0087ZM30.5866 26.3159C30.504 26.4128 30.4014 26.4906 30.2857 26.5439C30.1702 26.5974 30.0444 26.625 29.9171 26.625C29.7897 26.625 29.664 26.5974 29.5484 26.5439C29.4328 26.4906 29.3302 26.4128 29.2476 26.3159C29.0896 26.1097 29.0119 25.8164 29.0119 25.4348C29.0119 25.0532 29.0896 24.7653 29.2476 24.555C29.3307 24.4589 29.4334 24.3819 29.549 24.329C29.6645 24.2762 29.79 24.2488 29.9171 24.2488C30.0442 24.2488 30.1696 24.2762 30.2852 24.329C30.4008 24.3819 30.5036 24.4589 30.5866 24.555C30.7394 24.8234 30.8196 25.1267 30.8196 25.4355C30.8196 25.7443 30.7394 26.0476 30.5866 26.3159Z\" fill=\"#B6C5D5\"/>\n</g>\n</g>\n</svg>";

var MercadoPagoColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Mercado-pago, Color=On\">\n<g id=\"Mercadopago\">\n<path id=\"Vector\" d=\"M32.9181 8.81018C32.9181 5.60983 28.9411 3 24.0348 3C19.1285 3 15.1528 5.60983 15.1528 8.81018C15.1528 8.8932 15.1528 9.12084 15.1528 9.1503C15.1528 12.5462 18.6344 15.2966 24.0348 15.2966C29.4754 15.2966 32.9195 12.5462 32.9195 9.1503L32.9181 8.81018Z\" fill=\"#253E8A\"/>\n<path id=\"Vector_2\" d=\"M32.578 8.80747C32.578 11.8244 28.7536 14.2708 24.0361 14.2708C19.3186 14.2708 15.4902 11.8244 15.4902 8.80747C15.4902 5.79057 19.3199 3.34277 24.0361 3.34277C28.7523 3.34277 32.578 5.78923 32.578 8.80747Z\" fill=\"#00AEEF\"/>\n<path id=\"Vector_3\" d=\"M21.1996 7.08284C21.1996 7.09221 21.1113 7.18059 21.1662 7.25156C21.3001 7.42296 21.7165 7.51937 22.1383 7.42698C22.3887 7.37074 22.7101 7.11498 23.0208 6.86859C23.3582 6.60078 23.6903 6.33297 24.0291 6.22584C24.2654 6.13912 24.5237 6.13253 24.7642 6.20709C25.0085 6.29732 25.2352 6.42966 25.4338 6.5981C26.0176 7.03731 28.3676 9.08741 28.7734 9.44226C29.9813 8.92036 31.237 8.51676 32.5227 8.23711C32.3513 7.18327 31.7113 6.22048 30.7391 5.42508C29.3853 5.99418 27.7316 6.29012 26.1127 5.50007C26.1046 5.50007 25.2289 5.08228 24.3719 5.09835C23.0904 5.14254 22.5333 5.69156 21.9455 6.28074L21.1996 7.08284Z\" fill=\"white\"/>\n<path id=\"Vector_4\" d=\"M28.6798 9.66583C28.653 9.64173 25.9173 7.24749 25.2973 6.7815C24.9385 6.51369 24.739 6.44406 24.5301 6.41728C24.4071 6.40805 24.2835 6.41982 24.1645 6.45209C23.8766 6.5311 23.495 6.78284 23.1642 7.04797C22.8335 7.31311 22.4947 7.5836 22.188 7.65189C21.823 7.7257 21.4437 7.66832 21.1168 7.48986C21.0398 7.44326 20.9779 7.37536 20.9387 7.29436C20.917 7.23241 20.9141 7.16545 20.9303 7.10186C20.9465 7.03825 20.9811 6.98085 21.0298 6.93683L21.7837 6.12L22.0515 5.85889C21.8186 5.89398 21.5886 5.9459 21.3632 6.01422C21.1034 6.10037 20.8331 6.15083 20.5598 6.16419C20.2843 6.13453 20.0108 6.08983 19.7402 6.03029C18.9905 5.83801 18.261 5.57435 17.5616 5.24292C16.4904 6.04636 15.7713 7.04128 15.5637 8.14198C15.7177 8.18216 15.9654 8.2558 16.0712 8.27589C18.4989 8.81151 19.2555 9.37258 19.3934 9.48908C19.4741 9.39818 19.5743 9.32677 19.6865 9.2802C19.7987 9.23363 19.92 9.21311 20.0413 9.22019C20.1626 9.22729 20.2807 9.2618 20.3868 9.32112C20.4928 9.38045 20.584 9.46306 20.6535 9.56273C20.8173 9.43061 21.0215 9.35877 21.232 9.35919C21.3502 9.36045 21.4674 9.38126 21.5788 9.42079C21.6872 9.45501 21.787 9.51219 21.8713 9.58845C21.9557 9.6647 22.0226 9.75823 22.0675 9.86268C22.174 9.81463 22.2895 9.78996 22.4063 9.79037C22.5448 9.79225 22.6815 9.82232 22.808 9.87874C23.2566 10.0716 23.3262 10.5108 23.2861 10.8429C23.3182 10.8408 23.3504 10.8408 23.3825 10.8429C23.5491 10.8426 23.7128 10.8856 23.8577 10.9677C24.0027 11.0498 24.1238 11.1681 24.2092 11.311C24.2948 11.454 24.3415 11.6167 24.3453 11.7832C24.3489 11.9497 24.3093 12.1144 24.2301 12.2609C24.3747 12.3426 24.743 12.5287 25.0657 12.4846C25.3241 12.4524 25.4219 12.364 25.4567 12.3145C25.4915 12.2649 25.5062 12.2408 25.4835 12.2114L24.7979 11.4508C24.7979 11.4508 24.6854 11.3437 24.7215 11.3022C24.7577 11.2607 24.83 11.3209 24.8796 11.3624C25.2291 11.653 25.6549 12.0935 25.6549 12.0935C25.6549 12.0935 25.6897 12.1538 25.8477 12.1819C25.9414 12.1964 26.037 12.192 26.129 12.169C26.221 12.146 26.3074 12.1049 26.3833 12.048C26.4276 12.0122 26.4677 11.9713 26.5025 11.9262H26.4945C26.5425 11.8598 26.5669 11.7792 26.5634 11.6973C26.5601 11.6154 26.5291 11.537 26.4757 11.4749L25.6723 10.5764C25.6723 10.5764 25.5585 10.4706 25.5973 10.4278C25.6361 10.3849 25.7058 10.4478 25.7553 10.4894C26.0084 10.7009 26.3673 11.0598 26.7101 11.3959C26.8243 11.4734 26.9602 11.5125 27.0981 11.5077C27.236 11.5029 27.3687 11.4544 27.4773 11.3691C27.5662 11.32 27.6399 11.2472 27.69 11.1588C27.7401 11.0704 27.7647 10.9699 27.7612 10.8683C27.7443 10.7409 27.6849 10.6229 27.5925 10.5335L26.4998 9.43552C26.4998 9.43552 26.3847 9.33643 26.4248 9.28688C26.465 9.23733 26.5333 9.30563 26.5828 9.3458C26.931 9.63771 27.8724 10.5014 27.8724 10.5014C27.9836 10.5724 28.1135 10.6088 28.2456 10.6062C28.3774 10.6036 28.5057 10.562 28.6142 10.4867C28.6836 10.4462 28.7419 10.3894 28.7844 10.3213C28.8268 10.2532 28.8521 10.1757 28.8579 10.0957C28.8594 10.0156 28.8444 9.93612 28.8137 9.86215C28.783 9.78818 28.7375 9.72135 28.6798 9.66583Z\" fill=\"white\"/>\n<path id=\"Vector_5\" d=\"M23.3798 11.0582C23.2097 11.0582 23.0249 11.1572 23.0008 11.1425C22.9767 11.1278 23.0102 11.0648 23.0262 11.026C23.0423 10.9872 23.2659 10.315 22.7223 10.0887C22.6005 10.0235 22.461 9.99943 22.3245 10.0199C22.1879 10.0404 22.0616 10.1045 21.9644 10.2025C21.9403 10.2266 21.9309 10.2239 21.9282 10.1945C21.9252 10.0689 21.8828 9.94756 21.8072 9.84739C21.7315 9.74721 21.6263 9.6733 21.5064 9.63607C21.3372 9.58342 21.1555 9.58677 20.9883 9.64563C20.8211 9.7045 20.6774 9.81573 20.5784 9.9628C20.5612 9.82977 20.4996 9.70643 20.4036 9.61274C20.3076 9.51906 20.1828 9.46052 20.0494 9.44658C19.916 9.43265 19.7818 9.46414 19.6685 9.53596C19.5552 9.60778 19.4694 9.71572 19.4251 9.84233C19.3807 9.96893 19.3804 10.1068 19.4242 10.2336C19.4679 10.3604 19.5532 10.4687 19.6662 10.5411C19.7791 10.6134 19.9132 10.6455 20.0467 10.6322C20.1802 10.6188 20.3052 10.5609 20.4017 10.4676C20.4017 10.4676 20.4017 10.477 20.4017 10.4877C20.361 10.6716 20.388 10.864 20.4778 11.0296C20.5676 11.1951 20.7141 11.3227 20.8904 11.3889C20.9858 11.4259 21.0891 11.4372 21.1902 11.4217C21.2912 11.4061 21.3864 11.3644 21.4662 11.3005C21.5131 11.267 21.5211 11.2818 21.5144 11.326C21.4944 11.4599 21.5144 11.7585 21.9336 11.9259C22.0361 11.9753 22.1518 11.9909 22.2637 11.9701C22.3757 11.9494 22.4782 11.8936 22.5562 11.8107C22.6085 11.7625 22.6232 11.7692 22.6259 11.8442C22.6324 11.9909 22.6819 12.1324 22.7682 12.2513C22.8545 12.3701 22.9737 12.461 23.1112 12.5127C23.2487 12.5643 23.3982 12.5745 23.5415 12.5419C23.6847 12.5093 23.8151 12.4353 23.9167 12.3292C24.0182 12.2232 24.0864 12.0896 24.1128 11.9451C24.139 11.8006 24.1224 11.6516 24.0648 11.5165C24.0071 11.3815 23.9111 11.2663 23.7887 11.1852C23.6662 11.1042 23.5226 11.061 23.3757 11.0608L23.3798 11.0582Z\" fill=\"white\"/>\n<path id=\"Vector_6\" d=\"M28.7856 9.37921C27.9433 8.64407 25.9963 6.95016 25.4687 6.55513C25.2645 6.38207 25.0315 6.24611 24.7804 6.15342C24.6713 6.11853 24.5575 6.10093 24.443 6.10119C24.2973 6.10299 24.1527 6.12739 24.0145 6.1735C23.673 6.28063 23.3343 6.55112 23.0062 6.81223L22.9888 6.82562C22.6821 7.06799 22.3661 7.31974 22.1278 7.3733C22.0228 7.39736 21.9154 7.40949 21.8077 7.40945C21.5399 7.40945 21.2989 7.33179 21.2092 7.21663C21.1944 7.19654 21.2092 7.16575 21.2386 7.12156L21.9805 6.31812C22.5603 5.73831 23.1093 5.18929 24.372 5.16117H24.435C25.0081 5.18446 25.5713 5.31766 26.0941 5.55352C26.7965 5.90525 27.5702 6.09123 28.3557 6.09718C29.2173 6.08223 30.0652 5.87886 30.8397 5.50129C30.7423 5.42095 30.6419 5.34195 30.5384 5.26428C29.8536 5.57793 29.1115 5.74661 28.3584 5.75973C27.623 5.75337 26.8988 5.57887 26.2414 5.24955C25.6731 4.99047 25.0592 4.84578 24.435 4.82373H24.364C23.3035 4.84917 22.7062 5.22545 22.3045 5.55486C21.9556 5.57328 21.6104 5.63629 21.2775 5.74233C21.043 5.81901 20.7994 5.86405 20.553 5.87623C20.4606 5.87623 20.2932 5.8682 20.2852 5.86686C20.0228 5.86284 18.7172 5.54414 17.6781 5.14912C17.5723 5.22545 17.4705 5.30177 17.3714 5.38078C18.4561 5.82669 19.7817 6.17082 20.1928 6.19761C20.3093 6.2043 20.4325 6.21769 20.557 6.21769C20.8349 6.20457 21.1097 6.15367 21.3739 6.06638C21.5305 6.02219 21.7046 5.97398 21.8867 5.93917L21.7408 6.07977L20.9882 6.89526C20.9307 6.9459 20.8899 7.01292 20.8715 7.08734C20.8531 7.16177 20.8578 7.24005 20.8851 7.3117C20.9287 7.40244 20.9975 7.47868 21.0833 7.53131C21.3282 7.66946 21.6056 7.73929 21.8867 7.73351C21.9939 7.73435 22.1008 7.72312 22.2054 7.70003C22.5214 7.6304 22.8522 7.36527 23.203 7.08674C23.4829 6.86446 23.8792 6.58325 24.1832 6.50023C24.2707 6.47721 24.3606 6.46463 24.451 6.46274C24.4747 6.46129 24.4984 6.46129 24.522 6.46274C24.7229 6.48818 24.9237 6.55647 25.2638 6.81625C25.8825 7.28091 28.6182 9.67514 28.645 9.69791C28.6989 9.74966 28.7415 9.81214 28.7699 9.88133C28.7982 9.95052 28.8118 10.0249 28.8097 10.0996C28.8046 10.1712 28.7818 10.2405 28.7435 10.3012C28.7052 10.3619 28.6525 10.4123 28.5901 10.4478C28.484 10.5194 28.3592 10.5585 28.2312 10.5603C28.1187 10.5605 28.0086 10.5285 27.9138 10.4679C27.9045 10.4598 26.9671 9.60016 26.6216 9.31226C26.5785 9.26646 26.5216 9.23592 26.4596 9.22522C26.4461 9.22506 26.4326 9.22799 26.4202 9.23379C26.4079 9.23959 26.3972 9.2481 26.3886 9.2587C26.3337 9.32565 26.3886 9.41804 26.4663 9.47964L27.5617 10.5803C27.6432 10.6597 27.6964 10.7637 27.713 10.8763C27.7159 10.9686 27.6932 11.0598 27.6472 11.14C27.6014 11.2201 27.5342 11.286 27.4532 11.3302C27.3399 11.4124 27.2047 11.459 27.0649 11.4641C26.9537 11.4645 26.845 11.4314 26.7529 11.3691L26.5949 11.2151C26.3083 10.9325 26.011 10.6406 25.7914 10.4598C25.7482 10.4144 25.6913 10.3843 25.6294 10.3741C25.6164 10.3742 25.6036 10.3768 25.5916 10.3819C25.5797 10.3869 25.5689 10.3943 25.5598 10.4036C25.5357 10.4317 25.5183 10.4813 25.5799 10.5629C25.5967 10.5847 25.6151 10.6053 25.6348 10.6245L26.4382 11.5217C26.4844 11.574 26.5113 11.6404 26.5145 11.7101C26.5177 11.7798 26.4968 11.8485 26.4556 11.9047L26.4275 11.9408C26.4046 11.9662 26.3801 11.9899 26.3538 12.0118C26.2407 12.0952 26.1033 12.139 25.9628 12.1363C25.9265 12.1361 25.8902 12.133 25.8544 12.127C25.7962 12.1223 25.7412 12.0988 25.6977 12.06L25.6883 12.0506C25.6441 12.0051 25.2411 11.594 24.9076 11.3155C24.8667 11.2711 24.812 11.2418 24.7523 11.2325C24.7387 11.2323 24.7251 11.2351 24.7127 11.2407C24.7002 11.2462 24.6891 11.2544 24.68 11.2646C24.6144 11.3369 24.7135 11.4454 24.755 11.4842L25.4366 12.2394C25.4308 12.256 25.4222 12.2714 25.4111 12.285C25.387 12.3184 25.304 12.4015 25.0576 12.4323C25.0274 12.4343 24.9968 12.4343 24.9666 12.4323C24.7313 12.4179 24.5023 12.3501 24.297 12.2341C24.3609 12.0994 24.3939 11.952 24.3934 11.8029C24.3934 11.5332 24.2865 11.2746 24.0959 11.0838C23.9052 10.893 23.6468 10.7856 23.3771 10.7852H23.3409C23.3597 10.5295 23.3235 10.0447 22.8254 9.83181C22.692 9.77145 22.5474 9.73953 22.4009 9.73808C22.2944 9.73745 22.1886 9.75652 22.0889 9.79432C21.9854 9.59291 21.8063 9.44075 21.5908 9.37118C21.4738 9.32956 21.3507 9.30784 21.2266 9.3069C21.0224 9.30599 20.8232 9.36974 20.6575 9.48901C20.5816 9.39583 20.487 9.31965 20.3798 9.26545C20.2726 9.21124 20.1552 9.18023 20.0352 9.17442C19.9152 9.1686 19.7953 9.18813 19.6833 9.23171C19.5714 9.27531 19.4698 9.34199 19.3854 9.42742C19.1725 9.26539 18.3315 8.73111 16.0792 8.22226C15.9694 8.19816 15.719 8.12585 15.5664 8.08166C15.5405 8.20372 15.5212 8.32709 15.5088 8.45124L16.0056 8.56908C18.3021 9.07257 19.0667 9.60417 19.1952 9.7046C19.1517 9.80949 19.129 9.92181 19.1283 10.0354C19.1283 10.2643 19.219 10.4839 19.3807 10.6461C19.5423 10.8082 19.7617 10.8997 19.9906 10.9004C20.0436 10.9002 20.0965 10.8953 20.1486 10.8857C20.183 11.0564 20.261 11.2154 20.375 11.347C20.4891 11.4787 20.6353 11.5785 20.7994 11.6369C20.8972 11.6751 21.0011 11.695 21.1061 11.6958C21.1724 11.6958 21.2385 11.6877 21.3029 11.6717C21.3524 11.7879 21.4256 11.8924 21.5178 11.9787C21.6101 12.0649 21.7193 12.1309 21.8385 12.1725C21.946 12.2169 22.061 12.2406 22.1773 12.2421C22.2687 12.2426 22.3594 12.2267 22.4451 12.1953C22.5089 12.3513 22.6105 12.489 22.7408 12.5959C22.8712 12.7027 23.0261 12.7754 23.1917 12.8073C23.3572 12.8392 23.528 12.8294 23.6888 12.7786C23.8495 12.7279 23.9951 12.6378 24.1122 12.5166C24.3728 12.6696 24.6662 12.7582 24.9679 12.7751C25.0126 12.7753 25.0574 12.7726 25.1018 12.767C25.4486 12.7228 25.6107 12.5876 25.6843 12.4818C25.6981 12.4633 25.7101 12.4436 25.7205 12.4229C25.8099 12.4504 25.9028 12.4648 25.9963 12.4657C26.1982 12.4621 26.3933 12.3925 26.552 12.2676C26.7203 12.1576 26.8386 11.9859 26.8814 11.7895V11.7828C26.9426 11.7957 27.005 11.802 27.0676 11.8016C27.2719 11.7992 27.4709 11.7363 27.6393 11.6208C27.7675 11.5469 27.8733 11.4396 27.9454 11.3104C28.0176 11.1812 28.0534 11.0349 28.0491 10.887C28.1113 10.8992 28.1746 10.9055 28.2379 10.9057C28.4286 10.9039 28.6147 10.8467 28.7735 10.741C28.8798 10.6768 28.9693 10.5881 29.0345 10.4824C29.0997 10.3767 29.1387 10.2569 29.1484 10.1331C29.1609 9.96172 29.1193 9.79074 29.0293 9.64435C30.1793 9.17495 31.3667 8.80316 32.5791 8.53293C32.5697 8.40839 32.551 8.28654 32.5296 8.16468C31.2453 8.44791 29.9915 8.85463 28.7856 9.37921ZM23.3798 12.5073C23.1995 12.5084 23.0259 12.439 22.896 12.3139C22.7662 12.1888 22.6904 12.0179 22.6848 11.8377C22.6848 11.8056 22.6848 11.7212 22.6085 11.7212C22.5759 11.7251 22.5459 11.7408 22.5241 11.7654C22.4807 11.8125 22.4285 11.8506 22.3703 11.8775C22.3122 11.9043 22.2493 11.9195 22.1853 11.9221C22.108 11.9205 22.0316 11.9041 21.9604 11.8739C21.5587 11.7132 21.5587 11.44 21.5747 11.3383C21.5785 11.324 21.5791 11.309 21.5765 11.2945C21.574 11.2799 21.5684 11.2661 21.56 11.2539L21.5359 11.2325H21.5158C21.4902 11.2342 21.4658 11.244 21.4462 11.2606C21.3495 11.3347 21.2319 11.3764 21.1101 11.3798C21.0459 11.3793 20.9824 11.367 20.9226 11.3436C20.7559 11.2831 20.6169 11.164 20.5317 11.0085C20.4464 10.853 20.4207 10.6718 20.4593 10.4987C20.4623 10.4861 20.4618 10.4729 20.4578 10.4606C20.4538 10.4483 20.4464 10.4374 20.4365 10.429L20.4004 10.3982L20.3656 10.4317C20.2901 10.5084 20.1932 10.5607 20.0877 10.5815C19.9821 10.6024 19.8727 10.591 19.7737 10.5488C19.6747 10.5066 19.5907 10.4356 19.5326 10.3449C19.4746 10.2543 19.4452 10.1483 19.4483 10.0407C19.4438 9.97037 19.4532 9.89984 19.476 9.83314C19.4988 9.76643 19.5345 9.70487 19.581 9.65196C19.6276 9.59906 19.6841 9.55583 19.7474 9.52478C19.8107 9.49371 19.8794 9.47542 19.9498 9.47094C20.0918 9.46188 20.2317 9.50962 20.3385 9.60368C20.3914 9.65024 20.4347 9.70677 20.4657 9.77004C20.4968 9.83331 20.5151 9.90207 20.5195 9.97241L20.5383 10.1184L20.6186 9.99518C20.6892 9.89211 20.7831 9.80712 20.8927 9.74709C21.0023 9.68707 21.1245 9.65371 21.2493 9.6497C21.3294 9.65002 21.4088 9.66268 21.485 9.68719C21.5943 9.72139 21.69 9.78904 21.7587 9.88058C21.8274 9.97212 21.8656 10.0829 21.868 10.1974C21.868 10.2683 21.9242 10.271 21.9336 10.271C21.9457 10.2702 21.9575 10.2669 21.9684 10.2614C21.9792 10.2559 21.9888 10.2482 21.9965 10.2389C22.0483 10.1847 22.1107 10.1418 22.1798 10.1127C22.249 10.0837 22.3233 10.0692 22.3982 10.0702C22.5017 10.0722 22.6037 10.0949 22.6982 10.1371C23.2084 10.3567 22.9767 11.0048 22.974 11.0115C22.9299 11.1186 22.9285 11.1669 22.974 11.1936L22.9941 11.203H23.0102C23.0439 11.1994 23.0768 11.1908 23.108 11.1776C23.1935 11.1437 23.2839 11.1233 23.3758 11.1173C23.5604 11.1173 23.7376 11.1907 23.8681 11.3212C23.9987 11.4518 24.0721 11.629 24.0721 11.8136C24.0721 11.9983 23.9987 12.1754 23.8681 12.306C23.7376 12.4366 23.5604 12.5099 23.3758 12.5099L23.3798 12.5073Z\" fill=\"#253E8A\"/>\n<path id=\"Vector_7\" d=\"M37.5378 18.7659C37.2174 18.3642 36.7303 18.1633 36.0769 18.1633C35.4234 18.1633 34.9369 18.3642 34.6173 18.7659C34.3054 19.1762 34.1367 19.6774 34.1367 20.1927C34.1367 20.7079 34.3054 21.2092 34.6173 21.6194C34.9387 22.0158 35.4252 22.214 36.0769 22.214C36.7286 22.214 37.2155 22.0158 37.5378 21.6194C37.8495 21.2092 38.0184 20.7079 38.0184 20.1927C38.0184 19.6774 37.8495 19.1762 37.5378 18.7659ZM36.7437 21.0771C36.661 21.1738 36.5583 21.2515 36.4427 21.3046C36.3272 21.3579 36.2014 21.3855 36.0742 21.3855C35.947 21.3855 35.8213 21.3579 35.7057 21.3046C35.5901 21.2515 35.4874 21.1738 35.4047 21.0771C35.2326 20.8168 35.1504 20.5074 35.1703 20.196C35.1508 19.8855 35.233 19.5771 35.4047 19.3176C35.4877 19.2213 35.5904 19.1441 35.706 19.091C35.8215 19.0381 35.9471 19.0107 36.0742 19.0107C36.2013 19.0107 36.3269 19.0381 36.4424 19.091C36.558 19.1441 36.6607 19.2213 36.7437 19.3176C36.9143 19.5775 36.996 19.8858 36.9767 20.196C36.9964 20.5072 36.9147 20.8164 36.7437 21.0771Z\" fill=\"#253E8A\"/>\n<path id=\"Vector_8\" d=\"M29.3429 18.43C28.9961 18.26 28.6136 18.1751 28.2274 18.1823C27.5829 18.1823 27.1285 18.3501 26.8643 18.6858C26.6895 18.9251 26.5914 19.2118 26.5831 19.508H27.5418C27.5562 19.3809 27.6048 19.2601 27.6824 19.1585C27.7491 19.0941 27.8292 19.0451 27.9168 19.0147C28.0045 18.9844 28.0977 18.9736 28.1899 18.9831C28.356 18.9734 28.5219 19.0042 28.6733 19.0728C28.7289 19.1049 28.7742 19.1526 28.8034 19.2098C28.8326 19.2671 28.8446 19.3315 28.838 19.3955C28.8372 19.4595 28.8161 19.5215 28.7775 19.5727C28.739 19.6237 28.6851 19.661 28.6238 19.6794C28.4943 19.7258 28.3592 19.7552 28.2221 19.7664L27.8806 19.8079C27.5746 19.8339 27.2762 19.9169 27.0009 20.053C26.6366 20.2628 26.4545 20.602 26.4545 21.0707C26.4451 21.2267 26.4709 21.3828 26.5296 21.5277C26.5886 21.6724 26.6791 21.8023 26.7946 21.9076C27.0379 22.1035 27.342 22.2082 27.6543 22.2035C29.8289 22.2999 29.8048 21.0573 29.8249 20.7988V19.3674C29.8316 18.9094 29.6683 18.5961 29.3429 18.43ZM28.838 20.602C28.8309 20.9358 28.7359 21.1653 28.5528 21.2903C28.3767 21.4137 28.1666 21.4797 27.9516 21.4791C27.8252 21.4828 27.7015 21.4431 27.6008 21.3666C27.55 21.3203 27.5106 21.2627 27.4857 21.1985C27.461 21.1345 27.4512 21.0654 27.4575 20.997C27.4529 20.9114 27.4727 20.8264 27.5144 20.7516C27.556 20.6767 27.618 20.6151 27.6932 20.5739C27.8375 20.5046 27.9922 20.4594 28.1511 20.44L28.3787 20.3971C28.4697 20.3816 28.5593 20.3588 28.6466 20.3288C28.7142 20.3038 28.7787 20.2714 28.8394 20.2324L28.838 20.602Z\" fill=\"#253E8A\"/>\n<path id=\"Vector_9\" d=\"M24.384 19.0351C24.4873 19.0268 24.5911 19.0434 24.6865 19.0834C24.7822 19.1236 24.8666 19.186 24.9331 19.2654C25.0138 19.3789 25.0658 19.5103 25.0844 19.6484H26.1556C26.0967 19.1074 25.9075 18.7298 25.5879 18.5155C25.2171 18.2889 24.7874 18.1775 24.3532 18.1955C23.7627 18.1955 23.2981 18.3762 22.9633 18.7391C22.6285 19.102 22.4598 19.6042 22.4598 20.2603C22.4374 20.7695 22.5995 21.2698 22.9164 21.669C23.2209 22.0323 23.6954 22.214 24.3399 22.214C24.9843 22.214 25.471 21.9967 25.7994 21.5619C25.996 21.3162 26.1161 21.0182 26.1449 20.7049H25.0737C25.0605 20.8823 24.9953 21.0518 24.8862 21.1923C24.8184 21.2606 24.7362 21.3128 24.6457 21.3453C24.555 21.3778 24.4584 21.3895 24.3626 21.3798C24.209 21.3898 24.0564 21.3488 23.9285 21.2631C23.8006 21.1773 23.7046 21.0517 23.6556 20.9057C23.5795 20.6909 23.5446 20.4638 23.5525 20.2362C23.5445 19.998 23.5794 19.7603 23.6556 19.5345C23.7043 19.3823 23.8024 19.2505 23.9343 19.1601C24.0662 19.0696 24.2244 19.0257 24.384 19.0351Z\" fill=\"#253E8A\"/>\n<path id=\"Vector_10\" d=\"M22.1735 18.1958C19.9695 18.1958 20.0993 20.1468 20.0993 20.1468V22.1286H21.0996V20.274C21.0863 20.0428 21.1256 19.8115 21.2148 19.5978C21.3514 19.338 21.6192 19.2081 22.0182 19.2081H22.1374C22.1856 19.2081 22.2405 19.2081 22.3048 19.2215V18.2038H22.2191L22.1735 18.1958Z\" fill=\"#253E8A\"/>\n<path id=\"Vector_11\" d=\"M18.4989 21.0919C18.462 21.1487 18.4169 21.1997 18.365 21.2432C18.2019 21.3577 18.004 21.4117 17.8053 21.3959C17.6174 21.4053 17.431 21.3587 17.2697 21.262C17.0206 21.1093 16.88 20.8495 16.8679 20.4679H19.6331C19.6411 20.2162 19.6299 19.9642 19.5996 19.714C19.5592 19.4347 19.4557 19.1681 19.297 18.9347C19.1357 18.6891 18.9082 18.4941 18.6409 18.3723C18.359 18.2506 18.0547 18.1899 17.7477 18.1942C17.4973 18.1847 17.2475 18.2265 17.0138 18.317C16.7801 18.4075 16.5673 18.5448 16.3886 18.7204C16.0404 19.0722 15.8659 19.577 15.865 20.2349C15.865 20.9383 16.0583 21.4454 16.4448 21.7561C16.8226 22.0641 17.2965 22.2295 17.7839 22.2234C18.3954 22.2234 18.8716 22.0386 19.2126 21.6691C19.3755 21.5093 19.4949 21.3107 19.5595 21.0919H18.4989ZM17.1599 19.2306C17.2385 19.1556 17.3318 19.0977 17.4338 19.0603C17.5359 19.0229 17.6446 19.0071 17.7531 19.0137C17.968 19.0069 18.1779 19.0798 18.3423 19.2186C18.4253 19.2952 18.4919 19.3878 18.5379 19.4909C18.584 19.594 18.6085 19.7056 18.6101 19.8185H16.8907C16.9134 19.5993 17.0059 19.3933 17.1545 19.2306H17.1599Z\" fill=\"#253E8A\"/>\n<path id=\"Vector_12\" d=\"M15.4634 22.1272H14.5528V19.828C14.5528 19.6178 14.4832 19.1183 13.8833 19.1183C13.79 19.115 13.697 19.1312 13.6103 19.1659C13.5237 19.2007 13.4452 19.253 13.38 19.3199C13.3148 19.3868 13.2643 19.4665 13.2318 19.5539C13.1992 19.6415 13.1853 19.7348 13.191 19.828V22.1272H12.2764V19.828C12.2764 19.6178 12.2148 19.1183 11.6069 19.1183C11.5136 19.115 11.4206 19.1312 11.3339 19.1659C11.2473 19.2007 11.1688 19.253 11.1036 19.3199C11.0384 19.3868 10.9879 19.4665 10.9554 19.5539C10.9228 19.6415 10.9089 19.7348 10.9146 19.828V22.1272H10V19.8508C10 18.9014 10.6307 18.1837 11.6069 18.1837C11.8247 18.179 12.0406 18.2249 12.2377 18.3178C12.4347 18.4108 12.6075 18.5482 12.7424 18.7193C12.8799 18.5511 13.0532 18.4159 13.2496 18.3232C13.4461 18.2305 13.6607 18.1829 13.8779 18.1837C14.8755 18.1837 15.4634 18.872 15.4634 19.8508V22.1272Z\" fill=\"#253E8A\"/>\n<path id=\"Vector_13\" d=\"M33.8354 16.9932C33.8354 16.9932 32.8271 16.8861 32.8271 17.6949V18.7661C32.72 18.5918 32.5703 18.4474 32.3919 18.347C32.2036 18.2439 31.9918 18.1918 31.7773 18.1957C31.548 18.1877 31.32 18.234 31.112 18.3308C30.904 18.4276 30.7217 18.5722 30.5802 18.7527C30.2816 19.125 30.1329 19.6606 30.1329 20.3087C30.1119 20.8094 30.2737 21.3006 30.5882 21.6906C30.8908 22.0495 31.4854 22.2075 32.0143 22.2075C33.8555 22.2075 33.8341 20.6274 33.8341 20.6274L33.8354 16.9932ZM32.6303 21.0787C32.5592 21.1815 32.4628 21.2644 32.3505 21.3196C32.2382 21.3746 32.1138 21.4001 31.9889 21.3934C31.8654 21.4009 31.7422 21.3756 31.6316 21.32C31.5211 21.2646 31.4273 21.1809 31.3595 21.0774C31.2098 20.8136 31.1379 20.5127 31.1519 20.2096C31.1422 19.9238 31.2126 19.6407 31.3555 19.3928C31.4223 19.285 31.5171 19.1974 31.6299 19.1393C31.7426 19.0814 31.869 19.0551 31.9956 19.0634C32.1793 19.061 32.3576 19.1253 32.4977 19.2442C32.732 19.4437 32.8499 19.8026 32.8499 20.2672C32.8649 20.5524 32.7915 20.8354 32.6396 21.0774L32.6303 21.0787Z\" fill=\"#253E8A\"/>\n<path id=\"Vector_14\" d=\"M17.278 28.1742C17.279 28.2393 17.2665 28.3038 17.2411 28.3638C17.2157 28.4238 17.1781 28.4778 17.1307 28.5224C17.0849 28.5696 17.0299 28.6069 16.9691 28.632C16.9083 28.6571 16.843 28.6695 16.7772 28.6683H16.2764V25.1868C16.2764 24.5106 16.5053 24.0861 16.8803 23.7995C17.1293 23.6107 17.4989 23.4299 18.1912 23.4299C18.6586 23.4299 19.2062 23.6107 19.5022 23.9722C19.8342 24.374 19.9722 24.8292 19.9722 25.4198C19.9722 26.0304 19.8249 26.5232 19.5316 26.9021C19.3995 27.0771 19.2279 27.2183 19.0308 27.3141C18.8336 27.41 18.6166 27.458 18.3974 27.4538C18.1742 27.4574 17.9529 27.4116 17.7493 27.3199C17.5505 27.2203 17.3862 27.0629 17.278 26.8686V28.1742ZM18.9572 25.464C18.9762 25.1575 18.8989 24.8527 18.7362 24.5922C18.6641 24.4933 18.5684 24.4137 18.4578 24.3612C18.3472 24.3086 18.2252 24.2844 18.1028 24.2909C17.9822 24.2861 17.8624 24.3116 17.7541 24.3649C17.6458 24.4182 17.5526 24.4977 17.4829 24.5963C17.349 24.7797 17.278 25.0716 17.278 25.468C17.278 25.8366 17.3516 26.1125 17.4989 26.2955C17.5706 26.3953 17.6661 26.4755 17.7767 26.5288C17.8874 26.5821 18.0096 26.6068 18.1323 26.6008C18.2505 26.6044 18.3677 26.5785 18.4732 26.5252C18.5787 26.4717 18.6691 26.3929 18.7362 26.2955C18.8956 26.0501 18.973 25.7603 18.9572 25.468\" fill=\"#00AEEF\"/>\n<path id=\"Vector_15\" d=\"M26.6044 27.1339V26.8875C26.5278 27.0151 26.426 27.1259 26.3055 27.213C26.1849 27.3004 26.0479 27.3622 25.9027 27.395C25.6108 27.4622 25.3052 27.4369 25.0283 27.3227C24.7189 27.1893 24.4584 26.9633 24.2825 26.676C24.0599 26.3014 23.952 25.8698 23.9718 25.4346C23.9718 24.8347 24.1093 24.3483 24.3842 23.9751C24.6587 23.6028 25.1006 23.4394 25.7072 23.4167C26.3138 23.3939 26.6539 23.5359 26.9954 23.7943C27.3676 24.0768 27.5873 24.5107 27.5873 25.1883V27.237C27.5873 27.8891 27.1347 29.097 25.7126 28.9939C24.8288 28.9296 24.3387 28.5667 24.0642 27.7445H25.1207C25.2055 27.883 25.3301 27.9925 25.4782 28.0588C25.6265 28.1249 25.7913 28.1448 25.9509 28.1154C26.1238 28.0725 26.2771 27.9724 26.3861 27.8316C26.5327 27.6291 26.6111 27.3853 26.6097 27.1353L26.6044 27.1339ZM24.9614 25.4654C24.9614 26.134 25.1542 26.5042 25.5398 26.5755C25.9241 26.6478 26.2094 26.5581 26.3928 26.3077C26.4967 26.1599 26.5613 25.9879 26.5803 25.8082C26.6184 25.5869 26.6213 25.3609 26.5883 25.1387C26.5578 24.9238 26.4761 24.7195 26.35 24.5428C26.2874 24.4567 26.2043 24.3878 26.1081 24.3421C26.012 24.2964 25.9058 24.2757 25.7996 24.2817C25.4715 24.2817 25.2506 24.4022 25.1301 24.6433C25.0112 24.9032 24.9521 25.1864 24.9573 25.4721\" fill=\"#00AEEF\"/>\n<path id=\"Vector_16\" d=\"M23.1229 23.6925C22.7755 23.5225 22.3927 23.4376 22.0061 23.4447C21.3607 23.4447 20.9054 23.6125 20.6403 23.9482C20.4657 24.1882 20.3677 24.4752 20.3591 24.7718H21.3232C21.3382 24.6459 21.3862 24.5262 21.4624 24.4249C21.529 24.3608 21.6088 24.3119 21.6962 24.2818C21.7837 24.2518 21.8766 24.2412 21.9686 24.2509C22.1351 24.2411 22.3014 24.2719 22.4534 24.3406C22.5091 24.3727 22.5545 24.4203 22.5839 24.4774C22.6134 24.5347 22.6257 24.5993 22.6194 24.6633C22.6183 24.7274 22.5969 24.7894 22.5581 24.8406C22.5193 24.8916 22.4653 24.929 22.4038 24.9472C22.2742 24.9936 22.1392 25.0232 22.0021 25.0356L21.6606 25.0771C21.3536 25.1022 21.0542 25.1854 20.7782 25.3221C20.414 25.5327 20.2319 25.8725 20.2319 26.3411C20.2238 26.4973 20.2508 26.6531 20.3108 26.7975C20.3708 26.9418 20.4623 27.0709 20.5787 27.1754C20.8223 27.3715 21.1269 27.4763 21.4397 27.4713C23.6183 27.5691 23.5929 26.3237 23.613 26.0653V24.6312C23.613 24.1719 23.451 23.8585 23.1242 23.6938L23.1229 23.6925ZM22.614 25.8684C22.614 26.2019 22.5123 26.4308 22.3288 26.5581C22.1527 26.6815 21.9427 26.7475 21.7276 26.7469C21.601 26.7505 21.4771 26.7103 21.3768 26.633C21.3256 26.587 21.2859 26.5295 21.2608 26.4654C21.2357 26.4013 21.2259 26.332 21.2321 26.2635C21.2276 26.1779 21.2473 26.0929 21.289 26.018C21.3307 25.9432 21.3927 25.8816 21.4678 25.8403C21.6126 25.771 21.7677 25.7257 21.9271 25.7064L22.1547 25.6649C22.2456 25.6484 22.3352 25.6251 22.4226 25.5953C22.4898 25.5693 22.554 25.5361 22.614 25.4962V25.8684Z\" fill=\"#00AEEF\"/>\n<path id=\"Vector_17\" d=\"M31.382 24.0087C31.0606 23.606 30.5728 23.4048 29.9184 23.4048C29.264 23.4048 28.7766 23.606 28.4562 24.0087C28.1443 24.4201 27.9756 24.9219 27.9756 25.4381C27.9756 25.9544 28.1443 26.4562 28.4562 26.8676C28.7789 27.2626 29.2596 27.4621 29.9184 27.4621C30.5772 27.4621 31.0606 27.2626 31.382 26.8676C31.6947 26.4566 31.8639 25.9545 31.8639 25.4381C31.8639 24.9218 31.6947 24.4197 31.382 24.0087ZM30.5866 26.3159C30.504 26.4128 30.4014 26.4906 30.2857 26.5439C30.1702 26.5974 30.0444 26.625 29.9171 26.625C29.7897 26.625 29.664 26.5974 29.5484 26.5439C29.4328 26.4906 29.3302 26.4128 29.2476 26.3159C29.0896 26.1097 29.0119 25.8164 29.0119 25.4348C29.0119 25.0532 29.0896 24.7653 29.2476 24.555C29.3307 24.4589 29.4334 24.3819 29.549 24.329C29.6645 24.2762 29.79 24.2488 29.9171 24.2488C30.0442 24.2488 30.1696 24.2762 30.2852 24.329C30.4008 24.3819 30.5036 24.4589 30.5866 24.555C30.7394 24.8234 30.8196 25.1267 30.8196 25.4355C30.8196 25.7443 30.7394 26.0476 30.5866 26.3159Z\" fill=\"#00AEEF\"/>\n</g>\n</g>\n</svg>";

var AnkColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Ank, Color=On\">\n<g id=\"Group\">\n<g id=\"Group_2\">\n<g id=\"XMLID_2_\">\n<path id=\"Vector\" d=\"M27.7443 15.0921C27.5556 14.719 27.2612 14.4117 26.8666 14.1787C26.475 13.9485 25.9947 13.8313 25.4386 13.8313C24.7539 13.8313 24.0721 13.9728 23.4117 14.253C23.1229 14.3745 22.9657 14.6103 22.9657 14.9134C22.9657 15.1006 23.0343 15.2679 23.1629 15.3965C23.2916 15.5266 23.456 15.5952 23.6347 15.5952C23.6947 15.5952 23.7619 15.5852 23.8419 15.5652C23.8477 15.5638 23.8548 15.5624 23.8605 15.5595C24.1178 15.4737 24.3522 15.4094 24.5595 15.3665C24.7611 15.3251 24.9955 15.3051 25.2599 15.3051C25.7045 15.3051 26.0276 15.438 26.2177 15.6081C26.3749 15.7482 26.465 15.9383 26.4878 16.35H25.4043C24.5123 16.35 23.8176 16.4858 23.3402 16.846C22.8399 17.2219 22.5854 17.7108 22.5854 18.3426C22.5854 18.7243 22.6812 19.0574 22.8713 19.3547C23.06 19.6506 23.3188 19.8736 23.639 20.0279C23.9506 20.178 24.2936 20.2509 24.6581 20.2509C25.2299 20.2509 25.7445 20.128 26.1948 19.8864C26.3678 19.7935 26.5736 19.8307 26.7108 19.9693C26.7123 19.9708 26.7123 19.9708 26.7137 19.9722C26.8581 20.1166 27.0439 20.1923 27.2526 20.1923C27.4584 20.1923 27.6457 20.1166 27.7929 19.9751C27.943 19.8307 28.0216 19.6434 28.0216 19.4333V16.2828C28.0216 15.8583 27.9287 15.4566 27.7443 15.0921ZM25.0384 18.8415C24.6882 18.8415 24.4337 18.78 24.3036 18.6628C24.1764 18.5485 24.1164 18.4041 24.1164 18.2097C24.1164 17.7966 24.5952 17.5879 25.5401 17.5879H26.0519C26.2863 17.5879 26.4764 17.778 26.4764 18.0124C26.4764 18.1325 26.4278 18.2483 26.3363 18.3283C26.2048 18.4427 26.0233 18.5442 25.8546 18.6328C25.5901 18.7715 25.3214 18.8415 25.0384 18.8415Z\" fill=\"#465466\"/>\n<path id=\"Vector_2\" d=\"M34.3427 15.0578C34.1625 14.6818 33.891 14.3802 33.5507 14.1615C33.2091 13.9428 32.8003 13.8313 32.3443 13.8313C31.8554 13.8313 31.4223 13.9356 31.0564 14.1429C30.8705 14.2487 30.689 14.3745 30.516 14.5189C30.4874 14.353 30.4031 14.203 30.2716 14.0843C30.1287 13.9557 29.9471 13.887 29.7541 13.887C29.5454 13.8885 29.3868 13.9671 29.2424 14.1158C29.1009 14.263 29.0537 14.4502 29.0537 14.6561V19.4333C29.0537 19.642 29.1023 19.8278 29.2453 19.9722C29.3896 20.1166 29.5612 20.1923 29.7699 20.1923C29.9757 20.1923 30.193 20.118 30.3402 19.9751C30.4903 19.8307 30.5989 19.6434 30.5989 19.4333V16.5787C30.5989 16.2928 30.7147 16.0184 30.9191 15.8182C31.0321 15.7082 31.1507 15.611 31.2751 15.5295C31.5281 15.3637 31.7954 15.2822 32.1184 15.2822C32.7874 15.2822 33.0733 15.6224 33.0733 16.3829V19.4333C33.0733 19.642 33.1434 19.8278 33.2877 19.9722C33.4321 20.1166 33.6151 20.1923 33.8238 20.1923C34.0296 20.1923 34.2297 20.118 34.3784 19.9751C34.5285 19.8307 34.6214 19.6434 34.6214 19.4333V16.2714C34.6214 15.834 34.5171 15.4251 34.3427 15.0578Z\" fill=\"#465466\"/>\n<path id=\"Vector_3\" d=\"M40.841 18.989L39.0742 16.6462C39.0142 16.5675 39.0256 16.4546 39.0985 16.3889L40.395 15.2281C40.3979 15.2253 40.4021 15.2224 40.405 15.2181C40.5808 15.0423 40.6695 14.8536 40.6695 14.6578C40.6695 14.4648 40.6108 14.2933 40.4951 14.1503C40.4064 14.0403 40.2349 13.9102 39.9219 13.9102C39.7475 13.9102 39.5802 13.9802 39.4144 14.1232L37.1988 16.173V12.2435C37.1988 12.0491 37.0901 11.7717 36.9472 11.6402C36.8028 11.5073 36.6241 11.4373 36.4269 11.4373C36.2167 11.4373 36.0209 11.5159 35.8765 11.666C35.735 11.8132 35.6521 12.0005 35.6521 12.2063V19.4321C35.6521 19.6408 35.735 19.8267 35.8794 19.971C36.0238 20.1154 36.2139 20.1912 36.4211 20.1912C36.627 20.1912 36.8171 20.1169 36.9643 19.9739C37.1144 19.8295 37.1959 19.6423 37.1959 19.4321V18.4172C37.1959 18.2214 37.2788 18.0356 37.4232 17.9026C37.6605 17.6868 38.0321 17.724 38.2222 17.9827L39.616 19.8796C39.6917 19.9768 39.7846 20.054 39.8933 20.1083C40.0033 20.1626 40.1163 20.1912 40.2306 20.1912C40.445 20.1912 40.628 20.1226 40.7724 19.9896C40.921 19.8524 40.9997 19.6637 40.9997 19.4436C41.0039 19.2835 40.9496 19.1291 40.841 18.989Z\" fill=\"#465466\"/>\n</g>\n</g>\n<g id=\"Group_3\">\n<g id=\"Group_4\">\n<g id=\"Group_5\">\n<path id=\"Vector_4\" d=\"M9.89209 22.1549C9.40751 22.1549 8.91721 22.0334 8.4655 21.7775C7.07608 20.9885 6.58864 19.2217 7.3777 17.8323L10.9928 11.4655C11.7818 10.0761 13.5486 9.58864 14.938 10.3777C16.3275 11.1667 16.8149 12.9335 16.0258 14.323L12.4122 20.6897C11.879 21.6289 10.8999 22.1549 9.89209 22.1549Z\" fill=\"#FF3366\"/>\n</g>\n<g id=\"Group_6\">\n<path id=\"Vector_5\" d=\"M9.89527 22.1564C9.55792 22.1564 9.21628 22.0978 8.88179 21.972C7.38516 21.4116 6.6247 19.7449 7.18504 18.2483C7.66247 16.9732 8.50299 15.8825 9.61795 15.0949C10.7615 14.2873 12.108 13.8599 13.5103 13.8599C14.9141 13.8599 16.2592 14.2873 17.4027 15.0949C18.5177 15.8825 19.3582 16.9732 19.8356 18.2483C20.3945 19.7449 19.6355 21.4131 18.1375 21.972C17.803 22.0963 17.4613 22.1564 17.1254 22.1564C15.9518 22.1564 14.8483 21.4388 14.4137 20.2752C14.2965 19.9636 13.972 19.6477 13.5089 19.6477C13.0458 19.6477 12.7213 19.9622 12.6041 20.2752C12.1709 21.4374 11.0674 22.1564 9.89527 22.1564Z\" fill=\"url(#paint0_linear_430_1237)\"/>\n</g>\n</g>\n</g>\n</g>\n</g>\n<defs>\n<linearGradient id=\"paint0_linear_430_1237\" x1=\"7.00067\" y1=\"18.0075\" x2=\"20.0202\" y2=\"18.0075\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#FF00FF\" stop-opacity=\"0\"/>\n<stop offset=\"0.1455\" stop-color=\"#E12FFA\" stop-opacity=\"0.1455\"/>\n<stop offset=\"0.379\" stop-color=\"#B475F2\" stop-opacity=\"0.379\"/>\n<stop offset=\"0.5897\" stop-color=\"#90ACEC\" stop-opacity=\"0.5897\"/>\n<stop offset=\"0.7699\" stop-color=\"#77D4E8\" stop-opacity=\"0.7699\"/>\n<stop offset=\"0.9126\" stop-color=\"#67ECE5\" stop-opacity=\"0.9126\"/>\n<stop offset=\"1\" stop-color=\"#61F5E4\"/>\n</linearGradient>\n</defs>\n</svg>";

var AnkGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Ank, Color=Off\">\n<g id=\"Group\">\n<g id=\"Group_2\">\n<g id=\"XMLID_2_\">\n<path id=\"Vector\" d=\"M27.7443 15.0921C27.5556 14.719 27.2612 14.4117 26.8666 14.1787C26.475 13.9485 25.9947 13.8313 25.4386 13.8313C24.7539 13.8313 24.0721 13.9728 23.4117 14.253C23.1229 14.3745 22.9657 14.6103 22.9657 14.9134C22.9657 15.1006 23.0343 15.2679 23.1629 15.3965C23.2916 15.5266 23.456 15.5952 23.6347 15.5952C23.6947 15.5952 23.7619 15.5852 23.8419 15.5652C23.8477 15.5638 23.8548 15.5624 23.8605 15.5595C24.1178 15.4737 24.3522 15.4094 24.5595 15.3665C24.7611 15.3251 24.9955 15.3051 25.2599 15.3051C25.7045 15.3051 26.0276 15.438 26.2177 15.6081C26.3749 15.7482 26.465 15.9383 26.4878 16.35H25.4043C24.5123 16.35 23.8176 16.4858 23.3402 16.846C22.8399 17.2219 22.5854 17.7108 22.5854 18.3426C22.5854 18.7243 22.6812 19.0574 22.8713 19.3547C23.06 19.6506 23.3188 19.8736 23.639 20.0279C23.9506 20.178 24.2936 20.2509 24.6581 20.2509C25.2299 20.2509 25.7445 20.128 26.1948 19.8864C26.3678 19.7935 26.5736 19.8307 26.7108 19.9693C26.7123 19.9708 26.7123 19.9708 26.7137 19.9722C26.8581 20.1166 27.0439 20.1923 27.2526 20.1923C27.4584 20.1923 27.6457 20.1166 27.7929 19.9751C27.943 19.8307 28.0216 19.6434 28.0216 19.4333V16.2828C28.0216 15.8583 27.9287 15.4566 27.7443 15.0921ZM25.0384 18.8415C24.6882 18.8415 24.4337 18.78 24.3036 18.6628C24.1764 18.5485 24.1164 18.4041 24.1164 18.2097C24.1164 17.7966 24.5952 17.5879 25.5401 17.5879H26.0519C26.2863 17.5879 26.4764 17.778 26.4764 18.0124C26.4764 18.1325 26.4278 18.2483 26.3363 18.3283C26.2048 18.4427 26.0233 18.5442 25.8546 18.6328C25.5901 18.7715 25.3214 18.8415 25.0384 18.8415Z\" fill=\"#647180\"/>\n<path id=\"Vector_2\" d=\"M34.3427 15.0578C34.1625 14.6818 33.891 14.3802 33.5507 14.1615C33.2091 13.9428 32.8003 13.8313 32.3443 13.8313C31.8554 13.8313 31.4223 13.9356 31.0564 14.1429C30.8705 14.2487 30.689 14.3745 30.516 14.5189C30.4874 14.353 30.4031 14.203 30.2716 14.0843C30.1287 13.9557 29.9471 13.887 29.7541 13.887C29.5454 13.8885 29.3868 13.9671 29.2424 14.1158C29.1009 14.263 29.0537 14.4502 29.0537 14.6561V19.4333C29.0537 19.642 29.1023 19.8278 29.2453 19.9722C29.3896 20.1166 29.5612 20.1923 29.7699 20.1923C29.9757 20.1923 30.193 20.118 30.3402 19.9751C30.4903 19.8307 30.5989 19.6434 30.5989 19.4333V16.5787C30.5989 16.2928 30.7147 16.0184 30.9191 15.8182C31.0321 15.7082 31.1507 15.611 31.2751 15.5295C31.5281 15.3637 31.7954 15.2822 32.1184 15.2822C32.7874 15.2822 33.0733 15.6224 33.0733 16.3829V19.4333C33.0733 19.642 33.1434 19.8278 33.2877 19.9722C33.4321 20.1166 33.6151 20.1923 33.8238 20.1923C34.0296 20.1923 34.2297 20.118 34.3784 19.9751C34.5285 19.8307 34.6214 19.6434 34.6214 19.4333V16.2714C34.6214 15.834 34.5171 15.4251 34.3427 15.0578Z\" fill=\"#647180\"/>\n<path id=\"Vector_3\" d=\"M40.841 18.989L39.0742 16.6462C39.0142 16.5675 39.0256 16.4546 39.0985 16.3889L40.395 15.2281C40.3979 15.2253 40.4021 15.2224 40.405 15.2181C40.5808 15.0423 40.6695 14.8536 40.6695 14.6578C40.6695 14.4648 40.6108 14.2933 40.4951 14.1503C40.4064 14.0403 40.2349 13.9102 39.9219 13.9102C39.7475 13.9102 39.5802 13.9802 39.4144 14.1232L37.1988 16.173V12.2435C37.1988 12.0491 37.0901 11.7717 36.9472 11.6402C36.8028 11.5073 36.6241 11.4373 36.4269 11.4373C36.2167 11.4373 36.0209 11.5159 35.8765 11.666C35.735 11.8132 35.6521 12.0005 35.6521 12.2063V19.4321C35.6521 19.6408 35.735 19.8267 35.8794 19.971C36.0238 20.1154 36.2139 20.1912 36.4211 20.1912C36.627 20.1912 36.8171 20.1169 36.9643 19.9739C37.1144 19.8295 37.1959 19.6423 37.1959 19.4321V18.4172C37.1959 18.2214 37.2788 18.0356 37.4232 17.9026C37.6605 17.6868 38.0321 17.724 38.2222 17.9827L39.616 19.8796C39.6917 19.9768 39.7846 20.054 39.8933 20.1083C40.0033 20.1626 40.1163 20.1912 40.2306 20.1912C40.445 20.1912 40.628 20.1226 40.7724 19.9896C40.921 19.8524 40.9997 19.6637 40.9997 19.4436C41.0039 19.2835 40.9496 19.1291 40.841 18.989Z\" fill=\"#647180\"/>\n</g>\n</g>\n<g id=\"Group_3\">\n<g id=\"Group_4\">\n<g id=\"Group_5\">\n<path id=\"Vector_4\" d=\"M9.89209 22.1549C9.40751 22.1549 8.91721 22.0334 8.4655 21.7775C7.07608 20.9885 6.58864 19.2217 7.3777 17.8323L10.9928 11.4655C11.7818 10.0761 13.5486 9.58864 14.938 10.3777C16.3275 11.1667 16.8149 12.9335 16.0258 14.323L12.4122 20.6897C11.879 21.6289 10.8999 22.1549 9.89209 22.1549Z\" fill=\"#647180\"/>\n</g>\n<g id=\"Group_6\">\n<path id=\"Vector_5\" d=\"M9.89527 22.1564C9.55792 22.1564 9.21628 22.0978 8.88179 21.972C7.38516 21.4116 6.6247 19.7449 7.18504 18.2483C7.66247 16.9732 8.50299 15.8825 9.61795 15.0949C10.7615 14.2873 12.108 13.8599 13.5103 13.8599C14.9141 13.8599 16.2592 14.2873 17.4027 15.0949C18.5177 15.8825 19.3582 16.9732 19.8356 18.2483C20.3945 19.7449 19.6355 21.4131 18.1375 21.972C17.803 22.0963 17.4613 22.1564 17.1254 22.1564C15.9518 22.1564 14.8483 21.4388 14.4137 20.2752C14.2965 19.9636 13.972 19.6477 13.5089 19.6477C13.0458 19.6477 12.7213 19.9622 12.6041 20.2752C12.1709 21.4374 11.0674 22.1564 9.89527 22.1564Z\" fill=\"url(#paint0_linear_430_1277)\"/>\n</g>\n</g>\n</g>\n</g>\n</g>\n<defs>\n<linearGradient id=\"paint0_linear_430_1277\" x1=\"19.312\" y1=\"20.2599\" x2=\"9.73604\" y2=\"14.788\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#B6C5D5\"/>\n<stop offset=\"1\" stop-color=\"#B6C5D5\" stop-opacity=\"0\"/>\n</linearGradient>\n</defs>\n</svg>";

var InstantPaymentColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Sin_especificar, Color=On\">\n<g id=\"sin-especificar \">\n<g id=\"icon-fill\">\n<path d=\"M30.0261 5.36586C30.0261 3.6647 28.6052 2.28564 26.8525 2.28564H15.7451C13.9924 2.28564 12.5715 3.6647 12.5715 5.36586V25.3872C12.5715 27.0884 13.9924 28.4675 15.7451 28.4675H26.6064C26.2218 28.0018 25.8975 27.4844 25.6455 26.9274H15.7451C14.8687 26.9274 14.1583 26.2378 14.1583 25.3872V5.36586C14.1583 4.51528 14.8687 3.82575 15.7451 3.82575H26.8525C27.7289 3.82575 28.4393 4.51528 28.4393 5.36586V18.1805C28.9323 17.8922 29.4646 17.6636 30.0261 17.5048V5.36586Z\" fill=\"#373E45\"/>\n<path d=\"M24.0375 24.0951C24.0375 23.6577 23.6722 23.3031 23.2215 23.3031H19.0673C18.6166 23.3031 18.2513 23.6577 18.2513 24.0951V24.3831C18.2513 24.8205 18.6166 25.1751 19.0673 25.1751H23.2215C23.6722 25.1751 24.0375 24.8205 24.0375 24.3831V24.0951Z\" fill=\"#373E45\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.8962 29.7142C34.9618 29.7142 37.5066 27.1931 37.5066 24.1038C37.5066 21.0264 34.9618 18.4934 31.8962 18.4934C28.8188 18.4934 26.2858 21.0264 26.2858 24.1038C26.2858 27.1931 28.8188 29.7142 31.8962 29.7142ZM31.2858 27.2207C31.1345 27.2207 30.9509 27.1466 30.832 26.9985L28.8982 24.5544C28.8117 24.4556 28.7793 24.2828 28.7793 24.1347C28.7793 23.7767 29.017 23.4928 29.3303 23.4928C29.5248 23.4928 29.6652 23.6039 29.7625 23.7273L31.2642 25.5666L33.9867 21.2585C34.084 21.098 34.2568 20.9869 34.4513 20.9869C34.7538 20.9869 35.0131 21.2462 35.0131 21.6165C35.0131 21.7276 34.9699 21.8634 34.8834 21.9992L31.7504 26.9738C31.6531 27.122 31.4803 27.2207 31.2858 27.2207Z\" fill=\"#373E45\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.3537 7.27266C21.5805 7.27266 21.7652 7.3395 21.9079 7.47319C22.0506 7.60688 22.1219 7.78279 22.1219 8.00092V8.49698L22.4243 8.55357C22.9263 8.66595 23.4182 8.86873 23.8999 9.16192C24.0316 9.24635 24.1249 9.33958 24.1797 9.44161C24.2346 9.54364 24.262 9.66853 24.262 9.8163C24.262 10.0274 24.1962 10.2103 24.0645 10.3651C23.9328 10.5199 23.7791 10.5973 23.6035 10.5973C23.5157 10.5973 23.4316 10.5833 23.3511 10.5551C23.2706 10.527 23.1536 10.4742 22.9999 10.3968C22.9487 10.3686 22.8353 10.3106 22.6597 10.2226C22.4841 10.1347 22.2957 10.0643 22.0945 10.0116C21.8933 9.95878 21.6793 9.9324 21.4525 9.9324C21.1232 9.9324 20.8561 10.001 20.6513 10.1382C20.4464 10.2754 20.344 10.4601 20.344 10.6923C20.344 10.9175 20.4611 11.0864 20.6952 11.1989C20.9293 11.3115 21.2988 11.4241 21.8037 11.5367C22.3451 11.6563 22.7896 11.783 23.1371 11.9166C23.4846 12.0503 23.7846 12.2649 24.0371 12.5605C24.2895 12.856 24.4157 13.2536 24.4157 13.7531C24.4157 14.3231 24.2127 14.8086 23.8066 15.2097C23.4005 15.6107 22.8536 15.8746 22.1658 16.0012V16.5184L22.1573 16.6442C22.1344 16.8052 22.066 16.9392 21.9518 17.0461C21.8091 17.1798 21.6244 17.2467 21.3976 17.2467C21.1708 17.2467 20.986 17.1798 20.8433 17.0461C20.7007 16.9125 20.6293 16.7365 20.6293 16.5184V16.0435L20.2884 15.9933C19.621 15.877 19.0395 15.665 18.5441 15.3574C18.4124 15.28 18.3191 15.1921 18.2642 15.0936C18.2094 14.995 18.1819 14.8649 18.1819 14.703C18.1819 14.492 18.2459 14.309 18.374 14.1542C18.502 13.9994 18.6538 13.922 18.8294 13.922C18.9172 13.922 19.005 13.9361 19.0928 13.9642C19.1806 13.9924 19.2941 14.0451 19.4331 14.1225C19.755 14.2914 20.055 14.411 20.333 14.4814C20.611 14.5518 20.9074 14.5869 21.222 14.5869C21.6098 14.5869 21.9043 14.5254 22.1055 14.4022C22.3067 14.2791 22.4073 14.0944 22.4073 13.8481C22.4073 13.7004 22.3469 13.579 22.2262 13.484C22.1055 13.389 21.9555 13.3134 21.7762 13.2571C21.597 13.2008 21.3354 13.1304 20.9915 13.046C20.4428 12.9123 19.9928 12.7768 19.6416 12.6396C19.2904 12.5024 18.9868 12.2878 18.7307 11.9958C18.4746 11.7038 18.3465 11.3115 18.3465 10.819C18.3465 10.2561 18.5514 9.76704 18.9611 9.3519C19.3709 8.93675 19.9123 8.66234 20.5854 8.52865V8.00092L20.5942 7.8787C20.6176 7.72165 20.6879 7.58824 20.8049 7.47847C20.9513 7.34126 21.1342 7.27266 21.3537 7.27266Z\" fill=\"#373E45\"/>\n</g>\n</g>\n</g>\n</svg>";

var InstantPaymentGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Sin_especificar, Color=Off\">\n<g id=\"sin-especificar \">\n<g id=\"icon-fill\">\n<path d=\"M30.0261 5.36586C30.0261 3.6647 28.6052 2.28564 26.8525 2.28564H15.7451C13.9924 2.28564 12.5715 3.6647 12.5715 5.36586V25.3872C12.5715 27.0884 13.9924 28.4675 15.7451 28.4675H26.6064C26.2218 28.0018 25.8975 27.4844 25.6455 26.9274H15.7451C14.8687 26.9274 14.1583 26.2378 14.1583 25.3872V5.36586C14.1583 4.51528 14.8687 3.82575 15.7451 3.82575H26.8525C27.7289 3.82575 28.4393 4.51528 28.4393 5.36586V18.1805C28.9323 17.8922 29.4646 17.6636 30.0261 17.5048V5.36586Z\" fill=\"#647180\"/>\n<path d=\"M24.0375 24.0951C24.0375 23.6577 23.6722 23.3031 23.2215 23.3031H19.0673C18.6166 23.3031 18.2513 23.6577 18.2513 24.0951V24.3831C18.2513 24.8205 18.6166 25.1751 19.0673 25.1751H23.2215C23.6722 25.1751 24.0375 24.8205 24.0375 24.3831V24.0951Z\" fill=\"#647180\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.8962 29.7142C34.9618 29.7142 37.5066 27.1931 37.5066 24.1038C37.5066 21.0264 34.9618 18.4934 31.8962 18.4934C28.8188 18.4934 26.2858 21.0264 26.2858 24.1038C26.2858 27.1931 28.8188 29.7142 31.8962 29.7142ZM31.2858 27.2207C31.1345 27.2207 30.9509 27.1466 30.832 26.9985L28.8982 24.5544C28.8117 24.4556 28.7793 24.2828 28.7793 24.1347C28.7793 23.7767 29.017 23.4928 29.3303 23.4928C29.5248 23.4928 29.6652 23.6039 29.7625 23.7273L31.2642 25.5666L33.9867 21.2585C34.084 21.098 34.2568 20.9869 34.4513 20.9869C34.7538 20.9869 35.0131 21.2462 35.0131 21.6165C35.0131 21.7276 34.9699 21.8634 34.8834 21.9992L31.7504 26.9738C31.6531 27.122 31.4803 27.2207 31.2858 27.2207Z\" fill=\"#647180\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.3537 7.27266C21.5805 7.27266 21.7652 7.3395 21.9079 7.47319C22.0506 7.60688 22.1219 7.78279 22.1219 8.00092V8.49698L22.4243 8.55357C22.9263 8.66595 23.4182 8.86873 23.8999 9.16192C24.0316 9.24635 24.1249 9.33958 24.1797 9.44161C24.2346 9.54364 24.262 9.66853 24.262 9.8163C24.262 10.0274 24.1962 10.2103 24.0645 10.3651C23.9328 10.5199 23.7791 10.5973 23.6035 10.5973C23.5157 10.5973 23.4316 10.5833 23.3511 10.5551C23.2706 10.527 23.1536 10.4742 22.9999 10.3968C22.9487 10.3686 22.8353 10.3106 22.6597 10.2226C22.4841 10.1347 22.2957 10.0643 22.0945 10.0116C21.8933 9.95878 21.6793 9.9324 21.4525 9.9324C21.1232 9.9324 20.8561 10.001 20.6513 10.1382C20.4464 10.2754 20.344 10.4601 20.344 10.6923C20.344 10.9175 20.4611 11.0864 20.6952 11.1989C20.9293 11.3115 21.2988 11.4241 21.8037 11.5367C22.3451 11.6563 22.7896 11.783 23.1371 11.9166C23.4846 12.0503 23.7846 12.2649 24.0371 12.5605C24.2895 12.856 24.4157 13.2536 24.4157 13.7531C24.4157 14.3231 24.2127 14.8086 23.8066 15.2097C23.4005 15.6107 22.8536 15.8746 22.1658 16.0012V16.5184L22.1573 16.6442C22.1344 16.8052 22.066 16.9392 21.9518 17.0461C21.8091 17.1798 21.6244 17.2467 21.3976 17.2467C21.1708 17.2467 20.986 17.1798 20.8433 17.0461C20.7007 16.9125 20.6293 16.7365 20.6293 16.5184V16.0435L20.2884 15.9933C19.621 15.877 19.0395 15.665 18.5441 15.3574C18.4124 15.28 18.3191 15.1921 18.2642 15.0936C18.2094 14.995 18.1819 14.8649 18.1819 14.703C18.1819 14.492 18.2459 14.309 18.374 14.1542C18.502 13.9994 18.6538 13.922 18.8294 13.922C18.9172 13.922 19.005 13.9361 19.0928 13.9642C19.1806 13.9924 19.2941 14.0451 19.4331 14.1225C19.755 14.2914 20.055 14.411 20.333 14.4814C20.611 14.5518 20.9074 14.5869 21.222 14.5869C21.6098 14.5869 21.9043 14.5254 22.1055 14.4022C22.3067 14.2791 22.4073 14.0944 22.4073 13.8481C22.4073 13.7004 22.3469 13.579 22.2262 13.484C22.1055 13.389 21.9555 13.3134 21.7762 13.2571C21.597 13.2008 21.3354 13.1304 20.9915 13.046C20.4428 12.9123 19.9928 12.7768 19.6416 12.6396C19.2904 12.5024 18.9868 12.2878 18.7307 11.9958C18.4746 11.7038 18.3465 11.3115 18.3465 10.819C18.3465 10.2561 18.5514 9.76704 18.9611 9.3519C19.3709 8.93675 19.9123 8.66234 20.5854 8.52865V8.00092L20.5942 7.8787C20.6176 7.72165 20.6879 7.58824 20.8049 7.47847C20.9513 7.34126 21.1342 7.27266 21.3537 7.27266Z\" fill=\"#647180\"/>\n</g>\n</g>\n</g>\n</svg>";

var DiscoverColor = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Discover, Color=On\">\n<g id=\"brand\">\n<path id=\"Vector\" d=\"M7.38428 7.05537V25.4332C7.38428 25.82 7.73009 26.1365 8.15275 26.1365H29.4701C35.4373 26.1365 40.2787 21.7091 40.2787 16.2443C40.2787 10.783 35.4412 6.35205 29.4701 6.35205H8.15275C7.73009 6.35205 7.38428 6.66855 7.38428 7.05537Z\" fill=\"white\"/>\n<g id=\"Group\">\n<path id=\"Vector_2\" d=\"M9.98202 14.022H8.62183V18.3755H9.97818C10.6967 18.3755 11.2193 18.2208 11.6765 17.8727C12.2183 17.4612 12.541 16.8423 12.541 16.2023C12.541 14.9187 11.4921 14.022 9.98586 14.022H9.98202ZM11.0656 17.2924C10.7735 17.5316 10.397 17.6371 9.79759 17.6371H9.54783V14.7569H9.79759C10.397 14.7569 10.762 14.8554 11.0656 15.1086C11.3883 15.3688 11.5804 15.7768 11.5804 16.1917C11.5804 16.6067 11.3883 17.0287 11.0656 17.2889V17.2924Z\" fill=\"#231F20\"/>\n<path id=\"Vector_3\" d=\"M13.8894 14.022H12.9634V18.3755H13.8894V14.022Z\" fill=\"#231F20\"/>\n<path id=\"Vector_4\" d=\"M16.1602 15.6924C15.603 15.5025 15.4417 15.3794 15.4417 15.1438C15.4417 14.8695 15.7337 14.662 16.1333 14.662C16.4099 14.662 16.6405 14.7675 16.8826 15.0137L17.3667 14.4334C16.9671 14.1134 16.4906 13.9517 15.9681 13.9517C15.1266 13.9517 14.4849 14.4862 14.4849 15.2001C14.4849 15.8014 14.7846 16.1073 15.6568 16.3922C16.018 16.5082 16.2063 16.5891 16.2985 16.6384C16.4829 16.7474 16.5752 16.9056 16.5752 17.0885C16.5752 17.4401 16.2678 17.7039 15.8528 17.7039C15.4109 17.7039 15.0536 17.4999 14.8384 17.1236L14.239 17.6511C14.6655 18.2243 15.1804 18.4811 15.8874 18.4811C16.8518 18.4811 17.5281 17.8938 17.5281 17.0533C17.5281 16.3605 17.2168 16.0476 16.1602 15.6959V15.6924Z\" fill=\"#231F20\"/>\n<path id=\"Vector_5\" d=\"M17.8203 16.202C17.8203 17.4821 18.9192 18.4737 20.3294 18.4737C20.729 18.4737 21.0709 18.4034 21.4936 18.2205V17.2218C21.1209 17.5629 20.7943 17.7001 20.3716 17.7001C19.4379 17.7001 18.7732 17.0812 18.7732 16.1985C18.7732 15.3615 19.4572 14.7039 20.3294 14.7039C20.7712 14.7039 21.1055 14.8481 21.4936 15.1927V14.194C21.0863 14.0041 20.752 13.9268 20.3524 13.9268C18.9461 13.9268 17.8203 14.9395 17.8203 16.2055V16.202Z\" fill=\"#231F20\"/>\n<path id=\"Vector_6\" d=\"M28.8519 16.9443L27.5801 14.022H26.5696L28.5868 18.4846H29.0863L31.142 14.022H30.1353L28.8519 16.9443Z\" fill=\"#231F20\"/>\n<path id=\"Vector_7\" d=\"M31.5605 18.3755H34.1926V17.6371H32.4866V16.4625H34.1272V15.724H32.4866V14.7605H34.1926V14.022H31.5605V18.3755Z\" fill=\"#231F20\"/>\n<path id=\"Vector_8\" d=\"M37.8661 15.3055C37.8661 14.4897 37.2514 14.022 36.1832 14.022H34.8076V18.3755H35.7336V16.6278H35.8566L37.1399 18.3755H38.2811L36.7826 16.5399C37.4819 16.4098 37.8661 15.9737 37.8661 15.3055ZM36.0064 16.0229H35.7336V14.7042H36.018C36.5943 14.7042 36.9094 14.9257 36.9094 15.3513C36.9094 15.7768 36.5943 16.0229 36.0026 16.0229H36.0064Z\" fill=\"#231F20\"/>\n<path id=\"Vector_9\" d=\"M38.6035 14.2509C38.6035 14.1735 38.5459 14.1313 38.446 14.1313H38.3115V14.5147H38.4114V14.367L38.5305 14.5147H38.6535L38.5152 14.3564C38.5728 14.3423 38.6074 14.3037 38.6074 14.2509H38.6035ZM38.4268 14.3037H38.4114V14.2017H38.4306C38.4806 14.2017 38.5075 14.2193 38.5075 14.2509C38.5075 14.2826 38.4806 14.3037 38.4306 14.3037H38.4268Z\" fill=\"#231F20\"/>\n<path id=\"Vector_10\" d=\"M38.4656 13.9868C38.262 13.9868 38.1006 14.1345 38.1006 14.3209C38.1006 14.5073 38.2658 14.655 38.4656 14.655C38.6654 14.655 38.8268 14.5038 38.8268 14.3209C38.8268 14.138 38.6654 13.9868 38.4656 13.9868ZM38.4656 14.5952C38.3042 14.5952 38.1736 14.4721 38.1736 14.3209C38.1736 14.1697 38.3042 14.0466 38.4656 14.0466C38.627 14.0466 38.7538 14.1732 38.7538 14.3209C38.7538 14.4686 38.6231 14.5952 38.4656 14.5952Z\" fill=\"#231F20\"/>\n<path id=\"Vector_11\" d=\"M26.8305 16.1917C26.8305 17.4647 25.7047 18.4986 24.3099 18.4986C22.9151 18.4986 21.7893 17.4682 21.7893 16.1917C21.7893 14.9151 22.9151 13.8848 24.3099 13.8848C25.7047 13.8848 26.8305 14.9151 26.8305 16.1917Z\" fill=\"#F47922\"/>\n</g>\n<path id=\"Vector_12\" d=\"M40.8473 6H8.15271C7.51488 6 7 6.47123 7 7.05498V25.4328C7 26.0166 7.51488 26.4878 8.15271 26.4878H40.8473C41.4851 26.4878 42 26.0166 42 25.4328V7.05498C42 6.47123 41.4851 6 40.8473 6ZM40.2786 16.2439C40.2786 21.7052 35.4411 26.1361 29.4701 26.1361H8.15271C7.73005 26.1361 7.38424 25.8196 7.38424 25.4328V7.05498C7.38424 6.66816 7.73005 6.35166 8.15271 6.35166H29.4701C35.4373 6.35166 40.2786 10.7791 40.2786 16.2439Z\" fill=\"#F47922\"/>\n</g>\n</g>\n</svg>";

var DiscoverGray = "<svg width=\"48\" height=\"32\" viewBox=\"0 0 48 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"Brand=Discover, Color=Off\">\n<g id=\"Brand\">\n<g id=\"brand\">\n<path id=\"Vector\" d=\"M7.38428 7.05537V25.4332C7.38428 25.82 7.73009 26.1365 8.15275 26.1365H29.4701C35.4373 26.1365 40.2787 21.7091 40.2787 16.2443C40.2787 10.783 35.4412 6.35205 29.4701 6.35205H8.15275C7.73009 6.35205 7.38428 6.66855 7.38428 7.05537Z\" fill=\"white\"/>\n<g id=\"Group\">\n<path id=\"Vector_2\" d=\"M9.98202 14.022H8.62183V18.3755H9.97818C10.6967 18.3755 11.2193 18.2208 11.6765 17.8727C12.2183 17.4612 12.541 16.8423 12.541 16.2023C12.541 14.9187 11.4921 14.022 9.98586 14.022H9.98202ZM11.0656 17.2924C10.7735 17.5316 10.397 17.6371 9.79759 17.6371H9.54783V14.7569H9.79759C10.397 14.7569 10.762 14.8554 11.0656 15.1086C11.3883 15.3688 11.5804 15.7768 11.5804 16.1917C11.5804 16.6067 11.3883 17.0287 11.0656 17.2889V17.2924Z\" fill=\"#647180\"/>\n<path id=\"Vector_3\" d=\"M13.8894 14.022H12.9634V18.3755H13.8894V14.022Z\" fill=\"#647180\"/>\n<path id=\"Vector_4\" d=\"M16.1602 15.6924C15.603 15.5025 15.4417 15.3794 15.4417 15.1438C15.4417 14.8695 15.7337 14.662 16.1333 14.662C16.4099 14.662 16.6405 14.7675 16.8826 15.0137L17.3667 14.4334C16.9671 14.1134 16.4906 13.9517 15.9681 13.9517C15.1266 13.9517 14.4849 14.4862 14.4849 15.2001C14.4849 15.8014 14.7846 16.1073 15.6568 16.3922C16.018 16.5082 16.2063 16.5891 16.2985 16.6384C16.4829 16.7474 16.5752 16.9056 16.5752 17.0885C16.5752 17.4401 16.2678 17.7039 15.8528 17.7039C15.4109 17.7039 15.0536 17.4999 14.8384 17.1236L14.239 17.6511C14.6655 18.2243 15.1804 18.4811 15.8874 18.4811C16.8518 18.4811 17.5281 17.8938 17.5281 17.0533C17.5281 16.3605 17.2168 16.0476 16.1602 15.6959V15.6924Z\" fill=\"#647180\"/>\n<path id=\"Vector_5\" d=\"M17.8203 16.202C17.8203 17.4821 18.9192 18.4737 20.3294 18.4737C20.729 18.4737 21.0709 18.4034 21.4936 18.2205V17.2218C21.1209 17.5629 20.7943 17.7001 20.3716 17.7001C19.4379 17.7001 18.7732 17.0812 18.7732 16.1985C18.7732 15.3615 19.4572 14.7039 20.3294 14.7039C20.7712 14.7039 21.1055 14.8481 21.4936 15.1927V14.194C21.0863 14.0041 20.752 13.9268 20.3524 13.9268C18.9461 13.9268 17.8203 14.9395 17.8203 16.2055V16.202Z\" fill=\"#647180\"/>\n<path id=\"Vector_6\" d=\"M28.8519 16.9443L27.5801 14.022H26.5696L28.5868 18.4846H29.0863L31.142 14.022H30.1353L28.8519 16.9443Z\" fill=\"#647180\"/>\n<path id=\"Vector_7\" d=\"M31.5605 18.3755H34.1926V17.6371H32.4866V16.4625H34.1272V15.724H32.4866V14.7605H34.1926V14.022H31.5605V18.3755Z\" fill=\"#647180\"/>\n<path id=\"Vector_8\" d=\"M37.8661 15.3055C37.8661 14.4897 37.2514 14.022 36.1832 14.022H34.8076V18.3755H35.7336V16.6278H35.8566L37.1399 18.3755H38.2811L36.7826 16.5399C37.4819 16.4098 37.8661 15.9737 37.8661 15.3055ZM36.0064 16.0229H35.7336V14.7042H36.018C36.5943 14.7042 36.9094 14.9257 36.9094 15.3513C36.9094 15.7768 36.5943 16.0229 36.0026 16.0229H36.0064Z\" fill=\"#647180\"/>\n<path id=\"Vector_9\" d=\"M38.6035 14.2509C38.6035 14.1735 38.5459 14.1313 38.446 14.1313H38.3115V14.5147H38.4114V14.367L38.5305 14.5147H38.6535L38.5152 14.3564C38.5728 14.3423 38.6074 14.3037 38.6074 14.2509H38.6035ZM38.4268 14.3037H38.4114V14.2017H38.4306C38.4806 14.2017 38.5075 14.2193 38.5075 14.2509C38.5075 14.2826 38.4806 14.3037 38.4306 14.3037H38.4268Z\" fill=\"#647180\"/>\n<path id=\"Vector_10\" d=\"M38.4656 13.9868C38.262 13.9868 38.1006 14.1345 38.1006 14.3209C38.1006 14.5073 38.2658 14.655 38.4656 14.655C38.6654 14.655 38.8268 14.5038 38.8268 14.3209C38.8268 14.138 38.6654 13.9868 38.4656 13.9868ZM38.4656 14.5952C38.3042 14.5952 38.1736 14.4721 38.1736 14.3209C38.1736 14.1697 38.3042 14.0466 38.4656 14.0466C38.627 14.0466 38.7538 14.1732 38.7538 14.3209C38.7538 14.4686 38.6231 14.5952 38.4656 14.5952Z\" fill=\"#647180\"/>\n<path id=\"Vector_11\" d=\"M26.8305 16.1917C26.8305 17.4647 25.7047 18.4986 24.3099 18.4986C22.9151 18.4986 21.7893 17.4682 21.7893 16.1917C21.7893 14.9151 22.9151 13.8848 24.3099 13.8848C25.7047 13.8848 26.8305 14.9151 26.8305 16.1917Z\" fill=\"#B6C5D5\"/>\n</g>\n<path id=\"Vector_12\" d=\"M40.8473 6H8.15271C7.51488 6 7 6.47123 7 7.05498V25.4328C7 26.0166 7.51488 26.4878 8.15271 26.4878H40.8473C41.4851 26.4878 42 26.0166 42 25.4328V7.05498C42 6.47123 41.4851 6 40.8473 6ZM40.2786 16.2439C40.2786 21.7052 35.4411 26.1361 29.4701 26.1361H8.15271C7.73005 26.1361 7.38424 25.8196 7.38424 25.4328V7.05498C7.38424 6.66816 7.73005 6.35166 8.15271 6.35166H29.4701C35.4373 6.35166 40.2786 10.7791 40.2786 16.2439Z\" fill=\"#B6C5D5\"/>\n</g>\n</g>\n</g>\n</svg>";

var BrandAssets = {
  amex_color: AmexColor,
  bbva_color: BBVAColor,
  bimo_color: BimoColor,
  bna_color: BNAColor,
  brubank_color: BrubankColor,
  cabal_color: CabalColor,
  cabal_debito_color: CabalDebitoColor,
  cuenta_dni_color: CuentaDNIColor,
  maestro_color: MaestroColor,
  mastercard_color: MasterCardColor,
  mastercard_debito_color: MasterCardDebitoColor,
  modo_color: ModoColor,
  naranja_color: NaranjaColor,
  none_color: NoneColor,
  todopago_color: TodoPagoColor,
  unionpay_color: UnionPayColor,
  visa_color: VisaColor,
  visa_debito_color: VisaDebitoColor,
  amex_gray: AmexGray,
  bbva_gray: BBVAGray,
  bimo_gray: BimoGray,
  bna_gray: BNAGray,
  brubank_gray: BrubankGray,
  cabal_gray: CabalGray,
  cabal_debito_gray: CabalDebitoGray,
  cuenta_dni_gray: CuentaDNIGray,
  maestro_gray: MaestroGray,
  mastercard_gray: MasterCardGray,
  mastercard_debito_gray: MasterCardDebitoGray,
  modo_gray: ModoGray,
  naranja_gray: NaranjaGray,
  none_gray: NoneGray,
  todopago_gray: TodoPagoGray,
  unionpay_gray: UnionPayGray,
  visa_gray: VisaGray,
  visa_debito_gray: VisaDebitoGray,
  mercado_pago_gray: MercadoPagoGray,
  mercado_pago_color: MercadoPagoColor,
  ank_color: AnkColor,
  ank_gray: AnkGray,
  instant_payment_color: InstantPaymentColor,
  instant_payment_gray: InstantPaymentGray,
  discover_gray: DiscoverGray,
  discover_color: DiscoverColor
};

var ColorOnboardingUno = "<svg width=\"284\" height=\"212\" viewBox=\"0 0 284 212\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_201_851)\">\n<path opacity=\"0.1\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M75.1373 166.214C135.299 146.324 169.909 146.324 169.909 98.7964C169.909 51.2688 194.386 31.374 108.246 31.374C22.105 31.374 10 51.2676 10 98.7952C10 146.323 14.9761 186.104 75.1373 166.214Z\" fill=\"#479EF8\"/>\n<path opacity=\"0.1\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M144.657 59.4184C131.801 121.464 114.496 151.438 155.656 175.202C196.816 198.966 201.807 230.111 244.877 155.511C287.947 80.911 276.772 60.4809 235.612 36.7171C194.451 12.9534 157.512 -2.6276 144.657 59.4184Z\" fill=\"#479EF8\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M119 12C122.59 12 125.5 15.134 125.5 19C125.5 15.134 128.41 12 132 12C128.41 12 125.5 8.86599 125.5 5C125.5 8.86599 122.59 12 119 12ZM53 75C53 70.0294 48.9706 66 44 66C48.9706 66 53 61.9706 53 57C53 61.9706 57.0294 66 62 66C57.0294 66 53 70.0294 53 75ZM222 113C222 108.029 217.971 104 213 104C217.971 104 222 99.9706 222 95C222 99.9706 226.029 104 231 104C226.029 104 222 108.029 222 113ZM134 185C134 181.41 130.866 178.5 127 178.5C130.866 178.5 134 175.59 134 172C134 175.59 137.134 178.5 141 178.5C137.134 178.5 134 181.41 134 185ZM39 171C42.866 171 46 174.134 46 178C46 174.134 49.134 171 53 171C49.134 171 46 167.866 46 164C46 167.866 42.866 171 39 171ZM215.5 206C215.5 202.41 212.59 199.5 209 199.5C212.59 199.5 215.5 196.59 215.5 193C215.5 196.59 218.41 199.5 222 199.5C218.41 199.5 215.5 202.41 215.5 206Z\" fill=\"#0A7FE4\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96.9594 38.4998C97.0526 31.1969 99.1685 27.2648 103.307 26.7036C107.445 26.1424 125.904 26.1424 158.683 26.7036C161.34 28.6952 163.126 32.6434 164.038 38.5482C164.951 44.453 169.668 50.9046 178.19 57.9031L179.162 72.5148C177.786 77.2331 172.745 79.5923 164.038 79.5923C163.049 79.5923 164.038 81.57 164.038 84.7295C164.038 90.8763 164.038 108.188 164.038 136.666C163.24 141.006 159.894 143.176 154 143.176C148.105 143.176 131.208 142.893 103.307 142.326C99.0752 142.852 96.9594 140.243 96.9594 134.5C96.9594 128.756 97.3087 109.676 98.0075 77.2579C88.3139 79.9791 83.037 76.9339 82.1768 68.1222C82.1768 63.0107 82.7459 60.1363 83.8842 59.4992L96.9594 38.4998Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M180.345 58.346L165.46 39.804V32.7419C165.456 28.4679 161.98 25.0041 157.691 25H103.307C99.0183 25.0041 95.5423 28.4679 95.5382 32.7419V39.804C95.5382 39.804 80.4205 58.6375 80.4176 58.6411C80.1471 58.9823 80 59.4042 80 59.8387V71.4516C80.0053 76.794 84.3502 81.1237 89.7114 81.129H93.5959C94.2483 81.1288 94.8987 81.0639 95.5382 80.9355V137.258C95.5423 141.532 99.0183 144.996 103.307 145H157.691C161.98 144.996 165.456 141.532 165.46 137.258V80.9355C166.1 81.0639 166.75 81.1288 167.402 81.129H171.287C176.65 81.129 180.998 76.7962 180.998 71.4516V59.7056C181.023 59.1719 180.778 58.6612 180.345 58.346ZM175.014 57.9032H160.833L153.063 42.4194H162.583L175.014 57.9032ZM142.153 61.7742H157.691V71.4516C157.687 74.6568 155.081 77.2537 151.864 77.2581H147.98C144.763 77.2537 142.157 74.6568 142.153 71.4516V61.7742ZM141.803 57.9032L138.696 42.4194H148.722L156.492 57.9032H141.803ZM141.531 28.871L140.439 32.7419H120.363L119.392 28.871H141.531ZM99.4227 32.7419C99.4256 30.6052 101.163 28.8739 103.307 28.871H115.386L116.961 35.1468C117.178 36.0083 117.954 36.6127 118.845 36.6129H141.91C142.78 36.6129 143.543 36.0366 143.779 35.2024L145.566 28.871H157.691C159.835 28.8739 161.573 30.6052 161.575 32.7419V38.5484H99.4227V32.7419ZM138.268 61.7742V71.4516C138.264 74.6568 135.658 77.2537 132.441 77.2581H128.557C125.34 77.2537 122.734 74.6568 122.73 71.4516V61.7742H138.268ZM123.157 57.9032L126.265 42.4194H134.733L137.841 57.9032H123.157ZM104.507 57.9032L112.276 42.4194H122.303L119.195 57.9032H104.507ZM118.845 61.7742V71.4516C118.841 74.6568 116.235 77.2537 113.019 77.2581H109.134C105.918 77.2537 103.312 74.6568 103.307 71.4516V61.7742H118.845ZM98.4152 42.4194H107.935L100.166 57.9032H85.9846L98.4152 42.4194ZM93.5959 77.2581H89.7114C86.495 77.2537 83.8889 74.6568 83.8845 71.4516V61.7742H99.4227V71.4516C99.4184 74.6568 96.8123 77.2537 93.5959 77.2581ZM161.575 137.258C161.573 139.395 159.835 141.126 157.691 141.129H103.307C101.163 141.126 99.4256 139.395 99.4227 137.258V79.1887C100.158 78.6366 100.812 77.9844 101.365 77.2508C103.196 79.6919 106.076 81.1293 109.134 81.129H113.019C116.077 81.1293 118.957 79.6919 120.788 77.2508C122.619 79.6919 125.498 81.1293 128.557 81.129H132.441C135.5 81.1293 138.379 79.6919 140.21 77.2508C142.042 79.6919 144.921 81.1293 147.98 81.129H151.864C154.921 81.1276 157.798 79.6927 159.631 77.2556C160.185 77.9892 160.839 78.6415 161.575 79.1936V137.258ZM177.114 71.4516C177.109 74.6568 174.503 77.2537 171.287 77.2581H167.402C164.186 77.2537 161.58 74.6568 161.575 71.4516V61.7742H177.114V71.4516Z\" fill=\"#023F80\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M146.859 114.666C148.069 114.666 148.496 114.265 148.496 113.104V91.9154C148.496 90.7391 148.069 90.3357 146.859 90.3357H143.444C142.247 90.3357 141.821 90.7391 141.821 91.9154V113.104C141.821 114.265 142.247 114.666 143.444 114.666H146.859ZM139.317 113.553V91.4656C139.317 89.1763 140.577 88 143.018 88H147.267C149.723 88 151 89.1763 151 91.4656V113.553C151 115.843 149.723 117 147.267 117H143.018C140.577 117 139.317 115.843 139.317 113.553ZM132.706 114.666C133.919 114.666 134.329 114.265 134.329 113.104V96.4305C134.329 95.2563 133.919 94.8509 132.706 94.8509H129.291C128.081 94.8509 127.654 95.2563 127.654 96.4305V113.104C127.654 114.265 128.081 114.666 129.291 114.666H132.706ZM125.15 113.553V95.9807C125.15 93.6915 126.409 92.5173 128.866 92.5173H133.117C135.573 92.5173 136.833 93.6915 136.833 95.9807V113.553C136.833 115.843 135.573 117 133.117 117H128.866C126.409 117 125.15 115.843 125.15 113.553ZM118.539 114.666C119.753 114.666 120.177 114.265 120.177 113.104V100.931C120.177 99.7546 119.753 99.3533 118.539 99.3533H115.124C113.929 99.3533 113.502 99.7546 113.502 100.931V113.104C113.502 114.265 113.929 114.666 115.124 114.666H118.539ZM111 113.553V100.481C111 98.1918 112.259 97.0176 114.716 97.0176H118.952C121.406 97.0176 122.681 98.1918 122.681 100.481V113.553C122.681 115.843 121.406 117 118.952 117H114.716C112.259 117 111 115.843 111 113.553Z\" fill=\"#023F80\"/>\n<path d=\"M130.5 139C132.985 139 135 136.985 135 134.5C135 132.015 132.985 130 130.5 130C128.015 130 126 132.015 126 134.5C126 136.985 128.015 139 130.5 139Z\" fill=\"#023F80\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_201_851\">\n<rect width=\"284\" height=\"212\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var ColorOnboardingDos = "<svg width=\"284\" height=\"212\" viewBox=\"0 0 284 212\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path opacity=\"0.1\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M75.1373 151.84C135.299 131.95 169.909 131.95 169.909 84.4224C169.909 36.8948 194.386 17 108.246 17C22.105 17 10 36.8936 10 84.4212C10 131.949 14.9761 171.73 75.1373 151.84Z\" fill=\"#479EF8\"/>\n<path opacity=\"0.1\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M124.657 59.4184C111.801 121.464 94.4959 151.438 135.656 175.202C176.816 198.966 181.807 230.111 224.877 155.511C267.947 80.911 256.772 60.4809 215.612 36.7171C174.451 12.9534 137.512 -2.6276 124.657 59.4184Z\" fill=\"#479EF8\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M72 42C76.9706 42 81 46.0294 81 51C81 46.0294 85.0294 42 90 42C85.0294 42 81 37.9706 81 33C81 37.9706 76.9706 42 72 42Z\" fill=\"#0A7FE4\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M186 54C190.971 54 195 58.0294 195 63C195 58.0294 199.029 54 204 54C199.029 54 195 49.9706 195 45C195 49.9706 190.971 54 186 54Z\" fill=\"#0A7FE4\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22 33C25.5899 33 28.5 36.134 28.5 40C28.5 36.134 31.4101 33 35 33C31.4101 33 28.5 29.866 28.5 26C28.5 29.866 25.5899 33 22 33Z\" fill=\"#0A7FE4\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M124 14.5C127.866 14.5 131 17.4101 131 21C131 17.4101 134.134 14.5 138 14.5C134.134 14.5 131 11.5899 131 8C131 11.5899 127.866 14.5 124 14.5Z\" fill=\"#0A7FE4\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 180C18.866 180 22 183.134 22 187C22 183.134 25.134 180 29 180C25.134 180 22 176.866 22 173C22 176.866 18.866 180 15 180Z\" fill=\"#0A7FE4\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M214 127.5C217.59 127.5 220.5 130.41 220.5 134C220.5 130.41 223.41 127.5 227 127.5C223.41 127.5 220.5 124.59 220.5 121C220.5 124.59 217.59 127.5 214 127.5Z\" fill=\"#0A7FE4\"/>\n<path d=\"M62.0331 139.758L51.9962 82.8358L147.916 65.9224L157.953 122.844L62.0331 139.758Z\" fill=\"white\" stroke=\"#023F80\"/>\n<path d=\"M107.723 131.843L64.6374 139.44C62.9404 139.74 61.3222 138.606 61.023 136.91L51.5418 83.139C51.2426 81.4421 52.3757 79.8238 54.0726 79.5246L97.7866 71.8167\" stroke=\"#023F80\" stroke-width=\"4.68\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M53.4379 93.8931L51.5417 83.139C51.2425 81.442 52.3756 79.8238 54.0725 79.5246L64.8266 77.6284C66.1491 85.1283 61.2543 92.2864 53.8446 93.8153L53.4379 93.8931Z\" stroke=\"#023F80\" stroke-width=\"3.9\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M75.3911 137.544L64.637 139.44C62.9401 139.739 61.3219 138.606 61.0227 136.909L59.1264 126.155C66.6263 124.833 73.7845 129.728 75.3134 137.137L75.3911 137.544Z\" stroke=\"#023F80\" stroke-width=\"3.9\"/>\n<path d=\"M102.326 71.0162L145.411 63.419C147.108 63.1198 148.727 64.2529 149.026 65.9499L158.507 119.72C158.806 121.417 157.673 123.036 155.976 123.335L112.262 131.043L106.117 132.126\" stroke=\"#023F80\" stroke-width=\"4.68\" stroke-linecap=\"round\" stroke-dasharray=\"4.68 9.36\"/>\n<path d=\"M108.858 108.773L108.474 108.921L108.545 109.327L108.784 110.681C108.866 111.143 108.786 111.495 108.584 111.781C108.38 112.071 108.079 112.264 107.633 112.343C107.186 112.421 106.838 112.343 106.547 112.14C106.259 111.94 106.064 111.637 105.982 111.175L105.763 109.931L105.687 109.498L105.247 109.519C103.263 109.611 101.522 109.322 100.014 108.669L100.014 108.669L100.002 108.664C99.6989 108.542 99.5111 108.398 99.3991 108.253C99.2852 108.105 99.1792 107.863 99.1126 107.485C99.0329 107.033 99.094 106.64 99.282 106.285C99.469 105.932 99.6905 105.782 99.9422 105.738C100.102 105.71 100.269 105.708 100.447 105.735C100.627 105.763 100.894 105.838 101.26 105.976L101.26 105.976L101.272 105.98C102.172 106.293 103.007 106.487 103.775 106.555C104.54 106.622 105.331 106.583 106.146 106.439C107.143 106.263 107.951 105.95 108.492 105.445C109.067 104.907 109.271 104.204 109.131 103.41C109.037 102.877 108.743 102.459 108.274 102.189C107.868 101.956 107.402 101.806 106.884 101.729L106.884 101.729L106.876 101.728L106.424 101.668L106.424 101.668L106.418 101.667C106.075 101.626 105.665 101.585 105.189 101.544L105.188 101.544L104.821 101.514L104.819 101.513C103.418 101.403 102.271 101.246 101.373 101.046C100.529 100.858 99.7546 100.468 99.0471 99.864C98.3931 99.3062 97.9384 98.4532 97.725 97.243C97.4871 95.8942 97.7397 94.6525 98.4897 93.4926C99.244 92.3262 100.364 91.4332 101.879 90.8235L102.256 90.6721L102.185 90.2728L101.942 88.8909C101.865 88.4567 101.944 88.1061 102.158 87.8019C102.374 87.4945 102.673 87.3033 103.093 87.2293C103.54 87.1506 103.888 87.2288 104.179 87.4314C104.466 87.6318 104.662 87.9352 104.743 88.3969L104.972 89.6958L105.046 90.1157L105.473 90.1089C106.932 90.0858 108.425 90.3911 109.953 91.0357C110.26 91.1748 110.455 91.3312 110.572 91.4881C110.696 91.6531 110.797 91.889 110.856 92.2205C110.935 92.6691 110.871 93.0604 110.676 93.4166C110.48 93.7756 110.252 93.9279 109.999 93.9725C109.84 94.0006 109.686 94 109.535 93.9723C109.359 93.94 109.073 93.862 108.665 93.7283L108.335 93.614L108.335 93.614L108.331 93.6125C108.176 93.5604 107.979 93.4958 107.742 93.4185C107.232 93.2527 106.7 93.1433 106.145 93.0892C105.576 93.0337 104.991 93.0604 104.391 93.1662C103.509 93.3217 102.776 93.6526 102.242 94.1948C101.69 94.7557 101.468 95.446 101.604 96.217C101.671 96.5958 101.827 96.933 102.085 97.2076C102.34 97.4799 102.67 97.6658 103.049 97.7821C103.738 97.9934 104.749 98.13 106.055 98.206L106.056 98.206C107.43 98.2831 108.556 98.4194 109.44 98.6109C110.269 98.7907 111.032 99.1807 111.731 99.7933C112.38 100.361 112.835 101.231 113.052 102.462C113.294 103.832 113.042 105.061 112.3 106.177C111.552 107.302 110.417 108.173 108.858 108.773Z\" fill=\"#023F80\" stroke=\"#023F80\"/>\n<path d=\"M192.631 113H151.631V147H192.631V113Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M155.713 148.021H187.573C192.212 148.021 194.531 145.701 194.531 141.136V112.889C194.531 108.323 192.212 105.979 187.573 105.979H155.713C151.074 105.979 148.73 108.299 148.73 112.889V141.136C148.73 145.701 151.074 148.021 155.713 148.021ZM155.444 144.847C153.174 144.847 151.929 143.626 151.929 141.282V119.92C151.929 117.576 153.174 116.355 155.444 116.355H187.793C190.063 116.355 191.357 117.576 191.357 119.92V141.282C191.357 143.626 190.063 144.847 187.793 144.847H155.444ZM167.065 124.583H168.433C169.189 124.583 169.409 124.388 169.409 123.631V122.288C169.409 121.531 169.189 121.312 168.433 121.312H167.065C166.309 121.312 166.089 121.531 166.089 122.288V123.631C166.089 124.388 166.309 124.583 167.065 124.583ZM174.829 124.583H176.196C176.953 124.583 177.173 124.388 177.173 123.631V122.288C177.173 121.531 176.953 121.312 176.196 121.312H174.829C174.072 121.312 173.853 121.531 173.853 122.288V123.631C173.853 124.388 174.072 124.583 174.829 124.583ZM182.593 124.583H183.96C184.717 124.583 184.937 124.388 184.937 123.631V122.288C184.937 121.531 184.717 121.312 183.96 121.312H182.593C181.836 121.312 181.616 121.531 181.616 122.288V123.631C181.616 124.388 181.836 124.583 182.593 124.583ZM159.326 132.225H160.669C161.426 132.225 161.646 132.029 161.646 131.272V129.93C161.646 129.173 161.426 128.978 160.669 128.978H159.326C158.545 128.978 158.325 129.173 158.325 129.93V131.272C158.325 132.029 158.545 132.225 159.326 132.225ZM167.065 132.225H168.433C169.189 132.225 169.409 132.029 169.409 131.272V129.93C169.409 129.173 169.189 128.978 168.433 128.978H167.065C166.309 128.978 166.089 129.173 166.089 129.93V131.272C166.089 132.029 166.309 132.225 167.065 132.225ZM174.829 132.225H176.196C176.953 132.225 177.173 132.029 177.173 131.272V129.93C177.173 129.173 176.953 128.978 176.196 128.978H174.829C174.072 128.978 173.853 129.173 173.853 129.93V131.272C173.853 132.029 174.072 132.225 174.829 132.225ZM182.593 132.225H183.96C184.717 132.225 184.937 132.029 184.937 131.272V129.93C184.937 129.173 184.717 128.978 183.96 128.978H182.593C181.836 128.978 181.616 129.173 181.616 129.93V131.272C181.616 132.029 181.836 132.225 182.593 132.225ZM159.326 139.866H160.669C161.426 139.866 161.646 139.671 161.646 138.914V137.571C161.646 136.814 161.426 136.619 160.669 136.619H159.326C158.545 136.619 158.325 136.814 158.325 137.571V138.914C158.325 139.671 158.545 139.866 159.326 139.866ZM167.065 139.866H168.433C169.189 139.866 169.409 139.671 169.409 138.914V137.571C169.409 136.814 169.189 136.619 168.433 136.619H167.065C166.309 136.619 166.089 136.814 166.089 137.571V138.914C166.089 139.671 166.309 139.866 167.065 139.866ZM174.829 139.866C174.072 139.866 173.853 139.671 173.853 138.914V137.571C173.853 136.814 174.072 136.619 174.829 136.619H176.196C176.953 136.619 177.173 136.814 177.173 137.571V138.914C177.173 139.671 176.953 139.866 176.196 139.866H174.829Z\" fill=\"#023F80\"/>\n</svg>";

var ColorOnboardingTres = "<svg width=\"284\" height=\"212\" viewBox=\"0 0 284 212\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_201_884)\">\n<path opacity=\"0.1\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M75.1373 166.214C135.299 146.324 169.909 146.324 169.909 98.7964C169.909 51.2688 194.386 31.374 108.246 31.374C22.105 31.374 10 51.2676 10 98.7952C10 146.323 14.9761 186.104 75.1373 166.214Z\" fill=\"#479EF8\"/>\n<path opacity=\"0.1\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M144.657 59.4184C131.801 121.464 114.496 151.438 155.656 175.202C196.816 198.966 201.807 230.111 244.877 155.511C287.947 80.911 276.772 60.4809 235.612 36.7171C194.451 12.9534 157.512 -2.62759 144.657 59.4184Z\" fill=\"#479EF8\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M122 17C125.59 17 128.5 20.134 128.5 24C128.5 20.134 131.41 17 135 17C131.41 17 128.5 13.866 128.5 10C128.5 13.866 125.59 17 122 17ZM56 75C56 70.0294 51.9706 66 47 66C51.9706 66 56 61.9706 56 57C56 61.9706 60.0294 66 65 66C60.0294 66 56 70.0294 56 75ZM225 113C225 108.029 220.971 104 216 104C220.971 104 225 99.9706 225 95C225 99.9706 229.029 104 234 104C229.029 104 225 108.029 225 113ZM157 45C157 41.4101 153.866 38.5 150 38.5C153.866 38.5 157 35.5899 157 32C157 35.5899 160.134 38.5 164 38.5C160.134 38.5 157 41.4101 157 45ZM42 171C45.866 171 49 174.134 49 178C49 174.134 52.134 171 56 171C52.134 171 49 167.866 49 164C49 167.866 45.866 171 42 171ZM218.5 206C218.5 202.41 215.59 199.5 212 199.5C215.59 199.5 218.5 196.59 218.5 193C218.5 196.59 221.41 199.5 225 199.5C221.41 199.5 218.5 202.41 218.5 206Z\" fill=\"#0A7FE4\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M111.983 154.391L129.103 142.521H173.123V86.4323L166.58 80.3525H91.5611L84.5674 86.4323V136.329L89.6069 142.521H111.983V154.391Z\" fill=\"white\"/>\n<mask id=\"mask0_201_884\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"82\" y=\"77\" width=\"94\" height=\"82\">\n<path d=\"M165.197 77.4521C170.794 77.4521 175.378 81.7951 175.766 87.2972L175.793 88.0543L175.97 134.788C175.97 140.389 171.63 144.975 166.131 145.363L165.375 145.39H128.911L116.924 157.014C114.017 159.833 109.239 157.984 108.829 154.113L108.801 153.573V145.39H92.8022C87.2048 145.39 82.6213 141.047 82.2333 135.545L82.2067 134.788L82.0293 88.0543C82.0293 82.4535 86.3696 77.867 91.8681 77.4788L92.6248 77.4521H165.197ZM165.197 82.6645H92.6248C89.8483 82.6645 87.5624 84.7666 87.2699 87.451L87.2383 88.0345L87.4157 134.788C87.4157 137.566 89.5165 139.853 92.2153 140.146L92.8022 140.178H108.801C111.486 140.178 113.696 142.211 113.979 144.822L114.01 145.39V152.582L125.286 141.647C126.096 140.862 127.133 140.365 128.24 140.221L128.911 140.178H165.375C168.151 140.178 170.437 138.076 170.729 135.391L170.761 134.808L170.584 88.0543C170.584 85.0776 168.172 82.6645 165.197 82.6645ZM124.326 98.4242C125.909 98.4242 127.192 99.7083 127.192 101.292C127.192 102.59 126.327 103.7 125.089 104.051L124.608 104.146L124.326 104.16H117.959C114.073 104.16 110.922 107.313 110.922 111.201C110.922 114.708 113.492 117.635 116.853 118.158L117.585 118.233L117.959 118.242H124.326C125.909 118.242 127.192 119.526 127.192 121.11C127.192 122.408 126.327 123.517 125.089 123.869L124.608 123.963L124.326 123.978H117.959C110.907 123.978 105.19 118.258 105.19 111.201C105.19 104.636 110.148 99.2006 116.57 98.5L117.497 98.4325L124.326 98.4242ZM139.006 98.4242C146.058 98.4242 151.775 104.145 151.775 111.201C151.775 117.767 146.817 123.202 140.395 123.902L139.468 123.97L133.725 123.978C132.142 123.978 130.859 122.694 130.859 121.11C130.859 119.813 131.724 118.703 132.962 118.352L133.443 118.257L133.725 118.242H139.006C142.892 118.242 146.042 115.09 146.042 111.201C146.042 107.694 143.473 104.768 140.111 104.245L139.38 104.17L139.006 104.16H133.725C132.142 104.16 130.859 102.876 130.859 101.292C130.859 99.9948 131.724 98.8851 132.962 98.534L133.443 98.439L133.725 98.4242H139.006ZM134.279 108.558C135.738 108.558 136.921 109.741 136.921 111.201C136.921 112.499 135.986 113.578 134.754 113.802L134.279 113.845H123.927C122.468 113.845 121.285 112.661 121.285 111.201C121.285 109.904 122.22 108.824 123.452 108.6L123.927 108.558H134.279Z\" fill=\"white\"/>\n</mask>\n<g mask=\"url(#mask0_201_884)\">\n<path d=\"M165.197 77.4521C170.794 77.4521 175.378 81.7951 175.766 87.2972L175.793 88.0543L175.97 134.788C175.97 140.389 171.63 144.975 166.131 145.363L165.375 145.39H128.911L116.924 157.014C114.017 159.833 109.239 157.984 108.829 154.113L108.801 153.573V145.39H92.8022C87.2048 145.39 82.6213 141.047 82.2333 135.545L82.2067 134.788L82.0293 88.0543C82.0293 82.4535 86.3696 77.867 91.8681 77.4788L92.6248 77.4521H165.197ZM165.197 82.6645H92.6248C89.8483 82.6645 87.5624 84.7666 87.2699 87.451L87.2383 88.0345L87.4157 134.788C87.4157 137.566 89.5165 139.853 92.2153 140.146L92.8022 140.178H108.801C111.486 140.178 113.696 142.211 113.979 144.822L114.01 145.39V152.582L125.286 141.647C126.096 140.862 127.133 140.365 128.24 140.221L128.911 140.178H165.375C168.151 140.178 170.437 138.076 170.729 135.391L170.761 134.808L170.584 88.0543C170.584 85.0776 168.172 82.6645 165.197 82.6645ZM124.326 98.4242C125.909 98.4242 127.192 99.7083 127.192 101.292C127.192 102.59 126.327 103.7 125.089 104.051L124.608 104.146L124.326 104.16H117.959C114.073 104.16 110.922 107.313 110.922 111.201C110.922 114.708 113.492 117.635 116.853 118.158L117.585 118.233L117.959 118.242H124.326C125.909 118.242 127.192 119.526 127.192 121.11C127.192 122.408 126.327 123.517 125.089 123.869L124.608 123.963L124.326 123.978H117.959C110.907 123.978 105.19 118.258 105.19 111.201C105.19 104.636 110.148 99.2006 116.57 98.5L117.497 98.4325L124.326 98.4242ZM139.006 98.4242C146.058 98.4242 151.775 104.145 151.775 111.201C151.775 117.767 146.817 123.202 140.395 123.902L139.468 123.97L133.725 123.978C132.142 123.978 130.859 122.694 130.859 121.11C130.859 119.813 131.724 118.703 132.962 118.352L133.443 118.257L133.725 118.242H139.006C142.892 118.242 146.042 115.09 146.042 111.201C146.042 107.694 143.473 104.768 140.111 104.245L139.38 104.17L139.006 104.16H133.725C132.142 104.16 130.859 102.876 130.859 101.292C130.859 99.9948 131.724 98.8851 132.962 98.534L133.443 98.439L133.725 98.4242H139.006ZM134.279 108.558C135.738 108.558 136.921 109.741 136.921 111.201C136.921 112.499 135.986 113.578 134.754 113.802L134.279 113.845H123.927C122.468 113.845 121.285 112.661 121.285 111.201C121.285 109.904 122.22 108.824 123.452 108.6L123.927 108.558H134.279Z\" fill=\"#023F80\"/>\n</g>\n<mask id=\"mask1_201_884\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"143\" y=\"118\" width=\"59\" height=\"59\">\n<path d=\"M172.5 118C188.792 118 202 131.208 202 147.5C202 163.792 188.792 177 172.5 177C156.208 177 143 163.792 143 147.5C143 131.208 156.208 118 172.5 118Z\" fill=\"white\"/>\n</mask>\n<g mask=\"url(#mask1_201_884)\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M136.979 111.979H208.02V183.02H136.979V111.979Z\" fill=\"white\"/>\n</g>\n<mask id=\"mask2_201_884\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"148\" y=\"123\" width=\"50\" height=\"51\">\n<path d=\"M173.001 123C186.807 123 198 134.193 198 148.001C198 161.807 186.807 173.001 173.001 173.001C159.193 173.001 148 161.807 148 148.001C148 134.193 159.193 123 173.001 123Z\" fill=\"white\"/>\n</mask>\n<g mask=\"url(#mask2_201_884)\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M142 117H203.905V178.906H142V117Z\" fill=\"#023F80\"/>\n<path d=\"M186.046 135.941C182.85 132.756 178.599 131.002 174.071 131C164.74 131 157.146 138.558 157.142 147.847C157.141 150.816 157.92 153.715 159.402 156.27L157 165L165.974 162.657C168.447 164 171.231 164.707 174.064 164.708H174.071C183.401 164.708 190.996 157.15 191 147.86C191.002 143.358 189.243 139.125 186.046 135.941ZM174.071 161.863H174.065C171.541 161.861 169.064 161.186 166.904 159.911L166.39 159.607L161.065 160.997L162.486 155.83L162.151 155.3C160.743 153.071 159.999 150.494 160 147.848C160.003 140.127 166.316 133.846 174.077 133.846C177.835 133.847 181.368 135.305 184.024 137.952C186.681 140.599 188.143 144.117 188.142 147.859C188.139 155.58 181.827 161.863 174.071 161.863ZM181.789 151.375C181.366 151.164 179.287 150.146 178.899 150.005C178.511 149.865 178.229 149.795 177.947 150.216C177.665 150.637 176.855 151.586 176.608 151.866C176.361 152.147 176.114 152.183 175.691 151.972C175.268 151.761 173.905 151.316 172.29 149.882C171.032 148.766 170.183 147.387 169.936 146.966C169.69 146.544 169.934 146.339 170.122 146.107C170.58 145.541 171.038 144.948 171.179 144.667C171.321 144.386 171.25 144.14 171.144 143.93C171.038 143.719 170.192 141.647 169.84 140.804C169.496 139.983 169.148 140.094 168.888 140.081C168.642 140.069 168.36 140.066 168.077 140.066C167.796 140.066 167.337 140.172 166.949 140.593C166.562 141.015 165.469 142.033 165.469 144.105C165.469 146.177 166.985 148.179 167.196 148.46C167.408 148.741 170.179 152.993 174.422 154.816C175.431 155.25 176.219 155.509 176.834 155.703C177.847 156.024 178.769 155.978 179.498 155.87C180.311 155.749 182 154.851 182.353 153.868C182.706 152.885 182.706 152.042 182.6 151.866C182.494 151.691 182.212 151.586 181.789 151.375Z\" fill=\"white\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M110.509 61.537C110.811 62.2156 110.83 62.8997 110.567 63.5892C110.303 64.2787 109.802 64.8784 109.063 65.3882L109.337 66.004C109.453 66.2637 109.462 66.5104 109.366 66.744C109.269 66.9777 109.088 67.1537 108.822 67.2721C108.556 67.3905 108.304 67.4074 108.066 67.3226C107.828 67.2379 107.651 67.0657 107.536 66.806L107.284 66.2405C106.279 66.5471 105.343 66.6376 104.475 66.512C104.28 66.4886 104.124 66.4326 104.007 66.3439C103.891 66.2553 103.79 66.1146 103.704 65.9219C103.592 65.6706 103.57 65.4193 103.638 65.1682C103.706 64.917 103.843 64.7456 104.049 64.6539C104.152 64.6081 104.262 64.579 104.38 64.5667C104.498 64.5544 104.659 64.558 104.863 64.5776C105.33 64.6107 105.745 64.5965 106.108 64.5352C106.472 64.4738 106.838 64.3611 107.207 64.1968C107.661 63.9944 107.974 63.7674 108.144 63.5157C108.315 63.2641 108.335 62.9917 108.204 62.6984C108.126 62.5225 107.991 62.4095 107.799 62.3594C107.607 62.3093 107.391 62.2975 107.151 62.324L106.92 62.3532C106.749 62.3769 106.544 62.4092 106.305 62.4501L106.119 62.4823C105.405 62.6096 104.806 62.6831 104.321 62.7031C103.837 62.723 103.367 62.626 102.912 62.412C102.457 62.1979 102.099 61.7977 101.838 61.2112C101.539 60.541 101.52 59.8517 101.781 59.1436C102.041 58.4354 102.53 57.826 103.249 57.3155L102.969 56.6871C102.857 56.4358 102.85 56.1902 102.949 55.9504C103.048 55.7107 103.226 55.5335 103.483 55.4189C103.749 55.3006 104.001 55.2837 104.239 55.3684C104.478 55.4531 104.654 55.6254 104.77 55.8851L105.033 56.4757C105.794 56.2677 106.606 56.2222 107.47 56.3394C107.669 56.3712 107.828 56.4335 107.946 56.5264C108.065 56.6192 108.163 56.7536 108.242 56.9296C108.353 57.1809 108.373 57.4331 108.301 57.6862C108.229 57.9392 108.089 58.1116 107.884 58.2033C107.781 58.2491 107.675 58.2763 107.565 58.2848C107.456 58.2933 107.291 58.2915 107.07 58.2796L106.891 58.267C106.809 58.2621 106.705 58.2563 106.578 58.2498C106.326 58.2367 106.068 58.2513 105.804 58.2935C105.54 58.3357 105.275 58.416 105.009 58.5343C104.623 58.7062 104.346 58.9273 104.179 59.1976C104.012 59.4679 103.989 59.7413 104.112 60.0178C104.232 60.2859 104.459 60.4259 104.793 60.4377C105.127 60.4495 105.62 60.3907 106.271 60.2613C106.97 60.1211 107.558 60.0399 108.036 60.0176C108.514 59.9954 108.98 60.0944 109.433 60.3145C109.885 60.5346 110.244 60.9421 110.509 61.537ZM84.8331 163.408C85.3903 164.203 85.5982 165.068 85.4567 166.002C85.3151 166.935 84.8544 167.807 84.0745 168.616L84.5801 169.339C84.7933 169.643 84.8716 169.954 84.8148 170.272C84.758 170.59 84.5806 170.853 84.2825 171.062C83.9845 171.271 83.6764 171.348 83.3582 171.292C83.04 171.237 82.7743 171.057 82.561 170.752L82.0967 170.089C80.9332 170.699 79.7963 171.019 78.6859 171.05C78.4372 171.063 78.2286 171.026 78.0602 170.939C77.8918 170.852 77.7285 170.695 77.5703 170.47C77.3639 170.175 77.2692 169.86 77.2861 169.527C77.303 169.193 77.4268 168.945 77.6576 168.783C77.7729 168.702 77.9021 168.641 78.045 168.6C78.1879 168.558 78.3885 168.528 78.6468 168.508C79.235 168.447 79.7461 168.338 80.1802 168.181C80.6144 168.023 81.0381 167.8 81.4516 167.51C81.9611 167.153 82.2879 166.797 82.4319 166.439C82.576 166.082 82.5276 165.732 82.2868 165.388C82.1424 165.182 81.9444 165.068 81.6929 165.046C81.4414 165.025 81.1703 165.057 80.8798 165.144L80.6008 165.231C80.395 165.299 80.1493 165.385 79.8638 165.489L79.6422 165.571C78.7904 165.889 78.0667 166.114 77.4711 166.246C76.8755 166.377 76.2667 166.357 75.6447 166.185C75.0227 166.013 74.471 165.583 73.9894 164.895C73.4391 164.109 73.2303 163.238 73.3628 162.281C73.4954 161.325 73.9386 160.443 74.6924 159.637L74.1765 158.901C73.9701 158.606 73.896 158.295 73.9542 157.969C74.0123 157.643 74.1856 157.379 74.474 157.177C74.7721 156.968 75.0802 156.892 75.3984 156.947C75.7166 157.002 75.9823 157.182 76.1955 157.487L76.6805 158.179C77.5679 157.748 78.5634 157.513 79.6668 157.472C79.9225 157.469 80.1362 157.513 80.308 157.605C80.4799 157.697 80.638 157.846 80.7825 158.052C80.9889 158.347 81.0812 158.663 81.0595 159C81.0377 159.338 80.9115 159.587 80.6807 159.749C80.5654 159.829 80.4411 159.887 80.3078 159.922C80.1745 159.957 79.9691 159.991 79.6915 160.024L79.4661 160.047C79.3632 160.059 79.2326 160.075 79.0742 160.094C78.7575 160.133 78.4411 160.208 78.1251 160.319C77.8091 160.431 77.5021 160.591 77.204 160.8C76.7714 161.103 76.4875 161.444 76.3525 161.824C76.2174 162.204 76.2634 162.556 76.4904 162.88C76.7105 163.195 77.0294 163.323 77.4471 163.265C77.8649 163.206 78.4605 163.024 79.2339 162.716C80.0623 162.385 80.7702 162.153 81.3576 162.02C81.945 161.887 82.549 161.91 83.1696 162.091C83.7902 162.271 84.3447 162.71 84.8331 163.408ZM197.2 80.629C198.149 80.0505 198.771 79.2093 199.066 78.1054C199.326 77.1378 199.302 76.3061 198.995 75.6104C198.688 74.9147 198.253 74.3525 197.689 73.9238C197.125 73.4951 196.38 73.0327 195.455 72.5365C194.593 72.0719 193.978 71.6734 193.61 71.3409C193.241 71.0085 193.116 70.6242 193.233 70.1881C193.353 69.7384 193.636 69.4307 194.08 69.265C194.525 69.0993 195.047 69.0969 195.648 69.2577C196.061 69.3685 196.437 69.5241 196.777 69.7246C197.116 69.9251 197.423 70.1534 197.698 70.4096C197.835 70.5376 197.948 70.6436 198.036 70.7275L198.228 70.913C198.467 71.138 198.653 71.2974 198.786 71.3912C198.918 71.4851 199.064 71.5534 199.224 71.5963C199.544 71.6821 199.864 71.6072 200.185 71.3717C200.505 71.1362 200.72 70.814 200.83 70.4052C200.906 70.119 200.921 69.8637 200.874 69.6392C200.827 69.4148 200.705 69.1887 200.509 68.9608C199.638 67.997 198.673 67.2783 197.613 66.8045L197.87 65.8436C197.984 65.4212 197.945 65.0456 197.754 64.717C197.563 64.3883 197.261 64.1686 196.848 64.0578C196.448 63.9506 196.079 63.9941 195.741 64.1884C195.403 64.3827 195.179 64.6843 195.069 65.0931L194.796 66.1153C193.499 66.0454 192.37 66.3125 191.407 66.9164C190.445 67.5204 189.818 68.3675 189.526 69.4578C189.27 70.4118 189.3 71.2341 189.615 71.9248C189.93 72.6155 190.372 73.1794 190.941 73.6167C191.51 74.0541 192.26 74.5362 193.191 75.0632L193.433 75.2011C193.742 75.3795 194.006 75.5359 194.222 75.6703L194.512 75.8553C194.81 76.0519 195.044 76.2717 195.215 76.5146C195.386 76.7576 195.433 77.0222 195.356 77.3084C195.228 77.7854 194.949 78.094 194.518 78.2342C194.088 78.3744 193.519 78.3498 192.812 78.1604C192.238 78.0067 191.716 77.7939 191.246 77.5218C190.776 77.2497 190.291 76.8715 189.792 76.3871C189.578 76.1693 189.399 76.0117 189.254 75.9143C189.108 75.8169 188.955 75.7467 188.795 75.7039C188.475 75.6181 188.158 75.6938 187.845 75.9311C187.531 76.1684 187.319 76.4915 187.21 76.9003C187.126 77.2138 187.108 77.4793 187.157 77.6969C187.206 77.9145 187.33 78.1305 187.53 78.3447C188.398 79.3221 189.546 80.1045 190.976 80.692L190.729 81.612C190.616 82.0345 190.655 82.41 190.845 82.7386C191.036 83.0673 191.338 83.287 191.752 83.3978C192.165 83.5086 192.536 83.4693 192.866 83.2801C193.195 83.0908 193.417 82.785 193.53 82.3625L193.798 81.3608C195.118 81.4514 196.252 81.2075 197.2 80.629Z\" fill=\"#0A7FE4\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_201_884\">\n<rect width=\"284\" height=\"212\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var ColorOnboardingCuatro = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_570_1646)\">\n<path opacity=\"0.1\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M64.7413 77.3727C92.0256 68.3523 107.722 68.3523 107.722 46.7976C107.722 25.2429 118.823 16.2202 79.7565 16.2202C40.6901 16.2202 35.2002 25.2424 35.2002 46.7971C35.2002 68.3518 37.457 86.3932 64.7413 77.3727Z\" fill=\"#479EF8\"/>\n<path opacity=\"0.1\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96.2698 28.9387C90.4396 57.0778 82.5913 70.6715 101.258 81.4488C119.925 92.2262 122.189 106.351 141.722 72.5185C161.255 38.686 156.187 29.4206 137.52 18.6432C118.853 7.86587 102.1 0.799592 96.2698 28.9387Z\" fill=\"#479EF8\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M84.8031 17.8652C84.8031 16.2317 83.5735 14.9075 82.0566 14.9075C83.5735 14.9075 84.8031 13.5832 84.8031 11.9497C84.8031 13.5832 86.0327 14.9075 87.5496 14.9075C86.0327 14.9075 84.8031 16.2317 84.8031 17.8652ZM48.2534 38.5692C50.3536 38.5692 52.0562 40.2718 52.0562 42.372C52.0562 40.2718 53.7588 38.5692 55.859 38.5692C53.7588 38.5692 52.0562 36.8666 52.0562 34.7664C52.0562 36.8666 50.3536 38.5692 48.2534 38.5692ZM128.958 44.4853C131.058 44.4853 132.761 46.1878 132.761 48.2881C132.761 46.1878 134.463 44.4853 136.563 44.4853C134.463 44.4853 132.761 42.7827 132.761 40.6824C132.761 42.7827 131.058 44.4853 128.958 44.4853ZM143.747 69.2034C145.38 69.2034 146.704 70.433 146.704 71.9499C146.704 70.433 148.029 69.2034 149.662 69.2034C148.029 69.2034 146.704 67.9737 146.704 66.4569C146.704 67.9737 145.38 69.2034 143.747 69.2034ZM38.9577 75.3302C38.9577 73.6967 37.6335 72.3724 36 72.3724C37.6335 72.3724 38.9577 71.0482 38.9577 69.4147C38.9577 71.0482 40.282 72.3724 41.9155 72.3724C40.282 72.3724 38.9577 73.6967 38.9577 75.3302ZM115.014 87.795C116.531 87.795 117.761 89.0247 117.761 90.5415C117.761 89.0247 118.991 87.795 120.507 87.795C118.991 87.795 117.761 86.5654 117.761 85.0486C117.761 86.5654 116.531 87.795 115.014 87.795ZM80.1553 87.5837C80.1553 86.0669 78.9257 84.8373 77.4088 84.8373C78.9257 84.8373 80.1553 83.6076 80.1553 82.0908C80.1553 83.6076 81.385 84.8373 82.9018 84.8373C81.385 84.8373 80.1553 86.0669 80.1553 87.5837Z\" fill=\"#0A7FE4\"/>\n<path d=\"M83.6232 44.2302L76.6842 37.2912C76.5083 37.1113 76.2692 37.007 76.0176 37.0005C75.8854 36.9963 75.7536 37.0187 75.6302 37.0665C75.5068 37.1143 75.3943 37.1864 75.2994 37.2785C75.2044 37.3707 75.129 37.481 75.0775 37.6029C75.0261 37.7248 74.9997 37.8558 75 37.9881V51.8675C74.9997 51.9998 75.0261 52.1308 75.0775 52.2527C75.129 52.3747 75.2044 52.485 75.2994 52.5771C75.3943 52.6693 75.5068 52.7414 75.6302 52.7891C75.7536 52.8369 75.8854 52.8593 76.0176 52.8551C76.2692 52.8486 76.5083 52.7443 76.6842 52.5644L83.6232 45.6254C83.8082 45.4404 83.9121 45.1895 83.9121 44.9278C83.9121 44.6662 83.8082 44.4152 83.6232 44.2302ZM82.9676 45.2283L76.4691 51.7268C76.4097 51.7863 76.334 51.8269 76.2516 51.8434C76.1692 51.8598 76.0837 51.8514 76.006 51.8193C75.9284 51.7871 75.862 51.7326 75.8153 51.6627C75.7687 51.5928 75.7438 51.5106 75.7439 51.4265V38.4291C75.7438 38.3451 75.7687 38.2629 75.8153 38.1929C75.862 38.123 75.9284 38.0685 76.006 38.0364C76.0837 38.0042 76.1692 37.9958 76.2516 38.0123C76.334 38.0287 76.4097 38.0693 76.4691 38.1288L82.9676 44.6273C83.0071 44.6668 83.0385 44.7136 83.0598 44.7652C83.0812 44.8167 83.0922 44.872 83.0922 44.9278C83.0922 44.9836 83.0812 45.0389 83.0598 45.0904C83.0385 45.142 83.0071 45.1888 82.9676 45.2283Z\" fill=\"#023F80\"/>\n<path d=\"M106.998 44.9393C106.998 44.7442 106.94 44.5535 106.832 44.3913C106.724 44.2291 106.57 44.1027 106.389 44.0281C106.209 43.9534 106.011 43.9339 105.819 43.9719C105.628 44.01 105.452 44.1039 105.314 44.2418L98.9055 50.6532L91.5117 43.2608C91.3268 43.0759 91.0761 42.9721 90.8148 42.9721C90.5534 42.9721 90.3027 43.0759 90.1179 43.2608L75.2888 58.0816C75.1972 58.1732 75.1246 58.2819 75.0751 58.4015C75.0255 58.5211 75 58.6493 75 58.7788C75 58.9083 75.0255 59.0365 75.0751 59.1561C75.1246 59.2757 75.1972 59.3844 75.2888 59.476L79.1455 63.333C79.3304 63.5178 79.5811 63.6216 79.8426 63.6216C80.104 63.6216 80.3547 63.5178 80.5396 63.333L90.1179 53.7547C90.2094 53.6632 90.3181 53.5905 90.4377 53.541C90.5573 53.4914 90.6854 53.4659 90.8149 53.4659C90.9444 53.4659 91.0726 53.4914 91.1922 53.541C91.3118 53.5905 91.4204 53.6632 91.5119 53.7547L105.332 67.575C105.469 67.7115 105.643 67.8045 105.833 67.8422C106.022 67.8798 106.218 67.8604 106.397 67.7864C106.575 67.7125 106.728 67.5872 106.835 67.4265C106.943 67.2658 107 67.077 107 66.8837L106.998 44.9393ZM105.529 45.0786C105.589 45.0191 105.665 44.9785 105.747 44.962C105.829 44.9456 105.915 44.954 105.993 44.9861C106.07 45.0183 106.137 45.0728 106.183 45.1427C106.23 45.2126 106.255 45.2948 106.255 45.3789V58.0035L99.4301 51.1783L105.529 45.0786ZM92.0376 53.2291C91.8771 53.0684 91.6864 52.941 91.4766 52.8541C91.2668 52.7671 91.0419 52.7224 90.8148 52.7224C90.5876 52.7224 90.3628 52.7671 90.153 52.8541C89.9431 52.941 89.7525 53.0684 89.5919 53.2291L80.143 62.678C80.1036 62.7175 80.0568 62.7488 80.0052 62.7702C79.9537 62.7916 79.8984 62.8026 79.8426 62.8026C79.7868 62.8026 79.7315 62.7916 79.6799 62.7702C79.6284 62.7488 79.5815 62.7175 79.5421 62.678L75.9438 59.0794C75.9043 59.04 75.873 58.9931 75.8516 58.9416C75.8302 58.89 75.8192 58.8348 75.8192 58.7789C75.8192 58.7231 75.8302 58.6679 75.8516 58.6163C75.873 58.5647 75.9043 58.5179 75.9438 58.4785L90.5144 43.9158C90.5539 43.8763 90.6007 43.845 90.6522 43.8236C90.7038 43.8023 90.759 43.7913 90.8148 43.7913C90.8705 43.7913 90.9258 43.8023 90.9773 43.8236C91.0288 43.845 91.0757 43.8763 91.1151 43.9158L98.3788 51.18L94.1855 55.3764L92.0376 53.2291ZM105.531 66.7221L94.7103 55.9018L98.9036 51.7042L106.254 59.0553L106.256 66.4215C106.256 66.5056 106.231 66.5878 106.185 66.6578C106.138 66.7277 106.072 66.7823 105.994 66.8145C105.916 66.8467 105.831 66.8551 105.748 66.8386C105.666 66.8222 105.59 66.7816 105.531 66.7221Z\" fill=\"#023F80\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_570_1646\">\n<rect width=\"192\" height=\"98\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var ColorOnboardingCinco = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path opacity=\"0.1\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M63.7506 74.6651C90.3048 65.862 105.581 65.862 105.581 44.8266C105.581 23.7912 116.385 14.9858 78.364 14.9858C40.343 14.9858 35 23.7906 35 44.8261C35 65.8615 37.1964 83.4682 63.7506 74.6651Z\" fill=\"#479EF8\"/>\n<path opacity=\"0.1\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M99.1877 28.0142C93.5226 55.3565 85.8965 68.5652 104.035 79.0374C122.173 89.5096 124.373 103.234 143.353 70.36C162.333 37.4855 157.408 28.4824 139.269 18.0102C121.131 7.53804 104.853 0.671851 99.1877 28.0142Z\" fill=\"#479EF8\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M54.8303 35.3209C54.8303 33.1305 53.0546 31.3548 50.8642 31.3548C53.0546 31.3548 54.8303 29.5791 54.8303 27.3887C54.8303 29.5791 56.606 31.3548 58.7964 31.3548C56.606 31.3548 54.8303 33.1305 54.8303 35.3209ZM152.22 54.2698C152.22 52.0794 150.444 50.3037 148.254 50.3037C150.444 50.3037 152.22 48.528 152.22 46.3376C152.22 48.528 153.996 50.3037 156.186 50.3037C153.996 50.3037 152.22 52.0794 152.22 54.2698ZM47.7793 74.1004C49.483 74.1004 50.864 75.4814 50.864 77.1851C50.864 75.4814 52.2451 74.1004 53.9488 74.1004C52.2451 74.1004 50.864 72.7193 50.864 71.0156C50.864 72.7193 49.483 74.1004 47.7793 74.1004ZM132.61 92.6089C132.61 91.027 131.328 89.7445 129.746 89.7445C131.328 89.7445 132.61 88.4621 132.61 86.8801C132.61 88.4621 133.892 89.7445 135.474 89.7445C133.892 89.7445 132.61 91.027 132.61 92.6089Z\" fill=\"#0A7FE4\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M117.102 35.3741C117.52 35.1192 117.794 34.7485 117.925 34.2621C118.039 33.8356 118.028 33.4691 117.893 33.1626C117.758 32.856 117.566 32.6082 117.317 32.4193C117.069 32.2304 116.741 32.0266 116.333 31.808C115.953 31.6032 115.682 31.4276 115.52 31.2811C115.358 31.1346 115.302 30.9653 115.354 30.7731C115.407 30.5749 115.531 30.4393 115.727 30.3663C115.923 30.2932 116.153 30.2922 116.418 30.363C116.6 30.4119 116.766 30.4805 116.916 30.5688C117.065 30.6572 117.2 30.7578 117.321 30.8707C117.382 30.9271 117.431 30.9738 117.47 31.0108L117.555 31.0925C117.661 31.1917 117.743 31.2619 117.801 31.3033C117.859 31.3446 117.923 31.3747 117.994 31.3936C118.135 31.4314 118.276 31.3984 118.417 31.2947C118.558 31.1909 118.653 31.0489 118.701 30.8687C118.735 30.7426 118.742 30.6301 118.721 30.5312C118.7 30.4323 118.647 30.3326 118.56 30.2322C118.176 29.8075 117.751 29.4908 117.284 29.282L117.397 28.8586C117.447 28.6724 117.43 28.5069 117.346 28.3621C117.262 28.2172 117.129 28.1204 116.947 28.0716C116.771 28.0243 116.608 28.0435 116.459 28.1291C116.31 28.2148 116.211 28.3476 116.163 28.5278L116.042 28.9783C115.471 28.9475 114.973 29.0652 114.549 29.3313C114.125 29.5975 113.849 29.9708 113.72 30.4512C113.607 30.8716 113.621 31.234 113.759 31.5384C113.898 31.8427 114.093 32.0913 114.344 32.284C114.595 32.4767 114.925 32.6892 115.336 32.9214L115.442 32.9822C115.578 33.0608 115.694 33.1297 115.79 33.189L115.918 33.2705C116.049 33.3571 116.152 33.454 116.227 33.561C116.302 33.6681 116.323 33.7847 116.289 33.9108C116.233 34.121 116.11 34.257 115.92 34.3188C115.73 34.3806 115.48 34.3698 115.168 34.2863C114.915 34.2186 114.685 34.1248 114.478 34.0048C114.271 33.8849 114.057 33.7183 113.837 33.5048C113.743 33.4088 113.664 33.3394 113.6 33.2965C113.536 33.2535 113.469 33.2226 113.398 33.2037C113.257 33.1659 113.118 33.1993 112.979 33.3039C112.841 33.4085 112.748 33.5508 112.699 33.731C112.662 33.8691 112.655 33.9861 112.676 34.082C112.698 34.1779 112.753 34.2731 112.841 34.3675C113.223 34.7982 113.729 35.143 114.359 35.4019L114.25 35.8073C114.201 35.9935 114.218 36.159 114.302 36.3038C114.386 36.4486 114.519 36.5455 114.701 36.5943C114.883 36.6431 115.047 36.6258 115.192 36.5424C115.337 36.459 115.435 36.3242 115.485 36.138L115.603 35.6966C116.184 35.7366 116.684 35.6291 117.102 35.3741ZM71.6424 82.3157C71.7048 81.9043 71.6132 81.5233 71.3676 81.1726C71.1524 80.8652 70.908 80.6718 70.6345 80.5923C70.3611 80.5129 70.0949 80.5024 69.836 80.5611C69.5772 80.6198 69.2652 80.7221 68.9002 80.868C68.5593 81.0034 68.2969 81.084 68.1128 81.1097C67.9287 81.1353 67.7882 81.0789 67.6912 80.9404C67.5911 80.7975 67.5709 80.6423 67.6304 80.4748C67.6899 80.3073 67.815 80.1568 68.0057 80.0233C68.137 79.9314 68.2723 79.8608 68.4115 79.8117C68.5508 79.7626 68.6902 79.7295 68.8298 79.7124C68.8996 79.7039 68.9571 79.697 69.0025 79.6919L69.1018 79.6816C69.2241 79.6669 69.3147 79.6519 69.3734 79.6366C69.4321 79.6213 69.4869 79.5958 69.5378 79.5602C69.6394 79.489 69.6951 79.3791 69.7046 79.2305C69.7142 79.0818 69.6735 78.9426 69.5826 78.8127C69.5189 78.7218 69.4492 78.6561 69.3735 78.6155C69.2978 78.575 69.2036 78.5555 69.091 78.5569C68.6047 78.5748 68.166 78.6788 67.7749 78.8687L67.5612 78.5635C67.4672 78.4293 67.3502 78.35 67.2099 78.3256C67.0697 78.3012 66.9339 78.335 66.8026 78.4269C66.6755 78.5159 66.5991 78.6323 66.5735 78.7761C66.5479 78.9198 66.5805 79.0566 66.6715 79.1865L66.8988 79.5112C66.5666 79.8664 66.3713 80.2548 66.3129 80.6763C66.2545 81.0979 66.3465 81.4819 66.5891 81.8282C66.8012 82.1312 67.0444 82.3207 67.3185 82.3965C67.5926 82.4723 67.8609 82.4813 68.1233 82.4233C68.3858 82.3653 68.7047 82.2662 69.0801 82.1259L69.1778 82.09C69.3036 82.044 69.4118 82.0061 69.5025 81.9763L69.6255 81.9376C69.7535 81.8996 69.873 81.8853 69.9838 81.8948C70.0946 81.9043 70.1819 81.9545 70.2455 82.0454C70.3516 82.1969 70.3729 82.3514 70.3095 82.5087C70.246 82.6661 70.102 82.8234 69.8774 82.9806C69.6953 83.1082 69.5085 83.2067 69.3172 83.2761C69.1259 83.3455 68.9006 83.3936 68.6415 83.4202C68.5276 83.429 68.4392 83.4425 68.3762 83.4608C68.3133 83.479 68.2564 83.506 68.2055 83.5416C68.1038 83.6128 68.0493 83.722 68.0418 83.8691C68.0343 84.0163 68.0761 84.1548 68.167 84.2847C68.2368 84.3843 68.3087 84.4532 68.3829 84.4916C68.4572 84.5299 68.5491 84.5462 68.6587 84.5405C69.148 84.5269 69.649 84.3857 70.1617 84.117L70.3664 84.4093C70.4603 84.5435 70.5774 84.6228 70.7176 84.6472C70.8579 84.6716 70.9936 84.6378 71.125 84.5458C71.2563 84.4539 71.3345 84.3378 71.3595 84.1977C71.3846 84.0576 71.3501 83.9205 71.2561 83.7863L71.0333 83.4681C71.377 83.1113 71.58 82.7272 71.6424 82.3157Z\" fill=\"#0A7FE4\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M81.7975 25.2672C81.9707 25.1985 82.167 25.2397 82.3261 25.3361C82.4694 25.423 82.5712 25.5645 82.6522 25.7215C82.7316 25.8759 82.7909 26.0451 82.8491 26.1919C82.9543 26.4575 83.0595 26.7412 83.0909 27.0289C83.0963 27.0775 83.1472 27.1073 83.1917 27.0896L84.9492 26.3927C85.278 26.2624 85.656 26.4306 85.7892 26.7665C85.8569 26.9373 85.8387 27.121 85.7561 27.2687C85.7394 27.2987 85.7459 27.3368 85.7718 27.3601C85.8368 27.4187 85.89 27.4927 85.9245 27.5797L85.9522 27.6496C86.0199 27.8204 86.0017 28.0041 85.9192 28.1517C85.9024 28.1818 85.9089 28.2199 85.9348 28.2431C85.9998 28.3017 86.053 28.3757 86.0875 28.4627L86.1152 28.5326C86.1829 28.7034 86.1941 28.9612 86.1115 29.1087C86.0947 29.1387 86.1013 29.177 86.1272 29.2001C86.1922 29.2588 86.2454 29.3328 86.2799 29.4198C86.4131 29.7557 86.2531 30.1373 85.9244 30.2676L83.6717 31.1609C83.4162 31.2622 83.1397 31.2261 82.9207 31.088C82.9006 31.0753 82.8761 31.0721 82.8542 31.0808L82.1353 31.3659C82.0975 31.3809 82.0545 31.3617 82.0392 31.3231L80.9862 28.6676C80.9729 28.6341 80.985 28.5965 81.0146 28.5775C81.2057 28.4537 81.3258 28.3348 81.4911 28.1773C81.7062 27.9724 81.7858 27.6972 81.8036 27.4064C81.8292 26.9909 81.6906 26.5912 81.5835 26.194C81.4919 25.8536 81.3961 25.4264 81.7975 25.2672ZM80.1873 28.5584C80.3458 28.4956 80.5264 28.576 80.5906 28.7379L81.6924 31.5165C81.7566 31.6784 81.6801 31.8607 81.5217 31.9236L80.709 32.2458C80.5504 32.3087 80.3699 32.2282 80.3057 32.0663L79.204 29.2878C79.1397 29.1258 79.2161 28.9435 79.3747 28.8807L80.1873 28.5584Z\" fill=\"#0A7FE4\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M135.486 14.1485C135.488 14.1442 135.49 14.1401 135.491 14.1358C135.783 13.3295 135.468 12.3808 134.592 12.0644C133.897 11.8129 133.312 12.1678 133.005 12.5868C133.037 12.0684 132.815 11.4219 132.119 11.1704C131.244 10.854 130.395 11.3818 130.104 12.1881C130.102 12.1924 130.101 12.1968 130.099 12.2011C130.031 12.3747 129.39 14.1614 131.557 16.5898L131.557 16.5902C131.557 16.5903 131.557 16.5903 131.558 16.5902C131.558 16.5904 131.558 16.5905 131.558 16.5905C131.558 16.5906 131.558 16.5905 131.558 16.5905C131.559 16.5907 131.559 16.5908 131.559 16.5908L131.559 16.5904C134.778 16.1091 135.428 14.3256 135.486 14.1485Z\" fill=\"#0A7FE4\"/>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M114.085 75.2851L118.022 84.3421C118.207 84.7674 117.695 85.118 116.875 85.118H73.1979C72.3774 85.118 71.8643 84.7674 72.0496 84.3425L75.8675 75.5582V80.2343C75.8675 81.3553 76.7508 82.2705 77.8592 82.3216L77.9576 82.3239H111.995C113.15 82.3239 114.085 81.3883 114.085 80.2343V75.2847V75.2851Z\" fill=\"#B6C5D5\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M107.779 49.418H82.2189L76.6562 59.1696H113.341L107.779 49.418Z\" fill=\"#647180\"/>\n<path d=\"M69.1537 45.457L81.713 49.8638H108.154L122.035 45.457L134.815 53.1689L114.323 59.7791V80.2706L112.56 82.0333H78.4079L77.5266 81.1519L77.0859 59.7791L56.374 53.1689L69.1537 45.457Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M114.006 57.9402L109.473 50.0043L121.598 45.9703L132.158 52.3651L114.006 57.9402ZM112.521 80.2027C112.521 80.2881 112.452 80.3578 112.366 80.3578H98.6226V60.1627H112.521V80.2027H112.521ZM77.9381 80.2027V60.1627H91.8374V80.3578H78.0931C78.0082 80.3578 77.9381 80.2881 77.9381 80.2027V80.2027ZM68.8612 45.9703L80.9866 50.0047L76.453 57.9407L58.3015 52.3646L68.8612 45.9703V45.9703ZM78.6731 58.1329L80.9657 54.119L83.0632 50.4473H107.396L109.494 54.119L111.787 58.1329H78.6731ZM135.141 51.8013L122.244 43.9908C121.992 43.8375 121.684 43.8036 121.405 43.897L107.818 48.4175H82.6411L69.0557 43.8965C68.7762 43.8036 68.4678 43.838 68.2152 43.9908L55.3199 51.8013C54.9781 52.008 54.7896 52.3971 54.8388 52.7946C54.888 53.1926 55.1643 53.5237 55.546 53.6412L75.9171 59.8984V80.2027C75.9171 81.4077 76.8937 82.3875 78.0931 82.3875H112.366C113.566 82.3875 114.542 81.4077 114.542 80.2027V59.8984L134.914 53.6416C135.296 53.5241 135.572 53.193 135.622 52.7951C135.671 52.3976 135.482 52.0085 135.141 51.8013V51.8013Z\" fill=\"#023F80\"/>\n</svg>";

var ColorPagosInmediatosTutorial = "<svg width=\"192\" height=\"192\" viewBox=\"0 0 192 192\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M95.5065 191.893C147.149 191.893 189.013 149.773 189.013 97.8165C189.013 45.8596 147.149 3.74023 95.5065 3.74023C43.8643 3.74023 2 45.8596 2 97.8165C2 149.773 43.8643 191.893 95.5065 191.893Z\" fill=\"#ECEEF6\"/>\n<path d=\"M136.65 95.3565V176.301C136.65 182.224 131.907 187.013 126.04 187.013H63.7271C57.8598 187.013 53.1172 182.225 53.1172 176.301V15.6989C53.1172 9.77435 57.8598 4.98682 63.7271 4.98682H126.04C131.907 4.98682 136.65 9.77435 136.65 15.6989V95.3565Z\" fill=\"#479EF8\"/>\n<path d=\"M98.8141 70.2934L102.618 74.071C102.992 74.4413 103.36 74.5623 103.88 74.5623H109.213C113.662 74.5623 115.681 76.6369 115.681 81.0329V86.3939C115.681 86.8877 115.832 87.2579 116.204 87.6257L119.957 91.4321C123.068 94.5689 123.092 97.4314 119.957 100.543L116.204 104.346C115.832 104.741 115.68 105.089 115.68 105.605V110.939C115.68 115.387 113.634 117.413 109.213 117.413H103.88C103.36 117.413 102.992 117.558 102.618 117.933L98.8153 121.709C95.7022 124.821 92.8159 124.845 89.7003 121.709L85.9002 117.932C85.5287 117.558 85.1584 117.413 84.6385 117.413H79.3049C74.8839 117.413 72.8342 115.364 72.8342 110.939V105.605C72.8342 105.089 72.7096 104.741 72.3418 104.346L68.5616 100.543C65.4522 97.4314 65.426 94.5689 68.5616 91.4321L72.3418 87.6257C72.7096 87.2579 72.8342 86.8877 72.8342 86.3952V81.0342C72.8342 76.5895 74.8839 74.5635 79.3049 74.5635H84.6385C85.1584 74.5635 85.5287 74.4413 85.9002 74.0698L89.7003 70.2934C92.8159 67.1777 95.7022 67.154 98.8141 70.2934ZM92.4681 73.0587L87.8252 77.7253C87.2828 78.295 86.7131 78.4908 85.9476 78.4908H79.3049C77.0819 78.4908 76.759 78.8112 76.759 81.0342V87.6793C76.759 88.4411 76.5396 89.0084 75.9972 89.5545L71.3269 94.1974C69.7722 95.7795 69.7722 96.2209 71.3269 97.8017L75.9972 102.445C76.5396 102.992 76.7578 103.558 76.7578 104.3V110.939C76.7578 113.141 77.1093 113.485 79.3049 113.485H85.9476C86.7131 113.485 87.2816 113.708 87.8252 114.278L92.4681 118.94C94.0465 120.499 94.4953 120.499 96.05 118.94L100.719 114.278C101.235 113.708 101.829 113.485 102.571 113.485H109.213C111.413 113.485 111.757 113.141 111.757 110.939V104.3C111.757 103.558 112.002 102.991 112.548 102.445L117.215 97.8017C118.77 96.2209 118.77 95.7795 117.215 94.1986L112.55 89.5545C112.003 89.0084 111.758 88.4411 111.758 87.6793V81.0342C111.758 78.8349 111.414 78.4908 109.214 78.4908H102.572C101.83 78.4908 101.238 78.295 100.72 77.7253L96.05 73.0599C94.4953 71.5015 94.0465 71.5015 92.4681 73.0599V73.0587ZM100.111 85.4813C101.111 85.4813 101.856 86.1708 101.856 87.142C101.856 87.5659 101.688 87.9586 101.407 88.3813L96.0837 96.4228L90.1691 105.421C89.6479 106.224 89.1842 106.52 88.4087 106.52C87.4936 106.52 86.5772 105.914 86.5772 104.914C86.5772 104.351 86.7468 104.013 87.0011 103.618L92.5491 95.282L98.2094 86.6208C98.7305 85.8329 99.1669 85.4801 100.111 85.4801V85.4813ZM102.576 94.8881C105.73 94.8881 107.799 96.9577 107.799 100.661C107.799 104.322 105.758 106.52 102.576 106.52C99.4063 106.52 97.3516 104.351 97.3516 100.675C97.3516 96.9577 99.435 94.8881 102.576 94.8881ZM102.576 97.8591C101.871 97.8591 101.379 98.5348 101.379 100.675C101.379 102.788 101.885 103.548 102.576 103.548C103.28 103.548 103.772 102.788 103.772 100.675C103.772 98.5348 103.28 97.8591 102.576 97.8591ZM85.9438 85.4813C89.0981 85.4813 91.1677 87.5509 91.1677 91.2538C91.1677 94.9155 89.1268 97.1135 85.9438 97.1135C82.7758 97.1135 80.7199 94.9442 80.7199 91.2688C80.7199 87.5509 82.8033 85.4813 85.9438 85.4813ZM85.9438 88.4523C85.2394 88.4523 84.747 89.1281 84.747 91.2688C84.747 93.3808 85.2544 94.1413 85.9438 94.1413C86.6483 94.1413 87.1407 93.3808 87.1407 91.2688C87.1407 89.1281 86.6483 88.4511 85.9438 88.4511V88.4523Z\" fill=\"white\"/>\n<path d=\"M77.219 2.49365H112.547C114.158 2.49365 115.454 3.75163 115.454 5.31505V9.64628C115.454 11.2085 114.158 12.4677 112.547 12.4677H77.219C75.6081 12.4677 74.3115 11.2097 74.3115 9.64628V5.31505C74.3115 3.76908 75.6081 2.49365 77.219 2.49365Z\" fill=\"#484848\"/>\n<path d=\"M126.311 0H63.455C54.997 0 48.1299 6.89081 48.1299 15.3775V176.623C48.1299 185.109 54.997 192 63.455 192H126.311C134.769 192 141.636 185.109 141.636 176.623V15.3775C141.636 6.89081 134.769 0 126.311 0ZM136.566 95.3804V175.684C136.566 181.561 131.831 186.311 125.973 186.311H63.7729C57.9169 186.311 53.1817 181.561 53.1817 175.684V16.3537C53.1817 10.4765 57.9169 5.72634 63.7741 5.72634H125.975C131.831 5.72634 136.566 10.4765 136.566 16.3537V95.3804Z\" fill=\"#484848\"/>\n</svg>";

var ColorQRUno = "<svg width=\"192\" height=\"192\" viewBox=\"0 0 192 192\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M96 171.915C137.421 171.915 171 138.131 171 96.4573C171 54.7834 137.421 21 96 21C54.5786 21 21 54.7834 21 96.4573C21 138.131 54.5786 171.915 96 171.915Z\" fill=\"#ECEEF6\"/>\n<path d=\"M136 95.8814V173.702C136 179.397 131.401 184 125.711 184H65.2886C59.599 184 55 179.397 55 173.702V19.2984C55 13.6033 59.599 9 65.2886 9H125.711C131.401 9 136 13.6033 136 19.2984V95.8814Z\" fill=\"white\"/>\n<path d=\"M78.8263 5H113.174C114.74 5 116 6.26126 116 7.82883V12.1712C116 13.7387 114.74 15 113.174 15H78.8263C77.2601 15 76 13.7387 76 12.1712V7.82883C76 6.27928 77.2601 5 78.8263 5Z\" fill=\"#484848\"/>\n<path d=\"M126.085 3H64.9147C56.6834 3 50 9.67534 50 17.8967V174.103C50 182.325 56.6834 189 64.9147 189H126.085C134.317 189 141 182.325 141 174.103V17.8967C141 9.67534 134.317 3 126.085 3ZM136.065 95.3998V173.194C136.065 178.887 131.457 183.489 125.757 183.489H65.2243C59.5243 183.489 54.917 178.887 54.917 173.194V18.8426C54.917 13.1494 59.5243 8.54762 65.2243 8.54762H125.757C131.457 8.54762 136.065 13.1494 136.065 18.8426V95.3998Z\" fill=\"#484848\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23 103H67V147H23V103Z\" fill=\"white\" stroke=\"#979797\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M30 121H31.4286V111H30V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M30 125.286H31.4286V122.429H30V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M30 141H31.4286V131H30V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.4287 112.429H32.8573V111H31.4287V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.4287 121H32.8573V119.571H31.4287V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.4287 125.286H32.8573V122.429H31.4287V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.4287 132.429H32.8573V131H31.4287V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.4287 141H32.8573V139.571H31.4287V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.8574 112.429H34.286V111H32.8574V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.8574 118.143H34.286V113.857H32.8574V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.8574 121H34.286V119.571H32.8574V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.8574 129.571H34.286V125.286H32.8574V129.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.8574 132.429H34.286V131H32.8574V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.8574 138.143H34.286V133.857H32.8574V138.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.8574 141H34.286V139.571H32.8574V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M34.2861 112.429H35.7147V111H34.2861V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M34.2861 118.143H35.7147V113.857H34.2861V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M34.2861 121H35.7147V119.571H34.2861V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M34.2861 125.286H35.7147V122.429H34.2861V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M34.2861 128.143H35.7147V126.714H34.2861V128.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M34.2861 132.429H35.7147V131H34.2861V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M34.2861 138.143H35.7147V133.857H34.2861V138.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M34.2861 141H35.7147V139.571H34.2861V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M35.7139 112.429H37.1424V111H35.7139V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M35.7139 118.143H37.1424V113.857H35.7139V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M35.7139 121H37.1424V119.571H35.7139V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M35.7139 123.857H37.1424V122.429H35.7139V123.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M35.7139 129.572H37.1424V128.143H35.7139V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M35.7139 132.429H37.1424V131H35.7139V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M35.7139 138.143H37.1424V133.857H35.7139V138.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M35.7139 141H37.1424V139.571H35.7139V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M37.1426 112.429H38.5711V111H37.1426V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M37.1426 121H38.5711V119.571H37.1426V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M37.1426 126.714H38.5711V123.857H37.1426V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M37.1426 129.572H38.5711V128.143H37.1426V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M37.1426 132.429H38.5711V131H37.1426V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M37.1426 141H38.5711V139.571H37.1426V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M38.5713 121H39.9999V111H38.5713V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M38.5713 123.857H39.9999V122.429H38.5713V123.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M38.5713 126.714H39.9999V125.286H38.5713V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M38.5713 129.572H39.9999V128.143H38.5713V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M38.5713 141H39.9999V131H38.5713V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M40 129.571H41.4286V125.286H40V129.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M41.4287 112.429H42.8573V111H41.4287V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M41.4287 122.428H42.8573V119.571H41.4287V122.428Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M41.4287 125.286H42.8573V123.857H41.4287V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M41.4287 128.143H42.8573V126.714H41.4287V128.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M41.4287 131H42.8573V129.571H41.4287V131Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M41.4287 136.714H42.8573V133.857H41.4287V136.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M41.4287 141H42.8573V138.143H41.4287V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M42.8574 116.714H44.286V111H42.8574V116.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M42.8574 126.714H44.286V121H42.8574V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M42.8574 131H44.286V128.143H42.8574V131Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M42.8574 135.286H44.286V133.857H42.8574V135.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M42.8574 141H44.286V138.143H42.8574V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.2861 112.429H45.7147V111H44.2861V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.2861 118.143H45.7147V113.857H44.2861V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.2861 126.714H45.7147V119.571H44.2861V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.2861 129.572H45.7147V128.143H44.2861V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.2861 132.429H45.7147V131H44.2861V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.2861 139.571H45.7147V133.857H44.2861V139.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M45.7139 113.857H47.1424V111H45.7139V113.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M45.7139 116.714H47.1424V115.286H45.7139V116.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M45.7139 119.572H47.1424V118.143H45.7139V119.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M45.7139 122.429H47.1424V121H45.7139V122.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M45.7139 128.143H47.1424V126.714H45.7139V128.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M45.7139 131H47.1424V129.571H45.7139V131Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M45.7139 136.714H47.1424V132.429H45.7139V136.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M45.7139 141H47.1424V139.571H45.7139V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M47.1426 112.429H48.5711V111H47.1426V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M47.1426 125.286H48.5711V116.714H47.1426V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M47.1426 136.714H48.5711V129.571H47.1426V136.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M48.5713 126.714H49.9999V125.286H48.5713V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M48.5713 133.857H49.9999V131H48.5713V133.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M48.5713 139.572H49.9999V138.143H48.5713V139.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M50 121H51.4286V111H50V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M50 126.714H51.4286V122.429H50V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M50 129.572H51.4286V128.143H50V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M50 132.429H51.4286V131H50V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M50 135.286H51.4286V133.857H50V135.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M50 139.571H51.4286V136.714H50V139.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M51.4287 112.429H52.8573V111H51.4287V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M51.4287 121H52.8573V119.571H51.4287V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M51.4287 135.286H52.8573V131H51.4287V135.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M51.4287 139.572H52.8573V138.143H51.4287V139.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M52.8574 112.429H54.286V111H52.8574V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M52.8574 118.143H54.286V113.857H52.8574V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M52.8574 121H54.286V119.571H52.8574V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M52.8574 126.714H54.286V123.857H52.8574V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M52.8574 133.857H54.286V131H52.8574V133.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M52.8574 138.143H54.286V136.714H52.8574V138.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M54.2861 112.429H55.7147V111H54.2861V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M54.2861 118.143H55.7147V113.857H54.2861V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M54.2861 121H55.7147V119.571H54.2861V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M54.2861 126.714H55.7147V125.286H54.2861V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M54.2861 129.572H55.7147V128.143H54.2861V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M54.2861 133.857H55.7147V131H54.2861V133.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M54.2861 136.714H55.7147V135.286H54.2861V136.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M54.2861 139.572H55.7147V138.143H54.2861V139.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M55.7139 112.429H57.1424V111H55.7139V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M55.7139 118.143H57.1424V113.857H55.7139V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M55.7139 121H57.1424V119.571H55.7139V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M55.7139 125.286H57.1424V123.857H55.7139V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M55.7139 128.143H57.1424V126.714H55.7139V128.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M55.7139 133.857H57.1424V131H55.7139V133.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M55.7139 136.714H57.1424V135.286H55.7139V136.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M55.7139 139.572H57.1424V138.143H55.7139V139.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M57.1426 112.429H58.5711V111H57.1426V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M57.1426 121H58.5711V119.571H57.1426V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M57.1426 126.714H58.5711V123.857H57.1426V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M57.1426 129.572H58.5711V128.143H57.1426V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M57.1426 135.286H58.5711V133.857H57.1426V135.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M57.1426 139.571H58.5711V136.714H57.1426V139.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M58.5713 121H59.9999V111H58.5713V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M58.5713 123.857H59.9999V122.429H58.5713V123.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M58.5713 126.714H59.9999V125.286H58.5713V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M58.5713 129.572H59.9999V128.143H58.5713V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M58.5713 135.286H59.9999V133.857H58.5713V135.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M58.5713 139.571H59.9999V136.714H58.5713V139.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M74 103H118V147H74V103Z\" fill=\"white\" stroke=\"#979797\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M81 121H82.4286V111H81V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M81 125.286H82.4286V122.429H81V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M81 141H82.4286V131H81V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M82.4287 112.429H83.8573V111H82.4287V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M82.4287 121H83.8573V119.571H82.4287V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M82.4287 125.286H83.8573V122.429H82.4287V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M82.4287 132.429H83.8573V131H82.4287V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M82.4287 141H83.8573V139.571H82.4287V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M83.8574 112.429H85.286V111H83.8574V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M83.8574 118.143H85.286V113.857H83.8574V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M83.8574 121H85.286V119.571H83.8574V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M83.8574 129.571H85.286V125.286H83.8574V129.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M83.8574 132.429H85.286V131H83.8574V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M83.8574 138.143H85.286V133.857H83.8574V138.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M83.8574 141H85.286V139.571H83.8574V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M85.2861 112.429H86.7147V111H85.2861V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M85.2861 118.143H86.7147V113.857H85.2861V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M85.2861 121H86.7147V119.571H85.2861V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M85.2861 125.286H86.7147V122.429H85.2861V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M85.2861 128.143H86.7147V126.714H85.2861V128.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M85.2861 132.429H86.7147V131H85.2861V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M85.2861 138.143H86.7147V133.857H85.2861V138.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M85.2861 141H86.7147V139.571H85.2861V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M86.7139 112.429H88.1424V111H86.7139V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M86.7139 118.143H88.1424V113.857H86.7139V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M86.7139 121H88.1424V119.571H86.7139V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M86.7139 123.857H88.1424V122.429H86.7139V123.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M86.7139 129.572H88.1424V128.143H86.7139V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M86.7139 132.429H88.1424V131H86.7139V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M86.7139 138.143H88.1424V133.857H86.7139V138.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M86.7139 141H88.1424V139.571H86.7139V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M88.1426 112.429H89.5711V111H88.1426V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M88.1426 121H89.5711V119.571H88.1426V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M88.1426 126.714H89.5711V123.857H88.1426V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M88.1426 129.572H89.5711V128.143H88.1426V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M88.1426 132.429H89.5711V131H88.1426V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M88.1426 141H89.5711V139.571H88.1426V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M89.5713 121H90.9999V111H89.5713V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M89.5713 123.857H90.9999V122.429H89.5713V123.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M89.5713 126.714H90.9999V125.286H89.5713V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M89.5713 129.572H90.9999V128.143H89.5713V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M89.5713 141H90.9999V131H89.5713V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M91 129.571H92.4286V125.286H91V129.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M92.4287 112.429H93.8573V111H92.4287V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M92.4287 122.428H93.8573V119.571H92.4287V122.428Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M92.4287 125.286H93.8573V123.857H92.4287V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M92.4287 128.143H93.8573V126.714H92.4287V128.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M92.4287 131H93.8573V129.571H92.4287V131Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M92.4287 136.714H93.8573V133.857H92.4287V136.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M92.4287 141H93.8573V138.143H92.4287V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M93.8574 116.714H95.286V111H93.8574V116.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M93.8574 126.714H95.286V121H93.8574V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M93.8574 131H95.286V128.143H93.8574V131Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M93.8574 135.286H95.286V133.857H93.8574V135.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M93.8574 141H95.286V138.143H93.8574V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M95.2861 112.429H96.7147V111H95.2861V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M95.2861 118.143H96.7147V113.857H95.2861V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M95.2861 126.714H96.7147V119.571H95.2861V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M95.2861 129.572H96.7147V128.143H95.2861V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M95.2861 132.429H96.7147V131H95.2861V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M95.2861 139.571H96.7147V133.857H95.2861V139.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96.7139 113.857H98.1424V111H96.7139V113.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96.7139 116.714H98.1424V115.286H96.7139V116.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96.7139 119.572H98.1424V118.143H96.7139V119.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96.7139 122.429H98.1424V121H96.7139V122.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96.7139 128.143H98.1424V126.714H96.7139V128.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96.7139 131H98.1424V129.571H96.7139V131Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96.7139 136.714H98.1424V132.429H96.7139V136.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96.7139 141H98.1424V139.571H96.7139V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M98.1426 112.429H99.5711V111H98.1426V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M98.1426 125.286H99.5711V116.714H98.1426V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M98.1426 136.714H99.5711V129.571H98.1426V136.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M99.5713 126.714H101V125.286H99.5713V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M99.5713 133.857H101V131H99.5713V133.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M99.5713 139.572H101V138.143H99.5713V139.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M101 121H102.429V111H101V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M101 126.714H102.429V122.429H101V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M101 129.572H102.429V128.143H101V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M101 132.429H102.429V131H101V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M101 135.286H102.429V133.857H101V135.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M101 139.571H102.429V136.714H101V139.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M102.429 112.429H103.857V111H102.429V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M102.429 121H103.857V119.571H102.429V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M102.429 135.286H103.857V131H102.429V135.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M102.429 139.572H103.857V138.143H102.429V139.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M103.857 112.429H105.286V111H103.857V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M103.857 118.143H105.286V113.857H103.857V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M103.857 121H105.286V119.571H103.857V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M103.857 126.714H105.286V123.857H103.857V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M103.857 133.857H105.286V131H103.857V133.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M103.857 138.143H105.286V136.714H103.857V138.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M105.286 112.429H106.715V111H105.286V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M105.286 118.143H106.715V113.857H105.286V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M105.286 121H106.715V119.571H105.286V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M105.286 126.714H106.715V125.286H105.286V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M105.286 129.572H106.715V128.143H105.286V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M105.286 133.857H106.715V131H105.286V133.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M105.286 136.714H106.715V135.286H105.286V136.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M105.286 139.572H106.715V138.143H105.286V139.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M106.714 112.429H108.142V111H106.714V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M106.714 118.143H108.142V113.857H106.714V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M106.714 121H108.142V119.571H106.714V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M106.714 125.286H108.142V123.857H106.714V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M106.714 128.143H108.142V126.714H106.714V128.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M106.714 133.857H108.142V131H106.714V133.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M106.714 136.714H108.142V135.286H106.714V136.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M106.714 139.572H108.142V138.143H106.714V139.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M108.143 112.429H109.571V111H108.143V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M108.143 121H109.571V119.571H108.143V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M108.143 126.714H109.571V123.857H108.143V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M108.143 129.572H109.571V128.143H108.143V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M108.143 135.286H109.571V133.857H108.143V135.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M108.143 139.571H109.571V136.714H108.143V139.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M109.571 121H111V111H109.571V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M109.571 123.857H111V122.429H109.571V123.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M109.571 126.714H111V125.286H109.571V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M109.571 129.572H111V128.143H109.571V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M109.571 135.286H111V133.857H109.571V135.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M109.571 139.571H111V136.714H109.571V139.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M125 103H169V147H125V103Z\" fill=\"white\" stroke=\"#979797\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M132 121H133.429V111H132V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M132 125.286H133.429V122.429H132V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M132 141H133.429V131H132V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M133.429 112.429H134.857V111H133.429V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M133.429 121H134.857V119.571H133.429V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M133.429 125.286H134.857V122.429H133.429V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M133.429 132.429H134.857V131H133.429V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M133.429 141H134.857V139.571H133.429V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M134.857 112.429H136.286V111H134.857V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M134.857 118.143H136.286V113.857H134.857V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M134.857 121H136.286V119.571H134.857V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M134.857 129.571H136.286V125.286H134.857V129.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M134.857 132.429H136.286V131H134.857V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M134.857 138.143H136.286V133.857H134.857V138.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M134.857 141H136.286V139.571H134.857V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M136.286 112.429H137.715V111H136.286V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M136.286 118.143H137.715V113.857H136.286V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M136.286 121H137.715V119.571H136.286V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M136.286 125.286H137.715V122.429H136.286V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M136.286 128.143H137.715V126.714H136.286V128.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M136.286 132.429H137.715V131H136.286V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M136.286 138.143H137.715V133.857H136.286V138.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M136.286 141H137.715V139.571H136.286V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M137.714 112.429H139.142V111H137.714V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M137.714 118.143H139.142V113.857H137.714V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M137.714 121H139.142V119.571H137.714V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M137.714 123.857H139.142V122.429H137.714V123.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M137.714 129.572H139.142V128.143H137.714V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M137.714 132.429H139.142V131H137.714V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M137.714 138.143H139.142V133.857H137.714V138.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M137.714 141H139.142V139.571H137.714V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M139.143 112.429H140.571V111H139.143V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M139.143 121H140.571V119.571H139.143V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M139.143 126.714H140.571V123.857H139.143V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M139.143 129.572H140.571V128.143H139.143V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M139.143 132.429H140.571V131H139.143V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M139.143 141H140.571V139.571H139.143V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M140.571 121H142V111H140.571V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M140.571 123.857H142V122.429H140.571V123.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M140.571 126.714H142V125.286H140.571V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M140.571 129.572H142V128.143H140.571V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M140.571 141H142V131H140.571V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M142 129.571H143.429V125.286H142V129.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M143.429 112.429H144.857V111H143.429V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M143.429 122.428H144.857V119.571H143.429V122.428Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M143.429 125.286H144.857V123.857H143.429V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M143.429 128.143H144.857V126.714H143.429V128.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M143.429 131H144.857V129.571H143.429V131Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M143.429 136.714H144.857V133.857H143.429V136.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M143.429 141H144.857V138.143H143.429V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M144.857 116.714H146.286V111H144.857V116.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M144.857 126.714H146.286V121H144.857V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M144.857 131H146.286V128.143H144.857V131Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M144.857 135.286H146.286V133.857H144.857V135.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M144.857 141H146.286V138.143H144.857V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M146.286 112.429H147.715V111H146.286V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M146.286 118.143H147.715V113.857H146.286V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M146.286 126.714H147.715V119.571H146.286V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M146.286 129.572H147.715V128.143H146.286V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M146.286 132.429H147.715V131H146.286V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M146.286 139.571H147.715V133.857H146.286V139.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M147.714 113.857H149.142V111H147.714V113.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M147.714 116.714H149.142V115.286H147.714V116.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M147.714 119.572H149.142V118.143H147.714V119.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M147.714 122.429H149.142V121H147.714V122.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M147.714 128.143H149.142V126.714H147.714V128.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M147.714 131H149.142V129.571H147.714V131Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M147.714 136.714H149.142V132.429H147.714V136.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M147.714 141H149.142V139.571H147.714V141Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M149.143 112.429H150.571V111H149.143V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M149.143 125.286H150.571V116.714H149.143V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M149.143 136.714H150.571V129.571H149.143V136.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M150.571 126.714H152V125.286H150.571V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M150.571 133.857H152V131H150.571V133.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M150.571 139.572H152V138.143H150.571V139.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M152 121H153.429V111H152V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M152 126.714H153.429V122.429H152V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M152 129.572H153.429V128.143H152V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M152 132.429H153.429V131H152V132.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M152 135.286H153.429V133.857H152V135.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M152 139.571H153.429V136.714H152V139.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M153.429 112.429H154.857V111H153.429V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M153.429 121H154.857V119.571H153.429V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M153.429 135.286H154.857V131H153.429V135.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M153.429 139.572H154.857V138.143H153.429V139.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M154.857 112.429H156.286V111H154.857V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M154.857 118.143H156.286V113.857H154.857V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M154.857 121H156.286V119.571H154.857V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M154.857 126.714H156.286V123.857H154.857V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M154.857 133.857H156.286V131H154.857V133.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M154.857 138.143H156.286V136.714H154.857V138.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M156.286 112.429H157.715V111H156.286V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M156.286 118.143H157.715V113.857H156.286V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M156.286 121H157.715V119.571H156.286V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M156.286 126.714H157.715V125.286H156.286V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M156.286 129.572H157.715V128.143H156.286V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M156.286 133.857H157.715V131H156.286V133.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M156.286 136.714H157.715V135.286H156.286V136.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M156.286 139.572H157.715V138.143H156.286V139.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M157.714 112.429H159.142V111H157.714V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M157.714 118.143H159.142V113.857H157.714V118.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M157.714 121H159.142V119.571H157.714V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M157.714 125.286H159.142V123.857H157.714V125.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M157.714 128.143H159.142V126.714H157.714V128.143Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M157.714 133.857H159.142V131H157.714V133.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M157.714 136.714H159.142V135.286H157.714V136.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M157.714 139.572H159.142V138.143H157.714V139.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M159.143 112.429H160.571V111H159.143V112.429Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M159.143 121H160.571V119.571H159.143V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M159.143 126.714H160.571V123.857H159.143V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M159.143 129.572H160.571V128.143H159.143V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M159.143 135.286H160.571V133.857H159.143V135.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M159.143 139.571H160.571V136.714H159.143V139.571Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M160.571 121H162V111H160.571V121Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M160.571 123.857H162V122.429H160.571V123.857Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M160.571 126.714H162V125.286H160.571V126.714Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M160.571 129.572H162V128.143H160.571V129.572Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M160.571 135.286H162V133.857H160.571V135.286Z\" fill=\"black\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M160.571 139.571H162V136.714H160.571V139.571Z\" fill=\"black\"/>\n<mask id=\"mask0_201_414\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"55\" y=\"26\" width=\"13\" height=\"9\">\n<path d=\"M55 26V29.6567C55 32.7023 58.0648 35 61.562 35H61.6981C65.1952 35 68 32.7023 68 29.6567V26H55Z\" fill=\"white\"/>\n</mask>\n<g mask=\"url(#mask0_201_414)\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M55 26V29.6567C55 32.7023 58.0648 35 61.562 35H61.6981C65.1952 35 68 32.7023 68 29.6567V26H55Z\" fill=\"url(#paint0_linear_201_414)\"/>\n</g>\n<mask id=\"mask1_201_414\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"81\" y=\"26\" width=\"13\" height=\"9\">\n<path d=\"M81 26V29.6567C81 32.7023 84.0648 35 87.562 35H87.6981C91.1952 35 94 32.7023 94 29.6567V26H81Z\" fill=\"white\"/>\n</mask>\n<g mask=\"url(#mask1_201_414)\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M81 26V29.6567C81 32.7023 84.0648 35 87.562 35H87.6981C91.1952 35 94 32.7023 94 29.6567V26H81Z\" fill=\"url(#paint1_linear_201_414)\"/>\n</g>\n<mask id=\"mask2_201_414\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"107\" y=\"26\" width=\"13\" height=\"9\">\n<path d=\"M107 26V29.6567C107 32.7023 110.065 35 113.562 35H113.698C117.195 35 120 32.7023 120 29.6567V26H107Z\" fill=\"white\"/>\n</mask>\n<g mask=\"url(#mask2_201_414)\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M107 26V29.6567C107 32.7023 110.065 35 113.562 35H113.698C117.195 35 120 32.7023 120 29.6567V26H107Z\" fill=\"url(#paint2_linear_201_414)\"/>\n</g>\n<mask id=\"mask3_201_414\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"133\" y=\"26\" width=\"13\" height=\"9\">\n<path d=\"M133 26V29.6567C133 32.7023 136.065 35 139.562 35H139.698C143.195 35 146 32.7023 146 29.6567V26H133Z\" fill=\"white\"/>\n</mask>\n<g mask=\"url(#mask3_201_414)\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M133 26V29.6567C133 32.7023 136.065 35 139.562 35H139.698C143.195 35 146 32.7023 146 29.6567V26H133Z\" fill=\"url(#paint3_linear_201_414)\"/>\n</g>\n<mask id=\"mask4_201_414\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"42\" y=\"26\" width=\"13\" height=\"9\">\n<path d=\"M42 26V29.6567C42 32.7023 45.0648 35 48.562 35H48.6981C52.1952 35 55 32.7023 55 29.6567V26H42Z\" fill=\"white\"/>\n</mask>\n<g mask=\"url(#mask4_201_414)\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M42 26V29.6567C42 32.7023 45.0648 35 48.562 35H48.6981C52.1952 35 55 32.7023 55 29.6567V26H42Z\" fill=\"url(#paint4_linear_201_414)\"/>\n</g>\n<mask id=\"mask5_201_414\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"68\" y=\"26\" width=\"13\" height=\"9\">\n<path d=\"M68 26V29.6567C68 32.7023 71.0648 35 74.562 35H74.6981C78.1952 35 81 32.7023 81 29.6567V26H68Z\" fill=\"white\"/>\n</mask>\n<g mask=\"url(#mask5_201_414)\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M68 26V29.6567C68 32.7023 71.0648 35 74.562 35H74.6981C78.1952 35 81 32.7023 81 29.6567V26H68Z\" fill=\"url(#paint5_linear_201_414)\"/>\n</g>\n<mask id=\"mask6_201_414\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"94\" y=\"26\" width=\"13\" height=\"9\">\n<path d=\"M94 26V29.6567C94 32.7023 97.0648 35 100.562 35H100.698C104.195 35 107 32.7023 107 29.6567V26H94Z\" fill=\"white\"/>\n</mask>\n<g mask=\"url(#mask6_201_414)\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M94 26V29.6567C94 32.7023 97.0648 35 100.562 35H100.698C104.195 35 107 32.7023 107 29.6567V26H94Z\" fill=\"url(#paint6_linear_201_414)\"/>\n</g>\n<mask id=\"mask7_201_414\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"120\" y=\"26\" width=\"13\" height=\"9\">\n<path d=\"M120 26V29.6567C120 32.7023 123.065 35 126.562 35H126.698C130.195 35 133 32.7023 133 29.6567V26H120Z\" fill=\"white\"/>\n</mask>\n<g mask=\"url(#mask7_201_414)\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M120 26V29.6567C120 32.7023 123.065 35 126.562 35H126.698C130.195 35 133 32.7023 133 29.6567V26H120Z\" fill=\"url(#paint7_linear_201_414)\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M42 26L53.9356 7H63.0569L55 26H42Z\" fill=\"#E5E5EA\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M81 26H94L93.2814 7H83.3014L81 26Z\" fill=\"#20BABB\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M107 26H94L93 7H103.669L107 26Z\" fill=\"#E5E5EA\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M107 26L103.669 7H115.269L120 26H107Z\" fill=\"#20BABB\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M133 26H119.86L115.269 7H126.43L133 26Z\" fill=\"#E5E5EA\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M133 26H146L136.168 7H126.5L133 26Z\" fill=\"#20BABB\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M67.7061 26H81.0002L83.3016 7H73.0002L67.7061 26Z\" fill=\"#E5E5EA\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M55 26H68L73 7H63.0569L55 26Z\" fill=\"#20BABB\"/>\n<defs>\n<linearGradient id=\"paint0_linear_201_414\" x1=\"65.6564\" y1=\"6.64443\" x2=\"65.15\" y2=\"12.3957\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#2BCFD0\"/>\n<stop offset=\"1\" stop-color=\"#2BCFD0\"/>\n</linearGradient>\n<linearGradient id=\"paint1_linear_201_414\" x1=\"91.6564\" y1=\"6.64443\" x2=\"91.15\" y2=\"12.3957\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#2BCFD0\"/>\n<stop offset=\"1\" stop-color=\"#2BCFD0\"/>\n</linearGradient>\n<linearGradient id=\"paint2_linear_201_414\" x1=\"117.656\" y1=\"6.64443\" x2=\"117.15\" y2=\"12.3957\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#2BCFD0\"/>\n<stop offset=\"1\" stop-color=\"#2BCFD0\"/>\n</linearGradient>\n<linearGradient id=\"paint3_linear_201_414\" x1=\"143.656\" y1=\"6.64443\" x2=\"143.15\" y2=\"12.3957\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#2BCFD0\"/>\n<stop offset=\"1\" stop-color=\"#2BCFD0\"/>\n</linearGradient>\n<linearGradient id=\"paint4_linear_201_414\" x1=\"52.6564\" y1=\"6.64443\" x2=\"52.15\" y2=\"12.3957\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#F0F0F2\"/>\n<stop offset=\"1\" stop-color=\"#F0F0F2\"/>\n</linearGradient>\n<linearGradient id=\"paint5_linear_201_414\" x1=\"78.6564\" y1=\"6.64443\" x2=\"78.15\" y2=\"12.3957\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#F0F0F2\"/>\n<stop offset=\"1\" stop-color=\"#F0F0F2\"/>\n</linearGradient>\n<linearGradient id=\"paint6_linear_201_414\" x1=\"104.656\" y1=\"6.64443\" x2=\"104.15\" y2=\"12.3957\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#F0F0F2\"/>\n<stop offset=\"1\" stop-color=\"#F0F0F2\"/>\n</linearGradient>\n<linearGradient id=\"paint7_linear_201_414\" x1=\"130.656\" y1=\"6.64443\" x2=\"130.15\" y2=\"12.3957\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#F0F0F2\"/>\n<stop offset=\"1\" stop-color=\"#F0F0F2\"/>\n</linearGradient>\n</defs>\n</svg>";

var ColorQRDos = "<svg width=\"192\" height=\"192\" viewBox=\"0 0 192 192\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M85 174C126.421 174 160 140.198 160 98.5016C160 56.8048 126.421 23.0029 85 23.0029C43.5786 23.0029 10 56.8048 10 98.5016C10 140.198 43.5786 174 85 174Z\" fill=\"#ECEEF6\"/>\n<path d=\"M125 18H175V68.0276H125V18Z\" fill=\"white\" stroke=\"#979797\"/>\n<path d=\"M133 38.3441H134.619V27.0049H133V38.3441ZM133 43.2038H134.619V39.964H133V43.2038ZM133 61.0236H134.619V49.6844H133V61.0236ZM134.619 28.6248H136.239V27.0049H134.619V28.6248ZM134.619 38.3441H136.239V36.7242H134.619V38.3441ZM134.619 43.2038H136.239V39.964H134.619V43.2038ZM134.619 51.3043H136.239V49.6834H134.619V51.3043ZM134.619 61.0236H136.239V59.4037H134.619V61.0236Z\" fill=\"black\"/>\n<path d=\"M136.238 28.6248H137.858V27.0049H136.238V28.6248ZM136.238 35.1043H137.858V30.2447H136.238V35.1043ZM136.238 38.3441H137.858V36.7242H136.238V38.3441ZM136.238 48.0645H137.858V43.2038H136.238V48.0645ZM136.238 51.3043H137.858V49.6834H136.238V51.3043ZM136.238 57.7839H137.858V52.9242H136.238V57.7839ZM136.238 61.0236H137.858V59.4037H136.238V61.0236Z\" fill=\"black\"/>\n<path d=\"M137.857 28.6248H139.477V27.0049H137.857V28.6248ZM137.857 35.1043H139.477V30.2447H137.857V35.1043ZM137.857 38.3441H139.477V36.7242H137.857V38.3441ZM137.857 43.2038H139.477V39.964H137.857V43.2038ZM137.857 46.4446H139.477V44.8237H137.857V46.4446ZM137.857 51.3043H139.477V49.6834H137.857V51.3043ZM137.857 57.7839H139.477V52.9242H137.857V57.7839ZM137.857 61.0236H139.477V59.4037H137.857V61.0236Z\" fill=\"black\"/>\n<path d=\"M139.476 28.6248H141.096V27.0049H139.476V28.6248ZM139.476 35.1043H141.096V30.2447H139.476V35.1043ZM139.476 38.3441H141.096V36.7242H139.476V38.3441ZM139.476 41.5839H141.096V39.964H139.476V41.5839ZM139.476 48.0645H141.096V46.4436H139.476V48.0645ZM139.476 51.3043H141.096V49.6834H139.476V51.3043ZM139.476 57.7839H141.096V52.9242H139.476V57.7839ZM139.476 61.0236H141.096V59.4037H139.476V61.0236Z\" fill=\"black\"/>\n<path d=\"M141.095 28.6248H142.715V27.0049H141.095V28.6248ZM141.095 38.3441H142.715V36.7242H141.095V38.3441ZM141.095 44.8247H142.715V41.5829H141.095V44.8247ZM141.095 48.0645H142.715V46.4436H141.095V48.0645ZM141.095 51.3043H142.715V49.6834H141.095V51.3043ZM141.095 61.0236H142.715V59.4037H141.095V61.0236Z\" fill=\"black\"/>\n<path d=\"M142.714 38.3441H144.334V27.0049H142.714V38.3441ZM142.714 41.5839H144.334V39.964H142.714V41.5839ZM142.714 44.8247H144.334V43.2038H142.714V44.8247ZM142.714 48.0645H144.334V46.4436H142.714V48.0645ZM142.714 61.0236H144.334V49.6844H142.714V61.0236Z\" fill=\"black\"/>\n<path d=\"M144.333 48.0645H145.953V43.2038H144.333V48.0645ZM145.952 28.6248H147.572V27.0049H145.952V28.6248ZM145.952 39.964H147.572V36.7242H145.952V39.964ZM145.952 43.2038H147.572V41.5839H145.952V43.2038Z\" fill=\"black\"/>\n<path d=\"M145.952 46.4446H147.572V44.8237H145.952V46.4446ZM145.952 49.6844H147.572V48.0635H145.952V49.6844ZM145.952 56.164H147.572V52.9242H145.952V56.164ZM145.952 61.0236H147.572V57.7839H145.952V61.0236ZM147.571 33.4845H149.191V27.0049H147.571V33.4845Z\" fill=\"black\"/>\n<path d=\"M147.571 44.8247H149.191V38.3441H147.571V44.8247ZM147.571 49.6844H149.191V46.4446H147.571V49.6844ZM147.571 54.5441H149.191V52.9232H147.571V54.5441ZM147.571 61.0236H149.191V57.7839H147.571V61.0236ZM149.19 28.6248H150.81V27.0049H149.19V28.6248ZM149.19 35.1043H150.81V30.2447H149.19V35.1043Z\" fill=\"black\"/>\n<path d=\"M149.19 44.8247H150.81V36.7242H149.19V44.8247ZM149.19 48.0645H150.81V46.4436H149.19V48.0645ZM149.19 51.3043H150.81V49.6834H149.19V51.3043ZM149.19 59.4037H150.81V52.9242H149.19V59.4037ZM150.81 30.2447H152.429V27.0049H150.809L150.81 30.2447ZM150.81 33.4845H152.429V31.8646H150.809L150.81 33.4845ZM150.81 36.7242H152.429V35.1043H150.809L150.81 36.7242Z\" fill=\"black\"/>\n<path d=\"M150.81 39.964H152.429V38.3441H150.809L150.81 39.964ZM150.81 46.4446H152.429V44.8237H150.809L150.81 46.4446ZM150.81 49.6844H152.429V48.0635H150.809L150.81 49.6844ZM150.81 56.164H152.429V51.3043H150.809L150.81 56.164ZM150.81 61.0236H152.429V59.4037H150.809L150.81 61.0236ZM152.429 28.6248H154.048V27.0049H152.428L152.429 28.6248Z\" fill=\"black\"/>\n<path d=\"M152.429 43.2037H154.048V33.4844H152.428L152.429 43.2037ZM152.429 56.1639H154.048V48.0644H152.428L152.429 56.1639Z\" fill=\"black\"/>\n<path d=\"M154.048 44.8247H155.667V43.2038H154.047L154.048 44.8247ZM154.048 52.9242H155.667V49.6844H154.047L154.048 52.9242ZM154.048 59.4037H155.667V57.7829H154.047L154.048 59.4037ZM155.667 38.3441H157.286V27.0049H155.666L155.667 38.3441Z\" fill=\"black\"/>\n<path d=\"M155.667 44.8247H157.286V39.964H155.666L155.667 44.8247ZM155.667 48.0645H157.286V46.4436H155.666L155.667 48.0645ZM155.667 51.3043H157.286V49.6834H155.666L155.667 51.3043ZM155.667 54.5441H157.286V52.9232H155.666L155.667 54.5441ZM155.667 59.4037H157.286V56.164H155.666L155.667 59.4037ZM157.286 28.6248H158.905V27.0049H157.285L157.286 28.6248ZM157.286 38.3441H158.905V36.7242H157.285L157.286 38.3441Z\" fill=\"black\"/>\n<path d=\"M157.286 54.5441H158.905V49.6844H157.285L157.286 54.5441ZM157.286 59.4037H158.905V57.7829H157.285L157.286 59.4037ZM158.905 28.6248H160.524V27.0049H158.904L158.905 28.6248ZM158.905 35.1043H160.524V30.2447H158.904L158.905 35.1043ZM158.905 38.3441H160.524V36.7242H158.904L158.905 38.3441ZM158.905 44.8247H160.524V41.5829H158.904L158.905 44.8247Z\" fill=\"black\"/>\n<path d=\"M158.905 52.9242H160.524V49.6844H158.904L158.905 52.9242ZM158.905 57.7839H160.524V56.163H158.904L158.905 57.7839ZM160.524 28.6248H162.143V27.0049H160.523L160.524 28.6248ZM160.524 35.1043H162.143V30.2447H160.523L160.524 35.1043ZM160.524 38.3441H162.143V36.7242H160.523L160.524 38.3441ZM160.524 44.8247H162.143V43.2038H160.523L160.524 44.8247ZM160.524 48.0645H162.143V46.4436H160.523L160.524 48.0645Z\" fill=\"black\"/>\n<path d=\"M160.524 52.9242H162.143V49.6844H160.523L160.524 52.9242ZM160.524 56.164H162.143V54.5431H160.523L160.524 56.164ZM160.524 59.4037H162.143V57.7829H160.523L160.524 59.4037ZM162.143 28.6248H163.762V27.0049H162.142L162.143 28.6248ZM162.143 35.1043H163.762V30.2447H162.142L162.143 35.1043ZM162.143 38.3441H163.762V36.7242H162.142L162.143 38.3441ZM162.143 43.2038H163.762V41.5839H162.142L162.143 43.2038ZM162.143 46.4446H163.762V44.8237H162.142L162.143 46.4446Z\" fill=\"black\"/>\n<path d=\"M162.143 52.9242H163.762V49.6844H162.142L162.143 52.9242ZM162.143 56.164H163.762V54.5431H162.142L162.143 56.164ZM162.143 59.4037H163.762V57.7829H162.142L162.143 59.4037ZM163.762 28.6248H165.381V27.0049H163.761L163.762 28.6248ZM163.762 38.3441H165.381V36.7242H163.761L163.762 38.3441ZM163.762 44.8247H165.381V41.5829H163.761L163.762 44.8247ZM163.762 48.0645H165.381V46.4436H163.761L163.762 48.0645Z\" fill=\"black\"/>\n<path d=\"M163.762 54.5441H165.381V52.9232H163.761L163.762 54.5441ZM163.762 59.4037H165.381V56.164H163.761L163.762 59.4037ZM165.381 38.3441H167V27.0049H165.381V38.3441ZM165.381 41.5839H167V39.964H165.381V41.5839ZM165.381 44.8247H167V43.2038H165.381V44.8247ZM165.381 48.0645H167V46.4436H165.381V48.0645ZM165.381 54.5441H167V52.9232H165.381V54.5441ZM165.381 59.4037H167V56.164H165.381V59.4037Z\" fill=\"black\"/>\n<path d=\"M67.1634 78.6796C69.7884 78.0973 79.1314 78.3475 81.6314 76.9967C84.1314 75.646 114.995 52.3191 118.101 49.1434C121.206 45.9666 125.046 43.2101 127.821 39.7572C130.597 36.3033 127.913 45.8745 125.488 47.7596C125.208 50.32 125.138 55.68 125.138 55.68C123.839 55.4496 122.503 55.7888 121.47 56.6115C119.72 57.9952 94.4144 88.0388 94.4144 88.0388C94.4144 88.0388 64.5394 79.268 67.1644 78.6796H67.1634Z\" fill=\"#E49D75\"/>\n<path d=\"M58.4081 74.0308C62.6181 74.0308 86.4581 79.922 90.9401 89.4143C92.7721 93.2944 99.2201 129.575 99.9351 152.042C100.182 159.784 97.6581 172.616 95.0001 173.085C78.0001 176.087 55.3061 170.929 43.0001 161.079C38.3051 157.321 36.7751 73.9978 58.4081 74.0308Z\" fill=\"#5FC5D1\"/>\n<path d=\"M53 64.0254H62V81.8662C58.764 84.4977 53 81.8662 53 81.8662V64.0254Z\" fill=\"#E49D75\"/>\n<path d=\"M42 48.0134C42 36.9633 49.61 28.0054 59.003 28.0054C68.395 28.0054 76 36.9633 76 48.0134C76 59.0645 68.39 68.0274 59.003 68.0274C49.616 68.0274 42 59.0645 42 48.0134Z\" fill=\"#E49D75\"/>\n<path d=\"M56.4464 24.0061C61.9744 23.883 69.0004 27.352 69.0004 29.7613C69.0004 33.9306 62.4514 43.3828 57.5764 47.2599C58.9414 50.3727 60.1924 52.4298 60.1924 55.0722C60.1924 57.7137 56.0294 68.0654 56.0294 75.1033C56.0294 80.6263 57.2794 84.3834 57.2794 88.9639C57.2804 101.476 49.0104 109.05 37.0474 109.05C25.0844 109.05 17.0504 96.2459 17.0002 85.8512C16.9404 73.1062 31.2604 57.4656 34.7324 47.8553C37.6554 39.7448 43.1894 24.0061 56.4464 24.0061Z\" fill=\"black\"/>\n<path d=\"M53 48.5166C53 46.03 55.0147 44.0142 57.5 44.0142C59.9853 44.0142 62 46.03 62 48.5166C62 51.0033 59.9853 53.0191 57.5 53.0191C55.0147 53.0191 53 51.0033 53 48.5166ZM98.446 109.514C103.221 110.665 122.78 113.987 126.534 112.799C130.289 111.611 168.964 74.2298 171.979 71.4653C174.993 68.7008 181.043 64.7856 181.772 60.001C182.502 55.2163 181.772 51.1211 175.215 48.7228C175.339 51.8105 175.458 56.6281 175.328 55.9117C174.221 52.1887 174.091 47.9673 172.087 48.0159C171.007 51.4983 172.53 58.0629 169.872 62.4593C166.82 65.8212 126.286 92.778 122.029 94.1418C116.476 94.1418 102.238 89.2141 102.238 89.2141C102.238 89.2141 93.676 108.365 98.446 109.515V109.514Z\" fill=\"#E49D75\"/>\n<path d=\"M67.2871 91.0253C70.5061 77.3317 98.7441 84.5727 103.493 88.4138C105.155 93.6307 102.541 109.103 98.3921 111.975C92.1591 112.891 63.8581 105.591 67.2871 91.0253Z\" fill=\"#6BD5E1\"/>\n</svg>";

var ColorQRTres = "<svg width=\"192\" height=\"192\" viewBox=\"0 0 192 192\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M95.9717 172.322C135.721 172.322 167.943 139.903 167.943 99.9122C167.943 59.9211 135.721 27.502 95.9717 27.502C56.2228 27.502 24 59.9211 24 99.9122C24 139.903 56.2228 172.322 95.9717 172.322Z\" fill=\"#ECEEF6\"/>\n<path d=\"M79.1787 35.1777C75.8891 35.1777 74.8604 40.2916 74.8604 42.3356C74.8604 45.8036 78.5616 60.1279 82.0566 60.1279C85.5505 60.1279 89.2547 46.0071 89.2547 44.3815C89.2547 42.7568 84.9364 35.1787 79.1787 35.1787V35.1777Z\" fill=\"#E49D75\"/>\n<path d=\"M101.336 10.1805L146.027 18.9342C151.228 19.9533 154.619 24.9952 153.6 30.1963L153.595 30.2203L132.571 136.145C131.542 141.335 126.506 144.712 121.315 143.695L76.6234 134.941C71.4222 133.922 68.0319 128.88 69.051 123.679L69.0558 123.656L90.0792 17.7299C91.1089 12.5412 96.144 9.16428 101.336 10.1805Z\" fill=\"#484848\"/>\n<path d=\"M101.118 13.6794L145.04 22.3601C148.679 23.0808 151.046 26.6134 150.328 30.253L130.384 131.268C130.039 133.015 129.013 134.554 127.534 135.546C126.054 136.538 124.24 136.901 122.493 136.555L78.5707 127.874C74.9323 127.154 72.5655 123.622 73.2823 119.982L93.2271 18.9678C93.572 17.2201 94.5973 15.6811 96.0772 14.6894C97.5571 13.6977 99.3704 13.3348 101.118 13.6803V13.6794Z\" fill=\"white\"/>\n<path d=\"M110.745 12.0819L136.628 17.1132C137.194 17.222 137.693 17.5518 138.015 18.0296C138.337 18.5074 138.456 19.0938 138.344 19.6591L137.708 22.9314C137.6 23.4971 137.27 23.9964 136.793 24.3187C136.315 24.6411 135.729 24.7599 135.164 24.6491L109.28 19.6178C108.714 19.5089 108.215 19.1792 107.893 18.7014C107.571 18.2236 107.453 17.6372 107.564 17.0719L108.201 13.7996C108.431 12.6241 109.568 11.856 110.745 12.0819Z\" fill=\"#484848\"/>\n<path d=\"M113.042 50.2839L112.618 52.4651L97.3473 49.496L94.3791 64.7675L92.1979 64.3433L95.5902 46.8916L113.042 50.2839ZM90.9255 70.8879L93.1076 71.3111L90.1386 86.5826L105.409 89.5497L104.985 91.7309L87.5332 88.3387L90.9255 70.8879Z\" fill=\"#1AAAAD\"/>\n<path d=\"M99.49 64.6325L100.836 64.8945L102.667 55.4749L101.321 55.2129L99.49 64.6325ZM98.706 68.6706L100.051 68.9317L100.574 66.2399L99.229 65.9789L98.706 68.6706ZM95.8281 83.4728L97.1745 83.7348L99.0054 74.3142L97.6591 74.0532L95.8281 83.4728Z\" fill=\"black\"/>\n<path d=\"M102.406 56.821L103.752 57.082L104.013 55.7356L102.668 55.4746L102.406 56.821ZM100.837 64.8943L102.182 65.1562L102.444 63.8099L101.098 63.5489L100.837 64.8943ZM100.051 68.9314L101.397 69.1934L101.92 66.5016L100.575 66.2397L100.051 68.9314ZM98.7438 75.6603L100.089 75.9213L100.351 74.5759L99.0058 74.3139L98.7438 75.6603ZM97.1748 83.7345L98.5202 83.9956L98.7812 82.6502L97.4358 82.3882L97.1748 83.7345Z\" fill=\"black\"/>\n<path d=\"M103.751 57.0822L105.097 57.3432L105.358 55.9978L104.012 55.7358L103.751 57.0822ZM102.704 62.4647L104.051 62.7267L104.835 58.6896L103.489 58.4276L102.704 62.4647ZM102.181 65.1565L103.527 65.4175L103.789 64.0721L102.443 63.8101L102.181 65.1565ZM100.612 73.2307L101.958 73.4917L102.743 69.4546L101.396 69.1936L100.612 73.2307ZM100.089 75.9215L101.435 76.1835L101.696 74.8381L100.35 74.5761L100.089 75.9215ZM99.0425 81.305L100.388 81.566L101.173 77.5289L99.8275 77.2679L99.0425 81.305ZM98.5195 83.9958L99.8649 84.2577L100.127 82.9124L98.7805 82.6504L98.5195 83.9958Z\" fill=\"black\"/>\n<path d=\"M105.097 57.3434L106.442 57.6054L106.704 56.26L105.358 55.998L105.097 57.3434ZM104.051 62.7269L105.396 62.9879L106.181 58.9508L104.835 58.6898L104.051 62.7269ZM103.527 65.4177L104.874 65.6797L105.135 64.3343L103.789 64.0723L103.527 65.4177ZM102.743 69.4548L104.089 69.7168L104.612 67.0251L103.266 66.7641L102.743 69.4548ZM102.219 72.1466L103.566 72.4076L103.827 71.0622L102.481 70.8012L102.219 72.1466ZM101.435 76.1837L102.781 76.4447L103.043 75.0993L101.696 74.8383L101.435 76.1837ZM100.388 81.5662L101.735 81.8282L102.519 77.7911L101.173 77.5291L100.388 81.5662ZM99.8652 84.257L101.211 84.519L101.473 83.1736L100.127 82.9126L99.8652 84.257ZM106.442 57.6054L107.789 57.8674L108.05 56.521L106.704 56.26L106.442 57.6054Z\" fill=\"black\"/>\n<path d=\"M105.396 62.9879L106.742 63.2499L107.527 59.2127L106.182 58.9508L105.396 62.9879ZM104.874 65.6787L106.219 65.9407L106.481 64.5953L105.135 64.3342L104.874 65.6787ZM104.35 68.3714L105.696 68.6324L105.957 67.287L104.612 67.025L104.35 68.3714ZM103.304 73.7539L104.649 74.0149L104.911 72.6695L103.566 72.4075L103.304 73.7539ZM102.781 76.4456L104.126 76.7067L104.388 75.3613L103.043 75.0993L102.781 76.4456ZM101.735 81.8282L103.08 82.0892L103.865 78.052L102.519 77.791L101.735 81.8282ZM101.212 84.5189L102.557 84.7809L102.818 83.4355L101.473 83.1736L101.212 84.5189ZM107.789 57.8673L109.135 58.1284L109.396 56.783L108.05 56.521L107.789 57.8673ZM106.219 65.9407L107.565 66.2026L107.827 64.8572L106.481 64.5953L106.219 65.9407ZM105.173 71.3241L106.519 71.5852L107.042 68.8944L105.696 68.6324L105.173 71.3241ZM104.649 74.0149L105.996 74.2769L106.257 72.9315L104.911 72.6695L104.649 74.0149ZM104.126 76.7067L105.473 76.9686L105.734 75.6223L104.388 75.3613L104.126 76.7067Z\" fill=\"black\"/>\n<path d=\"M102.557 84.7812L103.902 85.0431L104.164 83.6968L102.818 83.4358L102.557 84.7812ZM107.564 66.2029L108.91 66.4648L110.741 57.0442L109.395 56.7832L107.564 66.2029ZM107.041 68.8936L108.386 69.1556L108.648 67.8102L107.303 67.5483L107.041 68.8936ZM106.518 71.5854L107.863 71.8474L108.125 70.502L106.78 70.24L106.518 71.5854ZM105.995 74.2771L107.34 74.5391L107.602 73.1928L106.256 72.9317L105.995 74.2771Z\" fill=\"black\"/>\n<path d=\"M103.902 85.0426L105.248 85.3036L107.08 75.884L105.733 75.622L103.902 85.0426ZM107.341 74.5386L108.686 74.7996L109.471 70.7625L108.126 70.5014L107.341 74.5386ZM111.825 58.6511L113.171 58.913L113.432 57.5676L112.087 57.3057L111.825 58.6511ZM109.994 68.0717L111.34 68.3327L111.863 65.6409L110.518 65.3799L109.994 68.0717ZM109.471 70.7625L110.817 71.0244L111.078 69.6781L109.733 69.4171L109.471 70.7625ZM108.948 73.4542L110.293 73.7152L110.555 72.3698L109.21 72.1088L108.948 73.4542Z\" fill=\"black\"/>\n<path d=\"M108.425 76.1452L109.77 76.4072L110.032 75.0618L108.686 74.7998L108.425 76.1452ZM107.379 81.5287L108.724 81.7897L109.247 79.0989L107.902 78.8369L107.379 81.5287ZM106.594 85.5658L107.939 85.8268L108.462 83.1361L107.117 82.8741L106.594 85.5658ZM112.386 62.9504L113.731 63.2114L114.777 57.8289L113.432 57.5679L112.386 62.9504ZM110.555 72.37L111.9 72.632L112.946 67.2485L111.601 66.9875L110.555 72.37Z\" fill=\"black\"/>\n<path d=\"M109.771 76.4069L111.117 76.6689L111.64 73.9771L110.293 73.7152L109.771 76.4069ZM108.985 80.444L110.332 80.706L110.593 79.3597L109.247 79.0986L108.985 80.444ZM107.939 85.8266L109.285 86.0885L109.809 83.3968L108.462 83.1358L107.939 85.8266ZM114.517 59.174L115.862 59.436L116.124 58.0906L114.779 57.8286L114.517 59.174ZM113.471 64.5575L114.816 64.8185L115.601 60.7814L114.256 60.5204L113.471 64.5575ZM111.902 72.6318L113.247 72.8928L114.555 66.1649L113.209 65.9029L111.902 72.6318Z\" fill=\"black\"/>\n<path d=\"M111.378 75.3228L112.723 75.5847L112.985 74.2393L111.64 73.9774L111.378 75.3228ZM110.855 78.0145L112.2 78.2765L112.462 76.9301L111.117 76.6691L110.855 78.0145ZM109.547 84.7434L110.892 85.0044L111.938 79.6209L110.593 79.3599L109.547 84.7434ZM115.601 60.7816L116.947 61.0436L117.47 58.3518L116.124 58.0908L115.601 60.7816ZM115.078 63.4733L116.424 63.7353L116.686 62.389L115.339 62.128L115.078 63.4733ZM114.555 66.1651L115.901 66.4261L116.162 65.0807L114.816 64.8187L114.555 66.1651ZM114.032 68.8559L115.378 69.1178L115.639 67.7725L114.293 67.5105L114.032 68.8559ZM112.985 74.2384L114.331 74.5004L114.593 73.155L113.247 72.893L112.985 74.2384Z\" fill=\"black\"/>\n<path d=\"M112.462 76.9299L113.807 77.1918L114.069 75.8455L112.723 75.5845L112.462 76.9299ZM111.416 82.3133L112.761 82.5744L113.546 78.5372L112.2 78.2762L111.416 82.3133ZM110.631 86.3505L111.976 86.6115L112.238 85.2661L110.892 85.0041L110.631 86.3505ZM117.208 59.6979L118.554 59.9589L118.815 58.6135L117.469 58.3516L117.208 59.6979ZM114.854 71.8093L116.2 72.0703L117.769 63.9961L116.423 63.735L114.854 71.8093Z\" fill=\"black\"/>\n<path d=\"M112.762 82.5748L114.107 82.8368L115.415 76.1079L114.07 75.846L112.762 82.5748ZM115.938 73.4162L117.284 73.6782L117.545 72.3328L116.2 72.0708L115.938 73.4162Z\" fill=\"black\"/>\n<path d=\"M114.63 80.145L115.976 80.407L116.499 77.7153L115.154 77.4533L114.63 80.145ZM113.584 85.5276L114.929 85.7895L115.191 84.4441L113.846 84.1822L113.584 85.5276ZM118.33 68.2956L119.676 68.5566L121.507 59.137L120.161 58.875L118.33 68.2956ZM117.284 73.6781L118.63 73.9401L119.415 69.903L118.068 69.641L117.284 73.6781ZM116.76 76.3689L118.107 76.6309L118.368 75.2855L117.022 75.0235L116.76 76.3689Z\" fill=\"black\"/>\n<path d=\"M116.238 79.0604L117.584 79.3224L117.845 77.977L116.5 77.715L116.238 79.0604ZM115.715 81.7521L117.06 82.0141L117.322 80.6678L115.977 80.4068L115.715 81.7521ZM114.93 85.7893L116.276 86.0513L116.799 83.3595L115.453 83.0975L114.93 85.7893ZM121.246 60.4821L122.591 60.7441L122.853 59.3987L121.507 59.1367L121.246 60.4821ZM119.676 68.5573L121.022 68.8184L121.283 67.473L119.938 67.211L119.676 68.5573Z\" fill=\"black\"/>\n<path d=\"M117.059 82.0144L118.406 82.2754L119.19 78.2382L117.844 77.9772L117.059 82.0144ZM116.275 86.0515L117.621 86.3125L117.883 84.9671L116.536 84.7051L116.275 86.0515ZM122.592 60.7443L123.936 61.0063L124.198 59.6599L122.853 59.3989L122.592 60.7443ZM121.545 66.1268L122.89 66.3888L123.675 62.3517L122.329 62.0897L121.545 66.1268ZM121.022 68.8186L122.367 69.0796L122.628 67.7342L121.283 67.4732L121.022 68.8186ZM119.975 74.2011L121.321 74.4631L121.844 71.7713L120.498 71.5103L119.975 74.2011Z\" fill=\"black\"/>\n<path d=\"M118.667 80.9297L120.013 81.1907L120.536 78.4999L119.19 78.238L118.667 80.9297ZM117.883 84.9668L119.228 85.2279L119.489 83.8825L118.144 83.6205L117.883 84.9668ZM123.936 61.0051L125.282 61.267L125.543 59.9216L124.198 59.6597L123.936 61.0051ZM122.89 66.3885L124.236 66.6496L125.02 62.6124L123.675 62.3514L122.89 66.3885ZM122.367 69.0793L123.713 69.3413L123.974 67.9959L122.628 67.7339L122.367 69.0793ZM121.321 74.4628L122.667 74.7238L122.928 73.3784L121.582 73.1165L121.321 74.4628ZM120.797 77.1536L122.144 77.4156L122.405 76.0702L121.059 75.8082L120.797 77.1536Z\" fill=\"black\"/>\n<path d=\"M120.014 81.191L121.359 81.4529L121.882 78.7612L120.537 78.5002L120.014 81.191ZM119.49 83.8827L120.836 84.1447L121.097 82.7983L119.752 82.5373L119.49 83.8827ZM118.967 86.5744L120.313 86.8355L120.574 85.4901L119.229 85.2281L118.967 86.5744ZM125.283 61.2673L126.628 61.5292L126.89 60.1829L125.544 59.9219L125.283 61.2673ZM124.236 66.6498L125.582 66.9118L126.366 62.8746L125.021 62.6127L124.236 66.6498ZM123.713 69.3415L125.059 69.6035L125.32 68.2572L123.975 67.9961L123.713 69.3415ZM122.928 73.3787L124.274 73.6406L124.535 72.2943L123.19 72.0333L122.928 73.3787ZM122.405 76.0704L123.751 76.3314L124.012 74.986L122.667 74.7241L122.405 76.0704ZM121.359 81.4529L122.705 81.7149L123.228 79.0232L121.882 78.7612L121.359 81.4529Z\" fill=\"black\"/>\n<path d=\"M120.835 84.1444L122.181 84.4054L122.443 83.06L121.097 82.798L120.835 84.1444ZM120.312 86.8352L121.658 87.0972L121.92 85.7518L120.574 85.4898L120.312 86.8352ZM126.628 61.529L127.973 61.79L128.235 60.4446L126.89 60.1826L126.628 61.529ZM125.058 69.6032L126.404 69.8642L126.665 68.5189L125.32 68.2569L125.058 69.6032ZM124.012 74.9858L125.358 75.2477L125.881 72.556L124.535 72.294L124.012 74.9858ZM123.489 77.6775L124.834 77.9385L125.096 76.5931L123.751 76.3311L123.489 77.6775ZM122.443 83.06L123.788 83.321L124.05 81.9756L122.704 81.7146L122.443 83.06Z\" fill=\"black\"/>\n<path d=\"M121.658 87.0974L123.004 87.3584L123.527 84.6676L122.181 84.4056L121.658 87.0974ZM126.404 69.8645L127.75 70.1265L129.581 60.7068L128.235 60.4448L126.404 69.8645ZM125.882 72.5562L127.227 72.8172L127.489 71.4718L126.143 71.2108L125.882 72.5562ZM125.359 75.248L126.704 75.509L126.965 74.1636L125.62 73.9016L125.359 75.248ZM124.835 77.9387L126.181 78.2007L126.442 76.8544L125.097 76.5934L124.835 77.9387ZM123.789 83.3213L125.134 83.5832L125.396 82.2379L124.051 81.9759L123.789 83.3213Z\" fill=\"black\"/>\n<path d=\"M123.005 87.3583L124.35 87.6202L124.873 84.9285L123.527 84.6675L123.005 87.3583Z\" fill=\"black\"/>\n<path d=\"M111.529 93.0037L111.953 90.8225L127.224 93.7915L130.192 78.5201L132.373 78.9443L128.981 96.396L111.529 93.0037ZM133.646 72.3996L131.464 71.9764L134.433 56.705L119.162 53.7378L119.586 51.5557L137.038 54.9479L133.646 72.3996Z\" fill=\"#1AAAAD\"/>\n<path d=\"M61.7298 108.887C58.0842 109.863 56.3972 113.289 57.1889 116.241C59.7923 125.958 67.4856 132.453 69.9202 131.8C75.1252 130.405 76.2902 127.117 75.7787 125.208C75.3997 123.811 70.0593 106.654 61.7298 108.887Z\" fill=\"#E49D75\"/>\n<path d=\"M74.3151 91.2138C75.4839 92.3912 85.416 102.017 85.416 108.693C85.416 113.215 81.5775 117.705 75.2882 116.745C71.3873 116.745 60.4658 101.228 60.4658 94.9448C60.4658 91.4086 62.6115 83.1587 68.6581 83.1587C70.4142 83.1587 74.3151 86.3024 74.8985 87.0874C75.4993 87.715 76.1365 88.3051 76.8082 88.856C76.279 91.5234 75.7448 94.1899 75.2056 96.8554\" fill=\"#E49D75\"/>\n<path d=\"M67.6591 129.694C69.3692 129.087 72.6626 127.192 74.0684 125.164C73.4965 123.857 72.0139 121.677 71.084 120.746C68.9335 118.597 63.1978 122.18 64.6315 125.765C65.2629 126.765 65.7408 127.483 66.0661 127.915C66.2197 128.119 66.7503 128.712 67.6591 129.694ZM74.5722 114.587C76.9502 113.738 81.5285 111.084 83.4833 108.246C82.6868 106.415 80.6265 103.364 79.3339 102.062C76.3437 99.0503 68.3712 104.068 70.3643 109.086C71.2414 110.487 71.9064 111.491 72.3574 112.097C72.5705 112.383 73.3084 113.213 74.5722 114.587Z\" fill=\"#F7BD9C\"/>\n<path d=\"M73.1756 67.0927C68.8151 68.2606 66.797 72.3591 67.7442 75.8896C70.8572 87.5116 80.059 95.2797 82.9714 94.4996C89.1975 92.8308 90.5908 88.8973 89.9786 86.6143C89.5257 84.9436 83.1375 64.4231 73.1756 67.0927Z\" fill=\"#E49D75\"/>\n<path d=\"M80.1373 92.2674C82.3607 91.4796 86.6416 89.0152 88.4697 86.3801C87.726 84.6797 85.7991 81.8459 84.59 80.6368C81.7936 77.8404 74.3383 82.5004 76.2028 87.1603C77.0224 88.4606 77.6442 89.3933 78.0664 89.9557C78.2651 90.2215 78.956 90.9921 80.1373 92.2684V92.2674Z\" fill=\"#F7BD9C\"/>\n<path d=\"M72.307 130.802C71.7178 132.377 71.3167 147.58 73.0881 156.035C71.8963 162.13 67.1826 182 67.1826 182H109.903L114.233 164.696C114.233 164.696 140.594 141.678 143.152 137.551C145.71 133.425 151.714 109.335 151.628 107.074C151.559 105.502 122.893 81.3138 122.106 80.3292C121.319 79.3456 107.475 93.1929 130.503 109.13C130.306 111.096 130.317 119.775 130.317 119.775C130.317 119.775 114.299 125.276 112.674 126.463C111.047 127.649 107.936 136.007 107.373 137.883C105.196 137.458 72.307 130.802 72.307 130.802Z\" fill=\"#E49D75\"/>\n<path d=\"M123.194 81.2397C122.008 83.2847 121.57 84.8844 121.881 86.0379C122.492 88.3054 124.741 90.6824 128.236 93.7148C129.757 93.0748 131.158 91.6353 132.437 89.3965L123.194 81.2397Z\" fill=\"#F7BD9C\"/>\n</svg>";

var ColorQRCuatro = "<svg width=\"192\" height=\"192\" viewBox=\"0 0 192 192\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M96 166.321C134.108 166.321 165 135.24 165 96.9004C165 58.5606 134.108 27.48 96 27.48C57.8924 27.48 27 58.5606 27 96.9004C27 135.24 57.8924 166.321 96 166.321Z\" fill=\"#ECEEF6\"/>\n<path d=\"M132.8 95.4505V167.045C132.8 172.285 128.569 176.52 123.334 176.52H67.7471C62.5114 176.52 58.2803 172.285 58.2803 167.046V24.9942C58.2803 19.7548 62.5114 15.52 67.7462 15.52H123.334C128.569 15.52 132.8 19.7548 132.8 24.9942V95.4505Z\" fill=\"white\"/>\n<path d=\"M119 179.28L106.525 162.305C106.525 162.305 99.4964 152.766 95.0831 152.6C95.0491 155.102 95.2193 173.043 96.0004 179.264H119V179.28Z\" fill=\"#56CAD8\"/>\n<path d=\"M80.2005 11.8398H111.801C112.491 11.8384 113.154 12.1122 113.642 12.6007C114.13 13.0892 114.403 13.7521 114.401 14.4425V18.4363C114.403 19.1269 114.13 19.79 113.642 20.2787C113.154 20.7674 112.491 21.0413 111.801 21.0399H80.2005C79.5101 21.0413 78.8475 20.7675 78.3595 20.279C77.8715 19.7905 77.5984 19.1276 77.6006 18.4372V14.4435C77.6006 13.0165 78.7598 11.8398 80.2005 11.8398Z\" fill=\"#484848\"/>\n<path d=\"M130.498 176.276H132.801V148.434L113.399 145.24L95.0811 152.133C95.9449 154.083 100.499 167.029 110.267 178.36H130.482V176.276H130.498Z\" fill=\"#74D5DE\"/>\n<path d=\"M89.9972 108.576C88.4635 108.542 88.4635 110.927 88.4635 110.927C87.722 108.692 71.5282 67.96 71.5282 67.96C71.5282 67.96 68.1803 69.3942 72.0388 77.0965C70.7857 77.8472 67.3063 80.6652 68.7415 85.1998C69.8299 88.6011 72.2044 89.8017 73.6883 89.8017C73.4409 92.3528 78.833 118.414 79.5423 119.663C81.1919 122.614 84.3741 125.833 86.2537 125.916C89.2557 126.066 96.6433 122.081 98.4731 119.997C100.304 117.912 92.8832 108.626 89.9972 108.576Z\" fill=\"#E49D75\"/>\n<path d=\"M113.064 93.499C105.596 86.8078 87.3716 102.834 87.7258 105.613C88.0791 108.391 97.8918 118.436 100.774 117.589C103.657 116.743 118.949 98.7513 113.065 93.4999L113.064 93.499Z\" fill=\"#FCC486\"/>\n<path d=\"M132.8 95.144C129.471 89.8062 124.587 86.3599 117.591 86.3599C93.3073 86.3599 92.6146 148.934 95.1492 152.413C97.3967 155.491 124.182 156.296 132.8 154.17\" fill=\"#FED385\"/>\n<path d=\"M132.8 117.64L130.04 118.652C130.277 119.437 131.337 123.83 132.8 128.68\" fill=\"#DE8E68\"/>\n<path d=\"M132.8 94.1674C131.201 92.9355 129.571 92.4369 128.068 93.0855C119.402 96.8473 125.575 119.465 128.068 120.296C128.867 120.563 130.69 120.296 132.8 119.714\" fill=\"#FED892\"/>\n<path d=\"M122.681 92.0135C122.681 94.0596 111.641 94.5067 111.641 92.0135V78.0801H122.681V92.0135Z\" fill=\"#E49D75\"/>\n<path d=\"M124.721 76.0751C127.464 69.179 125.531 61.9345 120.403 59.8941C115.274 57.8536 108.892 61.7899 106.149 68.6859C103.405 75.582 105.338 82.8265 110.467 84.867C115.595 86.9074 121.977 82.9712 124.721 76.0751Z\" fill=\"#E49D75\"/>\n<path d=\"M125.853 78.3762C126.87 76.956 126.89 75.2286 125.898 74.518C124.906 73.8073 123.277 74.3824 122.26 75.8026C121.243 77.2228 121.222 78.9501 122.215 79.6608C123.207 80.3715 124.836 79.7963 125.853 78.3762Z\" fill=\"#E49D75\"/>\n<path d=\"M133.72 70.8065C133.72 68.95 131.984 66.9076 131.664 64.5791C131.496 63.3978 131.866 58.4868 130.485 56.8161C127.62 53.3735 125.934 54.0828 123.744 53.2723C119.935 51.872 118.468 49.5601 115.317 49.5601C111.744 49.5601 110.295 51.4166 107.734 51.4166C104.801 51.4166 102.408 50.0661 98.2956 50.0661C96.106 50.0661 93.2402 52.9355 93.2402 55.4665C93.2402 61.4575 98.8016 60.5964 98.8016 62.0481C98.8016 63.0601 98.4649 63.8697 98.4649 65.2543C98.4649 67.0759 100.824 68.1229 102.173 68.1229C106.285 68.1229 106.823 67.6169 106.823 67.6169C107.632 65.9824 108.677 64.4756 109.924 63.1448C110.093 62.9764 112.755 64.8495 117.103 65.0013C120.676 65.1191 123.187 65.8109 123.187 67.4817C123.187 68.6629 122.749 72.1562 122.782 73.1351C122.816 74.1139 123.154 74.7543 123.373 74.7543C123.592 74.7543 123.71 74.4341 125.092 74.4341C126.558 74.4341 126.676 76.2401 126.929 76.2401C128.412 76.2401 133.72 75.0422 133.72 70.8065Z\" fill=\"#6E4F48\"/>\n<path d=\"M123.679 10H67.4025C59.829 10 53.6807 16.141 53.6807 23.7052V167.415C53.6807 174.979 59.829 181.12 67.4025 181.12H123.679C131.252 181.12 137.401 174.979 137.401 167.415V23.7052C137.401 16.141 131.252 10 123.679 10ZM132.86 95.008V166.578C132.86 171.816 128.621 176.05 123.377 176.05H67.6867C62.4427 176.05 58.2043 171.816 58.2043 166.578V24.5756C58.2043 19.3371 62.4427 15.1042 67.6867 15.1042H123.377C128.621 15.1042 132.86 19.3371 132.86 24.5756V95.008Z\" fill=\"#484848\"/>\n<path d=\"M57.0158 68.0375C69.4008 68.0375 79.4408 58.1647 79.4408 45.9861C79.4408 33.8074 69.4008 23.9346 57.0158 23.9346C44.6308 23.9346 34.5908 33.8074 34.5908 45.9861C34.5908 58.1647 44.6308 68.0375 57.0158 68.0375Z\" fill=\"white\"/>\n<path d=\"M56.4406 70.2988C70.3105 70.2988 81.7406 59.038 81.7406 45.4073C81.7406 31.8014 70.2839 20.5415 56.4406 20.5415C42.5707 20.5415 31.1406 31.8023 31.1406 45.4073C31.1406 59.0389 42.5974 70.2988 56.4406 70.2988ZM53.0633 57.5697C52.3052 57.5697 51.7357 57.2817 51.1129 56.5485L43.4493 47.5674C43.1245 47.1479 42.9083 46.6511 42.9083 46.1534C42.9083 45.1322 43.7474 44.3732 44.7226 44.3732C45.3454 44.3732 45.8873 44.6087 46.4283 45.2628L52.9547 53.1969L65.2763 34.2651C65.7087 33.611 66.3049 33.2706 66.8734 33.2706C67.8486 33.2706 68.7962 33.899 68.7962 34.9202C68.7962 35.2974 68.6233 35.7077 68.4006 36.0711L54.9042 56.5227C54.4166 57.2293 53.7938 57.5697 53.0633 57.5697Z\" fill=\"#1AAAAD\"/>\n</svg>";

var ColorQRCinco = "<svg width=\"192\" height=\"192\" viewBox=\"0 0 192 192\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M96.4193 175.395C139.177 175.395 173.839 140.522 173.839 97.5039C173.839 54.4858 139.177 19.6128 96.4193 19.6128C53.6618 19.6128 19 54.4858 19 97.5039C19 140.522 53.6618 175.395 96.4193 175.395Z\" fill=\"#ECEEF6\"/>\n<path d=\"M138.188 95.3583V176.148C138.188 182.06 133.413 186.839 127.506 186.839H64.7775C58.8709 186.839 54.0967 182.06 54.0967 176.148V15.8527C54.0967 9.94098 58.8709 5.16162 64.7775 5.16162H127.506C133.413 5.16162 138.188 9.94098 138.188 15.8527V95.3572\" fill=\"#479EF8\"/>\n<path d=\"M78.6916 2.06446H114.148C114.922 2.06281 115.666 2.37005 116.213 2.91815C116.761 3.46626 117.067 4.21 117.065 4.98472V9.46576C117.068 10.2407 116.761 10.9847 116.214 11.533C115.666 12.0813 114.923 12.3887 114.148 12.3871H78.6916C77.9169 12.3887 77.1735 12.0815 76.6259 11.5334C76.0784 10.9853 75.772 10.2415 75.7744 9.46679V4.98576C75.7744 3.38472 77.0751 2.06446 78.6916 2.06446Z\" fill=\"#484848\"/>\n<path d=\"M127.475 0H64.3317C55.8341 0 48.9355 6.89032 48.9355 15.3775V176.622C48.9355 185.11 55.8341 192 64.3317 192H127.475C135.972 192 142.871 185.11 142.871 176.622V15.3775C142.871 6.89032 135.972 0 127.475 0ZM137.777 95.3806V175.684C137.777 181.561 133.02 186.311 127.136 186.311H64.6506C58.7668 186.311 54.0112 181.561 54.0112 175.684V16.3541C54.0112 10.4764 58.7668 5.72697 64.6506 5.72697H127.136C133.02 5.72697 137.777 10.4764 137.777 16.3541V95.3806Z\" fill=\"#484848\"/>\n<path d=\"M55.7746 65.1191C69.6708 65.1191 80.9359 54.0417 80.9359 40.377C80.9359 26.7122 69.6708 15.6348 55.7746 15.6348C41.8784 15.6348 30.6133 26.7122 30.6133 40.377C30.6133 54.0417 41.8784 65.1191 55.7746 65.1191Z\" fill=\"white\"/>\n<path d=\"M55.1293 67.6563C70.6916 67.6563 83.5164 55.0214 83.5164 39.7275C83.5164 24.4614 70.6617 11.8276 55.1293 11.8276C39.567 11.8276 26.7422 24.4625 26.7422 39.7275C26.7422 55.0225 39.5969 67.6563 55.1293 67.6563ZM51.3399 53.374C50.4893 53.374 49.8503 53.0509 49.1515 52.2282L40.5528 42.1513C40.1884 41.6805 39.9458 41.1231 39.9458 40.5647C39.9458 39.4189 40.8872 38.5672 41.9814 38.5672C42.6803 38.5672 43.2883 38.8315 43.8952 39.5654L51.2181 48.4676L65.0431 27.2258C65.5282 26.4919 66.1972 26.11 66.8351 26.11C67.9293 26.11 68.9925 26.815 68.9925 27.9608C68.9925 28.384 68.7984 28.8444 68.5486 29.2522L53.4054 52.1993C52.8583 52.992 52.1595 53.374 51.3399 53.374Z\" fill=\"#1AAAAD\"/>\n<path d=\"M95.8986 72.0825C94.7116 72.0825 93.7206 72.4686 92.9299 73.2407C92.3458 73.8002 91.9553 74.5314 91.815 75.3279L91.7417 76.1796V79.1494C88.0999 79.9008 85.1704 81.4451 82.9531 83.7811C80.7358 86.1171 79.6272 88.8681 79.6272 92.035C79.6272 94.8067 80.3208 97.0136 81.7061 98.6559C83.0914 100.299 84.7348 101.507 86.6352 102.279C88.1546 102.896 90.0168 103.508 92.2217 104.112L93.9394 104.565L96.807 105.335L98.1851 105.753C99.1554 106.07 99.9668 106.496 100.619 107.03C101.273 107.564 101.6 108.248 101.6 109.079C101.6 110.464 101.055 111.503 99.9668 112.196C98.8777 112.888 97.2839 113.236 95.1864 113.236C93.4832 113.236 91.8801 113.037 90.3761 112.641C88.8721 112.246 87.2483 111.573 85.5069 110.622C84.7534 110.186 84.1402 109.889 83.6654 109.731C83.1905 109.573 82.7157 109.494 82.2408 109.494C81.2912 109.494 80.4685 109.929 79.7758 110.8C79.0832 111.672 78.7363 112.7 78.7363 113.888C78.7363 114.798 78.885 115.531 79.1823 116.086C79.4796 116.64 79.9843 117.134 80.6966 117.57C83.303 119.253 86.3492 120.426 89.8352 121.092L91.9792 121.43V124.103C91.9792 125.329 92.3652 126.319 93.1374 127.071C93.9095 127.824 94.9087 128.199 96.1361 128.199C97.3634 128.199 98.3626 127.823 99.1348 127.071C99.7129 126.509 100.094 125.775 100.221 124.979L100.293 124.102V121.192C104.014 120.48 106.974 118.996 109.17 116.739C111.368 114.483 112.466 111.75 112.466 108.543C112.466 105.733 111.784 103.496 110.417 101.833C109.052 100.171 107.429 98.9636 105.548 98.211C104.138 97.6474 102.433 97.1055 100.432 96.5852L98.3337 96.0732L97.2076 95.8017C95.045 95.2588 93.4212 94.7158 92.3353 94.1728C91.0687 93.5401 90.4359 92.5894 90.4359 91.3228C90.4359 90.0159 90.9892 88.9765 92.0979 88.2054C93.2065 87.4332 94.6517 87.0472 96.4334 87.0472C97.6607 87.0472 98.8179 87.1958 99.9069 87.4921C100.618 87.6849 101.315 87.9274 101.992 88.2177L102.965 88.6802L104.806 89.6598L105.392 89.9602L105.904 90.209L106.706 90.5506C107.142 90.7086 107.597 90.7881 108.072 90.7881C109.022 90.7881 109.854 90.3524 110.566 89.4812C111.278 88.611 111.635 87.5819 111.635 86.3937C111.635 85.5628 111.487 84.8598 111.189 84.2859C110.893 83.7119 110.388 83.1876 109.675 82.7117C107.174 81.1282 104.621 80.0134 102.018 79.3672L100.056 78.9708V76.1806C100.056 74.9532 99.6695 73.9643 98.8974 73.2118C98.1252 72.4593 97.126 72.0836 95.8986 72.0836V72.0825Z\" fill=\"white\"/>\n</svg>";

var ColorQRSeis = "<svg width=\"192\" height=\"192\" viewBox=\"0 0 192 192\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M95.5065 191.893C147.149 191.893 189.013 149.773 189.013 97.8165C189.013 45.8596 147.149 3.74023 95.5065 3.74023C43.8643 3.74023 2 45.8596 2 97.8165C2 149.773 43.8643 191.893 95.5065 191.893Z\" fill=\"#ECEEF6\"/>\n<path d=\"M136.65 95.3565V176.301C136.65 182.224 131.907 187.013 126.04 187.013H63.7271C57.8598 187.013 53.1172 182.225 53.1172 176.301V15.6989C53.1172 9.77435 57.8598 4.98682 63.7271 4.98682H126.04C131.907 4.98682 136.65 9.77435 136.65 15.6989V95.3565Z\" fill=\"#1AAAAD\"/>\n<path d=\"M101.51 93.8208H113.527C116.881 93.8208 118.572 92.1315 118.572 88.6443V76.8376C118.572 73.3529 116.881 71.6885 113.527 71.6885H101.51C98.1286 71.6885 96.4393 73.3529 96.4393 76.8376V88.6443C96.4393 92.1315 98.1286 93.8208 101.51 93.8208ZM74.9926 93.8208H87.0362C90.39 93.8208 92.0806 92.1315 92.0806 88.6443V76.8376C92.0806 73.3529 90.3913 71.6885 87.0362 71.6885H74.9926C71.6388 71.6885 69.9482 73.3529 69.9482 76.8376V88.6443C69.9482 92.1315 71.6388 93.8208 74.9926 93.8208ZM75.0462 90.0968C74.1211 90.0968 73.6723 89.6218 73.6723 88.6443V76.8376C73.6723 75.8875 74.1211 75.4125 75.0462 75.4125H86.9577C87.8815 75.4125 88.3566 75.8875 88.3566 76.8388V88.6456C88.3566 89.6218 87.8815 90.0968 86.9577 90.0968H75.0462ZM101.562 90.0968C100.612 90.0968 100.163 89.6218 100.163 88.6443V76.8376C100.163 75.8875 100.612 75.4125 101.562 75.4125H113.474C114.399 75.4125 114.848 75.8875 114.848 76.8388V88.6456C114.848 89.6218 114.399 90.0968 113.474 90.0968H101.562ZM78.7428 85.5274H83.2598C83.6289 85.5274 83.7872 85.3691 83.7872 84.9203V80.5367C83.7872 80.1128 83.6289 79.9557 83.2598 79.9557H78.7428C78.3476 79.9557 78.2155 80.114 78.2155 80.5367V84.9203C78.2155 85.3691 78.3476 85.5274 78.7428 85.5274ZM105.392 85.5274H109.909C110.304 85.5274 110.463 85.3691 110.463 84.9203V80.5367C110.463 80.1128 110.304 79.9557 109.909 79.9557H105.392C105.023 79.9557 104.891 80.114 104.891 80.5367V84.9203C104.891 85.3691 105.023 85.5274 105.392 85.5274ZM74.9926 120.312H87.0362C90.39 120.312 92.0806 118.647 92.0806 115.163V103.33C92.0806 99.8688 90.3913 98.1795 87.0362 98.1795H74.9926C71.6388 98.1795 69.9482 99.8688 69.9482 103.329V115.162C69.9482 118.647 71.6388 120.312 74.9926 120.312ZM98.2346 105.019H102.752C103.121 105.019 103.279 104.861 103.279 104.412V100.028C103.279 99.6045 103.121 99.4474 102.752 99.4474H98.2346C97.8381 99.4474 97.7072 99.6058 97.7072 100.028V104.412C97.7072 104.861 97.8381 105.019 98.2346 105.019ZM112.259 105.019H116.775C117.145 105.019 117.304 104.861 117.304 104.412V100.028C117.304 99.6045 117.145 99.4474 116.775 99.4474H112.259C111.863 99.4474 111.731 99.6058 111.731 100.028V104.412C111.731 104.861 111.863 105.019 112.259 105.019ZM75.0462 116.588C74.1211 116.588 73.6723 116.113 73.6723 115.162V103.356C73.6723 102.38 74.1211 101.905 75.0462 101.905H86.9577C87.8815 101.905 88.3566 102.38 88.3566 103.357V115.164C88.3566 116.114 87.8815 116.589 86.9577 116.589H75.0462V116.588ZM78.7428 112.045H83.2598C83.6289 112.045 83.7872 111.886 83.7872 111.411V107.054C83.7872 106.63 83.6289 106.473 83.2598 106.473H78.7428C78.3476 106.473 78.2155 106.631 78.2155 107.054V111.411C78.2155 111.886 78.3476 112.045 78.7428 112.045ZM105.314 112.045H109.829C110.2 112.045 110.358 111.886 110.358 111.411V107.054C110.358 106.63 110.2 106.473 109.829 106.473H105.314C104.917 106.473 104.785 106.631 104.785 107.054V111.411C104.785 111.886 104.917 112.045 105.314 112.045ZM98.2346 119.044H102.752C103.121 119.044 103.279 118.886 103.279 118.437V114.052C103.279 113.629 103.121 113.471 102.752 113.471H98.2346C97.8381 113.471 97.7072 113.629 97.7072 114.052V118.437C97.7072 118.886 97.8381 119.044 98.2346 119.044ZM112.259 119.044C111.863 119.044 111.731 118.886 111.731 118.437V114.052C111.731 113.629 111.863 113.471 112.259 113.471H116.775C117.145 113.471 117.304 113.629 117.304 114.052V118.437C117.304 118.886 117.145 119.044 116.775 119.044H112.259Z\" fill=\"white\"/>\n<path d=\"M77.219 2.49365H112.547C114.158 2.49365 115.454 3.75163 115.454 5.31506V9.64628C115.454 11.2085 114.158 12.4677 112.547 12.4677H77.219C75.6081 12.4677 74.3115 11.2097 74.3115 9.64628V5.31506C74.3115 3.76908 75.6081 2.49365 77.219 2.49365Z\" fill=\"#484848\"/>\n<path d=\"M126.311 0H63.455C54.997 0 48.1299 6.89081 48.1299 15.3775V176.623C48.1299 185.109 54.997 192 63.455 192H126.311C134.769 192 141.636 185.109 141.636 176.623V15.3775C141.636 6.89081 134.769 0 126.311 0ZM136.566 95.3804V175.684C136.566 181.561 131.831 186.311 125.973 186.311H63.7729C57.9169 186.311 53.1817 181.561 53.1817 175.684V16.3537C53.1817 10.4765 57.9169 5.72634 63.7741 5.72634H125.975C131.831 5.72634 136.566 10.4765 136.566 16.3537V95.3804Z\" fill=\"#484848\"/>\n</svg>";

var ColorTerminalesTutorTerminalesUno = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_462_39023)\">\n<path d=\"M94.9994 98.9146C122.148 98.9146 144.157 76.7718 144.157 49.4573C144.157 22.1428 122.148 0 94.9994 0C67.8504 0 45.8418 22.1428 45.8418 49.4573C45.8418 76.7718 67.8504 98.9146 94.9994 98.9146Z\" fill=\"#ECEEF6\"/>\n<path d=\"M125.804 78.1074C125.804 79.4945 124.886 80.6187 123.513 80.6187H66.2175C64.8456 80.6187 63.5391 79.4945 63.5391 78.1074V19.1866C63.5391 17.7995 64.8456 16.6753 66.2175 16.6753H123.514C124.887 16.6753 125.805 17.7995 125.805 19.1866L125.804 78.1074Z\" fill=\"#767676\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M125.805 35.8098C125.805 36.2368 124.827 37.3022 123.455 37.3022H66.2767C64.9048 37.3022 63.5391 36.2368 63.5391 35.8098V17.784C63.5391 17.357 64.9048 16.6753 66.2767 16.6753H123.455C124.827 16.6753 125.805 17.357 125.805 17.784V35.8098Z\" fill=\"#FD6666\"/>\n<path d=\"M82.9107 23.8006C82.9107 25.1816 81.861 26.3013 80.5663 26.3013H78.3366C77.0418 26.3013 75.9922 25.1816 75.9922 23.8006V12.988C75.9922 11.6069 77.0418 10.4873 78.3366 10.4873H80.5663C81.861 10.4873 82.9107 11.6069 82.9107 12.988V23.8006Z\" fill=\"#767676\"/>\n<path d=\"M113.352 23.8006C113.352 25.1816 112.302 26.3013 111.008 26.3013H108.778C107.483 26.3013 106.434 25.1816 106.434 23.8006V12.988C106.434 11.6069 107.483 10.4873 108.778 10.4873H111.008C112.302 10.4873 113.352 11.6069 113.352 12.988V23.8006Z\" fill=\"#767676\"/>\n<path d=\"M85 67.4629V64.7734L96.5541 46H98.4541V50.166H97.1703L88.4405 64.3516V64.5625H104V67.4629H85ZM97.3757 73V66.6455V65.3931V46H100.405V73H97.3757Z\" fill=\"white\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_462_39023\">\n<rect width=\"192\" height=\"98\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var ColorTerminalesTutorTerminalesDos = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_462_39022)\">\n<path d=\"M95 87.3716C119.301 87.3716 139 67.8128 139 43.6858C139 19.5588 119.301 0 95 0C70.6995 0 51 19.5588 51 43.6858C51 67.8128 70.6995 87.3716 95 87.3716Z\" fill=\"#ECEEF6\"/>\n<path d=\"M111.887 18.0557H78.1126C74.4789 18.0557 71.5332 20.9626 71.5332 24.5485V90.7704C71.5332 94.3563 74.4789 97.2632 78.1126 97.2632H111.887C115.521 97.2632 118.467 94.3563 118.467 90.7704V24.5485C118.467 20.9626 115.521 18.0557 111.887 18.0557Z\" fill=\"#CCCCCC\"/>\n<path d=\"M108.17 6.36865H81.7255C80.272 6.36865 79.0938 7.53143 79.0938 8.9658V21.5187C79.0938 22.953 80.272 24.1158 81.7255 24.1158H108.17C109.624 24.1158 110.802 22.953 110.802 21.5187V8.9658C110.802 7.53143 109.624 6.36865 108.17 6.36865Z\" fill=\"white\"/>\n<path d=\"M108.159 25.8472H80.9638C80.3581 25.8472 79.8672 26.3317 79.8672 26.9293C79.8672 27.527 80.3581 28.0115 80.9638 28.0115H108.159C108.764 28.0115 109.255 27.527 109.255 26.9293C109.255 26.3317 108.764 25.8472 108.159 25.8472Z\" fill=\"#5D5E68\"/>\n<path d=\"M107.939 32.3403H82.499C81.0455 32.3403 79.8672 33.5031 79.8672 34.9375V62.2075C79.8672 63.6419 81.0455 64.8047 82.499 64.8047H107.939C109.393 64.8047 110.571 63.6419 110.571 62.2075V34.9375C110.571 33.5031 109.393 32.3403 107.939 32.3403Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M95.2942 38.2109C94.8596 38.2109 94.4974 38.3503 94.2077 38.6291C93.9904 38.8381 93.8546 39.0894 93.8003 39.3829L93.7732 39.6905V40.7626C92.4405 41.0342 91.3686 41.5917 90.5574 42.4351C89.7462 43.2785 89.3406 44.272 89.3406 45.4156C89.3406 46.4163 89.5941 47.2132 90.1011 47.8065C90.6081 48.3997 91.2092 48.8357 91.9045 49.1144C92.4608 49.3375 93.1422 49.5582 93.9487 49.7766L94.5771 49.94L95.6266 50.2179L96.1307 50.3688C96.4856 50.4832 96.7825 50.6369 97.0216 50.8298C97.2606 51.0228 97.3801 51.2694 97.3801 51.5696C97.3801 52.0699 97.1809 52.4452 96.7825 52.6953C96.3842 52.9455 95.8012 53.0706 95.0334 53.0706C94.4105 53.0706 93.8239 52.9991 93.2734 52.8562C92.723 52.7132 92.1291 52.4702 91.4917 52.1271C91.2165 51.9699 90.9919 51.8627 90.8181 51.8055C90.6443 51.7483 90.4705 51.7197 90.2966 51.7197C89.949 51.7197 89.6484 51.877 89.3949 52.1914C89.1414 52.5059 89.0146 52.8776 89.0146 53.3065C89.0146 53.6352 89.069 53.8997 89.1776 54.0998C89.2863 54.3 89.4709 54.4786 89.7317 54.6359C90.6853 55.2434 91.7999 55.6673 93.0754 55.9075L93.8601 56.0297V56.9946C93.8601 57.4377 94.0013 57.7951 94.2838 58.0667C94.5663 58.3383 94.932 58.4741 95.3811 58.4741C95.8301 58.4741 96.1959 58.3383 96.4784 58.0667C96.6902 57.863 96.8226 57.611 96.8756 57.3108L96.9021 56.9946V55.9439C98.2637 55.6866 99.3465 55.1505 100.15 54.3357C100.954 53.5209 101.356 52.5345 101.356 51.3766C101.356 50.3617 101.107 49.554 100.607 48.9536C100.107 48.3532 99.5131 47.9172 98.825 47.6456C98.309 47.4419 97.685 47.2463 96.953 47.0586L96.185 46.8737L95.7731 46.7757C94.982 46.5796 94.3878 46.3836 93.9905 46.1875C93.5269 45.9588 93.2951 45.6157 93.2951 45.1583C93.2951 44.6866 93.4979 44.3113 93.9035 44.0326C94.3091 43.7538 94.8379 43.6144 95.4897 43.6144C95.9388 43.6144 96.3625 43.6681 96.7608 43.7753C97.0264 43.8467 97.2807 43.9341 97.5237 44.0373L97.8798 44.2041L98.5534 44.5579L98.768 44.6665L98.9554 44.7563L99.2487 44.8796C99.4081 44.9367 99.5746 44.9653 99.7485 44.9653C100.096 44.9653 100.4 44.8081 100.661 44.4936C100.922 44.1791 101.052 43.8074 101.052 43.3786C101.052 43.0784 100.998 42.8246 100.889 42.6174C100.781 42.4101 100.596 42.2207 100.335 42.0491C99.4196 41.4773 98.4856 41.0748 97.5331 40.8415L96.8151 40.6983V39.6905C96.8151 39.2473 96.6739 38.89 96.3914 38.6183C96.109 38.3467 95.7432 38.2109 95.2942 38.2109Z\" fill=\"#7BB8FF\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M103.115 69.1328H109.255C109.982 69.1328 110.571 69.7142 110.571 70.4314V73.8942C110.571 74.6114 109.982 75.1928 109.255 75.1928H103.115C102.388 75.1928 101.799 74.6114 101.799 73.8942V70.4314C101.799 69.7142 102.388 69.1328 103.115 69.1328ZM92.1488 69.1328H98.2896C99.0164 69.1328 99.6055 69.7142 99.6055 70.4314V73.8942C99.6055 74.6114 99.0164 75.1928 98.2896 75.1928H92.1488C91.4221 75.1928 90.8329 74.6114 90.8329 73.8942V70.4314C90.8329 69.7142 91.4221 69.1328 92.1488 69.1328ZM81.1831 69.1328H87.3239C88.0506 69.1328 88.6398 69.7142 88.6398 70.4314V73.8942C88.6398 74.6114 88.0506 75.1928 87.3239 75.1928H81.1831C80.4563 75.1928 79.8672 74.6114 79.8672 73.8942V70.4314C79.8672 69.7142 80.4563 69.1328 81.1831 69.1328ZM103.115 77.3571H109.255C109.982 77.3571 110.571 77.9385 110.571 78.6557V82.1185C110.571 82.8357 109.982 83.4171 109.255 83.4171H103.115C102.388 83.4171 101.799 82.8357 101.799 82.1185V78.6557C101.799 77.9385 102.388 77.3571 103.115 77.3571ZM92.1488 77.3571H98.2896C99.0164 77.3571 99.6055 77.9385 99.6055 78.6557V82.1185C99.6055 82.8357 99.0164 83.4171 98.2896 83.4171H92.1488C91.4221 83.4171 90.8329 82.8357 90.8329 82.1185V78.6557C90.8329 77.9385 91.4221 77.3571 92.1488 77.3571ZM81.1831 77.3571H87.3239C88.0506 77.3571 88.6398 77.9385 88.6398 78.6557V82.1185C88.6398 82.8357 88.0506 83.4171 87.3239 83.4171H81.1831C80.4563 83.4171 79.8672 82.8357 79.8672 82.1185V78.6557C79.8672 77.9385 80.4563 77.3571 81.1831 77.3571ZM103.115 85.5814H109.255C109.982 85.5814 110.571 86.1628 110.571 86.88V90.3428C110.571 91.06 109.982 91.6414 109.255 91.6414H103.115C102.388 91.6414 101.799 91.06 101.799 90.3428V86.88C101.799 86.1628 102.388 85.5814 103.115 85.5814ZM92.1488 85.5814H98.2896C99.0164 85.5814 99.6055 86.1628 99.6055 86.88V90.3428C99.6055 91.06 99.0164 91.6414 98.2896 91.6414H92.1488C91.4221 91.6414 90.8329 91.06 90.8329 90.3428V86.88C90.8329 86.1628 91.4221 85.5814 92.1488 85.5814ZM81.1831 85.5814H87.3239C88.0506 85.5814 88.6398 86.1628 88.6398 86.88V90.3428C88.6398 91.06 88.0506 91.6414 87.3239 91.6414H81.1831C80.4563 91.6414 79.8672 91.06 79.8672 90.3428V86.88C79.8672 86.1628 80.4563 85.5814 81.1831 85.5814Z\" fill=\"#5D5E68\"/>\n<path d=\"M87.3239 85.5815H81.1831C80.4563 85.5815 79.8672 86.1629 79.8672 86.8801V90.343C79.8672 91.0602 80.4563 91.6416 81.1831 91.6416H87.3239C88.0506 91.6416 88.6398 91.0602 88.6398 90.343V86.8801C88.6398 86.1629 88.0506 85.5815 87.3239 85.5815Z\" fill=\"#F95261\"/>\n<path d=\"M98.2897 85.5815H92.1489C91.4221 85.5815 90.833 86.1629 90.833 86.8801V90.343C90.833 91.0602 91.4221 91.6416 92.1489 91.6416H98.2897C99.0164 91.6416 99.6056 91.0602 99.6056 90.343V86.8801C99.6056 86.1629 99.0164 85.5815 98.2897 85.5815Z\" fill=\"#FCDA00\"/>\n<path d=\"M109.256 85.5815H103.115C102.388 85.5815 101.799 86.1629 101.799 86.8801V90.343C101.799 91.0602 102.388 91.6416 103.115 91.6416H109.256C109.982 91.6416 110.571 91.0602 110.571 90.343V86.8801C110.571 86.1629 109.982 85.5815 109.256 85.5815Z\" fill=\"#00A74C\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_462_39022\">\n<rect width=\"192\" height=\"98\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var ColorTerminalesTutorTerminalesTres = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M99.2306 98C126.074 98 147.835 76.062 147.835 49C147.835 21.938 126.074 0 99.2306 0C72.387 0 50.626 21.938 50.626 49C50.626 76.062 72.387 98 99.2306 98Z\" fill=\"#ECEEF6\"/>\n<path d=\"M111.862 11.0669L47.8326 11.0669C44.6113 11.0669 42 13.6835 42 16.9113L42 55.7876C42 59.0153 44.6113 61.6319 47.8326 61.6319L111.862 61.6319C115.083 61.6319 117.694 59.0153 117.694 55.7876L117.694 16.9113C117.694 13.6835 115.083 11.0669 111.862 11.0669Z\" fill=\"#F8B518\"/>\n<path d=\"M117.694 21.4395L42 21.4395V31.1635L117.694 31.1635V21.4395Z\" fill=\"#43444C\"/>\n<path d=\"M110.577 35.0532L49.1162 35.0532V43.4807L110.577 43.4807V35.0532Z\" fill=\"white\"/>\n<path d=\"M143.791 34.3193H80.2808C77.0596 34.3193 74.4482 36.9359 74.4482 40.1637V79.1261C74.4482 82.3539 77.0596 84.9705 80.2808 84.9705H143.791C147.012 84.9705 149.623 82.3539 149.623 79.1261V40.1637C149.623 36.9359 147.012 34.3193 143.791 34.3193Z\" fill=\"#20BABB\"/>\n<path d=\"M140.611 40.8135H117.514C116.44 40.8135 115.569 41.6857 115.569 42.7616V57.6972C115.569 58.7731 116.44 59.6453 117.514 59.6453H140.611C141.685 59.6453 142.555 58.7731 142.555 57.6972V42.7616C142.555 41.6857 141.685 40.8135 140.611 40.8135Z\" fill=\"#A0E3FA\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M81.5156 44.7095H107.859V46.6576H81.5156V44.7095ZM81.5156 53.8007H107.859V55.7488H81.5156V53.8007ZM81.5156 66.1388H91.796V71.3338H81.5156V66.1388ZM134.202 66.1388H142.555V71.3338H134.202V66.1388ZM134.202 73.9313H142.555V77.1782H134.202V73.9313ZM81.5156 73.9313H109.787V77.1782H81.5156V73.9313ZM97.5787 66.1388H109.787V71.3338H97.5787V66.1388ZM115.569 66.1388H127.777V71.3338H115.569V66.1388Z\" fill=\"black\" fill-opacity=\"0.3\"/>\n</svg>";

var ColorTerminalesTutorTerminalesCuatro = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_462_39020)\">\n<path d=\"M95 97C121.51 97 143 75.2858 143 48.5C143 21.7142 121.51 0 95 0C68.4903 0 47 21.7142 47 48.5C47 75.2858 68.4903 97 95 97Z\" fill=\"#ECEEF6\"/>\n<path d=\"M64.044 76.8554C64.044 78.2204 64.9477 79.3265 66.2987 79.3265H122.676C124.026 79.3265 125.312 78.2204 125.312 76.8554V18.8788C125.312 17.5139 124.026 16.4077 122.676 16.4077H66.2977C64.9467 16.4077 64.043 17.5139 64.043 18.8788L64.044 76.8554Z\" fill=\"#767676\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M64.043 35.2357C64.043 35.6558 65.006 36.7041 66.3559 36.7041H122.618C123.968 36.7041 125.312 35.6558 125.312 35.2357V17.4986C125.312 17.0785 123.968 16.4077 122.618 16.4077H66.3559C65.006 16.4077 64.043 17.0785 64.043 17.4986V35.2357Z\" fill=\"#24B9DC\"/>\n<path d=\"M106.25 23.4188C106.25 24.7777 107.283 25.8794 108.557 25.8794H110.751C112.025 25.8794 113.058 24.7777 113.058 23.4188V12.7795C113.058 11.4205 112.025 10.3188 110.751 10.3188H108.557C107.283 10.3188 106.25 11.4205 106.25 12.7795V23.4188Z\" fill=\"#767676\"/>\n<path d=\"M76.2969 23.4188C76.2969 24.7777 77.3297 25.8794 78.6037 25.8794H80.7977C82.0717 25.8794 83.1045 24.7777 83.1045 23.4188V12.7795C83.1045 11.4205 82.0717 10.3188 80.7977 10.3188H78.6037C77.3297 10.3188 76.2969 11.4205 76.2969 12.7795V23.4188Z\" fill=\"#767676\"/>\n<path d=\"M111.016 40.7637H121.228V50.2353H111.016V40.7637Z\" fill=\"white\"/>\n<path d=\"M96.7192 40.7637H106.931V50.2353H96.7192V40.7637Z\" fill=\"white\"/>\n<path d=\"M82.4233 40.7637H92.6348V50.2353H82.4233V40.7637Z\" fill=\"white\"/>\n<path d=\"M68.1274 40.7637H78.3389V50.2353H68.1274V40.7637Z\" fill=\"white\"/>\n<path d=\"M111.016 52.9414H121.228V63.0896H111.016V52.9414Z\" fill=\"white\"/>\n<path d=\"M96.7192 52.9414H106.931V63.0896H96.7192V52.9414Z\" fill=\"white\"/>\n<path d=\"M82.4233 52.9414H92.6348V63.0896H82.4233V52.9414Z\" fill=\"white\"/>\n<path d=\"M68.1274 52.9414H78.3389V63.0896H68.1274V52.9414Z\" fill=\"white\"/>\n<path d=\"M111.016 66.4722H121.228V76.6204H111.016V66.4722Z\" fill=\"white\"/>\n<path d=\"M96.7192 66.4722H106.931V76.6204H96.7192V66.4722Z\" fill=\"white\"/>\n<path d=\"M82.4233 66.4722H92.6348V76.6204H82.4233V66.4722Z\" fill=\"white\"/>\n<path d=\"M68.1274 66.4722H78.3389V76.6204H68.1274V66.4722Z\" fill=\"#24B9DC\"/>\n<path d=\"M124.748 96.498C133.43 96.498 140.468 89.5771 140.468 81.0398C140.468 72.5024 133.43 65.5815 124.748 65.5815C116.066 65.5815 109.027 72.5024 109.027 81.0398C109.027 89.5771 116.066 96.498 124.748 96.498Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M124.344 98.0832C134.067 98.0832 142.08 90.19 142.08 80.634C142.08 71.0964 134.048 63.2031 124.344 63.2031C114.621 63.2031 106.608 71.0964 106.608 80.634C106.608 90.19 114.64 98.0832 124.344 98.0832ZM121.976 89.1604C121.445 89.1604 121.046 88.9585 120.609 88.4445L115.237 82.1484C115.009 81.8547 114.858 81.5059 114.858 81.1571C114.858 80.4412 115.446 79.9089 116.129 79.9089C116.566 79.9089 116.946 80.0741 117.325 80.533L121.9 86.0949L130.538 72.8235C130.842 72.3646 131.259 72.1259 131.658 72.1259C132.341 72.1259 133.006 72.5665 133.006 73.2824C133.006 73.5467 132.884 73.8345 132.729 74.0894L123.267 88.4261C122.925 88.9218 122.489 89.1604 121.976 89.1604Z\" fill=\"#00A74C\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_462_39020\">\n<rect width=\"192\" height=\"98\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var FilledFeedbackError = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96 94C120.67 94 141 73.6333 141 48.9764C141 24.3667 120.623 4 96 4C71.3302 4 51 24.3667 51 48.9764C51 73.6333 71.3774 94 96 94ZM80.2618 69C78.4182 69 77 67.5345 77 65.7382C77 64.84 77.3309 64.0364 77.9455 63.4691L91.8436 49.5236L77.9455 35.5782C77.3309 35.0109 77 34.2073 77 33.3091C77 31.4655 78.4182 30.0945 80.2618 30.0945C81.16 30.0945 81.9164 30.4255 82.5309 31.04L96.4764 44.9382L110.469 31.04C111.131 30.3309 111.887 30 112.738 30C114.535 30 116 31.4655 116 33.2618C116 34.16 115.716 34.8691 115.007 35.5309L101.062 49.5236L115.007 63.3745C115.622 64.0364 115.953 64.7927 115.953 65.7382C115.953 67.5345 114.535 69 112.691 69C111.745 69 110.942 68.6218 110.327 68.0073L96.4764 54.1091L82.5782 68.0073C82.0109 68.6218 81.16 69 80.2618 69Z\" fill=\"#DD2457\"/>\n</svg>";

var FilledFeedbackSuccess = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96 94C120.67 94 141 73.6333 141 48.9764C141 24.3667 120.623 4 96 4C71.3302 4 51 24.3667 51 48.9764C51 73.6333 71.3774 94 96 94ZM90.6517 72C89.3337 72 88.3452 71.4784 87.2626 70.1509L73.9414 53.8879C73.3766 53.1293 73 52.2285 73 51.3276C73 49.4785 74.4592 48.1034 76.1538 48.1034C77.2364 48.1034 78.1778 48.5302 79.1192 49.7155L90.4634 64.0819L111.881 29.8017C112.634 28.6164 113.669 28 114.658 28C116.353 28 118 29.1379 118 30.9871C118 31.6698 117.699 32.4133 117.313 33.0718L93.8525 70.1034C93.0052 71.3836 91.9226 72 90.6517 72Z\" fill=\"#1AAAAD\"/>\n</svg>";

var FilledFeedbackWarning = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96 93C120.122 93 140 73.0859 140 48.977C140 24.9141 120.075 5 96 5C71.8784 5 52 24.9141 52 48.977C52 73.0859 71.9245 93 96 93ZM96.7389 55.8153C98.7261 55.8153 99.949 54.5924 99.949 52.4013L100.561 26.7707C100.611 24.6306 98.9299 23 96.6879 23C94.3949 23 92.8153 24.5796 92.8662 26.7707L93.4268 52.4013C93.4777 54.5924 94.6497 55.8153 96.7389 55.8153ZM96.7389 71C94.1911 71 92 68.9108 92 66.414C92 63.8662 94.1401 61.828 96.7389 61.828C99.3376 61.828 101.478 63.8153 101.478 66.414C101.478 68.9618 99.2866 71 96.7389 71Z\" fill=\"#F8B518\"/>\n</svg>";

var GreyPeopleError = "<svg width=\"192\" height=\"100\" viewBox=\"0 0 192 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M169.505 75.1303C169.516 74.4759 169.493 73.8214 169.434 73.1695C169.046 68.599 166.518 63.3656 162.487 60.9135C158.554 58.5208 154.089 57.6639 149.834 56.0413C143.586 53.6427 138.226 49.3817 134.481 43.8356C130.532 37.9601 128.624 30.9991 126.206 24.3466C123.788 17.6942 120.58 10.964 114.907 6.73164C107.22 1.00243 96.0447 1.1921 87.7766 6.02777C82.0428 9.37572 77.5293 14.6502 71.5236 17.4816C64.1513 20.9576 54.5233 20.8616 49.5848 27.3404C46.3397 31.591 46.2506 37.4162 46.7671 42.7386C47.5783 51.0845 49.3723 60.9935 39.9661 64.8922C33.4301 67.7831 23.5006 69.7416 23.0389 76.746C22.399 86.4151 32.42 90.7845 40.27 92.807C53.4515 96.2029 67.4923 96.123 80.9984 95.6431C91.8558 95.2568 102.697 94.4478 113.566 94.3473C123.587 94.2559 133.677 94.7609 143.638 93.4789C154.665 92.0552 169.288 88.3118 169.505 75.1303Z\" fill=\"#F0F5FB\"/>\n<path d=\"M59.2114 61.0803L59.7119 21.6088C59.7119 21.506 59.6662 18.9876 61.179 17.4153C61.9263 16.6383 62.9295 16.2338 64.1499 16.2155C69.1341 16.1424 92.1378 16.1196 101.793 16.307L104.993 16.3732C113.905 16.5492 121.079 16.4783 122.589 16.5149C122.989 16.5149 123.389 16.5286 123.784 16.5332C126.41 16.5629 128.89 16.5926 130.293 18.0323C131.086 18.8436 131.461 20.0297 131.436 21.6568C131.367 26.8558 131.746 58.9755 131.772 61.0803H134.411C134.384 58.8887 133.972 24.8174 134.048 19.1933C134.071 17.5022 133.687 16.2772 132.875 15.4454C131.426 13.96 128.796 13.928 126.019 13.896C125.59 13.896 125.158 13.896 124.726 13.8754L119.724 13.7771C116.956 13.7246 113.359 13.8823 109.588 13.8068H109.488C97.5425 13.5783 65.8022 13.4435 61.5904 13.5052C60.3312 13.5235 59.3051 13.9348 58.5418 14.7278C56.9764 16.3527 57.0221 19.0699 57.0221 19.095L56.4805 61.0849L59.2114 61.0803Z\" fill=\"white\"/>\n<path d=\"M131.079 61.0619C131.054 58.9274 130.675 26.8351 130.743 21.6361C130.766 20.073 130.412 18.9395 129.662 18.1716C128.323 16.8005 125.889 16.7707 123.311 16.741C122.914 16.741 122.514 16.741 122.114 16.7228C120.592 16.6862 113.407 16.757 104.506 16.5834L101.306 16.5148C91.6488 16.3274 68.6542 16.3525 63.6677 16.4234C62.5045 16.4417 61.5561 16.821 60.8522 17.566C59.4056 19.0675 59.4468 21.5767 59.4468 21.6018L58.9463 61.0733L131.079 61.0619Z\" fill=\"white\"/>\n<path d=\"M52.8125 61.3042V62.3851C52.8131 63.2147 53.1429 64.0101 53.7295 64.5967C54.3161 65.1833 55.1115 65.5131 55.9411 65.5137H133.922C134.91 65.5125 135.857 65.1194 136.556 64.4207C137.255 63.7219 137.648 62.7746 137.649 61.7864V61.3042H52.8125Z\" fill=\"white\"/>\n<path d=\"M59.6224 61.1215L60.1206 22.043C60.1206 21.9402 60.0772 19.4447 61.5809 17.8884C62.3259 17.1183 63.3223 16.7183 64.5518 16.7C69.5086 16.6292 92.3934 16.6018 101.998 16.7869L105.182 16.8532C114.035 17.0268 121.179 16.9537 122.699 16.9903C123.094 16.9903 123.492 17.004 123.887 17.0086C126.499 17.0383 128.965 17.0657 130.361 18.4917C131.15 19.2984 131.524 20.4731 131.504 22.0819C131.435 27.2329 131.812 59.0487 131.837 61.1329H134.463C134.436 58.9641 134.027 25.2127 134.102 19.6435C134.125 17.9684 133.743 16.7549 132.937 15.9299C131.495 14.4582 128.878 14.4285 126.106 14.3988L124.819 14.3782C124.17 14.3622 122.347 14.3279 119.844 14.2799C117.102 14.2274 113.512 14.385 109.764 14.3096H109.663C97.7798 14.0811 66.204 13.9531 62.0151 14.0125C60.7628 14.0308 59.7298 14.4399 58.9825 15.2237C57.424 16.8349 57.4697 19.5224 57.4697 19.5498L56.9326 61.142L59.6224 61.1215Z\" fill=\"#EAF1F8\"/>\n<path d=\"M53.2461 61.599V62.6045C53.2461 64.2042 54.6424 65.5137 56.3587 65.5137H133.94C135.996 65.5137 137.649 63.9597 137.649 62.0469V61.5898L53.2461 61.599Z\" fill=\"#EAF1F8\"/>\n<path d=\"M56.3818 61.2036L56.9257 19.0927C56.9257 19.0927 56.7909 13.4571 61.6083 13.3794C65.667 13.32 95.0672 13.4137 109.51 13.6834H109.608C116.807 13.8296 123.373 13.7222 124.746 13.7542C129.465 13.8685 134.264 13.3337 134.187 19.1863C134.109 25.039 134.23 61.1511 134.23 61.1511\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M131.685 61.2035C131.685 61.2035 131.276 27.0818 131.349 21.668C131.422 16.2541 126.977 16.7455 122.607 16.6403C121.058 16.6038 113.871 16.6746 105.011 16.5009L101.811 16.4324C86.845 16.1421 68.5284 16.2793 64.1703 16.3433C59.714 16.4072 59.8283 21.6246 59.8283 21.6246L59.3232 61.2035\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M52.7002 61.1924H137.761V61.7866C137.761 62.8048 137.356 63.7813 136.636 64.5013C135.916 65.2213 134.94 65.6258 133.922 65.6258H55.9316C55.0737 65.6234 54.2518 65.2809 53.6461 64.6735C53.0403 64.066 52.7002 63.2432 52.7002 62.3853V61.1924V61.1924Z\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M68.4072 45.4351C69.8091 46.8109 71.5887 47.7384 73.5194 48.0997\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M65.918 44.562C65.918 44.562 68.5026 49.7085 74.7163 49.7473\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M102.565 85.9508L99.983 84.022L95.8558 84.0997V82.228L87.9053 82.2532V84.2459L80.958 84.3762V89.5569H80.9991V89.5684L81.2277 89.8129V95.213L83.3873 97.7269L102.172 97.1121V91.1407L102.719 91.1292L102.565 85.9508ZM95.6273 84.1042L88.1338 84.2437V82.4817L95.6273 82.4588V84.1042Z\" fill=\"white\"/>\n<path d=\"M83.2959 91.5589L87.2632 91.4835L87.2266 89.7192C87.2244 89.6422 87.2376 89.5656 87.2655 89.4938C87.2934 89.4219 87.3353 89.3564 87.3888 89.301C87.4985 89.1891 87.5397 89.2416 87.6951 89.2416H88.3327C88.6366 89.2416 88.8674 89.3719 88.8857 89.6781L89.0548 91.4515L97.1105 91.2961L97.0762 89.6621C97.074 89.5851 97.0872 89.5084 97.1151 89.4366C97.143 89.3648 97.1849 89.2993 97.2384 89.2439C97.2917 89.1887 97.3557 89.1449 97.4264 89.115C97.4971 89.0852 97.5731 89.0699 97.6498 89.0702H98.4359C98.7376 89.0702 98.829 89.3102 98.8473 89.6141L98.9478 91.2595L102.415 91.1955L102.291 86.417L83.2959 86.6775V91.5589Z\" fill=\"#EAF1F8\"/>\n<path d=\"M82.9302 91.7945L81.6367 90.3594V95.4236L83.481 97.5992L83.433 91.7854L82.9302 91.7945Z\" fill=\"#EAF1F8\"/>\n<path d=\"M99.0186 92.3546L98.9957 92.3866C98.2645 93.4218 98.2576 93.3007 98.1982 93.3007C98.0154 93.3007 97.556 92.8894 97.1629 92.4506L97.1332 92.4186L97.1149 91.5182L89.0525 91.6736L89.0959 92.4026L89.073 92.4369C88.3394 93.4721 88.2892 93.351 88.2298 93.351C88.0469 93.351 87.7064 92.9396 87.3156 92.4986L87.2859 92.4666L87.2699 91.6987L83.6592 91.7673L83.7095 97.7799L101.882 97.1788V91.4199L98.9683 91.4748L99.0186 92.3546Z\" fill=\"#EAF1F8\"/>\n<path d=\"M81.6368 90.019L83.0285 91.5639H83.0697V86.6139L81.3877 85.0439V89.7402L81.6048 89.9825H81.6368V90.019Z\" fill=\"#EAF1F8\"/>\n<path d=\"M102.067 86.1908L99.8869 84.5454L81.5566 84.8905L83.2249 86.4491L102.067 86.1908Z\" fill=\"#EAF1F8\"/>\n<path d=\"M81.2734 89.9824V95.4648L83.369 97.9124L101.987 97.3022V91.237\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M98.9613 91.3742L102.533 91.3079L102.401 86.3009L99.8937 84.4292L81.0195 84.7811V89.8499\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M89.002 91.5682L97.1627 91.4082\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M81.0195 89.7856L82.7449 91.6802L87.1784 91.5956\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M83.3164 91.6802L83.3692 97.9121\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M81.0195 84.7808L82.9506 86.5633L102.401 86.3005\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M82.9502 86.5635V91.6802\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M87.9668 85.327V82.6601L95.6911 82.6372V85.1442\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M87.2147 92.4365L87.1576 89.717C87.1551 89.6555 87.1651 89.5941 87.187 89.5365C87.2089 89.4789 87.2421 89.4264 87.2848 89.382C87.3275 89.3376 87.3787 89.3023 87.4354 89.2782C87.4921 89.254 87.5531 89.2417 87.6147 89.2417H88.4122C88.53 89.2416 88.6432 89.2869 88.7283 89.3682C88.8135 89.4495 88.864 89.5606 88.8693 89.6782L89.0361 92.3771C89.0361 92.3771 88.3277 93.3644 88.2134 93.3644C88.058 93.3644 87.2147 92.4365 87.2147 92.4365Z\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M97.1838 92.3794L97.1244 89.6599C97.1219 89.5984 97.1319 89.537 97.1538 89.4794C97.1757 89.4218 97.2089 89.3692 97.2516 89.3248C97.2943 89.2804 97.3455 89.2451 97.4022 89.221C97.4589 89.1969 97.5199 89.1845 97.5814 89.1846H98.379C98.4968 89.1845 98.61 89.2298 98.6951 89.3111C98.7803 89.3924 98.8308 89.5034 98.8361 89.6211L99.0006 92.32C99.0006 92.32 98.2945 93.3072 98.1802 93.3072C98.0248 93.3072 97.1838 92.3794 97.1838 92.3794Z\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M88.1035 93.3643C88.1035 93.3643 88.2521 93.7003 88.6977 93.2112C88.8953 92.9751 89.0705 92.7211 89.221 92.4525L89.1913 91.6229C89.1913 91.6229 89.1113 89.7947 88.9422 89.5273L89.0519 92.4411L88.2932 93.3552L88.1035 93.3643Z\" fill=\"#373E45\"/>\n<path d=\"M98.0723 93.3643C98.0723 93.3643 98.2208 93.7003 98.6664 93.2112C98.864 92.9751 99.0392 92.7211 99.1898 92.4525L99.1601 91.6229C99.1601 91.6229 99.0801 89.7947 98.911 89.5273L99.0184 92.4411L98.2619 93.3552L98.0723 93.3643Z\" fill=\"#373E45\"/>\n<path d=\"M87.1374 91.5981L83.3164 91.6736L83.3027 91.9958L87.1123 91.9112C87.1115 91.8063 87.1199 91.7016 87.1374 91.5981Z\" fill=\"#373E45\"/>\n<path d=\"M98.9746 91.3696C98.9893 91.4635 98.9893 91.5591 98.9746 91.653L100.945 91.6096C100.945 91.6096 101.941 91.5524 101.895 92.9807L101.948 91.3193L98.9746 91.3696Z\" fill=\"#373E45\"/>\n<path d=\"M97.279 91.6893C97.279 91.6664 97.279 91.6436 97.279 91.6207C97.279 91.5499 97.279 91.479 97.279 91.4082L88.9834 91.5705C88.9879 91.6336 88.9879 91.697 88.9834 91.7601C88.9834 91.783 88.9834 91.8058 88.9834 91.831C88.9845 91.8462 88.9845 91.8615 88.9834 91.8767L97.2744 91.6961L97.279 91.6893Z\" fill=\"#373E45\"/>\n<path d=\"M85.1328 95.9033V97.8527\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M86.6641 95.9033V97.8527\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M88.1973 95.9033V97.8527\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M89.7285 95.6475V97.5991\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M91.2598 95.6475V97.5991\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M92.791 95.6475V97.5991\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M94.3223 95.5791V97.5307\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M95.8555 95.6475V97.5991\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M97.3867 95.5791V97.5307\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M98.918 95.4736V97.423\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M100.449 95.4736V97.423\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M106.672 5.06096C105.955 3.8753 104.902 2.92951 103.646 2.34375\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M108.221 6.08934C108.221 6.08934 107.357 2.11979 103.118 1\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M103.381 18.6332C103.854 19.3187 104.663 20.4362 104.663 20.4362L103.201 22.493L103.116 22.6096L101.635 21.8463L101.132 21.588C100.261 22.2503 99.2507 22.7059 98.1775 22.9204L98.0473 24.776L96.0774 25.1051L95.4878 25.2034L94.7245 23.0118L94.7085 22.9638C94.4799 22.9249 94.2697 22.8815 94.0572 22.8289C94.0551 22.8301 94.0527 22.8308 94.0503 22.8308C94.0479 22.8308 94.0455 22.8301 94.0435 22.8289C93.6097 22.7278 93.1836 22.5965 92.7683 22.4359C92.5809 22.3627 92.398 22.285 92.2244 22.2073L90.8052 23.3111L90.5607 23.5008L88.593 21.7937L89.5277 20.0843C88.8879 19.2996 88.4144 18.3931 88.136 17.4197L85.9238 16.7866V14.5471L87.864 14.058C87.9354 13.2363 88.1105 12.427 88.3851 11.6493C88.4628 11.4916 88.5451 11.3385 88.6296 11.1923C88.1725 10.5364 87.2744 9.28176 87.2744 9.28176L88.8193 7.10159L89.4729 7.43982L91.148 8.30137C91.928 7.73002 92.8031 7.30138 93.7327 7.03532L93.8812 4.942L96.4407 4.51465L96.5801 4.91L97.1926 6.67653H97.3137C97.4394 6.67653 97.5651 6.6971 97.6908 6.71538C98.5809 6.83046 99.4419 7.11022 100.23 7.54037L101.749 6.41372L102.236 6.85707L103.681 8.16425L102.766 9.74567C103.339 10.53 103.759 11.4154 104.003 12.3555L105.998 12.9245V13.0571V15.1641C105.998 15.1641 104.949 15.4246 104.19 15.6211C104.084 16.4531 103.884 17.2703 103.594 18.0573C103.546 18.2561 103.463 18.448 103.381 18.6332Z\" fill=\"white\" stroke=\"white\" stroke-miterlimit=\"10\"/>\n<path d=\"M90.832 23.3365L91.2022 23.6541L92.7471 22.4566C92.5966 22.3305 92.4165 22.2448 92.2238 22.2075C92.1346 22.2784 91.2617 23.0394 90.832 23.3365Z\" fill=\"#373E45\"/>\n<path d=\"M103.61 18.0575C103.9 17.2705 104.1 16.4533 104.206 15.6214C104.965 15.4248 106.014 15.1643 106.014 15.1643L106.028 12.879C106.028 12.879 104.565 12.5362 104.554 12.5019L104.012 12.3465C103.766 11.4044 103.345 10.5173 102.769 9.73217L103.683 8.15075L102.239 6.84357L100.879 7.85138L100.84 7.83081C99.926 7.34176 99.0256 6.82529 98.0429 6.75444C98.0201 6.75444 97.9492 6.73616 97.9264 6.73616L97.8235 6.72016L97.1951 6.65617L96.5826 4.88965L94.5876 5.2233L94.4367 7.30977L94.3933 7.32119C93.4703 7.59093 92.6006 8.01766 91.8224 8.58267L91.7881 8.6101L91.1505 8.28101L89.4731 7.41718L87.9968 9.50136C88.1522 9.72989 88.9109 10.7903 89.3245 11.3753L89.3474 11.4096L89.3291 11.4484C89.2377 11.613 89.1554 11.7638 89.0869 11.9055C88.8151 12.676 88.6408 13.4775 88.5681 14.2913V14.337L88.5224 14.3507L86.6348 14.8421V16.9765L88.8355 17.6096L88.8469 17.6438C89.12 18.6084 89.5865 19.5072 90.2181 20.2856L90.2455 20.3199L89.3154 22.0224L90.8031 23.3114L90.8306 23.3365C91.443 22.9091 92.0212 22.3652 92.2657 22.2281L92.7662 22.4407L92.8508 22.3744L92.8896 22.3904C93.2596 22.5648 93.6414 22.7129 94.0322 22.8337C94.0343 22.8349 94.0367 22.8356 94.0391 22.8356C94.0415 22.8356 94.0439 22.8349 94.046 22.8337C94.2631 22.9023 94.4893 22.9617 94.7133 23.0165C94.9372 23.0714 95.136 23.108 95.3486 23.1445H95.3874L96.073 25.103L98.0429 24.7739L98.1732 22.9183C99.2464 22.7038 100.257 22.2482 101.128 21.586L101.631 21.8442C101.663 21.8213 101.649 21.8922 101.679 21.8693L101.738 21.899L103.109 22.6075L104.657 20.4273C104.657 20.4273 103.848 19.3007 103.375 18.6242C103.464 18.4483 103.546 18.2563 103.61 18.0575Z\" fill=\"#B6C5D5\"/>\n<path d=\"M98.8035 23.1058L98.7509 23.1172L98.6184 24.966L96.1708 25.3774L96.0771 25.1123L98.0471 24.7832L98.1773 22.9275C99.2505 22.7131 100.261 22.2575 101.132 21.5952L101.635 21.8535C100.793 22.4718 99.8271 22.8991 98.8035 23.1058Z\" fill=\"#373E45\"/>\n<path d=\"M103.963 18.926C104.382 19.5271 105.07 20.4869 105.216 20.6925L103.735 22.7859L103.2 22.5116L104.663 20.4549C104.663 20.4549 103.854 19.3282 103.381 18.6518C103.463 18.4667 103.538 18.2747 103.609 18.0759C103.899 17.289 104.099 16.4717 104.206 15.6398C104.964 15.4432 106.013 15.1827 106.013 15.1827V13.0757L106.58 13.2402V15.3747L104.823 15.8157H104.779V15.8614C104.674 16.6884 104.476 17.5009 104.19 18.2839C104.121 18.4781 104.043 18.6701 103.961 18.8552L103.945 18.8917L103.963 18.926Z\" fill=\"#373E45\"/>\n<path d=\"M104.553 12.5109L104.012 12.3555C103.766 11.4134 103.344 10.5263 102.768 9.74114L103.683 8.15972L102.238 6.85254L104.231 8.41339L103.317 9.98567L103.342 10.0222C103.895 10.7703 104.306 11.614 104.553 12.5109Z\" fill=\"#373E45\"/>\n<path d=\"M96.0914 20.2972C97.1425 20.372 98.1922 20.1336 99.1079 19.6122C100.024 19.0907 100.764 18.3097 101.236 17.3675C101.708 16.4254 101.891 15.3645 101.76 14.3189C101.63 13.2732 101.192 12.2897 100.503 11.4924C99.8142 10.6952 98.9043 10.1201 97.8885 9.83969C96.8727 9.55928 95.7966 9.58617 94.7961 9.91696C93.7956 10.2478 92.9156 10.8676 92.2671 11.6983C91.6187 12.5289 91.2309 13.5331 91.1528 14.5839C91.1018 15.2834 91.189 15.986 91.4096 16.6518C91.6302 17.3175 91.9798 17.9332 92.4384 18.4638C92.897 18.9943 93.4557 19.4293 94.0825 19.7439C94.7093 20.0585 95.3919 20.2465 96.0914 20.2972Z\" fill=\"white\"/>\n<path d=\"M103.381 18.6332C103.854 19.3187 104.663 20.4362 104.663 20.4362L103.201 22.493L103.116 22.6096L101.635 21.8463L101.132 21.588C100.261 22.2503 99.2507 22.7059 98.1775 22.9204L98.0473 24.776L96.0774 25.1051L95.4878 25.2034L94.7245 23.0118L94.7085 22.9638C94.4799 22.9249 94.2697 22.8815 94.0572 22.8289C94.0551 22.8301 94.0527 22.8308 94.0503 22.8308C94.0479 22.8308 94.0455 22.8301 94.0435 22.8289C93.6097 22.7278 93.1836 22.5965 92.7683 22.4359C92.5809 22.3627 92.398 22.285 92.2244 22.2073L90.8052 23.3111L90.5607 23.5008L88.593 21.7937L89.5277 20.0843C88.8879 19.2996 88.4144 18.3931 88.136 17.4197L85.9238 16.7866V14.5471L87.864 14.058C87.9354 13.2363 88.1105 12.427 88.3851 11.6493C88.4628 11.4916 88.5451 11.3385 88.6296 11.1923C88.1726 10.5364 87.2744 9.28176 87.2744 9.28176L88.8193 7.10159L89.4729 7.43982L91.148 8.30137C91.928 7.73002 92.8031 7.30138 93.7327 7.03532L93.8812 4.942L96.4407 4.51465L96.5801 4.91L97.1926 6.67653H97.3137C97.4394 6.67653 97.5651 6.6971 97.6908 6.71538C98.5809 6.83046 99.4419 7.11022 100.23 7.54037L101.749 6.41372L102.236 6.85707L103.681 8.16425L102.766 9.74567C103.339 10.53 103.759 11.4154 104.003 12.3555L105.998 12.9245V13.0571V15.1641C105.998 15.1641 104.949 15.4246 104.19 15.6211C104.084 16.4531 103.884 17.2703 103.594 18.0573C103.546 18.2561 103.463 18.448 103.381 18.6332Z\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M95.9652 17.1023C97.2059 17.1023 98.2116 16.0965 98.2116 14.8558C98.2116 13.6151 97.2059 12.6094 95.9652 12.6094C94.7245 12.6094 93.7188 13.6151 93.7188 14.8558C93.7188 16.0965 94.7245 17.1023 95.9652 17.1023Z\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M95.9656 20.2558C98.948 20.2558 101.366 17.8381 101.366 14.8557C101.366 11.8733 98.948 9.45557 95.9656 9.45557C92.9832 9.45557 90.5654 11.8733 90.5654 14.8557C90.5654 17.8381 92.9832 20.2558 95.9656 20.2558Z\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M96.852 9.6545C96.852 9.6545 93.1109 9.38484 91.5455 12.9316C89.9801 16.4784 92.9304 19.351 94.3381 19.9543C94.3381 19.9543 90.7777 19.0813 90.5674 14.9518C90.3572 10.8223 94.4158 9.09918 96.852 9.6545Z\" fill=\"#373E45\"/>\n<path d=\"M73.4346 44.4544L73.9145 44.7081L75.2857 43.0238C75.0903 42.9257 74.8735 42.8778 74.6549 42.8844C74.5841 42.9827 73.8368 44.0225 73.4346 44.4544Z\" fill=\"#373E45\"/>\n<path d=\"M85.9927 35.5536C86.1118 34.6273 86.1256 33.6904 86.0339 32.761C86.8086 32.361 87.8827 31.8171 87.8827 31.8171L87.3319 29.3445C87.3319 29.3445 85.6614 29.333 85.6385 29.2988L85.0123 29.2645C84.5126 28.3031 83.8348 27.4454 83.015 26.737L83.6137 24.7922L81.7215 23.7249L80.4966 25.1578L80.4486 25.1441C79.3448 24.8379 78.2319 24.5042 77.1487 24.6711C77.1235 24.6711 77.039 24.6711 77.0138 24.6711H76.8996L76.214 24.7579L75.1102 22.9937L73.0283 23.8506L73.3802 26.1748L73.3345 26.1999C72.3991 26.7207 71.561 27.3996 70.8573 28.2064L70.8276 28.243L70.0528 28.0441L68.0189 27.5231L66.9334 30.1535C67.162 30.3523 68.2543 31.3235 68.8394 31.856L68.8736 31.888L68.8622 31.9337C68.8028 32.1371 68.7525 32.3199 68.7137 32.4936C68.6096 33.397 68.6196 34.3099 68.7434 35.2108V35.2634L68.6954 35.2885C68.0098 35.6382 67.0066 36.1501 66.7666 36.2712L67.3014 38.5862L69.8472 38.7256L69.8677 38.7621C70.407 39.737 71.1386 40.5923 72.0182 41.276L72.0593 41.3079L71.472 43.3853L73.4054 44.4159L73.4419 44.4365C74.0018 43.8195 74.4909 43.0859 74.724 42.8779L75.3204 42.9831L75.3959 42.8894H75.4416C75.8898 42.9856 76.3441 43.0505 76.8013 43.0836H76.8082C77.0618 43.1042 77.3201 43.1133 77.5783 43.1156C77.8365 43.1179 78.0582 43.1156 78.2982 43.0973H78.3439L79.5665 45.0535L81.6233 44.208L81.3056 42.1512C82.4167 41.6518 83.3998 40.9063 84.1805 39.9711L84.7907 40.1265C84.8204 40.0945 84.8204 40.1744 84.8478 40.1425L84.9209 40.1607L86.5892 40.5881L87.7318 37.8457C87.7318 37.8457 86.5755 36.8242 85.9036 36.2072C85.9287 36.0129 85.9653 35.7867 85.9927 35.5536Z\" fill=\"#F0F5FB\"/>\n<path d=\"M82.028 42.2353L81.9754 42.2605L82.2931 44.2921L79.7381 45.3456L79.5713 45.0805L81.628 44.235L81.3104 42.1782C82.4215 41.6788 83.4046 40.9333 84.1853 39.998L84.7955 40.1534C84.0374 41.0426 83.0924 41.7535 82.028 42.2353Z\" fill=\"#373E45\"/>\n<path d=\"M86.5889 36.3966C87.1922 36.9428 88.1772 37.8135 88.3875 37.9963L87.2974 40.6358L86.6506 40.4713L87.7247 37.8683C87.7247 37.8683 86.5684 36.8468 85.8965 36.2298C85.9376 36.0013 85.9742 35.7727 86.0016 35.5442C86.1207 34.6179 86.1345 33.681 86.0427 32.7516C86.8175 32.3516 87.8915 31.8077 87.8915 31.8077L87.3636 29.5225L88.0195 29.559L88.5566 31.874L86.7603 32.7881L86.7146 32.8133V32.8636C86.8052 33.7877 86.7922 34.719 86.6758 35.6402C86.6483 35.8687 86.6118 36.0972 86.5706 36.3258V36.3692L86.5889 36.3966Z\" fill=\"#373E45\"/>\n<path d=\"M85.6387 29.2984L85.0125 29.2641C84.5128 28.3028 83.835 27.4451 83.0152 26.7366L83.6139 24.7918L81.7217 23.7246L84.2743 24.929L83.6825 26.8623L83.719 26.8943C84.5011 27.571 85.1518 28.386 85.6387 29.2984Z\" fill=\"#373E45\"/>\n<path d=\"M78.3849 39.8429C79.5469 39.6644 80.6298 39.1453 81.4965 38.3512C82.3633 37.557 82.9751 36.5236 83.2544 35.3817C83.5337 34.2398 83.468 33.0407 83.0656 31.9362C82.6632 30.8316 81.9421 29.8713 80.9938 29.1766C80.0454 28.482 78.9123 28.0842 77.7378 28.0338C76.5633 27.9833 75.4002 28.2824 74.3958 28.8932C73.3913 29.5039 72.5906 30.3989 72.095 31.4649C71.5993 32.5309 71.431 33.7199 71.6114 34.8816C71.8528 36.4372 72.7018 37.8333 73.9718 38.7635C75.2417 39.6937 76.829 40.082 78.3849 39.8429Z\" fill=\"white\"/>\n<path d=\"M85.8875 36.2344C86.5731 36.8514 87.7157 37.8729 87.7157 37.8729L86.6416 40.4759L86.5799 40.6244L84.7814 40.1674L84.1712 40.012C83.3906 40.9472 82.4075 41.6927 81.2964 42.1921L81.614 44.2489L79.5573 45.0944L78.9402 45.3481L77.569 43.1588L77.5393 43.1108C77.2903 43.1245 77.0434 43.1314 76.7989 43.1268H76.7829C76.2873 43.1247 75.7925 43.088 75.302 43.0171C75.0735 42.9851 74.8633 42.9463 74.653 42.9006L73.387 44.45L73.1699 44.7151L70.6104 43.3439L71.2 41.2574C70.3113 40.5647 69.5727 39.6985 69.0289 38.7116L66.4694 38.5722L65.9072 36.143C65.9072 36.143 67.1093 35.5328 67.8909 35.1306C67.7652 34.2214 67.7545 33.3001 67.8589 32.3882C67.9046 32.1986 67.9548 32.0112 68.0097 31.8238C67.3515 31.225 66.0626 30.087 66.0626 30.087L67.2053 27.3446L68.0006 27.548L70.0322 28.0668C70.7389 27.2551 71.5819 26.573 72.5231 26.0511L72.1781 23.7247L74.8496 22.6255L75.0987 23.0208L76.2025 24.7851L76.335 24.7622C76.4744 24.7417 76.6138 24.7234 76.7532 24.712C77.7514 24.6148 78.7589 24.7047 79.7241 24.977L81.0953 23.3773L81.7214 23.7247L83.6136 24.7851L83.0149 26.7299C83.8347 27.4383 84.5125 28.296 85.0122 29.2574L87.3204 29.3808L87.3547 29.5248L87.8826 31.8101C87.8826 31.8101 86.8085 32.354 86.0338 32.7539C86.1255 33.6833 86.1117 34.6202 85.9926 35.5465C85.9652 35.7865 85.9286 36.0127 85.8875 36.2344Z\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M76.8995 36.4768C78.2803 36.4768 79.3996 35.3574 79.3996 33.9767C79.3996 32.5959 78.2803 31.4766 76.8995 31.4766C75.5187 31.4766 74.3994 32.5959 74.3994 33.9767C74.3994 35.3574 75.5187 36.4768 76.8995 36.4768Z\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M76.8993 39.989C80.22 39.989 82.9119 37.2971 82.9119 33.9765C82.9119 30.6558 80.22 27.9639 76.8993 27.9639C73.5786 27.9639 70.8867 30.6558 70.8867 33.9765C70.8867 37.2971 73.5786 39.989 76.8993 39.989Z\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M76.5791 28.1104C76.5791 28.1104 72.4518 28.748 71.6337 32.9849C70.8156 37.2218 74.7303 39.6122 76.4077 39.9116C76.4077 39.9116 72.3261 39.8499 71.0715 35.421C69.8169 30.9921 73.7864 28.1035 76.5791 28.1104Z\" fill=\"#373E45\"/>\n<path d=\"M145.193 69.9769C144.93 67.527 143.082 64.9492 139.846 62.5268C139.402 62.1932 138.678 61.6127 137.581 60.7215C136.731 60.0359 135.67 59.1766 134.382 58.1436C134.659 58.0849 134.932 58.0086 135.2 57.9151C135.904 57.6771 136.546 57.2848 137.08 56.7668C137.613 56.2489 138.024 55.6184 138.283 54.9214C138.453 54.4687 138.57 53.9979 138.632 53.5182H138.605C138.765 51.6214 138.148 49.1053 136.879 46.8246C135.405 44.176 132.994 42.8094 130.874 42.2083L130.659 42.1649C130.202 42.0438 129.745 41.9364 129.32 41.8701H129.091C128.746 41.8198 128.426 41.8038 128.138 41.7787C127.687 41.7411 127.234 41.7281 126.781 41.7399V39.4728C127.024 39.4266 127.252 39.3207 127.445 39.1648C127.638 39.0089 127.789 38.8078 127.884 38.5793C127.895 38.5523 127.904 38.5249 127.912 38.497C128.006 38.401 128.826 37.5281 128.773 36.5248C128.719 35.3822 127.859 34.6349 127.13 34.3355C126.264 33.9767 125.739 34.2692 125.531 34.4406C125.442 34.353 125.348 34.2721 125.247 34.1984C125.035 34.0381 124.786 33.9341 124.522 33.8962C124.259 33.8582 123.99 33.8875 123.741 33.9813C123.57 34.0288 123.413 34.1192 123.287 34.244C123.16 34.3687 123.067 34.5237 123.017 34.6943C122.788 35.5307 123.643 36.6916 123.867 36.9796C123.638 37.3795 123.063 38.8672 123.499 39.6717C123.565 39.7936 123.656 39.9003 123.766 39.9849C123.876 40.0696 124.002 40.1302 124.137 40.163L123.938 41.8107C123.588 41.7947 123.252 41.7558 122.939 41.765C122.535 41.7787 122.132 41.765 121.774 41.8175H121.673L121.689 41.9295L121.673 41.8175L121.582 41.749C121.582 41.7604 121.566 41.7718 121.568 41.8404C121.2 41.8953 120.848 41.9775 120.53 42.0575L120.345 42.0826C119.019 42.4266 117.826 43.1578 116.917 44.1828L113.419 41.3788C113.647 40.972 114.541 39.37 114.63 37.9737C114.838 34.7743 113.787 33.0398 113.154 32.297C112.15 30.8267 110.764 29.6582 109.145 28.9171C104.266 26.5701 101.318 28.8508 101.288 28.8737L101.183 28.9582L107.598 34.724L107.273 39.0935L102.493 39.2283L96.6903 33.6339L96.6149 33.7482C96.5806 33.803 93.1344 39.1918 98.3403 43.8697C99.4938 44.9478 100.872 45.7564 102.376 46.2373C103.615 46.7349 104.957 46.9171 106.284 46.7676C107.61 46.618 108.878 46.1413 109.975 45.3803L111.25 46.9092C111.22 47.044 111.193 47.1857 111.165 47.3319C110.914 48.6414 110.727 52.4898 112.843 54.5557C113.775 55.4699 115.03 55.9269 116.588 55.9269C116.865 55.9269 117.153 55.9086 117.448 55.8812C116.883 58.0065 113.926 69.5404 113.613 78.6884C113.469 82.8865 113.531 86.0996 113.574 88.4443C113.638 91.7465 113.672 93.5656 113.067 94.338C112.851 94.6027 112.609 94.8461 112.347 95.0648C112.077 95.2933 111.789 95.5081 111.51 95.7138C110.644 96.3605 109.824 96.9707 109.911 97.798C109.936 98.0608 110.155 98.2687 110.562 98.4218C111.152 98.6504 112.134 98.7304 113.147 98.7304C114.76 98.7304 116.451 98.5018 116.751 98.2207C116.904 98.0768 117.546 95.6087 118.391 92.119C118.444 92.0962 118.494 92.0756 118.545 92.0505C120.204 85.0415 122.74 73.695 124.029 67.847C124.091 68.0938 130.199 92.343 130.389 94.0044C130.492 94.9185 130.259 95.6567 130.051 96.3125C129.877 96.861 129.729 97.3363 129.804 97.8025C129.946 98.6892 130.988 99 132.117 99C132.387 98.9992 132.656 98.9824 132.924 98.9498C134.169 98.8035 134.946 98.479 135.234 97.9854C135.314 97.8347 135.356 97.6668 135.356 97.4963C135.356 97.3258 135.314 97.1579 135.234 97.0073C135.101 96.7048 134.949 96.4116 134.777 96.1297C134.407 95.499 134.091 94.9528 134.066 93.5748C134.066 93.0811 134.128 91.518 134.226 89.3333C134.32 87.2239 134.441 84.5044 134.535 81.6958C134.752 78.6244 134.9 75.8592 134.688 73.9258C134.688 73.7339 134.688 73.5465 134.688 73.3591C136.761 74.7828 138.783 75.569 140.513 75.569H140.554C141.192 75.5832 141.825 75.4557 142.407 75.1957C142.99 74.9357 143.507 74.5496 143.923 74.0652C144.407 73.5097 144.771 72.8591 144.989 72.1551C145.208 71.4511 145.278 70.7092 145.193 69.9769Z\" fill=\"white\"/>\n<path d=\"M120.288 46.973L129.637 54.4276C130.716 54.4619 132.272 54.2334 132.953 53.5912C131.324 50.1861 130.711 47.1924 130.574 45.3642C130.486 44.2932 130.523 43.2155 130.686 42.1533C130.234 42.0293 129.777 41.9278 129.315 41.8494L129.086 47.2449L122.4 47.0827V47.0073C121.828 43.3188 121.662 42.151 121.625 41.8174C121.256 41.8737 120.891 41.95 120.53 42.0459C120.731 43.8467 120.322 46.7376 120.288 46.973Z\" fill=\"#EAF1F8\"/>\n<path d=\"M120.342 42.0552C118.991 42.4035 117.779 43.159 116.871 44.2193L120.198 46.9C120.274 46.3492 120.546 43.6777 120.342 42.0552Z\" fill=\"#F0F5FB\"/>\n<path d=\"M124.941 44.0454C126.372 44.4773 127.912 43.2478 128.14 41.7601C127.684 41.7219 127.227 41.7089 126.769 41.7213V42.3223H126.589V39.2646H126.669C126.669 39.2646 127.443 39.164 127.704 38.5059C127.73 38.4588 127.744 38.4056 127.744 38.3516C127.744 38.2976 127.73 38.2445 127.704 38.1974C127.558 37.9917 127.082 37.9688 126.886 37.9688V38.0008L126.726 37.8111C126.714 37.7974 125.702 36.5977 124.831 36.5977H124.795C124.653 36.6047 124.516 36.6461 124.394 36.7182C124.272 36.7902 124.17 36.8908 124.095 37.0113L124.07 37.0479C123.924 37.2764 123.245 38.9104 123.739 39.6325C124.045 40.0896 124.751 40.1193 125.839 39.7491L125.899 39.9205C125.473 40.0783 125.025 40.1656 124.571 40.1787C124.494 40.1777 124.418 40.1724 124.342 40.1627L124.098 42.1829L123.92 42.16L123.963 41.7944C123.606 41.7807 123.277 41.7396 122.941 41.7487C123.051 42.8136 123.995 43.7278 124.941 44.0454Z\" fill=\"white\"/>\n<path d=\"M128.143 41.751C127.914 43.2478 126.372 44.4773 124.944 44.0363C123.997 43.7186 123.054 42.8045 122.942 41.751C122.53 41.767 122.121 41.751 121.758 41.8058C121.833 42.3589 122.331 45.5697 122.539 46.9089L128.897 47.0643L129.126 41.8447C128.765 41.7921 128.438 41.7784 128.143 41.751Z\" fill=\"#F0F5FB\"/>\n<path d=\"M133.177 53.406C133.405 53.1454 133.499 52.8186 133.634 52.3616C134.223 52.3159 137.025 52.3319 138.595 53.6162C138.787 51.7103 138.165 49.1416 136.876 46.8198C135.396 44.1597 132.966 42.7931 130.841 42.1943C130.724 42.9142 130.222 47.6425 133.033 53.5614C133.058 53.5408 133.156 53.4334 133.177 53.406Z\" fill=\"#F0F5FB\"/>\n<path d=\"M126.87 37.7838C127.025 37.7838 127.62 37.7838 127.834 38.0832C127.861 38.1198 127.88 38.1608 127.892 38.2043C128.132 37.9118 128.605 37.2445 128.577 36.5292C128.527 35.4894 127.727 34.797 127.06 34.5205C126.28 34.1982 125.826 34.4633 125.661 34.5982C126.459 35.5008 126.877 37.0366 126.877 37.7496L126.87 37.7838Z\" fill=\"#EAF1F8\"/>\n<path d=\"M124.772 36.4151H124.815C125.551 36.4151 126.333 37.1419 126.673 37.5006C126.582 36.6162 126.059 35.028 125.133 34.3675C124.947 34.2245 124.728 34.1315 124.496 34.0975C124.264 34.0635 124.027 34.0896 123.808 34.1733C123.668 34.2091 123.541 34.28 123.437 34.3792C123.333 34.4784 123.256 34.6026 123.213 34.74C123.019 35.4507 123.769 36.502 124.006 36.8128C124.097 36.6947 124.213 36.5979 124.345 36.5292C124.477 36.4605 124.623 36.4216 124.772 36.4151Z\" fill=\"#EAF1F8\"/>\n<path d=\"M133.925 91.9748C133.952 91.2618 133.991 90.3591 134.037 89.3193C134.309 83.0667 135.198 76.4006 134.574 73.1212L134.194 68.1507L118.979 55.625L118.017 55.7484C117.416 57.8852 117.135 59.0689 117.048 59.8619C115.985 64.5331 114.463 72.2162 114.246 78.695C114.107 82.8885 114.166 86.097 114.212 88.4394C114.239 89.9477 114.262 91.1269 114.225 92.0479C114.63 92.1828 116.945 92.8935 118.538 92.0479C120.247 84.8287 122.88 73.0046 124.139 67.3302L124.02 66.8732C123.76 66.6949 122.121 65.422 122.704 61.5759L122.88 61.6056C122.286 65.5454 124.114 66.7224 124.141 66.7338L124.173 66.7521L124.445 67.7919C124.656 68.6489 128.94 86.0102 130.284 92.0342C130.632 92.1211 132.478 92.5393 133.925 91.9748Z\" fill=\"#EAF1F8\"/>\n<path d=\"M130.283 96.2279C130.428 96.2386 130.572 96.2032 130.695 96.1268C130.819 96.0505 130.914 95.937 130.969 95.8028C131.108 95.4029 131.506 95.1172 132.057 95.0144C132.71 94.8956 133.428 95.067 133.711 95.4143C134.155 95.9445 134.324 96.0222 134.452 95.9765C134.143 95.4257 133.878 94.8133 133.858 93.5747C133.858 93.3461 133.869 92.8457 133.896 92.1623C133.348 92.3453 132.774 92.4364 132.196 92.432C131.523 92.4301 130.853 92.3308 130.208 92.1372C130.437 93.0902 130.562 93.7369 130.587 93.9769C130.653 94.7404 130.549 95.509 130.283 96.2279Z\" fill=\"white\"/>\n<path d=\"M135.048 97.0827C134.914 96.7885 134.761 96.5031 134.591 96.228L134.534 96.132C134.248 96.2577 133.983 96.0315 133.567 95.531C133.318 95.2362 132.667 95.0876 132.082 95.195C131.597 95.2819 131.25 95.5264 131.131 95.8646C131.061 96.0378 130.938 96.1843 130.78 96.2829C130.621 96.3815 130.435 96.4271 130.249 96.4131H130.222C130.062 96.9204 129.929 97.3592 129.993 97.7683C130.146 98.7213 131.648 98.8904 132.886 98.7441C134.052 98.607 134.799 98.3076 135.046 97.878C135.111 97.7557 135.145 97.6192 135.146 97.4806C135.146 97.342 135.113 97.2054 135.048 97.0827Z\" fill=\"#373E45\"/>\n<path d=\"M113.748 96.4904C113.334 96.3007 113.101 96.0585 113.108 95.8277C113.113 95.778 113.106 95.7278 113.087 95.6813C113.069 95.6348 113.04 95.5933 113.003 95.5603C112.808 95.3866 112.376 95.4072 112.205 95.43C112.013 95.5831 111.819 95.7294 111.629 95.8734C110.774 96.5087 110.029 97.0594 110.107 97.7702C110.125 97.9461 110.297 98.097 110.619 98.2272C112.123 98.794 116.225 98.4306 116.604 98.0741C116.677 97.9804 116.876 97.2971 117.166 96.1864C116.607 96.5981 115.928 96.8141 115.233 96.8012C114.722 96.8008 114.216 96.695 113.748 96.4904Z\" fill=\"#373E45\"/>\n<path d=\"M113.784 92.1392C113.732 93.2818 113.581 94.0017 113.222 94.4587C112.999 94.735 112.749 94.9884 112.475 95.2152L112.452 95.2334C112.691 95.2181 112.928 95.285 113.124 95.4231C113.181 95.4745 113.226 95.5383 113.254 95.6096C113.283 95.6809 113.295 95.7579 113.289 95.8345C113.289 95.9807 113.494 96.1727 113.823 96.3235C114.582 96.6709 116.177 96.8537 117.251 95.8665C117.503 94.8952 117.811 93.6452 118.165 92.21C117.561 92.4932 116.9 92.6362 116.232 92.6282C115.393 92.6198 114.563 92.4539 113.784 92.1392Z\" fill=\"white\"/>\n<path d=\"M124.006 36.9565C123.885 37.0525 122.037 41.134 125.853 39.836\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M124.262 40.0576L124.006 42.1738\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M126.842 37.875C126.842 37.875 128.063 37.811 127.779 38.5309C127.496 39.2507 126.671 39.349 126.671 39.349V42.3199\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M117.646 55.5586C117.646 55.5586 114.07 68.5162 113.723 78.6857C113.375 88.8552 114.228 93.0305 113.151 94.4016C112.932 94.6741 112.686 94.923 112.415 95.1443C111.307 96.0859 109.915 96.7692 110.018 97.7793C110.144 99.0385 116.159 98.6088 116.666 98.1312C117.173 97.6536 124.006 67.3233 124.006 67.3233\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M120.229 46.9343C120.229 46.9343 120.686 43.9314 120.407 42.0552\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M130.766 42.1738C130.766 42.1738 129.815 46.9866 132.998 53.6003\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M121.673 41.8057C121.655 41.8057 122.459 46.9978 122.459 46.9978L128.981 47.1578L129.21 41.8468\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M124.006 36.9563C124.006 36.9563 122.109 34.6711 123.777 34.086C125.702 33.4004 126.778 36.5998 126.778 37.7425C126.778 37.7493 124.977 35.592 124.006 36.9563Z\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M125.512 34.6094C125.512 34.6094 126.019 33.9946 127.086 34.4357C127.879 34.7625 128.611 35.5235 128.659 36.5244C128.707 37.5254 127.82 38.4212 127.82 38.4212\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M122.537 61.5874C121.906 65.6575 123.872 66.8116 123.872 66.8116L124.137 67.8148C124.137 67.8148 130.307 92.2971 130.501 93.9859C130.695 95.6748 129.756 96.7923 129.914 97.7795C130.072 98.7667 131.546 98.9907 132.908 98.833C134.27 98.6753 135.638 98.2274 135.131 97.0482C134.624 95.869 133.988 95.5491 133.952 93.5723C133.915 91.5955 135.124 72.5339 134.27 68.1347\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M116.595 59.7751C117.318 59.5974 117.995 59.2654 118.578 58.802C119.162 58.3385 119.638 57.7545 119.975 57.0898\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M113.695 92.105C113.695 92.105 116.438 93.0899 118.266 92.105\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M130.105 92.1048C130.105 92.1048 132.311 92.715 133.99 92.0386\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M117.959 54.7382L113.88 49.7632C113.889 49.8035 113.9 49.8432 113.914 49.882C113.954 50.0173 114.013 50.1465 114.088 50.2659L113.935 50.3665C113.77 50.0986 113.673 49.794 113.654 49.4798C113.597 48.8216 113.8 48.0218 114.255 47.1717C114.464 46.7986 114.693 46.437 114.94 46.0884C115.382 45.4508 115.797 44.8475 115.67 44.5161C115.627 44.4402 115.567 44.3756 115.494 44.3279C115.421 44.2801 115.338 44.2506 115.251 44.2419C114.933 44.1971 114.608 44.248 114.319 44.3882C113.783 44.6302 113.279 44.9372 112.817 45.3023L112.493 45.5651L112.68 45.1926C112.817 44.9184 112.971 44.4773 112.877 44.3516C112.852 44.3196 112.801 44.3105 112.724 44.3242C112.173 44.4247 111.741 45.396 111.353 47.3796C111.108 48.6525 110.921 52.3958 112.952 54.4023C114.209 55.6409 116.099 56.002 118.565 55.5038L117.959 54.7382Z\" fill=\"white\"/>\n<path d=\"M143.797 73.9028C140.913 77.2439 135.147 74.5884 130.515 69.3528C128.111 66.6379 122.619 60.2597 117.96 54.727C116.513 53.0107 115.144 51.379 113.974 49.9645L113.915 49.8708L113.654 49.4685C113.597 48.8104 113.8 48.0105 114.255 47.1604C114.464 46.7873 114.693 46.4257 114.941 46.0772C115.382 45.4396 115.798 44.8363 115.67 44.5049C115.631 44.4147 115.572 44.3345 115.498 44.2704C115.423 44.2063 115.335 44.1599 115.24 44.1347C114.973 44.0707 114.166 44.3015 113.787 44.5323C113.407 44.7631 112.941 44.9894 112.681 45.3002C112.733 45.0717 112.909 44.7791 112.987 44.5506C112.983 44.4442 112.959 44.3395 112.916 44.2421C112.877 44.1438 112.573 44.2421 112.459 44.3198C112.057 44.5483 111.86 45.1128 111.73 45.5241C111.63 45.8076 111.546 46.0968 111.481 46.3903C111.463 46.5137 111.41 46.7262 111.396 46.8473C110.987 46.356 110.069 45.3025 110.069 45.3025C110.069 45.3025 104.938 49.4 99.0992 44.121C93.9962 39.5047 97.3167 34.4725 97.3167 34.4725L102.692 39.6578L107.799 39.7812L108.256 34.6347L102.107 29.3443C102.107 29.3443 105.059 26.8305 109.753 29.3443C113.449 31.3188 116.017 36.2002 113.097 41.2644L130.165 54.7476L134.206 58.0612L134.345 58.1778C137.316 60.5659 139.067 62.0239 139.862 62.6204C146.149 67.3418 145.778 71.6084 143.797 73.9028Z\" fill=\"#B6C5D5\"/>\n<path d=\"M121.227 52.6632C121.171 52.7048 121.125 52.7593 121.094 52.8221C121.063 52.8849 121.048 52.9542 121.049 53.0243C121.049 53.655 121.881 53.9978 123.151 54.5189C123.855 54.8068 124.653 55.1336 125.535 55.5952L125.878 55.7758C128.417 57.1058 131.895 58.9295 135.158 57.8142C135.848 57.5818 136.478 57.1978 137 56.6904C137.522 56.1831 137.925 55.5652 138.177 54.8822C138.355 54.4589 138.48 54.0152 138.55 53.5613C137.034 52.2244 134.093 52.3273 133.613 52.3638C133.562 52.7435 133.411 53.1028 133.177 53.4059C132.288 54.528 130.364 54.5486 128.906 54.3566C127.077 54.1281 125.773 52.9237 124.989 52.2061C124.807 52.0111 124.598 51.844 124.367 51.7102C124.305 51.6942 124.287 51.7102 124.28 51.7102C124.173 51.8199 124.257 52.3295 124.349 52.6381L124.395 52.7957L124.239 52.7523C124.216 52.7478 121.917 52.1376 121.227 52.6632Z\" fill=\"white\"/>\n<path d=\"M133.613 52.3638C133.562 52.7435 133.411 53.1028 133.177 53.4059C132.288 54.528 130.364 54.5486 128.906 54.3566C127.077 54.1281 125.773 52.9237 124.989 52.2061C124.807 52.0111 124.598 51.844 124.367 51.7102C124.305 51.6942 124.287 51.7102 124.28 51.7102C124.173 51.8199 124.257 52.3295 124.349 52.6381L124.395 52.7957L124.239 52.7523C124.216 52.7523 121.917 52.1284 121.227 52.6541C121.171 52.6956 121.125 52.7501 121.094 52.8129C121.063 52.8758 121.048 52.9451 121.049 53.0151C121.049 53.6459 121.881 53.9887 123.151 54.5097C123.855 54.7977 124.653 55.1245 125.535 55.5861L125.878 55.7666C128.417 57.0967 131.895 58.9203 135.158 57.8051C135.848 57.5726 136.478 57.1887 137 56.6813C137.522 56.174 137.925 55.5561 138.177 54.8731C138.344 54.4309 138.459 53.9707 138.52 53.5019\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M111.369 46.8795L109.755 44.9439C109.755 44.9439 104.355 49.1259 98.4132 43.7852C93.2188 39.1164 96.7061 33.8099 96.7061 33.8099L102.447 39.3426L107.381 39.2032L107.717 34.6761L101.359 28.9628C101.359 28.9628 104.222 26.6775 109.095 29.02C113.862 31.3053 115.816 36.0381 112.895 41.1114C112.895 41.1114 121.954 48.2712 129.637 54.4278\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M134.169 58.1208C137.202 60.5409 138.968 62.0058 139.782 62.6182C146.181 67.4173 145.826 71.6885 143.838 73.9784C140.943 77.3149 135.092 74.6069 130.371 69.321C127.16 65.7262 118.945 55.8995 113.917 49.8823\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M118.746 55.5544C110.635 57.3164 110.889 49.359 111.273 47.3525C111.657 45.346 112.093 44.3382 112.708 44.2262C113.323 44.1143 112.761 45.2226 112.761 45.2226C112.761 45.2226 114.36 43.936 115.274 44.1531C116.582 44.4639 115.046 45.8785 114.337 47.2131C113.629 48.5477 113.373 49.8823 114.152 50.7187\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M112.173 95.3433C112.173 95.3433 113.217 95.1764 113.199 95.83C113.181 96.4836 115.793 97.3543 117.312 95.9306\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n<path d=\"M130.105 96.3101C130.105 96.3101 130.848 96.4289 131.056 95.8348C131.392 94.8818 133.154 94.8841 133.645 95.4737C134.137 96.0633 134.345 96.1707 134.58 96.0107\" stroke=\"#373E45\" stroke-miterlimit=\"10\"/>\n</svg>";

var LinealAccionistrasYSociosEmpty = "<svg width=\"144\" height=\"56\" viewBox=\"0 0 144 56\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path opacity=\"0.6\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M108.992 22.9578H102.765C102.144 22.9578 101.64 22.4458 101.64 21.8149C101.64 21.1841 102.144 20.6721 102.765 20.6721H108.992C109.613 20.6721 110.117 21.1841 110.117 21.8149C110.117 22.4458 109.613 22.9578 108.992 22.9578ZM117.037 11.8624H107.6C106.979 11.8624 106.475 11.3504 106.475 10.7195C106.475 10.0887 106.979 9.57666 107.6 9.57666H117.037C117.658 9.57666 118.162 10.0887 118.162 10.7195C118.162 11.3504 117.658 11.8624 117.037 11.8624ZM103.151 11.8624H101.235C100.614 11.8624 100.11 11.3504 100.11 10.7195C100.11 10.0887 100.614 9.57666 101.235 9.57666H103.151C103.772 9.57666 104.276 10.0887 104.276 10.7195C104.276 11.3504 103.772 11.8624 103.151 11.8624ZM115.22 22.9578H113.304C112.682 22.9578 112.179 22.4458 112.179 21.8149C112.179 21.1841 112.682 20.6721 113.304 20.6721H115.22C115.841 20.6721 116.345 21.1841 116.345 21.8149C116.345 22.4458 115.841 22.9578 115.22 22.9578ZM122.547 17.4101H117.723C117.101 17.4101 116.598 16.8981 116.598 16.2672C116.598 15.6364 117.101 15.1244 117.723 15.1244H122.547C123.168 15.1244 123.672 15.6364 123.672 16.2672C123.672 16.8981 123.168 17.4101 122.547 17.4101ZM112.169 17.4101H104.06C103.439 17.4101 102.935 16.8981 102.935 16.2672C102.935 15.6364 103.439 15.1244 104.06 15.1244H112.169C112.79 15.1244 113.294 15.6364 113.294 16.2672C113.294 16.8981 112.79 17.4101 112.169 17.4101ZM42.9314 28.8437H31.5633C30.9423 28.8437 30.4383 28.3317 30.4383 27.7008C30.4383 27.07 30.9423 26.558 31.5633 26.558H42.9314C43.5524 26.558 44.0564 27.07 44.0564 27.7008C44.0564 28.3317 43.5524 28.8437 42.9314 28.8437ZM25.974 28.8437H21.375C20.754 28.8437 20.25 28.3317 20.25 27.7008C20.25 27.07 20.754 26.558 21.375 26.558H25.974C26.595 26.558 27.099 27.07 27.099 27.7008C27.099 28.3317 26.595 28.8437 25.974 28.8437ZM41.0231 23.2962H26.3576C25.736 23.2962 25.2326 22.7842 25.2326 22.1533C25.2326 21.5225 25.736 21.0105 26.3576 21.0105H41.0231C41.6441 21.0105 42.1481 21.5225 42.1481 22.1533C42.1481 22.7842 41.6441 23.2962 41.0231 23.2962ZM37.9496 34.3913H25.974C25.3524 34.3913 24.849 33.8793 24.849 33.2485C24.849 32.6176 25.3524 32.1056 25.974 32.1056H37.9496C38.5706 32.1056 39.0746 32.6176 39.0746 33.2485C39.0746 33.8793 38.5706 34.3913 37.9496 34.3913Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96.1875 23.3732H94.3935L91.7196 24.8025C91.4186 24.6338 91.1056 24.4908 90.768 24.4049L87.4045 23.5498V23.1613C88.8925 22.1063 89.8004 20.3634 89.8004 18.5068V17.0891C89.8004 13.9383 87.3702 11.3016 84.3832 11.2097C84.2316 11.2057 84.0823 11.2113 83.9322 11.2188L84.8042 9.1448L80.5765 4.8511L78.0842 6.49896C77.1373 5.9572 76.1358 5.53543 75.0957 5.2396L74.4802 2.28564H68.3956L67.78 5.24039C66.74 5.53622 65.7377 5.95799 64.7915 6.49975L62.2993 4.85189L58.075 9.14322L58.9323 11.2188C58.8995 11.2172 58.8684 11.2113 58.8356 11.2105C57.3067 11.1653 55.8666 11.732 54.7727 12.8108C53.6773 13.8888 53.0746 15.3355 53.0746 16.8847V18.5068C53.0746 20.3634 53.9817 22.1055 55.4698 23.1605V23.5498L53.2758 24.107L49.299 21.7511H46.6875V38.5572L54.5419 41.2165H56.0717L56.2627 40.5369L58.6703 42.005C58.7097 43.3349 59.7595 44.4049 61.0674 44.4517C61.1134 45.7748 62.1601 46.8381 63.4626 46.8848C63.5086 48.208 64.5553 49.2713 65.8578 49.318C65.9053 50.672 66.9969 51.7603 68.3406 51.7603C68.8396 51.7603 69.3289 51.6023 69.7401 51.3207L70.4473 51.9551C70.8906 52.3516 71.4613 52.5714 72.0538 52.5714H72.2016C73.5301 52.5714 74.6112 51.4803 74.6279 50.135C75.9421 50.118 77.0063 49.0368 77.0231 47.7018C78.338 47.6848 79.403 46.6021 79.4183 45.2663C80.7453 45.2346 81.8165 44.1333 81.8165 42.7777C81.8165 42.6961 81.8126 42.6157 81.8044 42.5345L96.1875 35.2294V23.3732ZM88.2036 17.0891V18.5068C88.2036 19.9464 87.438 21.2913 86.2053 22.0164L85.8061 22.2509L85.8092 24.8175L89.7981 25.8297L81.0181 30.5242V28.3394C81.0181 27.2491 80.5846 26.2507 79.8748 25.5129L82.6149 24.8175V22.2489L82.2165 22.0148C80.9846 21.2913 80.2198 19.9464 80.2198 18.5068V16.8847C80.2198 15.7786 80.6501 14.7442 81.4325 13.9739C82.2142 13.2041 83.2511 12.789 84.3353 12.8318C86.4681 12.8967 88.2036 14.8068 88.2036 17.0891ZM72.6413 29.8866L69.0271 28.7132C67.3801 28.177 65.5973 28.097 63.9113 28.4764L63.4536 28.5794V28.3394C63.4536 27.221 64.2002 26.2499 65.2675 25.9783L69.8407 24.8175V22.2489L69.4423 22.0148C68.2104 21.2913 67.4456 19.9464 67.4456 18.5068V16.8847C67.4456 15.7786 67.8759 14.7442 68.6583 13.9739C69.44 13.2041 70.4836 12.789 71.5611 12.8318C73.6939 12.8967 75.4294 14.8068 75.4294 17.0891V18.5068C75.4294 19.9464 74.6638 21.2913 73.4311 22.0164L73.0319 22.2509L73.0351 24.8175L77.6075 25.9783C78.6748 26.2499 79.4214 27.221 79.4214 28.3394V31.3785L79.2241 31.4838H78.7349L73.8264 30.0589C73.4397 29.9476 73.0413 29.9021 72.6413 29.8866ZM63.6326 14.4246C65.1319 11.4734 68.1496 9.58518 71.4375 9.58518C74.6942 9.58518 77.6991 11.4481 79.2097 14.3593C78.8296 15.1335 78.623 15.9909 78.623 16.8847V18.5068C78.623 20.3634 79.5301 22.1055 81.0181 23.1605V23.5498L77.8246 24.3621L74.6303 23.5498V23.1613C76.1183 22.1063 77.0262 20.3634 77.0262 18.5068V17.0891C77.0262 13.9383 74.596 11.3016 71.609 11.2097C70.0809 11.1641 68.64 11.7312 67.5461 12.81C66.4515 13.8888 65.8488 15.3355 65.8488 16.8847V18.5068C65.8488 20.3634 66.7559 22.1055 68.244 23.1605V23.5498L65.0504 24.3621L61.8561 23.5498V23.1613C63.3441 22.1063 64.252 20.3634 64.252 18.5068V17.0891C64.252 16.1347 64.0259 15.2285 63.6326 14.4246ZM59.9607 9.51944L62.5114 6.92825L64.7565 8.41255L65.1861 8.14484C66.2624 7.47476 67.4257 6.98409 68.6431 6.68826L69.1343 6.56866L69.6899 3.90776H73.1859L73.7399 6.56787L74.2311 6.68707C75.4485 6.9833 76.6118 7.47397 77.6882 8.14405L78.1178 8.41176L80.3628 6.92746L82.9104 9.51628L82.0048 11.6703C81.3885 11.9396 80.817 12.3186 80.3196 12.8084C80.2868 12.8409 80.2587 12.8758 80.2268 12.909C78.3458 9.87151 75.0205 7.96306 71.4375 7.96306C67.8288 7.96306 64.4941 9.88933 62.6178 12.9577C62.1157 12.4239 61.5185 11.9914 60.8565 11.6893L59.9607 9.51944ZM57.0665 24.8175V22.2489L56.6681 22.0148C55.4362 21.2913 54.6714 19.9464 54.6714 18.5068V16.8847C54.6714 15.7786 55.1018 14.7442 55.8842 13.9739C56.6658 13.2041 57.7051 12.789 58.7869 12.8318C60.9197 12.8967 62.6552 14.8068 62.6552 17.0891V18.5068C62.6552 19.9464 61.8896 21.2913 60.6569 22.0164L60.2577 22.2509L60.2609 24.8175L63.0002 25.5129C62.2904 26.2507 61.8569 27.2491 61.8569 28.3394V28.9401L59.3666 29.5025L59.4313 29.2728L59.4617 27.7738L55.2511 25.2785L57.0665 24.8175ZM48.2843 23.3732H48.8663L54.6082 26.7755L51.7109 38.5481L48.2843 37.3874V23.3732ZM54.8008 39.5944L53.2294 39.0625L56.044 27.6265L57.8649 28.7053V28.937L54.8678 39.5944H54.8008ZM60.2601 41.9294C60.2601 41.6902 60.3552 41.4557 60.5221 41.2862L61.9255 39.8605C62.0923 39.691 62.3231 39.5944 62.5586 39.5944C63.0521 39.5944 63.4536 40.0023 63.4536 40.5037C63.4536 40.7429 63.3585 40.9773 63.1917 41.1468L61.7882 42.5725C61.6214 42.742 61.3906 42.8386 61.1551 42.8386C60.6616 42.8386 60.2601 42.4307 60.2601 41.9294ZM62.6552 44.3625C62.6552 44.1233 62.7504 43.8889 62.9172 43.7194L64.3206 42.2937C64.4875 42.1242 64.7183 42.0276 64.9537 42.0276C65.4473 42.0276 65.8488 42.4355 65.8488 42.9369C65.8488 43.1761 65.7537 43.4105 65.5868 43.58L64.1834 45.0057C64.0166 45.1752 63.7858 45.2718 63.5503 45.2718C63.0568 45.2718 62.6552 44.8639 62.6552 44.3625ZM65.0504 46.7957C65.0504 46.5565 65.1455 46.3221 65.3124 46.1526L66.7158 44.7269C66.8826 44.5574 67.1134 44.4608 67.3489 44.4608C67.8424 44.4608 68.244 44.8687 68.244 45.37C68.244 45.6092 68.1488 45.8437 67.982 46.0132L66.5786 47.4389C66.4117 47.6084 66.1809 47.705 65.9455 47.705C65.4519 47.705 65.0504 47.2971 65.0504 46.7957ZM68.3406 50.1382C67.8471 50.1382 67.4456 49.7303 67.4456 49.2289C67.4456 48.9897 67.5407 48.7553 67.7075 48.5858L69.111 47.1601C69.2778 46.9906 69.5086 46.8939 69.744 46.8939C70.2376 46.8939 70.6391 47.3018 70.6391 47.8032C70.6391 48.0424 70.544 48.2769 70.3771 48.4464L68.9737 49.8721C68.8069 50.0415 68.5761 50.1382 68.3406 50.1382ZM72.2016 50.9492H72.0538C71.8503 50.9492 71.6554 50.874 71.5038 50.7374L70.9065 50.2023L71.5061 49.5933C71.7201 49.3758 71.8862 49.1172 72.009 48.8396L72.7349 49.4535C72.9247 49.6142 73.0343 49.8511 73.0343 50.1033C73.0343 50.5698 72.6608 50.9492 72.2016 50.9492ZM79.3613 43.6497H79.2233C79.023 43.6497 78.8273 43.5776 78.6741 43.4469L74.3445 39.7817L73.3216 41.0284L77.526 44.5871C77.7151 44.7479 77.8246 44.9847 77.8246 45.237C77.8246 45.7035 77.4511 46.0829 76.9919 46.0829H76.8176C76.6239 46.0829 76.4344 46.0132 76.2851 45.8865L71.9486 42.2157L70.9256 43.4624L75.13 47.0215C75.3199 47.1811 75.4294 47.4179 75.4294 47.6702C75.4294 48.1367 75.056 48.5161 74.5967 48.5161C74.2903 48.5161 73.9917 48.4056 73.7566 48.2072L71.9747 46.6983C71.5821 45.8833 70.7756 45.315 69.831 45.2809C69.785 43.9578 68.7383 42.8945 67.4358 42.8477C67.3898 41.5246 66.3431 40.4613 65.0407 40.4146C64.9939 39.0606 63.9023 37.9723 62.5586 37.9723C61.9025 37.9723 61.2604 38.2424 60.7965 38.7136L59.3931 40.1393C59.3093 40.2245 59.2399 40.3211 59.1693 40.4169L56.7168 38.922L58.8668 31.2779L64.2567 30.0605C65.6706 29.7393 67.1614 29.809 68.5402 30.2573L69.7164 30.6395L65.7291 32.6648C64.8181 33.1285 64.252 34.0596 64.252 35.0948V35.2552C64.252 36.7533 65.4519 37.9723 66.9267 37.9723C67.4113 37.9723 67.888 37.8384 68.3024 37.5846L71.2753 35.7736C71.8726 35.41 72.6741 35.4896 73.1898 35.9609L79.9356 42.1282C80.1161 42.2945 80.2198 42.5305 80.2198 42.7777C80.2198 43.2588 79.835 43.6497 79.3613 43.6497ZM94.5907 34.2267L81.1402 41.0593C81.0965 41.0122 81.0509 40.9674 81.0029 40.9239L74.2584 34.7566C73.6674 34.2148 72.9033 33.917 72.1072 33.917C71.5252 33.917 70.9537 34.0778 70.4532 34.3827L67.4791 36.1945C67.3122 36.2967 67.1216 36.3502 66.9267 36.3502C66.3318 36.3502 65.8488 35.8595 65.8488 35.2552V35.0948C65.8488 34.677 66.0772 34.3023 66.4445 34.1158L70.898 31.8537C71.6601 31.466 72.5649 31.3793 73.3863 31.6192L78.4035 33.075L79.6186 33.1059L94.5907 25.1007V34.2267Z\" fill=\"#B6C5D5\"/>\n</svg>";

var LinealAltaUsuarioWarning = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g opacity=\"0.6\">\n<path d=\"M44.0863 55.3575C44.3724 55.3575 44.6201 55.4764 44.8322 55.7113L46.1851 57.0899L47.55 55.7113C47.7694 55.4837 48.018 55.3703 48.2959 55.3703C48.5656 55.3703 48.7987 55.4691 48.998 55.6674C49.1945 55.8658 49.2951 56.0953 49.2951 56.3567C49.2951 56.6264 49.1881 56.8705 48.9788 57.0899L47.5372 58.5059L49.104 60.0736C49.3143 60.2839 49.4212 60.5243 49.4212 60.794C49.4212 61.0554 49.3188 61.2876 49.1177 61.4887C48.9157 61.6917 48.6789 61.7922 48.4102 61.7922C48.1304 61.7922 47.8827 61.6789 47.6642 61.4512L46.1851 59.9091L44.7179 61.4512C44.4985 61.6789 44.2508 61.7922 43.9729 61.7922C43.7014 61.7922 43.4665 61.6917 43.2635 61.4887C43.0624 61.2876 42.96 61.0554 42.96 60.794C42.96 60.5243 43.0661 60.2839 43.2772 60.0736L44.8441 58.5059L43.4034 57.0889C43.1931 56.8787 43.0862 56.6392 43.0862 56.3695C43.0862 56.0998 43.1867 55.8631 43.3842 55.661C43.5826 55.459 43.8166 55.3575 44.0863 55.3575ZM24.8892 43.9307C25.1754 43.9307 25.4231 44.0496 25.6352 44.2845L26.9881 45.663L28.3529 44.2845C28.5723 44.0569 28.821 43.9435 29.0989 43.9435C29.3685 43.9435 29.6017 44.0423 29.8009 44.2406C29.9975 44.439 30.098 44.6685 30.098 44.9299C30.098 45.1996 29.9911 45.4437 29.7817 45.663L28.3401 47.0791L29.907 48.6468C30.1172 48.8571 30.2242 49.0975 30.2242 49.3672C30.2242 49.6286 30.1218 49.8608 29.9207 50.0619C29.7187 50.2649 29.4819 50.3654 29.2131 50.3654C28.9334 50.3654 28.6857 50.2521 28.4672 50.0244L26.9881 48.4823L25.5209 50.0244C25.3015 50.2521 25.0538 50.3654 24.7759 50.3654C24.5044 50.3654 24.2694 50.2649 24.0665 50.0619C23.8654 49.8608 23.763 49.6286 23.763 49.3672C23.763 49.0975 23.8691 48.8571 24.0802 48.6468L25.6471 47.0791L24.2064 45.6621C23.9961 45.4519 23.8892 45.2124 23.8892 44.9427C23.8892 44.673 23.9897 44.4363 24.1872 44.2342C24.3855 44.0322 24.6196 43.9307 24.8892 43.9307ZM156.736 42.1025C157.007 42.1025 157.241 42.203 157.445 42.406C157.646 42.608 157.747 42.8402 157.747 43.1007C157.747 43.3713 157.642 43.6117 157.43 43.822L155.865 45.3897L157.305 46.8057C157.515 47.0251 157.622 47.2692 157.622 47.5389C157.622 47.8003 157.522 48.0298 157.323 48.2281C157.126 48.4256 156.891 48.5252 156.621 48.5252C156.344 48.5252 156.095 48.411 155.876 48.1833L154.511 46.8057L153.158 48.1833C152.946 48.4192 152.7 48.5371 152.411 48.5371C152.142 48.5371 151.91 48.4366 151.709 48.2336C151.513 48.0325 151.413 47.7957 151.413 47.5261C151.413 47.2564 151.519 47.016 151.73 46.8057L153.171 45.3888L151.603 43.822C151.393 43.6117 151.286 43.3713 151.286 43.1016C151.286 42.8402 151.389 42.608 151.591 42.4069C151.792 42.2039 152.029 42.1025 152.299 42.1025C152.577 42.1025 152.826 42.2167 153.046 42.4443L154.511 43.9865L155.99 42.4443C156.21 42.2158 156.457 42.1025 156.737 42.1025H156.736ZM185.989 39.36C186.259 39.36 186.493 39.4606 186.697 39.6635C186.898 39.8655 187 40.0977 187 40.3583C187 40.6289 186.895 40.8693 186.683 41.0795L185.118 42.6473L186.557 44.0633C186.768 44.2827 186.875 44.5268 186.875 44.7964C186.875 45.0579 186.774 45.2873 186.576 45.4857C186.378 45.6832 186.143 45.7828 185.874 45.7828C185.597 45.7828 185.347 45.6685 185.129 45.4409L183.764 44.0633L182.411 45.4409C182.199 45.6768 181.953 45.7947 181.664 45.7947C181.394 45.7947 181.162 45.6941 180.962 45.4912C180.765 45.2901 180.666 45.0533 180.666 44.7836C180.666 44.514 180.772 44.2735 180.983 44.0633L182.424 42.6464L180.856 41.0795C180.646 40.8693 180.539 40.6289 180.539 40.3592C180.539 40.0977 180.642 39.8655 180.843 39.6644C181.044 39.4615 181.282 39.36 181.552 39.36C181.83 39.36 182.078 39.4743 182.298 39.7019L183.764 41.2441L185.243 39.7019C185.462 39.4734 185.709 39.36 185.99 39.36H185.989ZM5.69312 27.9332C5.97925 27.9332 6.22698 28.0521 6.43906 28.287L7.792 29.6655L9.15681 28.287C9.37621 28.0594 9.62485 27.946 9.90275 27.946C10.1724 27.946 10.4055 28.0447 10.6048 28.2431C10.8014 28.4415 10.9019 28.6709 10.9019 28.9324C10.9019 29.2021 10.795 29.4461 10.5856 29.6655L9.14401 31.0815L10.7109 32.6493C10.9211 32.8595 11.0281 33.1 11.0281 33.3696C11.0281 33.6311 10.9257 33.8633 10.7246 34.0644C10.5225 34.2673 10.2858 34.3679 10.017 34.3679C9.73729 34.3679 9.48956 34.2545 9.27108 34.0269L7.792 32.4847L6.32479 34.0269C6.1054 34.2545 5.85767 34.3679 5.57977 34.3679C5.30827 34.3679 5.07333 34.2673 4.87039 34.0644C4.66928 33.8633 4.56689 33.6311 4.56689 33.3696C4.56689 33.1 4.67294 32.8595 4.8841 32.6493L6.45095 31.0815L5.01025 29.6646C4.8 29.4544 4.69305 29.2149 4.69305 28.9452C4.69305 28.6755 4.7936 28.4387 4.99106 28.2367C5.18943 28.0347 5.42345 27.9332 5.69312 27.9332ZM167.707 21.0771C167.977 21.0771 168.212 21.1777 168.414 21.3806C168.616 21.5827 168.718 21.8149 168.718 22.0754C168.718 22.346 168.612 22.5864 168.401 22.7966L166.834 24.3644L168.276 25.7804C168.486 25.9998 168.592 26.2439 168.592 26.5136C168.592 26.775 168.491 27.0045 168.294 27.2028C168.095 27.4003 167.861 27.4999 167.592 27.4999C167.315 27.4999 167.065 27.3857 166.846 27.158L165.482 25.7804L164.128 27.158C163.918 27.3939 163.669 27.5118 163.382 27.5118C163.112 27.5118 162.879 27.4112 162.68 27.2083C162.483 27.0072 162.383 26.7704 162.383 26.5008C162.383 26.2311 162.49 25.9907 162.7 25.7804L164.141 24.3635L162.574 22.7966C162.364 22.5864 162.257 22.346 162.257 22.0763C162.257 21.8149 162.359 21.5827 162.56 21.3816C162.762 21.1786 162.999 21.0771 163.27 21.0771C163.548 21.0771 163.795 21.1914 164.015 21.419L165.482 22.9612L166.961 21.419C167.18 21.1905 167.427 21.0771 167.707 21.0771ZM42.0121 16.9635C42.2817 16.9635 42.5167 17.064 42.7196 17.267C42.9207 17.469 43.0231 17.7012 43.0231 17.9617C43.0231 18.2323 42.9171 18.4727 42.7059 18.683L41.1391 20.2508L42.5807 21.6668C42.7909 21.8862 42.897 22.1302 42.897 22.3999C42.897 22.6614 42.7964 22.8908 42.599 23.0892C42.4006 23.2866 42.1666 23.3863 41.8969 23.3863C41.6199 23.3863 41.3703 23.272 41.1509 23.0444L39.787 21.6668L38.4332 23.0444C38.2229 23.2802 37.9743 23.3982 37.6873 23.3982C37.4176 23.3982 37.1845 23.2976 36.9852 23.0947C36.7887 22.8935 36.6881 22.6568 36.6881 22.3871C36.6881 22.1174 36.7951 21.877 37.0053 21.6668L38.446 20.2498L36.8792 18.683C36.6689 18.4727 36.5619 18.2323 36.5619 17.9627C36.5619 17.7012 36.6643 17.469 36.8654 17.2679C37.0675 17.065 37.3042 16.9635 37.5748 16.9635C37.8527 16.9635 38.1004 17.0778 38.3198 17.3054L39.787 18.8475L41.2661 17.3054C41.4855 17.0768 41.7323 16.9635 42.0121 16.9635ZM145.767 10.9868C146.036 10.9868 146.271 11.0874 146.474 11.2903C146.675 11.4923 146.778 11.7245 146.778 11.9851C146.778 12.2556 146.672 12.4952 146.46 12.7063L144.894 14.2741L146.335 15.6901C146.545 15.9095 146.651 16.1536 146.651 16.4232C146.651 16.6838 146.551 16.9141 146.353 17.1116C146.155 17.31 145.921 17.4087 145.651 17.4087C145.374 17.4087 145.125 17.2953 144.905 17.0677L143.542 15.6901L142.188 17.0677C141.977 17.3036 141.729 17.4215 141.442 17.4215C141.172 17.4215 140.939 17.3209 140.74 17.118C140.543 16.916 140.443 16.6792 140.443 16.4104C140.443 16.1408 140.549 15.9003 140.76 15.6901L142.2 14.2732L140.634 12.7063C140.423 12.4961 140.316 12.2556 140.316 11.9851C140.316 11.7245 140.419 11.4923 140.62 11.2903C140.822 11.0883 141.059 10.9868 141.329 10.9868C141.607 10.9868 141.855 11.1002 142.074 11.3278L143.542 12.8709L145.021 11.3278C145.24 11.1002 145.487 10.9868 145.767 10.9868Z\" fill=\"#B6C5D5\"/>\n</g>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" d=\"M95.5235 78.2114C99.8365 78.2114 103.989 77.4527 107.853 76.065C108.139 77.5029 108.559 78.8933 109.1 80.2216C105.669 81.2911 102.029 81.8671 98.266 81.8671C85.436 81.8671 74.0082 75.139 67.3569 65.0486C74.1755 73.0748 84.3143 78.2105 95.5235 78.2105V78.2114ZM126.443 20.9878C131.934 27.4535 135.27 35.7914 135.27 44.8241C135.27 46.22 135.19 47.5994 135.036 48.9588C133.974 48.743 132.886 48.6013 131.778 48.5383C132.268 46.1524 132.527 43.6878 132.527 41.1675C132.527 33.8781 130.355 27.0422 126.631 21.2767L126.443 20.9878Z\" fill=\"#CCCCCC\"/>\n</g>\n<path d=\"M95.9612 4.16553C116.209 4.16553 132.965 20.9218 132.965 41.1692C132.965 43.6995 132.704 46.175 132.21 48.5692C131.627 48.5235 131.038 48.5015 130.445 48.5015C129.764 48.5015 129.092 48.5308 128.426 48.5884C128.961 46.2052 129.238 43.7224 129.226 41.1683C129.185 22.7647 114.364 7.9446 95.9602 7.9446C77.5174 7.9446 62.7375 22.7647 62.7375 41.1683C62.7375 49.7996 65.9535 57.6174 71.2875 63.4798C74.9925 58.7171 84.0718 54.1555 95.9602 54.1555C102.334 54.1555 107.893 55.4572 112.255 57.4025C109.217 61.305 107.407 66.2103 107.407 71.538C107.407 73.1377 107.57 74.7 107.881 76.2083C104.135 77.5046 100.123 78.2103 95.9602 78.2103C75.7138 78.2112 58.9575 61.4549 58.9575 41.1692C58.9575 20.9218 75.6754 4.16553 95.9612 4.16553ZM95.9612 18.897C103.33 18.897 109.112 25.3298 109.112 33.1064C109.112 41.331 103.371 47.6413 95.9612 47.6013C88.5913 47.5188 82.8505 41.3301 82.8092 33.1064C82.7691 25.3298 88.6325 18.897 95.9612 18.897Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M130.31 92.62C141.444 92.62 150.62 83.4278 150.62 72.2994C150.62 61.1922 141.423 52 130.31 52C119.176 52 110 61.1922 110 72.2994C110 83.4278 119.197 92.62 130.31 92.62ZM130.651 75.4559C131.568 75.4559 132.133 74.8914 132.133 73.88L132.415 62.0492C132.439 61.0613 131.662 60.3086 130.628 60.3086C129.569 60.3086 128.84 61.0378 128.863 62.0492L129.122 73.88C129.146 74.8914 129.687 75.4559 130.651 75.4559ZM130.651 82.465C129.475 82.465 128.464 81.5007 128.464 80.3481C128.464 79.1721 129.451 78.2313 130.651 78.2313C131.851 78.2313 132.838 79.1486 132.838 80.3481C132.838 81.5242 131.827 82.465 130.651 82.465Z\" fill=\"#FECF2F\"/>\n</svg>";

var LinealAppUpdate = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_324_1612)\">\n<g opacity=\"0.6\">\n<path d=\"M42.0985 64.1518C42.3466 64.1518 42.5621 64.2452 42.7482 64.431C42.9326 64.6177 43.0264 64.8305 43.0264 65.0702C43.0264 65.3191 42.9292 65.5403 42.7364 65.7346L41.2997 67.176L42.6199 68.4787C42.8127 68.6721 42.9108 68.8933 42.9108 69.1414C42.9108 69.3895 42.8186 69.6064 42.6375 69.7931C42.4556 69.979 42.241 70.0723 41.9937 70.0723C41.7314 70.0723 41.5042 69.963 41.3097 69.746L40.0692 68.4787L38.8177 69.746C38.6165 69.9563 38.3885 70.0606 38.1337 70.0606C37.8864 70.0606 37.6726 69.9689 37.4907 69.7873C37.3097 69.6048 37.2183 69.3937 37.2183 69.1532C37.2183 68.9051 37.3156 68.6805 37.5075 68.4787L38.8294 67.176L37.3927 65.7337C37.1999 65.5403 37.1018 65.3191 37.1018 65.071C37.1018 64.8305 37.1957 64.6169 37.3801 64.4319C37.5662 64.2452 37.7825 64.1518 38.0297 64.1518C38.2854 64.1518 38.5126 64.2569 38.7137 64.4664L40.07 65.8851L41.4145 64.4664C41.6157 64.2561 41.8437 64.1518 42.0985 64.1518ZM11.0799 53.6781C11.328 53.6781 11.5435 53.7714 11.7295 53.9581C11.914 54.144 12.0078 54.3576 12.0078 54.5972C12.0078 54.8453 11.9106 55.0665 11.717 55.2608L10.2811 56.7022L11.6013 58.0058C11.7941 58.1992 11.8922 58.4204 11.8922 58.6684C11.8922 58.9165 11.8 59.1335 11.6189 59.3194C11.437 59.5052 11.2224 59.5986 10.9751 59.5986C10.7128 59.5986 10.4856 59.4892 10.2911 59.2731L9.05055 58.0049L7.79906 59.2731C7.59789 59.4825 7.36989 59.5868 7.11506 59.5868C6.86778 59.5868 6.65404 59.496 6.47214 59.3135C6.29108 59.1318 6.19971 58.9199 6.19971 58.6794C6.19971 58.4313 6.29695 58.2067 6.4889 58.0049L7.8108 56.7022L6.37406 55.2608C6.18127 55.0674 6.0832 54.8453 6.0832 54.5972C6.0832 54.3576 6.17708 54.144 6.36149 53.9581C6.54674 53.7714 6.76384 53.6789 7.01112 53.6789C7.26678 53.6789 7.49395 53.7832 7.69512 53.9926L9.05138 55.4113L10.3959 53.9926C10.5971 53.7832 10.8251 53.6781 11.0799 53.6781ZM152.725 71.0696C152.973 71.0696 153.186 71.1621 153.369 71.348C153.55 71.5347 153.641 71.7517 153.641 71.9998C153.641 72.2479 153.544 72.469 153.35 72.6625L152.03 73.966L153.466 75.4074C153.659 75.6009 153.757 75.822 153.757 76.0701C153.757 76.3107 153.662 76.5243 153.478 76.7093C153.294 76.896 153.076 76.9893 152.829 76.9893C152.574 76.9893 152.346 76.8842 152.144 76.6748L150.801 75.2561L149.444 76.6748C149.242 76.885 149.017 76.9893 148.76 76.9893C148.512 76.9893 148.298 76.8968 148.11 76.7101C147.926 76.5243 147.833 76.3107 147.833 76.071C147.833 75.822 147.93 75.6009 148.123 75.4074L149.559 73.9651L148.238 72.6625C148.046 72.4606 147.947 72.2361 147.947 71.988C147.947 71.7475 148.04 71.5364 148.222 71.3539C148.403 71.1722 148.618 71.0806 148.865 71.0806C149.119 71.0806 149.349 71.1857 149.548 71.3951L150.801 72.6625L152.041 71.3951C152.235 71.1781 152.46 71.0696 152.725 71.0696ZM4.99671 28.9311C5.24483 28.9311 5.46026 29.0244 5.64634 29.2103C5.83075 29.397 5.92464 29.6098 5.92464 29.8494C5.92464 30.0984 5.8274 30.3195 5.63377 30.5138L4.19788 31.9553L5.51809 33.2579C5.71089 33.4514 5.80896 33.6725 5.80896 33.9206C5.80896 34.1687 5.71675 34.3857 5.5357 34.5724C5.3538 34.7574 5.13921 34.8516 4.89193 34.8516C4.62957 34.8516 4.4024 34.7423 4.20793 34.5253L2.96735 33.2579L1.71586 34.5253C1.51469 34.7355 1.28669 34.8398 1.03187 34.8398C0.784587 34.8398 0.570837 34.7482 0.38894 34.5665C0.207882 34.384 0.116514 34.1729 0.116514 33.9324C0.116514 33.6843 0.21375 33.4598 0.405705 33.2579L1.7276 31.9553L0.290867 30.513C0.0980734 30.3195 0 30.0984 0 29.8503C0 29.6098 0.0938822 29.3961 0.278294 29.2111C0.464382 29.0244 0.680646 28.9311 0.927925 28.9311C1.18359 28.9311 1.41075 29.0362 1.61192 29.2456L2.96819 30.6643L4.31271 29.2456C4.51389 29.0354 4.74189 28.9311 4.99671 28.9311ZM187.442 46.5005C187.69 46.5005 187.902 46.5938 188.085 46.7797C188.266 46.9664 188.357 47.1834 188.357 47.4314C188.357 47.6795 188.26 47.9007 188.066 48.0941L186.746 49.3968L188.182 50.8391C188.375 51.0325 188.473 51.2537 188.473 51.5018C188.473 51.7423 188.379 51.9559 188.194 52.1409C188.01 52.3276 187.792 52.421 187.545 52.421C187.291 52.421 187.063 52.3159 186.861 52.1065L185.517 50.6877L184.161 52.1065C183.959 52.3167 183.733 52.421 183.476 52.421C183.229 52.421 183.014 52.3276 182.826 52.1418C182.642 51.9551 182.55 51.7423 182.55 51.5018C182.55 51.2537 182.646 51.0325 182.84 50.8391L184.275 49.3968L182.954 48.0941C182.762 47.8923 182.664 47.6678 182.664 47.4197C182.664 47.1791 182.757 46.9681 182.938 46.7856C183.119 46.6039 183.334 46.5123 183.581 46.5123C183.835 46.5123 184.065 46.6174 184.265 46.8268L185.517 48.0941L186.757 46.8268C186.951 46.609 187.177 46.5005 187.442 46.5005ZM48.7316 5.18757C48.9789 5.18757 49.1926 5.28008 49.3745 5.46677C49.5556 5.65263 49.6469 5.87045 49.6469 6.11769C49.6469 6.36578 49.5497 6.58696 49.3561 6.78123L48.0359 8.08307L49.4718 9.52536C49.6654 9.71878 49.7626 9.9408 49.7626 10.1889C49.7626 10.4286 49.6696 10.6422 49.4843 10.828C49.2999 11.0139 49.0828 11.1072 48.8347 11.1072C48.5799 11.1072 48.3527 11.003 48.1507 10.7936L46.8062 9.37482L45.4499 10.7936C45.2487 11.003 45.0224 11.1072 44.7659 11.1072C44.5186 11.1072 44.3032 11.0147 44.1163 10.828C43.9319 10.6422 43.838 10.4286 43.838 10.1889C43.838 9.9408 43.9361 9.71962 44.1289 9.52536L45.5656 8.08307L44.2437 6.78123C44.0517 6.57939 43.9545 6.35401 43.9545 6.10592C43.9545 5.86624 44.0467 5.65431 44.2278 5.47266C44.4088 5.29017 44.6234 5.19934 44.8707 5.19934C45.1247 5.19934 45.3543 5.30362 45.5547 5.51303L46.8062 6.78123L48.0468 5.51303C48.2404 5.29605 48.4676 5.18757 48.7316 5.18757ZM191.539 13.7703C191.786 13.7703 192 13.8637 192.182 14.0504C192.363 14.2354 192.454 14.4532 192.454 14.7013C192.454 14.9494 192.357 15.1706 192.163 15.364L190.843 16.6675L192.279 18.109C192.472 18.3024 192.57 18.5236 192.57 18.7717C192.57 19.0122 192.477 19.2258 192.291 19.4116C192.107 19.5975 191.89 19.6909 191.642 19.6909C191.387 19.6909 191.16 19.5857 190.958 19.3763L189.613 17.9576L188.257 19.3763C188.056 19.5866 187.829 19.6909 187.573 19.6909C187.326 19.6909 187.11 19.5983 186.923 19.4116C186.739 19.2258 186.645 19.0122 186.645 18.7725C186.645 18.5236 186.743 18.3032 186.936 18.109L188.373 16.6667L187.051 15.364C186.859 15.1622 186.762 14.9376 186.762 14.6895C186.762 14.449 186.854 14.2379 187.035 14.0554C187.216 13.8738 187.43 13.7829 187.678 13.7829C187.932 13.7829 188.161 13.8872 188.362 14.0966L189.613 15.364L190.854 14.0966C191.047 13.8797 191.275 13.7703 191.539 13.7703ZM33.2773 15.6969C33.4617 15.8827 33.5556 16.0963 33.5556 16.336C33.5556 16.5841 33.4583 16.8053 33.2655 16.9995L31.828 18.441L33.1482 19.7428C33.341 19.9363 33.439 20.1583 33.439 20.4064C33.439 20.6544 33.3468 20.8714 33.1658 21.0573C32.9839 21.2431 32.7693 21.3365 32.522 21.3365C32.2597 21.3365 32.0325 21.228 31.838 21.011L30.5974 19.7428L29.346 21.011C29.1448 21.2204 28.9168 21.3247 28.662 21.3247C28.4147 21.3247 28.2009 21.2339 28.019 21.0514C27.838 20.8697 27.7466 20.6578 27.7466 20.4181C27.7466 20.17 27.8438 19.9447 28.0358 19.7428L29.3577 18.441L27.921 16.9987C27.7282 16.8053 27.6301 16.5833 27.6301 16.3352C27.6301 16.0955 27.724 15.8819 27.9084 15.696C28.0945 15.5093 28.3107 15.4168 28.558 15.4168C28.8137 15.4168 29.0408 15.5211 29.242 15.7305L30.5983 17.1492L31.9428 15.7305C32.144 15.5211 32.372 15.4168 32.6268 15.4168C32.8758 15.4177 33.0912 15.5102 33.2773 15.6969ZM135.764 0C136.011 0 136.225 0.0925081 136.407 0.279206C136.588 0.465064 136.679 0.682878 136.679 0.930968C136.679 1.17906 136.582 1.3994 136.389 1.59366L135.068 2.89634L136.504 4.33863C136.698 4.53206 136.795 4.75323 136.795 5.00132C136.795 5.24185 136.702 5.45546 136.517 5.64047C136.332 5.82717 136.115 5.91968 135.867 5.91968C135.612 5.91968 135.385 5.8154 135.183 5.60599L133.839 4.18725L132.482 5.60599C132.281 5.8154 132.055 5.91968 131.798 5.91968C131.551 5.91968 131.336 5.82717 131.149 5.64131C130.964 5.45461 130.87 5.24185 130.87 5.00132C130.87 4.75323 130.969 4.53206 131.161 4.33863L132.598 2.89634L131.276 1.59282C131.084 1.39183 130.987 1.16728 130.987 0.919194C130.987 0.678673 131.079 0.467586 131.26 0.285093C131.441 0.1026 131.656 0.0117738 131.903 0.0117738C132.157 0.0117738 132.387 0.116897 132.587 0.32546L133.839 1.59366L135.079 0.32546C135.273 0.108487 135.5 0 135.764 0Z\" fill=\"#B6C5D5\"/>\n</g>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M123.719 74.0388L129.547 87.4464C129.82 88.0761 129.062 88.5951 127.849 88.5951H63.1906C61.9759 88.5951 61.2163 88.0761 61.4906 87.4471L67.1426 74.443V81.3654C67.1426 83.0248 68.4501 84.3798 70.091 84.4554L70.2367 84.4588H120.625C122.334 84.4588 123.719 83.0736 123.719 81.3654V74.0381V74.0388Z\" fill=\"#B6C5D5\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M114.382 35.7466H76.5443L68.3096 50.1826H122.616L114.382 35.7466Z\" fill=\"#647180\"/>\n<path opacity=\"0.6\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M123.602 48.3624L116.891 36.6142L134.841 30.6426L150.473 40.1091L123.602 48.3624ZM121.404 81.3191C121.404 81.4456 121.301 81.5487 121.174 81.5487H100.829V51.6524H121.403V81.3191H121.404ZM70.2079 81.3191V51.6524H90.784V81.5487H70.4375C70.3117 81.5487 70.2079 81.4456 70.2079 81.3191V81.3191ZM56.7707 30.6426L74.7208 36.6149L68.0095 48.3631L41.1386 40.1084L56.7707 30.6426V30.6426ZM71.2961 48.6477L74.6899 42.7055L77.795 37.2701H113.816L116.922 42.7055L120.317 48.6477H71.2961ZM154.889 39.2746L135.797 27.712C135.424 27.4852 134.968 27.435 134.555 27.5732L114.442 34.2653H77.1701L57.0587 27.5725C56.6449 27.435 56.1885 27.4859 55.8145 27.712L36.7246 39.2746C36.2187 39.5805 35.9396 40.1566 36.0124 40.745C36.0853 41.3341 36.4943 41.8243 37.0594 41.9982L67.2162 51.2613V81.3191C67.2162 83.103 68.6618 84.5534 70.4375 84.5534H121.174C122.95 84.5534 124.395 83.103 124.395 81.3191V51.2613L154.554 41.9989C155.119 41.825 155.528 41.3348 155.601 40.7457C155.674 40.1573 155.395 39.5812 154.889 39.2746V39.2746Z\" fill=\"#B6C5D5\"/>\n<mask id=\"mask0_324_1612\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"62\" y=\"10\" width=\"66\" height=\"39\">\n<path d=\"M62.8105 10.3115H127.702V48.9532H62.8105V10.3115Z\" fill=\"white\"/>\n</mask>\n<g mask=\"url(#mask0_324_1612)\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M80.4057 13.749C77.9117 13.749 75.8721 15.8065 75.8721 18.3225V50.2638C75.8721 52.7798 77.9117 54.8373 80.4057 54.8373H112.079C114.573 54.8373 116.614 52.7791 116.614 50.2638V18.3225C116.614 15.8065 114.572 13.749 112.079 13.749H80.4063H80.4057Z\" fill=\"white\" stroke=\"#B6C5D5\"/>\n<path d=\"M89.7758 27.1407L83.921 20.9731C83.7726 20.8132 83.5709 20.7205 83.3586 20.7148C83.247 20.711 83.1359 20.7309 83.0317 20.7733C82.9276 20.8158 82.8327 20.8798 82.7525 20.9617C82.6724 21.0436 82.6088 21.1417 82.5654 21.2501C82.522 21.3584 82.4998 21.4749 82.5 21.5925V33.929C82.4998 34.0466 82.522 34.1631 82.5653 34.2714C82.6087 34.3798 82.6724 34.4778 82.7525 34.5597C82.8326 34.6416 82.9275 34.7057 83.0316 34.7481C83.1357 34.7906 83.2469 34.8105 83.3585 34.8067C83.5707 34.801 83.7725 34.7084 83.921 34.5484L89.7758 28.3808C89.9319 28.2163 90.0196 27.9933 90.0196 27.7608C90.0196 27.5282 89.9319 27.3052 89.7758 27.1407V27.1407Z\" fill=\"#1AAAAD\"/>\n<path d=\"M109.498 40.0426L102.669 32.8496L98.2412 37.5137L108.091 47.8891C108.206 48.0104 108.353 48.0931 108.513 48.1265C108.673 48.16 108.838 48.1428 108.989 48.077C109.14 48.0113 109.268 47.9 109.359 47.7572C109.45 47.6144 109.498 47.4465 109.498 47.2748L109.498 40.0426Z\" fill=\"#FECF2F\"/>\n<path d=\"M96.4319 26.2795C96.2759 26.1152 96.0644 26.0229 95.8438 26.0229C95.6233 26.0229 95.4117 26.1152 95.2558 26.2795L82.7437 39.4529C82.6664 39.5343 82.6052 39.6309 82.5633 39.7372C82.5215 39.8435 82.5 39.9575 82.5 40.0726C82.5 40.1877 82.5215 40.3016 82.5633 40.4079C82.6052 40.5143 82.6664 40.6109 82.7437 40.6922L85.9972 44.1195C86.0744 44.2009 86.1661 44.2654 86.267 44.3094C86.368 44.3535 86.4761 44.3761 86.5853 44.3761C86.6946 44.3761 86.8027 44.3535 86.9036 44.3094C87.0046 44.2654 87.0962 44.2009 87.1735 44.1195L95.2551 35.6062C95.3323 35.5249 95.424 35.4603 95.5249 35.4163C95.6258 35.3723 95.734 35.3496 95.8432 35.3496C95.9524 35.3496 96.0606 35.3723 96.1615 35.4163C96.2624 35.4603 96.3541 35.5249 96.4313 35.6062L98.2418 37.5134L102.669 32.8493L96.4319 26.2795Z\" fill=\"#DD2457\"/>\n<path d=\"M108.078 27.1509L102.668 32.8491L109.498 40.042L109.499 27.7708C109.5 27.5973 109.451 27.4277 109.359 27.2834C109.268 27.1391 109.138 27.0266 108.986 26.9602C108.833 26.8939 108.666 26.8766 108.504 26.9105C108.343 26.9444 108.194 27.0281 108.078 27.1509V27.1509Z\" fill=\"#023F80\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M138.419 82.4875C138.419 90.837 131.651 97.6061 123.301 97.6061C114.95 97.6061 108.181 90.837 108.181 82.4875C108.181 74.1373 114.95 67.3682 123.301 67.3682C131.649 67.3682 138.419 74.1373 138.419 82.4875Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M131.26 78.7773C131.781 79.9012 132.071 81.1578 132.071 82.4866C132.071 87.3371 128.192 91.2067 123.331 91.2067C122.647 91.2067 121.961 91.1324 121.328 90.9949L124.291 93.9371C124.429 94.0966 124.49 94.2822 124.479 94.4926C124.457 94.8817 124.146 95.1614 123.757 95.1367C123.565 95.1243 123.415 95.0521 123.311 94.927L119.125 90.6684C118.966 90.5 118.883 90.3103 118.883 90.1198C118.883 89.9301 118.946 89.7514 119.125 89.572L123.312 85.3443C123.437 85.2178 123.595 85.1545 123.806 85.1545C124.106 85.1545 124.377 85.3353 124.453 85.6268C124.519 85.8825 124.471 86.1341 124.281 86.3245L121.012 89.5933C121.687 89.7514 122.477 89.8249 123.331 89.8249C127.432 89.8249 130.69 86.5672 130.69 82.4866C130.69 81.3716 130.45 80.3185 130.017 79.3753C129.866 79.0481 129.982 78.6625 130.294 78.4817C130.641 78.2823 131.092 78.4136 131.26 78.7773ZM122.905 69.8379C123.098 69.8503 123.246 69.9225 123.352 70.0469L127.537 74.3062C127.695 74.4747 127.78 74.6637 127.78 74.8541C127.78 75.0445 127.717 75.2233 127.537 75.4027L123.352 79.6304C123.226 79.7569 123.068 79.8201 122.856 79.8201C122.556 79.8201 122.286 79.6386 122.21 79.3485C122.144 79.0914 122.192 78.8398 122.382 78.6494L125.65 75.3814C124.975 75.2233 124.185 75.1497 123.331 75.1497C119.23 75.1497 115.973 78.4067 115.973 82.4866C115.973 83.6106 116.217 84.6727 116.656 85.6213C116.807 85.9478 116.692 86.3355 116.38 86.515C116.033 86.7157 115.582 86.5844 115.414 86.2228C114.886 85.092 114.591 83.8264 114.591 82.4866C114.591 77.6382 118.471 73.7687 123.331 73.7687C124.016 73.7687 124.702 73.8422 125.333 73.9797L122.372 71.0375C122.234 70.8773 122.171 70.6917 122.183 70.4821C122.205 70.093 122.515 69.8132 122.905 69.8379Z\" fill=\"#023F80\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_324_1612\">\n<rect width=\"192\" height=\"98\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var LinealArchivoAdjunto = "<svg width=\"32\" height=\"40\" viewBox=\"0 0 32 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_205_103)\">\n<path d=\"M27.556 31.6667H18.666C17.196 31.6667 16 32.7876 16 34.1667C16 35.5448 17.196 36.6667 18.667 36.6667H24.889C25.0048 36.6675 25.1197 36.6467 25.2271 36.6053C25.3344 36.5639 25.4322 36.5027 25.5147 36.4254C25.5973 36.348 25.663 36.2559 25.7082 36.1543C25.7534 36.0527 25.7771 35.9436 25.778 35.8333C25.7772 35.7229 25.7536 35.6137 25.7084 35.512C25.6632 35.4103 25.5973 35.3181 25.5147 35.2407C25.432 35.1633 25.3341 35.1022 25.2265 35.0608C25.119 35.0195 25.0039 34.9989 24.888 35H18.667C18.433 35.0018 18.2078 34.915 18.0409 34.7587C17.874 34.6025 17.7791 34.3895 17.777 34.1667C17.777 33.7067 18.177 33.3333 18.667 33.3333H27.556C29.026 33.3333 30.222 34.4543 30.222 35.8333C30.222 37.2114 29.026 38.3333 27.556 38.3333H18.666C16.216 38.3333 14.222 36.4638 14.222 34.1667C14.222 31.8695 16.216 30 18.667 30H28.444C28.5599 30.001 28.6749 29.9802 28.7824 29.9389C28.8898 29.8975 28.9877 29.8364 29.0704 29.759C29.153 29.6816 29.2189 29.5895 29.2641 29.4878C29.3093 29.3862 29.3331 29.2771 29.334 29.1667C29.3331 29.0563 29.3093 28.9471 29.2641 28.8455C29.2189 28.7439 29.153 28.6517 29.0704 28.5743C28.9877 28.4969 28.8898 28.4358 28.7824 28.3944C28.6749 28.3531 28.5599 28.3323 28.444 28.3333H24.89V7.5C24.8899 7.39022 24.8669 7.28155 24.8223 7.18033C24.7776 7.07911 24.7123 6.98738 24.63 6.91048L17.518 0.243811C17.3504 0.0872297 17.1248 -0.000333362 16.89 9.53803e-07H3.556C1.595 9.53803e-07 0 1.49524 0 3.33333V28.3333C0 30.1714 1.595 31.6667 3.556 31.6667H13.069C12.6633 32.4437 12.4495 33.2989 12.444 34.1667C12.444 37.3829 15.236 40 18.667 40H27.556C30.006 40 32 38.1305 32 35.8333C32 33.5362 30.006 31.6667 27.556 31.6667ZM17.778 2.84476L21.854 6.66667H19.556C18.576 6.66667 17.778 5.91905 17.778 5V2.84476ZM3.556 30C2.576 30 1.778 29.2524 1.778 28.3333V3.33333C1.778 2.41429 2.576 1.66667 3.556 1.66667H16V5C16 6.8381 17.595 8.33333 19.556 8.33333H23.111V28.3333H18.667C16.977 28.3333 15.448 28.9714 14.326 30H3.556Z\" fill=\"#B6C5D5\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_205_103\">\n<rect width=\"32\" height=\"40\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var LinealBiometriaDefault = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M106.618 44.4681V39.9736C106.618 38.642 107.516 37.7434 108.848 37.7434C110.147 37.7434 111.045 38.642 111.045 39.9736V44.4681C111.045 45.7997 110.147 46.7318 108.848 46.7318C107.516 46.7318 106.618 45.7997 106.618 44.4681ZM106.418 76.7945C106.418 75.4629 107.183 74.7307 108.515 74.7307H116.972C120.634 74.7307 122.764 72.7663 122.764 68.9045V60.5816C122.764 59.25 123.463 58.4843 124.795 58.4843C126.126 58.4843 126.859 59.25 126.859 60.5816V69.1377C126.859 75.5297 123.563 78.8584 117.071 78.8584H108.515C107.183 78.8584 106.418 78.1261 106.418 76.7945ZM122.764 37.2436V28.9206C122.764 25.0922 120.634 23.0945 116.972 23.0945H108.515C107.183 23.0945 106.418 22.3622 106.418 21.0306C106.418 19.7325 107.183 18.9995 108.515 18.9995H117.071C123.563 18.9995 126.859 22.2954 126.859 28.7209V37.2436C126.859 38.6086 126.16 39.3409 124.795 39.3409C123.497 39.3409 122.764 38.6086 122.764 37.2436ZM92.2353 52.6581C92.2353 51.7261 92.9675 50.9931 93.933 50.9931H95.0655C95.5646 50.9931 95.9975 50.6604 95.9975 50.0611V39.4077C95.9975 38.3427 96.6303 37.6766 97.7287 37.6766C98.7609 37.6766 99.4264 38.3427 99.4264 39.4077V49.7618C99.4264 52.8579 97.7955 54.4888 94.7321 54.4888H94.4328C93.0009 54.4888 92.2353 53.8234 92.2353 52.6581ZM86.3096 60.1152C86.0096 59.7157 85.7771 59.3161 85.7771 58.817C85.7771 57.8181 86.5428 57.1193 87.5082 57.1193C88.1075 57.1193 88.5071 57.4186 88.9728 57.885C90.9371 59.8493 93.933 61.1475 96.8962 61.1475C99.9262 61.1475 102.955 59.8493 104.786 57.885C105.353 57.2856 105.752 57.1193 106.251 57.1193C107.217 57.1193 107.983 57.8181 107.983 58.817C107.983 59.3829 107.749 59.8159 107.45 60.1152C104.653 62.912 100.758 64.5763 96.8962 64.5763C93.0009 64.5763 89.0062 63.0116 86.3096 60.1152ZM82.9803 44.4681V39.9736C82.9803 38.642 83.8789 37.7434 85.1778 37.7434C86.5094 37.7434 87.408 38.642 87.408 39.9736V44.4681C87.408 45.7997 86.5094 46.7318 85.1778 46.7318C83.8789 46.7318 82.9803 45.7997 82.9803 44.4681ZM67.0005 69.1377V60.5816C67.0005 59.25 67.6994 58.4843 69.0644 58.4843C70.3959 58.4843 71.1282 59.25 71.1282 60.5816V68.9045C71.1282 72.7663 73.1594 74.7307 76.8875 74.7307H85.3441C86.7091 74.7307 87.4414 75.4629 87.4414 76.7945C87.4414 78.1261 86.7091 78.8584 85.3441 78.8584H76.8214C70.3291 78.8584 67.0005 75.5625 67.0005 69.1377ZM67.0005 37.2436V28.7209C67.0005 22.2627 70.3291 18.9995 76.8214 18.9995H85.3441C86.7091 18.9995 87.4414 19.7325 87.4414 21.0306C87.4414 22.3622 86.7091 23.0945 85.3441 23.0945H76.8875C73.1594 23.0945 71.1282 25.0922 71.1282 28.9206V37.2436C71.1282 38.6086 70.3959 39.3409 69.0644 39.3409C67.7328 39.3409 67.0005 38.6086 67.0005 37.2436Z\" fill=\"#1AAAAD\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M34.2103 73.727C34.4823 73.727 34.7173 73.839 34.9183 74.063L36.2023 75.371L37.4983 74.063C37.7063 73.847 37.9423 73.739 38.2063 73.739C38.4623 73.739 38.6833 73.833 38.8723 74.021C39.0593 74.209 39.1543 74.427 39.1543 74.675C39.1543 74.931 39.0533 75.163 38.8543 75.371L37.4863 76.715L38.9733 78.203C39.1733 78.403 39.2743 78.631 39.2743 78.887C39.2743 79.135 39.1773 79.355 38.9863 79.547C38.7943 79.739 38.5703 79.835 38.3143 79.835C38.0493 79.835 37.8143 79.727 37.6063 79.511L36.2023 78.047L34.8103 79.511C34.6013 79.727 34.3663 79.835 34.1023 79.835C33.8453 79.835 33.6223 79.739 33.4293 79.547C33.2383 79.355 33.1413 79.135 33.1413 78.887C33.1413 78.631 33.2423 78.403 33.4423 78.203L34.9293 76.715L33.5623 75.371C33.3623 75.171 33.2613 74.943 33.2613 74.687C33.2613 74.431 33.3563 74.207 33.5443 74.015C33.7323 73.823 33.9543 73.727 34.2103 73.727ZM45.4105 62.1274C45.6825 62.1274 45.9175 62.2394 46.1185 62.4634L47.4025 63.7714L48.6985 62.4634C48.9065 62.2474 49.1425 62.1394 49.4065 62.1394C49.6625 62.1394 49.8835 62.2334 50.0725 62.4214C50.2595 62.6094 50.3545 62.8274 50.3545 63.0754C50.3545 63.3314 50.2535 63.5634 50.0545 63.7714L48.6865 65.1154L50.1735 66.6034C50.3735 66.8034 50.4745 67.0314 50.4745 67.2874C50.4745 67.5354 50.3775 67.7554 50.1865 67.9474C49.9945 68.1394 49.7705 68.2354 49.5145 68.2354C49.2495 68.2354 49.0145 68.1274 48.8065 67.9114L47.4025 66.4474L46.0105 67.9114C45.8015 68.1274 45.5665 68.2354 45.3025 68.2354C45.0455 68.2354 44.8225 68.1394 44.6295 67.9474C44.4385 67.7554 44.3415 67.5354 44.3415 67.2874C44.3415 67.0314 44.4425 66.8034 44.6425 66.6034L46.1295 65.1154L44.7625 63.7714C44.5625 63.5714 44.4615 63.3434 44.4615 63.0874C44.4615 62.8314 44.5565 62.6074 44.7445 62.4154C44.9325 62.2234 45.1545 62.1274 45.4105 62.1274ZM178.935 60.0604C179.208 60.0604 179.443 60.1724 179.643 60.3964L180.928 61.7044L182.223 60.3964C182.431 60.1804 182.668 60.0724 182.931 60.0724C183.187 60.0724 183.409 60.1664 183.597 60.3544C183.785 60.5424 183.88 60.7604 183.88 61.0084C183.88 61.2644 183.779 61.4964 183.58 61.7044L182.212 63.0484L183.699 64.5364C183.899 64.7364 184 64.9644 184 65.2204C184 65.4684 183.903 65.6884 183.712 65.8804C183.519 66.0724 183.296 66.1684 183.04 66.1684C182.775 66.1684 182.54 66.0604 182.332 65.8444L180.928 64.3804L179.536 65.8444C179.327 66.0604 179.092 66.1684 178.828 66.1684C178.571 66.1684 178.347 66.0724 178.155 65.8804C177.964 65.6884 177.867 65.4684 177.867 65.2204C177.867 64.9644 177.968 64.7364 178.168 64.5364L179.655 63.0484L178.288 61.7044C178.088 61.5044 177.987 61.2764 177.987 61.0204C177.987 60.7644 178.082 60.5404 178.269 60.3484C178.458 60.1564 178.679 60.0604 178.935 60.0604ZM150.051 56.9272C150.323 56.9272 150.558 57.0392 150.759 57.2632L152.043 58.5712L153.339 57.2632C153.547 57.0472 153.783 56.9392 154.047 56.9392C154.303 56.9392 154.524 57.0332 154.713 57.2212C154.9 57.4092 154.995 57.6272 154.995 57.8752C154.995 58.1312 154.894 58.3632 154.695 58.5712L153.327 59.9152L154.814 61.4032C155.014 61.6032 155.115 61.8312 155.115 62.0872C155.115 62.3352 155.018 62.5552 154.827 62.7472C154.635 62.9392 154.411 63.0352 154.155 63.0352C153.89 63.0352 153.655 62.9272 153.447 62.7112L152.043 61.2472L150.651 62.7112C150.442 62.9272 150.207 63.0352 149.943 63.0352C149.686 63.0352 149.463 62.9392 149.27 62.7472C149.079 62.5552 148.982 62.3352 148.982 62.0872C148.982 61.8312 149.083 61.6032 149.283 61.4032L150.77 59.9152L149.403 58.5712C149.203 58.3712 149.102 58.1432 149.102 57.8872C149.102 57.6312 149.197 57.4072 149.385 57.2152C149.573 57.0232 149.795 56.9272 150.051 56.9272ZM27.5687 53.7988C27.8407 53.7988 28.0757 53.9108 28.2767 54.1348L29.5607 55.4428L30.8567 54.1348C31.0647 53.9188 31.3007 53.8108 31.5647 53.8108C31.8207 53.8108 32.0417 53.9048 32.2307 54.0928C32.4177 54.2808 32.5127 54.4988 32.5127 54.7468C32.5127 55.0028 32.4117 55.2348 32.2127 55.4428L30.8447 56.7868L32.3317 58.2748C32.5317 58.4748 32.6327 58.7028 32.6327 58.9588C32.6327 59.2068 32.5357 59.4268 32.3447 59.6188C32.1527 59.8108 31.9287 59.9068 31.6727 59.9068C31.4077 59.9068 31.1727 59.7988 30.9647 59.5828L29.5607 58.1188L28.1687 59.5828C27.9597 59.7988 27.7247 59.9068 27.4607 59.9068C27.2037 59.9068 26.9807 59.8108 26.7877 59.6188C26.5967 59.4268 26.4997 59.2068 26.4997 58.9588C26.4997 58.7028 26.6007 58.4748 26.8007 58.2748L28.2877 56.7868L26.9207 55.4428C26.7207 55.2428 26.6197 55.0148 26.6197 54.7588C26.6197 54.5028 26.7147 54.2788 26.9027 54.0868C27.0907 53.8948 27.3127 53.7988 27.5687 53.7988ZM165.651 46.5276C165.924 46.5276 166.159 46.6396 166.359 46.8636L167.644 48.1716L168.939 46.8636C169.147 46.6476 169.384 46.5396 169.647 46.5396C169.903 46.5396 170.125 46.6336 170.313 46.8216C170.501 47.0096 170.596 47.2276 170.596 47.4756C170.596 47.7316 170.495 47.9636 170.296 48.1716L168.928 49.5156L170.415 51.0036C170.615 51.2036 170.716 51.4316 170.716 51.6876C170.716 51.9356 170.619 52.1556 170.428 52.3476C170.235 52.5396 170.012 52.6356 169.756 52.6356C169.491 52.6356 169.256 52.5276 169.048 52.3116L167.644 50.8476L166.252 52.3116C166.043 52.5276 165.808 52.6356 165.544 52.6356C165.287 52.6356 165.063 52.5396 164.871 52.3476C164.68 52.1556 164.583 51.9356 164.583 51.6876C164.583 51.4316 164.684 51.2036 164.884 51.0036L166.371 49.5156L165.004 48.1716C164.804 47.9716 164.703 47.7436 164.703 47.4876C164.703 47.2316 164.798 47.0076 164.985 46.8156C165.174 46.6236 165.395 46.5276 165.651 46.5276ZM9.069 42.5986C9.341 42.5986 9.576 42.7106 9.777 42.9346L11.061 44.2426L12.357 42.9346C12.565 42.7186 12.801 42.6106 13.065 42.6106C13.321 42.6106 13.542 42.7046 13.731 42.8926C13.918 43.0806 14.013 43.2986 14.013 43.5466C14.013 43.8026 13.912 44.0346 13.713 44.2426L12.345 45.5866L13.832 47.0746C14.032 47.2746 14.133 47.5026 14.133 47.7586C14.133 48.0066 14.036 48.2266 13.845 48.4186C13.653 48.6106 13.429 48.7066 13.173 48.7066C12.908 48.7066 12.673 48.5986 12.465 48.3826L11.061 46.9186L9.669 48.3826C9.46 48.5986 9.225 48.7066 8.961 48.7066C8.704 48.7066 8.481 48.6106 8.288 48.4186C8.097 48.2266 8 48.0066 8 47.7586C8 47.5026 8.101 47.2746 8.301 47.0746L9.788 45.5866L8.421 44.2426C8.221 44.0426 8.12 43.8146 8.12 43.5586C8.12 43.3026 8.215 43.0786 8.403 42.8866C8.591 42.6946 8.813 42.5986 9.069 42.5986ZM39.81 40.6736C40.082 40.6736 40.317 40.7856 40.518 41.0096L41.802 42.3176L43.098 41.0096C43.306 40.7936 43.542 40.6856 43.806 40.6856C44.062 40.6856 44.283 40.7796 44.472 40.9676C44.659 41.1556 44.754 41.3736 44.754 41.6216C44.754 41.8776 44.653 42.1096 44.454 42.3176L43.086 43.6616L44.573 45.1496C44.773 45.3496 44.874 45.5776 44.874 45.8336C44.874 46.0816 44.777 46.3016 44.586 46.4936C44.394 46.6856 44.17 46.7816 43.914 46.7816C43.649 46.7816 43.414 46.6736 43.206 46.4576L41.802 44.9936L40.41 46.4576C40.201 46.6736 39.966 46.7816 39.702 46.7816C39.445 46.7816 39.222 46.6856 39.029 46.4936C38.838 46.3016 38.741 46.0816 38.741 45.8336C38.741 45.5776 38.842 45.3496 39.042 45.1496L40.529 43.6616L39.162 42.3176C38.962 42.1176 38.861 41.8896 38.861 41.6336C38.861 41.3776 38.956 41.1536 39.144 40.9616C39.332 40.7696 39.554 40.6736 39.81 40.6736ZM150.051 36.6733C150.323 36.6733 150.558 36.7853 150.759 37.0093L152.043 38.3173L153.339 37.0093C153.547 36.7933 153.783 36.6853 154.047 36.6853C154.303 36.6853 154.524 36.7793 154.713 36.9673C154.9 37.1553 154.995 37.3733 154.995 37.6213C154.995 37.8773 154.894 38.1093 154.695 38.3173L153.327 39.6613L154.814 41.1493C155.014 41.3493 155.115 41.5773 155.115 41.8333C155.115 42.0813 155.018 42.3013 154.827 42.4933C154.635 42.6853 154.411 42.7813 154.155 42.7813C153.89 42.7813 153.655 42.6733 153.447 42.4573L152.043 40.9933L150.651 42.4573C150.442 42.6733 150.207 42.7813 149.943 42.7813C149.686 42.7813 149.463 42.6853 149.27 42.4933C149.079 42.3013 148.982 42.0813 148.982 41.8333C148.982 41.5773 149.083 41.3493 149.283 41.1493L150.77 39.6613L149.403 38.3173C149.203 38.1173 149.102 37.8893 149.102 37.6333C149.102 37.3773 149.197 37.1533 149.385 36.9613C149.573 36.7693 149.795 36.6733 150.051 36.6733Z\" fill=\"#B6C5D5\"/>\n</svg>";

var LinealBiometriaWarning = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M106.618 29.4686V24.9741C106.618 23.6425 107.516 22.7439 108.848 22.7439C110.147 22.7439 111.045 23.6425 111.045 24.9741V29.4686C111.045 30.8002 110.147 31.7323 108.848 31.7323C107.516 31.7323 106.618 30.8002 106.618 29.4686ZM106.418 61.795C106.418 60.4634 107.183 59.7311 108.515 59.7311H116.972C120.634 59.7311 122.764 57.7668 122.764 53.905V45.582C122.764 44.2505 123.463 43.4848 124.795 43.4848C126.126 43.4848 126.859 44.2505 126.859 45.582V54.1382C126.859 60.5302 123.563 63.8589 117.071 63.8589H108.515C107.183 63.8589 106.418 63.1266 106.418 61.795ZM122.764 22.2441V13.9211C122.764 10.0927 120.634 8.095 116.972 8.095H108.515C107.183 8.095 106.418 7.36273 106.418 6.03114C106.418 4.73296 107.183 4 108.515 4H117.071C123.563 4 126.859 7.29591 126.859 13.7214V22.2441C126.859 23.6091 126.16 24.3414 124.795 24.3414C123.497 24.3414 122.764 23.6091 122.764 22.2441ZM92.2353 37.6586C92.2353 36.7266 92.9675 35.9936 93.933 35.9936H95.0655C95.5646 35.9936 95.9975 35.6609 95.9975 35.0616V24.4082C95.9975 23.3432 96.6303 22.677 97.7287 22.677C98.7609 22.677 99.4264 23.3432 99.4264 24.4082V34.7623C99.4264 37.8584 97.7955 39.4893 94.7321 39.4893H94.4328C93.0009 39.4893 92.2353 38.8239 92.2353 37.6586ZM86.3096 45.1157C86.0096 44.7161 85.7771 44.3166 85.7771 43.8175C85.7771 42.8186 86.5428 42.1198 87.5082 42.1198C88.1075 42.1198 88.5071 42.4191 88.9728 42.8855C90.9371 44.8498 93.933 46.148 96.8962 46.148C99.9262 46.148 102.955 44.8498 104.786 42.8855C105.353 42.2861 105.752 42.1198 106.251 42.1198C107.217 42.1198 107.983 42.8186 107.983 43.8175C107.983 44.3834 107.749 44.8164 107.45 45.1157C104.653 47.9125 100.758 49.5768 96.8962 49.5768C93.0009 49.5768 89.0062 48.012 86.3096 45.1157ZM82.9803 29.4686V24.9741C82.9803 23.6425 83.8789 22.7439 85.1778 22.7439C86.5094 22.7439 87.408 23.6425 87.408 24.9741V29.4686C87.408 30.8002 86.5094 31.7323 85.1778 31.7323C83.8789 31.7323 82.9803 30.8002 82.9803 29.4686ZM67.0005 54.1382V45.582C67.0005 44.2505 67.6994 43.4848 69.0644 43.4848C70.3959 43.4848 71.1282 44.2505 71.1282 45.582V53.905C71.1282 57.7668 73.1594 59.7311 76.8875 59.7311H85.3441C86.7091 59.7311 87.4414 60.4634 87.4414 61.795C87.4414 63.1266 86.7091 63.8589 85.3441 63.8589H76.8214C70.3291 63.8589 67.0005 60.563 67.0005 54.1382ZM67.0005 22.2441V13.7214C67.0005 7.26318 70.3291 4 76.8214 4H85.3441C86.7091 4 87.4414 4.73296 87.4414 6.03114C87.4414 7.36273 86.7091 8.095 85.3441 8.095H76.8875C73.1594 8.095 71.1282 10.0927 71.1282 13.9211V22.2441C71.1282 23.6091 70.3959 24.3414 69.0644 24.3414C67.7328 24.3414 67.0005 23.6091 67.0005 22.2441Z\" fill=\"#B6C5D5\"/>\n<path d=\"M132 94.0005C143.598 94.0005 153 84.5985 153 73.0005C153 61.4025 143.598 52.0005 132 52.0005C120.402 52.0005 111 61.4025 111 73.0005C111 84.5985 120.402 94.0005 132 94.0005Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M34.2103 58.7275C34.4823 58.7275 34.7173 58.8395 34.9183 59.0635L36.2023 60.3715L37.4983 59.0635C37.7063 58.8475 37.9423 58.7395 38.2063 58.7395C38.4623 58.7395 38.6833 58.8335 38.8723 59.0215C39.0593 59.2095 39.1543 59.4275 39.1543 59.6755C39.1543 59.9315 39.0533 60.1635 38.8543 60.3715L37.4863 61.7155L38.9733 63.2035C39.1733 63.4035 39.2743 63.6315 39.2743 63.8875C39.2743 64.1355 39.1773 64.3555 38.9863 64.5475C38.7943 64.7395 38.5703 64.8355 38.3143 64.8355C38.0493 64.8355 37.8143 64.7275 37.6063 64.5115L36.2023 63.0475L34.8103 64.5115C34.6013 64.7275 34.3663 64.8355 34.1023 64.8355C33.8453 64.8355 33.6223 64.7395 33.4293 64.5475C33.2383 64.3555 33.1413 64.1355 33.1413 63.8875C33.1413 63.6315 33.2423 63.4035 33.4423 63.2035L34.9293 61.7155L33.5623 60.3715C33.3623 60.1715 33.2613 59.9435 33.2613 59.6875C33.2613 59.4315 33.3563 59.2075 33.5443 59.0155C33.7323 58.8235 33.9543 58.7275 34.2103 58.7275ZM45.4105 47.1279C45.6825 47.1279 45.9175 47.2399 46.1185 47.4639L47.4025 48.7719L48.6985 47.4639C48.9065 47.2479 49.1425 47.1399 49.4065 47.1399C49.6625 47.1399 49.8835 47.2339 50.0725 47.4219C50.2595 47.6099 50.3545 47.8279 50.3545 48.0759C50.3545 48.3319 50.2535 48.5639 50.0545 48.7719L48.6865 50.1159L50.1735 51.6039C50.3735 51.8039 50.4745 52.0319 50.4745 52.2879C50.4745 52.5359 50.3775 52.7559 50.1865 52.9479C49.9945 53.1399 49.7705 53.2359 49.5145 53.2359C49.2495 53.2359 49.0145 53.1279 48.8065 52.9119L47.4025 51.4479L46.0105 52.9119C45.8015 53.1279 45.5665 53.2359 45.3025 53.2359C45.0455 53.2359 44.8225 53.1399 44.6295 52.9479C44.4385 52.7559 44.3415 52.5359 44.3415 52.2879C44.3415 52.0319 44.4425 51.8039 44.6425 51.6039L46.1295 50.1159L44.7625 48.7719C44.5625 48.5719 44.4615 48.3439 44.4615 48.0879C44.4615 47.8319 44.5565 47.6079 44.7445 47.4159C44.9325 47.2239 45.1545 47.1279 45.4105 47.1279ZM178.935 45.0609C179.208 45.0609 179.443 45.1729 179.643 45.3969L180.928 46.7049L182.223 45.3969C182.431 45.1809 182.668 45.0729 182.931 45.0729C183.187 45.0729 183.409 45.1669 183.597 45.3549C183.785 45.5429 183.88 45.7609 183.88 46.0089C183.88 46.2649 183.779 46.4969 183.58 46.7049L182.212 48.0489L183.699 49.5369C183.899 49.7369 184 49.9649 184 50.2209C184 50.4689 183.903 50.6889 183.712 50.8809C183.519 51.0729 183.296 51.1689 183.04 51.1689C182.775 51.1689 182.54 51.0609 182.332 50.8449L180.928 49.3809L179.536 50.8449C179.327 51.0609 179.092 51.1689 178.828 51.1689C178.571 51.1689 178.347 51.0729 178.155 50.8809C177.964 50.6889 177.867 50.4689 177.867 50.2209C177.867 49.9649 177.968 49.7369 178.168 49.5369L179.655 48.0489L178.288 46.7049C178.088 46.5049 177.987 46.2769 177.987 46.0209C177.987 45.7649 178.082 45.5409 178.269 45.3489C178.458 45.1569 178.679 45.0609 178.935 45.0609ZM150.051 41.9277C150.323 41.9277 150.558 42.0397 150.759 42.2637L152.043 43.5717L153.339 42.2637C153.547 42.0477 153.783 41.9397 154.047 41.9397C154.303 41.9397 154.524 42.0337 154.713 42.2217C154.9 42.4097 154.995 42.6277 154.995 42.8757C154.995 43.1317 154.894 43.3637 154.695 43.5717L153.327 44.9157L154.814 46.4037C155.014 46.6037 155.115 46.8317 155.115 47.0877C155.115 47.3357 155.018 47.5557 154.827 47.7477C154.635 47.9397 154.411 48.0357 154.155 48.0357C153.89 48.0357 153.655 47.9277 153.447 47.7117L152.043 46.2477L150.651 47.7117C150.442 47.9277 150.207 48.0357 149.943 48.0357C149.686 48.0357 149.463 47.9397 149.27 47.7477C149.079 47.5557 148.982 47.3357 148.982 47.0877C148.982 46.8317 149.083 46.6037 149.283 46.4037L150.77 44.9157L149.403 43.5717C149.203 43.3717 149.102 43.1437 149.102 42.8877C149.102 42.6317 149.197 42.4077 149.385 42.2157C149.573 42.0237 149.795 41.9277 150.051 41.9277ZM27.5687 38.7993C27.8407 38.7993 28.0757 38.9113 28.2767 39.1353L29.5607 40.4433L30.8567 39.1353C31.0647 38.9193 31.3007 38.8113 31.5647 38.8113C31.8207 38.8113 32.0417 38.9053 32.2307 39.0933C32.4177 39.2813 32.5127 39.4993 32.5127 39.7473C32.5127 40.0033 32.4117 40.2353 32.2127 40.4433L30.8447 41.7873L32.3317 43.2753C32.5317 43.4753 32.6327 43.7033 32.6327 43.9593C32.6327 44.2073 32.5357 44.4273 32.3447 44.6193C32.1527 44.8113 31.9287 44.9073 31.6727 44.9073C31.4077 44.9073 31.1727 44.7993 30.9647 44.5833L29.5607 43.1193L28.1687 44.5833C27.9597 44.7993 27.7247 44.9073 27.4607 44.9073C27.2037 44.9073 26.9807 44.8113 26.7877 44.6193C26.5967 44.4273 26.4997 44.2073 26.4997 43.9593C26.4997 43.7033 26.6007 43.4753 26.8007 43.2753L28.2877 41.7873L26.9207 40.4433C26.7207 40.2433 26.6197 40.0153 26.6197 39.7593C26.6197 39.5033 26.7147 39.2793 26.9027 39.0873C27.0907 38.8953 27.3127 38.7993 27.5687 38.7993ZM165.651 31.5281C165.924 31.5281 166.159 31.6401 166.359 31.8641L167.644 33.1721L168.939 31.8641C169.147 31.6481 169.384 31.5401 169.647 31.5401C169.903 31.5401 170.125 31.6341 170.313 31.8221C170.501 32.0101 170.596 32.2281 170.596 32.4761C170.596 32.7321 170.495 32.9641 170.296 33.1721L168.928 34.5161L170.415 36.0041C170.615 36.2041 170.716 36.4321 170.716 36.6881C170.716 36.9361 170.619 37.1561 170.428 37.3481C170.235 37.5401 170.012 37.6361 169.756 37.6361C169.491 37.6361 169.256 37.5281 169.048 37.3121L167.644 35.8481L166.252 37.3121C166.043 37.5281 165.808 37.6361 165.544 37.6361C165.287 37.6361 165.063 37.5401 164.871 37.3481C164.68 37.1561 164.583 36.9361 164.583 36.6881C164.583 36.4321 164.684 36.2041 164.884 36.0041L166.371 34.5161L165.004 33.1721C164.804 32.9721 164.703 32.7441 164.703 32.4881C164.703 32.2321 164.798 32.0081 164.985 31.8161C165.174 31.6241 165.395 31.5281 165.651 31.5281ZM9.069 27.5991C9.341 27.5991 9.576 27.7111 9.777 27.9351L11.061 29.2431L12.357 27.9351C12.565 27.7191 12.801 27.6111 13.065 27.6111C13.321 27.6111 13.542 27.7051 13.731 27.8931C13.918 28.0811 14.013 28.2991 14.013 28.5471C14.013 28.8031 13.912 29.0351 13.713 29.2431L12.345 30.5871L13.832 32.0751C14.032 32.2751 14.133 32.5031 14.133 32.7591C14.133 33.0071 14.036 33.2271 13.845 33.4191C13.653 33.6111 13.429 33.7071 13.173 33.7071C12.908 33.7071 12.673 33.5991 12.465 33.3831L11.061 31.9191L9.669 33.3831C9.46 33.5991 9.225 33.7071 8.961 33.7071C8.704 33.7071 8.481 33.6111 8.288 33.4191C8.097 33.2271 8 33.0071 8 32.7591C8 32.5031 8.101 32.2751 8.301 32.0751L9.788 30.5871L8.421 29.2431C8.221 29.0431 8.12 28.8151 8.12 28.5591C8.12 28.3031 8.215 28.0791 8.403 27.8871C8.591 27.6951 8.813 27.5991 9.069 27.5991ZM39.81 25.6741C40.082 25.6741 40.317 25.7861 40.518 26.0101L41.802 27.3181L43.098 26.0101C43.306 25.7941 43.542 25.6861 43.806 25.6861C44.062 25.6861 44.283 25.7801 44.472 25.9681C44.659 26.1561 44.754 26.3741 44.754 26.6221C44.754 26.8781 44.653 27.1101 44.454 27.3181L43.086 28.6621L44.573 30.1501C44.773 30.3501 44.874 30.5781 44.874 30.8341C44.874 31.0821 44.777 31.3021 44.586 31.4941C44.394 31.6861 44.17 31.7821 43.914 31.7821C43.649 31.7821 43.414 31.6741 43.206 31.4581L41.802 29.9941L40.41 31.4581C40.201 31.6741 39.966 31.7821 39.702 31.7821C39.445 31.7821 39.222 31.6861 39.029 31.4941C38.838 31.3021 38.741 31.0821 38.741 30.8341C38.741 30.5781 38.842 30.3501 39.042 30.1501L40.529 28.6621L39.162 27.3181C38.962 27.1181 38.861 26.8901 38.861 26.6341C38.861 26.3781 38.956 26.1541 39.144 25.9621C39.332 25.7701 39.554 25.6741 39.81 25.6741ZM150.051 21.6738C150.323 21.6738 150.558 21.7858 150.759 22.0098L152.043 23.3178L153.339 22.0098C153.547 21.7938 153.783 21.6858 154.047 21.6858C154.303 21.6858 154.524 21.7798 154.713 21.9678C154.9 22.1558 154.995 22.3738 154.995 22.6218C154.995 22.8778 154.894 23.1098 154.695 23.3178L153.327 24.6618L154.814 26.1498C155.014 26.3498 155.115 26.5778 155.115 26.8338C155.115 27.0818 155.018 27.3018 154.827 27.4938C154.635 27.6858 154.411 27.7818 154.155 27.7818C153.89 27.7818 153.655 27.6738 153.447 27.4578L152.043 25.9938L150.651 27.4578C150.442 27.6738 150.207 27.7818 149.943 27.7818C149.686 27.7818 149.463 27.6858 149.27 27.4938C149.079 27.3018 148.982 27.0818 148.982 26.8338C148.982 26.5778 149.083 26.3498 149.283 26.1498L150.77 24.6618L149.403 23.3178C149.203 23.1178 149.102 22.8898 149.102 22.6338C149.102 22.3778 149.197 22.1538 149.385 21.9618C149.573 21.7698 149.795 21.6738 150.051 21.6738Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M132 91.1584C142.051 91.1584 150.333 82.8608 150.333 72.8154C150.333 62.7892 142.031 54.4917 132 54.4917C121.949 54.4917 113.667 62.7892 113.667 72.8154C113.667 82.8608 121.968 91.1584 132 91.1584ZM132.308 75.6647C133.136 75.6647 133.645 75.1552 133.645 74.2422L133.9 63.5628C133.921 62.6711 133.221 61.9917 132.286 61.9917C131.331 61.9917 130.673 62.6499 130.694 63.5628L130.928 74.2422C130.949 75.1552 131.437 75.6647 132.308 75.6647ZM132.308 81.9917C131.246 81.9917 130.333 81.1212 130.333 80.0809C130.333 79.0193 131.225 78.17 132.308 78.17C133.39 78.17 134.282 78.9981 134.282 80.0809C134.282 81.1424 133.369 81.9917 132.308 81.9917Z\" fill=\"#FECF2F\"/>\n</svg>";

var LinealBtnDePagoDefault = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g opacity=\"0.6\">\n<path opacity=\"0.6\" d=\"M16.4908 70.4816C16.785 70.4816 17.0403 70.5925 17.261 70.8131C17.4796 71.0347 17.5909 71.2873 17.5909 71.5718C17.5909 71.8674 17.4756 72.1299 17.247 72.3605L15.5438 74.0717L17.1089 75.6182C17.3375 75.8478 17.4537 76.1104 17.4537 76.4049C17.4537 76.6994 17.3444 76.957 17.1298 77.1786C16.9141 77.3992 16.6597 77.5101 16.3666 77.5101C16.0555 77.5101 15.7862 77.3803 15.5557 77.1227L14.085 75.6182L12.6013 77.1227C12.3628 77.3723 12.0925 77.4961 11.7904 77.4961C11.4972 77.4961 11.2438 77.3873 11.0282 77.1716C10.8136 76.955 10.7052 76.7044 10.7052 76.4189C10.7052 76.1243 10.8205 75.8578 11.0481 75.6182L12.6152 74.0717L10.9119 72.3595C10.6834 72.1299 10.5671 71.8674 10.5671 71.5728C10.5671 71.2873 10.6784 71.0337 10.897 70.8141C11.1176 70.5925 11.374 70.4816 11.6672 70.4816C11.9703 70.4816 12.2396 70.6064 12.4781 70.855L14.086 72.5392L15.6799 70.855C15.9184 70.6054 16.1887 70.4816 16.4908 70.4816ZM40.67 66.9674C40.9642 66.9674 41.2196 67.0783 41.4402 67.2999C41.6588 67.5205 41.7701 67.7741 41.7701 68.0586C41.7701 68.3532 41.6548 68.6157 41.4253 68.8463L39.723 70.5575L41.2881 72.105C41.5167 72.3346 41.633 72.5972 41.633 72.8917C41.633 73.1862 41.5237 73.4438 41.309 73.6644C41.0934 73.885 40.839 73.9958 40.5458 73.9958C40.2348 73.9958 39.9655 73.8661 39.7349 73.6095L38.2642 72.104L36.7805 73.6095C36.542 73.8581 36.2717 73.9819 35.9696 73.9819C35.6765 73.9819 35.4231 73.8741 35.2074 73.6574C34.9928 73.4418 34.8845 73.1902 34.8845 72.9046C34.8845 72.6101 34.9997 72.3436 35.2273 72.104L36.7944 70.5575L35.0912 68.8463C34.8626 68.6167 34.7463 68.3532 34.7463 68.0586C34.7463 67.7741 34.8576 67.5205 35.0762 67.2999C35.2959 67.0783 35.5532 66.9684 35.8464 66.9684C36.1495 66.9684 36.4188 67.0922 36.6573 67.3408L38.2652 69.025L39.8591 67.3408C40.0976 67.0922 40.3679 66.9684 40.67 66.9684V66.9674ZM166.539 64.6392C166.834 64.6392 167.086 64.749 167.303 64.9696C167.517 65.1912 167.625 65.4488 167.625 65.7433C167.625 66.0378 167.51 66.3004 167.28 66.53L165.715 68.0775L167.418 69.7887C167.646 70.0183 167.763 70.2809 167.763 70.5754C167.763 70.8609 167.65 71.1145 167.432 71.3341C167.213 71.5558 166.955 71.6666 166.663 71.6666C166.36 71.6666 166.09 71.5418 165.851 71.2932L164.258 69.609L162.65 71.2932C162.41 71.5428 162.143 71.6666 161.838 71.6666C161.545 71.6666 161.29 71.5568 161.068 71.3351C160.849 71.1145 160.74 70.8609 160.74 70.5764C160.74 70.2809 160.854 70.0183 161.084 69.7887L162.786 68.0765L161.22 66.53C160.992 66.2904 160.875 66.0239 160.875 65.7294C160.875 65.4438 160.985 65.1932 161.201 64.9766C161.415 64.761 161.67 64.6521 161.963 64.6521C162.264 64.6521 162.537 64.7769 162.773 65.0255L164.258 66.53L165.728 65.0255C165.958 64.768 166.225 64.6392 166.54 64.6392H166.539ZM5.9237 47.9209C6.21785 47.9209 6.47324 48.0317 6.69386 48.2523C6.91248 48.4739 7.02378 48.7265 7.02378 49.0111C7.02378 49.3066 6.9085 49.5691 6.67895 49.7998L4.97667 51.5109L6.54181 53.0574C6.77037 53.287 6.88664 53.5496 6.88664 53.8441C6.88664 54.1386 6.77733 54.3962 6.56268 54.6178C6.34704 54.8374 6.09264 54.9493 5.79949 54.9493C5.48844 54.9493 5.21914 54.8195 4.98859 54.5619L3.51785 53.0574L2.03419 54.5619C1.79569 54.8115 1.5254 54.9353 1.2233 54.9353C0.930144 54.9353 0.676739 54.8265 0.461097 54.6108C0.246448 54.3942 0.13813 54.1436 0.13813 53.8581C0.13813 53.5635 0.253405 53.297 0.480972 53.0574L2.04811 51.5109L0.344829 49.7988C0.116268 49.5691 0 49.3066 0 49.0121C0 48.7265 0.111299 48.4729 0.329923 48.2533C0.550534 48.0317 0.80692 47.9209 1.10007 47.9209C1.40317 47.9209 1.67247 48.0456 1.91097 48.2942L3.51885 49.9785L5.11281 48.2942C5.35131 48.0446 5.62161 47.9209 5.9237 47.9209ZM190.638 47.9209C190.931 47.9209 191.182 48.0317 191.4 48.2523C191.615 48.4739 191.722 48.7315 191.722 49.026C191.722 49.3205 191.608 49.5831 191.377 49.8127L189.812 51.3592L191.515 53.0714C191.744 53.301 191.86 53.5635 191.86 53.8581C191.86 54.1436 191.748 54.3972 191.529 54.6168C191.311 54.8384 191.052 54.9493 190.76 54.9493C190.458 54.9493 190.188 54.8245 189.948 54.5759L188.355 52.8917L186.747 54.5759C186.508 54.8255 186.24 54.9493 185.935 54.9493C185.642 54.9493 185.388 54.8384 185.165 54.6178C184.947 54.3962 184.837 54.1436 184.837 53.8581C184.837 53.5635 184.952 53.301 185.181 53.0714L186.883 51.3592L185.317 49.8127C185.09 49.5731 184.972 49.3066 184.972 49.0121C184.972 48.7265 185.083 48.4759 185.298 48.2593C185.512 48.0436 185.767 47.9348 186.061 47.9348C186.362 47.9348 186.634 48.0596 186.87 48.3082L188.355 49.8127L189.826 48.3082C190.055 48.0496 190.323 47.9209 190.638 47.9209ZM37.1786 40.525C37.4718 40.525 37.7252 40.6349 37.9408 40.8565C38.1555 41.0771 38.2638 41.3357 38.2638 41.6292C38.2638 41.9237 38.1485 42.1863 37.919 42.4169L36.3538 43.9624L38.0561 45.6746C38.2857 45.9042 38.401 46.1677 38.401 46.4623C38.401 46.7468 38.2906 47.0004 38.071 47.221C37.8524 47.4416 37.595 47.5525 37.3009 47.5525C36.9988 47.5525 36.7295 47.4287 36.49 47.1801L34.896 45.4959L33.2881 47.1801C33.0496 47.4287 32.7813 47.5525 32.4772 47.5525C32.1841 47.5525 31.9287 47.4426 31.7071 47.221C31.4885 47.0004 31.3772 46.7468 31.3772 46.4623C31.3772 46.1677 31.4934 45.9052 31.722 45.6746L33.4253 43.9624L31.8581 42.4169C31.6306 42.1773 31.5153 41.9098 31.5153 41.6152C31.5153 41.3307 31.6246 41.0791 31.8393 40.8635C32.0539 40.6469 32.3083 40.539 32.6015 40.539C32.9026 40.539 33.1749 40.6628 33.4124 40.9114L34.896 42.4169L36.3668 40.9114C36.5963 40.6538 36.8656 40.525 37.1786 40.525ZM168.775 33.4966C169.069 33.4966 169.322 33.6075 169.538 33.8291C169.752 34.0487 169.861 34.3073 169.861 34.6018C169.861 34.8963 169.745 35.1589 169.516 35.3885L167.951 36.936L169.653 38.6471C169.882 38.8768 169.998 39.1393 169.998 39.4338C169.998 39.7194 169.887 39.973 169.668 40.1936C169.449 40.4142 169.192 40.525 168.898 40.525C168.596 40.525 168.326 40.4003 168.087 40.1517L166.493 38.4674L164.885 40.1517C164.646 40.4013 164.378 40.525 164.074 40.525C163.781 40.525 163.525 40.4152 163.304 40.1936C163.085 39.973 162.974 39.7194 162.974 39.4348C162.974 39.1393 163.09 38.8778 163.319 38.6471L165.022 36.935L163.455 35.3885C163.227 35.1489 163.112 34.8824 163.112 34.5878C163.112 34.3023 163.221 34.0517 163.436 33.8351C163.651 33.6194 163.905 33.5116 164.198 33.5116C164.499 33.5116 164.772 33.6354 165.009 33.884L166.493 35.3885L167.964 33.884C168.193 33.6264 168.462 33.4976 168.775 33.4976V33.4966ZM20.3668 22.957C20.6609 22.957 20.9163 23.0668 21.1369 23.2885C21.3555 23.5091 21.4668 23.7627 21.4668 24.0472C21.4668 24.3417 21.3516 24.6043 21.123 24.8349L19.4187 26.5461L20.9839 28.0916C21.2124 28.3212 21.3287 28.5847 21.3287 28.8793C21.3287 29.1738 21.2194 29.4313 21.0048 29.652C20.7891 29.8726 20.5347 29.9834 20.2416 29.9834C19.9305 29.9834 19.6612 29.8546 19.4307 29.5971L17.9599 28.0916L16.4763 29.5971C16.2378 29.8457 15.9675 29.9695 15.6654 29.9695C15.3722 29.9695 15.1188 29.8616 14.9032 29.645C14.6885 29.4293 14.5802 29.1778 14.5802 28.8932C14.5802 28.5987 14.6955 28.3312 14.923 28.0916L16.4902 26.5461L14.7869 24.8339C14.5583 24.6043 14.4421 24.3407 14.4421 24.0462C14.4421 23.7617 14.5534 23.5081 14.772 23.2875C14.9926 23.0658 15.249 22.956 15.5421 22.956C15.8452 22.956 16.1145 23.0798 16.353 23.3284L17.9609 25.0126L19.5549 23.3284C19.7934 23.0798 20.0637 22.956 20.3658 22.956L20.3668 22.957ZM147.385 2C147.678 2 147.932 2.10982 148.147 2.33145C148.362 2.55209 148.47 2.81066 148.47 3.10518C148.47 3.39969 148.355 3.66126 148.125 3.89188L146.56 5.43833L148.263 7.15051C148.492 7.38013 148.607 7.64269 148.607 7.93721C148.607 8.22274 148.497 8.47632 148.278 8.69596C148.059 8.91759 147.802 9.02741 147.507 9.02741C147.205 9.02741 146.936 8.90361 146.696 8.65502L145.103 6.9708L143.495 8.65502C143.256 8.90361 142.988 9.02741 142.684 9.02741C142.391 9.02741 142.135 8.91759 141.914 8.69695C141.695 8.47532 141.584 8.22274 141.584 7.93721C141.584 7.64269 141.7 7.38013 141.929 7.15051L143.632 5.43833L142.065 3.89088C141.837 3.65227 141.722 3.38571 141.722 3.0912C141.722 2.80567 141.831 2.55508 142.046 2.33844C142.26 2.1218 142.515 2.01398 142.808 2.01398C143.109 2.01398 143.381 2.13877 143.619 2.38636L145.103 3.89188L146.573 2.38636C146.803 2.12879 147.072 2 147.385 2Z\" fill=\"#B6C5D5\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M138.015 18.1304C144.033 18.1304 148.911 23.0088 148.911 29.0266V70.8204C148.911 76.8383 144.033 81.7167 138.015 81.7167H98.7117L86.3844 93.6636C83.2598 96.6918 78.0307 94.4777 78.0307 90.1264V81.7167H63.3831C57.3652 81.7167 52.4868 76.8383 52.4868 70.8204V29.0266C52.4868 23.0088 57.3652 18.1304 63.3831 18.1304H138.015ZM63.3831 23.0561C60.0856 23.0561 57.4125 25.7292 57.4125 29.0266V70.8204C57.4125 74.1179 60.0856 76.791 63.3831 76.791H82.9564V90.1264L96.7165 76.791H138.015C141.312 76.791 143.985 74.1179 143.985 70.8204V29.0266C143.985 25.7292 141.312 23.0561 138.015 23.0561H63.3831Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M100.051 32.9175C100.81 32.9175 101.429 33.1502 101.906 33.6157C102.384 34.0812 102.623 34.6938 102.623 35.4533V37.1805C104.657 37.499 106.641 38.2708 108.577 39.4958C109.018 39.7898 109.33 40.1145 109.514 40.4697C109.698 40.825 109.789 41.2598 109.789 41.7744C109.789 42.5094 109.569 43.1464 109.128 43.6854C108.687 44.2244 108.172 44.4939 107.584 44.4939C107.29 44.4939 107.009 44.4449 106.739 44.3469C106.47 44.2489 106.078 44.0651 105.563 43.7956L104.424 43.1892C103.836 42.883 103.205 42.638 102.531 42.4542C101.857 42.2705 101.141 42.1786 100.381 42.1786C99.2788 42.1786 98.3846 42.4175 97.6986 42.8952C97.0125 43.373 96.6695 44.0161 96.6695 44.8246C96.6695 45.6087 97.0615 46.1967 97.8456 46.5887C98.6296 46.9807 99.8668 47.3727 101.557 47.7647C103.37 48.1812 104.859 48.6222 106.023 49.0877C107.186 49.5532 108.191 50.3005 109.036 51.3295C109.881 52.3585 110.304 53.7428 110.304 55.4823C110.304 57.4668 109.624 59.1573 108.264 60.5539C106.905 61.9504 105.073 62.8691 102.77 63.3102V65.1109C102.77 65.8704 102.531 66.4829 102.053 66.9485C101.576 67.414 100.957 67.6467 100.198 67.6467C99.4381 67.6467 98.8194 67.414 98.3417 66.9485C97.8639 66.4829 97.6251 65.8704 97.6251 65.1109V63.4572C94.9055 63.1142 92.578 62.3179 90.6425 61.0684C90.2014 60.7989 89.8891 60.4926 89.7053 60.1496C89.5216 59.8066 89.4297 59.3534 89.4297 58.7898C89.4297 58.0548 89.6441 57.4178 90.0728 56.8788C90.5016 56.3398 91.01 56.0703 91.598 56.0703C91.892 56.0703 92.186 56.1193 92.48 56.2173C92.774 56.3153 93.1537 56.4991 93.6192 56.7686C94.6973 57.3566 95.7018 57.7731 96.6328 58.0181C97.5638 58.2631 98.5561 58.3856 99.6096 58.3856C100.908 58.3856 101.894 58.1712 102.568 57.7425C103.242 57.3137 103.579 56.6706 103.579 55.8131C103.579 55.2985 103.377 54.8759 102.972 54.5452C102.568 54.2144 102.066 53.951 101.465 53.755L100.773 53.5427C100.381 53.4284 99.9204 53.3018 99.3906 53.1629L98.8378 53.02C97.0003 52.5545 95.4935 52.0829 94.3175 51.6051C93.1415 51.1274 92.1247 50.3801 91.2672 49.3633C90.4097 48.3466 89.9809 46.9807 89.9809 45.2657C89.9809 43.3056 90.6669 41.6029 92.039 40.1573C93.411 38.7118 95.224 37.7563 97.4781 37.2908V35.4533C97.4781 34.7183 97.7231 34.1119 98.2131 33.6341C98.7031 33.1564 99.3156 32.9175 100.051 32.9175Z\" fill=\"#1AAAAD\"/>\n</svg>";

var LinealBtnDePagoError = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.1124 56.5994C32.204 56.5994 33.09 57.4853 33.09 58.5769C33.09 59.6685 32.204 60.5545 31.1124 60.5545H10.0617C8.96908 60.5545 8.08413 59.6685 8.08413 58.5769C8.08413 57.4853 8.96908 56.5994 10.0617 56.5994H31.1124ZM39.8694 47.0001C40.961 47.0001 41.847 47.886 41.847 48.9776C41.847 50.0692 40.961 50.9552 39.8694 50.9552H19.8865C18.7949 50.9552 17.909 50.0692 17.909 48.9776C17.909 47.886 18.7949 47.0001 19.8865 47.0001H39.8694ZM10.0617 47.0001C11.1533 47.0001 12.0392 47.886 12.0392 48.9776C12.0392 50.0692 11.1533 50.9552 10.0617 50.9552H1.97753C0.885933 50.9552 0 50.0692 0 48.9776C0 47.886 0.885933 47.0001 1.97753 47.0001H10.0617ZM36.515 37.4011C37.6066 37.4011 38.4925 38.287 38.4925 39.3786C38.4925 40.4702 37.6066 41.3561 36.515 41.3561H10.7359C9.64332 41.3561 8.75837 40.4702 8.75837 39.3786C8.75837 38.287 9.64332 37.4011 10.7359 37.4011H36.515ZM165.879 36.8155C166.971 36.8155 167.856 37.7015 167.856 38.7931C167.856 39.8847 166.971 40.7706 165.879 40.7706H154.933C153.841 40.7706 152.956 39.8847 152.956 38.7931C152.956 37.7015 153.841 36.8155 154.933 36.8155H165.879ZM176.826 36.8155C177.917 36.8155 178.803 37.7015 178.803 38.7931C178.803 39.8847 177.917 40.7706 176.826 40.7706H173.458C172.365 40.7706 171.481 39.8847 171.481 38.7931C171.481 37.7015 172.365 36.8155 173.458 36.8155H176.826ZM189.706 27.2161C190.797 27.2161 191.683 28.102 191.683 29.1936C191.683 30.2852 190.797 31.1712 189.706 31.1712H181.225C180.133 31.1712 179.248 30.2852 179.248 29.1936C179.248 28.102 180.133 27.2161 181.225 27.2161H189.706ZM171.464 27.2161C172.555 27.2161 173.441 28.102 173.441 29.1936C173.441 30.2852 172.555 31.1712 171.464 31.1712H157.209C156.117 31.1712 155.231 30.2852 155.231 29.1936C155.231 28.102 156.117 27.2161 157.209 27.2161H171.464ZM180.02 17.6167C181.112 17.6167 181.997 18.5026 181.997 19.5942C181.997 20.6858 181.112 21.5718 180.02 21.5718H163.432C162.34 21.5718 161.455 20.6858 161.455 19.5942C161.455 18.5026 162.34 17.6167 163.432 17.6167H180.02ZM155.612 17.6167C156.703 17.6167 157.589 18.5026 157.589 19.5942C157.589 20.6858 156.703 21.5718 155.612 21.5718H152.244C151.151 21.5718 150.267 20.6858 150.267 19.5942C150.267 18.5026 151.151 17.6167 152.244 17.6167H155.612Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M131.226 5C136.841 5 141.394 9.51439 141.394 15.0832V53.7584C141.394 59.3271 136.841 63.8415 131.226 63.8415H94.5504L83.0473 74.897C80.1316 77.6992 75.2521 75.6503 75.2521 71.6238V63.8415H61.5838C55.9683 63.8415 51.416 59.3271 51.416 53.7584V15.0832C51.416 9.51439 55.9683 5 61.5838 5H131.226ZM61.5838 9.55815C58.5068 9.55815 56.0124 12.0318 56.0124 15.0832V53.7584C56.0124 56.8097 58.5068 59.2834 61.5838 59.2834H79.8485V71.6238L92.6886 59.2834H131.226C134.303 59.2834 136.797 56.8097 136.797 53.7584V15.0832C136.797 12.0318 134.303 9.55815 131.226 9.55815H61.5838Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96.0847 17.854C96.8042 17.854 97.3902 18.0727 97.8429 18.51C98.2955 18.9474 98.5218 19.5229 98.5218 20.2365V21.8593C100.448 22.1585 102.328 22.8836 104.162 24.0346C104.58 24.3108 104.876 24.6158 105.05 24.9496C105.224 25.2833 105.311 25.6919 105.311 26.1753C105.311 26.8659 105.102 27.4644 104.684 27.9708C104.266 28.4772 103.779 28.7304 103.222 28.7304C102.943 28.7304 102.676 28.6844 102.421 28.5923C102.166 28.5002 101.794 28.3276 101.307 28.0744L100.228 27.5047C99.6707 27.2169 99.073 26.9867 98.4347 26.8141C97.7964 26.6414 97.1175 26.5551 96.398 26.5551C95.3535 26.5551 94.5064 26.7796 93.8565 27.2284C93.2066 27.6773 92.8816 28.2815 92.8816 29.0412C92.8816 29.7778 93.253 30.3302 93.9957 30.6985C94.7385 31.0668 95.9106 31.4351 97.5121 31.8034C99.2297 32.1947 100.64 32.6091 101.742 33.0464C102.845 33.4838 103.796 34.1859 104.597 35.1527C105.398 36.1195 105.798 37.42 105.798 39.0544C105.798 40.9189 105.154 42.5072 103.866 43.8193C102.578 45.1313 100.843 45.9945 98.661 46.4089V48.1008C98.661 48.8144 98.4347 49.3898 97.9821 49.8272C97.5295 50.2645 96.9435 50.4832 96.2239 50.4832C95.5044 50.4832 94.9183 50.2645 94.4657 49.8272C94.0131 49.3898 93.7868 48.8144 93.7868 48.1008V46.547C91.2105 46.2247 89.0055 45.4766 87.1719 44.3027C86.7541 44.0494 86.4581 43.7617 86.2841 43.4395C86.11 43.1172 86.0229 42.6913 86.0229 42.1619C86.0229 41.4713 86.226 40.8729 86.6322 40.3664C87.0384 39.86 87.52 39.6068 88.0771 39.6068C88.3556 39.6068 88.6341 39.6529 88.9126 39.7449C89.1912 39.837 89.5509 40.0096 89.9919 40.2628C91.0132 40.8153 91.9648 41.2066 92.8468 41.4368C93.7288 41.667 94.6688 41.7821 95.6669 41.7821C96.897 41.7821 97.8312 41.5807 98.4695 41.1779C99.1078 40.775 99.427 40.1708 99.427 39.3651C99.427 38.8817 99.2355 38.4846 98.8525 38.1739C98.4695 37.8631 97.9937 37.6157 97.4251 37.4315L96.7694 37.232C96.398 37.1246 95.9614 37.0057 95.4594 36.8752L94.9358 36.741C93.195 36.3036 91.7675 35.8605 90.6534 35.4116C89.5393 34.9628 88.5761 34.2607 87.7637 33.3054C86.9514 32.3501 86.5452 31.0668 86.5452 29.4555C86.5452 27.614 87.1951 26.0142 88.4949 24.6561C89.7946 23.298 91.5122 22.4002 93.6476 21.9629V20.2365C93.6476 19.5459 93.8797 18.9762 94.3439 18.5273C94.8081 18.0784 95.3884 17.854 96.0847 17.854Z\" fill=\"#B6C5D5\"/>\n<path d=\"M130.517 92.9998C141.985 92.9998 151.281 83.7034 151.281 72.2357C151.281 60.7681 141.985 51.4717 130.517 51.4717C119.049 51.4717 109.753 60.7681 109.753 72.2357C109.753 83.7034 119.049 92.9998 130.517 92.9998Z\" fill=\"white\"/>\n<path d=\"M130.418 89.7353C139.764 89.7353 147.341 82.1587 147.341 72.8125C147.341 63.4663 139.764 55.8896 130.418 55.8896C121.072 55.8896 113.495 63.4663 113.495 72.8125C113.495 82.1587 121.072 89.7353 130.418 89.7353Z\" fill=\"white\"/>\n<path d=\"M130.418 91.6249C140.726 91.6249 149.22 83.1108 149.22 72.802C149.22 62.5141 140.706 54 130.418 54C120.109 54 111.616 62.5141 111.616 72.802C111.616 83.1108 120.13 91.6249 130.418 91.6249ZM123.657 80.9426C122.889 80.9426 122.297 80.3312 122.297 79.583C122.297 79.2074 122.436 78.8735 122.691 78.6367L128.486 72.8218L122.691 67.008C122.436 66.7712 122.297 66.4362 122.297 66.0617C122.297 65.2937 122.889 64.7219 123.658 64.7219C124.032 64.7219 124.347 64.8597 124.604 65.1163L130.418 70.9103L136.251 65.1163C136.528 64.82 136.843 64.6823 137.198 64.6823C137.947 64.6823 138.557 65.2937 138.557 66.0418C138.557 66.4175 138.439 66.7127 138.144 66.9882L132.329 72.8218L138.144 78.597C138.4 78.8735 138.538 79.1886 138.538 79.583C138.538 80.3312 137.947 80.9426 137.178 80.9426C136.783 80.9426 136.449 80.785 136.193 80.5284L130.418 74.7344L124.623 80.5284C124.387 80.785 124.032 80.9426 123.658 80.9426H123.657Z\" fill=\"#DD2457\"/>\n</svg>";

var LinealBtnDePagoNoDisponible = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M126.851 24.5732C131.13 24.5732 134.634 27.8915 134.931 32.0954L134.951 32.6739L135.087 68.3811C135.087 72.6605 131.769 76.1649 127.565 76.4615L126.986 76.4819H99.1085L89.9438 85.3637C87.7219 87.517 84.0685 86.1046 83.755 83.1467L83.7334 82.734V76.4819H71.502C67.2226 76.4819 63.7182 73.1636 63.4216 68.9597L63.4013 68.3811L63.2656 32.6739C63.2656 28.3946 66.5839 24.8902 70.7878 24.5936L71.3663 24.5732H126.851ZM126.851 28.5558H71.3663C69.2436 28.5558 67.4959 30.1619 67.2723 32.2129L67.2481 32.6588L67.3838 68.3811C67.3838 70.5039 68.9899 72.2516 71.0532 72.4752L71.502 72.4993H83.7334C85.7862 72.4993 87.4763 74.0525 87.6925 76.0479L87.7159 76.4819V81.9769L96.3369 73.622C96.956 73.022 97.7495 72.6423 98.5955 72.5325L99.1085 72.4993H126.986C129.109 72.4993 130.857 70.8932 131.08 68.8422L131.104 68.3963L130.969 32.6739C130.969 30.3995 129.125 28.5558 126.851 28.5558ZM95.6028 40.5971C96.8131 40.5971 97.7942 41.5783 97.7942 42.7886C97.7942 43.7799 97.1328 44.6278 96.1861 44.8961L95.8184 44.9687L95.6028 44.98H90.7352C87.7641 44.98 85.3556 47.3885 85.3556 50.3596C85.3556 53.0392 87.3198 55.2751 89.89 55.6749L90.4495 55.732L90.7352 55.7392H95.6028C96.8131 55.7392 97.7942 56.7203 97.7942 57.9306C97.7942 58.922 97.1328 59.7699 96.1861 60.0381L95.8184 60.1107L95.6028 60.122H90.7352C85.3435 60.122 80.9727 55.7512 80.9727 50.3596C80.9727 45.3431 84.7636 41.1904 89.6734 40.6551L90.3821 40.6035L95.6028 40.5971ZM106.826 40.5971C112.218 40.5971 116.589 44.9679 116.589 50.3596C116.589 55.3761 112.798 59.5288 107.888 60.0641L107.179 60.1156L102.789 60.122C101.579 60.122 100.598 59.1409 100.598 57.9306C100.598 56.9392 101.259 56.0914 102.206 55.8231L102.573 55.7505L102.789 55.7392H106.826C109.797 55.7392 112.206 53.3307 112.206 50.3596C112.206 47.68 110.242 45.4441 107.672 45.0442L107.112 44.9872L106.826 44.98H102.789C101.579 44.98 100.598 43.9988 100.598 42.7886C100.598 41.7972 101.259 40.9493 102.206 40.681L102.573 40.6085L102.789 40.5971H106.826ZM103.213 48.3398C104.328 48.3398 105.232 49.2441 105.232 50.3596C105.232 51.3511 104.518 52.1758 103.576 52.3468L103.213 52.3794H95.2982C94.1827 52.3794 93.2785 51.4751 93.2785 50.3596C93.2785 49.368 93.993 48.5434 94.9352 48.3723L95.2982 48.3398H103.213Z\" fill=\"#B6C5D5\"/>\n<path d=\"M64.4478 85.309L62.9722 83.8334C62.1404 83.0015 62.1404 81.6528 62.9722 80.8209L130.849 12.9439C131.681 12.112 133.03 12.112 133.862 12.9439L135.337 14.4195C136.169 15.2514 136.169 16.6002 135.337 17.4321L67.4604 85.309C66.6285 86.1409 65.2797 86.1409 64.4478 85.309Z\" fill=\"#B6C5D5\" stroke=\"white\" stroke-width=\"2\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.9912 72.9687C34.1431 72.9687 35.078 73.9036 35.078 75.0555C35.078 76.2074 34.1431 77.1423 32.9912 77.1423H10.7773C9.62432 77.1423 8.69048 76.2074 8.69048 75.0555C8.69048 73.9036 9.62432 72.9687 10.7773 72.9687H32.9912ZM42.232 62.839C43.3839 62.839 44.3188 63.7738 44.3188 64.9258C44.3188 66.0777 43.3839 67.0125 42.232 67.0125H21.145C19.9931 67.0125 19.0582 66.0777 19.0582 64.9258C19.0582 63.7738 19.9931 62.839 21.145 62.839H42.232ZM10.7773 62.839C11.9292 62.839 12.8641 63.7738 12.8641 64.9258C12.8641 66.0777 11.9292 67.0125 10.7773 67.0125H2.24646C1.09455 67.0125 0.159668 66.0777 0.159668 64.9258C0.159668 63.7738 1.09455 62.839 2.24646 62.839H10.7773ZM38.6922 52.7096C39.8441 52.7096 40.779 53.6444 40.779 54.7964C40.779 55.9483 39.8441 56.8832 38.6922 56.8832H11.4888C10.3358 56.8832 9.40197 55.9483 9.40197 54.7964C9.40197 53.6444 10.3358 52.7096 11.4888 52.7096H38.6922ZM164.77 52.0917C165.922 52.0917 166.857 53.0265 166.857 54.1785C166.857 55.3304 165.922 56.2652 164.77 56.2652H153.22C152.067 56.2652 151.133 55.3304 151.133 54.1785C151.133 53.0265 152.067 52.0917 153.22 52.0917H164.77ZM176.322 52.0917C177.474 52.0917 178.409 53.0265 178.409 54.1785C178.409 55.3304 177.474 56.2652 176.322 56.2652H172.768C171.615 56.2652 170.681 55.3304 170.681 54.1785C170.681 53.0265 171.615 52.0917 172.768 52.0917H176.322ZM189.913 41.9618C191.065 41.9618 192 42.8967 192 44.0486C192 45.2006 191.065 46.1354 189.913 46.1354H180.964C179.811 46.1354 178.877 45.2006 178.877 44.0486C178.877 42.8967 179.811 41.9618 180.964 41.9618H189.913ZM170.663 41.9618C171.815 41.9618 172.75 42.8967 172.75 44.0486C172.75 45.2006 171.815 46.1354 170.663 46.1354H155.621C154.469 46.1354 153.534 45.2006 153.534 44.0486C153.534 42.8967 154.469 41.9618 155.621 41.9618H170.663ZM179.692 31.832C180.844 31.832 181.779 32.7669 181.779 33.9188C181.779 35.0707 180.844 36.0056 179.692 36.0056H162.188C161.035 36.0056 160.102 35.0707 160.102 33.9188C160.102 32.7669 161.035 31.832 162.188 31.832H179.692ZM153.936 31.832C155.087 31.832 156.022 32.7669 156.022 33.9188C156.022 35.0707 155.087 36.0056 153.936 36.0056H150.382C149.229 36.0056 148.295 35.0707 148.295 33.9188C148.295 32.7669 149.229 31.832 150.382 31.832H153.936Z\" fill=\"#B6C5D5\"/>\n</svg>";

var LinealBtnDePagoGenerado = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.1124 56.5994C32.204 56.5994 33.09 57.4853 33.09 58.5769C33.09 59.6685 32.204 60.5545 31.1124 60.5545H10.0617C8.96908 60.5545 8.08413 59.6685 8.08413 58.5769C8.08413 57.4853 8.96908 56.5994 10.0617 56.5994H31.1124ZM39.8694 47.0001C40.961 47.0001 41.847 47.886 41.847 48.9776C41.847 50.0692 40.961 50.9552 39.8694 50.9552H19.8865C18.7949 50.9552 17.909 50.0692 17.909 48.9776C17.909 47.886 18.7949 47.0001 19.8865 47.0001H39.8694ZM10.0617 47.0001C11.1533 47.0001 12.0392 47.886 12.0392 48.9776C12.0392 50.0692 11.1533 50.9552 10.0617 50.9552H1.97753C0.885933 50.9552 0 50.0692 0 48.9776C0 47.886 0.885933 47.0001 1.97753 47.0001H10.0617ZM36.515 37.4011C37.6066 37.4011 38.4925 38.287 38.4925 39.3786C38.4925 40.4702 37.6066 41.3561 36.515 41.3561H10.7359C9.64332 41.3561 8.75837 40.4702 8.75837 39.3786C8.75837 38.287 9.64332 37.4011 10.7359 37.4011H36.515ZM165.879 36.8155C166.971 36.8155 167.856 37.7015 167.856 38.7931C167.856 39.8847 166.971 40.7706 165.879 40.7706H154.933C153.841 40.7706 152.956 39.8847 152.956 38.7931C152.956 37.7015 153.841 36.8155 154.933 36.8155H165.879ZM176.826 36.8155C177.917 36.8155 178.803 37.7015 178.803 38.7931C178.803 39.8847 177.917 40.7706 176.826 40.7706H173.458C172.365 40.7706 171.481 39.8847 171.481 38.7931C171.481 37.7015 172.365 36.8155 173.458 36.8155H176.826ZM189.706 27.2161C190.797 27.2161 191.683 28.102 191.683 29.1936C191.683 30.2852 190.797 31.1712 189.706 31.1712H181.225C180.133 31.1712 179.248 30.2852 179.248 29.1936C179.248 28.102 180.133 27.2161 181.225 27.2161H189.706ZM171.464 27.2161C172.555 27.2161 173.441 28.102 173.441 29.1936C173.441 30.2852 172.555 31.1712 171.464 31.1712H157.209C156.117 31.1712 155.231 30.2852 155.231 29.1936C155.231 28.102 156.117 27.2161 157.209 27.2161H171.464ZM180.02 17.6167C181.112 17.6167 181.997 18.5026 181.997 19.5942C181.997 20.6858 181.112 21.5718 180.02 21.5718H163.432C162.34 21.5718 161.455 20.6858 161.455 19.5942C161.455 18.5026 162.34 17.6167 163.432 17.6167H180.02ZM155.612 17.6167C156.703 17.6167 157.589 18.5026 157.589 19.5942C157.589 20.6858 156.703 21.5718 155.612 21.5718H152.244C151.151 21.5718 150.267 20.6858 150.267 19.5942C150.267 18.5026 151.151 17.6167 152.244 17.6167H155.612Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M131.226 5C136.841 5 141.394 9.51439 141.394 15.0832V53.7584C141.394 59.3271 136.841 63.8415 131.226 63.8415H94.5504L83.0473 74.897C80.1316 77.6992 75.2521 75.6503 75.2521 71.6238V63.8415H61.5838C55.9683 63.8415 51.416 59.3271 51.416 53.7584V15.0832C51.416 9.51439 55.9683 5 61.5838 5H131.226ZM61.5838 9.55815C58.5068 9.55815 56.0124 12.0318 56.0124 15.0832V53.7584C56.0124 56.8097 58.5068 59.2834 61.5838 59.2834H79.8485V71.6238L92.6886 59.2834H131.226C134.303 59.2834 136.797 56.8097 136.797 53.7584V15.0832C136.797 12.0318 134.303 9.55815 131.226 9.55815H61.5838Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96.0847 17.854C96.8042 17.854 97.3902 18.0727 97.8429 18.51C98.2955 18.9474 98.5218 19.5229 98.5218 20.2365V21.8593C100.448 22.1585 102.328 22.8836 104.162 24.0346C104.58 24.3108 104.876 24.6158 105.05 24.9496C105.224 25.2833 105.311 25.6919 105.311 26.1753C105.311 26.8659 105.102 27.4644 104.684 27.9708C104.266 28.4772 103.779 28.7304 103.222 28.7304C102.943 28.7304 102.676 28.6844 102.421 28.5923C102.166 28.5002 101.794 28.3276 101.307 28.0744L100.228 27.5047C99.6707 27.2169 99.073 26.9867 98.4347 26.8141C97.7964 26.6414 97.1175 26.5551 96.398 26.5551C95.3535 26.5551 94.5064 26.7796 93.8565 27.2284C93.2066 27.6773 92.8816 28.2815 92.8816 29.0412C92.8816 29.7778 93.253 30.3302 93.9957 30.6985C94.7385 31.0668 95.9106 31.4351 97.5121 31.8034C99.2297 32.1947 100.64 32.6091 101.742 33.0464C102.845 33.4838 103.796 34.1859 104.597 35.1527C105.398 36.1195 105.798 37.42 105.798 39.0544C105.798 40.9189 105.154 42.5072 103.866 43.8193C102.578 45.1313 100.843 45.9945 98.661 46.4089V48.1008C98.661 48.8144 98.4347 49.3898 97.9821 49.8272C97.5295 50.2645 96.9435 50.4832 96.2239 50.4832C95.5044 50.4832 94.9183 50.2645 94.4657 49.8272C94.0131 49.3898 93.7868 48.8144 93.7868 48.1008V46.547C91.2105 46.2247 89.0055 45.4766 87.1719 44.3027C86.7541 44.0494 86.4581 43.7617 86.2841 43.4395C86.11 43.1172 86.0229 42.6913 86.0229 42.1619C86.0229 41.4713 86.226 40.8729 86.6322 40.3664C87.0384 39.86 87.52 39.6068 88.0771 39.6068C88.3556 39.6068 88.6341 39.6529 88.9126 39.7449C89.1912 39.837 89.5509 40.0096 89.9919 40.2628C91.0132 40.8153 91.9648 41.2066 92.8468 41.4368C93.7288 41.667 94.6688 41.7821 95.6669 41.7821C96.897 41.7821 97.8312 41.5807 98.4695 41.1779C99.1078 40.775 99.427 40.1708 99.427 39.3651C99.427 38.8817 99.2355 38.4846 98.8525 38.1739C98.4695 37.8631 97.9937 37.6157 97.4251 37.4315L96.7694 37.232C96.398 37.1246 95.9614 37.0057 95.4594 36.8752L94.9358 36.741C93.195 36.3036 91.7675 35.8605 90.6534 35.4116C89.5393 34.9628 88.5761 34.2607 87.7637 33.3054C86.9514 32.3501 86.5452 31.0668 86.5452 29.4555C86.5452 27.614 87.1951 26.0142 88.4949 24.6561C89.7946 23.298 91.5122 22.4002 93.6476 21.9629V20.2365C93.6476 19.5459 93.8797 18.9762 94.3439 18.5273C94.8081 18.0784 95.3884 17.854 96.0847 17.854Z\" fill=\"#B6C5D5\"/>\n<path d=\"M130.764 92.5281C142.232 92.5281 151.528 83.2317 151.528 71.764C151.528 60.2964 142.232 51 130.764 51C119.296 51 110 60.2964 110 71.764C110 83.2317 119.296 92.5281 130.764 92.5281Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M130.738 91.6198C141.523 91.6198 150.475 82.7179 150.475 71.8099C150.475 60.9437 141.523 52 130.738 52C119.911 52 111 60.9437 111 71.8099C111 82.7179 119.911 91.6198 130.738 91.6198ZM128.59 82.8154C128.058 82.8154 127.412 82.5539 126.994 82.0309L120.19 73.4008C119.886 73.0521 119.772 72.4419 119.772 71.9189C119.772 70.6549 120.609 69.6524 121.711 69.6524C122.395 69.6524 122.889 70.0447 123.231 70.4805L128.514 76.9749L138.092 61.7633C138.434 61.1967 139.043 60.8044 139.727 60.8044C140.791 60.8044 141.703 61.7197 141.703 63.0273C141.703 63.4196 141.551 63.899 141.247 64.3785L130.225 81.9437C129.883 82.4667 129.274 82.8154 128.59 82.8154Z\" fill=\"#1AAAAD\"/>\n</svg>";

var LinealBtnDePagoSinGenerar = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.1124 56.5994C32.204 56.5994 33.09 57.4853 33.09 58.5769C33.09 59.6685 32.204 60.5545 31.1124 60.5545H10.0617C8.96908 60.5545 8.08413 59.6685 8.08413 58.5769C8.08413 57.4853 8.96908 56.5994 10.0617 56.5994H31.1124ZM39.8694 47.0001C40.961 47.0001 41.847 47.886 41.847 48.9776C41.847 50.0692 40.961 50.9552 39.8694 50.9552H19.8865C18.7949 50.9552 17.909 50.0692 17.909 48.9776C17.909 47.886 18.7949 47.0001 19.8865 47.0001H39.8694ZM10.0617 47.0001C11.1533 47.0001 12.0392 47.886 12.0392 48.9776C12.0392 50.0692 11.1533 50.9552 10.0617 50.9552H1.97753C0.885933 50.9552 0 50.0692 0 48.9776C0 47.886 0.885933 47.0001 1.97753 47.0001H10.0617ZM36.515 37.4011C37.6066 37.4011 38.4925 38.287 38.4925 39.3786C38.4925 40.4702 37.6066 41.3561 36.515 41.3561H10.7359C9.64332 41.3561 8.75837 40.4702 8.75837 39.3786C8.75837 38.287 9.64332 37.4011 10.7359 37.4011H36.515ZM165.879 36.8155C166.971 36.8155 167.856 37.7015 167.856 38.7931C167.856 39.8847 166.971 40.7706 165.879 40.7706H154.933C153.841 40.7706 152.956 39.8847 152.956 38.7931C152.956 37.7015 153.841 36.8155 154.933 36.8155H165.879ZM176.826 36.8155C177.917 36.8155 178.803 37.7015 178.803 38.7931C178.803 39.8847 177.917 40.7706 176.826 40.7706H173.458C172.365 40.7706 171.481 39.8847 171.481 38.7931C171.481 37.7015 172.365 36.8155 173.458 36.8155H176.826ZM189.706 27.2161C190.797 27.2161 191.683 28.102 191.683 29.1936C191.683 30.2852 190.797 31.1712 189.706 31.1712H181.225C180.133 31.1712 179.248 30.2852 179.248 29.1936C179.248 28.102 180.133 27.2161 181.225 27.2161H189.706ZM171.464 27.2161C172.555 27.2161 173.441 28.102 173.441 29.1936C173.441 30.2852 172.555 31.1712 171.464 31.1712H157.209C156.117 31.1712 155.231 30.2852 155.231 29.1936C155.231 28.102 156.117 27.2161 157.209 27.2161H171.464ZM180.02 17.6167C181.112 17.6167 181.997 18.5026 181.997 19.5942C181.997 20.6858 181.112 21.5718 180.02 21.5718H163.432C162.34 21.5718 161.455 20.6858 161.455 19.5942C161.455 18.5026 162.34 17.6167 163.432 17.6167H180.02ZM155.612 17.6167C156.703 17.6167 157.589 18.5026 157.589 19.5942C157.589 20.6858 156.703 21.5718 155.612 21.5718H152.244C151.151 21.5718 150.267 20.6858 150.267 19.5942C150.267 18.5026 151.151 17.6167 152.244 17.6167H155.612Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M131.226 5C136.841 5 141.394 9.51439 141.394 15.0832V53.7584C141.394 59.3271 136.841 63.8415 131.226 63.8415H94.5504L83.0473 74.897C80.1316 77.6992 75.2521 75.6503 75.2521 71.6238V63.8415H61.5838C55.9683 63.8415 51.416 59.3271 51.416 53.7584V15.0832C51.416 9.51439 55.9683 5 61.5838 5H131.226ZM61.5838 9.55815C58.5068 9.55815 56.0124 12.0318 56.0124 15.0832V53.7584C56.0124 56.8097 58.5068 59.2834 61.5838 59.2834H79.8485V71.6238L92.6886 59.2834H131.226C134.303 59.2834 136.797 56.8097 136.797 53.7584V15.0832C136.797 12.0318 134.303 9.55815 131.226 9.55815H61.5838Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96.0847 17.854C96.8042 17.854 97.3902 18.0727 97.8429 18.51C98.2955 18.9474 98.5218 19.5229 98.5218 20.2365V21.8593C100.448 22.1585 102.328 22.8836 104.162 24.0346C104.58 24.3108 104.876 24.6158 105.05 24.9496C105.224 25.2833 105.311 25.6919 105.311 26.1753C105.311 26.8659 105.102 27.4644 104.684 27.9708C104.266 28.4772 103.779 28.7304 103.222 28.7304C102.943 28.7304 102.676 28.6844 102.421 28.5923C102.166 28.5002 101.794 28.3276 101.307 28.0744L100.228 27.5047C99.6707 27.2169 99.073 26.9867 98.4347 26.8141C97.7964 26.6414 97.1175 26.5551 96.398 26.5551C95.3535 26.5551 94.5064 26.7796 93.8565 27.2284C93.2066 27.6773 92.8816 28.2815 92.8816 29.0412C92.8816 29.7778 93.253 30.3302 93.9957 30.6985C94.7385 31.0668 95.9106 31.4351 97.5121 31.8034C99.2297 32.1947 100.64 32.6091 101.742 33.0464C102.845 33.4838 103.796 34.1859 104.597 35.1527C105.398 36.1195 105.798 37.42 105.798 39.0544C105.798 40.9189 105.154 42.5072 103.866 43.8193C102.578 45.1313 100.843 45.9945 98.661 46.4089V48.1008C98.661 48.8144 98.4347 49.3898 97.9821 49.8272C97.5295 50.2645 96.9435 50.4832 96.2239 50.4832C95.5044 50.4832 94.9183 50.2645 94.4657 49.8272C94.0131 49.3898 93.7868 48.8144 93.7868 48.1008V46.547C91.2105 46.2247 89.0055 45.4766 87.1719 44.3027C86.7541 44.0494 86.4581 43.7617 86.2841 43.4395C86.11 43.1172 86.0229 42.6913 86.0229 42.1619C86.0229 41.4713 86.226 40.8729 86.6322 40.3664C87.0384 39.86 87.52 39.6068 88.0771 39.6068C88.3556 39.6068 88.6341 39.6529 88.9126 39.7449C89.1912 39.837 89.5509 40.0096 89.9919 40.2628C91.0132 40.8153 91.9648 41.2066 92.8468 41.4368C93.7288 41.667 94.6688 41.7821 95.6669 41.7821C96.897 41.7821 97.8312 41.5807 98.4695 41.1779C99.1078 40.775 99.427 40.1708 99.427 39.3651C99.427 38.8817 99.2355 38.4846 98.8525 38.1739C98.4695 37.8631 97.9937 37.6157 97.4251 37.4315L96.7694 37.232C96.398 37.1246 95.9614 37.0057 95.4594 36.8752L94.9358 36.741C93.195 36.3036 91.7675 35.8605 90.6534 35.4116C89.5393 34.9628 88.5761 34.2607 87.7637 33.3054C86.9514 32.3501 86.5452 31.0668 86.5452 29.4555C86.5452 27.614 87.1951 26.0142 88.4949 24.6561C89.7946 23.298 91.5122 22.4002 93.6476 21.9629V20.2365C93.6476 19.5459 93.8797 18.9762 94.3439 18.5273C94.8081 18.0784 95.3884 17.854 96.0847 17.854Z\" fill=\"#B6C5D5\"/>\n</svg>";

var LinealBtnDePagoWarning = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.1124 56.5994C32.204 56.5994 33.09 57.4853 33.09 58.5769C33.09 59.6685 32.204 60.5545 31.1124 60.5545H10.0617C8.96908 60.5545 8.08413 59.6685 8.08413 58.5769C8.08413 57.4853 8.96908 56.5994 10.0617 56.5994H31.1124ZM39.8694 47.0001C40.961 47.0001 41.847 47.886 41.847 48.9776C41.847 50.0692 40.961 50.9552 39.8694 50.9552H19.8865C18.7949 50.9552 17.909 50.0692 17.909 48.9776C17.909 47.886 18.7949 47.0001 19.8865 47.0001H39.8694ZM10.0617 47.0001C11.1533 47.0001 12.0392 47.886 12.0392 48.9776C12.0392 50.0692 11.1533 50.9552 10.0617 50.9552H1.97753C0.885933 50.9552 0 50.0692 0 48.9776C0 47.886 0.885933 47.0001 1.97753 47.0001H10.0617ZM36.515 37.4011C37.6066 37.4011 38.4925 38.287 38.4925 39.3786C38.4925 40.4702 37.6066 41.3561 36.515 41.3561H10.7359C9.64332 41.3561 8.75837 40.4702 8.75837 39.3786C8.75837 38.287 9.64332 37.4011 10.7359 37.4011H36.515ZM165.879 36.8155C166.971 36.8155 167.856 37.7015 167.856 38.7931C167.856 39.8847 166.971 40.7706 165.879 40.7706H154.933C153.841 40.7706 152.956 39.8847 152.956 38.7931C152.956 37.7015 153.841 36.8155 154.933 36.8155H165.879ZM176.826 36.8155C177.917 36.8155 178.803 37.7015 178.803 38.7931C178.803 39.8847 177.917 40.7706 176.826 40.7706H173.458C172.365 40.7706 171.481 39.8847 171.481 38.7931C171.481 37.7015 172.365 36.8155 173.458 36.8155H176.826ZM189.706 27.2161C190.797 27.2161 191.683 28.102 191.683 29.1936C191.683 30.2852 190.797 31.1712 189.706 31.1712H181.225C180.133 31.1712 179.248 30.2852 179.248 29.1936C179.248 28.102 180.133 27.2161 181.225 27.2161H189.706ZM171.464 27.2161C172.555 27.2161 173.441 28.102 173.441 29.1936C173.441 30.2852 172.555 31.1712 171.464 31.1712H157.209C156.117 31.1712 155.231 30.2852 155.231 29.1936C155.231 28.102 156.117 27.2161 157.209 27.2161H171.464ZM180.02 17.6167C181.112 17.6167 181.997 18.5026 181.997 19.5942C181.997 20.6858 181.112 21.5718 180.02 21.5718H163.432C162.34 21.5718 161.455 20.6858 161.455 19.5942C161.455 18.5026 162.34 17.6167 163.432 17.6167H180.02ZM155.612 17.6167C156.703 17.6167 157.589 18.5026 157.589 19.5942C157.589 20.6858 156.703 21.5718 155.612 21.5718H152.244C151.151 21.5718 150.267 20.6858 150.267 19.5942C150.267 18.5026 151.151 17.6167 152.244 17.6167H155.612Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M131.226 5C136.841 5 141.394 9.51439 141.394 15.0832V53.7584C141.394 59.3271 136.841 63.8415 131.226 63.8415H94.5504L83.0473 74.897C80.1316 77.6992 75.2521 75.6503 75.2521 71.6238V63.8415H61.5838C55.9683 63.8415 51.416 59.3271 51.416 53.7584V15.0832C51.416 9.51439 55.9683 5 61.5838 5H131.226ZM61.5838 9.55815C58.5068 9.55815 56.0124 12.0318 56.0124 15.0832V53.7584C56.0124 56.8097 58.5068 59.2834 61.5838 59.2834H79.8485V71.6238L92.6886 59.2834H131.226C134.303 59.2834 136.797 56.8097 136.797 53.7584V15.0832C136.797 12.0318 134.303 9.55815 131.226 9.55815H61.5838Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96.0847 17.854C96.8042 17.854 97.3902 18.0727 97.8429 18.51C98.2955 18.9474 98.5218 19.5229 98.5218 20.2365V21.8593C100.448 22.1585 102.328 22.8836 104.162 24.0346C104.58 24.3108 104.876 24.6158 105.05 24.9496C105.224 25.2833 105.311 25.6919 105.311 26.1753C105.311 26.8659 105.102 27.4644 104.684 27.9708C104.266 28.4772 103.779 28.7304 103.222 28.7304C102.943 28.7304 102.676 28.6844 102.421 28.5923C102.166 28.5002 101.794 28.3276 101.307 28.0744L100.228 27.5047C99.6707 27.2169 99.073 26.9867 98.4347 26.8141C97.7964 26.6414 97.1175 26.5551 96.398 26.5551C95.3535 26.5551 94.5064 26.7796 93.8565 27.2284C93.2066 27.6773 92.8816 28.2815 92.8816 29.0412C92.8816 29.7778 93.253 30.3302 93.9957 30.6985C94.7385 31.0668 95.9106 31.4351 97.5121 31.8034C99.2297 32.1947 100.64 32.6091 101.742 33.0464C102.845 33.4838 103.796 34.1859 104.597 35.1527C105.398 36.1195 105.798 37.42 105.798 39.0544C105.798 40.9189 105.154 42.5072 103.866 43.8193C102.578 45.1313 100.843 45.9945 98.661 46.4089V48.1008C98.661 48.8144 98.4347 49.3898 97.9821 49.8272C97.5295 50.2645 96.9435 50.4832 96.2239 50.4832C95.5044 50.4832 94.9183 50.2645 94.4657 49.8272C94.0131 49.3898 93.7868 48.8144 93.7868 48.1008V46.547C91.2105 46.2247 89.0055 45.4766 87.1719 44.3027C86.7541 44.0494 86.4581 43.7617 86.2841 43.4395C86.11 43.1172 86.0229 42.6913 86.0229 42.1619C86.0229 41.4713 86.226 40.8729 86.6322 40.3664C87.0384 39.86 87.52 39.6068 88.0771 39.6068C88.3556 39.6068 88.6341 39.6529 88.9126 39.7449C89.1912 39.837 89.5509 40.0096 89.9919 40.2628C91.0132 40.8153 91.9648 41.2066 92.8468 41.4368C93.7288 41.667 94.6688 41.7821 95.6669 41.7821C96.897 41.7821 97.8312 41.5807 98.4695 41.1779C99.1078 40.775 99.427 40.1708 99.427 39.3651C99.427 38.8817 99.2355 38.4846 98.8525 38.1739C98.4695 37.8631 97.9937 37.6157 97.4251 37.4315L96.7694 37.232C96.398 37.1246 95.9614 37.0057 95.4594 36.8752L94.9358 36.741C93.195 36.3036 91.7675 35.8605 90.6534 35.4116C89.5393 34.9628 88.5761 34.2607 87.7637 33.3054C86.9514 32.3501 86.5452 31.0668 86.5452 29.4555C86.5452 27.614 87.1951 26.0142 88.4949 24.6561C89.7946 23.298 91.5122 22.4002 93.6476 21.9629V20.2365C93.6476 19.5459 93.8797 18.9762 94.3439 18.5273C94.8081 18.0784 95.3884 17.854 96.0847 17.854Z\" fill=\"#B6C5D5\"/>\n<path d=\"M130.517 92.9998C141.985 92.9998 151.281 83.7034 151.281 72.2357C151.281 60.7681 141.985 51.4717 130.517 51.4717C119.049 51.4717 109.753 60.7681 109.753 72.2357C109.753 83.7034 119.049 92.9998 130.517 92.9998Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M130.517 90.7493C140.455 90.7493 148.644 82.545 148.644 72.6125C148.644 62.6989 140.436 54.4946 130.517 54.4946C120.579 54.4946 112.39 62.6989 112.39 72.6125C112.39 82.545 120.598 90.7493 130.517 90.7493ZM130.821 75.4298C131.64 75.4298 132.144 74.9259 132.144 74.0232L132.396 63.4638C132.417 62.5821 131.724 61.9104 130.8 61.9104C129.856 61.9104 129.205 62.5611 129.226 63.4638L129.457 74.0232C129.478 74.9259 129.961 75.4298 130.821 75.4298ZM130.821 81.6856C129.772 81.6856 128.869 80.8249 128.869 79.7963C128.869 78.7466 129.751 77.9069 130.821 77.9069C131.892 77.9069 132.774 78.7256 132.774 79.7963C132.774 80.8459 131.871 81.6856 130.821 81.6856Z\" fill=\"#FECF2F\"/>\n</svg>";

var LinealCalendarioDefault = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M41.4123 50.7011C42.2337 50.7011 42.9004 51.368 42.9004 52.1897C42.9004 53.0114 42.2337 53.6783 41.4123 53.6783H25.5715C24.7493 53.6783 24.0834 53.0114 24.0834 52.1897C24.0834 51.368 24.7493 50.7011 25.5715 50.7011H41.4123ZM48.002 43.4751C48.8234 43.4751 49.4901 44.142 49.4901 44.9637C49.4901 45.7854 48.8234 46.4523 48.002 46.4523H32.9647C32.1433 46.4523 31.4766 45.7854 31.4766 44.9637C31.4766 44.142 32.1433 43.4751 32.9647 43.4751H48.002ZM25.5715 43.4751C26.3929 43.4751 27.0596 44.142 27.0596 44.9637C27.0596 45.7854 26.3929 46.4523 25.5715 46.4523H19.4881C18.6667 46.4523 18 45.7854 18 44.9637C18 44.142 18.6667 43.4751 19.4881 43.4751H25.5715ZM45.4777 36.2493C46.2991 36.2493 46.9658 36.9162 46.9658 37.7379C46.9658 38.5596 46.2991 39.2265 45.4777 39.2265H26.0788C25.2566 39.2265 24.5907 38.5596 24.5907 37.7379C24.5907 36.9162 25.2566 36.2493 26.0788 36.2493H45.4777ZM155.474 35.8086C156.295 35.8086 156.962 36.4755 156.962 37.2972C156.962 38.1189 156.295 38.7858 155.474 38.7858H147.237C146.415 38.7858 145.749 38.1189 145.749 37.2972C145.749 36.4755 146.415 35.8086 147.237 35.8086H155.474ZM163.711 35.8086C164.533 35.8086 165.199 36.4755 165.199 37.2972C165.199 38.1189 164.533 38.7858 163.711 38.7858H161.177C160.355 38.7858 159.689 38.1189 159.689 37.2972C159.689 36.4755 160.355 35.8086 161.177 35.8086H163.711ZM173.403 28.5825C174.225 28.5825 174.892 29.2494 174.892 30.0711C174.892 30.8928 174.225 31.5597 173.403 31.5597H167.022C166.2 31.5597 165.534 30.8928 165.534 30.0711C165.534 29.2494 166.2 28.5825 167.022 28.5825H173.403ZM159.676 28.5825C160.498 28.5825 161.164 29.2494 161.164 30.0711C161.164 30.8928 160.498 31.5597 159.676 31.5597H148.949C148.128 31.5597 147.461 30.8928 147.461 30.0711C147.461 29.2494 148.128 28.5825 148.949 28.5825H159.676ZM166.115 21.3564C166.936 21.3564 167.603 22.0233 167.603 22.845C167.603 23.6668 166.936 24.3337 166.115 24.3337H153.633C152.81 24.3337 152.145 23.6668 152.145 22.845C152.145 22.0233 152.81 21.3564 153.633 21.3564H166.115ZM147.748 21.3564C148.569 21.3564 149.236 22.0233 149.236 22.845C149.236 23.6668 148.569 24.3337 147.748 24.3337H145.213C144.391 24.3337 143.725 23.6668 143.725 22.845C143.725 22.0233 144.391 21.3564 145.213 21.3564H147.748Z\" fill=\"#B6C5D5\"/>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M109.385 71.7517C109.533 73.622 109.928 75.4224 110.539 77.12L73.9615 77.1199C70.8737 77.1199 68.3345 74.7658 68.0356 71.752L109.385 71.7517ZM130.708 17.7583C133.108 18.527 134.845 20.78 134.845 23.4392L134.846 49.9412C133.514 49.6222 132.133 49.4321 130.716 49.3847L130.716 18.0714C130.716 17.9664 130.714 17.862 130.708 17.7583Z\" fill=\"#B6C5D5\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M123.996 12C127.206 12 129.822 14.5461 129.939 17.7308L129.944 17.954L129.944 49.2086C129.753 49.2034 129.562 49.2008 129.37 49.2008C128.558 49.2008 127.757 49.2477 126.969 49.3389L126.97 26.885C126.97 25.2432 125.636 23.908 123.996 23.908H64.6541C63.0728 23.908 61.7762 25.1495 61.6856 26.7103L61.6806 26.885V65.586C61.6806 67.1692 62.9207 68.4673 64.4796 68.558L64.6541 68.5631L108.748 68.5638C108.72 69.0019 108.706 69.4436 108.706 69.8887C108.706 70.4448 108.728 70.9958 108.771 71.5408L64.6541 71.5401C61.4438 71.5401 58.8284 68.9939 58.7111 65.8092L58.707 65.586V17.954C58.707 14.7406 61.2495 12.1215 64.4311 12.0041L64.6541 12H123.996ZM96.7213 53.678C97.8259 53.678 98.7213 54.5735 98.7213 55.678V60.609C98.7213 61.7136 97.8259 62.609 96.7213 62.609H91.8007C90.6961 62.609 89.8007 61.7136 89.8007 60.609V55.678C89.8007 54.5735 90.6961 53.678 91.8007 53.678H96.7213ZM72.9329 41.77C74.0375 41.77 74.9329 42.6655 74.9329 43.77V48.701C74.9329 49.8056 74.0375 50.701 72.9329 50.701H68.0123C66.9077 50.701 66.0123 49.8056 66.0123 48.701V43.77C66.0123 42.6655 66.9077 41.77 68.0123 41.77H72.9329ZM108.615 29.862C109.72 29.862 110.615 30.7574 110.615 31.862V36.793C110.615 37.8976 109.72 38.793 108.615 38.793H103.695C102.59 38.793 101.695 37.8976 101.695 36.793V31.862C101.695 30.7574 102.59 29.862 103.695 29.862H108.615Z\" fill=\"#1AAAAD\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M108 35.5481C108 35.9481 107.87 36.2889 107.609 36.5704C107.349 36.8519 106.998 37.037 106.556 37.1259V37.4889C106.556 37.642 106.511 37.7654 106.419 37.8593C106.327 37.9531 106.209 38 106.063 38C105.918 38 105.799 37.9531 105.708 37.8593C105.616 37.7654 105.57 37.642 105.57 37.4889V37.1556C105.049 37.0864 104.603 36.9259 104.232 36.6741C104.148 36.6198 104.088 36.558 104.053 36.4889C104.018 36.4198 104 36.3284 104 36.2148C104 36.0667 104.041 35.9383 104.123 35.8296C104.205 35.721 104.303 35.6667 104.415 35.6667C104.472 35.6667 104.528 35.6765 104.585 35.6963C104.641 35.716 104.714 35.7531 104.803 35.8074C105.009 35.9259 105.202 36.0099 105.38 36.0593C105.559 36.1086 105.749 36.1333 105.951 36.1333C106.2 36.1333 106.388 36.0901 106.518 36.0037C106.647 35.9173 106.711 35.7877 106.711 35.6148C106.711 35.5111 106.673 35.4259 106.595 35.3593C106.518 35.2926 106.421 35.2395 106.306 35.2L106.174 35.1572C106.099 35.1342 106.01 35.1086 105.909 35.0807L105.803 35.0519C105.451 34.958 105.162 34.863 104.937 34.7667C104.711 34.6704 104.516 34.5198 104.352 34.3148C104.188 34.1099 104.106 33.8346 104.106 33.4889C104.106 33.0938 104.237 32.7506 104.5 32.4593C104.763 32.1679 105.11 31.9753 105.542 31.8815V31.5111C105.542 31.363 105.589 31.2407 105.683 31.1444C105.777 31.0481 105.894 31 106.035 31C106.181 31 106.299 31.0469 106.391 31.1407C106.482 31.2346 106.528 31.358 106.528 31.5111V31.8593C106.918 31.9235 107.298 32.079 107.669 32.3259C107.754 32.3852 107.813 32.4506 107.849 32.5222C107.884 32.5938 107.901 32.6815 107.901 32.7852C107.901 32.9333 107.859 33.0617 107.775 33.1704C107.69 33.279 107.592 33.3333 107.479 33.3333C107.423 33.3333 107.369 33.3235 107.317 33.3037C107.265 33.284 107.19 33.2469 107.092 33.1926L106.873 33.0704C106.761 33.0086 106.64 32.9593 106.511 32.9222C106.381 32.8852 106.244 32.8667 106.099 32.8667C105.887 32.8667 105.716 32.9148 105.585 33.0111C105.453 33.1074 105.387 33.237 105.387 33.4C105.387 33.558 105.462 33.6765 105.613 33.7556C105.763 33.8346 106 33.9136 106.324 33.9926C106.671 34.0765 106.957 34.1654 107.18 34.2593C107.403 34.3531 107.595 34.5037 107.757 34.7111C107.919 34.9185 108 35.1975 108 35.5481Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M73.2872 53.9877C74.3918 53.9877 75.2872 54.8831 75.2872 55.9877V61.0347C75.2872 62.1393 74.3918 63.0347 73.2872 63.0347H68.3394C67.2348 63.0347 66.3394 62.1393 66.3394 61.0347V55.9877C66.3394 54.8831 67.2348 53.9877 68.3394 53.9877H73.2872ZM85.368 53.9877C86.4726 53.9877 87.368 54.8831 87.368 55.9877V61.0347C87.368 62.1393 86.4726 63.0347 85.368 63.0347H80.4201C79.3155 63.0347 78.4201 62.1393 78.4201 61.0347V55.9877C78.4201 54.8831 79.3155 53.9877 80.4201 53.9877H85.368ZM85.368 41.925C86.4726 41.925 87.368 42.8204 87.368 43.925V48.972C87.368 50.0766 86.4726 50.972 85.368 50.972H80.4201C79.3155 50.972 78.4201 50.0766 78.4201 48.972V43.925C78.4201 42.8204 79.3155 41.925 80.4201 41.925H85.368ZM97.2985 41.925C98.4031 41.925 99.2985 42.8204 99.2985 43.925V48.972C99.2985 50.0766 98.4031 50.972 97.2985 50.972H92.3506C91.2461 50.972 90.3506 50.0766 90.3506 48.972V43.925C90.3506 42.8204 91.2461 41.925 92.3506 41.925H97.2985ZM109.229 41.925C110.334 41.925 111.229 42.8204 111.229 43.925V48.972C111.229 50.0766 110.334 50.972 109.229 50.972H104.281C103.177 50.972 102.281 50.0766 102.281 48.972V43.925C102.281 42.8204 103.177 41.925 104.281 41.925H109.229ZM85.368 29.8623C86.4726 29.8623 87.368 30.7577 87.368 31.8623V36.9093C87.368 38.0139 86.4726 38.9093 85.368 38.9093H80.4201C79.3155 38.9093 78.4201 38.0139 78.4201 36.9093V31.8623C78.4201 30.7577 79.3155 29.8623 80.4201 29.8623H85.368ZM97.2985 29.8623C98.4031 29.8623 99.2985 30.7577 99.2985 31.8623V36.9093C99.2985 38.0139 98.4031 38.9093 97.2985 38.9093H92.3506C91.2461 38.9093 90.3506 38.0139 90.3506 36.9093V31.8623C90.3506 30.7577 91.2461 29.8623 92.3506 29.8623H97.2985ZM121.16 29.8623C122.264 29.8623 123.16 30.7577 123.16 31.8623V36.9093C123.16 38.0139 122.264 38.9093 121.16 38.9093H116.212C115.107 38.9093 114.212 38.0139 114.212 36.9093V31.8623C114.212 30.7577 115.107 29.8623 116.212 29.8623H121.16Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M142.337 58.6222L136.856 54.4698C136.576 54.275 136.428 54.0107 136.428 53.7307C136.428 53.388 136.594 53.1103 136.874 52.8483C137.495 52.2884 138.611 51.9771 139.594 51.9771C142.173 51.9771 144.208 54.0286 144.208 56.5886C144.208 57.1933 144.109 57.8181 143.946 58.1787C143.748 58.5729 143.403 58.835 142.993 58.835C142.747 58.835 142.583 58.8014 142.337 58.6222ZM120.921 70.9875C120.921 70.3491 121.411 69.843 122.052 69.843H128.371V61.05C128.371 60.4094 128.864 59.8988 129.502 59.8988C130.143 59.8988 130.652 60.4094 130.652 61.05V70.9875C130.652 71.6302 130.143 72.1207 129.502 72.1207H122.052C121.411 72.1207 120.921 71.6302 120.921 70.9875ZM142.402 70.3178C142.402 63.2158 136.625 57.4419 129.52 57.4419C122.397 57.4419 116.636 63.2158 116.636 70.3178C116.636 77.4355 122.397 83.1937 129.52 83.1937C136.625 83.1937 142.402 77.4355 142.402 70.3178ZM115.11 58.1787C114.931 57.8002 114.833 57.1933 114.833 56.5886C114.833 54.0286 116.883 51.9771 119.442 51.9771C120.428 51.9771 121.543 52.2884 122.169 52.8483C122.446 53.1103 122.61 53.388 122.61 53.7307C122.61 54.0107 122.462 54.275 122.2 54.4698L116.704 58.6222C116.473 58.8014 116.291 58.835 116.047 58.835C115.635 58.835 115.292 58.5863 115.11 58.1787ZM115.816 83.7536L118.31 81.2743C115.538 78.4523 113.831 74.5821 113.831 70.3178C113.831 61.6547 120.856 54.6199 129.52 54.6199C138.185 54.6199 145.209 61.6547 145.209 70.3178C145.209 74.5821 143.504 78.4523 140.728 81.2743L143.224 83.7536C143.731 84.2419 143.731 85.0482 143.24 85.5252C142.747 86.0314 141.942 86.0314 141.434 85.5073L138.841 82.9317C136.231 84.8511 133.016 86 129.52 86C126.025 86 122.807 84.8511 120.199 82.9317L117.604 85.5073C117.096 86.0314 116.291 86.0314 115.801 85.5252C115.323 85.0482 115.308 84.2419 115.816 83.7536Z\" fill=\"#1AAAAD\"/>\n</svg>";

var LinealCalendarioFeriado = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M137.078 14.356H134.781V12.072C134.781 9.373 132.573 7.178 129.859 7.178H125.922V5.22C125.922 2.342 123.567 0 120.672 0C117.777 0 115.422 2.342 115.422 5.22V7.178H101.64V5.22C101.64 2.342 99.285 0 96.39 0C93.495 0 91.14 2.342 91.14 5.22V7.178H77.359V5.22C77.359 2.342 75.004 0 72.109 0C69.214 0 66.86 2.342 66.86 5.22V7.178H62.922C60.208 7.178 58 9.373 58 12.072V64.928C58 67.627 60.208 69.822 62.922 69.822H65.219V72.106C65.219 74.805 67.427 77 70.14 77H137.077C139.792 77 142 74.805 142 72.106V19.25C142 16.551 139.792 14.356 137.078 14.356ZM118.703 5.22C118.703 4.14 119.586 3.263 120.672 3.263C121.757 3.263 122.641 4.141 122.641 5.22V12.398C122.641 13.478 121.757 14.356 120.671 14.356C119.586 14.356 118.703 13.478 118.703 12.398V5.22ZM94.422 5.22C94.422 4.14 95.305 3.263 96.391 3.263C97.476 3.263 98.359 4.141 98.359 5.22V12.398C98.359 13.478 97.476 14.356 96.391 14.356C95.305 14.356 94.421 13.478 94.421 12.398V5.22H94.422ZM70.141 5.22C70.141 4.14 71.024 3.263 72.109 3.263C73.195 3.263 74.079 4.141 74.079 5.22V12.398C74.079 13.478 73.195 14.356 72.109 14.356C71.024 14.356 70.141 13.478 70.141 12.398V5.22ZM62.921 10.44H66.86V12.398C66.86 15.277 69.215 17.618 72.11 17.618C75.005 17.618 77.36 15.277 77.36 12.398V10.441H91.142V12.398C91.142 15.277 93.497 17.618 96.392 17.618C99.287 17.618 101.642 15.277 101.642 12.398V10.441H115.422V12.398C115.422 15.277 117.778 17.618 120.672 17.618C123.568 17.618 125.922 15.277 125.922 12.398V10.441H129.86C130.765 10.441 131.501 11.173 131.501 12.072V26.754H61.281V12.072C61.281 11.172 62.017 10.441 62.921 10.441V10.44ZM138.72 72.107C138.72 73.007 137.984 73.738 137.08 73.738H70.14C69.235 73.738 68.499 73.006 68.499 72.107V69.823H89.007C89.913 69.823 90.647 69.093 90.647 68.192C90.647 67.291 89.913 66.56 89.007 66.56H62.922C62.017 66.56 61.282 65.828 61.282 64.929V30.017H131.5V64.928C131.5 65.828 130.764 66.559 129.86 66.559H103.772C102.866 66.559 102.132 67.289 102.132 68.191C102.132 69.091 102.866 69.822 103.772 69.822H129.86C132.574 69.822 134.782 67.627 134.782 64.928V17.618H137.079C137.984 17.618 138.719 18.35 138.719 19.25V72.106L138.72 72.107Z\" fill=\"#B6C5D5\"/>\n<path d=\"M103.223 60.807C103.467 60.937 103.734 61 104.001 61C104.347 61 104.692 60.892 104.984 60.68C105.499 60.304 105.757 59.667 105.649 59.037L104.461 52.077L109.495 47.148C109.951 46.702 110.115 46.035 109.918 45.427C109.721 44.819 109.198 44.376 108.568 44.284L101.611 43.268L98.4991 36.936C98.2181 36.363 97.6361 36 97.0001 36C96.3631 36 95.7821 36.363 95.5001 36.936L92.3901 43.268L85.4321 44.284C84.8021 44.376 84.2791 44.819 84.0821 45.427C83.8851 46.035 84.0491 46.702 84.5051 47.148L89.5391 52.078L88.3511 59.037C88.2431 59.667 88.5011 60.304 89.0161 60.679C89.5311 61.055 90.2141 61.104 90.7771 60.807L97.0001 57.521L103.223 60.807ZM92.2201 56.25L92.9841 51.775C93.0771 51.23 92.8981 50.674 92.5041 50.288L89.2661 47.118L93.7401 46.465C94.2851 46.385 94.7561 46.042 95.0001 45.547L97.0001 41.475L99.0001 45.547C99.2451 46.042 99.7151 46.386 100.26 46.466L104.734 47.119L101.497 50.289C101.102 50.674 100.923 51.23 101.016 51.775L101.78 56.251L97.7781 54.137C97.5351 54.009 97.2681 53.944 97.0001 53.944C96.7331 53.944 96.4651 54.009 96.2221 54.137L92.2201 56.25ZM96.0001 66C95.4741 66 94.9581 66.214 94.5861 66.586C94.2141 66.958 94.0001 67.474 94.0001 68C94.0001 68.526 94.2141 69.042 94.5861 69.414C94.9581 69.786 95.4741 70 96.0001 70C96.5261 70 97.0421 69.786 97.4141 69.414C97.7861 69.042 98.0001 68.526 98.0001 68C98.0001 67.474 97.7861 66.958 97.4141 66.586C97.0421 66.214 96.5261 66 96.0001 66Z\" fill=\"#B6C5D5\"/>\n<path d=\"M135 95C146.598 95 156 85.598 156 74C156 62.402 146.598 53 135 53C123.402 53 114 62.402 114 74C114 85.598 123.402 95 135 95Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23.2978 55.6224C23.5396 55.6224 23.7484 55.721 23.9271 55.9182L25.0684 57.0698L26.2204 55.9182C26.4053 55.728 26.6151 55.6329 26.8498 55.6329C27.0773 55.6329 27.2738 55.7157 27.4418 55.8812C27.608 56.0467 27.6924 56.2387 27.6924 56.457C27.6924 56.6824 27.6036 56.8867 27.4258 57.0698L26.2098 58.2531L27.5316 59.5632C27.7093 59.7392 27.7991 59.94 27.7991 60.1654C27.7991 60.3837 27.7129 60.5774 27.5431 60.7464C27.3724 60.9155 27.1733 61 26.9458 61C26.7102 61 26.5013 60.9049 26.3164 60.7147L25.0684 59.4258L23.8311 60.7147C23.6453 60.9049 23.4364 61 23.2018 61C22.9733 61 22.7751 60.9155 22.6036 60.7464C22.4347 60.5774 22.3476 60.3837 22.3476 60.1654C22.3476 59.94 22.4373 59.7392 22.6151 59.5632L23.9369 58.2531L22.7218 57.0698C22.544 56.8937 22.4551 56.693 22.4551 56.4676C22.4551 56.2422 22.5387 56.045 22.7058 55.8759C22.8729 55.7069 23.0702 55.6224 23.2978 55.6224ZM33.2533 45.4094C33.496 45.4094 33.7049 45.5089 33.8836 45.7061L35.0249 46.8577L36.1769 45.7061C36.3618 45.516 36.5716 45.4209 36.8062 45.4209C37.0338 45.4209 37.2302 45.5037 37.3982 45.6692C37.5644 45.8347 37.6489 46.0266 37.6489 46.245C37.6489 46.4704 37.5591 46.6746 37.3822 46.8577L36.1662 48.041L37.4871 49.3511C37.6649 49.5272 37.7547 49.7279 37.7547 49.9533C37.7547 50.1717 37.6693 50.3654 37.4996 50.5344C37.3289 50.7034 37.1298 50.788 36.9022 50.788C36.6658 50.788 36.4578 50.6929 36.272 50.5027L35.0249 49.2138L33.7876 50.5027C33.6009 50.6929 33.392 50.788 33.1573 50.788C32.9289 50.788 32.7307 50.7034 32.56 50.5344C32.3893 50.3654 32.304 50.1717 32.304 49.9533C32.304 49.7279 32.3929 49.5272 32.5707 49.3511L33.8924 48.041L32.6782 46.8577C32.5004 46.6817 32.4107 46.4809 32.4107 46.2555C32.4107 46.0301 32.4942 45.8329 32.6613 45.6639C32.8284 45.4948 33.0258 45.4103 33.2533 45.4103V45.4094ZM187.498 43.5905C187.74 43.5905 187.949 43.6891 188.127 43.8863L189.269 45.0379L190.42 43.8863C190.605 43.6961 190.816 43.6011 191.05 43.6011C191.277 43.6011 191.475 43.6838 191.642 43.8493C191.809 44.0149 191.893 44.2068 191.893 44.4251C191.893 44.6505 191.804 44.8548 191.627 45.0379L190.411 46.2212L191.732 47.5313C191.91 47.7074 192 47.9081 192 48.1335C192 48.3518 191.914 48.5455 191.744 48.7146C191.572 48.8836 191.374 48.9681 191.147 48.9681C190.911 48.9681 190.702 48.873 190.517 48.6829L189.269 47.3939L188.032 48.6829C187.846 48.873 187.637 48.9681 187.403 48.9681C187.174 48.9681 186.975 48.8836 186.804 48.7146C186.635 48.5455 186.548 48.3518 186.548 48.1335C186.548 47.9081 186.638 47.7074 186.816 47.5313L188.138 46.2212L186.923 45.0379C186.745 44.8618 186.655 44.6611 186.655 44.4357C186.655 44.2103 186.74 44.0131 186.906 43.844C187.074 43.675 187.27 43.5905 187.498 43.5905ZM161.823 40.8321C162.065 40.8321 162.274 40.9307 162.452 41.1279L163.594 42.2795L164.746 41.1279C164.931 40.9378 165.14 40.8427 165.375 40.8427C165.603 40.8427 165.799 40.9254 165.967 41.091C166.133 41.2565 166.218 41.4484 166.218 41.6668C166.218 41.8921 166.129 42.0964 165.951 42.2795L164.735 43.4628L166.057 44.7729C166.235 44.949 166.324 45.1497 166.324 45.3751C166.324 45.5935 166.238 45.7871 166.068 45.9562C165.898 46.1252 165.699 46.2098 165.471 46.2098C165.236 46.2098 165.027 46.1147 164.842 45.9245L163.594 44.6356L162.356 45.9245C162.171 46.1147 161.962 46.2098 161.727 46.2098C161.499 46.2098 161.3 46.1252 161.129 45.9562C160.96 45.7871 160.873 45.5935 160.873 45.3751C160.873 45.1497 160.963 44.949 161.14 44.7729L162.462 43.4628L161.247 42.2795C161.069 42.1034 160.98 41.9027 160.98 41.6773C160.98 41.4519 161.064 41.2547 161.231 41.0857C161.398 40.9166 161.596 40.8321 161.823 40.8321ZM17.3956 38.0773C17.6373 38.0773 17.8462 38.1759 18.0249 38.3731L19.1662 39.5247L20.3182 38.3731C20.5031 38.1829 20.7129 38.0878 20.9476 38.0878C21.1751 38.0878 21.3716 38.1706 21.5396 38.3361C21.7058 38.5016 21.7902 38.6936 21.7902 38.9119C21.7902 39.1373 21.7004 39.3416 21.5236 39.5247L20.3076 40.708L21.6293 42.0181C21.8071 42.1941 21.896 42.3949 21.896 42.6203C21.896 42.8386 21.8107 43.0323 21.6409 43.2013C21.4702 43.3704 21.2711 43.4549 21.0436 43.4549C20.808 43.4549 20.5991 43.3598 20.4142 43.1696L19.1644 41.8816L17.9271 43.1705C17.7404 43.3607 17.5324 43.4558 17.2978 43.4558C17.0693 43.4558 16.8711 43.3713 16.6996 43.2022C16.5298 43.0332 16.4436 42.8395 16.4436 42.6211C16.4436 42.3958 16.5324 42.195 16.7102 42.0189L18.0329 40.7089L16.8178 39.5256C16.64 39.3495 16.5502 39.1487 16.5502 38.9234C16.5502 38.698 16.6347 38.5008 16.8018 38.3317C16.9689 38.1627 17.1662 38.0781 17.3938 38.0781L17.3956 38.0773ZM175.691 31.6757C175.933 31.6757 176.142 31.7743 176.32 31.9715L177.462 33.1231L178.613 31.9715C178.798 31.7814 179.009 31.6863 179.243 31.6863C179.47 31.6863 179.668 31.769 179.835 31.9345C180.002 32.1001 180.086 32.292 180.086 32.5103C180.086 32.7357 179.996 32.94 179.82 33.1231L178.604 34.3064L179.925 35.6165C180.103 35.7926 180.193 35.9933 180.193 36.2187C180.193 36.437 180.107 36.6307 179.937 36.7998C179.765 36.9688 179.567 37.0533 179.34 37.0533C179.104 37.0533 178.895 36.9583 178.71 36.7681L177.462 35.4791L176.225 36.7681C176.039 36.9583 175.83 37.0533 175.596 37.0533C175.367 37.0533 175.168 36.9688 174.997 36.7998C174.828 36.6307 174.741 36.437 174.741 36.2187C174.741 35.9933 174.831 35.7926 175.009 35.6165L176.331 34.3064L175.116 33.1231C174.938 32.947 174.848 32.7463 174.848 32.5209C174.848 32.2955 174.932 32.0983 175.099 31.9293C175.267 31.7602 175.463 31.6757 175.691 31.6757ZM0.950222 28.2165C1.192 28.2165 1.40089 28.3151 1.57956 28.5123L2.72089 29.6639L3.87289 28.5123C4.05778 28.3222 4.26756 28.2271 4.50222 28.2271C4.72978 28.2271 4.92622 28.3098 5.09422 28.4754C5.26044 28.6409 5.34489 28.8328 5.34489 29.0512C5.34489 29.2765 5.25511 29.4808 5.07822 29.6639L3.86222 30.8472L5.184 32.1573C5.36178 32.3334 5.45156 32.5341 5.45156 32.7595C5.45156 32.9778 5.36533 33.1715 5.19556 33.3406C5.02489 33.5096 4.82578 33.5941 4.59822 33.5941C4.36267 33.5941 4.15378 33.4991 3.96889 33.3089L2.72089 32.0199L1.48356 33.3089C1.29778 33.4991 1.08889 33.5941 0.854222 33.5941C0.625778 33.5941 0.427556 33.5096 0.256 33.3406C0.0862222 33.1715 0 32.9778 0 32.7595C0 32.5341 0.0897778 32.3334 0.267556 32.1573L1.58933 30.8472L0.374222 29.6639C0.196444 29.4878 0.106667 29.2871 0.106667 29.0617C0.106667 28.8363 0.191111 28.6391 0.358222 28.4701C0.525333 28.301 0.722667 28.2165 0.950222 28.2165ZM28.2756 26.5217C28.5173 26.5217 28.7262 26.6203 28.9049 26.8175L30.0462 27.9691L31.1982 26.8175C31.3831 26.6273 31.5929 26.5323 31.8276 26.5323C32.0551 26.5323 32.2516 26.615 32.4196 26.7805C32.5858 26.9461 32.6702 27.138 32.6702 27.3563C32.6702 27.5817 32.5804 27.786 32.4036 27.9691L31.1876 29.1524L32.5093 30.4625C32.6871 30.6386 32.7769 30.8393 32.7769 31.0647C32.7769 31.283 32.6907 31.4767 32.5209 31.6458C32.3502 31.8148 32.1511 31.8993 31.9236 31.8993C31.688 31.8993 31.4791 31.8042 31.2942 31.6141L30.0462 30.3251L28.8089 31.6141C28.6231 31.8042 28.4142 31.8993 28.1796 31.8993C27.9511 31.8993 27.7529 31.8148 27.5813 31.6458C27.4116 31.4767 27.3253 31.283 27.3253 31.0647C27.3253 30.8393 27.4151 30.6386 27.5929 30.4625L28.9147 29.1524L27.6996 27.9691C27.5218 27.793 27.432 27.5923 27.432 27.3669C27.432 27.1415 27.5164 26.9443 27.6836 26.7753C27.8507 26.6062 28.048 26.5217 28.2756 26.5217ZM161.823 23C162.065 23 162.274 23.0986 162.452 23.2958L163.594 24.4474L164.746 23.2958C164.931 23.1057 165.14 23.0106 165.375 23.0106C165.603 23.0106 165.799 23.0933 165.967 23.2588C166.133 23.4244 166.218 23.6163 166.218 23.8346C166.218 24.06 166.129 24.2643 165.951 24.4474L164.735 25.6307L166.057 26.9408C166.235 27.1169 166.324 27.3176 166.324 27.543C166.324 27.7613 166.238 27.955 166.068 28.1241C165.898 28.2931 165.699 28.3776 165.471 28.3776C165.236 28.3776 165.027 28.2825 164.842 28.0924L163.594 26.8034L162.356 28.0924C162.171 28.2825 161.962 28.3776 161.727 28.3776C161.499 28.3776 161.3 28.2931 161.129 28.1241C160.96 27.955 160.873 27.7613 160.873 27.543C160.873 27.3176 160.963 27.1169 161.14 26.9408L162.462 25.6307L161.247 24.4474C161.069 24.2713 160.98 24.0706 160.98 23.8452C160.98 23.6198 161.064 23.4226 161.231 23.2536C161.398 23.0845 161.596 23 161.823 23Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M135 92.1582C145.051 92.1582 153.334 83.8602 153.334 73.8152C153.334 63.7892 145.032 55.4912 135 55.4912C124.95 55.4912 116.667 63.7892 116.667 73.8152C116.667 83.8602 124.969 92.1582 135 92.1582ZM135.308 76.6642C136.136 76.6642 136.646 76.1542 136.646 75.2422L136.901 64.5622C136.921 63.6712 136.221 62.9922 135.287 62.9922C134.332 62.9922 133.673 63.6492 133.695 64.5622L133.928 75.2422C133.949 76.1552 134.438 76.6642 135.308 76.6642ZM135.308 82.9912C134.247 82.9912 133.334 82.1212 133.334 81.0812C133.334 80.0192 134.225 79.1692 135.308 79.1692C136.391 79.1692 137.283 79.9972 137.283 81.0802C137.283 82.1422 136.37 82.9912 135.308 82.9912Z\" fill=\"#FECF2F\"/>\n</svg>";

var LinealCobroAnticipadoDesactivar = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M37.8099 59.8525C38.9611 59.8525 39.8954 60.7868 39.8954 61.9379C39.8954 63.0368 39.0441 63.938 37.9655 64.0177L37.8099 64.0234H15.6099C14.4577 64.0234 13.5244 63.0891 13.5244 61.9379C13.5244 60.8391 14.3748 59.9378 15.4542 59.8582L15.6099 59.8525H37.8099ZM47.046 49.7294C48.1972 49.7294 49.1315 50.6637 49.1315 51.8149C49.1315 52.9137 48.2802 53.815 47.2016 53.8947L47.046 53.9004H25.9711C24.8199 53.9004 23.8856 52.9661 23.8856 51.8149C23.8856 50.716 24.7369 49.8148 25.8156 49.7351L25.9711 49.7294H47.046ZM15.6099 49.7294C16.7611 49.7294 17.6954 50.6637 17.6954 51.8149C17.6954 52.9137 16.8441 53.815 15.7655 53.8947L15.6099 53.9004H7.08549C5.9343 53.9004 5 52.9661 5 51.8149C5 50.716 5.85129 49.8148 6.92992 49.7351L7.08549 49.7294H15.6099ZM158.202 43.9969C159.353 43.9969 160.288 44.9312 160.288 46.0824C160.288 47.1813 159.436 48.0825 158.358 48.1622L158.202 48.1679H146.659C145.507 48.1679 144.573 47.2336 144.573 46.0824C144.573 44.9835 145.424 44.0823 146.503 44.0026L146.659 43.9969H158.202ZM169.747 43.9969C170.898 43.9969 171.832 44.9312 171.832 46.0824C171.832 47.1813 170.981 48.0825 169.902 48.1622L169.747 48.1679H166.195C165.043 48.1679 164.11 47.2336 164.11 46.0824C164.11 44.9835 164.96 44.0823 166.039 44.0026L166.195 43.9969H169.747ZM43.5071 39.6059C44.6593 39.6059 45.5925 40.5402 45.5925 41.6914C45.5925 42.7903 44.7422 43.6915 43.6628 43.7712L43.5071 43.7769H16.3206C15.1695 43.7769 14.2352 42.8426 14.2352 41.6914C14.2352 40.5926 15.0865 39.6913 16.1651 39.6116L16.3206 39.6059H43.5071ZM183.33 33.8734C184.481 33.8734 185.415 34.8077 185.415 35.9589C185.415 37.0578 184.564 37.959 183.485 38.0387L183.33 38.0444H174.386C173.234 38.0444 172.301 37.1101 172.301 35.9589C172.301 34.8601 173.151 33.9588 174.23 33.8792L174.386 33.8734H183.33ZM164.092 33.8734C165.243 33.8734 166.177 34.8077 166.177 35.9589C166.177 37.0578 165.326 37.959 164.247 38.0387L164.092 38.0444H149.059C147.907 38.0444 146.973 37.1101 146.973 35.9589C146.973 34.8601 147.824 33.9588 148.903 33.8792L149.059 33.8734H164.092ZM173.115 23.7505C174.267 23.7505 175.2 24.6848 175.2 25.836C175.2 26.9348 174.35 27.8361 173.27 27.9157L173.115 27.9215H155.622C154.47 27.9215 153.536 26.9872 153.536 25.836C153.536 24.7371 154.387 23.8359 155.466 23.7562L155.622 23.7505H173.115ZM147.374 23.7505C148.526 23.7505 149.46 24.6848 149.46 25.836C149.46 26.9348 148.609 27.8361 147.53 27.9157L147.374 27.9215H143.822C142.67 27.9215 141.736 26.9872 141.736 25.836C141.736 24.7371 142.587 23.8359 143.666 23.7562L143.822 23.7505H147.374Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M78.9127 22.2996C78.8844 22.8115 78.8701 23.3271 78.8701 23.846C78.8701 25.1162 78.9558 26.3664 79.1217 27.5912L78.5013 27.5904C77.0038 27.5904 75.999 28.5221 75.999 29.9123C75.999 31.1986 76.8129 32.1688 78.0674 32.35L78.5013 32.3805L80.2123 32.3798C80.7671 34.0911 81.4843 35.7293 82.3456 37.2763L69.3944 37.273C67.8871 37.273 66.8872 38.2388 66.8872 39.629C66.8872 40.9504 67.6971 41.8609 68.9579 42.0298L69.3944 42.0581L85.7143 42.0565C87.3719 43.9484 89.2834 45.6124 91.3956 46.995L64.9263 46.9945C63.4239 46.9945 62.3898 47.9945 62.3898 49.4237C62.3898 50.6748 63.2037 51.6099 64.4831 51.7844L64.9263 51.8138H94.9007C96.325 51.8138 97.403 52.887 97.403 54.204C97.403 55.4595 96.5298 56.4859 95.3168 56.6786L94.9007 56.7112H69.3944C67.8871 56.7112 66.8872 57.7111 66.8872 59.1404C66.8872 60.3915 67.6971 61.3266 68.9579 61.5011L69.3944 61.5305H104.69C106.51 61.5305 107.759 62.6378 107.759 64.2084C107.759 65.4333 107.269 66.4842 105.766 67.3294L105.227 67.6034L94.3251 72.5739C92.8959 73.2129 92.1837 74.3934 92.6861 75.6763C93.1339 76.8352 94.2218 77.3304 95.683 76.9734L96.1835 76.8225L113.905 70.496C126.016 66.1742 130.767 58.6038 130.767 48.2042C130.767 45.0017 130.254 42.1102 129.259 39.5747C130.513 37.7635 131.559 35.7911 132.358 33.6966C134.908 37.7429 136.275 42.7224 136.275 48.3847C136.275 60.995 129.72 69.9084 116.847 74.8669L115.622 75.3202L97.8664 81.6419C93.2617 83.2906 89.3643 81.8223 87.9351 77.964C86.7598 74.6998 88.0172 71.4703 91.3575 69.7352L92.0081 69.4277L96.9347 67.3888C97.1201 67.3205 97.1835 67.2083 97.1835 67.1059C97.1835 66.9449 97.1259 66.8635 97.0065 66.8329L96.8664 66.8181H68.8578C64.536 66.8181 61.7459 64.0328 61.7459 59.7794C61.7459 58.3892 62.2093 57.1014 63.0288 56.1015C59.4241 55.4917 57.2485 53.0626 57.2485 49.4237C57.2485 45.8824 59.4972 43.3459 62.9654 42.7069C62.1752 41.7703 61.7459 40.5606 61.7459 39.307C61.7459 35.5985 64.165 33.0343 67.9266 32.7608L68.6042 32.7366H72.1406C71.2528 31.8049 70.7846 30.4147 70.7846 28.9855C70.7846 25.2724 73.369 22.6122 77.1737 22.328L77.8574 22.3028L78.9127 22.2996ZM106.517 0.419922C119.455 0.419922 129.943 10.9081 129.943 23.846C129.943 36.7839 119.455 47.2721 106.517 47.2721C93.5794 47.2721 83.0912 36.7839 83.0912 23.846C83.0912 10.9081 93.5794 0.419922 106.517 0.419922ZM106.517 5.29777C96.2733 5.29777 87.969 13.6021 87.969 23.846C87.969 34.0899 96.2733 42.3942 106.517 42.3942C116.761 42.3942 125.065 34.0899 125.065 23.846C125.065 13.6021 116.761 5.29777 106.517 5.29777ZM106.668 9.61213C107.29 9.61213 107.798 9.80292 108.189 10.1845C108.502 10.4898 108.69 10.8721 108.753 11.3316L108.777 11.6907V13.1066L109.772 13.3078C111.093 13.6356 112.388 14.2011 113.657 15.0044C114.018 15.2454 114.274 15.5115 114.425 15.8027C114.576 16.0939 114.651 16.4504 114.651 16.8722C114.651 17.4747 114.47 17.9968 114.109 18.4386C113.747 18.8805 113.325 19.1014 112.843 19.1014C112.602 19.1014 112.371 19.0612 112.151 18.9809C111.93 18.9005 111.608 18.7499 111.187 18.529C111.046 18.4487 110.735 18.283 110.253 18.032C109.771 17.7809 109.254 17.5801 108.701 17.4295C108.149 17.2788 107.562 17.2035 106.939 17.2035C106.035 17.2035 105.302 17.3993 104.74 17.791C104.178 18.1826 103.896 18.7098 103.896 19.3725C103.896 20.0152 104.218 20.4972 104.86 20.8185C105.503 21.1398 106.517 21.4611 107.903 21.7825C109.389 22.1239 110.609 22.4854 111.563 22.867C112.517 23.2485 113.34 23.8611 114.033 24.7046C114.726 25.548 115.073 26.6827 115.073 28.1086C115.073 29.7354 114.515 31.1211 113.401 32.2658C112.445 33.247 111.206 33.9405 109.682 34.3463L108.897 34.5252V36.0013L108.874 36.3604C108.811 36.8199 108.623 37.2023 108.31 37.5075C107.918 37.8891 107.411 38.0799 106.788 38.0799C106.166 38.0799 105.659 37.8891 105.267 37.5075C104.954 37.2023 104.766 36.8199 104.703 36.3604L104.68 36.0013V34.6457L103.744 34.5024C101.912 34.1704 100.316 33.5655 98.956 32.6876C98.5945 32.4667 98.3384 32.2156 98.1878 31.9345C98.0372 31.6533 97.9619 31.2818 97.9619 30.8199C97.9619 30.2174 98.1376 29.6952 98.489 29.2534C98.8405 28.8115 99.2572 28.5906 99.7392 28.5906C99.9802 28.5906 100.221 28.6308 100.462 28.7111C100.703 28.7915 101.014 28.9421 101.396 29.163C102.28 29.645 103.103 29.9864 103.866 30.1872C104.629 30.3881 105.443 30.4885 106.306 30.4885C107.371 30.4885 108.179 30.3128 108.731 29.9613C109.284 29.6098 109.56 29.0827 109.56 28.3798C109.56 27.958 109.394 27.6116 109.063 27.3405C108.731 27.0693 108.32 26.8534 107.828 26.6928C107.336 26.5321 106.618 26.3313 105.674 26.0903C104.168 25.7087 102.932 25.3221 101.968 24.9305C101.004 24.5389 100.171 23.9263 99.4681 23.0929C98.7652 22.2594 98.4137 21.1398 98.4137 19.734C98.4137 18.1274 98.9761 16.7316 100.101 15.5467C101.065 14.531 102.294 13.8105 103.789 13.3851L104.559 13.197V11.6907L104.597 11.2586C104.672 10.8463 104.86 10.4933 105.162 10.1996C105.563 9.80794 106.065 9.61213 106.668 9.61213Z\" fill=\"#B6C5D5\"/>\n<path d=\"M132.215 97.9998C144.309 97.9998 154.113 88.1959 154.113 76.1022C154.113 64.0085 144.309 54.2046 132.215 54.2046C120.121 54.2046 110.317 64.0085 110.317 76.1022C110.317 88.1959 120.121 97.9998 132.215 97.9998Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M132.215 55.2476C143.727 55.2476 153.07 64.5899 153.07 76.102C153.07 87.6141 143.727 96.9565 132.215 96.9565C120.703 96.9565 111.36 87.6141 111.36 76.102C111.36 64.5899 120.703 55.2476 132.215 55.2476ZM115.114 76.102C115.114 85.547 122.77 93.2024 132.215 93.2024C136.185 93.2024 139.84 91.8495 142.743 89.5795L118.738 65.5734C116.467 68.4769 115.114 72.1309 115.114 76.102ZM132.215 59.0008C128.244 59.0008 124.59 60.3537 121.687 62.6253L145.692 86.6298C147.963 83.7271 149.316 80.0723 149.316 76.102C149.316 66.6579 141.659 59.0008 132.215 59.0008Z\" fill=\"#DD2457\"/>\n</svg>";

var LinealCobroAnticipadoError = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M34.9167 63.6692C36.1418 63.6692 37.1361 64.6635 37.1361 65.8886C37.1361 67.058 36.2302 68.0171 35.0823 68.1019L34.9167 68.108H11.2912C10.065 68.108 9.0718 67.1137 9.0718 65.8886C9.0718 64.7192 9.97674 63.76 11.1255 63.6753L11.2912 63.6692H34.9167ZM44.7459 52.8961C45.971 52.8961 46.9653 53.8904 46.9653 55.1155C46.9653 56.2849 46.0593 57.244 44.9114 57.3288L44.7459 57.3349H22.3177C21.0926 57.3349 20.0983 56.3406 20.0983 55.1155C20.0983 53.9461 21.0043 52.987 22.1522 52.9022L22.3177 52.8961H44.7459ZM11.2912 52.8961C12.5163 52.8961 13.5106 53.8904 13.5106 55.1155C13.5106 56.2849 12.6046 57.244 11.4568 57.3288L11.2912 57.3349H2.2194C0.994291 57.3349 0 56.3406 0 55.1155C0 53.9461 0.905956 52.987 2.05384 52.9022L2.2194 52.8961H11.2912ZM163.039 46.7955C164.265 46.7955 165.259 47.7898 165.259 49.0149C165.259 50.1843 164.353 51.1434 163.205 51.2282L163.039 51.2343H150.755C149.529 51.2343 148.536 50.24 148.536 49.0149C148.536 47.8455 149.441 46.8864 150.589 46.8016L150.755 46.7955H163.039ZM175.325 46.7955C176.55 46.7955 177.545 47.7898 177.545 49.0149C177.545 50.1843 176.639 51.1434 175.491 51.2282L175.325 51.2343H171.546C170.319 51.2343 169.326 50.24 169.326 49.0149C169.326 47.8455 170.231 46.8864 171.38 46.8016L171.546 46.7955H175.325ZM40.9797 42.1226C42.2059 42.1226 43.1991 43.1169 43.1991 44.342C43.1991 45.5114 42.2941 46.4705 41.1454 46.5553L40.9797 46.5614H12.0476C10.8225 46.5614 9.82817 45.5671 9.82817 44.342C9.82817 43.1725 10.7341 42.2134 11.882 42.1287L12.0476 42.1226H40.9797ZM189.781 36.022C191.006 36.022 192 37.0163 192 38.2414C192 39.4108 191.094 40.3699 189.946 40.4547L189.781 40.4608H180.263C179.036 40.4608 178.043 39.4665 178.043 38.2414C178.043 37.072 178.948 36.1129 180.097 36.0281L180.263 36.022H189.781ZM169.308 36.022C170.533 36.022 171.527 37.0163 171.527 38.2414C171.527 39.4108 170.621 40.3699 169.473 40.4547L169.308 40.4608H153.309C152.084 40.4608 151.09 39.4665 151.09 38.2414C151.09 37.072 151.996 36.1129 153.143 36.0281L153.309 36.022H169.308ZM178.91 25.249C180.136 25.249 181.129 26.2433 181.129 27.4684C181.129 28.6378 180.224 29.597 179.075 29.6817L178.91 29.6878H160.293C159.068 29.6878 158.074 28.6935 158.074 27.4684C158.074 26.299 158.98 25.3399 160.128 25.2551L160.293 25.249H178.91ZM151.517 25.249C152.742 25.249 153.736 26.2433 153.736 27.4684C153.736 28.6378 152.83 29.597 151.682 29.6817L151.517 29.6878H147.736C146.51 29.6878 145.516 28.6935 145.516 27.4684C145.516 26.299 146.421 25.3399 147.57 25.2551L147.736 25.249H151.517Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M78.6587 23.7046C78.6287 24.2493 78.6135 24.798 78.6135 25.3502C78.6135 26.702 78.7047 28.0325 78.8812 29.3359L78.221 29.3351C76.6273 29.3351 75.558 30.3266 75.558 31.8061C75.558 33.1749 76.4242 34.2074 77.7592 34.4003L78.221 34.4327L80.0419 34.432C80.6323 36.2532 81.3955 37.9966 82.3121 39.6429L68.5293 39.6394C66.9252 39.6394 65.8611 40.6672 65.8611 42.1467C65.8611 43.5529 66.723 44.5219 68.0648 44.7016L68.5293 44.7318L85.8971 44.73C87.6611 46.7435 89.6954 48.5143 91.9433 49.9857L63.7743 49.9852C62.1754 49.9852 61.0749 51.0493 61.0749 52.5703C61.0749 53.9018 61.9411 54.897 63.3026 55.0827L63.7743 55.1139H95.6734C97.1891 55.1139 98.3364 56.256 98.3364 57.6576C98.3364 58.9937 97.4071 60.086 96.1163 60.2911L95.6734 60.3258H68.5293C66.9252 60.3258 65.8611 61.3899 65.8611 62.9109C65.8611 64.2424 66.723 65.2376 68.0648 65.4233L68.5293 65.4545H106.092C108.028 65.4545 109.357 66.6329 109.357 68.3044C109.357 69.6079 108.836 70.7264 107.237 71.6258L106.663 71.9174L95.0608 77.2071C93.5398 77.8871 92.7819 79.1434 93.3166 80.5086C93.7931 81.742 94.9509 82.269 96.5059 81.8891L97.0386 81.7285L115.898 74.9957C128.787 70.3964 133.843 62.3399 133.843 51.2725C133.843 47.8644 133.297 44.7872 132.238 42.089C133.572 40.1614 134.686 38.0624 135.536 35.8334C138.25 40.1395 139.704 45.4388 139.704 51.4646C139.704 64.8846 132.729 74.3704 119.029 79.6473L117.725 80.1297L98.8295 86.8573C93.9292 88.6119 89.7815 87.0494 88.2605 82.9433C87.0098 79.4695 88.3479 76.0325 91.9026 74.1861L92.5951 73.8589L97.838 71.689C98.0353 71.6163 98.1028 71.4969 98.1028 71.3879C98.1028 71.2166 98.0415 71.13 97.9144 71.0974L97.7654 71.0817H67.9583C63.359 71.0817 60.3897 68.1176 60.3897 63.591C60.3897 62.1115 60.8828 60.7411 61.7549 59.6769C57.9187 59.028 55.6035 56.4429 55.6035 52.5703C55.6035 48.8016 57.9966 46.1022 61.6874 45.4222C60.8465 44.4255 60.3897 43.1381 60.3897 41.804C60.3897 37.8574 62.9641 35.1285 66.9673 34.8375L67.6883 34.8117H71.4518C70.5071 33.8202 70.0087 32.3407 70.0087 30.8197C70.0087 26.8682 72.7591 24.0372 76.8081 23.7348L77.5358 23.708L78.6587 23.7046ZM108.036 0.419922C121.805 0.419922 132.966 11.5816 132.966 25.3502C132.966 39.1189 121.805 50.2806 108.036 50.2806C94.2672 50.2806 83.1056 39.1189 83.1056 25.3502C83.1056 11.5816 94.2672 0.419922 108.036 0.419922ZM108.036 5.61099C97.1342 5.61099 88.2966 14.4486 88.2966 25.3502C88.2966 36.2519 97.1342 45.0895 108.036 45.0895C118.938 45.0895 127.775 36.2519 127.775 25.3502C127.775 14.4486 118.938 5.61099 108.036 5.61099ZM108.196 10.2024C108.859 10.2024 109.398 10.4054 109.815 10.8115C110.149 11.1364 110.349 11.5433 110.415 12.0323L110.44 12.4144V13.9212L111.5 14.1354C112.905 14.4842 114.283 15.086 115.634 15.9409C116.019 16.1974 116.291 16.4806 116.451 16.7905C116.612 17.1004 116.692 17.4798 116.692 17.9286C116.692 18.5698 116.499 19.1255 116.115 19.5957C115.73 20.0659 115.281 20.301 114.768 20.301C114.512 20.301 114.266 20.2582 114.031 20.1727C113.796 20.0872 113.454 19.9269 113.005 19.6918C112.855 19.6063 112.524 19.43 112.011 19.1629C111.498 18.8957 110.948 18.682 110.36 18.5217C109.772 18.3614 109.147 18.2812 108.485 18.2812C107.523 18.2812 106.743 18.4896 106.144 18.9064C105.546 19.3232 105.247 19.8842 105.247 20.5895C105.247 21.2734 105.589 21.7864 106.273 22.1283C106.957 22.4703 108.036 22.8122 109.511 23.1542C111.092 23.5175 112.391 23.9023 113.406 24.3083C114.421 24.7144 115.297 25.3663 116.035 26.2639C116.772 27.1616 117.141 28.3691 117.141 29.8866C117.141 31.6178 116.548 33.0925 115.361 34.3107C114.345 35.3549 113.026 36.093 111.404 36.5248L110.569 36.7152V38.286L110.544 38.6682C110.477 39.1572 110.277 39.5641 109.943 39.889C109.527 40.2951 108.987 40.4981 108.324 40.4981C107.662 40.4981 107.122 40.2951 106.705 39.889C106.372 39.5641 106.172 39.1572 106.105 38.6682L106.08 38.286V36.8434L105.084 36.6909C103.135 36.3376 101.436 35.6939 99.9891 34.7596C99.6044 34.5245 99.3319 34.2573 99.1716 33.9581C99.0113 33.6589 98.9311 33.2635 98.9311 32.7719C98.9311 32.1307 99.1181 31.575 99.4922 31.1048C99.8662 30.6346 100.31 30.3995 100.823 30.3995C101.079 30.3995 101.336 30.4423 101.592 30.5278C101.848 30.6133 102.18 30.7736 102.586 31.0087C103.526 31.5216 104.403 31.8849 105.215 32.0987C106.027 32.3124 106.892 32.4193 107.811 32.4193C108.944 32.4193 109.804 32.2322 110.392 31.8582C110.98 31.4842 111.274 30.9232 111.274 30.1751C111.274 29.7263 111.098 29.3576 110.745 29.0691C110.392 28.7806 109.954 28.5508 109.43 28.3798C108.907 28.2088 108.143 27.9951 107.138 27.7386C105.535 27.3326 104.221 26.9211 103.195 26.5044C102.169 26.0876 101.282 25.4357 100.534 24.5488C99.786 23.6618 99.412 22.4703 99.412 20.9742C99.412 19.2644 100.01 17.779 101.207 16.518C102.233 15.4372 103.542 14.6704 105.133 14.2176L105.952 14.0174V12.4144L105.992 11.9546C106.072 11.5158 106.273 11.1401 106.593 10.8275C107.021 10.4108 107.555 10.2024 108.196 10.2024Z\" fill=\"#B6C5D5\"/>\n<path d=\"M130 97C141.598 97 151 87.598 151 76C151 64.402 141.598 55 130 55C118.402 55 109 64.402 109 76C109 87.598 118.402 97 130 97Z\" fill=\"white\"/>\n<path d=\"M129.974 96.1149C140.938 96.1149 149.971 87.0598 149.971 76.0959C149.971 65.1543 140.915 56.0991 129.974 56.0991C119.01 56.0991 109.977 65.1543 109.977 76.0959C109.977 87.0598 119.032 96.1149 129.974 96.1149ZM122.783 84.7538C121.966 84.7538 121.337 84.1035 121.337 83.3079C121.337 82.9084 121.485 82.5533 121.757 82.3014L127.92 76.117L121.757 69.9338C121.485 69.6819 121.337 69.3256 121.337 68.9273C121.337 68.1105 121.966 67.5024 122.784 67.5024C123.182 67.5024 123.518 67.6489 123.791 67.9219L129.974 74.084L136.178 67.9219C136.472 67.6067 136.807 67.4602 137.185 67.4602C137.981 67.4602 138.631 68.1105 138.631 68.9062C138.631 69.3057 138.505 69.6197 138.191 69.9127L132.007 76.117L138.191 82.2592C138.463 82.5533 138.611 82.8884 138.611 83.3079C138.611 84.1035 137.981 84.7538 137.164 84.7538C136.744 84.7538 136.388 84.5862 136.116 84.3132L129.974 78.1511L123.811 84.3132C123.56 84.5862 123.182 84.7538 122.784 84.7538H122.783Z\" fill=\"#DD2457\"/>\n</svg>";

var LinealCobroAnticipadoSinGenerar = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M34.9167 67.6692C36.1418 67.6692 37.1361 68.6635 37.1361 69.8886C37.1361 71.058 36.2302 72.0171 35.0823 72.1019L34.9167 72.108H11.2912C10.065 72.108 9.0718 71.1137 9.0718 69.8886C9.0718 68.7192 9.97674 67.76 11.1255 67.6753L11.2912 67.6692H34.9167ZM44.7459 56.8961C45.971 56.8961 46.9653 57.8904 46.9653 59.1155C46.9653 60.2849 46.0593 61.244 44.9114 61.3288L44.7459 61.3349H22.3177C21.0926 61.3349 20.0983 60.3406 20.0983 59.1155C20.0983 57.9461 21.0043 56.987 22.1522 56.9022L22.3177 56.8961H44.7459ZM11.2912 56.8961C12.5163 56.8961 13.5106 57.8904 13.5106 59.1155C13.5106 60.2849 12.6046 61.244 11.4568 61.3288L11.2912 61.3349H2.2194C0.994291 61.3349 0 60.3406 0 59.1155C0 57.9461 0.905956 56.987 2.05384 56.9022L2.2194 56.8961H11.2912ZM163.039 50.7955C164.265 50.7955 165.259 51.7898 165.259 53.0149C165.259 54.1843 164.353 55.1434 163.205 55.2282L163.039 55.2343H150.755C149.529 55.2343 148.536 54.24 148.536 53.0149C148.536 51.8455 149.441 50.8864 150.589 50.8016L150.755 50.7955H163.039ZM175.325 50.7955C176.55 50.7955 177.545 51.7898 177.545 53.0149C177.545 54.1843 176.639 55.1434 175.491 55.2282L175.325 55.2343H171.546C170.319 55.2343 169.326 54.24 169.326 53.0149C169.326 51.8455 170.231 50.8864 171.38 50.8016L171.546 50.7955H175.325ZM40.9797 46.1226C42.2059 46.1226 43.1991 47.1169 43.1991 48.342C43.1991 49.5114 42.2941 50.4705 41.1454 50.5553L40.9797 50.5614H12.0476C10.8225 50.5614 9.82817 49.5671 9.82817 48.342C9.82817 47.1725 10.7341 46.2134 11.882 46.1287L12.0476 46.1226H40.9797ZM189.781 40.022C191.006 40.022 192 41.0163 192 42.2414C192 43.4108 191.094 44.3699 189.946 44.4547L189.781 44.4608H180.263C179.036 44.4608 178.043 43.4665 178.043 42.2414C178.043 41.072 178.948 40.1129 180.097 40.0281L180.263 40.022H189.781ZM169.308 40.022C170.533 40.022 171.527 41.0163 171.527 42.2414C171.527 43.4108 170.621 44.3699 169.473 44.4547L169.308 44.4608H153.309C152.084 44.4608 151.09 43.4665 151.09 42.2414C151.09 41.072 151.996 40.1129 153.143 40.0281L153.309 40.022H169.308ZM178.91 29.249C180.136 29.249 181.129 30.2433 181.129 31.4684C181.129 32.6378 180.224 33.597 179.075 33.6817L178.91 33.6878H160.293C159.068 33.6878 158.074 32.6935 158.074 31.4684C158.074 30.299 158.98 29.3399 160.128 29.2551L160.293 29.249H178.91ZM151.517 29.249C152.742 29.249 153.736 30.2433 153.736 31.4684C153.736 32.6378 152.83 33.597 151.682 33.6817L151.517 33.6878H147.736C146.51 33.6878 145.516 32.6935 145.516 31.4684C145.516 30.299 146.421 29.3399 147.57 29.2551L147.736 29.249H151.517Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M78.6587 27.7046C78.6287 28.2493 78.6135 28.798 78.6135 29.3502C78.6135 30.702 78.7047 32.0325 78.8812 33.3359L78.221 33.3351C76.6273 33.3351 75.558 34.3266 75.558 35.8061C75.558 37.1749 76.4242 38.2074 77.7592 38.4003L78.221 38.4327L80.0419 38.432C80.6323 40.2532 81.3955 41.9966 82.3121 43.6429L68.5293 43.6394C66.9252 43.6394 65.8611 44.6672 65.8611 46.1467C65.8611 47.5529 66.723 48.5219 68.0648 48.7016L68.5293 48.7318L85.8971 48.73C87.6611 50.7435 89.6954 52.5143 91.9433 53.9857L63.7743 53.9852C62.1754 53.9852 61.0749 55.0493 61.0749 56.5703C61.0749 57.9018 61.9411 58.897 63.3026 59.0827L63.7743 59.1139H95.6734C97.1891 59.1139 98.3364 60.256 98.3364 61.6576C98.3364 62.9937 97.4071 64.086 96.1163 64.2911L95.6734 64.3258H68.5293C66.9252 64.3258 65.8611 65.3899 65.8611 66.9109C65.8611 68.2424 66.723 69.2376 68.0648 69.4233L68.5293 69.4545H106.092C108.028 69.4545 109.357 70.6329 109.357 72.3044C109.357 73.6079 108.836 74.7264 107.237 75.6258L106.663 75.9174L95.0608 81.2071C93.5398 81.8871 92.7819 83.1434 93.3166 84.5086C93.7931 85.742 94.9509 86.269 96.5059 85.8891L97.0386 85.7285L115.898 78.9957C128.787 74.3964 133.843 66.3399 133.843 55.2725C133.843 51.8644 133.297 48.7872 132.238 46.089C133.572 44.1614 134.686 42.0624 135.536 39.8334C138.25 44.1395 139.704 49.4388 139.704 55.4646C139.704 68.8846 132.729 78.3704 119.029 83.6473L117.725 84.1297L98.8295 90.8573C93.9292 92.6119 89.7815 91.0494 88.2605 86.9433C87.0098 83.4695 88.3479 80.0325 91.9026 78.1861L92.5951 77.8589L97.838 75.689C98.0353 75.6163 98.1028 75.4969 98.1028 75.3879C98.1028 75.2166 98.0415 75.13 97.9144 75.0974L97.7654 75.0817H67.9583C63.359 75.0817 60.3897 72.1176 60.3897 67.591C60.3897 66.1115 60.8828 64.7411 61.7549 63.6769C57.9187 63.028 55.6035 60.4429 55.6035 56.5703C55.6035 52.8016 57.9966 50.1022 61.6874 49.4222C60.8465 48.4255 60.3897 47.1381 60.3897 45.804C60.3897 41.8574 62.9641 39.1285 66.9673 38.8375L67.6883 38.8117H71.4518C70.5071 37.8202 70.0087 36.3407 70.0087 34.8197C70.0087 30.8682 72.7591 28.0372 76.8081 27.7348L77.5358 27.708L78.6587 27.7046ZM108.036 4.41992C121.805 4.41992 132.966 15.5816 132.966 29.3502C132.966 43.1189 121.805 54.2806 108.036 54.2806C94.2672 54.2806 83.1056 43.1189 83.1056 29.3502C83.1056 15.5816 94.2672 4.41992 108.036 4.41992ZM108.036 9.61099C97.1342 9.61099 88.2966 18.4486 88.2966 29.3502C88.2966 40.2519 97.1342 49.0895 108.036 49.0895C118.938 49.0895 127.775 40.2519 127.775 29.3502C127.775 18.4486 118.938 9.61099 108.036 9.61099ZM108.196 14.2024C108.859 14.2024 109.398 14.4054 109.815 14.8115C110.149 15.1364 110.349 15.5433 110.415 16.0323L110.44 16.4144V17.9212L111.5 18.1354C112.905 18.4842 114.283 19.086 115.634 19.9409C116.019 20.1974 116.291 20.4806 116.451 20.7905C116.612 21.1004 116.692 21.4798 116.692 21.9286C116.692 22.5698 116.499 23.1255 116.115 23.5957C115.73 24.0659 115.281 24.301 114.768 24.301C114.512 24.301 114.266 24.2582 114.031 24.1727C113.796 24.0872 113.454 23.9269 113.005 23.6918C112.855 23.6063 112.524 23.43 112.011 23.1629C111.498 22.8957 110.948 22.682 110.36 22.5217C109.772 22.3614 109.147 22.2812 108.485 22.2812C107.523 22.2812 106.743 22.4896 106.144 22.9064C105.546 23.3232 105.247 23.8842 105.247 24.5895C105.247 25.2734 105.589 25.7864 106.273 26.1283C106.957 26.4703 108.036 26.8122 109.511 27.1542C111.092 27.5175 112.391 27.9023 113.406 28.3083C114.421 28.7144 115.297 29.3663 116.035 30.2639C116.772 31.1616 117.141 32.3691 117.141 33.8866C117.141 35.6178 116.548 37.0925 115.361 38.3107C114.345 39.3549 113.026 40.093 111.404 40.5248L110.569 40.7152V42.286L110.544 42.6682C110.477 43.1572 110.277 43.5641 109.943 43.889C109.527 44.2951 108.987 44.4981 108.324 44.4981C107.662 44.4981 107.122 44.2951 106.705 43.889C106.372 43.5641 106.172 43.1572 106.105 42.6682L106.08 42.286V40.8434L105.084 40.6909C103.135 40.3376 101.436 39.6939 99.9891 38.7596C99.6044 38.5245 99.3319 38.2573 99.1716 37.9581C99.0113 37.6589 98.9311 37.2635 98.9311 36.7719C98.9311 36.1307 99.1181 35.575 99.4922 35.1048C99.8662 34.6346 100.31 34.3995 100.823 34.3995C101.079 34.3995 101.336 34.4423 101.592 34.5278C101.848 34.6133 102.18 34.7736 102.586 35.0087C103.526 35.5216 104.403 35.8849 105.215 36.0987C106.027 36.3124 106.892 36.4193 107.811 36.4193C108.944 36.4193 109.804 36.2322 110.392 35.8582C110.98 35.4842 111.274 34.9232 111.274 34.1751C111.274 33.7263 111.098 33.3576 110.745 33.0691C110.392 32.7806 109.954 32.5508 109.43 32.3798C108.907 32.2088 108.143 31.9951 107.138 31.7386C105.535 31.3326 104.221 30.9211 103.195 30.5044C102.169 30.0876 101.282 29.4357 100.534 28.5488C99.786 27.6618 99.412 26.4703 99.412 24.9742C99.412 23.2644 100.01 21.779 101.207 20.518C102.233 19.4372 103.542 18.6704 105.133 18.2176L105.952 18.0174V16.4144L105.992 15.9546C106.072 15.5158 106.273 15.1401 106.593 14.8275C107.021 14.4108 107.555 14.2024 108.196 14.2024Z\" fill=\"#B6C5D5\"/>\n</svg>";

var LinealCobroAnticipadoWarning = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M38.8099 59.8525C39.9611 59.8525 40.8954 60.7868 40.8954 61.9379C40.8954 63.0368 40.0441 63.938 38.9655 64.0177L38.8099 64.0234H16.6099C15.4577 64.0234 14.5244 63.0891 14.5244 61.9379C14.5244 60.8391 15.3748 59.9378 16.4542 59.8582L16.6099 59.8525H38.8099ZM48.046 49.7294C49.1972 49.7294 50.1315 50.6637 50.1315 51.8149C50.1315 52.9137 49.2802 53.815 48.2016 53.8947L48.046 53.9004H26.9711C25.8199 53.9004 24.8856 52.9661 24.8856 51.8149C24.8856 50.716 25.7369 49.8148 26.8156 49.7351L26.9711 49.7294H48.046ZM16.6099 49.7294C17.7611 49.7294 18.6954 50.6637 18.6954 51.8149C18.6954 52.9137 17.8441 53.815 16.7655 53.8947L16.6099 53.9004H8.08549C6.9343 53.9004 6 52.9661 6 51.8149C6 50.716 6.85129 49.8148 7.92992 49.7351L8.08549 49.7294H16.6099ZM159.202 43.9969C160.353 43.9969 161.288 44.9312 161.288 46.0824C161.288 47.1813 160.436 48.0825 159.358 48.1622L159.202 48.1679H147.659C146.507 48.1679 145.573 47.2336 145.573 46.0824C145.573 44.9835 146.424 44.0823 147.503 44.0026L147.659 43.9969H159.202ZM170.747 43.9969C171.898 43.9969 172.832 44.9312 172.832 46.0824C172.832 47.1813 171.981 48.0825 170.902 48.1622L170.747 48.1679H167.195C166.043 48.1679 165.11 47.2336 165.11 46.0824C165.11 44.9835 165.96 44.0823 167.039 44.0026L167.195 43.9969H170.747ZM44.5071 39.6059C45.6593 39.6059 46.5925 40.5402 46.5925 41.6914C46.5925 42.7903 45.7422 43.6915 44.6628 43.7712L44.5071 43.7769H17.3206C16.1695 43.7769 15.2352 42.8426 15.2352 41.6914C15.2352 40.5926 16.0865 39.6913 17.1651 39.6116L17.3206 39.6059H44.5071ZM184.33 33.8734C185.481 33.8734 186.415 34.8077 186.415 35.9589C186.415 37.0578 185.564 37.959 184.485 38.0387L184.33 38.0444H175.386C174.234 38.0444 173.301 37.1101 173.301 35.9589C173.301 34.8601 174.151 33.9588 175.23 33.8792L175.386 33.8734H184.33ZM165.092 33.8734C166.243 33.8734 167.177 34.8077 167.177 35.9589C167.177 37.0578 166.326 37.959 165.247 38.0387L165.092 38.0444H150.059C148.907 38.0444 147.973 37.1101 147.973 35.9589C147.973 34.8601 148.824 33.9588 149.903 33.8792L150.059 33.8734H165.092ZM174.115 23.7505C175.267 23.7505 176.2 24.6848 176.2 25.836C176.2 26.9348 175.35 27.8361 174.27 27.9157L174.115 27.9215H156.622C155.47 27.9215 154.536 26.9872 154.536 25.836C154.536 24.7371 155.387 23.8359 156.466 23.7562L156.622 23.7505H174.115ZM148.374 23.7505C149.526 23.7505 150.46 24.6848 150.46 25.836C150.46 26.9348 149.609 27.8361 148.53 27.9157L148.374 27.9215H144.822C143.67 27.9215 142.736 26.9872 142.736 25.836C142.736 24.7371 143.587 23.8359 144.666 23.7562L144.822 23.7505H148.374Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M79.9127 22.2996C79.8844 22.8115 79.8701 23.3271 79.8701 23.846C79.8701 25.1162 79.9558 26.3664 80.1217 27.5912L79.5013 27.5904C78.0038 27.5904 76.999 28.5221 76.999 29.9123C76.999 31.1986 77.8129 32.1688 79.0674 32.35L79.5013 32.3805L81.2123 32.3798C81.7671 34.0911 82.4843 35.7293 83.3456 37.2763L70.3944 37.273C68.8871 37.273 67.8872 38.2388 67.8872 39.629C67.8872 40.9504 68.6971 41.8609 69.9579 42.0298L70.3944 42.0581L86.7143 42.0565C88.3719 43.9484 90.2834 45.6124 92.3956 46.995L65.9263 46.9945C64.4239 46.9945 63.3898 47.9945 63.3898 49.4237C63.3898 50.6748 64.2037 51.6099 65.4831 51.7844L65.9263 51.8138H95.9007C97.325 51.8138 98.403 52.887 98.403 54.204C98.403 55.4595 97.5298 56.4859 96.3168 56.6786L95.9007 56.7112H70.3944C68.8871 56.7112 67.8872 57.7111 67.8872 59.1404C67.8872 60.3915 68.6971 61.3266 69.9579 61.5011L70.3944 61.5305H105.69C107.51 61.5305 108.759 62.6378 108.759 64.2084C108.759 65.4333 108.269 66.4842 106.766 67.3294L106.227 67.6034L95.3251 72.5739C93.8959 73.2129 93.1837 74.3934 93.6861 75.6763C94.1339 76.8352 95.2218 77.3304 96.683 76.9734L97.1835 76.8225L114.905 70.496C127.016 66.1742 131.767 58.6038 131.767 48.2042C131.767 45.0017 131.254 42.1102 130.259 39.5747C131.513 37.7635 132.559 35.7911 133.358 33.6966C135.908 37.7429 137.275 42.7224 137.275 48.3847C137.275 60.995 130.72 69.9084 117.847 74.8669L116.622 75.3202L98.8664 81.6419C94.2617 83.2906 90.3643 81.8223 88.9351 77.964C87.7598 74.6998 89.0172 71.4703 92.3575 69.7352L93.0081 69.4277L97.9347 67.3888C98.1201 67.3205 98.1835 67.2083 98.1835 67.1059C98.1835 66.9449 98.1259 66.8635 98.0065 66.8329L97.8664 66.8181H69.8578C65.536 66.8181 62.7459 64.0328 62.7459 59.7794C62.7459 58.3892 63.2093 57.1014 64.0288 56.1015C60.4241 55.4917 58.2485 53.0626 58.2485 49.4237C58.2485 45.8824 60.4972 43.3459 63.9654 42.7069C63.1752 41.7703 62.7459 40.5606 62.7459 39.307C62.7459 35.5985 65.165 33.0343 68.9266 32.7608L69.6042 32.7366H73.1406C72.2528 31.8049 71.7846 30.4147 71.7846 28.9855C71.7846 25.2724 74.369 22.6122 78.1737 22.328L78.8574 22.3028L79.9127 22.2996ZM107.517 0.419922C120.455 0.419922 130.943 10.9081 130.943 23.846C130.943 36.7839 120.455 47.2721 107.517 47.2721C94.5794 47.2721 84.0912 36.7839 84.0912 23.846C84.0912 10.9081 94.5794 0.419922 107.517 0.419922ZM107.517 5.29777C97.2733 5.29777 88.969 13.6021 88.969 23.846C88.969 34.0899 97.2733 42.3942 107.517 42.3942C117.761 42.3942 126.065 34.0899 126.065 23.846C126.065 13.6021 117.761 5.29777 107.517 5.29777ZM107.668 9.61213C108.29 9.61213 108.798 9.80292 109.189 10.1845C109.502 10.4898 109.69 10.8721 109.753 11.3316L109.777 11.6907V13.1066L110.772 13.3078C112.093 13.6356 113.388 14.2011 114.657 15.0044C115.018 15.2454 115.274 15.5115 115.425 15.8027C115.576 16.0939 115.651 16.4504 115.651 16.8722C115.651 17.4747 115.47 17.9968 115.109 18.4386C114.747 18.8805 114.325 19.1014 113.843 19.1014C113.602 19.1014 113.371 19.0612 113.151 18.9809C112.93 18.9005 112.608 18.7499 112.187 18.529C112.046 18.4487 111.735 18.283 111.253 18.032C110.771 17.7809 110.254 17.5801 109.701 17.4295C109.149 17.2788 108.562 17.2035 107.939 17.2035C107.035 17.2035 106.302 17.3993 105.74 17.791C105.178 18.1826 104.896 18.7098 104.896 19.3725C104.896 20.0152 105.218 20.4972 105.86 20.8185C106.503 21.1398 107.517 21.4611 108.903 21.7825C110.389 22.1239 111.609 22.4854 112.563 22.867C113.517 23.2485 114.34 23.8611 115.033 24.7046C115.726 25.548 116.073 26.6827 116.073 28.1086C116.073 29.7354 115.515 31.1211 114.401 32.2658C113.445 33.247 112.206 33.9405 110.682 34.3463L109.897 34.5252V36.0013L109.874 36.3604C109.811 36.8199 109.623 37.2023 109.31 37.5075C108.918 37.8891 108.411 38.0799 107.788 38.0799C107.166 38.0799 106.659 37.8891 106.267 37.5075C105.954 37.2023 105.766 36.8199 105.703 36.3604L105.68 36.0013V34.6457L104.744 34.5024C102.912 34.1704 101.316 33.5655 99.956 32.6876C99.5945 32.4667 99.3384 32.2156 99.1878 31.9345C99.0372 31.6533 98.9619 31.2818 98.9619 30.8199C98.9619 30.2174 99.1376 29.6952 99.489 29.2534C99.8405 28.8115 100.257 28.5906 100.739 28.5906C100.98 28.5906 101.221 28.6308 101.462 28.7111C101.703 28.7915 102.014 28.9421 102.396 29.163C103.28 29.645 104.103 29.9864 104.866 30.1872C105.629 30.3881 106.443 30.4885 107.306 30.4885C108.371 30.4885 109.179 30.3128 109.731 29.9613C110.284 29.6098 110.56 29.0827 110.56 28.3798C110.56 27.958 110.394 27.6116 110.063 27.3405C109.731 27.0693 109.32 26.8534 108.828 26.6928C108.336 26.5321 107.618 26.3313 106.674 26.0903C105.168 25.7087 103.932 25.3221 102.968 24.9305C102.004 24.5389 101.171 23.9263 100.468 23.0929C99.7652 22.2594 99.4137 21.1398 99.4137 19.734C99.4137 18.1274 99.9761 16.7316 101.101 15.5467C102.065 14.531 103.294 13.8105 104.789 13.3851L105.559 13.197V11.6907L105.597 11.2586C105.672 10.8463 105.86 10.4933 106.162 10.1996C106.563 9.80794 107.065 9.61213 107.668 9.61213Z\" fill=\"#B6C5D5\"/>\n<path d=\"M133.215 97.9998C145.309 97.9998 155.113 88.1959 155.113 76.1022C155.113 64.0085 145.309 54.2046 133.215 54.2046C121.121 54.2046 111.317 64.0085 111.317 76.1022C111.317 88.1959 121.121 97.9998 133.215 97.9998Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M133.215 96.0791C143.695 96.0791 152.332 87.4269 152.332 76.9522C152.332 66.4974 143.675 57.8452 133.215 57.8452C122.734 57.8452 114.098 66.4974 114.098 76.9522C114.098 87.4269 122.754 96.0791 133.215 96.0791ZM133.536 79.9233C134.399 79.9233 134.93 79.3919 134.93 78.44L135.196 67.3041C135.218 66.3742 134.488 65.6658 133.513 65.6658C132.517 65.6658 131.831 66.3521 131.853 67.3041L132.097 78.44C132.119 79.3919 132.628 79.9233 133.536 79.9233ZM133.536 86.5207C132.429 86.5207 131.477 85.613 131.477 84.5282C131.477 83.4212 132.407 82.5357 133.536 82.5357C134.665 82.5357 135.595 83.3991 135.595 84.5282C135.595 85.6351 134.643 86.5207 133.536 86.5207Z\" fill=\"#FECF2F\"/>\n</svg>";

var LinealColaboradoresAlta = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" d=\"M94.0107 83.1669C98.2969 83.1669 102.423 82.4137 106.264 81.034C106.548 82.4632 106.966 83.8455 107.504 85.1671C104.092 86.2305 100.476 86.8035 96.7365 86.8035C83.9855 86.8035 72.628 80.1124 66.0176 70.0766C72.7944 78.0596 82.8711 83.1669 94.0107 83.1669ZM124.74 26.2617C130.197 32.691 133.511 40.9828 133.511 49.9645C133.511 51.3534 133.432 52.725 133.279 54.0762C132.224 53.8619 131.143 53.7211 130.041 53.6578C130.529 51.2866 130.786 48.8348 130.786 46.3284C130.786 39.0795 128.627 32.2803 124.926 26.547L124.74 26.2617Z\" fill=\"#B6C5D5\"/>\n</g>\n<path d=\"M94.4226 9.99316C114.525 9.99316 131.162 26.6211 131.162 46.7128C131.162 49.2233 130.903 51.6797 130.412 54.056C129.833 54.0116 129.249 53.9897 128.66 53.9897C127.985 53.9897 127.316 54.0187 126.655 54.0759C127.186 51.7113 127.462 49.2473 127.45 46.7118C127.409 28.4494 112.694 13.7436 94.4226 13.7436C76.1102 13.7431 61.4361 28.4494 61.4361 46.7118C61.4361 55.2776 64.6298 63.0351 69.9253 68.8526C73.6043 64.1255 82.6187 59.6005 94.4226 59.6005C100.75 59.6005 106.269 60.8915 110.599 62.8218C107.583 66.6947 105.787 71.5626 105.787 76.85C105.787 78.4379 105.949 79.9876 106.257 81.4842C102.537 82.7716 98.5542 83.4712 94.4226 83.4712C74.3197 83.4712 57.6836 66.8432 57.6836 46.7128C57.6836 26.6211 74.2815 9.99316 94.4226 9.99316ZM94.4226 24.6117C101.739 24.6117 107.479 30.9951 107.479 38.7123C107.479 46.8735 101.78 53.136 94.4226 53.0964C87.1054 53.0145 81.4058 46.8735 81.3647 38.7118C81.3251 30.9956 87.1462 24.6122 94.4226 24.6122V24.6117Z\" fill=\"#B6C5D5\"/>\n<path d=\"M129.672 96.2278C132.358 96.2278 134.9 95.7012 137.299 94.6481C139.697 93.5949 141.815 92.1518 143.651 90.3195C145.488 88.4866 146.927 86.3736 147.968 83.98C149.01 81.5868 149.531 79.0355 149.531 76.3275C149.531 73.5925 149.017 71.0274 147.989 68.6343C146.961 66.2406 145.536 64.1276 143.713 62.2948C141.89 60.4619 139.773 59.026 137.36 57.9866C134.948 56.9472 132.385 56.4272 129.672 56.4272C126.93 56.4272 124.361 56.9538 121.963 58.007C119.564 59.0602 117.447 60.4961 115.61 62.3152C113.773 64.1343 112.334 66.2406 111.293 68.6343C110.251 71.0274 109.73 73.592 109.73 76.3275C109.73 79.0626 110.251 81.6276 111.293 84.0208C112.334 86.4144 113.773 88.5274 115.61 90.3603C117.447 92.1932 119.564 93.6291 121.963 94.6685C124.361 95.7079 126.93 96.2278 129.672 96.2278Z\" fill=\"#B6C5D5\"/>\n<path d=\"M129.61 88.5737C128.858 88.5737 128.246 88.3416 127.773 87.8767C127.299 87.4124 127.062 86.8113 127.062 86.0734V78.6134H119.463C118.683 78.6134 118.057 78.3812 117.584 77.9169C117.11 77.4525 116.874 76.8372 116.874 76.0723C116.874 75.2798 117.11 74.6583 117.583 74.2073C118.057 73.7562 118.683 73.5312 119.463 73.5312H127.062V66.1119C127.062 65.3465 127.299 64.7322 127.772 64.2678C128.246 63.8035 128.858 63.5708 129.609 63.5708C130.389 63.5708 131.015 63.803 131.488 64.2678C131.962 64.7322 132.198 65.347 132.198 66.1119V73.5312H139.798C140.578 73.5312 141.204 73.7562 141.677 74.2073C142.15 74.6583 142.387 75.2798 142.387 76.0723C142.387 76.8377 142.15 77.452 141.677 77.9169C141.204 78.3812 140.578 78.6134 139.798 78.6134H132.198V86.0734C132.198 86.8113 131.962 87.4124 131.489 87.8767C131.015 88.341 130.389 88.5737 129.61 88.5737Z\" fill=\"white\"/>\n<path d=\"M62.8589 75.0586C62.8568 75.9878 63.2252 76.8802 63.883 77.5379C64.5402 78.1962 65.4332 78.5656 66.3639 78.5656C65.4332 78.5656 64.5402 78.9356 63.883 79.5933C63.2247 80.2515 62.8568 81.143 62.8589 82.0727C62.8604 81.1419 62.4915 80.2485 61.8322 79.5907C61.173 78.9325 60.278 78.5636 59.3457 78.5656C60.278 78.5677 61.1724 78.1987 61.8322 77.5405C62.491 76.8823 62.8604 75.9893 62.8589 75.0586ZM13.4847 71.4245C13.4847 73.8972 15.4921 75.9015 17.9689 75.9015C15.4921 75.9015 13.4847 77.9063 13.4847 80.3786C13.4847 77.9063 11.4768 75.9015 9 75.9015C11.4768 75.9015 13.4847 73.8972 13.4847 71.4245ZM161.816 70.9841C161.816 73.0446 163.49 74.7152 165.554 74.7152C163.49 74.7152 161.816 76.3853 161.816 78.4457C161.816 76.3853 160.143 74.7152 158.079 74.7152C160.143 74.7152 161.816 73.0446 161.816 70.9841ZM178.005 42.2267C178.005 44.6994 180.013 46.7037 182.49 46.7037C180.013 46.7037 178.005 48.7085 178.005 51.1808C178.005 48.7085 175.998 46.7037 173.521 46.7037C175.998 46.7037 178.005 44.6994 178.005 42.2267ZM48.5781 42.2741C48.5761 43.2038 48.9445 44.0958 49.6022 44.754C50.2594 45.4117 51.1524 45.7812 52.0831 45.7812C51.1524 45.7812 50.2594 46.1511 49.6022 46.8088C48.944 47.4671 48.5761 48.359 48.5781 49.2887C48.5802 48.3575 48.2107 47.4645 47.5515 46.8063C46.8922 46.148 45.9972 45.7791 45.0649 45.7812C45.9972 45.7832 46.8917 45.4143 47.5515 44.7565C48.2107 44.0983 48.5802 43.2053 48.5781 42.2741ZM15.6819 34.0645C15.6819 35.7744 17.0708 37.1608 18.7838 37.1608C17.0708 37.1608 15.6819 38.5471 15.6819 40.2575C15.6819 38.5471 14.293 37.1608 12.58 37.1608C14.293 37.1608 15.6819 35.7744 15.6819 34.064V34.0645ZM145.343 34.9222C145.343 36.1586 146.347 37.1608 147.586 37.1608C146.347 37.1608 145.343 38.1629 145.343 39.3993C145.343 38.1629 144.339 37.1608 143.101 37.1608C144.339 37.1608 145.343 36.1586 145.343 34.9222ZM42.0656 10.475C42.0656 11.9874 43.2938 13.2131 44.8088 13.2131C43.2953 13.2171 42.0697 14.4407 42.0656 15.9516C42.0656 14.4392 40.8374 13.2131 39.3224 13.2131C40.8379 13.2131 42.0656 11.9874 42.0656 10.475ZM135.991 4.36201C135.991 6.83424 137.999 8.83856 140.476 8.83856C137.999 8.83856 135.991 10.8429 135.991 13.3156C135.991 10.8429 133.984 8.83856 131.507 8.83856C133.984 8.83856 135.991 6.83424 135.991 4.3615V4.36201ZM176.623 2C176.621 2.82255 176.946 3.61243 177.528 4.19413C178.11 4.77686 178.901 5.10394 179.724 5.10394C178.011 5.10394 176.623 6.49032 176.623 8.20073C176.623 7.3792 176.296 6.59187 175.714 6.01118C175.133 5.4305 174.343 5.10394 173.52 5.10394C174.345 5.10394 175.135 4.77686 175.716 4.19465C176.298 3.61192 176.625 2.82204 176.623 2Z\" fill=\"#1AAAAD\"/>\n</svg>";

var LinealDireccionActualizar = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_201_374)\">\n<g opacity=\"0.6\">\n<path opacity=\"0.6\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M29.2426 43.9247C29.5346 43.9247 29.7879 44.0338 30.0072 44.2519C30.2241 44.47 30.3343 44.72 30.3343 45.0017C30.3343 45.2925 30.2196 45.5516 29.9924 45.7788L28.3031 47.4692L29.8561 48.9961C30.0833 49.2233 30.198 49.4823 30.198 49.7731C30.198 50.064 30.0901 50.3185 29.8765 50.5366C29.6629 50.7547 29.4107 50.8638 29.1199 50.8638C28.8109 50.8638 28.5439 50.7365 28.3156 50.482L26.8569 48.9961L25.3845 50.482C25.1482 50.7274 24.8801 50.8501 24.5802 50.8501C24.2894 50.8501 24.0383 50.7433 23.8236 50.5298C23.6112 50.3162 23.5032 50.0685 23.5032 49.7868C23.5032 49.496 23.618 49.2324 23.8441 48.9961L25.3982 47.4692L23.7089 45.7788C23.4817 45.5516 23.3669 45.2925 23.3669 45.0017C23.3669 44.72 23.4771 44.47 23.6941 44.2519C23.9122 44.0338 24.1667 43.9247 24.4575 43.9247C24.7586 43.9247 25.0256 44.0474 25.2619 44.2928L26.8569 45.956L28.4383 44.2928C28.6757 44.0474 28.9427 43.9247 29.2426 43.9247ZM190.787 40.1411C191.078 40.1411 191.328 40.2502 191.543 40.4683C191.756 40.6864 191.863 40.9409 191.863 41.2317C191.863 41.5226 191.749 41.7816 191.521 42.0088L189.968 43.5357L191.658 45.2261C191.884 45.4533 192 45.7123 192 46.0032C192 46.2849 191.889 46.5348 191.672 46.753C191.455 46.9711 191.199 47.0801 190.908 47.0801C190.609 47.0801 190.34 46.9575 190.103 46.7121L188.523 45.0489L186.928 46.7121C186.69 46.9575 186.424 47.0801 186.122 47.0801C185.831 47.0801 185.579 46.9711 185.359 46.753C185.142 46.5348 185.033 46.2849 185.033 46.0032C185.033 45.7123 185.146 45.4533 185.375 45.2261L187.063 43.5357L185.51 42.0088C185.284 41.7725 185.168 41.5089 185.168 41.2181C185.168 40.9364 185.277 40.6887 185.491 40.4751C185.703 40.2615 185.956 40.1547 186.247 40.1547C186.546 40.1547 186.815 40.2774 187.05 40.5228L188.523 42.0088L189.981 40.5228C190.21 40.2684 190.476 40.1411 190.787 40.1411ZM164.138 35.7245C164.428 35.7245 164.678 35.8336 164.894 36.0517C165.107 36.2698 165.213 36.5243 165.213 36.8151C165.213 37.1059 165.1 37.365 164.872 37.5922L163.319 39.119L165.009 40.8095C165.235 41.0367 165.351 41.2957 165.351 41.5865C165.351 41.8683 165.24 42.1182 165.023 42.3363C164.806 42.5545 164.55 42.6635 164.259 42.6635C163.959 42.6635 163.691 42.5408 163.454 42.2954L161.873 40.6323L160.278 42.2954C160.041 42.5408 159.775 42.6635 159.473 42.6635C159.182 42.6635 158.93 42.5545 158.71 42.3363C158.493 42.1182 158.383 41.8683 158.383 41.5865C158.383 41.2957 158.497 41.0367 158.725 40.8095L160.414 39.119L158.861 37.5922C158.635 37.3559 158.519 37.0923 158.519 36.8015C158.519 36.5197 158.628 36.2721 158.841 36.0585C159.054 35.8449 159.307 35.7381 159.598 35.7381C159.897 35.7381 160.166 35.8608 160.401 36.1062L161.873 37.5922L163.332 36.1062C163.561 35.8517 163.826 35.7245 164.138 35.7245ZM5.58418 31.622C5.87615 31.622 6.12949 31.731 6.34875 31.9492C6.56573 32.1673 6.67593 32.4172 6.67593 32.699C6.67593 32.9898 6.56119 33.2488 6.33398 33.476L4.64466 35.1665L6.19765 36.6933C6.42486 36.9205 6.5396 37.1796 6.5396 37.4704C6.5396 37.7612 6.43168 38.0157 6.2181 38.2338C6.00452 38.4519 5.75232 38.561 5.46149 38.561C5.15248 38.561 4.88551 38.4338 4.65716 38.1793L3.19846 36.6933L1.72613 38.1793C1.48983 38.4247 1.22172 38.5474 0.921805 38.5474C0.630974 38.5474 0.379906 38.4406 0.165191 38.227C-0.0472517 38.0134 -0.155177 37.7658 -0.155177 37.484C-0.155177 37.1932 -0.0404354 36.9296 0.18564 36.6933L1.73977 35.1665L0.0504491 33.476C-0.176762 33.2488 -0.291504 32.9898 -0.291504 32.699C-0.291504 32.4172 -0.181306 32.1673 0.0356803 31.9492C0.253803 31.731 0.50828 31.622 0.79911 31.622C1.10017 31.622 1.36714 31.7447 1.60344 31.9901L3.19846 33.6532L4.77985 31.9901C5.01729 31.7447 5.28426 31.622 5.58418 31.622ZM40.4909 24.6829C40.7817 24.6829 41.0328 24.792 41.2475 25.0101C41.46 25.2282 41.5679 25.4827 41.5679 25.7736C41.5679 26.0644 41.4531 26.3234 41.2259 26.5506L39.6729 28.0775L41.3623 29.7679C41.5895 29.9951 41.7042 30.2542 41.7042 30.545C41.7042 30.8267 41.594 31.0767 41.377 31.2948C41.1589 31.5129 40.9044 31.622 40.6125 31.622C40.3125 31.622 40.0456 31.4993 39.8081 31.2539L38.2267 29.5907L36.6317 31.2539C36.3954 31.4993 36.1284 31.622 35.8274 31.622C35.5366 31.622 35.2832 31.5129 35.064 31.2948C34.847 31.0767 34.7368 30.8267 34.7368 30.545C34.7368 30.2542 34.8515 29.9951 35.0787 29.7679L36.768 28.0775L35.2139 26.5506C34.9878 26.3143 34.8731 26.0507 34.8731 25.7599C34.8731 25.4782 34.981 25.2305 35.1946 25.0169C35.4082 24.8034 35.6604 24.6966 35.9512 24.6966C36.25 24.6966 36.5192 24.8193 36.7555 25.0647L38.2267 26.5506L39.6866 25.0647C39.9138 24.8102 40.1808 24.6829 40.4909 24.6829ZM179.91 19.9522C180.201 19.9522 180.452 20.0613 180.667 20.2794C180.879 20.4975 180.987 20.752 180.987 21.0428C180.987 21.3337 180.872 21.5927 180.645 21.8199L179.092 23.3468L180.781 25.0372C181.008 25.2644 181.123 25.5234 181.123 25.8143C181.123 26.096 181.013 26.3459 180.796 26.5641C180.578 26.7822 180.323 26.8912 180.031 26.8912C179.732 26.8912 179.465 26.7686 179.227 26.5232L177.646 24.86L176.051 26.5232C175.814 26.7686 175.547 26.8912 175.246 26.8912C174.956 26.8912 174.702 26.7822 174.483 26.5641C174.266 26.3459 174.156 26.096 174.156 25.8143C174.156 25.5234 174.271 25.2644 174.498 25.0372L176.187 23.3468L174.633 21.8199C174.407 21.5836 174.292 21.32 174.292 21.0292C174.292 20.7475 174.4 20.4998 174.614 20.2862C174.827 20.0726 175.079 19.9658 175.37 19.9658C175.669 19.9658 175.938 20.0885 176.175 20.3339L177.646 21.8199L179.106 20.3339C179.333 20.0795 179.6 19.9522 179.91 19.9522ZM154.84 12.021C155.131 12.021 155.382 12.1301 155.597 12.3482C155.809 12.5663 155.917 12.8208 155.917 13.1116C155.917 13.4024 155.802 13.6615 155.575 13.8887L154.022 15.4155L155.711 17.106C155.938 17.3332 156.053 17.5922 156.053 17.883C156.053 18.1648 155.943 18.4147 155.726 18.6328C155.508 18.851 155.253 18.96 154.961 18.96C154.662 18.96 154.395 18.8373 154.157 18.5919L152.576 16.9288L150.981 18.5919C150.744 18.8373 150.477 18.96 150.176 18.96C149.886 18.96 149.632 18.851 149.413 18.6328C149.196 18.4147 149.086 18.1648 149.086 17.883C149.086 17.5922 149.201 17.3332 149.428 17.106L151.117 15.4155L149.563 13.8887C149.337 13.6524 149.222 13.3888 149.222 13.098C149.222 12.8162 149.33 12.5686 149.544 12.355C149.757 12.1414 150.009 12.0346 150.3 12.0346C150.599 12.0346 150.868 12.1573 151.105 12.4027L152.576 13.8887L154.036 12.4027C154.263 12.1482 154.53 12.021 154.84 12.021ZM22.9022 12.021C23.1941 12.021 23.4475 12.1301 23.6667 12.3482C23.8837 12.5663 23.9939 12.8162 23.9939 13.098C23.9939 13.3888 23.8792 13.6478 23.652 13.875L21.9627 15.5655L23.5156 17.0924C23.7429 17.3196 23.8576 17.5786 23.8576 17.8694C23.8576 18.1602 23.7497 18.4147 23.5361 18.6328C23.3225 18.851 23.0703 18.96 22.7795 18.96C22.4705 18.96 22.2035 18.8328 21.9752 18.5783L20.5165 17.0924L19.0441 18.5783C18.8078 18.8237 18.5397 18.9464 18.2398 18.9464C17.949 18.9464 17.6979 18.8396 17.4832 18.626C17.2707 18.4125 17.1628 18.1648 17.1628 17.883C17.1628 17.5922 17.2776 17.3287 17.5036 17.0924L19.0578 15.5655L17.3684 13.875C17.1412 13.6478 17.0265 13.3888 17.0265 13.098C17.0265 12.8162 17.1367 12.5663 17.3537 12.3482C17.5718 12.1301 17.8263 12.021 18.1171 12.021C18.4182 12.021 18.6851 12.1437 18.9214 12.3891L20.5165 14.0523L22.0978 12.3891C22.3353 12.1437 22.6023 12.021 22.9022 12.021Z\" fill=\"#B6C5D5\"/>\n</g>\n<path opacity=\"0.6\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M124.909 5.43506V9.84042H128.662C130.555 9.84042 132.089 11.3745 132.089 13.2668V41.1674H129.152V63.6837L82.8018 63.6851C83.8196 63.0075 84.5647 61.9652 84.8376 60.7472L93.4058 60.7468L93.4185 41.1674H67.4768V49.7589C66.3774 49.7589 65.36 50.113 64.5396 50.7122L64.5399 41.1674H61.603V13.2668C61.603 11.3745 63.1371 9.84042 65.0294 9.84042H117.078V5.43506H124.909ZM111.041 24.9514L96.3554 41.1664L96.3427 60.7468H104.188V44.5938H116.915V60.7468H125.725V41.1664L111.041 24.9514ZM113.978 47.5307H107.125V60.7468H113.978V47.5307ZM128.662 12.7773H65.0294C64.7591 12.7773 64.5399 12.9965 64.5399 13.2668V38.2305H95.1109L111.041 20.439L127.274 38.2305H129.152V13.2668C129.152 12.9965 128.933 12.7773 128.662 12.7773ZM93.4195 19.1406V29.9093H84.6088V19.1406H93.4195ZM79.714 19.1406V29.9093H70.9032V19.1406H79.714ZM90.4826 22.0775H87.5457V26.9724H90.4826V22.0775ZM76.777 22.0775H73.8401V26.9724H76.777V22.0775Z\" fill=\"#B6C5D5\"/>\n<path opacity=\"0.6\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M83.2157 56.1321C84.4778 57.0046 85.2943 58.4425 85.2943 60.0561C85.2943 62.7176 83.0866 64.8585 80.3831 64.8585H66.0249C63.3215 64.8585 61.1138 62.7176 61.1138 60.0561C61.1138 58.3657 62.0098 56.8681 63.3757 56.0112C63.0728 55.3828 62.9085 54.6868 62.9085 53.9647C62.9085 51.3032 65.1163 49.1623 67.8197 49.1623C68.147 49.1623 68.4702 49.1939 68.7853 49.2554C69.586 47.6436 71.2775 46.5518 73.204 46.5518C75.1305 46.5518 76.8219 47.6435 77.6232 49.2553C77.9381 49.1938 78.2611 49.1623 78.5884 49.1623C81.2918 49.1623 83.4995 51.3032 83.4995 53.9647C83.4995 54.5966 83.3738 55.2084 83.1394 55.7726L83.0324 56.0114L83.2157 56.1321ZM66.0249 62.2153H80.3831C81.6446 62.2153 82.6511 61.2393 82.6511 60.0561C82.6511 58.9932 81.8338 58.0816 80.728 57.922L77.7769 57.4962L80.0744 55.5956C80.5702 55.1855 80.8563 54.5971 80.8563 53.9647C80.8563 52.7815 79.8499 51.8056 78.5884 51.8056C78.1709 51.8056 77.7739 51.912 77.4279 52.1101L75.6879 53.1064L75.4583 51.1145C75.3339 50.0357 74.3709 49.195 73.204 49.195C72.0373 49.195 71.0746 50.0355 70.951 51.1134L70.7228 53.1039L68.9828 52.1107C68.6348 51.9121 68.2372 51.8056 67.8197 51.8056C66.5582 51.8056 65.5518 52.7815 65.5518 53.9647C65.5518 54.5971 65.8379 55.1853 66.3333 55.595L68.6314 57.495L65.6803 57.9215C64.5743 58.0814 63.757 58.9932 63.757 60.0561C63.757 61.2393 64.7634 62.2153 66.0249 62.2153Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M152.778 71.4751C152.778 83.4489 143.072 93.1558 131.098 93.1558C119.124 93.1558 109.416 83.4489 109.416 71.4751C109.416 59.5013 119.124 49.7944 131.098 49.7944C143.072 49.7944 152.778 59.5013 152.778 71.4751Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M142.511 66.1551C143.259 67.7671 143.675 69.5691 143.675 71.4746C143.675 78.43 138.111 83.9783 131.142 83.9783C130.16 83.9783 129.177 83.8725 128.27 83.6751L132.518 87.894C132.715 88.1228 132.805 88.3893 132.787 88.6903C132.756 89.2482 132.31 89.6496 131.753 89.614C131.477 89.5967 131.263 89.4931 131.113 89.314L125.11 83.2068C124.883 82.9651 124.763 82.6932 124.763 82.4202C124.763 82.1483 124.853 81.8915 125.11 81.6347L131.113 75.5727C131.294 75.3904 131.521 75.2998 131.823 75.2998C132.253 75.2998 132.642 75.5598 132.75 75.9774C132.845 76.3442 132.777 76.7046 132.503 76.9776L127.816 81.6649C128.784 81.8915 129.917 81.9972 131.142 81.9972C137.023 81.9972 141.695 77.3261 141.695 71.4746C141.695 69.8755 141.349 68.3649 140.728 67.0129C140.513 66.5435 140.679 65.99 141.126 65.7321C141.623 65.4451 142.271 65.6339 142.511 66.1551ZM130.532 53.3362C130.808 53.3534 131.021 53.457 131.173 53.6361L137.174 59.7434C137.401 59.9851 137.522 60.257 137.522 60.5289C137.522 60.8019 137.431 61.0587 137.174 61.3155L131.173 67.3785C130.992 67.5598 130.765 67.6504 130.462 67.6504C130.031 67.6504 129.643 67.3904 129.535 66.9739C129.44 66.6059 129.509 66.2455 129.782 65.9715L134.468 61.2853C133.5 61.0587 132.366 60.953 131.142 60.953C125.261 60.953 120.59 65.624 120.59 71.4744C120.59 73.0865 120.941 74.609 121.571 75.9696C121.788 76.4379 121.621 76.9936 121.174 77.2515C120.677 77.5385 120.031 77.3507 119.789 76.8317C119.032 75.21 118.609 73.3951 118.609 71.4744C118.609 64.5213 124.172 58.973 131.142 58.973C132.125 58.973 133.108 59.0787 134.014 59.2751L129.767 55.0572C129.57 54.8263 129.479 54.5609 129.496 54.2598C129.527 53.702 129.973 53.3006 130.532 53.3362Z\" fill=\"#1AAAAD\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_201_374\">\n<rect width=\"192\" height=\"98\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var LinealDireccionError = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_201_364)\">\n<path opacity=\"0.6\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M29.2426 44.9247C29.5346 44.9247 29.7879 45.0338 30.0072 45.2519C30.2241 45.47 30.3343 45.72 30.3343 46.0017C30.3343 46.2925 30.2196 46.5516 29.9924 46.7788L28.3031 48.4692L29.8561 49.9961C30.0833 50.2233 30.198 50.4823 30.198 50.7731C30.198 51.064 30.0901 51.3185 29.8765 51.5366C29.6629 51.7547 29.4107 51.8638 29.1199 51.8638C28.8109 51.8638 28.5439 51.7365 28.3156 51.482L26.8569 49.9961L25.3845 51.482C25.1482 51.7274 24.8801 51.8501 24.5802 51.8501C24.2894 51.8501 24.0383 51.7433 23.8236 51.5298C23.6112 51.3162 23.5032 51.0685 23.5032 50.7868C23.5032 50.496 23.618 50.2324 23.8441 49.9961L25.3982 48.4692L23.7089 46.7788C23.4817 46.5516 23.3669 46.2925 23.3669 46.0017C23.3669 45.72 23.4771 45.47 23.6941 45.2519C23.9122 45.0338 24.1667 44.9247 24.4575 44.9247C24.7586 44.9247 25.0256 45.0474 25.2619 45.2928L26.8569 46.956L28.4383 45.2928C28.6757 45.0474 28.9427 44.9247 29.2426 44.9247ZM190.787 41.1411C191.078 41.1411 191.328 41.2502 191.543 41.4683C191.756 41.6864 191.863 41.9409 191.863 42.2317C191.863 42.5226 191.749 42.7816 191.521 43.0088L189.968 44.5357L191.658 46.2261C191.884 46.4533 192 46.7123 192 47.0032C192 47.2849 191.889 47.5348 191.672 47.753C191.455 47.9711 191.199 48.0801 190.908 48.0801C190.609 48.0801 190.34 47.9575 190.103 47.7121L188.523 46.0489L186.928 47.7121C186.69 47.9575 186.424 48.0801 186.122 48.0801C185.831 48.0801 185.579 47.9711 185.359 47.753C185.142 47.5348 185.033 47.2849 185.033 47.0032C185.033 46.7123 185.146 46.4533 185.375 46.2261L187.063 44.5357L185.51 43.0088C185.284 42.7725 185.168 42.5089 185.168 42.2181C185.168 41.9364 185.277 41.6887 185.491 41.4751C185.703 41.2615 185.956 41.1547 186.247 41.1547C186.546 41.1547 186.815 41.2774 187.05 41.5228L188.523 43.0088L189.981 41.5228C190.21 41.2684 190.476 41.1411 190.787 41.1411ZM164.138 36.7245C164.428 36.7245 164.678 36.8336 164.894 37.0517C165.107 37.2698 165.213 37.5243 165.213 37.8151C165.213 38.1059 165.1 38.365 164.872 38.5922L163.319 40.119L165.009 41.8095C165.235 42.0367 165.351 42.2957 165.351 42.5865C165.351 42.8683 165.24 43.1182 165.023 43.3363C164.806 43.5545 164.55 43.6635 164.259 43.6635C163.959 43.6635 163.691 43.5408 163.454 43.2954L161.873 41.6323L160.278 43.2954C160.041 43.5408 159.775 43.6635 159.473 43.6635C159.182 43.6635 158.93 43.5545 158.71 43.3363C158.493 43.1182 158.383 42.8683 158.383 42.5865C158.383 42.2957 158.497 42.0367 158.725 41.8095L160.414 40.119L158.861 38.5922C158.635 38.3559 158.519 38.0923 158.519 37.8015C158.519 37.5197 158.628 37.2721 158.841 37.0585C159.054 36.8449 159.307 36.7381 159.598 36.7381C159.897 36.7381 160.166 36.8608 160.401 37.1062L161.873 38.5922L163.332 37.1062C163.561 36.8517 163.826 36.7245 164.138 36.7245ZM5.58418 32.622C5.87615 32.622 6.12949 32.731 6.34875 32.9492C6.56573 33.1673 6.67593 33.4172 6.67593 33.699C6.67593 33.9898 6.56119 34.2488 6.33398 34.476L4.64466 36.1665L6.19765 37.6933C6.42486 37.9205 6.5396 38.1796 6.5396 38.4704C6.5396 38.7612 6.43168 39.0157 6.2181 39.2338C6.00452 39.4519 5.75232 39.561 5.46149 39.561C5.15248 39.561 4.88551 39.4338 4.65716 39.1793L3.19846 37.6933L1.72613 39.1793C1.48983 39.4247 1.22172 39.5474 0.921805 39.5474C0.630974 39.5474 0.379906 39.4406 0.165191 39.227C-0.0472517 39.0134 -0.155177 38.7658 -0.155177 38.484C-0.155177 38.1932 -0.0404354 37.9296 0.18564 37.6933L1.73977 36.1665L0.0504491 34.476C-0.176762 34.2488 -0.291504 33.9898 -0.291504 33.699C-0.291504 33.4172 -0.181306 33.1673 0.0356803 32.9492C0.253803 32.731 0.50828 32.622 0.79911 32.622C1.10017 32.622 1.36714 32.7447 1.60344 32.9901L3.19846 34.6532L4.77985 32.9901C5.01729 32.7447 5.28426 32.622 5.58418 32.622ZM40.4909 25.6829C40.7817 25.6829 41.0328 25.792 41.2475 26.0101C41.46 26.2282 41.5679 26.4827 41.5679 26.7736C41.5679 27.0644 41.4531 27.3234 41.2259 27.5506L39.6729 29.0775L41.3623 30.7679C41.5895 30.9951 41.7042 31.2542 41.7042 31.545C41.7042 31.8267 41.594 32.0767 41.377 32.2948C41.1589 32.5129 40.9044 32.622 40.6125 32.622C40.3125 32.622 40.0456 32.4993 39.8081 32.2539L38.2267 30.5907L36.6317 32.2539C36.3954 32.4993 36.1284 32.622 35.8274 32.622C35.5366 32.622 35.2832 32.5129 35.064 32.2948C34.847 32.0767 34.7368 31.8267 34.7368 31.545C34.7368 31.2542 34.8515 30.9951 35.0787 30.7679L36.768 29.0775L35.2139 27.5506C34.9878 27.3143 34.8731 27.0507 34.8731 26.7599C34.8731 26.4782 34.981 26.2305 35.1946 26.0169C35.4082 25.8034 35.6604 25.6966 35.9512 25.6966C36.25 25.6966 36.5192 25.8193 36.7555 26.0647L38.2267 27.5506L39.6866 26.0647C39.9138 25.8102 40.1808 25.6829 40.4909 25.6829ZM179.91 20.9522C180.201 20.9522 180.452 21.0613 180.667 21.2794C180.879 21.4975 180.987 21.752 180.987 22.0428C180.987 22.3337 180.872 22.5927 180.645 22.8199L179.092 24.3468L180.781 26.0372C181.008 26.2644 181.123 26.5234 181.123 26.8143C181.123 27.096 181.013 27.3459 180.796 27.5641C180.578 27.7822 180.323 27.8912 180.031 27.8912C179.732 27.8912 179.465 27.7686 179.227 27.5232L177.646 25.86L176.051 27.5232C175.814 27.7686 175.547 27.8912 175.246 27.8912C174.956 27.8912 174.702 27.7822 174.483 27.5641C174.266 27.3459 174.156 27.096 174.156 26.8143C174.156 26.5234 174.271 26.2644 174.498 26.0372L176.187 24.3468L174.633 22.8199C174.407 22.5836 174.292 22.32 174.292 22.0292C174.292 21.7475 174.4 21.4998 174.614 21.2862C174.827 21.0726 175.079 20.9658 175.37 20.9658C175.669 20.9658 175.938 21.0885 176.175 21.3339L177.646 22.8199L179.106 21.3339C179.333 21.0795 179.6 20.9522 179.91 20.9522ZM154.84 13.021C155.131 13.021 155.382 13.1301 155.597 13.3482C155.809 13.5663 155.917 13.8208 155.917 14.1116C155.917 14.4024 155.802 14.6615 155.575 14.8887L154.022 16.4155L155.711 18.106C155.938 18.3332 156.053 18.5922 156.053 18.883C156.053 19.1648 155.943 19.4147 155.726 19.6328C155.508 19.851 155.253 19.96 154.961 19.96C154.662 19.96 154.395 19.8373 154.157 19.5919L152.576 17.9288L150.981 19.5919C150.744 19.8373 150.477 19.96 150.176 19.96C149.886 19.96 149.632 19.851 149.413 19.6328C149.196 19.4147 149.086 19.1648 149.086 18.883C149.086 18.5922 149.201 18.3332 149.428 18.106L151.117 16.4155L149.563 14.8887C149.337 14.6524 149.222 14.3888 149.222 14.098C149.222 13.8162 149.33 13.5686 149.544 13.355C149.757 13.1414 150.009 13.0346 150.3 13.0346C150.599 13.0346 150.868 13.1573 151.105 13.4027L152.576 14.8887L154.036 13.4027C154.263 13.1482 154.53 13.021 154.84 13.021ZM22.9022 13.021C23.1941 13.021 23.4475 13.1301 23.6667 13.3482C23.8837 13.5663 23.9939 13.8162 23.9939 14.098C23.9939 14.3888 23.8792 14.6478 23.652 14.875L21.9627 16.5655L23.5156 18.0924C23.7429 18.3196 23.8576 18.5786 23.8576 18.8694C23.8576 19.1602 23.7497 19.4147 23.5361 19.6328C23.3225 19.851 23.0703 19.96 22.7795 19.96C22.4705 19.96 22.2035 19.8328 21.9752 19.5783L20.5165 18.0924L19.0441 19.5783C18.8078 19.8237 18.5397 19.9464 18.2398 19.9464C17.949 19.9464 17.6979 19.8396 17.4832 19.626C17.2707 19.4125 17.1628 19.1648 17.1628 18.883C17.1628 18.5922 17.2776 18.3287 17.5036 18.0924L19.0578 16.5655L17.3684 14.875C17.1412 14.6478 17.0265 14.3888 17.0265 14.098C17.0265 13.8162 17.1367 13.5663 17.3537 13.3482C17.5718 13.1301 17.8263 13.021 18.1171 13.021C18.4182 13.021 18.6851 13.1437 18.9214 13.3891L20.5165 15.0523L22.0978 13.3891C22.3353 13.1437 22.6023 13.021 22.9022 13.021Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M124.909 6.43506V10.8404H128.662C130.555 10.8404 132.089 12.3745 132.089 14.2668V42.1674H129.152V64.6837L82.8018 64.6851C83.8196 64.0075 84.5647 62.9652 84.8376 61.7472L93.4058 61.7468L93.4185 42.1674H67.4768V50.7589C66.3774 50.7589 65.36 51.113 64.5396 51.7122L64.5399 42.1674H61.603V14.2668C61.603 12.3745 63.1371 10.8404 65.0294 10.8404H117.078V6.43506H124.909ZM111.041 25.9514L96.3554 42.1664L96.3427 61.7468H104.188V45.5938H116.915V61.7468H125.725V42.1664L111.041 25.9514ZM113.978 48.5307H107.125V61.7468H113.978V48.5307ZM128.662 13.7773H65.0294C64.7591 13.7773 64.5399 13.9965 64.5399 14.2668V39.2305H95.1109L111.041 21.439L127.274 39.2305H129.152V14.2668C129.152 13.9965 128.933 13.7773 128.662 13.7773ZM93.4195 20.1406V30.9093H84.6088V20.1406H93.4195ZM79.714 20.1406V30.9093H70.9032V20.1406H79.714ZM90.4826 23.0775H87.5457V27.9724H90.4826V23.0775ZM76.777 23.0775H73.8401V27.9724H76.777V23.0775Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M83.2157 57.1321C84.4778 58.0046 85.2943 59.4425 85.2943 61.0561C85.2943 63.7176 83.0866 65.8585 80.3831 65.8585H66.0249C63.3215 65.8585 61.1138 63.7176 61.1138 61.0561C61.1138 59.3657 62.0098 57.8681 63.3757 57.0112C63.0728 56.3828 62.9085 55.6868 62.9085 54.9647C62.9085 52.3032 65.1163 50.1623 67.8197 50.1623C68.147 50.1623 68.4702 50.1939 68.7853 50.2554C69.586 48.6436 71.2775 47.5518 73.204 47.5518C75.1305 47.5518 76.8219 48.6435 77.6232 50.2553C77.9381 50.1938 78.2611 50.1623 78.5884 50.1623C81.2918 50.1623 83.4995 52.3032 83.4995 54.9647C83.4995 55.5966 83.3738 56.2084 83.1394 56.7726L83.0324 57.0114L83.2157 57.1321ZM66.0249 63.2153H80.3831C81.6446 63.2153 82.6511 62.2393 82.6511 61.0561C82.6511 59.9932 81.8338 59.0816 80.728 58.922L77.7769 58.4962L80.0744 56.5956C80.5702 56.1855 80.8563 55.5971 80.8563 54.9647C80.8563 53.7815 79.8499 52.8056 78.5884 52.8056C78.1709 52.8056 77.7739 52.912 77.4279 53.1101L75.6879 54.1064L75.4583 52.1145C75.3339 51.0357 74.3709 50.195 73.204 50.195C72.0373 50.195 71.0746 51.0355 70.951 52.1134L70.7228 54.1039L68.9828 53.1107C68.6348 52.9121 68.2372 52.8056 67.8197 52.8056C66.5582 52.8056 65.5518 53.7815 65.5518 54.9647C65.5518 55.5971 65.8379 56.1853 66.3333 56.595L68.6314 58.495L65.6803 58.9215C64.5743 59.0814 63.757 59.9932 63.757 61.0561C63.757 62.2393 64.7634 63.2153 66.0249 63.2153Z\" fill=\"#B6C5D5\"/>\n<path d=\"M129.5 92C141.374 92 151 82.3741 151 70.5C151 58.6259 141.374 49 129.5 49C117.626 49 108 58.6259 108 70.5C108 82.3741 117.626 92 129.5 92Z\" fill=\"white\"/>\n<path d=\"M129.58 90.7161C140.636 90.7161 149.744 81.5852 149.744 70.5297C149.744 59.4966 140.613 50.3657 129.58 50.3657C118.525 50.3657 109.416 59.4966 109.416 70.5297C109.416 81.5852 118.547 90.7161 129.58 90.7161ZM122.329 79.26C121.505 79.26 120.871 78.6043 120.871 77.802C120.871 77.3991 121.02 77.0411 121.294 76.7871L127.509 70.551L121.294 64.316C121.02 64.062 120.871 63.7028 120.871 63.3011C120.871 62.4776 121.505 61.8644 122.33 61.8644C122.732 61.8644 123.07 62.0121 123.345 62.2873L129.58 68.501L135.836 62.2873C136.133 61.9695 136.471 61.8218 136.851 61.8218C137.655 61.8218 138.309 62.4776 138.309 63.2799C138.309 63.6827 138.183 63.9994 137.866 64.2948L131.63 70.551L137.866 76.7445C138.14 77.0411 138.289 77.379 138.289 77.802C138.289 78.6043 137.655 79.26 136.83 79.26C136.407 79.26 136.048 79.091 135.774 78.8158L129.58 72.6021L123.365 78.8158C123.112 79.091 122.732 79.26 122.33 79.26H122.329Z\" fill=\"#DD2457\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_201_364\">\n<rect width=\"192\" height=\"98\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var LinealDNIDorso = "<svg width=\"144\" height=\"56\" viewBox=\"0 0 144 56\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path opacity=\"0.6\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M37.3868 32.9046C37.5368 32.9046 37.6648 32.9657 37.7758 33.0909L38.4818 33.8169L39.1938 33.0909C39.243 33.0349 39.303 32.9899 39.3702 32.9589C39.4373 32.9279 39.5101 32.9115 39.5838 32.9107C39.7238 32.9107 39.8458 32.9626 39.9498 33.0675C39.9986 33.114 40.0375 33.1701 40.0641 33.2324C40.0908 33.2948 40.1046 33.362 40.1048 33.43C40.1048 33.5725 40.0488 33.7008 39.9398 33.8169L39.1878 34.5622L40.0048 35.3879C40.1148 35.4999 40.1708 35.6252 40.1708 35.7677C40.1705 35.8366 40.1563 35.9046 40.1291 35.9677C40.1019 36.0307 40.0624 36.0874 40.0128 36.1343C39.9651 36.1851 39.9076 36.2255 39.844 36.253C39.7804 36.2804 39.7119 36.2944 39.6428 36.2941C39.5691 36.2934 39.4963 36.277 39.4291 36.246C39.362 36.215 39.3019 36.17 39.2528 36.1139L38.4818 35.3014L37.7168 36.1139C37.6677 36.1699 37.6077 36.2149 37.5405 36.2459C37.4734 36.2769 37.4006 36.2934 37.3268 36.2941C37.2577 36.2944 37.1893 36.2804 37.1257 36.2529C37.0621 36.2254 37.0047 36.185 36.9568 36.1343C36.9062 36.0865 36.8659 36.0285 36.8385 35.964C36.8112 35.8995 36.7974 35.8298 36.798 35.7595C36.7987 35.6892 36.8138 35.6199 36.8423 35.5559C36.8709 35.4919 36.9123 35.4347 36.9638 35.3879L37.7818 34.5632L37.0298 33.8169C36.9784 33.7694 36.9372 33.7116 36.9087 33.6472C36.8801 33.5828 36.8649 33.513 36.864 33.4424C36.863 33.3717 36.8764 33.3016 36.9032 33.2364C36.93 33.1712 36.9697 33.1123 37.0198 33.0634C37.067 33.0126 37.1239 32.9723 37.187 32.945C37.2502 32.9176 37.3182 32.9039 37.3868 32.9046ZM26.6848 29.7839C26.8348 29.7839 26.9638 29.845 27.0748 29.9702L27.7798 30.6962L28.4928 29.9702C28.5418 29.9143 28.6017 29.8694 28.6687 29.8384C28.7357 29.8074 28.8083 29.7909 28.8818 29.79C29.0218 29.79 29.1438 29.8419 29.2478 29.9468C29.2966 29.9933 29.3355 30.0494 29.3621 30.1117C29.3888 30.174 29.4026 30.2413 29.4028 30.3092C29.4028 30.4518 29.3478 30.5801 29.2378 30.6962L28.4858 31.4415L29.3038 32.2672C29.3554 32.314 29.3968 32.3712 29.4253 32.4352C29.4539 32.4991 29.469 32.5685 29.4696 32.6388C29.4703 32.7091 29.4565 32.7787 29.4292 32.8433C29.4018 32.9078 29.3615 32.9658 29.3108 33.0135C29.2631 33.0644 29.2056 33.1047 29.142 33.1322C29.0784 33.1597 29.0099 33.1737 28.9408 33.1734C28.8673 33.1726 28.7946 33.1561 28.7277 33.1251C28.6607 33.094 28.6008 33.0491 28.5518 32.9932L27.7798 32.1807L27.0148 32.9932C26.9657 33.0492 26.9057 33.0942 26.8385 33.1252C26.7714 33.1562 26.6986 33.1726 26.6248 33.1734C26.5557 33.1737 26.4873 33.1596 26.4237 33.1321C26.3601 33.1047 26.3027 33.0643 26.2548 33.0135C26.2042 32.9657 26.164 32.9077 26.1367 32.8431C26.1095 32.7785 26.0958 32.7089 26.0965 32.6386C26.0973 32.5683 26.1125 32.4989 26.1411 32.435C26.1698 32.371 26.2112 32.3139 26.2628 32.2672L27.0798 31.4425L26.3288 30.6962C26.2774 30.6487 26.2362 30.5909 26.2077 30.5265C26.1791 30.462 26.1639 30.3923 26.163 30.3216C26.162 30.251 26.1754 30.1809 26.2022 30.1157C26.229 30.0505 26.2687 29.9916 26.3188 29.9427C26.3658 29.892 26.4226 29.8518 26.4856 29.8245C26.5486 29.7971 26.6164 29.7833 26.6848 29.7839ZM111.445 28.2403C111.514 28.24 111.582 28.2541 111.646 28.2816C111.71 28.309 111.767 28.3494 111.815 28.4002C111.866 28.448 111.906 28.506 111.933 28.5707C111.96 28.6353 111.974 28.705 111.973 28.7754C111.972 28.8457 111.957 28.9151 111.928 28.979C111.899 29.0429 111.858 29.1 111.806 29.1465L110.989 29.9712L111.741 30.7175C111.851 30.8336 111.906 30.9619 111.906 31.1044C111.906 31.1725 111.892 31.2398 111.865 31.3022C111.838 31.3645 111.799 31.4206 111.75 31.4669C111.703 31.517 111.646 31.5568 111.583 31.5837C111.52 31.6107 111.452 31.6243 111.384 31.6237C111.31 31.6229 111.238 31.6064 111.171 31.5754C111.104 31.5444 111.044 31.4994 110.995 31.4435L110.283 30.7175L109.577 31.4435C109.531 31.4992 109.474 31.5445 109.41 31.5764C109.346 31.6083 109.276 31.6261 109.205 31.6286C109.133 31.6311 109.062 31.6182 108.996 31.5909C108.93 31.5636 108.87 31.5224 108.821 31.47C108.771 31.421 108.732 31.3622 108.705 31.2971C108.678 31.232 108.665 31.1621 108.666 31.0916C108.667 31.0211 108.682 30.9515 108.71 30.8872C108.739 30.8228 108.78 30.7651 108.831 30.7175L109.583 29.9722L108.765 29.1465C108.713 29.098 108.672 29.0393 108.644 28.974C108.615 28.9087 108.6 28.8381 108.6 28.7667C108.6 28.6292 108.654 28.5071 108.759 28.4002C108.807 28.3493 108.864 28.3089 108.928 28.2814C108.991 28.2539 109.06 28.2399 109.129 28.2403C109.273 28.2403 109.403 28.3014 109.519 28.4205L110.283 29.233L111.055 28.4205C111.104 28.3645 111.164 28.3195 111.231 28.2885C111.298 28.2575 111.371 28.2411 111.445 28.2403ZM126.473 25.1104C126.542 25.1102 126.61 25.1242 126.674 25.1517C126.738 25.1791 126.795 25.2195 126.843 25.2703C126.894 25.318 126.934 25.376 126.961 25.4406C126.989 25.5052 127.002 25.5749 127.002 25.6452C127.001 25.7156 126.986 25.785 126.957 25.8489C126.928 25.9129 126.887 25.97 126.835 26.0166L126.017 26.8413L126.769 27.5876C126.879 27.7037 126.935 27.832 126.935 27.9746C126.934 28.0427 126.92 28.1101 126.893 28.1724C126.866 28.2348 126.827 28.2908 126.778 28.337C126.731 28.3871 126.674 28.4269 126.611 28.4538C126.548 28.4808 126.48 28.4944 126.412 28.4938C126.338 28.4929 126.266 28.4763 126.199 28.4453C126.132 28.4143 126.073 28.3694 126.024 28.3136L125.311 27.5876L124.605 28.3136C124.559 28.3694 124.502 28.4146 124.438 28.4465C124.374 28.4784 124.304 28.4962 124.233 28.4987C124.161 28.5012 124.09 28.4883 124.024 28.461C123.958 28.4337 123.898 28.3925 123.849 28.3401C123.799 28.2911 123.76 28.2322 123.733 28.167C123.707 28.1019 123.693 28.0319 123.694 27.9614C123.696 27.8909 123.711 27.8214 123.739 27.7571C123.768 27.6928 123.809 27.6352 123.86 27.5876L124.612 26.8423L123.793 26.0166C123.741 25.9681 123.7 25.9094 123.672 25.8441C123.643 25.7788 123.628 25.7082 123.628 25.6368C123.628 25.4994 123.682 25.3772 123.787 25.2703C123.835 25.2194 123.892 25.179 123.956 25.1515C124.019 25.124 124.088 25.11 124.157 25.1104C124.301 25.1104 124.431 25.1705 124.547 25.2906L125.311 26.1031L126.083 25.2906C126.132 25.2346 126.192 25.1897 126.259 25.1586C126.326 25.1276 126.399 25.1112 126.473 25.1104ZM17.5878 22.8277C17.7378 22.8277 17.8668 22.8887 17.9768 23.014L18.6828 23.7399L19.3958 23.014C19.4448 22.9581 19.5047 22.9132 19.5717 22.8822C19.6387 22.8511 19.7113 22.8347 19.7848 22.8338C19.9248 22.8338 20.0468 22.8867 20.1508 22.9906C20.1996 23.037 20.2384 23.0932 20.2651 23.1555C20.2918 23.2178 20.3056 23.285 20.3058 23.353C20.3058 23.4956 20.2508 23.6239 20.1408 23.7399L19.3888 24.4853L20.2068 25.311C20.2584 25.3577 20.2998 25.4149 20.3283 25.4789C20.3569 25.5429 20.372 25.6123 20.3726 25.6826C20.3733 25.7529 20.3595 25.8225 20.3322 25.887C20.3048 25.9516 20.2645 26.0096 20.2138 26.0573C20.1661 26.1081 20.1086 26.1485 20.045 26.176C19.9814 26.2035 19.9129 26.2175 19.8438 26.2172C19.7701 26.2165 19.6973 26.2001 19.6301 26.1691C19.563 26.138 19.5029 26.093 19.4538 26.037L18.6828 25.2245L17.9178 26.037C17.8687 26.093 17.8087 26.1379 17.7415 26.169C17.6744 26.2 17.6016 26.2164 17.5278 26.2172C17.4587 26.2174 17.3903 26.2034 17.3267 26.1759C17.2631 26.1484 17.2057 26.1081 17.1578 26.0573C17.1072 26.0096 17.0669 25.9516 17.0395 25.887C17.0122 25.8225 16.9984 25.7529 16.999 25.6826C16.9997 25.6123 17.0148 25.5429 17.0433 25.4789C17.0719 25.4149 17.1133 25.3577 17.1648 25.311L17.9828 24.4863L17.2308 23.7399C17.1794 23.6924 17.1382 23.6347 17.1097 23.5702C17.0811 23.5058 17.0659 23.4361 17.065 23.3654C17.064 23.2948 17.0774 23.2246 17.1042 23.1595C17.131 23.0943 17.1707 23.0354 17.2208 22.9865C17.268 22.9357 17.3249 22.8954 17.388 22.868C17.4512 22.8407 17.5192 22.827 17.5878 22.8277ZM37.9728 20.1447C38.0419 20.1445 38.1104 20.1585 38.174 20.186C38.2376 20.2135 38.295 20.2538 38.3428 20.3046C38.3933 20.3523 38.4335 20.4103 38.4608 20.4747C38.488 20.5391 38.5017 20.6087 38.5011 20.6788C38.5004 20.749 38.4854 20.8182 38.4569 20.8821C38.4285 20.946 38.3872 21.0032 38.3358 21.0499L37.5178 21.8757L38.2698 22.622C38.3798 22.737 38.4348 22.8663 38.4348 23.0079C38.4347 23.0759 38.4209 23.1431 38.3943 23.2055C38.3676 23.2678 38.3287 23.3239 38.2798 23.3703C38.2324 23.4205 38.1753 23.4603 38.1122 23.4873C38.0491 23.5142 37.9813 23.5278 37.9128 23.5271C37.8393 23.5264 37.7668 23.51 37.6998 23.4792C37.6329 23.4483 37.5729 23.4036 37.5238 23.3479L36.8118 22.622L36.1058 23.3479C36.0601 23.4038 36.0034 23.4492 35.9392 23.4812C35.8751 23.5132 35.805 23.531 35.7337 23.5335C35.6623 23.536 35.5912 23.5231 35.5251 23.4957C35.4589 23.4683 35.3992 23.427 35.3498 23.3744C35.2999 23.3254 35.2603 23.2665 35.2335 23.2014C35.2068 23.1362 35.1935 23.0661 35.1944 22.9955C35.1954 22.9249 35.2105 22.8552 35.239 22.7908C35.2674 22.7263 35.3086 22.6685 35.3598 22.621L36.1118 21.8757L35.2948 21.0509C35.2433 21.0042 35.2019 20.947 35.1733 20.883C35.1448 20.819 35.1297 20.7496 35.129 20.6793C35.1284 20.6091 35.1422 20.5394 35.1695 20.4749C35.1969 20.4103 35.2372 20.3523 35.2878 20.3046C35.3356 20.2538 35.3931 20.2134 35.4567 20.1859C35.5203 20.1584 35.5887 20.1444 35.6578 20.1447C35.7313 20.1455 35.8039 20.1618 35.8708 20.1927C35.9378 20.2235 35.9977 20.2682 36.0468 20.3239L36.8118 21.1365L37.5838 20.3239C37.633 20.2681 37.6931 20.2233 37.7602 20.1924C37.8274 20.1615 37.9002 20.1453 37.9738 20.1447H37.9728ZM118.123 17.8885C118.192 17.8882 118.26 17.9022 118.324 17.9297C118.388 17.9572 118.445 17.9975 118.493 18.0483C118.543 18.096 118.584 18.154 118.611 18.2184C118.638 18.2829 118.652 18.3524 118.651 18.4225C118.65 18.4927 118.635 18.5619 118.607 18.6258C118.578 18.6897 118.537 18.7469 118.486 18.7936L117.668 19.6204L118.42 20.3657C118.53 20.4807 118.585 20.6101 118.585 20.7526C118.585 20.8207 118.571 20.888 118.544 20.9503C118.517 21.0127 118.478 21.0688 118.429 21.1151C118.381 21.1651 118.325 21.2048 118.262 21.2318C118.199 21.2588 118.131 21.2724 118.063 21.2719C117.989 21.271 117.917 21.2545 117.85 21.2235C117.783 21.1924 117.723 21.1475 117.674 21.0917L116.962 20.3657L116.255 21.0917C116.209 21.1474 116.152 21.1926 116.088 21.2245C116.024 21.2564 115.954 21.2742 115.883 21.2767C115.812 21.2792 115.741 21.2663 115.675 21.239C115.609 21.2117 115.549 21.1705 115.5 21.1181C115.45 21.0692 115.411 21.0103 115.384 20.9452C115.357 20.8802 115.344 20.8102 115.345 20.7397C115.346 20.6692 115.361 20.5996 115.389 20.5353C115.418 20.471 115.459 20.4133 115.51 20.3657L116.262 19.6204L115.445 18.7936C115.393 18.7469 115.352 18.6897 115.323 18.6257C115.295 18.5617 115.28 18.4923 115.279 18.422C115.278 18.3517 115.292 18.2821 115.32 18.2176C115.347 18.153 115.387 18.095 115.438 18.0473C115.486 17.9967 115.543 17.9565 115.607 17.9292C115.67 17.9018 115.739 17.888 115.808 17.8885C115.881 17.8894 115.954 17.9058 116.021 17.9369C116.088 17.9679 116.148 18.0128 116.197 18.0687L116.962 18.8812L117.734 18.0687C117.783 18.0126 117.843 17.9676 117.91 17.9366C117.977 17.9055 118.05 17.8891 118.124 17.8885H118.123ZM24.9998 14.3523C25.1498 14.3523 25.2788 14.4134 25.3888 14.5386L26.0948 15.2646L26.8078 14.5386C26.8568 14.4827 26.9167 14.4379 26.9837 14.4068C27.0507 14.3758 27.1233 14.3593 27.1968 14.3584C27.3368 14.3584 27.4588 14.4114 27.5628 14.5152C27.6117 14.5618 27.6506 14.6181 27.6773 14.6806C27.704 14.7431 27.7178 14.8106 27.7178 14.8787C27.7178 15.0213 27.6628 15.1495 27.5528 15.2646L26.8008 16.0099L27.6188 16.8357C27.6704 16.8824 27.7118 16.9396 27.7403 17.0036C27.7689 17.0676 27.784 17.137 27.7846 17.2072C27.7853 17.2775 27.7715 17.3472 27.7442 17.4117C27.7168 17.4762 27.6765 17.5342 27.6258 17.582C27.5781 17.6328 27.5206 17.6732 27.457 17.7007C27.3934 17.7281 27.3249 17.7422 27.2558 17.7418C27.1821 17.7411 27.1093 17.7247 27.0421 17.6937C26.975 17.6627 26.9149 17.6177 26.8658 17.5616L26.0948 16.7491L25.3298 17.5616C25.2807 17.6176 25.2207 17.6626 25.1535 17.6936C25.0864 17.7247 25.0136 17.7411 24.9398 17.7418C24.8707 17.7421 24.8023 17.7281 24.7387 17.7006C24.6751 17.6731 24.6177 17.6328 24.5698 17.582C24.5192 17.5342 24.479 17.4761 24.4517 17.4115C24.4245 17.347 24.4108 17.2773 24.4115 17.207C24.4123 17.1367 24.4275 17.0674 24.4561 17.0034C24.4848 16.9395 24.5262 16.8823 24.5778 16.8357L25.3948 16.0109L24.6428 15.2646C24.5914 15.2171 24.5502 15.1593 24.5217 15.0949C24.4931 15.0305 24.4779 14.9608 24.477 14.8901C24.476 14.8194 24.4894 14.7493 24.5162 14.6841C24.543 14.6189 24.5827 14.56 24.6328 14.5111C24.68 14.4603 24.7369 14.42 24.8 14.3927C24.8632 14.3654 24.9312 14.3516 24.9998 14.3523ZM109.298 11.5869C109.367 11.5865 109.435 11.6004 109.499 11.6277C109.562 11.655 109.62 11.6952 109.668 11.7458C109.719 11.7935 109.759 11.8515 109.786 11.916C109.813 11.9806 109.827 12.0502 109.827 12.1205C109.826 12.1908 109.811 12.2602 109.782 12.3241C109.754 12.3881 109.712 12.4453 109.661 12.4921L108.843 13.3178L109.595 14.0642C109.705 14.1792 109.76 14.3085 109.76 14.4501C109.76 14.5181 109.746 14.5854 109.719 14.6478C109.692 14.7101 109.653 14.7662 109.604 14.8125C109.556 14.8626 109.5 14.9023 109.437 14.9293C109.374 14.9562 109.306 14.9698 109.238 14.9693C109.164 14.9686 109.092 14.9522 109.025 14.9214C108.958 14.8905 108.898 14.8458 108.849 14.7901L108.137 14.0642L107.43 14.7901C107.384 14.8458 107.327 14.8911 107.263 14.923C107.199 14.9549 107.129 14.9726 107.058 14.9751C106.987 14.9776 106.916 14.9648 106.85 14.9375C106.784 14.9102 106.724 14.869 106.675 14.8166C106.625 14.7676 106.585 14.7087 106.559 14.6435C106.532 14.5784 106.519 14.5083 106.519 14.4377C106.52 14.367 106.536 14.2974 106.564 14.2329C106.592 14.1685 106.634 14.1107 106.685 14.0631L107.437 13.3178L106.619 12.4921C106.567 12.4453 106.526 12.3881 106.497 12.3241C106.469 12.2602 106.454 12.1908 106.453 12.1205C106.452 12.0502 106.466 11.9806 106.494 11.916C106.521 11.8515 106.561 11.7935 106.612 11.7458C106.66 11.6951 106.717 11.6549 106.781 11.6276C106.844 11.6003 106.913 11.5865 106.982 11.5869C107.056 11.5876 107.128 11.6038 107.195 11.6347C107.263 11.6655 107.323 11.7103 107.372 11.7661L108.137 12.5786L108.909 11.7661C108.958 11.7102 109.018 11.6654 109.085 11.6346C109.152 11.6037 109.225 11.5875 109.299 11.5869H109.298Z\" fill=\"#B6C5D5\"/>\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M101.735 14.0358V44.8541C101.735 46.9821 100.026 48.7069 97.9184 48.7069H52.1184C51.2583 48.7095 50.4225 48.4158 49.7471 47.8734C49.0717 47.331 48.5964 46.5719 48.3984 45.7196C48.6744 45.7837 48.9614 45.8173 49.2564 45.8173H95.0564C97.1644 45.8173 98.8724 44.0925 98.8724 41.9645V11.1462C98.8724 10.8489 98.8394 10.5597 98.7764 10.2808C100.471 10.6728 101.735 12.2051 101.735 14.0358Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M95.0565 7.29346C97.1645 7.29346 98.8725 9.01826 98.8725 11.1463V41.9646C98.8725 44.0926 97.1645 45.8174 95.0565 45.8174H49.2565C47.1485 45.8174 45.4395 44.0926 45.4395 41.9646V11.1463C45.4395 9.01826 47.1485 7.29346 49.2565 7.29346H95.0565ZM95.0565 9.21986H49.2565C48.7688 9.21782 48.299 9.40671 47.9442 9.74745C47.5894 10.0882 47.3769 10.5547 47.3505 11.0505L47.3485 11.1463V41.9646C47.3505 42.4609 47.5398 42.9375 47.8773 43.2956C48.2147 43.6538 48.6745 43.8662 49.1615 43.889L49.2565 43.891H95.0565C95.544 43.893 96.0136 43.7043 96.3684 43.3638C96.7231 43.0232 96.9358 42.557 96.9625 42.0613L96.9645 41.9646V11.1463C96.9624 10.6499 96.7731 10.1734 96.4356 9.81521C96.0982 9.45703 95.6384 9.24462 95.1515 9.22189L95.0565 9.21986ZM88.4215 16.4622C89.0215 16.4622 89.4305 16.8155 89.4305 17.4009C89.4311 17.5297 89.4177 17.6581 89.3905 17.7838L88.6305 21.5765H91.5405C92.1305 21.5765 92.4995 21.9919 92.4995 22.5448C92.4995 23.2423 92.0295 23.7259 91.3195 23.7259H88.2125L87.2535 28.5185H90.2205C90.8005 28.5185 91.1805 28.9217 91.1805 29.4756C91.1805 30.172 90.7105 30.6465 89.9905 30.6465H86.8315L85.9115 35.2375C85.7915 35.883 85.3745 36.2047 84.7435 36.2047C84.1535 36.2047 83.7535 35.8738 83.7535 35.2782C83.7535 35.1662 83.7745 35.0043 83.7935 34.8943L84.6435 30.6465H80.3155L79.4055 35.2375C79.2755 35.883 78.8555 36.2047 78.2355 36.2047C77.6355 36.2047 77.2365 35.8738 77.2365 35.2782C77.2365 35.1662 77.2565 35.0043 77.2765 34.8943L78.1265 30.6465H75.4465C74.8665 30.6465 74.4875 30.2728 74.4875 29.7077C74.4875 29.0031 74.9575 28.5185 75.6675 28.5185H78.5475L79.5055 23.7259H76.7775C76.1875 23.7259 75.8185 23.341 75.8185 22.7769C75.8185 22.0713 76.2775 21.5765 76.9965 21.5765H79.9265L80.7545 17.461C80.8745 16.8257 81.2255 16.4632 81.9045 16.4632C82.5045 16.4632 82.9145 16.8155 82.9145 17.3999C82.9145 17.5415 82.8945 17.7023 82.8745 17.7838L82.1245 21.5765H86.4545L87.2715 17.461C87.4015 16.8359 87.7325 16.4632 88.4215 16.4632V16.4622ZM63.0915 29.4165C63.3432 29.4157 63.585 29.5167 63.7637 29.6973C63.9424 29.8779 64.0434 30.1234 64.0445 30.3797C64.0435 30.6167 63.9571 30.8451 63.8017 31.0215C63.6463 31.1979 63.4327 31.3101 63.2015 31.3368L63.0915 31.3429H54.2775C54.1527 31.3434 54.0291 31.319 53.9136 31.2708C53.7981 31.2227 53.6931 31.1519 53.6045 31.0625C53.5159 30.973 53.4455 30.8667 53.3973 30.7496C53.3491 30.6324 53.324 30.5067 53.3235 30.3797C53.3244 30.1427 53.4108 29.9144 53.5662 29.7379C53.7216 29.5615 53.9352 29.4493 54.1665 29.4226L54.2765 29.4165H63.0905H63.0915ZM86.0225 23.7249H81.6945L80.7355 28.5185H85.0725L86.0225 23.7259V23.7249ZM67.3325 24.3735C67.5842 24.3724 67.8262 24.4731 68.005 24.6535C68.1839 24.8339 68.2851 25.0793 68.2865 25.3356C68.2855 25.5726 68.1991 25.801 68.0437 25.9774C67.8883 26.1538 67.6747 26.266 67.4435 26.2927L67.3325 26.2988H54.2775C54.1527 26.2994 54.0291 26.2749 53.9136 26.2268C53.7981 26.1787 53.6931 26.1079 53.6045 26.0184C53.5159 25.929 53.4455 25.8226 53.3973 25.7055C53.3491 25.5883 53.324 25.4627 53.3235 25.3356C53.3244 25.0987 53.4108 24.8703 53.5662 24.6939C53.7216 24.5174 53.9352 24.4052 54.1665 24.3785L54.2775 24.3735H67.3325ZM66.0715 19.3294C66.1962 19.3288 66.3198 19.3533 66.4353 19.4015C66.5508 19.4496 66.6558 19.5204 66.7444 19.6098C66.833 19.6993 66.9034 19.8056 66.9516 19.9227C66.9998 20.0399 67.0249 20.1656 67.0255 20.2926C67.0245 20.5296 66.9381 20.7579 66.7827 20.9344C66.6273 21.1108 66.4137 21.223 66.1825 21.2497L66.0715 21.2558H54.2775C54.1527 21.2563 54.0291 21.2318 53.9136 21.1837C53.7981 21.1356 53.6931 21.0648 53.6045 20.9754C53.5159 20.8859 53.4455 20.7796 53.3973 20.6624C53.3491 20.5453 53.324 20.4196 53.3235 20.2926C53.3244 20.0556 53.4108 19.8272 53.5662 19.6508C53.7216 19.4744 53.9352 19.3622 54.1665 19.3355L54.2765 19.3294H66.0715Z\" fill=\"#B6C5D5\"/>\n</svg>";

var LinealDNIFrente = "<svg width=\"144\" height=\"56\" viewBox=\"0 0 144 56\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path opacity=\"0.6\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M37.3868 32.9046C37.5368 32.9046 37.6648 32.9657 37.7758 33.0909L38.4818 33.8169L39.1938 33.0909C39.243 33.0349 39.303 32.9899 39.3702 32.9589C39.4373 32.9279 39.5101 32.9115 39.5838 32.9107C39.7238 32.9107 39.8458 32.9626 39.9498 33.0675C39.9986 33.114 40.0375 33.1701 40.0641 33.2324C40.0908 33.2948 40.1046 33.362 40.1048 33.43C40.1048 33.5725 40.0488 33.7008 39.9398 33.8169L39.1878 34.5622L40.0048 35.3879C40.1148 35.4999 40.1708 35.6252 40.1708 35.7677C40.1705 35.8366 40.1563 35.9046 40.1291 35.9677C40.1019 36.0307 40.0624 36.0874 40.0128 36.1343C39.9651 36.1851 39.9076 36.2255 39.844 36.253C39.7804 36.2804 39.7119 36.2944 39.6428 36.2941C39.5691 36.2934 39.4963 36.277 39.4291 36.246C39.362 36.215 39.3019 36.17 39.2528 36.1139L38.4818 35.3014L37.7168 36.1139C37.6677 36.1699 37.6077 36.2149 37.5405 36.2459C37.4734 36.2769 37.4006 36.2934 37.3268 36.2941C37.2577 36.2944 37.1893 36.2804 37.1257 36.2529C37.0621 36.2254 37.0047 36.185 36.9568 36.1343C36.9062 36.0865 36.8659 36.0285 36.8385 35.964C36.8112 35.8995 36.7974 35.8298 36.798 35.7595C36.7987 35.6892 36.8138 35.6199 36.8423 35.5559C36.8709 35.4919 36.9123 35.4347 36.9638 35.3879L37.7818 34.5632L37.0298 33.8169C36.9784 33.7694 36.9372 33.7116 36.9087 33.6472C36.8801 33.5828 36.8649 33.513 36.864 33.4424C36.863 33.3717 36.8764 33.3016 36.9032 33.2364C36.93 33.1712 36.9697 33.1123 37.0198 33.0634C37.067 33.0126 37.1239 32.9723 37.187 32.945C37.2502 32.9176 37.3182 32.9039 37.3868 32.9046ZM26.6848 29.7839C26.8348 29.7839 26.9638 29.845 27.0748 29.9702L27.7798 30.6962L28.4928 29.9702C28.5418 29.9143 28.6017 29.8694 28.6687 29.8384C28.7357 29.8074 28.8083 29.7909 28.8818 29.79C29.0218 29.79 29.1438 29.8419 29.2478 29.9468C29.2966 29.9933 29.3355 30.0494 29.3621 30.1117C29.3888 30.174 29.4026 30.2413 29.4028 30.3092C29.4028 30.4518 29.3478 30.5801 29.2378 30.6962L28.4858 31.4415L29.3038 32.2672C29.3554 32.314 29.3968 32.3712 29.4253 32.4352C29.4539 32.4991 29.469 32.5685 29.4696 32.6388C29.4703 32.7091 29.4565 32.7787 29.4292 32.8433C29.4018 32.9078 29.3615 32.9658 29.3108 33.0135C29.2631 33.0644 29.2056 33.1047 29.142 33.1322C29.0784 33.1597 29.0099 33.1737 28.9408 33.1734C28.8673 33.1726 28.7946 33.1561 28.7277 33.1251C28.6607 33.094 28.6008 33.0491 28.5518 32.9932L27.7798 32.1807L27.0148 32.9932C26.9657 33.0492 26.9057 33.0942 26.8385 33.1252C26.7714 33.1562 26.6986 33.1726 26.6248 33.1734C26.5557 33.1737 26.4873 33.1596 26.4237 33.1321C26.3601 33.1047 26.3027 33.0643 26.2548 33.0135C26.2042 32.9657 26.164 32.9077 26.1367 32.8431C26.1095 32.7785 26.0958 32.7089 26.0965 32.6386C26.0973 32.5683 26.1125 32.4989 26.1411 32.435C26.1698 32.371 26.2112 32.3139 26.2628 32.2672L27.0798 31.4425L26.3288 30.6962C26.2774 30.6487 26.2362 30.5909 26.2077 30.5265C26.1791 30.462 26.1639 30.3923 26.163 30.3216C26.162 30.251 26.1754 30.1809 26.2022 30.1157C26.229 30.0505 26.2687 29.9916 26.3188 29.9427C26.3658 29.892 26.4226 29.8518 26.4856 29.8245C26.5486 29.7971 26.6164 29.7833 26.6848 29.7839ZM111.445 28.2403C111.514 28.24 111.582 28.2541 111.646 28.2816C111.71 28.309 111.767 28.3494 111.815 28.4002C111.866 28.448 111.906 28.506 111.933 28.5707C111.96 28.6353 111.974 28.705 111.973 28.7754C111.972 28.8457 111.957 28.9151 111.928 28.979C111.899 29.0429 111.858 29.1 111.806 29.1465L110.989 29.9712L111.741 30.7175C111.851 30.8336 111.906 30.9619 111.906 31.1044C111.906 31.1725 111.892 31.2398 111.865 31.3022C111.838 31.3645 111.799 31.4206 111.75 31.4669C111.703 31.517 111.646 31.5568 111.583 31.5837C111.52 31.6107 111.452 31.6243 111.384 31.6237C111.31 31.6229 111.238 31.6064 111.171 31.5754C111.104 31.5444 111.044 31.4994 110.995 31.4435L110.283 30.7175L109.577 31.4435C109.531 31.4992 109.474 31.5445 109.41 31.5764C109.346 31.6083 109.276 31.6261 109.205 31.6286C109.133 31.6311 109.062 31.6182 108.996 31.5909C108.93 31.5636 108.87 31.5224 108.821 31.47C108.771 31.421 108.732 31.3622 108.705 31.2971C108.678 31.232 108.665 31.1621 108.666 31.0916C108.667 31.0211 108.682 30.9515 108.71 30.8872C108.739 30.8228 108.78 30.7651 108.831 30.7175L109.583 29.9722L108.765 29.1465C108.713 29.098 108.672 29.0393 108.644 28.974C108.615 28.9087 108.6 28.8381 108.6 28.7667C108.6 28.6292 108.654 28.5071 108.759 28.4002C108.807 28.3493 108.864 28.3089 108.928 28.2814C108.991 28.2539 109.06 28.2399 109.129 28.2403C109.273 28.2403 109.403 28.3014 109.519 28.4205L110.283 29.233L111.055 28.4205C111.104 28.3645 111.164 28.3195 111.231 28.2885C111.298 28.2575 111.371 28.2411 111.445 28.2403ZM126.473 25.1104C126.542 25.1102 126.61 25.1242 126.674 25.1517C126.738 25.1791 126.795 25.2195 126.843 25.2703C126.894 25.318 126.934 25.376 126.961 25.4406C126.989 25.5052 127.002 25.5749 127.002 25.6452C127.001 25.7156 126.986 25.785 126.957 25.8489C126.928 25.9129 126.887 25.97 126.835 26.0166L126.017 26.8413L126.769 27.5876C126.879 27.7037 126.935 27.832 126.935 27.9746C126.934 28.0427 126.92 28.1101 126.893 28.1724C126.866 28.2348 126.827 28.2908 126.778 28.337C126.731 28.3871 126.674 28.4269 126.611 28.4538C126.548 28.4808 126.48 28.4944 126.412 28.4938C126.338 28.4929 126.266 28.4763 126.199 28.4453C126.132 28.4143 126.073 28.3694 126.024 28.3136L125.311 27.5876L124.605 28.3136C124.559 28.3694 124.502 28.4146 124.438 28.4465C124.374 28.4784 124.304 28.4962 124.233 28.4987C124.161 28.5012 124.09 28.4883 124.024 28.461C123.958 28.4337 123.898 28.3925 123.849 28.3401C123.799 28.2911 123.76 28.2322 123.733 28.167C123.707 28.1019 123.693 28.0319 123.694 27.9614C123.696 27.8909 123.711 27.8214 123.739 27.7571C123.768 27.6928 123.809 27.6352 123.86 27.5876L124.612 26.8423L123.793 26.0166C123.741 25.9681 123.7 25.9094 123.672 25.8441C123.643 25.7788 123.628 25.7082 123.628 25.6368C123.628 25.4994 123.682 25.3772 123.787 25.2703C123.835 25.2194 123.892 25.179 123.956 25.1515C124.019 25.124 124.088 25.11 124.157 25.1104C124.301 25.1104 124.431 25.1705 124.547 25.2906L125.311 26.1031L126.083 25.2906C126.132 25.2346 126.192 25.1897 126.259 25.1586C126.326 25.1276 126.399 25.1112 126.473 25.1104ZM17.5878 22.8277C17.7378 22.8277 17.8668 22.8887 17.9768 23.014L18.6828 23.7399L19.3958 23.014C19.4448 22.9581 19.5047 22.9132 19.5717 22.8822C19.6387 22.8511 19.7113 22.8347 19.7848 22.8338C19.9248 22.8338 20.0468 22.8867 20.1508 22.9906C20.1996 23.037 20.2384 23.0932 20.2651 23.1555C20.2918 23.2178 20.3056 23.285 20.3058 23.353C20.3058 23.4956 20.2508 23.6239 20.1408 23.7399L19.3888 24.4853L20.2068 25.311C20.2584 25.3577 20.2998 25.4149 20.3283 25.4789C20.3569 25.5429 20.372 25.6123 20.3726 25.6826C20.3733 25.7529 20.3595 25.8225 20.3322 25.887C20.3048 25.9516 20.2645 26.0096 20.2138 26.0573C20.1661 26.1081 20.1086 26.1485 20.045 26.176C19.9814 26.2035 19.9129 26.2175 19.8438 26.2172C19.7701 26.2165 19.6973 26.2001 19.6301 26.1691C19.563 26.138 19.5029 26.093 19.4538 26.037L18.6828 25.2245L17.9178 26.037C17.8687 26.093 17.8087 26.1379 17.7415 26.169C17.6744 26.2 17.6016 26.2164 17.5278 26.2172C17.4587 26.2174 17.3903 26.2034 17.3267 26.1759C17.2631 26.1484 17.2057 26.1081 17.1578 26.0573C17.1072 26.0096 17.0669 25.9516 17.0395 25.887C17.0122 25.8225 16.9984 25.7529 16.999 25.6826C16.9997 25.6123 17.0148 25.5429 17.0433 25.4789C17.0719 25.4149 17.1133 25.3577 17.1648 25.311L17.9828 24.4863L17.2308 23.7399C17.1794 23.6924 17.1382 23.6347 17.1097 23.5702C17.0811 23.5058 17.0659 23.4361 17.065 23.3654C17.064 23.2948 17.0774 23.2246 17.1042 23.1595C17.131 23.0943 17.1707 23.0354 17.2208 22.9865C17.268 22.9357 17.3249 22.8954 17.388 22.868C17.4512 22.8407 17.5192 22.827 17.5878 22.8277ZM37.9728 20.1447C38.0419 20.1445 38.1104 20.1585 38.174 20.186C38.2376 20.2135 38.295 20.2538 38.3428 20.3046C38.3933 20.3523 38.4335 20.4103 38.4608 20.4747C38.488 20.5391 38.5017 20.6087 38.5011 20.6788C38.5004 20.749 38.4854 20.8182 38.4569 20.8821C38.4285 20.946 38.3872 21.0032 38.3358 21.0499L37.5178 21.8757L38.2698 22.622C38.3798 22.737 38.4348 22.8663 38.4348 23.0079C38.4347 23.0759 38.4209 23.1431 38.3943 23.2055C38.3676 23.2678 38.3287 23.3239 38.2798 23.3703C38.2324 23.4205 38.1753 23.4603 38.1122 23.4873C38.0491 23.5142 37.9813 23.5278 37.9128 23.5271C37.8393 23.5264 37.7668 23.51 37.6998 23.4792C37.6329 23.4483 37.5729 23.4036 37.5238 23.3479L36.8118 22.622L36.1058 23.3479C36.0601 23.4038 36.0034 23.4492 35.9392 23.4812C35.8751 23.5132 35.805 23.531 35.7337 23.5335C35.6623 23.536 35.5912 23.5231 35.5251 23.4957C35.4589 23.4683 35.3992 23.427 35.3498 23.3744C35.2999 23.3254 35.2603 23.2665 35.2335 23.2014C35.2068 23.1362 35.1935 23.0661 35.1944 22.9955C35.1954 22.9249 35.2105 22.8552 35.239 22.7908C35.2674 22.7263 35.3086 22.6685 35.3598 22.621L36.1118 21.8757L35.2948 21.0509C35.2433 21.0042 35.2019 20.947 35.1733 20.883C35.1448 20.819 35.1297 20.7496 35.129 20.6793C35.1284 20.6091 35.1422 20.5394 35.1695 20.4749C35.1969 20.4103 35.2372 20.3523 35.2878 20.3046C35.3356 20.2538 35.3931 20.2134 35.4567 20.1859C35.5203 20.1584 35.5887 20.1444 35.6578 20.1447C35.7313 20.1455 35.8039 20.1618 35.8708 20.1927C35.9378 20.2235 35.9977 20.2682 36.0468 20.3239L36.8118 21.1365L37.5838 20.3239C37.633 20.2681 37.6931 20.2233 37.7602 20.1924C37.8274 20.1615 37.9002 20.1453 37.9738 20.1447H37.9728ZM118.123 17.8885C118.192 17.8882 118.26 17.9022 118.324 17.9297C118.388 17.9572 118.445 17.9975 118.493 18.0483C118.543 18.096 118.584 18.154 118.611 18.2184C118.638 18.2829 118.652 18.3524 118.651 18.4225C118.65 18.4927 118.635 18.5619 118.607 18.6258C118.578 18.6897 118.537 18.7469 118.486 18.7936L117.668 19.6204L118.42 20.3657C118.53 20.4807 118.585 20.6101 118.585 20.7526C118.585 20.8207 118.571 20.888 118.544 20.9503C118.517 21.0127 118.478 21.0688 118.429 21.1151C118.381 21.1651 118.325 21.2048 118.262 21.2318C118.199 21.2588 118.131 21.2724 118.063 21.2719C117.989 21.271 117.917 21.2545 117.85 21.2235C117.783 21.1924 117.723 21.1475 117.674 21.0917L116.962 20.3657L116.255 21.0917C116.209 21.1474 116.152 21.1926 116.088 21.2245C116.024 21.2564 115.954 21.2742 115.883 21.2767C115.812 21.2792 115.741 21.2663 115.675 21.239C115.609 21.2117 115.549 21.1705 115.5 21.1181C115.45 21.0692 115.411 21.0103 115.384 20.9452C115.357 20.8802 115.344 20.8102 115.345 20.7397C115.346 20.6692 115.361 20.5996 115.389 20.5353C115.418 20.471 115.459 20.4133 115.51 20.3657L116.262 19.6204L115.445 18.7936C115.393 18.7469 115.352 18.6897 115.323 18.6257C115.295 18.5617 115.28 18.4923 115.279 18.422C115.278 18.3517 115.292 18.2821 115.32 18.2176C115.347 18.153 115.387 18.095 115.438 18.0473C115.486 17.9967 115.543 17.9565 115.607 17.9292C115.67 17.9018 115.739 17.888 115.808 17.8885C115.881 17.8894 115.954 17.9058 116.021 17.9369C116.088 17.9679 116.148 18.0128 116.197 18.0687L116.962 18.8812L117.734 18.0687C117.783 18.0126 117.843 17.9676 117.91 17.9366C117.977 17.9055 118.05 17.8891 118.124 17.8885H118.123ZM24.9998 14.3523C25.1498 14.3523 25.2788 14.4134 25.3888 14.5386L26.0948 15.2646L26.8078 14.5386C26.8568 14.4827 26.9167 14.4379 26.9837 14.4068C27.0507 14.3758 27.1233 14.3593 27.1968 14.3584C27.3368 14.3584 27.4588 14.4114 27.5628 14.5152C27.6117 14.5618 27.6506 14.6181 27.6773 14.6806C27.704 14.7431 27.7178 14.8106 27.7178 14.8787C27.7178 15.0213 27.6628 15.1495 27.5528 15.2646L26.8008 16.0099L27.6188 16.8357C27.6704 16.8824 27.7118 16.9396 27.7403 17.0036C27.7689 17.0676 27.784 17.137 27.7846 17.2072C27.7853 17.2775 27.7715 17.3472 27.7442 17.4117C27.7168 17.4762 27.6765 17.5342 27.6258 17.582C27.5781 17.6328 27.5206 17.6732 27.457 17.7007C27.3934 17.7281 27.3249 17.7422 27.2558 17.7418C27.1821 17.7411 27.1093 17.7247 27.0421 17.6937C26.975 17.6627 26.9149 17.6177 26.8658 17.5616L26.0948 16.7491L25.3298 17.5616C25.2807 17.6176 25.2207 17.6626 25.1535 17.6936C25.0864 17.7247 25.0136 17.7411 24.9398 17.7418C24.8707 17.7421 24.8023 17.7281 24.7387 17.7006C24.6751 17.6731 24.6177 17.6328 24.5698 17.582C24.5192 17.5342 24.479 17.4761 24.4517 17.4115C24.4245 17.347 24.4108 17.2773 24.4115 17.207C24.4123 17.1367 24.4275 17.0674 24.4561 17.0034C24.4848 16.9395 24.5262 16.8823 24.5778 16.8357L25.3948 16.0109L24.6428 15.2646C24.5914 15.2171 24.5502 15.1593 24.5217 15.0949C24.4931 15.0305 24.4779 14.9608 24.477 14.8901C24.476 14.8194 24.4894 14.7493 24.5162 14.6841C24.543 14.6189 24.5827 14.56 24.6328 14.5111C24.68 14.4603 24.7369 14.42 24.8 14.3927C24.8632 14.3654 24.9312 14.3516 24.9998 14.3523ZM109.298 11.5869C109.367 11.5865 109.435 11.6004 109.499 11.6277C109.562 11.655 109.62 11.6952 109.668 11.7458C109.719 11.7935 109.759 11.8515 109.786 11.916C109.813 11.9806 109.827 12.0502 109.827 12.1205C109.826 12.1908 109.811 12.2602 109.782 12.3241C109.754 12.3881 109.712 12.4453 109.661 12.4921L108.843 13.3178L109.595 14.0642C109.705 14.1792 109.76 14.3085 109.76 14.4501C109.76 14.5181 109.746 14.5854 109.719 14.6478C109.692 14.7101 109.653 14.7662 109.604 14.8125C109.556 14.8626 109.5 14.9023 109.437 14.9293C109.374 14.9562 109.306 14.9698 109.238 14.9693C109.164 14.9686 109.092 14.9522 109.025 14.9214C108.958 14.8905 108.898 14.8458 108.849 14.7901L108.137 14.0642L107.43 14.7901C107.384 14.8458 107.327 14.8911 107.263 14.923C107.199 14.9549 107.129 14.9726 107.058 14.9751C106.987 14.9776 106.916 14.9648 106.85 14.9375C106.784 14.9102 106.724 14.869 106.675 14.8166C106.625 14.7676 106.585 14.7087 106.559 14.6435C106.532 14.5784 106.519 14.5083 106.519 14.4377C106.52 14.367 106.536 14.2974 106.564 14.2329C106.592 14.1685 106.634 14.1107 106.685 14.0631L107.437 13.3178L106.619 12.4921C106.567 12.4453 106.526 12.3881 106.497 12.3241C106.469 12.2602 106.454 12.1908 106.453 12.1205C106.452 12.0502 106.466 11.9806 106.494 11.916C106.521 11.8515 106.561 11.7935 106.612 11.7458C106.66 11.6951 106.717 11.6549 106.781 11.6276C106.844 11.6003 106.913 11.5865 106.982 11.5869C107.056 11.5876 107.128 11.6038 107.195 11.6347C107.263 11.6655 107.323 11.7103 107.372 11.7661L108.137 12.5786L108.909 11.7661C108.958 11.7102 109.018 11.6654 109.085 11.6346C109.152 11.6037 109.225 11.5875 109.299 11.5869H109.298Z\" fill=\"#B6C5D5\"/>\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M101.735 14.0358V44.8541C101.735 46.9821 100.026 48.7069 97.9184 48.7069H52.1184C51.2583 48.7095 50.4225 48.4158 49.7471 47.8734C49.0717 47.331 48.5964 46.5719 48.3984 45.7196C48.6744 45.7837 48.9614 45.8173 49.2564 45.8173H95.0564C97.1644 45.8173 98.8724 44.0925 98.8724 41.9645V11.1462C98.8724 10.8489 98.8394 10.5597 98.7764 10.2808C100.471 10.6728 101.735 12.2051 101.735 14.0358Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M94.617 7.29346C96.724 7.29346 98.433 9.01826 98.433 11.1463V41.9646C98.433 44.0926 96.724 45.8174 94.617 45.8174H48.817C46.709 45.8174 45 44.0926 45 41.9646V11.1463C45 9.01826 46.709 7.29346 48.817 7.29346H94.617ZM94.617 9.21986H48.817C48.3293 9.21782 47.8595 9.40671 47.5047 9.74745C47.15 10.0882 46.9374 10.5547 46.911 11.0505L46.908 11.1463V41.9646C46.9101 42.4609 47.0994 42.9375 47.4368 43.2956C47.7743 43.6538 48.234 43.8662 48.721 43.889L48.817 43.891H94.617C95.1045 43.893 95.5742 43.7043 95.9289 43.3638C96.2837 43.0232 96.4963 42.557 96.523 42.0613L96.525 41.9646V11.1463C96.5229 10.6499 96.3336 10.1734 95.9962 9.81521C95.6587 9.45703 95.199 9.24462 94.712 9.22189L94.617 9.21986Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M65.393 28.3629C68.675 28.3629 71.345 31.117 71.345 34.5025V37.8757C71.3458 38.0038 71.3218 38.1308 71.2744 38.2495C71.227 38.3681 71.1571 38.4761 71.0687 38.5673C70.9803 38.6584 70.8751 38.7309 70.7592 38.7807C70.6432 38.8304 70.5188 38.8565 70.393 38.8573C70.2672 38.8565 70.1428 38.8304 70.0269 38.7807C69.9109 38.7309 69.8058 38.6584 69.7174 38.5673C69.629 38.4761 69.559 38.3681 69.5116 38.2495C69.4642 38.1308 69.4402 38.0038 69.441 37.8757V34.5025C69.441 32.2004 67.625 30.328 65.393 30.328H56.953C54.72 30.328 52.904 32.2004 52.904 34.5025V37.8757C52.9048 38.0038 52.8808 38.1308 52.8334 38.2495C52.786 38.3681 52.7161 38.4761 52.6277 38.5673C52.5393 38.6584 52.4341 38.7309 52.3182 38.7807C52.2022 38.8304 52.0778 38.8565 51.952 38.8573C51.6981 38.8556 51.4552 38.7515 51.2767 38.5676C51.0982 38.3838 50.9987 38.1353 51 37.8768V34.5035C51 31.1181 53.67 28.3639 56.952 28.3639L65.393 28.3629ZM78.19 34.1329C78.716 34.1329 79.142 34.5728 79.142 35.1154C79.1433 35.3741 79.0439 35.6227 78.8654 35.8067C78.6869 35.9907 78.444 36.0951 78.19 36.097H75.164C75.0381 36.0963 74.9136 36.0704 74.7976 36.0207C74.6815 35.971 74.5762 35.8985 74.4877 35.8073C74.3992 35.7162 74.3292 35.6081 74.2817 35.4894C74.2343 35.3707 74.2102 35.2436 74.211 35.1154C74.211 34.5728 74.637 34.1329 75.164 34.1329H78.19ZM84.098 34.1329C84.624 34.1329 85.05 34.5728 85.05 35.1154C85.0513 35.3741 84.9519 35.6227 84.7734 35.8067C84.5949 35.9907 84.352 36.0951 84.098 36.097H81.071C80.9452 36.0962 80.8208 36.0702 80.7049 36.0204C80.5889 35.9706 80.4838 35.8981 80.3954 35.807C80.307 35.7158 80.2371 35.6078 80.1896 35.4892C80.1422 35.3705 80.1182 35.2435 80.119 35.1154C80.119 34.5728 80.545 34.1329 81.071 34.1329H84.098ZM83.958 27.1013C84.484 27.1013 84.91 27.5422 84.91 28.0839C84.9116 28.3427 84.8122 28.5915 84.6337 28.7758C84.4552 28.96 84.2122 29.0645 83.958 29.0664H75.163C74.9088 29.0645 74.6658 28.96 74.4873 28.7758C74.3088 28.5915 74.2094 28.3427 74.211 28.0839C74.211 27.5422 74.638 27.1013 75.163 27.1013H83.958ZM61.173 14.4209C64.378 14.4209 66.986 17.1109 66.986 20.418C66.986 23.724 64.378 26.4141 61.173 26.4141C57.967 26.4141 55.359 23.724 55.359 20.417C55.359 17.1109 57.967 14.4209 61.173 14.4209ZM61.173 16.386C59.017 16.386 57.263 18.1943 57.263 20.418C57.263 22.6407 59.017 24.45 61.173 24.45C63.328 24.45 65.082 22.6407 65.082 20.418C65.082 18.1943 63.328 16.386 61.172 16.386H61.173ZM91.048 21.9585C91.573 21.9585 92 22.3984 92 22.941C92.0013 23.1997 91.9019 23.4483 91.7234 23.6323C91.5449 23.8163 91.302 23.9207 91.048 23.9226H75.163C75.0372 23.9218 74.9128 23.8957 74.7969 23.846C74.6809 23.7962 74.5758 23.7237 74.4874 23.6326C74.399 23.5414 74.3291 23.4334 74.2816 23.3148C74.2342 23.1961 74.2102 23.0691 74.211 22.941C74.211 22.3984 74.637 21.9585 75.163 21.9585H91.048ZM86.933 16.8157C87.458 16.8157 87.885 17.2555 87.885 17.7982C87.8863 18.0568 87.7869 18.3054 87.6084 18.4894C87.4299 18.6734 87.187 18.7779 86.933 18.7797H75.163C74.909 18.7779 74.6661 18.6734 74.4877 18.4894C74.3092 18.3054 74.2097 18.0568 74.211 17.7982C74.211 17.2555 74.638 16.8157 75.163 16.8157H86.933Z\" fill=\"#B6C5D5\"/>\n</svg>";

var LinealDocumentationSuccess = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M35.466 55.185C36.57 55.185 37.466 56.081 37.466 57.185C37.466 58.289 36.57 59.185 35.466 59.185H14.176C13.071 59.185 12.176 58.289 12.176 57.185C12.176 56.081 13.071 55.185 14.176 55.185H35.466ZM44.3225 45.4766C45.4265 45.4766 46.3225 46.3726 46.3225 47.4766C46.3225 48.5806 45.4265 49.4766 44.3225 49.4766H24.1125C23.0085 49.4766 22.1125 48.5806 22.1125 47.4766C22.1125 46.3726 23.0085 45.4766 24.1125 45.4766H44.3225ZM14.176 45.4766C15.28 45.4766 16.176 46.3726 16.176 47.4766C16.176 48.5806 15.28 49.4766 14.176 49.4766H6C4.896 49.4766 4 48.5806 4 47.4766C4 46.3726 4.896 45.4766 6 45.4766H14.176ZM40.9299 35.7685C42.0339 35.7685 42.9299 36.6645 42.9299 37.7685C42.9299 38.8725 42.0339 39.7685 40.9299 39.7685H14.8579C13.7529 39.7685 12.8579 38.8725 12.8579 37.7685C12.8579 36.6645 13.7529 35.7685 14.8579 35.7685H40.9299ZM161.764 35.1763C162.868 35.1763 163.764 36.0723 163.764 37.1763C163.764 38.2803 162.868 39.1763 161.764 39.1763H150.694C149.589 39.1763 148.694 38.2803 148.694 37.1763C148.694 36.0723 149.589 35.1763 150.694 35.1763H161.764ZM172.835 35.1763C173.939 35.1763 174.835 36.0723 174.835 37.1763C174.835 38.2803 173.939 39.1763 172.835 39.1763H169.429C168.324 39.1763 167.429 38.2803 167.429 37.1763C167.429 36.0723 168.324 35.1763 169.429 35.1763H172.835ZM185.861 25.4678C186.965 25.4678 187.861 26.3638 187.861 27.4678C187.861 28.5718 186.965 29.4678 185.861 29.4678H177.285C176.18 29.4678 175.285 28.5718 175.285 27.4678C175.285 26.3638 176.18 25.4678 177.285 25.4678H185.861ZM167.412 25.4678C168.516 25.4678 169.412 26.3638 169.412 27.4678C169.412 28.5718 168.516 29.4678 167.412 29.4678H152.995C151.891 29.4678 150.995 28.5718 150.995 27.4678C150.995 26.3638 151.891 25.4678 152.995 25.4678H167.412ZM176.066 15.7593C177.17 15.7593 178.066 16.6553 178.066 17.7593C178.066 18.8633 177.17 19.7593 176.066 19.7593H159.29C158.185 19.7593 157.29 18.8633 157.29 17.7593C157.29 16.6553 158.185 15.7593 159.29 15.7593H176.066ZM151.38 15.7593C152.484 15.7593 153.38 16.6553 153.38 17.7593C153.38 18.8633 152.484 19.7593 151.38 19.7593H147.974C146.869 19.7593 145.974 18.8633 145.974 17.7593C145.974 16.6553 146.869 15.7593 147.974 15.7593H151.38Z\" fill=\"#B6C5D5\"/>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M100.836 83.0002C101.013 85.5065 101.522 87.921 102.32 90.2L81.7592 90.1997C77.6115 90.1997 74.2007 87.0426 73.7988 83.0007L100.836 83.0002ZM128.342 10.7017C131.382 11.8345 133.547 14.7644 133.547 18.1997L133.548 53.662C131.93 53.3691 130.264 53.2162 128.563 53.2162C128.491 53.2162 128.419 53.2165 128.347 53.217L128.347 11C128.347 10.9001 128.345 10.8007 128.342 10.7017Z\" fill=\"#B6C5D5\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M120.348 3C124.682 3 128.212 6.4481 128.344 10.7508L128.348 11L128.348 53.217C126.989 53.2273 125.653 53.3351 124.348 53.5337L124.348 11C124.348 8.794 122.553 7 120.348 7H67.5205C65.3814 7 63.6296 8.68692 63.5254 10.8006L63.5205 11V75C63.5205 77.1392 65.2074 78.8909 67.3211 78.9951L67.5205 79L100.837 79.0002C100.789 79.665 100.765 80.3363 100.765 81.0132C100.765 81.6816 100.789 82.3445 100.835 83.0011L67.5205 83C63.1849 83 59.6559 79.5519 59.5243 75.2492L59.5205 75V11C59.5205 6.66536 62.9677 3.13547 67.2713 3.00381L67.5205 3H120.348ZM112.971 42.9404C113.161 42.9404 113.315 42.998 113.432 43.115C113.548 43.232 113.607 43.3859 113.607 43.5767V44.1599C114.243 44.2445 114.84 44.4848 115.399 44.8808C115.505 44.9519 115.581 45.0329 115.626 45.1247C115.672 45.2165 115.696 45.3263 115.696 45.4532C115.696 45.6305 115.641 45.7862 115.532 45.9194C115.422 46.0544 115.296 46.1219 115.155 46.1219C115.077 46.1219 115.005 46.1111 114.938 46.0895C114.87 46.0688 114.777 46.0229 114.656 45.9518C114.366 45.7682 114.107 45.6305 113.878 45.5387C113.647 45.4469 113.367 45.4001 113.034 45.4001C112.653 45.4001 112.347 45.4856 112.117 45.6548C111.887 45.8249 111.773 46.0508 111.773 46.3334C111.773 46.5314 111.839 46.6925 111.974 46.8158C112.108 46.94 112.278 47.0372 112.483 47.1074C112.688 47.1785 112.974 47.2595 113.341 47.3513C113.857 47.4782 114.28 47.6078 114.609 47.7383C114.938 47.8688 115.221 48.0776 115.457 48.3638C115.694 48.6509 115.812 49.0343 115.812 49.5149C115.812 50.0873 115.617 50.5697 115.224 50.9621C114.831 51.3545 114.303 51.6074 113.638 51.7199V52.3247C113.638 52.5155 113.581 52.6694 113.464 52.7855C113.347 52.9025 113.193 52.961 113.002 52.961C112.818 52.961 112.666 52.9025 112.546 52.7855C112.426 52.6694 112.366 52.5155 112.366 52.3247V51.7523C111.978 51.7163 111.601 51.6353 111.236 51.5084C110.873 51.3806 110.553 51.2186 110.277 51.0206C110.164 50.9495 110.084 50.8703 110.038 50.7821C109.993 50.6939 109.97 50.5823 109.97 50.4482C109.97 50.2709 110.025 50.1161 110.135 49.9811C110.244 49.847 110.369 49.7804 110.511 49.7804C110.645 49.7804 110.811 49.8371 111.009 49.9496C111.334 50.1404 111.643 50.2799 111.937 50.3681C112.23 50.4563 112.536 50.5004 112.854 50.5004C113.278 50.5004 113.603 50.4212 113.829 50.2628C114.056 50.1035 114.168 49.8785 114.168 49.5887C114.168 49.4123 114.104 49.2674 113.972 49.154C113.842 49.0415 113.681 48.9524 113.49 48.8894C113.299 48.8255 113.024 48.7445 112.663 48.6455C112.14 48.5105 111.709 48.3764 111.369 48.2423C111.03 48.1082 110.739 47.8958 110.495 47.606C110.251 47.3162 110.129 46.9274 110.129 46.4396C110.129 45.8672 110.332 45.3758 110.739 44.9654C111.145 44.5559 111.677 44.294 112.334 44.1806V43.5767C112.334 43.3859 112.394 43.232 112.514 43.115C112.635 42.998 112.787 42.9404 112.971 42.9404ZM76.355 43.6254C78.8921 43.6254 80.9495 45.6819 80.9495 48.2199C80.9495 50.757 78.8921 52.8144 76.355 52.8144C73.817 52.8144 71.7596 50.757 71.7596 48.2199C71.7596 45.6819 73.817 43.6254 76.355 43.6254ZM94.9127 49.4328C95.6579 49.4328 96.2627 50.0367 96.2627 50.7828C96.2627 51.5289 95.6579 52.1328 94.9127 52.1328H85.6418C84.8966 52.1328 84.2918 51.5289 84.2918 50.7828C84.2918 50.0367 84.8966 49.4328 85.6418 49.4328H94.9127ZM104.183 44.9314C104.929 44.9314 105.533 45.5354 105.533 46.2815C105.533 47.0276 104.929 47.6315 104.183 47.6315H85.6416C84.8964 47.6315 84.2916 47.0276 84.2916 46.2815C84.2916 45.5354 84.8964 44.9314 85.6416 44.9314H104.183ZM112.971 29.2233C113.161 29.2233 113.315 29.2809 113.432 29.3979C113.548 29.5149 113.607 29.6688 113.607 29.8596V30.4428C114.243 30.5274 114.84 30.7677 115.399 31.1637C115.505 31.2348 115.581 31.3158 115.626 31.4076C115.672 31.4994 115.696 31.6092 115.696 31.7361C115.696 31.9134 115.641 32.0691 115.532 32.2023C115.422 32.3373 115.296 32.4048 115.155 32.4048C115.077 32.4048 115.005 32.394 114.938 32.3724C114.87 32.3517 114.777 32.3058 114.656 32.2347C114.366 32.0511 114.107 31.9134 113.878 31.8216C113.647 31.7298 113.367 31.683 113.034 31.683C112.653 31.683 112.347 31.7685 112.117 31.9377C111.887 32.1078 111.773 32.3337 111.773 32.6163C111.773 32.8143 111.839 32.9754 111.974 33.0987C112.108 33.2229 112.278 33.3201 112.483 33.3903C112.688 33.4614 112.974 33.5424 113.341 33.6342C113.857 33.7611 114.28 33.8907 114.609 34.0212C114.938 34.1517 115.221 34.3605 115.457 34.6467C115.694 34.9338 115.812 35.3172 115.812 35.7978C115.812 36.3702 115.617 36.8526 115.224 37.245C114.831 37.6374 114.303 37.8903 113.638 38.0028V38.6076C113.638 38.7984 113.581 38.9523 113.464 39.0684C113.347 39.1854 113.193 39.2439 113.002 39.2439C112.818 39.2439 112.666 39.1854 112.546 39.0684C112.426 38.9523 112.366 38.7984 112.366 38.6076V38.0352C111.978 37.9992 111.601 37.9182 111.236 37.7913C110.873 37.6635 110.553 37.5015 110.277 37.3035C110.164 37.2324 110.084 37.1532 110.038 37.065C109.993 36.9768 109.97 36.8652 109.97 36.7311C109.97 36.5538 110.025 36.399 110.135 36.264C110.244 36.1299 110.369 36.0633 110.511 36.0633C110.645 36.0633 110.811 36.12 111.009 36.2325C111.334 36.4233 111.643 36.5628 111.937 36.651C112.23 36.7392 112.536 36.7833 112.854 36.7833C113.278 36.7833 113.603 36.7041 113.829 36.5457C114.056 36.3864 114.168 36.1614 114.168 35.8716C114.168 35.6952 114.104 35.5503 113.972 35.4369C113.842 35.3244 113.681 35.2353 113.49 35.1723C113.299 35.1084 113.024 35.0274 112.663 34.9284C112.14 34.7934 111.709 34.6593 111.369 34.5252C111.03 34.3911 110.739 34.1787 110.495 33.8889C110.251 33.5991 110.129 33.2103 110.129 32.7225C110.129 32.1501 110.332 31.6587 110.739 31.2483C111.145 30.8388 111.677 30.5769 112.334 30.4635V29.8596C112.334 29.6688 112.394 29.5149 112.514 29.3979C112.635 29.2809 112.787 29.2233 112.971 29.2233ZM76.355 29.9078C78.8921 29.9078 80.9495 31.9652 80.9495 34.5023C80.9495 37.0403 78.8921 39.0968 76.355 39.0968C73.817 39.0968 71.7596 37.0403 71.7596 34.5023C71.7596 31.9652 73.817 29.9078 76.355 29.9078ZM94.9127 35.7157C95.6579 35.7157 96.2627 36.3196 96.2627 37.0657C96.2627 37.8118 95.6579 38.4157 94.9127 38.4157H85.6418C84.8966 38.4157 84.2918 37.8118 84.2918 37.0657C84.2918 36.3196 84.8966 35.7157 85.6418 35.7157H94.9127ZM104.183 31.2139C104.929 31.2139 105.533 31.8178 105.533 32.5639C105.533 33.31 104.929 33.9139 104.183 33.9139H85.6416C84.8964 33.9139 84.2916 33.31 84.2916 32.5639C84.2916 31.8178 84.8964 31.2139 85.6416 31.2139H104.183ZM112.971 15.5062C113.161 15.5062 113.315 15.5638 113.432 15.6808C113.548 15.7978 113.607 15.9517 113.607 16.1425V16.7257C114.243 16.8103 114.84 17.0506 115.399 17.4466C115.505 17.5177 115.581 17.5987 115.626 17.6905C115.672 17.7823 115.696 17.8921 115.696 18.019C115.696 18.1963 115.641 18.352 115.532 18.4852C115.422 18.6202 115.296 18.6877 115.155 18.6877C115.077 18.6877 115.005 18.6769 114.938 18.6553C114.87 18.6346 114.777 18.5887 114.656 18.5176C114.366 18.334 114.107 18.1963 113.878 18.1045C113.647 18.0127 113.367 17.9659 113.034 17.9659C112.653 17.9659 112.347 18.0514 112.117 18.2206C111.887 18.3907 111.773 18.6166 111.773 18.8992C111.773 19.0972 111.839 19.2583 111.974 19.3816C112.108 19.5058 112.278 19.603 112.483 19.6732C112.688 19.7443 112.974 19.8253 113.341 19.9171C113.857 20.044 114.28 20.1736 114.609 20.3041C114.938 20.4346 115.221 20.6434 115.457 20.9296C115.694 21.2167 115.812 21.6001 115.812 22.0807C115.812 22.6531 115.617 23.1355 115.224 23.5279C114.831 23.9203 114.303 24.1732 113.638 24.2857V24.8905C113.638 25.0813 113.581 25.2352 113.464 25.3513C113.347 25.4683 113.193 25.5268 113.002 25.5268C112.818 25.5268 112.666 25.4683 112.546 25.3513C112.426 25.2352 112.366 25.0813 112.366 24.8905V24.3181C111.978 24.2821 111.601 24.2011 111.236 24.0742C110.873 23.9464 110.553 23.7844 110.277 23.5864C110.164 23.5153 110.084 23.4361 110.038 23.3479C109.993 23.2597 109.97 23.1481 109.97 23.014C109.97 22.8367 110.025 22.6819 110.135 22.5469C110.244 22.4128 110.369 22.3462 110.511 22.3462C110.645 22.3462 110.811 22.4029 111.009 22.5154C111.334 22.7062 111.643 22.8457 111.937 22.9339C112.23 23.0221 112.536 23.0662 112.854 23.0662C113.278 23.0662 113.603 22.987 113.829 22.8286C114.056 22.6693 114.168 22.4443 114.168 22.1545C114.168 21.9781 114.104 21.8332 113.972 21.7198C113.842 21.6073 113.681 21.5182 113.49 21.4552C113.299 21.3913 113.024 21.3103 112.663 21.2113C112.14 21.0763 111.709 20.9422 111.369 20.8081C111.03 20.674 110.739 20.4616 110.495 20.1718C110.251 19.882 110.129 19.4932 110.129 19.0054C110.129 18.433 110.332 17.9416 110.739 17.5312C111.145 17.1217 111.677 16.8598 112.334 16.7464V16.1425C112.334 15.9517 112.394 15.7978 112.514 15.6808C112.635 15.5638 112.787 15.5062 112.971 15.5062ZM76.355 16.1908C78.8921 16.1908 80.9495 18.2482 80.9495 20.7853C80.9495 23.3233 78.8921 25.3798 76.355 25.3798C73.817 25.3798 71.7596 23.3233 71.7596 20.7853C71.7596 18.2482 73.817 16.1908 76.355 16.1908ZM94.9127 21.9982C95.6579 21.9982 96.2627 22.6021 96.2627 23.3482C96.2627 24.0943 95.6579 24.6982 94.9127 24.6982H85.6418C84.8966 24.6982 84.2918 24.0943 84.2918 23.3482C84.2918 22.6021 84.8966 21.9982 85.6418 21.9982H94.9127ZM104.183 17.4968C104.929 17.4968 105.533 18.1007 105.533 18.8468C105.533 19.5929 104.929 20.1968 104.183 20.1968H85.6416C84.8964 20.1968 84.2916 19.5929 84.2916 18.8468C84.2916 18.1007 84.8964 17.4968 85.6416 17.4968H104.183Z\" fill=\"#B6C5D5\"/>\n<path d=\"M125.125 92.8433C134.083 92.8433 141.344 85.5818 141.344 76.6243C141.344 67.6668 134.083 60.4053 125.125 60.4053C116.168 60.4053 108.906 67.6668 108.906 76.6243C108.906 85.5818 116.168 92.8433 125.125 92.8433Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M125 95.3675C135.022 95.3675 143.281 87.0546 143.281 76.9905C143.281 66.9457 135.003 58.6328 125 58.6328C114.978 58.6328 106.719 66.9457 106.719 76.9905C106.719 87.0546 114.997 95.3675 125 95.3675ZM122.827 86.3879C122.292 86.3879 121.89 86.175 121.45 85.6332L116.039 78.9952C115.809 78.6856 115.656 78.3179 115.656 77.9502C115.656 77.1954 116.249 76.6342 116.937 76.6342C117.377 76.6342 117.76 76.8084 118.142 77.2922L122.751 83.156L131.452 69.1641C131.758 68.6803 132.178 68.4287 132.58 68.4287C133.268 68.4287 133.938 68.8932 133.938 69.6479C133.938 69.9266 133.815 70.2301 133.658 70.4988L124.128 85.6138C123.783 86.1363 123.344 86.3879 122.827 86.3879Z\" fill=\"#1AAAAD\"/>\n</svg>";

var LinealEstablecimientosEmpty = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M157.457 39.4555H147.11C146.077 39.4555 145.241 38.618 145.241 37.5861C145.241 36.5543 146.077 35.7168 147.11 35.7168H157.457C158.489 35.7168 159.326 36.5543 159.326 37.5861C159.326 38.618 158.489 39.4555 157.457 39.4555ZM170.824 21.307H155.144C154.111 21.307 153.275 20.4696 153.275 19.4377C153.275 18.4058 154.111 17.5684 155.144 17.5684H170.824C171.856 17.5684 172.694 18.4058 172.694 19.4377C172.694 20.4696 171.856 21.307 170.824 21.307ZM147.751 21.307H144.568C143.535 21.307 142.699 20.4696 142.699 19.4377C142.699 18.4058 143.535 17.5684 144.568 17.5684H147.751C148.783 17.5684 149.621 18.4058 149.621 19.4377C149.621 20.4696 148.783 21.307 147.751 21.307ZM167.805 39.4555H164.621C163.589 39.4555 162.752 38.618 162.752 37.5861C162.752 36.5543 163.589 35.7168 164.621 35.7168H167.805C168.837 35.7168 169.674 36.5543 169.674 37.5861C169.674 38.618 168.837 39.4555 167.805 39.4555ZM179.98 30.3813H171.963C170.931 30.3813 170.094 29.5438 170.094 28.5119C170.094 27.48 170.931 26.6426 171.963 26.6426H179.98C181.012 26.6426 181.849 27.48 181.849 28.5119C181.849 29.5438 181.012 30.3813 179.98 30.3813ZM162.736 30.3813H149.261C148.229 30.3813 147.392 29.5438 147.392 28.5119C147.392 27.48 148.229 26.6426 149.261 26.6426H162.736C163.768 26.6426 164.606 27.48 164.606 28.5119C164.606 29.5438 163.768 30.3813 162.736 30.3813ZM47.6881 39.7362H28.7985C27.7666 39.7362 26.9292 38.8987 26.9292 37.8668C26.9292 36.8349 27.7666 35.9975 28.7985 35.9975H47.6881C48.72 35.9975 49.5575 36.8349 49.5575 37.8668C49.5575 38.8987 48.72 39.7362 47.6881 39.7362ZM19.5112 39.7362H11.8693C10.8375 39.7362 10 38.8987 10 37.8668C10 36.8349 10.8375 35.9975 11.8693 35.9975H19.5112C20.5431 35.9975 21.3805 36.8349 21.3805 37.8668C21.3805 38.8987 20.5431 39.7362 19.5112 39.7362ZM44.5172 30.6623H20.1485C19.1157 30.6623 18.2792 29.8248 18.2792 28.793C18.2792 27.7611 19.1157 26.9236 20.1485 26.9236H44.5172C45.5491 26.9236 46.3865 27.7611 46.3865 28.793C46.3865 29.8248 45.5491 30.6623 44.5172 30.6623ZM39.4103 48.8103H19.5112C18.4784 48.8103 17.6418 47.9728 17.6418 46.941C17.6418 45.9091 18.4784 45.0716 19.5112 45.0716H39.4103C40.4421 45.0716 41.2796 45.9091 41.2796 46.941C41.2796 47.9728 40.4421 48.8103 39.4103 48.8103Z\" fill=\"#B6C5D5\"/>\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M121.218 7.0083C121.845 7.0083 122.429 7.36203 122.735 7.90735L133.352 26.7726C133.513 27.0379 133.586 27.3327 133.586 27.6422C133.586 31.8869 131.048 35.5273 127.431 37.1338C127.446 37.1928 127.446 37.2517 127.446 37.3254V68.2173C127.446 69.19 126.658 69.9859 125.696 69.9859H70.0864C69.1238 69.9859 68.3363 69.19 68.3363 68.2173V37.1043C64.734 35.4978 62.2109 31.8722 62.2109 27.6422C62.2109 27.3327 62.2984 27.0379 62.4443 26.7726L73.0469 7.90735C73.3532 7.34729 73.9366 7.0083 74.5637 7.0083H121.218ZM114.86 33.4197C113.022 36.1758 109.916 37.9886 106.386 37.9886C102.871 37.9886 99.7504 36.1758 97.9128 33.4197C96.0607 36.1758 92.9542 37.9886 89.4249 37.9886C85.8955 37.9886 82.7745 36.1758 80.9369 33.4197C79.0993 36.1758 75.9783 37.9886 72.449 37.9886C72.2448 37.9886 72.0406 37.9886 71.8364 37.9739V66.4634H78.0347V47.3623C78.0347 44.0167 80.7328 41.3048 84.0288 41.3048H89.1186C92.4292 41.3048 95.1127 44.0314 95.1127 47.3623V66.4487H123.945V37.9739L123.348 37.9886C119.818 37.9886 116.697 36.1758 114.86 33.4197ZM89.1332 44.842H84.0434C82.6579 44.842 81.5495 45.9769 81.5495 47.3623V66.4487H91.6271V47.3623C91.6271 45.9622 90.5041 44.842 89.1332 44.842ZM111.563 40.5964C114.447 40.5964 116.792 42.7207 116.792 45.3331V52.6536C116.792 55.266 114.447 57.3904 111.563 57.3904H101.027C98.1438 57.3904 95.799 55.266 95.799 52.6536V45.3331C95.799 42.7207 98.1438 40.5964 101.027 40.5964H111.563ZM111.563 44.0413H101.027C100.251 44.0413 99.6014 44.6155 99.6014 45.3331V52.6536C99.6014 53.357 100.235 53.9455 101.027 53.9455H111.563C112.34 53.9455 112.989 53.3713 112.989 52.6536V45.3331C112.989 44.6298 112.355 44.0413 111.563 44.0413ZM129.983 28.8508H116.726C117.281 32.0343 120.037 34.4514 123.348 34.4514C126.658 34.4514 129.415 32.0195 129.983 28.8508ZM113.007 28.836H99.765C100.319 32.0195 103.076 34.4367 106.386 34.4367C109.697 34.4367 112.453 32.0195 113.007 28.836ZM96.0461 28.836H82.7891C83.3579 32.0195 86.1143 34.4367 89.4249 34.4367C92.7355 34.4367 95.4919 32.0195 96.0461 28.836ZM79.0848 28.836H65.8278C66.382 32.0195 69.1384 34.4514 72.449 34.4367C75.7596 34.4367 78.5306 32.0195 79.0848 28.836ZM120.197 10.5603H75.5846L67.3008 25.3135H128.496L120.197 10.5603Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M119.48 5.13916C120.107 5.13916 120.69 5.49288 120.997 6.03821L131.614 24.9035C131.774 25.1688 131.847 25.4636 131.847 25.7731C131.847 30.0178 129.31 33.6582 125.693 35.2647C125.707 35.3236 125.707 35.3826 125.707 35.4563V66.3482C125.707 67.3209 124.92 68.1168 123.957 68.1168H68.3481C67.3855 68.1168 66.598 67.3209 66.598 66.3482V35.2352C62.9957 33.6287 60.4727 30.003 60.4727 25.7731C60.4727 25.4636 60.5602 25.1688 60.706 24.9035L71.3087 6.03821C71.6149 5.47815 72.1983 5.13916 72.8254 5.13916H119.48ZM113.121 31.5506C111.284 34.3067 108.177 36.1195 104.648 36.1195C101.133 36.1195 98.0122 34.3067 96.1746 31.5506C94.3224 34.3067 91.216 36.1195 87.6866 36.1195C84.1573 36.1195 81.0363 34.3067 79.1987 31.5506C77.3611 34.3067 74.2401 36.1195 70.7107 36.1195C70.5065 36.1195 70.3023 36.1195 70.0982 36.1048V64.5943H76.2964V45.4932C76.2964 42.1475 78.9945 39.4357 82.2905 39.4357H87.3803C90.6909 39.4357 93.3744 42.1623 93.3744 45.4932V64.5795H122.207V36.1048L121.609 36.1195C118.08 36.1195 114.959 34.3067 113.121 31.5506ZM87.3949 42.9729H82.3051C80.9196 42.9729 79.8112 44.1078 79.8112 45.4932V64.5795H89.8888V45.4932C89.8888 44.093 88.7658 42.9729 87.3949 42.9729ZM109.825 38.7272C112.708 38.7272 115.053 40.8516 115.053 43.464V50.7845C115.053 53.3969 112.708 55.5213 109.825 55.5213H99.2891C96.4056 55.5213 94.0607 53.3969 94.0607 50.7845V43.464C94.0607 40.8516 96.4056 38.7272 99.2891 38.7272H109.825ZM109.825 42.1722H99.2891C98.5127 42.1722 97.8631 42.7463 97.8631 43.464V50.7845C97.8631 51.4878 98.4969 52.0763 99.2891 52.0763H109.825C110.601 52.0763 111.251 51.5022 111.251 50.7845V43.464C111.251 42.7607 110.617 42.1722 109.825 42.1722ZM128.245 26.9816H114.988C115.542 30.1651 118.299 32.5823 121.609 32.5823C124.92 32.5823 127.676 30.1504 128.245 26.9816ZM111.269 26.9669H98.0267C98.5809 30.1504 101.337 32.5675 104.648 32.5675C107.959 32.5675 110.715 30.1504 111.269 26.9669ZM94.3078 26.9669H81.0508C81.6196 30.1504 84.376 32.5675 87.6866 32.5675C90.9972 32.5675 93.7536 30.1504 94.3078 26.9669ZM77.3465 26.9669H64.0895C64.6437 30.1504 67.4001 32.5823 70.7107 32.5675C74.0213 32.5675 76.7923 30.1504 77.3465 26.9669ZM118.459 8.69114H73.8463L65.5625 23.4444H126.757L118.459 8.69114Z\" fill=\"#B6C5D5\"/>\n<path d=\"M131.164 92.7677C143.037 92.7677 152.662 83.143 152.662 71.2703C152.662 59.3976 143.037 49.7729 131.164 49.7729C119.292 49.7729 109.667 59.3976 109.667 71.2703C109.667 83.143 119.292 92.7677 131.164 92.7677Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M130.869 52.9912C141.015 52.9912 149.24 61.2161 149.24 71.3629C149.24 81.5088 141.015 89.7345 130.869 89.7345C120.722 89.7345 112.497 81.5088 112.497 71.3629C112.497 61.2161 120.722 52.9912 130.869 52.9912ZM130.753 77.031C130.036 77.031 129.445 77.2684 128.98 77.743C128.515 78.2177 128.283 78.8127 128.283 79.5299C128.283 80.2462 128.515 80.8421 128.98 81.3167C129.445 81.7914 130.036 82.0287 130.753 82.0287C131.45 82.0287 132.031 81.7914 132.496 81.3167C132.961 80.8421 133.193 80.2462 133.193 79.5299C133.193 78.8127 132.961 78.2177 132.496 77.743C132.031 77.2684 131.45 77.031 130.753 77.031ZM131.131 61.1084C130.007 61.1084 128.888 61.2967 127.774 61.6742C126.66 62.0525 125.677 62.5796 124.825 63.2581C124.554 63.4713 124.355 63.6992 124.23 63.9409C124.103 64.1833 124.041 64.4783 124.041 64.8274C124.041 65.3313 124.181 65.7621 124.462 66.1198C124.742 66.4784 125.086 66.6581 125.493 66.6581C125.861 66.6581 126.325 66.5025 126.888 66.1929C127.78 65.6701 128.491 65.2823 129.024 65.0303C129.556 64.7792 130.132 64.6528 130.753 64.6528C131.431 64.6528 131.968 64.8128 132.365 65.1318C132.762 65.4517 132.961 65.8834 132.961 66.4251C132.961 66.929 132.839 67.3796 132.598 67.776C132.355 68.1733 131.972 68.672 131.45 69.2731C130.753 70.0667 130.224 70.7933 129.866 71.452C129.507 72.1107 129.328 72.9336 129.328 73.9216C129.328 74.4058 129.449 74.7936 129.692 75.0842C129.934 75.3749 130.268 75.5202 130.695 75.5202C131.043 75.5202 131.338 75.4179 131.58 75.2149C131.823 75.0111 131.982 74.7256 132.06 74.3576C132.156 73.7961 132.389 73.2879 132.757 72.8322C133.125 72.3773 133.678 71.8106 134.414 71.1321C135.072 70.4932 135.594 69.9558 135.983 69.5198C136.37 69.0839 136.704 68.5705 136.986 67.9798C137.266 67.389 137.407 66.7346 137.407 66.0184C137.407 65.0888 137.139 64.2513 136.607 63.5049C136.074 62.7594 135.329 62.1729 134.371 61.7473C133.411 61.3216 132.331 61.1084 131.131 61.1084Z\" fill=\"#B6C5D5\"/>\n</svg>";

var LinealEstablecimientosWarning = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M157.457 39.4555H147.11C146.077 39.4555 145.241 38.618 145.241 37.5861C145.241 36.5543 146.077 35.7168 147.11 35.7168H157.457C158.489 35.7168 159.326 36.5543 159.326 37.5861C159.326 38.618 158.489 39.4555 157.457 39.4555ZM170.824 21.307H155.144C154.111 21.307 153.275 20.4696 153.275 19.4377C153.275 18.4058 154.111 17.5684 155.144 17.5684H170.824C171.856 17.5684 172.694 18.4058 172.694 19.4377C172.694 20.4696 171.856 21.307 170.824 21.307ZM147.751 21.307H144.568C143.535 21.307 142.699 20.4696 142.699 19.4377C142.699 18.4058 143.535 17.5684 144.568 17.5684H147.751C148.783 17.5684 149.621 18.4058 149.621 19.4377C149.621 20.4696 148.783 21.307 147.751 21.307ZM167.805 39.4555H164.621C163.589 39.4555 162.752 38.618 162.752 37.5861C162.752 36.5543 163.589 35.7168 164.621 35.7168H167.805C168.837 35.7168 169.674 36.5543 169.674 37.5861C169.674 38.618 168.837 39.4555 167.805 39.4555ZM179.98 30.3813H171.963C170.931 30.3813 170.094 29.5438 170.094 28.5119C170.094 27.48 170.931 26.6426 171.963 26.6426H179.98C181.012 26.6426 181.849 27.48 181.849 28.5119C181.849 29.5438 181.012 30.3813 179.98 30.3813ZM162.736 30.3813H149.261C148.229 30.3813 147.392 29.5438 147.392 28.5119C147.392 27.48 148.229 26.6426 149.261 26.6426H162.736C163.768 26.6426 164.606 27.48 164.606 28.5119C164.606 29.5438 163.768 30.3813 162.736 30.3813ZM47.6881 39.7362H28.7985C27.7666 39.7362 26.9292 38.8987 26.9292 37.8668C26.9292 36.8349 27.7666 35.9975 28.7985 35.9975H47.6881C48.72 35.9975 49.5575 36.8349 49.5575 37.8668C49.5575 38.8987 48.72 39.7362 47.6881 39.7362ZM19.5112 39.7362H11.8693C10.8375 39.7362 10 38.8987 10 37.8668C10 36.8349 10.8375 35.9975 11.8693 35.9975H19.5112C20.5431 35.9975 21.3805 36.8349 21.3805 37.8668C21.3805 38.8987 20.5431 39.7362 19.5112 39.7362ZM44.5172 30.6623H20.1485C19.1157 30.6623 18.2792 29.8248 18.2792 28.793C18.2792 27.7611 19.1157 26.9236 20.1485 26.9236H44.5172C45.5491 26.9236 46.3865 27.7611 46.3865 28.793C46.3865 29.8248 45.5491 30.6623 44.5172 30.6623ZM39.4103 48.8103H19.5112C18.4784 48.8103 17.6418 47.9728 17.6418 46.941C17.6418 45.9091 18.4784 45.0716 19.5112 45.0716H39.4103C40.4421 45.0716 41.2796 45.9091 41.2796 46.941C41.2796 47.9728 40.4421 48.8103 39.4103 48.8103Z\" fill=\"#B6C5D5\"/>\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M121.218 7.0083C121.845 7.0083 122.429 7.36203 122.735 7.90735L133.352 26.7726C133.513 27.0379 133.586 27.3327 133.586 27.6422C133.586 31.8869 131.048 35.5273 127.431 37.1338C127.446 37.1928 127.446 37.2517 127.446 37.3254V68.2173C127.446 69.19 126.658 69.9859 125.696 69.9859H70.0864C69.1238 69.9859 68.3363 69.19 68.3363 68.2173V37.1043C64.734 35.4978 62.2109 31.8722 62.2109 27.6422C62.2109 27.3327 62.2984 27.0379 62.4443 26.7726L73.0469 7.90735C73.3532 7.34729 73.9366 7.0083 74.5637 7.0083H121.218ZM114.86 33.4197C113.022 36.1758 109.916 37.9886 106.386 37.9886C102.871 37.9886 99.7504 36.1758 97.9128 33.4197C96.0607 36.1758 92.9542 37.9886 89.4249 37.9886C85.8955 37.9886 82.7745 36.1758 80.9369 33.4197C79.0993 36.1758 75.9783 37.9886 72.449 37.9886C72.2448 37.9886 72.0406 37.9886 71.8364 37.9739V66.4634H78.0347V47.3623C78.0347 44.0167 80.7328 41.3048 84.0288 41.3048H89.1186C92.4292 41.3048 95.1127 44.0314 95.1127 47.3623V66.4487H123.945V37.9739L123.348 37.9886C119.818 37.9886 116.697 36.1758 114.86 33.4197ZM89.1332 44.842H84.0434C82.6579 44.842 81.5495 45.9769 81.5495 47.3623V66.4487H91.6271V47.3623C91.6271 45.9622 90.5041 44.842 89.1332 44.842ZM111.563 40.5964C114.447 40.5964 116.792 42.7207 116.792 45.3331V52.6536C116.792 55.266 114.447 57.3904 111.563 57.3904H101.027C98.1438 57.3904 95.799 55.266 95.799 52.6536V45.3331C95.799 42.7207 98.1438 40.5964 101.027 40.5964H111.563ZM111.563 44.0413H101.027C100.251 44.0413 99.6014 44.6155 99.6014 45.3331V52.6536C99.6014 53.357 100.235 53.9455 101.027 53.9455H111.563C112.34 53.9455 112.989 53.3713 112.989 52.6536V45.3331C112.989 44.6298 112.355 44.0413 111.563 44.0413ZM129.983 28.8508H116.726C117.281 32.0343 120.037 34.4514 123.348 34.4514C126.658 34.4514 129.415 32.0195 129.983 28.8508ZM113.007 28.836H99.765C100.319 32.0195 103.076 34.4367 106.386 34.4367C109.697 34.4367 112.453 32.0195 113.007 28.836ZM96.0461 28.836H82.7891C83.3579 32.0195 86.1143 34.4367 89.4249 34.4367C92.7355 34.4367 95.4919 32.0195 96.0461 28.836ZM79.0848 28.836H65.8278C66.382 32.0195 69.1384 34.4514 72.449 34.4367C75.7596 34.4367 78.5306 32.0195 79.0848 28.836ZM120.197 10.5603H75.5846L67.3008 25.3135H128.496L120.197 10.5603Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M119.48 5.13916C120.107 5.13916 120.69 5.49288 120.997 6.03821L131.614 24.9035C131.774 25.1688 131.847 25.4636 131.847 25.7731C131.847 30.0178 129.31 33.6582 125.693 35.2647C125.707 35.3236 125.707 35.3826 125.707 35.4563V66.3482C125.707 67.3209 124.92 68.1168 123.957 68.1168H68.3481C67.3855 68.1168 66.598 67.3209 66.598 66.3482V35.2352C62.9957 33.6287 60.4727 30.003 60.4727 25.7731C60.4727 25.4636 60.5602 25.1688 60.706 24.9035L71.3087 6.03821C71.6149 5.47815 72.1983 5.13916 72.8254 5.13916H119.48ZM113.121 31.5506C111.284 34.3067 108.177 36.1195 104.648 36.1195C101.133 36.1195 98.0122 34.3067 96.1746 31.5506C94.3224 34.3067 91.216 36.1195 87.6866 36.1195C84.1573 36.1195 81.0363 34.3067 79.1987 31.5506C77.3611 34.3067 74.2401 36.1195 70.7107 36.1195C70.5065 36.1195 70.3023 36.1195 70.0982 36.1048V64.5943H76.2964V45.4932C76.2964 42.1475 78.9945 39.4357 82.2905 39.4357H87.3803C90.6909 39.4357 93.3744 42.1623 93.3744 45.4932V64.5795H122.207V36.1048L121.609 36.1195C118.08 36.1195 114.959 34.3067 113.121 31.5506ZM87.3949 42.9729H82.3051C80.9196 42.9729 79.8112 44.1078 79.8112 45.4932V64.5795H89.8888V45.4932C89.8888 44.093 88.7658 42.9729 87.3949 42.9729ZM109.825 38.7272C112.708 38.7272 115.053 40.8516 115.053 43.464V50.7845C115.053 53.3969 112.708 55.5213 109.825 55.5213H99.2891C96.4056 55.5213 94.0607 53.3969 94.0607 50.7845V43.464C94.0607 40.8516 96.4056 38.7272 99.2891 38.7272H109.825ZM109.825 42.1722H99.2891C98.5127 42.1722 97.8631 42.7463 97.8631 43.464V50.7845C97.8631 51.4878 98.4969 52.0763 99.2891 52.0763H109.825C110.601 52.0763 111.251 51.5022 111.251 50.7845V43.464C111.251 42.7607 110.617 42.1722 109.825 42.1722ZM128.245 26.9816H114.988C115.542 30.1651 118.299 32.5823 121.609 32.5823C124.92 32.5823 127.676 30.1504 128.245 26.9816ZM111.269 26.9669H98.0267C98.5809 30.1504 101.337 32.5675 104.648 32.5675C107.959 32.5675 110.715 30.1504 111.269 26.9669ZM94.3078 26.9669H81.0508C81.6196 30.1504 84.376 32.5675 87.6866 32.5675C90.9972 32.5675 93.7536 30.1504 94.3078 26.9669ZM77.3465 26.9669H64.0895C64.6437 30.1504 67.4001 32.5823 70.7107 32.5675C74.0213 32.5675 76.7923 30.1504 77.3465 26.9669ZM118.459 8.69114H73.8463L65.5625 23.4444H126.757L118.459 8.69114Z\" fill=\"#B6C5D5\"/>\n<path d=\"M131.165 92.7677C143.038 92.7677 152.662 83.143 152.662 71.2703C152.662 59.3976 143.038 49.7729 131.165 49.7729C119.292 49.7729 109.667 59.3976 109.667 71.2703C109.667 83.143 119.292 92.7677 131.165 92.7677Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M131 90.1582C141.051 90.1582 149.334 81.8602 149.334 71.8152C149.334 61.7892 141.032 53.4912 131 53.4912C120.95 53.4912 112.667 61.7892 112.667 71.8152C112.667 81.8602 120.969 90.1582 131 90.1582ZM131.308 74.6642C132.136 74.6642 132.646 74.1542 132.646 73.2422L132.901 62.5622C132.921 61.6712 132.221 60.9922 131.287 60.9922C130.332 60.9922 129.673 61.6492 129.695 62.5622L129.928 73.2422C129.949 74.1552 130.438 74.6642 131.308 74.6642ZM131.308 80.9912C130.247 80.9912 129.334 80.1212 129.334 79.0812C129.334 78.0192 130.225 77.1692 131.308 77.1692C132.391 77.1692 133.283 77.9972 133.283 79.0802C133.283 80.1422 132.37 80.9912 131.308 80.9912Z\" fill=\"#FECF2F\"/>\n</svg>";

var LinealLiquidacionesDocumentosGuardados = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_201_180)\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M42.1553 48.3527C43.1782 48.3527 44.0084 49.1829 44.0084 50.2059C44.0084 51.2288 43.1782 52.059 42.1553 52.059H22.4287C21.4049 52.059 20.5756 51.2288 20.5756 50.2059C20.5756 49.1829 21.4049 48.3527 22.4287 48.3527H42.1553ZM50.3614 39.3573C51.3843 39.3573 52.2145 40.1875 52.2145 41.2104C52.2145 42.2333 51.3843 43.0635 50.3614 43.0635H31.6355C30.6126 43.0635 29.7824 42.2333 29.7824 41.2104C29.7824 40.1875 30.6126 39.3573 31.6355 39.3573H50.3614ZM22.4287 39.3573C23.4517 39.3573 24.2819 40.1875 24.2819 41.2104C24.2819 42.2333 23.4517 43.0635 22.4287 43.0635H14.8531C13.8302 43.0635 13 42.2333 13 41.2104C13 40.1875 13.8302 39.3573 14.8531 39.3573H22.4287ZM47.2179 30.3621C48.2409 30.3621 49.0711 31.1923 49.0711 32.2152C49.0711 33.2381 48.2409 34.0683 47.2179 34.0683H23.0605C22.0367 34.0683 21.2074 33.2381 21.2074 32.2152C21.2074 31.1923 22.0367 30.3621 23.0605 30.3621H47.2179ZM159.178 29.8134C160.201 29.8134 161.032 30.6436 161.032 31.6665C161.032 32.6894 160.201 33.5196 159.178 33.5196H148.921C147.898 33.5196 147.068 32.6894 147.068 31.6665C147.068 30.6436 147.898 29.8134 148.921 29.8134H159.178ZM169.437 29.8134C170.46 29.8134 171.29 30.6436 171.29 31.6665C171.29 32.6894 170.46 33.5196 169.437 33.5196H166.281C165.257 33.5196 164.428 32.6894 164.428 31.6665C164.428 30.6436 165.257 29.8134 166.281 29.8134H169.437ZM181.506 20.8178C182.529 20.8178 183.36 21.648 183.36 22.6709C183.36 23.6939 182.529 24.5241 181.506 24.5241H173.559C172.535 24.5241 171.706 23.6939 171.706 22.6709C171.706 21.648 172.535 20.8178 173.559 20.8178H181.506ZM164.412 20.8178C165.435 20.8178 166.265 21.648 166.265 22.6709C166.265 23.6939 165.435 24.5241 164.412 24.5241H151.054C150.031 24.5241 149.201 23.6939 149.201 22.6709C149.201 21.648 150.031 20.8178 151.054 20.8178H164.412ZM172.43 11.8223C173.453 11.8223 174.283 12.6525 174.283 13.6754C174.283 14.6983 173.453 15.5285 172.43 15.5285H156.886C155.862 15.5285 155.033 14.6983 155.033 13.6754C155.033 12.6525 155.862 11.8223 156.886 11.8223H172.43ZM149.557 11.8223C150.58 11.8223 151.41 12.6525 151.41 13.6754C151.41 14.6983 150.58 15.5285 149.557 15.5285H146.401C145.377 15.5285 144.548 14.6983 144.548 13.6754C144.548 12.6525 145.377 11.8223 146.401 11.8223H149.557Z\" fill=\"#B6C5D5\"/>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M102.724 74.1255C102.888 76.4478 103.36 78.685 104.099 80.7966L85.0487 80.7963C81.2056 80.7963 78.0452 77.8711 77.6729 74.1259L102.724 74.1255ZM128.21 7.13623C131.027 8.18589 133.034 10.9006 133.034 14.0837L133.034 46.9417C131.536 46.6704 129.992 46.5287 128.415 46.5287C128.349 46.5287 128.282 46.529 128.215 46.5295L128.215 7.41269C128.215 7.32013 128.214 7.22797 128.21 7.13623Z\" fill=\"#B6C5D5\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M144.722 63.7026L137.859 58.5007C137.508 58.2566 137.323 57.9255 137.323 57.5748C137.323 57.1455 137.531 56.7976 137.882 56.4694C138.659 55.7679 140.056 55.3779 141.288 55.3779C144.517 55.3779 147.065 57.948 147.065 61.1549C147.065 61.9125 146.941 62.6953 146.736 63.147C146.49 63.6408 146.057 63.9691 145.544 63.9691C145.235 63.9691 145.031 63.927 144.722 63.7026ZM117.905 79.193C117.905 78.3934 118.519 77.7593 119.322 77.7593H127.234V66.744C127.234 65.9415 127.851 65.3018 128.651 65.3018C129.453 65.3018 130.09 65.9415 130.09 66.744V79.193C130.09 79.9983 129.453 80.6128 128.651 80.6128H119.322C118.519 80.6128 117.905 79.9983 117.905 79.193ZM144.803 78.3541C144.803 69.4571 137.57 62.2239 128.673 62.2239C119.754 62.2239 112.54 69.4571 112.54 78.3541C112.54 87.2708 119.754 94.4843 128.673 94.4843C137.57 94.4843 144.803 87.2708 144.803 78.3541ZM110.629 63.147C110.405 62.6729 110.282 61.9125 110.282 61.1549C110.282 57.948 112.849 55.3779 116.053 55.3779C117.287 55.3779 118.685 55.7679 119.467 56.4694C119.815 56.7976 120.02 57.1455 120.02 57.5748C120.02 57.9255 119.835 58.2566 119.507 58.5007L112.624 63.7026C112.335 63.927 112.108 63.9691 111.802 63.9691C111.286 63.9691 110.857 63.6577 110.629 63.147ZM111.513 95.1858L114.636 92.0798C111.165 88.5446 109.027 83.6963 109.027 78.3541C109.027 67.5015 117.823 58.6887 128.673 58.6887C139.523 58.6887 148.319 67.5015 148.319 78.3541C148.319 83.6963 146.184 88.5446 142.707 92.0798L145.833 95.1858C146.467 95.7974 146.467 96.8075 145.853 97.4051C145.235 98.0392 144.228 98.0392 143.591 97.3827L140.345 94.1561C137.076 96.5606 133.05 97.9999 128.673 97.9999C124.296 97.9999 120.267 96.5606 117.001 94.1561L113.752 97.3827C113.115 98.0392 112.108 98.0392 111.494 97.4051C110.896 96.8075 110.876 95.7974 111.513 95.1858Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M120.804 0C124.82 0 128.091 3.19489 128.213 7.18165L128.217 7.41252L128.217 46.5293C126.958 46.5388 125.72 46.6387 124.51 46.8227L124.51 7.41252C124.51 5.36852 122.847 3.70626 120.804 3.70626H71.8564C69.8743 3.70626 68.2512 5.2693 68.1546 7.22779L68.1501 7.41252V66.7127C68.1501 68.6947 69.7131 70.3178 71.6716 70.4144L71.8564 70.4189L102.726 70.4191C102.682 71.0351 102.66 71.6571 102.66 72.2843C102.66 72.9036 102.682 73.5179 102.725 74.1263L71.8564 74.1252C67.8391 74.1252 64.5693 70.9303 64.4474 66.9435L64.4438 66.7127V7.41252C64.4438 3.39619 67.6379 0.125519 71.6255 0.00352754L71.8564 0H120.804ZM113.969 37.0074C114.146 37.0074 114.288 37.0607 114.397 37.1691C114.504 37.2775 114.558 37.4201 114.558 37.5969V38.1373C115.148 38.2157 115.701 38.4383 116.219 38.8053C116.317 38.8711 116.387 38.9462 116.43 39.0312C116.472 39.1163 116.494 39.218 116.494 39.3356C116.494 39.4999 116.443 39.6442 116.342 39.7676C116.24 39.8927 116.124 39.9552 115.993 39.9552C115.921 39.9552 115.853 39.9452 115.792 39.9252C115.728 39.906 115.642 39.8635 115.531 39.7976C115.262 39.6275 115.022 39.4999 114.809 39.4148C114.596 39.3298 114.336 39.2864 114.027 39.2864C113.674 39.2864 113.391 39.3656 113.178 39.5224C112.965 39.68 112.859 39.8893 112.859 40.1512C112.859 40.3346 112.921 40.4839 113.046 40.5982C113.17 40.7132 113.328 40.8033 113.517 40.8683C113.707 40.9342 113.972 41.0093 114.312 41.0943C114.79 41.2119 115.182 41.332 115.486 41.4529C115.792 41.5738 116.054 41.7673 116.273 42.0325C116.492 42.2985 116.601 42.6537 116.601 43.0991C116.601 43.6294 116.42 44.0764 116.057 44.44C115.692 44.8036 115.204 45.0379 114.588 45.1421V45.7025C114.588 45.8793 114.534 46.0219 114.426 46.1295C114.317 46.2379 114.175 46.2921 113.998 46.2921C113.828 46.2921 113.687 46.2379 113.575 46.1295C113.464 46.0219 113.408 45.8793 113.408 45.7025V45.1721C113.049 45.1388 112.7 45.0637 112.362 44.9462C112.025 44.8277 111.729 44.6776 111.473 44.4942C111.369 44.4283 111.294 44.3549 111.252 44.2732C111.21 44.1915 111.189 44.0881 111.189 43.9638C111.189 43.7995 111.239 43.6561 111.341 43.531C111.442 43.4068 111.558 43.3451 111.69 43.3451C111.814 43.3451 111.968 43.3976 112.151 43.5018C112.453 43.6786 112.739 43.8079 113.011 43.8896C113.282 43.9713 113.566 44.0122 113.86 44.0122C114.254 44.0122 114.555 43.9388 114.764 43.792C114.974 43.6444 115.079 43.436 115.079 43.1674C115.079 43.004 115.019 42.8697 114.897 42.7647C114.776 42.6604 114.627 42.5779 114.45 42.5195C114.273 42.4603 114.018 42.3852 113.684 42.2935C113.199 42.1684 112.8 42.0442 112.485 41.9199C112.171 41.7957 111.901 41.5989 111.675 41.3303C111.449 41.0618 111.336 40.7016 111.336 40.2496C111.336 39.7192 111.524 39.2639 111.901 38.8836C112.278 38.5042 112.77 38.2616 113.379 38.1565V37.5969C113.379 37.4201 113.434 37.2775 113.546 37.1691C113.658 37.0607 113.799 37.0074 113.969 37.0074ZM80.0421 37.642C82.3928 37.642 84.2992 39.5475 84.2992 41.8991C84.2992 44.2499 82.3928 46.1562 80.0421 46.1562C77.6904 46.1562 75.7841 44.2499 75.7841 41.8991C75.7841 39.5475 77.6904 37.642 80.0421 37.642ZM97.237 43.023C97.9275 43.023 98.4879 43.5826 98.4879 44.2739C98.4879 44.9652 97.9275 45.5247 97.237 45.5247H88.6469C87.9564 45.5247 87.396 44.9652 87.396 44.2739C87.396 43.5826 87.9564 43.023 88.6469 43.023H97.237ZM105.827 38.8522C106.517 38.8522 107.078 39.4118 107.078 40.1031C107.078 40.7944 106.517 41.3539 105.827 41.3539H88.6467C87.9563 41.3539 87.3959 40.7944 87.3959 40.1031C87.3959 39.4118 87.9563 38.8522 88.6467 38.8522H105.827ZM113.969 24.2976C114.146 24.2976 114.288 24.351 114.397 24.4594C114.504 24.5678 114.558 24.7104 114.558 24.8872V25.4275C115.148 25.5059 115.701 25.7286 116.219 26.0955C116.317 26.1614 116.387 26.2364 116.43 26.3215C116.472 26.4065 116.494 26.5083 116.494 26.6259C116.494 26.7901 116.443 26.9344 116.342 27.0578C116.24 27.1829 116.124 27.2455 115.993 27.2455C115.921 27.2455 115.853 27.2354 115.792 27.2154C115.728 27.1963 115.642 27.1537 115.531 27.0878C115.262 26.9177 115.022 26.7901 114.809 26.7051C114.596 26.62 114.336 26.5767 114.027 26.5767C113.674 26.5767 113.391 26.6559 113.178 26.8127C112.965 26.9703 112.859 27.1796 112.859 27.4414C112.859 27.6249 112.921 27.7742 113.046 27.8884C113.17 28.0035 113.328 28.0935 113.517 28.1586C113.707 28.2245 113.972 28.2995 114.312 28.3846C114.79 28.5022 115.182 28.6222 115.486 28.7432C115.792 28.8641 116.054 29.0575 116.273 29.3227C116.492 29.5887 116.601 29.944 116.601 30.3893C116.601 30.9197 116.42 31.3666 116.057 31.7302C115.692 32.0938 115.204 32.3281 114.588 32.4324V32.9928C114.588 33.1695 114.534 33.3121 114.426 33.4197C114.317 33.5281 114.175 33.5823 113.998 33.5823C113.828 33.5823 113.687 33.5281 113.575 33.4197C113.464 33.3121 113.408 33.1695 113.408 32.9928V32.4624C113.049 32.429 112.7 32.354 112.362 32.2364C112.025 32.118 111.729 31.9679 111.473 31.7844C111.369 31.7185 111.294 31.6452 111.252 31.5634C111.21 31.4817 111.189 31.3783 111.189 31.2541C111.189 31.0898 111.239 30.9463 111.341 30.8213C111.442 30.697 111.558 30.6353 111.69 30.6353C111.814 30.6353 111.968 30.6878 112.151 30.7921C112.453 30.9689 112.739 31.0981 113.011 31.1798C113.282 31.2616 113.566 31.3024 113.86 31.3024C114.254 31.3024 114.555 31.229 114.764 31.0823C114.974 30.9347 115.079 30.7262 115.079 30.4577C115.079 30.2942 115.019 30.16 114.897 30.0549C114.776 29.9507 114.627 29.8681 114.45 29.8097C114.273 29.7505 114.018 29.6755 113.684 29.5837C113.199 29.4586 112.8 29.3344 112.485 29.2101C112.171 29.0859 111.901 28.8891 111.675 28.6206C111.449 28.3521 111.336 27.9918 111.336 27.5398C111.336 27.0095 111.524 26.5541 111.901 26.1739C112.278 25.7945 112.77 25.5518 113.379 25.4467V24.8872C113.379 24.7104 113.434 24.5678 113.546 24.4594C113.658 24.351 113.799 24.2976 113.969 24.2976ZM80.0421 24.9319C82.3928 24.9319 84.2992 26.8382 84.2992 29.189C84.2992 31.5406 82.3928 33.4461 80.0421 33.4461C77.6904 33.4461 75.7841 31.5406 75.7841 29.189C75.7841 26.8382 77.6904 24.9319 80.0421 24.9319ZM97.237 30.3132C97.9275 30.3132 98.4879 30.8728 98.4879 31.5641C98.4879 32.2554 97.9275 32.815 97.237 32.815H88.6469C87.9564 32.815 87.396 32.2554 87.396 31.5641C87.396 30.8728 87.9564 30.3132 88.6469 30.3132H97.237ZM105.827 26.142C106.517 26.142 107.078 26.7016 107.078 27.3929C107.078 28.0842 106.517 28.6438 105.827 28.6438H88.6467C87.9563 28.6438 87.3959 28.0842 87.3959 27.3929C87.3959 26.7016 87.9563 26.142 88.6467 26.142H105.827ZM113.969 11.5878C114.146 11.5878 114.288 11.6412 114.397 11.7496C114.504 11.858 114.558 12.0006 114.558 12.1774V12.7178C115.148 12.7962 115.701 13.0188 116.219 13.3857C116.317 13.4516 116.387 13.5267 116.43 13.6117C116.472 13.6968 116.494 13.7985 116.494 13.9161C116.494 14.0804 116.443 14.2246 116.342 14.3481C116.24 14.4731 116.124 14.5357 115.993 14.5357C115.921 14.5357 115.853 14.5257 115.792 14.5057C115.728 14.4865 115.642 14.444 115.531 14.3781C115.262 14.208 115.022 14.0804 114.809 13.9953C114.596 13.9103 114.336 13.8669 114.027 13.8669C113.674 13.8669 113.391 13.9461 113.178 14.1029C112.965 14.2605 112.859 14.4698 112.859 14.7317C112.859 14.9151 112.921 15.0644 113.046 15.1786C113.17 15.2937 113.328 15.3838 113.517 15.4488C113.707 15.5147 113.972 15.5898 114.312 15.6748C114.79 15.7924 115.182 15.9125 115.486 16.0334C115.792 16.1543 116.054 16.3478 116.273 16.613C116.492 16.879 116.601 17.2342 116.601 17.6795C116.601 18.2099 116.42 18.6569 116.057 19.0204C115.692 19.384 115.204 19.6184 114.588 19.7226V20.283C114.588 20.4598 114.534 20.6024 114.426 20.7099C114.317 20.8184 114.175 20.8726 113.998 20.8726C113.828 20.8726 113.687 20.8184 113.575 20.7099C113.464 20.6024 113.408 20.4598 113.408 20.283V19.7526C113.049 19.7193 112.7 19.6442 112.362 19.5266C112.025 19.4082 111.729 19.2581 111.473 19.0747C111.369 19.0088 111.294 18.9354 111.252 18.8537C111.21 18.7719 111.189 18.6685 111.189 18.5443C111.189 18.38 111.239 18.2366 111.341 18.1115C111.442 17.9872 111.558 17.9255 111.69 17.9255C111.814 17.9255 111.968 17.9781 112.151 18.0823C112.453 18.2591 112.739 18.3883 113.011 18.4701C113.282 18.5518 113.566 18.5927 113.86 18.5927C114.254 18.5927 114.555 18.5193 114.764 18.3725C114.974 18.2249 115.079 18.0164 115.079 17.7479C115.079 17.5845 115.019 17.4502 114.897 17.3451C114.776 17.2409 114.627 17.1583 114.45 17.1C114.273 17.0408 114.018 16.9657 113.684 16.874C113.199 16.7489 112.8 16.6246 112.485 16.5004C112.171 16.3761 111.901 16.1793 111.675 15.9108C111.449 15.6423 111.336 15.282 111.336 14.8301C111.336 14.2997 111.524 13.8444 111.901 13.4641C112.278 13.0847 112.77 12.842 113.379 12.7369V12.1774C113.379 12.0006 113.434 11.858 113.546 11.7496C113.658 11.6412 113.799 11.5878 113.969 11.5878ZM80.0421 12.2221C82.3928 12.2221 84.2992 14.1284 84.2992 16.4792C84.2992 18.8308 82.3928 20.7363 80.0421 20.7363C77.6904 20.7363 75.7841 18.8308 75.7841 16.4792C75.7841 14.1284 77.6904 12.2221 80.0421 12.2221ZM97.237 17.6031C97.9275 17.6031 98.4879 18.1626 98.4879 18.8539C98.4879 19.5452 97.9275 20.1048 97.237 20.1048H88.6469C87.9564 20.1048 87.396 19.5452 87.396 18.8539C87.396 18.1626 87.9564 17.6031 88.6469 17.6031H97.237ZM105.827 13.4323C106.517 13.4323 107.078 13.9918 107.078 14.6831C107.078 15.3744 106.517 15.934 105.827 15.934H88.6467C87.9563 15.934 87.3959 15.3744 87.3959 14.6831C87.3959 13.9918 87.9563 13.4323 88.6467 13.4323H105.827Z\" fill=\"#B6C5D5\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_201_180\">\n<rect width=\"192\" height=\"98\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var LinealLiquidacionesEmpty = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M40.4652 55.417C40.9818 55.4182 41.4779 55.6193 41.8495 55.9781C42.2212 56.3369 42.4396 56.8256 42.459 57.3419C42.4784 57.8582 42.2973 58.3619 41.9536 58.7476C41.6098 59.1333 41.1302 59.371 40.6152 59.411L40.4652 59.417H19.1752C18.6562 59.4193 18.1566 59.2198 17.782 58.8606C17.4074 58.5014 17.1871 58.0107 17.1676 57.492C17.1481 56.9734 17.331 56.4675 17.6776 56.0812C18.0243 55.695 18.5075 55.4586 19.0252 55.422L19.1752 55.417H40.4652ZM49.3222 45.708C49.8411 45.7056 50.3407 45.9052 50.7153 46.2643C51.0899 46.6235 51.3102 47.1143 51.3297 47.6329C51.3492 48.1515 51.1663 48.6574 50.8197 49.0437C50.473 49.43 49.9898 49.6664 49.4722 49.703L49.3222 49.708H29.1122C28.5955 49.7067 28.0994 49.5057 27.7278 49.1468C27.3561 48.788 27.1377 48.2993 27.1183 47.783C27.0989 47.2668 27.28 46.763 27.6237 46.3774C27.9675 45.9917 28.4471 45.7539 28.9622 45.714L29.1122 45.709H49.3222V45.708ZM19.1752 45.708C19.6941 45.7056 20.1937 45.9052 20.5683 46.2643C20.9429 46.6235 21.1632 47.1143 21.1827 47.6329C21.2022 48.1515 21.0193 48.6574 20.6727 49.0437C20.326 49.43 19.8428 49.6664 19.3252 49.703L19.1752 49.708H11.0002C10.4835 49.7067 9.98743 49.5057 9.61576 49.1468C9.24409 48.788 9.02568 48.2993 9.00629 47.783C8.9869 47.2668 9.16804 46.763 9.51175 46.3774C9.85546 45.9917 10.3351 45.7539 10.8502 45.714L11.0002 45.709H19.1752V45.708ZM155.922 40.211C156.441 40.2086 156.941 40.4082 157.315 40.7673C157.69 41.1265 157.91 41.6173 157.93 42.1359C157.949 42.6545 157.766 43.1604 157.42 43.5467C157.073 43.933 156.59 44.1694 156.072 44.206L155.922 44.211H144.852C144.333 44.2133 143.834 44.0138 143.459 43.6546C143.084 43.2954 142.864 42.8046 142.845 42.286C142.825 41.7674 143.008 41.2615 143.355 40.8752C143.701 40.489 144.184 40.2526 144.702 40.216L144.852 40.211H155.922ZM166.993 40.211C167.512 40.2086 168.012 40.4082 168.386 40.7673C168.761 41.1265 168.981 41.6173 169.001 42.1359C169.02 42.6545 168.837 43.1604 168.491 43.5467C168.144 43.933 167.661 44.1694 167.143 44.206L166.993 44.211H163.587C163.068 44.213 162.569 44.0133 162.195 43.654C161.82 43.2948 161.6 42.8041 161.581 42.2855C161.561 41.767 161.744 41.2612 162.091 40.8751C162.437 40.4889 162.921 40.2526 163.438 40.216L163.588 40.211H166.993ZM45.9302 36C46.449 35.9979 46.9484 36.1976 47.3228 36.5569C47.6972 36.9162 47.9173 37.4069 47.9366 37.9254C47.956 38.4439 47.773 38.9497 47.4265 39.3358C47.0799 39.722 46.5967 39.9584 46.0792 39.995L45.9292 40H19.8582C19.3392 40.0023 18.8396 39.8028 18.465 39.4436C18.0904 39.0844 17.8701 38.5937 17.8506 38.075C17.8311 37.5564 18.014 37.0505 18.3606 36.6642C18.7073 36.278 19.1905 36.0416 19.7082 36.005L19.8582 36H45.9302ZM180.02 30.502C180.539 30.4996 181.039 30.6992 181.413 31.0583C181.788 31.4175 182.008 31.9083 182.028 32.4269C182.047 32.9455 181.864 33.4514 181.518 33.8377C181.171 34.224 180.688 34.4604 180.17 34.497L180.02 34.502H171.444C170.928 34.5007 170.431 34.2997 170.06 33.9408C169.688 33.582 169.47 33.0933 169.45 32.577C169.431 32.0608 169.612 31.557 169.956 31.1714C170.299 30.7857 170.779 30.5479 171.294 30.508L171.444 30.502H180.021H180.02ZM161.572 30.502C162.091 30.4999 162.59 30.6996 162.965 31.0589C163.339 31.4182 163.559 31.9089 163.579 32.4274C163.598 32.9459 163.415 33.4517 163.068 33.8378C162.722 34.224 162.239 34.4604 161.721 34.497L161.571 34.502H147.155C146.639 34.5007 146.142 34.2997 145.771 33.9408C145.399 33.582 145.181 33.0933 145.161 32.577C145.142 32.0608 145.323 31.557 145.667 31.1714C146.01 30.7857 146.49 30.5479 147.005 30.508L147.155 30.502H161.572ZM170.225 20.794C170.744 20.7919 171.243 20.9916 171.618 21.3509C171.992 21.7102 172.212 22.2009 172.232 22.7194C172.251 23.2379 172.068 23.7437 171.721 24.1298C171.375 24.516 170.892 24.7524 170.374 24.789L170.224 24.794H153.448C152.932 24.7925 152.436 24.5912 152.064 24.2323C151.693 23.8734 151.475 23.3847 151.455 22.8685C151.436 22.3524 151.617 21.8487 151.961 21.4632C152.305 21.0776 152.784 20.8399 153.299 20.8L153.449 20.794H170.224H170.225ZM145.539 20.794C146.058 20.7916 146.558 20.9912 146.932 21.3503C147.307 21.7095 147.527 22.2003 147.547 22.7189C147.566 23.2375 147.383 23.7434 147.037 24.1297C146.69 24.516 146.207 24.7524 145.689 24.789L145.539 24.794H142.132C141.616 24.7925 141.12 24.5912 140.748 24.2323C140.377 23.8734 140.158 23.3847 140.139 22.8685C140.12 22.3524 140.301 21.8487 140.645 21.4632C140.989 21.0776 141.468 20.8399 141.983 20.8L142.133 20.794H145.539Z\" fill=\"#B6C5D5\"/>\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M128.244 10.709C128.247 10.806 128.259 10.901 128.259 11.001V75.001C128.259 77.1227 127.416 79.1575 125.916 80.6578C124.416 82.1581 122.381 83.001 120.259 83.001H73.7109C73.9093 84.9743 74.8335 86.8036 76.3043 88.134C77.7751 89.4644 79.6877 90.201 81.6709 90.201H125.459C127.581 90.201 129.616 89.3581 131.116 87.8578C132.616 86.3576 133.459 84.3227 133.459 82.201V18.201C133.459 14.762 131.287 11.841 128.244 10.709Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M120.259 3C122.338 3.00002 124.334 3.80894 125.827 5.25547C127.319 6.702 128.19 8.67259 128.255 10.75L128.259 11V75C128.259 77.0784 127.45 79.0753 126.004 80.5677C124.557 82.0602 122.587 82.9311 120.509 82.996L120.259 83H67.4321C65.3537 83 63.3569 82.1911 61.8644 80.7445C60.372 79.298 59.5011 77.3274 59.4361 75.25L59.4321 75V11C59.4322 8.92157 60.2411 6.92474 61.6876 5.4323C63.1341 3.93985 65.1047 3.06895 67.1821 3.004L67.4321 3H120.259V3ZM120.259 7H67.4321C66.4062 7.00122 65.4199 7.39606 64.6766 8.1031C63.9333 8.81014 63.4896 9.77546 63.4371 10.8L63.4321 11V75C63.4321 77.14 65.1201 78.89 67.2321 78.995L67.4321 79H120.259C121.285 78.9988 122.271 78.6039 123.015 77.8969C123.758 77.1899 124.202 76.2245 124.254 75.2L124.259 75V11C124.259 8.794 122.464 7 120.259 7ZM112.721 57.738C112.911 57.738 113.065 57.796 113.181 57.913C113.274 58.006 113.331 58.123 113.35 58.263L113.357 58.373V58.957C114.005 59.0467 114.62 59.2947 115.149 59.679C115.245 59.7387 115.324 59.8224 115.378 59.922C115.426 60.0251 115.449 60.1376 115.446 60.251C115.448 60.4211 115.39 60.5866 115.282 60.718C115.172 60.852 115.046 60.918 114.905 60.918C114.832 60.9192 114.758 60.9087 114.688 60.887C114.59 60.8511 114.496 60.8048 114.407 60.749C114.16 60.5885 113.899 60.4503 113.627 60.336C113.358 60.2373 113.072 60.1905 112.785 60.198C112.403 60.198 112.097 60.283 111.867 60.453C111.758 60.5286 111.669 60.6302 111.609 60.7485C111.549 60.8669 111.52 60.9983 111.523 61.131C111.523 61.329 111.589 61.49 111.723 61.614C111.858 61.738 112.028 61.834 112.233 61.904C112.438 61.976 112.723 62.057 113.092 62.149C113.608 62.276 114.031 62.406 114.359 62.536C114.688 62.666 114.969 62.875 115.208 63.162C115.444 63.448 115.563 63.832 115.563 64.312C115.563 64.885 115.367 65.368 114.973 65.76C114.631 66.103 114.183 66.34 113.631 66.469L113.389 66.518V67.122C113.393 67.207 113.379 67.2918 113.349 67.3713C113.319 67.4507 113.273 67.5231 113.213 67.584C113.153 67.6431 113.08 67.6892 113.001 67.7193C112.922 67.7494 112.838 67.7629 112.753 67.759C112.669 67.7618 112.585 67.7477 112.507 67.7177C112.428 67.6876 112.357 67.6422 112.296 67.584C112.2 67.4899 112.139 67.3656 112.124 67.232L112.117 67.122V66.55C111.732 66.5156 111.352 66.4337 110.987 66.306C110.645 66.1902 110.322 66.0259 110.027 65.818C109.928 65.7606 109.846 65.6777 109.789 65.578C109.739 65.4742 109.715 65.36 109.719 65.245C109.719 65.069 109.775 64.913 109.884 64.779C109.994 64.645 110.119 64.578 110.26 64.578C110.395 64.578 110.56 64.634 110.759 64.747C111.085 64.937 111.393 65.077 111.687 65.166C111.98 65.254 112.286 65.299 112.604 65.299C113.028 65.299 113.353 65.219 113.58 65.059C113.689 64.9851 113.778 64.8847 113.837 64.7671C113.897 64.6495 113.925 64.5187 113.92 64.387C113.922 64.3043 113.906 64.2223 113.871 64.147C113.837 64.0716 113.787 64.005 113.723 63.952C113.581 63.8328 113.418 63.7428 113.241 63.687C112.968 63.5988 112.692 63.5175 112.414 63.443C111.975 63.3348 111.543 63.2003 111.12 63.04C110.779 62.9053 110.478 62.6865 110.245 62.404C110.001 62.114 109.879 61.724 109.879 61.237C109.879 60.664 110.082 60.173 110.489 59.763C110.844 59.404 111.296 59.159 111.844 59.027L112.084 58.977V58.374C112.08 58.2888 112.094 58.2038 112.125 58.1244C112.156 58.045 112.204 57.973 112.264 57.913C112.325 57.8546 112.396 57.8091 112.475 57.779C112.553 57.7489 112.637 57.735 112.721 57.738ZM75.1051 58.88C76.2018 58.88 77.2536 59.3157 78.029 60.0911C78.8045 60.8666 79.2401 61.9183 79.2401 63.015C79.2401 64.1117 78.8045 65.1634 78.029 65.9389C77.2536 66.7143 76.2018 67.15 75.1051 67.15C74.0085 67.15 72.9567 66.7143 72.1812 65.9389C71.4058 65.1634 70.9701 64.1117 70.9701 63.015C70.9701 61.9183 71.4058 60.8666 72.1812 60.0911C72.9567 59.3157 74.0085 58.88 75.1051 58.88ZM94.6621 64.229C95.0077 64.2308 95.3394 64.3651 95.5889 64.6041C95.8384 64.8431 95.9868 65.1687 96.0034 65.5139C96.0201 65.859 95.9038 66.1974 95.6784 66.4594C95.4531 66.7213 95.1359 66.8869 94.7921 66.922L94.6621 66.928H85.3921C85.0466 66.9262 84.7149 66.7919 84.4654 66.5529C84.2158 66.3139 84.0675 65.9883 84.0508 65.6431C84.0342 65.298 84.1505 64.9596 84.3758 64.6976C84.6012 64.4357 84.9184 64.2701 85.2621 64.235L85.3921 64.229H94.6621ZM103.934 59.727C104.281 59.7263 104.616 59.8594 104.867 60.0987C105.119 60.338 105.269 60.6651 105.285 61.0119C105.302 61.3588 105.185 61.6988 104.957 61.9612C104.73 62.2236 104.41 62.3883 104.064 62.421L103.934 62.427H85.3921C85.0449 62.4277 84.7106 62.2946 84.459 62.0553C84.2073 61.816 84.0575 61.4889 84.0408 61.1421C84.0241 60.7952 84.1416 60.4552 84.3691 60.1928C84.5966 59.9304 84.9164 59.7657 85.2621 59.733L85.3921 59.727H103.934ZM112.721 43.869C112.911 43.869 113.065 43.928 113.181 44.044C113.274 44.138 113.331 44.254 113.35 44.395L113.357 44.505V45.089C114.005 45.1784 114.62 45.426 115.149 45.81C115.245 45.8697 115.324 45.9534 115.378 46.053C115.426 46.1564 115.449 46.2693 115.446 46.383C115.448 46.5528 115.39 46.7178 115.282 46.849C115.172 46.983 115.046 47.05 114.905 47.05C114.832 47.0509 114.758 47.0401 114.688 47.018C114.59 46.9824 114.496 46.9365 114.407 46.881C114.16 46.7205 113.899 46.5823 113.627 46.468C113.358 46.369 113.072 46.3218 112.785 46.329C112.403 46.329 112.097 46.415 111.867 46.585C111.758 46.6606 111.669 46.7622 111.609 46.8805C111.549 46.9989 111.52 47.1303 111.523 47.263C111.523 47.46 111.589 47.621 111.723 47.745C111.858 47.869 112.028 47.966 112.233 48.036C112.438 48.108 112.723 48.189 113.092 48.281C113.608 48.408 114.031 48.538 114.359 48.668C114.688 48.798 114.969 49.007 115.208 49.294C115.444 49.579 115.563 49.964 115.563 50.444C115.563 51.016 115.367 51.5 114.973 51.891C114.631 52.234 114.183 52.471 113.631 52.601L113.389 52.65V53.253C113.393 53.3381 113.38 53.4232 113.349 53.5028C113.319 53.5825 113.273 53.655 113.213 53.716C113.153 53.7751 113.08 53.8212 113.001 53.8513C112.922 53.8814 112.838 53.8949 112.753 53.891C112.669 53.8938 112.585 53.8797 112.507 53.8497C112.428 53.8196 112.357 53.7742 112.296 53.716C112.2 53.6219 112.139 53.4976 112.124 53.364L112.117 53.254V52.681C111.732 52.6466 111.352 52.5647 110.987 52.437C110.645 52.3212 110.322 52.1569 110.027 51.949C109.928 51.8919 109.846 51.8094 109.789 51.71C109.739 51.6059 109.715 51.4913 109.719 51.376C109.719 51.201 109.775 51.044 109.884 50.91C109.994 50.777 110.119 50.71 110.26 50.71C110.395 50.71 110.56 50.766 110.759 50.879C111.085 51.069 111.393 51.209 111.687 51.297C111.98 51.385 112.286 51.43 112.604 51.43C113.028 51.43 113.353 51.35 113.58 51.192C113.689 51.118 113.778 51.0174 113.837 50.8996C113.897 50.7819 113.925 50.6508 113.92 50.519C113.922 50.4362 113.906 50.3539 113.872 50.2784C113.838 50.2029 113.787 50.1361 113.723 50.083C113.581 49.9638 113.418 49.8738 113.241 49.818C112.968 49.7298 112.692 49.6485 112.414 49.574C111.975 49.4658 111.543 49.3313 111.12 49.171C110.779 49.0363 110.478 48.8175 110.245 48.535C110.001 48.245 109.879 47.857 109.879 47.369C109.879 46.796 110.082 46.305 110.489 45.895C110.844 45.535 111.296 45.291 111.844 45.159L112.084 45.109V44.506C112.08 44.4207 112.094 44.3355 112.125 44.2559C112.156 44.1763 112.203 44.1041 112.264 44.044C112.325 43.9856 112.396 43.9401 112.475 43.91C112.553 43.8799 112.637 43.866 112.721 43.869ZM75.1051 45.013C76.2018 45.013 77.2536 45.4487 78.029 46.2241C78.8045 46.9996 79.2401 48.0513 79.2401 49.148C79.2401 50.2447 78.8045 51.2964 78.029 52.0719C77.2536 52.8474 76.2018 53.283 75.1051 53.283C74.0085 53.283 72.9567 52.8474 72.1812 52.0719C71.4058 51.2964 70.9701 50.2447 70.9701 49.148C70.9701 48.0513 71.4058 46.9996 72.1812 46.2241C72.9567 45.4487 74.0085 45.013 75.1051 45.013ZM94.6631 50.361C95.0104 50.3603 95.3446 50.4934 95.5963 50.7327C95.8479 50.972 95.9977 51.2991 96.0145 51.6459C96.0312 51.9928 95.9136 52.3328 95.6862 52.5952C95.4587 52.8576 95.1389 53.0223 94.7931 53.055L94.6631 53.062H85.3921C85.0449 53.0627 84.7106 52.9296 84.459 52.6903C84.2073 52.451 84.0575 52.1239 84.0408 51.7771C84.0241 51.4302 84.1416 51.0902 84.3691 50.8278C84.5966 50.5654 84.9164 50.4007 85.2621 50.368L85.3921 50.361H94.6621H94.6631ZM103.933 45.86C104.28 45.8593 104.615 45.9924 104.866 46.2317C105.118 46.471 105.268 46.7981 105.284 47.1449C105.301 47.4918 105.184 47.8318 104.956 48.0942C104.729 48.3566 104.409 48.5213 104.063 48.554L103.933 48.56H85.3931C85.0459 48.5607 84.7116 48.4276 84.46 48.1883C84.2083 47.949 84.0585 47.6219 84.0418 47.2751C84.0251 46.9282 84.1426 46.5882 84.3701 46.3258C84.5976 46.0634 84.9174 45.8987 85.2631 45.866L85.3931 45.86H103.935H103.933ZM112.721 30.002C112.911 30.002 113.065 30.06 113.181 30.177C113.274 30.271 113.331 30.387 113.35 30.528L113.357 30.638V31.221C114.005 31.3107 114.62 31.5587 115.149 31.943C115.245 32.0027 115.324 32.0864 115.378 32.186C115.426 32.2894 115.449 32.4023 115.446 32.516C115.448 32.6858 115.39 32.8508 115.282 32.982C115.172 33.116 115.046 33.183 114.905 33.183C114.832 33.1839 114.758 33.1731 114.688 33.151C114.59 33.1151 114.496 33.0688 114.407 33.013C114.16 32.8525 113.899 32.7143 113.627 32.6C113.358 32.5013 113.072 32.4545 112.785 32.462C112.403 32.462 112.097 32.547 111.867 32.717C111.758 32.7926 111.669 32.8942 111.609 33.0125C111.549 33.1309 111.52 33.2623 111.523 33.395C111.523 33.593 111.589 33.755 111.723 33.878C111.858 34.002 112.028 34.099 112.233 34.169C112.438 34.24 112.723 34.321 113.092 34.413C113.608 34.54 114.031 34.67 114.359 34.8C114.688 34.931 114.969 35.14 115.208 35.426C115.444 35.712 115.563 36.096 115.563 36.576C115.563 37.149 115.367 37.632 114.973 38.024C114.631 38.367 114.183 38.604 113.631 38.734L113.389 38.782V39.386C113.393 39.471 113.379 39.5558 113.349 39.6353C113.319 39.7147 113.273 39.7871 113.213 39.848C113.153 39.9071 113.08 39.9532 113.001 39.9833C112.922 40.0134 112.838 40.0269 112.753 40.023C112.669 40.0258 112.585 40.0117 112.507 39.9817C112.428 39.9516 112.357 39.9062 112.296 39.848C112.2 39.7539 112.139 39.6296 112.124 39.496L112.117 39.386V38.814C111.732 38.7796 111.352 38.6977 110.987 38.57C110.645 38.4542 110.322 38.2899 110.027 38.082C109.928 38.0249 109.846 37.9424 109.789 37.843C109.739 37.7389 109.715 37.6243 109.719 37.509C109.719 37.333 109.775 37.177 109.884 37.043C109.994 36.909 110.119 36.843 110.26 36.843C110.395 36.843 110.56 36.898 110.759 37.011C111.085 37.202 111.393 37.342 111.687 37.431C111.98 37.518 112.286 37.563 112.604 37.563C113.028 37.563 113.353 37.483 113.58 37.324C113.689 37.25 113.778 37.1494 113.837 37.0316C113.897 36.9139 113.925 36.7828 113.92 36.651C113.922 36.5683 113.906 36.4863 113.871 36.411C113.837 36.3356 113.787 36.269 113.723 36.216C113.581 36.0968 113.418 36.0068 113.241 35.951C112.968 35.8628 112.692 35.7815 112.414 35.707C111.975 35.5988 111.543 35.4643 111.12 35.304C110.779 35.1693 110.478 34.9505 110.245 34.668C110.001 34.378 109.879 33.989 109.879 33.501C109.879 32.928 110.082 32.437 110.489 32.027C110.844 31.669 111.296 31.424 111.844 31.292L112.084 31.242V30.638C112.08 30.553 112.094 30.4682 112.125 30.389C112.156 30.3097 112.204 30.2379 112.264 30.178C112.325 30.1195 112.396 30.0737 112.475 30.0435C112.553 30.0132 112.637 29.9991 112.721 30.002ZM75.1051 31.146C76.2018 31.146 77.2536 31.5816 78.029 32.3571C78.8045 33.1326 79.2401 34.1843 79.2401 35.281C79.2401 36.3777 78.8045 37.4294 78.029 38.2049C77.2536 38.9804 76.2018 39.416 75.1051 39.416C74.0085 39.416 72.9567 38.9804 72.1812 38.2049C71.4058 37.4294 70.9701 36.3777 70.9701 35.281C70.9701 34.1843 71.4058 33.1326 72.1812 32.3571C72.9567 31.5816 74.0085 31.146 75.1051 31.146ZM94.6631 36.494C95.0104 36.4933 95.3446 36.6264 95.5963 36.8657C95.8479 37.105 95.9977 37.4321 96.0145 37.7789C96.0312 38.1258 95.9136 38.4658 95.6862 38.7282C95.4587 38.9906 95.1389 39.1553 94.7931 39.188L94.6631 39.194H85.3921C85.0466 39.1922 84.7149 39.0579 84.4654 38.8189C84.2158 38.5799 84.0675 38.2543 84.0508 37.9091C84.0342 37.564 84.1505 37.2256 84.3758 36.9636C84.6012 36.7017 84.9184 36.5361 85.2621 36.501L85.3921 36.494H94.6621H94.6631ZM103.933 31.993C104.28 31.9923 104.615 32.1254 104.866 32.3647C105.118 32.604 105.268 32.9311 105.284 33.2779C105.301 33.6248 105.184 33.9648 104.956 34.2272C104.729 34.4896 104.409 34.6543 104.063 34.687L103.933 34.693H85.3931C85.0459 34.6937 84.7116 34.5606 84.46 34.3213C84.2083 34.082 84.0585 33.7549 84.0418 33.4081C84.0251 33.0612 84.1426 32.7212 84.3701 32.4588C84.5976 32.1964 84.9174 32.0317 85.2631 31.999L85.3931 31.993H103.935H103.933ZM112.721 16.135C112.911 16.135 113.065 16.194 113.181 16.31C113.275 16.403 113.331 16.52 113.35 16.662L113.357 16.772V17.355C114.005 17.444 114.62 17.6913 115.149 18.075C115.245 18.1353 115.324 18.2198 115.377 18.32C115.425 18.4224 115.449 18.5348 115.446 18.648C115.448 18.8182 115.39 18.9836 115.282 19.115C115.172 19.249 115.046 19.317 114.905 19.317C114.832 19.3176 114.758 19.3064 114.688 19.284C114.59 19.2481 114.496 19.2022 114.407 19.147C114.16 18.9857 113.899 18.8471 113.627 18.733C113.358 18.6341 113.072 18.5873 112.785 18.595C112.403 18.595 112.097 18.68 111.867 18.85C111.758 18.9258 111.669 19.0276 111.609 19.1461C111.549 19.2646 111.52 19.3962 111.523 19.529C111.523 19.726 111.589 19.887 111.723 20.011C111.858 20.135 112.028 20.231 112.233 20.301C112.438 20.373 112.723 20.455 113.092 20.547C113.608 20.674 114.031 20.803 114.359 20.933C114.688 21.063 114.969 21.273 115.208 21.559C115.444 21.845 115.563 22.229 115.563 22.709C115.563 23.282 115.367 23.765 114.973 24.157C114.631 24.501 114.183 24.737 113.631 24.866L113.389 24.915V25.52C113.393 25.6046 113.379 25.6891 113.349 25.7683C113.319 25.8474 113.272 25.9195 113.213 25.98C113.152 26.0394 113.08 26.0856 113.001 26.1159C112.922 26.1462 112.837 26.1598 112.752 26.156C112.668 26.1587 112.585 26.1445 112.506 26.1145C112.428 26.0844 112.357 26.0391 112.296 25.981C112.2 25.8873 112.139 25.7633 112.124 25.63L112.117 25.52V24.947C111.732 24.9126 111.352 24.8307 110.987 24.703C110.646 24.5871 110.322 24.4231 110.027 24.216C109.928 24.1586 109.846 24.0757 109.789 23.976C109.74 23.8722 109.716 23.758 109.719 23.643C109.719 23.466 109.775 23.311 109.884 23.176C109.994 23.042 110.119 22.975 110.26 22.975C110.395 22.975 110.56 23.031 110.759 23.144C111.084 23.334 111.393 23.474 111.687 23.563C111.98 23.652 112.286 23.696 112.604 23.696C113.028 23.696 113.353 23.616 113.58 23.456C113.689 23.382 113.777 23.2815 113.837 23.1639C113.896 23.0463 113.924 22.9156 113.919 22.784C113.921 22.7014 113.905 22.6194 113.871 22.5441C113.837 22.4687 113.786 22.402 113.723 22.349C113.581 22.2302 113.417 22.1402 113.241 22.084C112.968 21.9958 112.692 21.9145 112.414 21.84C111.975 21.7325 111.543 21.5979 111.12 21.437C110.779 21.3023 110.478 21.0835 110.245 20.801C110 20.511 109.878 20.121 109.878 19.634C109.878 19.062 110.082 18.571 110.488 18.16C110.844 17.802 111.296 17.557 111.843 17.425L112.083 17.375V16.772C112.083 16.581 112.143 16.427 112.265 16.31C112.326 16.2519 112.397 16.2066 112.475 16.1765C112.554 16.1465 112.637 16.1323 112.721 16.135ZM75.1051 17.28C76.2018 17.28 77.2536 17.7157 78.029 18.4911C78.8045 19.2666 79.2401 20.3183 79.2401 21.415C79.2401 22.5117 78.8045 23.5634 78.029 24.3389C77.2536 25.1143 76.2018 25.55 75.1051 25.55C74.0085 25.55 72.9567 25.1143 72.1812 24.3389C71.4058 23.5634 70.9701 22.5117 70.9701 21.415C70.9701 20.3183 71.4058 19.2666 72.1812 18.4911C72.9567 17.7157 74.0085 17.28 75.1051 17.28ZM94.6631 22.628C95.0104 22.6273 95.3446 22.7604 95.5963 22.9997C95.8479 23.239 95.9977 23.5661 96.0145 23.9129C96.0312 24.2598 95.9136 24.5998 95.6862 24.8622C95.4587 25.1246 95.1389 25.2893 94.7931 25.322L94.6631 25.328H85.3921C85.0449 25.3287 84.7106 25.1956 84.459 24.9563C84.2073 24.717 84.0575 24.3899 84.0408 24.0431C84.0241 23.6962 84.1416 23.3562 84.3691 23.0938C84.5966 22.8314 84.9164 22.6667 85.2621 22.634L85.3921 22.628H94.6621H94.6631ZM103.933 18.126C104.28 18.1253 104.615 18.2584 104.866 18.4977C105.118 18.737 105.268 19.0641 105.284 19.4109C105.301 19.7578 105.184 20.0978 104.956 20.3602C104.729 20.6226 104.409 20.7873 104.063 20.82L103.933 20.826H85.3931C85.0476 20.8242 84.7159 20.6899 84.4664 20.4509C84.2168 20.2119 84.0685 19.8863 84.0518 19.5411C84.0352 19.196 84.1515 18.8576 84.3768 18.5956C84.6022 18.3337 84.9194 18.1681 85.2631 18.133L85.3931 18.127H103.935L103.933 18.126Z\" fill=\"#B6C5D5\"/>\n</svg>";

var LinealLiquidacionesError = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M35.466 55.185C36.57 55.185 37.466 56.081 37.466 57.185C37.466 58.289 36.57 59.185 35.466 59.185H14.176C13.071 59.185 12.176 58.289 12.176 57.185C12.176 56.081 13.071 55.185 14.176 55.185H35.466ZM44.3225 45.4766C45.4265 45.4766 46.3225 46.3726 46.3225 47.4766C46.3225 48.5806 45.4265 49.4766 44.3225 49.4766H24.1125C23.0085 49.4766 22.1125 48.5806 22.1125 47.4766C22.1125 46.3726 23.0085 45.4766 24.1125 45.4766H44.3225ZM14.176 45.4766C15.28 45.4766 16.176 46.3726 16.176 47.4766C16.176 48.5806 15.28 49.4766 14.176 49.4766H6C4.896 49.4766 4 48.5806 4 47.4766C4 46.3726 4.896 45.4766 6 45.4766H14.176ZM40.9299 35.7685C42.0339 35.7685 42.9299 36.6645 42.9299 37.7685C42.9299 38.8725 42.0339 39.7685 40.9299 39.7685H14.8579C13.7529 39.7685 12.8579 38.8725 12.8579 37.7685C12.8579 36.6645 13.7529 35.7685 14.8579 35.7685H40.9299ZM161.764 35.1763C162.868 35.1763 163.764 36.0723 163.764 37.1763C163.764 38.2803 162.868 39.1763 161.764 39.1763H150.694C149.589 39.1763 148.694 38.2803 148.694 37.1763C148.694 36.0723 149.589 35.1763 150.694 35.1763H161.764ZM172.835 35.1763C173.939 35.1763 174.835 36.0723 174.835 37.1763C174.835 38.2803 173.939 39.1763 172.835 39.1763H169.429C168.324 39.1763 167.429 38.2803 167.429 37.1763C167.429 36.0723 168.324 35.1763 169.429 35.1763H172.835ZM185.861 25.4678C186.965 25.4678 187.861 26.3638 187.861 27.4678C187.861 28.5718 186.965 29.4678 185.861 29.4678H177.285C176.18 29.4678 175.285 28.5718 175.285 27.4678C175.285 26.3638 176.18 25.4678 177.285 25.4678H185.861ZM167.412 25.4678C168.516 25.4678 169.412 26.3638 169.412 27.4678C169.412 28.5718 168.516 29.4678 167.412 29.4678H152.995C151.891 29.4678 150.995 28.5718 150.995 27.4678C150.995 26.3638 151.891 25.4678 152.995 25.4678H167.412ZM176.066 15.7593C177.17 15.7593 178.066 16.6553 178.066 17.7593C178.066 18.8633 177.17 19.7593 176.066 19.7593H159.29C158.185 19.7593 157.29 18.8633 157.29 17.7593C157.29 16.6553 158.185 15.7593 159.29 15.7593H176.066ZM151.38 15.7593C152.484 15.7593 153.38 16.6553 153.38 17.7593C153.38 18.8633 152.484 19.7593 151.38 19.7593H147.974C146.869 19.7593 145.974 18.8633 145.974 17.7593C145.974 16.6553 146.869 15.7593 147.974 15.7593H151.38Z\" fill=\"#B6C5D5\"/>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M100.836 83.0002C101.013 85.5065 101.522 87.921 102.32 90.2L81.7592 90.1997C77.6115 90.1997 74.2007 87.0426 73.7988 83.0007L100.836 83.0002ZM128.342 10.7017C131.382 11.8345 133.547 14.7644 133.547 18.1997L133.548 53.662C131.93 53.3691 130.264 53.2162 128.563 53.2162C128.491 53.2162 128.419 53.2165 128.347 53.217L128.347 11C128.347 10.9001 128.345 10.8007 128.342 10.7017Z\" fill=\"#B6C5D5\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M120.348 3C124.683 3 128.213 6.4481 128.344 10.7508L128.348 11L128.348 53.217C126.989 53.2273 125.654 53.3351 124.348 53.5337L124.348 11C124.348 8.794 122.553 7 120.348 7H67.521C65.3818 7 63.6301 8.68692 63.5259 10.8006L63.521 11V75C63.521 77.1392 65.2079 78.8909 67.3216 78.9951L67.521 79L100.837 79.0002C100.79 79.665 100.766 80.3363 100.766 81.0132C100.766 81.6816 100.789 82.3445 100.836 83.0011L67.521 83C63.1854 83 59.6564 79.5519 59.5248 75.2492L59.521 75V11C59.521 6.66536 62.9681 3.13547 67.2718 3.00381L67.521 3H120.348ZM112.971 42.9404C113.162 42.9404 113.316 42.998 113.433 43.115C113.549 43.232 113.607 43.3859 113.607 43.5767V44.1599C114.244 44.2445 114.84 44.4848 115.399 44.8808C115.505 44.9519 115.581 45.0329 115.627 45.1247C115.673 45.2165 115.696 45.3263 115.696 45.4532C115.696 45.6305 115.641 45.7862 115.532 45.9194C115.423 46.0544 115.297 46.1219 115.155 46.1219C115.078 46.1219 115.005 46.1111 114.938 46.0895C114.87 46.0688 114.777 46.0229 114.657 45.9518C114.367 45.7682 114.108 45.6305 113.878 45.5387C113.648 45.4469 113.367 45.4001 113.034 45.4001C112.653 45.4001 112.347 45.4856 112.118 45.6548C111.887 45.8249 111.773 46.0508 111.773 46.3334C111.773 46.5314 111.84 46.6925 111.975 46.8158C112.109 46.94 112.279 47.0372 112.483 47.1074C112.688 47.1785 112.975 47.2595 113.342 47.3513C113.858 47.4782 114.281 47.6078 114.609 47.7383C114.938 47.8688 115.221 48.0776 115.458 48.3638C115.694 48.6509 115.812 49.0343 115.812 49.5149C115.812 50.0873 115.617 50.5697 115.225 50.9621C114.831 51.3545 114.304 51.6074 113.639 51.7199V52.3247C113.639 52.5155 113.581 52.6694 113.464 52.7855C113.347 52.9025 113.193 52.961 113.003 52.961C112.819 52.961 112.667 52.9025 112.546 52.7855C112.427 52.6694 112.366 52.5155 112.366 52.3247V51.7523C111.978 51.7163 111.601 51.6353 111.237 51.5084C110.873 51.3806 110.554 51.2186 110.277 51.0206C110.165 50.9495 110.085 50.8703 110.039 50.7821C109.994 50.6939 109.97 50.5823 109.97 50.4482C109.97 50.2709 110.025 50.1161 110.135 49.9811C110.244 49.847 110.369 49.7804 110.511 49.7804C110.645 49.7804 110.812 49.8371 111.009 49.9496C111.335 50.1404 111.644 50.2799 111.938 50.3681C112.23 50.4563 112.536 50.5004 112.854 50.5004C113.279 50.5004 113.604 50.4212 113.83 50.2628C114.056 50.1035 114.169 49.8785 114.169 49.5887C114.169 49.4123 114.104 49.2674 113.973 49.154C113.842 49.0415 113.681 48.9524 113.49 48.8894C113.3 48.8255 113.024 48.7445 112.663 48.6455C112.14 48.5105 111.709 48.3764 111.37 48.2423C111.031 48.1082 110.739 47.8958 110.495 47.606C110.251 47.3162 110.13 46.9274 110.13 46.4396C110.13 45.8672 110.332 45.3758 110.739 44.9654C111.146 44.5559 111.678 44.294 112.335 44.1806V43.5767C112.335 43.3859 112.394 43.232 112.515 43.115C112.635 42.998 112.787 42.9404 112.971 42.9404ZM76.3554 43.6254C78.8925 43.6254 80.95 45.6819 80.95 48.2199C80.95 50.757 78.8925 52.8144 76.3554 52.8144C73.8174 52.8144 71.76 50.757 71.76 48.2199C71.76 45.6819 73.8174 43.6254 76.3554 43.6254ZM94.9132 49.4328C95.6584 49.4328 96.2632 50.0367 96.2632 50.7828C96.2632 51.5289 95.6584 52.1328 94.9132 52.1328H85.6423C84.8971 52.1328 84.2923 51.5289 84.2923 50.7828C84.2923 50.0367 84.8971 49.4328 85.6423 49.4328H94.9132ZM104.184 44.9314C104.929 44.9314 105.534 45.5354 105.534 46.2815C105.534 47.0276 104.929 47.6315 104.184 47.6315H85.6421C84.8969 47.6315 84.2921 47.0276 84.2921 46.2815C84.2921 45.5354 84.8969 44.9314 85.6421 44.9314H104.184ZM112.971 29.2233C113.162 29.2233 113.316 29.2809 113.433 29.3979C113.549 29.5149 113.607 29.6688 113.607 29.8596V30.4428C114.244 30.5274 114.84 30.7677 115.399 31.1637C115.505 31.2348 115.581 31.3158 115.627 31.4076C115.673 31.4994 115.696 31.6092 115.696 31.7361C115.696 31.9134 115.641 32.0691 115.532 32.2023C115.423 32.3373 115.297 32.4048 115.155 32.4048C115.078 32.4048 115.005 32.394 114.938 32.3724C114.87 32.3517 114.777 32.3058 114.657 32.2347C114.367 32.0511 114.108 31.9134 113.878 31.8216C113.648 31.7298 113.367 31.683 113.034 31.683C112.653 31.683 112.347 31.7685 112.118 31.9377C111.887 32.1078 111.773 32.3337 111.773 32.6163C111.773 32.8143 111.84 32.9754 111.975 33.0987C112.109 33.2229 112.279 33.3201 112.483 33.3903C112.688 33.4614 112.975 33.5424 113.342 33.6342C113.858 33.7611 114.281 33.8907 114.609 34.0212C114.938 34.1517 115.221 34.3605 115.458 34.6467C115.694 34.9338 115.812 35.3172 115.812 35.7978C115.812 36.3702 115.617 36.8526 115.225 37.245C114.831 37.6374 114.304 37.8903 113.639 38.0028V38.6076C113.639 38.7984 113.581 38.9523 113.464 39.0684C113.347 39.1854 113.193 39.2439 113.003 39.2439C112.819 39.2439 112.667 39.1854 112.546 39.0684C112.427 38.9523 112.366 38.7984 112.366 38.6076V38.0352C111.978 37.9992 111.601 37.9182 111.237 37.7913C110.873 37.6635 110.554 37.5015 110.277 37.3035C110.165 37.2324 110.085 37.1532 110.039 37.065C109.994 36.9768 109.97 36.8652 109.97 36.7311C109.97 36.5538 110.025 36.399 110.135 36.264C110.244 36.1299 110.369 36.0633 110.511 36.0633C110.645 36.0633 110.812 36.12 111.009 36.2325C111.335 36.4233 111.644 36.5628 111.938 36.651C112.23 36.7392 112.536 36.7833 112.854 36.7833C113.279 36.7833 113.604 36.7041 113.83 36.5457C114.056 36.3864 114.169 36.1614 114.169 35.8716C114.169 35.6952 114.104 35.5503 113.973 35.4369C113.842 35.3244 113.681 35.2353 113.49 35.1723C113.3 35.1084 113.024 35.0274 112.663 34.9284C112.14 34.7934 111.709 34.6593 111.37 34.5252C111.031 34.3911 110.739 34.1787 110.495 33.8889C110.251 33.5991 110.13 33.2103 110.13 32.7225C110.13 32.1501 110.332 31.6587 110.739 31.2483C111.146 30.8388 111.678 30.5769 112.335 30.4635V29.8596C112.335 29.6688 112.394 29.5149 112.515 29.3979C112.635 29.2809 112.787 29.2233 112.971 29.2233ZM76.3554 29.9078C78.8925 29.9078 80.95 31.9652 80.95 34.5023C80.95 37.0403 78.8925 39.0968 76.3554 39.0968C73.8174 39.0968 71.76 37.0403 71.76 34.5023C71.76 31.9652 73.8174 29.9078 76.3554 29.9078ZM94.9132 35.7157C95.6584 35.7157 96.2632 36.3196 96.2632 37.0657C96.2632 37.8118 95.6584 38.4157 94.9132 38.4157H85.6423C84.8971 38.4157 84.2923 37.8118 84.2923 37.0657C84.2923 36.3196 84.8971 35.7157 85.6423 35.7157H94.9132ZM104.184 31.2139C104.929 31.2139 105.534 31.8178 105.534 32.5639C105.534 33.31 104.929 33.9139 104.184 33.9139H85.6421C84.8969 33.9139 84.2921 33.31 84.2921 32.5639C84.2921 31.8178 84.8969 31.2139 85.6421 31.2139H104.184ZM112.971 15.5062C113.162 15.5062 113.316 15.5638 113.433 15.6808C113.549 15.7978 113.607 15.9517 113.607 16.1425V16.7257C114.244 16.8103 114.84 17.0506 115.399 17.4466C115.505 17.5177 115.581 17.5987 115.627 17.6905C115.673 17.7823 115.696 17.8921 115.696 18.019C115.696 18.1963 115.641 18.352 115.532 18.4852C115.423 18.6202 115.297 18.6877 115.155 18.6877C115.078 18.6877 115.005 18.6769 114.938 18.6553C114.87 18.6346 114.777 18.5887 114.657 18.5176C114.367 18.334 114.108 18.1963 113.878 18.1045C113.648 18.0127 113.367 17.9659 113.034 17.9659C112.653 17.9659 112.347 18.0514 112.118 18.2206C111.887 18.3907 111.773 18.6166 111.773 18.8992C111.773 19.0972 111.84 19.2583 111.975 19.3816C112.109 19.5058 112.279 19.603 112.483 19.6732C112.688 19.7443 112.975 19.8253 113.342 19.9171C113.858 20.044 114.281 20.1736 114.609 20.3041C114.938 20.4346 115.221 20.6434 115.458 20.9296C115.694 21.2167 115.812 21.6001 115.812 22.0807C115.812 22.6531 115.617 23.1355 115.225 23.5279C114.831 23.9203 114.304 24.1732 113.639 24.2857V24.8905C113.639 25.0813 113.581 25.2352 113.464 25.3513C113.347 25.4683 113.193 25.5268 113.003 25.5268C112.819 25.5268 112.667 25.4683 112.546 25.3513C112.427 25.2352 112.366 25.0813 112.366 24.8905V24.3181C111.978 24.2821 111.601 24.2011 111.237 24.0742C110.873 23.9464 110.554 23.7844 110.277 23.5864C110.165 23.5153 110.085 23.4361 110.039 23.3479C109.994 23.2597 109.97 23.1481 109.97 23.014C109.97 22.8367 110.025 22.6819 110.135 22.5469C110.244 22.4128 110.369 22.3462 110.511 22.3462C110.645 22.3462 110.812 22.4029 111.009 22.5154C111.335 22.7062 111.644 22.8457 111.938 22.9339C112.23 23.0221 112.536 23.0662 112.854 23.0662C113.279 23.0662 113.604 22.987 113.83 22.8286C114.056 22.6693 114.169 22.4443 114.169 22.1545C114.169 21.9781 114.104 21.8332 113.973 21.7198C113.842 21.6073 113.681 21.5182 113.49 21.4552C113.3 21.3913 113.024 21.3103 112.663 21.2113C112.14 21.0763 111.709 20.9422 111.37 20.8081C111.031 20.674 110.739 20.4616 110.495 20.1718C110.251 19.882 110.13 19.4932 110.13 19.0054C110.13 18.433 110.332 17.9416 110.739 17.5312C111.146 17.1217 111.678 16.8598 112.335 16.7464V16.1425C112.335 15.9517 112.394 15.7978 112.515 15.6808C112.635 15.5638 112.787 15.5062 112.971 15.5062ZM76.3554 16.1908C78.8925 16.1908 80.95 18.2482 80.95 20.7853C80.95 23.3233 78.8925 25.3798 76.3554 25.3798C73.8174 25.3798 71.76 23.3233 71.76 20.7853C71.76 18.2482 73.8174 16.1908 76.3554 16.1908ZM94.9132 21.9982C95.6584 21.9982 96.2632 22.6021 96.2632 23.3482C96.2632 24.0943 95.6584 24.6982 94.9132 24.6982H85.6423C84.8971 24.6982 84.2923 24.0943 84.2923 23.3482C84.2923 22.6021 84.8971 21.9982 85.6423 21.9982H94.9132ZM104.184 17.4968C104.929 17.4968 105.534 18.1007 105.534 18.8468C105.534 19.5929 104.929 20.1968 104.184 20.1968H85.6421C84.8969 20.1968 84.2921 19.5929 84.2921 18.8468C84.2921 18.1007 84.8969 17.4968 85.6421 17.4968H104.184Z\" fill=\"#B6C5D5\"/>\n<path d=\"M125.125 92.8438C134.082 92.8438 141.344 85.5823 141.344 76.6248C141.344 67.6673 134.082 60.4058 125.125 60.4058C116.167 60.4058 108.906 67.6673 108.906 76.6248C108.906 85.5823 116.167 92.8438 125.125 92.8438Z\" fill=\"white\"/>\n<path d=\"M125.125 94.6547C135.005 94.6547 143.145 86.4947 143.145 76.6147C143.145 66.7547 134.985 58.5947 125.125 58.5947C115.245 58.5947 107.105 66.7547 107.105 76.6147C107.105 86.4947 115.265 94.6547 125.125 94.6547ZM118.645 84.4167C117.909 84.4167 117.342 83.8307 117.342 83.1137C117.342 82.7537 117.475 82.4337 117.72 82.2067L123.274 76.6337L117.72 71.0617C117.475 70.8347 117.342 70.5137 117.342 70.1547C117.342 69.4187 117.909 68.8707 118.646 68.8707C119.005 68.8707 119.307 69.0027 119.553 69.2487L125.125 74.8017L130.716 69.2487C130.981 68.9647 131.283 68.8327 131.623 68.8327C132.341 68.8327 132.926 69.4187 132.926 70.1357C132.926 70.4957 132.813 70.7787 132.53 71.0427L126.957 76.6337L132.53 82.1687C132.775 82.4337 132.908 82.7357 132.908 83.1137C132.908 83.8307 132.341 84.4167 131.604 84.4167C131.226 84.4167 130.905 84.2657 130.66 84.0197L125.125 78.4667L119.571 84.0197C119.345 84.2657 119.005 84.4167 118.646 84.4167H118.645Z\" fill=\"#DD2457\"/>\n</svg>";

var LinealMailConfirmado = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g opacity=\"0.6\">\n<path opacity=\"0.6\" d=\"M154.087 22.0432C153.156 22.0432 152.4 21.2779 152.4 20.3356C152.4 19.3932 153.156 18.628 154.087 18.628L171.132 18.628C172.063 18.628 172.819 19.3932 172.819 20.3356C172.819 21.2779 172.063 22.0432 171.132 22.0432L154.087 22.0432ZM11.3498 30.0446C10.4178 30.0446 9.66277 29.2803 9.66277 28.338C9.66277 27.3956 10.4178 26.6304 11.3498 26.6304L25.4978 26.6304C26.4288 26.6304 27.1848 27.3956 27.1848 28.338C27.1848 29.2793 26.4288 30.0446 25.4978 30.0446L11.3498 30.0446ZM32.1678 30.0446C31.2378 30.0446 30.4818 29.2803 30.4818 28.338C30.4818 27.3956 31.2368 26.6304 32.1678 26.6304H35.0418C35.9738 26.6304 36.7288 27.3956 36.7288 28.338C36.7288 29.2793 35.9738 30.0446 35.0418 30.0446H32.1678ZM174.679 30.1569C173.749 30.1569 172.993 29.3927 172.993 28.4503C172.993 27.507 173.748 26.7428 174.679 26.7428H181.573C182.504 26.7428 183.26 27.507 183.26 28.4503C183.26 29.3917 182.504 30.1569 181.573 30.1569H174.679ZM145.536 30.1569C144.604 30.1569 143.85 29.3927 143.85 28.4503C143.85 27.507 144.604 26.7428 145.536 26.7428H167.524C168.454 26.7428 169.21 27.507 169.21 28.4503C169.21 29.3917 168.455 30.1569 167.524 30.1569H145.536ZM148.559 38.2717C147.628 38.2717 146.872 37.5065 146.872 36.5641C146.872 35.6217 147.628 34.8565 148.559 34.8565H151.952C152.884 34.8565 153.639 35.6217 153.639 36.5641C153.639 37.5065 152.884 38.2717 151.952 38.2717H148.559ZM159.009 38.2717C158.079 38.2717 157.323 37.5065 157.323 36.5641C157.323 35.6217 158.078 34.8565 159.009 34.8565H176.964C177.896 34.8565 178.651 35.6217 178.651 36.5641C178.651 37.5065 177.896 38.2717 176.964 38.2717H159.009ZM31.0108 38.467C30.0798 38.467 29.3238 37.7018 29.3238 36.7595C29.3238 35.8181 30.0798 35.0519 31.0108 35.0519H40.3468C41.2788 35.0519 42.0338 35.8171 42.0338 36.7595C42.0338 37.7018 41.2788 38.467 40.3468 38.467H31.0108ZM21.6728 38.467C20.7428 38.467 19.9868 37.7018 19.9868 36.7595C19.9868 35.8181 20.7418 35.0519 21.6728 35.0519H24.5458C25.4778 35.0519 26.2328 35.8171 26.2328 36.7595C26.2328 37.7018 25.4778 38.467 24.5458 38.467H21.6728ZM10.6858 46.7549C9.75577 46.7549 8.99976 45.9897 8.99976 45.0473C8.99976 44.105 9.75476 43.3397 10.6858 43.3397H17.9198C18.8518 43.3397 19.6068 44.105 19.6068 45.0473C19.6068 45.9897 18.8518 46.7549 17.9198 46.7549H10.6858ZM26.2458 46.7549C25.3148 46.7549 24.5588 45.9897 24.5588 45.0473C24.5588 44.105 25.3148 43.3397 26.2458 43.3397L38.4048 43.3397C39.3348 43.3397 40.0918 44.105 40.0918 45.0473C40.0918 45.9897 39.3358 46.7549 38.4048 46.7549L26.2458 46.7549Z\" fill=\"#B6C5D5\"/>\n</g>\n<path d=\"M120.259 8C127.036 8 130.532 11.5376 130.532 18.3244V42.3246C130.024 42.2942 129.511 42.278 128.994 42.278C128.121 42.278 127.257 42.3225 126.406 42.4106V18.3649C126.406 17.8335 126.373 17.3365 126.306 16.878L104.894 38.0926L114.114 47.1993C113.028 48.004 112.008 48.8957 111.064 49.8634L102.027 40.9176L99.4419 43.4997C97.1389 45.7589 94.9019 46.6476 92.6989 46.6476C90.4999 46.6476 88.2629 45.7589 85.9929 43.4997L83.4129 40.9176L61.3359 62.7709C62.2759 63.2972 63.4299 63.5483 64.8269 63.5483H104.141C103.914 64.9178 103.796 66.3237 103.794 67.759L64.9319 67.758C58.1219 67.758 54.6309 64.2527 54.6309 57.3982V18.3254C54.6289 11.5042 58.0829 8 64.2289 8H120.259ZM58.8839 16.6644C58.8219 17.1624 58.7459 17.7272 58.7459 18.3649V57.3597C58.7459 58.1026 58.8219 58.7737 58.9599 59.377L80.5409 38.0936L58.8839 16.6644ZM120.331 12.1753H64.8259C63.3239 12.1753 62.0649 12.4941 61.1209 13.0924L88.4439 40.3194C89.9029 41.8012 91.3769 42.443 92.6979 42.443C94.0619 42.443 95.4929 41.8397 96.9949 40.3194L124.213 13.233C123.197 12.5275 121.9 12.1753 120.331 12.1753Z\" fill=\"#B6C5D5\"/>\n<path d=\"M130.119 87.6143C140.889 87.6143 149.619 78.7774 149.619 67.8765C149.619 56.9756 140.889 48.1387 130.119 48.1387C119.35 48.1387 110.619 56.9756 110.619 67.8765C110.619 78.7774 119.35 87.6143 130.119 87.6143Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M129.619 89.6386C141.679 89.6386 151.619 79.5602 151.619 67.3582C151.619 55.1805 141.657 45.1021 129.619 45.1021C117.559 45.1021 107.619 55.1805 107.619 67.3582C107.619 79.5602 117.581 89.6386 129.619 89.6386ZM126.682 78.2454C126.022 78.2454 125.528 77.9873 124.987 77.3314L118.323 69.2935C118.04 68.919 117.852 68.4736 117.852 68.0283C117.852 67.1132 118.582 66.4341 119.429 66.4341C119.971 66.4341 120.442 66.6446 120.913 67.2307L126.588 74.3322L137.302 57.3871C137.679 56.8 138.197 56.4963 138.692 56.4963C139.539 56.4963 140.363 57.0591 140.363 57.9731C140.363 58.3102 140.213 58.6776 140.02 59.0035L128.283 77.3081C127.859 77.9407 127.318 78.2454 126.682 78.2454Z\" fill=\"#1AAAAD\"/>\n</svg>";

var LinealMailCreado = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g opacity=\"0.6\">\n<path opacity=\"0.6\" d=\"M18.921 50.9141C19.853 50.9141 20.607 51.6701 20.607 52.6011C20.607 53.5321 19.853 54.2881 18.921 54.2881H11.687C10.756 54.2881 10 53.5321 10 52.6011C10 51.6701 10.756 50.9141 11.687 50.9141H18.921ZM39.406 50.9141C40.336 50.9141 41.092 51.6701 41.092 52.6011C41.092 53.5321 40.337 54.2881 39.406 54.2881H27.246C26.316 54.2881 25.56 53.5321 25.56 52.6011C25.56 51.6701 26.316 50.9141 27.247 50.9141H39.406ZM150.952 49.9141C151.884 49.9141 152.639 50.6701 152.639 51.6011C152.639 52.5321 151.884 53.2881 150.952 53.2881H147.558C146.628 53.2881 145.872 52.5321 145.872 51.6011C145.872 50.6701 146.627 49.9141 147.558 49.9141H150.952ZM175.965 49.9141C176.896 49.9141 177.651 50.6701 177.651 51.6011C177.651 52.5321 176.896 53.2881 175.965 53.2881H158.009C157.078 53.2881 156.322 52.5321 156.322 51.6011C156.322 50.6701 157.078 49.9141 158.009 49.9141H175.965ZM41.346 42.6221C42.278 42.6221 43.033 43.3771 43.033 44.3081C43.033 45.2391 42.278 45.9951 41.346 45.9951H32.011C31.081 45.9951 30.325 45.2391 30.325 44.3081C30.325 43.3781 31.08 42.6221 32.011 42.6221H41.346ZM25.546 42.6221C26.478 42.6221 27.232 43.3771 27.232 44.3081C27.232 45.2391 26.478 45.9951 25.546 45.9951H22.673C21.742 45.9951 20.986 45.2391 20.986 44.3081C20.986 43.3781 21.742 42.6221 22.673 42.6221H25.546ZM179.401 41.6221C180.331 41.6221 181.088 42.3771 181.088 43.3081C181.088 44.2391 180.332 44.9951 179.401 44.9951H172.506C171.576 44.9951 170.819 44.2391 170.819 43.3081C170.819 42.3781 171.575 41.6221 172.506 41.6221H179.401ZM164.807 41.6221C165.649 41.6221 166.333 42.3771 166.333 43.3081C166.333 44.2391 165.649 44.9951 164.807 44.9951H144.923C144.08 44.9951 143.397 44.2391 143.397 43.3081C143.397 42.3781 144.08 41.6221 144.923 41.6221H164.807ZM26.499 34.4061C27.429 34.4061 28.186 35.1621 28.186 36.0931C28.186 37.0231 27.43 37.7791 26.499 37.7791H12.35C11.418 37.7791 10.664 37.0241 10.664 36.0931C10.664 35.1621 11.418 34.4061 12.35 34.4061H26.499ZM36.042 34.4061C36.974 34.4061 37.729 35.1621 37.729 36.0931C37.729 37.0231 36.974 37.7791 36.042 37.7791H33.169C32.238 37.7791 31.482 37.0241 31.482 36.0931C31.482 35.1621 32.238 34.4061 33.169 34.4061H36.042ZM169.338 33.3291C170.384 33.3291 171.233 34.0851 171.233 35.0161C171.233 35.9461 170.383 36.7021 169.338 36.7021H150.192C149.146 36.7021 148.298 35.9471 148.298 35.0161C148.298 34.0851 149.146 33.3291 150.192 33.3291H169.338Z\" fill=\"#B6C5D5\"/>\n</g>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" d=\"M135.548 35.2471V70.8731C135.548 77.5771 132.06 81.0651 125.29 81.0651H70.01C64.244 81.0651 60.857 78.5811 59.957 73.7281C61.539 74.6161 63.56 75.0651 66.01 75.0651H121.29C128.06 75.0651 131.548 71.5771 131.548 64.8731V29.2471C131.548 27.8191 131.476 26.6391 131.296 25.6201C134.659 28.2681 135.548 30.2211 135.548 35.2471Z\" fill=\"#B6C5D5\"/>\n</g>\n<path d=\"M127.309 24.77L105.895 45.73L127.231 66.55C127.341 66.02 127.408 65.429 127.408 64.804V26.24C127.408 25.715 127.374 25.224 127.308 24.771L127.309 24.77ZM121.333 70.88C122.802 70.88 124.023 70.598 125 70.006L103.028 48.521L100.443 51.072C98.1399 53.304 95.9029 54.182 93.6999 54.182C91.5009 54.182 89.2639 53.304 86.9939 51.072L84.4139 48.521L62.3369 70.111C63.2769 70.631 64.4309 70.879 65.8279 70.879H121.333V70.88ZM93.6999 50.027C95.0639 50.027 96.4949 49.431 97.9969 47.929L125.215 21.169C124.199 20.472 122.902 20.124 121.333 20.124H65.8279C64.3259 20.124 63.0669 20.439 62.1229 21.03L89.4459 47.93C90.9049 49.394 92.3789 50.028 93.6999 50.028V50.027ZM59.9609 66.758L81.5419 45.731L59.8859 24.56C59.8239 25.05 59.7479 25.609 59.7479 26.238V64.764C59.7479 65.498 59.8239 66.161 59.9619 66.757L59.9609 66.758ZM55.6309 64.803V26.201C55.6309 19.462 59.0849 16 65.2309 16H121.261C128.037 16 131.533 19.495 131.533 26.2V64.803C131.533 71.547 128.071 75.038 121.923 75.038H65.9329C59.1219 75.038 55.6309 71.575 55.6309 64.803Z\" fill=\"#B6C5D5\"/>\n</svg>";

var LinealMailWarning = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g opacity=\"0.6\">\n<path d=\"M22.7447 57.3374C23.0299 57.3374 23.2775 57.4443 23.4913 57.6572C23.7033 57.8711 23.8112 58.1148 23.8112 58.3894C23.8112 58.6746 23.6994 58.9279 23.4778 59.1505L21.8266 60.8017L23.3439 62.294C23.5655 62.5156 23.6782 62.769 23.6782 63.0532C23.6782 63.3374 23.5723 63.5859 23.3642 63.7998C23.1551 64.0127 22.9085 64.1196 22.6243 64.1196C22.3227 64.1196 22.0617 63.9944 21.8382 63.7458L20.4123 62.294L18.974 63.7458C18.7428 63.9867 18.4807 64.1062 18.1879 64.1062C17.9037 64.1062 17.658 64.0011 17.4489 63.7931C17.2408 63.584 17.1358 63.3422 17.1358 63.0667C17.1358 62.7825 17.2476 62.5252 17.4682 62.294L18.9875 60.8017L17.3362 59.1495C17.1146 58.9279 17.0019 58.6746 17.0019 58.3904C17.0019 58.1148 17.1098 57.8701 17.3218 57.6582C17.5356 57.4443 17.7842 57.3374 18.0684 57.3374C18.3622 57.3374 18.6233 57.4578 18.8545 57.6977L20.4133 59.3229L21.9586 57.6977C22.1898 57.4568 22.4518 57.3374 22.7447 57.3374ZM51.8218 53.9462C52.1069 53.9462 52.3545 54.0532 52.5684 54.267C52.7803 54.48 52.8882 54.7247 52.8882 54.9992C52.8882 55.2834 52.7765 55.5368 52.554 55.7593L50.9037 57.4106L52.421 58.9038C52.6426 59.1254 52.7553 59.3788 52.7553 59.663C52.7553 59.9472 52.6493 60.1958 52.4412 60.4087C52.2322 60.6216 51.9855 60.7285 51.7014 60.7285C51.3998 60.7285 51.1387 60.6033 50.9152 60.3557L49.4894 58.9029L48.0511 60.3557C47.8198 60.5956 47.5578 60.715 47.2649 60.715C46.9807 60.715 46.7351 60.611 46.526 60.4019C46.3179 60.1938 46.2129 59.951 46.2129 59.6755C46.2129 59.3913 46.3247 59.1341 46.5453 58.9029L48.0645 57.4106L46.4133 55.7593C46.1917 55.5378 46.079 55.2834 46.079 54.9992C46.079 54.7247 46.1869 54.48 46.3988 54.267C46.6118 54.0532 46.8613 53.9472 47.1455 53.9472C47.4393 53.9472 47.7004 54.0667 47.9316 54.3065L49.4904 55.9318L51.0356 54.3065C51.2669 54.0667 51.5289 53.9472 51.8218 53.9472V53.9462ZM155.059 42.3489C155.344 42.3489 155.589 42.4549 155.799 42.6678C156.007 42.8817 156.111 43.1302 156.111 43.4144C156.111 43.6986 156 43.952 155.777 44.1736L154.259 45.6669L155.91 47.3181C156.132 47.5397 156.245 47.7931 156.245 48.0773C156.245 48.3528 156.136 48.5975 155.924 48.8094C155.712 49.0233 155.461 49.1302 155.178 49.1302C154.885 49.1302 154.623 49.0098 154.391 48.7699L152.847 47.1447L151.288 48.7699C151.056 49.0108 150.797 49.1302 150.501 49.1302C150.217 49.1302 149.97 49.0243 149.754 48.8104C149.542 48.5975 149.436 48.3528 149.436 48.0782C149.436 47.7931 149.547 47.5397 149.77 47.3181L151.42 45.6659L149.902 44.1736C149.681 43.9424 149.567 43.6852 149.567 43.401C149.567 43.1254 149.674 42.8836 149.883 42.6746C150.091 42.4665 150.338 42.3615 150.622 42.3615C150.914 42.3615 151.178 42.4819 151.408 42.7218L152.847 44.1736L154.273 42.7218C154.495 42.4732 154.754 42.3489 155.06 42.3489H155.059ZM8.74277 35.5667C9.02794 35.5667 9.27553 35.6736 9.4894 35.8865C9.70135 36.1004 9.80925 36.3441 9.80925 36.6187C9.80925 36.9038 9.6975 37.1572 9.47495 37.3798L7.82466 39.031L9.342 40.5233C9.56358 40.7449 9.6763 40.9983 9.6763 41.2825C9.6763 41.5667 9.57033 41.8152 9.36224 42.0291C9.15318 42.241 8.90655 42.3489 8.62235 42.3489C8.32081 42.3489 8.05973 42.2237 7.83622 41.9751L6.4104 40.5233L4.97206 41.9751C4.74085 42.216 4.47881 42.3354 4.18593 42.3354C3.90173 42.3354 3.65607 42.2304 3.44701 42.0223C3.23892 41.8133 3.13391 41.5715 3.13391 41.2959C3.13391 41.0117 3.24566 40.7545 3.46628 40.5233L4.98555 39.031L3.3343 37.3788C3.11272 37.1572 3 36.9038 3 36.6196C3 36.3441 3.1079 36.0994 3.31985 35.8875C3.53372 35.6736 3.78227 35.5667 4.06647 35.5667C4.36031 35.5667 4.62139 35.6871 4.8526 35.927L6.41137 37.5522L7.95665 35.927C8.18786 35.6861 8.4499 35.5667 8.74277 35.5667ZM187.815 35.5667C188.099 35.5667 188.343 35.6736 188.554 35.8865C188.762 36.1004 188.866 36.3489 188.866 36.6331C188.866 36.9173 188.755 37.1707 188.532 37.3923L187.014 38.8846L188.666 40.5368C188.887 40.7584 189 41.0117 189 41.2959C189 41.5715 188.891 41.8162 188.679 42.0281C188.467 42.242 188.217 42.3489 187.934 42.3489C187.641 42.3489 187.379 42.2285 187.146 41.9886L185.602 40.3634L184.043 41.9886C183.811 42.2295 183.552 42.3489 183.256 42.3489C182.972 42.3489 182.725 42.242 182.51 42.0291C182.298 41.8152 182.192 41.5715 182.192 41.2959C182.192 41.0117 182.303 40.7584 182.525 40.5368L184.175 38.8846L182.657 37.3923C182.436 37.1611 182.323 36.9038 182.323 36.6196C182.323 36.3441 182.43 36.1023 182.639 35.8932C182.846 35.6852 183.093 35.5801 183.378 35.5801C183.67 35.5801 183.934 35.7006 184.163 35.9405L185.602 37.3923L187.028 35.9405C187.25 35.6909 187.51 35.5667 187.815 35.5667ZM41.8613 28.4299C42.1455 28.4299 42.3911 28.5358 42.6002 28.7497C42.8083 28.9626 42.9133 29.2121 42.9133 29.4954C42.9133 29.7796 42.8015 30.0329 42.579 30.2555L41.0617 31.7468L42.7119 33.399C42.9345 33.6206 43.0462 33.8749 43.0462 34.1591C43.0462 34.4337 42.9393 34.6784 42.7264 34.8913C42.5145 35.1042 42.2649 35.2112 41.9798 35.2112C41.6869 35.2112 41.4258 35.0917 41.1936 34.8518L39.6484 33.2266L38.0896 34.8518C37.8584 35.0917 37.5983 35.2112 37.3035 35.2112C37.0193 35.2112 36.7717 35.1052 36.5568 34.8913C36.3449 34.6784 36.237 34.4337 36.237 34.1591C36.237 33.8749 36.3497 33.6216 36.5713 33.399L38.2225 31.7468L36.7033 30.2555C36.4827 30.0243 36.3709 29.7661 36.3709 29.4819C36.3709 29.2073 36.4769 28.9645 36.685 28.7564C36.8931 28.5474 37.1397 28.4433 37.4239 28.4433C37.7158 28.4433 37.9798 28.5628 38.21 28.8027L39.6484 30.2555L41.0742 28.8027C41.2967 28.5541 41.5578 28.4299 41.8613 28.4299ZM166.62 21.6476C166.905 21.6476 167.15 21.7545 167.359 21.9684C167.567 22.1803 167.672 22.4299 167.672 22.7141C167.672 22.9983 167.561 23.2516 167.338 23.4732L165.821 24.9665L167.471 26.6177C167.694 26.8393 167.805 27.0927 167.805 27.3769C167.805 27.6524 167.698 27.8971 167.486 28.11C167.274 28.3229 167.024 28.4299 166.739 28.4299C166.446 28.4299 166.185 28.3094 165.953 28.0695L164.408 26.4443L162.849 28.0695C162.618 28.3104 162.357 28.4299 162.063 28.4299C161.778 28.4299 161.531 28.3239 161.316 28.11C161.104 27.8971 160.996 27.6524 160.996 27.3778C160.996 27.0927 161.109 26.8403 161.33 26.6177L162.982 24.9655L161.462 23.4732C161.242 23.242 161.13 22.9848 161.13 22.7006C161.13 22.425 161.236 22.1832 161.444 21.9742C161.652 21.7661 161.899 21.662 162.183 21.662C162.475 21.662 162.739 21.7815 162.969 22.0214L164.408 23.4732L165.833 22.0214C166.056 21.7728 166.317 21.6485 166.62 21.6485V21.6476ZM22.7447 11.4771C23.0299 11.4771 23.2775 11.583 23.4913 11.7969C23.7033 12.0098 23.8112 12.2545 23.8112 12.5291C23.8112 12.8133 23.6994 13.0667 23.4778 13.2892L21.8256 14.9405L23.343 16.4318C23.5645 16.6534 23.6773 16.9077 23.6773 17.1919C23.6773 17.4761 23.5713 17.7247 23.3632 17.9376C23.1541 18.1505 22.9075 18.2574 22.6233 18.2574C22.3218 18.2574 22.0607 18.1331 21.8372 17.8846L20.4114 16.4318L18.973 17.8846C18.7418 18.1245 18.4798 18.2439 18.1869 18.2439C17.9027 18.2439 17.657 18.1399 17.448 17.9308C17.2399 17.7227 17.1349 17.48 17.1349 17.2054C17.1349 16.9212 17.2466 16.663 17.4672 16.4318L18.9865 14.9405L17.3353 13.2882C17.1137 13.0667 17.001 12.8123 17.001 12.5281C17.001 12.2536 17.1089 12.0089 17.3208 11.7959C17.5347 11.5821 17.7832 11.4761 18.0674 11.4761C18.3613 11.4761 18.6224 11.5956 18.8536 11.8354L20.4123 13.4607L21.9576 11.8354C22.1888 11.5956 22.4509 11.4761 22.7437 11.4761L22.7447 11.4771ZM144.944 8.08496C145.228 8.08496 145.474 8.19093 145.683 8.40481C145.891 8.61772 145.996 8.86723 145.996 9.15144C145.996 9.43564 145.884 9.68804 145.662 9.91059L144.145 11.4029L145.795 13.0551C146.017 13.2767 146.129 13.53 146.129 13.8142C146.129 14.0898 146.022 14.3345 145.809 14.5464C145.597 14.7603 145.348 14.8663 145.063 14.8663C144.77 14.8663 144.509 14.7468 144.277 14.5069L142.731 12.8817L141.172 14.5069C140.941 14.7468 140.681 14.8663 140.386 14.8663C140.102 14.8663 139.855 14.7603 139.64 14.5474C139.428 14.3335 139.32 14.0898 139.32 13.8142C139.32 13.53 139.433 13.2767 139.654 13.0551L141.305 11.4029L139.786 9.90962C139.566 9.67937 139.454 9.42215 139.454 9.13795C139.454 8.86242 139.56 8.62061 139.768 8.41155C139.976 8.20249 140.223 8.09845 140.507 8.09845C140.799 8.09845 141.063 8.21887 141.293 8.45779L142.731 9.91059L144.157 8.45779C144.38 8.20924 144.641 8.08496 144.944 8.08496Z\" fill=\"#B6C5D5\"/>\n</g>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" d=\"M64.9722 74.8605C66.4009 75.663 68.2015 76.0927 70.3652 76.1428L70.8036 76.1485H108.169C108.169 78.1408 108.41 80.0763 108.861 81.9289H74.6571C69.1022 81.9289 65.8392 79.5358 64.9722 74.8605ZM133.7 28.5137C136.939 31.0647 137.796 32.9462 137.796 37.7882V52.4616C136.545 52.1803 135.258 51.9963 133.942 51.9164V32.0079C133.942 30.6322 133.873 29.4954 133.7 28.5137H133.7Z\" fill=\"#CCCCCC\"/>\n</g>\n<path d=\"M97.4305 0C99.7494 0 101.764 1.13873 103.821 2.75434L129.572 22.5202C133.037 25.1821 133.942 27.0318 133.942 32.0077V51.9171C133.448 51.8873 132.95 51.8719 132.447 51.8719C131.614 51.8719 130.789 51.9133 129.976 51.9961V31.3969C129.976 30.4913 129.907 29.7534 129.773 29.1108L109.265 49.1146L117.41 57.0857C116.404 57.8815 115.46 58.7553 114.592 59.6975L101.668 46.9942C100.226 45.553 98.8448 44.9788 97.5365 44.9788C96.2513 44.9788 94.8467 45.5896 93.4286 46.9942L68.2186 71.815C68.9209 72.0491 69.76 72.1821 70.7022 72.1821H108.491C108.279 73.4721 108.168 74.7977 108.168 76.1484H70.8024C64.2475 76.1484 60.8833 72.815 60.8833 66.3295V32.0077C60.8833 27.0318 61.7918 25.1821 65.2898 22.5202L91.0413 2.75434C93.0606 1.13873 95.076 0 97.4305 0ZM65.0875 28.9143C64.918 29.5886 64.8534 30.3921 64.8534 31.3979V66.3015C64.8534 67.4085 65.024 68.3487 65.3582 69.157L85.8361 49.1156L65.0875 28.9133V28.9143ZM97.4305 4.13584C95.7879 4.13584 94.7407 4.84297 93.1945 6.0183L67.681 25.5173C67.575 25.5819 67.4748 25.6503 67.4112 25.7197L88.5856 46.3988L91.0779 43.975C93.2629 41.8266 95.4161 40.9817 97.5365 40.9817C99.653 40.9817 101.8 41.8266 104.023 43.975L106.51 46.3988L127.585 25.8208C127.452 25.7197 127.318 25.6137 127.185 25.5173L101.668 6.0183C100.121 4.84297 99.0471 4.13584 97.4305 4.13584ZM97.6868 12.5241C104.831 12.5241 109.891 17.0597 109.891 23.9451C109.891 28.5751 107.725 31.7197 104.201 31.7197C102.284 31.7197 100.878 30.7659 100.544 29.1715H100.366C99.7118 30.8044 98.391 31.7303 96.5808 31.7303C93.4238 31.7303 91.2937 29.1002 91.2937 25.29C91.2937 21.5376 93.4006 18.9653 96.4382 18.9653C98.1742 18.9653 99.5808 19.8372 100.189 21.2775H100.366V20.3362C100.366 19.4788 100.855 18.9653 101.678 18.9653C102.509 18.9653 102.973 19.4788 102.973 20.3362V27.5636C102.973 28.8025 103.617 29.5183 104.747 29.5183C106.451 29.5183 107.51 27.3738 107.51 24.1715C107.51 18.2293 103.213 14.763 97.6771 14.763C91.5538 14.763 87.4363 19.0742 87.4363 25.3141C87.4363 31.7563 91.7446 35.6358 98.2234 35.6358C99.603 35.6358 100.603 35.4586 101.711 35.2197C101.974 35.1715 102.175 35.1484 102.366 35.1484C103.022 35.1484 103.414 35.553 103.414 36.1252C103.414 36.6484 103.141 37.0645 102.378 37.3276C101.378 37.6724 99.7821 37.8873 97.8293 37.8873C90.2812 37.8873 84.9344 33.0299 84.9344 25.2428C84.9344 17.632 90.1848 12.5241 97.6868 12.5241ZM97.2003 21.3362C95.365 21.3362 94.2109 22.8719 94.2109 25.3247C94.2109 27.8025 95.3534 29.3372 97.1877 29.3372C99.0326 29.3372 100.222 27.7659 100.222 25.29C100.222 22.8603 99.0442 21.3362 97.2003 21.3362Z\" fill=\"#B6C5D5\"/>\n<path d=\"M132.049 55.3633C143.646 55.3633 153.244 64.9558 153.244 76.5463C153.244 88.16 143.668 97.7525 132.049 97.7525C120.452 97.7525 110.854 88.16 110.854 76.5463C110.854 64.9558 120.431 55.3633 132.049 55.3633ZM132.406 82.7371C131.153 82.7371 130.122 83.7188 130.122 84.9461C130.122 86.1484 131.178 87.1552 132.406 87.1552L132.557 87.1501C133.718 87.0729 134.688 86.1214 134.688 84.9461C134.688 83.6937 133.657 82.7371 132.406 82.7371ZM132.381 64.0338C131.275 64.0338 130.515 64.7949 130.54 65.8498L130.81 78.1957L130.818 78.3585C130.895 79.3119 131.451 79.8402 132.406 79.8402L132.554 79.8353C133.423 79.7769 133.952 79.196 133.952 78.1957L134.246 65.8498L134.244 65.7108C134.196 64.7492 133.411 64.0338 132.381 64.0338Z\" fill=\"#FECF2F\"/>\n</svg>";

var LinealNotificacionesEmpty = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M127.48 60.2947C129.805 62.6613 132.022 65.0856 132.022 67.7273C132.022 70.0356 130.197 71.6094 127.183 71.6094H113.652C113.396 77.7947 108.551 83.1822 101.755 83.1822C97.4219 83.1822 93.8794 80.9599 91.8247 77.7447C93.7852 79.2978 96.2772 80.2452 99.1059 80.2452C105.903 80.2452 110.748 74.8586 111.003 68.6716H124.534C127.549 68.6716 129.375 67.0987 129.375 64.7904C129.375 63.2814 128.652 61.8435 127.598 60.4467L127.48 60.2947ZM73.7111 68.6716H87.2464C87.2883 69.6776 87.4525 70.6638 87.7275 71.6099L76.3582 71.6094C73.5999 71.6094 71.8674 70.3171 71.5667 68.3569C72.1875 68.5615 72.9056 68.6716 73.7111 68.6716ZM116.015 27.2932C120.872 31.4332 122.872 38.5447 123.045 48.3264C123.266 51.507 123.729 55.3294 125.204 57.7417C124.588 57.1054 123.955 56.4751 123.346 55.8464C121.234 53.6317 120.653 49.0792 120.397 45.3894C120.261 37.7093 118.999 31.6753 116.112 27.4332L116.015 27.2932ZM107.201 18.6841C108.474 19.6129 109.497 20.8578 110.212 22.2852C109.629 21.996 109.017 21.7352 108.375 21.5034C108.119 20.5279 107.736 19.5981 107.237 18.7459L107.201 18.6841Z\" fill=\"#B6C5D5\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M54.1731 53.5455C55.1042 53.5455 55.8599 54.3012 55.8599 55.2322C55.8599 56.1633 55.1042 56.919 54.1731 56.919H37.1277C36.1966 56.919 35.441 56.1633 35.441 55.2322C35.441 54.3012 36.1966 53.5455 37.1277 53.5455H54.1731ZM158.91 45.6397C159.842 45.6397 160.597 46.3954 160.597 47.3265C160.597 48.2575 159.842 49.0132 158.91 49.0132H144.762C143.831 49.0132 143.075 48.2575 143.075 47.3265C143.075 46.3954 143.831 45.6397 144.762 45.6397H158.91ZM138.091 45.6397C139.022 45.6397 139.778 46.3954 139.778 47.3265C139.778 48.2575 139.022 49.0132 138.091 49.0132H135.218C134.286 49.0132 133.531 48.2575 133.531 47.3265C133.531 46.3954 134.286 45.6397 135.218 45.6397H138.091ZM39.5813 45.5289C40.5124 45.5289 41.2681 46.2846 41.2681 47.2156C41.2681 48.1467 40.5124 48.9024 39.5813 48.9024H32.6867C31.7557 48.9024 31 48.1467 31 47.2156C31 46.2846 31.7557 45.5289 32.6867 45.5289H39.5813ZM68.7244 45.5289C69.6564 45.5289 70.4112 46.2846 70.4112 47.2156C70.4112 48.1467 69.6564 48.9024 68.7244 48.9024H46.736C45.8049 48.9024 45.0493 48.1467 45.0493 47.2156C45.0493 46.2846 45.8049 45.5289 46.736 45.5289H68.7244ZM65.702 37.5124C66.6331 37.5124 67.3888 38.268 67.3888 39.1991C67.3888 40.1302 66.6331 40.8859 65.702 40.8859H62.3083C61.3764 40.8859 60.6216 40.1302 60.6216 39.1991C60.6216 38.268 61.3764 37.5124 62.3083 37.5124H65.702ZM55.2513 37.5124C56.1824 37.5124 56.938 38.268 56.938 39.1991C56.938 40.1302 56.1824 40.8859 55.2513 40.8859H37.2959C36.3639 40.8859 35.6091 40.1302 35.6091 39.1991C35.6091 38.268 36.3639 37.5124 37.2959 37.5124H55.2513ZM139.25 37.3192C140.181 37.3192 140.937 38.0749 140.937 39.006C140.937 39.9371 140.181 40.6927 139.25 40.6927H129.914C128.982 40.6927 128.227 39.9371 128.227 39.006C128.227 38.0749 128.982 37.3192 129.914 37.3192H139.25ZM148.587 37.3192C149.518 37.3192 150.274 38.0749 150.274 39.006C150.274 39.9371 149.518 40.6927 148.587 40.6927H145.715C144.783 40.6927 144.028 39.9371 144.028 39.006C144.028 38.0749 144.783 37.3192 145.715 37.3192H148.587ZM159.573 29.1313C160.504 29.1313 161.26 29.887 161.26 30.8181C161.26 31.7492 160.504 32.5048 159.573 32.5048H152.34C151.408 32.5048 150.653 31.7492 150.653 30.8181C150.653 29.887 151.408 29.1313 152.34 29.1313H159.573ZM144.014 29.1313C144.945 29.1313 145.701 29.887 145.701 30.8181C145.701 31.7492 144.945 32.5048 144.014 32.5048H131.855C130.924 32.5048 130.168 31.7492 130.168 30.8181C130.168 29.887 130.924 29.1313 131.855 29.1313H144.014Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M123.125 63.8282H75.0921V63.4436C75.6689 62.4813 77.5935 60.6217 79.26 58.7283C81.5692 56.1628 82.6597 52.0581 82.9456 45.7741C83.2011 31.7943 87.3741 27.3051 92.8552 25.8342C93.6589 25.6377 94.1034 25.2228 94.138 24.4233C94.2316 21.0548 96.1553 18.7111 99.1063 18.7111C102.09 18.7111 103.979 21.0548 104.107 24.4233C104.142 25.2228 104.56 25.6377 105.361 25.8342C110.876 27.3051 115.044 31.7943 115.301 45.7741C115.591 52.0581 116.677 56.1628 118.956 58.7283C120.653 60.6217 122.547 62.4813 123.125 63.4436V63.8282ZM99.1063 75.7569C95.258 75.7569 92.4706 72.999 92.248 68.6717H106.001C105.746 72.999 102.987 75.7569 99.1063 75.7569ZM120.397 45.3895C120.175 32.76 116.903 24.5818 108.375 21.5035C107.284 17.3355 103.851 14 99.1063 14C94.3952 14 90.9315 17.3355 89.8713 21.5035C81.3465 24.5818 78.0717 32.76 77.8482 45.3895C77.5935 49.0784 77.0158 53.6318 74.8989 55.8465C72.1124 58.6979 68.8713 61.584 68.8713 64.7905C68.8713 67.0988 70.6669 68.6717 73.7106 68.6717H87.2468C87.5031 74.8283 92.3424 80.2453 99.1063 80.2453C105.903 80.2453 110.747 74.8587 111.004 68.6717H124.535C127.549 68.6717 129.375 67.0988 129.375 64.7905C129.375 61.584 126.108 58.6979 123.347 55.8465C121.235 53.6318 120.653 49.0784 120.397 45.3895Z\" fill=\"#B6C5D5\"/>\n</svg>";

var LinealPagosInmediatosDefault = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g opacity=\"0.6\">\n<path d=\"M21.957 59.7161C22.2452 59.7161 22.4955 59.8247 22.7117 60.0409C22.9259 60.258 23.035 60.5055 23.035 60.7843C23.035 61.0739 22.922 61.3312 22.698 61.5572L21.029 63.2339L22.5627 64.7493C22.7866 64.9743 22.9006 65.2315 22.9006 65.5201C22.9006 65.8087 22.7935 66.0611 22.5831 66.2783C22.3718 66.4945 22.1225 66.6031 21.8353 66.6031C21.5305 66.6031 21.2666 66.4759 21.0407 66.2235L19.5996 64.7493L18.1458 66.2235C17.9121 66.4681 17.6472 66.5894 17.3512 66.5894C17.0639 66.5894 16.8156 66.4828 16.6043 66.2714C16.394 66.0592 16.2878 65.8136 16.2878 65.5338C16.2878 65.2452 16.4008 64.984 16.6238 64.7493L18.1594 63.2339L16.4904 61.5562C16.2664 61.3312 16.1525 61.0739 16.1525 60.7853C16.1525 60.5055 16.2615 60.2571 16.4758 60.0418C16.6919 59.8247 16.9432 59.7161 17.2304 59.7161C17.5274 59.7161 17.7913 59.8384 18.025 60.0819L19.6005 61.7323L21.1624 60.0819C21.3961 59.8374 21.661 59.7161 21.957 59.7161ZM51.3467 56.2726C51.635 56.2726 51.8852 56.3812 52.1014 56.5983C52.3156 56.8145 52.4247 57.063 52.4247 57.3418C52.4247 57.6304 52.3117 57.8877 52.0868 58.1137L50.4188 59.7904L51.9524 61.3067C52.1764 61.5317 52.2903 61.789 52.2903 62.0776C52.2903 62.3662 52.1832 62.6186 51.9729 62.8348C51.7616 63.051 51.5123 63.1596 51.225 63.1596C50.9202 63.1596 50.6563 63.0324 50.4304 62.781L48.9893 61.3058L47.5355 62.781C47.3018 63.0246 47.0369 63.1459 46.7409 63.1459C46.4536 63.1459 46.2053 63.0402 45.994 62.8279C45.7837 62.6166 45.6776 62.3701 45.6776 62.0903C45.6776 61.8017 45.7905 61.5405 46.0135 61.3058L47.5491 59.7904L45.8801 58.1137C45.6561 57.8887 45.5422 57.6304 45.5422 57.3418C45.5422 57.063 45.6513 56.8145 45.8655 56.5983C46.0807 56.3812 46.3329 56.2736 46.6202 56.2736C46.9171 56.2736 47.181 56.3949 47.4147 56.6384L48.9903 58.2888L50.5522 56.6384C50.7859 56.3949 51.0507 56.2736 51.3467 56.2736V56.2726ZM155.694 44.4962C155.982 44.4962 156.229 44.6038 156.442 44.82C156.652 45.0372 156.757 45.2896 156.757 45.5782C156.757 45.8667 156.645 46.124 156.419 46.349L154.886 47.8653L156.555 49.5421C156.779 49.7671 156.892 50.0244 156.892 50.313C156.892 50.5928 156.782 50.8412 156.568 51.0564C156.354 51.2736 156.101 51.3822 155.815 51.3822C155.519 51.3822 155.254 51.2599 155.019 51.0163L153.458 49.366L151.883 51.0163C151.648 51.2609 151.386 51.3822 151.087 51.3822C150.8 51.3822 150.55 51.2746 150.332 51.0574C150.118 50.8412 150.011 50.5928 150.011 50.3139C150.011 50.0244 150.123 49.7671 150.348 49.5421L152.016 47.8644L150.481 46.349C150.258 46.1142 150.143 45.853 150.143 45.5645C150.143 45.2847 150.252 45.0391 150.463 44.8268C150.672 44.6155 150.922 44.5089 151.21 44.5089C151.505 44.5089 151.772 44.6312 152.003 44.8748L153.458 46.349L154.899 44.8748C155.124 44.6224 155.386 44.4962 155.695 44.4962H155.694ZM7.80452 37.6092C8.09275 37.6092 8.34301 37.7178 8.55918 37.934C8.77341 38.1511 8.88247 38.3986 8.88247 38.6775C8.88247 38.967 8.76951 39.2243 8.54458 39.4503L6.87654 41.127L8.4102 42.6424C8.63416 42.8674 8.74809 43.1247 8.74809 43.4132C8.74809 43.7018 8.64098 43.9542 8.43065 44.1714C8.21934 44.3866 7.97006 44.4962 7.68281 44.4962C7.37802 44.4962 7.11414 44.369 6.88823 44.1166L5.44708 42.6424L3.99327 44.1166C3.75957 44.3612 3.49471 44.4825 3.19869 44.4825C2.91143 44.4825 2.66312 44.3759 2.45182 44.1646C2.24149 43.9523 2.13535 43.7067 2.13535 43.4269C2.13535 43.1384 2.24831 42.8772 2.4713 42.6424L4.0069 41.127L2.33789 39.4493C2.11393 39.2243 2 38.967 2 38.6784C2 38.3986 2.10906 38.1502 2.32329 37.9349C2.53946 37.7178 2.79069 37.6092 3.07794 37.6092C3.37494 37.6092 3.63882 37.7315 3.87252 37.9751L5.44805 39.6254L7.00994 37.9751C7.24364 37.7305 7.5085 37.6092 7.80452 37.6092ZM188.802 37.6092C189.09 37.6092 189.336 37.7178 189.549 37.934C189.759 38.1511 189.865 38.4035 189.865 38.6921C189.865 38.9807 189.753 39.238 189.527 39.463L187.993 40.9783L189.662 42.6561C189.886 42.8811 190 43.1384 190 43.4269C190 43.7067 189.89 43.9552 189.676 44.1704C189.462 44.3876 189.208 44.4962 188.922 44.4962C188.626 44.4962 188.361 44.3739 188.127 44.1303L186.566 42.48L184.99 44.1303C184.755 44.3749 184.493 44.4962 184.195 44.4962C183.907 44.4962 183.658 44.3876 183.44 44.1714C183.226 43.9542 183.119 43.7067 183.119 43.4269C183.119 43.1384 183.23 42.8811 183.455 42.6561L185.123 40.9783L183.589 39.463C183.366 39.2282 183.251 38.967 183.251 38.6784C183.251 38.3986 183.359 38.1531 183.57 37.9408C183.78 37.7295 184.03 37.6229 184.317 37.6229C184.612 37.6229 184.879 37.7452 185.111 37.9888L186.566 39.463L188.007 37.9888C188.232 37.7354 188.494 37.6092 188.802 37.6092ZM41.2791 30.3622C41.5664 30.3622 41.8147 30.4698 42.026 30.687C42.2363 30.9032 42.3425 31.1565 42.3425 31.4441C42.3425 31.7327 42.2295 31.99 42.0046 32.216L40.4709 33.7304L42.139 35.4081C42.3639 35.6331 42.4768 35.8913 42.4768 36.1799C42.4768 36.4587 42.3688 36.7072 42.1536 36.9234C41.9393 37.1396 41.6871 37.2482 41.3989 37.2482C41.1029 37.2482 40.839 37.1269 40.6043 36.8833L39.0424 35.233L37.4669 36.8833C37.2332 37.1269 36.9703 37.2482 36.6723 37.2482C36.3851 37.2482 36.1348 37.1406 35.9177 36.9234C35.7034 36.7072 35.5944 36.4587 35.5944 36.1799C35.5944 35.8913 35.7083 35.6341 35.9323 35.4081L37.6013 33.7304L36.0657 32.216C35.8427 31.9812 35.7297 31.719 35.7297 31.4304C35.7297 31.1516 35.8368 30.9051 36.0472 30.6938C36.2575 30.4815 36.5068 30.3759 36.794 30.3759C37.0891 30.3759 37.3559 30.4972 37.5886 30.7408L39.0424 32.216L40.4836 30.7408C40.7085 30.4884 40.9724 30.3622 41.2791 30.3622ZM167.38 23.4752C167.667 23.4752 167.915 23.5838 168.127 23.8009C168.337 24.0162 168.443 24.2695 168.443 24.5581C168.443 24.8467 168.33 25.104 168.105 25.329L166.572 26.8453L168.24 28.5221C168.465 28.7471 168.577 29.0043 168.577 29.2929C168.577 29.5727 168.469 29.8212 168.254 30.0374C168.04 30.2536 167.788 30.3622 167.5 30.3622C167.204 30.3622 166.94 30.2399 166.705 29.9963L165.143 28.346L163.568 29.9963C163.334 30.2409 163.071 30.3622 162.773 30.3622C162.486 30.3622 162.235 30.2546 162.018 30.0374C161.804 29.8212 161.695 29.5727 161.695 29.2939C161.695 29.0043 161.809 28.748 162.033 28.5221L163.702 26.8443L162.166 25.329C161.943 25.0942 161.83 24.833 161.83 24.5444C161.83 24.2646 161.937 24.0191 162.148 23.8068C162.358 23.5955 162.607 23.4898 162.895 23.4898C163.19 23.4898 163.457 23.6112 163.689 23.8547L165.143 25.329L166.584 23.8547C166.809 23.6024 167.073 23.4762 167.38 23.4762V23.4752ZM21.957 13.1476C22.2452 13.1476 22.4955 13.2552 22.7117 13.4724C22.9259 13.6886 23.035 13.9371 23.035 14.2159C23.035 14.5045 22.922 14.7617 22.698 14.9877L21.0281 16.6645L22.5617 18.1788C22.7857 18.4038 22.8996 18.6621 22.8996 18.9507C22.8996 19.2393 22.7925 19.4917 22.5822 19.7079C22.3709 19.9241 22.1216 20.0327 21.8343 20.0327C21.5295 20.0327 21.2656 19.9065 21.0397 19.6541L19.5986 18.1788L18.1448 19.6541C17.9111 19.8977 17.6462 20.019 17.3502 20.019C17.0629 20.019 16.8146 19.9133 16.6033 19.701C16.393 19.4897 16.2869 19.2432 16.2869 18.9644C16.2869 18.6758 16.3998 18.4136 16.6228 18.1788L18.1584 16.6645L16.4894 14.9867C16.2654 14.7617 16.1515 14.5035 16.1515 14.2149C16.1515 13.9361 16.2606 13.6876 16.4748 13.4714C16.691 13.2542 16.9422 13.1466 17.2295 13.1466C17.5264 13.1466 17.7903 13.2679 18.024 13.5115L19.5996 15.1619L21.1615 13.5115C21.3952 13.2679 21.66 13.1466 21.956 13.1466L21.957 13.1476ZM145.47 9.70312C145.758 9.70312 146.006 9.81073 146.217 10.0279C146.428 10.2441 146.534 10.4975 146.534 10.7861C146.534 11.0747 146.421 11.331 146.196 11.5569L144.662 13.0723L146.33 14.75C146.555 14.975 146.668 15.2323 146.668 15.5209C146.668 15.8007 146.56 16.0491 146.345 16.2644C146.131 16.4815 145.878 16.5892 145.59 16.5892C145.294 16.5892 145.03 16.4678 144.796 16.2243L143.234 14.5739L141.658 16.2243C141.424 16.4678 141.162 16.5892 140.864 16.5892C140.576 16.5892 140.326 16.4815 140.109 16.2653C139.895 16.0482 139.786 15.8007 139.786 15.5209C139.786 15.2323 139.9 14.975 140.124 14.75L141.793 13.0723L140.257 11.556C140.034 11.3222 139.921 11.061 139.921 10.7724C139.921 10.4926 140.028 10.247 140.238 10.0348C140.449 9.82247 140.698 9.71682 140.985 9.71682C141.28 9.71682 141.547 9.8391 141.78 10.0817L143.234 11.5569L144.675 10.0817C144.9 9.82932 145.164 9.70312 145.47 9.70312Z\" fill=\"#B6C5D5\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M110.447 0.515137C116.613 0.515137 121.611 5.3845 121.611 11.3912L121.611 54.253C119.636 54.8138 117.763 55.6209 116.029 56.639L116.029 11.3912C116.029 8.38784 113.53 5.95315 110.447 5.95315H71.3698C68.2868 5.95315 65.7875 8.38784 65.7875 11.3912V82.0854C65.7875 85.0887 68.2868 87.5234 71.3698 87.5234L106.2 87.5239C107.087 89.4906 108.228 91.3172 109.581 92.9615L71.3698 92.9614C65.2037 92.9614 60.2051 88.092 60.2051 82.0854V11.3912C60.2051 5.3845 65.2037 0.515137 71.3698 0.515137H110.447ZM97.6723 74.7264C99.2578 74.7264 100.543 75.9784 100.543 77.5229V78.5398C100.543 80.0843 99.2578 81.3363 97.6723 81.3363H83.0576C81.4722 81.3363 80.1869 80.0843 80.1869 78.5398V77.5229C80.1869 75.9784 81.4722 74.7264 83.0576 74.7264H97.6723Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M128.191 97.3635C138.976 97.3635 147.929 88.4616 147.929 77.5536C147.929 66.6874 138.976 57.7437 128.191 57.7437C117.364 57.7437 108.453 66.6874 108.453 77.5536C108.453 88.4616 117.364 97.3635 128.191 97.3635ZM126.043 88.5591C125.511 88.5591 124.865 88.2976 124.447 87.7745L117.644 79.1445C117.339 78.7958 117.225 78.1856 117.225 77.6625C117.225 76.3985 118.062 75.396 119.164 75.396C119.848 75.396 120.342 75.7883 120.684 76.2242L125.967 82.7185L135.545 67.507C135.888 66.9403 136.496 66.5481 137.18 66.5481C138.244 66.5481 139.156 67.4634 139.156 68.771C139.156 69.1632 139.004 69.6427 138.7 70.1221L127.678 87.6874C127.336 88.2104 126.728 88.5591 126.043 88.5591Z\" fill=\"#1AAAAD\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M91.1013 18.124C91.8993 18.124 92.5492 18.36 93.0512 18.8321C93.5531 19.3042 93.8041 19.9253 93.8041 20.6955V22.447L94.868 22.6468C96.6341 23.0437 98.3644 23.7597 100.059 24.7949C100.522 25.093 100.85 25.4222 101.044 25.7825C101.237 26.1427 101.333 26.5837 101.333 27.1055C101.333 27.8508 101.101 28.4968 100.638 29.0434C100.175 29.5899 99.6343 29.8632 99.0165 29.8632C98.7076 29.8632 98.4116 29.8135 98.1284 29.7142C97.8453 29.6148 97.4335 29.4284 96.8929 29.1552C96.7127 29.0558 96.3137 28.8508 95.696 28.5402C95.0782 28.2297 94.4154 27.9812 93.7075 27.7949C92.9997 27.6086 92.2468 27.5154 91.4488 27.5154C90.2905 27.5154 89.351 27.7576 88.6302 28.2421C87.9095 28.7266 87.5492 29.3788 87.5492 30.1986C87.5492 30.9937 87.961 31.59 88.7847 31.9875C89.6084 32.385 90.9083 32.7825 92.6844 33.18C94.5891 33.6024 96.1529 34.0496 97.3755 34.5217C98.5982 34.9937 99.6536 35.7515 100.542 36.795C101.43 37.8384 101.874 39.2422 101.874 41.0062C101.874 43.0186 101.159 44.7329 99.7308 46.1491C98.3022 47.5652 96.3781 48.4969 93.9585 48.9441V50.7702L93.9284 51.2144C93.8481 51.7829 93.6071 52.2559 93.2056 52.6336C92.7037 53.1056 92.0537 53.3417 91.2558 53.3417C90.4578 53.3417 89.8079 53.1056 89.3059 52.6336C88.804 52.1615 88.553 51.5404 88.553 50.7702V49.0932L87.3537 48.916C85.0056 48.5053 82.96 47.7569 81.217 46.6708C80.7537 46.3975 80.4255 46.0869 80.2325 45.7391C80.0394 45.3913 79.9429 44.9317 79.9429 44.3602C79.9429 43.6149 80.1681 42.9689 80.6186 42.4223C81.069 41.8757 81.6031 41.6024 82.2209 41.6024C82.5298 41.6024 82.8387 41.6521 83.1475 41.7515C83.4564 41.8509 83.8554 42.0372 84.3445 42.3105C85.477 42.9068 86.5324 43.3292 87.5105 43.5776C88.4887 43.8261 89.5312 43.9503 90.638 43.9503C92.0022 43.9503 93.0383 43.7329 93.7461 43.2981C94.454 42.8633 94.8079 42.2111 94.8079 41.3416C94.8079 40.8198 94.5956 40.3913 94.1709 40.0558C93.7461 39.7204 93.2185 39.4534 92.5878 39.2546C91.9572 39.0558 91.037 38.8074 89.8272 38.5093C87.8966 38.0372 86.3136 37.5589 85.0781 37.0745C83.8425 36.59 82.7743 35.8322 81.8734 34.8012C80.9725 33.7701 80.522 32.385 80.522 30.6458C80.522 28.6583 81.2428 26.9315 82.6842 25.4657C84.1257 23.9998 86.0305 23.0309 88.3986 22.5588V20.6955L88.4295 20.2639C88.5118 19.7094 88.7589 19.2383 89.1708 18.8507C89.6856 18.3663 90.3291 18.124 91.1013 18.124Z\" fill=\"#1AAAAD\"/>\n</svg>";

var LinealPasswordConfirm = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g opacity=\"0.6\">\n<path opacity=\"0.6\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M50.0285 59.9953C50.3247 59.9953 50.5817 60.106 50.8042 60.3273C51.0243 60.5485 51.1361 60.8021 51.1361 61.0879C51.1361 61.3829 51.0197 61.6457 50.7892 61.8762L49.0755 63.591L50.6509 65.1399C50.8814 65.3704 50.9978 65.6332 50.9978 65.9282C50.9978 66.2232 50.8883 66.4814 50.6716 66.7027C50.455 66.9239 50.1991 67.0346 49.9041 67.0346C49.5906 67.0346 49.3198 66.9055 49.0881 66.6473L47.6084 65.1399L46.1148 66.6473C45.8751 66.8963 45.6031 67.0207 45.2989 67.0207C45.0038 67.0207 44.7491 66.9124 44.5313 66.6957C44.3158 66.4791 44.2063 66.2278 44.2063 65.942C44.2063 65.647 44.3227 65.3796 44.5521 65.1399L46.1286 63.591L44.4149 61.8762C44.1844 61.6457 44.068 61.3829 44.068 61.0879C44.068 60.8021 44.1798 60.5485 44.3999 60.3273C44.6212 60.106 44.8794 59.9953 45.1744 59.9953C45.4798 59.9953 45.7506 60.1198 45.9903 60.3687L47.6084 62.0559L49.2126 60.3687C49.4535 60.1198 49.7243 59.9953 50.0285 59.9953ZM15.9265 56.4757C16.2227 56.4757 16.4797 56.5864 16.7021 56.8076C16.9222 57.0289 17.034 57.2825 17.034 57.5683C17.034 57.8633 16.9176 58.1261 16.6871 58.3565L14.9734 60.0714L16.5488 61.6203C16.7793 61.8508 16.8957 62.1136 16.8957 62.4086C16.8957 62.7036 16.7862 62.9618 16.5696 63.183C16.3529 63.4043 16.0971 63.515 15.802 63.515C15.4886 63.515 15.2177 63.3859 14.9861 63.1277L13.5063 61.6203L12.0128 63.1277C11.773 63.3767 11.5011 63.5011 11.1968 63.5011C10.9018 63.5011 10.6471 63.3928 10.4293 63.1761C10.2138 62.9595 10.1043 62.7082 10.1043 62.4224C10.1043 62.1274 10.2207 61.86 10.45 61.6203L12.0266 60.0714L10.3129 58.3565C10.0824 58.1261 9.96598 57.8633 9.96598 57.5683C9.96598 57.2825 10.0778 57.0289 10.2979 56.8076C10.5192 56.5864 10.7773 56.4757 11.0723 56.4757C11.3777 56.4757 11.6486 56.6002 11.8883 56.8491L13.5063 58.5363L15.1106 56.8491C15.3514 56.6002 15.6223 56.4757 15.9265 56.4757ZM190.519 45.9169C190.814 45.9169 191.068 46.0275 191.287 46.2488C191.502 46.4701 191.611 46.7282 191.611 47.0233C191.611 47.3183 191.495 47.5811 191.264 47.8115L189.688 49.3605L191.403 51.0753C191.632 51.3058 191.75 51.5686 191.75 51.8636C191.75 52.1494 191.637 52.4029 191.417 52.6242C191.197 52.8455 190.938 52.9561 190.642 52.9561C190.338 52.9561 190.066 52.8317 189.825 52.5827L188.222 50.8955L186.604 52.5827C186.363 52.8317 186.094 52.9561 185.787 52.9561C185.492 52.9561 185.236 52.8455 185.013 52.6242C184.793 52.4029 184.682 52.1494 184.682 51.8636C184.682 51.5686 184.797 51.3058 185.029 51.0753L186.741 49.3605L185.166 47.8115C184.937 47.5718 184.819 47.3045 184.819 47.0094C184.819 46.7236 184.93 46.4724 185.146 46.2557C185.362 46.0391 185.619 45.9307 185.914 45.9307C186.217 45.9307 186.49 46.0552 186.729 46.3041L188.222 47.8115L189.702 46.3041C189.934 46.046 190.203 45.9169 190.519 45.9169ZM30.9605 33.8777C31.2567 33.8777 31.5137 33.9883 31.7361 34.2096C31.9562 34.4309 32.068 34.6844 32.068 34.9702C32.068 35.2652 31.9516 35.528 31.7211 35.7585L30.0074 37.4734L31.5828 39.0223C31.8133 39.2528 31.9297 39.5155 31.9297 39.8105C31.9297 40.1056 31.8203 40.3637 31.6036 40.585C31.3869 40.8063 31.1311 40.9169 30.8361 40.9169C30.5226 40.9169 30.2518 40.7878 30.0201 40.5297L28.5404 39.0223L27.0468 40.5297C26.8071 40.7786 26.5351 40.9031 26.2308 40.9031C25.9358 40.9031 25.6811 40.7947 25.4633 40.5781C25.2478 40.3614 25.1383 40.1102 25.1383 39.8244C25.1383 39.5293 25.2547 39.262 25.484 39.0223L27.0606 37.4734L25.3469 35.7585C25.1164 35.528 25 35.2652 25 34.9702C25 34.6844 25.1118 34.4309 25.3319 34.2096C25.5532 33.9883 25.8113 33.8777 26.1064 33.8777C26.4118 33.8777 26.6826 34.0021 26.9223 34.2511L28.5404 35.9383L30.1446 34.2511C30.3854 34.0021 30.6563 33.8777 30.9605 33.8777ZM170.337 33.5084C170.632 33.5084 170.887 33.6191 171.105 33.8404C171.32 34.0616 171.43 34.3198 171.43 34.6148C171.43 34.9098 171.313 35.1726 171.083 35.4031L169.507 36.952L171.221 38.6669C171.452 38.8973 171.568 39.1601 171.568 39.4551C171.568 39.7409 171.456 39.9945 171.236 40.2158C171.015 40.437 170.757 40.5477 170.461 40.5477C170.156 40.5477 169.885 40.4232 169.645 40.1743L168.04 38.4871L166.422 40.1743C166.183 40.4232 165.912 40.5477 165.606 40.5477C165.311 40.5477 165.054 40.437 164.832 40.2158C164.612 39.9945 164.5 39.7409 164.5 39.4551C164.5 39.1601 164.616 38.8973 164.847 38.6669L166.561 36.952L164.984 35.4031C164.755 35.1634 164.638 34.896 164.638 34.601C164.638 34.3152 164.748 34.0639 164.964 33.8473C165.181 33.6306 165.437 33.5223 165.732 33.5223C166.035 33.5223 166.308 33.6467 166.548 33.8957L168.04 35.4031L169.521 33.8957C169.752 33.6375 170.023 33.5084 170.337 33.5084ZM6.96052 22.9496C7.2567 22.9496 7.5137 23.0603 7.73612 23.2815C7.95624 23.5028 8.06803 23.7563 8.06803 24.0421C8.06803 24.3372 7.95163 24.5999 7.72114 24.8304L6.00743 26.5453L7.58285 28.0942C7.81334 28.3247 7.92974 28.5874 7.92974 28.8825C7.92974 29.1775 7.82025 29.4357 7.60359 29.6569C7.38693 29.8782 7.13108 29.9888 6.83605 29.9888C6.52258 29.9888 6.25176 29.8598 6.02011 29.6016L4.54035 28.0942L3.04677 29.6016C2.80706 29.8505 2.53508 29.975 2.23083 29.975C1.9358 29.975 1.6811 29.8667 1.46329 29.65C1.24778 29.4333 1.1383 29.1821 1.1383 28.8963C1.1383 28.6013 1.25469 28.3339 1.48403 28.0942L3.0606 26.5453L1.34689 24.8304C1.1164 24.5999 1 24.3372 1 24.0421C1 23.7563 1.11179 23.5028 1.33191 23.2815C1.55318 23.0603 1.81133 22.9496 2.10636 22.9496C2.41176 22.9496 2.68259 23.0741 2.9223 23.323L4.54035 25.0102L6.14458 23.323C6.38544 23.0741 6.65627 22.9496 6.96052 22.9496ZM46.3712 15.9104C46.6662 15.9104 46.9209 16.021 47.1388 16.2423C47.3543 16.4636 47.4638 16.7217 47.4638 17.0168C47.4638 17.3118 47.3474 17.5745 47.1169 17.805L45.5415 19.3539L47.2552 21.0688C47.4856 21.2993 47.602 21.5621 47.602 21.8571C47.602 22.1429 47.4903 22.3964 47.2701 22.6177C47.0489 22.839 46.7907 22.9496 46.4945 22.9496C46.1903 22.9496 45.9195 22.8251 45.6786 22.5762L44.0744 20.889L42.4563 22.5762C42.2166 22.8251 41.9458 22.9496 41.6404 22.9496C41.3453 22.9496 41.0883 22.839 40.8659 22.6177C40.6458 22.3964 40.534 22.1429 40.534 21.8571C40.534 21.5621 40.6504 21.2993 40.8809 21.0688L42.5946 19.3539L41.018 17.805C40.7887 17.5653 40.6723 17.298 40.6723 17.0029C40.6723 16.7171 40.7818 16.4659 40.9985 16.2492C41.2151 16.0326 41.471 15.9242 41.766 15.9242C42.0691 15.9242 42.3422 16.0487 42.5819 16.2976L44.0744 17.805L45.5553 16.2976C45.7858 16.0395 46.0566 15.9104 46.3712 15.9104ZM190.519 8.87117C190.814 8.87117 191.068 8.98181 191.287 9.20308C191.502 9.42435 191.611 9.6825 191.611 9.97753C191.611 10.2726 191.495 10.5353 191.264 10.7658L189.688 12.3147L191.403 14.0296C191.632 14.2601 191.75 14.5228 191.75 14.8179C191.75 15.1037 191.637 15.3572 191.417 15.5785C191.197 15.7998 190.938 15.9104 190.642 15.9104C190.338 15.9104 190.066 15.7859 189.825 15.537L188.222 13.8498L186.604 15.537C186.363 15.7859 186.094 15.9104 185.787 15.9104C185.492 15.9104 185.236 15.7998 185.013 15.5785C184.793 15.3572 184.682 15.1037 184.682 14.8179C184.682 14.5228 184.797 14.2601 185.029 14.0296L186.741 12.3147L185.166 10.7658C184.937 10.5261 184.819 10.2587 184.819 9.9637C184.819 9.67789 184.93 9.42666 185.146 9.21C185.362 8.99333 185.619 8.885 185.914 8.885C186.217 8.885 186.49 9.00947 186.729 9.2584L188.222 10.7658L189.702 9.2584C189.934 9.00025 190.203 8.87117 190.519 8.87117ZM156.337 5.35156C156.632 5.35156 156.887 5.4622 157.105 5.68347C157.32 5.90474 157.43 6.16289 157.43 6.45792C157.43 6.75295 157.313 7.01571 157.083 7.24621L155.507 8.79511L157.221 10.51C157.452 10.7405 157.568 11.0032 157.568 11.2983C157.568 11.5841 157.456 11.8376 157.236 12.0589C157.015 12.2801 156.757 12.3908 156.461 12.3908C156.156 12.3908 155.885 12.2663 155.645 12.0174L154.04 10.3302L152.422 12.0174C152.183 12.2663 151.912 12.3908 151.606 12.3908C151.311 12.3908 151.054 12.2801 150.832 12.0589C150.612 11.8376 150.5 11.5841 150.5 11.2983C150.5 11.0032 150.616 10.7405 150.847 10.51L152.561 8.79511L150.984 7.24621C150.755 7.00649 150.638 6.73912 150.638 6.44409C150.638 6.15828 150.748 5.90705 150.964 5.69039C151.181 5.47372 151.437 5.36539 151.732 5.36539C152.035 5.36539 152.308 5.48986 152.548 5.73879L154.04 7.24621L155.521 5.73879C155.752 5.48064 156.023 5.35156 156.337 5.35156Z\" fill=\"#B6C5D5\"/>\n</g>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M70.0796 60.0126C76.9809 69.3811 88.0794 75.5184 100.485 75.5184C104.407 75.5184 108.198 74.9006 111.765 73.7581C111.698 74.4965 111.665 75.2456 111.665 76.0026C111.665 76.4557 111.677 76.9059 111.701 77.3531C108.748 78.1137 105.66 78.5184 102.485 78.5184C88.7994 78.5184 76.7045 71.0493 70.0796 60.0126ZM145.023 33.8206L145.251 33.8304C147.44 33.8304 148.078 35.3364 146.839 37.1046L138.625 48.8137C137.572 50.2889 136.065 50.2889 135.053 48.8137L126.844 37.1046C126.665 36.8484 126.525 36.5978 126.423 36.3564L133.053 45.8137C134.031 47.2381 135.468 47.2872 136.515 45.9611L136.625 45.8137L144.839 34.1046C144.906 34.0091 144.967 33.9143 145.023 33.8206ZM84.6243 8.93136C81.9778 10.4631 79.5101 12.3058 77.3017 14.3994L77.2088 14.4882C79.3958 12.305 81.8907 10.4298 84.6243 8.93136ZM114.048 2.55566C116.43 3.39451 118.638 4.53351 120.67 5.92462L120.786 6.00396C118.672 4.64028 116.416 3.48111 114.048 2.55566Z\" fill=\"#B6C5D5\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M100.485 0C118.82 0 134.297 13.4054 137.612 30.8303H143.251C145.441 30.8303 146.078 32.3363 144.839 34.1045L136.625 45.8137C135.572 47.2889 134.065 47.2889 133.053 45.8137L124.844 34.1045C123.605 32.3363 124.243 30.8303 126.427 30.8303H132.642C129.481 15.9651 116.337 4.89337 100.485 4.89337C82.2636 4.89337 67.5886 19.5375 67.5886 37.7592C67.5886 55.9397 82.2636 70.6609 100.485 70.6301C104.886 70.6301 109.076 69.7671 112.897 68.2017C112.319 69.975 111.933 71.8352 111.764 73.7574C108.197 74.9007 104.407 75.5183 100.485 75.5183C79.7861 75.5183 62.7261 58.4326 62.7261 37.7592C62.7261 17.0548 79.7861 0 100.485 0ZM100.485 15.3226C106.741 15.3226 111.444 19.9898 111.444 27.5972V32.4134C113.736 32.5985 114.831 33.9555 114.831 36.6643V52.6295C114.831 55.5285 113.515 56.8443 110.843 56.8443H90.0919C87.4242 56.8443 86.1444 55.5285 86.1444 52.6295V36.6643C86.1444 33.9555 87.2341 32.6396 89.5317 32.4494V27.5972C89.5317 19.9898 94.24 15.3226 100.485 15.3226ZM100.485 18.4838C95.8591 18.4838 92.7699 22.0253 92.7699 27.2939V32.4134H108.206V27.2939C108.206 22.0253 105.116 18.4838 100.485 18.4838Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M137.191 95.3635C147.976 95.3635 156.929 86.4616 156.929 75.5536C156.929 64.6874 147.976 55.7437 137.191 55.7437C126.364 55.7437 117.453 64.6874 117.453 75.5536C117.453 86.4616 126.364 95.3635 137.191 95.3635ZM135.043 86.5591C134.511 86.5591 133.865 86.2976 133.447 85.7745L126.644 77.1445C126.339 76.7958 126.225 76.1856 126.225 75.6625C126.225 74.3985 127.062 73.396 128.164 73.396C128.848 73.396 129.342 73.7883 129.684 74.2242L134.967 80.7185L144.545 65.507C144.888 64.9403 145.496 64.5481 146.18 64.5481C147.244 64.5481 148.156 65.4634 148.156 66.771C148.156 67.1632 148.004 67.6427 147.7 68.1221L136.678 85.6874C136.336 86.2104 135.728 86.5591 135.043 86.5591Z\" fill=\"#1AAAAD\"/>\n</svg>";

var LinealPasswordError = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g opacity=\"0.6\">\n<path opacity=\"0.6\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M29.4893 49.3055C29.7808 49.3055 30.0338 49.4144 30.2527 49.6322C30.4694 49.85 30.5794 50.0996 30.5794 50.3809C30.5794 50.6713 30.4648 50.9299 30.238 51.1568L28.5512 52.8447L30.1018 54.3692C30.3287 54.5961 30.4433 54.8547 30.4433 55.1451C30.4433 55.4355 30.3355 55.6896 30.1223 55.9074C29.909 56.1251 29.6572 56.234 29.3668 56.234C29.0583 56.234 28.7917 56.107 28.5637 55.8529L27.1072 54.3692L25.6371 55.8529C25.4012 56.0979 25.1335 56.2204 24.834 56.2204C24.5436 56.2204 24.2929 56.1138 24.0785 55.9005C23.8664 55.6873 23.7586 55.44 23.7586 55.1587C23.7586 54.8683 23.8732 54.6051 24.0989 54.3692L25.6507 52.8447L23.964 51.1568C23.7371 50.9299 23.6225 50.6713 23.6225 50.3809C23.6225 50.0996 23.7326 49.85 23.9492 49.6322C24.167 49.4144 24.4211 49.3055 24.7115 49.3055C25.0121 49.3055 25.2787 49.428 25.5146 49.6731L27.1072 51.3337L28.6862 49.6731C28.9233 49.428 29.1898 49.3055 29.4893 49.3055ZM190.789 45.5277C191.079 45.5277 191.328 45.6366 191.544 45.8543C191.756 46.0721 191.863 46.3262 191.863 46.6166C191.863 46.907 191.749 47.1656 191.521 47.3925L189.971 48.917L191.659 50.6049C191.884 50.8318 192 51.0904 192 51.3808C192 51.6621 191.889 51.9117 191.672 52.1295C191.456 52.3473 191.2 52.4562 190.91 52.4562C190.61 52.4562 190.343 52.3337 190.106 52.0886L188.528 50.428L186.935 52.0886C186.698 52.3337 186.433 52.4562 186.131 52.4562C185.841 52.4562 185.589 52.3473 185.369 52.1295C185.152 51.9117 185.043 51.6621 185.043 51.3808C185.043 51.0904 185.157 50.8318 185.385 50.6049L187.07 48.917L185.52 47.3925C185.294 47.1566 185.178 46.8934 185.178 46.603C185.178 46.3217 185.287 46.0744 185.5 45.8612C185.712 45.6479 185.965 45.5413 186.256 45.5413C186.554 45.5413 186.823 45.6638 187.058 45.9088L188.528 47.3925L189.984 45.9088C190.212 45.6547 190.478 45.5277 190.789 45.5277ZM164.18 41.1177C164.47 41.1177 164.72 41.2266 164.935 41.4444C165.147 41.6622 165.254 41.9163 165.254 42.2067C165.254 42.4971 165.14 42.7557 164.912 42.9826L163.362 44.5071L165.05 46.195C165.275 46.4219 165.391 46.6805 165.391 46.9709C165.391 47.2522 165.28 47.5018 165.063 47.7196C164.847 47.9373 164.591 48.0462 164.301 48.0462C164.002 48.0462 163.734 47.9237 163.497 47.6787L161.919 46.0181L160.326 47.6787C160.089 47.9237 159.824 48.0462 159.522 48.0462C159.232 48.0462 158.98 47.9373 158.76 47.7196C158.543 47.5018 158.434 47.2522 158.434 46.9709C158.434 46.6805 158.548 46.4219 158.776 46.195L160.461 44.5071L158.911 42.9826C158.685 42.7466 158.569 42.4835 158.569 42.1931C158.569 41.9118 158.678 41.6645 158.891 41.4512C159.104 41.238 159.357 41.1313 159.647 41.1313C159.945 41.1313 160.214 41.2539 160.449 41.4989L161.919 42.9826L163.375 41.4989C163.603 41.2448 163.869 41.1177 164.18 41.1177ZM5.86677 37.0214C6.1583 37.0214 6.41125 37.1303 6.63018 37.3481C6.84684 37.5659 6.95687 37.8155 6.95687 38.0968C6.95687 38.3872 6.8423 38.6458 6.61543 38.8727L4.92868 40.5606L6.47931 42.0851C6.70618 42.312 6.82075 42.5706 6.82075 42.861C6.82075 43.1514 6.71298 43.4055 6.49973 43.6233C6.28648 43.841 6.03465 43.9499 5.74426 43.9499C5.43573 43.9499 5.16916 43.8229 4.94116 43.5688L3.48467 42.0851L2.01458 43.5688C1.77863 43.8138 1.51093 43.9363 1.21147 43.9363C0.921079 43.9363 0.670391 43.8297 0.456002 43.6164C0.243882 43.4032 0.13612 43.1559 0.13612 42.8746C0.13612 42.5842 0.250688 42.321 0.47642 42.0851L2.02819 40.5606L0.341434 38.8727C0.114568 38.6458 0 38.3872 0 38.0968C0 37.8155 0.11003 37.5659 0.326688 37.3481C0.54448 37.1303 0.798571 37.0214 1.08896 37.0214C1.38956 37.0214 1.65613 37.1439 1.89207 37.389L3.48467 39.0496L5.06366 37.389C5.30074 37.1439 5.56731 37.0214 5.86677 37.0214ZM40.7205 30.0929C41.0109 30.0929 41.2616 30.2018 41.476 30.4196C41.6881 30.6374 41.7959 30.8915 41.7959 31.1819C41.7959 31.4723 41.6813 31.7309 41.4544 31.9578L39.9038 33.4823L41.5906 35.1702C41.8174 35.3971 41.932 35.6557 41.932 35.9461C41.932 36.2274 41.822 36.477 41.6053 36.6947C41.3875 36.9125 41.1334 37.0214 40.8419 37.0214C40.5424 37.0214 40.2759 36.8989 40.0388 36.6539L38.4598 34.9932L36.8672 36.6539C36.6313 36.8989 36.3647 37.0214 36.0641 37.0214C35.7737 37.0214 35.5208 36.9125 35.3018 36.6947C35.0852 36.477 34.9751 36.2274 34.9751 35.9461C34.9751 35.6557 35.0897 35.3971 35.3166 35.1702L37.0033 33.4823L35.4516 31.9578C35.2258 31.7218 35.1113 31.4587 35.1113 31.1683C35.1113 30.887 35.219 30.6397 35.4323 30.4264C35.6455 30.2132 35.8974 30.1065 36.1877 30.1065C36.4861 30.1065 36.7549 30.229 36.9908 30.4741L38.4598 31.9578L39.9174 30.4741C40.1443 30.22 40.4109 30.0929 40.7205 30.0929ZM179.928 25.3694C180.218 25.3694 180.469 25.4783 180.684 25.6961C180.896 25.9139 181.003 26.168 181.003 26.4583C181.003 26.7487 180.889 27.0074 180.662 27.2342L179.111 28.7588L180.798 30.4467C181.025 30.6735 181.14 30.9322 181.14 31.2225C181.14 31.5039 181.029 31.7534 180.813 31.9712C180.595 32.189 180.341 32.2979 180.049 32.2979C179.75 32.2979 179.483 32.1754 179.246 31.9304L177.667 30.2697L176.075 31.9304C175.839 32.1754 175.572 32.2979 175.272 32.2979C174.981 32.2979 174.728 32.189 174.509 31.9712C174.293 31.7534 174.183 31.5039 174.183 31.2225C174.183 30.9322 174.297 30.6735 174.524 30.4467L176.211 28.7588L174.659 27.2342C174.433 26.9983 174.319 26.7351 174.319 26.4447C174.319 26.1634 174.427 25.9161 174.64 25.7029C174.853 25.4896 175.105 25.383 175.395 25.383C175.694 25.383 175.962 25.5055 176.198 25.7505L177.667 27.2342L179.125 25.7505C179.352 25.4964 179.618 25.3694 179.928 25.3694ZM154.896 17.4502C155.186 17.4502 155.437 17.5591 155.652 17.7769C155.864 17.9947 155.971 18.2488 155.971 18.5392C155.971 18.8295 155.857 19.0882 155.63 19.315L154.079 20.8396L155.766 22.5275C155.993 22.7543 156.108 23.013 156.108 23.3034C156.108 23.5847 155.998 23.8342 155.781 24.052C155.563 24.2698 155.309 24.3787 155.017 24.3787C154.718 24.3787 154.451 24.2562 154.214 24.0112L152.635 22.3505L151.043 24.0112C150.807 24.2562 150.54 24.3787 150.24 24.3787C149.949 24.3787 149.696 24.2698 149.477 24.052C149.261 23.8342 149.151 23.5847 149.151 23.3034C149.151 23.013 149.265 22.7543 149.492 22.5275L151.179 20.8396L149.627 19.315C149.401 19.0791 149.287 18.8159 149.287 18.5255C149.287 18.2442 149.395 17.9969 149.608 17.7837C149.821 17.5704 150.073 17.4638 150.363 17.4638C150.662 17.4638 150.93 17.5863 151.166 17.8313L152.635 19.315L154.093 17.8313C154.32 17.5772 154.586 17.4502 154.896 17.4502ZM23.1585 17.4502C23.45 17.4502 23.703 17.5591 23.9219 17.7769C24.1386 17.9947 24.2486 18.2442 24.2486 18.5255C24.2486 18.8159 24.134 19.0746 23.9072 19.3014L22.2204 20.9893L23.771 22.5139C23.9979 22.7407 24.1125 22.9994 24.1125 23.2897C24.1125 23.5801 24.0047 23.8342 23.7915 24.052C23.5782 24.2698 23.3264 24.3787 23.036 24.3787C22.7274 24.3787 22.4609 24.2517 22.2329 23.9976L20.7764 22.5139L19.3063 23.9976C19.0704 24.2426 18.8027 24.3651 18.5032 24.3651C18.2128 24.3651 17.9621 24.2585 17.7477 24.0452C17.5356 23.832 17.4278 23.5847 17.4278 23.3034C17.4278 23.013 17.5424 22.7498 17.7681 22.5139L19.3199 20.9893L17.6332 19.3014C17.4063 19.0746 17.2917 18.8159 17.2917 18.5255C17.2917 18.2442 17.4018 17.9947 17.6184 17.7769C17.8362 17.5591 18.0903 17.4502 18.3807 17.4502C18.6813 17.4502 18.9478 17.5727 19.1838 17.8177L20.7764 19.4784L22.3554 17.8177C22.5925 17.5727 22.859 17.4502 23.1585 17.4502Z\" fill=\"#B6C5D5\"/>\n</g>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M95.7889 5.95264C96.7475 5.95264 97.7439 6.17397 98.7025 6.5056C103.978 8.31331 115.597 12.629 120.834 14.7313C124.227 16.0964 125.703 17.3874 125.703 21.3337V49.3672C125.703 49.6808 125.699 49.9895 125.691 50.2933C124.055 50.5805 122.474 51.0291 120.965 51.6213C121.101 50.6266 121.166 49.5607 121.166 48.4078V22.145C121.166 20.301 120.834 19.563 119.433 19.047C114.453 17.2393 102.465 12.8133 97.5596 10.8583C96.8216 10.6 96.2316 10.4156 95.7889 10.4156C95.3092 10.4156 94.6822 10.5629 94.0182 10.8583C89.0755 12.8133 77.0138 17.092 72.1081 19.047C70.7068 19.6 70.3744 20.301 70.3744 22.145V48.4078C70.3744 59.6212 76.4978 62.6829 93.6126 73.3426C94.4979 73.8585 95.1619 74.1539 95.7889 74.1539C96.3789 74.1539 97.0429 73.8585 97.9282 73.3426C100.985 71.4171 103.693 69.7409 106.079 68.2218C105.543 70.1979 105.246 72.2719 105.22 74.4109C103.089 75.6834 100.761 77.0388 98.2236 78.5066C97.3753 78.9863 96.4529 79.2809 95.7889 79.2809C95.0879 79.2809 94.1655 78.9863 93.3172 78.5066C72.7351 66.4449 65.8374 62.0551 65.8374 49.3672V21.3337C65.8374 17.3874 67.3135 16.0594 70.7068 14.7313C75.9441 12.666 87.6002 8.20227 92.8382 6.5056C93.7969 6.21099 94.7933 5.95264 95.7889 5.95264ZM95.7889 20.4121C101.654 20.4121 105.6 24.764 105.6 31.2561V36.0514C107.851 36.2358 108.92 37.4898 108.92 40.1458V54.8998C108.92 57.7402 107.666 59.0312 105.01 59.0312H86.5305C83.8745 59.0312 82.6205 57.7402 82.6205 54.8998V40.1458C82.6205 37.5268 83.6902 36.2728 85.9405 36.0514V31.2561C85.9405 24.764 89.8868 20.4121 95.7889 20.4121ZM95.7889 23.51C91.7686 23.51 89.1125 26.4977 89.1125 30.9977V36.0144L102.428 35.9774V30.9977C102.428 26.4977 99.7722 23.51 95.7889 23.51Z\" fill=\"#B6C5D5\"/>\n</g>\n<path d=\"M129.674 93.0041C139.682 93.0041 147.796 84.891 147.796 74.8829C147.796 64.8749 139.682 56.7617 129.674 56.7617C119.666 56.7617 111.553 64.8749 111.553 74.8829C111.553 84.891 119.666 93.0041 129.674 93.0041Z\" fill=\"white\"/>\n<path d=\"M129.674 95.0275C140.713 95.0275 149.808 85.9104 149.808 74.8717C149.808 63.8553 140.691 54.7383 129.674 54.7383C118.636 54.7383 109.541 63.8553 109.541 74.8717C109.541 85.9104 118.658 95.0275 129.674 95.0275ZM122.434 83.5887C121.612 83.5887 120.979 82.934 120.979 82.1329C120.979 81.7307 121.127 81.3732 121.401 81.1195L127.606 74.8929L121.401 68.6674C121.127 68.4138 120.979 68.0552 120.979 67.6541C120.979 66.8317 121.612 66.2195 122.436 66.2195C122.837 66.2195 123.174 66.367 123.449 66.6418L129.674 72.8461L135.921 66.6418C136.217 66.3245 136.555 66.177 136.935 66.177C137.737 66.177 138.39 66.8317 138.39 67.6328C138.39 68.0351 138.264 68.3512 137.948 68.6462L131.721 74.8929L137.948 81.0771C138.222 81.3732 138.37 81.7106 138.37 82.1329C138.37 82.934 137.737 83.5887 136.913 83.5887C136.491 83.5887 136.132 83.42 135.859 83.1452L129.674 76.9409L123.469 83.1452C123.217 83.42 122.837 83.5887 122.436 83.5887H122.434Z\" fill=\"#DD2457\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M95.7889 3C96.7475 3 97.7439 3.22134 98.7025 3.55296C103.978 5.36068 115.597 9.67637 120.834 11.7787C124.227 13.1437 125.703 14.4347 125.703 18.381V46.4145C125.703 47.8151 125.62 49.1159 125.445 50.338C123.609 50.6798 121.844 51.2247 120.174 51.9479C120.854 50.0786 121.166 47.9745 121.166 45.4552V19.1924C121.166 17.3484 120.834 16.6103 119.433 16.0944C114.453 14.2867 102.465 9.86069 97.5596 7.90567C96.8216 7.64732 96.2316 7.463 95.7889 7.463C95.3092 7.463 94.6822 7.61031 94.0182 7.90567C89.0755 9.86069 77.0138 14.1394 72.1081 16.0944C70.7068 16.6474 70.3744 17.3484 70.3744 19.1924V45.4552C70.3744 56.6686 76.4978 59.7303 93.6125 70.3899C94.4979 70.9059 95.1619 71.2013 95.7889 71.2013C96.3789 71.2013 97.0429 70.9059 97.9282 70.3899C101.597 68.0794 104.762 66.1278 107.472 64.3758C106.477 66.5409 105.784 68.8745 105.449 71.3218C103.256 72.6335 100.852 74.0334 98.2236 75.554C97.3753 76.0337 96.4529 76.3283 95.7889 76.3283C95.0879 76.3283 94.1655 76.0337 93.3172 75.554C72.7351 63.4922 65.8374 59.1025 65.8374 46.4145V18.381C65.8374 14.4347 67.3135 13.1067 70.7068 11.7787C75.9441 9.71339 87.6002 5.24963 92.8382 3.55296C93.7969 3.25835 94.7933 3 95.7889 3ZM95.7889 17.4594C101.654 17.4594 105.6 21.8114 105.6 28.3034V33.0988C107.851 33.2831 108.92 34.5371 108.92 37.1932V51.9472C108.92 54.7876 107.666 56.0786 105.01 56.0786H86.5305C83.8745 56.0786 82.6205 54.7876 82.6205 51.9472V37.1932C82.6205 34.5741 83.6902 33.3201 85.9405 33.0988V28.3034C85.9405 21.8114 89.8868 17.4594 95.7889 17.4594ZM95.7889 20.5574C91.7686 20.5574 89.1125 23.5451 89.1125 28.0451V33.0618L102.428 33.0248V28.0451C102.428 23.5451 99.7722 20.5574 95.7889 20.5574Z\" fill=\"#B6C5D5\"/>\n</svg>";

var LinealPasswordRecuperar = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g opacity=\"0.6\">\n<path opacity=\"0.6\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M50.0285 59.9953C50.3247 59.9953 50.5817 60.106 50.8042 60.3273C51.0243 60.5485 51.1361 60.8021 51.1361 61.0879C51.1361 61.3829 51.0197 61.6457 50.7892 61.8762L49.0755 63.591L50.6509 65.1399C50.8814 65.3704 50.9978 65.6332 50.9978 65.9282C50.9978 66.2232 50.8883 66.4814 50.6716 66.7027C50.455 66.9239 50.1991 67.0346 49.9041 67.0346C49.5906 67.0346 49.3198 66.9055 49.0881 66.6473L47.6084 65.1399L46.1148 66.6473C45.8751 66.8963 45.6031 67.0207 45.2989 67.0207C45.0038 67.0207 44.7491 66.9124 44.5313 66.6957C44.3158 66.4791 44.2063 66.2278 44.2063 65.942C44.2063 65.647 44.3227 65.3796 44.5521 65.1399L46.1286 63.591L44.4149 61.8762C44.1844 61.6457 44.068 61.3829 44.068 61.0879C44.068 60.8021 44.1798 60.5485 44.3999 60.3273C44.6212 60.106 44.8794 59.9953 45.1744 59.9953C45.4798 59.9953 45.7506 60.1198 45.9903 60.3687L47.6084 62.0559L49.2126 60.3687C49.4535 60.1198 49.7243 59.9953 50.0285 59.9953ZM15.9265 56.4757C16.2227 56.4757 16.4797 56.5864 16.7021 56.8076C16.9222 57.0289 17.034 57.2825 17.034 57.5683C17.034 57.8633 16.9176 58.1261 16.6871 58.3565L14.9734 60.0714L16.5488 61.6203C16.7793 61.8508 16.8957 62.1136 16.8957 62.4086C16.8957 62.7036 16.7862 62.9618 16.5696 63.183C16.3529 63.4043 16.0971 63.515 15.802 63.515C15.4886 63.515 15.2177 63.3859 14.9861 63.1277L13.5063 61.6203L12.0128 63.1277C11.773 63.3767 11.5011 63.5011 11.1968 63.5011C10.9018 63.5011 10.6471 63.3928 10.4293 63.1761C10.2138 62.9595 10.1043 62.7082 10.1043 62.4224C10.1043 62.1274 10.2207 61.86 10.45 61.6203L12.0266 60.0714L10.3129 58.3565C10.0824 58.1261 9.96598 57.8633 9.96598 57.5683C9.96598 57.2825 10.0778 57.0289 10.2979 56.8076C10.5192 56.5864 10.7773 56.4757 11.0723 56.4757C11.3777 56.4757 11.6486 56.6002 11.8883 56.8491L13.5063 58.5363L15.1106 56.8491C15.3514 56.6002 15.6223 56.4757 15.9265 56.4757ZM190.519 45.9169C190.814 45.9169 191.068 46.0275 191.287 46.2488C191.502 46.4701 191.611 46.7282 191.611 47.0233C191.611 47.3183 191.495 47.5811 191.264 47.8115L189.688 49.3605L191.403 51.0753C191.632 51.3058 191.75 51.5686 191.75 51.8636C191.75 52.1494 191.637 52.4029 191.417 52.6242C191.197 52.8455 190.938 52.9561 190.642 52.9561C190.338 52.9561 190.066 52.8317 189.825 52.5827L188.222 50.8955L186.604 52.5827C186.363 52.8317 186.094 52.9561 185.787 52.9561C185.492 52.9561 185.236 52.8455 185.013 52.6242C184.793 52.4029 184.682 52.1494 184.682 51.8636C184.682 51.5686 184.797 51.3058 185.029 51.0753L186.741 49.3605L185.166 47.8115C184.937 47.5718 184.819 47.3045 184.819 47.0094C184.819 46.7236 184.93 46.4724 185.146 46.2557C185.362 46.0391 185.619 45.9307 185.914 45.9307C186.217 45.9307 186.49 46.0552 186.729 46.3041L188.222 47.8115L189.702 46.3041C189.934 46.046 190.203 45.9169 190.519 45.9169ZM30.9605 33.8777C31.2567 33.8777 31.5137 33.9883 31.7361 34.2096C31.9562 34.4309 32.068 34.6844 32.068 34.9702C32.068 35.2652 31.9516 35.528 31.7211 35.7585L30.0074 37.4734L31.5828 39.0223C31.8133 39.2528 31.9297 39.5155 31.9297 39.8105C31.9297 40.1056 31.8203 40.3637 31.6036 40.585C31.3869 40.8063 31.1311 40.9169 30.8361 40.9169C30.5226 40.9169 30.2518 40.7878 30.0201 40.5297L28.5404 39.0223L27.0468 40.5297C26.8071 40.7786 26.5351 40.9031 26.2308 40.9031C25.9358 40.9031 25.6811 40.7947 25.4633 40.5781C25.2478 40.3614 25.1383 40.1102 25.1383 39.8244C25.1383 39.5293 25.2547 39.262 25.484 39.0223L27.0606 37.4734L25.3469 35.7585C25.1164 35.528 25 35.2652 25 34.9702C25 34.6844 25.1118 34.4309 25.3319 34.2096C25.5532 33.9883 25.8113 33.8777 26.1064 33.8777C26.4118 33.8777 26.6826 34.0021 26.9223 34.2511L28.5404 35.9383L30.1446 34.2511C30.3854 34.0021 30.6563 33.8777 30.9605 33.8777ZM170.337 33.5084C170.632 33.5084 170.887 33.6191 171.105 33.8404C171.32 34.0616 171.43 34.3198 171.43 34.6148C171.43 34.9098 171.313 35.1726 171.083 35.4031L169.507 36.952L171.221 38.6669C171.452 38.8973 171.568 39.1601 171.568 39.4551C171.568 39.7409 171.456 39.9945 171.236 40.2158C171.015 40.437 170.757 40.5477 170.461 40.5477C170.156 40.5477 169.885 40.4232 169.645 40.1743L168.04 38.4871L166.422 40.1743C166.183 40.4232 165.912 40.5477 165.606 40.5477C165.311 40.5477 165.054 40.437 164.832 40.2158C164.612 39.9945 164.5 39.7409 164.5 39.4551C164.5 39.1601 164.616 38.8973 164.847 38.6669L166.561 36.952L164.984 35.4031C164.755 35.1634 164.638 34.896 164.638 34.601C164.638 34.3152 164.748 34.0639 164.964 33.8473C165.181 33.6306 165.437 33.5223 165.732 33.5223C166.035 33.5223 166.308 33.6467 166.548 33.8957L168.04 35.4031L169.521 33.8957C169.752 33.6375 170.023 33.5084 170.337 33.5084ZM6.96052 22.9496C7.2567 22.9496 7.5137 23.0603 7.73612 23.2815C7.95624 23.5028 8.06803 23.7563 8.06803 24.0421C8.06803 24.3372 7.95163 24.5999 7.72114 24.8304L6.00743 26.5453L7.58285 28.0942C7.81334 28.3247 7.92974 28.5874 7.92974 28.8825C7.92974 29.1775 7.82025 29.4357 7.60359 29.6569C7.38693 29.8782 7.13108 29.9888 6.83605 29.9888C6.52258 29.9888 6.25176 29.8598 6.02011 29.6016L4.54035 28.0942L3.04677 29.6016C2.80706 29.8505 2.53508 29.975 2.23083 29.975C1.9358 29.975 1.6811 29.8667 1.46329 29.65C1.24778 29.4333 1.1383 29.1821 1.1383 28.8963C1.1383 28.6013 1.25469 28.3339 1.48403 28.0942L3.0606 26.5453L1.34689 24.8304C1.1164 24.5999 1 24.3372 1 24.0421C1 23.7563 1.11179 23.5028 1.33191 23.2815C1.55318 23.0603 1.81133 22.9496 2.10636 22.9496C2.41176 22.9496 2.68259 23.0741 2.9223 23.323L4.54035 25.0102L6.14458 23.323C6.38544 23.0741 6.65627 22.9496 6.96052 22.9496ZM46.3712 15.9104C46.6662 15.9104 46.9209 16.021 47.1388 16.2423C47.3543 16.4636 47.4638 16.7217 47.4638 17.0168C47.4638 17.3118 47.3474 17.5745 47.1169 17.805L45.5415 19.3539L47.2552 21.0688C47.4856 21.2993 47.602 21.5621 47.602 21.8571C47.602 22.1429 47.4903 22.3964 47.2701 22.6177C47.0489 22.839 46.7907 22.9496 46.4945 22.9496C46.1903 22.9496 45.9195 22.8251 45.6786 22.5762L44.0744 20.889L42.4563 22.5762C42.2166 22.8251 41.9458 22.9496 41.6404 22.9496C41.3453 22.9496 41.0883 22.839 40.8659 22.6177C40.6458 22.3964 40.534 22.1429 40.534 21.8571C40.534 21.5621 40.6504 21.2993 40.8809 21.0688L42.5946 19.3539L41.018 17.805C40.7887 17.5653 40.6723 17.298 40.6723 17.0029C40.6723 16.7171 40.7818 16.4659 40.9985 16.2492C41.2151 16.0326 41.471 15.9242 41.766 15.9242C42.0691 15.9242 42.3422 16.0487 42.5819 16.2976L44.0744 17.805L45.5553 16.2976C45.7858 16.0395 46.0566 15.9104 46.3712 15.9104ZM190.519 8.87117C190.814 8.87117 191.068 8.98181 191.287 9.20308C191.502 9.42435 191.611 9.6825 191.611 9.97753C191.611 10.2726 191.495 10.5353 191.264 10.7658L189.688 12.3147L191.403 14.0296C191.632 14.2601 191.75 14.5228 191.75 14.8179C191.75 15.1037 191.637 15.3572 191.417 15.5785C191.197 15.7998 190.938 15.9104 190.642 15.9104C190.338 15.9104 190.066 15.7859 189.825 15.537L188.222 13.8498L186.604 15.537C186.363 15.7859 186.094 15.9104 185.787 15.9104C185.492 15.9104 185.236 15.7998 185.013 15.5785C184.793 15.3572 184.682 15.1037 184.682 14.8179C184.682 14.5228 184.797 14.2601 185.029 14.0296L186.741 12.3147L185.166 10.7658C184.937 10.5261 184.819 10.2587 184.819 9.9637C184.819 9.67789 184.93 9.42666 185.146 9.21C185.362 8.99333 185.619 8.885 185.914 8.885C186.217 8.885 186.49 9.00947 186.729 9.2584L188.222 10.7658L189.702 9.2584C189.934 9.00025 190.203 8.87117 190.519 8.87117ZM156.337 5.35156C156.632 5.35156 156.887 5.4622 157.105 5.68347C157.32 5.90474 157.43 6.16289 157.43 6.45792C157.43 6.75295 157.313 7.01571 157.083 7.24621L155.507 8.79511L157.221 10.51C157.452 10.7405 157.568 11.0032 157.568 11.2983C157.568 11.5841 157.456 11.8376 157.236 12.0589C157.015 12.2801 156.757 12.3908 156.461 12.3908C156.156 12.3908 155.885 12.2663 155.645 12.0174L154.04 10.3302L152.422 12.0174C152.183 12.2663 151.912 12.3908 151.606 12.3908C151.311 12.3908 151.054 12.2801 150.832 12.0589C150.612 11.8376 150.5 11.5841 150.5 11.2983C150.5 11.0032 150.616 10.7405 150.847 10.51L152.561 8.79511L150.984 7.24621C150.755 7.00649 150.638 6.73912 150.638 6.44409C150.638 6.15828 150.748 5.90705 150.964 5.69039C151.181 5.47372 151.437 5.36539 151.732 5.36539C152.035 5.36539 152.308 5.48986 152.548 5.73879L154.04 7.24621L155.521 5.73879C155.752 5.48064 156.023 5.35156 156.337 5.35156Z\" fill=\"#B6C5D5\"/>\n</g>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M70.0796 60.0126C76.9809 69.3811 88.0794 75.5184 100.485 75.5184C104.407 75.5184 108.198 74.9006 111.765 73.7581C111.698 74.4965 111.665 75.2456 111.665 76.0026C111.665 76.4557 111.677 76.9059 111.701 77.3531C108.748 78.1137 105.66 78.5184 102.485 78.5184C88.7994 78.5184 76.7045 71.0493 70.0796 60.0126ZM145.023 33.8206L145.251 33.8304C147.44 33.8304 148.078 35.3364 146.839 37.1046L138.625 48.8137C137.572 50.2889 136.065 50.2889 135.053 48.8137L126.844 37.1046C126.665 36.8484 126.525 36.5978 126.423 36.3564L133.053 45.8137C134.031 47.2381 135.468 47.2872 136.515 45.9611L136.625 45.8137L144.839 34.1046C144.906 34.0091 144.967 33.9143 145.023 33.8206ZM84.6243 8.93136C81.9778 10.4631 79.5101 12.3058 77.3017 14.3994L77.2088 14.4882C79.3958 12.305 81.8907 10.4298 84.6243 8.93136ZM114.048 2.55566C116.43 3.39451 118.638 4.53351 120.67 5.92462L120.786 6.00396C118.672 4.64028 116.416 3.48111 114.048 2.55566Z\" fill=\"#B6C5D5\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M100.485 0C118.82 0 134.297 13.4054 137.612 30.8303H143.251C145.441 30.8303 146.078 32.3363 144.839 34.1045L136.625 45.8137C135.572 47.2889 134.065 47.2889 133.053 45.8137L124.844 34.1045C123.605 32.3363 124.243 30.8303 126.427 30.8303H132.642C129.481 15.9651 116.337 4.89337 100.485 4.89337C82.2636 4.89337 67.5886 19.5375 67.5886 37.7592C67.5886 55.9397 82.2636 70.6609 100.485 70.6301C104.886 70.6301 109.076 69.7671 112.897 68.2017C112.319 69.975 111.933 71.8352 111.764 73.7574C108.197 74.9007 104.407 75.5183 100.485 75.5183C79.7861 75.5183 62.7261 58.4326 62.7261 37.7592C62.7261 17.0548 79.7861 0 100.485 0ZM100.485 15.3226C106.741 15.3226 111.444 19.9898 111.444 27.5972V32.4134C113.736 32.5985 114.831 33.9555 114.831 36.6643V52.6295C114.831 55.5285 113.515 56.8443 110.843 56.8443H90.0919C87.4242 56.8443 86.1444 55.5285 86.1444 52.6295V36.6643C86.1444 33.9555 87.2341 32.6396 89.5317 32.4494V27.5972C89.5317 19.9898 94.24 15.3226 100.485 15.3226ZM100.485 18.4838C95.8591 18.4838 92.7699 22.0253 92.7699 27.2939V32.4134H108.206V27.2939C108.206 22.0253 105.116 18.4838 100.485 18.4838Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M143.97 71.8675C143.643 72.5545 143.254 73.1515 142.804 73.6585C142.353 74.1655 141.745 74.7905 140.98 75.5345C140.123 76.3225 139.481 76.9815 139.053 77.5105C138.625 78.0405 138.355 78.6315 138.242 79.2845C138.152 79.7125 137.966 80.0455 137.685 80.2815C137.403 80.5175 137.06 80.6365 136.655 80.6365C136.158 80.6365 135.77 80.4675 135.489 80.1295C135.206 79.7915 135.066 79.3415 135.066 78.7775C135.066 77.6285 135.274 76.6715 135.691 75.9055C136.108 75.1395 136.722 74.2955 137.533 73.3715C138.141 72.6735 138.585 72.0935 138.867 71.6315C139.149 71.1695 139.29 70.6455 139.29 70.0595C139.29 69.4295 139.059 68.9285 138.597 68.5555C138.135 68.1845 137.51 67.9985 136.722 67.9985C136 67.9985 135.33 68.1455 134.711 68.4375C134.091 68.7305 133.264 69.1815 132.228 69.7895C131.574 70.1505 131.033 70.3305 130.606 70.3305C130.132 70.3305 129.733 70.1215 129.407 69.7045C129.079 69.2885 128.916 68.7875 128.916 68.2015C128.916 67.7955 128.989 67.4525 129.136 67.1705C129.282 66.8895 129.513 66.6245 129.828 66.3765C130.82 65.5885 131.962 64.9745 133.258 64.5345C134.553 64.0955 135.855 63.8765 137.161 63.8765C138.558 63.8765 139.814 64.1245 140.929 64.6195C142.044 65.1155 142.91 65.7965 143.531 66.6635C144.15 67.5315 144.46 68.5055 144.46 69.5865C144.46 70.4205 144.296 71.1805 143.97 71.8675ZM138.749 87.3775C138.208 87.9295 137.533 88.2055 136.722 88.2055C135.888 88.2055 135.201 87.9295 134.66 87.3775C134.119 86.8255 133.85 86.1335 133.85 85.2995C133.85 84.4665 134.119 83.7735 134.66 83.2215C135.201 82.6695 135.888 82.3935 136.722 82.3935C137.533 82.3935 138.208 82.6695 138.749 83.2215C139.29 83.7735 139.56 84.4665 139.56 85.2995C139.56 86.1335 139.29 86.8255 138.749 87.3775ZM136.857 54.4365C125.058 54.4365 115.491 64.0025 115.491 75.8025C115.491 87.6015 125.058 97.1665 136.857 97.1665C148.657 97.1665 158.222 87.6015 158.222 75.8025C158.222 64.0025 148.657 54.4365 136.857 54.4365Z\" fill=\"#FECF2F\"/>\n</svg>";

var LinealQRDefault = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g opacity=\"0.6\">\n<path d=\"M17.3448 69.8752C17.6363 69.8752 17.8894 69.985 18.1081 70.2037C18.3248 70.4233 18.4351 70.6737 18.4351 70.9557C18.4351 71.2486 18.3208 71.5088 18.0943 71.7374L16.4061 73.4334L17.9574 74.9662C18.1839 75.1938 18.2992 75.454 18.2992 75.7459C18.2992 76.0378 18.1908 76.2931 17.9781 76.5128C17.7643 76.7315 17.5122 76.8413 17.2216 76.8413C16.9134 76.8413 16.6464 76.7127 16.4179 76.4574L14.9602 74.9662L13.4897 76.4574C13.2533 76.7048 12.9854 76.8275 12.686 76.8275C12.3954 76.8275 12.1443 76.7196 11.9305 76.5059C11.7178 76.2912 11.6104 76.0428 11.6104 75.7598C11.6104 75.4679 11.7247 75.2037 11.9502 74.9662L13.5035 73.4334L11.8153 71.7364C11.5888 71.5088 11.4735 71.2486 11.4735 70.9567C11.4735 70.6737 11.5838 70.4224 11.8005 70.2047C12.0192 69.985 12.2733 69.8752 12.5639 69.8752C12.8643 69.8752 13.1312 69.9988 13.3676 70.2452L14.9612 71.9145L16.5411 70.2452C16.7774 69.9979 17.0453 69.8752 17.3448 69.8752ZM41.3098 66.3921C41.6014 66.3921 41.8545 66.5019 42.0732 66.7216C42.2899 66.9403 42.4002 67.1916 42.4002 67.4736C42.4002 67.7655 42.2859 68.0258 42.0584 68.2543L40.3712 69.9504L41.9225 71.4841C42.149 71.7117 42.2643 71.9719 42.2643 72.2638C42.2643 72.5557 42.1559 72.811 41.9432 73.0297C41.7294 73.2484 41.4773 73.3582 41.1867 73.3582C40.8784 73.3582 40.6115 73.2296 40.383 72.9753L38.9253 71.4831L37.4548 72.9753C37.2184 73.2217 36.9505 73.3444 36.6511 73.3444C36.3605 73.3444 36.1094 73.2375 35.8956 73.0228C35.6829 72.8091 35.5755 72.5597 35.5755 72.2767C35.5755 71.9848 35.6898 71.7206 35.9153 71.4831L37.4686 69.9504L35.7804 68.2543C35.5538 68.0267 35.4386 67.7655 35.4386 67.4736C35.4386 67.1916 35.5489 66.9403 35.7656 66.7216C35.9833 66.5019 36.2384 66.3931 36.5289 66.3931C36.8293 66.3931 37.0963 66.5158 37.3327 66.7622L38.9263 68.4315L40.5061 66.7622C40.7425 66.5158 41.0104 66.3931 41.3098 66.3931V66.3921ZM166.064 64.0844C166.356 64.0844 166.606 64.1933 166.821 64.4119C167.034 64.6316 167.14 64.8869 167.14 65.1788C167.14 65.4707 167.027 65.731 166.798 65.9586L165.247 67.4923L166.935 69.1883C167.162 69.4159 167.277 69.6761 167.277 69.9681C167.277 70.2511 167.166 70.5024 166.949 70.7201C166.732 70.9398 166.476 71.0496 166.187 71.0496C165.887 71.0496 165.619 70.9259 165.382 70.6795L163.803 69.0102L162.209 70.6795C161.972 70.9269 161.707 71.0496 161.405 71.0496C161.114 71.0496 160.862 70.9408 160.641 70.7211C160.425 70.5024 160.316 70.2511 160.316 69.969C160.316 69.6762 160.43 69.4159 160.657 69.1883L162.344 67.4913L160.792 65.9586C160.567 65.7211 160.45 65.4569 160.45 65.165C160.45 64.882 160.56 64.6336 160.773 64.4189C160.985 64.2051 161.238 64.0973 161.529 64.0973C161.827 64.0973 162.097 64.221 162.332 64.4674L163.803 65.9586L165.261 64.4674C165.488 64.2121 165.753 64.0844 166.065 64.0844H166.064ZM6.87124 47.5142C7.16279 47.5142 7.41592 47.624 7.63457 47.8427C7.85126 48.0624 7.96157 48.3127 7.96157 48.5947C7.96157 48.8876 7.84732 49.1479 7.6198 49.3764L5.93259 51.0725L7.48388 52.6052C7.71041 52.8328 7.82565 53.093 7.82565 53.3849C7.82565 53.6768 7.71731 53.9321 7.50456 54.1518C7.29083 54.3695 7.03868 54.4803 6.74812 54.4803C6.43984 54.4803 6.17292 54.3517 5.94441 54.0964L4.4867 52.6052L3.01618 54.0964C2.77979 54.3438 2.51189 54.4665 2.21246 54.4665C1.92191 54.4665 1.67075 54.3586 1.45701 54.1449C1.24427 53.9302 1.13691 53.6818 1.13691 53.3988C1.13691 53.1069 1.25116 52.8427 1.47671 52.6052L3.02997 51.0725L1.34178 49.3754C1.11524 49.1479 1 48.8876 1 48.5957C1 48.3127 1.11031 48.0614 1.327 47.8437C1.54566 47.624 1.79977 47.5142 2.09033 47.5142C2.39074 47.5142 2.65766 47.6379 2.89404 47.8842L4.48768 49.5536L6.06753 47.8842C6.30392 47.6369 6.57182 47.5142 6.87124 47.5142ZM189.949 47.5142C190.24 47.5142 190.489 47.624 190.705 47.8427C190.918 48.0624 191.024 48.3176 191.024 48.6096C191.024 48.9015 190.911 49.1617 190.682 49.3893L189.131 50.922L190.819 52.6191C191.046 52.8466 191.161 53.1069 191.161 53.3988C191.161 53.6818 191.05 53.9331 190.833 54.1508C190.616 54.3705 190.36 54.4803 190.071 54.4803C189.771 54.4803 189.503 54.3566 189.266 54.1103L187.687 52.4409L186.093 54.1103C185.856 54.3576 185.591 54.4803 185.289 54.4803C184.998 54.4803 184.746 54.3705 184.525 54.1518C184.309 53.9321 184.2 53.6818 184.2 53.3988C184.2 53.1069 184.314 52.8466 184.541 52.6191L186.228 50.922L184.676 49.3893C184.45 49.1518 184.334 48.8876 184.334 48.5957C184.334 48.3127 184.444 48.0643 184.657 47.8496C184.869 47.6359 185.122 47.528 185.413 47.528C185.711 47.528 185.981 47.6517 186.215 47.8981L187.687 49.3893L189.145 47.8981C189.372 47.6418 189.637 47.5142 189.949 47.5142ZM37.8494 40.1839C38.1399 40.1839 38.3911 40.2927 38.6048 40.5124C38.8176 40.7311 38.9249 40.9874 38.9249 41.2783C38.9249 41.5702 38.8107 41.8304 38.5832 42.059L37.0319 43.5908L38.7191 45.2878C38.9466 45.5154 39.0609 45.7766 39.0609 46.0685C39.0609 46.3505 38.9515 46.6018 38.7339 46.8205C38.5172 47.0392 38.2621 47.149 37.9705 47.149C37.6711 47.149 37.4042 47.0263 37.1668 46.7799L35.587 45.1106L33.9933 46.7799C33.757 47.0263 33.491 47.149 33.1896 47.149C32.8991 47.149 32.6459 47.0402 32.4263 46.8205C32.2096 46.6018 32.0993 46.3505 32.0993 46.0685C32.0993 45.7766 32.2145 45.5163 32.4411 45.2878L34.1293 43.5908L32.576 42.059C32.3505 41.8215 32.2362 41.5563 32.2362 41.2644C32.2362 40.9824 32.3445 40.733 32.5573 40.5193C32.77 40.3046 33.0222 40.1977 33.3127 40.1977C33.6112 40.1977 33.8811 40.3204 34.1165 40.5668L35.587 42.059L37.0447 40.5668C37.2722 40.3115 37.5391 40.1839 37.8494 40.1839ZM168.281 33.2177C168.571 33.2177 168.822 33.3275 169.036 33.5472C169.249 33.7649 169.356 34.0212 169.356 34.3131C169.356 34.605 169.242 34.8652 169.014 35.0928L167.463 36.6266L169.15 38.3226C169.378 38.5502 169.492 38.8104 169.492 39.1023C169.492 39.3853 169.383 39.6367 169.165 39.8553C168.948 40.074 168.693 40.1839 168.402 40.1839C168.102 40.1839 167.835 40.0602 167.598 39.8138L166.018 38.1445L164.425 39.8138C164.188 40.0612 163.922 40.1839 163.621 40.1839C163.33 40.1839 163.077 40.075 162.858 39.8553C162.641 39.6367 162.531 39.3853 162.531 39.1033C162.531 38.8104 162.646 38.5512 162.872 38.3226L164.561 36.6256L163.007 35.0928C162.782 34.8553 162.667 34.5911 162.667 34.2992C162.667 34.0162 162.776 33.7679 162.989 33.5531C163.201 33.3394 163.453 33.2325 163.744 33.2325C164.042 33.2325 164.312 33.3552 164.548 33.6016L166.018 35.0928L167.476 33.6016C167.704 33.3463 167.97 33.2187 168.281 33.2187V33.2177ZM21.1864 22.7714C21.4779 22.7714 21.7311 22.8803 21.9497 23.0999C22.1664 23.3186 22.2767 23.57 22.2767 23.852C22.2767 24.1439 22.1625 24.4041 21.9359 24.6327L20.2468 26.3287L21.798 27.8605C22.0246 28.0881 22.1398 28.3493 22.1398 28.6412C22.1398 28.9331 22.0315 29.1884 21.8187 29.4071C21.605 29.6258 21.3529 29.7356 21.0623 29.7356C20.754 29.7356 20.4871 29.608 20.2586 29.3527L18.8009 27.8605L17.3303 29.3527C17.094 29.5991 16.8261 29.7218 16.5266 29.7218C16.2361 29.7218 15.9849 29.6149 15.7712 29.4002C15.5584 29.1864 15.4511 28.9371 15.4511 28.6551C15.4511 28.3632 15.5653 28.098 15.7909 27.8605L17.3441 26.3287L15.6559 24.6317C15.4294 24.4041 15.3142 24.1429 15.3142 23.851C15.3142 23.569 15.4245 23.3176 15.6412 23.099C15.8598 22.8793 16.1139 22.7704 16.4045 22.7704C16.7049 22.7704 16.9718 22.8931 17.2082 23.1395L18.8019 24.8088L20.3817 23.1395C20.6181 22.8931 20.886 22.7704 21.1854 22.7704L21.1864 22.7714ZM147.08 2C147.37 2 147.622 2.10885 147.835 2.32852C148.048 2.5472 148.155 2.80348 148.155 3.09539C148.155 3.3873 148.041 3.64655 147.814 3.87512L146.262 5.40788L147.95 7.10489C148.177 7.33248 148.291 7.59272 148.291 7.88463C148.291 8.16763 148.182 8.41896 147.964 8.63666C147.748 8.85633 147.493 8.96517 147.201 8.96517C146.902 8.96517 146.635 8.84247 146.397 8.59609L144.817 6.92678L143.224 8.59609C142.987 8.84247 142.721 8.96517 142.42 8.96517C142.13 8.96517 141.876 8.85633 141.657 8.63765C141.44 8.41797 141.33 8.16763 141.33 7.88463C141.33 7.59272 141.445 7.33248 141.672 7.10489L143.36 5.40788L141.806 3.87414C141.581 3.63764 141.467 3.37344 141.467 3.08154C141.467 2.79854 141.575 2.55017 141.788 2.33544C142.001 2.12072 142.253 2.01385 142.543 2.01385C142.842 2.01385 143.112 2.13754 143.347 2.38294L144.817 3.87512L146.275 2.38294C146.503 2.12765 146.77 2 147.08 2Z\" fill=\"#B6C5D5\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M110.719 52.8736H129.411C134.629 52.8736 137.258 50.2443 137.258 44.8215V26.4578C137.258 21.035 134.629 18.4468 129.411 18.4468H110.719C105.461 18.4468 102.831 21.035 102.831 26.4578V44.8215C102.831 50.2443 105.461 52.8736 110.719 52.8736ZM69.4727 52.8736H88.2061C93.4235 52.8736 96.0528 50.2443 96.0528 44.8215V26.4578C96.0528 21.035 93.4235 18.4468 88.2061 18.4468H69.4727C64.2552 18.4468 61.626 21.035 61.626 26.4578V44.8215C61.626 50.2443 64.2552 52.8736 69.4727 52.8736ZM69.5548 47.081C68.117 47.081 67.4186 46.3415 67.4186 44.8215V26.4578C67.4186 24.9788 68.117 24.2394 69.5548 24.2394H88.0829C89.5207 24.2394 90.2602 24.9788 90.2602 26.4578V44.8215C90.2602 46.3415 89.5207 47.081 88.0829 47.081H69.5548ZM110.801 47.081C109.322 47.081 108.624 46.3415 108.624 44.8215V26.4578C108.624 24.9788 109.322 24.2394 110.801 24.2394H129.329C130.767 24.2394 131.466 24.9788 131.466 26.4578V44.8215C131.466 46.3415 130.767 47.081 129.329 47.081H110.801ZM75.3063 39.9738H82.3314C82.9065 39.9738 83.153 39.7273 83.153 39.0289V32.2093C83.153 31.552 82.9065 31.3055 82.3314 31.3055H75.3063C74.6901 31.3055 74.4847 31.552 74.4847 32.2093V39.0289C74.4847 39.7273 74.6901 39.9738 75.3063 39.9738ZM116.758 39.9738H123.783C124.399 39.9738 124.646 39.7273 124.646 39.0289V32.2093C124.646 31.552 124.399 31.3055 123.783 31.3055H116.758C116.183 31.3055 115.978 31.552 115.978 32.2093V39.0289C115.978 39.7273 116.183 39.9738 116.758 39.9738ZM69.4727 94.0789H88.2061C93.4235 94.0789 96.0528 91.4908 96.0528 86.0679V67.6632C96.0528 62.2814 93.4235 59.6521 88.2061 59.6521H69.4727C64.2552 59.6521 61.626 62.2814 61.626 67.6632V86.0679C61.626 91.4908 64.2552 94.0789 69.4727 94.0789ZM69.5548 88.2864C68.117 88.2864 67.4186 87.5469 67.4186 86.0679V67.7042C67.4186 66.1842 68.117 65.4447 69.5548 65.4447H88.0829C89.5207 65.4447 90.2602 66.1842 90.2602 67.7042V86.0679C90.2602 87.5469 89.5207 88.2864 88.0829 88.2864H69.5548ZM75.3063 81.2202H82.3314C82.9065 81.2202 83.153 80.9738 83.153 80.2343V73.4557C83.153 72.7984 82.9065 72.5519 82.3314 72.5519H75.3063C74.6901 72.5519 74.4847 72.7984 74.4847 73.4557V80.2343C74.4847 80.9738 74.6901 81.2202 75.3063 81.2202Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M112.65 83.4386C113.225 83.4386 113.472 83.6851 113.472 84.3424V91.1621C113.472 91.8605 113.225 92.107 112.65 92.107H105.625C105.009 92.107 104.803 91.8605 104.803 91.1621V84.3424C104.803 83.6851 105.009 83.4386 105.625 83.4386H112.65ZM134.465 83.4386C135.04 83.4386 135.286 83.6851 135.286 84.3424V91.1621C135.286 91.8605 135.04 92.107 134.465 92.107H127.439C126.823 92.107 126.618 91.8605 126.618 91.1621V84.3424C126.618 83.6851 126.823 83.4386 127.439 83.4386H134.465ZM123.66 72.5519C124.235 72.5519 124.482 72.7984 124.482 73.4557V80.2342C124.482 80.9737 124.235 81.2202 123.66 81.2202H116.635C116.019 81.2202 115.813 80.9737 115.813 80.2342V73.4557C115.813 72.7984 116.019 72.5519 116.635 72.5519H123.66ZM112.65 61.624C113.225 61.624 113.472 61.8705 113.472 62.5278V69.3475C113.472 70.0459 113.225 70.2923 112.65 70.2923H105.625C105.009 70.2923 104.803 70.0459 104.803 69.3475V62.5278C104.803 61.8705 105.009 61.624 105.625 61.624H112.65ZM134.465 61.624C135.04 61.624 135.286 61.8705 135.286 62.5278V69.3475C135.286 70.0459 135.04 70.2923 134.465 70.2923H127.439C126.823 70.2923 126.618 70.0459 126.618 69.3475V62.5278C126.618 61.8705 126.823 61.624 127.439 61.624H134.465Z\" fill=\"#1AAAAD\"/>\n</svg>";

var LinealQRLoader = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.1639 56.6843C32.2573 56.6843 33.1447 57.5717 33.1447 58.6651C33.1447 59.7585 32.2573 60.6459 31.1639 60.6459H10.0783C8.9839 60.6459 8.09749 59.7585 8.09749 58.6651C8.09749 57.5717 8.9839 56.6843 10.0783 56.6843H31.1639ZM39.9353 47.0692C41.0287 47.0692 41.9161 47.9566 41.9161 49.05C41.9161 50.1434 41.0287 51.0307 39.9353 51.0307H19.9194C18.826 51.0307 17.9386 50.1434 17.9386 49.05C17.9386 47.9566 18.826 47.0692 19.9194 47.0692H39.9353ZM10.0783 47.0692C11.1717 47.0692 12.0591 47.9566 12.0591 49.05C12.0591 50.1434 11.1717 51.0307 10.0783 51.0307H1.9808C0.887396 51.0307 0 50.1434 0 49.05C0 47.9566 0.887396 47.0692 1.9808 47.0692H10.0783ZM36.5753 37.4543C37.6687 37.4543 38.5561 38.3417 38.5561 39.4351C38.5561 40.5285 37.6687 41.4159 36.5753 41.4159H10.7536C9.65925 41.4159 8.77284 40.5285 8.77284 39.4351C8.77284 38.3417 9.65925 37.4543 10.7536 37.4543H36.5753ZM166.153 36.8678C167.246 36.8678 168.134 37.7552 168.134 38.8486C168.134 39.942 167.246 40.8294 166.153 40.8294H155.189C154.095 40.8294 153.208 39.942 153.208 38.8486C153.208 37.7552 154.095 36.8678 155.189 36.8678H166.153ZM177.118 36.8678C178.211 36.8678 179.099 37.7552 179.099 38.8486C179.099 39.942 178.211 40.8294 177.118 40.8294H173.745C172.65 40.8294 171.764 39.942 171.764 38.8486C171.764 37.7552 172.65 36.8678 173.745 36.8678H177.118ZM190.019 27.2525C191.113 27.2525 192 28.1399 192 29.2333C192 30.3267 191.113 31.2141 190.019 31.2141H181.525C180.43 31.2141 179.544 30.3267 179.544 29.2333C179.544 28.1399 180.43 27.2525 181.525 27.2525H190.019ZM171.747 27.2525C172.841 27.2525 173.728 28.1399 173.728 29.2333C173.728 30.3267 172.841 31.2141 171.747 31.2141H157.469C156.375 31.2141 155.488 30.3267 155.488 29.2333C155.488 28.1399 156.375 27.2525 157.469 27.2525H171.747ZM180.317 17.6372C181.411 17.6372 182.298 18.5246 182.298 19.618C182.298 20.7114 181.411 21.5988 180.317 21.5988H163.702C162.608 21.5988 161.722 20.7114 161.722 19.618C161.722 18.5246 162.608 17.6372 163.702 17.6372H180.317ZM155.869 17.6372C156.962 17.6372 157.85 18.5246 157.85 19.618C157.85 20.7114 156.962 21.5988 155.869 21.5988H152.496C151.401 21.5988 150.515 20.7114 150.515 19.618C150.515 18.5246 151.401 17.6372 152.496 17.6372H155.869Z\" fill=\"#B6C5D5\"/>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M65.8594 57.4617V64.6743C65.8594 70.2556 70.3407 74.8139 75.9062 74.9618L76.1854 74.9655H83.4223V78.289H76.1854C68.756 78.289 62.6928 72.3477 62.5281 64.982L62.5247 64.6743V57.4617H65.8594ZM91.2269 44.845C94.3701 44.845 95.9952 46.3821 96.0785 49.5265L96.0819 49.785V61.1343C96.0819 64.3903 94.5396 65.9891 91.4784 66.071L91.2269 66.0743H79.6358C76.4926 66.0743 74.8676 64.5612 74.7842 61.3947L74.7808 61.1343V49.785C74.7808 46.5536 76.3231 44.9315 79.3843 44.8483L79.6358 44.845H91.2269ZM106.351 59.513C106.675 59.513 106.83 59.6386 106.856 59.966L106.86 60.0703V64.2757C106.86 64.6672 106.734 64.8284 106.443 64.8545L106.351 64.8583H102.005C101.658 64.8583 101.521 64.7327 101.499 64.3863L101.496 64.2757V60.0703C101.496 59.7018 101.601 59.5427 101.907 59.5168L102.005 59.513H106.351ZM91.1506 48.417H79.6867C78.8494 48.417 78.4173 48.8209 78.3694 49.6499L78.3649 49.8103V61.1343C78.3649 61.9927 78.7477 62.4471 79.5344 62.4976L79.6867 62.5023H91.1506C91.988 62.5023 92.4425 62.0984 92.4931 61.2905L92.4978 61.1343V49.8103C92.4978 48.873 92.0403 48.417 91.1506 48.417ZM87.592 52.7997C87.9155 52.7997 88.071 52.9253 88.0965 53.2526L88.1004 53.357V57.537C88.1004 57.9515 87.9743 58.1148 87.684 58.1411L87.592 58.145H83.2453C82.8958 58.145 82.7599 58.0173 82.7397 57.6447L82.737 57.537V53.357C82.737 52.9885 82.842 52.8294 83.1476 52.8035L83.2453 52.7997H87.592ZM113.163 52.7997C113.487 52.7997 113.642 52.9253 113.668 53.2526L113.672 53.357V57.537C113.672 57.9515 113.546 58.1148 113.255 58.1411L113.163 58.145H108.817C108.467 58.145 108.331 58.0173 108.311 57.6447L108.308 57.537V53.357C108.308 52.9885 108.413 52.8294 108.719 52.8035L108.817 52.7997H113.163ZM106.351 46.061C106.675 46.061 106.83 46.1866 106.856 46.514L106.86 46.6183V50.8237C106.86 51.2152 106.734 51.3764 106.443 51.4025L106.351 51.4063H102.005C101.658 51.4063 101.521 51.2807 101.499 50.9343L101.496 50.8237V46.6183C101.496 46.2498 101.601 46.0907 101.907 46.0648L102.005 46.061H106.351ZM119.849 46.061C120.172 46.061 120.328 46.1866 120.353 46.514L120.357 46.6183V50.8237C120.357 51.2152 120.231 51.3764 119.941 51.4025L119.849 51.4063H115.502C115.155 51.4063 115.019 51.2807 114.997 50.9343L114.994 50.8237V46.6183C114.994 46.2498 115.099 46.0907 115.404 46.0648L115.502 46.061H119.849ZM116.722 19.4356C119.865 19.4356 121.49 20.9487 121.574 24.1152L121.577 24.3756V35.6996C121.577 38.9556 120.035 40.5784 116.974 40.6616L116.722 40.665H105.156C101.988 40.665 100.363 39.1278 100.279 35.9601L100.276 35.6996V24.3756C100.276 21.1196 101.818 19.5208 104.903 19.4389L105.156 19.4356H116.722ZM91.2269 19.4356C94.3701 19.4356 95.9952 20.9487 96.0785 24.1152L96.0819 24.3756V35.6996C96.0819 38.9556 94.5396 40.5784 91.4784 40.6616L91.2269 40.665H79.6358C76.4926 40.665 74.8676 39.1278 74.7842 35.9601L74.7808 35.6996V24.3756C74.7808 21.1196 76.3231 19.5208 79.3843 19.4389L79.6358 19.4356H91.2269ZM91.1506 23.0076H79.6867C78.8494 23.0076 78.4173 23.4115 78.3694 24.2194L78.3649 24.3756V35.6996C78.3649 36.5818 78.7477 37.0377 79.5344 37.0882L79.6867 37.093H91.1506C91.988 37.093 92.4425 36.689 92.4931 35.8601L92.4978 35.6996V24.3756C92.4978 23.4636 92.0403 23.0076 91.1506 23.0076ZM116.671 23.0076H105.207C104.346 23.0076 103.913 23.4115 103.865 24.2194L103.86 24.3756V35.6996C103.86 36.5818 104.243 37.0377 105.051 37.0882L105.207 37.093H116.671C117.509 37.093 117.941 36.689 117.989 35.8601L117.993 35.6996V24.3756C117.993 23.4636 117.561 23.0076 116.671 23.0076ZM87.592 27.365C87.9155 27.365 88.071 27.4906 88.0965 27.8179L88.1004 27.9223V32.1276C88.1004 32.5191 87.9743 32.6804 87.684 32.7064L87.592 32.7103H83.2453C82.8987 32.7103 82.7622 32.5847 82.7402 32.2383L82.737 32.1276V27.9223C82.737 27.5538 82.842 27.3947 83.1476 27.3688L83.2453 27.365H87.592ZM113.24 27.365C113.586 27.365 113.744 27.4906 113.77 27.8179L113.774 27.9223V32.1276C113.774 32.5191 113.647 32.6804 113.338 32.7064L113.24 32.7103H108.893C108.57 32.7103 108.435 32.5847 108.413 32.2383L108.41 32.1276V27.9223C108.41 27.5538 108.515 27.3947 108.802 27.3688L108.893 27.365H113.24ZM120.173 7.22092C127.601 7.22092 133.665 13.1617 133.83 20.5274L133.833 20.8351V28.0482H130.499V20.8351C130.499 15.2538 126.017 10.6961 120.452 10.5481L120.173 10.5444H112.936V7.22092H120.173ZM83.4226 7.2207V10.5442H76.1851C70.5849 10.5442 66.0118 15.0104 65.8633 20.5572L65.8596 20.8354V28.048H62.5249V20.8354C62.5249 13.431 68.4857 7.38829 75.8763 7.22413L76.1851 7.2207H83.4226Z\" fill=\"#B6C5D5\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M65.8594 55.241V62.4536C65.8594 68.0349 70.3407 72.5932 75.9062 72.7411L76.1854 72.7448H83.4223V76.0683H76.1854C68.756 76.0683 62.6928 70.127 62.5281 62.7613L62.5247 62.4536V55.241H65.8594ZM91.2269 42.6243C94.3701 42.6243 95.9952 44.1614 96.0785 47.3058L96.0819 47.5643V58.9136C96.0819 62.1696 94.5396 63.7684 91.4784 63.8503L91.2269 63.8536H79.6358C76.4926 63.8536 74.8676 62.3405 74.7842 59.174L74.7808 58.9136V47.5643C74.7808 44.3329 76.3231 42.7108 79.3843 42.6276L79.6358 42.6243H91.2269ZM106.351 57.2923C106.675 57.2923 106.83 57.4179 106.856 57.7453L106.86 57.8496V62.055C106.86 62.4465 106.734 62.6077 106.443 62.6338L106.351 62.6376H102.005C101.658 62.6376 101.521 62.512 101.499 62.1656L101.496 62.055V57.8496C101.496 57.4811 101.601 57.322 101.907 57.2961L102.005 57.2923H106.351ZM91.1506 46.1963H79.6867C78.8494 46.1963 78.4173 46.6002 78.3694 47.4292L78.3649 47.5896V58.9136C78.3649 59.772 78.7477 60.2264 79.5344 60.2769L79.6867 60.2816H91.1506C91.988 60.2816 92.4425 59.8777 92.4931 59.0698L92.4978 58.9136V47.5896C92.4978 46.6523 92.0403 46.1963 91.1506 46.1963ZM87.592 50.579C87.9155 50.579 88.071 50.7046 88.0965 51.0319L88.1004 51.1363V55.3163C88.1004 55.7308 87.9743 55.8941 87.684 55.9204L87.592 55.9243H83.2453C82.8958 55.9243 82.7599 55.7966 82.7397 55.4241L82.737 55.3163V51.1363C82.737 50.7678 82.842 50.6087 83.1476 50.5828L83.2453 50.579H87.592ZM113.163 50.579C113.487 50.579 113.642 50.7046 113.668 51.0319L113.672 51.1363V55.3163C113.672 55.7308 113.546 55.8941 113.255 55.9204L113.163 55.9243H108.817C108.467 55.9243 108.331 55.7966 108.311 55.4241L108.308 55.3163V51.1363C108.308 50.7678 108.413 50.6087 108.719 50.5828L108.817 50.579H113.163ZM106.351 43.8403C106.675 43.8403 106.83 43.9659 106.856 44.2933L106.86 44.3976V48.603C106.86 48.9945 106.734 49.1557 106.443 49.1818L106.351 49.1856H102.005C101.658 49.1856 101.521 49.06 101.499 48.7136L101.496 48.603V44.3976C101.496 44.0291 101.601 43.87 101.907 43.8441L102.005 43.8403H106.351ZM119.849 43.8403C120.172 43.8403 120.328 43.9659 120.353 44.2933L120.357 44.3976V48.603C120.357 48.9945 120.231 49.1557 119.941 49.1818L119.849 49.1856H115.502C115.155 49.1856 115.019 49.06 114.997 48.7136L114.994 48.603V44.3976C114.994 44.0291 115.099 43.87 115.404 43.8441L115.502 43.8403H119.849ZM116.722 17.2149C119.865 17.2149 121.49 18.728 121.574 21.8945L121.577 22.1549V33.4789C121.577 36.7349 120.035 38.3577 116.974 38.4409L116.722 38.4443H105.156C101.988 38.4443 100.363 36.9071 100.279 33.7394L100.276 33.4789V22.1549C100.276 18.8989 101.818 17.3001 104.903 17.2182L105.156 17.2149H116.722ZM91.2269 17.2149C94.3701 17.2149 95.9952 18.728 96.0785 21.8945L96.0819 22.1549V33.4789C96.0819 36.7349 94.5396 38.3577 91.4784 38.4409L91.2269 38.4443H79.6358C76.4926 38.4443 74.8676 36.9071 74.7842 33.7394L74.7808 33.4789V22.1549C74.7808 18.8989 76.3231 17.3001 79.3843 17.2182L79.6358 17.2149H91.2269ZM91.1506 20.7869H79.6867C78.8494 20.7869 78.4173 21.1908 78.3694 21.9987L78.3649 22.1549V33.4789C78.3649 34.3611 78.7477 34.817 79.5344 34.8675L79.6867 34.8723H91.1506C91.988 34.8723 92.4425 34.4683 92.4931 33.6394L92.4978 33.4789V22.1549C92.4978 21.2429 92.0403 20.7869 91.1506 20.7869ZM116.671 20.7869H105.207C104.346 20.7869 103.913 21.1908 103.865 21.9987L103.86 22.1549V33.4789C103.86 34.3611 104.243 34.817 105.051 34.8675L105.207 34.8723H116.671C117.509 34.8723 117.941 34.4683 117.989 33.6394L117.993 33.4789V22.1549C117.993 21.2429 117.561 20.7869 116.671 20.7869ZM87.592 25.1443C87.9155 25.1443 88.071 25.2699 88.0965 25.5972L88.1004 25.7016V29.9069C88.1004 30.2984 87.9743 30.4597 87.684 30.4857L87.592 30.4896H83.2453C82.8987 30.4896 82.7622 30.364 82.7402 30.0176L82.737 29.9069V25.7016C82.737 25.3331 82.842 25.174 83.1476 25.1481L83.2453 25.1443H87.592ZM113.24 25.1443C113.586 25.1443 113.744 25.2699 113.77 25.5972L113.774 25.7016V29.9069C113.774 30.2984 113.647 30.4597 113.338 30.4857L113.24 30.4896H108.893C108.57 30.4896 108.435 30.364 108.413 30.0176L108.41 29.9069V25.7016C108.41 25.3331 108.515 25.174 108.802 25.1481L108.893 25.1443H113.24ZM120.173 5.00022C127.601 5.00022 133.665 10.941 133.83 18.3067L133.833 18.6144V25.8275H130.499V18.6144C130.499 13.0331 126.017 8.47537 120.452 8.32743L120.173 8.32373H112.936V5.00022H120.173ZM83.4226 5V8.32351H76.1851C70.5849 8.32351 66.0118 12.7897 65.8633 18.3365L65.8596 18.6147V25.8273H62.5249V18.6147C62.5249 11.2103 68.4857 5.16759 75.8763 5.00343L76.1851 5H83.4226Z\" fill=\"#B6C5D5\"/>\n<path d=\"M130.312 91.9911C141.185 91.9911 150 83.1763 150 72.3027C150 61.4291 141.185 52.6143 130.312 52.6143C119.438 52.6143 110.623 61.4291 110.623 72.3027C110.623 83.1763 119.438 91.9911 130.312 91.9911Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M126.364 64.81C127.618 64.0713 129.074 63.6482 130.63 63.6482C135.023 63.6482 138.64 67.0272 139.112 71.3717H137.418C136.987 71.3717 136.737 71.866 136.988 72.2213L139.635 75.9746C139.846 76.2736 140.284 76.2736 140.494 75.9746L143.141 72.2213C143.392 71.866 143.142 71.3717 142.712 71.3717H141.018C140.539 65.9589 136.071 61.7173 130.63 61.7173C128.732 61.7173 126.949 62.2345 125.414 63.1386C124.961 63.4056 124.806 63.9962 125.068 64.4577C125.331 64.9193 125.911 65.077 126.364 64.81ZM120.242 73.3026H118.549C118.118 73.3026 117.868 72.8083 118.119 72.4529L120.766 68.6997C120.977 68.4006 121.414 68.4006 121.625 68.6997L124.272 72.4529C124.523 72.8083 124.273 73.3026 123.842 73.3026H122.148C122.62 77.647 126.238 81.0261 130.63 81.0261C132.202 81.0261 133.671 80.5944 134.934 79.8418C135.386 79.5725 135.967 79.7271 136.231 80.1873C136.496 80.6475 136.344 81.2388 135.892 81.5082C134.347 82.4293 132.547 82.9569 130.63 82.9569C125.189 82.9569 120.721 78.7153 120.242 73.3026Z\" fill=\"white\"/>\n</svg>";

var LinealQRSucess = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.1639 56.6843C32.2573 56.6843 33.1447 57.5717 33.1447 58.6651C33.1447 59.7585 32.2573 60.6459 31.1639 60.6459H10.0783C8.9839 60.6459 8.09749 59.7585 8.09749 58.6651C8.09749 57.5717 8.9839 56.6843 10.0783 56.6843H31.1639ZM39.9353 47.0692C41.0287 47.0692 41.9161 47.9566 41.9161 49.05C41.9161 50.1434 41.0287 51.0307 39.9353 51.0307H19.9194C18.826 51.0307 17.9386 50.1434 17.9386 49.05C17.9386 47.9566 18.826 47.0692 19.9194 47.0692H39.9353ZM10.0783 47.0692C11.1717 47.0692 12.0591 47.9566 12.0591 49.05C12.0591 50.1434 11.1717 51.0307 10.0783 51.0307H1.9808C0.887396 51.0307 0 50.1434 0 49.05C0 47.9566 0.887396 47.0692 1.9808 47.0692H10.0783ZM36.5753 37.4543C37.6687 37.4543 38.5561 38.3417 38.5561 39.4351C38.5561 40.5285 37.6687 41.4159 36.5753 41.4159H10.7536C9.65925 41.4159 8.77284 40.5285 8.77284 39.4351C8.77284 38.3417 9.65925 37.4543 10.7536 37.4543H36.5753ZM166.153 36.8678C167.246 36.8678 168.134 37.7552 168.134 38.8486C168.134 39.942 167.246 40.8294 166.153 40.8294H155.189C154.095 40.8294 153.208 39.942 153.208 38.8486C153.208 37.7552 154.095 36.8678 155.189 36.8678H166.153ZM177.118 36.8678C178.211 36.8678 179.099 37.7552 179.099 38.8486C179.099 39.942 178.211 40.8294 177.118 40.8294H173.745C172.65 40.8294 171.764 39.942 171.764 38.8486C171.764 37.7552 172.65 36.8678 173.745 36.8678H177.118ZM190.019 27.2525C191.113 27.2525 192 28.1399 192 29.2333C192 30.3267 191.113 31.2141 190.019 31.2141H181.525C180.43 31.2141 179.544 30.3267 179.544 29.2333C179.544 28.1399 180.43 27.2525 181.525 27.2525H190.019ZM171.747 27.2525C172.841 27.2525 173.728 28.1399 173.728 29.2333C173.728 30.3267 172.841 31.2141 171.747 31.2141H157.469C156.375 31.2141 155.488 30.3267 155.488 29.2333C155.488 28.1399 156.375 27.2525 157.469 27.2525H171.747ZM180.317 17.6372C181.411 17.6372 182.298 18.5246 182.298 19.618C182.298 20.7114 181.411 21.5988 180.317 21.5988H163.702C162.608 21.5988 161.722 20.7114 161.722 19.618C161.722 18.5246 162.608 17.6372 163.702 17.6372H180.317ZM155.869 17.6372C156.962 17.6372 157.85 18.5246 157.85 19.618C157.85 20.7114 156.962 21.5988 155.869 21.5988H152.496C151.401 21.5988 150.515 20.7114 150.515 19.618C150.515 18.5246 151.401 17.6372 152.496 17.6372H155.869Z\" fill=\"#B6C5D5\"/>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M65.8591 57.4617V64.6743C65.8591 70.2556 70.3405 74.8139 75.906 74.9618L76.1852 74.9655H83.4221V78.289H76.1852C68.7557 78.289 62.6926 72.3477 62.5279 64.982L62.5244 64.6743V57.4617H65.8591ZM91.2266 44.845C94.3699 44.845 95.9949 46.3821 96.0783 49.5265L96.0817 49.785V61.1343C96.0817 64.3903 94.5393 65.9891 91.4782 66.071L91.2266 66.0743H79.6356C76.4924 66.0743 74.8673 64.5612 74.784 61.3947L74.7806 61.1343V49.785C74.7806 46.5536 76.3229 44.9315 79.3841 44.8483L79.6356 44.845H91.2266ZM106.351 59.513C106.674 59.513 106.83 59.6386 106.855 59.966L106.859 60.0703V64.2757C106.859 64.6672 106.733 64.8284 106.443 64.8545L106.351 64.8583H102.004C101.658 64.8583 101.521 64.7327 101.499 64.3863L101.496 64.2757V60.0703C101.496 59.7018 101.601 59.5427 101.907 59.5168L102.004 59.513H106.351ZM91.1504 48.417H79.6864C78.8491 48.417 78.4171 48.8209 78.3692 49.6499L78.3647 49.8103V61.1343C78.3647 61.9927 78.7474 62.4471 79.5342 62.4976L79.6864 62.5023H91.1504C91.9877 62.5023 92.4423 62.0984 92.4929 61.2905L92.4976 61.1343V49.8103C92.4976 48.873 92.0401 48.417 91.1504 48.417ZM87.5917 52.7997C87.9153 52.7997 88.0707 52.9253 88.0963 53.2526L88.1001 53.357V57.537C88.1001 57.9515 87.9741 58.1148 87.6838 58.1411L87.5917 58.145H83.2451C82.8956 58.145 82.7597 58.0173 82.7394 57.6447L82.7367 57.537V53.357C82.7367 52.9885 82.8418 52.8294 83.1473 52.8035L83.2451 52.7997H87.5917ZM113.163 52.7997C113.487 52.7997 113.642 52.9253 113.668 53.2526L113.672 53.357V57.537C113.672 57.9515 113.546 58.1148 113.255 58.1411L113.163 58.145H108.817C108.467 58.145 108.331 58.0173 108.311 57.6447L108.308 57.537V53.357C108.308 52.9885 108.413 52.8294 108.719 52.8035L108.817 52.7997H113.163ZM106.351 46.061C106.674 46.061 106.83 46.1866 106.855 46.514L106.859 46.6183V50.8237C106.859 51.2152 106.733 51.3764 106.443 51.4025L106.351 51.4063H102.004C101.658 51.4063 101.521 51.2807 101.499 50.9343L101.496 50.8237V46.6183C101.496 46.2498 101.601 46.0907 101.907 46.0648L102.004 46.061H106.351ZM119.848 46.061C120.172 46.061 120.327 46.1866 120.353 46.514L120.357 46.6183V50.8237C120.357 51.2152 120.231 51.3764 119.94 51.4025L119.848 51.4063H115.502C115.155 51.4063 115.019 51.2807 114.997 50.9343L114.993 50.8237V46.6183C114.993 46.2498 115.098 46.0907 115.404 46.0648L115.502 46.061H119.848ZM116.722 19.4356C119.865 19.4356 121.49 20.9487 121.573 24.1152L121.577 24.3756V35.6996C121.577 38.9556 120.035 40.5784 116.973 40.6616L116.722 40.665H105.156C101.988 40.665 100.363 39.1278 100.279 35.9601L100.276 35.6996V24.3756C100.276 21.1196 101.818 19.5208 104.903 19.4389L105.156 19.4356H116.722ZM91.2266 19.4356C94.3699 19.4356 95.9949 20.9487 96.0783 24.1152L96.0817 24.3756V35.6996C96.0817 38.9556 94.5393 40.5784 91.4782 40.6616L91.2266 40.665H79.6356C76.4924 40.665 74.8673 39.1278 74.784 35.9601L74.7806 35.6996V24.3756C74.7806 21.1196 76.3229 19.5208 79.3841 19.4389L79.6356 19.4356H91.2266ZM91.1504 23.0076H79.6864C78.8491 23.0076 78.4171 23.4115 78.3692 24.2194L78.3647 24.3756V35.6996C78.3647 36.5818 78.7474 37.0377 79.5342 37.0882L79.6864 37.093H91.1504C91.9877 37.093 92.4423 36.689 92.4929 35.8601L92.4976 35.6996V24.3756C92.4976 23.4636 92.0401 23.0076 91.1504 23.0076ZM116.671 23.0076H105.207C104.346 23.0076 103.912 23.4115 103.864 24.2194L103.86 24.3756V35.6996C103.86 36.5818 104.243 37.0377 105.051 37.0882L105.207 37.093H116.671C117.508 37.093 117.94 36.689 117.988 35.8601L117.993 35.6996V24.3756C117.993 23.4636 117.561 23.0076 116.671 23.0076ZM87.5917 27.365C87.9153 27.365 88.0707 27.4906 88.0963 27.8179L88.1001 27.9223V32.1276C88.1001 32.5191 87.9741 32.6804 87.6838 32.7064L87.5917 32.7103H83.2451C82.8985 32.7103 82.7619 32.5847 82.74 32.2383L82.7367 32.1276V27.9223C82.7367 27.5538 82.8418 27.3947 83.1473 27.3688L83.2451 27.365H87.5917ZM113.239 27.365C113.586 27.365 113.744 27.4906 113.769 27.8179L113.773 27.9223V32.1276C113.773 32.5191 113.647 32.6804 113.338 32.7064L113.239 32.7103H108.893C108.569 32.7103 108.435 32.5847 108.413 32.2383L108.41 32.1276V27.9223C108.41 27.5538 108.515 27.3947 108.801 27.3688L108.893 27.365H113.239ZM120.172 7.22092C127.601 7.22092 133.665 13.1617 133.83 20.5274L133.833 20.8351V28.0482H130.498V20.8351C130.498 15.2538 126.016 10.6961 120.451 10.5481L120.172 10.5444H112.935V7.22092H120.172ZM83.4223 7.2207V10.5442H76.1848C70.5847 10.5442 66.0115 15.0104 65.8631 20.5572L65.8594 20.8354V28.048H62.5246V20.8354C62.5246 13.431 68.4855 7.38829 75.8761 7.22413L76.1848 7.2207H83.4223Z\" fill=\"#B6C5D5\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M65.8591 55.241V62.4536C65.8591 68.0349 70.3405 72.5932 75.906 72.7411L76.1852 72.7448H83.4221V76.0683H76.1852C68.7557 76.0683 62.6926 70.127 62.5279 62.7613L62.5244 62.4536V55.241H65.8591ZM91.2266 42.6243C94.3699 42.6243 95.9949 44.1614 96.0783 47.3058L96.0817 47.5643V58.9136C96.0817 62.1696 94.5393 63.7684 91.4782 63.8503L91.2266 63.8536H79.6356C76.4924 63.8536 74.8673 62.3405 74.784 59.174L74.7806 58.9136V47.5643C74.7806 44.3329 76.3229 42.7108 79.3841 42.6276L79.6356 42.6243H91.2266ZM106.351 57.2923C106.674 57.2923 106.83 57.4179 106.855 57.7453L106.859 57.8496V62.055C106.859 62.4465 106.733 62.6077 106.443 62.6338L106.351 62.6376H102.004C101.658 62.6376 101.521 62.512 101.499 62.1656L101.496 62.055V57.8496C101.496 57.4811 101.601 57.322 101.907 57.2961L102.004 57.2923H106.351ZM91.1504 46.1963H79.6864C78.8491 46.1963 78.4171 46.6002 78.3692 47.4292L78.3647 47.5896V58.9136C78.3647 59.772 78.7474 60.2264 79.5342 60.2769L79.6864 60.2816H91.1504C91.9877 60.2816 92.4423 59.8777 92.4929 59.0698L92.4976 58.9136V47.5896C92.4976 46.6523 92.0401 46.1963 91.1504 46.1963ZM87.5917 50.579C87.9153 50.579 88.0707 50.7046 88.0963 51.0319L88.1001 51.1363V55.3163C88.1001 55.7308 87.9741 55.8941 87.6838 55.9204L87.5917 55.9243H83.2451C82.8956 55.9243 82.7597 55.7966 82.7394 55.424L82.7367 55.3163V51.1363C82.7367 50.7678 82.8418 50.6087 83.1473 50.5828L83.2451 50.579H87.5917ZM113.163 50.579C113.487 50.579 113.642 50.7046 113.668 51.0319L113.672 51.1363V55.3163C113.672 55.7308 113.546 55.8941 113.255 55.9204L113.163 55.9243H108.817C108.467 55.9243 108.331 55.7966 108.311 55.424L108.308 55.3163V51.1363C108.308 50.7678 108.413 50.6087 108.719 50.5828L108.817 50.579H113.163ZM106.351 43.8403C106.674 43.8403 106.83 43.9659 106.855 44.2933L106.859 44.3976V48.603C106.859 48.9945 106.733 49.1557 106.443 49.1818L106.351 49.1856H102.004C101.658 49.1856 101.521 49.06 101.499 48.7136L101.496 48.603V44.3976C101.496 44.0291 101.601 43.87 101.907 43.8441L102.004 43.8403H106.351ZM119.848 43.8403C120.172 43.8403 120.327 43.9659 120.353 44.2933L120.357 44.3976V48.603C120.357 48.9945 120.231 49.1557 119.94 49.1818L119.848 49.1856H115.502C115.155 49.1856 115.019 49.06 114.997 48.7136L114.993 48.603V44.3976C114.993 44.0291 115.098 43.87 115.404 43.8441L115.502 43.8403H119.848ZM116.722 17.2149C119.865 17.2149 121.49 18.728 121.573 21.8945L121.577 22.1549V33.4789C121.577 36.7349 120.035 38.3577 116.973 38.4409L116.722 38.4443H105.156C101.988 38.4443 100.363 36.9071 100.279 33.7394L100.276 33.4789V22.1549C100.276 18.8989 101.818 17.3001 104.903 17.2182L105.156 17.2149H116.722ZM91.2266 17.2149C94.3699 17.2149 95.9949 18.728 96.0783 21.8945L96.0817 22.1549V33.4789C96.0817 36.7349 94.5393 38.3577 91.4782 38.4409L91.2266 38.4443H79.6356C76.4924 38.4443 74.8673 36.9071 74.784 33.7394L74.7806 33.4789V22.1549C74.7806 18.8989 76.3229 17.3001 79.3841 17.2182L79.6356 17.2149H91.2266ZM91.1504 20.7869H79.6864C78.8491 20.7869 78.4171 21.1908 78.3692 21.9987L78.3647 22.1549V33.4789C78.3647 34.3611 78.7474 34.817 79.5342 34.8675L79.6864 34.8723H91.1504C91.9877 34.8723 92.4423 34.4683 92.4929 33.6394L92.4976 33.4789V22.1549C92.4976 21.2429 92.0401 20.7869 91.1504 20.7869ZM116.671 20.7869H105.207C104.346 20.7869 103.912 21.1908 103.864 21.9987L103.86 22.1549V33.4789C103.86 34.3611 104.243 34.817 105.051 34.8675L105.207 34.8723H116.671C117.508 34.8723 117.94 34.4683 117.988 33.6394L117.993 33.4789V22.1549C117.993 21.2429 117.561 20.7869 116.671 20.7869ZM87.5917 25.1443C87.9153 25.1443 88.0707 25.2699 88.0963 25.5972L88.1001 25.7016V29.9069C88.1001 30.2984 87.9741 30.4597 87.6838 30.4857L87.5917 30.4896H83.2451C82.8985 30.4896 82.7619 30.364 82.74 30.0176L82.7367 29.9069V25.7016C82.7367 25.3331 82.8418 25.174 83.1473 25.1481L83.2451 25.1443H87.5917ZM113.239 25.1443C113.586 25.1443 113.744 25.2699 113.769 25.5972L113.773 25.7016V29.9069C113.773 30.2984 113.647 30.4597 113.338 30.4857L113.239 30.4896H108.893C108.569 30.4896 108.435 30.364 108.413 30.0176L108.41 29.9069V25.7016C108.41 25.3331 108.515 25.174 108.801 25.1481L108.893 25.1443H113.239ZM120.172 5.00022C127.601 5.00022 133.665 10.941 133.83 18.3067L133.833 18.6144V25.8275H130.498V18.6144C130.498 13.0331 126.016 8.47537 120.451 8.32743L120.172 8.32373H112.935V5.00022H120.172ZM83.4223 5V8.32351H76.1848C70.5847 8.32351 66.0115 12.7897 65.8631 18.3365L65.8594 18.6147V25.8273H62.5246V18.6147C62.5246 11.2103 68.4855 5.16759 75.8761 5.00343L76.1848 5H83.4223Z\" fill=\"#B6C5D5\"/>\n<path d=\"M130.764 93.5281C142.232 93.5281 151.528 84.2317 151.528 72.764C151.528 61.2964 142.232 52 130.764 52C119.296 52 110 61.2964 110 72.764C110 84.2317 119.296 93.5281 130.764 93.5281Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M130.738 92.6198C141.523 92.6198 150.475 83.7179 150.475 72.8099C150.475 61.9437 141.523 53 130.738 53C119.911 53 111 61.9437 111 72.8099C111 83.7179 119.911 92.6198 130.738 92.6198ZM128.59 83.8154C128.058 83.8154 127.412 83.5539 126.994 83.0309L120.19 74.4008C119.886 74.0521 119.772 73.4419 119.772 72.9189C119.772 71.6549 120.609 70.6524 121.711 70.6524C122.395 70.6524 122.889 71.0447 123.231 71.4805L128.514 77.9749L138.092 62.7633C138.434 62.1967 139.043 61.8044 139.727 61.8044C140.791 61.8044 141.703 62.7197 141.703 64.0273C141.703 64.4196 141.551 64.899 141.247 65.3785L130.225 82.9437C129.883 83.4667 129.274 83.8154 128.59 83.8154Z\" fill=\"#1AAAAD\"/>\n</svg>";

var LinealQRWarning = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.1639 56.6843C32.2573 56.6843 33.1447 57.5717 33.1447 58.6651C33.1447 59.7585 32.2573 60.6459 31.1639 60.6459H10.0783C8.9839 60.6459 8.09749 59.7585 8.09749 58.6651C8.09749 57.5717 8.9839 56.6843 10.0783 56.6843H31.1639ZM39.9353 47.0692C41.0287 47.0692 41.9161 47.9566 41.9161 49.05C41.9161 50.1434 41.0287 51.0307 39.9353 51.0307H19.9194C18.826 51.0307 17.9386 50.1434 17.9386 49.05C17.9386 47.9566 18.826 47.0692 19.9194 47.0692H39.9353ZM10.0783 47.0692C11.1717 47.0692 12.0591 47.9566 12.0591 49.05C12.0591 50.1434 11.1717 51.0307 10.0783 51.0307H1.9808C0.887396 51.0307 0 50.1434 0 49.05C0 47.9566 0.887396 47.0692 1.9808 47.0692H10.0783ZM36.5753 37.4543C37.6687 37.4543 38.5561 38.3417 38.5561 39.4351C38.5561 40.5285 37.6687 41.4159 36.5753 41.4159H10.7536C9.65925 41.4159 8.77284 40.5285 8.77284 39.4351C8.77284 38.3417 9.65925 37.4543 10.7536 37.4543H36.5753ZM166.153 36.8678C167.246 36.8678 168.134 37.7552 168.134 38.8486C168.134 39.942 167.246 40.8294 166.153 40.8294H155.189C154.095 40.8294 153.208 39.942 153.208 38.8486C153.208 37.7552 154.095 36.8678 155.189 36.8678H166.153ZM177.118 36.8678C178.211 36.8678 179.099 37.7552 179.099 38.8486C179.099 39.942 178.211 40.8294 177.118 40.8294H173.745C172.65 40.8294 171.764 39.942 171.764 38.8486C171.764 37.7552 172.65 36.8678 173.745 36.8678H177.118ZM190.019 27.2525C191.113 27.2525 192 28.1399 192 29.2333C192 30.3267 191.113 31.2141 190.019 31.2141H181.525C180.43 31.2141 179.544 30.3267 179.544 29.2333C179.544 28.1399 180.43 27.2525 181.525 27.2525H190.019ZM171.747 27.2525C172.841 27.2525 173.728 28.1399 173.728 29.2333C173.728 30.3267 172.841 31.2141 171.747 31.2141H157.469C156.375 31.2141 155.488 30.3267 155.488 29.2333C155.488 28.1399 156.375 27.2525 157.469 27.2525H171.747ZM180.317 17.6372C181.411 17.6372 182.298 18.5246 182.298 19.618C182.298 20.7114 181.411 21.5988 180.317 21.5988H163.702C162.608 21.5988 161.722 20.7114 161.722 19.618C161.722 18.5246 162.608 17.6372 163.702 17.6372H180.317ZM155.869 17.6372C156.962 17.6372 157.85 18.5246 157.85 19.618C157.85 20.7114 156.962 21.5988 155.869 21.5988H152.496C151.401 21.5988 150.515 20.7114 150.515 19.618C150.515 18.5246 151.401 17.6372 152.496 17.6372H155.869Z\" fill=\"#B6C5D5\"/>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M65.8591 57.4617V64.6743C65.8591 70.2556 70.3405 74.8139 75.906 74.9618L76.1852 74.9655H83.4221V78.289H76.1852C68.7557 78.289 62.6926 72.3477 62.5279 64.982L62.5244 64.6743V57.4617H65.8591ZM91.2266 44.845C94.3699 44.845 95.9949 46.3821 96.0783 49.5265L96.0817 49.785V61.1343C96.0817 64.3903 94.5393 65.9891 91.4782 66.071L91.2266 66.0743H79.6356C76.4924 66.0743 74.8673 64.5612 74.784 61.3947L74.7806 61.1343V49.785C74.7806 46.5536 76.3229 44.9315 79.3841 44.8483L79.6356 44.845H91.2266ZM106.351 59.513C106.674 59.513 106.83 59.6386 106.855 59.966L106.859 60.0703V64.2757C106.859 64.6672 106.733 64.8284 106.443 64.8545L106.351 64.8583H102.004C101.658 64.8583 101.521 64.7327 101.499 64.3863L101.496 64.2757V60.0703C101.496 59.7018 101.601 59.5427 101.907 59.5168L102.004 59.513H106.351ZM91.1504 48.417H79.6864C78.8491 48.417 78.4171 48.8209 78.3692 49.6499L78.3647 49.8103V61.1343C78.3647 61.9927 78.7474 62.4471 79.5342 62.4976L79.6864 62.5023H91.1504C91.9877 62.5023 92.4423 62.0984 92.4929 61.2905L92.4976 61.1343V49.8103C92.4976 48.873 92.0401 48.417 91.1504 48.417ZM87.5917 52.7997C87.9153 52.7997 88.0707 52.9253 88.0963 53.2526L88.1001 53.357V57.537C88.1001 57.9515 87.9741 58.1148 87.6838 58.1411L87.5917 58.145H83.2451C82.8956 58.145 82.7597 58.0173 82.7394 57.6447L82.7367 57.537V53.357C82.7367 52.9885 82.8418 52.8294 83.1473 52.8035L83.2451 52.7997H87.5917ZM113.163 52.7997C113.487 52.7997 113.642 52.9253 113.668 53.2526L113.672 53.357V57.537C113.672 57.9515 113.546 58.1148 113.255 58.1411L113.163 58.145H108.817C108.467 58.145 108.331 58.0173 108.311 57.6447L108.308 57.537V53.357C108.308 52.9885 108.413 52.8294 108.719 52.8035L108.817 52.7997H113.163ZM106.351 46.061C106.674 46.061 106.83 46.1866 106.855 46.514L106.859 46.6183V50.8237C106.859 51.2152 106.733 51.3764 106.443 51.4025L106.351 51.4063H102.004C101.658 51.4063 101.521 51.2807 101.499 50.9343L101.496 50.8237V46.6183C101.496 46.2498 101.601 46.0907 101.907 46.0648L102.004 46.061H106.351ZM119.848 46.061C120.172 46.061 120.327 46.1866 120.353 46.514L120.357 46.6183V50.8237C120.357 51.2152 120.231 51.3764 119.94 51.4025L119.848 51.4063H115.502C115.155 51.4063 115.019 51.2807 114.997 50.9343L114.993 50.8237V46.6183C114.993 46.2498 115.098 46.0907 115.404 46.0648L115.502 46.061H119.848ZM116.722 19.4356C119.865 19.4356 121.49 20.9487 121.573 24.1152L121.577 24.3756V35.6996C121.577 38.9556 120.035 40.5784 116.973 40.6616L116.722 40.665H105.156C101.988 40.665 100.363 39.1278 100.279 35.9601L100.276 35.6996V24.3756C100.276 21.1196 101.818 19.5208 104.903 19.4389L105.156 19.4356H116.722ZM91.2266 19.4356C94.3699 19.4356 95.9949 20.9487 96.0783 24.1152L96.0817 24.3756V35.6996C96.0817 38.9556 94.5393 40.5784 91.4782 40.6616L91.2266 40.665H79.6356C76.4924 40.665 74.8673 39.1278 74.784 35.9601L74.7806 35.6996V24.3756C74.7806 21.1196 76.3229 19.5208 79.3841 19.4389L79.6356 19.4356H91.2266ZM91.1504 23.0076H79.6864C78.8491 23.0076 78.4171 23.4115 78.3692 24.2194L78.3647 24.3756V35.6996C78.3647 36.5818 78.7474 37.0377 79.5342 37.0882L79.6864 37.093H91.1504C91.9877 37.093 92.4423 36.689 92.4929 35.8601L92.4976 35.6996V24.3756C92.4976 23.4636 92.0401 23.0076 91.1504 23.0076ZM116.671 23.0076H105.207C104.346 23.0076 103.912 23.4115 103.864 24.2194L103.86 24.3756V35.6996C103.86 36.5818 104.243 37.0377 105.051 37.0882L105.207 37.093H116.671C117.508 37.093 117.94 36.689 117.988 35.8601L117.993 35.6996V24.3756C117.993 23.4636 117.561 23.0076 116.671 23.0076ZM87.5917 27.365C87.9153 27.365 88.0707 27.4906 88.0963 27.8179L88.1001 27.9223V32.1276C88.1001 32.5191 87.9741 32.6804 87.6838 32.7064L87.5917 32.7103H83.2451C82.8985 32.7103 82.7619 32.5847 82.74 32.2383L82.7367 32.1276V27.9223C82.7367 27.5538 82.8418 27.3947 83.1473 27.3688L83.2451 27.365H87.5917ZM113.239 27.365C113.586 27.365 113.744 27.4906 113.769 27.8179L113.773 27.9223V32.1276C113.773 32.5191 113.647 32.6804 113.338 32.7064L113.239 32.7103H108.893C108.569 32.7103 108.435 32.5847 108.413 32.2383L108.41 32.1276V27.9223C108.41 27.5538 108.515 27.3947 108.801 27.3688L108.893 27.365H113.239ZM120.172 7.22092C127.601 7.22092 133.665 13.1617 133.83 20.5274L133.833 20.8351V28.0482H130.498V20.8351C130.498 15.2538 126.016 10.6961 120.451 10.5481L120.172 10.5444H112.935V7.22092H120.172ZM83.4223 7.2207V10.5442H76.1848C70.5847 10.5442 66.0115 15.0104 65.8631 20.5572L65.8594 20.8354V28.048H62.5246V20.8354C62.5246 13.431 68.4855 7.38829 75.8761 7.22413L76.1848 7.2207H83.4223Z\" fill=\"#CCCCCC\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M65.8591 55.241V62.4536C65.8591 68.0349 70.3405 72.5932 75.906 72.7411L76.1852 72.7448H83.4221V76.0683H76.1852C68.7557 76.0683 62.6926 70.127 62.5279 62.7613L62.5244 62.4536V55.241H65.8591ZM91.2266 42.6243C94.3699 42.6243 95.9949 44.1614 96.0783 47.3058L96.0817 47.5643V58.9136C96.0817 62.1696 94.5393 63.7684 91.4782 63.8503L91.2266 63.8536H79.6356C76.4924 63.8536 74.8673 62.3405 74.784 59.174L74.7806 58.9136V47.5643C74.7806 44.3329 76.3229 42.7108 79.3841 42.6276L79.6356 42.6243H91.2266ZM106.351 57.2923C106.674 57.2923 106.83 57.4179 106.855 57.7453L106.859 57.8496V62.055C106.859 62.4465 106.733 62.6077 106.443 62.6338L106.351 62.6376H102.004C101.658 62.6376 101.521 62.512 101.499 62.1656L101.496 62.055V57.8496C101.496 57.4811 101.601 57.322 101.907 57.2961L102.004 57.2923H106.351ZM91.1504 46.1963H79.6864C78.8491 46.1963 78.4171 46.6002 78.3692 47.4292L78.3647 47.5896V58.9136C78.3647 59.772 78.7474 60.2264 79.5342 60.2769L79.6864 60.2816H91.1504C91.9877 60.2816 92.4423 59.8777 92.4929 59.0698L92.4976 58.9136V47.5896C92.4976 46.6523 92.0401 46.1963 91.1504 46.1963ZM87.5917 50.579C87.9153 50.579 88.0707 50.7046 88.0963 51.0319L88.1001 51.1363V55.3163C88.1001 55.7308 87.9741 55.8941 87.6838 55.9204L87.5917 55.9243H83.2451C82.8956 55.9243 82.7597 55.7966 82.7394 55.424L82.7367 55.3163V51.1363C82.7367 50.7678 82.8418 50.6087 83.1473 50.5828L83.2451 50.579H87.5917ZM113.163 50.579C113.487 50.579 113.642 50.7046 113.668 51.0319L113.672 51.1363V55.3163C113.672 55.7308 113.546 55.8941 113.255 55.9204L113.163 55.9243H108.817C108.467 55.9243 108.331 55.7966 108.311 55.424L108.308 55.3163V51.1363C108.308 50.7678 108.413 50.6087 108.719 50.5828L108.817 50.579H113.163ZM106.351 43.8403C106.674 43.8403 106.83 43.9659 106.855 44.2933L106.859 44.3976V48.603C106.859 48.9945 106.733 49.1557 106.443 49.1818L106.351 49.1856H102.004C101.658 49.1856 101.521 49.06 101.499 48.7136L101.496 48.603V44.3976C101.496 44.0291 101.601 43.87 101.907 43.8441L102.004 43.8403H106.351ZM119.848 43.8403C120.172 43.8403 120.327 43.9659 120.353 44.2933L120.357 44.3976V48.603C120.357 48.9945 120.231 49.1557 119.94 49.1818L119.848 49.1856H115.502C115.155 49.1856 115.019 49.06 114.997 48.7136L114.993 48.603V44.3976C114.993 44.0291 115.098 43.87 115.404 43.8441L115.502 43.8403H119.848ZM116.722 17.2149C119.865 17.2149 121.49 18.728 121.573 21.8945L121.577 22.1549V33.4789C121.577 36.7349 120.035 38.3577 116.973 38.4409L116.722 38.4443H105.156C101.988 38.4443 100.363 36.9071 100.279 33.7394L100.276 33.4789V22.1549C100.276 18.8989 101.818 17.3001 104.903 17.2182L105.156 17.2149H116.722ZM91.2266 17.2149C94.3699 17.2149 95.9949 18.728 96.0783 21.8945L96.0817 22.1549V33.4789C96.0817 36.7349 94.5393 38.3577 91.4782 38.4409L91.2266 38.4443H79.6356C76.4924 38.4443 74.8673 36.9071 74.784 33.7394L74.7806 33.4789V22.1549C74.7806 18.8989 76.3229 17.3001 79.3841 17.2182L79.6356 17.2149H91.2266ZM91.1504 20.7869H79.6864C78.8491 20.7869 78.4171 21.1908 78.3692 21.9987L78.3647 22.1549V33.4789C78.3647 34.3611 78.7474 34.817 79.5342 34.8675L79.6864 34.8723H91.1504C91.9877 34.8723 92.4423 34.4683 92.4929 33.6394L92.4976 33.4789V22.1549C92.4976 21.2429 92.0401 20.7869 91.1504 20.7869ZM116.671 20.7869H105.207C104.346 20.7869 103.912 21.1908 103.864 21.9987L103.86 22.1549V33.4789C103.86 34.3611 104.243 34.817 105.051 34.8675L105.207 34.8723H116.671C117.508 34.8723 117.94 34.4683 117.988 33.6394L117.993 33.4789V22.1549C117.993 21.2429 117.561 20.7869 116.671 20.7869ZM87.5917 25.1443C87.9153 25.1443 88.0707 25.2699 88.0963 25.5972L88.1001 25.7016V29.9069C88.1001 30.2984 87.9741 30.4597 87.6838 30.4857L87.5917 30.4896H83.2451C82.8985 30.4896 82.7619 30.364 82.74 30.0176L82.7367 29.9069V25.7016C82.7367 25.3331 82.8418 25.174 83.1473 25.1481L83.2451 25.1443H87.5917ZM113.239 25.1443C113.586 25.1443 113.744 25.2699 113.769 25.5972L113.773 25.7016V29.9069C113.773 30.2984 113.647 30.4597 113.338 30.4857L113.239 30.4896H108.893C108.569 30.4896 108.435 30.364 108.413 30.0176L108.41 29.9069V25.7016C108.41 25.3331 108.515 25.174 108.801 25.1481L108.893 25.1443H113.239ZM120.172 5.00022C127.601 5.00022 133.665 10.941 133.83 18.3067L133.833 18.6144V25.8275H130.498V18.6144C130.498 13.0331 126.016 8.47537 120.451 8.32743L120.172 8.32373H112.935V5.00022H120.172ZM83.4223 5V8.32351H76.1848C70.5847 8.32351 66.0115 12.7897 65.8631 18.3365L65.8594 18.6147V25.8273H62.5246V18.6147C62.5246 11.2103 68.4855 5.16759 75.8761 5.00343L76.1848 5H83.4223Z\" fill=\"#B6C5D5\"/>\n<path d=\"M130.732 93.1455C142.219 93.1455 151.531 83.8338 151.531 72.3472C151.531 60.8606 142.219 51.5488 130.732 51.5488C119.246 51.5488 109.934 60.8606 109.934 72.3472C109.934 83.8338 119.246 93.1455 130.732 93.1455Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M130.732 90.8912C140.687 90.8912 148.89 82.6734 148.89 72.7244C148.89 62.7945 140.668 54.5767 130.732 54.5767C120.778 54.5767 112.575 62.7945 112.575 72.7244C112.575 82.6734 120.797 90.8912 130.732 90.8912ZM131.037 75.5464C131.857 75.5464 132.362 75.0417 132.362 74.1375L132.614 63.5607C132.635 62.6775 131.942 62.0046 131.016 62.0046C130.07 62.0046 129.418 62.6565 129.439 63.5607L129.671 74.1375C129.692 75.0417 130.175 75.5464 131.037 75.5464ZM131.037 81.8126C129.986 81.8126 129.082 80.9505 129.082 79.9201C129.082 78.8687 129.965 78.0276 131.037 78.0276C132.11 78.0276 132.993 78.8477 132.993 79.9201C132.993 80.9715 132.089 81.8126 131.037 81.8126Z\" fill=\"#FECF2F\"/>\n</svg>";

var LinealSistemaError = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_201_125)\">\n<g opacity=\"0.5\">\n<path opacity=\"0.5\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M58.9403 56.4831C62.2869 58.9189 66.4011 60.3606 70.8477 60.3606H114.981C115.224 62.9214 115.884 65.3581 116.892 67.6072H75.6311C68.1111 67.6072 61.6652 63.0156 58.9403 56.4831ZM163.237 11.4835C165.463 11.4835 167.46 12.4543 168.846 13.9868C172.613 14.217 175.858 16.8122 176.895 20.3427L176.967 20.6026H182.78C183.355 20.6026 183.821 21.0693 183.821 21.6443C183.821 22.181 183.415 22.6233 182.893 22.6799L182.78 22.686H175.221L175.089 21.7985C174.701 19.1968 172.771 17.0985 170.3 16.3476C170.624 17.1893 170.81 18.1001 170.81 19.0551C170.81 19.6301 170.343 20.0968 169.768 20.0968C169.192 20.0968 168.726 19.6301 168.726 19.0551C168.726 16.0293 166.264 13.5668 163.237 13.5668C160.845 13.5668 158.728 15.1253 158.007 17.3844L157.94 17.6126L157.762 18.2693L157.089 18.3701C155.546 18.6001 154.368 19.9103 154.279 21.4576L154.274 21.6443V22.686H142.331C141.756 22.686 141.29 22.2193 141.29 21.6443C141.29 21.1076 141.696 20.6654 142.218 20.6088L142.331 20.6026H152.293C152.687 18.6293 154.176 16.9993 156.126 16.4501C157.207 13.496 160.046 11.4835 163.237 11.4835ZM40.9696 7.07715C44.1612 7.07715 46.9996 9.08965 48.0812 12.0438C49.9554 12.5727 51.4051 14.0993 51.8635 15.9702L51.9137 16.1963H57.3029C57.8779 16.1963 58.3446 16.663 58.3446 17.238C58.3446 17.7746 57.9381 18.2169 57.4164 18.2735L57.3029 18.2796H49.9329V17.238C49.9329 15.6731 48.8142 14.3116 47.3013 13.9965L47.1179 13.9638L46.4454 13.8638L46.2671 13.2071C45.6196 10.8246 43.4412 9.16048 40.9696 9.16048C37.9437 9.16048 35.4804 11.623 35.4804 14.6496C35.4804 15.2246 35.0146 15.6913 34.4387 15.6913C33.8637 15.6913 33.3971 15.2246 33.3971 14.6496C33.3971 13.6946 33.5829 12.7838 33.9071 11.9413C31.5186 12.6671 29.6363 14.6521 29.1627 17.1337L29.1187 17.3921L28.9862 18.2796H22.3662C21.7912 18.2796 21.3246 17.813 21.3246 17.238C21.3246 16.7013 21.7311 16.259 22.2528 16.2024L22.3662 16.1963H27.2396C28.1912 12.5338 31.5021 9.81632 35.3604 9.58048C36.7471 8.04798 38.7446 7.07715 40.9696 7.07715ZM17.0856 16.1963V18.2796H6V16.1963H17.0856ZM185.843 16.0429C186.418 16.0429 186.885 16.5096 186.885 17.0846C186.885 17.6596 186.418 18.1262 185.843 18.1262H180.902C180.327 18.1262 179.86 17.6596 179.86 17.0846C179.86 16.5096 180.327 16.0429 180.902 16.0429H185.843ZM149.527 15.2845C150.102 15.2845 150.569 15.7511 150.569 16.3261C150.569 16.9011 150.102 17.3678 149.527 17.3678H146.711C146.136 17.3678 145.669 16.9011 145.669 16.3261C145.669 15.7511 146.136 15.2845 146.711 15.2845H149.527ZM20.9845 11.637C21.5595 11.637 22.0262 12.1036 22.0262 12.6786C22.0262 13.2536 21.5595 13.7203 20.9845 13.7203H16.0437C15.4687 13.7203 15.002 13.2536 15.002 12.6786C15.002 12.1036 15.4687 11.637 16.0437 11.637H20.9845Z\" fill=\"#DEE8F3\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M85.9708 85.0824C87.025 85.6916 87.3866 87.0391 86.7775 88.0941L81.5141 97.2116C81.1058 97.9191 80.365 98.3141 79.6025 98.3141C79.2291 98.3141 78.85 98.2191 78.5033 98.0191C77.4483 97.4099 77.0866 96.0616 77.6958 95.0074L82.9591 85.8891C83.5675 84.8366 84.9166 84.4741 85.9708 85.0824ZM80.1098 77.3978C81.1631 78.007 81.5248 79.3553 80.9156 80.4095L73.8506 92.6453C73.4423 93.3528 72.7015 93.7478 71.939 93.7478C71.5656 93.7478 71.1865 93.6528 70.839 93.4528C69.7848 92.8437 69.4231 91.4953 70.0323 90.4412L77.0973 78.2045C77.7065 77.1512 79.0531 76.7887 80.1098 77.3978ZM99.066 80.0275C100.121 80.6367 100.483 81.985 99.8735 83.0392L95.6418 90.3683C95.2335 91.0758 94.4926 91.4708 93.7301 91.4708C93.3568 91.4708 92.9776 91.3758 92.631 91.1758C91.576 90.5667 91.2143 89.2183 91.8235 88.1642L96.0551 80.8342C96.6635 79.7808 98.0126 79.4192 99.066 80.0275ZM77.3325 67.0303C78.3875 67.6387 78.7491 68.987 78.14 70.0412L71.2033 82.057C70.795 82.7645 70.0541 83.1595 69.2916 83.1595C68.9183 83.1595 68.5391 83.0645 68.1925 82.8645C67.1375 82.2553 66.7758 80.907 67.385 79.8528L74.3216 67.837C74.9308 66.7837 76.2791 66.4212 77.3325 67.0303ZM96.9297 66.0997C97.9847 66.7089 98.3456 68.0573 97.7372 69.1114L91.2122 80.4131C90.8039 81.1206 90.0631 81.5156 89.3006 81.5156C88.9272 81.5156 88.5481 81.4206 88.2014 81.2206C87.1464 80.6114 86.7847 79.2631 87.3939 78.2089L93.9189 66.9072C94.5272 65.8539 95.8756 65.4914 96.9297 66.0997ZM108.464 63.7504C109.518 64.3596 109.879 65.7079 109.27 66.7621L104.352 75.2812C103.944 75.9887 103.203 76.3838 102.44 76.3838C102.067 76.3838 101.688 76.2887 101.341 76.0888C100.286 75.4796 99.9244 74.1312 100.534 73.0771L105.452 64.5579C106.061 63.5037 107.409 63.1413 108.464 63.7504ZM87.8303 64.0247C88.8836 64.6339 89.2453 65.9822 88.6361 67.0364L85.8753 71.8181C85.467 72.5256 84.7261 72.9206 83.9636 72.9206C83.5903 72.9206 83.2111 72.8256 82.8636 72.6256C81.8095 72.0164 81.4478 70.6681 82.057 69.6139L84.8178 64.8314C85.4261 63.7781 86.7728 63.4156 87.8303 64.0247ZM88.3285 -1C95.1101 -1 101.588 2.0575 105.941 7.24667C107.184 6.98167 108.449 6.84833 109.718 6.84833C118.315 6.84833 125.724 12.9475 127.483 21.2433C133.582 23.6717 138.024 28.8408 139.605 35.0508C139.086 35.0158 138.565 34.9925 138.038 34.9925C137.03 34.9925 136.039 35.0633 135.065 35.1883C133.533 30.4317 129.807 26.5842 124.852 24.9783L123.532 24.5508L123.346 23.175C122.433 16.3808 116.574 11.2575 109.718 11.2575C108.373 11.2575 107.033 11.4558 105.733 11.8483L104.239 12.3L103.318 11.0408C99.8176 6.26167 94.2135 3.40917 88.3285 3.40917C78.0785 3.40917 69.7393 11.7475 69.7393 21.9967C69.7485 22.0917 69.7535 22.1833 69.7543 22.2775L69.7843 24.1408L67.951 24.4792C60.431 25.8667 54.9726 32.4267 54.9726 40.0767C54.9726 48.83 62.0943 55.9508 70.8476 55.9508H114.981C114.913 56.6775 114.874 57.4117 114.874 58.1558C114.874 58.9 114.913 59.6342 114.981 60.3608H70.8476C59.6626 60.3608 50.5635 51.2608 50.5635 40.0767C50.5635 30.9125 56.6918 22.9733 65.3751 20.5533C66.1218 8.5425 76.1318 -1 88.3285 -1ZM95.9658 38.7157C102.103 38.7157 107.857 41.0498 111.356 44.9607C112.075 45.764 112.006 46.9982 111.202 47.7165C110.4 48.4365 109.165 48.3673 108.447 47.564C105.677 44.4673 101.01 42.6198 95.9658 42.6198C90.9008 42.6198 86.225 44.479 83.4583 47.5923C83.0725 48.0265 82.5366 48.2482 81.9983 48.2482C81.5366 48.2482 81.075 48.0857 80.7025 47.7557C79.8975 47.039 79.8241 45.8057 80.54 44.9998C84.0358 41.0648 89.8025 38.7157 95.9658 38.7157ZM85.2959 21.2054C85.7142 21.2054 86.0751 21.3771 86.3834 21.7212L88.3542 23.7296L90.3442 21.7212C90.6634 21.3896 91.0259 21.2237 91.4309 21.2237C91.8242 21.2237 92.1642 21.3679 92.4534 21.6571C92.7417 21.9454 92.8867 22.2804 92.8867 22.6604C92.8867 23.0537 92.7326 23.4104 92.4267 23.7296L90.3259 25.7929L92.6092 28.0779C92.9167 28.3846 93.0717 28.7346 93.0717 29.1279C93.0717 29.5087 92.9226 29.8462 92.6292 30.1404C92.3334 30.4354 91.9901 30.5829 91.5967 30.5829C91.1909 30.5829 90.8301 30.4171 90.5109 30.0854L88.3542 27.8379L86.2176 30.0854C85.8976 30.4171 85.5359 30.5829 85.1309 30.5829C84.7367 30.5829 84.3934 30.4354 84.0976 30.1404C83.8042 29.8462 83.6551 29.5087 83.6551 29.1279C83.6551 28.7346 83.8101 28.3846 84.1176 28.0779L86.4009 25.7929L84.3017 23.7296C83.9942 23.4221 83.8401 23.0721 83.8401 22.6796C83.8401 22.2862 83.9851 21.9421 84.2726 21.6479C84.5626 21.3521 84.9026 21.2054 85.2959 21.2054ZM100.469 21.2054C100.888 21.2054 101.248 21.3771 101.557 21.7212L103.528 23.7296L105.518 21.7212C105.837 21.3896 106.199 21.2237 106.604 21.2237C106.998 21.2237 107.338 21.3679 107.627 21.6571C107.915 21.9454 108.06 22.2804 108.06 22.6604C108.06 23.0537 107.906 23.4104 107.6 23.7296L105.499 25.7929L107.783 28.0779C108.09 28.3846 108.245 28.7346 108.245 29.1279C108.245 29.5087 108.096 29.8462 107.803 30.1404C107.507 30.4354 107.163 30.5829 106.77 30.5829C106.364 30.5829 106.003 30.4171 105.684 30.0854L103.528 27.8379L101.391 30.0854C101.071 30.4171 100.709 30.5829 100.304 30.5829C99.9101 30.5829 99.5667 30.4354 99.2709 30.1404C98.9776 29.8462 98.8284 29.5087 98.8284 29.1279C98.8284 28.7346 98.9834 28.3846 99.2909 28.0779L101.574 25.7929L99.4751 23.7296C99.1676 23.4221 99.0134 23.0721 99.0134 22.6796C99.0134 22.2862 99.1584 21.9421 99.4459 21.6479C99.7359 21.3521 100.076 21.2054 100.469 21.2054Z\" fill=\"#B6C5D5\"/>\n<path d=\"M138.125 73.8442C147.082 73.8442 154.344 66.5828 154.344 57.6252C154.344 48.6677 147.082 41.4062 138.125 41.4062C129.167 41.4062 121.906 48.6677 121.906 57.6252C121.906 66.5828 129.167 73.8442 138.125 73.8442Z\" fill=\"white\"/>\n<path d=\"M138.125 75.6552C148.005 75.6552 156.145 67.4952 156.145 57.6152C156.145 47.7552 147.985 39.5952 138.125 39.5952C128.245 39.5952 120.105 47.7552 120.105 57.6152C120.105 67.4952 128.265 75.6552 138.125 75.6552ZM131.645 65.4172C130.909 65.4172 130.342 64.8312 130.342 64.1142C130.342 63.7542 130.475 63.4342 130.72 63.2072L136.274 57.6342L130.72 52.0622C130.475 51.8352 130.342 51.5142 130.342 51.1552C130.342 50.4192 130.909 49.8712 131.646 49.8712C132.005 49.8712 132.307 50.0032 132.553 50.2492L138.125 55.8022L143.716 50.2492C143.981 49.9652 144.283 49.8332 144.623 49.8332C145.341 49.8332 145.926 50.4192 145.926 51.1362C145.926 51.4962 145.813 51.7792 145.53 52.0432L139.957 57.6342L145.53 63.1692C145.775 63.4342 145.908 63.7362 145.908 64.1142C145.908 64.8312 145.341 65.4172 144.604 65.4172C144.226 65.4172 143.905 65.2662 143.66 65.0202L138.125 59.4672L132.571 65.0202C132.345 65.2662 132.005 65.4172 131.646 65.4172H131.645Z\" fill=\"#DD2457\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_201_125\">\n<rect width=\"192\" height=\"98\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var LinealSistemaNoResults = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g opacity=\"0.6\">\n<path opacity=\"0.6\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M51.427 51.437C52.319 51.437 53.043 52.161 53.043 53.053C53.043 53.945 52.319 54.669 51.427 54.669H34.223C33.33 54.669 32.607 53.945 32.607 53.053C32.607 52.161 33.33 51.437 34.223 51.437H51.427ZM58.584 43.592C59.477 43.592 60.201 44.316 60.201 45.208C60.201 46.1 59.477 46.824 58.584 46.824H42.252C41.36 46.824 40.636 46.1 40.636 45.208C40.636 44.316 41.36 43.592 42.252 43.592H58.584ZM34.223 43.592C35.115 43.592 35.839 44.316 35.839 45.208C35.839 46.1 35.115 46.824 34.223 46.824H27.616C26.724 46.824 26 46.1 26 45.208C26 44.316 26.724 43.592 27.616 43.592H34.223ZM144.726 39.149C145.618 39.149 146.342 39.873 146.342 40.766C146.342 41.658 145.618 42.382 144.726 42.382H135.78C134.887 42.382 134.164 41.658 134.164 40.766C134.164 39.873 134.887 39.149 135.78 39.149H144.726ZM153.672 39.149C154.564 39.149 155.288 39.873 155.288 40.766C155.288 41.658 154.564 42.382 153.672 42.382H150.92C150.027 42.382 149.304 41.658 149.304 40.766C149.304 39.873 150.027 39.149 150.92 39.149H153.672ZM55.842 35.747C56.734 35.747 57.458 36.471 57.458 37.363C57.458 38.255 56.734 38.979 55.842 38.979H34.774C33.881 38.979 33.158 38.255 33.158 37.363C33.158 36.471 33.881 35.747 34.774 35.747H55.842ZM164.198 31.305C165.091 31.305 165.815 32.029 165.815 32.921C165.815 33.813 165.091 34.537 164.198 34.537H157.268C156.375 34.537 155.651 33.813 155.651 32.921C155.651 32.029 156.375 31.305 157.267 31.305H164.198ZM149.29 31.305C150.182 31.305 150.906 32.029 150.906 32.921C150.906 33.813 150.182 34.537 149.29 34.537H137.64C136.748 34.537 136.024 33.813 136.024 32.921C136.024 32.029 136.748 31.305 137.64 31.305H149.29ZM156.283 23.459C157.175 23.459 157.899 24.183 157.899 25.075C157.899 25.968 157.175 26.692 156.283 26.692H142.726C141.833 26.692 141.11 25.968 141.11 25.075C141.11 24.183 141.833 23.459 142.726 23.459H156.283ZM136.335 23.459C137.227 23.459 137.951 24.183 137.951 25.075C137.951 25.968 137.227 26.692 136.335 26.692H133.581C132.689 26.692 131.965 25.968 131.965 25.075C131.965 24.183 132.689 23.459 133.581 23.459H136.335Z\" fill=\"#B6C5D5\"/>\n</g>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M73.8041 36.6801C73.8041 24.0901 84.0451 13.8491 96.6341 13.8491C109.224 13.8491 119.465 24.0911 119.465 36.6791C119.465 49.2691 109.224 59.5101 96.6351 59.5101C84.0451 59.5101 73.8041 49.2691 73.8041 36.6801ZM141.776 79.2411L127.111 64.5761C125.566 63.0311 123.299 62.6511 121.397 63.4341L117.567 59.6061C121.767 54.7521 124.314 48.4341 124.314 41.5281C124.314 26.2661 111.897 13.8481 96.6341 13.8481C81.3731 13.8491 68.9561 26.2671 68.9561 41.5291C68.9561 56.7911 81.3731 69.2091 96.6361 69.2091C103.541 69.2091 109.858 66.6611 114.712 62.4631L118.54 66.2911C117.759 68.1931 118.139 70.4601 119.683 72.0051L134.347 86.6701C135.372 87.6951 136.717 88.2081 138.061 88.2081C139.405 88.2081 140.75 87.6951 141.775 86.6701C143.826 84.6181 143.826 81.2931 141.775 79.2411\" fill=\"#B6C5D5\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M96.6351 9C111.897 9 124.315 21.417 124.315 36.68C124.315 43.584 121.767 49.903 117.568 54.757L121.397 58.585C123.299 57.802 125.567 58.182 127.112 59.727L141.777 74.392C143.827 76.444 143.827 79.769 141.777 81.821C140.751 82.846 139.407 83.36 138.063 83.36C136.718 83.36 135.373 82.846 134.348 81.821L119.682 67.155C118.138 65.61 117.758 63.343 118.54 61.441L114.712 57.613C109.858 61.811 103.541 64.358 96.6351 64.358C81.3731 64.358 68.9551 51.941 68.9551 36.679C68.9561 21.417 81.3741 9 96.6361 9H96.6351ZM96.6351 13.848C84.0451 13.848 73.8051 24.09 73.8051 36.679C73.8051 49.269 84.0451 59.509 96.6351 59.509C109.225 59.509 119.465 49.269 119.465 36.679C119.465 24.09 109.225 13.849 96.6351 13.849V13.848ZM96.5551 44.448C97.3251 44.448 97.9641 44.707 98.4691 45.224C98.9751 45.742 99.2291 46.386 99.2291 47.156C99.2291 47.926 98.9691 48.571 98.4521 49.088C97.9341 49.606 97.3021 49.865 96.5551 49.865C95.7851 49.865 95.1471 49.606 94.6421 49.088C94.1361 48.571 93.8841 47.927 93.8841 47.156C93.8841 46.386 94.1361 45.742 94.6421 45.224C95.1471 44.707 95.7851 44.447 96.5551 44.447V44.448ZM97.0611 23.899C98.5301 23.899 99.8361 24.152 100.979 24.659C102.123 25.163 103.013 25.862 103.652 26.753C104.289 27.643 104.608 28.666 104.608 29.822C104.608 31.074 104.308 32.164 103.706 33.091C103.104 34.017 102.226 35.058 101.07 36.214C100.082 37.225 99.3411 38.074 98.8481 38.76C98.3551 39.446 98.0481 40.223 97.9281 41.09C97.8561 41.474 97.6931 41.77 97.4411 41.974C97.1871 42.179 96.8691 42.281 96.4831 42.281C96.0731 42.281 95.7431 42.136 95.4901 41.848C95.2371 41.559 95.1111 41.162 95.1111 40.656C95.1111 39.332 95.3511 38.213 95.8331 37.297C96.3141 36.383 97.0131 35.384 97.9271 34.3C98.6501 33.433 99.1791 32.71 99.5171 32.134C99.8541 31.555 100.023 30.905 100.023 30.183C100.023 29.389 99.7281 28.757 99.1371 28.287C98.5471 27.817 97.7471 27.583 96.7371 27.583C95.8701 27.583 95.0381 27.77 94.2451 28.143C93.4501 28.516 92.5231 29.052 91.4631 29.75C90.8611 30.087 90.3681 30.255 89.9831 30.255C89.5741 30.255 89.2191 30.069 88.9181 29.695C88.6161 29.323 88.4661 28.883 88.4661 28.378C88.4661 27.68 88.7561 27.114 89.3331 26.68C90.3441 25.814 91.5351 25.133 92.9071 24.64C94.2801 24.147 95.6651 23.9 97.0611 23.9V23.899Z\" fill=\"#B6C5D5\"/>\n</svg>";

var LinealSistemaNotFound = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_368_1043)\">\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.0945 83.9814C34.2439 83.9046 36.1483 85.3583 36.6382 87.4522C38.9396 87.6946 39.3041 91.2661 39.3041 91.2661H35.7309C35.724 90.2102 34.9114 89.3335 33.8589 89.2447C33.5789 87.4248 32.0074 86.0847 30.1653 86.0949C28.768 86.0949 27.8708 86.5439 27.5285 87.5776L27.4961 87.6878L27.5038 87.6528C27.7991 86.3049 28.7543 84.1069 31.8461 83.9857L32.0945 83.9814ZM53.8794 61.482C53.8794 61.482 53.8624 61.4905 53.8282 61.511L53.7676 61.5502C53.4253 61.7705 52.3336 62.5729 50.9575 64.5959C50.9575 64.5891 46.127 51.4401 28.3864 55.0543C28.3864 55.0543 43.7906 43.8686 53.8794 61.482V61.482ZM144.864 54.8682C150.138 49.6902 159.661 51.7474 162.384 58.0248C160.833 58.0248 158.69 59.4538 158.69 59.4538C154.624 52.2749 144.864 54.8682 144.864 54.8682V54.8682Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M37.3042 86.6942C38.6913 87.1167 39.748 88.2469 40.0758 89.6588H51.5868C52.0793 89.6588 52.4796 90.0591 52.4796 90.5517C52.4796 91.045 52.0793 91.4445 51.5868 91.4445V91.459H38.39V90.5662C38.3857 89.4582 37.5773 88.5167 36.4821 88.3451L35.9034 88.2597L35.7532 87.6946C35.2598 85.8457 33.4706 84.6507 31.573 84.9016C30.5871 85.0322 29.7318 85.5333 29.1377 86.2503C29.1052 86.305 29.0668 86.3545 29.0233 86.3988C28.5427 87.0391 28.2627 87.8346 28.2653 88.6874C28.2653 89.1808 27.865 89.5803 27.3716 89.5803C26.879 89.5803 26.4787 89.1808 26.4787 88.6874C26.4787 88.0916 26.5717 87.5137 26.7459 86.9699C25.1641 87.5529 23.958 88.9503 23.6712 90.6942L23.5636 91.459H15.9255C15.4321 91.459 15.0326 91.0596 15.0326 90.5662C15.0326 90.0728 15.4321 89.6733 15.9255 89.6733H22.0707C22.8423 86.9981 25.1991 85.1065 27.946 84.9059C28.745 84.0309 29.824 83.4078 31.06 83.1799C33.7173 82.6908 36.3439 84.1701 37.3033 86.6951L37.3042 86.6942ZM68.7767 89.6733C69.271 89.6733 69.6705 90.0728 69.6705 90.5662C69.6705 91.0596 69.271 91.459 68.7776 91.459H56.5872C56.0938 91.459 55.6943 91.0596 55.6943 90.5662C55.6943 90.0728 56.0938 89.6733 56.5872 89.6733H68.7767ZM56.5872 85.7091C57.0814 85.7091 57.4809 86.1086 57.4809 86.602C57.4809 87.0954 57.0814 87.4949 56.5881 87.4949H49.1932C48.6998 87.4949 48.2995 87.0954 48.2995 86.602C48.2995 86.1086 48.6998 85.7091 49.1932 85.7091H56.5881H56.5872ZM54.3943 60.4415L54.4907 60.4107C55.4084 60.1307 56.39 60.0377 57.3811 60.1589C60.1869 60.5029 62.5112 62.5021 63.2684 65.2251H80.0307C80.5241 65.2251 80.9236 65.6246 80.9236 66.1171C80.9236 66.6105 80.5241 67.01 80.0307 67.01V66.9886H61.7891L61.6679 66.2392C61.3128 64.0573 59.6192 62.3382 57.4434 61.9489C55.2667 61.5605 53.0823 62.5874 51.9939 64.5098C51.9154 64.6608 51.8369 64.8034 51.772 64.9605C51.5492 65.3642 51.055 65.5324 50.6316 65.3463C50.209 65.1611 49.9965 64.6839 50.1433 64.246C50.2329 64.0437 50.3337 63.8456 50.4429 63.6536C51.02 62.6361 51.8258 61.8038 52.7716 61.202C49.8565 55.0654 43.2598 51.505 36.4813 52.4935C29.4714 53.5153 24.0374 59.1431 23.2631 66.182L23.1923 66.9886H5.98012C5.48673 66.9886 5.08639 66.5891 5.08639 66.0958C5.08639 65.6032 5.48673 65.2029 5.98012 65.2029H21.5918C22.7937 57.5545 28.9209 51.6288 36.6085 50.683C44.046 49.7662 51.2001 53.7261 54.3943 60.4415ZM2.32838 65.2029C2.82177 65.2029 3.22211 65.6032 3.22211 66.0958C3.22211 66.5891 2.82177 66.9886 2.32838 66.9886H0.399223C-0.0941632 66.9886 -0.493652 66.5891 -0.493652 66.0966C-0.493652 65.6041 -0.0941632 65.2037 0.399223 65.2037H2.32838V65.2029ZM162.89 57.1226L163.171 57.1183C167.709 57.1423 171.456 60.6745 171.744 65.2029H181.511C182.005 65.2029 182.405 65.6032 182.405 66.0958C182.405 66.5891 182.005 66.9886 181.511 66.9886H169.951L170.001 66.0531C170.005 65.9916 170.005 65.9293 170.001 65.8678V65.7313C170 63.1756 168.57 60.8341 166.296 59.6638C164.024 58.4944 161.287 58.6907 159.205 60.1751C159.013 60.316 158.774 60.3732 158.539 60.3339C158.305 60.2946 158.097 60.1632 157.962 59.9677C157.677 59.5665 157.769 59.0117 158.168 58.7248C159.016 58.1171 159.961 57.6732 160.957 57.4077C158.754 54.158 154.854 52.4115 150.9 53.0057C146.538 53.6612 143.077 57.021 142.292 61.3608L142.192 61.9754L141.571 62.0889C139.421 62.4739 137.724 64.129 137.284 66.2673L137.083 66.9886H117.857C117.363 66.9886 116.964 66.5891 116.964 66.0958C116.964 65.6032 117.363 65.2029 117.857 65.2029H135.654C136.392 62.8828 138.261 61.0987 140.614 60.4679C141.738 55.5033 145.855 51.7756 150.908 51.1448C155.76 50.5396 160.477 52.916 162.89 57.1226V57.1226ZM191.107 65.2029C191.601 65.2029 192 65.6032 192 66.0958C192 66.5891 191.601 66.9886 191.107 66.9886H185.17C184.676 66.9886 184.277 66.5891 184.277 66.0958C184.277 65.6032 184.676 65.2029 185.17 65.2029H191.107ZM160.534 25.9838C162.212 26.4644 163.481 27.843 163.82 29.5553H177.661C178.154 29.5553 178.553 29.9548 178.553 30.4482C178.553 30.9416 178.154 31.3411 177.661 31.3411V31.3265H162.119V30.4337C162.112 29.0355 161.093 27.8472 159.712 27.627L159.132 27.5416L158.975 26.9766C158.347 24.7128 156.144 23.2582 153.814 23.5707C151.484 23.8814 149.741 25.8626 149.73 28.2126C149.73 28.706 149.33 29.1055 148.837 29.1055C148.343 29.1055 147.943 28.706 147.943 28.2126C147.946 27.3846 148.104 26.589 148.391 25.8558C146.276 26.484 144.633 28.2757 144.264 30.5481L144.164 31.3265H135.218C134.725 31.3265 134.325 30.9271 134.325 30.4337C134.325 29.9411 134.725 29.5408 135.218 29.5408H142.663C143.527 26.3235 146.353 24.0384 149.65 23.8404C150.588 22.8178 151.855 22.0913 153.305 21.8344C156.402 21.2864 159.446 23.0346 160.533 25.9838H160.534ZM129.795 29.5408C130.29 29.5408 130.689 29.9411 130.689 30.4337C130.689 30.9271 130.29 31.3265 129.796 31.3265H122.08C121.586 31.3265 121.186 30.9271 121.186 30.4337C121.186 29.9411 121.586 29.5408 122.08 29.5408H129.796H129.795ZM134.012 25.6338C134.505 25.6338 134.905 26.0342 134.905 26.5267C134.905 27.0201 134.505 27.4196 134.011 27.4196H129.796C129.303 27.4196 128.902 27.0201 128.902 26.5267C128.902 26.0342 129.303 25.6338 129.796 25.6338H134.011H134.012Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M64.5556 78.0608C64.5539 78.946 64.9056 79.7944 65.533 80.421C66.1604 81.0475 67.0123 81.3992 67.9009 81.3992C67.0123 81.3992 66.1604 81.7518 65.533 82.3775C64.9056 83.004 64.5539 83.8534 64.5556 84.7385C64.5573 83.8525 64.2056 83.0015 63.5757 82.3749C62.9474 81.7484 62.0938 81.3975 61.2035 81.3992C62.0938 81.4018 62.9474 81.0501 63.5765 80.4236C64.2048 79.797 64.5582 78.9468 64.5556 78.0608V78.0608ZM17.4432 74.6011C17.4432 76.9553 19.3587 78.8632 21.7223 78.8632C19.3587 78.8632 17.4432 80.7718 17.4432 83.1261C17.4432 80.7718 15.5277 78.8632 13.1641 78.8632C15.5277 78.8632 17.4432 76.9553 17.4432 74.6011ZM139.724 74.6864C139.724 76.648 141.321 78.2383 143.291 78.2383C141.322 78.2383 139.724 79.8286 139.724 81.7902C139.724 79.8286 138.128 78.2392 136.159 78.2392C138.128 78.2392 139.724 76.648 139.724 74.6864ZM174.428 46.805C174.428 49.1584 176.344 51.0671 178.707 51.0671C176.344 51.0671 174.428 52.9749 174.428 55.3291C174.428 52.9749 172.512 51.0671 170.149 51.0671C172.512 51.0671 174.428 49.1584 174.428 46.805ZM19.5405 39.0329C19.5405 40.6616 20.8653 41.9813 22.5 41.9813C20.8653 41.9813 19.5397 43.3009 19.5397 44.9296C19.5397 43.3009 18.2149 41.9813 16.5802 41.9813C18.2149 41.9813 19.5397 40.6616 19.5397 39.0329H19.5405ZM143.263 39.8498C143.263 41.0278 144.22 41.9813 145.402 41.9813C144.22 41.9813 143.262 42.9356 143.262 44.1127C143.262 42.9347 142.304 41.9813 141.123 41.9813C142.304 41.9813 143.262 41.0269 143.262 39.8498H143.263ZM57.5159 33.7277C57.5142 34.6129 57.8659 35.4614 58.4933 36.0879C59.1207 36.7145 59.9726 37.0662 60.8603 37.0662C59.9726 37.0662 59.1207 37.4187 58.4933 38.0444C57.8659 38.671 57.5142 39.5203 57.5159 40.4055C57.5176 39.5195 57.1659 38.6684 56.536 38.0419C55.9068 37.4153 55.0532 37.0645 54.1638 37.0662C55.0532 37.0687 55.9068 36.7171 56.5368 36.0905C57.1651 35.464 57.5185 34.6138 57.5159 33.7277V33.7277ZM88.2262 7.22314C88.2262 9.5774 90.1417 11.4852 92.5053 11.4852C90.1417 11.4852 88.2262 13.3939 88.2262 15.7473C88.2262 13.3939 86.3107 11.4852 83.947 11.4852C86.3107 11.4852 88.2262 9.5774 88.2262 7.22314ZM44.7152 10.5189C44.7152 11.959 45.8872 13.1267 47.3323 13.1267C45.8889 13.1301 44.7194 14.2953 44.7152 15.7336C44.7152 14.2936 43.5432 13.1267 42.098 13.1267C43.5432 13.1267 44.7152 11.959 44.7152 10.5189ZM173.109 8.50868C173.107 9.29229 173.418 10.0435 173.973 10.5983C174.528 11.1532 175.282 11.4639 176.069 11.4639C174.434 11.4639 173.109 12.7836 173.109 14.4122C173.109 13.6303 172.797 12.88 172.242 12.3277C171.687 11.7746 170.934 11.4639 170.149 11.4639C170.935 11.4639 171.69 11.1523 172.244 10.5983C172.799 10.0435 173.111 9.29229 173.109 8.50868V8.50868Z\" fill=\"#1AAAAD\"/>\n<path d=\"M97.817 90.0592C115.812 90.0592 130.4 75.3375 130.4 57.1773C130.4 39.0171 115.812 24.2954 97.817 24.2954C79.8218 24.2954 65.2339 39.0171 65.2339 57.1773C65.2339 75.3375 79.8218 90.0592 97.817 90.0592Z\" fill=\"white\"/>\n<path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M97.8172 24.3022C96.6256 24.304 95.4357 24.3697 94.25 24.4969C110.545 26.2963 120.298 41.0927 120.298 58.0053C120.298 74.9179 110.545 88.0651 94.25 89.8577C106.296 91.3003 118.139 85.8697 124.984 75.7629C131.83 65.6562 132.544 52.549 126.837 41.7466C121.13 30.9433 109.948 24.2348 97.8181 24.3372V24.3022H97.8172Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M97.817 24.3022C115.813 24.3227 130.393 39.0458 130.401 57.2063C130.389 75.3643 115.796 90.0745 97.8033 90.0669C79.8101 90.0583 65.2296 75.3353 65.2339 57.1773C65.2382 39.0202 79.8246 24.3022 97.817 24.3022ZM109.214 29.4469C98.0961 24.7905 85.2954 27.3539 76.7807 35.9386C68.2668 44.526 65.7179 57.4428 70.3231 68.666C74.9283 79.8884 85.7811 87.2047 97.8179 87.2021C114.226 87.1782 127.526 73.7663 127.561 57.2072C127.573 45.0603 120.331 34.1034 109.214 29.4478V29.4469ZM97.8264 64.3152C103.089 64.3152 108.106 66.5653 111.632 70.5064C112.154 71.1039 112.098 72.0139 111.507 72.5406C110.916 73.0681 110.013 73.0109 109.492 72.4151C106.504 69.0775 102.255 67.1739 97.7974 67.1739C93.3415 67.1739 89.0923 69.0775 86.1046 72.4151C85.5797 72.9947 84.6902 73.0425 84.1072 72.5226C83.5387 71.9866 83.5011 71.0903 84.0218 70.5064C87.5472 66.5653 92.5639 64.3152 97.8264 64.3152V64.3152ZM93.2545 51.7944C93.2545 53.9421 91.5302 55.6818 89.403 55.6818C87.2749 55.6818 85.5498 53.9421 85.5498 51.7944C85.5498 49.6468 87.2749 47.9062 89.403 47.9062C91.5302 47.9062 93.2545 49.6476 93.2545 51.7944ZM110.11 51.7944C110.11 53.9421 108.386 55.6818 106.258 55.6818C104.129 55.6818 102.405 53.9421 102.405 51.7944C102.405 49.6468 104.129 47.9062 106.258 47.9062C108.386 47.9062 110.11 49.6476 110.11 51.7944Z\" fill=\"#B6C5D5\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_368_1043\">\n<rect width=\"192\" height=\"98\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var LinealSistemaRateApp = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_201_351)\">\n<g opacity=\"0.6\">\n<path d=\"M32.0985 57.1518C32.3466 57.1518 32.5621 57.2452 32.7482 57.431C32.9326 57.6177 33.0264 57.8305 33.0264 58.0702C33.0264 58.3191 32.9292 58.5403 32.7364 58.7346L31.2997 60.176L32.6199 61.4787C32.8127 61.6721 32.9108 61.8933 32.9108 62.1414C32.9108 62.3895 32.8186 62.6064 32.6375 62.7931C32.4556 62.979 32.241 63.0723 31.9937 63.0723C31.7314 63.0723 31.5042 62.963 31.3097 62.746L30.0692 61.4787L28.8177 62.746C28.6165 62.9563 28.3885 63.0606 28.1337 63.0606C27.8864 63.0606 27.6726 62.9689 27.4907 62.7873C27.3097 62.6048 27.2183 62.3937 27.2183 62.1532C27.2183 61.9051 27.3156 61.6805 27.5075 61.4787L28.8294 60.176L27.3927 58.7337C27.1999 58.5403 27.1018 58.3191 27.1018 58.071C27.1018 57.8305 27.1957 57.6169 27.3801 57.4319C27.5662 57.2452 27.7825 57.1518 28.0297 57.1518C28.2854 57.1518 28.5126 57.257 28.7137 57.4664L30.07 58.8851L31.4145 57.4664C31.6157 57.2561 31.8437 57.1518 32.0985 57.1518ZM11.0799 56.6781C11.328 56.6781 11.5435 56.7714 11.7295 56.9581C11.914 57.144 12.0078 57.3576 12.0078 57.5972C12.0078 57.8453 11.9106 58.0665 11.717 58.2608L10.2811 59.7022L11.6013 61.0058C11.7941 61.1992 11.8922 61.4204 11.8922 61.6684C11.8922 61.9165 11.8 62.1335 11.6189 62.3194C11.437 62.5052 11.2224 62.5986 10.9751 62.5986C10.7128 62.5986 10.4856 62.4892 10.2911 62.2731L9.05055 61.0049L7.79906 62.2731C7.59789 62.4825 7.36989 62.5868 7.11506 62.5868C6.86778 62.5868 6.65404 62.496 6.47214 62.3135C6.29108 62.1318 6.19971 61.9199 6.19971 61.6794C6.19971 61.4313 6.29695 61.2067 6.4889 61.0049L7.8108 59.7022L6.37406 58.2608C6.18127 58.0674 6.0832 57.8453 6.0832 57.5972C6.0832 57.3576 6.17708 57.144 6.36149 56.9581C6.54674 56.7714 6.76384 56.6789 7.01112 56.6789C7.26678 56.6789 7.49395 56.7832 7.69512 56.9926L9.05138 58.4113L10.3959 56.9926C10.5971 56.7832 10.8251 56.6789 11.0799 56.6789V56.6781ZM152.725 74.0696C152.973 74.0696 153.186 74.1622 153.369 74.348C153.55 74.5347 153.641 74.7517 153.641 74.9998C153.641 75.2479 153.544 75.469 153.35 75.6625L152.03 76.966L153.466 78.4074C153.659 78.6009 153.757 78.822 153.757 79.0701C153.757 79.3106 153.662 79.5243 153.478 79.7093C153.294 79.896 153.076 79.9893 152.829 79.9893C152.574 79.9893 152.346 79.8842 152.144 79.6748L150.801 78.2561L149.444 79.6748C149.242 79.885 149.017 79.9893 148.76 79.9893C148.512 79.9893 148.298 79.8968 148.11 79.7101C147.926 79.5243 147.833 79.3107 147.833 79.071C147.833 78.822 147.93 78.6009 148.123 78.4074L149.559 76.9651L148.238 75.6625C148.046 75.4606 147.947 75.2361 147.947 74.988C147.947 74.7475 148.04 74.5364 148.222 74.3539C148.403 74.1722 148.618 74.0806 148.865 74.0806C149.119 74.0806 149.349 74.1857 149.548 74.3951L150.801 75.6625L152.041 74.3951C152.235 74.1781 152.46 74.0696 152.726 74.0696H152.725ZM4.99671 31.9311C5.24483 31.9311 5.46026 32.0244 5.64634 32.2103C5.83075 32.397 5.92464 32.6098 5.92464 32.8494C5.92464 33.0984 5.8274 33.3195 5.63377 33.5138L4.19788 34.9553L5.51809 36.2579C5.71089 36.4514 5.80896 36.6725 5.80896 36.9206C5.80896 37.1687 5.71675 37.3857 5.5357 37.5724C5.3538 37.7574 5.13921 37.8516 4.89193 37.8516C4.62957 37.8516 4.4024 37.7423 4.20793 37.5253L2.96735 36.2579L1.71586 37.5253C1.51469 37.7355 1.28669 37.8398 1.03187 37.8398C0.784587 37.8398 0.570837 37.7482 0.38894 37.5665C0.207882 37.384 0.116514 37.1729 0.116514 36.9324C0.116514 36.6843 0.21375 36.4598 0.405705 36.2579L1.7276 34.9553L0.290867 33.513C0.0980734 33.3195 0 33.0984 0 32.8503C0 32.6098 0.0938822 32.3961 0.278294 32.2111C0.464382 32.0244 0.680646 31.9311 0.927925 31.9311C1.18359 31.9311 1.41075 32.0362 1.61192 32.2456L2.96819 33.6643L4.31271 32.2456C4.51389 32.0354 4.74189 31.9311 4.99671 31.9311ZM187.442 49.5005C187.69 49.5005 187.902 49.5938 188.085 49.7797C188.266 49.9664 188.357 50.1834 188.357 50.4314C188.357 50.6795 188.26 50.9007 188.066 51.0941L186.746 52.3968L188.182 53.8391C188.375 54.0325 188.473 54.2537 188.473 54.5018C188.473 54.7423 188.379 54.9559 188.194 55.1409C188.01 55.3276 187.792 55.421 187.545 55.421C187.291 55.421 187.063 55.3159 186.861 55.1065L185.517 53.6877L184.161 55.1065C183.959 55.3167 183.733 55.421 183.476 55.421C183.229 55.421 183.014 55.3276 182.826 55.1418C182.642 54.9551 182.55 54.7423 182.55 54.5018C182.55 54.2537 182.646 54.0325 182.84 53.8391L184.275 52.3968L182.954 51.0941C182.762 50.8923 182.664 50.6678 182.664 50.4197C182.664 50.1791 182.757 49.9681 182.938 49.7856C183.119 49.6039 183.334 49.5123 183.581 49.5123C183.835 49.5123 184.065 49.6174 184.265 49.8268L185.517 51.0941L186.757 49.8268C186.951 49.609 187.177 49.5005 187.442 49.5005ZM48.7316 28.1876C48.9789 28.1876 49.1926 28.2801 49.3745 28.4668C49.5556 28.6526 49.6469 28.8704 49.6469 29.1177C49.6469 29.3658 49.5497 29.587 49.3561 29.7812L48.0359 31.0831L49.4718 32.5254C49.6654 32.7188 49.7626 32.9408 49.7626 33.1889C49.7626 33.4286 49.6696 33.6422 49.4843 33.828C49.2999 34.0139 49.0828 34.1072 48.8347 34.1072C48.5799 34.1072 48.3527 34.003 48.1507 33.7936L46.8062 32.3748L45.4499 33.7936C45.2487 34.003 45.0224 34.1072 44.7659 34.1072C44.5186 34.1072 44.3032 34.0147 44.1163 33.828C43.9319 33.6422 43.838 33.4286 43.838 33.1889C43.838 32.9408 43.9361 32.7196 44.1289 32.5254L45.5656 31.0831L44.2437 29.7812C44.0517 29.5794 43.9545 29.354 43.9545 29.1059C43.9545 28.8662 44.0467 28.6543 44.2278 28.4727C44.4088 28.2902 44.6234 28.1993 44.8707 28.1993C45.1247 28.1993 45.3544 28.3036 45.5547 28.513L46.8062 29.7812L48.0468 28.513C48.2404 28.2961 48.4676 28.1876 48.7316 28.1876ZM191.539 16.7703C191.786 16.7703 192 16.8637 192.182 17.0504C192.363 17.2354 192.454 17.4532 192.454 17.7013C192.454 17.9494 192.357 18.1706 192.163 18.364L190.843 19.6675L192.279 21.109C192.472 21.3024 192.57 21.5236 192.57 21.7717C192.57 22.0122 192.477 22.2258 192.291 22.4116C192.107 22.5975 191.89 22.6909 191.642 22.6909C191.387 22.6909 191.16 22.5857 190.958 22.3763L189.613 20.9576L188.257 22.3763C188.056 22.5866 187.829 22.6909 187.573 22.6909C187.326 22.6909 187.11 22.5983 186.923 22.4116C186.739 22.2258 186.645 22.0122 186.645 21.7725C186.645 21.5236 186.743 21.3032 186.936 21.109L188.373 19.6667L187.051 18.364C186.859 18.1622 186.762 17.9376 186.762 17.6895C186.762 17.449 186.854 17.2379 187.035 17.0554C187.216 16.8738 187.43 16.7829 187.678 16.7829C187.932 16.7829 188.161 16.8872 188.362 17.0966L189.613 18.364L190.854 17.0966C191.047 16.8797 191.275 16.7712 191.539 16.7712V16.7703ZM33.2773 38.6969C33.4617 38.8827 33.5556 39.0963 33.5556 39.336C33.5556 39.5841 33.4583 39.8053 33.2655 39.9995L31.828 41.441L33.1482 42.7428C33.341 42.9362 33.439 43.1583 33.439 43.4064C33.439 43.6544 33.3468 43.8714 33.1658 44.0573C32.9839 44.2431 32.7693 44.3365 32.522 44.3365C32.2597 44.3365 32.0325 44.228 31.838 44.011L30.5974 42.7428L29.346 44.011C29.1448 44.2204 28.9168 44.3247 28.662 44.3247C28.4147 44.3247 28.2009 44.2339 28.019 44.0514C27.838 43.8697 27.7466 43.6578 27.7466 43.4181C27.7466 43.17 27.8438 42.9447 28.0358 42.7428L29.3577 41.441L27.921 39.9987C27.7282 39.8053 27.6301 39.5833 27.6301 39.3352C27.6301 39.0955 27.724 38.8819 27.9084 38.696C28.0945 38.5093 28.3107 38.4168 28.558 38.4168C28.8137 38.4168 29.0408 38.5211 29.242 38.7305L30.5983 40.1492L31.9428 38.7305C32.144 38.5211 32.372 38.4168 32.6268 38.4168C32.8758 38.4176 33.0912 38.5102 33.2773 38.6969ZM135.764 3C136.011 3 136.225 3.09251 136.407 3.27921C136.588 3.46506 136.679 3.68288 136.679 3.93097C136.679 4.17906 136.582 4.3994 136.389 4.59366L135.068 5.89634L136.504 7.33863C136.698 7.53206 136.795 7.75323 136.795 8.00132C136.795 8.24185 136.702 8.45546 136.517 8.64047C136.332 8.82717 136.115 8.91968 135.867 8.91968C135.612 8.91968 135.385 8.8154 135.183 8.60599L133.839 7.18725L132.482 8.60599C132.281 8.8154 132.055 8.91968 131.798 8.91968C131.551 8.91968 131.336 8.82717 131.149 8.64131C130.964 8.45461 130.87 8.24185 130.87 8.00132C130.87 7.75323 130.969 7.53206 131.161 7.33863L132.598 5.89634L131.276 4.59282C131.084 4.39183 130.987 4.16728 130.987 3.91919C130.987 3.67867 131.079 3.46759 131.26 3.28509C131.441 3.1026 131.656 3.01177 131.903 3.01177C132.157 3.01177 132.387 3.1169 132.587 3.32546L133.839 4.59366L135.079 3.32546C135.273 3.10849 135.5 3 135.764 3Z\" fill=\"#B6C5D5\"/>\n</g>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M133.688 42.2355C132.919 43.337 131.521 44.1096 130.284 44.8724C129.078 41.1567 127.751 37.4748 126.319 33.8355C127.204 33.6879 128.088 33.5452 128.979 33.4511C131.15 33.2233 131.979 33.8464 132.998 35.8572C133.966 37.77 135.088 40.2316 133.688 42.2355ZM132.997 68.2646C132.895 69.8098 132.094 70.5835 130.938 70.9054C128.998 59.7843 125.553 48.4592 121.377 38.0196C117.86 29.2274 114.465 19.4178 109.152 11.4764C110.123 11.0554 111.108 10.9801 112.055 11.525C113.314 12.2481 114.393 15.1257 115.056 16.3381C118.135 21.9695 120.716 27.899 123.086 33.8582C125.916 40.9794 128.417 48.2512 130.378 55.6626C131.365 59.395 133.253 64.3786 132.997 68.2646ZM120.7 69.1898C114.31 67.7732 107.932 66.1982 101.405 65.5474C93.9363 64.8025 86.5363 65.5227 79.1927 66.8698C76.6559 59.7843 74.2603 52.6523 72.0071 45.4707C84.2565 38.7675 93.7822 28.2972 102.762 17.7863C103.801 16.5709 105.447 14.2391 107.286 12.6839C112.586 20.6372 116.045 30.5418 119.515 39.3202C123.498 49.3893 126.808 60.345 128.717 71.0659C125.985 70.8638 122.617 69.6137 120.7 69.1898ZM79.6147 80.2653C80.011 80.7873 80.6375 81.4599 80.9577 81.9631C82.8897 85.0022 82.9322 86.8714 80.3786 89.6984C79.6977 90.4513 78.3715 91.2962 77.485 91.7212C76.6163 92.1372 75.975 92.3601 75.4037 92.3759C75.8158 91.6677 76.1558 90.9208 76.4226 90.1392C76.8861 88.7792 74.7396 88.1957 74.2781 89.5469C74.0548 90.2036 73.7544 90.8168 73.3996 91.4032C73.3037 91.3121 73.2118 91.2318 73.11 91.1268C72.9025 90.9148 72.7078 90.6781 72.5151 90.4384C72.5368 90.3928 72.5615 90.3492 72.5793 90.2967C72.7414 89.8193 73.0438 89.3973 73.2691 88.9476C73.5439 88.3968 73.7761 87.8233 73.9767 87.2418C74.4432 85.8828 72.2967 85.2983 71.8322 86.6495C71.6356 87.222 71.3529 87.753 71.0772 88.2869C70.7827 87.7648 70.507 87.226 70.2411 86.6822C70.2441 86.6752 70.252 86.6722 70.255 86.6643C70.7649 85.549 71.2739 84.4326 71.7838 83.3162C72.0338 82.7694 71.939 82.1166 71.3855 81.7917C70.9062 81.5114 70.1146 81.6412 69.8636 82.1909C69.579 82.816 69.2934 83.44 69.0088 84.0631C68.8082 83.6292 68.6086 83.2043 68.4109 82.8061C68.3081 82.5981 68.2133 82.3861 68.1115 82.1771C68.1945 82.1008 68.2735 82.0136 68.3398 81.8997C68.8349 81.0448 69.33 80.189 69.8261 79.3332C70.5465 78.091 68.6254 76.9677 67.9069 78.2089C67.5976 78.7408 67.2892 79.2737 66.9799 79.8076C66.7003 79.2153 66.4117 78.6289 66.135 78.0365C66.216 77.9652 66.297 77.8948 66.3652 77.8057C66.808 77.2213 67.2369 76.6259 67.6509 76.0187C67.9899 75.5215 67.7438 74.7835 67.2517 74.4942C66.7012 74.1723 66.0707 74.3962 65.7308 74.8944C65.5213 75.2015 65.296 75.4977 65.0795 75.7998C64.8236 75.255 64.5686 74.7102 64.3087 74.1674C64.9402 73.9633 65.5391 73.7691 66.0757 73.6324C68.8823 72.9163 71.6652 72.1218 74.4343 71.2759C75.9068 74.4358 77.4919 77.4679 79.6147 80.2653ZM56.3335 68.6152C55.1832 67.0115 54.2632 65.2968 53.4943 63.4841C52.7245 61.6694 52.1325 59.816 51.7807 57.8725C51.0276 53.7082 53.3569 51.8786 56.9423 50.6682C61.2728 49.2061 65.626 47.8213 69.9951 46.48C72.1989 53.4843 74.538 60.4421 77.0106 67.3552C73.1347 68.6043 69.2341 69.7603 65.2871 70.7667C61.6147 71.7018 58.8397 72.106 56.3335 68.6152ZM131.095 31.1401C129.305 30.9004 127.328 31.3482 125.483 31.7058C123.577 27.0253 121.488 22.4271 119.233 17.9448C117.812 15.1177 116.145 10.6424 113.39 8.77316C109.582 6.18877 105.286 10.467 102.898 13.09C92.7208 24.2686 83.4412 36.0623 69.8093 43.2954C69.6818 43.3627 69.578 43.443 69.4861 43.5272C65.6448 44.704 61.8153 45.9134 58.0047 47.1824C55.5499 47.9996 52.2037 48.5513 50.1777 50.3581C46.6981 53.4606 49.0205 60.2182 50.3942 63.7605C51.6908 67.0997 54.7039 73.8306 58.5828 74.9756C59.6432 75.2887 60.9012 75.1203 62.1593 74.8043C64.4648 79.5976 66.5639 84.5287 69.2242 89.1407C70.9379 92.1114 72.6722 96.0638 76.6766 94.7355C80.852 93.3497 86.1114 89.0793 84.8395 84.1374C84.1972 81.6402 81.9222 79.7779 80.5061 77.7522C78.9397 75.5096 77.7182 73.0817 76.5679 70.6122C77.1875 70.4161 77.8072 70.2229 78.4258 70.0218C86.2478 68.4944 94.1152 67.7108 102.063 68.5915C109.136 69.374 116.045 71.2452 122.993 72.729C126.414 73.4591 132.938 76.1633 135.289 72.0089C137.691 67.7663 134.523 59.8309 133.43 55.615C132.687 52.7513 131.86 49.8975 130.978 47.0575C132.897 45.7649 135.276 44.5395 136.214 42.3761C137.201 40.0939 136.217 37.5749 135.256 35.4679C134.432 33.6601 133.261 31.4304 131.095 31.1401Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M166.726 16.3146C166.726 16.2976 166.728 16.281 166.728 16.264C166.728 13.0867 164.427 10.1777 160.968 10.1777C158.219 10.1777 156.624 12.1508 156.081 13.9978C155.537 12.1508 153.943 10.1777 151.194 10.1777C147.735 10.1777 145.434 13.0867 145.434 16.264C145.434 16.281 145.435 16.2976 145.435 16.3146C145.416 17.0057 145.434 24.0399 156.078 29.7729V29.7745C156.078 29.7745 156.079 29.7742 156.079 29.7738C156.08 29.7742 156.08 29.7745 156.081 29.7745C156.081 29.7745 156.082 29.7742 156.082 29.7738C156.083 29.7742 156.083 29.7745 156.084 29.7745V29.7729C166.728 24.0399 166.745 17.0057 166.726 16.3146Z\" fill=\"#DD2457\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M66.1092 11.7017C66.602 11.7017 67.0445 11.9879 67.3418 12.3718C67.6093 12.7173 67.7218 13.155 67.7676 13.61C67.8126 14.0573 67.7932 14.5209 67.7932 14.9295C67.7929 15.669 67.7751 16.4519 67.5718 17.1741C67.5376 17.2961 67.6337 17.4163 67.7605 17.4163H72.761C73.6963 17.4163 74.4616 18.1817 74.4616 19.117C74.4616 19.5925 74.2379 20.0172 73.8909 20.2936C73.8204 20.3499 73.7992 20.4478 73.8403 20.5284C73.943 20.7314 74.0016 20.9602 74.0016 21.2024V21.397C74.0016 21.8726 73.7778 22.2972 73.4308 22.5737C73.3603 22.6299 73.3392 22.7278 73.3802 22.8085C73.4829 23.0114 73.5415 23.2402 73.5415 23.4825V23.6771C73.5415 24.1526 73.3178 24.7835 72.9708 25.0596C72.9002 25.1159 72.8791 25.2141 72.9202 25.2944C73.0229 25.4977 73.0815 25.7265 73.0815 25.9687C73.0815 26.904 72.3161 27.6694 71.3808 27.6694H64.9716C64.2446 27.6694 63.5997 27.3189 63.1962 26.7776C63.159 26.7279 63.1019 26.6969 63.0397 26.6969H60.9942C60.8867 26.6969 60.7995 26.6097 60.7995 26.5023V19.1087C60.7995 19.0155 60.8659 18.9367 60.9573 18.9191C61.5476 18.8037 61.9589 18.632 62.5189 18.4109C63.2474 18.1231 63.7113 17.5369 64.0387 16.8542C64.5068 15.8791 64.5556 14.7852 64.6797 13.7273C64.7862 12.8209 64.9671 11.7017 66.1092 11.7017ZM58.9417 18.084C59.3926 18.084 59.7583 18.4497 59.7583 18.9005V26.6367C59.7583 27.0875 59.3926 27.4532 58.9417 27.4532H56.6295C56.1784 27.4532 55.813 27.0875 55.813 26.6367V18.9005C55.813 18.4497 56.1784 18.084 56.6295 18.084H58.9417Z\" fill=\"#0A7FE4\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M155.043 54.0879C155.043 49.2182 158.991 45.2705 163.86 45.2705C168.73 45.2705 172.678 49.2182 172.678 54.0879C172.678 58.9576 168.73 62.9053 163.86 62.9053C158.991 62.9053 155.043 58.9576 155.043 54.0879Z\" fill=\"#FFD05D\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M161.584 52.2426C161.335 51.619 160.739 51.2158 160.068 51.2158C159.41 51.2158 158.819 51.6071 158.563 52.2126C158.514 52.3287 158.553 52.4594 158.657 52.5307C158.761 52.6023 158.897 52.591 158.988 52.5031C159.477 52.0287 160.25 51.6479 161.157 52.5289C161.208 52.5786 161.274 52.6042 161.34 52.6042C161.391 52.6042 161.442 52.5892 161.487 52.5589C161.591 52.4892 161.631 52.3592 161.584 52.2426Z\" fill=\"#303030\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M169.16 52.2426C168.91 51.619 168.315 51.2158 167.643 51.2158C166.986 51.2158 166.395 51.6071 166.139 52.2126C166.09 52.3284 166.128 52.4592 166.232 52.5307C166.337 52.6023 166.473 52.591 166.564 52.5031C167.053 52.0287 167.826 51.6479 168.733 52.5289C168.784 52.5786 168.85 52.6042 168.916 52.6042C168.967 52.6042 169.018 52.5892 169.063 52.5589C169.167 52.4892 169.207 52.3592 169.16 52.2426Z\" fill=\"#303030\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M159.918 55.7502C159.918 55.7454 159.919 55.741 159.919 55.7362C159.919 54.8563 159.282 54.0508 158.326 54.0508C157.565 54.0508 157.124 54.5971 156.974 55.1086C156.824 54.5971 156.383 54.0508 155.622 54.0508C154.666 54.0508 154.029 54.8563 154.029 55.7362C154.029 55.741 154.03 55.7454 154.03 55.7502C154.025 55.9415 154.029 57.8895 156.973 59.4771V59.4776C156.973 59.4776 156.974 59.4773 156.974 59.4773C156.974 59.4773 156.974 59.4776 156.974 59.4776L156.974 59.4773C156.975 59.4773 156.975 59.4776 156.975 59.4776V59.4771C159.919 57.8895 159.924 55.9415 159.918 55.7502Z\" fill=\"#EE5181\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M163.861 58.9917C163.059 58.9917 162.407 58.3396 162.407 57.5378C162.407 57.1891 162.53 56.8589 162.752 56.5984C162.53 56.3381 162.407 56.0076 162.407 55.6589C162.407 54.8571 163.059 54.2051 163.861 54.2051C164.349 54.2051 164.802 54.4485 165.072 54.8558C165.149 54.9703 165.117 55.125 165.003 55.2011C164.888 55.2774 164.733 55.2461 164.657 55.1313C164.48 54.8635 164.182 54.7035 163.861 54.7035C163.334 54.7035 162.905 55.1321 162.905 55.6589C162.905 55.9497 163.036 56.2213 163.264 56.4042C163.323 56.4513 163.357 56.5228 163.357 56.5984C163.357 56.6739 163.323 56.7455 163.264 56.7928C163.036 56.9755 162.905 57.247 162.905 57.5378C162.905 58.0646 163.334 58.4933 163.861 58.4933C164.178 58.4933 164.475 58.3359 164.653 58.072C164.73 57.958 164.885 57.9278 164.999 58.0051C165.113 58.082 165.143 58.237 165.066 58.3509C164.795 58.7522 164.344 58.9917 163.861 58.9917Z\" fill=\"#5E4939\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_201_351\">\n<rect width=\"192\" height=\"98\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var LinealTerminalDefault = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M70.8149 57.9914V94.0741H121.185L121.177 57.991H116.599L116.605 89.4734H75.394L75.3942 57.991L70.8149 57.9914ZM107.447 82.4942V87.0949H112.027V82.4942H107.447ZM79.9731 82.4942V87.0949H84.5521V82.4942H79.9731ZM77.6835 17.9688C73.9626 17.9688 70.9233 20.9569 70.8178 24.6702L70.8149 24.8698V35.0284L75.3942 35.028L75.394 24.8698C75.394 23.6014 76.4211 22.5694 77.6835 22.5694H114.301C115.52 22.5694 116.519 23.531 116.587 24.7387L116.591 24.869L116.593 35.028H121.172L121.17 24.8675C121.169 21.1304 118.194 18.0776 114.5 17.9716L114.301 17.9688H77.6835ZM107.447 26.1979V30.7986H112.027V26.1979H107.447ZM79.9731 26.1979V30.7986H84.5521V26.1979H79.9731Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M80.9799 18.7095V14.1088H71.8218V6.90104C71.8218 3.09581 74.9031 0 78.6904 0H104.691C108.478 0 111.56 3.09581 111.56 6.90104V18.7095H80.9799ZM78.6904 4.60069C77.428 4.60069 76.4009 5.63263 76.4009 6.90104V9.5081H80.9799V6.90104C80.9799 5.63263 79.9529 4.60069 78.6904 4.60069ZM106.981 6.90104C106.981 5.63263 105.953 4.60069 104.691 4.60069H85.1667C85.4207 5.3204 85.559 6.09485 85.559 6.90104V18.7095H106.981V6.90104Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M121.185 37.0371H71.5556C67.8737 37.0371 64.8889 40.0219 64.8889 43.7038V49.1298C64.8889 52.8117 67.8737 55.7965 71.5556 55.7965H121.185C124.867 55.7965 127.852 52.8117 127.852 49.1298V43.7038C127.852 40.0219 124.867 37.0371 121.185 37.0371ZM71.5556 38.5186H121.185C124.049 38.5186 126.37 40.8401 126.37 43.7038V49.1298C126.37 51.9935 124.049 54.315 121.185 54.315H71.5556C68.6919 54.315 66.3704 51.9935 66.3704 49.1298V43.7038C66.3704 40.8401 68.6919 38.5186 71.5556 38.5186Z\" fill=\"#B6C5D5\"/>\n<path d=\"M73.592 46.5921C74.3974 46.6241 74.9867 46.8001 75.36 47.1201C75.7387 47.4401 75.928 47.8748 75.928 48.4241C75.928 48.6695 75.8854 48.8961 75.8 49.1041C75.72 49.3121 75.5947 49.4908 75.424 49.6401C75.2587 49.7895 75.048 49.9068 74.792 49.9921C74.536 50.0775 74.232 50.1201 73.88 50.1201C73.7414 50.1201 73.6 50.1095 73.456 50.0881C73.312 50.0668 73.1787 50.0401 73.056 50.0081C72.9334 49.9761 72.824 49.9441 72.728 49.9121C72.632 49.8801 72.5627 49.8535 72.52 49.8321L72.664 49.1841C72.7547 49.2268 72.9014 49.2828 73.104 49.3521C73.312 49.4215 73.5654 49.4561 73.864 49.4561C74.104 49.4561 74.304 49.4295 74.464 49.3761C74.6294 49.3228 74.7627 49.2508 74.864 49.1601C74.9654 49.0695 75.0374 48.9655 75.08 48.8481C75.128 48.7255 75.152 48.5975 75.152 48.4641C75.152 48.2615 75.1174 48.0828 75.048 47.9281C74.9787 47.7681 74.856 47.6348 74.68 47.5281C74.504 47.4215 74.2694 47.3415 73.976 47.2881C73.6827 47.2295 73.312 47.2001 72.864 47.2001C72.896 46.9388 72.92 46.6935 72.936 46.4641C72.9574 46.2348 72.976 46.0108 72.992 45.7921C73.008 45.5735 73.0214 45.3575 73.032 45.1441C73.0427 44.9255 73.0534 44.6961 73.064 44.4561H75.736V45.0881H73.712C73.7067 45.1681 73.6987 45.2775 73.688 45.4161C73.6774 45.5495 73.6667 45.6908 73.656 45.8401C73.6454 45.9841 73.6347 46.1255 73.624 46.2641C73.6134 46.4028 73.6027 46.5121 73.592 46.5921Z\" fill=\"#B6C5D5\"/>\n<path d=\"M76.8356 48.0801C76.937 47.8455 77.0756 47.5735 77.2516 47.2641C77.4276 46.9495 77.625 46.6268 77.8436 46.2961C78.0676 45.9655 78.305 45.6401 78.5556 45.3201C78.8116 45.0001 79.0676 44.7121 79.3236 44.4561H80.0356V47.9761H80.6916V48.5841H80.0356V50.0001H79.3156V48.5841H76.8356V48.0801ZM79.3156 45.3361C79.1556 45.5068 78.993 45.6988 78.8276 45.9121C78.6676 46.1201 78.5103 46.3388 78.3556 46.5681C78.201 46.7975 78.0543 47.0321 77.9156 47.2721C77.7823 47.5121 77.6623 47.7468 77.5556 47.9761H79.3156V45.3361Z\" fill=\"#B6C5D5\"/>\n<path d=\"M84.7673 45.8721C84.7673 46.0641 84.7273 46.2508 84.6473 46.4321C84.5726 46.6081 84.4713 46.7841 84.3433 46.9601C84.2153 47.1308 84.0713 47.3015 83.9113 47.4721C83.7513 47.6375 83.5913 47.8001 83.4313 47.9601C83.3406 48.0508 83.2339 48.1575 83.1113 48.2801C82.9939 48.4028 82.8819 48.5308 82.7753 48.6641C82.6686 48.7975 82.5779 48.9255 82.5033 49.0481C82.4339 49.1708 82.3993 49.2775 82.3993 49.3681H84.9513V50.0001H81.5913C81.5859 49.9681 81.5833 49.9361 81.5833 49.9041C81.5833 49.8721 81.5833 49.8428 81.5833 49.8161C81.5833 49.5655 81.6233 49.3335 81.7033 49.1201C81.7886 48.9015 81.8979 48.6961 82.0313 48.5041C82.1646 48.3121 82.3139 48.1308 82.4793 47.9601C82.6446 47.7895 82.8073 47.6241 82.9673 47.4641C83.1006 47.3361 83.2259 47.2108 83.3433 47.0881C83.4659 46.9601 83.5726 46.8348 83.6633 46.7121C83.7593 46.5841 83.8339 46.4535 83.8873 46.3201C83.9459 46.1868 83.9753 46.0455 83.9753 45.8961C83.9753 45.7361 83.9486 45.6001 83.8953 45.4881C83.8473 45.3761 83.7806 45.2828 83.6953 45.2081C83.6099 45.1335 83.5086 45.0801 83.3913 45.0481C83.2793 45.0108 83.1593 44.9921 83.0313 44.9921C82.8766 44.9921 82.7353 45.0135 82.6073 45.0561C82.4793 45.0988 82.3646 45.1495 82.2633 45.2081C82.1619 45.2615 82.0766 45.3201 82.0073 45.3841C81.9379 45.4428 81.8846 45.4881 81.8473 45.5201L81.4793 44.9921C81.5273 44.9388 81.5993 44.8748 81.6953 44.8001C81.7913 44.7201 81.9059 44.6455 82.0393 44.5761C82.1726 44.5068 82.3219 44.4481 82.4873 44.4001C82.6526 44.3521 82.8313 44.3281 83.0233 44.3281C83.6046 44.3281 84.0393 44.4641 84.3273 44.7361C84.6206 45.0028 84.7673 45.3815 84.7673 45.8721Z\" fill=\"#B6C5D5\"/>\n<path d=\"M86.2909 45.6001C86.5949 45.4828 86.8909 45.3335 87.1789 45.1521C87.4669 44.9655 87.7309 44.7335 87.9709 44.4561H88.4989V50.0001H87.7549V45.4881C87.6909 45.5468 87.6109 45.6081 87.5149 45.6721C87.4242 45.7361 87.3229 45.7975 87.2109 45.8561C87.1042 45.9148 86.9896 45.9708 86.8669 46.0241C86.7496 46.0775 86.6349 46.1228 86.5229 46.1601L86.2909 45.6001Z\" fill=\"#B6C5D5\"/>\n<path d=\"M93.7985 45.8721C93.7985 46.0641 93.7585 46.2508 93.6785 46.4321C93.6039 46.6081 93.5025 46.7841 93.3745 46.9601C93.2465 47.1308 93.1025 47.3015 92.9425 47.4721C92.7825 47.6375 92.6225 47.8001 92.4625 47.9601C92.3719 48.0508 92.2652 48.1575 92.1425 48.2801C92.0252 48.4028 91.9132 48.5308 91.8065 48.6641C91.6999 48.7975 91.6092 48.9255 91.5345 49.0481C91.4652 49.1708 91.4305 49.2775 91.4305 49.3681H93.9825V50.0001H90.6225C90.6172 49.9681 90.6145 49.9361 90.6145 49.9041C90.6145 49.8721 90.6145 49.8428 90.6145 49.8161C90.6145 49.5655 90.6545 49.3335 90.7345 49.1201C90.8199 48.9015 90.9292 48.6961 91.0625 48.5041C91.1959 48.3121 91.3452 48.1308 91.5105 47.9601C91.6759 47.7895 91.8385 47.6241 91.9985 47.4641C92.1319 47.3361 92.2572 47.2108 92.3745 47.0881C92.4972 46.9601 92.6039 46.8348 92.6945 46.7121C92.7905 46.5841 92.8652 46.4535 92.9185 46.3201C92.9772 46.1868 93.0065 46.0455 93.0065 45.8961C93.0065 45.7361 92.9799 45.6001 92.9265 45.4881C92.8785 45.3761 92.8119 45.2828 92.7265 45.2081C92.6412 45.1335 92.5399 45.0801 92.4225 45.0481C92.3105 45.0108 92.1905 44.9921 92.0625 44.9921C91.9079 44.9921 91.7665 45.0135 91.6385 45.0561C91.5105 45.0988 91.3959 45.1495 91.2945 45.2081C91.1932 45.2615 91.1079 45.3201 91.0385 45.3841C90.9692 45.4428 90.9159 45.4881 90.8785 45.5201L90.5105 44.9921C90.5585 44.9388 90.6305 44.8748 90.7265 44.8001C90.8225 44.7201 90.9372 44.6455 91.0705 44.5761C91.2039 44.5068 91.3532 44.4481 91.5185 44.4001C91.6839 44.3521 91.8625 44.3281 92.0545 44.3281C92.6359 44.3281 93.0705 44.4641 93.3585 44.7361C93.6519 45.0028 93.7985 45.3815 93.7985 45.8721Z\" fill=\"#B6C5D5\"/>\n<path d=\"M98.3141 45.8721C98.3141 46.0641 98.2741 46.2508 98.1941 46.4321C98.1195 46.6081 98.0181 46.7841 97.8901 46.9601C97.7621 47.1308 97.6181 47.3015 97.4581 47.4721C97.2981 47.6375 97.1381 47.8001 96.9781 47.9601C96.8875 48.0508 96.7808 48.1575 96.6581 48.2801C96.5408 48.4028 96.4288 48.5308 96.3221 48.6641C96.2155 48.7975 96.1248 48.9255 96.0501 49.0481C95.9808 49.1708 95.9461 49.2775 95.9461 49.3681H98.4981V50.0001H95.1381C95.1328 49.9681 95.1301 49.9361 95.1301 49.9041C95.1301 49.8721 95.1301 49.8428 95.1301 49.8161C95.1301 49.5655 95.1701 49.3335 95.2501 49.1201C95.3355 48.9015 95.4448 48.6961 95.5781 48.5041C95.7115 48.3121 95.8608 48.1308 96.0261 47.9601C96.1915 47.7895 96.3541 47.6241 96.5141 47.4641C96.6475 47.3361 96.7728 47.2108 96.8901 47.0881C97.0128 46.9601 97.1195 46.8348 97.2101 46.7121C97.3061 46.5841 97.3808 46.4535 97.4341 46.3201C97.4928 46.1868 97.5221 46.0455 97.5221 45.8961C97.5221 45.7361 97.4955 45.6001 97.4421 45.4881C97.3941 45.3761 97.3275 45.2828 97.2421 45.2081C97.1568 45.1335 97.0555 45.0801 96.9381 45.0481C96.8261 45.0108 96.7061 44.9921 96.5781 44.9921C96.4235 44.9921 96.2821 45.0135 96.1541 45.0561C96.0261 45.0988 95.9115 45.1495 95.8101 45.2081C95.7088 45.2615 95.6235 45.3201 95.5541 45.3841C95.4848 45.4428 95.4315 45.4881 95.3941 45.5201L95.0261 44.9921C95.0741 44.9388 95.1461 44.8748 95.2421 44.8001C95.3381 44.7201 95.4528 44.6455 95.5861 44.5761C95.7195 44.5068 95.8688 44.4481 96.0341 44.4001C96.1995 44.3521 96.3781 44.3281 96.5701 44.3281C97.1515 44.3281 97.5861 44.4641 97.8741 44.7361C98.1675 45.0028 98.3141 45.3815 98.3141 45.8721Z\" fill=\"#B6C5D5\"/>\n<path d=\"M100.902 49.4561C101.376 49.4561 101.715 49.3628 101.918 49.1761C102.126 48.9895 102.23 48.7388 102.23 48.4241C102.23 48.2215 102.187 48.0508 102.102 47.9121C102.016 47.7735 101.904 47.6641 101.766 47.5841C101.627 47.4988 101.464 47.4401 101.278 47.4081C101.096 47.3708 100.91 47.3521 100.718 47.3521H100.526V46.7441H100.79C100.923 46.7441 101.059 46.7308 101.198 46.7041C101.342 46.6775 101.472 46.6295 101.59 46.5601C101.707 46.4908 101.803 46.3975 101.878 46.2801C101.952 46.1575 101.99 46.0055 101.99 45.8241C101.99 45.6748 101.963 45.5468 101.91 45.4401C101.856 45.3335 101.784 45.2455 101.694 45.1761C101.608 45.1068 101.507 45.0588 101.39 45.0321C101.278 45.0001 101.158 44.9841 101.03 44.9841C100.774 44.9841 100.555 45.0215 100.374 45.0961C100.198 45.1708 100.048 45.2481 99.9258 45.3281L99.6378 44.7601C99.7018 44.7175 99.7818 44.6721 99.8778 44.6241C99.9791 44.5708 100.091 44.5228 100.214 44.4801C100.336 44.4375 100.467 44.4028 100.606 44.3761C100.75 44.3441 100.899 44.3281 101.054 44.3281C101.347 44.3281 101.6 44.3655 101.814 44.4401C102.027 44.5095 102.203 44.6108 102.342 44.7441C102.48 44.8721 102.584 45.0268 102.654 45.2081C102.723 45.3841 102.758 45.5761 102.758 45.7841C102.758 46.0721 102.675 46.3201 102.51 46.5281C102.344 46.7308 102.144 46.8855 101.91 46.9921C102.054 47.0348 102.192 47.0961 102.326 47.1761C102.459 47.2561 102.574 47.3575 102.67 47.4801C102.771 47.6028 102.851 47.7441 102.91 47.9041C102.974 48.0641 103.006 48.2428 103.006 48.4401C103.006 48.6801 102.963 48.9041 102.878 49.1121C102.798 49.3148 102.67 49.4908 102.494 49.6401C102.323 49.7895 102.107 49.9068 101.846 49.9921C101.584 50.0775 101.275 50.1201 100.918 50.1201C100.779 50.1201 100.635 50.1095 100.486 50.0881C100.342 50.0668 100.206 50.0401 100.078 50.0081C99.9498 49.9761 99.8378 49.9441 99.7418 49.9121C99.6458 49.8801 99.5764 49.8535 99.5338 49.8321L99.6778 49.1841C99.7684 49.2268 99.9178 49.2828 100.126 49.3521C100.339 49.4215 100.598 49.4561 100.902 49.4561Z\" fill=\"#B6C5D5\"/>\n<path d=\"M105.201 46.5921C106.007 46.6241 106.596 46.8001 106.969 47.1201C107.348 47.4401 107.537 47.8748 107.537 48.4241C107.537 48.6695 107.495 48.8961 107.409 49.1041C107.329 49.3121 107.204 49.4908 107.033 49.6401C106.868 49.7895 106.657 49.9068 106.401 49.9921C106.145 50.0775 105.841 50.1201 105.489 50.1201C105.351 50.1201 105.209 50.1095 105.065 50.0881C104.921 50.0668 104.788 50.0401 104.665 50.0081C104.543 49.9761 104.433 49.9441 104.337 49.9121C104.241 49.8801 104.172 49.8535 104.129 49.8321L104.273 49.1841C104.364 49.2268 104.511 49.2828 104.713 49.3521C104.921 49.4215 105.175 49.4561 105.473 49.4561C105.713 49.4561 105.913 49.4295 106.073 49.3761C106.239 49.3228 106.372 49.2508 106.473 49.1601C106.575 49.0695 106.647 48.9655 106.689 48.8481C106.737 48.7255 106.761 48.5975 106.761 48.4641C106.761 48.2615 106.727 48.0828 106.657 47.9281C106.588 47.7681 106.465 47.6348 106.289 47.5281C106.113 47.4215 105.879 47.3415 105.585 47.2881C105.292 47.2295 104.921 47.2001 104.473 47.2001C104.505 46.9388 104.529 46.6935 104.545 46.4641C104.567 46.2348 104.585 46.0108 104.601 45.7921C104.617 45.5735 104.631 45.3575 104.641 45.1441C104.652 44.9255 104.663 44.6961 104.673 44.4561H107.345V45.0881H105.321C105.316 45.1681 105.308 45.2775 105.297 45.4161C105.287 45.5495 105.276 45.6908 105.265 45.8401C105.255 45.9841 105.244 46.1255 105.233 46.2641C105.223 46.4028 105.212 46.5121 105.201 46.5921Z\" fill=\"#B6C5D5\"/>\n<path d=\"M108.445 48.0801C108.546 47.8455 108.685 47.5735 108.861 47.2641C109.037 46.9495 109.234 46.6268 109.453 46.2961C109.677 45.9655 109.914 45.6401 110.165 45.3201C110.421 45.0001 110.677 44.7121 110.933 44.4561H111.645V47.9761H112.301V48.5841H111.645V50.0001H110.925V48.5841H108.445V48.0801ZM110.925 45.3361C110.765 45.5068 110.602 45.6988 110.437 45.9121C110.277 46.1201 110.12 46.3388 109.965 46.5681C109.81 46.7975 109.664 47.0321 109.525 47.2721C109.392 47.5121 109.272 47.7468 109.165 47.9761H110.925V45.3361Z\" fill=\"#B6C5D5\"/>\n<path d=\"M114.233 46.5921C115.038 46.6241 115.627 46.8001 116.001 47.1201C116.379 47.4401 116.569 47.8748 116.569 48.4241C116.569 48.6695 116.526 48.8961 116.441 49.1041C116.361 49.3121 116.235 49.4908 116.065 49.6401C115.899 49.7895 115.689 49.9068 115.433 49.9921C115.177 50.0775 114.873 50.1201 114.521 50.1201C114.382 50.1201 114.241 50.1095 114.097 50.0881C113.953 50.0668 113.819 50.0401 113.697 50.0081C113.574 49.9761 113.465 49.9441 113.369 49.9121C113.273 49.8801 113.203 49.8535 113.161 49.8321L113.305 49.1841C113.395 49.2268 113.542 49.2828 113.745 49.3521C113.953 49.4215 114.206 49.4561 114.505 49.4561C114.745 49.4561 114.945 49.4295 115.105 49.3761C115.27 49.3228 115.403 49.2508 115.505 49.1601C115.606 49.0695 115.678 48.9655 115.721 48.8481C115.769 48.7255 115.793 48.5975 115.793 48.4641C115.793 48.2615 115.758 48.0828 115.689 47.9281C115.619 47.7681 115.497 47.6348 115.321 47.5281C115.145 47.4215 114.91 47.3415 114.617 47.2881C114.323 47.2295 113.953 47.2001 113.505 47.2001C113.537 46.9388 113.561 46.6935 113.577 46.4641C113.598 46.2348 113.617 46.0108 113.633 45.7921C113.649 45.5735 113.662 45.3575 113.673 45.1441C113.683 44.9255 113.694 44.6961 113.705 44.4561H116.377V45.0881H114.353C114.347 45.1681 114.339 45.2775 114.329 45.4161C114.318 45.5495 114.307 45.6908 114.297 45.8401C114.286 45.9841 114.275 46.1255 114.265 46.2641C114.254 46.4028 114.243 46.5121 114.233 46.5921Z\" fill=\"#B6C5D5\"/>\n<path d=\"M118.748 46.5921C119.554 46.6241 120.143 46.8001 120.516 47.1201C120.895 47.4401 121.084 47.8748 121.084 48.4241C121.084 48.6695 121.042 48.8961 120.956 49.1041C120.876 49.3121 120.751 49.4908 120.58 49.6401C120.415 49.7895 120.204 49.9068 119.948 49.9921C119.692 50.0775 119.388 50.1201 119.036 50.1201C118.898 50.1201 118.756 50.1095 118.612 50.0881C118.468 50.0668 118.335 50.0401 118.212 50.0081C118.09 49.9761 117.98 49.9441 117.884 49.9121C117.788 49.8801 117.719 49.8535 117.676 49.8321L117.82 49.1841C117.911 49.2268 118.058 49.2828 118.26 49.3521C118.468 49.4215 118.722 49.4561 119.02 49.4561C119.26 49.4561 119.46 49.4295 119.62 49.3761C119.786 49.3228 119.919 49.2508 120.02 49.1601C120.122 49.0695 120.194 48.9655 120.236 48.8481C120.284 48.7255 120.308 48.5975 120.308 48.4641C120.308 48.2615 120.274 48.0828 120.204 47.9281C120.135 47.7681 120.012 47.6348 119.836 47.5281C119.66 47.4215 119.426 47.3415 119.132 47.2881C118.839 47.2295 118.468 47.2001 118.02 47.2001C118.052 46.9388 118.076 46.6935 118.092 46.4641C118.114 46.2348 118.132 46.0108 118.148 45.7921C118.164 45.5735 118.178 45.3575 118.188 45.1441C118.199 44.9255 118.21 44.6961 118.22 44.4561H120.892V45.0881H118.868C118.863 45.1681 118.855 45.2775 118.844 45.4161C118.834 45.5495 118.823 45.6908 118.812 45.8401C118.802 45.9841 118.791 46.1255 118.78 46.2641C118.77 46.4028 118.759 46.5121 118.748 46.5921Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M35.415 61.7348C35.6165 61.7348 35.7906 61.8177 35.9395 61.9837L36.8906 62.9526L37.8506 61.9837C38.0047 61.8237 38.1795 61.7437 38.375 61.7437C38.5647 61.7437 38.7284 61.8133 38.8684 61.9526C39.0069 62.0918 39.0773 62.2533 39.0773 62.437C39.0773 62.6266 39.0024 62.7985 38.855 62.9526L37.8417 63.9481L38.9432 65.0503C39.0913 65.1985 39.1661 65.3674 39.1661 65.557C39.1661 65.7407 39.0943 65.9037 38.9528 66.0459C38.8106 66.1881 38.6447 66.2592 38.455 66.2592C38.2587 66.2592 38.0847 66.1792 37.9306 66.0192L36.8906 64.9348L35.8595 66.0192C35.7047 66.1792 35.5306 66.2592 35.335 66.2592C35.1447 66.2592 34.9795 66.1881 34.8365 66.0459C34.695 65.9037 34.6232 65.7407 34.6232 65.557C34.6232 65.3674 34.698 65.1985 34.8461 65.0503L35.9476 63.9481L34.935 62.9526C34.7869 62.8044 34.7121 62.6355 34.7121 62.4459C34.7121 62.2563 34.7824 62.0903 34.9217 61.9481C35.061 61.8059 35.2254 61.7348 35.415 61.7348ZM43.7115 53.1425C43.913 53.1425 44.087 53.2255 44.2359 53.3914L45.187 54.3603L46.147 53.3914C46.3011 53.2314 46.4759 53.1514 46.6715 53.1514C46.8611 53.1514 47.0248 53.221 47.1648 53.3603C47.3033 53.4995 47.3737 53.661 47.3737 53.8447C47.3737 54.0343 47.2989 54.2062 47.1515 54.3603L46.1381 55.3558L47.2396 56.458C47.3878 56.6062 47.4626 56.7751 47.4626 56.9647C47.4626 57.1484 47.3907 57.3114 47.2493 57.4536C47.107 57.5958 46.9411 57.6669 46.7515 57.6669C46.5552 57.6669 46.3811 57.5869 46.227 57.4269L45.187 56.3425L44.1559 57.4269C44.0011 57.5869 43.827 57.6669 43.6315 57.6669C43.4411 57.6669 43.2759 57.5958 43.133 57.4536C42.9915 57.3114 42.9196 57.1484 42.9196 56.9647C42.9196 56.7751 42.9944 56.6062 43.1426 56.458L44.2441 55.3558L43.2315 54.3603C43.0833 54.2121 43.0085 54.0432 43.0085 53.8536C43.0085 53.664 43.0789 53.498 43.2181 53.3558C43.3574 53.2136 43.5219 53.1425 43.7115 53.1425ZM172.248 51.6114C172.45 51.6114 172.624 51.6943 172.773 51.8603L173.724 52.8292L174.684 51.8603C174.838 51.7003 175.013 51.6203 175.208 51.6203C175.398 51.6203 175.562 51.6899 175.701 51.8292C175.841 51.9684 175.911 52.1299 175.911 52.3136C175.911 52.5032 175.836 52.6751 175.689 52.8292L174.676 53.8247L175.777 54.9269C175.925 55.0751 176 55.244 176 55.4336C176 55.6173 175.928 55.7803 175.787 55.9225C175.644 56.0647 175.479 56.1358 175.289 56.1358C175.093 56.1358 174.919 56.0558 174.764 55.8958L173.724 54.8114L172.693 55.8958C172.539 56.0558 172.364 56.1358 172.169 56.1358C171.979 56.1358 171.813 56.0647 171.67 55.9225C171.529 55.7803 171.457 55.6173 171.457 55.4336C171.457 55.244 171.532 55.0751 171.68 54.9269L172.781 53.8247L171.769 52.8292C171.621 52.681 171.546 52.5121 171.546 52.3225C171.546 52.1329 171.616 51.9669 171.755 51.8247C171.895 51.6825 172.059 51.6114 172.248 51.6114ZM150.853 49.2905C151.054 49.2905 151.228 49.3734 151.377 49.5394L152.328 50.5083L153.288 49.5394C153.442 49.3794 153.617 49.2994 153.813 49.2994C154.002 49.2994 154.166 49.369 154.306 49.5083C154.445 49.6475 154.515 49.809 154.515 49.9927C154.515 50.1823 154.44 50.3542 154.293 50.5083L153.279 51.5038L154.381 52.606C154.529 52.7542 154.604 52.9231 154.604 53.1127C154.604 53.2964 154.532 53.4594 154.39 53.6016C154.248 53.7438 154.082 53.8149 153.893 53.8149C153.696 53.8149 153.522 53.7349 153.368 53.5749L152.328 52.4905L151.297 53.5749C151.142 53.7349 150.968 53.8149 150.773 53.8149C150.582 53.8149 150.417 53.7438 150.274 53.6016C150.133 53.4594 150.061 53.2964 150.061 53.1127C150.061 52.9231 150.136 52.7542 150.284 52.606L151.385 51.5038L150.373 50.5083C150.225 50.3601 150.15 50.1912 150.15 50.0016C150.15 49.812 150.22 49.646 150.359 49.5038C150.499 49.3616 150.663 49.2905 150.853 49.2905ZM30.4953 46.9732C30.6968 46.9732 30.8709 47.0561 31.0198 47.222L31.9709 48.1909L32.9309 47.222C33.085 47.062 33.2598 46.982 33.4553 46.982C33.645 46.982 33.8087 47.0517 33.9487 47.1909C34.0872 47.3302 34.1576 47.4917 34.1576 47.6754C34.1576 47.865 34.0827 48.0369 33.9353 48.1909L32.922 49.1865L34.0235 50.2887C34.1716 50.4369 34.2464 50.6057 34.2464 50.7954C34.2464 50.9791 34.1746 51.142 34.0331 51.2843C33.8909 51.4265 33.725 51.4976 33.5353 51.4976C33.339 51.4976 33.165 51.4176 33.0109 51.2576L31.9709 50.1732L30.9398 51.2576C30.785 51.4176 30.6109 51.4976 30.4153 51.4976C30.225 51.4976 30.0598 51.4265 29.9168 51.2843C29.7753 51.142 29.7035 50.9791 29.7035 50.7954C29.7035 50.6057 29.7783 50.4369 29.9264 50.2887L31.0279 49.1865L30.0153 48.1909C29.8672 48.0428 29.7924 47.8739 29.7924 47.6843C29.7924 47.4946 29.8627 47.3287 30.002 47.1865C30.1413 47.0443 30.3057 46.9732 30.4953 46.9732ZM162.408 41.5871C162.61 41.5871 162.784 41.67 162.933 41.836L163.884 42.8049L164.844 41.836C164.998 41.676 165.173 41.596 165.368 41.596C165.558 41.596 165.722 41.6656 165.861 41.8049C166.001 41.9441 166.071 42.1056 166.071 42.2893C166.071 42.4789 165.996 42.6508 165.849 42.8049L164.836 43.8004L165.937 44.9026C166.085 45.0508 166.16 45.2197 166.16 45.4093C166.16 45.593 166.088 45.756 165.947 45.8982C165.804 46.0404 165.639 46.1115 165.449 46.1115C165.253 46.1115 165.079 46.0315 164.924 45.8715L163.884 44.7871L162.853 45.8715C162.699 46.0315 162.524 46.1115 162.329 46.1115C162.139 46.1115 161.973 46.0404 161.83 45.8982C161.689 45.756 161.617 45.593 161.617 45.4093C161.617 45.2197 161.692 45.0508 161.84 44.9026L162.941 43.8004L161.929 42.8049C161.781 42.6567 161.706 42.4878 161.706 42.2982C161.706 42.1086 161.776 41.9426 161.915 41.8004C162.055 41.6582 162.219 41.5871 162.408 41.5871ZM16.7919 38.6767C16.9933 38.6767 17.1674 38.7597 17.3163 38.9256L18.2674 39.8945L19.2274 38.9256C19.3815 38.7656 19.5563 38.6856 19.7519 38.6856C19.9415 38.6856 20.1052 38.7552 20.2452 38.8945C20.3837 39.0337 20.4541 39.1952 20.4541 39.3789C20.4541 39.5686 20.3793 39.7404 20.2319 39.8945L19.2185 40.89L20.32 41.9923C20.4681 42.1404 20.543 42.3093 20.543 42.4989C20.543 42.6826 20.4711 42.8456 20.3296 42.9878C20.1874 43.13 20.0215 43.2012 19.8319 43.2012C19.6356 43.2012 19.4615 43.1212 19.3074 42.9612L18.2674 41.8767L17.2363 42.9612C17.0815 43.1212 16.9074 43.2012 16.7119 43.2012C16.5215 43.2012 16.3563 43.13 16.2133 42.9878C16.0719 42.8456 16 42.6826 16 42.4989C16 42.3093 16.0748 42.1404 16.223 41.9923L17.3244 40.89L16.3119 39.8945C16.1637 39.7463 16.0889 39.5774 16.0889 39.3878C16.0889 39.1982 16.1593 39.0323 16.2985 38.89C16.4378 38.7478 16.6022 38.6767 16.7919 38.6767ZM39.563 37.2508C39.7644 37.2508 39.9385 37.3337 40.0874 37.4997L41.0385 38.4686L41.9985 37.4997C42.1526 37.3397 42.3274 37.2597 42.523 37.2597C42.7126 37.2597 42.8763 37.3293 43.0163 37.4686C43.1548 37.6078 43.2252 37.7693 43.2252 37.953C43.2252 38.1426 43.1504 38.3145 43.003 38.4686L41.9896 39.4641L43.0911 40.5663C43.2393 40.7145 43.3141 40.8834 43.3141 41.073C43.3141 41.2567 43.2422 41.4197 43.1007 41.5619C42.9585 41.7041 42.7926 41.7752 42.603 41.7752C42.4067 41.7752 42.2326 41.6952 42.0785 41.5352L41.0385 40.4508L40.0074 41.5352C39.8526 41.6952 39.6785 41.7752 39.483 41.7752C39.2926 41.7752 39.1274 41.7041 38.9844 41.5619C38.843 41.4197 38.7711 41.2567 38.7711 41.073C38.7711 40.8834 38.8459 40.7145 38.9941 40.5663L40.0956 39.4641L39.083 38.4686C38.9348 38.3204 38.86 38.1515 38.86 37.9619C38.86 37.7723 38.9304 37.6063 39.0696 37.4641C39.2089 37.3219 39.3733 37.2508 39.563 37.2508ZM150.853 34.2876C151.054 34.2876 151.228 34.3706 151.377 34.5365L152.328 35.5054L153.288 34.5365C153.442 34.3765 153.617 34.2965 153.813 34.2965C154.002 34.2965 154.166 34.3661 154.306 34.5054C154.445 34.6446 154.515 34.8061 154.515 34.9898C154.515 35.1794 154.44 35.3513 154.293 35.5054L153.279 36.5009L154.381 37.6032C154.529 37.7513 154.604 37.9202 154.604 38.1098C154.604 38.2935 154.532 38.4565 154.39 38.5987C154.248 38.7409 154.082 38.812 153.893 38.812C153.696 38.812 153.522 38.732 153.368 38.572L152.328 37.4876L151.297 38.572C151.142 38.732 150.968 38.812 150.773 38.812C150.582 38.812 150.417 38.7409 150.274 38.5987C150.133 38.4565 150.061 38.2935 150.061 38.1098C150.061 37.9202 150.136 37.7513 150.284 37.6032L151.385 36.5009L150.373 35.5054C150.225 35.3572 150.15 35.1883 150.15 34.9987C150.15 34.8091 150.22 34.6432 150.359 34.5009C150.499 34.3587 150.663 34.2876 150.853 34.2876Z\" fill=\"#B6C5D5\"/>\n</svg>";

var LinealTerminalError = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_201_342)\">\n<path opacity=\"0.6\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M29.2424 48.8188C29.5343 48.8188 29.7877 48.9278 30.0069 49.146C30.2239 49.3641 30.3341 49.614 30.3341 49.8958C30.3341 50.1866 30.2194 50.4456 29.9922 50.6728L28.3028 52.3633L29.8558 53.8901C30.083 54.1173 30.1978 54.3764 30.1978 54.6672C30.1978 54.958 30.0899 55.2125 29.8763 55.4306C29.6627 55.6487 29.4105 55.7578 29.1197 55.7578C28.8107 55.7578 28.5437 55.6306 28.3153 55.3761L26.8566 53.8901L25.3843 55.3761C25.148 55.6215 24.8799 55.7442 24.58 55.7442C24.2891 55.7442 24.0381 55.6374 23.8234 55.4238C23.6109 55.2102 23.503 54.9626 23.503 54.6808C23.503 54.39 23.6177 54.1264 23.8438 53.8901L25.3979 52.3633L23.7086 50.6728C23.4814 50.4456 23.3667 50.1866 23.3667 49.8958C23.3667 49.614 23.4769 49.3641 23.6939 49.146C23.912 48.9278 24.1665 48.8188 24.4573 48.8188C24.7583 48.8188 25.0253 48.9415 25.2616 49.1869L26.8566 50.85L28.438 49.1869C28.6755 48.9415 28.9424 48.8188 29.2424 48.8188ZM190.787 45.0352C191.077 45.0352 191.327 45.1442 191.543 45.3623C191.756 45.5805 191.862 45.8349 191.862 46.1258C191.862 46.4166 191.749 46.6756 191.521 46.9028L189.968 48.4297L191.658 50.1201C191.884 50.3474 192 50.6064 192 50.8972C192 51.1789 191.889 51.4289 191.672 51.647C191.455 51.8651 191.199 51.9742 190.908 51.9742C190.608 51.9742 190.34 51.8515 190.103 51.6061L188.522 49.9429L186.927 51.6061C186.69 51.8515 186.424 51.9742 186.122 51.9742C185.831 51.9742 185.579 51.8651 185.359 51.647C185.142 51.4289 185.033 51.1789 185.033 50.8972C185.033 50.6064 185.146 50.3474 185.374 50.1201L187.063 48.4297L185.51 46.9028C185.284 46.6665 185.168 46.403 185.168 46.1121C185.168 45.8304 185.277 45.5827 185.49 45.3692C185.703 45.1556 185.956 45.0488 186.247 45.0488C186.546 45.0488 186.815 45.1715 187.05 45.4169L188.522 46.9028L189.981 45.4169C190.21 45.1624 190.475 45.0352 190.787 45.0352ZM164.137 40.6185C164.428 40.6185 164.678 40.7276 164.894 40.9457C165.106 41.1638 165.213 41.4183 165.213 41.7091C165.213 42 165.1 42.259 164.871 42.4862L163.318 44.0131L165.009 45.7035C165.235 45.9307 165.351 46.1898 165.351 46.4806C165.351 46.7623 165.239 47.0123 165.022 47.2304C164.805 47.4485 164.55 47.5576 164.259 47.5576C163.959 47.5576 163.691 47.4349 163.453 47.1895L161.873 45.5263L160.278 47.1895C160.041 47.4349 159.775 47.5576 159.473 47.5576C159.182 47.5576 158.93 47.4485 158.709 47.2304C158.492 47.0123 158.383 46.7623 158.383 46.4806C158.383 46.1898 158.497 45.9307 158.725 45.7035L160.413 44.0131L158.86 42.4862C158.634 42.2499 158.518 41.9863 158.518 41.6955C158.518 41.4138 158.628 41.1661 158.841 40.9525C159.054 40.739 159.307 40.6322 159.598 40.6322C159.896 40.6322 160.166 40.7549 160.401 41.0002L161.873 42.4862L163.332 41.0002C163.56 40.7458 163.826 40.6185 164.137 40.6185ZM5.58394 36.516C5.8759 36.516 6.12924 36.6251 6.3485 36.8432C6.56549 37.0613 6.67569 37.3113 6.67569 37.593C6.67569 37.8838 6.56095 38.1428 6.33373 38.3701L4.64442 40.0605L6.19741 41.5874C6.42462 41.8146 6.53936 42.0736 6.53936 42.3644C6.53936 42.6553 6.43144 42.9097 6.21786 43.1279C6.00428 43.346 5.75207 43.455 5.46124 43.455C5.15224 43.455 4.88526 43.3278 4.65692 43.0733L3.19822 41.5874L1.72589 43.0733C1.48959 43.3187 1.22148 43.4414 0.92156 43.4414C0.63073 43.4414 0.379661 43.3346 0.164947 43.121C-0.0474958 42.9075 -0.155421 42.6598 -0.155421 42.3781C-0.155421 42.0872 -0.0406796 41.8237 0.185396 41.5874L1.73952 40.0605L0.0502049 38.3701C-0.177006 38.1428 -0.291748 37.8838 -0.291748 37.593C-0.291748 37.3113 -0.181551 37.0613 0.0354362 36.8432C0.253559 36.6251 0.508036 36.516 0.798866 36.516C1.09992 36.516 1.36689 36.6387 1.60319 36.8841L3.19822 38.5473L4.77961 36.8841C5.01705 36.6387 5.28402 36.516 5.58394 36.516ZM40.4907 29.577C40.7815 29.577 41.0326 29.686 41.2473 29.9042C41.4597 30.1223 41.5676 30.3768 41.5676 30.6676C41.5676 30.9584 41.4529 31.2174 41.2257 31.4447L39.6727 32.9715L41.362 34.662C41.5892 34.8892 41.704 35.1482 41.704 35.439C41.704 35.7208 41.5938 35.9707 41.3768 36.1888C41.1587 36.407 40.9042 36.516 40.6122 36.516C40.3123 36.516 40.0453 36.3933 39.8079 36.1479L38.2265 34.4847L36.6315 36.1479C36.3952 36.3933 36.1282 36.516 35.8271 36.516C35.5363 36.516 35.283 36.407 35.0637 36.1888C34.8467 35.9707 34.7365 35.7208 34.7365 35.439C34.7365 35.1482 34.8513 34.8892 35.0785 34.662L36.7678 32.9715L35.2137 31.4447C34.9876 31.2084 34.8729 30.9448 34.8729 30.654C34.8729 30.3722 34.9808 30.1246 35.1944 29.911C35.4079 29.6974 35.6601 29.5906 35.951 29.5906C36.2498 29.5906 36.519 29.7133 36.7553 29.9587L38.2265 31.4447L39.6863 29.9587C39.9135 29.7042 40.1805 29.577 40.4907 29.577ZM179.91 24.8463C180.2 24.8463 180.452 24.9553 180.666 25.1734C180.879 25.3916 180.987 25.646 180.987 25.9369C180.987 26.2277 180.872 26.4867 180.645 26.7139L179.092 28.2408L180.781 29.9312C181.008 30.1585 181.123 30.4175 181.123 30.7083C181.123 30.9901 181.013 31.24 180.796 31.4581C180.578 31.6762 180.323 31.7853 180.031 31.7853C179.731 31.7853 179.464 31.6626 179.227 31.4172L177.646 29.754L176.05 31.4172C175.814 31.6626 175.547 31.7853 175.246 31.7853C174.955 31.7853 174.702 31.6762 174.483 31.4581C174.266 31.24 174.156 30.9901 174.156 30.7083C174.156 30.4175 174.27 30.1585 174.497 29.9312L176.187 28.2408L174.633 26.7139C174.407 26.4776 174.292 26.2141 174.292 25.9232C174.292 25.6415 174.4 25.3938 174.613 25.1803C174.827 24.9667 175.079 24.8599 175.37 24.8599C175.669 24.8599 175.938 24.9826 176.174 25.228L177.646 26.7139L179.105 25.228C179.333 24.9735 179.6 24.8463 179.91 24.8463ZM154.84 16.915C155.13 16.915 155.382 17.0241 155.596 17.2422C155.809 17.4603 155.917 17.7148 155.917 18.0057C155.917 18.2965 155.802 18.5555 155.575 18.7827L154.022 20.3096L155.711 22C155.938 22.2272 156.053 22.4863 156.053 22.7771C156.053 23.0588 155.943 23.3088 155.726 23.5269C155.508 23.745 155.253 23.8541 154.961 23.8541C154.661 23.8541 154.394 23.7314 154.157 23.486L152.576 21.8228L150.98 23.486C150.744 23.7314 150.477 23.8541 150.176 23.8541C149.885 23.8541 149.632 23.745 149.413 23.5269C149.196 23.3088 149.086 23.0588 149.086 22.7771C149.086 22.4863 149.2 22.2272 149.427 22L151.117 20.3096L149.563 18.7827C149.337 18.5464 149.222 18.2829 149.222 17.992C149.222 17.7103 149.33 17.4626 149.543 17.249C149.757 17.0355 150.009 16.9287 150.3 16.9287C150.599 16.9287 150.868 17.0514 151.104 17.2968L152.576 18.7827L154.035 17.2968C154.263 17.0423 154.53 16.915 154.84 16.915ZM22.9019 16.915C23.1939 16.915 23.4472 17.0241 23.6665 17.2422C23.8835 17.4603 23.9937 17.7103 23.9937 17.992C23.9937 18.2829 23.8789 18.5419 23.6517 18.7691L21.9624 20.4595L23.5154 21.9864C23.7426 22.2136 23.8574 22.4726 23.8574 22.7635C23.8574 23.0543 23.7494 23.3088 23.5358 23.5269C23.3223 23.745 23.0701 23.8541 22.7792 23.8541C22.4702 23.8541 22.2033 23.7268 21.9749 23.4724L20.5162 21.9864L19.0439 23.4724C18.8076 23.7177 18.5395 23.8404 18.2396 23.8404C17.9487 23.8404 17.6977 23.7337 17.4829 23.5201C17.2705 23.3065 17.1626 23.0588 17.1626 22.7771C17.1626 22.4863 17.2773 22.2227 17.5034 21.9864L19.0575 20.4595L17.3682 18.7691C17.141 18.5419 17.0262 18.2829 17.0262 17.992C17.0262 17.7103 17.1364 17.4603 17.3534 17.2422C17.5716 17.0241 17.826 16.915 18.1169 16.915C18.4179 16.915 18.6849 17.0377 18.9212 17.2831L20.5162 18.9463L22.0976 17.2831C22.335 17.0377 22.602 16.915 22.9019 16.915Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M115.477 3C119.331 3 122.467 6.10933 122.467 9.93118V17.1704H113.147V21.7912H116.227C120.081 21.7912 123.217 24.9005 123.217 28.7224V81.8614H71.9568L71.9728 28.7201C71.9739 24.8996 75.1095 21.7912 78.9627 21.7912H82.0272V9.93118C82.0272 6.10933 85.1629 3 89.0171 3H115.477ZM116.227 26.412H78.9627C77.6783 26.412 76.633 27.448 76.6327 28.7216L76.6181 77.2406H118.557V28.7224C118.557 27.4484 117.512 26.412 116.227 26.412ZM95.2571 67.999V72.6198H90.5971V67.999H95.2571ZM85.9372 67.999V72.6198H81.2773V67.999H85.9372ZM104.577 67.999V72.6198H99.917V67.999H104.577ZM113.897 67.999V72.6198H109.237V67.999H113.897ZM95.2571 58.7575V63.3783H90.5971V58.7575H95.2571ZM85.9372 58.7575V63.3783H81.2773V58.7575H85.9372ZM104.577 58.7575V63.3783H99.917V58.7575H104.577ZM113.897 49.5159V63.3783H109.237V49.5159H113.897ZM95.2571 49.5159V54.1367H90.5971V49.5159H95.2571ZM85.9372 49.5159V54.1367H81.2773V49.5159H85.9372ZM104.577 49.5159V54.1367H99.917V49.5159H104.577ZM113.897 31.0328V44.8951H81.2773V31.0328H113.897ZM109.237 35.6535H85.9372V40.2743H109.237V35.6535ZM108.886 7.62078H89.0171C87.7324 7.62078 86.6872 8.65723 86.6872 9.93118V21.7912H108.487V9.93118C108.487 9.12146 108.628 8.34363 108.886 7.62078ZM115.477 7.62078C114.192 7.62078 113.147 8.65723 113.147 9.93118V12.5496H117.807V9.93118C117.807 8.65723 116.762 7.62078 115.477 7.62078Z\" fill=\"#B6C5D5\"/>\n<path d=\"M129.5 96C141.374 96 151 86.3741 151 74.5C151 62.6259 141.374 53 129.5 53C117.626 53 108 62.6259 108 74.5C108 86.3741 117.626 96 129.5 96Z\" fill=\"white\"/>\n<path d=\"M129.58 94.6102C140.636 94.6102 149.744 85.4793 149.744 74.4238C149.744 63.3906 140.613 54.2598 129.58 54.2598C118.525 54.2598 109.416 63.3906 109.416 74.4238C109.416 85.4793 118.547 94.6102 129.58 94.6102ZM122.329 83.154C121.505 83.154 120.871 82.4983 120.871 81.696C120.871 81.2932 121.02 80.9351 121.294 80.6811L127.509 74.445L121.294 68.2101C121.02 67.9561 120.871 67.5969 120.871 67.1952C120.871 66.3716 121.505 65.7584 122.33 65.7584C122.732 65.7584 123.07 65.9061 123.345 66.1814L129.58 72.3951L135.836 66.1814C136.133 65.8636 136.471 65.7159 136.851 65.7159C137.655 65.7159 138.309 66.3716 138.309 67.1739C138.309 67.5767 138.183 67.8934 137.866 68.1888L131.63 74.445L137.866 80.6386C138.14 80.9351 138.289 81.273 138.289 81.696C138.289 82.4983 137.655 83.154 136.83 83.154C136.407 83.154 136.048 82.9851 135.774 82.7098L129.58 76.4961L123.365 82.7098C123.112 82.9851 122.732 83.154 122.33 83.154H122.329Z\" fill=\"#DD2457\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_201_342\">\n<rect width=\"192\" height=\"98\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var LinealTerminalNumero = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_201_330)\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M124.88 57.4391C123.964 57.7956 122.968 57.9913 121.926 57.9913L120.301 57.9909L120.308 93.9177H79.0976L79.0978 90.5612H74.5185V98.5184H124.889L124.88 57.4391ZM117.482 22.4131V27.0131L118.005 27.0138C119.223 27.0138 120.223 27.9753 120.29 29.1831L120.294 29.3134L120.296 35.0279L121.926 35.0283C122.966 35.0283 123.961 35.2232 124.875 35.5784L124.873 29.3118C124.872 25.508 121.791 22.4131 118.005 22.4131H117.482Z\" fill=\"#F7FAFE\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M70.8149 57.9914V94.0741H121.185L121.177 57.991H116.599L116.605 89.4734H75.394L75.3942 57.991L70.8149 57.9914ZM107.447 82.4942V87.0949H112.027V82.4942H107.447ZM79.9731 82.4942V87.0949H84.5521V82.4942H79.9731ZM77.6835 17.9688C73.9626 17.9688 70.9233 20.9569 70.8178 24.6702L70.8149 24.8698V35.0284L75.3942 35.028L75.394 24.8698C75.394 23.6014 76.4211 22.5694 77.6835 22.5694H114.301C115.52 22.5694 116.519 23.531 116.587 24.7387L116.591 24.869L116.593 35.028H121.172L121.17 24.8675C121.169 21.1304 118.194 18.0776 114.5 17.9716L114.301 17.9688H77.6835ZM107.447 26.1979V30.7986H112.027V26.1979H107.447ZM79.9731 26.1979V30.7986H84.5521V26.1979H79.9731Z\" fill=\"#1AAAAD\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M80.9797 18.7095V14.1088H71.8216V6.90104C71.8216 3.09581 74.9028 0 78.6902 0H104.691C108.478 0 111.559 3.09581 111.559 6.90104V18.7095H80.9797ZM78.6902 4.60069C77.4277 4.60069 76.4006 5.63263 76.4006 6.90104V9.5081H80.9797V6.90104C80.9797 5.63263 79.9526 4.60069 78.6902 4.60069ZM106.98 6.90104C106.98 5.63263 105.953 4.60069 104.691 4.60069H85.1665C85.4205 5.3204 85.5588 6.09485 85.5588 6.90104V18.7095H106.98V6.90104Z\" fill=\"#1AAAAD\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M121.185 37.0371H71.5556C67.8737 37.0371 64.8889 40.0219 64.8889 43.7038V49.1298C64.8889 52.8117 67.8737 55.7965 71.5556 55.7965H121.185C124.867 55.7965 127.852 52.8117 127.852 49.1298V43.7038C127.852 40.0219 124.867 37.0371 121.185 37.0371ZM71.5556 38.5186H121.185C124.049 38.5186 126.37 40.8401 126.37 43.7038V49.1298C126.37 51.9935 124.049 54.315 121.185 54.315H71.5556C68.6919 54.315 66.3704 51.9935 66.3704 49.1298V43.7038C66.3704 40.8401 68.6919 38.5186 71.5556 38.5186Z\" fill=\"#647180\"/>\n<path d=\"M73.592 46.5921C74.3974 46.6241 74.9867 46.8001 75.36 47.1201C75.7387 47.4401 75.928 47.8748 75.928 48.4241C75.928 48.6695 75.8854 48.8961 75.8 49.1041C75.72 49.3121 75.5947 49.4908 75.424 49.6401C75.2587 49.7895 75.048 49.9068 74.792 49.9921C74.536 50.0775 74.232 50.1201 73.88 50.1201C73.7414 50.1201 73.6 50.1095 73.456 50.0881C73.312 50.0668 73.1787 50.0401 73.056 50.0081C72.9334 49.9761 72.824 49.9441 72.728 49.9121C72.632 49.8801 72.5627 49.8535 72.52 49.8321L72.664 49.1841C72.7547 49.2268 72.9014 49.2828 73.104 49.3521C73.312 49.4215 73.5654 49.4561 73.864 49.4561C74.104 49.4561 74.304 49.4295 74.464 49.3761C74.6294 49.3228 74.7627 49.2508 74.864 49.1601C74.9654 49.0695 75.0374 48.9655 75.08 48.8481C75.128 48.7255 75.152 48.5975 75.152 48.4641C75.152 48.2615 75.1174 48.0828 75.048 47.9281C74.9787 47.7681 74.856 47.6348 74.68 47.5281C74.504 47.4215 74.2694 47.3415 73.976 47.2881C73.6827 47.2295 73.312 47.2001 72.864 47.2001C72.896 46.9388 72.92 46.6935 72.936 46.4641C72.9574 46.2348 72.976 46.0108 72.992 45.7921C73.008 45.5735 73.0214 45.3575 73.032 45.1441C73.0427 44.9255 73.0534 44.6961 73.064 44.4561H75.736V45.0881H73.712C73.7067 45.1681 73.6987 45.2775 73.688 45.4161C73.6774 45.5495 73.6667 45.6908 73.656 45.8401C73.6454 45.9841 73.6347 46.1255 73.624 46.2641C73.6134 46.4028 73.6027 46.5121 73.592 46.5921Z\" fill=\"#647180\"/>\n<path d=\"M76.8356 48.0801C76.937 47.8455 77.0756 47.5735 77.2516 47.2641C77.4276 46.9495 77.625 46.6268 77.8436 46.2961C78.0676 45.9655 78.305 45.6401 78.5556 45.3201C78.8116 45.0001 79.0676 44.7121 79.3236 44.4561H80.0356V47.9761H80.6916V48.5841H80.0356V50.0001H79.3156V48.5841H76.8356V48.0801ZM79.3156 45.3361C79.1556 45.5068 78.993 45.6988 78.8276 45.9121C78.6676 46.1201 78.5103 46.3388 78.3556 46.5681C78.201 46.7975 78.0543 47.0321 77.9156 47.2721C77.7823 47.5121 77.6623 47.7468 77.5556 47.9761H79.3156V45.3361Z\" fill=\"#647180\"/>\n<path d=\"M84.7673 45.8721C84.7673 46.0641 84.7273 46.2508 84.6473 46.4321C84.5726 46.6081 84.4713 46.7841 84.3433 46.9601C84.2153 47.1308 84.0713 47.3015 83.9113 47.4721C83.7513 47.6375 83.5913 47.8001 83.4313 47.9601C83.3406 48.0508 83.2339 48.1575 83.1113 48.2801C82.9939 48.4028 82.8819 48.5308 82.7753 48.6641C82.6686 48.7975 82.5779 48.9255 82.5033 49.0481C82.4339 49.1708 82.3993 49.2775 82.3993 49.3681H84.9513V50.0001H81.5913C81.5859 49.9681 81.5833 49.9361 81.5833 49.9041C81.5833 49.8721 81.5833 49.8428 81.5833 49.8161C81.5833 49.5655 81.6233 49.3335 81.7033 49.1201C81.7886 48.9015 81.8979 48.6961 82.0313 48.5041C82.1646 48.3121 82.3139 48.1308 82.4793 47.9601C82.6446 47.7895 82.8073 47.6241 82.9673 47.4641C83.1006 47.3361 83.2259 47.2108 83.3433 47.0881C83.4659 46.9601 83.5726 46.8348 83.6633 46.7121C83.7593 46.5841 83.8339 46.4535 83.8873 46.3201C83.9459 46.1868 83.9753 46.0455 83.9753 45.8961C83.9753 45.7361 83.9486 45.6001 83.8953 45.4881C83.8473 45.3761 83.7806 45.2828 83.6953 45.2081C83.6099 45.1335 83.5086 45.0801 83.3913 45.0481C83.2793 45.0108 83.1593 44.9921 83.0313 44.9921C82.8766 44.9921 82.7353 45.0135 82.6073 45.0561C82.4793 45.0988 82.3646 45.1495 82.2633 45.2081C82.1619 45.2615 82.0766 45.3201 82.0073 45.3841C81.9379 45.4428 81.8846 45.4881 81.8473 45.5201L81.4793 44.9921C81.5273 44.9388 81.5993 44.8748 81.6953 44.8001C81.7913 44.7201 81.9059 44.6455 82.0393 44.5761C82.1726 44.5068 82.3219 44.4481 82.4873 44.4001C82.6526 44.3521 82.8313 44.3281 83.0233 44.3281C83.6046 44.3281 84.0393 44.4641 84.3273 44.7361C84.6206 45.0028 84.7673 45.3815 84.7673 45.8721Z\" fill=\"#647180\"/>\n<path d=\"M86.2909 45.6001C86.5949 45.4828 86.8909 45.3335 87.1789 45.1521C87.4669 44.9655 87.7309 44.7335 87.9709 44.4561H88.4989V50.0001H87.7549V45.4881C87.6909 45.5468 87.6109 45.6081 87.5149 45.6721C87.4242 45.7361 87.3229 45.7975 87.2109 45.8561C87.1042 45.9148 86.9896 45.9708 86.8669 46.0241C86.7496 46.0775 86.6349 46.1228 86.5229 46.1601L86.2909 45.6001Z\" fill=\"#647180\"/>\n<path d=\"M93.7985 45.8721C93.7985 46.0641 93.7585 46.2508 93.6785 46.4321C93.6039 46.6081 93.5025 46.7841 93.3745 46.9601C93.2465 47.1308 93.1025 47.3015 92.9425 47.4721C92.7825 47.6375 92.6225 47.8001 92.4625 47.9601C92.3719 48.0508 92.2652 48.1575 92.1425 48.2801C92.0252 48.4028 91.9132 48.5308 91.8065 48.6641C91.6999 48.7975 91.6092 48.9255 91.5345 49.0481C91.4652 49.1708 91.4305 49.2775 91.4305 49.3681H93.9825V50.0001H90.6225C90.6172 49.9681 90.6145 49.9361 90.6145 49.9041C90.6145 49.8721 90.6145 49.8428 90.6145 49.8161C90.6145 49.5655 90.6545 49.3335 90.7345 49.1201C90.8199 48.9015 90.9292 48.6961 91.0625 48.5041C91.1959 48.3121 91.3452 48.1308 91.5105 47.9601C91.6759 47.7895 91.8385 47.6241 91.9985 47.4641C92.1319 47.3361 92.2572 47.2108 92.3745 47.0881C92.4972 46.9601 92.6039 46.8348 92.6945 46.7121C92.7905 46.5841 92.8652 46.4535 92.9185 46.3201C92.9772 46.1868 93.0065 46.0455 93.0065 45.8961C93.0065 45.7361 92.9799 45.6001 92.9265 45.4881C92.8785 45.3761 92.8119 45.2828 92.7265 45.2081C92.6412 45.1335 92.5399 45.0801 92.4225 45.0481C92.3105 45.0108 92.1905 44.9921 92.0625 44.9921C91.9079 44.9921 91.7665 45.0135 91.6385 45.0561C91.5105 45.0988 91.3959 45.1495 91.2945 45.2081C91.1932 45.2615 91.1079 45.3201 91.0385 45.3841C90.9692 45.4428 90.9159 45.4881 90.8785 45.5201L90.5105 44.9921C90.5585 44.9388 90.6305 44.8748 90.7265 44.8001C90.8225 44.7201 90.9372 44.6455 91.0705 44.5761C91.2039 44.5068 91.3532 44.4481 91.5185 44.4001C91.6839 44.3521 91.8625 44.3281 92.0545 44.3281C92.6359 44.3281 93.0705 44.4641 93.3585 44.7361C93.6519 45.0028 93.7985 45.3815 93.7985 45.8721Z\" fill=\"#647180\"/>\n<path d=\"M98.3141 45.8721C98.3141 46.0641 98.2741 46.2508 98.1941 46.4321C98.1195 46.6081 98.0181 46.7841 97.8901 46.9601C97.7621 47.1308 97.6181 47.3015 97.4581 47.4721C97.2981 47.6375 97.1381 47.8001 96.9781 47.9601C96.8875 48.0508 96.7808 48.1575 96.6581 48.2801C96.5408 48.4028 96.4288 48.5308 96.3221 48.6641C96.2155 48.7975 96.1248 48.9255 96.0501 49.0481C95.9808 49.1708 95.9461 49.2775 95.9461 49.3681H98.4981V50.0001H95.1381C95.1328 49.9681 95.1301 49.9361 95.1301 49.9041C95.1301 49.8721 95.1301 49.8428 95.1301 49.8161C95.1301 49.5655 95.1701 49.3335 95.2501 49.1201C95.3355 48.9015 95.4448 48.6961 95.5781 48.5041C95.7115 48.3121 95.8608 48.1308 96.0261 47.9601C96.1915 47.7895 96.3541 47.6241 96.5141 47.4641C96.6475 47.3361 96.7728 47.2108 96.8901 47.0881C97.0128 46.9601 97.1195 46.8348 97.2101 46.7121C97.3061 46.5841 97.3808 46.4535 97.4341 46.3201C97.4928 46.1868 97.5221 46.0455 97.5221 45.8961C97.5221 45.7361 97.4955 45.6001 97.4421 45.4881C97.3941 45.3761 97.3275 45.2828 97.2421 45.2081C97.1568 45.1335 97.0555 45.0801 96.9381 45.0481C96.8261 45.0108 96.7061 44.9921 96.5781 44.9921C96.4235 44.9921 96.2821 45.0135 96.1541 45.0561C96.0261 45.0988 95.9115 45.1495 95.8101 45.2081C95.7088 45.2615 95.6235 45.3201 95.5541 45.3841C95.4848 45.4428 95.4315 45.4881 95.3941 45.5201L95.0261 44.9921C95.0741 44.9388 95.1461 44.8748 95.2421 44.8001C95.3381 44.7201 95.4528 44.6455 95.5861 44.5761C95.7195 44.5068 95.8688 44.4481 96.0341 44.4001C96.1995 44.3521 96.3781 44.3281 96.5701 44.3281C97.1515 44.3281 97.5861 44.4641 97.8741 44.7361C98.1675 45.0028 98.3141 45.3815 98.3141 45.8721Z\" fill=\"#647180\"/>\n<path d=\"M100.902 49.4561C101.376 49.4561 101.715 49.3628 101.918 49.1761C102.126 48.9895 102.23 48.7388 102.23 48.4241C102.23 48.2215 102.187 48.0508 102.102 47.9121C102.016 47.7735 101.904 47.6641 101.766 47.5841C101.627 47.4988 101.464 47.4401 101.278 47.4081C101.096 47.3708 100.91 47.3521 100.718 47.3521H100.526V46.7441H100.79C100.923 46.7441 101.059 46.7308 101.198 46.7041C101.342 46.6775 101.472 46.6295 101.59 46.5601C101.707 46.4908 101.803 46.3975 101.878 46.2801C101.952 46.1575 101.99 46.0055 101.99 45.8241C101.99 45.6748 101.963 45.5468 101.91 45.4401C101.856 45.3335 101.784 45.2455 101.694 45.1761C101.608 45.1068 101.507 45.0588 101.39 45.0321C101.278 45.0001 101.158 44.9841 101.03 44.9841C100.774 44.9841 100.555 45.0215 100.374 45.0961C100.198 45.1708 100.048 45.2481 99.9258 45.3281L99.6378 44.7601C99.7018 44.7175 99.7818 44.6721 99.8778 44.6241C99.9791 44.5708 100.091 44.5228 100.214 44.4801C100.336 44.4375 100.467 44.4028 100.606 44.3761C100.75 44.3441 100.899 44.3281 101.054 44.3281C101.347 44.3281 101.6 44.3655 101.814 44.4401C102.027 44.5095 102.203 44.6108 102.342 44.7441C102.48 44.8721 102.584 45.0268 102.654 45.2081C102.723 45.3841 102.758 45.5761 102.758 45.7841C102.758 46.0721 102.675 46.3201 102.51 46.5281C102.344 46.7308 102.144 46.8855 101.91 46.9921C102.054 47.0348 102.192 47.0961 102.326 47.1761C102.459 47.2561 102.574 47.3575 102.67 47.4801C102.771 47.6028 102.851 47.7441 102.91 47.9041C102.974 48.0641 103.006 48.2428 103.006 48.4401C103.006 48.6801 102.963 48.9041 102.878 49.1121C102.798 49.3148 102.67 49.4908 102.494 49.6401C102.323 49.7895 102.107 49.9068 101.846 49.9921C101.584 50.0775 101.275 50.1201 100.918 50.1201C100.779 50.1201 100.635 50.1095 100.486 50.0881C100.342 50.0668 100.206 50.0401 100.078 50.0081C99.9498 49.9761 99.8378 49.9441 99.7418 49.9121C99.6458 49.8801 99.5764 49.8535 99.5338 49.8321L99.6778 49.1841C99.7684 49.2268 99.9178 49.2828 100.126 49.3521C100.339 49.4215 100.598 49.4561 100.902 49.4561Z\" fill=\"#647180\"/>\n<path d=\"M105.201 46.5921C106.007 46.6241 106.596 46.8001 106.969 47.1201C107.348 47.4401 107.537 47.8748 107.537 48.4241C107.537 48.6695 107.495 48.8961 107.409 49.1041C107.329 49.3121 107.204 49.4908 107.033 49.6401C106.868 49.7895 106.657 49.9068 106.401 49.9921C106.145 50.0775 105.841 50.1201 105.489 50.1201C105.351 50.1201 105.209 50.1095 105.065 50.0881C104.921 50.0668 104.788 50.0401 104.665 50.0081C104.543 49.9761 104.433 49.9441 104.337 49.9121C104.241 49.8801 104.172 49.8535 104.129 49.8321L104.273 49.1841C104.364 49.2268 104.511 49.2828 104.713 49.3521C104.921 49.4215 105.175 49.4561 105.473 49.4561C105.713 49.4561 105.913 49.4295 106.073 49.3761C106.239 49.3228 106.372 49.2508 106.473 49.1601C106.575 49.0695 106.647 48.9655 106.689 48.8481C106.737 48.7255 106.761 48.5975 106.761 48.4641C106.761 48.2615 106.727 48.0828 106.657 47.9281C106.588 47.7681 106.465 47.6348 106.289 47.5281C106.113 47.4215 105.879 47.3415 105.585 47.2881C105.292 47.2295 104.921 47.2001 104.473 47.2001C104.505 46.9388 104.529 46.6935 104.545 46.4641C104.567 46.2348 104.585 46.0108 104.601 45.7921C104.617 45.5735 104.631 45.3575 104.641 45.1441C104.652 44.9255 104.663 44.6961 104.673 44.4561H107.345V45.0881H105.321C105.316 45.1681 105.308 45.2775 105.297 45.4161C105.287 45.5495 105.276 45.6908 105.265 45.8401C105.255 45.9841 105.244 46.1255 105.233 46.2641C105.223 46.4028 105.212 46.5121 105.201 46.5921Z\" fill=\"#647180\"/>\n<path d=\"M108.445 48.0801C108.546 47.8455 108.685 47.5735 108.861 47.2641C109.037 46.9495 109.234 46.6268 109.453 46.2961C109.677 45.9655 109.914 45.6401 110.165 45.3201C110.421 45.0001 110.677 44.7121 110.933 44.4561H111.645V47.9761H112.301V48.5841H111.645V50.0001H110.925V48.5841H108.445V48.0801ZM110.925 45.3361C110.765 45.5068 110.602 45.6988 110.437 45.9121C110.277 46.1201 110.12 46.3388 109.965 46.5681C109.81 46.7975 109.664 47.0321 109.525 47.2721C109.392 47.5121 109.272 47.7468 109.165 47.9761H110.925V45.3361Z\" fill=\"#647180\"/>\n<path d=\"M114.233 46.5921C115.038 46.6241 115.627 46.8001 116.001 47.1201C116.379 47.4401 116.569 47.8748 116.569 48.4241C116.569 48.6695 116.526 48.8961 116.441 49.1041C116.361 49.3121 116.235 49.4908 116.065 49.6401C115.899 49.7895 115.689 49.9068 115.433 49.9921C115.177 50.0775 114.873 50.1201 114.521 50.1201C114.382 50.1201 114.241 50.1095 114.097 50.0881C113.953 50.0668 113.819 50.0401 113.697 50.0081C113.574 49.9761 113.465 49.9441 113.369 49.9121C113.273 49.8801 113.203 49.8535 113.161 49.8321L113.305 49.1841C113.395 49.2268 113.542 49.2828 113.745 49.3521C113.953 49.4215 114.206 49.4561 114.505 49.4561C114.745 49.4561 114.945 49.4295 115.105 49.3761C115.27 49.3228 115.403 49.2508 115.505 49.1601C115.606 49.0695 115.678 48.9655 115.721 48.8481C115.769 48.7255 115.793 48.5975 115.793 48.4641C115.793 48.2615 115.758 48.0828 115.689 47.9281C115.619 47.7681 115.497 47.6348 115.321 47.5281C115.145 47.4215 114.91 47.3415 114.617 47.2881C114.323 47.2295 113.953 47.2001 113.505 47.2001C113.537 46.9388 113.561 46.6935 113.577 46.4641C113.598 46.2348 113.617 46.0108 113.633 45.7921C113.649 45.5735 113.662 45.3575 113.673 45.1441C113.683 44.9255 113.694 44.6961 113.705 44.4561H116.377V45.0881H114.353C114.347 45.1681 114.339 45.2775 114.329 45.4161C114.318 45.5495 114.307 45.6908 114.297 45.8401C114.286 45.9841 114.275 46.1255 114.265 46.2641C114.254 46.4028 114.243 46.5121 114.233 46.5921Z\" fill=\"#647180\"/>\n<path d=\"M118.748 46.5921C119.554 46.6241 120.143 46.8001 120.516 47.1201C120.895 47.4401 121.084 47.8748 121.084 48.4241C121.084 48.6695 121.042 48.8961 120.956 49.1041C120.876 49.3121 120.751 49.4908 120.58 49.6401C120.415 49.7895 120.204 49.9068 119.948 49.9921C119.692 50.0775 119.388 50.1201 119.036 50.1201C118.898 50.1201 118.756 50.1095 118.612 50.0881C118.468 50.0668 118.335 50.0401 118.212 50.0081C118.09 49.9761 117.98 49.9441 117.884 49.9121C117.788 49.8801 117.719 49.8535 117.676 49.8321L117.82 49.1841C117.911 49.2268 118.058 49.2828 118.26 49.3521C118.468 49.4215 118.722 49.4561 119.02 49.4561C119.26 49.4561 119.46 49.4295 119.62 49.3761C119.786 49.3228 119.919 49.2508 120.02 49.1601C120.122 49.0695 120.194 48.9655 120.236 48.8481C120.284 48.7255 120.308 48.5975 120.308 48.4641C120.308 48.2615 120.274 48.0828 120.204 47.9281C120.135 47.7681 120.012 47.6348 119.836 47.5281C119.66 47.4215 119.426 47.3415 119.132 47.2881C118.839 47.2295 118.468 47.2001 118.02 47.2001C118.052 46.9388 118.076 46.6935 118.092 46.4641C118.114 46.2348 118.132 46.0108 118.148 45.7921C118.164 45.5735 118.178 45.3575 118.188 45.1441C118.199 44.9255 118.21 44.6961 118.22 44.4561H120.892V45.0881H118.868C118.863 45.1681 118.855 45.2775 118.844 45.4161C118.834 45.5495 118.823 45.6908 118.812 45.8401C118.802 45.9841 118.791 46.1255 118.78 46.2641C118.77 46.4028 118.759 46.5121 118.748 46.5921Z\" fill=\"#647180\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M35.415 61.7348C35.6165 61.7348 35.7906 61.8177 35.9395 61.9837L36.8906 62.9526L37.8506 61.9837C38.0047 61.8237 38.1795 61.7437 38.375 61.7437C38.5647 61.7437 38.7284 61.8133 38.8684 61.9526C39.0069 62.0918 39.0773 62.2533 39.0773 62.437C39.0773 62.6266 39.0024 62.7985 38.855 62.9526L37.8417 63.9481L38.9432 65.0503C39.0913 65.1985 39.1661 65.3674 39.1661 65.557C39.1661 65.7407 39.0943 65.9037 38.9528 66.0459C38.8106 66.1881 38.6447 66.2592 38.455 66.2592C38.2587 66.2592 38.0847 66.1792 37.9306 66.0192L36.8906 64.9348L35.8595 66.0192C35.7047 66.1792 35.5306 66.2592 35.335 66.2592C35.1447 66.2592 34.9795 66.1881 34.8365 66.0459C34.695 65.9037 34.6232 65.7407 34.6232 65.557C34.6232 65.3674 34.698 65.1985 34.8461 65.0503L35.9476 63.9481L34.935 62.9526C34.7869 62.8044 34.7121 62.6355 34.7121 62.4459C34.7121 62.2563 34.7824 62.0903 34.9217 61.9481C35.061 61.8059 35.2254 61.7348 35.415 61.7348ZM43.7115 53.1425C43.913 53.1425 44.087 53.2255 44.2359 53.3914L45.187 54.3603L46.147 53.3914C46.3011 53.2314 46.4759 53.1514 46.6715 53.1514C46.8611 53.1514 47.0248 53.221 47.1648 53.3603C47.3033 53.4995 47.3737 53.661 47.3737 53.8447C47.3737 54.0343 47.2989 54.2062 47.1515 54.3603L46.1381 55.3558L47.2396 56.458C47.3878 56.6062 47.4626 56.7751 47.4626 56.9647C47.4626 57.1484 47.3907 57.3114 47.2493 57.4536C47.107 57.5958 46.9411 57.6669 46.7515 57.6669C46.5552 57.6669 46.3811 57.5869 46.227 57.4269L45.187 56.3425L44.1559 57.4269C44.0011 57.5869 43.827 57.6669 43.6315 57.6669C43.4411 57.6669 43.2759 57.5958 43.133 57.4536C42.9915 57.3114 42.9196 57.1484 42.9196 56.9647C42.9196 56.7751 42.9944 56.6062 43.1426 56.458L44.2441 55.3558L43.2315 54.3603C43.0833 54.2121 43.0085 54.0432 43.0085 53.8536C43.0085 53.664 43.0789 53.498 43.2181 53.3558C43.3574 53.2136 43.5219 53.1425 43.7115 53.1425ZM172.248 51.6114C172.45 51.6114 172.624 51.6943 172.773 51.8603L173.724 52.8292L174.684 51.8603C174.838 51.7003 175.013 51.6203 175.208 51.6203C175.398 51.6203 175.562 51.6899 175.701 51.8292C175.841 51.9684 175.911 52.1299 175.911 52.3136C175.911 52.5032 175.836 52.6751 175.689 52.8292L174.676 53.8247L175.777 54.9269C175.925 55.0751 176 55.244 176 55.4336C176 55.6173 175.928 55.7803 175.787 55.9225C175.644 56.0647 175.479 56.1358 175.289 56.1358C175.093 56.1358 174.919 56.0558 174.764 55.8958L173.724 54.8114L172.693 55.8958C172.539 56.0558 172.364 56.1358 172.169 56.1358C171.979 56.1358 171.813 56.0647 171.67 55.9225C171.529 55.7803 171.457 55.6173 171.457 55.4336C171.457 55.244 171.532 55.0751 171.68 54.9269L172.781 53.8247L171.769 52.8292C171.621 52.681 171.546 52.5121 171.546 52.3225C171.546 52.1329 171.616 51.9669 171.755 51.8247C171.895 51.6825 172.059 51.6114 172.248 51.6114ZM150.853 49.2905C151.054 49.2905 151.228 49.3734 151.377 49.5394L152.328 50.5083L153.288 49.5394C153.442 49.3794 153.617 49.2994 153.813 49.2994C154.002 49.2994 154.166 49.369 154.306 49.5083C154.445 49.6475 154.515 49.809 154.515 49.9927C154.515 50.1823 154.44 50.3542 154.293 50.5083L153.279 51.5038L154.381 52.606C154.529 52.7542 154.604 52.9231 154.604 53.1127C154.604 53.2964 154.532 53.4594 154.39 53.6016C154.248 53.7438 154.082 53.8149 153.893 53.8149C153.696 53.8149 153.522 53.7349 153.368 53.5749L152.328 52.4905L151.297 53.5749C151.142 53.7349 150.968 53.8149 150.773 53.8149C150.582 53.8149 150.417 53.7438 150.274 53.6016C150.133 53.4594 150.061 53.2964 150.061 53.1127C150.061 52.9231 150.136 52.7542 150.284 52.606L151.385 51.5038L150.373 50.5083C150.225 50.3601 150.15 50.1912 150.15 50.0016C150.15 49.812 150.22 49.646 150.359 49.5038C150.499 49.3616 150.663 49.2905 150.853 49.2905ZM30.4953 46.9732C30.6968 46.9732 30.8709 47.0561 31.0198 47.222L31.9709 48.1909L32.9309 47.222C33.085 47.062 33.2598 46.982 33.4553 46.982C33.645 46.982 33.8087 47.0517 33.9487 47.1909C34.0872 47.3302 34.1576 47.4917 34.1576 47.6754C34.1576 47.865 34.0827 48.0369 33.9353 48.1909L32.922 49.1865L34.0235 50.2887C34.1716 50.4369 34.2464 50.6057 34.2464 50.7954C34.2464 50.9791 34.1746 51.142 34.0331 51.2843C33.8909 51.4265 33.725 51.4976 33.5353 51.4976C33.339 51.4976 33.165 51.4176 33.0109 51.2576L31.9709 50.1732L30.9398 51.2576C30.785 51.4176 30.6109 51.4976 30.4153 51.4976C30.225 51.4976 30.0598 51.4265 29.9168 51.2843C29.7753 51.142 29.7035 50.9791 29.7035 50.7954C29.7035 50.6057 29.7783 50.4369 29.9264 50.2887L31.0279 49.1865L30.0153 48.1909C29.8672 48.0428 29.7924 47.8739 29.7924 47.6843C29.7924 47.4946 29.8627 47.3287 30.002 47.1865C30.1413 47.0443 30.3057 46.9732 30.4953 46.9732ZM162.408 41.5871C162.61 41.5871 162.784 41.67 162.933 41.836L163.884 42.8049L164.844 41.836C164.998 41.676 165.173 41.596 165.368 41.596C165.558 41.596 165.722 41.6656 165.861 41.8049C166.001 41.9441 166.071 42.1056 166.071 42.2893C166.071 42.4789 165.996 42.6508 165.849 42.8049L164.836 43.8004L165.937 44.9026C166.085 45.0508 166.16 45.2197 166.16 45.4093C166.16 45.593 166.088 45.756 165.947 45.8982C165.804 46.0404 165.639 46.1115 165.449 46.1115C165.253 46.1115 165.079 46.0315 164.924 45.8715L163.884 44.7871L162.853 45.8715C162.699 46.0315 162.524 46.1115 162.329 46.1115C162.139 46.1115 161.973 46.0404 161.83 45.8982C161.689 45.756 161.617 45.593 161.617 45.4093C161.617 45.2197 161.692 45.0508 161.84 44.9026L162.941 43.8004L161.929 42.8049C161.781 42.6567 161.706 42.4878 161.706 42.2982C161.706 42.1086 161.776 41.9426 161.915 41.8004C162.055 41.6582 162.219 41.5871 162.408 41.5871ZM16.7919 38.6767C16.9933 38.6767 17.1674 38.7597 17.3163 38.9256L18.2674 39.8945L19.2274 38.9256C19.3815 38.7656 19.5563 38.6856 19.7519 38.6856C19.9415 38.6856 20.1052 38.7552 20.2452 38.8945C20.3837 39.0337 20.4541 39.1952 20.4541 39.3789C20.4541 39.5686 20.3793 39.7404 20.2319 39.8945L19.2185 40.89L20.32 41.9923C20.4681 42.1404 20.543 42.3093 20.543 42.4989C20.543 42.6826 20.4711 42.8456 20.3296 42.9878C20.1874 43.13 20.0215 43.2012 19.8319 43.2012C19.6356 43.2012 19.4615 43.1212 19.3074 42.9612L18.2674 41.8767L17.2363 42.9612C17.0815 43.1212 16.9074 43.2012 16.7119 43.2012C16.5215 43.2012 16.3563 43.13 16.2133 42.9878C16.0719 42.8456 16 42.6826 16 42.4989C16 42.3093 16.0748 42.1404 16.223 41.9923L17.3244 40.89L16.3119 39.8945C16.1637 39.7463 16.0889 39.5774 16.0889 39.3878C16.0889 39.1982 16.1593 39.0323 16.2985 38.89C16.4378 38.7478 16.6022 38.6767 16.7919 38.6767ZM39.563 37.2508C39.7644 37.2508 39.9385 37.3337 40.0874 37.4997L41.0385 38.4686L41.9985 37.4997C42.1526 37.3397 42.3274 37.2597 42.523 37.2597C42.7126 37.2597 42.8763 37.3293 43.0163 37.4686C43.1548 37.6078 43.2252 37.7693 43.2252 37.953C43.2252 38.1426 43.1504 38.3145 43.003 38.4686L41.9896 39.4641L43.0911 40.5663C43.2393 40.7145 43.3141 40.8834 43.3141 41.073C43.3141 41.2567 43.2422 41.4197 43.1007 41.5619C42.9585 41.7041 42.7926 41.7752 42.603 41.7752C42.4067 41.7752 42.2326 41.6952 42.0785 41.5352L41.0385 40.4508L40.0074 41.5352C39.8526 41.6952 39.6785 41.7752 39.483 41.7752C39.2926 41.7752 39.1274 41.7041 38.9844 41.5619C38.843 41.4197 38.7711 41.2567 38.7711 41.073C38.7711 40.8834 38.8459 40.7145 38.9941 40.5663L40.0956 39.4641L39.083 38.4686C38.9348 38.3204 38.86 38.1515 38.86 37.9619C38.86 37.7723 38.9304 37.6063 39.0696 37.4641C39.2089 37.3219 39.3733 37.2508 39.563 37.2508ZM150.853 34.2876C151.054 34.2876 151.228 34.3706 151.377 34.5365L152.328 35.5054L153.288 34.5365C153.442 34.3765 153.617 34.2965 153.813 34.2965C154.002 34.2965 154.166 34.3661 154.306 34.5054C154.445 34.6446 154.515 34.8061 154.515 34.9898C154.515 35.1794 154.44 35.3513 154.293 35.5054L153.279 36.5009L154.381 37.6032C154.529 37.7513 154.604 37.9202 154.604 38.1098C154.604 38.2935 154.532 38.4565 154.39 38.5987C154.248 38.7409 154.082 38.812 153.893 38.812C153.696 38.812 153.522 38.732 153.368 38.572L152.328 37.4876L151.297 38.572C151.142 38.732 150.968 38.812 150.773 38.812C150.582 38.812 150.417 38.7409 150.274 38.5987C150.133 38.4565 150.061 38.2935 150.061 38.1098C150.061 37.9202 150.136 37.7513 150.284 37.6032L151.385 36.5009L150.373 35.5054C150.225 35.3572 150.15 35.1883 150.15 34.9987C150.15 34.8091 150.22 34.6432 150.359 34.5009C150.499 34.3587 150.663 34.2876 150.853 34.2876Z\" fill=\"#B6C5D5\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_201_330\">\n<rect width=\"192\" height=\"98\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>";

var LinealTimeWarning = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M126.353 30.1094L116.343 22.5426C115.831 22.1875 115.561 21.7059 115.561 21.1957C115.561 20.5713 115.864 20.0652 116.375 19.5877C117.509 18.5673 119.547 18 121.344 18C126.054 18 129.77 21.7385 129.77 26.4035C129.77 27.5055 129.59 28.6442 129.291 29.3013C128.931 30.0196 128.301 30.4971 127.552 30.4971C127.102 30.4971 126.803 30.4359 126.353 30.1094ZM87.2375 52.6426C87.2375 51.4794 88.1337 50.557 89.3041 50.557H100.845V34.5336C100.845 33.3663 101.745 32.4358 102.911 32.4358C104.082 32.4358 105.011 33.3663 105.011 34.5336V52.6426C105.011 53.814 104.082 54.7078 102.911 54.7078H89.3041C88.1337 54.7078 87.2375 53.814 87.2375 52.6426ZM126.471 51.4223C126.471 38.4803 115.921 27.9585 102.944 27.9585C89.9344 27.9585 79.4128 38.4803 79.4128 51.4223C79.4128 64.3929 89.9344 74.8861 102.944 74.8861C115.921 74.8861 126.471 64.3929 126.471 51.4223ZM76.6258 29.3013C76.2984 28.6116 76.1184 27.5055 76.1184 26.4035C76.1184 21.7385 79.8629 18 84.5365 18C86.3371 18 88.3751 18.5673 89.5169 19.5877C90.0244 20.0652 90.3231 20.5713 90.3231 21.1957C90.3231 21.7059 90.053 22.1875 89.5742 22.5426L79.5355 30.1094C79.114 30.4359 78.7825 30.4971 78.3365 30.4971C77.5835 30.4971 76.9573 30.0441 76.6258 29.3013ZM77.9149 75.9064L82.4698 71.3883C77.4075 66.2458 74.2891 59.1932 74.2891 51.4223C74.2891 35.6356 87.1188 22.816 102.944 22.816C118.769 22.816 131.599 35.6356 131.599 51.4223C131.599 59.1932 128.485 66.2458 123.414 71.3883L127.973 75.9064C128.898 76.7961 128.898 78.2654 128.002 79.1348C127.102 80.0571 125.632 80.0571 124.703 79.1021L119.969 74.4085C115.201 77.9063 109.328 80 102.944 80C96.56 80 90.6833 77.9063 85.9197 74.4085L81.1807 79.1021C80.2517 80.0571 78.7825 80.0571 77.8863 79.1348C77.0146 78.2654 76.986 76.7961 77.9149 75.9064Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M43.1754 56.8282C44.3477 56.8282 45.299 57.777 45.299 58.9461C45.299 60.1152 44.3477 61.064 43.1754 61.064H21.7149C20.5426 61.064 19.5912 60.1152 19.5912 58.9461C19.5912 57.777 20.5426 56.8282 21.7149 56.8282H43.1754ZM175.041 46.9016C176.215 46.9016 177.165 47.8504 177.165 49.0195C177.165 50.1886 176.215 51.1374 175.041 51.1374H157.228C156.056 51.1374 155.104 50.1886 155.104 49.0195C155.104 47.8504 156.056 46.9016 157.228 46.9016H175.041ZM148.83 46.9016C150.002 46.9016 150.954 47.8504 150.954 49.0195C150.954 50.1886 150.002 51.1374 148.83 51.1374H145.212C144.039 51.1374 143.089 50.1886 143.089 49.0195C143.089 47.8504 144.039 46.9016 145.212 46.9016H148.83ZM24.8041 46.7624C25.9763 46.7624 26.9277 47.7112 26.9277 48.8803C26.9277 50.0494 25.9763 50.9982 24.8041 50.9982H16.1236C14.9514 50.9982 14 50.0494 14 48.8803C14 47.7112 14.9514 46.7624 16.1236 46.7624H24.8041ZM61.4958 46.7624C62.6691 46.7624 63.6194 47.7112 63.6194 48.8803C63.6194 50.0494 62.6691 50.9982 61.4958 50.9982H33.8119C32.6397 50.9982 31.6883 50.0494 31.6883 48.8803C31.6883 47.7112 32.6397 46.7624 33.8119 46.7624H61.4958ZM57.6905 36.6967C58.8628 36.6967 59.8142 37.6455 59.8142 38.8146C59.8142 39.9837 58.8628 40.9325 57.6905 40.9325H53.4178C52.2444 40.9325 51.2941 39.9837 51.2941 38.8146C51.2941 37.6455 52.2444 36.6967 53.4178 36.6967H57.6905ZM44.5328 36.6967C45.7051 36.6967 46.6565 37.6455 46.6565 38.8146C46.6565 39.9837 45.7051 40.9325 44.5328 40.9325H21.9266C20.7533 40.9325 19.803 39.9837 19.803 38.8146C19.803 37.6455 20.7533 36.6967 21.9266 36.6967H44.5328ZM150.289 36.4542C151.461 36.4542 152.413 37.403 152.413 38.5721C152.413 39.7412 151.461 40.69 150.289 40.69H138.535C137.361 40.69 136.411 39.7412 136.411 38.5721C136.411 37.403 137.361 36.4542 138.535 36.4542H150.289ZM162.045 36.4542C163.217 36.4542 164.168 37.403 164.168 38.5721C164.168 39.7412 163.217 40.69 162.045 40.69H158.428C157.255 40.69 156.305 39.7412 156.305 38.5721C156.305 37.403 157.255 36.4542 158.428 36.4542H162.045ZM175.876 26.1733C177.049 26.1733 178 27.1222 178 28.2913C178 29.4603 177.049 30.4092 175.876 30.4092H166.769C165.596 30.4092 164.645 29.4603 164.645 28.2913C164.645 27.1222 165.596 26.1733 166.769 26.1733H175.876ZM156.287 26.1733C157.459 26.1733 158.41 27.1222 158.41 28.2913C158.41 29.4603 157.459 30.4092 156.287 30.4092H140.978C139.806 30.4092 138.855 29.4603 138.855 28.2913C138.855 27.1222 139.806 26.1733 140.978 26.1733H156.287Z\" fill=\"#B6C5D5\"/>\n<path d=\"M135.165 97.9947C147.038 97.9947 156.663 88.37 156.663 76.4974C156.663 64.6247 147.038 55 135.165 55C123.293 55 113.668 64.6247 113.668 76.4974C113.668 88.37 123.293 97.9947 135.165 97.9947Z\" fill=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M135.001 95.3853C145.052 95.3853 153.335 87.0873 153.335 77.0423C153.335 67.0163 145.033 58.7183 135.001 58.7183C124.951 58.7183 116.668 67.0163 116.668 77.0423C116.668 87.0873 124.97 95.3853 135.001 95.3853ZM135.309 79.8913C136.137 79.8913 136.647 79.3813 136.647 78.4693L136.902 67.7893C136.922 66.8983 136.222 66.2193 135.288 66.2193C134.333 66.2193 133.674 66.8763 133.696 67.7893L133.929 78.4693C133.95 79.3823 134.439 79.8913 135.309 79.8913ZM135.309 86.2183C134.248 86.2183 133.335 85.3483 133.335 84.3083C133.335 83.2463 134.226 82.3963 135.309 82.3963C136.392 82.3963 137.284 83.2243 137.284 84.3073C137.284 85.3693 136.371 86.2183 135.309 86.2183Z\" fill=\"#FECF2F\"/>\n</svg>";

var LinealUsuarioAltaError = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M43.1784 55.6962C43.4674 55.6962 43.7175 55.8162 43.9317 56.0534L45.298 57.4455L46.6762 56.0534C46.8978 55.8236 47.1489 55.7091 47.4295 55.7091C47.7018 55.7091 47.9372 55.8088 48.1385 56.0091C48.3369 56.2095 48.4385 56.4412 48.4385 56.7052C48.4385 56.9775 48.3305 57.224 48.1191 57.4455L46.6633 58.8755L48.2456 60.4587C48.4579 60.671 48.5659 60.9138 48.5659 61.1861C48.5659 61.4501 48.4625 61.6846 48.2594 61.8877C48.0554 62.0926 47.8163 62.1942 47.5449 62.1942C47.2624 62.1942 47.0122 62.0797 46.7916 61.8499L45.298 60.2925L43.8163 61.8499C43.5948 62.0797 43.3446 62.1942 43.0639 62.1942C42.7898 62.1942 42.5525 62.0926 42.3476 61.8877C42.1445 61.6846 42.0411 61.4501 42.0411 61.1861C42.0411 60.9138 42.1482 60.671 42.3614 60.4587L43.9437 58.8755L42.4888 57.4446C42.2765 57.2323 42.1685 56.9904 42.1685 56.7181C42.1685 56.4458 42.27 56.2067 42.4694 56.0027C42.6698 55.7987 42.9061 55.6962 43.1784 55.6962ZM23.7924 44.1569C24.0814 44.1569 24.3315 44.2769 24.5457 44.5142L25.912 45.9063L27.2902 44.5142C27.5118 44.2843 27.7629 44.1698 28.0435 44.1698C28.3158 44.1698 28.5512 44.2695 28.7525 44.4698C28.9509 44.6702 29.0525 44.9019 29.0525 45.1659C29.0525 45.4382 28.9445 45.6847 28.7331 45.9063L27.2773 47.3362L28.8595 48.9194C29.0719 49.1317 29.1799 49.3745 29.1799 49.6468C29.1799 49.9109 29.0765 50.1453 28.8734 50.3484C28.6694 50.5534 28.4303 50.6549 28.1589 50.6549C27.8764 50.6549 27.6262 50.5404 27.4056 50.3106L25.912 48.7532L24.4303 50.3106C24.2088 50.5404 23.9586 50.6549 23.6779 50.6549C23.4038 50.6549 23.1665 50.5534 22.9616 50.3484C22.7585 50.1453 22.6551 49.9109 22.6551 49.6468C22.6551 49.3745 22.7622 49.1317 22.9754 48.9194L24.5577 47.3362L23.1028 45.9053C22.8905 45.693 22.7825 45.4511 22.7825 45.1788C22.7825 44.9065 22.884 44.6674 23.0834 44.4634C23.2838 44.2594 23.5201 44.1569 23.7924 44.1569ZM156.937 42.3106C157.211 42.3106 157.447 42.4122 157.653 42.6171C157.856 42.8211 157.958 43.0556 157.958 43.3187C157.958 43.5919 157.852 43.8347 157.638 44.047L156.058 45.6302L157.512 47.0602C157.724 47.2817 157.832 47.5282 157.832 47.8005C157.832 48.0646 157.73 48.2963 157.53 48.4966C157.331 48.696 157.093 48.7966 156.821 48.7966C156.541 48.7966 156.289 48.6812 156.069 48.4514L154.69 47.0602L153.324 48.4514C153.11 48.6895 152.862 48.8086 152.57 48.8086C152.298 48.8086 152.063 48.7071 151.861 48.5021C151.662 48.299 151.562 48.0599 151.562 47.7876C151.562 47.5153 151.669 47.2725 151.882 47.0602L153.337 45.6293L151.754 44.047C151.542 43.8347 151.434 43.5919 151.434 43.3196C151.434 43.0556 151.538 42.8211 151.741 42.618C151.944 42.4131 152.184 42.3106 152.456 42.3106C152.737 42.3106 152.988 42.426 153.211 42.6559L154.69 44.2132L156.184 42.6559C156.406 42.4251 156.655 42.3106 156.938 42.3106H156.937ZM186.478 39.5412C186.751 39.5412 186.987 39.6427 187.193 39.8477C187.396 40.0517 187.499 40.2862 187.499 40.5493C187.499 40.8225 187.393 41.0653 187.179 41.2776L185.598 42.8608L187.052 44.2908C187.264 44.5123 187.372 44.7588 187.372 45.0311C187.372 45.2951 187.271 45.5268 187.071 45.7272C186.871 45.9266 186.634 46.0272 186.362 46.0272C186.082 46.0272 185.83 45.9118 185.609 45.6819L184.231 44.2908L182.865 45.6819C182.651 45.9201 182.402 46.0392 182.111 46.0392C181.838 46.0392 181.604 45.9376 181.402 45.7327C181.203 45.5296 181.102 45.2905 181.102 45.0182C181.102 44.7459 181.21 44.5031 181.423 44.2908L182.878 42.8599L181.294 41.2776C181.082 41.0653 180.974 40.8225 180.974 40.5502C180.974 40.2862 181.078 40.0517 181.282 39.8486C181.485 39.6437 181.725 39.5412 181.997 39.5412C182.278 39.5412 182.529 39.6566 182.751 39.8864L184.231 41.4438L185.725 39.8864C185.946 39.6557 186.195 39.5412 186.479 39.5412H186.478ZM4.40733 28.0019C4.69628 28.0019 4.94645 28.1219 5.16062 28.3592L6.52687 29.7513L7.90512 28.3592C8.12668 28.1293 8.37777 28.0148 8.65841 28.0148C8.93073 28.0148 9.16613 28.1145 9.36738 28.3148C9.56586 28.5152 9.6674 28.7469 9.6674 29.0109C9.6674 29.2832 9.55939 29.5297 9.34799 29.7513L7.8922 31.1812L9.47446 32.7644C9.68679 32.9767 9.79479 33.2195 9.79479 33.4918C9.79479 33.7558 9.6914 33.9903 9.48831 34.1934C9.2843 34.3984 9.0452 34.4999 8.7738 34.4999C8.49132 34.4999 8.24115 34.3854 8.02051 34.1556L6.52687 32.5982L5.04522 34.1556C4.82367 34.3854 4.5735 34.4999 4.29286 34.4999C4.01869 34.4999 3.78144 34.3984 3.5765 34.1934C3.37341 33.9903 3.27002 33.7558 3.27002 33.4918C3.27002 33.2195 3.3771 32.9767 3.59035 32.7644L5.17262 31.1812L3.71774 29.7503C3.50542 29.538 3.39741 29.2961 3.39741 29.0238C3.39741 28.7515 3.49896 28.5124 3.69836 28.3084C3.89868 28.1044 4.135 28.0019 4.40733 28.0019ZM168.016 21.0783C168.288 21.0783 168.526 21.1799 168.73 21.3848C168.934 21.5888 169.037 21.8233 169.037 22.0864C169.037 22.3596 168.93 22.6024 168.717 22.8148L167.134 24.3979L168.59 25.8279C168.803 26.0495 168.91 26.2959 168.91 26.5683C168.91 26.8323 168.808 27.064 168.609 27.2643C168.408 27.4637 168.172 27.5643 167.9 27.5643C167.62 27.5643 167.368 27.4489 167.146 27.2191L165.769 25.8279L164.402 27.2191C164.19 27.4572 163.938 27.5763 163.649 27.5763C163.376 27.5763 163.141 27.4748 162.94 27.2698C162.741 27.0668 162.64 26.8277 162.64 26.5553C162.64 26.283 162.748 26.0402 162.96 25.8279L164.415 24.397L162.833 22.8148C162.62 22.6024 162.512 22.3596 162.512 22.0873C162.512 21.8233 162.616 21.5888 162.819 21.3857C163.023 21.1808 163.262 21.0783 163.535 21.0783C163.816 21.0783 164.066 21.1937 164.287 21.4236L165.769 22.9809L167.263 21.4236C167.484 21.1928 167.733 21.0783 168.016 21.0783ZM41.0838 16.9242C41.3561 16.9242 41.5934 17.0257 41.7983 17.2307C42.0014 17.4347 42.1048 17.6692 42.1048 17.9323C42.1048 18.2055 41.9977 18.4483 41.7845 18.6606L40.2022 20.2438L41.658 21.6738C41.8703 21.8953 41.9774 22.1418 41.9774 22.4141C41.9774 22.6781 41.8759 22.9098 41.6765 23.1102C41.4761 23.3096 41.2398 23.4102 40.9675 23.4102C40.6878 23.4102 40.4358 23.2948 40.2142 23.0649L38.8369 21.6738L37.4697 23.0649C37.2574 23.3031 37.0063 23.4222 36.7164 23.4222C36.4441 23.4222 36.2087 23.3206 36.0074 23.1157C35.809 22.9126 35.7074 22.6735 35.7074 22.4012C35.7074 22.1289 35.8154 21.8861 36.0278 21.6738L37.4826 20.2429L35.9004 18.6606C35.688 18.4483 35.58 18.2055 35.58 17.9332C35.58 17.6692 35.6834 17.4347 35.8865 17.2316C36.0905 17.0267 36.3296 16.9242 36.6029 16.9242C36.8835 16.9242 37.1337 17.0396 37.3552 17.2694L38.8369 18.8268L40.3305 17.2694C40.5521 17.0387 40.8013 16.9242 41.0838 16.9242ZM145.86 10.8887C146.132 10.8887 146.369 10.9902 146.574 11.1952C146.777 11.3992 146.881 11.6336 146.881 11.8967C146.881 12.17 146.774 12.4119 146.56 12.6251L144.978 14.2083L146.434 15.6382C146.646 15.8598 146.753 16.1063 146.753 16.3786C146.753 16.6417 146.652 16.8743 146.452 17.0737C146.252 17.2741 146.016 17.3738 145.743 17.3738C145.464 17.3738 145.212 17.2593 144.99 17.0294L143.613 15.6382L142.246 17.0294C142.033 17.2676 141.782 17.3867 141.492 17.3867C141.22 17.3867 140.984 17.2851 140.783 17.0802C140.585 16.8762 140.483 16.6371 140.483 16.3657C140.483 16.0934 140.591 15.8506 140.804 15.6382L142.258 14.2074L140.676 12.6251C140.464 12.4128 140.356 12.17 140.356 11.8967C140.356 11.6336 140.459 11.3992 140.662 11.1952C140.866 10.9911 141.105 10.8887 141.379 10.8887C141.659 10.8887 141.909 11.0031 142.131 11.233L143.613 12.7913L145.106 11.233C145.328 11.0031 145.577 10.8887 145.86 10.8887Z\" fill=\"#B6C5D5\"/>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" d=\"M95.1216 78.7747C99.477 78.7747 103.67 78.0085 107.572 76.6072C107.861 78.0593 108.286 79.4634 108.832 80.8047C105.367 81.8848 101.691 82.4664 97.891 82.4664C84.9347 82.4664 73.3945 75.672 66.6777 65.4824C73.5635 73.5876 83.802 78.7738 95.1216 78.7738V78.7747ZM126.345 20.9878C131.89 27.5172 135.259 35.9372 135.259 45.0587C135.259 46.4684 135.179 47.8614 135.023 49.2341C133.951 49.0163 132.852 48.8732 131.733 48.8095C132.228 46.4001 132.49 43.9113 132.49 41.3662C132.49 34.005 130.296 27.1018 126.535 21.2795L126.345 20.9878Z\" fill=\"#CCCCCC\"/>\n</g>\n<path d=\"M95.5642 4C116.011 4 132.932 20.9212 132.932 41.3679C132.932 43.9232 132.669 46.423 132.17 48.8408C131.581 48.7946 130.986 48.7724 130.388 48.7724C129.7 48.7724 129.021 48.802 128.349 48.8601C128.889 46.4535 129.168 43.9462 129.156 41.367C129.115 22.7823 114.148 7.81627 95.5633 7.81627C76.9389 7.81627 62.0135 22.7823 62.0135 41.367C62.0135 50.0833 65.2611 57.978 70.6476 63.8981C74.3891 59.0886 83.5578 54.4821 95.5633 54.4821C101.999 54.4821 107.614 55.7966 112.018 57.7611C108.951 61.702 107.123 66.6556 107.123 72.0356C107.123 73.6511 107.287 75.2288 107.601 76.752C103.818 78.061 99.7673 78.7737 95.5633 78.7737C75.1175 78.7746 58.1963 61.8534 58.1963 41.3679C58.1963 20.9212 75.0787 4 95.5642 4ZM95.5642 18.8765C103.006 18.8765 108.845 25.3726 108.845 33.2258C108.845 41.5313 103.047 47.9038 95.5642 47.8633C88.1218 47.7801 82.3245 41.5304 82.2827 33.2258C82.2423 25.3726 88.1634 18.8765 95.5642 18.8765Z\" fill=\"#B6C5D5\"/>\n<path d=\"M130.201 93.1057C141.336 93.1057 150.51 83.9091 150.51 72.774C150.51 61.6614 141.314 52.4648 130.201 52.4648C119.066 52.4648 109.892 61.6614 109.892 72.774C109.892 83.9091 119.089 93.1057 130.201 93.1057ZM122.898 81.5671C122.069 81.5671 121.43 80.9067 121.43 80.0986C121.43 79.6928 121.579 79.3322 121.856 79.0764L128.115 72.7954L121.856 66.5156C121.579 66.2597 121.43 65.898 121.43 65.4934C121.43 64.6639 122.069 64.0462 122.899 64.0462C123.304 64.0462 123.644 64.195 123.921 64.4723L130.201 70.7307L136.502 64.4723C136.801 64.1522 137.142 64.0034 137.525 64.0034C138.334 64.0034 138.993 64.6639 138.993 65.4719C138.993 65.8777 138.866 66.1966 138.547 66.4942L132.266 72.7954L138.547 79.0335C138.823 79.3322 138.973 79.6726 138.973 80.0986C138.973 80.9067 138.334 81.5671 137.503 81.5671C137.077 81.5671 136.715 81.3969 136.439 81.1197L130.201 74.8613L123.942 81.1197C123.687 81.3969 123.304 81.5671 122.899 81.5671H122.898Z\" fill=\"#DD2457\"/>\n</svg>";

var LinealUsuarioAlta = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g opacity=\"0.6\">\n<path d=\"M44.0863 55.3575C44.3724 55.3575 44.6201 55.4764 44.8322 55.7113L46.1851 57.0899L47.55 55.7113C47.7694 55.4837 48.018 55.3703 48.2959 55.3703C48.5656 55.3703 48.7987 55.4691 48.998 55.6674C49.1945 55.8658 49.2951 56.0953 49.2951 56.3567C49.2951 56.6264 49.1881 56.8705 48.9788 57.0899L47.5372 58.5059L49.104 60.0736C49.3143 60.2839 49.4212 60.5243 49.4212 60.794C49.4212 61.0554 49.3188 61.2876 49.1177 61.4887C48.9157 61.6917 48.6789 61.7922 48.4102 61.7922C48.1304 61.7922 47.8827 61.6789 47.6642 61.4512L46.1851 59.9091L44.7179 61.4512C44.4985 61.6789 44.2508 61.7922 43.9729 61.7922C43.7014 61.7922 43.4665 61.6917 43.2635 61.4887C43.0624 61.2876 42.96 61.0554 42.96 60.794C42.96 60.5243 43.0661 60.2839 43.2772 60.0736L44.8441 58.5059L43.4034 57.0889C43.1931 56.8787 43.0862 56.6392 43.0862 56.3695C43.0862 56.0998 43.1867 55.8631 43.3842 55.661C43.5826 55.459 43.8166 55.3575 44.0863 55.3575ZM24.8892 43.9307C25.1754 43.9307 25.4231 44.0496 25.6352 44.2845L26.9881 45.663L28.3529 44.2845C28.5723 44.0569 28.821 43.9435 29.0989 43.9435C29.3685 43.9435 29.6017 44.0423 29.8009 44.2406C29.9975 44.439 30.098 44.6685 30.098 44.9299C30.098 45.1996 29.9911 45.4437 29.7817 45.663L28.3401 47.0791L29.907 48.6468C30.1172 48.8571 30.2242 49.0975 30.2242 49.3672C30.2242 49.6286 30.1218 49.8608 29.9207 50.0619C29.7187 50.2649 29.4819 50.3654 29.2131 50.3654C28.9334 50.3654 28.6857 50.2521 28.4672 50.0244L26.9881 48.4823L25.5209 50.0244C25.3015 50.2521 25.0538 50.3654 24.7759 50.3654C24.5044 50.3654 24.2694 50.2649 24.0665 50.0619C23.8654 49.8608 23.763 49.6286 23.763 49.3672C23.763 49.0975 23.8691 48.8571 24.0802 48.6468L25.6471 47.0791L24.2064 45.6621C23.9961 45.4519 23.8892 45.2124 23.8892 44.9427C23.8892 44.673 23.9897 44.4363 24.1872 44.2342C24.3855 44.0322 24.6196 43.9307 24.8892 43.9307ZM156.736 42.1025C157.007 42.1025 157.241 42.203 157.445 42.406C157.646 42.608 157.747 42.8402 157.747 43.1007C157.747 43.3713 157.642 43.6117 157.43 43.822L155.865 45.3897L157.305 46.8057C157.515 47.0251 157.622 47.2692 157.622 47.5389C157.622 47.8003 157.522 48.0298 157.323 48.2281C157.126 48.4256 156.891 48.5252 156.621 48.5252C156.344 48.5252 156.095 48.411 155.876 48.1833L154.511 46.8057L153.158 48.1833C152.946 48.4192 152.7 48.5371 152.411 48.5371C152.142 48.5371 151.91 48.4366 151.709 48.2336C151.513 48.0325 151.413 47.7957 151.413 47.5261C151.413 47.2564 151.519 47.016 151.73 46.8057L153.171 45.3888L151.603 43.822C151.393 43.6117 151.286 43.3713 151.286 43.1016C151.286 42.8402 151.389 42.608 151.591 42.4069C151.792 42.2039 152.029 42.1025 152.299 42.1025C152.577 42.1025 152.826 42.2167 153.046 42.4443L154.511 43.9865L155.99 42.4443C156.21 42.2158 156.457 42.1025 156.737 42.1025H156.736ZM185.989 39.36C186.259 39.36 186.493 39.4606 186.697 39.6635C186.898 39.8655 187 40.0977 187 40.3583C187 40.6289 186.895 40.8693 186.683 41.0795L185.118 42.6473L186.557 44.0633C186.768 44.2827 186.875 44.5268 186.875 44.7964C186.875 45.0579 186.774 45.2873 186.576 45.4857C186.378 45.6832 186.143 45.7828 185.874 45.7828C185.597 45.7828 185.347 45.6685 185.129 45.4409L183.764 44.0633L182.411 45.4409C182.199 45.6768 181.953 45.7947 181.664 45.7947C181.394 45.7947 181.162 45.6941 180.962 45.4912C180.765 45.2901 180.666 45.0533 180.666 44.7836C180.666 44.514 180.772 44.2735 180.983 44.0633L182.424 42.6464L180.856 41.0795C180.646 40.8693 180.539 40.6289 180.539 40.3592C180.539 40.0977 180.642 39.8655 180.843 39.6644C181.044 39.4615 181.282 39.36 181.552 39.36C181.83 39.36 182.078 39.4743 182.298 39.7019L183.764 41.2441L185.243 39.7019C185.462 39.4734 185.709 39.36 185.99 39.36H185.989ZM5.69312 27.9332C5.97925 27.9332 6.22698 28.0521 6.43906 28.287L7.792 29.6655L9.15681 28.287C9.37621 28.0594 9.62485 27.946 9.90275 27.946C10.1724 27.946 10.4055 28.0447 10.6048 28.2431C10.8014 28.4415 10.9019 28.6709 10.9019 28.9324C10.9019 29.2021 10.795 29.4461 10.5856 29.6655L9.14401 31.0815L10.7109 32.6493C10.9211 32.8595 11.0281 33.1 11.0281 33.3696C11.0281 33.6311 10.9257 33.8633 10.7246 34.0644C10.5225 34.2673 10.2858 34.3679 10.017 34.3679C9.73729 34.3679 9.48956 34.2545 9.27108 34.0269L7.792 32.4847L6.32479 34.0269C6.1054 34.2545 5.85767 34.3679 5.57977 34.3679C5.30827 34.3679 5.07333 34.2673 4.87039 34.0644C4.66928 33.8633 4.56689 33.6311 4.56689 33.3696C4.56689 33.1 4.67294 32.8595 4.8841 32.6493L6.45095 31.0815L5.01025 29.6646C4.8 29.4544 4.69305 29.2149 4.69305 28.9452C4.69305 28.6755 4.7936 28.4387 4.99106 28.2367C5.18943 28.0347 5.42345 27.9332 5.69312 27.9332ZM167.707 21.0771C167.977 21.0771 168.212 21.1777 168.414 21.3806C168.616 21.5827 168.718 21.8149 168.718 22.0754C168.718 22.346 168.612 22.5864 168.401 22.7966L166.834 24.3644L168.276 25.7804C168.486 25.9998 168.592 26.2439 168.592 26.5136C168.592 26.775 168.491 27.0045 168.294 27.2028C168.095 27.4003 167.861 27.4999 167.592 27.4999C167.315 27.4999 167.065 27.3857 166.846 27.158L165.482 25.7804L164.128 27.158C163.918 27.3939 163.669 27.5118 163.382 27.5118C163.112 27.5118 162.879 27.4112 162.68 27.2083C162.483 27.0072 162.383 26.7704 162.383 26.5008C162.383 26.2311 162.49 25.9907 162.7 25.7804L164.141 24.3635L162.574 22.7966C162.364 22.5864 162.257 22.346 162.257 22.0763C162.257 21.8149 162.359 21.5827 162.56 21.3816C162.762 21.1786 162.999 21.0771 163.27 21.0771C163.548 21.0771 163.795 21.1914 164.015 21.419L165.482 22.9612L166.961 21.419C167.18 21.1905 167.427 21.0771 167.707 21.0771ZM42.0121 16.9635C42.2817 16.9635 42.5167 17.064 42.7196 17.267C42.9207 17.469 43.0231 17.7012 43.0231 17.9617C43.0231 18.2323 42.9171 18.4727 42.7059 18.683L41.1391 20.2508L42.5807 21.6668C42.7909 21.8862 42.897 22.1302 42.897 22.3999C42.897 22.6614 42.7964 22.8908 42.599 23.0892C42.4006 23.2866 42.1666 23.3863 41.8969 23.3863C41.6199 23.3863 41.3703 23.272 41.1509 23.0444L39.787 21.6668L38.4332 23.0444C38.2229 23.2802 37.9743 23.3982 37.6873 23.3982C37.4176 23.3982 37.1845 23.2976 36.9852 23.0947C36.7887 22.8935 36.6881 22.6568 36.6881 22.3871C36.6881 22.1174 36.7951 21.877 37.0053 21.6668L38.446 20.2498L36.8792 18.683C36.6689 18.4727 36.5619 18.2323 36.5619 17.9627C36.5619 17.7012 36.6643 17.469 36.8654 17.2679C37.0675 17.065 37.3042 16.9635 37.5748 16.9635C37.8527 16.9635 38.1004 17.0778 38.3198 17.3054L39.787 18.8475L41.2661 17.3054C41.4855 17.0768 41.7323 16.9635 42.0121 16.9635ZM145.767 10.9868C146.036 10.9868 146.271 11.0874 146.474 11.2903C146.675 11.4923 146.778 11.7245 146.778 11.9851C146.778 12.2556 146.672 12.4952 146.46 12.7063L144.894 14.2741L146.335 15.6901C146.545 15.9095 146.651 16.1536 146.651 16.4232C146.651 16.6838 146.551 16.9141 146.353 17.1116C146.155 17.31 145.921 17.4087 145.651 17.4087C145.374 17.4087 145.125 17.2953 144.905 17.0677L143.542 15.6901L142.188 17.0677C141.977 17.3036 141.729 17.4215 141.442 17.4215C141.172 17.4215 140.939 17.3209 140.74 17.118C140.543 16.916 140.443 16.6792 140.443 16.4104C140.443 16.1408 140.549 15.9003 140.76 15.6901L142.2 14.2732L140.634 12.7063C140.423 12.4961 140.316 12.2556 140.316 11.9851C140.316 11.7245 140.419 11.4923 140.62 11.2903C140.822 11.0883 141.059 10.9868 141.329 10.9868C141.607 10.9868 141.855 11.1002 142.074 11.3278L143.542 12.8709L145.021 11.3278C145.24 11.1002 145.487 10.9868 145.767 10.9868Z\" fill=\"#B6C5D5\"/>\n</g>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" d=\"M95.5235 78.2114C99.8365 78.2114 103.989 77.4527 107.853 76.065C108.139 77.5029 108.559 78.8933 109.1 80.2216C105.669 81.2911 102.029 81.8671 98.266 81.8671C85.436 81.8671 74.0082 75.139 67.3569 65.0486C74.1755 73.0748 84.3143 78.2105 95.5235 78.2105V78.2114ZM126.443 20.9878C131.934 27.4535 135.27 35.7914 135.27 44.8241C135.27 46.22 135.19 47.5994 135.036 48.9588C133.974 48.743 132.886 48.6013 131.778 48.5383C132.268 46.1524 132.527 43.6878 132.527 41.1675C132.527 33.8781 130.355 27.0422 126.631 21.2767L126.443 20.9878Z\" fill=\"#CCCCCC\"/>\n</g>\n<path d=\"M95.9612 4.16553C116.209 4.16553 132.965 20.9218 132.965 41.1692C132.965 43.6995 132.704 46.175 132.21 48.5692C131.627 48.5235 131.038 48.5015 130.445 48.5015C129.764 48.5015 129.092 48.5308 128.426 48.5884C128.961 46.2052 129.238 43.7224 129.226 41.1683C129.185 22.7647 114.364 7.9446 95.9602 7.9446C77.5174 7.9446 62.7375 22.7647 62.7375 41.1683C62.7375 49.7996 65.9535 57.6174 71.2875 63.4798C74.9925 58.7171 84.0718 54.1555 95.9602 54.1555C102.334 54.1555 107.893 55.4572 112.255 57.4025C109.217 61.305 107.407 66.2103 107.407 71.538C107.407 73.1377 107.57 74.7 107.881 76.2083C104.135 77.5046 100.123 78.2103 95.9602 78.2103C75.7138 78.2112 58.9575 61.4549 58.9575 41.1692C58.9575 20.9218 75.6754 4.16553 95.9612 4.16553ZM95.9612 18.897C103.33 18.897 109.112 25.3298 109.112 33.1064C109.112 41.331 103.371 47.6413 95.9612 47.6013C88.5913 47.5188 82.8505 41.3301 82.8092 33.1064C82.7691 25.3298 88.6325 18.897 95.9612 18.897Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M130.261 92.8711C141.285 92.8711 150.372 83.6579 150.372 72.5035C150.372 61.3713 141.265 52.1582 130.261 52.1582C119.236 52.1582 110.149 61.3713 110.149 72.5035C110.149 83.6579 119.256 92.8711 130.261 92.8711ZM127.576 82.456C126.972 82.456 126.521 82.22 126.026 81.6204L119.934 74.2727C119.676 73.9303 119.504 73.5232 119.504 73.1161C119.504 72.2796 120.171 71.6587 120.945 71.6587C121.441 71.6587 121.871 71.8512 122.302 72.3869L127.49 78.8788L137.284 63.3885C137.629 62.8518 138.102 62.5742 138.555 62.5742C139.329 62.5742 140.082 63.0887 140.082 63.9242C140.082 64.2323 139.945 64.5682 139.769 64.8662L129.039 81.5992C128.652 82.1775 128.157 82.456 127.576 82.456Z\" fill=\"#1AAAAD\"/>\n</svg>";

var LinealUsuarioCuentaBloqueada = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g opacity=\"0.6\">\n<path d=\"M41.5217 55.7859C41.8224 55.7859 42.0826 55.9108 42.3055 56.1576L43.727 57.606L45.1609 56.1576C45.3914 55.9184 45.6527 55.7993 45.9447 55.7993C46.228 55.7993 46.4729 55.9031 46.6823 56.1115C46.8888 56.3199 46.9944 56.561 46.9944 56.8357C46.9944 57.119 46.8821 57.3755 46.6621 57.606L45.1475 59.0937L46.7937 60.7409C47.0146 60.9618 47.127 61.2144 47.127 61.4978C47.127 61.7725 47.0194 62.0164 46.8081 62.2277C46.5959 62.4409 46.3471 62.5466 46.0647 62.5466C45.7708 62.5466 45.5105 62.4275 45.281 62.1883L43.727 60.568L42.1854 62.1883C41.9549 62.4275 41.6946 62.5466 41.4026 62.5466C41.1174 62.5466 40.8705 62.4409 40.6573 62.2277C40.446 62.0164 40.3384 61.7725 40.3384 61.4978C40.3384 61.2144 40.4499 60.9618 40.6717 60.7409L42.318 59.0937L40.8043 57.605C40.5834 57.3841 40.471 57.1325 40.471 56.8491C40.471 56.5658 40.5766 56.317 40.7841 56.1048C40.9925 55.8925 41.2384 55.7859 41.5217 55.7859ZM21.352 43.7801C21.6527 43.7801 21.9129 43.905 22.1358 44.1518L23.5573 45.6002L24.9912 44.1518C25.2217 43.9127 25.483 43.7936 25.775 43.7936C26.0583 43.7936 26.3032 43.8973 26.5126 44.1057C26.7191 44.3141 26.8247 44.5552 26.8247 44.8299C26.8247 45.1132 26.7124 45.3697 26.4924 45.6002L24.9778 47.088L26.624 48.7351C26.8449 48.9561 26.9573 49.2087 26.9573 49.492C26.9573 49.7667 26.8497 50.0106 26.6384 50.2219C26.4262 50.4352 26.1774 50.5408 25.895 50.5408C25.6011 50.5408 25.3408 50.4217 25.1113 50.1826L23.5573 48.5623L22.0157 50.1826C21.7852 50.4217 21.5249 50.5408 21.2329 50.5408C20.9477 50.5408 20.7008 50.4352 20.4876 50.2219C20.2763 50.0106 20.1687 49.7667 20.1687 49.492C20.1687 49.2087 20.2802 48.9561 20.502 48.7351L22.1483 47.088L20.6346 45.5992C20.4137 45.3783 20.3013 45.1267 20.3013 44.8434C20.3013 44.56 20.4069 44.3113 20.6144 44.099C20.8228 43.8867 21.0687 43.7801 21.352 43.7801ZM159.879 41.8592C160.164 41.8592 160.41 41.9649 160.624 42.1781C160.835 42.3903 160.942 42.6343 160.942 42.908C160.942 43.1923 160.831 43.4449 160.608 43.6658L158.964 45.313L160.477 46.8008C160.698 47.0313 160.81 47.2877 160.81 47.5711C160.81 47.8458 160.705 48.0868 160.496 48.2953C160.289 48.5027 160.042 48.6074 159.758 48.6074C159.467 48.6074 159.205 48.4873 158.976 48.2482L157.542 46.8008L156.12 48.2482C155.897 48.496 155.639 48.6199 155.336 48.6199C155.052 48.6199 154.808 48.5142 154.598 48.301C154.391 48.0897 154.287 47.841 154.287 47.5576C154.287 47.2743 154.398 47.0217 154.62 46.8008L156.134 45.3121L154.486 43.6658C154.266 43.4449 154.153 43.1923 154.153 42.909C154.153 42.6343 154.262 42.3903 154.473 42.179C154.684 41.9658 154.934 41.8592 155.217 41.8592C155.509 41.8592 155.771 41.9793 156.002 42.2184L157.542 43.8387L159.096 42.2184C159.326 41.9783 159.586 41.8592 159.88 41.8592H159.879ZM190.614 38.9778C190.899 38.9778 191.144 39.0835 191.359 39.2967C191.57 39.509 191.677 39.7529 191.677 40.0266C191.677 40.3109 191.566 40.5635 191.343 40.7844L189.699 42.4316L191.212 43.9194C191.433 44.1499 191.545 44.4063 191.545 44.6897C191.545 44.9644 191.439 45.2054 191.231 45.4139C191.023 45.6213 190.777 45.726 190.493 45.726C190.202 45.726 189.94 45.606 189.71 45.3668L188.276 43.9194L186.855 45.3668C186.632 45.6146 186.374 45.7385 186.07 45.7385C185.787 45.7385 185.543 45.6329 185.333 45.4196C185.126 45.2083 185.021 44.9596 185.021 44.6762C185.021 44.3929 185.133 44.1403 185.355 43.9194L186.868 42.4307L185.221 40.7844C185 40.5635 184.888 40.3109 184.888 40.0276C184.888 39.7529 184.997 39.509 185.208 39.2976C185.419 39.0844 185.669 38.9778 185.952 38.9778C186.244 38.9778 186.505 39.0979 186.737 39.337L188.276 40.9573L189.831 39.337C190.061 39.0969 190.32 38.9778 190.615 38.9778H190.614ZM1.18329 26.972C1.48391 26.972 1.7442 27.0969 1.96703 27.3437L3.38851 28.7921L4.82248 27.3437C5.05299 27.1046 5.31424 26.9855 5.60622 26.9855C5.88955 26.9855 6.13447 27.0892 6.34385 27.2976C6.55035 27.5061 6.656 27.7471 6.656 28.0218C6.656 28.3052 6.54363 28.5616 6.32368 28.7921L4.80903 30.2799L6.45527 31.9271C6.67617 32.148 6.78855 32.4006 6.78855 32.6839C6.78855 32.9586 6.68097 33.2026 6.46967 33.4139C6.25741 33.6271 6.00865 33.7327 5.72627 33.7327C5.43237 33.7327 5.17209 33.6136 4.94254 33.3745L3.38851 31.7542L1.84697 33.3745C1.61646 33.6136 1.35617 33.7327 1.06419 33.7327C0.778935 33.7327 0.532096 33.6271 0.318873 33.4139C0.107572 33.2026 0 32.9586 0 32.6839C0 32.4006 0.111414 32.148 0.33328 31.9271L1.97951 30.2799L0.465824 28.7912C0.244918 28.5702 0.132544 28.3186 0.132544 28.0353C0.132544 27.7519 0.238195 27.5032 0.445654 27.2909C0.654075 27.0787 0.899953 26.972 1.18329 26.972ZM171.406 19.7686C171.689 19.7686 171.936 19.8742 172.149 20.0874C172.361 20.2997 172.468 20.5437 172.468 20.8174C172.468 21.1017 172.357 21.3543 172.135 21.5752L170.489 23.2224L172.003 24.7102C172.224 24.9407 172.336 25.1971 172.336 25.4804C172.336 25.7551 172.23 25.9962 172.023 26.2046C171.814 26.4121 171.568 26.5168 171.285 26.5168C170.994 26.5168 170.732 26.3967 170.501 26.1576L169.068 24.7102L167.646 26.1576C167.425 26.4054 167.164 26.5293 166.862 26.5293C166.579 26.5293 166.334 26.4236 166.124 26.2104C165.918 25.9991 165.812 25.7503 165.812 25.467C165.812 25.1837 165.925 24.9311 166.146 24.7102L167.659 23.2214L166.013 21.5752C165.792 21.3543 165.68 21.1017 165.68 20.8184C165.68 20.5437 165.787 20.2997 165.999 20.0884C166.211 19.8752 166.46 19.7686 166.744 19.7686C167.036 19.7686 167.296 19.8886 167.527 20.1278L169.068 21.7481L170.622 20.1278C170.853 19.8877 171.112 19.7686 171.406 19.7686ZM39.3424 15.4465C39.6258 15.4465 39.8726 15.5521 40.0858 15.7654C40.2971 15.9776 40.4047 16.2216 40.4047 16.4953C40.4047 16.7796 40.2933 17.0322 40.0714 17.2531L38.4252 18.9003L39.9399 20.3881C40.1608 20.6186 40.2722 20.875 40.2722 21.1584C40.2722 21.4331 40.1665 21.6741 39.9591 21.8826C39.7506 22.09 39.5048 22.1947 39.2214 22.1947C38.9304 22.1947 38.6682 22.0746 38.4377 21.8355L37.0047 20.3881L35.5822 21.8355C35.3613 22.0833 35.1001 22.2072 34.7985 22.2072C34.5152 22.2072 34.2702 22.1015 34.0609 21.8883C33.8544 21.677 33.7487 21.4283 33.7487 21.1449C33.7487 20.8616 33.8611 20.609 34.082 20.3881L35.5957 18.8994L33.9495 17.2531C33.7285 17.0322 33.6162 16.7796 33.6162 16.4963C33.6162 16.2216 33.7237 15.9776 33.935 15.7663C34.1473 15.5531 34.3961 15.4465 34.6804 15.4465C34.9723 15.4465 35.2326 15.5666 35.4631 15.8057L37.0047 17.426L38.5587 15.8057C38.7892 15.5656 39.0485 15.4465 39.3424 15.4465ZM148.354 9.16699C148.637 9.16699 148.884 9.27264 149.097 9.48587C149.309 9.69813 149.416 9.94208 149.416 10.2158C149.416 10.5001 149.305 10.7518 149.083 10.9736L147.437 12.6208L148.951 14.1086C149.172 14.3391 149.284 14.5955 149.284 14.8789C149.284 15.1526 149.178 15.3946 148.971 15.6021C148.762 15.8105 148.516 15.9142 148.233 15.9142C147.942 15.9142 147.68 15.7951 147.449 15.556L146.016 14.1086L144.594 15.556C144.373 15.8038 144.112 15.9277 143.81 15.9277C143.527 15.9277 143.282 15.822 143.072 15.6088C142.866 15.3965 142.76 15.1478 142.76 14.8654C142.76 14.5821 142.873 14.3295 143.093 14.1086L144.607 12.6199L142.961 10.9736C142.74 10.7527 142.628 10.5001 142.628 10.2158C142.628 9.94208 142.735 9.69813 142.947 9.48587C143.159 9.2736 143.408 9.16699 143.692 9.16699C143.984 9.16699 144.244 9.28609 144.475 9.52524L146.016 11.1465L147.57 9.52524C147.801 9.28609 148.06 9.16699 148.354 9.16699Z\" fill=\"#B6C5D5\"/>\n</g>\n<g opacity=\"0.3\">\n<path opacity=\"0.3\" d=\"M95.5649 79.7973C100.096 79.7973 104.459 79.0001 108.519 77.5422C108.819 79.053 109.261 80.5138 109.83 81.9094C106.224 83.0331 102.4 83.6382 98.4463 83.6382C84.9663 83.6382 72.9595 76.5692 65.9712 65.9676C73.1353 74.4005 83.7878 79.7964 95.5649 79.7964V79.7973ZM128.051 19.6743C133.82 26.4677 137.325 35.228 137.325 44.7184C137.325 46.185 137.241 47.6343 137.079 49.0625C135.964 48.8359 134.821 48.687 133.656 48.6207C134.172 46.1139 134.443 43.5245 134.443 40.8765C134.443 33.2178 132.161 26.0355 128.249 19.9778L128.051 19.6743Z\" fill=\"#CCCCCC\"/>\n</g>\n<path d=\"M96.025 2C117.298 2 134.904 19.6053 134.904 40.8785C134.904 43.5371 134.63 46.138 134.11 48.6535C133.497 48.6055 132.879 48.5824 132.257 48.5824C131.541 48.5824 130.834 48.6131 130.135 48.6737C130.697 46.1697 130.988 43.5611 130.975 40.8776C130.932 21.5416 115.36 5.97055 96.0241 5.97055C76.6467 5.97055 61.118 21.5416 61.118 40.8776C61.118 49.9463 64.4969 58.1601 70.1012 64.3196C73.9939 59.3156 83.5333 54.5229 96.0241 54.5229C102.72 54.5229 108.562 55.8906 113.144 57.9344C109.953 62.0346 108.051 67.1885 108.051 72.7861C108.051 74.4669 108.222 76.1083 108.548 77.6931C104.613 79.055 100.398 79.7965 96.0241 79.7965C74.7518 79.7974 57.1465 62.1922 57.1465 40.8785C57.1465 19.6053 74.7114 2 96.025 2ZM96.025 17.4778C103.767 17.4778 109.842 24.2366 109.842 32.4073C109.842 41.0485 103.811 47.6786 96.025 47.6366C88.2818 47.5499 82.2501 41.0476 82.2066 32.4073C82.1646 24.2366 88.325 17.4778 96.025 17.4778Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M132.063 54.3452C142.667 54.3452 151.272 62.9503 151.272 73.5541C151.272 84.1578 142.667 92.7629 132.063 92.7629C121.459 92.7629 112.854 84.1578 112.854 73.5541C112.854 62.9503 121.459 54.3452 132.063 54.3452ZM116.311 73.5541C116.311 82.2537 123.363 89.3051 132.063 89.3051C135.72 89.3051 139.087 88.0589 141.76 85.9681L119.649 63.8563C117.558 66.5306 116.311 69.8963 116.311 73.5541ZM132.063 57.8023C128.405 57.8023 125.04 59.0484 122.365 61.1408L144.476 83.2511C146.568 80.5775 147.814 77.2111 147.814 73.5541C147.814 64.8552 140.762 57.8023 132.063 57.8023Z\" fill=\"#DD2457\"/>\n</svg>";

var LinealSesionExpirada = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M126.353 30.1094L116.343 22.5426C115.831 22.1875 115.561 21.7059 115.561 21.1957C115.561 20.5713 115.864 20.0652 116.375 19.5877C117.509 18.5673 119.547 18 121.344 18C126.054 18 129.77 21.7385 129.77 26.4035C129.77 27.5055 129.59 28.6442 129.291 29.3013C128.931 30.0196 128.301 30.4971 127.552 30.4971C127.102 30.4971 126.803 30.4359 126.353 30.1094ZM87.2375 52.6426C87.2375 51.4794 88.1337 50.557 89.3041 50.557H100.845V34.5336C100.845 33.3663 101.745 32.4358 102.911 32.4358C104.082 32.4358 105.011 33.3663 105.011 34.5336V52.6426C105.011 53.814 104.082 54.7078 102.911 54.7078H89.3041C88.1337 54.7078 87.2375 53.814 87.2375 52.6426ZM126.471 51.4223C126.471 38.4803 115.921 27.9585 102.944 27.9585C89.9344 27.9585 79.4128 38.4803 79.4128 51.4223C79.4128 64.3929 89.9344 74.8861 102.944 74.8861C115.921 74.8861 126.471 64.3929 126.471 51.4223ZM76.6258 29.3013C76.2984 28.6116 76.1184 27.5055 76.1184 26.4035C76.1184 21.7385 79.8629 18 84.5365 18C86.3371 18 88.3751 18.5673 89.5169 19.5877C90.0244 20.0652 90.3231 20.5713 90.3231 21.1957C90.3231 21.7059 90.053 22.1875 89.5742 22.5426L79.5355 30.1094C79.114 30.4359 78.7825 30.4971 78.3365 30.4971C77.5835 30.4971 76.9573 30.0441 76.6258 29.3013ZM77.9149 75.9064L82.4698 71.3883C77.4075 66.2458 74.2891 59.1932 74.2891 51.4223C74.2891 35.6356 87.1188 22.816 102.944 22.816C118.769 22.816 131.599 35.6356 131.599 51.4223C131.599 59.1932 128.485 66.2458 123.414 71.3883L127.973 75.9064C128.898 76.7961 128.898 78.2654 128.002 79.1348C127.102 80.0571 125.632 80.0571 124.703 79.1021L119.969 74.4085C115.201 77.9063 109.328 80 102.944 80C96.56 80 90.6833 77.9063 85.9197 74.4085L81.1807 79.1021C80.2517 80.0571 78.7825 80.0571 77.8863 79.1348C77.0146 78.2654 76.986 76.7961 77.9149 75.9064Z\" fill=\"#B6C5D5\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M43.1754 56.8282C44.3477 56.8282 45.299 57.777 45.299 58.9461C45.299 60.1152 44.3477 61.064 43.1754 61.064H21.7149C20.5426 61.064 19.5912 60.1152 19.5912 58.9461C19.5912 57.777 20.5426 56.8282 21.7149 56.8282H43.1754ZM175.041 46.9016C176.215 46.9016 177.165 47.8504 177.165 49.0195C177.165 50.1886 176.215 51.1374 175.041 51.1374H157.228C156.056 51.1374 155.104 50.1886 155.104 49.0195C155.104 47.8504 156.056 46.9016 157.228 46.9016H175.041ZM148.83 46.9016C150.002 46.9016 150.954 47.8504 150.954 49.0195C150.954 50.1886 150.002 51.1374 148.83 51.1374H145.212C144.039 51.1374 143.089 50.1886 143.089 49.0195C143.089 47.8504 144.039 46.9016 145.212 46.9016H148.83ZM24.8041 46.7624C25.9763 46.7624 26.9277 47.7112 26.9277 48.8803C26.9277 50.0494 25.9763 50.9982 24.8041 50.9982H16.1236C14.9514 50.9982 14 50.0494 14 48.8803C14 47.7112 14.9514 46.7624 16.1236 46.7624H24.8041ZM61.4958 46.7624C62.6691 46.7624 63.6194 47.7112 63.6194 48.8803C63.6194 50.0494 62.6691 50.9982 61.4958 50.9982H33.8119C32.6397 50.9982 31.6883 50.0494 31.6883 48.8803C31.6883 47.7112 32.6397 46.7624 33.8119 46.7624H61.4958ZM57.6905 36.6967C58.8628 36.6967 59.8142 37.6455 59.8142 38.8146C59.8142 39.9837 58.8628 40.9325 57.6905 40.9325H53.4178C52.2444 40.9325 51.2941 39.9837 51.2941 38.8146C51.2941 37.6455 52.2444 36.6967 53.4178 36.6967H57.6905ZM44.5328 36.6967C45.7051 36.6967 46.6565 37.6455 46.6565 38.8146C46.6565 39.9837 45.7051 40.9325 44.5328 40.9325H21.9266C20.7533 40.9325 19.803 39.9837 19.803 38.8146C19.803 37.6455 20.7533 36.6967 21.9266 36.6967H44.5328ZM150.289 36.4542C151.461 36.4542 152.413 37.403 152.413 38.5721C152.413 39.7412 151.461 40.69 150.289 40.69H138.535C137.361 40.69 136.411 39.7412 136.411 38.5721C136.411 37.403 137.361 36.4542 138.535 36.4542H150.289ZM162.045 36.4542C163.217 36.4542 164.168 37.403 164.168 38.5721C164.168 39.7412 163.217 40.69 162.045 40.69H158.428C157.255 40.69 156.305 39.7412 156.305 38.5721C156.305 37.403 157.255 36.4542 158.428 36.4542H162.045ZM175.876 26.1733C177.049 26.1733 178 27.1222 178 28.2913C178 29.4603 177.049 30.4092 175.876 30.4092H166.769C165.596 30.4092 164.645 29.4603 164.645 28.2913C164.645 27.1222 165.596 26.1733 166.769 26.1733H175.876ZM156.287 26.1733C157.459 26.1733 158.41 27.1222 158.41 28.2913C158.41 29.4603 157.459 30.4092 156.287 30.4092H140.978C139.806 30.4092 138.855 29.4603 138.855 28.2913C138.855 27.1222 139.806 26.1733 140.978 26.1733H156.287Z\" fill=\"#B6C5D5\"/>\n</svg>";

var Avatar = "<svg width=\"70\" height=\"70\" viewBox=\"0 0 70 70\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <defs>\n        <circle id=\"a\" cx=\"35\" cy=\"35\" r=\"35\"/>\n    </defs>\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <mask id=\"b\" fill=\"#fff\">\n            <use xlink:href=\"#a\"/>\n        </mask>\n        <use fill=\"#CCC\" xlink:href=\"#a\"/>\n        <g mask=\"url(#b)\" fill=\"#FFF\">\n            <path d=\"M34.998 40c10.916 0 18.5 6.883 21.002 13.552C50.514 58.79 43.111 62 34.966 62 26.854 62 19.478 58.816 14 53.619 16.473 46.929 24.066 40 34.998 40zM35 15c5.885 0 11 4.617 11 10.849C46 32.156 40.885 37 35 37c-5.913 0-11-4.844-11-11.1C24 19.717 29.115 15 35 15z\"/>\n        </g>\n    </g>\n</svg>";

var Password = "<svg width=\"87\" height=\"58\" viewBox=\"0 0 87 58\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M79.8 36.25a7.2 7.2 0 0 1 7.2 7.2v7.35a7.2 7.2 0 0 1-7.2 7.2H7.2A7.2 7.2 0 0 1 0 50.8v-7.35a7.2 7.2 0 0 1 7.2-7.2h72.6zm-65.746 6.506a1.022 1.022 0 0 0-.424 1.28l.053.106 1.309 2.303h-2.596a1.02 1.02 0 0 0-.11 2.033l.11.006h2.595l-1.308 2.304a1.021 1.021 0 0 0 .37 1.386l.007.003.11.055a.995.995 0 0 0 1.188-.327l.063-.097 1.31-2.305 1.31 2.305.006.011a.994.994 0 0 0 1.36.355c.448-.263.623-.814.424-1.28l-.052-.106-1.31-2.304h2.596a1.02 1.02 0 0 0 .111-2.033l-.11-.006h-2.597l1.31-2.303a1.021 1.021 0 0 0-.383-1.393.995.995 0 0 0-1.293.276l-.063.097-1.31 2.303-1.309-2.303a.993.993 0 0 0-1.367-.366zm13.384 0a1.022 1.022 0 0 0-.423 1.28l.052.106 1.31 2.303H25.78a1.02 1.02 0 0 0-.111 2.033l.111.006h2.595l-1.309 2.304a1.021 1.021 0 0 0 .371 1.386l.006.003.11.055a.995.995 0 0 0 1.189-.327l.063-.097 1.31-2.305 1.309 2.305a.994.994 0 0 0 1.367.366c.448-.263.623-.814.424-1.28l-.052-.106-1.31-2.304h2.596a1.02 1.02 0 0 0 .11-2.033l-.11-.006h-2.596l1.31-2.303a1.022 1.022 0 0 0-.273-1.32l-.099-.066-.115-.058a.995.995 0 0 0-1.189.327l-.063.097-1.31 2.303-1.31-2.303-.006-.011a.994.994 0 0 0-1.36-.355zm13.385 0a1.022 1.022 0 0 0-.424 1.28l.053.106 1.31 2.303h-2.596a1.02 1.02 0 0 0-.111 2.033l.11.006h2.595l-1.308 2.304a1.021 1.021 0 0 0 .371 1.386l.006.003.11.055a.995.995 0 0 0 1.188-.327l.063-.097 1.31-2.305 1.31 2.305.003.005.068.103c.3.397.856.516 1.296.258.448-.263.622-.814.424-1.28l-.053-.106-1.309-2.304h2.595a1.02 1.02 0 0 0 .111-2.033l-.11-.006h-2.597l1.31-2.303a1.021 1.021 0 0 0-.371-1.386l-.006-.004-.11-.054a.995.995 0 0 0-1.188.327l-.063.097-1.31 2.303-1.31-2.303a.993.993 0 0 0-1.367-.366zm13.385 0a1.022 1.022 0 0 0-.424 1.28l.052.106 1.31 2.303H52.55a1.02 1.02 0 0 0-.11 2.033l.11.006h2.595l-1.309 2.304a1.021 1.021 0 0 0 .372 1.386l.005.003.11.055a.995.995 0 0 0 1.189-.327l.063-.097 1.31-2.305 1.31 2.305.006.011a.994.994 0 0 0 1.36.355c.448-.263.623-.814.424-1.28l-.052-.106-1.31-2.304h2.596a1.02 1.02 0 0 0 .111-2.033l-.111-.006h-2.596l1.31-2.303a1.022 1.022 0 0 0-.273-1.32l-.098-.066-.116-.058a.995.995 0 0 0-1.189.327l-.063.097-1.31 2.303-1.309-2.303a.994.994 0 0 0-1.367-.366zm13.384 0a1.022 1.022 0 0 0-.423 1.28l.052.106 1.31 2.303h-2.596a1.02 1.02 0 0 0-.111 2.033l.11.006h2.595l-1.308 2.304a1.021 1.021 0 0 0 .383 1.393.995.995 0 0 0 1.293-.276l.063-.097 1.31-2.305 1.309 2.305.006.011a.994.994 0 0 0 1.361.355c.448-.263.622-.814.424-1.28l-.053-.106-1.309-2.304h2.596a1.02 1.02 0 0 0 .11-2.033l-.11-.006h-2.597l1.31-2.303a1.022 1.022 0 0 0-.272-1.32l-.099-.066-.116-.058a.995.995 0 0 0-1.188.327l-.063.097-1.31 2.303-1.31-2.303-.006-.011a.994.994 0 0 0-1.36-.355zM55.535 18.52c1.877 0 3.423 1.477 3.524 3.32l.005.193v12.606h-13.18l-.889-3.455c1.35-.655 2.275-2 2.275-3.553 0-2.199-1.853-3.98-4.138-3.98-2.286 0-4.139 1.781-4.139 3.98 0 1.344.694 2.532 1.756 3.253l.18.116-.782 3.639h-13.01V22.033c0-1.868 1.484-3.407 3.336-3.508l.193-.005h24.87zM43.101 0c6.658 0 12.094 4.6 12.262 10.311l.004.273v7.25h-3.863v-7.25c0-3.998-3.77-7.25-8.403-7.25-4.545 0-8.258 3.128-8.399 7.02l-.004.23v7.25h-3.864v-7.25C30.834 4.748 36.337 0 43.101 0z\" fill=\"#CCC\" fill-rule=\"evenodd\"/>\n</svg>";

var LogoAndreani = "<svg width=\"192\" height=\"98\" viewBox=\"0 0 192 98\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M80.3381 57L79.9559 55.3321H76.3273L75.4142 57H73L78.0198 48H80.7761L83 57H80.3381ZM79.1777 51.8927C79.0463 51.404 78.9659 50.9032 78.9381 50.3981H78.9067C78.6919 50.949 78.4384 51.4842 78.1478 51.9996L77.1848 53.6907H79.6163L79.1777 51.8927Z\" fill=\"#D0080F\"/>\n<path d=\"M89.6046 57L87.8302 53.1214C87.5427 52.4796 87.2955 51.8193 87.09 51.1448C87.0315 51.8126 86.9214 52.7202 86.7866 53.5726L86.2479 57H84L85.4125 48H88.4091L90.0695 51.5621C90.4016 52.2931 90.6993 53.081 90.95 53.7724C90.9953 52.9998 91.1523 51.8127 91.2875 50.9595L91.751 48.0001H94L92.5876 57H89.6046Z\" fill=\"#D0080F\"/>\n<path d=\"M109.807 57L107.968 53.5045H107.877L107.33 57H105L106.408 48.0656C107.267 48.0139 108.358 48 109.568 48C111.94 48 113.255 48.7539 112.959 50.6462C112.767 51.8504 111.732 52.8313 110.344 53.1214C110.558 53.4672 110.757 53.7963 110.963 54.1265L112.644 57H109.807ZM109.121 49.6939C108.883 49.6939 108.613 49.7077 108.476 49.7205L108.115 52.0102C108.232 52.022 108.469 52.0364 108.694 52.0364C109.678 52.0364 110.378 51.573 110.497 50.819C110.606 50.1168 110.211 49.6939 109.121 49.6939\" fill=\"#D0080F\"/>\n<path d=\"M114 57L115.391 48H121L120.73 49.745H117.425L117.148 51.5326H120.277L120.015 53.2271H116.885L116.58 55.2128H119.884L119.609 57H114Z\" fill=\"#D0080F\"/>\n<path d=\"M128.335 57L127.952 55.3321H124.324L123.413 57H121L126.018 48H128.777L131 57H128.335ZM127.174 51.8927C127.046 51.4033 126.966 50.9028 126.935 50.3981H126.903C126.689 50.9491 126.436 51.4843 126.145 51.9996L125.185 53.6907H127.613L127.174 51.8927Z\" fill=\"#D0080F\"/>\n<path d=\"M137.604 57L135.83 53.1214C135.543 52.4794 135.297 51.8192 135.092 51.1448C135.032 51.8126 134.919 52.7202 134.786 53.5726L134.247 57H132L133.412 48H136.41L138.069 51.5621C138.404 52.2931 138.698 53.081 138.951 53.7724C138.997 52.9998 139.152 51.8127 139.287 50.9595L139.753 48.0001H142L140.586 57H137.604Z\" fill=\"#D0080F\"/>\n<path d=\"M143 57L144.131 48H146L144.87 57H143Z\" fill=\"#D0080F\"/>\n<path d=\"M67.6754 44.2091C67.153 42.8235 66.0196 41.704 64.3987 40.9706C62.8733 40.2792 60.9509 39.947 58.8417 40.0069C54.2189 40.2103 49.7821 41.8871 46.1787 44.7926C44.5571 46.1436 43.3333 47.6636 42.6455 49.1906C41.9112 50.8132 41.8017 52.4031 42.3257 53.7891C43.0977 55.8394 45.1533 57.258 48.1109 57.7816C51.0348 58.3022 54.5032 57.8842 57.8734 56.612C60.0297 55.8094 62.0399 54.6581 63.8239 53.2042C65.4464 51.8555 66.667 50.3319 67.3552 48.8061C67.7658 47.935 67.9856 46.9862 68 46.0232C68.0027 45.4039 67.8927 44.7892 67.6755 44.2092M51.5654 56.2465C51.1419 56.1144 51.0418 55.8095 51.4093 55.1829L53.2941 51.9976H58.4692L58.9206 54.009C58.9542 54.1835 58.9397 54.3639 58.8786 54.5308C58.8174 54.6976 58.712 54.8447 58.5736 54.956C58.4529 55.0046 58.3337 55.0508 58.2142 55.0974C56.0969 55.9214 53.8361 56.3121 51.5654 56.2465M54.0458 50.8241L57.0077 45.9292L58.1865 50.8241H54.0458ZM62.6757 52.6533C62.6145 52.6919 62.545 52.7155 62.473 52.7222C62.4009 52.7289 62.3283 52.7185 62.261 52.6919C62.1937 52.6652 62.1336 52.6231 62.0856 52.5689C62.0377 52.5147 62.0031 52.4499 61.9848 52.3798L59.7775 43.8727C59.7775 43.8727 59.4697 42.3834 58.1663 42.3834H57.8111L55.9586 45.5329L50.0209 55.0204C49.6289 55.6408 49.2105 55.821 48.7836 55.7838C46.9609 55.215 45.602 54.1511 45.0365 52.652C43.6807 49.0616 47.3832 44.3372 53.3046 42.097C59.2261 39.8545 65.1273 40.9488 66.48 44.54C67.4492 47.1054 65.8369 50.2514 62.6759 52.6532\" fill=\"#D0080F\"/>\n<path d=\"M99.6379 48.001C98.5638 47.9939 97.4038 48.0266 96.7809 48.0446L96.4809 48.0509L95 56.9034L95.9166 56.9376C96.5559 56.9632 97.2216 56.9947 98.0808 56.9998C100.011 57.0131 101.59 56.4134 102.648 55.267C103.589 54.2523 104.066 52.8487 103.993 51.3223C103.891 49.201 102.346 48.0199 99.6379 48.0011M98.2501 55.108C98.1028 55.108 97.9108 55.0966 97.7415 55.0813C97.8157 54.6133 98.5257 50.225 98.5803 49.8821C98.8265 49.8711 99.1329 49.8644 99.4942 49.8667C101.262 49.8804 101.537 50.6828 101.575 51.4667C101.634 52.7354 101.018 55.1269 98.2501 55.1081\" fill=\"#D0080F\"/>\n</svg>";

var IllustrationAssets = {
  avatar: Avatar,
  password: Password,
  color_onboarding_1: ColorOnboardingUno,
  color_onboarding_2: ColorOnboardingDos,
  color_onboarding_3: ColorOnboardingTres,
  color_onboarding_4: ColorOnboardingCuatro,
  color_onboarding_5: ColorOnboardingCinco,
  color_pagos_inmediatos_tutorial: ColorPagosInmediatosTutorial,
  color_qr_1: ColorQRUno,
  color_qr_2: ColorQRDos,
  color_qr_3: ColorQRTres,
  color_qr_4: ColorQRCuatro,
  color_qr_5: ColorQRCinco,
  color_qr_6: ColorQRSeis,
  color_terminales_tutor_terminales_1: ColorTerminalesTutorTerminalesUno,
  color_terminales_tutor_terminales_2: ColorTerminalesTutorTerminalesDos,
  color_terminales_tutor_terminales_3: ColorTerminalesTutorTerminalesTres,
  color_terminales_tutor_terminales_4: ColorTerminalesTutorTerminalesCuatro,
  filled_feedback_error: FilledFeedbackError,
  filled_feedback_success: FilledFeedbackSuccess,
  filled_feedback_warning: FilledFeedbackWarning,
  grey_people_error: GreyPeopleError,
  lineal_accionistasysocios_empty: LinealAccionistrasYSociosEmpty,
  lineal_alta_usuario_warning: LinealAltaUsuarioWarning,
  lineal_app_update: LinealAppUpdate,
  lineal_archivo_adjunto: LinealArchivoAdjunto,
  lineal_biometria_default: LinealBiometriaDefault,
  lineal_biometria_warning: LinealBiometriaWarning,
  lineal_btn_de_pago_default: LinealBtnDePagoDefault,
  lineal_btn_de_pago_error: LinealBtnDePagoError,
  lineal_btn_de_pago_no_disponible: LinealBtnDePagoNoDisponible,
  lineal_btn_de_pago_pago_generado: LinealBtnDePagoGenerado,
  lineal_btn_de_pago_sin_generar: LinealBtnDePagoSinGenerar,
  lineal_btn_de_pago_warning: LinealBtnDePagoWarning,
  lineal_calendario_default: LinealCalendarioDefault,
  lineal_calendario_feriado: LinealCalendarioFeriado,
  lineal_cobro_anticipado_desactivar: LinealCobroAnticipadoDesactivar,
  lineal_cobro_anticipado_error: LinealCobroAnticipadoError,
  lineal_cobro_anticipado_sin_generar: LinealCobroAnticipadoSinGenerar,
  lineal_cobro_anticipado_warning: LinealCobroAnticipadoWarning,
  lineal_colaboradores_alta: LinealColaboradoresAlta,
  lineal_direccion_actualizar: LinealDireccionActualizar,
  lineal_direccion_error: LinealDireccionError,
  lineal_dni_dorso: LinealDNIDorso,
  lineal_dni_frente: LinealDNIFrente,
  lineal_establecimientos_empty: LinealEstablecimientosEmpty,
  lineal_establecimientos_warning: LinealEstablecimientosWarning,
  lineal_liquidaciones_documentos_guardados: LinealLiquidacionesDocumentosGuardados,
  lineal_liquidaciones_empty: LinealLiquidacionesEmpty,
  lineal_liquidaciones_error: LinealLiquidacionesError,
  lineal_mail_confirmado: LinealMailConfirmado,
  lineal_mail_creado: LinealMailCreado,
  lineal_mail_warning: LinealMailWarning,
  lineal_notificaciones_empty: LinealNotificacionesEmpty,
  lineal_pagos_inmediatos_default: LinealPagosInmediatosDefault,
  lineal_password_confirm: LinealPasswordConfirm,
  lineal_password_error: LinealPasswordError,
  lineal_password_recuperar: LinealPasswordRecuperar,
  lineal_qr_default: LinealQRDefault,
  lineal_qr_loader: LinealQRLoader,
  lineal_qr_success: LinealQRSucess,
  lineal_qr_warning: LinealQRWarning,
  lineal_sistema_error: LinealSistemaError,
  lineal_sistema_no_results: LinealSistemaNoResults,
  lineal_sistema_not_found: LinealSistemaNotFound,
  lineal_sistema_rate_app: LinealSistemaRateApp,
  lineal_terminal_default: LinealTerminalDefault,
  lineal_terminal_error: LinealTerminalError,
  lineal_terminal_numero: LinealTerminalNumero,
  lineal_time_warning: LinealTimeWarning,
  lineal_usuario_alta_error: LinealUsuarioAltaError,
  lineal_usuario_alta: LinealUsuarioAlta,
  lineal_usuario_cuenta_bloqueada: LinealUsuarioCuentaBloqueada,
  lineal_sesion_expirada: LinealSesionExpirada,
  lineal_documentation_success: LinealDocumentationSuccess,
  logo_andreani: LogoAndreani
};

var Image$1 = function Image$1(_ref) {
  var alt = _ref.alt,
    cursor = _ref.cursor,
    height = _ref.height,
    name = _ref.name,
    width = _ref.width,
    isExternalSrc = _ref.isExternalSrc;
  var ImgSource = _objectSpread2(_objectSpread2({}, BrandAssets), IllustrationAssets);
  var ImageToRender = isExternalSrc ? "".concat(name) : ImgSource["".concat(name)] || false;
  return ImageToRender && /*#__PURE__*/React__default.createElement(Image, {
    cursor: cursor,
    width: width,
    height: height,
    src: ImageToRender,
    alt: alt
  });
};
Image$1.defaultProps = {
  cursor: 'default',
  height: 24,
  width: 32,
  isExternalSrc: false
};
Image$1.propTypes = {
  alt: PropTypes.string.isRequired,
  cursor: PropTypes.oneOf(['not-allowed', 'pointer', 'default', 'none']),
  name: PropTypes.string.isRequired,
  height: PropTypes.number,
  width: PropTypes.number,
  isExternalSrc: PropTypes.bool
};

var Brand = function Brand(_ref) {
  var alt = _ref.alt,
    cursor = _ref.cursor,
    height = _ref.height,
    name = _ref.name,
    width = _ref.width;
  return /*#__PURE__*/React__default.createElement(Image$1, {
    cursor: cursor,
    width: width,
    height: height,
    name: name,
    alt: alt
  });
};
Brand.defaultProps = {
  cursor: 'default',
  height: 24,
  width: 32
};
Brand.propTypes = {
  alt: PropTypes.string.isRequired,
  cursor: PropTypes.oneOf(['not-allowed', 'pointer', 'default', 'none']),
  name: PropTypes.string.isRequired,
  height: PropTypes.number,
  width: PropTypes.number
};

var BrandFormatter = function BrandFormatter(_ref) {
  var cell = _ref.cell,
    formatExtraData = _ref.formatExtraData;
  return cell ? /*#__PURE__*/React__default.createElement(Cell, {
    align: formatExtraData.align
  }, /*#__PURE__*/React__default.createElement(Brand, {
    name: cell,
    alt: cell,
    width: 48,
    height: 32,
    cursor: formatExtraData.clickableRows ? 'pointer' : 'default'
  })) : null;
};

var CheckboxFormatter = function CheckboxFormatter(_ref) {
  var cell = _ref.cell,
    formatExtraData = _ref.formatExtraData;
  return cell ? /*#__PURE__*/React__default.createElement(Cell, {
    align: formatExtraData.align
  }, /*#__PURE__*/React__default.createElement(Checkbox$1, cell, cell.text)) : null;
};

var StatusFormatter = function StatusFormatter(_ref) {
  var cell = _ref.cell,
    formatExtraData = _ref.formatExtraData;
  return cell ? /*#__PURE__*/React__default.createElement(Cell, {
    align: formatExtraData.align
  }, /*#__PURE__*/React__default.createElement(Pill, {
    variant: cell.variant,
    type: "dot"
  }, cell.text)) : null;
};

var _templateObject$B, _templateObject2$u;
var CardNumber = styled.div(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: 'flex-start';\n"])));
var CardNumberSpan = styled(Span)(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteral(["\n  margin-right: ", ";\n"])), theme.spacing['spacing-3']);

var CardNumberFormatter = function CardNumberFormatter(_ref) {
  var cell = _ref.cell,
    formatExtraData = _ref.formatExtraData;
  if (cell) {
    var cardNumber = cell.slice(-8);
    var cardNumberPart1 = cardNumber.slice(0, -4);
    var cardNumberPart2 = cardNumber.slice(-4);
    return /*#__PURE__*/React__default.createElement(CardNumber, null, /*#__PURE__*/React__default.createElement(CardNumberSpan, {
      variant: "neutral",
      modifier: "strong",
      type: "4"
    }, cardNumberPart1), /*#__PURE__*/React__default.createElement(Span$1, {
      variant: "neutral",
      modifier: "strong",
      type: "4"
    }, cardNumberPart2));
  }
  return null;
};

var _defs$2, _circle$1, _animateTransform;
function _extends$7k() { _extends$7k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7k.apply(this, arguments); }
var SvgSpinnerPrimary = function SvgSpinnerPrimary(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7k({
    width: 40,
    height: 40,
    viewBox: "0 0 48 48",
    color: "#023F80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs$2 || (_defs$2 = /*#__PURE__*/createElement$2("defs", null, /*#__PURE__*/createElement$2("linearGradient", {
    id: "spinner-primary_svg__a",
    y2: 1,
    x2: 0
  }, /*#__PURE__*/createElement$2("stop", {
    offset: 0,
    stopColor: "currentColor",
    stopOpacity: 0.3
  }), /*#__PURE__*/createElement$2("stop", {
    offset: "100%",
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/createElement$2("linearGradient", {
    id: "spinner-primary_svg__b",
    y2: 1,
    x2: 0
  }, /*#__PURE__*/createElement$2("stop", {
    offset: "10%",
    stopColor: "currentColor",
    stopOpacity: 0
  }), /*#__PURE__*/createElement$2("stop", {
    offset: "100%",
    stopColor: "currentColor"
  })), /*#__PURE__*/createElement$2("pattern", {
    id: "spinner-primary_svg__c",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/createElement$2("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#spinner-primary_svg__a)"
  }), /*#__PURE__*/createElement$2("rect", {
    x: "-50%",
    width: "100%",
    height: "100%",
    fill: "url(#spinner-primary_svg__b)"
  })))), _circle$1 || (_circle$1 = /*#__PURE__*/createElement$2("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    strokeWidth: 4,
    stroke: "url(#spinner-primary_svg__c)"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/createElement$2("animateTransform", {
    from: "360 0 0",
    to: "0 0 0",
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "2000ms"
  })));
};

var _defs$3, _circle$2, _animateTransform$1;
function _extends$7l() { _extends$7l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7l.apply(this, arguments); }
var SvgSpinnerNeutral = function SvgSpinnerNeutral(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7l({
    width: 40,
    height: 40,
    viewBox: "0 0 48 48",
    color: "#fff",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs$3 || (_defs$3 = /*#__PURE__*/createElement$2("defs", null, /*#__PURE__*/createElement$2("linearGradient", {
    id: "spinner-neutral_svg__a",
    y2: 1,
    x2: 0
  }, /*#__PURE__*/createElement$2("stop", {
    offset: 0,
    stopColor: "currentColor",
    stopOpacity: 0.3
  }), /*#__PURE__*/createElement$2("stop", {
    offset: "100%",
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/createElement$2("linearGradient", {
    id: "spinner-neutral_svg__b",
    y2: 1,
    x2: 0
  }, /*#__PURE__*/createElement$2("stop", {
    offset: "10%",
    stopColor: "currentColor",
    stopOpacity: 0
  }), /*#__PURE__*/createElement$2("stop", {
    offset: "100%",
    stopColor: "currentColor"
  })), /*#__PURE__*/createElement$2("pattern", {
    id: "spinner-neutral_svg__c",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/createElement$2("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#spinner-neutral_svg__a)"
  }), /*#__PURE__*/createElement$2("rect", {
    x: "-50%",
    width: "100%",
    height: "100%",
    fill: "url(#spinner-neutral_svg__b)"
  })))), _circle$2 || (_circle$2 = /*#__PURE__*/createElement$2("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    strokeWidth: 4,
    stroke: "url(#spinner-neutral_svg__c)"
  })), _animateTransform$1 || (_animateTransform$1 = /*#__PURE__*/createElement$2("animateTransform", {
    from: "360 0 0",
    to: "0 0 0",
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "2000ms"
  })));
};

var SpinnerSource = {
  primary: SvgSpinnerPrimary,
  neutral: SvgSpinnerNeutral
};

var Spinner = function Spinner(_ref) {
  var size = _ref.size,
    variant = _ref.variant;
  var CurrentSpinner = SpinnerSource["".concat(variant)] || SpinnerSource['primary'];
  var spinnerSize = {
    sm: {
      width: 24,
      height: 24
    },
    md: {
      width: 48,
      height: 48
    }
  };
  return /*#__PURE__*/React__default.createElement(CurrentSpinner, spinnerSize[size] || spinnerSize.md);
};
Spinner.defaultProps = {
  size: 'md',
  variant: 'primary'
};
Spinner.propTypes = {
  size: PropTypes.oneOf(['md', 'sm']),
  variant: PropTypes.oneOf(['primary', 'neutral'])
};

var IconActionFormatter = function IconActionFormatter(_ref) {
  var cell = _ref.cell,
    row = _ref.row,
    _ref$formatExtraData = _ref.formatExtraData,
    _ref$formatExtraData$ = _ref$formatExtraData.action,
    action = _ref$formatExtraData$ === void 0 ? function () {} : _ref$formatExtraData$,
    align = _ref$formatExtraData.align,
    icon = _ref$formatExtraData.icon,
    label = _ref$formatExtraData.label;
  var handleOnClick = function handleOnClick(event) {
    event.stopPropagation();
    event.preventDefault();
    !cell.disabled && action(row);
  };
  if (cell) {
    return cell.loading ? /*#__PURE__*/React__default.createElement(Spinner, {
      size: "sm",
      variant: "primary"
    }) : /*#__PURE__*/React__default.createElement(Cell, {
      align: align,
      cursor: cell.disabled ? 'default' : 'pointer',
      onClick: handleOnClick
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      alt: "",
      name: icon.name,
      width: icon === null || icon === void 0 ? void 0 : icon.width,
      height: icon === null || icon === void 0 ? void 0 : icon.height,
      variant: cell.disabled ? 'neutral' : 'primary',
      cursor: cell.disabled ? 'default' : 'pointer'
    }), label && /*#__PURE__*/React__default.createElement(Span$1, {
      type: "2",
      variant: cell.disabled ? 'neutral' : 'primary'
    }, label));
  } else return null;
};

var formatters = {
  AmountFormatter: function AmountFormatter$1(cell, row, rowIndex, formatExtraData) {
    return /*#__PURE__*/React__default.createElement(AmountFormatter, {
      cell: cell,
      formatExtraData: formatExtraData
    });
  },
  DateFormatter: function DateFormatter$1(cell, row, rowIndex, formatExtraData) {
    return /*#__PURE__*/React__default.createElement(DateFormatter, {
      cell: cell,
      formatExtraData: formatExtraData
    });
  },
  IdNumberFormatter: function IdNumberFormatter$1(cell, row, rowIndex, formatExtraData) {
    return /*#__PURE__*/React__default.createElement(IdNumberFormatter, {
      cell: cell,
      row: row,
      formatExtraData: formatExtraData
    });
  },
  DescriptionFormatter: function DescriptionFormatter$1(cell, row, rowIndex, formatExtraData) {
    return /*#__PURE__*/React__default.createElement(DescriptionFormatter, {
      cell: cell,
      formatExtraData: formatExtraData
    });
  },
  HeaderFormatter: function HeaderFormatter$1(column, colIndex, components) {
    return /*#__PURE__*/React__default.createElement(HeaderFormatter, {
      column: column
    });
  },
  NumberFormatter: function NumberFormatter$1(cell, row, rowIndex, formatExtraData) {
    return /*#__PURE__*/React__default.createElement(NumberFormatter, {
      cell: cell,
      formatExtraData: formatExtraData
    });
  },
  ButtonFormatter: function ButtonFormatter$1(cell, row, rowIndex, formatExtraData) {
    return /*#__PURE__*/React__default.createElement(ButtonFormatter, {
      cell: cell,
      formatExtraData: formatExtraData
    });
  },
  ToggleFormatter: function ToggleFormatter$1(cell, row, rowIndex, formatExtraData) {
    return /*#__PURE__*/React__default.createElement(ToggleFormatter, {
      cell: cell,
      formatExtraData: formatExtraData
    });
  },
  BrandFormatter: function BrandFormatter$1(cell, row, rowIndex, formatExtraData) {
    return /*#__PURE__*/React__default.createElement(BrandFormatter, {
      cell: cell,
      formatExtraData: formatExtraData
    });
  },
  CheckboxFormatter: function CheckboxFormatter$1(cell, row, rowIndex, formatExtraData) {
    return /*#__PURE__*/React__default.createElement(CheckboxFormatter, {
      cell: cell,
      formatExtraData: formatExtraData
    });
  },
  StatusFormatter: function StatusFormatter$1(cell, row, rowIndex, formatExtraData) {
    return /*#__PURE__*/React__default.createElement(StatusFormatter, {
      cell: cell,
      formatExtraData: formatExtraData
    });
  },
  CardNumberFormatter: function CardNumberFormatter$1(cell, row, rowIndex, formatExtraData) {
    return /*#__PURE__*/React__default.createElement(CardNumberFormatter, {
      cell: cell,
      formatExtraData: formatExtraData
    });
  },
  IconActionFormatter: function IconActionFormatter$1(cell, row, rowIndex, formatExtraData) {
    return /*#__PURE__*/React__default.createElement(IconActionFormatter, {
      cell: cell,
      row: row,
      formatExtraData: formatExtraData
    });
  }
};
var cellAligns = {
  AmountFormatter: 'right',
  IdNumberFormatter: 'left',
  DateFormatter: 'left',
  DescriptionFormatter: 'left',
  NumberFormatter: 'center',
  ButtonFormatter: 'center',
  ToggleFormatter: 'center',
  BrandFormatter: 'center',
  CheckboxFormatter: 'center',
  StatusFormatter: 'center',
  CardNumberFormatter: 'left',
  IconActionFormatter: 'center'
};
var columnsFormatter = function columnsFormatter(_ref) {
  var columns = _ref.columns,
    clickableRows = _ref.clickableRows;
  return columns.map(function (column) {
    return formatters[column.formatter] !== undefined ? _objectSpread2(_objectSpread2({}, column), {}, {
      align: cellAligns[column.formatter],
      formatter: formatters[column.formatter],
      formatExtraData: _objectSpread2(_objectSpread2({}, column.formatExtraData), {}, {
        align: cellAligns[column.formatter],
        clickableRows: clickableRows
      }),
      headerAlign: cellAligns[column.formatter],
      headerFormatter: formatters['HeaderFormatter']
    }) : _objectSpread2(_objectSpread2({}, column), {}, {
      headerFormatter: formatters['HeaderFormatter']
    });
  });
};

var _templateObject$C, _templateObject2$v, _templateObject3$o, _templateObject4$j;
var TableFooter = styled.div(_templateObject$C || (_templateObject$C = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: ", ";\n  border-radius: 0px 0px ", "\n    ", ";\n  padding: ", " ", ";\n  margin-bottom: ", ";\n"])), theme.colors.neutral.bg.regular, theme.borderRadius['border-radius-4'], theme.borderRadius['border-radius-4'], theme.spacing['spacing-4'], theme.spacing['spacing-7'], theme.spacing['spacing-3']);
var LeftContent = styled.div(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteral(["\n  span {\n    margin-right: ", ";\n  }\n"])), theme.spacing['spacing-9']);
var RightContent = styled.div(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteral([""])));
var TableCheckbox = styled.div(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"])));

var createElement = function createElement(id, targetElementContainer) {
  var element = targetElementContainer.querySelector("#".concat(id));
  if (targetElementContainer) {
    if (!element) {
      element = document.createElement('div');
      element.setAttribute('id', id);
    }
    targetElementContainer.appendChild(element);
  }
  return element;
};
var TableFooter$1 = function TableFooter$1(_ref) {
  var countSelected = _ref.countSelected,
    maxSelected = _ref.maxSelected,
    itemsCurrent = _ref.itemsCurrent,
    onClick = _ref.onClick,
    icon = _ref.icon,
    text = _ref.text,
    items = _ref.items,
    onClear = _ref.onClear,
    proxyOnClear = _ref.proxyOnClear;
  var handleClick = function handleClick() {
    !!onClick && onClick(items);
  };
  var handleClear = function handleClear() {
    !!proxyOnClear && proxyOnClear();
    !!onClear && onClear(itemsCurrent);
  };
  return !!countSelected && /*#__PURE__*/React__default.createElement(TableFooter, null, /*#__PURE__*/React__default.createElement(LeftContent, null, maxSelected ? /*#__PURE__*/React__default.createElement(Span$1, {
    type: "2",
    variant: "neutral",
    modifier: "strong"
  }, countSelected, " de ", maxSelected, " seleccionados") : /*#__PURE__*/React__default.createElement(Span$1, {
    type: "2",
    variant: "neutral",
    modifier: "strong"
  }, countSelected, " seleccionado", countSelected > 1 && "s"), /*#__PURE__*/React__default.createElement(Link$1, {
    type: "2",
    variant: "primary",
    onClick: handleClear
  }, "Limpiar selecci\xF3n")), /*#__PURE__*/React__default.createElement(RightContent, null, !!text && /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "primary",
    size: "md",
    onClick: handleClick,
    icon: icon ? icon : 'download_outline',
    iconAlign: "right"
  }, text)));
};
var useTableSelectRow = function useTableSelectRow(_ref2) {
  var sizePerPage = _ref2.sizePerPage,
    selectRow = _ref2.selectRow,
    pageActive = _ref2.pageActive,
    data = _ref2.data;
  var _ref3 = selectRow || {},
    _ref3$maxSelected = _ref3.maxSelected,
    maxSelected = _ref3$maxSelected === void 0 ? false : _ref3$maxSelected,
    selectedList = _ref3.selectedList,
    nonSelectableChecked = _ref3.nonSelectableChecked,
    _ref3$labelAction = _ref3.labelAction,
    labelAction = _ref3$labelAction === void 0 ? {} : _ref3$labelAction,
    onSelect = _ref3.onSelect,
    onSelectAll = _ref3.onSelectAll;
  var _useState = useState({
      selecteds: [],
      disableds: [],
      disabledSelecteds: [],
      selectedsIndex: [],
      disabledsIndex: []
    }),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var _useState3 = useState(pageActive),
    _useState4 = _slicedToArray(_useState3, 2),
    pageSelectRow = _useState4[0],
    setPageSelectRow = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isMaxSelectable = _useState6[0],
    setIsMaxSelectable = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    refTable = _useState8[0],
    setRefTable = _useState8[1];
  var tableSelectRow = selectRow ? _objectSpread2(_objectSpread2({}, selectRow), {}, {
    mode: 'checkbox',
    headerColumnStyle: {
      width: '78px'
    },
    selectionRenderer: function selectionRenderer(_ref4) {
      var checked = _ref4.checked,
        disabled = _ref4.disabled;
      return /*#__PURE__*/React__default.createElement(TableCheckbox, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
        checked: checked,
        disabled: disabled
      }));
    },
    selectionHeaderRenderer: function selectionHeaderRenderer(_ref5) {
      var checked = _ref5.checked,
        indeterminate = _ref5.indeterminate;
      return /*#__PURE__*/React__default.createElement(TableCheckbox, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
        checked: checked || indeterminate,
        disabled: isMaxSelectable,
        isSelectAllCheck: indeterminate
      }));
    },
    onSelect: function onSelect(row, isSelect) {
      handleSelectRow({
        row: row,
        isSelect: isSelect
      });
    },
    onSelectAll: function onSelectAll(isSelect, rows, _) {
      rows && handleSelectAllRow({
        rows: rows,
        isSelect: isSelect
      });
    },
    selected: items.selectedsIndex,
    nonSelectable: items.disabledsIndex
  }) : undefined;
  var getIndexRows = useCallback(function (rows) {
    return (rows || []).map(function (row) {
      return row === null || row === void 0 ? void 0 : row.index;
    }) || [];
  });
  var getArrayNumber = useCallback(function (_ref6) {
    var min = _ref6.min,
      max = _ref6.max;
    return Array.apply(null, {
      length: max
    }).map(Number.call, Number).slice(min).filter(function (index) {
      return !getIndexRows(items.selecteds).includes(index);
    });
  });
  var getItemsDisabledMax = function getItemsDisabledMax() {
    var min = parseInt(pageSelectRow - 1) * sizePerPage;
    var max = parseInt(pageSelectRow - 1) * sizePerPage + sizePerPage;
    return getArrayNumber({
      min: min,
      max: max
    });
  };
  var getItemsCurrent = function getItemsCurrent() {
    var min = parseInt(pageSelectRow - 1) * sizePerPage;
    var max = parseInt(pageSelectRow - 1) * sizePerPage + sizePerPage;
    return ((items === null || items === void 0 ? void 0 : items.selecteds) || []).filter(function (item) {
      return (item === null || item === void 0 ? void 0 : item.index) >= min && (item === null || item === void 0 ? void 0 : item.index) < max;
    });
  };
  var onClear = function onClear() {
    return setItems(function (items) {
      return _objectSpread2(_objectSpread2({}, items), {}, {
        selecteds: [],
        selectedsIndex: []
      });
    });
  };
  var handleSelectRow = useCallback(function (_ref7) {
    var row = _ref7.row,
      isSelect = _ref7.isSelect;
    var selecteds = items.selecteds.filter(function (current) {
      return row.index !== current.index;
    });
    var rowSelecteds = isSelect ? [].concat(_toConsumableArray(selecteds), [row]) : _toConsumableArray(selecteds);
    setItems(function (items) {
      return _objectSpread2(_objectSpread2({}, items), {}, {
        selecteds: rowSelecteds
      });
    });
    onSelect && onSelect(rowSelecteds);
  });
  var handleSelectAllRow = useCallback(function (_ref8) {
    var rows = _ref8.rows,
      isSelect = _ref8.isSelect;
    var hasDisabledSelecteds = items.disabledSelecteds.length && !items.selecteds.length;
    isSelect = hasDisabledSelecteds || isSelect;
    rows = hasDisabledSelecteds ? data.filter(function (row) {
      var disabledSelecteds = items.disabledSelecteds.find(function (item) {
        return row.index === item.index;
      });
      return !disabledSelecteds && row;
    }) : rows;
    var selecteds = items.selecteds.filter(function (current) {
      return !(getIndexRows(rows) || []).includes(current.index);
    });
    var resetSelecteds = rows.filter(function (_, index) {
      return items.selecteds.length + index + 1 <= maxSelected;
    });
    var rowSelecteds = isSelect ? [].concat(_toConsumableArray(selecteds), _toConsumableArray(resetSelecteds)) : _toConsumableArray(selecteds);
    setItems(function (items) {
      return _objectSpread2(_objectSpread2({}, items), {}, {
        selecteds: rowSelecteds
      });
    });
    onSelectAll && onSelectAll(rowSelecteds);
  });
  useEffect(function () {
    maxSelected && setIsMaxSelectable(maxSelected <= items.selecteds.length);
  }, [items.selecteds]);
  useEffect(function () {
    setItems(function (items) {
      return _objectSpread2(_objectSpread2({}, items), {}, {
        disableds: isMaxSelectable ? getItemsDisabledMax() : []
      });
    });
  }, [isMaxSelectable, pageSelectRow]);
  useEffect(function () {
    if (!!nonSelectableChecked || !!selectedList) {
      setItems(function (items) {
        return _objectSpread2(_objectSpread2({}, items), {}, {
          disabledSelecteds: nonSelectableChecked,
          selecteds: selectedList
        });
      });
    }
  }, [nonSelectableChecked, selectedList]);
  useEffect(function () {
    if (refTable) {
      ReactDOM.render( /*#__PURE__*/React__default.createElement(React__default.StrictMode, null, /*#__PURE__*/React__default.createElement(TableFooter$1, _extends({
        isMaxSelectable: isMaxSelectable,
        maxSelected: maxSelected,
        countSelected: items.selecteds.length,
        items: items.selecteds,
        proxyOnClear: onClear,
        itemsCurrent: getItemsCurrent()
      }, labelAction))), createElement('react-bootstrap-table-footer', refTable.querySelector('.react-bootstrap-table')));
    }
  }, [refTable, isMaxSelectable, items.selecteds]);
  useEffect(function () {
    setItems(function (items) {
      return _objectSpread2(_objectSpread2({}, items), {}, {
        selectedsIndex: getIndexRows([].concat(_toConsumableArray(items.selecteds), _toConsumableArray(items.disabledSelecteds)))
      });
    });
  }, [items.selecteds, items.disabledSelecteds]);
  useEffect(function () {
    var disabledsIndex = getIndexRows(items.disabledSelecteds);
    setItems(function (items) {
      return _objectSpread2(_objectSpread2({}, items), {}, {
        disabledsIndex: [].concat(_toConsumableArray(items.disableds), _toConsumableArray(disabledsIndex))
      });
    });
  }, [items.disableds, items.disabledSelecteds, isMaxSelectable]);
  return [tableSelectRow, setPageSelectRow, setRefTable];
};

var paginationOptions = function paginationOptions(totalElements, onPageChange, active, sizePerPage) {
  return {
    pageStartIndex: 1,
    page: active,
    sizePerPage: sizePerPage,
    totalSize: totalElements,
    // Total data size. It's necessary when remote is enabled
    showTotal: true,
    firstPageText: '|<',
    // the text of first page button
    prePageText: '<',
    // the text of previous page button
    nextPageText: '>',
    // the text of next page button
    lastPageText: '>|',
    // the text of last page button
    withFirstAndLast: true,
    // hide the going to first and last page button
    alwaysShowAllBtns: true,
    // always show the next and previous page button
    hideSizePerPage: true,
    // hide the size per page dropdown
    hidePageListOnlyOnePage: true,
    // hide pagination bar when only one page, default is false
    disablePageTitle: true,
    onPageChange: onPageChange,
    paginationTotalRenderer: function pagination(from, to, size) {
      return /*#__PURE__*/React__default.createElement("span", {
        className: "pagination__total"
      }, from, " - ", to, " de ", size);
    },
    pageListRenderer: pageListRenderer
  };
};
var isALongPaginationNumber = function isALongPaginationNumber(page) {
  return !Number.isNaN(Number(page)) && page.toString().length > 2;
};
var activeClass = function activeClass(page) {
  return isALongPaginationNumber(page.page) ? 'page--active-pill' : 'page--active';
};
var pageListRenderer = function pageListRenderer(_ref) {
  var pages = _ref.pages,
    onPageChange = _ref.onPageChange;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "pagination__list-of-buttons"
  }, pages.map(function (page) {
    return /*#__PURE__*/React__default.createElement("button", {
      key: page.page,
      className: "pagination-list-of-buttons__button\n                          ".concat(page.active ? activeClass(page) : '', "\n                          ").concat(page.disabled ? ' disabled' : ''),
      onClick: function onClick() {
        return onPageChange(page.page);
      }
    }, page.page);
  }));
};
var Table$1 = function Table$1(_ref2) {
  var dataListContent = _ref2.dataListContent,
    columns = _ref2.columns,
    totalElements = _ref2.totalElements,
    onPageChange = _ref2.onPageChange,
    pageActive = _ref2.pageActive,
    noDataIndication = _ref2.noDataIndication,
    _ref2$remote = _ref2.remote,
    remote = _ref2$remote === void 0 ? {} : _ref2$remote,
    _ref2$sizePerPage = _ref2.sizePerPage,
    sizePerPage = _ref2$sizePerPage === void 0 ? 10 : _ref2$sizePerPage,
    _ref2$clickableRows = _ref2.clickableRows,
    clickableRows = _ref2$clickableRows === void 0 ? false : _ref2$clickableRows,
    _ref2$defaultSorted = _ref2.defaultSorted,
    defaultSorted = _ref2$defaultSorted === void 0 ? [] : _ref2$defaultSorted,
    _ref2$headerClasses = _ref2.headerClasses,
    headerClasses = _ref2$headerClasses === void 0 ? 'headerClasses' : _ref2$headerClasses,
    _ref2$rowEvents = _ref2.rowEvents,
    rowEvents = _ref2$rowEvents === void 0 ? {} : _ref2$rowEvents,
    _ref2$wrapperClasses = _ref2.wrapperClasses,
    wrapperClasses = _ref2$wrapperClasses === void 0 ? '' : _ref2$wrapperClasses,
    _ref2$selectRow = _ref2.selectRow,
    selectRow = _ref2$selectRow === void 0 ? false : _ref2$selectRow,
    scroll = _ref2.scroll,
    _ref2$hasPagination = _ref2.hasPagination,
    hasPagination = _ref2$hasPagination === void 0 ? true : _ref2$hasPagination;
  var refTable = useRef(null);
  var columnsFormatted = columnsFormatter({
    columns: columns,
    clickableRows: clickableRows
  });
  var currentIndex = useCallback(function (index) {
    return parseInt(pageActive - 1) * sizePerPage + index;
  });
  var data = (dataListContent || []).map(function (item, index) {
    return _objectSpread2(_objectSpread2({}, item), {}, {
      index: currentIndex(index)
    });
  });
  var _useTableSelectRow = useTableSelectRow({
      selectRow: selectRow,
      sizePerPage: sizePerPage,
      pageActive: pageActive,
      data: data
    }),
    _useTableSelectRow2 = _slicedToArray(_useTableSelectRow, 3),
    tableSelectRow = _useTableSelectRow2[0],
    setPageSelectRow = _useTableSelectRow2[1],
    setRefTable = _useTableSelectRow2[2];
  useEffect(function () {
    if (selectRow && refTable !== null && refTable !== void 0 && refTable.current) setRefTable(refTable.current);
  }, [selectRow, setRefTable]);
  return /*#__PURE__*/React__default.createElement(Table, {
    clickableRows: clickableRows,
    ref: refTable,
    scroll: scroll
  }, /*#__PURE__*/React__default.createElement(ToolkitProvider, {
    keyField: "index",
    data: data,
    columns: columnsFormatted,
    search: true
  }, function (props) {
    return /*#__PURE__*/React__default.createElement(BootstrapTable, _extends({
      pagination: hasPagination && paginationFactory(paginationOptions(totalElements, function (page, size) {
        return onPageChange(page, size) & setPageSelectRow(page);
      }, pageActive, sizePerPage)),
      remote: remote,
      onTableChange: function onTableChange(e) {
        return e;
      },
      bordered: false,
      defaultSorted: defaultSorted
    }, props.baseProps, {
      hover: true,
      noDataIndication: noDataIndication(),
      headerClasses: headerClasses,
      rowEvents: rowEvents,
      wrapperClasses: wrapperClasses,
      selectRow: tableSelectRow
    }));
  }));
};
Table$1.propTypes = {
  dataListContent: PropTypes.array,
  columns: PropTypes.array.isRequired,
  totalElements: PropTypes.number,
  onPageChange: PropTypes.func,
  pageActive: PropTypes.number.isRequired,
  noDataIndication: PropTypes.func.isRequired,
  remote: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    pagination: PropTypes.bool,
    filter: PropTypes.bool,
    sort: PropTypes.bool,
    cellEdit: PropTypes.bool,
    search: PropTypes.bool
  })]),
  sizePerPage: PropTypes.number,
  clickableRows: PropTypes.bool,
  defaultSorted: PropTypes.array,
  headerClasses: PropTypes.string,
  rowEvents: PropTypes.func,
  wrapperClasses: PropTypes.string,
  selectRow: PropTypes.bool,
  scroll: PropTypes.bool,
  hasPagination: PropTypes.bool
};

var _templateObject$D, _templateObject2$w, _templateObject3$p;
var TabGroup = styled(Flex)(_templateObject$D || (_templateObject$D = _taggedTemplateLiteral(["\n  height: 40px;\n  color: ", ";\n"])), theme.colors.neutral.text.strong);
var TabGroupTab = styled(Flex)(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteral(["\n  cursor: pointer;\n  text-align: center;\n  text-transform: none;\n  color: ", ";\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  outline: none;\n  position: relative;\n  align-items: center;\n  box-shadow: 0 1px 0 0 ", ";\n  &:hover {\n    color: ", ";\n    box-shadow: 0 1px 0 0 ", ";\n    background: ", ";\n  }\n  ", "\n"])), theme.colors.neutral.text.regular, theme.colors.neutral.border.weak, theme.colors.neutral.text.strong, theme.colors.neutral.border.strong, theme.colors.neutral.bg.regular, function (_ref) {
  var active = _ref.active;
  return active && "color: ".concat(theme.colors['secondary-1'].text.strong, ";\n     box-shadow: 0 1px 0 0  ").concat(theme.colors['secondary-1'].border.regular, ";\n     background: ").concat(theme.colors.neutral.bg.weak, ";\n    ");
});
var TabGroupTabTitle = styled.div(_templateObject3$p || (_templateObject3$p = _taggedTemplateLiteral(["\n  ", "\n  display: flex;\n  align-items: center;\n  padding-left: ", ";\n  padding-right: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  > * {\n    margin-left: ", ";\n  }\n"])), theme.textStyles['text-preset-9'](), theme.spacing['spacing-5'], theme.spacing['spacing-5'], theme.spacing['spacing-3'], theme.spacing['spacing-3'], theme.spacing['spacing-2']);

var useWindowLocation = function useWindowLocation() {
  var _useState = useState(window.location.pathname),
    _useState2 = _slicedToArray(_useState, 2),
    path = _useState2[0],
    setPath = _useState2[1];
  var _useState3 = useState(window.location.hash),
    _useState4 = _slicedToArray(_useState3, 2),
    hash = _useState4[0],
    setHash = _useState4[1];
  var listenToPopstate = function listenToPopstate() {
    setPath(window.location.pathname);
    setHash(window.location.hash);
  };
  useEffect(function () {
    window.addEventListener('popstate', listenToPopstate);
    return function () {
      window.removeEventListener('popstate', listenToPopstate);
    };
  }, []);
  return [path, hash];
};
var TabsGroup = function TabsGroup(_ref) {
  var tabs = _ref.tabs,
    onClick = _ref.onClick;
  var handleClick = function handleClick(event) {
    var index = event.currentTarget.getAttribute('data-index');
    onClick(tabs[index].path);
  };
  var shouldShowMe = function shouldShowMe(_ref2) {
    var show = _ref2.show;
    return show === undefined ? true : show;
  };
  var _useWindowLocation = useWindowLocation(),
    _useWindowLocation2 = _slicedToArray(_useWindowLocation, 2),
    locationPathName = _useWindowLocation2[0],
    locationHash = _useWindowLocation2[1];
  return /*#__PURE__*/React__default.createElement(TabGroup, null, tabs.map(function (tab, index) {
    return shouldShowMe(tab) && /*#__PURE__*/React__default.createElement(TabGroupTab, {
      key: index,
      "data-index": index,
      active: tab.path === locationPathName || tab.path === locationHash,
      onClick: handleClick
    }, /*#__PURE__*/React__default.createElement(TabGroupTabTitle, null, tab.label));
  }));
};
TabsGroup.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    show: PropTypes.bool
  })).isRequired,
  onClick: PropTypes.func
};

var css_248z$9 = ":root {\n  --primary-text: #023F80;\n  --primary-text-strong: #002A55;\n  --primary-text-weak: #0A7FE4;\n  --primary-bg: #023F80;\n  --primary-bg-strong: #002A55;\n  --primary-bg-weak: #D8EBFF;\n  --primary-border: #023F80;\n  --primary-border-strong: #002A55;\n  --primary-border-weak: #479EF8;\n  --primary-ic: #023F80;\n  --primary-ic-strong: #002A55;\n  --primary-ic-weak: #0A7FE4;\n  --secondary-1-text: #1AAAAD;\n  --secondary-1-text-strong: #076568;\n  --secondary-1-text-weak: #71D7D9;\n  --secondary-1-bg: #1AAAAD;\n  --secondary-1-bg-strong: #137F82;\n  --secondary-1-bg-weak: #E0FBFD;\n  --secondary-1-border: #1AAAAD;\n  --secondary-1-border-strong: #137F82;\n  --secondary-1-border-weak: #71D7D9;\n  --secondary-1-ic: #1AAAAD;\n  --secondary-1-ic-strong: #137F82;\n  --secondary-1-ic-weak: #71D7D9;\n  --secondary-2-text: #DD2457;\n  --secondary-2-text-strong: #921034;\n  --secondary-2-text-weak: #FF95B3;\n  --secondary-2-bg: #DD2457;\n  --secondary-2-bg-strong: #B11E47;\n  --secondary-2-bg-weak: #FF95B3;\n  --secondary-2-border: #DD2457;\n  --secondary-2-border-strong: #B11E47;\n  --secondary-2-border-weak: #FF95B3;\n  --secondary-2-ic: #DD2457;\n  --secondary-2-ic-strong: #B11E47;\n  --secondary-2-ic-weak: #FF95B3;\n  --secondary-3-bg: #FECF2F;\n  --secondary-3-bg-strong: #FFA53F;\n  --secondary-3-bg-weak: #FFF0BD;\n  --secondary-3-border: #FECF2F;\n  --secondary-3-border-strong: #FFA53F;\n  --secondary-3-border-weak: #FFF0BD;\n  --secondary-3-ic: #FECF2F;\n  --secondary-3-ic-strong: #FFA53F;\n  --secondary-3-ic-weak: #FFF0BD;\n  --neutral-text: #647180;\n  --neutral-text-strong: #373E45;\n  --neutral-text-weak: #B6C5D5;\n  --neutral-text-inverted: #FFFFFF;\n  --neutral-bg: #F0F5FB;\n  --neutral-bg-strong: #EAF1F8;\n  --neutral-bg-stronger: #B6C5D5;\n  --neutral-bg-weak: #FFFFFF;\n  --neutral-bg-inverted:#373E45;\n  --neutral-border: #B6C5D5;\n  --neutral-border-strong: #647180;\n  --neutral-border-weak: #DEE8F3;\n  --neutral-ic: #647180;\n  --neutral-ic-strong: #373E45;\n  --neutral-ic-weak: #B6C5D5;\n  --neutral-ic-inverted: #FFFFFF;\n  --danger-text: #DD2457;\n  --danger-text-strong: #921034;\n  --danger-text-weak: #FF95B3;\n  --danger-bg:#DD2457;\n  --danger-bg-strong:#B11E47;\n  --danger-bg-weak: #FFF0F4;\n  --danger-border: #DD2457;\n  --danger-border-strong: #B11E47;\n  --danger-ic: #DD2457;\n  --warning-text: #623311;\n  --warning-bg: #FECF2F;\n  --warning-bg-strong: #FFA53F;\n  --warning-bg-weak: #FFF4CD;\n  --warning-border: #FECF2F;\n  --warning-border-strong: #FFA53F;\n  --warning-ic: #FFA53F;\n  --info-text:#023F80;\n  --info-bg: #479EF8;\n  --info-bg-strong: #023F80;\n  --info-bg-weak: #D8EBFF;\n  --info-border: #479EF8;\n  --info-border-strong: #023F80;\n  --info-ic: #479EF8;\n  --success-text: #035456;\n  --success-bg: #1AAAAD;\n  --success-bg-strong: #137F82;\n  --success-bg-weak: #E0FBFD;\n  --success-border: #1AAAAD;\n  --success-border-strong: #137F82;\n  --success-border-weak: #71D7D9;\n  --success-ic: #1AAAAD; }\n\n.rsg--content-3 {\n  max-width: none;\n  padding: 0;\n  margin: auto;\n  background-color: #f5f5f5; }\n\ndiv[class*='rsg--preview-'] {\n  padding: 0;\n  border: none; }\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box; }\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nlabel {\n  font-weight: normal;\n  margin: 0; }\n\ncode[class*='rsg--code-'] {\n  color: darkgreen;\n  font-size: 14px; }\n\n.selectable-image-component {\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none; }\n  .selectable-image-component .selectable-image-component__title {\n    flex-basis: 100%;\n    margin: 0 0 18px 10px;\n    font-size: 11px;\n    color: var(--neutral-border-strong); }\n  .selectable-image-component .selectable-image-component__input {\n    opacity: 0;\n    cursor: pointer;\n    position: absolute;\n    z-index: 999; }\n    .selectable-image-component .selectable-image-component__input:hover ~ .selectable-image-component__label {\n      border: solid 1px var(--neutral-border-strong); }\n    .selectable-image-component .selectable-image-component__input:checked ~ .selectable-image-component__label {\n      border: solid 2px var(--primary-bg); }\n      .selectable-image-component .selectable-image-component__input:checked ~ .selectable-image-component__label .selectable-image-component__label__check {\n        opacity: 1; }\n  .selectable-image-component .selectable-image-component__label {\n    margin-bottom: 0px;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: 40px;\n    padding: 1px;\n    border: solid 1px #e8e8e8;\n    border-radius: 4px;\n    cursor: pointer;\n    display: inline-block;\n    width: 65px;\n    height: 65px; }\n    .selectable-image-component .selectable-image-component__label .selectable-image-component__label__check {\n      background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0xIDJIMTJWMTJIMXoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjIwIC00MDkpIHRyYW5zbGF0ZSgxMTcxIDQwNikgdHJhbnNsYXRlKDQ5IDMpIHRyYW5zbGF0ZSgyIDIpIi8+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiMyMEJBQkIiIGQ9Ik02IDBjMy4zMTQgMCA2IDIuNjg2IDYgNnMtMi42ODYgNi02IDYtNi0yLjY4Ni02LTYgMi42ODYtNiA2LTZ6bTIuNjIzIDIuOTc1Yy0uMTQ2IDAtLjI5My4wOTEtLjM5Ny4yNThMNS4xMjUgOC4xNiAzLjQxOSA2LjAzYy0uMTEtLjEyMi0uMjI3LS4xNjMtLjM2NC0uMTYzLS4yNDQgMC0uNDUzLjE5Ni0uNDUzLjQ1MyAwIC4xMzMuMDU2LjI1OC4xNC4zNjNsMS45MTYgMi4zNDFjLjE2LjE4MS4zLjI1OC40ODguMjU4cy4zNDEtLjA4NC40Ni0uMjY1bDMuMzUxLTUuMjU0Yy4wNzctLjEwNS4xNC0uMjM3LjE0LS4zNjIgMC0uMjY1LS4yMy0uNDI2LS40NzQtLjQyNnoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjIwIC00MDkpIHRyYW5zbGF0ZSgxMTcxIDQwNikgdHJhbnNsYXRlKDQ5IDMpIHRyYW5zbGF0ZSgyIDIpIi8+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K\");\n      background-repeat: no-repeat;\n      background-position-x: right;\n      height: inherit;\n      opacity: 0;\n      position: relative; }\n  .selectable-image-component.options-basic li {\n    margin-right: 18px; }\n  .selectable-image-component.options-multiple {\n    justify-content: space-between; }\n    .selectable-image-component.options-multiple li:not(:nth-child(4n)) {\n      margin-right: 8px; }\n";
styleInject(css_248z$9);

var SelectableImage = function SelectableImage(_ref) {
  var label = _ref.label,
    name = _ref.name,
    options = _ref.options,
    onClick = _ref.onClick,
    onChange = _ref.onChange;
  return /*#__PURE__*/React__default.createElement("ul", {
    className: "selectable-image-component options-".concat(options.length <= 3 ? 'basic' : 'multiple')
  }, label && /*#__PURE__*/React__default.createElement("label", {
    className: "selectable-image-component__title"
  }, label), options.map(function (option) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: option.id
    }, /*#__PURE__*/React__default.createElement("input", {
      className: "selectable-image-component__input",
      id: option.id,
      type: "radio",
      name: name,
      value: option.value,
      onClick: onClick,
      onChange: onChange
    }), /*#__PURE__*/React__default.createElement("label", {
      style: {
        backgroundImage: "url(".concat(option.srcImage, ")")
      },
      className: "selectable-image-component__label",
      htmlFor: option.id
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "selectable-image-component__label__check",
      alt: "checkbox"
    })));
  }));
};
SelectableImage.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    srcImage: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  onClick: PropTypes.func,
  onChange: PropTypes.func
};

var Illustration = function Illustration(_ref) {
  var alt = _ref.alt,
    cursor = _ref.cursor,
    name = _ref.name;
  return /*#__PURE__*/React__default.createElement(Image$1, {
    cursor: cursor,
    width: 192,
    height: 98,
    name: name,
    alt: alt
  });
};
Illustration.defaultProps = {
  cursor: 'default'
};
Illustration.propTypes = {
  alt: PropTypes.string.isRequired,
  cursor: PropTypes.oneOf(['not-allowed', 'pointer', 'default', 'none']),
  name: PropTypes.string.isRequired
};

var _templateObject$E, _templateObject2$x, _templateObject3$q;
var StateMessageWrapper = styled.div(_templateObject$E || (_templateObject$E = _taggedTemplateLiteral(["\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])));
var StateMessageContent = styled.div(_templateObject2$x || (_templateObject2$x = _taggedTemplateLiteral(["\n  white-space: pre-line;\n  margin-top: ", ";\n  > * {\n    :nth-child(2) {\n      margin-top: ", ";\n    }\n  }\n"])), theme.spacing['spacing-5'], theme.spacing['spacing-3']);
var StateMessageContenButton = styled.div(_templateObject3$q || (_templateObject3$q = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), theme.spacing['spacing-6']);

var _excluded$8 = ["iconAlign", "variant", "text"];
var StateMessage = function StateMessage(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    illustration = _ref.illustration,
    button = _ref.button,
    children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'regular' : _ref$variant;
  var currentVariant = {
    regular: {
      weight: 'regular',
      modifier: 'regular'
    },
    'strong-bold': {
      weight: 'bold',
      modifier: 'strong'
    }
  };
  var renderButton = function renderButton(propsButton) {
    var _propsButton$iconAlig = propsButton.iconAlign,
      iconAlign = _propsButton$iconAlig === void 0 ? 'none' : _propsButton$iconAlig,
      _propsButton$variant = propsButton.variant,
      variant = _propsButton$variant === void 0 ? 'primary' : _propsButton$variant,
      text = propsButton.text,
      defaultProps = _objectWithoutProperties(propsButton, _excluded$8);
    var defaultPropsButton = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
      size: 'md',
      iconAlign: iconAlign,
      variant: variant
    });
    return text && /*#__PURE__*/React__default.createElement(StateMessageContenButton, null, /*#__PURE__*/React__default.createElement(Button$1, defaultPropsButton, text));
  };
  var _currentVariant$varia = currentVariant[variant],
    weight = _currentVariant$varia.weight,
    modifier = _currentVariant$varia.modifier;
  return /*#__PURE__*/React__default.createElement(StateMessageWrapper, null, illustration && /*#__PURE__*/React__default.createElement(Illustration, {
    name: illustration
  }), /*#__PURE__*/React__default.createElement(StateMessageContent, null, /*#__PURE__*/React__default.createElement(H$1, {
    type: "5",
    align: "center",
    variant: "neutral",
    weight: weight,
    modifier: modifier
  }, title), subtitle && /*#__PURE__*/React__default.createElement(P$1, {
    type: "1",
    align: "center",
    variant: "neutral"
  }, subtitle)), button && renderButton(button), children);
};
StateMessage.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  illustration: PropTypes.string,
  button: PropTypes.shape({
    iconAlign: PropTypes.string,
    icon: PropTypes.string,
    text: PropTypes.string,
    variant: PropTypes.string,
    onClick: PropTypes.func
  }),
  variant: PropTypes.oneOf(['regular', 'strong-bold'])
};

var NoData = function NoData(_ref) {
  var label = _ref.label,
    onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement(StateMessage, {
    illustration: 'lineal_liquidaciones_empty',
    title: label,
    subtitle: 'Empezá a vender ahora generando un link de pago',
    button: {
      icon: 'historial-btn-pago',
      iconAlign: 'left',
      text: 'Link de pago',
      onClick: onClick
    }
  });
};

var FilterNoData = function FilterNoData(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/React__default.createElement(StateMessage, {
    illustration: 'lineal_liquidaciones_empty',
    title: label
  });
};

var ConnectionError = function ConnectionError(_ref) {
  var label = _ref.label,
    onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement(StateMessage, {
    illustration: 'lineal_sistema_error',
    title: '¡Lo sentimos!',
    subtitle: label,
    button: {
      text: 'Reintentar',
      variant: 'secondary',
      onClick: onClick
    }
  });
};

var css_248z$a = ":root {\n  --primary-text: #023F80;\n  --primary-text-strong: #002A55;\n  --primary-text-weak: #0A7FE4;\n  --primary-bg: #023F80;\n  --primary-bg-strong: #002A55;\n  --primary-bg-weak: #D8EBFF;\n  --primary-border: #023F80;\n  --primary-border-strong: #002A55;\n  --primary-border-weak: #479EF8;\n  --primary-ic: #023F80;\n  --primary-ic-strong: #002A55;\n  --primary-ic-weak: #0A7FE4;\n  --secondary-1-text: #1AAAAD;\n  --secondary-1-text-strong: #076568;\n  --secondary-1-text-weak: #71D7D9;\n  --secondary-1-bg: #1AAAAD;\n  --secondary-1-bg-strong: #137F82;\n  --secondary-1-bg-weak: #E0FBFD;\n  --secondary-1-border: #1AAAAD;\n  --secondary-1-border-strong: #137F82;\n  --secondary-1-border-weak: #71D7D9;\n  --secondary-1-ic: #1AAAAD;\n  --secondary-1-ic-strong: #137F82;\n  --secondary-1-ic-weak: #71D7D9;\n  --secondary-2-text: #DD2457;\n  --secondary-2-text-strong: #921034;\n  --secondary-2-text-weak: #FF95B3;\n  --secondary-2-bg: #DD2457;\n  --secondary-2-bg-strong: #B11E47;\n  --secondary-2-bg-weak: #FF95B3;\n  --secondary-2-border: #DD2457;\n  --secondary-2-border-strong: #B11E47;\n  --secondary-2-border-weak: #FF95B3;\n  --secondary-2-ic: #DD2457;\n  --secondary-2-ic-strong: #B11E47;\n  --secondary-2-ic-weak: #FF95B3;\n  --secondary-3-bg: #FECF2F;\n  --secondary-3-bg-strong: #FFA53F;\n  --secondary-3-bg-weak: #FFF0BD;\n  --secondary-3-border: #FECF2F;\n  --secondary-3-border-strong: #FFA53F;\n  --secondary-3-border-weak: #FFF0BD;\n  --secondary-3-ic: #FECF2F;\n  --secondary-3-ic-strong: #FFA53F;\n  --secondary-3-ic-weak: #FFF0BD;\n  --neutral-text: #647180;\n  --neutral-text-strong: #373E45;\n  --neutral-text-weak: #B6C5D5;\n  --neutral-text-inverted: #FFFFFF;\n  --neutral-bg: #F0F5FB;\n  --neutral-bg-strong: #EAF1F8;\n  --neutral-bg-stronger: #B6C5D5;\n  --neutral-bg-weak: #FFFFFF;\n  --neutral-bg-inverted:#373E45;\n  --neutral-border: #B6C5D5;\n  --neutral-border-strong: #647180;\n  --neutral-border-weak: #DEE8F3;\n  --neutral-ic: #647180;\n  --neutral-ic-strong: #373E45;\n  --neutral-ic-weak: #B6C5D5;\n  --neutral-ic-inverted: #FFFFFF;\n  --danger-text: #DD2457;\n  --danger-text-strong: #921034;\n  --danger-text-weak: #FF95B3;\n  --danger-bg:#DD2457;\n  --danger-bg-strong:#B11E47;\n  --danger-bg-weak: #FFF0F4;\n  --danger-border: #DD2457;\n  --danger-border-strong: #B11E47;\n  --danger-ic: #DD2457;\n  --warning-text: #623311;\n  --warning-bg: #FECF2F;\n  --warning-bg-strong: #FFA53F;\n  --warning-bg-weak: #FFF4CD;\n  --warning-border: #FECF2F;\n  --warning-border-strong: #FFA53F;\n  --warning-ic: #FFA53F;\n  --info-text:#023F80;\n  --info-bg: #479EF8;\n  --info-bg-strong: #023F80;\n  --info-bg-weak: #D8EBFF;\n  --info-border: #479EF8;\n  --info-border-strong: #023F80;\n  --info-ic: #479EF8;\n  --success-text: #035456;\n  --success-bg: #1AAAAD;\n  --success-bg-strong: #137F82;\n  --success-bg-weak: #E0FBFD;\n  --success-border: #1AAAAD;\n  --success-border-strong: #137F82;\n  --success-border-weak: #71D7D9;\n  --success-ic: #1AAAAD; }\n\n.rsg--content-3 {\n  max-width: none;\n  padding: 0;\n  margin: auto;\n  background-color: #f5f5f5; }\n\ndiv[class*='rsg--preview-'] {\n  padding: 0;\n  border: none; }\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box; }\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nlabel {\n  font-weight: normal;\n  margin: 0; }\n\ncode[class*='rsg--code-'] {\n  color: darkgreen;\n  font-size: 14px; }\n\n.status-pill {\n  font-family: Ubuntu, serif;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px;\n  padding: 4px;\n  background-color: white;\n  font-size: 12px;\n  border: 1px solid;\n  width: 95px; }\n  .status-pill.status-pill--approved {\n    border-color: var(--success-bg); }\n  .status-pill.status-pill--rejected {\n    border-color: var(--danger-bg); }\n  .status-pill.status-pill--pending {\n    border-color: var(--secondary-3-bg-strong); }\n  .status-pill.status-pill--expired {\n    border-color: var(--neutral-border-strong); }\n  .status-pill.status-pill--refunded {\n    border-color: var(--info-bg); }\n  .status-pill.status-pill--cancelled {\n    border-color: var(--neutral-border-strong); }\n  .status-pill .oval {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    margin-right: 5px; }\n    .status-pill .oval.oval--approved {\n      background-color: var(--success-bg); }\n    .status-pill .oval.oval--rejected {\n      background-color: var(--danger-bg); }\n    .status-pill .oval.oval--pending {\n      background-color: var(--secondary-3-bg-strong); }\n    .status-pill .oval.oval--expired {\n      background-color: var(--neutral-border-strong); }\n    .status-pill .oval.oval--refunded {\n      background-color: var(--info-bg); }\n    .status-pill .oval.oval--cancelled {\n      background-color: var(--neutral-border-strong); }\n";
styleInject(css_248z$a);

var STATUS = {
  APPROVED: {
    value: 'APPROVED',
    text: 'Aprobado'
  },
  REJECTED: {
    value: 'REJECTED',
    text: 'Rechazado'
  },
  PENDING: {
    value: 'PENDING',
    text: 'Pendiente'
  },
  EXPIRED: {
    value: 'EXPIRED',
    text: 'Vencido'
  },
  REFUNDED: {
    value: 'REFUNDED',
    text: 'Devuelto'
  },
  CANCELLED: {
    value: 'CANCELLED',
    text: 'Anulado'
  }
};
var StatusPaymentPill = function StatusPaymentPill(_ref) {
  var status = _ref.status;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "status-pill status-pill--".concat(status.toLowerCase())
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "oval oval--".concat(status.toLowerCase())
  }), /*#__PURE__*/React__default.createElement("span", null, STATUS[status].text));
};
StatusPaymentPill.propTypes = {
  status: PropTypes.oneOf(['APPROVED', 'REJECTED', 'PENDING', 'EXPIRED', 'REFUNDED', 'CANCELLED'])
};

var _excluded$9 = ["children"];
var Section = function Section(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$9);
  return /*#__PURE__*/React__default.createElement(Card$1, props, children);
};

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _extends$7m = unwrapExports(_extends_1);

var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _objectWithoutPropertiesLoose$2 = unwrapExports(objectWithoutPropertiesLoose);

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};
var removeLabel = function removeLabel(context, content) {
  if (context === 1 && // charcode for l
  content.charCodeAt(0) === 108 && // charcode for b
  content.charCodeAt(2) === 98 // this ignores label
  ) {
      return '';
    }
};

var isBrowser = typeof document !== 'undefined';
var rootServerStylisCache = {};
var getServerStylisCache = isBrowser ? undefined : weakMemoize(function () {
  var getCache = weakMemoize(function () {
    return {};
  });
  var prefixTrueCache = {};
  var prefixFalseCache = {};
  return function (prefix) {
    if (prefix === undefined || prefix === true) {
      return prefixTrueCache;
    }

    if (prefix === false) {
      return prefixFalseCache;
    }

    return getCache(prefix);
  };
});

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_min(stylisOptions);

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  if (isBrowser) {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  if (isBrowser) {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  } else {
    stylis.use(removeLabel);
    var serverStylisCache = rootServerStylisCache;

    if (options.stylisPlugins || options.prefix !== undefined) {
      stylis.use(options.stylisPlugins); // $FlowFixMe

      serverStylisCache = getServerStylisCache(options.stylisPlugins || rootServerStylisCache)(options.prefix);
    }

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = stylis(selector, serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  if (process.env.NODE_ENV !== 'production') {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

var isBrowser$1 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      if (!isBrowser$1 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$1 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern$1 = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern$1, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (process.env.NODE_ENV !== 'production' && couldBeSelectorInterpolation && shouldWarnAboutInterpolatingClassNameFromCss && cached !== undefined) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser$2 = typeof document !== 'undefined';
var hasOwnProperty = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/createContext$1( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? createCache() : null);
var ThemeContext$1 = /*#__PURE__*/createContext$1({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/createElement$2(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/forwardRef(render);
};

if (!isBrowser$2) {
  var BasicProvider = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(BasicProvider, _React$Component);

    function BasicProvider(props, context, updater) {
      var _this;

      _this = _React$Component.call(this, props, context, updater) || this;
      _this.state = {
        value: createCache()
      };
      return _this;
    }

    var _proto = BasicProvider.prototype;

    _proto.render = function render() {
      return /*#__PURE__*/createElement$2(EmotionCacheContext.Provider, this.state, this.props.children(this.state.value));
    };

    return BasicProvider;
  }(Component$1);

  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      return /*#__PURE__*/createElement$2(EmotionCacheContext.Consumer, null, function (context) {
        if (context === null) {
          return /*#__PURE__*/createElement$2(BasicProvider, null, function (newContext) {
            return func(props, newContext);
          });
        } else {
          return func(props, context);
        }
      });
    };
  };
}

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (process.env.NODE_ENV !== 'production' && typeof props.css === 'string' && // check if there is a css declaration
  props.css.indexOf(':') !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions

  if (process.env.NODE_ENV !== 'production') {
    var error = new Error();

    if (error.stack) {
      // chrome
      var match = error.stack.match(/at (?:Object\.|Module\.|)(?:jsx|createEmotionProps).*\n\s+at (?:Object\.|)([A-Z][A-Za-z$]+) /);

      if (!match) {
        // safari and firefox
        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
      }

      if (match) {
        newProps[labelPropName] = sanitizeIdentifier(match[1]);
      }
    }
  }

  return newProps;
};

var Noop = function Noop() {
  return null;
};

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles);

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/createElement$2(type, newProps);
  var possiblyStyleElement = /*#__PURE__*/createElement$2(Noop, null);

  if (!isBrowser$2 && rules !== undefined) {
    var _ref;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    possiblyStyleElement = /*#__PURE__*/createElement$2("style", (_ref = {}, _ref["data-emotion-" + cache.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // Need to return the same number of siblings or else `React.useId` will cause hydration mismatches.


  return /*#__PURE__*/createElement$2(Fragment$1, null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/createElement$2(ThemeContext$1.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2$1(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys$1 = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize$1(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR$1 = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex$1 = /[A-Z]|^ms/g;
var animationRegex$1 = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty$1 = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue$1 = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName$1 = memoize$1(function (styleName) {
  return isCustomProperty$1(styleName) ? styleName : styleName.replace(hyphenateRegex$1, '-$&').toLowerCase();
});

var processStyleValue$1 = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex$1, function (match, p1, p2) {
            cursor$1 = {
              name: p1,
              styles: p2,
              next: cursor$1
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys$1[key] !== 1 && !isCustomProperty$1(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern$1 = /(attr|calc|counters?|url)\(/;
  var contentValues$1 = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue$1 = processStyleValue$1;
  var msPattern$2 = /^-ms-/;
  var hyphenPattern$1 = /-(.)/g;
  var hyphenatedCache$1 = {};

  processStyleValue$1 = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues$1.indexOf(value) === -1 && !contentValuePattern$1.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue$1(key, value);

    if (processed !== '' && !isCustomProperty$1(key) && key.indexOf('-') !== -1 && hyphenatedCache$1[key] === undefined) {
      hyphenatedCache$1[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern$2, 'ms-').replace(hyphenPattern$1, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss$1 = true;

function handleInterpolation$1(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor$1 = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor$1
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor$1 = {
                name: next.name,
                styles: next.styles,
                next: cursor$1
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject$1(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor$1;
          var result = interpolation(mergedProps);
          cursor$1 = previousCursor;
          return handleInterpolation$1(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex$1, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (process.env.NODE_ENV !== 'production' && couldBeSelectorInterpolation && shouldWarnAboutInterpolatingClassNameFromCss$1 && cached !== undefined) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss$1 = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject$1(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation$1(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue$1(value)) {
          string += processStyleName$1(_key) + ":" + processStyleValue$1(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue$1(value[_i])) {
              string += processStyleName$1(_key) + ":" + processStyleValue$1(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation$1(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName$1(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR$1);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern$1 = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern$1;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern$1 = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor$1;
var serializeStyles$1 = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor$1 = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation$1(mergedProps, registered, strings, false);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation$1(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern$1, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern$1.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern$1.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2$1(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor$1,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor$1
  };
};

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles$1(args);
}

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return createElement$2.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return createElement$2.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false;
var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (process.env.NODE_ENV !== 'production' && !warnedAboutCssPropForGlobal && ( // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  props.className || props.css)) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;

  if (typeof styles === 'function') {
    return /*#__PURE__*/createElement$2(ThemeContext$1.Consumer, null, function (theme) {
      var serialized = serializeStyles([styles(theme)]);
      return /*#__PURE__*/createElement$2(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }

  var serialized = serializeStyles([styles]);
  return /*#__PURE__*/createElement$2(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
});

// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var InnerGlobal = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InnerGlobal, _React$Component);

  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }

  var _proto = InnerGlobal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new StyleSheet({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");

    if (node !== null) {
      this.sheet.tags.push(node);
    }

    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }

    this.insertStyles();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };

  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      // insert keyframes
      insertStyles(this.props.cache, this.props.serialized.next, true);
    }

    if (this.sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }

    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };

  _proto.render = function render() {
    if (!isBrowser$2) {
      var serialized = this.props.serialized;
      var serializedNames = serialized.name;
      var serializedStyles = serialized.styles;
      var next = serialized.next;

      while (next !== undefined) {
        serializedNames += ' ' + next.name;
        serializedStyles += next.styles;
        next = next.next;
      }

      var shouldCache = this.props.cache.compat === true;
      var rules = this.props.cache.insert("", {
        name: serializedNames,
        styles: serializedStyles
      }, this.sheet, shouldCache);

      if (!shouldCache) {
        var _ref;

        return /*#__PURE__*/createElement$2("style", (_ref = {}, _ref["data-emotion-" + this.props.cache.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
          __html: rules
        }, _ref.nonce = this.props.cache.sheet.nonce, _ref));
      }
    }

    return null;
  };

  return InnerGlobal;
}(Component$1);

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames$1 = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Noop$1 = function Noop() {
  return null;
};

var ClassNames = withEmotionCache(function (props, context) {
  return /*#__PURE__*/createElement$2(ThemeContext$1.Consumer, null, function (theme) {
    var rules = '';
    var serializedHashes = '';
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, context.registered);

      if (isBrowser$2) {
        insertStyles(context, serialized, false);
      } else {
        var res = insertStyles(context, serialized, false);

        if (res !== undefined) {
          rules += res;
        }
      }

      if (!isBrowser$2) {
        serializedHashes += " " + serialized.name;
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames$1(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;
    var possiblyStyleElement = /*#__PURE__*/createElement$2(Noop$1, null);

    if (!isBrowser$2 && rules.length !== 0) {
      var _ref;

      possiblyStyleElement = /*#__PURE__*/createElement$2("style", (_ref = {}, _ref["data-emotion-" + context.key] = serializedHashes.substring(1), _ref.dangerouslySetInnerHTML = {
        __html: rules
      }, _ref.nonce = context.sheet.nonce, _ref));
    } // Need to return the same number of siblings or else `React.useId` will cause hydration mismatches.


    return /*#__PURE__*/createElement$2(Fragment$1, null, possiblyStyleElement, ele);
  });
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var cleanProps = function cleanProps(props) {
  var initialState = props.initialState,
      getInitialState = props.getInitialState,
      refs = props.refs,
      getRefs = props.getRefs,
      didMount = props.didMount,
      didUpdate = props.didUpdate,
      willUnmount = props.willUnmount,
      getSnapshotBeforeUpdate = props.getSnapshotBeforeUpdate,
      shouldUpdate = props.shouldUpdate,
      render = props.render,
      rest = _objectWithoutProperties$1(props, ["initialState", "getInitialState", "refs", "getRefs", "didMount", "didUpdate", "willUnmount", "getSnapshotBeforeUpdate", "shouldUpdate", "render"]);

  return rest;
};

var Component = function (_React$Component) {
  _inherits(Component, _React$Component);

  function Component() {
    var _temp, _this, _ret;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Component.prototype.getArgs = function getArgs() {
    var state = this.state,
        props = this.props,
        setState = this._setState,
        forceUpdate = this._forceUpdate,
        refs = this._refs;

    return {
      state: state,
      props: cleanProps(props),
      refs: refs,
      setState: setState,
      forceUpdate: forceUpdate
    };
  };

  Component.prototype.componentDidMount = function componentDidMount() {
    if (this.props.didMount) this.props.didMount(this.getArgs());
  };

  Component.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    if (this.props.shouldUpdate) return this.props.shouldUpdate({
      props: this.props,
      state: this.state,
      nextProps: cleanProps(nextProps),
      nextState: nextState
    });else return true;
  };

  Component.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.props.willUnmount) this.props.willUnmount({
      state: this.state,
      props: cleanProps(this.props),
      refs: this._refs
    });
  };

  Component.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.didUpdate) this.props.didUpdate(Object.assign(this.getArgs(), {
      prevProps: cleanProps(prevProps),
      prevState: prevState
    }), snapshot);
  };

  Component.prototype.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate(prevProps, prevState) {
    if (this.props.getSnapshotBeforeUpdate) {
      return this.props.getSnapshotBeforeUpdate(Object.assign(this.getArgs(), {
        prevProps: cleanProps(prevProps),
        prevState: prevState
      }));
    } else {
      return null;
    }
  };

  Component.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        render = _props.render;

    return render ? render(this.getArgs()) : typeof children === "function" ? children(this.getArgs()) : children || null;
  };

  return Component;
}(React__default.Component);

Component.defaultProps = {
  getInitialState: function getInitialState() {},
  getRefs: function getRefs() {
    return {};
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = this.props.initialState || this.props.getInitialState(this.props);
  this._refs = this.props.refs || this.props.getRefs(this.getArgs());

  this._setState = function () {
    return _this2.setState.apply(_this2, arguments);
  };

  this._forceUpdate = function () {
    return _this2.forceUpdate.apply(_this2, arguments);
  };
};

process.env.NODE_ENV !== "production" ? Component.propTypes = {
  initialState: object,
  getInitialState: func,
  refs: object,
  getRefs: func,
  didMount: func,
  didUpdate: func,
  willUnmount: func,
  getSnapshotBeforeUpdate: func,
  shouldUpdate: func,
  render: func,
  children: oneOfType([func, node])
} : void 0;

var Portal = function Portal(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? "reach-portal" : _ref$type;
  return React__default.createElement(Component, {
    getRefs: function getRefs() {
      return { mountNode: null, portalNode: null };
    },
    didMount: function didMount(_ref2) {
      var refs = _ref2.refs,
          forceUpdate = _ref2.forceUpdate;

      // It's possible that the content we are portal has, itself, been portaled.
      // In that case, it's important to append to the correct document element.
      var ownerDocument = refs.mountNode.ownerDocument;
      refs.portalNode = ownerDocument.createElement(type);
      ownerDocument.body.appendChild(refs.portalNode);
      forceUpdate();
    },
    willUnmount: function willUnmount(_ref3) {
      var portalNode = _ref3.refs.portalNode;

      portalNode.ownerDocument.body.removeChild(portalNode);
    },
    render: function render(_ref4) {
      var refs = _ref4.refs;
      var portalNode = refs.portalNode;

      if (!portalNode) {
        return React__default.createElement("div", { ref: function ref(div) {
            return refs.mountNode = div;
          } });
      } else {
        return createPortal(children, portalNode);
      }
    }
  });
};

var checkedPkgs = {};

var checkStyles = function checkStyles() {};

if (process.env.NODE_ENV !== "production") {
  checkStyles = function checkStyles(pkg) {
    // only check once per package
    if (checkedPkgs[pkg]) return;
    checkedPkgs[pkg] = true;

    if (parseInt(window.getComputedStyle(document.body).getPropertyValue("--reach-" + pkg), 10) !== 1) {
      console.warn("@reach/" + pkg + " styles not found. If you are using a bundler like webpack or parcel include this in the entry file of your app before any of your own styles:\n\n    import \"@reach/" + pkg + "/styles.css\";\n\n  Otherwise you'll need to include them some other way:\n\n    <link rel=\"stylesheet\" type=\"text/css\" href=\"node_modules/@reach/" + pkg + "/styles.css\" />\n\n  For more information visit https://ui.reach.tech/styling.\n  ");
    }
  };
}

var wrapEvent = function wrapEvent(theirHandler, ourHandler) {
  return function (event) {
    theirHandler && theirHandler(event);
    if (!event.defaultPrevented) {
      return ourHandler(event);
    }
  };
};

var assignRef = function assignRef(ref, value) {
  if (ref == null) return;
  if (typeof ref === "function") {
    ref(value);
  } else {
    try {
      ref.current = value;
    } catch (error) {
      throw new Error("Cannot assign value \"" + value + "\" to ref \"" + ref + "\"");
    }
  }
};

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(setPrototypeOf);

var inheritsLoose = createCommonjsModule(function (module) {
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _inheritsLoose$1 = unwrapExports(inheritsLoose);

var assertThisInitialized = createCommonjsModule(function (module) {
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _assertThisInitialized$1 = unwrapExports(assertThisInitialized);

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(_typeof_1);

var toPrimitive = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(toPrimitive);

var toPropertyKey = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];

function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(toPropertyKey);

var defineProperty = createCommonjsModule(function (module) {
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _defineProperty$1 = unwrapExports(defineProperty);

var toArray = function toArray(a) {
  var ret = Array(a.length);
  for (var i = 0; i < a.length; ++i) {
    ret[i] = a[i];
  }
  return ret;
};

var arrayFind = function arrayFind(array, search) {
  return array.filter(function (a) {
    return a === search;
  })[0];
};

var asArray = function asArray(a) {
  return Array.isArray(a) ? a : [a];
};

var tabSort = function tabSort(a, b) {
  var tabDiff = a.tabIndex - b.tabIndex;
  var indexDiff = a.index - b.index;

  if (tabDiff) {
    if (!a.tabIndex) return 1;
    if (!b.tabIndex) return -1;
  }

  return tabDiff || indexDiff;
};

var orderByTabIndex = function orderByTabIndex(nodes, filterNegative, keepGuards) {
  return toArray(nodes).map(function (node, index) {
    return {
      node: node,
      index: index,
      tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
    };
  }).filter(function (data) {
    return !filterNegative || data.tabIndex >= 0;
  }).sort(tabSort);
};

var tabbables = ['button:enabled:not([readonly])', 'select:enabled:not([readonly])', 'textarea:enabled:not([readonly])', 'input:enabled:not([readonly])', 'a[href]', 'area[href]', 'iframe', 'object', 'embed', '[tabindex]', '[contenteditable]', '[autofocus]'];

var FOCUS_GROUP = 'data-focus-lock';
var FOCUS_DISABLED = 'data-focus-lock-disabled';
var FOCUS_ALLOW = 'data-no-focus-lock';
var FOCUS_AUTO = 'data-autofocus-inside';

var queryTabbables = tabbables.join(',');
var queryGuardTabbables = queryTabbables + ', [data-focus-guard]';

var getFocusables = function getFocusables(parents, withGuards) {
  return parents.reduce(function (acc, parent) {
    return acc.concat(
    // add all tabbables inside
    toArray(parent.querySelectorAll(withGuards ? queryGuardTabbables : queryTabbables)),
    // add if node is tabble itself
    parent.parentNode ? toArray(parent.parentNode.querySelectorAll(tabbables.join(','))).filter(function (node) {
      return node === parent;
    }) : []);
  }, []);
};

var getParentAutofocusables = function getParentAutofocusables(parent) {
  var parentFocus = parent.querySelectorAll('[' + FOCUS_AUTO + ']');
  return toArray(parentFocus).map(function (node) {
    return getFocusables([node]);
  }).reduce(function (acc, nodes) {
    return acc.concat(nodes);
  }, []);
};

var isElementHidden = function isElementHidden(computedStyle) {
  if (!computedStyle || !computedStyle.getPropertyValue) {
    return false;
  }
  return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};

var isVisible = function isVisible(node) {
  return !node || node === document || node.nodeType === Node.DOCUMENT_NODE || !isElementHidden(window.getComputedStyle(node, null)) && isVisible(node.parentNode);
};

var notHiddenInput = function notHiddenInput(node) {
  return !((node.tagName === 'INPUT' || node.tagName === 'BUTTON') && (node.type === 'hidden' || node.disabled));
};

var getParents = function getParents(node) {
  var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  parents.push(node);
  if (node.parentNode) {
    getParents(node.parentNode, parents);
  }
  return parents;
};

var getCommonParent = function getCommonParent(nodea, nodeb) {
  var parentsA = getParents(nodea);
  var parentsB = getParents(nodeb);

  for (var i = 0; i < parentsA.length; i += 1) {
    var currentParent = parentsA[i];
    if (parentsB.indexOf(currentParent) >= 0) {
      return currentParent;
    }
  }
  return false;
};

var filterFocusable = function filterFocusable(nodes) {
  return toArray(nodes).filter(function (node) {
    return isVisible(node);
  }).filter(function (node) {
    return notHiddenInput(node);
  });
};

var getTabbableNodes = function getTabbableNodes(topNodes, withGuards) {
  return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards)), true, withGuards);
};

var getAllTabbableNodes = function getAllTabbableNodes(topNodes) {
  return orderByTabIndex(filterFocusable(getFocusables(topNodes)), false);
};

var parentAutofocusables = function parentAutofocusables(topNode) {
  return filterFocusable(getParentAutofocusables(topNode));
};

var isRadio = function isRadio(node) {
  return node.tagName === 'INPUT' && node.type === 'radio';
};

var findSelectedRadio = function findSelectedRadio(node, nodes) {
  return nodes.filter(isRadio).filter(function (el) {
    return el.name === node.name;
  }).filter(function (el) {
    return el.checked;
  })[0] || node;
};

var pickFirstFocus = function pickFirstFocus(nodes) {
  if (nodes[0] && nodes.length > 1) {
    if (isRadio(nodes[0]) && nodes[0].name) {
      return findSelectedRadio(nodes[0], nodes);
    }
  }
  return nodes[0];
};

var pickFocusable = function pickFocusable(nodes, index) {
  if (nodes.length > 1) {
    if (isRadio(nodes[index]) && nodes[index].name) {
      return nodes.indexOf(findSelectedRadio(nodes[index], nodes));
    }
  }
  return index;
};

var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var filterNested = function filterNested(nodes) {
  var l = nodes.length;
  for (var i = 0; i < l; i += 1) {
    var _loop = function _loop(j) {
      if (i !== j) {
        if (nodes[i].contains(nodes[j])) {
          return {
            v: filterNested(nodes.filter(function (x) {
              return x !== nodes[j];
            }))
          };
        }
      }
    };

    for (var j = 0; j < l; j += 1) {
      var _ret = _loop(j);

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof$1(_ret)) === "object") return _ret.v;
    }
  }
  return nodes;
};

var getTopParent = function getTopParent(node) {
  return node.parentNode ? getTopParent(node.parentNode) : node;
};

var getAllAffectedNodes = function getAllAffectedNodes(node) {
  var nodes = asArray(node);
  return nodes.filter(Boolean).reduce(function (acc, currentNode) {
    var group = currentNode.getAttribute(FOCUS_GROUP);
    acc.push.apply(acc, group ? filterNested(toArray(getTopParent(currentNode).querySelectorAll('[' + FOCUS_GROUP + '="' + group + '"]:not([' + FOCUS_DISABLED + '="disabled"])'))) : [currentNode]);
    return acc;
  }, []);
};

var findAutoFocused = function findAutoFocused(autoFocusables) {
  return function (node) {
    return !!node.autofocus || node.dataset && !!node.dataset.autofocus || autoFocusables.indexOf(node) >= 0;
  };
};

var isGuard = function isGuard(node) {
  return node && node.dataset && node.dataset.focusGuard;
};
var notAGuard = function notAGuard(node) {
  return !isGuard(node);
};

var newFocus = function newFocus(innerNodes, outerNodes, activeElement, lastNode, autoFocused) {
  var cnt = innerNodes.length;
  var firstFocus = innerNodes[0];
  var lastFocus = innerNodes[cnt - 1];
  var isOnGuard = isGuard(activeElement);

  // focus is inside
  if (innerNodes.indexOf(activeElement) >= 0) {
    return undefined;
  }

  var activeIndex = outerNodes.indexOf(activeElement);
  var lastIndex = outerNodes.indexOf(lastNode || activeIndex);
  var lastNodeInside = innerNodes.indexOf(lastNode);
  var indexDiff = activeIndex - lastIndex;
  var firstNodeIndex = outerNodes.indexOf(firstFocus);
  var lastNodeIndex = outerNodes.indexOf(lastFocus);

  var returnFirstNode = pickFocusable(innerNodes, 0);
  var returnLastNode = pickFocusable(innerNodes, cnt - 1);

  // new focus
  if (activeIndex === -1 || lastNodeInside === -1) {
    return innerNodes.indexOf(autoFocused && autoFocused.length ? pickFirstFocus(autoFocused) : pickFirstFocus(innerNodes));
  }
  // old focus
  if (!indexDiff && lastNodeInside >= 0) {
    return lastNodeInside;
  }
  // first element
  if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnLastNode;
  }
  // last element
  if (activeIndex >= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnFirstNode;
  }
  // jump out, but not on the guard
  if (indexDiff && Math.abs(indexDiff) > 1) {
    return lastNodeInside;
  }
  // focus above lock
  if (activeIndex <= firstNodeIndex) {
    return returnLastNode;
  }
  // focus below lock
  if (activeIndex > lastNodeIndex) {
    return returnFirstNode;
  }
  // index is inside tab order, but outside Lock
  if (indexDiff) {
    if (Math.abs(indexDiff) > 1) {
      return lastNodeInside;
    }
    return (cnt + lastNodeInside + indexDiff) % cnt;
  }
  // do nothing
  return undefined;
};

var getTopCommonParent = function getTopCommonParent(baseActiveElement, leftEntry, rightEntries) {
  var activeElements = asArray(baseActiveElement);
  var leftEntries = asArray(leftEntry);
  var activeElement = activeElements[0];
  var topCommon = null;
  leftEntries.filter(Boolean).forEach(function (entry) {
    topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
    rightEntries.filter(Boolean).forEach(function (subEntry) {
      var common = getCommonParent(activeElement, subEntry);
      if (common) {
        if (!topCommon || common.contains(topCommon)) {
          topCommon = common;
        } else {
          topCommon = getCommonParent(common, topCommon);
        }
      }
    });
  });
  return topCommon;
};

var allParentAutofocusables = function allParentAutofocusables(entries) {
  return entries.reduce(function (acc, node) {
    return acc.concat(parentAutofocusables(node));
  }, []);
};

var reorderNodes = function reorderNodes(srcNodes, dstNodes) {
  var remap = new Map();
  // no Set(dstNodes) for IE11 :(
  dstNodes.forEach(function (entity) {
    return remap.set(entity.node, entity);
  });
  // remap to dstNodes
  return srcNodes.map(function (node) {
    return remap.get(node);
  }).filter(Boolean);
};

var getFocusabledIn = function getFocusabledIn(topNode) {
  var entries = getAllAffectedNodes(topNode).filter(notAGuard);
  var commonParent = getTopCommonParent(topNode, topNode, entries);
  var outerNodes = getTabbableNodes([commonParent], true);
  var innerElements = getTabbableNodes(entries).filter(function (_ref) {
    var node = _ref.node;
    return notAGuard(node);
  }).map(function (_ref2) {
    var node = _ref2.node;
    return node;
  });

  return outerNodes.map(function (_ref3) {
    var node = _ref3.node,
        index = _ref3.index;
    return {
      node: node,
      index: index,
      lockItem: innerElements.indexOf(node) >= 0,
      guard: isGuard(node)
    };
  });
};

var getFocusMerge = function getFocusMerge(topNode, lastNode) {
  var activeElement = document && document.activeElement;
  var entries = getAllAffectedNodes(topNode).filter(notAGuard);

  var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);

  var innerElements = getTabbableNodes(entries).filter(function (_ref4) {
    var node = _ref4.node;
    return notAGuard(node);
  });

  if (!innerElements[0]) {
    innerElements = getAllTabbableNodes(entries).filter(function (_ref5) {
      var node = _ref5.node;
      return notAGuard(node);
    });
    if (!innerElements[0]) {
      return undefined;
    }
  }

  var outerNodes = getTabbableNodes([commonParent]).map(function (_ref6) {
    var node = _ref6.node;
    return node;
  });
  var orderedInnerElements = reorderNodes(outerNodes, innerElements);
  var innerNodes = orderedInnerElements.map(function (_ref7) {
    var node = _ref7.node;
    return node;
  });

  var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode, innerNodes.filter(findAutoFocused(allParentAutofocusables(entries))));

  if (newId === undefined) {
    return newId;
  }
  return orderedInnerElements[newId];
};

var focusInFrame = function focusInFrame(frame) {
  return frame === document.activeElement;
};

var focusInsideIframe = function focusInsideIframe(topNode) {
  return !!arrayFind(toArray(topNode.querySelectorAll('iframe')), focusInFrame);
};

var focusInside = function focusInside(topNode) {
  var activeElement = document && document.activeElement;

  if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
    return false;
  }
  return getAllAffectedNodes(topNode).reduce(function (result, node) {
    return result || node.contains(activeElement) || focusInsideIframe(node);
  }, false);
};

var focusIsHidden = function focusIsHidden() {
  return document && toArray(document.querySelectorAll('[' + FOCUS_ALLOW + ']')).some(function (node) {
    return node.contains(document.activeElement);
  });
};

var focusOn = function focusOn(target) {
  target.focus();
  if (target.contentWindow) {
    target.contentWindow.focus();
  }
};

var guardCount = 0;
var lockDisabled = false;

var setFocus = (function (topNode, lastNode) {
  var focusable = getFocusMerge(topNode, lastNode);

  if (lockDisabled) {
    return;
  }

  if (focusable) {
    if (guardCount > 2) {
      // eslint-disable-next-line no-console
      console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' + 'See https://github.com/theKashey/focus-lock/#focus-fighting');
      lockDisabled = true;
      setTimeout(function () {
        lockDisabled = false;
      }, 1);
      return;
    }
    guardCount++;
    focusOn(focusable.node);
    guardCount--;
  }
});

function _typeof$2(obj) {
  "@babel/helpers - typeof";

  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$2(obj);
}

function _toPrimitive$1(input, hint) {
  if (_typeof$2(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof$2(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey$1(arg) {
  var key = _toPrimitive$1(arg, "string");
  return _typeof$2(key) === "symbol" ? key : String(key);
}

function _defineProperty$2(obj, key, value) {
  key = _toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof reducePropsToState !== 'function') {
      throw new Error('Expected reducePropsToState to be a function.');
    }

    if (typeof handleStateChangeOnClient !== 'function') {
      throw new Error('Expected handleStateChangeOnClient to be a function.');
    }
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (process.env.NODE_ENV !== "production") {
      if (typeof WrappedComponent !== 'function') {
        throw new Error('Expected WrappedComponent to be a React component.');
      }
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));
      handleStateChangeOnClient(state);
    }

    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      var _proto = SideEffect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return /*#__PURE__*/React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(PureComponent);

    _defineProperty$2(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    return SideEffect;
  };
}

function deferAction(action) {
  // Hidding setImmediate from Webpack to avoid inserting polyfill
  var setImmediate = window.setImmediate;

  if (typeof setImmediate !== 'undefined') {
    setImmediate(action);
  } else {
    setTimeout(action, 1);
  }
}

var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};

var isFreeFocus = function isFreeFocus() {
  return focusOnBody() || focusIsHidden();
};

var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;

var defaultWhitelist = function defaultWhitelist() {
  return true;
};

var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};

var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement
  };
};

var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};

function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;

  do {
    var item = allNodes[i];

    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i !== startIndex) {
        // we will tab to the next element
        return;
      }

      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);

  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}

var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};

var activateTrap = function activateTrap() {
  var result = false;

  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
        observed = _lastActiveTrap.observed,
        persistentFocus = _lastActiveTrap.persistentFocus,
        autoFocus = _lastActiveTrap.autoFocus,
        shards = _lastActiveTrap.shards;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;

    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));

      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutsideWindow || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !(focusInside(workingArea) || focusIsPortaledPair(activeElement))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              activeElement.blur();
              document.body.focus();
            } else {
              result = setFocus(workingArea, lastActiveFocus);
              lastPortaledElement = {};
            }
          }

          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }

      if (document) {
        var newActiveElement = document && document.activeElement;
        var allNodes = getFocusabledIn(workingArea);
        var focusedItem = allNodes.find(function (_ref) {
          var node = _ref.node;
          return node === newActiveElement;
        });

        if (focusedItem) {
          // remove old focus
          allNodes.filter(function (_ref2) {
            var guard = _ref2.guard,
                node = _ref2.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function (_ref3) {
            var node = _ref3.node;
            return node.removeAttribute('tabIndex');
          });
          var focusedIndex = allNodes.indexOf(focusedItem);
          autoGuard(focusedIndex, allNodes.length, +1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }

  return result;
};

var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    // prevent scroll jump
    event.stopPropagation();
    event.preventDefault();
  }
};

var onBlur = function onBlur() {
  return deferAction(activateTrap);
};
var onFocus = function onFocus(event) {
  // detect portal
  var source = event.target;
  var currentNode = event.currentTarget;

  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};

var FocusWatcher = function FocusWatcher() {
  return null;
};

var FocusTrap = function FocusTrap(_ref4) {
  var children = _ref4.children;
  return React__default.createElement("div", {
    onBlur: onBlur,
    onFocus: onFocus
  }, children);
};

FocusTrap.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired
} : {};

var onWindowBlur = function onWindowBlur() {
  focusWasOutsideWindow = true;
};

var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap, true);
  document.addEventListener('focusout', onBlur);
  window.addEventListener('blur', onWindowBlur);
};

var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap, true);
  document.removeEventListener('focusout', onBlur);
  window.removeEventListener('blur', onWindowBlur);
};

function reducePropsToState(propsList) {
  return propsList.filter(function (_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  }).slice(-1)[0];
}

function handleStateChangeOnClient(trap) {
  if (trap && !lastActiveTrap) {
    attachHandler();
  }

  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.onActivation === lastTrap.onActivation;
  lastActiveTrap = trap;

  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation();
  }

  if (trap) {
    lastActiveFocus = null;

    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation();
    }

    activateTrap();
    deferAction(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
}

var FocusTrap$1 = withSideEffect(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);

var hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};

var InFocusGuard = function InFocusGuard(_ref) {
  var children = _ref.children;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }), children, children && React__default.createElement("div", {
    key: "guard-last",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }));
};

InFocusGuard.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
InFocusGuard.defaultProps = {
  children: null
};

var RenderChildren = function RenderChildren(_ref) {
  var children = _ref.children;
  return React__default.createElement("div", null, children);
};

RenderChildren.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired
} : {};
var Fragment = React__default.Fragment ? React__default.Fragment : RenderChildren;
var emptyArray = [];

var FocusLock =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose$1(FocusLock, _Component);

  function FocusLock() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "state", {
      observed: undefined
    });

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onActivation", function () {
      _this.originalFocusedElement = _this.originalFocusedElement || document && document.activeElement;

      if (_this.state.observed && _this.props.onActivation) {
        _this.props.onActivation(_this.state.observed);
      }

      _this.isActive = true;
    });

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onDeactivation", function () {
      _this.isActive = false;

      if (_this.props.returnFocus && _this.originalFocusedElement && _this.originalFocusedElement.focus) {
        _this.originalFocusedElement.focus();

        _this.originalFocusedElement = null;
      }

      if (_this.props.onDeactivation) {
        _this.props.onDeactivation(_this.state.observed);
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onFocus", function (event) {
      if (_this.isActive) {
        onFocus(event);
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onBlur", onBlur);

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "setObserveNode", function (observed) {
      if (_this.state.observed !== observed) {
        _this.setState({
          observed: observed
        });
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "isActive", false);

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "originalFocusedElement", null);

    return _this;
  }

  var _proto = FocusLock.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        children = _this$props.children,
        disabled = _this$props.disabled,
        noFocusGuards = _this$props.noFocusGuards,
        persistentFocus = _this$props.persistentFocus,
        autoFocus = _this$props.autoFocus,
        allowTextSelection = _this$props.allowTextSelection,
        group = _this$props.group,
        className = _this$props.className,
        whiteList = _this$props.whiteList,
        _this$props$shards = _this$props.shards,
        shards = _this$props$shards === void 0 ? emptyArray : _this$props$shards,
        _this$props$as = _this$props.as,
        Container = _this$props$as === void 0 ? 'div' : _this$props$as,
        _this$props$lockProps = _this$props.lockProps,
        containerProps = _this$props$lockProps === void 0 ? {} : _this$props$lockProps;
    var observed = this.state.observed;

    if (process.env.NODE_ENV !== 'production') {
      if (typeof allowTextSelection !== 'undefined') {
        // eslint-disable-next-line no-console
        console.warn('React-Focus-Lock: allowTextSelection is deprecated and enabled by default');
      }
    }

    var lockProps = _extends$7m((_extends2 = {}, _extends2[FOCUS_DISABLED] = disabled && 'disabled', _extends2[FOCUS_GROUP] = group, _extends2), containerProps);

    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    return React__default.createElement(Fragment, null, hasLeadingGuards && [React__default.createElement("div", {
      key: "guard-first",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 0,
      style: hiddenGuard
    }), // nearest focus guard
    React__default.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 1,
      style: hiddenGuard
    })], React__default.createElement(Container, _extends$7m({
      ref: this.setObserveNode
    }, lockProps, {
      className: className,
      onBlur: this.onBlur,
      onFocus: this.onFocus
    }), React__default.createElement(FocusTrap$1, {
      observed: observed,
      disabled: disabled,
      persistentFocus: persistentFocus,
      autoFocus: autoFocus,
      whiteList: whiteList,
      shards: shards,
      onActivation: this.onActivation,
      onDeactivation: this.onDeactivation
    }), children), hasTailingGuards && React__default.createElement("div", {
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 0,
      style: hiddenGuard
    }));
  };

  return FocusLock;
}(Component$1);

FocusLock.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  returnFocus: PropTypes.bool,
  noFocusGuards: PropTypes.bool,
  allowTextSelection: PropTypes.bool,
  autoFocus: PropTypes.bool,
  persistentFocus: PropTypes.bool,
  group: PropTypes.string,
  className: PropTypes.string,
  whiteList: PropTypes.func,
  shards: PropTypes.arrayOf(PropTypes.any),
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  lockProps: PropTypes.object,
  onActivation: PropTypes.func,
  onDeactivation: PropTypes.func
} : {};
FocusLock.defaultProps = {
  disabled: false,
  returnFocus: false,
  noFocusGuards: false,
  autoFocus: true,
  persistentFocus: false,
  allowTextSelection: undefined,
  group: undefined,
  className: undefined,
  whiteList: undefined,
  shards: undefined,
  as: 'div',
  lockProps: {},
  onActivation: undefined,
  onDeactivation: undefined
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function makeStyleTag() {
    if (!document)
        return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    return tag;
}
function injectStyles(tag, css) {
    if (tag.styleSheet) {
        tag.styleSheet.cssText = css;
    }
    else {
        tag.appendChild(document.createTextNode(css));
    }
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var stylesheetSinglentone = function () {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function (style) {
            if (counter == 0) {
                if (stylesheet = makeStyleTag()) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function () {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};

var styleSinglentone = function () {
    var sheet = stylesheetSinglentone();
    return (function (_super) {
        __extends(Sheet, _super);
        function Sheet() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Sheet.prototype.componentDidMount = function () {
            sheet.add(this.props.styles);
        };
        Sheet.prototype.componentWillUnmount = function () {
            sheet.remove();
        };
        Sheet.prototype.render = function () {
            return null;
        };
        return Sheet;
    }(PureComponent));
};

var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0,
};
var parse = function (x) { return parseInt(x || '', 10) || 0; };
var getOffset = function (gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        parse(left),
        parse(top),
        parse(right),
    ];
};
var getGapWidth = function (gapMode) {
    if (gapMode === void 0) { gapMode = 'margin'; }
    if (typeof window === 'undefined') {
        return zeroGap;
    }
    var offsets = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0]),
    };
};

var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';

var Style = styleSinglentone();
var getStyles = function (_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) { gapMode = 'margin'; }
    return "\n  ." + noScrollbarsClassName + " {\n   overflow: hidden " + important + ";\n   padding-right: " + gap + "px " + important + ";\n  }\n  body {\n    overflow: hidden " + important + ";\n    " + [
        allowRelative && "position: relative " + important + ";",
        gapMode === 'margin' && "\n    padding-left: " + left + "px;\n    padding-top: " + top + "px;\n    padding-right: " + right + "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: " + gap + "px " + important + ";\n    ",
        gapMode === 'padding' && "padding-right: " + gap + "px " + important + ";",
    ].filter(Boolean).join('') + "\n  }\n  \n  ." + zeroRightClassName + " {\n    right: " + gap + "px " + important + ";\n  }\n  \n  ." + fullWidthClassName + " {\n    margin-right: " + gap + "px " + important + ";\n  }\n  \n  ." + zeroRightClassName + " ." + zeroRightClassName + " {\n    right: 0 " + important + ";\n  }\n  \n  ." + fullWidthClassName + " ." + fullWidthClassName + " {\n    margin-right: 0 " + important + ";\n  }\n";
};
var RemoveScrollBar = (function (_super) {
    __extends(RemoveScrollBar, _super);
    function RemoveScrollBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            gap: getGapWidth(_this.props.gapMode)
        };
        _this.onResize = function () {
            _this.forceUpdate();
            if (_this.state.gap && _this.props.dynamic) {
                if (window.innerHeight > document.body.offsetHeight) {
                    _this.setGap(zeroGap);
                }
            }
        };
        return _this;
    }
    RemoveScrollBar.prototype.componentDidMount = function () {
        var gap = getGapWidth(this.props.gapMode);
        if (gap !== this.state.gap) {
            this.setGap(gap);
        }
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.onResize);
        }
    };
    RemoveScrollBar.prototype.componentWillUnmount = function () {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResize);
        }
    };
    RemoveScrollBar.prototype.componentDidUpdate = function () {
        if (!this.state.gap) {
            var gap = getGapWidth(this.props.gapMode);
            if (gap !== this.state.gap) {
                this.setGap(gap);
            }
        }
    };
    RemoveScrollBar.prototype.setGap = function (gap) {
        this.setState({ gap: gap });
    };
    RemoveScrollBar.prototype.render = function () {
        var _a = this.props, noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
        var gap = this.state.gap;
        return createElement$2(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : '') });
    };
    return RemoveScrollBar;
}(Component$1));

var elementCouldBeScrolled = function (node) {
    var styles = window.getComputedStyle(node);
    return (styles.overflowY !== 'hidden' &&
        !(styles.overflowY === styles.overflowX && styles.overflowY === 'visible'));
};
var handleScroll = function (endTarget, event, sourceDelta) {
    var delta = sourceDelta;
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var scrollTop = target.scrollTop, scrollHeight = target.scrollHeight, clientHeight = target.clientHeight;
        var elementScroll = scrollHeight - clientHeight - scrollTop;
        if (scrollTop || elementScroll) {
            if (elementCouldBeScrolled(target)) {
                availableScroll += elementScroll;
                availableScrollTop += scrollTop;
            }
        }
        target = target.parentNode;
    } while ((!targetInLock && target !== document.body) ||
        (targetInLock && (endTarget.contains(target) || endTarget === target)));
    if (isDeltaPositive && delta > availableScroll) {
        shouldCancelScroll = true;
    }
    else if (!isDeltaPositive && -delta > availableScrollTop) {
        shouldCancelScroll = true;
    }
    return shouldCancelScroll;
};

var passiveSupported = false;
if (typeof window !== 'undefined') {
    try {
        var options$1 = Object.defineProperty({}, 'passive', {
            get: function () {
                passiveSupported = true;
                return true;
            },
        });
        window.addEventListener('test', options$1, options$1);
        window.removeEventListener('test', options$1, options$1);
    }
    catch (err) {
        passiveSupported = false;
    }
}
var aggressive = passiveSupported ? { passive: false } : false;

var getTouchY = function (event) { return event.changedTouches ? event.changedTouches[0].clientY : 0; };
var classNames = {
    fullWidth: fullWidthClassName,
    zeroRight: zeroRightClassName,
};
var extractRef$1 = function (ref) { return ((ref && 'current' in ref) ? ref.current : ref); };
var RemoveScroll = (function (_super) {
    __extends(RemoveScroll, _super);
    function RemoveScroll() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shouldPreventQueue = [];
        _this.touchStart = 0;
        _this.ref = createRef();
        _this.shouldPrevent = function (event) {
            var stack = RemoveScroll.stack.filter(function (el) { return el.props.enabled; });
            if (!stack.length || stack[stack.length - 1] !== _this) {
                return;
            }
            var delta = event.deltaY || getTouchY(event);
            var sourceEvent = _this.shouldPreventQueue.filter(function (e) { return e.name === event.type && e.delta === delta && e.target === event.target; })[0];
            if (sourceEvent && sourceEvent.should) {
                event.preventDefault();
                return;
            }
            if (!sourceEvent) {
                var shardNodes = (_this.props.shards || [])
                    .map(extractRef$1)
                    .filter(Boolean)
                    .filter(function (node) { return node.contains(event.target); });
                var shouldStop = shardNodes.length > 0
                    ? _this.shouldCancelEvent(event, shardNodes[0])
                    : !_this.props.noIsolation;
                if (shouldStop) {
                    event.preventDefault();
                }
            }
        };
        _this.shouldCancel = function (name, delta, target, should) {
            var event = { name: name, delta: delta, target: target, should: should };
            _this.shouldPreventQueue.push(event);
            setTimeout(function () {
                _this.shouldPreventQueue = _this.shouldPreventQueue.filter(function (e) { return e !== event; });
            }, 1);
        };
        _this.scrollTouchStart = function (event) {
            _this.touchStart = getTouchY(event);
        };
        _this.scrollWheel = function (event) {
            _this.shouldCancel(event.type, event.deltaY, event.target, _this.shouldCancelEvent(event, _this.ref.current));
        };
        _this.scrollTouchMove = function (event) {
            _this.shouldCancel(event.type, getTouchY(event), event.target, _this.shouldCancelEvent(event, _this.ref.current));
        };
        return _this;
    }
    RemoveScroll.prototype.componentDidMount = function () {
        RemoveScroll.stack.push(this);
        this.componentDidUpdate({ enabled: false });
    };
    RemoveScroll.prototype.componentWillUnmount = function () {
        var _this = this;
        RemoveScroll.stack = RemoveScroll.stack.filter(function (inst) { return inst !== _this; });
        this.disable();
    };
    RemoveScroll.prototype.componentDidUpdate = function (oldProps) {
        if (oldProps.enabled !== this.props.enabled) {
            if (this.props.enabled) {
                this.enable();
            }
            else {
                this.disable();
            }
        }
    };
    RemoveScroll.prototype.enable = function () {
        if (typeof document !== 'undefined') {
            document.addEventListener('wheel', this.shouldPrevent, aggressive);
            document.addEventListener('touchmove', this.shouldPrevent, aggressive);
            document.addEventListener('touchstart', this.scrollTouchStart, aggressive);
        }
    };
    RemoveScroll.prototype.disable = function () {
        if (typeof window !== 'undefined') {
            document.removeEventListener('wheel', this.shouldPrevent, aggressive);
            document.removeEventListener('touchmove', this.shouldPrevent, aggressive);
            document.removeEventListener('touchstart', this.scrollTouchStart, aggressive);
        }
    };
    RemoveScroll.prototype.shouldCancelEvent = function (event, parent) {
        switch (event.type) {
            case 'wheel':
            case 'scroll':
                return handleScroll(parent, event, event.deltaY);
            case 'touchmove':
                return handleScroll(parent, event, this.touchStart - getTouchY(event));
        }
        return false;
    };
    RemoveScroll.prototype.render = function () {
        var _a = this.props, forwardProps = _a.forwardProps, children = _a.children, className = _a.className, removeScrollBar = _a.removeScrollBar, enabled = _a.enabled;
        var props = {
            ref: this.ref,
            onScrollCapture: this.scrollWheel,
            onWheelCapture: this.scrollWheel,
            onTouchMoveCapture: this.scrollTouchMove,
        };
        return (createElement$2(Fragment$1, null,
            removeScrollBar && enabled && createElement$2(RemoveScrollBar, { gapMode: "margin" }),
            forwardProps
                ? cloneElement(Children.only(children), props)
                : createElement$2("div", __assign({}, props, { className: className }), children)));
    };
    RemoveScroll.classNames = classNames;
    RemoveScroll.defaultProps = {
        enabled: true,
        removeScrollBar: true,
    };
    RemoveScroll.stack = [];
    return RemoveScroll;
}(Component$1));

var _extends$7n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties$2(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createAriaHider = function createAriaHider(dialogNode) {
  var originalValues = [];
  var rootNodes = [];

  Array.prototype.forEach.call(document.querySelectorAll("body > *"), function (node) {
    var portalNode = dialogNode.parentNode.parentNode.parentNode;
    if (node === portalNode) {
      return;
    }
    var attr = node.getAttribute("aria-hidden");
    var alreadyHidden = attr !== null && attr !== "false";
    if (alreadyHidden) {
      return;
    }
    originalValues.push(attr);
    rootNodes.push(node);
    node.setAttribute("aria-hidden", "true");
  });

  return function () {
    rootNodes.forEach(function (node, index) {
      var originalValue = originalValues[index];
      if (originalValue === null) {
        node.removeAttribute("aria-hidden");
      } else {
        node.setAttribute("aria-hidden", originalValue);
      }
    });
  };
};

var k = function k() {};

var checkDialogStyles = function checkDialogStyles() {
  return checkStyles("dialog");
};

var portalDidMount = function portalDidMount(refs) {
  refs.disposeAriaHider = createAriaHider(refs.overlayNode);
};

var contentWillUnmount = function contentWillUnmount(_ref) {
  var refs = _ref.refs;

  refs.disposeAriaHider();
};

var FocusContext = React__default.createContext();

var DialogOverlay = React__default.forwardRef(function (_ref2, forwardedRef) {
  var _ref2$isOpen = _ref2.isOpen,
      isOpen = _ref2$isOpen === undefined ? true : _ref2$isOpen,
      _ref2$onDismiss = _ref2.onDismiss,
      onDismiss = _ref2$onDismiss === undefined ? k : _ref2$onDismiss,
      initialFocusRef = _ref2.initialFocusRef,
      onClick = _ref2.onClick,
      onKeyDown = _ref2.onKeyDown,
      props = _objectWithoutProperties$2(_ref2, ["isOpen", "onDismiss", "initialFocusRef", "onClick", "onKeyDown"]);

  return React__default.createElement(
    Component,
    { didMount: checkDialogStyles },
    isOpen ? React__default.createElement(
      Portal,
      { "data-reach-dialog-wrapper": true },
      React__default.createElement(
        Component,
        {
          refs: { overlayNode: null },
          didMount: function didMount(_ref3) {
            var refs = _ref3.refs;

            portalDidMount(refs);
          },
          willUnmount: contentWillUnmount
        },
        function (_ref4) {
          var refs = _ref4.refs;
          return React__default.createElement(
            FocusLock,
            {
              returnFocus: true,
              onActivation: function onActivation() {
                if (initialFocusRef) {
                  initialFocusRef.current.focus();
                }
              }
            },
            React__default.createElement(
              RemoveScroll,
              null,
              React__default.createElement("div", _extends$7n({
                "data-reach-dialog-overlay": true,
                onClick: wrapEvent(onClick, function (event) {
                  event.stopPropagation();
                  onDismiss();
                }),
                onKeyDown: wrapEvent(onKeyDown, function (event) {
                  if (event.key === "Escape") {
                    event.stopPropagation();
                    onDismiss();
                  }
                }),
                ref: function ref(node) {
                  refs.overlayNode = node;
                  assignRef(forwardedRef, node);
                }
              }, props))
            )
          );
        }
      )
    ) : null
  );
});

DialogOverlay.propTypes = {
  initialFocusRef: function initialFocusRef() {}
};

var stopPropagation = function stopPropagation(event) {
  return event.stopPropagation();
};

var DialogContent = React__default.forwardRef(function (_ref5, forwardedRef) {
  var onClick = _ref5.onClick,
      onKeyDown = _ref5.onKeyDown,
      props = _objectWithoutProperties$2(_ref5, ["onClick", "onKeyDown"]);

  return React__default.createElement("div", _extends$7n({
    "aria-modal": "true",
    "data-reach-dialog-content": true,
    tabIndex: "-1",
    onClick: wrapEvent(onClick, stopPropagation),
    ref: function ref(node) {
      assignRef(forwardedRef, node);
    }
  }, props));
});

var Dialog = function Dialog(_ref6) {
  var isOpen = _ref6.isOpen,
      _ref6$onDismiss = _ref6.onDismiss,
      onDismiss = _ref6$onDismiss === undefined ? k : _ref6$onDismiss,
      initialFocusRef = _ref6.initialFocusRef,
      props = _objectWithoutProperties$2(_ref6, ["isOpen", "onDismiss", "initialFocusRef"]);

  return React__default.createElement(
    DialogOverlay,
    {
      isOpen: isOpen,
      onDismiss: onDismiss,
      initialFocusRef: initialFocusRef
    },
    React__default.createElement(DialogContent, props)
  );
};

process.env.NODE_ENV !== "production" ? Dialog.propTypes = {
  isOpen: bool,
  onDismiss: func
} : void 0;

const is = {
  arr: Array.isArray,
  obj: a => Object.prototype.toString.call(a) === '[object Object]',
  fun: a => typeof a === 'function',
  str: a => typeof a === 'string',
  num: a => typeof a === 'number',
  und: a => a === void 0,
  nul: a => a === null,
  set: a => a instanceof Set,
  map: a => a instanceof Map,

  equ(a, b) {
    if (typeof a !== typeof b) return false;
    if (is.str(a) || is.num(a)) return a === b;
    if (is.obj(a) && is.obj(b) && Object.keys(a).length + Object.keys(b).length === 0) return true;
    let i;

    for (i in a) if (!(i in b)) return false;

    for (i in b) if (a[i] !== b[i]) return false;

    return is.und(i) ? a === b : true;
  }

};
function merge$1(target, lowercase) {
  if (lowercase === void 0) {
    lowercase = true;
  }

  return object => (is.arr(object) ? object : Object.keys(object)).reduce((acc, element) => {
    const key = lowercase ? element[0].toLowerCase() + element.substring(1) : element;
    acc[key] = target(key);
    return acc;
  }, target);
}
function useForceUpdate() {
  const _useState = useState(false),
        f = _useState[1];

  const forceUpdate = useCallback(() => f(v => !v), []);
  return forceUpdate;
}
function withDefault(value, defaultValue) {
  return is.und(value) || is.nul(value) ? defaultValue : value;
}
function toArray$1(a) {
  return !is.und(a) ? is.arr(a) ? a : [a] : [];
}
function callProp(obj) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return is.fun(obj) ? obj(...args) : obj;
}

function getForwardProps(props) {
  const to = props.to,
        from = props.from,
        config = props.config,
        onStart = props.onStart,
        onRest = props.onRest,
        onFrame = props.onFrame,
        children = props.children,
        reset = props.reset,
        reverse = props.reverse,
        force = props.force,
        immediate = props.immediate,
        delay = props.delay,
        attach = props.attach,
        destroyed = props.destroyed,
        interpolateTo = props.interpolateTo,
        ref = props.ref,
        lazy = props.lazy,
        forward = _objectWithoutPropertiesLoose$1(props, ["to", "from", "config", "onStart", "onRest", "onFrame", "children", "reset", "reverse", "force", "immediate", "delay", "attach", "destroyed", "interpolateTo", "ref", "lazy"]);

  return forward;
}

function interpolateTo(props) {
  const forward = getForwardProps(props);
  if (is.und(forward)) return _extends$7j({
    to: forward
  }, props);
  const rest = Object.keys(props).reduce((a, k) => !is.und(forward[k]) ? a : _extends$7j({}, a, {
    [k]: props[k]
  }), {});
  return _extends$7j({
    to: forward
  }, rest);
}
function handleRef(ref, forward) {
  if (forward) {
    // If it's a function, assume it's a ref callback
    if (is.fun(forward)) forward(ref);else if (is.obj(forward)) {
      forward.current = ref;
    }
  }

  return ref;
}

class Animated {
  constructor() {
    this.payload = void 0;
    this.children = [];
  }

  getAnimatedValue() {
    return this.getValue();
  }

  getPayload() {
    return this.payload || this;
  }

  attach() {}

  detach() {}

  getChildren() {
    return this.children;
  }

  addChild(child) {
    if (this.children.length === 0) this.attach();
    this.children.push(child);
  }

  removeChild(child) {
    const index = this.children.indexOf(child);
    this.children.splice(index, 1);
    if (this.children.length === 0) this.detach();
  }

}
class AnimatedArray extends Animated {
  constructor() {
    super(...arguments);
    this.payload = [];

    this.attach = () => this.payload.forEach(p => p instanceof Animated && p.addChild(this));

    this.detach = () => this.payload.forEach(p => p instanceof Animated && p.removeChild(this));
  }

}
class AnimatedObject extends Animated {
  constructor() {
    super(...arguments);
    this.payload = {};

    this.attach = () => Object.values(this.payload).forEach(s => s instanceof Animated && s.addChild(this));

    this.detach = () => Object.values(this.payload).forEach(s => s instanceof Animated && s.removeChild(this));
  }

  getValue(animated) {
    if (animated === void 0) {
      animated = false;
    }

    const payload = {};

    for (const key in this.payload) {
      const value = this.payload[key];
      if (animated && !(value instanceof Animated)) continue;
      payload[key] = value instanceof Animated ? value[animated ? 'getAnimatedValue' : 'getValue']() : value;
    }

    return payload;
  }

  getAnimatedValue() {
    return this.getValue(true);
  }

}

let applyAnimatedValues;
function injectApplyAnimatedValues(fn, transform) {
  applyAnimatedValues = {
    fn,
    transform
  };
}
let colorNames;
function injectColorNames(names) {
  colorNames = names;
}
let requestFrame = cb => typeof window !== 'undefined' ? window.requestAnimationFrame(cb) : -1;
let interpolation;
function injectStringInterpolator(fn) {
  interpolation = fn;
}
let now = () => Date.now();
let animatedApi = node => node.current;
let createAnimatedStyle;
function injectCreateAnimatedStyle(factory) {
  createAnimatedStyle = factory;
}

/**
 * Wraps the `style` property with `AnimatedStyle`.
 */

class AnimatedProps extends AnimatedObject {
  constructor(props, callback) {
    super();
    this.update = void 0;
    this.payload = !props.style ? props : _extends$7j({}, props, {
      style: createAnimatedStyle(props.style)
    });
    this.update = callback;
    this.attach();
  }

}

const isFunctionComponent = val => is.fun(val) && !(val.prototype instanceof React__default.Component);

const createAnimatedComponent = Component => {
  const AnimatedComponent = forwardRef((props, ref) => {
    const forceUpdate = useForceUpdate();
    const mounted = useRef(true);
    const propsAnimated = useRef(null);
    const node = useRef(null);
    const attachProps = useCallback(props => {
      const oldPropsAnimated = propsAnimated.current;

      const callback = () => {
        let didUpdate = false;

        if (node.current) {
          didUpdate = applyAnimatedValues.fn(node.current, propsAnimated.current.getAnimatedValue());
        }

        if (!node.current || didUpdate === false) {
          // If no referenced node has been found, or the update target didn't have a
          // native-responder, then forceUpdate the animation ...
          forceUpdate();
        }
      };

      propsAnimated.current = new AnimatedProps(props, callback);
      oldPropsAnimated && oldPropsAnimated.detach();
    }, []);
    useEffect(() => () => {
      mounted.current = false;
      propsAnimated.current && propsAnimated.current.detach();
    }, []);
    useImperativeHandle(ref, () => animatedApi(node));
    attachProps(props);

    const _getValue = propsAnimated.current.getValue(),
          scrollTop = _getValue.scrollTop,
          scrollLeft = _getValue.scrollLeft,
          animatedProps = _objectWithoutPropertiesLoose$1(_getValue, ["scrollTop", "scrollLeft"]); // Functions cannot have refs, see:
    // See: https://github.com/react-spring/react-spring/issues/569


    const refFn = isFunctionComponent(Component) ? undefined : childRef => node.current = handleRef(childRef, ref);
    return React__default.createElement(Component, _extends$7j({}, animatedProps, {
      ref: refFn
    }));
  });
  return AnimatedComponent;
};

let active = false;
const controllers = new Set();

const update = () => {
  if (!active) return false;
  let time = now();

  for (let controller of controllers) {
    let isActive = false;

    for (let configIdx = 0; configIdx < controller.configs.length; configIdx++) {
      let config = controller.configs[configIdx];
      let endOfAnimation, lastTime;

      for (let valIdx = 0; valIdx < config.animatedValues.length; valIdx++) {
        let animation = config.animatedValues[valIdx]; // If an animation is done, skip, until all of them conclude

        if (animation.done) continue;
        let from = config.fromValues[valIdx];
        let to = config.toValues[valIdx];
        let position = animation.lastPosition;
        let isAnimated = to instanceof Animated;
        let velocity = Array.isArray(config.initialVelocity) ? config.initialVelocity[valIdx] : config.initialVelocity;
        if (isAnimated) to = to.getValue(); // Conclude animation if it's either immediate, or from-values match end-state

        if (config.immediate) {
          animation.setValue(to);
          animation.done = true;
          continue;
        } // Break animation when string values are involved


        if (typeof from === 'string' || typeof to === 'string') {
          animation.setValue(to);
          animation.done = true;
          continue;
        }

        if (config.duration !== void 0) {
          /** Duration easing */
          position = from + config.easing((time - animation.startTime) / config.duration) * (to - from);
          endOfAnimation = time >= animation.startTime + config.duration;
        } else if (config.decay) {
          /** Decay easing */
          position = from + velocity / (1 - 0.998) * (1 - Math.exp(-(1 - 0.998) * (time - animation.startTime)));
          endOfAnimation = Math.abs(animation.lastPosition - position) < 0.1;
          if (endOfAnimation) to = position;
        } else {
          /** Spring easing */
          lastTime = animation.lastTime !== void 0 ? animation.lastTime : time;
          velocity = animation.lastVelocity !== void 0 ? animation.lastVelocity : config.initialVelocity; // If we lost a lot of frames just jump to the end.

          if (time > lastTime + 64) lastTime = time; // http://gafferongames.com/game-physics/fix-your-timestep/

          let numSteps = Math.floor(time - lastTime);

          for (let i = 0; i < numSteps; ++i) {
            let force = -config.tension * (position - to);
            let damping = -config.friction * velocity;
            let acceleration = (force + damping) / config.mass;
            velocity = velocity + acceleration * 1 / 1000;
            position = position + velocity * 1 / 1000;
          } // Conditions for stopping the spring animation


          let isOvershooting = config.clamp && config.tension !== 0 ? from < to ? position > to : position < to : false;
          let isVelocity = Math.abs(velocity) <= config.precision;
          let isDisplacement = config.tension !== 0 ? Math.abs(to - position) <= config.precision : true;
          endOfAnimation = isOvershooting || isVelocity && isDisplacement;
          animation.lastVelocity = velocity;
          animation.lastTime = time;
        } // Trails aren't done until their parents conclude


        if (isAnimated && !config.toValues[valIdx].done) endOfAnimation = false;

        if (endOfAnimation) {
          // Ensure that we end up with a round value
          if (animation.value !== to) position = to;
          animation.done = true;
        } else isActive = true;

        animation.setValue(position);
        animation.lastPosition = position;
      } // Keep track of updated values only when necessary


      if (controller.props.onFrame) controller.values[config.name] = config.interpolation.getValue();
    } // Update callbacks in the end of the frame


    if (controller.props.onFrame) controller.props.onFrame(controller.values); // Either call onEnd or next frame

    if (!isActive) {
      controllers.delete(controller);
      controller.stop(true);
    }
  } // Loop over as long as there are controllers ...


  if (controllers.size) {
    requestFrame(update);
  } else {
    active = false;
  }

  return active;
};

const start$1 = controller => {
  if (!controllers.has(controller)) controllers.add(controller);

  if (!active) {
    active = true;
    requestFrame(update);
  }
};

const stop = controller => {
  if (controllers.has(controller)) controllers.delete(controller);
};

function createInterpolator(range, output, extrapolate) {
  if (typeof range === 'function') {
    return range;
  }

  if (Array.isArray(range)) {
    return createInterpolator({
      range,
      output: output,
      extrapolate
    });
  }

  if (interpolation && typeof range.output[0] === 'string') {
    return interpolation(range);
  }

  const config = range;
  const outputRange = config.output;
  const inputRange = config.range || [0, 1];
  const extrapolateLeft = config.extrapolateLeft || config.extrapolate || 'extend';
  const extrapolateRight = config.extrapolateRight || config.extrapolate || 'extend';

  const easing = config.easing || (t => t);

  return input => {
    const range = findRange(input, inputRange);
    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
  };
}

function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  let result = map ? map(input) : input; // Extrapolate

  if (result < inputMin) {
    if (extrapolateLeft === 'identity') return result;else if (extrapolateLeft === 'clamp') result = inputMin;
  }

  if (result > inputMax) {
    if (extrapolateRight === 'identity') return result;else if (extrapolateRight === 'clamp') result = inputMax;
  }

  if (outputMin === outputMax) return outputMin;
  if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax; // Input Range

  if (inputMin === -Infinity) result = -result;else if (inputMax === Infinity) result = result - inputMin;else result = (result - inputMin) / (inputMax - inputMin); // Easing

  result = easing(result); // Output Range

  if (outputMin === -Infinity) result = -result;else if (outputMax === Infinity) result = result + outputMin;else result = result * (outputMax - outputMin) + outputMin;
  return result;
}

function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i) if (inputRange[i] >= input) break;

  return i - 1;
}

class AnimatedInterpolation extends AnimatedArray {
  constructor(parents, range, output, extrapolate) {
    super();
    this.calc = void 0;
    this.payload = parents instanceof AnimatedArray && !(parents instanceof AnimatedInterpolation) ? parents.getPayload() : Array.isArray(parents) ? parents : [parents];
    this.calc = createInterpolator(range, output, extrapolate);
  }

  getValue() {
    return this.calc(...this.payload.map(value => value.getValue()));
  }

  updateConfig(range, output, extrapolate) {
    this.calc = createInterpolator(range, output, extrapolate);
  }

  interpolate(range, output, extrapolate) {
    return new AnimatedInterpolation(this, range, output, extrapolate);
  }

}

/**
 * Animated works by building a directed acyclic graph of dependencies
 * transparently when you render your Animated components.
 *
 *               new Animated.Value(0)
 *     .interpolate()        .interpolate()    new Animated.Value(1)
 *         opacity               translateY      scale
 *          style                         transform
 *         View#234                         style
 *                                         View#123
 *
 * A) Top Down phase
 * When an AnimatedValue is updated, we recursively go down through this
 * graph in order to find leaf nodes: the views that we flag as needing
 * an update.
 *
 * B) Bottom Up phase
 * When a view is flagged as needing an update, we recursively go back up
 * in order to build the new value that it needs. The reason why we need
 * this two-phases process is to deal with composite props such as
 * transform which can receive values from multiple parents.
 */
function addAnimatedStyles(node, styles) {
  if ('update' in node) {
    styles.add(node);
  } else {
    node.getChildren().forEach(child => addAnimatedStyles(child, styles));
  }
}

class AnimatedValue extends Animated {
  constructor(_value) {
    var _this;

    super();
    _this = this;
    this.animatedStyles = new Set();
    this.value = void 0;
    this.startPosition = void 0;
    this.lastPosition = void 0;
    this.lastVelocity = void 0;
    this.startTime = void 0;
    this.lastTime = void 0;
    this.done = false;

    this.setValue = function (value, flush) {
      if (flush === void 0) {
        flush = true;
      }

      _this.value = value;
      if (flush) _this.flush();
    };

    this.value = _value;
    this.startPosition = _value;
    this.lastPosition = _value;
  }

  flush() {
    if (this.animatedStyles.size === 0) {
      addAnimatedStyles(this, this.animatedStyles);
    }

    this.animatedStyles.forEach(animatedStyle => animatedStyle.update());
  }

  clearStyles() {
    this.animatedStyles.clear();
  }

  getValue() {
    return this.value;
  }

  interpolate(range, output, extrapolate) {
    return new AnimatedInterpolation(this, range, output, extrapolate);
  }

}

class AnimatedValueArray extends AnimatedArray {
  constructor(values) {
    super();
    this.payload = values.map(n => new AnimatedValue(n));
  }

  setValue(value, flush) {
    if (flush === void 0) {
      flush = true;
    }

    if (Array.isArray(value)) {
      if (value.length === this.payload.length) {
        value.forEach((v, i) => this.payload[i].setValue(v, flush));
      }
    } else {
      this.payload.forEach(p => p.setValue(value, flush));
    }
  }

  getValue() {
    return this.payload.map(v => v.getValue());
  }

  interpolate(range, output) {
    return new AnimatedInterpolation(this, range, output);
  }

}

let G = 0;

class Controller {
  constructor() {
    this.id = void 0;
    this.idle = true;
    this.hasChanged = false;
    this.guid = 0;
    this.local = 0;
    this.props = {};
    this.merged = {};
    this.animations = {};
    this.interpolations = {};
    this.values = {};
    this.configs = [];
    this.listeners = [];
    this.queue = [];
    this.localQueue = void 0;

    this.getValues = () => this.interpolations;

    this.id = G++;
  }
  /** update(props)
   *  This function filters input props and creates an array of tasks which are executed in .start()
   *  Each task is allowed to carry a delay, which means it can execute asnychroneously */


  update(args) {
    //this._id = n + this.id
    if (!args) return this; // Extract delay and the to-prop from props

    const _ref = interpolateTo(args),
          _ref$delay = _ref.delay,
          delay = _ref$delay === void 0 ? 0 : _ref$delay,
          to = _ref.to,
          props = _objectWithoutPropertiesLoose$1(_ref, ["delay", "to"]);

    if (is.arr(to) || is.fun(to)) {
      // If config is either a function or an array queue it up as is
      this.queue.push(_extends$7j({}, props, {
        delay,
        to
      }));
    } else if (to) {
      // Otherwise go through each key since it could be delayed individually
      let ops = {};
      Object.entries(to).forEach((_ref2) => {
        let k = _ref2[0],
            v = _ref2[1];

        // Fetch delay and create an entry, consisting of the to-props, the delay, and basic props
        const entry = _extends$7j({
          to: {
            [k]: v
          },
          delay: callProp(delay, k)
        }, props);

        const previous = ops[entry.delay] && ops[entry.delay].to;
        ops[entry.delay] = _extends$7j({}, ops[entry.delay], entry, {
          to: _extends$7j({}, previous, entry.to)
        });
      });
      this.queue = Object.values(ops);
    } // Sort queue, so that async calls go last


    this.queue = this.queue.sort((a, b) => a.delay - b.delay); // Diff the reduced props immediately (they'll contain the from-prop and some config)

    this.diff(props);
    return this;
  }
  /** start(onEnd)
   *  This function either executes a queue, if present, or starts the frameloop, which animates */


  start(onEnd) {
    // If a queue is present we must excecute it
    if (this.queue.length) {
      this.idle = false; // Updates can interrupt trailing queues, in that case we just merge values

      if (this.localQueue) {
        this.localQueue.forEach((_ref3) => {
          let _ref3$from = _ref3.from,
              from = _ref3$from === void 0 ? {} : _ref3$from,
              _ref3$to = _ref3.to,
              to = _ref3$to === void 0 ? {} : _ref3$to;
          if (is.obj(from)) this.merged = _extends$7j({}, from, this.merged);
          if (is.obj(to)) this.merged = _extends$7j({}, this.merged, to);
        });
      } // The guid helps us tracking frames, a new queue over an old one means an override
      // We discard async calls in that caseÍ


      const local = this.local = ++this.guid;
      const queue = this.localQueue = this.queue;
      this.queue = []; // Go through each entry and execute it

      queue.forEach((_ref4, index) => {
        let delay = _ref4.delay,
            props = _objectWithoutPropertiesLoose$1(_ref4, ["delay"]);

        const cb = finished => {
          if (index === queue.length - 1 && local === this.guid && finished) {
            this.idle = true;
            if (this.props.onRest) this.props.onRest(this.merged);
          }

          if (onEnd) onEnd();
        }; // Entries can be delayed, ansyc or immediate


        let async = is.arr(props.to) || is.fun(props.to);

        if (delay) {
          setTimeout(() => {
            if (local === this.guid) {
              if (async) this.runAsync(props, cb);else this.diff(props).start(cb);
            }
          }, delay);
        } else if (async) this.runAsync(props, cb);else this.diff(props).start(cb);
      });
    } // Otherwise we kick of the frameloop
    else {
        if (is.fun(onEnd)) this.listeners.push(onEnd);
        if (this.props.onStart) this.props.onStart();
        start$1(this);
      }

    return this;
  }

  stop(finished) {
    this.listeners.forEach(onEnd => onEnd(finished));
    this.listeners = [];
    return this;
  }
  /** Pause sets onEnd listeners free, but also removes the controller from the frameloop */


  pause(finished) {
    this.stop(true);
    if (finished) stop(this);
    return this;
  }

  runAsync(_ref5, onEnd) {
    var _this = this;

    let delay = _ref5.delay,
        props = _objectWithoutPropertiesLoose$1(_ref5, ["delay"]);

    const local = this.local; // If "to" is either a function or an array it will be processed async, therefor "to" should be empty right now
    // If the view relies on certain values "from" has to be present

    let queue = Promise.resolve(undefined);

    if (is.arr(props.to)) {
      for (let i = 0; i < props.to.length; i++) {
        const index = i;

        const fresh = _extends$7j({}, props, interpolateTo(props.to[index]));

        if (is.arr(fresh.config)) fresh.config = fresh.config[index];
        queue = queue.then(() => {
          //this.stop()
          if (local === this.guid) return new Promise(r => this.diff(fresh).start(r));
        });
      }
    } else if (is.fun(props.to)) {
      let index = 0;
      let last;
      queue = queue.then(() => props.to( // next(props)
      p => {
        const fresh = _extends$7j({}, props, interpolateTo(p));

        if (is.arr(fresh.config)) fresh.config = fresh.config[index];
        index++; //this.stop()

        if (local === this.guid) return last = new Promise(r => this.diff(fresh).start(r));
        return;
      }, // cancel()
      function (finished) {
        if (finished === void 0) {
          finished = true;
        }

        return _this.stop(finished);
      }).then(() => last));
    }

    queue.then(onEnd);
  }

  diff(props) {
    this.props = _extends$7j({}, this.props, props);
    let _this$props = this.props,
        _this$props$from = _this$props.from,
        from = _this$props$from === void 0 ? {} : _this$props$from,
        _this$props$to = _this$props.to,
        to = _this$props$to === void 0 ? {} : _this$props$to,
        _this$props$config = _this$props.config,
        config = _this$props$config === void 0 ? {} : _this$props$config,
        reverse = _this$props.reverse,
        attach = _this$props.attach,
        reset = _this$props.reset,
        immediate = _this$props.immediate; // Reverse values when requested

    if (reverse) {
      var _ref6 = [to, from];
      from = _ref6[0];
      to = _ref6[1];
    } // This will collect all props that were ever set, reset merged props when necessary


    this.merged = _extends$7j({}, from, this.merged, to);
    this.hasChanged = false; // Attachment handling, trailed springs can "attach" themselves to a previous spring

    let target = attach && attach(this); // Reduces input { name: value } pairs into animated values

    this.animations = Object.entries(this.merged).reduce((acc, _ref7) => {
      let name = _ref7[0],
          value = _ref7[1];
      // Issue cached entries, except on reset
      let entry = acc[name] || {}; // Figure out what the value is supposed to be

      const isNumber = is.num(value);
      const isString = is.str(value) && !value.startsWith('#') && !/\d/.test(value) && !colorNames[value];
      const isArray = is.arr(value);
      const isInterpolation = !isNumber && !isArray && !isString;
      let fromValue = !is.und(from[name]) ? from[name] : value;
      let toValue = isNumber || isArray ? value : isString ? value : 1;
      let toConfig = callProp(config, name);
      if (target) toValue = target.animations[name].parent;
      let parent = entry.parent,
          interpolation$$1 = entry.interpolation,
          toValues = toArray$1(target ? toValue.getPayload() : toValue),
          animatedValues;
      let newValue = value;
      if (isInterpolation) newValue = interpolation({
        range: [0, 1],
        output: [value, value]
      })(1);
      let currentValue = interpolation$$1 && interpolation$$1.getValue(); // Change detection flags

      const isFirst = is.und(parent);
      const isActive = !isFirst && entry.animatedValues.some(v => !v.done);
      const currentValueDiffersFromGoal = !is.equ(newValue, currentValue);
      const hasNewGoal = !is.equ(newValue, entry.previous);
      const hasNewConfig = !is.equ(toConfig, entry.config); // Change animation props when props indicate a new goal (new value differs from previous one)
      // and current values differ from it. Config changes trigger a new update as well (though probably shouldn't?)

      if (reset || hasNewGoal && currentValueDiffersFromGoal || hasNewConfig) {
        // Convert regular values into animated values, ALWAYS re-use if possible
        if (isNumber || isString) parent = interpolation$$1 = entry.parent || new AnimatedValue(fromValue);else if (isArray) parent = interpolation$$1 = entry.parent || new AnimatedValueArray(fromValue);else if (isInterpolation) {
          let prev = entry.interpolation && entry.interpolation.calc(entry.parent.value);
          prev = prev !== void 0 && !reset ? prev : fromValue;

          if (entry.parent) {
            parent = entry.parent;
            parent.setValue(0, false);
          } else parent = new AnimatedValue(0);

          const range = {
            output: [prev, value]
          };

          if (entry.interpolation) {
            interpolation$$1 = entry.interpolation;
            entry.interpolation.updateConfig(range);
          } else interpolation$$1 = parent.interpolate(range);
        }
        toValues = toArray$1(target ? toValue.getPayload() : toValue);
        animatedValues = toArray$1(parent.getPayload());
        if (reset && !isInterpolation) parent.setValue(fromValue, false);
        this.hasChanged = true; // Reset animated values

        animatedValues.forEach(value => {
          value.startPosition = value.value;
          value.lastPosition = value.value;
          value.lastVelocity = isActive ? value.lastVelocity : undefined;
          value.lastTime = isActive ? value.lastTime : undefined;
          value.startTime = now();
          value.done = false;
          value.animatedStyles.clear();
        }); // Set immediate values

        if (callProp(immediate, name)) {
          parent.setValue(isInterpolation ? toValue : value, false);
        }

        return _extends$7j({}, acc, {
          [name]: _extends$7j({}, entry, {
            name,
            parent,
            interpolation: interpolation$$1,
            animatedValues,
            toValues,
            previous: newValue,
            config: toConfig,
            fromValues: toArray$1(parent.getValue()),
            immediate: callProp(immediate, name),
            initialVelocity: withDefault(toConfig.velocity, 0),
            clamp: withDefault(toConfig.clamp, false),
            precision: withDefault(toConfig.precision, 0.01),
            tension: withDefault(toConfig.tension, 170),
            friction: withDefault(toConfig.friction, 26),
            mass: withDefault(toConfig.mass, 1),
            duration: toConfig.duration,
            easing: withDefault(toConfig.easing, t => t),
            decay: toConfig.decay
          })
        });
      } else {
        if (!currentValueDiffersFromGoal) {
          // So ... the current target value (newValue) appears to be different from the previous value,
          // which normally constitutes an update, but the actual value (currentValue) matches the target!
          // In order to resolve this without causing an animation update we silently flag the animation as done,
          // which it technically is. Interpolations also needs a config update with their target set to 1.
          if (isInterpolation) {
            parent.setValue(1, false);
            interpolation$$1.updateConfig({
              output: [newValue, newValue]
            });
          }

          parent.done = true;
          this.hasChanged = true;
          return _extends$7j({}, acc, {
            [name]: _extends$7j({}, acc[name], {
              previous: newValue
            })
          });
        }

        return acc;
      }
    }, this.animations);

    if (this.hasChanged) {
      // Make animations available to frameloop
      this.configs = Object.values(this.animations);
      this.values = {};
      this.interpolations = {};

      for (let key in this.animations) {
        this.interpolations[key] = this.animations[key].interpolation;
        this.values[key] = this.animations[key].interpolation.getValue();
      }
    }

    return this;
  }

  destroy() {
    this.stop();
    this.props = {};
    this.merged = {};
    this.animations = {};
    this.interpolations = {};
    this.values = {};
    this.configs = [];
    this.local = 0;
  }

}

/** API
 * const transitions = useTransition(items, itemKeys, { ... })
 * const [transitions, update] = useTransition(items, itemKeys, () => ({ ... }))
 */

let guid = 0;
const ENTER = 'enter';
const LEAVE = 'leave';
const UPDATE = 'update';

const mapKeys = (items, keys) => (typeof keys === 'function' ? items.map(keys) : toArray$1(keys)).map(String);

const get = props => {
  let items = props.items,
      _props$keys = props.keys,
      keys = _props$keys === void 0 ? item => item : _props$keys,
      rest = _objectWithoutPropertiesLoose$1(props, ["items", "keys"]);

  items = toArray$1(items !== void 0 ? items : null);
  return _extends$7j({
    items,
    keys: mapKeys(items, keys)
  }, rest);
};

function useTransition(input, keyTransform, config) {
  const props = _extends$7j({
    items: input,
    keys: keyTransform || (i => i)
  }, config);

  const _get = get(props),
        _get$lazy = _get.lazy,
        lazy = _get$lazy === void 0 ? false : _get$lazy,
        _get$unique = _get.unique,
        _get$reset = _get.reset,
        reset = _get$reset === void 0 ? false : _get$reset,
        enter = _get.enter,
        leave = _get.leave,
        update = _get.update,
        onDestroyed = _get.onDestroyed,
        keys = _get.keys,
        items = _get.items,
        onFrame = _get.onFrame,
        _onRest = _get.onRest,
        onStart = _get.onStart,
        ref = _get.ref,
        extra = _objectWithoutPropertiesLoose$1(_get, ["lazy", "unique", "reset", "enter", "leave", "update", "onDestroyed", "keys", "items", "onFrame", "onRest", "onStart", "ref"]);

  const forceUpdate = useForceUpdate();
  const mounted = useRef(false);
  const state = useRef({
    mounted: false,
    first: true,
    deleted: [],
    current: {},
    transitions: [],
    prevProps: {},
    paused: !!props.ref,
    instances: !mounted.current && new Map(),
    forceUpdate
  });
  useImperativeHandle(props.ref, () => ({
    start: () => Promise.all(Array.from(state.current.instances).map((_ref) => {
      let c = _ref[1];
      return new Promise(r => c.start(r));
    })),
    stop: finished => Array.from(state.current.instances).forEach((_ref2) => {
      let c = _ref2[1];
      return c.stop(finished);
    }),

    get controllers() {
      return Array.from(state.current.instances).map((_ref3) => {
        let c = _ref3[1];
        return c;
      });
    }

  })); // Update state

  state.current = diffItems(state.current, props);

  if (state.current.changed) {
    // Update state
    state.current.transitions.forEach(transition => {
      const slot = transition.slot,
            from = transition.from,
            to = transition.to,
            config = transition.config,
            trail = transition.trail,
            key = transition.key,
            item = transition.item;
      if (!state.current.instances.has(key)) state.current.instances.set(key, new Controller()); // update the map object

      const ctrl = state.current.instances.get(key);

      const newProps = _extends$7j({}, extra, {
        to,
        from,
        config,
        ref,
        onRest: values => {
          if (state.current.mounted) {
            if (transition.destroyed) {
              // If no ref is given delete destroyed items immediately
              if (!ref && !lazy) cleanUp(state, key);
              if (onDestroyed) onDestroyed(item);
            } // A transition comes to rest once all its springs conclude


            const curInstances = Array.from(state.current.instances);
            const active = curInstances.some((_ref4) => {
              let c = _ref4[1];
              return !c.idle;
            });
            if (!active && (ref || lazy) && state.current.deleted.length > 0) cleanUp(state);
            if (_onRest) _onRest(item, slot, values);
          }
        },
        onStart: onStart && (() => onStart(item, slot)),
        onFrame: onFrame && (values => onFrame(item, slot, values)),
        delay: trail,
        reset: reset && slot === ENTER // Update controller

      });

      ctrl.update(newProps);
      if (!state.current.paused) ctrl.start();
    });
  }

  useEffect(() => {
    state.current.mounted = mounted.current = true;
    return () => {
      state.current.mounted = mounted.current = false;
      Array.from(state.current.instances).map((_ref5) => {
        let c = _ref5[1];
        return c.destroy();
      });
      state.current.instances.clear();
    };
  }, []);
  return state.current.transitions.map((_ref6) => {
    let item = _ref6.item,
        slot = _ref6.slot,
        key = _ref6.key;
    return {
      item,
      key,
      state: slot,
      props: state.current.instances.get(key).getValues()
    };
  });
}

function cleanUp(state, filterKey) {
  const deleted = state.current.deleted;

  for (let _ref7 of deleted) {
    let key = _ref7.key;

    const filter = t => t.key !== key;

    if (is.und(filterKey) || filterKey === key) {
      state.current.instances.delete(key);
      state.current.transitions = state.current.transitions.filter(filter);
      state.current.deleted = state.current.deleted.filter(filter);
    }
  }

  state.current.forceUpdate();
}

function diffItems(_ref8, props) {
  let first = _ref8.first,
      prevProps = _ref8.prevProps,
      state = _objectWithoutPropertiesLoose$1(_ref8, ["first", "prevProps"]);

  let _get2 = get(props),
      items = _get2.items,
      keys = _get2.keys,
      initial = _get2.initial,
      from = _get2.from,
      enter = _get2.enter,
      leave = _get2.leave,
      update = _get2.update,
      _get2$trail = _get2.trail,
      trail = _get2$trail === void 0 ? 0 : _get2$trail,
      unique = _get2.unique,
      config = _get2.config,
      _get2$order = _get2.order,
      order = _get2$order === void 0 ? [ENTER, LEAVE, UPDATE] : _get2$order;

  let _get3 = get(prevProps),
      _keys = _get3.keys,
      _items = _get3.items;

  let current = _extends$7j({}, state.current);

  let deleted = [...state.deleted]; // Compare next keys with current keys

  let currentKeys = Object.keys(current);
  let currentSet = new Set(currentKeys);
  let nextSet = new Set(keys);
  let added = keys.filter(item => !currentSet.has(item));
  let removed = state.transitions.filter(item => !item.destroyed && !nextSet.has(item.originalKey)).map(i => i.originalKey);
  let updated = keys.filter(item => currentSet.has(item));
  let delay = -trail;

  while (order.length) {
    const changeType = order.shift();

    switch (changeType) {
      case ENTER:
        {
          added.forEach((key, index) => {
            // In unique mode, remove fading out transitions if their key comes in again
            if (unique && deleted.find(d => d.originalKey === key)) deleted = deleted.filter(t => t.originalKey !== key);
            const keyIndex = keys.indexOf(key);
            const item = items[keyIndex];
            const slot = first && initial !== void 0 ? 'initial' : ENTER;
            current[key] = {
              slot,
              originalKey: key,
              key: unique ? String(key) : guid++,
              item,
              trail: delay = delay + trail,
              config: callProp(config, item, slot),
              from: callProp(first ? initial !== void 0 ? initial || {} : from : from, item),
              to: callProp(enter, item)
            };
          });
          break;
        }

      case LEAVE:
        {
          removed.forEach(key => {
            const keyIndex = _keys.indexOf(key);

            const item = _items[keyIndex];
            const slot = LEAVE;
            deleted.unshift(_extends$7j({}, current[key], {
              slot,
              destroyed: true,
              left: _keys[Math.max(0, keyIndex - 1)],
              right: _keys[Math.min(_keys.length, keyIndex + 1)],
              trail: delay = delay + trail,
              config: callProp(config, item, slot),
              to: callProp(leave, item)
            }));
            delete current[key];
          });
          break;
        }

      case UPDATE:
        {
          updated.forEach(key => {
            const keyIndex = keys.indexOf(key);
            const item = items[keyIndex];
            const slot = UPDATE;
            current[key] = _extends$7j({}, current[key], {
              item,
              slot,
              trail: delay = delay + trail,
              config: callProp(config, item, slot),
              to: callProp(update, item)
            });
          });
          break;
        }
    }
  }

  let out = keys.map(key => current[key]); // This tries to restore order for deleted items by finding their last known siblings
  // only using the left sibling to keep order placement consistent for all deleted items

  deleted.forEach((_ref9) => {
    let left = _ref9.left,
        right = _ref9.right,
        item = _objectWithoutPropertiesLoose$1(_ref9, ["left", "right"]);

    let pos; // Was it the element on the left, if yes, move there ...

    if ((pos = out.findIndex(t => t.originalKey === left)) !== -1) pos += 1; // And if nothing else helps, move it to the start ¯\_(ツ)_/¯

    pos = Math.max(0, pos);
    out = [...out.slice(0, pos), item, ...out.slice(pos)];
  });
  return _extends$7j({}, state, {
    changed: added.length || removed.length || updated.length,
    first: first && added.length === 0,
    transitions: out,
    current,
    deleted,
    prevProps: props
  });
}

class AnimatedStyle extends AnimatedObject {
  constructor(style) {
    if (style === void 0) {
      style = {};
    }

    super();

    if (style.transform && !(style.transform instanceof Animated)) {
      style = applyAnimatedValues.transform(style);
    }

    this.payload = style;
  }

}

// http://www.w3.org/TR/css3-color/#svg-color
const colors$3 = {
  transparent: 0x00000000,
  aliceblue: 0xf0f8ffff,
  antiquewhite: 0xfaebd7ff,
  aqua: 0x00ffffff,
  aquamarine: 0x7fffd4ff,
  azure: 0xf0ffffff,
  beige: 0xf5f5dcff,
  bisque: 0xffe4c4ff,
  black: 0x000000ff,
  blanchedalmond: 0xffebcdff,
  blue: 0x0000ffff,
  blueviolet: 0x8a2be2ff,
  brown: 0xa52a2aff,
  burlywood: 0xdeb887ff,
  burntsienna: 0xea7e5dff,
  cadetblue: 0x5f9ea0ff,
  chartreuse: 0x7fff00ff,
  chocolate: 0xd2691eff,
  coral: 0xff7f50ff,
  cornflowerblue: 0x6495edff,
  cornsilk: 0xfff8dcff,
  crimson: 0xdc143cff,
  cyan: 0x00ffffff,
  darkblue: 0x00008bff,
  darkcyan: 0x008b8bff,
  darkgoldenrod: 0xb8860bff,
  darkgray: 0xa9a9a9ff,
  darkgreen: 0x006400ff,
  darkgrey: 0xa9a9a9ff,
  darkkhaki: 0xbdb76bff,
  darkmagenta: 0x8b008bff,
  darkolivegreen: 0x556b2fff,
  darkorange: 0xff8c00ff,
  darkorchid: 0x9932ccff,
  darkred: 0x8b0000ff,
  darksalmon: 0xe9967aff,
  darkseagreen: 0x8fbc8fff,
  darkslateblue: 0x483d8bff,
  darkslategray: 0x2f4f4fff,
  darkslategrey: 0x2f4f4fff,
  darkturquoise: 0x00ced1ff,
  darkviolet: 0x9400d3ff,
  deeppink: 0xff1493ff,
  deepskyblue: 0x00bfffff,
  dimgray: 0x696969ff,
  dimgrey: 0x696969ff,
  dodgerblue: 0x1e90ffff,
  firebrick: 0xb22222ff,
  floralwhite: 0xfffaf0ff,
  forestgreen: 0x228b22ff,
  fuchsia: 0xff00ffff,
  gainsboro: 0xdcdcdcff,
  ghostwhite: 0xf8f8ffff,
  gold: 0xffd700ff,
  goldenrod: 0xdaa520ff,
  gray: 0x808080ff,
  green: 0x008000ff,
  greenyellow: 0xadff2fff,
  grey: 0x808080ff,
  honeydew: 0xf0fff0ff,
  hotpink: 0xff69b4ff,
  indianred: 0xcd5c5cff,
  indigo: 0x4b0082ff,
  ivory: 0xfffff0ff,
  khaki: 0xf0e68cff,
  lavender: 0xe6e6faff,
  lavenderblush: 0xfff0f5ff,
  lawngreen: 0x7cfc00ff,
  lemonchiffon: 0xfffacdff,
  lightblue: 0xadd8e6ff,
  lightcoral: 0xf08080ff,
  lightcyan: 0xe0ffffff,
  lightgoldenrodyellow: 0xfafad2ff,
  lightgray: 0xd3d3d3ff,
  lightgreen: 0x90ee90ff,
  lightgrey: 0xd3d3d3ff,
  lightpink: 0xffb6c1ff,
  lightsalmon: 0xffa07aff,
  lightseagreen: 0x20b2aaff,
  lightskyblue: 0x87cefaff,
  lightslategray: 0x778899ff,
  lightslategrey: 0x778899ff,
  lightsteelblue: 0xb0c4deff,
  lightyellow: 0xffffe0ff,
  lime: 0x00ff00ff,
  limegreen: 0x32cd32ff,
  linen: 0xfaf0e6ff,
  magenta: 0xff00ffff,
  maroon: 0x800000ff,
  mediumaquamarine: 0x66cdaaff,
  mediumblue: 0x0000cdff,
  mediumorchid: 0xba55d3ff,
  mediumpurple: 0x9370dbff,
  mediumseagreen: 0x3cb371ff,
  mediumslateblue: 0x7b68eeff,
  mediumspringgreen: 0x00fa9aff,
  mediumturquoise: 0x48d1ccff,
  mediumvioletred: 0xc71585ff,
  midnightblue: 0x191970ff,
  mintcream: 0xf5fffaff,
  mistyrose: 0xffe4e1ff,
  moccasin: 0xffe4b5ff,
  navajowhite: 0xffdeadff,
  navy: 0x000080ff,
  oldlace: 0xfdf5e6ff,
  olive: 0x808000ff,
  olivedrab: 0x6b8e23ff,
  orange: 0xffa500ff,
  orangered: 0xff4500ff,
  orchid: 0xda70d6ff,
  palegoldenrod: 0xeee8aaff,
  palegreen: 0x98fb98ff,
  paleturquoise: 0xafeeeeff,
  palevioletred: 0xdb7093ff,
  papayawhip: 0xffefd5ff,
  peachpuff: 0xffdab9ff,
  peru: 0xcd853fff,
  pink: 0xffc0cbff,
  plum: 0xdda0ddff,
  powderblue: 0xb0e0e6ff,
  purple: 0x800080ff,
  rebeccapurple: 0x663399ff,
  red: 0xff0000ff,
  rosybrown: 0xbc8f8fff,
  royalblue: 0x4169e1ff,
  saddlebrown: 0x8b4513ff,
  salmon: 0xfa8072ff,
  sandybrown: 0xf4a460ff,
  seagreen: 0x2e8b57ff,
  seashell: 0xfff5eeff,
  sienna: 0xa0522dff,
  silver: 0xc0c0c0ff,
  skyblue: 0x87ceebff,
  slateblue: 0x6a5acdff,
  slategray: 0x708090ff,
  slategrey: 0x708090ff,
  snow: 0xfffafaff,
  springgreen: 0x00ff7fff,
  steelblue: 0x4682b4ff,
  tan: 0xd2b48cff,
  teal: 0x008080ff,
  thistle: 0xd8bfd8ff,
  tomato: 0xff6347ff,
  turquoise: 0x40e0d0ff,
  violet: 0xee82eeff,
  wheat: 0xf5deb3ff,
  white: 0xffffffff,
  whitesmoke: 0xf5f5f5ff,
  yellow: 0xffff00ff,
  yellowgreen: 0x9acd32ff
};

// const INTEGER = '[-+]?\\d+';
const NUMBER = '[-+]?\\d*\\.?\\d+';
const PERCENTAGE = NUMBER + '%';

function call() {
  for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }

  return '\\(\\s*(' + parts.join(')\\s*,\\s*(') + ')\\s*\\)';
}

const rgb = new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER));
const rgba = new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER));
const hsl = new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE));
const hsla = new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
const hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex6 = /^#([0-9a-fA-F]{6})$/;
const hex8 = /^#([0-9a-fA-F]{8})$/;

/*
https://github.com/react-community/normalize-css-color

BSD 3-Clause License

Copyright (c) 2016, React Community
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this
  list of conditions and the following disclaimer.

* Redistributions in binary form must reproduce the above copyright notice,
  this list of conditions and the following disclaimer in the documentation
  and/or other materials provided with the distribution.

* Neither the name of the copyright holder nor the names of its
  contributors may be used to endorse or promote products derived from
  this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
function normalizeColor(color) {
  let match;

  if (typeof color === 'number') {
    return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
  } // Ordered based on occurrences on Facebook codebase


  if (match = hex6.exec(color)) return parseInt(match[1] + 'ff', 16) >>> 0;
  if (colors$3.hasOwnProperty(color)) return colors$3[color];

  if (match = rgb.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    0x000000ff) >>> // a
    0;
  }

  if (match = rgba.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    parse1(match[4])) >>> // a
    0;
  }

  if (match = hex3.exec(color)) {
    return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    'ff', // a
    16) >>> 0;
  } // https://drafts.csswg.org/css-color-4/#hex-notation


  if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;

  if (match = hex4.exec(color)) {
    return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
  }

  if (match = hsl.exec(color)) {
    return (hslToRgb(parse360(match[1]), // h
    parsePercentage(match[2]), // s
    parsePercentage(match[3]) // l
    ) | 0x000000ff) >>> // a
    0;
  }

  if (match = hsla.exec(color)) {
    return (hslToRgb(parse360(match[1]), // h
    parsePercentage(match[2]), // s
    parsePercentage(match[3]) // l
    ) | parse1(match[4])) >>> // a
    0;
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}

function hslToRgb(h, s, l) {
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hue2rgb(p, q, h + 1 / 3);
  const g = hue2rgb(p, q, h);
  const b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}

function parse255(str) {
  const int = parseInt(str, 10);
  if (int < 0) return 0;
  if (int > 255) return 255;
  return int;
}

function parse360(str) {
  const int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}

function parse1(str) {
  const num = parseFloat(str);
  if (num < 0) return 0;
  if (num > 1) return 255;
  return Math.round(num * 255);
}

function parsePercentage(str) {
  // parseFloat conveniently ignores the final %
  const int = parseFloat(str);
  if (int < 0) return 0;
  if (int > 100) return 1;
  return int / 100;
}

function colorToRgba(input) {
  let int32Color = normalizeColor(input);
  if (int32Color === null) return input;
  int32Color = int32Color || 0;
  let r = (int32Color & 0xff000000) >>> 24;
  let g = (int32Color & 0x00ff0000) >>> 16;
  let b = (int32Color & 0x0000ff00) >>> 8;
  let a = (int32Color & 0x000000ff) / 255;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
} // Problem: https://github.com/animatedjs/animated/pull/102
// Solution: https://stackoverflow.com/questions/638565/parsing-scientific-notation-sensibly/658662


const stringShapeRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g; // Covers rgb, rgba, hsl, hsla
// Taken from https://gist.github.com/olmokramer/82ccce673f86db7cda5e

const colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi; // Covers color names (transparent, blue, etc.)

const colorNamesRegex = new RegExp(`(${Object.keys(colors$3).join('|')})`, 'g');
/**
 * Supports string shapes by extracting numbers so new values can be computed,
 * and recombines those values into new strings of the same shape.  Supports
 * things like:
 *
 *   rgba(123, 42, 99, 0.36)           // colors
 *   -45deg                            // values with units
 *   0 2px 2px 0px rgba(0, 0, 0, 0.12) // box shadows
 */

const createStringInterpolator = config => {
  // Replace colors with rgba
  const outputRange = config.output.map(rangeValue => rangeValue.replace(colorRegex, colorToRgba)).map(rangeValue => rangeValue.replace(colorNamesRegex, colorToRgba));
  const outputRanges = outputRange[0].match(stringShapeRegex).map(() => []);
  outputRange.forEach(value => {
    value.match(stringShapeRegex).forEach((number, i) => outputRanges[i].push(+number));
  });
  const interpolations = outputRange[0].match(stringShapeRegex).map((_value, i) => createInterpolator(_extends$7j({}, config, {
    output: outputRanges[i]
  })));
  return input => {
    let i = 0;
    return outputRange[0] // 'rgba(0, 100, 200, 0)'
    // ->
    // 'rgba(${interpolations[0](input)}, ${interpolations[1](input)}, ...'
    .replace(stringShapeRegex, () => interpolations[i++](input)) // rgba requires that the r,g,b are integers.... so we want to round them, but we *dont* want to
    // round the opacity (4th column).
    .replace(/rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, (_, p1, p2, p3, p4) => `rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`);
  };
};

let isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

const prefixKey = (prefix, key) => prefix + key.charAt(0).toUpperCase() + key.substring(1);

const prefixes = ['Webkit', 'Ms', 'Moz', 'O'];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
  prefixes.forEach(prefix => acc[prefixKey(prefix, prop)] = acc[prop]);
  return acc;
}, isUnitlessNumber);

function dangerousStyleValue(name, value, isCustomProperty) {
  if (value == null || typeof value === 'boolean' || value === '') return '';
  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers

  return ('' + value).trim();
}

const attributeCache = {};
injectCreateAnimatedStyle(style => new AnimatedStyle(style));
injectStringInterpolator(createStringInterpolator);
injectColorNames(colors$3);
injectApplyAnimatedValues((instance, props) => {
  if (instance.nodeType && instance.setAttribute !== undefined) {
    const style = props.style,
          children = props.children,
          scrollTop = props.scrollTop,
          scrollLeft = props.scrollLeft,
          attributes = _objectWithoutPropertiesLoose$1(props, ["style", "children", "scrollTop", "scrollLeft"]);

    const filter = instance.nodeName === 'filter' || instance.parentNode && instance.parentNode.nodeName === 'filter';
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft; // Set textContent, if children is an animatable value

    if (children !== void 0) instance.textContent = children; // Set styles ...

    for (let styleName in style) {
      if (!style.hasOwnProperty(styleName)) continue;
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = dangerousStyleValue(styleName, style[styleName], isCustomProperty);
      if (styleName === 'float') styleName = 'cssFloat';
      if (isCustomProperty) instance.style.setProperty(styleName, styleValue);else instance.style[styleName] = styleValue;
    } // Set attributes ...


    for (let name in attributes) {
      // Attributes are written in dash case
      const dashCase = filter ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, n => '-' + n.toLowerCase()));
      if (typeof instance.getAttribute(dashCase) !== 'undefined') instance.setAttribute(dashCase, attributes[name]);
    }

    return;
  } else return false;
}, style => style);

const domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
// Extend animated with all the available THREE elements
const apply = merge$1(createAnimatedComponent, false);
const extendedAnimated = apply(domElements);

var defaultStyles = {
  size: 50,
  width: 6,
  primaryColor: '#5e72e4',
  secondaryColor: '#dddbd3'
};
var rotate = keyframes({
  '0%': {
    transform: 'rotate(0deg)'
  },
  '100%': {
    transform: 'rotate(360deg)'
  }
});

var Spinner$1 = function Spinner(_ref) {
  var customStyles = _ref.styles;

  var _defaultStyles$custom = _extends$7m({}, defaultStyles, customStyles),
      width = _defaultStyles$custom.width,
      size = _defaultStyles$custom.size,
      primaryColor = _defaultStyles$custom.primaryColor,
      secondaryColor = _defaultStyles$custom.secondaryColor;

  return jsx("div", {
    css:
    /*#__PURE__*/
    css({
      position: 'relative',
      boxSizing: 'border-box',
      width: size,
      height: size,
      borderTop: width + "px solid " + secondaryColor,
      borderRight: width + "px solid " + secondaryColor,
      borderBottom: width + "px solid " + secondaryColor,
      borderLeft: width + "px solid " + primaryColor,
      borderRadius: '50%',
      animation: rotate + " 1.1s infinite linear"
    })
  });
};

Spinner$1.defaultProps = {
  styles: {}
};

/** @jsx jsx */
var _ref = {
  name: "gyp8mm",
  styles: "visibility:hidden;"
};
var _ref2 = {
  name: "1gx2944",
  styles: "position:absolute;display:flex;top:0;left:0;width:100%;height:100%;align-items:center;justify-content:center;"
};

var Loading = function Loading(_ref3) {
  var children = _ref3.children;
  return jsx(Fragment$1, null, jsx("span", {
    css: _ref
  }, children), jsx("span", {
    css: _ref2
  }, jsx(Spinner$1, {
    styles: {
      size: 12,
      width: 2,
      primaryColor: 'rgba(0, 0, 0, 0)'
    }
  })));
};

var defaultStyles$1 = {
  base: {
    position: 'relative',
    display: 'inline-flex',
    appearance: 'none !important',
    textDecoration: 'none',
    padding: '12px 20px',
    borderRadius: 6,
    fontSize: 14,
    lineHeight: 1,
    borderWidth: 1,
    borderStyle: 'solid',
    cursor: 'pointer',
    fontWeight: '600',
    userSelect: 'none',
    outline: 0
  },
  baseHover: {},
  default: {
    color: '#212529',
    backgroundColor: '#ffffff',
    borderColor: '#cccccc'
  },
  defaultsuccess: {
    color: '#00c853'
  },
  defaultwarning: {
    color: '#ee9913'
  },
  defaultdanger: {
    color: '#ec4c47'
  },
  primary: {
    color: '#fff',
    borderColor: '#5e72e4',
    backgroundColor: '#5e72e4'
  },
  primarysuccess: {
    borderColor: '#00c853',
    backgroundColor: '#00c853'
  },
  primarywarning: {
    borderColor: '#ee9913',
    backgroundColor: '#ee9913'
  },
  primarydanger: {
    borderColor: '#ec4c47',
    backgroundColor: '#ec4c47'
  },
  minimal: {
    borderColor: '#fff'
  },
  minimalsuccess: {
    color: '#00c853'
  },
  minimalwarning: {
    color: '#ee9913'
  },
  minimaldanger: {
    color: '#ec4c47'
  },
  block: {
    display: 'block',
    width: '100%'
  },
  disabled: {
    opacity: 0.4,
    cursor: 'not-allowed'
  }
};
var makeStyles = function makeStyles(_ref) {
  var customStyles = _ref.styles,
      appearance = _ref.appearance,
      intent = _ref.intent,
      block = _ref.block,
      disabled = _ref.disabled,
      loading = _ref.loading;
  var styles = [_extends$7m({}, defaultStyles$1.base, customStyles.base), _extends$7m({}, defaultStyles$1[appearance], customStyles[appearance]), _extends$7m({}, defaultStyles$1["" + appearance + intent], customStyles["" + appearance + intent]), block && _extends$7m({}, defaultStyles$1.block, customStyles.block), disabled && !loading && _extends$7m({}, defaultStyles$1.disabled, customStyles.disabled), {
    '&:hover': _extends$7m({}, defaultStyles$1.baseHover, customStyles.baseHover)
  }];
  return styles;
};

var Button$2 = function Button(_ref) {
  var children = _ref.children,
      component = _ref.component,
      appearance = _ref.appearance,
      intent = _ref.intent,
      block = _ref.block,
      disabled = _ref.disabled,
      loading = _ref.loading,
      styles = _ref.styles,
      props = _objectWithoutPropertiesLoose$2(_ref, ["children", "component", "appearance", "intent", "block", "disabled", "loading", "styles"]);

  var buttonStyles = makeStyles({
    styles: styles,
    appearance: appearance,
    intent: intent,
    block: block,
    disabled: disabled,
    loading: loading
  });

  var buttonProps = _extends$7m({}, props, {
    css: buttonStyles,
    disabled: disabled || loading
  });

  return jsx(component, buttonProps, loading ? jsx(Loading, null, children) : children);
};

Button$2.defaultProps = {
  block: false,
  loading: false,
  disabled: false,
  appearance: 'default',
  intent: 'none',
  component: 'button',
  type: 'button',
  styles: {}
};

var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
var IS_IOS = IS_BROWSER && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

var defaultStyles$2 = {
  transitionConfig: {
    spring: {
      from: {
        opacity: 0,
        scale: 0.8
      },
      enter: {
        opacity: 1,
        scale: 1
      },
      leave: {
        opacity: 0,
        scale: 0.8
      },
      config: {
        friction: 26,
        tension: 250,
        clamp: true
      }
    },
    overlay: function overlay(_ref) {
      var opacity = _ref.opacity;
      return {
        opacity: opacity
      };
    },
    dialog: function dialog(_ref2) {
      var scale = _ref2.scale;
      return {
        transform: scale.interpolate(function (s) {
          return "scale(" + s + ")";
        })
      };
    }
  },
  overlay: {
    background: 'hsla(0, 0%, 0%, 0.33)',
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: 'auto',
    zIndex: 20
  },
  ovelayOpen: {},
  overlayCentered: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: 'hsla(0, 0%, 0%, 0.33)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  dialog: {
    maxWidth: 500,
    marginTop: 80,
    backgroundColor: '#fff',
    marginLeft: 'auto',
    marginRight: 'auto',
    borderRadius: 8,
    outline: 'none'
  },
  dialogOpen: {},
  dialogCentered: {
    backgroundColor: '#fff',
    borderRadius: 8,
    outline: 'none'
  },
  header: {
    fontWeight: '600',
    fontSize: 18,
    padding: 15,
    alignItems: 'center',
    display: 'flex',
    borderBottom: '1px solid #ececec'
  },
  body: {
    padding: 15
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '12px 15px',
    borderTop: '1px solid #ececec'
  }
};

var AnimatedOverlay = extendedAnimated(DialogOverlay);
var AnimatedContent = extendedAnimated(DialogContent);

var Dialog$1 = function Dialog(_ref) {
  var customStyles = _ref.styles,
      onDismiss = _ref.onDismiss,
      centered = _ref.centered,
      children = _ref.children,
      isOpen = _ref.isOpen;
  var styles = centered ? {
    overlay: [_extends$7m({}, defaultStyles$2.overlayCentered, customStyles.overlayCentered)],
    dialog: [_extends$7m({}, defaultStyles$2.dialogCentered, customStyles.dialogCentered)]
  } : {
    overlay: [_extends$7m({}, defaultStyles$2.overlay, customStyles.overlay), isOpen && _extends$7m({}, defaultStyles$2.overlayOpen, customStyles.overlayOpen)],
    dialog: [_extends$7m({}, defaultStyles$2.dialog, customStyles.dialog), isOpen && _extends$7m({}, defaultStyles$2.dialogOpen, customStyles.dialogOpen)]
  };
  var transitionConfig = customStyles.transitionConfig || defaultStyles$2.transitionConfig;
  var transitions = useTransition(isOpen, null, transitionConfig.spring);

  function renderDialog() {
    if (typeof customStyles.transitionConfig !== 'undefined' && (customStyles.transitionConfig == null || customStyles.transitionConfig === false)) {
      return isOpen && jsx(DialogOverlay, {
        css: styles.overlay,
        onDismiss: onDismiss
      }, jsx(DialogContent, {
        css: styles.dialog
      }, children));
    }

    return transitions.map(function (_ref2) {
      var isOpen = _ref2.item,
          props = _ref2.props,
          key = _ref2.key;
      return isOpen && jsx(AnimatedOverlay, {
        style: transitionConfig.overlay(props),
        css: styles.overlay,
        key: key,
        onDismiss: onDismiss
      }, jsx(AnimatedContent, {
        css: styles.dialog,
        style: transitionConfig.dialog(props)
      }, children));
    });
  }

  return jsx(Fragment$1, null, jsx(Global, {
    styles: {
      ':root': {
        '--reach-dialog': 1
      }
    }
  }), renderDialog());
}; // todo: dismissabble


Dialog$1.defaultProps = {
  centered: false,
  styles: {}
};
var DialogBody = function DialogBody(_ref3) {
  var customStyles = _ref3.styles,
      children = _ref3.children,
      props = _objectWithoutPropertiesLoose$2(_ref3, ["styles", "children"]);

  var styles = {
    body: [defaultStyles$2.body, customStyles.body]
  };
  return jsx("div", _extends$7m({}, props, {
    css: styles.body
  }), children);
};
DialogBody.defaultProps = {
  styles: {}
};
var DialogFooter = function DialogFooter(_ref4) {
  var customStyles = _ref4.styles,
      children = _ref4.children,
      props = _objectWithoutPropertiesLoose$2(_ref4, ["styles", "children"]);

  var styles = {
    footer: [defaultStyles$2.footer, customStyles.footer]
  };
  return jsx("div", _extends$7m({}, props, {
    css: styles.footer
  }), children);
};
DialogFooter.defaultProps = {
  styles: {}
};

var _ref$1 = {
  name: "yyswcu",
  styles: "margin-left:auto;cursor:pointer;"
};

var DialogHeader = function DialogHeader(_ref2) {
  var children = _ref2.children,
      onDismiss = _ref2.onDismiss,
      customStyles = _ref2.styles,
      props = _objectWithoutPropertiesLoose$2(_ref2, ["children", "onDismiss", "styles"]);

  return jsx("div", _extends$7m({}, props, {
    css:
    /*#__PURE__*/
    css([defaultStyles$2.header, customStyles.header])
  }), children, onDismiss ? jsx("div", {
    onClick: onDismiss,
    css: _ref$1
  }, "\xD7") : null);
};

DialogHeader.defaultProps = {
  styles: {}
};

var container = null;

var ConfirmDialog =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose$1(ConfirmDialog, _Component);

  function ConfirmDialog(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.open = function (_ref) {
      var title = _ref.title,
          content = _ref.content,
          onOK = _ref.onOK,
          onCancel = _ref.onCancel;

      _this.setState({
        isOpen: true,
        title: title,
        content: content,
        onOK: onOK,
        onCancel: onCancel
      });
    };

    _this.ok = function () {
      _this.setState({
        isOpen: false
      });

      if (_this.state.onOK) {
        _this.state.onOK();
      }
    };

    _this.cancel = function () {
      _this.setState({
        isOpen: false
      });

      if (_this.state.onCancel) {
        _this.state.onCancel();
      }
    };

    props.bindOpen(_this.open);
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  var _proto = ConfirmDialog.prototype;

  _proto.render = function render() {
    var _this$state = this.state,
        isOpen = _this$state.isOpen,
        title = _this$state.title,
        content = _this$state.content;
    return React__default.createElement(Dialog$1, {
      isOpen: isOpen
    }, React__default.createElement(DialogHeader, null, title), React__default.createElement(DialogBody, null, content), React__default.createElement(DialogFooter, null, React__default.createElement(Button$2, {
      onClick: this.cancel
    }, "\u53D6\u6D88"), React__default.createElement(Button$2, {
      appearance: "primary",
      onClick: this.ok,
      style: {
        marginLeft: 8
      }
    }, "\u786E\u5B9A")));
  };

  return ConfirmDialog;
}(Component$1);

function init() {
  if (!IS_BROWSER) return;
  container = document.createElement('div');
  document.body.appendChild(container);
  ReactDOM.render(React__default.createElement(ConfirmDialog, {
    bindOpen: function bindOpen(open) {
    }
  }), container);
}

init();

var container$1 = null;

var AlertDialog =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose$1(AlertDialog, _Component);

  function AlertDialog(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.open = function (_ref) {
      var title = _ref.title,
          content = _ref.content,
          onOK = _ref.onOK;

      _this.setState({
        isOpen: true,
        title: title,
        content: content,
        onOK: onOK
      });
    };

    _this.ok = function () {
      _this.setState({
        isOpen: false
      });

      if (_this.state.onOK) {
        _this.state.onOK();
      }
    };

    props.bindOpen(_this.open);
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  var _proto = AlertDialog.prototype;

  _proto.render = function render() {
    var _this$state = this.state,
        isOpen = _this$state.isOpen,
        title = _this$state.title,
        content = _this$state.content;
    return React__default.createElement(Dialog$1, {
      isOpen: isOpen
    }, React__default.createElement(DialogHeader, null, title), React__default.createElement(DialogBody, null, content), React__default.createElement(DialogFooter, null, React__default.createElement(Button$2, {
      appearance: "primary",
      onClick: this.ok
    }, "\u786E\u5B9A")));
  };

  return AlertDialog;
}(Component$1);

function init$1() {
  if (!IS_BROWSER) return;
  container$1 = document.createElement('div');
  document.body.appendChild(container$1);
  ReactDOM.render(React__default.createElement(AlertDialog, {
    bindOpen: function bindOpen(open) {
    }
  }), container$1);
}

init$1();

var SideSheet = function SideSheet(_ref) {
  var children = _ref.children,
      Dialog = _ref.components.Dialog,
      props = _objectWithoutPropertiesLoose$2(_ref, ["children", "components"]);

  return jsx(Dialog, _extends$7m({
    styles: {
      transitionConfig: {
        spring: {
          from: {
            opacity: 0,
            x: 100
          },
          enter: {
            opacity: 1,
            x: 0
          },
          leave: {
            opacity: 0,
            x: 100
          },
          config: {
            friction: 25,
            tension: 250,
            clamp: true
          }
        },
        overlay: function overlay(_ref2) {
          var opacity = _ref2.opacity;
          return {
            opacity: opacity
          };
        },
        dialog: function dialog(_ref3) {
          var x = _ref3.x;
          return {
            transform: x.interpolate(function (s) {
              return "translateX(" + s + "%)";
            })
          };
        }
      },
      dialog: {
        position: 'fixed',
        right: 0,
        top: 0,
        bottom: 0,
        width: 620,
        maxWidth: 620,
        marginTop: 0,
        overflowY: 'auto',
        borderRadius: 0,
        boxShadow: 'none',
        outline: 'none'
      }
    }
  }, props), children);
};

SideSheet.defaultProps = {
  components: {
    Dialog: Dialog$1
  }
};

var _templateObject$F, _templateObject2$y, _templateObject3$r, _templateObject4$k, _templateObject5$i, _templateObject6$g, _templateObject7$d, _templateObject8$a, _templateObject9$9, _templateObject10$9, _templateObject11$8;
var Content$1 = styled(Flex).attrs({
  column: true
})(_templateObject$F || (_templateObject$F = _taggedTemplateLiteral(["\n  height: 100vh;\n"])));
var Header$2 = styled(Flex)(_templateObject2$y || (_templateObject2$y = _taggedTemplateLiteral(["\n  padding: ", " ", "\n    ", " ", ";\n  position: relative;\n  ", "\n  ", "\n"])), theme.spacing['spacing-7'], theme.spacing['spacing-6'], theme.spacing['spacing-7'], theme.spacing['spacing-6'], function (_ref) {
  var colors = _ref.colors;
  return getHeaderSideSheet(colors);
}, function (_ref2) {
  var colors = _ref2.colors;
  return getRounderSideSheet(colors);
});
var getRounderSideSheet = function getRounderSideSheet(_ref3) {
  var variant = _ref3.variant,
    modifier = _ref3.modifier;
  var defaultVariant = variant == 'neutral' && modifier == 'weak';
  return !defaultVariant && css$1(_templateObject3$r || (_templateObject3$r = _taggedTemplateLiteral(["\n      &:after {\n        content: ' ';\n        border-radius: ", "\n          ", " 0px 0px;\n        height: 28px;\n        position: absolute;\n        background-color: ", ";\n        width: 100%;\n        left: 0;\n        bottom: 0;\n        z-index: 1;\n      }\n      & {\n        padding-bottom: ", ";\n      }\n    "])), theme.borderRadius['border-radius-4'], theme.borderRadius['border-radius-4'], theme.colors.neutral.bg.weak, theme.spacing['spacing-9']);
};
var Body = styled.div(_templateObject4$k || (_templateObject4$k = _taggedTemplateLiteral(["\n  overflow: hidden;\n  height: 100%;\n"])));
var Footer = styled.div(_templateObject5$i || (_templateObject5$i = _taggedTemplateLiteral(["\n  margin-top: auto;\n  padding: ", " ", "\n    ", " ", ";\n"])), theme.spacing['spacing-3'], theme.spacing['spacing-6'], theme.spacing['spacing-6'], theme.spacing['spacing-6']);
var HeaderWrapper = styled.div(_templateObject6$g || (_templateObject6$g = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  margin-bottom: ", ";\n"])), theme.spacing['spacing-1']);
var SubTitleWrapper = styled.div(_templateObject7$d || (_templateObject7$d = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), theme.spacing['spacing-1']);
var CloseIconWrapper = styled.div(_templateObject8$a || (_templateObject8$a = _taggedTemplateLiteral(["\n  margin-left: ", ";\n"])), theme.spacing['spacing-3']);
var PreviousIconWrapper = styled.div(_templateObject9$9 || (_templateObject9$9 = _taggedTemplateLiteral(["\n  margin-right: ", ";\n"])), theme.spacing['spacing-3']);
var TitleWrapper = styled(Flex)(_templateObject10$9 || (_templateObject10$9 = _taggedTemplateLiteral(["\n  ", "\n  justify-content: space-between;\n"])), function (_ref4) {
  var hasPreviousStep = _ref4.hasPreviousStep;
  return hasPreviousStep && css$1(_templateObject11$8 || (_templateObject11$8 = _taggedTemplateLiteral(["\n      align-items: center;\n    "])));
});
var getHeaderSideSheet = function getHeaderSideSheet(_ref5) {
  var variant = _ref5.variant,
    modifier = _ref5.modifier;
  return "background-color: ".concat(theme.colors[variant].bg[modifier], ";");
};

var styleSideSheetConfig = function styleSideSheetConfig(stylesSideSheet) {
  return {
    transitionConfig: {
      spring: {
        from: {
          opacity: 0,
          x: 100
        },
        enter: {
          opacity: 1,
          x: 0
        },
        leave: {
          opacity: 0,
          x: 100
        },
        config: {
          friction: 25,
          tension: 250,
          clamp: true
        }
      },
      overlay: function overlay(_ref2) {
        var opacity = _ref2.opacity;
        return {
          opacity: opacity,
          background: 'none'
        };
      },
      dialog: function dialog(_ref3) {
        var x = _ref3.x;
        return {
          transform: x.interpolate(function (s) {
            return 'translateX(' + s + '%)';
          })
        };
      }
    },
    dialog: _objectSpread2({
      position: 'fixed',
      right: 0,
      top: 0,
      bottom: 0,
      width: 620,
      maxWidth: 620,
      marginTop: 0,
      overflowY: 'auto',
      borderRadius: 0,
      boxShadow: 'none',
      outline: 'none'
    }, stylesSideSheet)
  };
};

var SideSheet$1 = function SideSheet$1(_ref) {
  var children = _ref.children,
    isOpen = _ref.isOpen,
    onDismiss = _ref.onDismiss,
    title = _ref.title,
    subtitle = _ref.subtitle,
    footer = _ref.footer,
    size = _ref.size,
    previousStepAction = _ref.previousStepAction,
    variant = _ref.variant;
  var sideSheetSizes = {
    sm: 360 // TODO
  };

  var sideSheetVariants = {
    icon: {
      variant: variant == 'default' ? 'neutral' : variant,
      modifier: variant == 'neutral' ? 'strong' : 'regular'
    },
    subtitle: variant == 'default' ? 'neutral' : variant,
    title: {
      variant: variant == 'default' ? 'neutral' : variant,
      modifier: variant == 'default' ? 'strong' : 'regular'
    },
    header: {
      variant: variant == 'default' ? 'neutral' : variant,
      modifier: variant == 'neutral' ? 'strong' : 'weak'
    }
  };
  return /*#__PURE__*/React__default.createElement(SideSheet, {
    isOpen: isOpen,
    styles: styleSideSheetConfig({
      width: sideSheetSizes[size],
      background: theme.colors.neutral.bg.weak,
      boxShadow: theme.elevations['elevation-3']
    }),
    onDismiss: onDismiss
  }, /*#__PURE__*/React__default.createElement(Content$1, {
    "data-testid": 'sidesheet-content',
    size: size
  }, /*#__PURE__*/React__default.createElement(Header$2, {
    hasPreviousStep: previousStepAction,
    "data-testid": 'sidesheet-header',
    colors: sideSheetVariants.header
  }, previousStepAction && /*#__PURE__*/React__default.createElement(PreviousIconWrapper, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "arrow_left_outline",
    onClick: previousStepAction,
    width: 24,
    height: 24,
    variant: sideSheetVariants.icon.variant,
    modifier: sideSheetVariants.icon.modifier,
    cursor: "pointer"
  })), /*#__PURE__*/React__default.createElement(HeaderWrapper, {
    hasPreviousStep: previousStepAction
  }, /*#__PURE__*/React__default.createElement(TitleWrapper, null, /*#__PURE__*/React__default.createElement(H$1, {
    type: "4",
    variant: sideSheetVariants.title.variant,
    modifier: sideSheetVariants.title.modifier,
    weight: "bold"
  }, title), /*#__PURE__*/React__default.createElement(CloseIconWrapper, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "cancel_outline",
    onClick: onDismiss,
    width: 24,
    height: 24,
    variant: sideSheetVariants.icon.variant,
    modifier: sideSheetVariants.icon.modifier,
    cursor: "pointer"
  }))), subtitle && /*#__PURE__*/React__default.createElement(SubTitleWrapper, null, /*#__PURE__*/React__default.createElement(Span$1, {
    type: "2",
    variant: sideSheetVariants.subtitle,
    modifier: "regular"
  }, subtitle)))), /*#__PURE__*/React__default.createElement(Body, null, children), footer && /*#__PURE__*/React__default.createElement(Footer, null, footer)));
};
SideSheet$1.defaultProps = {
  isOpen: false,
  closeOnApply: true,
  size: 'sm',
  // TODO
  variant: 'default'
};
SideSheet$1.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  size: PropTypes.oneOf(['sm']),
  // TODO
  variant: PropTypes.oneOf(['danger', 'success', 'info', 'default', 'warning', 'neutral'])
};

var _templateObject$G, _templateObject2$z, _templateObject3$s, _templateObject4$l;
var SelectorButton = styled(Flex).attrs(function (_ref) {
  var id = _ref.id;
  return {
    id: id
  };
})(_templateObject$G || (_templateObject$G = _taggedTemplateLiteral(["\n  cursor: pointer;\n  background-color: ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])), theme.colors.neutral.bg.weak);
var CountWrapper = styled(Flex)(_templateObject2$z || (_templateObject2$z = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: 32px;\n  width: 32px;\n  border-radius: ", ";\n  align-items: center;\n  justify-content: center;\n  margin-right: ", ";\n"])), theme.colors.primary.bg.regular, theme.borderRadius['border-radius-5'], theme.spacing['spacing-6']);
var TextWrapper$3 = styled(Flex)(_templateObject3$s || (_templateObject3$s = _taggedTemplateLiteral(["\n  flex-direction: column;\n  align-items: center;\n"])));
var Info = styled(Flex)(_templateObject4$l || (_templateObject4$l = _taggedTemplateLiteral(["\n  align-items: center;\n"])));

var _templateObject$H, _templateObject2$A, _templateObject3$t;
var CuitSelector = styled(Flex)(_templateObject$H || (_templateObject$H = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  background-color: ", ";\n"])), theme.colors.neutral.bg.weak);
var IconWrapper$1 = styled(Flex)(_templateObject2$A || (_templateObject2$A = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: 32px;\n  width: 32px;\n  border-radius: ", ";\n  align-items: center;\n  justify-content: center;\n  margin-right: ", ";\n"])), theme.colors.primary.bg.regular, theme.borderRadius['border-radius-5'], theme.spacing['spacing-8']);
var TextWrapper$4 = styled(Flex)(_templateObject3$t || (_templateObject3$t = _taggedTemplateLiteral(["\n  flex-direction: column;\n  align-items: center;\n"])));

var CuitSelector$1 = function CuitSelector$1(_ref) {
  var cuit = _ref.cuit;
  return /*#__PURE__*/React__default.createElement(Card$1, {
    spacing: "6"
  }, /*#__PURE__*/React__default.createElement(CuitSelector, null, /*#__PURE__*/React__default.createElement(IconWrapper$1, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "storefront_outline",
    height: "24",
    width: "24",
    variant: "neutral",
    modifier: "inverted"
  })), /*#__PURE__*/React__default.createElement(TextWrapper$4, null, /*#__PURE__*/React__default.createElement(Span$1, {
    type: "4",
    variant: "neutral",
    weight: "bold",
    modifier: "strong"
  }, "Todos los establecimientos"), /*#__PURE__*/React__default.createElement(Span$1, {
    type: "4",
    variant: "neutral",
    modifier: "strong"
  }, "CUIT: ", cuit))));
};

var SelectorButton$1 = function SelectorButton$1(_ref) {
  var onClick = _ref.onClick,
    selectedQuantity = _ref.selectedQuantity,
    children = _ref.children,
    id = _ref.id,
    bigCommerce = _ref.bigCommerce,
    cuit = _ref.cuit;
  return bigCommerce ? /*#__PURE__*/React__default.createElement(CuitSelector$1, {
    cuit: cuit
  }) : /*#__PURE__*/React__default.createElement(Card$1, {
    spacing: "6",
    hasHover: true
  }, /*#__PURE__*/React__default.createElement(SelectorButton, {
    onClick: onClick,
    id: id
  }, /*#__PURE__*/React__default.createElement(Info, null, /*#__PURE__*/React__default.createElement(CountWrapper, null, /*#__PURE__*/React__default.createElement(Span$1, {
    type: "4",
    variant: "neutral",
    modifier: "inverted",
    weight: "bold"
  }, selectedQuantity)), /*#__PURE__*/React__default.createElement(TextWrapper$3, null, /*#__PURE__*/React__default.createElement(Span$1, {
    type: "4",
    variant: "neutral",
    weight: "bold"
  }, children))), /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "chevron_right_small",
    height: "24",
    width: "24"
  })));
};

var _templateObject$I, _templateObject2$B, _templateObject3$u, _templateObject4$m, _templateObject5$j, _templateObject6$h, _templateObject7$e, _templateObject8$b, _templateObject9$a;
var ItemsSelector = styled.div(_templateObject$I || (_templateObject$I = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n"])));
var Hr = styled.hr(_templateObject2$B || (_templateObject2$B = _taggedTemplateLiteral(["\n  border: 0;\n  width: auto;\n  margin: ", " ", ";\n  background-color: ", ";\n  height: 1px;\n"])), theme.spacing['spacing-0'], theme.spacing['spacing-5'], theme.colors.neutral.border.weak);
var SelectAll$1 = styled.div(_templateObject3$u || (_templateObject3$u = _taggedTemplateLiteral(["\n  padding: ", ";\n  margin-top: ", ";\n"])), theme.spacing['spacing-5'], theme.spacing['spacing-6']);
var CheckboxWrapper = styled(Flex)(_templateObject4$m || (_templateObject4$m = _taggedTemplateLiteral(["\n  align-items: center;\n  padding: ", " ", "\n    ", " ", ";\n"])), theme.spacing['spacing-0'], theme.spacing['spacing-7'], theme.spacing['spacing-0'], theme.spacing['spacing-5']);
var Item = styled(Flex)(_templateObject5$j || (_templateObject5$j = _taggedTemplateLiteral(["\n  justify-content: flex-start;\n  padding: ", " ", ";\n"])), theme.spacing['spacing-5'], theme.spacing['spacing-0']);
var Footer$1 = styled.div(_templateObject6$h || (_templateObject6$h = _taggedTemplateLiteral(["\n  justify-content: center;\n  width: 100%;\n  display: flex;\n  button:first-child {\n    margin-right: ", ";\n  }\n"])), theme.spacing['spacing-5']);
var List = styled.ul(_templateObject7$e || (_templateObject7$e = _taggedTemplateLiteral(["\n  height: 100%;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: ", "\n    ", ";\n\n  &::-webkit-scrollbar {\n    width: ", ";\n    height: ", ";\n  }\n  &::-webkit-scrollbar-track {\n    background: ", ";\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n    height: ", ";\n    border-radius: ", ";\n    margin: ", " ", "\n      ", ";\n    padding: ", " ", "\n      ", " ", ";\n  }\n"])), theme.colors.neutral.bg.strong, theme.colors.neutral.bg.weak, theme.spacing['spacing-2'], theme.spacing['spacing-6'], theme.colors.neutral.bg.weak, theme.colors.neutral.bg.strong, theme.spacing['spacing-6'], theme.borderRadius['border-radius-1'], theme.spacing['spacing-6'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-6'], theme.spacing['spacing-13'], theme.spacing['spacing-5'], theme.spacing['spacing-13']);
var SearchWrapper = styled.div(_templateObject8$b || (_templateObject8$b = _taggedTemplateLiteral(["\n  margin: ", " ", ";\n"])), theme.spacing['spacing-0'], theme.spacing['spacing-6']);
var ItemSelectorNoItems = styled.div(_templateObject9$a || (_templateObject9$a = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  padding: ", " ", ";\n"])), theme.spacing['spacing-13'], theme.spacing['spacing-0'], theme.spacing['spacing-6']);

var SearchInput = function SearchInput(_ref) {
  var id = _ref.id,
    value = _ref.value,
    label = _ref.label,
    size = _ref.size,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    onSearch = _ref.onSearch,
    onClear = _ref.onClear,
    message = _ref.message,
    inputStatus = _ref.inputStatus;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isSearchButtonDisabled = _useState2[0],
    setSearchButtonDisabled = _useState2[1];
  var _useState3 = useState(!!value),
    _useState4 = _slicedToArray(_useState3, 2),
    showClearButton = _useState4[0],
    setShowClearIcon = _useState4[1];
  var _useState5 = useState(value),
    _useState6 = _slicedToArray(_useState5, 2),
    inputValue = _useState6[0],
    setInputValue = _useState6[1];
  var _useState7 = useState(!!value),
    _useState8 = _slicedToArray(_useState7, 2),
    valueChanged = _useState8[0],
    setValueChanged = _useState8[1];
  useEffect(function () {
    setSearchButtonDisabled(disabled);
    setShowClearIcon(!!inputValue);
  }, [inputValue]);
  var proxyOnSearch = function proxyOnSearch() {
    onSearch && onSearch(inputValue);
  };
  var proxyOnChange = function proxyOnChange(e) {
    setInputValue(e.target.value);
    setValueChanged(true);
    onChange && onChange(e);
  };
  var proxyOnClear = function proxyOnClear() {
    setInputValue('');
    onClear && onClear();
  };
  var onFocus = function onFocus() {
    setSearchButtonDisabled(false);
  };
  var onBlur = function onBlur() {
    setSearchButtonDisabled(disabled || !valueChanged);
  };
  var onKeyDown = function onKeyDown(e) {
    e.key === 'Enter' && proxyOnSearch();
  };
  return /*#__PURE__*/React__default.createElement(Input$1, {
    id: id,
    type: "text",
    placeHolder: placeholder,
    onChange: proxyOnChange,
    value: inputValue,
    onFocus: onFocus,
    onBlur: onBlur,
    disabled: disabled,
    onKeyDown: onKeyDown,
    searchText: true,
    message: message,
    label: label,
    inputStatus: inputStatus,
    size: size,
    icons: {
      iconLeft: 'search_outline',
      iconRight: showClearButton && {
        name: 'cancel_outline',
        callback: proxyOnClear
      }
    }
  });
};
SearchInput.defaultProps = {
  disabled: false,
  value: ''
};
SearchInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  placeHolder: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  onSearch: PropTypes.func,
  onClear: PropTypes.func,
  message: PropTypes.string,
  inputStatus: PropTypes.oneOf(['normal', 'error'])
};

var _templateObject$J;
var IllustrationWrapper = styled.div(_templateObject$J || (_templateObject$J = _taggedTemplateLiteral(["\n  margin: ", " auto ", " auto;\n"])), theme.spacing['spacing-0'], theme.spacing['spacing-7']);

var NoItems = function NoItems() {
  return /*#__PURE__*/React__default.createElement(Flex, {
    column: true
  }, /*#__PURE__*/React__default.createElement(IllustrationWrapper, null, /*#__PURE__*/React__default.createElement(Illustration, {
    name: "lineal_establecimientos_empty",
    alt: "No hay datos"
  })), /*#__PURE__*/React__default.createElement(P$1, {
    type: "2",
    variant: "neutral",
    weight: "regular",
    align: "center"
  }, "No se encontraron resultados que coincidan con tu b\xFAsqueda"));
};

var _excluded$a = ["localId"];
var ItemsSelector$1 = function ItemsSelector$1(_ref) {
  var title = _ref.title,
    initialData = _ref.initialData,
    onChange = _ref.onChange,
    renderItem = _ref.renderItem,
    outFormat = _ref.outFormat,
    closeOnApply = _ref.closeOnApply,
    filterCallback = _ref.filterCallback,
    searchLabel = _ref.searchLabel,
    searchPlaceholder = _ref.searchPlaceholder,
    onDismiss = _ref.onDismiss,
    previousStepAction = _ref.previousStepAction,
    id = _ref.id,
    bigCommerce = _ref.bigCommerce,
    cuit = _ref.cuit;
  var getInitialData = function getInitialData() {
    return initialData.map(function (i, localId) {
      return _objectSpread2(_objectSpread2({}, i), {}, {
        localId: localId
      });
    });
  };
  var _useState = useState(getInitialData()),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var _useState3 = useState(getInitialData()),
    _useState4 = _slicedToArray(_useState3, 2),
    allItems = _useState4[0],
    setAllItems = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSideSheetOpen = _useState6[0],
    setSideSheetOpen = _useState6[1];
  useEffect(function () {
    setAllItems(getInitialData());
    setItems(getInitialData());
  }, []);
  var allItemsSelectedQuantity = allItems.filter(function (item) {
    return item.checked;
  }).length;
  var itemsSelectedQuantity = items.filter(function (item) {
    return item.checked;
  }).length;
  var handleAllChecked = function handleAllChecked(checked) {
    var changedItems = items.map(function (item) {
      return _objectSpread2(_objectSpread2({}, item), {}, {
        checked: checked
      });
    });
    var otherItems = allItems.filter(function (item) {
      return !items.find(function (otherItem) {
        return otherItem.localId === item.localId;
      });
    });
    setAllItems([].concat(_toConsumableArray(changedItems), _toConsumableArray(otherItems)));
    setItems(changedItems);
  };
  var handleChecked = function handleChecked(_ref2) {
    var localId = _ref2.localId;
    return function (checked) {
      setAllItems(allItems.map(function (item) {
        return item.localId === localId ? _objectSpread2(_objectSpread2({}, item), {}, {
          checked: checked
        }) : item;
      }));
      setItems(items.map(function (item) {
        return item.localId === localId ? _objectSpread2(_objectSpread2({}, item), {}, {
          checked: checked
        }) : item;
      }));
    };
  };
  var handleCerrar = function handleCerrar() {
    return setSideSheetOpen(false);
  };
  var handleDismiss = function handleDismiss() {
    handleCerrar();
    onDismiss && onDismiss();
  };
  var handleApply = function handleApply() {
    onChange && onChange(allItems.filter(function (item) {
      return item.checked;
    }).map(function (_ref3) {
      var localId = _ref3.localId,
        item = _objectWithoutProperties(_ref3, _excluded$a);
      return item;
    }).map(outFormat));
    closeOnApply && handleCerrar();
  };
  var handleOnSearch = function handleOnSearch(value) {
    if (value) {
      filterCallback && setItems(allItems.filter(function (item) {
        return filterCallback(item, value);
      }));
    } else {
      setItems(allItems);
    }
  };
  var footer = /*#__PURE__*/React__default.createElement(Footer$1, null, /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "secondary",
    size: "md-full",
    onClick: handleCerrar
  }, "Cancelar"), /*#__PURE__*/React__default.createElement(Button$1, {
    id: "aplicar_filtro",
    variant: "primary",
    size: "md-full",
    onClick: handleApply,
    disabled: allItemsSelectedQuantity === 0
  }, "Aplicar"));
  var handlePreviousStepAction = function handlePreviousStepAction() {
    handleCerrar();
    previousStepAction && previousStepAction();
  };
  var handleClick = function handleClick() {
    setItems(allItems);
    setSideSheetOpen(true);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SelectorButton$1, {
    selectedQuantity: allItemsSelectedQuantity,
    onClick: handleClick,
    id: id,
    bigCommerce: bigCommerce,
    cuit: cuit
  }, title), /*#__PURE__*/React__default.createElement(SideSheet$1, {
    isOpen: isSideSheetOpen,
    onDismiss: handleDismiss,
    title: title,
    footer: footer,
    size: 'sm',
    previousStepAction: previousStepAction && handlePreviousStepAction
  }, /*#__PURE__*/React__default.createElement(ItemsSelector, null, filterCallback && /*#__PURE__*/React__default.createElement(SearchWrapper, null, /*#__PURE__*/React__default.createElement(SearchInput, {
    id: 'search-input',
    label: searchLabel,
    placeholder: searchPlaceholder,
    size: 'md',
    onSearch: handleOnSearch
  })), items.length === 0 ? /*#__PURE__*/React__default.createElement(ItemSelectorNoItems, null, /*#__PURE__*/React__default.createElement(NoItems, null)) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SelectAll$1, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
    id: "select-all",
    checked: itemsSelectedQuantity > 0,
    onChange: handleAllChecked,
    isSelectAllCheck: true,
    size: "sm"
  }, allItemsSelectedQuantity === 0 && 'Seleccionar todos', allItemsSelectedQuantity > 0 && "".concat(allItemsSelectedQuantity, " Seleccionados"))), /*#__PURE__*/React__default.createElement(Hr, null), /*#__PURE__*/React__default.createElement(List, null, items.map(function (data, key) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: key
    }, /*#__PURE__*/React__default.createElement(Item, null, /*#__PURE__*/React__default.createElement(CheckboxWrapper, null, /*#__PURE__*/React__default.createElement(Checkbox$1, {
      id: "items__selector--".concat(key),
      checked: data.checked,
      onChange: handleChecked(data),
      size: "sm"
    })), renderItem(_objectSpread2(_objectSpread2({}, data), {}, {
      key: key
    }))), /*#__PURE__*/React__default.createElement(Hr, null));
  }))))));
};
ItemsSelector$1.defaultProps = {
  initialData: [],
  renderItem: function renderItem() {
    return false;
  },
  outFormat: function outFormat(e) {
    return e;
  },
  closeOnApply: true,
  bigCommerce: false,
  cuit: ''
};
ItemsSelector$1.propTypes = {
  title: PropTypes.string,
  initialData: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  renderItem: PropTypes.func.isRequired,
  outFormat: PropTypes.func.isRequired,
  closeOnApply: PropTypes.bool,
  filterCallback: PropTypes.func,
  searchLabel: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  onDismiss: PropTypes.func,
  previousStepAction: PropTypes.func,
  disabled: PropTypes.bool,
  bigCommerce: PropTypes.bool,
  cuit: PropTypes.string
};

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof$3(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

function _typeof$4(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || _typeof$4(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);

  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters$1 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */
var formatters$2 = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters$1.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters$1.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters$1.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters$1.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters$1.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters$1.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters$1.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters$1.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};

var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};

var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format$1(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale$1 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : locale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters$2[firstCharacter];

    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }

      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }

      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}

var MILLISECONDS_IN_MINUTE = 60000;
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */

function addMinutes(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */

function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}

/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */

function subWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addWeeks(dirtyDate, -amount);
}

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */

function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}

/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */

function subYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addYears(dirtyDate, -amount);
}

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */

function getMinutes(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var day = date.getDay();
  return day;
}

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */

function getDate(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}

/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */

function getISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */

function startOfISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$2 = 604800000;
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */

function getISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$2) + 1;
}

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */

function getMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  return month;
}

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */

function getQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getFullYear();
}

/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */

function getTime(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var seconds = toInteger(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var minutes = toInteger(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var hours = toInteger(dirtyHours);
  date.setHours(hours);
  return date;
}

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */

function setQuarter(dirtyDate, dirtyQuarter) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var quarter = toInteger(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return setMonth(date, date.getMonth() + diff * 3);
}

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var year = toInteger(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}

function _typeof$5(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$5 = function _typeof(obj) { return typeof obj; }; } else { _typeof$5 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$5(obj); }
/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} - the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */

function min$1(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (_typeof$5(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = toDate(dirtyDate);

    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

function _typeof$6(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$6 = function _typeof(obj) { return typeof obj; }; } else { _typeof$6 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$6(obj); }
/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */

function max$1(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (_typeof$6(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = toDate(dirtyDate);

    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

var MILLISECONDS_IN_DAY$1 = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$1);
}

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */

function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */

function startOfQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */

function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */

function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft);
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  requiredArgs(2, arguments);
  var time = toDate(dirtyDate).getTime();
  var startTime = toDate(interval.start).getTime();
  var endTime = toDate(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}

function assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      target[property] = object[property];
    }
  }

  return target;
}

function _typeof$7(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$7 = function _typeof(obj) { return typeof obj; }; } else { _typeof$7 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$7(obj); }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$1(subClass, superClass); }

function _setPrototypeOf$1(o, p) { _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$1(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _possibleConstructorReturn$1(self, call) { if (call && (_typeof$7(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$2(self); }

function _assertThisInitialized$2(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/function () {
  function Setter() {
    _classCallCheck$1(this, Setter);

    _defineProperty$3(this, "subPriority", 0);
  }

  _createClass(Setter, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);

  return Setter;
}();
var ValueSetter = /*#__PURE__*/function (_Setter) {
  _inherits$1(ValueSetter, _Setter);

  var _super = _createSuper(ValueSetter);

  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this;

    _classCallCheck$1(this, ValueSetter);

    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;

    if (subPriority) {
      _this.subPriority = subPriority;
    }

    return _this;
  }

  _createClass(ValueSetter, [{
    key: "validate",
    value: function validate(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);

  return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
  _inherits$1(DateToSystemTimezoneSetter, _Setter2);

  var _super2 = _createSuper(DateToSystemTimezoneSetter);

  function DateToSystemTimezoneSetter() {
    var _this2;

    _classCallCheck$1(this, DateToSystemTimezoneSetter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty$3(_assertThisInitialized$2(_this2), "priority", TIMEZONE_UNIT_PRIORITY);

    _defineProperty$3(_assertThisInitialized$2(_this2), "subPriority", -1);

    return _this2;
  }

  _createClass(DateToSystemTimezoneSetter, [{
    key: "set",
    value: function set(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }

      var convertedDate = new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);

  return DateToSystemTimezoneSetter;
}(Setter);

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }
var Parser = /*#__PURE__*/function () {
  function Parser() {
    _classCallCheck$2(this, Parser);
  }

  _createClass$1(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);

      if (!result) {
        return null;
      }

      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);

  return Parser;
}();

function _typeof$8(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$8 = function _typeof(obj) { return typeof obj; }; } else { _typeof$8 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$8(obj); }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); return Constructor; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$2(subClass, superClass); }

function _setPrototypeOf$2(o, p) { _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$2(o, p); }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }

function _possibleConstructorReturn$2(self, call) { if (call && (_typeof$8(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$3(self); }

function _assertThisInitialized$3(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$1(o) { _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$1(o); }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var EraParser = /*#__PURE__*/function (_Parser) {
  _inherits$2(EraParser, _Parser);

  var _super = _createSuper$1(EraParser);

  function EraParser() {
    var _this;

    _classCallCheck$3(this, EraParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$4(_assertThisInitialized$3(_this), "priority", 140);

    _defineProperty$4(_assertThisInitialized$3(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);

    return _this;
  }

  _createClass$2(EraParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(dateString, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(dateString, {
            width: 'wide'
          }) || match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return EraParser;
}(Parser);

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInHour = 3600000;
/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInSecond = 1000;

var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }

  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function _typeof$9(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$9 = function _typeof(obj) { return typeof obj; }; } else { _typeof$9 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$9(obj); }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); return Constructor; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$3(subClass, superClass); }

function _setPrototypeOf$3(o, p) { _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$3(o, p); }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$3(this, result); }; }

function _possibleConstructorReturn$3(self, call) { if (call && (_typeof$9(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$4(self); }

function _assertThisInitialized$4(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$2(o) { _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$2(o); }

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
var YearParser = /*#__PURE__*/function (_Parser) {
  _inherits$3(YearParser, _Parser);

  var _super = _createSuper$2(YearParser);

  function YearParser() {
    var _this;

    _classCallCheck$4(this, YearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$5(_assertThisInitialized$4(_this), "priority", 130);

    _defineProperty$5(_assertThisInitialized$4(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass$3(YearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return mapValue(parseNDigits(4, dateString), valueCallback);

        case 'yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);

        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return YearParser;
}(Parser);

function _typeof$a(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$a = function _typeof(obj) { return typeof obj; }; } else { _typeof$a = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$a(obj); }

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$4(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$4(Constructor.prototype, protoProps); if (staticProps) _defineProperties$4(Constructor, staticProps); return Constructor; }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$4(subClass, superClass); }

function _setPrototypeOf$4(o, p) { _setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$4(o, p); }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf$3(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$3(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$4(this, result); }; }

function _possibleConstructorReturn$4(self, call) { if (call && (_typeof$a(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$5(self); }

function _assertThisInitialized$5(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$3(o) { _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$3(o); }

function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// Local week-numbering year
var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits$4(LocalWeekYearParser, _Parser);

  var _super = _createSuper$3(LocalWeekYearParser);

  function LocalWeekYearParser() {
    var _this;

    _classCallCheck$5(this, LocalWeekYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$6(_assertThisInitialized$5(_this), "priority", 130);

    _defineProperty$6(_assertThisInitialized$5(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);

    return _this;
  }

  _createClass$4(LocalWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return mapValue(parseNDigits(4, dateString), valueCallback);

        case 'Yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);

        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value, options) {
      var currentYear = getUTCWeekYear(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    }
  }]);

  return LocalWeekYearParser;
}(Parser);

function _typeof$b(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$b = function _typeof(obj) { return typeof obj; }; } else { _typeof$b = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$b(obj); }

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$5(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$5(Constructor.prototype, protoProps); if (staticProps) _defineProperties$5(Constructor, staticProps); return Constructor; }

function _inherits$5(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$5(subClass, superClass); }

function _setPrototypeOf$5(o, p) { _setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$5(o, p); }

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf$4(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$4(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$5(this, result); }; }

function _possibleConstructorReturn$5(self, call) { if (call && (_typeof$b(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$6(self); }

function _assertThisInitialized$6(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$4(o) { _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$4(o); }

function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits$5(ISOWeekYearParser, _Parser);

  var _super = _createSuper$4(ISOWeekYearParser);

  function ISOWeekYearParser() {
    var _this;

    _classCallCheck$6(this, ISOWeekYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$7(_assertThisInitialized$6(_this), "priority", 130);

    _defineProperty$7(_assertThisInitialized$6(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass$5(ISOWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'R') {
        return parseNDigitsSigned(4, dateString);
      }

      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    }
  }]);

  return ISOWeekYearParser;
}(Parser);

function _typeof$c(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$c = function _typeof(obj) { return typeof obj; }; } else { _typeof$c = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$c(obj); }

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$6(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$6(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$6(Constructor.prototype, protoProps); if (staticProps) _defineProperties$6(Constructor, staticProps); return Constructor; }

function _inherits$6(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$6(subClass, superClass); }

function _setPrototypeOf$6(o, p) { _setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$6(o, p); }

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf$5(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$5(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$6(this, result); }; }

function _possibleConstructorReturn$6(self, call) { if (call && (_typeof$c(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$7(self); }

function _assertThisInitialized$7(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$5(o) { _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$5(o); }

function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
  _inherits$6(ExtendedYearParser, _Parser);

  var _super = _createSuper$5(ExtendedYearParser);

  function ExtendedYearParser() {
    var _this;

    _classCallCheck$7(this, ExtendedYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$7(_this), "priority", 130);

    _defineProperty$8(_assertThisInitialized$7(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass$6(ExtendedYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'u') {
        return parseNDigitsSigned(4, dateString);
      }

      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return ExtendedYearParser;
}(Parser);

function _typeof$d(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$d = function _typeof(obj) { return typeof obj; }; } else { _typeof$d = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$d(obj); }

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$7(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$7(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$7(Constructor.prototype, protoProps); if (staticProps) _defineProperties$7(Constructor, staticProps); return Constructor; }

function _inherits$7(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$7(subClass, superClass); }

function _setPrototypeOf$7(o, p) { _setPrototypeOf$7 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$7(o, p); }

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf$6(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$6(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$7(this, result); }; }

function _possibleConstructorReturn$7(self, call) { if (call && (_typeof$d(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$8(self); }

function _assertThisInitialized$8(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$6(o) { _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$6(o); }

function _defineProperty$9(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var QuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits$7(QuarterParser, _Parser);

  var _super = _createSuper$6(QuarterParser);

  function QuarterParser() {
    var _this;

    _classCallCheck$8(this, QuarterParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$9(_assertThisInitialized$8(_this), "priority", 120);

    _defineProperty$9(_assertThisInitialized$8(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass$7(QuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return QuarterParser;
}(Parser);

function _typeof$e(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$e = function _typeof(obj) { return typeof obj; }; } else { _typeof$e = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$e(obj); }

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$8(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$8(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$8(Constructor.prototype, protoProps); if (staticProps) _defineProperties$8(Constructor, staticProps); return Constructor; }

function _inherits$8(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$8(subClass, superClass); }

function _setPrototypeOf$8(o, p) { _setPrototypeOf$8 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$8(o, p); }

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf$7(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$7(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$8(this, result); }; }

function _possibleConstructorReturn$8(self, call) { if (call && (_typeof$e(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$9(self); }

function _assertThisInitialized$9(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$7(o) { _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$7(o); }

function _defineProperty$a(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits$8(StandAloneQuarterParser, _Parser);

  var _super = _createSuper$7(StandAloneQuarterParser);

  function StandAloneQuarterParser() {
    var _this;

    _classCallCheck$9(this, StandAloneQuarterParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$a(_assertThisInitialized$9(_this), "priority", 120);

    _defineProperty$a(_assertThisInitialized$9(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass$8(StandAloneQuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return StandAloneQuarterParser;
}(Parser);

function _typeof$f(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$f = function _typeof(obj) { return typeof obj; }; } else { _typeof$f = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$f(obj); }

function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$9(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$9(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$9(Constructor.prototype, protoProps); if (staticProps) _defineProperties$9(Constructor, staticProps); return Constructor; }

function _inherits$9(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$9(subClass, superClass); }

function _setPrototypeOf$9(o, p) { _setPrototypeOf$9 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$9(o, p); }

function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf$8(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$8(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$9(this, result); }; }

function _possibleConstructorReturn$9(self, call) { if (call && (_typeof$f(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$a(self); }

function _assertThisInitialized$a(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$8(o) { _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$8(o); }

function _defineProperty$b(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var MonthParser = /*#__PURE__*/function (_Parser) {
  _inherits$9(MonthParser, _Parser);

  var _super = _createSuper$8(MonthParser);

  function MonthParser() {
    var _this;

    _classCallCheck$a(this, MonthParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$b(_assertThisInitialized$a(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

    _defineProperty$b(_assertThisInitialized$a(_this), "priority", 110);

    return _this;
  }

  _createClass$9(MonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return MonthParser;
}(Parser);

function _typeof$g(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$g = function _typeof(obj) { return typeof obj; }; } else { _typeof$g = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$g(obj); }

function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$a(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$a(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$a(Constructor.prototype, protoProps); if (staticProps) _defineProperties$a(Constructor, staticProps); return Constructor; }

function _inherits$a(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$a(subClass, superClass); }

function _setPrototypeOf$a(o, p) { _setPrototypeOf$a = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$a(o, p); }

function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf$9(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$9(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$a(this, result); }; }

function _possibleConstructorReturn$a(self, call) { if (call && (_typeof$g(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$b(self); }

function _assertThisInitialized$b(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$9(o) { _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$9(o); }

function _defineProperty$c(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
  _inherits$a(StandAloneMonthParser, _Parser);

  var _super = _createSuper$9(StandAloneMonthParser);

  function StandAloneMonthParser() {
    var _this;

    _classCallCheck$b(this, StandAloneMonthParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$c(_assertThisInitialized$b(_this), "priority", 110);

    _defineProperty$c(_assertThisInitialized$b(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass$a(StandAloneMonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return StandAloneMonthParser;
}(Parser);

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

function _typeof$h(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$h = function _typeof(obj) { return typeof obj; }; } else { _typeof$h = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$h(obj); }

function _classCallCheck$c(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$b(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$b(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$b(Constructor.prototype, protoProps); if (staticProps) _defineProperties$b(Constructor, staticProps); return Constructor; }

function _inherits$b(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$b(subClass, superClass); }

function _setPrototypeOf$b(o, p) { _setPrototypeOf$b = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$b(o, p); }

function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf$a(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$a(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$b(this, result); }; }

function _possibleConstructorReturn$b(self, call) { if (call && (_typeof$h(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$c(self); }

function _assertThisInitialized$c(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$a(o) { _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$a(o); }

function _defineProperty$d(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LocalWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits$b(LocalWeekParser, _Parser);

  var _super = _createSuper$a(LocalWeekParser);

  function LocalWeekParser() {
    var _this;

    _classCallCheck$c(this, LocalWeekParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$d(_assertThisInitialized$c(_this), "priority", 100);

    _defineProperty$d(_assertThisInitialized$c(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);

    return _this;
  }

  _createClass$b(LocalWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, dateString);

        case 'wo':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    }
  }]);

  return LocalWeekParser;
}(Parser);

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

function _typeof$i(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$i = function _typeof(obj) { return typeof obj; }; } else { _typeof$i = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$i(obj); }

function _classCallCheck$d(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$c(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$c(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$c(Constructor.prototype, protoProps); if (staticProps) _defineProperties$c(Constructor, staticProps); return Constructor; }

function _inherits$c(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$c(subClass, superClass); }

function _setPrototypeOf$c(o, p) { _setPrototypeOf$c = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$c(o, p); }

function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf$b(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$b(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$c(this, result); }; }

function _possibleConstructorReturn$c(self, call) { if (call && (_typeof$i(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$d(self); }

function _assertThisInitialized$d(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$b(o) { _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$b(o); }

function _defineProperty$e(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ISOWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits$c(ISOWeekParser, _Parser);

  var _super = _createSuper$b(ISOWeekParser);

  function ISOWeekParser() {
    var _this;

    _classCallCheck$d(this, ISOWeekParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$e(_assertThisInitialized$d(_this), "priority", 100);

    _defineProperty$e(_assertThisInitialized$d(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass$c(ISOWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, dateString);

        case 'Io':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value));
    }
  }]);

  return ISOWeekParser;
}(Parser);

function _typeof$j(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$j = function _typeof(obj) { return typeof obj; }; } else { _typeof$j = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$j(obj); }

function _classCallCheck$e(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$d(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$d(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$d(Constructor.prototype, protoProps); if (staticProps) _defineProperties$d(Constructor, staticProps); return Constructor; }

function _inherits$d(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$d(subClass, superClass); }

function _setPrototypeOf$d(o, p) { _setPrototypeOf$d = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$d(o, p); }

function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf$c(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$c(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$d(this, result); }; }

function _possibleConstructorReturn$d(self, call) { if (call && (_typeof$j(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$e(self); }

function _assertThisInitialized$e(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$c(o) { _getPrototypeOf$c = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$c(o); }

function _defineProperty$f(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Day of the month

var DateParser = /*#__PURE__*/function (_Parser) {
  _inherits$d(DateParser, _Parser);

  var _super = _createSuper$c(DateParser);

  function DateParser() {
    var _this;

    _classCallCheck$e(this, DateParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$f(_assertThisInitialized$e(_this), "priority", 90);

    _defineProperty$f(_assertThisInitialized$e(_this), "subPriority", 1);

    _defineProperty$f(_assertThisInitialized$e(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass$d(DateParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, dateString);

        case 'do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return DateParser;
}(Parser);

function _typeof$k(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$k = function _typeof(obj) { return typeof obj; }; } else { _typeof$k = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$k(obj); }

function _classCallCheck$f(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$e(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$e(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$e(Constructor.prototype, protoProps); if (staticProps) _defineProperties$e(Constructor, staticProps); return Constructor; }

function _inherits$e(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$e(subClass, superClass); }

function _setPrototypeOf$e(o, p) { _setPrototypeOf$e = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$e(o, p); }

function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = _getPrototypeOf$d(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$d(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$e(this, result); }; }

function _possibleConstructorReturn$e(self, call) { if (call && (_typeof$k(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$f(self); }

function _assertThisInitialized$f(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$d(o) { _getPrototypeOf$d = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$d(o); }

function _defineProperty$g(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var DayOfYearParser = /*#__PURE__*/function (_Parser) {
  _inherits$e(DayOfYearParser, _Parser);

  var _super = _createSuper$d(DayOfYearParser);

  function DayOfYearParser() {
    var _this;

    _classCallCheck$f(this, DayOfYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$g(_assertThisInitialized$f(_this), "priority", 90);

    _defineProperty$g(_assertThisInitialized$f(_this), "subpriority", 1);

    _defineProperty$g(_assertThisInitialized$f(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass$e(DayOfYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);

        case 'Do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return DayOfYearParser;
}(Parser);

function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(2, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

function _typeof$l(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$l = function _typeof(obj) { return typeof obj; }; } else { _typeof$l = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$l(obj); }

function _classCallCheck$g(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$f(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$f(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$f(Constructor.prototype, protoProps); if (staticProps) _defineProperties$f(Constructor, staticProps); return Constructor; }

function _inherits$f(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$f(subClass, superClass); }

function _setPrototypeOf$f(o, p) { _setPrototypeOf$f = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$f(o, p); }

function _createSuper$e(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$e(); return function _createSuperInternal() { var Super = _getPrototypeOf$e(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$e(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$f(this, result); }; }

function _possibleConstructorReturn$f(self, call) { if (call && (_typeof$l(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$g(self); }

function _assertThisInitialized$g(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$e(o) { _getPrototypeOf$e = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$e(o); }

function _defineProperty$h(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DayParser = /*#__PURE__*/function (_Parser) {
  _inherits$f(DayParser, _Parser);

  var _super = _createSuper$e(DayParser);

  function DayParser() {
    var _this;

    _classCallCheck$g(this, DayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$h(_assertThisInitialized$g(_this), "priority", 90);

    _defineProperty$h(_assertThisInitialized$g(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass$f(DayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return DayParser;
}(Parser);

function _typeof$m(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$m = function _typeof(obj) { return typeof obj; }; } else { _typeof$m = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$m(obj); }

function _classCallCheck$h(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$g(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$g(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$g(Constructor.prototype, protoProps); if (staticProps) _defineProperties$g(Constructor, staticProps); return Constructor; }

function _inherits$g(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$g(subClass, superClass); }

function _setPrototypeOf$g(o, p) { _setPrototypeOf$g = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$g(o, p); }

function _createSuper$f(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$f(); return function _createSuperInternal() { var Super = _getPrototypeOf$f(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$f(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$g(this, result); }; }

function _possibleConstructorReturn$g(self, call) { if (call && (_typeof$m(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$h(self); }

function _assertThisInitialized$h(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$f() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$f(o) { _getPrototypeOf$f = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$f(o); }

function _defineProperty$i(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits$g(LocalDayParser, _Parser);

  var _super = _createSuper$f(LocalDayParser);

  function LocalDayParser() {
    var _this;

    _classCallCheck$h(this, LocalDayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$i(_assertThisInitialized$h(_this), "priority", 90);

    _defineProperty$i(_assertThisInitialized$h(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);

    return _this;
  }

  _createClass$g(LocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd

        case 'eo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue

        case 'eee':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return LocalDayParser;
}(Parser);

function _typeof$n(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$n = function _typeof(obj) { return typeof obj; }; } else { _typeof$n = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$n(obj); }

function _classCallCheck$i(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$h(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$h(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$h(Constructor.prototype, protoProps); if (staticProps) _defineProperties$h(Constructor, staticProps); return Constructor; }

function _inherits$h(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$h(subClass, superClass); }

function _setPrototypeOf$h(o, p) { _setPrototypeOf$h = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$h(o, p); }

function _createSuper$g(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$g(); return function _createSuperInternal() { var Super = _getPrototypeOf$g(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$g(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$h(this, result); }; }

function _possibleConstructorReturn$h(self, call) { if (call && (_typeof$n(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$i(self); }

function _assertThisInitialized$i(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$g() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$g(o) { _getPrototypeOf$g = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$g(o); }

function _defineProperty$j(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits$h(StandAloneLocalDayParser, _Parser);

  var _super = _createSuper$g(StandAloneLocalDayParser);

  function StandAloneLocalDayParser() {
    var _this;

    _classCallCheck$i(this, StandAloneLocalDayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$j(_assertThisInitialized$i(_this), "priority", 90);

    _defineProperty$j(_assertThisInitialized$i(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);

    return _this;
  }

  _createClass$h(StandAloneLocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd

        case 'co':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue

        case 'ccc':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return StandAloneLocalDayParser;
}(Parser);

function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

function _typeof$o(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$o = function _typeof(obj) { return typeof obj; }; } else { _typeof$o = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$o(obj); }

function _classCallCheck$j(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$i(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$i(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$i(Constructor.prototype, protoProps); if (staticProps) _defineProperties$i(Constructor, staticProps); return Constructor; }

function _inherits$i(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$i(subClass, superClass); }

function _setPrototypeOf$i(o, p) { _setPrototypeOf$i = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$i(o, p); }

function _createSuper$h(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$h(); return function _createSuperInternal() { var Super = _getPrototypeOf$h(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$h(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$i(this, result); }; }

function _possibleConstructorReturn$i(self, call) { if (call && (_typeof$o(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$j(self); }

function _assertThisInitialized$j(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$h() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$h(o) { _getPrototypeOf$h = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$h(o); }

function _defineProperty$k(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ISODayParser = /*#__PURE__*/function (_Parser) {
  _inherits$i(ISODayParser, _Parser);

  var _super = _createSuper$h(ISODayParser);

  function ISODayParser() {
    var _this;

    _classCallCheck$j(this, ISODayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$k(_assertThisInitialized$j(_this), "priority", 90);

    _defineProperty$k(_assertThisInitialized$j(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass$i(ISODayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, dateString);
        // 2nd

        case 'io':
          return match.ordinalNumber(dateString, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return mapValue(match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // T

        case 'iiiii':
          return mapValue(match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tu

        case 'iiiiii':
          return mapValue(match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tuesday

        case 'iiii':
        default:
          return mapValue(match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date = setUTCISODay(date, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return ISODayParser;
}(Parser);

function _typeof$p(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$p = function _typeof(obj) { return typeof obj; }; } else { _typeof$p = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$p(obj); }

function _classCallCheck$k(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$j(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$j(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$j(Constructor.prototype, protoProps); if (staticProps) _defineProperties$j(Constructor, staticProps); return Constructor; }

function _inherits$j(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$j(subClass, superClass); }

function _setPrototypeOf$j(o, p) { _setPrototypeOf$j = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$j(o, p); }

function _createSuper$i(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$i(); return function _createSuperInternal() { var Super = _getPrototypeOf$i(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$i(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$j(this, result); }; }

function _possibleConstructorReturn$j(self, call) { if (call && (_typeof$p(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$k(self); }

function _assertThisInitialized$k(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$i() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$i(o) { _getPrototypeOf$i = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$i(o); }

function _defineProperty$l(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var AMPMParser = /*#__PURE__*/function (_Parser) {
  _inherits$j(AMPMParser, _Parser);

  var _super = _createSuper$i(AMPMParser);

  function AMPMParser() {
    var _this;

    _classCallCheck$k(this, AMPMParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$l(_assertThisInitialized$k(_this), "priority", 80);

    _defineProperty$l(_assertThisInitialized$k(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);

    return _this;
  }

  _createClass$j(AMPMParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);

  return AMPMParser;
}(Parser);

function _typeof$q(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$q = function _typeof(obj) { return typeof obj; }; } else { _typeof$q = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$q(obj); }

function _classCallCheck$l(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$k(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$k(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$k(Constructor.prototype, protoProps); if (staticProps) _defineProperties$k(Constructor, staticProps); return Constructor; }

function _inherits$k(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$k(subClass, superClass); }

function _setPrototypeOf$k(o, p) { _setPrototypeOf$k = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$k(o, p); }

function _createSuper$j(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$j(); return function _createSuperInternal() { var Super = _getPrototypeOf$j(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$j(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$k(this, result); }; }

function _possibleConstructorReturn$k(self, call) { if (call && (_typeof$q(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$l(self); }

function _assertThisInitialized$l(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$j() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$j(o) { _getPrototypeOf$j = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$j(o); }

function _defineProperty$m(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
  _inherits$k(AMPMMidnightParser, _Parser);

  var _super = _createSuper$j(AMPMMidnightParser);

  function AMPMMidnightParser() {
    var _this;

    _classCallCheck$l(this, AMPMMidnightParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$m(_assertThisInitialized$l(_this), "priority", 80);

    _defineProperty$m(_assertThisInitialized$l(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);

    return _this;
  }

  _createClass$k(AMPMMidnightParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);

  return AMPMMidnightParser;
}(Parser);

function _typeof$r(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$r = function _typeof(obj) { return typeof obj; }; } else { _typeof$r = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$r(obj); }

function _classCallCheck$m(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$l(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$l(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$l(Constructor.prototype, protoProps); if (staticProps) _defineProperties$l(Constructor, staticProps); return Constructor; }

function _inherits$l(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$l(subClass, superClass); }

function _setPrototypeOf$l(o, p) { _setPrototypeOf$l = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$l(o, p); }

function _createSuper$k(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$k(); return function _createSuperInternal() { var Super = _getPrototypeOf$k(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$k(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$l(this, result); }; }

function _possibleConstructorReturn$l(self, call) { if (call && (_typeof$r(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$m(self); }

function _assertThisInitialized$m(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$k() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$k(o) { _getPrototypeOf$k = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$k(o); }

function _defineProperty$n(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DayPeriodParser = /*#__PURE__*/function (_Parser) {
  _inherits$l(DayPeriodParser, _Parser);

  var _super = _createSuper$k(DayPeriodParser);

  function DayPeriodParser() {
    var _this;

    _classCallCheck$m(this, DayPeriodParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$n(_assertThisInitialized$m(_this), "priority", 80);

    _defineProperty$n(_assertThisInitialized$m(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);

    return _this;
  }

  _createClass$l(DayPeriodParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);

  return DayPeriodParser;
}(Parser);

function _typeof$s(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$s = function _typeof(obj) { return typeof obj; }; } else { _typeof$s = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$s(obj); }

function _classCallCheck$n(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$m(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$m(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$m(Constructor.prototype, protoProps); if (staticProps) _defineProperties$m(Constructor, staticProps); return Constructor; }

function _inherits$m(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$m(subClass, superClass); }

function _setPrototypeOf$m(o, p) { _setPrototypeOf$m = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$m(o, p); }

function _createSuper$l(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$l(); return function _createSuperInternal() { var Super = _getPrototypeOf$l(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$l(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$m(this, result); }; }

function _possibleConstructorReturn$m(self, call) { if (call && (_typeof$s(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$n(self); }

function _assertThisInitialized$n(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$l() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$l(o) { _getPrototypeOf$l = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$l(o); }

function _defineProperty$o(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
  _inherits$m(Hour1to12Parser, _Parser);

  var _super = _createSuper$l(Hour1to12Parser);

  function Hour1to12Parser() {
    var _this;

    _classCallCheck$n(this, Hour1to12Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$o(_assertThisInitialized$n(_this), "priority", 70);

    _defineProperty$o(_assertThisInitialized$n(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);

    return _this;
  }

  _createClass$m(Hour1to12Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, dateString);

        case 'ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    }
  }]);

  return Hour1to12Parser;
}(Parser);

function _typeof$t(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$t = function _typeof(obj) { return typeof obj; }; } else { _typeof$t = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$t(obj); }

function _classCallCheck$o(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$n(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$n(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$n(Constructor.prototype, protoProps); if (staticProps) _defineProperties$n(Constructor, staticProps); return Constructor; }

function _inherits$n(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$n(subClass, superClass); }

function _setPrototypeOf$n(o, p) { _setPrototypeOf$n = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$n(o, p); }

function _createSuper$m(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$m(); return function _createSuperInternal() { var Super = _getPrototypeOf$m(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$m(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$n(this, result); }; }

function _possibleConstructorReturn$n(self, call) { if (call && (_typeof$t(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$o(self); }

function _assertThisInitialized$o(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$m() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$m(o) { _getPrototypeOf$m = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$m(o); }

function _defineProperty$p(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
  _inherits$n(Hour0to23Parser, _Parser);

  var _super = _createSuper$m(Hour0to23Parser);

  function Hour0to23Parser() {
    var _this;

    _classCallCheck$o(this, Hour0to23Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$p(_assertThisInitialized$o(_this), "priority", 70);

    _defineProperty$p(_assertThisInitialized$o(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);

    return _this;
  }

  _createClass$n(Hour0to23Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, dateString);

        case 'Ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  }]);

  return Hour0to23Parser;
}(Parser);

function _typeof$u(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$u = function _typeof(obj) { return typeof obj; }; } else { _typeof$u = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$u(obj); }

function _classCallCheck$p(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$o(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$o(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$o(Constructor.prototype, protoProps); if (staticProps) _defineProperties$o(Constructor, staticProps); return Constructor; }

function _inherits$o(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$o(subClass, superClass); }

function _setPrototypeOf$o(o, p) { _setPrototypeOf$o = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$o(o, p); }

function _createSuper$n(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$n(); return function _createSuperInternal() { var Super = _getPrototypeOf$n(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$n(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$o(this, result); }; }

function _possibleConstructorReturn$o(self, call) { if (call && (_typeof$u(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$p(self); }

function _assertThisInitialized$p(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$n() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$n(o) { _getPrototypeOf$n = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$n(o); }

function _defineProperty$q(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
  _inherits$o(Hour0To11Parser, _Parser);

  var _super = _createSuper$n(Hour0To11Parser);

  function Hour0To11Parser() {
    var _this;

    _classCallCheck$p(this, Hour0To11Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$q(_assertThisInitialized$p(_this), "priority", 70);

    _defineProperty$q(_assertThisInitialized$p(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);

    return _this;
  }

  _createClass$o(Hour0To11Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, dateString);

        case 'Ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    }
  }]);

  return Hour0To11Parser;
}(Parser);

function _typeof$v(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$v = function _typeof(obj) { return typeof obj; }; } else { _typeof$v = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$v(obj); }

function _classCallCheck$q(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$p(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$p(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$p(Constructor.prototype, protoProps); if (staticProps) _defineProperties$p(Constructor, staticProps); return Constructor; }

function _inherits$p(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$p(subClass, superClass); }

function _setPrototypeOf$p(o, p) { _setPrototypeOf$p = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$p(o, p); }

function _createSuper$o(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$o(); return function _createSuperInternal() { var Super = _getPrototypeOf$o(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$o(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$p(this, result); }; }

function _possibleConstructorReturn$p(self, call) { if (call && (_typeof$v(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$q(self); }

function _assertThisInitialized$q(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$o() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$o(o) { _getPrototypeOf$o = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$o(o); }

function _defineProperty$r(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
  _inherits$p(Hour1To24Parser, _Parser);

  var _super = _createSuper$o(Hour1To24Parser);

  function Hour1To24Parser() {
    var _this;

    _classCallCheck$q(this, Hour1To24Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$r(_assertThisInitialized$q(_this), "priority", 70);

    _defineProperty$r(_assertThisInitialized$q(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);

    return _this;
  }

  _createClass$p(Hour1To24Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, dateString);

        case 'ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);

  return Hour1To24Parser;
}(Parser);

function _typeof$w(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$w = function _typeof(obj) { return typeof obj; }; } else { _typeof$w = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$w(obj); }

function _classCallCheck$r(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$q(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$q(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$q(Constructor.prototype, protoProps); if (staticProps) _defineProperties$q(Constructor, staticProps); return Constructor; }

function _inherits$q(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$q(subClass, superClass); }

function _setPrototypeOf$q(o, p) { _setPrototypeOf$q = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$q(o, p); }

function _createSuper$p(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$p(); return function _createSuperInternal() { var Super = _getPrototypeOf$p(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$p(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$q(this, result); }; }

function _possibleConstructorReturn$q(self, call) { if (call && (_typeof$w(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$r(self); }

function _assertThisInitialized$r(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$p() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$p(o) { _getPrototypeOf$p = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$p(o); }

function _defineProperty$s(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var MinuteParser = /*#__PURE__*/function (_Parser) {
  _inherits$q(MinuteParser, _Parser);

  var _super = _createSuper$p(MinuteParser);

  function MinuteParser() {
    var _this;

    _classCallCheck$r(this, MinuteParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$s(_assertThisInitialized$r(_this), "priority", 60);

    _defineProperty$s(_assertThisInitialized$r(_this), "incompatibleTokens", ['t', 'T']);

    return _this;
  }

  _createClass$q(MinuteParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, dateString);

        case 'mo':
          return match.ordinalNumber(dateString, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  }]);

  return MinuteParser;
}(Parser);

function _typeof$x(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$x = function _typeof(obj) { return typeof obj; }; } else { _typeof$x = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$x(obj); }

function _classCallCheck$s(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$r(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$r(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$r(Constructor.prototype, protoProps); if (staticProps) _defineProperties$r(Constructor, staticProps); return Constructor; }

function _inherits$r(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$r(subClass, superClass); }

function _setPrototypeOf$r(o, p) { _setPrototypeOf$r = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$r(o, p); }

function _createSuper$q(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$q(); return function _createSuperInternal() { var Super = _getPrototypeOf$q(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$q(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$r(this, result); }; }

function _possibleConstructorReturn$r(self, call) { if (call && (_typeof$x(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$s(self); }

function _assertThisInitialized$s(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$q() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$q(o) { _getPrototypeOf$q = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$q(o); }

function _defineProperty$t(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var SecondParser = /*#__PURE__*/function (_Parser) {
  _inherits$r(SecondParser, _Parser);

  var _super = _createSuper$q(SecondParser);

  function SecondParser() {
    var _this;

    _classCallCheck$s(this, SecondParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$t(_assertThisInitialized$s(_this), "priority", 50);

    _defineProperty$t(_assertThisInitialized$s(_this), "incompatibleTokens", ['t', 'T']);

    return _this;
  }

  _createClass$r(SecondParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, dateString);

        case 'so':
          return match.ordinalNumber(dateString, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  }]);

  return SecondParser;
}(Parser);

function _typeof$y(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$y = function _typeof(obj) { return typeof obj; }; } else { _typeof$y = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$y(obj); }

function _classCallCheck$t(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$s(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$s(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$s(Constructor.prototype, protoProps); if (staticProps) _defineProperties$s(Constructor, staticProps); return Constructor; }

function _inherits$s(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$s(subClass, superClass); }

function _setPrototypeOf$s(o, p) { _setPrototypeOf$s = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$s(o, p); }

function _createSuper$r(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$r(); return function _createSuperInternal() { var Super = _getPrototypeOf$r(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$r(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$s(this, result); }; }

function _possibleConstructorReturn$s(self, call) { if (call && (_typeof$y(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$t(self); }

function _assertThisInitialized$t(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$r() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$r(o) { _getPrototypeOf$r = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$r(o); }

function _defineProperty$u(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
  _inherits$s(FractionOfSecondParser, _Parser);

  var _super = _createSuper$r(FractionOfSecondParser);

  function FractionOfSecondParser() {
    var _this;

    _classCallCheck$t(this, FractionOfSecondParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$u(_assertThisInitialized$t(_this), "priority", 30);

    _defineProperty$u(_assertThisInitialized$t(_this), "incompatibleTokens", ['t', 'T']);

    return _this;
  }

  _createClass$s(FractionOfSecondParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMilliseconds(value);
      return date;
    }
  }]);

  return FractionOfSecondParser;
}(Parser);

function _typeof$z(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$z = function _typeof(obj) { return typeof obj; }; } else { _typeof$z = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$z(obj); }

function _classCallCheck$u(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$t(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$t(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$t(Constructor.prototype, protoProps); if (staticProps) _defineProperties$t(Constructor, staticProps); return Constructor; }

function _inherits$t(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$t(subClass, superClass); }

function _setPrototypeOf$t(o, p) { _setPrototypeOf$t = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$t(o, p); }

function _createSuper$s(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$s(); return function _createSuperInternal() { var Super = _getPrototypeOf$s(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$s(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$t(this, result); }; }

function _possibleConstructorReturn$t(self, call) { if (call && (_typeof$z(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$u(self); }

function _assertThisInitialized$u(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$s() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$s(o) { _getPrototypeOf$s = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$s(o); }

function _defineProperty$v(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
  _inherits$t(ISOTimezoneWithZParser, _Parser);

  var _super = _createSuper$s(ISOTimezoneWithZParser);

  function ISOTimezoneWithZParser() {
    var _this;

    _classCallCheck$u(this, ISOTimezoneWithZParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$v(_assertThisInitialized$u(_this), "priority", 10);

    _defineProperty$v(_assertThisInitialized$u(_this), "incompatibleTokens", ['t', 'T', 'x']);

    return _this;
  }

  _createClass$t(ISOTimezoneWithZParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, dateString);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    }
  }]);

  return ISOTimezoneWithZParser;
}(Parser);

function _typeof$A(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$A = function _typeof(obj) { return typeof obj; }; } else { _typeof$A = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$A(obj); }

function _classCallCheck$v(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$u(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$u(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$u(Constructor.prototype, protoProps); if (staticProps) _defineProperties$u(Constructor, staticProps); return Constructor; }

function _inherits$u(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$u(subClass, superClass); }

function _setPrototypeOf$u(o, p) { _setPrototypeOf$u = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$u(o, p); }

function _createSuper$t(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$t(); return function _createSuperInternal() { var Super = _getPrototypeOf$t(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$t(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$u(this, result); }; }

function _possibleConstructorReturn$u(self, call) { if (call && (_typeof$A(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$v(self); }

function _assertThisInitialized$v(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$t() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$t(o) { _getPrototypeOf$t = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$t(o); }

function _defineProperty$w(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
  _inherits$u(ISOTimezoneParser, _Parser);

  var _super = _createSuper$t(ISOTimezoneParser);

  function ISOTimezoneParser() {
    var _this;

    _classCallCheck$v(this, ISOTimezoneParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$w(_assertThisInitialized$v(_this), "priority", 10);

    _defineProperty$w(_assertThisInitialized$v(_this), "incompatibleTokens", ['t', 'T', 'X']);

    return _this;
  }

  _createClass$u(ISOTimezoneParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, dateString);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    }
  }]);

  return ISOTimezoneParser;
}(Parser);

function _typeof$B(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$B = function _typeof(obj) { return typeof obj; }; } else { _typeof$B = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$B(obj); }

function _classCallCheck$w(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$v(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$v(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$v(Constructor.prototype, protoProps); if (staticProps) _defineProperties$v(Constructor, staticProps); return Constructor; }

function _inherits$v(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$v(subClass, superClass); }

function _setPrototypeOf$v(o, p) { _setPrototypeOf$v = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$v(o, p); }

function _createSuper$u(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$u(); return function _createSuperInternal() { var Super = _getPrototypeOf$u(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$u(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$v(this, result); }; }

function _possibleConstructorReturn$v(self, call) { if (call && (_typeof$B(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$w(self); }

function _assertThisInitialized$w(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$u() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$u(o) { _getPrototypeOf$u = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$u(o); }

function _defineProperty$x(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits$v(TimestampSecondsParser, _Parser);

  var _super = _createSuper$u(TimestampSecondsParser);

  function TimestampSecondsParser() {
    var _this;

    _classCallCheck$w(this, TimestampSecondsParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$x(_assertThisInitialized$w(_this), "priority", 40);

    _defineProperty$x(_assertThisInitialized$w(_this), "incompatibleTokens", '*');

    return _this;
  }

  _createClass$v(TimestampSecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    }
  }]);

  return TimestampSecondsParser;
}(Parser);

function _typeof$C(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$C = function _typeof(obj) { return typeof obj; }; } else { _typeof$C = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$C(obj); }

function _classCallCheck$x(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$w(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$w(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$w(Constructor.prototype, protoProps); if (staticProps) _defineProperties$w(Constructor, staticProps); return Constructor; }

function _inherits$w(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$w(subClass, superClass); }

function _setPrototypeOf$w(o, p) { _setPrototypeOf$w = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$w(o, p); }

function _createSuper$v(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$v(); return function _createSuperInternal() { var Super = _getPrototypeOf$v(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$v(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$w(this, result); }; }

function _possibleConstructorReturn$w(self, call) { if (call && (_typeof$C(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$x(self); }

function _assertThisInitialized$x(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$v() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$v(o) { _getPrototypeOf$v = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$v(o); }

function _defineProperty$y(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits$w(TimestampMillisecondsParser, _Parser);

  var _super = _createSuper$v(TimestampMillisecondsParser);

  function TimestampMillisecondsParser() {
    var _this;

    _classCallCheck$x(this, TimestampMillisecondsParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$y(_assertThisInitialized$x(_this), "priority", 20);

    _defineProperty$y(_assertThisInitialized$x(_this), "incompatibleTokens", '*');

    return _this;
  }

  _createClass$w(TimestampMillisecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);

  return TimestampMillisecondsParser;
}(Parser);

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */

var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};

function _typeof$D(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$D = function _typeof(obj) { return typeof obj; }; } else { _typeof$D = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$D(obj); }

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse$1(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions = getDefaultOptions();
  var locale$1 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : locale;

  if (!locale$1.match) {
    throw new RangeError('locale must contain match property');
  }

  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1
  }; // If timezone isn't specified, it will be set to the system timezone

  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp$1).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter in longFormatters) {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong);
    }

    return substring;
  }).join('').match(formattingTokensRegExp$1);
  var usedTokens = [];

  var _iterator = _createForOfIteratorHelper$1(tokens),
      _step;

  try {
    var _loop = function _loop() {
      var token = _step.value;

      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token)) {
        throwProtectedError(token, formatString, dirtyDateString);
      }

      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token)) {
        throwProtectedError(token, formatString, dirtyDateString);
      }

      var firstCharacter = token[0];
      var parser = parsers[firstCharacter];

      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;

        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function (usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });

          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
        }

        usedTokens.push({
          token: firstCharacter,
          fullToken: token
        });
        var parseResult = parser.run(dateString, token, locale$1.match, subFnOptions);

        if (!parseResult) {
          return {
            v: new Date(NaN)
          };
        }

        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        } // Replace two single quote characters with one single quote character


        if (token === "''") {
          token = "'";
        } else if (firstCharacter === "'") {
          token = cleanEscapedString$1(token);
        } // Cut token from string, or, if string doesn't match the token, return Invalid Date


        if (dateString.indexOf(token) === 0) {
          dateString = dateString.slice(token.length);
        } else {
          return {
            v: new Date(NaN)
          };
        }
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();

      if (_typeof$D(_ret) === "object") return _ret.v;
    } // Check if the remaining input contains something other than whitespace

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.


  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};

  var _iterator2 = _createForOfIteratorHelper$1(uniquePrioritySetters),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var setter = _step2.value;

      if (!setter.validate(utcDate, subFnOptions)) {
        return new Date(NaN);
      }

      var result = setter.set(utcDate, flags, subFnOptions); // Result is tuple (date, flags)

      if (Array.isArray(result)) {
        utcDate = result[0];
        assign(flags, result[1]); // Result is date
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return utcDate;
}

function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, options) {
  var _options$additionalDi;

  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both

  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex$1(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex$1(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

function _inheritsLoose$2(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf$x(subClass, superClass);
}

function _setPrototypeOf$x(o, p) {
  _setPrototypeOf$x = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$x(o, p);
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized$y(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host


  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose$2(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return findDOMNode(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized$y(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized$y(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose$3(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return createElement$2(WrappedComponent, props);
    };

    return onClickOutside;
  }(Component$1), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}

var toStr = Object.prototype.toString;

var isArguments = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr$1 = Object.prototype.toString;
	var isArgs = isArguments; // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr$1.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr$1.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
var implementation = keysShim;

var slice = Array.prototype.slice;


var origKeys = Object.keys;
var keysShim$1 = origKeys ? function keys(o) { return origKeys(o); } : implementation;

var originalKeys = Object.keys;

keysShim$1.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArguments(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim$1;
	}
	return Object.keys || keysShim$1;
};

var objectKeys = keysShim$1;

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

var shams$1 = function hasToStringTagShams() {
	return shams() && !!Symbol.toStringTag;
};

var origSymbol = typeof Symbol !== 'undefined' && Symbol;


var hasSymbols = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return shams();
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice$1 = Array.prototype.slice;
var toStr$2 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation$1 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$2.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice$1.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice$1.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice$1.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var functionBind = Function.prototype.bind || implementation$1;

var src = functionBind.call(Function.call, Object.prototype.hasOwnProperty);

var undefined$1;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols$1 = hasSymbols();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols$1 ? getProto([][Symbol.iterator]()) : undefined$1,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols$1 ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$1 ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$1 ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols$1 ? getProto(''[Symbol.iterator]()) : undefined$1,
	'%Symbol%': hasSymbols$1 ? Symbol : undefined$1,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};



var $concat = functionBind.call(Function.call, Array.prototype.concat);
var $spliceApply = functionBind.call(Function.apply, Array.prototype.splice);
var $replace = functionBind.call(Function.call, String.prototype.replace);
var $strSlice = functionBind.call(Function.call, String.prototype.slice);
var $exec = functionBind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (src(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (src(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (src(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined$1;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = src(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var callBind = createCommonjsModule(function (module) {




var $apply = getIntrinsic('%Function.prototype.apply%');
var $call = getIntrinsic('%Function.prototype.call%');
var $reflectApply = getIntrinsic('%Reflect.apply%', true) || functionBind.call($call, $apply);

var $gOPD = getIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = getIntrinsic('%Object.defineProperty%', true);
var $max = getIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(functionBind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(functionBind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}
});
var callBind_1 = callBind.apply;

var $indexOf = callBind(getIntrinsic('String.prototype.indexOf'));

var callBound = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = getIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

var hasToStringTag = shams$1();


var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

var isArguments$1 = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

var $defineProperty = getIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

var hasPropertyDescriptors_1 = hasPropertyDescriptors;

var hasSymbols$2 = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr$3 = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr$3.call(fn) === '[object Function]';
};

var hasPropertyDescriptors$1 = hasPropertyDescriptors_1();

var supportsDescriptors = origDefineProperty && hasPropertyDescriptors$1;

var defineProperty$1 = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value; // eslint-disable-line no-param-reassign
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = objectKeys(map);
	if (hasSymbols$2) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty$1(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

var defineProperties_1 = defineProperties;

var numberIsNaN = function (value) {
	return value !== value;
};

var implementation$2 = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};

var polyfill$1 = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation$2;
};

var shim = function shimObjectIs() {
	var polyfill = polyfill$1();
	defineProperties_1(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};

var polyfill$2 = callBind(polyfill$1(), Object);

defineProperties_1(polyfill$2, {
	getPolyfill: polyfill$1,
	implementation: implementation$2,
	shim: shim
});

var objectIs = polyfill$2;

var hasToStringTag$1 = shams$1();
var has$1;
var $exec$1;
var isRegexMarker;
var badStringifier;

if (hasToStringTag$1) {
	has$1 = callBound('Object.prototype.hasOwnProperty');
	$exec$1 = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString$1 = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

var isRegex = hasToStringTag$1
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has$1(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec$1(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString$1(value) === regexClass;
	};

var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD$1 = Object.getOwnPropertyDescriptor;
if (gOPD$1) {
	try {
		gOPD$1([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD$1 = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	if (!functionsHaveNames() || !gOPD$1) {
		return false;
	}
	var desc = gOPD$1(function () {}, 'name');
	return !!desc && !!desc.configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

var functionsHaveNames_1 = functionsHaveNames;

var implementation$3 = createCommonjsModule(function (module) {

var functionsHaveConfigurableNames = functionsHaveNames_1.functionsHaveConfigurableNames();

var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.hasIndices) {
		result += 'd';
	}
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};

if (functionsHaveConfigurableNames && Object.defineProperty) {
	Object.defineProperty(module.exports, 'name', { value: 'get flags' });
}
});

var supportsDescriptors$1 = defineProperties_1.supportsDescriptors;
var $gOPD$1 = Object.getOwnPropertyDescriptor;

var polyfill$3 = function getPolyfill() {
	if (supportsDescriptors$1 && (/a/mig).flags === 'gim') {
		var descriptor = $gOPD$1(RegExp.prototype, 'flags');
		if (
			descriptor
			&& typeof descriptor.get === 'function'
			&& typeof RegExp.prototype.dotAll === 'boolean'
			&& typeof RegExp.prototype.hasIndices === 'boolean'
		) {
			/* eslint getter-return: 0 */
			var calls = '';
			var o = {};
			Object.defineProperty(o, 'hasIndices', {
				get: function () {
					calls += 'd';
				}
			});
			Object.defineProperty(o, 'sticky', {
				get: function () {
					calls += 'y';
				}
			});
			if (calls === 'dy') {
				return descriptor.get;
			}
		}
	}
	return implementation$3;
};

var supportsDescriptors$2 = defineProperties_1.supportsDescriptors;

var gOPD$2 = Object.getOwnPropertyDescriptor;
var defineProperty$2 = Object.defineProperty;
var TypeErr = TypeError;
var getProto$1 = Object.getPrototypeOf;
var regex = /a/;

var shim$1 = function shimFlags() {
	if (!supportsDescriptors$2 || !getProto$1) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = polyfill$3();
	var proto = getProto$1(regex);
	var descriptor = gOPD$2(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty$2(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};

var flagsBound = callBind(polyfill$3());

defineProperties_1(flagsBound, {
	getPolyfill: polyfill$3,
	implementation: implementation$3,
	shim: shim$1
});

var regexp_prototype_flags = flagsBound;

var getDay$1 = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay$1.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr$4 = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag$2 = shams$1();

var isDateObject = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag$2 ? tryDateObject(value) : toStr$4.call(value) === dateClass;
};

var getTime$1 = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? objectIs(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? objectIs(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments$1(a) !== isArguments$1(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && regexp_prototype_flags(a) === regexp_prototype_flags(b);
  }

  if (isDateObject(a) && isDateObject(b)) {
    return getTime$1.call(a) === getTime$1.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

var deepEqual_1 = deepEqual;

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser$3 = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser$3 && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser$3 && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce$1 = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction$1(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode$1(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent$1(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent$1(getParentNode$1(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser$3 && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser$3 && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent$1(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent$1(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent$1(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent$1(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll$1(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll$1(element, 'top');
  var scrollLeft = getScroll$1(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize$3(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize$3('Height', body, html, computedStyle),
    width: getSize$3('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty$3 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends$7o = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends$7o({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect$1(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll$1(element, 'top');
      var scrollLeft = getScroll$1(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect$1(children);
  var parentRect = getBoundingClientRect$1(parent);
  var scrollParent = getScrollParent$1(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll$1(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll$1(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode$1(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent$1(getParentNode$1(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement$1(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends$7o({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement$1(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement$1(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex$1(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex$1(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction$1(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update$1() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement$1(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow$1(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent$1(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow$1(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent$1(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow$1(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement$1(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser$3 && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent$1(data.instance.popper);
  var offsetParentRect = getBoundingClientRect$1(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends$7o({}, attributes, data.attributes);
  data.styles = _extends$7o({}, styles, data.styles);
  data.arrowStyles = _extends$7o({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow$2(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty$3(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty$3(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements$1 = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements$1.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip$2(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement$1(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement$1(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends$7o({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset$2(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow$2(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent$1(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent$1(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty$3({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty$3({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends$7o({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty$3({}, side, reference[side]),
      end: defineProperty$3({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends$7o({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide$2(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement$1(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset$2,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow$2,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow$2,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip$2,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide$2
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce$1(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends$7o({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends$7o({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends$7o({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends$7o({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction$1(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update$1.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements$1;
Popper.Defaults = Defaults;

var key = '__global_unique_id__';

var gud = function() {
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
};

var implementation$4 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _gud2 = _interopRequireDefault(gud);



var _warning2 = _interopRequireDefault(warning_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (process.env.NODE_ENV !== 'production') {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(React__default.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(React__default.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];
});

unwrapExports(implementation$4);

var lib$3 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _react2 = _interopRequireDefault(React__default);



var _implementation2 = _interopRequireDefault(implementation$4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];
});

var createContext = unwrapExports(lib$3);

var ManagerReferenceNodeContext = createContext();
var ManagerReferenceNodeSetterContext = createContext();

var Manager =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose$1(Manager, _React$Component);

  function Manager() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "referenceNode", void 0);

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "setReferenceNode", function (newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;

        _this.forceUpdate();
      }
    });

    return _this;
  }

  var _proto = Manager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };

  _proto.render = function render() {
    return createElement$2(ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, createElement$2(ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };

  return Manager;
}(Component$1);

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Does a shallow equality check of two objects by comparing the reference
 * equality of each value.
 */

var shallowEqual = function shallowEqual(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (bKeys.length !== aKeys.length) {
    return false;
  }

  for (var i = 0; i < bKeys.length; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};

var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose$1(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "state", {
      data: undefined,
      placement: undefined
    });

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "popperInstance", void 0);

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "popperNode", null);

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "arrowNode", null);

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      setRef(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: _extends$7m({}, _this.props.modifiers, {
          arrow: _extends$7m({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : _extends$7m({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = _assertThisInitialized$1(_assertThisInitialized$1(_this)),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new Popper(referenceElement, popperNode, _this.getOptions());
    });

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !deepEqual_1(this.props.modifiers, prevProps.modifiers, {
      strict: true
    })) {
      // develop only check that modifiers isn't being updated needlessly
      if (process.env.NODE_ENV === "development") {
        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && shallowEqual(this.props.modifiers, prevProps.modifiers)) {
          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
        }
      }

      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    setRef(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return unwrapArray(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(Component$1);

_defineProperty$1(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});
function Popper$1(_ref) {
  var referenceElement = _ref.referenceElement,
      props = _objectWithoutPropertiesLoose$2(_ref, ["referenceElement"]);

  return createElement$2(ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
    return createElement$2(InnerPopper, _extends$7m({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}

var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose$1(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "refHandler", function (node) {
      setRef(_this.props.innerRef, node);
      safeInvoke(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    setRef(this.props.innerRef, null);
  };

  _proto.render = function render() {
    warning_1(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return unwrapArray(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(Component$1);

function Reference(props) {
  return createElement$2(ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
    return createElement$2(InnerReference, _extends$7m({
      setReferenceNode: setReferenceNode
    }, props));
  });
}

function oe(e){return (oe="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ae(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function se(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}function ie(e,t,r){return t&&se(e.prototype,t),r&&se(e,r),e}function pe(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function ce(){return (ce=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e}).apply(this,arguments)}function le(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n);}return r}function de(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?le(Object(r),!0).forEach((function(t){pe(e,t,r[t]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):le(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));}));}return e}function ue(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&me(e,t);}function he(e){return (he=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function me(e,t){return (me=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function fe(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function ye(e,t){return !t||"object"!=typeof t&&"function"!=typeof t?fe(e):t}function ve(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}();return function(){var r,n=he(e);if(t){var o=he(this).constructor;r=Reflect.construct(n,arguments,o);}else r=n.apply(this,arguments);return ye(this,r)}}function De(e){return function(e){if(Array.isArray(e))return we(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return we(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return we(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function we(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function ke(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});case"PPPP":default:return t.date({width:"full"})}}function ge(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});case"pppp":default:return t.time({width:"full"})}}var be={p:ge,P:function(e,t){var r,n=e.match(/(P+)(p+)?/),o=n[1],a=n[2];if(!a)return ke(e,t);switch(o){case"P":r=t.dateTime({width:"short"});break;case"PP":r=t.dateTime({width:"medium"});break;case"PPP":r=t.dateTime({width:"long"});break;case"PPPP":default:r=t.dateTime({width:"full"});}return r.replace("{{date}}",ke(o,t)).replace("{{time}}",ge(a,t))}},Ce=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function _e(e){var t=e?"string"==typeof e||e instanceof String?parseISO(e):toDate(e):new Date;return Me(t)?t:null}function Se(e,t,r,n){var a=null,s=Ve(r)||Ve(Qe()),i=!0;return Array.isArray(t)?(t.forEach((function(t){var r=parse$1(e,t,new Date,{locale:s});n&&(i=Me(r)&&e===format$1(r,t,{awareOfUnicodeTokens:!0})),Me(r)&&i&&(a=r);})),a):(a=parse$1(e,t,new Date,{locale:s}),n?i=Me(a)&&e===format$1(a,t,{awareOfUnicodeTokens:!0}):Me(a)||(t=t.match(Ce).map((function(e){var t=e[0];return "p"===t||"P"===t?s?(0, be[t])(e,s.formatLong):t:e})).join(""),e.length>0&&(a=parse$1(e,t.slice(0,e.length),new Date)),Me(a)||(a=new Date(e))),Me(a)&&i?a:null)}function Me(e){return isValid(e)&&isAfter(e,new Date("1/1/1000"))}function Pe(e,t,r){if("en"===r)return format$1(e,t,{awareOfUnicodeTokens:!0});var n=Ve(r);return r&&!n&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!n&&Qe()&&Ve(Qe())&&(n=Ve(Qe())),format$1(e,t,{locale:n||null,awareOfUnicodeTokens:!0})}function Ee(e,t){var r=t.hour,n=void 0===r?0:r,o=t.minute,a=void 0===o?0:o,s=t.second;return setHours(setMinutes(setSeconds(e,void 0===s?0:s),a),n)}function Ne(e,t){var r=t&&Ve(t)||Qe()&&Ve(Qe());return getISOWeek(e,r?{locale:r}:null)}function Oe(e,t){return Pe(e,"ddd",t)}function xe(e){return startOfDay(e)}function Te(e,t){var r=Ve(t||Qe());return startOfWeek(e,{locale:r})}function Ye(e){return startOfMonth(e)}function Ie(e){return startOfYear(e)}function Le(e){return startOfQuarter(e)}function Fe(e,t){return e&&t?isSameYear(e,t):!e&&!t}function Re(e,t){return e&&t?isSameMonth(e,t):!e&&!t}function Ae(e,t){return e&&t?isSameQuarter(e,t):!e&&!t}function We(e,t){return e&&t?isSameDay(e,t):!e&&!t}function Be(e,t){return e&&t?isEqual(e,t):!e&&!t}function je(e,t,r){var n,o=startOfDay(t),a=endOfDay(r);try{n=isWithinInterval(e,{start:o,end:a});}catch(e){n=!1;}return n}function Ke(e,t){var r="undefined"!=typeof window?window:global;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t;}function Qe(){return ("undefined"!=typeof window?window:global).__localeId__}function Ve(e){if("string"==typeof e){var t="undefined"!=typeof window?window:global;return t.__localeData__?t.__localeData__[e]:null}return e}function qe(e,t){return Pe(setMonth(_e(),e),"LLLL",t)}function Ue(e,t){return Pe(setMonth(_e(),e),"LLL",t)}function $e(e,t){return Pe(setQuarter(_e(),e),"QQQ",t)}function ze(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.includeDates,s=t.filterDate;return rt(e,{minDate:r,maxDate:n})||o&&o.some((function(t){return We(e,t)}))||a&&!a.some((function(t){return We(e,t)}))||s&&!s(_e(e))||!1}function Ge(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeDates;return r&&r.some((function(t){return We(e,t)}))||!1}function Je(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.includeDates,s=t.filterDate;return rt(e,{minDate:r,maxDate:n})||o&&o.some((function(t){return Re(e,t)}))||a&&!a.some((function(t){return Re(e,t)}))||s&&!s(_e(e))||!1}function Xe(e,t,r,n){var o=getYear(e),a=getMonth(e),s=getYear(t),i=getMonth(t),p=getYear(n);return o===s&&o===p?a<=r&&r<=i:o<s?p===o&&a<=r||p===s&&i>=r||p<s&&p>o:void 0}function Ze(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.includeDates,s=t.filterDate;return rt(e,{minDate:r,maxDate:n})||o&&o.some((function(t){return Ae(e,t)}))||a&&!a.some((function(t){return Ae(e,t)}))||s&&!s(_e(e))||!1}function et(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=new Date(e,0,1);return rt(o,{minDate:r,maxDate:n})||!1}function tt(e,t,r,n){var o=getYear(e),a=getQuarter(e),s=getYear(t),i=getQuarter(t),p=getYear(n);return o===s&&o===p?a<=r&&r<=i:o<s?p===o&&a<=r||p===s&&i>=r||p<s&&p>o:void 0}function rt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate;return r&&differenceInCalendarDays(e,r)<0||n&&differenceInCalendarDays(e,n)>0}function nt(e,t){return t.some((function(t){return getHours(t)===getHours(e)&&getMinutes(t)===getMinutes(e)}))}function ot(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeTimes,n=t.includeTimes,o=t.filterTime;return r&&nt(e,r)||n&&!nt(e,n)||o&&!o(e)||!1}function at(e,t){var r=t.minTime,n=t.maxTime;if(!r||!n)throw new Error("Both minTime and maxTime props required");var o,a=_e(),s=setHours(setMinutes(a,getMinutes(e)),getHours(e)),i=setHours(setMinutes(a,getMinutes(r)),getHours(r)),p=setHours(setMinutes(a,getMinutes(n)),getHours(n));try{o=!isWithinInterval(s,{start:i,end:p});}catch(e){o=!1;}return o}function st(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,o=subMonths(e,1);return r&&differenceInCalendarMonths(r,o)>0||n&&n.every((function(e){return differenceInCalendarMonths(e,o)>0}))||!1}function it(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,o=addMonths(e,1);return r&&differenceInCalendarMonths(o,r)>0||n&&n.every((function(e){return differenceInCalendarMonths(o,e)>0}))||!1}function pt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,o=subYears(e,1);return r&&differenceInCalendarYears(r,o)>0||n&&n.every((function(e){return differenceInCalendarYears(e,o)>0}))||!1}function ct(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,o=addYears(e,1);return r&&differenceInCalendarYears(o,r)>0||n&&n.every((function(e){return differenceInCalendarYears(o,e)>0}))||!1}function lt(e){var t=e.minDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return differenceInCalendarDays(e,t)>=0}));return min$1(n)}return r?min$1(r):t}function dt(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return differenceInCalendarDays(e,t)<=0}));return max$1(n)}return r?max$1(r):t}function ut(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",n=new Map,o=0,a=e.length;o<a;o++){var s=e[o];if(isDate(s)){var i=Pe(s,"MM.dd.yyyy"),p=n.get(i)||[];p.includes(t)||(p.push(t),n.set(i,p));}else if("object"===oe(s)){var c=Object.keys(s),l=c[0],d=s[c[0]];if("string"==typeof l&&d.constructor===Array)for(var u=0,h=d.length;u<h;u++){var m=Pe(d[u],"MM.dd.yyyy"),f=n.get(m)||[];f.includes(l)||(f.push(l),n.set(m,f));}}}return n}function ht(e,t,r,n,o){for(var i=o.length,p=[],c=0;c<i;c++){var l=addMinutes(addHours(e,getHours(o[c])),getMinutes(o[c])),d=addMinutes(e,(r+1)*n);isAfter(l,t)&&isBefore(l,d)&&p.push(o[c]);}return p}function mt(e){return e<10?"0".concat(e):"".concat(e)}function ft(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:12,r=Math.ceil(getYear(e)/t)*t,n=r-(t-1);return {startPeriod:n,endPeriod:r}}function yt(e,t,r,n){for(var o=[],a=0;a<2*t+1;a++){var s=e+t-a,i=!0;r&&(i=getYear(r)<=s),n&&i&&(i=getYear(n)>=s),i&&o.push(s);}return o}var vt=onClickOutsideHOC(function(r){ue(o,React__default.Component);var n=ve(o);function o(t){var r;ae(this,o),pe(fe(r=n.call(this,t)),"renderOptions",(function(){var t=r.props.year,n=r.state.yearsList.map((function(n){return React__default.createElement("div",{className:t===n?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:n,onClick:r.onChange.bind(fe(r),n)},t===n?React__default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",n)})),o=r.props.minDate?getYear(r.props.minDate):null,a=r.props.maxDate?getYear(r.props.maxDate):null;return a&&r.state.yearsList.find((function(e){return e===a}))||n.unshift(React__default.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:r.incrementYears},React__default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),o&&r.state.yearsList.find((function(e){return e===o}))||n.push(React__default.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:r.decrementYears},React__default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),n})),pe(fe(r),"onChange",(function(e){r.props.onChange(e);})),pe(fe(r),"handleClickOutside",(function(){r.props.onCancel();})),pe(fe(r),"shiftYears",(function(e){var t=r.state.yearsList.map((function(t){return t+e}));r.setState({yearsList:t});})),pe(fe(r),"incrementYears",(function(){return r.shiftYears(1)})),pe(fe(r),"decrementYears",(function(){return r.shiftYears(-1)}));var a=t.yearDropdownItemNumber,s=t.scrollableYearDropdown,i=a||(s?10:5);return r.state={yearsList:yt(r.props.year,i,r.props.minDate,r.props.maxDate)},r}return ie(o,[{key:"render",value:function(){var r=classnames({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return React__default.createElement("div",{className:r},this.renderOptions())}}]),o}()),Dt=function(t){ue(n,React__default.Component);var r=ve(n);function n(){var t;ae(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return pe(fe(t=r.call.apply(r,[this].concat(a))),"state",{dropdownVisible:!1}),pe(fe(t),"renderSelectOptions",(function(){for(var r=t.props.minDate?getYear(t.props.minDate):1900,n=t.props.maxDate?getYear(t.props.maxDate):2100,o=[],a=r;a<=n;a++)o.push(React__default.createElement("option",{key:a,value:a},a));return o})),pe(fe(t),"onSelectChange",(function(e){t.onChange(e.target.value);})),pe(fe(t),"renderSelectMode",(function(){return React__default.createElement("select",{value:t.props.year,className:"react-datepicker__year-select",onChange:t.onSelectChange},t.renderSelectOptions())})),pe(fe(t),"renderReadView",(function(r){return React__default.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(e){return t.toggleDropdown(e)}},React__default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),React__default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},t.props.year))})),pe(fe(t),"renderDropdown",(function(){return React__default.createElement(vt,{key:"dropdown",year:t.props.year,onChange:t.onChange,onCancel:t.toggleDropdown,minDate:t.props.minDate,maxDate:t.props.maxDate,scrollableYearDropdown:t.props.scrollableYearDropdown,yearDropdownItemNumber:t.props.yearDropdownItemNumber})})),pe(fe(t),"renderScrollMode",(function(){var e=t.state.dropdownVisible,r=[t.renderReadView(!e)];return e&&r.unshift(t.renderDropdown()),r})),pe(fe(t),"onChange",(function(e){t.toggleDropdown(),e!==t.props.year&&t.props.onChange(e);})),pe(fe(t),"toggleDropdown",(function(e){t.setState({dropdownVisible:!t.state.dropdownVisible},(function(){t.props.adjustDateOnChange&&t.handleYearChange(t.props.date,e);}));})),pe(fe(t),"handleYearChange",(function(e,r){t.onSelect(e,r),t.setOpen();})),pe(fe(t),"onSelect",(function(e,r){t.props.onSelect&&t.props.onSelect(e,r);})),pe(fe(t),"setOpen",(function(){t.props.setOpen&&t.props.setOpen(!0);})),t}return ie(n,[{key:"render",value:function(){var t;switch(this.props.dropdownMode){case"scroll":t=this.renderScrollMode();break;case"select":t=this.renderSelectMode();}return React__default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},t)}}]),n}(),wt=onClickOutsideHOC(function(t){ue(n,React__default.Component);var r=ve(n);function n(){var t;ae(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return pe(fe(t=r.call.apply(r,[this].concat(a))),"renderOptions",(function(){return t.props.monthNames.map((function(r,n){return React__default.createElement("div",{className:t.props.month===n?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:r,onClick:t.onChange.bind(fe(t),n)},t.props.month===n?React__default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",r)}))})),pe(fe(t),"onChange",(function(e){return t.props.onChange(e)})),pe(fe(t),"handleClickOutside",(function(){return t.props.onCancel()})),t}return ie(n,[{key:"render",value:function(){return React__default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),n}()),kt=function(t){ue(n,React__default.Component);var r=ve(n);function n(){var t;ae(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return pe(fe(t=r.call.apply(r,[this].concat(a))),"state",{dropdownVisible:!1}),pe(fe(t),"renderSelectOptions",(function(t){return t.map((function(t,r){return React__default.createElement("option",{key:r,value:r},t)}))})),pe(fe(t),"renderSelectMode",(function(r){return React__default.createElement("select",{value:t.props.month,className:"react-datepicker__month-select",onChange:function(e){return t.onChange(e.target.value)}},t.renderSelectOptions(r))})),pe(fe(t),"renderReadView",(function(r,n){return React__default.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:t.toggleDropdown},React__default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),React__default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},n[t.props.month]))})),pe(fe(t),"renderDropdown",(function(r){return React__default.createElement(wt,{key:"dropdown",month:t.props.month,monthNames:r,onChange:t.onChange,onCancel:t.toggleDropdown})})),pe(fe(t),"renderScrollMode",(function(e){var r=t.state.dropdownVisible,n=[t.renderReadView(!r,e)];return r&&n.unshift(t.renderDropdown(e)),n})),pe(fe(t),"onChange",(function(e){t.toggleDropdown(),e!==t.props.month&&t.props.onChange(e);})),pe(fe(t),"toggleDropdown",(function(){return t.setState({dropdownVisible:!t.state.dropdownVisible})})),t}return ie(n,[{key:"render",value:function(){var t,r=this,n=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return Ue(e,r.props.locale)}:function(e){return qe(e,r.props.locale)});switch(this.props.dropdownMode){case"scroll":t=this.renderScrollMode(n);break;case"select":t=this.renderSelectMode(n);}return React__default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},t)}}]),n}();function gt(e,t){for(var r=[],n=Ye(e),o=Ye(t);!isAfter(n,o);)r.push(_e(n)),n=addMonths(n,1);return r}var bt=onClickOutsideHOC(function(r){ue(o,React__default.Component);var n=ve(o);function o(t){var r;return ae(this,o),pe(fe(r=n.call(this,t)),"renderOptions",(function(){return r.state.monthYearsList.map((function(t){var n=getTime(t),o=Fe(r.props.date,t)&&Re(r.props.date,t);return React__default.createElement("div",{className:o?"react-datepicker__month-year-option --selected_month-year":"react-datepicker__month-year-option",key:n,onClick:r.onChange.bind(fe(r),n)},o?React__default.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Pe(t,r.props.dateFormat,r.props.locale))}))})),pe(fe(r),"onChange",(function(e){return r.props.onChange(e)})),pe(fe(r),"handleClickOutside",(function(){r.props.onCancel();})),r.state={monthYearsList:gt(r.props.minDate,r.props.maxDate)},r}return ie(o,[{key:"render",value:function(){var r=classnames({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return React__default.createElement("div",{className:r},this.renderOptions())}}]),o}()),Ct=function(t){ue(n,React__default.Component);var r=ve(n);function n(){var t;ae(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return pe(fe(t=r.call.apply(r,[this].concat(a))),"state",{dropdownVisible:!1}),pe(fe(t),"renderSelectOptions",(function(){for(var r=Ye(t.props.minDate),n=Ye(t.props.maxDate),o=[];!isAfter(r,n);){var a=getTime(r);o.push(React__default.createElement("option",{key:a,value:a},Pe(r,t.props.dateFormat,t.props.locale))),r=addMonths(r,1);}return o})),pe(fe(t),"onSelectChange",(function(e){t.onChange(e.target.value);})),pe(fe(t),"renderSelectMode",(function(){return React__default.createElement("select",{value:getTime(Ye(t.props.date)),className:"react-datepicker__month-year-select",onChange:t.onSelectChange},t.renderSelectOptions())})),pe(fe(t),"renderReadView",(function(r){var n=Pe(t.props.date,t.props.dateFormat,t.props.locale);return React__default.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(e){return t.toggleDropdown(e)}},React__default.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),React__default.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},n))})),pe(fe(t),"renderDropdown",(function(){return React__default.createElement(bt,{key:"dropdown",date:t.props.date,dateFormat:t.props.dateFormat,onChange:t.onChange,onCancel:t.toggleDropdown,minDate:t.props.minDate,maxDate:t.props.maxDate,scrollableMonthYearDropdown:t.props.scrollableMonthYearDropdown,locale:t.props.locale})})),pe(fe(t),"renderScrollMode",(function(){var e=t.state.dropdownVisible,r=[t.renderReadView(!e)];return e&&r.unshift(t.renderDropdown()),r})),pe(fe(t),"onChange",(function(e){t.toggleDropdown();var r=_e(parseInt(e));Fe(t.props.date,r)&&Re(t.props.date,r)||t.props.onChange(r);})),pe(fe(t),"toggleDropdown",(function(){return t.setState({dropdownVisible:!t.state.dropdownVisible})})),t}return ie(n,[{key:"render",value:function(){var t;switch(this.props.dropdownMode){case"scroll":t=this.renderScrollMode();break;case"select":t=this.renderSelectMode();}return React__default.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},t)}}]),n}(),_t=function(r){ue(o,React__default.Component);var n=ve(o);function o(){var r;ae(this,o);for(var a=arguments.length,s=new Array(a),i=0;i<a;i++)s[i]=arguments[i];return pe(fe(r=n.call.apply(n,[this].concat(s))),"dayEl",React__default.createRef()),pe(fe(r),"handleClick",(function(e){!r.isDisabled()&&r.props.onClick&&r.props.onClick(e);})),pe(fe(r),"handleMouseEnter",(function(e){!r.isDisabled()&&r.props.onMouseEnter&&r.props.onMouseEnter(e);})),pe(fe(r),"handleOnKeyDown",(function(e){" "===e.key&&(e.preventDefault(),e.key="Enter"),r.props.handleOnKeyDown(e);})),pe(fe(r),"isSameDay",(function(e){return We(r.props.day,e)})),pe(fe(r),"isKeyboardSelected",(function(){return !r.props.disabledKeyboardNavigation&&!r.isSameDay(r.props.selected)&&r.isSameDay(r.props.preSelection)})),pe(fe(r),"isDisabled",(function(){return ze(r.props.day,r.props)})),pe(fe(r),"isExcluded",(function(){return Ge(r.props.day,r.props)})),pe(fe(r),"getHighLightedClass",(function(e){var t=r.props,n=t.day,o=t.highlightDates;if(!o)return !1;var a=Pe(n,"MM.dd.yyyy");return o.get(a)})),pe(fe(r),"isInRange",(function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return !(!n||!o)&&je(t,n,o)})),pe(fe(r),"isInSelectingRange",(function(){var e=r.props,t=e.day,n=e.selectsStart,o=e.selectsEnd,a=e.selectsRange,s=e.selectingDate,i=e.startDate,p=e.endDate;return !(!(n||o||a)||!s||r.isDisabled())&&(n&&p&&(isBefore(s,p)||Be(s,p))?je(t,s,p):(o&&i&&(isAfter(s,i)||Be(s,i))||!(!a||!i||p||!isAfter(s,i)&&!Be(s,i)))&&je(t,i,s))})),pe(fe(r),"isSelectingRangeStart",(function(){if(!r.isInSelectingRange())return !1;var e=r.props,t=e.day,n=e.selectingDate,o=e.startDate;return We(t,e.selectsStart?n:o)})),pe(fe(r),"isSelectingRangeEnd",(function(){if(!r.isInSelectingRange())return !1;var e=r.props,t=e.day,n=e.selectingDate,o=e.endDate;return We(t,e.selectsEnd?n:o)})),pe(fe(r),"isRangeStart",(function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return !(!n||!o)&&We(n,t)})),pe(fe(r),"isRangeEnd",(function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return !(!n||!o)&&We(o,t)})),pe(fe(r),"isWeekend",(function(){var e=getDay(r.props.day);return 0===e||6===e})),pe(fe(r),"isOutsideMonth",(function(){return void 0!==r.props.month&&r.props.month!==getMonth(r.props.day)})),pe(fe(r),"getClassNames",(function(e){var n=r.props.dayClassName?r.props.dayClassName(e):void 0;return classnames("react-datepicker__day",n,"react-datepicker__day--"+Oe(r.props.day),{"react-datepicker__day--disabled":r.isDisabled(),"react-datepicker__day--excluded":r.isExcluded(),"react-datepicker__day--selected":r.isSameDay(r.props.selected),"react-datepicker__day--keyboard-selected":r.isKeyboardSelected(),"react-datepicker__day--range-start":r.isRangeStart(),"react-datepicker__day--range-end":r.isRangeEnd(),"react-datepicker__day--in-range":r.isInRange(),"react-datepicker__day--in-selecting-range":r.isInSelectingRange(),"react-datepicker__day--selecting-range-start":r.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":r.isSelectingRangeEnd(),"react-datepicker__day--today":r.isSameDay(_e()),"react-datepicker__day--weekend":r.isWeekend(),"react-datepicker__day--outside-month":r.isOutsideMonth()},r.getHighLightedClass("react-datepicker__day--highlighted"))})),pe(fe(r),"getAriaLabel",(function(){var e=r.props,t=e.day,n=e.ariaLabelPrefixWhenEnabled,o=void 0===n?"Choose":n,a=e.ariaLabelPrefixWhenDisabled,s=void 0===a?"Not available":a,i=r.isDisabled()||r.isExcluded()?s:o;return "".concat(i," ").concat(Pe(t,"PPPP"))})),pe(fe(r),"getTabIndex",(function(e,t){var n=e||r.props.selected,o=t||r.props.preSelection;return r.isKeyboardSelected()||r.isSameDay(n)&&We(o,n)?0:-1})),pe(fe(r),"handleFocusDay",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=!1;0===r.getTabIndex()&&!e.isInputFocused&&r.isSameDay(r.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(t=!0),r.props.inline&&!r.props.shouldFocusDayInline&&(t=!1),r.props.containerRef&&r.props.containerRef.current&&r.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(t=!0)),t&&r.dayEl.current.focus({preventScroll:!0});})),pe(fe(r),"renderDayContents",(function(){if(r.isOutsideMonth()){if(r.props.monthShowsDuplicateDaysEnd&&getDate(r.props.day)<10)return null;if(r.props.monthShowsDuplicateDaysStart&&getDate(r.props.day)>20)return null}return r.props.renderDayContents?r.props.renderDayContents(getDate(r.props.day),r.props.day):getDate(r.props.day)})),pe(fe(r),"render",(function(){return React__default.createElement("div",{ref:r.dayEl,className:r.getClassNames(r.props.day),onKeyDown:r.handleOnKeyDown,onClick:r.handleClick,onMouseEnter:r.handleMouseEnter,tabIndex:r.getTabIndex(),"aria-label":r.getAriaLabel(),role:"button","aria-disabled":r.isDisabled()},r.renderDayContents())})),r}return ie(o,[{key:"componentDidMount",value:function(){this.handleFocusDay();}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e);}}]),o}(),St=function(r){ue(o,React__default.Component);var n=ve(o);function o(){var e;ae(this,o);for(var t=arguments.length,r=new Array(t),a=0;a<t;a++)r[a]=arguments[a];return pe(fe(e=n.call.apply(n,[this].concat(r))),"handleClick",(function(t){e.props.onClick&&e.props.onClick(t);})),e}return ie(o,[{key:"render",value:function(){var r=this.props,n=r.weekNumber,o=r.ariaLabelPrefix,a=void 0===o?"week ":o,s={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!r.onClick};return React__default.createElement("div",{className:classnames(s),"aria-label":"".concat(a," ").concat(this.props.weekNumber),onClick:this.handleClick},n)}}]),o}(),Mt=function(t){ue(n,React__default.Component);var r=ve(n);function n(){var t;ae(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return pe(fe(t=r.call.apply(r,[this].concat(a))),"handleDayClick",(function(e,r){t.props.onDayClick&&t.props.onDayClick(e,r);})),pe(fe(t),"handleDayMouseEnter",(function(e){t.props.onDayMouseEnter&&t.props.onDayMouseEnter(e);})),pe(fe(t),"handleWeekClick",(function(e,r,n){"function"==typeof t.props.onWeekSelect&&t.props.onWeekSelect(e,r,n),t.props.shouldCloseOnSelect&&t.props.setOpen(!1);})),pe(fe(t),"formatWeekNumber",(function(e){return t.props.formatWeekNumber?t.props.formatWeekNumber(e):Ne(e)})),pe(fe(t),"renderDays",(function(){var r=Te(t.props.day,t.props.locale),n=[],o=t.formatWeekNumber(r);if(t.props.showWeekNumber){var a=t.props.onWeekSelect?t.handleWeekClick.bind(fe(t),r,o):void 0;n.push(React__default.createElement(St,{key:"W",weekNumber:o,onClick:a,ariaLabelPrefix:t.props.ariaLabelPrefix}));}return n.concat([0,1,2,3,4,5,6].map((function(n){var o=addDays(r,n);return React__default.createElement(_t,{ariaLabelPrefixWhenEnabled:t.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:t.props.disabledDayAriaLabelPrefix,key:o.valueOf(),day:o,month:t.props.month,onClick:t.handleDayClick.bind(fe(t),o),onMouseEnter:t.handleDayMouseEnter.bind(fe(t),o),minDate:t.props.minDate,maxDate:t.props.maxDate,excludeDates:t.props.excludeDates,includeDates:t.props.includeDates,highlightDates:t.props.highlightDates,selectingDate:t.props.selectingDate,filterDate:t.props.filterDate,preSelection:t.props.preSelection,selected:t.props.selected,selectsStart:t.props.selectsStart,selectsEnd:t.props.selectsEnd,selectsRange:t.props.selectsRange,startDate:t.props.startDate,endDate:t.props.endDate,dayClassName:t.props.dayClassName,renderDayContents:t.props.renderDayContents,disabledKeyboardNavigation:t.props.disabledKeyboardNavigation,handleOnKeyDown:t.props.handleOnKeyDown,isInputFocused:t.props.isInputFocused,containerRef:t.props.containerRef,inline:t.props.inline,shouldFocusDayInline:t.props.shouldFocusDayInline,monthShowsDuplicateDaysEnd:t.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:t.props.monthShowsDuplicateDaysStart})})))})),t}return ie(n,[{key:"render",value:function(){return React__default.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}],[{key:"defaultProps",get:function(){return {shouldCloseOnSelect:!0}}}]),n}(),Pt=function(r){ue(o,React__default.Component);var n=ve(o);function o(){var r;ae(this,o);for(var a=arguments.length,s=new Array(a),l=0;l<a;l++)s[l]=arguments[l];return pe(fe(r=n.call.apply(n,[this].concat(s))),"MONTH_REFS",De(Array(12)).map((function(){return React__default.createRef()}))),pe(fe(r),"isDisabled",(function(e){return ze(e,r.props)})),pe(fe(r),"isExcluded",(function(e){return Ge(e,r.props)})),pe(fe(r),"handleDayClick",(function(e,t){r.props.onDayClick&&r.props.onDayClick(e,t,r.props.orderInDisplay);})),pe(fe(r),"handleDayMouseEnter",(function(e){r.props.onDayMouseEnter&&r.props.onDayMouseEnter(e);})),pe(fe(r),"handleMouseLeave",(function(){r.props.onMouseLeave&&r.props.onMouseLeave();})),pe(fe(r),"isRangeStartMonth",(function(e){var t=r.props,n=t.day,o=t.startDate,a=t.endDate;return !(!o||!a)&&Re(setMonth(n,e),o)})),pe(fe(r),"isRangeStartQuarter",(function(e){var t=r.props,n=t.day,o=t.startDate,a=t.endDate;return !(!o||!a)&&Ae(setQuarter(n,e),o)})),pe(fe(r),"isRangeEndMonth",(function(e){var t=r.props,n=t.day,o=t.startDate,a=t.endDate;return !(!o||!a)&&Re(setMonth(n,e),a)})),pe(fe(r),"isRangeEndQuarter",(function(e){var t=r.props,n=t.day,o=t.startDate,a=t.endDate;return !(!o||!a)&&Ae(setQuarter(n,e),a)})),pe(fe(r),"isWeekInMonth",(function(e){var t=r.props.day,n=addDays(e,6);return Re(e,t)||Re(n,t)})),pe(fe(r),"renderWeeks",(function(){for(var t=[],n=r.props.fixedHeight,o=Te(Ye(r.props.day),r.props.locale),a=0,s=!1;t.push(React__default.createElement(Mt,{ariaLabelPrefix:r.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:r.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:r.props.disabledDayAriaLabelPrefix,key:a,day:o,month:getMonth(r.props.day),onDayClick:r.handleDayClick,onDayMouseEnter:r.handleDayMouseEnter,onWeekSelect:r.props.onWeekSelect,formatWeekNumber:r.props.formatWeekNumber,locale:r.props.locale,minDate:r.props.minDate,maxDate:r.props.maxDate,excludeDates:r.props.excludeDates,includeDates:r.props.includeDates,inline:r.props.inline,shouldFocusDayInline:r.props.shouldFocusDayInline,highlightDates:r.props.highlightDates,selectingDate:r.props.selectingDate,filterDate:r.props.filterDate,preSelection:r.props.preSelection,selected:r.props.selected,selectsStart:r.props.selectsStart,selectsEnd:r.props.selectsEnd,selectsRange:r.props.selectsRange,showWeekNumber:r.props.showWeekNumbers,startDate:r.props.startDate,endDate:r.props.endDate,dayClassName:r.props.dayClassName,setOpen:r.props.setOpen,shouldCloseOnSelect:r.props.shouldCloseOnSelect,disabledKeyboardNavigation:r.props.disabledKeyboardNavigation,renderDayContents:r.props.renderDayContents,handleOnKeyDown:r.props.handleOnKeyDown,isInputFocused:r.props.isInputFocused,containerRef:r.props.containerRef,monthShowsDuplicateDaysEnd:r.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:r.props.monthShowsDuplicateDaysStart})),!s;){a++,o=addWeeks(o,1);var i=n&&a>=6,c=!n&&!r.isWeekInMonth(o);if(i||c){if(!r.props.peekNextMonth)break;s=!0;}}return t})),pe(fe(r),"onMonthClick",(function(e,t){r.handleDayClick(Ye(setMonth(r.props.day,t)),e);})),pe(fe(r),"handleMonthNavigation",(function(e,t){r.isDisabled(t)||r.isExcluded(t)||(r.props.setPreSelection(t),r.MONTH_REFS[e].current&&r.MONTH_REFS[e].current.focus());})),pe(fe(r),"onMonthKeyDown",(function(e,t){var n=e.key;if(!r.props.disabledKeyboardNavigation)switch(n){case"Enter":r.onMonthClick(e,t),r.props.setPreSelection(r.props.selected);break;case"ArrowRight":r.handleMonthNavigation(11===t?0:t+1,addMonths(r.props.preSelection,1));break;case"ArrowLeft":r.handleMonthNavigation(0===t?11:t-1,subMonths(r.props.preSelection,1));}})),pe(fe(r),"onQuarterClick",(function(e,t){r.handleDayClick(Le(setQuarter(r.props.day,t)),e);})),pe(fe(r),"getMonthClassNames",(function(e){var n=r.props,o=n.day,a=n.startDate,s=n.endDate,i=n.selected,p=n.minDate,c=n.maxDate,l=n.preSelection,d=n.monthClassName,u=d?d(o):void 0;return classnames("react-datepicker__month-text","react-datepicker__month-".concat(e),u,{"react-datepicker__month--disabled":(p||c)&&Je(setMonth(o,e),r.props),"react-datepicker__month--selected":getMonth(o)===e&&getYear(o)===getYear(i),"react-datepicker__month-text--keyboard-selected":getMonth(l)===e,"react-datepicker__month--in-range":Xe(a,s,e,o),"react-datepicker__month--range-start":r.isRangeStartMonth(e),"react-datepicker__month--range-end":r.isRangeEndMonth(e)})})),pe(fe(r),"getTabIndex",(function(e){var t=getMonth(r.props.preSelection);return r.props.disabledKeyboardNavigation||e!==t?"-1":"0"})),pe(fe(r),"getAriaLabel",(function(e){var t=r.props,n=t.ariaLabelPrefix,o=void 0===n?"Choose":n,a=t.disabledDayAriaLabelPrefix,s=void 0===a?"Not available":a,i=t.day,p=setMonth(i,e),c=r.isDisabled(p)||r.isExcluded(p)?s:o;return "".concat(c," ").concat(Pe(p,"MMMM yyyy"))})),pe(fe(r),"getQuarterClassNames",(function(e){var n=r.props,o=n.day,a=n.startDate,s=n.endDate,i=n.selected,p=n.minDate,c=n.maxDate;return classnames("react-datepicker__quarter-text","react-datepicker__quarter-".concat(e),{"react-datepicker__quarter--disabled":(p||c)&&Ze(setQuarter(o,e),r.props),"react-datepicker__quarter--selected":getQuarter(o)===e&&getYear(o)===getYear(i),"react-datepicker__quarter--in-range":tt(a,s,e,o),"react-datepicker__quarter--range-start":r.isRangeStartQuarter(e),"react-datepicker__quarter--range-end":r.isRangeEndQuarter(e)})})),pe(fe(r),"renderMonths",(function(){var t=r.props,n=t.showFullMonthYearPicker,o=t.showTwoColumnMonthYearPicker,a=t.showFourColumnMonthYearPicker,s=t.locale;return (a?[[0,1,2,3],[4,5,6,7],[8,9,10,11]]:o?[[0,1],[2,3],[4,5],[6,7],[8,9],[10,11]]:[[0,1,2],[3,4,5],[6,7,8],[9,10,11]]).map((function(t,o){return React__default.createElement("div",{className:"react-datepicker__month-wrapper",key:o},t.map((function(t,o){return React__default.createElement("div",{ref:r.MONTH_REFS[t],key:o,onClick:function(e){r.onMonthClick(e,t);},onKeyDown:function(e){r.onMonthKeyDown(e,t);},tabIndex:r.getTabIndex(t),className:r.getMonthClassNames(t),role:"button","aria-label":r.getAriaLabel(t)},n?qe(t,s):Ue(t,s))})))}))})),pe(fe(r),"renderQuarters",(function(){return React__default.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(t,n){return React__default.createElement("div",{key:n,onClick:function(e){r.onQuarterClick(e,t);},className:r.getQuarterClassNames(t)},$e(t,r.props.locale))})))})),pe(fe(r),"getClassNames",(function(){var e=r.props;e.day;var n=e.selectingDate,o=e.selectsStart,a=e.selectsEnd,s=e.showMonthYearPicker,i=e.showQuarterYearPicker;return classnames("react-datepicker__month",{"react-datepicker__month--selecting-range":n&&(o||a)},{"react-datepicker__monthPicker":s},{"react-datepicker__quarterPicker":i})})),r}return ie(o,[{key:"render",value:function(){var t=this.props,r=t.showMonthYearPicker,n=t.showQuarterYearPicker,o=t.day,a=t.ariaLabelPrefix,s=void 0===a?"month ":a;return React__default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,"aria-label":"".concat(s," ").concat(Pe(o,"yyyy-MM"))},r?this.renderMonths():n?this.renderQuarters():this.renderWeeks())}}]),o}(),Et=function(t){ue(n,React__default.Component);var r=ve(n);function n(){var t;ae(this,n);for(var o=arguments.length,s=new Array(o),i=0;i<o;i++)s[i]=arguments[i];return pe(fe(t=r.call.apply(r,[this].concat(s))),"state",{height:null}),pe(fe(t),"handleClick",(function(e){(t.props.minTime||t.props.maxTime)&&at(e,t.props)||(t.props.excludeTimes||t.props.includeTimes||t.props.filterTime)&&ot(e,t.props)||t.props.onChange(e);})),pe(fe(t),"liClasses",(function(e,r,n){var o=["react-datepicker__time-list-item",t.props.timeClassName?t.props.timeClassName(e,r,n):void 0];return t.props.selected&&r===getHours(e)&&n===getMinutes(e)&&o.push("react-datepicker__time-list-item--selected"),((t.props.minTime||t.props.maxTime)&&at(e,t.props)||(t.props.excludeTimes||t.props.includeTimes||t.props.filterTime)&&ot(e,t.props))&&o.push("react-datepicker__time-list-item--disabled"),t.props.injectTimes&&(60*getHours(e)+getMinutes(e))%t.props.intervals!=0&&o.push("react-datepicker__time-list-item--injected"),o.join(" ")})),pe(fe(t),"renderTimes",(function(){for(var r=[],n=t.props.format?t.props.format:"p",o=t.props.intervals,s=xe(_e(t.props.selected)),i=1440/o,p=t.props.injectTimes&&t.props.injectTimes.sort((function(e,t){return e-t})),c=t.props.selected||t.props.openToDate||_e(),l=getHours(c),d=getMinutes(c),u=setHours(setMinutes(s,d),l),h=0;h<i;h++){var m=addMinutes(s,h*o);if(r.push(m),p){var f=ht(s,m,h,o,p);r=r.concat(f);}}return r.map((function(r,o){return React__default.createElement("li",{key:o,onClick:t.handleClick.bind(fe(t),r),className:t.liClasses(r,l,d),ref:function(e){(isBefore(r,u)||Be(r,u))&&(t.centerLi=e);},tabIndex:"0"},Pe(r,n,t.props.locale))}))})),t}return ie(n,[{key:"componentDidMount",value:function(){this.list.scrollTop=n.calcCenterPosition(this.props.monthRef?this.props.monthRef.clientHeight-this.header.clientHeight:this.list.clientHeight,this.centerLi),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight});}},{key:"render",value:function(){var t=this,r=this.state.height;return React__default.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},React__default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly?"react-datepicker__header--time--only":""),ref:function(e){t.header=e;}},React__default.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),React__default.createElement("div",{className:"react-datepicker__time"},React__default.createElement("div",{className:"react-datepicker__time-box"},React__default.createElement("ul",{className:"react-datepicker__time-list",ref:function(e){t.list=e;},style:r?{height:r}:{},tabIndex:"0"},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return {intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),n}();pe(Et,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var Nt=function(r){ue(o,React__default.Component);var n=ve(o);function o(e){var r;return ae(this,o),pe(fe(r=n.call(this,e)),"handleYearClick",(function(e,t){r.props.onDayClick&&r.props.onDayClick(e,t);})),pe(fe(r),"isSameDay",(function(e,t){return We(e,t)})),pe(fe(r),"isKeyboardSelected",(function(e){var t=Ie(setYear(r.props.date,e));return !r.props.disabledKeyboardNavigation&&!r.props.inline&&!We(t,Ie(r.props.selected))&&We(t,Ie(r.props.preSelection))})),pe(fe(r),"onYearClick",(function(e,t){var n=r.props.date;r.handleYearClick(Ie(setYear(n,t)),e);})),pe(fe(r),"getYearClassNames",(function(e){var n=r.props,o=n.minDate,a=n.maxDate,s=n.selected;return classnames("react-datepicker__year-text",{"react-datepicker__year-text--selected":e===getYear(s),"react-datepicker__year-text--disabled":(o||a)&&et(e,r.props),"react-datepicker__year-text--keyboard-selected":r.isKeyboardSelected(e),"react-datepicker__year-text--today":e===getYear(_e())})})),r}return ie(o,[{key:"render",value:function(){for(var t=this,r=[],n=this.props,o=ft(n.date,n.yearItemNumber),a=o.startPeriod,s=o.endPeriod,i=function(n){r.push(React__default.createElement("div",{onClick:function(e){t.onYearClick(e,n);},className:t.getYearClassNames(n),key:n},n));},p=a;p<=s;p++)i(p);return React__default.createElement("div",{className:"react-datepicker__year"},React__default.createElement("div",{className:"react-datepicker__year-wrapper"},r))}}]),o}(),Ot=function(t){ue(n,React__default.Component);var r=ve(n);function n(t){var o;return ae(this,n),pe(fe(o=r.call(this,t)),"onTimeChange",(function(e){o.setState({time:e});var t=new Date;t.setHours(e.split(":")[0]),t.setMinutes(e.split(":")[1]),o.props.onChange(t);})),pe(fe(o),"renderTimeInput",(function(){var t=o.state.time,r=o.props,n=r.date,a=r.timeString,s=r.customTimeInput;return s?React__default.cloneElement(s,{date:n,value:t,onChange:o.onTimeChange}):React__default.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:t,onChange:function(e){o.onTimeChange(e.target.value||a);}})})),o.state={time:o.props.timeString},o}return ie(n,[{key:"render",value:function(){return React__default.createElement("div",{className:"react-datepicker__input-time-container"},React__default.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),React__default.createElement("div",{className:"react-datepicker-time__input-container"},React__default.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}],[{key:"getDerivedStateFromProps",value:function(e,t){return e.timeString!==t.time?{time:e.timeString}:null}}]),n}();function xt(t){var r=t.className,n=t.children,o=t.showPopperArrow,a=t.arrowProps,s=void 0===a?{}:a;return React__default.createElement("div",{className:r},o&&React__default.createElement("div",ce({className:"react-datepicker__triangle"},s)),n)}var Tt=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],Yt=function(r){ue(o,React__default.Component);var n=ve(o);function o(r){var a;return ae(this,o),pe(fe(a=n.call(this,r)),"handleClickOutside",(function(e){a.props.onClickOutside(e);})),pe(fe(a),"setClickOutsideRef",(function(){return a.containerRef.current})),pe(fe(a),"handleDropdownFocus",(function(e){(function(){var e=((arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).className||"").split(/\s+/);return Tt.some((function(t){return e.indexOf(t)>=0}))})(e.target)&&a.props.onDropdownFocus();})),pe(fe(a),"getDateInView",(function(){var e=a.props,t=e.preSelection,r=e.selected,n=e.openToDate,o=lt(a.props),s=dt(a.props),i=_e(),p=n||r||t;return p||(o&&isBefore(i,o)?o:s&&isAfter(i,s)?s:i)})),pe(fe(a),"increaseMonth",(function(){a.setState((function(e){var t=e.date;return {date:addMonths(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}));})),pe(fe(a),"decreaseMonth",(function(){a.setState((function(e){var t=e.date;return {date:subMonths(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}));})),pe(fe(a),"handleDayClick",(function(e,t,r){a.props.onSelect(e,t,r),a.props.setPreSelection&&a.props.setPreSelection(e);})),pe(fe(a),"handleDayMouseEnter",(function(e){a.setState({selectingDate:e}),a.props.onDayMouseEnter&&a.props.onDayMouseEnter(e);})),pe(fe(a),"handleMonthMouseLeave",(function(){a.setState({selectingDate:null}),a.props.onMonthMouseLeave&&a.props.onMonthMouseLeave();})),pe(fe(a),"handleYearChange",(function(e){a.props.onYearChange&&a.props.onYearChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e);})),pe(fe(a),"handleMonthChange",(function(e){a.props.onMonthChange&&a.props.onMonthChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e);})),pe(fe(a),"handleMonthYearChange",(function(e){a.handleYearChange(e),a.handleMonthChange(e);})),pe(fe(a),"changeYear",(function(e){a.setState((function(t){var r=t.date;return {date:setYear(r,e)}}),(function(){return a.handleYearChange(a.state.date)}));})),pe(fe(a),"changeMonth",(function(e){a.setState((function(t){var r=t.date;return {date:setMonth(r,e)}}),(function(){return a.handleMonthChange(a.state.date)}));})),pe(fe(a),"changeMonthYear",(function(e){a.setState((function(t){var r=t.date;return {date:setYear(setMonth(r,getMonth(e)),getYear(e))}}),(function(){return a.handleMonthYearChange(a.state.date)}));})),pe(fe(a),"header",(function(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,n=Te(r,a.props.locale),o=[];return a.props.showWeekNumbers&&o.push(React__default.createElement("div",{key:"W",className:"react-datepicker__day-name"},a.props.weekLabel||"#")),o.concat([0,1,2,3,4,5,6].map((function(r){var o=addDays(n,r),s=a.formatWeekday(o,a.props.locale),p=a.props.weekDayClassName?a.props.weekDayClassName(o):void 0;return React__default.createElement("div",{key:r,className:classnames("react-datepicker__day-name",p)},s)})))})),pe(fe(a),"formatWeekday",(function(e,t){return a.props.formatWeekDay?function(e,t,r){return t(Pe(e,"EEEE",r))}(e,a.props.formatWeekDay,t):a.props.useWeekdaysShort?function(e,t){return Pe(e,"EEE",t)}(e,t):function(e,t){return Pe(e,"EEEEEE",t)}(e,t)})),pe(fe(a),"decreaseYear",(function(){a.setState((function(e){var t=e.date;return {date:subYears(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}));})),pe(fe(a),"renderPreviousButton",(function(){if(!a.props.renderCustomHeader){var t;switch(!0){case a.props.showMonthYearPicker:t=pt(a.state.date,a.props);break;case a.props.showYearPicker:t=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.yearItemNumber,o=void 0===n?12:n,a=ft(Ie(subYears(e,o)),o).endPeriod,s=r&&getYear(r);return s&&s>a||!1}(a.state.date,a.props);break;default:t=st(a.state.date,a.props);}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!t)&&!a.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--previous"],n=a.decreaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(n=a.decreaseYear),t&&a.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--previous--disabled"),n=null);var o=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,s=a.props,i=s.previousMonthAriaLabel,p=void 0===i?"Previous Month":i,c=s.previousYearAriaLabel,l=void 0===c?"Previous Year":c;return React__default.createElement("button",{type:"button",className:r.join(" "),onClick:n,"aria-label":o?l:p},o?a.props.previousYearButtonLabel:a.props.previousMonthButtonLabel)}}})),pe(fe(a),"increaseYear",(function(){a.setState((function(e){var t=e.date;return {date:addYears(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}));})),pe(fe(a),"renderNextButton",(function(){if(!a.props.renderCustomHeader){var t;switch(!0){case a.props.showMonthYearPicker:t=ct(a.state.date,a.props);break;case a.props.showYearPicker:t=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.yearItemNumber,o=void 0===n?12:n,a=ft(addYears(e,o),o).startPeriod,s=r&&getYear(r);return s&&s<a||!1}(a.state.date,a.props);break;default:t=it(a.state.date,a.props);}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!t)&&!a.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--next"];a.props.showTimeSelect&&r.push("react-datepicker__navigation--next--with-time"),a.props.todayButton&&r.push("react-datepicker__navigation--next--with-today-button");var n=a.increaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(n=a.increaseYear),t&&a.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--next--disabled"),n=null);var o=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,s=a.props,i=s.nextMonthAriaLabel,p=void 0===i?"Next Month":i,c=s.nextYearAriaLabel,d=void 0===c?"Next Year":c;return React__default.createElement("button",{type:"button",className:r.join(" "),onClick:n,"aria-label":o?d:p},o?a.props.nextYearButtonLabel:a.props.nextMonthButtonLabel)}}})),pe(fe(a),"renderCurrentMonth",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,r=["react-datepicker__current-month"];return a.props.showYearDropdown&&r.push("react-datepicker__current-month--hasYearDropdown"),a.props.showMonthDropdown&&r.push("react-datepicker__current-month--hasMonthDropdown"),a.props.showMonthYearDropdown&&r.push("react-datepicker__current-month--hasMonthYearDropdown"),React__default.createElement("div",{className:r.join(" ")},Pe(t,a.props.dateFormat,a.props.locale))})),pe(fe(a),"renderYearDropdown",(function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showYearDropdown&&!t)return React__default.createElement(Dt,{adjustDateOnChange:a.props.adjustDateOnChange,date:a.state.date,onSelect:a.props.onSelect,setOpen:a.props.setOpen,dropdownMode:a.props.dropdownMode,onChange:a.changeYear,minDate:a.props.minDate,maxDate:a.props.maxDate,year:getYear(a.state.date),scrollableYearDropdown:a.props.scrollableYearDropdown,yearDropdownItemNumber:a.props.yearDropdownItemNumber})})),pe(fe(a),"renderMonthDropdown",(function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthDropdown&&!t)return React__default.createElement(kt,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,onChange:a.changeMonth,month:getMonth(a.state.date),useShortMonthInDropdown:a.props.useShortMonthInDropdown})})),pe(fe(a),"renderMonthYearDropdown",(function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthYearDropdown&&!t)return React__default.createElement(Ct,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,dateFormat:a.props.dateFormat,onChange:a.changeMonthYear,minDate:a.props.minDate,maxDate:a.props.maxDate,date:a.state.date,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown})})),pe(fe(a),"renderTodayButton",(function(){if(a.props.todayButton&&!a.props.showTimeSelectOnly)return React__default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return a.props.onSelect(startOfDay(_e()),e)}},a.props.todayButton)})),pe(fe(a),"renderDefaultHeader",(function(t){var r=t.monthDate,n=t.i;return React__default.createElement("div",{className:"react-datepicker__header ".concat(a.props.showTimeSelect?"react-datepicker__header--has-time-select":"")},a.renderCurrentMonth(r),React__default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),onFocus:a.handleDropdownFocus},a.renderMonthDropdown(0!==n),a.renderMonthYearDropdown(0!==n),a.renderYearDropdown(0!==n)),React__default.createElement("div",{className:"react-datepicker__day-names"},a.header(r)))})),pe(fe(a),"renderCustomHeader",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=t.monthDate,n=t.i;if(a.props.showTimeSelect&&!a.state.monthContainer||a.props.showTimeSelectOnly)return null;var o=st(a.state.date,a.props),s=it(a.state.date,a.props),i=pt(a.state.date,a.props),p=ct(a.state.date,a.props),c=!a.props.showMonthYearPicker&&!a.props.showQuarterYearPicker&&!a.props.showYearPicker;return React__default.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:a.props.onDropdownFocus},a.props.renderCustomHeader(de(de({},a.state),{},{customHeaderCount:n,changeMonth:a.changeMonth,changeYear:a.changeYear,decreaseMonth:a.decreaseMonth,increaseMonth:a.increaseMonth,decreaseYear:a.decreaseYear,increaseYear:a.increaseYear,prevMonthButtonDisabled:o,nextMonthButtonDisabled:s,prevYearButtonDisabled:i,nextYearButtonDisabled:p})),c&&React__default.createElement("div",{className:"react-datepicker__day-names"},a.header(r)))})),pe(fe(a),"renderYearHeader",(function(){var t=a.state.date,r=a.props,n=r.showYearPicker,o=ft(t,r.yearItemNumber),s=o.startPeriod,i=o.endPeriod;return React__default.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},n?"".concat(s," - ").concat(i):getYear(t))})),pe(fe(a),"renderHeader",(function(e){switch(!0){case void 0!==a.props.renderCustomHeader:return a.renderCustomHeader(e);case a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker:return a.renderYearHeader(e);default:return a.renderDefaultHeader(e)}})),pe(fe(a),"renderMonths",(function(){if(!a.props.showTimeSelectOnly&&!a.props.showYearPicker){for(var t=[],r=a.props.showPreviousMonths?a.props.monthsShown-1:0,n=subMonths(a.state.date,r),o=0;o<a.props.monthsShown;++o){var s=o-a.props.monthSelectedIn,i=addMonths(n,s),p="month-".concat(o),l=o<a.props.monthsShown-1,d=o>0;t.push(React__default.createElement("div",{key:p,ref:function(e){a.monthContainer=e;},className:"react-datepicker__month-container"},a.renderHeader({monthDate:i,i:o}),React__default.createElement(Pt,{chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,onChange:a.changeMonthYear,day:i,dayClassName:a.props.dayClassName,monthClassName:a.props.monthClassName,onDayClick:a.handleDayClick,handleOnKeyDown:a.props.handleOnKeyDown,onDayMouseEnter:a.handleDayMouseEnter,onMouseLeave:a.handleMonthMouseLeave,onWeekSelect:a.props.onWeekSelect,orderInDisplay:o,formatWeekNumber:a.props.formatWeekNumber,locale:a.props.locale,minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,highlightDates:a.props.highlightDates,selectingDate:a.state.selectingDate,includeDates:a.props.includeDates,inline:a.props.inline,shouldFocusDayInline:a.props.shouldFocusDayInline,fixedHeight:a.props.fixedHeight,filterDate:a.props.filterDate,preSelection:a.props.preSelection,setPreSelection:a.props.setPreSelection,selected:a.props.selected,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,showWeekNumbers:a.props.showWeekNumbers,startDate:a.props.startDate,endDate:a.props.endDate,peekNextMonth:a.props.peekNextMonth,setOpen:a.props.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,renderDayContents:a.props.renderDayContents,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,isInputFocused:a.props.isInputFocused,containerRef:a.containerRef,monthShowsDuplicateDaysEnd:l,monthShowsDuplicateDaysStart:d})));}return t}})),pe(fe(a),"renderYears",(function(){if(!a.props.showTimeSelectOnly)return a.props.showYearPicker?React__default.createElement("div",{className:"react-datepicker__year--container"},a.renderHeader(),React__default.createElement(Nt,ce({onDayClick:a.handleDayClick,date:a.state.date},a.props))):void 0})),pe(fe(a),"renderTimeSection",(function(){if(a.props.showTimeSelect&&(a.state.monthContainer||a.props.showTimeSelectOnly))return React__default.createElement(Et,{selected:a.props.selected,openToDate:a.props.openToDate,onChange:a.props.onTimeChange,timeClassName:a.props.timeClassName,format:a.props.timeFormat,includeTimes:a.props.includeTimes,intervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,todayButton:a.props.todayButton,showMonthDropdown:a.props.showMonthDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,monthRef:a.state.monthContainer,injectTimes:a.props.injectTimes,locale:a.props.locale,showTimeSelectOnly:a.props.showTimeSelectOnly})})),pe(fe(a),"renderInputTimeSection",(function(){var t=new Date(a.props.selected),r=Me(t)&&Boolean(a.props.selected)?"".concat(mt(t.getHours()),":").concat(mt(t.getMinutes())):"";if(a.props.showTimeInput)return React__default.createElement(Ot,{date:t,timeString:r,timeInputLabel:a.props.timeInputLabel,onChange:a.props.onTimeChange,customTimeInput:a.props.customTimeInput})})),a.containerRef=React__default.createRef(),a.state={date:a.getDateInView(),selectingDate:null,monthContainer:null},a}return ie(o,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}));}},{key:"componentDidUpdate",value:function(e){this.props.preSelection&&!We(this.props.preSelection,e.preSelection)?this.setState({date:this.props.preSelection}):this.props.openToDate&&!We(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate});}},{key:"render",value:function(){var r=this.props.container||xt;return React__default.createElement("div",{ref:this.containerRef},React__default.createElement(r,{className:classnames("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow,arrowProps:this.props.arrowProps},this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.props.children))}}],[{key:"defaultProps",get:function(){return {onDropdownFocus:function(){},monthsShown:1,monthSelectedIn:0,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null,yearItemNumber:12}}}]),o}(),It=function(e){return !e.disabled&&-1!==e.tabIndex},Lt=function(t){ue(n,React__default.Component);var r=ve(n);function n(t){var o;return ae(this,n),pe(fe(o=r.call(this,t)),"getTabChildren",(function(){return Array.prototype.slice.call(o.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(It)})),pe(fe(o),"handleFocusStart",(function(e){var t=o.getTabChildren();t&&t.length>1&&t[t.length-1].focus();})),pe(fe(o),"handleFocusEnd",(function(e){var t=o.getTabChildren();t&&t.length>1&&t[0].focus();})),o.tabLoopRef=React__default.createRef(),o}return ie(n,[{key:"render",value:function(){return this.props.enableTabLoop?React__default.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},React__default.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,React__default.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}],[{key:"defaultProps",get:function(){return {enableTabLoop:!0}}}]),n}(),Ft=function(t){ue(n,React__default.Component);var r=ve(n);function n(e){var t;return ae(this,n),(t=r.call(this,e)).el=document.createElement("div"),t}return ie(n,[{key:"componentDidMount",value:function(){this.portalRoot=document.getElementById(this.props.portalId),this.portalRoot||(this.portalRoot=document.createElement("div"),this.portalRoot.setAttribute("id",this.props.portalId),document.body.appendChild(this.portalRoot)),this.portalRoot.appendChild(this.el);}},{key:"componentWillUnmount",value:function(){this.portalRoot.removeChild(this.el);}},{key:"render",value:function(){return ReactDOM.createPortal(this.props.children,this.el)}}]),n}(),Rt=function(r){ue(o,React__default.Component);var n=ve(o);function o(){return ae(this,o),n.apply(this,arguments)}return ie(o,[{key:"render",value:function(){var r,n=this.props,o=n.className,a=n.wrapperClassName,s=n.hidePopper,i=n.popperComponent,p=n.popperModifiers,c=n.popperPlacement,l=n.popperProps,d=n.targetComponent,u=n.enableTabLoop,h=n.popperOnKeyDown,m=n.portalId;if(!s){var f=classnames("react-datepicker-popper",o);r=React__default.createElement(Popper$1,ce({modifiers:p,placement:c},l),(function(t){var r=t.ref,n=t.style,o=t.placement,a=t.arrowProps;return React__default.createElement(Lt,{enableTabLoop:u},React__default.createElement("div",{ref:r,style:n,className:f,"data-placement":o,onKeyDown:h},React__default.cloneElement(i,{arrowProps:a})))}));}this.props.popperContainer&&(r=React__default.createElement(this.props.popperContainer,{},r)),m&&!s&&(r=React__default.createElement(Ft,{portalId:m},r));var y=classnames("react-datepicker-wrapper",a);return React__default.createElement(Manager,{className:"react-datepicker-manager"},React__default.createElement(Reference,null,(function(t){var r=t.ref;return React__default.createElement("div",{ref:r,className:y},d)})),r)}}],[{key:"defaultProps",get:function(){return {hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperProps:{},popperPlacement:"bottom-start"}}}]),o}(),At=onClickOutsideHOC(Yt);var Wt=function(n){ue(a,React__default.Component);var o=ve(a);function a(n){var s;return ae(this,a),pe(fe(s=o.call(this,n)),"getPreSelection",(function(){return s.props.openToDate?s.props.openToDate:s.props.selectsEnd&&s.props.startDate?s.props.startDate:s.props.selectsStart&&s.props.endDate?s.props.endDate:_e()})),pe(fe(s),"calcInitialState",(function(){var e=s.getPreSelection(),t=lt(s.props),r=dt(s.props),n=t&&isBefore(e,startOfDay(t))?t:r&&isAfter(e,endOfDay(r))?r:e;return {open:s.props.startOpen||!1,preventFocus:!1,preSelection:s.props.selected?s.props.selected:n,highlightDates:ut(s.props.highlightDates),focused:!1,shouldFocusDayInline:!1}})),pe(fe(s),"clearPreventFocusTimeout",(function(){s.preventFocusTimeout&&clearTimeout(s.preventFocusTimeout);})),pe(fe(s),"setFocus",(function(){s.input&&s.input.focus&&s.input.focus({preventScroll:!0});})),pe(fe(s),"setBlur",(function(){s.input&&s.input.blur&&s.input.blur(),s.cancelFocusInput();})),pe(fe(s),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];s.setState({open:e,preSelection:e&&s.state.open?s.state.preSelection:s.calcInitialState().preSelection,lastPreSelectChange:jt},(function(){e||s.setState((function(e){return {focused:!!t&&e.focused}}),(function(){!t&&s.setBlur(),s.setState({inputValue:null});}));}));})),pe(fe(s),"inputOk",(function(){return isDate(s.state.preSelection)})),pe(fe(s),"isCalendarOpen",(function(){return void 0===s.props.open?s.state.open&&!s.props.disabled&&!s.props.readOnly:s.props.open})),pe(fe(s),"handleFocus",(function(e){s.state.preventFocus||(s.props.onFocus(e),s.props.preventOpenOnFocus||s.props.readOnly||s.setOpen(!0)),s.setState({focused:!0});})),pe(fe(s),"cancelFocusInput",(function(){clearTimeout(s.inputFocusTimeout),s.inputFocusTimeout=null;})),pe(fe(s),"deferFocusInput",(function(){s.cancelFocusInput(),s.inputFocusTimeout=setTimeout((function(){return s.setFocus()}),1);})),pe(fe(s),"handleDropdownFocus",(function(){s.cancelFocusInput();})),pe(fe(s),"handleBlur",(function(e){(!s.state.open||s.props.withPortal||s.props.showTimeInput)&&s.props.onBlur(e),s.setState({focused:!1});})),pe(fe(s),"handleCalendarClickOutside",(function(e){s.props.inline||s.setOpen(!1),s.props.onClickOutside(e),s.props.withPortal&&e.preventDefault();})),pe(fe(s),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!s.props.onChangeRaw||(s.props.onChangeRaw.apply(fe(s),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){s.setState({inputValue:n.target.value,lastPreSelectChange:Bt});var o=Se(n.target.value,s.props.dateFormat,s.props.locale,s.props.strictParsing);!o&&n.target.value||s.setSelected(o,n,!0);}})),pe(fe(s),"handleSelect",(function(e,t,r){s.setState({preventFocus:!0},(function(){return s.preventFocusTimeout=setTimeout((function(){return s.setState({preventFocus:!1})}),50),s.preventFocusTimeout})),s.props.onChangeRaw&&s.props.onChangeRaw(t),s.setSelected(e,t,!1,r),!s.props.shouldCloseOnSelect||s.props.showTimeSelect?s.setPreSelection(e):s.props.inline||s.setOpen(!1);})),pe(fe(s),"setSelected",(function(e,t,r,n){var o=e;if(null===o||!ze(o,s.props)){var a=s.props,i=a.onChange,p=a.selectsRange,c=a.startDate,l=a.endDate;if(!Be(s.props.selected,o)||s.props.allowSameDay||p)if(null!==o&&(!s.props.selected||r&&(s.props.showTimeSelect||s.props.showTimeSelectOnly||s.props.showTimeInput)||(o=Ee(o,{hour:getHours(s.props.selected),minute:getMinutes(s.props.selected),second:getSeconds(s.props.selected)})),s.props.inline||s.setState({preSelection:o}),s.props.focusSelectedMonth||s.setState({monthSelectedIn:n})),p){var d=c&&!l,u=c&&l;!c&&!l?i([o,null],t):d&&(isBefore(o,c)?i([o,null],t):i([c,o],t)),u&&i([o,null],t);}else i(o,t);r||(s.props.onSelect(o,t),s.setState({inputValue:null}));}})),pe(fe(s),"setPreSelection",(function(e){var t=void 0!==s.props.minDate,r=void 0!==s.props.maxDate,n=!0;if(e){var o=startOfDay(e);if(t&&r)n=je(e,s.props.minDate,s.props.maxDate);else if(t){var a=startOfDay(s.props.minDate);n=isAfter(e,a)||Be(o,a);}else if(r){var i=endOfDay(s.props.maxDate);n=isBefore(e,i)||Be(o,i);}}n&&s.setState({preSelection:e});})),pe(fe(s),"handleTimeChange",(function(e){var t=Ee(s.props.selected?s.props.selected:s.getPreSelection(),{hour:getHours(e),minute:getMinutes(e)});s.setState({preSelection:t}),s.props.onChange(t),s.props.shouldCloseOnSelect&&s.setOpen(!1),s.props.showTimeInput&&s.setOpen(!0),s.setState({inputValue:null});})),pe(fe(s),"onInputClick",(function(){s.props.disabled||s.props.readOnly||s.setOpen(!0),s.props.onInputClick();})),pe(fe(s),"onInputKeyDown",(function(e){s.props.onKeyDown(e);var t=e.key;if(s.state.open||s.props.inline||s.props.preventOpenOnFocus){if(s.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=s.calendar.componentNode&&s.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');return void(r&&r.focus({preventScroll:!0}))}var n=_e(s.state.preSelection);"Enter"===t?(e.preventDefault(),s.inputOk()&&s.state.lastPreSelectChange===jt?(s.handleSelect(n,e),!s.props.shouldCloseOnSelect&&s.setPreSelection(n)):s.setOpen(!1)):"Escape"===t&&(e.preventDefault(),s.setOpen(!1)),s.inputOk()||s.props.onInputError({code:1,msg:"Date input not valid."});}}else "ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||s.onInputClick();})),pe(fe(s),"onDayKeyDown",(function(e){s.props.onKeyDown(e);var t=e.key,r=_e(s.state.preSelection);if("Enter"===t)e.preventDefault(),s.handleSelect(r,e),!s.props.shouldCloseOnSelect&&s.setPreSelection(r);else if("Escape"===t)e.preventDefault(),s.setOpen(!1),s.inputOk()||s.props.onInputError({code:1,msg:"Date input not valid."});else if(!s.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=subDays(r,1);break;case"ArrowRight":n=addDays(r,1);break;case"ArrowUp":n=subWeeks(r,1);break;case"ArrowDown":n=addWeeks(r,1);break;case"PageUp":n=subMonths(r,1);break;case"PageDown":n=addMonths(r,1);break;case"Home":n=subYears(r,1);break;case"End":n=addYears(r,1);}if(!n)return void(s.props.onInputError&&s.props.onInputError({code:1,msg:"Date input not valid."}));if(e.preventDefault(),s.setState({lastPreSelectChange:jt}),s.props.adjustDateOnChange&&s.setSelected(n),s.setPreSelection(n),s.props.inline){var o=getMonth(r),a=getMonth(n),f=getYear(r),y=getYear(n);o!==a||f!==y?s.setState({shouldFocusDayInline:!0}):s.setState({shouldFocusDayInline:!1});}}})),pe(fe(s),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),s.setState({preventFocus:!0},(function(){s.setOpen(!1),setTimeout((function(){s.setFocus(),s.setState({preventFocus:!1});}));})));})),pe(fe(s),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),s.props.onChange(null,e),s.setState({inputValue:null});})),pe(fe(s),"clear",(function(){s.onClearClick();})),pe(fe(s),"onScroll",(function(e){"boolean"==typeof s.props.closeOnScroll&&s.props.closeOnScroll?e.target!==document&&e.target!==document.documentElement&&e.target!==document.body||s.setOpen(!1):"function"==typeof s.props.closeOnScroll&&s.props.closeOnScroll(e)&&s.setOpen(!1);})),pe(fe(s),"renderCalendar",(function(){return s.props.inline||s.isCalendarOpen()?React__default.createElement(At,{ref:function(e){s.calendar=e;},locale:s.props.locale,chooseDayAriaLabelPrefix:s.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:s.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:s.props.weekAriaLabelPrefix,adjustDateOnChange:s.props.adjustDateOnChange,setOpen:s.setOpen,shouldCloseOnSelect:s.props.shouldCloseOnSelect,dateFormat:s.props.dateFormatCalendar,useWeekdaysShort:s.props.useWeekdaysShort,formatWeekDay:s.props.formatWeekDay,dropdownMode:s.props.dropdownMode,selected:s.props.selected,preSelection:s.state.preSelection,onSelect:s.handleSelect,onWeekSelect:s.props.onWeekSelect,openToDate:s.props.openToDate,minDate:s.props.minDate,maxDate:s.props.maxDate,selectsStart:s.props.selectsStart,selectsEnd:s.props.selectsEnd,selectsRange:s.props.selectsRange,startDate:s.props.startDate,endDate:s.props.endDate,excludeDates:s.props.excludeDates,filterDate:s.props.filterDate,onClickOutside:s.handleCalendarClickOutside,formatWeekNumber:s.props.formatWeekNumber,highlightDates:s.state.highlightDates,includeDates:s.props.includeDates,includeTimes:s.props.includeTimes,injectTimes:s.props.injectTimes,inline:s.props.inline,shouldFocusDayInline:s.state.shouldFocusDayInline,peekNextMonth:s.props.peekNextMonth,showMonthDropdown:s.props.showMonthDropdown,showPreviousMonths:s.props.showPreviousMonths,useShortMonthInDropdown:s.props.useShortMonthInDropdown,showMonthYearDropdown:s.props.showMonthYearDropdown,showWeekNumbers:s.props.showWeekNumbers,showYearDropdown:s.props.showYearDropdown,withPortal:s.props.withPortal,forceShowMonthNavigation:s.props.forceShowMonthNavigation,showDisabledMonthNavigation:s.props.showDisabledMonthNavigation,scrollableYearDropdown:s.props.scrollableYearDropdown,scrollableMonthYearDropdown:s.props.scrollableMonthYearDropdown,todayButton:s.props.todayButton,weekLabel:s.props.weekLabel,outsideClickIgnoreClass:"react-datepicker-ignore-onclickoutside",fixedHeight:s.props.fixedHeight,monthsShown:s.props.monthsShown,monthSelectedIn:s.state.monthSelectedIn,onDropdownFocus:s.handleDropdownFocus,onMonthChange:s.props.onMonthChange,onYearChange:s.props.onYearChange,dayClassName:s.props.dayClassName,weekDayClassName:s.props.weekDayClassName,monthClassName:s.props.monthClassName,timeClassName:s.props.timeClassName,showTimeSelect:s.props.showTimeSelect,showTimeSelectOnly:s.props.showTimeSelectOnly,onTimeChange:s.handleTimeChange,timeFormat:s.props.timeFormat,timeIntervals:s.props.timeIntervals,minTime:s.props.minTime,maxTime:s.props.maxTime,excludeTimes:s.props.excludeTimes,filterTime:s.props.filterTime,timeCaption:s.props.timeCaption,className:s.props.calendarClassName,container:s.props.calendarContainer,yearItemNumber:s.props.yearItemNumber,yearDropdownItemNumber:s.props.yearDropdownItemNumber,previousMonthButtonLabel:s.props.previousMonthButtonLabel,nextMonthButtonLabel:s.props.nextMonthButtonLabel,previousYearButtonLabel:s.props.previousYearButtonLabel,nextYearButtonLabel:s.props.nextYearButtonLabel,timeInputLabel:s.props.timeInputLabel,disabledKeyboardNavigation:s.props.disabledKeyboardNavigation,renderCustomHeader:s.props.renderCustomHeader,popperProps:s.props.popperProps,renderDayContents:s.props.renderDayContents,onDayMouseEnter:s.props.onDayMouseEnter,onMonthMouseLeave:s.props.onMonthMouseLeave,showTimeInput:s.props.showTimeInput,showMonthYearPicker:s.props.showMonthYearPicker,showFullMonthYearPicker:s.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:s.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:s.props.showFourColumnMonthYearPicker,showYearPicker:s.props.showYearPicker,showQuarterYearPicker:s.props.showQuarterYearPicker,showPopperArrow:s.props.showPopperArrow,excludeScrollbar:s.props.excludeScrollbar,handleOnKeyDown:s.onDayKeyDown,isInputFocused:s.state.focused,customTimeInput:s.props.customTimeInput,setPreSelection:s.setPreSelection},s.props.children):null})),pe(fe(s),"renderDateInput",(function(){var r,n,o,a,i,p=classnames(s.props.className,pe({},"react-datepicker-ignore-onclickoutside",s.state.open)),c=s.props.customInput||React__default.createElement("input",{type:"text"}),l=s.props.customInputRef||"ref",d="string"==typeof s.props.value?s.props.value:"string"==typeof s.state.inputValue?s.state.inputValue:(n=s.props.selected,o=s.props,a=o.dateFormat,i=o.locale,n&&Pe(n,Array.isArray(a)?a[0]:a,i)||"");return React__default.cloneElement(c,(pe(r={},l,(function(e){s.input=e;})),pe(r,"value",d),pe(r,"onBlur",s.handleBlur),pe(r,"onChange",s.handleChange),pe(r,"onClick",s.onInputClick),pe(r,"onFocus",s.handleFocus),pe(r,"onKeyDown",s.onInputKeyDown),pe(r,"id",s.props.id),pe(r,"name",s.props.name),pe(r,"autoFocus",s.props.autoFocus),pe(r,"placeholder",s.props.placeholderText),pe(r,"disabled",s.props.disabled),pe(r,"autoComplete",s.props.autoComplete),pe(r,"className",classnames(c.props.className,p)),pe(r,"title",s.props.title),pe(r,"readOnly",s.props.readOnly),pe(r,"required",s.props.required),pe(r,"tabIndex",s.props.tabIndex),pe(r,"aria-describedby",s.props.ariaDescribedBy),pe(r,"aria-invalid",s.props.ariaInvalid),pe(r,"aria-labelledby",s.props.ariaLabelledBy),pe(r,"aria-required",s.props.ariaRequired),r))})),pe(fe(s),"renderClearButton",(function(){var t=s.props,r=t.isClearable,n=t.selected,o=t.clearButtonTitle,a=t.clearButtonClassName,i=t.ariaLabelClose,p=void 0===i?"Close":i;return r&&null!=n?React__default.createElement("button",{type:"button",className:"react-datepicker__close-icon ".concat(a),"aria-label":p,onClick:s.onClearClick,title:o,tabIndex:-1}):null})),s.state=s.calcInitialState(),s}return ie(a,[{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.onScroll,!0);}},{key:"componentDidUpdate",value:function(e,t){var r,n;e.inline&&(r=e.selected,n=this.props.selected,r&&n?getMonth(r)!==getMonth(n)||getYear(r)!==getYear(n):r!==n)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:ut(this.props.highlightDates)}),t.focused||Be(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose());}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout(),window.removeEventListener("scroll",this.onScroll,!0);}},{key:"render",value:function(){var t=this.renderCalendar();return this.props.inline&&!this.props.withPortal?t:this.props.withPortal?React__default.createElement("div",null,this.props.inline?null:React__default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?React__default.createElement("div",{className:"react-datepicker__portal"},t):null):React__default.createElement(Rt,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),portalId:this.props.portalId,popperModifiers:this.props.popperModifiers,targetComponent:React__default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperContainer:this.props.popperContainer,popperComponent:t,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}],[{key:"defaultProps",get:function(){return {allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showTwoColumnMonthYearPicker:!1,showFourColumnMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,yearItemNumber:12,renderDayContents:function(e){return e},focusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null}}}]),a}(),Bt="input",jt="navigate";

var css_248z$b = ":root {\n  --primary-text: #023F80;\n  --primary-text-strong: #002A55;\n  --primary-text-weak: #0A7FE4;\n  --primary-bg: #023F80;\n  --primary-bg-strong: #002A55;\n  --primary-bg-weak: #D8EBFF;\n  --primary-border: #023F80;\n  --primary-border-strong: #002A55;\n  --primary-border-weak: #479EF8;\n  --primary-ic: #023F80;\n  --primary-ic-strong: #002A55;\n  --primary-ic-weak: #0A7FE4;\n  --secondary-1-text: #1AAAAD;\n  --secondary-1-text-strong: #076568;\n  --secondary-1-text-weak: #71D7D9;\n  --secondary-1-bg: #1AAAAD;\n  --secondary-1-bg-strong: #137F82;\n  --secondary-1-bg-weak: #E0FBFD;\n  --secondary-1-border: #1AAAAD;\n  --secondary-1-border-strong: #137F82;\n  --secondary-1-border-weak: #71D7D9;\n  --secondary-1-ic: #1AAAAD;\n  --secondary-1-ic-strong: #137F82;\n  --secondary-1-ic-weak: #71D7D9;\n  --secondary-2-text: #DD2457;\n  --secondary-2-text-strong: #921034;\n  --secondary-2-text-weak: #FF95B3;\n  --secondary-2-bg: #DD2457;\n  --secondary-2-bg-strong: #B11E47;\n  --secondary-2-bg-weak: #FF95B3;\n  --secondary-2-border: #DD2457;\n  --secondary-2-border-strong: #B11E47;\n  --secondary-2-border-weak: #FF95B3;\n  --secondary-2-ic: #DD2457;\n  --secondary-2-ic-strong: #B11E47;\n  --secondary-2-ic-weak: #FF95B3;\n  --secondary-3-bg: #FECF2F;\n  --secondary-3-bg-strong: #FFA53F;\n  --secondary-3-bg-weak: #FFF0BD;\n  --secondary-3-border: #FECF2F;\n  --secondary-3-border-strong: #FFA53F;\n  --secondary-3-border-weak: #FFF0BD;\n  --secondary-3-ic: #FECF2F;\n  --secondary-3-ic-strong: #FFA53F;\n  --secondary-3-ic-weak: #FFF0BD;\n  --neutral-text: #647180;\n  --neutral-text-strong: #373E45;\n  --neutral-text-weak: #B6C5D5;\n  --neutral-text-inverted: #FFFFFF;\n  --neutral-bg: #F0F5FB;\n  --neutral-bg-strong: #EAF1F8;\n  --neutral-bg-stronger: #B6C5D5;\n  --neutral-bg-weak: #FFFFFF;\n  --neutral-bg-inverted:#373E45;\n  --neutral-border: #B6C5D5;\n  --neutral-border-strong: #647180;\n  --neutral-border-weak: #DEE8F3;\n  --neutral-ic: #647180;\n  --neutral-ic-strong: #373E45;\n  --neutral-ic-weak: #B6C5D5;\n  --neutral-ic-inverted: #FFFFFF;\n  --danger-text: #DD2457;\n  --danger-text-strong: #921034;\n  --danger-text-weak: #FF95B3;\n  --danger-bg:#DD2457;\n  --danger-bg-strong:#B11E47;\n  --danger-bg-weak: #FFF0F4;\n  --danger-border: #DD2457;\n  --danger-border-strong: #B11E47;\n  --danger-ic: #DD2457;\n  --warning-text: #623311;\n  --warning-bg: #FECF2F;\n  --warning-bg-strong: #FFA53F;\n  --warning-bg-weak: #FFF4CD;\n  --warning-border: #FECF2F;\n  --warning-border-strong: #FFA53F;\n  --warning-ic: #FFA53F;\n  --info-text:#023F80;\n  --info-bg: #479EF8;\n  --info-bg-strong: #023F80;\n  --info-bg-weak: #D8EBFF;\n  --info-border: #479EF8;\n  --info-border-strong: #023F80;\n  --info-ic: #479EF8;\n  --success-text: #035456;\n  --success-bg: #1AAAAD;\n  --success-bg-strong: #137F82;\n  --success-bg-weak: #E0FBFD;\n  --success-border: #1AAAAD;\n  --success-border-strong: #137F82;\n  --success-border-weak: #71D7D9;\n  --success-ic: #1AAAAD; }\n\n.rsg--content-3 {\n  max-width: none;\n  padding: 0;\n  margin: auto;\n  background-color: #f5f5f5; }\n\ndiv[class*='rsg--preview-'] {\n  padding: 0;\n  border: none; }\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box; }\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nlabel {\n  font-weight: normal;\n  margin: 0; }\n\ncode[class*='rsg--code-'] {\n  color: darkgreen;\n  font-size: 14px; }\n\n.datepicker.monthYearPicker .react-datepicker-year-header {\n  font-size: 16px; }\n\n.datepicker.monthYearPicker .react-datepicker-popper {\n  width: 350px;\n  height: 230px; }\n\n.datepicker.monthYearPicker .react-datepicker__month-wrapper {\n  padding: 2px; }\n\n.datepicker.monthYearPicker .react-datepicker__month-text, .datepicker.monthYearPicker .react-datepicker__month-text:hover {\n  font-size: 12px;\n  text-transform: uppercase;\n  padding: 8px 20px;\n  border-radius: 15px; }\n\n.datepicker.monthYearPicker .react-datepicker__month--in-range {\n  border-radius: 0px; }\n\n.datepicker.monthYearPicker .react-datepicker__month-text:hover .react-datepicker__month--range-end, .datepicker.monthYearPicker .react-datepicker__month-text:hover .react-datepicker__month--range-start {\n  border-radius: 15px; }\n\n.datepicker .react-datepicker-popper {\n  z-index: 999;\n  background-color: #ffffff;\n  width: 630px;\n  height: 310px;\n  border-radius: 4px;\n  box-shadow: 0 15px 40px 0 rgba(117, 117, 170, 0.08);\n  top: unset !important;\n  left: unset !important;\n  transform: unset !important; }\n  .datepicker .react-datepicker-popper .react-datepicker__header {\n    background-color: white;\n    border: none;\n    text-transform: capitalize;\n    margin-top: 10px; }\n    .datepicker .react-datepicker-popper .react-datepicker__header .react-datepicker__day-name {\n      color: #858b9b;\n      text-transform: uppercase;\n      margin: 15px 0 0 0; }\n  .datepicker .react-datepicker-popper .react-datepicker__navigation--next {\n    background: url(\"../../assets/images/icons-flecha-ios-derech-24-px.svg\") no-repeat;\n    width: 24px;\n    height: 24px;\n    border: none;\n    top: 150px; }\n  .datepicker .react-datepicker-popper .react-datepicker__navigation--previous {\n    background: url(\"../../assets/images/icons-flecha-ios-derech-24-px.svg\") no-repeat;\n    width: 24px;\n    height: 24px;\n    border: none;\n    top: 150px;\n    transform: rotate(180deg); }\n\n.datepicker .react-datepicker__navigation {\n  top: 18px; }\n\n.datepicker .react-datepicker__navigation--previous {\n  left: 20px; }\n\n.datepicker .react-datepicker__navigation--next {\n  right: 20px; }\n\n.datepicker .react-datepicker__day {\n  margin: 0px; }\n\n.datepicker .react-datepicker__day--today {\n  background-color: white; }\n\n.datepicker .react-datepicker__day-name,\n.datepicker .react-datepicker__day,\n.datepicker .react-datepicker__time-name {\n  font-size: 12px;\n  color: var(--neutral-text-strong);\n  width: 2.1rem;\n  line-height: 2.5rem; }\n\n.datepicker .react-datepicker__day:hover,\n.datepicker .react-datepicker__month-text:hover,\n.datepicker .react-datepicker__quarter-text:hover,\n.datepicker .react-datepicker__year-text:hover {\n  background-color: #20babb;\n  color: white;\n  font-weight: bold;\n  border-radius: 0px; }\n\n.datepicker .react-datepicker__day--keyboard-selected {\n  background-color: white; }\n\n.datepicker .react-datepicker__current-month,\n.datepicker .react-datepicker-time__header,\n.datepicker .react-datepicker-year-header {\n  font-size: 12px;\n  font-weight: normal;\n  color: var(--neutral-border-strong); }\n\n.datepicker .react-datepicker__day--selected,\n.datepicker .react-datepicker__day--in-selecting-range,\n.datepicker .react-datepicker__day--in-range,\n.datepicker .react-datepicker__month--selected,\n.datepicker .react-datepicker__month--in-selecting-range,\n.datepicker .react-datepicker__month--in-range,\n.datepicker .react-datepicker__month-text--selected,\n.datepicker .react-datepicker__month-text--in-selecting-range,\n.datepicker .react-datepicker__month-text--in-range,\n.datepicker .react-datepicker__quarter-text--selected,\n.datepicker .react-datepicker__quarter-text--in-selecting-range,\n.datepicker .react-datepicker__quarter-text--in-range,\n.datepicker .react-datepicker__year-text--selected,\n.datepicker .react-datepicker__year-text--in-selecting-range,\n.datepicker .react-datepicker__year-text--in-range {\n  background-color: rgba(32, 186, 187, 0.3);\n  color: var(--neutral-text-strong);\n  border-radius: 0px; }\n\n.datepicker .react-datepicker__month--selecting-range-start, .datepicker .react-datepicker__month--range-start, .datepicker .react-datepicker__day--range-start {\n  background-color: var(--primary-bg);\n  border-radius: 0px; }\n\n.datepicker .react-datepicker__month--selecting-range-end, .datepicker .react-datepicker__month--range-end, .datepicker .react-datepicker__day--range-end {\n  background-color: var(--primary-bg);\n  border-radius: 0px; }\n\n.datepicker .react-datepicker__day--selecting-range-start,\n.datepicker .react-datepicker__day--range-start,\n.datepicker .react-datepicker__month--selecting-range-start {\n  background-color: var(--primary-bg);\n  color: white;\n  font-weight: bold; }\n\n.datepicker .react-datepicker__day--disabled {\n  color: lightgray; }\n  .datepicker .react-datepicker__day--disabled:hover {\n    background-color: white;\n    color: lightgray;\n    font-weight: normal; }\n\n.datepicker .react-datepicker__month-container {\n  padding-left: 10px;\n  padding-right: 10px;\n  width: 230px; }\n\n.datepicker .react-datepicker__month-container:nth-of-type(2) {\n  padding-left: 10px;\n  padding-right: 10px;\n  width: 270px;\n  border-left: 1px solid var(--neutral-bg-stronger); }\n\n.datepicker .react-datepicker__month .react-datepicker__month-text,\n.datepicker .react-datepicker__month .react-datepicker__quarter-text {\n  margin: 0px; }\n";
styleInject(css_248z$b);

var _path$7f;
function _extends$7p() { _extends$7p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7p.apply(this, arguments); }
var SvgIconsHoy16Px = function SvgIconsHoy16Px(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path$7f || (_path$7f = /*#__PURE__*/createElement$2("path", {
    d: "M3.755 13.605h8.496c1.237 0 1.856-.618 1.856-1.835V4.237c0-1.217-.619-1.842-1.856-1.842H3.755c-1.237 0-1.862.618-1.862 1.842v7.533c0 1.217.625 1.835 1.862 1.835zm-.071-.846c-.606 0-.938-.325-.938-.95V6.112c0-.625.332-.95.938-.95h8.626c.605 0 .95.325.95.95v5.697c0 .625-.345.95-.95.95H3.684zm.952-6.703H6.66c.368 0 .667.298.667.667v2.022a.667.667 0 0 1-.667.667H4.636a.666.666 0 0 1-.666-.667V6.723c0-.369.298-.667.666-.667z",
    fill: "#5D5E68",
    fillRule: "evenodd"
  })));
};

var _templateObject$K, _templateObject2$C, _templateObject3$v, _templateObject4$n, _templateObject5$k;
var Body$1 = styled(Flex)(_templateObject$K || (_templateObject$K = _taggedTemplateLiteral(["\n  position: relative;\n  padding-right: 10px;\n  padding-left: 10px;\n  justify-content: space-evenly;\n"])));
var Footer$2 = styled.div(_templateObject2$C || (_templateObject2$C = _taggedTemplateLiteral(["\n  background-color: white;\n  position: absolute;\n  bottom: -60px;\n  border-top: 1px solid ", ";\n  width: 100%;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  box-shadow: 0 15px 40px 0 rgba(117, 117, 170, 0.08);\n"])), theme.oldColors['palette-buttons-primary-disabled']);
var Buttons = styled(Flex)(_templateObject3$v || (_templateObject3$v = _taggedTemplateLiteral(["\n  justify-content: space-between;\n  margin: 15px;\n"])));
var ButtonsRight = styled(Flex)(_templateObject4$n || (_templateObject4$n = _taggedTemplateLiteral(["\n  justify-content: flex-end;\n  & button:last-child {\n    margin-left: 15px;\n  }\n"])));
var DateInput = styled(Flex)(_templateObject5$k || (_templateObject5$k = _taggedTemplateLiteral(["\n      justify-content: space-between;\n      align-items: center;\n      width: 210px;\n      padding: 10px;\n      font-size: 14px;\n      color:  ", ";\n      border: solid 1px ", ";\n      border-radius: 5px;\n      background-color: white;\n      &:focus {\n        border-color: ", ";\n        $palette-message-info: #439aff;\n      }\n      & placeholder: ", ";\n  "])), theme.oldColors['palette-neutral-n-1'], theme.oldColors['palette-neutral-n-3'], theme.oldColors['palette-message-info'], theme.oldColors['palette-input-disabled-text']);

var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: 'menos de un segundo',
    other: 'menos de {{count}} segundos'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundos'
  },
  halfAMinute: 'medio minuto',
  lessThanXMinutes: {
    one: 'menos de un minuto',
    other: 'menos de {{count}} minutos'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutos'
  },
  aboutXHours: {
    one: 'alrededor de 1 hora',
    other: 'alrededor de {{count}} horas'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} horas'
  },
  xDays: {
    one: '1 día',
    other: '{{count}} días'
  },
  aboutXWeeks: {
    one: 'alrededor de 1 semana',
    other: 'alrededor de {{count}} semanas'
  },
  xWeeks: {
    one: '1 semana',
    other: '{{count}} semanas'
  },
  aboutXMonths: {
    one: 'alrededor de 1 mes',
    other: 'alrededor de {{count}} meses'
  },
  xMonths: {
    one: '1 mes',
    other: '{{count}} meses'
  },
  aboutXYears: {
    one: 'alrededor de 1 año',
    other: 'alrededor de {{count}} años'
  },
  xYears: {
    one: '1 año',
    other: '{{count}} años'
  },
  overXYears: {
    one: 'más de 1 año',
    other: 'más de {{count}} años'
  },
  almostXYears: {
    one: 'casi 1 año',
    other: 'casi {{count}} años'
  }
};

var formatDistance$1 = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$1[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'en ' + result;
    } else {
      return 'hace ' + result;
    }
  }

  return result;
};

var dateFormats$1 = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
var timeFormats$1 = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$1 = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale$1 = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: 'P'
};
var formatRelativeLocalePlural = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: 'P'
};

var formatRelative$1 = function formatRelative(token, date, _baseDate, _options) {
  if (date.getUTCHours() !== 1) {
    return formatRelativeLocalePlural[token];
  } else {
    return formatRelativeLocale$1[token];
  }
};

var eraValues$1 = {
  narrow: ['AC', 'DC'],
  abbreviated: ['AC', 'DC'],
  wide: ['antes de cristo', 'después de cristo']
};
var quarterValues$1 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
var monthValues$1 = {
  narrow: ['e', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
  wide: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
};
var dayValues$1 = {
  narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
  short: ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sá'],
  abbreviated: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  wide: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
};
var dayPeriodValues$1 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  }
};
var formattingDayPeriodValues$1 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  }
};

var ordinalNumber$1 = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + 'º';
};

var localize$1 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: 'wide'
  })
};

var matchOrdinalNumberPattern$1 = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var parseEraPatterns$1 = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
};
var matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1 = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var parseMonthPatterns$1 = {
  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
};
var matchDayPatterns$1 = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var parseDayPatterns$1 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
};
var matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
};
var match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */
var locale$1 = {
  code: 'es',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};

Ke('es', locale$1);
var Datepicker_DEPRECATED = function Datepicker_DEPRECATED(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    clickedOutsideTrigger = _useState2[0],
    setClickedOutsideTrigger = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    fltersModified = _useState4[0],
    setFiltersModified = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    startDate = _useState6[0],
    setStartDate = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    endDate = _useState8[0],
    setEndDate = _useState8[1];
  useEffect(function () {
    if (props.initialValues) {
      props.initialValues.startDate && setStartDate(createDate(props.initialValues.startDate));
      props.initialValues.endDate && setEndDate(createDate(props.initialValues.endDate));
    }
  }, [props.initialValues]);
  useEffect(function () {
    fltersModified && clearCalendar();
  }, [clickedOutsideTrigger]);
  var calendarRef = /*#__PURE__*/React__default.createRef();
  var calendarContainer = function calendarContainer(_ref) {
    var children = _ref.children;
    setClickedOutsideTrigger(false);
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Body$1, null, children), /*#__PURE__*/React__default.createElement(Footer$2, null, /*#__PURE__*/React__default.createElement(Buttons, null, /*#__PURE__*/React__default.createElement(Button$1, {
      variant: "link",
      size: "sm",
      onClick: onReset
    }, "Limpiar"), /*#__PURE__*/React__default.createElement(ButtonsRight, null, /*#__PURE__*/React__default.createElement(Button$1, {
      variant: "secondary",
      size: "sm",
      onClick: onCancel
    }, "Cancelar"), /*#__PURE__*/React__default.createElement(Button$1, {
      variant: "primary",
      size: "sm",
      onClick: onAccept
    }, "Aplicar")))));
  };

  //input: 'yyyy-MM-dd'
  //output: Date
  var createDate = function createDate(date) {
    return new Date(Date.parse(date + 'T00:00-03:00'));
  };
  var onChange = function onChange(dates) {
    setFiltersModified(true);
    var _dates = _slicedToArray(dates, 2),
      start = _dates[0],
      end = _dates[1];
    setStartDate(start);
    setEndDate(end);
  };
  var onAccept = function onAccept() {
    setFiltersModified(false);
    calendarRef.current.setOpen(false);
    if (props.onAccept) {
      props.onAccept(outputFormatDate(startDate), outputFormatDate(endDate));
      props.onSubmit();
    }
  };
  var onCancel = function onCancel() {
    var finalDateStart = props.start ? setStartDate(createDate(props.start)) : null;
    var finalDateEnd = props.end ? setStartDate(createDate(props.end)) : null;
    setStartDate(finalDateStart);
    setEndDate(finalDateEnd);
    calendarRef.current.setOpen(false);
  };
  var onReset = function onReset() {
    clearCalendar();
  };
  var clearCalendar = function clearCalendar() {
    setEndDate(null);
    setStartDate(null);
  };
  var outputFormatDate = function outputFormatDate(date) {
    return date && props.outputFormat ? format$1(date, props.outputFormat) : '';
  };
  var CustomDateInput = function CustomDateInput(_ref2) {
    var onClick = _ref2.onClick,
      start = _ref2.start,
      end = _ref2.end,
      placeholder = _ref2.placeholder;
    var dateFormat = props.dateFormat ? typeof props.dateFormat === 'function' ? props.dateFormat(start, end) : props.dateFormat : 'dd/MM/yyyy';
    var startFormatted = start ? format$1(start, dateFormat) + ' - ' : '';
    var endFormatted = end ? format$1(end, dateFormat) : '';
    var place = startFormatted || endFormatted;
    return /*#__PURE__*/React__default.createElement(DateInput, {
      onClick: onClick
    }, place ? /*#__PURE__*/React__default.createElement("span", null, startFormatted + endFormatted) : /*#__PURE__*/React__default.createElement(Span$1, {
      type: "2",
      variant: "disabled"
    }, placeholder), /*#__PURE__*/React__default.createElement(SvgIconsHoy16Px, null));
  };
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "datepicker",
    className: "datepicker ".concat(props.showMonthYearPicker ? 'monthYearPicker' : '')
  }, /*#__PURE__*/React__default.createElement(OutsideAlerter, {
    handleOutSideClick: function handleOutSideClick() {
      return setClickedOutsideTrigger(!clickedOutsideTrigger);
    }
  }, /*#__PURE__*/React__default.createElement(Wt, {
    selected: null,
    onChange: onChange,
    startDate: startDate,
    endDate: endDate,
    selectsRange: true,
    shouldCloseOnSelect: false,
    monthsShown: props.monthsShown,
    ref: calendarRef,
    maxDate: props.maxDate,
    minDate: props.minDate,
    openToDate: startDate ? startDate : subDays(new Date(), 30),
    placeholderText: props.placeholder,
    formatWeekDay: function formatWeekDay(nameOfDay) {
      return nameOfDay.substr(0, 1);
    },
    calendarContainer: calendarContainer,
    locale: "es",
    showMonthYearPicker: props.showMonthYearPicker,
    customInput: props.customInput ? props.customInput : /*#__PURE__*/React__default.createElement(CustomDateInput, {
      start: startDate,
      end: endDate,
      placeholder: props.placeholder,
      onClick: props.onClick
    })
  })));
};

var _templateObject$L, _templateObject2$D, _templateObject3$w, _templateObject4$o, _templateObject5$l, _templateObject6$i, _templateObject7$f, _templateObject8$c, _templateObject9$b, _templateObject10$a, _templateObject11$9, _templateObject12$5, _templateObject13$4, _templateObject14$3, _templateObject15$3, _templateObject16$2, _templateObject17$2, _templateObject18$2, _templateObject19$1, _templateObject20$1, _templateObject21$1, _templateObject22$1, _templateObject23$1, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33;
var DatePickerGrid = styled.div(_templateObject$L || (_templateObject$L = _taggedTemplateLiteral(["\n  min-height: 200px;\n  padding-top: ", ";\n  ", "\n"])), theme.spacing['spacing-6'], function (_ref) {
  var months = _ref.months;
  return months && months >= 2 && css$1(_templateObject2$D || (_templateObject2$D = _taggedTemplateLiteral(["\n      min-width ", "px;\n      min-height: 310px;\n      &:nth-child(2n) {\n        margin-left: ", ";\n      }\n    "])), 344 / months, theme.spacing['spacing-4']);
});
var DatePickerDay = styled.div(_templateObject3$w || (_templateObject3$w = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(\n    ", ",\n    230px\n  );\n"])), function (_ref2) {
  var numberOfMonths = _ref2.numberOfMonths;
  return numberOfMonths;
});
var DayGrid = styled.div(_templateObject4$o || (_templateObject4$o = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(7, 32px);\n  justify-content: left;\n"])));
var DatePickerWeek = styled.div(_templateObject5$l || (_templateObject5$l = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(7, 32px);\n  justify-content: left;\n"])));
var DatePickerWeekContent = styled.div(_templateObject6$i || (_templateObject6$i = _taggedTemplateLiteral(["\n  text-align: center;\n  height: 14px;\n  width: 14px;\n  padding: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), theme.spacing['spacing-5']);
var NavButton = styled.div(_templateObject7$f || (_templateObject7$f = _taggedTemplateLiteral(["\n  align-self: center;\n  background: transparent;\n  cursor: pointer;\n  min-width: 60px;\n  padding: ", " ", ";\n"])), theme.spacing['spacing-0'], theme.spacing['spacing-5']);
var DatePickerBody = styled(Flex)(_templateObject8$c || (_templateObject8$c = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var DatePickerFooter = styled.div(_templateObject9$b || (_templateObject9$b = _taggedTemplateLiteral(["\n  width: 100%;\n  padding-top: ", ";\n  padding-bottom: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-left: ", ";\n  padding-right: ", ";\n  ", "\n"])), theme.spacing['spacing-5'], theme.spacing['spacing-6'], theme.spacing['spacing-7'], theme.spacing['spacing-6'], function (_ref3) {
  var bookingDate = _ref3.bookingDate,
    numberOfMonths = _ref3.numberOfMonths;
  return !!bookingDate && numberOfMonths !== '1' && css$1(_templateObject10$a || (_templateObject10$a = _taggedTemplateLiteral(["\n      padding-left: ", ";\n      padding-right: ", ";\n    "])), theme.spacing['spacing-11'], theme.spacing['spacing-11']);
});
var DatePickerButtons = styled(Flex)(_templateObject11$9 || (_templateObject11$9 = _taggedTemplateLiteral(["\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n"])));
var DatePickerButtonsRight = styled(Flex)(_templateObject12$5 || (_templateObject12$5 = _taggedTemplateLiteral(["\n  justify-content: flex-end;\n  & button:last-child {\n    margin-left: ", ";\n  }\n"])), theme.spacing['spacing-5']);
var DatePickerWrapper = styled.div(_templateObject13$4 || (_templateObject13$4 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  border-radius: ", ";\n"])), theme.spacing['spacing-2'], theme.colors.neutral.bg.weak, theme.elevations['elevation-3'], theme.borderRadius['border-radius-3']);
var DatePickerCalendarBox = styled.div(_templateObject14$3 || (_templateObject14$3 = _taggedTemplateLiteral(["\n  justify-self: center;\n  margin: ", " 0;\n  ", "\n  &.inrange:hover {\n    margin: ", " 0;\n    background: linear-gradient(\n      90deg,\n      ", " 50%,\n      transparent 50%\n    );\n    & button {\n      ", "\n      & span {\n        color: ", ";\n      }\n    }\n  }\n"])), theme.spacing['spacing-1'], function (_ref4) {
  var isStartDate = _ref4.isStartDate,
    isEndDate = _ref4.isEndDate,
    range = _ref4.range;
  if (isStartDate !== isEndDate && range) {
    if (isStartDate) {
      return css$1(_templateObject15$3 || (_templateObject15$3 = _taggedTemplateLiteral(["\n          background: linear-gradient(\n            90deg,\n            transparent 50%,\n            ", " 20%\n          );\n        "])), theme.colors.primary.bg.weak);
    } else if (isEndDate) {
      return css$1(_templateObject16$2 || (_templateObject16$2 = _taggedTemplateLiteral(["\n          background: linear-gradient(\n            90deg,\n            ", " 50%,\n            transparent 20%\n          );\n        "])), theme.colors.primary.bg.weak);
    }
  }
}, theme.spacing['spacing-1'], theme.colors.primary.bg.weak, function () {
  return dayVariants['startOrEnd'];
}, theme.colors.neutral.text.inverted);
var MonthGrid = styled.div(_templateObject17$2 || (_templateObject17$2 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(3, 65px);\n  justify-content: left;\n"])));
var Month$1 = styled(DatePickerCalendarBox)(_templateObject18$2 || (_templateObject18$2 = _taggedTemplateLiteral([""])));
var Day = styled(DatePickerCalendarBox)(_templateObject19$1 || (_templateObject19$1 = _taggedTemplateLiteral([""])));
var DayContent = styled.button(_templateObject20$1 || (_templateObject20$1 = _taggedTemplateLiteral(["\n  border: 0;\n  text-transform: uppercase;\n  align-items: center;\n  display: flex;\n  width: 14px;\n  height: 14px;\n  padding: ", ";\n  justify-content: center;\n  ", "\n  ", "\n"])), theme.spacing['spacing-5'], function (props) {
  return dayVariants[props.variant] || dayVariants.normal;
}, function (props) {
  return startOrEndOfRowGridVariant[props.isStartOrEndOfRowGrid];
});
var MonthContent = styled.button(_templateObject21$1 || (_templateObject21$1 = _taggedTemplateLiteral(["\n  border: 0;\n  text-transform: uppercase;\n  align-items: center;\n  display: flex;\n  width: 65px;\n  height: 30px;\n  padding: ", ";\n  justify-content: center;\n\n  ", "\n  ", "\n"])), theme.spacing['spacing-5'], function (props) {
  return dayVariants[props.variant] || dayVariants.normal;
}, function (props) {
  return startOrEndOfRowGridVariant[props.isStartOrEndOfRowGrid];
});
var DatePickerHeader = styled.div(_templateObject22$1 || (_templateObject22$1 = _taggedTemplateLiteral(["\n  text-align: center;\n  margin: ", " ", "\n    ", ";\n"])), theme.spacing['spacing-0'], theme.spacing['spacing-2'], theme.spacing['spacing-5']);
var DatePickerPopper = styled.div(_templateObject23$1 || (_templateObject23$1 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 999;\n"])));
var startOrEndOfRowGridVariant = {
  startRowGrid: css$1(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n    border-bottom-left-radius: ", ";\n    border-top-left-radius: ", ";\n  "])), theme.borderRadius['border-radius-4'], theme.borderRadius['border-radius-4']),
  endRowGrid: css$1(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n    border-bottom-right-radius: ", ";\n    border-top-right-radius: ", ";\n  "])), theme.borderRadius['border-radius-4'], theme.borderRadius['border-radius-4'])
};
var dayVariants = {
  startOrEnd: css$1(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n    background: ", ";\n    border-radius: ", ";\n    cursor: pointer;\n  "])), theme.colors.primary.bg.regular, theme.borderRadius['border-radius-4']),
  selected: css$1(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n    background: ", ";\n    cursor: pointer;\n  "])), theme.colors.primary.bg.weak),
  inrange: css$1(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n    background: ", ";\n    cursor: pointer;\n  "])), theme.colors.primary.bg.weak),
  disabled: css$1(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n    background: transparent;\n    cursor: auto !important;\n    color: ", ";\n  "])), theme.colors.neutral.text.regular),
  normal: css$1(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n    background: none;\n    cursor: pointer;\n  "])))
};
var DatePickerOptions = styled.div(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  h6 {\n    width: 250px;\n    margin-bottom: ", ";\n  }\n  z-index:999;\n  padding-top: ", ";\n  padding-left: ", ";\n  & ul {\n    & li {\n      display: block;\n      margin-top: ", ";\n      margin-right: 100%\n    }\n    list-style: none;\n  }\n\n  & label {\n      margin-bottom: ", ";\n      white-space: nowrap;\n    }\n  }\n"])), theme.spacing['spacing-4'], theme.spacing['spacing-6'], theme.spacing['spacing-5'], theme.spacing['spacing-6'], theme.spacing['spacing-6']);
var DatePickerCalendarControl = styled(Flex)(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var DatePickerCalendar = styled.div(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  position: relative;\n"])));

var _excluded$b = ["onChange", "dateFormat", "outputFormat", "range", "filterAlternatives", "setCurrentFilterAlternative", "currentFilterAlternative", "bookingDate", "disabled", "numberOfMonths"];
var RESET_VALUE = [null, null];
var getInitialValue = function getInitialValue(range, value) {
  return value ? range ? value : [value] : [];
};
var DatePicker = function DatePicker(_ref) {
  var onChange = _ref.onChange,
    _ref$dateFormat = _ref.dateFormat,
    dateFormat = _ref$dateFormat === void 0 ? 'dd/MM/yyyy' : _ref$dateFormat,
    _ref$outputFormat = _ref.outputFormat,
    outputFormat = _ref$outputFormat === void 0 ? 'dd-MM-yyyy' : _ref$outputFormat,
    range = _ref.range,
    filterAlternatives = _ref.filterAlternatives,
    setCurrentFilterAlternative = _ref.setCurrentFilterAlternative,
    currentFilterAlternative = _ref.currentFilterAlternative,
    bookingDate = _ref.bookingDate,
    disabled = _ref.disabled,
    numberOfMonths = _ref.numberOfMonths,
    props = _objectWithoutProperties(_ref, _excluded$b);
  var initialValue = getInitialValue(range, props.value);
  var _useState = useState(initialValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var lastValueRef = useRef();
  var inputEl = useRef(null);
  var setLastValue = function setLastValue(lastValue) {
    lastValueRef.current = lastValue;
  };
  useEffect(function () {
    lastValueRef.current = initialValue;
  }, [initialValue]);
  useEffect(function () {
    if (value !== props.value) {
      setValue(props.value || []);
    }
  }, [props.value]);
  var _value = _slicedToArray(value, 2),
    startDate = _value[0],
    endDate = _value[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var outputFormatDate = function outputFormatDate(date) {
    return date ? format$1(date, outputFormat) : date;
  };
  var handleClose = function handleClose() {
    return setOpen(false);
  };
  var handleApply = function handleApply() {
    handleClose();
    if (range) {
      onChange && onChange(value.map(outputFormatDate));
    } else {
      onChange && onChange(value.map(outputFormatDate)[0]);
    }
    setLastValue(value);
  };
  var handleCancel = function handleCancel() {
    setValue(lastValueRef.current);
    handleClose();
  };
  var handleOnChange = function handleOnChange(_ref2) {
    var startDate = _ref2.startDate,
      endDate = _ref2.endDate;
    return setValue([startDate, endDate]);
  };
  var handleReset = function handleReset() {
    onChange && onChange(null);
    setValue(RESET_VALUE);
    setLastValue(RESET_VALUE);
    handleClose();
  };
  var startFormatted = startDate ? "".concat(format$1(startDate, dateFormat, {
    locale: locale$1
  })).concat(range ? ' - ' : '') : '';
  var endFormatted = endDate ? format$1(endDate, dateFormat, {
    locale: locale$1
  }) : '';
  var handleSelected = function handleSelected(filterAlternatives) {
    return filterAlternatives.map(function (item) {
      return item.id === currentFilterAlternative ? _objectSpread2(_objectSpread2({}, item), {}, {
        active: true
      }) : _objectSpread2(_objectSpread2({}, item), {}, {
        active: false
      });
    });
  };
  var filtersAlternativesRender = function filtersAlternativesRender() {
    return /*#__PURE__*/React__default.createElement(DatePickerOptions, {
      "data-testid": "datepicker-filter-alternatives"
    }, /*#__PURE__*/React__default.createElement(H$1, {
      className: "datepicker-options__title",
      type: "6",
      align: "left",
      variant: "neutral"
    }, "Seleccion\xE1 tipo de fecha"), /*#__PURE__*/React__default.createElement(SelectableChips$1, {
      options: handleSelected(filterAlternatives),
      direction: "column",
      value: currentFilterAlternative,
      onChange: function onChange(list) {
        setValue(RESET_VALUE);
        setCurrentFilterAlternative(list.filter(function (item) {
          return item.active;
        })[0].id);
      }
    }));
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OutsideAlerter, {
    handleOutSideClick: handleCancel,
    exclude: ['#daterange-picker'],
    active: open
  }, /*#__PURE__*/React__default.createElement(RangeInput, {
    from: capitalize$1(startFormatted),
    to: capitalize$1(endFormatted),
    placeHolder: 'Desde - Hasta',
    label: props.label,
    onClick: function onClick() {
      return setOpen(true);
    },
    inputRef: inputEl,
    icons: {
      iconRight: 'calendar_outline'
    },
    disabled: disabled
  }), open && inputEl.current && /*#__PURE__*/React__default.createElement(DatePickerContainerPortal, {
    target: inputEl
  }, /*#__PURE__*/React__default.createElement(DatePickerWrapper, null, filterAlternatives && filtersAlternativesRender(), /*#__PURE__*/React__default.createElement(DatePickerCalendar, null, /*#__PURE__*/React__default.createElement(DatePickerCalendarControl, null, /*#__PURE__*/React__default.cloneElement(React__default.Children.only(props.children), {
    onChange: handleOnChange,
    value: {
      startDate: startDate,
      endDate: endDate
    }
  })), /*#__PURE__*/React__default.createElement(DatePickerFooter, {
    bookingDate: bookingDate,
    numberOfMonths: numberOfMonths
  }, /*#__PURE__*/React__default.createElement(DatePickerButtons, null, /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "tertiary",
    size: "sm",
    onClick: handleReset
  }, "Limpiar"), /*#__PURE__*/React__default.createElement(DatePickerButtonsRight, null, /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "secondary",
    size: "sm",
    onClick: handleCancel
  }, "Cancelar"), /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "primary",
    size: "sm",
    onClick: handleApply
  }, "Aplicar")))))))));
};
var DatePickerContainerPortal = function DatePickerContainerPortal(_ref3) {
  var children = _ref3.children,
    target = _ref3.target;
  var targetContainer = getScrollableParent(target.current);
  var getTargetProps = function getTargetProps() {
    return target.current.getBoundingClientRect().toJSON && target.current.getBoundingClientRect().toJSON();
  };
  var _useState5 = useState(getTargetProps()),
    _useState6 = _slicedToArray(_useState5, 2),
    targetProps = _useState6[0],
    setTargetProps = _useState6[1];
  var handleScroll = function handleScroll() {
    return setTargetProps(getTargetProps());
  };
  useEffect(function () {
    targetContainer.addEventListener('scroll', handleScroll);
    return function () {
      targetContainer.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(DatePickerPopper, targetProps, children);
};
var isScrollable = function isScrollable(ele) {
  var hasScrollableContent = ele.scrollHeight > ele.clientHeight;
  var overflowYStyle = window.getComputedStyle(ele).overflowY;
  var isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1;
  return hasScrollableContent && !isOverflowHidden;
};
var getScrollableParent = function getScrollableParent(ele) {
  return !ele || ele === document.body ? document.body : isScrollable(ele) ? ele : getScrollableParent(ele.parentNode);
};
var capitalize$1 = function capitalize(str) {
  var lower = str.toLowerCase();
  return str.charAt(0).toUpperCase() + lower.slice(1);
};

var a = {
  lessThanXSeconds: {one: 'less than a second', other: 'less than {{count}} seconds'},
  xSeconds: {one: '1 second', other: '{{count}} seconds'},
  halfAMinute: 'half a minute',
  lessThanXMinutes: {one: 'less than a minute', other: 'less than {{count}} minutes'},
  xMinutes: {one: '1 minute', other: '{{count}} minutes'},
  aboutXHours: {one: 'about 1 hour', other: 'about {{count}} hours'},
  xHours: {one: '1 hour', other: '{{count}} hours'},
  xDays: {one: '1 day', other: '{{count}} days'},
  aboutXWeeks: {one: 'about 1 week', other: 'about {{count}} weeks'},
  xWeeks: {one: '1 week', other: '{{count}} weeks'},
  aboutXMonths: {one: 'about 1 month', other: 'about {{count}} months'},
  xMonths: {one: '1 month', other: '{{count}} months'},
  aboutXYears: {one: 'about 1 year', other: 'about {{count}} years'},
  xYears: {one: '1 year', other: '{{count}} years'},
  overXYears: {one: 'over 1 year', other: 'over {{count}} years'},
  almostXYears: {one: 'almost 1 year', other: 'almost {{count}} years'},
};
function i(t) {
  return function (e) {
    var n = e || {},
      r = n.width ? String(n.width) : t.defaultWidth;
    return t.formats[r] || t.formats[t.defaultWidth]
  }
}
var o = {
    date: i({
      formats: {
        full: 'EEEE, MMMM do, y',
        long: 'MMMM do, y',
        medium: 'MMM d, y',
        short: 'MM/dd/yyyy',
      },
      defaultWidth: 'full',
    }),
    time: i({
      formats: {full: 'h:mm:ss a zzzz', long: 'h:mm:ss a z', medium: 'h:mm:ss a', short: 'h:mm a'},
      defaultWidth: 'full',
    }),
    dateTime: i({
      formats: {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}',
      },
      defaultWidth: 'full',
    }),
  },
  u = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P',
  };
function s(t) {
  return function (e, n) {
    var r,
      a = n || {};
    if ('formatting' === (a.context ? String(a.context) : 'standalone') && t.formattingValues) {
      var i = t.defaultFormattingWidth || t.defaultWidth,
        o = a.width ? String(a.width) : i;
      r = t.formattingValues[o] || t.formattingValues[i];
    } else {
      var u = t.defaultWidth,
        s = a.width ? String(a.width) : t.defaultWidth;
      r = t.values[s] || t.values[u];
    }
    return r[t.argumentCallback ? t.argumentCallback(e) : e]
  }
}
function c(t) {
  return function (e, n) {
    var r = String(e),
      a = n || {},
      i = a.width,
      o = (i && t.matchPatterns[i]) || t.matchPatterns[t.defaultMatchWidth],
      u = r.match(o);
    if (!u) return null
    var s,
      c = u[0],
      d = (i && t.parsePatterns[i]) || t.parsePatterns[t.defaultParseWidth];
    return (
      (s =
        '[object Array]' === Object.prototype.toString.call(d)
          ? (function (t, e) {
              for (var n = 0; n < t.length; n++) if (e(t[n])) return n
            })(d, function (t) {
              return t.test(c)
            })
          : (function (t, e) {
              for (var n in t) if (t.hasOwnProperty(n) && e(t[n])) return n
            })(d, function (t) {
              return t.test(c)
            })),
      (s = t.valueCallback ? t.valueCallback(s) : s),
      {value: (s = a.valueCallback ? a.valueCallback(s) : s), rest: r.slice(c.length)}
    )
  }
}
var d,
  l = {
    code: 'en-US',
    formatDistance: function (t, e, n) {
      var r;
      return (
        (n = n || {}),
        (r =
          'string' == typeof a[t] ? a[t] : 1 === e ? a[t].one : a[t].other.replace('{{count}}', e)),
        n.addSuffix ? (n.comparison > 0 ? 'in ' + r : r + ' ago') : r
      )
    },
    formatLong: o,
    formatRelative: function (t, e, n, r) {
      return u[t]
    },
    localize: {
      ordinalNumber: function (t, e) {
        var n = Number(t),
          r = n % 100;
        if (r > 20 || r < 10)
          switch (r % 10) {
            case 1:
              return n + 'st'
            case 2:
              return n + 'nd'
            case 3:
              return n + 'rd'
          }
        return n + 'th'
      },
      era: s({
        values: {
          narrow: ['B', 'A'],
          abbreviated: ['BC', 'AD'],
          wide: ['Before Christ', 'Anno Domini'],
        },
        defaultWidth: 'wide',
      }),
      quarter: s({
        values: {
          narrow: ['1', '2', '3', '4'],
          abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
          wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'],
        },
        defaultWidth: 'wide',
        argumentCallback: function (t) {
          return Number(t) - 1
        },
      }),
      month: s({
        values: {
          narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
          abbreviated: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
          wide: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ],
        },
        defaultWidth: 'wide',
      }),
      day: s({
        values: {
          narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
          short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        },
        defaultWidth: 'wide',
      }),
      dayPeriod: s({
        values: {
          narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night',
          },
          abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night',
          },
          wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night',
          },
        },
        defaultWidth: 'wide',
        formattingValues: {
          narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night',
          },
          abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night',
          },
          wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night',
          },
        },
        defaultFormattingWidth: 'wide',
      }),
    },
    match: {
      ordinalNumber:
        ((d = {
          matchPattern: /^(\d+)(th|st|nd|rd)?/i,
          parsePattern: /\d+/i,
          valueCallback: function (t) {
            return parseInt(t, 10)
          },
        }),
        function (t, e) {
          var n = String(t),
            r = e || {},
            a = n.match(d.matchPattern);
          if (!a) return null
          var i = a[0],
            o = n.match(d.parsePattern);
          if (!o) return null
          var u = d.valueCallback ? d.valueCallback(o[0]) : o[0];
          return {value: (u = r.valueCallback ? r.valueCallback(u) : u), rest: n.slice(i.length)}
        }),
      era: c({
        matchPatterns: {
          narrow: /^(b|a)/i,
          abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
          wide: /^(before christ|before common era|anno domini|common era)/i,
        },
        defaultMatchWidth: 'wide',
        parsePatterns: {any: [/^b/i, /^(a|c)/i]},
        defaultParseWidth: 'any',
      }),
      quarter: c({
        matchPatterns: {
          narrow: /^[1234]/i,
          abbreviated: /^q[1234]/i,
          wide: /^[1234](th|st|nd|rd)? quarter/i,
        },
        defaultMatchWidth: 'wide',
        parsePatterns: {any: [/1/i, /2/i, /3/i, /4/i]},
        defaultParseWidth: 'any',
        valueCallback: function (t) {
          return t + 1
        },
      }),
      month: c({
        matchPatterns: {
          narrow: /^[jfmasond]/i,
          abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
          wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
        },
        defaultMatchWidth: 'wide',
        parsePatterns: {
          narrow: [
            /^j/i,
            /^f/i,
            /^m/i,
            /^a/i,
            /^m/i,
            /^j/i,
            /^j/i,
            /^a/i,
            /^s/i,
            /^o/i,
            /^n/i,
            /^d/i,
          ],
          any: [
            /^ja/i,
            /^f/i,
            /^mar/i,
            /^ap/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^au/i,
            /^s/i,
            /^o/i,
            /^n/i,
            /^d/i,
          ],
        },
        defaultParseWidth: 'any',
      }),
      day: c({
        matchPatterns: {
          narrow: /^[smtwf]/i,
          short: /^(su|mo|tu|we|th|fr|sa)/i,
          abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
          wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
        },
        defaultMatchWidth: 'wide',
        parsePatterns: {
          narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
          any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
        },
        defaultParseWidth: 'any',
      }),
      dayPeriod: c({
        matchPatterns: {
          narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
          any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
        },
        defaultMatchWidth: 'any',
        parsePatterns: {
          any: {
            am: /^a/i,
            pm: /^p/i,
            midnight: /^mi/i,
            noon: /^no/i,
            morning: /morning/i,
            afternoon: /afternoon/i,
            evening: /evening/i,
            night: /night/i,
          },
        },
        defaultParseWidth: 'any',
      }),
    },
    options: {weekStartsOn: 0, firstWeekContainsDate: 1},
  };
function f(t) {
  if (null === t || !0 === t || !1 === t) return NaN
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e)
}
function h(t, e) {
  if (e.length < t)
    throw new TypeError(
      t + ' argument' + (t > 1 ? 's' : '') + ' required, but only ' + e.length + ' present',
    )
}
function m(t) {
  h(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || ('object' == typeof t && '[object Date]' === e)
    ? new Date(t.getTime())
    : 'number' == typeof t || '[object Number]' === e
    ? new Date(t)
    : (('string' != typeof t && '[object String]' !== e) ||
        'undefined' == typeof console ||
        (console.warn(
          "Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule",
        ),
        console.warn(new Error().stack)),
      new Date(NaN))
}
function w(t, e) {
  h(2, arguments);
  var n = m(t).getTime(),
    r = f(e);
  return new Date(n + r)
}
function g(t, e) {
  h(2, arguments);
  var n = f(e);
  return w(t, -n)
}
function y(t, e) {
  switch (t) {
    case 'P':
      return e.date({width: 'short'})
    case 'PP':
      return e.date({width: 'medium'})
    case 'PPP':
      return e.date({width: 'long'})
    case 'PPPP':
    default:
      return e.date({width: 'full'})
  }
}
function b(t, e) {
  switch (t) {
    case 'p':
      return e.time({width: 'short'})
    case 'pp':
      return e.time({width: 'medium'})
    case 'ppp':
      return e.time({width: 'long'})
    case 'pppp':
    default:
      return e.time({width: 'full'})
  }
}
var D = {
  p: b,
  P: function (t, e) {
    var n,
      r = t.match(/(P+)(p+)?/),
      a = r[1],
      i = r[2];
    if (!i) return y(t, e)
    switch (a) {
      case 'P':
        n = e.dateTime({width: 'short'});
        break
      case 'PP':
        n = e.dateTime({width: 'medium'});
        break
      case 'PPP':
        n = e.dateTime({width: 'long'});
        break
      case 'PPPP':
      default:
        n = e.dateTime({width: 'full'});
    }
    return n.replace('{{date}}', y(a, e)).replace('{{time}}', b(i, e))
  },
};
function T(t) {
  return t.getTime() % 6e4
}
function p(t) {
  var e = new Date(t.getTime()),
    n = Math.ceil(e.getTimezoneOffset());
  return e.setSeconds(0, 0), 6e4 * n + (n > 0 ? (6e4 + T(e)) % 6e4 : T(e))
}
var k$1 = ['D', 'DD'],
  x = ['YY', 'YYYY'];
function C(t) {
  return -1 !== k$1.indexOf(t)
}
function M(t) {
  return -1 !== x.indexOf(t)
}
function U(t) {
  if ('YYYY' === t)
    throw new RangeError(
      'Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr',
    )
  if ('YY' === t)
    throw new RangeError('Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr')
  if ('D' === t)
    throw new RangeError(
      'Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr',
    )
  if ('DD' === t)
    throw new RangeError(
      'Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr',
    )
}
function S(t, e) {
  h(1, arguments);
  var n = e || {},
    r = n.locale,
    a = r && r.options && r.options.weekStartsOn,
    i = null == a ? 0 : f(a),
    o = null == n.weekStartsOn ? i : f(n.weekStartsOn);
  if (!(o >= 0 && o <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  var u = m(t),
    s = u.getUTCDay(),
    c = (s < o ? 7 : 0) + s - o;
  return u.setUTCDate(u.getUTCDate() - c), u.setUTCHours(0, 0, 0, 0), u
}
function P$2(t, e) {
  h(1, arguments);
  var n = m(t, e),
    r = n.getUTCFullYear(),
    a = e || {},
    i = a.locale,
    o = i && i.options && i.options.firstWeekContainsDate,
    u = null == o ? 1 : f(o),
    s = null == a.firstWeekContainsDate ? u : f(a.firstWeekContainsDate);
  if (!(s >= 1 && s <= 7))
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively')
  var c = new Date(0);
  c.setUTCFullYear(r + 1, 0, s), c.setUTCHours(0, 0, 0, 0);
  var d = S(c, e),
    l = new Date(0);
  l.setUTCFullYear(r, 0, s), l.setUTCHours(0, 0, 0, 0);
  var w = S(l, e);
  return n.getTime() >= d.getTime() ? r + 1 : n.getTime() >= w.getTime() ? r : r - 1
}
function Y(t) {
  h(1, arguments);
  var e = 1,
    n = m(t),
    r = n.getUTCDay(),
    a = (r < e ? 7 : 0) + r - e;
  return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n
}
function N(t) {
  h(1, arguments);
  var e = m(t),
    n = e.getUTCFullYear(),
    r = new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = Y(r),
    i = new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = Y(i);
  return e.getTime() >= a.getTime() ? n + 1 : e.getTime() >= o.getTime() ? n : n - 1
}
function q(t) {
  h(1, arguments);
  var e = N(t),
    n = new Date(0);
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Y(n);
  return r
}
function B(t) {
  h(1, arguments);
  var e = m(t),
    n = Y(e).getTime() - q(e).getTime();
  return Math.round(n / 6048e5) + 1
}
function O(t, e) {
  h(1, arguments);
  var n = e || {},
    r = n.locale,
    a = r && r.options && r.options.firstWeekContainsDate,
    i = null == a ? 1 : f(a),
    o = null == n.firstWeekContainsDate ? i : f(n.firstWeekContainsDate),
    u = P$2(t, e),
    s = new Date(0);
  s.setUTCFullYear(u, 0, o), s.setUTCHours(0, 0, 0, 0);
  var c = S(s, e);
  return c
}
function H$2(t, e) {
  h(1, arguments);
  var n = m(t),
    r = S(n, e).getTime() - O(n, e).getTime();
  return Math.round(r / 6048e5) + 1
}
function Ut(t) {
  h(1, arguments);
  var e = m(t);
  return !isNaN(e)
}
function St$1(t, e) {
  for (var n = t < 0 ? '-' : '', r = Math.abs(t).toString(); r.length < e; ) r = '0' + r;
  return n + r
}
var Pt$1 = function (t, e) {
    var n = t.getUTCFullYear(),
      r = n > 0 ? n : 1 - n;
    return St$1('yy' === e ? r % 100 : r, e.length)
  },
  Et$1 = function (t, e) {
    var n = t.getUTCMonth();
    return 'M' === e ? String(n + 1) : St$1(n + 1, 2)
  },
  Yt$1 = function (t, e) {
    return St$1(t.getUTCDate(), e.length)
  },
  Nt$1 = function (t, e) {
    return St$1(t.getUTCHours() % 12 || 12, e.length)
  },
  qt = function (t, e) {
    return St$1(t.getUTCHours(), e.length)
  },
  Bt$1 = function (t, e) {
    return St$1(t.getUTCMinutes(), e.length)
  },
  Ot$1 = function (t, e) {
    return St$1(t.getUTCSeconds(), e.length)
  },
  Ht = function (t, e) {
    var n = e.length,
      r = t.getUTCMilliseconds();
    return St$1(Math.floor(r * Math.pow(10, n - 3)), e.length)
  };
var Lt$1 = 'midnight',
  Wt$1 = 'noon',
  Ft$1 = 'morning',
  Qt = 'afternoon',
  Rt$1 = 'evening',
  It$1 = 'night',
  Xt = {
    G: function (t, e, n) {
      var r = t.getUTCFullYear() > 0 ? 1 : 0;
      switch (e) {
        case 'G':
        case 'GG':
        case 'GGG':
          return n.era(r, {width: 'abbreviated'})
        case 'GGGGG':
          return n.era(r, {width: 'narrow'})
        case 'GGGG':
        default:
          return n.era(r, {width: 'wide'})
      }
    },
    y: function (t, e, n) {
      if ('yo' === e) {
        var r = t.getUTCFullYear(),
          a = r > 0 ? r : 1 - r;
        return n.ordinalNumber(a, {unit: 'year'})
      }
      return Pt$1(t, e)
    },
    Y: function (t, e, n, r) {
      var a = P$2(t, r),
        i = a > 0 ? a : 1 - a;
      return 'YY' === e
        ? St$1(i % 100, 2)
        : 'Yo' === e
        ? n.ordinalNumber(i, {unit: 'year'})
        : St$1(i, e.length)
    },
    R: function (t, e) {
      return St$1(N(t), e.length)
    },
    u: function (t, e) {
      return St$1(t.getUTCFullYear(), e.length)
    },
    Q: function (t, e, n) {
      var r = Math.ceil((t.getUTCMonth() + 1) / 3);
      switch (e) {
        case 'Q':
          return String(r)
        case 'QQ':
          return St$1(r, 2)
        case 'Qo':
          return n.ordinalNumber(r, {unit: 'quarter'})
        case 'QQQ':
          return n.quarter(r, {width: 'abbreviated', context: 'formatting'})
        case 'QQQQQ':
          return n.quarter(r, {width: 'narrow', context: 'formatting'})
        case 'QQQQ':
        default:
          return n.quarter(r, {width: 'wide', context: 'formatting'})
      }
    },
    q: function (t, e, n) {
      var r = Math.ceil((t.getUTCMonth() + 1) / 3);
      switch (e) {
        case 'q':
          return String(r)
        case 'qq':
          return St$1(r, 2)
        case 'qo':
          return n.ordinalNumber(r, {unit: 'quarter'})
        case 'qqq':
          return n.quarter(r, {width: 'abbreviated', context: 'standalone'})
        case 'qqqqq':
          return n.quarter(r, {width: 'narrow', context: 'standalone'})
        case 'qqqq':
        default:
          return n.quarter(r, {width: 'wide', context: 'standalone'})
      }
    },
    M: function (t, e, n) {
      var r = t.getUTCMonth();
      switch (e) {
        case 'M':
        case 'MM':
          return Et$1(t, e)
        case 'Mo':
          return n.ordinalNumber(r + 1, {unit: 'month'})
        case 'MMM':
          return n.month(r, {width: 'abbreviated', context: 'formatting'})
        case 'MMMMM':
          return n.month(r, {width: 'narrow', context: 'formatting'})
        case 'MMMM':
        default:
          return n.month(r, {width: 'wide', context: 'formatting'})
      }
    },
    L: function (t, e, n) {
      var r = t.getUTCMonth();
      switch (e) {
        case 'L':
          return String(r + 1)
        case 'LL':
          return St$1(r + 1, 2)
        case 'Lo':
          return n.ordinalNumber(r + 1, {unit: 'month'})
        case 'LLL':
          return n.month(r, {width: 'abbreviated', context: 'standalone'})
        case 'LLLLL':
          return n.month(r, {width: 'narrow', context: 'standalone'})
        case 'LLLL':
        default:
          return n.month(r, {width: 'wide', context: 'standalone'})
      }
    },
    w: function (t, e, n, r) {
      var a = H$2(t, r);
      return 'wo' === e ? n.ordinalNumber(a, {unit: 'week'}) : St$1(a, e.length)
    },
    I: function (t, e, n) {
      var r = B(t);
      return 'Io' === e ? n.ordinalNumber(r, {unit: 'week'}) : St$1(r, e.length)
    },
    d: function (t, e, n) {
      return 'do' === e ? n.ordinalNumber(t.getUTCDate(), {unit: 'date'}) : Yt$1(t, e)
    },
    D: function (t, e, n) {
      var r = (function (t) {
        h(1, arguments);
        var e = m(t),
          n = e.getTime();
        e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
        var r = e.getTime(),
          a = n - r;
        return Math.floor(a / 864e5) + 1
      })(t);
      return 'Do' === e ? n.ordinalNumber(r, {unit: 'dayOfYear'}) : St$1(r, e.length)
    },
    E: function (t, e, n) {
      var r = t.getUTCDay();
      switch (e) {
        case 'E':
        case 'EE':
        case 'EEE':
          return n.day(r, {width: 'abbreviated', context: 'formatting'})
        case 'EEEEE':
          return n.day(r, {width: 'narrow', context: 'formatting'})
        case 'EEEEEE':
          return n.day(r, {width: 'short', context: 'formatting'})
        case 'EEEE':
        default:
          return n.day(r, {width: 'wide', context: 'formatting'})
      }
    },
    e: function (t, e, n, r) {
      var a = t.getUTCDay(),
        i = (a - r.weekStartsOn + 8) % 7 || 7;
      switch (e) {
        case 'e':
          return String(i)
        case 'ee':
          return St$1(i, 2)
        case 'eo':
          return n.ordinalNumber(i, {unit: 'day'})
        case 'eee':
          return n.day(a, {width: 'abbreviated', context: 'formatting'})
        case 'eeeee':
          return n.day(a, {width: 'narrow', context: 'formatting'})
        case 'eeeeee':
          return n.day(a, {width: 'short', context: 'formatting'})
        case 'eeee':
        default:
          return n.day(a, {width: 'wide', context: 'formatting'})
      }
    },
    c: function (t, e, n, r) {
      var a = t.getUTCDay(),
        i = (a - r.weekStartsOn + 8) % 7 || 7;
      switch (e) {
        case 'c':
          return String(i)
        case 'cc':
          return St$1(i, e.length)
        case 'co':
          return n.ordinalNumber(i, {unit: 'day'})
        case 'ccc':
          return n.day(a, {width: 'abbreviated', context: 'standalone'})
        case 'ccccc':
          return n.day(a, {width: 'narrow', context: 'standalone'})
        case 'cccccc':
          return n.day(a, {width: 'short', context: 'standalone'})
        case 'cccc':
        default:
          return n.day(a, {width: 'wide', context: 'standalone'})
      }
    },
    i: function (t, e, n) {
      var r = t.getUTCDay(),
        a = 0 === r ? 7 : r;
      switch (e) {
        case 'i':
          return String(a)
        case 'ii':
          return St$1(a, e.length)
        case 'io':
          return n.ordinalNumber(a, {unit: 'day'})
        case 'iii':
          return n.day(r, {width: 'abbreviated', context: 'formatting'})
        case 'iiiii':
          return n.day(r, {width: 'narrow', context: 'formatting'})
        case 'iiiiii':
          return n.day(r, {width: 'short', context: 'formatting'})
        case 'iiii':
        default:
          return n.day(r, {width: 'wide', context: 'formatting'})
      }
    },
    a: function (t, e, n) {
      var r = t.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
      switch (e) {
        case 'a':
        case 'aa':
        case 'aaa':
          return n.dayPeriod(r, {width: 'abbreviated', context: 'formatting'})
        case 'aaaaa':
          return n.dayPeriod(r, {width: 'narrow', context: 'formatting'})
        case 'aaaa':
        default:
          return n.dayPeriod(r, {width: 'wide', context: 'formatting'})
      }
    },
    b: function (t, e, n) {
      var r,
        a = t.getUTCHours();
      switch (((r = 12 === a ? Wt$1 : 0 === a ? Lt$1 : a / 12 >= 1 ? 'pm' : 'am'), e)) {
        case 'b':
        case 'bb':
        case 'bbb':
          return n.dayPeriod(r, {width: 'abbreviated', context: 'formatting'})
        case 'bbbbb':
          return n.dayPeriod(r, {width: 'narrow', context: 'formatting'})
        case 'bbbb':
        default:
          return n.dayPeriod(r, {width: 'wide', context: 'formatting'})
      }
    },
    B: function (t, e, n) {
      var r,
        a = t.getUTCHours();
      switch (((r = a >= 17 ? Rt$1 : a >= 12 ? Qt : a >= 4 ? Ft$1 : It$1), e)) {
        case 'B':
        case 'BB':
        case 'BBB':
          return n.dayPeriod(r, {width: 'abbreviated', context: 'formatting'})
        case 'BBBBB':
          return n.dayPeriod(r, {width: 'narrow', context: 'formatting'})
        case 'BBBB':
        default:
          return n.dayPeriod(r, {width: 'wide', context: 'formatting'})
      }
    },
    h: function (t, e, n) {
      if ('ho' === e) {
        var r = t.getUTCHours() % 12;
        return 0 === r && (r = 12), n.ordinalNumber(r, {unit: 'hour'})
      }
      return Nt$1(t, e)
    },
    H: function (t, e, n) {
      return 'Ho' === e ? n.ordinalNumber(t.getUTCHours(), {unit: 'hour'}) : qt(t, e)
    },
    K: function (t, e, n) {
      var r = t.getUTCHours() % 12;
      return 'Ko' === e ? n.ordinalNumber(r, {unit: 'hour'}) : St$1(r, e.length)
    },
    k: function (t, e, n) {
      var r = t.getUTCHours();
      return 0 === r && (r = 24), 'ko' === e ? n.ordinalNumber(r, {unit: 'hour'}) : St$1(r, e.length)
    },
    m: function (t, e, n) {
      return 'mo' === e ? n.ordinalNumber(t.getUTCMinutes(), {unit: 'minute'}) : Bt$1(t, e)
    },
    s: function (t, e, n) {
      return 'so' === e ? n.ordinalNumber(t.getUTCSeconds(), {unit: 'second'}) : Ot$1(t, e)
    },
    S: function (t, e) {
      return Ht(t, e)
    },
    X: function (t, e, n, r) {
      var a = (r._originalDate || t).getTimezoneOffset();
      if (0 === a) return 'Z'
      switch (e) {
        case 'X':
          return At$1(a)
        case 'XXXX':
        case 'XX':
          return zt(a)
        case 'XXXXX':
        case 'XXX':
        default:
          return zt(a, ':')
      }
    },
    x: function (t, e, n, r) {
      var a = (r._originalDate || t).getTimezoneOffset();
      switch (e) {
        case 'x':
          return At$1(a)
        case 'xxxx':
        case 'xx':
          return zt(a)
        case 'xxxxx':
        case 'xxx':
        default:
          return zt(a, ':')
      }
    },
    O: function (t, e, n, r) {
      var a = (r._originalDate || t).getTimezoneOffset();
      switch (e) {
        case 'O':
        case 'OO':
        case 'OOO':
          return 'GMT' + Gt(a, ':')
        case 'OOOO':
        default:
          return 'GMT' + zt(a, ':')
      }
    },
    z: function (t, e, n, r) {
      var a = (r._originalDate || t).getTimezoneOffset();
      switch (e) {
        case 'z':
        case 'zz':
        case 'zzz':
          return 'GMT' + Gt(a, ':')
        case 'zzzz':
        default:
          return 'GMT' + zt(a, ':')
      }
    },
    t: function (t, e, n, r) {
      var a = r._originalDate || t;
      return St$1(Math.floor(a.getTime() / 1e3), e.length)
    },
    T: function (t, e, n, r) {
      return St$1((r._originalDate || t).getTime(), e.length)
    },
  };
function Gt(t, e) {
  var n = t > 0 ? '-' : '+',
    r = Math.abs(t),
    a = Math.floor(r / 60),
    i = r % 60;
  if (0 === i) return n + String(a)
  var o = e || '';
  return n + String(a) + o + St$1(i, 2)
}
function At$1(t, e) {
  return t % 60 == 0 ? (t > 0 ? '-' : '+') + St$1(Math.abs(t) / 60, 2) : zt(t, e)
}
function zt(t, e) {
  var n = e || '',
    r = t > 0 ? '-' : '+',
    a = Math.abs(t);
  return r + St$1(Math.floor(a / 60), 2) + n + St$1(a % 60, 2)
}
var jt$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
  Kt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
  Jt = /^'([^]*?)'?$/,
  Zt = /''/g,
  _t$1 = /[a-zA-Z]/;
function $t(t, e, n) {
  h(2, arguments);
  var r = String(e),
    a = n || {},
    i = a.locale || l,
    o = i.options && i.options.firstWeekContainsDate,
    u = null == o ? 1 : f(o),
    s = null == a.firstWeekContainsDate ? u : f(a.firstWeekContainsDate);
  if (!(s >= 1 && s <= 7))
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively')
  var c = i.options && i.options.weekStartsOn,
    d = null == c ? 0 : f(c),
    w = null == a.weekStartsOn ? d : f(a.weekStartsOn);
  if (!(w >= 0 && w <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  if (!i.localize) throw new RangeError('locale must contain localize property')
  if (!i.formatLong) throw new RangeError('locale must contain formatLong property')
  var v = m(t);
  if (!Ut(v)) throw new RangeError('Invalid time value')
  var y = p(v),
    b = g(v, y),
    T = {firstWeekContainsDate: s, weekStartsOn: w, locale: i, _originalDate: v},
    k = r
      .match(Kt)
      .map(function (t) {
        var e = t[0];
        return 'p' === e || 'P' === e ? (0, D[e])(t, i.formatLong, T) : t
      })
      .join('')
      .match(jt$1)
      .map(function (t) {
        if ("''" === t) return "'"
        var e = t[0];
        if ("'" === e) return Vt(t)
        var n = Xt[e];
        if (n)
          return (
            !a.useAdditionalWeekYearTokens && M(t) && U(t),
            !a.useAdditionalDayOfYearTokens && C(t) && U(t),
            n(b, t, i.localize, T)
          )
        if (e.match(_t$1))
          throw new RangeError(
            'Format string contains an unescaped latin alphabet character `' + e + '`',
          )
        return t
      })
      .join('');
  return k
}
function Vt(t) {
  return t.match(Jt)[1].replace(Zt, "'")
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function te(
  t,
  e,
) {
  h(2, arguments);
  var n = m(t),
    r = f(e);
  return isNaN(r) ? new Date(NaN) : r ? (n.setDate(n.getDate() + r), n) : n
}
function ee(t, e) {
  h(1, arguments);
  var n = t || {},
    r = m(n.start),
    a = m(n.end),
    i = a.getTime();
  if (!(r.getTime() <= i)) throw new RangeError('Invalid interval')
  var o = [],
    u = r;
  u.setHours(0, 0, 0, 0);
  var s = e && 'step' in e ? Number(e.step) : 1;
  if (s < 1 || isNaN(s)) throw new RangeError('`options.step` must be a number greater than 1')
  for (; u.getTime() <= i; ) o.push(m(u)), u.setDate(u.getDate() + s), u.setHours(0, 0, 0, 0);
  return o
}
function ne(t, e) {
  h(1, arguments);
  var n = e || {},
    r = n.locale,
    a = r && r.options && r.options.weekStartsOn,
    i = null == a ? 0 : f(a),
    o = null == n.weekStartsOn ? i : f(n.weekStartsOn);
  if (!(o >= 0 && o <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  var u = m(t),
    s = u.getDay(),
    c = 6 + (s < o ? -7 : 0) - (s - o);
  return u.setDate(u.getDate() + c), u.setHours(23, 59, 59, 999), u
}
function re(t) {
  h(1, arguments);
  var e = m(t);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e
}
function ae$1(t, e) {
  h(1, arguments);
  var n = e || {},
    r = n.locale,
    a = r && r.options && r.options.weekStartsOn,
    i = null == a ? 0 : f(a),
    o = null == n.weekStartsOn ? i : f(n.weekStartsOn);
  if (!(o >= 0 && o <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  var u = m(t),
    s = u.getDay(),
    c = (s < o ? 7 : 0) + s - o;
  return u.setDate(u.getDate() - c), u.setHours(0, 0, 0, 0), u
}
function ie$1(t) {
  var e = void 0 === t ? {} : t,
    n = e.firstDayOfWeek,
    r = void 0 === n ? 1 : n,
    a = e.weekdayLabelFormat,
    i =
      void 0 === a
        ? function (t) {
            return $t(t, 'iiiiii')
          }
        : a,
    o = new Date();
  return ee({start: te(ae$1(o), r), end: te(ne(o), r)}).reduce(function (t, e) {
    return t.push(i(e)), t
  }, [])
}
function oe$1(t) {
  var e = t.year,
    n = t.month,
    r = t.firstDayOfWeek,
    a = void 0 === r ? 1 : r,
    i = t.dayLabelFormat,
    o =
      void 0 === i
        ? function (t) {
            return $t(t, 'dd')
          }
        : i,
    u = new Date(e, n),
    s = re(u),
    c = (function (t) {
      h(1, arguments);
      var e = m(t),
        n = e.getDay();
      return n
    })(s),
    d = (function (t) {
      h(1, arguments);
      var e = m(t),
        n = e.getMonth();
      return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e
    })(u);
  return (function () {
    for (var t = 0, e = 0, n = arguments.length; e < n; e++) t += arguments[e].length;
    var r = Array(t),
      a = 0;
    for (e = 0; e < n; e++)
      for (var i = arguments[e], o = 0, u = i.length; o < u; o++, a++) r[a] = i[o];
    return r
  })(
    Array.from(Array(c >= a ? c - a : 6 - a + c + 1).keys()).fill(0),
    ee({start: s, end: d}).map(function (t) {
      return {date: t, dayLabel: o(t)}
    }),
  )
}
var ue$1 = function (t) {
    return $t(t, 'dd')
  },
  se$1 = function (t) {
    return $t(t, 'eeeeee')
  },
  ce$1 = function (t) {
    return $t(t, 'MMMM yyyy')
  };
function de$1(e) {
  var n = e.year,
    r = e.month,
    a = e.firstDayOfWeek,
    i = void 0 === a ? 1 : a,
    o = e.dayLabelFormat,
    u = void 0 === o ? ue$1 : o,
    s = e.weekdayLabelFormat,
    c = void 0 === s ? se$1 : s,
    d = e.monthLabelFormat,
    l = void 0 === d ? ce$1 : d;
  return {
    days: useMemo(
      function () {
        return oe$1({year: n, month: r, firstDayOfWeek: i, dayLabelFormat: u})
      },
      [n, r, i, u],
    ),
    weekdayLabels: useMemo(
      function () {
        return ie$1({firstDayOfWeek: i, weekdayLabelFormat: c})
      },
      [i, c],
    ),
    monthLabel: l(new Date(n, r)),
  }
}
function le$1(t, e) {
  h(2, arguments);
  var n = m(t),
    r = m(e);
  return n.getTime() < r.getTime()
}
function fe$1(t, e) {
  h(2, arguments);
  var n = m(t),
    r = m(e);
  return n.getTime() > r.getTime()
}
function he$1(t, e) {
  h(2, arguments);
  var n = e || {},
    r = m(t).getTime(),
    a = m(n.start).getTime(),
    i = m(n.end).getTime();
  if (!(a <= i)) throw new RangeError('Invalid interval')
  return r >= a && r <= i
}
function me$1(t) {
  h(1, arguments);
  var e = m(t);
  return e.setHours(0, 0, 0, 0), e
}
function we$1(t, e) {
  h(2, arguments);
  var n = me$1(t),
    r = me$1(e);
  return n.getTime() === r.getTime()
}
function ge$1(t, e) {
  h(2, arguments);
  var n = m(t),
    r = f(e);
  if (isNaN(r)) return new Date(NaN)
  if (!r) return n
  var a = n.getDate(),
    i = new Date(n.getTime());
  i.setMonth(n.getMonth() + r + 1, 0);
  var o = i.getDate();
  return a >= o ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), a), n)
}
var ve$1 = function (t, e) {
  return (
    void 0 === t && (t = []),
    t.some(function (t) {
      return we$1(e, t)
    })
  )
};
function ye$1(t, e, n) {
  return !(!e || !n) && he$1(t, {start: e, end: n})
}
function be$1(t, e, n) {
  return !!((e && we$1(t, e)) || (n && we$1(t, n)))
}
function De$1(t, e) {
  return !(!e || !we$1(t, e))
}
function Te$1(t, e) {
  return !(!e || !we$1(t, e))
}
function pe$1(t) {
  var e = t.date,
    n = t.minBookingDate,
    r = t.maxBookingDate,
    a = t.isDateBlockedFn,
    i = t.startDate,
    o = t.endDate,
    u = t.minBookingDays,
    s = void 0 === u ? 1 : u,
    c = t.unavailableDates,
    d = void 0 === c ? [] : c,
    l = n ? new Date(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0, 0) : n,
    f = r ? new Date(r.getFullYear(), r.getMonth(), r.getDate(), 0, 0, 0) : r;
  return !!(
    ve$1(d, e) ||
    (l && le$1(e, l)) ||
    (f && fe$1(e, f)) ||
    (i && !o && s > 1 && he$1(e, {start: i, end: te(i, s - 2)})) ||
    (a && a(e))
  )
}
function ke$1(t) {
  var e = re(t);
  return {
    year: (function (t) {
      h(1, arguments);
      var e = m(t),
        n = e.getFullYear();
      return n
    })(e),
    month: (function (t) {
      h(1, arguments);
      var e = m(t),
        n = e.getMonth();
      return n
    })(e),
    date: e,
  }
}
function xe$1() {
  return ke$1(me$1(Date.now()))
}
function Ce$1(t, e) {
  var n = e ? ke$1(e) : xe$1(),
    r = n.date,
    a = [n];
  return (
    t > 1 &&
      (a = Array.from(Array(t - 1).keys()).reduce(function (t) {
        return (r = ge$1(t[t.length - 1].date, 1)), t.concat([ke$1(r)])
      }, a)),
    a
  )
}
function Me$1(t, e, n, r) {
  var a = t[r ? (n > 0 ? 0 : t.length - r) : n > 0 ? t.length - 1 : 0].date;
  return Array.from(Array(e).keys()).reduce(function (t) {
    return (
      (a = 0 === t.length ? ge$1(a, n) : ge$1(a, n >= 0 ? 1 : -1)),
      n > 0 ? t.concat([ke$1(a)]) : [ke$1(a)].concat(t)
    )
  }, [])
}
function Se$1(t) {
  var e = t.startDate,
    n = t.endDate,
    r = t.isDateBlocked,
    a = t.minBookingDays,
    i = t.exactMinBookingDays,
    o = t.minBookingDate,
    u = t.maxBookingDate,
    s = !o || !le$1(e, te(o, -1)),
    c = !u || !fe$1(te(e, a - 1), u);
  return (
    !(!e || 1 !== a || n || r(e)) ||
    ((e && a > 1 && !n && !i) || (e && a > 0 && i && s && c) || (e && a > 0 && i && !o && !u)
      ? !ee({start: e, end: te(e, a - 1)}).some(function (t) {
          return r(t)
        })
      : !(!e || !n || i) &&
        !le$1(n, te(e, a - 1)) &&
        !ee({start: e, end: n}).some(function (t) {
          return r(t)
        }))
  )
}
var Pe$1 = 'startDate';
function Ye$1(t) {
  var a = t.startDate,
    i = t.endDate,
    o = t.focusedInput,
    u = t.minBookingDate,
    s = t.maxBookingDate,
    c = t.onDatesChange,
    d = t.initialVisibleMonth,
    l = t.exactMinBookingDays,
    f = void 0 !== l && l,
    h = t.minBookingDays,
    m = void 0 === h ? 1 : h,
    w = t.numberOfMonths,
    g = void 0 === w ? 2 : w,
    v = t.firstDayOfWeek,
    y = void 0 === v ? 1 : v,
    b = t.isDateBlocked,
    D =
      void 0 === b
        ? function () {
            return !1
          }
        : b,
    T = t.unavailableDates,
    p = void 0 === T ? [] : T,
    k = t.changeActiveMonthOnSelect,
    x = void 0 === k || k,
    C = useState(function () {
      return Ce$1(g, a || d || null)
    }),
    M = C[0],
    U = C[1],
    S = useState(null),
    P = S[0],
    E = S[1],
    Y = useState(a),
    N = Y[0],
    q = Y[1];
  useEffect(function () {
    return (
      'undefined' != typeof window &&
        window.addEventListener &&
        window.addEventListener('keydown', L),
      function () {
        window.removeEventListener && window.removeEventListener('keydown', L);
      }
    )
  });
  var B = function (t) {
      return ve$1(p, t) || D(t)
    },
    O = function (t) {
      q(t), (!N || (N && !we$1(t, N))) && U(Ce$1(g, t));
    },
    H = function (t) {
      return pe$1({
        date: t,
        minBookingDate: u,
        maxBookingDate: s,
        startDate: a,
        endDate: i,
        minBookingDays: m,
        isDateBlockedFn: B,
      })
    };
  function L(t) {
    if (
      ('ArrowRight' === t.key ||
        'ArrowLeft' === t.key ||
        'ArrowDown' === t.key ||
        'ArrowUp' === t.key) &&
      !N
    ) {
      var e = M[0];
      O(e.date), U(Ce$1(g, e.date));
    }
  }
  var W = useCallback(
      function () {
        U(Me$1(M, g, -1)), q(null);
      },
      [M, g],
    ),
    F = useCallback(
      function () {
        U(Me$1(M, g, -1, 1)), q(null);
      },
      [M, g],
    ),
    Q = useCallback(
      function () {
        U(Me$1(M, g, 1)), q(null);
      },
      [M, g],
    ),
    R = useCallback(
      function () {
        U(Me$1(M, g, 1, 1)), q(null);
      },
      [M, g],
    ),
    I = useCallback(
      function (t) {
        U(Ce$1(g, t)), q(null);
      },
      [g],
    ),
    X = useCallback(
      function (t) {
        void 0 === t && (t = 1), U(Me$1(M, g, -(12 * t - g + 1))), q(null);
      },
      [M, g],
    ),
    G = useCallback(
      function (t) {
        void 0 === t && (t = 1), U(Me$1(M, g, 12 * t - g + 1)), q(null);
      },
      [M, g],
    );
  return {
    firstDayOfWeek: y,
    activeMonths: M,
    isDateSelected: function (t) {
      return ye$1(t, a, i)
    },
    isDateHovered: function (t) {
      return (function (t) {
        var e = t.date,
          n = t.startDate,
          r = t.endDate,
          a = t.isDateBlocked,
          i = t.hoveredDate,
          o = t.minBookingDays,
          u = t.exactMinBookingDays;
        return i && o > 1 && u && he$1(e, {start: i, end: te(i, o - 1)})
          ? !ee({start: i, end: te(i, o - 1)}).some(function (t) {
              return a(t)
            })
          : n && !r && i && he$1(e, {start: n, end: te(n, o - 1)}) && we$1(n, i) && o > 1
          ? !ee({start: n, end: te(n, o - 1)}).some(function (t) {
              return a(t)
            })
          : !(!n || r || !i || le$1(i, n) || !he$1(e, {start: n, end: i})) &&
            !ee({start: n, end: i}).some(function (t) {
              return a(t)
            })
      })({
        date: t,
        hoveredDate: P,
        startDate: a,
        endDate: i,
        minBookingDays: m,
        exactMinBookingDays: f,
        isDateBlocked: B,
      })
    },
    isFirstOrLastSelectedDate: function (t) {
      return be$1(t, a, i)
    },
    isStartDate: function (t) {
      return De$1(t, a)
    },
    isEndDate: function (t) {
      return Te$1(t, i)
    },
    isDateBlocked: H,
    numberOfMonths: g,
    isDateFocused: function (t) {
      return !!N && we$1(t, N)
    },
    focusedDate: N,
    hoveredDate: P,
    onResetDates: function () {
      c({startDate: null, endDate: null, focusedInput: 'startDate'});
    },
    onDateHover: function (t) {
      if (t) {
        if (t) {
          var e = !H(t) || (a && we$1(t, a)),
            n = !u || !le$1(t, te(u, -1)),
            r = !s || !fe$1(t, s),
            o = te(t, m - 1),
            c = !u || !le$1(o, u),
            d = !s || !fe$1(o, s),
            l = f && m > 1 && n && r && c && d,
            h = a && !i && !f && n && r,
            w = !(m > 1 && a) || he$1(t, {start: a, end: te(a, m - 2)}),
            g = a && we$1(t, a) && w;
          e && (l || h || g) ? E(t) : null !== P && E(null);
        }
      } else E(null);
    },
    onDateSelect: function (t) {
('endDate' === o || 'startDate' === o) &&
      m > 0 &&
      f &&
      Se$1({
        minBookingDays: m,
        exactMinBookingDays: f,
        minBookingDate: u,
        maxBookingDate: s,
        isDateBlocked: B,
        startDate: t,
        endDate: null,
      })
        ? c({startDate: t, endDate: te(t, m - 1), focusedInput: null})
        : (('endDate' === o && a && le$1(t, a)) || ('startDate' === o && i && fe$1(t, i))) &&
          !f &&
          Se$1({minBookingDays: m, isDateBlocked: B, startDate: t, endDate: null})
        ? c({endDate: null, startDate: t, focusedInput: 'endDate'})
        : 'startDate' === o &&
          !f &&
          Se$1({minBookingDays: m, isDateBlocked: B, endDate: i, startDate: t})
        ? c({endDate: i, startDate: t, focusedInput: 'endDate'})
        : 'startDate' === o &&
          !f &&
          Se$1({minBookingDays: m, isDateBlocked: B, endDate: null, startDate: t})
        ? c({endDate: null, startDate: t, focusedInput: 'endDate'})
        : 'endDate' === o &&
          a &&
          !le$1(t, a) &&
          !f &&
          Se$1({minBookingDays: m, isDateBlocked: B, startDate: a, endDate: t}) &&
          c({startDate: a, endDate: t, focusedInput: null}),
        'endDate' !== o && (!N || (N && !we$1(t, N))) && x && U(Ce$1(g, t));
    },
    onDateFocus: O,
    goToPreviousMonths: W,
    goToPreviousMonthsByOneMonth: F,
    goToNextMonths: Q,
    goToNextMonthsByOneMonth: R,
    goToDate: I,
    goToPreviousYear: X,
    goToNextYear: G,
  }
}
function Ne$1(t) {
  var e = t.date,
    n = t.focusedDate,
    a = t.isDateSelected,
    i = t.isDateFocused,
    o = t.isFirstOrLastSelectedDate,
    u = t.isDateHovered,
    s = t.isDateBlocked,
    c = t.onDateSelect,
    d = t.onDateFocus,
    l = t.onDateHover,
    f = useCallback(
      function () {
        return c(e)
      },
      [e, c],
    ),
    h = useCallback(
      function () {
        return l(e)
      },
      [e, l],
    ),
    m = s(e) && !u(e);
  return {
    tabIndex: null === n || i(e) ? 0 : -1,
    isSelected: a(e),
    isSelectedStartOrEnd: o(e),
    isWithinHoverRange: u(e),
    disabledDate: m,
    onKeyDown: function (t) {
      'ArrowRight' === t.key
        ? d(te(e, 1))
        : 'ArrowLeft' === t.key
        ? d(te(e, -1))
        : 'ArrowUp' === t.key
        ? d(te(e, -7))
        : 'ArrowDown' === t.key && d(te(e, 7));
    },
    onClick: m ? function () {} : f,
    onMouseEnter: h,
  }
}

var datepickerContextDefaultValue = {
  focusedDate: null,
  onDateFocus: function onDateFocus() {},
  onDateHover: function onDateHover() {},
  onDateSelect: function onDateSelect() {}
};
var DatePickerContextInner = /*#__PURE__*/React__default.createContext(datepickerContextDefaultValue);

var getColor = function getColor(isSelected, isSelectedStartOrEnd, isWithinHoverRange, isDisabled, range) {
  if (isSelectedStartOrEnd) {
    return {
      type: '4',
      variant: 'neutral',
      modifier: 'inverted',
      align: 'center',
      weight: 'regular',
      buttonVariant: 'startOrEnd'
    };
  } else if (isSelected) {
    return {
      type: '4',
      variant: 'neutral',
      modifier: 'strong',
      align: 'center',
      weight: 'regular',
      buttonVariant: 'selected'
    };
  } else if (isWithinHoverRange && range) {
    return {
      type: '4',
      variant: 'neutral',
      modifier: 'strong',
      align: 'center',
      weight: 'regular',
      buttonVariant: 'inrange'
    };
  } else if (isDisabled) {
    return {
      type: '4',
      variant: 'neutral',
      modifier: 'weak',
      align: 'center',
      weight: 'regular',
      buttonVariant: 'disabled'
    };
  } else {
    return {
      type: '4',
      variant: 'neutral',
      modifier: 'strong',
      align: 'center',
      weight: 'regular',
      buttonVariant: 'normal'
    };
  }
};

var _excluded$c = ["range"],
  _excluded2$1 = ["buttonVariant"];
function Day$1(_ref) {
  var label = _ref.label,
    date = _ref.date,
    isStartOrEndOfRowGrid = _ref.isStartOrEndOfRowGrid;
  var dayRef = useRef(null);
  var _useContext = useContext(DatePickerContextInner),
    range = _useContext.range,
    context = _objectWithoutProperties(_useContext, _excluded$c);
  var _useDay = Ne$1(_objectSpread2(_objectSpread2({
      date: date
    }, context), {}, {
      dayRef: dayRef
    })),
    isSelected = _useDay.isSelected,
    isSelectedStartOrEnd = _useDay.isSelectedStartOrEnd,
    isWithinHoverRange = _useDay.isWithinHoverRange,
    disabledDate = _useDay.disabledDate,
    onClick = _useDay.onClick,
    onKeyDown = _useDay.onKeyDown,
    onMouseEnter = _useDay.onMouseEnter,
    tabIndex = _useDay.tabIndex;
  if (!label) {
    return /*#__PURE__*/React__default.createElement("div", null);
  }
  var _getColor = getColor(isSelected, isSelectedStartOrEnd, isWithinHoverRange, disabledDate, range),
    buttonVariant = _getColor.buttonVariant,
    spanProps = _objectWithoutProperties(_getColor, _excluded2$1);
  var isStartDate = context.isStartDate(date);
  var isEndDate = context.isEndDate(date);
  return /*#__PURE__*/React__default.createElement(Day, {
    className: buttonVariant,
    isStartDate: isStartDate,
    isEndDate: isEndDate,
    range: range
  }, /*#__PURE__*/React__default.createElement(DayContent, {
    onClick: onClick,
    onKeyDown: onKeyDown,
    onMouseEnter: onMouseEnter,
    tabIndex: tabIndex,
    type: "button",
    ref: dayRef,
    variant: buttonVariant,
    isStartOrEndOfRowGrid: isStartOrEndOfRowGrid
  }, /*#__PURE__*/React__default.createElement(Span$1, spanProps, label)));
}

var dayOfWeek = {
  Mo: 'L',
  Tu: 'M',
  We: 'M',
  Th: 'J',
  Fr: 'V',
  Sa: 'S',
  Su: 'D'
};
var monthName = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
var isStartOrEndOfRowGrid = function isStartOrEndOfRowGrid(index) {
  var rest = (index + 1) % 7;
  if (index === 0 || rest === 1) return 'startRowGrid';
  if (rest === 0) return 'endRowGrid';
  return false;
};
function Month$2(_ref) {
  var year = _ref.year,
    month = _ref.month,
    firstDayOfWeek = _ref.firstDayOfWeek;
  var _useMonth = de$1({
      year: year,
      month: month,
      firstDayOfWeek: firstDayOfWeek
    }),
    days = _useMonth.days,
    weekdayLabels = _useMonth.weekdayLabels;
  return /*#__PURE__*/React__default.createElement(DatePickerGrid, {
    months: 2
  }, /*#__PURE__*/React__default.createElement(DatePickerHeader, null, /*#__PURE__*/React__default.createElement(Span$1, {
    type: "4",
    variant: "primary",
    modifier: "strong",
    align: "center"
  }, "".concat(monthName[month], " ").concat(year))), /*#__PURE__*/React__default.createElement(DatePickerWeek, null, weekdayLabels.map(function (dayLabel) {
    return /*#__PURE__*/React__default.createElement(DatePickerWeekContent, {
      key: dayLabel
    }, /*#__PURE__*/React__default.createElement(Span$1, {
      type: "4",
      variant: "disabled",
      align: "center"
    }, dayOfWeek[dayLabel]));
  })), /*#__PURE__*/React__default.createElement(DayGrid, null, days.map(function (day, index) {
    if (_typeof(day) === 'object') {
      return /*#__PURE__*/React__default.createElement(Day$1, {
        date: day.date,
        key: day.date.toString(),
        label: day.dayLabel,
        isStartOrEndOfRowGrid: isStartOrEndOfRowGrid(index)
      });
    }
    return /*#__PURE__*/React__default.createElement("div", {
      key: index
    });
  })));
}

var _excluded$d = ["focusedInput"],
  _excluded2$2 = ["firstDayOfWeek", "activeMonths", "focusedDate", "goToPreviousMonths", "goToNextMonths"];
var DatePickerContainer = function DatePickerContainer(_ref) {
  var onChange = _ref.onChange,
    value = _ref.value,
    minBookingDate = _ref.minBookingDate,
    maxBookingDate = _ref.maxBookingDate,
    range = _ref.range,
    _ref$numberOfMonths = _ref.numberOfMonths,
    numberOfMonths = _ref$numberOfMonths === void 0 ? 2 : _ref$numberOfMonths;
  var _useState = useState(Pe$1),
    _useState2 = _slicedToArray(_useState, 2),
    focusedInput = _useState2[0],
    setFocusedInput = _useState2[1];
  var onDatesChange = function onDatesChange(_ref2) {
    var focusedInput = _ref2.focusedInput,
      data = _objectWithoutProperties(_ref2, _excluded$d);
    onChange && onChange(data);
    if (range) {
      setFocusedInput(focusedInput || Pe$1);
    }
  };
  var _useDatepicker = Ye$1(_objectSpread2(_objectSpread2({}, value), {}, {
      minBookingDate: minBookingDate,
      maxBookingDate: maxBookingDate,
      onDatesChange: onDatesChange,
      focusedInput: focusedInput,
      numberOfMonths: numberOfMonths
    })),
    firstDayOfWeek = _useDatepicker.firstDayOfWeek,
    activeMonths = _useDatepicker.activeMonths,
    focusedDate = _useDatepicker.focusedDate,
    goToPreviousMonths = _useDatepicker.goToPreviousMonths,
    goToNextMonths = _useDatepicker.goToNextMonths,
    context = _objectWithoutProperties(_useDatepicker, _excluded2$2);
  return /*#__PURE__*/React__default.createElement(DatePickerContextInner.Provider, {
    value: _objectSpread2({
      focusedDate: focusedDate,
      range: range
    }, context)
  }, /*#__PURE__*/React__default.createElement(NavButton, {
    onClick: goToPreviousMonths
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "chevron_left_outline",
    height: 20,
    width: 20,
    cursor: "pointer"
  })), /*#__PURE__*/React__default.createElement(DatePickerBody, {
    daily: true
  }, /*#__PURE__*/React__default.createElement(DatePickerDay, {
    numberOfMonths: numberOfMonths
  }, activeMonths.map(function (month, index) {
    return /*#__PURE__*/React__default.createElement(Month$2, {
      key: "".concat(month.year, "-").concat(month.month, "-").concat(index),
      year: month.year,
      month: month.month,
      firstDayOfWeek: firstDayOfWeek
    });
  }))), /*#__PURE__*/React__default.createElement(NavButton, {
    onClick: goToNextMonths,
    next: true
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "chevron_right_outline",
    height: 20,
    width: 20,
    cursor: "pointer"
  })));
};

var _excluded$e = ["range"],
  _excluded2$3 = ["buttonVariant"];
function Month$3(_ref) {
  var label = _ref.label,
    date = _ref.date,
    isStartOrEndOfRowGrid = _ref.isStartOrEndOfRowGrid;
  var dayRef = useRef(null);
  var _useContext = useContext(DatePickerContextInner),
    range = _useContext.range,
    context = _objectWithoutProperties(_useContext, _excluded$e);
  var _useDay = Ne$1(_objectSpread2(_objectSpread2({
      date: date
    }, context), {}, {
      dayRef: dayRef
    })),
    isSelected = _useDay.isSelected,
    isSelectedStartOrEnd = _useDay.isSelectedStartOrEnd,
    isWithinHoverRange = _useDay.isWithinHoverRange,
    disabledDate = _useDay.disabledDate,
    onClick = _useDay.onClick,
    onKeyDown = _useDay.onKeyDown,
    onMouseEnter = _useDay.onMouseEnter,
    tabIndex = _useDay.tabIndex;
  if (!label) {
    return /*#__PURE__*/React__default.createElement("div", null);
  }
  var _getColor = getColor(isSelected, isSelectedStartOrEnd, isWithinHoverRange, disabledDate, range),
    buttonVariant = _getColor.buttonVariant,
    spanProps = _objectWithoutProperties(_getColor, _excluded2$3);
  var isStartDate = context.isStartDate(date);
  var isEndDate = context.isEndDate(date);
  return /*#__PURE__*/React__default.createElement(Month$1, {
    className: buttonVariant,
    monthly: true,
    isStartDate: isStartDate,
    isEndDate: isEndDate,
    range: range
  }, /*#__PURE__*/React__default.createElement(MonthContent, {
    onClick: onClick,
    onKeyDown: onKeyDown,
    onMouseEnter: onMouseEnter,
    tabIndex: tabIndex,
    type: "button",
    ref: dayRef,
    variant: buttonVariant,
    isStartOrEndOfRowGrid: isStartOrEndOfRowGrid
  }, /*#__PURE__*/React__default.createElement(Span$1, spanProps, label)));
}

var _excluded$f = ["focusedInput"],
  _excluded2$4 = ["firstDayOfWeek", "activeMonths", "focusedDate", "goToNextMonths", "goToPreviousMonths"];
var months$1 = _toConsumableArray(Array(12).keys()).map(function (e, index) {
  return locale$1.localize.month(index, {
    width: 'abbreviated'
  });
});
var isStartOrEndOfRowGrid$1 = function isStartOrEndOfRowGrid(index) {
  if (index === 1) return false;
  var rest = (index + 1) % 3;
  if (index === 0 || rest === 1) return 'startRowGrid';
  if (index === 2 || rest === 0) return 'endRowGrid';
  return false;
};
var MonthlyContainer = function MonthlyContainer(_ref) {
  var onChange = _ref.onChange,
    value = _ref.value,
    minBookingDate = _ref.minBookingDate,
    maxBookingDate = _ref.maxBookingDate,
    range = _ref.range;
  var _useState = useState(Pe$1),
    _useState2 = _slicedToArray(_useState, 2),
    focusedInput = _useState2[0],
    setFocusedInput = _useState2[1];
  var onDatesChange = function onDatesChange(_ref2) {
    var focusedInput = _ref2.focusedInput,
      data = _objectWithoutProperties(_ref2, _excluded$f);
    onChange && onChange(data);
    if (range) {
      setFocusedInput(focusedInput || Pe$1);
    }
  };
  var _useDatepicker = Ye$1(_objectSpread2(_objectSpread2({}, value), {}, {
      onDatesChange: onDatesChange,
      minBookingDate: minBookingDate,
      maxBookingDate: maxBookingDate,
      focusedInput: focusedInput,
      numberOfMonths: 12,
      initialVisibleMonth: startOfYear(new Date()),
      changeActiveMonthOnSelect: false
    })),
    firstDayOfWeek = _useDatepicker.firstDayOfWeek,
    activeMonths = _useDatepicker.activeMonths,
    focusedDate = _useDatepicker.focusedDate,
    goToNextMonths = _useDatepicker.goToNextMonths,
    goToPreviousMonths = _useDatepicker.goToPreviousMonths,
    context = _objectWithoutProperties(_useDatepicker, _excluded2$4);
  var _useMonth = de$1(_objectSpread2(_objectSpread2({}, activeMonths[0]), {}, {
      firstDayOfWeek: firstDayOfWeek
    })),
    monthLabel = _useMonth.monthLabel;
  var year = monthLabel.split(' ')[1];
  return /*#__PURE__*/React__default.createElement(DatePickerContextInner.Provider, {
    value: _objectSpread2({
      focusedDate: focusedDate,
      range: range
    }, context)
  }, /*#__PURE__*/React__default.createElement(NavButton, {
    onClick: function onClick() {
      return goToPreviousMonths(12);
    }
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "chevron_left_outline",
    height: 20,
    width: 20,
    cursor: "pointer"
  })), /*#__PURE__*/React__default.createElement(DatePickerBody, null, /*#__PURE__*/React__default.createElement(DatePickerGrid, null, /*#__PURE__*/React__default.createElement(DatePickerHeader, {
    monthly: true
  }, /*#__PURE__*/React__default.createElement(Span$1, {
    type: "4",
    variant: "primary",
    modifier: "strong",
    align: "center"
  }, year)), /*#__PURE__*/React__default.createElement(MonthGrid, null, activeMonths.map(function (month, i) {
    return /*#__PURE__*/React__default.createElement(Month$3, {
      key: "datepicker-monthly-".concat(months$1[i]),
      label: months$1[i],
      date: new Date(year, i, 1),
      isStartOrEndOfRowGrid: isStartOrEndOfRowGrid$1(i)
    });
  })))), /*#__PURE__*/React__default.createElement(NavButton, {
    onClick: function onClick() {
      return goToNextMonths(12);
    },
    next: true
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "chevron_right_outline",
    height: 20,
    width: 20,
    cursor: "pointer"
  })));
};

var _excluded$g = ["monthly", "minDate", "maxDate", "filterAlternatives", "setCurrentFilterAlternative", "monthsShown"],
  _excluded2$5 = ["monthly", "minDate", "maxDate", "filterAlternatives", "setCurrentFilterAlternative"];
var DateRangePicker = function DateRangePicker(_ref) {
  var monthly = _ref.monthly,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    filterAlternatives = _ref.filterAlternatives,
    setCurrentFilterAlternative = _ref.setCurrentFilterAlternative,
    monthsShown = _ref.monthsShown,
    props = _objectWithoutProperties(_ref, _excluded$g);
  var pickerProps = monthsShown ? {
    numberOfMonths: monthsShown
  } : {};
  if (monthly) return /*#__PURE__*/React__default.createElement(DatePicker, _extends({}, props, {
    filterAlternatives: filterAlternatives,
    setCurrentFilterAlternative: setCurrentFilterAlternative,
    dateFormat: "LLL",
    numberOfMonths: monthsShown,
    range: true
  }), /*#__PURE__*/React__default.createElement(MonthlyContainer, _extends({}, pickerProps, {
    minBookingDate: minDate,
    maxBookingDate: maxDate,
    range: true
  })));
  return /*#__PURE__*/React__default.createElement(DatePicker, _extends({}, props, {
    filterAlternatives: filterAlternatives,
    setCurrentFilterAlternative: setCurrentFilterAlternative,
    bookingDate: true,
    numberOfMonths: monthsShown,
    range: true
  }), /*#__PURE__*/React__default.createElement(DatePickerContainer, _extends({}, pickerProps, {
    minBookingDate: minDate,
    maxBookingDate: maxDate,
    range: true
  })));
};
var DatePicker$1 = function DatePicker$1(_ref2) {
  var monthly = _ref2.monthly,
    minDate = _ref2.minDate,
    maxDate = _ref2.maxDate,
    filterAlternatives = _ref2.filterAlternatives,
    setCurrentFilterAlternative = _ref2.setCurrentFilterAlternative,
    props = _objectWithoutProperties(_ref2, _excluded2$5);
  if (monthly) return /*#__PURE__*/React__default.createElement(DatePicker, _extends({}, props, {
    filterAlternatives: filterAlternatives,
    setCurrentFilterAlternative: setCurrentFilterAlternative,
    dateFormat: "LLL"
  }), /*#__PURE__*/React__default.createElement(MonthlyContainer, {
    minBookingDate: minDate,
    maxBookingDate: maxDate,
    numberOfMonths: "1"
  }));
  return /*#__PURE__*/React__default.createElement(DatePicker, _extends({}, props, {
    filterAlternatives: filterAlternatives,
    setCurrentFilterAlternative: setCurrentFilterAlternative
  }), /*#__PURE__*/React__default.createElement(DatePickerContainer, {
    minBookingDate: minDate,
    maxBookingDate: maxDate,
    numberOfMonths: "1"
  }));
};

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

function _extends$7q() {
  _extends$7q = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$7q.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function isNum(v) {
  return typeof v === 'number' && !isNaN(v);
}
function isBool(v) {
  return typeof v === 'boolean';
}
function isStr(v) {
  return typeof v === 'string';
}
function isFn(v) {
  return typeof v === 'function';
}
function parseClassName(v) {
  return isStr(v) || isFn(v) ? v : null;
}
function objectValues(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
}
function hasToastId(toastId) {
  return toastId === 0 || toastId;
}
function getAutoCloseDelay(toastAutoClose, containerAutoClose) {
  return toastAutoClose === false || isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}
var canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function canBeRendered(content) {
  return isValidElement(content) || isStr(content) || isFn(content) || isNum(content);
}

var POSITION = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center'
};
var TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'default',
  DARK: 'dark'
};

/**
 * Used to collapse toast after exit animation
 */
function collapseToast(node, done, duration
/* COLLAPSE_DURATION */
) {
  if (duration === void 0) {
    duration = 300;
  }

  var height = node.scrollHeight;
  var style = node.style;
  requestAnimationFrame(function () {
    style.minHeight = 'initial';
    style.height = height + 'px';
    style.transition = "all " + duration + "ms";
    requestAnimationFrame(function () {
      style.height = '0';
      style.padding = '0';
      style.margin = '0';
      setTimeout(function () {
        return done();
      }, duration);
    });
  });
}

function cssTransition(_ref) {
  var enter = _ref.enter,
      exit = _ref.exit,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 750 : _ref$duration,
      _ref$appendPosition = _ref.appendPosition,
      appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition,
      _ref$collapse = _ref.collapse,
      collapse = _ref$collapse === void 0 ? true : _ref$collapse,
      _ref$collapseDuration = _ref.collapseDuration,
      collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
  var enterDuration, exitDuration;

  if (Array.isArray(duration) && duration.length === 2) {
    enterDuration = duration[0];
    exitDuration = duration[1];
  } else {
    enterDuration = exitDuration = duration;
  }

  return function ToastTransition(_ref2) {
    var children = _ref2.children,
        position = _ref2.position,
        preventExitTransition = _ref2.preventExitTransition,
        done = _ref2.done,
        props = _objectWithoutPropertiesLoose$4(_ref2, ["children", "position", "preventExitTransition", "done"]);

    var enterClassName = appendPosition ? enter + "--" + position : enter;
    var exitClassName = appendPosition ? exit + "--" + position : exit;

    var onEnter = function onEnter() {
      var node = props.nodeRef.current;

      if (node) {
        node.classList.add(enterClassName);
        node.style.animationFillMode = 'forwards';
        node.style.animationDuration = enterDuration + "ms";
      }
    };

    var onEntered = function onEntered() {
      var node = props.nodeRef.current;

      if (node) {
        node.classList.remove(enterClassName);
        node.style.removeProperty('animationFillMode');
        node.style.removeProperty('animationDuration');
      }
    };

    var onExited = function onExited() {
      var node = props.nodeRef.current;

      if (node) {
        node.removeEventListener('animationend', onExited);
        collapse ? collapseToast(node, done, collapseDuration) : done();
      }
    };

    var onExit = function onExit() {
      var node = props.nodeRef.current;

      if (node) {
        node.classList.add(exitClassName);
        node.style.animationFillMode = 'forwards';
        node.style.animationDuration = exitDuration + "ms";
        node.addEventListener('animationend', onExited);
      }
    };

    return createElement$2(Transition, Object.assign({}, props, {
      timeout: preventExitTransition ? collapse ? collapseDuration : 50
      /* DEBOUNCE_DURATION */
      : {
        enter: enterDuration,
        exit: collapse ? exitDuration + collapseDuration : exitDuration + 50
        /* DEBOUNCE_DURATION */

      },
      onEnter: onEnter,
      onEntered: onEntered,
      onExit: preventExitTransition ? onExited : onExit,
      unmountOnExit: true
    }), children);
  };
}

var eventManager = {
  list: /*#__PURE__*/new Map(),
  emitQueue: /*#__PURE__*/new Map(),
  on: function on(event, callback) {
    this.list.has(event) || this.list.set(event, []);
    this.list.get(event).push(callback);
    return this;
  },
  off: function off(event, callback) {
    if (callback) {
      var cb = this.list.get(event).filter(function (cb) {
        return cb !== callback;
      });
      this.list.set(event, cb);
      return this;
    }

    this.list["delete"](event);
    return this;
  },
  cancelEmit: function cancelEmit(event) {
    var timers = this.emitQueue.get(event);

    if (timers) {
      timers.forEach(function (timer) {
        return clearTimeout(timer);
      });
      this.emitQueue["delete"](event);
    }

    return this;
  },

  /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */
  emit: function emit(event) {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    this.list.has(event) && this.list.get(event).forEach(function (callback) {
      var timer = setTimeout(function () {
        // @ts-ignore
        callback.apply(void 0, args);
      }, 0);
      _this.emitQueue.has(event) || _this.emitQueue.set(event, []);

      _this.emitQueue.get(event).push(timer);
    });
  }
};

/**
 * `useKeeper` is a helper around `useRef`.
 *
 * You don't need to access the `.current`property to get the value
 * If refresh is set to true. The ref will be updated every render
 */

function useKeeper(arg, refresh) {
  if (refresh === void 0) {
    refresh = false;
  }

  var ref = useRef(arg);
  useEffect(function () {
    if (refresh) ref.current = arg;
  });
  return ref.current;
}

function reducer(state, action) {
  switch (action.type) {
    case 'ADD':
      return [].concat(state, [action.toastId]).filter(function (id) {
        return id !== action.staleId;
      });

    case 'REMOVE':
      return hasToastId(action.toastId) ? state.filter(function (id) {
        return id !== action.toastId;
      }) : [];
  }
}

function useToastContainer(props) {
  var _useReducer = useReducer(function (x) {
    return x + 1;
  }, 0),
      forceUpdate = _useReducer[1];

  var _useReducer2 = useReducer(reducer, []),
      toast = _useReducer2[0],
      dispatch = _useReducer2[1];

  var containerRef = useRef(null);
  var toastCount = useKeeper(0);
  var queue = useKeeper([]);
  var collection = useKeeper({});
  var instance = useKeeper({
    toastKey: 1,
    displayedToast: 0,
    props: props,
    containerId: null,
    isToastActive: isToastActive,
    getToast: function getToast(id) {
      return collection[id] || null;
    }
  });
  useEffect(function () {
    instance.containerId = props.containerId;
    eventManager.cancelEmit(3
    /* WillUnmount */
    ).on(0
    /* Show */
    , buildToast).on(1
    /* Clear */
    , function (toastId) {
      return containerRef.current && removeToast(toastId);
    }).on(5
    /* ClearWaitingQueue */
    , clearWaitingQueue).emit(2
    /* DidMount */
    , instance);
    return function () {
      return eventManager.emit(3
      /* WillUnmount */
      , instance);
    };
  }, []);
  useEffect(function () {
    instance.isToastActive = isToastActive;
    instance.displayedToast = toast.length;
    eventManager.emit(4
    /* Change */
    , toast.length, props.containerId);
  }, [toast]);
  useEffect(function () {
    instance.props = props;
  });

  function isToastActive(id) {
    return toast.indexOf(id) !== -1;
  }

  function clearWaitingQueue(_ref) {
    var containerId = _ref.containerId;
    var _instance$props = instance.props,
        limit = _instance$props.limit,
        enableMultiContainer = _instance$props.enableMultiContainer;

    if (limit && (!containerId || instance.containerId === containerId && enableMultiContainer)) {
      toastCount -= queue.length;
      queue = [];
    }
  }

  function removeToast(toastId) {
    var queueLen = queue.length;
    toastCount = hasToastId(toastId) ? toastCount - 1 : toastCount - instance.displayedToast;
    if (toastCount < 0) toastCount = 0;

    if (queueLen > 0) {
      var freeSlot = hasToastId(toastId) ? 1 : instance.props.limit;

      if (queueLen === 1 || freeSlot === 1) {
        instance.displayedToast++;
        dequeueToast();
      } else {
        var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
        instance.displayedToast = toDequeue;

        for (var i = 0; i < toDequeue; i++) {
          dequeueToast();
        }
      }
    }

    dispatch({
      type: 'REMOVE',
      toastId: toastId
    });
  }

  function dequeueToast() {
    var _queue$shift = queue.shift(),
        toastContent = _queue$shift.toastContent,
        toastProps = _queue$shift.toastProps,
        staleId = _queue$shift.staleId; // ensure that exit transition has been completed, hence the timeout


    setTimeout(function () {
      appendToast(toastContent, toastProps, staleId);
    }, 500);
  }
  /**
   * check if a container is attached to the dom
   * check for multi-container, build only if associated
   * check for duplicate toastId if no update
   */


  function isNotValid(_ref2) {
    var containerId = _ref2.containerId,
        toastId = _ref2.toastId,
        updateId = _ref2.updateId;
    return !containerRef.current || instance.props.enableMultiContainer && containerId !== instance.props.containerId || instance.isToastActive(toastId) && updateId == null ? true : false;
  } // this function and all the function called inside needs to rely on ref(`useKeeper`)


  function buildToast(content, _ref3) {
    var delay = _ref3.delay,
        staleId = _ref3.staleId,
        options = _objectWithoutPropertiesLoose$4(_ref3, ["delay", "staleId"]);

    if (!canBeRendered(content) || isNotValid(options)) return;
    var toastId = options.toastId,
        updateId = options.updateId;
    var props = instance.props,
        isToastActive = instance.isToastActive;

    var closeToast = function closeToast() {
      return removeToast(toastId);
    };

    var isNotAnUpdate = !isToastActive(toastId);
    if (isNotAnUpdate) toastCount++;
    var toastProps = {
      toastId: toastId,
      updateId: updateId,
      key: options.key || instance.toastKey++,
      type: options.type,
      closeToast: closeToast,
      closeButton: options.closeButton,
      rtl: props.rtl,
      position: options.position || props.position,
      transition: options.transition || props.transition,
      className: parseClassName(options.className || props.toastClassName),
      bodyClassName: parseClassName(options.bodyClassName || props.bodyClassName),
      style: options.style || props.toastStyle,
      bodyStyle: options.bodyStyle || props.bodyStyle,
      onClick: options.onClick || props.onClick,
      pauseOnHover: isBool(options.pauseOnHover) ? options.pauseOnHover : props.pauseOnHover,
      pauseOnFocusLoss: isBool(options.pauseOnFocusLoss) ? options.pauseOnFocusLoss : props.pauseOnFocusLoss,
      draggable: isBool(options.draggable) ? options.draggable : props.draggable,
      draggablePercent: isNum(options.draggablePercent) ? options.draggablePercent : props.draggablePercent,
      closeOnClick: isBool(options.closeOnClick) ? options.closeOnClick : props.closeOnClick,
      progressClassName: parseClassName(options.progressClassName || props.progressClassName),
      progressStyle: options.progressStyle || props.progressStyle,
      autoClose: getAutoCloseDelay(options.autoClose, props.autoClose),
      hideProgressBar: isBool(options.hideProgressBar) ? options.hideProgressBar : props.hideProgressBar,
      progress: options.progress,
      role: isStr(options.role) ? options.role : props.role,
      deleteToast: function deleteToast() {
        removeFromCollection(toastId);
      }
    };
    if (isFn(options.onOpen)) toastProps.onOpen = options.onOpen;
    if (isFn(options.onClose)) toastProps.onClose = options.onClose;
    var closeButton = props.closeButton;

    if (options.closeButton === false || canBeRendered(options.closeButton)) {
      closeButton = options.closeButton;
    } else if (options.closeButton === true) {
      closeButton = canBeRendered(props.closeButton) ? props.closeButton : true;
    }

    toastProps.closeButton = closeButton;
    var toastContent = content;

    if (isValidElement(content) && !isStr(content.type)) {
      toastContent = cloneElement(content, {
        closeToast: closeToast,
        toastProps: toastProps
      });
    } else if (isFn(content)) {
      toastContent = content({
        closeToast: closeToast,
        toastProps: toastProps
      });
    } // not handling limit + delay by design. Waiting for user feedback first


    if (props.limit && props.limit > 0 && toastCount > props.limit && isNotAnUpdate) {
      queue.push({
        toastContent: toastContent,
        toastProps: toastProps,
        staleId: staleId
      });
    } else if (isNum(delay) && delay > 0) {
      setTimeout(function () {
        appendToast(toastContent, toastProps, staleId);
      }, delay);
    } else {
      appendToast(toastContent, toastProps, staleId);
    }
  }

  function appendToast(content, toastProps, staleId) {
    var toastId = toastProps.toastId;
    collection[toastId] = {
      content: content,
      props: toastProps
    };
    dispatch({
      type: 'ADD',
      toastId: toastId,
      staleId: staleId
    });
  }

  function removeFromCollection(toastId) {
    delete collection[toastId];
    forceUpdate();
  }

  function getToastToRender(cb) {
    var toastToRender = {};
    var toastList = props.newestOnTop ? Object.keys(collection).reverse() : Object.keys(collection);

    for (var i = 0; i < toastList.length; i++) {
      var _toast = collection[toastList[i]];
      var position = _toast.props.position;
      toastToRender[position] || (toastToRender[position] = []);
      toastToRender[position].push(_toast);
    }

    return Object.keys(toastToRender).map(function (p) {
      return cb(p, toastToRender[p]);
    });
  }

  return {
    getToastToRender: getToastToRender,
    collection: collection,
    containerRef: containerRef,
    isToastActive: isToastActive
  };
}

function getX(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}

function getY(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}

function useToast(props) {
  var _useState = useState(true),
      isRunning = _useState[0],
      setIsRunning = _useState[1];

  var _useState2 = useState(false),
      preventExitTransition = _useState2[0],
      setPreventExitTransition = _useState2[1];

  var toastRef = useRef(null);
  var drag = useKeeper({
    start: 0,
    x: 0,
    y: 0,
    deltaX: 0,
    removalDistance: 0,
    canCloseOnClick: true,
    canDrag: false,
    boundingRect: null
  });
  var syncProps = useKeeper(props, true);
  var autoClose = props.autoClose,
      pauseOnHover = props.pauseOnHover,
      closeToast = props.closeToast,
      onClick = props.onClick,
      closeOnClick = props.closeOnClick;
  useEffect(function () {
    if (isFn(props.onOpen)) props.onOpen(isValidElement(props.children) && props.children.props);
    return function () {
      if (isFn(syncProps.onClose)) syncProps.onClose(isValidElement(syncProps.children) && syncProps.children.props);
    };
  }, []);
  useEffect(function () {
    props.draggable && bindDragEvents();
    return function () {
      props.draggable && unbindDragEvents();
    };
  }, [props.draggable]);
  useEffect(function () {
    props.pauseOnFocusLoss && bindFocusEvents();
    return function () {
      props.pauseOnFocusLoss && unbindFocusEvents();
    };
  }, [props.pauseOnFocusLoss]);

  function onDragStart(e) {
    var toast = toastRef.current;
    drag.canCloseOnClick = true;
    drag.canDrag = true;
    drag.boundingRect = toast.getBoundingClientRect();
    toast.style.transition = '';
    drag.start = drag.x = getX(e.nativeEvent);
    drag.removalDistance = toast.offsetWidth * (props.draggablePercent / 100);
  }

  function onDragTransitionEnd() {
    if (drag.boundingRect) {
      var _drag$boundingRect = drag.boundingRect,
          top = _drag$boundingRect.top,
          bottom = _drag$boundingRect.bottom,
          left = _drag$boundingRect.left,
          right = _drag$boundingRect.right;

      if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) {
        pauseToast();
      } else {
        playToast();
      }
    }
  }

  function playToast() {
    setIsRunning(true);
  }

  function pauseToast() {
    setIsRunning(false);
  }

  function bindFocusEvents() {
    window.addEventListener('focus', playToast);
    window.addEventListener('blur', pauseToast);
  }

  function unbindFocusEvents() {
    window.removeEventListener('focus', playToast);
    window.removeEventListener('blur', pauseToast);
  }

  function bindDragEvents() {
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);
    document.addEventListener('touchmove', onDragMove);
    document.addEventListener('touchend', onDragEnd);
  }

  function unbindDragEvents() {
    document.removeEventListener('mousemove', onDragMove);
    document.removeEventListener('mouseup', onDragEnd);
    document.removeEventListener('touchmove', onDragMove);
    document.removeEventListener('touchend', onDragEnd);
  }

  function onDragMove(e) {
    e.preventDefault();
    var toast = toastRef.current;

    if (drag.canDrag) {
      if (isRunning) pauseToast();
      drag.x = getX(e);
      drag.deltaX = drag.x - drag.start;
      drag.y = getY(e); // prevent false positif during a toast click

      if (drag.start !== drag.x) drag.canCloseOnClick = false;
      toast.style.transform = "translateX(" + drag.deltaX + "px)";
      toast.style.opacity = "" + (1 - Math.abs(drag.deltaX / drag.removalDistance));
    }
  }

  function onDragEnd() {
    var toast = toastRef.current;

    if (drag.canDrag) {
      drag.canDrag = false;

      if (Math.abs(drag.deltaX) > drag.removalDistance) {
        setPreventExitTransition(true);
        props.closeToast();
        return;
      }

      toast.style.transition = 'transform 0.2s, opacity 0.2s';
      toast.style.transform = 'translateX(0)';
      toast.style.opacity = '1';
    }
  }

  var eventHandlers = {
    onMouseDown: onDragStart,
    onTouchStart: onDragStart,
    onMouseUp: onDragTransitionEnd,
    onTouchEnd: onDragTransitionEnd
  };

  if (autoClose && pauseOnHover) {
    eventHandlers.onMouseEnter = pauseToast;
    eventHandlers.onMouseLeave = playToast;
  } // prevent toast from closing when user drags the toast


  if (closeOnClick) {
    eventHandlers.onClick = function (e) {
      onClick && onClick(e);
      drag.canCloseOnClick && closeToast();
    };
  }

  return {
    playToast: playToast,
    pauseToast: pauseToast,
    isRunning: isRunning,
    preventExitTransition: preventExitTransition,
    toastRef: toastRef,
    eventHandlers: eventHandlers
  };
}

function CloseButton(_ref) {
  var closeToast = _ref.closeToast,
      type = _ref.type,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'close' : _ref$ariaLabel;
  return createElement$2("button", {
    className: "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button " + "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button--" + type,
    type: "button",
    onClick: function onClick(e) {
      e.stopPropagation();
      closeToast(e);
    },
    "aria-label": ariaLabel
  }, createElement$2("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, createElement$2("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}

function ProgressBar(_ref) {
  var _ref2, _animationEvent;

  var delay = _ref.delay,
      isRunning = _ref.isRunning,
      closeToast = _ref.closeToast,
      type = _ref.type,
      hide = _ref.hide,
      className = _ref.className,
      userStyle = _ref.style,
      controlledProgress = _ref.controlledProgress,
      progress = _ref.progress,
      rtl = _ref.rtl,
      isIn = _ref.isIn;

  var style = _extends$7q({}, userStyle, {
    animationDuration: delay + "ms",
    animationPlayState: isRunning ? 'running' : 'paused',
    opacity: hide ? 0 : 1
  });

  if (controlledProgress) style.transform = "scaleX(" + progress + ")";
  var defaultClassArr = ["Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar", controlledProgress ? "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--controlled" : "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--animated", "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--" + type, (_ref2 = {}, _ref2["Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--rtl"] = rtl, _ref2)];
  var classNames = isFn(className) ? className({
    rtl: rtl,
    type: type,
    defaultClassName: clsx.apply(void 0, defaultClassArr)
  }) : clsx.apply(void 0, [].concat(defaultClassArr, [className])); // 🧐 controlledProgress is derived from progress
  // so if controlledProgress is set
  // it means that this is also the case for progress

  var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? 'onTransitionEnd' : 'onAnimationEnd'] = controlledProgress && progress < 1 ? null : function () {
    isIn && closeToast();
  }, _animationEvent);
  return createElement$2("div", Object.assign({
    className: classNames,
    style: style
  }, animationEvent));
}
ProgressBar.defaultProps = {
  type: TYPE.DEFAULT,
  hide: false
};

var Toast = function Toast(props) {
  var _ref;

  var _useToast = useToast(props),
      isRunning = _useToast.isRunning,
      preventExitTransition = _useToast.preventExitTransition,
      toastRef = _useToast.toastRef,
      eventHandlers = _useToast.eventHandlers;

  var closeButton = props.closeButton,
      children = props.children,
      autoClose = props.autoClose,
      onClick = props.onClick,
      type = props.type,
      hideProgressBar = props.hideProgressBar,
      closeToast = props.closeToast,
      Transition = props.transition,
      position = props.position,
      className = props.className,
      style = props.style,
      bodyClassName = props.bodyClassName,
      bodyStyle = props.bodyStyle,
      progressClassName = props.progressClassName,
      progressStyle = props.progressStyle,
      updateId = props.updateId,
      role = props.role,
      progress = props.progress,
      rtl = props.rtl,
      toastId = props.toastId,
      deleteToast = props.deleteToast;
  var defaultClassArr = ["Toastify"
  /* CSS_NAMESPACE */
  + "__toast", "Toastify"
  /* CSS_NAMESPACE */
  + "__toast--" + type, (_ref = {}, _ref["Toastify"
  /* CSS_NAMESPACE */
  + "__toast--rtl"] = rtl, _ref)];
  var cssClasses = isFn(className) ? className({
    rtl: rtl,
    position: position,
    type: type,
    defaultClassName: clsx.apply(void 0, defaultClassArr)
  }) : clsx.apply(void 0, [].concat(defaultClassArr, [className]));
  var controlledProgress = !!progress;

  function renderCloseButton(closeButton) {
    if (!closeButton) return;
    var props = {
      closeToast: closeToast,
      type: type
    };
    if (isFn(closeButton)) return closeButton(props);
    if (isValidElement(closeButton)) return cloneElement(closeButton, props);
  }

  return createElement$2(Transition, {
    "in": props["in"],
    appear: true,
    done: deleteToast,
    position: position,
    preventExitTransition: preventExitTransition,
    nodeRef: toastRef
  }, createElement$2("div", Object.assign({
    id: toastId,
    onClick: onClick,
    className: cssClasses || undefined
  }, eventHandlers, {
    style: style,
    ref: toastRef
  }), createElement$2("div", Object.assign({}, props["in"] && {
    role: role
  }, {
    className: isFn(bodyClassName) ? bodyClassName({
      type: type
    }) : clsx("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-body", bodyClassName),
    style: bodyStyle
  }), children), renderCloseButton(closeButton), (autoClose || controlledProgress) && createElement$2(ProgressBar, Object.assign({}, updateId && !controlledProgress ? {
    key: "pb-" + updateId
  } : {}, {
    rtl: rtl,
    delay: autoClose,
    isRunning: isRunning,
    isIn: props["in"],
    closeToast: closeToast,
    hide: hideProgressBar,
    type: type,
    style: progressStyle,
    className: progressClassName,
    controlledProgress: controlledProgress,
    progress: progress
  }))));
};

var Bounce = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-exit",
  appendPosition: true
});

var ToastPositioner = function ToastPositioner(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      rest = _objectWithoutPropertiesLoose$4(_ref, ["children", "className", "style"]);

  // Monkey patch react-transition-group
  // As exit transition is broken with strict mode
  delete rest["in"];
  return createElement$2("div", {
    className: className,
    style: style
  }, Children.map(children, function (child) {
    return cloneElement(child, rest);
  }));
};

var ToastContainer = function ToastContainer(props) {
  var _useToastContainer = useToastContainer(props),
      getToastToRender = _useToastContainer.getToastToRender,
      containerRef = _useToastContainer.containerRef,
      isToastActive = _useToastContainer.isToastActive;

  var className = props.className,
      style = props.style,
      rtl = props.rtl,
      containerId = props.containerId;
  return createElement$2("div", {
    ref: containerRef,
    className: "Toastify"
    /* CSS_NAMESPACE */
    ,
    id: containerId
  }, getToastToRender(function (position, toastList) {
    var _cx, _cx2;

    var swag = {
      className: isFn(className) ? className({
        position: position,
        rtl: rtl,
        defaultClassName: clsx("Toastify"
        /* CSS_NAMESPACE */
        + "__toast-container", "Toastify"
        /* CSS_NAMESPACE */
        + "__toast-container--" + position, (_cx = {}, _cx["Toastify"
        /* CSS_NAMESPACE */
        + "__toast-container--rtl"] = rtl, _cx))
      }) : clsx("Toastify"
      /* CSS_NAMESPACE */
      + "__toast-container", "Toastify"
      /* CSS_NAMESPACE */
      + "__toast-container--" + position, (_cx2 = {}, _cx2["Toastify"
      /* CSS_NAMESPACE */
      + "__toast-container--rtl"] = rtl, _cx2), parseClassName(className)),
      style: toastList.length === 0 ? _extends$7q({}, style, {
        pointerEvents: 'none'
      }) : _extends$7q({}, style)
    };
    return createElement$2(ToastPositioner, Object.assign({}, swag, {
      key: "container-" + position
    }), toastList.map(function (_ref) {
      var content = _ref.content,
          toastProps = _ref.props;
      return createElement$2(Toast, Object.assign({}, toastProps, {
        "in": isToastActive(toastProps.toastId),
        key: "toast-" + toastProps.key,
        closeButton: toastProps.closeButton === true ? CloseButton : toastProps.closeButton
      }), content);
    }));
  }));
};

if (process.env.NODE_ENV !== 'production') {
  // @ts-ignore
  ToastContainer.propTypes = {
    // @ts-ignore
    position: /*#__PURE__*/PropTypes.oneOf( /*#__PURE__*/objectValues(POSITION)),
    // @ts-ignore
    autoClose: /*#__PURE__*/PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    // @ts-ignore
    closeButton: /*#__PURE__*/PropTypes.oneOfType([PropTypes.node, PropTypes.bool, PropTypes.func]),
    hideProgressBar: PropTypes.bool,
    pauseOnHover: PropTypes.bool,
    closeOnClick: PropTypes.bool,
    newestOnTop: PropTypes.bool,
    className: PropTypes.any,
    style: PropTypes.object,
    toastClassName: /*#__PURE__*/PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    bodyClassName: /*#__PURE__*/PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    progressClassName: /*#__PURE__*/PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    progressStyle: PropTypes.object,
    transition: PropTypes.func,
    rtl: PropTypes.bool,
    draggable: PropTypes.bool,
    draggablePercent: PropTypes.number,
    pauseOnFocusLoss: PropTypes.bool,
    enableMultiContainer: PropTypes.bool,
    containerId: /*#__PURE__*/PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    role: PropTypes.string,
    onClick: PropTypes.func
  };
}

ToastContainer.defaultProps = {
  position: POSITION.TOP_RIGHT,
  transition: Bounce,
  rtl: false,
  autoClose: 5000,
  hideProgressBar: false,
  closeButton: CloseButton,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: true,
  newestOnTop: false,
  draggable: true,
  draggablePercent: 80,
  role: 'alert'
};

var containers = /*#__PURE__*/new Map();
var latestInstance;
var containerDomNode;
var containerConfig;
var queue = [];
var lazy = false;
/**
 * Check whether any container is currently mounted in the DOM
 */

function isAnyContainerMounted() {
  return containers.size > 0;
}
/**
 * Get the container by id. Returns the last container declared when no id is given.
 */


function getContainer(containerId) {
  if (!isAnyContainerMounted()) return null;
  return containers.get(!containerId ? latestInstance : containerId);
}
/**
 * Get the toast by id, given it's in the DOM, otherwise returns null
 */


function getToast(toastId, _ref) {
  var containerId = _ref.containerId;
  var container = getContainer(containerId);
  if (!container) return null;
  return container.getToast(toastId);
}
/**
 * Generate a random toastId
 */


function generateToastId() {
  return (Math.random().toString(36) + Date.now().toString(36)).substr(2, 10);
}
/**
 * Generate a toastId or use the one provided
 */


function getToastId(options) {
  if (options && (isStr(options.toastId) || isNum(options.toastId))) {
    return options.toastId;
  }

  return generateToastId();
}
/**
 * If the container is not mounted, the toast is enqueued and
 * the container lazy mounted
 */


function dispatchToast(content, options) {
  if (isAnyContainerMounted()) {
    eventManager.emit(0
    /* Show */
    , content, options);
  } else {
    queue.push({
      content: content,
      options: options
    });

    if (lazy && canUseDom) {
      lazy = false;
      containerDomNode = document.createElement('div');
      document.body.appendChild(containerDomNode);
      render$1(createElement$2(ToastContainer, Object.assign({}, containerConfig)), containerDomNode);
    }
  }

  return options.toastId;
}
/**
 * Merge provided options with the defaults settings and generate the toastId
 */


function mergeOptions(type, options) {
  return _extends$7q({}, options, {
    type: options && options.type || type,
    toastId: getToastId(options)
  });
}

var toast = function toast(content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, options));
};

toast.success = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.SUCCESS, options));
};

toast.info = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.INFO, options));
};

toast.error = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.ERROR, options));
};

toast.warning = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.WARNING, options));
};

toast.dark = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DARK, options));
};
/**
 * Maybe I should remove warning in favor of warn, I don't know
 */


toast.warn = toast.warning;
/**
 * Remove toast programmaticaly
 */

toast.dismiss = function (id) {
  return isAnyContainerMounted() && eventManager.emit(1
  /* Clear */
  , id);
};
/**
 * Clear waiting queue when limit is used
 */


toast.clearWaitingQueue = function (params) {
  if (params === void 0) {
    params = {};
  }

  return isAnyContainerMounted() && eventManager.emit(5
  /* ClearWaitingQueue */
  , params);
};
/**
 * return true if one container is displaying the toast
 */


toast.isActive = function (id) {
  var isToastActive = false;
  containers.forEach(function (container) {
    if (container.isToastActive && container.isToastActive(id)) {
      isToastActive = true;
    }
  });
  return isToastActive;
};

toast.update = function (toastId, options) {
  if (options === void 0) {
    options = {};
  }

  // if you call toast and toast.update directly nothing will be displayed
  // this is why I defered the update
  setTimeout(function () {
    var toast = getToast(toastId, options);

    if (toast) {
      var oldOptions = toast.props,
          oldContent = toast.content;

      var nextOptions = _extends$7q({}, oldOptions, options, {
        toastId: options.toastId || toastId,
        updateId: generateToastId()
      });

      if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
      var content = typeof nextOptions.render !== 'undefined' ? nextOptions.render : oldContent;
      delete nextOptions.render;
      dispatchToast(content, nextOptions);
    }
  }, 0);
};
/**
 * Used for controlled progress bar.
 */


toast.done = function (id) {
  toast.update(id, {
    progress: 1
  });
};
/**
 * Track changes. The callback get the number of toast displayed
 *
 */


toast.onChange = function (callback) {
  if (isFn(callback)) {
    eventManager.on(4
    /* Change */
    , callback);
  }

  return function () {
    isFn(callback) && eventManager.off(4
    /* Change */
    , callback);
  };
};
/**
 * Configure the ToastContainer when lazy mounted
 */


toast.configure = function (config) {
  if (config === void 0) {
    config = {};
  }

  lazy = true;
  containerConfig = config;
};

toast.POSITION = POSITION;
toast.TYPE = TYPE;
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */

eventManager.on(2
/* DidMount */
, function (containerInstance) {
  latestInstance = containerInstance.containerId || containerInstance;
  containers.set(latestInstance, containerInstance);
  queue.forEach(function (item) {
    eventManager.emit(0
    /* Show */
    , item.content, item.options);
  });
  queue = [];
}).on(3
/* WillUnmount */
, function (containerInstance) {
  containers["delete"](containerInstance.containerId || containerInstance);

  if (containers.size === 0) {
    eventManager.off(0
    /* Show */
    ).off(1
    /* Clear */
    ).off(5
    /* ClearWaitingQueue */
    );
  }

  if (canUseDom && containerDomNode) {
    document.body.removeChild(containerDomNode);
  }
});

var _templateObject$M, _templateObject2$E, _templateObject3$x, _templateObject4$p;
var ToastBody = styled.div(_templateObject$M || (_templateObject$M = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  .toast-body__text {\n    margin-left: ", ";\n  }\n"])), theme.spacing['spacing-6']);
var IconCloseWrapper = styled.div(_templateObject2$E || (_templateObject2$E = _taggedTemplateLiteral(["\n  align-self: flex-start;\n"])));
var Toast$1 = styled(ToastContainer)(_templateObject3$x || (_templateObject3$x = _taggedTemplateLiteral(["\n  .Toastify__toast-body {\n    width: 100%;\n  }\n\n  &.Toast__toast-body--md-full {\n    width: 100%;\n  }\n  &.Toastify__toast-container {\n    z-index: 9999;\n    position: fixed;\n  }\n  .Toastify__toast {\n    width: 328px;\n    display: flex;\n    justify-content: space-between;\n    border-radius: ", ";\n    margin: ", ";\n    padding: ", " ", ";\n  }\n\n  &.Toastify__toast-container--top-right {\n    top: 0;\n    right: 0;\n  }\n\n  &.Toastify__toast-container--top-left {\n    top: 0;\n    left: 0;\n  }\n  &.Toastify__toast-container--top-center {\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  &.Toastify__toast-container--bottom-left {\n    bottom: 0;\n    left: 0;\n  }\n  &.Toastify__toast-container--bottom-center {\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  &.Toastify__toast-container--bottom-right {\n    bottom: 0;\n    right: 0;\n  }\n  .Toastify__toast--success {\n    background: ", ";\n  }\n  .Toastify__toast--error {\n    background: ", ";\n  }\n  .Toastify__toast--info {\n    background: ", ";\n  }\n  .Toastify__toast--warning {\n    background: ", ";\n  }\n  @keyframes Toastify__fadeIn {\n    from {\n      opacity: ", ";\n    }\n    to {\n      opacity: ", ";\n    }\n  }\n  @keyframes Toastify__fadeOut {\n    from {\n      opacity: ", ";\n    }\n    to {\n      opacity: ", ";\n    }\n  }\n  .Toastify__fade-enter {\n    animation-name: Toastify__fadeIn;\n  }\n\n  .Toastify__fade-exit {\n    animation-name: Toastify__fadeOut;\n  }\n  @keyframes Toastify__trackProgress {\n    0% {\n      transform: scaleX(1);\n    }\n    100% {\n      transform: scaleX(0);\n    }\n  }\n  .Toastify__progress-bar--animated {\n    animation: Toastify__trackProgress linear 1 forwards;\n  }\n"])), theme.borderRadius['border-radius-2'], theme.spacing['spacing-4'], theme.spacing['spacing-6'], theme.spacing['spacing-5'], theme.colors.success.bg.regular, theme.colors.danger.bg.regular, theme.colors.info.bg.regular, theme.colors.warning.bg.regular, theme.opacities['opacity-4'], theme.opacities['opacity-1'], theme.opacities['opacity-1'], theme.opacities['opacity-4']);
var Button$3 = styled.button(_templateObject4$p || (_templateObject4$p = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  background-color: transparent;\n\n  &:focus,\n  &:focus-visible {\n    outline: none;\n  }\n  outline: none;\n\n  &::-moz-focus-inner {\n    border: none;\n  }\n  border: none;\n\n  border-radius: ", ";\n  ", ";\n\n  ", "\n"])), theme.borderRadius['border-radius-5'], theme.textStyles['text-preset-7'], function (props) {
  return props.color === 'light' && "\n      &, &:hover, &:active {\n        color: ".concat(theme.colors['neutral'].text.inverted, ";\n      }\n    ") || props.color === 'dark' && "\n      &, &:hover, &:active {\n        color: ".concat(theme.colors['neutral'].text.strong, ";\n      }\n    ");
});

var Fade$1 = cssTransition({
  enter: 'Toastify__fade-enter',
  exit: 'Toastify__fade-exit'
});
var states = {
  info: {
    text: {
      variant: 'neutral',
      modifier: 'inverted'
    },
    icon: {
      name: 'info_circle_outline',
      variant: 'neutral',
      modifier: 'inverted'
    }
  },
  success: {
    text: {
      variant: 'neutral',
      modifier: 'inverted'
    },
    icon: {
      name: 'check_circle_outline',
      variant: 'neutral',
      modifier: 'inverted'
    }
  },
  warning: {
    text: {
      variant: 'neutral',
      modifier: 'strong'
    },
    icon: {
      name: 'error_circle_outline',
      variant: 'neutral',
      modifier: 'strong'
    }
  },
  danger: {
    text: {
      variant: 'neutral',
      modifier: 'inverted'
    },
    icon: {
      name: 'cancel_circle_outline',
      variant: 'neutral',
      modifier: 'inverted'
    }
  }
};
var renderIcon = function renderIcon(_ref) {
  var variant = _ref.variant;
  return /*#__PURE__*/React__default.createElement(Icon$1, {
    name: states[variant].icon.name,
    variant: states[variant].icon.variant,
    modifier: states[variant].icon.modifier,
    width: 32,
    height: 32
  });
};
var renderToast = function renderToast(_ref2) {
  var title = _ref2.title,
    description = _ref2.description,
    variant = _ref2.variant;
  return /*#__PURE__*/React__default.createElement(ToastBody, null, /*#__PURE__*/React__default.createElement("div", {
    className: "toast-body__icon"
  }, renderIcon({
    variant: variant
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "toast-body__text"
  }, title && /*#__PURE__*/React__default.createElement(H$1, {
    variant: states[variant].text.variant,
    modifier: states[variant].text.modifier,
    type: "6",
    weight: "bold"
  }, title), description && /*#__PURE__*/React__default.createElement(P$1, {
    variant: states[variant].text.variant,
    modifier: states[variant].text.modifier,
    type: "2",
    weight: "regular"
  }, description)));
};
var CloseButton$1 = function CloseButton(_ref3) {
  var closeToast = _ref3.closeToast,
    variant = _ref3.variant;
  return /*#__PURE__*/React__default.createElement(IconCloseWrapper, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "cancel_outline",
    variant: states[variant].icon.variant,
    modifier: states[variant].icon.modifier,
    cursor: "pointer",
    onClick: closeToast,
    width: 24,
    height: 24
  }));
};
var ToastButton = function ToastButton(_ref4) {
  var closeToast = _ref4.closeToast,
    label = _ref4.label,
    _onClick = _ref4.onClick,
    color = _ref4.color;
  return /*#__PURE__*/React__default.createElement(Button$3, {
    onClick: function onClick(ev) {
      _onClick(ev);
      closeToast();
    },
    color: color
  }, label);
};
var renderTertiaryButton = function renderTertiaryButton(_ref5) {
  var label = _ref5.label,
    onClick = _ref5.onClick,
    type = _ref5.type;
  return label && onClick && /*#__PURE__*/React__default.createElement(ToastButton, {
    onClick: onClick,
    label: label,
    color: type === 'warning' ? 'dark' : 'light'
  });
};
var renderCloseButtonSection = function renderCloseButtonSection(_ref6) {
  var closeButton = _ref6.closeButton,
    description = _ref6.description,
    onClick = _ref6.onClick,
    label = _ref6.label,
    type = _ref6.type;
  return closeButton && /*#__PURE__*/React__default.createElement(CloseButton$1, {
    variant: type
  }) || description && renderTertiaryButton({
    onClick: onClick,
    label: label,
    type: type
  });
};
var useToast$1 = {
  error: function error(_ref7) {
    var title = _ref7.title,
      id = _ref7.id,
      description = _ref7.description,
      closeButton = _ref7.closeButton,
      autoClose = _ref7.autoClose,
      tertiaryButtonOnClick = _ref7.tertiaryButtonOnClick,
      tertiaryButtonLabel = _ref7.tertiaryButtonLabel;
    toast.error(renderToast({
      title: title,
      description: description,
      variant: 'danger'
    }), {
      containerId: id,
      closeButton: renderCloseButtonSection({
        closeButton: closeButton,
        description: description,
        onClick: tertiaryButtonOnClick,
        label: tertiaryButtonLabel,
        type: 'danger'
      }),
      autoClose: autoClose
    });
  },
  success: function success(_ref8) {
    var title = _ref8.title,
      id = _ref8.id,
      description = _ref8.description,
      closeButton = _ref8.closeButton,
      autoClose = _ref8.autoClose,
      tertiaryButtonOnClick = _ref8.tertiaryButtonOnClick,
      tertiaryButtonLabel = _ref8.tertiaryButtonLabel;
    toast.success(renderToast({
      title: title,
      description: description,
      variant: 'success'
    }), {
      containerId: id,
      closeButton: renderCloseButtonSection({
        closeButton: closeButton,
        description: description,
        onClick: tertiaryButtonOnClick,
        label: tertiaryButtonLabel,
        type: 'success'
      }),
      autoClose: autoClose
    });
  },
  inProgress: function inProgress(_ref9) {
    var title = _ref9.title,
      id = _ref9.id,
      description = _ref9.description,
      closeButton = _ref9.closeButton,
      autoClose = _ref9.autoClose;
    toast.info(renderToast({
      title: title,
      description: description,
      variant: 'info'
    }), {
      containerId: id,
      closeButton: closeButton && /*#__PURE__*/React__default.createElement(CloseButton$1, {
        variant: "info"
      }),
      autoClose: autoClose
    });
  },
  info: function info(_ref10) {
    var title = _ref10.title,
      id = _ref10.id,
      description = _ref10.description,
      closeButton = _ref10.closeButton,
      autoClose = _ref10.autoClose,
      tertiaryButtonOnClick = _ref10.tertiaryButtonOnClick,
      tertiaryButtonLabel = _ref10.tertiaryButtonLabel;
    toast.info(renderToast({
      title: title,
      description: description,
      variant: 'info'
    }), {
      containerId: id,
      closeButton: renderCloseButtonSection({
        closeButton: closeButton,
        description: description,
        onClick: tertiaryButtonOnClick,
        label: tertiaryButtonLabel,
        type: 'info'
      }),
      autoClose: autoClose
    });
  },
  warning: function warning(_ref11) {
    var title = _ref11.title,
      id = _ref11.id,
      description = _ref11.description,
      closeButton = _ref11.closeButton,
      autoClose = _ref11.autoClose,
      tertiaryButtonOnClick = _ref11.tertiaryButtonOnClick,
      tertiaryButtonLabel = _ref11.tertiaryButtonLabel;
    toast.warning(renderToast({
      title: title,
      description: description,
      variant: 'warning'
    }), {
      containerId: id,
      closeButton: renderCloseButtonSection({
        closeButton: closeButton,
        description: description,
        onClick: tertiaryButtonOnClick,
        label: tertiaryButtonLabel,
        type: 'warning'
      }),
      autoClose: autoClose
    });
  },
  dismiss: function dismiss() {
    toast.dismiss();
  }
};
var Toast$2 = function Toast(_ref12) {
  var position = _ref12.position,
    autoClose = _ref12.autoClose,
    className = _ref12.className,
    id = _ref12.id,
    fullWidth = _ref12.fullWidth;
  return /*#__PURE__*/React__default.createElement(Toast$1, {
    enableMultiContainer: true,
    containerId: id,
    position: position,
    autoClose: autoClose,
    hideProgressBar: true,
    newestOnTop: true,
    closeOnClick: false,
    rtl: false,
    pauseOnFocusLoss: false,
    draggable: false,
    pauseOnHover: true,
    transition: Fade$1,
    className: "".concat(className, " ").concat(fullWidth && 'Toast__toast-body--md-full'),
    limit: 3,
    closeButton: false
  });
};
Toast$2.defaultProps = {
  position: 'top-right',
  fullWidth: false,
  autoClose: 5000
};
Toast$2.propTypes = {
  position: PropTypes.oneOf(['top-left', 'top-center', 'top-right', 'bottom-left', 'bottom-center', 'bottom-right']),
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string
};

var _templateObject$N, _templateObject2$F, _templateObject3$y, _templateObject4$q, _templateObject5$m, _templateObject6$j, _templateObject7$g, _templateObject8$d, _templateObject9$c, _templateObject10$b, _templateObject11$a, _templateObject12$6, _templateObject13$5, _templateObject14$4, _templateObject15$4, _templateObject16$3, _templateObject17$3, _templateObject18$3, _templateObject19$2, _templateObject20$2, _templateObject21$2, _templateObject22$2, _templateObject23$2, _templateObject24$1;
var Oval = styled.div(_templateObject$N || (_templateObject$N = _taggedTemplateLiteral(["\n  width: 10px;\n  height: 10px;\n  margin-right: 10px;\n  border-radius: 5px;\n\n  ", "\n"])), function (props) {
  return getOvalVariant(props.variant);
});
var StepCounter = styled.div(_templateObject2$F || (_templateObject2$F = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin-bottom: 30px;\n"])));
var StepContainer = styled.div(_templateObject3$y || (_templateObject3$y = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 30px;\n  background-color: ", ";\n  border-radius: 10px;\n\n  ", "\n"])), theme.oldColors['palette-background-cards'], function (props) {
  return props.border && css$1(_templateObject4$q || (_templateObject4$q = _taggedTemplateLiteral(["\n      box-shadow: 0px 0px 0px 1px ", ";\n    "])), theme.oldColors['border-grey-walkthrough']);
});
var StepFooter = styled.div(_templateObject5$m || (_templateObject5$m = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding-top: 30px;\n"])));
var ButtonsContainer = styled.div(_templateObject6$j || (_templateObject6$j = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n"])));
var TooltipContainer = styled.div(_templateObject7$g || (_templateObject7$g = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n\n  ", "\n\n  &:after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    ", "\n    ", "\n  }\n"])), function (_ref) {
  var bottom = _ref.bottom,
    left = _ref.left,
    right = _ref.right,
    top = _ref.top,
    width = _ref.width;
  return css$1(_templateObject8$d || (_templateObject8$d = _taggedTemplateLiteral(["\n    width: ", "px;\n    bottom: ", ";\n    left: ", ";\n    right: ", ";\n    top: ", ";\n  "])), width, bottom, left, right, top);
}, function (_ref2) {
  var position = _ref2.position;
  return styleByPosition[position];
}, function (_ref3) {
  var border = _ref3.border,
    position = _ref3.position;
  return border && shadowBorderByPosition[position];
});
var shadowBorderByPosition = {
  bottom: css$1(_templateObject9$c || (_templateObject9$c = _taggedTemplateLiteral(["\n    filter: drop-shadow(\n      0 -1px 0.6px ", "\n    );\n  "])), theme.oldColors['border-grey-walkthrough']),
  top: css$1(_templateObject10$b || (_templateObject10$b = _taggedTemplateLiteral(["\n    filter: drop-shadow(\n      0 1px 0.6px ", "\n    );\n  "])), theme.oldColors['border-grey-walkthrough']),
  left: css$1(_templateObject11$a || (_templateObject11$a = _taggedTemplateLiteral(["\n    filter: drop-shadow(\n      1px 0 0.6px ", "\n    );\n  "])), theme.oldColors['border-grey-walkthrough']),
  right: css$1(_templateObject12$6 || (_templateObject12$6 = _taggedTemplateLiteral(["\n    filter: drop-shadow(\n      -1px 0 0.6px ", "\n    );\n  "])), theme.oldColors['border-grey-walkthrough']),
  rightTop: css$1(_templateObject13$5 || (_templateObject13$5 = _taggedTemplateLiteral(["\n    filter: drop-shadow(\n      -1px 0 0.6px ", "\n    );\n  "])), theme.oldColors['border-grey-walkthrough'])
};
var styleByPosition = {
  bottom: css$1(_templateObject14$4 || (_templateObject14$4 = _taggedTemplateLiteral(["\n    bottom: 100%;\n    margin-left: -25px;\n    left: 50%;\n    border-bottom: solid 25px ", ";\n    border-left: solid 25px transparent;\n    border-right: solid 25px transparent;\n  "])), theme.oldColors['palette-background-cards']),
  top: css$1(_templateObject15$4 || (_templateObject15$4 = _taggedTemplateLiteral(["\n    top: 100%;\n    margin-left: -25px;\n    left: 50%;\n    border-top: solid 25px ", ";\n    border-left: solid 25px transparent;\n    border-right: solid 25px transparent;\n  "])), theme.oldColors['palette-background-cards']),
  left: css$1(_templateObject16$3 || (_templateObject16$3 = _taggedTemplateLiteral(["\n    left: 100%;\n    top: 5%;\n    border-left: solid 25px ", ";\n    border-top: solid 25px transparent;\n    border-bottom: solid 25px transparent;\n  "])), theme.oldColors['palette-background-cards']),
  right: css$1(_templateObject17$3 || (_templateObject17$3 = _taggedTemplateLiteral(["\n    right: 100%;\n    top: 5%;\n    border-right: solid 25px ", ";\n    border-top: solid 25px transparent;\n    border-bottom: solid 25px transparent;\n  "])), theme.oldColors['palette-background-cards']),
  rightTop: css$1(_templateObject18$3 || (_templateObject18$3 = _taggedTemplateLiteral(["\n    right: 100%;\n    top: 5%;\n    border-right: solid 25px ", ";\n    border-top: solid 25px transparent;\n    border-bottom: solid 25px transparent;\n  "])), theme.oldColors['palette-background-cards'])
};
var getOvalVariant = function getOvalVariant(variant) {
  switch (variant) {
    case 'neutral-3':
      return css$1(_templateObject19$2 || (_templateObject19$2 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), theme.oldColors['palette-neutral-n-3']);
    case 'primary':
      return css$1(_templateObject20$2 || (_templateObject20$2 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), theme.oldColors['palette-primary-p-1-p-1']);
  }
};
var Target = styled.div(_templateObject21$2 || (_templateObject21$2 = _taggedTemplateLiteral(["\n  position: absolute;\n\n  ", "\n  ", "\n  z-index: 1;\n  ", "\n"])), function (props) {
  return props.showOverlay && css$1(_templateObject22$2 || (_templateObject22$2 = _taggedTemplateLiteral(["\n      box-shadow: 2px 2px 2px 99999px rgba(0, 0, 0, 0.65);\n    "])));
}, function (_ref4) {
  var borderRadius = _ref4.borderRadius;
  return borderRadius && css$1(_templateObject23$2 || (_templateObject23$2 = _taggedTemplateLiteral(["\n      border-radius: ", ";\n    "])), borderRadius);
}, function (_ref5) {
  var bottom = _ref5.bottom,
    height = _ref5.height,
    left = _ref5.left,
    right = _ref5.right,
    top = _ref5.top,
    width = _ref5.width,
    x = _ref5.x,
    y = _ref5.y;
  return css$1(_templateObject24$1 || (_templateObject24$1 = _taggedTemplateLiteral(["\n    bottom: ", "px;\n    height: ", "px;\n    left: ", "px;\n    right: ", "px;\n    top: ", "px;\n    width: ", "px;\n    x: ", "px;\n    y: ", "px;\n  "])), bottom, height, left, right, top, width, x, y);
});

var tabbable_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var DISPLAY_NONE = "none";
var DISPLAY_CONTENTS = "contents";

var tabbableNode = /input|select|textarea|button|object|iframe/;

function isNotOverflowing(element, style) {
  return style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0;
}

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    var displayValue = style.getPropertyValue("display");
    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();
  while (parentElement) {
    if (parentElement === document.body) break;

    // if we are not hidden yet, skip to checking outside the Web Component
    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}
module.exports = exports["default"];
});

unwrapExports(tabbable_1);

var focusManager = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;



var _tabbable2 = _interopRequireDefault(tabbable_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log() {
  if (process.env.NODE_ENV !== "production") {
    console.log("focusManager ----------");
    focusLaterElements.forEach(function (f) {
      var check = f || {};
      console.log(check.nodeName, check.className, check.id);
    });
    console.log("end focusManager ----------");
  }
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}
});

unwrapExports(focusManager);
var focusManager_1 = focusManager.resetState;
var focusManager_2 = focusManager.log;
var focusManager_3 = focusManager.handleBlur;
var focusManager_4 = focusManager.handleFocus;
var focusManager_5 = focusManager.markForFocusLater;
var focusManager_6 = focusManager.returnFocus;
var focusManager_7 = focusManager.popWithoutFocus;
var focusManager_8 = focusManager.setupScopedFocus;
var focusManager_9 = focusManager.teardownScopedFocus;

var scopeTab_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;



var _tabbable2 = _interopRequireDefault(tabbable_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement();

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];
});

unwrapExports(scopeTab_1);

var exenv = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if ( module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());
});

var safeHTMLElement = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;



var _exenv2 = _interopRequireDefault(exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;
});

unwrapExports(safeHTMLElement);
var safeHTMLElement_1 = safeHTMLElement.canUseDOM;
var safeHTMLElement_2 = safeHTMLElement.SafeNodeList;
var safeHTMLElement_3 = safeHTMLElement.SafeHTMLCollection;

var ariaAppHider = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;



var _warning2 = _interopRequireDefault(warning_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log() {
  if (process.env.NODE_ENV !== "production") {
    var check = globalElement || {};
    console.log("ariaAppHider ----------");
    console.log(check.nodeName, check.className, check.id);
    console.log("end ariaAppHider ----------");
  }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}
});

unwrapExports(ariaAppHider);
var ariaAppHider_1 = ariaAppHider.resetState;
var ariaAppHider_2 = ariaAppHider.log;
var ariaAppHider_3 = ariaAppHider.assertNodeList;
var ariaAppHider_4 = ariaAppHider.setElement;
var ariaAppHider_5 = ariaAppHider.validateElement;
var ariaAppHider_6 = ariaAppHider.hide;
var ariaAppHider_7 = ariaAppHider.show;
var ariaAppHider_8 = ariaAppHider.documentNotReadyOrSSRTesting;

var classList = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log() {
  if (process.env.NODE_ENV !== "production") {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n  ";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n  ";
    }

    classes = document.body.className;

    buffer += "\n\ndoc.body (" + classes + "):\n  ";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n  ";
    }

    buffer += "\n";

    console.log(buffer);
  }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};
});

unwrapExports(classList);
var classList_1 = classList.resetState;
var classList_2 = classList.log;
var classList_3 = classList.add;
var classList_4 = classList.remove;

var portalOpenInstances_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.log = log;
exports.resetState = resetState;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Cannot register modal instance that's already open");
      }
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
      }
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

exports.default = portalOpenInstances;
});

unwrapExports(portalOpenInstances_1);
var portalOpenInstances_2 = portalOpenInstances_1.log;
var portalOpenInstances_3 = portalOpenInstances_1.resetState;

var bodyTrap_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;



var _portalOpenInstances2 = _interopRequireDefault(portalOpenInstances_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("React-Modal: Open instances > 0 expected");
    }
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);
});

unwrapExports(bodyTrap_1);
var bodyTrap_2 = bodyTrap_1.resetState;
var bodyTrap_3 = bodyTrap_1.log;

var ModalPortal_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();





var _propTypes2 = _interopRequireDefault(PropTypes);



var focusManager$1 = _interopRequireWildcard(focusManager);



var _scopeTab2 = _interopRequireDefault(scopeTab_1);



var ariaAppHider$1 = _interopRequireWildcard(ariaAppHider);



var classList$1 = _interopRequireWildcard(classList);



var _safeHTMLElement2 = _interopRequireDefault(safeHTMLElement);



var _portalOpenInstances2 = _interopRequireDefault(portalOpenInstances_1);



function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */
var isTabKey = function isTabKey(event) {
  return event.code === "Tab" || event.keyCode === 9;
};
var isEscKey = function isEscKey(event) {
  return event.code === "Escape" || event.keyCode === 27;
};

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName,
          parentSelector = _this$props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Remove classes.
      bodyOpenClassName && classList$1.remove(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList$1.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider$1.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager$1.returnFocus(_this.props.preventScroll);
          focusManager$1.teardownScopedFocus();
        } else {
          focusManager$1.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager$1.setupScopedFocus(_this.node);
          focusManager$1.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (isTabKey(event)) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (process.env.NODE_ENV !== "production") {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName,
          parentSelector = _props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Add classes.
      bodyOpenClassName && classList$1.add(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList$1.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider$1.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(React__default.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  parentSelector: _propTypes2.default.func,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];
});

unwrapExports(ModalPortal_1);

var _reactLifecyclesCompat = getCjsExportFromNamespace(reactLifecyclesCompat_es);

var Modal_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _reactDom2 = _interopRequireDefault(ReactDOM);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _ModalPortal2 = _interopRequireDefault(ModalPortal_1);



var ariaAppHider$1 = _interopRequireWildcard(ariaAppHider);



var _safeHTMLElement2 = _interopRequireDefault(safeHTMLElement);



function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider$1.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(React__default.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

if (process.env.NODE_ENV !== "production") {
  Modal.setCreateHTMLElement = function (fn) {
    return createHTMLElement = fn;
  };
}

exports.default = Modal;
});

unwrapExports(Modal_1);
var Modal_2 = Modal_1.bodyOpenClassName;
var Modal_3 = Modal_1.portalClassName;

var lib$4 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _Modal2 = _interopRequireDefault(Modal_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];
});

var ReactModal = unwrapExports(lib$4);

var _templateObject$O, _templateObject2$G, _templateObject3$z, _templateObject4$r, _templateObject5$n;
var ModalWrapper = styled.div(_templateObject$O || (_templateObject$O = _taggedTemplateLiteral(["\n  background: ", ";\n  ", "\n"])), theme.colors.neutral.bg.weak, function (_ref) {
  var sizeMd = _ref.sizeMd;
  return sizeMd ? "\n            margin: 10% auto;\n            border-radius: ".concat(theme.borderRadius['border-radius-2'], ";\n            ") : "\n            margin: 4% auto;\n            border-radius: ".concat(theme.borderRadius['border-radius-4'], ";\n            width: 504px;\n            @media ").concat(theme.sizesResponsive.xxs, " {\n              width: 100%;\n            }\n ");
});
var ModalContent = styled.div(_templateObject2$G || (_templateObject2$G = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var sizeMd = _ref2.sizeMd;
  return sizeMd ? "\n            min-height: 490px;\n            " : "\n            padding: ".concat(theme.spacing['spacing-11'], " ").concat(theme.spacing['spacing-13'], " ").concat(theme.spacing['spacing-9'], "\n            ").concat(theme.spacing['spacing-13'], ";\n            @media ").concat(theme.sizesResponsive.xxs, " {\n              padding: ").concat(theme.spacing['spacing-11'], " ").concat(theme.spacing['spacing-5'], " ").concat(theme.spacing['spacing-5'], "\n              ").concat(theme.spacing['spacing-5'], ";\n            }\n ");
});
var ModalIconBase = styled.div(_templateObject3$z || (_templateObject3$z = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n"])));
var IconWrapper$2 = styled.div(_templateObject4$r || (_templateObject4$r = _taggedTemplateLiteral(["\n  position: absolute;\n  margin-top: ", ";\n  margin-right: ", ";\n"])), theme.spacing['spacing-5'], theme.spacing['spacing-5']);
var IconMd = styled.img(_templateObject5$n || (_templateObject5$n = _taggedTemplateLiteral(["\n  cursor: pointer;\n  padding-top: 10px;\n  padding-right: 10px;\n"])));

var CloseIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"24\" viewBox=\"0 0 25 24\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <g fill=\"#5D5E68\">\n            <g>\n                <g>\n                    <path d=\"M12 22.005c5.482 0 10-4.528 10-10.01 0-5.472-4.528-10-10-10-5.482 0-10 4.528-10 10 0 5.482 4.528 10.01 10 10.01zm0-1.446c-4.738 0-8.553-3.816-8.553-8.564C3.447 7.257 7.252 3.44 12 3.44c4.738 0 8.553 3.816 8.564 8.554.01 4.748-3.816 8.564-8.564 8.564zm-3.428-4.434c-.388 0-.691-.304-.691-.682 0-.188.073-.356.21-.492l2.934-2.935L8.09 9.07c-.136-.126-.21-.293-.21-.482 0-.388.304-.681.692-.681.2 0 .346.073.483.21L12 11.05l2.956-2.945c.147-.147.293-.21.482-.21.378 0 .692.304.692.682 0 .188-.073.335-.22.482l-2.935 2.956 2.935 2.935c.136.136.21.293.21.492 0 .378-.304.682-.692.682-.2 0-.367-.074-.503-.21L12 12.98l-2.925 2.935c-.136.147-.304.21-.503.21z\" transform=\"translate(-1393 -20) translate(1065.5) translate(328 20)\"/>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>";

var widthBySize = {
  md: '510px'
};
var Modal = function Modal(_ref) {
  var children = _ref.children,
    onDismiss = _ref.onDismiss,
    isOpen = _ref.isOpen,
    size = _ref.size,
    _ref$showOverlay = _ref.showOverlay,
    showOverlay = _ref$showOverlay === void 0 ? true : _ref$showOverlay,
    _ref$shouldCloseOnOve = _ref.shouldCloseOnOverlayClick,
    shouldCloseOnOverlayClick = _ref$shouldCloseOnOve === void 0 ? true : _ref$shouldCloseOnOve;
  var sizeMd = size === 'md';
  return /*#__PURE__*/React__default.createElement(ReactModal, {
    isOpen: isOpen,
    className: "modal-size-".concat(size),
    onRequestClose: function onRequestClose() {
      return onDismiss && onDismiss(false);
    },
    style: {
      overlay: {
        background: showOverlay ? 'rgba(0,0,0,0.65)' : 'transparent',
        zIndex: 1
      },
      content: {
        width: sizeMd && widthBySize[size],
        margin: sizeMd ? '0 auto' : '0 16px'
      }
    },
    shouldFocusAfterRender: false,
    ariaHideApp: false,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
  }, /*#__PURE__*/React__default.createElement(ModalWrapper, {
    sizeMd: sizeMd,
    "data-testid": "modal-wrapper"
  }, /*#__PURE__*/React__default.createElement(ModalIconBase, null, onDismiss && (sizeMd ? /*#__PURE__*/React__default.createElement(IconMd, {
    onClick: onDismiss,
    src: CloseIcon
  }) : /*#__PURE__*/React__default.createElement(IconWrapper$2, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    onClick: onDismiss,
    width: 24,
    height: 24,
    cursor: "pointer",
    name: "cancel_outline"
  })))), /*#__PURE__*/React__default.createElement(ModalContent, {
    sizeMd: sizeMd
  }, children)));
};

var createElement$1 = function createElement(id, targetElementContainer) {
  var element = document.createElement('div');
  element.setAttribute('id', id);
  if (!targetElementContainer) {
    document.body.appendChild(element);
  } else {
    targetElementContainer.appendChild(element);
  }
  return element;
};
var usePortal = function usePortal(id, targetElementContainer) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    element = _useState2[0],
    setElement = _useState2[1];
  useEffect(function () {
    if (!element) {
      var existDomElement = document.querySelector("#".concat(id));
      if (!existDomElement) {
        existDomElement = createElement$1(id, targetElementContainer);
      }
      setElement(existDomElement);
    }
  }, []);
  return element;
};

var WithTarget = function WithTarget(_ref) {
  var target = _ref.target,
    position = _ref.position,
    children = _ref.children,
    showOverlay = _ref.showOverlay,
    border = _ref.border;
  var targetDom = usePortal('walkthrough-target');
  useEffect(function () {
    if (targetDom) {
      targetDom.style.position = 'fixed';
      targetDom.style.zIndex = '1';
      targetDom.style.inset = '0';
    }
    return function () {
      if (targetDom) {
        targetDom.style.position = null;
        targetDom.style.zIndex = null;
        targetDom.style.inset = null;
      }
    };
  }, [targetDom]);
  if (!targetDom) return false;
  var props = target.getBoundingClientRect().toJSON();
  var _window$getComputedSt = window.getComputedStyle(target),
    borderRadius = _window$getComputedSt.borderRadius;
  var newProps = _objectSpread2(_objectSpread2({}, props), {}, {
    borderRadius: borderRadius
  });
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Target, _extends({}, newProps, {
    showOverlay: showOverlay
  })), /*#__PURE__*/React__default.createElement(Tooltip$2, {
    target: props,
    position: position,
    border: border
  }, children)), targetDom);
};
var Tooltip$2 = function Tooltip(_ref2) {
  var position = _ref2.position,
    target = _ref2.target,
    children = _ref2.children,
    border = _ref2.border;
  var tooltipDom = usePortal('tooltip');
  if (!tooltipDom) return false;
  var spaceTooltipToTarget = 25;
  var spaceArrowToTarget = 5;
  var width = 370;
  var propsByPosition = {
    bottom: {
      top: "".concat(target.bottom + spaceTooltipToTarget + spaceArrowToTarget, "px"),
      left: "".concat(target.left + target.width / 2 - width / 2, "px")
    },
    top: {
      bottom: "calc(100vh - ".concat(target.top - spaceTooltipToTarget - spaceArrowToTarget, "px)"),
      left: "".concat(target.left + target.width / 2 - width / 2, "px")
    },
    left: {
      right: "calc(100vw - ".concat(target.left - spaceTooltipToTarget - spaceArrowToTarget, "px)"),
      top: "calc(".concat(target.top + target.height / 2, "px - 5%)")
    },
    right: {
      left: "".concat(target.left + target.width + spaceTooltipToTarget + spaceArrowToTarget, "px"),
      top: "calc(".concat(target.top + target.height / 2, "px - 5%)")
    },
    rightTop: {
      left: "".concat(target.left + target.width + spaceTooltipToTarget + spaceArrowToTarget, "px"),
      top: "calc(".concat(target.top + 10, "px - 5%)")
    }
  };
  var align = propsByPosition[position];
  var render = function render() {
    return /*#__PURE__*/React__default.createElement(TooltipContainer, _extends({}, align, {
      width: width,
      position: position,
      border: border
    }), children);
  };
  return /*#__PURE__*/ReactDOM.createPortal(render(), tooltipDom);
};

var Buttons$1 = function Buttons(_ref) {
  var step = _ref.step,
    stepData = _ref.stepData,
    nextStep = _ref.nextStep,
    endStep = _ref.endStep;
  var buttons = {
    firststep: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Button$1, {
      size: "md",
      onClick: nextStep
    }, stepData.nextLabel || /*#__PURE__*/React__default.createElement(Span$1, {
      type: "2",
      variant: "white",
      align: "center"
    }, "Iniciar el tutorial"))), /*#__PURE__*/React__default.createElement("div", null, stepData.skipButton && (stepData.skipLabel || /*#__PURE__*/React__default.createElement(Button$1, {
      size: "md",
      onClick: endStep,
      variant: "none"
    }, /*#__PURE__*/React__default.createElement(Span$1, {
      type: "4",
      variant: "link",
      align: "center"
    }, "Omitir"))))),
    laststep: /*#__PURE__*/React__default.createElement(Button$1, {
      size: "md",
      onClick: endStep
    }, stepData.skipLabel || /*#__PURE__*/React__default.createElement(Span$1, {
      type: "2",
      variant: "white",
      align: "center"
    }, "Finalizar")),
    middlestep: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Button$1, {
      size: "md",
      onClick: nextStep
    }, /*#__PURE__*/React__default.createElement(Span$1, {
      type: "2",
      variant: "white",
      align: "center"
    }, "Siguiente"))), /*#__PURE__*/React__default.createElement("div", null, stepData.skipButton && (stepData.skipLabel || /*#__PURE__*/React__default.createElement(Button$1, {
      size: "md",
      onClick: endStep,
      variant: "none"
    }, /*#__PURE__*/React__default.createElement(Span$1, {
      type: "4",
      variant: "link",
      align: "center"
    }, "Omitir")))))
  };
  return buttons[step];
};

var Walkthrough = function Walkthrough(_ref) {
  var steps = _ref.steps,
    show = _ref.show,
    onFinish = _ref.onFinish,
    _ref$showOverlay = _ref.showOverlay,
    showOverlay = _ref$showOverlay === void 0 ? true : _ref$showOverlay,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? false : _ref$border;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentStep = _useState2[0],
    setCurrentStep = _useState2[1];
  useEffect(function () {
    if (currentStep !== 0) {
      setCurrentStep(0);
    }
  }, [show]);
  var _steps$currentStep = steps[currentStep],
    render = _steps$currentStep.render,
    position = _steps$currentStep.position,
    target = _steps$currentStep.target;
  var isLastStep = currentStep === steps.length - 1;
  var endStep = function endStep() {
    return onFinish();
  };
  var nextStep = function nextStep() {
    return !isLastStep ? setCurrentStep(function (actual) {
      return actual + 1;
    }) : endStep();
  };
  var currentTypeStep = currentStep === 0 ? 'firststep' : isLastStep ? 'laststep' : 'middlestep';
  var getStepRender = function getStepRender() {
    return /*#__PURE__*/React__default.createElement(StepContainer, {
      border: !!border
    }, render, /*#__PURE__*/React__default.createElement(StepFooter, null, steps.length > 1 && /*#__PURE__*/React__default.createElement(StepCounter, null, steps.map(function (step, index) {
      return /*#__PURE__*/React__default.createElement(Oval, {
        key: "steps-oval-".concat(index),
        variant: currentStep === index ? 'primary' : 'neutral-3'
      });
    })), /*#__PURE__*/React__default.createElement(ButtonsContainer, null, /*#__PURE__*/React__default.createElement(Buttons$1, {
      step: currentTypeStep,
      stepData: steps[currentStep],
      endStep: endStep,
      nextStep: nextStep
    }))));
  };
  if (!show) return false;
  var targetElement = document.querySelector(target);
  if (!targetElement) {
    return /*#__PURE__*/React__default.createElement(WithoutTarget, {
      showOverlay: showOverlay
    }, getStepRender());
  }
  return /*#__PURE__*/React__default.createElement(WithTarget, {
    target: targetElement,
    position: position,
    showOverlay: showOverlay,
    border: !!border
  }, getStepRender(), targetElement.scrollIntoView(true));
};
var WithoutTarget = function WithoutTarget(_ref2) {
  var children = _ref2.children,
    showOverlay = _ref2.showOverlay;
  return /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: true,
    size: "md",
    showOverlay: showOverlay
  }, children);
};

var useFilters = function useFilters(initialValue) {
  var _useState = useState(initialValue || {}),
    _useState2 = _slicedToArray(_useState, 2),
    filters = _useState2[0],
    setFilters = _useState2[1];
  var handleSetFilters = function handleSetFilters(filter) {
    return setFilters(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), filter);
    });
  };
  var setFilter = function setFilter(name) {
    return function (filter) {
      return handleSetFilters(_defineProperty({}, name, filter));
    };
  };
  return {
    filters: filters,
    setFilter: setFilter,
    addFilters: handleSetFilters
  };
};

var _excluded$h = ["name"];
var FilterContext = /*#__PURE__*/createContext$1();
var Provider$1 = FilterContext.Provider;
var EMPTY_FUNCTION = function EMPTY_FUNCTION() {
  return function () {
    return {};
  };
};
var useFilterContext = function useFilterContext(name) {
  var _filters$name;
  var _useContext = useContext(FilterContext),
    filters = _useContext.filters,
    _useContext$setFilter = _useContext.setFilter,
    setFilter = _useContext$setFilter === void 0 ? EMPTY_FUNCTION : _useContext$setFilter;
  return [(_filters$name = filters[name]) === null || _filters$name === void 0 ? void 0 : _filters$name.value, setFilter(name)];
};
var withFilterContext = function withFilterContext(Component, _ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$h);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var _useFilterContext = useFilterContext(name),
    _useFilterContext2 = _slicedToArray(_useFilterContext, 2),
    filterValue = _useFilterContext2[0],
    setFilterValue = _useFilterContext2[1];
  return /*#__PURE__*/React__default.createElement(Component, _extends({}, props, {
    filterValue: filterValue,
    setFilterValue: setFilterValue
  }));
};

var _templateObject$P, _templateObject2$H, _templateObject3$A, _templateObject4$s, _templateObject5$o, _templateObject6$k, _templateObject7$h, _templateObject8$e, _templateObject9$d, _templateObject10$c, _templateObject11$b;
var FilterChipsWrapper = styled.div(_templateObject$P || (_templateObject$P = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-top: ", ";\n"])), theme.spacing['spacing-8']);
var FiltersChips = styled.div(_templateObject2$H || (_templateObject2$H = _taggedTemplateLiteral(["\n  display: flex;\n  margin-left: ", ";\n  margin-right: ", ";\n"])), theme.spacing['spacing-4'], theme.spacing['spacing-5']);
var FilterWrapper = styled.div(_templateObject3$A || (_templateObject3$A = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: relative;\n"])));
var AdvancedFiltersPopper = styled.div(_templateObject4$s || (_templateObject4$s = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 10;\n  box-shadow: ", ";\n"])), theme.elevations['elevation-3']);
var AdvancedButtonWrapper = styled.div(_templateObject5$o || (_templateObject5$o = _taggedTemplateLiteral(["\n  position: relative;\n  align-self: flex-end;\n"])));
var AdvancedFiltersWrapper = styled.div(_templateObject6$k || (_templateObject6$k = _taggedTemplateLiteral(["\n  width: 550px;\n"])));
var AdvancedFiltersHeader = styled.div(_templateObject7$h || (_templateObject7$h = _taggedTemplateLiteral([""])));
var AdvancedFiltersBody = styled.div(_templateObject8$e || (_templateObject8$e = _taggedTemplateLiteral(["\n  padding-top: ", ";\n"])), theme.spacing['spacing-6']);
var AdvancedFiltersButtons = styled.div(_templateObject9$d || (_templateObject9$d = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: right;\n  margin-top: ", ";\n  button:first-child {\n    margin-right: ", ";\n  }\n"])), theme.spacing['spacing-7'], theme.spacing['spacing-5']);
var FiltersWrapper = styled.div(_templateObject10$c || (_templateObject10$c = _taggedTemplateLiteral(["\n  margin-right: ", ";\n"])), theme.spacing['spacing-4']);
var FilterChipWrapper = styled.div(_templateObject11$b || (_templateObject11$b = _taggedTemplateLiteral(["\n  margin-right: ", ";\n"])), theme.spacing['spacing-4']);

/* eslint-disable react-hooks/rules-of-hooks */
var FiltersChilds = function FiltersChilds(_ref) {
  var children = _ref.children,
    setFilter = _ref.setFilter,
    filters = _ref.filters;
  return Children.toArray(children).map(function (child, index) {
    var _filters$child$props$;
    return /*#__PURE__*/React__default.createElement(FiltersWrapper, {
      key: "filter-container-".concat(index)
    }, child.props.filterValue ? child : /*#__PURE__*/React__default.cloneElement(child, {
      setFilterValue: setFilter(child.props.name),
      filterValue: (_filters$child$props$ = filters[child.props.name]) === null || _filters$child$props$ === void 0 ? void 0 : _filters$child$props$.value
    }));
  });
};

var AdvancedFilters = function AdvancedFilters(_ref) {
  var filters = _ref.filters,
    children = _ref.children,
    open = _ref.open,
    onChange = _ref.onChange,
    onCancel = _ref.onCancel;
  var _useFilters = useFilters(filters),
    advanced = _useFilters.filters,
    setFilter = _useFilters.setFilter,
    addFilters = _useFilters.addFilters;
  useEffect(function () {
    return addFilters(filters);
  }, [filters]);
  var handleChangeFilters = function handleChangeFilters() {
    return onChange({
      advanced: advancedWithNoError(advanced)
    });
  };
  var advancedWithNoError = function advancedWithNoError(adv) {
    return Object.keys(adv).reduce(function (acc, key) {
      var filter = adv[key];
      if (filter) {
        return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, key, {
          value: filter.value,
          type: filter.type
        }));
      }
      return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, key, null));
    }, {});
  };
  var handleCancel = function handleCancel(e) {
    addFilters(fillObject(advanced, null));
    onCancel(e);
  };
  return /*#__PURE__*/React__default.createElement(Provider$1, {
    value: {
      filters: advanced,
      setFilter: setFilter
    }
  }, open && /*#__PURE__*/React__default.createElement(OutsideAlerter, {
    handleOutSideClick: handleCancel
  }, /*#__PURE__*/React__default.createElement(AdvancedFiltersPopper, null, /*#__PURE__*/React__default.createElement(Card$1, {
    spacing: "6"
  }, /*#__PURE__*/React__default.createElement(AdvancedFiltersWrapper, null, /*#__PURE__*/React__default.createElement(AdvancedFiltersHeader, null, /*#__PURE__*/React__default.createElement(Span$1, {
    type: "1",
    variant: "neutral",
    weight: "bold"
  }, "Filtrar por")), /*#__PURE__*/React__default.createElement(AdvancedFiltersBody, null, /*#__PURE__*/React__default.createElement(FiltersChilds, {
    setFilter: setFilter,
    filters: advanced
  }, children))), /*#__PURE__*/React__default.createElement(AdvancedFiltersButtons, null, /*#__PURE__*/React__default.createElement(Button$1, {
    size: "sm",
    variant: "secondary",
    onClick: handleCancel
  }, "Cancelar"), /*#__PURE__*/React__default.createElement(Button$1, {
    size: "sm",
    variant: "primary",
    disabled: !hasValues(advanced) || Object.values(advanced).some(function (item) {
      return item === null || item === void 0 ? void 0 : item.error;
    }),
    onClick: handleChangeFilters
  }, "Aplicar"))))));
};
AdvancedFilters.displayName = 'AdvancedFilters';

var typeFilters = {
  EQUALS: 'equals',
  RANGE: 'range',
  IN: 'in',
  CONTAINS: 'contains',
  NONE: ''
};

var EqualFilter = function EqualFilter(_ref) {
  var children = _ref.children,
    setFilterValue = _ref.setFilterValue,
    filterValue = _ref.filterValue;
  var _useState = useState(filterValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var hasChanges = function hasChanges() {
    return filterValue !== value;
  };
  useEffect(function () {
    hasChanges() && setValue(filterValue);
  }, [filterValue]);
  useEffect(function () {
    if (hasChanges()) {
      if (value) {
        setFilterValue({
          type: typeFilters.EQUALS,
          value: value
        });
      } else {
        setFilterValue(null);
      }
    }
  }, [value]);
  return children({
    setValue: setValue,
    value: value
  });
};
EqualFilter.propTypes = {
  children: PropTypes.func.isRequired,
  setFilterValue: PropTypes.func.isRequired
};

var getWithoutSymbol = function getWithoutSymbol(value) {
  return value === null || value === void 0 ? void 0 : value.replace('$', '');
};
var isInteger = function isInteger(value) {
  return /^\$?-?\d+$/.test(getWithoutSymbol(value));
};
var isDecimal = function isDecimal(value) {
  return /^-?\$?\d+\.\d{2}$/.test(getWithoutSymbol(value));
};
var isNumeric$1 = function isNumeric(value) {
  return isInteger(value) || isDecimal(value);
};
var renderPillText = function renderPillText(filter) {
  if (filter.type === typeFilters.RANGE) {
    var filterValues = filter.value.map(function (value) {
      if (isNumeric$1(value)) {
        return value >= 0 ? '$' + value : '-$' + value.slice(1);
      }
    });
    if (isNumeric$1(filterValues[0]) && isNumeric$1(filterValues[1])) {
      return filterValues.join(' a ');
    }
    if (!filterValues[0]) {
      filterValues[0] = 'Hasta';
      return filterValues.join(' ');
    }
    if (!filterValues[1]) {
      filterValues[1] = 'Más de';
      return filterValues.reverse().join(' ');
    }
    return filterValues;
  } else {
    if (Array.isArray(filter.value)) return filter.value.join(' - ');
    return isDecimal(filter.value) ? '$' + filter.value : filter.value;
  }
};
var FilterPills = function FilterPills(_ref) {
  var filters = _ref.filters,
    removeFilter = _ref.removeFilter,
    clearFilters = _ref.clearFilters;
  var FilterPill = function FilterPill(filterKey) {
    return filters[filterKey] && /*#__PURE__*/React__default.createElement(FilterChipWrapper, null, /*#__PURE__*/React__default.createElement(Chip$1, {
      value: filters[filterKey].value,
      text: renderPillText(filters[filterKey]),
      onClickClose: function onClickClose() {
        return removeFilter(filterKey);
      },
      closeButton: true
    }));
  };
  return /*#__PURE__*/React__default.createElement(FilterChipsWrapper, null, /*#__PURE__*/React__default.createElement(Span$1, {
    type: "2",
    variant: "neutral",
    modifier: "strong"
  }, "Filtrado por:"), /*#__PURE__*/React__default.createElement(FiltersChips, null, Object.keys(filters).map(FilterPill)), hasValues(filters) && /*#__PURE__*/React__default.createElement(Link$1, {
    variant: "primary",
    size: "sm",
    onClick: clearFilters
  }, "Limpiar Filtros"));
};

var _excluded$i = ["advanced"];
var Filters = function Filters(_ref) {
  var onChange = _ref.onChange,
    children = _ref.children,
    initialValue = _ref.initialValue,
    _ref$showPills = _ref.showPills,
    showPills = _ref$showPills === void 0 ? true : _ref$showPills;
  var _useFilters = useFilters(initialValue),
    allFilters = _useFilters.filters,
    setFilter = _useFilters.setFilter,
    addFilters = _useFilters.addFilters;
  var advanced = allFilters.advanced,
    filters = _objectWithoutProperties(allFilters, _excluded$i);
  var mergedFilters = _objectSpread2(_objectSpread2({}, filters), advanced);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openAdvancedFilters = _useState2[0],
    setOpenAdvancedFilters = _useState2[1];
  var handleApplyFilters = function handleApplyFilters() {
    onChange && onChange(mergedFilters);
  };
  useEffect(function () {
    hasKeys(mergedFilters) && handleApplyFilters();
  }, [allFilters]);
  var _getFiltersChildrens = getFiltersChildrens(children),
    normalFilters = _getFiltersChildrens.normalFilters,
    advancedFilters = _getFiltersChildrens.advancedFilters;
  var handleAdvancedFiltersChange = function handleAdvancedFiltersChange(filters) {
    addFilters(filters);
    setOpenAdvancedFilters(false);
  };
  var handleAdvancedCancel = function handleAdvancedCancel() {
    setOpenAdvancedFilters(false);
  };
  var removeAdvancedFilter = function removeAdvancedFilter(name) {
    return addFilters({
      advanced: _objectSpread2(_objectSpread2({}, advanced), {}, _defineProperty({}, name, null))
    });
  };
  var clearAdvancedFilters = function clearAdvancedFilters() {
    addFilters(_objectSpread2(_objectSpread2({}, filters), {}, {
      advanced: fillObject(advanced, null)
    }));
  };
  return /*#__PURE__*/React__default.createElement(Provider$1, {
    value: {
      filters: filters,
      setFilter: setFilter
    }
  }, /*#__PURE__*/React__default.createElement(FilterWrapper, null, /*#__PURE__*/React__default.createElement(FiltersChilds, {
    setFilter: setFilter,
    filters: filters
  }, normalFilters), advancedFilters && /*#__PURE__*/React__default.createElement(AdvancedButtonWrapper, null, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: function onClick() {
      return setOpenAdvancedFilters(function (open) {
        return !open;
      });
    },
    icon: "sliders_outline",
    size: "md",
    variant: "secondary",
    iconAlign: "right"
  }, "Filtros"), /*#__PURE__*/React__default.createElement(AdvancedFilters, {
    filters: advanced,
    open: openAdvancedFilters,
    onChange: handleAdvancedFiltersChange,
    onCancel: handleAdvancedCancel
  }, advancedFilters))), showPills && hasValues(advanced) && /*#__PURE__*/React__default.createElement(FilterPills, {
    filters: advanced || {},
    removeFilter: removeAdvancedFilter,
    clearFilters: clearAdvancedFilters
  }));
};
var getFiltersChildrens = function getFiltersChildrens(children) {
  var filtersChildrens = Children.toArray(children);
  var indexAdvancedFilter = filtersChildrens.findIndex(function (component) {
    return component.type.displayName === 'AdvancedFilters';
  });
  var hasAdvancedFilter = filtersChildrens.find(function (component) {
    return component.type.displayName === 'AdvancedFilters';
  });
  var advancedFilters = null;
  var normalFilters = _toConsumableArray(filtersChildrens);
  if (hasAdvancedFilter) {
    advancedFilters = filtersChildrens[indexAdvancedFilter].props.children;
    normalFilters = [].concat(_toConsumableArray(filtersChildrens.slice(0, indexAdvancedFilter)), _toConsumableArray(filtersChildrens.slice(indexAdvancedFilter + 1)));
  }
  return {
    normalFilters: normalFilters,
    advancedFilters: advancedFilters
  };
};
Filters.defaultProps = {
  showPills: true
};
Filters.protoTypes = {
  showPills: PropTypes.bool,
  onChange: PropTypes.func
};

var InFilter = function InFilter(_ref) {
  var children = _ref.children,
    setFilterValue = _ref.setFilterValue,
    filterValue = _ref.filterValue,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? function () {
      return false;
    } : _ref$validate;
  var _useState = useState(filterValue),
    _useState2 = _slicedToArray(_useState, 2),
    inValues = _useState2[0],
    setInValues = _useState2[1];
  var hasChanges = function hasChanges() {
    if (inValues && filterValue) {
      if ((inValues === null || inValues === void 0 ? void 0 : inValues.length) !== (filterValue === null || filterValue === void 0 ? void 0 : filterValue.length)) return true;
      var uniqueValues = new Set([].concat(_toConsumableArray(inValues), _toConsumableArray(filterValue)));
      var _iterator = _createForOfIteratorHelper(uniqueValues),
        _step;
      try {
        var _loop = function _loop() {
          var v = _step.value;
          var aCount = inValues.filter(function (e) {
            return e === v;
          }).length;
          var bCount = filterValue.filter(function (e) {
            return e === v;
          }).length;
          if (aCount !== bCount) return {
            v: true
          };
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();
          if (_typeof(_ret) === "object") return _ret.v;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return inValues !== filterValue;
  };
  useEffect(function () {
    hasChanges() && setInValues(filterValue);
  }, [filterValue]);
  useEffect(function () {
    if (hasChanges()) {
      if ((inValues === null || inValues === void 0 ? void 0 : inValues.length) > 0) {
        setFilterValue({
          type: typeFilters.IN,
          value: inValues,
          error: validate(inValues)
        });
      } else {
        setFilterValue(null);
      }
    }
  }, [inValues]);
  return children({
    setValues: setInValues,
    values: inValues
  });
};
InFilter.propTypes = {
  children: PropTypes.func.isRequired,
  setFilterValue: PropTypes.func.isRequired
};

var RangeFilter = function RangeFilter(_ref) {
  var children = _ref.children,
    setFilterValue = _ref.setFilterValue,
    filterValue = _ref.filterValue,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? function () {
      return false;
    } : _ref$validate;
  var getValue = function getValue() {
    return filterValue ? _typeof(filterValue) == 'object' ? filterValue : [filterValue, filterValue] : null;
  };
  var _useState = useState(getValue()),
    _useState2 = _slicedToArray(_useState, 2),
    rangeValues = _useState2[0],
    setRangeValues = _useState2[1];
  var hasChanges = function hasChanges() {
    if (rangeValues && getValue()) {
      return rangeValues[0] != getValue()[0] || rangeValues[1] != getValue()[1];
    }
    return rangeValues != getValue();
  };
  useEffect(function () {
    hasChanges() && setRangeValues(getValue());
  }, [filterValue]);
  useEffect(function () {
    if (hasChanges()) {
      if (rangeValues && (rangeValues[0] || rangeValues[1])) {
        if (rangeValues[0] === rangeValues[1]) {
          setFilterValue({
            type: typeFilters.EQUALS,
            value: rangeValues[0],
            error: validate(rangeValues)
          });
        } else {
          setFilterValue({
            type: typeFilters.RANGE,
            value: Object.values(rangeValues).map(function (value) {
              return value || '';
            }),
            error: validate(rangeValues)
          });
        }
      } else {
        setFilterValue(null);
      }
    }
  }, [rangeValues]);
  var setFrom = function setFrom(from) {
    return setRangeValues([from, rangeValues ? rangeValues[1] : '']);
  };
  var setTo = function setTo(to) {
    return setRangeValues([rangeValues ? rangeValues[0] : '', to]);
  };
  var hasError = function hasError() {
    return validate(rangeValues);
  };
  return children({
    setFrom: setFrom,
    setTo: setTo,
    fromValue: rangeValues ? rangeValues[0] : undefined,
    toValue: rangeValues ? rangeValues[1] : undefined,
    setRangeValues: setRangeValues,
    error: hasError()
  });
};
RangeFilter.propTypes = {
  children: PropTypes.func.isRequired,
  setFilterValue: PropTypes.func.isRequired
};

var ContainsFilter = function ContainsFilter(_ref) {
  var children = _ref.children,
    setFilterValue = _ref.setFilterValue,
    filterValue = _ref.filterValue,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? function () {
      return false;
    } : _ref$validate;
  var _useState = useState(filterValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var hasChanges = function hasChanges() {
    return filterValue !== value;
  };
  useEffect(function () {
    hasChanges() && setValue(filterValue);
  }, [filterValue]);
  useEffect(function () {
    if (hasChanges()) {
      if (value) {
        setFilterValue({
          type: typeFilters.CONTAINS,
          value: value,
          error: validate(value)
        });
      } else {
        setFilterValue(null);
      }
    }
  }, [value]);
  return children({
    setValue: setValue,
    value: value
  });
};
ContainsFilter.propTypes = {
  children: PropTypes.func.isRequired,
  setFilterValue: PropTypes.func.isRequired
};

var Filter = {
  Equal: EqualFilter,
  Range: RangeFilter,
  In: InFilter,
  Contains: ContainsFilter
};
var Equal = function Equal(props) {
  return withFilterContext(Filter.Equal, props);
};
var Range = function Range(props) {
  return withFilterContext(Filter.Range, props);
};
var In = function In(props) {
  return withFilterContext(Filter.In, props);
};

var _templateObject$Q, _templateObject2$I, _templateObject3$B, _templateObject4$t, _templateObject5$p, _templateObject6$l, _templateObject7$i, _templateObject8$f, _templateObject9$e, _templateObject10$d, _templateObject11$c, _templateObject12$7, _templateObject13$6;
var TextArea = styled.div(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteral(["\n  width: 100%;\n  position: relative;\n\n  textarea:-webkit-autofill,\n  textarea:-webkit-autofill:hover,\n  textarea:-webkit-autofill:focus,\n  textarea:-webkit-autofill:active {\n    -webkit-transition: 'color 9999s ease-out, background-color 9999s ease-out';\n    -webkit-transition-delay: 9999s;\n  }\n"])));
var LabelWrapper$2 = styled.div(_templateObject2$I || (_templateObject2$I = _taggedTemplateLiteral(["\n  padding: ", " ", "\n    ", " ", ";\n  display: flex;\n"])), theme.spacing['spacing-2'], theme.spacing['spacing-2'], theme.spacing['spacing-2'], theme.spacing['spacing-5']);
var IconBaseTextArea = styled.div(_templateObject3$B || (_templateObject3$B = _taggedTemplateLiteral(["\n  align-self: flex-start;\n"])));
var BaseTextArea = styled.div.attrs({
  'data-testid': 'base-text-area'
})(_templateObject4$t || (_templateObject4$t = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  padding: ", " ", "\n    ", " ", ";\n  display: flex;\n  align-items: center;\n  width: 100%;\n  ", ";\n\n  &:focus,\n  &:focus-visible {\n    outline: none;\n  }\n\n  outline: none;\n\n  &::-moz-focus-inner {\n    border: 0;\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"])), theme.colors.neutral.bg.weak, theme.borderRadius['border-radius-3'], theme.spacing['spacing-3'], theme.spacing['spacing-3'], theme.spacing['spacing-3'], theme.spacing['spacing-5'], theme.textStyles['text-preset-9'], function (_ref) {
  var hasFocus = _ref.hasFocus;
  return css$1(_templateObject5$p || (_templateObject5$p = _taggedTemplateLiteral(["\n      box-shadow: inset 0 0 0 1px\n        ", ";\n      textarea {\n        caret-color: ", ";\n      }\n    "])), theme.colors["".concat(hasFocus ? 'secondary-1' : 'neutral')].border.regular, theme.colors['secondary-1'].border.regular);
}, function (_ref2) {
  var status = _ref2.status;
  return status === 'error' && css$1(_templateObject6$l || (_templateObject6$l = _taggedTemplateLiteral(["\n      box-shadow: inset 0 0 0 1px ", ";\n      textarea {\n        caret-color: ", ";\n      }\n    "])), theme.colors['danger'].border.regular, theme.colors['danger'].border.regular);
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled === true && css$1(_templateObject7$i || (_templateObject7$i = _taggedTemplateLiteral(["\n      textarea {\n        color: ", ";\n        background-color: ", ";\n      }\n      box-shadow: inset 0 0 0 1px ", ";\n      background-color: ", ";\n      &:hover,\n      &:focus {\n        box-shadow: inset 0 0 0 1px ", ";\n      }\n    "])), theme.colors['neutral'].text.regular, theme.colors['neutral'].bg.regular, theme.colors['neutral'].border.regular, theme.colors['neutral'].bg.regular, theme.colors['neutral'].border.regular);
}, function (_ref4) {
  var readOnly = _ref4.readOnly;
  return readOnly === true && css$1(_templateObject8$f || (_templateObject8$f = _taggedTemplateLiteral(["\n      box-shadow: inset 0 0 0 1px ", ";\n      textarea {\n        color: ", ";\n      }\n      &:hover,\n      &:focus {\n        box-shadow: inset 0 0 0 1px ", ";\n      }\n    "])), theme.colors['neutral'].border.weak, theme.colors['neutral'].text.regular, theme.colors['neutral'].border.weak);
});
var TextAreaTag = styled.textarea(_templateObject9$e || (_templateObject9$e = _taggedTemplateLiteral(["\n  min-height: 24px;\n  width: 100%;\n  height: 80px;\n  border: none;\n  background-color: ", ";\n  ", ";\n  color: ", ";\n  &:focus,\n  &:focus-visible {\n    outline: none;\n  }\n\n  outline: none;\n\n  &::-moz-focus-inner {\n    border: 0;\n  }\n  ", "\n"])), theme.colors.neutral.bg.weak, theme.textStyles['text-preset-9'], theme.colors.neutral.text.strong, function (prop) {
  return prop.resize === false && css$1(_templateObject10$d || (_templateObject10$d = _taggedTemplateLiteral(["\n      resize: none;\n    "])));
});
var HelpText$2 = styled.div(_templateObject11$c || (_templateObject11$c = _taggedTemplateLiteral(["\n  padding: ", " ", "\n    ", " ", ";\n  display: flex;\n  align-items: center;\n  position: absolute;\n  ", "\n"])), theme.spacing['spacing-2'], theme.spacing['spacing-2'], theme.spacing['spacing-2'], theme.spacing['spacing-5'], function (_ref5) {
  var status = _ref5.status;
  return status === 'error' && css$1(_templateObject12$7 || (_templateObject12$7 = _taggedTemplateLiteral(["\n      > * {\n        &:first-child {\n          margin-right: ", ";\n        }\n      }\n    "])), theme.spacing['spacing-2']);
});
var SiblingTextArea = styled.div(_templateObject13$6 || (_templateObject13$6 = _taggedTemplateLiteral(["\n  padding: ", " ", "\n    ", " ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n"])), theme.spacing['spacing-2'], theme.spacing['spacing-5'], theme.spacing['spacing-2'], theme.spacing['spacing-2']);

var spanVariantByStatus$1 = {
  normal: 'neutral',
  error: 'danger'
};
var TextArea$1 = function TextArea$1(_ref) {
  var id = _ref.id,
    name = _ref.name,
    value = _ref.value,
    label = _ref.label,
    maxLength = _ref.maxLength,
    status = _ref.status,
    readOnly = _ref.readOnly,
    placeHolder = _ref.placeHolder,
    message = _ref.message,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    disabled = _ref.disabled,
    _ref$maxLengthHelpTex = _ref.maxLengthHelpText,
    maxLengthHelpText = _ref$maxLengthHelpTex === void 0 ? false : _ref$maxLengthHelpTex,
    _ref$resize = _ref.resize,
    resize = _ref$resize === void 0 ? false : _ref$resize,
    children = _ref.children,
    rows = _ref.rows,
    cols = _ref.cols,
    icon = _ref.icon,
    required = _ref.required;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasFocus = _useState2[0],
    setFocus = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    characterCount = _useState4[0],
    setCharacterCount = _useState4[1];
  var renderMaxLengthHelpText = function renderMaxLengthHelpText() {
    return /*#__PURE__*/React__default.createElement(SiblingTextArea, null, /*#__PURE__*/React__default.createElement(Span$1, {
      type: "4",
      variant: "neutral",
      modifier: "regular"
    }, characterCount, "/", maxLength));
  };
  var renderIcon = function renderIcon(icon) {
    var _icon$name = icon.name,
      name = _icon$name === void 0 ? icon : _icon$name,
      callback = icon.callback;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, disabled ? /*#__PURE__*/React__default.createElement(Icon$1, {
      name: name,
      variant: "primary",
      cursor: 'not-allowed'
    }) : /*#__PURE__*/React__default.createElement(Icon$1, {
      name: name,
      variant: "primary",
      cursor: callback ? 'pointer' : 'default',
      modifier: "regular",
      onClick: function onClick() {
        return callback && callback();
      }
    }));
  };
  var proxyOnChange = function proxyOnChange(e) {
    setCharacterCount(e.target.value.length);
    onChange && onChange(e);
  };
  var proxyOnBlur = function proxyOnBlur(e) {
    setFocus(false);
    onBlur && onBlur(e);
  };
  var proxyOnFocus = function proxyOnFocus(e) {
    setFocus(true);
    onFocus && onFocus(e);
  };
  return /*#__PURE__*/React__default.createElement(TextArea, null, label && /*#__PURE__*/React__default.createElement(LabelWrapper$2, null, /*#__PURE__*/React__default.createElement(Label$1, {
    id: id,
    type: "4"
  }, label, required && /*#__PURE__*/React__default.createElement(Span$1, {
    variant: "danger",
    modifier: "regular",
    type: "4"
  }, "*"))), /*#__PURE__*/React__default.createElement(BaseTextArea, {
    hasFocus: hasFocus,
    status: status,
    disabled: disabled,
    readOnly: readOnly
  }, /*#__PURE__*/React__default.createElement(TextAreaTag, {
    id: id,
    name: name,
    rows: rows,
    cols: cols,
    disabled: disabled,
    placeholder: placeHolder,
    resize: resize,
    maxLength: maxLength,
    onChange: proxyOnChange,
    onBlur: proxyOnBlur,
    onFocus: proxyOnFocus,
    readOnly: readOnly,
    value: value
  }, children), /*#__PURE__*/React__default.createElement(IconBaseTextArea, null, icon && renderIcon(icon))), message && /*#__PURE__*/React__default.createElement(HelpText$2, {
    status: status
  }, status === 'error' && /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "error_circle_outline",
    variant: "danger",
    width: "16",
    height: "16"
  }), /*#__PURE__*/React__default.createElement(Span$1, {
    id: id,
    type: "4",
    variant: spanVariantByStatus$1[status]
  }, message)), maxLengthHelpText && renderMaxLengthHelpText());
};
TextArea$1.defaultProps = {
  status: 'normal',
  readOnly: false,
  disabled: false,
  maxLengthHelpText: true,
  maxLength: '120'
};
TextArea$1.propTypes = {
  label: PropTypes.string,
  inputStatus: PropTypes.oneOf(['normal', 'error']),
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onKeydown: PropTypes.func,
  placeHolder: PropTypes.string,
  message: PropTypes.string,
  disabled: PropTypes.bool,
  maxLength: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    name: PropTypes.string,
    callback: PropTypes.func
  })]),
  maxLengthHelpText: PropTypes.bool
};

var _templateObject$R, _templateObject2$J, _templateObject3$C, _templateObject4$u, _templateObject5$q, _templateObject6$m, _templateObject7$j, _templateObject8$g, _templateObject9$f, _templateObject10$e, _templateObject11$d, _templateObject12$8, _templateObject13$7, _templateObject14$5, _templateObject15$5, _templateObject16$4, _templateObject17$4, _templateObject18$4;
var RadioButton = styled.div(_templateObject$R || (_templateObject$R = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  border-radius: ", ";\n\n  ", "\n\n  ", "\n"])), theme.spacing['spacing-2'], function (_ref) {
  var align = _ref.align;
  return align === 'left' ? css$1(_templateObject2$J || (_templateObject2$J = _taggedTemplateLiteral(["\n          justify-content: flex-start;\n        "]))) : css$1(_templateObject3$C || (_templateObject3$C = _taggedTemplateLiteral(["\n          justify-content: flex-end;\n        "])));
}, function (_ref2) {
  var border = _ref2.border;
  return border === true && css$1(_templateObject4$u || (_templateObject4$u = _taggedTemplateLiteral(["\n      height: 40px;\n    "])));
});
var RadioBorder = styled.label(_templateObject5$q || (_templateObject5$q = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  margin: 0;\n  cursor: pointer;\n  border-radius: ", ";\n"])), theme.spacing['spacing-2']);
var Mark = styled.label(_templateObject6$m || (_templateObject6$m = _taggedTemplateLiteral(["\n  position: relative;\n  border: 1px solid ", ";\n  width: 14px;\n  height: 14px;\n  left: 0px;\n  border-radius: ", ";\n  ", "\n  ", "\n  ", "\n\n  margin-bottom: 0px;\n  vertical-align: middle;\n  &::after {\n    content: '';\n    display: block;\n    width: 14px;\n    height: 14px;\n    border-radius: ", ";\n    background-color: ", ";\n    opacity: ", ";\n    left: 50%;\n    top: 50%;\n    position: absolute;\n    margin: 0;\n    padding: 0;\n  }\n"])), theme.colors.neutral.border.regular, theme.borderRadius['border-radius-5'], function (_ref3) {
  var align = _ref3.align;
  return align === 'left' ? css$1(_templateObject7$j || (_templateObject7$j = _taggedTemplateLiteral(["\n          margin-right: ", ";\n        "])), theme.spacing['spacing-3']) : css$1(_templateObject8$g || (_templateObject8$g = _taggedTemplateLiteral(["\n          margin-left: ", ";\n        "])), theme.spacing['spacing-3']);
}, function (_ref4) {
  var border = _ref4.border,
    align = _ref4.align;
  return border === true && align === 'right' ? css$1(_templateObject9$f || (_templateObject9$f = _taggedTemplateLiteral(["\n          margin-left: ", ";\n          margin-right: ", ";\n        "])), theme.spacing['spacing-3'], theme.spacing['spacing-5']) : border === true && align === 'left' && css$1(_templateObject10$e || (_templateObject10$e = _taggedTemplateLiteral(["\n          margin-left: ", ";\n          margin-right: ", ";\n        "])), theme.spacing['spacing-5'], theme.spacing['spacing-3']);
}, function (_ref5) {
  var disabled = _ref5.disabled,
    status = _ref5.status;
  return disabled === true && status !== 'error' ? css$1(_templateObject11$d || (_templateObject11$d = _taggedTemplateLiteral(["\n          background-color: ", ";\n          border-color: ", ";\n        "])), theme.colors.neutral.bg.strong, theme.colors.neutral.border.regular) : status === 'error' && css$1(_templateObject12$8 || (_templateObject12$8 = _taggedTemplateLiteral(["\n          border-color: ", ";\n        "])), theme.colors.danger.border.regular);
}, theme.borderRadius['border-radius-5'], theme.colors['secondary-1'].bg.regular, theme.opacities['opacity-4']);
var InputRadioTag = styled.input(_templateObject13$7 || (_templateObject13$7 = _taggedTemplateLiteral(["\n  position: absolute;\n  visibility: hidden;\n  display: none;\n  + ", " + label,\n  + label + ", ", + label {\n    z-index: 1;\n  }\n\n  ", "\n  ", "\n    ", "\n"])), Mark, Mark, function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled === false ? css$1(_templateObject14$5 || (_templateObject14$5 = _taggedTemplateLiteral(["\n          &:checked + ", ", &:checked + label + ", " {\n            border-color: ", ";\n            &::after {\n              width: 8px;\n              height: 8px;\n              opacity: ", ";\n              left: 2px;\n              top: 2px;\n              margin: 0;\n              padding: 0;\n            }\n          }\n          &:hover {\n            + ", ", + label + ", " {\n              background-color: ", ";\n            }\n            &:checked + ", ", &:checked + label + ", " {\n              background-color: ", ";\n              border-color: ", ";\n              &::after {\n                background-color: ", ";\n              }\n            }\n          }\n        "])), Mark, Mark, theme.colors['secondary-1'].border.regular, theme.opacities['opacity-1'], Mark, Mark, theme.colors.neutral.bg.strong, Mark, Mark, theme.colors.neutral.bg.weak, theme.colors['secondary-1'].border.strong, theme.colors['secondary-1'].bg.strong) : css$1(_templateObject15$5 || (_templateObject15$5 = _taggedTemplateLiteral(["\n          &:checked + ", ", &:checked + label + ", " {\n            z-index: 1;\n            border-color: ", ";\n            &::after {\n              background-color: ", ";\n              width: 8px;\n              height: 8px;\n              opacity: ", ";\n              left: 2px;\n              top: 2px;\n              margin: 0;\n              padding: 0;\n            }\n          }\n        "])), Mark, Mark, theme.colors.neutral.border.regular, theme.colors.neutral.bg.stronger, theme.opacities['opacity-1']);
}, function (_ref7) {
  var border = _ref7.border,
    disabled = _ref7.disabled,
    status = _ref7.status;
  return border === true && disabled === false ? css$1(_templateObject16$4 || (_templateObject16$4 = _taggedTemplateLiteral(["\n          &:checked\n            + ", "\n            + label\n            + ", ",\n            &:checked\n            + label\n            + ", "\n            + ", " {\n            box-shadow: inset 0 0 0 1px\n              ", ";\n          }\n          &:hover {\n            + ", "\n              + label\n              + ", ",\n              + label\n              + ", "\n              + ", " {\n              background-color: ", ";\n              box-shadow: inset 0 0 0 1px\n                ", ";\n            }\n            &:checked\n              + ", "\n              + label\n              + ", ",\n              &:checked\n              + label\n              + ", "\n              + ", " {\n              background-color: ", ";\n              box-shadow: inset 0 0 0 1px\n                ", ";\n            }\n          }\n        "])), Mark, RadioBorder, Mark, RadioBorder, theme.colors['secondary-1'].border.regular, Mark, RadioBorder, Mark, RadioBorder, theme.colors.neutral.bg.regular, theme.colors[status === 'error' ? 'danger' : 'neutral'].border.regular, Mark, RadioBorder, Mark, RadioBorder, theme.colors.neutral.bg.regular, theme.colors['secondary-1'].border.strong) : border === true && disabled === true && css$1(_templateObject17$4 || (_templateObject17$4 = _taggedTemplateLiteral(["\n          &:checked\n            + ", "\n            + label\n            + ", ",\n            &:checked\n            + label\n            + ", "\n            + ", " {\n            box-shadow: inset 0 0 0 1px ", ";\n          }\n          + ", "\n            + label\n            + ", ",\n            + label\n            + ", "\n            + ", " {\n            box-shadow: none;\n          }\n        "])), Mark, RadioBorder, Mark, RadioBorder, theme.colors.neutral.border.weak, Mark, RadioBorder, Mark, RadioBorder);
}, function (_ref8) {
  var border = _ref8.border,
    status = _ref8.status;
  return border === true && status === 'error' && css$1(_templateObject18$4 || (_templateObject18$4 = _taggedTemplateLiteral(["\n      + ", " + label + ", ", + label + ", " + ", " {\n        box-shadow: inset 0 0 0 1px ", ";\n      }\n      &:hover {\n        + ", " + label + ", ", + label + ", " + ", " {\n          background-color: ", ";\n        }\n      }\n    "])), Mark, RadioBorder, Mark, RadioBorder, theme.colors['danger'].border.regular, Mark, RadioBorder, Mark, RadioBorder, theme.colors.neutral.bg.regular);
});

var RadioButton$1 = function RadioButton$1(_ref) {
  var id = _ref.id,
    name = _ref.name,
    value = _ref.value,
    label = _ref.label,
    onChange = _ref.onChange,
    checked = _ref.checked,
    border = _ref.border,
    disabled = _ref.disabled,
    align = _ref.align,
    status = _ref.status;
  var renderMark = /*#__PURE__*/React__default.createElement(Mark, {
    htmlFor: id,
    align: align,
    border: border,
    disabled: disabled,
    status: status
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(RadioButton, {
    border: border,
    disabled: disabled,
    align: align
  }, /*#__PURE__*/React__default.createElement(InputRadioTag, {
    type: "radio",
    id: id,
    name: name,
    value: value,
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    border: border,
    status: status
  }), align === 'left' && renderMark, /*#__PURE__*/React__default.createElement(Label$1, {
    id: id,
    type: "2",
    cursor: "pointer",
    variant: "neutral",
    modifier: disabled ? 'regular' : 'strong'
  }, label), align === 'right' && renderMark, /*#__PURE__*/React__default.createElement(RadioBorder, {
    htmlFor: id,
    border: border,
    "data-testid": "radio-border-data-test-id",
    disabled: disabled,
    status: status
  })));
};
RadioButton$1.defaultProps = {
  align: 'left',
  status: 'normal',
  border: false,
  disabled: false
};
RadioButton$1.propTypes = {
  label: PropTypes.string,
  status: PropTypes.oneOf(['normal', 'error']),
  border: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  align: PropTypes.oneOf(['right', 'left'])
};

var _templateObject$S, _templateObject2$K, _templateObject3$D, _templateObject4$v, _templateObject5$r, _templateObject6$n, _templateObject7$k;
var SearchableSelectWrapper = styled.div(_templateObject$S || (_templateObject$S = _taggedTemplateLiteral(["\n  position: relative;\n  display: grid;\n"])));
var DataItem = styled.div(_templateObject2$K || (_templateObject2$K = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  color: ", ";\n  padding: ", " ", "\n    ", " ", ";\n  :hover {\n    cursor: pointer;\n    background-color: ", ";\n  }\n"])), theme.colors.neutral.text.strong, theme.spacing['spacing-3'], theme.spacing['spacing-5'], theme.spacing['spacing-3'], theme.spacing['spacing-5'], theme.colors.neutral.bg.regular);
var DataItemText = styled.p(_templateObject3$D || (_templateObject3$D = _taggedTemplateLiteral(["\n  margin-bottom: auto;\n  margin-top: auto;\n  ", "\n"])), theme.textStyles['text-preset-9']());
var DataResult = styled.div(_templateObject4$v || (_templateObject4$v = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  max-height: 208px;\n  height: auto;\n  overflow: hidden;\n  overflow-y: auto;\n  z-index: 1;\n  border-radius: ", ";\n  box-shadow: ", ";\n  background-color: ", ";\n  top: ", ";\n  box-shadow: ", ";\n  &::-webkit-scrollbar {\n    width: 2px;\n  }\n  &::-webkit-scrollbar-track {\n    background: ", ";\n  }\n  &::-webkit-scrollbar-thumb {\n    background: ", ";\n  }\n  &::-webkit-scrollbar-thumb:hover {\n    background: ", ";\n  }\n"])), theme.borderRadius['border-radius-3'], theme.elevations['elevation-1'], theme.colors.neutral.bg.weak, theme.spacing['spacing-2'], theme.elevations['elevation-1'], theme.colors.neutral.bg.weak, theme.colors.neutral.border.weak, theme.colors.neutral.border.regular);
var InputWrapper = styled.div(_templateObject5$r || (_templateObject5$r = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var EmptyButtonWrapper = styled.div(_templateObject6$n || (_templateObject6$n = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  padding: ", " ", "\n    ", " ", ";\n"])), theme.spacing['spacing-1'], theme.spacing['spacing-1'], theme.spacing['spacing-1'], theme.spacing['spacing-5']);
var DataResultWrapper = styled.div(_templateObject7$k || (_templateObject7$k = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n"])));

var RESET_VALUE$1 = '';
var SearchableSelect = function SearchableSelect(props) {
  var placeholder = props.placeholder,
    options = props.options,
    minLength = props.minLength,
    label = props.label,
    onChange = props.onChange,
    onlyNumbers = props.onlyNumbers,
    onClick = props.onClick,
    disabled = props.disabled,
    inputStatus = props.inputStatus,
    message = props.message,
    pattern = props.pattern,
    onKeyDown = props.onKeyDown,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    name = props.name,
    maxLength = props.maxLength;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    filteredOptions = _useState2[0],
    setFilteredOptions = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    showResetButton = _useState4[0],
    setShowResetButton = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedOption = _useState6[0],
    setSelectedOption = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isWrite = _useState8[0],
    setIsWrite = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    value = _useState10[0],
    setValue = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    open = _useState12[0],
    setOpen = _useState12[1];
  var _useState13 = useState(!!placeholder),
    _useState14 = _slicedToArray(_useState13, 2),
    showPlaceHolder = _useState14[0],
    setShowPlaceHolder = _useState14[1];
  var inputRef = useRef(null);
  useEffect(function () {
    if (open || isWrite) inputRef.current.focus();
  }, [open, isWrite]);
  useEffect(function () {
    filteredOptions !== options && setFilteredOptions(options || []);
  }, [options]);
  useEffect(function () {
    var isOpen = !selectedOption && filteredOptions.length !== 0 && isWrite;
    minLength ? minLength <= value.length && setOpen(isOpen) : setOpen(isOpen);
  }, [filteredOptions, isWrite]);
  var handleClose = function handleClose() {
    setOpen(false);
  };
  useEffect(function () {
    if (props !== null && props !== void 0 && props.value) {
      setValue(props.value);
      setShowResetButton(!message ? true : showResetButton);
    }
  }, [props.value]);
  var handleOnChange = function handleOnChange(event) {
    var searchWord = event.target.value;
    var isValidValue = validateValue(searchWord);
    setIsWrite(true);
    setShowResetButton(false);
    setSelectedOption(RESET_VALUE$1);
    if (isValidValue) {
      setValue(searchWord);
      minLength ? minLength <= searchWord.length ? onChange(searchWord) : handleClose() : onChange(searchWord);
    }
  };
  var validateValue = function validateValue(searchWord) {
    if (onlyNumbers || pattern) {
      var regex = onlyNumbers ? /^[0-9]{0,}$/ : pattern;
      return regex.test(searchWord);
    } else return true;
  };
  var handleReset = function handleReset() {
    onChange && onChange('');
    setValue(RESET_VALUE$1);
    setSelectedOption(RESET_VALUE$1);
    setShowResetButton(false);
    setIsWrite(false);
    setShowPlaceHolder(true);
    handleClose();
  };
  var handleOnClick = function handleOnClick(option) {
    var _option$value = option.value,
      value = _option$value === void 0 ? '' : _option$value;
    onClick && onClick(option);
    setIsWrite(false);
    setValue(value);
    setSelectedOption(value);
    setShowResetButton(true);
    handleClose();
  };
  var handleOnFocus = function handleOnFocus() {
    onFocus && onFocus();
    setShowPlaceHolder(false);
  };
  var handleOnBlur = function handleOnBlur() {
    onBlur && onBlur();
    setShowPlaceHolder(value.length == 0);
  };
  var renderFilteredOptions = function renderFilteredOptions() {
    return /*#__PURE__*/React__default.createElement(DataResultWrapper, null, /*#__PURE__*/React__default.createElement(DataResult, null, filteredOptions.map(function (filteredOption, key) {
      return /*#__PURE__*/React__default.createElement(DataItem, {
        key: key,
        onClick: function onClick() {
          return handleOnClick(filteredOption);
        }
      }, /*#__PURE__*/React__default.createElement(DataItemText, null, filteredOption.label));
    })));
  };
  var renderResetButton = function renderResetButton() {
    return /*#__PURE__*/React__default.createElement(EmptyButtonWrapper, null, /*#__PURE__*/React__default.createElement(Link$1, {
      variant: "primary",
      size: "xs",
      onClick: handleReset
    }, "Limpiar"));
  };
  return /*#__PURE__*/React__default.createElement(OutsideAlerter, {
    handleOutSideClick: handleReset,
    active: open
  }, /*#__PURE__*/React__default.createElement(SearchableSelectWrapper, {
    "data-testid": "searchable-select"
  }, /*#__PURE__*/React__default.createElement(InputWrapper, null, /*#__PURE__*/React__default.createElement(Input$1, {
    disabled: disabled,
    inputRef: inputRef,
    id: "searchable-select",
    type: "text",
    label: label,
    placeHolder: showPlaceHolder ? placeholder : '',
    onChange: handleOnChange,
    value: value,
    autocomplete: "off",
    icons: {
      iconLeft: 'search_outline'
    },
    inputStatus: inputStatus,
    message: !showResetButton ? message : '',
    pattern: pattern,
    onKeyDown: onKeyDown,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    name: name,
    maxLength: maxLength
  }), (props.showResetButton || showResetButton) && renderResetButton()), open && renderFilteredOptions()));
};
SearchableSelect.defaultProps = {
  options: [],
  placeholder: '',
  label: '',
  disabled: false,
  inputStatus: 'normal'
};
SearchableSelect.propTypes = {
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array,
  minLength: PropTypes.number,
  onChange: PropTypes.func,
  onInput: PropTypes.func,
  onlyNumbers: PropTypes.bool,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  inputStatus: PropTypes.oneOf(['normal', 'error']),
  message: PropTypes.string,
  maxLength: PropTypes.number
};

var _templateObject$T, _templateObject2$L, _templateObject3$E, _templateObject4$w, _templateObject5$s, _templateObject6$o;
var DropdownWrapper = styled.div(_templateObject$T || (_templateObject$T = _taggedTemplateLiteral(["\n  position: relative;\n  width: max-content;\n"])));
var Elements = styled.ul(_templateObject2$L || (_templateObject2$L = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  box-shadow: ", ";\n  margin-top: ", ";\n  position: absolute;\n  width: 100%;\n  z-index: 9999;\n"])), theme.borderRadius['border-radius-3'], theme.elevations['elevation-1'], theme.spacing['spacing-2']);
var Element$1 = styled.li(_templateObject3$E || (_templateObject3$E = _taggedTemplateLiteral(["\n  background-color: ", ";\n  list-style-type: none;\n\n  &:first-of-type {\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n  }\n\n  &:last-of-type {\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n  }\n\n  &:hover,\n  &:focus {\n    background-color: ", ";\n    cursor: pointer;\n  }\n"])), theme.colors.neutral.bg.weak, theme.borderRadius['border-radius-3'], theme.borderRadius['border-radius-3'], theme.borderRadius['border-radius-3'], theme.borderRadius['border-radius-3'], theme.colors.neutral.bg.regular);
var ElementButton = styled.button(_templateObject4$w || (_templateObject4$w = _taggedTemplateLiteral(["\n  background-color: inherit;\n  border-radius: inherit;\n  border: none;\n  padding: ", " ", ";\n  text-align: left;\n  width: 100%;\n\n  ", "\n"])), theme.spacing['spacing-3'], theme.spacing['spacing-5'], function (_ref) {
  var disabled = _ref.disabled;
  if (disabled) {
    return css$1(_templateObject5$s || (_templateObject5$s = _taggedTemplateLiteral(["\n        cursor: not-allowed;\n      "])));
  } else {
    return css$1(_templateObject6$o || (_templateObject6$o = _taggedTemplateLiteral(["\n        cursor: pointer;\n      "])));
  }
});

var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    items = _ref.items,
    size = _ref.size,
    title = _ref.title;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var toggle = function toggle() {
    return setOpen(!open);
  };
  var renderDropdownContent = function renderDropdownContent() {
    return items ? items.map(function (item) {
      return /*#__PURE__*/React__default.createElement(Element$1, {
        key: item.title
      }, /*#__PURE__*/React__default.createElement(ElementButton, {
        type: "button",
        onClick: function onClick() {
          return callItemAction(item.action);
        },
        disabled: item.disabled
      }, /*#__PURE__*/React__default.createElement(Span$1, {
        variant: "neutral",
        modifier: item.disabled ? 'weak' : 'strong',
        type: "2"
      }, item.title)));
    }) : children;
  };
  var callItemAction = function callItemAction(action) {
    toggle();
    action();
  };
  return /*#__PURE__*/React__default.createElement(OutsideAlerter, {
    handleOutSideClick: function handleOutSideClick() {
      return setOpen(false);
    },
    active: open
  }, /*#__PURE__*/React__default.createElement(DropdownWrapper, null, /*#__PURE__*/React__default.createElement(Button$1, {
    variant: disabled ? 'secondary' : 'primary',
    size: size,
    type: "button",
    onClick: toggle,
    disabled: disabled,
    icon: open ? 'chevron_up_small' : 'chevron_down_small',
    iconAlign: "right"
  }, title), open && /*#__PURE__*/React__default.createElement(Elements, null, renderDropdownContent())));
};
Dropdown.propTypes = {
  disabled: PropTypes.bool,
  items: PropTypes.array,
  size: PropTypes.string,
  title: PropTypes.string
};

var ADMIN_ROLE = 'ROLE_admin';
var OWNER_ROLE = 'ROLE_administrator';
var BACKSPACE_KEY = 'Backspace';
var DELETE_KEY = 'Delete';
var REQUIRED_KEY = 'Requerido';
var NULL_OPTION_SELECT = Object.freeze({
  label: '',
  value: ''
});
var QUOTE_MARK = '"';
var COLUMN_SEPARATOR = '-';
var SPACE_KEY = ' ';
var MEDIUM_COMPONENT_SIZE = 'md';
var SMALL_COMPONENT_SIZE = 'sm';
var MB = 1048576;
var MAX_CHAR_FILENAME_SM = 26;
var MAX_CHAR_FILENAME_MD = 56;
var mimeTypesMap = {
  csv: 'text/csv',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  gif: 'image/gif',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  pdf: 'application/pdf',
  png: 'image/png',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
};
var MIME_TYPES_MAP = Object.freeze(mimeTypesMap);

var PermissionContext = /*#__PURE__*/createContext$1();
var usePermissionContext = function usePermissionContext() {
  return useContext(PermissionContext);
};
var PermissionProvider = function PermissionProvider(_ref) {
  var children = _ref.children,
    permissions = _ref.permissions,
    roles = _ref.roles;
  var isAllowedTo = function isAllowedTo(permission) {
    return permissions.includes(permission) || roles.includes(ADMIN_ROLE) || roles.includes(OWNER_ROLE);
  };
  return /*#__PURE__*/React__default.createElement(PermissionContext.Provider, {
    value: {
      isAllowedTo: isAllowedTo
    }
  }, children);
};

var Restricted = function Restricted(_ref) {
  var children = _ref.children,
    to = _ref.to,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? null : _ref$fallback;
  var _usePermissionContext = usePermissionContext(),
    isAllowedTo = _usePermissionContext.isAllowedTo;
  return isAllowedTo(to) ? children : fallback;
};

/**
 * react-number-format - 4.9.4
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2022 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */

//     

                                                               

// basic noop function
function noop$2() {}
function returnTrue() {
  return true;
}

function charIsNumber(char         ) {
  return !!(char || '').match(/\d/);
}

function isNil(val     ) {
  return val === null || val === undefined;
}

function escapeRegExp(str        ) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}

function getThousandsGroupRegex(thousandsGroupStyle        ) {
  switch (thousandsGroupStyle) {
    case 'lakh':
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case 'wan':
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case 'thousand':
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}

function applyThousandSeparator(
  str        ,
  thousandSeparator        ,
  thousandsGroupStyle        
) {
  var thousandsGroupRegex = getThousandsGroupRegex(thousandsGroupStyle);
  var index = str.search(/[1-9]/);
  index = index === -1 ? str.length : index;
  return (
    str.substring(0, index) +
    str.substring(index, str.length).replace(thousandsGroupRegex, '$1' + thousandSeparator)
  );
}

//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function splitDecimal(numStr        , allowNegative) {
  if ( allowNegative === void 0 ) allowNegative          = true;

  var hasNagation = numStr[0] === '-';
  var addNegation = hasNagation && allowNegative;
  numStr = numStr.replace('-', '');

  var parts = numStr.split('.');
  var beforeDecimal = parts[0];
  var afterDecimal = parts[1] || '';

  return {
    beforeDecimal: beforeDecimal,
    afterDecimal: afterDecimal,
    hasNagation: hasNagation,
    addNegation: addNegation,
  };
}

function fixLeadingZero(numStr         ) {
  if (!numStr) { return numStr; }
  var isNegative = numStr[0] === '-';
  if (isNegative) { numStr = numStr.substring(1, numStr.length); }
  var parts = numStr.split('.');
  var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
  var afterDecimal = parts[1] || '';

  return ("" + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? ("." + afterDecimal) : ''));
}

/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */
function limitToScale(numStr        , scale        , fixedDecimalScale         ) {
  var str = '';
  var filler = fixedDecimalScale ? '0' : '';
  for (var i = 0; i <= scale - 1; i++) {
    str += numStr[i] || filler;
  }
  return str;
}

function repeat(str, count) {
  return Array(count + 1).join(str);
}

function toNumericString(num) {
  num += ''; // typecast number to string

  // store the sign and remove it from the number.
  var sign = num[0] === '-' ? '-' : '';
  if (sign) { num = num.substring(1); }

  // split the number into cofficient and exponent
  var ref = num.split(/[eE]/g);
  var coefficient = ref[0];
  var exponent = ref[1];

  // covert exponent to number;
  exponent = Number(exponent);

  // if there is no exponent part or its 0, return the coffiecient with sign
  if (!exponent) { return sign + coefficient; }

  coefficient = coefficient.replace('.', '');

  /**
   * for scientific notation the current decimal index will be after first number (index 0)
   * So effective decimal index will always be 1 + exponent value
   */
  var decimalIndex = 1 + exponent;

  var coffiecientLn = coefficient.length;

  if (decimalIndex < 0) {
    // if decimal index is less then 0 add preceding 0s
    // add 1 as join will have
    coefficient = '0.' + repeat('0', Math.abs(decimalIndex)) + coefficient;
  } else if (decimalIndex >= coffiecientLn) {
    // if decimal index is less then 0 add leading 0s
    coefficient = coefficient + repeat('0', decimalIndex - coffiecientLn);
  } else {
    // else add decimal point at proper index
    coefficient =
      (coefficient.substring(0, decimalIndex) || '0') + '.' + coefficient.substring(decimalIndex);
  }

  return sign + coefficient;
}

/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */
function roundToPrecision(numStr        , scale        , fixedDecimalScale         ) {
  //if number is empty don't do anything return empty string
  if (['', '-'].indexOf(numStr) !== -1) { return numStr; }

  var shoudHaveDecimalSeparator = numStr.indexOf('.') !== -1 && scale;
  var ref = splitDecimal(numStr);
  var beforeDecimal = ref.beforeDecimal;
  var afterDecimal = ref.afterDecimal;
  var hasNagation = ref.hasNagation;
  var floatValue = parseFloat(("0." + (afterDecimal || '0')));
  var floatValueStr =
    afterDecimal.length <= scale ? ("0." + afterDecimal) : floatValue.toFixed(scale);
  var roundedDecimalParts = floatValueStr.split('.');
  var intPart = beforeDecimal
    .split('')
    .reverse()
    .reduce(function (roundedStr, current, idx) {
      if (roundedStr.length > idx) {
        return (
          (Number(roundedStr[0]) + Number(current)).toString() +
          roundedStr.substring(1, roundedStr.length)
        );
      }
      return current + roundedStr;
    }, roundedDecimalParts[0]);

  var decimalPart = limitToScale(
    roundedDecimalParts[1] || '',
    Math.min(scale, afterDecimal.length),
    fixedDecimalScale
  );
  var negation = hasNagation ? '-' : '';
  var decimalSeparator = shoudHaveDecimalSeparator ? '.' : '';
  return ("" + negation + intPart + decimalSeparator + decimalPart);
}

/** set the caret positon in an input field **/
function setCaretPosition(el                  , caretPos        ) {
  el.value = el.value;
  // ^ this is used to not only get 'focus', but
  // to make sure we don't have it everything -selected-
  // (it causes an issue in chrome, and having it doesn't hurt any other browser)
  if (el !== null) {
    if (el.createTextRange) {
      var range = el.createTextRange();
      range.move('character', caretPos);
      range.select();
      return true;
    }
    // (el.selectionStart === 0 added for Firefox bug)
    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(caretPos, caretPos);
      return true;
    }

    // fail city, fortunately this never happens (as far as I've tested) :)
    el.focus();
    return false;
  }
}

/**
  Given previous value and newValue it returns the index
  start - end to which values have changed.
  This function makes assumption about only consecutive
  characters are changed which is correct assumption for caret input.
*/
function findChangedIndex(prevValue        , newValue        ) {
  var i = 0,
    j = 0;
  var prevLength = prevValue.length;
  var newLength = newValue.length;
  while (prevValue[i] === newValue[i] && i < prevLength) { i++; }

  //check what has been changed from last
  while (
    prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] &&
    newLength - j > i &&
    prevLength - j > i
  ) {
    j++;
  }

  return { start: i, end: prevLength - j };
}

/*
  Returns a number whose value is limited to the given range
*/
function clamp(num        , min        , max        ) {
  return Math.min(Math.max(num, min), max);
}

function getCurrentCaretPosition(el                  ) {
  /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
  return Math.max(el.selectionStart, el.selectionEnd);
}

function addInputMode(format                                   ) {
  return (
    format ||
    (typeof navigator !== 'undefined' &&
      !(navigator.platform && /iPhone|iPod/.test(navigator.platform)))
  );
}

//     
function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }

var defaultProps$4 = {
  displayType: 'input',
  decimalSeparator: '.',
  thousandsGroupStyle: 'thousand',
  fixedDecimalScale: false,
  prefix: '',
  suffix: '',
  allowNegative: true,
  allowEmptyFormatting: false,
  allowLeadingZeros: false,
  isNumericString: false,
  type: 'text',
  onValueChange: noop$2,
  onChange: noop$2,
  onKeyDown: noop$2,
  onMouseUp: noop$2,
  onFocus: noop$2,
  onBlur: noop$2,
  isAllowed: returnTrue,
};
var NumberFormat = /*@__PURE__*/(function (superclass) {
  function NumberFormat(props        ) {
    superclass.call(this, props);
    var defaultValue = props.defaultValue;

    //validate props
    this.validateProps();

    var formattedValue = this.formatValueProp(defaultValue);

    this.state = {
      value: formattedValue,
      numAsString: this.removeFormatting(formattedValue),
      mounted: false,
    };

    this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0,
    };

    this.onChange = this.onChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  if ( superclass ) NumberFormat.__proto__ = superclass;
  NumberFormat.prototype = Object.create( superclass && superclass.prototype );
  NumberFormat.prototype.constructor = NumberFormat;

  NumberFormat.prototype.componentDidMount = function componentDidMount () {
    // set mounted state
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      mounted: true,
    });
  };

  NumberFormat.prototype.componentDidUpdate = function componentDidUpdate (prevProps        ) {
    this.updateValueIfRequired(prevProps);
  };

  NumberFormat.prototype.componentWillUnmount = function componentWillUnmount () {
    clearTimeout(this.focusTimeout);
    clearTimeout(this.caretPositionTimeout);
  };

  NumberFormat.prototype.updateValueIfRequired = function updateValueIfRequired (prevProps        ) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var focusedElm = ref.focusedElm;
    var stateValue = state.value;
    var lastNumStr = state.numAsString; if ( lastNumStr === void 0 ) lastNumStr = '';

    // If only state changed no need to do any thing
    if (prevProps !== props) {
      //validate props
      this.validateProps();

      var lastValueWithNewFormat = this.formatNumString(lastNumStr);

      var formattedValue = isNil(props.value) ? lastValueWithNewFormat : this.formatValueProp();
      var numAsString = this.removeFormatting(formattedValue);

      var floatValue = parseFloat(numAsString);
      var lastFloatValue = parseFloat(lastNumStr);

      if (
        //while typing set state only when float value changes
        ((!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue) ||
        //can also set state when float value is same and the format props changes
        lastValueWithNewFormat !== stateValue ||
        //set state always when not in focus and formatted value is changed
        (focusedElm === null && formattedValue !== stateValue)
      ) {
        this.updateValue({
          formattedValue: formattedValue,
          numAsString: numAsString,
          input: focusedElm,
          source: 'prop',
          event: null,
        });
      }
    }
  };

  /** Misc methods **/
  NumberFormat.prototype.getFloatString = function getFloatString (num) {
    if ( num === void 0 ) num         = '';

    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var numRegex = this.getNumberRegex(true);

    //remove negation for regex check
    var hasNegation = num[0] === '-';
    if (hasNegation) { num = num.replace('-', ''); }

    //if decimal scale is zero remove decimal and number after decimalSeparator
    if (decimalSeparator && decimalScale === 0) {
      num = num.split(decimalSeparator)[0];
    }

    num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.');

    //remove extra decimals
    var firstDecimalIndex = num.indexOf('.');

    if (firstDecimalIndex !== -1) {
      num = (num.substring(0, firstDecimalIndex)) + "." + (num
        .substring(firstDecimalIndex + 1, num.length)
        .replace(new RegExp(escapeRegExp(decimalSeparator), 'g'), ''));
    }

    //add negation back
    if (hasNegation) { num = '-' + num; }

    return num;
  };

  //returned regex assumes decimalSeparator is as per prop
  NumberFormat.prototype.getNumberRegex = function getNumberRegex (g         , ignoreDecimalSeparator          ) {
    var ref = this.props;
    var format = ref.format;
    var decimalScale = ref.decimalScale;
    var customNumerals = ref.customNumerals;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    return new RegExp(
      '[0-9' +
        (customNumerals ? customNumerals.join('') : '') +
        ']' +
        (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format
          ? '|' + escapeRegExp(decimalSeparator)
          : ''),
      g ? 'g' : undefined
    );
  };

  NumberFormat.prototype.getSeparators = function getSeparators () {
    var ref = this.props;
    var decimalSeparator = ref.decimalSeparator;
    var ref$1 = this.props;
    var thousandSeparator = ref$1.thousandSeparator;
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;

    if (thousandSeparator === true) {
      thousandSeparator = ',';
    }
    if (!allowedDecimalSeparators) {
      allowedDecimalSeparators = [decimalSeparator, '.'];
    }

    return {
      decimalSeparator: decimalSeparator,
      thousandSeparator: thousandSeparator,
      allowedDecimalSeparators: allowedDecimalSeparators,
    };
  };

  NumberFormat.prototype.getMaskAtIndex = function getMaskAtIndex (index        ) {
    var ref = this.props;
    var mask = ref.mask; if ( mask === void 0 ) mask = ' ';
    if (typeof mask === 'string') {
      return mask;
    }

    return mask[index] || ' ';
  };

  NumberFormat.prototype.getValueObject = function getValueObject (formattedValue        , numAsString        ) {
    var floatValue = parseFloat(numAsString);

    return {
      formattedValue: formattedValue,
      value: numAsString,
      floatValue: isNaN(floatValue) ? undefined : floatValue,
    };
  };

  NumberFormat.prototype.validateProps = function validateProps () {
    var ref = this.props;
    var mask = ref.mask;

    //validate decimalSeparator and thousandSeparator
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var thousandSeparator = ref$1.thousandSeparator;

    if (decimalSeparator === thousandSeparator) {
      throw new Error(("\n          Decimal separator can't be same as thousand separator.\n          thousandSeparator: " + thousandSeparator + " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n          decimalSeparator: " + decimalSeparator + " (default value for decimalSeparator is .)\n       "));
    }

    //validate mask
    if (mask) {
      var maskAsStr = mask === 'string' ? mask : mask.toString();
      if (maskAsStr.match(/\d/g)) {
        throw new Error(("\n          Mask " + mask + " should not contain numeric character;\n        "));
      }
    }
  };
  /** Misc methods end **/

  /** caret specific methods **/
  NumberFormat.prototype.setPatchedCaretPosition = function setPatchedCaretPosition (el                  , caretPos        , currentValue        ) {
    /* setting caret position within timeout of 0ms is required for mobile chrome,
    otherwise browser resets the caret position after we set it
    We are also setting it without timeout so that in normal browser we don't see the flickering */
    setCaretPosition(el, caretPos);
    this.caretPositionTimeout = setTimeout(function () {
      if (el.value === currentValue) { setCaretPosition(el, caretPos); }
    }, 0);
  };

  /* This keeps the caret within typing area so people can't type in between prefix or suffix */
  NumberFormat.prototype.correctCaretPosition = function correctCaretPosition (value        , caretPos        , direction         ) {
    var ref = this.props;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var format = ref.format;

    //if value is empty return 0
    if (value === '') { return 0; }

    //caret position should be between 0 and value length
    caretPos = clamp(caretPos, 0, value.length);

    //in case of format as number limit between prefix and suffix
    if (!format) {
      var hasNegation = value[0] === '-';
      return clamp(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
    }

    //in case if custom format method don't do anything
    if (typeof format === 'function') { return caretPos; }

    /* in case format is string find the closest # position from the caret position */

    //in case the caretPos have input value on it don't do anything
    if (format[caretPos] === '#' && charIsNumber(value[caretPos])) {
      return caretPos;
    }

    //if caretPos is just after input value don't do anything
    if (format[caretPos - 1] === '#' && charIsNumber(value[caretPos - 1])) {
      return caretPos;
    }

    //find the nearest caret position
    var firstHashPosition = format.indexOf('#');
    var lastHashPosition = format.lastIndexOf('#');

    //limit the cursor between the first # position and the last # position
    caretPos = clamp(caretPos, firstHashPosition, lastHashPosition + 1);

    var nextPos = format.substring(caretPos, format.length).indexOf('#');
    var caretLeftBound = caretPos;
    var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos);

    //get the position where the last number is present
    while (
      caretLeftBound > firstHashPosition &&
      (format[caretLeftBound] !== '#' || !charIsNumber(value[caretLeftBound]))
    ) {
      caretLeftBound -= 1;
    }

    var goToLeft =
      !charIsNumber(value[caretRightBound]) ||
      (direction === 'left' && caretPos !== firstHashPosition) ||
      caretPos - caretLeftBound < caretRightBound - caretPos;

    if (goToLeft) {
      //check if number should be taken after the bound or after it
      //if number preceding a valid number keep it after
      return charIsNumber(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
    }

    return caretRightBound;
  };

  NumberFormat.prototype.getCaretPosition = function getCaretPosition (inputValue        , formattedValue        , caretPos        ) {
    var ref = this.props;
    var format = ref.format;
    var stateValue = this.state.value;
    var numRegex = this.getNumberRegex(true);
    var inputNumber = (inputValue.match(numRegex) || []).join('');
    var formattedNumber = (formattedValue.match(numRegex) || []).join('');
    var j, i;

    j = 0;

    for (i = 0; i < caretPos; i++) {
      var currentInputChar = inputValue[i] || '';
      var currentFormatChar = formattedValue[j] || '';
      //no need to increase new cursor position if formatted value does not have those characters
      //case inputValue = 1a23 and formattedValue =  123
      if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) {
        continue;
      }

      //When we are striping out leading zeros maintain the new cursor position
      //Case inputValue = 00023 and formattedValue = 23;
      if (
        currentInputChar === '0' &&
        currentFormatChar.match(numRegex) &&
        currentFormatChar !== '0' &&
        inputNumber.length !== formattedNumber.length
      ) {
        continue;
      }

      //we are not using currentFormatChar because j can change here
      while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
        j++;
      }
      j++;
    }

    if (typeof format === 'string' && !stateValue) {
      //set it to the maximum value so it goes after the last number
      j = formattedValue.length;
    }

    //correct caret position if its outside of editable area
    j = this.correctCaretPosition(formattedValue, j);

    return j;
  };
  /** caret specific methods ends **/

  /** methods to remove formattting **/
  NumberFormat.prototype.removePrefixAndSuffix = function removePrefixAndSuffix (val        ) {
    var ref = this.props;
    var format = ref.format;
    var prefix = ref.prefix;
    var suffix = ref.suffix;

    //remove prefix and suffix
    if (!format && val) {
      var isNegative = val[0] === '-';

      //remove negation sign
      if (isNegative) { val = val.substring(1, val.length); }

      //remove prefix
      val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val;

      //remove suffix
      var suffixLastIndex = val.lastIndexOf(suffix);
      val =
        suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length
          ? val.substring(0, suffixLastIndex)
          : val;

      //add negation sign back
      if (isNegative) { val = '-' + val; }
    }

    return val;
  };

  NumberFormat.prototype.removePatternFormatting = function removePatternFormatting (val        ) {
    var ref = this.props;
    var format = ref.format;
    var formatArray = format.split('#').filter(function (str) { return str !== ''; });
    var start = 0;
    var numStr = '';

    for (var i = 0, ln = formatArray.length; i <= ln; i++) {
      var part = formatArray[i] || '';

      //if i is the last fragment take the index of end of the value
      //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##
      var index = i === ln ? val.length : val.indexOf(part, start);

      /* in any case if we don't find the pattern part in the value assume the val as numeric string
      This will be also in case if user has started typing, in any other case it will not be -1
      unless wrong prop value is provided */
      if (index === -1) {
        numStr = val;
        break;
      } else {
        numStr += val.substring(start, index);
        start = index + part.length;
      }
    }

    return (numStr.match(this.getNumberRegex(true)) || []).join('');
  };

  NumberFormat.prototype.removeFormatting = function removeFormatting (val        ) {
    var ref = this.props;
    var format = ref.format;
    var removeFormatting = ref.removeFormatting;
    if (!val) { return val; }

    if (!format) {
      val = this.removePrefixAndSuffix(val);
      val = this.getFloatString(val);
    } else if (typeof format === 'string') {
      val = this.removePatternFormatting(val);
    } else if (typeof removeFormatting === 'function') {
      //condition need to be handled if format method is provide,
      val = removeFormatting(val);
    } else {
      val = (val.match(this.getNumberRegex(true)) || []).join('');
    }
    return val;
  };
  /** methods to remove formattting end **/

  /*** format specific methods start ***/
  /**
   * Format when # based string is provided
   * @param  {string} numStr Numeric String
   * @return {string}        formatted Value
   */
  NumberFormat.prototype.formatWithPattern = function formatWithPattern (numStr        ) {
    var ref = this.props;
    var format = ref.format;
    var hashCount = 0;
    var formattedNumberAry = format.split('');
    for (var i = 0, ln = format.length; i < ln; i++) {
      if (format[i] === '#') {
        formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
        hashCount += 1;
      }
    }
    return formattedNumberAry.join('');
  };
  /**
   * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
   * @return {string} formatted Value
   */
  NumberFormat.prototype.formatAsNumber = function formatAsNumber (numStr        ) {
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var allowNegative = ref.allowNegative;
    var thousandsGroupStyle = ref.thousandsGroupStyle;
    var ref$1 = this.getSeparators();
    var thousandSeparator = ref$1.thousandSeparator;
    var decimalSeparator = ref$1.decimalSeparator;

    var hasDecimalSeparator = numStr.indexOf('.') !== -1 || (decimalScale && fixedDecimalScale);
    var ref$2 = splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const

    //apply decimal precision if its defined
    if (decimalScale !== undefined) {
      afterDecimal = limitToScale(afterDecimal, decimalScale, fixedDecimalScale);
    }

    if (thousandSeparator) {
      beforeDecimal = applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    }

    //add prefix and suffix
    if (prefix) { beforeDecimal = prefix + beforeDecimal; }
    if (suffix) { afterDecimal = afterDecimal + suffix; }

    //restore negation sign
    if (addNegation) { beforeDecimal = '-' + beforeDecimal; }

    numStr = beforeDecimal + ((hasDecimalSeparator && decimalSeparator) || '') + afterDecimal;

    return numStr;
  };

  NumberFormat.prototype.formatNumString = function formatNumString (numStr) {
    if ( numStr === void 0 ) numStr         = '';

    var ref = this.props;
    var format = ref.format;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var customNumerals = ref.customNumerals;
    var formattedValue = numStr;

    if (customNumerals && customNumerals.length === 10) {
      var customNumeralRegex = new RegExp('[' + customNumerals.join('') + ']', 'g');
      formattedValue = numStr.replace(customNumeralRegex, function (digit) { return customNumerals.indexOf(digit).toString(); }
      );
    }

    if (numStr === '' && !allowEmptyFormatting) {
      formattedValue = '';
    } else if (numStr === '-' && !format) {
      formattedValue = '-';
    } else if (typeof format === 'string') {
      formattedValue = this.formatWithPattern(formattedValue);
    } else if (typeof format === 'function') {
      formattedValue = format(formattedValue);
    } else {
      formattedValue = this.formatAsNumber(formattedValue);
    }

    return formattedValue;
  };

  NumberFormat.prototype.formatValueProp = function formatValueProp (defaultValue                 ) {
    var ref = this.props;
    var format = ref.format;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var ref$1 = this.props;
    var value = ref$1.value;
    var isNumericString = ref$1.isNumericString;

    // if value is undefined or null, use defaultValue instead
    value = isNil(value) ? defaultValue : value;

    var isNonNumericFalsy = !value && value !== 0;

    if (isNonNumericFalsy && allowEmptyFormatting) {
      value = '';
    }

    // if value is not defined return empty string
    if (isNonNumericFalsy && !allowEmptyFormatting) { return ''; }

    if (typeof value === 'number') {
      value = toNumericString(value);
      isNumericString = true;
    }

    //change infinity value to empty string
    if (value === 'Infinity' && isNumericString) {
      value = '';
    }

    //round the number based on decimalScale
    //format only if non formatted value is provided
    if (isNumericString && !format && typeof decimalScale === 'number') {
      value = roundToPrecision(value, decimalScale, fixedDecimalScale);
    }

    var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);

    return formattedValue;
  };

  NumberFormat.prototype.formatNegation = function formatNegation (value) {
    if ( value === void 0 ) value         = '';

    var ref = this.props;
    var allowNegative = ref.allowNegative;
    var negationRegex = new RegExp('(-)');
    var doubleNegationRegex = new RegExp('(-)(.)*(-)');

    // Check number has '-' value
    var hasNegation = negationRegex.test(value);

    // Check number has 2 or more '-' values
    var removeNegation = doubleNegationRegex.test(value);

    //remove negation
    value = value.replace(/-/g, '');

    if (hasNegation && !removeNegation && allowNegative) {
      value = '-' + value;
    }

    return value;
  };

  NumberFormat.prototype.formatInput = function formatInput (value) {
    if ( value === void 0 ) value         = '';

    var ref = this.props;
    var format = ref.format;

    //format negation only if we are formatting as number
    if (!format) {
      value = this.removePrefixAndSuffix(value);
      value = this.formatNegation(value);
    }

    //remove formatting from number
    value = this.removeFormatting(value);

    return this.formatNumString(value);
  };

  /*** format specific methods end ***/
  NumberFormat.prototype.isCharacterAFormat = function isCharacterAFormat (caretPos        , value        ) {
    var ref = this.props;
    var format = ref.format;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;

    //check within format pattern
    if (typeof format === 'string' && format[caretPos] !== '#') { return true; }

    //check in number format
    if (
      !format &&
      (caretPos < prefix.length ||
        caretPos >= value.length - suffix.length ||
        (decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator))
    ) {
      return true;
    }

    return false;
  };

  /**
   * This will check if any formatting got removed by the delete or backspace and reset the value
   * It will also work as fallback if android chome keyDown handler does not work
   **/
  NumberFormat.prototype.correctInputValue = function correctInputValue (caretPos        , lastValue        , value        ) {
    var this$1 = this;

    var ref = this.props;
    var format = ref.format;
    var allowNegative = ref.allowNegative;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;
    var decimalSeparator = ref$1.decimalSeparator;
    var lastNumStr = this.state.numAsString || '';
    var ref$2 = this.selectionBeforeInput;
    var selectionStart = ref$2.selectionStart;
    var selectionEnd = ref$2.selectionEnd;
    var ref$3 = findChangedIndex(lastValue, value);
    var start = ref$3.start;
    var end = ref$3.end;

    /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */
    if (
      !format &&
      start === end &&
      allowedDecimalSeparators.indexOf(value[selectionStart]) !== -1
    ) {
      var separator = decimalScale === 0 ? '' : decimalSeparator;
      return (
        value.substr(0, selectionStart) + separator + value.substr(selectionStart + 1, value.length)
      );
    }

    var leftBound = !!format ? 0 : prefix.length;
    var rightBound = lastValue.length - (!!format ? 0 : suffix.length);

    if (
      // don't do anything if something got added
      value.length > lastValue.length ||
      // or if the new value is an empty string
      !value.length ||
      // or if nothing has changed, in which case start will be same as end
      start === end ||
      // or in case if whole input is selected and new value is typed
      (selectionStart === 0 && selectionEnd === lastValue.length) ||
      // or in case if the whole content is replaced by browser, example (autocomplete)
      (start === 0 && end === lastValue.length) ||
      // or if charcters between prefix and suffix is selected.
      // For numeric inputs we apply the format so, prefix and suffix can be ignored
      (selectionStart === leftBound && selectionEnd === rightBound)
    ) {
      return value;
    }

    // check whether the deleted portion has a character that is part of a format
    var deletedValues = lastValue.substr(start, end - start);
    var formatGotDeleted = !![].concat( deletedValues ).find(function (deletedVal, idx) { return this$1.isCharacterAFormat(idx + start, lastValue); }
    );

    // if it has, only remove characters that are not part of the format
    if (formatGotDeleted) {
      var deletedValuePortion = lastValue.substr(start);
      var recordIndexOfFormatCharacters = {};
      var resolvedPortion = [];
      [].concat( deletedValuePortion ).forEach(function (currentPortion, idx) {
        if (this$1.isCharacterAFormat(idx + start, lastValue)) {
          recordIndexOfFormatCharacters[idx] = currentPortion;
        } else if (idx > deletedValues.length - 1) {
          resolvedPortion.push(currentPortion);
        }
      });

      Object.keys(recordIndexOfFormatCharacters).forEach(function (idx) {
        if (resolvedPortion.length > idx) {
          resolvedPortion.splice(idx, 0, recordIndexOfFormatCharacters[idx]);
        } else {
          resolvedPortion.push(recordIndexOfFormatCharacters[idx]);
        }
      });

      value = lastValue.substr(0, start) + resolvedPortion.join('');
    }

    //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
    //clear all numbers in such case while keeping the - sign
    if (!format) {
      var numericString = this.removeFormatting(value);
      var ref$4 = splitDecimal(
        numericString,
        allowNegative
      );
      var beforeDecimal = ref$4.beforeDecimal;
      var afterDecimal = ref$4.afterDecimal;
      var addNegation = ref$4.addNegation; // eslint-disable-line prefer-const

      //clear only if something got deleted
      var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;
      if (
        numericString.length < lastNumStr.length &&
        isBeforeDecimalPoint &&
        beforeDecimal === '' &&
        !parseFloat(afterDecimal)
      ) {
        return addNegation ? '-' : '';
      }
    }

    return value;
  };

  /** Update value and caret position */
  NumberFormat.prototype.updateValue = function updateValue (params   
                           
                        
                       
                            
                               
                   
                     
                              
   ) {
    var formattedValue = params.formattedValue;
    var input = params.input;
    var setCaretPosition = params.setCaretPosition; if ( setCaretPosition === void 0 ) setCaretPosition = true;
    var source = params.source;
    var event = params.event;
    var numAsString = params.numAsString;
    var caretPos = params.caretPos;
    var ref = this.props;
    var onValueChange = ref.onValueChange;
    var ref$1 = this.state;
    var lastValue = ref$1.value;

    if (input) {
      //calculate caret position if not defined
      if (caretPos === undefined && setCaretPosition) {
        var inputValue = params.inputValue || input.value;

        var currentCaretPosition = getCurrentCaretPosition(input);

        /**
         * set the value imperatively, this is required for IE fix
         * This is also required as if new caret position is beyond the previous value.
         * Caret position will not be set correctly
         */
        input.value = formattedValue;

        //get the caret position
        caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);
      }

      /**
       * set the value imperatively, as we set the caret position as well imperatively.
       * This is to keep value and caret position in sync
       */
      input.value = formattedValue;

      //set caret position, and value imperatively when element is provided
      if (setCaretPosition) {
        //set caret position
        this.setPatchedCaretPosition(input, caretPos, formattedValue);
      }
    }

    //calculate numeric string if not passed
    if (numAsString === undefined) {
      numAsString = this.removeFormatting(formattedValue);
    }

    //update state if value is changed
    if (formattedValue !== lastValue) {
      this.setState({ value: formattedValue, numAsString: numAsString });

      // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
      onValueChange(this.getValueObject(formattedValue, numAsString), { event: event, source: source });
    }
  };

  NumberFormat.prototype.onChange = function onChange (e                     ) {
    var el = e.target;
    var inputValue = el.value;
    var ref = this;
    var state = ref.state;
    var props = ref.props;
    var isAllowed = props.isAllowed;
    var lastValue = state.value || '';

    var currentCaretPosition = getCurrentCaretPosition(el);

    inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);

    var formattedValue = this.formatInput(inputValue) || '';
    var numAsString = this.removeFormatting(formattedValue);

    var valueObj = this.getValueObject(formattedValue, numAsString);
    var isChangeAllowed = isAllowed(valueObj);

    if (!isChangeAllowed) {
      formattedValue = lastValue;
    }

    this.updateValue({
      formattedValue: formattedValue,
      numAsString: numAsString,
      inputValue: inputValue,
      input: el,
      event: e,
      source: 'event',
    });

    if (isChangeAllowed) {
      props.onChange(e);
    }
  };

  NumberFormat.prototype.onBlur = function onBlur (e                     ) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var format = props.format;
    var onBlur = props.onBlur;
    var allowLeadingZeros = props.allowLeadingZeros;
    var numAsString = state.numAsString;
    var lastValue = state.value;
    this.focusedElm = null;

    clearTimeout(this.focusTimeout);
    clearTimeout(this.caretPositionTimeout);

    if (!format) {
      // if the numAsString is not a valid number reset it to empty
      if (isNaN(parseFloat(numAsString))) {
        numAsString = '';
      }

      if (!allowLeadingZeros) {
        numAsString = fixLeadingZero(numAsString);
      }

      var formattedValue = this.formatNumString(numAsString);

      //change the state
      if (formattedValue !== lastValue) {
        // the event needs to be persisted because its properties can be accessed in an asynchronous way
        this.updateValue({
          formattedValue: formattedValue,
          numAsString: numAsString,
          input: e.target,
          setCaretPosition: false,
          event: e,
          source: 'event',
        });
        onBlur(e);
        return;
      }
    }
    onBlur(e);
  };

  NumberFormat.prototype.onKeyDown = function onKeyDown (e                             ) {
    var el = e.target;
    var key = e.key;
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value; if ( value === void 0 ) value = '';
    var expectedCaretPosition;
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var format = ref.format;
    var onKeyDown = ref.onKeyDown;
    var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
    var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
    var negativeRegex = new RegExp('-');
    var isPatternFormat = typeof format === 'string';

    this.selectionBeforeInput = {
      selectionStart: selectionStart,
      selectionEnd: selectionEnd,
    };

    //Handle backspace and delete against non numerical/decimal characters or arrow keys
    if (key === 'ArrowLeft' || key === 'Backspace') {
      expectedCaretPosition = selectionStart - 1;
    } else if (key === 'ArrowRight') {
      expectedCaretPosition = selectionStart + 1;
    } else if (key === 'Delete') {
      expectedCaretPosition = selectionStart;
    }

    //if expectedCaretPosition is not set it means we don't want to Handle keyDown
    //also if multiple characters are selected don't handle
    if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
      onKeyDown(e);
      return;
    }

    var newCaretPosition = expectedCaretPosition;
    var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
    var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;

    if (key === 'ArrowLeft' || key === 'ArrowRight') {
      var direction = key === 'ArrowLeft' ? 'left' : 'right';
      newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
    } else if (
      key === 'Delete' &&
      !numRegex.test(value[expectedCaretPosition]) &&
      !negativeRegex.test(value[expectedCaretPosition])
    ) {
      while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
        newCaretPosition++;
      }
    } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition])) {
      /* NOTE: This is special case when backspace is pressed on a
      negative value while the cursor position is after prefix. We can't handle it on onChange because
      we will not have any information of keyPress
      */
      if (selectionStart <= leftBound + 1 && value[0] === '-' && typeof format === 'undefined') {
        var newValue = value.substring(1);
        this.updateValue({
          formattedValue: newValue,
          caretPos: newCaretPosition,
          input: el,
          event: e,
          source: 'event',
        });
      } else if (!negativeRegex.test(value[expectedCaretPosition])) {
        while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
          newCaretPosition--;
        }
        newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
      }
    }

    if (
      newCaretPosition !== expectedCaretPosition ||
      expectedCaretPosition < leftBound ||
      expectedCaretPosition > rightBound
    ) {
      e.preventDefault();
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }

    /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
            Remove this when you find different solution */
    if (e.isUnitTestRun) {
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }

    onKeyDown(e);
  };

  /** required to handle the caret position when click anywhere within the input **/
  NumberFormat.prototype.onMouseUp = function onMouseUp (e                          ) {
    var el = e.target;

    /**
     * NOTE: we have to give default value for value as in case when custom input is provided
     * value can come as undefined when nothing is provided on value prop.
     */
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value; if ( value === void 0 ) value = '';

    if (selectionStart === selectionEnd) {
      var caretPosition = this.correctCaretPosition(value, selectionStart);
      if (caretPosition !== selectionStart) {
        this.setPatchedCaretPosition(el, caretPosition, value);
      }
    }

    this.props.onMouseUp(e);
  };

  NumberFormat.prototype.onFocus = function onFocus (e                     ) {
    var this$1 = this;

    // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
    // (onFocus event target selectionStart is always 0 before setTimeout)
    e.persist();

    this.focusedElm = e.target;
    this.focusTimeout = setTimeout(function () {
      var el = e.target;
      var selectionStart = el.selectionStart;
      var selectionEnd = el.selectionEnd;
      var value = el.value; if ( value === void 0 ) value = '';

      var caretPosition = this$1.correctCaretPosition(value, selectionStart);

      //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
      if (
        caretPosition !== selectionStart &&
        !(selectionStart === 0 && selectionEnd === value.length)
      ) {
        this$1.setPatchedCaretPosition(el, caretPosition, value);
      }

      this$1.props.onFocus(e);
    }, 0);
  };

  NumberFormat.prototype.render = function render () {
    var ref = this.props;
    var type = ref.type;
    var displayType = ref.displayType;
    var customInput = ref.customInput;
    var renderText = ref.renderText;
    var getInputRef = ref.getInputRef;
    var format = ref.format;
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var thousandsGroupStyle = ref.thousandsGroupStyle;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var removeFormatting = ref.removeFormatting;
    var mask = ref.mask;
    var defaultValue = ref.defaultValue;
    var isNumericString = ref.isNumericString;
    var allowNegative = ref.allowNegative;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var allowLeadingZeros = ref.allowLeadingZeros;
    var onValueChange = ref.onValueChange;
    var isAllowed = ref.isAllowed;
    var customNumerals = ref.customNumerals;
    var onChange = ref.onChange;
    var onKeyDown = ref.onKeyDown;
    var onMouseUp = ref.onMouseUp;
    var onFocus = ref.onFocus;
    var onBlur = ref.onBlur;
    var propValue = ref.value;
    var rest = objectWithoutProperties( ref, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "thousandSeparator", "decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "decimalScale", "fixedDecimalScale", "prefix", "suffix", "removeFormatting", "mask", "defaultValue", "isNumericString", "allowNegative", "allowEmptyFormatting", "allowLeadingZeros", "onValueChange", "isAllowed", "customNumerals", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value"] );
    var otherProps = rest;
    var ref$1 = this.state;
    var value = ref$1.value;
    var mounted = ref$1.mounted;

    // add input mode on element based on format prop and device once the component is mounted
    var inputMode = mounted && addInputMode(format) ? 'numeric' : undefined;

    var inputProps = Object.assign({ inputMode: inputMode }, otherProps, {
      type: type,
      value: value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onMouseUp: this.onMouseUp,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
    });

    if (displayType === 'text') {
      return renderText ? (
        renderText(value, otherProps) || null
      ) : (
        React__default.createElement( 'span', Object.assign({}, otherProps, { ref: getInputRef }),
          value
        )
      );
    } else if (customInput) {
      var CustomInput = customInput;
      return React__default.createElement( CustomInput, Object.assign({}, inputProps, { ref: getInputRef }));
    }

    return React__default.createElement( 'input', Object.assign({}, inputProps, { ref: getInputRef }));
  };

  return NumberFormat;
}(React__default.Component));

NumberFormat.defaultProps = defaultProps$4;

var _templateObject$U, _templateObject2$M, _templateObject3$F, _templateObject4$x;
var FormattedAmountInput = styled.div(_templateObject$U || (_templateObject$U = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  input {\n    text-align: center;\n    ", ";\n    border: none;\n    box-shadow: inset 0 -1px 0 ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    color: ", ";\n\n    &:focus {\n      outline: none;\n      border: none;\n      box-shadow: inset 0 -1px 0 ", ";\n      caret-color: ", ";\n    }\n\n    ", "\n\n    &::placeholder {\n      color: ", ";\n    }\n  }\n"])), theme.textStyles['text-preset-2'], theme.colors.neutral.border.regular, theme.spacing['spacing-6'], theme.spacing['spacing-3'], theme.colors.neutral.text.strong, theme.colors['secondary-1'].border.regular, theme.colors['secondary-1'].border.regular, function (_ref) {
  var status = _ref.status;
  return status === 'error' && css$1(_templateObject2$M || (_templateObject2$M = _taggedTemplateLiteral(["\n        border: none;\n        box-shadow: inset 0 -1px 0 ", ";\n        &:focus {\n          outline: none;\n          border: none;\n          box-shadow: inset 0 -1px 0 ", ";\n          caret-color: ", ";\n        }\n      "])), theme.colors.danger.border.regular, theme.colors.danger.border.regular, theme.colors.danger.border.regular);
}, theme.colors.neutral.text.regular);
var HelpText$3 = styled.div(_templateObject3$F || (_templateObject3$F = _taggedTemplateLiteral(["\n  padding-top: ", ";\n  display: flex;\n  justify-content: center;\n  ", "\n"])), theme.spacing['spacing-3'], function (_ref2) {
  var status = _ref2.status;
  return status === 'error' && css$1(_templateObject4$x || (_templateObject4$x = _taggedTemplateLiteral(["\n      > * {\n        &:first-child {\n          margin-right: ", ";\n        }\n      }\n    "])), theme.spacing['spacing-2']);
});

var spanVariantByStatus$2 = {
  normal: 'neutral',
  error: 'danger'
};
var FormattedAmountInput$1 = function FormattedAmountInput$1(_ref) {
  var name = _ref.name,
    label = _ref.label,
    message = _ref.message,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    _onValueChange = _ref.onValueChange,
    disabled = _ref.disabled,
    placeHolder = _ref.placeHolder,
    decimalSeparator = _ref.decimalSeparator,
    decimalScale = _ref.decimalScale,
    thousandSeparator = _ref.thousandSeparator,
    prefix = _ref.prefix,
    status = _ref.status,
    value = _ref.value;
  var _useState = useState({
      value: value
    }),
    _useState2 = _slicedToArray(_useState, 2),
    formattedAmountState = _useState2[0],
    setFormattedAmountState = _useState2[1];
  return /*#__PURE__*/React__default.createElement(FormattedAmountInput, {
    status: status
  }, label && /*#__PURE__*/React__default.createElement(Label$1, {
    type: "2",
    htmlFor: name,
    align: "center"
  }, label), /*#__PURE__*/React__default.createElement(NumberFormat, {
    placeholder: placeHolder,
    isNumericString: true,
    decimalSeparator: decimalSeparator || ',',
    value: formattedAmountState.value,
    decimalScale: decimalScale || 2,
    fixedDecimalScale: true,
    thousandSeparator: thousandSeparator || '.',
    prefix: prefix || '$',
    onValueChange: function onValueChange(values) {
      setFormattedAmountState({
        value: values.value
      });
      _onValueChange && _onValueChange(values);
    },
    name: name,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    disabled: disabled
  }), message && /*#__PURE__*/React__default.createElement(HelpText$3, {
    status: status
  }, status === 'error' && /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "error_circle_outline",
    variant: "danger",
    width: 16,
    height: 16
  }), /*#__PURE__*/React__default.createElement(Span$1, {
    type: "4",
    variant: spanVariantByStatus$2[status]
  }, message)));
};
FormattedAmountInput$1.defaultProps = {
  status: 'normal',
  disabled: false,
  value: ''
};
FormattedAmountInput$1.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  message: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  disabled: PropTypes.bool,
  placeHolder: PropTypes.string,
  decimalSeparator: PropTypes.string,
  decimalScale: PropTypes.number,
  thousandSeparator: PropTypes.string,
  prefix: PropTypes.string,
  status: PropTypes.oneOf(['normal', 'error']),
  value: PropTypes.string
};

var _templateObject$V, _templateObject2$N, _templateObject3$G, _templateObject4$y, _templateObject5$t, _templateObject6$p;
var ItemEstablishment = styled.div(_templateObject$V || (_templateObject$V = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  border: none;\n"])));
var Info$1 = styled.div(_templateObject2$N || (_templateObject2$N = _taggedTemplateLiteral(["\n  width: ", ";\n"])), theme.spacing['spacing-13']);
var BrandWrapper = styled.div(_templateObject3$G || (_templateObject3$G = _taggedTemplateLiteral([""])));
var Detail = styled.div(_templateObject4$y || (_templateObject4$y = _taggedTemplateLiteral([""])));
var FirstContent = styled.div(_templateObject5$t || (_templateObject5$t = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var SecondContent = styled.div(_templateObject6$p || (_templateObject6$p = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-top: ", ";\n  span:first-child {\n    margin-bottom: ", ";\n  }\n"])), theme.spacing['spacing-3'], theme.spacing['spacing-2']);

var images = {
  VISA: 'visa_color',
  'VISA DEBITO': 'visa_debito_color',
  MASTERCARD: 'mastercard_color',
  'MASTERCARD DEBITO': 'mastercard_debito_color',
  CABAL: 'cabal_color',
  'CABAL DEBITO': 'cabal_debito_color',
  'UNION PAY': 'unionpay_color',
  MAESTRO: 'maestro_color',
  AMEX: 'amex_color',
  DISCOVER: 'discover_color',
  DEFAULT: 'none_color',
  PRIVADA: 'none_color'
};
var ItemEstablishment$1 = function ItemEstablishment$1(_ref) {
  var brand = _ref.brand,
    sale_method = _ref.sale_method,
    establishment_id = _ref.establishment_id,
    fantasy_name = _ref.fantasy_name,
    business_area = _ref.business_area,
    bank = _ref.bank;
  return /*#__PURE__*/React__default.createElement(ItemEstablishment, null, /*#__PURE__*/React__default.createElement(Info$1, null, /*#__PURE__*/React__default.createElement(BrandWrapper, null, /*#__PURE__*/React__default.createElement(Brand, {
    name: images[brand] || 'none_color',
    width: 48,
    height: 32
  })), /*#__PURE__*/React__default.createElement(Pill, {
    variant: "neutral-1"
  }, sale_method.toLowerCase())), /*#__PURE__*/React__default.createElement(Detail, null, /*#__PURE__*/React__default.createElement(FirstContent, null, /*#__PURE__*/React__default.createElement(Span$1, {
    type: "1",
    variant: "neutral",
    modifier: "strong"
  }, establishment_id), /*#__PURE__*/React__default.createElement(Span$1, {
    type: "2",
    variant: "neutral"
  }, fantasy_name)), /*#__PURE__*/React__default.createElement(SecondContent, null, /*#__PURE__*/React__default.createElement(Span$1, {
    type: "4",
    variant: "neutral",
    modifier: "strong"
  }, business_area), /*#__PURE__*/React__default.createElement(Span$1, {
    type: "5",
    variant: "neutral"
  }, bank))));
};

var _templateObject$W, _templateObject2$O, _templateObject3$H, _templateObject4$z, _templateObject5$u, _templateObject6$q, _templateObject7$l, _templateObject8$h;
var Wrapper = styled.div(_templateObject$W || (_templateObject$W = _taggedTemplateLiteral(["\n  display: grid;\n  position: relative;\n"])));
var DataItem$1 = styled.div(_templateObject2$O || (_templateObject2$O = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 40px;\n  display: flex;\n  -webkit-box-align: center;\n  align-items: center;\n  :hover {\n    cursor: pointer;\n    background-color: ", ";\n  }\n"])), theme.colors.neutral.bg.regular);
var DataItemText$1 = styled.p(_templateObject3$H || (_templateObject3$H = _taggedTemplateLiteral(["\n  margin-left: ", ";\n  padding-left: ", ";\n  margin-bottom: auto;\n  margin-top: auto;\n"])), theme.spacing['spacing-3'], theme.spacing['spacing-1']);
var DataResult$1 = styled.div(_templateObject4$z || (_templateObject4$z = _taggedTemplateLiteral(["\n  background: ", ";\n  position: absolute;\n  width: 100%;\n  top: ", ";\n  height: auto;\n  max-height: 200px;\n  border-radius: ", ";\n  border: solid 1px ", ";\n  overflow: hidden auto;\n  z-index: 2;\n  &::-webkit-scrollbar {\n    width: 3px;\n  }\n  &::-webkit-scrollbar-track {\n  }\n  &::-webkit-scrollbar-thumb {\n    background: ", ";\n  }\n  &::-webkit-scrollbar-thumb:hover {\n  }\n"])), theme.colors.neutral.bg.weak, theme.spacing['spacing-11'], theme.borderRadius['border-radius-2'], theme.colors.neutral.border.regular, theme.colors.neutral.bg.stronger);
var InputWrapper$1 = styled.div(_templateObject5$u || (_templateObject5$u = _taggedTemplateLiteral(["\n  position: relative;\n  input {\n    ", "\n"])), function (_ref) {
  var showDisplay = _ref.showDisplay;
  return css$1(_templateObject6$q || (_templateObject6$q = _taggedTemplateLiteral(["\n      opacity: ", ";\n    "])), showDisplay ? '0' : '1');
});
var InputDisplay = styled.div(_templateObject7$l || (_templateObject7$l = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n  ", "\n  padding-left: ", ";\n  padding-right: ", ";\n  margin-left: ", ";\n  display: flex;\n  justify-content: space-between;\n  outline: none;\n  width: 100%;\n"])), function (_ref2) {
  var hasLabel = _ref2.hasLabel;
  return css$1(_templateObject8$h || (_templateObject8$h = _taggedTemplateLiteral(["\n    padding-top: ", ";\n  "])), hasLabel ? theme.spacing['spacing-7'] : theme.spacing['spacing-3']);
}, theme.spacing['spacing-8'], theme.spacing['spacing-4'], theme.spacing['spacing-1']);

var SelectList = function SelectList(props) {
  var placeholder = props.placeholder,
    options = props.options,
    label = props.label,
    onChange = props.onChange,
    disabled = props.disabled,
    inputStatus = props.inputStatus,
    message = props.message,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    name = props.name,
    value = props.value;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    filteredOptions = _useState2[0],
    setFilteredOptions = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var _useState5 = useState(!!placeholder),
    _useState6 = _slicedToArray(_useState5, 2),
    showPlaceHolder = _useState6[0],
    setShowPlaceHolder = _useState6[1];
  var inputRef = useRef(null);
  var valueRef = useRef(null);
  var _useState7 = useState(NULL_OPTION_SELECT),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedValue = _useState8[0],
    setSelectedValue = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showDisplay = _useState10[0],
    setShowDisplay = _useState10[1];
  useEffect(function () {
    setSelectedValue(value ? options.find(function (elem) {
      return elem.value === value;
    }) || NULL_OPTION_SELECT : NULL_OPTION_SELECT);
  }, [value]);
  useEffect(function () {
    setShowDisplay(selectedValue && selectedValue !== NULL_OPTION_SELECT);
  }, [selectedValue]);
  useEffect(function () {
    if (open) {
      inputRef.current.focus();
    }
  }, [open]);
  useEffect(function () {
    if (filteredOptions !== options) {
      setFilteredOptions(options || []);
    }
  }, [options]);
  var filterOptionsByLabel = function filterOptionsByLabel(value, options) {
    return value ? options.filter(function (_ref) {
      var label = _ref.label;
      return label.toLowerCase().includes(value.toLowerCase());
    }) : options;
  };
  var handleClose = function handleClose() {
    setOpen(false);
  };
  var handleOnChange = function handleOnChange(event) {
    var newOptions = filterOptionsByLabel(event.target.value, options);
    setFilteredOptions(newOptions);
    setSelectedValue({
      value: event.target.value,
      label: event.target.value
    });
  };
  var handleReset = function handleReset() {
    onChange && onChange('');
    setShowPlaceHolder(true);
    setFilteredOptions(options);
    setSelectedValue(NULL_OPTION_SELECT);
    handleClose();
  };
  var handleSelectOption = function handleSelectOption(option) {
    var optionChosen = options.filter(function (_ref2) {
      var value = _ref2.value;
      return value === option.value;
    });
    setFilteredOptions(optionChosen);
    setSelectedValue(option);
    onChange && onChange(option.value);
    handleClose();
    valueRef.current.focus();
  };
  var handleOnFocus = function handleOnFocus() {
    onFocus && onFocus();
    setOpen(true);
    setShowPlaceHolder(false);
  };
  var handleOnBlur = function handleOnBlur() {
    onBlur && onBlur();
    setShowPlaceHolder(inputRef.current.value.length === 0);
  };
  var handleKeyDown = function handleKeyDown(event) {
    event.preventDefault();
    if (event.key === BACKSPACE_KEY || event.key === DELETE_KEY) {
      handleReset();
    }
  };
  var renderFilteredOptions = function renderFilteredOptions() {
    return /*#__PURE__*/React__default.createElement(OutsideAlerter, {
      handleOutSideClick: handleReset,
      active: open,
      exclude: ['#select-list']
    }, /*#__PURE__*/React__default.createElement(DataResult$1, null, filteredOptions.length > 0 && filteredOptions.map(function (filteredOption, key) {
      return /*#__PURE__*/React__default.createElement(DataItem$1, {
        "data-testid": "option-".concat(key),
        key: key,
        onClick: function onClick() {
          return handleSelectOption(filteredOption);
        }
      }, /*#__PURE__*/React__default.createElement(DataItemText$1, null, filteredOption.label));
    })));
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Wrapper, {
    "data-testid": "select-list"
  }, /*#__PURE__*/React__default.createElement(InputWrapper$1, {
    showDisplay: showDisplay
  }, /*#__PURE__*/React__default.createElement(InputDisplay, {
    tabIndex: -1,
    onKeyDown: handleKeyDown,
    ref: valueRef,
    hasLabel: !!label,
    "data-testid": "input-display"
  }, /*#__PURE__*/React__default.createElement(P$1, {
    type: "2",
    variant: "neutral",
    modifier: "strong"
  }, selectedValue.label), selectedValue.value && /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "cancel_outline",
    onClick: handleReset,
    modifier: "strong",
    cursor: "pointer"
  })), /*#__PURE__*/React__default.createElement(Input$1, {
    disabled: disabled,
    inputRef: inputRef,
    id: "select-list",
    type: "text",
    label: label,
    placeHolder: showPlaceHolder ? placeholder : '',
    onChange: handleOnChange,
    value: selectedValue.value,
    autocomplete: "off",
    icons: {
      iconLeft: 'search_outline'
    },
    inputStatus: inputStatus,
    message: message,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    name: name
  })), open && renderFilteredOptions()));
};
SelectList.defaultProps = {
  options: [],
  placeholder: '',
  label: '',
  disabled: false,
  inputStatus: 'normal'
};
SelectList.propTypes = {
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  onInput: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  inputStatus: PropTypes.oneOf(['normal', 'error']),
  message: PropTypes.string
};

var _templateObject$X, _templateObject2$P, _templateObject3$I, _templateObject4$A, _templateObject5$v, _templateObject6$r, _templateObject7$m;
var Carousel = styled.div(_templateObject$X || (_templateObject$X = _taggedTemplateLiteral(["\n  width: 328px;\n  height: 476px;\n  position: relative;\n  overflow: hidden;\n"])));
var CarouselImagesWrapper = styled.div(_templateObject2$P || (_templateObject2$P = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: nowrap;\n"])));
var CarouselImage = styled.div(_templateObject3$I || (_templateObject3$I = _taggedTemplateLiteral(["\n  min-width: 328px;\n  height: 448px;\n  transition: 0.3s ease all;\n  position: relative;\n  img {\n    border-radius: ", ";\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n  }\n"])), theme.borderRadius["border-radius-4"]);
var CarouselBottom = styled.div(_templateObject4$A || (_templateObject4$A = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  height: 28px;\n  justify-content: center;\n  align-content: center;\n  padding: ", " ", ";\n  bottom: 0;\n  position: absolute;\n"])), theme.spacing["spacing-3"], theme.spacing["spacing-6"]);
var getOvalVariant$1 = function getOvalVariant(variant) {
  switch (variant) {
    case 'neutral':
      return css$1(_templateObject5$v || (_templateObject5$v = _taggedTemplateLiteral(["\n        border-color: ", ";\n        background-color: ", ";\n      "])), theme.colors.primary.border.strong, theme.colors.neutral.bg.strong);
    case 'primary':
      return css$1(_templateObject6$r || (_templateObject6$r = _taggedTemplateLiteral(["\n        border-color: ", ";\n        background-color: ", ";\n      "])), theme.colors.neutral.border.strong, theme.colors.primary.bg.strong);
  }
};
var Oval$1 = styled.div(_templateObject7$m || (_templateObject7$m = _taggedTemplateLiteral(["\n  ", "\n  width: 10px;\n  height: 10px;\n  margin-right: ", ";\n  border-radius: ", ";\n  border-width: 1px;\n  border-style: solid;\n  cursor: pointer;\n"])), function (props) {
  return getOvalVariant$1(props.variant);
}, theme.spacing["spacing-3"], theme.borderRadius["border-radius-5"]);

var Carousel$1 = function Carousel$1(_ref) {
  var images = _ref.images,
    interval = _ref.interval,
    transitionInterval = _ref.transitionInterval;
  var carousel = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  var handleClick = function handleClick(selectedIndex) {
    setActiveIndex(selectedIndex);
    movement(selectedIndex);
  };
  var movement = function movement(selectedIndex) {
    if (images.length > 0) {
      var mov = -328 * selectedIndex;
      carousel.current.style.transform = "translateX(".concat(mov, "px)");
      carousel.current.style.transition = "".concat(transitionInterval, "ms ease-out all");
    }
  };
  useEffect(function () {
    var intervalId = setInterval(function () {
      if (activeIndex === images.length - 1) {
        setActiveIndex(0);
        movement(0);
      } else {
        setActiveIndex(activeIndex + 1);
        movement(activeIndex + 1);
      }
    }, interval);
    return function () {
      return clearInterval(intervalId);
    };
  }, [activeIndex]);
  return /*#__PURE__*/React__default.createElement(Carousel, null, /*#__PURE__*/React__default.createElement(CarouselImagesWrapper, {
    ref: carousel
  }, images.map(function (element, index) {
    return /*#__PURE__*/React__default.createElement(CarouselImage, {
      key: "".concat(element.imageURL, "-").concat(index)
    }, /*#__PURE__*/React__default.createElement("a", {
      href: "".concat(element.href),
      target: element.isLocalRef ? '_self' : '_blank',
      rel: "noreferrer"
    }, /*#__PURE__*/React__default.createElement(Image$1, {
      name: element.imageURL,
      alt: element.alt,
      cursor: "onClick",
      isExternalSrc: true
    })));
  })), /*#__PURE__*/React__default.createElement(CarouselBottom, null, images.length > 1 && images.map(function (element, index) {
    return /*#__PURE__*/React__default.createElement(Oval$1, {
      key: "data-oval-".concat(index),
      variant: activeIndex === index ? 'primary' : 'neutral',
      onClick: function onClick() {
        handleClick(index);
      }
    });
  })));
};
Carousel$1.defaultProps = {
  interval: 5000,
  transitionInterval: 1000
};
Carousel$1.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string.isRequired,
    imageURL: PropTypes.string.isRequired,
    isLocalRef: PropTypes.bool.isRequired,
    altImage: PropTypes.string.isRequired
  })).isRequired,
  interval: PropTypes.number,
  transitionInterval: PropTypes.number
};

var _templateObject$Y, _templateObject2$Q;
var Logo = styled.i(_templateObject$Y || (_templateObject$Y = _taggedTemplateLiteral(["\n  font-style: normal;\n  display: flex;\n  align-items: center;\n  ", "\n"])), function (_ref) {
  var cursor = _ref.cursor;
  return css$1(_templateObject2$Q || (_templateObject2$Q = _taggedTemplateLiteral(["\n      cursor: ", ";\n    "])), cursor);
});

var _path$7g, _path2$2i, _path3$F, _path4$8, _path5$2;
function _extends$7r() { _extends$7r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7r.apply(this, arguments); }
var SvgVerticalMediumFull = function SvgVerticalMediumFull(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7r({
    width: 120,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7g || (_path$7g = /*#__PURE__*/createElement$2("path", {
    d: "M30.18 70.477a4.544 4.544 0 0 0-1.773-2.182 5.263 5.263 0 0 0-2.935-.794c-.57 0-1.135.09-1.676.269a6.712 6.712 0 0 0-2.468 1.43l.058-.334a1.107 1.107 0 0 0-.245-.973 1.252 1.252 0 0 0-.985-.392 1.736 1.736 0 0 0-1.121.392c-.31.239-.52.586-.588.973l-2.416 13.767a1.096 1.096 0 0 0 .243.984 1.274 1.274 0 0 0 .986.38c.409.006.806-.132 1.122-.391.31-.24.52-.586.588-.973l.74-4.216c.158.172.33.33.516.475.416.318.881.568 1.376.738.575.2 1.179.299 1.786.291a6.526 6.526 0 0 0 3.14-.793 7.62 7.62 0 0 0 2.517-2.194 7.502 7.502 0 0 0 1.363-3.235 5.873 5.873 0 0 0-.228-3.222Zm-3.376 5.136a4.457 4.457 0 0 1-1.488 1.354c-.6.332-1.276.501-1.96.493a3.12 3.12 0 0 1-1.8-.493 2.65 2.65 0 0 1-1.024-1.354 3.748 3.748 0 0 1-.118-1.913 4.61 4.61 0 0 1 .79-1.914 4.467 4.467 0 0 1 1.495-1.332c.605-.33 1.285-.5 1.974-.492a3.066 3.066 0 0 1 1.788.492c.47.325.825.791 1.015 1.332.208.616.249 1.277.118 1.914a4.712 4.712 0 0 1-.79 1.913ZM45.508 67.88a1.274 1.274 0 0 0-.987-.381 1.736 1.736 0 0 0-1.121.392c-.31.239-.52.586-.588.973l-.006.033a4.496 4.496 0 0 0-.413-.369 4.854 4.854 0 0 0-1.401-.738 5.687 5.687 0 0 0-1.883-.291 6.544 6.544 0 0 0-3.128.794 7.577 7.577 0 0 0-2.529 2.193 7.5 7.5 0 0 0-1.363 3.236 5.877 5.877 0 0 0 .233 3.211c.344.905.969 1.674 1.783 2.194.876.544 1.892.82 2.922.793a5.618 5.618 0 0 0 1.776-.28 7.228 7.228 0 0 0 1.504-.682 6.45 6.45 0 0 0 .843-.604 1.097 1.097 0 0 0 .248.95 1.25 1.25 0 0 0 .984.392c.408.006.805-.132 1.122-.391.31-.24.52-.587.587-.974l1.662-9.467a1.1 1.1 0 0 0-.245-.985Zm-5.71 9.086a4.02 4.02 0 0 1-1.974.493 3.075 3.075 0 0 1-1.775-.493 2.663 2.663 0 0 1-1.026-1.343 3.681 3.681 0 0 1-.12-1.902 4.68 4.68 0 0 1 .79-1.925 4.44 4.44 0 0 1 1.497-1.343 3.98 3.98 0 0 1 1.949-.492 3.125 3.125 0 0 1 1.8.492 2.67 2.67 0 0 1 1.025 1.343c.206.62.246 1.284.116 1.925a4.64 4.64 0 0 1-.787 1.902 4.44 4.44 0 0 1-1.495 1.343ZM58.386 67.89a1.253 1.253 0 0 0-.985-.39 1.735 1.735 0 0 0-1.122.39c-.31.24-.52.587-.587.974l-1.006 5.73a3.49 3.49 0 0 1-.572 1.444c-.27.386-.637.695-1.063.895a3.48 3.48 0 0 1-1.498.302c-.833 0-1.447-.198-1.843-.593-.396-.395-.51-1.078-.339-2.048l1.005-5.73a1.106 1.106 0 0 0-.245-.973 1.253 1.253 0 0 0-.985-.392 1.737 1.737 0 0 0-1.122.392c-.31.239-.52.586-.587.973L46.29 75.4a4.174 4.174 0 0 0 .149 2.228 3 3 0 0 0 1.239 1.522 3.997 3.997 0 0 0 2.17.55 7.598 7.598 0 0 0 2.004-.247 5.349 5.349 0 0 0 1.61-.728c.217-.148.422-.315.613-.496l-.042.24a4.186 4.186 0 0 1-.695 1.8 2.7 2.7 0 0 1-1.292.94c-.621.2-1.271.295-1.923.28a3.893 3.893 0 0 1-1.428-.235c-.397-.157-.72-.273-.968-.347a1.36 1.36 0 0 0-1.038.056 1.825 1.825 0 0 0-.866.885.998.998 0 0 0-.053.929c.198.344.514.602.89.727.445.173.91.286 1.386.336a12.8 12.8 0 0 0 1.646.112 9.744 9.744 0 0 0 3.28-.537 6.021 6.021 0 0 0 2.573-1.757 6.648 6.648 0 0 0 1.421-3.279l1.67-9.512a1.105 1.105 0 0 0-.25-.976ZM77.198 67.89a1.164 1.164 0 0 0-.91-.39c-.752 0-1.276.283-1.571.85l-3.754 6.435-1.063-4.667a1.165 1.165 0 0 0-.346-.616 1.18 1.18 0 0 0-.783-.213 1.684 1.684 0 0 0-1.492.828l-2.773 4.792-1.498-6.56a.867.867 0 0 0-.4-.649 1.509 1.509 0 0 0-.798-.201 1.647 1.647 0 0 0-1.154.425c-.29.248-.488.587-.56.962-.032.17-.03.346.007.515l2.13 9.221a.989.989 0 0 0 .505.683c.269.156.582.215.89.168a1.773 1.773 0 0 0 1.396-.85l2.94-5.506 1.127 5.505a1.153 1.153 0 0 0 1.1.851 1.73 1.73 0 0 0 1.692-.85l5.366-9.222a1.385 1.385 0 0 0 .188-.515 1.129 1.129 0 0 0-.239-.995ZM90.844 67.88a1.276 1.276 0 0 0-.986-.38 1.736 1.736 0 0 0-1.122.39c-.31.24-.52.587-.588.975l-.005.032a4.496 4.496 0 0 0-.413-.368 4.854 4.854 0 0 0-1.402-.739 5.688 5.688 0 0 0-1.883-.29 6.545 6.545 0 0 0-3.128.793 7.577 7.577 0 0 0-2.528 2.193 7.498 7.498 0 0 0-1.364 3.236 5.877 5.877 0 0 0 .233 3.212 4.5 4.5 0 0 0 1.783 2.193c.876.545 1.892.82 2.922.794a5.616 5.616 0 0 0 1.776-.28 7.215 7.215 0 0 0 1.504-.683c.297-.178.579-.38.843-.604a1.098 1.098 0 0 0 .248.95 1.248 1.248 0 0 0 .984.392c.409.007.806-.132 1.124-.391.31-.24.52-.587.587-.974l1.661-9.467a1.1 1.1 0 0 0-.246-.985Zm-5.71 9.086c-.604.33-1.283.5-1.972.493a3.074 3.074 0 0 1-1.775-.493 2.664 2.664 0 0 1-1.026-1.343 3.687 3.687 0 0 1-.12-1.902 4.684 4.684 0 0 1 .79-1.925 4.438 4.438 0 0 1 1.498-1.343 3.977 3.977 0 0 1 1.948-.492 3.125 3.125 0 0 1 1.8.492 2.67 2.67 0 0 1 1.025 1.343c.206.62.246 1.284.116 1.925a4.634 4.634 0 0 1-.787 1.902 4.44 4.44 0 0 1-1.497 1.343ZM103.721 67.89a1.247 1.247 0 0 0-.984-.39 1.736 1.736 0 0 0-1.122.39c-.31.24-.52.587-.588.974l-1.005 5.73a3.49 3.49 0 0 1-.572 1.444c-.27.386-.637.695-1.063.895-.47.21-.982.314-1.498.302-.833 0-1.447-.198-1.843-.593-.396-.395-.509-1.078-.339-2.048l1.005-5.73a1.103 1.103 0 0 0-.245-.973 1.253 1.253 0 0 0-.985-.392 1.735 1.735 0 0 0-1.122.392c-.31.239-.52.586-.587.973L91.626 75.4a4.174 4.174 0 0 0 .148 2.228 3.001 3.001 0 0 0 1.24 1.522c.657.386 1.409.576 2.17.55a7.602 7.602 0 0 0 2.004-.247 5.344 5.344 0 0 0 1.61-.728c.217-.148.422-.314.613-.496l-.042.24a4.184 4.184 0 0 1-.695 1.8 2.7 2.7 0 0 1-1.292.94c-.621.2-1.271.295-1.923.28a3.893 3.893 0 0 1-1.428-.235c-.397-.157-.72-.273-.968-.347a1.36 1.36 0 0 0-1.038.056 1.825 1.825 0 0 0-.866.885.998.998 0 0 0-.053.929c.198.343.515.602.89.727.445.173.91.286 1.386.336a12.8 12.8 0 0 0 1.646.112 9.744 9.744 0 0 0 3.28-.537 6.021 6.021 0 0 0 2.574-1.757 6.643 6.643 0 0 0 1.42-3.279l1.671-9.512a1.11 1.11 0 0 0-.252-.976Z",
    fill: "#023F80"
  })), _path2$2i || (_path2$2i = /*#__PURE__*/createElement$2("path", {
    d: "m49.454 26.388-9.92-9.97a1.405 1.405 0 0 0-2.297.448 1.424 1.424 0 0 0-.11.553v19.942a1.422 1.422 0 0 0 .9 1.324 1.403 1.403 0 0 0 1.507-.323l9.92-9.97a1.42 1.42 0 0 0 0-2.004Z",
    fill: "#1AAAAD"
  })), _path3$F || (_path3$F = /*#__PURE__*/createElement$2("path", {
    d: "M82.868 47.242 71.297 35.615l-7.502 7.54 16.688 16.771a1.395 1.395 0 0 0 2.384-.993l.001-11.69Z",
    fill: "#FECF2F"
  })), _path4$8 || (_path4$8 = /*#__PURE__*/createElement$2("path", {
    d: "M60.731 24.995a1.406 1.406 0 0 0-1.992 0L37.54 46.29a1.418 1.418 0 0 0 0 2.003l5.512 5.54a1.408 1.408 0 0 0 1.993 0l13.693-13.761a1.409 1.409 0 0 1 1.535-.307c.171.07.327.175.457.307l3.068 3.082 7.501-7.539-10.568-10.62Z",
    fill: "#DD2457"
  })), _path5$2 || (_path5$2 = /*#__PURE__*/createElement$2("path", {
    d: "m80.463 26.404-9.166 9.211 11.571 11.628.003-19.836a1.423 1.423 0 0 0-.87-1.31 1.403 1.403 0 0 0-1.538.307Z",
    fill: "#023F80"
  })));
};

var _path$7h, _path2$2j, _path3$G, _path4$9, _path5$3;
function _extends$7s() { _extends$7s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7s.apply(this, arguments); }
var SvgVerticalSmallFull = function SvgVerticalSmallFull(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7s({
    width: 88,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7h || (_path$7h = /*#__PURE__*/createElement$2("path", {
    d: "M22.312 50.454a3.229 3.229 0 0 0-1.289-1.54 3.916 3.916 0 0 0-2.134-.56c-.415 0-.826.063-1.22.19a4.96 4.96 0 0 0-1.794 1.008l.042-.235a.759.759 0 0 0-.178-.687.913.913 0 0 0-.716-.276 1.286 1.286 0 0 0-.816.276 1.102 1.102 0 0 0-.427.687l-1.757 9.718a.754.754 0 0 0 .176.695.93.93 0 0 0 .718.268c.296.004.585-.093.816-.276.225-.169.378-.414.427-.687l.538-2.976c.115.122.24.234.375.335.303.225.641.4 1.001.522.418.14.857.21 1.3.205a4.86 4.86 0 0 0 2.283-.56 5.495 5.495 0 0 0 1.83-1.549 5.214 5.214 0 0 0 .992-2.284 4.029 4.029 0 0 0-.167-2.274Zm-2.455 3.626a3.208 3.208 0 0 1-1.082.956 2.944 2.944 0 0 1-1.426.347 2.321 2.321 0 0 1-1.309-.347 1.878 1.878 0 0 1-.744-.956 2.571 2.571 0 0 1-.086-1.35 3.203 3.203 0 0 1 1.662-2.292 3 3 0 0 1 1.436-.347c.46-.017.913.104 1.3.347.342.23.6.559.738.94.151.435.181.901.086 1.351a3.274 3.274 0 0 1-.575 1.351ZM33.46 48.62a.931.931 0 0 0-.717-.268 1.286 1.286 0 0 0-.816.277 1.102 1.102 0 0 0-.427.687l-.004.023a3.235 3.235 0 0 0-.3-.26 3.567 3.567 0 0 0-1.02-.521 4.249 4.249 0 0 0-1.37-.206c-.794 0-1.576.192-2.274.56a5.465 5.465 0 0 0-1.84 1.549 5.211 5.211 0 0 0-.991 2.284 4.032 4.032 0 0 0 .17 2.267c.25.639.704 1.181 1.296 1.548.637.385 1.376.58 2.125.56a4.2 4.2 0 0 0 1.292-.197c.382-.12.75-.281 1.094-.482.215-.126.42-.269.613-.427a.752.752 0 0 0 .18.672.909.909 0 0 0 .716.276c.297.004.585-.094.816-.276.225-.17.378-.414.427-.687l1.208-6.683a.754.754 0 0 0-.178-.695Zm-4.152 6.415c-.44.234-.935.353-1.436.348a2.287 2.287 0 0 1-1.291-.348 1.887 1.887 0 0 1-.746-.948 2.525 2.525 0 0 1-.087-1.343 3.25 3.25 0 0 1 1.663-2.307 2.963 2.963 0 0 1 1.417-.347c.462-.016.919.105 1.309.347.348.229.61.562.746.948.15.438.179.907.084 1.359-.085.484-.28.943-.572 1.343a3.196 3.196 0 0 1-1.087.948ZM42.826 48.629a.913.913 0 0 0-.716-.277 1.286 1.286 0 0 0-.816.277 1.103 1.103 0 0 0-.427.687l-.732 4.044c-.058.366-.2.715-.415 1.02-.197.272-.464.49-.773.631a2.597 2.597 0 0 1-1.09.214c-.606 0-1.053-.14-1.34-.42-.289-.278-.37-.76-.247-1.445l.731-4.044a.757.757 0 0 0-.178-.687.913.913 0 0 0-.716-.277 1.287 1.287 0 0 0-.816.277 1.102 1.102 0 0 0-.427.687l-.834 4.613a2.866 2.866 0 0 0 .107 1.573c.169.447.486.825.902 1.074a2.977 2.977 0 0 0 1.577.388c.492.005.982-.053 1.458-.174.417-.107.812-.28 1.17-.513.159-.105.308-.223.447-.351l-.03.169a2.904 2.904 0 0 1-.506 1.271c-.238.309-.565.54-.94.664a4.36 4.36 0 0 1-1.399.197 2.907 2.907 0 0 1-1.038-.166 9.475 9.475 0 0 0-.704-.244 1.017 1.017 0 0 0-.755.039c-.278.13-.5.351-.63.625a.69.69 0 0 0-.038.655c.144.243.374.426.647.514a4.01 4.01 0 0 0 1.008.237c.397.051.797.078 1.197.079a7.283 7.283 0 0 0 2.386-.38 4.386 4.386 0 0 0 1.871-1.24 4.624 4.624 0 0 0 1.034-2.314l1.215-6.714a.759.759 0 0 0-.183-.69ZM56.508 48.629a.847.847 0 0 0-.663-.277c-.546 0-.927.2-1.142.6l-2.73 4.543-.773-3.294a.817.817 0 0 0-.251-.435.877.877 0 0 0-.57-.15 1.254 1.254 0 0 0-.624.148c-.19.103-.35.253-.462.436l-2.016 3.383-1.09-4.63a.6.6 0 0 0-.29-.459 1.123 1.123 0 0 0-.58-.142 1.219 1.219 0 0 0-.84.3 1.184 1.184 0 0 0-.408.68.896.896 0 0 0 .006.363l1.55 6.509a.69.69 0 0 0 .366.482c.196.11.424.151.647.118.206-.013.406-.075.583-.18a1.28 1.28 0 0 0 .433-.42l2.138-3.886.82 3.886a.813.813 0 0 0 .295.432.848.848 0 0 0 .504.168c.243.027.488-.015.707-.122.218-.107.4-.273.524-.478l3.903-6.509a.976.976 0 0 0 .137-.363.776.776 0 0 0-.174-.703ZM66.432 48.62a.932.932 0 0 0-.718-.268 1.287 1.287 0 0 0-.815.277 1.102 1.102 0 0 0-.428.687l-.004.023a3.209 3.209 0 0 0-.3-.26 3.562 3.562 0 0 0-1.02-.521 4.25 4.25 0 0 0-1.369-.206c-.794 0-1.576.192-2.275.56a5.469 5.469 0 0 0-1.839 1.549 5.212 5.212 0 0 0-.991 2.284 4.032 4.032 0 0 0 .169 2.267c.25.638.705 1.181 1.297 1.548.637.384 1.376.58 2.125.56a4.2 4.2 0 0 0 1.292-.197c.382-.12.749-.281 1.093-.482.216-.126.421-.269.614-.427a.751.751 0 0 0 .18.672.911.911 0 0 0 .716.276c.297.004.586-.093.817-.276.225-.17.378-.414.427-.688l1.208-6.682a.754.754 0 0 0-.179-.695Zm-4.152 6.415c-.44.233-.934.353-1.435.348a2.287 2.287 0 0 1-1.291-.348 1.888 1.888 0 0 1-.746-.948 2.53 2.53 0 0 1-.087-1.343c.084-.49.28-.954.574-1.359a3.198 3.198 0 0 1 1.09-.948 2.963 2.963 0 0 1 1.416-.347c.462-.017.919.105 1.309.347.348.229.61.562.746.948.15.438.179.907.084 1.359a3.22 3.22 0 0 1-.572 1.343 3.198 3.198 0 0 1-1.089.948ZM75.797 48.629a.913.913 0 0 0-.716-.277 1.286 1.286 0 0 0-.816.277 1.103 1.103 0 0 0-.427.687l-.73 4.044c-.06.366-.201.715-.417 1.02-.197.272-.463.49-.773.631a2.597 2.597 0 0 1-1.09.214c-.605 0-1.052-.14-1.34-.42-.288-.278-.37-.76-.246-1.445l.73-4.044a.758.758 0 0 0-.178-.687.913.913 0 0 0-.716-.277 1.286 1.286 0 0 0-.816.277 1.102 1.102 0 0 0-.427.687l-.834 4.613a2.866 2.866 0 0 0 .108 1.573c.168.447.486.825.901 1.074a2.977 2.977 0 0 0 1.578.388c.492.005.982-.053 1.458-.174.416-.107.812-.28 1.17-.513.159-.105.308-.223.447-.351l-.03.169a2.902 2.902 0 0 1-.507 1.271c-.237.309-.565.54-.94.664a4.36 4.36 0 0 1-1.398.197 2.907 2.907 0 0 1-1.038-.166 9.475 9.475 0 0 0-.704-.244 1.017 1.017 0 0 0-.755.039c-.278.13-.501.351-.63.625a.69.69 0 0 0-.038.655c.144.243.374.426.646.514a4.01 4.01 0 0 0 1.009.237c.396.051.796.078 1.197.079a7.283 7.283 0 0 0 2.385-.38 4.386 4.386 0 0 0 1.872-1.24 4.626 4.626 0 0 0 1.034-2.314l1.214-6.714a.759.759 0 0 0-.183-.69Z",
    fill: "#023F80"
  })), _path2$2j || (_path2$2j = /*#__PURE__*/createElement$2("path", {
    d: "m36.33 19.333-7.214-7.038a1.049 1.049 0 0 0-1.44-.013.998.998 0 0 0-.311.72v14.076a.98.98 0 0 0 .311.72 1.028 1.028 0 0 0 .747.282c.261-.007.51-.112.693-.295l7.214-7.037a.989.989 0 0 0 .3-.708.989.989 0 0 0-.3-.707Z",
    fill: "#1AAAAD"
  })), _path3$G || (_path3$G = /*#__PURE__*/createElement$2("path", {
    d: "m60.631 34.053-8.415-8.207-5.456 5.322 12.137 11.839a1.04 1.04 0 0 0 1.107.214 1.01 1.01 0 0 0 .455-.365.974.974 0 0 0 .172-.55v-8.253Z",
    fill: "#FECF2F"
  })), _path4$9 || (_path4$9 = /*#__PURE__*/createElement$2("path", {
    d: "M44.532 18.35a1.038 1.038 0 0 0-.725-.293c-.272 0-.532.105-.724.293L27.665 33.38a1 1 0 0 0-.3.708.979.979 0 0 0 .3.707l4.01 3.91a1.028 1.028 0 0 0 .724.294 1.048 1.048 0 0 0 .725-.293l9.958-9.714a1.028 1.028 0 0 1 .724-.293 1.049 1.049 0 0 1 .725.293l2.23 2.176 5.457-5.322-7.686-7.496Z",
    fill: "#DD2457"
  })), _path5$3 || (_path5$3 = /*#__PURE__*/createElement$2("path", {
    d: "m58.883 19.344-6.667 6.502 8.416 8.208.002-14.002a.983.983 0 0 0-.173-.556 1.02 1.02 0 0 0-.46-.37 1.05 1.05 0 0 0-1.118.218Z",
    fill: "#023F80"
  })));
};

var _path$7i, _path2$2k, _path3$H, _path4$a, _path5$4;
function _extends$7t() { _extends$7t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7t.apply(this, arguments); }
var SvgVerticalMediumInverted = function SvgVerticalMediumInverted(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7t({
    width: 120,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7i || (_path$7i = /*#__PURE__*/createElement$2("path", {
    d: "M30.18 70.477a4.544 4.544 0 0 0-1.773-2.182 5.263 5.263 0 0 0-2.935-.794c-.57 0-1.135.09-1.676.269a6.712 6.712 0 0 0-2.468 1.43l.058-.334a1.107 1.107 0 0 0-.245-.973 1.252 1.252 0 0 0-.985-.392 1.736 1.736 0 0 0-1.121.392c-.31.239-.52.586-.588.973l-2.416 13.767a1.096 1.096 0 0 0 .243.984 1.274 1.274 0 0 0 .986.38c.409.006.806-.132 1.122-.391.31-.24.52-.586.588-.973l.74-4.216c.158.172.33.33.516.475.416.318.881.568 1.376.738.575.2 1.179.299 1.786.291a6.526 6.526 0 0 0 3.14-.793 7.62 7.62 0 0 0 2.517-2.194 7.502 7.502 0 0 0 1.363-3.235 5.873 5.873 0 0 0-.228-3.222Zm-3.376 5.136a4.457 4.457 0 0 1-1.488 1.354c-.6.332-1.276.501-1.96.493a3.12 3.12 0 0 1-1.8-.493 2.65 2.65 0 0 1-1.024-1.354 3.748 3.748 0 0 1-.118-1.913 4.61 4.61 0 0 1 .79-1.914 4.467 4.467 0 0 1 1.495-1.332c.605-.33 1.285-.5 1.974-.492a3.066 3.066 0 0 1 1.788.492c.47.325.825.791 1.015 1.332.208.616.249 1.277.118 1.914a4.712 4.712 0 0 1-.79 1.913ZM45.508 67.88a1.274 1.274 0 0 0-.987-.381 1.736 1.736 0 0 0-1.121.392c-.31.239-.52.586-.588.973l-.006.033a4.496 4.496 0 0 0-.413-.369 4.854 4.854 0 0 0-1.401-.738 5.687 5.687 0 0 0-1.883-.291 6.544 6.544 0 0 0-3.128.794 7.577 7.577 0 0 0-2.529 2.193 7.5 7.5 0 0 0-1.363 3.236 5.877 5.877 0 0 0 .233 3.211c.344.905.969 1.674 1.783 2.194.876.544 1.892.82 2.922.793a5.618 5.618 0 0 0 1.776-.28 7.228 7.228 0 0 0 1.504-.682 6.45 6.45 0 0 0 .843-.604 1.097 1.097 0 0 0 .248.95 1.25 1.25 0 0 0 .984.392c.408.006.805-.132 1.122-.391.31-.24.52-.587.587-.974l1.662-9.467a1.1 1.1 0 0 0-.245-.985Zm-5.71 9.086a4.02 4.02 0 0 1-1.974.493 3.075 3.075 0 0 1-1.775-.493 2.663 2.663 0 0 1-1.026-1.343 3.681 3.681 0 0 1-.12-1.902 4.68 4.68 0 0 1 .79-1.925 4.44 4.44 0 0 1 1.497-1.343 3.98 3.98 0 0 1 1.949-.492 3.125 3.125 0 0 1 1.8.492 2.67 2.67 0 0 1 1.025 1.343c.206.62.246 1.284.116 1.925a4.64 4.64 0 0 1-.787 1.902 4.44 4.44 0 0 1-1.495 1.343ZM58.386 67.89a1.253 1.253 0 0 0-.985-.39 1.735 1.735 0 0 0-1.122.39c-.31.24-.52.587-.587.974l-1.006 5.73a3.49 3.49 0 0 1-.572 1.444c-.27.386-.637.695-1.063.895a3.48 3.48 0 0 1-1.498.302c-.833 0-1.447-.198-1.843-.593-.396-.395-.51-1.078-.339-2.048l1.005-5.73a1.106 1.106 0 0 0-.245-.973 1.253 1.253 0 0 0-.985-.392 1.737 1.737 0 0 0-1.122.392c-.31.239-.52.586-.587.973L46.29 75.4a4.174 4.174 0 0 0 .149 2.228 3 3 0 0 0 1.239 1.522 3.997 3.997 0 0 0 2.17.55 7.598 7.598 0 0 0 2.004-.247 5.349 5.349 0 0 0 1.61-.728c.217-.148.422-.315.613-.496l-.042.24a4.186 4.186 0 0 1-.695 1.8 2.7 2.7 0 0 1-1.292.94c-.621.2-1.271.295-1.923.28a3.893 3.893 0 0 1-1.428-.235c-.397-.157-.72-.273-.968-.347a1.36 1.36 0 0 0-1.038.056 1.825 1.825 0 0 0-.866.885.998.998 0 0 0-.053.929c.198.344.514.602.89.727.445.173.91.286 1.386.336a12.8 12.8 0 0 0 1.646.112 9.744 9.744 0 0 0 3.28-.537 6.021 6.021 0 0 0 2.573-1.757 6.648 6.648 0 0 0 1.421-3.279l1.67-9.512a1.105 1.105 0 0 0-.25-.976ZM77.198 67.89a1.164 1.164 0 0 0-.91-.39c-.752 0-1.276.283-1.571.85l-3.754 6.435-1.063-4.667a1.165 1.165 0 0 0-.346-.616 1.18 1.18 0 0 0-.783-.213 1.684 1.684 0 0 0-1.492.828l-2.773 4.792-1.498-6.56a.867.867 0 0 0-.4-.649 1.509 1.509 0 0 0-.798-.201 1.647 1.647 0 0 0-1.154.425c-.29.248-.488.587-.56.962-.032.17-.03.346.007.515l2.13 9.221a.989.989 0 0 0 .505.683c.269.156.582.215.89.168a1.773 1.773 0 0 0 1.396-.85l2.94-5.506 1.127 5.505a1.153 1.153 0 0 0 1.1.851 1.73 1.73 0 0 0 1.692-.85l5.366-9.222a1.385 1.385 0 0 0 .188-.515 1.129 1.129 0 0 0-.239-.995ZM90.844 67.88a1.276 1.276 0 0 0-.986-.38 1.736 1.736 0 0 0-1.122.39c-.31.24-.52.587-.588.975l-.005.032a4.496 4.496 0 0 0-.413-.368 4.854 4.854 0 0 0-1.402-.739 5.688 5.688 0 0 0-1.883-.29 6.545 6.545 0 0 0-3.128.793 7.577 7.577 0 0 0-2.528 2.193 7.498 7.498 0 0 0-1.364 3.236 5.877 5.877 0 0 0 .233 3.212 4.5 4.5 0 0 0 1.783 2.193c.876.545 1.892.82 2.922.794a5.616 5.616 0 0 0 1.776-.28 7.215 7.215 0 0 0 1.504-.683c.297-.178.579-.38.843-.604a1.098 1.098 0 0 0 .248.95 1.248 1.248 0 0 0 .984.392c.409.007.806-.132 1.124-.391.31-.24.52-.587.587-.974l1.661-9.467a1.1 1.1 0 0 0-.246-.985Zm-5.71 9.086c-.604.33-1.283.5-1.972.493a3.074 3.074 0 0 1-1.775-.493 2.664 2.664 0 0 1-1.026-1.343 3.687 3.687 0 0 1-.12-1.902 4.684 4.684 0 0 1 .79-1.925 4.438 4.438 0 0 1 1.498-1.343 3.977 3.977 0 0 1 1.948-.492 3.125 3.125 0 0 1 1.8.492 2.67 2.67 0 0 1 1.025 1.343c.206.62.246 1.284.116 1.925a4.634 4.634 0 0 1-.787 1.902 4.44 4.44 0 0 1-1.497 1.343ZM103.721 67.89a1.247 1.247 0 0 0-.984-.39 1.736 1.736 0 0 0-1.122.39c-.31.24-.52.587-.588.974l-1.005 5.73a3.49 3.49 0 0 1-.572 1.444c-.27.386-.637.695-1.063.895-.47.21-.982.314-1.498.302-.833 0-1.447-.198-1.843-.593-.396-.395-.509-1.078-.339-2.048l1.005-5.73a1.103 1.103 0 0 0-.245-.973 1.253 1.253 0 0 0-.985-.392 1.735 1.735 0 0 0-1.122.392c-.31.239-.52.586-.587.973L91.626 75.4a4.174 4.174 0 0 0 .148 2.228 3.001 3.001 0 0 0 1.24 1.522c.657.386 1.409.576 2.17.55a7.602 7.602 0 0 0 2.004-.247 5.344 5.344 0 0 0 1.61-.728c.217-.148.422-.314.613-.496l-.042.24a4.184 4.184 0 0 1-.695 1.8 2.7 2.7 0 0 1-1.292.94c-.621.2-1.271.295-1.923.28a3.893 3.893 0 0 1-1.428-.235c-.397-.157-.72-.273-.968-.347a1.36 1.36 0 0 0-1.038.056 1.825 1.825 0 0 0-.866.885.998.998 0 0 0-.053.929c.198.343.515.602.89.727.445.173.91.286 1.386.336a12.8 12.8 0 0 0 1.646.112 9.744 9.744 0 0 0 3.28-.537 6.021 6.021 0 0 0 2.574-1.757 6.643 6.643 0 0 0 1.42-3.279l1.671-9.512a1.11 1.11 0 0 0-.252-.976Z",
    fill: "#F0F5FB"
  })), _path2$2k || (_path2$2k = /*#__PURE__*/createElement$2("path", {
    d: "m49.454 26.388-9.92-9.97a1.405 1.405 0 0 0-2.297.448 1.424 1.424 0 0 0-.11.553v19.942a1.422 1.422 0 0 0 .9 1.324 1.403 1.403 0 0 0 1.507-.323l9.92-9.97a1.42 1.42 0 0 0 0-2.004Z",
    fill: "#1AAAAD"
  })), _path3$H || (_path3$H = /*#__PURE__*/createElement$2("path", {
    d: "M82.868 47.242 71.297 35.615l-7.502 7.54 16.688 16.771a1.395 1.395 0 0 0 2.384-.993l.001-11.69Z",
    fill: "#FECF2F"
  })), _path4$a || (_path4$a = /*#__PURE__*/createElement$2("path", {
    d: "M60.731 24.995a1.406 1.406 0 0 0-1.992 0L37.54 46.29a1.418 1.418 0 0 0 0 2.003l5.512 5.54a1.408 1.408 0 0 0 1.993 0l13.693-13.761a1.409 1.409 0 0 1 1.535-.307c.171.07.327.175.457.307l3.068 3.082 7.501-7.539-10.568-10.62Z",
    fill: "#DD2457"
  })), _path5$4 || (_path5$4 = /*#__PURE__*/createElement$2("path", {
    d: "m80.463 26.404-9.166 9.211 11.571 11.628.003-19.836a1.423 1.423 0 0 0-.87-1.31 1.403 1.403 0 0 0-1.538.307Z",
    fill: "#F0F5FB"
  })));
};

var _path$7j, _path2$2l, _path3$I, _path4$b, _path5$5;
function _extends$7u() { _extends$7u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7u.apply(this, arguments); }
var SvgVerticalSmallInverted = function SvgVerticalSmallInverted(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7u({
    width: 88,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7j || (_path$7j = /*#__PURE__*/createElement$2("path", {
    d: "M22.312 50.454a3.229 3.229 0 0 0-1.289-1.54 3.916 3.916 0 0 0-2.134-.56c-.415 0-.826.063-1.22.19a4.96 4.96 0 0 0-1.794 1.008l.042-.235a.759.759 0 0 0-.178-.687.913.913 0 0 0-.716-.276 1.286 1.286 0 0 0-.816.276 1.102 1.102 0 0 0-.427.687l-1.757 9.718a.754.754 0 0 0 .176.695.93.93 0 0 0 .718.268c.296.004.585-.093.816-.276.225-.169.378-.414.427-.687l.538-2.976c.115.122.24.234.375.335.303.225.641.4 1.001.522.418.14.857.21 1.3.205a4.86 4.86 0 0 0 2.283-.56 5.495 5.495 0 0 0 1.83-1.549 5.214 5.214 0 0 0 .992-2.284 4.029 4.029 0 0 0-.167-2.274Zm-2.455 3.626a3.208 3.208 0 0 1-1.082.956 2.944 2.944 0 0 1-1.426.347 2.321 2.321 0 0 1-1.309-.347 1.878 1.878 0 0 1-.744-.956 2.571 2.571 0 0 1-.086-1.35 3.203 3.203 0 0 1 1.662-2.292 3 3 0 0 1 1.436-.347c.46-.017.913.104 1.3.347.342.23.6.559.738.94.151.435.181.901.086 1.351a3.274 3.274 0 0 1-.575 1.351ZM33.46 48.62a.931.931 0 0 0-.717-.268 1.286 1.286 0 0 0-.816.277 1.102 1.102 0 0 0-.427.687l-.004.023a3.235 3.235 0 0 0-.3-.26 3.567 3.567 0 0 0-1.02-.521 4.249 4.249 0 0 0-1.37-.206c-.794 0-1.576.192-2.274.56a5.465 5.465 0 0 0-1.84 1.549 5.211 5.211 0 0 0-.991 2.284 4.032 4.032 0 0 0 .17 2.267c.25.639.704 1.181 1.296 1.548.637.385 1.376.58 2.125.56a4.2 4.2 0 0 0 1.292-.197c.382-.12.75-.281 1.094-.482.215-.126.42-.269.613-.427a.752.752 0 0 0 .18.672.909.909 0 0 0 .716.276c.297.004.585-.094.816-.276.225-.17.378-.414.427-.687l1.208-6.683a.754.754 0 0 0-.178-.695Zm-4.152 6.415c-.44.234-.935.353-1.436.348a2.287 2.287 0 0 1-1.291-.348 1.887 1.887 0 0 1-.746-.948 2.525 2.525 0 0 1-.087-1.343 3.25 3.25 0 0 1 1.663-2.307 2.963 2.963 0 0 1 1.417-.347c.462-.016.919.105 1.309.347.348.229.61.562.746.948.15.438.179.907.084 1.359-.085.484-.28.943-.572 1.343a3.196 3.196 0 0 1-1.087.948ZM42.826 48.629a.913.913 0 0 0-.716-.277 1.286 1.286 0 0 0-.816.277 1.103 1.103 0 0 0-.427.687l-.732 4.044c-.058.366-.2.715-.415 1.02-.197.272-.464.49-.773.631a2.597 2.597 0 0 1-1.09.214c-.606 0-1.053-.14-1.34-.42-.289-.278-.37-.76-.247-1.445l.731-4.044a.757.757 0 0 0-.178-.687.913.913 0 0 0-.716-.277 1.287 1.287 0 0 0-.816.277 1.102 1.102 0 0 0-.427.687l-.834 4.613a2.866 2.866 0 0 0 .107 1.573c.169.447.486.825.902 1.074a2.977 2.977 0 0 0 1.577.388c.492.005.982-.053 1.458-.174.417-.107.812-.28 1.17-.513.159-.105.308-.223.447-.351l-.03.169a2.904 2.904 0 0 1-.506 1.271c-.238.309-.565.54-.94.664a4.36 4.36 0 0 1-1.399.197 2.907 2.907 0 0 1-1.038-.166 9.475 9.475 0 0 0-.704-.244 1.017 1.017 0 0 0-.755.039c-.278.13-.5.351-.63.625a.69.69 0 0 0-.038.655c.144.243.374.426.647.514a4.01 4.01 0 0 0 1.008.237c.397.051.797.078 1.197.079a7.283 7.283 0 0 0 2.386-.38 4.386 4.386 0 0 0 1.871-1.24 4.624 4.624 0 0 0 1.034-2.314l1.215-6.714a.759.759 0 0 0-.183-.69ZM56.508 48.629a.847.847 0 0 0-.663-.277c-.546 0-.927.2-1.142.6l-2.73 4.543-.773-3.294a.817.817 0 0 0-.251-.435.877.877 0 0 0-.57-.15 1.254 1.254 0 0 0-.624.148c-.19.103-.35.253-.462.436l-2.016 3.383-1.09-4.63a.6.6 0 0 0-.29-.459 1.123 1.123 0 0 0-.58-.142 1.219 1.219 0 0 0-.84.3 1.184 1.184 0 0 0-.408.68.896.896 0 0 0 .006.363l1.55 6.509a.69.69 0 0 0 .366.482c.196.11.424.151.647.118.206-.013.406-.075.583-.18a1.28 1.28 0 0 0 .433-.42l2.138-3.886.82 3.886a.813.813 0 0 0 .295.432.848.848 0 0 0 .504.168c.243.027.488-.015.707-.122.218-.107.4-.273.524-.478l3.903-6.509a.976.976 0 0 0 .137-.363.776.776 0 0 0-.174-.703ZM66.432 48.62a.932.932 0 0 0-.718-.268 1.287 1.287 0 0 0-.815.277 1.102 1.102 0 0 0-.428.687l-.004.023a3.209 3.209 0 0 0-.3-.26 3.562 3.562 0 0 0-1.02-.521 4.25 4.25 0 0 0-1.369-.206c-.794 0-1.576.192-2.275.56a5.469 5.469 0 0 0-1.839 1.549 5.212 5.212 0 0 0-.991 2.284 4.032 4.032 0 0 0 .169 2.267c.25.638.705 1.181 1.297 1.548.637.384 1.376.58 2.125.56a4.2 4.2 0 0 0 1.292-.197c.382-.12.749-.281 1.093-.482.216-.126.421-.269.614-.427a.751.751 0 0 0 .18.672.911.911 0 0 0 .716.276c.297.004.586-.093.817-.276.225-.17.378-.414.427-.688l1.208-6.682a.754.754 0 0 0-.179-.695Zm-4.152 6.415c-.44.233-.934.353-1.435.348a2.287 2.287 0 0 1-1.291-.348 1.888 1.888 0 0 1-.746-.948 2.53 2.53 0 0 1-.087-1.343c.084-.49.28-.954.574-1.359a3.198 3.198 0 0 1 1.09-.948 2.963 2.963 0 0 1 1.416-.347c.462-.017.919.105 1.309.347.348.229.61.562.746.948.15.438.179.907.084 1.359a3.22 3.22 0 0 1-.572 1.343 3.198 3.198 0 0 1-1.089.948ZM75.797 48.629a.913.913 0 0 0-.716-.277 1.286 1.286 0 0 0-.816.277 1.103 1.103 0 0 0-.427.687l-.73 4.044c-.06.366-.201.715-.417 1.02-.197.272-.463.49-.773.631a2.597 2.597 0 0 1-1.09.214c-.605 0-1.052-.14-1.34-.42-.288-.278-.37-.76-.246-1.445l.73-4.044a.758.758 0 0 0-.178-.687.913.913 0 0 0-.716-.277 1.286 1.286 0 0 0-.816.277 1.102 1.102 0 0 0-.427.687l-.834 4.613a2.866 2.866 0 0 0 .108 1.573c.168.447.486.825.901 1.074a2.977 2.977 0 0 0 1.578.388c.492.005.982-.053 1.458-.174.416-.107.812-.28 1.17-.513.159-.105.308-.223.447-.351l-.03.169a2.902 2.902 0 0 1-.507 1.271c-.237.309-.565.54-.94.664a4.36 4.36 0 0 1-1.398.197 2.907 2.907 0 0 1-1.038-.166 9.475 9.475 0 0 0-.704-.244 1.017 1.017 0 0 0-.755.039c-.278.13-.501.351-.63.625a.69.69 0 0 0-.038.655c.144.243.374.426.646.514a4.01 4.01 0 0 0 1.009.237c.396.051.796.078 1.197.079a7.283 7.283 0 0 0 2.385-.38 4.386 4.386 0 0 0 1.872-1.24 4.626 4.626 0 0 0 1.034-2.314l1.214-6.714a.759.759 0 0 0-.183-.69Z",
    fill: "#F0F5FB"
  })), _path2$2l || (_path2$2l = /*#__PURE__*/createElement$2("path", {
    d: "m36.33 19.333-7.214-7.038a1.049 1.049 0 0 0-1.44-.013.998.998 0 0 0-.311.72v14.076a.98.98 0 0 0 .311.72 1.028 1.028 0 0 0 .747.282c.261-.007.51-.112.693-.295l7.214-7.037a.989.989 0 0 0 .3-.708.989.989 0 0 0-.3-.707Z",
    fill: "#1AAAAD"
  })), _path3$I || (_path3$I = /*#__PURE__*/createElement$2("path", {
    d: "m60.631 34.053-8.415-8.207-5.456 5.322 12.137 11.839a1.04 1.04 0 0 0 1.107.214 1.01 1.01 0 0 0 .455-.365.974.974 0 0 0 .172-.55v-8.253Z",
    fill: "#FECF2F"
  })), _path4$b || (_path4$b = /*#__PURE__*/createElement$2("path", {
    d: "M44.532 18.35a1.038 1.038 0 0 0-.725-.293c-.272 0-.532.105-.724.293L27.665 33.38a1 1 0 0 0-.3.708.979.979 0 0 0 .3.707l4.01 3.91a1.028 1.028 0 0 0 .724.294 1.048 1.048 0 0 0 .725-.293l9.958-9.714a1.028 1.028 0 0 1 .724-.293 1.049 1.049 0 0 1 .725.293l2.23 2.176 5.457-5.322-7.686-7.496Z",
    fill: "#DD2457"
  })), _path5$5 || (_path5$5 = /*#__PURE__*/createElement$2("path", {
    d: "m58.883 19.344-6.667 6.502 8.416 8.208.002-14.002a.983.983 0 0 0-.173-.556 1.02 1.02 0 0 0-.46-.37 1.05 1.05 0 0 0-1.118.218Z",
    fill: "#F0F5FB"
  })));
};

var _path$7k;
function _extends$7v() { _extends$7v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7v.apply(this, arguments); }
var SvgVerticalMediumWithout = function SvgVerticalMediumWithout(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7v({
    width: 120,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7k || (_path$7k = /*#__PURE__*/createElement$2("path", {
    d: "M28.925 71.052a4.763 4.763 0 0 0-1.866-2.285c-.926-.574-2-.863-3.089-.831-.6 0-1.195.094-1.764.281a7.09 7.09 0 0 0-2.598 1.497l.062-.348a1.151 1.151 0 0 0-.259-1.02 1.317 1.317 0 0 0-1.036-.41c-.43-.006-.848.139-1.181.41-.327.25-.547.614-.618 1.02l-2.543 14.417a1.143 1.143 0 0 0 .256 1.032 1.342 1.342 0 0 0 1.038.398c.43.006.847-.14 1.18-.41.327-.25.548-.614.62-1.02l.778-4.414c.167.18.349.346.543.496.439.334.928.595 1.45.774a5.54 5.54 0 0 0 1.88.305 6.893 6.893 0 0 0 3.305-.832 8.008 8.008 0 0 0 2.648-2.296 7.84 7.84 0 0 0 1.435-3.389 6.117 6.117 0 0 0-.241-3.375Zm-3.553 5.38a4.67 4.67 0 0 1-1.566 1.418 4.177 4.177 0 0 1-2.064.516 3.295 3.295 0 0 1-1.894-.516 2.775 2.775 0 0 1-1.078-1.418 3.905 3.905 0 0 1-.123-2.004c.12-.723.405-1.408.83-2.004a4.692 4.692 0 0 1 1.575-1.395 4.251 4.251 0 0 1 2.076-.516 3.238 3.238 0 0 1 1.881.516c.495.34.87.828 1.07 1.395.218.645.26 1.336.123 2.004a4.916 4.916 0 0 1-.83 2.004ZM45.06 68.332a1.345 1.345 0 0 0-1.039-.399c-.43-.006-.847.14-1.18.41a1.64 1.64 0 0 0-.619 1.02l-.006.035a4.765 4.765 0 0 0-.435-.386 5.118 5.118 0 0 0-1.475-.774 6.013 6.013 0 0 0-1.982-.305c-1.15 0-2.28.285-3.292.832a7.969 7.969 0 0 0-2.662 2.297 7.836 7.836 0 0 0-1.435 3.388 6.129 6.129 0 0 0 .245 3.364 4.716 4.716 0 0 0 1.877 2.297c.922.57 1.991.86 3.076.831a5.94 5.94 0 0 0 1.87-.293 7.599 7.599 0 0 0 1.582-.715 6.79 6.79 0 0 0 .888-.632 1.145 1.145 0 0 0 .26.996 1.315 1.315 0 0 0 1.037.41c.43.006.847-.14 1.18-.41.327-.25.548-.615.619-1.02l1.748-9.915a1.145 1.145 0 0 0-.257-1.03Zm-6.01 9.517a4.25 4.25 0 0 1-2.076.516 3.249 3.249 0 0 1-1.869-.516 2.792 2.792 0 0 1-1.08-1.407 3.84 3.84 0 0 1-.125-1.992 4.89 4.89 0 0 1 .83-2.016 4.66 4.66 0 0 1 1.577-1.407 4.2 4.2 0 0 1 2.05-.515 3.3 3.3 0 0 1 1.895.515c.503.34.882.833 1.08 1.407.217.65.259 1.345.121 2.016a4.837 4.837 0 0 1-.828 1.992 4.66 4.66 0 0 1-1.575 1.408v-.001ZM58.614 68.345a1.316 1.316 0 0 0-1.036-.41 1.831 1.831 0 0 0-1.183.41c-.326.25-.547.615-.618 1.02l-1.058 6a3.648 3.648 0 0 1-.602 1.513c-.285.404-.67.727-1.119.937a3.679 3.679 0 0 1-1.577.317c-.877 0-1.523-.208-1.94-.622-.417-.414-.536-1.129-.357-2.145l1.059-6a1.151 1.151 0 0 0-.259-1.02 1.316 1.316 0 0 0-1.036-.41 1.83 1.83 0 0 0-1.181.41c-.327.25-.548.615-.619 1.02l-1.207 6.844a4.352 4.352 0 0 0 .156 2.334 3.15 3.15 0 0 0 1.305 1.594 4.228 4.228 0 0 0 2.284.575c.71.008 1.42-.079 2.108-.258a5.655 5.655 0 0 0 1.694-.761c.23-.156.446-.33.647-.521l-.045.251a4.366 4.366 0 0 1-.732 1.886c-.344.458-.818.801-1.36.985a6.17 6.17 0 0 1-2.024.293 4.111 4.111 0 0 1-1.502-.246 13.531 13.531 0 0 0-1.02-.364 1.438 1.438 0 0 0-1.092.059 1.918 1.918 0 0 0-.912.927 1.041 1.041 0 0 0-.055.972c.208.36.541.631.936.762.468.181.96.3 1.459.352.574.076 1.153.115 1.733.117 1.174.01 2.342-.18 3.452-.563a6.338 6.338 0 0 0 2.71-1.84 6.946 6.946 0 0 0 1.495-3.434l1.758-9.961a1.15 1.15 0 0 0-.262-1.023ZM78.416 68.345a1.225 1.225 0 0 0-.959-.41c-.79 0-1.341.297-1.652.89l-3.952 6.74-1.119-4.887a1.22 1.22 0 0 0-.363-.645 1.247 1.247 0 0 0-.825-.224 1.779 1.779 0 0 0-1.57.867l-2.92 5.02-1.576-6.87a.906.906 0 0 0-.421-.68 1.596 1.596 0 0 0-.84-.212 1.74 1.74 0 0 0-1.215.446c-.305.26-.513.615-.59 1.008-.033.178-.03.361.008.539l2.242 9.657a1.034 1.034 0 0 0 .531.715c.283.163.614.225.936.176a1.873 1.873 0 0 0 1.47-.89l3.095-5.767 1.19 5.767a1.206 1.206 0 0 0 1.157.89 1.83 1.83 0 0 0 1.781-.89l5.649-9.658a1.443 1.443 0 0 0 .198-.539 1.18 1.18 0 0 0-.255-1.043ZM92.781 68.332a1.345 1.345 0 0 0-1.038-.399c-.43-.006-.848.14-1.181.41-.327.251-.548.615-.619 1.02l-.006.035a4.723 4.723 0 0 0-.434-.386 5.116 5.116 0 0 0-1.475-.774 6.012 6.012 0 0 0-1.983-.305 6.92 6.92 0 0 0-3.292.832 7.971 7.971 0 0 0-2.662 2.297 7.835 7.835 0 0 0-1.435 3.388 6.128 6.128 0 0 0 .245 3.364 4.716 4.716 0 0 0 1.877 2.297c.922.57 1.992.86 3.076.831a5.94 5.94 0 0 0 1.87-.293 7.614 7.614 0 0 0 1.583-.715c.312-.187.608-.398.887-.632a1.146 1.146 0 0 0 .26.996 1.315 1.315 0 0 0 1.037.41c.43.006.847-.14 1.18-.41.327-.25.548-.615.619-1.02l1.748-9.915a1.146 1.146 0 0 0-.257-1.03Zm-6.01 9.518a4.25 4.25 0 0 1-2.078.516 3.25 3.25 0 0 1-1.868-.516 2.791 2.791 0 0 1-1.08-1.407 3.84 3.84 0 0 1-.126-1.992 4.891 4.891 0 0 1 .831-2.016c.411-.583.95-1.064 1.576-1.406a4.201 4.201 0 0 1 2.05-.516 3.3 3.3 0 0 1 1.896.516c.502.339.881.833 1.08 1.406.216.65.258 1.345.12 2.016a4.837 4.837 0 0 1-.828 1.992 4.657 4.657 0 0 1-1.573 1.407ZM106.335 68.345a1.313 1.313 0 0 0-1.036-.41 1.833 1.833 0 0 0-1.183.41c-.326.25-.547.615-.618 1.02l-1.058 6a3.645 3.645 0 0 1-.602 1.513 2.845 2.845 0 0 1-1.119.937 3.679 3.679 0 0 1-1.577.317c-.877 0-1.524-.208-1.94-.622-.417-.414-.536-1.129-.357-2.145l1.058-6a1.151 1.151 0 0 0-.258-1.02 1.317 1.317 0 0 0-1.037-.41c-.43-.006-.847.14-1.18.41a1.64 1.64 0 0 0-.619 1.02l-1.207 6.844a4.356 4.356 0 0 0 .156 2.334 3.15 3.15 0 0 0 1.305 1.594 4.229 4.229 0 0 0 2.284.575 8.04 8.04 0 0 0 2.108-.258 5.653 5.653 0 0 0 1.694-.761c.229-.157.446-.332.647-.524l-.045.252a4.357 4.357 0 0 1-.732 1.886 2.84 2.84 0 0 1-1.36.984 6.17 6.17 0 0 1-2.024.293 4.109 4.109 0 0 1-1.502-.246 13.602 13.602 0 0 0-1.02-.363 1.439 1.439 0 0 0-1.092.058 1.918 1.918 0 0 0-.912.927 1.038 1.038 0 0 0-.055.973c.208.36.541.63.936.762.469.18.96.299 1.459.351a13.58 13.58 0 0 0 1.732.118c1.175.01 2.343-.18 3.453-.563a6.333 6.333 0 0 0 2.709-1.84 6.946 6.946 0 0 0 1.496-3.434l1.757-9.962a1.141 1.141 0 0 0-.261-1.02ZM49.212 24.88 38.77 14.437a1.483 1.483 0 0 0-2.534 1.049V36.37a1.483 1.483 0 0 0 2.534 1.048l10.44-10.44a1.484 1.484 0 0 0 0-2.1Zm-.986 1.502-9.779 9.778a.64.64 0 0 1-1.091-.452V16.15a.64.64 0 0 1 1.091-.452l9.779 9.779a.64.64 0 0 1 0 .905ZM84.384 25.945a1.484 1.484 0 0 0-2.534-1.049l-9.643 9.646L61.083 23.42a1.484 1.484 0 0 0-2.098 0L36.672 45.72a1.483 1.483 0 0 0 0 2.098l5.803 5.803a1.484 1.484 0 0 0 2.098 0L58.984 39.21a1.483 1.483 0 0 1 2.098 0l20.795 20.795a1.47 1.47 0 0 0 2.51-1.04l-.003-33.019Zm-2.21.21a.64.64 0 0 1 1.091.452v18.996L72.996 35.334l9.178-9.179Zm-20.3 12.264a2.603 2.603 0 0 0-3.68 0L43.976 52.636a.637.637 0 0 1-.905 0l-5.414-5.415a.64.64 0 0 1 0-.904L59.58 24.405a.64.64 0 0 1 .904 0l10.929 10.93-6.31 6.315-3.23-3.231Zm20.303 20.303L65.896 42.44l6.31-6.316 11.06 11.06.003 11.084a.64.64 0 0 1-1.093.453h.001Z",
    fill: "#fff"
  })));
};

var _path$7l;
function _extends$7w() { _extends$7w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7w.apply(this, arguments); }
var SvgVerticalSmallWithout = function SvgVerticalSmallWithout(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7w({
    width: 88,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7l || (_path$7l = /*#__PURE__*/createElement$2("path", {
    d: "M22.313 50.454a3.228 3.228 0 0 0-1.29-1.54 3.917 3.917 0 0 0-2.134-.56c-.414-.001-.826.063-1.22.189-.376.117-.738.28-1.075.482-.257.152-.497.329-.719.527l.043-.235a.758.758 0 0 0-.18-.687.913.913 0 0 0-.715-.277 1.286 1.286 0 0 0-.816.277 1.102 1.102 0 0 0-.427.687l-1.757 9.718a.752.752 0 0 0 .176.695.932.932 0 0 0 .718.268c.297.004.585-.094.816-.276.225-.169.378-.414.427-.687l.538-2.976c.116.122.241.233.376.335.303.225.64.4 1.001.521.418.141.857.21 1.299.206a4.858 4.858 0 0 0 2.284-.56 5.496 5.496 0 0 0 1.83-1.549 5.216 5.216 0 0 0 .991-2.284 4.028 4.028 0 0 0-.166-2.274Zm-2.455 3.626a3.198 3.198 0 0 1-1.083.955 2.944 2.944 0 0 1-1.425.348 2.32 2.32 0 0 1-1.31-.348c-.348-.23-.61-.566-.744-.955a2.571 2.571 0 0 1-.085-1.351 3.202 3.202 0 0 1 1.661-2.291c.44-.233.934-.353 1.435-.348a2.28 2.28 0 0 1 1.3.348c.342.23.6.558.739.94.15.435.18.901.085 1.35a3.269 3.269 0 0 1-.573 1.352ZM33.461 48.62a.931.931 0 0 0-.717-.268 1.286 1.286 0 0 0-.816.276 1.102 1.102 0 0 0-.428.687l-.004.023a3.265 3.265 0 0 0-.3-.26 3.566 3.566 0 0 0-1.02-.52 4.25 4.25 0 0 0-1.369-.206c-.794 0-1.576.192-2.275.56a5.47 5.47 0 0 0-1.839 1.548 5.213 5.213 0 0 0-.992 2.284 4.035 4.035 0 0 0 .17 2.267c.25.639.705 1.182 1.297 1.548.637.385 1.376.58 2.125.56.439.002.875-.064 1.292-.197.382-.12.749-.281 1.093-.482.216-.126.421-.268.613-.426a.752.752 0 0 0 .18.671.91.91 0 0 0 .717.277c.297.004.585-.094.816-.277.225-.169.378-.414.427-.687l1.208-6.683a.753.753 0 0 0-.178-.695Zm-4.152 6.415c-.44.233-.934.353-1.435.347a2.286 2.286 0 0 1-1.291-.347 1.888 1.888 0 0 1-.746-.949 2.529 2.529 0 0 1-.087-1.342c.084-.49.28-.954.574-1.36a3.195 3.195 0 0 1 1.09-.947 2.961 2.961 0 0 1 1.416-.348c.462-.016.919.105 1.309.348.348.229.61.561.746.948.15.438.179.906.084 1.359-.085.484-.28.943-.572 1.342a3.196 3.196 0 0 1-1.089.95v-.002ZM42.827 48.63a.913.913 0 0 0-.716-.277 1.286 1.286 0 0 0-.817.276 1.102 1.102 0 0 0-.427.688l-.732 4.044c-.058.366-.2.714-.416 1.019-.197.273-.463.49-.773.632a2.6 2.6 0 0 1-1.09.213c-.605 0-1.052-.14-1.34-.419-.288-.279-.37-.76-.247-1.445l.732-4.044a.757.757 0 0 0-.179-.688.912.912 0 0 0-.716-.276 1.285 1.285 0 0 0-.816.276 1.102 1.102 0 0 0-.427.688l-.834 4.613a2.865 2.865 0 0 0 .108 1.573c.168.446.486.825.901 1.074a2.98 2.98 0 0 0 1.578.388c.491.005.981-.054 1.457-.174.416-.107.812-.28 1.17-.514.159-.105.308-.222.447-.35l-.03.169a2.901 2.901 0 0 1-.507 1.271 1.96 1.96 0 0 1-.94.664 4.36 4.36 0 0 1-1.398.197 2.905 2.905 0 0 1-1.038-.166 9.53 9.53 0 0 0-.704-.245 1.017 1.017 0 0 0-.755.04c-.278.13-.5.351-.63.625a.688.688 0 0 0-.038.655c.144.243.374.425.647.514a4.01 4.01 0 0 0 1.008.236c.397.052.796.078 1.197.08a7.284 7.284 0 0 0 2.385-.38 4.386 4.386 0 0 0 1.873-1.24 4.625 4.625 0 0 0 1.033-2.314l1.215-6.715a.755.755 0 0 0-.181-.689ZM56.51 48.63a.847.847 0 0 0-.663-.278c-.547 0-.927.2-1.142.601l-2.73 4.543L51.2 50.2a.817.817 0 0 0-.251-.434.878.878 0 0 0-.57-.151 1.253 1.253 0 0 0-.624.149c-.19.102-.35.253-.461.435l-2.017 3.383-1.09-4.63a.6.6 0 0 0-.29-.459 1.124 1.124 0 0 0-.58-.142 1.22 1.22 0 0 0-.84.3 1.183 1.183 0 0 0-.408.68.893.893 0 0 0 .006.363l1.549 6.51a.688.688 0 0 0 .367.481c.196.11.424.152.647.119.206-.014.406-.076.583-.18.176-.105.325-.249.433-.42l2.138-3.887.822 3.887a.812.812 0 0 0 .296.431.847.847 0 0 0 .504.169 1.29 1.29 0 0 0 .706-.122c.218-.107.4-.273.524-.478l3.903-6.51a.96.96 0 0 0 .137-.363.776.776 0 0 0-.176-.703ZM66.435 48.62a.931.931 0 0 0-.718-.268 1.286 1.286 0 0 0-.816.276 1.102 1.102 0 0 0-.427.687l-.004.023a3.221 3.221 0 0 0-.3-.26 3.566 3.566 0 0 0-1.02-.52 4.25 4.25 0 0 0-1.37-.206c-.794 0-1.575.192-2.274.56a5.472 5.472 0 0 0-1.84 1.548 5.213 5.213 0 0 0-.991 2.284 4.035 4.035 0 0 0 .17 2.267c.25.639.704 1.182 1.296 1.548.637.385 1.376.58 2.126.56.438.002.874-.064 1.291-.197.383-.12.75-.281 1.094-.482.216-.126.42-.268.613-.426a.752.752 0 0 0 .18.671.91.91 0 0 0 .716.277c.297.004.586-.094.816-.277.226-.169.378-.414.427-.687l1.209-6.683a.753.753 0 0 0-.178-.695Zm-4.153 6.415c-.44.234-.934.354-1.436.348a2.287 2.287 0 0 1-1.29-.348 1.888 1.888 0 0 1-.747-.948 2.528 2.528 0 0 1-.087-1.343c.084-.489.28-.953.575-1.358a3.197 3.197 0 0 1 1.089-.948 2.96 2.96 0 0 1 1.416-.348c.463-.016.92.105 1.31.348.347.228.609.561.745.948.15.438.18.906.084 1.358-.084.484-.28.943-.572 1.343a3.192 3.192 0 0 1-1.087.948ZM75.8 48.63a.912.912 0 0 0-.716-.277 1.286 1.286 0 0 0-.817.276 1.102 1.102 0 0 0-.427.688l-.731 4.044c-.059.366-.2.714-.416 1.019-.197.273-.464.49-.773.632a2.598 2.598 0 0 1-1.09.213c-.606 0-1.053-.14-1.34-.419-.289-.279-.37-.76-.247-1.445l.731-4.044a.758.758 0 0 0-.179-.688.913.913 0 0 0-.716-.276 1.286 1.286 0 0 0-.816.276 1.102 1.102 0 0 0-.427.688l-.834 4.613a2.867 2.867 0 0 0 .108 1.573c.168.446.486.825.901 1.074a2.98 2.98 0 0 0 1.578.388c.492.005.981-.054 1.457-.174.417-.107.812-.28 1.17-.514a3.57 3.57 0 0 0 .448-.352l-.031.169a2.9 2.9 0 0 1-.506 1.271 1.96 1.96 0 0 1-.94.664 4.365 4.365 0 0 1-1.398.197 2.905 2.905 0 0 1-1.038-.166 9.562 9.562 0 0 0-.705-.244 1.017 1.017 0 0 0-.755.039c-.278.13-.5.351-.63.625a.688.688 0 0 0-.038.655c.144.243.374.426.647.514.324.122.663.202 1.008.237a9.6 9.6 0 0 0 1.197.079 7.285 7.285 0 0 0 2.386-.38 4.385 4.385 0 0 0 1.872-1.24 4.628 4.628 0 0 0 1.033-2.314l1.214-6.714a.756.756 0 0 0-.18-.688ZM36.33 19.333l-7.214-7.038a1.049 1.049 0 0 0-1.44-.013 1 1 0 0 0-.311.72v14.076a.98.98 0 0 0 .31.72 1.027 1.027 0 0 0 .748.281c.261-.006.51-.112.693-.294l7.214-7.038a.988.988 0 0 0 .3-.707.988.988 0 0 0-.3-.707Zm-.681 1.012-6.757 6.59a.445.445 0 0 1-.481.094.44.44 0 0 1-.198-.158.423.423 0 0 1-.075-.24V13.45c0-.085.026-.168.074-.24a.453.453 0 0 1 .68-.066l6.757 6.592a.426.426 0 0 1 0 .61ZM60.633 20.051a.983.983 0 0 0-.173-.555 1.02 1.02 0 0 0-.46-.369 1.05 1.05 0 0 0-1.118.217l-6.663 6.502-7.687-7.498a1.038 1.038 0 0 0-.724-.292c-.272 0-.533.105-.725.292L27.665 33.38a.988.988 0 0 0-.3.707c0 .265.108.52.3.707l4.01 3.911a1.026 1.026 0 0 0 .725.293 1.047 1.047 0 0 0 .725-.293l9.957-9.714a1.027 1.027 0 0 1 .725-.293 1.048 1.048 0 0 1 .725.293L58.9 43.007a1.04 1.04 0 0 0 1.107.214c.185-.074.344-.201.455-.364a.974.974 0 0 0 .172-.55l-.002-22.256Zm-1.527.142a.445.445 0 0 1 .48-.094.44.44 0 0 1 .2.159c.048.07.074.154.074.24V33.3l-7.096-6.922 6.342-6.186Zm-14.027 8.265a1.803 1.803 0 0 0-.583-.38 1.839 1.839 0 0 0-1.96.38l-9.824 9.583a.444.444 0 0 1-.312.126.453.453 0 0 1-.313-.126l-3.741-3.65a.43.43 0 0 1-.13-.304.422.422 0 0 1 .13-.305l15.149-14.77a.448.448 0 0 1 .624 0l7.552 7.368-4.36 4.256-2.232-2.177Zm14.029 13.685-11.25-10.974 4.36-4.257 7.642 7.455.002 7.47c0 .086-.025.17-.074.241a.452.452 0 0 1-.681.065Z",
    fill: "#fff"
  })));
};

var _path$7m;
function _extends$7x() { _extends$7x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7x.apply(this, arguments); }
var SvgHorizontalMediumFull = function SvgHorizontalMediumFull(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7x({
    width: 177,
    height: 67,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7m || (_path$7m = /*#__PURE__*/createElement$2("path", {
    d: "M79.185 31.678a5.115 5.115 0 0 0-2.003-2.453 5.97 5.97 0 0 0-3.316-.893c-.643 0-1.283.101-1.894.302a7.614 7.614 0 0 0-1.672.767 7.26 7.26 0 0 0-1.117.84l.066-.374a1.237 1.237 0 0 0-.277-1.095 1.415 1.415 0 0 0-1.113-.44c-.46-.006-.91.15-1.268.44-.35.269-.587.66-.663 1.095l-2.73 15.48a1.226 1.226 0 0 0 .275 1.107 1.44 1.44 0 0 0 1.117.428c.46.006.91-.15 1.267-.44.35-.27.588-.66.664-1.095l.836-4.739c.18.193.375.372.584.533.471.358.996.638 1.556.83a5.94 5.94 0 0 0 2.019.328 7.402 7.402 0 0 0 3.548-.894 8.6 8.6 0 0 0 2.842-2.466 8.412 8.412 0 0 0 1.54-3.636 6.569 6.569 0 0 0-.261-3.625Zm-3.815 5.776a5.018 5.018 0 0 1-1.68 1.523 4.486 4.486 0 0 1-2.215.553 3.54 3.54 0 0 1-2.034-.553 2.983 2.983 0 0 1-1.157-1.523 4.191 4.191 0 0 1-.133-2.151c.13-.776.435-1.512.892-2.152a5.036 5.036 0 0 1 1.69-1.497 4.567 4.567 0 0 1 2.229-.553 3.477 3.477 0 0 1 2.02.553c.531.365.933.89 1.147 1.497.235.693.28 1.436.133 2.152a5.283 5.283 0 0 1-.892 2.151ZM96.507 28.76a1.444 1.444 0 0 0-1.117-.428c-.461-.006-.91.15-1.268.44-.35.269-.587.66-.663 1.095l-.007.037a4.985 4.985 0 0 0-.467-.415 5.494 5.494 0 0 0-1.583-.83 6.45 6.45 0 0 0-2.13-.327 7.426 7.426 0 0 0-3.534.893 8.549 8.549 0 0 0-2.857 2.466 8.41 8.41 0 0 0-1.54 3.636 6.574 6.574 0 0 0 .262 3.611 5.063 5.063 0 0 0 2.015 2.467c.99.612 2.138.923 3.302.893a6.375 6.375 0 0 0 2.007-.315 8.189 8.189 0 0 0 1.7-.767c.335-.2.653-.428.952-.68a1.227 1.227 0 0 0 .28 1.07 1.41 1.41 0 0 0 1.113.44c.46.006.91-.15 1.268-.44.35-.269.587-.66.663-1.095l1.877-10.644a1.23 1.23 0 0 0-.273-1.107Zm-6.453 10.217a4.565 4.565 0 0 1-2.229.553c-.71.024-1.41-.17-2.006-.553a3 3 0 0 1-1.16-1.51 4.119 4.119 0 0 1-.135-2.14c.131-.78.437-1.52.894-2.164a5.01 5.01 0 0 1 1.691-1.51 4.514 4.514 0 0 1 2.202-.554 3.544 3.544 0 0 1 2.034.554c.54.364.947.894 1.159 1.51.233.697.278 1.444.13 2.165a5.196 5.196 0 0 1-.889 2.139 5.01 5.01 0 0 1-1.69 1.51ZM111.059 28.772a1.418 1.418 0 0 0-1.113-.44 1.967 1.967 0 0 0-1.268.44c-.35.269-.587.66-.663 1.095l-1.136 6.442a3.927 3.927 0 0 1-.647 1.624c-.306.434-.72.781-1.201 1.006a3.95 3.95 0 0 1-1.693.34c-.942 0-1.636-.222-2.083-.667-.448-.445-.576-1.212-.383-2.303l1.136-6.442a1.24 1.24 0 0 0-.278-1.094 1.415 1.415 0 0 0-1.113-.44c-.461-.007-.91.149-1.267.44-.35.268-.588.66-.664 1.094l-1.296 7.348a4.68 4.68 0 0 0 .168 2.504 3.38 3.38 0 0 0 1.4 1.71 4.538 4.538 0 0 0 2.452.617 8.643 8.643 0 0 0 2.263-.276 6.064 6.064 0 0 0 1.819-.818c.246-.168.478-.355.694-.56l-.048.271a4.679 4.679 0 0 1-.786 2.026 3.05 3.05 0 0 1-1.46 1.057 6.626 6.626 0 0 1-2.173.314 4.413 4.413 0 0 1-1.614-.264c-.45-.176-.814-.306-1.094-.39a1.546 1.546 0 0 0-1.173.063 2.057 2.057 0 0 0-.979.994 1.116 1.116 0 0 0-.06 1.045c.224.386.582.677 1.005.817.504.195 1.03.322 1.567.378.617.081 1.238.124 1.861.126 1.26.011 2.513-.193 3.705-.604a6.803 6.803 0 0 0 2.909-1.976 7.451 7.451 0 0 0 1.605-3.687l1.887-10.695a1.242 1.242 0 0 0-.279-1.095ZM132.318 28.772a1.319 1.319 0 0 0-1.03-.44c-.849 0-1.44.319-1.774.956l-4.243 7.236-1.201-5.248a1.312 1.312 0 0 0-.39-.692 1.34 1.34 0 0 0-.886-.239 1.911 1.911 0 0 0-1.686.931l-3.133 5.388-1.692-7.375a.975.975 0 0 0-.453-.73 1.71 1.71 0 0 0-.901-.226 1.866 1.866 0 0 0-1.302.478c-.328.278-.552.66-.634 1.082-.036.192-.033.389.009.579l2.407 10.367a1.115 1.115 0 0 0 .57.768c.304.175.658.242 1.005.189a2.01 2.01 0 0 0 1.58-.957l3.321-6.19 1.274 6.19a1.297 1.297 0 0 0 1.243.957 1.963 1.963 0 0 0 1.913-.957l6.063-10.367a1.534 1.534 0 0 0 .213-.579 1.26 1.26 0 0 0-.273-1.121ZM147.737 28.76a1.431 1.431 0 0 0-1.114-.428c-.461-.006-.91.15-1.268.44a1.76 1.76 0 0 0-.664 1.095l-.006.037a5.088 5.088 0 0 0-.467-.415 5.495 5.495 0 0 0-1.584-.83 6.448 6.448 0 0 0-2.129-.327 7.422 7.422 0 0 0-3.534.893 8.55 8.55 0 0 0-2.858 2.466 8.412 8.412 0 0 0-1.541 3.636 6.593 6.593 0 0 0 .263 3.611 5.067 5.067 0 0 0 2.015 2.467 5.988 5.988 0 0 0 3.303.893 6.377 6.377 0 0 0 2.007-.315 8.162 8.162 0 0 0 1.699-.767c.335-.2.654-.428.953-.68a1.224 1.224 0 0 0 .279 1.07 1.416 1.416 0 0 0 1.113.44c.461.006.91-.15 1.268-.44.35-.269.587-.66.664-1.095l1.877-10.644a1.228 1.228 0 0 0-.276-1.107Zm-6.452 10.217a4.562 4.562 0 0 1-2.229.553 3.49 3.49 0 0 1-2.006-.553 2.999 2.999 0 0 1-1.159-1.51 4.125 4.125 0 0 1-.136-2.14c.131-.78.437-1.52.894-2.164a5.007 5.007 0 0 1 1.692-1.51 4.509 4.509 0 0 1 2.201-.554 3.545 3.545 0 0 1 2.034.554 3 3 0 0 1 1.159 1.51c.233.697.278 1.444.131 2.165a5.197 5.197 0 0 1-.89 2.139 5.007 5.007 0 0 1-1.691 1.51ZM162.289 28.772a1.414 1.414 0 0 0-1.112-.44c-.461-.006-.91.15-1.268.44a1.76 1.76 0 0 0-.664 1.095l-1.136 6.442a3.911 3.911 0 0 1-.646 1.624c-.306.434-.72.781-1.202 1.006a3.945 3.945 0 0 1-1.691.34c-.942 0-1.636-.222-2.084-.667-.447-.445-.575-1.212-.383-2.303l1.137-6.442a1.24 1.24 0 0 0-.278-1.094 1.413 1.413 0 0 0-1.112-.44c-.461-.007-.91.149-1.268.44a1.76 1.76 0 0 0-.664 1.094l-1.296 7.348c-.173.835-.115 1.7.168 2.504a3.375 3.375 0 0 0 1.4 1.71 4.539 4.539 0 0 0 2.452.617 8.643 8.643 0 0 0 2.263-.276 6.064 6.064 0 0 0 1.819-.818c.246-.168.478-.355.694-.56l-.048.271a4.692 4.692 0 0 1-.786 2.026 3.05 3.05 0 0 1-1.46 1.057 6.626 6.626 0 0 1-2.173.314 4.411 4.411 0 0 1-1.614-.264 14.787 14.787 0 0 0-1.094-.39 1.545 1.545 0 0 0-1.173.063 2.06 2.06 0 0 0-.979.994 1.116 1.116 0 0 0-.059 1.045c.223.386.581.677 1.004.817.504.195 1.03.322 1.567.378.617.081 1.238.123 1.86.126a11.068 11.068 0 0 0 3.706-.604 6.807 6.807 0 0 0 2.909-1.976 7.452 7.452 0 0 0 1.605-3.687l1.886-10.695a1.242 1.242 0 0 0-.28-1.095ZM24.024 23.703l-8.293-8.293a1.179 1.179 0 0 0-2.013.833v16.588a1.18 1.18 0 0 0 1.216 1.18c.3-.007.586-.132.797-.347l8.293-8.293a1.18 1.18 0 0 0 0-1.668Zm-.784 1.193-7.766 7.767a.508.508 0 0 1-.867-.359V16.77a.508.508 0 0 1 .867-.359l7.767 7.767a.508.508 0 0 1 0 .718ZM51.961 24.55a1.18 1.18 0 0 0-2.012-.833l-7.66 7.663-8.837-8.835a1.178 1.178 0 0 0-1.666 0L14.063 40.258a1.178 1.178 0 0 0 0 1.667l4.61 4.61a1.178 1.178 0 0 0 1.666 0l11.447-11.448a1.18 1.18 0 0 1 1.666 0L49.97 51.604a1.168 1.168 0 0 0 1.993-.826l-.002-26.227Zm-1.755.167a.508.508 0 0 1 .866.36v15.088l-8.156-8.157 7.29-7.29ZM34.08 34.46a2.067 2.067 0 0 0-2.923 0L19.865 45.752a.506.506 0 0 1-.719 0l-4.3-4.301a.508.508 0 0 1 0-.718L32.26 23.328a.51.51 0 0 1 .718 0l8.681 8.682-5.011 5.015-2.567-2.566Zm16.126 16.126L37.275 37.653l5.012-5.017 8.785 8.786.002 8.804a.507.507 0 0 1-.867.359Z",
    fill: "#023F80"
  })));
};

var _path$7n;
function _extends$7y() { _extends$7y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7y.apply(this, arguments); }
var SvgHorizontalSmallFull = function SvgHorizontalSmallFull(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7y({
    width: 88,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7n || (_path$7n = /*#__PURE__*/createElement$2("path", {
    d: "M39.092 16.34a2.557 2.557 0 0 0-1.001-1.227 2.985 2.985 0 0 0-1.658-.447c-.322 0-.642.05-.947.15a3.808 3.808 0 0 0-1.395.804l.033-.186a.62.62 0 0 0-.138-.548.707.707 0 0 0-.557-.22.983.983 0 0 0-.634.22.88.88 0 0 0-.331.548l-1.365 7.74a.613.613 0 0 0 .137.553.72.72 0 0 0 .558.214.985.985 0 0 0 .634-.22.882.882 0 0 0 .332-.547l.418-2.37c.09.097.188.186.292.267.236.179.498.319.778.415.325.112.666.168 1.01.163a3.7 3.7 0 0 0 1.774-.446 4.298 4.298 0 0 0 1.42-1.233c.398-.537.662-1.16.771-1.818a3.285 3.285 0 0 0-.13-1.813Zm-1.907 2.887a2.509 2.509 0 0 1-.84.761c-.34.187-.72.282-1.108.277a1.77 1.77 0 0 1-1.017-.277 1.491 1.491 0 0 1-.578-.76 2.097 2.097 0 0 1-.067-1.076c.065-.388.218-.756.446-1.076.221-.31.51-.567.845-.749.342-.186.726-.28 1.114-.277.358-.013.71.083 1.01.277.266.183.467.445.574.749.118.346.14.718.067 1.076-.067.387-.22.754-.446 1.075ZM47.754 14.88a.722.722 0 0 0-.559-.214.984.984 0 0 0-.634.22.881.881 0 0 0-.331.547l-.004.019a2.492 2.492 0 0 0-.233-.207 2.742 2.742 0 0 0-.792-.415 3.22 3.22 0 0 0-1.064-.164c-.617 0-1.225.153-1.768.447-.562.299-1.05.72-1.428 1.233a4.205 4.205 0 0 0-.77 1.818 3.287 3.287 0 0 0 .13 1.805c.195.509.548.941 1.008 1.233.495.307 1.07.462 1.651.447.341.002.68-.052 1.004-.157a4.09 4.09 0 0 0 .85-.384c.167-.1.326-.214.476-.34a.615.615 0 0 0 .14.535.707.707 0 0 0 .556.22.984.984 0 0 0 .634-.22.882.882 0 0 0 .332-.547l.939-5.323a.615.615 0 0 0-.137-.553Zm-3.227 5.108a2.283 2.283 0 0 1-1.114.277 1.745 1.745 0 0 1-1.003-.277 1.5 1.5 0 0 1-.58-.755 2.06 2.06 0 0 1-.068-1.07c.066-.389.219-.76.447-1.082.22-.313.51-.57.846-.755.337-.184.716-.28 1.1-.276a1.77 1.77 0 0 1 1.017.276c.27.183.474.447.58.755.117.35.14.723.065 1.083a2.598 2.598 0 0 1-.444 1.07c-.22.312-.51.57-.846.754ZM55.03 14.886a.707.707 0 0 0-.557-.22.984.984 0 0 0-.634.22.882.882 0 0 0-.332.548l-.568 3.22a1.96 1.96 0 0 1-.323.813c-.153.217-.36.39-.6.503a1.973 1.973 0 0 1-.847.17c-.471 0-.818-.111-1.042-.334-.224-.222-.288-.606-.192-1.151l.569-3.221a.618.618 0 0 0-.14-.547.708.708 0 0 0-.555-.22.982.982 0 0 0-.634.22.88.88 0 0 0-.332.547l-.648 3.674c-.087.417-.058.85.084 1.252.13.355.377.657.7.855.37.217.796.324 1.226.308.381.005.762-.042 1.132-.138.323-.085.63-.223.909-.409.123-.084.239-.177.347-.28l-.024.136c-.05.364-.185.71-.393 1.013-.185.245-.44.43-.73.528-.351.113-.718.166-1.087.157a2.209 2.209 0 0 1-.807-.132 7.336 7.336 0 0 0-.547-.195.773.773 0 0 0-.586.032c-.216.103-.39.28-.49.497a.558.558 0 0 0-.03.522c.112.193.291.339.503.409.252.097.515.16.783.189.309.04.62.061.93.063a5.529 5.529 0 0 0 1.853-.302 3.402 3.402 0 0 0 1.455-.988c.431-.53.709-1.167.802-1.844l.944-5.347a.62.62 0 0 0-.14-.548ZM65.659 14.886a.656.656 0 0 0-.515-.22c-.424 0-.72.16-.887.478l-2.121 3.618-.6-2.624a.657.657 0 0 0-.196-.346.67.67 0 0 0-.443-.12.954.954 0 0 0-.843.466l-1.566 2.694-.846-3.688a.487.487 0 0 0-.227-.364.857.857 0 0 0-.45-.114.934.934 0 0 0-.651.24.947.947 0 0 0-.317.54.729.729 0 0 0 .004.29l1.204 5.184a.554.554 0 0 0 .285.384c.152.087.329.12.502.094a1.004 1.004 0 0 0 .79-.478l1.661-3.096.637 3.096a.648.648 0 0 0 .621.478.983.983 0 0 0 .957-.478l3.031-5.184a.765.765 0 0 0 .107-.29.632.632 0 0 0-.137-.56ZM73.369 14.88a.722.722 0 0 0-.557-.214.983.983 0 0 0-.634.22.881.881 0 0 0-.332.547l-.004.019a2.563 2.563 0 0 0-.233-.207c-.24-.181-.507-.321-.792-.415a3.227 3.227 0 0 0-1.064-.164c-.617 0-1.225.153-1.768.447-.562.299-1.05.72-1.428 1.233a4.205 4.205 0 0 0-.77 1.818 3.29 3.29 0 0 0 .13 1.805c.195.509.549.941 1.008 1.233.496.307 1.07.462 1.652.447.34.002.68-.052 1.003-.157.297-.095.582-.224.85-.384.167-.1.327-.214.476-.34a.614.614 0 0 0 .14.535.706.706 0 0 0 .556.22.983.983 0 0 0 .634-.22.882.882 0 0 0 .332-.547l.939-5.323a.615.615 0 0 0-.138-.553Zm-3.226 5.108a2.282 2.282 0 0 1-1.115.277 1.745 1.745 0 0 1-1.003-.277 1.5 1.5 0 0 1-.58-.755 2.064 2.064 0 0 1-.067-1.07c.065-.389.218-.76.447-1.082.22-.313.51-.571.846-.755.337-.184.716-.28 1.1-.276.36-.013.714.083 1.017.276.27.183.474.447.58.755.116.35.139.723.065 1.083a2.602 2.602 0 0 1-.445 1.07c-.22.312-.51.57-.845.754ZM80.645 14.886a.707.707 0 0 0-.556-.22.983.983 0 0 0-.635.22.881.881 0 0 0-.331.548l-.568 3.22a1.96 1.96 0 0 1-.324.813c-.153.217-.36.39-.6.503a1.973 1.973 0 0 1-.846.17c-.47 0-.818-.111-1.042-.334-.224-.222-.287-.606-.191-1.151l.568-3.221a.619.619 0 0 0-.139-.547.706.706 0 0 0-.556-.22.983.983 0 0 0-.634.22.882.882 0 0 0-.332.547l-.648 3.674c-.087.417-.058.85.084 1.252.13.355.377.657.7.855.371.217.796.324 1.226.308a4.32 4.32 0 0 0 1.132-.138c.323-.085.63-.223.909-.409.123-.084.239-.177.347-.28l-.024.136c-.05.364-.184.71-.393 1.013-.184.245-.439.43-.73.528-.35.113-.718.166-1.086.157a2.208 2.208 0 0 1-.807-.132 7.414 7.414 0 0 0-.547-.195.773.773 0 0 0-.587.032c-.216.103-.39.28-.49.497a.556.556 0 0 0-.03.522c.113.193.291.339.503.409.252.097.515.16.783.189.309.04.62.061.93.063a5.531 5.531 0 0 0 1.853-.302 3.403 3.403 0 0 0 1.455-.988 3.73 3.73 0 0 0 .803-1.844l.943-5.347a.618.618 0 0 0-.14-.548ZM11.512 12.352 7.365 8.205a.578.578 0 0 0-.63-.134.59.59 0 0 0-.376.55v8.295a.59.59 0 0 0 1.006.416l4.147-4.146a.59.59 0 0 0 0-.834Zm-.392.596-3.883 3.884a.253.253 0 0 1-.434-.18V8.885a.254.254 0 0 1 .434-.18l3.883 3.884a.253.253 0 0 1 0 .36ZM25.48 12.776a.589.589 0 0 0-1.006-.417l-3.83 3.831-4.418-4.418a.589.589 0 0 0-.833 0L6.531 20.63a.589.589 0 0 0 0 .833l2.305 2.305a.589.589 0 0 0 .833 0l5.724-5.723a.592.592 0 0 1 .833 0l8.259 8.258a.583.583 0 0 0 .997-.413l-.001-13.113Zm-.877.083a.254.254 0 0 1 .433.18v7.544l-4.078-4.08 3.645-3.644Zm-8.063 4.87a1.031 1.031 0 0 0-1.461 0l-5.647 5.647a.254.254 0 0 1-.359 0l-2.15-2.15a.253.253 0 0 1 0-.36l8.707-8.702a.253.253 0 0 1 .359 0l4.34 4.34-2.505 2.509-1.284-1.284Zm8.064 8.064-6.466-6.466 2.505-2.509 4.393 4.393.001 4.402a.254.254 0 0 1-.433.18Z",
    fill: "#023F80"
  })));
};

var _path$7o, _path2$2m, _path3$J, _path4$c, _path5$6;
function _extends$7z() { _extends$7z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7z.apply(this, arguments); }
var SvgHorizontalMediumInverted = function SvgHorizontalMediumInverted(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7z({
    width: 177,
    height: 67,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7o || (_path$7o = /*#__PURE__*/createElement$2("path", {
    d: "M79.76 31.768a4.884 4.884 0 0 0-1.951-2.328 5.931 5.931 0 0 0-3.23-.848c-.626 0-1.249.096-1.844.287a7.492 7.492 0 0 0-1.628.728c-.388.23-.752.497-1.088.797l.065-.355a1.144 1.144 0 0 0-.27-1.039 1.41 1.41 0 0 0-1.084-.417 1.947 1.947 0 0 0-1.235.417 1.665 1.665 0 0 0-.647 1.039L64.19 44.738a1.137 1.137 0 0 0 .268 1.05 1.436 1.436 0 0 0 1.086.406c.449.006.886-.141 1.234-.417.342-.255.572-.626.647-1.04l.814-4.496c.175.183.365.352.569.506.459.34.97.606 1.516.788a5.924 5.924 0 0 0 1.965.31 7.358 7.358 0 0 0 3.456-.848 8.31 8.31 0 0 0 2.768-2.34 7.88 7.88 0 0 0 1.5-3.45 6.082 6.082 0 0 0-.253-3.44Zm-3.715 5.48a4.847 4.847 0 0 1-1.636 1.445 4.462 4.462 0 0 1-2.158.525c-.7.025-1.39-.158-1.98-.525a2.84 2.84 0 0 1-1.128-1.445 3.883 3.883 0 0 1-.129-2.042 4.867 4.867 0 0 1 2.514-3.463 4.541 4.541 0 0 1 2.171-.524 3.454 3.454 0 0 1 1.967.525c.518.346.909.844 1.118 1.42.229.658.273 1.363.13 2.042a4.935 4.935 0 0 1-.87 2.042ZM96.63 28.997a1.439 1.439 0 0 0-1.087-.406 1.948 1.948 0 0 0-1.235.418 1.665 1.665 0 0 0-.647 1.038l-.006.035a4.916 4.916 0 0 0-.454-.392 5.397 5.397 0 0 0-1.542-.789 6.444 6.444 0 0 0-2.074-.31c-1.202 0-2.385.29-3.443.848a8.273 8.273 0 0 0-2.782 2.34 7.874 7.874 0 0 0-1.501 3.45 6.09 6.09 0 0 0 .256 3.427 4.831 4.831 0 0 0 1.962 2.34 5.943 5.943 0 0 0 3.217.848 6.358 6.358 0 0 0 1.954-.299 8.073 8.073 0 0 0 1.655-.728c.327-.19.637-.406.928-.644a1.137 1.137 0 0 0 .273 1.014c.138.143.306.254.494.326.187.072.388.103.589.091.45.007.886-.141 1.235-.417.341-.255.572-.626.646-1.038l1.829-10.102a1.139 1.139 0 0 0-.267-1.05Zm-6.284 9.695a4.539 4.539 0 0 1-2.17.526 3.467 3.467 0 0 1-1.955-.526 2.853 2.853 0 0 1-1.129-1.432 3.816 3.816 0 0 1-.131-2.03 4.908 4.908 0 0 1 2.518-3.487 4.487 4.487 0 0 1 2.144-.526 3.52 3.52 0 0 1 1.98.526c.526.345.922.848 1.13 1.433a3.87 3.87 0 0 1 .126 2.054 4.865 4.865 0 0 1-.866 2.03 4.833 4.833 0 0 1-1.647 1.432ZM110.803 29.01a1.386 1.386 0 0 0-1.084-.418 1.949 1.949 0 0 0-1.235.418 1.667 1.667 0 0 0-.646 1.039l-1.106 6.112a3.653 3.653 0 0 1-.63 1.541 2.951 2.951 0 0 1-1.17.956 3.93 3.93 0 0 1-1.647.32c-.917 0-1.594-.21-2.029-.632-.436-.422-.56-1.15-.373-2.185l1.106-6.113a1.142 1.142 0 0 0-.27-1.039 1.378 1.378 0 0 0-.494-.325 1.41 1.41 0 0 0-.589-.092 1.948 1.948 0 0 0-1.235.417 1.667 1.667 0 0 0-.647 1.04l-1.262 6.972a4.321 4.321 0 0 0 .163 2.376 3.224 3.224 0 0 0 1.364 1.623c.723.412 1.551.615 2.388.585a8.602 8.602 0 0 0 2.204-.262 5.98 5.98 0 0 0 1.772-.776c.239-.16.465-.337.675-.53l-.046.256a4.371 4.371 0 0 1-.766 1.922 2.968 2.968 0 0 1-1.421 1.003 6.608 6.608 0 0 1-2.117.299 4.404 4.404 0 0 1-1.572-.25 14.75 14.75 0 0 0-1.065-.371 1.544 1.544 0 0 0-1.143.06c-.42.196-.758.53-.953.943a1.04 1.04 0 0 0-.058.99c.218.367.566.644.978.777.49.185 1.004.305 1.526.358.601.078 1.206.117 1.813.12 1.227.01 2.447-.184 3.608-.574a6.642 6.642 0 0 0 2.834-1.874 6.986 6.986 0 0 0 1.563-3.5l1.837-10.148a1.157 1.157 0 0 0-.273-1.039ZM131.507 29.01a1.29 1.29 0 0 0-1.003-.418c-.827 0-1.403.303-1.728.908l-4.132 6.866-1.17-4.98a1.24 1.24 0 0 0-.38-.657 1.33 1.33 0 0 0-.862-.226 1.9 1.9 0 0 0-.944.225c-.288.155-.53.382-.698.658l-3.052 5.112-1.648-6.998a.91.91 0 0 0-.44-.692 1.707 1.707 0 0 0-.878-.215 1.845 1.845 0 0 0-1.268.454c-.32.264-.538.626-.618 1.027-.034.182-.032.368.009.549l2.344 9.838c.031.154.097.3.193.426s.22.23.363.303c.296.165.641.229.978.179.312-.02.615-.114.883-.272.268-.158.493-.376.656-.636l3.235-5.875 1.241 5.875c.072.26.229.489.448.653.218.164.486.253.762.255.367.04.739-.024 1.069-.185a1.89 1.89 0 0 0 .794-.723l5.905-9.838c.05-.08.093-.164.126-.25.037-.098.064-.198.081-.3a1.168 1.168 0 0 0-.266-1.063ZM146.525 28.997a1.439 1.439 0 0 0-1.088-.406 1.944 1.944 0 0 0-1.234.418 1.662 1.662 0 0 0-.647 1.039l-.006.035a4.802 4.802 0 0 0-.455-.393 5.389 5.389 0 0 0-1.542-.789 6.437 6.437 0 0 0-2.073-.31c-1.202 0-2.385.291-3.443.848a8.267 8.267 0 0 0-2.782 2.34 7.866 7.866 0 0 0-1.501 3.45 6.09 6.09 0 0 0 .257 3.427 4.824 4.824 0 0 0 1.962 2.34 5.94 5.94 0 0 0 3.216.848 6.357 6.357 0 0 0 1.955-.299 8.1 8.1 0 0 0 1.655-.728c.326-.19.636-.406.927-.644a1.141 1.141 0 0 0 .273 1.014c.138.143.307.254.494.326.187.072.389.103.59.091.449.007.886-.141 1.234-.417.342-.255.573-.625.647-1.038l1.828-10.101a1.142 1.142 0 0 0-.267-1.05Zm-6.284 9.695a4.541 4.541 0 0 1-2.171.526 3.465 3.465 0 0 1-1.954-.526 2.852 2.852 0 0 1-1.129-1.432 3.809 3.809 0 0 1-.132-2.03 4.92 4.92 0 0 1 .87-2.054 4.848 4.848 0 0 1 1.648-1.433 4.486 4.486 0 0 1 2.144-.526c.7-.024 1.39.159 1.981.526.526.345.922.848 1.129 1.433a3.87 3.87 0 0 1 .127 2.054 4.857 4.857 0 0 1-.867 2.03 4.83 4.83 0 0 1-1.646 1.432ZM160.697 29.01a1.377 1.377 0 0 0-.494-.326 1.413 1.413 0 0 0-.59-.092 1.944 1.944 0 0 0-1.234.418 1.668 1.668 0 0 0-.647 1.038l-1.106 6.113a3.664 3.664 0 0 1-.629 1.541 2.954 2.954 0 0 1-1.171.956 3.93 3.93 0 0 1-1.647.32c-.917 0-1.593-.21-2.029-.632-.436-.422-.56-1.15-.373-2.185l1.106-6.113a1.142 1.142 0 0 0-.27-1.039 1.408 1.408 0 0 0-1.083-.417 1.949 1.949 0 0 0-1.235.417 1.662 1.662 0 0 0-.646 1.04l-1.263 6.972a4.331 4.331 0 0 0 .163 2.375 3.227 3.227 0 0 0 1.365 1.624 4.507 4.507 0 0 0 2.387.585 8.615 8.615 0 0 0 2.205-.263 5.979 5.979 0 0 0 1.771-.776c.239-.158.465-.336.676-.53l-.047.257a4.37 4.37 0 0 1-.766 1.922 2.964 2.964 0 0 1-1.421 1.003 6.605 6.605 0 0 1-2.117.299 4.406 4.406 0 0 1-1.572-.251 14.74 14.74 0 0 0-1.065-.37 1.545 1.545 0 0 0-1.143.06c-.42.196-.757.53-.953.943a1.038 1.038 0 0 0-.058.99c.218.367.566.643.979.777.49.184 1.003.305 1.525.358.601.078 1.207.117 1.813.12a11.03 11.03 0 0 0 3.608-.574 6.639 6.639 0 0 0 2.834-1.874 6.984 6.984 0 0 0 1.563-3.5l1.837-10.148a1.143 1.143 0 0 0-.273-1.038Z",
    fill: "#fff"
  })), _path2$2m || (_path2$2m = /*#__PURE__*/createElement$2("path", {
    d: "m26.038 24.2-8.078-7.87a1.174 1.174 0 0 0-1.612-.015 1.117 1.117 0 0 0-.348.806v15.74a1.093 1.093 0 0 0 .348.806 1.15 1.15 0 0 0 .837.315 1.14 1.14 0 0 0 .775-.33l8.078-7.87a1.116 1.116 0 0 0 .336-.79 1.095 1.095 0 0 0-.336-.792Z",
    fill: "#1AAAAD"
  })), _path3$J || (_path3$J = /*#__PURE__*/createElement$2("path", {
    d: "m53.246 40.663-9.42-9.179-6.108 5.952 13.588 13.24a1.165 1.165 0 0 0 1.24.24c.208-.085.385-.227.51-.409.125-.182.192-.396.192-.616l-.002-9.228Z",
    fill: "#FECF2F"
  })), _path4$c || (_path4$c = /*#__PURE__*/createElement$2("path", {
    d: "M35.222 23.1a1.15 1.15 0 0 0-.812-.327 1.174 1.174 0 0 0-.81.328L16.336 39.91a1.117 1.117 0 0 0-.336.79 1.094 1.094 0 0 0 .336.79l4.49 4.375a1.164 1.164 0 0 0 1.623 0L33.6 35.003a1.163 1.163 0 0 1 1.623 0l2.496 2.432 6.108-5.95-8.605-8.384Z",
    fill: "#DD2457"
  })), _path5$6 || (_path5$6 = /*#__PURE__*/createElement$2("path", {
    d: "m51.287 24.213-7.46 7.271 9.42 9.178.002-15.658c0-.221-.067-.438-.194-.622a1.142 1.142 0 0 0-.515-.413 1.176 1.176 0 0 0-1.253.244Z",
    fill: "#fff"
  })));
};

var _path$7p, _path2$2n, _path3$K, _path4$d, _path5$7;
function _extends$7A() { _extends$7A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7A.apply(this, arguments); }
var SvgHorizontalSmallInverted = function SvgHorizontalSmallInverted(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7A({
    width: 88,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7p || (_path$7p = /*#__PURE__*/createElement$2("path", {
    d: "M39.54 16.11a2.507 2.507 0 0 0-.996-1.198 3.01 3.01 0 0 0-1.648-.436c-.32 0-.638.05-.942.147a3.81 3.81 0 0 0-1.386.785l.033-.183a.594.594 0 0 0-.138-.534.704.704 0 0 0-.553-.215.99.99 0 0 0-.63.215.858.858 0 0 0-.33.534l-1.357 7.554a.59.59 0 0 0 .137.54.718.718 0 0 0 .554.21.989.989 0 0 0 .63-.215.858.858 0 0 0 .33-.535l.416-2.312c.089.094.186.181.29.26.234.175.495.311.773.405.323.11.662.164 1.004.16a3.731 3.731 0 0 0 1.763-.436 4.248 4.248 0 0 0 1.413-1.204 4.069 4.069 0 0 0 .766-1.774 3.151 3.151 0 0 0-.13-1.769Zm-1.897 2.818a2.48 2.48 0 0 1-.835.742 2.263 2.263 0 0 1-1.1.27 1.785 1.785 0 0 1-1.012-.27 1.46 1.46 0 0 1-.575-.742 2.011 2.011 0 0 1-.066-1.05 2.5 2.5 0 0 1 1.283-1.781c.34-.181.721-.274 1.108-.27.355-.014.706.08 1.004.27.264.178.464.434.57.73.117.338.14.701.066 1.05a2.549 2.549 0 0 1-.443 1.05ZM48.149 14.684a.72.72 0 0 0-.555-.208.99.99 0 0 0-.63.214.858.858 0 0 0-.33.534l-.003.018a2.518 2.518 0 0 0-.232-.202 2.749 2.749 0 0 0-.787-.405 3.263 3.263 0 0 0-1.059-.16c-.613 0-1.217.15-1.757.436a4.23 4.23 0 0 0-1.42 1.204 4.065 4.065 0 0 0-.765 1.774 3.155 3.155 0 0 0 .13 1.763 2.48 2.48 0 0 0 1.002 1.203c.492.3 1.062.45 1.641.436.339.002.676-.05.998-.153.295-.093.578-.219.844-.375a3.65 3.65 0 0 0 .474-.331.589.589 0 0 0 .139.521.703.703 0 0 0 .553.215.988.988 0 0 0 .63-.215.857.857 0 0 0 .33-.534l.933-5.195a.59.59 0 0 0-.136-.54Zm-3.207 4.986c-.34.182-.721.275-1.108.27-.353.012-.7-.082-.997-.27a1.465 1.465 0 0 1-.576-.737 1.975 1.975 0 0 1-.068-1.043c.066-.38.217-.742.445-1.057.219-.305.507-.558.84-.737.336-.18.712-.273 1.095-.27.357-.013.71.082 1.01.27.269.178.471.437.577.737.116.34.138.705.065 1.057a2.514 2.514 0 0 1-1.283 1.78ZM55.382 14.69a.702.702 0 0 0-.553-.214.989.989 0 0 0-.63.215.858.858 0 0 0-.33.534l-.565 3.144a1.889 1.889 0 0 1-.321.792 1.51 1.51 0 0 1-.597.492 1.994 1.994 0 0 1-.841.165c-.468 0-.813-.109-1.035-.326-.223-.217-.286-.591-.19-1.123l.564-3.144a.594.594 0 0 0-.138-.534.705.705 0 0 0-.553-.215.99.99 0 0 0-.63.214.859.859 0 0 0-.33.535l-.644 3.586a2.24 2.24 0 0 0 .083 1.221c.13.348.375.642.696.835.37.212.792.317 1.219.302.38.003.758-.042 1.125-.136.321-.083.627-.218.904-.399a2.76 2.76 0 0 0 .345-.273l-.024.133c-.05.355-.183.693-.39.988-.184.24-.437.42-.726.516-.35.11-.714.162-1.08.153a2.232 2.232 0 0 1-.803-.128 7.524 7.524 0 0 0-.544-.19.783.783 0 0 0-.583.03 1.012 1.012 0 0 0-.486.485.537.537 0 0 0-.03.51c.112.188.29.33.5.399.25.095.512.157.778.184.307.04.616.06.925.061a5.59 5.59 0 0 0 1.842-.294 3.387 3.387 0 0 0 1.446-.964c.429-.517.705-1.14.798-1.8l.937-5.22a.594.594 0 0 0-.14-.533ZM65.948 14.69a.655.655 0 0 0-.512-.214c-.422 0-.716.156-.881.467l-2.11 3.53-.596-2.56a.638.638 0 0 0-.194-.338.676.676 0 0 0-.44-.116.963.963 0 0 0-.482.115.941.941 0 0 0-.356.339l-1.558 2.629-.84-3.6a.468.468 0 0 0-.226-.355.864.864 0 0 0-.447-.11.938.938 0 0 0-.648.233.92.92 0 0 0-.315.528.702.702 0 0 0 .004.282l1.197 5.06a.537.537 0 0 0 .283.375.783.783 0 0 0 .5.092 1.012 1.012 0 0 0 .785-.467l1.651-3.021.633 3.021a.632.632 0 0 0 .229.336.65.65 0 0 0 .389.13.992.992 0 0 0 .546-.094.969.969 0 0 0 .405-.372l3.013-5.06a.761.761 0 0 0 .106-.282.604.604 0 0 0-.136-.547ZM73.612 14.684a.72.72 0 0 0-.554-.208.989.989 0 0 0-.63.214.857.857 0 0 0-.33.534l-.004.018a2.476 2.476 0 0 0-.232-.202 2.748 2.748 0 0 0-.787-.405 3.266 3.266 0 0 0-1.058-.16c-.613 0-1.217.15-1.757.436a4.23 4.23 0 0 0-1.42 1.204 4.063 4.063 0 0 0-.766 1.775 3.153 3.153 0 0 0 .131 1.762 2.48 2.48 0 0 0 1.002 1.203c.492.3 1.062.45 1.641.436.339.002.676-.05.998-.153.295-.093.578-.219.844-.375a3.64 3.64 0 0 0 .474-.331.59.59 0 0 0 .139.521.704.704 0 0 0 .553.215.99.99 0 0 0 .63-.215.856.856 0 0 0 .33-.534l.933-5.195a.59.59 0 0 0-.136-.54Zm-3.206 4.986c-.34.182-.722.275-1.108.27-.353.012-.7-.082-.998-.27a1.466 1.466 0 0 1-.576-.737 1.976 1.976 0 0 1-.067-1.043c.065-.38.217-.742.444-1.057.22-.305.507-.557.84-.737.336-.18.713-.273 1.095-.27.357-.013.71.082 1.011.27.268.178.47.437.576.737.116.34.138.705.065 1.057a2.507 2.507 0 0 1-.442 1.043 2.471 2.471 0 0 1-.84.737ZM80.845 14.69a.705.705 0 0 0-.553-.214.99.99 0 0 0-.63.215.858.858 0 0 0-.33.534l-.564 3.144a1.89 1.89 0 0 1-.321.792 1.51 1.51 0 0 1-.598.491 1.992 1.992 0 0 1-.84.166c-.468 0-.814-.109-1.036-.326-.222-.217-.286-.591-.19-1.123l.564-3.144a.593.593 0 0 0-.137-.534.702.702 0 0 0-.554-.215.989.989 0 0 0-.63.214.856.856 0 0 0-.33.535l-.644 3.586c-.086.407-.057.83.083 1.221.13.348.376.642.697.835.369.212.791.316 1.218.301.38.005.758-.041 1.125-.135.322-.083.627-.218.904-.399.123-.082.238-.173.345-.273l-.024.133c-.05.355-.183.693-.39.988-.184.24-.437.42-.726.516-.349.11-.714.162-1.08.153a2.23 2.23 0 0 1-.802-.128 7.524 7.524 0 0 0-.544-.19.783.783 0 0 0-.583.03 1.013 1.013 0 0 0-.487.485.538.538 0 0 0-.03.51c.112.188.29.33.5.399.25.095.512.157.779.184.306.04.615.06.925.061a5.592 5.592 0 0 0 1.841-.294 3.385 3.385 0 0 0 1.446-.964c.43-.517.705-1.14.798-1.8l.938-5.22a.592.592 0 0 0-.14-.533Z",
    fill: "#F0F5FB"
  })), _path2$2n || (_path2$2n = /*#__PURE__*/createElement$2("path", {
    d: "M12.123 12.217 8 8.17a.595.595 0 0 0-.823-.008.575.575 0 0 0-.178.414v8.096a.566.566 0 0 0 .178.414.589.589 0 0 0 .426.162.58.58 0 0 0 .397-.17l4.122-4.047a.575.575 0 0 0 .171-.407.565.565 0 0 0-.171-.407Z",
    fill: "#1AAAAD"
  })), _path3$K || (_path3$K = /*#__PURE__*/createElement$2("path", {
    d: "m26.009 20.684-4.808-4.72-3.117 3.06 6.935 6.81a.584.584 0 0 0 .632.123.563.563 0 0 0 .358-.527v-4.746Z",
    fill: "#FECF2F"
  })), _path4$d || (_path4$d = /*#__PURE__*/createElement$2("path", {
    d: "M16.81 11.652a.586.586 0 0 0-.414-.169.595.595 0 0 0-.415.169l-8.809 8.645a.574.574 0 0 0-.172.406.566.566 0 0 0 .172.407l2.291 2.25a.591.591 0 0 0 .828 0l5.69-5.587a.591.591 0 0 1 .829 0l1.274 1.251 3.117-3.06-4.391-4.312Z",
    fill: "#DD2457"
  })), _path5$7 || (_path5$7 = /*#__PURE__*/createElement$2("path", {
    d: "m25.009 12.224-3.808 3.74 4.808 4.72.001-8.053a.569.569 0 0 0-.362-.533.595.595 0 0 0-.64.126Z",
    fill: "#fff"
  })));
};

var _path$7q;
function _extends$7B() { _extends$7B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7B.apply(this, arguments); }
var SvgHorizontalMediumWithout = function SvgHorizontalMediumWithout(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7B({
    width: 177,
    height: 67,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7q || (_path$7q = /*#__PURE__*/createElement$2("path", {
    d: "M79.185 31.678a5.115 5.115 0 0 0-2.003-2.453 5.97 5.97 0 0 0-3.316-.893c-.643 0-1.283.101-1.894.302a7.614 7.614 0 0 0-1.672.767 7.26 7.26 0 0 0-1.117.84l.066-.374a1.237 1.237 0 0 0-.277-1.095 1.415 1.415 0 0 0-1.113-.44c-.46-.006-.91.15-1.268.44-.35.269-.587.66-.663 1.095l-2.73 15.48a1.226 1.226 0 0 0 .275 1.107 1.44 1.44 0 0 0 1.117.428c.46.006.91-.15 1.267-.44.35-.27.588-.66.664-1.095l.836-4.739c.18.193.375.372.584.533.471.358.996.638 1.556.83a5.94 5.94 0 0 0 2.019.328 7.402 7.402 0 0 0 3.548-.894 8.6 8.6 0 0 0 2.842-2.466 8.412 8.412 0 0 0 1.54-3.636 6.569 6.569 0 0 0-.261-3.625Zm-3.815 5.776a5.018 5.018 0 0 1-1.68 1.523 4.486 4.486 0 0 1-2.215.553 3.54 3.54 0 0 1-2.034-.553 2.983 2.983 0 0 1-1.157-1.523 4.191 4.191 0 0 1-.133-2.151c.13-.776.435-1.512.892-2.152a5.036 5.036 0 0 1 1.69-1.497 4.567 4.567 0 0 1 2.229-.553 3.477 3.477 0 0 1 2.02.553c.531.365.933.89 1.147 1.497.235.693.28 1.436.133 2.152a5.283 5.283 0 0 1-.892 2.151ZM96.507 28.76a1.444 1.444 0 0 0-1.117-.428c-.461-.006-.91.15-1.268.44-.35.269-.587.66-.663 1.095l-.007.037a4.985 4.985 0 0 0-.467-.415 5.492 5.492 0 0 0-1.583-.83 6.45 6.45 0 0 0-2.13-.327 7.426 7.426 0 0 0-3.534.893 8.549 8.549 0 0 0-2.857 2.466 8.41 8.41 0 0 0-1.54 3.636 6.574 6.574 0 0 0 .262 3.611 5.063 5.063 0 0 0 2.015 2.467c.99.612 2.138.923 3.302.893a6.375 6.375 0 0 0 2.007-.315 8.189 8.189 0 0 0 1.7-.767c.335-.2.653-.428.952-.68a1.227 1.227 0 0 0 .28 1.07 1.41 1.41 0 0 0 1.113.44c.46.006.91-.15 1.268-.44.35-.269.587-.66.663-1.095l1.877-10.644a1.23 1.23 0 0 0-.273-1.107Zm-6.453 10.217a4.565 4.565 0 0 1-2.229.553c-.71.024-1.41-.17-2.006-.553a3 3 0 0 1-1.16-1.51 4.119 4.119 0 0 1-.135-2.14c.131-.78.437-1.52.894-2.164a5.01 5.01 0 0 1 1.691-1.51 4.514 4.514 0 0 1 2.202-.554 3.545 3.545 0 0 1 2.034.554c.54.364.947.894 1.159 1.51.233.697.278 1.444.13 2.165a5.196 5.196 0 0 1-.889 2.139 5.01 5.01 0 0 1-1.69 1.51ZM111.059 28.772a1.418 1.418 0 0 0-1.113-.44 1.967 1.967 0 0 0-1.268.44c-.35.269-.587.66-.663 1.095l-1.136 6.442a3.927 3.927 0 0 1-.647 1.624c-.306.434-.72.781-1.201 1.006a3.95 3.95 0 0 1-1.693.34c-.942 0-1.636-.222-2.083-.667-.448-.445-.576-1.212-.383-2.303l1.136-6.442a1.24 1.24 0 0 0-.278-1.094 1.415 1.415 0 0 0-1.113-.44c-.461-.007-.91.149-1.267.44-.35.268-.588.66-.664 1.094l-1.296 7.348a4.68 4.68 0 0 0 .168 2.504 3.38 3.38 0 0 0 1.4 1.71 4.538 4.538 0 0 0 2.452.617 8.643 8.643 0 0 0 2.263-.276 6.064 6.064 0 0 0 1.819-.818c.246-.168.478-.355.694-.56l-.048.271a4.679 4.679 0 0 1-.786 2.026 3.05 3.05 0 0 1-1.46 1.057 6.626 6.626 0 0 1-2.173.314 4.413 4.413 0 0 1-1.614-.264c-.45-.176-.814-.306-1.094-.39a1.546 1.546 0 0 0-1.173.063 2.057 2.057 0 0 0-.979.994 1.116 1.116 0 0 0-.06 1.045c.224.386.582.677 1.005.817a6.11 6.11 0 0 0 1.567.378c.617.081 1.238.124 1.861.126 1.26.011 2.513-.193 3.705-.604a6.803 6.803 0 0 0 2.909-1.976 7.451 7.451 0 0 0 1.605-3.687l1.887-10.695a1.242 1.242 0 0 0-.279-1.095ZM132.318 28.772a1.319 1.319 0 0 0-1.03-.44c-.849 0-1.44.319-1.774.956l-4.243 7.236-1.201-5.248a1.312 1.312 0 0 0-.39-.692 1.34 1.34 0 0 0-.886-.239 1.909 1.909 0 0 0-1.686.931l-3.133 5.388-1.692-7.375a.975.975 0 0 0-.453-.73 1.71 1.71 0 0 0-.901-.226 1.866 1.866 0 0 0-1.302.478c-.328.278-.552.66-.634 1.082-.036.192-.033.389.009.579l2.407 10.367a1.115 1.115 0 0 0 .57.768c.304.175.658.242 1.005.189a2.01 2.01 0 0 0 1.58-.957l3.321-6.19 1.274 6.19a1.297 1.297 0 0 0 1.243.957 1.963 1.963 0 0 0 1.913-.957l6.063-10.367a1.534 1.534 0 0 0 .213-.579 1.26 1.26 0 0 0-.273-1.121ZM147.737 28.76a1.431 1.431 0 0 0-1.114-.428c-.461-.006-.91.15-1.268.44a1.76 1.76 0 0 0-.664 1.095l-.006.037a5.088 5.088 0 0 0-.467-.415 5.495 5.495 0 0 0-1.584-.83 6.448 6.448 0 0 0-2.129-.327 7.422 7.422 0 0 0-3.534.893 8.55 8.55 0 0 0-2.858 2.466 8.412 8.412 0 0 0-1.541 3.636 6.593 6.593 0 0 0 .263 3.611 5.067 5.067 0 0 0 2.015 2.467 5.988 5.988 0 0 0 3.303.893 6.377 6.377 0 0 0 2.007-.315 8.162 8.162 0 0 0 1.699-.767c.335-.2.654-.428.953-.68a1.224 1.224 0 0 0 .279 1.07 1.416 1.416 0 0 0 1.113.44c.461.006.91-.15 1.268-.44.35-.269.587-.66.664-1.095l1.877-10.644a1.228 1.228 0 0 0-.276-1.107Zm-6.452 10.217a4.562 4.562 0 0 1-2.229.553 3.49 3.49 0 0 1-2.006-.553 2.999 2.999 0 0 1-1.159-1.51 4.125 4.125 0 0 1-.136-2.14c.131-.78.437-1.52.894-2.164a5.007 5.007 0 0 1 1.692-1.51 4.51 4.51 0 0 1 2.201-.554 3.545 3.545 0 0 1 2.034.554 3 3 0 0 1 1.159 1.51c.233.697.278 1.444.131 2.165a5.197 5.197 0 0 1-.89 2.139 5.007 5.007 0 0 1-1.691 1.51ZM162.289 28.772a1.414 1.414 0 0 0-1.112-.44c-.461-.006-.91.15-1.268.44a1.76 1.76 0 0 0-.664 1.095l-1.136 6.442a3.911 3.911 0 0 1-.646 1.624c-.306.434-.72.781-1.202 1.006a3.945 3.945 0 0 1-1.691.34c-.942 0-1.636-.222-2.084-.667-.447-.445-.575-1.212-.383-2.303l1.137-6.442a1.24 1.24 0 0 0-.278-1.094 1.413 1.413 0 0 0-1.112-.44c-.461-.007-.91.149-1.268.44a1.76 1.76 0 0 0-.664 1.094l-1.296 7.348c-.173.835-.115 1.7.168 2.504a3.375 3.375 0 0 0 1.4 1.71 4.539 4.539 0 0 0 2.452.617 8.643 8.643 0 0 0 2.263-.276 6.064 6.064 0 0 0 1.819-.818c.246-.168.478-.355.694-.56l-.048.271a4.692 4.692 0 0 1-.786 2.026 3.05 3.05 0 0 1-1.46 1.057 6.626 6.626 0 0 1-2.173.314 4.411 4.411 0 0 1-1.614-.264 14.787 14.787 0 0 0-1.094-.39 1.545 1.545 0 0 0-1.173.063 2.06 2.06 0 0 0-.979.994 1.116 1.116 0 0 0-.059 1.045c.223.386.581.677 1.004.817.504.195 1.03.322 1.567.378.617.081 1.238.123 1.86.126a11.068 11.068 0 0 0 3.706-.604 6.807 6.807 0 0 0 2.909-1.976 7.452 7.452 0 0 0 1.605-3.687l1.886-10.695a1.242 1.242 0 0 0-.28-1.095ZM24.024 23.703l-8.293-8.293a1.179 1.179 0 0 0-2.013.833v16.588a1.18 1.18 0 0 0 1.216 1.18c.3-.007.586-.132.797-.347l8.293-8.293a1.18 1.18 0 0 0 0-1.668Zm-.784 1.193-7.766 7.767a.508.508 0 0 1-.867-.359V16.77a.508.508 0 0 1 .867-.359l7.767 7.767a.508.508 0 0 1 0 .718ZM51.961 24.55a1.18 1.18 0 0 0-2.012-.833l-7.66 7.663-8.837-8.835a1.178 1.178 0 0 0-1.666 0L14.063 40.258a1.178 1.178 0 0 0 0 1.667l4.61 4.61a1.178 1.178 0 0 0 1.666 0l11.447-11.448a1.18 1.18 0 0 1 1.666 0L49.97 51.604a1.168 1.168 0 0 0 1.993-.826l-.002-26.227Zm-1.755.167a.508.508 0 0 1 .866.36v15.088l-8.156-8.157 7.29-7.29ZM34.08 34.46a2.067 2.067 0 0 0-2.923 0L19.865 45.752a.506.506 0 0 1-.719 0l-4.3-4.301a.508.508 0 0 1 0-.718L32.26 23.328a.51.51 0 0 1 .718 0l8.681 8.682-5.011 5.015-2.567-2.566Zm16.126 16.126L37.275 37.653l5.012-5.017 8.785 8.786.002 8.804a.507.507 0 0 1-.867.359Z",
    fill: "#fff"
  })));
};

var _path$7r;
function _extends$7C() { _extends$7C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7C.apply(this, arguments); }
var SvgHorizontalSmallWithout = function SvgHorizontalSmallWithout(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7C({
    width: 88,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7r || (_path$7r = /*#__PURE__*/createElement$2("path", {
    d: "M40.092 16.339a2.558 2.558 0 0 0-1.001-1.227 2.986 2.986 0 0 0-1.658-.446c-.322 0-.642.05-.947.15a3.813 3.813 0 0 0-1.395.804l.033-.187a.62.62 0 0 0-.138-.547.708.708 0 0 0-.557-.22.984.984 0 0 0-.634.22.881.881 0 0 0-.331.547l-1.365 7.74a.613.613 0 0 0 .137.554.72.72 0 0 0 .559.214.985.985 0 0 0 .633-.22.882.882 0 0 0 .332-.547l.418-2.37c.09.097.188.186.292.266.236.18.498.32.778.415a2.97 2.97 0 0 0 1.01.164 3.7 3.7 0 0 0 1.774-.446 4.298 4.298 0 0 0 1.42-1.234c.398-.536.662-1.16.771-1.818a3.285 3.285 0 0 0-.13-1.812Zm-1.907 2.888a2.509 2.509 0 0 1-.84.761c-.34.186-.72.282-1.108.277a1.77 1.77 0 0 1-1.017-.277 1.492 1.492 0 0 1-.578-.761 2.097 2.097 0 0 1-.067-1.076c.065-.387.218-.756.446-1.075.221-.31.51-.567.845-.75a2.283 2.283 0 0 1 1.114-.276c.358-.014.71.083 1.01.277.266.182.467.444.574.748.118.347.14.718.067 1.076-.067.388-.22.755-.446 1.076ZM48.754 14.88a.723.723 0 0 0-.559-.214.983.983 0 0 0-.634.22.88.88 0 0 0-.331.547l-.004.019a2.52 2.52 0 0 0-.233-.208c-.24-.18-.507-.32-.792-.415a3.226 3.226 0 0 0-1.064-.163c-.617 0-1.225.153-1.768.446-.562.3-1.05.721-1.428 1.233a4.205 4.205 0 0 0-.77 1.819 3.287 3.287 0 0 0 .13 1.805c.195.509.548.941 1.008 1.233.495.306 1.07.462 1.651.447.341.001.68-.052 1.004-.158.297-.095.582-.223.85-.383.167-.1.326-.214.476-.34a.615.615 0 0 0 .14.535.705.705 0 0 0 .556.22.984.984 0 0 0 .634-.22.882.882 0 0 0 .332-.548l.939-5.322a.615.615 0 0 0-.137-.553Zm-3.227 5.108c-.342.186-.725.281-1.114.277a1.745 1.745 0 0 1-1.003-.277 1.5 1.5 0 0 1-.58-.755 2.059 2.059 0 0 1-.068-1.07c.066-.39.219-.76.447-1.082.22-.313.51-.571.846-.755.337-.184.716-.28 1.1-.277.36-.013.714.084 1.017.277a1.5 1.5 0 0 1 .58.755c.117.349.14.722.065 1.083a2.597 2.597 0 0 1-.444 1.07c-.22.312-.51.57-.846.754ZM56.03 14.886a.707.707 0 0 0-.557-.22.983.983 0 0 0-.634.22.881.881 0 0 0-.332.547l-.568 3.221a1.96 1.96 0 0 1-.323.812c-.153.217-.36.391-.6.504a1.975 1.975 0 0 1-.847.17c-.471 0-.818-.112-1.042-.334-.224-.222-.288-.606-.192-1.151l.569-3.221a.619.619 0 0 0-.14-.548.708.708 0 0 0-.555-.22.983.983 0 0 0-.634.22.881.881 0 0 0-.332.548l-.648 3.674c-.087.417-.058.85.084 1.252.13.355.377.656.7.855.37.217.796.324 1.226.308a4.32 4.32 0 0 0 1.132-.138c.323-.085.63-.224.909-.41.123-.083.239-.176.347-.279l-.024.136c-.05.363-.185.71-.393 1.013-.185.245-.44.43-.73.528-.351.112-.718.166-1.087.157a2.209 2.209 0 0 1-.807-.132 7.382 7.382 0 0 0-.547-.195.773.773 0 0 0-.586.032c-.216.103-.39.279-.49.497a.557.557 0 0 0-.03.522c.112.193.291.338.503.409.252.097.515.16.783.189.309.04.62.061.93.062a5.534 5.534 0 0 0 1.853-.302 3.402 3.402 0 0 0 1.455-.987c.431-.53.709-1.168.802-1.844l.944-5.347a.62.62 0 0 0-.14-.548ZM66.659 14.886a.658.658 0 0 0-.515-.22c-.424 0-.72.16-.887.478l-2.121 3.618-.6-2.624a.656.656 0 0 0-.196-.346.67.67 0 0 0-.443-.12.955.955 0 0 0-.843.466l-1.566 2.694-.846-3.688a.489.489 0 0 0-.227-.365.857.857 0 0 0-.45-.113.934.934 0 0 0-.651.24.947.947 0 0 0-.317.54.73.73 0 0 0 .004.29l1.204 5.184a.554.554 0 0 0 .285.383c.152.088.329.121.502.095a1.004 1.004 0 0 0 .79-.478l1.661-3.096.637 3.096a.647.647 0 0 0 .621.478.982.982 0 0 0 .957-.478l3.031-5.184a.772.772 0 0 0 .107-.29.632.632 0 0 0-.137-.56ZM74.369 14.88a.72.72 0 0 0-.557-.214.983.983 0 0 0-.634.22.881.881 0 0 0-.332.547l-.004.019a2.533 2.533 0 0 0-.233-.208c-.24-.18-.507-.32-.792-.415a3.221 3.221 0 0 0-1.064-.163c-.617 0-1.225.153-1.768.446-.562.3-1.05.721-1.428 1.233a4.205 4.205 0 0 0-.77 1.819 3.289 3.289 0 0 0 .13 1.805 2.53 2.53 0 0 0 1.008 1.233c.496.306 1.07.462 1.652.447.34.001.68-.052 1.003-.158.297-.095.582-.223.85-.383.167-.1.327-.214.476-.34a.614.614 0 0 0 .14.535.707.707 0 0 0 .556.22.983.983 0 0 0 .634-.22.883.883 0 0 0 .332-.548l.939-5.322a.615.615 0 0 0-.138-.553Zm-3.226 5.108a2.282 2.282 0 0 1-1.115.277 1.745 1.745 0 0 1-1.003-.277 1.5 1.5 0 0 1-.58-.755 2.065 2.065 0 0 1-.067-1.07c.065-.39.218-.76.447-1.082.22-.313.51-.571.846-.755.337-.184.716-.28 1.1-.277.36-.013.714.084 1.017.277.27.182.474.447.58.755.116.349.139.722.065 1.083a2.603 2.603 0 0 1-.445 1.07c-.22.312-.51.57-.845.754ZM81.645 14.886a.706.706 0 0 0-.556-.22.983.983 0 0 0-.635.22.881.881 0 0 0-.331.547l-.568 3.221a1.96 1.96 0 0 1-.324.812c-.153.217-.36.39-.6.503a1.975 1.975 0 0 1-.846.17c-.47 0-.818-.11-1.042-.333-.224-.223-.287-.606-.191-1.151l.568-3.221a.618.618 0 0 0-.139-.548.707.707 0 0 0-.556-.22.984.984 0 0 0-.634.22.882.882 0 0 0-.332.548l-.648 3.674c-.087.417-.058.85.084 1.251.13.356.377.657.7.856.371.217.796.324 1.226.308.382.004.762-.042 1.132-.138.323-.085.63-.224.909-.41.123-.083.239-.176.347-.279l-.024.136c-.05.363-.184.71-.393 1.013-.184.245-.439.43-.73.528-.35.112-.718.165-1.086.157a2.206 2.206 0 0 1-.807-.132 7.406 7.406 0 0 0-.547-.195.773.773 0 0 0-.587.032c-.216.103-.39.279-.49.497a.556.556 0 0 0-.03.522c.113.193.291.338.503.409.252.097.515.16.783.188.309.041.62.062.93.063a5.534 5.534 0 0 0 1.853-.302 3.405 3.405 0 0 0 1.455-.987 3.73 3.73 0 0 0 .803-1.844l.943-5.347a.618.618 0 0 0-.14-.548ZM12.512 12.352 8.365 8.205a.578.578 0 0 0-.63-.134.59.59 0 0 0-.376.55v8.295a.589.589 0 0 0 1.006.416l4.147-4.147a.59.59 0 0 0 0-.833Zm-.392.596-3.883 3.883a.254.254 0 0 1-.434-.179V8.885a.254.254 0 0 1 .434-.18l3.883 3.884a.253.253 0 0 1 0 .36ZM26.48 12.775a.59.59 0 0 0-1.006-.416l-3.83 3.83-4.418-4.417a.589.589 0 0 0-.833 0L7.531 20.63a.589.589 0 0 0 0 .833l2.305 2.305a.59.59 0 0 0 .833 0l5.724-5.724a.59.59 0 0 1 .833 0l8.259 8.26a.584.584 0 0 0 .997-.414l-.001-13.114Zm-.877.084a.254.254 0 0 1 .433.18v7.543l-4.078-4.078 3.645-3.645Zm-8.063 4.87a1.033 1.033 0 0 0-1.461 0l-5.647 5.647a.253.253 0 0 1-.359 0l-2.15-2.15a.254.254 0 0 1 0-.36l8.707-8.702a.251.251 0 0 1 .277-.055c.03.012.058.031.082.055l4.34 4.34-2.505 2.508-1.284-1.283Zm8.064 8.063-6.466-6.466 2.505-2.508 4.393 4.393.001 4.402a.254.254 0 0 1-.433.18Z",
    fill: "#fff"
  })));
};

var _path$7s;
function _extends$7D() { _extends$7D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7D.apply(this, arguments); }
var SvgIsotypeLargeFull = function SvgIsotypeLargeFull(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7D({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7s || (_path$7s = /*#__PURE__*/createElement$2("path", {
    d: "m24.623 24.23-6.939-6.939a.986.986 0 0 0-1.684.697v13.88a.986.986 0 0 0 1.684.696l6.94-6.939a.986.986 0 0 0 0-1.395Zm-.655.998-6.499 6.499a.425.425 0 0 1-.725-.3V18.428a.425.425 0 0 1 .725-.3l6.499 6.498a.424.424 0 0 1 0 .601ZM47.998 24.94a.987.987 0 0 0-1.684-.698l-6.408 6.411-7.394-7.392a.986.986 0 0 0-1.394 0l-14.83 14.82a.985.985 0 0 0 0 1.395l3.857 3.857a.986.986 0 0 0 1.395 0l9.578-9.578a.985.985 0 0 1 1.394 0l13.82 13.82A.978.978 0 0 0 48 46.884l-.002-21.945Zm-1.468.139a.425.425 0 0 1 .725.3v12.625l-6.825-6.826 6.1-6.1Zm-13.492 8.15a1.727 1.727 0 0 0-2.446 0l-9.449 9.449a.424.424 0 0 1-.6 0l-3.6-3.599a.425.425 0 0 1 0-.6l14.571-14.563a.426.426 0 0 1 .601 0l7.264 7.264-4.194 4.196-2.147-2.147ZM46.53 46.722l-10.82-10.82 4.193-4.198 7.35 7.351.002 7.367a.425.425 0 0 1-.725.3Z",
    fill: "#023F80"
  })));
};

var _path$7t;
function _extends$7E() { _extends$7E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7E.apply(this, arguments); }
var SvgIsotypeMediumFull = function SvgIsotypeMediumFull(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7E({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7t || (_path$7t = /*#__PURE__*/createElement$2("path", {
    d: "M10.467 10.423 5.263 5.218A.74.74 0 0 0 4 5.741v10.41a.74.74 0 0 0 1.263.522l5.204-5.204a.74.74 0 0 0 0-1.046Zm-.491.748-4.874 4.874a.318.318 0 0 1-.544-.225V6.072a.318.318 0 0 1 .544-.225l4.874 4.873a.319.319 0 0 1 0 .451ZM27.999 10.954a.74.74 0 0 0-1.263-.523l-4.807 4.809-5.545-5.544a.74.74 0 0 0-1.046 0L4.217 20.81a.74.74 0 0 0 0 1.046l2.892 2.893a.74.74 0 0 0 1.046 0l7.183-7.184a.742.742 0 0 1 1.046 0l10.365 10.365A.733.733 0 0 0 28 27.413l-.001-16.459Zm-1.102.105a.32.32 0 0 1 .544.225v9.469l-5.118-5.12 4.574-4.574Zm-10.119 6.113a1.296 1.296 0 0 0-1.834 0l-7.087 7.087a.318.318 0 0 1-.45 0l-2.7-2.7a.317.317 0 0 1 0-.45l10.929-10.922a.32.32 0 0 1 .45 0l5.448 5.448-3.145 3.147-1.61-1.61Zm10.12 10.12-8.115-8.116 3.145-3.148 5.513 5.514.001 5.524a.318.318 0 0 1-.544.226Z",
    fill: "#023F80"
  })));
};

var _path$7u;
function _extends$7F() { _extends$7F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7F.apply(this, arguments); }
var SvgIsotypeSmallFull = function SvgIsotypeSmallFull(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7F({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7u || (_path$7u = /*#__PURE__*/createElement$2("path", {
    d: "m8.312 7.615-3.47-3.47a.484.484 0 0 0-.527-.112.493.493 0 0 0-.315.461v6.94a.493.493 0 0 0 .842.348l3.47-3.47a.493.493 0 0 0 0-.697Zm-.328.5-3.25 3.248a.213.213 0 0 1-.362-.15V4.715a.212.212 0 0 1 .363-.15l3.249 3.249a.212.212 0 0 1 0 .3ZM20 7.97a.493.493 0 0 0-.843-.35l-3.204 3.207-3.697-3.697a.493.493 0 0 0-.697 0l-7.415 7.41a.493.493 0 0 0 0 .698l1.929 1.928a.493.493 0 0 0 .697 0l4.789-4.789a.493.493 0 0 1 .697 0l6.91 6.91a.488.488 0 0 0 .834-.345V7.97Zm-.735.07a.213.213 0 0 1 .362.15v6.312l-3.412-3.413 3.05-3.05Zm-6.746 4.075a.866.866 0 0 0-1.223 0l-4.724 4.724a.213.213 0 0 1-.301 0l-1.8-1.8a.212.212 0 0 1 0-.3l7.286-7.281a.212.212 0 0 1 .3 0l3.632 3.632-2.096 2.098-1.074-1.074Zm6.746 6.746-5.41-5.41 2.097-2.099 3.675 3.676.001 3.683a.212.212 0 0 1-.363.15Z",
    fill: "#023F80"
  })));
};

var _path$7v, _path2$2o, _path3$L;
function _extends$7G() { _extends$7G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7G.apply(this, arguments); }
var SvgIsotypeLargeWithout = function SvgIsotypeLargeWithout(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7G({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7v || (_path$7v = /*#__PURE__*/createElement$2("path", {
    d: "m24.623 23.87-6.939-7.31a.944.944 0 0 0-1.054-.236.982.982 0 0 0-.33.223c-.096.097-.171.213-.223.342a1.087 1.087 0 0 0-.077.406v14.62c0 .14.026.278.078.407.05.128.126.244.221.341a.98.98 0 0 0 .331.224.942.942 0 0 0 1.054-.237l6.94-7.31c.184-.195.288-.46.288-.735 0-.275-.104-.54-.289-.735ZM47.998 39.161l-8.095-8.525-5.247 5.528 11.673 12.297c.137.144.31.242.5.281.19.04.386.02.565-.059a.99.99 0 0 0 .438-.379c.108-.169.165-.368.165-.571V39.16Z",
    fill: "#fff"
  })), _path2$2o || (_path2$2o = /*#__PURE__*/createElement$2("path", {
    d: "M32.512 22.85a.961.961 0 0 0-.697-.305.962.962 0 0 0-.697.304L16.29 38.462a1.086 1.086 0 0 0 0 1.469l3.856 4.062c.092.097.2.173.32.225a.942.942 0 0 0 1.074-.225l9.579-10.09a.981.981 0 0 1 .32-.225.942.942 0 0 1 1.074.225l2.145 2.26 5.248-5.527-7.393-7.787Z",
    fill: "#fff"
  })), _path3$L || (_path3$L = /*#__PURE__*/createElement$2("path", {
    d: "m46.315 23.883-6.412 6.753 8.095 8.525L48 24.617c0-.205-.058-.406-.166-.577a1 1 0 0 0-.443-.383.94.94 0 0 0-.57-.06.973.973 0 0 0-.506.286Z",
    fill: "#fff"
  })));
};

var _path$7w, _path2$2p, _path3$M;
function _extends$7H() { _extends$7H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7H.apply(this, arguments); }
var SvgIsotypeMediumWithout = function SvgIsotypeMediumWithout(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7H({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7w || (_path$7w = /*#__PURE__*/createElement$2("path", {
    d: "M10.467 9.712 5.263 4.23a.708.708 0 0 0-.79-.178.736.736 0 0 0-.249.168.815.815 0 0 0-.224.56v10.966a.815.815 0 0 0 .224.561c.072.073.156.13.249.168a.704.704 0 0 0 .79-.178l5.204-5.482a.8.8 0 0 0 .217-.551.8.8 0 0 0-.217-.552ZM27.998 21.18l-6.07-6.393-3.936 4.146 8.755 9.222a.723.723 0 0 0 .375.211c.142.03.29.015.424-.044a.744.744 0 0 0 .328-.284.802.802 0 0 0 .124-.429V21.18Z",
    fill: "#fff"
  })), _path2$2p || (_path2$2p = /*#__PURE__*/createElement$2("path", {
    d: "M16.384 8.947a.72.72 0 0 0-.522-.228.72.72 0 0 0-.523.228L4.217 20.657a.784.784 0 0 0-.217.55.816.816 0 0 0 .217.551l2.892 3.047c.069.072.15.13.24.168a.708.708 0 0 0 .806-.168l7.183-7.568a.707.707 0 0 1 1.046 0l1.61 1.695 3.935-4.145-5.545-5.84Z",
    fill: "#fff"
  })), _path3$M || (_path3$M = /*#__PURE__*/createElement$2("path", {
    d: "m26.737 9.722-4.81 5.065 6.071 6.393L28 10.273a.81.81 0 0 0-.125-.434.75.75 0 0 0-.332-.287.705.705 0 0 0-.427-.044.729.729 0 0 0-.38.214Z",
    fill: "#fff"
  })));
};

var _path$7x, _path2$2q, _path3$N;
function _extends$7I() { _extends$7I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7I.apply(this, arguments); }
var SvgIsotypeSmallWithout = function SvgIsotypeSmallWithout(props) {
  return /*#__PURE__*/createElement$2("svg", _extends$7I({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7x || (_path$7x = /*#__PURE__*/createElement$2("path", {
    d: "m8.312 7.808-3.47-3.655a.472.472 0 0 0-.692-.006.521.521 0 0 0-.15.373v7.311a.544.544 0 0 0 .15.374.492.492 0 0 0 .359.146.472.472 0 0 0 .333-.153l3.47-3.655a.534.534 0 0 0 .144-.367.534.534 0 0 0-.144-.368ZM19.999 15.454l-4.047-4.263-2.624 2.764 5.837 6.149a.465.465 0 0 0 .532.111.494.494 0 0 0 .22-.19.534.534 0 0 0 .082-.285v-4.286Z",
    fill: "#fff"
  })), _path2$2q || (_path2$2q = /*#__PURE__*/createElement$2("path", {
    d: "M12.256 7.298a.48.48 0 0 0-.348-.152.48.48 0 0 0-.349.152l-7.414 7.806a.522.522 0 0 0-.145.368.543.543 0 0 0 .145.367l1.928 2.03a.493.493 0 0 0 .348.153.473.473 0 0 0 .349-.152l4.789-5.045a.493.493 0 0 1 .348-.152.471.471 0 0 1 .349.152l1.073 1.13 2.624-2.764-3.697-3.893Z",
    fill: "#fff"
  })), _path3$N || (_path3$N = /*#__PURE__*/createElement$2("path", {
    d: "m19.158 7.814-3.206 3.377 4.047 4.263L20 8.182a.538.538 0 0 0-.083-.29.5.5 0 0 0-.222-.19.47.47 0 0 0-.537.112Z",
    fill: "#fff"
  })));
};

var LogoSource = {
  verticalMediumFull: SvgVerticalMediumFull,
  verticalSmallFull: SvgVerticalSmallFull,
  verticalMediumInverted: SvgVerticalMediumInverted,
  verticalSmallInverted: SvgVerticalSmallInverted,
  verticalMediumWithout: SvgVerticalMediumWithout,
  verticalSmallWithout: SvgVerticalSmallWithout,
  horizontalMediumFull: SvgHorizontalMediumFull,
  horizontalSmallFull: SvgHorizontalSmallFull,
  horizontalMediumInverted: SvgHorizontalMediumInverted,
  horizontalSmallInverted: SvgHorizontalSmallInverted,
  horizontalMediumWithout: SvgHorizontalMediumWithout,
  horizontalSmallWithout: SvgHorizontalSmallWithout,
  isotypeLargeFull: SvgIsotypeLargeFull,
  isotypeMediumFull: SvgIsotypeMediumFull,
  isotypeSmallFull: SvgIsotypeSmallFull,
  isotypeLargeWithout: SvgIsotypeLargeWithout,
  isotypeMediumWithout: SvgIsotypeMediumWithout,
  isotypeSmallWithout: SvgIsotypeSmallWithout
};

var Logo$1 = function Logo$1(_ref) {
  var cursor = _ref.cursor,
    size = _ref.size,
    type = _ref.type,
    onClick = _ref.onClick,
    variant = _ref.variant;
  size = (type === 'horizontal' || type === 'vertical') && size === 'large' ? 'medium' : size;
  var CurrentIcon = LogoSource["".concat(type).concat(capitalize(size)).concat(capitalize(variant))] || false;
  return CurrentIcon && /*#__PURE__*/React__default.createElement(Logo, {
    cursor: cursor,
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(CurrentIcon, null));
};
Logo$1.defaultProps = {
  size: 'medium',
  cursor: 'default',
  type: 'horizontal',
  variant: 'full'
};
Logo$1.propTypes = {
  size: PropTypes.oneOf(['medium', 'small', 'large']),
  type: PropTypes.oneOf(['horizontal', 'vertical', 'isotype']),
  cursor: PropTypes.oneOf(['not-allowed', 'pointer', 'default', 'none']),
  variant: PropTypes.oneOf(['full', 'inverted', 'without']),
  onClick: PropTypes.func
};

var useDraggableInputFile = function useDraggableInputFile(setValue, fileTypes, maxFileSize, inputSize) {
  var _INVALID_FILE_SIZE, _INVALID_FILE_TYPE;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showFileNameArea = _useState2[0],
    setShowFileNameArea = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    touched = _useState4[0],
    setTouched = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showErrorMessage = _useState6[0],
    setShowErrorMessage = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];
  var _useState9 = useState({
      name: '',
      size: 0
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    fileData = _useState10[0],
    setFileData = _useState10[1];
  var inputFileRef = useRef(null);
  var errorMessages = {
    INVALID_FILE_SIZE: (_INVALID_FILE_SIZE = {}, _defineProperty(_INVALID_FILE_SIZE, MEDIUM_COMPONENT_SIZE, 'El archivo supera el peso máximo. Por favor, volvé a intentarlo.'), _defineProperty(_INVALID_FILE_SIZE, SMALL_COMPONENT_SIZE, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "El archivo supera el peso m\xE1ximo.", /*#__PURE__*/React__default.createElement("br", null), "Por favor, volv\xE9 a intentarlo.")), _INVALID_FILE_SIZE),
    INVALID_FILE_TYPE: (_INVALID_FILE_TYPE = {}, _defineProperty(_INVALID_FILE_TYPE, MEDIUM_COMPONENT_SIZE, 'Tipo de archivo no soportado. Por favor, volvé a intentarlo.'), _defineProperty(_INVALID_FILE_TYPE, SMALL_COMPONENT_SIZE, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Tipo de archivo no soportado.", /*#__PURE__*/React__default.createElement("br", null), "Por favor, volv\xE9 a intentarlo.")), _INVALID_FILE_TYPE)
  };
  var supportedTypes = fileTypes.map(function (type) {
    return MIME_TYPES_MAP[type];
  });
  var getFileSizeInMB = function getFileSizeInMB(fileSize) {
    return (fileSize / MB).toFixed(2);
  };
  var handleFile = function handleFile(file) {
    setValue(file);
    setFileData({
      name: file.name,
      size: getFileSizeInMB(file.size)
    });
    setShowFileNameArea(true);
  };
  var showError = function showError() {
    setValue(null);
    setFileData({});
    setShowFileNameArea(false);
    setShowErrorMessage(true);
  };
  var deleteAttachedFile = function deleteAttachedFile() {
    setValue(null);
    setFileData({});
    setShowFileNameArea(false);
    setShowErrorMessage(false);
    setErrorMessage(REQUIRED_KEY);
  };
  var validFileType = function validFileType(file) {
    if (supportedTypes.includes(file === null || file === void 0 ? void 0 : file.type)) {
      return true;
    } else {
      setErrorMessage(errorMessages.INVALID_FILE_TYPE[inputSize]);
      return false;
    }
  };
  var validFileSize = function validFileSize(file) {
    if (getFileSizeInMB(file.size) <= maxFileSize) {
      return true;
    } else {
      setErrorMessage(errorMessages.INVALID_FILE_SIZE[inputSize]);
      return false;
    }
  };
  var removeDragData = function removeDragData(ev) {
    var _ev$dataTransfer$item;
    (_ev$dataTransfer$item = ev.dataTransfer.items) === null || _ev$dataTransfer$item === void 0 ? void 0 : _ev$dataTransfer$item.clear();
    ev.dataTransfer.clearData();
  };
  var removeInputFileData = function removeInputFileData() {
    inputFileRef.current.value = '';
  };
  var dragOverHandler = function dragOverHandler(ev) {
    ev.preventDefault();
  };
  var dropHandler = function dropHandler(ev) {
    ev.preventDefault();
    setTouched(true);
    _toConsumableArray(ev.dataTransfer.items).map(function (dataTransferItem) {
      if (dataTransferItem.kind === 'file') {
        var file = dataTransferItem.getAsFile();
        if (validFileType(file) && validFileSize(file)) {
          handleFile(file);
        } else {
          showError();
        }
      }
    });
    removeDragData(ev);
  };
  var handleInputFileClick = function handleInputFileClick(ev) {
    ev.preventDefault();
    setTouched(true);
    var file = inputFileRef.current.files[0];
    if (validFileType(file) && validFileSize(file)) {
      handleFile(file);
    } else {
      showError();
    }
    removeInputFileData();
  };
  var handleDeleteClick = function handleDeleteClick() {
    deleteAttachedFile();
  };
  return [touched, inputFileRef, showFileNameArea, fileData, dragOverHandler, dropHandler, handleInputFileClick, handleDeleteClick, showErrorMessage, errorMessage];
};

var _templateObject$Z, _templateObject2$R, _templateObject3$J, _templateObject4$B, _templateObject5$w, _templateObject6$s, _templateObject7$n, _templateObject8$i, _templateObject9$g, _templateObject10$f, _templateObject11$e, _templateObject12$9, _templateObject13$8, _templateObject14$6, _templateObject15$6, _templateObject16$5, _templateObject17$5, _templateObject18$5, _templateObject19$3, _templateObject20$3;
var DragAndDropWrapper = styled.div(_templateObject$Z || (_templateObject$Z = _taggedTemplateLiteral([""])));
var DragAndDrop = styled.div(_templateObject2$R || (_templateObject2$R = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  border: dashed 1px ", ";\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n\n  ", "\n\n  ", ";\n\n  ", "\n"])), theme.borderRadius['border-radius-3'], theme.colors.neutral.border.weak, theme.colors.neutral.bg.weak, function (_ref) {
  var status = _ref.status;
  if (status === 'error') {
    return css$1(_templateObject3$J || (_templateObject3$J = _taggedTemplateLiteral(["\n        border: dashed 1px ", ";\n      "])), theme.colors.danger.border.regular);
  }
}, function (_ref2) {
  var size = _ref2.size;
  return getSize$4(size);
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled && getDisabled$1();
});
var DropBaseIcon = styled.div(_templateObject4$B || (_templateObject4$B = _taggedTemplateLiteral(["\n  padding: ", ";\n  margin: ", ";\n  ", "\n"])), theme.spacing['spacing-6'], theme.spacing['spacing-2'], function (_ref4) {
  var size = _ref4.size;
  return size === SMALL_COMPONENT_SIZE && css$1(_templateObject5$w || (_templateObject5$w = _taggedTemplateLiteral(["\n      padding: ", ";\n      margin: ", ";\n    "])), theme.spacing['spacing-5'], theme.spacing['spacing-0']);
});
var SuccessIcon = styled.div(_templateObject6$s || (_templateObject6$s = _taggedTemplateLiteral(["\n  padding: ", " ", "\n    ", " ", ";\n  margin: ", ";\n\n  ", "\n"])), theme.spacing['spacing-6'], theme.spacing['spacing-3'], theme.spacing['spacing-6'], theme.spacing['spacing-6'], theme.spacing['spacing-2'], function (_ref5) {
  var size = _ref5.size;
  return size === SMALL_COMPONENT_SIZE && css$1(_templateObject7$n || (_templateObject7$n = _taggedTemplateLiteral(["\n      padding: ", " ", "\n        ", " ", ";\n      margin: ", ";\n    "])), theme.spacing['spacing-7'], theme.spacing['spacing-0'], theme.spacing['spacing-5'], theme.spacing['spacing-0'], theme.spacing['spacing-0']);
});
var MainTextWrapper = styled.div(_templateObject8$i || (_templateObject8$i = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding: ", " ", "\n    ", " ", ";\n  gap: ", ";\n  min-width: 400px;\n  ", "\n"])), theme.spacing['spacing-5'], theme.spacing['spacing-0'], theme.spacing['spacing-5'], theme.spacing['spacing-0'], theme.spacing['spacing-3'], function (_ref6) {
  var size = _ref6.size;
  return size === SMALL_COMPONENT_SIZE && css$1(_templateObject9$g || (_templateObject9$g = _taggedTemplateLiteral(["\n      min-width: auto;\n      max-width: 265px;\n      padding: ", ";\n      align-items: center;\n    "])), theme.spacing['spacing-0']);
});
var FileInputLabel = styled.label(_templateObject10$f || (_templateObject10$f = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  cursor: pointer;\n\n  ", "\n"])), theme.textStyles['text-preset-9'](), theme.colors.info.text.regular, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled && css$1(_templateObject11$e || (_templateObject11$e = _taggedTemplateLiteral(["\n      color: ", ";\n      cursor: not-allowed;\n    "])), theme.colors.neutral.text.regular);
});
var FileInput = styled.input(_templateObject12$9 || (_templateObject12$9 = _taggedTemplateLiteral(["\n  display: none;\n"])));
var ActionWrapper = styled.div(_templateObject13$8 || (_templateObject13$8 = _taggedTemplateLiteral(["\n  padding: ", " ", "\n    ", " ", ";\n  width: 100%;\n  text-align: right;\n\n  ", "\n  ", "\n"])), theme.spacing['spacing-7'], theme.spacing['spacing-6'], theme.spacing['spacing-7'], theme.spacing['spacing-0'], function (_ref8) {
  var size = _ref8.size;
  return size === SMALL_COMPONENT_SIZE && css$1(_templateObject14$6 || (_templateObject14$6 = _taggedTemplateLiteral(["\n      padding: ", " ", "\n        ", " ", ";\n      text-align: center;\n    "])), theme.spacing['spacing-4'], theme.spacing['spacing-0'], theme.spacing['spacing-5'], theme.spacing['spacing-0']);
}, function (_ref9) {
  var size = _ref9.size,
    deleteAction = _ref9.deleteAction;
  return deleteAction && size === SMALL_COMPONENT_SIZE && css$1(_templateObject15$6 || (_templateObject15$6 = _taggedTemplateLiteral(["\n      padding-bottom: ", ";\n      margin-bottom: ", ";\n    "])), theme.spacing['spacing-6'], theme.spacing['spacing-4']);
});
var HelpText$4 = styled.div(_templateObject16$5 || (_templateObject16$5 = _taggedTemplateLiteral(["\n  padding: ", " ", "\n    ", " ", ";\n  display: flex;\n  align-items: flex-start;\n  ", "\n"])), theme.spacing['spacing-2'], theme.spacing['spacing-2'], theme.spacing['spacing-2'], theme.spacing['spacing-5'], function (_ref10) {
  var status = _ref10.status;
  return status === 'error' && css$1(_templateObject17$5 || (_templateObject17$5 = _taggedTemplateLiteral(["\n      > * {\n        &:first-child {\n          margin-right: ", ";\n        }\n      }\n    "])), theme.spacing['spacing-2']);
});
var getSize$4 = function getSize(size) {
  switch (size) {
    case SMALL_COMPONENT_SIZE:
      return css$1(_templateObject18$5 || (_templateObject18$5 = _taggedTemplateLiteral(["\n        max-width: 312px;\n        flex-direction: column;\n      "])));
    case MEDIUM_COMPONENT_SIZE:
      return css$1(_templateObject19$3 || (_templateObject19$3 = _taggedTemplateLiteral(["\n        min-width: 671px;\n      "])));
  }
};
var getDisabled$1 = function getDisabled() {
  return css$1(_templateObject20$3 || (_templateObject20$3 = _taggedTemplateLiteral(["\n  background: ", ";\n"])), theme.colors.neutral.bg.regular);
};

var DragAndDrop$1 = function DragAndDrop$1(_ref) {
  var _textBySize, _iconDimensionBySize;
  var name = _ref.name,
    setValue = _ref.setValue,
    fileTypes = _ref.fileTypes,
    maxFileSize = _ref.maxFileSize,
    size = _ref.size,
    disabled = _ref.disabled,
    message = _ref.message;
  var _useDraggableInputFil = useDraggableInputFile(setValue, fileTypes, maxFileSize, size),
    _useDraggableInputFil2 = _slicedToArray(_useDraggableInputFil, 10),
    touched = _useDraggableInputFil2[0],
    inputFileRef = _useDraggableInputFil2[1],
    showFileNameArea = _useDraggableInputFil2[2],
    fileData = _useDraggableInputFil2[3],
    dragOverHandler = _useDraggableInputFil2[4],
    dropHandler = _useDraggableInputFil2[5],
    handleInputFileClick = _useDraggableInputFil2[6],
    handleDeleteClick = _useDraggableInputFil2[7],
    showErrorMessage = _useDraggableInputFil2[8],
    errorMessage = _useDraggableInputFil2[9];
  var spanVariantByStatus = {
    normal: 'neutral',
    error: 'danger'
  };
  var fileTypesToString = function fileTypesToString() {
    if ((fileTypes === null || fileTypes === void 0 ? void 0 : fileTypes.length) > 1) {
      var fileTypesCopy = _toConsumableArray(fileTypes);
      var lastFileType = fileTypesCopy.pop();
      return fileTypesCopy.map(function (type) {
        return type.toUpperCase();
      }).join(', ').concat(" o ".concat(lastFileType.toUpperCase()));
    }
    return fileTypes[0].toUpperCase();
  };
  var textBySize = (_textBySize = {}, _defineProperty(_textBySize, MEDIUM_COMPONENT_SIZE, 'Arrastrá y soltá un archivo, o hacé click para subirlo.'), _defineProperty(_textBySize, SMALL_COMPONENT_SIZE, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Arrastr\xE1 y solt\xE1 un archivo,", /*#__PURE__*/React__default.createElement("br", null), "o hac\xE9 click para subirlo.")), _textBySize);
  var iconDimensionBySize = (_iconDimensionBySize = {}, _defineProperty(_iconDimensionBySize, MEDIUM_COMPONENT_SIZE, 20), _defineProperty(_iconDimensionBySize, SMALL_COMPONENT_SIZE, 32), _iconDimensionBySize);
  var getStatus = function getStatus() {
    return message || showErrorMessage ? 'error' : 'normal';
  };
  var getMessage = function getMessage() {
    if (message && Object.keys(fileData).length === 0) {
      return errorMessage;
    } else {
      return message;
    }
  };
  var nameFormat = function nameFormat(fileName, size) {
    if (fileName) {
      var max = size === SMALL_COMPONENT_SIZE ? MAX_CHAR_FILENAME_SM : MAX_CHAR_FILENAME_MD;
      var parenthesis = '(...)';
      var symbolIndex = fileName.indexOf('.');
      var _name = fileName.slice(0, symbolIndex);
      var fileNameResult = '';
      if (_name.length > max) {
        var extension = fileName.slice(symbolIndex, fileName.length);
        fileNameResult = _name.slice(0, max - 1) + parenthesis + extension;
      } else {
        fileNameResult = fileName;
      }
      return fileNameResult;
    }
  };
  var renderEmptyInput = function renderEmptyInput() {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DragAndDrop, {
      status: getStatus(),
      onDragOver: !disabled && dragOverHandler,
      onDrop: !disabled && dropHandler,
      name: name,
      size: size,
      disabled: disabled
    }, /*#__PURE__*/React__default.createElement(DropBaseIcon, {
      size: size
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      name: "upload_cloud_outline",
      variant: "neutral",
      modifier: "weak",
      height: 32,
      width: 32
    })), /*#__PURE__*/React__default.createElement(MainTextWrapper, {
      size: size
    }, /*#__PURE__*/React__default.createElement(P$1, {
      type: "4",
      variant: "neutral",
      modifier: disabled ? 'regular' : 'strong',
      weight: "bold",
      align: size === SMALL_COMPONENT_SIZE ? 'center' : 'left'
    }, textBySize[size]), /*#__PURE__*/React__default.createElement(Span$1, {
      type: "4",
      variant: "neutral"
    }, "".concat(fileTypesToString(), ". Peso m\xE1ximo: ").concat(maxFileSize, "MB."))), /*#__PURE__*/React__default.createElement(ActionWrapper, {
      size: size
    }, /*#__PURE__*/React__default.createElement(FileInputLabel, {
      htmlFor: name,
      disabled: disabled
    }, "Seleccionar archivo"), /*#__PURE__*/React__default.createElement(FileInput, {
      type: "file",
      name: name,
      id: name,
      onChange: handleInputFileClick,
      ref: inputFileRef,
      disabled: disabled
    }))), getStatus() === 'error' && /*#__PURE__*/React__default.createElement(HelpText$4, {
      status: getStatus()
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      name: "error_circle_outline",
      variant: "danger",
      width: 16,
      height: 16
    }), getMessage() && /*#__PURE__*/React__default.createElement(Span$1, {
      type: "4",
      variant: spanVariantByStatus[getStatus()]
    }, getMessage())));
  };
  var renderFullfilledInput = function renderFullfilledInput() {
    return /*#__PURE__*/React__default.createElement(DragAndDrop, {
      onDrop: dropHandler,
      name: name,
      size: size
    }, /*#__PURE__*/React__default.createElement(SuccessIcon, {
      size: size
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      name: "check_circle_outline",
      variant: "success",
      height: iconDimensionBySize[size],
      width: iconDimensionBySize[size]
    })), /*#__PURE__*/React__default.createElement(MainTextWrapper, {
      size: size
    }, /*#__PURE__*/React__default.createElement(Span$1, {
      type: "4",
      variant: "secondary-1",
      modifier: "strong"
    }, nameFormat(fileData.name, size))), /*#__PURE__*/React__default.createElement(ActionWrapper, {
      size: size,
      deleteAction: true
    }, /*#__PURE__*/React__default.createElement(FileInputLabel, {
      onClick: handleDeleteClick
    }, "Eliminar")));
  };
  return /*#__PURE__*/React__default.createElement(DragAndDropWrapper, null, !showFileNameArea && renderEmptyInput(), showFileNameArea && renderFullfilledInput());
};
DragAndDrop$1.defaultProps = {
  size: MEDIUM_COMPONENT_SIZE,
  disabled: false
};
DragAndDrop$1.propTypes = {
  name: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  maxFileSize: PropTypes.number.isRequired,
  message: PropTypes.string,
  fileTypes: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(MIME_TYPES_MAP))).isRequired,
  size: PropTypes.oneOf([SMALL_COMPONENT_SIZE, MEDIUM_COMPONENT_SIZE]),
  disabled: PropTypes.bool
};

var _templateObject$_, _templateObject2$S;
var AppContentWrapper = styled.div(_templateObject$_ || (_templateObject$_ = _taggedTemplateLiteral(["\n  padding: ", " ", ";\n"])), theme.spacing['spacing-5'], theme.spacing['spacing-7']);
var AppContent = styled.div(_templateObject2$S || (_templateObject2$S = _taggedTemplateLiteral(["\n  margin: ", " auto;\n"])), theme.spacing['spacing-0']);

var AppContent$1 = function AppContent$1(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(AppContentWrapper, null, /*#__PURE__*/React__default.createElement(AppContent, null, children));
};

var _templateObject$$, _templateObject2$T;
var getMediaQuery = function getMediaQuery(key) {
  return function (style) {
    return "@media (min-width: ".concat(theme.breakpoints[key].size, ") { gap: ").concat(theme.breakpoints[key].gap, "; ").concat(style, "}");
  };
};
var getGridTemplateAreas = function getGridTemplateAreas(value) {
  return "grid-template-areas: ".concat(value, ";");
};
var Grid = styled.div(_templateObject$$ || (_templateObject$$ = _taggedTemplateLiteral(["\n  display: grid;\n  height: 100%;\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_ref) {
  var xxs = _ref.xxs;
  return xxs && getMediaQuery('xxs')(getGridTemplateAreas(xxs));
}, function (_ref2) {
  var xs = _ref2.xs;
  return xs && getMediaQuery('xs')(getGridTemplateAreas(xs));
}, function (_ref3) {
  var s = _ref3.s;
  return s && getMediaQuery('s')(getGridTemplateAreas(s));
}, function (_ref4) {
  var m = _ref4.m;
  return m && getMediaQuery('m')(getGridTemplateAreas(m));
}, function (_ref5) {
  var l = _ref5.l;
  return l && getMediaQuery('l')(getGridTemplateAreas(l));
});
var Area = styled.div(_templateObject2$T || (_templateObject2$T = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref6) {
  var name = _ref6.name;
  return "grid-area:".concat(name, ";");
});

/*Método para formatear la row para agregarlo al grid-area-template
  Entrada: 'area-1 otraArea-2'     Salida: 'area otraArea otraArea'
 * 1 - Splitea por cada espacio dentro de la row para obtener las areas(Ej: [area-1, otraArea-2])
 * 2 - Splitea de nuevo para separar areas de cantidad de columnas. (Ej: [['area', 1], ['otraArea',2]])
 * 3 - Recorro cada array del array general donde repito el string del area la cantidad de columnas especificada (Ej.: otraArea otraArea)
 *  3.1 - Si es que no tengo una cantidad especifica ocupo el máximo de columnas (Ej: Si ['area'] => columnIncrease = 8)
 *  3.2 - Siempre valido que la cantidad de columnas a sumar al string no sean mayores
 *        que la cantidad maxima permitida => columnCount < maxColumns
 */
var formatGridArea = function formatGridArea(value, breakpoint) {
  var columnCount = 0;
  var maxColumns = theme.breakpoints[breakpoint].columns;
  return value.split(SPACE_KEY).map(function (areaColumn) {
    return areaColumn.split(COLUMN_SEPARATOR);
  }).reduce(function (row, item) {
    var area = item[0];
    var columnIncrease = item[1] || maxColumns;
    columnCount += parseInt(columnIncrease);
    return row.concat(area.concat(SPACE_KEY).repeat(validateColumnLength(columnCount, columnIncrease, maxColumns)));
  }, '').trim();
};
var validateColumnLength = function validateColumnLength(actualCount, increase, maxNumber) {
  return actualCount <= maxNumber ? increase : increase - (actualCount - maxNumber);
};
var buildRow = function buildRow(value, breakpoint) {
  return QUOTE_MARK.concat(formatGridArea(value, breakpoint), QUOTE_MARK);
};
var buildGridArea = function buildGridArea(values, breakpoint) {
  return values.reduce(function (acc, item) {
    return acc.concat(buildRow(item, breakpoint));
  }, '');
};

var Grid$1 = function Grid$1(_ref) {
  var children = _ref.children,
    xxs = _ref.xxs,
    xs = _ref.xs,
    s = _ref.s,
    m = _ref.m,
    l = _ref.l;
  return /*#__PURE__*/React__default.createElement(Grid, {
    "data-testid": "grid-component",
    xxs: xxs && buildGridArea(xxs, 'xxs'),
    xs: xs && buildGridArea(xs, 'xs'),
    s: s && buildGridArea(s, 's'),
    m: m && buildGridArea(m, 'm'),
    l: l && buildGridArea(l, 'l')
  }, children);
};
var GridArea = function GridArea(_ref2) {
  var children = _ref2.children,
    name = _ref2.name;
  return /*#__PURE__*/React__default.createElement(Area, {
    "data-testid": "grid-area",
    name: name
  }, children);
};
Grid$1.Area = GridArea;
Grid$1.propTypes = {
  xxs: PropTypes.arrayOf(PropTypes.array),
  xs: PropTypes.arrayOf(PropTypes.array),
  s: PropTypes.arrayOf(PropTypes.array),
  m: PropTypes.arrayOf(PropTypes.array),
  l: PropTypes.arrayOf(PropTypes.array)
};

var _templateObject$10, _templateObject2$U, _templateObject3$K, _templateObject4$C, _templateObject5$x, _templateObject6$t, _templateObject7$o, _templateObject8$j, _templateObject9$h, _templateObject10$g, _templateObject11$f, _templateObject12$a, _templateObject13$9, _templateObject14$7, _templateObject15$7, _templateObject16$6, _templateObject17$6, _templateObject18$6, _templateObject19$4, _templateObject20$4;
var Popover = styled.div(_templateObject$10 || (_templateObject$10 = _taggedTemplateLiteral(["\n  display: inline-block;\n"])));
var BasePopover = styled.div(_templateObject2$U || (_templateObject2$U = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var position = _ref.position;
  return getPositionWrapper$1(position);
});
var Wrapper$1 = styled.div(_templateObject3$K || (_templateObject3$K = _taggedTemplateLiteral(["\n  will-change: transform;\n  white-space: pre-wrap;\n  min-width: 50px;\n  width: max-content;\n  max-width: 294px;\n  border-radius: ", ";\n  padding: ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  display: flex;\n"])), theme.spacing['spacing-2'], theme.spacing['spacing-5'], theme.colors.neutral.bg.weak, theme.elevations['elevation-3']);
var Content$2 = styled.div(_templateObject4$C || (_templateObject4$C = _taggedTemplateLiteral([""])));
var CloseButton$2 = styled.div(_templateObject5$x || (_templateObject5$x = _taggedTemplateLiteral([""])));
var ChildrenWrapper$1 = styled.div(_templateObject6$t || (_templateObject6$t = _taggedTemplateLiteral([""])));
var Arrow = styled.div(_templateObject7$o || (_templateObject7$o = _taggedTemplateLiteral(["\n  z-index: 12;\n  position: absolute;\n  display: block;\n  border-style: solid;\n  border-color: transparent;\n  transform-origin: center bottom;\n  ", ";\n  ", ";\n"])), function (_ref2) {
  var position = _ref2.position,
    width = _ref2.width,
    height = _ref2.height;
  return getArrow$1(position, width, height);
}, function (_ref3) {
  var position = _ref3.position,
    width = _ref3.width,
    height = _ref3.height;
  return getArrowPosition(position, width, height);
});
var getArrow$1 = function getArrow(position, width, height) {
  var aux = position.indexOf('-');
  var positions;
  aux === -1 ? positions = position : positions = position.slice(0, aux);
  return css$1(_templateObject8$j || (_templateObject8$j = _taggedTemplateLiteral(["\n    width: ", ";\n    height: ", ";\n    border-color: transparent;\n    border-", "-color: ", ""])), width, height, positions, theme.colors.neutral.bg.weak);
};
var getArrowPosition = function getArrowPosition(position, width, height) {
  switch (position) {
    case 'top':
      return css$1(_templateObject9$h || (_templateObject9$h = _taggedTemplateLiteral(["\n        border-width: ", " ", " 0px ", ";\n        bottom: calc(0% - ", ");\n        left: calc(50% - ", ");\n      "])), height, height, height, height, width);
    case 'top-right':
      return css$1(_templateObject10$g || (_templateObject10$g = _taggedTemplateLiteral(["\n        border-width: ", " ", " 0px ", ";\n        bottom: calc(0% - ", ");\n        right: calc(0% + ", ");\n      "])), height, height, height, height, width);
    case 'top-left':
      return css$1(_templateObject11$f || (_templateObject11$f = _taggedTemplateLiteral(["\n        border-width: ", " ", " 0px ", ";\n        bottom: calc(0% - ", ");\n        left: calc(0% + ", ");\n      "])), height, height, height, height, width);
    case 'bottom':
      return css$1(_templateObject12$a || (_templateObject12$a = _taggedTemplateLiteral(["\n        border-width: 0px ", " ", " ", ";\n        top: calc(0% - ", ");\n        left: calc(50% - ", ");\n      "])), height, height, height, height, width);
    case 'bottom-left':
      return css$1(_templateObject13$9 || (_templateObject13$9 = _taggedTemplateLiteral(["\n        border-width: 0px ", " ", " ", ";\n        top: calc(0% - ", ");\n        left: calc(0% + ", ");\n      "])), height, height, height, height, width);
    case 'bottom-right':
      return css$1(_templateObject14$7 || (_templateObject14$7 = _taggedTemplateLiteral(["\n        border-width: 0px ", " ", " ", ";\n        top: calc(0% - ", ");\n        right: calc(0% + ", ");\n      "])), height, height, height, height, width);
    case 'right':
      return css$1(_templateObject15$7 || (_templateObject15$7 = _taggedTemplateLiteral(["\n        border-width: ", " ", " ", " 0px;\n        top: calc(50% - ", ");\n        left: calc(0% - ", ");\n      "])), height, height, height, height, width);
    case 'left':
      return css$1(_templateObject16$6 || (_templateObject16$6 = _taggedTemplateLiteral(["\n        border-width: ", " 0px ", " ", ";\n        top: calc(50% - ", ");\n        right: calc(0% - ", ");\n      "])), height, height, height, height, width);
  }
};
var getPositionWrapper$1 = function getPositionWrapper(position) {
  switch (position) {
    case 'top':
    case 'top-left':
    case 'top-right':
      return css$1(_templateObject17$6 || (_templateObject17$6 = _taggedTemplateLiteral(["\n        padding: ", " ", "\n          ", " ", ";\n      "])), theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-3'], theme.spacing['spacing-0']);
    case 'bottom':
    case 'bottom-left':
    case 'bottom-right':
      return css$1(_templateObject18$6 || (_templateObject18$6 = _taggedTemplateLiteral(["\n        padding: ", " ", "\n          ", " ", ";\n      "])), theme.spacing['spacing-3'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-0']);
    case 'right':
      return css$1(_templateObject19$4 || (_templateObject19$4 = _taggedTemplateLiteral(["\n        padding: ", " ", "\n          ", " ", ";\n      "])), theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-0'], theme.spacing['spacing-3']);
    case 'left':
      return css$1(_templateObject20$4 || (_templateObject20$4 = _taggedTemplateLiteral(["\n        padding: ", " ", "\n          ", " ", ";\n      "])), theme.spacing['spacing-0'], theme.spacing['spacing-3'], theme.spacing['spacing-0'], theme.spacing['spacing-0']);
  }
};

var _excluded$j = ["ref"];
var arrowWidth = '10px';
var arrowHeight = '8px';
var Popover$1 = function Popover$1(_ref) {
  var position = _ref.position,
    content = _ref.content,
    showArrow = _ref.showArrow,
    children = _ref.children;
  var positionTranslate = {
    top: 'top',
    right: 'right',
    bottom: 'bottom',
    left: 'left',
    'top-right': 'top-end',
    'top-left': 'top-start',
    'bottom-right': 'bottom-end',
    'bottom-left': 'bottom-start'
  };
  var onCloseButton = function onCloseButton() {
    document.body.click();
  };
  var ChildrenWrapper = function ChildrenWrapper() {
    return /*#__PURE__*/React__default.createElement(OverlayTrigger, {
      trigger: "click",
      placement: positionTranslate[position],
      rootClose: true,
      overlay: /*#__PURE__*/React__default.createElement(BasePopover, {
        "data-testid": "popover",
        position: position
      }, /*#__PURE__*/React__default.createElement(Wrapper$1, null, showArrow && /*#__PURE__*/React__default.createElement(Arrow, {
        "data-testid": "popover-arrow",
        position: position,
        width: arrowWidth,
        height: arrowHeight
      }), /*#__PURE__*/React__default.createElement(Content$2, null, content), /*#__PURE__*/React__default.createElement(CloseButton$2, null, /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "cancel_outline",
        variant: "neutral",
        modifier: "strong",
        cursor: "pointer",
        width: 16,
        height: 16,
        onClick: onCloseButton
      }))))
    }, function (_ref2) {
      var ref = _ref2.ref,
        triggerHandler = _objectWithoutProperties(_ref2, _excluded$j);
      return /*#__PURE__*/React__default.createElement(ChildrenWrapper$1, _extends({}, triggerHandler, {
        ref: ref
      }), children);
    });
  };
  return /*#__PURE__*/React__default.createElement(Popover, {
    position: position,
    content: content,
    showArrow: showArrow
  }, ChildrenWrapper());
};
Popover$1.defaultProps = {
  position: 'top',
  showArrow: true
};
Popover$1.propTypes = {
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left', 'top-right', 'top-left', 'bottom-right', 'bottom-left']),
  content: PropTypes.string.isRequired,
  showArrow: PropTypes.bool
};

var storageBreak = {};
var mediaQueryXXS = function mediaQueryXXS() {
  var SIZE = 'xxs';
  var mediaQueryList = buildMatchMedia(SIZE);
  for (var _len = arguments.length, referencedElements = new Array(_len), _key = 0; _key < _len; _key++) {
    referencedElements[_key] = arguments[_key];
  }
  buildClassNameWithModifier(referencedElements, mediaQueryList, SIZE);
};
var mediaQueryXS = function mediaQueryXS() {
  var SIZE = 'xs';
  var mediaQueryList = buildMatchMedia(SIZE);
  for (var _len2 = arguments.length, referencedElements = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    referencedElements[_key2] = arguments[_key2];
  }
  buildClassNameWithModifier(referencedElements, mediaQueryList, SIZE);
};
var mediaQueryS = function mediaQueryS() {
  var SIZE = 's';
  var mediaQueryList = buildMatchMedia(SIZE);
  for (var _len3 = arguments.length, referencedElements = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    referencedElements[_key3] = arguments[_key3];
  }
  buildClassNameWithModifier(referencedElements, mediaQueryList, SIZE);
};
var mediaQueryM = function mediaQueryM() {
  var SIZE = 'm';
  var mediaQueryList = buildMatchMedia(SIZE);
  for (var _len4 = arguments.length, referencedElements = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    referencedElements[_key4] = arguments[_key4];
  }
  buildClassNameWithModifier(referencedElements, mediaQueryList, SIZE);
};
var mediaQueryL = function mediaQueryL() {
  var SIZE = 'l';
  var mediaQueryList = buildMatchMedia(SIZE);
  for (var _len5 = arguments.length, referencedElements = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    referencedElements[_key5] = arguments[_key5];
  }
  buildClassNameWithModifier(referencedElements, mediaQueryList, SIZE);
};
var buildMatchMedia = function buildMatchMedia(SIZE) {
  return window.matchMedia("(min-width: ".concat(breakpoints[SIZE].size, ")"));
};
var buildClassNameWithModifier = function buildClassNameWithModifier(referencedElements, mediaQueryList, SIZE) {
  referencedElements.forEach(function (element) {
    if (element.current) {
      element.current.className = getClassMedia(mediaQueryList.matches, element.current, SIZE);
      addListener(element, mediaQueryList, SIZE);
    }
  });
};
var addListener = function addListener(element, mediaQueryList, size) {
  mediaQueryList.addEventListener('change', function (event) {
    element.current.className = getClassMedia(event.matches, element.current, size);
  });
};
var getClassMedia = function getClassMedia(matches, currentElement, SIZE, event) {
  var concatModifier = "--".concat(SIZE);
  var currentModifier = getCurrentModifier(currentElement.className);
  if (matches) {
    var pureClassName = getPureClassName(currentModifier, currentElement.className);
    saveCurrentAndPrevModifier(pureClassName, concatModifier, currentModifier);
    return pureClassName + concatModifier;
  } else {
    var currentSize = currentModifier.replace('--', '');
    var shouldGoBack = sortedBreakpoints.indexOf(SIZE) <= sortedBreakpoints.indexOf(currentSize);
    return shouldGoBack ? goBackUntilMatch(currentElement, currentElement.className) : currentElement.className;
  }
};
var getCurrentModifier = function getCurrentModifier(className) {
  var currentModifier = '';
  sortedBreakpoints.forEach(function (breakPoint) {
    var modifierToCompare = "--".concat(breakPoint);
    if (className.includes(modifierToCompare)) {
      if (className.split(modifierToCompare).length === 2) {
        currentModifier = modifierToCompare;
      }
    }
  });
  return currentModifier;
};
var getPureClassName = function getPureClassName(currentModifier, currentElementClassName) {
  return currentModifier === '' ? currentElementClassName : currentElementClassName.split(currentModifier)[0];
};
var saveCurrentAndPrevModifier = function saveCurrentAndPrevModifier(pureClassName, concatModifier, currentModifier) {
  sortedBreakpoints.forEach(function (breakPoint) {
    if (!storageBreak["".concat(pureClassName).concat(concatModifier)] && concatModifier !== "--".concat(breakPoint)) {
      storageBreak = _objectSpread2(_objectSpread2({}, storageBreak), {}, _defineProperty({}, "".concat(pureClassName).concat(concatModifier), {
        previousModifier: currentModifier
      }));
    }
  });
};
var goBackUntilMatch = function goBackUntilMatch(currentElement, className) {
  var _breakpoints$modifier;
  var currentModifier = getCurrentModifier(currentElement.className);
  var storagedPrevModifier = storageBreak["".concat(className)] ? storageBreak["".concat(className)].previousModifier : '';
  var prevModifier = storagedPrevModifier || currentModifier;
  if (prevModifier === '') {
    return currentElement.className;
  }
  var modifierSize = prevModifier.replace('--', '');
  var pxBreak = Number((_breakpoints$modifier = breakpoints[modifierSize]) === null || _breakpoints$modifier === void 0 ? void 0 : _breakpoints$modifier.size.replace('px', ''));
  removeAllModifiers(currentElement);
  var newClassName = currentElement.className + prevModifier;
  if (window.screen.availWidth >= pxBreak) {
    return newClassName;
  }
  return goBackUntilMatch(currentElement, newClassName);
};
var sortedBreakpoints = Object.entries(breakpoints).sort(function (firstEl, secondEl) {
  return Number(firstEl[1].size.replace('px', '')) - Number(secondEl[1].size.replace('px', ''));
}).map(function (el) {
  return el[0];
});
var cleanClassName = function cleanClassName(className, modifier) {
  return className.split(modifier)[0];
};
var removeAllModifiers = function removeAllModifiers(currentElement) {
  sortedBreakpoints.forEach(function (breakPoint) {
    var modifierToRemove = "--".concat(breakPoint);
    var currentClassName = currentElement.className;
    if (currentClassName.includes(modifierToRemove)) {
      currentElement.className = cleanClassName(currentClassName, modifierToRemove);
    }
  });
};

var _templateObject$11, _templateObject2$V;
var TotalizerWrapper = styled.div(_templateObject$11 || (_templateObject$11 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-evenly;\n  & div {\n    border-right: solid 2px ", ";\n  }\n  & div:last-child,\n  div:only-child {\n    border-right: none;\n  }\n"])), theme.colors.neutral.border.regular);
var TotalizerContent = styled.div(_templateObject2$V || (_templateObject2$V = _taggedTemplateLiteral(["\n  display: block;\n  padding: ", " ", ";\n  width: 100%;\n"])), theme.spacing['spacing-3'], theme.spacing['spacing-0']);

var dateFormatter = function dateFormatter(date) {
  var dateSplitted = date.split(/[-,' ']/);
  return dateSplitted[2] + ' ' + months$2[dateSplitted[1]] + ' ' + dateSplitted[0];
};
var months$2 = {
  '01': 'Ene',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Abr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Ago',
  '09': 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dic'
};
var Totalizer = function Totalizer(_ref) {
  var totalizerData = _ref.totalizerData;
  return /*#__PURE__*/React__default.createElement(TotalizerWrapper, {
    "data-testid": 'totalizerContainer'
  }, totalizerData.map(function (element, index) {
    return /*#__PURE__*/React__default.createElement(TotalizerContent, {
      key: index,
      "data-testid": 'totalizer' + index
    }, /*#__PURE__*/React__default.createElement(P$1, {
      type: "2",
      variant: element.variant,
      modifier: "regular",
      align: "center"
    }, element.title), /*#__PURE__*/React__default.createElement(H$1, {
      type: "5",
      align: "center",
      weight: "bold",
      variant: element.variant
    }, formatters$3.find(function (e) {
      return e.name === element.formatter;
    }).value(element.value)));
  }));
};
var formatters$3 = [{
  name: 'AmountFormatter',
  value: function value(e) {
    return numberFormatter.format(e);
  }
}, {
  name: 'NoFormatter',
  value: function value(e) {
    return e;
  }
}, {
  name: 'DateFormatter',
  value: function value(e) {
    return dateFormatter(e[0]) + ' - ' + dateFormatter(e[1]);
  }
}];
Totalizer.propTypes = {
  totalizerData: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]).isRequired,
    variant: PropTypes.oneOf(['primary', 'neutral']).isRequired,
    formatter: PropTypes.oneOf(['AmountFormatter', 'NoFormatter', 'DateFormatter'])
  })).isRequired
};
Totalizer.defaultProps = {
  totalizerData: [{
    variant: 'neutral',
    formatter: 'NoFormatter'
  }]
};

var _BREAKPOINT_TO_RESOLU;
var BREAKPOINT_XXS_INDEX = 0;
var BREAKPOINT_XS_INDEX = 1;
var BREAKPOINT_S_INDEX = 2;
var BREAKPOINT_M_INDEX = 3;
var BREAKPOINT_L_INDEX = 4;
var parseSize = function parseSize(size) {
  return Number(size.replace('px', ''));
};
var MEDIA_MATCHERS = function () {
  var matchers = [];
  var breakpointEntries = Object.values(breakpoints).sort(function (a, b) {
    return parseSize(a.size) - parseSize(b.size);
  });
  for (var i = 0; i < breakpointEntries.length; i += 1) {
    var current = breakpointEntries[i];
    var next = breakpointEntries[i + 1];
    if (current && next) {
      var nextSize = Number(next.size.replace('px', '')) - 1;
      matchers.push(window.matchMedia("(min-width: ".concat(current.size, ") and (max-width: ").concat(nextSize, "px)")));
    } else {
      matchers.push(window.matchMedia("(min-width: ".concat(current.size, ")")));
    }
  }
  return matchers;
}();

// Returns current active breakpoint's index in ['xxs', 'xs', 's', 'm', 'l']
var useMediaQuery = function useMediaQuery() {
  var _useState = useState(MEDIA_MATCHERS.findIndex(function (matcher) {
      return matcher.matches;
    })),
    _useState2 = _slicedToArray(_useState, 2),
    matchingMedia = _useState2[0],
    setMatchingMedia = _useState2[1];
  useEffect(function () {
    var listeners = [];
    MEDIA_MATCHERS.forEach(function (matcher, index) {
      var listener = function listener() {
        if (matcher.matches) {
          setMatchingMedia(index);
        }
      };
      matcher.addEventListener('change', listener);
      listeners.push(listener);
    });
    return function () {
      listeners.forEach(function (listener, index) {
        MEDIA_MATCHERS[index].removeEventListener('change', listener);
      });
    };
  }, []);
  return matchingMedia;
};
var RESOLUTION_PHONE = 0;
var RESOLUTION_TABLET = 1;
var RESOLUTION_DESKTOP = 2;
var BREAKPOINT_TO_RESOLUTION_MAP = (_BREAKPOINT_TO_RESOLU = {}, _defineProperty(_BREAKPOINT_TO_RESOLU, BREAKPOINT_XXS_INDEX, RESOLUTION_PHONE), _defineProperty(_BREAKPOINT_TO_RESOLU, BREAKPOINT_XS_INDEX, RESOLUTION_TABLET), _defineProperty(_BREAKPOINT_TO_RESOLU, BREAKPOINT_S_INDEX, RESOLUTION_DESKTOP), _defineProperty(_BREAKPOINT_TO_RESOLU, BREAKPOINT_M_INDEX, RESOLUTION_DESKTOP), _defineProperty(_BREAKPOINT_TO_RESOLU, BREAKPOINT_L_INDEX, RESOLUTION_DESKTOP), _BREAKPOINT_TO_RESOLU);
var useResolution = function useResolution() {
  var breakpoint = useMediaQuery();
  return BREAKPOINT_TO_RESOLUTION_MAP[breakpoint];
};

export { AdvancedFilters, Alert$1 as Alert, AppContent$1 as AppContent, BREAKPOINT_L_INDEX, BREAKPOINT_M_INDEX, BREAKPOINT_S_INDEX, BREAKPOINT_XS_INDEX, BREAKPOINT_XXS_INDEX, Badge$1 as Badge, Brand, Bullet, Button$1 as Button, ButtonRound, Calendar, Card$1 as Card, CardWithColoredHeader, Carousel$1 as Carousel, Checkbox$1 as Checkbox, Chip$1 as Chip, ConnectionError, CuitSelector$1 as CuitSelector, DatePicker$1 as DatePicker, DateRangePicker, Datepicker_DEPRECATED as Datepicker, Dot$1 as Dot, DragAndDrop$1 as DragAndDrop, Dropdown, DynamicList, Equal, Filter, FilterNoData, Filters, FormattedAmountInput$1 as FormattedAmountInput, Grid$1 as Grid, H$1 as H, Icon$1 as Icon, Illustration, In, Input$1 as Input, ItemEstablishment$1 as ItemEstablishment, ItemsSelector$1 as ItemsSelector, Label$1 as Label, Link$1 as Link, Logo$1 as Logo, Modal, MultiSelect, MultiSelectableButton, NoData, NumberInput, OutsideAlerter, P$1 as P, PermissionProvider, Pill, Popover$1 as Popover, RESOLUTION_DESKTOP, RESOLUTION_PHONE, RESOLUTION_TABLET, RadioButton$1 as RadioButton, Range, RangeInput, Restricted, SearchInput, SearchableSelect, Section, Select$1 as Select, SelectList, SelectableButton, SelectableChips$1 as SelectableChips, SelectableImage, SideSheet$1 as SideSheet, Span$1 as Span, Spinner, StateMessage, StatusPaymentPill, Table$1 as Table, TabsGroup, TextArea$1 as TextArea, Toast$2 as Toast, Toggle$1 as Toggle, Tooltip$1 as Tooltip, Totalizer, Walkthrough, mediaQueryL, mediaQueryM, mediaQueryS, mediaQueryXS, mediaQueryXXS, themeFree, themePremium, typeFilters, useFilterContext, useMediaQuery, useResolution, useToast$1 as useToast, withFilterContext };
